
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire44bd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire44bd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bh6RR", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bjR3q"));

});
parcelRegister("bjR3q", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $83da9f8ce41d3d63$export$9c16c1426311996d; }, function (v) { return $83da9f8ce41d3d63$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $83da9f8ce41d3d63$export$dca3b0875bd9a954; }, function (v) { return $83da9f8ce41d3d63$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $83da9f8ce41d3d63$export$16fa2f45be04daa8; }, function (v) { return $83da9f8ce41d3d63$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $83da9f8ce41d3d63$export$ffb0004e005737fa; }, function (v) { return $83da9f8ce41d3d63$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $83da9f8ce41d3d63$export$e2c29f18771995cb; }, function (v) { return $83da9f8ce41d3d63$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $83da9f8ce41d3d63$export$221d75b3f55bb0bd; }, function (v) { return $83da9f8ce41d3d63$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $83da9f8ce41d3d63$export$5f8d39834fd61797; }, function (v) { return $83da9f8ce41d3d63$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $83da9f8ce41d3d63$export$74bf444e3cd11ea5; }, function (v) { return $83da9f8ce41d3d63$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $83da9f8ce41d3d63$export$1ced07cd6b1985ce; }, function (v) { return $83da9f8ce41d3d63$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $83da9f8ce41d3d63$export$abd8e32b826d7ea7; }, function (v) { return $83da9f8ce41d3d63$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $83da9f8ce41d3d63$export$69a3209f1a06c04d; }, function (v) { return $83da9f8ce41d3d63$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $83da9f8ce41d3d63$export$8c538325882c7eec; }, function (v) { return $83da9f8ce41d3d63$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $83da9f8ce41d3d63$export$e530037191fcd5d7; }, function (v) { return $83da9f8ce41d3d63$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $83da9f8ce41d3d63$export$fd42f52fd3ae1109; }, function (v) { return $83da9f8ce41d3d63$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $83da9f8ce41d3d63$export$c8a8987d4410bf2d; }, function (v) { return $83da9f8ce41d3d63$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $83da9f8ce41d3d63$export$7d1e3a5e95ceca43; }, function (v) { return $83da9f8ce41d3d63$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $83da9f8ce41d3d63$export$257a8862b851cb5b; }, function (v) { return $83da9f8ce41d3d63$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $83da9f8ce41d3d63$export$a8257692ac88316c; }, function (v) { return $83da9f8ce41d3d63$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $83da9f8ce41d3d63$export$488013bae63b21da; }, function (v) { return $83da9f8ce41d3d63$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $83da9f8ce41d3d63$export$7c73462e0d25e514; }, function (v) { return $83da9f8ce41d3d63$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $83da9f8ce41d3d63$export$7568632d0d33d16d; }, function (v) { return $83da9f8ce41d3d63$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $83da9f8ce41d3d63$export$f93f40ac0ca7e3a8; }, function (v) { return $83da9f8ce41d3d63$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $83da9f8ce41d3d63$export$1f96ae73734a86cc; }, function (v) { return $83da9f8ce41d3d63$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $83da9f8ce41d3d63$export$9a47ced3238df325; }, function (v) { return $83da9f8ce41d3d63$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $83da9f8ce41d3d63$export$35808ee640e87ca7; }, function (v) { return $83da9f8ce41d3d63$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $83da9f8ce41d3d63$export$fae74005e78b1a27; }, function (v) { return $83da9f8ce41d3d63$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $83da9f8ce41d3d63$export$dc8fbce3eb94dc1e; }, function (v) { return $83da9f8ce41d3d63$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $83da9f8ce41d3d63$export$6a7bc4e911dc01cf; }, function (v) { return $83da9f8ce41d3d63$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $83da9f8ce41d3d63$export$6d9c69b0de29b591; }, function (v) { return $83da9f8ce41d3d63$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $83da9f8ce41d3d63$export$7f54fc3180508a52; }, function (v) { return $83da9f8ce41d3d63$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $83da9f8ce41d3d63$export$f680877a34711e37; }, function (v) { return $83da9f8ce41d3d63$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $83da9f8ce41d3d63$export$d5a552a76deda3c2; }, function (v) { return $83da9f8ce41d3d63$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $83da9f8ce41d3d63$export$aaabe4eda9ed9969; }, function (v) { return $83da9f8ce41d3d63$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $83da9f8ce41d3d63$export$e5c5a5f917a5871c; }, function (v) { return $83da9f8ce41d3d63$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $83da9f8ce41d3d63$export$1538c33de8887b59; }, function (v) { return $83da9f8ce41d3d63$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $83da9f8ce41d3d63$export$fca7f784ae7a249a; }, function (v) { return $83da9f8ce41d3d63$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $83da9f8ce41d3d63$export$13e3392192263954; }, function (v) { return $83da9f8ce41d3d63$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $83da9f8ce41d3d63$export$b8f5890fc79d6aca; }, function (v) { return $83da9f8ce41d3d63$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $83da9f8ce41d3d63$export$60241385465d0a34; }, function (v) { return $83da9f8ce41d3d63$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $83da9f8ce41d3d63$export$306c0aa65ff9ec16; }, function (v) { return $83da9f8ce41d3d63$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $83da9f8ce41d3d63$export$7b286972b8d8ccbf; }, function (v) { return $83da9f8ce41d3d63$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $83da9f8ce41d3d63$export$83d89fbfd8236492; }, function (v) { return $83da9f8ce41d3d63$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $83da9f8ce41d3d63$export$9c16c1426311996d;
var $83da9f8ce41d3d63$export$dca3b0875bd9a954;
var $83da9f8ce41d3d63$export$16fa2f45be04daa8;
var $83da9f8ce41d3d63$export$ffb0004e005737fa;
var $83da9f8ce41d3d63$export$e2c29f18771995cb;
var $83da9f8ce41d3d63$export$221d75b3f55bb0bd;
var $83da9f8ce41d3d63$export$5f8d39834fd61797;
var $83da9f8ce41d3d63$export$74bf444e3cd11ea5;
var $83da9f8ce41d3d63$export$1ced07cd6b1985ce;
var $83da9f8ce41d3d63$export$abd8e32b826d7ea7;
var $83da9f8ce41d3d63$export$69a3209f1a06c04d;
var $83da9f8ce41d3d63$export$8c538325882c7eec;
var $83da9f8ce41d3d63$export$e530037191fcd5d7;
var $83da9f8ce41d3d63$export$fd42f52fd3ae1109;
var $83da9f8ce41d3d63$export$c8a8987d4410bf2d;
var $83da9f8ce41d3d63$export$7d1e3a5e95ceca43;
var $83da9f8ce41d3d63$export$257a8862b851cb5b;
var $83da9f8ce41d3d63$export$a8257692ac88316c;
var $83da9f8ce41d3d63$export$488013bae63b21da;
var $83da9f8ce41d3d63$export$7c73462e0d25e514;
var $83da9f8ce41d3d63$export$7568632d0d33d16d;
var $83da9f8ce41d3d63$export$f93f40ac0ca7e3a8;
var $83da9f8ce41d3d63$export$1f96ae73734a86cc;
var $83da9f8ce41d3d63$export$9a47ced3238df325;
var $83da9f8ce41d3d63$export$35808ee640e87ca7;
var $83da9f8ce41d3d63$export$fae74005e78b1a27;
var $83da9f8ce41d3d63$export$dc8fbce3eb94dc1e;
var $83da9f8ce41d3d63$export$6a7bc4e911dc01cf;
var $83da9f8ce41d3d63$export$6d9c69b0de29b591;
var $83da9f8ce41d3d63$export$7f54fc3180508a52;
var $83da9f8ce41d3d63$export$f680877a34711e37;
var $83da9f8ce41d3d63$export$d5a552a76deda3c2;
var $83da9f8ce41d3d63$export$aaabe4eda9ed9969;
var $83da9f8ce41d3d63$export$e5c5a5f917a5871c;
var $83da9f8ce41d3d63$export$1538c33de8887b59;
var $83da9f8ce41d3d63$export$fca7f784ae7a249a;
var $83da9f8ce41d3d63$export$13e3392192263954;
var $83da9f8ce41d3d63$export$b8f5890fc79d6aca;
var $83da9f8ce41d3d63$export$60241385465d0a34;
var $83da9f8ce41d3d63$export$306c0aa65ff9ec16;
var $83da9f8ce41d3d63$export$7b286972b8d8ccbf;
var $83da9f8ce41d3d63$export$83d89fbfd8236492;
"use strict";
var $83da9f8ce41d3d63$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $83da9f8ce41d3d63$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $83da9f8ce41d3d63$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $83da9f8ce41d3d63$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $83da9f8ce41d3d63$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $83da9f8ce41d3d63$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $83da9f8ce41d3d63$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $83da9f8ce41d3d63$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $83da9f8ce41d3d63$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $83da9f8ce41d3d63$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $83da9f8ce41d3d63$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $83da9f8ce41d3d63$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $83da9f8ce41d3d63$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $83da9f8ce41d3d63$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $83da9f8ce41d3d63$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$83da9f8ce41d3d63$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $83da9f8ce41d3d63$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $83da9f8ce41d3d63$var$assign = Object.assign, $83da9f8ce41d3d63$var$emptyObject = {};
function $83da9f8ce41d3d63$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $83da9f8ce41d3d63$var$emptyObject;
    this.updater = updater || $83da9f8ce41d3d63$var$ReactNoopUpdateQueue;
}
$83da9f8ce41d3d63$var$Component.prototype.isReactComponent = {};
$83da9f8ce41d3d63$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$83da9f8ce41d3d63$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $83da9f8ce41d3d63$var$ComponentDummy() {}
$83da9f8ce41d3d63$var$ComponentDummy.prototype = $83da9f8ce41d3d63$var$Component.prototype;
function $83da9f8ce41d3d63$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $83da9f8ce41d3d63$var$emptyObject;
    this.updater = updater || $83da9f8ce41d3d63$var$ReactNoopUpdateQueue;
}
var $83da9f8ce41d3d63$var$pureComponentPrototype = $83da9f8ce41d3d63$var$PureComponent.prototype = new $83da9f8ce41d3d63$var$ComponentDummy();
$83da9f8ce41d3d63$var$pureComponentPrototype.constructor = $83da9f8ce41d3d63$var$PureComponent;
$83da9f8ce41d3d63$var$assign($83da9f8ce41d3d63$var$pureComponentPrototype, $83da9f8ce41d3d63$var$Component.prototype);
$83da9f8ce41d3d63$var$pureComponentPrototype.isPureReactComponent = !0;
var $83da9f8ce41d3d63$var$isArrayImpl = Array.isArray;
function $83da9f8ce41d3d63$var$noop() {}
var $83da9f8ce41d3d63$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $83da9f8ce41d3d63$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $83da9f8ce41d3d63$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $83da9f8ce41d3d63$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $83da9f8ce41d3d63$var$cloneAndReplaceKey(oldElement, newKey) {
    return $83da9f8ce41d3d63$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $83da9f8ce41d3d63$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $83da9f8ce41d3d63$var$REACT_ELEMENT_TYPE;
}
function $83da9f8ce41d3d63$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $83da9f8ce41d3d63$var$userProvidedKeyEscapeRegex = /\/+/g;
function $83da9f8ce41d3d63$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $83da9f8ce41d3d63$var$escape("" + element.key) : index.toString(36);
}
function $83da9f8ce41d3d63$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($83da9f8ce41d3d63$var$noop, $83da9f8ce41d3d63$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $83da9f8ce41d3d63$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $83da9f8ce41d3d63$var$REACT_ELEMENT_TYPE:
                case $83da9f8ce41d3d63$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $83da9f8ce41d3d63$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $83da9f8ce41d3d63$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $83da9f8ce41d3d63$var$getElementKey(children, 0) : nameSoFar, $83da9f8ce41d3d63$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($83da9f8ce41d3d63$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $83da9f8ce41d3d63$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($83da9f8ce41d3d63$var$isValidElement(callback) && (callback = $83da9f8ce41d3d63$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($83da9f8ce41d3d63$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($83da9f8ce41d3d63$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $83da9f8ce41d3d63$var$getElementKey(nameSoFar, i), invokeCallback += $83da9f8ce41d3d63$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $83da9f8ce41d3d63$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $83da9f8ce41d3d63$var$getElementKey(nameSoFar, i++), invokeCallback += $83da9f8ce41d3d63$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $83da9f8ce41d3d63$var$mapIntoArray($83da9f8ce41d3d63$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $83da9f8ce41d3d63$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $83da9f8ce41d3d63$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $83da9f8ce41d3d63$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $83da9f8ce41d3d63$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $83da9f8ce41d3d63$var$Children = {
    map: $83da9f8ce41d3d63$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $83da9f8ce41d3d63$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $83da9f8ce41d3d63$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $83da9f8ce41d3d63$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$83da9f8ce41d3d63$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$83da9f8ce41d3d63$export$9c16c1426311996d = $83da9f8ce41d3d63$var$REACT_ACTIVITY_TYPE;
$83da9f8ce41d3d63$export$dca3b0875bd9a954 = $83da9f8ce41d3d63$var$Children;
$83da9f8ce41d3d63$export$16fa2f45be04daa8 = $83da9f8ce41d3d63$var$Component;
$83da9f8ce41d3d63$export$ffb0004e005737fa = $83da9f8ce41d3d63$var$REACT_FRAGMENT_TYPE;
$83da9f8ce41d3d63$export$e2c29f18771995cb = $83da9f8ce41d3d63$var$REACT_PROFILER_TYPE;
$83da9f8ce41d3d63$export$221d75b3f55bb0bd = $83da9f8ce41d3d63$var$PureComponent;
$83da9f8ce41d3d63$export$5f8d39834fd61797 = $83da9f8ce41d3d63$var$REACT_STRICT_MODE_TYPE;
$83da9f8ce41d3d63$export$74bf444e3cd11ea5 = $83da9f8ce41d3d63$var$REACT_SUSPENSE_TYPE;
$83da9f8ce41d3d63$export$1ced07cd6b1985ce = $83da9f8ce41d3d63$var$ReactSharedInternals;
$83da9f8ce41d3d63$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$83da9f8ce41d3d63$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$83da9f8ce41d3d63$export$8c538325882c7eec = function() {
    return null;
};
$83da9f8ce41d3d63$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $83da9f8ce41d3d63$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$83da9f8ce41d3d63$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $83da9f8ce41d3d63$var$ReactElement(element.type, key, props);
};
$83da9f8ce41d3d63$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $83da9f8ce41d3d63$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $83da9f8ce41d3d63$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$83da9f8ce41d3d63$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$83da9f8ce41d3d63$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $83da9f8ce41d3d63$var$ReactElement(type, key, props);
};
$83da9f8ce41d3d63$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$83da9f8ce41d3d63$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $83da9f8ce41d3d63$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$83da9f8ce41d3d63$export$a8257692ac88316c = $83da9f8ce41d3d63$var$isValidElement;
$83da9f8ce41d3d63$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $83da9f8ce41d3d63$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $83da9f8ce41d3d63$var$lazyInitializer
    };
};
$83da9f8ce41d3d63$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $83da9f8ce41d3d63$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$83da9f8ce41d3d63$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $83da9f8ce41d3d63$var$ReactSharedInternals.T, currentTransition = {};
    $83da9f8ce41d3d63$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $83da9f8ce41d3d63$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($83da9f8ce41d3d63$var$noop, $83da9f8ce41d3d63$var$reportGlobalError);
    } catch (error) {
        $83da9f8ce41d3d63$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $83da9f8ce41d3d63$var$ReactSharedInternals.T = prevTransition;
    }
};
$83da9f8ce41d3d63$export$f93f40ac0ca7e3a8 = function() {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useCacheRefresh();
};
$83da9f8ce41d3d63$export$1f96ae73734a86cc = function(usable) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.use(usable);
};
$83da9f8ce41d3d63$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$83da9f8ce41d3d63$export$35808ee640e87ca7 = function(callback, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$83da9f8ce41d3d63$export$fae74005e78b1a27 = function(Context) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useContext(Context);
};
$83da9f8ce41d3d63$export$dc8fbce3eb94dc1e = function() {};
$83da9f8ce41d3d63$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$83da9f8ce41d3d63$export$6d9c69b0de29b591 = function(create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useEffect(create, deps);
};
$83da9f8ce41d3d63$export$7f54fc3180508a52 = function(callback) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$83da9f8ce41d3d63$export$f680877a34711e37 = function() {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useId();
};
$83da9f8ce41d3d63$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$83da9f8ce41d3d63$export$aaabe4eda9ed9969 = function(create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$83da9f8ce41d3d63$export$e5c5a5f917a5871c = function(create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$83da9f8ce41d3d63$export$1538c33de8887b59 = function(create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useMemo(create, deps);
};
$83da9f8ce41d3d63$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$83da9f8ce41d3d63$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$83da9f8ce41d3d63$export$b8f5890fc79d6aca = function(initialValue) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useRef(initialValue);
};
$83da9f8ce41d3d63$export$60241385465d0a34 = function(initialState) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useState(initialState);
};
$83da9f8ce41d3d63$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$83da9f8ce41d3d63$export$7b286972b8d8ccbf = function() {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useTransition();
};
$83da9f8ce41d3d63$export$83d89fbfd8236492 = "19.2.0";

});


parcelRegister("6Wfmo", function(module, exports) {

$parcel$export(module.exports, "datadogRum", function () { return $27c795c4ac910d10$export$65cc181beb0d2632; });

var $cFehY = parcelRequire("cFehY");

var $7wVtg = parcelRequire("7wVtg");
parcelRequire("6QSjS");

var $5rjZK = parcelRequire("5rjZK");

var $6AfsN = parcelRequire("6AfsN");
parcelRequire("lNEHA");
var $13M2C = parcelRequire("13M2C");

var $1nqsB = parcelRequire("1nqsB");

var $c2Qhr = parcelRequire("c2Qhr");
//#region src/entries/main.ts
/**
* Datadog Browser RUM SDK - Full version with Session Replay and Real User Profiling capabilities.
* Use this package to monitor your web application's performance and user experience.
*
* @packageDocumentation
* @see [RUM Browser Monitoring Setup](https://docs.datadoghq.com/real_user_monitoring/browser/)
*/ const $27c795c4ac910d10$var$recorderApi = (0, $5rjZK.makeRecorderApi)();
const $27c795c4ac910d10$var$profilerApi = (0, $6AfsN.makeProfilerApi)();
/**
* The global RUM instance. Use this to call RUM methods.
*
* @category Main
* @see {@link DatadogRum}
* @see [RUM Browser Monitoring Setup](https://docs.datadoghq.com/real_user_monitoring/browser/)
*/ const $27c795c4ac910d10$export$65cc181beb0d2632 = (0, $13M2C.makeRumPublicApi)($27c795c4ac910d10$var$recorderApi, $27c795c4ac910d10$var$profilerApi, {
    startDeflateWorker: $7wVtg.startDeflateWorker,
    createDeflateEncoder: $cFehY.createDeflateEncoder,
    sdkName: "rum"
});
(0, $1nqsB.defineGlobal)((0, $c2Qhr.globalObject), "DD_RUM", $27c795c4ac910d10$export$65cc181beb0d2632);

});
parcelRegister("cFehY", function(module, exports) {

$parcel$export(module.exports, "createDeflateEncoder", function () { return $4c698c2530c4d7db$export$1b838d3ae89a44b8; });

var $50cui = parcelRequire("50cui");
var $eTAnO = parcelRequire("eTAnO");
//#region src/domain/deflate/deflateEncoder.ts
function $4c698c2530c4d7db$export$1b838d3ae89a44b8(worker, streamId) {
    let rawBytesCount = 0;
    let compressedData = [];
    let compressedDataTrailer;
    let isEmpty = true;
    let nextWriteActionId = 0;
    const pendingWriteActions = [];
    const expectedStreamId = streamId;
    const { stop: removeMessageListener } = (0, $50cui.addEventListener)(worker, "message", ({ data: workerResponse })=>{
        if (workerResponse.type !== "wrote" || workerResponse.streamId !== expectedStreamId) return;
        const nextPendingAction = pendingWriteActions[0];
        if (nextPendingAction) {
            if (nextPendingAction.id === workerResponse.id) {
                pendingWriteActions.shift();
                rawBytesCount += workerResponse.additionalBytesCount;
                compressedData.push(workerResponse.result);
                compressedDataTrailer = workerResponse.trailer;
                if (nextPendingAction.writeCallback) nextPendingAction.writeCallback(workerResponse.result.byteLength);
                else if (nextPendingAction.finishCallback) nextPendingAction.finishCallback();
            } else if (nextPendingAction.id < workerResponse.id) removeMessageListener();
        }
    });
    function consumeResult() {
        const output = compressedData.length === 0 ? /* @__PURE__ */ new Uint8Array(0) : (0, $eTAnO.concatBuffers)(compressedData.concat(compressedDataTrailer));
        const result = {
            rawBytesCount: rawBytesCount,
            output: output,
            outputBytesCount: output.byteLength,
            encoding: "deflate"
        };
        rawBytesCount = 0;
        compressedData = [];
        return result;
    }
    function sendResetIfNeeded() {
        if (!isEmpty) {
            worker.postMessage({
                action: "reset",
                streamId: streamId
            });
            isEmpty = true;
        }
    }
    return {
        isAsync: true,
        get isEmpty () {
            return isEmpty;
        },
        write (data, callback) {
            worker.postMessage({
                action: "write",
                id: nextWriteActionId,
                data: data,
                streamId: streamId
            });
            pendingWriteActions.push({
                id: nextWriteActionId,
                writeCallback: callback,
                data: data
            });
            isEmpty = false;
            nextWriteActionId += 1;
        },
        finish (callback) {
            sendResetIfNeeded();
            if (!pendingWriteActions.length) callback(consumeResult());
            else {
                pendingWriteActions.forEach((pendingWriteAction)=>{
                    delete pendingWriteAction.writeCallback;
                });
                pendingWriteActions[pendingWriteActions.length - 1].finishCallback = ()=>callback(consumeResult());
            }
        },
        finishSync () {
            sendResetIfNeeded();
            const pendingData = pendingWriteActions.map((pendingWriteAction)=>pendingWriteAction.data).join("");
            pendingWriteActions.length = 0;
            return {
                ...consumeResult(),
                pendingData: pendingData
            };
        },
        estimateEncodedBytesCount (data) {
            return data.length / 8;
        },
        stop () {
            removeMessageListener();
        }
    };
}

});
parcelRegister("50cui", function(module, exports) {

$parcel$export(module.exports, "DOM_EVENT", function () { return $1c77a2cf54db3678$export$54664c6599f7afe2; });
$parcel$export(module.exports, "addEventListener", function () { return $1c77a2cf54db3678$export$3f65cefe8380dbea; });
$parcel$export(module.exports, "addEventListeners", function () { return $1c77a2cf54db3678$export$40a4ed63e5cb7043; });
$parcel$export(module.exports, "isEventSupported", function () { return $1c77a2cf54db3678$export$83c7bfedfc35d3c2; });
$parcel$export(module.exports, "setAllowUntrustedEvents", function () { return $1c77a2cf54db3678$export$df4a5f3c3845f879; });

var $hu8Xq = parcelRequire("hu8Xq");

var $hH6Lc = parcelRequire("hH6Lc");

var $dee0n = parcelRequire("dee0n");
//#region src/browser/addEventListener.ts
let $1c77a2cf54db3678$export$54664c6599f7afe2 = /* @__PURE__ */ function(DOM_EVENT) {
    DOM_EVENT["BEFORE_UNLOAD"] = "beforeunload";
    DOM_EVENT["CLICK"] = "click";
    DOM_EVENT["DBL_CLICK"] = "dblclick";
    DOM_EVENT["KEY_DOWN"] = "keydown";
    DOM_EVENT["LOAD"] = "load";
    DOM_EVENT["POP_STATE"] = "popstate";
    DOM_EVENT["SCROLL"] = "scroll";
    DOM_EVENT["TOUCH_START"] = "touchstart";
    DOM_EVENT["TOUCH_END"] = "touchend";
    DOM_EVENT["TOUCH_MOVE"] = "touchmove";
    DOM_EVENT["VISIBILITY_CHANGE"] = "visibilitychange";
    DOM_EVENT["PAGE_SHOW"] = "pageshow";
    DOM_EVENT["FREEZE"] = "freeze";
    DOM_EVENT["RESUME"] = "resume";
    DOM_EVENT["DOM_CONTENT_LOADED"] = "DOMContentLoaded";
    DOM_EVENT["POINTER_DOWN"] = "pointerdown";
    DOM_EVENT["POINTER_UP"] = "pointerup";
    DOM_EVENT["POINTER_CANCEL"] = "pointercancel";
    DOM_EVENT["HASH_CHANGE"] = "hashchange";
    DOM_EVENT["PAGE_HIDE"] = "pagehide";
    DOM_EVENT["MOUSE_DOWN"] = "mousedown";
    DOM_EVENT["MOUSE_UP"] = "mouseup";
    DOM_EVENT["MOUSE_MOVE"] = "mousemove";
    DOM_EVENT["FOCUS"] = "focus";
    DOM_EVENT["BLUR"] = "blur";
    DOM_EVENT["CONTEXT_MENU"] = "contextmenu";
    DOM_EVENT["RESIZE"] = "resize";
    DOM_EVENT["CHANGE"] = "change";
    DOM_EVENT["INPUT"] = "input";
    DOM_EVENT["PLAY"] = "play";
    DOM_EVENT["PAUSE"] = "pause";
    DOM_EVENT["SECURITY_POLICY_VIOLATION"] = "securitypolicyviolation";
    DOM_EVENT["SELECTION_CHANGE"] = "selectionchange";
    DOM_EVENT["STORAGE"] = "storage";
    DOM_EVENT["UNHANDLED_REJECTION"] = "unhandledrejection";
    return DOM_EVENT;
}({});
/**
* Add an event listener to an event target object (Window, Element, mock object...).  This provides
* a few conveniences compared to using `element.addEventListener` directly:
*
* * supports IE11 by: using an option object only if needed and emulating the `once` option
*
* * wraps the listener with a `monitor` function
*
* * returns a `stop` function to remove the listener
*/ function $1c77a2cf54db3678$export$3f65cefe8380dbea(eventTarget, eventName, listener, options) {
    return $1c77a2cf54db3678$export$40a4ed63e5cb7043(eventTarget, [
        eventName
    ], listener, options);
}
/**
* Add event listeners to an event target object (Window, Element, mock object...).  This provides
* a few conveniences compared to using `element.addEventListener` directly:
*
* * supports IE11 by: using an option object only if needed and emulating the `once` option
*
* * wraps the listener with a `monitor` function
*
* * returns a `stop` function to remove the listener
*
* * with `once: true`, the listener will be called at most once, even if different events are listened
*/ function $1c77a2cf54db3678$export$40a4ed63e5cb7043(eventTarget, eventNames, listener, { once: once, capture: capture, passive: passive } = {}) {
    const listenerWithMonitor = (0, $dee0n.monitor)((event)=>{
        if (!event.isTrusted && !event.__ddIsTrusted && $1c77a2cf54db3678$var$allowUntrustedEventsFromConfiguration === false) return;
        if (once) stop();
        listener(event);
    });
    const options = passive ? {
        capture: capture,
        passive: passive
    } : capture;
    const listenerTarget = window.EventTarget && eventTarget instanceof EventTarget ? window.EventTarget.prototype : eventTarget;
    const add = (0, $hu8Xq.getZoneJsOriginalValue)(listenerTarget, "addEventListener");
    eventNames.forEach((eventName)=>add.call(eventTarget, eventName, listenerWithMonitor, options));
    function stop() {
        const remove = (0, $hu8Xq.getZoneJsOriginalValue)(listenerTarget, "removeEventListener");
        eventNames.forEach((eventName)=>remove.call(eventTarget, eventName, listenerWithMonitor, options));
    }
    return {
        stop: stop
    };
}
function $1c77a2cf54db3678$export$83c7bfedfc35d3c2(eventTarget, eventName) {
    if (!eventTarget) return false;
    try {
        $1c77a2cf54db3678$export$3f65cefe8380dbea(eventTarget, eventName, (0, $hH6Lc.noop)).stop();
        return true;
    } catch  {
        return false;
    }
}
let $1c77a2cf54db3678$var$allowUntrustedEventsFromConfiguration;
function $1c77a2cf54db3678$export$df4a5f3c3845f879(value) {
    if ($1c77a2cf54db3678$var$allowUntrustedEventsFromConfiguration === true) return;
    $1c77a2cf54db3678$var$allowUntrustedEventsFromConfiguration = value ?? false;
}
function $1c77a2cf54db3678$export$8ccb215d471aa59d() {
    $1c77a2cf54db3678$var$allowUntrustedEventsFromConfiguration = void 0;
}

});
parcelRegister("hu8Xq", function(module, exports) {

$parcel$export(module.exports, "getZoneJsOriginalValue", function () { return $0d811038f62e192d$export$610f486206760177; });

var $c2Qhr = parcelRequire("c2Qhr");
//#region src/tools/getZoneJsOriginalValue.ts
/**
* Gets the original value for a DOM API that was potentially patched by Zone.js.
*
* Zone.js[1] is a library that patches a bunch of JS and DOM APIs. It usually stores the original
* value of the patched functions/constructors/methods in a hidden property prefixed by
* __zone_symbol__.
*
* In multiple occasions, we observed that Zone.js is the culprit of important issues leading to
* browser resource exhaustion (memory leak, high CPU usage). This method is used as a workaround to
* use the original DOM API instead of the one patched by Zone.js.
*
* [1]: https://github.com/angular/angular/tree/main/packages/zone.js
*/ function $0d811038f62e192d$export$610f486206760177(target, name) {
    const browserWindow = (0, $c2Qhr.globalObject);
    let original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === "function") original = target[browserWindow.Zone.__symbol__(name)];
    if (!original) original = target[name];
    return original;
}

});
parcelRegister("c2Qhr", function(module, exports) {

$parcel$export(module.exports, "globalObject", function () { return $0649d069e39fe5ea$export$ded1884231baf037; });
$parcel$export(module.exports, "isWorkerEnvironment", function () { return $0649d069e39fe5ea$export$24f8daea74528daa; });
//#region src/util/globalObject.ts
/** The global object for the current JS environment. */ const $0649d069e39fe5ea$export$ded1884231baf037 = globalThis;
/** True when the SDK is running inside a Web Worker. */ const $0649d069e39fe5ea$export$24f8daea74528daa = "WorkerGlobalScope" in $0649d069e39fe5ea$export$ded1884231baf037;

});


parcelRegister("hH6Lc", function(module, exports) {

$parcel$export(module.exports, "throttle", function () { return $aa3801b3ae9490d2$export$de363e709c412c8a; });
$parcel$export(module.exports, "noop", function () { return $aa3801b3ae9490d2$export$8793edee2d425525; });

var $foX5P = parcelRequire("foX5P");
//#region src/tools/utils/functionUtils.ts
function $aa3801b3ae9490d2$export$de363e709c412c8a(fn, wait, options) {
    const needLeadingExecution = options?.leading !== void 0 ? options.leading : true;
    const needTrailingExecution = options?.trailing !== void 0 ? options.trailing : true;
    let inWaitPeriod = false;
    let pendingExecutionWithParameters;
    let pendingTimeoutId;
    return {
        throttled: (...parameters)=>{
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) fn(...parameters);
            else pendingExecutionWithParameters = parameters;
            inWaitPeriod = true;
            pendingTimeoutId = (0, $foX5P.setTimeout)(()=>{
                if (needTrailingExecution && pendingExecutionWithParameters) fn(...pendingExecutionWithParameters);
                inWaitPeriod = false;
                pendingExecutionWithParameters = void 0;
            }, wait);
        },
        cancel: ()=>{
            (0, $foX5P.clearTimeout)(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = void 0;
        }
    };
}
function $aa3801b3ae9490d2$export$8793edee2d425525() {}

});
parcelRegister("foX5P", function(module, exports) {

$parcel$export(module.exports, "setTimeout", function () { return $69e5d753ba10f4cf$export$831dc9f2ab0a617b; });
$parcel$export(module.exports, "clearTimeout", function () { return $69e5d753ba10f4cf$export$4e6a25ba7ce9d78e; });
$parcel$export(module.exports, "setInterval", function () { return $69e5d753ba10f4cf$export$cda6c73645970615; });
$parcel$export(module.exports, "clearInterval", function () { return $69e5d753ba10f4cf$export$5c0dc72231454d02; });

var $hu8Xq = parcelRequire("hu8Xq");

var $c2Qhr = parcelRequire("c2Qhr");

var $dee0n = parcelRequire("dee0n");
//#region src/tools/timer.ts
function $69e5d753ba10f4cf$export$831dc9f2ab0a617b(callback, delay) {
    return (0, $hu8Xq.getZoneJsOriginalValue)((0, $c2Qhr.globalObject), "setTimeout")((0, $dee0n.monitor)(callback), delay);
}
function $69e5d753ba10f4cf$export$4e6a25ba7ce9d78e(timeoutId) {
    (0, $hu8Xq.getZoneJsOriginalValue)((0, $c2Qhr.globalObject), "clearTimeout")(timeoutId);
}
function $69e5d753ba10f4cf$export$cda6c73645970615(callback, delay) {
    return (0, $hu8Xq.getZoneJsOriginalValue)((0, $c2Qhr.globalObject), "setInterval")((0, $dee0n.monitor)(callback), delay);
}
function $69e5d753ba10f4cf$export$5c0dc72231454d02(timeoutId) {
    (0, $hu8Xq.getZoneJsOriginalValue)((0, $c2Qhr.globalObject), "clearInterval")(timeoutId);
}

});
parcelRegister("dee0n", function(module, exports) {

$parcel$export(module.exports, "monitor", function () { return $d69ac58c3b4902eb$export$ec5b303098bc4b7f; });
$parcel$export(module.exports, "callMonitored", function () { return $d69ac58c3b4902eb$export$b69eb0f8afebfb6d; });
$parcel$export(module.exports, "monitorError", function () { return $d69ac58c3b4902eb$export$7ec91d0dd633c6c2; });
$parcel$export(module.exports, "startMonitorErrorCollection", function () { return $d69ac58c3b4902eb$export$2fa3dec4f40a39a2; });

var $6PIx8 = parcelRequire("6PIx8");

var $oEuYl = parcelRequire("oEuYl");
//#region src/entries/monitor.ts
/**
* Creates an isolated monitor with its own error-collection callback and display.
*
* Each consumer (SDK) should create its own monitor so that error-collection callbacks do not
* clobber each other when several SDKs share the same `@datadog/js-core/monitor` module instance.
*
* @param display - {@link Display} used for debug logging (see `createDisplay` in
* `@datadog/js-core/util`). Lets the consumer control the log prefix and console binding. Debug
* output is only emitted when debug mode is enabled (see `setDebugMode`/`getDebugMode`).
* @param onMonitorErrorCollected - Callback invoked with each error caught by the monitor (e.g. to
* forward it to telemetry). Fixed for the lifetime of the monitor.
* @returns A {@link Monitor}.
*/ function $d69ac58c3b4902eb$export$34f78c626680d09c(display, onMonitorErrorCollected) {
    function monitored(_, __, descriptor) {
        descriptor.value = monitor(descriptor.value);
    }
    function monitor(fn) {
        return function(...args) {
            return callMonitored(fn, this, args);
        };
    }
    function callMonitored(fn, context, args) {
        try {
            return fn.apply(context, args);
        } catch (e) {
            monitorError(e);
        }
    }
    function monitorError(e) {
        const displayIfDebugEnabled = (e)=>{
            if ((0, $oEuYl.getDebugMode)()) display.error("[MONITOR]", e);
        };
        displayIfDebugEnabled(e);
        try {
            onMonitorErrorCollected(e);
        } catch (e) {
            displayIfDebugEnabled(e);
        }
    }
    return {
        monitored: monitored,
        monitor: monitor,
        callMonitored: callMonitored,
        monitorError: monitorError
    };
}
/**
* Display used by the global monitor. Debug output is only emitted when
* debug mode is enabled (see {@link setDebugMode}/{@link getDebugMode}); the prefix is cosmetic.
*/ const $d69ac58c3b4902eb$var$monitorDisplay = (0, $6PIx8.createDisplay)("Datadog SDK:");
/**
* Holds the error-collection callback registered by the SDK that claimed the global monitor.
*
* `undefined` until {@link startMonitorErrorCollection} is called. Kept in a mutable holder (rather
* than passed directly to {@link createMonitor}) so the callback can be wired lazily during SDK
* init while the monitor functions themselves are usable from import time.
*/ let $d69ac58c3b4902eb$var$onMonitorErrorCollected;
const $d69ac58c3b4902eb$var$globalMonitor = $d69ac58c3b4902eb$export$34f78c626680d09c($d69ac58c3b4902eb$var$monitorDisplay, (error)=>$d69ac58c3b4902eb$var$onMonitorErrorCollected?.(error));
/**
* Function wrapper backed by the **global monitor**. See {@link Monitor.monitor} for semantics and
* usage.
*
* @param fn - The function to wrap.
* @returns A function with the same signature as `fn` that never throws (errors are collected
* instead).
*/ const $d69ac58c3b4902eb$export$ec5b303098bc4b7f = $d69ac58c3b4902eb$var$globalMonitor.monitor;
/**
* Invoke-with-error-handling backed by the **global monitor**. See {@link Monitor.callMonitored}
* for semantics and usage.
*
* @param fn - The function to invoke.
* @param context - `this` value to invoke `fn` with (optional for context-free functions).
* @param args - Arguments to invoke `fn` with (optional for context-free functions).
* @returns The result of `fn`, or `undefined` if it threw.
*/ const $d69ac58c3b4902eb$export$b69eb0f8afebfb6d = $d69ac58c3b4902eb$var$globalMonitor.callMonitored;
/**
* Direct error reporter backed by the **global monitor**. See {@link Monitor.monitorError} for
* semantics and usage.
*
* @param e - The error to report.
* @returns void; logs and forwards the error to the registered callback.
*/ const $d69ac58c3b4902eb$export$7ec91d0dd633c6c2 = $d69ac58c3b4902eb$var$globalMonitor.monitorError;
/**
* Registers the error-collection callback for the global monitor.
*
* **First-wins**: the first call claims the sink for the lifetime of the js-core module instance;
* subsequent calls are ignored and return `false`. This avoids a late-loading SDK silently
* hijacking an earlier SDK's internal-error telemetry.
*
* **Limitation / trade-off**: when several SDKs share the same js-core module instance, only the
* first SDK's callback receives internal errors caught by the global monitor — including errors
* raised by shared code (e.g. transport) on behalf of a later-loading SDK. Those errors are
* attributed to the first SDK's telemetry. There is no per-SDK attribution today; this is the
* pragmatic simplification chosen over threading monitor functions through every call site. We
* can revisit a per-SDK strategy (e.g. context-based attribution) in the future.
*
* @returns `true` if the callback was registered, `false` if a callback was already registered.
*/ function $d69ac58c3b4902eb$export$2fa3dec4f40a39a2(onMonitorErrorCollectedCallback) {
    if ($d69ac58c3b4902eb$var$onMonitorErrorCollected) return false;
    $d69ac58c3b4902eb$var$onMonitorErrorCollected = onMonitorErrorCollectedCallback;
    return true;
}
/**
* Clears the error-collection callback registered by {@link startMonitorErrorCollection}.
*
* This is the production detach path: after it returns, errors caught by the global monitor are
* dropped (no longer forwarded to telemetry). Intended for SDK teardown (`stop()`); does not
* affect debug mode. Tests that need a full reset should call this followed by
* `setDebugMode(false)`.
*/ function $d69ac58c3b4902eb$export$2e900091ce261161() {
    $d69ac58c3b4902eb$var$onMonitorErrorCollected = void 0;
}

});
parcelRegister("6PIx8", function(module, exports) {

$parcel$export(module.exports, "DOCS_ORIGIN", function () { return $ab119bef7c063701$export$61b69f86bb46c85e; });
$parcel$export(module.exports, "MORE_DETAILS", function () { return $ab119bef7c063701$export$69ce01f6d41ea86c; });
$parcel$export(module.exports, "ConsoleApiName", function () { return $ab119bef7c063701$export$d37676e8a94e6b40; });
$parcel$export(module.exports, "globalConsole", function () { return $ab119bef7c063701$export$d07b2d1b8b601164; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $ab119bef7c063701$export$77c4ce905194557b; });
$parcel$export(module.exports, "createDisplay", function () { return $ab119bef7c063701$export$630b3f7014e81311; });
//#region src/util/display.ts
/** Base origin for Datadog documentation links referenced in display messages. */ const $ab119bef7c063701$export$61b69f86bb46c85e = "https://docs.datadoghq.com";
/** Prefix used before a documentation link in a display message (e.g. `"${MORE_DETAILS} ${DOCS_ORIGIN}/..."`). */ const $ab119bef7c063701$export$69ce01f6d41ea86c = "More details:";
/** Names of the console methods wrapped by {@link Display}. */ const $ab119bef7c063701$export$d37676e8a94e6b40 = {
    log: "log",
    debug: "debug",
    info: "info",
    warn: "warn",
    error: "error"
};
/**
* When building JS bundles, some users might use a plugin[1] or configuration[2] to remove
* "console.*" references. This causes some issue as we expect `console.*` to be defined.
* As a workaround, let's use a variable alias, so those expressions won't be taken into account by
* simple static analysis.
*
* [1]: https://babeljs.io/docs/babel-plugin-transform-remove-console/
* [2]: https://github.com/terser/terser#compress-options (look for drop_console)
*/ const $ab119bef7c063701$export$d07b2d1b8b601164 = console;
/**
* Keep references on console methods to avoid triggering patched behaviors
*
* NB: in some setup, console could already be patched by another SDK.
* In this case, some display messages can be sent by the other SDK
* but we should be safe from infinite loop nonetheless.
*/ const $ab119bef7c063701$export$77c4ce905194557b = {
    log: $ab119bef7c063701$export$d07b2d1b8b601164.log,
    debug: $ab119bef7c063701$export$d07b2d1b8b601164.debug,
    info: $ab119bef7c063701$export$d07b2d1b8b601164.info,
    warn: $ab119bef7c063701$export$d07b2d1b8b601164.warn,
    error: $ab119bef7c063701$export$d07b2d1b8b601164.error
};
/**
* Creates a {@link Display} bound to the original (unpatched) console methods, prefixing every
* message with the given prefix.
*
* Capturing the original console methods up front avoids triggering behaviors added by another SDK
* (or the host application) that may have patched `console.*` afterwards.
*
* @param prefix - String prepended to every logged message (e.g. to attribute output to an SDK).
* @returns A {@link Display} whose methods forward to the original console methods.
*/ function $ab119bef7c063701$export$630b3f7014e81311(prefix) {
    return {
        debug: $ab119bef7c063701$export$77c4ce905194557b.debug.bind($ab119bef7c063701$export$d07b2d1b8b601164, prefix),
        log: $ab119bef7c063701$export$77c4ce905194557b.log.bind($ab119bef7c063701$export$d07b2d1b8b601164, prefix),
        info: $ab119bef7c063701$export$77c4ce905194557b.info.bind($ab119bef7c063701$export$d07b2d1b8b601164, prefix),
        warn: $ab119bef7c063701$export$77c4ce905194557b.warn.bind($ab119bef7c063701$export$d07b2d1b8b601164, prefix),
        error: $ab119bef7c063701$export$77c4ce905194557b.error.bind($ab119bef7c063701$export$d07b2d1b8b601164, prefix)
    };
}

});

parcelRegister("oEuYl", function(module, exports) {

$parcel$export(module.exports, "setDebugMode", function () { return $015e1f18fecfce6c$export$2be227cb6aa211be; });
$parcel$export(module.exports, "getDebugMode", function () { return $015e1f18fecfce6c$export$98c061db55879721; });
//#region src/util/debug.ts
let $015e1f18fecfce6c$var$debugMode = false;
/**
* Enables or disables debug mode globally.
*
* Debug mode is a process-wide toggle that SDKs check (via {@link getDebugMode}) to decide whether
* to emit internal diagnostic logs to the console. It does not affect any data sent to Datadog.
*
* @param newDebugMode - `true` to enable debug mode, `false` to disable it.
*/ function $015e1f18fecfce6c$export$2be227cb6aa211be(newDebugMode) {
    $015e1f18fecfce6c$var$debugMode = newDebugMode;
}
/**
* Returns whether debug mode is currently enabled (see {@link setDebugMode}).
*
* @returns `true` when debug mode is on.
*/ function $015e1f18fecfce6c$export$98c061db55879721() {
    return $015e1f18fecfce6c$var$debugMode;
}

});





parcelRegister("eTAnO", function(module, exports) {

$parcel$export(module.exports, "ONE_KIBI_BYTE", function () { return $3624812ef99c7fe5$export$756c3d65870c899e; });
$parcel$export(module.exports, "ONE_MEBI_BYTE", function () { return $3624812ef99c7fe5$export$377b1474fc07c10f; });
$parcel$export(module.exports, "computeBytesCount", function () { return $3624812ef99c7fe5$export$36cba7c53d8f13a2; });
$parcel$export(module.exports, "concatBuffers", function () { return $3624812ef99c7fe5$export$28e250f55413be00; });
//#region src/tools/utils/byteUtils.ts
const $3624812ef99c7fe5$export$756c3d65870c899e = 1024;
const $3624812ef99c7fe5$export$377b1474fc07c10f = 1024 * $3624812ef99c7fe5$export$756c3d65870c899e;
const $3624812ef99c7fe5$var$HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function $3624812ef99c7fe5$export$36cba7c53d8f13a2(candidate) {
    if (!$3624812ef99c7fe5$var$HAS_MULTI_BYTES_CHARACTERS.test(candidate)) return candidate.length;
    return new TextEncoder().encode(candidate).length;
}
function $3624812ef99c7fe5$export$28e250f55413be00(buffers) {
    if (buffers.length === 1) return buffers[0];
    const length = buffers.reduce((total, buffer)=>total + buffer.length, 0);
    const result = new Uint8Array(length);
    let offset = 0;
    for (const buffer of buffers){
        result.set(buffer, offset);
        offset += buffer.length;
    }
    return result;
}

});


parcelRegister("7wVtg", function(module, exports) {

$parcel$export(module.exports, "startDeflateWorker", function () { return $2068053584767326$export$8ad05986c983585a; });
$parcel$export(module.exports, "getDeflateWorkerStatus", function () { return $2068053584767326$export$c2a4b833556ae71; });

var $caLix = parcelRequire("caLix");

var $50cui = parcelRequire("50cui");
var $461Vl = parcelRequire("461Vl");
var $jq8c3 = parcelRequire("jq8c3");
var $bOZaS = parcelRequire("bOZaS");
var $foX5P = parcelRequire("foX5P");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/deflate/deflateWorker.ts
const $2068053584767326$export$da9b966004898f5b = 30 * (0, $1wrwm.ONE_SECOND);
function $2068053584767326$export$f7f3c9481e41f43(configuration) {
    return new Worker(configuration.workerUrl || URL.createObjectURL(new Blob([
        "(()=>{function t(t){if(1===t.length)return t[0];const e=t.reduce((t,e)=>t+e.length,0),a=new Uint8Array(e);let n=0;for(const e of t)a.set(e,n),n+=e.length;return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),n=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),r=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),i=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=Array(576);e(s);var h=Array(60);e(h);var l=Array(512);e(l);var _=Array(256);e(_);var o=Array(29);e(o);var d,u,f,c=Array(30);function p(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t?.length}function g(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(c);var v=function(t){return t<256?l[t]:l[256+(t>>>7)]},w=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},m=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,w(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},b=function(t,e,a){m(t,a[2*e],a[2*e+1])},y=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},z=function(t,e,a){var n,r,i=Array(16),s=0;for(n=1;n<=15;n++)i[n]=s=s+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=y(i[h]++,h))}},k=function(t){var e;for(e=0;e<286;e++)t.dyn_ltree[2*e]=0;for(e=0;e<30;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},x=function(t){t.bi_valid>8?w(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},A=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},U=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&A(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!A(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},B=function(t,e,r){var i,s,h,l,d=0;if(0!==t.last_lit)do{i=t.pending_buf[t.d_buf+2*d]<<8|t.pending_buf[t.d_buf+2*d+1],s=t.pending_buf[t.l_buf+d],d++,0===i?b(t,s,e):(h=_[s],b(t,h+256+1,e),0!==(l=a[h])&&(s-=o[h],m(t,s,l)),i--,h=v(i),b(t,h,r),0!==(l=n[h])&&(i-=c[h],m(t,i,l)))}while(d<t.last_lit);b(t,256,e)},I=function(t,e){var a,n,r,i=e.dyn_tree,s=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,_=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==i[2*a]?(t.heap[++t.heap_len]=_=a,t.depth[a]=0):i[2*a+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=_<2?++_:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=s[2*r+1]);for(e.max_code=_,a=t.heap_len>>1;a>=1;a--)U(t,i,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],U(t,i,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,i[2*r]=i[2*a]+i[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,i[2*a+1]=i[2*n+1]=r,t.heap[1]=r++,U(t,i,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,i,s,h,l=e.dyn_tree,_=e.max_code,o=e.stat_desc.static_tree,d=e.stat_desc.has_stree,u=e.stat_desc.extra_bits,f=e.stat_desc.extra_base,c=e.stat_desc.max_length,p=0;for(i=0;i<=15;i++)t.bl_count[i]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(i=l[2*l[2*(n=t.heap[a])+1]+1]+1)>c&&(i=c,p++),l[2*n+1]=i,n>_||(t.bl_count[i]++,s=0,n>=f&&(s=u[n-f]),h=l[2*n],t.opt_len+=h*(i+s),d&&(t.static_len+=h*(o[2*n+1]+s)));if(0!==p){do{for(i=c-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[c]--,p-=2}while(p>0);for(i=c;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--a])>_||(l[2*r+1]!==i&&(t.opt_len+=(i-l[2*r+1])*l[2*r],l[2*r+1]=i),n--)}}(t,e),z(i,_,t.bl_count)},E=function(t,e,a){var n,r,i=-1,s=e[1],h=0,l=7,_=4;for(0===s&&(l=138,_=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++h<l&&r===s||(h<_?t.bl_tree[2*r]+=h:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):h<=10?t.bl_tree[34]++:t.bl_tree[36]++,h=0,i=r,0===s?(l=138,_=3):r===s?(l=6,_=3):(l=7,_=4))},D=function(t,e,a){var n,r,i=-1,s=e[1],h=0,l=7,_=4;for(0===s&&(l=138,_=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++h<l&&r===s)){if(h<_)do{b(t,r,t.bl_tree)}while(0!==--h);else 0!==r?(r!==i&&(b(t,r,t.bl_tree),h--),b(t,16,t.bl_tree),m(t,h-3,2)):h<=10?(b(t,17,t.bl_tree),m(t,h-3,3)):(b(t,18,t.bl_tree),m(t,h-11,7));h=0,i=r,0===s?(l=138,_=3):r===s?(l=6,_=3):(l=7,_=4)}},M=!1,j=function(t,e,a,n){m(t,0+(n?1:0),3),function(t,e,a){x(t),w(t,a),w(t,~a),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a)},C=j,L=function(t,e,a,n){for(var r=65535&t,i=t>>>16&65535,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16},S=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),O=function(t,e,a,n){var r=S,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},T={2:\"need dictionary\",1:\"stream end\",0:\"\",\"-1\":\"file error\",\"-2\":\"stream error\",\"-3\":\"data error\",\"-4\":\"insufficient memory\",\"-5\":\"buffer error\",\"-6\":\"incompatible version\"},q=C,F=function(t,e,a){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&a,t.last_lit++,0===e?t.dyn_ltree[2*a]++:(t.matches++,e--,t.dyn_ltree[2*(_[a]+256+1)]++,t.dyn_dtree[2*v(e)]++),t.last_lit===t.lit_bufsize-1},G=-2,H=258,J=262,K=103,N=113,P=666,Q=function(t,e){return t.msg=T[e],e},R=function(t){return(t<<1)-(t>4?9:0)},V=function(t){for(var e=t.length;--e>=0;)t[e]=0},W=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},X=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},Y=function(t,e){(function(t,e,a,n){var r,l,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,a=4093624447;for(e=0;e<=31;e++,a>>>=1)if(1&a&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<256;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),I(t,t.l_desc),I(t,t.d_desc),_=function(t){var e;for(E(t,t.dyn_ltree,t.l_desc.max_code),E(t,t.dyn_dtree,t.d_desc.max_code),I(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*i[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),r=t.opt_len+3+7>>>3,(l=t.static_len+3+7>>>3)<=r&&(r=l)):r=l=a+5,a+4<=r&&-1!==e?j(t,e,a,n):4===t.strategy||l===r?(m(t,2+(n?1:0),3),B(t,s,h)):(m(t,4+(n?1:0),3),function(t,e,a,n){var r;for(m(t,e-257,5),m(t,a-1,5),m(t,n-4,4),r=0;r<n;r++)m(t,t.bl_tree[2*i[r]+1],3);D(t,t.dyn_ltree,e-1),D(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),B(t,t.dyn_ltree,t.dyn_dtree)),k(t),n&&x(t)})(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,X(t.strm)},Z=function(t,e){t.pending_buf[t.pending++]=e},$=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},tt=function(t,e,a,n){var r=t.avail_in;return r>n&&(r=n),0===r?0:(t.avail_in-=r,e.set(t.input.subarray(t.next_in,t.next_in+r),a),1===t.state.wrap?t.adler=L(t.adler,e,r,a):2===t.state.wrap&&(t.adler=O(t.adler,e,r,a)),t.next_in+=r,t.total_in+=r,r)},et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,h=t.nice_match,l=t.strstart>t.w_size-J?t.strstart-(t.w_size-J):0,_=t.window,o=t.w_mask,d=t.prev,u=t.strstart+H,f=_[i+s-1],c=_[i+s];t.prev_length>=t.good_match&&(r>>=2),h>t.lookahead&&(h=t.lookahead);do{if(_[(a=e)+s]===c&&_[a+s-1]===f&&_[a]===_[i]&&_[++a]===_[i+1]){i+=2,a++;do{}while(_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&i<u);if(n=H-(u-i),i=u-H,n>s){if(t.match_start=e,s=n,n>=h)break;f=_[i+s-1],c=_[i+s]}}}while((e=d[e&o])>l&&0!==--r);return s<=t.lookahead?s:t.lookahead},at=function(t){var e,a,n,r,i,s=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=s+(s-J)){t.window.set(t.window.subarray(s,s+s),0),t.match_start-=s,t.strstart-=s,t.block_start-=s,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=s?n-s:0}while(--a);e=a=s;do{n=t.prev[--e],t.prev[e]=n>=s?n-s:0}while(--a);r+=s}if(0===t.strm.avail_in)break;if(a=tt(t.strm,t.window,t.strstart+t.lookahead,r),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=W(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=W(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<J&&0!==t.strm.avail_in)},nt=function(t,e){for(var a,n;;){if(t.lookahead<J){if(at(t),t.lookahead<J&&0===e)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-J&&(t.match_length=et(t,a)),t.match_length>=3)if(n=F(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!==--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=W(t,t.ins_h,t.window[t.strstart+1]);else n=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2},rt=function(t,e){for(var a,n,r;;){if(t.lookahead<J){if(at(t),t.lookahead<J&&0===e)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-J&&(t.match_length=et(t,a),t.match_length<=5&&(1===t.strategy||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=F(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!==--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(Y(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=F(t,0,t.window[t.strstart-1]))&&Y(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=F(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2};function it(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var st=[new it(0,0,0,0,function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(at(t),0===t.lookahead&&0===e)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,Y(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-J&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(Y(t,!1),t.strm.avail_out),1)}),new it(4,4,8,4,nt),new it(4,5,16,8,nt),new it(4,6,32,32,nt),new it(4,4,16,16,rt),new it(8,16,32,32,rt),new it(8,16,128,128,rt),new it(8,32,128,256,rt),new it(32,128,258,1024,rt),new it(32,258,258,4096,rt)];function ht(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=8,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),V(this.dyn_ltree),V(this.dyn_dtree),V(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),V(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),V(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}for(var lt=function(t){var e,i=function(t){if(!t?.state)return Q(t,G);t.total_in=t.total_out=0,t.data_type=2;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:N,t.adler=2===e.wrap?0:1,e.last_flush=0,function(t){M||(function(){var t,e,i,g,v,w=Array(16);for(i=0,g=0;g<28;g++)for(o[g]=i,t=0;t<1<<a[g];t++)_[i++]=g;for(_[i-1]=g,v=0,g=0;g<16;g++)for(c[g]=v,t=0;t<1<<n[g];t++)l[v++]=g;for(v>>=7;g<30;g++)for(c[g]=v<<7,t=0;t<1<<n[g]-7;t++)l[256+v++]=g;for(e=0;e<=15;e++)w[e]=0;for(t=0;t<=143;)s[2*t+1]=8,t++,w[8]++;for(;t<=255;)s[2*t+1]=9,t++,w[9]++;for(;t<=279;)s[2*t+1]=7,t++,w[7]++;for(;t<=287;)s[2*t+1]=8,t++,w[8]++;for(z(s,287,w),t=0;t<30;t++)h[2*t+1]=5,h[2*t]=y(t,5);d=new p(s,a,257,286,15),u=new p(h,n,0,30,15),f=new p([],r,0,19,7)}(),M=!0),t.l_desc=new g(t.dyn_ltree,d),t.d_desc=new g(t.dyn_dtree,u),t.bl_desc=new g(t.bl_tree,f),t.bi_buf=0,t.bi_valid=0,k(t)}(e),0}(t);return 0===i&&((e=t.state).window_size=2*e.w_size,V(e.head),e.max_lazy_match=st[e.level].max_lazy,e.good_match=st[e.level].good_length,e.nice_match=st[e.level].nice_length,e.max_chain_length=st[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),i},_t=function(t,e){var a,n;if(!t?.state||e>5||e<0)return t?Q(t,G):G;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===P&&4!==e)return Q(t,0===t.avail_out?-5:G);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,Z(r,31),Z(r,139),Z(r,8),r.gzhead?(Z(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),Z(r,255&r.gzhead.time),Z(r,r.gzhead.time>>8&255),Z(r,r.gzhead.time>>16&255),Z(r,r.gzhead.time>>24&255),Z(r,9===r.level?2:r.strategy>=2||r.level<2?4:0),Z(r,255&r.gzhead.os),r.gzhead.extra?.length&&(Z(r,255&r.gzhead.extra.length),Z(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=O(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(Z(r,0),Z(r,0),Z(r,0),Z(r,0),Z(r,0),Z(r,9===r.level?2:r.strategy>=2||r.level<2?4:0),Z(r,3),r.status=N);else{var h=8+(r.w_bits-8<<4)<<8;h|=(r.strategy>=2||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(h|=32),h+=31-h%31,r.status=N,$(r,h),0!==r.strstart&&($(r,t.adler>>>16),$(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending!==r.pending_buf_size));)Z(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,Z(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,Z(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=K)}else r.status=K;if(r.status===K&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&X(t),r.pending+2<=r.pending_buf_size&&(Z(r,255&t.adler),Z(r,t.adler>>8&255),t.adler=0,r.status=N)):r.status=N),0!==r.pending){if(X(t),0===t.avail_out)return r.last_flush=-1,0}else if(0===t.avail_in&&R(e)<=R(i)&&4!==e)return Q(t,-5);if(r.status===P&&0!==t.avail_in)return Q(t,-5);if(0!==t.avail_in||0!==r.lookahead||0!==e&&r.status!==P){var l=2===r.strategy?function(t,e){for(var a;;){if(0===t.lookahead&&(at(t),0===t.lookahead)){if(0===e)return 1;break}if(t.match_length=0,a=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2}(r,e):3===r.strategy?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=H){if(at(t),t.lookahead<=H&&0===e)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+H;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=H-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=F(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2}(r,e):st[r.level].func(r,e);if(3!==l&&4!==l||(r.status=P),1===l||3===l)return 0===t.avail_out&&(r.last_flush=-1),0;if(2===l&&(1===e?function(t){m(t,2,3),b(t,256,s),function(t){16===t.bi_valid?(w(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}(r):5!==e&&(q(r,0,0,!1),3===e&&(V(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),X(t),0===t.avail_out))return r.last_flush=-1,0}return 4!==e?0:r.wrap<=0?1:(2===r.wrap?(Z(r,255&t.adler),Z(r,t.adler>>8&255),Z(r,t.adler>>16&255),Z(r,t.adler>>24&255),Z(r,255&t.total_in),Z(r,t.total_in>>8&255),Z(r,t.total_in>>16&255),Z(r,t.total_in>>24&255)):($(r,t.adler>>>16),$(r,65535&t.adler)),X(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?0:1)},ot=function(t){if(!t?.state)return G;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==K&&e!==N&&e!==P?Q(t,G):(t.state=null,e===N?Q(t,-3):0)},dt=new Uint8Array(256),ut=0;ut<256;ut++)dt[ut]=ut>=252?6:ut>=248?5:ut>=240?4:ut>=224?3:ut>=192?2:1;dt[254]=dt[254]=1;var ft=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg=\"\",this.state=null,this.data_type=2,this.adler=0},ct=Object.prototype.toString;function pt(){this.options={level:-1,method:8,chunkSize:16384,windowBits:15,memLevel:8,strategy:0};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg=\"\",this.ended=!1,this.chunks=[],this.strm=new ft,this.strm.avail_out=0;var e,a,n=function(t,e,a,n,r,i){if(!t)return G;var s=1;if(-1===e&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||8!==a||n<8||n>15||e<0||e>9||i<0||i>4)return Q(t,G);8===n&&(n=9);var h=new ht;return t.state=h,h.strm=t,h.wrap=s,h.gzhead=null,h.w_bits=n,h.w_size=1<<h.w_bits,h.w_mask=h.w_size-1,h.hash_bits=r+7,h.hash_size=1<<h.hash_bits,h.hash_mask=h.hash_size-1,h.hash_shift=~~((h.hash_bits+3-1)/3),h.window=new Uint8Array(2*h.w_size),h.head=new Uint16Array(h.hash_size),h.prev=new Uint16Array(h.w_size),h.lit_bufsize=1<<r+6,h.pending_buf_size=4*h.lit_bufsize,h.pending_buf=new Uint8Array(h.pending_buf_size),h.d_buf=1*h.lit_bufsize,h.l_buf=3*h.lit_bufsize,h.level=e,h.strategy=i,h.method=a,lt(t)}(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(0!==n)throw Error(T[n]);if(t.header&&(e=this.strm,a=t.header,e?.state&&(2!==e.state.wrap||(e.state.gzhead=a))),t.dictionary){var r;if(r=\"[object ArrayBuffer]\"===ct.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,0!==(n=function(t,e){var a=e.length;if(!t?.state)return G;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return G;if(1===r&&(t.adler=L(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(V(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,h=t.next_in,l=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,at(n);n.lookahead>=3;){var _=n.strstart,o=n.lookahead-2;do{n.ins_h=W(n,n.ins_h,n.window[_+3-1]),n.prev[_&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=_,_++}while(--o);n.strstart=_,n.lookahead=2,at(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=h,t.input=l,t.avail_in=s,n.wrap=r,0}(this.strm,r)))throw Error(T[n]);this._dict_set=!0}}function gt(t,e,a){try{t.postMessage({type:\"errored\",error:e,streamId:a})}catch{t.postMessage({type:\"errored\",error:e+\"\",streamId:a})}}function vt(t){const e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}pt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?4:0,\"[object ArrayBuffer]\"===ct.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(2===n||3===n)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if(1===(a=_t(r,n)))return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=ot(this.strm),this.onEnd(a),this.ended=!0,0===a;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},pt.prototype.onData=function(t){this.chunks.push(t)},pt.prototype.onEnd=function(t){0===t&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,h=t.length;i<h;i++){var l=t[i];r.set(l,s),s+=l.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e=self){try{const a=new Map;e.addEventListener(\"message\",n=>{try{const r=function(e,a){switch(a.action){case\"init\":return{type:\"initialized\",version:\"7.14.0\"};case\"write\":{let n=e.get(a.streamId);n||(n=new pt,e.set(a.streamId,n));const r=n.chunks.length,i=(new TextEncoder).encode(a.data);return n.push(i,2),{type:\"wrote\",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:vt(n),additionalBytesCount:i.length}}case\"reset\":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){gt(e,t,n.data&&\"streamId\"in n.data?n.data.streamId:void 0)}})}catch(t){gt(e,t)}}()})();"
    ])));
}
let $2068053584767326$var$state = {
    status: 0
};
function $2068053584767326$export$8ad05986c983585a(configuration, source, onInitializationFailure) {
    if ($2068053584767326$var$state.status === 0) $2068053584767326$export$ae2ae5e796988f9a(configuration, source);
    switch($2068053584767326$var$state.status){
        case 1:
            $2068053584767326$var$state.initializationFailureCallbacks.push(onInitializationFailure);
            return $2068053584767326$var$state.worker;
        case 3:
            return $2068053584767326$var$state.worker;
    }
}
function $2068053584767326$export$c2a4b833556ae71() {
    return $2068053584767326$var$state.status;
}
/**
* Starts the deflate worker and handle messages and errors
*
* The spec allow browsers to handle worker errors differently:
* - Chromium throws an exception
* - Firefox fires an error event
*
* more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
*/ function $2068053584767326$export$ae2ae5e796988f9a(configuration, source) {
    try {
        const worker = (0, $bOZaS.mockable)($2068053584767326$export$f7f3c9481e41f43)(configuration);
        const { stop: removeErrorListener } = (0, $50cui.addEventListener)(worker, "error", (error)=>{
            $2068053584767326$var$onError(configuration, source, error);
        });
        const { stop: removeMessageListener } = (0, $50cui.addEventListener)(worker, "message", ({ data: data })=>{
            if (data.type === "errored") $2068053584767326$var$onError(configuration, source, data.error, data.streamId);
            else if (data.type === "initialized") $2068053584767326$var$onInitialized(data.version);
        });
        worker.postMessage({
            action: "init"
        });
        (0, $foX5P.setTimeout)(()=>$2068053584767326$var$onTimeout(source), $2068053584767326$export$da9b966004898f5b);
        const stop = ()=>{
            removeErrorListener();
            removeMessageListener();
        };
        $2068053584767326$var$state = {
            status: 1,
            worker: worker,
            stop: stop,
            initializationFailureCallbacks: []
        };
    } catch (error) {
        $2068053584767326$var$onError(configuration, source, error);
    }
}
function $2068053584767326$var$onTimeout(source) {
    if ($2068053584767326$var$state.status === 1) {
        (0, $jq8c3.display).error(`${source} failed to start: a timeout occurred while initializing the Worker`);
        $2068053584767326$var$state.initializationFailureCallbacks.forEach((callback)=>callback());
        $2068053584767326$var$state = {
            status: 2
        };
    }
}
function $2068053584767326$var$onInitialized(version) {
    if ($2068053584767326$var$state.status === 1) $2068053584767326$var$state = {
        status: 3,
        worker: $2068053584767326$var$state.worker,
        stop: $2068053584767326$var$state.stop,
        version: version
    };
}
function $2068053584767326$var$onError(configuration, source, error, streamId) {
    if ($2068053584767326$var$state.status === 1 || $2068053584767326$var$state.status === 0) {
        (0, $caLix.reportScriptLoadingError)({
            configuredUrl: configuration.workerUrl,
            error: error,
            source: source,
            scriptType: "worker"
        });
        if ($2068053584767326$var$state.status === 1) $2068053584767326$var$state.initializationFailureCallbacks.forEach((callback)=>callback());
        $2068053584767326$var$state = {
            status: 2
        };
    } else (0, $461Vl.addTelemetryError)(error, {
        worker_version: $2068053584767326$var$state.status === 3 && $2068053584767326$var$state.version,
        stream_id: streamId
    });
}

});
parcelRegister("caLix", function(module, exports) {

$parcel$export(module.exports, "reportScriptLoadingError", function () { return $182f6739ee3767e7$export$a276d138883e3de4; });

var $461Vl = parcelRequire("461Vl");
var $jq8c3 = parcelRequire("jq8c3");

var $6PIx8 = parcelRequire("6PIx8");
//#region src/domain/scriptLoadingError.ts
function $182f6739ee3767e7$export$a276d138883e3de4({ configuredUrl: configuredUrl, error: error, source: source, scriptType: scriptType }) {
    (0, $jq8c3.display).error(`${source} failed to start: an error occurred while initializing the ${scriptType}:`, error);
    if (error instanceof Event || error instanceof Error && $182f6739ee3767e7$var$isMessageCspRelated(error.message)) {
        let baseMessage;
        if (configuredUrl) baseMessage = `Please make sure the ${scriptType} URL ${configuredUrl} is correct and CSP is correctly configured.`;
        else baseMessage = "Please make sure CSP is correctly configured.";
        (0, $jq8c3.display).error(`${baseMessage} See documentation at ${(0, $6PIx8.DOCS_ORIGIN)}/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay`);
    } else if (scriptType === "worker") (0, $461Vl.addTelemetryError)(error);
}
function $182f6739ee3767e7$var$isMessageCspRelated(message) {
    return message.includes("Content Security Policy") || message.includes("requires 'TrustedScriptURL'");
}

});
parcelRegister("461Vl", function(module, exports) {

$parcel$export(module.exports, "TelemetryService", function () { return $7b5bec578fe67795$export$48f9d5b8d678c414; });
$parcel$export(module.exports, "TelemetryMetrics", function () { return $7b5bec578fe67795$export$334807434906183b; });
$parcel$export(module.exports, "startTelemetry", function () { return $7b5bec578fe67795$export$a1198c4bba5d5e18; });
$parcel$export(module.exports, "addTelemetryError", function () { return $7b5bec578fe67795$export$2e825f93958b0e6a; });
$parcel$export(module.exports, "addTelemetryDebug", function () { return $7b5bec578fe67795$export$d922954195a17683; });
$parcel$export(module.exports, "addTelemetryConfiguration", function () { return $7b5bec578fe67795$export$d546dcbd09bc447f; });
$parcel$export(module.exports, "addTelemetryMetrics", function () { return $7b5bec578fe67795$export$4a0be9503ff69005; });
$parcel$export(module.exports, "addTelemetryUsage", function () { return $7b5bec578fe67795$export$1241dad04919e70b; });

var $fnvkG = parcelRequire("fnvkG");

var $jq8c3 = parcelRequire("jq8c3");

var $fOYzt = parcelRequire("fOYzt");

var $hH6Lc = parcelRequire("hH6Lc");

var $fiOtf = parcelRequire("fiOtf");

var $e6zeV = parcelRequire("e6zeV");

var $gnsX5 = parcelRequire("gnsX5");

var $cWoRJ = parcelRequire("cWoRJ");

var $leyUX = parcelRequire("leyUX");

var $jkF2M = parcelRequire("jkF2M");


var $hVWmP = parcelRequire("hVWmP");

var $gS0nt = parcelRequire("gS0nt");

var $luYWf = parcelRequire("luYWf");

var $hwuAb = parcelRequire("hwuAb");

var $k8VFU = parcelRequire("k8VFU");
var $hWYdN = parcelRequire("hWYdN");

var $5tXxv = parcelRequire("5tXxv");
var $oEuYl = parcelRequire("oEuYl");
var $c2Qhr = parcelRequire("c2Qhr");

var $dee0n = parcelRequire("dee0n");

var $1wrwm = parcelRequire("1wrwm");

var $fNtjE = parcelRequire("fNtjE");

var $9xMbG = parcelRequire("9xMbG");
//#region src/domain/telemetry/telemetry.ts
const $7b5bec578fe67795$var$ALLOWED_FRAME_URLS = [
    "https://www.datadoghq-browser-agent.com",
    "https://www.datad0g-browser-agent.com",
    "https://d3uc069fcn7uxw.cloudfront.net",
    "https://d20xtzwzcl0ceb.cloudfront.net",
    "http://localhost",
    "<anonymous>"
];
let $7b5bec578fe67795$export$48f9d5b8d678c414 = /* @__PURE__ */ function(TelemetryService) {
    TelemetryService["LOGS"] = "browser-logs-sdk";
    TelemetryService["RUM"] = "browser-rum-sdk";
    return TelemetryService;
}({});
let $7b5bec578fe67795$export$334807434906183b = /* @__PURE__ */ function(TelemetryMetrics) {
    TelemetryMetrics["CUSTOMER_DATA_METRIC_NAME"] = "Customer data measures";
    TelemetryMetrics["REMOTE_CONFIGURATION_METRIC_NAME"] = "remote configuration metrics";
    TelemetryMetrics["RECORDER_INIT_METRICS_TELEMETRY_NAME"] = "Recorder init metrics";
    TelemetryMetrics["SEGMENT_METRICS_TELEMETRY_NAME"] = "Segment network request metrics";
    TelemetryMetrics["SESSION_MANAGER_INIT_METRICS_TELEMETRY_NAME"] = "Session manager init metrics";
    return TelemetryMetrics;
}({});
const $7b5bec578fe67795$var$METRIC_SAMPLE_RATE = 1;
const $7b5bec578fe67795$var$TELEMETRY_EXCLUDED_SITES = [
    (0, $hWYdN.INTAKE_SITE_US1_FED),
    (0, $hWYdN.INTAKE_SITE_US2_FED)
];
const $7b5bec578fe67795$var$MAX_TELEMETRY_EVENTS_PER_PAGE = 15;
let $7b5bec578fe67795$var$telemetryObservable;
function $7b5bec578fe67795$export$6b87b6bd493d4cbf() {
    if (!$7b5bec578fe67795$var$telemetryObservable) $7b5bec578fe67795$var$telemetryObservable = new (0, $fnvkG.BufferedObservable)(100);
    return $7b5bec578fe67795$var$telemetryObservable;
}
function $7b5bec578fe67795$export$a1198c4bba5d5e18(telemetryService, configuration, hook, sdkName) {
    const observable = new (0, $fnvkG.Observable)();
    const { enabled: enabled, metricsEnabled: metricsEnabled } = $7b5bec578fe67795$export$bf13ce82ed454ffe(telemetryService, configuration, hook, observable, sdkName);
    const { stop: stop } = $7b5bec578fe67795$export$e21b6c2f85dfc755(configuration, observable);
    return {
        stop: stop,
        enabled: enabled,
        metricsEnabled: metricsEnabled
    };
}
function $7b5bec578fe67795$export$bf13ce82ed454ffe(telemetryService, configuration, hook, observable, sdkName, metricSampleRate = $7b5bec578fe67795$var$METRIC_SAMPLE_RATE, maxTelemetryEventsPerPage = $7b5bec578fe67795$var$MAX_TELEMETRY_EVENTS_PER_PAGE) {
    const alreadySentEventsByKind = {};
    const telemetryEnabled = !$7b5bec578fe67795$var$TELEMETRY_EXCLUDED_SITES.includes(configuration.site) && (0, $9xMbG.performDraw)(configuration.telemetrySampleRate);
    const telemetryEnabledPerType = {
        [(0, $hwuAb.TelemetryType).LOG]: telemetryEnabled,
        [(0, $hwuAb.TelemetryType).CONFIGURATION]: telemetryEnabled && (0, $9xMbG.performDraw)(configuration.telemetryConfigurationSampleRate),
        [(0, $hwuAb.TelemetryType).USAGE]: telemetryEnabled && (0, $9xMbG.performDraw)(configuration.telemetryUsageSampleRate),
        metric: telemetryEnabled && (0, $9xMbG.performDraw)(metricSampleRate)
    };
    const runtimeEnvInfo = $7b5bec578fe67795$var$getRuntimeEnvInfo();
    const telemetryObservable = $7b5bec578fe67795$export$6b87b6bd493d4cbf();
    telemetryObservable.subscribe(({ rawEvent: rawEvent, metricName: metricName })=>{
        if (metricName && !telemetryEnabledPerType["metric"] || !telemetryEnabledPerType[rawEvent.type]) return;
        const kind = metricName || rawEvent.status || rawEvent.type;
        let alreadySentEvents = alreadySentEventsByKind[kind];
        if (!alreadySentEvents) alreadySentEvents = alreadySentEventsByKind[kind] = /* @__PURE__ */ new Set();
        if (alreadySentEvents.size >= maxTelemetryEventsPerPage) return;
        const stringifiedEvent = (0, $gnsX5.jsonStringify)(rawEvent);
        if (alreadySentEvents.has(stringifiedEvent)) return;
        const defaultTelemetryEventAttributes = hook.trigger({
            startTime: (0, $1wrwm.clocksNow)().relative
        });
        if (defaultTelemetryEventAttributes === (0, $fNtjE.DISCARDED)) return;
        const event = toTelemetryEvent(defaultTelemetryEventAttributes, telemetryService, rawEvent, runtimeEnvInfo);
        observable.notify(event);
        (0, $jkF2M.sendToExtension)("telemetry", event);
        alreadySentEvents.add(stringifiedEvent);
    });
    telemetryObservable.unbuffer();
    (0, $dee0n.startMonitorErrorCollection)($7b5bec578fe67795$export$2e825f93958b0e6a);
    return {
        enabled: telemetryEnabled,
        metricsEnabled: telemetryEnabledPerType["metric"]
    };
    function toTelemetryEvent(defaultTelemetryEventAttributes, telemetryService, rawEvent, runtimeEnvInfo) {
        const event = {
            type: "telemetry",
            date: (0, $1wrwm.clocksNow)().timeStamp,
            service: telemetryService,
            version: "7.14.0",
            source: "browser",
            _dd: {
                format_version: 2
            },
            telemetry: (0, $5tXxv.combine)(rawEvent, {
                runtime_env: runtimeEnvInfo,
                connectivity: (0, $hVWmP.getConnectivity)(),
                sdk_setup: "npm",
                sdk_name: sdkName
            }),
            ddtags: (0, $leyUX.buildTags)(configuration).join(","),
            experimental_features: Array.from((0, $fOYzt.getExperimentalFeatures)())
        };
        return (0, $5tXxv.combine)(event, defaultTelemetryEventAttributes);
    }
}
function $7b5bec578fe67795$export$e21b6c2f85dfc755(configuration, telemetryObservable) {
    const cleanupTasks = [];
    if ((0, $gS0nt.canUseEventBridge)()) {
        const bridge = (0, $gS0nt.getEventBridge)();
        const telemetrySubscription = telemetryObservable.subscribe((event)=>bridge.send("internal_telemetry", event));
        cleanupTasks.push(telemetrySubscription.unsubscribe);
    } else {
        const endpoints = [
            (0, $k8VFU.createEndpointBuilder)(configuration, "rum")
        ];
        const replicaEndpoint = (0, $k8VFU.createReplicaEndpointBuilder)(configuration, "rum");
        if (replicaEndpoint && $7b5bec578fe67795$var$isTelemetryReplicationAllowed(configuration)) endpoints.push(replicaEndpoint);
        const telemetryBatch = (0, $luYWf.createBatch)({
            endpoints: endpoints,
            reportError: (0, $hH6Lc.noop)
        });
        cleanupTasks.push(telemetryBatch.stop);
        const telemetrySubscription = telemetryObservable.subscribe(telemetryBatch.add);
        cleanupTasks.push(telemetrySubscription.unsubscribe);
    }
    return {
        stop: ()=>cleanupTasks.forEach((task)=>task())
    };
}
function $7b5bec578fe67795$var$getRuntimeEnvInfo() {
    return {
        is_local_file: (0, $c2Qhr.globalObject).location?.protocol === "file:",
        is_worker: (0, $c2Qhr.isWorkerEnvironment)
    };
}
/**
* Avoid mixing telemetry events from different data centers
* but keep replicating staging events for reliability
*/ function $7b5bec578fe67795$var$isTelemetryReplicationAllowed(configuration) {
    return configuration.site === (0, $hWYdN.INTAKE_SITE_STAGING);
}
function $7b5bec578fe67795$export$d922954195a17683(message, context) {
    if ((0, $oEuYl.getDebugMode)()) (0, $jq8c3.display).debug("[Telemetry]", message, context);
    $7b5bec578fe67795$export$6b87b6bd493d4cbf().notify({
        rawEvent: {
            type: (0, $hwuAb.TelemetryType).LOG,
            message: message,
            status: "debug",
            ...context
        }
    });
}
function $7b5bec578fe67795$export$2e825f93958b0e6a(e, context) {
    $7b5bec578fe67795$export$6b87b6bd493d4cbf().notify({
        rawEvent: {
            type: (0, $hwuAb.TelemetryType).LOG,
            status: "error",
            ...$7b5bec578fe67795$export$7b5b869ee98c16ab(e),
            ...context
        }
    });
}
function $7b5bec578fe67795$export$d546dcbd09bc447f(configuration) {
    $7b5bec578fe67795$export$6b87b6bd493d4cbf().notify({
        rawEvent: {
            type: (0, $hwuAb.TelemetryType).CONFIGURATION,
            configuration: configuration
        }
    });
}
function $7b5bec578fe67795$export$4a0be9503ff69005(metricName, context) {
    $7b5bec578fe67795$export$6b87b6bd493d4cbf().notify({
        rawEvent: {
            type: (0, $hwuAb.TelemetryType).LOG,
            message: metricName,
            status: "debug",
            ...context
        },
        metricName: metricName
    });
}
function $7b5bec578fe67795$export$1241dad04919e70b(usage) {
    $7b5bec578fe67795$export$6b87b6bd493d4cbf().notify({
        rawEvent: {
            type: (0, $hwuAb.TelemetryType).USAGE,
            usage: usage
        }
    });
}
function $7b5bec578fe67795$export$7b5b869ee98c16ab(e) {
    if ((0, $cWoRJ.isError)(e)) {
        const stackTrace = (0, $fiOtf.computeStackTrace)(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: (0, $e6zeV.toStackTraceString)($7b5bec578fe67795$export$cb9c82b4610a83c3(stackTrace))
            },
            message: stackTrace.message
        };
    }
    return {
        error: {
            stack: (0, $cWoRJ.NO_ERROR_STACK_PRESENT_MESSAGE)
        },
        message: `Uncaught ${(0, $gnsX5.jsonStringify)(e)}`
    };
}
function $7b5bec578fe67795$export$cb9c82b4610a83c3(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter((frame)=>!frame.url || $7b5bec578fe67795$var$ALLOWED_FRAME_URLS.some((allowedFrameUrl)=>frame.url.startsWith(allowedFrameUrl)));
    return stackTrace;
}

});
parcelRegister("fnvkG", function(module, exports) {

$parcel$export(module.exports, "Observable", function () { return $16ea266a130b0d2a$export$77cea355fa80b5f4; });
$parcel$export(module.exports, "mergeObservables", function () { return $16ea266a130b0d2a$export$ca54b410f15f44fe; });
$parcel$export(module.exports, "BufferedObservable", function () { return $16ea266a130b0d2a$export$c18dc866571e997c; });

var $eqRXs = parcelRequire("eqRXs");
//#region src/tools/observable.ts
var $16ea266a130b0d2a$export$77cea355fa80b5f4 = class {
    constructor(onFirstSubscribe){
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    subscribe(observer) {
        this.addObserver(observer);
        return {
            unsubscribe: ()=>this.removeObserver(observer)
        };
    }
    notify(data) {
        this.observers.forEach((observer)=>observer(data));
    }
    addObserver(observer) {
        this.observers.push(observer);
        if (this.observers.length === 1 && this.onFirstSubscribe) this.onLastUnsubscribe = this.onFirstSubscribe(this) || void 0;
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((other)=>observer !== other);
        if (!this.observers.length && this.onLastUnsubscribe) this.onLastUnsubscribe();
    }
};
function $16ea266a130b0d2a$export$ca54b410f15f44fe(...observables) {
    return new $16ea266a130b0d2a$export$77cea355fa80b5f4((globalObservable)=>{
        const subscriptions = observables.map((observable)=>observable.subscribe((data)=>globalObservable.notify(data)));
        return ()=>subscriptions.forEach((subscription)=>subscription.unsubscribe());
    });
}
var $16ea266a130b0d2a$export$c18dc866571e997c = class extends $16ea266a130b0d2a$export$77cea355fa80b5f4 {
    constructor(maxBufferSize, onDrop){
        super();
        this.maxBufferSize = maxBufferSize;
        this.onDrop = onDrop;
        this.buffer = [];
        this.droppedCount = 0;
    }
    notify(data) {
        this.buffer.push(data);
        if (this.buffer.length > this.maxBufferSize) {
            this.buffer.shift();
            this.droppedCount++;
        }
        super.notify(data);
    }
    subscribe(observer) {
        let closed = false;
        const subscription = {
            unsubscribe: ()=>{
                closed = true;
                this.removeObserver(observer);
            }
        };
        (0, $eqRXs.queueMicrotask)(()=>{
            for (const data of this.buffer){
                if (closed) return;
                observer(data);
            }
            if (!closed) this.addObserver(observer);
        });
        return subscription;
    }
    /**
	* Drop buffered data and don't buffer future data. This is to avoid leaking memory when it's not
	* needed anymore. This can be seen as a performance optimization, and things will work probably
	* even if this method isn't called, but still useful to clarify our intent and lowering our
	* memory impact.
	*/ unbuffer() {
        (0, $eqRXs.queueMicrotask)(()=>{
            if (this.droppedCount > 0 && this.onDrop) this.onDrop(this.droppedCount);
            this.maxBufferSize = this.buffer.length = 0;
        });
    }
};

});
parcelRegister("eqRXs", function(module, exports) {

$parcel$export(module.exports, "queueMicrotask", function () { return $461c2c70934887f8$export$940a1c21a3fba9d1; });

var $c2Qhr = parcelRequire("c2Qhr");

var $dee0n = parcelRequire("dee0n");
//#region src/tools/queueMicrotask.ts
function $461c2c70934887f8$export$940a1c21a3fba9d1(callback) {
    const nativeImplementation = (0, $c2Qhr.globalObject).queueMicrotask;
    if (typeof nativeImplementation === "function") nativeImplementation((0, $dee0n.monitor)(callback));
    else Promise.resolve().then((0, $dee0n.monitor)(callback));
}

});


parcelRegister("jq8c3", function(module, exports) {

$parcel$export(module.exports, "display", function () { return $d782d3dab4b73e09$export$79693fdaa4661ff2; });
$parcel$export(module.exports, "DOCS_TROUBLESHOOTING", function () { return $d782d3dab4b73e09$export$f3bbdb3cea20e78e; });

var $6PIx8 = parcelRequire("6PIx8");
//#region src/tools/display.ts
const $d782d3dab4b73e09$export$79693fdaa4661ff2 = (0, $6PIx8.createDisplay)("Datadog Browser SDK:");
const $d782d3dab4b73e09$export$f3bbdb3cea20e78e = `${(0, $6PIx8.DOCS_ORIGIN)}/real_user_monitoring/browser/troubleshooting`;

});

parcelRegister("fOYzt", function(module, exports) {

$parcel$export(module.exports, "ExperimentalFeature", function () { return $1232393970e0abd7$export$8c1a7666d5772525; });
$parcel$export(module.exports, "initFeatureFlags", function () { return $1232393970e0abd7$export$f9d0db67c92b2ab2; });
$parcel$export(module.exports, "isExperimentalFeatureEnabled", function () { return $1232393970e0abd7$export$ada3eaf101ef7eb6; });
$parcel$export(module.exports, "getExperimentalFeatures", function () { return $1232393970e0abd7$export$45a70c97bd86e1c8; });

var $brKlt = parcelRequire("brKlt");
//#region src/tools/experimentalFeatures.ts
/**
* LIMITATION:
* For NPM setup, this feature flag singleton is shared between RUM and Logs product.
* This means that an experimental flag set on the RUM product will be set on the Logs product.
* So keep in mind that in certain configurations, your experimental feature flag may affect other products.
*
* FORMAT:
* All feature flags should be snake_cased
*/ let $1232393970e0abd7$export$8c1a7666d5772525 = /* @__PURE__ */ function(ExperimentalFeature) {
    ExperimentalFeature["SESSION_REPLAY_RECORD_CANVAS"] = "session_replay_record_canvas";
    ExperimentalFeature["TRACK_INTAKE_REQUESTS"] = "track_intake_requests";
    ExperimentalFeature["TRACK_WEBSOCKETS"] = "track_websockets";
    ExperimentalFeature["SOFT_NAVIGATION"] = "soft_navigation";
    return ExperimentalFeature;
}({});
const $1232393970e0abd7$var$enabledExperimentalFeatures = /* @__PURE__ */ new Set();
function $1232393970e0abd7$export$f9d0db67c92b2ab2(enableExperimentalFeatures) {
    if (Array.isArray(enableExperimentalFeatures)) $1232393970e0abd7$export$6d36e587aa761763(enableExperimentalFeatures.filter((flag)=>(0, $brKlt.objectHasValue)($1232393970e0abd7$export$8c1a7666d5772525, flag)));
}
function $1232393970e0abd7$export$6d36e587aa761763(enabledFeatures) {
    enabledFeatures.forEach((flag)=>{
        $1232393970e0abd7$var$enabledExperimentalFeatures.add(flag);
    });
}
function $1232393970e0abd7$export$ada3eaf101ef7eb6(featureName) {
    return $1232393970e0abd7$var$enabledExperimentalFeatures.has(featureName);
}
function $1232393970e0abd7$export$45a70c97bd86e1c8() {
    return $1232393970e0abd7$var$enabledExperimentalFeatures;
}

});
parcelRegister("brKlt", function(module, exports) {

$parcel$export(module.exports, "tryJsonParse", function () { return $6a56a6d7ea931086$export$cb915d61ff5253f2; });
$parcel$export(module.exports, "shallowClone", function () { return $6a56a6d7ea931086$export$370e8311c3cdebd9; });
$parcel$export(module.exports, "objectHasValue", function () { return $6a56a6d7ea931086$export$783ef1184b4cd483; });
$parcel$export(module.exports, "isEmptyObject", function () { return $6a56a6d7ea931086$export$83b788b1a3698c03; });
$parcel$export(module.exports, "mapValues", function () { return $6a56a6d7ea931086$export$825e789796ab7275; });
//#region src/tools/utils/objectUtils.ts
const $6a56a6d7ea931086$var$stripDangerousKeys = (key, value)=>key === "__proto__" ? void 0 : value;
function $6a56a6d7ea931086$export$cb915d61ff5253f2(text) {
    try {
        return JSON.parse(text, $6a56a6d7ea931086$var$stripDangerousKeys);
    } catch  {}
}
function $6a56a6d7ea931086$export$370e8311c3cdebd9(object) {
    return {
        ...object
    };
}
function $6a56a6d7ea931086$export$783ef1184b4cd483(object, value) {
    return Object.keys(object).some((key)=>object[key] === value);
}
function $6a56a6d7ea931086$export$83b788b1a3698c03(object) {
    return Object.keys(object).length === 0;
}
function $6a56a6d7ea931086$export$825e789796ab7275(object, fn) {
    const newObject = {};
    for (const key of Object.keys(object))newObject[key] = fn(object[key]);
    return newObject;
}
function $6a56a6d7ea931086$export$5e94c011200079cb(value) {
    try {
        const name = value?.constructor?.name;
        return typeof name === "string" && name ? name : void 0;
    } catch  {}
}

});


parcelRegister("fiOtf", function(module, exports) {

$parcel$export(module.exports, "computeStackTrace", function () { return $5c7d907d61efef6e$export$81296eded4f2ac09; });
$parcel$export(module.exports, "computeStackTraceFromOnErrorMessage", function () { return $5c7d907d61efef6e$export$e8e53f0e2ff18afa; });

var $bF5dI = parcelRequire("bF5dI");
//#region src/tools/stackTrace/computeStackTrace.ts
/**
* Cross-browser stack trace computation.
*
* Reference implementation: https://github.com/csnover/TraceKit/blob/04530298073c3823de72deb0b97e7b38ca7bcb59/tracekit.js
*/ const $5c7d907d61efef6e$var$UNKNOWN_FUNCTION = "?";
function $5c7d907d61efef6e$export$81296eded4f2ac09(ex) {
    const stack = [];
    let stackProperty = $5c7d907d61efef6e$var$tryToGetString(ex, "stack");
    const exString = String(ex);
    if (stackProperty?.startsWith(exString)) stackProperty = stackProperty.slice(exString.length);
    if (stackProperty) stackProperty.split("\n").forEach((line)=>{
        const stackFrame = $5c7d907d61efef6e$var$parseChromeLine(line) || $5c7d907d61efef6e$var$parseChromeAnonymousLine(line) || $5c7d907d61efef6e$var$parseWinLine(line) || $5c7d907d61efef6e$var$parseGeckoLine(line);
        if (stackFrame) {
            if (!stackFrame.func && stackFrame.line) stackFrame.func = $5c7d907d61efef6e$var$UNKNOWN_FUNCTION;
            stack.push(stackFrame);
        }
    });
    if (stack.length > 0 && $5c7d907d61efef6e$var$isWronglyReportingCustomErrors() && ex instanceof Error) {
        const constructors = [];
        let currentPrototype = ex;
        while((currentPrototype = Object.getPrototypeOf(currentPrototype)) && $5c7d907d61efef6e$var$isNonNativeClassPrototype(currentPrototype)){
            const constructorName = currentPrototype.constructor?.name || $5c7d907d61efef6e$var$UNKNOWN_FUNCTION;
            constructors.push(constructorName);
        }
        for(let i = constructors.length - 1; i >= 0 && stack[0]?.func === constructors[i]; i--)stack.shift();
    }
    return {
        message: $5c7d907d61efef6e$var$tryToGetString(ex, "message"),
        name: $5c7d907d61efef6e$var$tryToGetString(ex, "name"),
        stack: stack
    };
}
const $5c7d907d61efef6e$var$fileUrl = "((?:blob|native|eval|<anonymous>|[a-zA-Z][a-zA-Z0-9+.-]*:\\/\\/|\\w+\\.|\\/).*?)";
const $5c7d907d61efef6e$var$filePosition = "(?::(\\d+))";
const $5c7d907d61efef6e$var$CHROME_LINE_RE = new RegExp(`^\\s*at (.*?) ?\\(${$5c7d907d61efef6e$var$fileUrl}${$5c7d907d61efef6e$var$filePosition}?${$5c7d907d61efef6e$var$filePosition}?\\)?\\s*$`, "i");
const $5c7d907d61efef6e$var$CHROME_EVAL_RE = new RegExp(`\\((\\S*)${$5c7d907d61efef6e$var$filePosition}${$5c7d907d61efef6e$var$filePosition}\\)`);
function $5c7d907d61efef6e$var$parseChromeLine(line) {
    const parts = $5c7d907d61efef6e$var$CHROME_LINE_RE.exec(line);
    if (!parts) return;
    const isNative = parts[2]?.indexOf("native") === 0;
    const isEval = parts[2]?.indexOf("eval") === 0;
    const submatch = $5c7d907d61efef6e$var$CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        parts[2] = submatch[1];
        parts[3] = submatch[2];
        parts[4] = submatch[3];
    }
    return {
        args: isNative ? [
            parts[2]
        ] : [],
        column: parts[4] ? +parts[4] : void 0,
        func: parts[1] || $5c7d907d61efef6e$var$UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : void 0,
        url: !isNative ? parts[2] : void 0
    };
}
const $5c7d907d61efef6e$var$CHROME_ANONYMOUS_FUNCTION_RE = new RegExp(`^\\s*at\\s*(?:(.*)?(?: @))?\\s*${$5c7d907d61efef6e$var$fileUrl}${$5c7d907d61efef6e$var$filePosition}?${$5c7d907d61efef6e$var$filePosition}??\\s*$`, "i");
function $5c7d907d61efef6e$var$parseChromeAnonymousLine(line) {
    const parts = $5c7d907d61efef6e$var$CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) return;
    return {
        args: [],
        column: parts[4] ? +parts[4] : void 0,
        func: parts[1] || $5c7d907d61efef6e$var$UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : void 0,
        url: parts[2]
    };
}
const $5c7d907d61efef6e$var$WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function $5c7d907d61efef6e$var$parseWinLine(line) {
    const parts = $5c7d907d61efef6e$var$WINJS_LINE_RE.exec(line);
    if (!parts) return;
    return {
        args: [],
        column: parts[4] ? +parts[4] : void 0,
        func: parts[1] || $5c7d907d61efef6e$var$UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2]
    };
}
const $5c7d907d61efef6e$var$GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:(?:(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle|\[wasm code\])(?::(\d+))?(?::(\d+))?)|@)\s*$/i;
const $5c7d907d61efef6e$var$GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function $5c7d907d61efef6e$var$parseGeckoLine(line) {
    const parts = $5c7d907d61efef6e$var$GECKO_LINE_RE.exec(line);
    if (!parts) return;
    const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
    const submatch = $5c7d907d61efef6e$var$GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = void 0;
    }
    return {
        args: parts[2] ? parts[2].split(",") : [],
        column: parts[5] ? +parts[5] : void 0,
        func: parts[1] || $5c7d907d61efef6e$var$UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : void 0,
        url: parts[3]
    };
}
function $5c7d907d61efef6e$var$tryToGetString(candidate, property) {
    return (0, $bF5dI.isIndexableObject)(candidate) && typeof candidate[property] === "string" ? candidate[property] : void 0;
}
function $5c7d907d61efef6e$export$e8e53f0e2ff18afa(messageObj, url, line, column) {
    if (url === void 0) return;
    const { name: name, message: message } = $5c7d907d61efef6e$var$tryToParseMessage(messageObj);
    return {
        name: name,
        message: message,
        stack: [
            {
                url: url,
                column: column,
                line: line
            }
        ]
    };
}
const $5c7d907d61efef6e$var$ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function $5c7d907d61efef6e$var$tryToParseMessage(messageObj) {
    let name;
    let message;
    if (({}).toString.call(messageObj) === "[object String]") [, name, message] = $5c7d907d61efef6e$var$ERROR_TYPES_RE.exec(messageObj);
    return {
        name: name,
        message: message
    };
}
function $5c7d907d61efef6e$var$isNonNativeClassPrototype(prototype) {
    return String(prototype.constructor).startsWith("class ");
}
let $5c7d907d61efef6e$var$isWronglyReportingCustomErrorsCache;
function $5c7d907d61efef6e$var$isWronglyReportingCustomErrors() {
    if ($5c7d907d61efef6e$var$isWronglyReportingCustomErrorsCache !== void 0) return $5c7d907d61efef6e$var$isWronglyReportingCustomErrorsCache;
    class DatadogTestCustomError extends Error {
        constructor(){
            super();
            this.name = "Error";
        }
    }
    const [customError, nativeError] = [
        DatadogTestCustomError,
        Error
    ].map((errConstructor)=>new errConstructor());
    $5c7d907d61efef6e$var$isWronglyReportingCustomErrorsCache = $5c7d907d61efef6e$var$isNonNativeClassPrototype(Object.getPrototypeOf(customError)) && nativeError.stack !== customError.stack;
    return $5c7d907d61efef6e$var$isWronglyReportingCustomErrorsCache;
}

});
parcelRegister("bF5dI", function(module, exports) {

$parcel$export(module.exports, "getType", function () { return $3fab2d832c43d69e$export$e2b5c5db9e2009fd; });
$parcel$export(module.exports, "isIndexableObject", function () { return $3fab2d832c43d69e$export$e6bfaed68d90ccbd; });
$parcel$export(module.exports, "isPercentage", function () { return $3fab2d832c43d69e$export$d86432a85610ea90; });
$parcel$export(module.exports, "isMatchOption", function () { return $3fab2d832c43d69e$export$b620f5b550eaf484; });
//#region src/util/typeUtils.ts
/**
* Similar to `typeof`, but distinguish plain objects from `null` and arrays
*
* @returns `'null'` for `null`, `'array'` for arrays, or the result of `typeof` for everything else.
*/ function $3fab2d832c43d69e$export$e2b5c5db9e2009fd(value) {
    if (value === null) return "null";
    if (Array.isArray(value)) return "array";
    return typeof value;
}
/**
* Checks whether a value can have properties. Use this when you have an unknown value and you want
* to access its properties as unknown. This is a friendly solution for dealing with unknown objects
* in TypeScript.
*
* This function is intended to be used on values that will be used as "plain objects", i.e. not
* Array, Date, RegExp or other class instances. But it's safe to use on any value.
*
* @returns `true` if `value` is a non-null object that is not an array.
* @example
* ```
* // Before:
* if (typeof value === 'object' && value !== null && 'property' in value && typeof value.property === 'string') {
*   // use value.property
* }
* // After:
* if (isIndexableObject(value) && typeof value.property === 'string') {
*   // use value.property
* }
* ```
*/ function $3fab2d832c43d69e$export$e6bfaed68d90ccbd(value) {
    return $3fab2d832c43d69e$export$e2b5c5db9e2009fd(value) === "object";
}
/**
* Checks whether `value` is a valid percentage: a number between 0 and 100 inclusive.
*/ function $3fab2d832c43d69e$export$d86432a85610ea90(value) {
    return typeof value === "number" && value >= 0 && value <= 100;
}
/**
* Checks whether `value` can be used to match against a string: a string, a RegExp, or a
* predicate function.
*/ function $3fab2d832c43d69e$export$b620f5b550eaf484(value) {
    return typeof value === "string" || value instanceof RegExp || typeof value === "function";
}

});


parcelRegister("e6zeV", function(module, exports) {

$parcel$export(module.exports, "createHandlingStack", function () { return $ccae801a574789c4$export$46c2cbbc853cd95b; });
$parcel$export(module.exports, "toStackTraceString", function () { return $ccae801a574789c4$export$36ad41d7075a6f2b; });
$parcel$export(module.exports, "formatErrorMessage", function () { return $ccae801a574789c4$export$5201d50a34753d71; });

var $fiOtf = parcelRequire("fiOtf");

var $dee0n = parcelRequire("dee0n");
//#region src/tools/stackTrace/handlingStack.ts
/**
* Creates a stacktrace without SDK internal frames.
* Constraints:
* - Has to be called at the utmost position of the call stack.
* - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
*/ function $ccae801a574789c4$export$46c2cbbc853cd95b(type) {
    /**
	* Skip the two internal frames:
	* - SDK API (console.error, ...)
	* - this function
	* in order to keep only the user calls
	*/ const internalFramesToSkip = 2;
    const error = new Error(type);
    error.name = "HandlingStack";
    let formattedStack;
    (0, $dee0n.callMonitored)(()=>{
        const stackTrace = (0, $fiOtf.computeStackTrace)(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = $ccae801a574789c4$export$36ad41d7075a6f2b(stackTrace);
    });
    return formattedStack;
}
function $ccae801a574789c4$export$36ad41d7075a6f2b(stack) {
    let result = $ccae801a574789c4$export$5201d50a34753d71(stack);
    stack.stack.forEach((frame)=>{
        const func = frame.func === "?" ? "<anonymous>" : frame.func;
        const args = frame.args && frame.args.length > 0 ? `(${frame.args.join(", ")})` : "";
        const line = frame.line ? `:${frame.line}` : "";
        const column = frame.line && frame.column ? `:${frame.column}` : "";
        result += `\n  at ${func}${args} @ ${frame.url}${line}${column}`;
    });
    return result;
}
function $ccae801a574789c4$export$5201d50a34753d71(stack) {
    return `${stack.name || "Error"}: ${stack.message}`;
}

});

parcelRegister("gnsX5", function(module, exports) {

$parcel$export(module.exports, "jsonStringify", function () { return $81d5bfb3a2a4ef0f$export$1f8609334739c2b6; });
$parcel$export(module.exports, "detachToJsonMethod", function () { return $81d5bfb3a2a4ef0f$export$f6ec9d87b663748; });

var $hH6Lc = parcelRequire("hH6Lc");
//#region src/tools/serialisation/jsonStringify.ts
/**
* Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
* because some sites badly override toJSON on certain objects. Removing all toJSON methods from
* nested values would be too costly, so we just detach them from the root value, and native classes
* used to build JSON values (Array and Object).
*
* Note: this still assumes that JSON.stringify is correct.
*/ function $81d5bfb3a2a4ef0f$export$1f8609334739c2b6(value, replacer, space) {
    if (typeof value !== "object" || value === null) return JSON.stringify(value);
    const restoreObjectPrototypeToJson = $81d5bfb3a2a4ef0f$export$f6ec9d87b663748(Object.prototype);
    const restoreArrayPrototypeToJson = $81d5bfb3a2a4ef0f$export$f6ec9d87b663748(Array.prototype);
    const restoreValuePrototypeToJson = $81d5bfb3a2a4ef0f$export$f6ec9d87b663748(Object.getPrototypeOf(value));
    const restoreValueToJson = $81d5bfb3a2a4ef0f$export$f6ec9d87b663748(value);
    try {
        return JSON.stringify(value, replacer, space);
    } catch  {
        return "<error: unable to serialize object>";
    } finally{
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
function $81d5bfb3a2a4ef0f$export$f6ec9d87b663748(value) {
    const object = value;
    const objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return ()=>{
            object.toJSON = objectToJson;
        };
    }
    return 0, $hH6Lc.noop;
}

});

parcelRegister("cWoRJ", function(module, exports) {

$parcel$export(module.exports, "NO_ERROR_STACK_PRESENT_MESSAGE", function () { return $7cb672464d09f221$export$25ad0fcc62fe3571; });
$parcel$export(module.exports, "isError", function () { return $7cb672464d09f221$export$e6127cc7fe7395c3; });
//#region src/domain/error/isError.ts
const $7cb672464d09f221$export$25ad0fcc62fe3571 = "No stack, consider using an instance of Error";
function $7cb672464d09f221$export$e6127cc7fe7395c3(error) {
    try {
        return error instanceof Error || Object.prototype.toString.call(error) === "[object Error]";
    } catch  {
        return false;
    }
}

});

parcelRegister("leyUX", function(module, exports) {

$parcel$export(module.exports, "buildTags", function () { return $726b7f442c37c7ee$export$ebabee42db672bb6; });
$parcel$export(module.exports, "buildTag", function () { return $726b7f442c37c7ee$export$4478cda40be33ba2; });
$parcel$export(module.exports, "sanitizeTag", function () { return $726b7f442c37c7ee$export$f478f5145f8a9a3d; });

var $jq8c3 = parcelRequire("jq8c3");

var $6PIx8 = parcelRequire("6PIx8");
//#region src/domain/tags.ts
const $726b7f442c37c7ee$export$4f41fac0b8471c73 = 200;
function $726b7f442c37c7ee$export$ebabee42db672bb6(configuration) {
    const { env: env, service: service, version: version, datacenter: datacenter, sdkVersion: sdkVersion, variant: variant } = configuration;
    const tags = [
        $726b7f442c37c7ee$export$4478cda40be33ba2("sdk_version", sdkVersion ?? "7.14.0")
    ];
    if (env) tags.push($726b7f442c37c7ee$export$4478cda40be33ba2("env", env));
    if (service) tags.push($726b7f442c37c7ee$export$4478cda40be33ba2("service", service));
    if (version) tags.push($726b7f442c37c7ee$export$4478cda40be33ba2("version", version));
    if (datacenter) tags.push($726b7f442c37c7ee$export$4478cda40be33ba2("datacenter", datacenter));
    if (variant) tags.push($726b7f442c37c7ee$export$4478cda40be33ba2("variant", variant));
    return tags;
}
function $726b7f442c37c7ee$export$4478cda40be33ba2(key, rawValue) {
    const tag = rawValue ? `${key}:${rawValue}` : key;
    if (tag.length > 200 || $726b7f442c37c7ee$var$hasForbiddenCharacters(tag)) (0, $jq8c3.display).warn(`Tag ${tag} doesn't meet tag requirements and will be sanitized. ${(0, $6PIx8.MORE_DETAILS)} ${(0, $6PIx8.DOCS_ORIGIN)}/getting_started/tagging/#defining-tags`);
    return $726b7f442c37c7ee$export$f478f5145f8a9a3d(tag);
}
function $726b7f442c37c7ee$export$f478f5145f8a9a3d(tag) {
    return tag.replace(/,/g, "_");
}
function $726b7f442c37c7ee$var$hasForbiddenCharacters(rawValue) {
    return new RegExp("[^\\p{Ll}\\p{Lo}0-9_:./-]", "u").test(rawValue);
}

});

parcelRegister("jkF2M", function(module, exports) {

$parcel$export(module.exports, "sendToExtension", function () { return $ec99a2be71993786$export$528ac5c14fe2fa6b; });

var $c2Qhr = parcelRequire("c2Qhr");
//#region src/tools/sendToExtension.ts
function $ec99a2be71993786$export$528ac5c14fe2fa6b(type, payload) {
    const callback = (0, $c2Qhr.globalObject).__ddBrowserSdkExtensionCallback;
    if (callback) callback({
        type: type,
        payload: payload
    });
}

});

parcelRegister("hVWmP", function(module, exports) {

$parcel$export(module.exports, "getConnectivity", function () { return $76f3f4c393f13fcc$export$5c86d3b16901f3ce; });

var $c2Qhr = parcelRequire("c2Qhr");
//#region src/domain/connectivity/connectivity.ts
function $76f3f4c393f13fcc$export$5c86d3b16901f3ce() {
    const { navigator: navigator } = (0, $c2Qhr.globalObject);
    return {
        status: navigator?.onLine ? "connected" : "not_connected",
        interfaces: navigator?.connection?.type ? [
            navigator.connection.type
        ] : void 0,
        effective_type: navigator?.connection?.effectiveType
    };
}

});

parcelRegister("gS0nt", function(module, exports) {

$parcel$export(module.exports, "BridgeCapability", function () { return $c5231af2cecda2c1$export$a91a1b7eac5b5f7c; });
$parcel$export(module.exports, "getEventBridge", function () { return $c5231af2cecda2c1$export$86c8e1e7efd0dfc1; });
$parcel$export(module.exports, "bridgeSupports", function () { return $c5231af2cecda2c1$export$c3d8d1f8445a3630; });
$parcel$export(module.exports, "canUseEventBridge", function () { return $c5231af2cecda2c1$export$a8ab916fee43a31b; });

var $jq8c3 = parcelRequire("jq8c3");

var $c2Qhr = parcelRequire("c2Qhr");
//#region src/transport/eventBridge.ts
let $c5231af2cecda2c1$export$a91a1b7eac5b5f7c = /* @__PURE__ */ function(BridgeCapability) {
    BridgeCapability["RECORDS"] = "records";
    BridgeCapability["PROFILES"] = "profiles";
    return BridgeCapability;
}({});
function $c5231af2cecda2c1$export$86c8e1e7efd0dfc1() {
    const eventBridgeGlobal = $c5231af2cecda2c1$var$getEventBridgeGlobal();
    if (!eventBridgeGlobal) return;
    return {
        getCapabilities () {
            return JSON.parse(eventBridgeGlobal.getCapabilities?.() || "[]");
        },
        getPrivacyLevel () {
            return eventBridgeGlobal.getPrivacyLevel?.();
        },
        getIsTraceSampled () {
            return JSON.parse(eventBridgeGlobal.getIsTraceSampled?.() || "null");
        },
        getAllowedWebViewHosts () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send (eventType, event, viewId) {
            const view = viewId ? {
                id: viewId
            } : void 0;
            eventBridgeGlobal.send(JSON.stringify({
                eventType: eventType,
                event: event,
                view: view
            }));
        }
    };
}
function $c5231af2cecda2c1$export$c3d8d1f8445a3630(capability) {
    const bridge = $c5231af2cecda2c1$export$86c8e1e7efd0dfc1();
    return !!bridge && bridge.getCapabilities().includes(capability);
}
function $c5231af2cecda2c1$export$a8ab916fee43a31b(currentHost = (0, $c2Qhr.globalObject).location?.hostname) {
    return $c5231af2cecda2c1$export$86c8e1e7efd0dfc1()?.getAllowedWebViewHosts().some((entry)=>$c5231af2cecda2c1$export$189971ab7be107dd(currentHost, entry)) ?? false;
}
function $c5231af2cecda2c1$export$189971ab7be107dd(host, entry) {
    if (!entry.includes("*")) return host === entry || host.endsWith(`.${entry}`);
    const parts = entry.split("*");
    if (parts.length !== 2) {
        (0, $jq8c3.display).error(`Invalid WebView host pattern "${entry}": only one wildcard (*) is supported.`);
        return false;
    }
    const [prefix, suffix] = parts;
    return host.length > prefix.length + suffix.length && host.startsWith(prefix) && host.endsWith(suffix);
}
function $c5231af2cecda2c1$var$getEventBridgeGlobal() {
    return (0, $c2Qhr.globalObject).DatadogEventBridge;
}

});

parcelRegister("luYWf", function(module, exports) {

$parcel$export(module.exports, "createBatch", function () { return $5cc5a02170e0ff41$export$71e68e90ba624b44; });

var $jq8c3 = parcelRequire("jq8c3");

var $bOZaS = parcelRequire("bOZaS");

var $eTAnO = parcelRequire("eTAnO");

var $gnsX5 = parcelRequire("gnsX5");

var $b28LB = parcelRequire("b28LB");

var $2faqW = parcelRequire("2faqW");

var $ljRg3 = parcelRequire("ljRg3");

var $8DfP8 = parcelRequire("8DfP8");

var $hvzBH = parcelRequire("hvzBH");

var $6PIx8 = parcelRequire("6PIx8");
//#region src/transport/batch.ts
const $5cc5a02170e0ff41$export$187bee24de14bef = 256 * (0, $eTAnO.ONE_KIBI_BYTE);
function $5cc5a02170e0ff41$export$71e68e90ba624b44({ encoder: encoder = (0, $8DfP8.createIdentityEncoder)(), endpoints: endpoints, reportError: reportError }) {
    const request = (0, $bOZaS.mockable)((0, $b28LB.createHttpRequest))(endpoints, reportError);
    const pageMayExitObservable = (0, $bOZaS.mockable)((0, $ljRg3.createPageMayExitObservable))();
    const flushController = (0, $bOZaS.mockable)((0, $hvzBH.createFlushController))({
        pageMayExitObservable: pageMayExitObservable
    });
    let upsertBuffer = {};
    const flushSubscription = flushController.flushObservable.subscribe((event)=>flush(event));
    function push(serializedMessage, estimatedMessageBytesCount, key) {
        if (key !== void 0) {
            let bytesDiff;
            if (upsertBuffer[key] !== void 0) bytesDiff = estimatedMessageBytesCount - encoder.estimateEncodedBytesCount(upsertBuffer[key]);
            else {
                flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
                bytesDiff = 0;
            }
            upsertBuffer[key] = serializedMessage;
            flushController.notifyAfterAddMessage(bytesDiff);
        } else {
            flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
            encoder.write(encoder.isEmpty ? serializedMessage : `\n${serializedMessage}`, (realMessageBytesCount)=>{
                flushController.notifyAfterAddMessage(realMessageBytesCount - estimatedMessageBytesCount);
            });
        }
    }
    function addOrUpdate(message, key) {
        const serializedMessage = (0, $gnsX5.jsonStringify)(message);
        const estimatedMessageBytesCount = encoder.estimateEncodedBytesCount(serializedMessage);
        if (estimatedMessageBytesCount >= $5cc5a02170e0ff41$export$187bee24de14bef) {
            (0, $jq8c3.display).warn(`Discarded a message whose size was bigger than the maximum allowed size ${$5cc5a02170e0ff41$export$187bee24de14bef / (0, $eTAnO.ONE_KIBI_BYTE)}KiB. ${(0, $6PIx8.MORE_DETAILS)} ${(0, $jq8c3.DOCS_TROUBLESHOOTING)}/#technical-limitations`);
            return;
        }
        push(serializedMessage, estimatedMessageBytesCount, key);
    }
    function flush(event) {
        const upsertMessages = (0, $2faqW.objectValues)(upsertBuffer).join("\n");
        upsertBuffer = {};
        const pageMightExit = (0, $ljRg3.isPageExitReason)(event.reason);
        const send = pageMightExit ? request.sendOnExit : request.send;
        if (pageMightExit && encoder.isAsync) {
            const encoderResult = encoder.finishSync();
            if (encoderResult.outputBytesCount) send($5cc5a02170e0ff41$var$formatPayloadFromEncoder(encoderResult));
            const pendingMessages = [
                encoderResult.pendingData,
                upsertMessages
            ].filter(Boolean).join("\n");
            if (pendingMessages) send({
                data: pendingMessages,
                bytesCount: (0, $eTAnO.computeBytesCount)(pendingMessages)
            });
        } else {
            if (upsertMessages) encoder.write(encoder.isEmpty ? upsertMessages : `\n${upsertMessages}`);
            encoder.finish((encoderResult)=>{
                send($5cc5a02170e0ff41$var$formatPayloadFromEncoder(encoderResult));
            });
        }
    }
    return {
        get isEmpty () {
            return flushController.messagesCount === 0;
        },
        add: addOrUpdate,
        upsert: addOrUpdate,
        prepareUrgentFlushObservable: flushController.prepareUrgentFlushObservable,
        forceFlush: flushController.forceFlush,
        flushObservable: flushController.flushObservable,
        stop: flushSubscription.unsubscribe
    };
}
function $5cc5a02170e0ff41$var$formatPayloadFromEncoder(encoderResult) {
    let data;
    if (typeof encoderResult.output === "string") data = encoderResult.output;
    else data = new Blob([
        encoderResult.output
    ], {
        type: "text/plain"
    });
    return {
        data: data,
        bytesCount: encoderResult.outputBytesCount,
        encoding: encoderResult.encoding
    };
}

});
parcelRegister("bOZaS", function(module, exports) {

$parcel$export(module.exports, "mockable", function () { return $aee7af526e7e1706$export$ee85b4ef9d075583; });
//#region src/tools/mockable.ts
/**
* Wraps a value to make it mockable in tests. In production builds, this is a no-op
* that returns the value as-is. In test builds, it checks if a mock replacement has
* been registered and returns that instead.
*
* @example
* // In source file:
* import { mockable } from '../tools/mockable'
* export function formatNavigationEntry(): string {
*   const navigationEntry = mockable(getNavigationEntry)()
*   ...
* }
*
* // In test file:
* import { replaceMockable } from '@datadog/browser-core/test'
* it('...', () => {
*   replaceMockable(getNavigationEntry, () => FAKE_NAVIGATION_ENTRY)
*   expect(formatNavigationEntry()).toEqual(...)
* })
*/ function $aee7af526e7e1706$export$ee85b4ef9d075583(value) {
    return value;
}

});

parcelRegister("b28LB", function(module, exports) {

$parcel$export(module.exports, "RECOMMENDED_REQUEST_BYTES_LIMIT", function () { return $eb257cde8c39e6dd$export$4c94f4312ed62ea6; });
$parcel$export(module.exports, "createHttpRequest", function () { return $eb257cde8c39e6dd$export$58d47321b4325073; });

var $fnvkG = parcelRequire("fnvkG");

var $eTAnO = parcelRequire("eTAnO");

var $93D3m = parcelRequire("93D3m");

var $6TQJX = parcelRequire("6TQJX");

var $dee0n = parcelRequire("dee0n");
//#region src/transport/httpRequest.ts
/**
* beacon payload max queue size implementation is 64kb
* ensure that we leave room for logs, rum and potential other users
*/ const $eb257cde8c39e6dd$export$4c94f4312ed62ea6 = 16 * (0, $eTAnO.ONE_KIBI_BYTE);
function $eb257cde8c39e6dd$export$58d47321b4325073(endpointBuilders, reportError, bytesLimit = $eb257cde8c39e6dd$export$4c94f4312ed62ea6) {
    const observable = new (0, $fnvkG.Observable)();
    const retryState = (0, $6TQJX.newRetryState)();
    return {
        observable: observable,
        send: (payload)=>{
            for (const endpointBuilder of endpointBuilders)(0, $6TQJX.sendWithRetryStrategy)(payload, retryState, (payload, onResponse)=>{
                $eb257cde8c39e6dd$export$ba55352ffa668a55(endpointBuilder, payload, onResponse);
            }, endpointBuilder.trackType, reportError, observable);
        },
        /**
		* Since fetch keepalive behaves like regular fetch on Firefox,
		* keep using sendBeaconStrategy on exit
		*/ sendOnExit: (payload)=>{
            for (const endpointBuilder of endpointBuilders)$eb257cde8c39e6dd$var$sendBeaconStrategy(endpointBuilder, bytesLimit, payload);
        }
    };
}
function $eb257cde8c39e6dd$var$sendBeaconStrategy(endpointBuilder, bytesLimit, payload) {
    if (payload.bytesCount < bytesLimit) try {
        const beaconUrl = endpointBuilder.build("beacon", payload);
        if (navigator.sendBeacon(beaconUrl, payload.data)) return;
    } catch (e) {
        $eb257cde8c39e6dd$var$reportBeaconError(e);
    }
    $eb257cde8c39e6dd$export$ba55352ffa668a55(endpointBuilder, payload);
}
let $eb257cde8c39e6dd$var$hasReportedBeaconError = false;
function $eb257cde8c39e6dd$var$reportBeaconError(e) {
    if (!$eb257cde8c39e6dd$var$hasReportedBeaconError) {
        $eb257cde8c39e6dd$var$hasReportedBeaconError = true;
        (0, $dee0n.monitorError)(e);
    }
}
function $eb257cde8c39e6dd$export$ba55352ffa668a55(endpointBuilder, payload, onResponse) {
    const fetchUrl = endpointBuilder.build("fetch", payload);
    (0, $93D3m.fetch)(fetchUrl, {
        method: "POST",
        body: payload.data,
        mode: "cors"
    }).then((0, $dee0n.monitor)((response)=>onResponse?.({
            status: response.status,
            type: response.type
        }))).catch((0, $dee0n.monitor)(()=>onResponse?.({
            status: 0
        })));
}

});
parcelRegister("93D3m", function(module, exports) {

$parcel$export(module.exports, "fetch", function () { return $7458656f8e89ecf1$export$e7aa7bc5c1b3cfb3; });

var $hu8Xq = parcelRequire("hu8Xq");

var $c2Qhr = parcelRequire("c2Qhr");
//#region src/browser/fetch.ts
/**
* Make a fetch request using the native implementation, bypassing Zone.js patching.
* This prevents unnecessary Angular change detection cycles.
*
* @param input - The resource to fetch (URL or Request object)
* @param init - Optional fetch options
* @returns A Promise that resolves to the Response
*/ function $7458656f8e89ecf1$export$e7aa7bc5c1b3cfb3(input, init) {
    return (0, $hu8Xq.getZoneJsOriginalValue)((0, $c2Qhr.globalObject), "fetch")(input, init);
}

});

parcelRegister("6TQJX", function(module, exports) {

$parcel$export(module.exports, "sendWithRetryStrategy", function () { return $98660adf766efbb7$export$96c9f5ab1844e401; });
$parcel$export(module.exports, "newRetryState", function () { return $98660adf766efbb7$export$1663dd4904e17e74; });

var $foX5P = parcelRequire("foX5P");

var $eTAnO = parcelRequire("eTAnO");

var $aPpOh = parcelRequire("aPpOh");

var $1wrwm = parcelRequire("1wrwm");
//#region src/transport/sendWithRetryStrategy.ts
const $98660adf766efbb7$export$b0eb5f34be1e4aa5 = 80 * (0, $eTAnO.ONE_KIBI_BYTE);
const $98660adf766efbb7$export$5557f582a01f898f = 20 * (0, $eTAnO.ONE_MEBI_BYTE);
const $98660adf766efbb7$export$ba196f7860333423 = (0, $1wrwm.ONE_MINUTE);
const $98660adf766efbb7$export$c3914d5086178577 = (0, $1wrwm.ONE_SECOND);
function $98660adf766efbb7$export$96c9f5ab1844e401(payload, state, sendStrategy, trackType, reportError, requestObservable) {
    if (state.transportStatus === 0 && state.queuedPayloads.size() === 0 && state.bandwidthMonitor.canHandle(payload)) $98660adf766efbb7$var$send(payload, state, sendStrategy, requestObservable, {
        onSuccess: ()=>$98660adf766efbb7$var$retryQueuedPayloads(0, state, sendStrategy, trackType, reportError, requestObservable),
        onFailure: ()=>{
            if (!state.queuedPayloads.enqueue(payload)) requestObservable.notify({
                type: "queue-full",
                bandwidth: state.bandwidthMonitor.stats(),
                payload: payload
            });
            $98660adf766efbb7$var$scheduleRetry(state, sendStrategy, trackType, reportError, requestObservable);
        }
    });
    else if (!state.queuedPayloads.enqueue(payload)) requestObservable.notify({
        type: "queue-full",
        bandwidth: state.bandwidthMonitor.stats(),
        payload: payload
    });
}
function $98660adf766efbb7$var$scheduleRetry(state, sendStrategy, trackType, reportError, requestObservable) {
    if (state.transportStatus !== 2) return;
    (0, $foX5P.setTimeout)(()=>{
        $98660adf766efbb7$var$send(state.queuedPayloads.first(), state, sendStrategy, requestObservable, {
            onSuccess: ()=>{
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = $98660adf766efbb7$export$c3914d5086178577;
                $98660adf766efbb7$var$retryQueuedPayloads(1, state, sendStrategy, trackType, reportError, requestObservable);
            },
            onFailure: ()=>{
                state.currentBackoffTime = Math.min($98660adf766efbb7$export$ba196f7860333423, state.currentBackoffTime * 2);
                $98660adf766efbb7$var$scheduleRetry(state, sendStrategy, trackType, reportError, requestObservable);
            }
        });
    }, state.currentBackoffTime);
}
function $98660adf766efbb7$var$send(payload, state, sendStrategy, requestObservable, { onSuccess: onSuccess, onFailure: onFailure }) {
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, (response)=>{
        state.bandwidthMonitor.remove(payload);
        if (!$98660adf766efbb7$var$shouldRetryRequest(response)) {
            state.transportStatus = 0;
            requestObservable.notify({
                type: "success",
                bandwidth: state.bandwidthMonitor.stats(),
                payload: payload
            });
            onSuccess();
        } else {
            state.transportStatus = state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 : 2;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status
            };
            requestObservable.notify({
                type: "failure",
                bandwidth: state.bandwidthMonitor.stats(),
                payload: payload
            });
            onFailure();
        }
    });
}
function $98660adf766efbb7$var$retryQueuedPayloads(reason, state, sendStrategy, trackType, reportError, requestObservable) {
    if (reason === 0 && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError(`Reached max ${trackType} events size queued for upload: ${$98660adf766efbb7$export$5557f582a01f898f / (0, $eTAnO.ONE_MEBI_BYTE)}MiB`);
        state.queueFullReported = true;
    }
    const previousQueue = state.queuedPayloads;
    state.queuedPayloads = $98660adf766efbb7$var$newPayloadQueue();
    while(previousQueue.size() > 0)$98660adf766efbb7$export$96c9f5ab1844e401(previousQueue.dequeue(), state, sendStrategy, trackType, reportError, requestObservable);
}
function $98660adf766efbb7$var$shouldRetryRequest(response) {
    return response.type !== "opaque" && (response.status === 0 && !navigator.onLine || response.status === 408 || response.status === 429 || (0, $aPpOh.isServerError)(response.status));
}
function $98660adf766efbb7$export$1663dd4904e17e74() {
    return {
        transportStatus: 0,
        currentBackoffTime: $98660adf766efbb7$export$c3914d5086178577,
        bandwidthMonitor: $98660adf766efbb7$var$newBandwidthMonitor(),
        queuedPayloads: $98660adf766efbb7$var$newPayloadQueue(),
        queueFullReported: false
    };
}
function $98660adf766efbb7$var$newPayloadQueue() {
    const queue = [];
    return {
        bytesCount: 0,
        enqueue (payload) {
            if (this.isFull()) return false;
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
            return true;
        },
        first () {
            return queue[0];
        },
        dequeue () {
            const payload = queue.shift();
            if (payload) this.bytesCount -= payload.bytesCount;
            return payload;
        },
        size () {
            return queue.length;
        },
        isFull () {
            return this.bytesCount >= $98660adf766efbb7$export$5557f582a01f898f;
        }
    };
}
function $98660adf766efbb7$var$newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle (payload) {
            return this.ongoingRequestCount === 0 || this.ongoingByteCount + payload.bytesCount <= $98660adf766efbb7$export$b0eb5f34be1e4aa5 && this.ongoingRequestCount < 32;
        },
        add (payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove (payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        },
        stats () {
            return {
                ongoingByteCount: this.ongoingByteCount,
                ongoingRequestCount: this.ongoingRequestCount
            };
        }
    };
}

});
parcelRegister("aPpOh", function(module, exports) {

$parcel$export(module.exports, "isServerError", function () { return $d8c6cdb51decb70b$export$a7cbe72d7c4012af; });
$parcel$export(module.exports, "tryToClone", function () { return $d8c6cdb51decb70b$export$8a0df03d5faeada4; });
//#region src/tools/utils/responseUtils.ts
function $d8c6cdb51decb70b$export$a7cbe72d7c4012af(status) {
    return status >= 500;
}
function $d8c6cdb51decb70b$export$8a0df03d5faeada4(response) {
    try {
        return response.clone();
    } catch  {
        return;
    }
}

});

parcelRegister("1wrwm", function(module, exports) {

$parcel$export(module.exports, "ONE_SECOND", function () { return $52e2b8768004cd1e$export$32c0454ceff7f92d; });
$parcel$export(module.exports, "ONE_MINUTE", function () { return $52e2b8768004cd1e$export$35acaebf644db34e; });
$parcel$export(module.exports, "ONE_HOUR", function () { return $52e2b8768004cd1e$export$82541edf19e5e3b0; });
$parcel$export(module.exports, "ONE_YEAR", function () { return $52e2b8768004cd1e$export$99cafda57477293d; });
$parcel$export(module.exports, "dateNow", function () { return $52e2b8768004cd1e$export$ceae11818251d43c; });
$parcel$export(module.exports, "timeStampNow", function () { return $52e2b8768004cd1e$export$71f52cdbbf629086; });
$parcel$export(module.exports, "elapsed", function () { return $52e2b8768004cd1e$export$e04aa69d28450d55; });
$parcel$export(module.exports, "toServerDuration", function () { return $52e2b8768004cd1e$export$cc7917ebd320fa93; });
$parcel$export(module.exports, "addDuration", function () { return $52e2b8768004cd1e$export$c0c581816dedfc70; });
$parcel$export(module.exports, "relativeNow", function () { return $52e2b8768004cd1e$export$53cb631b087d9e92; });
$parcel$export(module.exports, "clocksNow", function () { return $52e2b8768004cd1e$export$67898643147706d3; });
$parcel$export(module.exports, "clocksOrigin", function () { return $52e2b8768004cd1e$export$d8b428538156d05f; });
$parcel$export(module.exports, "getTimeOrigin", function () { return $52e2b8768004cd1e$export$e752b05e58096a2f; });
$parcel$export(module.exports, "relativeToClocks", function () { return $52e2b8768004cd1e$export$6d554362ef4543f2; });
$parcel$export(module.exports, "timeStampToClocks", function () { return $52e2b8768004cd1e$export$1208e92a226eb540; });
$parcel$export(module.exports, "toRelativeTime", function () { return $52e2b8768004cd1e$export$89ff575194a16392; });
$parcel$export(module.exports, "isRelativeTime", function () { return $52e2b8768004cd1e$export$4819cf52d6832533; });
$parcel$export(module.exports, "clockDrift", function () { return $52e2b8768004cd1e$export$a0cc366a069675be; });
//#region src/entries/time.ts
/** One second in milliseconds. */ const $52e2b8768004cd1e$export$32c0454ceff7f92d = 1e3;
/** One minute in milliseconds. */ const $52e2b8768004cd1e$export$35acaebf644db34e = 60 * $52e2b8768004cd1e$export$32c0454ceff7f92d;
/** One hour in milliseconds. */ const $52e2b8768004cd1e$export$82541edf19e5e3b0 = 60 * $52e2b8768004cd1e$export$35acaebf644db34e;
/** One day in milliseconds. */ const $52e2b8768004cd1e$export$a97a1358cbb650ab = 864e5;
/** One year in milliseconds. */ const $52e2b8768004cd1e$export$99cafda57477293d = 31536e6;
/**
* Returns the current time as a Unix timestamp in milliseconds.
*
* Prefer this over `Date.now()` because some environments incorrectly polyfill `Date.now` —
* for example, old versions of `datejs` patched it to return a `Date` instance instead of a
* number, which silently breaks arithmetic. `new Date().getTime()` is unaffected by such patches.
*
* @returns Current Unix timestamp in milliseconds.
*/ function $52e2b8768004cd1e$export$ceae11818251d43c() {
    return /* @__PURE__ */ new Date().getTime();
}
/**
* Returns the current time as a {@link TimeStamp}.
*
* @returns Current Unix timestamp in milliseconds, typed as {@link TimeStamp}.
*/ function $52e2b8768004cd1e$export$71f52cdbbf629086() {
    return $52e2b8768004cd1e$export$ceae11818251d43c();
}
function $52e2b8768004cd1e$export$e04aa69d28450d55(start, end) {
    return end - start;
}
function $52e2b8768004cd1e$export$cc7917ebd320fa93(duration) {
    if (typeof duration !== "number") return duration;
    return Math.round(duration * 1e6);
}
function $52e2b8768004cd1e$export$c0c581816dedfc70(a, b) {
    return a + b;
}
/**
* Returns the current relative time in milliseconds since navigation start, sourced from
* `performance.now()`. In Node.js (≥16), this is relative to the process start time.
*
* @returns Current relative time as a {@link RelativeTime}.
*/ function $52e2b8768004cd1e$export$53cb631b087d9e92() {
    return performance.now();
}
/**
* Returns the current time as both a relative time and an absolute timestamp.
*
* @returns A {@link ClocksState} with the current relative and absolute times.
*/ function $52e2b8768004cd1e$export$67898643147706d3() {
    return {
        relative: $52e2b8768004cd1e$export$53cb631b087d9e92(),
        timeStamp: $52e2b8768004cd1e$export$71f52cdbbf629086()
    };
}
/**
* Returns the clocks state at the navigation/process origin (relative = 0).
*
* @returns A {@link ClocksState} with `relative = 0` and the navigation start timestamp.
*/ function $52e2b8768004cd1e$export$d8b428538156d05f() {
    return {
        relative: 0,
        timeStamp: $52e2b8768004cd1e$export$e752b05e58096a2f()
    };
}
/**
* Converts a relative time to a {@link ClocksState} with a corrected absolute timestamp.
* Applies a drift correction when the system clock moved forward relative to `performance.now()`.
*
* @param relative - The relative time to convert.
* @returns A {@link ClocksState} with the relative time and its corrected absolute timestamp.
*/ function $52e2b8768004cd1e$export$6d554362ef4543f2(relative) {
    return {
        relative: relative,
        timeStamp: $52e2b8768004cd1e$var$getCorrectedTimeStamp(relative)
    };
}
/**
* Converts an absolute timestamp to a {@link ClocksState} with its corresponding relative time.
*
* @param timeStamp - The absolute timestamp to convert.
* @returns A {@link ClocksState} with the timestamp and its relative time since navigation start.
*/ function $52e2b8768004cd1e$export$1208e92a226eb540(timeStamp) {
    return {
        relative: $52e2b8768004cd1e$export$89ff575194a16392(timeStamp),
        timeStamp: timeStamp
    };
}
/**
* Converts an absolute timestamp to a relative time since navigation start.
*
* @param timestamp - An absolute Unix timestamp.
* @returns The corresponding {@link RelativeTime} since navigation start.
*/ function $52e2b8768004cd1e$export$89ff575194a16392(timestamp) {
    return timestamp - $52e2b8768004cd1e$export$e752b05e58096a2f();
}
/**
* Converts a relative time since navigation start to an absolute timestamp.
*
* @param relativeTime - Time in milliseconds since navigation start.
* @returns The corresponding absolute {@link TimeStamp}.
*/ function $52e2b8768004cd1e$export$5c3e5344811bdbb8(relativeTime) {
    return Math.round($52e2b8768004cd1e$export$c0c581816dedfc70($52e2b8768004cd1e$export$e752b05e58096a2f(), relativeTime));
}
/**
* Returns `true` if the given value is more likely a relative time than an absolute timestamp.
* Heuristic: values smaller than one year are treated as relative.
*
* @param time - A value that may be either a {@link RelativeTime} or a {@link TimeStamp}.
*/ function $52e2b8768004cd1e$export$4819cf52d6832533(time) {
    return time < $52e2b8768004cd1e$export$99cafda57477293d;
}
/**
* Returns the drift in milliseconds between `Date.now()` and `performance.now()` relative to
* navigation start. A positive value means the system clock ran ahead of the performance timer.
*
* @returns Clock drift in milliseconds.
*/ function $52e2b8768004cd1e$export$a0cc366a069675be() {
    return Math.round($52e2b8768004cd1e$export$ceae11818251d43c() - $52e2b8768004cd1e$export$c0c581816dedfc70($52e2b8768004cd1e$export$e752b05e58096a2f(), performance.now()));
}
/**
* Time origin slightly changes on some rare cases — cache it.
*/ let $52e2b8768004cd1e$var$timeOrigin;
/**
* Returns the time origin — the start of the current navigation in browsers, or the process
* start time in Node.js.
*
* Prefers `performance.timing.navigationStart` over `performance.timeOrigin` because
* `timeOrigin` can be much farther in the past than the actual navigation start (Firefox 71,
* https://bugzilla.mozilla.org/show_bug.cgi?id=1429926) and is not supported in Safari <15.
* Falls back to `performance.timeOrigin` in environments without `performance.timing`
* (Service Workers, Node.js)
*
* @returns The time origin as a {@link TimeStamp}.
*/ function $52e2b8768004cd1e$export$e752b05e58096a2f() {
    if ($52e2b8768004cd1e$var$timeOrigin === void 0) $52e2b8768004cd1e$var$timeOrigin = performance.timing?.navigationStart ?? performance.timeOrigin;
    return $52e2b8768004cd1e$var$timeOrigin;
}
function $52e2b8768004cd1e$var$getCorrectedTimeStamp(relativeTime) {
    const correctedOrigin = $52e2b8768004cd1e$export$ceae11818251d43c() - performance.now();
    if (correctedOrigin > $52e2b8768004cd1e$export$e752b05e58096a2f()) return Math.round($52e2b8768004cd1e$export$c0c581816dedfc70(correctedOrigin, relativeTime));
    return $52e2b8768004cd1e$export$5c3e5344811bdbb8(relativeTime);
}

});



parcelRegister("2faqW", function(module, exports) {

$parcel$export(module.exports, "findLast", function () { return $e13b5c992a3c6882$export$296de88ccac4bedb; });
$parcel$export(module.exports, "objectValues", function () { return $e13b5c992a3c6882$export$ad1854f4a08c15f8; });
$parcel$export(module.exports, "objectEntries", function () { return $e13b5c992a3c6882$export$6a29ade99f81ec8a; });
//#region src/tools/utils/polyfills.ts
function $e13b5c992a3c6882$export$296de88ccac4bedb(array, predicate) {
    for(let i = array.length - 1; i >= 0; i -= 1){
        const item = array[i];
        if (predicate(item, i, array)) return item;
    }
}
function $e13b5c992a3c6882$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $e13b5c992a3c6882$export$6a29ade99f81ec8a(object) {
    return Object.entries(object);
}

});

parcelRegister("ljRg3", function(module, exports) {

$parcel$export(module.exports, "PageExitReason", function () { return $8a90059f7130c844$export$69c8658089134213; });
$parcel$export(module.exports, "createPageMayExitObservable", function () { return $8a90059f7130c844$export$c59fbb34be0ea4a; });
$parcel$export(module.exports, "isPageExitReason", function () { return $8a90059f7130c844$export$cbb6b5cdbd0f2b60; });

var $fnvkG = parcelRequire("fnvkG");

var $50cui = parcelRequire("50cui");

var $2faqW = parcelRequire("2faqW");

var $c2Qhr = parcelRequire("c2Qhr");
//#region src/browser/pageMayExitObservable.ts
const $8a90059f7130c844$export$69c8658089134213 = {
    HIDDEN: "visibility_hidden",
    UNLOADING: "before_unload",
    PAGEHIDE: "page_hide",
    FROZEN: "page_frozen"
};
function $8a90059f7130c844$export$c59fbb34be0ea4a() {
    return new (0, $fnvkG.Observable)((observable)=>{
        const window = (0, $c2Qhr.globalObject).window;
        if (!window) return;
        const { stop: stopListeners } = (0, $50cui.addEventListeners)(window, [
            "visibilitychange",
            "freeze"
        ], (event)=>{
            if (event.type === "visibilitychange" && document.visibilityState === "hidden") /**
			* Only event that guarantee to fire on mobile devices when the page transitions to background state
			* (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
			*/ observable.notify({
                reason: $8a90059f7130c844$export$69c8658089134213.HIDDEN
            });
            else if (event.type === "freeze") /**
			* After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
			* Allow to collect events happening between hidden and frozen state.
			*/ observable.notify({
                reason: $8a90059f7130c844$export$69c8658089134213.FROZEN
            });
        }, {
            capture: true
        });
        const stopBeforeUnloadListener = (0, $50cui.addEventListener)(window, "beforeunload", ()=>{
            observable.notify({
                reason: $8a90059f7130c844$export$69c8658089134213.UNLOADING
            });
        }).stop;
        return ()=>{
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
}
function $8a90059f7130c844$export$cbb6b5cdbd0f2b60(reason) {
    return (0, $2faqW.objectValues)($8a90059f7130c844$export$69c8658089134213).includes(reason);
}

});

parcelRegister("8DfP8", function(module, exports) {

$parcel$export(module.exports, "createIdentityEncoder", function () { return $5626981192f0f1e0$export$b5341466c7007825; });

var $eTAnO = parcelRequire("eTAnO");
//#region src/tools/encoder.ts
function $5626981192f0f1e0$export$b5341466c7007825() {
    let output = "";
    let outputBytesCount = 0;
    return {
        isAsync: false,
        get isEmpty () {
            return !output;
        },
        write (data, callback) {
            const additionalEncodedBytesCount = (0, $eTAnO.computeBytesCount)(data);
            outputBytesCount += additionalEncodedBytesCount;
            output += data;
            if (callback) callback(additionalEncodedBytesCount);
        },
        finish (callback) {
            callback(this.finishSync());
        },
        finishSync () {
            const result = {
                output: output,
                outputBytesCount: outputBytesCount,
                rawBytesCount: outputBytesCount,
                pendingData: ""
            };
            output = "";
            outputBytesCount = 0;
            return result;
        },
        estimateEncodedBytesCount (data) {
            return data.length;
        }
    };
}

});

parcelRegister("hvzBH", function(module, exports) {

$parcel$export(module.exports, "createFlushController", function () { return $0c959c40a2bb941c$export$afc20ff9bd852d2b; });

var $fnvkG = parcelRequire("fnvkG");

var $foX5P = parcelRequire("foX5P");

var $b28LB = parcelRequire("b28LB");

var $c2Qhr = parcelRequire("c2Qhr");

var $1wrwm = parcelRequire("1wrwm");
//#region src/transport/flushController.ts
/**
* flush automatically, aim to be lower than ALB connection timeout
* to maximize connection reuse.
*/ const $0c959c40a2bb941c$export$dedca8af5f86b2c = 30 * (0, $1wrwm.ONE_SECOND);
/**
* When using the SDK in a Worker Environment, we limit the batch size to 1 to ensure it can be sent
* in a single event.
*/ const $0c959c40a2bb941c$export$7ee84a9580ca1c30 = (0, $c2Qhr.isWorkerEnvironment) ? 1 : 50;
/**
* Returns a "flush controller", responsible of notifying when flushing a pool of pending data needs
* to happen. The implementation is designed to support both synchronous and asynchronous usages,
* but relies on invariants described in each method documentation to keep a coherent state.
*/ function $0c959c40a2bb941c$export$afc20ff9bd852d2b({ pageMayExitObservable: pageMayExitObservable }) {
    let forcedFlushReason;
    const prepareUrgentFlushObservable = new (0, $fnvkG.Observable)();
    const pageMayExitSubscription = pageMayExitObservable.subscribe((event)=>{
        forcedFlushReason = event.reason;
        try {
            prepareUrgentFlushObservable.notify(event.reason);
        } finally{
            forcedFlushReason = void 0;
        }
        flush(event.reason);
    });
    const flushObservable = new (0, $fnvkG.Observable)(()=>()=>{
            pageMayExitSubscription.unsubscribe();
        });
    let currentBytesCount = 0;
    let currentMessagesCount = 0;
    function flush(flushReason) {
        if (currentMessagesCount === 0) return;
        const messagesCount = currentMessagesCount;
        const bytesCount = currentBytesCount;
        currentMessagesCount = 0;
        currentBytesCount = 0;
        cancelDurationLimitTimeout();
        flushObservable.notify({
            reason: flushReason,
            messagesCount: messagesCount,
            bytesCount: bytesCount
        });
    }
    let durationLimitTimeoutId;
    function scheduleDurationLimitTimeout() {
        if (durationLimitTimeoutId === void 0) durationLimitTimeoutId = (0, $foX5P.setTimeout)(()=>{
            flush("duration_limit");
        }, $0c959c40a2bb941c$export$dedca8af5f86b2c);
    }
    function cancelDurationLimitTimeout() {
        (0, $foX5P.clearTimeout)(durationLimitTimeoutId);
        durationLimitTimeoutId = void 0;
    }
    return {
        flushObservable: flushObservable,
        prepareUrgentFlushObservable: prepareUrgentFlushObservable,
        forceFlush: flush,
        get messagesCount () {
            return currentMessagesCount;
        },
        /**
		* Notifies that a message will be added to a pool of pending messages waiting to be flushed.
		*
		* This function needs to be called synchronously, right before adding the message, so no flush
		* event can happen after `notifyBeforeAddMessage` and before adding the message.
		*
		* @param estimatedMessageBytesCount - an estimation of the message bytes count once it is
		* actually added.
		*/ notifyBeforeAddMessage (estimatedMessageBytesCount) {
            if (currentBytesCount + estimatedMessageBytesCount >= (0, $b28LB.RECOMMENDED_REQUEST_BYTES_LIMIT)) flush(forcedFlushReason ?? "bytes_limit");
            currentMessagesCount += 1;
            currentBytesCount += estimatedMessageBytesCount;
            scheduleDurationLimitTimeout();
        },
        /**
		* Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
		*
		* This function can be called asynchronously after the message was added, but in this case it
		* should not be called if a flush event occurred in between.
		*
		* @param messageBytesCountDiff - the difference between the estimated message bytes count and
		* its actual bytes count once added to the pool.
		*/ notifyAfterAddMessage (messageBytesCountDiff = 0) {
            currentBytesCount += messageBytesCountDiff;
            if (currentMessagesCount >= $0c959c40a2bb941c$export$7ee84a9580ca1c30) flush(forcedFlushReason ?? "messages_limit");
            else if (currentBytesCount >= (0, $b28LB.RECOMMENDED_REQUEST_BYTES_LIMIT)) flush(forcedFlushReason ?? "bytes_limit");
        }
    };
}

});


parcelRegister("hwuAb", function(module, exports) {

$parcel$export(module.exports, "TelemetryType", function () { return $5683eca9b9c7865e$export$8c1a12d9d019b209; });
//#region src/domain/telemetry/rawTelemetryEvent.types.ts
const $5683eca9b9c7865e$export$8c1a12d9d019b209 = {
    LOG: "log",
    CONFIGURATION: "configuration",
    USAGE: "usage"
};

});

parcelRegister("k8VFU", function(module, exports) {

$parcel$export(module.exports, "createEndpointBuilder", function () { return $001c4869c8a35b99$export$b84621d9b3dd3f17; });
$parcel$export(module.exports, "buildEndpointUrl", function () { return $001c4869c8a35b99$export$dca3dcb31b66def7; });
$parcel$export(module.exports, "createReplicaEndpointBuilder", function () { return $001c4869c8a35b99$export$b9658836c7d8b11; });

var $kRkcp = parcelRequire("kRkcp");

var $1wrwm = parcelRequire("1wrwm");

var $hWYdN = parcelRequire("hWYdN");
//#region src/transport/endpointBuilder.ts
/** Creates an {@link EndpointBuilder} for the given track type. */ function $001c4869c8a35b99$export$b84621d9b3dd3f17(configuration, trackType, extraParameters) {
    return {
        build (api, payload) {
            return $001c4869c8a35b99$export$dca3dcb31b66def7({
                proxy: configuration.proxy,
                site: configuration.site,
                path: `/api/v2/${trackType}`,
                parameters: $001c4869c8a35b99$var$buildEndpointParameters(configuration, trackType, api, payload, extraParameters)
            });
        },
        trackType: trackType
    };
}
/**
* Build the endpoint for the replica (dual shipping) site, if a replica is configured.
*
* The replica always targets the US1 site but keeps the `proxy` and `source` of the main
* configuration. The RUM track additionally carries the replica `application.id`.
*/ function $001c4869c8a35b99$export$b9658836c7d8b11({ replica: replica, proxy: proxy, source: source }, trackType) {
    if (!replica) return;
    return $001c4869c8a35b99$export$b84621d9b3dd3f17({
        clientToken: replica.clientToken,
        proxy: proxy,
        source: source,
        site: (0, $hWYdN.INTAKE_SITE_US1)
    }, trackType, trackType === "rum" ? [
        `application.id=${replica.applicationId}`
    ] : void 0);
}
/** Builds a Datadog intake URL from the given options. */ function $001c4869c8a35b99$export$dca3dcb31b66def7({ proxy: proxy, site: site = (0, $hWYdN.INTAKE_SITE_US1), path: path, parameters: parameters = "", subdomain: subdomain }) {
    let pathAndParameters = path;
    if (parameters) pathAndParameters += `?${parameters}`;
    if (typeof proxy === "string") {
        let url = `${(0, $kRkcp.normalizeUrl)(proxy)}?ddforward=${encodeURIComponent(pathAndParameters)}`;
        if (subdomain) url += `&ddforwardSubdomain=${subdomain}`;
        return url;
    }
    if (typeof proxy === "function") return proxy({
        path: path,
        parameters: parameters,
        subdomain: subdomain
    });
    const domainParts = site.split(".");
    const extension = domainParts.pop();
    let domain = `browser-intake-${domainParts.join("-")}.${extension}`;
    if (subdomain) domain = `${subdomain}.${domain}`;
    return `https://${domain}${pathAndParameters}`;
}
/**
* Build parameters to be used for an intake request. Parameters should be re-built for each
* request, as they change randomly.
*/ function $001c4869c8a35b99$var$buildEndpointParameters({ clientToken: clientToken, source: source = "browser" }, trackType, api, { retry: retry, encoding: encoding }, extraParameters = []) {
    const parameters = [
        `ddsource=${source}`,
        `dd-api-key=${clientToken}`,
        `dd-evp-origin-version=${encodeURIComponent("7.14.0")}`,
        "dd-evp-origin=browser",
        `dd-request-id=${$001c4869c8a35b99$var$generateUUID()}`
    ].concat(extraParameters);
    if (encoding) parameters.push(`dd-evp-encoding=${encoding}`);
    if (trackType === "rum") {
        parameters.push(`batch_time=${(0, $1wrwm.timeStampNow)()}`, `_dd.api=${api}`);
        if (retry) parameters.push(`_dd.retry_count=${retry.count}`, `_dd.retry_after=${retry.lastFailureStatus}`);
    }
    return parameters.join("&");
}
/**
* UUID v4
* from https://gist.github.com/jed/982883
*/ function $001c4869c8a35b99$var$generateUUID(placeholder) {
    return placeholder ? (parseInt(placeholder, 10) ^ Math.random() * 16 >> parseInt(placeholder, 10) / 4).toString(16) : `10000000-1000-4000-8000-100000000000`.replace(/[018]/g, $001c4869c8a35b99$var$generateUUID);
}

});
parcelRegister("kRkcp", function(module, exports) {

$parcel$export(module.exports, "normalizeUrl", function () { return $5aecb9a8bff2763a$export$6535eb414fa2c8b6; });
$parcel$export(module.exports, "buildUrl", function () { return $5aecb9a8bff2763a$export$b5cd97dee32de81d; });
$parcel$export(module.exports, "isValidUrl", function () { return $5aecb9a8bff2763a$export$bef94a5618bf18bf; });
$parcel$export(module.exports, "getPathName", function () { return $5aecb9a8bff2763a$export$ba1b94ff70383687; });

var $c2Qhr = parcelRequire("c2Qhr");
//#region src/util/urlPolyfill.ts
/**
* Resolves a URL, returning a normalized absolute URL string.
*
* Document-relative inputs are resolved against `document.baseURI` (the `<base href>`, defaulting to
* the document location) to match how the browser resolves relative request URLs — so the URL
* recorded for a fetch/XHR matches the one actually requested. Falls back to `location.href` in
* environments without a document (workers, SSR). Absolute and root-relative inputs ignore the base
* and are unaffected.
*/ function $5aecb9a8bff2763a$export$6535eb414fa2c8b6(url) {
    return $5aecb9a8bff2763a$export$b5cd97dee32de81d(url, (0, $c2Qhr.globalObject).document?.baseURI ?? (0, $c2Qhr.globalObject).location?.href).href;
}
/** Returns true if the given string is a valid URL. */ function $5aecb9a8bff2763a$export$bef94a5618bf18bf(url) {
    try {
        return !!$5aecb9a8bff2763a$export$b5cd97dee32de81d(url);
    } catch  {
        return false;
    }
}
/** Extracts the pathname from a URL, ensuring it starts with `/`. */ function $5aecb9a8bff2763a$export$ba1b94ff70383687(url) {
    const pathname = $5aecb9a8bff2763a$export$b5cd97dee32de81d(url).pathname;
    return pathname[0] === "/" ? pathname : `/${pathname}`;
}
/**
* Constructs a URL object, using the global `URL` constructor when it behaves correctly and
* falling back to a pristine iframe-sourced constructor to avoid polyfill interference.
*/ function $5aecb9a8bff2763a$export$b5cd97dee32de81d(url, base) {
    const URL = $5aecb9a8bff2763a$var$getUrlConstructor();
    try {
        return base !== void 0 ? new URL(url, base) : new URL(url);
    } catch (error) {
        throw new Error(`Failed to construct URL: ${String(error)}`);
    }
}
/**
* Returns a `URL` constructor. Uses the current global `URL` when it resolves relative URLs
* correctly; otherwise falls back to a constructor sourced from a pristine iframe to bypass any
* patched/polyfilled `URL`.
*/ let $5aecb9a8bff2763a$var$urlConstructorCache;
function $5aecb9a8bff2763a$var$getUrlConstructor() {
    if (!$5aecb9a8bff2763a$var$urlConstructorCache) {
        let globalUrlConstructorLooksGood = false;
        try {
            globalUrlConstructorLooksGood = new (0, $c2Qhr.globalObject).URL("b", "http://a").href === "http://a/b";
        } catch  {}
        $5aecb9a8bff2763a$var$urlConstructorCache = globalUrlConstructorLooksGood ? (0, $c2Qhr.globalObject).URL : $5aecb9a8bff2763a$export$d5113ba3ff2db2da().URL;
    }
    return $5aecb9a8bff2763a$var$urlConstructorCache;
}
let $5aecb9a8bff2763a$var$getPristineGlobalObjectCache;
/**
* Returns a `{ URL }` object sourced from a pristine iframe, bypassing any patched URL constructor.
* Falls back to the current global if iframe creation fails.
*/ function $5aecb9a8bff2763a$export$d5113ba3ff2db2da() {
    if (!$5aecb9a8bff2763a$var$getPristineGlobalObjectCache) {
        let iframe;
        let pristineWindow;
        try {
            iframe = document.createElement("iframe");
            iframe.style.display = "none";
            document.body.appendChild(iframe);
            pristineWindow = iframe.contentWindow ?? (0, $c2Qhr.globalObject);
        } catch  {
            pristineWindow = (0, $c2Qhr.globalObject);
        }
        $5aecb9a8bff2763a$var$getPristineGlobalObjectCache = {
            URL: pristineWindow.URL
        };
        iframe?.remove();
    }
    return $5aecb9a8bff2763a$var$getPristineGlobalObjectCache;
}

});

parcelRegister("hWYdN", function(module, exports) {

$parcel$export(module.exports, "INTAKE_SITE_STAGING", function () { return $6595f4f13a34ff3b$export$a204b9d5a62f1e2c; });
$parcel$export(module.exports, "INTAKE_SITE_US1", function () { return $6595f4f13a34ff3b$export$6b79fd7dd2f5fb9a; });
$parcel$export(module.exports, "INTAKE_SITE_EU1", function () { return $6595f4f13a34ff3b$export$7452d85ec570d2ea; });
$parcel$export(module.exports, "INTAKE_SITE_US1_FED", function () { return $6595f4f13a34ff3b$export$241ba7106e833c7b; });
$parcel$export(module.exports, "INTAKE_SITE_US2_FED", function () { return $6595f4f13a34ff3b$export$aea49056f677f575; });
$parcel$export(module.exports, "isIntakeUrl", function () { return $6595f4f13a34ff3b$export$8f53a704ec1860b3; });
//#region src/transport/intakeSites.ts
/** Datadog staging environment (internal use). */ const $6595f4f13a34ff3b$export$a204b9d5a62f1e2c = "datad0g.com";
/** Datadog US1 site (default). */ const $6595f4f13a34ff3b$export$6b79fd7dd2f5fb9a = "datadoghq.com";
/** Datadog EU1 site. */ const $6595f4f13a34ff3b$export$7452d85ec570d2ea = "datadoghq.eu";
/** Datadog US1 FedRAMP site. */ const $6595f4f13a34ff3b$export$241ba7106e833c7b = "ddog-gov.com";
/** Datadog US2 FedRAMP site. */ const $6595f4f13a34ff3b$export$aea49056f677f575 = "us2.ddog-gov.com";
/** URL query parameters that identify a Datadog intake request. */ const $6595f4f13a34ff3b$export$e36b5f83de28fc8a = [
    "ddsource",
    "dd-api-key",
    "dd-request-id"
];
/** Returns true if the URL targets a Datadog intake endpoint. */ function $6595f4f13a34ff3b$export$8f53a704ec1860b3(url) {
    return $6595f4f13a34ff3b$export$e36b5f83de28fc8a.every((param)=>url.includes(param));
}

});


parcelRegister("5tXxv", function(module, exports) {

$parcel$export(module.exports, "deepClone", function () { return $591b2fd06409c3b2$export$b7d58db314e0ac27; });
$parcel$export(module.exports, "combine", function () { return $591b2fd06409c3b2$export$1be1fc439b849fdf; });

var $bF5dI = parcelRequire("bF5dI");
//#region src/util/mergeInto.ts
/**
* Recursively merges `source` into `destination` in place and returns the result.
* - Objects are merged key by key.
* - Arrays are merged index by index.
* - Primitive and class-instance values replace the destination.
* - `undefined` source values leave the destination unchanged.
* - Circular references in `source` are silently dropped.
*
* Prefer `combine` for a non-mutating deep merge or `deepClone` for a simple deep copy.
*
* @returns The merged value — either `destination` (mutated) or `source` when they cannot be merged.
*/ function $591b2fd06409c3b2$export$f00f2bc10b5384e6(destination, source) {
    return $591b2fd06409c3b2$var$mergeIntoInternal(destination, source, $591b2fd06409c3b2$var$createCircularReferenceChecker());
}
function $591b2fd06409c3b2$var$mergeIntoInternal(destination, source, circularReferenceChecker) {
    if (source === void 0) return destination;
    if (typeof source !== "object" || source === null) return source;
    else if (source instanceof Date) return new Date(source.getTime());
    else if (source instanceof RegExp) return new RegExp(source.source, source.flags);
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) return;
    else if (Array.isArray(source)) {
        const merged = Array.isArray(destination) ? destination : [];
        for(let i = 0; i < source.length; ++i)merged[i] = $591b2fd06409c3b2$var$mergeIntoInternal(merged[i], source[i], circularReferenceChecker);
        return merged;
    }
    const merged = (0, $bF5dI.getType)(destination) === "object" ? destination : {};
    for(const key in source)if (Object.prototype.hasOwnProperty.call(source, key) && key !== "__proto__") merged[key] = $591b2fd06409c3b2$var$mergeIntoInternal(merged[key], source[key], circularReferenceChecker);
    return merged;
}
/**
* A simplistic implementation of a deep clone algorithm.
* Caveats:
* - It doesn't maintain prototype chains - don't use with instances of custom classes.
* - It doesn't handle Map and Set
*
* @returns A deep copy of `value` with the same type.
*/ function $591b2fd06409c3b2$export$b7d58db314e0ac27(value) {
    return $591b2fd06409c3b2$export$f00f2bc10b5384e6(void 0, value);
}
function $591b2fd06409c3b2$export$1be1fc439b849fdf(...sources) {
    let destination;
    for (const source of sources){
        if (source === void 0 || source === null) continue;
        destination = $591b2fd06409c3b2$export$f00f2bc10b5384e6(destination, source);
    }
    return destination;
}
function $591b2fd06409c3b2$var$createCircularReferenceChecker() {
    const set = /* @__PURE__ */ new WeakSet();
    return {
        hasAlreadyBeenSeen (value) {
            const has = set.has(value);
            if (!has) set.add(value);
            return has;
        }
    };
}

});

parcelRegister("fNtjE", function(module, exports) {

$parcel$export(module.exports, "createHook", function () { return $d56e9d45c80a9a0d$export$e7f733c8fc2b8a24; });
$parcel$export(module.exports, "DISCARDED", function () { return $d56e9d45c80a9a0d$export$c8e0478a0e0003f8; });
$parcel$export(module.exports, "SKIPPED", function () { return $d56e9d45c80a9a0d$export$bbe2f08ef1e830d8; });

var $5tXxv = parcelRequire("5tXxv");
//#region src/assembly/hook.ts
/**
* Creates a new `Hook` instance with no registered callbacks.
*
* @typeParam Params - The input type passed to registered callbacks.
* @typeParam Result - The return type that callbacks contribute to.
*/ function $d56e9d45c80a9a0d$export$e7f733c8fc2b8a24() {
    let callbacks = [];
    return {
        register (callback) {
            callbacks.push(callback);
            return {
                unregister () {
                    callbacks = callbacks.filter((cb)=>cb !== callback);
                }
            };
        },
        trigger (params) {
            const results = [];
            for (const callback of callbacks){
                const result = callback(params);
                if (result === "DISCARDED") return $d56e9d45c80a9a0d$export$c8e0478a0e0003f8;
                if (result === "SKIPPED") continue;
                results.push(result);
            }
            return (0, $5tXxv.combine)(...results);
        }
    };
}
/** Sentinel returned by a hook callback to discard the entire event (no further callbacks are invoked). */ const $d56e9d45c80a9a0d$export$c8e0478a0e0003f8 = "DISCARDED";
/** Sentinel returned by a hook callback to opt out of contributing a result (other callbacks still run). */ const $d56e9d45c80a9a0d$export$bbe2f08ef1e830d8 = "SKIPPED";

});

parcelRegister("9xMbG", function(module, exports) {

$parcel$export(module.exports, "performDraw", function () { return $f8f8c858ef094850$export$72c7afebfef3b500; });
//#region src/entries/sample.ts
/**
* Performs a weighted random draw, typically used to decide whether an event should be sampled
* (e.g. included in a telemetry payload).
*
* @param threshold - The probability of success, as a percentage between `0` and `100`.
* @returns `true` if the draw succeeds, `false` otherwise. Always `false` when `threshold` is `0`.
* @example
* ```ts
* const isSampled = performDraw(10)
* if (isSampled) {
*   // Include the event in the sampled payload.
* }
* ```
*/ function $f8f8c858ef094850$export$72c7afebfef3b500(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}

});




parcelRegister("6QSjS", function(module, exports) {

var $cFehY = parcelRequire("cFehY");

var $7wVtg = parcelRequire("7wVtg");

});

parcelRegister("5rjZK", function(module, exports) {

$parcel$export(module.exports, "makeRecorderApi", function () { return $a5b33e4c656ff51a$export$e9b5b20eb46e0952; });

var $ljNmG = parcelRequire("ljNmG");

var $cFehY = parcelRequire("cFehY");

var $7wVtg = parcelRequire("7wVtg");
parcelRequire("6QSjS");

var $61DSn = parcelRequire("61DSn");

var $jAExM = parcelRequire("jAExM");

var $gS0nt = parcelRequire("gS0nt");
var $52KhB = parcelRequire("52KhB");
var $hH6Lc = parcelRequire("hH6Lc");
//#region src/boot/recorderApi.ts
function $a5b33e4c656ff51a$export$e9b5b20eb46e0952() {
    if ((0, $gS0nt.canUseEventBridge)() && !(0, $gS0nt.bridgeSupports)((0, $gS0nt.BridgeCapability).RECORDS)) return {
        start: (0, $hH6Lc.noop),
        stop: (0, $hH6Lc.noop),
        getReplayStats: ()=>void 0,
        onRumStart: (0, $hH6Lc.noop),
        isRecording: ()=>false,
        getSessionReplayLink: ()=>void 0
    };
    let { strategy: strategy, shouldStartImmediately: shouldStartImmediately } = (0, $jAExM.createPreStartStrategy)();
    return {
        start: (options)=>strategy.start(options),
        stop: ()=>strategy.stop(),
        getSessionReplayLink: ()=>strategy.getSessionReplayLink(),
        onRumStart: onRumStart,
        isRecording: ()=>(0, $7wVtg.getDeflateWorkerStatus)() === 3 && strategy.isRecording(),
        getReplayStats: (viewId)=>(0, $7wVtg.getDeflateWorkerStatus)() === 3 ? (0, $ljNmG.getReplayStats)(viewId) : void 0
    };
    function onRumStart(lifeCycle, configuration, sessionManager, viewHistory, worker, telemetry) {
        let cachedDeflateEncoder;
        function getOrCreateDeflateEncoder() {
            if (!cachedDeflateEncoder) {
                worker ??= (0, $7wVtg.startDeflateWorker)(configuration, "Datadog Session Replay", ()=>strategy.stop());
                if (worker) cachedDeflateEncoder = (0, $cFehY.createDeflateEncoder)(worker, (0, $52KhB.DeflateEncoderStreamId).REPLAY);
            }
            return cachedDeflateEncoder;
        }
        strategy = (0, $61DSn.createPostStartStrategy)(configuration, lifeCycle, sessionManager, viewHistory, getOrCreateDeflateEncoder, telemetry);
        if (shouldStartImmediately(configuration)) strategy.start();
    }
}

});
parcelRegister("ljNmG", function(module, exports) {

$parcel$export(module.exports, "getSegmentsCount", function () { return $cf4193a7e3d11bd5$export$4223f4e280561ccd; });
$parcel$export(module.exports, "addSegment", function () { return $cf4193a7e3d11bd5$export$1c43f9ac826b6462; });
$parcel$export(module.exports, "addRecord", function () { return $cf4193a7e3d11bd5$export$ab0ab92b3cb31c66; });
$parcel$export(module.exports, "addResource", function () { return $cf4193a7e3d11bd5$export$dd712f36c1a9cd08; });
$parcel$export(module.exports, "addWroteData", function () { return $cf4193a7e3d11bd5$export$ae4fdff69a4959e9; });
$parcel$export(module.exports, "getReplayStats", function () { return $cf4193a7e3d11bd5$export$92ac42d7bd545b2a; });
//#region src/domain/replayStats.ts
const $cf4193a7e3d11bd5$export$f10444a7271b7f1e = 1e3;
let $cf4193a7e3d11bd5$var$statsPerView;
function $cf4193a7e3d11bd5$export$4223f4e280561ccd(viewId) {
    return $cf4193a7e3d11bd5$var$getOrCreateReplayStats(viewId).segments_count;
}
function $cf4193a7e3d11bd5$export$1c43f9ac826b6462(viewId) {
    $cf4193a7e3d11bd5$var$getOrCreateReplayStats(viewId).segments_count += 1;
}
function $cf4193a7e3d11bd5$export$ab0ab92b3cb31c66(viewId) {
    $cf4193a7e3d11bd5$var$getOrCreateReplayStats(viewId).records_count += 1;
}
function $cf4193a7e3d11bd5$export$dd712f36c1a9cd08(viewId) {
    $cf4193a7e3d11bd5$var$getOrCreateReplayStats(viewId).resources_count += 1;
}
function $cf4193a7e3d11bd5$export$ae4fdff69a4959e9(viewId, additionalBytesCount) {
    $cf4193a7e3d11bd5$var$getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function $cf4193a7e3d11bd5$export$92ac42d7bd545b2a(viewId) {
    return $cf4193a7e3d11bd5$var$statsPerView?.get(viewId);
}
function $cf4193a7e3d11bd5$var$getOrCreateReplayStats(viewId) {
    if (!$cf4193a7e3d11bd5$var$statsPerView) $cf4193a7e3d11bd5$var$statsPerView = /* @__PURE__ */ new Map();
    let replayStats;
    if ($cf4193a7e3d11bd5$var$statsPerView.has(viewId)) replayStats = $cf4193a7e3d11bd5$var$statsPerView.get(viewId);
    else {
        replayStats = {
            records_count: 0,
            resources_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0
        };
        $cf4193a7e3d11bd5$var$statsPerView.set(viewId, replayStats);
        if ($cf4193a7e3d11bd5$var$statsPerView.size > 1e3) $cf4193a7e3d11bd5$var$deleteOldestStats();
    }
    return replayStats;
}
function $cf4193a7e3d11bd5$var$deleteOldestStats() {
    if (!$cf4193a7e3d11bd5$var$statsPerView) return;
    const toDelete = $cf4193a7e3d11bd5$var$statsPerView.keys().next().value;
    if (toDelete) $cf4193a7e3d11bd5$var$statsPerView.delete(toDelete);
}

});

parcelRegister("61DSn", function(module, exports) {

$parcel$export(module.exports, "createPostStartStrategy", function () { return $e5049a173526c8c3$export$eedb6b2f1f53c8e; });

var $2YlOK = parcelRequire("2YlOK");

var $hMxBh = parcelRequire("hMxBh");

var $5y9vp = parcelRequire("5y9vp");
parcelRequire("lNEHA");
var $jIq9O = parcelRequire("jIq9O");
var $jNZRV = parcelRequire("jNZRV");

var $drxRN = parcelRequire("drxRN");
var $fnvkG = parcelRequire("fnvkG");

var $dee0n = parcelRequire("dee0n");
//#region src/boot/postStartStrategy.ts
function $e5049a173526c8c3$export$eedb6b2f1f53c8e(configuration, lifeCycle, sessionManager, viewHistory, getOrCreateDeflateEncoder, telemetry) {
    let status = 0;
    let stopRecording;
    lifeCycle.subscribe((0, $jNZRV.LifeCycleEventType).SESSION_EXPIRED, ()=>{
        if (status === 2 || status === 3) {
            stop();
            status = 1;
        }
    });
    lifeCycle.subscribe((0, $jNZRV.LifeCycleEventType).SESSION_RENEWED, ()=>{
        if (status === 1) start();
    });
    const observable = new (0, $fnvkG.Observable)();
    (0, $hMxBh.startRecorderInitTelemetry)(telemetry, observable);
    const doStart = async (forced)=>{
        observable.notify({
            type: "start",
            forced: forced
        });
        const [startRecordingImpl] = await Promise.all([
            $e5049a173526c8c3$var$notifyWhenSettled(observable, {
                type: "recorder-settled"
            }, (0, $5y9vp.lazyLoadRecorder)()),
            $e5049a173526c8c3$var$notifyWhenSettled(observable, {
                type: "document-ready"
            }, (0, $drxRN.asyncRunOnReadyState)("interactive"))
        ]);
        if (status !== 2) {
            observable.notify({
                type: "aborted"
            });
            return;
        }
        if (!startRecordingImpl) {
            status = 0;
            observable.notify({
                type: "recorder-load-failed"
            });
            return;
        }
        const deflateEncoder = getOrCreateDeflateEncoder();
        if (!deflateEncoder) {
            status = 0;
            observable.notify({
                type: "deflate-encoder-load-failed"
            });
            return;
        }
        ({ stop: stopRecording } = startRecordingImpl(lifeCycle, configuration, sessionManager, viewHistory, deflateEncoder, telemetry));
        status = 3;
        observable.notify({
            type: "succeeded"
        });
    };
    function start(options) {
        const session = sessionManager.findTrackedSession();
        const replayState = session ? (0, $jIq9O.computeSessionReplayState)(session, configuration) : void 0;
        if (!$e5049a173526c8c3$var$canStartRecording(replayState, options)) {
            status = 1;
            return;
        }
        if ($e5049a173526c8c3$var$isRecordingInProgress(status)) return;
        status = 2;
        const forced = $e5049a173526c8c3$var$shouldForceReplay(replayState, options) || false;
        doStart(forced).catch((0, $dee0n.monitorError));
        if (forced) sessionManager.updateSessionState({
            forcedReplay: "1"
        });
    }
    function stop() {
        if (status === 3) stopRecording?.();
        status = 0;
    }
    return {
        start: start,
        stop: stop,
        getSessionReplayLink () {
            return (0, $2YlOK.getSessionReplayLink)(configuration, sessionManager, viewHistory, status !== 0);
        },
        isRecording: ()=>status === 3
    };
}
function $e5049a173526c8c3$var$canStartRecording(replayState, options) {
    return replayState !== void 0 && (replayState !== (0, $jIq9O.SessionReplayState).OFF || options?.force);
}
function $e5049a173526c8c3$var$isRecordingInProgress(status) {
    return status === 2 || status === 3;
}
function $e5049a173526c8c3$var$shouldForceReplay(replayState, options) {
    return options && options.force && replayState === (0, $jIq9O.SessionReplayState).OFF;
}
async function $e5049a173526c8c3$var$notifyWhenSettled(observable, event, promise) {
    try {
        return await promise;
    } finally{
        observable.notify(event);
    }
}

});
parcelRegister("2YlOK", function(module, exports) {

$parcel$export(module.exports, "getSessionReplayLink", function () { return $b19c7768eb701b57$export$5070ba0fc541c84; });
parcelRequire("lNEHA");
var $jIq9O = parcelRequire("jIq9O");
var $j4B0M = parcelRequire("j4B0M");
//#region src/domain/getSessionReplayLink.ts
function $b19c7768eb701b57$export$5070ba0fc541c84(configuration, sessionManager, viewHistory, isRecordingStarted) {
    const session = sessionManager.findTrackedSession();
    const errorType = $b19c7768eb701b57$var$getErrorType(configuration, session, isRecordingStarted);
    const viewContext = viewHistory.findView();
    return (0, $j4B0M.getSessionReplayUrl)(configuration, {
        viewContext: viewContext,
        errorType: errorType,
        session: session
    });
}
function $b19c7768eb701b57$var$getErrorType(configuration, session, isRecordingStarted) {
    if (!session) return "rum-not-tracked";
    if ((0, $jIq9O.computeSessionReplayState)(session, configuration) === (0, $jIq9O.SessionReplayState).OFF) return "incorrect-session-plan";
    if (!isRecordingStarted) return "replay-not-started";
}

});
parcelRegister("lNEHA", function(module, exports) {

$parcel$export(module.exports, "CENSORED_IMG_MARK", function () { return (parcelRequire("8yVTM")).CENSORED_IMG_MARK; });
$parcel$export(module.exports, "CENSORED_STRING_MARK", function () { return (parcelRequire("8yVTM")).CENSORED_STRING_MARK; });
$parcel$export(module.exports, "LifeCycleEventType", function () { return (parcelRequire("jNZRV")).LifeCycleEventType; });
$parcel$export(module.exports, "NodePrivacyLevel", function () { return (parcelRequire("8yVTM")).NodePrivacyLevel; });
$parcel$export(module.exports, "PRIVACY_ATTR_NAME", function () { return (parcelRequire("8yVTM")).PRIVACY_ATTR_NAME; });
$parcel$export(module.exports, "PRIVACY_ATTR_VALUE_HIDDEN", function () { return (parcelRequire("8yVTM")).PRIVACY_ATTR_VALUE_HIDDEN; });
$parcel$export(module.exports, "RumEventType", function () { return (parcelRequire("6htpc")).RumEventType; });
$parcel$export(module.exports, "RumLongTaskEntryType", function () { return (parcelRequire("6htpc")).RumLongTaskEntryType; });
$parcel$export(module.exports, "RumPerformanceEntryType", function () { return (parcelRequire("4H1Xw")).RumPerformanceEntryType; });
$parcel$export(module.exports, "SessionReplayState", function () { return (parcelRequire("jIq9O")).SessionReplayState; });
$parcel$export(module.exports, "VitalType", function () { return (parcelRequire("6htpc")).VitalType; });
$parcel$export(module.exports, "computeSessionReplayState", function () { return (parcelRequire("jIq9O")).computeSessionReplayState; });
$parcel$export(module.exports, "createFormDataTransport", function () { return (parcelRequire("65e75")).createFormDataTransport; });
$parcel$export(module.exports, "forEachChildNodes", function () { return (parcelRequire("8EfFG")).forEachChildNodes; });
$parcel$export(module.exports, "getMutationObserverConstructor", function () { return (parcelRequire("46UCk")).getMutationObserverConstructor; });
$parcel$export(module.exports, "getNodePrivacyLevel", function () { return (parcelRequire("8lnE0")).getNodePrivacyLevel; });
$parcel$export(module.exports, "getNodeSelfPrivacyLevel", function () { return (parcelRequire("8lnE0")).getNodeSelfPrivacyLevel; });
$parcel$export(module.exports, "getParentNode", function () { return (parcelRequire("8EfFG")).getParentNode; });
$parcel$export(module.exports, "getScrollX", function () { return (parcelRequire("ktiJ6")).getScrollX; });
$parcel$export(module.exports, "getScrollY", function () { return (parcelRequire("ktiJ6")).getScrollY; });
$parcel$export(module.exports, "getSessionReplayUrl", function () { return (parcelRequire("j4B0M")).getSessionReplayUrl; });
$parcel$export(module.exports, "getTextContent", function () { return (parcelRequire("8lnE0")).getTextContent; });
$parcel$export(module.exports, "getViewportDimension", function () { return (parcelRequire("fUJs2")).getViewportDimension; });
$parcel$export(module.exports, "initViewportObservable", function () { return (parcelRequire("fUJs2")).initViewportObservable; });
$parcel$export(module.exports, "isElementNode", function () { return (parcelRequire("8EfFG")).isElementNode; });
$parcel$export(module.exports, "isNodeShadowHost", function () { return (parcelRequire("8EfFG")).isNodeShadowHost; });
$parcel$export(module.exports, "isNodeShadowRoot", function () { return (parcelRequire("8EfFG")).isNodeShadowRoot; });
$parcel$export(module.exports, "makeRumPublicApi", function () { return (parcelRequire("13M2C")).makeRumPublicApi; });
$parcel$export(module.exports, "reducePrivacyLevel", function () { return (parcelRequire("8lnE0")).reducePrivacyLevel; });
$parcel$export(module.exports, "sanitizeIfLongDataUrl", function () { return (parcelRequire("38LZB")).sanitizeIfLongDataUrl; });
$parcel$export(module.exports, "shouldMaskAttribute", function () { return (parcelRequire("8lnE0")).shouldMaskAttribute; });
$parcel$export(module.exports, "shouldMaskNode", function () { return (parcelRequire("8lnE0")).shouldMaskNode; });

var $6htpc = parcelRequire("6htpc");

var $iVgUy = parcelRequire("iVgUy");
parcelRequire("laTCl");

var $kmm0x = parcelRequire("kmm0x");

var $46UCk = parcelRequire("46UCk");

var $jNZRV = parcelRequire("jNZRV");

var $80kZV = parcelRequire("80kZV");

var $38LZB = parcelRequire("38LZB");

var $8EfFG = parcelRequire("8EfFG");

var $4H1Xw = parcelRequire("4H1Xw");

var $eqtGB = parcelRequire("eqtGB");

var $iMCYf = parcelRequire("iMCYf");

var $8yVTM = parcelRequire("8yVTM");

var $8lnE0 = parcelRequire("8lnE0");

var $ktiJ6 = parcelRequire("ktiJ6");

var $fUJs2 = parcelRequire("fUJs2");

var $jIq9O = parcelRequire("jIq9O");

var $eE0f0 = parcelRequire("eE0f0");

var $13M2C = parcelRequire("13M2C");

var $j4B0M = parcelRequire("j4B0M");

var $65e75 = parcelRequire("65e75");

});
parcelRegister("6htpc", function(module, exports) {

$parcel$export(module.exports, "RumEventType", function () { return $bba115eb58042ebb$export$ce36bdd8bcd00f70; });
$parcel$export(module.exports, "RumLongTaskEntryType", function () { return $bba115eb58042ebb$export$292a466c44f68ccd; });
$parcel$export(module.exports, "ViewLoadingType", function () { return $bba115eb58042ebb$export$82f61b2f79c8be94; });
$parcel$export(module.exports, "ActionType", function () { return $bba115eb58042ebb$export$e4a712fff93fb00f; });
$parcel$export(module.exports, "FrustrationType", function () { return $bba115eb58042ebb$export$9de4b95bcfcfa4e1; });
$parcel$export(module.exports, "VitalType", function () { return $bba115eb58042ebb$export$e7428258e7ebc9a7; });
//#region src/rawRumEvent.types.ts
const $bba115eb58042ebb$export$ce36bdd8bcd00f70 = {
    ACTION: "action",
    ERROR: "error",
    LONG_TASK: "long_task",
    VIEW: "view",
    VIEW_UPDATE: "view_update",
    RESOURCE: "resource",
    VITAL: "vital"
};
const $bba115eb58042ebb$export$292a466c44f68ccd = {
    LONG_TASK: "long-task",
    LONG_ANIMATION_FRAME: "long-animation-frame"
};
const $bba115eb58042ebb$export$82f61b2f79c8be94 = {
    INITIAL_LOAD: "initial_load",
    ROUTE_CHANGE: "route_change",
    SESSION_RENEWAL: "session_renewal",
    BF_CACHE: "bf_cache"
};
const $bba115eb58042ebb$export$e4a712fff93fb00f = {
    CLICK: "click",
    CUSTOM: "custom",
    TAP: "tap",
    SCROLL: "scroll",
    SWIPE: "swipe",
    APPLICATION_START: "application_start",
    BACK: "back"
};
const $bba115eb58042ebb$export$9de4b95bcfcfa4e1 = {
    RAGE_CLICK: "rage_click",
    ERROR_CLICK: "error_click",
    DEAD_CLICK: "dead_click"
};
const $bba115eb58042ebb$export$e7428258e7ebc9a7 = {
    DURATION: "duration",
    OPERATION_STEP: "operation_step"
};

});

parcelRegister("iVgUy", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_TRACKED_RESOURCE_HEADERS", function () { return $6d2976a3456659ca$export$64881634f73a51ad; });
$parcel$export(module.exports, "validateAndBuildRumConfiguration", function () { return $6d2976a3456659ca$export$4f016a753eca1880; });
$parcel$export(module.exports, "serializeRumConfiguration", function () { return $6d2976a3456659ca$export$937b8b43e93f9c22; });

var $e6c5e = parcelRequire("e6c5e");

var $bF5dI = parcelRequire("bF5dI");

var $9O7SB = parcelRequire("9O7SB");
var $gS0nt = parcelRequire("gS0nt");
var $4wo62 = parcelRequire("4wo62");
var $jq8c3 = parcelRequire("jq8c3");
var $fOYzt = parcelRequire("fOYzt");
var $5kKbc = parcelRequire("5kKbc");
var $eQWMG = parcelRequire("eQWMG");

var $b6w9H = parcelRequire("b6w9H");
//#region src/domain/configuration/configuration.ts
const $6d2976a3456659ca$export$6fcd8876d4ab74f5 = [
    "tracecontext",
    "datadog"
];
/**
* Default list of headers collected on resource events when {@link RumInitConfiguration.trackResourceHeaders | trackResourceHeaders}
* is set to `true`.
*/ const $6d2976a3456659ca$export$64881634f73a51ad = [
    "cache-control",
    "etag",
    "age",
    "expires",
    "content-type",
    "content-encoding",
    "vary",
    "content-length",
    "server-timing",
    "x-cache",
    "cf-cache-status",
    "x-vercel-cache"
];
/**
* Recording quality presets for canvas capture. See {@link RumInitConfiguration.sessionReplayCanvasRecording}.
*
* @example
* ```ts
* datadogRum.init({
*   // ...
*   sessionReplayCanvasRecording: {
*     enable: true,
*     quality: CanvasRecordingQuality.MEDIUM,
*   },
* })
* ```
* @hidden
*/ const $6d2976a3456659ca$export$3c48616c92fea365 = {
    LOW: "low",
    MEDIUM: "medium",
    HIGH: "high"
};
const $6d2976a3456659ca$var$CANVAS_RECORDING_QUALITY_PRESETS = {
    [$6d2976a3456659ca$export$3c48616c92fea365.LOW]: {
        maxFramesPerSecond: 1,
        hashingMaxDimension: 50,
        maxImageDimension: 600,
        encodeQuality: .3
    },
    [$6d2976a3456659ca$export$3c48616c92fea365.MEDIUM]: {
        maxFramesPerSecond: 4,
        hashingMaxDimension: 100,
        maxImageDimension: 1e3,
        encodeQuality: .5
    },
    [$6d2976a3456659ca$export$3c48616c92fea365.HIGH]: {
        maxFramesPerSecond: 8,
        hashingMaxDimension: 100,
        maxImageDimension: 1280,
        encodeQuality: .75
    }
};
function $6d2976a3456659ca$var$resolveCanvasRecordingConfiguration(configuration) {
    const preset = configuration && $6d2976a3456659ca$var$CANVAS_RECORDING_QUALITY_PRESETS[configuration.quality];
    return (0, $fOYzt.isExperimentalFeatureEnabled)((0, $fOYzt.ExperimentalFeature).SESSION_REPLAY_RECORD_CANVAS) && configuration?.enable && preset ? {
        enable: true,
        ...preset
    } : void 0;
}
const $6d2976a3456659ca$export$436bdb97e6291617 = {
    ...(0, $9O7SB.BROWSER_CORE_SCHEMA),
    applicationId: {
        type: "string",
        required: true
    },
    actionNameAttribute: {
        type: "string"
    },
    workerUrl: {
        type: "string"
    },
    subdomain: {
        type: "string"
    },
    sessionReplaySampleRate: {
        type: "percentage",
        default: 0
    },
    traceSampleRate: {
        type: "percentage",
        default: 100
    },
    profilingSampleRate: {
        type: "percentage",
        default: 0
    },
    compressIntakeRequests: {
        type: "boolean",
        default: false
    },
    trackUserInteractions: {
        type: "boolean",
        default: true,
        strict: false
    },
    trackResources: {
        type: "boolean",
        default: true,
        strict: false
    },
    trackLongTasks: {
        type: "boolean",
        default: true,
        strict: false
    },
    trackViewsManually: {
        type: "boolean",
        default: false,
        strict: false
    },
    betaEnableViewUpdates: {
        type: "boolean"
    },
    betaTrackWebSockets: {
        type: "boolean",
        default: false,
        strict: false
    },
    enablePrivacyForActionName: {
        type: "boolean",
        default: true
    },
    propagateTraceBaggage: {
        type: "boolean",
        default: true
    },
    startSessionReplayRecordingManually: {
        type: "boolean",
        default: false,
        strict: false
    },
    sessionReplayCanvasRecording: {
        type: "schema",
        schema: {
            enable: {
                type: "boolean",
                required: true
            },
            quality: {
                type: "enum",
                values: $6d2976a3456659ca$export$3c48616c92fea365,
                default: $6d2976a3456659ca$export$3c48616c92fea365.MEDIUM
            }
        }
    },
    defaultPrivacyLevel: {
        type: "enum",
        values: (0, $9O7SB.DefaultPrivacyLevel),
        default: (0, $9O7SB.DefaultPrivacyLevel).MASK_USER_INPUT,
        strict: false
    },
    traceContextInjection: {
        type: "enum",
        values: (0, $9O7SB.TraceContextInjection),
        default: (0, $9O7SB.TraceContextInjection).SAMPLED,
        strict: false
    },
    excludedActivityUrls: {
        type: "match-option",
        multiple: true,
        default: []
    },
    allowedTracingUrls: {
        type: "union",
        multiple: true,
        strict: false,
        default: [],
        variants: [
            {
                type: "match-option"
            },
            {
                type: "schema",
                schema: {
                    match: {
                        type: "match-option",
                        required: true
                    },
                    propagatorTypes: {
                        type: "enum",
                        values: [
                            "datadog",
                            "b3",
                            "b3multi",
                            "tracecontext"
                        ],
                        multiple: true,
                        strict: false,
                        default: $6d2976a3456659ca$export$6fcd8876d4ab74f5
                    }
                }
            }
        ]
    },
    plugins: {
        type: "schema",
        multiple: true,
        strict: false,
        default: [],
        schema: {
            name: {
                type: "string",
                required: true
            },
            getConfigurationTelemetry: {
                type: "function",
                strict: false,
                signature: void 0
            },
            onInit: {
                type: "function",
                strict: false,
                signature: void 0
            },
            onRumStart: {
                type: "function",
                strict: false,
                signature: void 0
            }
        }
    },
    trackFeatureFlagsForEvents: {
        type: "enum",
        values: [
            "vital",
            "action",
            "long_task",
            "resource"
        ],
        multiple: true,
        strict: false,
        default: []
    }
};
/**
* Resolves whether partial view updates are enabled. Never enabled when the event bridge is used.
* Otherwise an explicit `betaEnableViewUpdates` takes precedence, and it defaults to true for CDN
* users that do not go through a proxy: a proxy may not forward the `view_update` event type yet,
* and npm users pin an SDK version so they opt in explicitly.
*
* The CDN check is temporary, the next step is to default this to true unless `proxy` is set.
* TODO next major: remove the option.
*/ function $6d2976a3456659ca$var$isViewUpdatesEnabled(explicit, proxy, sdkName) {
    if ((0, $gS0nt.canUseEventBridge)()) return false;
    return explicit ?? false;
}
function $6d2976a3456659ca$export$4f016a753eca1880(initConfiguration, sdkName) {
    const config = (0, $b6w9H.validateAndBuildConfiguration)(initConfiguration, $6d2976a3456659ca$export$436bdb97e6291617, (0, $jq8c3.display));
    if (!config) return;
    const allowedTracingUrls = config.allowedTracingUrls.map($6d2976a3456659ca$var$normalizeTracingOption).filter(Boolean);
    if (allowedTracingUrls.length > 0 && !config.service) {
        (0, $jq8c3.display).error("Service needs to be configured when tracing is enabled");
        return;
    }
    const sessionReplayCanvasRecording = $6d2976a3456659ca$var$resolveCanvasRecordingConfiguration(config.sessionReplayCanvasRecording);
    return {
        ...config,
        service: config.service || config.applicationId,
        sessionReplayCanvasRecording: sessionReplayCanvasRecording,
        betaEnableViewUpdates: $6d2976a3456659ca$var$isViewUpdatesEnabled(config.betaEnableViewUpdates, config.proxy, sdkName),
        allowedTracingUrls: allowedTracingUrls,
        beforeSend: config.beforeSend ? (0, $4wo62.catchUserErrors)(config.beforeSend, "beforeSend threw an error:") : void 0,
        rulePsr: (0, $eQWMG.isNumber)(initConfiguration.traceSampleRate) ? initConfiguration.traceSampleRate / 100 : void 0,
        trackResourceHeaders: $6d2976a3456659ca$var$validateAndBuildTrackResourceHeaders(initConfiguration),
        allowedGraphQlUrls: $6d2976a3456659ca$var$validateAndBuildGraphQlOptions(initConfiguration),
        remoteConfigurationId: (0, $e6c5e.getRemoteConfigurationId)(initConfiguration)
    };
}
/**
* Combines the selected tracing propagators from the different options in allowedTracingUrls
*/ function $6d2976a3456659ca$var$getSelectedTracingPropagators(configuration) {
    const usedTracingPropagators = /* @__PURE__ */ new Set();
    if ((0, $5kKbc.isNonEmptyArray)(configuration.allowedTracingUrls)) configuration.allowedTracingUrls.forEach((option)=>{
        $6d2976a3456659ca$var$normalizeTracingOption(option)?.propagatorTypes.forEach((propagatorType)=>usedTracingPropagators.add(propagatorType));
    });
    return Array.from(usedTracingPropagators);
}
function $6d2976a3456659ca$var$normalizeTracingOption(option) {
    if ((0, $bF5dI.isMatchOption)(option)) return {
        match: option,
        propagatorTypes: $6d2976a3456659ca$export$6fcd8876d4ab74f5
    };
    if ((0, $bF5dI.isIndexableObject)(option) && (0, $bF5dI.isMatchOption)(option.match) && (option.propagatorTypes === null || option.propagatorTypes === void 0 || Array.isArray(option.propagatorTypes))) return {
        match: option.match,
        propagatorTypes: option.propagatorTypes || $6d2976a3456659ca$export$6fcd8876d4ab74f5
    };
}
/**
* Build GraphQL options from configuration
*/ function $6d2976a3456659ca$var$validateAndBuildGraphQlOptions(initConfiguration) {
    if (!initConfiguration.allowedGraphQlUrls) return [];
    if (!Array.isArray(initConfiguration.allowedGraphQlUrls)) {
        (0, $jq8c3.display).warn("allowedGraphQlUrls should be an array");
        return [];
    }
    const graphQlOptions = [];
    initConfiguration.allowedGraphQlUrls.forEach((option)=>{
        if ((0, $bF5dI.isMatchOption)(option)) graphQlOptions.push({
            match: option,
            trackPayload: false,
            trackResponseErrors: false
        });
        else if ((0, $bF5dI.isIndexableObject)(option) && (0, $bF5dI.isMatchOption)(option.match)) graphQlOptions.push({
            match: option.match,
            trackPayload: !!option.trackPayload,
            trackResponseErrors: !!option.trackResponseErrors
        });
    });
    return graphQlOptions;
}
const $6d2976a3456659ca$var$VALID_HEADER_LOCATIONS = [
    "request",
    "response",
    "any"
];
function $6d2976a3456659ca$var$validateAndBuildTrackResourceHeaders(initConfiguration) {
    const option = initConfiguration.trackResourceHeaders;
    if (option === void 0 || option === false) return [];
    if (option === true) return $6d2976a3456659ca$export$64881634f73a51ad.map((name)=>({
            name: name
        }));
    if (!Array.isArray(option)) {
        (0, $jq8c3.display).warn("trackResourceHeaders should be true or an array of MatchHeader");
        return [];
    }
    if (option.length === 0) {
        (0, $jq8c3.display).warn("trackResourceHeaders is an empty array, no headers will be captured");
        return [];
    }
    const result = [];
    option.forEach((item, index)=>{
        if (!(0, $bF5dI.isIndexableObject)(item)) {
            (0, $jq8c3.display).warn(`trackResourceHeaders[${index}] should be a MatchHeader object`);
            return;
        }
        if (item.name !== void 0 && !(0, $bF5dI.isMatchOption)(item.name)) {
            (0, $jq8c3.display).warn(`trackResourceHeaders[${index}].name should be a MatchOption`);
            return;
        }
        if (item.url !== void 0 && !(0, $bF5dI.isMatchOption)(item.url)) {
            (0, $jq8c3.display).warn(`trackResourceHeaders[${index}].url should be a MatchOption`);
            return;
        }
        if (item.extractor !== void 0 && !(item.extractor instanceof RegExp)) {
            (0, $jq8c3.display).warn(`trackResourceHeaders[${index}].extractor should be a RegExp`);
            return;
        }
        if (item.location !== void 0 && (typeof item.location !== "string" || !$6d2976a3456659ca$var$VALID_HEADER_LOCATIONS.includes(item.location))) {
            (0, $jq8c3.display).warn(`trackResourceHeaders[${index}].location should be 'request', 'response', or 'any'`);
            return;
        }
        const { name: name, ...rest } = item;
        result.push({
            ...rest,
            ...name !== void 0 ? {
                name: typeof name === "string" ? name.toLowerCase() : name
            } : {}
        });
    });
    return result;
}
function $6d2976a3456659ca$var$hasGraphQlPayloadTracking(allowedGraphQlUrls) {
    return (0, $5kKbc.isNonEmptyArray)(allowedGraphQlUrls) && allowedGraphQlUrls.some((option)=>(0, $bF5dI.isIndexableObject)(option) && option.trackPayload);
}
function $6d2976a3456659ca$var$hasGraphQlResponseErrorsTracking(allowedGraphQlUrls) {
    return (0, $5kKbc.isNonEmptyArray)(allowedGraphQlUrls) && allowedGraphQlUrls.some((option)=>(0, $bF5dI.isIndexableObject)(option) && option.trackResponseErrors);
}
function $6d2976a3456659ca$var$getTrackResourceHeadersTelemetryValue(trackResourceHeaders) {
    if (trackResourceHeaders === true) return "default_headers";
    if (Array.isArray(trackResourceHeaders)) return "custom";
}
function $6d2976a3456659ca$export$937b8b43e93f9c22(configuration, sdkName, remoteConfigurationMetadata) {
    const baseSerializedConfiguration = (0, $9O7SB.serializeConfiguration)(configuration);
    return {
        session_replay_sample_rate: configuration.sessionReplaySampleRate,
        start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
        trace_sample_rate: configuration.traceSampleRate,
        trace_context_injection: configuration.traceContextInjection,
        propagate_trace_baggage: configuration.propagateTraceBaggage,
        action_name_attribute: configuration.actionNameAttribute,
        use_allowed_tracing_urls: (0, $5kKbc.isNonEmptyArray)(configuration.allowedTracingUrls),
        use_allowed_graph_ql_urls: (0, $5kKbc.isNonEmptyArray)(configuration.allowedGraphQlUrls),
        use_track_graph_ql_payload: $6d2976a3456659ca$var$hasGraphQlPayloadTracking(configuration.allowedGraphQlUrls),
        use_track_graph_ql_response_errors: $6d2976a3456659ca$var$hasGraphQlResponseErrorsTracking(configuration.allowedGraphQlUrls),
        selected_tracing_propagators: $6d2976a3456659ca$var$getSelectedTracingPropagators(configuration),
        default_privacy_level: configuration.defaultPrivacyLevel,
        enable_privacy_for_action_name: configuration.enablePrivacyForActionName,
        use_excluded_activity_urls: (0, $5kKbc.isNonEmptyArray)(configuration.excludedActivityUrls),
        use_worker_url: !!configuration.workerUrl,
        compress_intake_requests: configuration.compressIntakeRequests,
        track_views_manually: configuration.trackViewsManually,
        track_user_interactions: configuration.trackUserInteractions,
        track_resources: configuration.trackResources,
        track_long_task: configuration.trackLongTasks,
        plugins: configuration.plugins?.map((plugin)=>({
                name: plugin.name,
                ...plugin.getConfigurationTelemetry?.()
            })),
        track_feature_flags_for_events: configuration.trackFeatureFlagsForEvents,
        remote_configuration_id: (0, $e6c5e.getRemoteConfigurationId)(configuration),
        remote_configuration: remoteConfigurationMetadata && {
            config_id: (0, $e6c5e.getRemoteConfigurationId)(configuration),
            last_modified: remoteConfigurationMetadata.lastModified,
            last_synced: remoteConfigurationMetadata.lastSynced,
            first_applied: remoteConfigurationMetadata.firstApplied,
            sync_id: remoteConfigurationMetadata.syncId
        },
        profiling_sample_rate: configuration.profilingSampleRate,
        use_remote_configuration_proxy: !!configuration.remoteConfigurationProxy,
        track_resource_headers: $6d2976a3456659ca$var$getTrackResourceHeadersTelemetryValue(configuration.trackResourceHeaders),
        beta_enable_view_updates: $6d2976a3456659ca$var$isViewUpdatesEnabled(configuration.betaEnableViewUpdates, configuration.proxy, sdkName),
        beta_track_web_sockets: configuration.betaTrackWebSockets,
        ...baseSerializedConfiguration
    };
}

});
parcelRegister("e6c5e", function(module, exports) {

$parcel$export(module.exports, "fetchAndApplyRemoteConfiguration", function () { return $4d9506bc843c6b97$export$cfd957a7abf0b7b5; });
$parcel$export(module.exports, "getRemoteConfigurationId", function () { return $4d9506bc843c6b97$export$6855b92f2de76db7; });
$parcel$export(module.exports, "getRemoteConfiguration", function () { return $4d9506bc843c6b97$export$bbea94e68c062b90; });

var $3TQDF = parcelRequire("3TQDF");

var $d6xBc = parcelRequire("d6xBc");

var $cHgkH = parcelRequire("cHgkH");

var $bF5dI = parcelRequire("bF5dI");

var $461Vl = parcelRequire("461Vl");
var $jq8c3 = parcelRequire("jq8c3");
var $93D3m = parcelRequire("93D3m");
var $aZWin = parcelRequire("aZWin");
var $brKlt = parcelRequire("brKlt");

var $dee0n = parcelRequire("dee0n");

var $k8VFU = parcelRequire("k8VFU");
//#region src/domain/configuration/remoteConfiguration.ts
const $4d9506bc843c6b97$var$REMOTE_CONFIGURATION_VERSION = "v1";
const $4d9506bc843c6b97$var$SUPPORTED_RUM_FIELDS = [
    "applicationId",
    "service",
    "env",
    "version",
    "sessionSampleRate",
    "sessionReplaySampleRate",
    "telemetrySampleRate",
    "trackAnonymousUser",
    "trackUserInteractions",
    "trackResources",
    "trackLongTasks",
    "traceContextInjection",
    "actionNameAttribute",
    "defaultPrivacyLevel",
    "enablePrivacyForActionName",
    "traceSampleRate",
    "trackSessionAcrossSubdomains",
    "allowedTracingUrls",
    "allowedTrackingOrigins"
];
async function $4d9506bc843c6b97$export$cfd957a7abf0b7b5(initConfiguration, supportedContextManagers) {
    let rumInitConfiguration;
    const metrics = $4d9506bc843c6b97$export$844c6120e74e95ac();
    const fetchResult = await $4d9506bc843c6b97$export$4e57f2d70ec375f7(initConfiguration);
    if (!fetchResult.ok) {
        metrics.increment("fetch", "failure");
        (0, $jq8c3.display).error(fetchResult.error);
    } else {
        metrics.increment("fetch", "success");
        rumInitConfiguration = $4d9506bc843c6b97$export$8fe2215bb479e811(initConfiguration, fetchResult.value, supportedContextManagers, metrics);
    }
    (0, $461Vl.addTelemetryMetrics)((0, $461Vl.TelemetryMetrics).REMOTE_CONFIGURATION_METRIC_NAME, {
        metrics: metrics.get()
    });
    return rumInitConfiguration;
}
function $4d9506bc843c6b97$export$8fe2215bb479e811(initConfiguration, remoteConfiguration, supportedContextManagers, metrics) {
    const appliedConfiguration = {
        ...initConfiguration
    };
    if (remoteConfiguration.rum) {
        const rumRemoteConfiguration = remoteConfiguration.rum;
        $4d9506bc843c6b97$var$SUPPORTED_RUM_FIELDS.forEach((option)=>{
            if (option in rumRemoteConfiguration) appliedConfiguration[option] = resolveConfigurationProperty(rumRemoteConfiguration[option]);
        });
        Object.keys(supportedContextManagers).forEach((context)=>{
            if (rumRemoteConfiguration[context] !== void 0) resolveContextProperty(supportedContextManagers[context], rumRemoteConfiguration[context]);
        });
    }
    if (remoteConfiguration.profiling?.sampleRate !== void 0) appliedConfiguration.profilingSampleRate = remoteConfiguration.profiling.sampleRate;
    return appliedConfiguration;
    function resolveConfigurationProperty(property) {
        if (Array.isArray(property)) return property.map(resolveConfigurationProperty);
        if ((0, $bF5dI.isIndexableObject)(property)) {
            if ($4d9506bc843c6b97$var$isSerializedOption(property)) {
                const type = property.rcSerializedType;
                switch(type){
                    case "string":
                        return property.value;
                    case "regex":
                        return $4d9506bc843c6b97$var$resolveRegex(property.value);
                    case "dynamic":
                        return resolveDynamicOption(property);
                    default:
                        (0, $jq8c3.display).error(`Unsupported remote configuration: "rcSerializedType": "${type}"`);
                        return;
                }
            }
            return (0, $brKlt.mapValues)(property, resolveConfigurationProperty);
        }
        return property;
    }
    function resolveContextProperty(contextManager, contextItems) {
        contextItems.forEach(({ key: key, value: value })=>{
            contextManager.setContextProperty(key, resolveConfigurationProperty(value));
        });
    }
    function resolveDynamicOption(property) {
        const strategy = property.strategy;
        let resolvedValue;
        switch(strategy){
            case "cookie":
                resolvedValue = resolveCookieValue(property);
                break;
            case "dom":
                resolvedValue = resolveDomValue(property);
                break;
            case "js":
                resolvedValue = resolveJsValue(property);
                break;
            case "localStorage":
                resolvedValue = resolveLocalStorageValue(property);
                break;
            default:
                (0, $jq8c3.display).error(`Unsupported remote configuration: "strategy": "${strategy}"`);
                return;
        }
        const extractor = property.extractor;
        if (extractor !== void 0 && typeof resolvedValue === "string") return $4d9506bc843c6b97$var$extractValue(extractor, resolvedValue);
        return resolvedValue;
    }
    function resolveCookieValue({ name: name }) {
        const value = (0, $aZWin.getCookie)(name);
        metrics.increment("cookie", value !== void 0 ? "success" : "missing");
        return value;
    }
    function resolveLocalStorageValue({ key: key }) {
        let value;
        try {
            value = localStorage.getItem(key);
        } catch  {
            metrics.increment("localStorage", "failure");
            return;
        }
        metrics.increment("localStorage", value !== null ? "success" : "missing");
        return value ?? void 0;
    }
    function resolveDomValue({ selector: selector, attribute: attribute }) {
        let element;
        try {
            element = document.querySelector(selector);
        } catch  {
            (0, $jq8c3.display).error(`Invalid selector in the remote configuration: '${selector}'`);
            metrics.increment("dom", "failure");
            return;
        }
        if (!element) {
            metrics.increment("dom", "missing");
            return;
        }
        if (isForbidden(element, attribute)) {
            (0, $jq8c3.display).error(`Forbidden element selected by the remote configuration: '${selector}'`);
            metrics.increment("dom", "failure");
            return;
        }
        const domValue = attribute !== void 0 ? element.getAttribute(attribute) : element.textContent;
        if (domValue === null) {
            metrics.increment("dom", "missing");
            return;
        }
        metrics.increment("dom", "success");
        return domValue;
    }
    function isForbidden(element, attribute) {
        return element.getAttribute("type") === "password" && attribute === "value";
    }
    function resolveJsValue({ path: path }) {
        let current = window;
        const pathParts = (0, $d6xBc.parseJsonPath)(path);
        if (pathParts.length === 0) {
            (0, $jq8c3.display).error(`Invalid JSON path in the remote configuration: '${path}'`);
            metrics.increment("js", "failure");
            return;
        }
        for (const pathPart of pathParts){
            if (!(pathPart in current)) {
                metrics.increment("js", "missing");
                return;
            }
            try {
                current = current[pathPart];
            } catch (e) {
                (0, $jq8c3.display).error(`Error accessing: '${path}'`, e);
                metrics.increment("js", "failure");
                return;
            }
        }
        metrics.increment("js", "success");
        return current;
    }
}
function $4d9506bc843c6b97$export$844c6120e74e95ac() {
    const metrics = {
        fetch: {}
    };
    return {
        get: ()=>metrics,
        increment: (metricName, type)=>{
            if (!metrics[metricName]) metrics[metricName] = {};
            if (!metrics[metricName][type]) metrics[metricName][type] = 0;
            metrics[metricName][type] = metrics[metricName][type] + 1;
        }
    };
}
function $4d9506bc843c6b97$var$isSerializedOption(value) {
    return "rcSerializedType" in value;
}
function $4d9506bc843c6b97$var$resolveRegex(pattern) {
    try {
        return new RegExp(pattern);
    } catch  {
        (0, $jq8c3.display).error(`Invalid regex in the remote configuration: '${pattern}'`);
    }
}
function $4d9506bc843c6b97$var$extractValue(extractor, candidate) {
    const resolvedExtractor = $4d9506bc843c6b97$var$resolveRegex(extractor.value);
    if (resolvedExtractor === void 0) return;
    return (0, $3TQDF.extractRegexMatch)(candidate, resolvedExtractor);
}
/**
* Reads the CDN publish time. `Last-Modified` is a CORS-safelisted response header, so it is
* readable cross-origin without the CDN having to expose it explicitly. It carries an HTTP-date,
* so the value is only accurate to the second.
*/ function $4d9506bc843c6b97$var$parseLastModified(response) {
    const header = response.headers?.get("last-modified");
    if (!header) return;
    const timestamp = new Date(header).getTime();
    return isNaN(timestamp) ? void 0 : timestamp;
}
async function $4d9506bc843c6b97$export$4e57f2d70ec375f7(configuration) {
    let response;
    try {
        response = await (0, $93D3m.fetch)($4d9506bc843c6b97$export$a18226397bb190d3(configuration));
    } catch  {
        response = void 0;
    }
    if (!response?.ok) return {
        ok: false,
        error: /* @__PURE__ */ new Error("Error fetching the remote configuration.")
    };
    const remoteConfiguration = await response.json();
    if (remoteConfiguration.rum || remoteConfiguration.profiling) return {
        ok: true,
        value: remoteConfiguration,
        lastModified: $4d9506bc843c6b97$var$parseLastModified(response)
    };
    return {
        ok: false,
        error: /* @__PURE__ */ new Error("No remote configuration for RUM.")
    };
}
function $4d9506bc843c6b97$export$6855b92f2de76db7(configuration) {
    return configuration.remoteConfiguration?.id ?? configuration.remoteConfigurationId;
}
function $4d9506bc843c6b97$export$a18226397bb190d3(configuration) {
    if (configuration.remoteConfigurationProxy) return configuration.remoteConfigurationProxy;
    const id = $4d9506bc843c6b97$export$6855b92f2de76db7(configuration);
    return (0, $k8VFU.buildEndpointUrl)({
        site: configuration.site,
        path: `/${$4d9506bc843c6b97$var$REMOTE_CONFIGURATION_VERSION}/${encodeURIComponent(id)}.json`,
        subdomain: "sdk-configuration"
    });
}
function $4d9506bc843c6b97$var$doBackgroundCacheSync(initConfiguration, cache, metrics) {
    $4d9506bc843c6b97$export$4e57f2d70ec375f7(initConfiguration).then((fetchResult)=>{
        if (!fetchResult.ok) {
            metrics.increment("fetch", "failure");
            (0, $jq8c3.display).error(fetchResult.error);
        } else {
            metrics.increment("fetch", "success");
            cache.write(fetchResult.value, fetchResult.lastModified);
        }
    }).catch((0, $dee0n.monitorError)).finally(()=>{
        (0, $461Vl.addTelemetryMetrics)((0, $461Vl.TelemetryMetrics).REMOTE_CONFIGURATION_METRIC_NAME, {
            metrics: metrics.get()
        });
    });
}
/**
* Returns `undefined` when RUM must not start, which only happens with `required: true` and no
* usable cache entry.
*/ function $4d9506bc843c6b97$export$bbea94e68c062b90(initConfiguration, supportedContextManagers) {
    const configurationCache = (0, $cHgkH.createConfigurationCache)({
        remoteConfigurationId: $4d9506bc843c6b97$export$6855b92f2de76db7(initConfiguration)
    });
    const metrics = $4d9506bc843c6b97$export$844c6120e74e95ac();
    const cacheResult = configurationCache.read();
    metrics.increment("cache", (0, $cHgkH.CACHE_STATUS_TO_METRIC_MAP)[cacheResult.status]);
    $4d9506bc843c6b97$var$doBackgroundCacheSync(initConfiguration, configurationCache, metrics);
    if (cacheResult.status === "hit") return {
        metadata: configurationCache.stampFirstApplied(cacheResult),
        initConfiguration: $4d9506bc843c6b97$export$8fe2215bb479e811(initConfiguration, cacheResult.config, supportedContextManagers, metrics)
    };
    if (initConfiguration.remoteConfiguration?.required) return;
    return {
        initConfiguration: initConfiguration
    };
}

});
parcelRegister("3TQDF", function(module, exports) {

$parcel$export(module.exports, "extractRegexMatch", function () { return $3cfb7406d3c7486f$export$e3179c144dd71295; });
//#region src/domain/extractRegexMatch.ts
/**
* Executes a RegExp against a string and returns the first capture group, or the full match if
* there is no capture group. Returns undefined when the pattern does not match.
*/ function $3cfb7406d3c7486f$export$e3179c144dd71295(candidate, extractor) {
    extractor.lastIndex = 0;
    const regexResult = extractor.exec(candidate);
    if (!regexResult) return;
    const [match, capture] = regexResult;
    return capture ? capture : match;
}

});

parcelRegister("d6xBc", function(module, exports) {

$parcel$export(module.exports, "parseJsonPath", function () { return $7dcded5274613fe7$export$3bcc3f8beb4316ae; });
//#region src/domain/configuration/jsonPathParser.ts
/**
* Extract selectors from a simple JSON path expression, return [] for an invalid path
*
* Supports:
* - Dot notation: `foo.bar.baz`
* - Bracket notation: `['foo']["bar"]`
* - Array indices: `items[0]`, `data['users'][1]`
*
* Examples:
* parseJsonPath("['foo'].bar[12]")
* => ['foo', 'bar', '12']
*
* parseJsonPath("['foo")
* => []
*/ function $7dcded5274613fe7$export$3bcc3f8beb4316ae(path) {
    const selectors = [];
    let previousToken = 0;
    let currentToken;
    const parsingContext = {
        quote: void 0,
        escapeSequence: void 0
    };
    let currentSelector = "";
    for (const char of path){
        currentToken = $7dcded5274613fe7$var$ALLOWED_NEXT_TOKENS[previousToken].find((token)=>$7dcded5274613fe7$var$TOKEN_PREDICATE[token](char, parsingContext));
        if (!currentToken) return [];
        if (parsingContext.escapeSequence !== void 0 && currentToken !== 12) {
            if (!$7dcded5274613fe7$var$isValidEscapeSequence(parsingContext.escapeSequence)) return [];
            currentSelector += $7dcded5274613fe7$var$resolveEscapeSequence(parsingContext.escapeSequence);
            parsingContext.escapeSequence = void 0;
        }
        if ($7dcded5274613fe7$var$ALLOWED_SELECTOR_TOKENS.includes(currentToken)) currentSelector += char;
        else if ($7dcded5274613fe7$var$ALLOWED_SELECTOR_DELIMITER_TOKENS.includes(currentToken) && currentSelector !== "") {
            selectors.push(currentSelector);
            currentSelector = "";
        } else if (currentToken === 12) parsingContext.escapeSequence = parsingContext.escapeSequence ? `${parsingContext.escapeSequence}${char}` : char;
        else if (currentToken === 8) parsingContext.quote = char;
        else if (currentToken === 9) parsingContext.quote = void 0;
        previousToken = currentToken;
    }
    if (!$7dcded5274613fe7$var$ALLOWED_NEXT_TOKENS[previousToken].includes(1)) return [];
    if (currentSelector !== "") selectors.push(currentSelector);
    return selectors;
}
const $7dcded5274613fe7$var$NAME_SHORTHAND_FIRST_CHAR_REGEX = /[a-zA-Z_$]/;
const $7dcded5274613fe7$var$NAME_SHORTHAND_CHAR_REGEX = /[a-zA-Z0-9_$]/;
const $7dcded5274613fe7$var$DIGIT_REGEX = /[0-9]/;
const $7dcded5274613fe7$var$UNICODE_CHAR_REGEX = /[a-fA-F0-9]/;
const $7dcded5274613fe7$var$QUOTE_CHARS = "'\"";
const $7dcded5274613fe7$var$TOKEN_PREDICATE = {
    [0]: ()=>false,
    [1]: ()=>false,
    [2]: (char)=>$7dcded5274613fe7$var$NAME_SHORTHAND_FIRST_CHAR_REGEX.test(char),
    [3]: (char)=>$7dcded5274613fe7$var$NAME_SHORTHAND_CHAR_REGEX.test(char),
    [4]: (char)=>char === ".",
    [5]: (char)=>char === "[",
    [6]: (char)=>char === "]",
    [7]: (char)=>$7dcded5274613fe7$var$DIGIT_REGEX.test(char),
    [8]: (char)=>$7dcded5274613fe7$var$QUOTE_CHARS.includes(char),
    [9]: (char, parsingContext)=>char === parsingContext.quote,
    [10]: ()=>true,
    [11]: (char)=>char === "\\",
    [12]: (char, parsingContext)=>{
        if (parsingContext.escapeSequence === void 0) return `${parsingContext.quote}/\\bfnrtu`.includes(char);
        else if (parsingContext.escapeSequence.startsWith("u") && parsingContext.escapeSequence.length < 5) return $7dcded5274613fe7$var$UNICODE_CHAR_REGEX.test(char);
        return false;
    }
};
const $7dcded5274613fe7$var$ALLOWED_NEXT_TOKENS = {
    [0]: [
        2,
        5
    ],
    [1]: [],
    [2]: [
        3,
        4,
        5,
        1
    ],
    [3]: [
        3,
        4,
        5,
        1
    ],
    [4]: [
        2
    ],
    [5]: [
        8,
        7
    ],
    [6]: [
        4,
        5,
        1
    ],
    [7]: [
        7,
        6
    ],
    [8]: [
        11,
        9,
        10
    ],
    [9]: [
        6
    ],
    [10]: [
        11,
        9,
        10
    ],
    [11]: [
        12
    ],
    [12]: [
        12,
        11,
        9,
        10
    ]
};
const $7dcded5274613fe7$var$ALLOWED_SELECTOR_TOKENS = [
    2,
    3,
    7,
    10
];
const $7dcded5274613fe7$var$ALLOWED_SELECTOR_DELIMITER_TOKENS = [
    4,
    5,
    6
];
function $7dcded5274613fe7$var$isValidEscapeSequence(escapeSequence) {
    return "\"'/\\bfnrt".includes(escapeSequence) || escapeSequence.startsWith("u") && escapeSequence.length === 5;
}
const $7dcded5274613fe7$var$ESCAPED_CHARS = {
    "\"": "\"",
    "'": "'",
    "/": "/",
    "\\": "\\",
    b: "\b",
    f: "\f",
    n: "\n",
    r: "\r",
    t: "	"
};
function $7dcded5274613fe7$var$resolveEscapeSequence(escapeSequence) {
    if (escapeSequence.startsWith("u")) return String.fromCharCode(parseInt(escapeSequence.slice(1), 16));
    return $7dcded5274613fe7$var$ESCAPED_CHARS[escapeSequence];
}

});

parcelRegister("cHgkH", function(module, exports) {

$parcel$export(module.exports, "CACHE_STATUS_TO_METRIC_MAP", function () { return $6a59f83e17f9b5f5$export$e2bec058bb15cedd; });
$parcel$export(module.exports, "createConfigurationCache", function () { return $6a59f83e17f9b5f5$export$1446ba40939c73ee; });

var $1wrwm = parcelRequire("1wrwm");

var $bF5dI = parcelRequire("bF5dI");

var $bWkrj = parcelRequire("bWkrj");
var $brKlt = parcelRequire("brKlt");
const $6a59f83e17f9b5f5$export$d760c7627fae4639 = "dd_rc_";
const $6a59f83e17f9b5f5$export$e2bec058bb15cedd = {
    hit: "success",
    miss: "missing",
    error: "failure"
};
function $6a59f83e17f9b5f5$export$d7c1567adb5095ab(remoteConfigurationId) {
    return `${$6a59f83e17f9b5f5$export$d760c7627fae4639}${remoteConfigurationId}`;
}
function $6a59f83e17f9b5f5$var$isValidCacheEntry(value) {
    if (typeof value !== "object" || value === null) return false;
    const hasVersion = "version" in value && value.version === 3;
    const hasConfig = "config" in value && typeof value.config === "object" && value.config !== null;
    const hasMetadata = "metadata" in value && (0, $bF5dI.isIndexableObject)(value.metadata) && typeof value.metadata.syncId === "string" && typeof value.metadata.lastSynced === "number";
    return hasVersion && hasConfig && hasMetadata;
}
function $6a59f83e17f9b5f5$var$persist(key, entry) {
    try {
        localStorage.setItem(key, JSON.stringify(entry));
    } catch  {}
}
function $6a59f83e17f9b5f5$export$1446ba40939c73ee({ remoteConfigurationId: remoteConfigurationId }) {
    const key = $6a59f83e17f9b5f5$export$d7c1567adb5095ab(remoteConfigurationId);
    return {
        read () {
            let raw;
            try {
                raw = localStorage.getItem(key);
            } catch  {
                return {
                    status: "error"
                };
            }
            if (raw === null) return {
                status: "miss"
            };
            const parsed = (0, $brKlt.tryJsonParse)(raw);
            if (parsed === void 0) {
                this.remove();
                return {
                    status: "error"
                };
            }
            if (!$6a59f83e17f9b5f5$var$isValidCacheEntry(parsed)) {
                this.remove();
                return {
                    status: "error"
                };
            }
            return {
                status: "hit",
                config: parsed.config,
                metadata: parsed.metadata
            };
        },
        remove () {
            try {
                localStorage.removeItem(key);
            } catch  {}
        },
        write (config, lastModified) {
            const cached = this.read();
            if (cached.status === "hit" && JSON.stringify(cached.config) === JSON.stringify(config)) return;
            $6a59f83e17f9b5f5$var$persist(key, {
                version: 3,
                config: config,
                metadata: {
                    lastModified: lastModified,
                    lastSynced: (0, $1wrwm.timeStampNow)(),
                    syncId: (0, $bWkrj.generateUUID)()
                }
            });
        },
        /**
		* Records when this configuration version was first put into effect. Stamped on the first page
		* load that applies it, then reused by every later one, so the reported value marks a fixed
		* point in time instead of drifting with each page load.
		*/ stampFirstApplied (cached) {
            if (cached.metadata.firstApplied !== void 0) return cached.metadata;
            const metadata = {
                ...cached.metadata,
                firstApplied: (0, $1wrwm.timeStampNow)()
            };
            $6a59f83e17f9b5f5$var$persist(key, {
                version: 3,
                config: cached.config,
                metadata: metadata
            });
            return metadata;
        }
    };
}

});
parcelRegister("bWkrj", function(module, exports) {

$parcel$export(module.exports, "generateUUID", function () { return $a63a7573e2fbecd8$export$e73c8bd0f20705a; });
$parcel$export(module.exports, "findCommaSeparatedValue", function () { return $a63a7573e2fbecd8$export$fe87bb5193f3e70; });
$parcel$export(module.exports, "findAllCommaSeparatedValues", function () { return $a63a7573e2fbecd8$export$bdcfc1f2b1056fb7; });
$parcel$export(module.exports, "findCommaSeparatedValues", function () { return $a63a7573e2fbecd8$export$58032b923d63748e; });
$parcel$export(module.exports, "safeTruncate", function () { return $a63a7573e2fbecd8$export$b26462d2f74496cd; });
//#region src/tools/utils/stringUtils.ts
/**
* UUID v4
* from https://gist.github.com/jed/982883
*/ function $a63a7573e2fbecd8$export$e73c8bd0f20705a(placeholder) {
    return placeholder ? (parseInt(placeholder, 10) ^ Math.random() * 16 >> parseInt(placeholder, 10) / 4).toString(16) : `10000000-1000-4000-8000-100000000000`.replace(/[018]/g, $a63a7573e2fbecd8$export$e73c8bd0f20705a);
}
const $a63a7573e2fbecd8$var$COMMA_SEPARATED_KEY_VALUE = /(\S+?)\s*=\s*(.*?)(?:;|$)/g;
/**
* Returns the value of the key with the given name
* If there are multiple values with the same key, returns the first one
*/ function $a63a7573e2fbecd8$export$fe87bb5193f3e70(rawString, name) {
    $a63a7573e2fbecd8$var$COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    while(true){
        const match = $a63a7573e2fbecd8$var$COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            if (match[1] === name) return match[2];
        } else break;
    }
}
/**
* Returns a map of all the values with the given key
* If there are multiple values with the same key, returns all the values
*/ function $a63a7573e2fbecd8$export$bdcfc1f2b1056fb7(rawString) {
    const result = /* @__PURE__ */ new Map();
    $a63a7573e2fbecd8$var$COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    while(true){
        const match = $a63a7573e2fbecd8$var$COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            const key = match[1];
            const value = match[2];
            if (result.has(key)) result.get(key).push(value);
            else result.set(key, [
                value
            ]);
        } else break;
    }
    return result;
}
/**
* Returns a map of the values with the given key
* ⚠️ If there are multiple values with the same key, returns the LAST one
*
* @deprecated use `findAllCommaSeparatedValues()` instead
*/ function $a63a7573e2fbecd8$export$58032b923d63748e(rawString) {
    const result = /* @__PURE__ */ new Map();
    $a63a7573e2fbecd8$var$COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    while(true){
        const match = $a63a7573e2fbecd8$var$COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) result.set(match[1], match[2]);
        else break;
    }
    return result;
}
function $a63a7573e2fbecd8$export$b26462d2f74496cd(candidate, length, suffix = "") {
    const lastChar = candidate.charCodeAt(length - 1);
    const correctedLength = lastChar >= 55296 && lastChar <= 56319 ? length + 1 : length;
    if (candidate.length <= correctedLength) return candidate;
    return `${candidate.slice(0, correctedLength)}${suffix}`;
}
/**
* Builds a telemetry integration identifier from a library name and its version, e.g. `react-v18`
*/ function $a63a7573e2fbecd8$export$227ad293025fff71(name, version) {
    if (!version) return name;
    return `${name}-v${version.split(".")[0]}`;
}
/**
* Filters out falsy values and returns `undefined` if no integration is left, so plugins report a
* consistent "nothing to report" telemetry shape instead of an empty array.
*/ function $a63a7573e2fbecd8$export$8fb5287a60d065aa(...maybeIntegrations) {
    const integrations = maybeIntegrations.filter((integration)=>!!integration);
    return integrations.length > 0 ? integrations : void 0;
}

});


parcelRegister("aZWin", function(module, exports) {

$parcel$export(module.exports, "setCookie", function () { return $8c4c0835d24a595d$export$110700823644f4a6; });
$parcel$export(module.exports, "getCookie", function () { return $8c4c0835d24a595d$export$4be65e66cfa2648a; });
$parcel$export(module.exports, "getCookies", function () { return $8c4c0835d24a595d$export$f3eb5caaef7b2b34; });
$parcel$export(module.exports, "getInitCookie", function () { return $8c4c0835d24a595d$export$379e6c34a14280ba; });
$parcel$export(module.exports, "deleteCookie", function () { return $8c4c0835d24a595d$export$b43e45590305ffaa; });
$parcel$export(module.exports, "buildCookieOptions", function () { return $8c4c0835d24a595d$export$d037e740f60b1dc5; });

var $bWkrj = parcelRequire("bWkrj");

var $kRkcp = parcelRequire("kRkcp");
var $c2Qhr = parcelRequire("c2Qhr");

var $1wrwm = parcelRequire("1wrwm");
//#region src/browser/cookie.ts
function $8c4c0835d24a595d$export$110700823644f4a6(name, value, expireDelay = 0, options) {
    const date = /* @__PURE__ */ new Date();
    date.setTime(date.getTime() + expireDelay);
    const expires = `expires=${date.toUTCString()}`;
    const sameSite = options?.crossSite ? "none" : "strict";
    const domain = options?.domain ? `;domain=${options.domain}` : "";
    const secure = options?.secure ? ";secure" : "";
    const partitioned = options?.partitioned ? ";partitioned" : "";
    document.cookie = `${name}=${value};${expires};path=/;samesite=${sameSite}${domain}${secure}${partitioned}`;
}
/**
* Returns the value of the cookie with the given name
* If there are multiple cookies with the same name, returns the first one
*/ function $8c4c0835d24a595d$export$4be65e66cfa2648a(name) {
    const value = (0, $bWkrj.findCommaSeparatedValue)(document.cookie, name);
    if (value === "") return;
    return value;
}
/**
* Returns all the values of the cookies with the given name
*/ function $8c4c0835d24a595d$export$f3eb5caaef7b2b34(name) {
    return (0, $bWkrj.findAllCommaSeparatedValues)(document.cookie).get(name) || [];
}
let $8c4c0835d24a595d$var$initCookieParsed;
/**
* Returns a cached value of the cookie. Use this during SDK initialization (and whenever possible)
* to avoid accessing document.cookie multiple times.
*
* ⚠️ If there are multiple cookies with the same name, returns the LAST one (unlike `getCookie()`)
*/ function $8c4c0835d24a595d$export$379e6c34a14280ba(name) {
    if (!$8c4c0835d24a595d$var$initCookieParsed) $8c4c0835d24a595d$var$initCookieParsed = (0, $bWkrj.findCommaSeparatedValues)(document.cookie);
    return $8c4c0835d24a595d$var$initCookieParsed.get(name);
}
function $8c4c0835d24a595d$export$c97a852288b43516() {
    $8c4c0835d24a595d$var$initCookieParsed = void 0;
}
function $8c4c0835d24a595d$export$b43e45590305ffaa(name, options) {
    $8c4c0835d24a595d$export$110700823644f4a6(name, "", 0, options);
}
/**
* No API to retrieve it, number of levels for subdomain and suffix are unknown
* strategy: find the minimal domain on which cookies are allowed to be set
* https://web.dev/same-site-same-origin/#site
*/ let $8c4c0835d24a595d$var$getCurrentSiteCache;
function $8c4c0835d24a595d$export$8d7fb5ac3c42095(hostname = (0, $c2Qhr.globalObject).location?.hostname ?? "", referrer = typeof document !== "undefined" ? document.referrer : "") {
    if (typeof document === "undefined") return;
    if ($8c4c0835d24a595d$var$getCurrentSiteCache === void 0) {
        const defaultHostName = $8c4c0835d24a595d$var$getCookieDefaultHostName(hostname, referrer);
        if (defaultHostName) {
            const testCookieName = `dd_site_test_${(0, $bWkrj.generateUUID)()}`;
            const testCookieValue = "test";
            const domainLevels = defaultHostName.split(".");
            let candidateDomain = domainLevels.pop();
            while(domainLevels.length && !$8c4c0835d24a595d$export$4be65e66cfa2648a(testCookieName)){
                candidateDomain = `${domainLevels.pop()}.${candidateDomain}`;
                $8c4c0835d24a595d$export$110700823644f4a6(testCookieName, testCookieValue, (0, $1wrwm.ONE_SECOND), {
                    domain: candidateDomain
                });
            }
            $8c4c0835d24a595d$export$b43e45590305ffaa(testCookieName, {
                domain: candidateDomain
            });
            $8c4c0835d24a595d$var$getCurrentSiteCache = candidateDomain;
        }
    }
    return $8c4c0835d24a595d$var$getCurrentSiteCache;
}
function $8c4c0835d24a595d$var$getCookieDefaultHostName(hostname, referrer) {
    try {
        return hostname || (0, $kRkcp.buildUrl)(referrer).hostname;
    } catch  {}
}
function $8c4c0835d24a595d$export$d037e740f60b1dc5(configuration) {
    const cookieOptions = {};
    cookieOptions.secure = configuration.useSecureSessionCookie || configuration.usePartitionedCrossSiteSessionCookie;
    cookieOptions.crossSite = configuration.usePartitionedCrossSiteSessionCookie;
    cookieOptions.partitioned = configuration.usePartitionedCrossSiteSessionCookie;
    if (configuration.trackSessionAcrossSubdomains) {
        const currentSite = $8c4c0835d24a595d$export$8d7fb5ac3c42095();
        if (!currentSite) return;
        cookieOptions.domain = currentSite;
    }
    return cookieOptions;
}

});


parcelRegister("9O7SB", function(module, exports) {

$parcel$export(module.exports, "DefaultPrivacyLevel", function () { return $03e9636c20098f09$export$e8c12a778f5ad67c; });
$parcel$export(module.exports, "TraceContextInjection", function () { return $03e9636c20098f09$export$d060b603b6f9a5d5; });
$parcel$export(module.exports, "BROWSER_CORE_SCHEMA", function () { return $03e9636c20098f09$export$bf8eb7100b909799; });
$parcel$export(module.exports, "serializeConfiguration", function () { return $03e9636c20098f09$export$948cb0730656da11; });

var $efY2P = parcelRequire("efY2P");

var $hWYdN = parcelRequire("hWYdN");
//#region src/domain/configuration/configuration.ts
/**
* Default privacy level for the browser SDK.
*
* [Replay Privacy Options](https://docs.datadoghq.com/real_user_monitoring/session_replay/browser/privacy_options) for further information.
*/ const $03e9636c20098f09$export$e8c12a778f5ad67c = {
    ALLOW: "allow",
    MASK: "mask",
    MASK_USER_INPUT: "mask-user-input",
    MASK_UNLESS_ALLOWLISTED: "mask-unless-allowlisted"
};
/**
* Trace context injection option.
*
* See [Connect RUM and Traces](https://docs.datadoghq.com/real_user_monitoring/platform/connect_rum_and_traces/?tab=browserrum) for further information.
*/ const $03e9636c20098f09$export$d060b603b6f9a5d5 = {
    ALL: "all",
    SAMPLED: "sampled"
};
const $03e9636c20098f09$export$bf8eb7100b909799 = {
    clientToken: {
        type: "string",
        required: true
    },
    service: {
        type: "string"
    },
    env: {
        type: "string"
    },
    version: {
        type: "string"
    },
    site: {
        type: "site",
        default: (0, $hWYdN.INTAKE_SITE_US1)
    },
    proxy: {
        type: "union",
        variants: [
            {
                type: "string"
            },
            {
                type: "function",
                signature: void 0
            }
        ]
    },
    sessionSampleRate: {
        type: "percentage",
        default: 100
    },
    telemetrySampleRate: {
        type: "percentage",
        default: 20
    },
    telemetryConfigurationSampleRate: {
        type: "percentage",
        default: 5
    },
    telemetryUsageSampleRate: {
        type: "percentage",
        default: 5
    },
    silentMultipleInit: {
        type: "boolean",
        default: false,
        strict: false
    },
    storeContextsAcrossPages: {
        type: "boolean",
        default: false,
        strict: false
    },
    trackAnonymousUser: {
        type: "boolean",
        default: true,
        strict: false
    },
    useSecureSessionCookie: {
        type: "boolean",
        default: false,
        strict: false
    },
    usePartitionedCrossSiteSessionCookie: {
        type: "boolean",
        default: false,
        strict: false
    },
    trackSessionAcrossSubdomains: {
        type: "boolean",
        default: false,
        strict: false
    },
    allowedTrackingOrigins: {
        type: "match-option",
        multiple: true,
        strict: false
    },
    trackingConsent: {
        type: "enum",
        values: (0, $efY2P.TrackingConsent),
        default: (0, $efY2P.TrackingConsent).GRANTED
    },
    beforeSend: {
        type: "function",
        signature: void 0
    },
    source: {
        type: "enum",
        values: [
            "browser",
            "flutter",
            "unity"
        ],
        default: "browser",
        strict: false
    },
    sessionPersistence: {
        type: "enum",
        values: [
            "cookie",
            "local-storage",
            "memory"
        ],
        multiple: true,
        strict: false
    },
    replica: {
        type: "schema",
        schema: {
            clientToken: {
                type: "string",
                required: true
            },
            applicationId: {
                type: "string"
            }
        }
    },
    datacenter: {
        type: "string"
    },
    sdkVersion: {
        type: "string"
    },
    variant: {
        type: "string"
    }
};
function $03e9636c20098f09$export$948cb0730656da11(initConfiguration) {
    return {
        session_sample_rate: initConfiguration.sessionSampleRate,
        telemetry_sample_rate: initConfiguration.telemetrySampleRate,
        telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
        telemetry_usage_sample_rate: initConfiguration.telemetryUsageSampleRate,
        use_before_send: !!initConfiguration.beforeSend,
        use_partitioned_cross_site_session_cookie: initConfiguration.usePartitionedCrossSiteSessionCookie,
        use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
        use_proxy: !!initConfiguration.proxy,
        silent_multiple_init: initConfiguration.silentMultipleInit,
        track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
        track_anonymous_user: initConfiguration.trackAnonymousUser,
        session_persistence: Array.isArray(initConfiguration.sessionPersistence) ? initConfiguration.sessionPersistence[0] : initConfiguration.sessionPersistence,
        store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
        allow_untrusted_events: !!initConfiguration.allowUntrustedEvents,
        tracking_consent: initConfiguration.trackingConsent,
        use_allowed_tracking_origins: Array.isArray(initConfiguration.allowedTrackingOrigins),
        source: initConfiguration.source,
        sdk_version: initConfiguration.sdkVersion,
        variant: initConfiguration.variant
    };
}

});
parcelRegister("efY2P", function(module, exports) {

$parcel$export(module.exports, "TrackingConsent", function () { return $89b3308f775ec771$export$52745dd8ee2d32b2; });
$parcel$export(module.exports, "createTrackingConsentState", function () { return $89b3308f775ec771$export$6a999af43d888e18; });

var $fnvkG = parcelRequire("fnvkG");
//#region src/domain/trackingConsent.ts
const $89b3308f775ec771$export$52745dd8ee2d32b2 = {
    GRANTED: "granted",
    NOT_GRANTED: "not-granted"
};
function $89b3308f775ec771$export$6a999af43d888e18(currentConsent) {
    const observable = new (0, $fnvkG.Observable)();
    function isGranted() {
        return currentConsent === $89b3308f775ec771$export$52745dd8ee2d32b2.GRANTED;
    }
    return {
        tryToInit (trackingConsent) {
            if (!currentConsent) currentConsent = trackingConsent;
        },
        onGrantedOnce (fn) {
            if (isGranted()) fn();
            else {
                const subscription = observable.subscribe(()=>{
                    if (isGranted()) {
                        fn();
                        subscription.unsubscribe();
                    }
                });
            }
        },
        update (trackingConsent) {
            currentConsent = trackingConsent;
            observable.notify();
        },
        isGranted: isGranted,
        observable: observable
    };
}

});


parcelRegister("4wo62", function(module, exports) {

$parcel$export(module.exports, "catchUserErrors", function () { return $0a3509661b3f3ed5$export$a7d71543eda007d0; });

var $jq8c3 = parcelRequire("jq8c3");
//#region src/tools/catchUserErrors.ts
function $0a3509661b3f3ed5$export$a7d71543eda007d0(fn, errorMsg) {
    return (...args)=>{
        try {
            return fn(...args);
        } catch (err) {
            (0, $jq8c3.display).error(errorMsg, err);
        }
    };
}

});

parcelRegister("5kKbc", function(module, exports) {

$parcel$export(module.exports, "removeItem", function () { return $498dfbdca9452e1f$export$fe2d9b4e03920b4c; });
$parcel$export(module.exports, "isNonEmptyArray", function () { return $498dfbdca9452e1f$export$d307f5934e447d0e; });
//#region src/tools/utils/arrayUtils.ts
function $498dfbdca9452e1f$export$2e2262a44ac61957(array) {
    const set = /* @__PURE__ */ new Set();
    array.forEach((item)=>set.add(item));
    return Array.from(set);
}
function $498dfbdca9452e1f$export$fe2d9b4e03920b4c(array, item) {
    const index = array.indexOf(item);
    if (index >= 0) array.splice(index, 1);
}
function $498dfbdca9452e1f$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}
function $498dfbdca9452e1f$export$9826fe7ad3921016(current, next) {
    if (!next?.length) return current;
    return current ? current.concat(next) : next;
}

});

parcelRegister("eQWMG", function(module, exports) {

$parcel$export(module.exports, "round", function () { return $43f70fde2530df06$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "isNumber", function () { return $43f70fde2530df06$export$7e4aa119212bc614; });
//#region src/tools/utils/numberUtils.ts
function $43f70fde2530df06$export$2077e0241d6afd3c(num, decimals) {
    return +num.toFixed(decimals);
}
function $43f70fde2530df06$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}

});

parcelRegister("b6w9H", function(module, exports) {

$parcel$export(module.exports, "validateAndBuildConfiguration", function () { return $11a6c8263c7a8e06$export$bb3dd6b9741fea90; });

var $bF5dI = parcelRequire("bF5dI");

var $5tXxv = parcelRequire("5tXxv");

var $6PIx8 = parcelRequire("6PIx8");
//#region src/entries/configuration.ts
function $11a6c8263c7a8e06$var$buildErrorMessage(key, field) {
    switch(field.type){
        case "string":
            return `"${key}" must be a non-empty string`;
        case "number":
            if (field.min !== void 0 && field.max !== void 0) return `"${key}" must be a number between ${field.min} and ${field.max}`;
            if (field.min !== void 0) return `"${key}" must be a number greater than or equal to ${field.min}`;
            if (field.max !== void 0) return `"${key}" must be a number less than or equal to ${field.max}`;
            return `"${key}" must be a finite number`;
        case "percentage":
            return `"${key}" must be a number between 0 and 100`;
        case "boolean":
            return `"${key}" must be a boolean`;
        case "site":
            return `"${key}" must be a valid Datadog site. ${0, $6PIx8.MORE_DETAILS} ${0, $6PIx8.DOCS_ORIGIN}/getting_started/site/.`;
        case "match-option":
            return `"${key}" must be a string, RegExp, or function`;
        case "enum":
            return `"${key}" must be one of: "${$11a6c8263c7a8e06$var$getEnumValues(field.values).join("\", \"")}"`;
        case "union":
            return `"${key}" does not match any expected type`;
        case "schema":
            return `"${key}" is not a valid object`;
        case "function":
            return `"${key}" must be a function`;
    }
}
/**
* Validates a raw init configuration object against a {@link ConfigurationSchema} and builds
* the corresponding {@link InferredConfig}. Use this to derive a schema-driven configuration
* builder for a package (e.g. `validateAndBuildRumConfiguration`) instead of writing
* per-field validation by hand.
*
* @param initConfig - The raw, untrusted configuration object provided by the SDK consumer.
* @param schema - The {@link ConfigurationSchema} describing every field to validate.
* @param display - Optional error reporter; when provided, validation failures are reported
* through `display.error` with a message naming the offending field.
* @returns The validated, defaulted configuration, or `undefined` if `initConfig` is missing
* or a required/strict field failed validation.
*/ function $11a6c8263c7a8e06$export$bb3dd6b9741fea90(initConfig, schema, display) {
    if (!initConfig || typeof initConfig !== "object") {
        display.error("Configuration must be an object");
        return;
    }
    return $11a6c8263c7a8e06$var$validateSchemaFields(schema, initConfig, display);
}
/**
* Validates every field of `schema` against `rawConfig`. Shared by {@link validateAndBuildConfiguration}
* and nested `type: 'schema'` field validation. `display` is threaded down into nested fields
* (`type: 'schema'`, `type: 'union'`, `multiple: true`) so a nested validation failure reports
* its own specific message, in addition to the outer field's generic message.
*/ function $11a6c8263c7a8e06$var$validateSchemaFields(schema, rawConfig, display) {
    const result = {};
    for (const [key, field] of Object.entries(schema)){
        const rawValue = rawConfig[key];
        const validated = field.multiple ? $11a6c8263c7a8e06$var$validateArrayField(field, rawValue, display) : $11a6c8263c7a8e06$var$validateField(field, rawValue, display);
        if (validated === void 0) {
            if (rawValue !== void 0 && rawValue !== null && rawValue !== "") {
                display.error($11a6c8263c7a8e06$var$buildErrorMessage(key, field));
                if (field.required || field.strict !== false) return;
            } else if (field.required) {
                display.error(`"${key}" is required`);
                return;
            }
            result[key] = "default" in field ? (0, $5tXxv.deepClone)(field.default) : void 0;
        } else result[key] = validated;
    }
    return result;
}
function $11a6c8263c7a8e06$var$validateArrayField(field, value, display) {
    if (value === void 0 || value === null) return;
    if (field.type === "enum" && field.allowAll && value === "all") return $11a6c8263c7a8e06$var$getEnumValues(field.values).slice();
    const items = Array.isArray(value) ? value : [
        value
    ];
    const results = [];
    for (const item of items){
        const validated = $11a6c8263c7a8e06$var$validateField(field, item, display);
        if (validated === void 0) {
            if (field.strict !== false) return;
        } else results.push(validated);
    }
    if (field.strict === false && results.length === 0 && items.length > 0) return;
    return results;
}
const $11a6c8263c7a8e06$var$DATADOG_SITE_REGEX = /(datadog|ddog|datad0g|dd0g)/;
function $11a6c8263c7a8e06$var$validateField(field, value, display) {
    if (field.type === "schema") {
        if (typeof value !== "object" || value === null) return;
        return $11a6c8263c7a8e06$var$validateSchemaFields(field.schema, value, display);
    }
    if (field.type === "union") {
        if (value === void 0 || value === null) return;
        for (const variant of field.variants){
            const result = $11a6c8263c7a8e06$var$validateField(variant, value, display);
            if (result !== void 0) return result;
        }
        return;
    }
    if (value === void 0 || value === null) return;
    switch(field.type){
        case "function":
            return typeof value === "function" ? value : void 0;
        case "string":
            return typeof value === "string" && value.length > 0 ? value : void 0;
        case "number":
            return typeof value === "number" && Number.isFinite(value) && (field.min === void 0 || value >= field.min) && (field.max === void 0 || value <= field.max) ? value : void 0;
        case "percentage":
            return (0, $bF5dI.isPercentage)(value) ? value : void 0;
        case "boolean":
            return typeof value === "boolean" ? value : field.strict === false ? !!value : void 0;
        case "site":
            if (typeof value !== "string" || !$11a6c8263c7a8e06$var$DATADOG_SITE_REGEX.test(value)) return;
            return value;
        case "match-option":
            return (0, $bF5dI.isMatchOption)(value) ? value : void 0;
        case "enum":
            return typeof value === "string" && $11a6c8263c7a8e06$var$getEnumValues(field.values).includes(value) ? value : void 0;
    }
}
function $11a6c8263c7a8e06$var$getEnumValues(values) {
    return $11a6c8263c7a8e06$var$isReadonlyStringArray(values) ? values : Object.values(values);
}
function $11a6c8263c7a8e06$var$isReadonlyStringArray(value) {
    return Array.isArray(value);
}

});


parcelRegister("laTCl", function(module, exports) {

var $cHgkH = parcelRequire("cHgkH");

var $e6c5e = parcelRequire("e6c5e");

var $iVgUy = parcelRequire("iVgUy");

});

parcelRegister("kmm0x", function(module, exports) {

$parcel$export(module.exports, "createHooks", function () { return $8bdd766b3475c0ee$export$39c6a2b4dbabca5d; });

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/hooks.ts
function $8bdd766b3475c0ee$export$39c6a2b4dbabca5d() {
    return {
        assembleEventDefaults: (0, $fNtjE.createHook)(),
        assembleTelemetry: (0, $fNtjE.createHook)(),
        assembleEvent: (0, $fNtjE.createHook)()
    };
}

});

parcelRegister("46UCk", function(module, exports) {

$parcel$export(module.exports, "createDOMMutationObservable", function () { return $5bb61c1d6990c333$export$e0f9a2ab04194dff; });
$parcel$export(module.exports, "getMutationObserverConstructor", function () { return $5bb61c1d6990c333$export$e4f8ebbdf64ea982; });

var $hu8Xq = parcelRequire("hu8Xq");
var $hH6Lc = parcelRequire("hH6Lc");
var $fnvkG = parcelRequire("fnvkG");

var $dee0n = parcelRequire("dee0n");
//#region src/browser/domMutationObservable.ts
function $5bb61c1d6990c333$export$e0f9a2ab04194dff() {
    const MutationObserver = $5bb61c1d6990c333$export$e4f8ebbdf64ea982();
    return new (0, $fnvkG.Observable)((observable)=>{
        const observer = new MutationObserver((0, $dee0n.monitor)((records)=>observable.notify(records)));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true
        });
        return ()=>observer.disconnect();
    });
}
function $5bb61c1d6990c333$export$e4f8ebbdf64ea982() {
    let constructor;
    const browserWindow = window;
    if (browserWindow.Zone) {
        constructor = (0, $hu8Xq.getZoneJsOriginalValue)(browserWindow, "MutationObserver");
        if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
            const patchedInstance = new browserWindow.MutationObserver((0, $hH6Lc.noop));
            constructor = (0, $hu8Xq.getZoneJsOriginalValue)(patchedInstance, "originalInstance")?.constructor;
        }
    }
    if (!constructor) constructor = browserWindow.MutationObserver;
    return constructor;
}

});

parcelRegister("jNZRV", function(module, exports) {

$parcel$export(module.exports, "LifeCycleEventType", function () { return $2b075f5309f064d1$export$b21eaca6c6da9627; });
$parcel$export(module.exports, "LifeCycle", function () { return $2b075f5309f064d1$export$6af70476896cbaec; });

var $dcbEk = parcelRequire("dcbEk");
//#region src/domain/lifeCycle.ts
let $2b075f5309f064d1$export$b21eaca6c6da9627 = /* @__PURE__ */ function(LifeCycleEventType) {
    LifeCycleEventType[LifeCycleEventType["AUTO_ACTION_COMPLETED"] = 0] = "AUTO_ACTION_COMPLETED";
    LifeCycleEventType[LifeCycleEventType["BEFORE_VIEW_CREATED"] = 1] = "BEFORE_VIEW_CREATED";
    LifeCycleEventType[LifeCycleEventType["VIEW_CREATED"] = 2] = "VIEW_CREATED";
    LifeCycleEventType[LifeCycleEventType["BEFORE_VIEW_UPDATED"] = 3] = "BEFORE_VIEW_UPDATED";
    LifeCycleEventType[LifeCycleEventType["VIEW_UPDATED"] = 4] = "VIEW_UPDATED";
    LifeCycleEventType[LifeCycleEventType["VIEW_ENDED"] = 5] = "VIEW_ENDED";
    LifeCycleEventType[LifeCycleEventType["AFTER_VIEW_ENDED"] = 6] = "AFTER_VIEW_ENDED";
    LifeCycleEventType[LifeCycleEventType["REQUEST_STARTED"] = 7] = "REQUEST_STARTED";
    LifeCycleEventType[LifeCycleEventType["REQUEST_COMPLETED"] = 8] = "REQUEST_COMPLETED";
    LifeCycleEventType[LifeCycleEventType["WEBSOCKET_COMPLETED"] = 9] = "WEBSOCKET_COMPLETED";
    LifeCycleEventType[LifeCycleEventType["SESSION_EXPIRED"] = 10] = "SESSION_EXPIRED";
    LifeCycleEventType[LifeCycleEventType["SESSION_RENEWED"] = 11] = "SESSION_RENEWED";
    LifeCycleEventType[LifeCycleEventType["PREPARE_URGENT_FLUSH"] = 12] = "PREPARE_URGENT_FLUSH";
    LifeCycleEventType[LifeCycleEventType["RAW_RUM_EVENT_COLLECTED"] = 13] = "RAW_RUM_EVENT_COLLECTED";
    LifeCycleEventType[LifeCycleEventType["RUM_EVENT_COLLECTED"] = 14] = "RUM_EVENT_COLLECTED";
    LifeCycleEventType[LifeCycleEventType["RAW_ERROR_COLLECTED"] = 15] = "RAW_ERROR_COLLECTED";
    LifeCycleEventType[LifeCycleEventType["ACTION_STARTED"] = 16] = "ACTION_STARTED";
    LifeCycleEventType[LifeCycleEventType["DURATION_VITAL_STARTED"] = 17] = "DURATION_VITAL_STARTED";
    return LifeCycleEventType;
}({});
const $2b075f5309f064d1$export$6af70476896cbaec = (0, $dcbEk.AbstractLifeCycle);

});
parcelRegister("dcbEk", function(module, exports) {

$parcel$export(module.exports, "AbstractLifeCycle", function () { return $06a4144c3a6e4c74$export$cf0c49d09be0ebd8; });
//#region src/tools/abstractLifeCycle.ts
var $06a4144c3a6e4c74$export$cf0c49d09be0ebd8 = class {
    constructor(){
        this.callbacks = {};
    }
    notify(eventType, data) {
        const eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) eventCallbacks.forEach((callback)=>callback(data));
    }
    subscribe(eventType, callback) {
        if (!this.callbacks[eventType]) this.callbacks[eventType] = [];
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: ()=>{
                this.callbacks[eventType] = this.callbacks[eventType].filter((other)=>callback !== other);
            }
        };
    }
};

});


parcelRegister("80kZV", function(module, exports) {

$parcel$export(module.exports, "startViewHistory", function () { return $32061313c4832364$export$268034a9c98ba695; });
parcelRequire("jNZRV");

var $boqsR = parcelRequire("boqsR");
var $aWbFv = parcelRequire("aWbFv");
//#region src/domain/contexts/viewHistory.ts
const $32061313c4832364$export$f12c747a768c817c = (0, $aWbFv.SESSION_TIME_OUT_DELAY);
function $32061313c4832364$export$268034a9c98ba695(lifeCycle) {
    const viewValueHistory = (0, $boqsR.createValueHistory)({
        expireDelay: $32061313c4832364$export$f12c747a768c817c
    });
    lifeCycle.subscribe(1, (view)=>{
        viewValueHistory.add(buildViewHistoryEntry(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(6, ({ endClocks: endClocks })=>{
        viewValueHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(3, (viewUpdate)=>{
        const currentView = viewValueHistory.find(viewUpdate.startClocks.relative);
        if (!currentView) return;
        if (viewUpdate.name) currentView.name = viewUpdate.name;
        if (viewUpdate.context) currentView.context = viewUpdate.context;
        currentView.sessionIsActive = viewUpdate.sessionIsActive;
    });
    lifeCycle.subscribe(11, ()=>{
        viewValueHistory.reset();
    });
    function buildViewHistoryEntry(view) {
        return {
            service: view.service,
            version: view.version,
            context: view.context,
            id: view.id,
            name: view.name,
            startClocks: view.startClocks
        };
    }
    return {
        findView: (startTime, options)=>viewValueHistory.find(startTime, options),
        stop: ()=>{
            viewValueHistory.stop();
        }
    };
}

});
parcelRegister("boqsR", function(module, exports) {

$parcel$export(module.exports, "createValueHistory", function () { return $85df85ddf4af46e3$export$74da638c6075b86; });

var $foX5P = parcelRequire("foX5P");

var $5kKbc = parcelRequire("5kKbc");

var $1wrwm = parcelRequire("1wrwm");
//#region src/tools/valueHistory.ts
const $85df85ddf4af46e3$var$END_OF_TIMES = Infinity;
const $85df85ddf4af46e3$export$7cf440d5901bea64 = (0, $1wrwm.ONE_MINUTE);
let $85df85ddf4af46e3$var$cleanupHistoriesInterval;
const $85df85ddf4af46e3$var$cleanupTasks = /* @__PURE__ */ new Set();
function $85df85ddf4af46e3$var$cleanupHistories() {
    $85df85ddf4af46e3$var$cleanupTasks.forEach((task)=>task());
}
function $85df85ddf4af46e3$export$74da638c6075b86({ expireDelay: expireDelay, maxEntries: maxEntries }) {
    let entries = [];
    const clearExpiredValues = ()=>{
        if (!expireDelay) return;
        const oldTimeThreshold = (0, $1wrwm.relativeNow)() - expireDelay;
        while(entries.length > 0 && entries[entries.length - 1].endTime < oldTimeThreshold)entries.pop();
    };
    if (expireDelay) {
        if (!$85df85ddf4af46e3$var$cleanupHistoriesInterval) $85df85ddf4af46e3$var$cleanupHistoriesInterval = (0, $foX5P.setInterval)(()=>$85df85ddf4af46e3$var$cleanupHistories(), $85df85ddf4af46e3$export$7cf440d5901bea64);
        $85df85ddf4af46e3$var$cleanupTasks.add(clearExpiredValues);
    }
    /**
	* Add a value to the history associated with a start time. Returns a reference to this newly
	* added entry that can be removed or closed.
	*/ function add(value, startTime) {
        const entry = {
            value: value,
            startTime: startTime,
            endTime: $85df85ddf4af46e3$var$END_OF_TIMES,
            remove: ()=>{
                (0, $5kKbc.removeItem)(entries, entry);
            },
            close: (endTime)=>{
                entry.endTime = endTime;
            }
        };
        if (maxEntries && entries.length >= maxEntries) entries.pop();
        entries.unshift(entry);
        return entry;
    }
    /**
	* Return the latest value that was active during `startTime`, or the currently active value
	* if no `startTime` is provided. This method assumes that entries are not overlapping.
	*
	* If `option.returnInactive` is true, returns the value at `startTime` (active or not).
	*/ function find(startTime = $85df85ddf4af46e3$var$END_OF_TIMES, options = {
        returnInactive: false
    }) {
        for (const entry of entries)if (entry.startTime <= startTime) {
            if (options.returnInactive || startTime <= entry.endTime) return entry.value;
            break;
        }
    }
    /**
	* Helper function to close the currently active value, if any. This method assumes that entries
	* are not overlapping.
	*/ function closeActive(endTime) {
        const latestEntry = entries[0];
        if (latestEntry?.endTime === $85df85ddf4af46e3$var$END_OF_TIMES) latestEntry.close(endTime);
    }
    /**
	* Return all values with an active period overlapping with the duration,
	* or all values that were active during `startTime` if no duration is provided,
	* or all currently active values if no `startTime` is provided.
	*/ function findAll(startTime = $85df85ddf4af46e3$var$END_OF_TIMES, duration = 0) {
        const endTime = (0, $1wrwm.addDuration)(startTime, duration);
        return entries.filter((entry)=>entry.startTime <= endTime && startTime <= entry.endTime).map((entry)=>entry.value);
    }
    /**
	* Return all entries with an active period overlapping with the duration,
	* or all entries that were active during `startTime` if no duration is provided,
	* or all currently active entries if no `startTime` is provided.
	*/ function findAllEntries(startTime = $85df85ddf4af46e3$var$END_OF_TIMES, duration = 0) {
        const endTime = (0, $1wrwm.addDuration)(startTime, duration);
        return entries.filter((entry)=>entry.startTime <= endTime && startTime <= entry.endTime);
    }
    /**
	* Return all the entries whose start time is equal to the given startTime.
	*/ function getEntries(startTime) {
        return entries.filter((entry)=>entry.startTime === startTime);
    }
    /**
	* Remove all entries from this collection.
	*/ function reset() {
        entries = [];
    }
    /**
	* Stop internal garbage collection of past entries.
	*/ function stop() {
        $85df85ddf4af46e3$var$cleanupTasks.delete(clearExpiredValues);
        if ($85df85ddf4af46e3$var$cleanupTasks.size === 0 && $85df85ddf4af46e3$var$cleanupHistoriesInterval) {
            (0, $foX5P.clearInterval)($85df85ddf4af46e3$var$cleanupHistoriesInterval);
            $85df85ddf4af46e3$var$cleanupHistoriesInterval = void 0;
        }
    }
    return {
        add: add,
        find: find,
        closeActive: closeActive,
        findAll: findAll,
        findAllEntries: findAllEntries,
        getEntries: getEntries,
        reset: reset,
        stop: stop
    };
}

});

parcelRegister("aWbFv", function(module, exports) {

$parcel$export(module.exports, "SESSION_TIME_OUT_DELAY", function () { return $b7a85fae3c81fbc0$export$324def7afe89d7e8; });
$parcel$export(module.exports, "SESSION_EXPIRATION_DELAY", function () { return $b7a85fae3c81fbc0$export$481fdd126dba0912; });
$parcel$export(module.exports, "SESSION_COOKIE_EXPIRATION_DELAY", function () { return $b7a85fae3c81fbc0$export$39360b0e14efae23; });
$parcel$export(module.exports, "SessionPersistence", function () { return $b7a85fae3c81fbc0$export$6b08240aba869f7e; });

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/session/sessionConstants.ts
const $b7a85fae3c81fbc0$export$324def7afe89d7e8 = 4 * (0, $1wrwm.ONE_HOUR);
const $b7a85fae3c81fbc0$export$481fdd126dba0912 = 15 * (0, $1wrwm.ONE_MINUTE);
const $b7a85fae3c81fbc0$export$39360b0e14efae23 = (0, $1wrwm.ONE_YEAR);
const $b7a85fae3c81fbc0$export$b63d4ae1bc652a1b = "0";
/**
* @internal
*/ const $b7a85fae3c81fbc0$export$6b08240aba869f7e = {
    COOKIE: "cookie",
    MEMORY: "memory",
    LOCAL_STORAGE: "local-storage"
};

});


parcelRegister("38LZB", function(module, exports) {

$parcel$export(module.exports, "computeResourceEntryType", function () { return $e719b4893434fd4f$export$874b6cde352e515a; });
$parcel$export(module.exports, "isResourceEntryRequestType", function () { return $e719b4893434fd4f$export$a5878f59e3ee2e9f; });
$parcel$export(module.exports, "computeResourceEntryDuration", function () { return $e719b4893434fd4f$export$e10d69e2d9b371b6; });
$parcel$export(module.exports, "computeResourceEntryDetails", function () { return $e719b4893434fd4f$export$a8cdd6a8741b9542; });
$parcel$export(module.exports, "hasValidResourceEntryDuration", function () { return $e719b4893434fd4f$export$bb48f5f5ee2d8ac6; });
$parcel$export(module.exports, "computeResourceEntryProtocol", function () { return $e719b4893434fd4f$export$628529093947cac8; });
$parcel$export(module.exports, "computeResourceEntryDeliveryType", function () { return $e719b4893434fd4f$export$f83ec67aa945dcf6; });
$parcel$export(module.exports, "computeResourceEntrySize", function () { return $e719b4893434fd4f$export$9207ac338b648dd5; });
$parcel$export(module.exports, "isAllowedRequestUrl", function () { return $e719b4893434fd4f$export$c298da523d6ed600; });
$parcel$export(module.exports, "sanitizeIfLongDataUrl", function () { return $e719b4893434fd4f$export$a7d3956fe6ae6a3d; });

var $1wrwm = parcelRequire("1wrwm");

var $kRkcp = parcelRequire("kRkcp");

var $fOYzt = parcelRequire("fOYzt");
var $iXofQ = parcelRequire("iXofQ");

var $hWYdN = parcelRequire("hWYdN");
//#region src/domain/resource/resourceUtils.ts
const $e719b4893434fd4f$var$RESOURCE_TYPES = [
    [
        (0, $iXofQ.ResourceType).DOCUMENT,
        (initiatorType)=>"navigation" === initiatorType
    ],
    [
        (0, $iXofQ.ResourceType).XHR,
        (initiatorType)=>"xmlhttprequest" === initiatorType
    ],
    [
        (0, $iXofQ.ResourceType).FETCH,
        (initiatorType)=>"fetch" === initiatorType
    ],
    [
        (0, $iXofQ.ResourceType).BEACON,
        (initiatorType)=>"beacon" === initiatorType
    ],
    [
        (0, $iXofQ.ResourceType).CSS,
        (_, path)=>/\.css$/i.test(path)
    ],
    [
        (0, $iXofQ.ResourceType).JS,
        (_, path)=>/\.js$/i.test(path)
    ],
    [
        (0, $iXofQ.ResourceType).IMAGE,
        (initiatorType, path)=>[
                "image",
                "img",
                "icon"
            ].includes(initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null
    ],
    [
        (0, $iXofQ.ResourceType).FONT,
        (_, path)=>/\.(woff|eot|woff2|ttf)$/i.exec(path) !== null
    ],
    [
        (0, $iXofQ.ResourceType).MEDIA,
        (initiatorType, path)=>[
                "audio",
                "video"
            ].includes(initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null
    ]
];
function $e719b4893434fd4f$export$874b6cde352e515a(entry) {
    const url = entry.name;
    if (!(0, $kRkcp.isValidUrl)(url)) return (0, $iXofQ.ResourceType).OTHER;
    const path = (0, $kRkcp.getPathName)(url);
    for (const [type, isType] of $e719b4893434fd4f$var$RESOURCE_TYPES)if (isType(entry.initiatorType, path)) return type;
    return (0, $iXofQ.ResourceType).OTHER;
}
function $e719b4893434fd4f$var$areInOrder(...numbers) {
    for(let i = 1; i < numbers.length; i += 1)if (numbers[i - 1] > numbers[i]) return false;
    return true;
}
function $e719b4893434fd4f$export$a5878f59e3ee2e9f(entry) {
    return entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch";
}
function $e719b4893434fd4f$export$e10d69e2d9b371b6(entry) {
    const { duration: duration, startTime: startTime, responseEnd: responseEnd } = entry;
    if (entry.initiatorType === "navigation" || duration === 0 && startTime < responseEnd) return (0, $1wrwm.elapsed)(startTime, responseEnd);
    return duration;
}
function $e719b4893434fd4f$export$a8cdd6a8741b9542(entry) {
    if (!$e719b4893434fd4f$export$c07d151c23cfeb06(entry)) return;
    const { startTime: startTime, fetchStart: fetchStart, workerStart: workerStart, redirectStart: redirectStart, redirectEnd: redirectEnd, domainLookupStart: domainLookupStart, domainLookupEnd: domainLookupEnd, connectStart: connectStart, secureConnectionStart: secureConnectionStart, connectEnd: connectEnd, requestStart: requestStart, responseStart: responseStart, responseEnd: responseEnd } = entry;
    const details = {
        download: $e719b4893434fd4f$var$formatTiming(startTime, responseStart, responseEnd),
        first_byte: $e719b4893434fd4f$var$formatTiming(startTime, requestStart, responseStart)
    };
    if (0 < workerStart && workerStart < fetchStart) details.worker = $e719b4893434fd4f$var$formatTiming(startTime, workerStart, fetchStart);
    if (fetchStart < connectEnd) {
        details.connect = $e719b4893434fd4f$var$formatTiming(startTime, connectStart, connectEnd);
        if (connectStart <= secureConnectionStart && secureConnectionStart <= connectEnd) details.ssl = $e719b4893434fd4f$var$formatTiming(startTime, secureConnectionStart, connectEnd);
    }
    if (fetchStart < domainLookupEnd) details.dns = $e719b4893434fd4f$var$formatTiming(startTime, domainLookupStart, domainLookupEnd);
    if (startTime < redirectEnd) details.redirect = $e719b4893434fd4f$var$formatTiming(startTime, redirectStart, redirectEnd);
    return details;
}
/**
* Entries with negative duration are unexpected and should be dismissed. The intake will ignore RUM
* Resource events with negative durations anyway.
* Since Chromium 128, more entries have unexpected negative durations, see
* https://issues.chromium.org/issues/363031537
*/ function $e719b4893434fd4f$export$bb48f5f5ee2d8ac6(entry) {
    return entry.duration >= 0;
}
function $e719b4893434fd4f$export$c07d151c23cfeb06(entry) {
    const areCommonTimingsInOrder = $e719b4893434fd4f$var$areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd);
    const areRedirectionTimingsInOrder = $e719b4893434fd4f$var$hasRedirection(entry) ? $e719b4893434fd4f$var$areInOrder(entry.startTime, entry.redirectStart, entry.redirectEnd, entry.fetchStart) : true;
    return areCommonTimingsInOrder && areRedirectionTimingsInOrder;
}
function $e719b4893434fd4f$var$hasRedirection(entry) {
    return entry.redirectEnd > entry.startTime;
}
function $e719b4893434fd4f$var$formatTiming(origin, start, end) {
    if (origin <= start && start <= end) return {
        duration: (0, $1wrwm.toServerDuration)((0, $1wrwm.elapsed)(start, end)),
        start: (0, $1wrwm.toServerDuration)((0, $1wrwm.elapsed)(origin, start))
    };
}
/**
* The 'nextHopProtocol' is an empty string for cross-origin resources without CORS headers,
* meaning the protocol is unknown, and we shouldn't report it.
* https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/nextHopProtocol#cross-origin_resources
*/ function $e719b4893434fd4f$export$628529093947cac8(entry) {
    return entry.nextHopProtocol === "" ? void 0 : entry.nextHopProtocol;
}
/**
* Handles the 'deliveryType' property to distinguish between supported values ('cache', 'navigational-prefetch'),
* undefined (unsupported in some browsers), and other cases ('other' for unknown or unrecognized values).
* see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
*/ function $e719b4893434fd4f$export$f83ec67aa945dcf6(entry) {
    return entry.deliveryType === "" ? "other" : entry.deliveryType;
}
function $e719b4893434fd4f$export$9207ac338b648dd5(entry) {
    if (entry.startTime < entry.responseStart) {
        const { encodedBodySize: encodedBodySize, decodedBodySize: decodedBodySize, transferSize: transferSize } = entry;
        return {
            size: decodedBodySize,
            encoded_body_size: encodedBodySize,
            decoded_body_size: decodedBodySize,
            transfer_size: transferSize
        };
    }
    return {
        size: void 0,
        encoded_body_size: void 0,
        decoded_body_size: void 0,
        transfer_size: void 0
    };
}
function $e719b4893434fd4f$export$c298da523d6ed600(url) {
    return url && (!(0, $hWYdN.isIntakeUrl)(url) || (0, $fOYzt.isExperimentalFeatureEnabled)((0, $fOYzt.ExperimentalFeature).TRACK_INTAKE_REQUESTS));
}
const $e719b4893434fd4f$var$DATA_URL_REGEX = /data:(.+)?(;base64)?,/g;
const $e719b4893434fd4f$export$c9b94c34a00de3eb = 24e3;
function $e719b4893434fd4f$export$a7d3956fe6ae6a3d(url, lengthLimit = $e719b4893434fd4f$export$c9b94c34a00de3eb) {
    if (url.length <= lengthLimit || !url.startsWith("data:")) return url;
    const dataUrlMatchArray = url.substring(0, 100).match($e719b4893434fd4f$var$DATA_URL_REGEX);
    if (!dataUrlMatchArray) return url;
    return `${dataUrlMatchArray[0]}[...]`;
}

});
parcelRegister("iXofQ", function(module, exports) {

$parcel$export(module.exports, "ResourceType", function () { return $4ec0ddf027dff3d7$export$c6f9da6f70cfc2eb; });
$parcel$export(module.exports, "RequestType", function () { return $4ec0ddf027dff3d7$export$8d9ecf8a6190d0ad; });
//#region src/domain/resourceUtils.ts
const $4ec0ddf027dff3d7$export$c6f9da6f70cfc2eb = {
    DOCUMENT: "document",
    XHR: "xhr",
    BEACON: "beacon",
    FETCH: "fetch",
    CSS: "css",
    JS: "js",
    IMAGE: "image",
    FONT: "font",
    MEDIA: "media",
    WEBSOCKET: "websocket",
    OTHER: "other"
};
const $4ec0ddf027dff3d7$export$8d9ecf8a6190d0ad = {
    FETCH: $4ec0ddf027dff3d7$export$c6f9da6f70cfc2eb.FETCH,
    XHR: $4ec0ddf027dff3d7$export$c6f9da6f70cfc2eb.XHR
};

});


parcelRegister("8EfFG", function(module, exports) {

$parcel$export(module.exports, "isTextNode", function () { return $074248546752eb7d$export$ccbedd67ef6e9417; });
$parcel$export(module.exports, "isCommentNode", function () { return $074248546752eb7d$export$575485136eb1b1f; });
$parcel$export(module.exports, "isElementNode", function () { return $074248546752eb7d$export$95fe5d3c5526a812; });
$parcel$export(module.exports, "isNodeShadowHost", function () { return $074248546752eb7d$export$1fde2ba54cd81850; });
$parcel$export(module.exports, "isNodeShadowRoot", function () { return $074248546752eb7d$export$3a98bd54c2ced0bf; });
$parcel$export(module.exports, "forEachChildNodes", function () { return $074248546752eb7d$export$522badb50a8fb0b; });
$parcel$export(module.exports, "getParentNode", function () { return $074248546752eb7d$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "getParentElement", function () { return $074248546752eb7d$export$169e5491001d3ed6; });
//#region src/browser/htmlDomUtils.ts
function $074248546752eb7d$export$ccbedd67ef6e9417(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $074248546752eb7d$export$575485136eb1b1f(node) {
    return node.nodeType === Node.COMMENT_NODE;
}
function $074248546752eb7d$export$95fe5d3c5526a812(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $074248546752eb7d$export$1fde2ba54cd81850(node) {
    return $074248546752eb7d$export$95fe5d3c5526a812(node) && Boolean(node.shadowRoot);
}
function $074248546752eb7d$export$3a98bd54c2ced0bf(node) {
    const shadowRoot = node;
    return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && $074248546752eb7d$export$95fe5d3c5526a812(shadowRoot.host);
}
function $074248546752eb7d$export$13782f450ac5e09a(node) {
    return node.childNodes.length > 0 || $074248546752eb7d$export$1fde2ba54cd81850(node);
}
function $074248546752eb7d$export$522badb50a8fb0b(node, callback) {
    let child = node.firstChild;
    while(child){
        callback(child);
        child = child.nextSibling;
    }
    if ($074248546752eb7d$export$1fde2ba54cd81850(node)) callback(node.shadowRoot);
}
/**
* Return `host` in case if the current node is a shadow root otherwise will return the `parentNode`
*/ function $074248546752eb7d$export$4e12058fc4d51d56(node) {
    return $074248546752eb7d$export$3a98bd54c2ced0bf(node) ? node.host : node.parentNode;
}
/**
* Return the parent element, crossing shadow DOM boundaries.
* If the element is a direct child of a shadow root, returns the shadow host.
*/ function $074248546752eb7d$export$169e5491001d3ed6(element) {
    if (element.parentElement) return element.parentElement;
    const parentNode = element.parentNode;
    if (parentNode && $074248546752eb7d$export$3a98bd54c2ced0bf(parentNode)) return parentNode.host;
    return null;
}

});

parcelRegister("4H1Xw", function(module, exports) {

$parcel$export(module.exports, "RumPerformanceEntryType", function () { return $3d20279042b00fff$export$5241bfb054a2a291; });
$parcel$export(module.exports, "createPerformanceObservable", function () { return $3d20279042b00fff$export$f3f6554c84596077; });
$parcel$export(module.exports, "supportPerformanceTimingEvent", function () { return $3d20279042b00fff$export$c6967607cdac15e8; });

var $38LZB = parcelRequire("38LZB");

var $50cui = parcelRequire("50cui");
var $foX5P = parcelRequire("foX5P");
var $fnvkG = parcelRequire("fnvkG");

var $dee0n = parcelRequire("dee0n");
//#region src/browser/performanceObservable.ts
let $3d20279042b00fff$export$5241bfb054a2a291 = /* @__PURE__ */ function(RumPerformanceEntryType) {
    RumPerformanceEntryType["EVENT"] = "event";
    RumPerformanceEntryType["FIRST_INPUT"] = "first-input";
    RumPerformanceEntryType["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
    RumPerformanceEntryType["LAYOUT_SHIFT"] = "layout-shift";
    RumPerformanceEntryType["LONG_TASK"] = "longtask";
    RumPerformanceEntryType["LONG_ANIMATION_FRAME"] = "long-animation-frame";
    RumPerformanceEntryType["NAVIGATION"] = "navigation";
    RumPerformanceEntryType["PAINT"] = "paint";
    RumPerformanceEntryType["RESOURCE"] = "resource";
    RumPerformanceEntryType["SOFT_NAVIGATION"] = "soft-navigation";
    RumPerformanceEntryType["INTERACTION_CONTENTFUL_PAINT"] = "interaction-contentful-paint";
    RumPerformanceEntryType["VISIBILITY_STATE"] = "visibility-state";
    return RumPerformanceEntryType;
}({});
function $3d20279042b00fff$export$f3f6554c84596077(options) {
    return new (0, $fnvkG.Observable)((observable)=>{
        const handlePerformanceEntries = (entries)=>{
            const rumPerformanceEntries = $3d20279042b00fff$var$filterRumPerformanceEntries(entries);
            if (rumPerformanceEntries.length > 0) observable.notify(rumPerformanceEntries);
        };
        let timeoutId;
        let isObserverInitializing = true;
        const observer = new PerformanceObserver((0, $dee0n.monitor)((entries)=>{
            if (isObserverInitializing) timeoutId = (0, $foX5P.setTimeout)(()=>handlePerformanceEntries(entries.getEntries()));
            else handlePerformanceEntries(entries.getEntries());
        }));
        observer.observe(options);
        isObserverInitializing = false;
        $3d20279042b00fff$var$manageResourceTimingBufferFull();
        return ()=>{
            observer.disconnect();
            (0, $foX5P.clearTimeout)(timeoutId);
        };
    });
}
let $3d20279042b00fff$var$resourceTimingBufferFullListener;
function $3d20279042b00fff$var$manageResourceTimingBufferFull() {
    if (!$3d20279042b00fff$var$resourceTimingBufferFullListener && $3d20279042b00fff$var$supportPerformanceObject() && "addEventListener" in performance) $3d20279042b00fff$var$resourceTimingBufferFullListener = (0, $50cui.addEventListener)(performance, "resourcetimingbufferfull", ()=>{
        performance.clearResourceTimings();
    });
}
function $3d20279042b00fff$var$supportPerformanceObject() {
    return window.performance !== void 0 && "getEntries" in performance;
}
function $3d20279042b00fff$export$c6967607cdac15e8(entryType) {
    return PerformanceObserver.supportedEntryTypes.includes(entryType);
}
function $3d20279042b00fff$var$filterRumPerformanceEntries(entries) {
    return entries.filter((entry)=>!$3d20279042b00fff$var$isForbiddenResource(entry));
}
function $3d20279042b00fff$var$isForbiddenResource(entry) {
    return entry.entryType === "resource" && (!(0, $38LZB.isAllowedRequestUrl)(entry.name) || !(0, $38LZB.hasValidResourceEntryDuration)(entry));
}

});

parcelRegister("eqtGB", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE", function () { return $2152e77a3355d461$export$e3a045a56698d3f9; });
$parcel$export(module.exports, "ACTION_NAME_PLACEHOLDER", function () { return $2152e77a3355d461$export$23b90ecb4143a9ad; });
//#region src/domain/action/actionNameConstants.ts
/**
* Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
* It can also be retrieved from a user defined attribute.
*/ const $2152e77a3355d461$export$e3a045a56698d3f9 = "data-dd-action-name";
const $2152e77a3355d461$export$23b90ecb4143a9ad = "Masked Element";

});

parcelRegister("iMCYf", function(module, exports) {

$parcel$export(module.exports, "STABLE_ATTRIBUTES", function () { return $cd4662007a1bbf45$export$4ab9e1b4853d6dd7; });
$parcel$export(module.exports, "getIDSelector", function () { return $cd4662007a1bbf45$export$810c85d2e109892a; });
$parcel$export(module.exports, "getTagNameSelector", function () { return $cd4662007a1bbf45$export$e8aa1d92284ab2dc; });
$parcel$export(module.exports, "getSelectorFromElement", function () { return $cd4662007a1bbf45$export$2a298c6a007e5e40; });
$parcel$export(module.exports, "isGeneratedValue", function () { return $cd4662007a1bbf45$export$76ae048df570c708; });
$parcel$export(module.exports, "getAttributeValueSelector", function () { return $cd4662007a1bbf45$export$ab51fe52b0621f44; });
$parcel$export(module.exports, "getNthOfTypeSelector", function () { return $cd4662007a1bbf45$export$551b85403f3bee6; });

var $8EfFG = parcelRequire("8EfFG");

var $eqtGB = parcelRequire("eqtGB");
//#region src/domain/getSelectorFromElement.ts
/**
* Marker used to indicate shadow DOM boundaries in selectors.
* Named after the deprecated Shadow DOM v0 '::shadow' pseudo-element which served the same
* purpose of marking entry into a shadow root.
* Note: This is NOT a valid CSS selector, it's an internal marker that requires custom
* parsing logic.
*/ const $cd4662007a1bbf45$export$5786d969a307d4df = "::shadow ";
/**
* Stable attributes are attributes that are commonly used to identify parts of a UI (ex:
* component). Those attribute values should not be generated randomly (hardcoded most of the time)
* and stay the same across deploys. They are not necessarily unique across the document.
*/ const $cd4662007a1bbf45$export$4ab9e1b4853d6dd7 = [
    (0, $eqtGB.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE),
    "data-testid",
    "data-test",
    "data-qa",
    "data-cy",
    "data-test-id",
    "data-qa-id",
    "data-testing",
    "data-component",
    "data-element",
    "data-source-file"
];
const $cd4662007a1bbf45$var$GLOBALLY_UNIQUE_SELECTOR_GETTERS = [
    $cd4662007a1bbf45$var$getStableAttributeSelector,
    $cd4662007a1bbf45$export$810c85d2e109892a
];
const $cd4662007a1bbf45$var$UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [
    $cd4662007a1bbf45$var$getStableAttributeSelector,
    $cd4662007a1bbf45$var$getClassSelector,
    $cd4662007a1bbf45$export$e8aa1d92284ab2dc
];
function $cd4662007a1bbf45$export$2a298c6a007e5e40(targetElement, actionNameAttribute) {
    if (!targetElement.isConnected) return;
    const subtrees = $cd4662007a1bbf45$var$getAllSubtreeTargets(targetElement);
    const selectorParts = [];
    for (const { rootNode: rootNode, target: target } of subtrees){
        const selector = $cd4662007a1bbf45$var$getSelectorFromElementWithinSubtree(target, rootNode, actionNameAttribute);
        if (!selector) return;
        selectorParts.push(selector);
    }
    return selectorParts.join($cd4662007a1bbf45$export$5786d969a307d4df);
}
/**
* Returns all (rootNode, target) pairs from the document down to the element.
*/ function $cd4662007a1bbf45$var$getAllSubtreeTargets(element) {
    const result = [];
    let currentTarget = element;
    while(currentTarget){
        const rootNode = currentTarget.getRootNode();
        result.push({
            rootNode: rootNode,
            target: currentTarget
        });
        if ((0, $8EfFG.isNodeShadowRoot)(rootNode)) currentTarget = rootNode.host;
        else break;
    }
    return result.reverse();
}
/**
* Computes a CSS selector for an element within a specific subtree (document or shadow root).
*/ function $cd4662007a1bbf45$var$getSelectorFromElementWithinSubtree(targetElement, rootNode, actionNameAttribute) {
    let currentSelector;
    let currentElement = targetElement;
    while(currentElement && currentElement.nodeName !== "HTML"){
        const globallyUniqueSelector = $cd4662007a1bbf45$var$findSelector(currentElement, rootNode, $cd4662007a1bbf45$var$GLOBALLY_UNIQUE_SELECTOR_GETTERS, $cd4662007a1bbf45$var$isSelectorUniqueWithinRoot, actionNameAttribute, currentSelector);
        if (globallyUniqueSelector) return $cd4662007a1bbf45$var$combineSelector(globallyUniqueSelector, currentSelector);
        currentSelector = $cd4662007a1bbf45$var$combineSelector($cd4662007a1bbf45$var$findSelector(currentElement, rootNode, $cd4662007a1bbf45$var$UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, $cd4662007a1bbf45$export$feed9c87b437f926, actionNameAttribute, currentSelector) || $cd4662007a1bbf45$var$getPositionSelector(currentElement), currentSelector);
        currentElement = currentElement.parentElement;
    }
    return currentSelector;
}
function $cd4662007a1bbf45$export$76ae048df570c708(value) {
    return /[0-9]/.test(value);
}
function $cd4662007a1bbf45$export$810c85d2e109892a(element) {
    if (element.id && !$cd4662007a1bbf45$export$76ae048df570c708(element.id)) return `#${CSS.escape(element.id)}`;
}
function $cd4662007a1bbf45$var$getClassSelector(element) {
    if (element.tagName === "BODY") return;
    const classList = element.classList;
    for(let i = 0; i < classList.length; i += 1){
        const className = classList[i];
        if ($cd4662007a1bbf45$export$76ae048df570c708(className)) continue;
        return `${CSS.escape(element.tagName)}.${CSS.escape(className)}`;
    }
}
function $cd4662007a1bbf45$export$e8aa1d92284ab2dc(element) {
    return CSS.escape(element.tagName);
}
function $cd4662007a1bbf45$var$getStableAttributeSelector(element, actionNameAttribute) {
    if (actionNameAttribute) {
        const selector = getAttributeSelector(actionNameAttribute);
        if (selector) return selector;
    }
    for (const attributeName of $cd4662007a1bbf45$export$4ab9e1b4853d6dd7){
        const selector = getAttributeSelector(attributeName);
        if (selector) return selector;
    }
    function getAttributeSelector(attributeName) {
        if (element.hasAttribute(attributeName)) return `${CSS.escape(element.tagName)}${$cd4662007a1bbf45$export$ab51fe52b0621f44(attributeName, element.getAttribute(attributeName))}`;
    }
}
function $cd4662007a1bbf45$export$ab51fe52b0621f44(attributeName, attributeValue) {
    return `[${attributeName}="${CSS.escape(attributeValue)}"]`;
}
function $cd4662007a1bbf45$var$getPositionSelector(element) {
    const nthOfType = $cd4662007a1bbf45$export$551b85403f3bee6(element);
    return `${CSS.escape(element.tagName)}:nth-of-type(${nthOfType})`;
}
function $cd4662007a1bbf45$export$551b85403f3bee6(element) {
    let sibling = element.parentNode.firstElementChild;
    let nthOfType = 1;
    while(sibling && sibling !== element){
        if (sibling.tagName === element.tagName) nthOfType += 1;
        sibling = sibling.nextElementSibling;
    }
    return nthOfType;
}
function $cd4662007a1bbf45$var$findSelector(element, rootNode, selectorGetters, predicate, actionNameAttribute, childSelector) {
    for (const selectorGetter of selectorGetters){
        const elementSelector = selectorGetter(element, actionNameAttribute);
        if (!elementSelector) continue;
        if (predicate(element, rootNode, elementSelector, childSelector)) return elementSelector;
    }
}
/**
* Check whether the selector is unique within the root node (document or shadow root).
*/ function $cd4662007a1bbf45$var$isSelectorUniqueWithinRoot(_element, rootNode, elementSelector, childSelector) {
    return rootNode.querySelectorAll($cd4662007a1bbf45$var$combineSelector(elementSelector, childSelector)).length === 1;
}
/**
* Check whether the selector is unique among the element siblings. In other words, it returns true
* if "ELEMENT_PARENT > CHILD_SELECTOR" returns a single element.
*
* @param currentElement - the element being considered while iterating over the target
* element ancestors.
* @param _rootNode - the root node (document or shadow root) - unused but required for predicate signature.
* @param currentElementSelector - a selector that matches the current element. That
* selector is not a composed selector (i.e. it might be a single tag name, class name...).
* @param childSelector - child selector is a selector that targets a descendant
* of the current element. When undefined, the current element is the target element.
*
* # Scope selector usage
*
* When composed together, the final selector will be joined with `>` operators to make sure we
* target direct descendants at each level. In this function, we'll use `querySelector` to check if
* a selector matches descendants of the current element. But by default, the query selector match
* elements at any level. Example:
*
* ```html
* <main>
*   <div>
*     <span></span>
*   </div>
*   <marquee>
*     <div>
*       <span></span>
*     </div>
*   </marquee>
* </main>
* ```
*
* `sibling.querySelector('DIV > SPAN')` will match both span elements, so we would consider the
* selector to be not unique, even if it is unique when we'll compose it with the parent with a `>`
* operator (`MAIN > DIV > SPAN`).
*
* To avoid this, we can use the `:scope` selector to make sure the selector starts from the current
* sibling (i.e. `sibling.querySelector('DIV:scope > SPAN')` will only match the first span).
*
* [1]: https://developer.mozilla.org/fr/docs/Web/CSS/:scope
*
* # Performance considerations
*
* We compute selectors in performance-critical operations (ex: during a click), so we need to make
* sure the function is as fast as possible. We observed that naively using `querySelectorAll` to
* check if the selector matches more than 1 element is quite expensive, so we want to avoid it.
*
* Because we are iterating the DOM upward and we use that function at every level, we know the
* child selector is already unique among the current element children, so we don't need to check
* for the current element subtree.
*
* Instead, we can focus on the current element siblings. If we find a single element matching the
* selector within a sibling, we know that it's not unique. This allows us to use `querySelector`
* (or `matches`, when the current element is the target element) instead of `querySelectorAll`.
*/ function $cd4662007a1bbf45$export$feed9c87b437f926(currentElement, _rootNode, currentElementSelector, childSelector) {
    let isSiblingMatching;
    if (childSelector === void 0) isSiblingMatching = (sibling)=>sibling.matches(currentElementSelector);
    else {
        const scopedSelector = $cd4662007a1bbf45$var$combineSelector(`${currentElementSelector}:scope`, childSelector);
        isSiblingMatching = (sibling)=>sibling.querySelector(scopedSelector) !== null;
    }
    let sibling = currentElement.previousElementSibling;
    while(sibling){
        if (isSiblingMatching(sibling)) return false;
        sibling = sibling.previousElementSibling;
    }
    sibling = currentElement.nextElementSibling;
    while(sibling){
        if (isSiblingMatching(sibling)) return false;
        sibling = sibling.nextElementSibling;
    }
    return true;
}
function $cd4662007a1bbf45$var$combineSelector(parent, child) {
    return child ? `${parent}>${child}` : parent;
}

});

parcelRegister("8yVTM", function(module, exports) {

$parcel$export(module.exports, "NodePrivacyLevel", function () { return $d78883ba28d48a97$export$92940eb5f25d0fc5; });
$parcel$export(module.exports, "PRIVACY_ATTR_NAME", function () { return $d78883ba28d48a97$export$ff33c64c78e35b2b; });
$parcel$export(module.exports, "PRIVACY_ATTR_VALUE_HIDDEN", function () { return $d78883ba28d48a97$export$e41cc9b2bd72efb8; });
$parcel$export(module.exports, "CENSORED_STRING_MARK", function () { return $d78883ba28d48a97$export$76054905c0914783; });
$parcel$export(module.exports, "CENSORED_IMG_MARK", function () { return $d78883ba28d48a97$export$4ab830af01a1bf7e; });
$parcel$export(module.exports, "FORM_PRIVATE_TAG_NAMES", function () { return $d78883ba28d48a97$export$b6dba6f930ee071f; });
$parcel$export(module.exports, "getPrivacySelector", function () { return $d78883ba28d48a97$export$8af88c85d388edd6; });

var $9O7SB = parcelRequire("9O7SB");
//#region src/domain/privacyConstants.ts
const $d78883ba28d48a97$export$92940eb5f25d0fc5 = {
    IGNORE: "ignore",
    HIDDEN: "hidden",
    ALLOW: (0, $9O7SB.DefaultPrivacyLevel).ALLOW,
    MASK: (0, $9O7SB.DefaultPrivacyLevel).MASK,
    MASK_USER_INPUT: (0, $9O7SB.DefaultPrivacyLevel).MASK_USER_INPUT,
    MASK_UNLESS_ALLOWLISTED: (0, $9O7SB.DefaultPrivacyLevel).MASK_UNLESS_ALLOWLISTED
};
const $d78883ba28d48a97$export$ff33c64c78e35b2b = "data-dd-privacy";
const $d78883ba28d48a97$export$a5095f6ae8c6493c = "allow";
const $d78883ba28d48a97$export$faf6990c986cc1eb = "mask";
const $d78883ba28d48a97$export$b06f6b91aa78d012 = "mask-user-input";
const $d78883ba28d48a97$export$bb9ad7f5163289ba = "mask-unless-allowlisted";
const $d78883ba28d48a97$export$e41cc9b2bd72efb8 = "hidden";
const $d78883ba28d48a97$export$bee0efbfde2065b1 = "dd-privacy-";
const $d78883ba28d48a97$export$76054905c0914783 = "***";
const $d78883ba28d48a97$export$4ab830af01a1bf7e = "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==";
const $d78883ba28d48a97$export$b6dba6f930ee071f = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true
};
const $d78883ba28d48a97$export$338da8c573d46a97 = "x";
function $d78883ba28d48a97$export$8af88c85d388edd6(privacyLevel) {
    return `[${$d78883ba28d48a97$export$ff33c64c78e35b2b}="${privacyLevel}"], .${$d78883ba28d48a97$export$bee0efbfde2065b1}${privacyLevel}`;
}

});

parcelRegister("8lnE0", function(module, exports) {

$parcel$export(module.exports, "getNodePrivacyLevel", function () { return $54553333a3de0e0a$export$da439d4b145972be; });
$parcel$export(module.exports, "reducePrivacyLevel", function () { return $54553333a3de0e0a$export$3e5e4c23b3787dea; });
$parcel$export(module.exports, "getNodeSelfPrivacyLevel", function () { return $54553333a3de0e0a$export$c417e854a5c24a6f; });
$parcel$export(module.exports, "shouldMaskNode", function () { return $54553333a3de0e0a$export$f97c617afddc1089; });
$parcel$export(module.exports, "shouldMaskAttribute", function () { return $54553333a3de0e0a$export$15e4315f0331c4e9; });
$parcel$export(module.exports, "getTextContent", function () { return $54553333a3de0e0a$export$132e79e4118a78e0; });
$parcel$export(module.exports, "maskDisallowedTextContent", function () { return $54553333a3de0e0a$export$1520fe27573fdbd3; });

var $8EfFG = parcelRequire("8EfFG");

var $iMCYf = parcelRequire("iMCYf");

var $8yVTM = parcelRequire("8yVTM");
//#region src/domain/privacy.ts
/**
* Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
* know, it is best to use something like:
*
* derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
*/ function $54553333a3de0e0a$export$da439d4b145972be(node, defaultPrivacyLevel, cache) {
    if (cache?.has(node)) return cache.get(node);
    const parentNode = (0, $8EfFG.getParentNode)(node);
    const parentNodePrivacyLevel = parentNode ? $54553333a3de0e0a$export$da439d4b145972be(parentNode, defaultPrivacyLevel, cache) : defaultPrivacyLevel;
    const nodePrivacyLevel = $54553333a3de0e0a$export$3e5e4c23b3787dea($54553333a3de0e0a$export$c417e854a5c24a6f(node), parentNodePrivacyLevel);
    if (cache) cache.set(node, nodePrivacyLevel);
    return nodePrivacyLevel;
}
/**
* Reduces the next privacy level based on self + parent privacy levels
*/ function $54553333a3de0e0a$export$3e5e4c23b3787dea(childPrivacyLevel, parentNodePrivacyLevel) {
    switch(parentNodePrivacyLevel){
        case (0, $8yVTM.NodePrivacyLevel).HIDDEN:
        case (0, $8yVTM.NodePrivacyLevel).IGNORE:
            return parentNodePrivacyLevel;
    }
    switch(childPrivacyLevel){
        case (0, $8yVTM.NodePrivacyLevel).ALLOW:
        case (0, $8yVTM.NodePrivacyLevel).MASK:
        case (0, $8yVTM.NodePrivacyLevel).MASK_USER_INPUT:
        case (0, $8yVTM.NodePrivacyLevel).MASK_UNLESS_ALLOWLISTED:
        case (0, $8yVTM.NodePrivacyLevel).HIDDEN:
        case (0, $8yVTM.NodePrivacyLevel).IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
/**
* Determines the node's own privacy level without checking for ancestors.
*/ function $54553333a3de0e0a$export$c417e854a5c24a6f(node) {
    if (!(0, $8EfFG.isElementNode)(node)) return;
    if (node.tagName === "BASE") return (0, $8yVTM.NodePrivacyLevel).ALLOW;
    if (node.tagName === "INPUT") {
        const inputElement = node;
        if (inputElement.type === "password" || inputElement.type === "email" || inputElement.type === "tel") return (0, $8yVTM.NodePrivacyLevel).MASK;
        if (inputElement.type === "hidden") return (0, $8yVTM.NodePrivacyLevel).MASK;
        const autocomplete = inputElement.getAttribute("autocomplete");
        if (autocomplete && (autocomplete.startsWith("cc-") || autocomplete.endsWith("-password"))) return (0, $8yVTM.NodePrivacyLevel).MASK;
    }
    if (node.matches((0, $8yVTM.getPrivacySelector)((0, $8yVTM.NodePrivacyLevel).HIDDEN))) return (0, $8yVTM.NodePrivacyLevel).HIDDEN;
    if (node.matches((0, $8yVTM.getPrivacySelector)((0, $8yVTM.NodePrivacyLevel).MASK))) return (0, $8yVTM.NodePrivacyLevel).MASK;
    if (node.matches((0, $8yVTM.getPrivacySelector)((0, $8yVTM.NodePrivacyLevel).MASK_UNLESS_ALLOWLISTED))) return (0, $8yVTM.NodePrivacyLevel).MASK_UNLESS_ALLOWLISTED;
    if (node.matches((0, $8yVTM.getPrivacySelector)((0, $8yVTM.NodePrivacyLevel).MASK_USER_INPUT))) return (0, $8yVTM.NodePrivacyLevel).MASK_USER_INPUT;
    if (node.matches((0, $8yVTM.getPrivacySelector)((0, $8yVTM.NodePrivacyLevel).ALLOW))) return (0, $8yVTM.NodePrivacyLevel).ALLOW;
    if ($54553333a3de0e0a$export$15d4213dc9444b1(node)) return (0, $8yVTM.NodePrivacyLevel).IGNORE;
}
/**
* Helper aiming to unify `mask` and `mask-user-input` privacy levels:
*
* In the `mask` case, it is trivial: we should mask the element.
*
* In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
* direct parent is a form element for text nodes).
*
* Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
* node if it is ignored or hidden? it doesn't matter since it won't be serialized).
*/ function $54553333a3de0e0a$export$f97c617afddc1089(node, privacyLevel) {
    switch(privacyLevel){
        case (0, $8yVTM.NodePrivacyLevel).MASK:
        case (0, $8yVTM.NodePrivacyLevel).HIDDEN:
        case (0, $8yVTM.NodePrivacyLevel).IGNORE:
            return true;
        case (0, $8yVTM.NodePrivacyLevel).MASK_UNLESS_ALLOWLISTED:
            if ((0, $8EfFG.isTextNode)(node)) return $54553333a3de0e0a$var$isFormElement(node.parentNode) ? true : !$54553333a3de0e0a$export$204f2b4e8040eb90(node.textContent || "");
            return $54553333a3de0e0a$var$isFormElement(node);
        case (0, $8yVTM.NodePrivacyLevel).MASK_USER_INPUT:
            return (0, $8EfFG.isTextNode)(node) ? $54553333a3de0e0a$var$isFormElement(node.parentNode) : $54553333a3de0e0a$var$isFormElement(node);
        default:
            return false;
    }
}
function $54553333a3de0e0a$export$15e4315f0331c4e9(tagName, attributeName, attributeValue, nodePrivacyLevel, configuration) {
    if (nodePrivacyLevel !== (0, $8yVTM.NodePrivacyLevel).MASK && nodePrivacyLevel !== (0, $8yVTM.NodePrivacyLevel).MASK_UNLESS_ALLOWLISTED) return false;
    if (attributeName === "data-dd-privacy" || (0, $iMCYf.STABLE_ATTRIBUTES).includes(attributeName) || attributeName === configuration.actionNameAttribute) return false;
    switch(attributeName){
        case "title":
        case "alt":
        case "placeholder":
        case "aria-label":
        case "name":
            return true;
    }
    if (tagName === "A" && attributeName === "href") return true;
    if (tagName === "IFRAME" && attributeName === "srcdoc") return true;
    if (attributeValue && attributeName.startsWith("data-")) return true;
    if ((tagName === "IMG" || tagName === "SOURCE") && (attributeName === "src" || attributeName === "srcset")) return true;
    return false;
}
function $54553333a3de0e0a$var$isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) return false;
    const element = node;
    if (element.tagName === "INPUT") switch(element.type){
        case "button":
        case "color":
        case "reset":
        case "submit":
            return false;
    }
    return !!(0, $8yVTM.FORM_PRIVATE_TAG_NAMES)[element.tagName];
}
/**
* Text censoring non-destructively maintains whitespace characters in order to preserve text shape
* during replay.
*/ function $54553333a3de0e0a$export$7aa14ef9d0a56a45(text) {
    return text.replace(/\S/g, "x");
}
function $54553333a3de0e0a$export$132e79e4118a78e0(textNode, parentNodePrivacyLevel) {
    const parentTagName = textNode.parentElement?.tagName;
    let textContent = textNode.textContent || "";
    const nodePrivacyLevel = parentNodePrivacyLevel;
    if (parentTagName === "SCRIPT") textContent = "***";
    else if (nodePrivacyLevel === (0, $8yVTM.NodePrivacyLevel).HIDDEN) textContent = "***";
    else if ($54553333a3de0e0a$export$f97c617afddc1089(textNode, nodePrivacyLevel)) {
        if (parentTagName === "DATALIST" || parentTagName === "SELECT" || parentTagName === "OPTGROUP") ;
        else if (parentTagName === "OPTION") textContent = "***";
        else textContent = $54553333a3de0e0a$export$7aa14ef9d0a56a45(textContent);
    }
    if (parentTagName === "HEAD" && !textContent.trim()) return "";
    return textContent;
}
/**
* TODO: Preserve CSS element order, and record the presence of the tag, just don't render
* We don't need this logic on the recorder side.
* For security related meta's, customer can mask themmanually given they
* are easy to identify in the HEAD tag.
*/ function $54553333a3de0e0a$export$15d4213dc9444b1(element) {
    if (element.nodeName === "SCRIPT") return true;
    if (element.nodeName === "LINK") {
        const relAttribute = getLowerCaseAttribute("rel");
        return /preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute("as") === "script" || relAttribute === "shortcut icon" || relAttribute === "icon";
    }
    if (element.nodeName === "META") {
        const nameAttribute = getLowerCaseAttribute("name");
        const relAttribute = getLowerCaseAttribute("rel");
        const propertyAttribute = getLowerCaseAttribute("property");
        return /^msapplication-tile(image|color)$/.test(nameAttribute) || nameAttribute === "application-name" || relAttribute === "icon" || relAttribute === "apple-touch-icon" || relAttribute === "shortcut icon" || nameAttribute === "keywords" || nameAttribute === "description" || /^(og|twitter|fb):/.test(propertyAttribute) || /^(og|twitter):/.test(nameAttribute) || nameAttribute === "pinterest" || nameAttribute === "robots" || nameAttribute === "googlebot" || nameAttribute === "bingbot" || element.hasAttribute("http-equiv") || nameAttribute === "author" || nameAttribute === "generator" || nameAttribute === "framework" || nameAttribute === "publisher" || nameAttribute === "progid" || /^article:/.test(propertyAttribute) || /^product:/.test(propertyAttribute) || nameAttribute === "google-site-verification" || nameAttribute === "yandex-verification" || nameAttribute === "csrf-token" || nameAttribute === "p:domain_verify" || nameAttribute === "verify-v1" || nameAttribute === "verification" || nameAttribute === "shopify-checkout-api-token";
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || "").toLowerCase();
    }
    return false;
}
function $54553333a3de0e0a$export$204f2b4e8040eb90(text) {
    if (!text?.trim()) return true;
    return window.$DD_ALLOW?.has(text.toLocaleLowerCase()) || false;
}
function $54553333a3de0e0a$export$1520fe27573fdbd3(text, fixedMask) {
    if ($54553333a3de0e0a$export$204f2b4e8040eb90(text)) return text;
    return fixedMask || $54553333a3de0e0a$export$7aa14ef9d0a56a45(text);
}

});

parcelRegister("ktiJ6", function(module, exports) {

$parcel$export(module.exports, "getScrollX", function () { return $06fbce62d85c1c74$export$1a2bd001e684a8d2; });
$parcel$export(module.exports, "getScrollY", function () { return $06fbce62d85c1c74$export$91aaad5752ba6e7; });
//#region src/browser/scroll.ts
function $06fbce62d85c1c74$export$1a2bd001e684a8d2() {
    let scrollX;
    const visual = window.visualViewport;
    if (visual) scrollX = visual.pageLeft - visual.offsetLeft;
    else if (window.scrollX !== void 0) scrollX = window.scrollX;
    else scrollX = window.pageXOffset || 0;
    return Math.round(scrollX);
}
function $06fbce62d85c1c74$export$91aaad5752ba6e7() {
    let scrollY;
    const visual = window.visualViewport;
    if (visual) scrollY = visual.pageTop - visual.offsetTop;
    else if (window.scrollY !== void 0) scrollY = window.scrollY;
    else scrollY = window.pageYOffset || 0;
    return Math.round(scrollY);
}

});

parcelRegister("fUJs2", function(module, exports) {

$parcel$export(module.exports, "initViewportObservable", function () { return $b2504e1b28a891c3$export$2c24cc613e51a50f; });
$parcel$export(module.exports, "getViewportDimension", function () { return $b2504e1b28a891c3$export$e79021d67c61dfbd; });

var $50cui = parcelRequire("50cui");
var $fnvkG = parcelRequire("fnvkG");
var $hH6Lc = parcelRequire("hH6Lc");
//#region src/browser/viewportObservable.ts
let $b2504e1b28a891c3$var$viewportObservable;
function $b2504e1b28a891c3$export$2c24cc613e51a50f() {
    if (!$b2504e1b28a891c3$var$viewportObservable) $b2504e1b28a891c3$var$viewportObservable = $b2504e1b28a891c3$export$36388875a0cf8990();
    return $b2504e1b28a891c3$var$viewportObservable;
}
function $b2504e1b28a891c3$export$36388875a0cf8990() {
    return new (0, $fnvkG.Observable)((observable)=>{
        const { throttled: updateDimension } = (0, $hH6Lc.throttle)(()=>{
            observable.notify($b2504e1b28a891c3$export$e79021d67c61dfbd());
        }, 200);
        return (0, $50cui.addEventListener)(window, (0, $50cui.DOM_EVENT).RESIZE, updateDimension, {
            capture: true,
            passive: true
        }).stop;
    });
}
function $b2504e1b28a891c3$export$e79021d67c61dfbd() {
    const visual = window.visualViewport;
    if (visual) return {
        width: Number(visual.width * visual.scale),
        height: Number(visual.height * visual.scale)
    };
    return {
        width: Number(window.innerWidth || 0),
        height: Number(window.innerHeight || 0)
    };
}

});

parcelRegister("jIq9O", function(module, exports) {

$parcel$export(module.exports, "SessionReplayState", function () { return $298df4a76021f0a0$export$e0b0cbe6fa305f28; });
$parcel$export(module.exports, "computeSessionReplayState", function () { return $298df4a76021f0a0$export$8a8884cee1ecbc24; });

var $gS0nt = parcelRequire("gS0nt");
var $i1EVG = parcelRequire("i1EVG");
//#region src/domain/sessionReplayState.ts
let $298df4a76021f0a0$export$e0b0cbe6fa305f28 = /* @__PURE__ */ function(SessionReplayState) {
    SessionReplayState[SessionReplayState["OFF"] = 0] = "OFF";
    SessionReplayState[SessionReplayState["SAMPLED"] = 1] = "SAMPLED";
    SessionReplayState[SessionReplayState["FORCED"] = 2] = "FORCED";
    return SessionReplayState;
}({});
function $298df4a76021f0a0$export$8a8884cee1ecbc24(session, configuration) {
    if ((0, $gS0nt.canUseEventBridge)()) return (0, $gS0nt.bridgeSupports)((0, $gS0nt.BridgeCapability).RECORDS) ? 1 : 0;
    if ((0, $i1EVG.isSampled)(session.id, (0, $i1EVG.correctedChildSampleRate)(configuration.sessionSampleRate, configuration.sessionReplaySampleRate))) return 1;
    if (session.isReplayForced) return 2;
    return 0;
}

});
parcelRegister("i1EVG", function(module, exports) {

$parcel$export(module.exports, "correctedChildSampleRate", function () { return $6ad5ee6bbcc5a2b3$export$dd4559086f7d100e; });
$parcel$export(module.exports, "isSampled", function () { return $6ad5ee6bbcc5a2b3$export$ed7a494f7df966be; });
//#region src/domain/sampler.ts
function $6ad5ee6bbcc5a2b3$export$dd4559086f7d100e(parentRate, childRate) {
    return parentRate * childRate / 100;
}
const $6ad5ee6bbcc5a2b3$var$sampleDecisionCache = /* @__PURE__ */ new Map();
function $6ad5ee6bbcc5a2b3$export$ed7a494f7df966be(sessionId, sampleRate) {
    if (sampleRate === 100) return true;
    if (sampleRate === 0) return false;
    const cachedDecision = $6ad5ee6bbcc5a2b3$var$sampleDecisionCache.get(sampleRate);
    if (sessionId === cachedDecision?.sessionId) return cachedDecision.decision;
    const decision = $6ad5ee6bbcc5a2b3$export$63da09b47e2ee93a(BigInt(`0x${sessionId.split("-")[4]}`), sampleRate);
    $6ad5ee6bbcc5a2b3$var$sampleDecisionCache.set(sampleRate, {
        sessionId: sessionId,
        decision: decision
    });
    return decision;
}
function $6ad5ee6bbcc5a2b3$export$5ffa6f8189c2cad3() {
    $6ad5ee6bbcc5a2b3$var$sampleDecisionCache.clear();
}
/**
* Perform sampling using the Knuth factor method. This method offer consistent sampling result
* based on the provided identifier.
*
* @param identifier - The identifier to use for sampling.
* @param sampleRate - The sample rate in percentage between 0 and 100.
*/ function $6ad5ee6bbcc5a2b3$export$63da09b47e2ee93a(identifier, sampleRate) {
    const knuthFactor = 1111111111111111111n;
    const twoPow64 = 1n << 64n;
    const hash = identifier * knuthFactor % twoPow64;
    return Number(hash) <= sampleRate / 100 * Number(twoPow64);
}

});


parcelRegister("eE0f0", function(module, exports) {

$parcel$export(module.exports, "startRum", function () { return $211d2ca899fac529$export$3215a7cbec5ac3e0; });

var $46UCk = parcelRequire("46UCk");

var $iKo11 = parcelRequire("iKo11");

var $hbF4A = parcelRequire("hbF4A");

var $jNZRV = parcelRequire("jNZRV");

var $80kZV = parcelRequire("80kZV");

var $fSFKy = parcelRequire("fSFKy");

var $7TKXD = parcelRequire("7TKXD");

var $73kBg = parcelRequire("73kBg");

var $17qGp = parcelRequire("17qGp");

var $5axha = parcelRequire("5axha");

var $9jBKY = parcelRequire("9jBKY");

var $bUYde = parcelRequire("bUYde");

var $kcZgo = parcelRequire("kcZgo");

var $41DCp = parcelRequire("41DCp");

var $gAVHv = parcelRequire("gAVHv");

var $8ceHp = parcelRequire("8ceHp");

var $92olM = parcelRequire("92olM");

var $drAqL = parcelRequire("drAqL");

var $jvgPw = parcelRequire("jvgPw");

var $2ifT4 = parcelRequire("2ifT4");

var $5GkPj = parcelRequire("5GkPj");

var $1sqPO = parcelRequire("1sqPO");

var $kOVfx = parcelRequire("kOVfx");

var $ky7Xi = parcelRequire("ky7Xi");

var $b6EDT = parcelRequire("b6EDT");

var $eGPRq = parcelRequire("eGPRq");

var $aSSxK = parcelRequire("aSSxK");

var $6zIVo = parcelRequire("6zIVo");

var $3Twtr = parcelRequire("3Twtr");

var $1wrwm = parcelRequire("1wrwm");

var $461Vl = parcelRequire("461Vl");
var $gS0nt = parcelRequire("gS0nt");
var $ljRg3 = parcelRequire("ljRg3");
var $7RJVj = parcelRequire("7RJVj");
var $fOYzt = parcelRequire("fOYzt");
var $jkF2M = parcelRequire("jkF2M");
var $dmc88 = parcelRequire("dmc88");
var $4B1f5 = parcelRequire("4B1f5");
var $6gx7W = parcelRequire("6gx7W");
var $7P6fE = parcelRequire("7P6fE");
//#region src/boot/startRum.ts
function $211d2ca899fac529$export$3215a7cbec5ac3e0(configuration, sessionManager, recorderApi, profilerApi, initialViewOptions, createEncoder, bufferedDataObservable, telemetry, hooks, sdkName) {
    const cleanupTasks = [];
    const lifeCycle = new (0, $jNZRV.LifeCycle)();
    lifeCycle.subscribe(14, (event)=>(0, $jkF2M.sendToExtension)("rum", event));
    sessionManager.expireObservable.subscribe(()=>lifeCycle.notify(10, {
            endClocks: (0, $1wrwm.clocksNow)()
        }));
    sessionManager.renewObservable.subscribe(()=>lifeCycle.notify(11));
    const reportError = (message)=>{
        lifeCycle.notify(15, {
            error: {
                message: message,
                source: (0, $7RJVj.ErrorSource).AGENT,
                startClocks: (0, $1wrwm.clocksNow)()
            }
        });
        (0, $461Vl.addTelemetryDebug)("Error reported to customer", {
            "error.message": message
        });
    };
    if (!(0, $gS0nt.canUseEventBridge)()) {
        const batch = (0, $bUYde.startRumBatch)(configuration, lifeCycle, reportError, sessionManager.expireObservable, createEncoder);
        const preparePageExitSubscription = batch.prepareUrgentFlushObservable.subscribe((reason)=>{
            lifeCycle.notify(12, reason);
        });
        cleanupTasks.push(()=>preparePageExitSubscription.unsubscribe());
        cleanupTasks.push(()=>batch.stop());
        (0, $92olM.startCustomerDataTelemetry)(telemetry, lifeCycle, batch.flushObservable);
    } else {
        (0, $kcZgo.startRumEventBridge)(lifeCycle);
        const pageMayExitSubscription = (0, $ljRg3.createPageMayExitObservable)().subscribe((event)=>{
            lifeCycle.notify(12, event.reason);
        });
        cleanupTasks.push(()=>pageMayExitSubscription.unsubscribe());
    }
    const { stop: stopRumEventCollection, ...startRumEventCollectionResult } = $211d2ca899fac529$export$cd2ea6643dad23e3(lifeCycle, hooks, configuration, sessionManager, recorderApi, initialViewOptions, bufferedDataObservable, sdkName, reportError);
    cleanupTasks.push(stopRumEventCollection);
    bufferedDataObservable.unbuffer();
    cleanupTasks.push(()=>profilerApi.stop());
    return {
        ...startRumEventCollectionResult,
        lifeCycle: lifeCycle,
        sessionManager: sessionManager,
        stopSession: ()=>sessionManager.expire(),
        telemetry: telemetry,
        stop: ()=>{
            cleanupTasks.forEach((task)=>task());
        },
        hooks: hooks
    };
}
function $211d2ca899fac529$export$cd2ea6643dad23e3(lifeCycle, hooks, configuration, sessionManager, recorderApi, initialViewOptions, bufferedDataObservable, sdkName, reportError) {
    const cleanupTasks = [];
    const domMutationObservable = (0, $46UCk.createDOMMutationObservable)();
    const locationChangeObservable = (0, $gAVHv.createLocationChangeObservable)();
    const { observable: windowOpenObservable, stop: stopWindowOpen } = (0, $iKo11.createWindowOpenObservable)();
    cleanupTasks.push(stopWindowOpen);
    const { assembleEventDefaults: assembleHook } = hooks;
    (0, $aSSxK.startDefaultContext)(assembleHook, configuration, sdkName);
    const pageStateHistory = (0, $drAqL.startPageStateHistory)(assembleHook);
    cleanupTasks.push(()=>pageStateHistory.stop());
    const viewHistory = (0, $80kZV.startViewHistory)(lifeCycle);
    cleanupTasks.push(()=>viewHistory.stop());
    const urlContexts = (0, $41DCp.startUrlContexts)(lifeCycle, assembleHook, locationChangeObservable);
    cleanupTasks.push(()=>urlContexts.stop());
    const featureFlagContexts = (0, $8ceHp.startFeatureFlagContexts)(lifeCycle, assembleHook, configuration);
    (0, $5GkPj.startSessionContext)(assembleHook, configuration, sessionManager, recorderApi, viewHistory);
    (0, $eGPRq.startConnectivityContext)(assembleHook);
    (0, $6gx7W.startTabContext)(assembleHook);
    const globalContext = (0, $4B1f5.startGlobalContext)(assembleHook, configuration, "rum", true);
    const userContext = (0, $7P6fE.startUserContext)(assembleHook, configuration, sessionManager, "rum");
    const accountContext = (0, $dmc88.startAccountContext)(assembleHook, configuration, "rum");
    const actionCollection = (0, $73kBg.startActionCollection)(lifeCycle, hooks, domMutationObservable, windowOpenObservable, configuration);
    cleanupTasks.push(actionCollection.stop);
    const eventCollection = (0, $6zIVo.startEventCollection)(lifeCycle);
    const displayContext = (0, $jvgPw.startDisplayContext)(assembleHook);
    cleanupTasks.push(displayContext.stop);
    const ciVisibilityContext = (0, $1sqPO.startCiVisibilityContext)(assembleHook);
    cleanupTasks.push(ciVisibilityContext.stop);
    (0, $ky7Xi.startSyntheticsContext)(assembleHook);
    (0, $b6EDT.startRumAssembly)(configuration, lifeCycle, hooks, reportError);
    const { addTiming: addTiming, setLoadingTime: setLoadingTime, startView: startView, setViewName: setViewName, setViewContext: setViewContext, setViewContextProperty: setViewContextProperty, getViewContext: getViewContext, stop: stopViewCollection } = (0, $9jBKY.startViewCollection)(lifeCycle, hooks, configuration, domMutationObservable, windowOpenObservable, locationChangeObservable, recorderApi, viewHistory, initialViewOptions);
    (0, $3Twtr.startSourceCodeMfeContext)(assembleHook);
    cleanupTasks.push(stopViewCollection);
    const resourceCollection = (0, $5axha.startResourceCollection)(lifeCycle, configuration);
    cleanupTasks.push(resourceCollection.stop);
    const { stop: stopLongTaskCollection } = (0, $kOVfx.startLongTaskCollection)(lifeCycle, configuration);
    cleanupTasks.push(stopLongTaskCollection);
    const { addError: addError } = (0, $17qGp.startErrorCollection)(lifeCycle, bufferedDataObservable);
    (0, $fSFKy.startRequestCollection)(lifeCycle, configuration, sessionManager, userContext, accountContext, bufferedDataObservable);
    const vitalCollection = (0, $2ifT4.startVitalCollection)(lifeCycle, pageStateHistory);
    if (configuration.trackResources && (configuration.betaTrackWebSockets || (0, $fOYzt.isExperimentalFeatureEnabled)((0, $fOYzt.ExperimentalFeature).TRACK_WEBSOCKETS))) {
        const webSocketCollection = (0, $7TKXD.startWebSocketCollection)(lifeCycle, viewHistory, vitalCollection.addDurationVital);
        cleanupTasks.push(webSocketCollection.stop);
    }
    const internalContext = (0, $hbF4A.startInternalContext)(configuration.applicationId, sessionManager, viewHistory, actionCollection.actionContexts, urlContexts);
    return {
        addAction: actionCollection.addAction,
        startAction: actionCollection.startAction,
        stopAction: actionCollection.stopAction,
        startResource: resourceCollection.startResource,
        stopResource: resourceCollection.stopResource,
        addEvent: eventCollection.addEvent,
        addError: addError,
        addTiming: addTiming,
        setLoadingTime: setLoadingTime,
        addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
        startView: startView,
        setViewContext: setViewContext,
        setViewContextProperty: setViewContextProperty,
        getViewContext: getViewContext,
        setViewName: setViewName,
        viewHistory: viewHistory,
        sessionManager: sessionManager,
        stopSession: ()=>sessionManager.expire(),
        getInternalContext: internalContext.get,
        startDurationVital: vitalCollection.startDurationVital,
        stopDurationVital: vitalCollection.stopDurationVital,
        addDurationVital: vitalCollection.addDurationVital,
        addOperationStepVital: vitalCollection.addOperationStepVital,
        globalContext: globalContext,
        userContext: userContext,
        accountContext: accountContext,
        stop: ()=>cleanupTasks.forEach((task)=>task())
    };
}

});
parcelRegister("iKo11", function(module, exports) {

$parcel$export(module.exports, "createWindowOpenObservable", function () { return $0ffa55af9d1074d0$export$7c27c71faac0cc07; });

var $74beb = parcelRequire("74beb");
var $fnvkG = parcelRequire("fnvkG");
//#region src/browser/windowOpenObservable.ts
function $0ffa55af9d1074d0$export$7c27c71faac0cc07() {
    const observable = new (0, $fnvkG.Observable)();
    const { stop: stop } = (0, $74beb.instrumentMethod)(window, "open", ()=>observable.notify());
    return {
        observable: observable,
        stop: stop
    };
}

});
parcelRegister("74beb", function(module, exports) {

$parcel$export(module.exports, "instrumentMethod", function () { return $fe0d94a0f674c1e7$export$f00f71a511cb3cac; });
$parcel$export(module.exports, "instrumentConstructor", function () { return $fe0d94a0f674c1e7$export$9e5c262fbe128628; });
$parcel$export(module.exports, "instrumentSetter", function () { return $fe0d94a0f674c1e7$export$2a2b9a3e88aa9011; });

var $foX5P = parcelRequire("foX5P");

var $hH6Lc = parcelRequire("hH6Lc");

var $e6zeV = parcelRequire("e6zeV");

var $dee0n = parcelRequire("dee0n");
//#region src/tools/instrumentMethod.ts
/**
* Instruments a method on a object, calling the given callback before the original method is
* invoked. The callback receives an object with information about the method call.
*
* This function makes sure that we are "good citizens" regarding third party instrumentations: when
* removing the instrumentation, the original method is usually restored, but if a third party
* instrumentation was set after ours, we keep it in place and just replace our instrumentation with
* a noop.
*
* Note: it is generally better to instrument methods that are "owned" by the object instead of ones
* that are inherited from the prototype chain. Example:
* * do:    `instrumentMethod(Array.prototype, 'push', ...)`
* * don't: `instrumentMethod([], 'push', ...)`
*
* This method is also used to set event handler properties (ex: window.onerror = ...), as it has
* the same requirements as instrumenting a method:
* * if the event handler is already set by a third party, we need to call it and not just blindly
* override it.
* * if the event handler is set by a third party after us, we need to keep it in place when
* removing ours.
*
* To instrument a constructor @see {@link instrumentConstructor}.
*
* @example
*
*  instrumentMethod(window, 'fetch', ({ target, parameters, onPostCall }) => {
*    console.log('Before calling fetch on', target, 'with parameters', parameters)
*
*    onPostCall((result) => {
*      console.log('After fetch calling on', target, 'with parameters', parameters, 'and result', result)
*    })
*  })
*/ function $fe0d94a0f674c1e7$export$f00f71a511cb3cac(targetPrototype, method, onPreCall, { computeHandlingStack: computeHandlingStack } = {}) {
    let original = targetPrototype[method];
    if (typeof original !== "function") {
        if (method in targetPrototype && typeof method === "string" && method.startsWith("on")) original = (0, $hH6Lc.noop);
        else return {
            stop: (0, $hH6Lc.noop)
        };
    }
    let stopped = false;
    const instrumentation = function() {
        if (stopped) return original.apply(this, arguments);
        const parameters = Array.from(arguments);
        return $fe0d94a0f674c1e7$var$notifyInstrumentation(onPreCall, {
            target: this,
            parameters: parameters,
            handlingStack: computeHandlingStack ? (0, $e6zeV.createHandlingStack)("instrumented method") : void 0
        }, ()=>original.apply(this, parameters));
    };
    const { stop: restoreOriginal } = $fe0d94a0f674c1e7$var$replaceWithInstrumentation(targetPrototype, method, original, instrumentation);
    return {
        stop: ()=>{
            stopped = true;
            restoreOriginal();
        }
    };
}
/**
* Instruments a constructor on an object (typically a global, e.g. `window.WebSocket`), calling the
* given callback before the original constructor is invoked. The callback receives an object with
* information about the constructor call, and can register an `onPostCall` callback to be notified
* with the constructed instance.
*
* Like `instrumentMethod`, this is a "good citizen" regarding third party instrumentations: stopping
* restores the original constructor unless a third party replaced it afterwards.
*
* The wrapper preserves the original prototype (so `instanceof` keeps working), the original
* `new.target` (so constructors that inspect it behave as if not instrumented), the original
* static members (e.g. `WebSocket.OPEN`), and `instance.constructor ===` so checks like
* `new WebSocket(url).constructor === WebSocket` stay true.
*
* @see {@link preserveConstructorShape} for limitations on static members preservation.
* @example
*
*  instrumentConstructor(window, 'WebSocket', ({ parameters, onPostCall }) => {
*    console.log('Before constructing WebSocket with parameters', parameters)
*
*    onPostCall((instance) => {
*      console.log('Constructed WebSocket instance', instance)
*    })
*  })
*/ function $fe0d94a0f674c1e7$export$9e5c262fbe128628(container, constructor, onPreCall, { computeHandlingStack: computeHandlingStack } = {}) {
    const original = container[constructor];
    if (typeof original !== "function" || $fe0d94a0f674c1e7$var$isReadOnly(container, constructor)) return {
        stop: (0, $hH6Lc.noop)
    };
    let stopped = false;
    const instrumentation = function() {
        if (!new.target) return Reflect.apply(original, this, Array.from(arguments));
        const newTarget = new.target === instrumentation ? original : new.target;
        if (stopped) return Reflect.construct(original, arguments, newTarget);
        const parameters = Array.from(arguments);
        return $fe0d94a0f674c1e7$var$notifyInstrumentation(onPreCall, {
            parameters: parameters,
            handlingStack: computeHandlingStack ? (0, $e6zeV.createHandlingStack)("instrumented constructor") : void 0
        }, ()=>Reflect.construct(original, parameters, newTarget));
    };
    const restorePrototypeConstructor = $fe0d94a0f674c1e7$var$preserveConstructorShape(instrumentation, original);
    const { stop: restoreOriginal } = $fe0d94a0f674c1e7$var$replaceWithInstrumentation(container, constructor, original, instrumentation);
    return {
        stop: ()=>{
            stopped = true;
            restorePrototypeConstructor();
            restoreOriginal();
        }
    };
}
/**
* Replaces `targetPrototype[method]` with the provided instrumentation and
* returns a `stop` function restoring the original (unless a third party replaced us afterwards).
*/ function $fe0d94a0f674c1e7$var$replaceWithInstrumentation(targetPrototype, method, original, instrumentation) {
    if ($fe0d94a0f674c1e7$var$isReadOnly(targetPrototype, method)) return {
        stop: (0, $hH6Lc.noop)
    };
    targetPrototype[method] = instrumentation;
    return {
        stop: ()=>{
            if (targetPrototype[method] === instrumentation) targetPrototype[method] = original;
        }
    };
}
function $fe0d94a0f674c1e7$var$isReadOnly(target, property) {
    const descriptor = Object.getOwnPropertyDescriptor(target, property);
    return !!descriptor && !descriptor.writable && !descriptor.set;
}
/**
* Runs the pre-call callback (injecting the `onPostCall` registration), invokes the original
* method/constructor, then runs the registered post-call callback with the result.
*
* Note: the handling stack must be computed by the caller (at the topmost position of the call
* stack), so it is part of `baseCallInfo` rather than computed here.
*/ function $fe0d94a0f674c1e7$var$notifyInstrumentation(onPreCall, baseCallInfo, invokeOriginal) {
    let postCallCallback;
    (0, $dee0n.callMonitored)(onPreCall, null, [
        {
            ...baseCallInfo,
            onPostCall: (callback)=>{
                postCallCallback = callback;
            }
        }
    ]);
    const result = invokeOriginal();
    if (postCallCallback) (0, $dee0n.callMonitored)(postCallCallback, null, [
        result
    ]);
    return result;
}
/**
* Copies the original constructor prototype and other static members onto the instrumentation, so that
* `instanceof` checks keep working and statics such as `WebSocket.OPEN` remain available while
* instrumented.
*
* Returns a function that restores `prototype.constructor` to its prior descriptor; call it
* before restoring the global property in `stop()`.
*/ function $fe0d94a0f674c1e7$var$preserveConstructorShape(instrumentation, original) {
    /**
	* Limitation: Only the original's *own* static members are copied. Statics inherited through the
	* constructor's prototype chain (e.g. `class Child extends Parent` where `Parent` defines statics)
	* are not preserved, since the instrumentation still inherits from `Function.prototype`. This is
	* acceptable for the globals we instrument (e.g. `WebSocket`, whose own statics are the only ones
	* that matter), but we would need to delegate the static prototype chain to support subclassed
	* constructors with meaningful inherited statics.
	*/ for (const key of [].concat(Object.getOwnPropertyNames(original), Object.getOwnPropertySymbols(original))){
        const descriptor = Object.getOwnPropertyDescriptor(original, key);
        Object.defineProperty(instrumentation, key, descriptor);
    }
    const { stop: restoreOriginalConstructor } = $fe0d94a0f674c1e7$var$replaceWithInstrumentation(original.prototype, "constructor", original.prototype.constructor, instrumentation);
    return restoreOriginalConstructor;
}
function $fe0d94a0f674c1e7$export$2a2b9a3e88aa9011(targetPrototype, property, after) {
    const originalDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, property);
    if (!originalDescriptor?.set || !originalDescriptor.configurable) return {
        stop: (0, $hH6Lc.noop)
    };
    const stoppedInstrumentation = (0, $hH6Lc.noop);
    let instrumentation = (target, value)=>{
        (0, $foX5P.setTimeout)(()=>{
            if (instrumentation !== stoppedInstrumentation) after(target, value);
        }, 0);
    };
    const instrumentationWrapper = function(value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(targetPrototype, property, {
        set: instrumentationWrapper
    });
    return {
        stop: ()=>{
            if (Object.getOwnPropertyDescriptor(targetPrototype, property)?.set === instrumentationWrapper) Object.defineProperty(targetPrototype, property, originalDescriptor);
            instrumentation = stoppedInstrumentation;
        }
    };
}

});


parcelRegister("hbF4A", function(module, exports) {

$parcel$export(module.exports, "startInternalContext", function () { return $709bd4ffd27c3e30$export$ee941cf091e8459; });
//#region src/domain/contexts/internalContext.ts
/**
* Internal context keep returning v1 format
* to not break compatibility with logs data format
*/ function $709bd4ffd27c3e30$export$ee941cf091e8459(applicationId, sessionManager, viewHistory, actionContexts, urlContexts) {
    return {
        get: (startTime)=>{
            const viewContext = viewHistory.findView(startTime);
            const urlContext = urlContexts.findUrl(startTime);
            const session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                const actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? {
                        id: actionId
                    } : void 0,
                    view: {
                        id: viewContext.id,
                        name: viewContext.name,
                        referrer: urlContext.referrer,
                        url: urlContext.url
                    }
                };
            }
        }
    };
}

});

parcelRegister("fSFKy", function(module, exports) {

$parcel$export(module.exports, "startRequestCollection", function () { return $bc8b78ee2523fcfd$export$254c90b445eb4949; });
parcelRequire("jNZRV");

var $38LZB = parcelRequire("38LZB");

var $htShQ = parcelRequire("htShQ");

var $02H2D = parcelRequire("02H2D");

var $1wrwm = parcelRequire("1wrwm");

var $lePkT = parcelRequire("lePkT");
var $lEi17 = parcelRequire("lEi17");
var $gRy7g = parcelRequire("gRy7g");
var $iXofQ = parcelRequire("iXofQ");
//#region src/domain/requestCollection.ts
let $bc8b78ee2523fcfd$var$nextRequestIndex = 1;
function $bc8b78ee2523fcfd$export$254c90b445eb4949(lifeCycle, configuration, sessionManager, userContext, accountContext, bufferedDataObservable) {
    const tracer = (0, $htShQ.startTracer)(configuration, sessionManager, userContext, accountContext);
    $bc8b78ee2523fcfd$export$cbfd392b1e1a167d(lifeCycle, tracer, bufferedDataObservable);
    $bc8b78ee2523fcfd$export$2862eaaabb376c8d(lifeCycle, configuration, tracer, bufferedDataObservable);
}
function $bc8b78ee2523fcfd$export$cbfd392b1e1a167d(lifeCycle, tracer, bufferedDataObservable) {
    const subscriptions = [];
    subscriptions.push((0, $gRy7g.initXhrObservable)().subscribe((context)=>{
        if (context.state === "start" && (0, $38LZB.isAllowedRequestUrl)(context.url)) {
            tracer.traceXhr(context, context.xhr);
            $bc8b78ee2523fcfd$var$assignRequestIndex(context);
        }
    }));
    subscriptions.push(bufferedDataObservable.subscribe(({ data: data, type: type })=>{
        if (type !== (0, $lePkT.BufferedDataType).XHR) return;
        const context = data;
        if (!(0, $38LZB.isAllowedRequestUrl)(context.url)) return;
        switch(context.state){
            case "start":
                $bc8b78ee2523fcfd$var$assignRequestIndex(context);
                lifeCycle.notify(7, {
                    requestIndex: context.requestIndex,
                    url: context.url
                });
                break;
            case "complete":
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(8, {
                    ...context,
                    type: (0, $iXofQ.RequestType).XHR,
                    isAbortedOnStart: false
                });
        }
    }));
    return {
        stop: ()=>subscriptions.forEach((subscription)=>subscription.unsubscribe())
    };
}
function $bc8b78ee2523fcfd$export$2862eaaabb376c8d(lifeCycle, configuration, tracer, bufferedDataObservable) {
    const subscriptions = [];
    subscriptions.push((0, $lEi17.initFetchObservable)({
        responseBodyAction: (context)=>{
            if ((0, $02H2D.findGraphQlConfiguration)(context.url, configuration)?.trackResponseErrors) return (0, $lEi17.ResponseBodyAction).COLLECT;
            return (0, $lEi17.ResponseBodyAction).IGNORE;
        }
    }).subscribe((context)=>{
        if (context.state === "start" && (0, $38LZB.isAllowedRequestUrl)(context.url)) {
            tracer.traceFetch(context);
            $bc8b78ee2523fcfd$var$assignRequestIndex(context);
        }
    }));
    subscriptions.push(bufferedDataObservable.subscribe(({ data: data, type: type })=>{
        if (type !== (0, $lePkT.BufferedDataType).FETCH) return;
        const context = data;
        if (!(0, $38LZB.isAllowedRequestUrl)(context.url)) return;
        switch(context.state){
            case "start":
                $bc8b78ee2523fcfd$var$assignRequestIndex(context);
                lifeCycle.notify(7, {
                    requestIndex: context.requestIndex,
                    url: context.url
                });
                break;
            case "resolve":
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(8, {
                    ...context,
                    duration: (0, $1wrwm.elapsed)(context.startClocks.timeStamp, (0, $1wrwm.timeStampNow)()),
                    type: (0, $iXofQ.RequestType).FETCH,
                    requestBody: context.init?.body
                });
        }
    }));
    return {
        stop: ()=>subscriptions.forEach((subscription)=>subscription.unsubscribe())
    };
}
function $bc8b78ee2523fcfd$var$assignRequestIndex(context) {
    if (!context.requestIndex) context.requestIndex = $bc8b78ee2523fcfd$var$nextRequestIndex++;
}

});
parcelRegister("htShQ", function(module, exports) {

$parcel$export(module.exports, "startTracer", function () { return $d1ac18df0e7651bf$export$faa83af43a19aa4b; });

var $j3F15 = parcelRequire("j3F15");

var $gS0nt = parcelRequire("gS0nt");
var $i1EVG = parcelRequire("i1EVG");
var $jM84O = parcelRequire("jM84O");
var $2faqW = parcelRequire("2faqW");
var $brKlt = parcelRequire("brKlt");
var $9O7SB = parcelRequire("9O7SB");
//#region src/domain/tracing/tracer.ts
/**
* Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
* request did not reach the server, but the browser does not expose this. So, we clear tracing
* information if the request ended with status 0 without being aborted by the application.
*
* Reasoning:
*
* * Applications are usually aborting requests after a bit of time, for example when the user is
* typing (autocompletion) or navigating away (in a SPA). With a performant device and good
* network conditions, the request is likely to reach the server before being canceled.
*
* * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
* are likely to finish quickly and without reaching the server.
*
* Of course, it might not be the case every time, but it should limit having incomplete traces a
* bit.
* */ function $d1ac18df0e7651bf$export$5fcd137715d2568d(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = void 0;
        context.spanId = void 0;
        context.traceSampled = void 0;
    }
}
function $d1ac18df0e7651bf$export$faa83af43a19aa4b(configuration, sessionManager, userContext, accountContext) {
    return {
        clearTracingIfNeeded: $d1ac18df0e7651bf$export$5fcd137715d2568d,
        traceFetch: (context)=>$d1ac18df0e7651bf$var$injectHeadersIfTracingAllowed(configuration, context, sessionManager, userContext, accountContext, (tracingHeaders)=>{
                if (context.input instanceof Request && !context.init?.headers) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach((key)=>{
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                } else {
                    context.init = (0, $brKlt.shallowClone)(context.init);
                    const headers = [];
                    if (context.init.headers instanceof Headers) context.init.headers.forEach((value, key)=>{
                        headers.push([
                            key,
                            value
                        ]);
                    });
                    else if (Array.isArray(context.init.headers)) context.init.headers.forEach((header)=>{
                        headers.push(header);
                    });
                    else if (context.init.headers) Object.keys(context.init.headers).forEach((key)=>{
                        headers.push([
                            key,
                            context.init.headers[key]
                        ]);
                    });
                    context.init.headers = headers.concat((0, $2faqW.objectEntries)(tracingHeaders));
                }
            }),
        traceXhr: (context, xhr)=>$d1ac18df0e7651bf$var$injectHeadersIfTracingAllowed(configuration, context, sessionManager, userContext, accountContext, (tracingHeaders)=>{
                try {
                    Object.keys(tracingHeaders).forEach((name)=>{
                        xhr.setRequestHeader(name, tracingHeaders[name]);
                    });
                } catch  {}
            })
    };
}
function $d1ac18df0e7651bf$var$injectHeadersIfTracingAllowed(configuration, context, sessionManager, userContext, accountContext, inject) {
    const session = sessionManager.findTrackedSession();
    if (!session) return;
    const tracingOption = configuration.allowedTracingUrls.find((tracingOption)=>(0, $jM84O.matchList)([
            tracingOption.match
        ], context.url, true));
    if (!tracingOption) return;
    const fallbackTraceSampled = (0, $i1EVG.isSampled)(session.id, (0, $i1EVG.correctedChildSampleRate)(configuration.sessionSampleRate, configuration.traceSampleRate));
    const traceSampled = (0, $gS0nt.canUseEventBridge)() ? (0, $gS0nt.getEventBridge)()?.getIsTraceSampled() ?? fallbackTraceSampled : fallbackTraceSampled;
    if (!(traceSampled || configuration.traceContextInjection === (0, $9O7SB.TraceContextInjection).ALL)) return;
    context.traceSampled = traceSampled;
    context.traceId = (0, $j3F15.createTraceIdentifier)();
    context.spanId = (0, $j3F15.createSpanIdentifier)();
    inject($d1ac18df0e7651bf$var$makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, session.id, tracingOption.propagatorTypes, userContext, accountContext, configuration));
}
/**
* When trace is not sampled, set priority to '0' instead of not adding the tracing headers
* to prepare the implementation for sampling delegation.
*/ function $d1ac18df0e7651bf$var$makeTracingHeaders(traceId, spanId, traceSampled, sessionId, propagatorTypes, userContext, accountContext, configuration) {
    const tracingHeaders = {};
    propagatorTypes.forEach((propagatorType)=>{
        switch(propagatorType){
            case "datadog":
                Object.assign(tracingHeaders, {
                    "x-datadog-origin": "rum",
                    "x-datadog-parent-id": spanId.toString(),
                    "x-datadog-sampling-priority": traceSampled ? "1" : "0",
                    "x-datadog-trace-id": traceId.toString()
                });
                break;
            case "tracecontext":
                Object.assign(tracingHeaders, {
                    traceparent: `00-0000000000000000${(0, $j3F15.toPaddedHexadecimalString)(traceId)}-${(0, $j3F15.toPaddedHexadecimalString)(spanId)}-0${traceSampled ? "1" : "0"}`,
                    tracestate: `dd=s:${traceSampled ? "1" : "0"};o:rum`
                });
                break;
            case "b3":
                Object.assign(tracingHeaders, {
                    b3: `${(0, $j3F15.toPaddedHexadecimalString)(traceId)}-${(0, $j3F15.toPaddedHexadecimalString)(spanId)}-${traceSampled ? "1" : "0"}`
                });
                break;
            case "b3multi":
                Object.assign(tracingHeaders, {
                    "X-B3-TraceId": (0, $j3F15.toPaddedHexadecimalString)(traceId),
                    "X-B3-SpanId": (0, $j3F15.toPaddedHexadecimalString)(spanId),
                    "X-B3-Sampled": traceSampled ? "1" : "0"
                });
        }
    });
    if (configuration.propagateTraceBaggage) {
        const baggageItems = {
            "session.id": sessionId
        };
        const userId = userContext.getContext().id;
        if (typeof userId === "string") baggageItems["user.id"] = userId;
        const accountId = accountContext.getContext().id;
        if (typeof accountId === "string") baggageItems["account.id"] = accountId;
        const baggageHeader = Object.entries(baggageItems).map(([key, value])=>`${key}=${encodeURIComponent(value)}`).join(",");
        if (baggageHeader) tracingHeaders["baggage"] = baggageHeader;
    }
    return tracingHeaders;
}

});
parcelRegister("j3F15", function(module, exports) {

$parcel$export(module.exports, "createTraceIdentifier", function () { return $69144822f8a99e50$export$d0df1a1c84fa9037; });
$parcel$export(module.exports, "createSpanIdentifier", function () { return $69144822f8a99e50$export$42e322be3a41cf8f; });
$parcel$export(module.exports, "toPaddedHexadecimalString", function () { return $69144822f8a99e50$export$8c28a7bcd86c533; });
//#region src/domain/tracing/identifier.ts
function $69144822f8a99e50$export$d0df1a1c84fa9037() {
    return $69144822f8a99e50$var$createIdentifier(64);
}
function $69144822f8a99e50$export$42e322be3a41cf8f() {
    return $69144822f8a99e50$var$createIdentifier(63);
}
function $69144822f8a99e50$var$createIdentifier(bits) {
    const buffer = crypto.getRandomValues(/* @__PURE__ */ new Uint32Array(2));
    let value = BigInt(buffer[0]) + (BigInt(buffer[1]) << 32n);
    if (bits === 63) value &= 9223372036854775807n;
    return value;
}
function $69144822f8a99e50$export$8c28a7bcd86c533(id) {
    return id.toString(16).padStart(16, "0");
}

});

parcelRegister("jM84O", function(module, exports) {

$parcel$export(module.exports, "matchList", function () { return $d16f0e575ba030f5$export$eb5a30555469227; });

var $jq8c3 = parcelRequire("jq8c3");
//#region src/tools/matchOption.ts
/**
* Returns true if value can be matched by at least one of the provided MatchOptions.
* When comparing strings, setting useStartsWith to true will compare the value with the start of
* the option, instead of requiring an exact match.
*/ function $d16f0e575ba030f5$export$eb5a30555469227(list, value, useStartsWith = false) {
    return list.some((item)=>{
        try {
            if (typeof item === "function") return item(value);
            else if (item instanceof RegExp) {
                item.lastIndex = 0;
                return item.test(value);
            } else if (typeof item === "string") return useStartsWith ? value.startsWith(item) : item === value;
        } catch (e) {
            (0, $jq8c3.display).error(e);
        }
        return false;
    });
}

});


parcelRegister("02H2D", function(module, exports) {

$parcel$export(module.exports, "extractGraphQlMetadata", function () { return $959deedeec8b169e$export$9cb22fe4fb9b2782; });
$parcel$export(module.exports, "findGraphQlConfiguration", function () { return $959deedeec8b169e$export$8356908c1c4aedc8; });

var $kRkcp = parcelRequire("kRkcp");

var $5kKbc = parcelRequire("5kKbc");
var $jM84O = parcelRequire("jM84O");
var $eTAnO = parcelRequire("eTAnO");
var $bWkrj = parcelRequire("bWkrj");
var $brKlt = parcelRequire("brKlt");
//#region src/domain/resource/graphql.ts
/**
* arbitrary value, byte precision not needed
*/ const $959deedeec8b169e$var$GRAPHQL_PAYLOAD_LIMIT = 32 * (0, $eTAnO.ONE_KIBI_BYTE);
function $959deedeec8b169e$export$9cb22fe4fb9b2782(request, graphQlConfig) {
    const metadata = $959deedeec8b169e$export$a90c538f03fea897(request, graphQlConfig.trackPayload);
    if (!metadata) return;
    if (graphQlConfig.trackResponseErrors && request.responseBody) {
        const responseErrors = $959deedeec8b169e$export$8e9c0b4437eedbc6(request.responseBody);
        if (responseErrors) {
            metadata.error_count = responseErrors.length;
            metadata.errors = responseErrors;
        }
    }
    return metadata;
}
function $959deedeec8b169e$export$8e9c0b4437eedbc6(responseText) {
    const response = (0, $brKlt.tryJsonParse)(responseText);
    if (!response || typeof response !== "object") return;
    const responseObj = response;
    if (!(0, $5kKbc.isNonEmptyArray)(responseObj.errors)) return;
    return responseObj.errors.map((error)=>{
        return {
            message: error.message,
            path: error.path,
            locations: error.locations,
            code: error.extensions?.code
        };
    });
}
function $959deedeec8b169e$export$8356908c1c4aedc8(url, configuration) {
    return configuration.allowedGraphQlUrls.find((graphQlOption)=>(0, $jM84O.matchList)([
            graphQlOption.match
        ], url));
}
function $959deedeec8b169e$export$a90c538f03fea897(request, trackPayload = false) {
    let rawMetadata;
    if (request.method === "POST") rawMetadata = $959deedeec8b169e$var$extractFromBody(request.requestBody);
    else if (request.method === "GET") rawMetadata = $959deedeec8b169e$var$extractFromUrlQueryParams(request.url);
    if (!rawMetadata) return;
    return $959deedeec8b169e$var$sanitizeGraphQlMetadata(rawMetadata, trackPayload);
}
function $959deedeec8b169e$var$extractFromBody(requestBody) {
    if (!requestBody || typeof requestBody !== "string") return;
    const graphqlBody = (0, $brKlt.tryJsonParse)(requestBody);
    if (!graphqlBody) return;
    return {
        query: graphqlBody.query,
        operationName: graphqlBody.operationName,
        variables: graphqlBody.variables ? JSON.stringify(graphqlBody.variables) : void 0,
        operationType: graphqlBody.operationType
    };
}
function $959deedeec8b169e$var$extractFromUrlQueryParams(url) {
    const searchParams = (0, $kRkcp.buildUrl)(url).searchParams;
    const variablesParam = searchParams.get("variables");
    const variables = variablesParam && (0, $brKlt.tryJsonParse)(variablesParam) !== void 0 ? variablesParam : void 0;
    return {
        query: searchParams.get("query") || void 0,
        operationName: searchParams.get("operationName") || void 0,
        variables: variables,
        operationType: searchParams.get("operationType") || void 0
    };
}
function $959deedeec8b169e$var$sanitizeGraphQlMetadata(rawMetadata, trackPayload) {
    let operationType;
    let payload;
    let variables;
    if (rawMetadata.query) {
        const trimmedQuery = rawMetadata.query.trim();
        operationType = $959deedeec8b169e$var$getOperationType(trimmedQuery);
        if (trackPayload) payload = (0, $bWkrj.safeTruncate)(trimmedQuery, $959deedeec8b169e$var$GRAPHQL_PAYLOAD_LIMIT, "...");
    }
    if (!operationType) {
        const bodyType = rawMetadata.operationType;
        if (bodyType === "query" || bodyType === "mutation" || bodyType === "subscription") operationType = bodyType;
    }
    if (rawMetadata.variables) variables = rawMetadata.variables;
    return {
        operationType: operationType,
        operationName: rawMetadata.operationName,
        variables: variables,
        payload: payload
    };
}
function $959deedeec8b169e$var$getOperationType(query) {
    return query.match(/^\s*(query|mutation|subscription)\b/i)?.[1];
}

});

parcelRegister("lePkT", function(module, exports) {

$parcel$export(module.exports, "BufferedDataType", function () { return $ce13a368a3b93bb5$export$66eb5b0febac973b; });
$parcel$export(module.exports, "startBufferingData", function () { return $ce13a368a3b93bb5$export$8be22dc4343dffdd; });

var $fnvkG = parcelRequire("fnvkG");

var $bOZaS = parcelRequire("bOZaS");

var $461Vl = parcelRequire("461Vl");

var $4pKFz = parcelRequire("4pKFz");

var $gRy7g = parcelRequire("gRy7g");

var $lEi17 = parcelRequire("lEi17");

var $boE7L = parcelRequire("boE7L");

var $6PIx8 = parcelRequire("6PIx8");
//#region src/domain/bufferedData.ts
const $ce13a368a3b93bb5$var$BUFFER_LIMIT = 500;
let $ce13a368a3b93bb5$export$66eb5b0febac973b = /* @__PURE__ */ function(BufferedDataType) {
    BufferedDataType[BufferedDataType["RUNTIME_ERROR"] = 0] = "RUNTIME_ERROR";
    BufferedDataType[BufferedDataType["FETCH"] = 1] = "FETCH";
    BufferedDataType[BufferedDataType["XHR"] = 2] = "XHR";
    BufferedDataType[BufferedDataType["CONSOLE"] = 3] = "CONSOLE";
    return BufferedDataType;
}({});
function $ce13a368a3b93bb5$export$8be22dc4343dffdd() {
    const observable = new (0, $fnvkG.BufferedObservable)($ce13a368a3b93bb5$var$BUFFER_LIMIT, (count)=>{
        (0, $461Vl.addTelemetryDebug)("Early data collection dropped data on unbuffer", {
            count: count
        });
    });
    const subscriptions = [];
    function subscribe(type, source) {
        subscriptions.push(source.subscribe((data)=>{
            observable.notify({
                type: type,
                data: data
            });
        }));
    }
    subscribe(0, (0, $bOZaS.mockable)((0, $4pKFz.trackRuntimeError))());
    subscribe(1, (0, $lEi17.initFetchObservable)());
    subscribe(2, (0, $gRy7g.initXhrObservable)());
    subscribe(3, (0, $boE7L.initConsoleObservable)(Object.values((0, $6PIx8.ConsoleApiName))));
    return {
        observable: observable,
        stop: ()=>subscriptions.forEach((subscription)=>subscription.unsubscribe())
    };
}

});
parcelRegister("4pKFz", function(module, exports) {

$parcel$export(module.exports, "trackRuntimeError", function () { return $9a8535602bf98ea3$export$5f76c2084a9e04d; });

var $fnvkG = parcelRequire("fnvkG");

var $hH6Lc = parcelRequire("hH6Lc");

var $fiOtf = parcelRequire("fiOtf");

var $74beb = parcelRequire("74beb");

var $50cui = parcelRequire("50cui");

var $cWoRJ = parcelRequire("cWoRJ");

var $7RJVj = parcelRequire("7RJVj");

var $SMkA1 = parcelRequire("SMkA1");

var $c2Qhr = parcelRequire("c2Qhr");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/error/trackRuntimeError.ts
function $9a8535602bf98ea3$export$5f76c2084a9e04d() {
    return new (0, $fnvkG.Observable)((observer)=>{
        const handleRuntimeError = (originalError, stackTrace)=>{
            const rawError = (0, $SMkA1.computeRawError)({
                stackTrace: stackTrace,
                originalError: originalError,
                startClocks: (0, $1wrwm.clocksNow)(),
                nonErrorPrefix: "Uncaught",
                source: (0, $7RJVj.ErrorSource).SOURCE,
                handling: "unhandled"
            });
            observer.notify(rawError);
        };
        const { stop: stopInstrumentingOnError } = $9a8535602bf98ea3$export$f636584f9e54fd1(handleRuntimeError);
        const { stop: stopInstrumentingOnUnhandledRejection } = $9a8535602bf98ea3$export$fac10d06c5b5cb33(handleRuntimeError);
        return ()=>{
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        };
    });
}
function $9a8535602bf98ea3$export$f636584f9e54fd1(callback) {
    return (0, $74beb.instrumentMethod)((0, $c2Qhr.globalObject), "onerror", ({ parameters: [messageObj, url, line, column, errorObj] })=>{
        let stackTrace;
        if (!(0, $cWoRJ.isError)(errorObj)) stackTrace = (0, $fiOtf.computeStackTraceFromOnErrorMessage)(messageObj, url, line, column);
        callback(errorObj ?? messageObj, stackTrace);
    });
}
function $9a8535602bf98ea3$export$fac10d06c5b5cb33(callback) {
    if (!(0, $50cui.isEventSupported)((0, $c2Qhr.globalObject).window, "unhandledrejection")) return {
        stop: (0, $hH6Lc.noop)
    };
    return (0, $74beb.instrumentMethod)((0, $c2Qhr.globalObject), "onunhandledrejection", ({ parameters: [e] })=>{
        callback(e.reason || "Empty reason");
    });
}

});
parcelRegister("7RJVj", function(module, exports) {

$parcel$export(module.exports, "ErrorSource", function () { return $88b05a51a51857b8$export$4f7d2dba9330699b; });
$parcel$export(module.exports, "NonErrorPrefix", function () { return $88b05a51a51857b8$export$405ae474f65bdd7d; });
$parcel$export(module.exports, "ErrorHandling", function () { return $88b05a51a51857b8$export$b648208ff1c161a7; });
//#region src/domain/error/error.types.ts
const $88b05a51a51857b8$export$4f7d2dba9330699b = {
    AGENT: "agent",
    CONSOLE: "console",
    CUSTOM: "custom",
    LOGGER: "logger",
    NETWORK: "network",
    SOURCE: "source",
    REPORT: "report"
};
let $88b05a51a51857b8$export$405ae474f65bdd7d = /* @__PURE__ */ function(NonErrorPrefix) {
    NonErrorPrefix["UNCAUGHT"] = "Uncaught";
    NonErrorPrefix["PROVIDED"] = "Provided";
    return NonErrorPrefix;
}({});
let $88b05a51a51857b8$export$b648208ff1c161a7 = /* @__PURE__ */ function(ErrorHandling) {
    ErrorHandling["HANDLED"] = "handled";
    ErrorHandling["UNHANDLED"] = "unhandled";
    return ErrorHandling;
}({});

});

parcelRegister("SMkA1", function(module, exports) {

$parcel$export(module.exports, "getStackTraceUrls", function () { return $2e60c6a08e7fee34$export$98a9efa2bc5ef86e; });
$parcel$export(module.exports, "computeRawError", function () { return $2e60c6a08e7fee34$export$b8dc46b79c72ee26; });
$parcel$export(module.exports, "getFileFromStackTraceString", function () { return $2e60c6a08e7fee34$export$edc1986890374033; });

var $fiOtf = parcelRequire("fiOtf");

var $e6zeV = parcelRequire("e6zeV");

var $gnsX5 = parcelRequire("gnsX5");

var $hpOLz = parcelRequire("hpOLz");

var $cWoRJ = parcelRequire("cWoRJ");

var $cDxUX = parcelRequire("cDxUX");

var $bF5dI = parcelRequire("bF5dI");
//#region src/domain/error/error.ts
function $2e60c6a08e7fee34$var$computeErrorBase({ originalError: originalError, stackTrace: stackTrace, source: source, useFallbackStack: useFallbackStack = true, nonErrorPrefix: nonErrorPrefix }) {
    const isErrorInstance = (0, $cWoRJ.isError)(originalError);
    return {
        source: source,
        type: stackTrace ? stackTrace.name : void 0,
        message: $2e60c6a08e7fee34$var$computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError),
        stack: stackTrace ? (0, $e6zeV.toStackTraceString)(stackTrace) : useFallbackStack ? (0, $cWoRJ.NO_ERROR_STACK_PRESENT_MESSAGE) : void 0
    };
}
function $2e60c6a08e7fee34$export$98a9efa2bc5ef86e(stackTrace) {
    return stackTrace?.stack.map((frame)=>frame.url).filter((url)=>!!url) ?? [];
}
function $2e60c6a08e7fee34$var$getErrorDebugIds(stackTrace, errorCauses) {
    const errorCausesUrls = errorCauses.flatMap(({ stackTrace: stackTrace })=>$2e60c6a08e7fee34$export$98a9efa2bc5ef86e(stackTrace));
    return (0, $cDxUX.buildDebugIdByUrl)($2e60c6a08e7fee34$export$98a9efa2bc5ef86e(stackTrace).concat(errorCausesUrls));
}
function $2e60c6a08e7fee34$export$bf9a979d43c83a9(error) {
    const chain = [];
    let current = error.cause;
    while(current !== void 0 && current !== null && chain.length < 10){
        const isCurrentError = (0, $cWoRJ.isError)(current);
        const stackTrace = isCurrentError ? (0, $fiOtf.computeStackTrace)(current) : void 0;
        chain.push({
            originalError: current,
            stackTrace: stackTrace
        });
        current = isCurrentError ? current.cause : void 0;
    }
    return chain;
}
function $2e60c6a08e7fee34$export$b8dc46b79c72ee26({ stackTrace: stackTrace, originalError: originalError, handlingStack: handlingStack, componentStack: componentStack, startClocks: startClocks, nonErrorPrefix: nonErrorPrefix, useFallbackStack: useFallbackStack = true, source: source, handling: handling }) {
    const errorStackTrace = stackTrace ?? ((0, $cWoRJ.isError)(originalError) ? (0, $fiOtf.computeStackTrace)(originalError) : void 0);
    const errorCauses = (0, $cWoRJ.isError)(originalError) ? $2e60c6a08e7fee34$export$bf9a979d43c83a9(originalError) : [];
    const errorBase = $2e60c6a08e7fee34$var$computeErrorBase({
        originalError: originalError,
        stackTrace: errorStackTrace,
        source: source,
        useFallbackStack: useFallbackStack,
        nonErrorPrefix: nonErrorPrefix
    });
    const rawErrorCauses = errorCauses.map(({ originalError: originalError, stackTrace: stackTrace })=>$2e60c6a08e7fee34$var$computeErrorBase({
            originalError: originalError,
            stackTrace: stackTrace,
            source: source,
            useFallbackStack: false
        }));
    return {
        startClocks: startClocks,
        handling: handling,
        handlingStack: handlingStack,
        componentStack: componentStack,
        originalError: originalError,
        ...errorBase,
        debugIds: $2e60c6a08e7fee34$var$getErrorDebugIds(errorStackTrace, errorCauses),
        causes: rawErrorCauses.length ? rawErrorCauses : void 0,
        fingerprint: $2e60c6a08e7fee34$export$1c18937f21a7f1f7(originalError),
        context: $2e60c6a08e7fee34$export$2f5123898fe3d684(originalError)
    };
}
function $2e60c6a08e7fee34$var$computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
    return stackTrace?.message && stackTrace?.name ? stackTrace.message : !isErrorInstance ? nonErrorPrefix ? `${nonErrorPrefix} ${(0, $gnsX5.jsonStringify)((0, $hpOLz.sanitize)(originalError))}` : (0, $gnsX5.jsonStringify)((0, $hpOLz.sanitize)(originalError)) : "Empty message";
}
function $2e60c6a08e7fee34$export$1c18937f21a7f1f7(originalError) {
    return (0, $cWoRJ.isError)(originalError) && "dd_fingerprint" in originalError ? String(originalError.dd_fingerprint) : void 0;
}
function $2e60c6a08e7fee34$export$2f5123898fe3d684(originalError) {
    if ((0, $bF5dI.isIndexableObject)(originalError)) return originalError.dd_context;
}
function $2e60c6a08e7fee34$export$edc1986890374033(stack) {
    return /@ (.+)/.exec(stack)?.[1];
}

});
parcelRegister("hpOLz", function(module, exports) {

$parcel$export(module.exports, "sanitize", function () { return $8191a34114235e0e$export$83d2e9e3e4ee39ed; });

var $jq8c3 = parcelRequire("jq8c3");

var $eTAnO = parcelRequire("eTAnO");

var $gnsX5 = parcelRequire("gnsX5");
//#region src/tools/serialisation/sanitize.ts
const $8191a34114235e0e$export$9e92fe25085833dd = 220 * (0, $eTAnO.ONE_KIBI_BYTE);
const $8191a34114235e0e$var$JSON_PATH_ROOT_ELEMENT = "$";
const $8191a34114235e0e$var$KEY_DECORATION_LENGTH = 3;
function $8191a34114235e0e$export$83d2e9e3e4ee39ed(source, maxCharacterCount = $8191a34114235e0e$export$9e92fe25085833dd) {
    const restoreObjectPrototypeToJson = (0, $gnsX5.detachToJsonMethod)(Object.prototype);
    const restoreArrayPrototypeToJson = (0, $gnsX5.detachToJsonMethod)(Array.prototype);
    try {
        const containerQueue = [];
        const visitedObjectsWithPath = /* @__PURE__ */ new WeakMap();
        const sanitizedData = $8191a34114235e0e$var$sanitizeProcessor(source, $8191a34114235e0e$var$JSON_PATH_ROOT_ELEMENT, void 0, containerQueue, visitedObjectsWithPath);
        const serializedSanitizedData = JSON.stringify(sanitizedData);
        let accumulatedCharacterCount = serializedSanitizedData ? serializedSanitizedData.length : 0;
        if (accumulatedCharacterCount > maxCharacterCount) {
            $8191a34114235e0e$var$warnOverCharacterLimit(maxCharacterCount, "discarded", source);
            return;
        }
        while(containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount){
            const containerToProcess = containerQueue.shift();
            let separatorLength = 0;
            if (Array.isArray(containerToProcess.source)) for(let key = 0; key < containerToProcess.source.length; key++){
                const targetData = $8191a34114235e0e$var$sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                if (targetData !== void 0) accumulatedCharacterCount += JSON.stringify(targetData).length;
                else accumulatedCharacterCount += 4;
                accumulatedCharacterCount += separatorLength;
                separatorLength = 1;
                if (accumulatedCharacterCount > maxCharacterCount) {
                    $8191a34114235e0e$var$warnOverCharacterLimit(maxCharacterCount, "truncated", source);
                    break;
                }
                containerToProcess.target[key] = targetData;
            }
            else for(const key in containerToProcess.source)if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
                const targetData = $8191a34114235e0e$var$sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                if (targetData !== void 0) {
                    accumulatedCharacterCount += JSON.stringify(targetData).length + separatorLength + key.length + $8191a34114235e0e$var$KEY_DECORATION_LENGTH;
                    separatorLength = 1;
                }
                if (accumulatedCharacterCount > maxCharacterCount) {
                    $8191a34114235e0e$var$warnOverCharacterLimit(maxCharacterCount, "truncated", source);
                    break;
                }
                containerToProcess.target[key] = targetData;
            }
        }
        return sanitizedData;
    } finally{
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
    }
}
/**
* Internal function to factorize the process common to the
* initial call to sanitize, and iterations for Arrays and Objects
*
*/ function $8191a34114235e0e$var$sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
    const sourceToSanitize = $8191a34114235e0e$var$tryToApplyToJSON(source);
    if (!sourceToSanitize || typeof sourceToSanitize !== "object") return $8191a34114235e0e$var$sanitizePrimitivesAndFunctions(sourceToSanitize);
    const sanitizedSource = $8191a34114235e0e$var$sanitizeObjects(sourceToSanitize);
    if (sanitizedSource !== "[Object]" && sanitizedSource !== "[Array]" && sanitizedSource !== "[Error]") return sanitizedSource;
    const sourceAsObject = source;
    if (visitedObjectsWithPath.has(sourceAsObject)) return `[Reference seen at ${visitedObjectsWithPath.get(sourceAsObject)}]`;
    const currentPath = key !== void 0 ? `${parentPath}.${key}` : parentPath;
    const target = Array.isArray(sourceToSanitize) ? [] : {};
    visitedObjectsWithPath.set(sourceAsObject, currentPath);
    queue.push({
        source: sourceToSanitize,
        target: target,
        path: currentPath
    });
    return target;
}
/**
* Handles sanitization of simple, non-object types
*
*/ function $8191a34114235e0e$var$sanitizePrimitivesAndFunctions(value) {
    if (typeof value === "bigint") return `[BigInt] ${value.toString()}`;
    if (typeof value === "function") return `[Function] ${value.name || "unknown"}`;
    if (typeof value === "symbol") return `[Symbol] ${value.description || value.toString()}`;
    return value;
}
/**
* Handles sanitization of object types
*
* LIMITATIONS
* - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
* To avoid this, a toJSON method can be defined.
*/ function $8191a34114235e0e$var$sanitizeObjects(value) {
    try {
        if (value instanceof Event) return $8191a34114235e0e$var$sanitizeEvent(value);
        if (value instanceof RegExp) return `[RegExp] ${value.toString()}`;
        const match = Object.prototype.toString.call(value).match(/\[object (.*)\]/);
        if (match?.[1]) return `[${match[1]}]`;
    } catch  {}
    return "[Unserializable]";
}
function $8191a34114235e0e$var$sanitizeEvent(event) {
    return {
        type: event.type,
        isTrusted: event.isTrusted,
        currentTarget: event.currentTarget ? $8191a34114235e0e$var$sanitizeObjects(event.currentTarget) : null,
        target: event.target ? $8191a34114235e0e$var$sanitizeObjects(event.target) : null
    };
}
/**
* Checks if a toJSON function exists and tries to execute it
*
*/ function $8191a34114235e0e$var$tryToApplyToJSON(value) {
    if ((typeof value !== "object" || value === null) && typeof value !== "function") return value;
    const object = value;
    if (typeof object.toJSON === "function") try {
        return object.toJSON();
    } catch  {}
    return value;
}
/**
* Helper function to display the warning when the accumulated character count is over the limit
*/ function $8191a34114235e0e$var$warnOverCharacterLimit(maxCharacterCount, changeType, source) {
    (0, $jq8c3.display).warn(`The data provided has been ${changeType} as it is over the limit of ${maxCharacterCount} characters:`, source);
}

});

parcelRegister("cDxUX", function(module, exports) {

$parcel$export(module.exports, "buildDebugIdByUrl", function () { return $3c2eea22514e3378$export$fe9f8fa70a5c34; });
$parcel$export(module.exports, "getSourceCodeContext", function () { return $3c2eea22514e3378$export$889450845d2a8007; });

var $fiOtf = parcelRequire("fiOtf");

var $461Vl = parcelRequire("461Vl");

var $c2Qhr = parcelRequire("c2Qhr");
//#region src/domain/sourceCodeContext.ts
const $3c2eea22514e3378$var$contextByUrl = /* @__PURE__ */ new Map();
const $3c2eea22514e3378$var$processedStacks = /* @__PURE__ */ new Set();
let $3c2eea22514e3378$var$hasFiredTelemetry = false;
function $3c2eea22514e3378$var$syncSourceCodeContext() {
    const sourceCodeContext = (0, $c2Qhr.globalObject).window?.DD_SOURCE_CODE_CONTEXT;
    if (!sourceCodeContext) return;
    let useDebugId = false;
    let useService = false;
    let useVersion = false;
    for (const [stack, entry] of Object.entries(sourceCodeContext)){
        useDebugId = useDebugId || entry.ddDebugId !== void 0;
        useService = useService || entry.service !== void 0;
        useVersion = useVersion || entry.version !== void 0;
        if ($3c2eea22514e3378$var$processedStacks.has(stack)) continue;
        $3c2eea22514e3378$var$processedStacks.add(stack);
        const url = (0, $fiOtf.computeStackTrace)({
            stack: stack
        }).stack[0]?.url;
        if (url && !$3c2eea22514e3378$var$contextByUrl.has(url)) $3c2eea22514e3378$var$contextByUrl.set(url, entry);
    }
    if (!$3c2eea22514e3378$var$hasFiredTelemetry) {
        $3c2eea22514e3378$var$hasFiredTelemetry = true;
        (0, $461Vl.addTelemetryUsage)({
            feature: "source-code-context",
            use_debug_id: useDebugId,
            use_service: useService,
            use_version: useVersion
        });
    }
}
function $3c2eea22514e3378$export$fe9f8fa70a5c34(urls) {
    $3c2eea22514e3378$var$syncSourceCodeContext();
    const seenUrls = /* @__PURE__ */ new Set();
    const debugIds = [];
    for (const url of urls){
        if (seenUrls.has(url)) continue;
        seenUrls.add(url);
        const debugId = $3c2eea22514e3378$var$contextByUrl.get(url)?.ddDebugId;
        if (debugId !== void 0) debugIds.push({
            url: url,
            id: debugId
        });
    }
    return debugIds.length ? debugIds : void 0;
}
function $3c2eea22514e3378$export$889450845d2a8007(url) {
    $3c2eea22514e3378$var$syncSourceCodeContext();
    return $3c2eea22514e3378$var$contextByUrl.get(url);
}

});



parcelRegister("gRy7g", function(module, exports) {

$parcel$export(module.exports, "initXhrObservable", function () { return $ecce53536958c713$export$1b29a115c614eaec; });

var $fnvkG = parcelRequire("fnvkG");

var $74beb = parcelRequire("74beb");

var $50cui = parcelRequire("50cui");

var $c2Qhr = parcelRequire("c2Qhr");
var $kRkcp = parcelRequire("kRkcp");

var $1wrwm = parcelRequire("1wrwm");
//#region src/browser/xhrObservable.ts
let $ecce53536958c713$var$xhrObservable;
const $ecce53536958c713$var$xhrContexts = /* @__PURE__ */ new WeakMap();
function $ecce53536958c713$export$1b29a115c614eaec() {
    if (!$ecce53536958c713$var$xhrObservable) $ecce53536958c713$var$xhrObservable = $ecce53536958c713$var$createXhrObservable();
    return $ecce53536958c713$var$xhrObservable;
}
function $ecce53536958c713$var$createXhrObservable() {
    if (!("XMLHttpRequest" in (0, $c2Qhr.globalObject))) return new (0, $fnvkG.Observable)();
    return new (0, $fnvkG.Observable)((observable)=>{
        const { stop: stopInstrumentingStart } = (0, $74beb.instrumentMethod)(XMLHttpRequest.prototype, "open", $ecce53536958c713$var$openXhr);
        const { stop: stopInstrumentingSend } = (0, $74beb.instrumentMethod)(XMLHttpRequest.prototype, "send", (call)=>{
            $ecce53536958c713$var$sendXhr(call, observable);
        }, {
            computeHandlingStack: true
        });
        const { stop: stopInstrumentingAbort } = (0, $74beb.instrumentMethod)(XMLHttpRequest.prototype, "abort", $ecce53536958c713$var$abortXhr);
        return ()=>{
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
}
function $ecce53536958c713$var$openXhr({ target: xhr, parameters: [method, url] }) {
    $ecce53536958c713$var$xhrContexts.set(xhr, {
        state: "open",
        method: String(method).toUpperCase(),
        url: (0, $kRkcp.normalizeUrl)(String(url))
    });
}
function $ecce53536958c713$var$sendXhr({ target: xhr, parameters: [body], handlingStack: handlingStack }, observable) {
    const context = $ecce53536958c713$var$xhrContexts.get(xhr);
    if (!context) return;
    const startContext = context;
    startContext.state = "start";
    startContext.startClocks = (0, $1wrwm.clocksNow)();
    startContext.isAborted = false;
    startContext.xhr = xhr;
    startContext.handlingStack = handlingStack;
    startContext.requestBody = body;
    let hasBeenReported = false;
    const { stop: stopInstrumentingOnReadyStateChange } = (0, $74beb.instrumentMethod)(xhr, "onreadystatechange", ()=>{
        if (xhr.readyState === XMLHttpRequest.DONE) onEnd();
    });
    const onEnd = ()=>{
        unsubscribeLoadEndListener();
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) return;
        hasBeenReported = true;
        const completeContext = context;
        completeContext.duration = (0, $1wrwm.elapsed)(startContext.startClocks.timeStamp, (0, $1wrwm.timeStampNow)());
        completeContext.status = xhr.status;
        if (typeof xhr.response === "string") completeContext.responseBody = xhr.response;
        observable.notify({
            ...completeContext,
            state: "complete"
        });
    };
    const { stop: unsubscribeLoadEndListener } = (0, $50cui.addEventListener)(xhr, "loadend", onEnd);
    observable.notify(startContext);
}
function $ecce53536958c713$var$abortXhr({ target: xhr }) {
    const context = $ecce53536958c713$var$xhrContexts.get(xhr);
    if (context) context.isAborted = true;
}

});

parcelRegister("lEi17", function(module, exports) {

$parcel$export(module.exports, "ResponseBodyAction", function () { return $a74d2e62cb737c14$export$706c9b2b8bd978e7; });
$parcel$export(module.exports, "initFetchObservable", function () { return $a74d2e62cb737c14$export$68d940e9b7f5282c; });

var $fnvkG = parcelRequire("fnvkG");

var $74beb = parcelRequire("74beb");

var $aPpOh = parcelRequire("aPpOh");

var $03HHZ = parcelRequire("03HHZ");

var $c2Qhr = parcelRequire("c2Qhr");
var $kRkcp = parcelRequire("kRkcp");

var $dee0n = parcelRequire("dee0n");

var $1wrwm = parcelRequire("1wrwm");
//#region src/browser/fetchObservable.ts
/**
* Action to take with the response body of a fetch request.
* Values are ordered by priority: higher values take precedence when multiple actions are requested.
*/ let $a74d2e62cb737c14$export$706c9b2b8bd978e7 = /* @__PURE__ */ function(ResponseBodyAction) {
    ResponseBodyAction[ResponseBodyAction["IGNORE"] = 0] = "IGNORE";
    ResponseBodyAction[ResponseBodyAction["COLLECT"] = 1] = "COLLECT";
    return ResponseBodyAction;
}({});
let $a74d2e62cb737c14$var$fetchObservable;
const $a74d2e62cb737c14$var$responseBodyActionGetters = [];
function $a74d2e62cb737c14$export$68d940e9b7f5282c({ responseBodyAction: responseBodyAction } = {}) {
    if (responseBodyAction) $a74d2e62cb737c14$var$responseBodyActionGetters.push(responseBodyAction);
    if (!$a74d2e62cb737c14$var$fetchObservable) $a74d2e62cb737c14$var$fetchObservable = $a74d2e62cb737c14$var$createFetchObservable();
    return $a74d2e62cb737c14$var$fetchObservable;
}
function $a74d2e62cb737c14$var$createFetchObservable() {
    return new (0, $fnvkG.Observable)((observable)=>{
        if (!(0, $c2Qhr.globalObject).fetch) return;
        const { stop: stop } = (0, $74beb.instrumentMethod)((0, $c2Qhr.globalObject), "fetch", (call)=>$a74d2e62cb737c14$var$beforeSend(call, observable), {
            computeHandlingStack: true
        });
        return stop;
    });
}
function $a74d2e62cb737c14$var$beforeSend({ parameters: parameters, onPostCall: onPostCall, handlingStack: handlingStack }, observable) {
    const [input, init] = parameters;
    let methodFromParams = init?.method;
    if (methodFromParams === void 0 && input instanceof Request) methodFromParams = input.method;
    const method = methodFromParams !== void 0 ? String(methodFromParams).toUpperCase() : "GET";
    const url = input instanceof Request ? input.url : (0, $kRkcp.normalizeUrl)(String(input));
    const context = {
        state: "start",
        init: init,
        input: input,
        method: method,
        startClocks: (0, $1wrwm.clocksNow)(),
        url: url,
        handlingStack: handlingStack,
        isAbortedOnStart: input instanceof Request && input.signal?.aborted || init?.signal?.aborted || false
    };
    observable.notify(context);
    parameters[0] = context.input;
    parameters[1] = context.init;
    onPostCall((responsePromise)=>{
        $a74d2e62cb737c14$var$afterSend(observable, responsePromise, context).catch((0, $dee0n.monitorError));
    });
}
async function $a74d2e62cb737c14$var$afterSend(observable, responsePromise, startContext) {
    const context = startContext;
    let response;
    try {
        response = await responsePromise;
    } catch (error) {
        observable.notify({
            ...context,
            state: "resolve",
            status: 0,
            isAborted: context.init?.signal?.aborted || error instanceof DOMException && error.code === DOMException.ABORT_ERR,
            error: error
        });
        return;
    }
    context.response = response;
    context.status = response.status;
    context.responseType = response.type;
    context.isAborted = false;
    if ($a74d2e62cb737c14$var$responseBodyActionGetters.reduce((action, getter)=>Math.max(action, getter(context)), 0) === 1) {
        const clonedResponse = (0, $aPpOh.tryToClone)(response);
        if (clonedResponse?.body) try {
            const bytes = await (0, $03HHZ.readBytesFromStream)(clonedResponse.body);
            context.responseBody = new TextDecoder().decode(bytes);
        } catch  {}
    }
    observable.notify({
        ...context,
        state: "resolve"
    });
}

});
parcelRegister("03HHZ", function(module, exports) {

$parcel$export(module.exports, "readBytesFromStream", function () { return $3ac469c7d92132da$export$ecd154de096317dd; });

var $hH6Lc = parcelRequire("hH6Lc");

var $eTAnO = parcelRequire("eTAnO");
//#region src/tools/readBytesFromStream.ts
/**
* Read bytes from a ReadableStream until the end of the stream.
*/ async function $3ac469c7d92132da$export$ecd154de096317dd(stream) {
    const reader = stream.getReader();
    const chunks = [];
    while(true){
        const result = await reader.read();
        if (result.done) break;
        chunks.push(result.value);
    }
    reader.cancel().catch((0, $hH6Lc.noop));
    return (0, $eTAnO.concatBuffers)(chunks);
}

});


parcelRegister("boE7L", function(module, exports) {

$parcel$export(module.exports, "initConsoleObservable", function () { return $84b99b745388f74c$export$688fb0189cfcddd4; });

var $fnvkG = parcelRequire("fnvkG");

var $fiOtf = parcelRequire("fiOtf");

var $e6zeV = parcelRequire("e6zeV");

var $gnsX5 = parcelRequire("gnsX5");

var $hpOLz = parcelRequire("hpOLz");

var $cWoRJ = parcelRequire("cWoRJ");

var $7RJVj = parcelRequire("7RJVj");

var $SMkA1 = parcelRequire("SMkA1");

var $6PIx8 = parcelRequire("6PIx8");

var $dee0n = parcelRequire("dee0n");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/console/consoleObservable.ts
let $84b99b745388f74c$var$consoleObservablesByApi = {};
function $84b99b745388f74c$export$688fb0189cfcddd4(apis) {
    const consoleObservables = apis.map((api)=>{
        if (!$84b99b745388f74c$var$consoleObservablesByApi[api]) $84b99b745388f74c$var$consoleObservablesByApi[api] = $84b99b745388f74c$var$createConsoleObservable(api);
        return $84b99b745388f74c$var$consoleObservablesByApi[api];
    });
    return (0, $fnvkG.mergeObservables)(...consoleObservables);
}
function $84b99b745388f74c$var$createConsoleObservable(api) {
    return new (0, $fnvkG.Observable)((observable)=>{
        const originalConsoleApi = (0, $6PIx8.globalConsole)[api];
        (0, $6PIx8.globalConsole)[api] = (...params)=>{
            originalConsoleApi.apply(console, params);
            const handlingStack = (0, $e6zeV.createHandlingStack)("console error");
            (0, $dee0n.callMonitored)(()=>{
                observable.notify($84b99b745388f74c$var$buildConsoleLog(params, api, handlingStack));
            });
        };
        return ()=>{
            (0, $6PIx8.globalConsole)[api] = originalConsoleApi;
        };
    });
}
function $84b99b745388f74c$var$buildConsoleLog(params, api, handlingStack) {
    const message = params.map((param)=>$84b99b745388f74c$var$formatConsoleParameters(param)).join(" ");
    if (api === (0, $6PIx8.ConsoleApiName).error) {
        const firstErrorParam = params.find((0, $cWoRJ.isError));
        const rawError = (0, $SMkA1.computeRawError)({
            originalError: firstErrorParam,
            handlingStack: handlingStack,
            startClocks: (0, $1wrwm.clocksNow)(),
            source: (0, $7RJVj.ErrorSource).CONSOLE,
            handling: "handled",
            nonErrorPrefix: "Provided",
            useFallbackStack: false
        });
        rawError.message = message;
        return {
            api: api,
            message: message,
            handlingStack: handlingStack,
            error: rawError
        };
    }
    return {
        api: api,
        message: message,
        error: void 0,
        handlingStack: handlingStack
    };
}
function $84b99b745388f74c$var$formatConsoleParameters(param) {
    if (typeof param === "string") return (0, $hpOLz.sanitize)(param);
    if ((0, $cWoRJ.isError)(param)) return (0, $e6zeV.formatErrorMessage)((0, $fiOtf.computeStackTrace)(param));
    return (0, $gnsX5.jsonStringify)((0, $hpOLz.sanitize)(param), void 0, 2);
}

});



parcelRegister("7TKXD", function(module, exports) {

$parcel$export(module.exports, "startWebSocketCollection", function () { return $efb7fc10eb5f9aee$export$1fb31b745b779274; });

var $6htpc = parcelRequire("6htpc");
parcelRequire("jNZRV");

var $1wrwm = parcelRequire("1wrwm");

var $kRkcp = parcelRequire("kRkcp");

var $bWkrj = parcelRequire("bWkrj");
var $itfe1 = parcelRequire("itfe1");
var $hpOLz = parcelRequire("hpOLz");
//#region src/domain/resource/webSocketCollection.ts
const $efb7fc10eb5f9aee$export$7a325b03d69c0b = "websocket-connecting";
const $efb7fc10eb5f9aee$export$380bc06cdaae441b = "websocket-closed";
function $efb7fc10eb5f9aee$export$1fb31b745b779274(lifeCycle, viewHistory, addDurationVital) {
    const tracker = $efb7fc10eb5f9aee$export$e77dd8d91b86d535(lifeCycle, (0, $itfe1.initWebSocketObservable)(), viewHistory, addDurationVital);
    const sessionExpiredSubscription = lifeCycle.subscribe(10, ({ endClocks: endClocks })=>{
        tracker.flushOpenConnections("session_end", endClocks);
    });
    return {
        stop: ()=>{
            sessionExpiredSubscription.unsubscribe();
            tracker.flushOpenConnections("session_end");
            tracker.stop();
        }
    };
}
function $efb7fc10eb5f9aee$export$e77dd8d91b86d535(lifeCycle, webSocketContextObservable, viewHistory, addDurationVital) {
    const webSocketRegistry = /* @__PURE__ */ new Map();
    function completeConnection(webSocket, endInfo, reason) {
        const completedEvent = $efb7fc10eb5f9aee$var$buildCompletedEvent(webSocket, endInfo, reason, viewHistory);
        lifeCycle.notify(9, completedEvent);
        addDurationVital({
            id: (0, $bWkrj.generateUUID)(),
            name: $efb7fc10eb5f9aee$export$380bc06cdaae441b,
            type: (0, $6htpc.VitalType).DURATION,
            startClocks: completedEvent.endClocks,
            duration: 0,
            context: (0, $hpOLz.sanitize)({
                url: completedEvent.url,
                connection_id: completedEvent.connectionId
            })
        });
    }
    const subscription = webSocketContextObservable.subscribe((context)=>{
        switch(context.state){
            case "connecting":
                {
                    const connectionId = (0, $bWkrj.generateUUID)();
                    const startViewId = viewHistory.findView(context.startClocks.relative)?.id;
                    const url = $efb7fc10eb5f9aee$var$sanitizeWebSocketUrl(context.url);
                    const webSocket = {
                        webSocket: context.instance,
                        connectionId: connectionId,
                        url: url,
                        startClocks: context.startClocks,
                        startViewId: startViewId,
                        messagesIn: {
                            count: 0,
                            size: 0
                        },
                        messagesOut: {
                            count: 0,
                            size: 0
                        },
                        longestInboundSilence: 0,
                        bufferedAmountMax: 0
                    };
                    webSocketRegistry.set(context.instance, webSocket);
                    addDurationVital({
                        id: (0, $bWkrj.generateUUID)(),
                        name: $efb7fc10eb5f9aee$export$7a325b03d69c0b,
                        type: (0, $6htpc.VitalType).DURATION,
                        startClocks: context.startClocks,
                        duration: 0,
                        context: (0, $hpOLz.sanitize)({
                            url: url,
                            connection_id: connectionId
                        })
                    });
                    return;
                }
            case "open":
                {
                    const webSocket = webSocketRegistry.get(context.instance);
                    if (!webSocket) return;
                    webSocket.openClocks = context.openClocks;
                    webSocket.protocol = context.protocol;
                    webSocket.setupDuration = (0, $1wrwm.elapsed)(webSocket.startClocks.timeStamp, context.openClocks.timeStamp);
                    return;
                }
            case "message-in":
                {
                    const webSocket = webSocketRegistry.get(context.instance);
                    if (!webSocket) return;
                    webSocket.messagesIn.count += 1;
                    webSocket.messagesIn.size += context.size;
                    $efb7fc10eb5f9aee$var$recordMessageTiming(webSocket, context.at, "in");
                    return;
                }
            case "message-out":
                {
                    const webSocket = webSocketRegistry.get(context.instance);
                    if (!webSocket) return;
                    if (context.bufferedAmountPreSend > webSocket.bufferedAmountMax) webSocket.bufferedAmountMax = context.bufferedAmountPreSend;
                    webSocket.messagesOut.count += 1;
                    webSocket.messagesOut.size += context.size;
                    $efb7fc10eb5f9aee$var$recordMessageTiming(webSocket, context.at, "out");
                    return;
                }
            case "closed":
                {
                    const webSocket = webSocketRegistry.get(context.instance);
                    if (!webSocket) return;
                    webSocketRegistry.delete(context.instance);
                    completeConnection(webSocket, context, "close_event");
                    return;
                }
        }
    });
    return {
        flushOpenConnections: (reason, endClocks = (0, $1wrwm.clocksNow)())=>{
            webSocketRegistry.forEach((webSocket)=>{
                completeConnection(webSocket, {
                    at: endClocks
                }, reason);
            });
            webSocketRegistry.clear();
        },
        stop: ()=>{
            subscription.unsubscribe();
            webSocketRegistry.clear();
        }
    };
}
function $efb7fc10eb5f9aee$var$sanitizeWebSocketUrl(url) {
    const sanitizedUrl = (0, $kRkcp.buildUrl)(url);
    sanitizedUrl.search = "";
    return sanitizedUrl.href;
}
function $efb7fc10eb5f9aee$var$recordMessageTiming(webSocket, at, direction) {
    if (webSocket.openClocks === void 0) return;
    const offset = (0, $1wrwm.elapsed)(webSocket.openClocks.timeStamp, at.timeStamp);
    if (direction === "in" && webSocket.firstMessageInOffset === void 0) webSocket.firstMessageInOffset = offset;
    else if (direction === "out" && webSocket.firstMessageOutOffset === void 0) webSocket.firstMessageOutOffset = offset;
    if (direction === "in") {
        if (webSocket.lastMessageInAt !== void 0) {
            const gap = (0, $1wrwm.elapsed)(webSocket.lastMessageInAt, at.timeStamp);
            if (gap > webSocket.longestInboundSilence) webSocket.longestInboundSilence = gap;
        }
        webSocket.lastMessageInAt = at.timeStamp;
    }
}
function $efb7fc10eb5f9aee$var$buildCompletedEvent(webSocket, endInfo, trackingEndReason, viewHistory) {
    const endClocks = endInfo.at;
    const endViewId = trackingEndReason === "session_end" ? viewHistory.findView(endClocks.relative, {
        returnInactive: true
    })?.id : viewHistory.findView(endClocks.relative)?.id;
    const inboundIdleDurationBeforeClose = webSocket.lastMessageInAt !== void 0 ? (0, $1wrwm.elapsed)(webSocket.lastMessageInAt, endClocks.timeStamp) : void 0;
    const { openClocks: openClocks, ...rest } = webSocket;
    return {
        ...rest,
        endClocks: endClocks,
        endViewId: endViewId,
        inboundIdleDurationBeforeClose: inboundIdleDurationBeforeClose,
        trackingEndReason: trackingEndReason,
        handshakeSucceeded: openClocks !== void 0,
        setupDuration: webSocket.setupDuration ?? (0, $1wrwm.elapsed)(webSocket.startClocks.timeStamp, endClocks.timeStamp),
        closeCode: endInfo.code,
        closeReason: endInfo.reason,
        wasClean: endInfo.wasClean
    };
}

});
parcelRegister("itfe1", function(module, exports) {

$parcel$export(module.exports, "initWebSocketObservable", function () { return $57352d82b7ab3100$export$7feaa6f216a456d2; });

var $fnvkG = parcelRequire("fnvkG");

var $74beb = parcelRequire("74beb");

var $50cui = parcelRequire("50cui");

var $eTAnO = parcelRequire("eTAnO");

var $c2Qhr = parcelRequire("c2Qhr");

var $1wrwm = parcelRequire("1wrwm");
//#region src/browser/webSocketObservable.ts
function $57352d82b7ab3100$var$isGlobalWithWebSocket(global) {
    return typeof global.WebSocket === "function";
}
let $57352d82b7ab3100$var$webSocketObservable;
function $57352d82b7ab3100$export$7feaa6f216a456d2() {
    if (!$57352d82b7ab3100$var$webSocketObservable) $57352d82b7ab3100$var$webSocketObservable = $57352d82b7ab3100$var$createWebSocketObservable();
    return $57352d82b7ab3100$var$webSocketObservable;
}
function $57352d82b7ab3100$var$createWebSocketObservable() {
    return new (0, $fnvkG.Observable)((observable)=>{
        if (!$57352d82b7ab3100$var$isGlobalWithWebSocket((0, $c2Qhr.globalObject))) return;
        const { stop: stopInstrumentingConstructor } = (0, $74beb.instrumentConstructor)((0, $c2Qhr.globalObject), "WebSocket", ({ parameters: parameters, onPostCall: onPostCall })=>{
            const protocols = Array.isArray(parameters[1]) ? [].concat(parameters[1]) : parameters[1];
            const startClocks = (0, $1wrwm.clocksNow)();
            onPostCall((instance)=>{
                observable.notify({
                    state: "connecting",
                    instance: instance,
                    url: instance.url,
                    protocols: protocols,
                    startClocks: startClocks
                });
                $57352d82b7ab3100$var$attachInstanceListeners(instance, observable);
            });
        });
        const { stop: stopInstrumentingSend } = (0, $74beb.instrumentMethod)((0, $c2Qhr.globalObject).WebSocket.prototype, "send", ({ target: instance, parameters: [data], onPostCall: onPostCall })=>{
            const size = $57352d82b7ab3100$var$computePayloadSize(data);
            const bufferedAmountPreSend = instance.bufferedAmount;
            onPostCall(()=>{
                observable.notify({
                    state: "message-out",
                    instance: instance,
                    size: size,
                    bufferedAmountPreSend: bufferedAmountPreSend,
                    at: (0, $1wrwm.clocksNow)()
                });
            });
        });
        return ()=>{
            stopInstrumentingConstructor();
            stopInstrumentingSend();
        };
    });
}
function $57352d82b7ab3100$var$attachInstanceListeners(instance, observable) {
    const { stop: stopOpen } = (0, $50cui.addEventListener)(instance, "open", ()=>{
        observable.notify({
            state: "open",
            instance: instance,
            openClocks: (0, $1wrwm.clocksNow)(),
            protocol: instance.protocol || ""
        });
        stopOpen();
    });
    const { stop: stopMessage } = (0, $50cui.addEventListener)(instance, "message", (event)=>{
        observable.notify({
            state: "message-in",
            instance: instance,
            size: $57352d82b7ab3100$var$computePayloadSize(event.data),
            at: (0, $1wrwm.clocksNow)()
        });
    });
    const { stop: stopClose } = (0, $50cui.addEventListener)(instance, "close", (event)=>{
        observable.notify({
            state: "closed",
            instance: instance,
            code: event.code,
            reason: event.reason,
            wasClean: event.wasClean,
            at: (0, $1wrwm.clocksNow)()
        });
        stopMessage();
        stopClose();
    });
}
function $57352d82b7ab3100$var$computePayloadSize(data) {
    if (typeof data === "string") return (0, $eTAnO.computeBytesCount)(data);
    if (data instanceof ArrayBuffer || ArrayBuffer.isView(data)) return data.byteLength;
    if (typeof Blob !== "undefined" && data instanceof Blob) return data.size;
    return 0;
}

});


parcelRegister("73kBg", function(module, exports) {

$parcel$export(module.exports, "startActionCollection", function () { return $142eb2dfc75f9fad$export$195095f773513078; });

var $6htpc = parcelRequire("6htpc");
parcelRequire("jNZRV");

var $hEma3 = parcelRequire("hEma3");

var $edj8b = parcelRequire("edj8b");

var $1J1qi = parcelRequire("1J1qi");

var $1wrwm = parcelRequire("1wrwm");

var $hH6Lc = parcelRequire("hH6Lc");

var $fNtjE = parcelRequire("fNtjE");
function $142eb2dfc75f9fad$export$195095f773513078(lifeCycle, hooks, domMutationObservable, windowOpenObservable, configuration) {
    const { unsubscribe: unsubscribeAutoAction } = lifeCycle.subscribe(0, (action)=>{
        lifeCycle.notify(13, $142eb2dfc75f9fad$var$processAction(action));
    });
    const stopClickActions = (0, $hH6Lc.noop);
    let clickActions;
    if (configuration.trackUserInteractions) clickActions = (0, $edj8b.trackClickActions)(lifeCycle, domMutationObservable, windowOpenObservable, configuration);
    const manualActions = (0, $1J1qi.trackManualActions)(lifeCycle, (action)=>{
        lifeCycle.notify(13, $142eb2dfc75f9fad$var$processAction(action));
    });
    const actionContexts = {
        findActionId: (startTime)=>{
            const manualActionId = manualActions.findActionId(startTime);
            const clickActionId = clickActions?.findActionId(startTime) ?? [];
            return manualActionId.concat(clickActionId);
        }
    };
    hooks.assembleEventDefaults.register(({ startTime: startTime, eventType: eventType })=>{
        if (eventType !== (0, $6htpc.RumEventType).ERROR && eventType !== (0, $6htpc.RumEventType).RESOURCE && eventType !== (0, $6htpc.RumEventType).LONG_TASK) return 0, $fNtjE.SKIPPED;
        const correctedStartTime = eventType === (0, $6htpc.RumEventType).LONG_TASK ? (0, $1wrwm.addDuration)(startTime, 1) : startTime;
        const actionId = actionContexts.findActionId(correctedStartTime);
        if (!actionId.length) return 0, $fNtjE.SKIPPED;
        return {
            type: eventType,
            action: {
                id: actionId
            }
        };
    });
    hooks.assembleTelemetry.register(({ startTime: startTime })=>({
            action: {
                id: actionContexts.findActionId(startTime)
            }
        }));
    return {
        addAction: manualActions.addAction,
        startAction: manualActions.startAction,
        stopAction: manualActions.stopAction,
        actionContexts: actionContexts,
        stop: ()=>{
            unsubscribeAutoAction();
            stopClickActions();
            manualActions.stop();
            clickActions?.stop();
        }
    };
}
function $142eb2dfc75f9fad$var$processAction(action) {
    const isAuto = $142eb2dfc75f9fad$var$isAutoAction(action);
    const loadingTime = (0, $hEma3.discardNegativeDuration)((0, $1wrwm.toServerDuration)(action.duration));
    return {
        rawRumEvent: {
            type: (0, $6htpc.RumEventType).ACTION,
            date: action.startClocks.timeStamp,
            action: {
                id: action.id,
                target: {
                    name: action.name
                },
                type: action.type,
                ...loadingTime !== void 0 && {
                    loading_time: loadingTime
                },
                ...action.counts && {
                    error: {
                        count: action.counts.errorCount
                    },
                    long_task: {
                        count: action.counts.longTaskCount
                    },
                    resource: {
                        count: action.counts.resourceCount
                    }
                },
                frustration: {
                    type: action.frustrationTypes
                }
            },
            ...isAuto ? {
                _dd: {
                    action: {
                        target: {
                            selector: action.target?.selector || void 0,
                            width: action.target?.width || void 0,
                            height: action.target?.height || void 0,
                            composed_path_selector: action.target?.composedPathSelector
                        },
                        position: action.position,
                        name_source: action.nameSource
                    }
                }
            } : {
                context: action.context
            }
        },
        duration: action.duration,
        startClocks: action.startClocks,
        domainContext: isAuto ? {
            events: action.events
        } : {
            handlingStack: action.handlingStack
        }
    };
}
function $142eb2dfc75f9fad$var$isAutoAction(action) {
    return "events" in action;
}

});
parcelRegister("hEma3", function(module, exports) {

$parcel$export(module.exports, "discardNegativeDuration", function () { return $543f88c41ee8ccd5$export$e8fc7a7e81732139; });

var $eQWMG = parcelRequire("eQWMG");
//#region src/domain/discardNegativeDuration.ts
function $543f88c41ee8ccd5$export$e8fc7a7e81732139(duration) {
    return (0, $eQWMG.isNumber)(duration) && duration < 0 ? void 0 : duration;
}

});

parcelRegister("edj8b", function(module, exports) {

$parcel$export(module.exports, "trackClickActions", function () { return $48dea89e15c18713$export$ce3e012cf7d342e2; });

var $6htpc = parcelRequire("6htpc");
parcelRequire("jNZRV");

var $8EfFG = parcelRequire("8EfFG");

var $9DgYZ = parcelRequire("9DgYZ");

var $iMCYf = parcelRequire("iMCYf");

var $8yVTM = parcelRequire("8yVTM");

var $8lnE0 = parcelRequire("8lnE0");

var $kPF4T = parcelRequire("kPF4T");

var $b9XA6 = parcelRequire("b9XA6");

var $i1SZ9 = parcelRequire("i1SZ9");

var $6QRSP = parcelRequire("6QRSP");

var $aGKMF = parcelRequire("aGKMF");

var $ciHIa = parcelRequire("ciHIa");

var $gjrP2 = parcelRequire("gjrP2");

var $6DNEb = parcelRequire("6DNEb");

var $gxKYz = parcelRequire("gxKYz");

var $1wrwm = parcelRequire("1wrwm");

var $bWkrj = parcelRequire("bWkrj");
var $fnvkG = parcelRequire("fnvkG");
//#region src/domain/action/trackClickActions.ts
function $48dea89e15c18713$export$ce3e012cf7d342e2(lifeCycle, domMutationObservable, windowOpenObservable, configuration) {
    const actionTracker = (0, $kPF4T.startEventTracker)(lifeCycle);
    const stopObservable = new (0, $fnvkG.Observable)();
    let currentClickChain;
    lifeCycle.subscribe(5, stopClickChain);
    lifeCycle.subscribe(12, stopClickChain);
    const { stop: stopActionEventsListener } = (0, $ciHIa.listenActionEvents)({
        onPointerDown: (pointerDownEvent)=>$48dea89e15c18713$var$processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent, windowOpenObservable),
        onPointerUp: ({ clickActionBase: clickActionBase, ignore: ignore, hadActivityOnPointerDown: hadActivityOnPointerDown }, startEvent, getUserActivity)=>{
            $48dea89e15c18713$var$startClickAction(configuration, lifeCycle, domMutationObservable, windowOpenObservable, actionTracker, stopObservable, appendClickToClickChain, clickActionBase, ignore, startEvent, getUserActivity, hadActivityOnPointerDown);
        }
    });
    return {
        stop: ()=>{
            stopClickChain();
            stopObservable.notify();
            stopActionEventsListener();
            actionTracker.stopAll();
        },
        findActionId: actionTracker.findId
    };
    function appendClickToClickChain(click) {
        if (!currentClickChain?.tryAppend(click)) {
            const rageClick = click.clone();
            const clickChain = (0, $6QRSP.createClickChain)(click, (clicks)=>{
                $48dea89e15c18713$export$4e2c2102bb4a32e4(clicks, rageClick);
                if (currentClickChain === clickChain) currentClickChain = void 0;
            });
            currentClickChain = clickChain;
        }
    }
    function stopClickChain() {
        if (currentClickChain) currentClickChain.stop();
    }
}
function $48dea89e15c18713$var$processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent, windowOpenObservable) {
    let nodePrivacyLevel;
    if (configuration.enablePrivacyForActionName) nodePrivacyLevel = (0, $8lnE0.getNodePrivacyLevel)($48dea89e15c18713$var$getEventTarget(pointerDownEvent), configuration.defaultPrivacyLevel);
    else nodePrivacyLevel = (0, $8yVTM.NodePrivacyLevel).ALLOW;
    if (nodePrivacyLevel === (0, $8yVTM.NodePrivacyLevel).HIDDEN) return;
    const clickActionBase = $48dea89e15c18713$var$computeClickActionBase(pointerDownEvent, nodePrivacyLevel, configuration);
    let hadActivityOnPointerDown = false;
    (0, $9DgYZ.waitPageActivityEnd)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, (pageActivityEndEvent)=>{
        hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
    }, 100);
    return {
        clickActionBase: clickActionBase,
        ignore: (0, $i1SZ9.getFrustrationIgnore)($48dea89e15c18713$var$getEventTarget(pointerDownEvent)),
        hadActivityOnPointerDown: ()=>hadActivityOnPointerDown
    };
}
function $48dea89e15c18713$var$startClickAction(configuration, lifeCycle, domMutationObservable, windowOpenObservable, actionTracker, stopObservable, appendClickToClickChain, clickActionBase, ignore, startEvent, getUserActivity, hadActivityOnPointerDown) {
    const click = $48dea89e15c18713$var$newClick(lifeCycle, actionTracker, getUserActivity, clickActionBase, ignore, startEvent);
    appendClickToClickChain(click);
    const selector = clickActionBase?.target?.selector;
    if (selector) (0, $6DNEb.updateInteractionSelector)(startEvent.timeStamp, selector);
    const { stop: stopWaitPageActivityEnd } = (0, $9DgYZ.waitPageActivityEnd)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, (pageActivityEndEvent)=>{
        if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) click.discard();
        else if (pageActivityEndEvent.hadActivity) click.stop(pageActivityEndEvent.end);
        else if (hadActivityOnPointerDown()) click.stop(click.startClocks.timeStamp);
        else click.stop();
    }, (0, $6DNEb.CLICK_ACTION_MAX_DURATION));
    const viewEndedSubscription = lifeCycle.subscribe(5, ({ endClocks: endClocks })=>{
        click.stop(endClocks.timeStamp);
    });
    const pageMayExitSubscription = lifeCycle.subscribe(12, ()=>{
        click.stop((0, $1wrwm.timeStampNow)());
    });
    const stopSubscription = stopObservable.subscribe(()=>{
        click.stop();
    });
    click.stopObservable.subscribe(()=>{
        pageMayExitSubscription.unsubscribe();
        viewEndedSubscription.unsubscribe();
        stopWaitPageActivityEnd();
        stopSubscription.unsubscribe();
    });
}
function $48dea89e15c18713$var$computeClickActionBase(event, nodePrivacyLevel, configuration) {
    const target = $48dea89e15c18713$var$getEventTarget(event);
    const rect = target.getBoundingClientRect();
    const selector = (0, $iMCYf.getSelectorFromElement)(target, configuration.actionNameAttribute);
    const composedPathSelector = (0, $b9XA6.getComposedPathSelector)(event.composedPath(), configuration.actionNameAttribute);
    if (selector) (0, $6DNEb.updateInteractionSelector)(event.timeStamp, selector);
    const { name: name, nameSource: nameSource } = (0, $aGKMF.getActionNameFromElement)(target, configuration, nodePrivacyLevel);
    return {
        type: (0, $6htpc.ActionType).CLICK,
        target: {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            selector: selector,
            composedPathSelector: composedPathSelector || void 0
        },
        position: {
            x: Math.round(event.clientX - rect.left),
            y: Math.round(event.clientY - rect.top)
        },
        name: name,
        nameSource: nameSource
    };
}
function $48dea89e15c18713$var$getEventTarget(event) {
    if (event.composed && (0, $8EfFG.isNodeShadowHost)(event.target) && typeof event.composedPath === "function") {
        const composedPath = event.composedPath();
        if (composedPath.length > 0 && composedPath[0] instanceof Element) return composedPath[0];
    }
    return event.target;
}
function $48dea89e15c18713$var$newClick(lifeCycle, actionTracker, getUserActivity, clickActionBase, ignore, startEvent) {
    const clickKey = (0, $bWkrj.generateUUID)();
    const startClocks = (0, $1wrwm.relativeToClocks)(startEvent.timeStamp);
    const startedClickAction = actionTracker.start(clickKey, startClocks, clickActionBase, {
        isChildEvent: (0, $gxKYz.isActionChildEvent)
    });
    lifeCycle.notify(16, startedClickAction);
    let status = 0;
    let actionTrackerFinishedEvent;
    const frustrationTypes = [];
    const stopObservable = new (0, $fnvkG.Observable)();
    function stop(activityEndTime) {
        if (status !== 0) return;
        status = 1;
        actionTrackerFinishedEvent = activityEndTime ? actionTracker.stop(clickKey, (0, $1wrwm.timeStampToClocks)(activityEndTime)) : actionTracker.discard(clickKey);
        stopObservable.notify();
    }
    return {
        event: startEvent,
        ignore: ignore,
        stop: stop,
        stopObservable: stopObservable,
        get hasError () {
            const currentCounts = actionTrackerFinishedEvent?.counts ?? actionTracker.getCounts(clickKey);
            return currentCounts ? currentCounts.errorCount > 0 : false;
        },
        get hasPageActivity () {
            return actionTrackerFinishedEvent && "duration" in actionTrackerFinishedEvent;
        },
        getUserActivity: getUserActivity,
        addFrustration: (frustrationType)=>{
            frustrationTypes.push(frustrationType);
        },
        get startClocks () {
            return startClocks;
        },
        isStopped: ()=>status === 1 || status === 2,
        clone: ()=>$48dea89e15c18713$var$newClick(lifeCycle, actionTracker, getUserActivity, clickActionBase, ignore, startEvent),
        validate: (domEvents)=>{
            stop();
            if (status !== 1) return;
            if (!actionTrackerFinishedEvent) return;
            const clickAction = {
                frustrationTypes: frustrationTypes,
                events: domEvents ?? [
                    startEvent
                ],
                event: startEvent,
                ...actionTrackerFinishedEvent,
                counts: actionTrackerFinishedEvent.counts
            };
            lifeCycle.notify(0, clickAction);
            status = 2;
        },
        discard: ()=>{
            stop();
            status = 2;
        }
    };
}
function $48dea89e15c18713$export$4e2c2102bb4a32e4(clicks, rageClick) {
    const { isRage: isRage } = (0, $gjrP2.computeFrustration)(clicks, rageClick);
    if (isRage) {
        clicks.forEach((click)=>click.discard());
        rageClick.stop((0, $1wrwm.timeStampNow)());
        rageClick.validate(clicks.map((click)=>click.event));
    } else {
        rageClick.discard();
        clicks.forEach((click)=>click.validate());
    }
}

});
parcelRegister("9DgYZ", function(module, exports) {

$parcel$export(module.exports, "waitPageActivityEnd", function () { return $a8a9e96cb49bd866$export$4a886e0e421b0302; });
parcelRequire("jNZRV");

var $8EfFG = parcelRequire("8EfFG");

var $4H1Xw = parcelRequire("4H1Xw");

var $1wrwm = parcelRequire("1wrwm");

var $foX5P = parcelRequire("foX5P");
var $jM84O = parcelRequire("jM84O");
var $bOZaS = parcelRequire("bOZaS");
var $fnvkG = parcelRequire("fnvkG");

var $dee0n = parcelRequire("dee0n");
const $a8a9e96cb49bd866$export$ba7660fe1e727fd2 = "data-dd-excluded-activity-mutations";
/**
* Wait for the page activity end
*
* Detection lifecycle:
* ```
*                        Wait page activity end
*              .-------------------'--------------------.
*              v                                        v
*     [Wait for a page activity ]          [Wait for a maximum duration]
*     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
*          /                  \                           |
*         v                    v                          |
*  [No page activity]   [Page activity]                   |
*         |                   |,----------------------.   |
*         v                   v                       |   |
*     (Discard)     [Wait for a page activity]        |   |
*                   [   timeout: END_DELAY   ]        |   |
*                       /                \            |   |
*                      v                  v           |   |
*             [No page activity]    [Page activity]   |   |
*                      |                 |            |   |
*                      |                 '------------'   |
*                      '-----------. ,--------------------'
*                                   v
*                                 (End)
* ```
*
* Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
* process is still alive after maxDuration, it has been validated.
*/ function $a8a9e96cb49bd866$export$4a886e0e421b0302(lifeCycle, domMutationObservable, windowOpenObservable, configuration, pageActivityEndCallback, maxDuration) {
    const pageActivityObservable = (0, $bOZaS.mockable)($a8a9e96cb49bd866$export$48867124286069d5)(lifeCycle, domMutationObservable, windowOpenObservable, configuration);
    let pageActivityEndTimeoutId;
    let hasCompleted = false;
    const validationTimeoutId = (0, $foX5P.setTimeout)((0, $dee0n.monitor)(()=>complete({
            hadActivity: false
        })), 100);
    const maxDurationTimeoutId = maxDuration !== void 0 ? (0, $foX5P.setTimeout)((0, $dee0n.monitor)(()=>complete({
            hadActivity: true,
            end: (0, $1wrwm.timeStampNow)()
        })), maxDuration) : void 0;
    const pageActivitySubscription = pageActivityObservable.subscribe(({ isBusy: isBusy })=>{
        (0, $foX5P.clearTimeout)(validationTimeoutId);
        (0, $foX5P.clearTimeout)(pageActivityEndTimeoutId);
        const lastChangeTime = (0, $1wrwm.timeStampNow)();
        if (!isBusy) pageActivityEndTimeoutId = (0, $foX5P.setTimeout)((0, $dee0n.monitor)(()=>complete({
                hadActivity: true,
                end: lastChangeTime
            })), 100);
    });
    const stop = ()=>{
        hasCompleted = true;
        (0, $foX5P.clearTimeout)(validationTimeoutId);
        (0, $foX5P.clearTimeout)(pageActivityEndTimeoutId);
        (0, $foX5P.clearTimeout)(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) return;
        stop();
        pageActivityEndCallback(event);
    }
    return {
        stop: stop
    };
}
function $a8a9e96cb49bd866$export$48867124286069d5(lifeCycle, domMutationObservable, windowOpenObservable, configuration) {
    return new (0, $fnvkG.Observable)((observable)=>{
        const subscriptions = [];
        let firstRequestIndex;
        let pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe((mutations)=>{
            if (!mutations.every($a8a9e96cb49bd866$var$isExcludedMutation)) notifyPageActivity();
        }), windowOpenObservable.subscribe(notifyPageActivity), (0, $4H1Xw.createPerformanceObservable)({
            type: "resource"
        }).subscribe((entries)=>{
            if (entries.some((entry)=>!$a8a9e96cb49bd866$var$isExcludedUrl(configuration, entry.name))) notifyPageActivity();
        }), lifeCycle.subscribe(7, (startEvent)=>{
            if ($a8a9e96cb49bd866$var$isExcludedUrl(configuration, startEvent.url)) return;
            if (firstRequestIndex === void 0) firstRequestIndex = startEvent.requestIndex;
            pendingRequestsCount += 1;
            notifyPageActivity();
        }), lifeCycle.subscribe(8, (request)=>{
            if ($a8a9e96cb49bd866$var$isExcludedUrl(configuration, request.url) || firstRequestIndex === void 0 || request.requestIndex < firstRequestIndex) return;
            pendingRequestsCount -= 1;
            notifyPageActivity();
        }));
        return ()=>{
            subscriptions.forEach((s)=>s.unsubscribe());
        };
        function notifyPageActivity() {
            observable.notify({
                isBusy: pendingRequestsCount > 0
            });
        }
    });
}
function $a8a9e96cb49bd866$var$isExcludedUrl(configuration, requestUrl) {
    return (0, $jM84O.matchList)(configuration.excludedActivityUrls, requestUrl);
}
function $a8a9e96cb49bd866$var$isExcludedMutation(mutation) {
    const targetElement = mutation.type === "characterData" ? mutation.target.parentElement : mutation.target;
    return Boolean(targetElement && (0, $8EfFG.isElementNode)(targetElement) && targetElement.matches(`[data-dd-excluded-activity-mutations], [data-dd-excluded-activity-mutations] *`));
}

});

parcelRegister("kPF4T", function(module, exports) {

$parcel$export(module.exports, "startEventTracker", function () { return $ef87abc7cffae85f$export$adf9d423257cdcbe; });
parcelRequire("jNZRV");

var $0aAbO = parcelRequire("0aAbO");

var $1wrwm = parcelRequire("1wrwm");

var $5tXxv = parcelRequire("5tXxv");

var $boqsR = parcelRequire("boqsR");
var $bWkrj = parcelRequire("bWkrj");
//#region src/domain/eventTracker.ts
const $ef87abc7cffae85f$export$7dd0e2af89dbbfc9 = 5 * (0, $1wrwm.ONE_MINUTE);
function $ef87abc7cffae85f$export$adf9d423257cdcbe(lifeCycle) {
    const history = (0, $boqsR.createValueHistory)({
        expireDelay: $ef87abc7cffae85f$export$7dd0e2af89dbbfc9
    });
    const keyedEvents = /* @__PURE__ */ new Map();
    function cleanUpEvent(event) {
        keyedEvents.delete(event.key);
        event.eventCounts?.stop();
    }
    function discardAll() {
        keyedEvents.forEach((event)=>{
            cleanUpEvent(event);
        });
        history.reset();
    }
    const sessionRenewalSubscription = lifeCycle.subscribe(11, discardAll);
    function start(key, startClocks, data, options) {
        const id = (0, $bWkrj.generateUUID)();
        const historyEntry = history.add(id, startClocks.relative);
        const existing = keyedEvents.get(key);
        if (existing) cleanUpEvent(existing);
        const trackedEventData = {
            id: id,
            key: key,
            startClocks: startClocks,
            data: data,
            historyEntry: historyEntry,
            eventCounts: options?.isChildEvent ? (0, $0aAbO.trackEventCounts)({
                lifeCycle: lifeCycle,
                isChildEvent: options.isChildEvent(id)
            }) : void 0
        };
        keyedEvents.set(key, trackedEventData);
        return trackedEventData;
    }
    function stop(key, stopClocks, extraData) {
        const event = keyedEvents.get(key);
        if (!event) return;
        const finalData = extraData ? (0, $5tXxv.combine)(event.data, extraData) : event.data;
        event.historyEntry.close(stopClocks.relative);
        const duration = (0, $1wrwm.elapsed)(event.startClocks.timeStamp, stopClocks.timeStamp);
        const counts = event.eventCounts?.eventCounts;
        cleanUpEvent(event);
        return {
            ...finalData,
            id: event.id,
            startClocks: event.startClocks,
            duration: duration,
            counts: counts
        };
    }
    function discard(key) {
        const event = keyedEvents.get(key);
        if (!event) return;
        const counts = event.eventCounts?.eventCounts;
        cleanUpEvent(event);
        event.historyEntry.remove();
        return {
            ...event.data,
            id: event.id,
            startClocks: event.startClocks,
            counts: counts
        };
    }
    function findId(startTime) {
        return history.findAll(startTime);
    }
    function getCounts(key) {
        return keyedEvents.get(key)?.eventCounts?.eventCounts;
    }
    function stopTracker() {
        sessionRenewalSubscription.unsubscribe();
        discardAll();
        history.stop();
    }
    return {
        start: start,
        stop: stop,
        discard: discard,
        getCounts: getCounts,
        findId: findId,
        stopAll: stopTracker
    };
}

});
parcelRegister("0aAbO", function(module, exports) {

$parcel$export(module.exports, "trackEventCounts", function () { return $35ef1a44764266b0$export$a50549f6fbbed49b; });

var $6htpc = parcelRequire("6htpc");
parcelRequire("jNZRV");

var $hH6Lc = parcelRequire("hH6Lc");
//#region src/domain/trackEventCounts.ts
function $35ef1a44764266b0$export$a50549f6fbbed49b({ lifeCycle: lifeCycle, isChildEvent: isChildEvent, onChange: callback = (0, $hH6Lc.noop) }) {
    const eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        actionCount: 0,
        frustrationCount: 0
    };
    const subscription = lifeCycle.subscribe(14, (event)=>{
        if (event.type === "view" || event.type === "vital" || !isChildEvent(event)) return;
        switch(event.type){
            case (0, $6htpc.RumEventType).ERROR:
                eventCounts.errorCount += 1;
                callback();
                break;
            case (0, $6htpc.RumEventType).ACTION:
                eventCounts.actionCount += 1;
                if (event.action.frustration) eventCounts.frustrationCount += event.action.frustration.type.length;
                callback();
                break;
            case (0, $6htpc.RumEventType).LONG_TASK:
                eventCounts.longTaskCount += 1;
                callback();
                break;
            case (0, $6htpc.RumEventType).RESOURCE:
                if (!event._dd?.discarded) {
                    eventCounts.resourceCount += 1;
                    callback();
                }
        }
    });
    return {
        stop: ()=>{
            subscription.unsubscribe();
        },
        eventCounts: eventCounts
    };
}

});


parcelRegister("b9XA6", function(module, exports) {

$parcel$export(module.exports, "getComposedPathSelector", function () { return $4efd4e85d5f07a15$export$c780826a82a9e923; });

var $iMCYf = parcelRequire("iMCYf");

var $eTAnO = parcelRequire("eTAnO");
var $bWkrj = parcelRequire("bWkrj");
//#region src/domain/getComposedPathSelector.ts
const $4efd4e85d5f07a15$var$FILTERED_TAGNAMES = [
    "HTML",
    "BODY"
];
/**
* arbitrary value, we want to truncate the selector if it exceeds the limit
*/ const $4efd4e85d5f07a15$export$850d7233a25b9ac1 = 2 * (0, $eTAnO.ONE_KIBI_BYTE);
/**
* Safe attributes that can be collected without PII concerns.
* These are commonly used for testing, accessibility, and UI identification.
*/ const $4efd4e85d5f07a15$export$f14a1f46a83c3bed = (0, $iMCYf.STABLE_ATTRIBUTES).concat([
    "role",
    "type",
    "disabled",
    "readonly",
    "tabindex",
    "draggable",
    "target",
    "rel",
    "download",
    "method",
    "action",
    "enctype",
    "autocomplete"
]);
/**
* Extracts a selector string from a MouseEvent composedPath.
*
* This function:
* 1. Filters out non-Element items (Document, Window, ShadowRoot)
* 2. Extracts a selector string from each element
* 3. Truncates the selector string if it exceeds the character limit
* 4. Returns the selector string
*
* @param composedPath - The composedPath from a MouseEvent
* @returns A selector string
*/ function $4efd4e85d5f07a15$export$c780826a82a9e923(composedPath, actionNameAttribute) {
    const elements = composedPath.filter((el)=>el instanceof Element && !$4efd4e85d5f07a15$var$FILTERED_TAGNAMES.includes(el.tagName));
    if (elements.length === 0) return "";
    const allowedAttributes = actionNameAttribute ? [
        actionNameAttribute
    ].concat($4efd4e85d5f07a15$export$f14a1f46a83c3bed) : $4efd4e85d5f07a15$export$f14a1f46a83c3bed;
    let result = "";
    for (const element of elements){
        const part = $4efd4e85d5f07a15$var$getSelectorStringFromElement(element, allowedAttributes);
        result += part;
        if (result.length >= $4efd4e85d5f07a15$export$850d7233a25b9ac1) return (0, $bWkrj.safeTruncate)(result, $4efd4e85d5f07a15$export$850d7233a25b9ac1);
    }
    return result;
}
/**
* Extracts a selector string from an element.
*/ function $4efd4e85d5f07a15$var$getSelectorStringFromElement(element, allowedAttributes) {
    const tagName = (0, $iMCYf.getTagNameSelector)(element);
    const id = (0, $iMCYf.getIDSelector)(element);
    const classes = $4efd4e85d5f07a15$var$getElementClassesString(element);
    const attributes = $4efd4e85d5f07a15$var$extractSafeAttributesString(element, allowedAttributes);
    const positionData = $4efd4e85d5f07a15$var$computePositionDataString(element);
    return `${tagName}${id || ""}${attributes}${classes}${positionData};`;
}
function $4efd4e85d5f07a15$var$getElementClassesString(element) {
    return Array.from(element.classList).filter((c)=>!(0, $iMCYf.isGeneratedValue)(c)).sort().map((c)=>`.${CSS.escape(c)}`).join("");
}
/**
* Computes the nthChild and nthOfType positions for an element.
*
* @param element - The element to compute the position data for
* @returns A string of the form ":nth-child(1):nth-of-type(1)"
*/ function $4efd4e85d5f07a15$var$computePositionDataString(element) {
    const siblings = Array.from(element.parentNode.children);
    if (siblings.length <= 1) return "";
    const sameTypeSiblings = siblings.filter((sibling)=>sibling.tagName === element.tagName);
    const nthChild = siblings.indexOf(element);
    const nthOfType = (0, $iMCYf.getNthOfTypeSelector)(element);
    return `:nth-child(${nthChild + 1})${sameTypeSiblings.length > 1 ? `:nth-of-type(${nthOfType})` : ""}`;
}
/**
* Extracts only the safe (allowlisted) attributes from an element.
* The attributes are sorted alphabetically by name.
*/ function $4efd4e85d5f07a15$var$extractSafeAttributesString(element, allowedAttributes) {
    const result = [];
    const attributes = Array.from(element.attributes);
    for (const attribute of attributes)if (allowedAttributes.includes(attribute.name)) result.push((0, $iMCYf.getAttributeValueSelector)(attribute.name, attribute.value));
    return result.sort().join("");
}

});

parcelRegister("i1SZ9", function(module, exports) {

$parcel$export(module.exports, "shouldIgnore", function () { return $31d460405430d474$export$d58edfa12bd68db7; });
$parcel$export(module.exports, "getFrustrationIgnore", function () { return $31d460405430d474$export$54d9392c5518779c; });

var $8EfFG = parcelRequire("8EfFG");
//#region src/domain/action/frustrationIgnore.ts
const $31d460405430d474$var$FRUSTRATION_IGNORE_ATTRIBUTE = "data-dd-ignore-frustration";
const $31d460405430d474$var$ALL_FRUSTRATIONS_IGNORE_VALUE = "all";
const $31d460405430d474$var$RAGE_CLICK_IGNORE_VALUE = "rage-click";
const $31d460405430d474$var$DEAD_CLICK_IGNORE_VALUE = "dead-click";
const $31d460405430d474$var$ERROR_CLICK_IGNORE_VALUE = "error-click";
function $31d460405430d474$export$d58edfa12bd68db7(ignoredFrustrations, frustration) {
    return (ignoredFrustrations & frustration) !== 0;
}
function $31d460405430d474$export$54d9392c5518779c(element) {
    let frustrationIgnore = 0;
    let currentElement = element;
    while(currentElement){
        const attributeValue = currentElement.getAttribute($31d460405430d474$var$FRUSTRATION_IGNORE_ATTRIBUTE);
        if (attributeValue !== null) {
            const values = attributeValue.split(/\s+/);
            if (attributeValue.trim() === "" || values.includes($31d460405430d474$var$ALL_FRUSTRATIONS_IGNORE_VALUE)) return 7;
            if (values.includes($31d460405430d474$var$RAGE_CLICK_IGNORE_VALUE)) frustrationIgnore |= 1;
            if (values.includes($31d460405430d474$var$DEAD_CLICK_IGNORE_VALUE)) frustrationIgnore |= 2;
            if (values.includes($31d460405430d474$var$ERROR_CLICK_IGNORE_VALUE)) frustrationIgnore |= 4;
        }
        if (frustrationIgnore === 7) break;
        currentElement = (0, $8EfFG.getParentElement)(currentElement);
    }
    return frustrationIgnore;
}

});

parcelRegister("6QRSP", function(module, exports) {

$parcel$export(module.exports, "createClickChain", function () { return $47e8dbde2514f5fc$export$864c62f6b0bc947; });

var $i1SZ9 = parcelRequire("i1SZ9");

var $1wrwm = parcelRequire("1wrwm");

var $foX5P = parcelRequire("foX5P");
//#region src/domain/action/clickChain.ts
const $47e8dbde2514f5fc$export$1505b1def7b874c6 = (0, $1wrwm.ONE_SECOND);
function $47e8dbde2514f5fc$export$864c62f6b0bc947(firstClick, onFinalize) {
    const bufferedClicks = [];
    let status = 0;
    let maxDurationBetweenClicksTimeoutId;
    appendClick(firstClick);
    function appendClick(click) {
        click.stopObservable.subscribe(tryFinalize);
        bufferedClicks.push(click);
        (0, $foX5P.clearTimeout)(maxDurationBetweenClicksTimeoutId);
        maxDurationBetweenClicksTimeoutId = (0, $foX5P.setTimeout)(dontAcceptMoreClick, $47e8dbde2514f5fc$export$1505b1def7b874c6);
    }
    function tryFinalize() {
        if (status === 1 && bufferedClicks.every((click)=>click.isStopped())) {
            status = 2;
            onFinalize(bufferedClicks);
        }
    }
    function dontAcceptMoreClick() {
        (0, $foX5P.clearTimeout)(maxDurationBetweenClicksTimeoutId);
        if (status === 0) {
            status = 1;
            tryFinalize();
        }
    }
    return {
        tryAppend: (click)=>{
            if (status !== 0) return false;
            if (bufferedClicks.length > 0 && !$47e8dbde2514f5fc$var$areClicksSimilar(bufferedClicks[bufferedClicks.length - 1], click)) {
                dontAcceptMoreClick();
                return false;
            }
            appendClick(click);
            return true;
        },
        stop: ()=>{
            dontAcceptMoreClick();
        }
    };
}
/**
* Checks whether two clicks are similar by comparing their rage ignore state, target, position and timestamp
*/ function $47e8dbde2514f5fc$var$areClicksSimilar(first, second) {
    return (0, $i1SZ9.shouldIgnore)(first.ignore, 1) === (0, $i1SZ9.shouldIgnore)(second.ignore, 1) && first.event.target === second.event.target && $47e8dbde2514f5fc$var$mouseEventDistance(first.event, second.event) <= 100 && first.event.timeStamp - second.event.timeStamp <= $47e8dbde2514f5fc$export$1505b1def7b874c6;
}
function $47e8dbde2514f5fc$var$mouseEventDistance(origin, other) {
    return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}

});

parcelRegister("aGKMF", function(module, exports) {

$parcel$export(module.exports, "getActionNameFromElement", function () { return $c013ad059bd9127f$export$9c46f8d96b9f088f; });

var $8EfFG = parcelRequire("8EfFG");

var $eqtGB = parcelRequire("eqtGB");

var $8yVTM = parcelRequire("8yVTM");

var $8lnE0 = parcelRequire("8lnE0");

var $bWkrj = parcelRequire("bWkrj");
//#region src/domain/action/getActionNameFromElement.ts
function $c013ad059bd9127f$export$9c46f8d96b9f088f(element, rumConfiguration, nodePrivacyLevel = (0, $8yVTM.NodePrivacyLevel).ALLOW) {
    const nodePrivacyLevelCache = /* @__PURE__ */ new Map();
    const { actionNameAttribute: userProgrammaticAttribute } = rumConfiguration;
    const defaultActionName = $c013ad059bd9127f$var$getActionNameFromElementProgrammatically(element, "data-dd-action-name") || userProgrammaticAttribute && $c013ad059bd9127f$var$getActionNameFromElementProgrammatically(element, userProgrammaticAttribute);
    if (defaultActionName) return {
        name: defaultActionName,
        nameSource: "custom_attribute"
    };
    else if (nodePrivacyLevel === (0, $8yVTM.NodePrivacyLevel).MASK) return {
        name: (0, $eqtGB.ACTION_NAME_PLACEHOLDER),
        nameSource: "mask_placeholder"
    };
    return $c013ad059bd9127f$var$getActionNameFromElementForStrategies(element, $c013ad059bd9127f$var$priorityStrategies, rumConfiguration, nodePrivacyLevelCache) || $c013ad059bd9127f$var$getActionNameFromElementForStrategies(element, $c013ad059bd9127f$var$fallbackStrategies, rumConfiguration, nodePrivacyLevelCache) || {
        name: "",
        nameSource: "blank"
    };
}
function $c013ad059bd9127f$var$getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    const elementWithAttribute = $c013ad059bd9127f$var$closestShadowAware(targetElement, `[${programmaticAttribute}]`);
    if (!elementWithAttribute) return;
    return $c013ad059bd9127f$var$truncate($c013ad059bd9127f$var$normalizeWhitespace(elementWithAttribute.getAttribute(programmaticAttribute).trim()));
}
function $c013ad059bd9127f$var$closestShadowAware(element, selector) {
    let current = element;
    while(current){
        if (current.matches(selector)) return current;
        current = (0, $8EfFG.getParentElement)(current);
    }
    return null;
}
const $c013ad059bd9127f$var$priorityStrategies = [
    (element, rumConfiguration, nodePrivacyLevelCache)=>{
        if ("labels" in element && element.labels && element.labels.length > 0) return $c013ad059bd9127f$var$getActionNameFromTextualContent(element.labels[0], rumConfiguration, nodePrivacyLevelCache);
    },
    (element)=>{
        if (element.nodeName === "INPUT") {
            const input = element;
            const type = input.getAttribute("type");
            if (type === "button" || type === "submit" || type === "reset") return {
                name: input.value,
                nameSource: "text_content"
            };
        }
    },
    (element, rumConfiguration, nodePrivacyLevelCache)=>{
        if (element.nodeName === "BUTTON" || element.nodeName === "LABEL" || element.nodeName === "A" || element.getAttribute("role") === "button" || element.getAttribute("role") === "link") return $c013ad059bd9127f$var$getActionNameFromTextualContent(element, rumConfiguration, nodePrivacyLevelCache);
    },
    (element, rumConfiguration, nodePrivacyLevelCache)=>$c013ad059bd9127f$var$getActionNameFromStandardAttribute(element, "aria-label", rumConfiguration, nodePrivacyLevelCache),
    (element, rumConfiguration, nodePrivacyLevelCache)=>{
        const labelledByAttribute = element.getAttribute("aria-labelledby");
        if (labelledByAttribute) return {
            name: labelledByAttribute.split(/\s+/).map((id)=>$c013ad059bd9127f$var$getElementById(element, id)).filter((label)=>Boolean(label)).map((element)=>$c013ad059bd9127f$var$getTextualContent(element, rumConfiguration, nodePrivacyLevelCache)).join(" "),
            nameSource: "text_content"
        };
    },
    (element, rumConfiguration, nodePrivacyLevelCache)=>$c013ad059bd9127f$var$getActionNameFromStandardAttribute(element, "alt", rumConfiguration, nodePrivacyLevelCache),
    (element, rumConfiguration, nodePrivacyLevelCache)=>$c013ad059bd9127f$var$getActionNameFromStandardAttribute(element, "name", rumConfiguration, nodePrivacyLevelCache),
    (element, rumConfiguration, nodePrivacyLevelCache)=>$c013ad059bd9127f$var$getActionNameFromStandardAttribute(element, "title", rumConfiguration, nodePrivacyLevelCache),
    (element, rumConfiguration, nodePrivacyLevelCache)=>$c013ad059bd9127f$var$getActionNameFromStandardAttribute(element, "placeholder", rumConfiguration, nodePrivacyLevelCache),
    (element, rumConfiguration, nodePrivacyLevelCache)=>{
        if ("options" in element && element.options.length > 0) return $c013ad059bd9127f$var$getActionNameFromTextualContent(element.options[0], rumConfiguration, nodePrivacyLevelCache);
    }
];
const $c013ad059bd9127f$var$fallbackStrategies = [
    (element, rumConfiguration, nodePrivacyLevelCache)=>$c013ad059bd9127f$var$getActionNameFromTextualContent(element, rumConfiguration, nodePrivacyLevelCache)
];
/**
* Iterates over the target element and its parent, using the strategies list to get an action name.
* Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
*/ const $c013ad059bd9127f$var$MAX_PARENTS_TO_CONSIDER = 10;
function $c013ad059bd9127f$var$getActionNameFromElementForStrategies(targetElement, strategies, rumConfiguration, nodePrivacyLevelCache) {
    let element = targetElement;
    let recursionCounter = 0;
    while(recursionCounter <= $c013ad059bd9127f$var$MAX_PARENTS_TO_CONSIDER && element && element.nodeName !== "BODY" && element.nodeName !== "HTML" && element.nodeName !== "HEAD"){
        for (const strategy of strategies){
            const actionName = strategy(element, rumConfiguration, nodePrivacyLevelCache);
            if (actionName) {
                const { name: name, nameSource: nameSource } = actionName;
                const trimmedName = name?.trim();
                if (trimmedName) return {
                    name: $c013ad059bd9127f$var$truncate($c013ad059bd9127f$var$normalizeWhitespace(trimmedName)),
                    nameSource: nameSource
                };
            }
        }
        if (element.nodeName === "FORM") break;
        element = (0, $8EfFG.getParentElement)(element);
        recursionCounter += 1;
    }
}
function $c013ad059bd9127f$var$normalizeWhitespace(s) {
    return s.replace(/\s+/g, " ");
}
function $c013ad059bd9127f$var$truncate(s) {
    return s.length > 100 ? `${(0, $bWkrj.safeTruncate)(s, 100)} [...]` : s;
}
function $c013ad059bd9127f$var$getElementById(refElement, id) {
    const rootNode = refElement.getRootNode();
    if (rootNode instanceof ShadowRoot) {
        const shadowElement = rootNode.getElementById(id);
        if (shadowElement) return shadowElement;
    }
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function $c013ad059bd9127f$var$getActionNameFromStandardAttribute(element, attribute, rumConfiguration, nodePrivacyLevelCache) {
    const { enablePrivacyForActionName: enablePrivacyForActionName, defaultPrivacyLevel: defaultPrivacyLevel } = rumConfiguration;
    let attributeValue = element.getAttribute(attribute);
    if (attributeValue && enablePrivacyForActionName) {
        const nodePrivacyLevel = (0, $8lnE0.getNodePrivacyLevel)(element, defaultPrivacyLevel, nodePrivacyLevelCache);
        if ((0, $8lnE0.shouldMaskAttribute)(element.tagName, attribute, attributeValue, nodePrivacyLevel, rumConfiguration)) attributeValue = (0, $8lnE0.maskDisallowedTextContent)(attributeValue, (0, $eqtGB.ACTION_NAME_PLACEHOLDER));
    } else if (!attributeValue) attributeValue = "";
    return {
        name: attributeValue,
        nameSource: "standard_attribute"
    };
}
function $c013ad059bd9127f$var$getActionNameFromTextualContent(element, rumConfiguration, nodePrivacyLevelCache) {
    return {
        name: $c013ad059bd9127f$var$getTextualContent(element, rumConfiguration, nodePrivacyLevelCache) || "",
        nameSource: "text_content"
    };
}
function $c013ad059bd9127f$var$getTextualContent(element, rumConfiguration, nodePrivacyLevelCache) {
    if (element.isContentEditable) return;
    const { enablePrivacyForActionName: enablePrivacyForActionName, actionNameAttribute: userProgrammaticAttribute, defaultPrivacyLevel: defaultPrivacyLevel } = rumConfiguration;
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, rejectInvisibleOrMaskedElementsFilter);
    let text = "";
    while(walker.nextNode()){
        const node = walker.currentNode;
        if ((0, $8EfFG.isElementNode)(node)) {
            if (node.nodeName === "BR" || node.nodeName === "P" || [
                "block",
                "flex",
                "grid",
                "list-item",
                "table",
                "table-caption"
            ].includes(getComputedStyle(node).display)) text += " ";
            continue;
        }
        text += node.textContent || "";
    }
    return text.replace(/\s+/g, " ").trim();
    function rejectInvisibleOrMaskedElementsFilter(node) {
        const nodeSelfPrivacyLevel = (0, $8lnE0.getNodePrivacyLevel)(node, defaultPrivacyLevel, nodePrivacyLevelCache);
        if (enablePrivacyForActionName && nodeSelfPrivacyLevel && (0, $8lnE0.shouldMaskNode)(node, nodeSelfPrivacyLevel)) return NodeFilter.FILTER_REJECT;
        if ((0, $8EfFG.isElementNode)(node)) {
            if (node.hasAttribute("data-dd-action-name") || userProgrammaticAttribute && node.hasAttribute(userProgrammaticAttribute)) return NodeFilter.FILTER_REJECT;
            const style = getComputedStyle(node);
            if (style.visibility !== "visible" || style.display === "none" || style.contentVisibility && style.contentVisibility !== "visible") return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
    }
}

});

parcelRegister("ciHIa", function(module, exports) {

$parcel$export(module.exports, "listenActionEvents", function () { return $23bf9c1b25666728$export$8c9c528e477216a0; });

var $50cui = parcelRequire("50cui");
//#region src/domain/action/listenActionEvents.ts
function $23bf9c1b25666728$export$8c9c528e477216a0({ onPointerDown: onPointerDown, onPointerUp: onPointerUp }) {
    let selectionEmptyAtPointerDown;
    let userActivity = {
        selection: false,
        input: false,
        scroll: false
    };
    let clickContext;
    const listeners = [
        (0, $50cui.addEventListener)(window, (0, $50cui.DOM_EVENT).POINTER_DOWN, (event)=>{
            if ($23bf9c1b25666728$var$isValidPointerEvent(event)) {
                selectionEmptyAtPointerDown = $23bf9c1b25666728$var$isSelectionEmpty();
                userActivity = {
                    selection: false,
                    input: false,
                    scroll: false
                };
                clickContext = onPointerDown(event);
            }
        }, {
            capture: true
        }),
        (0, $50cui.addEventListener)(window, (0, $50cui.DOM_EVENT).SELECTION_CHANGE, ()=>{
            if (!selectionEmptyAtPointerDown || !$23bf9c1b25666728$var$isSelectionEmpty()) userActivity.selection = true;
        }, {
            capture: true
        }),
        (0, $50cui.addEventListener)(window, (0, $50cui.DOM_EVENT).SCROLL, ()=>{
            userActivity.scroll = true;
        }, {
            capture: true,
            passive: true
        }),
        (0, $50cui.addEventListener)(window, (0, $50cui.DOM_EVENT).POINTER_UP, (event)=>{
            if ($23bf9c1b25666728$var$isValidPointerEvent(event) && clickContext) {
                const localUserActivity = userActivity;
                onPointerUp(clickContext, event, ()=>localUserActivity);
                clickContext = void 0;
            }
        }, {
            capture: true
        }),
        (0, $50cui.addEventListener)(window, (0, $50cui.DOM_EVENT).INPUT, ()=>{
            userActivity.input = true;
        }, {
            capture: true
        })
    ];
    return {
        stop: ()=>{
            listeners.forEach((listener)=>listener.stop());
        }
    };
}
function $23bf9c1b25666728$var$isSelectionEmpty() {
    const selection = window.getSelection();
    return !selection || selection.isCollapsed;
}
function $23bf9c1b25666728$var$isValidPointerEvent(event) {
    return event.target instanceof Element && event.isPrimary !== false;
}

});

parcelRegister("gjrP2", function(module, exports) {

$parcel$export(module.exports, "computeFrustration", function () { return $6489a2fa063368f8$export$bd2d8b95c6d3b36c; });

var $6htpc = parcelRequire("6htpc");

var $i1SZ9 = parcelRequire("i1SZ9");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/action/computeFrustration.ts
const $6489a2fa063368f8$var$MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function $6489a2fa063368f8$export$bd2d8b95c6d3b36c(clicks, rageClick) {
    if ($6489a2fa063368f8$export$225704fb2a185e45(clicks)) {
        rageClick.addFrustration((0, $6htpc.FrustrationType).RAGE_CLICK);
        if (clicks.some($6489a2fa063368f8$export$e4a368a4d2e950a3)) rageClick.addFrustration((0, $6htpc.FrustrationType).DEAD_CLICK);
        if (rageClick.hasError && !(0, $i1SZ9.shouldIgnore)(rageClick.ignore, 4)) rageClick.addFrustration((0, $6htpc.FrustrationType).ERROR_CLICK);
        return {
            isRage: true
        };
    }
    const hasSelectionChanged = clicks.some((click)=>click.getUserActivity().selection);
    clicks.forEach((click)=>{
        if (click.hasError && !(0, $i1SZ9.shouldIgnore)(click.ignore, 4)) click.addFrustration((0, $6htpc.FrustrationType).ERROR_CLICK);
        if ($6489a2fa063368f8$export$e4a368a4d2e950a3(click) && !hasSelectionChanged) click.addFrustration((0, $6htpc.FrustrationType).DEAD_CLICK);
    });
    return {
        isRage: false
    };
}
function $6489a2fa063368f8$export$225704fb2a185e45(clicks) {
    if (clicks.some((click)=>(0, $i1SZ9.shouldIgnore)(click.ignore, 1) || click.getUserActivity().selection || click.getUserActivity().scroll)) return false;
    for(let i = 0; i < clicks.length - 2; i += 1)if (clicks[i + $6489a2fa063368f8$var$MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <= (0, $1wrwm.ONE_SECOND)) return true;
    return false;
}
const $6489a2fa063368f8$var$DEAD_CLICK_EXCLUDE_SELECTOR = "input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"button\"]):not([type=\"submit\"]):not([type=\"reset\"]):not([type=\"range\"]),textarea,select,[contenteditable],[contenteditable] *,canvas,a[href],a[href] *";
function $6489a2fa063368f8$export$e4a368a4d2e950a3(click) {
    if ((0, $i1SZ9.shouldIgnore)(click.ignore, 2)) return false;
    if (click.hasPageActivity || click.getUserActivity().input || click.getUserActivity().scroll) return false;
    let target = click.event.target;
    if (target.tagName === "LABEL" && target.hasAttribute("for")) target = document.getElementById(target.getAttribute("for"));
    return !target?.matches($6489a2fa063368f8$var$DEAD_CLICK_EXCLUDE_SELECTOR);
}

});

parcelRegister("6DNEb", function(module, exports) {

$parcel$export(module.exports, "CLICK_ACTION_MAX_DURATION", function () { return $f2a799e24209c88f$export$9ecdfc5cb82b78f3; });
$parcel$export(module.exports, "getInteractionSelector", function () { return $f2a799e24209c88f$export$54553eb1afcc5093; });
$parcel$export(module.exports, "updateInteractionSelector", function () { return $f2a799e24209c88f$export$49ad699d303b84c; });

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/action/interactionSelectorCache.ts
const $f2a799e24209c88f$export$9ecdfc5cb82b78f3 = 10 * (0, $1wrwm.ONE_SECOND);
const $f2a799e24209c88f$export$921921d3d73df8fe = /* @__PURE__ */ new Map();
function $f2a799e24209c88f$export$54553eb1afcc5093(relativeTimestamp) {
    const selector = $f2a799e24209c88f$export$921921d3d73df8fe.get(relativeTimestamp);
    $f2a799e24209c88f$export$921921d3d73df8fe.delete(relativeTimestamp);
    return selector;
}
function $f2a799e24209c88f$export$49ad699d303b84c(relativeTimestamp, selector) {
    $f2a799e24209c88f$export$921921d3d73df8fe.set(relativeTimestamp, selector);
    $f2a799e24209c88f$export$921921d3d73df8fe.forEach((_, relativeTimestamp)=>{
        if ((0, $1wrwm.elapsed)(relativeTimestamp, (0, $1wrwm.relativeNow)()) > $f2a799e24209c88f$export$9ecdfc5cb82b78f3) $f2a799e24209c88f$export$921921d3d73df8fe.delete(relativeTimestamp);
    });
}

});

parcelRegister("gxKYz", function(module, exports) {

$parcel$export(module.exports, "isActionChildEvent", function () { return $5ba3764d8859f7d2$export$cce53c8a96c99749; });
//#region src/domain/action/isActionChildEvent.ts
function $5ba3764d8859f7d2$export$cce53c8a96c99749(id) {
    return (event)=>event.action?.id?.includes(id) ?? false;
}

});


parcelRegister("1J1qi", function(module, exports) {

$parcel$export(module.exports, "trackManualActions", function () { return $eb30f29d1b7f923b$export$87a2e3ac9fea3df6; });

var $6htpc = parcelRequire("6htpc");
parcelRequire("jNZRV");

var $kPF4T = parcelRequire("kPF4T");

var $gxKYz = parcelRequire("gxKYz");

var $1wrwm = parcelRequire("1wrwm");

var $bWkrj = parcelRequire("bWkrj");
//#region src/domain/action/trackManualActions.ts
function $eb30f29d1b7f923b$export$87a2e3ac9fea3df6(lifeCycle, onManualActionCompleted) {
    const actionTracker = (0, $kPF4T.startEventTracker)(lifeCycle);
    function startManualAction(name, options = {}, startClocks = (0, $1wrwm.clocksNow)()) {
        const lookupKey = options.actionKey ?? name;
        const startedManualAction = actionTracker.start(lookupKey, startClocks, {
            name: name,
            ...options
        }, {
            isChildEvent: (0, $gxKYz.isActionChildEvent)
        });
        lifeCycle.notify(16, startedManualAction);
    }
    function stopManualAction(name, options = {}, stopClocks = (0, $1wrwm.clocksNow)()) {
        const lookupKey = options.actionKey ?? name;
        const stopped = actionTracker.stop(lookupKey, stopClocks, options);
        if (!stopped) return;
        const frustrationTypes = [];
        if (stopped.counts && stopped.counts.errorCount > 0) frustrationTypes.push((0, $6htpc.FrustrationType).ERROR_CLICK);
        onManualActionCompleted({
            ...stopped,
            type: stopped.type || (0, $6htpc.ActionType).CUSTOM,
            frustrationTypes: frustrationTypes
        });
    }
    function addInstantAction(action) {
        onManualActionCompleted({
            id: (0, $bWkrj.generateUUID)(),
            frustrationTypes: [],
            ...action
        });
    }
    return {
        addAction: addInstantAction,
        startAction: startManualAction,
        stopAction: stopManualAction,
        findActionId: actionTracker.findId,
        stop: actionTracker.stopAll
    };
}

});


parcelRegister("17qGp", function(module, exports) {

$parcel$export(module.exports, "startErrorCollection", function () { return $bf60d2b2284ed88d$export$243c2bf7ff6b9330; });

var $6htpc = parcelRequire("6htpc");
parcelRequire("jNZRV");

var $aF4xq = parcelRequire("aF4xq");

var $5tXxv = parcelRequire("5tXxv");
var $6PIx8 = parcelRequire("6PIx8");

var $lePkT = parcelRequire("lePkT");
var $SMkA1 = parcelRequire("SMkA1");
var $7RJVj = parcelRequire("7RJVj");
var $bWkrj = parcelRequire("bWkrj");
var $fnvkG = parcelRequire("fnvkG");
//#region src/domain/error/errorCollection.ts
function $bf60d2b2284ed88d$export$243c2bf7ff6b9330(lifeCycle, bufferedDataObservable) {
    const errorObservable = new (0, $fnvkG.Observable)();
    bufferedDataObservable.subscribe(({ data: data, type: type })=>{
        if (type === (0, $lePkT.BufferedDataType).RUNTIME_ERROR) errorObservable.notify(data);
        else if (type === (0, $lePkT.BufferedDataType).CONSOLE && data.api === (0, $6PIx8.ConsoleApiName).error) errorObservable.notify(data.error);
    });
    (0, $aF4xq.trackReportError)(errorObservable);
    errorObservable.subscribe((error)=>lifeCycle.notify(15, {
            error: error
        }));
    return $bf60d2b2284ed88d$export$87a10e29a48f580b(lifeCycle);
}
function $bf60d2b2284ed88d$export$87a10e29a48f580b(lifeCycle) {
    lifeCycle.subscribe(15, ({ error: error })=>{
        lifeCycle.notify(13, $bf60d2b2284ed88d$var$processError(error));
    });
    return {
        addError: ({ error: error, handlingStack: handlingStack, componentStack: componentStack, startClocks: startClocks, context: context })=>{
            const rawError = (0, $SMkA1.computeRawError)({
                originalError: error,
                handlingStack: handlingStack,
                componentStack: componentStack,
                startClocks: startClocks,
                nonErrorPrefix: (0, $7RJVj.NonErrorPrefix).PROVIDED,
                source: (0, $7RJVj.ErrorSource).CUSTOM,
                handling: (0, $7RJVj.ErrorHandling).HANDLED
            });
            rawError.context = (0, $5tXxv.combine)(rawError.context, context);
            lifeCycle.notify(15, {
                error: rawError
            });
        }
    };
}
function $bf60d2b2284ed88d$var$processError(error) {
    const rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: (0, $bWkrj.generateUUID)(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            component_stack: error.componentStack,
            type: error.type,
            handling: error.handling,
            causes: error.causes,
            source_type: "browser",
            fingerprint: error.fingerprint,
            csp: error.csp
        },
        _dd: {
            debug_ids: error.debugIds
        },
        type: (0, $6htpc.RumEventType).ERROR,
        context: error.context
    };
    const domainContext = {
        error: error.originalError,
        handlingStack: error.handlingStack
    };
    return {
        rawRumEvent: rawRumEvent,
        startClocks: error.startClocks,
        domainContext: domainContext
    };
}

});
parcelRegister("aF4xq", function(module, exports) {

$parcel$export(module.exports, "trackReportError", function () { return $dd6d2672fd7bd891$export$532a6c6a36756d07; });

var $cMPyG = parcelRequire("cMPyG");
//#region src/domain/error/trackReportError.ts
function $dd6d2672fd7bd891$export$532a6c6a36756d07(errorObservable) {
    const subscription = (0, $cMPyG.initReportObservable)([
        (0, $cMPyG.RawReportType).cspViolation,
        (0, $cMPyG.RawReportType).intervention
    ]).subscribe((rawError)=>errorObservable.notify(rawError));
    return {
        stop: ()=>{
            subscription.unsubscribe();
        }
    };
}

});
parcelRegister("cMPyG", function(module, exports) {

$parcel$export(module.exports, "RawReportType", function () { return $5d012ce2187000e7$export$1bd494ac7adbb6ce; });
$parcel$export(module.exports, "initReportObservable", function () { return $5d012ce2187000e7$export$645a986d81bb5490; });

var $fnvkG = parcelRequire("fnvkG");

var $bWkrj = parcelRequire("bWkrj");

var $e6zeV = parcelRequire("e6zeV");

var $50cui = parcelRequire("50cui");

var $7RJVj = parcelRequire("7RJVj");

var $cDxUX = parcelRequire("cDxUX");

var $dee0n = parcelRequire("dee0n");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/report/reportObservable.ts
const $5d012ce2187000e7$export$1bd494ac7adbb6ce = {
    intervention: "intervention",
    deprecation: "deprecation",
    cspViolation: "csp_violation"
};
function $5d012ce2187000e7$export$645a986d81bb5490(apis) {
    const observables = [];
    if (apis.includes($5d012ce2187000e7$export$1bd494ac7adbb6ce.cspViolation)) observables.push($5d012ce2187000e7$var$createCspViolationReportObservable());
    const reportTypes = apis.filter((api)=>api !== $5d012ce2187000e7$export$1bd494ac7adbb6ce.cspViolation);
    if (reportTypes.length) observables.push($5d012ce2187000e7$var$createReportObservable(reportTypes));
    return (0, $fnvkG.mergeObservables)(...observables);
}
function $5d012ce2187000e7$var$createReportObservable(reportTypes) {
    return new (0, $fnvkG.Observable)((observable)=>{
        if (!window.ReportingObserver) return;
        const handleReports = (0, $dee0n.monitor)((reports, _)=>reports.forEach((report)=>observable.notify($5d012ce2187000e7$var$buildRawReportErrorFromReport(report))));
        const observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true
        });
        observer.observe();
        return ()=>{
            observer.disconnect();
        };
    });
}
function $5d012ce2187000e7$var$createCspViolationReportObservable() {
    return new (0, $fnvkG.Observable)((observable)=>{
        if (!(0, $50cui.isEventSupported)(document, "securitypolicyviolation")) return;
        const { stop: stop } = (0, $50cui.addEventListener)(document, "securitypolicyviolation", (event)=>{
            observable.notify($5d012ce2187000e7$var$buildRawReportErrorFromCspViolation(event));
        });
        return stop;
    });
}
function $5d012ce2187000e7$var$buildRawReportErrorFromReport(report) {
    const { type: type, body: body } = report;
    return $5d012ce2187000e7$var$buildRawReportError({
        type: body.id,
        message: `${type}: ${body.message}`,
        originalError: report,
        stack: $5d012ce2187000e7$var$buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
        debugIds: body.sourceFile ? (0, $cDxUX.buildDebugIdByUrl)([
            body.sourceFile
        ]) : void 0
    });
}
function $5d012ce2187000e7$var$buildRawReportErrorFromCspViolation(event) {
    const message = `'${event.blockedURI}' blocked by '${event.effectiveDirective}' directive`;
    return $5d012ce2187000e7$var$buildRawReportError({
        type: event.effectiveDirective,
        message: `${$5d012ce2187000e7$export$1bd494ac7adbb6ce.cspViolation}: ${message}`,
        originalError: event,
        csp: {
            disposition: event.disposition
        },
        stack: $5d012ce2187000e7$var$buildStack(event.effectiveDirective, event.originalPolicy ? `${message} of the policy "${(0, $bWkrj.safeTruncate)(event.originalPolicy, 100, "...")}"` : "no policy", event.sourceFile, event.lineNumber, event.columnNumber),
        debugIds: event.sourceFile ? (0, $cDxUX.buildDebugIdByUrl)([
            event.sourceFile
        ]) : void 0
    });
}
function $5d012ce2187000e7$var$buildRawReportError(partial) {
    return {
        startClocks: (0, $1wrwm.clocksNow)(),
        source: (0, $7RJVj.ErrorSource).REPORT,
        handling: "unhandled",
        ...partial
    };
}
function $5d012ce2187000e7$var$buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return sourceFile ? (0, $e6zeV.toStackTraceString)({
        name: name,
        message: message,
        stack: [
            {
                func: "?",
                url: sourceFile,
                line: lineNumber ?? void 0,
                column: columnNumber ?? void 0
            }
        ]
    }) : void 0;
}

});



parcelRegister("5axha", function(module, exports) {

$parcel$export(module.exports, "startResourceCollection", function () { return $9b4a4e72ed3f7c60$export$7a0c7e0d79d84977; });

var $6htpc = parcelRequire("6htpc");

var $3TQDF = parcelRequire("3TQDF");

var $iVgUy = parcelRequire("iVgUy");
parcelRequire("laTCl");
parcelRequire("jNZRV");

var $38LZB = parcelRequire("38LZB");

var $j3F15 = parcelRequire("j3F15");

var $02H2D = parcelRequire("02H2D");

var $4H1Xw = parcelRequire("4H1Xw");

var $kPF4T = parcelRequire("kPF4T");

var $748DJ = parcelRequire("748DJ");

var $dW3bH = parcelRequire("dW3bH");

var $6AdX7 = parcelRequire("6AdX7");

var $ixCvr = parcelRequire("ixCvr");

var $1wrwm = parcelRequire("1wrwm");

var $5tXxv = parcelRequire("5tXxv");

var $cAK1F = parcelRequire("cAK1F");
var $jq8c3 = parcelRequire("jq8c3");
var $bWkrj = parcelRequire("bWkrj");
var $jM84O = parcelRequire("jM84O");
var $bOZaS = parcelRequire("bOZaS");
var $iXofQ = parcelRequire("iXofQ");
var $drxRN = parcelRequire("drxRN");
var $foX5P = parcelRequire("foX5P");
function $9b4a4e72ed3f7c60$export$7a0c7e0d79d84977(lifeCycle, configuration) {
    const taskQueue = (0, $bOZaS.mockable)((0, $cAK1F.createTaskQueue))();
    const requestRegistry = (0, $6AdX7.createRequestRegistry)(lifeCycle);
    lifeCycle.subscribe(9, (event)=>{
        const rawEvent = $9b4a4e72ed3f7c60$var$assembleWebSocketResource(event, configuration);
        if (rawEvent) lifeCycle.notify(13, rawEvent);
    });
    const performanceResourceSubscription = (0, $4H1Xw.createPerformanceObservable)({
        type: "resource",
        buffered: true
    }).subscribe((entries)=>{
        for (const entry of entries)if ((0, $38LZB.isResourceEntryRequestType)(entry)) (0, $foX5P.setTimeout)(()=>{
            const rawEvent = $9b4a4e72ed3f7c60$var$assembleResource(entry, requestRegistry.getMatchingRequest(entry), configuration);
            if (rawEvent) lifeCycle.notify(13, rawEvent);
        }, 50);
        else handleResource(()=>$9b4a4e72ed3f7c60$var$assembleResource(entry, void 0, configuration));
    });
    const { stop: stopRunOnReadyState } = (0, $drxRN.runOnReadyState)("interactive", ()=>{
        handleResource(()=>$9b4a4e72ed3f7c60$var$assembleResource((0, $748DJ.getNavigationEntry)(), void 0, configuration));
    });
    function handleResource(computeRawEvent) {
        taskQueue.push(()=>{
            const rawEvent = computeRawEvent();
            if (rawEvent) lifeCycle.notify(13, rawEvent);
        });
    }
    const resourceTracker = (0, $kPF4T.startEventTracker)(lifeCycle);
    const manualResources = (0, $ixCvr.trackManualResources)(lifeCycle, resourceTracker);
    return {
        startResource: manualResources.startResource,
        stopResource: manualResources.stopResource,
        stop: ()=>{
            stopRunOnReadyState();
            taskQueue.stop();
            performanceResourceSubscription.unsubscribe();
            resourceTracker.stopAll();
        }
    };
}
function $9b4a4e72ed3f7c60$var$assembleWebSocketResource(event, configuration) {
    const duration = (0, $1wrwm.elapsed)(event.startClocks.timeStamp, event.endClocks.timeStamp);
    const rawRumEvent = {
        date: event.startClocks.timeStamp,
        type: (0, $6htpc.RumEventType).RESOURCE,
        resource: {
            id: (0, $bWkrj.generateUUID)(),
            type: (0, $iXofQ.ResourceType).WEBSOCKET,
            url: event.url,
            duration: (0, $1wrwm.toServerDuration)(duration),
            websocket: {
                connection_id: event.connectionId,
                handshake_succeeded: event.handshakeSucceeded,
                start_time: event.startClocks.timeStamp,
                end_time: event.endClocks.timeStamp,
                start_view_id: event.startViewId,
                end_view_id: event.endViewId,
                tracking_end_reason: event.trackingEndReason,
                close_code: event.closeCode,
                close_reason: event.closeReason,
                was_clean: event.wasClean,
                messages_in: event.messagesIn,
                messages_out: event.messagesOut,
                time_to_first_message_in: (0, $1wrwm.toServerDuration)(event.firstMessageInOffset),
                time_to_first_message_out: (0, $1wrwm.toServerDuration)(event.firstMessageOutOffset),
                last_message_in_at: event.lastMessageInAt,
                longest_inbound_silence: (0, $1wrwm.toServerDuration)(event.longestInboundSilence),
                inbound_idle_duration_before_close: (0, $1wrwm.toServerDuration)(event.inboundIdleDurationBeforeClose),
                buffered_amount_max: event.bufferedAmountMax,
                protocol: event.protocol,
                setup_duration: (0, $1wrwm.toServerDuration)(event.setupDuration)
            }
        },
        _dd: {
            discarded: !configuration.trackResources
        }
    };
    return {
        startClocks: event.startClocks,
        duration: duration,
        rawRumEvent: rawRumEvent,
        domainContext: {
            isWebSocket: true,
            isManual: false,
            webSocket: event.webSocket
        }
    };
}
function $9b4a4e72ed3f7c60$var$assembleResource(entry, request, configuration) {
    const tracingInfo = request ? $9b4a4e72ed3f7c60$var$computeRequestTracingInfo(request, configuration) : $9b4a4e72ed3f7c60$var$computeResourceEntryTracingInfo(entry, configuration);
    if (!configuration.trackResources && !tracingInfo) return;
    const startClocks = (0, $1wrwm.relativeToClocks)(entry.startTime);
    const duration = (0, $38LZB.computeResourceEntryDuration)(entry);
    const networkHeaders = $9b4a4e72ed3f7c60$var$computeNetworkHeaders(request, configuration);
    return {
        startClocks: startClocks,
        duration: duration,
        rawRumEvent: (0, $5tXxv.combine)({
            date: startClocks.timeStamp,
            resource: {
                id: (0, $bWkrj.generateUUID)(),
                duration: (0, $1wrwm.toServerDuration)(duration),
                type: (0, $38LZB.computeResourceEntryType)(entry),
                method: request?.method,
                status_code: request ? request.status : $9b4a4e72ed3f7c60$var$discardZeroStatus(entry.responseStatus),
                url: request ? (0, $38LZB.sanitizeIfLongDataUrl)(request.url) : entry.name,
                protocol: (0, $38LZB.computeResourceEntryProtocol)(entry),
                delivery_type: (0, $38LZB.computeResourceEntryDeliveryType)(entry),
                graphql: request && $9b4a4e72ed3f7c60$var$computeGraphQlMetaData(request, configuration),
                render_blocking_status: entry.renderBlockingStatus,
                ...(0, $38LZB.computeResourceEntrySize)(entry),
                ...(0, $38LZB.computeResourceEntryDetails)(entry)
            },
            type: (0, $6htpc.RumEventType).RESOURCE,
            _dd: {
                discarded: !configuration.trackResources
            }
        }, tracingInfo, $9b4a4e72ed3f7c60$var$computeContentTypeFromPerformanceEntry(entry), networkHeaders),
        domainContext: $9b4a4e72ed3f7c60$var$getResourceDomainContext(entry, request)
    };
}
function $9b4a4e72ed3f7c60$var$computeGraphQlMetaData(request, configuration) {
    const graphQlConfig = (0, $02H2D.findGraphQlConfiguration)(request.url, configuration);
    if (!graphQlConfig) return;
    return (0, $02H2D.extractGraphQlMetadata)(request, graphQlConfig);
}
function $9b4a4e72ed3f7c60$var$computeContentTypeFromPerformanceEntry(entry) {
    const contentType = entry.contentType;
    if (contentType) return {
        resource: {
            response: {
                headers: {
                    "content-type": contentType
                }
            }
        }
    };
}
function $9b4a4e72ed3f7c60$var$getResourceDomainContext(entry, request) {
    return {
        performanceEntry: entry,
        isManual: false,
        isAborted: request ? request.isAborted : false,
        isWebSocket: false,
        handlingStack: request?.handlingStack,
        requestInit: request?.init,
        requestInput: request?.input,
        response: request?.response,
        error: request?.error,
        xhr: request?.xhr
    };
}
function $9b4a4e72ed3f7c60$var$computeRequestTracingInfo(request, configuration) {
    if (!(request.traceSampled && request.traceId && request.spanId)) return;
    return {
        _dd: {
            span_id: request.spanId.toString(),
            trace_id: request.traceId.toString(),
            rule_psr: configuration.rulePsr
        }
    };
}
function $9b4a4e72ed3f7c60$var$computeResourceEntryTracingInfo(entry, configuration) {
    if (entry.initiatorType !== "navigation") return;
    const traceId = (0, $bOZaS.mockable)((0, $dW3bH.getDocumentTraceId))(document);
    if (!traceId) return;
    return {
        _dd: {
            trace_id: traceId,
            span_id: (0, $j3F15.createSpanIdentifier)().toString(),
            rule_psr: configuration.rulePsr
        }
    };
}
/**
* The status is 0 for cross-origin resources without CORS headers, so the status is meaningless, and we shouldn't report it
* https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus#cross-origin_response_status_codes
*/ function $9b4a4e72ed3f7c60$var$discardZeroStatus(statusCode) {
    return statusCode === 0 ? void 0 : statusCode;
}
function $9b4a4e72ed3f7c60$var$computeNetworkHeaders(request, configuration) {
    const matchers = configuration.trackResourceHeaders;
    if (matchers.length === 0 || !request) return;
    const urlMatchers = matchers.filter((m)=>m.url !== void 0 ? (0, $jM84O.matchList)([
            m.url
        ], request.url, true) : true);
    if (urlMatchers.length === 0) return;
    const responseMatchers = urlMatchers.filter((m)=>m.location === void 0 || m.location === "any" || m.location === "response");
    const requestMatchers = urlMatchers.filter((m)=>m.location === void 0 || m.location === "any" || m.location === "request");
    const responseHeaders = responseMatchers.length > 0 ? $9b4a4e72ed3f7c60$var$getResponseHeaders(request, responseMatchers) : void 0;
    const requestHeaders = requestMatchers.length > 0 ? $9b4a4e72ed3f7c60$var$getRequestHeaders(request, requestMatchers) : void 0;
    if (!responseHeaders && !requestHeaders) return;
    return {
        resource: {
            request: requestHeaders ? {
                headers: requestHeaders
            } : void 0,
            response: responseHeaders ? {
                headers: responseHeaders
            } : void 0
        }
    };
}
function $9b4a4e72ed3f7c60$var$getResponseHeaders(request, matchers) {
    if (request.type === (0, $iXofQ.RequestType).FETCH && request.response) return $9b4a4e72ed3f7c60$var$filterHeaders(request.response.headers, matchers);
    if (request.type === (0, $iXofQ.RequestType).XHR && request.xhr) {
        const rawXhrHeaders = request.xhr.getAllResponseHeaders();
        if (rawXhrHeaders) try {
            return $9b4a4e72ed3f7c60$var$filterHeaders(new Headers($9b4a4e72ed3f7c60$var$parseRawXhrHeaders(rawXhrHeaders)), matchers);
        } catch  {}
    }
}
function $9b4a4e72ed3f7c60$var$getRequestHeaders(request, matchers) {
    if (request.type !== (0, $iXofQ.RequestType).FETCH) return;
    let headers;
    if (request.init?.headers) headers = new Headers(request.init.headers);
    else if (request.input instanceof Request) headers = request.input.headers;
    return headers ? $9b4a4e72ed3f7c60$var$filterHeaders(headers, matchers) : void 0;
}
const $9b4a4e72ed3f7c60$var$FORBIDDEN_HEADER_PATTERN = /(token|cookie|secret|authorization|(api|secret|access|app).?key|(client|connecting|real).?ip|forwarded)/;
const $9b4a4e72ed3f7c60$var$MAX_HEADER_COUNT = 100;
const $9b4a4e72ed3f7c60$var$MAX_HEADER_VALUE_LENGTH = 128;
const $9b4a4e72ed3f7c60$var$defaultHeadersMatchOption = (headerName)=>(0, $iVgUy.DEFAULT_TRACKED_RESOURCE_HEADERS).includes(headerName);
function $9b4a4e72ed3f7c60$var$filterHeaders(headers, matchers) {
    const result = {};
    let collectedHeaderCount = 0;
    let hasReachedMaxHeaderCount = false;
    headers.forEach((value, name)=>{
        if (collectedHeaderCount >= $9b4a4e72ed3f7c60$var$MAX_HEADER_COUNT) {
            if (!hasReachedMaxHeaderCount) {
                (0, $jq8c3.display).warn(`Maximum number of headers (${$9b4a4e72ed3f7c60$var$MAX_HEADER_COUNT}) has been reached. Further headers are dropped.`);
                hasReachedMaxHeaderCount = true;
            }
            return;
        }
        const lowerName = name.toLowerCase();
        if ($9b4a4e72ed3f7c60$var$FORBIDDEN_HEADER_PATTERN.test(lowerName)) return;
        const matchHeader = matchers.find((m)=>(0, $jM84O.matchList)([
                m.name ?? $9b4a4e72ed3f7c60$var$defaultHeadersMatchOption
            ], lowerName));
        if (!matchHeader) return;
        const { extractor: extractor } = matchHeader;
        const capturedValue = extractor ? (0, $3TQDF.extractRegexMatch)(value, extractor) : value;
        if (capturedValue === void 0) return;
        if (capturedValue.length > $9b4a4e72ed3f7c60$var$MAX_HEADER_VALUE_LENGTH) (0, $jq8c3.display).warn(`Header "${lowerName}" value was truncated from ${capturedValue.length} to ${$9b4a4e72ed3f7c60$var$MAX_HEADER_VALUE_LENGTH} characters.`);
        result[lowerName] = (0, $bWkrj.safeTruncate)(capturedValue, $9b4a4e72ed3f7c60$var$MAX_HEADER_VALUE_LENGTH);
        collectedHeaderCount++;
    });
    return collectedHeaderCount > 0 ? result : void 0;
}
function $9b4a4e72ed3f7c60$var$parseRawXhrHeaders(rawXhrheaders) {
    const pairs = [];
    const lines = rawXhrheaders.trim().split(/\r\n/);
    for (const line of lines){
        const colonIndex = line.indexOf(":");
        if (colonIndex > 0) pairs.push([
            line.substring(0, colonIndex).trim(),
            line.substring(colonIndex + 1).trim()
        ]);
    }
    return pairs;
}

});
parcelRegister("748DJ", function(module, exports) {

$parcel$export(module.exports, "getNavigationEntry", function () { return $962790a51c93cce1$export$6431553786c94949; });
$parcel$export(module.exports, "sanitizeFirstByte", function () { return $962790a51c93cce1$export$4e297b8162c99df9; });
$parcel$export(module.exports, "findLcpResourceEntry", function () { return $962790a51c93cce1$export$f575d1cc2a00f708; });

var $4H1Xw = parcelRequire("4H1Xw");

var $1wrwm = parcelRequire("1wrwm");

var $2faqW = parcelRequire("2faqW");
var $eQWMG = parcelRequire("eQWMG");
//#region src/browser/performanceUtils.ts
function $962790a51c93cce1$var$isValidNavigationEntry(entry) {
    return !(entry.loadEventEnd > 0 && entry.domComplete <= 0);
}
function $962790a51c93cce1$export$6431553786c94949() {
    if ((0, $4H1Xw.supportPerformanceTimingEvent)("navigation")) {
        const navigationEntry = performance.getEntriesByType("navigation")[0];
        if (navigationEntry && $962790a51c93cce1$var$isValidNavigationEntry(navigationEntry)) return navigationEntry;
    }
    const timings = $962790a51c93cce1$export$feb5c3ed98a58355();
    const entry = {
        entryType: "navigation",
        initiatorType: "navigation",
        name: window.location.href,
        startTime: 0,
        duration: timings.loadEventEnd,
        decodedBodySize: 0,
        encodedBodySize: 0,
        transferSize: 0,
        workerStart: 0,
        toJSON: ()=>({
                ...entry,
                toJSON: void 0
            }),
        ...timings
    };
    return entry;
}
function $962790a51c93cce1$export$feb5c3ed98a58355() {
    const result = {};
    const timing = performance.timing;
    for(const key in timing)if ((0, $eQWMG.isNumber)(timing[key])) {
        const numberKey = key;
        const timingElement = timing[numberKey];
        result[numberKey] = timingElement === 0 ? 0 : (0, $1wrwm.toRelativeTime)(timingElement);
    }
    return result;
}
function $962790a51c93cce1$export$4e297b8162c99df9(entry) {
    return entry.responseStart >= 0 && entry.responseStart <= (0, $1wrwm.relativeNow)() ? entry.responseStart : void 0;
}
function $962790a51c93cce1$export$d585e13c7167efb5() {
    if ((0, $4H1Xw.supportPerformanceTimingEvent)("resource")) return performance.getEntriesByType("resource");
}
/**
* Find the most relevant resource entry for an LCP element.
*
* Resource entries persist for the entire page lifetime and can include multiple requests
* for the same URL (preloads, cache-busting reloads, SPA route changes, etc.).
* This function returns the most recent matching entry that started before the LCP time,
* which is most likely the one that triggered the LCP paint.
*/ function $962790a51c93cce1$export$f575d1cc2a00f708(resourceUrl, lcpStartTime) {
    const entries = $962790a51c93cce1$export$d585e13c7167efb5();
    if (!entries) return;
    return (0, $2faqW.findLast)(entries, (entry)=>entry.name === resourceUrl && entry.startTime <= lcpStartTime);
}

});

parcelRegister("dW3bH", function(module, exports) {

$parcel$export(module.exports, "getDocumentTraceId", function () { return $0d7efb8fcb8e4115$export$9600d3c1068ac02c; });

var $8EfFG = parcelRequire("8EfFG");

var $1wrwm = parcelRequire("1wrwm");

var $bWkrj = parcelRequire("bWkrj");
//#region src/domain/tracing/getDocumentTraceId.ts
const $0d7efb8fcb8e4115$export$f1b0e1c95ecb6961 = 2 * (0, $1wrwm.ONE_MINUTE);
function $0d7efb8fcb8e4115$export$9600d3c1068ac02c(document) {
    const data = $0d7efb8fcb8e4115$export$cabe353a895a405f(document) || $0d7efb8fcb8e4115$export$70f194456d3a8998(document);
    if (!data || data.traceTime <= (0, $1wrwm.getTimeOrigin)() - $0d7efb8fcb8e4115$export$f1b0e1c95ecb6961) return;
    return data.traceId;
}
function $0d7efb8fcb8e4115$export$cabe353a895a405f(document) {
    const traceIdMeta = document.querySelector("meta[name=dd-trace-id]");
    const traceTimeMeta = document.querySelector("meta[name=dd-trace-time]");
    return $0d7efb8fcb8e4115$export$10b75f215ee15e0e(traceIdMeta?.content, traceTimeMeta?.content);
}
function $0d7efb8fcb8e4115$export$70f194456d3a8998(document) {
    const comment = $0d7efb8fcb8e4115$export$4d376e42fa08c24d(document);
    if (!comment) return;
    return $0d7efb8fcb8e4115$export$10b75f215ee15e0e((0, $bWkrj.findCommaSeparatedValue)(comment, "trace-id"), (0, $bWkrj.findCommaSeparatedValue)(comment, "trace-time"));
}
function $0d7efb8fcb8e4115$export$10b75f215ee15e0e(traceId, rawTraceTime) {
    const traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) return;
    return {
        traceId: traceId,
        traceTime: traceTime
    };
}
function $0d7efb8fcb8e4115$export$4d376e42fa08c24d(document) {
    for(let i = 0; i < document.childNodes.length; i += 1){
        const comment = $0d7efb8fcb8e4115$var$getTraceCommentFromNode(document.childNodes[i]);
        if (comment) return comment;
    }
    if (document.body) for(let i = document.body.childNodes.length - 1; i >= 0; i -= 1){
        const node = document.body.childNodes[i];
        const comment = $0d7efb8fcb8e4115$var$getTraceCommentFromNode(node);
        if (comment) return comment;
        if (!(0, $8EfFG.isTextNode)(node)) break;
    }
}
function $0d7efb8fcb8e4115$var$getTraceCommentFromNode(node) {
    if (node && (0, $8EfFG.isCommentNode)(node)) {
        const match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) return match[1];
    }
}

});

parcelRegister("6AdX7", function(module, exports) {

$parcel$export(module.exports, "createRequestRegistry", function () { return $f45d28ba758e2224$export$b1ac79667d658120; });
parcelRequire("jNZRV");
//#region src/domain/resource/requestRegistry.ts
const $f45d28ba758e2224$export$dc11d21111e5acb8 = 1e3;
function $f45d28ba758e2224$export$b1ac79667d658120(lifeCycle) {
    const requests = /* @__PURE__ */ new Set();
    const subscription = lifeCycle.subscribe(8, (request)=>{
        requests.add(request);
        if (requests.size > 1e3) requests.delete(requests.values().next().value);
    });
    return {
        getMatchingRequest (entry) {
            let minTimeDifference = Infinity;
            let closestRequest;
            for (const request of requests){
                const timeDifference = entry.startTime - request.startClocks.relative;
                if (0 <= timeDifference && timeDifference < minTimeDifference && request.url === entry.name) {
                    minTimeDifference = Math.abs(timeDifference);
                    closestRequest = request;
                }
            }
            if (closestRequest) requests.delete(closestRequest);
            return closestRequest;
        },
        stop () {
            subscription.unsubscribe();
        }
    };
}

});

parcelRegister("ixCvr", function(module, exports) {

$parcel$export(module.exports, "trackManualResources", function () { return $f591d6b4daf0fac1$export$578c6c69d18434b4; });

var $6htpc = parcelRequire("6htpc");
parcelRequire("jNZRV");

var $38LZB = parcelRequire("38LZB");

var $1wrwm = parcelRequire("1wrwm");

var $iXofQ = parcelRequire("iXofQ");
//#region src/domain/resource/trackManualResources.ts
function $f591d6b4daf0fac1$export$578c6c69d18434b4(lifeCycle, resourceTracker) {
    function startManualResource(url, options = {}, startClocks = (0, $1wrwm.clocksNow)()) {
        const lookupKey = options.resourceKey ?? url;
        resourceTracker.start(lookupKey, startClocks, {
            url: url,
            ...options
        });
    }
    function stopManualResource(url, options = {}, stopClocks = (0, $1wrwm.clocksNow)()) {
        const lookupKey = options.resourceKey ?? url;
        const stopped = resourceTracker.stop(lookupKey, stopClocks, {
            context: options.context,
            type: options.type
        });
        if (!stopped) return;
        const duration = (0, $1wrwm.elapsed)(stopped.startClocks.relative, stopClocks.relative);
        const rawRumEvent = {
            date: stopped.startClocks.timeStamp,
            type: (0, $6htpc.RumEventType).RESOURCE,
            resource: {
                id: stopped.id,
                type: stopped.type || (0, $iXofQ.ResourceType).OTHER,
                url: (0, $38LZB.sanitizeIfLongDataUrl)(stopped.url),
                duration: (0, $1wrwm.toServerDuration)(duration),
                method: stopped.method,
                status_code: options.statusCode,
                size: options.size
            },
            _dd: {},
            context: stopped.context
        };
        lifeCycle.notify(13, {
            rawRumEvent: rawRumEvent,
            startClocks: stopped.startClocks,
            duration: duration,
            domainContext: {
                isManual: true
            }
        });
    }
    return {
        startResource: startManualResource,
        stopResource: stopManualResource
    };
}

});

parcelRegister("cAK1F", function(module, exports) {

$parcel$export(module.exports, "createTaskQueue", function () { return $afb77fd5f7cd8c99$export$e1c4294b917c2b7b; });

var $8rkBq = parcelRequire("8rkBq");

var $1wrwm = parcelRequire("1wrwm");
//#region src/tools/taskQueue.ts
/**
* Maximum delay before starting to execute tasks in the queue. We don't want to wait too long
* before running tasks, as it might hurt reliability (ex: if the user navigates away, we might lose
* the opportunity to send some data). We also don't want to run tasks too often, as it might hurt
* performance.
*/ const $afb77fd5f7cd8c99$var$IDLE_CALLBACK_TIMEOUT = (0, $1wrwm.ONE_SECOND);
/**
* Maximum amount of time allocated to running tasks when a timeout (`IDLE_CALLBACK_TIMEOUT`) is
* reached. We should not run tasks for too long as it will hurt performance, but we should still
* run some tasks to avoid postponing them forever.
*
* Rational: Running tasks for 30ms every second (IDLE_CALLBACK_TIMEOUT) should be acceptable.
*/ const $afb77fd5f7cd8c99$export$85114d25709d11dc = 30;
function $afb77fd5f7cd8c99$export$e1c4294b917c2b7b() {
    const pendingTasks = [];
    function run(deadline) {
        let executionTimeRemaining;
        if (!deadline || deadline.didTimeout) {
            const start = performance.now();
            executionTimeRemaining = ()=>30 - (performance.now() - start);
        } else executionTimeRemaining = deadline.timeRemaining.bind(deadline);
        while(executionTimeRemaining() > 0 && pendingTasks.length)pendingTasks.shift()();
        if (pendingTasks.length) scheduleNextRun();
    }
    function scheduleNextRun() {
        (0, $8rkBq.requestIdleCallback)(run, {
            timeout: $afb77fd5f7cd8c99$var$IDLE_CALLBACK_TIMEOUT
        });
    }
    return {
        push (task) {
            if (pendingTasks.push(task) === 1) scheduleNextRun();
        },
        stop () {
            pendingTasks.length = 0;
        }
    };
}

});
parcelRegister("8rkBq", function(module, exports) {

$parcel$export(module.exports, "requestIdleCallback", function () { return $5e66cb524c3997c9$export$9288a5d956b3efbe; });

var $foX5P = parcelRequire("foX5P");

var $dee0n = parcelRequire("dee0n");

var $1wrwm = parcelRequire("1wrwm");
//#region src/tools/requestIdleCallback.ts
/**
* 'requestIdleCallback' with a shim.
*/ function $5e66cb524c3997c9$export$9288a5d956b3efbe(callback, opts) {
    if (window.requestIdleCallback && window.cancelIdleCallback) {
        const id = window.requestIdleCallback((0, $dee0n.monitor)(callback), opts);
        return ()=>window.cancelIdleCallback(id);
    }
    return $5e66cb524c3997c9$export$fc768205f0931253(callback);
}
function $5e66cb524c3997c9$export$fc768205f0931253(callback) {
    const start = (0, $1wrwm.dateNow)();
    const timeoutId = (0, $foX5P.setTimeout)(()=>{
        callback({
            didTimeout: false,
            timeRemaining: ()=>Math.max(0, 50 - ((0, $1wrwm.dateNow)() - start))
        });
    }, 0);
    return ()=>(0, $foX5P.clearTimeout)(timeoutId);
}

});


parcelRegister("drxRN", function(module, exports) {

$parcel$export(module.exports, "runOnReadyState", function () { return $16a8f95ccdcb7c96$export$12cb733fc911e4f7; });
$parcel$export(module.exports, "asyncRunOnReadyState", function () { return $16a8f95ccdcb7c96$export$67f00e1a0f1478a8; });

var $hH6Lc = parcelRequire("hH6Lc");

var $50cui = parcelRequire("50cui");
//#region src/browser/runOnReadyState.ts
function $16a8f95ccdcb7c96$export$12cb733fc911e4f7(expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === "complete") {
        callback();
        return {
            stop: (0, $hH6Lc.noop)
        };
    }
    return (0, $50cui.addEventListener)(window, expectedReadyState === "complete" ? "load" : "DOMContentLoaded", callback, {
        once: true
    });
}
function $16a8f95ccdcb7c96$export$67f00e1a0f1478a8(expectedReadyState) {
    return new Promise((resolve)=>{
        $16a8f95ccdcb7c96$export$12cb733fc911e4f7(expectedReadyState, resolve);
    });
}

});


parcelRegister("9jBKY", function(module, exports) {

$parcel$export(module.exports, "startViewCollection", function () { return $c32137ec2a48580a$export$794a32d201ece359; });

var $6htpc = parcelRequire("6htpc");
parcelRequire("jNZRV");

var $hEma3 = parcelRequire("hEma3");

var $lj333 = parcelRequire("lj333");

var $1wrwm = parcelRequire("1wrwm");

var $8nGP1 = parcelRequire("8nGP1");
var $brKlt = parcelRequire("brKlt");

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/view/viewCollection.ts
function $c32137ec2a48580a$export$794a32d201ece359(lifeCycle, hooks, configuration, domMutationObservable, pageOpenObservable, locationChangeObservable, recorderApi, viewHistory, initialViewOptions) {
    lifeCycle.subscribe(4, (view)=>lifeCycle.notify(13, $c32137ec2a48580a$var$processViewUpdate(view, configuration, recorderApi)));
    hooks.assembleEventDefaults.register(({ startTime: startTime, eventType: eventType })=>{
        const view = viewHistory.findView(startTime);
        if (!view) return 0, $fNtjE.DISCARDED;
        return {
            type: eventType,
            service: view.service,
            version: view.version,
            context: view.context,
            view: {
                id: view.id,
                name: view.name
            }
        };
    });
    hooks.assembleTelemetry.register(({ startTime: startTime })=>({
            view: {
                id: viewHistory.findView(startTime)?.id
            }
        }));
    return (0, $lj333.trackViews)(lifeCycle, domMutationObservable, pageOpenObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function $c32137ec2a48580a$var$processViewUpdate(view, configuration, recorderApi) {
    const replayStats = recorderApi.getReplayStats(view.id);
    const clsDevicePixelRatio = view.commonViewMetrics?.cumulativeLayoutShift?.devicePixelRatio;
    const viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
            cls: clsDevicePixelRatio ? {
                device_pixel_ratio: clsDevicePixelRatio
            } : void 0,
            configuration: {
                start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
                remote_configuration_id: configuration.remoteConfigurationId
            }
        },
        date: view.startClocks.timeStamp,
        type: (0, $6htpc.RumEventType).VIEW,
        view: {
            action: {
                count: view.eventCounts.actionCount
            },
            frustration: {
                count: view.eventCounts.frustrationCount
            },
            cumulative_layout_shift: view.commonViewMetrics.cumulativeLayoutShift?.value,
            cumulative_layout_shift_time: (0, $1wrwm.toServerDuration)(view.commonViewMetrics.cumulativeLayoutShift?.time),
            cumulative_layout_shift_target_selector: view.commonViewMetrics.cumulativeLayoutShift?.targetSelector,
            first_byte: (0, $1wrwm.toServerDuration)(view.initialViewMetrics.navigationTimings?.firstByte),
            dom_complete: (0, $1wrwm.toServerDuration)(view.initialViewMetrics.navigationTimings?.domComplete),
            dom_content_loaded: (0, $1wrwm.toServerDuration)(view.initialViewMetrics.navigationTimings?.domContentLoaded),
            dom_interactive: (0, $1wrwm.toServerDuration)(view.initialViewMetrics.navigationTimings?.domInteractive),
            error: {
                count: view.eventCounts.errorCount
            },
            first_contentful_paint: (0, $1wrwm.toServerDuration)(view.initialViewMetrics.firstContentfulPaint),
            interaction_to_next_paint: (0, $1wrwm.toServerDuration)(view.commonViewMetrics.interactionToNextPaint?.value),
            interaction_to_next_paint_time: (0, $1wrwm.toServerDuration)(view.commonViewMetrics.interactionToNextPaint?.time),
            interaction_to_next_paint_target_selector: view.commonViewMetrics.interactionToNextPaint?.targetSelector,
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: (0, $1wrwm.toServerDuration)(view.initialViewMetrics.largestContentfulPaint?.value),
            largest_contentful_paint_target_selector: view.initialViewMetrics.largestContentfulPaint?.targetSelector,
            load_event: (0, $1wrwm.toServerDuration)(view.initialViewMetrics.navigationTimings?.loadEvent),
            loading_time: (0, $hEma3.discardNegativeDuration)((0, $1wrwm.toServerDuration)(view.commonViewMetrics.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount
            },
            performance: $c32137ec2a48580a$var$computeViewPerformanceData(view.commonViewMetrics, view.initialViewMetrics),
            resource: {
                count: view.eventCounts.resourceCount
            },
            time_spent: (0, $1wrwm.toServerDuration)(view.duration)
        },
        display: view.commonViewMetrics.scroll ? {
            scroll: {
                max_depth: view.commonViewMetrics.scroll.maxDepth,
                max_depth_scroll_top: view.commonViewMetrics.scroll.maxDepthScrollTop,
                max_scroll_height: view.commonViewMetrics.scroll.maxScrollHeight,
                max_scroll_height_time: (0, $1wrwm.toServerDuration)(view.commonViewMetrics.scroll.maxScrollHeightTime)
            }
        } : void 0,
        privacy: {
            replay_level: configuration.defaultPrivacyLevel
        },
        device: {
            locale: navigator.language,
            locales: navigator.languages,
            time_zone: (0, $8nGP1.getTimeZone)()
        }
    };
    if (!(0, $brKlt.isEmptyObject)(view.customTimings)) viewEvent.view.custom_timings = (0, $brKlt.mapValues)(view.customTimings, (0, $1wrwm.toServerDuration));
    return {
        rawRumEvent: viewEvent,
        startClocks: view.startClocks,
        duration: view.duration,
        domainContext: {
            location: view.location,
            handlingStack: view.handlingStack
        }
    };
}
function $c32137ec2a48580a$var$computeViewPerformanceData({ cumulativeLayoutShift: cumulativeLayoutShift, interactionToNextPaint: interactionToNextPaint }, { firstContentfulPaint: firstContentfulPaint, largestContentfulPaint: largestContentfulPaint }) {
    return {
        cls: cumulativeLayoutShift && {
            score: cumulativeLayoutShift.value,
            timestamp: (0, $1wrwm.toServerDuration)(cumulativeLayoutShift.time),
            target_selector: cumulativeLayoutShift.targetSelector,
            previous_rect: cumulativeLayoutShift.previousRect,
            current_rect: cumulativeLayoutShift.currentRect
        },
        fcp: firstContentfulPaint && {
            timestamp: (0, $1wrwm.toServerDuration)(firstContentfulPaint)
        },
        inp: interactionToNextPaint && {
            duration: (0, $1wrwm.toServerDuration)(interactionToNextPaint.value),
            timestamp: (0, $1wrwm.toServerDuration)(interactionToNextPaint.time),
            target_selector: interactionToNextPaint.targetSelector,
            sub_parts: interactionToNextPaint.subParts ? {
                input_delay: (0, $1wrwm.toServerDuration)(interactionToNextPaint.subParts.inputDelay),
                processing_duration: (0, $1wrwm.toServerDuration)(interactionToNextPaint.subParts.processingDuration),
                presentation_delay: (0, $1wrwm.toServerDuration)(interactionToNextPaint.subParts.presentationDelay)
            } : void 0
        },
        lcp: largestContentfulPaint && {
            timestamp: (0, $1wrwm.toServerDuration)(largestContentfulPaint.value),
            target_selector: largestContentfulPaint.targetSelector,
            resource_url: largestContentfulPaint.resourceUrl,
            sub_parts: largestContentfulPaint.subParts ? {
                load_delay: (0, $1wrwm.toServerDuration)(largestContentfulPaint.subParts.loadDelay),
                load_time: (0, $1wrwm.toServerDuration)(largestContentfulPaint.subParts.loadTime),
                render_delay: (0, $1wrwm.toServerDuration)(largestContentfulPaint.subParts.renderDelay)
            } : void 0
        }
    };
}

});
parcelRegister("lj333", function(module, exports) {

$parcel$export(module.exports, "trackViews", function () { return $07c415d6400d8ff5$export$a9e93bc2fdba42cf; });

var $6htpc = parcelRequire("6htpc");
parcelRequire("jNZRV");

var $4H1Xw = parcelRequire("4H1Xw");

var $1BqRF = parcelRequire("1BqRF");

var $2KLlK = parcelRequire("2KLlK");

var $b8Bkb = parcelRequire("b8Bkb");

var $2XHS3 = parcelRequire("2XHS3");

var $1JL9a = parcelRequire("1JL9a");

var $bkA2Z = parcelRequire("bkA2Z");

var $1wrwm = parcelRequire("1wrwm");

var $foX5P = parcelRequire("foX5P");
var $cybD8 = parcelRequire("cybD8");
var $jq8c3 = parcelRequire("jq8c3");
var $fOYzt = parcelRequire("fOYzt");
var $bWkrj = parcelRequire("bWkrj");
var $bOZaS = parcelRequire("bOZaS");
var $hH6Lc = parcelRequire("hH6Lc");
var $fnvkG = parcelRequire("fnvkG");
var $ljRg3 = parcelRequire("ljRg3");
var $brKlt = parcelRequire("brKlt");
//#region src/domain/view/trackViews.ts
const $07c415d6400d8ff5$export$547e59d66cff6939 = 3e3;
const $07c415d6400d8ff5$export$466344df8256a878 = 5 * (0, $1wrwm.ONE_MINUTE);
const $07c415d6400d8ff5$export$41ad004d27ab927 = 5 * (0, $1wrwm.ONE_MINUTE);
function $07c415d6400d8ff5$export$a9e93bc2fdba42cf(lifeCycle, domMutationObservable, windowOpenObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    const activeViews = /* @__PURE__ */ new Set();
    let currentView = startNewView((0, $6htpc.ViewLoadingType).INITIAL_LOAD, (0, $1wrwm.clocksOrigin)(), initialViewOptions);
    let stopOnBFCacheRestore;
    startViewLifeCycle();
    let locationChangeSubscription;
    if (areViewsTrackedAutomatically) {
        locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
        stopOnBFCacheRestore = (0, $1JL9a.onBFCacheRestore)((pageshowEvent)=>{
            currentView.end();
            const startClocks = (0, $1wrwm.relativeToClocks)(pageshowEvent.timeStamp);
            currentView = startNewView((0, $6htpc.ViewLoadingType).BF_CACHE, startClocks, void 0);
        });
    }
    function startNewView(loadingType, startClocks, viewOptions) {
        const newlyCreatedView = $07c415d6400d8ff5$var$newView(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadingType, startClocks, viewOptions);
        activeViews.add(newlyCreatedView);
        newlyCreatedView.stopObservable.subscribe(()=>{
            activeViews.delete(newlyCreatedView);
        });
        return newlyCreatedView;
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(11, ()=>{
            currentView = startNewView((0, $6htpc.ViewLoadingType).SESSION_RENEWAL, void 0, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version,
                context: currentView.contextManager.getContext()
            });
        });
        lifeCycle.subscribe(10, ({ endClocks: endClocks })=>{
            currentView.end({
                sessionIsActive: false,
                endClocks: endClocks
            });
        });
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(({ oldLocation: oldLocation, newLocation: newLocation })=>{
            if ($07c415d6400d8ff5$var$areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView = startNewView((0, $6htpc.ViewLoadingType).ROUTE_CHANGE);
            }
        });
    }
    return {
        addTiming: (name, time = (0, $1wrwm.timeStampNow)())=>{
            currentView.addTiming(name, time);
        },
        setLoadingTime: (callTimestamp)=>currentView.setLoadingTime(callTimestamp),
        startView: (options, startClocks)=>{
            currentView.end({
                endClocks: startClocks
            });
            currentView = startNewView((0, $6htpc.ViewLoadingType).ROUTE_CHANGE, startClocks, options);
        },
        setViewContext: (context)=>{
            currentView.contextManager.setContext(context);
        },
        setViewContextProperty: (key, value)=>{
            currentView.contextManager.setContextProperty(key, value);
        },
        setViewName: (name)=>{
            currentView.setViewName(name);
        },
        getViewContext: ()=>currentView.contextManager.getContext(),
        stop: ()=>{
            if (locationChangeSubscription) locationChangeSubscription.unsubscribe();
            if (stopOnBFCacheRestore) stopOnBFCacheRestore();
            currentView.end();
            activeViews.forEach((view)=>view.stop());
        }
    };
}
function $07c415d6400d8ff5$var$newView(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadingType, startClocks = (0, $1wrwm.clocksNow)(), viewOptions) {
    const id = (0, $bWkrj.generateUUID)();
    const stopObservable = new (0, $fnvkG.Observable)();
    const customTimings = {};
    let documentVersion = 0;
    let endClocks;
    const location = (0, $brKlt.shallowClone)((0, $bOZaS.mockable)(window.location));
    const contextManager = (0, $cybD8.createContextManager)();
    let sessionIsActive = true;
    let name = viewOptions?.name;
    const service = viewOptions?.service || configuration.service;
    const version = viewOptions?.version || configuration.version;
    const context = viewOptions?.context;
    const handlingStack = viewOptions?.handlingStack;
    if (context) contextManager.setContext(context);
    const viewCreatedEvent = {
        id: id,
        name: name,
        startClocks: startClocks,
        service: service,
        version: version,
        context: context,
        url: viewOptions?.url
    };
    lifeCycle.notify(1, viewCreatedEvent);
    lifeCycle.notify(2, viewCreatedEvent);
    const { throttled: throttled, cancel: cancelScheduleViewUpdate } = (0, $hH6Lc.throttle)(triggerViewUpdate, $07c415d6400d8ff5$export$547e59d66cff6939, {
        leading: false
    });
    const { setLoadEvent: setLoadEvent, setViewEnd: setViewEnd, stop: stopCommonViewMetricsTracking, stopINPTracking: stopINPTracking, getCommonViewMetrics: getCommonViewMetrics, setLoadingTime: setLoadingTime } = (0, $2XHS3.trackCommonViewMetrics)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, scheduleViewUpdate, loadingType, startClocks);
    let viewMetricsTracking = loadingType === (0, $6htpc.ViewLoadingType).INITIAL_LOAD ? {
        ...(0, $b8Bkb.trackInitialViewMetrics)(configuration, startClocks, setLoadEvent, scheduleViewUpdate),
        setViewEnd: (0, $hH6Lc.noop)
    } : {
        stop: (0, $hH6Lc.noop),
        initialViewMetrics: {},
        setViewEnd: (0, $hH6Lc.noop)
    };
    if (loadingType === (0, $6htpc.ViewLoadingType).ROUTE_CHANGE && (0, $fOYzt.isExperimentalFeatureEnabled)((0, $fOYzt.ExperimentalFeature).SOFT_NAVIGATION) && (0, $4H1Xw.supportPerformanceTimingEvent)("soft-navigation")) viewMetricsTracking = (0, $2KLlK.trackRouteChangeViewMetrics)(configuration, scheduleViewUpdate);
    const { stop: stopInitialViewMetricsTracking, initialViewMetrics: initialViewMetrics, setViewEnd: setRouteChangeViewEnd } = viewMetricsTracking;
    if (loadingType === (0, $6htpc.ViewLoadingType).BF_CACHE) (0, $bkA2Z.trackBfcacheMetrics)(startClocks, initialViewMetrics, scheduleViewUpdate);
    const { stop: stopEventCountsTracking, eventCounts: eventCounts } = (0, $1BqRF.trackViewEventCounts)(lifeCycle, id, scheduleViewUpdate);
    const keepAliveIntervalId = (0, $foX5P.setInterval)(triggerViewUpdate, $07c415d6400d8ff5$export$466344df8256a878);
    const pageMayExitSubscription = lifeCycle.subscribe(12, (reason)=>{
        if (reason === (0, $ljRg3.PageExitReason).UNLOADING) triggerViewUpdate();
    });
    triggerViewUpdate();
    contextManager.changeObservable.subscribe(scheduleViewUpdate);
    function triggerBeforeViewUpdate() {
        lifeCycle.notify(3, {
            id: id,
            name: name,
            context: contextManager.getContext(),
            startClocks: startClocks,
            sessionIsActive: sessionIsActive
        });
    }
    function scheduleViewUpdate() {
        triggerBeforeViewUpdate();
        throttled();
    }
    function triggerViewUpdate() {
        cancelScheduleViewUpdate();
        triggerBeforeViewUpdate();
        documentVersion += 1;
        const currentEnd = endClocks === void 0 ? (0, $1wrwm.timeStampNow)() : endClocks.timeStamp;
        lifeCycle.notify(4, {
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            service: service,
            version: version,
            context: contextManager.getContext(),
            loadingType: loadingType,
            location: location,
            handlingStack: handlingStack,
            startClocks: startClocks,
            commonViewMetrics: getCommonViewMetrics(),
            initialViewMetrics: initialViewMetrics,
            duration: (0, $1wrwm.elapsed)(startClocks.timeStamp, currentEnd),
            isActive: endClocks === void 0,
            sessionIsActive: sessionIsActive,
            eventCounts: eventCounts
        });
    }
    return {
        get name () {
            return name;
        },
        service: service,
        version: version,
        contextManager: contextManager,
        stopObservable: stopObservable,
        end (options = {}) {
            if (endClocks) return;
            endClocks = options.endClocks ?? (0, $1wrwm.clocksNow)();
            sessionIsActive = options.sessionIsActive ?? true;
            lifeCycle.notify(5, {
                endClocks: endClocks
            });
            lifeCycle.notify(6, {
                endClocks: endClocks
            });
            (0, $foX5P.clearInterval)(keepAliveIntervalId);
            setViewEnd(endClocks.relative);
            setRouteChangeViewEnd();
            stopCommonViewMetricsTracking();
            pageMayExitSubscription.unsubscribe();
            triggerViewUpdate();
            (0, $foX5P.setTimeout)(()=>{
                this.stop();
            }, $07c415d6400d8ff5$export$41ad004d27ab927);
        },
        stop () {
            stopInitialViewMetricsTracking();
            stopEventCountsTracking();
            stopINPTracking();
            stopObservable.notify();
        },
        addTiming (name, time) {
            if (endClocks) return;
            const relativeTime = (0, $1wrwm.isRelativeTime)(time) ? time : (0, $1wrwm.elapsed)(startClocks.timeStamp, time);
            customTimings[$07c415d6400d8ff5$var$sanitizeTiming(name)] = relativeTime;
            scheduleViewUpdate();
        },
        setLoadingTime: setLoadingTime,
        setViewName (updatedName) {
            name = updatedName;
            triggerViewUpdate();
        }
    };
}
/**
* Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
*/ function $07c415d6400d8ff5$var$sanitizeTiming(name) {
    const sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, "_");
    if (sanitized !== name) (0, $jq8c3.display).warn(`Invalid timing name: ${name}, sanitized to: ${sanitized}`);
    return sanitized;
}
function $07c415d6400d8ff5$var$areDifferentLocation(currentLocation, otherLocation) {
    return currentLocation.pathname !== otherLocation.pathname || !$07c415d6400d8ff5$var$isHashAnAnchor(otherLocation.hash) && $07c415d6400d8ff5$var$getPathFromHash(otherLocation.hash) !== $07c415d6400d8ff5$var$getPathFromHash(currentLocation.hash);
}
function $07c415d6400d8ff5$var$isHashAnAnchor(hash) {
    const correspondingId = hash.substring(1);
    return correspondingId !== "" && !!document.getElementById(correspondingId);
}
function $07c415d6400d8ff5$var$getPathFromHash(hash) {
    const index = hash.indexOf("?");
    return index < 0 ? hash : hash.slice(0, index);
}

});
parcelRegister("1BqRF", function(module, exports) {

$parcel$export(module.exports, "trackViewEventCounts", function () { return $b2c72421907aac94$export$fcb8a99c2bff4a6b; });

var $0aAbO = parcelRequire("0aAbO");
//#region src/domain/view/trackViewEventCounts.ts
function $b2c72421907aac94$export$fcb8a99c2bff4a6b(lifeCycle, viewId, onChange) {
    const { stop: stop, eventCounts: eventCounts } = (0, $0aAbO.trackEventCounts)({
        lifeCycle: lifeCycle,
        isChildEvent: (event)=>event.view.id === viewId,
        onChange: onChange
    });
    return {
        stop: stop,
        eventCounts: eventCounts
    };
}

});

parcelRegister("2KLlK", function(module, exports) {

$parcel$export(module.exports, "trackRouteChangeViewMetrics", function () { return $70ab3dbb565881da$export$dbbab88b95305c56; });

var $4H1Xw = parcelRequire("4H1Xw");

var $iMCYf = parcelRequire("iMCYf");

var $aexs5 = parcelRequire("aexs5");
//#region src/domain/view/viewMetrics/trackRouteChangeViewMetrics.ts
/**
* Tracks LCP for a `route_change` view via Chrome's Soft Navigation API (gated behind
* ExperimentalFeature.SOFT_NAVIGATION + browser support, see trackViews.ts).
*
* Gated behind the experimental flag while validating in production; the plan is to make this
* the default behavior for route_change views once stable, likely in v8.
*
* The soft-navigation entry arrives asynchronously, so `setViewEnd` must unsubscribe from it
* immediately when the view ends -- otherwise an ended view could steal the next view's entry.
* ICP entries keep being tracked until `stop()`, since by then the `interactionId` to filter on
* is already known.
*/ function $70ab3dbb565881da$export$dbbab88b95305c56(configuration, scheduleViewUpdate) {
    const initialViewMetrics = {};
    let softNavEntry;
    let softNavStopped = false;
    let biggestIcpSize = 0;
    const pendingIcpEntries = [];
    const icpSubscription = (0, $4H1Xw.createPerformanceObservable)({
        type: "interaction-contentful-paint",
        buffered: true
    }).subscribe((entries)=>{
        if (!softNavEntry) pendingIcpEntries.push(...entries);
        applyIcpEntries(entries);
    });
    const softNavSubscription = (0, $4H1Xw.createPerformanceObservable)({
        type: "soft-navigation",
        buffered: false
    }).subscribe((entries)=>{
        if (softNavEntry) return;
        softNavEntry = entries[0];
        applyIcpEntries(pendingIcpEntries);
        pendingIcpEntries.length = 0;
        const seededIcp = softNavEntry.getLargestInteractionContentfulPaint();
        if (seededIcp) applyIcpEntries([
            seededIcp
        ]);
    });
    function applyIcpEntries(entries) {
        if (!softNavEntry) return;
        for (const entry of entries){
            if (entry.interactionId !== softNavEntry.interactionId || entry.largestContentfulPaint.size <= biggestIcpSize) continue;
            biggestIcpSize = entry.largestContentfulPaint.size;
            const lcpEntry = entry.largestContentfulPaint;
            const resourceUrl = lcpEntry.url || void 0;
            const largestContentfulPaint = {
                value: lcpEntry.startTime - softNavEntry.startTime,
                targetSelector: lcpEntry.element ? (0, $iMCYf.getSelectorFromElement)(lcpEntry.element, configuration.actionNameAttribute) : void 0,
                resourceUrl: resourceUrl,
                subParts: (0, $aexs5.computeLcpSubParts)(resourceUrl, lcpEntry.startTime, softNavEntry.startTime)
            };
            initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
            scheduleViewUpdate();
        }
    }
    return {
        initialViewMetrics: initialViewMetrics,
        setViewEnd: ()=>{
            softNavStopped = true;
            softNavSubscription.unsubscribe();
            if (!softNavEntry) icpSubscription.unsubscribe();
        },
        stop: ()=>{
            if (!softNavStopped) softNavSubscription.unsubscribe();
            icpSubscription.unsubscribe();
        }
    };
}

});
parcelRegister("aexs5", function(module, exports) {

$parcel$export(module.exports, "trackLargestContentfulPaint", function () { return $42c658018cc28aef$export$e39d61369fabf03f; });
$parcel$export(module.exports, "computeLcpSubParts", function () { return $42c658018cc28aef$export$907ea5348fd79747; });

var $4H1Xw = parcelRequire("4H1Xw");

var $iMCYf = parcelRequire("iMCYf");

var $748DJ = parcelRequire("748DJ");

var $1wrwm = parcelRequire("1wrwm");

var $50cui = parcelRequire("50cui");
var $2faqW = parcelRequire("2faqW");
//#region src/domain/view/viewMetrics/trackLargestContentfulPaint.ts
const $42c658018cc28aef$export$5486837c6e61d9ac = 10 * (0, $1wrwm.ONE_MINUTE);
/**
* Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
* multiple values, only the most recent one should be used.
* Documentation: https://web.dev/lcp/
* Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/onLCP.ts
*/ function $42c658018cc28aef$export$e39d61369fabf03f(configuration, firstHidden, eventTarget, callback) {
    let firstInteractionTimestamp = Infinity;
    const { stop: stopEventListener } = (0, $50cui.addEventListeners)(eventTarget, [
        (0, $50cui.DOM_EVENT).POINTER_DOWN,
        (0, $50cui.DOM_EVENT).KEY_DOWN
    ], (event)=>{
        firstInteractionTimestamp = event.timeStamp;
    }, {
        capture: true,
        once: true
    });
    let biggestLcpSize = 0;
    const performanceLcpSubscription = (0, $4H1Xw.createPerformanceObservable)({
        type: "largest-contentful-paint",
        buffered: true
    }).subscribe((entries)=>{
        const lcpEntry = (0, $2faqW.findLast)(entries, (entry)=>entry.entryType === "largest-contentful-paint" && entry.startTime < firstInteractionTimestamp && entry.startTime < firstHidden.timeStamp && entry.startTime < $42c658018cc28aef$export$5486837c6e61d9ac && entry.size > biggestLcpSize);
        if (lcpEntry) {
            let lcpTargetSelector;
            if (lcpEntry.element) lcpTargetSelector = (0, $iMCYf.getSelectorFromElement)(lcpEntry.element, configuration.actionNameAttribute);
            const resourceUrl = $42c658018cc28aef$var$computeLcpEntryUrl(lcpEntry);
            const lcpValue = lcpEntry.startTime;
            const subParts = $42c658018cc28aef$export$907ea5348fd79747(resourceUrl, lcpValue, (0, $748DJ.sanitizeFirstByte)((0, $748DJ.getNavigationEntry)()));
            callback({
                value: lcpValue,
                targetSelector: lcpTargetSelector,
                resourceUrl: resourceUrl,
                subParts: subParts
            });
            biggestLcpSize = lcpEntry.size;
        }
    });
    return {
        stop: ()=>{
            stopEventListener();
            performanceLcpSubscription.unsubscribe();
        }
    };
}
function $42c658018cc28aef$var$computeLcpEntryUrl(entry) {
    return entry.url === "" ? void 0 : entry.url;
}
/**
* Compute the LCP sub-parts breakdown (loadDelay, loadTime, renderDelay) relative to a baseline.
* For the initial view, the baseline is TTFB (first byte of the navigation response). For a
* soft-navigation route_change view, there's no equivalent request/response round trip, so the
* caller passes the soft-navigation start time instead, effectively treating TTFB as 0.
* Returns undefined if the baseline is unavailable.
*/ function $42c658018cc28aef$export$907ea5348fd79747(resourceUrl, lcpValue, firstByte) {
    if (firstByte === void 0) return;
    const lcpResourceEntry = resourceUrl ? (0, $748DJ.findLcpResourceEntry)(resourceUrl, lcpValue) : void 0;
    const lcpRequestStart = lcpResourceEntry ? Math.max(firstByte, lcpResourceEntry.requestStart || lcpResourceEntry.startTime) : firstByte;
    const lcpResponseEnd = Math.min(lcpValue, Math.max(lcpRequestStart, lcpResourceEntry?.responseEnd || 0));
    return {
        loadDelay: lcpRequestStart - firstByte,
        loadTime: lcpResponseEnd - lcpRequestStart,
        renderDelay: lcpValue - lcpResponseEnd
    };
}

});


parcelRegister("b8Bkb", function(module, exports) {

$parcel$export(module.exports, "trackInitialViewMetrics", function () { return $9bcebaeb8b3f7eb1$export$e0159acaad53a4f8; });

var $aexs5 = parcelRequire("aexs5");

var $3NPtL = parcelRequire("3NPtL");

var $6wTX3 = parcelRequire("6wTX3");

var $uJvcT = parcelRequire("uJvcT");
//#region src/domain/view/viewMetrics/trackInitialViewMetrics.ts
function $9bcebaeb8b3f7eb1$export$e0159acaad53a4f8(configuration, viewStart, setLoadEvent, scheduleViewUpdate) {
    const initialViewMetrics = {};
    const { stop: stopNavigationTracking } = (0, $6wTX3.trackNavigationTimings)((navigationTimings)=>{
        setLoadEvent(navigationTimings.loadEvent);
        initialViewMetrics.navigationTimings = navigationTimings;
        scheduleViewUpdate();
    });
    const firstHidden = (0, $uJvcT.trackFirstHidden)(viewStart);
    const { stop: stopFCPTracking } = (0, $3NPtL.trackFirstContentfulPaint)(firstHidden, (firstContentfulPaint)=>{
        initialViewMetrics.firstContentfulPaint = firstContentfulPaint;
        scheduleViewUpdate();
    });
    const { stop: stopLCPTracking } = (0, $aexs5.trackLargestContentfulPaint)(configuration, firstHidden, window, (largestContentfulPaint)=>{
        initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
        scheduleViewUpdate();
    });
    function stop() {
        stopNavigationTracking();
        stopFCPTracking();
        stopLCPTracking();
        firstHidden.stop();
    }
    return {
        stop: stop,
        initialViewMetrics: initialViewMetrics
    };
}

});
parcelRegister("3NPtL", function(module, exports) {

$parcel$export(module.exports, "trackFirstContentfulPaint", function () { return $bfc829c39b55ea3c$export$a43e15ae3a012adf; });
$parcel$export(module.exports, "trackRestoredFirstContentfulPaint", function () { return $bfc829c39b55ea3c$export$d019b707386eb55c; });

var $4H1Xw = parcelRequire("4H1Xw");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/view/viewMetrics/trackFirstContentfulPaint.ts
const $bfc829c39b55ea3c$export$2f95fa37b4a92d63 = 10 * (0, $1wrwm.ONE_MINUTE);
function $bfc829c39b55ea3c$export$a43e15ae3a012adf(firstHidden, callback) {
    return {
        stop: (0, $4H1Xw.createPerformanceObservable)({
            type: "paint",
            buffered: true
        }).subscribe((entries)=>{
            const fcpEntry = entries.find((entry)=>entry.name === "first-contentful-paint" && entry.startTime < firstHidden.timeStamp && entry.startTime < $bfc829c39b55ea3c$export$2f95fa37b4a92d63);
            if (fcpEntry) callback(fcpEntry.startTime);
        }).unsubscribe
    };
}
/**
* Measure the First Contentful Paint after a BFCache restoration.
* The DOM is restored synchronously, so we approximate the FCP with the first frame
* rendered just after the pageshow event, using two nested requestAnimationFrame calls.
*/ function $bfc829c39b55ea3c$export$d019b707386eb55c(viewStartRelative, callback) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback((0, $1wrwm.elapsed)(viewStartRelative, (0, $1wrwm.relativeNow)()));
        });
    });
}

});

parcelRegister("6wTX3", function(module, exports) {

$parcel$export(module.exports, "trackNavigationTimings", function () { return $452f1a565ccfe614$export$8e38110c52840b40; });

var $748DJ = parcelRequire("748DJ");

var $foX5P = parcelRequire("foX5P");
var $bOZaS = parcelRequire("bOZaS");
var $drxRN = parcelRequire("drxRN");
//#region src/domain/view/viewMetrics/trackNavigationTimings.ts
function $452f1a565ccfe614$export$8e38110c52840b40(callback) {
    return $452f1a565ccfe614$var$waitAfterLoadEvent(()=>{
        const entry = (0, $bOZaS.mockable)((0, $748DJ.getNavigationEntry))();
        if (!$452f1a565ccfe614$var$isIncompleteNavigation(entry)) callback($452f1a565ccfe614$var$processNavigationEntry(entry));
    });
}
function $452f1a565ccfe614$var$processNavigationEntry(entry) {
    return {
        domComplete: entry.domComplete,
        domContentLoaded: entry.domContentLoadedEventEnd,
        domInteractive: entry.domInteractive,
        loadEvent: entry.loadEventEnd,
        firstByte: (0, $748DJ.sanitizeFirstByte)(entry)
    };
}
function $452f1a565ccfe614$var$isIncompleteNavigation(entry) {
    return entry.loadEventEnd <= 0;
}
function $452f1a565ccfe614$var$waitAfterLoadEvent(callback) {
    let timeoutId;
    const { stop: stopOnReadyState } = (0, $drxRN.runOnReadyState)("complete", ()=>{
        timeoutId = (0, $foX5P.setTimeout)(()=>callback());
    });
    return {
        stop: ()=>{
            stopOnReadyState();
            (0, $foX5P.clearTimeout)(timeoutId);
        }
    };
}

});

parcelRegister("uJvcT", function(module, exports) {

$parcel$export(module.exports, "trackFirstHidden", function () { return $8ce302cc5fd3aced$export$42b1d249aa2dee14; });

var $4H1Xw = parcelRequire("4H1Xw");

var $50cui = parcelRequire("50cui");
var $hH6Lc = parcelRequire("hH6Lc");
//#region src/domain/view/viewMetrics/trackFirstHidden.ts
function $8ce302cc5fd3aced$export$42b1d249aa2dee14(viewStart, eventTarget = window) {
    if (document.visibilityState === "hidden") return {
        timeStamp: 0,
        stop: (0, $hH6Lc.noop)
    };
    if ((0, $4H1Xw.supportPerformanceTimingEvent)("visibility-state")) {
        const firstHiddenEntry = performance.getEntriesByType("visibility-state").filter((entry)=>entry.name === "hidden").find((entry)=>entry.startTime >= viewStart.relative);
        if (firstHiddenEntry) return {
            timeStamp: firstHiddenEntry.startTime,
            stop: (0, $hH6Lc.noop)
        };
    }
    let timeStamp = Infinity;
    const { stop: stop } = (0, $50cui.addEventListeners)(eventTarget, [
        (0, $50cui.DOM_EVENT).PAGE_HIDE,
        (0, $50cui.DOM_EVENT).VISIBILITY_CHANGE
    ], (event)=>{
        if (event.type === (0, $50cui.DOM_EVENT).PAGE_HIDE || document.visibilityState === "hidden") {
            timeStamp = event.timeStamp;
            stop();
        }
    }, {
        capture: true
    });
    return {
        get timeStamp () {
            return timeStamp;
        },
        stop: stop
    };
}

});


parcelRegister("2XHS3", function(module, exports) {

$parcel$export(module.exports, "trackCommonViewMetrics", function () { return $8d417cfe437898a2$export$b84f637a03e61a8d; });

var $7yeDI = parcelRequire("7yeDI");

var $cRu7k = parcelRequire("cRu7k");

var $gxAol = parcelRequire("gxAol");

var $eo4bb = parcelRequire("eo4bb");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/view/viewMetrics/trackCommonViewMetrics.ts
function $8d417cfe437898a2$export$b84f637a03e61a8d(lifeCycle, domMutationObservable, windowOpenObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    const commonViewMetrics = {};
    let hasManualLoadingTime = false;
    let viewEnded = false;
    const { stop: stopLoadingTimeTracking, setLoadEvent: setLoadEvent } = (0, $gxAol.trackLoadingTime)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadingType, viewStart, (newLoadingTime)=>{
        if (!hasManualLoadingTime) {
            commonViewMetrics.loadingTime = newLoadingTime;
            scheduleViewUpdate();
        }
    });
    const { stop: stopScrollMetricsTracking } = (0, $eo4bb.trackScrollMetrics)(viewStart, (newScrollMetrics)=>{
        commonViewMetrics.scroll = newScrollMetrics;
    });
    const { stop: stopCLSTracking } = (0, $7yeDI.trackCumulativeLayoutShift)(configuration, viewStart.relative, (cumulativeLayoutShift)=>{
        commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
        scheduleViewUpdate();
    });
    const { stop: stopINPTracking, getInteractionToNextPaint: getInteractionToNextPaint, setViewEnd: setINPViewEnd } = (0, $cRu7k.trackInteractionToNextPaint)(configuration, viewStart.relative, loadingType);
    return {
        stop: ()=>{
            stopLoadingTimeTracking();
            stopCLSTracking();
            stopScrollMetricsTracking();
        },
        stopINPTracking: stopINPTracking,
        setLoadEvent: setLoadEvent,
        setViewEnd: (viewEndTime)=>{
            viewEnded = true;
            setINPViewEnd(viewEndTime);
        },
        getCommonViewMetrics: ()=>{
            commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
            return commonViewMetrics;
        },
        setLoadingTime: (callTimestamp)=>{
            if (viewEnded) return;
            const loadingTime = (0, $1wrwm.elapsed)(viewStart.timeStamp, callTimestamp ?? (0, $1wrwm.timeStampNow)());
            if (!hasManualLoadingTime) stopLoadingTimeTracking();
            hasManualLoadingTime = true;
            commonViewMetrics.loadingTime = loadingTime;
            scheduleViewUpdate();
        }
    };
}

});
parcelRegister("7yeDI", function(module, exports) {

$parcel$export(module.exports, "trackCumulativeLayoutShift", function () { return $df14cb1afc55c27b$export$da6e6ed807ae3512; });

var $8EfFG = parcelRequire("8EfFG");

var $4H1Xw = parcelRequire("4H1Xw");

var $iMCYf = parcelRequire("iMCYf");

var $l4Cel = parcelRequire("l4Cel");

var $1wrwm = parcelRequire("1wrwm");

var $hH6Lc = parcelRequire("hH6Lc");
var $eQWMG = parcelRequire("eQWMG");
//#region src/domain/view/viewMetrics/trackCumulativeLayoutShift.ts
/**
* Track the cumulative layout shifts (CLS).
* Layout shifts are grouped into session windows.
* The minimum gap between session windows is 1 second.
* The maximum duration of a session window is 5 second.
* The session window layout shift value is the sum of layout shifts inside it.
* The CLS value is the max of session windows values.
*
* This yields a new value whenever the CLS value is updated (a higher session window value is computed).
*
* See isLayoutShiftSupported to check for browser support.
*
* Documentation:
* https://web.dev/cls/
* https://web.dev/evolving-cls/
* Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
*/ function $df14cb1afc55c27b$export$da6e6ed807ae3512(configuration, viewStart, callback) {
    if (!$df14cb1afc55c27b$export$fc2cd0a8db29c298()) return {
        stop: (0, $hH6Lc.noop)
    };
    let maxClsValue = 0;
    let biggestShift;
    callback({
        value: 0
    });
    const slidingWindow = $df14cb1afc55c27b$var$slidingSessionWindow();
    const performanceSubscription = (0, $4H1Xw.createPerformanceObservable)({
        type: "layout-shift",
        buffered: true
    }).subscribe((entries)=>{
        for (const entry of entries){
            if (entry.hadRecentInput || entry.startTime < viewStart) continue;
            const { cumulatedValue: cumulatedValue, isMaxValue: isMaxValue } = slidingWindow.update(entry);
            if (isMaxValue) {
                const attribution = $df14cb1afc55c27b$var$getTopImpactedElement(entry.sources);
                biggestShift = {
                    target: attribution?.node ? new WeakRef(attribution.node) : void 0,
                    time: (0, $1wrwm.elapsed)(viewStart, entry.startTime),
                    previousRect: attribution?.previousRect,
                    currentRect: attribution?.currentRect,
                    devicePixelRatio: window.devicePixelRatio
                };
            }
            if (cumulatedValue > maxClsValue) {
                maxClsValue = cumulatedValue;
                const target = biggestShift?.target?.deref();
                callback({
                    value: (0, $eQWMG.round)(maxClsValue, 4),
                    targetSelector: target && (0, $iMCYf.getSelectorFromElement)(target, configuration.actionNameAttribute),
                    time: biggestShift?.time,
                    previousRect: biggestShift?.previousRect ? $df14cb1afc55c27b$var$asRumRect(biggestShift.previousRect) : void 0,
                    currentRect: biggestShift?.currentRect ? $df14cb1afc55c27b$var$asRumRect(biggestShift.currentRect) : void 0,
                    devicePixelRatio: biggestShift?.devicePixelRatio
                });
            }
        }
    });
    return {
        stop: ()=>{
            performanceSubscription.unsubscribe();
        }
    };
}
function $df14cb1afc55c27b$var$getTopImpactedElement(sources) {
    let topImpactedSource;
    for (const source of sources)if (source.node && (0, $8EfFG.isElementNode)(source.node)) {
        const currentImpactedArea = (0, $l4Cel.getClsAttributionImpactedArea)(source);
        if (!topImpactedSource || (0, $l4Cel.getClsAttributionImpactedArea)(topImpactedSource) < currentImpactedArea) topImpactedSource = source;
    }
    return topImpactedSource;
}
function $df14cb1afc55c27b$var$asRumRect({ x: x, y: y, width: width, height: height }) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
const $df14cb1afc55c27b$export$d03c32743ed6c027 = 5 * (0, $1wrwm.ONE_SECOND);
const $df14cb1afc55c27b$var$MAX_UPDATE_GAP = (0, $1wrwm.ONE_SECOND);
function $df14cb1afc55c27b$var$slidingSessionWindow() {
    let cumulatedValue = 0;
    let startTime;
    let endTime;
    let maxValue = 0;
    return {
        update: (entry)=>{
            const shouldCreateNewWindow = startTime === void 0 || entry.startTime - endTime >= $df14cb1afc55c27b$var$MAX_UPDATE_GAP || entry.startTime - startTime >= $df14cb1afc55c27b$export$d03c32743ed6c027;
            let isMaxValue;
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                maxValue = cumulatedValue = entry.value;
                isMaxValue = true;
            } else {
                cumulatedValue += entry.value;
                endTime = entry.startTime;
                isMaxValue = entry.value > maxValue;
                if (isMaxValue) maxValue = entry.value;
            }
            return {
                cumulatedValue: cumulatedValue,
                isMaxValue: isMaxValue
            };
        }
    };
}
/**
* Check whether `layout-shift` is supported by the browser.
*/ function $df14cb1afc55c27b$export$fc2cd0a8db29c298() {
    return (0, $4H1Xw.supportPerformanceTimingEvent)("layout-shift") && "WeakRef" in window;
}

});
parcelRegister("l4Cel", function(module, exports) {

$parcel$export(module.exports, "getClsAttributionImpactedArea", function () { return $db6a00247467a441$export$6fff176b782d9306; });
//#region src/domain/view/viewMetrics/getClsAttributionImpactedArea.ts
/**
* Calculates the area of a rectangle given its width and height
*/ const $db6a00247467a441$var$calculateArea = (width, height)=>width * height;
/**
* Calculates the intersection area between two rectangles
*/ const $db6a00247467a441$var$calculateIntersectionArea = (rect1, rect2)=>{
    const left = Math.max(rect1.left, rect2.left);
    const top = Math.max(rect1.top, rect2.top);
    const right = Math.min(rect1.right, rect2.right);
    const bottom = Math.min(rect1.bottom, rect2.bottom);
    if (left >= right || top >= bottom) return 0;
    return $db6a00247467a441$var$calculateArea(right - left, bottom - top);
};
/**
* Calculates the total impacted area of a layout shift source
* This is the sum of the previous and current areas minus their intersection
*/ const $db6a00247467a441$export$6fff176b782d9306 = (source)=>{
    const previousArea = $db6a00247467a441$var$calculateArea(source.previousRect.width, source.previousRect.height);
    const currentArea = $db6a00247467a441$var$calculateArea(source.currentRect.width, source.currentRect.height);
    const intersectionArea = $db6a00247467a441$var$calculateIntersectionArea(source.previousRect, source.currentRect);
    return previousArea + currentArea - intersectionArea;
};

});


parcelRegister("cRu7k", function(module, exports) {

$parcel$export(module.exports, "trackInteractionToNextPaint", function () { return $9b8f07b760f3c90a$export$21a417d4761d0ac9; });

var $6htpc = parcelRequire("6htpc");

var $8EfFG = parcelRequire("8EfFG");

var $4H1Xw = parcelRequire("4H1Xw");

var $iMCYf = parcelRequire("iMCYf");

var $6DNEb = parcelRequire("6DNEb");

var $gdIrY = parcelRequire("gdIrY");

var $1wrwm = parcelRequire("1wrwm");

var $hH6Lc = parcelRequire("hH6Lc");
//#region src/domain/view/viewMetrics/trackInteractionToNextPaint.ts
const $9b8f07b760f3c90a$var$MAX_INTERACTION_ENTRIES = 10;
const $9b8f07b760f3c90a$export$7cc919a034f18bad = 1 * (0, $1wrwm.ONE_MINUTE);
const $9b8f07b760f3c90a$var$RENDER_TIME_GROUPING_THRESHOLD = 8;
/**
* Track the interaction to next paint (INP).
* To avoid outliers, return the p98 worst interaction of the view.
* Documentation: https://web.dev/inp/
* Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/onINP.ts
*/ function $9b8f07b760f3c90a$export$21a417d4761d0ac9(configuration, viewStart, viewLoadingType) {
    if (!$9b8f07b760f3c90a$export$8abc245381a65a8f()) return {
        getInteractionToNextPaint: ()=>void 0,
        setViewEnd: (0, $hH6Lc.noop),
        stop: (0, $hH6Lc.noop)
    };
    let viewEnd = Infinity;
    let currentInp;
    const { getViewInteractionCount: getViewInteractionCount, stopViewInteractionCount: stopViewInteractionCount } = $9b8f07b760f3c90a$export$cd95581cdbd15637(viewLoadingType);
    const longestInteractions = $9b8f07b760f3c90a$var$trackLongestInteractions(getViewInteractionCount);
    const subPartsTracker = $9b8f07b760f3c90a$var$createSubPartsTracker(longestInteractions);
    const firstInputSubscription = (0, $4H1Xw.createPerformanceObservable)({
        type: "first-input",
        buffered: true
    }).subscribe(handleEntries);
    const eventSubscription = (0, $4H1Xw.createPerformanceObservable)({
        type: "event",
        durationThreshold: 40,
        buffered: true
    }).subscribe(handleEntries);
    function handleEntries(entries) {
        for (const entry of entries)if (entry.interactionId && entry.startTime >= viewStart && entry.startTime <= viewEnd) {
            longestInteractions.process(entry);
            subPartsTracker.process(entry);
        }
        subPartsTracker.pruneUntracked();
        const candidate = longestInteractions.estimateP98Interaction();
        if (candidate) updateCurrentInp(candidate);
    }
    function updateCurrentInp(candidate) {
        const newStartTime = (0, $1wrwm.elapsed)(viewStart, candidate.startTime);
        if (candidate.duration !== currentInp?.duration || newStartTime !== currentInp.startTime) {
            let targetSelector = (0, $6DNEb.getInteractionSelector)(candidate.startTime);
            if (!targetSelector && candidate.target && (0, $8EfFG.isElementNode)(candidate.target)) targetSelector = (0, $iMCYf.getSelectorFromElement)(candidate.target, configuration.actionNameAttribute);
            currentInp = {
                duration: candidate.duration,
                startTime: newStartTime,
                targetSelector: targetSelector
            };
        }
        currentInp.subParts = subPartsTracker.computeSubParts(candidate, $9b8f07b760f3c90a$var$sanitizeInpValue(currentInp.duration));
    }
    return {
        getInteractionToNextPaint: ()=>{
            if (currentInp) return {
                value: $9b8f07b760f3c90a$var$sanitizeInpValue(currentInp.duration),
                targetSelector: currentInp.targetSelector,
                time: currentInp.startTime,
                subParts: currentInp.subParts
            };
            else if (getViewInteractionCount()) return {
                value: 0
            };
        },
        setViewEnd: (viewEndTime)=>{
            viewEnd = viewEndTime;
            stopViewInteractionCount();
        },
        stop: ()=>{
            eventSubscription.unsubscribe();
            firstInputSubscription.unsubscribe();
            subPartsTracker.stop();
        }
    };
}
/**
* Maintains a bounded list of the slowest interactions seen so far, used to estimate the p98
* interaction duration without keeping every entry in memory.
*/ function $9b8f07b760f3c90a$var$trackLongestInteractions(getViewInteractionCount) {
    const longestInteractions = [];
    function sortAndTrimLongestInteractions() {
        longestInteractions.sort((a, b)=>b.duration - a.duration).splice($9b8f07b760f3c90a$var$MAX_INTERACTION_ENTRIES);
    }
    return {
        /**
		* Process the performance entry:
		* - if its duration is long enough, add the performance entry to the list of worst interactions
		* - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
		*/ process (entry) {
            const interactionIndex = longestInteractions.findIndex((interaction)=>entry.interactionId === interaction.interactionId);
            const minLongestInteraction = longestInteractions[longestInteractions.length - 1];
            if (interactionIndex !== -1) {
                if (entry.duration > longestInteractions[interactionIndex].duration) {
                    longestInteractions[interactionIndex] = entry;
                    sortAndTrimLongestInteractions();
                }
            } else if (longestInteractions.length < $9b8f07b760f3c90a$var$MAX_INTERACTION_ENTRIES || entry.duration > minLongestInteraction.duration) {
                longestInteractions.push(entry);
                sortAndTrimLongestInteractions();
            }
        },
        /**
		* Compute the p98 longest interaction.
		* For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
		*/ estimateP98Interaction () {
            const interactionIndex = Math.min(longestInteractions.length - 1, Math.floor(getViewInteractionCount() / 50));
            return longestInteractions[interactionIndex];
        },
        isTracked (interactionId) {
            return longestInteractions.some((i)=>i.interactionId === interactionId);
        }
    };
}
/**
* Tracks the number of interactions that occurred during the current view. Freezes the count
* when the view ends so that the p98 estimate remains stable after `setViewEnd` is called.
*/ function $9b8f07b760f3c90a$export$cd95581cdbd15637(viewLoadingType) {
    (0, $gdIrY.initInteractionCountPolyfill)();
    const previousInteractionCount = viewLoadingType === (0, $6htpc.ViewLoadingType).INITIAL_LOAD ? 0 : (0, $gdIrY.getInteractionCount)();
    let state = {
        stopped: false
    };
    function computeViewInteractionCount() {
        return (0, $gdIrY.getInteractionCount)() - previousInteractionCount;
    }
    return {
        getViewInteractionCount: ()=>{
            if (state.stopped) return state.interactionCount;
            return computeViewInteractionCount();
        },
        stopViewInteractionCount: ()=>{
            state = {
                stopped: true,
                interactionCount: computeViewInteractionCount()
            };
        }
    };
}
/**
* Groups performance entries by interaction and render time to compute INP subparts
* (input delay, processing duration, presentation delay). Entries sharing the same
* interactionId, or whose render time falls within the 8 ms Event Timing rounding window,
* are merged into a single group so that subparts always sum to the reported INP duration.
*/ function $9b8f07b760f3c90a$var$createSubPartsTracker(longestInteractions) {
    const groupsByInteractionId = /* @__PURE__ */ new Map();
    function updateGroupWithEntry(group, entry) {
        group.startTime = Math.min(entry.startTime, group.startTime);
        group.processingStart = Math.min(entry.processingStart, group.processingStart);
        group.processingEnd = Math.max(entry.processingEnd, group.processingEnd);
    }
    return {
        process (entry) {
            if (entry.interactionId === void 0 || !entry.processingStart || !entry.processingEnd) return;
            const renderTime = entry.startTime + entry.duration;
            const existingGroup = groupsByInteractionId.get(entry.interactionId);
            if (existingGroup) {
                updateGroupWithEntry(existingGroup, entry);
                return;
            }
            for (const [, group] of groupsByInteractionId.entries())if (Math.abs(renderTime - group.referenceRenderTime) <= $9b8f07b760f3c90a$var$RENDER_TIME_GROUPING_THRESHOLD) {
                updateGroupWithEntry(group, entry);
                groupsByInteractionId.set(entry.interactionId, group);
                return;
            }
            groupsByInteractionId.set(entry.interactionId, {
                startTime: entry.startTime,
                processingStart: entry.processingStart,
                processingEnd: entry.processingEnd,
                referenceRenderTime: renderTime
            });
        },
        pruneUntracked () {
            for (const [interactionId] of groupsByInteractionId)if (!longestInteractions.isTracked(interactionId)) groupsByInteractionId.delete(interactionId);
        },
        computeSubParts (entry, inpDuration) {
            if (!entry.processingStart || !entry.processingEnd || entry.interactionId === void 0) return;
            const group = groupsByInteractionId.get(entry.interactionId);
            if (!group) return;
            const nextPaintTime = Math.max(group.startTime + inpDuration, group.processingStart);
            const processingEnd = Math.min(group.processingEnd, nextPaintTime);
            return {
                inputDelay: (0, $1wrwm.elapsed)(group.startTime, group.processingStart),
                processingDuration: (0, $1wrwm.elapsed)(group.processingStart, processingEnd),
                presentationDelay: (0, $1wrwm.elapsed)(processingEnd, nextPaintTime)
            };
        },
        stop () {
            groupsByInteractionId.clear();
        }
    };
}
function $9b8f07b760f3c90a$export$8abc245381a65a8f() {
    return (0, $4H1Xw.supportPerformanceTimingEvent)("event") && window.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype;
}
function $9b8f07b760f3c90a$var$sanitizeInpValue(inpValue) {
    return Math.min(inpValue, $9b8f07b760f3c90a$export$7cc919a034f18bad);
}

});
parcelRegister("gdIrY", function(module, exports) {

$parcel$export(module.exports, "initInteractionCountPolyfill", function () { return $f0cf1525a49d1bc4$export$67d90cda6b78a2eb; });
$parcel$export(module.exports, "getInteractionCount", function () { return $f0cf1525a49d1bc4$export$8a962f2683a476d1; });

var $dee0n = parcelRequire("dee0n");
//#region src/domain/view/viewMetrics/interactionCountPolyfill.ts
/**
* performance.interactionCount polyfill
*
* The interactionCount is an integer which counts the total number of distinct user interactions,
* for which there was a unique interactionId.
*
* The interactionCount polyfill is an estimate based on a convention specific to Chrome. Cf: https://github.com/GoogleChrome/web-vitals/pull/213
* This is currently not an issue as the polyfill is only used for INP which is currently only supported on Chrome.
* Hopefully when/if other browsers will support INP, they will also implement performance.interactionCount at the same time, so we won't need that polyfill.
*
* Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
*/ let $f0cf1525a49d1bc4$var$observer;
let $f0cf1525a49d1bc4$var$interactionCountEstimate = 0;
let $f0cf1525a49d1bc4$var$minKnownInteractionId = Infinity;
let $f0cf1525a49d1bc4$var$maxKnownInteractionId = 0;
function $f0cf1525a49d1bc4$export$67d90cda6b78a2eb() {
    if ("interactionCount" in performance || $f0cf1525a49d1bc4$var$observer) return;
    $f0cf1525a49d1bc4$var$observer = new window.PerformanceObserver((0, $dee0n.monitor)((entries)=>{
        entries.getEntries().forEach((e)=>{
            const entry = e;
            if (entry.interactionId) {
                $f0cf1525a49d1bc4$var$minKnownInteractionId = Math.min($f0cf1525a49d1bc4$var$minKnownInteractionId, entry.interactionId);
                $f0cf1525a49d1bc4$var$maxKnownInteractionId = Math.max($f0cf1525a49d1bc4$var$maxKnownInteractionId, entry.interactionId);
                $f0cf1525a49d1bc4$var$interactionCountEstimate = ($f0cf1525a49d1bc4$var$maxKnownInteractionId - $f0cf1525a49d1bc4$var$minKnownInteractionId) / 7 + 1;
            }
        });
    }));
    $f0cf1525a49d1bc4$var$observer.observe({
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
}
/**
* Returns the `interactionCount` value using the native API (if available)
* or the polyfill estimate in this module.
*/ const $f0cf1525a49d1bc4$export$8a962f2683a476d1 = ()=>$f0cf1525a49d1bc4$var$observer ? $f0cf1525a49d1bc4$var$interactionCountEstimate : window.performance.interactionCount || 0;

});


parcelRegister("gxAol", function(module, exports) {

$parcel$export(module.exports, "trackLoadingTime", function () { return $cfb047f303abb5cb$export$58b2b8bfa724cb6f; });

var $6htpc = parcelRequire("6htpc");

var $9DgYZ = parcelRequire("9DgYZ");

var $uJvcT = parcelRequire("uJvcT");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/view/viewMetrics/trackLoadingTime.ts
/**
* For non-initial views (such as route changes or BFCache restores), the regular load event does not fire
* In these cases, trackLoadingTime can only emit a loadingTime  if waitPageActivityEnd detects some post-restore activity.
* If nothing happens after the view starts,no candidate is recorded and loadingTime stays undefined.
*/ function $cfb047f303abb5cb$export$58b2b8bfa724cb6f(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadType, viewStart, callback) {
    let isWaitingForLoadEvent = loadType === (0, $6htpc.ViewLoadingType).INITIAL_LOAD;
    let isWaitingForActivityLoadingTime = true;
    const loadingTimeCandidates = [];
    const firstHidden = (0, $uJvcT.trackFirstHidden)(viewStart);
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            const loadingTime = Math.max(...loadingTimeCandidates);
            if (loadingTime < firstHidden.timeStamp - viewStart.relative) callback(loadingTime);
        }
    }
    const { stop: stop } = (0, $9DgYZ.waitPageActivityEnd)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, (event)=>{
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) loadingTimeCandidates.push((0, $1wrwm.elapsed)(viewStart.timeStamp, event.end));
            invokeCallbackIfAllCandidatesAreReceived();
        }
    });
    return {
        stop: ()=>{
            stop();
            firstHidden.stop();
        },
        setLoadEvent: (loadEvent)=>{
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        }
    };
}

});

parcelRegister("eo4bb", function(module, exports) {

$parcel$export(module.exports, "trackScrollMetrics", function () { return $245692ce73573698$export$eeec767135e98c85; });

var $ktiJ6 = parcelRequire("ktiJ6");

var $fUJs2 = parcelRequire("fUJs2");

var $1wrwm = parcelRequire("1wrwm");

var $50cui = parcelRequire("50cui");
var $fnvkG = parcelRequire("fnvkG");
var $hH6Lc = parcelRequire("hH6Lc");

var $dee0n = parcelRequire("dee0n");
//#region src/domain/view/viewMetrics/trackScrollMetrics.ts
/** Arbitrary scroll throttle duration */ const $245692ce73573698$export$f01db56fd078c3a8 = (0, $1wrwm.ONE_SECOND);
function $245692ce73573698$export$eeec767135e98c85(viewStart, callback, scrollValues = $245692ce73573698$export$68a7c526e4759c01()) {
    let maxScrollDepth = 0;
    let maxScrollHeight = 0;
    let maxScrollHeightTime = 0;
    const subscription = scrollValues.subscribe(({ scrollDepth: scrollDepth, scrollTop: scrollTop, scrollHeight: scrollHeight })=>{
        let shouldUpdate = false;
        if (scrollDepth > maxScrollDepth) {
            maxScrollDepth = scrollDepth;
            shouldUpdate = true;
        }
        if (scrollHeight > maxScrollHeight) {
            maxScrollHeight = scrollHeight;
            const now = (0, $1wrwm.relativeNow)();
            maxScrollHeightTime = (0, $1wrwm.elapsed)(viewStart.relative, now);
            shouldUpdate = true;
        }
        if (shouldUpdate) callback({
            maxDepth: Math.min(maxScrollDepth, maxScrollHeight),
            maxDepthScrollTop: scrollTop,
            maxScrollHeight: maxScrollHeight,
            maxScrollHeightTime: maxScrollHeightTime
        });
    });
    return {
        stop: ()=>subscription.unsubscribe()
    };
}
function $245692ce73573698$export$7819cf13be3ef65c() {
    const scrollTop = (0, $ktiJ6.getScrollY)();
    const { height: height } = (0, $fUJs2.getViewportDimension)();
    return {
        scrollHeight: Math.round((document.scrollingElement || document.documentElement).scrollHeight),
        scrollDepth: Math.round(height + scrollTop),
        scrollTop: scrollTop
    };
}
function $245692ce73573698$export$68a7c526e4759c01(throttleDuration = $245692ce73573698$export$f01db56fd078c3a8) {
    return new (0, $fnvkG.Observable)((observable)=>{
        function notify() {
            observable.notify($245692ce73573698$export$7819cf13be3ef65c());
        }
        const throttledNotify = (0, $hH6Lc.throttle)(notify, throttleDuration, {
            leading: false,
            trailing: true
        });
        const observerTarget = document.scrollingElement || document.documentElement;
        const resizeObserver = new ResizeObserver((0, $dee0n.monitor)(throttledNotify.throttled));
        if (observerTarget) resizeObserver.observe(observerTarget);
        const eventListener = (0, $50cui.addEventListener)(window, (0, $50cui.DOM_EVENT).SCROLL, throttledNotify.throttled, {
            passive: true
        });
        return ()=>{
            throttledNotify.cancel();
            resizeObserver.disconnect();
            eventListener.stop();
        };
    });
}

});


parcelRegister("1JL9a", function(module, exports) {

$parcel$export(module.exports, "onBFCacheRestore", function () { return $a4264d1b5ee2a626$export$8776175fdff4a422; });

var $50cui = parcelRequire("50cui");
//#region src/domain/view/bfCacheSupport.ts
function $a4264d1b5ee2a626$export$8776175fdff4a422(callback) {
    const { stop: stop } = (0, $50cui.addEventListener)(window, (0, $50cui.DOM_EVENT).PAGE_SHOW, (event)=>{
        if (event.persisted) callback(event);
    }, {
        capture: true
    });
    return stop;
}

});

parcelRegister("bkA2Z", function(module, exports) {

$parcel$export(module.exports, "trackBfcacheMetrics", function () { return $707276c4ca619ad5$export$3047835c299420b6; });

var $3NPtL = parcelRequire("3NPtL");
//#region src/domain/view/viewMetrics/trackBfcacheMetrics.ts
/**
* BFCache keeps a full in-memory snapshot of the DOM. When the page is restored, nothing needs to be fetched, so the whole
* viewport repaints in a single frame. Consequently, LCP almost always equals FCP.
* (See: https://github.com/GoogleChrome/web-vitals/pull/87)
*/ function $707276c4ca619ad5$export$3047835c299420b6(viewStart, metrics, scheduleViewUpdate) {
    (0, $3NPtL.trackRestoredFirstContentfulPaint)(viewStart.relative, (paintTime)=>{
        metrics.firstContentfulPaint = paintTime;
        metrics.largestContentfulPaint = {
            value: paintTime
        };
        scheduleViewUpdate();
    });
}

});

parcelRegister("cybD8", function(module, exports) {

$parcel$export(module.exports, "createContextManager", function () { return $bba83507c1bbcf87$export$fe3149b78a43e1ad; });

var $fnvkG = parcelRequire("fnvkG");

var $jq8c3 = parcelRequire("jq8c3");

var $hpOLz = parcelRequire("hpOLz");

var $7ycAs = parcelRequire("7ycAs");

var $5tXxv = parcelRequire("5tXxv");
//#region src/domain/context/contextManager.ts
function $bba83507c1bbcf87$var$ensureProperties(context, propertiesConfig, name) {
    const newContext = {
        ...context
    };
    for (const [key, { required: required, type: type }] of Object.entries(propertiesConfig)){
        /**
		* Ensure specified properties are strings as defined here:
		* https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
		*/ if (type === "string" && !$bba83507c1bbcf87$var$isDefined(newContext[key])) newContext[key] = String(newContext[key]);
        if (required && $bba83507c1bbcf87$var$isDefined(newContext[key])) (0, $jq8c3.display).warn(`The property ${key} of ${name} is required; context will not be sent to the intake.`);
    }
    return newContext;
}
function $bba83507c1bbcf87$var$isDefined(value) {
    return value === void 0 || value === null || value === "";
}
function $bba83507c1bbcf87$export$fe3149b78a43e1ad(name = "", { propertiesConfig: propertiesConfig = {} } = {}) {
    let context = {};
    const changeObservable = new (0, $fnvkG.Observable)();
    const contextManager = {
        getContext: ()=>(0, $5tXxv.deepClone)(context),
        setContext: (newContext)=>{
            if ((0, $7ycAs.checkContext)(newContext)) context = (0, $hpOLz.sanitize)($bba83507c1bbcf87$var$ensureProperties(newContext, propertiesConfig, name));
            else contextManager.clearContext();
            changeObservable.notify();
        },
        setContextProperty: (key, property)=>{
            context = (0, $hpOLz.sanitize)($bba83507c1bbcf87$var$ensureProperties({
                ...context,
                [key]: property
            }, propertiesConfig, name));
            changeObservable.notify();
        },
        removeContextProperty: (key)=>{
            delete context[key];
            $bba83507c1bbcf87$var$ensureProperties(context, propertiesConfig, name);
            changeObservable.notify();
        },
        clearContext: ()=>{
            context = {};
            changeObservable.notify();
        },
        changeObservable: changeObservable
    };
    return contextManager;
}

});
parcelRegister("7ycAs", function(module, exports) {

$parcel$export(module.exports, "checkContext", function () { return $d702a4bb1d4acc4f$export$775b4f8fc598bf34; });

var $jq8c3 = parcelRequire("jq8c3");

var $bF5dI = parcelRequire("bF5dI");
//#region src/domain/context/contextUtils.ts
/**
* Simple check to ensure an object is a valid context
*/ function $d702a4bb1d4acc4f$export$775b4f8fc598bf34(maybeContext) {
    const isValid = (0, $bF5dI.getType)(maybeContext) === "object";
    if (!isValid) (0, $jq8c3.display).error("Unsupported context:", maybeContext);
    return isValid;
}

});



parcelRegister("8nGP1", function(module, exports) {

$parcel$export(module.exports, "getTimeZone", function () { return $68bf7ef97b17cc3b$export$c3133dbc11f66777; });
//#region src/tools/utils/timezone.ts
function $68bf7ef97b17cc3b$export$c3133dbc11f66777() {
    try {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch  {
        return;
    }
}

});


parcelRegister("bUYde", function(module, exports) {

$parcel$export(module.exports, "startRumBatch", function () { return $8aa32ee6e6a01d9c$export$33e6a2986ce7483; });

var $6htpc = parcelRequire("6htpc");
parcelRequire("jNZRV");

var $5HuS4 = parcelRequire("5HuS4");

var $5tXxv = parcelRequire("5tXxv");

var $luYWf = parcelRequire("luYWf");
var $52KhB = parcelRequire("52KhB");
var $jkF2M = parcelRequire("jkF2M");

var $k8VFU = parcelRequire("k8VFU");
function $8aa32ee6e6a01d9c$export$fd4326a859f8c106(current, last) {
    const diff = (0, $5HuS4.diffMerge)(current, last, {
        replaceKeys: /* @__PURE__ */ new Set([
            "view.custom_timings",
            "context",
            "connectivity",
            "usr",
            "device",
            "privacy"
        ]),
        appendKeys: /* @__PURE__ */ new Set([
            "_dd.page_states"
        ]),
        ignoreKeys: /* @__PURE__ */ new Set([
            "date",
            "type",
            "application",
            "session",
            "view.id",
            "view.url",
            "_dd.document_version",
            "_dd.format_version"
        ])
    });
    if (!diff) return;
    return (0, $5tXxv.combine)(diff, {
        type: (0, $6htpc.RumEventType).VIEW_UPDATE,
        date: current.date,
        application: current.application,
        session: current.session,
        view: {
            id: current.view.id,
            url: current.view.url
        },
        _dd: {
            document_version: current._dd.document_version,
            format_version: current._dd.format_version
        }
    });
}
/**
* Dispatches assembled RUM events to the batch. VIEW events are handled specially:
* intermediate updates either replace the full VIEW already in the batch, or are
* aggregated into a single view_update diff against the last flushed state.
*/ function $8aa32ee6e6a01d9c$export$239565b6fc9aecfb(batch, enableViewUpdates) {
    let lastSentView;
    let batchBase;
    let batchHasFullView = false;
    let viewUpdatesSinceCheckpoint = 0;
    const { unsubscribe: unsubscribe } = batch.flushObservable.subscribe(()=>{
        batchHasFullView = false;
        batchBase = lastSentView;
    });
    return {
        dispatch: (serverRumEvent)=>{
            if (serverRumEvent.type !== (0, $6htpc.RumEventType).VIEW) {
                batch.add(serverRumEvent);
                return;
            }
            if (!enableViewUpdates) {
                batch.upsert(serverRumEvent, serverRumEvent.view.id);
                return;
            }
            const viewId = serverRumEvent.view.id;
            if (!serverRumEvent.view.is_active) {
                if (viewId === lastSentView?.view.id) {
                    lastSentView = void 0;
                    batchBase = void 0;
                    batchHasFullView = false;
                    viewUpdatesSinceCheckpoint = 0;
                }
                batch.upsert(serverRumEvent, viewId);
                return;
            }
            if (viewId !== lastSentView?.view.id) {
                viewUpdatesSinceCheckpoint = 0;
                batch.upsert(serverRumEvent, viewId);
                lastSentView = serverRumEvent;
                batchHasFullView = !batch.isEmpty;
                return;
            }
            lastSentView = serverRumEvent;
            if (batchHasFullView) {
                batch.upsert(serverRumEvent, viewId);
                return;
            }
            viewUpdatesSinceCheckpoint += 1;
            if (viewUpdatesSinceCheckpoint >= 100) {
                viewUpdatesSinceCheckpoint = 0;
                batch.upsert(serverRumEvent, viewId);
                batchHasFullView = !batch.isEmpty;
                return;
            }
            if (batchBase) {
                const diff = $8aa32ee6e6a01d9c$export$fd4326a859f8c106(serverRumEvent, batchBase);
                if (diff) {
                    (0, $jkF2M.sendToExtension)("rum", diff);
                    batch.upsert(diff, viewId);
                }
            }
        },
        stop: unsubscribe
    };
}
function $8aa32ee6e6a01d9c$export$33e6a2986ce7483(configuration, lifeCycle, reportError, sessionExpireObservable, createEncoder) {
    const endpoints = [
        (0, $k8VFU.createEndpointBuilder)(configuration, "rum")
    ];
    const replicaEndpoint = (0, $k8VFU.createReplicaEndpointBuilder)(configuration, "rum");
    if (replicaEndpoint) endpoints.push(replicaEndpoint);
    const batch = (0, $luYWf.createBatch)({
        encoder: createEncoder((0, $52KhB.DeflateEncoderStreamId).RUM),
        endpoints: endpoints,
        reportError: reportError
    });
    sessionExpireObservable.subscribe(()=>batch.forceFlush("session_expire"));
    const { dispatch: dispatch, stop: stopDispatcher } = $8aa32ee6e6a01d9c$export$239565b6fc9aecfb(batch, configuration.betaEnableViewUpdates);
    lifeCycle.subscribe(14, dispatch);
    const stopBatch = batch.stop.bind(batch);
    batch.stop = ()=>{
        stopDispatcher();
        stopBatch();
    };
    return batch;
}

});
parcelRegister("5HuS4", function(module, exports) {

$parcel$export(module.exports, "diffMerge", function () { return $280fe2f96ca829d4$export$4b4f77a13af87d5d; });

var $bF5dI = parcelRequire("bF5dI");
//#region src/domain/view/viewDiff.ts
/**
* Compare two values for deep equality
*/ function $280fe2f96ca829d4$export$248d38f6296296c5(a, b) {
    if (a === b) return true;
    if (a === null || typeof a !== "object" || b === null || typeof b !== "object") return a === b;
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false;
        return a.every((val, idx)=>$280fe2f96ca829d4$export$248d38f6296296c5(val, b[idx]));
    }
    if (Array.isArray(a) || Array.isArray(b)) return false;
    const aObj = a;
    const bObj = b;
    const aKeys = Object.keys(aObj);
    const bKeys = Object.keys(bObj);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key)=>bKeys.includes(key) && $280fe2f96ca829d4$export$248d38f6296296c5(aObj[key], bObj[key]));
}
/**
* MERGE strategy: compare two objects and return an object with only changed fields.
* Returns undefined if no changes.
*
* Default strategy is REPLACE (isEqual check). Exceptions:
* - Both values are plain objects and key is not in replaceKeys: recurse (MERGE), sub-paths
* (e.g. 'view.custom_timings') are propagated to the recursive call.
* - Both values are arrays and key is in appendKeys: include only new trailing elements (APPEND)
*/ function $280fe2f96ca829d4$export$4b4f77a13af87d5d(current, lastSent, options) {
    const result = {};
    const replaceKeys = options?.replaceKeys ?? /* @__PURE__ */ new Set();
    const appendKeys = options?.appendKeys ?? /* @__PURE__ */ new Set();
    const ignoreKeys = options?.ignoreKeys ?? /* @__PURE__ */ new Set();
    for (const key of Object.keys(current)){
        if (ignoreKeys.has(key)) continue;
        const currentVal = current[key];
        const lastSentVal = lastSent[key];
        if (!replaceKeys.has(key) && (0, $bF5dI.isIndexableObject)(currentVal) && (0, $bF5dI.isIndexableObject)(lastSentVal)) {
            const nestedDiff = $280fe2f96ca829d4$export$4b4f77a13af87d5d(currentVal, lastSentVal, {
                replaceKeys: $280fe2f96ca829d4$var$extractSubPaths(replaceKeys, key),
                appendKeys: $280fe2f96ca829d4$var$extractSubPaths(appendKeys, key),
                ignoreKeys: $280fe2f96ca829d4$var$extractSubPaths(ignoreKeys, key)
            });
            if (nestedDiff) result[key] = nestedDiff;
        } else if (appendKeys.has(key) && Array.isArray(currentVal) && Array.isArray(lastSentVal)) {
            if (currentVal.length > lastSentVal.length) result[key] = currentVal.slice(lastSentVal.length);
        } else if (!$280fe2f96ca829d4$export$248d38f6296296c5(currentVal, lastSentVal)) result[key] = currentVal;
    }
    for (const key of Object.keys(lastSent))if (!(key in current)) result[key] = null;
    return Object.keys(result).length > 0 ? result : void 0;
}
function $280fe2f96ca829d4$var$extractSubPaths(keys, prefix) {
    const result = /* @__PURE__ */ new Set();
    for (const key of keys)if (key.startsWith(`${prefix}.`)) result.add(key.slice(prefix.length + 1));
    return result;
}

});

parcelRegister("52KhB", function(module, exports) {

$parcel$export(module.exports, "DeflateEncoderStreamId", function () { return $518fa59cc1f5e4ee$export$172993b69353bcbf; });
//#region src/domain/deflate/deflate.types.ts
let $518fa59cc1f5e4ee$export$172993b69353bcbf = /* @__PURE__ */ function(DeflateEncoderStreamId) {
    DeflateEncoderStreamId[DeflateEncoderStreamId["REPLAY"] = 1] = "REPLAY";
    DeflateEncoderStreamId[DeflateEncoderStreamId["RUM"] = 2] = "RUM";
    DeflateEncoderStreamId[DeflateEncoderStreamId["TELEMETRY"] = 4] = "TELEMETRY";
    DeflateEncoderStreamId[DeflateEncoderStreamId["PROFILING"] = 6] = "PROFILING";
    return DeflateEncoderStreamId;
}({});

});


parcelRegister("kcZgo", function(module, exports) {

$parcel$export(module.exports, "startRumEventBridge", function () { return $e6f6c56869cfb94b$export$38cafc1b8954ea9d; });
parcelRequire("jNZRV");

var $gS0nt = parcelRequire("gS0nt");
//#region src/transport/startRumEventBridge.ts
function $e6f6c56869cfb94b$export$38cafc1b8954ea9d(lifeCycle) {
    const bridge = (0, $gS0nt.getEventBridge)();
    lifeCycle.subscribe(14, (serverRumEvent)=>{
        bridge.send("rum", serverRumEvent);
    });
}

});

parcelRegister("41DCp", function(module, exports) {

$parcel$export(module.exports, "startUrlContexts", function () { return $0bd8c50f389131fd$export$a9a4d4dde99a99fd; });
parcelRequire("jNZRV");

var $1wrwm = parcelRequire("1wrwm");

var $kRkcp = parcelRequire("kRkcp");
var $c2Qhr = parcelRequire("c2Qhr");

var $boqsR = parcelRequire("boqsR");
var $bOZaS = parcelRequire("bOZaS");
var $aWbFv = parcelRequire("aWbFv");

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/contexts/urlContexts.ts
/**
* We want to attach to an event:
* - the url corresponding to its start
* - the referrer corresponding to the previous view url (or document referrer for initial view)
*/ const $0bd8c50f389131fd$export$e5d2b82a8e642e14 = (0, $aWbFv.SESSION_TIME_OUT_DELAY);
function $0bd8c50f389131fd$export$a9a4d4dde99a99fd(lifeCycle, assembleHook, locationChangeObservable) {
    const urlContextHistory = (0, $boqsR.createValueHistory)({
        expireDelay: $0bd8c50f389131fd$export$e5d2b82a8e642e14
    });
    let previousViewUrl;
    lifeCycle.subscribe(1, ({ startClocks: startClocks, url: url })=>{
        const locationHref = (0, $bOZaS.mockable)((0, $c2Qhr.globalObject).location).href;
        const viewUrl = url !== void 0 ? (0, $kRkcp.buildUrl)(url, locationHref).href : locationHref;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    lifeCycle.subscribe(6, ({ endClocks: endClocks })=>{
        urlContextHistory.closeActive(endClocks.relative);
    });
    const locationChangeSubscription = locationChangeObservable.subscribe(({ newLocation: newLocation })=>{
        const current = urlContextHistory.find();
        if (current) {
            const changeTime = (0, $1wrwm.relativeNow)();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.referrer
            }), changeTime);
        }
    });
    function buildUrlContext({ url: url, referrer: referrer }) {
        return {
            url: url,
            referrer: referrer
        };
    }
    assembleHook.register(({ startTime: startTime, eventType: eventType })=>{
        const urlContext = urlContextHistory.find(startTime);
        if (!urlContext) return 0, $fNtjE.DISCARDED;
        return {
            type: eventType,
            view: {
                url: urlContext.url,
                referrer: urlContext.referrer
            }
        };
    });
    return {
        findUrl: (startTime)=>urlContextHistory.find(startTime),
        stop: ()=>{
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        }
    };
}

});

parcelRegister("gAVHv", function(module, exports) {

$parcel$export(module.exports, "createLocationChangeObservable", function () { return $d8b48b7ac46812b5$export$c2da1b41b3b918ce; });

var $c2Qhr = parcelRequire("c2Qhr");

var $50cui = parcelRequire("50cui");
var $74beb = parcelRequire("74beb");
var $bOZaS = parcelRequire("bOZaS");
var $fnvkG = parcelRequire("fnvkG");
var $brKlt = parcelRequire("brKlt");
//#region src/browser/locationChangeObservable.ts
function $d8b48b7ac46812b5$export$c2da1b41b3b918ce() {
    let currentLocation = (0, $brKlt.shallowClone)($d8b48b7ac46812b5$var$getLocation());
    return new (0, $fnvkG.Observable)((observable)=>{
        const { stop: stopHistoryTracking } = $d8b48b7ac46812b5$var$trackHistory(onLocationChange);
        const { stop: stopHashTracking } = $d8b48b7ac46812b5$var$trackHash(onLocationChange);
        function onLocationChange() {
            if (currentLocation.href === $d8b48b7ac46812b5$var$getLocation().href) return;
            const newLocation = (0, $brKlt.shallowClone)($d8b48b7ac46812b5$var$getLocation());
            observable.notify({
                newLocation: newLocation,
                oldLocation: currentLocation
            });
            currentLocation = newLocation;
        }
        return ()=>{
            stopHistoryTracking();
            stopHashTracking();
        };
    });
}
function $d8b48b7ac46812b5$var$getLocation() {
    return (0, $bOZaS.mockable)((0, $c2Qhr.globalObject).location);
}
function $d8b48b7ac46812b5$var$trackHistory(onHistoryChange) {
    const { stop: stopInstrumentingPushState } = (0, $74beb.instrumentMethod)($d8b48b7ac46812b5$var$getHistoryInstrumentationTarget("pushState"), "pushState", ({ onPostCall: onPostCall })=>{
        onPostCall(onHistoryChange);
    });
    const { stop: stopInstrumentingReplaceState } = (0, $74beb.instrumentMethod)($d8b48b7ac46812b5$var$getHistoryInstrumentationTarget("replaceState"), "replaceState", ({ onPostCall: onPostCall })=>{
        onPostCall(onHistoryChange);
    });
    const { stop: removeListener } = (0, $50cui.addEventListener)(window, (0, $50cui.DOM_EVENT).POP_STATE, onHistoryChange);
    return {
        stop: ()=>{
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        }
    };
}
function $d8b48b7ac46812b5$var$trackHash(onHashChange) {
    return (0, $50cui.addEventListener)(window, (0, $50cui.DOM_EVENT).HASH_CHANGE, onHashChange);
}
function $d8b48b7ac46812b5$var$getHistoryInstrumentationTarget(methodName) {
    return Object.prototype.hasOwnProperty.call(history, methodName) ? history : History.prototype;
}

});

parcelRegister("8ceHp", function(module, exports) {

$parcel$export(module.exports, "startFeatureFlagContexts", function () { return $0ba808fb1ad6eb81$export$9125b974ef9cfd53; });

var $6htpc = parcelRequire("6htpc");
parcelRequire("jNZRV");

var $boqsR = parcelRequire("boqsR");
var $brKlt = parcelRequire("brKlt");
var $aWbFv = parcelRequire("aWbFv");

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/contexts/featureFlagContext.ts
const $0ba808fb1ad6eb81$export$205c45090af638e0 = (0, $aWbFv.SESSION_TIME_OUT_DELAY);
/**
* Start feature flag contexts
*
* Feature flag contexts follow the life of views.
* A new context is added when a view is created and ended when the view is ended
*
* Note: we choose not to add a new context at each evaluation to save memory
*/ function $0ba808fb1ad6eb81$export$9125b974ef9cfd53(lifeCycle, assembleHook, configuration) {
    const featureFlagContexts = (0, $boqsR.createValueHistory)({
        expireDelay: $0ba808fb1ad6eb81$export$205c45090af638e0
    });
    lifeCycle.subscribe(1, ({ startClocks: startClocks })=>{
        featureFlagContexts.add({}, startClocks.relative);
    });
    lifeCycle.subscribe(6, ({ endClocks: endClocks })=>{
        featureFlagContexts.closeActive(endClocks.relative);
    });
    assembleHook.register(({ startTime: startTime, eventType: eventType })=>{
        if (!configuration.trackFeatureFlagsForEvents.concat([
            (0, $6htpc.RumEventType).VIEW,
            (0, $6htpc.RumEventType).ERROR
        ]).includes(eventType)) return 0, $fNtjE.SKIPPED;
        const featureFlagContext = featureFlagContexts.find(startTime);
        if (!featureFlagContext || (0, $brKlt.isEmptyObject)(featureFlagContext)) return 0, $fNtjE.SKIPPED;
        return {
            type: eventType,
            feature_flags: featureFlagContext
        };
    });
    return {
        addFeatureFlagEvaluation: (key, value)=>{
            const currentContext = featureFlagContexts.find();
            if (currentContext) currentContext[key] = value;
        }
    };
}

});

parcelRegister("92olM", function(module, exports) {

$parcel$export(module.exports, "startCustomerDataTelemetry", function () { return $255ea07fc16e5bee$export$7cc15698fd3ea8d2; });
parcelRequire("jNZRV");

var $1wrwm = parcelRequire("1wrwm");

var $461Vl = parcelRequire("461Vl");
var $foX5P = parcelRequire("foX5P");
//#region src/domain/startCustomerDataTelemetry.ts
const $255ea07fc16e5bee$export$e9b7b62aafe04389 = 10 * (0, $1wrwm.ONE_SECOND);
let $255ea07fc16e5bee$var$currentPeriodMeasures;
let $255ea07fc16e5bee$var$batchHasRumEvent;
function $255ea07fc16e5bee$export$7cc15698fd3ea8d2(telemetry, lifeCycle, batchFlushObservable) {
    if (!telemetry.metricsEnabled) return;
    $255ea07fc16e5bee$var$initCurrentPeriodMeasures();
    $255ea07fc16e5bee$var$batchHasRumEvent = false;
    lifeCycle.subscribe(14, ()=>{
        $255ea07fc16e5bee$var$batchHasRumEvent = true;
    });
    batchFlushObservable.subscribe(({ bytesCount: bytesCount, messagesCount: messagesCount })=>{
        if (!$255ea07fc16e5bee$var$batchHasRumEvent) return;
        $255ea07fc16e5bee$var$batchHasRumEvent = false;
        $255ea07fc16e5bee$var$currentPeriodMeasures.batchCount += 1;
        $255ea07fc16e5bee$var$updateMeasure($255ea07fc16e5bee$var$currentPeriodMeasures.batchBytesCount, bytesCount);
        $255ea07fc16e5bee$var$updateMeasure($255ea07fc16e5bee$var$currentPeriodMeasures.batchMessagesCount, messagesCount);
    });
    (0, $foX5P.setInterval)($255ea07fc16e5bee$var$sendCurrentPeriodMeasures, $255ea07fc16e5bee$export$e9b7b62aafe04389);
}
function $255ea07fc16e5bee$var$sendCurrentPeriodMeasures() {
    if ($255ea07fc16e5bee$var$currentPeriodMeasures.batchCount === 0) return;
    (0, $461Vl.addTelemetryMetrics)((0, $461Vl.TelemetryMetrics).CUSTOMER_DATA_METRIC_NAME, $255ea07fc16e5bee$var$currentPeriodMeasures);
    $255ea07fc16e5bee$var$initCurrentPeriodMeasures();
}
function $255ea07fc16e5bee$var$createMeasure() {
    return {
        min: Infinity,
        max: 0,
        sum: 0
    };
}
function $255ea07fc16e5bee$var$updateMeasure(measure, value) {
    measure.sum += value;
    measure.min = Math.min(measure.min, value);
    measure.max = Math.max(measure.max, value);
}
function $255ea07fc16e5bee$var$initCurrentPeriodMeasures() {
    $255ea07fc16e5bee$var$currentPeriodMeasures = {
        batchCount: 0,
        batchBytesCount: $255ea07fc16e5bee$var$createMeasure(),
        batchMessagesCount: $255ea07fc16e5bee$var$createMeasure()
    };
}

});

parcelRegister("drAqL", function(module, exports) {

$parcel$export(module.exports, "startPageStateHistory", function () { return $aecc79add3396db5$export$7f01c272948a14b1; });

var $6htpc = parcelRequire("6htpc");

var $4H1Xw = parcelRequire("4H1Xw");

var $1wrwm = parcelRequire("1wrwm");

var $50cui = parcelRequire("50cui");
var $boqsR = parcelRequire("boqsR");
var $aWbFv = parcelRequire("aWbFv");

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/contexts/pageStateHistory.ts
const $aecc79add3396db5$export$491f01a0e9b8b208 = 4e3;
const $aecc79add3396db5$export$20f880bb2b8d10f6 = (0, $aWbFv.SESSION_TIME_OUT_DELAY);
function $aecc79add3396db5$export$7f01c272948a14b1(assembleHook, maxPageStateEntriesSelectable = 500) {
    const pageStateEntryHistory = (0, $boqsR.createValueHistory)({
        expireDelay: $aecc79add3396db5$export$20f880bb2b8d10f6,
        maxEntries: $aecc79add3396db5$export$491f01a0e9b8b208
    });
    let currentPageState;
    if ((0, $4H1Xw.supportPerformanceTimingEvent)("visibility-state")) performance.getEntriesByType("visibility-state").forEach((entry)=>{
        addPageState(entry.name === "hidden" ? "hidden" : "active", entry.startTime);
    });
    addPageState($aecc79add3396db5$var$getPageState(), (0, $1wrwm.relativeNow)());
    const { stop: stopEventListeners } = (0, $50cui.addEventListeners)(window, [
        (0, $50cui.DOM_EVENT).PAGE_SHOW,
        (0, $50cui.DOM_EVENT).FOCUS,
        (0, $50cui.DOM_EVENT).BLUR,
        (0, $50cui.DOM_EVENT).VISIBILITY_CHANGE,
        (0, $50cui.DOM_EVENT).RESUME,
        (0, $50cui.DOM_EVENT).FREEZE,
        (0, $50cui.DOM_EVENT).PAGE_HIDE
    ], (event)=>{
        addPageState($aecc79add3396db5$var$computePageState(event), event.timeStamp);
    }, {
        capture: true
    });
    function addPageState(nextPageState, startTime = (0, $1wrwm.relativeNow)()) {
        if (nextPageState === currentPageState) return;
        currentPageState = nextPageState;
        pageStateEntryHistory.closeActive(startTime);
        pageStateEntryHistory.add({
            state: currentPageState,
            startTime: startTime
        }, startTime);
    }
    function wasInPageStateDuringPeriod(state, startTime, duration) {
        return pageStateEntryHistory.findAll(startTime, duration).some((pageState)=>pageState.state === state);
    }
    assembleHook.register(({ startTime: startTime, duration: duration = 0, eventType: eventType })=>{
        if (eventType === (0, $6htpc.RumEventType).VIEW) return {
            type: eventType,
            _dd: {
                page_states: $aecc79add3396db5$var$processPageStates(pageStateEntryHistory.findAll(startTime, duration), startTime, maxPageStateEntriesSelectable)
            }
        };
        if (eventType === (0, $6htpc.RumEventType).ACTION || eventType === (0, $6htpc.RumEventType).ERROR) return {
            type: eventType,
            view: {
                in_foreground: wasInPageStateDuringPeriod("active", startTime, 0)
            }
        };
        return 0, $fNtjE.SKIPPED;
    });
    return {
        wasInPageStateDuringPeriod: wasInPageStateDuringPeriod,
        addPageState: addPageState,
        stop: ()=>{
            stopEventListeners();
            pageStateEntryHistory.stop();
        }
    };
}
function $aecc79add3396db5$var$processPageStates(pageStateEntries, eventStartTime, maxPageStateEntriesSelectable) {
    if (pageStateEntries.length === 0) return;
    return pageStateEntries.slice(-maxPageStateEntriesSelectable).reverse().map(({ state: state, startTime: startTime })=>({
            state: state,
            start: (0, $1wrwm.toServerDuration)((0, $1wrwm.elapsed)(eventStartTime, startTime))
        }));
}
function $aecc79add3396db5$var$computePageState(event) {
    if (event.type === (0, $50cui.DOM_EVENT).FREEZE) return "frozen";
    else if (event.type === (0, $50cui.DOM_EVENT).PAGE_HIDE) return event.persisted ? "frozen" : "terminated";
    return $aecc79add3396db5$var$getPageState();
}
function $aecc79add3396db5$var$getPageState() {
    if (document.visibilityState === "hidden") return "hidden";
    if (document.hasFocus()) return "active";
    return "passive";
}

});

parcelRegister("jvgPw", function(module, exports) {

$parcel$export(module.exports, "startDisplayContext", function () { return $4fa2da23fac51029$export$9b255c0d165a033f; });

var $fUJs2 = parcelRequire("fUJs2");

var $dee0n = parcelRequire("dee0n");
//#region src/domain/contexts/displayContext.ts
function $4fa2da23fac51029$export$9b255c0d165a033f(assembleHook) {
    let viewport;
    const animationFrameId = requestAnimationFrame((0, $dee0n.monitor)(()=>{
        viewport = (0, $fUJs2.getViewportDimension)();
    }));
    const unsubscribeViewport = (0, $fUJs2.initViewportObservable)().subscribe((viewportDimension)=>{
        viewport = viewportDimension;
    }).unsubscribe;
    assembleHook.register(({ eventType: eventType })=>({
            type: eventType,
            display: viewport ? {
                viewport: viewport
            } : void 0
        }));
    return {
        stop: ()=>{
            unsubscribeViewport();
            if (animationFrameId) cancelAnimationFrame(animationFrameId);
        }
    };
}

});

parcelRegister("2ifT4", function(module, exports) {

$parcel$export(module.exports, "startVitalCollection", function () { return $9b16d81b80933563$export$1f5a51a997c60d35; });

var $6htpc = parcelRequire("6htpc");
parcelRequire("jNZRV");

var $kPF4T = parcelRequire("kPF4T");
parcelRequire("drAqL");

var $1wrwm = parcelRequire("1wrwm");

var $bWkrj = parcelRequire("bWkrj");
var $hpOLz = parcelRequire("hpOLz");
//#region src/domain/vital/vitalCollection.ts
function $9b16d81b80933563$export$1f5a51a997c60d35(lifeCycle, pageStateHistory) {
    const vitalTracker = (0, $kPF4T.startEventTracker)(lifeCycle);
    function isValid(vital) {
        return !pageStateHistory.wasInPageStateDuringPeriod("frozen", vital.startClocks.relative, vital.duration);
    }
    function addDurationVital(vital) {
        if (isValid(vital)) lifeCycle.notify(13, $9b16d81b80933563$var$processVital(vital));
    }
    function addOperationStepVital(name, stepType, options, failureReason) {
        const { operationKey: operationKey, context: context, description: description, handlingStack: handlingStack } = options || {};
        const vital = {
            name: name,
            type: (0, $6htpc.VitalType).OPERATION_STEP,
            operationKey: operationKey,
            failureReason: failureReason,
            stepType: stepType,
            startClocks: (0, $1wrwm.clocksNow)(),
            context: (0, $hpOLz.sanitize)(context),
            description: description,
            handlingStack: handlingStack
        };
        lifeCycle.notify(13, $9b16d81b80933563$var$processVital(vital));
    }
    function startDurationVital(name, options = {}, startClocks = (0, $1wrwm.clocksNow)()) {
        const { id: id } = vitalTracker.start(options.vitalKey ?? name, startClocks, {
            name: name,
            ...options
        });
        lifeCycle.notify(17, {
            id: id,
            name: name,
            startClocks: startClocks,
            ...options
        });
    }
    function stopDurationVital(name, options = {}, stopClocks = (0, $1wrwm.clocksNow)()) {
        const stopped = vitalTracker.stop(options.vitalKey ?? name, stopClocks, options);
        if (stopped) addDurationVital({
            type: (0, $6htpc.VitalType).DURATION,
            ...stopped
        });
    }
    return {
        addOperationStepVital: addOperationStepVital,
        addDurationVital: addDurationVital,
        startDurationVital: startDurationVital,
        stopDurationVital: stopDurationVital
    };
}
function $9b16d81b80933563$var$processVital(vital) {
    const { startClocks: startClocks, type: type, name: name, description: description, context: context, handlingStack: handlingStack } = vital;
    const vitalData = {
        id: (vital.type === (0, $6htpc.VitalType).DURATION ? vital.id : void 0) ?? (0, $bWkrj.generateUUID)(),
        type: type,
        name: name,
        description: description,
        ...type === (0, $6htpc.VitalType).DURATION ? {
            duration: (0, $1wrwm.toServerDuration)(vital.duration)
        } : {
            step_type: vital.stepType,
            operation_key: vital.operationKey,
            failure_reason: vital.failureReason
        }
    };
    return {
        rawRumEvent: {
            date: startClocks.timeStamp,
            vital: vitalData,
            type: (0, $6htpc.RumEventType).VITAL,
            context: context
        },
        startClocks: startClocks,
        duration: type === (0, $6htpc.VitalType).DURATION ? vital.duration : void 0,
        domainContext: handlingStack ? {
            handlingStack: handlingStack
        } : {}
    };
}

});

parcelRegister("5GkPj", function(module, exports) {

$parcel$export(module.exports, "startSessionContext", function () { return $c8c7aa934b36028f$export$930c4ba5de05acaa; });

var $6htpc = parcelRequire("6htpc");

var $jIq9O = parcelRequire("jIq9O");

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/contexts/sessionContext.ts
function $c8c7aa934b36028f$export$930c4ba5de05acaa(assembleHook, configuration, sessionManager, recorderApi, viewHistory) {
    assembleHook.register(({ eventType: eventType, startTime: startTime })=>{
        const session = sessionManager.findTrackedSession(startTime);
        const view = viewHistory.findView(startTime);
        if (!session || !view) return 0, $fNtjE.DISCARDED;
        let hasReplay;
        let sampledForReplay;
        let isActive;
        if (eventType === (0, $6htpc.RumEventType).VIEW) {
            hasReplay = recorderApi.getReplayStats(view.id) ? true : void 0;
            sampledForReplay = (0, $jIq9O.computeSessionReplayState)(session, configuration) === 1;
            isActive = view.sessionIsActive ? void 0 : false;
        } else hasReplay = recorderApi.isRecording() ? true : void 0;
        return {
            type: eventType,
            session: {
                id: session.id,
                type: "user",
                has_replay: hasReplay,
                sampled_for_replay: sampledForReplay,
                is_active: isActive
            }
        };
    });
}

});

parcelRegister("1sqPO", function(module, exports) {

$parcel$export(module.exports, "startCiVisibilityContext", function () { return $bd921cb7700330ed$export$121aef6278f2cce8; });

var $jlRsC = parcelRequire("jlRsC");
parcelRequire("5GkPj");

var $jq8c3 = parcelRequire("jq8c3");
var $aZWin = parcelRequire("aZWin");

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/contexts/ciVisibilityContext.ts
const $bd921cb7700330ed$export$f848217ffff2b290 = "datadog-ci-visibility-test-execution-id";
function $bd921cb7700330ed$export$121aef6278f2cce8(assembleHook, cookieObservable = (0, $jlRsC.createCookieObservable)($bd921cb7700330ed$export$f848217ffff2b290)) {
    let testExecutionId = (0, $aZWin.getInitCookie)("datadog-ci-visibility-test-execution-id") || $bd921cb7700330ed$var$readCypressTraceId();
    const cookieObservableSubscription = cookieObservable.subscribe((value)=>{
        testExecutionId = value;
    });
    assembleHook.register(({ eventType: eventType })=>{
        if (typeof testExecutionId !== "string") return 0, $fNtjE.SKIPPED;
        return {
            type: eventType,
            session: {
                type: "ci_test"
            },
            ci_test: {
                test_execution_id: testExecutionId
            }
        };
    });
    return {
        stop: ()=>{
            cookieObservableSubscription.unsubscribe();
        }
    };
}
function $bd921cb7700330ed$var$readCypressTraceId() {
    const cypress = window.Cypress;
    if (!cypress) return;
    try {
        return cypress.env("traceId");
    } catch  {
        (0, $jq8c3.display).warn("Failed to read Cypress test execution id via Cypress.env(). Upgrade dd-trace-js to >= 5.88.0 to keep RUM \u2194 test correlation working.");
        return;
    }
}

});
parcelRegister("jlRsC", function(module, exports) {

$parcel$export(module.exports, "createCookieObservable", function () { return $19027779e1d909a2$export$346054de39969c66; });

var $1wrwm = parcelRequire("1wrwm");

var $c2Qhr = parcelRequire("c2Qhr");

var $50cui = parcelRequire("50cui");
var $foX5P = parcelRequire("foX5P");
var $aZWin = parcelRequire("aZWin");
var $frs82 = parcelRequire("frs82");
var $fnvkG = parcelRequire("fnvkG");
//#region src/browser/cookieObservable.ts
function $19027779e1d909a2$export$346054de39969c66(cookieName) {
    const detectCookieChangeStrategy = (0, $frs82.isCookieStoreSupported)() ? $19027779e1d909a2$var$listenToCookieStoreChange() : $19027779e1d909a2$var$watchCookieFallback;
    return new (0, $fnvkG.Observable)((observable)=>detectCookieChangeStrategy(cookieName, (event)=>observable.notify(event)));
}
function $19027779e1d909a2$var$listenToCookieStoreChange() {
    return (cookieName, callback)=>{
        return (0, $50cui.addEventListener)((0, $c2Qhr.globalObject).cookieStore, (0, $50cui.DOM_EVENT).CHANGE, (event)=>{
            const changeEvent = event.changed.find((event)=>event.name === cookieName) || event.deleted.find((event)=>event.name === cookieName);
            if (changeEvent) callback(changeEvent.value);
        }).stop;
    };
}
const $19027779e1d909a2$export$541bea9a14448c32 = (0, $1wrwm.ONE_SECOND);
function $19027779e1d909a2$var$watchCookieFallback(cookieName, callback) {
    let previousCookieValue = (0, $aZWin.getCookie)(cookieName);
    const watchCookieIntervalId = (0, $foX5P.setInterval)(()=>{
        const cookieValue = (0, $aZWin.getCookie)(cookieName);
        if (cookieValue !== previousCookieValue) {
            previousCookieValue = cookieValue;
            callback(cookieValue);
        }
    }, $19027779e1d909a2$export$541bea9a14448c32);
    return ()=>{
        (0, $foX5P.clearInterval)(watchCookieIntervalId);
    };
}

});
parcelRegister("frs82", function(module, exports) {

$parcel$export(module.exports, "areCookiesAuthorized", function () { return $6d75b31ed2f39f2c$export$29b13dee24cadcda; });
$parcel$export(module.exports, "createCookieStoreAccess", function () { return $6d75b31ed2f39f2c$export$24405899271110c1; });
$parcel$export(module.exports, "createDocumentCookieAccess", function () { return $6d75b31ed2f39f2c$export$3c3dae9bbbf29ee9; });
$parcel$export(module.exports, "isCookieStoreSupported", function () { return $6d75b31ed2f39f2c$export$838fa1e3c9088d2b; });

var $fnvkG = parcelRequire("fnvkG");

var $bWkrj = parcelRequire("bWkrj");

var $aZWin = parcelRequire("aZWin");

var $jq8c3 = parcelRequire("jq8c3");

var $bOZaS = parcelRequire("bOZaS");

var $foX5P = parcelRequire("foX5P");

var $50cui = parcelRequire("50cui");

var $461Vl = parcelRequire("461Vl");

var $c2Qhr = parcelRequire("c2Qhr");

var $1wrwm = parcelRequire("1wrwm");
//#region src/browser/cookieAccess.ts
const $6d75b31ed2f39f2c$export$6fe540baa85aedcb = "dd_cookie_test_";
async function $6d75b31ed2f39f2c$export$29b13dee24cadcda(createAccess, cookieOptions) {
    const testCookieName = `${$6d75b31ed2f39f2c$export$6fe540baa85aedcb}${(0, $bWkrj.generateUUID)()}`;
    const testCookieValue = "test";
    const access = createAccess(testCookieName, cookieOptions);
    try {
        await access.getAllAndSet(()=>({
                value: testCookieValue,
                expireDelay: (0, $1wrwm.ONE_MINUTE)
            }));
        return (await access.getAll()).includes(testCookieValue);
    } catch (error) {
        (0, $jq8c3.display).error(error);
        return false;
    } finally{
        try {
            await access.delete();
        } catch  {}
    }
}
function $6d75b31ed2f39f2c$export$24405899271110c1(cookieName, cookieOptions) {
    const cookieStore = (0, $bOZaS.mockable)((0, $c2Qhr.globalObject).cookieStore);
    const observable = new (0, $fnvkG.Observable)(()=>{
        return (0, $50cui.addEventListener)(cookieStore, "change", (event)=>{
            if (event.changed.some((event)=>event.name === cookieName) || event.deleted.some((event)=>event.name === cookieName)) observable.notify();
        }).stop;
    });
    return {
        async getAll () {
            return (await cookieStore.getAll(cookieName)).map((item)=>item.value);
        },
        delete () {
            return cookieStore.delete({
                name: cookieName,
                domain: cookieOptions.domain,
                path: "/",
                partitioned: cookieOptions.partitioned
            });
        },
        async getAllAndSet (cb) {
            const items = await cookieStore.getAll(cookieName);
            const { value: value, expireDelay: expireDelay } = cb(items.map((item)=>item.value));
            try {
                await cookieStore.set({
                    name: cookieName,
                    value: value,
                    expires: (0, $1wrwm.dateNow)() + expireDelay,
                    path: "/",
                    sameSite: cookieOptions.crossSite ? "none" : "strict",
                    domain: cookieOptions.domain,
                    secure: cookieOptions.secure,
                    partitioned: cookieOptions.partitioned
                });
            } catch (error) {
                if (!cookieName.startsWith("dd_cookie_test_")) {
                    const documentCookies = (0, $aZWin.getCookies)(cookieName);
                    (0, $461Vl.addTelemetryDebug)("Failed to set cookie using Cookie Store API", {
                        "error.message": error.message,
                        newValue: value,
                        cookieOptions: {
                            ...cookieOptions
                        },
                        cookies: items.map((item)=>({
                                ...item
                            })),
                        cookieCount: items.length,
                        documentCookies: documentCookies
                    });
                }
            }
        },
        observable: observable
    };
}
const $6d75b31ed2f39f2c$export$541bea9a14448c32 = (0, $1wrwm.ONE_SECOND);
function $6d75b31ed2f39f2c$export$3c3dae9bbbf29ee9(cookieName, cookieOptions) {
    let previousCookieValues = (0, $aZWin.getCookies)(cookieName);
    const observable = new (0, $fnvkG.Observable)(()=>{
        const watchCookieIntervalId = (0, $foX5P.setInterval)(()=>{
            notifyCookieValueIfChanged((0, $aZWin.getCookies)(cookieName));
        }, $6d75b31ed2f39f2c$export$541bea9a14448c32);
        return ()=>{
            (0, $foX5P.clearInterval)(watchCookieIntervalId);
        };
    });
    function notifyCookieValueIfChanged(cookieValues) {
        if (String(cookieValues) !== String(previousCookieValues)) {
            previousCookieValues = cookieValues;
            observable.notify();
        }
    }
    return {
        getAll () {
            return Promise.resolve((0, $aZWin.getCookies)(cookieName));
        },
        async getAllAndSet (cb) {
            const { value: value, expireDelay: expireDelay } = cb((0, $aZWin.getCookies)(cookieName));
            (0, $aZWin.setCookie)(cookieName, value, expireDelay, cookieOptions);
            await Promise.resolve();
            notifyCookieValueIfChanged([
                value
            ]);
        },
        async delete () {
            (0, $aZWin.deleteCookie)(cookieName, cookieOptions);
            await Promise.resolve();
            notifyCookieValueIfChanged([]);
        },
        observable: observable
    };
}
function $6d75b31ed2f39f2c$export$838fa1e3c9088d2b() {
    const cookieStore = (0, $bOZaS.mockable)((0, $c2Qhr.globalObject).cookieStore);
    return Boolean(cookieStore && (0, $50cui.isEventSupported)(cookieStore, "change"));
}

});



parcelRegister("kOVfx", function(module, exports) {

$parcel$export(module.exports, "startLongTaskCollection", function () { return $6cec1bacd8975ab9$export$52c09388c428dadc; });

var $6htpc = parcelRequire("6htpc");
parcelRequire("jNZRV");

var $4H1Xw = parcelRequire("4H1Xw");

var $1wrwm = parcelRequire("1wrwm");

var $cDxUX = parcelRequire("cDxUX");
var $bWkrj = parcelRequire("bWkrj");
//#region src/domain/longTask/longTaskCollection.ts
function $6cec1bacd8975ab9$export$52c09388c428dadc(lifeCycle, configuration) {
    const entryType = (0, $4H1Xw.supportPerformanceTimingEvent)("long-animation-frame") ? "long-animation-frame" : "longtask";
    const subscription = (0, $4H1Xw.createPerformanceObservable)({
        type: entryType,
        buffered: true
    }).subscribe((entries)=>{
        for (const entry of entries){
            if (!configuration.trackLongTasks) break;
            const startClocks = (0, $1wrwm.relativeToClocks)(entry.startTime);
            const rawRumEvent = $6cec1bacd8975ab9$var$processEntry(entry, startClocks);
            lifeCycle.notify(13, {
                rawRumEvent: rawRumEvent,
                startClocks: startClocks,
                duration: entry.duration,
                domainContext: {
                    performanceEntry: entry
                }
            });
        }
    });
    return {
        stop: ()=>subscription.unsubscribe()
    };
}
function $6cec1bacd8975ab9$var$processEntry(entry, startClocks) {
    const id = (0, $bWkrj.generateUUID)();
    const duration = (0, $1wrwm.toServerDuration)(entry.duration);
    const baseEvent = {
        date: startClocks.timeStamp,
        type: (0, $6htpc.RumEventType).LONG_TASK,
        _dd: {
            discarded: false
        }
    };
    if (entry.entryType === "longtask") return {
        ...baseEvent,
        long_task: {
            id: id,
            entry_type: (0, $6htpc.RumLongTaskEntryType).LONG_TASK,
            duration: duration
        }
    };
    const scriptUrls = entry.scripts.map((script)=>script.sourceURL).filter((url)=>!!url);
    const debugIdByUrl = (0, $cDxUX.buildDebugIdByUrl)(scriptUrls);
    return {
        ...baseEvent,
        _dd: {
            discarded: false,
            debug_ids: debugIdByUrl
        },
        long_task: {
            id: id,
            entry_type: (0, $6htpc.RumLongTaskEntryType).LONG_ANIMATION_FRAME,
            duration: duration,
            blocking_duration: (0, $1wrwm.toServerDuration)(entry.blockingDuration),
            first_ui_event_timestamp: (0, $1wrwm.toServerDuration)(entry.firstUIEventTimestamp),
            render_start: (0, $1wrwm.toServerDuration)(entry.renderStart),
            style_and_layout_start: (0, $1wrwm.toServerDuration)(entry.styleAndLayoutStart),
            start_time: (0, $1wrwm.toServerDuration)(entry.startTime),
            scripts: entry.scripts.map((script)=>({
                    duration: (0, $1wrwm.toServerDuration)(script.duration),
                    pause_duration: (0, $1wrwm.toServerDuration)(script.pauseDuration),
                    forced_style_and_layout_duration: (0, $1wrwm.toServerDuration)(script.forcedStyleAndLayoutDuration),
                    start_time: (0, $1wrwm.toServerDuration)(script.startTime),
                    execution_start: (0, $1wrwm.toServerDuration)(script.executionStart),
                    source_url: script.sourceURL,
                    source_function_name: script.sourceFunctionName,
                    source_char_position: script.sourceCharPosition,
                    invoker: script.invoker,
                    invoker_type: script.invokerType,
                    window_attribution: script.windowAttribution
                }))
        }
    };
}

});

parcelRegister("ky7Xi", function(module, exports) {

$parcel$export(module.exports, "startSyntheticsContext", function () { return $8500d87bc4514b01$export$cbd80c79c0d9a191; });
parcelRequire("5GkPj");

var $eQBSl = parcelRequire("eQBSl");

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/contexts/syntheticsContext.ts
function $8500d87bc4514b01$export$cbd80c79c0d9a191(assembleHook) {
    assembleHook.register(({ eventType: eventType })=>{
        if (!(0, $eQBSl.isSyntheticsTest)()) return 0, $fNtjE.SKIPPED;
        return {
            type: eventType,
            session: {
                type: "synthetics"
            },
            synthetics: {
                ...(0, $eQBSl.getSyntheticsContext)(),
                injected: (0, $eQBSl.willSyntheticsInjectRum)()
            }
        };
    });
}

});
parcelRegister("eQBSl", function(module, exports) {

$parcel$export(module.exports, "willSyntheticsInjectRum", function () { return $0f69a8d5a112295f$export$749ed8af36cd25e0; });
$parcel$export(module.exports, "getSyntheticsContext", function () { return $0f69a8d5a112295f$export$f36825a638794cc1; });
$parcel$export(module.exports, "isSyntheticsTest", function () { return $0f69a8d5a112295f$export$334d13f0551749; });

var $aZWin = parcelRequire("aZWin");

var $brKlt = parcelRequire("brKlt");

var $c2Qhr = parcelRequire("c2Qhr");
//#region src/domain/synthetics/syntheticsWorkerValues.ts
const $0f69a8d5a112295f$var$cookieNamePrefix = "datadog-synthetics-";
const $0f69a8d5a112295f$export$ef391ea72457ea48 = `${$0f69a8d5a112295f$var$cookieNamePrefix}public-id`;
const $0f69a8d5a112295f$export$a2c8b6e1d6d69dc9 = `${$0f69a8d5a112295f$var$cookieNamePrefix}result-id`;
const $0f69a8d5a112295f$export$c8a0c5680e097130 = `${$0f69a8d5a112295f$var$cookieNamePrefix}injects-rum`;
const $0f69a8d5a112295f$export$bcc1d30e2cefd5e9 = `${$0f69a8d5a112295f$var$cookieNamePrefix}rum-context`;
function $0f69a8d5a112295f$export$749ed8af36cd25e0() {
    if (0, $c2Qhr.isWorkerEnvironment) return false;
    return Boolean((0, $c2Qhr.globalObject)._DATADOG_SYNTHETICS_INJECTS_RUM || (0, $aZWin.getInitCookie)($0f69a8d5a112295f$export$c8a0c5680e097130));
}
function $0f69a8d5a112295f$export$f36825a638794cc1() {
    const raw = $0f69a8d5a112295f$var$getRawSyntheticsContext();
    return $0f69a8d5a112295f$var$isValidSyntheticsContext(raw) ? raw : void 0;
}
function $0f69a8d5a112295f$export$334d13f0551749() {
    return Boolean($0f69a8d5a112295f$export$f36825a638794cc1());
}
function $0f69a8d5a112295f$var$getRawSyntheticsContext() {
    const rawGlobal = (0, $c2Qhr.globalObject)._DATADOG_SYNTHETICS_RUM_CONTEXT;
    if (rawGlobal) return rawGlobal;
    const rawCookie = (0, $aZWin.getInitCookie)($0f69a8d5a112295f$export$bcc1d30e2cefd5e9);
    if (rawCookie) return (0, $brKlt.tryJsonParse)(decodeURIComponent(rawCookie));
    return {
        test_id: window._DATADOG_SYNTHETICS_PUBLIC_ID || (0, $aZWin.getInitCookie)($0f69a8d5a112295f$export$ef391ea72457ea48),
        result_id: window._DATADOG_SYNTHETICS_RESULT_ID || (0, $aZWin.getInitCookie)($0f69a8d5a112295f$export$a2c8b6e1d6d69dc9)
    };
}
function $0f69a8d5a112295f$var$isValidSyntheticsContext(value) {
    return typeof value === "object" && value !== null && typeof value.test_id === "string" && typeof value.result_id === "string";
}

});


parcelRegister("b6EDT", function(module, exports) {

$parcel$export(module.exports, "startRumAssembly", function () { return $9589e170a4520b34$export$1a0bc162690d6539; });

var $6htpc = parcelRequire("6htpc");
parcelRequire("jNZRV");

var $f1WSi = parcelRequire("f1WSi");

var $5tXxv = parcelRequire("5tXxv");

var $leyUX = parcelRequire("leyUX");
var $a55RI = parcelRequire("a55RI");
var $jq8c3 = parcelRequire("jq8c3");
var $brKlt = parcelRequire("brKlt");

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/assembly.ts
const $9589e170a4520b34$var$COMMON_MODIFIABLE_FIELD_PATHS = {
    "view.name": "string",
    "view.url": "string",
    "view.referrer": "string",
    context: "object",
    service: "string",
    version: "string"
};
const $9589e170a4520b34$var$MODIFIABLE_FIELD_PATHS_BY_EVENT = {
    [(0, $6htpc.RumEventType).VIEW]: {
        ...$9589e170a4520b34$var$COMMON_MODIFIABLE_FIELD_PATHS,
        "view.performance.lcp.resource_url": "string"
    },
    [(0, $6htpc.RumEventType).ERROR]: {
        ...$9589e170a4520b34$var$COMMON_MODIFIABLE_FIELD_PATHS,
        "error.message": "string",
        "error.stack": "string",
        "error.handling_stack": "string",
        "error.resource.url": "string",
        "error.fingerprint": "string",
        "_dd.debug_ids": "array"
    },
    [(0, $6htpc.RumEventType).RESOURCE]: {
        ...$9589e170a4520b34$var$COMMON_MODIFIABLE_FIELD_PATHS,
        "resource.url": "string",
        "resource.graphql.variables": "string",
        "resource.request.headers": "object",
        "resource.response.headers": "object",
        "resource.websocket.close_reason": "string",
        "resource.websocket.protocol": "string"
    },
    [(0, $6htpc.RumEventType).ACTION]: {
        ...$9589e170a4520b34$var$COMMON_MODIFIABLE_FIELD_PATHS,
        "action.target.name": "string"
    },
    [(0, $6htpc.RumEventType).LONG_TASK]: {
        ...$9589e170a4520b34$var$COMMON_MODIFIABLE_FIELD_PATHS,
        "long_task.scripts[].source_url": "string",
        "long_task.scripts[].invoker": "string",
        "_dd.debug_ids": "array"
    },
    [(0, $6htpc.RumEventType).VITAL]: $9589e170a4520b34$var$COMMON_MODIFIABLE_FIELD_PATHS
};
function $9589e170a4520b34$export$1a0bc162690d6539(configuration, lifeCycle, hooks, reportError, eventRateLimit) {
    const eventRateLimiters = {
        [(0, $6htpc.RumEventType).ERROR]: (0, $a55RI.createEventRateLimiter)((0, $6htpc.RumEventType).ERROR, reportError, eventRateLimit),
        [(0, $6htpc.RumEventType).ACTION]: (0, $a55RI.createEventRateLimiter)((0, $6htpc.RumEventType).ACTION, reportError, eventRateLimit),
        [(0, $6htpc.RumEventType).VITAL]: (0, $a55RI.createEventRateLimiter)((0, $6htpc.RumEventType).VITAL, reportError, eventRateLimit)
    };
    lifeCycle.subscribe(13, ({ startClocks: startClocks, duration: duration, rawRumEvent: rawRumEvent, domainContext: domainContext })=>{
        const assemblyParams = {
            eventType: rawRumEvent.type,
            rawRumEvent: rawRumEvent,
            domainContext: domainContext,
            startTime: startClocks.relative,
            duration: duration
        };
        const defaultRumEventAttributes = hooks.assembleEventDefaults.trigger(assemblyParams);
        if (defaultRumEventAttributes === (0, $fNtjE.DISCARDED)) return;
        const rumEventAttributes = hooks.assembleEvent.trigger(assemblyParams);
        if (rumEventAttributes === (0, $fNtjE.DISCARDED)) return;
        const serverRumEvent = (0, $5tXxv.combine)(defaultRumEventAttributes, rawRumEvent, rumEventAttributes, {
            ddtags: (0, $leyUX.buildTags)(configuration).join(",")
        });
        if ($9589e170a4520b34$var$shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
            if ((0, $brKlt.isEmptyObject)(serverRumEvent.context)) delete serverRumEvent.context;
            lifeCycle.notify(14, serverRumEvent);
        }
    });
}
function $9589e170a4520b34$var$shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    if (beforeSend) {
        const result = (0, $f1WSi.limitModification)(event, $9589e170a4520b34$var$MODIFIABLE_FIELD_PATHS_BY_EVENT[event.type], (event)=>beforeSend(event, domainContext));
        if (result === false && event.type !== (0, $6htpc.RumEventType).VIEW) return false;
        if (result === false) (0, $jq8c3.display).warn("Can't dismiss view events using beforeSend!");
    }
    return !eventRateLimiters[event.type]?.isLimitReached();
}

});
parcelRegister("f1WSi", function(module, exports) {

$parcel$export(module.exports, "limitModification", function () { return $7d0c9017d5a61a14$export$a1733aa00dfb01; });

var $5tXxv = parcelRequire("5tXxv");
var $bF5dI = parcelRequire("bF5dI");

var $2faqW = parcelRequire("2faqW");
var $hpOLz = parcelRequire("hpOLz");
//#region src/domain/limitModification.ts
/**
* Allows declaring and enforcing modifications to specific fields of an object.
* Only supports modifying properties of an object (even if nested in an array).
* Does not support array manipulation (adding/removing items).
*
* Modifications of the object are sanitized only if the field was actually changed by the modifier function (i.e., value is different).
* This ensures consistent SDK behavior regardless of whether limitModification is called.
* Only string fields are handled this way, object fields are sanitized regardless of whether the modifier function was called or not.
*/ function $7d0c9017d5a61a14$export$a1733aa00dfb01(object, modifiableFieldPaths, modifier) {
    const clone = (0, $5tXxv.deepClone)(object);
    const result = modifier(clone);
    (0, $2faqW.objectEntries)(modifiableFieldPaths).forEach(([fieldPath, fieldType])=>$7d0c9017d5a61a14$var$setValueAtPath(object, clone, fieldPath.split(/\.|(?=\[\])/), fieldType));
    return result;
}
function $7d0c9017d5a61a14$var$setValueAtPath(object, clone, pathSegments, fieldType) {
    const [field, ...restPathSegments] = pathSegments;
    if (field === "[]") {
        if (Array.isArray(object) && Array.isArray(clone)) object.forEach((item, i)=>$7d0c9017d5a61a14$var$setValueAtPath(item, clone[i], restPathSegments, fieldType));
        return;
    }
    if (!$7d0c9017d5a61a14$var$isValidObject(object) || !$7d0c9017d5a61a14$var$isValidObject(clone)) return;
    if (restPathSegments.length > 0) return $7d0c9017d5a61a14$var$setValueAtPath(object[field], clone[field], restPathSegments, fieldType);
    $7d0c9017d5a61a14$var$setNestedValue(object, field, clone[field], fieldType);
}
function $7d0c9017d5a61a14$var$setNestedValue(object, field, value, fieldType) {
    if (object[field] === value) return;
    const newType = (0, $bF5dI.getType)(value);
    if (newType === fieldType) object[field] = (0, $hpOLz.sanitize)(value);
    else if (fieldType === "object" && (newType === "undefined" || newType === "null")) object[field] = {};
    else if (fieldType === "array" && (newType === "undefined" || newType === "null")) object[field] = [];
}
function $7d0c9017d5a61a14$var$isValidObject(object) {
    return (0, $bF5dI.getType)(object) === "object";
}

});

parcelRegister("a55RI", function(module, exports) {

$parcel$export(module.exports, "createEventRateLimiter", function () { return $4722b88865376f71$export$eafcd5d914e17d69; });

var $foX5P = parcelRequire("foX5P");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/eventRateLimiter/createEventRateLimiter.ts
const $4722b88865376f71$var$EVENT_RATE_LIMIT = 3e3;
function $4722b88865376f71$export$eafcd5d914e17d69(eventType, onLimitReached, limit = $4722b88865376f71$var$EVENT_RATE_LIMIT) {
    let eventCount = 0;
    let allowNextEvent = false;
    return {
        isLimitReached () {
            if (eventCount === 0) (0, $foX5P.setTimeout)(()=>{
                eventCount = 0;
            }, (0, $1wrwm.ONE_MINUTE));
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached(`Reached max number of ${eventType}s by minute: ${limit}`);
                } finally{
                    allowNextEvent = false;
                }
            }
            return true;
        }
    };
}

});


parcelRegister("eGPRq", function(module, exports) {

$parcel$export(module.exports, "startConnectivityContext", function () { return $1e81ca62bd551300$export$e80ceed9d1147534; });

var $hVWmP = parcelRequire("hVWmP");
//#region src/domain/contexts/connectivityContext.ts
function $1e81ca62bd551300$export$e80ceed9d1147534(assembleHook) {
    assembleHook.register(({ eventType: eventType })=>({
            type: eventType,
            connectivity: (0, $hVWmP.getConnectivity)()
        }));
}

});

parcelRegister("aSSxK", function(module, exports) {

$parcel$export(module.exports, "startDefaultContext", function () { return $91afa5d505a6004a$export$4349d78965f7073b; });

var $1wrwm = parcelRequire("1wrwm");

var $gS0nt = parcelRequire("gS0nt");
var $eQWMG = parcelRequire("eQWMG");
//#region src/domain/contexts/defaultContext.ts
function $91afa5d505a6004a$export$4349d78965f7073b(assembleHook, configuration, sdkName) {
    assembleHook.register(({ eventType: eventType })=>{
        const source = configuration.source;
        return {
            type: eventType,
            _dd: {
                format_version: 2,
                drift: (0, $1wrwm.clockDrift)(),
                configuration: {
                    session_sample_rate: (0, $eQWMG.round)(configuration.sessionSampleRate, 3),
                    session_replay_sample_rate: (0, $eQWMG.round)(configuration.sessionReplaySampleRate, 3),
                    profiling_sample_rate: (0, $eQWMG.round)(configuration.profilingSampleRate, 3),
                    trace_sample_rate: (0, $eQWMG.round)(configuration.traceSampleRate, 3)
                },
                browser_sdk_version: (0, $gS0nt.canUseEventBridge)() ? "7.14.0" : void 0,
                sdk_name: sdkName
            },
            application: {
                id: configuration.applicationId
            },
            date: (0, $1wrwm.timeStampNow)(),
            source: source
        };
    });
}

});

parcelRegister("6zIVo", function(module, exports) {

$parcel$export(module.exports, "startEventCollection", function () { return $53d928a953837dcc$export$8fba5d6b972d9291; });

var $6htpc = parcelRequire("6htpc");
parcelRequire("jNZRV");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/event/eventCollection.ts
const $53d928a953837dcc$var$allowedEventTypes = [
    (0, $6htpc.RumEventType).ACTION,
    (0, $6htpc.RumEventType).ERROR,
    (0, $6htpc.RumEventType).LONG_TASK,
    (0, $6htpc.RumEventType).RESOURCE,
    (0, $6htpc.RumEventType).VITAL
];
function $53d928a953837dcc$export$8fba5d6b972d9291(lifeCycle) {
    return {
        addEvent: (startTime, event, domainContext, duration)=>{
            if (!$53d928a953837dcc$var$allowedEventTypes.includes(event.type)) return;
            lifeCycle.notify(13, {
                startClocks: (0, $1wrwm.relativeToClocks)(startTime),
                rawRumEvent: event,
                domainContext: domainContext,
                duration: duration
            });
        }
    };
}

});

parcelRegister("3Twtr", function(module, exports) {

$parcel$export(module.exports, "startSourceCodeMfeContext", function () { return $47ad6c78bedfcb58$export$f906987c76c1dac; });

var $fiOtf = parcelRequire("fiOtf");
var $cDxUX = parcelRequire("cDxUX");

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/contexts/sourceCodeMfeContext.ts
/**
* Attributes service and version from the source code context (injected at build time by the
* Datadog build plugins) to RUM events emitted by micro-frontend bundles.
*
* Note: service/version attribution relies on a single URL (the top frame of the error stack, or the
* first script of a long animation frame). Debug IDs, on the other hand, are resolved separately and
* cover every bundle URL across the full error cause chain — not just that top frame.
*/ function $47ad6c78bedfcb58$export$f906987c76c1dac(assembleHook) {
    assembleHook.register(({ domainContext: domainContext, rawRumEvent: rawRumEvent })=>{
        const url = $47ad6c78bedfcb58$var$getSourceUrl(domainContext, rawRumEvent);
        if (!url) return 0, $fNtjE.SKIPPED;
        const context = (0, $cDxUX.getSourceCodeContext)(url);
        if (!context) return 0, $fNtjE.SKIPPED;
        return {
            type: rawRumEvent.type,
            service: context.service,
            version: context.version
        };
    });
}
function $47ad6c78bedfcb58$var$getSourceUrl(domainContext, rawRumEvent) {
    if (rawRumEvent.type === "long_task" && rawRumEvent.long_task.entry_type === "long-animation-frame") return rawRumEvent.long_task.scripts[0]?.source_url;
    let stack;
    if ("handlingStack" in domainContext) stack = domainContext.handlingStack;
    if (rawRumEvent.type === "error" && rawRumEvent.error.stack) stack = rawRumEvent.error.stack;
    return (0, $fiOtf.computeStackTrace)({
        stack: stack
    }).stack[0]?.url;
}

});

parcelRegister("dmc88", function(module, exports) {

$parcel$export(module.exports, "startAccountContext", function () { return $ff28d915a22286c6$export$cf2a880268c4528; });
$parcel$export(module.exports, "buildAccountContextManager", function () { return $ff28d915a22286c6$export$ce92dcf53cc1a6a; });

var $brKlt = parcelRequire("brKlt");

var $cybD8 = parcelRequire("cybD8");

var $41A51 = parcelRequire("41A51");


var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/contexts/accountContext.ts
function $ff28d915a22286c6$export$cf2a880268c4528(assembleHook, configuration, productKey) {
    const accountContextManager = $ff28d915a22286c6$export$ce92dcf53cc1a6a();
    if (configuration.storeContextsAcrossPages) (0, $41A51.storeContextManager)(accountContextManager, productKey, 4);
    assembleHook.register(()=>{
        const account = accountContextManager.getContext();
        if ((0, $brKlt.isEmptyObject)(account) || !account.id) return 0, $fNtjE.SKIPPED;
        return {
            account: account
        };
    });
    return accountContextManager;
}
function $ff28d915a22286c6$export$ce92dcf53cc1a6a() {
    return (0, $cybD8.createContextManager)("account", {
        propertiesConfig: {
            id: {
                type: "string",
                required: true
            },
            name: {
                type: "string"
            }
        }
    });
}

});
parcelRegister("41A51", function(module, exports) {

$parcel$export(module.exports, "storeContextManager", function () { return $b1a08f009a2543f1$export$a658cbc041b124d0; });

var $brKlt = parcelRequire("brKlt");

var $50cui = parcelRequire("50cui");

var $5tXxv = parcelRequire("5tXxv");
//#region src/domain/context/storeContextManager.ts
const $b1a08f009a2543f1$var$CONTEXT_STORE_KEY_PREFIX = "_dd_c";
const $b1a08f009a2543f1$var$storageListeners = [];
function $b1a08f009a2543f1$export$a658cbc041b124d0(contextManager, productKey, customerDataType) {
    if (typeof window === "undefined" || typeof localStorage === "undefined") return;
    const storageKey = $b1a08f009a2543f1$export$c2d6dd7271dc8ae0(productKey, customerDataType);
    $b1a08f009a2543f1$var$storageListeners.push((0, $50cui.addEventListener)(window, "storage", ({ key: key })=>{
        if (storageKey === key) synchronizeWithStorage();
    }));
    contextManager.changeObservable.subscribe(dumpToStorage);
    const contextFromStorage = (0, $5tXxv.combine)(getFromStorage(), contextManager.getContext());
    if (!(0, $brKlt.isEmptyObject)(contextFromStorage)) contextManager.setContext(contextFromStorage);
    function synchronizeWithStorage() {
        contextManager.setContext(getFromStorage());
    }
    function dumpToStorage() {
        localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
    }
    function getFromStorage() {
        const rawContext = localStorage.getItem(storageKey);
        return rawContext ? (0, $brKlt.tryJsonParse)(rawContext) ?? {} : {};
    }
}
function $b1a08f009a2543f1$export$c2d6dd7271dc8ae0(productKey, customerDataType) {
    return `${$b1a08f009a2543f1$var$CONTEXT_STORE_KEY_PREFIX}_${productKey}_${customerDataType}`;
}
function $b1a08f009a2543f1$export$c82fd872f963a6c() {
    $b1a08f009a2543f1$var$storageListeners.map((listener)=>listener.stop());
}

});


parcelRegister("4B1f5", function(module, exports) {

$parcel$export(module.exports, "startGlobalContext", function () { return $e4e47fe88d02164f$export$79168511affd2fc8; });
$parcel$export(module.exports, "buildGlobalContextManager", function () { return $e4e47fe88d02164f$export$74c774929829d55; });

var $cybD8 = parcelRequire("cybD8");

var $41A51 = parcelRequire("41A51");

//#region src/domain/contexts/globalContext.ts
function $e4e47fe88d02164f$export$79168511affd2fc8(assembleHook, configuration, productKey, useContextNamespace) {
    const globalContextManager = $e4e47fe88d02164f$export$74c774929829d55();
    if (configuration.storeContextsAcrossPages) (0, $41A51.storeContextManager)(globalContextManager, productKey, 2);
    assembleHook.register(()=>{
        const context = globalContextManager.getContext();
        return useContextNamespace ? {
            context: context
        } : context;
    });
    return globalContextManager;
}
function $e4e47fe88d02164f$export$74c774929829d55() {
    return (0, $cybD8.createContextManager)("global context");
}

});

parcelRegister("6gx7W", function(module, exports) {

$parcel$export(module.exports, "startTabContext", function () { return $819aa5ff594cf6a2$export$b43e6f92624488b6; });

var $bWkrj = parcelRequire("bWkrj");
//#region src/domain/contexts/tabContext.ts
const $819aa5ff594cf6a2$export$ecc65ceb1b2e53fb = "_dd_tab_id";
let $819aa5ff594cf6a2$var$cachedTabId;
function $819aa5ff594cf6a2$export$b43e6f92624488b6(assembleHook) {
    const tabId = $819aa5ff594cf6a2$var$retrieveOrCreateTabId();
    assembleHook.register(()=>({
            tab: {
                id: tabId
            }
        }));
}
function $819aa5ff594cf6a2$var$retrieveOrCreateTabId() {
    if (!$819aa5ff594cf6a2$var$cachedTabId) $819aa5ff594cf6a2$var$cachedTabId = $819aa5ff594cf6a2$var$getOrCreateIdInSessionStorage() ?? (0, $bWkrj.generateUUID)();
    return $819aa5ff594cf6a2$var$cachedTabId;
}
function $819aa5ff594cf6a2$var$getOrCreateIdInSessionStorage() {
    try {
        const existingId = sessionStorage.getItem($819aa5ff594cf6a2$export$ecc65ceb1b2e53fb);
        if (existingId) return existingId;
        const newId = (0, $bWkrj.generateUUID)();
        sessionStorage.setItem($819aa5ff594cf6a2$export$ecc65ceb1b2e53fb, newId);
        return newId;
    } catch  {
        return;
    }
}

});

parcelRegister("7P6fE", function(module, exports) {

$parcel$export(module.exports, "startUserContext", function () { return $b31a83b8b0a4e01a$export$bc474ea3ef4605f1; });
$parcel$export(module.exports, "buildUserContextManager", function () { return $b31a83b8b0a4e01a$export$aef22fb136f9980c; });

var $brKlt = parcelRequire("brKlt");

var $cybD8 = parcelRequire("cybD8");

var $41A51 = parcelRequire("41A51");


var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/contexts/userContext.ts
function $b31a83b8b0a4e01a$export$bc474ea3ef4605f1(hook, configuration, sessionManager, productKey) {
    const userContextManager = $b31a83b8b0a4e01a$export$aef22fb136f9980c();
    if (configuration.storeContextsAcrossPages) (0, $41A51.storeContextManager)(userContextManager, productKey, 1);
    hook.register(({ eventType: eventType, startTime: startTime })=>{
        const user = userContextManager.getContext();
        const session = sessionManager.findTrackedSession(startTime);
        if (session?.anonymousId && !user.anonymous_id && !!configuration.trackAnonymousUser) user.anonymous_id = session.anonymousId;
        if ((0, $brKlt.isEmptyObject)(user)) return 0, $fNtjE.SKIPPED;
        return {
            type: eventType,
            usr: user
        };
    });
    return userContextManager;
}
function $b31a83b8b0a4e01a$export$aef22fb136f9980c() {
    return (0, $cybD8.createContextManager)("user", {
        propertiesConfig: {
            id: {
                type: "string"
            },
            name: {
                type: "string"
            },
            email: {
                type: "string"
            }
        }
    });
}

});


parcelRegister("13M2C", function(module, exports) {

$parcel$export(module.exports, "makeRumPublicApi", function () { return $278d0a776a178c4e$export$27595a139f6e6837; });

var $6htpc = parcelRequire("6htpc");

var $iVgUy = parcelRequire("iVgUy");
parcelRequire("laTCl");

var $kKNA5 = parcelRequire("kKNA5");

var $aPdc8 = parcelRequire("aPdc8");

var $eE0f0 = parcelRequire("eE0f0");

var $1wrwm = parcelRequire("1wrwm");

var $5tXxv = parcelRequire("5tXxv");

var $461Vl = parcelRequire("461Vl");
var $95eAR = parcelRequire("95eAR");
var $e6zeV = parcelRequire("e6zeV");
var $8DfP8 = parcelRequire("8DfP8");
var $efY2P = parcelRequire("efY2P");
var $aAvkZ = parcelRequire("aAvkZ");
var $jq8c3 = parcelRequire("jq8c3");
var $81mt8 = parcelRequire("81mt8");
var $bWkrj = parcelRequire("bWkrj");
var $1nqsB = parcelRequire("1nqsB");
var $bOZaS = parcelRequire("bOZaS");
var $hpOLz = parcelRequire("hpOLz");
var $lePkT = parcelRequire("lePkT");

var $dee0n = parcelRequire("dee0n");
//#region src/boot/rumPublicApi.ts
function $278d0a776a178c4e$export$27595a139f6e6837(recorderApi, profilerApi, options = {}) {
    const trackingConsentState = (0, $efY2P.createTrackingConsentState)();
    const bufferedData = (0, $lePkT.startBufferingData)();
    let strategy = (0, $aPdc8.createPreStartStrategy)(options, trackingConsentState, (configuration, sessionManager, deflateWorker, initialViewOptions, telemetry, hooks)=>{
        const createEncoder = deflateWorker && options.createDeflateEncoder ? (streamId)=>options.createDeflateEncoder(deflateWorker, streamId) : (0, $8DfP8.createIdentityEncoder);
        const startRumResult = (0, $bOZaS.mockable)((0, $eE0f0.startRum))(configuration, sessionManager, recorderApi, profilerApi, initialViewOptions, createEncoder, bufferedData.observable, telemetry, hooks, options.sdkName);
        recorderApi.onRumStart(startRumResult.lifeCycle, configuration, sessionManager, startRumResult.viewHistory, deflateWorker, startRumResult.telemetry);
        profilerApi.onRumStart(startRumResult.lifeCycle, startRumResult.hooks, configuration, sessionManager, startRumResult.viewHistory, createEncoder);
        strategy = $278d0a776a178c4e$var$createPostStartStrategy(strategy, startRumResult);
        (0, $kKNA5.callPluginsOnRumStart)(configuration.plugins, {
            addEvent: startRumResult.addEvent,
            addError: startRumResult.addError
        });
        return startRumResult;
    });
    const getStrategy = ()=>strategy;
    const startView = (options)=>{
        const handlingStack = (0, $e6zeV.createHandlingStack)("view");
        (0, $dee0n.callMonitored)(()=>{
            const sanitizedOptions = typeof options === "object" ? options : {
                name: options
            };
            strategy.startView({
                ...sanitizedOptions,
                name: $278d0a776a178c4e$var$sanitizeStringOption(sanitizedOptions.name, "view name"),
                service: $278d0a776a178c4e$var$sanitizeStringOption(sanitizedOptions.service, "view service"),
                version: $278d0a776a178c4e$var$sanitizeStringOption(sanitizedOptions.version, "view version"),
                handlingStack: handlingStack
            });
            (0, $461Vl.addTelemetryUsage)({
                feature: "start-view"
            });
        });
    };
    const startOperation = (name, options)=>{
        const handlingStack = (0, $e6zeV.createHandlingStack)("vital");
        (0, $dee0n.callMonitored)(()=>{
            (0, $461Vl.addTelemetryUsage)({
                feature: "add-operation-step-vital",
                action_type: "start"
            });
            strategy.addOperationStepVital(name, "start", {
                ...options,
                handlingStack: handlingStack
            });
        });
    };
    const succeedOperation = (0, $dee0n.monitor)((name, options)=>{
        (0, $461Vl.addTelemetryUsage)({
            feature: "add-operation-step-vital",
            action_type: "succeed"
        });
        strategy.addOperationStepVital(name, "end", options);
    });
    const failOperation = (0, $dee0n.monitor)((name, failureReason, options)=>{
        (0, $461Vl.addTelemetryUsage)({
            feature: "add-operation-step-vital",
            action_type: "fail"
        });
        strategy.addOperationStepVital(name, "end", options, failureReason);
    });
    const rumPublicApi = (0, $1nqsB.makePublicApi)({
        init: (initConfiguration)=>{
            const errorStack = /* @__PURE__ */ new Error().stack;
            (0, $dee0n.callMonitored)(()=>strategy.init(initConfiguration, rumPublicApi, errorStack));
        },
        setTrackingConsent: (0, $dee0n.monitor)((trackingConsent)=>{
            trackingConsentState.update(trackingConsent);
            (0, $461Vl.addTelemetryUsage)({
                feature: "set-tracking-consent",
                tracking_consent: trackingConsent
            });
        }),
        setViewName: (0, $dee0n.monitor)((name)=>{
            strategy.setViewName($278d0a776a178c4e$var$sanitizeStringOption(name, "view name"));
            (0, $461Vl.addTelemetryUsage)({
                feature: "set-view-name"
            });
        }),
        setViewContext: (0, $dee0n.monitor)((context)=>{
            strategy.setViewContext(context);
            (0, $461Vl.addTelemetryUsage)({
                feature: "set-view-context"
            });
        }),
        setViewContextProperty: (0, $dee0n.monitor)((key, value)=>{
            strategy.setViewContextProperty(key, value);
            (0, $461Vl.addTelemetryUsage)({
                feature: "set-view-context-property"
            });
        }),
        getViewContext: (0, $dee0n.monitor)(()=>{
            (0, $461Vl.addTelemetryUsage)({
                feature: "set-view-context-property"
            });
            return strategy.getViewContext();
        }),
        getInternalContext: (0, $dee0n.monitor)((startTime)=>strategy.getInternalContext(startTime)),
        getInitConfiguration: (0, $dee0n.monitor)(()=>(0, $5tXxv.deepClone)(strategy.initConfiguration)),
        addAction: (name, context)=>{
            const handlingStack = (0, $e6zeV.createHandlingStack)("action");
            (0, $dee0n.callMonitored)(()=>{
                strategy.addAction({
                    name: (0, $hpOLz.sanitize)(name),
                    context: (0, $hpOLz.sanitize)(context),
                    startClocks: (0, $1wrwm.clocksNow)(),
                    type: (0, $6htpc.ActionType).CUSTOM,
                    handlingStack: handlingStack
                });
                (0, $461Vl.addTelemetryUsage)({
                    feature: "add-action"
                });
            });
        },
        startAction: (0, $dee0n.monitor)((name, options)=>{
            (0, $461Vl.addTelemetryUsage)({
                feature: "start-action"
            });
            strategy.startAction((0, $hpOLz.sanitize)(name), {
                type: (0, $hpOLz.sanitize)(options?.type),
                context: (0, $hpOLz.sanitize)(options?.context),
                actionKey: options?.actionKey
            });
        }),
        stopAction: (0, $dee0n.monitor)((name, options)=>{
            (0, $461Vl.addTelemetryUsage)({
                feature: "stop-action"
            });
            strategy.stopAction((0, $hpOLz.sanitize)(name), {
                type: (0, $hpOLz.sanitize)(options?.type),
                context: (0, $hpOLz.sanitize)(options?.context),
                actionKey: options?.actionKey
            });
        }),
        startResource: (0, $dee0n.monitor)((url, options)=>{
            (0, $461Vl.addTelemetryUsage)({
                feature: "start-resource"
            });
            strategy.startResource((0, $hpOLz.sanitize)(url), {
                type: (0, $hpOLz.sanitize)(options?.type),
                method: (0, $hpOLz.sanitize)(options?.method),
                context: (0, $hpOLz.sanitize)(options?.context),
                resourceKey: options?.resourceKey
            });
        }),
        stopResource: (0, $dee0n.monitor)((url, options)=>{
            (0, $461Vl.addTelemetryUsage)({
                feature: "stop-resource"
            });
            strategy.stopResource((0, $hpOLz.sanitize)(url), {
                type: (0, $hpOLz.sanitize)(options?.type),
                statusCode: options?.statusCode,
                size: options?.size,
                context: (0, $hpOLz.sanitize)(options?.context),
                resourceKey: options?.resourceKey
            });
        }),
        addError: (error, context)=>{
            const handlingStack = (0, $e6zeV.createHandlingStack)("error");
            (0, $dee0n.callMonitored)(()=>{
                strategy.addError({
                    error: error,
                    handlingStack: handlingStack,
                    context: (0, $hpOLz.sanitize)(context),
                    startClocks: (0, $1wrwm.clocksNow)()
                });
                (0, $461Vl.addTelemetryUsage)({
                    feature: "add-error"
                });
            });
        },
        addTiming: (0, $dee0n.monitor)((name, time)=>{
            strategy.addTiming((0, $hpOLz.sanitize)(name), time);
        }),
        setViewLoadingTime: (0, $dee0n.monitor)(()=>{
            const callTimestamp = (0, $1wrwm.timeStampNow)();
            strategy.setLoadingTime(callTimestamp);
            (0, $461Vl.addTelemetryUsage)({
                feature: "addViewLoadingTime"
            });
        }),
        setGlobalContext: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).globalContext, (0, $95eAR.ContextManagerMethod).setContext, "set-global-context"),
        getGlobalContext: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).globalContext, (0, $95eAR.ContextManagerMethod).getContext, "get-global-context"),
        setGlobalContextProperty: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).globalContext, (0, $95eAR.ContextManagerMethod).setContextProperty, "set-global-context-property"),
        removeGlobalContextProperty: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).globalContext, (0, $95eAR.ContextManagerMethod).removeContextProperty, "remove-global-context-property"),
        clearGlobalContext: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).globalContext, (0, $95eAR.ContextManagerMethod).clearContext, "clear-global-context"),
        setUser: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).userContext, (0, $95eAR.ContextManagerMethod).setContext, "set-user"),
        getUser: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).userContext, (0, $95eAR.ContextManagerMethod).getContext, "get-user"),
        setUserProperty: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).userContext, (0, $95eAR.ContextManagerMethod).setContextProperty, "set-user-property"),
        removeUserProperty: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).userContext, (0, $95eAR.ContextManagerMethod).removeContextProperty, "remove-user-property"),
        clearUser: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).userContext, (0, $95eAR.ContextManagerMethod).clearContext, "clear-user"),
        setAccount: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).accountContext, (0, $95eAR.ContextManagerMethod).setContext, "set-account"),
        getAccount: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).accountContext, (0, $95eAR.ContextManagerMethod).getContext, "get-account"),
        setAccountProperty: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).accountContext, (0, $95eAR.ContextManagerMethod).setContextProperty, "set-account-property"),
        removeAccountProperty: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).accountContext, (0, $95eAR.ContextManagerMethod).removeContextProperty, "remove-account-property"),
        clearAccount: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).accountContext, (0, $95eAR.ContextManagerMethod).clearContext, "clear-account"),
        startView: startView,
        stopSession: (0, $dee0n.monitor)(()=>{
            strategy.stopSession();
            (0, $461Vl.addTelemetryUsage)({
                feature: "stop-session"
            });
        }),
        addFeatureFlagEvaluation: (0, $dee0n.monitor)((key, value)=>{
            strategy.addFeatureFlagEvaluation((0, $hpOLz.sanitize)(key), (0, $hpOLz.sanitize)(value));
            (0, $461Vl.addTelemetryUsage)({
                feature: "add-feature-flag-evaluation"
            });
        }),
        getSessionReplayLink: (0, $dee0n.monitor)(()=>recorderApi.getSessionReplayLink()),
        startSessionReplayRecording: (0, $dee0n.monitor)((options)=>{
            recorderApi.start(options);
            (0, $461Vl.addTelemetryUsage)({
                feature: "start-session-replay-recording",
                force: options?.force
            });
        }),
        stopSessionReplayRecording: (0, $dee0n.monitor)(()=>recorderApi.stop()),
        addDurationVital: (name, options)=>{
            const handlingStack = (0, $e6zeV.createHandlingStack)("vital");
            (0, $dee0n.callMonitored)(()=>{
                (0, $461Vl.addTelemetryUsage)({
                    feature: "add-duration-vital"
                });
                strategy.addDurationVital({
                    id: (0, $bWkrj.generateUUID)(),
                    name: (0, $hpOLz.sanitize)(name),
                    type: (0, $6htpc.VitalType).DURATION,
                    startClocks: (0, $1wrwm.timeStampToClocks)(options.startTime),
                    duration: options.duration,
                    context: (0, $hpOLz.sanitize)(options?.context),
                    description: (0, $hpOLz.sanitize)(options?.description),
                    handlingStack: handlingStack
                });
            });
        },
        startDurationVital: (name, options)=>{
            const handlingStack = (0, $e6zeV.createHandlingStack)("vital");
            (0, $dee0n.callMonitored)(()=>{
                (0, $461Vl.addTelemetryUsage)({
                    feature: "start-duration-vital"
                });
                strategy.startDurationVital((0, $hpOLz.sanitize)(name), {
                    vitalKey: options?.vitalKey,
                    context: (0, $hpOLz.sanitize)(options?.context),
                    description: (0, $hpOLz.sanitize)(options?.description),
                    handlingStack: handlingStack
                });
            });
        },
        stopDurationVital: (0, $dee0n.monitor)((name, options)=>{
            (0, $461Vl.addTelemetryUsage)({
                feature: "stop-duration-vital"
            });
            strategy.stopDurationVital((0, $hpOLz.sanitize)(name), {
                vitalKey: options?.vitalKey,
                context: (0, $hpOLz.sanitize)(options?.context),
                description: (0, $hpOLz.sanitize)(options?.description)
            });
        }),
        startOperation: startOperation,
        succeedOperation: succeedOperation,
        failOperation: failOperation,
        startFeatureOperation: startOperation,
        succeedFeatureOperation: succeedOperation,
        failFeatureOperation: failOperation,
        DEFAULT_TRACKED_RESOURCE_HEADERS: $iVgUy.DEFAULT_TRACKED_RESOURCE_HEADERS
    });
    return rumPublicApi;
}
function $278d0a776a178c4e$var$sanitizeStringOption(value, label) {
    if (value === void 0) return;
    if (typeof value !== "string") {
        (0, $jq8c3.display).warn(`Invalid ${label} provided (expected a string, got ${typeof value}). Ignoring.`);
        return;
    }
    return (0, $hpOLz.sanitize)(value);
}
function $278d0a776a178c4e$var$createPostStartStrategy(preStartStrategy, startRumResult) {
    return {
        ...preStartStrategy,
        init: (initConfiguration)=>{
            (0, $81mt8.displayAlreadyInitializedError)("DD_RUM", initConfiguration);
        },
        getInternalContext: startRumResult.getInternalContext,
        stopSession: startRumResult.stopSession,
        getViewContext: startRumResult.getViewContext,
        globalContext: startRumResult.globalContext,
        userContext: startRumResult.userContext,
        accountContext: startRumResult.accountContext
    };
}

});
parcelRegister("kKNA5", function(module, exports) {

$parcel$export(module.exports, "callPluginsOnInit", function () { return $1ba1bc0d22a594b8$export$503760b6f9240c7e; });
$parcel$export(module.exports, "callPluginsOnRumStart", function () { return $1ba1bc0d22a594b8$export$78d75f5f9b364b08; });

var $acqNr = parcelRequire("acqNr");
//#region src/domain/plugins.ts
/**
* Calls every plugin's `onInit` method concurrently, without waiting for one to resolve before
* calling the next. Stays synchronous as long as no plugin returns a thenable.
* Returns `false` if any plugin returned (or resolved to) `false`, `true` otherwise.
*/ function $1ba1bc0d22a594b8$export$503760b6f9240c7e(plugins, parameter) {
    if (!plugins) return true;
    const results = plugins.map((plugin)=>plugin.onInit?.(parameter));
    if (results.some((0, $acqNr.isThenable))) return Promise.all(results).then((results)=>!results.includes(false));
    return !results.includes(false);
}
/**
* Calls each plugin's `onRumStart` method in order.
*/ function $1ba1bc0d22a594b8$export$78d75f5f9b364b08(plugins, options) {
    for (const plugin of plugins ?? [])plugin.onRumStart?.(options);
}

});
parcelRegister("acqNr", function(module, exports) {

$parcel$export(module.exports, "isThenable", function () { return $89658563ed3750cf$export$f5b060c2914b97c8; });

var $foX5P = parcelRequire("foX5P");
//#region src/tools/thenable.ts
function $89658563ed3750cf$export$f5b060c2914b97c8(value) {
    return !!value && typeof value.then === "function";
}
const $89658563ed3750cf$export$4124beefd05acd0b = "Timeout";
function $89658563ed3750cf$export$f47339bf28a93789(error) {
    return error instanceof Error && error.message === "Timeout";
}
/**
* Resolves or rejects with `thenable`, or rejects with a `TIMEOUT_ERROR_MESSAGE` error if it
* doesn't settle within `timeout` ms.
*/ function $89658563ed3750cf$export$629655d17bce2109(thenable, timeout = 3e3) {
    let timeoutId;
    const timeoutPromise = new Promise((_, reject)=>{
        timeoutId = (0, $foX5P.setTimeout)(()=>reject(/* @__PURE__ */ new Error($89658563ed3750cf$export$4124beefd05acd0b)), timeout);
    });
    return Promise.race([
        thenable,
        timeoutPromise
    ]).finally(()=>(0, $foX5P.clearTimeout)(timeoutId));
}

});


parcelRegister("aPdc8", function(module, exports) {

$parcel$export(module.exports, "createPreStartStrategy", function () { return $fb772a9148f292f6$export$8f7002373dcc6602; });

var $e6c5e = parcelRequire("e6c5e");

var $iVgUy = parcelRequire("iVgUy");
parcelRequire("laTCl");

var $kKNA5 = parcelRequire("kKNA5");

var $kmm0x = parcelRequire("kmm0x");

var $kpcu4 = parcelRequire("kpcu4");

var $1wrwm = parcelRequire("1wrwm");

var $c2Qhr = parcelRequire("c2Qhr");

var $461Vl = parcelRequire("461Vl");
var $aAvkZ = parcelRequire("aAvkZ");
var $fnvkG = parcelRequire("fnvkG");
var $dmc88 = parcelRequire("dmc88");
var $4B1f5 = parcelRequire("4B1f5");
var $7P6fE = parcelRequire("7P6fE");
var $gS0nt = parcelRequire("gS0nt");
var $95eAR = parcelRequire("95eAR");
var $jq8c3 = parcelRequire("jq8c3");
var $81mt8 = parcelRequire("81mt8");
var $fOYzt = parcelRequire("fOYzt");
var $dvi3b = parcelRequire("dvi3b");
var $bOZaS = parcelRequire("bOZaS");
var $hH6Lc = parcelRequire("hH6Lc");
var $hpOLz = parcelRequire("hpOLz");
var $50cui = parcelRequire("50cui");
var $a6fzQ = parcelRequire("a6fzQ");
var $kL392 = parcelRequire("kL392");
var $eQBSl = parcelRequire("eQBSl");

var $dee0n = parcelRequire("dee0n");
//#region src/boot/preStartRum.ts
function $fb772a9148f292f6$export$8f7002373dcc6602({ ignoreInitIfSyntheticsWillInjectRum: ignoreInitIfSyntheticsWillInjectRum = true, startDeflateWorker: startDeflateWorker, sdkName: sdkName }, trackingConsentState, doStartRum) {
    const bufferApiCalls = new (0, $fnvkG.BufferedObservable)(500, (count)=>{
        (0, $461Vl.addTelemetryDebug)("preStartRum buffer data lost", {
            count: count
        });
    });
    const globalContext = (0, $4B1f5.buildGlobalContextManager)();
    (0, $aAvkZ.bufferContextCalls)(globalContext, (0, $95eAR.CustomerContextKey).globalContext, bufferApiCalls);
    const userContext = (0, $7P6fE.buildUserContextManager)();
    (0, $aAvkZ.bufferContextCalls)(userContext, (0, $95eAR.CustomerContextKey).userContext, bufferApiCalls);
    const accountContext = (0, $dmc88.buildAccountContextManager)();
    (0, $aAvkZ.bufferContextCalls)(accountContext, (0, $95eAR.CustomerContextKey).accountContext, bufferApiCalls);
    let firstStartViewCall;
    let deflateWorker;
    let cachedInitConfiguration;
    let cachedConfiguration;
    let sessionManager;
    let telemetry;
    const hooks = (0, $kmm0x.createHooks)();
    const trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartRum);
    const emptyContext = {};
    let started = false;
    function tryStartRum() {
        if (started || !cachedInitConfiguration || !cachedConfiguration || !sessionManager || !telemetry) return;
        trackingConsentStateSubscription.unsubscribe();
        let initialViewOptions;
        if (cachedConfiguration.trackViewsManually) {
            if (!firstStartViewCall) return;
            initialViewOptions = firstStartViewCall.options;
        }
        const callbackToSkip = cachedConfiguration.trackViewsManually ? firstStartViewCall?.callback : void 0;
        const startRumResult = doStartRum(cachedConfiguration, sessionManager, deflateWorker, initialViewOptions, telemetry, hooks);
        started = true;
        bufferApiCalls.subscribe((callback)=>{
            if (callback !== callbackToSkip) callback(startRumResult);
        });
        bufferApiCalls.unbuffer();
    }
    function doInit(initConfiguration, errorStack, remoteConfigurationMetadata) {
        const eventBridgeAvailable = (0, $gS0nt.canUseEventBridge)();
        if (eventBridgeAvailable) initConfiguration = $fb772a9148f292f6$var$overrideInitConfigurationForBridge(initConfiguration);
        cachedInitConfiguration = initConfiguration;
        if (cachedConfiguration) {
            (0, $81mt8.displayAlreadyInitializedError)("DD_RUM", initConfiguration);
            return;
        }
        const configuration = (0, $iVgUy.validateAndBuildRumConfiguration)(initConfiguration, sdkName);
        if (!configuration || !(0, $dvi3b.isAllowedTrackingOrigins)(configuration, errorStack ?? "")) return;
        if (configuration.compressIntakeRequests && !eventBridgeAvailable && startDeflateWorker) {
            deflateWorker = startDeflateWorker(configuration, "Datadog RUM", (0, $hH6Lc.noop));
            if (!deflateWorker) return;
        }
        cachedConfiguration = configuration;
        trackingConsentState.tryToInit(configuration.trackingConsent);
        trackingConsentState.onGrantedOnce(()=>{
            const { assembleTelemetry: assembleTelemetryHook } = hooks;
            (0, $kpcu4.startTrackingConsentContext)(assembleTelemetryHook, trackingConsentState);
            telemetry = (0, $bOZaS.mockable)((0, $461Vl.startTelemetry))((0, $461Vl.TelemetryService).RUM, configuration, assembleTelemetryHook, sdkName);
            if (0, $c2Qhr.isWorkerEnvironment) {
                (0, $jq8c3.display).warn("The RUM SDK is not supported in a web or service worker environment.");
                return;
            }
            const onSessionManagerReady = (newSessionManager)=>{
                sessionManager = newSessionManager;
                (0, $kL392.startTelemetrySessionContext)(assembleTelemetryHook, sessionManager, {
                    application: {
                        id: configuration.applicationId
                    }
                });
                (0, $461Vl.addTelemetryConfiguration)((0, $iVgUy.serializeRumConfiguration)(initConfiguration, sdkName, remoteConfigurationMetadata));
                tryStartRum();
            };
            if ((0, $gS0nt.canUseEventBridge)()) onSessionManagerReady((0, $a6fzQ.startSessionManagerStub)());
            else (0, $bOZaS.mockable)((0, $a6fzQ.startSessionManager))(configuration, trackingConsentState).then((newSessionManager)=>{
                if (newSessionManager) onSessionManagerReady(newSessionManager);
            }).catch((0, $dee0n.monitorError));
        });
    }
    const addOperationStepVital = (name, stepType, options, failureReason)=>{
        bufferApiCalls.notify((startRumResult)=>startRumResult.addOperationStepVital((0, $hpOLz.sanitize)(name), stepType, (0, $hpOLz.sanitize)(options), (0, $hpOLz.sanitize)(failureReason)));
    };
    return {
        init (initConfiguration, publicApi, errorStack) {
            if (!initConfiguration) {
                (0, $jq8c3.display).error("Missing configuration");
                return;
            }
            (0, $fOYzt.initFeatureFlags)(initConfiguration.enableExperimentalFeatures);
            (0, $50cui.setAllowUntrustedEvents)(initConfiguration.allowUntrustedEvents);
            cachedInitConfiguration = initConfiguration;
            if (ignoreInitIfSyntheticsWillInjectRum && (0, $eQBSl.willSyntheticsInjectRum)()) return;
            const shouldContinue = (0, $kKNA5.callPluginsOnInit)(initConfiguration.plugins, {
                initConfiguration: initConfiguration,
                publicApi: publicApi,
                registerAssembleEventHook: hooks.assembleEvent.register
            });
            if (typeof shouldContinue === "boolean") {
                if (shouldContinue) proceedWithInit();
            } else shouldContinue.then((result)=>{
                if (result) proceedWithInit();
            }).catch((0, $dee0n.monitorError));
            function proceedWithInit() {
                if ((0, $e6c5e.getRemoteConfigurationId)(initConfiguration)) {
                    const supportedContextManagers = {
                        user: userContext,
                        context: globalContext
                    };
                    if (!!initConfiguration.remoteConfigurationId || !!initConfiguration.remoteConfiguration?.sync) (0, $e6c5e.fetchAndApplyRemoteConfiguration)(initConfiguration, supportedContextManagers).then((resolvedInitConfiguration)=>{
                        if (resolvedInitConfiguration) doInit(resolvedInitConfiguration, errorStack);
                    }).catch((0, $dee0n.monitorError));
                    else {
                        const resolvedRemoteConfiguration = (0, $e6c5e.getRemoteConfiguration)(initConfiguration, supportedContextManagers);
                        if (resolvedRemoteConfiguration) doInit(resolvedRemoteConfiguration.initConfiguration, errorStack, resolvedRemoteConfiguration.metadata);
                    }
                } else doInit(initConfiguration, errorStack);
            }
        },
        get initConfiguration () {
            return cachedInitConfiguration;
        },
        getInternalContext: (0, $hH6Lc.noop),
        stopSession: (0, $hH6Lc.noop),
        addTiming (name, time = (0, $1wrwm.timeStampNow)()) {
            bufferApiCalls.notify((startRumResult)=>startRumResult.addTiming(name, time));
        },
        setLoadingTime: (callTimestamp)=>{
            bufferApiCalls.notify((startRumResult)=>startRumResult.setLoadingTime(callTimestamp));
        },
        startView (options, startClocks = (0, $1wrwm.clocksNow)()) {
            const callback = (startRumResult)=>{
                startRumResult.startView(options, startClocks);
            };
            bufferApiCalls.notify(callback);
            if (!firstStartViewCall) {
                firstStartViewCall = {
                    options: options,
                    callback: callback
                };
                tryStartRum();
            }
        },
        setViewName (name) {
            bufferApiCalls.notify((startRumResult)=>startRumResult.setViewName(name));
        },
        setViewContext (context) {
            bufferApiCalls.notify((startRumResult)=>startRumResult.setViewContext(context));
        },
        setViewContextProperty (key, value) {
            bufferApiCalls.notify((startRumResult)=>startRumResult.setViewContextProperty(key, value));
        },
        getViewContext: ()=>emptyContext,
        globalContext: globalContext,
        userContext: userContext,
        accountContext: accountContext,
        addAction (action) {
            bufferApiCalls.notify((startRumResult)=>startRumResult.addAction(action));
        },
        startAction (name, options) {
            const startClocks = (0, $1wrwm.clocksNow)();
            bufferApiCalls.notify((startRumResult)=>startRumResult.startAction(name, options, startClocks));
        },
        stopAction (name, options) {
            const stopClocks = (0, $1wrwm.clocksNow)();
            bufferApiCalls.notify((startRumResult)=>startRumResult.stopAction(name, options, stopClocks));
        },
        startResource (url, options) {
            const startClocks = (0, $1wrwm.clocksNow)();
            bufferApiCalls.notify((startRumResult)=>startRumResult.startResource(url, options, startClocks));
        },
        stopResource (url, options) {
            const stopClocks = (0, $1wrwm.clocksNow)();
            bufferApiCalls.notify((startRumResult)=>startRumResult.stopResource(url, options, stopClocks));
        },
        addError (providedError) {
            bufferApiCalls.notify((startRumResult)=>startRumResult.addError(providedError));
        },
        addFeatureFlagEvaluation (key, value) {
            bufferApiCalls.notify((startRumResult)=>startRumResult.addFeatureFlagEvaluation(key, value));
        },
        startDurationVital (name, options) {
            const startClocks = (0, $1wrwm.clocksNow)();
            bufferApiCalls.notify((startRumResult)=>startRumResult.startDurationVital(name, options, startClocks));
        },
        stopDurationVital (name, options) {
            const stopClocks = (0, $1wrwm.clocksNow)();
            bufferApiCalls.notify((startRumResult)=>startRumResult.stopDurationVital(name, options, stopClocks));
        },
        addDurationVital (vital) {
            bufferApiCalls.notify((startRumResult)=>startRumResult.addDurationVital(vital));
        },
        addOperationStepVital: addOperationStepVital
    };
}
function $fb772a9148f292f6$var$overrideInitConfigurationForBridge(initConfiguration) {
    return {
        ...initConfiguration,
        service: initConfiguration.service || initConfiguration.applicationId,
        applicationId: "00000000-aaaa-0000-aaaa-000000000000",
        clientToken: "empty",
        sessionSampleRate: 100,
        defaultPrivacyLevel: initConfiguration.defaultPrivacyLevel ?? (0, $gS0nt.getEventBridge)()?.getPrivacyLevel()
    };
}

});
parcelRegister("kpcu4", function(module, exports) {

$parcel$export(module.exports, "startTrackingConsentContext", function () { return $10ae751f70233c2d$export$43dc707f6931474b; });

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/contexts/trackingConsentContext.ts
function $10ae751f70233c2d$export$43dc707f6931474b(assembleTelemetryHook, trackingConsentState) {
    assembleTelemetryHook.register(()=>{
        if (!trackingConsentState.isGranted()) return 0, $fNtjE.DISCARDED;
        return 0, $fNtjE.SKIPPED;
    });
}

});

parcelRegister("aAvkZ", function(module, exports) {

$parcel$export(module.exports, "defineContextMethod", function () { return $84ec1d7ca51c055a$export$288575403fa2adbb; });
$parcel$export(module.exports, "bufferContextCalls", function () { return $84ec1d7ca51c055a$export$3adfc94c48fc5c98; });

var $461Vl = parcelRequire("461Vl");

var $dee0n = parcelRequire("dee0n");
//#region src/domain/context/defineContextMethod.ts
function $84ec1d7ca51c055a$export$288575403fa2adbb(getStrategy, contextName, methodName, usage) {
    return (0, $dee0n.monitor)((...args)=>{
        if (usage) (0, $461Vl.addTelemetryUsage)({
            feature: usage
        });
        return getStrategy()[contextName][methodName](...args);
    });
}
function $84ec1d7ca51c055a$export$3adfc94c48fc5c98(preStartContextManager, name, bufferApiCalls) {
    preStartContextManager.changeObservable.subscribe(()=>{
        const context = preStartContextManager.getContext();
        bufferApiCalls.notify((startResult)=>startResult[name].setContext(context));
    });
}

});

parcelRegister("95eAR", function(module, exports) {

$parcel$export(module.exports, "CustomerContextKey", function () { return $f1d60504a9fd8213$export$a18622daaa394f17; });
$parcel$export(module.exports, "ContextManagerMethod", function () { return $f1d60504a9fd8213$export$cb7fa5be07ff81f4; });
//#region src/domain/context/contextConstants.ts
let $f1d60504a9fd8213$export$aea5bedbe53acc02 = /* @__PURE__ */ function(CustomerDataType) {
    CustomerDataType[CustomerDataType["FeatureFlag"] = 0] = "FeatureFlag";
    CustomerDataType[CustomerDataType["User"] = 1] = "User";
    CustomerDataType[CustomerDataType["GlobalContext"] = 2] = "GlobalContext";
    CustomerDataType[CustomerDataType["View"] = 3] = "View";
    CustomerDataType[CustomerDataType["Account"] = 4] = "Account";
    return CustomerDataType;
}({});
const $f1d60504a9fd8213$export$a18622daaa394f17 = {
    userContext: "userContext",
    globalContext: "globalContext",
    accountContext: "accountContext"
};
const $f1d60504a9fd8213$export$cb7fa5be07ff81f4 = {
    getContext: "getContext",
    setContext: "setContext",
    setContextProperty: "setContextProperty",
    removeContextProperty: "removeContextProperty",
    clearContext: "clearContext"
};

});

parcelRegister("81mt8", function(module, exports) {

$parcel$export(module.exports, "displayAlreadyInitializedError", function () { return $67a753d8909b1e21$export$b25c854130ebaef9; });

var $jq8c3 = parcelRequire("jq8c3");
//#region src/boot/displayAlreadyInitializedError.ts
function $67a753d8909b1e21$export$b25c854130ebaef9(sdkName, initConfiguration) {
    if (!initConfiguration.silentMultipleInit) (0, $jq8c3.display).error(`${sdkName} is already initialized.`);
}

});

parcelRegister("dvi3b", function(module, exports) {

$parcel$export(module.exports, "isAllowedTrackingOrigins", function () { return $4c92de67a8cd937d$export$535fd1118e4d98ab; });

var $jq8c3 = parcelRequire("jq8c3");

var $jM84O = parcelRequire("jM84O");

var $bOZaS = parcelRequire("bOZaS");

var $7c5B5 = parcelRequire("7c5B5");

var $c2Qhr = parcelRequire("c2Qhr");
//#region src/domain/allowedTrackingOrigins.ts
const $4c92de67a8cd937d$export$58a2d2910fbd692f = "Running the Browser SDK in a Web extension content script is forbidden unless the `allowedTrackingOrigins` option is provided.";
const $4c92de67a8cd937d$export$ee1c7410b08fb439 = "SDK initialized on a non-allowed domain.";
function $4c92de67a8cd937d$export$535fd1118e4d98ab(configuration, errorStack) {
    const location = (0, $bOZaS.mockable)((0, $c2Qhr.globalObject).location);
    const windowOrigin = location ? location.origin : "";
    const allowedTrackingOrigins = configuration.allowedTrackingOrigins;
    if (!allowedTrackingOrigins) {
        if ((0, $7c5B5.isUnsupportedExtensionEnvironment)(windowOrigin, errorStack)) {
            (0, $jq8c3.display).error($4c92de67a8cd937d$export$58a2d2910fbd692f);
            return false;
        }
        return true;
    }
    const isAllowed = (0, $jM84O.matchList)(allowedTrackingOrigins, windowOrigin);
    if (!isAllowed) (0, $jq8c3.display).error($4c92de67a8cd937d$export$ee1c7410b08fb439);
    return isAllowed;
}

});
parcelRegister("7c5B5", function(module, exports) {

$parcel$export(module.exports, "isUnsupportedExtensionEnvironment", function () { return $b912143ad8be97fb$export$2234becf7269aa18; });
//#region src/domain/extension/extensionUtils.ts
const $b912143ad8be97fb$export$145fc3a465813f29 = [
    "chrome-extension://",
    "moz-extension://"
];
function $b912143ad8be97fb$export$5e93b7e8021af3c3(str) {
    return $b912143ad8be97fb$export$145fc3a465813f29.some((prefix)=>str.includes(prefix));
}
/**
* Utility function to detect if the SDK is being initialized in an unsupported browser extension environment.
*
* @param windowLocation - The current window location to check
* @param stack - The error stack to check for extension URLs
* @returns true if running in an unsupported browser extension environment
*/ function $b912143ad8be97fb$export$2234becf7269aa18(windowLocation, stack = "") {
    if ($b912143ad8be97fb$export$5e93b7e8021af3c3(windowLocation)) return false;
    return $b912143ad8be97fb$export$5e93b7e8021af3c3(stack.split("\n").filter((line)=>{
        const trimmedLine = line.trim();
        return trimmedLine.length && /^at\s+|@/.test(trimmedLine);
    })[1] || "");
}

});


parcelRegister("a6fzQ", function(module, exports) {

$parcel$export(module.exports, "startSessionManager", function () { return $f548b6bdbb835ce4$export$3b6b9a4f35a367c5; });
$parcel$export(module.exports, "startSessionManagerStub", function () { return $f548b6bdbb835ce4$export$bb34b88612f5eec2; });

var $fnvkG = parcelRequire("fnvkG");

var $bWkrj = parcelRequire("bWkrj");

var $jq8c3 = parcelRequire("jq8c3");

var $bOZaS = parcelRequire("bOZaS");

var $foX5P = parcelRequire("foX5P");

var $hH6Lc = parcelRequire("hH6Lc");

var $50cui = parcelRequire("50cui");

var $461Vl = parcelRequire("461Vl");

var $boqsR = parcelRequire("boqsR");

var $i1EVG = parcelRequire("i1EVG");

var $aOG5f = parcelRequire("aOG5f");

var $d53qY = parcelRequire("d53qY");

var $c2Qhr = parcelRequire("c2Qhr");

var $dee0n = parcelRequire("dee0n");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/session/sessionManager.ts
const $f548b6bdbb835ce4$export$3d1fb0c94cce8478 = (0, $1wrwm.ONE_MINUTE);
const $f548b6bdbb835ce4$export$f38e803ceb7cc395 = 1e3;
const $f548b6bdbb835ce4$export$288230643bc48d91 = (0, $1wrwm.ONE_HOUR) * 12;
let $f548b6bdbb835ce4$var$stopCallbacks = [];
async function $f548b6bdbb835ce4$export$3b6b9a4f35a367c5(configuration, trackingConsentState) {
    const startTime = (0, $1wrwm.relativeNow)();
    const renewObservable = new (0, $fnvkG.Observable)();
    const expireObservable = new (0, $fnvkG.Observable)();
    const sessionStoreStrategyType = await (0, $bOZaS.mockable)((0, $d53qY.selectSessionStoreStrategyType))(configuration);
    if (!sessionStoreStrategyType) {
        (0, $jq8c3.display).warn("No storage available for session. We will not send any data.");
        return;
    }
    const strategy = (0, $bOZaS.mockable)((0, $d53qY.getSessionStoreStrategy))(sessionStoreStrategyType, configuration);
    const sessionContextHistory = (0, $boqsR.createValueHistory)({
        maxEntries: $f548b6bdbb835ce4$export$f38e803ceb7cc395
    });
    $f548b6bdbb835ce4$var$stopCallbacks.push(()=>sessionContextHistory.stop());
    let sessionExpired = false;
    const { throttled: throttledExpandOrRenew, cancel: cancelExpandOrRenew } = (0, $hH6Lc.throttle)(()=>{
        sessionExpired = false;
        strategy.setSessionState((state)=>(0, $aOG5f.expandOrRenew)(state, configuration), "expandOrRenewOnActivity").catch((0, $dee0n.monitorError));
    }, (0, $1wrwm.ONE_SECOND));
    $f548b6bdbb835ce4$var$stopCallbacks.push(cancelExpandOrRenew);
    let expirationTimeoutId;
    $f548b6bdbb835ce4$var$stopCallbacks.push(()=>(0, $foX5P.clearTimeout)(expirationTimeoutId));
    let stopped = false;
    $f548b6bdbb835ce4$var$stopCallbacks.push(()=>{
        stopped = true;
    });
    let initialState = await resolveInitialState().catch((error)=>(0, $dee0n.monitorError)(/* @__PURE__ */ new Error(`Error while resolving initial session state: ${error}`)));
    if (!initialState || stopped) return;
    while(!trackingConsentState.isGranted()){
        expire();
        await new Promise((resolve)=>trackingConsentState.onGrantedOnce(resolve));
        if (stopped) return;
        initialState = await resolveInitialState().catch((0, $dee0n.monitorError));
        if (!initialState || stopped) return;
    }
    sessionContextHistory.add(buildSessionContext(initialState), (0, $1wrwm.clocksOrigin)().relative);
    scheduleExpirationTimeout(initialState);
    subscribeToSessionChanges();
    setupSessionTracking();
    (0, $461Vl.addTelemetryMetrics)("Session manager init metrics", {
        metrics: {
            duration: (0, $1wrwm.elapsed)(startTime, (0, $1wrwm.relativeNow)())
        }
    });
    return buildSessionManager();
    async function resolveInitialState() {
        let state = {};
        await strategy.setSessionState((currentState)=>{
            const initialState = (0, $aOG5f.initializeSession)(currentState, configuration);
            state = (0, $aOG5f.expandOrRenew)(initialState, configuration);
            return state;
        }, "initialize");
        return state;
    }
    function subscribeToSessionChanges() {
        const subscription = strategy.sessionObservable.subscribe((sessionState)=>{
            scheduleExpirationTimeout(sessionState);
            handleStateChange(sessionState);
        });
        $f548b6bdbb835ce4$var$stopCallbacks.push(()=>subscription.unsubscribe());
    }
    function scheduleExpirationTimeout(state) {
        (0, $foX5P.clearTimeout)(expirationTimeoutId);
        const expireDate = (0, $aOG5f.getExpireDate)(state);
        if (expireDate) {
            const delay = expireDate - (0, $1wrwm.dateNow)();
            expirationTimeoutId = (0, $foX5P.setTimeout)(()=>{
                strategy.setSessionState((state)=>{
                    if ((0, $aOG5f.isSessionInExpiredState)(state)) {
                        if (!trackingConsentState.isGranted()) delete state.anonymousId;
                        return (0, $aOG5f.getExpiredSessionState)(state, configuration);
                    }
                    return state;
                }, "expireOnTimeout").catch((0, $dee0n.monitorError));
            }, delay);
        }
    }
    function setupSessionTracking() {
        trackingConsentState.observable.subscribe(()=>{
            if (trackingConsentState.isGranted()) {
                sessionExpired = false;
                strategy.setSessionState((state)=>(0, $aOG5f.expandOrRenew)(state, configuration), "expandOrRenewOnConsent").catch((0, $dee0n.monitorError));
            } else expire();
        });
        if (!(0, $c2Qhr.isWorkerEnvironment)) {
            $f548b6bdbb835ce4$var$trackActivity(()=>{
                if (trackingConsentState.isGranted()) throttledExpandOrRenew();
            });
            $f548b6bdbb835ce4$var$trackVisibility(()=>{
                if (!sessionExpired) strategy.setSessionState((state)=>(0, $aOG5f.expandOnly)(state), "expandOnVisibility").catch((0, $dee0n.monitorError));
            });
            $f548b6bdbb835ce4$var$trackResume(()=>{
                strategy.setSessionState((state)=>(0, $aOG5f.initializeSession)(state, configuration), "initializeOnResume").catch((0, $dee0n.monitorError));
            });
        }
    }
    function buildSessionManager() {
        return {
            findSession: (startTime, options)=>sessionContextHistory.find(startTime, options),
            findTrackedSession: (startTime, { returnInactive: returnInactive = false, maxAge: maxAge = $f548b6bdbb835ce4$export$288230643bc48d91 } = {})=>{
                const session = sessionContextHistory.find(startTime, {
                    returnInactive: returnInactive
                });
                if (!session || session.id === "invalid" || !(0, $i1EVG.isSampled)(session.id, configuration.sessionSampleRate)) return;
                if ((0, $1wrwm.dateNow)() - session.createdAt > maxAge) return;
                return session;
            },
            renewObservable: renewObservable,
            expireObservable: expireObservable,
            expire: expire,
            updateSessionState: (partialState)=>{
                strategy.setSessionState((state)=>({
                        ...state,
                        ...partialState
                    }), "updateState").catch((0, $dee0n.monitorError));
            }
        };
    }
    function handleStateChange(newState) {
        const previousSession = sessionContextHistory.find();
        const hadSession = previousSession?.id !== void 0;
        const hasSession = newState.id !== void 0;
        const sessionIdChanged = hadSession && hasSession && previousSession.id !== newState.id;
        if (hadSession && (!hasSession || sessionIdChanged)) {
            sessionExpired = true;
            expireObservable.notify();
            sessionContextHistory.closeActive((0, $1wrwm.relativeNow)());
        }
        if (hasSession && (!hadSession || sessionIdChanged)) {
            if (sessionExpired) return;
            sessionContextHistory.add(buildSessionContext(newState), (0, $1wrwm.relativeNow)());
            renewObservable.notify();
        } else if (hadSession && hasSession && !sessionIdChanged) previousSession.isReplayForced = !!newState.forcedReplay;
    }
    function expire() {
        cancelExpandOrRenew();
        const expiredState = (0, $aOG5f.getExpiredSessionState)(sessionContextHistory.find(), configuration);
        if (!trackingConsentState.isGranted()) delete expiredState.anonymousId;
        handleStateChange(expiredState);
        strategy.setSessionState((state)=>{
            if (!trackingConsentState.isGranted()) delete state.anonymousId;
            return (0, $aOG5f.getExpiredSessionState)(state, configuration);
        }, "expire").catch((0, $dee0n.monitorError));
    }
    function buildSessionContext(sessionState) {
        const createdAt = (0, $aOG5f.getCreatedDate)(sessionState) ?? (0, $1wrwm.timeStampNow)();
        if (!sessionState.id) return {
            id: "invalid",
            isReplayForced: false,
            anonymousId: void 0,
            createdAt: createdAt
        };
        return {
            id: sessionState.id,
            isReplayForced: !!sessionState.forcedReplay,
            anonymousId: sessionState.anonymousId,
            createdAt: createdAt
        };
    }
}
function $f548b6bdbb835ce4$export$bb34b88612f5eec2() {
    let sessionContext = {
        id: (0, $bWkrj.generateUUID)(),
        isReplayForced: false,
        anonymousId: void 0,
        createdAt: (0, $1wrwm.timeStampNow)()
    };
    return {
        findSession: ()=>sessionContext,
        findTrackedSession: ()=>sessionContext,
        renewObservable: new (0, $fnvkG.Observable)(),
        expireObservable: new (0, $fnvkG.Observable)(),
        expire: (0, $hH6Lc.noop),
        updateSessionState: (state)=>{
            sessionContext = {
                ...sessionContext,
                ...state
            };
        }
    };
}
function $f548b6bdbb835ce4$export$c08596f6814fce4f() {
    $f548b6bdbb835ce4$var$stopCallbacks.forEach((e)=>e());
    $f548b6bdbb835ce4$var$stopCallbacks = [];
}
function $f548b6bdbb835ce4$var$trackActivity(expandOrRenewSession) {
    const { stop: stop } = (0, $50cui.addEventListeners)(window, [
        "click",
        "touchstart",
        "keydown",
        "scroll"
    ], expandOrRenewSession, {
        capture: true,
        passive: true
    });
    $f548b6bdbb835ce4$var$stopCallbacks.push(stop);
}
function $f548b6bdbb835ce4$var$trackVisibility(expandSession) {
    const expandSessionWhenVisible = ()=>{
        if (document.visibilityState === "visible") expandSession();
    };
    const { stop: stop } = (0, $50cui.addEventListener)(document, "visibilitychange", expandSessionWhenVisible);
    $f548b6bdbb835ce4$var$stopCallbacks.push(stop);
    const visibilityCheckInterval = (0, $foX5P.setInterval)(expandSessionWhenVisible, $f548b6bdbb835ce4$export$3d1fb0c94cce8478);
    $f548b6bdbb835ce4$var$stopCallbacks.push(()=>{
        (0, $foX5P.clearInterval)(visibilityCheckInterval);
    });
}
function $f548b6bdbb835ce4$var$trackResume(cb) {
    const { stop: stop } = (0, $50cui.addEventListener)(window, "resume", cb, {
        capture: true
    });
    $f548b6bdbb835ce4$var$stopCallbacks.push(stop);
}

});
parcelRegister("aOG5f", function(module, exports) {

$parcel$export(module.exports, "getCreatedDate", function () { return $80010b34a30289b4$export$1028703a6dee32c7; });
$parcel$export(module.exports, "getExpireDate", function () { return $80010b34a30289b4$export$b7783dd9a7768792; });
$parcel$export(module.exports, "getExpiredSessionState", function () { return $80010b34a30289b4$export$551e7155381c0fd; });
$parcel$export(module.exports, "isSessionInNotStartedState", function () { return $80010b34a30289b4$export$5ad8724e83865c4; });
$parcel$export(module.exports, "isSessionInExpiredState", function () { return $80010b34a30289b4$export$7b5aaa833707368f; });
$parcel$export(module.exports, "toSessionString", function () { return $80010b34a30289b4$export$df489f56daf61eef; });
$parcel$export(module.exports, "toSessionState", function () { return $80010b34a30289b4$export$fa3c08092be8a0e4; });
$parcel$export(module.exports, "initializeSession", function () { return $80010b34a30289b4$export$7fcb3638cd59ac57; });
$parcel$export(module.exports, "expandOrRenew", function () { return $80010b34a30289b4$export$d749371b6b62473f; });
$parcel$export(module.exports, "expandOnly", function () { return $80010b34a30289b4$export$90fb9d5a14b92c4b; });

var $bWkrj = parcelRequire("bWkrj");

var $brKlt = parcelRequire("brKlt");

var $2faqW = parcelRequire("2faqW");

var $aWbFv = parcelRequire("aWbFv");

var $erdsp = parcelRequire("erdsp");

var $1wrwm = parcelRequire("1wrwm");
function $80010b34a30289b4$export$1028703a6dee32c7(state) {
    return state.created ? Number(state.created) : void 0;
}
function $80010b34a30289b4$export$b7783dd9a7768792(state) {
    const expireDate = state.expire && Number(state.expire);
    const createdDate = $80010b34a30289b4$export$1028703a6dee32c7(state);
    if (expireDate && createdDate) return Math.min(expireDate, createdDate + (0, $aWbFv.SESSION_TIME_OUT_DELAY));
}
function $80010b34a30289b4$export$551e7155381c0fd(previousSessionState, configuration) {
    const expiredSessionState = {
        isExpired: "1"
    };
    if (configuration.trackAnonymousUser && previousSessionState?.anonymousId) expiredSessionState.anonymousId = previousSessionState?.anonymousId;
    return expiredSessionState;
}
function $80010b34a30289b4$export$5ad8724e83865c4(session) {
    return (0, $brKlt.isEmptyObject)(session);
}
function $80010b34a30289b4$export$7b5aaa833707368f(session) {
    return session.isExpired !== void 0 || !$80010b34a30289b4$var$isActiveSession(session);
}
function $80010b34a30289b4$var$isActiveSession(sessionState) {
    const expireDate = $80010b34a30289b4$export$b7783dd9a7768792(sessionState);
    return expireDate ? (0, $1wrwm.dateNow)() < expireDate : false;
}
function $80010b34a30289b4$export$112e1a1467f7ca28(session) {
    session.expire = String((0, $1wrwm.dateNow)() + (0, $aWbFv.SESSION_EXPIRATION_DELAY));
}
function $80010b34a30289b4$export$df489f56daf61eef(session) {
    return (0, $2faqW.objectEntries)(session).map(([key, value])=>key === "anonymousId" ? `aid=${value}` : `${key}=${value}`).join("&");
}
function $80010b34a30289b4$export$fa3c08092be8a0e4(sessionString) {
    const session = {};
    if ((0, $erdsp.isValidSessionString)(sessionString)) sessionString.split("&").forEach((entry)=>{
        const matches = (0, $erdsp.SESSION_ENTRY_REGEXP).exec(entry);
        if (matches !== null) {
            const [, key, value] = matches;
            if (key === "aid") session.anonymousId = value;
            else session[key] = value;
        }
    });
    return session;
}
function $80010b34a30289b4$export$7fcb3638cd59ac57(state, configuration) {
    if ($80010b34a30289b4$export$5ad8724e83865c4(state)) {
        if (configuration.trackAnonymousUser) state.anonymousId = (0, $bWkrj.generateUUID)();
        return $80010b34a30289b4$export$551e7155381c0fd(state, configuration);
    }
    return state;
}
function $80010b34a30289b4$export$d749371b6b62473f(state, configuration) {
    if ($80010b34a30289b4$export$5ad8724e83865c4(state)) return state;
    let newState = state;
    if ($80010b34a30289b4$export$7b5aaa833707368f(state)) newState = $80010b34a30289b4$export$551e7155381c0fd(state, configuration);
    if (!newState.id) {
        newState.id = (0, $bWkrj.generateUUID)();
        newState.created = String((0, $1wrwm.dateNow)());
    }
    if (configuration.trackAnonymousUser && !newState.anonymousId) newState.anonymousId = (0, $bWkrj.generateUUID)();
    delete newState.isExpired;
    $80010b34a30289b4$export$112e1a1467f7ca28(newState);
    return newState;
}
function $80010b34a30289b4$export$90fb9d5a14b92c4b(state) {
    if ($80010b34a30289b4$export$7b5aaa833707368f(state) || $80010b34a30289b4$export$5ad8724e83865c4(state) || !state.id) return state;
    $80010b34a30289b4$export$112e1a1467f7ca28(state);
    return state;
}

});
parcelRegister("erdsp", function(module, exports) {

$parcel$export(module.exports, "SESSION_ENTRY_REGEXP", function () { return $1d4dd984f02f2d7a$export$d79faf935ae6abec; });
$parcel$export(module.exports, "isValidSessionString", function () { return $1d4dd984f02f2d7a$export$1a6351cc7f3c5cc8; });
//#region src/domain/session/sessionStateValidation.ts
const $1d4dd984f02f2d7a$export$d79faf935ae6abec = /^([a-zA-Z]+)=([a-z0-9-]+)$/;
function $1d4dd984f02f2d7a$export$1a6351cc7f3c5cc8(sessionString) {
    return !!sessionString && (sessionString.indexOf("&") !== -1 || $1d4dd984f02f2d7a$export$d79faf935ae6abec.test(sessionString));
}

});


parcelRegister("d53qY", function(module, exports) {

$parcel$export(module.exports, "selectSessionStoreStrategyType", function () { return $14b9c8a4f258a357$export$2ae22598cc9269e0; });
$parcel$export(module.exports, "getSessionStoreStrategy", function () { return $14b9c8a4f258a357$export$8a3087d371d1213d; });

var $jq8c3 = parcelRequire("jq8c3");

var $aWbFv = parcelRequire("aWbFv");

var $2QAjE = parcelRequire("2QAjE");

var $70dyu = parcelRequire("70dyu");

var $Ec7Ip = parcelRequire("Ec7Ip");

var $c2Qhr = parcelRequire("c2Qhr");
//#region src/domain/session/sessionStore.ts
/**
* Selects the correct session store strategy type based on the configuration and storage
* availability. When an array is provided, tries each persistence type in order until one
* successfully initializes.
*/ async function $14b9c8a4f258a357$export$2ae22598cc9269e0(configuration) {
    const persistenceList = $14b9c8a4f258a357$var$normalizePersistenceList(configuration.sessionPersistence);
    for (const persistence of persistenceList){
        const strategyType = await $14b9c8a4f258a357$var$selectStrategyForPersistence(persistence, configuration);
        if (strategyType !== void 0) return strategyType;
    }
}
function $14b9c8a4f258a357$var$normalizePersistenceList(sessionPersistence) {
    if (sessionPersistence !== void 0) return sessionPersistence;
    if (0, $c2Qhr.isWorkerEnvironment) return [
        (0, $aWbFv.SessionPersistence).MEMORY
    ];
    return [
        (0, $aWbFv.SessionPersistence).COOKIE
    ];
}
function $14b9c8a4f258a357$var$selectStrategyForPersistence(persistence, configuration) {
    switch(persistence){
        case (0, $aWbFv.SessionPersistence).COOKIE:
            return (0, $2QAjE.selectCookieStrategy)(configuration);
        case (0, $aWbFv.SessionPersistence).LOCAL_STORAGE:
            return (0, $70dyu.selectLocalStorageStrategy)();
        case (0, $aWbFv.SessionPersistence).MEMORY:
            return (0, $Ec7Ip.selectMemorySessionStoreStrategy)();
        default:
            (0, $jq8c3.display).error(`Invalid session persistence '${String(persistence)}'`);
            return;
    }
}
function $14b9c8a4f258a357$export$8a3087d371d1213d(sessionStoreStrategyType, configuration) {
    switch(sessionStoreStrategyType.type){
        case (0, $aWbFv.SessionPersistence).COOKIE:
            return (0, $2QAjE.initCookieStrategy)(sessionStoreStrategyType, configuration);
        case (0, $aWbFv.SessionPersistence).LOCAL_STORAGE:
            return (0, $70dyu.initLocalStorageStrategy)();
        case (0, $aWbFv.SessionPersistence).MEMORY:
            return (0, $Ec7Ip.initMemorySessionStoreStrategy)();
    }
}

});
parcelRegister("2QAjE", function(module, exports) {

$parcel$export(module.exports, "selectCookieStrategy", function () { return $3006e3a869043b99$export$88fc2ec23ae4ccfd; });
$parcel$export(module.exports, "initCookieStrategy", function () { return $3006e3a869043b99$export$96a0082cb9ded337; });

var $fnvkG = parcelRequire("fnvkG");

var $aZWin = parcelRequire("aZWin");

var $bOZaS = parcelRequire("bOZaS");

var $brKlt = parcelRequire("brKlt");

var $aWbFv = parcelRequire("aWbFv");

var $aOG5f = parcelRequire("aOG5f");

var $frs82 = parcelRequire("frs82");

var $7cKdv = parcelRequire("7cKdv");

var $dee0n = parcelRequire("dee0n");
//#region src/domain/session/storeStrategies/sessionInCookie.ts
async function $3006e3a869043b99$export$88fc2ec23ae4ccfd(configuration) {
    const cookieOptions = (0, $aZWin.buildCookieOptions)(configuration);
    if (!cookieOptions) return;
    if ((0, $frs82.isCookieStoreSupported)() && await (0, $frs82.areCookiesAuthorized)((0, $frs82.createCookieStoreAccess), cookieOptions)) return {
        type: (0, $aWbFv.SessionPersistence).COOKIE,
        cookieOptions: cookieOptions,
        cookieApi: 1
    };
    if (await (0, $frs82.areCookiesAuthorized)((0, $frs82.createDocumentCookieAccess), cookieOptions)) return {
        type: (0, $aWbFv.SessionPersistence).COOKIE,
        cookieOptions: cookieOptions,
        cookieApi: 0
    };
}
let $3006e3a869043b99$var$pendingChain;
function $3006e3a869043b99$export$96a0082cb9ded337(sessionStoreStrategyType, configuration) {
    const { cookieOptions: cookieOptions, cookieApi: cookieApi } = sessionStoreStrategyType;
    const sessionObservable = new (0, $fnvkG.Observable)();
    const trackAnonymousUser = !!configuration.trackAnonymousUser;
    const opts = $3006e3a869043b99$var$encodeCookieOptions(cookieOptions);
    const cookieAccess = (0, $bOZaS.mockable)($3006e3a869043b99$export$5d3c054582d2abcd)(cookieApi, cookieOptions);
    let isFirstCall = true;
    cookieAccess.observable.subscribe(()=>{
        cookieAccess.getAll().then((cookieValues)=>{
            sessionObservable.notify($3006e3a869043b99$var$findMatchingSessionState(cookieValues, opts));
        }).catch((error)=>(0, $dee0n.monitorError)(/* @__PURE__ */ new Error(`Error while reading session cookies on change: ${error}`)));
    });
    function applyAndWrite(fn) {
        return cookieAccess.getAllAndSet((cookieValues)=>{
            let currentState = $3006e3a869043b99$var$findMatchingSessionState(cookieValues, opts);
            if (isFirstCall && (0, $brKlt.isEmptyObject)(currentState)) currentState = $3006e3a869043b99$var$findMatchingSessionState((0, $aZWin.getCookies)((0, $7cKdv.LEGACY_SESSION_STORE_KEY)), opts);
            isFirstCall = false;
            return {
                value: $3006e3a869043b99$var$buildSessionString(fn(currentState), cookieOptions),
                expireDelay: trackAnonymousUser ? (0, $aWbFv.SESSION_COOKIE_EXPIRATION_DELAY) : (0, $aWbFv.SESSION_TIME_OUT_DELAY)
            };
        });
    }
    return {
        async setSessionState (fn, _operation) {
            if (typeof navigator !== "undefined" && navigator.locks) await navigator.locks.request((0, $7cKdv.SESSION_STORE_KEY), ()=>applyAndWrite(fn)).catch((error)=>{
                if ($3006e3a869043b99$var$isContextGoingAwayError(error)) return;
                throw error;
            });
            else {
                $3006e3a869043b99$var$pendingChain = ($3006e3a869043b99$var$pendingChain ?? Promise.resolve()).then(()=>applyAndWrite(fn));
                await $3006e3a869043b99$var$pendingChain;
            }
        },
        sessionObservable: sessionObservable
    };
}
function $3006e3a869043b99$var$isContextGoingAwayError(error) {
    if (!(error instanceof Error)) return false;
    return error.name === "AbortError" || error.message.includes("no longer runnable") || error.message.includes("Responsible document is not fully active") || error.message.includes("The document is not active");
}
function $3006e3a869043b99$export$5d3c054582d2abcd(cookieApi, cookieOptions) {
    return cookieApi === 1 ? (0, $frs82.createCookieStoreAccess)((0, $7cKdv.SESSION_STORE_KEY), cookieOptions) : (0, $frs82.createDocumentCookieAccess)((0, $7cKdv.SESSION_STORE_KEY), cookieOptions);
}
function $3006e3a869043b99$var$findMatchingSessionState(items, opts) {
    let sessionState;
    for (const item of items.slice().reverse()){
        sessionState = (0, $aOG5f.toSessionState)(item);
        if (sessionState.c === opts) break;
    }
    delete sessionState?.c;
    return sessionState ?? {};
}
function $3006e3a869043b99$var$buildSessionString(sessionState, cookieOptions) {
    return (0, $aOG5f.toSessionString)((0, $brKlt.isEmptyObject)(sessionState) ? sessionState : {
        ...sessionState,
        c: $3006e3a869043b99$var$encodeCookieOptions(cookieOptions)
    });
}
function $3006e3a869043b99$var$encodeCookieOptions(cookieOptions) {
    const domainCount = cookieOptions.domain ? cookieOptions.domain.split(".").length - 1 : 0;
    let byte = 0;
    byte |= 0;
    byte |= domainCount << 1;
    byte |= cookieOptions.crossSite ? 1 : 0;
    return byte.toString(16);
}

});
parcelRegister("7cKdv", function(module, exports) {

$parcel$export(module.exports, "SESSION_STORE_KEY", function () { return $715ae9889ef0b3b6$export$dce9f2ddeb0efe71; });
$parcel$export(module.exports, "LEGACY_SESSION_STORE_KEY", function () { return $715ae9889ef0b3b6$export$ded329255691036f; });
//#region src/domain/session/storeStrategies/sessionStoreStrategy.ts
const $715ae9889ef0b3b6$export$dce9f2ddeb0efe71 = "_dd_s_v2";
const $715ae9889ef0b3b6$export$ded329255691036f = "_dd_s";

});


parcelRegister("70dyu", function(module, exports) {

$parcel$export(module.exports, "selectLocalStorageStrategy", function () { return $8d055cbd2725ded4$export$4d20c6f83e85c567; });
$parcel$export(module.exports, "initLocalStorageStrategy", function () { return $8d055cbd2725ded4$export$f96a432ca80663c2; });

var $fnvkG = parcelRequire("fnvkG");

var $bWkrj = parcelRequire("bWkrj");

var $50cui = parcelRequire("50cui");

var $aWbFv = parcelRequire("aWbFv");

var $aOG5f = parcelRequire("aOG5f");

var $7cKdv = parcelRequire("7cKdv");
//#region src/domain/session/storeStrategies/sessionInLocalStorage.ts
const $8d055cbd2725ded4$var$LOCAL_STORAGE_TEST_KEY = "_dd_test_";
function $8d055cbd2725ded4$export$4d20c6f83e85c567() {
    try {
        const id = (0, $bWkrj.generateUUID)();
        const testKey = `${$8d055cbd2725ded4$var$LOCAL_STORAGE_TEST_KEY}${id}`;
        localStorage.setItem(testKey, id);
        const retrievedId = localStorage.getItem(testKey);
        localStorage.removeItem(testKey);
        return id === retrievedId ? {
            type: (0, $aWbFv.SessionPersistence).LOCAL_STORAGE
        } : void 0;
    } catch  {
        return;
    }
}
function $8d055cbd2725ded4$export$f96a432ca80663c2() {
    const sessionObservable = new (0, $fnvkG.Observable)((observable)=>(0, $50cui.addEventListener)(window, "storage", (event)=>{
            if (event.key === "_dd_s_v2" && event.storageArea === localStorage) observable.notify((0, $aOG5f.toSessionState)(event.newValue));
        }).stop);
    let isFirstCall = true;
    return {
        async setSessionState (fn, _operation) {
            let currentState = (0, $aOG5f.toSessionState)(localStorage.getItem((0, $7cKdv.SESSION_STORE_KEY)));
            if (isFirstCall && (0, $aOG5f.isSessionInNotStartedState)(currentState)) currentState = (0, $aOG5f.toSessionState)(localStorage.getItem((0, $7cKdv.LEGACY_SESSION_STORE_KEY)));
            isFirstCall = false;
            const newState = fn(currentState);
            localStorage.setItem((0, $7cKdv.SESSION_STORE_KEY), (0, $aOG5f.toSessionString)(newState));
            await Promise.resolve();
            sessionObservable.notify(newState);
        },
        sessionObservable: sessionObservable
    };
}

});

parcelRegister("Ec7Ip", function(module, exports) {

$parcel$export(module.exports, "selectMemorySessionStoreStrategy", function () { return $1ec67da403b53ba7$export$f88572049b46576c; });
$parcel$export(module.exports, "initMemorySessionStoreStrategy", function () { return $1ec67da403b53ba7$export$29a94e54ea429ef7; });

var $fnvkG = parcelRequire("fnvkG");

var $brKlt = parcelRequire("brKlt");

var $aWbFv = parcelRequire("aWbFv");

var $c2Qhr = parcelRequire("c2Qhr");
//#region src/domain/session/storeStrategies/sessionInMemory.ts
const $1ec67da403b53ba7$export$dbe6521780060772 = "_DD_SESSION";
function $1ec67da403b53ba7$export$f88572049b46576c() {
    return {
        type: (0, $aWbFv.SessionPersistence).MEMORY
    };
}
function $1ec67da403b53ba7$export$29a94e54ea429ef7() {
    const globalObjectWithSession = (0, $c2Qhr.globalObject);
    if (!globalObjectWithSession["_DD_SESSION"]) globalObjectWithSession[$1ec67da403b53ba7$export$dbe6521780060772] = {};
    const memorySession = globalObjectWithSession[$1ec67da403b53ba7$export$dbe6521780060772];
    const sessionObservable = new (0, $fnvkG.Observable)();
    const previousOnChange = memorySession.onChange;
    memorySession.onChange = (state)=>{
        previousOnChange?.(state);
        sessionObservable.notify(state);
    };
    return {
        async setSessionState (fn, _operation) {
            const currentState = memorySession.state ?? {};
            const newState = (0, $brKlt.shallowClone)(fn(currentState));
            memorySession.state = newState;
            await Promise.resolve();
            memorySession.onChange?.(newState);
        },
        sessionObservable: sessionObservable
    };
}

});



parcelRegister("kL392", function(module, exports) {

$parcel$export(module.exports, "startTelemetrySessionContext", function () { return $a4fd266133ba2499$export$f6f1ded37e181eb9; });

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/contexts/telemetrySessionContext.ts
function $a4fd266133ba2499$export$f6f1ded37e181eb9(assembleTelemetryHook, sessionManager, extraContext) {
    assembleTelemetryHook.register(({ startTime: startTime })=>{
        const session = sessionManager.findTrackedSession(startTime);
        if (!session) return 0, $fNtjE.SKIPPED;
        return {
            session: {
                id: session.id
            },
            anonymous_id: session.anonymousId,
            ...extraContext
        };
    });
}

});


parcelRegister("1nqsB", function(module, exports) {

$parcel$export(module.exports, "makePublicApi", function () { return $949815fc9ce3c423$export$119e7fe763fbc1d1; });
$parcel$export(module.exports, "defineGlobal", function () { return $949815fc9ce3c423$export$884b45263866f2b7; });

var $jq8c3 = parcelRequire("jq8c3");

var $4wo62 = parcelRequire("4wo62");

var $oEuYl = parcelRequire("oEuYl");
//#region src/boot/init.ts
function $949815fc9ce3c423$export$119e7fe763fbc1d1(stub) {
    const publicApi = {
        version: "7.14.0",
        onReady (callback) {
            callback();
        },
        ...stub
    };
    Object.defineProperty(publicApi, "_setDebug", {
        get () {
            return 0, $oEuYl.setDebugMode;
        },
        enumerable: false
    });
    return publicApi;
}
function $949815fc9ce3c423$export$884b45263866f2b7(global, name, api) {
    const existingGlobalVariable = global[name];
    if (existingGlobalVariable && !existingGlobalVariable.q && existingGlobalVariable.version) (0, $jq8c3.display).warn("SDK is loaded more than once. This is unsupported and might have unexpected behavior.");
    global[name] = api;
    if (existingGlobalVariable?.q) existingGlobalVariable.q.forEach((fn)=>(0, $4wo62.catchUserErrors)(fn, "onReady callback threw an error:")());
}

});


parcelRegister("j4B0M", function(module, exports) {

$parcel$export(module.exports, "getSessionReplayUrl", function () { return $f4319441ad4e86a7$export$58d09b88d0d4cf52; });

var $hWYdN = parcelRequire("hWYdN");
//#region src/domain/getSessionReplayUrl.ts
function $f4319441ad4e86a7$export$58d09b88d0d4cf52(configuration, { session: session, viewContext: viewContext, errorType: errorType }) {
    const sessionId = session ? session.id : "no-session-id";
    const parameters = [];
    if (errorType !== void 0) parameters.push(`error-type=${errorType}`);
    if (viewContext) {
        parameters.push(`seed=${viewContext.id}`);
        parameters.push(`from=${viewContext.startClocks.timeStamp}`);
    }
    return `${$f4319441ad4e86a7$export$63276db6097e2435(configuration)}${`/rum/replay/sessions/${sessionId}`}?${parameters.join("&")}`;
}
function $f4319441ad4e86a7$export$63276db6097e2435(rumConfiguration) {
    const site = rumConfiguration.site;
    const subdomain = rumConfiguration.subdomain || $f4319441ad4e86a7$var$getSiteDefaultSubdomain(rumConfiguration);
    return `https://${subdomain ? `${subdomain}.` : ""}${site}`;
}
function $f4319441ad4e86a7$var$getSiteDefaultSubdomain(configuration) {
    switch(configuration.site){
        case 0, $hWYdN.INTAKE_SITE_US1:
        case 0, $hWYdN.INTAKE_SITE_EU1:
            return "app";
        case 0, $hWYdN.INTAKE_SITE_STAGING:
            return "dd";
        default:
            return;
    }
}

});

parcelRegister("65e75", function(module, exports) {

$parcel$export(module.exports, "createFormDataTransport", function () { return $51ccdf8b8d584bb8$export$602e019c0da77727; });
parcelRequire("jNZRV");

var $1wrwm = parcelRequire("1wrwm");

var $461Vl = parcelRequire("461Vl");
var $b28LB = parcelRequire("b28LB");
var $7RJVj = parcelRequire("7RJVj");
var $gnsX5 = parcelRequire("gnsX5");
var $2faqW = parcelRequire("2faqW");

var $k8VFU = parcelRequire("k8VFU");
//#region src/transport/formDataTransport.ts
function $51ccdf8b8d584bb8$export$602e019c0da77727(configuration, lifeCycle, createEncoder, streamId) {
    const reportError = (message)=>{
        lifeCycle.notify(15, {
            error: {
                message: message,
                source: (0, $7RJVj.ErrorSource).AGENT,
                startClocks: (0, $1wrwm.clocksNow)()
            }
        });
        (0, $461Vl.addTelemetryDebug)("Error reported to customer", {
            "error.message": message
        });
    };
    const httpRequest = (0, $b28LB.createHttpRequest)([
        (0, $k8VFU.createEndpointBuilder)(configuration, "profile")
    ], reportError);
    const encoder = createEncoder(streamId);
    return {
        async send ({ event: event, ...attachments }) {
            const formData = new FormData();
            const serializedEvent = (0, $gnsX5.jsonStringify)(event);
            if (!serializedEvent) throw new Error("Failed to serialize event");
            formData.append("event", new Blob([
                serializedEvent
            ], {
                type: "application/json"
            }), "event.json");
            let bytesCount = serializedEvent.length;
            for (const [key, value] of (0, $2faqW.objectEntries)(attachments)){
                const serializedValue = (0, $gnsX5.jsonStringify)(value);
                if (!serializedValue) throw new Error("Failed to serialize attachment");
                const result = await $51ccdf8b8d584bb8$var$encode(encoder, serializedValue);
                bytesCount += result.outputBytesCount;
                formData.append(key, new Blob([
                    result.output
                ]), key);
            }
            httpRequest.send({
                data: formData,
                bytesCount: bytesCount
            });
        }
    };
}
function $51ccdf8b8d584bb8$var$encode(encoder, data) {
    return new Promise((resolve)=>{
        encoder.write(data);
        encoder.finish((encoderResult)=>{
            resolve(encoderResult);
        });
    });
}

});



parcelRegister("hMxBh", function(module, exports) {

$parcel$export(module.exports, "startRecorderInitTelemetry", function () { return $17f01102fee95bf4$export$85fe378f0447e9bb; });

var $461Vl = parcelRequire("461Vl");
var $hH6Lc = parcelRequire("hH6Lc");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/startRecorderInitTelemetry.ts
function $17f01102fee95bf4$export$85fe378f0447e9bb(telemetry, observable) {
    if (!telemetry.metricsEnabled) return {
        stop: (0, $hH6Lc.noop)
    };
    let startContext;
    let documentReadyDuration;
    let recorderSettledDuration;
    const { unsubscribe: unsubscribe } = observable.subscribe((event)=>{
        switch(event.type){
            case "start":
                startContext = {
                    forced: event.forced,
                    timestamp: (0, $1wrwm.timeStampNow)()
                };
                documentReadyDuration = void 0;
                recorderSettledDuration = void 0;
                break;
            case "document-ready":
                if (startContext) documentReadyDuration = (0, $1wrwm.elapsed)(startContext.timestamp, (0, $1wrwm.timeStampNow)());
                break;
            case "recorder-settled":
                if (startContext) recorderSettledDuration = (0, $1wrwm.elapsed)(startContext.timestamp, (0, $1wrwm.timeStampNow)());
                break;
            case "aborted":
            case "deflate-encoder-load-failed":
            case "recorder-load-failed":
            case "succeeded":
                unsubscribe();
                if (startContext) (0, $461Vl.addTelemetryMetrics)((0, $461Vl.TelemetryMetrics).RECORDER_INIT_METRICS_TELEMETRY_NAME, {
                    metrics: $17f01102fee95bf4$var$createRecorderInitMetrics(startContext.forced, recorderSettledDuration, (0, $1wrwm.elapsed)(startContext.timestamp, (0, $1wrwm.timeStampNow)()), event.type, documentReadyDuration)
                });
        }
    });
    return {
        stop: unsubscribe
    };
}
function $17f01102fee95bf4$var$createRecorderInitMetrics(forced, loadRecorderModuleDuration, recorderInitDuration, result, waitForDocReadyDuration) {
    return {
        forced: forced,
        loadRecorderModuleDuration: loadRecorderModuleDuration,
        recorderInitDuration: recorderInitDuration,
        result: result,
        waitForDocReadyDuration: waitForDocReadyDuration
    };
}

});

parcelRegister("5y9vp", function(module, exports) {

$parcel$export(module.exports, "lazyLoadRecorder", function () { return $fead11099746abea$export$789fad9c3c8f2281; });

var $caLix = parcelRequire("caLix");

var $bOZaS = parcelRequire("bOZaS");
//#region src/boot/lazyLoadRecorder.ts
async function $fead11099746abea$export$789fad9c3c8f2281() {
    try {
        return await (0, $bOZaS.mockable)($fead11099746abea$export$209e5cb48ef53c0a)();
    } catch (error) {
        (0, $caLix.reportScriptLoadingError)({
            error: error,
            source: "Recorder",
            scriptType: "module"
        });
    }
}

async function $fead11099746abea$export$209e5cb48ef53c0a() {
    return (await (parcelRequire("cYEXL"))).startRecording;
}

});
parcelRegister("cYEXL", function(module, exports) {
module.exports = $parcel$import("krmla").then(()=>parcelRequire('lQ8LV'));

});



parcelRegister("jAExM", function(module, exports) {

$parcel$export(module.exports, "createPreStartStrategy", function () { return $08f64aa939c37cf5$export$8f7002373dcc6602; });

var $hH6Lc = parcelRequire("hH6Lc");
//#region src/boot/preStartStrategy.ts
function $08f64aa939c37cf5$export$8f7002373dcc6602() {
    let status = 0;
    return {
        strategy: {
            start () {
                status = 1;
            },
            stop () {
                status = 2;
            },
            isRecording: ()=>false,
            getSessionReplayLink: (0, $hH6Lc.noop)
        },
        shouldStartImmediately (configuration) {
            return status === 1 || status === 0 && !configuration.startSessionReplayRecordingManually;
        }
    };
}

});


parcelRegister("6AfsN", function(module, exports) {

$parcel$export(module.exports, "makeProfilerApi", function () { return $53c7ed9825ee0b9a$export$4cbb20720c46956f; });

var $iO39P = parcelRequire("iO39P");

var $9riGN = parcelRequire("9riGN");

var $cuPPi = parcelRequire("cuPPi");

var $gS0nt = parcelRequire("gS0nt");
var $i1EVG = parcelRequire("i1EVG");
var $bOZaS = parcelRequire("bOZaS");

var $dee0n = parcelRequire("dee0n");
//#region src/boot/profilerApi.ts
function $53c7ed9825ee0b9a$export$4cbb20720c46956f() {
    let profiler;
    function onRumStart(lifeCycle, hooks, configuration, sessionManager, viewHistory, createEncoder) {
        const session = sessionManager.findTrackedSession();
        if (!session) return;
        if (!$53c7ed9825ee0b9a$var$isProfilingSampled(configuration, session)) return;
        const profilingContextManager = (0, $9riGN.startProfilingContext)(hooks);
        if (!(0, $bOZaS.mockable)((0, $iO39P.isProfilingSupported))()) {
            profilingContextManager.set({
                status: "error",
                error_reason: "not-supported-by-browser"
            });
            return;
        }
        (0, $bOZaS.mockable)((0, $cuPPi.lazyLoadProfiler))().then((createRumProfiler)=>{
            if (!createRumProfiler) {
                profilingContextManager.set({
                    status: "error",
                    error_reason: "failed-to-lazy-load"
                });
                return;
            }
            profiler = createRumProfiler(configuration, lifeCycle, sessionManager, profilingContextManager, createEncoder, viewHistory, void 0);
            profiler.start();
        }).catch((0, $dee0n.monitorError));
    }
    return {
        onRumStart: onRumStart,
        stop: ()=>{
            profiler?.stop();
        }
    };
}
function $53c7ed9825ee0b9a$var$isProfilingSampled(configuration, session) {
    if ((0, $gS0nt.canUseEventBridge)()) return (0, $gS0nt.bridgeSupports)((0, $gS0nt.BridgeCapability).PROFILES);
    return (0, $i1EVG.isSampled)(session.id, (0, $i1EVG.correctedChildSampleRate)(configuration.sessionSampleRate, configuration.profilingSampleRate));
}

});
parcelRegister("iO39P", function(module, exports) {

$parcel$export(module.exports, "isProfilingSupported", function () { return $410713e1c8ab8098$export$e6a61085ab61d2c1; });

var $c2Qhr = parcelRequire("c2Qhr");
//#region src/domain/profiling/profilingSupported.ts
function $410713e1c8ab8098$export$e6a61085ab61d2c1() {
    return (0, $c2Qhr.globalObject).Profiler !== void 0;
}

});

parcelRegister("9riGN", function(module, exports) {

$parcel$export(module.exports, "startProfilingContext", function () { return $8b6e86dfb9035271$export$5a7dfb6ed5bd727; });
parcelRequire("lNEHA");
var $6htpc = parcelRequire("6htpc");

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/profiling/profilingContext.ts
function $8b6e86dfb9035271$export$5a7dfb6ed5bd727(hooks) {
    let currentContext = {
        status: "starting"
    };
    hooks.assembleEventDefaults.register(({ eventType: eventType })=>{
        if (eventType !== (0, $6htpc.RumEventType).VIEW && eventType !== (0, $6htpc.RumEventType).LONG_TASK && eventType !== (0, $6htpc.RumEventType).ACTION && eventType !== (0, $6htpc.RumEventType).VITAL) return 0, $fNtjE.SKIPPED;
        return {
            type: eventType,
            _dd: {
                profiling: currentContext
            }
        };
    });
    return {
        get: ()=>currentContext,
        set: (newContext)=>{
            currentContext = newContext;
        }
    };
}

});

parcelRegister("cuPPi", function(module, exports) {

$parcel$export(module.exports, "lazyLoadProfiler", function () { return $6432284bd240a48d$export$2c07ce88fb5e9ae2; });

var $caLix = parcelRequire("caLix");

var $bOZaS = parcelRequire("bOZaS");
//#region src/boot/lazyLoadProfiler.ts
async function $6432284bd240a48d$export$2c07ce88fb5e9ae2() {
    try {
        return await (0, $bOZaS.mockable)($6432284bd240a48d$export$348922f82d1132a5)();
    } catch (error) {
        (0, $caLix.reportScriptLoadingError)({
            error: error,
            source: "Profiler",
            scriptType: "module"
        });
    }
}

async function $6432284bd240a48d$export$348922f82d1132a5() {
    return (await (parcelRequire("5WQxN"))).createRumProfiler;
}

});
parcelRegister("5WQxN", function(module, exports) {
module.exports = $parcel$import("dQHPw").then(()=>parcelRequire('46FmM'));

});




parcelRegister("9ATkq", function(module, exports) {
'use strict';
function $6fc264ec92100d3a$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6fc264ec92100d3a$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6fc264ec92100d3a$var$checkDCE();

module.exports = (parcelRequire("jpRqs"));

});
parcelRegister("jpRqs", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $e229cb5c8b2cd629$export$882461b6382ed46c; }, function (v) { return $e229cb5c8b2cd629$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e229cb5c8b2cd629$export$757ceba2d55c277e; }, function (v) { return $e229cb5c8b2cd629$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $e229cb5c8b2cd629$export$83d89fbfd8236492; }, function (v) { return $e229cb5c8b2cd629$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e229cb5c8b2cd629$export$882461b6382ed46c;
var $e229cb5c8b2cd629$export$757ceba2d55c277e;
var $e229cb5c8b2cd629$export$83d89fbfd8236492;
"use strict";

var $iqDh9 = parcelRequire("iqDh9");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");
function $e229cb5c8b2cd629$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $e229cb5c8b2cd629$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $e229cb5c8b2cd629$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $e229cb5c8b2cd629$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $e229cb5c8b2cd629$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $e229cb5c8b2cd629$var$assertIsMounted(fiber) {
    if ($e229cb5c8b2cd629$var$getNearestMountedFiber(fiber) !== fiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
}
function $e229cb5c8b2cd629$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $e229cb5c8b2cd629$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $e229cb5c8b2cd629$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $e229cb5c8b2cd629$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $e229cb5c8b2cd629$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $e229cb5c8b2cd629$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $e229cb5c8b2cd629$var$assign = Object.assign, $e229cb5c8b2cd629$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $e229cb5c8b2cd629$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $e229cb5c8b2cd629$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $e229cb5c8b2cd629$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $e229cb5c8b2cd629$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $e229cb5c8b2cd629$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $e229cb5c8b2cd629$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $e229cb5c8b2cd629$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $e229cb5c8b2cd629$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $e229cb5c8b2cd629$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $e229cb5c8b2cd629$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $e229cb5c8b2cd629$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $e229cb5c8b2cd629$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $e229cb5c8b2cd629$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$e229cb5c8b2cd629$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $e229cb5c8b2cd629$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $e229cb5c8b2cd629$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $e229cb5c8b2cd629$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $e229cb5c8b2cd629$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $e229cb5c8b2cd629$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $e229cb5c8b2cd629$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $e229cb5c8b2cd629$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $e229cb5c8b2cd629$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $e229cb5c8b2cd629$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $e229cb5c8b2cd629$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $e229cb5c8b2cd629$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $e229cb5c8b2cd629$var$getComponentNameFromType(type.type) || "Memo";
        case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $e229cb5c8b2cd629$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $e229cb5c8b2cd629$var$isArrayImpl = Array.isArray, $e229cb5c8b2cd629$var$ReactSharedInternals = $bh6RR.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $e229cb5c8b2cd629$var$ReactDOMSharedInternals = $6afFj.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $e229cb5c8b2cd629$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $e229cb5c8b2cd629$var$valueStack = [], $e229cb5c8b2cd629$var$index = -1;
function $e229cb5c8b2cd629$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $e229cb5c8b2cd629$var$pop(cursor) {
    0 > $e229cb5c8b2cd629$var$index || (cursor.current = $e229cb5c8b2cd629$var$valueStack[$e229cb5c8b2cd629$var$index], $e229cb5c8b2cd629$var$valueStack[$e229cb5c8b2cd629$var$index] = null, $e229cb5c8b2cd629$var$index--);
}
function $e229cb5c8b2cd629$var$push(cursor, value) {
    $e229cb5c8b2cd629$var$index++;
    $e229cb5c8b2cd629$var$valueStack[$e229cb5c8b2cd629$var$index] = cursor.current;
    cursor.current = value;
}
var $e229cb5c8b2cd629$var$contextStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$contextFiberStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$rootInstanceStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$hostTransitionProviderCursor = $e229cb5c8b2cd629$var$createCursor(null);
function $e229cb5c8b2cd629$var$pushHostContainer(fiber, nextRootInstance) {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$rootInstanceStackCursor, nextRootInstance);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextFiberStackCursor, fiber);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $e229cb5c8b2cd629$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $e229cb5c8b2cd629$var$getOwnHostContext(nextRootInstance), fiber = $e229cb5c8b2cd629$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextStackCursor);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextStackCursor, fiber);
}
function $e229cb5c8b2cd629$var$popHostContainer() {
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextStackCursor);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextFiberStackCursor);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$rootInstanceStackCursor);
}
function $e229cb5c8b2cd629$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$hostTransitionProviderCursor, fiber);
    var context = $e229cb5c8b2cd629$var$contextStackCursor.current;
    var JSCompiler_inline_result = $e229cb5c8b2cd629$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextFiberStackCursor, fiber), $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextStackCursor, JSCompiler_inline_result));
}
function $e229cb5c8b2cd629$var$popHostContext(fiber) {
    $e229cb5c8b2cd629$var$contextFiberStackCursor.current === fiber && ($e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextStackCursor), $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextFiberStackCursor));
    $e229cb5c8b2cd629$var$hostTransitionProviderCursor.current === fiber && ($e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$hostTransitionProviderCursor), $e229cb5c8b2cd629$var$HostTransitionContext._currentValue = $e229cb5c8b2cd629$var$sharedNotPendingObject);
}
var $e229cb5c8b2cd629$var$prefix, $e229cb5c8b2cd629$var$suffix;
function $e229cb5c8b2cd629$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $e229cb5c8b2cd629$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $e229cb5c8b2cd629$var$prefix = match && match[1] || "";
        $e229cb5c8b2cd629$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $e229cb5c8b2cd629$var$prefix + name + $e229cb5c8b2cd629$var$suffix;
}
var $e229cb5c8b2cd629$var$reentry = !1;
function $e229cb5c8b2cd629$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $e229cb5c8b2cd629$var$reentry) return "";
    $e229cb5c8b2cd629$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $e229cb5c8b2cd629$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $e229cb5c8b2cd629$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $e229cb5c8b2cd629$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("Suspense Fallback") : $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $e229cb5c8b2cd629$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $e229cb5c8b2cd629$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $e229cb5c8b2cd629$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $e229cb5c8b2cd629$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $e229cb5c8b2cd629$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $e229cb5c8b2cd629$var$hasOwnProperty = Object.prototype.hasOwnProperty, $e229cb5c8b2cd629$var$scheduleCallback$3 = $iqDh9.unstable_scheduleCallback, $e229cb5c8b2cd629$var$cancelCallback$1 = $iqDh9.unstable_cancelCallback, $e229cb5c8b2cd629$var$shouldYield = $iqDh9.unstable_shouldYield, $e229cb5c8b2cd629$var$requestPaint = $iqDh9.unstable_requestPaint, $e229cb5c8b2cd629$var$now = $iqDh9.unstable_now, $e229cb5c8b2cd629$var$getCurrentPriorityLevel = $iqDh9.unstable_getCurrentPriorityLevel, $e229cb5c8b2cd629$var$ImmediatePriority = $iqDh9.unstable_ImmediatePriority, $e229cb5c8b2cd629$var$UserBlockingPriority = $iqDh9.unstable_UserBlockingPriority, $e229cb5c8b2cd629$var$NormalPriority$1 = $iqDh9.unstable_NormalPriority, $e229cb5c8b2cd629$var$LowPriority = $iqDh9.unstable_LowPriority, $e229cb5c8b2cd629$var$IdlePriority = $iqDh9.unstable_IdlePriority, $e229cb5c8b2cd629$var$log$1 = $iqDh9.log, $e229cb5c8b2cd629$var$unstable_setDisableYieldValue = $iqDh9.unstable_setDisableYieldValue, $e229cb5c8b2cd629$var$rendererID = null, $e229cb5c8b2cd629$var$injectedHook = null;
function $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $e229cb5c8b2cd629$var$log$1 && $e229cb5c8b2cd629$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($e229cb5c8b2cd629$var$injectedHook && "function" === typeof $e229cb5c8b2cd629$var$injectedHook.setStrictMode) try {
        $e229cb5c8b2cd629$var$injectedHook.setStrictMode($e229cb5c8b2cd629$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $e229cb5c8b2cd629$var$clz32 = Math.clz32 ? Math.clz32 : $e229cb5c8b2cd629$var$clz32Fallback, $e229cb5c8b2cd629$var$log = Math.log, $e229cb5c8b2cd629$var$LN2 = Math.LN2;
function $e229cb5c8b2cd629$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($e229cb5c8b2cd629$var$log(x) / $e229cb5c8b2cd629$var$LN2 | 0) | 0;
}
var $e229cb5c8b2cd629$var$nextTransitionUpdateLane = 256, $e229cb5c8b2cd629$var$nextTransitionDeferredLane = 262144, $e229cb5c8b2cd629$var$nextRetryLane = 4194304;
function $e229cb5c8b2cd629$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $e229cb5c8b2cd629$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $e229cb5c8b2cd629$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e229cb5c8b2cd629$var$claimNextRetryLane() {
    var lane = $e229cb5c8b2cd629$var$nextRetryLane;
    $e229cb5c8b2cd629$var$nextRetryLane <<= 1;
    0 === ($e229cb5c8b2cd629$var$nextRetryLane & 62914560) && ($e229cb5c8b2cd629$var$nextRetryLane = 4194304);
    return lane;
}
function $e229cb5c8b2cd629$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $e229cb5c8b2cd629$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $e229cb5c8b2cd629$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $e229cb5c8b2cd629$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $e229cb5c8b2cd629$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $e229cb5c8b2cd629$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $e229cb5c8b2cd629$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $e229cb5c8b2cd629$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $e229cb5c8b2cd629$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $e229cb5c8b2cd629$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $e229cb5c8b2cd629$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $e229cb5c8b2cd629$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $e229cb5c8b2cd629$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $e229cb5c8b2cd629$var$resolveUpdatePriority() {
    var updatePriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $e229cb5c8b2cd629$var$getEventPriority(updatePriority.type);
}
function $e229cb5c8b2cd629$var$runWithPriority(priority, fn) {
    var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    try {
        return $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $e229cb5c8b2cd629$var$randomKey = Math.random().toString(36).slice(2), $e229cb5c8b2cd629$var$internalInstanceKey = "__reactFiber$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalPropsKey = "__reactProps$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalContainerInstanceKey = "__reactContainer$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalEventHandlersKey = "__reactEvents$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalEventHandlerListenersKey = "__reactListeners$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalEventHandlesSetKey = "__reactHandles$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalRootNodeResourcesKey = "__reactResources$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalHoistableMarker = "__reactMarker$" + $e229cb5c8b2cd629$var$randomKey;
function $e229cb5c8b2cd629$var$detachDeletedInstance(node) {
    delete node[$e229cb5c8b2cd629$var$internalInstanceKey];
    delete node[$e229cb5c8b2cd629$var$internalPropsKey];
    delete node[$e229cb5c8b2cd629$var$internalEventHandlersKey];
    delete node[$e229cb5c8b2cd629$var$internalEventHandlerListenersKey];
    delete node[$e229cb5c8b2cd629$var$internalEventHandlesSetKey];
}
function $e229cb5c8b2cd629$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$e229cb5c8b2cd629$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$e229cb5c8b2cd629$var$internalContainerInstanceKey] || parentNode[$e229cb5c8b2cd629$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $e229cb5c8b2cd629$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$e229cb5c8b2cd629$var$internalInstanceKey]) return parentNode;
                targetNode = $e229cb5c8b2cd629$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $e229cb5c8b2cd629$var$getInstanceFromNode(node) {
    if (node = node[$e229cb5c8b2cd629$var$internalInstanceKey] || node[$e229cb5c8b2cd629$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $e229cb5c8b2cd629$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(33));
}
function $e229cb5c8b2cd629$var$getResourcesFromRoot(root) {
    var resources = root[$e229cb5c8b2cd629$var$internalRootNodeResourcesKey];
    resources || (resources = root[$e229cb5c8b2cd629$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $e229cb5c8b2cd629$var$markNodeAsHoistable(node) {
    node[$e229cb5c8b2cd629$var$internalHoistableMarker] = !0;
}
var $e229cb5c8b2cd629$var$allNativeEvents = new Set(), $e229cb5c8b2cd629$var$registrationNameDependencies = {};
function $e229cb5c8b2cd629$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $e229cb5c8b2cd629$var$registerDirectEvent(registrationName, dependencies);
    $e229cb5c8b2cd629$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $e229cb5c8b2cd629$var$registerDirectEvent(registrationName, dependencies) {
    $e229cb5c8b2cd629$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$e229cb5c8b2cd629$var$allNativeEvents.add(dependencies[registrationName]);
}
var $e229cb5c8b2cd629$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $e229cb5c8b2cd629$var$illegalAttributeNameCache = {}, $e229cb5c8b2cd629$var$validatedAttributeNameCache = {};
function $e229cb5c8b2cd629$var$isAttributeNameSafe(attributeName) {
    if ($e229cb5c8b2cd629$var$hasOwnProperty.call($e229cb5c8b2cd629$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($e229cb5c8b2cd629$var$hasOwnProperty.call($e229cb5c8b2cd629$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($e229cb5c8b2cd629$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $e229cb5c8b2cd629$var$validatedAttributeNameCache[attributeName] = !0;
    $e229cb5c8b2cd629$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $e229cb5c8b2cd629$var$setValueForAttribute(node, name, value) {
    if ($e229cb5c8b2cd629$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $e229cb5c8b2cd629$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $e229cb5c8b2cd629$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $e229cb5c8b2cd629$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $e229cb5c8b2cd629$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $e229cb5c8b2cd629$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $e229cb5c8b2cd629$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $e229cb5c8b2cd629$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $e229cb5c8b2cd629$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $e229cb5c8b2cd629$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $e229cb5c8b2cd629$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $e229cb5c8b2cd629$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $e229cb5c8b2cd629$var$getToStringValue(value);
        } else element.value !== "" + $e229cb5c8b2cd629$var$getToStringValue(value) && (element.value = "" + $e229cb5c8b2cd629$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $e229cb5c8b2cd629$var$setDefaultValue(element, type, $e229cb5c8b2cd629$var$getToStringValue(value)) : null != defaultValue ? $e229cb5c8b2cd629$var$setDefaultValue(element, type, $e229cb5c8b2cd629$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $e229cb5c8b2cd629$var$getToStringValue(name) : element.removeAttribute("name");
}
function $e229cb5c8b2cd629$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $e229cb5c8b2cd629$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $e229cb5c8b2cd629$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $e229cb5c8b2cd629$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $e229cb5c8b2cd629$var$track(element);
}
function $e229cb5c8b2cd629$var$setDefaultValue(node, type, value) {
    "number" === type && $e229cb5c8b2cd629$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $e229cb5c8b2cd629$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $e229cb5c8b2cd629$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $e229cb5c8b2cd629$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $e229cb5c8b2cd629$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $e229cb5c8b2cd629$var$getToStringValue(defaultValue) : "";
}
function $e229cb5c8b2cd629$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(92));
            if ($e229cb5c8b2cd629$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $e229cb5c8b2cd629$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $e229cb5c8b2cd629$var$track(element);
}
function $e229cb5c8b2cd629$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $e229cb5c8b2cd629$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $e229cb5c8b2cd629$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $e229cb5c8b2cd629$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $e229cb5c8b2cd629$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $e229cb5c8b2cd629$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $e229cb5c8b2cd629$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $e229cb5c8b2cd629$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e229cb5c8b2cd629$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $e229cb5c8b2cd629$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $e229cb5c8b2cd629$var$sanitizeURL(url) {
    return $e229cb5c8b2cd629$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $e229cb5c8b2cd629$var$noop$1() {}
var $e229cb5c8b2cd629$var$currentReplayingEvent = null;
function $e229cb5c8b2cd629$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $e229cb5c8b2cd629$var$restoreTarget = null, $e229cb5c8b2cd629$var$restoreQueue = null;
function $e229cb5c8b2cd629$var$restoreStateOfTarget(target) {
    var internalInstance = $e229cb5c8b2cd629$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$e229cb5c8b2cd629$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $e229cb5c8b2cd629$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$e229cb5c8b2cd629$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(90));
                            $e229cb5c8b2cd629$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $e229cb5c8b2cd629$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $e229cb5c8b2cd629$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $e229cb5c8b2cd629$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $e229cb5c8b2cd629$var$isInsideEventHandler = !1;
function $e229cb5c8b2cd629$var$batchedUpdates$1(fn, a, b) {
    if ($e229cb5c8b2cd629$var$isInsideEventHandler) return fn(a, b);
    $e229cb5c8b2cd629$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($e229cb5c8b2cd629$var$isInsideEventHandler = !1, null !== $e229cb5c8b2cd629$var$restoreTarget || null !== $e229cb5c8b2cd629$var$restoreQueue) {
            if ($e229cb5c8b2cd629$var$flushSyncWork$1(), $e229cb5c8b2cd629$var$restoreTarget && (a = $e229cb5c8b2cd629$var$restoreTarget, fn = $e229cb5c8b2cd629$var$restoreQueue, $e229cb5c8b2cd629$var$restoreQueue = $e229cb5c8b2cd629$var$restoreTarget = null, $e229cb5c8b2cd629$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$e229cb5c8b2cd629$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $e229cb5c8b2cd629$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$e229cb5c8b2cd629$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $e229cb5c8b2cd629$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e229cb5c8b2cd629$var$passiveBrowserEventsSupported = !1;
if ($e229cb5c8b2cd629$var$canUseDOM) try {
    var $e229cb5c8b2cd629$var$options = {};
    Object.defineProperty($e229cb5c8b2cd629$var$options, "passive", {
        get: function() {
            $e229cb5c8b2cd629$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $e229cb5c8b2cd629$var$options, $e229cb5c8b2cd629$var$options);
    window.removeEventListener("test", $e229cb5c8b2cd629$var$options, $e229cb5c8b2cd629$var$options);
} catch (e) {
    $e229cb5c8b2cd629$var$passiveBrowserEventsSupported = !1;
}
var $e229cb5c8b2cd629$var$root = null, $e229cb5c8b2cd629$var$startText = null, $e229cb5c8b2cd629$var$fallbackText = null;
function $e229cb5c8b2cd629$var$getData() {
    if ($e229cb5c8b2cd629$var$fallbackText) return $e229cb5c8b2cd629$var$fallbackText;
    var start, startValue = $e229cb5c8b2cd629$var$startText, startLength = startValue.length, end, endValue = "value" in $e229cb5c8b2cd629$var$root ? $e229cb5c8b2cd629$var$root.value : $e229cb5c8b2cd629$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $e229cb5c8b2cd629$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $e229cb5c8b2cd629$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $e229cb5c8b2cd629$var$functionThatReturnsTrue() {
    return !0;
}
function $e229cb5c8b2cd629$var$functionThatReturnsFalse() {
    return !1;
}
function $e229cb5c8b2cd629$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $e229cb5c8b2cd629$var$functionThatReturnsTrue : $e229cb5c8b2cd629$var$functionThatReturnsFalse;
        this.isPropagationStopped = $e229cb5c8b2cd629$var$functionThatReturnsFalse;
        return this;
    }
    $e229cb5c8b2cd629$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $e229cb5c8b2cd629$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $e229cb5c8b2cd629$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $e229cb5c8b2cd629$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $e229cb5c8b2cd629$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e229cb5c8b2cd629$var$SyntheticEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$EventInterface), $e229cb5c8b2cd629$var$UIEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    view: 0,
    detail: 0
}), $e229cb5c8b2cd629$var$SyntheticUIEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$UIEventInterface), $e229cb5c8b2cd629$var$lastMovementX, $e229cb5c8b2cd629$var$lastMovementY, $e229cb5c8b2cd629$var$lastMouseEvent, $e229cb5c8b2cd629$var$MouseEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e229cb5c8b2cd629$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $e229cb5c8b2cd629$var$lastMouseEvent && ($e229cb5c8b2cd629$var$lastMouseEvent && "mousemove" === event.type ? ($e229cb5c8b2cd629$var$lastMovementX = event.screenX - $e229cb5c8b2cd629$var$lastMouseEvent.screenX, $e229cb5c8b2cd629$var$lastMovementY = event.screenY - $e229cb5c8b2cd629$var$lastMouseEvent.screenY) : $e229cb5c8b2cd629$var$lastMovementY = $e229cb5c8b2cd629$var$lastMovementX = 0, $e229cb5c8b2cd629$var$lastMouseEvent = event);
        return $e229cb5c8b2cd629$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $e229cb5c8b2cd629$var$lastMovementY;
    }
}), $e229cb5c8b2cd629$var$SyntheticMouseEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$MouseEventInterface), $e229cb5c8b2cd629$var$DragEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$MouseEventInterface, {
    dataTransfer: 0
}), $e229cb5c8b2cd629$var$SyntheticDragEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$DragEventInterface), $e229cb5c8b2cd629$var$FocusEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$UIEventInterface, {
    relatedTarget: 0
}), $e229cb5c8b2cd629$var$SyntheticFocusEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$FocusEventInterface), $e229cb5c8b2cd629$var$AnimationEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e229cb5c8b2cd629$var$SyntheticAnimationEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$AnimationEventInterface), $e229cb5c8b2cd629$var$ClipboardEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $e229cb5c8b2cd629$var$SyntheticClipboardEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$ClipboardEventInterface), $e229cb5c8b2cd629$var$CompositionEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    data: 0
}), $e229cb5c8b2cd629$var$SyntheticCompositionEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$CompositionEventInterface), $e229cb5c8b2cd629$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e229cb5c8b2cd629$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e229cb5c8b2cd629$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e229cb5c8b2cd629$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $e229cb5c8b2cd629$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $e229cb5c8b2cd629$var$getEventModifierState() {
    return $e229cb5c8b2cd629$var$modifierStateGetter;
}
var $e229cb5c8b2cd629$var$KeyboardEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $e229cb5c8b2cd629$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $e229cb5c8b2cd629$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $e229cb5c8b2cd629$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e229cb5c8b2cd629$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $e229cb5c8b2cd629$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $e229cb5c8b2cd629$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $e229cb5c8b2cd629$var$SyntheticKeyboardEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$KeyboardEventInterface), $e229cb5c8b2cd629$var$PointerEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e229cb5c8b2cd629$var$SyntheticPointerEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$PointerEventInterface), $e229cb5c8b2cd629$var$TouchEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e229cb5c8b2cd629$var$getEventModifierState
}), $e229cb5c8b2cd629$var$SyntheticTouchEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$TouchEventInterface), $e229cb5c8b2cd629$var$TransitionEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e229cb5c8b2cd629$var$SyntheticTransitionEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$TransitionEventInterface), $e229cb5c8b2cd629$var$WheelEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e229cb5c8b2cd629$var$SyntheticWheelEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$WheelEventInterface), $e229cb5c8b2cd629$var$ToggleEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $e229cb5c8b2cd629$var$SyntheticToggleEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$ToggleEventInterface), $e229cb5c8b2cd629$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $e229cb5c8b2cd629$var$canUseCompositionEvent = $e229cb5c8b2cd629$var$canUseDOM && "CompositionEvent" in window, $e229cb5c8b2cd629$var$documentMode = null;
$e229cb5c8b2cd629$var$canUseDOM && "documentMode" in document && ($e229cb5c8b2cd629$var$documentMode = document.documentMode);
var $e229cb5c8b2cd629$var$canUseTextInputEvent = $e229cb5c8b2cd629$var$canUseDOM && "TextEvent" in window && !$e229cb5c8b2cd629$var$documentMode, $e229cb5c8b2cd629$var$useFallbackCompositionData = $e229cb5c8b2cd629$var$canUseDOM && (!$e229cb5c8b2cd629$var$canUseCompositionEvent || $e229cb5c8b2cd629$var$documentMode && 8 < $e229cb5c8b2cd629$var$documentMode && 11 >= $e229cb5c8b2cd629$var$documentMode), $e229cb5c8b2cd629$var$SPACEBAR_CHAR = String.fromCharCode(32), $e229cb5c8b2cd629$var$hasSpaceKeypress = !1;
function $e229cb5c8b2cd629$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $e229cb5c8b2cd629$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e229cb5c8b2cd629$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $e229cb5c8b2cd629$var$isComposing = !1;
function $e229cb5c8b2cd629$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $e229cb5c8b2cd629$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $e229cb5c8b2cd629$var$hasSpaceKeypress = !0;
            return $e229cb5c8b2cd629$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $e229cb5c8b2cd629$var$SPACEBAR_CHAR && $e229cb5c8b2cd629$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $e229cb5c8b2cd629$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($e229cb5c8b2cd629$var$isComposing) return "compositionend" === domEventName || !$e229cb5c8b2cd629$var$canUseCompositionEvent && $e229cb5c8b2cd629$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $e229cb5c8b2cd629$var$getData(), $e229cb5c8b2cd629$var$fallbackText = $e229cb5c8b2cd629$var$startText = $e229cb5c8b2cd629$var$root = null, $e229cb5c8b2cd629$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $e229cb5c8b2cd629$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $e229cb5c8b2cd629$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e229cb5c8b2cd629$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$e229cb5c8b2cd629$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $e229cb5c8b2cd629$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $e229cb5c8b2cd629$var$restoreTarget ? $e229cb5c8b2cd629$var$restoreQueue ? $e229cb5c8b2cd629$var$restoreQueue.push(target) : $e229cb5c8b2cd629$var$restoreQueue = [
        target
    ] : $e229cb5c8b2cd629$var$restoreTarget = target;
    inst = $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $e229cb5c8b2cd629$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $e229cb5c8b2cd629$var$activeElement$1 = null, $e229cb5c8b2cd629$var$activeElementInst$1 = null;
function $e229cb5c8b2cd629$var$runEventInBatch(dispatchQueue) {
    $e229cb5c8b2cd629$var$processDispatchQueue(dispatchQueue, 0);
}
function $e229cb5c8b2cd629$var$getInstIfValueChanged(targetInst) {
    var targetNode = $e229cb5c8b2cd629$var$getNodeFromInstance(targetInst);
    if ($e229cb5c8b2cd629$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $e229cb5c8b2cd629$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $e229cb5c8b2cd629$var$isInputEventSupported = !1;
if ($e229cb5c8b2cd629$var$canUseDOM) {
    var $e229cb5c8b2cd629$var$JSCompiler_inline_result$jscomp$286;
    if ($e229cb5c8b2cd629$var$canUseDOM) {
        var $e229cb5c8b2cd629$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$e229cb5c8b2cd629$var$isSupported$jscomp$inline_427) {
            var $e229cb5c8b2cd629$var$element$jscomp$inline_428 = document.createElement("div");
            $e229cb5c8b2cd629$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $e229cb5c8b2cd629$var$isSupported$jscomp$inline_427 = "function" === typeof $e229cb5c8b2cd629$var$element$jscomp$inline_428.oninput;
        }
        $e229cb5c8b2cd629$var$JSCompiler_inline_result$jscomp$286 = $e229cb5c8b2cd629$var$isSupported$jscomp$inline_427;
    } else $e229cb5c8b2cd629$var$JSCompiler_inline_result$jscomp$286 = !1;
    $e229cb5c8b2cd629$var$isInputEventSupported = $e229cb5c8b2cd629$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $e229cb5c8b2cd629$var$stopWatchingForValueChange() {
    $e229cb5c8b2cd629$var$activeElement$1 && ($e229cb5c8b2cd629$var$activeElement$1.detachEvent("onpropertychange", $e229cb5c8b2cd629$var$handlePropertyChange), $e229cb5c8b2cd629$var$activeElementInst$1 = $e229cb5c8b2cd629$var$activeElement$1 = null);
}
function $e229cb5c8b2cd629$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $e229cb5c8b2cd629$var$getInstIfValueChanged($e229cb5c8b2cd629$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $e229cb5c8b2cd629$var$createAndAccumulateChangeEvent(dispatchQueue, $e229cb5c8b2cd629$var$activeElementInst$1, nativeEvent, $e229cb5c8b2cd629$var$getEventTarget(nativeEvent));
        $e229cb5c8b2cd629$var$batchedUpdates$1($e229cb5c8b2cd629$var$runEventInBatch, dispatchQueue);
    }
}
function $e229cb5c8b2cd629$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($e229cb5c8b2cd629$var$stopWatchingForValueChange(), $e229cb5c8b2cd629$var$activeElement$1 = target, $e229cb5c8b2cd629$var$activeElementInst$1 = targetInst, $e229cb5c8b2cd629$var$activeElement$1.attachEvent("onpropertychange", $e229cb5c8b2cd629$var$handlePropertyChange)) : "focusout" === domEventName && $e229cb5c8b2cd629$var$stopWatchingForValueChange();
}
function $e229cb5c8b2cd629$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $e229cb5c8b2cd629$var$getInstIfValueChanged($e229cb5c8b2cd629$var$activeElementInst$1);
}
function $e229cb5c8b2cd629$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $e229cb5c8b2cd629$var$getInstIfValueChanged(targetInst);
}
function $e229cb5c8b2cd629$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $e229cb5c8b2cd629$var$getInstIfValueChanged(targetInst);
}
function $e229cb5c8b2cd629$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $e229cb5c8b2cd629$var$objectIs = "function" === typeof Object.is ? Object.is : $e229cb5c8b2cd629$var$is;
function $e229cb5c8b2cd629$var$shallowEqual(objA, objB) {
    if ($e229cb5c8b2cd629$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$e229cb5c8b2cd629$var$hasOwnProperty.call(objB, currentKey) || !$e229cb5c8b2cd629$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $e229cb5c8b2cd629$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $e229cb5c8b2cd629$var$getNodeForCharacterOffset(root, offset) {
    var node = $e229cb5c8b2cd629$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $e229cb5c8b2cd629$var$getLeafNode(node);
    }
}
function $e229cb5c8b2cd629$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $e229cb5c8b2cd629$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $e229cb5c8b2cd629$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $e229cb5c8b2cd629$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $e229cb5c8b2cd629$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $e229cb5c8b2cd629$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $e229cb5c8b2cd629$var$skipSelectionChangeEvent = $e229cb5c8b2cd629$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $e229cb5c8b2cd629$var$activeElement = null, $e229cb5c8b2cd629$var$activeElementInst = null, $e229cb5c8b2cd629$var$lastSelection = null, $e229cb5c8b2cd629$var$mouseDown = !1;
function $e229cb5c8b2cd629$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $e229cb5c8b2cd629$var$mouseDown || null == $e229cb5c8b2cd629$var$activeElement || $e229cb5c8b2cd629$var$activeElement !== $e229cb5c8b2cd629$var$getActiveElement(doc) || (doc = $e229cb5c8b2cd629$var$activeElement, "selectionStart" in doc && $e229cb5c8b2cd629$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $e229cb5c8b2cd629$var$lastSelection && $e229cb5c8b2cd629$var$shallowEqual($e229cb5c8b2cd629$var$lastSelection, doc) || ($e229cb5c8b2cd629$var$lastSelection = doc, doc = $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners($e229cb5c8b2cd629$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $e229cb5c8b2cd629$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $e229cb5c8b2cd629$var$activeElement)));
}
function $e229cb5c8b2cd629$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $e229cb5c8b2cd629$var$vendorPrefixes = {
    animationend: $e229cb5c8b2cd629$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $e229cb5c8b2cd629$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $e229cb5c8b2cd629$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $e229cb5c8b2cd629$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $e229cb5c8b2cd629$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $e229cb5c8b2cd629$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $e229cb5c8b2cd629$var$makePrefixMap("Transition", "TransitionEnd")
}, $e229cb5c8b2cd629$var$prefixedEventNames = {}, $e229cb5c8b2cd629$var$style = {};
$e229cb5c8b2cd629$var$canUseDOM && ($e229cb5c8b2cd629$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $e229cb5c8b2cd629$var$vendorPrefixes.animationend.animation, delete $e229cb5c8b2cd629$var$vendorPrefixes.animationiteration.animation, delete $e229cb5c8b2cd629$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $e229cb5c8b2cd629$var$vendorPrefixes.transitionend.transition);
function $e229cb5c8b2cd629$var$getVendorPrefixedEventName(eventName) {
    if ($e229cb5c8b2cd629$var$prefixedEventNames[eventName]) return $e229cb5c8b2cd629$var$prefixedEventNames[eventName];
    if (!$e229cb5c8b2cd629$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $e229cb5c8b2cd629$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $e229cb5c8b2cd629$var$style) return $e229cb5c8b2cd629$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $e229cb5c8b2cd629$var$ANIMATION_END = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("animationend"), $e229cb5c8b2cd629$var$ANIMATION_ITERATION = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("animationiteration"), $e229cb5c8b2cd629$var$ANIMATION_START = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("animationstart"), $e229cb5c8b2cd629$var$TRANSITION_RUN = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("transitionrun"), $e229cb5c8b2cd629$var$TRANSITION_START = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("transitionstart"), $e229cb5c8b2cd629$var$TRANSITION_CANCEL = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("transitioncancel"), $e229cb5c8b2cd629$var$TRANSITION_END = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("transitionend"), $e229cb5c8b2cd629$var$topLevelEventsToReactNames = new Map(), $e229cb5c8b2cd629$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$e229cb5c8b2cd629$var$simpleEventPluginEvents.push("scrollEnd");
function $e229cb5c8b2cd629$var$registerSimpleEvent(domEventName, reactName) {
    $e229cb5c8b2cd629$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $e229cb5c8b2cd629$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $e229cb5c8b2cd629$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $e229cb5c8b2cd629$var$concurrentQueues = [], $e229cb5c8b2cd629$var$concurrentQueuesIndex = 0, $e229cb5c8b2cd629$var$concurrentlyUpdatedLanes = 0;
function $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $e229cb5c8b2cd629$var$concurrentQueuesIndex, i = $e229cb5c8b2cd629$var$concurrentlyUpdatedLanes = $e229cb5c8b2cd629$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $e229cb5c8b2cd629$var$concurrentQueues[i];
        $e229cb5c8b2cd629$var$concurrentQueues[i++] = null;
        var queue = $e229cb5c8b2cd629$var$concurrentQueues[i];
        $e229cb5c8b2cd629$var$concurrentQueues[i++] = null;
        var update = $e229cb5c8b2cd629$var$concurrentQueues[i];
        $e229cb5c8b2cd629$var$concurrentQueues[i++] = null;
        var lane = $e229cb5c8b2cd629$var$concurrentQueues[i];
        $e229cb5c8b2cd629$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $e229cb5c8b2cd629$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $e229cb5c8b2cd629$var$concurrentQueues[$e229cb5c8b2cd629$var$concurrentQueuesIndex++] = fiber;
    $e229cb5c8b2cd629$var$concurrentQueues[$e229cb5c8b2cd629$var$concurrentQueuesIndex++] = queue;
    $e229cb5c8b2cd629$var$concurrentQueues[$e229cb5c8b2cd629$var$concurrentQueuesIndex++] = update;
    $e229cb5c8b2cd629$var$concurrentQueues[$e229cb5c8b2cd629$var$concurrentQueuesIndex++] = lane;
    $e229cb5c8b2cd629$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $e229cb5c8b2cd629$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $e229cb5c8b2cd629$var$getRootForUpdatedFiber(fiber);
}
function $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, null, null, lane);
    return $e229cb5c8b2cd629$var$getRootForUpdatedFiber(fiber);
}
function $e229cb5c8b2cd629$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $e229cb5c8b2cd629$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $e229cb5c8b2cd629$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $e229cb5c8b2cd629$var$nestedUpdateCount) throw $e229cb5c8b2cd629$var$nestedUpdateCount = 0, $e229cb5c8b2cd629$var$rootWithNestedUpdates = null, Error($e229cb5c8b2cd629$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $e229cb5c8b2cd629$var$emptyContextObject = {};
function $e229cb5c8b2cd629$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e229cb5c8b2cd629$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $e229cb5c8b2cd629$var$FiberNode(tag, pendingProps, key, mode);
}
function $e229cb5c8b2cd629$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $e229cb5c8b2cd629$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $e229cb5c8b2cd629$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $e229cb5c8b2cd629$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $e229cb5c8b2cd629$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $e229cb5c8b2cd629$var$isHostHoistableType(type, pendingProps, $e229cb5c8b2cd629$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $e229cb5c8b2cd629$var$REACT_ACTIVITY_TYPE:
            return type = $e229cb5c8b2cd629$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $e229cb5c8b2cd629$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE:
            return $e229cb5c8b2cd629$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $e229cb5c8b2cd629$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $e229cb5c8b2cd629$var$REACT_PROFILER_TYPE:
            return type = $e229cb5c8b2cd629$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $e229cb5c8b2cd629$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $e229cb5c8b2cd629$var$REACT_SUSPENSE_TYPE:
            return type = $e229cb5c8b2cd629$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $e229cb5c8b2cd629$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $e229cb5c8b2cd629$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $e229cb5c8b2cd629$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $e229cb5c8b2cd629$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $e229cb5c8b2cd629$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $e229cb5c8b2cd629$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $e229cb5c8b2cd629$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $e229cb5c8b2cd629$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $e229cb5c8b2cd629$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $e229cb5c8b2cd629$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $e229cb5c8b2cd629$var$createFiberFromText(content, mode, lanes) {
    content = $e229cb5c8b2cd629$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $e229cb5c8b2cd629$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $e229cb5c8b2cd629$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $e229cb5c8b2cd629$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $e229cb5c8b2cd629$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $e229cb5c8b2cd629$var$CapturedStacks = new WeakMap();
function $e229cb5c8b2cd629$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $e229cb5c8b2cd629$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $e229cb5c8b2cd629$var$getStackByFiberInDevAndProd(source)
        };
        $e229cb5c8b2cd629$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $e229cb5c8b2cd629$var$getStackByFiberInDevAndProd(source)
    };
}
var $e229cb5c8b2cd629$var$forkStack = [], $e229cb5c8b2cd629$var$forkStackIndex = 0, $e229cb5c8b2cd629$var$treeForkProvider = null, $e229cb5c8b2cd629$var$treeForkCount = 0, $e229cb5c8b2cd629$var$idStack = [], $e229cb5c8b2cd629$var$idStackIndex = 0, $e229cb5c8b2cd629$var$treeContextProvider = null, $e229cb5c8b2cd629$var$treeContextId = 1, $e229cb5c8b2cd629$var$treeContextOverflow = "";
function $e229cb5c8b2cd629$var$pushTreeFork(workInProgress, totalChildren) {
    $e229cb5c8b2cd629$var$forkStack[$e229cb5c8b2cd629$var$forkStackIndex++] = $e229cb5c8b2cd629$var$treeForkCount;
    $e229cb5c8b2cd629$var$forkStack[$e229cb5c8b2cd629$var$forkStackIndex++] = $e229cb5c8b2cd629$var$treeForkProvider;
    $e229cb5c8b2cd629$var$treeForkProvider = workInProgress;
    $e229cb5c8b2cd629$var$treeForkCount = totalChildren;
}
function $e229cb5c8b2cd629$var$pushTreeId(workInProgress, totalChildren, index) {
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextId;
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextOverflow;
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextProvider;
    $e229cb5c8b2cd629$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $e229cb5c8b2cd629$var$treeContextId;
    workInProgress = $e229cb5c8b2cd629$var$treeContextOverflow;
    var baseLength = 32 - $e229cb5c8b2cd629$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $e229cb5c8b2cd629$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $e229cb5c8b2cd629$var$treeContextId = 1 << 32 - $e229cb5c8b2cd629$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $e229cb5c8b2cd629$var$treeContextOverflow = length + workInProgress;
    } else $e229cb5c8b2cd629$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $e229cb5c8b2cd629$var$treeContextOverflow = workInProgress;
}
function $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($e229cb5c8b2cd629$var$pushTreeFork(workInProgress, 1), $e229cb5c8b2cd629$var$pushTreeId(workInProgress, 1, 0));
}
function $e229cb5c8b2cd629$var$popTreeContext(workInProgress) {
    for(; workInProgress === $e229cb5c8b2cd629$var$treeForkProvider;)$e229cb5c8b2cd629$var$treeForkProvider = $e229cb5c8b2cd629$var$forkStack[--$e229cb5c8b2cd629$var$forkStackIndex], $e229cb5c8b2cd629$var$forkStack[$e229cb5c8b2cd629$var$forkStackIndex] = null, $e229cb5c8b2cd629$var$treeForkCount = $e229cb5c8b2cd629$var$forkStack[--$e229cb5c8b2cd629$var$forkStackIndex], $e229cb5c8b2cd629$var$forkStack[$e229cb5c8b2cd629$var$forkStackIndex] = null;
    for(; workInProgress === $e229cb5c8b2cd629$var$treeContextProvider;)$e229cb5c8b2cd629$var$treeContextProvider = $e229cb5c8b2cd629$var$idStack[--$e229cb5c8b2cd629$var$idStackIndex], $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex] = null, $e229cb5c8b2cd629$var$treeContextOverflow = $e229cb5c8b2cd629$var$idStack[--$e229cb5c8b2cd629$var$idStackIndex], $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex] = null, $e229cb5c8b2cd629$var$treeContextId = $e229cb5c8b2cd629$var$idStack[--$e229cb5c8b2cd629$var$idStackIndex], $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex] = null;
}
function $e229cb5c8b2cd629$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextId;
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextOverflow;
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextProvider;
    $e229cb5c8b2cd629$var$treeContextId = suspendedContext.id;
    $e229cb5c8b2cd629$var$treeContextOverflow = suspendedContext.overflow;
    $e229cb5c8b2cd629$var$treeContextProvider = workInProgress;
}
var $e229cb5c8b2cd629$var$hydrationParentFiber = null, $e229cb5c8b2cd629$var$nextHydratableInstance = null, $e229cb5c8b2cd629$var$isHydrating = !1, $e229cb5c8b2cd629$var$hydrationErrors = null, $e229cb5c8b2cd629$var$rootOrSingletonContext = !1, $e229cb5c8b2cd629$var$HydrationMismatchException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(519));
function $e229cb5c8b2cd629$var$throwOnHydrationMismatch(fiber) {
    var error = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $e229cb5c8b2cd629$var$queueHydrationError($e229cb5c8b2cd629$var$createCapturedValueAtFiber(error, fiber));
    throw $e229cb5c8b2cd629$var$HydrationMismatchException;
}
function $e229cb5c8b2cd629$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$e229cb5c8b2cd629$var$internalInstanceKey] = fiber;
    instance[$e229cb5c8b2cd629$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("cancel", instance);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $e229cb5c8b2cd629$var$mediaEventTypes.length; type++)$e229cb5c8b2cd629$var$listenToNonDelegatedEvent($e229cb5c8b2cd629$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", instance);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", instance);
            $e229cb5c8b2cd629$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", instance), $e229cb5c8b2cd629$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $e229cb5c8b2cd629$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($e229cb5c8b2cd629$var$listenToNonDelegatedEvent("beforetoggle", instance), $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $e229cb5c8b2cd629$var$noop$1), instance = !0) : instance = !1;
    instance || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(fiber, !0);
}
function $e229cb5c8b2cd629$var$popToNextHostParent(fiber) {
    for($e229cb5c8b2cd629$var$hydrationParentFiber = fiber.return; $e229cb5c8b2cd629$var$hydrationParentFiber;)switch($e229cb5c8b2cd629$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $e229cb5c8b2cd629$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $e229cb5c8b2cd629$var$rootOrSingletonContext = !0;
            return;
        default:
            $e229cb5c8b2cd629$var$hydrationParentFiber = $e229cb5c8b2cd629$var$hydrationParentFiber.return;
    }
}
function $e229cb5c8b2cd629$var$popHydrationState(fiber) {
    if (fiber !== $e229cb5c8b2cd629$var$hydrationParentFiber) return !1;
    if (!$e229cb5c8b2cd629$var$isHydrating) return $e229cb5c8b2cd629$var$popToNextHostParent(fiber), $e229cb5c8b2cd629$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $e229cb5c8b2cd629$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $e229cb5c8b2cd629$var$nextHydratableInstance && $e229cb5c8b2cd629$var$throwOnHydrationMismatch(fiber);
    $e229cb5c8b2cd629$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(317));
        $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(317));
        $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $e229cb5c8b2cd629$var$nextHydratableInstance, $e229cb5c8b2cd629$var$isSingletonScope(fiber.type) ? (fiber = $e229cb5c8b2cd629$var$previousHydratableOnEnteringScopedSingleton, $e229cb5c8b2cd629$var$previousHydratableOnEnteringScopedSingleton = null, $e229cb5c8b2cd629$var$nextHydratableInstance = fiber) : $e229cb5c8b2cd629$var$nextHydratableInstance = tag) : $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$hydrationParentFiber ? $e229cb5c8b2cd629$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $e229cb5c8b2cd629$var$resetHydrationState() {
    $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$hydrationParentFiber = null;
    $e229cb5c8b2cd629$var$isHydrating = !1;
}
function $e229cb5c8b2cd629$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $e229cb5c8b2cd629$var$hydrationErrors;
    null !== queuedErrors && (null === $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors ? $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = queuedErrors : $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors.push.apply($e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors, queuedErrors), $e229cb5c8b2cd629$var$hydrationErrors = null);
    return queuedErrors;
}
function $e229cb5c8b2cd629$var$queueHydrationError(error) {
    null === $e229cb5c8b2cd629$var$hydrationErrors ? $e229cb5c8b2cd629$var$hydrationErrors = [
        error
    ] : $e229cb5c8b2cd629$var$hydrationErrors.push(error);
}
var $e229cb5c8b2cd629$var$valueCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null, $e229cb5c8b2cd629$var$lastContextDependency = null;
function $e229cb5c8b2cd629$var$pushProvider(providerFiber, context, nextValue) {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $e229cb5c8b2cd629$var$popProvider(context) {
    context._currentValue = $e229cb5c8b2cd629$var$valueCursor.current;
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$valueCursor);
}
function $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $e229cb5c8b2cd629$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $e229cb5c8b2cd629$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $e229cb5c8b2cd629$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($e229cb5c8b2cd629$var$HostTransitionContext) : current = [
                $e229cb5c8b2cd629$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $e229cb5c8b2cd629$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $e229cb5c8b2cd629$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$e229cb5c8b2cd629$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress) {
    $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = workInProgress;
    $e229cb5c8b2cd629$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $e229cb5c8b2cd629$var$readContext(context) {
    return $e229cb5c8b2cd629$var$readContextForConsumer($e229cb5c8b2cd629$var$currentlyRenderingFiber$1, context);
}
function $e229cb5c8b2cd629$var$readContextDuringReconciliation(consumer, context) {
    null === $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 && $e229cb5c8b2cd629$var$prepareToReadContext(consumer);
    return $e229cb5c8b2cd629$var$readContextForConsumer(consumer, context);
}
function $e229cb5c8b2cd629$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $e229cb5c8b2cd629$var$lastContextDependency) {
        if (null === consumer) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(308));
        $e229cb5c8b2cd629$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$lastContextDependency.next = context;
    return value;
}
var $e229cb5c8b2cd629$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $e229cb5c8b2cd629$var$scheduleCallback$2 = $iqDh9.unstable_scheduleCallback, $e229cb5c8b2cd629$var$NormalPriority = $iqDh9.unstable_NormalPriority, $e229cb5c8b2cd629$var$CacheContext = {
    $$typeof: $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $e229cb5c8b2cd629$var$createCache() {
    return {
        controller: new $e229cb5c8b2cd629$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $e229cb5c8b2cd629$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $e229cb5c8b2cd629$var$scheduleCallback$2($e229cb5c8b2cd629$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $e229cb5c8b2cd629$var$currentEntangledListeners = null, $e229cb5c8b2cd629$var$currentEntangledPendingCount = 0, $e229cb5c8b2cd629$var$currentEntangledLane = 0, $e229cb5c8b2cd629$var$currentEntangledActionThenable = null;
function $e229cb5c8b2cd629$var$entangleAsyncAction(transition, thenable) {
    if (null === $e229cb5c8b2cd629$var$currentEntangledListeners) {
        var entangledListeners = $e229cb5c8b2cd629$var$currentEntangledListeners = [];
        $e229cb5c8b2cd629$var$currentEntangledPendingCount = 0;
        $e229cb5c8b2cd629$var$currentEntangledLane = $e229cb5c8b2cd629$var$requestTransitionLane();
        $e229cb5c8b2cd629$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $e229cb5c8b2cd629$var$currentEntangledPendingCount++;
    thenable.then($e229cb5c8b2cd629$var$pingEngtangledActionScope, $e229cb5c8b2cd629$var$pingEngtangledActionScope);
    return thenable;
}
function $e229cb5c8b2cd629$var$pingEngtangledActionScope() {
    if (0 === --$e229cb5c8b2cd629$var$currentEntangledPendingCount && null !== $e229cb5c8b2cd629$var$currentEntangledListeners) {
        null !== $e229cb5c8b2cd629$var$currentEntangledActionThenable && ($e229cb5c8b2cd629$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $e229cb5c8b2cd629$var$currentEntangledListeners;
        $e229cb5c8b2cd629$var$currentEntangledListeners = null;
        $e229cb5c8b2cd629$var$currentEntangledLane = 0;
        $e229cb5c8b2cd629$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $e229cb5c8b2cd629$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $e229cb5c8b2cd629$var$prevOnStartTransitionFinish = $e229cb5c8b2cd629$var$ReactSharedInternals.S;
$e229cb5c8b2cd629$var$ReactSharedInternals.S = function(transition, returnValue) {
    $e229cb5c8b2cd629$var$globalMostRecentTransitionTime = $e229cb5c8b2cd629$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $e229cb5c8b2cd629$var$entangleAsyncAction(transition, returnValue);
    null !== $e229cb5c8b2cd629$var$prevOnStartTransitionFinish && $e229cb5c8b2cd629$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $e229cb5c8b2cd629$var$resumedCache = $e229cb5c8b2cd629$var$createCursor(null);
function $e229cb5c8b2cd629$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $e229cb5c8b2cd629$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $e229cb5c8b2cd629$var$workInProgressRoot.pooledCache;
}
function $e229cb5c8b2cd629$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$resumedCache, $e229cb5c8b2cd629$var$resumedCache.current) : $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$resumedCache, prevCachePool.pool);
}
function $e229cb5c8b2cd629$var$getSuspendedCache() {
    var cacheFromPool = $e229cb5c8b2cd629$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $e229cb5c8b2cd629$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $e229cb5c8b2cd629$var$SuspenseException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(460)), $e229cb5c8b2cd629$var$SuspenseyCommitException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(474)), $e229cb5c8b2cd629$var$SuspenseActionException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(542)), $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $e229cb5c8b2cd629$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $e229cb5c8b2cd629$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($e229cb5c8b2cd629$var$noop$1, $e229cb5c8b2cd629$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $e229cb5c8b2cd629$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($e229cb5c8b2cd629$var$noop$1, $e229cb5c8b2cd629$var$noop$1);
            else {
                thenableState = $e229cb5c8b2cd629$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $e229cb5c8b2cd629$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $e229cb5c8b2cd629$var$suspendedThenable = thenable;
            throw $e229cb5c8b2cd629$var$SuspenseException;
    }
}
function $e229cb5c8b2cd629$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $e229cb5c8b2cd629$var$suspendedThenable = x, $e229cb5c8b2cd629$var$SuspenseException;
        throw x;
    }
}
var $e229cb5c8b2cd629$var$suspendedThenable = null;
function $e229cb5c8b2cd629$var$getSuspendedThenable() {
    if (null === $e229cb5c8b2cd629$var$suspendedThenable) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(459));
    var thenable = $e229cb5c8b2cd629$var$suspendedThenable;
    $e229cb5c8b2cd629$var$suspendedThenable = null;
    return thenable;
}
function $e229cb5c8b2cd629$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $e229cb5c8b2cd629$var$SuspenseException || rejectedReason === $e229cb5c8b2cd629$var$SuspenseActionException) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(483));
}
var $e229cb5c8b2cd629$var$thenableState$1 = null, $e229cb5c8b2cd629$var$thenableIndexCounter$1 = 0;
function $e229cb5c8b2cd629$var$unwrapThenable(thenable) {
    var index = $e229cb5c8b2cd629$var$thenableIndexCounter$1;
    $e229cb5c8b2cd629$var$thenableIndexCounter$1 += 1;
    null === $e229cb5c8b2cd629$var$thenableState$1 && ($e229cb5c8b2cd629$var$thenableState$1 = []);
    return $e229cb5c8b2cd629$var$trackUsedThenable($e229cb5c8b2cd629$var$thenableState$1, thenable, index);
}
function $e229cb5c8b2cd629$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $e229cb5c8b2cd629$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $e229cb5c8b2cd629$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $e229cb5c8b2cd629$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $e229cb5c8b2cd629$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $e229cb5c8b2cd629$var$REACT_LAZY_TYPE && $e229cb5c8b2cd629$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $e229cb5c8b2cd629$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $e229cb5c8b2cd629$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $e229cb5c8b2cd629$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $e229cb5c8b2cd629$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $e229cb5c8b2cd629$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE:
                    return lanes = $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $e229cb5c8b2cd629$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
                    return newChild = $e229cb5c8b2cd629$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    return newChild = $e229cb5c8b2cd629$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($e229cb5c8b2cd629$var$isArrayImpl(newChild) || $e229cb5c8b2cd629$var$getIteratorFn(newChild)) return newChild = $e229cb5c8b2cd629$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $e229cb5c8b2cd629$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $e229cb5c8b2cd629$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e229cb5c8b2cd629$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    return newChild = $e229cb5c8b2cd629$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($e229cb5c8b2cd629$var$isArrayImpl(newChild) || $e229cb5c8b2cd629$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $e229cb5c8b2cd629$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $e229cb5c8b2cd629$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e229cb5c8b2cd629$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    return newChild = $e229cb5c8b2cd629$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($e229cb5c8b2cd629$var$isArrayImpl(newChild) || $e229cb5c8b2cd629$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $e229cb5c8b2cd629$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $e229cb5c8b2cd629$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e229cb5c8b2cd629$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $e229cb5c8b2cd629$var$REACT_LAZY_TYPE && $e229cb5c8b2cd629$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $e229cb5c8b2cd629$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE ? (lanes = $e229cb5c8b2cd629$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $e229cb5c8b2cd629$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $e229cb5c8b2cd629$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    return newChild = $e229cb5c8b2cd629$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($e229cb5c8b2cd629$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($e229cb5c8b2cd629$var$getIteratorFn(newChild)) {
                key = $e229cb5c8b2cd629$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $e229cb5c8b2cd629$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $e229cb5c8b2cd629$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e229cb5c8b2cd629$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $e229cb5c8b2cd629$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $e229cb5c8b2cd629$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $e229cb5c8b2cd629$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $e229cb5c8b2cd629$var$SuspenseException || x === $e229cb5c8b2cd629$var$SuspenseActionException) throw x;
            var fiber = $e229cb5c8b2cd629$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $e229cb5c8b2cd629$var$reconcileChildFibers = $e229cb5c8b2cd629$var$createChildReconciler(!0), $e229cb5c8b2cd629$var$mountChildFibers = $e229cb5c8b2cd629$var$createChildReconciler(!1), $e229cb5c8b2cd629$var$hasForceUpdate = !1;
function $e229cb5c8b2cd629$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $e229cb5c8b2cd629$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $e229cb5c8b2cd629$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e229cb5c8b2cd629$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($e229cb5c8b2cd629$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $e229cb5c8b2cd629$var$getRootForUpdatedFiber(fiber);
        $e229cb5c8b2cd629$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $e229cb5c8b2cd629$var$getRootForUpdatedFiber(fiber);
}
function $e229cb5c8b2cd629$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $e229cb5c8b2cd629$var$markRootEntangled(root, lane);
    }
}
function $e229cb5c8b2cd629$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $e229cb5c8b2cd629$var$didReadFromEntangledAsyncAction = !1;
function $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($e229cb5c8b2cd629$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $e229cb5c8b2cd629$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $e229cb5c8b2cd629$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $e229cb5c8b2cd629$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $e229cb5c8b2cd629$var$currentEntangledLane && ($e229cb5c8b2cd629$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $e229cb5c8b2cd629$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $e229cb5c8b2cd629$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $e229cb5c8b2cd629$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $e229cb5c8b2cd629$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$e229cb5c8b2cd629$var$callCallback(callbacks[updateQueue], context);
}
var $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor = $e229cb5c8b2cd629$var$createCursor(0);
function $e229cb5c8b2cd629$var$pushHiddenContext(fiber, context) {
    fiber = $e229cb5c8b2cd629$var$entangledRenderLanes;
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor, fiber);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$currentTreeHiddenStackCursor, context);
    $e229cb5c8b2cd629$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $e229cb5c8b2cd629$var$reuseHiddenContextOnStack() {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor, $e229cb5c8b2cd629$var$entangledRenderLanes);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$currentTreeHiddenStackCursor, $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor.current);
}
function $e229cb5c8b2cd629$var$popHiddenContext() {
    $e229cb5c8b2cd629$var$entangledRenderLanes = $e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor.current;
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$currentTreeHiddenStackCursor);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor);
}
var $e229cb5c8b2cd629$var$suspenseHandlerStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$shellBoundary = null;
function $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current & 1);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, handler);
    null === $e229cb5c8b2cd629$var$shellBoundary && (null === current || null !== $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor.current ? $e229cb5c8b2cd629$var$shellBoundary = handler : null !== current.memoizedState && ($e229cb5c8b2cd629$var$shellBoundary = handler));
}
function $e229cb5c8b2cd629$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, fiber);
    null === $e229cb5c8b2cd629$var$shellBoundary && ($e229cb5c8b2cd629$var$shellBoundary = fiber);
}
function $e229cb5c8b2cd629$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current), $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, fiber), null === $e229cb5c8b2cd629$var$shellBoundary && ($e229cb5c8b2cd629$var$shellBoundary = fiber)) : $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(fiber);
}
function $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack() {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current);
}
function $e229cb5c8b2cd629$var$popSuspenseHandler(fiber) {
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseHandlerStackCursor);
    $e229cb5c8b2cd629$var$shellBoundary === fiber && ($e229cb5c8b2cd629$var$shellBoundary = null);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseStackCursor);
}
var $e229cb5c8b2cd629$var$suspenseStackCursor = $e229cb5c8b2cd629$var$createCursor(0);
function $e229cb5c8b2cd629$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $e229cb5c8b2cd629$var$isSuspenseInstancePending(state) || $e229cb5c8b2cd629$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $e229cb5c8b2cd629$var$renderLanes = 0, $e229cb5c8b2cd629$var$currentlyRenderingFiber = null, $e229cb5c8b2cd629$var$currentHook = null, $e229cb5c8b2cd629$var$workInProgressHook = null, $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate = !1, $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $e229cb5c8b2cd629$var$localIdCounter = 0, $e229cb5c8b2cd629$var$thenableIndexCounter = 0, $e229cb5c8b2cd629$var$thenableState = null, $e229cb5c8b2cd629$var$globalClientIdCounter = 0;
function $e229cb5c8b2cd629$var$throwInvalidHookError() {
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(321));
}
function $e229cb5c8b2cd629$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$e229cb5c8b2cd629$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $e229cb5c8b2cd629$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $e229cb5c8b2cd629$var$renderLanes = nextRenderLanes;
    $e229cb5c8b2cd629$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $e229cb5c8b2cd629$var$HooksDispatcherOnMount : $e229cb5c8b2cd629$var$HooksDispatcherOnUpdate;
    $e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $e229cb5c8b2cd629$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $e229cb5c8b2cd629$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $e229cb5c8b2cd629$var$finishRenderingHooks(current) {
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = $e229cb5c8b2cd629$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $e229cb5c8b2cd629$var$currentHook && null !== $e229cb5c8b2cd629$var$currentHook.next;
    $e229cb5c8b2cd629$var$renderLanes = 0;
    $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$currentHook = $e229cb5c8b2cd629$var$currentlyRenderingFiber = null;
    $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate = !1;
    $e229cb5c8b2cd629$var$thenableIndexCounter = 0;
    $e229cb5c8b2cd629$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(300));
    null === current || $e229cb5c8b2cd629$var$didReceiveUpdate || (current = current.dependencies, null !== current && $e229cb5c8b2cd629$var$checkIfContextChanged(current) && ($e229cb5c8b2cd629$var$didReceiveUpdate = !0));
}
function $e229cb5c8b2cd629$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $e229cb5c8b2cd629$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass && ($e229cb5c8b2cd629$var$thenableState = null);
        $e229cb5c8b2cd629$var$thenableIndexCounter = 0;
        $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $e229cb5c8b2cd629$var$ReactSharedInternals.H = $e229cb5c8b2cd629$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $e229cb5c8b2cd629$var$TransitionAwareHostComponent() {
    var dispatcher = $e229cb5c8b2cd629$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $e229cb5c8b2cd629$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $e229cb5c8b2cd629$var$currentHook ? $e229cb5c8b2cd629$var$currentHook.memoizedState : null) !== dispatcher && ($e229cb5c8b2cd629$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $e229cb5c8b2cd629$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $e229cb5c8b2cd629$var$localIdCounter;
    $e229cb5c8b2cd629$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $e229cb5c8b2cd629$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $e229cb5c8b2cd629$var$resetHooksOnUnwind(workInProgress) {
    if ($e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate = !1;
    }
    $e229cb5c8b2cd629$var$renderLanes = 0;
    $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$currentHook = $e229cb5c8b2cd629$var$currentlyRenderingFiber = null;
    $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $e229cb5c8b2cd629$var$thenableIndexCounter = $e229cb5c8b2cd629$var$localIdCounter = 0;
    $e229cb5c8b2cd629$var$thenableState = null;
}
function $e229cb5c8b2cd629$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e229cb5c8b2cd629$var$workInProgressHook ? $e229cb5c8b2cd629$var$currentlyRenderingFiber.memoizedState = $e229cb5c8b2cd629$var$workInProgressHook = hook : $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$workInProgressHook.next = hook;
    return $e229cb5c8b2cd629$var$workInProgressHook;
}
function $e229cb5c8b2cd629$var$updateWorkInProgressHook() {
    if (null === $e229cb5c8b2cd629$var$currentHook) {
        var nextCurrentHook = $e229cb5c8b2cd629$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $e229cb5c8b2cd629$var$currentHook.next;
    var nextWorkInProgressHook = null === $e229cb5c8b2cd629$var$workInProgressHook ? $e229cb5c8b2cd629$var$currentlyRenderingFiber.memoizedState : $e229cb5c8b2cd629$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $e229cb5c8b2cd629$var$workInProgressHook = nextWorkInProgressHook, $e229cb5c8b2cd629$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $e229cb5c8b2cd629$var$currentlyRenderingFiber.alternate) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(467));
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(310));
        }
        $e229cb5c8b2cd629$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $e229cb5c8b2cd629$var$currentHook.memoizedState,
            baseState: $e229cb5c8b2cd629$var$currentHook.baseState,
            baseQueue: $e229cb5c8b2cd629$var$currentHook.baseQueue,
            queue: $e229cb5c8b2cd629$var$currentHook.queue,
            next: null
        };
        null === $e229cb5c8b2cd629$var$workInProgressHook ? $e229cb5c8b2cd629$var$currentlyRenderingFiber.memoizedState = $e229cb5c8b2cd629$var$workInProgressHook = nextCurrentHook : $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$workInProgressHook.next = nextCurrentHook;
    }
    return $e229cb5c8b2cd629$var$workInProgressHook;
}
function $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $e229cb5c8b2cd629$var$useThenable(thenable) {
    var index = $e229cb5c8b2cd629$var$thenableIndexCounter;
    $e229cb5c8b2cd629$var$thenableIndexCounter += 1;
    null === $e229cb5c8b2cd629$var$thenableState && ($e229cb5c8b2cd629$var$thenableState = []);
    thenable = $e229cb5c8b2cd629$var$trackUsedThenable($e229cb5c8b2cd629$var$thenableState, thenable, index);
    index = $e229cb5c8b2cd629$var$currentlyRenderingFiber;
    null === (null === $e229cb5c8b2cd629$var$workInProgressHook ? index.memoizedState : $e229cb5c8b2cd629$var$workInProgressHook.next) && (index = index.alternate, $e229cb5c8b2cd629$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $e229cb5c8b2cd629$var$HooksDispatcherOnMount : $e229cb5c8b2cd629$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $e229cb5c8b2cd629$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $e229cb5c8b2cd629$var$useThenable(usable);
        if (usable.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return $e229cb5c8b2cd629$var$readContext(usable);
    }
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(438, String(usable)));
}
function $e229cb5c8b2cd629$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $e229cb5c8b2cd629$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue(), $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $e229cb5c8b2cd629$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $e229cb5c8b2cd629$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $e229cb5c8b2cd629$var$updateReducer(reducer) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    return $e229cb5c8b2cd629$var$updateReducerImpl(hook, $e229cb5c8b2cd629$var$currentHook, reducer);
}
function $e229cb5c8b2cd629$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($e229cb5c8b2cd629$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $e229cb5c8b2cd629$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($e229cb5c8b2cd629$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $e229cb5c8b2cd629$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $e229cb5c8b2cd629$var$currentlyRenderingFiber.lanes |= revertLane, $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $e229cb5c8b2cd629$var$currentlyRenderingFiber.lanes |= updateLane, $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$e229cb5c8b2cd629$var$objectIs(pendingQueue, hook.memoizedState) && ($e229cb5c8b2cd629$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $e229cb5c8b2cd629$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $e229cb5c8b2cd629$var$rerenderReducer(reducer) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $e229cb5c8b2cd629$var$objectIs(newState, hook.memoizedState) || ($e229cb5c8b2cd629$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $e229cb5c8b2cd629$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $e229cb5c8b2cd629$var$currentlyRenderingFiber, hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $e229cb5c8b2cd629$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$e229cb5c8b2cd629$var$objectIs(($e229cb5c8b2cd629$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $e229cb5c8b2cd629$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $e229cb5c8b2cd629$var$updateEffect($e229cb5c8b2cd629$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $e229cb5c8b2cd629$var$workInProgressHook && $e229cb5c8b2cd629$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $e229cb5c8b2cd629$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $e229cb5c8b2cd629$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $e229cb5c8b2cd629$var$workInProgressRoot) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($e229cb5c8b2cd629$var$renderLanes & 127) || $e229cb5c8b2cd629$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $e229cb5c8b2cd629$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue(), $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $e229cb5c8b2cd629$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $e229cb5c8b2cd629$var$checkIfSnapshotChanged(inst) && $e229cb5c8b2cd629$var$forceStoreRerender(fiber);
}
function $e229cb5c8b2cd629$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $e229cb5c8b2cd629$var$checkIfSnapshotChanged(inst) && $e229cb5c8b2cd629$var$forceStoreRerender(fiber);
    });
}
function $e229cb5c8b2cd629$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$e229cb5c8b2cd629$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $e229cb5c8b2cd629$var$forceStoreRerender(fiber) {
    var root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $e229cb5c8b2cd629$var$mountStateImpl(initialState) {
    var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e229cb5c8b2cd629$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $e229cb5c8b2cd629$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $e229cb5c8b2cd629$var$updateReducerImpl(hook, $e229cb5c8b2cd629$var$currentHook, "function" === typeof reducer ? reducer : $e229cb5c8b2cd629$var$basicStateReducer);
}
function $e229cb5c8b2cd629$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $e229cb5c8b2cd629$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $e229cb5c8b2cd629$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $e229cb5c8b2cd629$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T, currentTransition = {};
        $e229cb5c8b2cd629$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $e229cb5c8b2cd629$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $e229cb5c8b2cd629$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $e229cb5c8b2cd629$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $e229cb5c8b2cd629$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $e229cb5c8b2cd629$var$onActionError(actionQueue, node, error$66);
    }
}
function $e229cb5c8b2cd629$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $e229cb5c8b2cd629$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $e229cb5c8b2cd629$var$onActionError(actionQueue, node, error);
    }) : $e229cb5c8b2cd629$var$onActionSuccess(actionQueue, node, returnValue);
}
function $e229cb5c8b2cd629$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $e229cb5c8b2cd629$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $e229cb5c8b2cd629$var$runActionStateAction(actionQueue, nextState)));
}
function $e229cb5c8b2cd629$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $e229cb5c8b2cd629$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $e229cb5c8b2cd629$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $e229cb5c8b2cd629$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $e229cb5c8b2cd629$var$mountActionState(action, initialStateProp) {
    if ($e229cb5c8b2cd629$var$isHydrating) {
        var ssrFormState = $e229cb5c8b2cd629$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $e229cb5c8b2cd629$var$currentlyRenderingFiber;
                if ($e229cb5c8b2cd629$var$isHydrating) {
                    if ($e229cb5c8b2cd629$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $e229cb5c8b2cd629$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $e229cb5c8b2cd629$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $e229cb5c8b2cd629$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $e229cb5c8b2cd629$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e229cb5c8b2cd629$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $e229cb5c8b2cd629$var$dispatchSetState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $e229cb5c8b2cd629$var$mountStateImpl(!1);
    inRootOrSingleton = $e229cb5c8b2cd629$var$dispatchOptimisticSetState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $e229cb5c8b2cd629$var$dispatchActionState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $e229cb5c8b2cd629$var$updateActionState(action) {
    var stateHook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    return $e229cb5c8b2cd629$var$updateActionStateImpl(stateHook, $e229cb5c8b2cd629$var$currentHook, action);
}
function $e229cb5c8b2cd629$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $e229cb5c8b2cd629$var$updateReducerImpl(stateHook, currentStateHook, $e229cb5c8b2cd629$var$actionStateReducer)[0];
    stateHook = $e229cb5c8b2cd629$var$updateReducer($e229cb5c8b2cd629$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $e229cb5c8b2cd629$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $e229cb5c8b2cd629$var$SuspenseException) throw $e229cb5c8b2cd629$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($e229cb5c8b2cd629$var$currentlyRenderingFiber.flags |= 2048, $e229cb5c8b2cd629$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $e229cb5c8b2cd629$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $e229cb5c8b2cd629$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $e229cb5c8b2cd629$var$rerenderActionState(action) {
    var stateHook = $e229cb5c8b2cd629$var$updateWorkInProgressHook(), currentStateHook = $e229cb5c8b2cd629$var$currentHook;
    if (null !== currentStateHook) return $e229cb5c8b2cd629$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $e229cb5c8b2cd629$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue(), $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $e229cb5c8b2cd629$var$updateRef() {
    return $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
}
function $e229cb5c8b2cd629$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    $e229cb5c8b2cd629$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $e229cb5c8b2cd629$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $e229cb5c8b2cd629$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $e229cb5c8b2cd629$var$currentHook && null !== deps && $e229cb5c8b2cd629$var$areHookInputsEqual(deps, $e229cb5c8b2cd629$var$currentHook.memoizedState.deps) ? hook.memoizedState = $e229cb5c8b2cd629$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($e229cb5c8b2cd629$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $e229cb5c8b2cd629$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $e229cb5c8b2cd629$var$mountEffect(create, deps) {
    $e229cb5c8b2cd629$var$mountEffectImpl(8390656, 8, create, deps);
}
function $e229cb5c8b2cd629$var$updateEffect(create, deps) {
    $e229cb5c8b2cd629$var$updateEffectImpl(2048, 8, create, deps);
}
function $e229cb5c8b2cd629$var$useEffectEventImpl(payload) {
    $e229cb5c8b2cd629$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue(), $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $e229cb5c8b2cd629$var$updateEvent(callback) {
    var ref = $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
    $e229cb5c8b2cd629$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($e229cb5c8b2cd629$var$executionContext & 2)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $e229cb5c8b2cd629$var$updateInsertionEffect(create, deps) {
    return $e229cb5c8b2cd629$var$updateEffectImpl(4, 2, create, deps);
}
function $e229cb5c8b2cd629$var$updateLayoutEffect(create, deps) {
    return $e229cb5c8b2cd629$var$updateEffectImpl(4, 4, create, deps);
}
function $e229cb5c8b2cd629$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $e229cb5c8b2cd629$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $e229cb5c8b2cd629$var$updateEffectImpl(4, 4, $e229cb5c8b2cd629$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $e229cb5c8b2cd629$var$mountDebugValue() {}
function $e229cb5c8b2cd629$var$updateCallback(callback, deps) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $e229cb5c8b2cd629$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $e229cb5c8b2cd629$var$updateMemo(nextCreate, deps) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $e229cb5c8b2cd629$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $e229cb5c8b2cd629$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($e229cb5c8b2cd629$var$renderLanes & 1073741824) && 0 === ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $e229cb5c8b2cd629$var$requestDeferredLane();
    $e229cb5c8b2cd629$var$currentlyRenderingFiber.lanes |= hook;
    $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $e229cb5c8b2cd629$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($e229cb5c8b2cd629$var$objectIs(value, prevValue)) return value;
    if (null !== $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor.current) return hook = $e229cb5c8b2cd629$var$mountDeferredValueImpl(hook, value, initialValue), $e229cb5c8b2cd629$var$objectIs(hook, prevValue) || ($e229cb5c8b2cd629$var$didReceiveUpdate = !0), hook;
    if (0 === ($e229cb5c8b2cd629$var$renderLanes & 42) || 0 !== ($e229cb5c8b2cd629$var$renderLanes & 1073741824) && 0 === ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 261930)) return $e229cb5c8b2cd629$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $e229cb5c8b2cd629$var$requestDeferredLane();
    $e229cb5c8b2cd629$var$currentlyRenderingFiber.lanes |= hook;
    $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $e229cb5c8b2cd629$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T, currentTransition = {};
    $e229cb5c8b2cd629$var$ReactSharedInternals.T = currentTransition;
    $e229cb5c8b2cd629$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $e229cb5c8b2cd629$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $e229cb5c8b2cd629$var$chainThenableValue(returnValue, finishedState);
            $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $e229cb5c8b2cd629$var$requestUpdateLane(fiber));
        } else $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, finishedState, $e229cb5c8b2cd629$var$requestUpdateLane(fiber));
    } catch (error) {
        $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $e229cb5c8b2cd629$var$requestUpdateLane());
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition;
    }
}
function $e229cb5c8b2cd629$var$noop() {}
function $e229cb5c8b2cd629$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(476));
    var queue = $e229cb5c8b2cd629$var$ensureFormComponentIsStateful(formFiber).queue;
    $e229cb5c8b2cd629$var$startTransition(formFiber, queue, pendingState, $e229cb5c8b2cd629$var$sharedNotPendingObject, null === action ? $e229cb5c8b2cd629$var$noop : function() {
        $e229cb5c8b2cd629$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $e229cb5c8b2cd629$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $e229cb5c8b2cd629$var$sharedNotPendingObject,
        baseState: $e229cb5c8b2cd629$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $e229cb5c8b2cd629$var$basicStateReducer,
            lastRenderedState: $e229cb5c8b2cd629$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $e229cb5c8b2cd629$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $e229cb5c8b2cd629$var$requestFormReset$1(formFiber) {
    var stateHook = $e229cb5c8b2cd629$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $e229cb5c8b2cd629$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $e229cb5c8b2cd629$var$requestUpdateLane());
}
function $e229cb5c8b2cd629$var$useHostTransitionStatus() {
    return $e229cb5c8b2cd629$var$readContext($e229cb5c8b2cd629$var$HostTransitionContext);
}
function $e229cb5c8b2cd629$var$updateId() {
    return $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
}
function $e229cb5c8b2cd629$var$updateRefresh() {
    return $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
}
function $e229cb5c8b2cd629$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $e229cb5c8b2cd629$var$requestUpdateLane();
                fiber = $e229cb5c8b2cd629$var$createUpdate(lane);
                var root$69 = $e229cb5c8b2cd629$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root$69, provider, lane), $e229cb5c8b2cd629$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $e229cb5c8b2cd629$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $e229cb5c8b2cd629$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $e229cb5c8b2cd629$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber) ? $e229cb5c8b2cd629$var$enqueueRenderPhaseUpdate(queue, action) : (action = $e229cb5c8b2cd629$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(action, fiber, lane), $e229cb5c8b2cd629$var$entangleTransitionUpdate(action, queue, lane)));
}
function $e229cb5c8b2cd629$var$dispatchSetState(fiber, queue, action) {
    var lane = $e229cb5c8b2cd629$var$requestUpdateLane();
    $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber)) $e229cb5c8b2cd629$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($e229cb5c8b2cd629$var$objectIs(eagerState, currentState)) return $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, queue, update, 0), null === $e229cb5c8b2cd629$var$workInProgressRoot && $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $e229cb5c8b2cd629$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(action, fiber, lane), $e229cb5c8b2cd629$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $e229cb5c8b2cd629$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $e229cb5c8b2cd629$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $e229cb5c8b2cd629$var$currentlyRenderingFiber || null !== alternate && alternate === $e229cb5c8b2cd629$var$currentlyRenderingFiber;
}
function $e229cb5c8b2cd629$var$enqueueRenderPhaseUpdate(queue, update) {
    $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass = $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $e229cb5c8b2cd629$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $e229cb5c8b2cd629$var$markRootEntangled(root, lane);
    }
}
var $e229cb5c8b2cd629$var$ContextOnlyDispatcher = {
    readContext: $e229cb5c8b2cd629$var$readContext,
    use: $e229cb5c8b2cd629$var$use,
    useCallback: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useContext: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useEffect: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useImperativeHandle: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useLayoutEffect: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useInsertionEffect: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useMemo: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useReducer: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useRef: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useState: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useDebugValue: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useDeferredValue: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useTransition: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useSyncExternalStore: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useId: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useHostTransitionStatus: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useFormState: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useActionState: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useOptimistic: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useMemoCache: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useCacheRefresh: $e229cb5c8b2cd629$var$throwInvalidHookError
};
$e229cb5c8b2cd629$var$ContextOnlyDispatcher.useEffectEvent = $e229cb5c8b2cd629$var$throwInvalidHookError;
var $e229cb5c8b2cd629$var$HooksDispatcherOnMount = {
    readContext: $e229cb5c8b2cd629$var$readContext,
    use: $e229cb5c8b2cd629$var$use,
    useCallback: function(callback, deps) {
        $e229cb5c8b2cd629$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $e229cb5c8b2cd629$var$readContext,
    useEffect: $e229cb5c8b2cd629$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $e229cb5c8b2cd629$var$mountEffectImpl(4194308, 4, $e229cb5c8b2cd629$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $e229cb5c8b2cd629$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $e229cb5c8b2cd629$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $e229cb5c8b2cd629$var$dispatchReducerAction.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $e229cb5c8b2cd629$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $e229cb5c8b2cd629$var$dispatchSetState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $e229cb5c8b2cd629$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        return $e229cb5c8b2cd629$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $e229cb5c8b2cd629$var$mountStateImpl(!1);
        stateHook = $e229cb5c8b2cd629$var$startTransition.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $e229cb5c8b2cd629$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $e229cb5c8b2cd629$var$currentlyRenderingFiber, hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        if ($e229cb5c8b2cd629$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $e229cb5c8b2cd629$var$workInProgressRoot) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(349));
            0 !== ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 127) || $e229cb5c8b2cd629$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $e229cb5c8b2cd629$var$mountEffect($e229cb5c8b2cd629$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $e229cb5c8b2cd629$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $e229cb5c8b2cd629$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook(), identifierPrefix = $e229cb5c8b2cd629$var$workInProgressRoot.identifierPrefix;
        if ($e229cb5c8b2cd629$var$isHydrating) {
            var JSCompiler_inline_result = $e229cb5c8b2cd629$var$treeContextOverflow;
            var idWithLeadingBit = $e229cb5c8b2cd629$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $e229cb5c8b2cd629$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $e229cb5c8b2cd629$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $e229cb5c8b2cd629$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $e229cb5c8b2cd629$var$useHostTransitionStatus,
    useFormState: $e229cb5c8b2cd629$var$mountActionState,
    useActionState: $e229cb5c8b2cd629$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $e229cb5c8b2cd629$var$dispatchOptimisticSetState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $e229cb5c8b2cd629$var$useMemoCache,
    useCacheRefresh: function() {
        return $e229cb5c8b2cd629$var$mountWorkInProgressHook().memoizedState = $e229cb5c8b2cd629$var$refreshCache.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($e229cb5c8b2cd629$var$executionContext & 2)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $e229cb5c8b2cd629$var$HooksDispatcherOnUpdate = {
    readContext: $e229cb5c8b2cd629$var$readContext,
    use: $e229cb5c8b2cd629$var$use,
    useCallback: $e229cb5c8b2cd629$var$updateCallback,
    useContext: $e229cb5c8b2cd629$var$readContext,
    useEffect: $e229cb5c8b2cd629$var$updateEffect,
    useImperativeHandle: $e229cb5c8b2cd629$var$updateImperativeHandle,
    useInsertionEffect: $e229cb5c8b2cd629$var$updateInsertionEffect,
    useLayoutEffect: $e229cb5c8b2cd629$var$updateLayoutEffect,
    useMemo: $e229cb5c8b2cd629$var$updateMemo,
    useReducer: $e229cb5c8b2cd629$var$updateReducer,
    useRef: $e229cb5c8b2cd629$var$updateRef,
    useState: function() {
        return $e229cb5c8b2cd629$var$updateReducer($e229cb5c8b2cd629$var$basicStateReducer);
    },
    useDebugValue: $e229cb5c8b2cd629$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
        return $e229cb5c8b2cd629$var$updateDeferredValueImpl(hook, $e229cb5c8b2cd629$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $e229cb5c8b2cd629$var$updateReducer($e229cb5c8b2cd629$var$basicStateReducer)[0], start = $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $e229cb5c8b2cd629$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $e229cb5c8b2cd629$var$updateSyncExternalStore,
    useId: $e229cb5c8b2cd629$var$updateId,
    useHostTransitionStatus: $e229cb5c8b2cd629$var$useHostTransitionStatus,
    useFormState: $e229cb5c8b2cd629$var$updateActionState,
    useActionState: $e229cb5c8b2cd629$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
        return $e229cb5c8b2cd629$var$updateOptimisticImpl(hook, $e229cb5c8b2cd629$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $e229cb5c8b2cd629$var$useMemoCache,
    useCacheRefresh: $e229cb5c8b2cd629$var$updateRefresh
};
$e229cb5c8b2cd629$var$HooksDispatcherOnUpdate.useEffectEvent = $e229cb5c8b2cd629$var$updateEvent;
var $e229cb5c8b2cd629$var$HooksDispatcherOnRerender = {
    readContext: $e229cb5c8b2cd629$var$readContext,
    use: $e229cb5c8b2cd629$var$use,
    useCallback: $e229cb5c8b2cd629$var$updateCallback,
    useContext: $e229cb5c8b2cd629$var$readContext,
    useEffect: $e229cb5c8b2cd629$var$updateEffect,
    useImperativeHandle: $e229cb5c8b2cd629$var$updateImperativeHandle,
    useInsertionEffect: $e229cb5c8b2cd629$var$updateInsertionEffect,
    useLayoutEffect: $e229cb5c8b2cd629$var$updateLayoutEffect,
    useMemo: $e229cb5c8b2cd629$var$updateMemo,
    useReducer: $e229cb5c8b2cd629$var$rerenderReducer,
    useRef: $e229cb5c8b2cd629$var$updateRef,
    useState: function() {
        return $e229cb5c8b2cd629$var$rerenderReducer($e229cb5c8b2cd629$var$basicStateReducer);
    },
    useDebugValue: $e229cb5c8b2cd629$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
        return null === $e229cb5c8b2cd629$var$currentHook ? $e229cb5c8b2cd629$var$mountDeferredValueImpl(hook, value, initialValue) : $e229cb5c8b2cd629$var$updateDeferredValueImpl(hook, $e229cb5c8b2cd629$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $e229cb5c8b2cd629$var$rerenderReducer($e229cb5c8b2cd629$var$basicStateReducer)[0], start = $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $e229cb5c8b2cd629$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $e229cb5c8b2cd629$var$updateSyncExternalStore,
    useId: $e229cb5c8b2cd629$var$updateId,
    useHostTransitionStatus: $e229cb5c8b2cd629$var$useHostTransitionStatus,
    useFormState: $e229cb5c8b2cd629$var$rerenderActionState,
    useActionState: $e229cb5c8b2cd629$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
        if (null !== $e229cb5c8b2cd629$var$currentHook) return $e229cb5c8b2cd629$var$updateOptimisticImpl(hook, $e229cb5c8b2cd629$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $e229cb5c8b2cd629$var$useMemoCache,
    useCacheRefresh: $e229cb5c8b2cd629$var$updateRefresh
};
$e229cb5c8b2cd629$var$HooksDispatcherOnRerender.useEffectEvent = $e229cb5c8b2cd629$var$updateEvent;
function $e229cb5c8b2cd629$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $e229cb5c8b2cd629$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $e229cb5c8b2cd629$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $e229cb5c8b2cd629$var$requestUpdateLane(), update = $e229cb5c8b2cd629$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $e229cb5c8b2cd629$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(payload, inst, lane), $e229cb5c8b2cd629$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $e229cb5c8b2cd629$var$requestUpdateLane(), update = $e229cb5c8b2cd629$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $e229cb5c8b2cd629$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(payload, inst, lane), $e229cb5c8b2cd629$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $e229cb5c8b2cd629$var$requestUpdateLane(), update = $e229cb5c8b2cd629$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $e229cb5c8b2cd629$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(callback, inst, lane), $e229cb5c8b2cd629$var$entangleTransitions(callback, inst, lane));
    }
};
function $e229cb5c8b2cd629$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$e229cb5c8b2cd629$var$shallowEqual(oldProps, newProps) || !$e229cb5c8b2cd629$var$shallowEqual(oldState, newState) : !0;
}
function $e229cb5c8b2cd629$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $e229cb5c8b2cd629$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $e229cb5c8b2cd629$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $e229cb5c8b2cd629$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $e229cb5c8b2cd629$var$defaultOnUncaughtError(error) {
    $e229cb5c8b2cd629$var$reportGlobalError(error);
}
function $e229cb5c8b2cd629$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $e229cb5c8b2cd629$var$defaultOnRecoverableError(error) {
    $e229cb5c8b2cd629$var$reportGlobalError(error);
}
function $e229cb5c8b2cd629$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $e229cb5c8b2cd629$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $e229cb5c8b2cd629$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $e229cb5c8b2cd629$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $e229cb5c8b2cd629$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $e229cb5c8b2cd629$var$createClassErrorUpdate(lane) {
    lane = $e229cb5c8b2cd629$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $e229cb5c8b2cd629$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $e229cb5c8b2cd629$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $e229cb5c8b2cd629$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed ? $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $e229cb5c8b2cd629$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $e229cb5c8b2cd629$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $e229cb5c8b2cd629$var$shellBoundary ? $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $e229cb5c8b2cd629$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $e229cb5c8b2cd629$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $e229cb5c8b2cd629$var$attachPingListener(root, value, rootRenderLanes);
        $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($e229cb5c8b2cd629$var$isHydrating) return returnFiber = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $e229cb5c8b2cd629$var$HydrationMismatchException && (root = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(422), {
        cause: value
    }), $e229cb5c8b2cd629$var$queueHydrationError($e229cb5c8b2cd629$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $e229cb5c8b2cd629$var$HydrationMismatchException && (returnFiber = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(423), {
        cause: value
    }), $e229cb5c8b2cd629$var$queueHydrationError($e229cb5c8b2cd629$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $e229cb5c8b2cd629$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $e229cb5c8b2cd629$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors ? $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $e229cb5c8b2cd629$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $e229cb5c8b2cd629$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed || !$e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $e229cb5c8b2cd629$var$createClassErrorUpdate(rootRenderLanes), $e229cb5c8b2cd629$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $e229cb5c8b2cd629$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $e229cb5c8b2cd629$var$SelectiveHydrationException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(461)), $e229cb5c8b2cd629$var$didReceiveUpdate = !1;
function $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $e229cb5c8b2cd629$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $e229cb5c8b2cd629$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress);
    nextProps = $e229cb5c8b2cd629$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $e229cb5c8b2cd629$var$checkDidRenderIdHook();
    if (null !== current && !$e229cb5c8b2cd629$var$didReceiveUpdate) return $e229cb5c8b2cd629$var$bailoutHooks(current, workInProgress, renderLanes), $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $e229cb5c8b2cd629$var$isHydrating && key && $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$e229cb5c8b2cd629$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $e229cb5c8b2cd629$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$e229cb5c8b2cd629$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $e229cb5c8b2cd629$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $e229cb5c8b2cd629$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $e229cb5c8b2cd629$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($e229cb5c8b2cd629$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($e229cb5c8b2cd629$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $e229cb5c8b2cd629$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($e229cb5c8b2cd629$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $e229cb5c8b2cd629$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $e229cb5c8b2cd629$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $e229cb5c8b2cd629$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $e229cb5c8b2cd629$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $e229cb5c8b2cd629$var$pushHiddenContext(workInProgress, prevState) : $e229cb5c8b2cd629$var$reuseHiddenContextOnStack(), $e229cb5c8b2cd629$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $e229cb5c8b2cd629$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($e229cb5c8b2cd629$var$pushTransition(workInProgress, prevState.cachePool), $e229cb5c8b2cd629$var$pushHiddenContext(workInProgress, prevState), $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $e229cb5c8b2cd629$var$pushTransition(workInProgress, null), $e229cb5c8b2cd629$var$reuseHiddenContextOnStack(), $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress));
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $e229cb5c8b2cd629$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $e229cb5c8b2cd629$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $e229cb5c8b2cd629$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $e229cb5c8b2cd629$var$pushTransition(workInProgress, null);
    $e229cb5c8b2cd629$var$reuseHiddenContextOnStack();
    $e229cb5c8b2cd629$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $e229cb5c8b2cd629$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $e229cb5c8b2cd629$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $e229cb5c8b2cd629$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $e229cb5c8b2cd629$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($e229cb5c8b2cd629$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $e229cb5c8b2cd629$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $e229cb5c8b2cd629$var$bailoutOffscreenComponent(null, current);
            $e229cb5c8b2cd629$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $e229cb5c8b2cd629$var$nextHydratableInstance) ? (current = $e229cb5c8b2cd629$var$canHydrateHydrationBoundary(current, $e229cb5c8b2cd629$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $e229cb5c8b2cd629$var$treeContextProvider ? {
                    id: $e229cb5c8b2cd629$var$treeContextId,
                    overflow: $e229cb5c8b2cd629$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $e229cb5c8b2cd629$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $e229cb5c8b2cd629$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $e229cb5c8b2cd629$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $e229cb5c8b2cd629$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(558));
        } else if ($e229cb5c8b2cd629$var$didReceiveUpdate || $e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $e229cb5c8b2cd629$var$didReceiveUpdate || didSuspend) {
            nextProps = $e229cb5c8b2cd629$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $e229cb5c8b2cd629$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(current, dehydrated), $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $e229cb5c8b2cd629$var$SelectiveHydrationException;
            $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible();
            workInProgress = $e229cb5c8b2cd629$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(dehydrated.nextSibling), $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$isHydrating = !0, $e229cb5c8b2cd629$var$hydrationErrors = null, $e229cb5c8b2cd629$var$rootOrSingletonContext = !1, null !== current && $e229cb5c8b2cd629$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $e229cb5c8b2cd629$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $e229cb5c8b2cd629$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $e229cb5c8b2cd629$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $e229cb5c8b2cd629$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress);
    Component = $e229cb5c8b2cd629$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $e229cb5c8b2cd629$var$checkDidRenderIdHook();
    if (null !== current && !$e229cb5c8b2cd629$var$didReceiveUpdate) return $e229cb5c8b2cd629$var$bailoutHooks(current, workInProgress, renderLanes), $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $e229cb5c8b2cd629$var$isHydrating && nextProps && $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $e229cb5c8b2cd629$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $e229cb5c8b2cd629$var$finishRenderingHooks(current);
    Component = $e229cb5c8b2cd629$var$checkDidRenderIdHook();
    if (null !== current && !$e229cb5c8b2cd629$var$didReceiveUpdate) return $e229cb5c8b2cd629$var$bailoutHooks(current, workInProgress, renderLanes), $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $e229cb5c8b2cd629$var$isHydrating && Component && $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $e229cb5c8b2cd629$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $e229cb5c8b2cd629$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $e229cb5c8b2cd629$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $e229cb5c8b2cd629$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $e229cb5c8b2cd629$var$readContext(contextType) : $e229cb5c8b2cd629$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($e229cb5c8b2cd629$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $e229cb5c8b2cd629$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $e229cb5c8b2cd629$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $e229cb5c8b2cd629$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $e229cb5c8b2cd629$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $e229cb5c8b2cd629$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $e229cb5c8b2cd629$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $e229cb5c8b2cd629$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($e229cb5c8b2cd629$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $e229cb5c8b2cd629$var$hasForceUpdate || $e229cb5c8b2cd629$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $e229cb5c8b2cd629$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $e229cb5c8b2cd629$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $e229cb5c8b2cd629$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $e229cb5c8b2cd629$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $e229cb5c8b2cd629$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $e229cb5c8b2cd629$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $e229cb5c8b2cd629$var$hasForceUpdate || null !== current && null !== current.dependencies && $e229cb5c8b2cd629$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($e229cb5c8b2cd629$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $e229cb5c8b2cd629$var$hasForceUpdate || $e229cb5c8b2cd629$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $e229cb5c8b2cd629$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $e229cb5c8b2cd629$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $e229cb5c8b2cd629$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $e229cb5c8b2cd629$var$resetHydrationState();
    workInProgress.flags |= 256;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $e229cb5c8b2cd629$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $e229cb5c8b2cd629$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $e229cb5c8b2cd629$var$getSuspendedCache()
    };
}
function $e229cb5c8b2cd629$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $e229cb5c8b2cd629$var$workInProgressDeferredLane);
    return current;
}
function $e229cb5c8b2cd629$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($e229cb5c8b2cd629$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($e229cb5c8b2cd629$var$isHydrating) {
            showFallback ? $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $e229cb5c8b2cd629$var$nextHydratableInstance) ? (current = $e229cb5c8b2cd629$var$canHydrateHydrationBoundary(current, $e229cb5c8b2cd629$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $e229cb5c8b2cd629$var$treeContextProvider ? {
                    id: $e229cb5c8b2cd629$var$treeContextId,
                    overflow: $e229cb5c8b2cd629$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $e229cb5c8b2cd629$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress);
            $e229cb5c8b2cd629$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $e229cb5c8b2cd629$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $e229cb5c8b2cd629$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $e229cb5c8b2cd629$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $e229cb5c8b2cd629$var$SUSPENDED_MARKER, $e229cb5c8b2cd629$var$bailoutOffscreenComponent(null, nextProps);
        $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $e229cb5c8b2cd629$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $e229cb5c8b2cd629$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $e229cb5c8b2cd629$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $e229cb5c8b2cd629$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $e229cb5c8b2cd629$var$SUSPENDED_MARKER, workInProgress = $e229cb5c8b2cd629$var$bailoutOffscreenComponent(null, nextProps));
        else if ($e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress), $e229cb5c8b2cd629$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $e229cb5c8b2cd629$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($e229cb5c8b2cd629$var$didReceiveUpdate || $e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $e229cb5c8b2cd629$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $e229cb5c8b2cd629$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $e229cb5c8b2cd629$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(current, nextProps), $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $e229cb5c8b2cd629$var$SelectiveHydrationException;
            $e229cb5c8b2cd629$var$isSuspenseInstancePending(nextPrimaryChildren) || $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible();
            workInProgress = $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $e229cb5c8b2cd629$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(nextPrimaryChildren.nextSibling), $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$isHydrating = !0, $e229cb5c8b2cd629$var$hydrationErrors = null, $e229cb5c8b2cd629$var$rootOrSingletonContext = !1, null !== current && $e229cb5c8b2cd629$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $e229cb5c8b2cd629$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $e229cb5c8b2cd629$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $e229cb5c8b2cd629$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $e229cb5c8b2cd629$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $e229cb5c8b2cd629$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $e229cb5c8b2cd629$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $e229cb5c8b2cd629$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $e229cb5c8b2cd629$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $e229cb5c8b2cd629$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $e229cb5c8b2cd629$var$SUSPENDED_MARKER, $e229cb5c8b2cd629$var$bailoutOffscreenComponent(current.child, nextProps);
    $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $e229cb5c8b2cd629$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $e229cb5c8b2cd629$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $e229cb5c8b2cd629$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $e229cb5c8b2cd629$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $e229cb5c8b2cd629$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $e229cb5c8b2cd629$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $e229cb5c8b2cd629$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, suspenseContext);
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $e229cb5c8b2cd629$var$isHydrating ? $e229cb5c8b2cd629$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $e229cb5c8b2cd629$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $e229cb5c8b2cd629$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $e229cb5c8b2cd629$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $e229cb5c8b2cd629$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $e229cb5c8b2cd629$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $e229cb5c8b2cd629$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $e229cb5c8b2cd629$var$checkIfContextChanged(current) ? !0 : !1;
}
function $e229cb5c8b2cd629$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $e229cb5c8b2cd629$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, current.memoizedState.cache);
            $e229cb5c8b2cd629$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $e229cb5c8b2cd629$var$pushHostContext(workInProgress);
            break;
        case 4:
            $e229cb5c8b2cd629$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $e229cb5c8b2cd629$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $e229cb5c8b2cd629$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $e229cb5c8b2cd629$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $e229cb5c8b2cd629$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $e229cb5c8b2cd629$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, current.memoizedState.cache);
    }
    return $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $e229cb5c8b2cd629$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $e229cb5c8b2cd629$var$didReceiveUpdate = !0;
        else {
            if (!$e229cb5c8b2cd629$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $e229cb5c8b2cd629$var$didReceiveUpdate = !1, $e229cb5c8b2cd629$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $e229cb5c8b2cd629$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $e229cb5c8b2cd629$var$didReceiveUpdate = !1, $e229cb5c8b2cd629$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $e229cb5c8b2cd629$var$pushTreeId(workInProgress, $e229cb5c8b2cd629$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $e229cb5c8b2cd629$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $e229cb5c8b2cd629$var$shouldConstruct(current) ? (props = $e229cb5c8b2cd629$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $e229cb5c8b2cd629$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $e229cb5c8b2cd629$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $e229cb5c8b2cd629$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $e229cb5c8b2cd629$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $e229cb5c8b2cd629$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $e229cb5c8b2cd629$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $e229cb5c8b2cd629$var$getComponentNameFromType(current) || current;
                    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $e229cb5c8b2cd629$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $e229cb5c8b2cd629$var$resolveClassComponentProps(props, workInProgress.pendingProps), $e229cb5c8b2cd629$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $e229cb5c8b2cd629$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $e229cb5c8b2cd629$var$cloneUpdateQueue(current, workInProgress);
                $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, props);
                props !== prevState.cache && $e229cb5c8b2cd629$var$propagateContextChanges(workInProgress, [
                    $e229cb5c8b2cd629$var$CacheContext
                ], renderLanes, !0);
                $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $e229cb5c8b2cd629$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(Error($e229cb5c8b2cd629$var$formatProdErrorMessage(424)), workInProgress);
                        $e229cb5c8b2cd629$var$queueHydrationError($$typeof);
                        workInProgress = $e229cb5c8b2cd629$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(current.firstChild);
                        $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress;
                        $e229cb5c8b2cd629$var$isHydrating = !0;
                        $e229cb5c8b2cd629$var$hydrationErrors = null;
                        $e229cb5c8b2cd629$var$rootOrSingletonContext = !0;
                        renderLanes = $e229cb5c8b2cd629$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $e229cb5c8b2cd629$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $e229cb5c8b2cd629$var$markRef(current, workInProgress), null === current ? (renderLanes = $e229cb5c8b2cd629$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $e229cb5c8b2cd629$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer($e229cb5c8b2cd629$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress, props[$e229cb5c8b2cd629$var$internalPropsKey] = current, $e229cb5c8b2cd629$var$setInitialProperties(props, renderLanes, current), $e229cb5c8b2cd629$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $e229cb5c8b2cd629$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $e229cb5c8b2cd629$var$pushHostContext(workInProgress), null === current && $e229cb5c8b2cd629$var$isHydrating && (props = workInProgress.stateNode = $e229cb5c8b2cd629$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $e229cb5c8b2cd629$var$rootInstanceStackCursor.current), $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$rootOrSingletonContext = !0, $$typeof = $e229cb5c8b2cd629$var$nextHydratableInstance, $e229cb5c8b2cd629$var$isSingletonScope(workInProgress.type) ? ($e229cb5c8b2cd629$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(props.firstChild)) : $e229cb5c8b2cd629$var$nextHydratableInstance = $$typeof), $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $e229cb5c8b2cd629$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $e229cb5c8b2cd629$var$isHydrating) {
                if ($$typeof = props = $e229cb5c8b2cd629$var$nextHydratableInstance) props = $e229cb5c8b2cd629$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $e229cb5c8b2cd629$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(props.firstChild), $e229cb5c8b2cd629$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress);
            }
            $e229cb5c8b2cd629$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $e229cb5c8b2cd629$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $e229cb5c8b2cd629$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $e229cb5c8b2cd629$var$renderWithHooks(current, workInProgress, $e229cb5c8b2cd629$var$TransitionAwareHostComponent, null, null, renderLanes), $e229cb5c8b2cd629$var$HostTransitionContext._currentValue = $$typeof);
            $e229cb5c8b2cd629$var$markRef(current, workInProgress);
            $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $e229cb5c8b2cd629$var$isHydrating) {
                if (current = renderLanes = $e229cb5c8b2cd629$var$nextHydratableInstance) renderLanes = $e229cb5c8b2cd629$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $e229cb5c8b2cd629$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $e229cb5c8b2cd629$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $e229cb5c8b2cd629$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $e229cb5c8b2cd629$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $e229cb5c8b2cd629$var$pushProvider(workInProgress, workInProgress.type, props.value), $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress), $$typeof = $e229cb5c8b2cd629$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $e229cb5c8b2cd629$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $e229cb5c8b2cd629$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $e229cb5c8b2cd629$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $e229cb5c8b2cd629$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $e229cb5c8b2cd629$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress), props = $e229cb5c8b2cd629$var$readContext($e229cb5c8b2cd629$var$CacheContext), null === current ? ($$typeof = $e229cb5c8b2cd629$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $e229cb5c8b2cd629$var$workInProgressRoot, prevState = $e229cb5c8b2cd629$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $e229cb5c8b2cd629$var$initializeUpdateQueue(workInProgress), $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($e229cb5c8b2cd629$var$cloneUpdateQueue(current, workInProgress), $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, null, null, renderLanes), $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, props)) : (props = prevState.cache, $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, props), props !== $$typeof.cache && $e229cb5c8b2cd629$var$propagateContextChanges(workInProgress, [
                $e229cb5c8b2cd629$var$CacheContext
            ], renderLanes, !0))), $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $e229cb5c8b2cd629$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $e229cb5c8b2cd629$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($e229cb5c8b2cd629$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $e229cb5c8b2cd629$var$suspendedThenable = $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable, $e229cb5c8b2cd629$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $e229cb5c8b2cd629$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$e229cb5c8b2cd629$var$preloadResource(resource)) {
        if ($e229cb5c8b2cd629$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $e229cb5c8b2cd629$var$suspendedThenable = $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable, $e229cb5c8b2cd629$var$SuspenseyCommitException;
    }
}
function $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $e229cb5c8b2cd629$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $e229cb5c8b2cd629$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$e229cb5c8b2cd629$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $e229cb5c8b2cd629$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $e229cb5c8b2cd629$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $e229cb5c8b2cd629$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 1:
            return $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext);
            $e229cb5c8b2cd629$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $e229cb5c8b2cd629$var$popHydrationState(workInProgress) ? $e229cb5c8b2cd629$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $e229cb5c8b2cd629$var$upgradeHydrationErrorsToRecoverable());
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($e229cb5c8b2cd629$var$markUpdate(workInProgress), null !== nextResource ? ($e229cb5c8b2cd629$var$bubbleProperties(workInProgress), $e229cb5c8b2cd629$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($e229cb5c8b2cd629$var$bubbleProperties(workInProgress), $e229cb5c8b2cd629$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($e229cb5c8b2cd629$var$markUpdate(workInProgress), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), $e229cb5c8b2cd629$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($e229cb5c8b2cd629$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), $e229cb5c8b2cd629$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $e229cb5c8b2cd629$var$popHostContext(workInProgress);
            renderLanes = $e229cb5c8b2cd629$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(166));
                    $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $e229cb5c8b2cd629$var$contextStackCursor.current;
                $e229cb5c8b2cd629$var$popHydrationState(workInProgress) ? $e229cb5c8b2cd629$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $e229cb5c8b2cd629$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $e229cb5c8b2cd629$var$markUpdate(workInProgress));
            }
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $e229cb5c8b2cd629$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(166));
                    $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $e229cb5c8b2cd629$var$contextStackCursor.current;
                if ($e229cb5c8b2cd629$var$popHydrationState(workInProgress)) $e229cb5c8b2cd629$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer($e229cb5c8b2cd629$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress;
                    nextResource[$e229cb5c8b2cd629$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($e229cb5c8b2cd629$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress);
                }
            }
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            $e229cb5c8b2cd629$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(166));
                current = $e229cb5c8b2cd629$var$rootInstanceStackCursor.current;
                if ($e229cb5c8b2cd629$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $e229cb5c8b2cd629$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $e229cb5c8b2cd629$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $e229cb5c8b2cd629$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(557));
                        current[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress;
                    } else $e229cb5c8b2cd629$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $e229cb5c8b2cd629$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress), workInProgress;
                    $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(558));
            }
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $e229cb5c8b2cd629$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(317));
                        type[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress;
                    } else $e229cb5c8b2cd629$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $e229cb5c8b2cd629$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress), workInProgress;
                    $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $e229cb5c8b2cd629$var$popHostContainer(), null === current && $e229cb5c8b2cd629$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 10:
            return $e229cb5c8b2cd629$var$popProvider(workInProgress.type), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 19:
            $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $e229cb5c8b2cd629$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $e229cb5c8b2cd629$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $e229cb5c8b2cd629$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $e229cb5c8b2cd629$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$e229cb5c8b2cd629$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current & 1 | 2);
                            $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $e229cb5c8b2cd629$var$now() > $e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $e229cb5c8b2cd629$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $e229cb5c8b2cd629$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, current), $e229cb5c8b2cd629$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$e229cb5c8b2cd629$var$isHydrating) return $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
                    } else 2 * $e229cb5c8b2cd629$var$now() - newProps.renderingStartTime > $e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $e229cb5c8b2cd629$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $e229cb5c8b2cd629$var$now(), current.sibling = null, renderLanes = $e229cb5c8b2cd629$var$suspenseStackCursor.current, $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress), $e229cb5c8b2cd629$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($e229cb5c8b2cd629$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $e229cb5c8b2cd629$var$unwindWork(current, workInProgress) {
    $e229cb5c8b2cd629$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext), $e229cb5c8b2cd629$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $e229cb5c8b2cd629$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(340));
                $e229cb5c8b2cd629$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(340));
                $e229cb5c8b2cd629$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseStackCursor), null;
        case 4:
            return $e229cb5c8b2cd629$var$popHostContainer(), null;
        case 10:
            return $e229cb5c8b2cd629$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress), $e229cb5c8b2cd629$var$popHiddenContext(), null !== current && $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $e229cb5c8b2cd629$var$unwindInterruptedWork(current, interruptedWork) {
    $e229cb5c8b2cd629$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext);
            $e229cb5c8b2cd629$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $e229cb5c8b2cd629$var$popHostContext(interruptedWork);
            break;
        case 4:
            $e229cb5c8b2cd629$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $e229cb5c8b2cd629$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $e229cb5c8b2cd629$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseStackCursor);
            break;
        case 10:
            $e229cb5c8b2cd629$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $e229cb5c8b2cd629$var$popSuspenseHandler(interruptedWork);
            $e229cb5c8b2cd629$var$popHiddenContext();
            null !== current && $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$resumedCache);
            break;
        case 24:
            $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext);
    }
}
function $e229cb5c8b2cd629$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $e229cb5c8b2cd629$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $e229cb5c8b2cd629$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $e229cb5c8b2cd629$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $e229cb5c8b2cd629$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $e229cb5c8b2cd629$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $e229cb5c8b2cd629$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $e229cb5c8b2cd629$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $e229cb5c8b2cd629$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$e229cb5c8b2cd629$var$internalPropsKey] = newProps;
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $e229cb5c8b2cd629$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $e229cb5c8b2cd629$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $e229cb5c8b2cd629$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $e229cb5c8b2cd629$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $e229cb5c8b2cd629$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $e229cb5c8b2cd629$var$noop$1));
    else if (4 !== tag && (27 === tag && $e229cb5c8b2cd629$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($e229cb5c8b2cd629$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$e229cb5c8b2cd629$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $e229cb5c8b2cd629$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $e229cb5c8b2cd629$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($e229cb5c8b2cd629$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$e229cb5c8b2cd629$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $e229cb5c8b2cd629$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $e229cb5c8b2cd629$var$setInitialProperties(singleton, type, props);
        singleton[$e229cb5c8b2cd629$var$internalInstanceKey] = finishedWork;
        singleton[$e229cb5c8b2cd629$var$internalPropsKey] = props;
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = !1, $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = !1, $e229cb5c8b2cd629$var$needsFormReset = !1, $e229cb5c8b2cd629$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $e229cb5c8b2cd629$var$nextEffect = null;
function $e229cb5c8b2cd629$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $e229cb5c8b2cd629$var$eventsEnabled = $e229cb5c8b2cd629$var$_enabled;
    root = $e229cb5c8b2cd629$var$getActiveElementDeep(root);
    if ($e229cb5c8b2cd629$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $e229cb5c8b2cd629$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $e229cb5c8b2cd629$var$_enabled = !1;
    for($e229cb5c8b2cd629$var$nextEffect = firstChild; null !== $e229cb5c8b2cd629$var$nextEffect;)if (firstChild = $e229cb5c8b2cd629$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $e229cb5c8b2cd629$var$nextEffect = root;
    else for(; null !== $e229cb5c8b2cd629$var$nextEffect;){
        firstChild = $e229cb5c8b2cd629$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $e229cb5c8b2cd629$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $e229cb5c8b2cd629$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $e229cb5c8b2cd629$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $e229cb5c8b2cd629$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $e229cb5c8b2cd629$var$nextEffect = root;
            break;
        }
        $e229cb5c8b2cd629$var$nextEffect = firstChild.return;
    }
}
function $e229cb5c8b2cd629$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $e229cb5c8b2cd629$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $e229cb5c8b2cd629$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $e229cb5c8b2cd629$var$commitClassCallbacks(finishedWork);
            flags & 512 && $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $e229cb5c8b2cd629$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $e229cb5c8b2cd629$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $e229cb5c8b2cd629$var$commitHostMount(finishedWork);
            flags & 512 && $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $e229cb5c8b2cd629$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $e229cb5c8b2cd629$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $e229cb5c8b2cd629$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $e229cb5c8b2cd629$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden;
                prevProps = $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden;
                $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = flags;
                ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = prevProps;
                $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $e229cb5c8b2cd629$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $e229cb5c8b2cd629$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $e229cb5c8b2cd629$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $e229cb5c8b2cd629$var$hostParent = null, $e229cb5c8b2cd629$var$hostParentIsContainer = !1;
function $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$e229cb5c8b2cd629$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $e229cb5c8b2cd629$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($e229cb5c8b2cd629$var$injectedHook && "function" === typeof $e229cb5c8b2cd629$var$injectedHook.onCommitFiberUnmount) try {
        $e229cb5c8b2cd629$var$injectedHook.onCommitFiberUnmount($e229cb5c8b2cd629$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $e229cb5c8b2cd629$var$hostParent, prevHostParentIsContainer = $e229cb5c8b2cd629$var$hostParentIsContainer;
            $e229cb5c8b2cd629$var$isSingletonScope(deletedFiber.type) && ($e229cb5c8b2cd629$var$hostParent = deletedFiber.stateNode, $e229cb5c8b2cd629$var$hostParentIsContainer = !1);
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e229cb5c8b2cd629$var$releaseSingletonInstance(deletedFiber.stateNode);
            $e229cb5c8b2cd629$var$hostParent = prevHostParent;
            $e229cb5c8b2cd629$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $e229cb5c8b2cd629$var$hostParent;
            prevHostParentIsContainer = $e229cb5c8b2cd629$var$hostParentIsContainer;
            $e229cb5c8b2cd629$var$hostParent = null;
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e229cb5c8b2cd629$var$hostParent = prevHostParent;
            $e229cb5c8b2cd629$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $e229cb5c8b2cd629$var$hostParent) {
                if ($e229cb5c8b2cd629$var$hostParentIsContainer) try {
                    (9 === $e229cb5c8b2cd629$var$hostParent.nodeType ? $e229cb5c8b2cd629$var$hostParent.body : "HTML" === $e229cb5c8b2cd629$var$hostParent.nodeName ? $e229cb5c8b2cd629$var$hostParent.ownerDocument.body : $e229cb5c8b2cd629$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $e229cb5c8b2cd629$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $e229cb5c8b2cd629$var$hostParent && ($e229cb5c8b2cd629$var$hostParentIsContainer ? (finishedRoot = $e229cb5c8b2cd629$var$hostParent, $e229cb5c8b2cd629$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $e229cb5c8b2cd629$var$retryIfBlockedOn(finishedRoot)) : $e229cb5c8b2cd629$var$clearHydrationBoundary($e229cb5c8b2cd629$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $e229cb5c8b2cd629$var$hostParent;
            prevHostParentIsContainer = $e229cb5c8b2cd629$var$hostParentIsContainer;
            $e229cb5c8b2cd629$var$hostParent = deletedFiber.stateNode.containerInfo;
            $e229cb5c8b2cd629$var$hostParentIsContainer = !0;
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e229cb5c8b2cd629$var$hostParent = prevHostParent;
            $e229cb5c8b2cd629$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $e229cb5c8b2cd629$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || ($e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $e229cb5c8b2cd629$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = (prevHostParent = $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $e229cb5c8b2cd629$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $e229cb5c8b2cd629$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $e229cb5c8b2cd629$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $e229cb5c8b2cd629$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $e229cb5c8b2cd629$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $e229cb5c8b2cd629$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $e229cb5c8b2cd629$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $e229cb5c8b2cd629$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($e229cb5c8b2cd629$var$isSingletonScope(parent.type)) {
                        $e229cb5c8b2cd629$var$hostParent = parent.stateNode;
                        $e229cb5c8b2cd629$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $e229cb5c8b2cd629$var$hostParent = parent.stateNode;
                    $e229cb5c8b2cd629$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $e229cb5c8b2cd629$var$hostParent = parent.stateNode.containerInfo;
                    $e229cb5c8b2cd629$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $e229cb5c8b2cd629$var$hostParent) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(160));
        $e229cb5c8b2cd629$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $e229cb5c8b2cd629$var$hostParent = null;
        $e229cb5c8b2cd629$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $e229cb5c8b2cd629$var$currentHoistableRoot = null;
function $e229cb5c8b2cd629$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($e229cb5c8b2cd629$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $e229cb5c8b2cd629$var$commitHookEffectListMount(3, finishedWork), $e229cb5c8b2cd629$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            flags & 64 && $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $e229cb5c8b2cd629$var$currentHoistableRoot;
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$e229cb5c8b2cd629$var$internalHoistableMarker] || currentResource[$e229cb5c8b2cd629$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $e229cb5c8b2cd629$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$e229cb5c8b2cd629$var$internalInstanceKey] = finishedWork;
                                        $e229cb5c8b2cd629$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $e229cb5c8b2cd629$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $e229cb5c8b2cd629$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $e229cb5c8b2cd629$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $e229cb5c8b2cd629$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$e229cb5c8b2cd629$var$internalInstanceKey] = finishedWork;
                                $e229cb5c8b2cd629$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $e229cb5c8b2cd629$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $e229cb5c8b2cd629$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $e229cb5c8b2cd629$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $e229cb5c8b2cd629$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $e229cb5c8b2cd629$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $e229cb5c8b2cd629$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $e229cb5c8b2cd629$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $e229cb5c8b2cd629$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($e229cb5c8b2cd629$var$needsFormReset = !0);
            break;
        case 6:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $e229cb5c8b2cd629$var$tagCaches = null;
            hoistableRoot = $e229cb5c8b2cd629$var$currentHoistableRoot;
            $e229cb5c8b2cd629$var$currentHoistableRoot = $e229cb5c8b2cd629$var$getHoistableRoot(root.containerInfo);
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$currentHoistableRoot = hoistableRoot;
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $e229cb5c8b2cd629$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $e229cb5c8b2cd629$var$needsFormReset && ($e229cb5c8b2cd629$var$needsFormReset = !1, $e229cb5c8b2cd629$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $e229cb5c8b2cd629$var$currentHoistableRoot;
            $e229cb5c8b2cd629$var$currentHoistableRoot = $e229cb5c8b2cd629$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            $e229cb5c8b2cd629$var$currentHoistableRoot = flags;
            break;
        case 12:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($e229cb5c8b2cd629$var$globalMostRecentFallbackTime = $e229cb5c8b2cd629$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden;
            $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden || $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $e229cb5c8b2cd629$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $e229cb5c8b2cd629$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $e229cb5c8b2cd629$var$hideOrUnhideDehydratedBoundary(instance, !0) : $e229cb5c8b2cd629$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $e229cb5c8b2cd629$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork), $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
    }
}
function $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($e229cb5c8b2cd629$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $e229cb5c8b2cd629$var$getHostSibling(finishedWork);
                    $e229cb5c8b2cd629$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($e229cb5c8b2cd629$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $e229cb5c8b2cd629$var$getHostSibling(finishedWork);
                    $e229cb5c8b2cd629$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $e229cb5c8b2cd629$var$getHostSibling(finishedWork);
                    $e229cb5c8b2cd629$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $e229cb5c8b2cd629$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $e229cb5c8b2cd629$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $e229cb5c8b2cd629$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $e229cb5c8b2cd629$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $e229cb5c8b2cd629$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $e229cb5c8b2cd629$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $e229cb5c8b2cd629$var$safelyDetachRef(finishedWork, finishedWork.return);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $e229cb5c8b2cd629$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$e229cb5c8b2cd629$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $e229cb5c8b2cd629$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $e229cb5c8b2cd629$var$commitClassCallbacks(finishedWork);
                $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $e229cb5c8b2cd629$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $e229cb5c8b2cd629$var$commitHostMount(finishedWork);
                $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $e229cb5c8b2cd629$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $e229cb5c8b2cd629$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $e229cb5c8b2cd629$var$releaseCache(previousCache));
}
function $e229cb5c8b2cd629$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $e229cb5c8b2cd629$var$releaseCache(current));
}
function $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $e229cb5c8b2cd629$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $e229cb5c8b2cd629$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $e229cb5c8b2cd629$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $e229cb5c8b2cd629$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $e229cb5c8b2cd629$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $e229cb5c8b2cd629$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $e229cb5c8b2cd629$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $e229cb5c8b2cd629$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $e229cb5c8b2cd629$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $e229cb5c8b2cd629$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $e229cb5c8b2cd629$var$suspenseyCommitFlag = 8192;
function $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $e229cb5c8b2cd629$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $e229cb5c8b2cd629$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $e229cb5c8b2cd629$var$suspenseyCommitFlag && null !== fiber.memoizedState && $e229cb5c8b2cd629$var$suspendResource(suspendedState, $e229cb5c8b2cd629$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $e229cb5c8b2cd629$var$currentHoistableRoot;
            $e229cb5c8b2cd629$var$currentHoistableRoot = $e229cb5c8b2cd629$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $e229cb5c8b2cd629$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $e229cb5c8b2cd629$var$suspenseyCommitFlag, $e229cb5c8b2cd629$var$suspenseyCommitFlag = 16777216, $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $e229cb5c8b2cd629$var$suspenseyCommitFlag = previousHoistableRoot) : $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $e229cb5c8b2cd629$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $e229cb5c8b2cd629$var$nextEffect = childToDelete;
            $e229cb5c8b2cd629$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $e229cb5c8b2cd629$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $e229cb5c8b2cd629$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $e229cb5c8b2cd629$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $e229cb5c8b2cd629$var$nextEffect = childToDelete;
            $e229cb5c8b2cd629$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $e229cb5c8b2cd629$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $e229cb5c8b2cd629$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $e229cb5c8b2cd629$var$nextEffect;){
        var fiber = $e229cb5c8b2cd629$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $e229cb5c8b2cd629$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $e229cb5c8b2cd629$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $e229cb5c8b2cd629$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $e229cb5c8b2cd629$var$nextEffect;){
            cache = $e229cb5c8b2cd629$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $e229cb5c8b2cd629$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $e229cb5c8b2cd629$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $e229cb5c8b2cd629$var$nextEffect = sibling;
                break a;
            }
            $e229cb5c8b2cd629$var$nextEffect = returnFiber;
        }
    }
}
var $e229cb5c8b2cd629$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $e229cb5c8b2cd629$var$readContext($e229cb5c8b2cd629$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $e229cb5c8b2cd629$var$readContext($e229cb5c8b2cd629$var$CacheContext).controller.signal;
    }
}, $e229cb5c8b2cd629$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $e229cb5c8b2cd629$var$executionContext = 0, $e229cb5c8b2cd629$var$workInProgressRoot = null, $e229cb5c8b2cd629$var$workInProgress = null, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = 0, $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0, $e229cb5c8b2cd629$var$workInProgressThrownValue = null, $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings = !1, $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering = !1, $e229cb5c8b2cd629$var$workInProgressRootDidAttachPingListener = !1, $e229cb5c8b2cd629$var$entangledRenderLanes = 0, $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 0, $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes = 0, $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes = 0, $e229cb5c8b2cd629$var$workInProgressRootPingedLanes = 0, $e229cb5c8b2cd629$var$workInProgressDeferredLane = 0, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes = 0, $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors = null, $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = null, $e229cb5c8b2cd629$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $e229cb5c8b2cd629$var$globalMostRecentFallbackTime = 0, $e229cb5c8b2cd629$var$globalMostRecentTransitionTime = 0, $e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime = Infinity, $e229cb5c8b2cd629$var$workInProgressTransitions = null, $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed = null, $e229cb5c8b2cd629$var$pendingEffectsStatus = 0, $e229cb5c8b2cd629$var$pendingEffectsRoot = null, $e229cb5c8b2cd629$var$pendingFinishedWork = null, $e229cb5c8b2cd629$var$pendingEffectsLanes = 0, $e229cb5c8b2cd629$var$pendingEffectsRemainingLanes = 0, $e229cb5c8b2cd629$var$pendingPassiveTransitions = null, $e229cb5c8b2cd629$var$pendingRecoverableErrors = null, $e229cb5c8b2cd629$var$nestedUpdateCount = 0, $e229cb5c8b2cd629$var$rootWithNestedUpdates = null;
function $e229cb5c8b2cd629$var$requestUpdateLane() {
    return 0 !== ($e229cb5c8b2cd629$var$executionContext & 2) && 0 !== $e229cb5c8b2cd629$var$workInProgressRootRenderLanes ? $e229cb5c8b2cd629$var$workInProgressRootRenderLanes & -$e229cb5c8b2cd629$var$workInProgressRootRenderLanes : null !== $e229cb5c8b2cd629$var$ReactSharedInternals.T ? $e229cb5c8b2cd629$var$requestTransitionLane() : $e229cb5c8b2cd629$var$resolveUpdatePriority();
}
function $e229cb5c8b2cd629$var$requestDeferredLane() {
    if (0 === $e229cb5c8b2cd629$var$workInProgressDeferredLane) {
        if (0 === ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 536870912) || $e229cb5c8b2cd629$var$isHydrating) {
            var lane = $e229cb5c8b2cd629$var$nextTransitionDeferredLane;
            $e229cb5c8b2cd629$var$nextTransitionDeferredLane <<= 1;
            0 === ($e229cb5c8b2cd629$var$nextTransitionDeferredLane & 3932160) && ($e229cb5c8b2cd629$var$nextTransitionDeferredLane = 262144);
            $e229cb5c8b2cd629$var$workInProgressDeferredLane = lane;
        } else $e229cb5c8b2cd629$var$workInProgressDeferredLane = 536870912;
    }
    lane = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $e229cb5c8b2cd629$var$workInProgressDeferredLane;
}
function $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $e229cb5c8b2cd629$var$workInProgressRoot && (2 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason || 9 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $e229cb5c8b2cd629$var$prepareFreshStack(root, 0), $e229cb5c8b2cd629$var$markRootSuspended(root, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !1);
    $e229cb5c8b2cd629$var$markRootUpdated$1(root, lane);
    if (0 === ($e229cb5c8b2cd629$var$executionContext & 2) || root !== $e229cb5c8b2cd629$var$workInProgressRoot) root === $e229cb5c8b2cd629$var$workInProgressRoot && (0 === ($e229cb5c8b2cd629$var$executionContext & 2) && ($e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus && $e229cb5c8b2cd629$var$markRootSuspended(root, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !1)), $e229cb5c8b2cd629$var$ensureRootIsScheduled(root);
}
function $e229cb5c8b2cd629$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($e229cb5c8b2cd629$var$executionContext & 6)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $e229cb5c8b2cd629$var$renderRootConcurrent(root$jscomp$0, lanes) : $e229cb5c8b2cd629$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $e229cb5c8b2cd629$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$e229cb5c8b2cd629$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $e229cb5c8b2cd629$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($e229cb5c8b2cd629$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $e229cb5c8b2cd629$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($e229cb5c8b2cd629$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors;
                            $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors ? $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors.push.apply($e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $e229cb5c8b2cd629$var$prepareFreshStack(root$jscomp$0, 0);
                $e229cb5c8b2cd629$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $e229cb5c8b2cd629$var$markRootSuspended(shouldTimeSlice, lanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !$e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $e229cb5c8b2cd629$var$globalMostRecentFallbackTime + 300 - $e229cb5c8b2cd629$var$now(), 10 < exitStatus)) {
                    $e229cb5c8b2cd629$var$markRootSuspended(shouldTimeSlice, lanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !$e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $e229cb5c8b2cd629$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $e229cb5c8b2cd629$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $e229cb5c8b2cd629$var$scheduleTimeout($e229cb5c8b2cd629$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors, $e229cb5c8b2cd629$var$workInProgressTransitions, $e229cb5c8b2cd629$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes, $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $e229cb5c8b2cd629$var$commitRootWhenReady(shouldTimeSlice, forceSync, $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors, $e229cb5c8b2cd629$var$workInProgressTransitions, $e229cb5c8b2cd629$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes, $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $e229cb5c8b2cd629$var$ensureRootIsScheduled(root$jscomp$0);
}
function $e229cb5c8b2cd629$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $e229cb5c8b2cd629$var$noop$1
        };
        $e229cb5c8b2cd629$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $e229cb5c8b2cd629$var$globalMostRecentFallbackTime - $e229cb5c8b2cd629$var$now() : (lanes & 4194048) === lanes ? $e229cb5c8b2cd629$var$globalMostRecentTransitionTime - $e229cb5c8b2cd629$var$now() : 0;
        timeoutOffset = $e229cb5c8b2cd629$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $e229cb5c8b2cd629$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($e229cb5c8b2cd629$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $e229cb5c8b2cd629$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $e229cb5c8b2cd629$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $e229cb5c8b2cd629$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$e229cb5c8b2cd629$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $e229cb5c8b2cd629$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$e229cb5c8b2cd629$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $e229cb5c8b2cd629$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $e229cb5c8b2cd629$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $e229cb5c8b2cd629$var$flushSyncWork$1() {
    return 0 === ($e229cb5c8b2cd629$var$executionContext & 6) ? ($e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $e229cb5c8b2cd629$var$resetWorkInProgressStack() {
    if (null !== $e229cb5c8b2cd629$var$workInProgress) {
        if (0 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason) var interruptedWork = $e229cb5c8b2cd629$var$workInProgress.return;
        else interruptedWork = $e229cb5c8b2cd629$var$workInProgress, $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null, $e229cb5c8b2cd629$var$resetHooksOnUnwind(interruptedWork), $e229cb5c8b2cd629$var$thenableState$1 = null, $e229cb5c8b2cd629$var$thenableIndexCounter$1 = 0, interruptedWork = $e229cb5c8b2cd629$var$workInProgress;
        for(; null !== interruptedWork;)$e229cb5c8b2cd629$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $e229cb5c8b2cd629$var$workInProgress = null;
    }
}
function $e229cb5c8b2cd629$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $e229cb5c8b2cd629$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $e229cb5c8b2cd629$var$pendingEffectsLanes = 0;
    $e229cb5c8b2cd629$var$resetWorkInProgressStack();
    $e229cb5c8b2cd629$var$workInProgressRoot = root;
    $e229cb5c8b2cd629$var$workInProgress = timeoutHandle = $e229cb5c8b2cd629$var$createWorkInProgress(root.current, null);
    $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = lanes;
    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
    $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering = $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root, lanes);
    $e229cb5c8b2cd629$var$workInProgressRootDidAttachPingListener = !1;
    $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes = $e229cb5c8b2cd629$var$workInProgressDeferredLane = $e229cb5c8b2cd629$var$workInProgressRootPingedLanes = $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes = $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes = $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 0;
    $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors = null;
    $e229cb5c8b2cd629$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $e229cb5c8b2cd629$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $e229cb5c8b2cd629$var$entangledRenderLanes = lanes;
    $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $e229cb5c8b2cd629$var$handleThrow(root, thrownValue) {
    $e229cb5c8b2cd629$var$currentlyRenderingFiber = null;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = $e229cb5c8b2cd629$var$ContextOnlyDispatcher;
    thrownValue === $e229cb5c8b2cd629$var$SuspenseException || thrownValue === $e229cb5c8b2cd629$var$SuspenseActionException ? (thrownValue = $e229cb5c8b2cd629$var$getSuspendedThenable(), $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 3) : thrownValue === $e229cb5c8b2cd629$var$SuspenseyCommitException ? (thrownValue = $e229cb5c8b2cd629$var$getSuspendedThenable(), $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 4) : $e229cb5c8b2cd629$var$workInProgressSuspendedReason = thrownValue === $e229cb5c8b2cd629$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $e229cb5c8b2cd629$var$workInProgressThrownValue = thrownValue;
    null === $e229cb5c8b2cd629$var$workInProgress && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 1, $e229cb5c8b2cd629$var$logUncaughtError(root, $e229cb5c8b2cd629$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $e229cb5c8b2cd629$var$shouldRemainOnPreviousScreen() {
    var handler = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 4194048) === $e229cb5c8b2cd629$var$workInProgressRootRenderLanes ? null === $e229cb5c8b2cd629$var$shellBoundary ? !0 : !1 : ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 62914560) === $e229cb5c8b2cd629$var$workInProgressRootRenderLanes || 0 !== ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 536870912) ? handler === $e229cb5c8b2cd629$var$shellBoundary : !1;
}
function $e229cb5c8b2cd629$var$pushDispatcher() {
    var prevDispatcher = $e229cb5c8b2cd629$var$ReactSharedInternals.H;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = $e229cb5c8b2cd629$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $e229cb5c8b2cd629$var$ContextOnlyDispatcher : prevDispatcher;
}
function $e229cb5c8b2cd629$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $e229cb5c8b2cd629$var$ReactSharedInternals.A;
    $e229cb5c8b2cd629$var$ReactSharedInternals.A = $e229cb5c8b2cd629$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible() {
    $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 4;
    $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings || ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 4194048) !== $e229cb5c8b2cd629$var$workInProgressRootRenderLanes && null !== $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current || ($e229cb5c8b2cd629$var$workInProgressRootIsPrerendering = !0);
    0 === ($e229cb5c8b2cd629$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $e229cb5c8b2cd629$var$workInProgressRoot || $e229cb5c8b2cd629$var$markRootSuspended($e229cb5c8b2cd629$var$workInProgressRoot, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !1);
}
function $e229cb5c8b2cd629$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
    $e229cb5c8b2cd629$var$executionContext |= 2;
    var prevDispatcher = $e229cb5c8b2cd629$var$pushDispatcher(), prevAsyncDispatcher = $e229cb5c8b2cd629$var$pushAsyncDispatcher();
    if ($e229cb5c8b2cd629$var$workInProgressRoot !== root || $e229cb5c8b2cd629$var$workInProgressRootRenderLanes !== lanes) $e229cb5c8b2cd629$var$workInProgressTransitions = null, $e229cb5c8b2cd629$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $e229cb5c8b2cd629$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $e229cb5c8b2cd629$var$workInProgressSuspendedReason && null !== $e229cb5c8b2cd629$var$workInProgress) {
            var unitOfWork = $e229cb5c8b2cd629$var$workInProgress, thrownValue = $e229cb5c8b2cd629$var$workInProgressThrownValue;
            switch($e229cb5c8b2cd629$var$workInProgressSuspendedReason){
                case 8:
                    $e229cb5c8b2cd629$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $e229cb5c8b2cd629$var$workInProgressSuspendedReason;
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                    $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $e229cb5c8b2cd629$var$workInProgressSuspendedReason, $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0, $e229cb5c8b2cd629$var$workInProgressThrownValue = null, $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $e229cb5c8b2cd629$var$workLoopSync();
        exitStatus = $e229cb5c8b2cd629$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $e229cb5c8b2cd629$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null;
    $e229cb5c8b2cd629$var$executionContext = prevExecutionContext;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = prevDispatcher;
    $e229cb5c8b2cd629$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $e229cb5c8b2cd629$var$workInProgress && ($e229cb5c8b2cd629$var$workInProgressRoot = null, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = 0, $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $e229cb5c8b2cd629$var$workLoopSync() {
    for(; null !== $e229cb5c8b2cd629$var$workInProgress;)$e229cb5c8b2cd629$var$performUnitOfWork($e229cb5c8b2cd629$var$workInProgress);
}
function $e229cb5c8b2cd629$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
    $e229cb5c8b2cd629$var$executionContext |= 2;
    var prevDispatcher = $e229cb5c8b2cd629$var$pushDispatcher(), prevAsyncDispatcher = $e229cb5c8b2cd629$var$pushAsyncDispatcher();
    $e229cb5c8b2cd629$var$workInProgressRoot !== root || $e229cb5c8b2cd629$var$workInProgressRootRenderLanes !== lanes ? ($e229cb5c8b2cd629$var$workInProgressTransitions = null, $e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime = $e229cb5c8b2cd629$var$now() + 500, $e229cb5c8b2cd629$var$prepareFreshStack(root, lanes)) : $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering = $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $e229cb5c8b2cd629$var$workInProgressSuspendedReason && null !== $e229cb5c8b2cd629$var$workInProgress) {
            lanes = $e229cb5c8b2cd629$var$workInProgress;
            var thrownValue = $e229cb5c8b2cd629$var$workInProgressThrownValue;
            b: switch($e229cb5c8b2cd629$var$workInProgressSuspendedReason){
                case 1:
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                    $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($e229cb5c8b2cd629$var$isThenableResolved(thrownValue)) {
                        $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                        $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                        $e229cb5c8b2cd629$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $e229cb5c8b2cd629$var$workInProgressSuspendedReason && 9 !== $e229cb5c8b2cd629$var$workInProgressSuspendedReason || $e229cb5c8b2cd629$var$workInProgressRoot !== root || ($e229cb5c8b2cd629$var$workInProgressSuspendedReason = 7);
                        $e229cb5c8b2cd629$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $e229cb5c8b2cd629$var$isThenableResolved(thrownValue) ? ($e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0, $e229cb5c8b2cd629$var$workInProgressThrownValue = null, $e229cb5c8b2cd629$var$replaySuspendedUnitOfWork(lanes)) : ($e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0, $e229cb5c8b2cd629$var$workInProgressThrownValue = null, $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($e229cb5c8b2cd629$var$workInProgress.tag){
                        case 26:
                            resource = $e229cb5c8b2cd629$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $e229cb5c8b2cd629$var$workInProgress;
                            if (resource ? $e229cb5c8b2cd629$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                                $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $e229cb5c8b2cd629$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($e229cb5c8b2cd629$var$workInProgress = returnFiber, $e229cb5c8b2cd629$var$completeUnitOfWork(returnFiber)) : $e229cb5c8b2cd629$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                    $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                    $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $e229cb5c8b2cd629$var$resetWorkInProgressStack();
                    $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(462));
            }
        }
        $e229cb5c8b2cd629$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $e229cb5c8b2cd629$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = prevDispatcher;
    $e229cb5c8b2cd629$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $e229cb5c8b2cd629$var$executionContext = prevExecutionContext;
    if (null !== $e229cb5c8b2cd629$var$workInProgress) return 0;
    $e229cb5c8b2cd629$var$workInProgressRoot = null;
    $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = 0;
    $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates();
    return $e229cb5c8b2cd629$var$workInProgressRootExitStatus;
}
function $e229cb5c8b2cd629$var$workLoopConcurrentByScheduler() {
    for(; null !== $e229cb5c8b2cd629$var$workInProgress && !$e229cb5c8b2cd629$var$shouldYield();)$e229cb5c8b2cd629$var$performUnitOfWork($e229cb5c8b2cd629$var$workInProgress);
}
function $e229cb5c8b2cd629$var$performUnitOfWork(unitOfWork) {
    var next = $e229cb5c8b2cd629$var$beginWork(unitOfWork.alternate, unitOfWork, $e229cb5c8b2cd629$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $e229cb5c8b2cd629$var$completeUnitOfWork(unitOfWork) : $e229cb5c8b2cd629$var$workInProgress = next;
}
function $e229cb5c8b2cd629$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $e229cb5c8b2cd629$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $e229cb5c8b2cd629$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $e229cb5c8b2cd629$var$resetHooksOnUnwind(next);
        default:
            $e229cb5c8b2cd629$var$unwindInterruptedWork(current, next), next = $e229cb5c8b2cd629$var$workInProgress = $e229cb5c8b2cd629$var$resetWorkInProgress(next, $e229cb5c8b2cd629$var$entangledRenderLanes), next = $e229cb5c8b2cd629$var$beginWork(current, next, $e229cb5c8b2cd629$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $e229cb5c8b2cd629$var$completeUnitOfWork(unitOfWork) : $e229cb5c8b2cd629$var$workInProgress = next;
}
function $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null;
    $e229cb5c8b2cd629$var$resetHooksOnUnwind(unitOfWork);
    $e229cb5c8b2cd629$var$thenableState$1 = null;
    $e229cb5c8b2cd629$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($e229cb5c8b2cd629$var$throwException(root, returnFiber, unitOfWork, thrownValue, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes)) {
            $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 1;
            $e229cb5c8b2cd629$var$logUncaughtError(root, $e229cb5c8b2cd629$var$createCapturedValueAtFiber(thrownValue, root.current));
            $e229cb5c8b2cd629$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $e229cb5c8b2cd629$var$workInProgress = returnFiber, error;
        $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 1;
        $e229cb5c8b2cd629$var$logUncaughtError(root, $e229cb5c8b2cd629$var$createCapturedValueAtFiber(thrownValue, root.current));
        $e229cb5c8b2cd629$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($e229cb5c8b2cd629$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($e229cb5c8b2cd629$var$workInProgressRootIsPrerendering || 0 !== ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $e229cb5c8b2cd629$var$unwindUnitOfWork(unitOfWork, root);
    } else $e229cb5c8b2cd629$var$completeUnitOfWork(unitOfWork);
}
function $e229cb5c8b2cd629$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $e229cb5c8b2cd629$var$unwindUnitOfWork(completedWork, $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $e229cb5c8b2cd629$var$completeWork(completedWork.alternate, completedWork, $e229cb5c8b2cd629$var$entangledRenderLanes);
        if (null !== next) {
            $e229cb5c8b2cd629$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $e229cb5c8b2cd629$var$workInProgress = completedWork;
            return;
        }
        $e229cb5c8b2cd629$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 5);
}
function $e229cb5c8b2cd629$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $e229cb5c8b2cd629$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $e229cb5c8b2cd629$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $e229cb5c8b2cd629$var$workInProgress = unitOfWork;
            return;
        }
        $e229cb5c8b2cd629$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 6;
    $e229cb5c8b2cd629$var$workInProgress = null;
}
function $e229cb5c8b2cd629$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $e229cb5c8b2cd629$var$flushPendingEffects();
    while (0 !== $e229cb5c8b2cd629$var$pendingEffectsStatus);
    if (0 !== ($e229cb5c8b2cd629$var$executionContext & 6)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $e229cb5c8b2cd629$var$concurrentlyUpdatedLanes;
        $e229cb5c8b2cd629$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $e229cb5c8b2cd629$var$workInProgressRoot && ($e229cb5c8b2cd629$var$workInProgress = $e229cb5c8b2cd629$var$workInProgressRoot = null, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = 0);
        $e229cb5c8b2cd629$var$pendingFinishedWork = finishedWork;
        $e229cb5c8b2cd629$var$pendingEffectsRoot = root;
        $e229cb5c8b2cd629$var$pendingEffectsLanes = lanes;
        $e229cb5c8b2cd629$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $e229cb5c8b2cd629$var$pendingPassiveTransitions = transitions;
        $e229cb5c8b2cd629$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $e229cb5c8b2cd629$var$scheduleCallback$1($e229cb5c8b2cd629$var$NormalPriority$1, function() {
            $e229cb5c8b2cd629$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
            $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
            transitions = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
            $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $e229cb5c8b2cd629$var$executionContext;
            $e229cb5c8b2cd629$var$executionContext |= 4;
            try {
                $e229cb5c8b2cd629$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $e229cb5c8b2cd629$var$executionContext = spawnedLane, $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = transitions, $e229cb5c8b2cd629$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 1;
        $e229cb5c8b2cd629$var$flushMutationEffects();
        $e229cb5c8b2cd629$var$flushLayoutEffects();
        $e229cb5c8b2cd629$var$flushSpawnedWork();
    }
}
function $e229cb5c8b2cd629$var$flushMutationEffects() {
    if (1 === $e229cb5c8b2cd629$var$pendingEffectsStatus) {
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 0;
        var root = $e229cb5c8b2cd629$var$pendingEffectsRoot, finishedWork = $e229cb5c8b2cd629$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
            $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
            var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
            $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
            $e229cb5c8b2cd629$var$executionContext |= 4;
            try {
                $e229cb5c8b2cd629$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $e229cb5c8b2cd629$var$selectionInformation, curFocusedElem = $e229cb5c8b2cd629$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $e229cb5c8b2cd629$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $e229cb5c8b2cd629$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $e229cb5c8b2cd629$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $e229cb5c8b2cd629$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $e229cb5c8b2cd629$var$_enabled = !!$e229cb5c8b2cd629$var$eventsEnabled;
                $e229cb5c8b2cd629$var$selectionInformation = $e229cb5c8b2cd629$var$eventsEnabled = null;
            } finally{
                $e229cb5c8b2cd629$var$executionContext = prevExecutionContext, $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 2;
    }
}
function $e229cb5c8b2cd629$var$flushLayoutEffects() {
    if (2 === $e229cb5c8b2cd629$var$pendingEffectsStatus) {
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 0;
        var root = $e229cb5c8b2cd629$var$pendingEffectsRoot, finishedWork = $e229cb5c8b2cd629$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
            $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
            var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
            $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
            $e229cb5c8b2cd629$var$executionContext |= 4;
            try {
                $e229cb5c8b2cd629$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $e229cb5c8b2cd629$var$executionContext = prevExecutionContext, $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 3;
    }
}
function $e229cb5c8b2cd629$var$flushSpawnedWork() {
    if (4 === $e229cb5c8b2cd629$var$pendingEffectsStatus || 3 === $e229cb5c8b2cd629$var$pendingEffectsStatus) {
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 0;
        $e229cb5c8b2cd629$var$requestPaint();
        var root = $e229cb5c8b2cd629$var$pendingEffectsRoot, finishedWork = $e229cb5c8b2cd629$var$pendingFinishedWork, lanes = $e229cb5c8b2cd629$var$pendingEffectsLanes, recoverableErrors = $e229cb5c8b2cd629$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $e229cb5c8b2cd629$var$pendingEffectsStatus = 5 : ($e229cb5c8b2cd629$var$pendingEffectsStatus = 0, $e229cb5c8b2cd629$var$pendingFinishedWork = $e229cb5c8b2cd629$var$pendingEffectsRoot = null, $e229cb5c8b2cd629$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $e229cb5c8b2cd629$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($e229cb5c8b2cd629$var$injectedHook && "function" === typeof $e229cb5c8b2cd629$var$injectedHook.onCommitFiberRoot) try {
            $e229cb5c8b2cd629$var$injectedHook.onCommitFiberRoot($e229cb5c8b2cd629$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
            remainingLanes = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
            $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2;
            $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $e229cb5c8b2cd629$var$ReactSharedInternals.T = finishedWork, $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($e229cb5c8b2cd629$var$pendingEffectsLanes & 3) && $e229cb5c8b2cd629$var$flushPendingEffects();
        $e229cb5c8b2cd629$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $e229cb5c8b2cd629$var$rootWithNestedUpdates ? $e229cb5c8b2cd629$var$nestedUpdateCount++ : ($e229cb5c8b2cd629$var$nestedUpdateCount = 0, $e229cb5c8b2cd629$var$rootWithNestedUpdates = root) : $e229cb5c8b2cd629$var$nestedUpdateCount = 0;
        $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $e229cb5c8b2cd629$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $e229cb5c8b2cd629$var$releaseCache(remainingLanes)));
}
function $e229cb5c8b2cd629$var$flushPendingEffects() {
    $e229cb5c8b2cd629$var$flushMutationEffects();
    $e229cb5c8b2cd629$var$flushLayoutEffects();
    $e229cb5c8b2cd629$var$flushSpawnedWork();
    return $e229cb5c8b2cd629$var$flushPassiveEffects();
}
function $e229cb5c8b2cd629$var$flushPassiveEffects() {
    if (5 !== $e229cb5c8b2cd629$var$pendingEffectsStatus) return !1;
    var root = $e229cb5c8b2cd629$var$pendingEffectsRoot, remainingLanes = $e229cb5c8b2cd629$var$pendingEffectsRemainingLanes;
    $e229cb5c8b2cd629$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $e229cb5c8b2cd629$var$lanesToEventPriority($e229cb5c8b2cd629$var$pendingEffectsLanes), prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T, previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    try {
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
        renderPriority = $e229cb5c8b2cd629$var$pendingPassiveTransitions;
        $e229cb5c8b2cd629$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $e229cb5c8b2cd629$var$pendingEffectsRoot, lanes = $e229cb5c8b2cd629$var$pendingEffectsLanes;
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 0;
        $e229cb5c8b2cd629$var$pendingFinishedWork = $e229cb5c8b2cd629$var$pendingEffectsRoot = null;
        $e229cb5c8b2cd629$var$pendingEffectsLanes = 0;
        if (0 !== ($e229cb5c8b2cd629$var$executionContext & 6)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(331));
        var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
        $e229cb5c8b2cd629$var$executionContext |= 4;
        $e229cb5c8b2cd629$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $e229cb5c8b2cd629$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $e229cb5c8b2cd629$var$executionContext = prevExecutionContext;
        $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($e229cb5c8b2cd629$var$injectedHook && "function" === typeof $e229cb5c8b2cd629$var$injectedHook.onPostCommitFiberRoot) try {
            $e229cb5c8b2cd629$var$injectedHook.onPostCommitFiberRoot($e229cb5c8b2cd629$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition, $e229cb5c8b2cd629$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $e229cb5c8b2cd629$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $e229cb5c8b2cd629$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $e229cb5c8b2cd629$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($e229cb5c8b2cd629$var$markRootUpdated$1(rootFiber, 2), $e229cb5c8b2cd629$var$ensureRootIsScheduled(rootFiber));
}
function $e229cb5c8b2cd629$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $e229cb5c8b2cd629$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $e229cb5c8b2cd629$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed || !$e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $e229cb5c8b2cd629$var$createClassErrorUpdate(2);
                instance = $e229cb5c8b2cd629$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($e229cb5c8b2cd629$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $e229cb5c8b2cd629$var$markRootUpdated$1(instance, 2), $e229cb5c8b2cd629$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $e229cb5c8b2cd629$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $e229cb5c8b2cd629$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($e229cb5c8b2cd629$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $e229cb5c8b2cd629$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $e229cb5c8b2cd629$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $e229cb5c8b2cd629$var$workInProgressRoot === root && ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus || 3 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 62914560) === $e229cb5c8b2cd629$var$workInProgressRootRenderLanes && 300 > $e229cb5c8b2cd629$var$now() - $e229cb5c8b2cd629$var$globalMostRecentFallbackTime ? 0 === ($e229cb5c8b2cd629$var$executionContext & 2) && $e229cb5c8b2cd629$var$prepareFreshStack(root, 0) : $e229cb5c8b2cd629$var$workInProgressRootPingedLanes |= pingedLanes, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes === $e229cb5c8b2cd629$var$workInProgressRootRenderLanes && ($e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes = 0));
    $e229cb5c8b2cd629$var$ensureRootIsScheduled(root);
}
function $e229cb5c8b2cd629$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $e229cb5c8b2cd629$var$claimNextRetryLane());
    boundaryFiber = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($e229cb5c8b2cd629$var$markRootUpdated$1(boundaryFiber, retryLane), $e229cb5c8b2cd629$var$ensureRootIsScheduled(boundaryFiber));
}
function $e229cb5c8b2cd629$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $e229cb5c8b2cd629$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $e229cb5c8b2cd629$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $e229cb5c8b2cd629$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $e229cb5c8b2cd629$var$scheduleCallback$1(priorityLevel, callback) {
    return $e229cb5c8b2cd629$var$scheduleCallback$3(priorityLevel, callback);
}
var $e229cb5c8b2cd629$var$firstScheduledRoot = null, $e229cb5c8b2cd629$var$lastScheduledRoot = null, $e229cb5c8b2cd629$var$didScheduleMicrotask = !1, $e229cb5c8b2cd629$var$mightHavePendingSyncWork = !1, $e229cb5c8b2cd629$var$isFlushingWork = !1, $e229cb5c8b2cd629$var$currentEventTransitionLane = 0;
function $e229cb5c8b2cd629$var$ensureRootIsScheduled(root) {
    root !== $e229cb5c8b2cd629$var$lastScheduledRoot && null === root.next && (null === $e229cb5c8b2cd629$var$lastScheduledRoot ? $e229cb5c8b2cd629$var$firstScheduledRoot = $e229cb5c8b2cd629$var$lastScheduledRoot = root : $e229cb5c8b2cd629$var$lastScheduledRoot = $e229cb5c8b2cd629$var$lastScheduledRoot.next = root);
    $e229cb5c8b2cd629$var$mightHavePendingSyncWork = !0;
    $e229cb5c8b2cd629$var$didScheduleMicrotask || ($e229cb5c8b2cd629$var$didScheduleMicrotask = !0, $e229cb5c8b2cd629$var$scheduleImmediateRootScheduleTask());
}
function $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$e229cb5c8b2cd629$var$isFlushingWork && $e229cb5c8b2cd629$var$mightHavePendingSyncWork) {
        $e229cb5c8b2cd629$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $e229cb5c8b2cd629$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $e229cb5c8b2cd629$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $e229cb5c8b2cd629$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $e229cb5c8b2cd629$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $e229cb5c8b2cd629$var$getNextLanes(root$170, root$170 === $e229cb5c8b2cd629$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $e229cb5c8b2cd629$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $e229cb5c8b2cd629$var$isFlushingWork = !1;
    }
}
function $e229cb5c8b2cd629$var$processRootScheduleInImmediateTask() {
    $e229cb5c8b2cd629$var$processRootScheduleInMicrotask();
}
function $e229cb5c8b2cd629$var$processRootScheduleInMicrotask() {
    $e229cb5c8b2cd629$var$mightHavePendingSyncWork = $e229cb5c8b2cd629$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $e229cb5c8b2cd629$var$currentEventTransitionLane && $e229cb5c8b2cd629$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $e229cb5c8b2cd629$var$currentEventTransitionLane);
    for(var currentTime = $e229cb5c8b2cd629$var$now(), prev = null, root = $e229cb5c8b2cd629$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $e229cb5c8b2cd629$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $e229cb5c8b2cd629$var$firstScheduledRoot = next : prev.next = next, null === next && ($e229cb5c8b2cd629$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $e229cb5c8b2cd629$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $e229cb5c8b2cd629$var$pendingEffectsStatus && 5 !== $e229cb5c8b2cd629$var$pendingEffectsStatus || $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $e229cb5c8b2cd629$var$currentEventTransitionLane && ($e229cb5c8b2cd629$var$currentEventTransitionLane = 0);
}
function $e229cb5c8b2cd629$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $e229cb5c8b2cd629$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $e229cb5c8b2cd629$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $e229cb5c8b2cd629$var$workInProgressRoot;
    suspendedLanes = $e229cb5c8b2cd629$var$workInProgressRootRenderLanes;
    suspendedLanes = $e229cb5c8b2cd629$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason || 9 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $e229cb5c8b2cd629$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $e229cb5c8b2cd629$var$cancelCallback$1(pingedLanes);
        switch($e229cb5c8b2cd629$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $e229cb5c8b2cd629$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $e229cb5c8b2cd629$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $e229cb5c8b2cd629$var$IdlePriority;
                break;
            default:
                suspendedLanes = $e229cb5c8b2cd629$var$NormalPriority$1;
        }
        pingedLanes = $e229cb5c8b2cd629$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $e229cb5c8b2cd629$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $e229cb5c8b2cd629$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $e229cb5c8b2cd629$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $e229cb5c8b2cd629$var$pendingEffectsStatus && 5 !== $e229cb5c8b2cd629$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($e229cb5c8b2cd629$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $e229cb5c8b2cd629$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $e229cb5c8b2cd629$var$getNextLanes(root, root === $e229cb5c8b2cd629$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $e229cb5c8b2cd629$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $e229cb5c8b2cd629$var$scheduleTaskForRootDuringMicrotask(root, $e229cb5c8b2cd629$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $e229cb5c8b2cd629$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $e229cb5c8b2cd629$var$performSyncWorkOnRoot(root, lanes) {
    if ($e229cb5c8b2cd629$var$flushPendingEffects()) return null;
    $e229cb5c8b2cd629$var$performWorkOnRoot(root, lanes, !0);
}
function $e229cb5c8b2cd629$var$scheduleImmediateRootScheduleTask() {
    $e229cb5c8b2cd629$var$scheduleMicrotask(function() {
        0 !== ($e229cb5c8b2cd629$var$executionContext & 6) ? $e229cb5c8b2cd629$var$scheduleCallback$3($e229cb5c8b2cd629$var$ImmediatePriority, $e229cb5c8b2cd629$var$processRootScheduleInImmediateTask) : $e229cb5c8b2cd629$var$processRootScheduleInMicrotask();
    });
}
function $e229cb5c8b2cd629$var$requestTransitionLane() {
    if (0 === $e229cb5c8b2cd629$var$currentEventTransitionLane) {
        var actionScopeLane = $e229cb5c8b2cd629$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $e229cb5c8b2cd629$var$nextTransitionUpdateLane, $e229cb5c8b2cd629$var$nextTransitionUpdateLane <<= 1, 0 === ($e229cb5c8b2cd629$var$nextTransitionUpdateLane & 261888) && ($e229cb5c8b2cd629$var$nextTransitionUpdateLane = 256));
        $e229cb5c8b2cd629$var$currentEventTransitionLane = actionScopeLane;
    }
    return $e229cb5c8b2cd629$var$currentEventTransitionLane;
}
function $e229cb5c8b2cd629$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $e229cb5c8b2cd629$var$sanitizeURL("" + actionProp);
}
function $e229cb5c8b2cd629$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $e229cb5c8b2cd629$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $e229cb5c8b2cd629$var$coerceFormActionProp((nativeEventTarget[$e229cb5c8b2cd629$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$e229cb5c8b2cd629$var$internalPropsKey] || null) ? $e229cb5c8b2cd629$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $e229cb5c8b2cd629$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $e229cb5c8b2cd629$var$currentEventTransitionLane) {
                                var formData = submitter ? $e229cb5c8b2cd629$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $e229cb5c8b2cd629$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $e229cb5c8b2cd629$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $e229cb5c8b2cd629$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $e229cb5c8b2cd629$var$i$jscomp$inline_1577 = 0; $e229cb5c8b2cd629$var$i$jscomp$inline_1577 < $e229cb5c8b2cd629$var$simpleEventPluginEvents.length; $e229cb5c8b2cd629$var$i$jscomp$inline_1577++){
    var $e229cb5c8b2cd629$var$eventName$jscomp$inline_1578 = $e229cb5c8b2cd629$var$simpleEventPluginEvents[$e229cb5c8b2cd629$var$i$jscomp$inline_1577], $e229cb5c8b2cd629$var$domEventName$jscomp$inline_1579 = $e229cb5c8b2cd629$var$eventName$jscomp$inline_1578.toLowerCase(), $e229cb5c8b2cd629$var$capitalizedEvent$jscomp$inline_1580 = $e229cb5c8b2cd629$var$eventName$jscomp$inline_1578[0].toUpperCase() + $e229cb5c8b2cd629$var$eventName$jscomp$inline_1578.slice(1);
    $e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$domEventName$jscomp$inline_1579, "on" + $e229cb5c8b2cd629$var$capitalizedEvent$jscomp$inline_1580);
}
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$ANIMATION_END, "onAnimationEnd");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$ANIMATION_ITERATION, "onAnimationIteration");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$ANIMATION_START, "onAnimationStart");
$e229cb5c8b2cd629$var$registerSimpleEvent("dblclick", "onDoubleClick");
$e229cb5c8b2cd629$var$registerSimpleEvent("focusin", "onFocus");
$e229cb5c8b2cd629$var$registerSimpleEvent("focusout", "onBlur");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$TRANSITION_RUN, "onTransitionRun");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$TRANSITION_START, "onTransitionStart");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$TRANSITION_CANCEL, "onTransitionCancel");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$TRANSITION_END, "onTransitionEnd");
$e229cb5c8b2cd629$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e229cb5c8b2cd629$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e229cb5c8b2cd629$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e229cb5c8b2cd629$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e229cb5c8b2cd629$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e229cb5c8b2cd629$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($e229cb5c8b2cd629$var$mediaEventTypes));
function $e229cb5c8b2cd629$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $e229cb5c8b2cd629$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $e229cb5c8b2cd629$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $e229cb5c8b2cd629$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$e229cb5c8b2cd629$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$e229cb5c8b2cd629$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($e229cb5c8b2cd629$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $e229cb5c8b2cd629$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $e229cb5c8b2cd629$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $e229cb5c8b2cd629$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $e229cb5c8b2cd629$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$e229cb5c8b2cd629$var$listeningMarker]) {
        rootContainerElement[$e229cb5c8b2cd629$var$listeningMarker] = !0;
        $e229cb5c8b2cd629$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($e229cb5c8b2cd629$var$nonDelegatedEvents.has(domEventName) || $e229cb5c8b2cd629$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $e229cb5c8b2cd629$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$e229cb5c8b2cd629$var$listeningMarker] || (ownerDocument[$e229cb5c8b2cd629$var$listeningMarker] = !0, $e229cb5c8b2cd629$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $e229cb5c8b2cd629$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($e229cb5c8b2cd629$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $e229cb5c8b2cd629$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $e229cb5c8b2cd629$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $e229cb5c8b2cd629$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$e229cb5c8b2cd629$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $e229cb5c8b2cd629$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $e229cb5c8b2cd629$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $e229cb5c8b2cd629$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $e229cb5c8b2cd629$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $e229cb5c8b2cd629$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $e229cb5c8b2cd629$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticTouchEvent;
                        break;
                    case $e229cb5c8b2cd629$var$ANIMATION_END:
                    case $e229cb5c8b2cd629$var$ANIMATION_ITERATION:
                    case $e229cb5c8b2cd629$var$ANIMATION_START:
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticAnimationEvent;
                        break;
                    case $e229cb5c8b2cd629$var$TRANSITION_END:
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $e229cb5c8b2cd629$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($e229cb5c8b2cd629$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $e229cb5c8b2cd629$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($e229cb5c8b2cd629$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$e229cb5c8b2cd629$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $e229cb5c8b2cd629$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $e229cb5c8b2cd629$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $e229cb5c8b2cd629$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $e229cb5c8b2cd629$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $e229cb5c8b2cd629$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $e229cb5c8b2cd629$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $e229cb5c8b2cd629$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $e229cb5c8b2cd629$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $e229cb5c8b2cd629$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $e229cb5c8b2cd629$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $e229cb5c8b2cd629$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForChangeEvent;
                else if ($e229cb5c8b2cd629$var$isTextInputElement(reactName)) {
                    if ($e229cb5c8b2cd629$var$isInputEventSupported) getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $e229cb5c8b2cd629$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $e229cb5c8b2cd629$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForChangeEvent) : getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $e229cb5c8b2cd629$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $e229cb5c8b2cd629$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $e229cb5c8b2cd629$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($e229cb5c8b2cd629$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $e229cb5c8b2cd629$var$activeElement = handleEventFunc, $e229cb5c8b2cd629$var$activeElementInst = targetInst, $e229cb5c8b2cd629$var$lastSelection = null;
                    break;
                case "focusout":
                    $e229cb5c8b2cd629$var$lastSelection = $e229cb5c8b2cd629$var$activeElementInst = $e229cb5c8b2cd629$var$activeElement = null;
                    break;
                case "mousedown":
                    $e229cb5c8b2cd629$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e229cb5c8b2cd629$var$mouseDown = !1;
                    $e229cb5c8b2cd629$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($e229cb5c8b2cd629$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $e229cb5c8b2cd629$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($e229cb5c8b2cd629$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $e229cb5c8b2cd629$var$isComposing ? $e229cb5c8b2cd629$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($e229cb5c8b2cd629$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($e229cb5c8b2cd629$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $e229cb5c8b2cd629$var$isComposing && (fallbackData = $e229cb5c8b2cd629$var$getData()) : ($e229cb5c8b2cd629$var$root = nativeEventTarget, $e229cb5c8b2cd629$var$startText = "value" in $e229cb5c8b2cd629$var$root ? $e229cb5c8b2cd629$var$root.value : $e229cb5c8b2cd629$var$root.textContent, $e229cb5c8b2cd629$var$isComposing = !0)), handleEventFunc = $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $e229cb5c8b2cd629$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $e229cb5c8b2cd629$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $e229cb5c8b2cd629$var$canUseTextInputEvent ? $e229cb5c8b2cd629$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $e229cb5c8b2cd629$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $e229cb5c8b2cd629$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $e229cb5c8b2cd629$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $e229cb5c8b2cd629$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $e229cb5c8b2cd629$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $e229cb5c8b2cd629$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($e229cb5c8b2cd629$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $e229cb5c8b2cd629$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($e229cb5c8b2cd629$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $e229cb5c8b2cd629$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $e229cb5c8b2cd629$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $e229cb5c8b2cd629$var$getListener(target, registrationName), null != stateNode && listeners.unshift($e229cb5c8b2cd629$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $e229cb5c8b2cd629$var$getListener(target, registrationName), null != stateNode && listeners.push($e229cb5c8b2cd629$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $e229cb5c8b2cd629$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $e229cb5c8b2cd629$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $e229cb5c8b2cd629$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($e229cb5c8b2cd629$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($e229cb5c8b2cd629$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $e229cb5c8b2cd629$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $e229cb5c8b2cd629$var$normalizeMarkupForTextOrAttribute(clientText);
    return $e229cb5c8b2cd629$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $e229cb5c8b2cd629$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $e229cb5c8b2cd629$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $e229cb5c8b2cd629$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $e229cb5c8b2cd629$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $e229cb5c8b2cd629$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $e229cb5c8b2cd629$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $e229cb5c8b2cd629$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $e229cb5c8b2cd629$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $e229cb5c8b2cd629$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $e229cb5c8b2cd629$var$setProp(domElement, tag, "name", props.name, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($e229cb5c8b2cd629$var$setProp(domElement, tag, "encType", props.encType, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "method", props.method, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $e229cb5c8b2cd629$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $e229cb5c8b2cd629$var$noop$1);
            break;
        case "onScroll":
            null != value && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $e229cb5c8b2cd629$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", domElement);
            $e229cb5c8b2cd629$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $e229cb5c8b2cd629$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $e229cb5c8b2cd629$var$aliases.get(key) || key, $e229cb5c8b2cd629$var$setValueForAttribute(domElement, key, value);
    }
}
function $e229cb5c8b2cd629$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $e229cb5c8b2cd629$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $e229cb5c8b2cd629$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $e229cb5c8b2cd629$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $e229cb5c8b2cd629$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$e229cb5c8b2cd629$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$e229cb5c8b2cd629$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $e229cb5c8b2cd629$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $e229cb5c8b2cd629$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                    default:
                        $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $e229cb5c8b2cd629$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $e229cb5c8b2cd629$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $e229cb5c8b2cd629$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $e229cb5c8b2cd629$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $e229cb5c8b2cd629$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $e229cb5c8b2cd629$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(91));
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $e229cb5c8b2cd629$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("cancel", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $e229cb5c8b2cd629$var$mediaEventTypes.length; hasSrc++)$e229cb5c8b2cd629$var$listenToNonDelegatedEvent($e229cb5c8b2cd629$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", domElement), $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($e229cb5c8b2cd629$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $e229cb5c8b2cd629$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $e229cb5c8b2cd629$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $e229cb5c8b2cd629$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $e229cb5c8b2cd629$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $e229cb5c8b2cd629$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $e229cb5c8b2cd629$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $e229cb5c8b2cd629$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $e229cb5c8b2cd629$var$updateOptions(domElement, !!lastProps, tag, !0) : $e229cb5c8b2cd629$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $e229cb5c8b2cd629$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $e229cb5c8b2cd629$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($e229cb5c8b2cd629$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $e229cb5c8b2cd629$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $e229cb5c8b2cd629$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $e229cb5c8b2cd629$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $e229cb5c8b2cd629$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $e229cb5c8b2cd629$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $e229cb5c8b2cd629$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $e229cb5c8b2cd629$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $e229cb5c8b2cd629$var$eventsEnabled = null, $e229cb5c8b2cd629$var$selectionInformation = null;
function $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $e229cb5c8b2cd629$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $e229cb5c8b2cd629$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $e229cb5c8b2cd629$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $e229cb5c8b2cd629$var$currentPopstateTransitionEvent = null;
function $e229cb5c8b2cd629$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $e229cb5c8b2cd629$var$currentPopstateTransitionEvent) return !1;
        $e229cb5c8b2cd629$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $e229cb5c8b2cd629$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $e229cb5c8b2cd629$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $e229cb5c8b2cd629$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $e229cb5c8b2cd629$var$localPromise = "function" === typeof Promise ? Promise : void 0, $e229cb5c8b2cd629$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e229cb5c8b2cd629$var$localPromise ? function(callback) {
    return $e229cb5c8b2cd629$var$localPromise.resolve(null).then(callback).catch($e229cb5c8b2cd629$var$handleErrorInNextTick);
} : $e229cb5c8b2cd629$var$scheduleTimeout;
function $e229cb5c8b2cd629$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $e229cb5c8b2cd629$var$isSingletonScope(type) {
    return "head" === type;
}
function $e229cb5c8b2cd629$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $e229cb5c8b2cd629$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $e229cb5c8b2cd629$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $e229cb5c8b2cd629$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$e229cb5c8b2cd629$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $e229cb5c8b2cd629$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $e229cb5c8b2cd629$var$retryIfBlockedOn(hydrationInstance);
}
function $e229cb5c8b2cd629$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $e229cb5c8b2cd629$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $e229cb5c8b2cd629$var$clearContainerSparingly(node);
                $e229cb5c8b2cd629$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $e229cb5c8b2cd629$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$e229cb5c8b2cd629$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $e229cb5c8b2cd629$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $e229cb5c8b2cd629$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $e229cb5c8b2cd629$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $e229cb5c8b2cd629$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $e229cb5c8b2cd629$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $e229cb5c8b2cd629$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $e229cb5c8b2cd629$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $e229cb5c8b2cd629$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $e229cb5c8b2cd629$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $e229cb5c8b2cd629$var$previousHydratableOnEnteringScopedSingleton = null;
function $e229cb5c8b2cd629$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $e229cb5c8b2cd629$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $e229cb5c8b2cd629$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $e229cb5c8b2cd629$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(451));
    }
}
function $e229cb5c8b2cd629$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $e229cb5c8b2cd629$var$detachDeletedInstance(instance);
}
var $e229cb5c8b2cd629$var$preloadPropsMap = new Map(), $e229cb5c8b2cd629$var$preconnectsSet = new Set();
function $e229cb5c8b2cd629$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $e229cb5c8b2cd629$var$previousDispatcher = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.d;
$e229cb5c8b2cd629$var$ReactDOMSharedInternals.d = {
    f: $e229cb5c8b2cd629$var$flushSyncWork,
    r: $e229cb5c8b2cd629$var$requestFormReset,
    D: $e229cb5c8b2cd629$var$prefetchDNS,
    C: $e229cb5c8b2cd629$var$preconnect,
    L: $e229cb5c8b2cd629$var$preload,
    m: $e229cb5c8b2cd629$var$preloadModule,
    X: $e229cb5c8b2cd629$var$preinitScript,
    S: $e229cb5c8b2cd629$var$preinitStyle,
    M: $e229cb5c8b2cd629$var$preinitModuleScript
};
function $e229cb5c8b2cd629$var$flushSyncWork() {
    var previousWasRendering = $e229cb5c8b2cd629$var$previousDispatcher.f(), wasRendering = $e229cb5c8b2cd629$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $e229cb5c8b2cd629$var$requestFormReset(form) {
    var formInst = $e229cb5c8b2cd629$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $e229cb5c8b2cd629$var$requestFormReset$1(formInst) : $e229cb5c8b2cd629$var$previousDispatcher.r(form);
}
var $e229cb5c8b2cd629$var$globalDocument = "undefined" === typeof document ? null : document;
function $e229cb5c8b2cd629$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $e229cb5c8b2cd629$var$preconnectsSet.has(limitedEscapedHref) || ($e229cb5c8b2cd629$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $e229cb5c8b2cd629$var$setInitialProperties(href, "link", rel), $e229cb5c8b2cd629$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $e229cb5c8b2cd629$var$prefetchDNS(href) {
    $e229cb5c8b2cd629$var$previousDispatcher.D(href);
    $e229cb5c8b2cd629$var$preconnectAs("dns-prefetch", href, null);
}
function $e229cb5c8b2cd629$var$preconnect(href, crossOrigin) {
    $e229cb5c8b2cd629$var$previousDispatcher.C(href, crossOrigin);
    $e229cb5c8b2cd629$var$preconnectAs("preconnect", href, crossOrigin);
}
function $e229cb5c8b2cd629$var$preload(href, as, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $e229cb5c8b2cd629$var$getStyleKey(href);
                break;
            case "script":
                key = $e229cb5c8b2cd629$var$getScriptKey(href);
        }
        $e229cb5c8b2cd629$var$preloadPropsMap.has(key) || (href = $e229cb5c8b2cd629$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $e229cb5c8b2cd629$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $e229cb5c8b2cd629$var$setInitialProperties(as, "link", href), $e229cb5c8b2cd629$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $e229cb5c8b2cd629$var$preloadModule(href, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.m(href, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $e229cb5c8b2cd629$var$getScriptKey(href);
        }
        if (!$e229cb5c8b2cd629$var$preloadPropsMap.has(key) && (href = $e229cb5c8b2cd629$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $e229cb5c8b2cd629$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $e229cb5c8b2cd629$var$setInitialProperties(as, "link", href);
            $e229cb5c8b2cd629$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $e229cb5c8b2cd629$var$preinitStyle(href, precedence, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $e229cb5c8b2cd629$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $e229cb5c8b2cd629$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $e229cb5c8b2cd629$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $e229cb5c8b2cd629$var$preloadPropsMap.get(key)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $e229cb5c8b2cd629$var$markNodeAsHoistable(link);
                $e229cb5c8b2cd629$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $e229cb5c8b2cd629$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $e229cb5c8b2cd629$var$preinitScript(src, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.X(src, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $e229cb5c8b2cd629$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $e229cb5c8b2cd629$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(key)), resource || (src = $e229cb5c8b2cd629$var$assign({
            src: src,
            async: !0
        }, options), (options = $e229cb5c8b2cd629$var$preloadPropsMap.get(key)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $e229cb5c8b2cd629$var$markNodeAsHoistable(resource), $e229cb5c8b2cd629$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $e229cb5c8b2cd629$var$preinitModuleScript(src, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.M(src, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $e229cb5c8b2cd629$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $e229cb5c8b2cd629$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(key)), resource || (src = $e229cb5c8b2cd629$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $e229cb5c8b2cd629$var$preloadPropsMap.get(key)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $e229cb5c8b2cd629$var$markNodeAsHoistable(resource), $e229cb5c8b2cd629$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $e229cb5c8b2cd629$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $e229cb5c8b2cd629$var$rootInstanceStackCursor.current) ? $e229cb5c8b2cd629$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $e229cb5c8b2cd629$var$getStyleKey(pendingProps.href), pendingProps = $e229cb5c8b2cd629$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $e229cb5c8b2cd629$var$getStyleKey(pendingProps.href);
                var styles$243 = $e229cb5c8b2cd629$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $e229cb5c8b2cd629$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $e229cb5c8b2cd629$var$preloadPropsMap.set(type, pendingProps), styles$243 || $e229cb5c8b2cd629$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $e229cb5c8b2cd629$var$getScriptKey(pendingProps), pendingProps = $e229cb5c8b2cd629$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(444, type));
    }
}
function $e229cb5c8b2cd629$var$getStyleKey(href) {
    return 'href="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $e229cb5c8b2cd629$var$stylesheetPropsFromRawProps(rawProps) {
    return $e229cb5c8b2cd629$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $e229cb5c8b2cd629$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $e229cb5c8b2cd629$var$setInitialProperties(key, "link", preloadProps), $e229cb5c8b2cd629$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $e229cb5c8b2cd629$var$getScriptKey(src) {
    return '[src="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $e229cb5c8b2cd629$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $e229cb5c8b2cd629$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $e229cb5c8b2cd629$var$markNodeAsHoistable(instance), instance;
            var styleProps = $e229cb5c8b2cd629$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $e229cb5c8b2cd629$var$markNodeAsHoistable(instance);
            $e229cb5c8b2cd629$var$setInitialProperties(instance, "style", styleProps);
            $e229cb5c8b2cd629$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $e229cb5c8b2cd629$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $e229cb5c8b2cd629$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $e229cb5c8b2cd629$var$stylesheetPropsFromRawProps(props);
            (styleProps = $e229cb5c8b2cd629$var$preloadPropsMap.get(styleProps)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $e229cb5c8b2cd629$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $e229cb5c8b2cd629$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $e229cb5c8b2cd629$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $e229cb5c8b2cd629$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $e229cb5c8b2cd629$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $e229cb5c8b2cd629$var$preloadPropsMap.get(instance$249)) instance = $e229cb5c8b2cd629$var$assign({}, props), $e229cb5c8b2cd629$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $e229cb5c8b2cd629$var$markNodeAsHoistable(styleProps);
            $e229cb5c8b2cd629$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $e229cb5c8b2cd629$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $e229cb5c8b2cd629$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $e229cb5c8b2cd629$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $e229cb5c8b2cd629$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $e229cb5c8b2cd629$var$tagCaches = null;
function $e229cb5c8b2cd629$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $e229cb5c8b2cd629$var$tagCaches) {
        var cache = new Map();
        var caches = $e229cb5c8b2cd629$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $e229cb5c8b2cd629$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$e229cb5c8b2cd629$var$internalHoistableMarker] || node[$e229cb5c8b2cd629$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $e229cb5c8b2cd629$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $e229cb5c8b2cd629$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $e229cb5c8b2cd629$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $e229cb5c8b2cd629$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $e229cb5c8b2cd629$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $e229cb5c8b2cd629$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $e229cb5c8b2cd629$var$stylesheetPropsFromRawProps(props);
            (key = $e229cb5c8b2cd629$var$preloadPropsMap.get(key)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $e229cb5c8b2cd629$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $e229cb5c8b2cd629$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $e229cb5c8b2cd629$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $e229cb5c8b2cd629$var$estimatedBytesWithinLimit = 0;
function $e229cb5c8b2cd629$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $e229cb5c8b2cd629$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $e229cb5c8b2cd629$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $e229cb5c8b2cd629$var$estimatedBytesWithinLimit && ($e229cb5c8b2cd629$var$estimatedBytesWithinLimit = 62500 * $e229cb5c8b2cd629$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $e229cb5c8b2cd629$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $e229cb5c8b2cd629$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $e229cb5c8b2cd629$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $e229cb5c8b2cd629$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $e229cb5c8b2cd629$var$precedencesByRoot = null;
function $e229cb5c8b2cd629$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $e229cb5c8b2cd629$var$precedencesByRoot = new Map(), resources.forEach($e229cb5c8b2cd629$var$insertStylesheetIntoRoot, state), $e229cb5c8b2cd629$var$precedencesByRoot = null, $e229cb5c8b2cd629$var$onUnsuspend.call(state));
}
function $e229cb5c8b2cd629$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $e229cb5c8b2cd629$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $e229cb5c8b2cd629$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $e229cb5c8b2cd629$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $e229cb5c8b2cd629$var$HostTransitionContext = {
    $$typeof: $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $e229cb5c8b2cd629$var$sharedNotPendingObject,
    _currentValue2: $e229cb5c8b2cd629$var$sharedNotPendingObject,
    _threadCount: 0
};
function $e229cb5c8b2cd629$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $e229cb5c8b2cd629$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e229cb5c8b2cd629$var$createLaneMap(0);
    this.hiddenUpdates = $e229cb5c8b2cd629$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $e229cb5c8b2cd629$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $e229cb5c8b2cd629$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $e229cb5c8b2cd629$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $e229cb5c8b2cd629$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $e229cb5c8b2cd629$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $e229cb5c8b2cd629$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $e229cb5c8b2cd629$var$emptyContextObject;
    parentComponent = $e229cb5c8b2cd629$var$emptyContextObject;
    return parentComponent;
}
function $e229cb5c8b2cd629$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $e229cb5c8b2cd629$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $e229cb5c8b2cd629$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $e229cb5c8b2cd629$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(element, rootFiber, lane), $e229cb5c8b2cd629$var$entangleTransitions(element, rootFiber, lane));
}
function $e229cb5c8b2cd629$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $e229cb5c8b2cd629$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $e229cb5c8b2cd629$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $e229cb5c8b2cd629$var$markRetryLaneImpl(fiber, retryLane);
}
function $e229cb5c8b2cd629$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $e229cb5c8b2cd629$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $e229cb5c8b2cd629$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $e229cb5c8b2cd629$var$requestUpdateLane();
        lane = $e229cb5c8b2cd629$var$getBumpedLaneForHydrationByLane(lane);
        var root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, lane);
        $e229cb5c8b2cd629$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $e229cb5c8b2cd629$var$_enabled = !0;
function $e229cb5c8b2cd629$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
    $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
    var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    try {
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2, $e229cb5c8b2cd629$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition;
    }
}
function $e229cb5c8b2cd629$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
    $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
    var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    try {
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 8, $e229cb5c8b2cd629$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition;
    }
}
function $e229cb5c8b2cd629$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($e229cb5c8b2cd629$var$_enabled) {
        var blockedOn = $e229cb5c8b2cd629$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $e229cb5c8b2cd629$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $e229cb5c8b2cd629$var$return_targetInst, targetContainer), $e229cb5c8b2cd629$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($e229cb5c8b2cd629$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($e229cb5c8b2cd629$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $e229cb5c8b2cd629$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $e229cb5c8b2cd629$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $e229cb5c8b2cd629$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $e229cb5c8b2cd629$var$ensureRootIsScheduled(fiber);
                                0 === ($e229cb5c8b2cd629$var$executionContext & 6) && ($e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime = $e229cb5c8b2cd629$var$now() + 500, $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, 2), $e229cb5c8b2cd629$var$flushSyncWork$1(), $e229cb5c8b2cd629$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $e229cb5c8b2cd629$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $e229cb5c8b2cd629$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $e229cb5c8b2cd629$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $e229cb5c8b2cd629$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $e229cb5c8b2cd629$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $e229cb5c8b2cd629$var$getEventTarget(nativeEvent);
    return $e229cb5c8b2cd629$var$findInstanceBlockingTarget(nativeEvent);
}
var $e229cb5c8b2cd629$var$return_targetInst = null;
function $e229cb5c8b2cd629$var$findInstanceBlockingTarget(targetNode) {
    $e229cb5c8b2cd629$var$return_targetInst = null;
    targetNode = $e229cb5c8b2cd629$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $e229cb5c8b2cd629$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $e229cb5c8b2cd629$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $e229cb5c8b2cd629$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $e229cb5c8b2cd629$var$return_targetInst = targetNode;
    return null;
}
function $e229cb5c8b2cd629$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($e229cb5c8b2cd629$var$getCurrentPriorityLevel()){
                case $e229cb5c8b2cd629$var$ImmediatePriority:
                    return 2;
                case $e229cb5c8b2cd629$var$UserBlockingPriority:
                    return 8;
                case $e229cb5c8b2cd629$var$NormalPriority$1:
                case $e229cb5c8b2cd629$var$LowPriority:
                    return 32;
                case $e229cb5c8b2cd629$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $e229cb5c8b2cd629$var$hasScheduledReplayAttempt = !1, $e229cb5c8b2cd629$var$queuedFocus = null, $e229cb5c8b2cd629$var$queuedDrag = null, $e229cb5c8b2cd629$var$queuedMouse = null, $e229cb5c8b2cd629$var$queuedPointers = new Map(), $e229cb5c8b2cd629$var$queuedPointerCaptures = new Map(), $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets = [], $e229cb5c8b2cd629$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $e229cb5c8b2cd629$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $e229cb5c8b2cd629$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $e229cb5c8b2cd629$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $e229cb5c8b2cd629$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $e229cb5c8b2cd629$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e229cb5c8b2cd629$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $e229cb5c8b2cd629$var$getInstanceFromNode(blockedOn), null !== blockedOn && $e229cb5c8b2cd629$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $e229cb5c8b2cd629$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $e229cb5c8b2cd629$var$queuedFocus = $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $e229cb5c8b2cd629$var$queuedDrag = $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $e229cb5c8b2cd629$var$queuedMouse = $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $e229cb5c8b2cd629$var$queuedPointers.set(pointerId, $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $e229cb5c8b2cd629$var$queuedPointerCaptures.set(pointerId, $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $e229cb5c8b2cd629$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $e229cb5c8b2cd629$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $e229cb5c8b2cd629$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $e229cb5c8b2cd629$var$runWithPriority(queuedTarget.priority, function() {
                        $e229cb5c8b2cd629$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $e229cb5c8b2cd629$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $e229cb5c8b2cd629$var$runWithPriority(queuedTarget.priority, function() {
                        $e229cb5c8b2cd629$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $e229cb5c8b2cd629$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $e229cb5c8b2cd629$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $e229cb5c8b2cd629$var$currentReplayingEvent = null;
        } else return targetContainers = $e229cb5c8b2cd629$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $e229cb5c8b2cd629$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $e229cb5c8b2cd629$var$replayUnblockedEvents() {
    $e229cb5c8b2cd629$var$hasScheduledReplayAttempt = !1;
    null !== $e229cb5c8b2cd629$var$queuedFocus && $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent($e229cb5c8b2cd629$var$queuedFocus) && ($e229cb5c8b2cd629$var$queuedFocus = null);
    null !== $e229cb5c8b2cd629$var$queuedDrag && $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent($e229cb5c8b2cd629$var$queuedDrag) && ($e229cb5c8b2cd629$var$queuedDrag = null);
    null !== $e229cb5c8b2cd629$var$queuedMouse && $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent($e229cb5c8b2cd629$var$queuedMouse) && ($e229cb5c8b2cd629$var$queuedMouse = null);
    $e229cb5c8b2cd629$var$queuedPointers.forEach($e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEventInMap);
    $e229cb5c8b2cd629$var$queuedPointerCaptures.forEach($e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEventInMap);
}
function $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $e229cb5c8b2cd629$var$hasScheduledReplayAttempt || ($e229cb5c8b2cd629$var$hasScheduledReplayAttempt = !0, $iqDh9.unstable_scheduleCallback($iqDh9.unstable_NormalPriority, $e229cb5c8b2cd629$var$replayUnblockedEvents)));
}
var $e229cb5c8b2cd629$var$lastScheduledReplayQueue = null;
function $e229cb5c8b2cd629$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $e229cb5c8b2cd629$var$lastScheduledReplayQueue !== formReplayingQueue && ($e229cb5c8b2cd629$var$lastScheduledReplayQueue = formReplayingQueue, $iqDh9.unstable_scheduleCallback($iqDh9.unstable_NormalPriority, function() {
        $e229cb5c8b2cd629$var$lastScheduledReplayQueue === formReplayingQueue && ($e229cb5c8b2cd629$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $e229cb5c8b2cd629$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $e229cb5c8b2cd629$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $e229cb5c8b2cd629$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $e229cb5c8b2cd629$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $e229cb5c8b2cd629$var$queuedFocus && $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked($e229cb5c8b2cd629$var$queuedFocus, unblocked);
    null !== $e229cb5c8b2cd629$var$queuedDrag && $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked($e229cb5c8b2cd629$var$queuedDrag, unblocked);
    null !== $e229cb5c8b2cd629$var$queuedMouse && $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked($e229cb5c8b2cd629$var$queuedMouse, unblocked);
    $e229cb5c8b2cd629$var$queuedPointers.forEach(unblock);
    $e229cb5c8b2cd629$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.length && (i = $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$e229cb5c8b2cd629$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$e229cb5c8b2cd629$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $e229cb5c8b2cd629$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$e229cb5c8b2cd629$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $e229cb5c8b2cd629$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $e229cb5c8b2cd629$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $e229cb5c8b2cd629$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $e229cb5c8b2cd629$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$e229cb5c8b2cd629$var$ReactDOMHydrationRoot.prototype.render = $e229cb5c8b2cd629$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(409));
    var current = root.current, lane = $e229cb5c8b2cd629$var$requestUpdateLane();
    $e229cb5c8b2cd629$var$updateContainerImpl(current, lane, children, root, null, null);
};
$e229cb5c8b2cd629$var$ReactDOMHydrationRoot.prototype.unmount = $e229cb5c8b2cd629$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $e229cb5c8b2cd629$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $e229cb5c8b2cd629$var$flushSyncWork$1();
        container[$e229cb5c8b2cd629$var$internalContainerInstanceKey] = null;
    }
};
function $e229cb5c8b2cd629$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$e229cb5c8b2cd629$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $e229cb5c8b2cd629$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets[i].priority; i++);
        $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $e229cb5c8b2cd629$var$attemptExplicitHydrationTarget(target);
    }
};
var $e229cb5c8b2cd629$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $bh6RR.version;
if ("19.2.0" !== $e229cb5c8b2cd629$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(527, $e229cb5c8b2cd629$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.0"));
$e229cb5c8b2cd629$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $e229cb5c8b2cd629$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $e229cb5c8b2cd629$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $e229cb5c8b2cd629$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $e229cb5c8b2cd629$var$ReactSharedInternals,
    reconcilerVersion: "19.2.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e229cb5c8b2cd629$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e229cb5c8b2cd629$var$hook$jscomp$inline_2348.isDisabled && $e229cb5c8b2cd629$var$hook$jscomp$inline_2348.supportsFiber) try {
        $e229cb5c8b2cd629$var$rendererID = $e229cb5c8b2cd629$var$hook$jscomp$inline_2348.inject($e229cb5c8b2cd629$var$internals$jscomp$inline_2347), $e229cb5c8b2cd629$var$injectedHook = $e229cb5c8b2cd629$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$e229cb5c8b2cd629$export$882461b6382ed46c = function(container, options) {
    if (!$e229cb5c8b2cd629$var$isValidContainer(container)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $e229cb5c8b2cd629$var$defaultOnUncaughtError, onCaughtError = $e229cb5c8b2cd629$var$defaultOnCaughtError, onRecoverableError = $e229cb5c8b2cd629$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $e229cb5c8b2cd629$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $e229cb5c8b2cd629$var$defaultOnDefaultTransitionIndicator);
    container[$e229cb5c8b2cd629$var$internalContainerInstanceKey] = options.current;
    $e229cb5c8b2cd629$var$listenToAllSupportedEvents(container);
    return new $e229cb5c8b2cd629$var$ReactDOMRoot(options);
};
$e229cb5c8b2cd629$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$e229cb5c8b2cd629$var$isValidContainer(container)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $e229cb5c8b2cd629$var$defaultOnUncaughtError, onCaughtError = $e229cb5c8b2cd629$var$defaultOnCaughtError, onRecoverableError = $e229cb5c8b2cd629$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $e229cb5c8b2cd629$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $e229cb5c8b2cd629$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $e229cb5c8b2cd629$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $e229cb5c8b2cd629$var$requestUpdateLane();
    isStrictMode = $e229cb5c8b2cd629$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $e229cb5c8b2cd629$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $e229cb5c8b2cd629$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $e229cb5c8b2cd629$var$markRootUpdated$1(initialChildren, options);
    $e229cb5c8b2cd629$var$ensureRootIsScheduled(initialChildren);
    container[$e229cb5c8b2cd629$var$internalContainerInstanceKey] = initialChildren.current;
    $e229cb5c8b2cd629$var$listenToAllSupportedEvents(container);
    return new $e229cb5c8b2cd629$var$ReactDOMHydrationRoot(initialChildren);
};
$e229cb5c8b2cd629$export$83d89fbfd8236492 = "19.2.0";

});
parcelRegister("iqDh9", function(module, exports) {
'use strict';

module.exports = (parcelRequire("64IEP"));

});
parcelRegister("64IEP", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $46c5c1dce9ce0d2f$export$c4744153514ff05d; }, function (v) { return $46c5c1dce9ce0d2f$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $46c5c1dce9ce0d2f$export$3e506c1ccc9cc1a7; }, function (v) { return $46c5c1dce9ce0d2f$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $46c5c1dce9ce0d2f$export$e26fe2ed2fa76875; }, function (v) { return $46c5c1dce9ce0d2f$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $46c5c1dce9ce0d2f$export$502329bbf4b505b1; }, function (v) { return $46c5c1dce9ce0d2f$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $46c5c1dce9ce0d2f$export$6e3807111c4874c4; }, function (v) { return $46c5c1dce9ce0d2f$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $46c5c1dce9ce0d2f$export$c27134553091fb3a; }, function (v) { return $46c5c1dce9ce0d2f$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $46c5c1dce9ce0d2f$export$33ee1acdc04fd2a2; }, function (v) { return $46c5c1dce9ce0d2f$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $46c5c1dce9ce0d2f$export$b00a404bbd5edef2; }, function (v) { return $46c5c1dce9ce0d2f$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $46c5c1dce9ce0d2f$export$d66a1c1c77bd778b; }, function (v) { return $46c5c1dce9ce0d2f$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $46c5c1dce9ce0d2f$export$d3dfb8e4810cb555; }, function (v) { return $46c5c1dce9ce0d2f$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $46c5c1dce9ce0d2f$export$72fdf0e06517287b; }, function (v) { return $46c5c1dce9ce0d2f$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $46c5c1dce9ce0d2f$export$816d2913ae6b83b1; }, function (v) { return $46c5c1dce9ce0d2f$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $46c5c1dce9ce0d2f$export$61bcfe829111a1d0; }, function (v) { return $46c5c1dce9ce0d2f$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $46c5c1dce9ce0d2f$export$7ee8c9beb337bc3f; }, function (v) { return $46c5c1dce9ce0d2f$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $46c5c1dce9ce0d2f$export$b5836b71941fa3ed; }, function (v) { return $46c5c1dce9ce0d2f$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $46c5c1dce9ce0d2f$export$cf845f2c119da08a; }, function (v) { return $46c5c1dce9ce0d2f$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $46c5c1dce9ce0d2f$export$c4744153514ff05d;
var $46c5c1dce9ce0d2f$export$3e506c1ccc9cc1a7;
var $46c5c1dce9ce0d2f$export$e26fe2ed2fa76875;
var $46c5c1dce9ce0d2f$export$502329bbf4b505b1;
var $46c5c1dce9ce0d2f$export$6e3807111c4874c4;
var $46c5c1dce9ce0d2f$export$c27134553091fb3a;
var $46c5c1dce9ce0d2f$export$33ee1acdc04fd2a2;
var $46c5c1dce9ce0d2f$export$b00a404bbd5edef2;
var $46c5c1dce9ce0d2f$export$d66a1c1c77bd778b;
var $46c5c1dce9ce0d2f$export$d3dfb8e4810cb555;
var $46c5c1dce9ce0d2f$export$72fdf0e06517287b;
var $46c5c1dce9ce0d2f$export$816d2913ae6b83b1;
var $46c5c1dce9ce0d2f$export$61bcfe829111a1d0;
var $46c5c1dce9ce0d2f$export$7ee8c9beb337bc3f;
var $46c5c1dce9ce0d2f$export$b5836b71941fa3ed;
var $46c5c1dce9ce0d2f$export$cf845f2c119da08a;
"use strict";
function $46c5c1dce9ce0d2f$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $46c5c1dce9ce0d2f$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $46c5c1dce9ce0d2f$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $46c5c1dce9ce0d2f$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $46c5c1dce9ce0d2f$var$compare(left, last)) rightIndex < length && 0 > $46c5c1dce9ce0d2f$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $46c5c1dce9ce0d2f$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $46c5c1dce9ce0d2f$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$46c5c1dce9ce0d2f$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $46c5c1dce9ce0d2f$var$localPerformance = performance;
    $46c5c1dce9ce0d2f$export$c4744153514ff05d = function() {
        return $46c5c1dce9ce0d2f$var$localPerformance.now();
    };
} else {
    var $46c5c1dce9ce0d2f$var$localDate = Date, $46c5c1dce9ce0d2f$var$initialTime = $46c5c1dce9ce0d2f$var$localDate.now();
    $46c5c1dce9ce0d2f$export$c4744153514ff05d = function() {
        return $46c5c1dce9ce0d2f$var$localDate.now() - $46c5c1dce9ce0d2f$var$initialTime;
    };
}
var $46c5c1dce9ce0d2f$var$taskQueue = [], $46c5c1dce9ce0d2f$var$timerQueue = [], $46c5c1dce9ce0d2f$var$taskIdCounter = 1, $46c5c1dce9ce0d2f$var$currentTask = null, $46c5c1dce9ce0d2f$var$currentPriorityLevel = 3, $46c5c1dce9ce0d2f$var$isPerformingWork = !1, $46c5c1dce9ce0d2f$var$isHostCallbackScheduled = !1, $46c5c1dce9ce0d2f$var$isHostTimeoutScheduled = !1, $46c5c1dce9ce0d2f$var$needsPaint = !1, $46c5c1dce9ce0d2f$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $46c5c1dce9ce0d2f$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $46c5c1dce9ce0d2f$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $46c5c1dce9ce0d2f$var$advanceTimers(currentTime) {
    for(var timer = $46c5c1dce9ce0d2f$var$peek($46c5c1dce9ce0d2f$var$timerQueue); null !== timer;){
        if (null === timer.callback) $46c5c1dce9ce0d2f$var$pop($46c5c1dce9ce0d2f$var$timerQueue);
        else if (timer.startTime <= currentTime) $46c5c1dce9ce0d2f$var$pop($46c5c1dce9ce0d2f$var$timerQueue), timer.sortIndex = timer.expirationTime, $46c5c1dce9ce0d2f$var$push($46c5c1dce9ce0d2f$var$taskQueue, timer);
        else break;
        timer = $46c5c1dce9ce0d2f$var$peek($46c5c1dce9ce0d2f$var$timerQueue);
    }
}
function $46c5c1dce9ce0d2f$var$handleTimeout(currentTime) {
    $46c5c1dce9ce0d2f$var$isHostTimeoutScheduled = !1;
    $46c5c1dce9ce0d2f$var$advanceTimers(currentTime);
    if (!$46c5c1dce9ce0d2f$var$isHostCallbackScheduled) {
        if (null !== $46c5c1dce9ce0d2f$var$peek($46c5c1dce9ce0d2f$var$taskQueue)) $46c5c1dce9ce0d2f$var$isHostCallbackScheduled = !0, $46c5c1dce9ce0d2f$var$isMessageLoopRunning || ($46c5c1dce9ce0d2f$var$isMessageLoopRunning = !0, $46c5c1dce9ce0d2f$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $46c5c1dce9ce0d2f$var$peek($46c5c1dce9ce0d2f$var$timerQueue);
            null !== firstTimer && $46c5c1dce9ce0d2f$var$requestHostTimeout($46c5c1dce9ce0d2f$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $46c5c1dce9ce0d2f$var$isMessageLoopRunning = !1, $46c5c1dce9ce0d2f$var$taskTimeoutID = -1, $46c5c1dce9ce0d2f$var$frameInterval = 5, $46c5c1dce9ce0d2f$var$startTime = -1;
function $46c5c1dce9ce0d2f$var$shouldYieldToHost() {
    return $46c5c1dce9ce0d2f$var$needsPaint ? !0 : $46c5c1dce9ce0d2f$export$c4744153514ff05d() - $46c5c1dce9ce0d2f$var$startTime < $46c5c1dce9ce0d2f$var$frameInterval ? !1 : !0;
}
function $46c5c1dce9ce0d2f$var$performWorkUntilDeadline() {
    $46c5c1dce9ce0d2f$var$needsPaint = !1;
    if ($46c5c1dce9ce0d2f$var$isMessageLoopRunning) {
        var currentTime = $46c5c1dce9ce0d2f$export$c4744153514ff05d();
        $46c5c1dce9ce0d2f$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $46c5c1dce9ce0d2f$var$isHostCallbackScheduled = !1;
                $46c5c1dce9ce0d2f$var$isHostTimeoutScheduled && ($46c5c1dce9ce0d2f$var$isHostTimeoutScheduled = !1, $46c5c1dce9ce0d2f$var$localClearTimeout($46c5c1dce9ce0d2f$var$taskTimeoutID), $46c5c1dce9ce0d2f$var$taskTimeoutID = -1);
                $46c5c1dce9ce0d2f$var$isPerformingWork = !0;
                var previousPriorityLevel = $46c5c1dce9ce0d2f$var$currentPriorityLevel;
                try {
                    b: {
                        $46c5c1dce9ce0d2f$var$advanceTimers(currentTime);
                        for($46c5c1dce9ce0d2f$var$currentTask = $46c5c1dce9ce0d2f$var$peek($46c5c1dce9ce0d2f$var$taskQueue); null !== $46c5c1dce9ce0d2f$var$currentTask && !($46c5c1dce9ce0d2f$var$currentTask.expirationTime > currentTime && $46c5c1dce9ce0d2f$var$shouldYieldToHost());){
                            var callback = $46c5c1dce9ce0d2f$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $46c5c1dce9ce0d2f$var$currentTask.callback = null;
                                $46c5c1dce9ce0d2f$var$currentPriorityLevel = $46c5c1dce9ce0d2f$var$currentTask.priorityLevel;
                                var continuationCallback = callback($46c5c1dce9ce0d2f$var$currentTask.expirationTime <= currentTime);
                                currentTime = $46c5c1dce9ce0d2f$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $46c5c1dce9ce0d2f$var$currentTask.callback = continuationCallback;
                                    $46c5c1dce9ce0d2f$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $46c5c1dce9ce0d2f$var$currentTask === $46c5c1dce9ce0d2f$var$peek($46c5c1dce9ce0d2f$var$taskQueue) && $46c5c1dce9ce0d2f$var$pop($46c5c1dce9ce0d2f$var$taskQueue);
                                $46c5c1dce9ce0d2f$var$advanceTimers(currentTime);
                            } else $46c5c1dce9ce0d2f$var$pop($46c5c1dce9ce0d2f$var$taskQueue);
                            $46c5c1dce9ce0d2f$var$currentTask = $46c5c1dce9ce0d2f$var$peek($46c5c1dce9ce0d2f$var$taskQueue);
                        }
                        if (null !== $46c5c1dce9ce0d2f$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $46c5c1dce9ce0d2f$var$peek($46c5c1dce9ce0d2f$var$timerQueue);
                            null !== firstTimer && $46c5c1dce9ce0d2f$var$requestHostTimeout($46c5c1dce9ce0d2f$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $46c5c1dce9ce0d2f$var$currentTask = null, $46c5c1dce9ce0d2f$var$currentPriorityLevel = previousPriorityLevel, $46c5c1dce9ce0d2f$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $46c5c1dce9ce0d2f$var$schedulePerformWorkUntilDeadline() : $46c5c1dce9ce0d2f$var$isMessageLoopRunning = !1;
        }
    }
}
var $46c5c1dce9ce0d2f$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $46c5c1dce9ce0d2f$var$localSetImmediate) $46c5c1dce9ce0d2f$var$schedulePerformWorkUntilDeadline = function() {
    $46c5c1dce9ce0d2f$var$localSetImmediate($46c5c1dce9ce0d2f$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $46c5c1dce9ce0d2f$var$channel = new MessageChannel(), $46c5c1dce9ce0d2f$var$port = $46c5c1dce9ce0d2f$var$channel.port2;
    $46c5c1dce9ce0d2f$var$channel.port1.onmessage = $46c5c1dce9ce0d2f$var$performWorkUntilDeadline;
    $46c5c1dce9ce0d2f$var$schedulePerformWorkUntilDeadline = function() {
        $46c5c1dce9ce0d2f$var$port.postMessage(null);
    };
} else $46c5c1dce9ce0d2f$var$schedulePerformWorkUntilDeadline = function() {
    $46c5c1dce9ce0d2f$var$localSetTimeout($46c5c1dce9ce0d2f$var$performWorkUntilDeadline, 0);
};
function $46c5c1dce9ce0d2f$var$requestHostTimeout(callback, ms) {
    $46c5c1dce9ce0d2f$var$taskTimeoutID = $46c5c1dce9ce0d2f$var$localSetTimeout(function() {
        callback($46c5c1dce9ce0d2f$export$c4744153514ff05d());
    }, ms);
}
$46c5c1dce9ce0d2f$export$3e506c1ccc9cc1a7 = 5;
$46c5c1dce9ce0d2f$export$e26fe2ed2fa76875 = 1;
$46c5c1dce9ce0d2f$export$502329bbf4b505b1 = 4;
$46c5c1dce9ce0d2f$export$6e3807111c4874c4 = 3;
$46c5c1dce9ce0d2f$export$c27134553091fb3a = null;
$46c5c1dce9ce0d2f$export$33ee1acdc04fd2a2 = 2;
$46c5c1dce9ce0d2f$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$46c5c1dce9ce0d2f$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $46c5c1dce9ce0d2f$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$46c5c1dce9ce0d2f$export$d3dfb8e4810cb555 = function() {
    return $46c5c1dce9ce0d2f$var$currentPriorityLevel;
};
$46c5c1dce9ce0d2f$export$72fdf0e06517287b = function(eventHandler) {
    switch($46c5c1dce9ce0d2f$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $46c5c1dce9ce0d2f$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $46c5c1dce9ce0d2f$var$currentPriorityLevel;
    $46c5c1dce9ce0d2f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $46c5c1dce9ce0d2f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$46c5c1dce9ce0d2f$export$816d2913ae6b83b1 = function() {
    $46c5c1dce9ce0d2f$var$needsPaint = !0;
};
$46c5c1dce9ce0d2f$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $46c5c1dce9ce0d2f$var$currentPriorityLevel;
    $46c5c1dce9ce0d2f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $46c5c1dce9ce0d2f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$46c5c1dce9ce0d2f$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $46c5c1dce9ce0d2f$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $46c5c1dce9ce0d2f$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $46c5c1dce9ce0d2f$var$push($46c5c1dce9ce0d2f$var$timerQueue, priorityLevel), null === $46c5c1dce9ce0d2f$var$peek($46c5c1dce9ce0d2f$var$taskQueue) && priorityLevel === $46c5c1dce9ce0d2f$var$peek($46c5c1dce9ce0d2f$var$timerQueue) && ($46c5c1dce9ce0d2f$var$isHostTimeoutScheduled ? ($46c5c1dce9ce0d2f$var$localClearTimeout($46c5c1dce9ce0d2f$var$taskTimeoutID), $46c5c1dce9ce0d2f$var$taskTimeoutID = -1) : $46c5c1dce9ce0d2f$var$isHostTimeoutScheduled = !0, $46c5c1dce9ce0d2f$var$requestHostTimeout($46c5c1dce9ce0d2f$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $46c5c1dce9ce0d2f$var$push($46c5c1dce9ce0d2f$var$taskQueue, priorityLevel), $46c5c1dce9ce0d2f$var$isHostCallbackScheduled || $46c5c1dce9ce0d2f$var$isPerformingWork || ($46c5c1dce9ce0d2f$var$isHostCallbackScheduled = !0, $46c5c1dce9ce0d2f$var$isMessageLoopRunning || ($46c5c1dce9ce0d2f$var$isMessageLoopRunning = !0, $46c5c1dce9ce0d2f$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$46c5c1dce9ce0d2f$export$b5836b71941fa3ed = $46c5c1dce9ce0d2f$var$shouldYieldToHost;
$46c5c1dce9ce0d2f$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $46c5c1dce9ce0d2f$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $46c5c1dce9ce0d2f$var$currentPriorityLevel;
        $46c5c1dce9ce0d2f$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $46c5c1dce9ce0d2f$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("6afFj", function(module, exports) {
'use strict';
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

module.exports = (parcelRequire("41dBC"));

});
parcelRegister("41dBC", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $2ed1cf3ec43ffc9d$export$69ce8ef3fe5cead0; }, function (v) { return $2ed1cf3ec43ffc9d$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $2ed1cf3ec43ffc9d$export$d39a5bbd09211389; }, function (v) { return $2ed1cf3ec43ffc9d$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $2ed1cf3ec43ffc9d$export$cd75ccfd720a3cd4; }, function (v) { return $2ed1cf3ec43ffc9d$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $2ed1cf3ec43ffc9d$export$a0816fa17a9e79be; }, function (v) { return $2ed1cf3ec43ffc9d$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $2ed1cf3ec43ffc9d$export$7292efcadded39f3; }, function (v) { return $2ed1cf3ec43ffc9d$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $2ed1cf3ec43ffc9d$export$da407abadb9b8f86; }, function (v) { return $2ed1cf3ec43ffc9d$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $2ed1cf3ec43ffc9d$export$314cfea32580671c; }, function (v) { return $2ed1cf3ec43ffc9d$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $2ed1cf3ec43ffc9d$export$513ccb98c53b8039; }, function (v) { return $2ed1cf3ec43ffc9d$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $2ed1cf3ec43ffc9d$export$dbca993bc2d264a; }, function (v) { return $2ed1cf3ec43ffc9d$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $2ed1cf3ec43ffc9d$export$4797a8006f0655d0; }, function (v) { return $2ed1cf3ec43ffc9d$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $2ed1cf3ec43ffc9d$export$c78a37762a8d58e1; }, function (v) { return $2ed1cf3ec43ffc9d$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $2ed1cf3ec43ffc9d$export$606f11b2eb45ecc6; }, function (v) { return $2ed1cf3ec43ffc9d$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $2ed1cf3ec43ffc9d$export$f7e8a0bf92324b1e; }, function (v) { return $2ed1cf3ec43ffc9d$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $2ed1cf3ec43ffc9d$export$83d89fbfd8236492; }, function (v) { return $2ed1cf3ec43ffc9d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2ed1cf3ec43ffc9d$export$69ce8ef3fe5cead0;
var $2ed1cf3ec43ffc9d$export$d39a5bbd09211389;
var $2ed1cf3ec43ffc9d$export$cd75ccfd720a3cd4;
var $2ed1cf3ec43ffc9d$export$a0816fa17a9e79be;
var $2ed1cf3ec43ffc9d$export$7292efcadded39f3;
var $2ed1cf3ec43ffc9d$export$da407abadb9b8f86;
var $2ed1cf3ec43ffc9d$export$314cfea32580671c;
var $2ed1cf3ec43ffc9d$export$513ccb98c53b8039;
var $2ed1cf3ec43ffc9d$export$dbca993bc2d264a;
var $2ed1cf3ec43ffc9d$export$4797a8006f0655d0;
var $2ed1cf3ec43ffc9d$export$c78a37762a8d58e1;
var $2ed1cf3ec43ffc9d$export$606f11b2eb45ecc6;
var $2ed1cf3ec43ffc9d$export$f7e8a0bf92324b1e;
var $2ed1cf3ec43ffc9d$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
function $2ed1cf3ec43ffc9d$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $2ed1cf3ec43ffc9d$var$noop() {}
var $2ed1cf3ec43ffc9d$var$Internals = {
    d: {
        f: $2ed1cf3ec43ffc9d$var$noop,
        r: function() {
            throw Error($2ed1cf3ec43ffc9d$var$formatProdErrorMessage(522));
        },
        D: $2ed1cf3ec43ffc9d$var$noop,
        C: $2ed1cf3ec43ffc9d$var$noop,
        L: $2ed1cf3ec43ffc9d$var$noop,
        m: $2ed1cf3ec43ffc9d$var$noop,
        X: $2ed1cf3ec43ffc9d$var$noop,
        S: $2ed1cf3ec43ffc9d$var$noop,
        M: $2ed1cf3ec43ffc9d$var$noop
    },
    p: 0,
    findDOMNode: null
}, $2ed1cf3ec43ffc9d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $2ed1cf3ec43ffc9d$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $2ed1cf3ec43ffc9d$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $2ed1cf3ec43ffc9d$var$ReactSharedInternals = $bh6RR.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$2ed1cf3ec43ffc9d$export$69ce8ef3fe5cead0 = $2ed1cf3ec43ffc9d$var$Internals;
$2ed1cf3ec43ffc9d$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($2ed1cf3ec43ffc9d$var$formatProdErrorMessage(299));
    return $2ed1cf3ec43ffc9d$var$createPortal$1(children, container, null, key);
};
$2ed1cf3ec43ffc9d$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $2ed1cf3ec43ffc9d$var$ReactSharedInternals.T, previousUpdatePriority = $2ed1cf3ec43ffc9d$var$Internals.p;
    try {
        if ($2ed1cf3ec43ffc9d$var$ReactSharedInternals.T = null, $2ed1cf3ec43ffc9d$var$Internals.p = 2, fn) return fn();
    } finally{
        $2ed1cf3ec43ffc9d$var$ReactSharedInternals.T = previousTransition, $2ed1cf3ec43ffc9d$var$Internals.p = previousUpdatePriority, $2ed1cf3ec43ffc9d$var$Internals.d.f();
    }
};
$2ed1cf3ec43ffc9d$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $2ed1cf3ec43ffc9d$var$Internals.d.C(href, options));
};
$2ed1cf3ec43ffc9d$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $2ed1cf3ec43ffc9d$var$Internals.d.D(href);
};
$2ed1cf3ec43ffc9d$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $2ed1cf3ec43ffc9d$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $2ed1cf3ec43ffc9d$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$2ed1cf3ec43ffc9d$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $2ed1cf3ec43ffc9d$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $2ed1cf3ec43ffc9d$var$Internals.d.M(href);
    }
};
$2ed1cf3ec43ffc9d$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(as, options.crossOrigin);
        $2ed1cf3ec43ffc9d$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$2ed1cf3ec43ffc9d$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $2ed1cf3ec43ffc9d$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $2ed1cf3ec43ffc9d$var$Internals.d.m(href);
    }
};
$2ed1cf3ec43ffc9d$export$4797a8006f0655d0 = function(form) {
    $2ed1cf3ec43ffc9d$var$Internals.d.r(form);
};
$2ed1cf3ec43ffc9d$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$2ed1cf3ec43ffc9d$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $2ed1cf3ec43ffc9d$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$2ed1cf3ec43ffc9d$export$f7e8a0bf92324b1e = function() {
    return $2ed1cf3ec43ffc9d$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$2ed1cf3ec43ffc9d$export$83d89fbfd8236492 = "19.2.0";

});




parcelRegister("ih19M", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kyM0p"));

});
parcelRegister("kyM0p", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $ef7c3885563104b0$export$ffb0004e005737fa; }, function (v) { return $ef7c3885563104b0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $ef7c3885563104b0$export$34b9dba7ce09269b; }, function (v) { return $ef7c3885563104b0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $ef7c3885563104b0$export$25062201e9e25d76; }, function (v) { return $ef7c3885563104b0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ef7c3885563104b0$export$ffb0004e005737fa;
var $ef7c3885563104b0$export$34b9dba7ce09269b;
var $ef7c3885563104b0$export$25062201e9e25d76;
"use strict";
var $ef7c3885563104b0$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $ef7c3885563104b0$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $ef7c3885563104b0$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $ef7c3885563104b0$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$ef7c3885563104b0$export$ffb0004e005737fa = $ef7c3885563104b0$var$REACT_FRAGMENT_TYPE;
$ef7c3885563104b0$export$34b9dba7ce09269b = $ef7c3885563104b0$var$jsxProd;
$ef7c3885563104b0$export$25062201e9e25d76 = $ef7c3885563104b0$var$jsxProd;

});


parcelRegister("as544", function(module, exports) {

$parcel$export(module.exports, "createBrowserHistory", function () { return $40154fc552d3dc18$export$719fc203c4e16dee; });
$parcel$export(module.exports, "invariant", function () { return $40154fc552d3dc18$export$f5708dca728d7177; });
$parcel$export(module.exports, "createContext", function () { return $40154fc552d3dc18$export$fd42f52fd3ae1109; });
$parcel$export(module.exports, "RouterContextProvider", function () { return $40154fc552d3dc18$export$b8d3e69d4b3eff04; });
$parcel$export(module.exports, "convertRoutesToDataRoutes", function () { return $40154fc552d3dc18$export$87cb1a9238dc3fba; });
$parcel$export(module.exports, "matchRoutes", function () { return $40154fc552d3dc18$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $40154fc552d3dc18$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "redirect", function () { return $40154fc552d3dc18$export$89e12c5b50f7529d; });
$parcel$export(module.exports, "redirectDocument", function () { return $40154fc552d3dc18$export$a6cd19cd1951a23c; });
$parcel$export(module.exports, "replace", function () { return $40154fc552d3dc18$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "ErrorResponseImpl", function () { return $40154fc552d3dc18$export$f2680fa305b734ca; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $40154fc552d3dc18$export$972111febbeef05b; });
$parcel$export(module.exports, "instrumentHandler", function () { return $40154fc552d3dc18$export$8f7a8e481272777; });
$parcel$export(module.exports, "createRouter", function () { return $40154fc552d3dc18$export$baddd0131ee8c05b; });
$parcel$export(module.exports, "isMutationMethod", function () { return $40154fc552d3dc18$export$cbae47800eb95bc3; });
$parcel$export(module.exports, "createStaticHandler", function () { return $40154fc552d3dc18$export$3336b097a6fbc59a; });
$parcel$export(module.exports, "isResponse", function () { return $40154fc552d3dc18$export$3f1eb41d9a6a6a27; });
$parcel$export(module.exports, "isRedirectResponse", function () { return $40154fc552d3dc18$export$6e80290866a84dd4; });
$parcel$export(module.exports, "isDataWithResponseInit", function () { return $40154fc552d3dc18$export$e0163cfdf7bc9cfa; });
$parcel$export(module.exports, "getStaticContextFromError", function () { return $40154fc552d3dc18$export$fec11da027c70692; });
$parcel$export(module.exports, "isRedirectStatusCode", function () { return $40154fc552d3dc18$export$794b2760043cf8cd; });
$parcel$export(module.exports, "RSCRouterContext", function () { return $40154fc552d3dc18$export$717f757c655223f1; });
$parcel$export(module.exports, "ENABLE_DEV_WARNINGS", function () { return $40154fc552d3dc18$export$945fecf35a8ef089; });
$parcel$export(module.exports, "useLocation", function () { return $40154fc552d3dc18$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $40154fc552d3dc18$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $40154fc552d3dc18$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "useRouteError", function () { return $40154fc552d3dc18$export$ed527bf60f6e05f2; });
$parcel$export(module.exports, "warnOnce", function () { return $40154fc552d3dc18$export$5b28268982f175ba; });
$parcel$export(module.exports, "mapRouteProperties", function () { return $40154fc552d3dc18$export$9269a41d8c4635e; });
$parcel$export(module.exports, "hydrationRouteProperties", function () { return $40154fc552d3dc18$export$e2fd2c03906469db; });
$parcel$export(module.exports, "createMemoryRouter", function () { return $40154fc552d3dc18$export$f30f7e456d254e83; });
$parcel$export(module.exports, "UNSTABLE_TransitionEnabledRouterProvider", function () { return $40154fc552d3dc18$export$b23aa17f1e546c5e; });
$parcel$export(module.exports, "RouterProvider", function () { return $40154fc552d3dc18$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "Navigate", function () { return $40154fc552d3dc18$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Outlet", function () { return $40154fc552d3dc18$export$910ae8079b2c2852; });
$parcel$export(module.exports, "Route", function () { return $40154fc552d3dc18$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $40154fc552d3dc18$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "withComponentProps", function () { return $40154fc552d3dc18$export$1a5de91a5c3255e0; });
$parcel$export(module.exports, "withHydrateFallbackProps", function () { return $40154fc552d3dc18$export$cd4a5850c74ba029; });
$parcel$export(module.exports, "withErrorBoundaryProps", function () { return $40154fc552d3dc18$export$26aea97ad016e70c; });
$parcel$export(module.exports, "encode", function () { return $40154fc552d3dc18$export$c564cdbbe6da493; });
$parcel$export(module.exports, "createRequestInit", function () { return $40154fc552d3dc18$export$a30aa2a0fce6c468; });
$parcel$export(module.exports, "escapeHtml", function () { return $40154fc552d3dc18$export$4cf11838cdc2a8a8; });
$parcel$export(module.exports, "SingleFetchRedirectSymbol", function () { return $40154fc552d3dc18$export$60644022b8b46aaa; });
$parcel$export(module.exports, "SINGLE_FETCH_REDIRECT_STATUS", function () { return $40154fc552d3dc18$export$ae9272e641ead836; });
$parcel$export(module.exports, "NO_BODY_STATUS_CODES", function () { return $40154fc552d3dc18$export$e35ccdcde387134d; });
$parcel$export(module.exports, "StreamTransfer", function () { return $40154fc552d3dc18$export$2b0b5f24fd77a79f; });
$parcel$export(module.exports, "getTurboStreamSingleFetchDataStrategy", function () { return $40154fc552d3dc18$export$77d7799427e365da; });
$parcel$export(module.exports, "getSingleFetchDataStrategyImpl", function () { return $40154fc552d3dc18$export$7144ac7f1a8613d3; });
$parcel$export(module.exports, "stripIndexParam", function () { return $40154fc552d3dc18$export$425969b7f98e2c9c; });
$parcel$export(module.exports, "singleFetchUrl", function () { return $40154fc552d3dc18$export$7b977381851b2c; });
$parcel$export(module.exports, "decodeViaTurboStream", function () { return $40154fc552d3dc18$export$4023ad4ecd4126a2; });
$parcel$export(module.exports, "createServerRoutes", function () { return $40154fc552d3dc18$export$5be2318464878170; });
$parcel$export(module.exports, "createClientRoutesWithHMRRevalidationOptOut", function () { return $40154fc552d3dc18$export$49d9dc160d22054c; });
$parcel$export(module.exports, "createClientRoutes", function () { return $40154fc552d3dc18$export$af76e85f27ba0229; });
$parcel$export(module.exports, "noActionDefinedError", function () { return $40154fc552d3dc18$export$2754e84c8e66e57d; });
$parcel$export(module.exports, "shouldHydrateRouteLoader", function () { return $40154fc552d3dc18$export$6ac68922d4e92125; });
$parcel$export(module.exports, "getPatchRoutesOnNavigationFunction", function () { return $40154fc552d3dc18$export$72ab377a1030deb9; });
$parcel$export(module.exports, "useFogOFWarDiscovery", function () { return $40154fc552d3dc18$export$5ef046b23d96090d; });
$parcel$export(module.exports, "getManifestPath", function () { return $40154fc552d3dc18$export$bcb79c3deff01d56; });
$parcel$export(module.exports, "FrameworkContext", function () { return $40154fc552d3dc18$export$208d6a3bc3aa62bd; });
$parcel$export(module.exports, "setIsHydrated", function () { return $40154fc552d3dc18$export$3be068dde909e563; });
$parcel$export(module.exports, "RemixErrorBoundary", function () { return $40154fc552d3dc18$export$32e57f52df4b6e34; });
$parcel$export(module.exports, "createBrowserRouter", function () { return $40154fc552d3dc18$export$1f3f55432a00e06d; });
$parcel$export(module.exports, "Link", function () { return $40154fc552d3dc18$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useSearchParams", function () { return $40154fc552d3dc18$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "StaticRouterProvider", function () { return $40154fc552d3dc18$export$3d80f15952491985; });
$parcel$export(module.exports, "createStaticRouter", function () { return $40154fc552d3dc18$export$3dd6171c30258b6f; });
/**
 * react-router v7.9.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");
var $40154fc552d3dc18$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-4WY6JWTD.mjs"
});
var $40154fc552d3dc18$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $40154fc552d3dc18$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $40154fc552d3dc18$var$__typeError("Cannot " + msg);
var $40154fc552d3dc18$var$__privateGet = (obj, member, getter)=>($40154fc552d3dc18$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $40154fc552d3dc18$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $40154fc552d3dc18$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $40154fc552d3dc18$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($40154fc552d3dc18$export$e19cd5f9376f8cee || {});
var $40154fc552d3dc18$var$PopStateEventType = "popstate";
function $40154fc552d3dc18$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $40154fc552d3dc18$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $40154fc552d3dc18$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $40154fc552d3dc18$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $40154fc552d3dc18$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $40154fc552d3dc18$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $40154fc552d3dc18$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $40154fc552d3dc18$export$fe53371bee54353d(to);
    }
    return $40154fc552d3dc18$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $40154fc552d3dc18$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $40154fc552d3dc18$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $40154fc552d3dc18$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $40154fc552d3dc18$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $40154fc552d3dc18$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $40154fc552d3dc18$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $40154fc552d3dc18$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $40154fc552d3dc18$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $40154fc552d3dc18$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $40154fc552d3dc18$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $40154fc552d3dc18$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $40154fc552d3dc18$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $40154fc552d3dc18$var$createKey()
    };
    return location;
}
function $40154fc552d3dc18$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $40154fc552d3dc18$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $40154fc552d3dc18$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $40154fc552d3dc18$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $40154fc552d3dc18$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $40154fc552d3dc18$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $40154fc552d3dc18$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $40154fc552d3dc18$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($40154fc552d3dc18$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($40154fc552d3dc18$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $40154fc552d3dc18$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $40154fc552d3dc18$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $40154fc552d3dc18$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $40154fc552d3dc18$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $40154fc552d3dc18$var$_map;
var $40154fc552d3dc18$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $40154fc552d3dc18$var$__privateAdd(this, $40154fc552d3dc18$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($40154fc552d3dc18$var$__privateGet(this, $40154fc552d3dc18$var$_map).has(context)) return $40154fc552d3dc18$var$__privateGet(this, $40154fc552d3dc18$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $40154fc552d3dc18$var$__privateGet(this, $40154fc552d3dc18$var$_map).set(context, value);
    }
};
$40154fc552d3dc18$var$_map = new WeakMap();
var $40154fc552d3dc18$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $40154fc552d3dc18$var$isUnsupportedLazyRouteObjectKey(key) {
    return $40154fc552d3dc18$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $40154fc552d3dc18$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $40154fc552d3dc18$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $40154fc552d3dc18$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $40154fc552d3dc18$var$isIndexRoute(route) {
    return route.index === true;
}
function $40154fc552d3dc18$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $40154fc552d3dc18$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $40154fc552d3dc18$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($40154fc552d3dc18$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $40154fc552d3dc18$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $40154fc552d3dc18$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $40154fc552d3dc18$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $40154fc552d3dc18$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $40154fc552d3dc18$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $40154fc552d3dc18$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $40154fc552d3dc18$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $40154fc552d3dc18$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $40154fc552d3dc18$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $40154fc552d3dc18$var$flattenRoutes(routes);
    $40154fc552d3dc18$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $40154fc552d3dc18$var$decodePath(pathname);
        matches = $40154fc552d3dc18$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $40154fc552d3dc18$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $40154fc552d3dc18$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $40154fc552d3dc18$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $40154fc552d3dc18$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $40154fc552d3dc18$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $40154fc552d3dc18$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $40154fc552d3dc18$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $40154fc552d3dc18$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $40154fc552d3dc18$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $40154fc552d3dc18$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $40154fc552d3dc18$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $40154fc552d3dc18$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $40154fc552d3dc18$var$paramRe = /^:[\w-]+$/;
var $40154fc552d3dc18$var$dynamicSegmentValue = 3;
var $40154fc552d3dc18$var$indexRouteValue = 2;
var $40154fc552d3dc18$var$emptySegmentValue = 1;
var $40154fc552d3dc18$var$staticSegmentValue = 10;
var $40154fc552d3dc18$var$splatPenalty = -2;
var $40154fc552d3dc18$var$isSplat = (s)=>s === "*";
function $40154fc552d3dc18$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($40154fc552d3dc18$var$isSplat)) initialScore += $40154fc552d3dc18$var$splatPenalty;
    if (index) initialScore += $40154fc552d3dc18$var$indexRouteValue;
    return segments.filter((s)=>!$40154fc552d3dc18$var$isSplat(s)).reduce((score, segment)=>score + ($40154fc552d3dc18$var$paramRe.test(segment) ? $40154fc552d3dc18$var$dynamicSegmentValue : segment === "" ? $40154fc552d3dc18$var$emptySegmentValue : $40154fc552d3dc18$var$staticSegmentValue), initialScore);
}
function $40154fc552d3dc18$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $40154fc552d3dc18$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $40154fc552d3dc18$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $40154fc552d3dc18$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $40154fc552d3dc18$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $40154fc552d3dc18$var$normalizePathname($40154fc552d3dc18$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $40154fc552d3dc18$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $40154fc552d3dc18$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $40154fc552d3dc18$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $40154fc552d3dc18$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param));
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $40154fc552d3dc18$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $40154fc552d3dc18$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $40154fc552d3dc18$var$compilePath(path, caseSensitive = false, end = true) {
    $40154fc552d3dc18$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $40154fc552d3dc18$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $40154fc552d3dc18$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $40154fc552d3dc18$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $40154fc552d3dc18$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $40154fc552d3dc18$var$joinPaths([
        basename,
        pathname
    ]);
}
var $40154fc552d3dc18$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $40154fc552d3dc18$var$isAbsoluteUrl = (url)=>$40154fc552d3dc18$var$ABSOLUTE_URL_REGEX.test(url);
function $40154fc552d3dc18$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $40154fc552d3dc18$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($40154fc552d3dc18$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $40154fc552d3dc18$var$warning(false, `Pathnames cannot have embedded double slashes - normalizing ${oldPathname} -> ${toPathname}`);
            }
            if (toPathname.startsWith("/")) pathname = $40154fc552d3dc18$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $40154fc552d3dc18$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $40154fc552d3dc18$var$normalizeSearch(search),
        hash: $40154fc552d3dc18$var$normalizeHash(hash)
    };
}
function $40154fc552d3dc18$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $40154fc552d3dc18$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $40154fc552d3dc18$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $40154fc552d3dc18$var$getResolveToMatches(matches) {
    let pathMatches = $40154fc552d3dc18$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $40154fc552d3dc18$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $40154fc552d3dc18$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $40154fc552d3dc18$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $40154fc552d3dc18$var$getInvalidPathError("?", "pathname", "search", to));
        $40154fc552d3dc18$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $40154fc552d3dc18$var$getInvalidPathError("#", "pathname", "hash", to));
        $40154fc552d3dc18$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $40154fc552d3dc18$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $40154fc552d3dc18$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $40154fc552d3dc18$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $40154fc552d3dc18$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $40154fc552d3dc18$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $40154fc552d3dc18$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $40154fc552d3dc18$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $40154fc552d3dc18$export$4051a07651545597(data2, init) {
    return new $40154fc552d3dc18$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $40154fc552d3dc18$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $40154fc552d3dc18$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $40154fc552d3dc18$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $40154fc552d3dc18$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $40154fc552d3dc18$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $40154fc552d3dc18$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $40154fc552d3dc18$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $40154fc552d3dc18$var$getRoutePattern(paths) {
    return paths.filter(Boolean).join("/").replace(/\/\/*/g, "/") || "/";
}
// lib/router/instrumentation.ts
var $40154fc552d3dc18$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $40154fc552d3dc18$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $40154fc552d3dc18$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $40154fc552d3dc18$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$40154fc552d3dc18$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $40154fc552d3dc18$var$wrapImpl(aggregated[key], original, (...args)=>$40154fc552d3dc18$var$getHandlerInfo(args[0]));
            if (instrumented) {
                instrumented[$40154fc552d3dc18$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$40154fc552d3dc18$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $40154fc552d3dc18$var$wrapImpl(aggregated.middleware, original, (...args)=>$40154fc552d3dc18$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$40154fc552d3dc18$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $40154fc552d3dc18$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$40154fc552d3dc18$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $40154fc552d3dc18$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $40154fc552d3dc18$export$fe53371bee54353d(to) : ".",
                ...$40154fc552d3dc18$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$40154fc552d3dc18$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$40154fc552d3dc18$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $40154fc552d3dc18$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$40154fc552d3dc18$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$40154fc552d3dc18$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $40154fc552d3dc18$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $40154fc552d3dc18$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $40154fc552d3dc18$var$getReadonlyRequest(request),
            context: context != null ? $40154fc552d3dc18$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $40154fc552d3dc18$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $40154fc552d3dc18$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $40154fc552d3dc18$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $40154fc552d3dc18$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $40154fc552d3dc18$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $40154fc552d3dc18$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $40154fc552d3dc18$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $40154fc552d3dc18$var$getReadonlyContext(context)
    };
}
function $40154fc552d3dc18$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $40154fc552d3dc18$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $40154fc552d3dc18$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $40154fc552d3dc18$var$getReadonlyContext(context) {
    if ($40154fc552d3dc18$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $40154fc552d3dc18$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $40154fc552d3dc18$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $40154fc552d3dc18$var$objectProtoNames;
}
// lib/router/router.ts
var $40154fc552d3dc18$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $40154fc552d3dc18$var$validMutationMethods = new Set($40154fc552d3dc18$var$validMutationMethodsArr);
var $40154fc552d3dc18$var$validRequestMethodsArr = [
    "GET",
    ...$40154fc552d3dc18$var$validMutationMethodsArr
];
var $40154fc552d3dc18$var$validRequestMethods = new Set($40154fc552d3dc18$var$validRequestMethodsArr);
var $40154fc552d3dc18$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $40154fc552d3dc18$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $40154fc552d3dc18$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $40154fc552d3dc18$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $40154fc552d3dc18$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $40154fc552d3dc18$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $40154fc552d3dc18$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $40154fc552d3dc18$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $40154fc552d3dc18$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $40154fc552d3dc18$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $40154fc552d3dc18$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$40154fc552d3dc18$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $40154fc552d3dc18$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $40154fc552d3dc18$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $40154fc552d3dc18$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $40154fc552d3dc18$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $40154fc552d3dc18$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
        else if (!initialMatches.some((m)=>$40154fc552d3dc18$var$routeHasLoaderOrMiddleware(m.route))) initialized = true;
        else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                initialized = initialMatches.slice(0, idx + 1).every((m)=>!$40154fc552d3dc18$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
            } else initialized = initialMatches.every((m)=>!$40154fc552d3dc18$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $40154fc552d3dc18$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $40154fc552d3dc18$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $40154fc552d3dc18$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $40154fc552d3dc18$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$40154fc552d3dc18$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $40154fc552d3dc18$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $40154fc552d3dc18$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $40154fc552d3dc18$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $40154fc552d3dc18$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $40154fc552d3dc18$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $40154fc552d3dc18$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $40154fc552d3dc18$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $40154fc552d3dc18$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $40154fc552d3dc18$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $40154fc552d3dc18$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $40154fc552d3dc18$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $40154fc552d3dc18$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $40154fc552d3dc18$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $40154fc552d3dc18$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $40154fc552d3dc18$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $40154fc552d3dc18$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $40154fc552d3dc18$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $40154fc552d3dc18$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($40154fc552d3dc18$var$isErrorResult(result) && $40154fc552d3dc18$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $40154fc552d3dc18$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $40154fc552d3dc18$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$40154fc552d3dc18$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $40154fc552d3dc18$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $40154fc552d3dc18$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $40154fc552d3dc18$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $40154fc552d3dc18$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $40154fc552d3dc18$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $40154fc552d3dc18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($40154fc552d3dc18$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $40154fc552d3dc18$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($40154fc552d3dc18$var$isErrorResult(result)) {
            let boundaryMatch = $40154fc552d3dc18$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $40154fc552d3dc18$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $40154fc552d3dc18$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $40154fc552d3dc18$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $40154fc552d3dc18$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $40154fc552d3dc18$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $40154fc552d3dc18$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$40154fc552d3dc18$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $40154fc552d3dc18$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $40154fc552d3dc18$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $40154fc552d3dc18$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$40154fc552d3dc18$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $40154fc552d3dc18$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $40154fc552d3dc18$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $40154fc552d3dc18$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $40154fc552d3dc18$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $40154fc552d3dc18$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $40154fc552d3dc18$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $40154fc552d3dc18$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $40154fc552d3dc18$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $40154fc552d3dc18$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $40154fc552d3dc18$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $40154fc552d3dc18$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $40154fc552d3dc18$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $40154fc552d3dc18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($40154fc552d3dc18$var$isRedirectResult(actionResult) || $40154fc552d3dc18$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $40154fc552d3dc18$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($40154fc552d3dc18$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $40154fc552d3dc18$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $40154fc552d3dc18$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($40154fc552d3dc18$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $40154fc552d3dc18$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $40154fc552d3dc18$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $40154fc552d3dc18$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $40154fc552d3dc18$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $40154fc552d3dc18$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $40154fc552d3dc18$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $40154fc552d3dc18$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $40154fc552d3dc18$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $40154fc552d3dc18$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $40154fc552d3dc18$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $40154fc552d3dc18$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $40154fc552d3dc18$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $40154fc552d3dc18$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $40154fc552d3dc18$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $40154fc552d3dc18$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $40154fc552d3dc18$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $40154fc552d3dc18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $40154fc552d3dc18$var$getDoneFetcher(void 0));
            return;
        }
        if ($40154fc552d3dc18$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $40154fc552d3dc18$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($40154fc552d3dc18$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $40154fc552d3dc18$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $40154fc552d3dc18$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $40154fc552d3dc18$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $40154fc552d3dc18$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($40154fc552d3dc18$var$isAbsoluteUrl(location)) {
                const url = $40154fc552d3dc18$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $40154fc552d3dc18$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $40154fc552d3dc18$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($40154fc552d3dc18$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $40154fc552d3dc18$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $40154fc552d3dc18$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $40154fc552d3dc18$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        for (let [routeId, result] of Object.entries(results))if ($40154fc552d3dc18$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $40154fc552d3dc18$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $40154fc552d3dc18$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $40154fc552d3dc18$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $40154fc552d3dc18$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $40154fc552d3dc18$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $40154fc552d3dc18$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $40154fc552d3dc18$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $40154fc552d3dc18$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $40154fc552d3dc18$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $40154fc552d3dc18$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $40154fc552d3dc18$export$386d57f03f0b2883;
        $40154fc552d3dc18$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $40154fc552d3dc18$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $40154fc552d3dc18$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $40154fc552d3dc18$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $40154fc552d3dc18$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$40154fc552d3dc18$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $40154fc552d3dc18$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $40154fc552d3dc18$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $40154fc552d3dc18$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $40154fc552d3dc18$export$2708184779ceb39d(routesToUse, pathname, basename);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $40154fc552d3dc18$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $40154fc552d3dc18$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $40154fc552d3dc18$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $40154fc552d3dc18$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $40154fc552d3dc18$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $40154fc552d3dc18$export$3336b097a6fbc59a(routes, opts) {
    $40154fc552d3dc18$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $40154fc552d3dc18$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (opts?.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$40154fc552d3dc18$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $40154fc552d3dc18$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $40154fc552d3dc18$var$createLocation("", $40154fc552d3dc18$export$fe53371bee54353d(url), null, "default");
        let matches = $40154fc552d3dc18$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $40154fc552d3dc18$export$b8d3e69d4b3eff04();
        if (!$40154fc552d3dc18$var$isValidMethod(method) && method !== "HEAD") {
            let error = $40154fc552d3dc18$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $40154fc552d3dc18$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $40154fc552d3dc18$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $40154fc552d3dc18$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $40154fc552d3dc18$export$f5708dca728d7177(requestContext instanceof $40154fc552d3dc18$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $40154fc552d3dc18$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $40154fc552d3dc18$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_pattern: $40154fc552d3dc18$var$getRoutePattern(matches.map((m)=>m.route.path)),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($40154fc552d3dc18$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($40154fc552d3dc18$export$6e80290866a84dd4(error)) return error;
                    if ($40154fc552d3dc18$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $40154fc552d3dc18$export$f2680fa305b734ca(error.status, error.statusText, await $40154fc552d3dc18$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($40154fc552d3dc18$export$e0163cfdf7bc9cfa(error)) error = $40154fc552d3dc18$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $40154fc552d3dc18$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $40154fc552d3dc18$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $40154fc552d3dc18$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $40154fc552d3dc18$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $40154fc552d3dc18$export$f5708dca728d7177($40154fc552d3dc18$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($40154fc552d3dc18$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($40154fc552d3dc18$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $40154fc552d3dc18$var$createLocation("", $40154fc552d3dc18$export$fe53371bee54353d(url), null, "default");
        let matches = $40154fc552d3dc18$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $40154fc552d3dc18$export$b8d3e69d4b3eff04();
        if (!$40154fc552d3dc18$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $40154fc552d3dc18$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $40154fc552d3dc18$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $40154fc552d3dc18$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $40154fc552d3dc18$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $40154fc552d3dc18$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $40154fc552d3dc18$export$f5708dca728d7177(requestContext instanceof $40154fc552d3dc18$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $40154fc552d3dc18$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $40154fc552d3dc18$var$runServerMiddlewarePipeline({
                request: request,
                unstable_pattern: $40154fc552d3dc18$var$getRoutePattern(matches.map((m)=>m.route.path)),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $40154fc552d3dc18$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($40154fc552d3dc18$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($40154fc552d3dc18$var$dataWithResponseInitToResponse(error));
                if ($40154fc552d3dc18$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($40154fc552d3dc18$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $40154fc552d3dc18$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($40154fc552d3dc18$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $40154fc552d3dc18$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $40154fc552d3dc18$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($40154fc552d3dc18$var$isDataStrategyResult(e) && $40154fc552d3dc18$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($40154fc552d3dc18$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $40154fc552d3dc18$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $40154fc552d3dc18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $40154fc552d3dc18$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($40154fc552d3dc18$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($40154fc552d3dc18$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($40154fc552d3dc18$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $40154fc552d3dc18$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $40154fc552d3dc18$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($40154fc552d3dc18$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $40154fc552d3dc18$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $40154fc552d3dc18$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $40154fc552d3dc18$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $40154fc552d3dc18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $40154fc552d3dc18$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $40154fc552d3dc18$var$getRoutePattern(matches.map((m)=>m.route.path));
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $40154fc552d3dc18$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, false);
                return $40154fc552d3dc18$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $40154fc552d3dc18$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $40154fc552d3dc18$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $40154fc552d3dc18$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $40154fc552d3dc18$var$callDataStrategyImpl(dataStrategy || $40154fc552d3dc18$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($40154fc552d3dc18$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $40154fc552d3dc18$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($40154fc552d3dc18$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($40154fc552d3dc18$export$e0163cfdf7bc9cfa(result.result)) throw $40154fc552d3dc18$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $40154fc552d3dc18$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $40154fc552d3dc18$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $40154fc552d3dc18$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $40154fc552d3dc18$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $40154fc552d3dc18$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $40154fc552d3dc18$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $40154fc552d3dc18$var$resolveTo(to ? to : ".", $40154fc552d3dc18$var$getResolveToMatches(contextualMatches), $40154fc552d3dc18$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $40154fc552d3dc18$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $40154fc552d3dc18$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $40154fc552d3dc18$export$fe53371bee54353d(path);
}
function $40154fc552d3dc18$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$40154fc552d3dc18$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$40154fc552d3dc18$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $40154fc552d3dc18$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $40154fc552d3dc18$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $40154fc552d3dc18$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$40154fc552d3dc18$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$40154fc552d3dc18$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $40154fc552d3dc18$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $40154fc552d3dc18$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $40154fc552d3dc18$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $40154fc552d3dc18$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $40154fc552d3dc18$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($40154fc552d3dc18$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $40154fc552d3dc18$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $40154fc552d3dc18$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $40154fc552d3dc18$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $40154fc552d3dc18$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult) {
    let actionResult = pendingActionResult ? $40154fc552d3dc18$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $40154fc552d3dc18$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $40154fc552d3dc18$var$getRoutePattern(matches.map((m)=>m.route.path));
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$40154fc552d3dc18$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = $40154fc552d3dc18$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if ($40154fc552d3dc18$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $40154fc552d3dc18$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
        currentUrl.search !== nextUrl.search || $40154fc552d3dc18$var$isNewRouteInstance(state.matches[index], match);
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $40154fc552d3dc18$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $40154fc552d3dc18$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $40154fc552d3dc18$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $40154fc552d3dc18$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $40154fc552d3dc18$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $40154fc552d3dc18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $40154fc552d3dc18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
            };
            if ($40154fc552d3dc18$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $40154fc552d3dc18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $40154fc552d3dc18$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $40154fc552d3dc18$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!$40154fc552d3dc18$var$routeHasLoaderOrMiddleware(route)) return false;
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $40154fc552d3dc18$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $40154fc552d3dc18$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $40154fc552d3dc18$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $40154fc552d3dc18$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $40154fc552d3dc18$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$40154fc552d3dc18$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $40154fc552d3dc18$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $40154fc552d3dc18$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $40154fc552d3dc18$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$40154fc552d3dc18$var$isSameRoute(aChild, bChild)));
}
var $40154fc552d3dc18$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $40154fc552d3dc18$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $40154fc552d3dc18$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $40154fc552d3dc18$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $40154fc552d3dc18$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $40154fc552d3dc18$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $40154fc552d3dc18$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $40154fc552d3dc18$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $40154fc552d3dc18$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $40154fc552d3dc18$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $40154fc552d3dc18$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $40154fc552d3dc18$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $40154fc552d3dc18$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $40154fc552d3dc18$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $40154fc552d3dc18$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $40154fc552d3dc18$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $40154fc552d3dc18$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $40154fc552d3dc18$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $40154fc552d3dc18$var$isNonNullable(value) {
    return value !== void 0;
}
function $40154fc552d3dc18$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $40154fc552d3dc18$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($40154fc552d3dc18$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $40154fc552d3dc18$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $40154fc552d3dc18$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $40154fc552d3dc18$var$defaultDataStrategy(args);
    return $40154fc552d3dc18$var$runClientMiddlewarePipeline(args, ()=>$40154fc552d3dc18$var$defaultDataStrategy(args));
}
function $40154fc552d3dc18$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $40154fc552d3dc18$var$runMiddlewarePipeline(args, handler, processResult, $40154fc552d3dc18$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $40154fc552d3dc18$export$e0163cfdf7bc9cfa(result) ? $40154fc552d3dc18$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $40154fc552d3dc18$var$runClientMiddlewarePipeline(args, handler) {
    return $40154fc552d3dc18$var$runMiddlewarePipeline(args, handler, (r)=>r, // No post-processing needed on the client
    $40154fc552d3dc18$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.unstable_shouldCallHandler()), 0));
            let boundaryRouteId = $40154fc552d3dc18$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $40154fc552d3dc18$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, request: request, params: params, context: context, unstable_pattern: unstable_pattern } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $40154fc552d3dc18$var$callRouteMiddleware({
        request: request,
        params: params,
        context: context,
        unstable_pattern: unstable_pattern
    }, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $40154fc552d3dc18$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $40154fc552d3dc18$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $40154fc552d3dc18$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $40154fc552d3dc18$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $40154fc552d3dc18$var$loadLazyRoute(match.route, $40154fc552d3dc18$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $40154fc552d3dc18$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, unstable_shouldRevalidateArgs = null) {
    let isUsingNewApi = false;
    let _lazyPromises = $40154fc552d3dc18$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        unstable_shouldRevalidateArgs: unstable_shouldRevalidateArgs,
        unstable_shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!unstable_shouldRevalidateArgs) return shouldLoad;
            if (typeof defaultShouldRevalidate === "boolean") return $40154fc552d3dc18$var$shouldRevalidateLoader(match, {
                ...unstable_shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $40154fc552d3dc18$var$shouldRevalidateLoader(match, unstable_shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$40154fc552d3dc18$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($40154fc552d3dc18$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $40154fc552d3dc18$var$callLoaderOrAction({
                request: request,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $40154fc552d3dc18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            unstable_shouldRevalidateArgs: shouldRevalidateArgs,
            unstable_shouldCallHandler: ()=>false,
            _lazyPromises: $40154fc552d3dc18$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $40154fc552d3dc18$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, $40154fc552d3dc18$var$getRoutePattern(matches.map((m)=>m.route.path)), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $40154fc552d3dc18$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        unstable_pattern: $40154fc552d3dc18$var$getRoutePattern(matches.map((m)=>m.route.path)),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $40154fc552d3dc18$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $40154fc552d3dc18$var$callLoaderOrAction({ request: request, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $40154fc552d3dc18$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $40154fc552d3dc18$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $40154fc552d3dc18$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $40154fc552d3dc18$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $40154fc552d3dc18$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($40154fc552d3dc18$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $40154fc552d3dc18$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $40154fc552d3dc18$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($40154fc552d3dc18$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: new $40154fc552d3dc18$export$f2680fa305b734ca(result.init?.status || 500, void 0, result.data),
                statusCode: $40154fc552d3dc18$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $40154fc552d3dc18$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($40154fc552d3dc18$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $40154fc552d3dc18$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $40154fc552d3dc18$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$40154fc552d3dc18$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $40154fc552d3dc18$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $40154fc552d3dc18$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($40154fc552d3dc18$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $40154fc552d3dc18$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $40154fc552d3dc18$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($40154fc552d3dc18$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $40154fc552d3dc18$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $40154fc552d3dc18$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $40154fc552d3dc18$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $40154fc552d3dc18$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $40154fc552d3dc18$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $40154fc552d3dc18$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $40154fc552d3dc18$export$f5708dca728d7177(!$40154fc552d3dc18$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($40154fc552d3dc18$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $40154fc552d3dc18$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $40154fc552d3dc18$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $40154fc552d3dc18$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $40154fc552d3dc18$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $40154fc552d3dc18$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $40154fc552d3dc18$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($40154fc552d3dc18$var$isErrorResult(result)) {
            let boundaryMatch = $40154fc552d3dc18$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($40154fc552d3dc18$var$isRedirectResult(result)) $40154fc552d3dc18$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $40154fc552d3dc18$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $40154fc552d3dc18$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $40154fc552d3dc18$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $40154fc552d3dc18$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $40154fc552d3dc18$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $40154fc552d3dc18$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $40154fc552d3dc18$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $40154fc552d3dc18$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $40154fc552d3dc18$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $40154fc552d3dc18$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($40154fc552d3dc18$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $40154fc552d3dc18$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $40154fc552d3dc18$export$8ccf933b0513f8d0(path) : path;
    return $40154fc552d3dc18$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $40154fc552d3dc18$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $40154fc552d3dc18$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $40154fc552d3dc18$var$dataWithResponseInitToErrorResponse(data2) {
    return new $40154fc552d3dc18$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $40154fc552d3dc18$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $40154fc552d3dc18$var$isDataStrategyResult(value));
}
function $40154fc552d3dc18$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $40154fc552d3dc18$var$isRedirectDataStrategyResult(result) {
    return $40154fc552d3dc18$export$3f1eb41d9a6a6a27(result.result) && $40154fc552d3dc18$var$redirectStatusCodes.has(result.result.status);
}
function $40154fc552d3dc18$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $40154fc552d3dc18$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $40154fc552d3dc18$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $40154fc552d3dc18$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $40154fc552d3dc18$export$794b2760043cf8cd(statusCode) {
    return $40154fc552d3dc18$var$redirectStatusCodes.has(statusCode);
}
function $40154fc552d3dc18$export$6e80290866a84dd4(result) {
    return $40154fc552d3dc18$export$3f1eb41d9a6a6a27(result) && $40154fc552d3dc18$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $40154fc552d3dc18$var$isValidMethod(method) {
    return $40154fc552d3dc18$var$validRequestMethods.has(method.toUpperCase());
}
function $40154fc552d3dc18$export$cbae47800eb95bc3(method) {
    return $40154fc552d3dc18$var$validMutationMethods.has(method.toUpperCase());
}
function $40154fc552d3dc18$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $40154fc552d3dc18$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $40154fc552d3dc18$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $40154fc552d3dc18$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $40154fc552d3dc18$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $40154fc552d3dc18$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $40154fc552d3dc18$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $40154fc552d3dc18$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $40154fc552d3dc18$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $40154fc552d3dc18$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $40154fc552d3dc18$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $40154fc552d3dc18$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($40154fc552d3dc18$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $40154fc552d3dc18$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($40154fc552d3dc18$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $40154fc552d3dc18$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $40154fc552d3dc18$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $40154fc552d3dc18$export$2eeee58951ff3c1c = $bh6RR.createContext(null);
$40154fc552d3dc18$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $40154fc552d3dc18$export$315e3ffb01f217 = $bh6RR.createContext(null);
$40154fc552d3dc18$export$315e3ffb01f217.displayName = "DataRouterState";
var $40154fc552d3dc18$export$717f757c655223f1 = $bh6RR.createContext(false);
function $40154fc552d3dc18$var$useIsRSCRouterContext() {
    return $bh6RR.useContext($40154fc552d3dc18$export$717f757c655223f1);
}
var $40154fc552d3dc18$export$3681f408decb40d1 = $bh6RR.createContext({
    isTransitioning: false
});
$40154fc552d3dc18$export$3681f408decb40d1.displayName = "ViewTransition";
var $40154fc552d3dc18$export$cb3f1df1bef00a39 = $bh6RR.createContext(/* @__PURE__ */ new Map());
$40154fc552d3dc18$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $40154fc552d3dc18$var$AwaitContext = $bh6RR.createContext(null);
$40154fc552d3dc18$var$AwaitContext.displayName = "Await";
var $40154fc552d3dc18$export$2666c20e15407622 = (props)=>$bh6RR.createElement($40154fc552d3dc18$var$AwaitContext.Provider, props);
var $40154fc552d3dc18$export$3044ab7fdabeaee6 = $bh6RR.createContext(null);
$40154fc552d3dc18$export$3044ab7fdabeaee6.displayName = "Navigation";
var $40154fc552d3dc18$export$e6a44b110a0c44d3 = $bh6RR.createContext(null);
$40154fc552d3dc18$export$e6a44b110a0c44d3.displayName = "Location";
var $40154fc552d3dc18$export$aac280ed165a4397 = $bh6RR.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$40154fc552d3dc18$export$aac280ed165a4397.displayName = "Route";
var $40154fc552d3dc18$var$RouteErrorContext = $bh6RR.createContext(null);
$40154fc552d3dc18$var$RouteErrorContext.displayName = "RouteError";
var $40154fc552d3dc18$export$945fecf35a8ef089 = true;
function $40154fc552d3dc18$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $40154fc552d3dc18$export$f5708dca728d7177($40154fc552d3dc18$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $bh6RR.useContext($40154fc552d3dc18$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $40154fc552d3dc18$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $40154fc552d3dc18$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $40154fc552d3dc18$export$9c954a9d03d32f4a() {
    return $bh6RR.useContext($40154fc552d3dc18$export$e6a44b110a0c44d3) != null;
}
function $40154fc552d3dc18$export$45d76561a5302f2b() {
    $40154fc552d3dc18$export$f5708dca728d7177($40154fc552d3dc18$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $bh6RR.useContext($40154fc552d3dc18$export$e6a44b110a0c44d3).location;
}
function $40154fc552d3dc18$export$1b3f31771c5d07c() {
    return $bh6RR.useContext($40154fc552d3dc18$export$e6a44b110a0c44d3).navigationType;
}
function $40154fc552d3dc18$export$6c330e8992e8a295(pattern) {
    $40154fc552d3dc18$export$f5708dca728d7177($40154fc552d3dc18$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $40154fc552d3dc18$export$45d76561a5302f2b();
    return $bh6RR.useMemo(()=>$40154fc552d3dc18$export$81336c211d5ff295(pattern, $40154fc552d3dc18$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $40154fc552d3dc18$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $40154fc552d3dc18$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $bh6RR.useContext($40154fc552d3dc18$export$3044ab7fdabeaee6).static;
    if (!isStatic) $bh6RR.useLayoutEffect(cb);
}
function $40154fc552d3dc18$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $bh6RR.useContext($40154fc552d3dc18$export$aac280ed165a4397);
    return isDataRoute ? $40154fc552d3dc18$var$useNavigateStable() : $40154fc552d3dc18$var$useNavigateUnstable();
}
function $40154fc552d3dc18$var$useNavigateUnstable() {
    $40154fc552d3dc18$export$f5708dca728d7177($40154fc552d3dc18$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $bh6RR.useContext($40154fc552d3dc18$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $bh6RR.useContext($40154fc552d3dc18$export$3044ab7fdabeaee6);
    let { matches: matches } = $bh6RR.useContext($40154fc552d3dc18$export$aac280ed165a4397);
    let { pathname: locationPathname } = $40154fc552d3dc18$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($40154fc552d3dc18$var$getResolveToMatches(matches));
    let activeRef = $bh6RR.useRef(false);
    $40154fc552d3dc18$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback((to, options = {})=>{
        $40154fc552d3dc18$var$warning(activeRef.current, $40154fc552d3dc18$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $40154fc552d3dc18$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $40154fc552d3dc18$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $40154fc552d3dc18$var$OutletContext = $bh6RR.createContext(null);
function $40154fc552d3dc18$export$4138103a3ae699cc() {
    return $bh6RR.useContext($40154fc552d3dc18$var$OutletContext);
}
function $40154fc552d3dc18$export$a3be3530d8e40d0b(context) {
    let outlet = $bh6RR.useContext($40154fc552d3dc18$export$aac280ed165a4397).outlet;
    return $bh6RR.useMemo(()=>outlet && /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $40154fc552d3dc18$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $bh6RR.useContext($40154fc552d3dc18$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $40154fc552d3dc18$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $bh6RR.useContext($40154fc552d3dc18$export$aac280ed165a4397);
    let { pathname: locationPathname } = $40154fc552d3dc18$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($40154fc552d3dc18$var$getResolveToMatches(matches));
    return $bh6RR.useMemo(()=>$40154fc552d3dc18$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $40154fc552d3dc18$export$5d3fca4a98652595(routes, locationArg) {
    return $40154fc552d3dc18$var$useRoutesImpl(routes, locationArg);
}
function $40154fc552d3dc18$var$useRoutesImpl(routes, locationArg, dataRouterState, unstable_onError, future) {
    $40154fc552d3dc18$export$f5708dca728d7177($40154fc552d3dc18$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $bh6RR.useContext($40154fc552d3dc18$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $bh6RR.useContext($40154fc552d3dc18$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($40154fc552d3dc18$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $40154fc552d3dc18$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $40154fc552d3dc18$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $40154fc552d3dc18$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $40154fc552d3dc18$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $40154fc552d3dc18$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($40154fc552d3dc18$export$945fecf35a8ef089) {
        $40154fc552d3dc18$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $40154fc552d3dc18$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $40154fc552d3dc18$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $40154fc552d3dc18$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $40154fc552d3dc18$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, unstable_onError, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $40154fc552d3dc18$var$DefaultErrorComponent() {
    let error = $40154fc552d3dc18$export$ed527bf60f6e05f2();
    let message = $40154fc552d3dc18$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($40154fc552d3dc18$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, /* @__PURE__ */ $bh6RR.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $bh6RR.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $bh6RR.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $bh6RR.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, /* @__PURE__ */ $bh6RR.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $bh6RR.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $bh6RR.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $40154fc552d3dc18$var$defaultErrorElement = /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$DefaultErrorComponent, null);
var $40154fc552d3dc18$var$RenderErrorBoundary = class extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function $40154fc552d3dc18$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $bh6RR.useContext($40154fc552d3dc18$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $40154fc552d3dc18$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, unstable_onError = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $40154fc552d3dc18$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    let onError = dataRouterState && unstable_onError ? (error, errorInfo)=>{
        unstable_onError(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $40154fc552d3dc18$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $40154fc552d3dc18$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $bh6RR.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $40154fc552d3dc18$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $40154fc552d3dc18$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext($40154fc552d3dc18$export$2eeee58951ff3c1c);
    $40154fc552d3dc18$export$f5708dca728d7177(ctx, $40154fc552d3dc18$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $40154fc552d3dc18$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext($40154fc552d3dc18$export$315e3ffb01f217);
    $40154fc552d3dc18$export$f5708dca728d7177(state, $40154fc552d3dc18$var$getDataRouterConsoleError(hookName));
    return state;
}
function $40154fc552d3dc18$var$useRouteContext(hookName) {
    let route = $bh6RR.useContext($40154fc552d3dc18$export$aac280ed165a4397);
    $40154fc552d3dc18$export$f5708dca728d7177(route, $40154fc552d3dc18$var$getDataRouterConsoleError(hookName));
    return route;
}
function $40154fc552d3dc18$var$useCurrentRouteId(hookName) {
    let route = $40154fc552d3dc18$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $40154fc552d3dc18$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $40154fc552d3dc18$var$useRouteId() {
    return $40154fc552d3dc18$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $40154fc552d3dc18$export$d0fd4b7106de2769() {
    let state = $40154fc552d3dc18$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $40154fc552d3dc18$export$600dc272ed516c15() {
    let dataRouterContext = $40154fc552d3dc18$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $40154fc552d3dc18$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $bh6RR.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $bh6RR.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $40154fc552d3dc18$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $40154fc552d3dc18$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $bh6RR.useMemo(()=>matches.map((m)=>$40154fc552d3dc18$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $40154fc552d3dc18$export$1448a5050d252c4d() {
    let state = $40154fc552d3dc18$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $40154fc552d3dc18$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $40154fc552d3dc18$export$fd5d37484eab868d(routeId) {
    let state = $40154fc552d3dc18$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $40154fc552d3dc18$export$fdc00f3f26066d5e() {
    let state = $40154fc552d3dc18$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $40154fc552d3dc18$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $40154fc552d3dc18$export$ed527bf60f6e05f2() {
    let error = $bh6RR.useContext($40154fc552d3dc18$var$RouteErrorContext);
    let state = $40154fc552d3dc18$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $40154fc552d3dc18$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $40154fc552d3dc18$export$78a72ddb39bdd145() {
    let value = $bh6RR.useContext($40154fc552d3dc18$var$AwaitContext);
    return value?._data;
}
function $40154fc552d3dc18$export$17f53340677d5831() {
    let value = $bh6RR.useContext($40154fc552d3dc18$var$AwaitContext);
    return value?._error;
}
var $40154fc552d3dc18$var$blockerId = 0;
function $40154fc552d3dc18$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $40154fc552d3dc18$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $40154fc552d3dc18$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $bh6RR.useState("");
    let blockerFunction = $bh6RR.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $40154fc552d3dc18$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $40154fc552d3dc18$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $bh6RR.useEffect(()=>{
        let key = String(++$40154fc552d3dc18$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $bh6RR.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $40154fc552d3dc18$export$386d57f03f0b2883;
}
function $40154fc552d3dc18$var$useNavigateStable() {
    let { router: router } = $40154fc552d3dc18$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $40154fc552d3dc18$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $bh6RR.useRef(false);
    $40154fc552d3dc18$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(async (to, options = {})=>{
        $40154fc552d3dc18$var$warning(activeRef.current, $40154fc552d3dc18$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $40154fc552d3dc18$var$alreadyWarned = {};
function $40154fc552d3dc18$var$warningOnce(key, cond, message) {
    if (!cond && !$40154fc552d3dc18$var$alreadyWarned[key]) {
        $40154fc552d3dc18$var$alreadyWarned[key] = true;
        $40154fc552d3dc18$var$warning(false, message);
    }
}
function $40154fc552d3dc18$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $40154fc552d3dc18$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $40154fc552d3dc18$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
// lib/server-runtime/warnings.ts
var $40154fc552d3dc18$var$alreadyWarned2 = {};
function $40154fc552d3dc18$export$5b28268982f175ba(condition, message) {
    if (!condition && !$40154fc552d3dc18$var$alreadyWarned2[message]) {
        $40154fc552d3dc18$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
function $40154fc552d3dc18$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($40154fc552d3dc18$export$945fecf35a8ef089) {
            if (route.element) $40154fc552d3dc18$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $bh6RR.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($40154fc552d3dc18$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $40154fc552d3dc18$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $bh6RR.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($40154fc552d3dc18$export$945fecf35a8ef089) {
            if (route.errorElement) $40154fc552d3dc18$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $bh6RR.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $40154fc552d3dc18$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $40154fc552d3dc18$export$f30f7e456d254e83(routes, opts) {
    return $40154fc552d3dc18$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $40154fc552d3dc18$var$createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $40154fc552d3dc18$export$e2fd2c03906469db,
        mapRouteProperties: $40154fc552d3dc18$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
var $40154fc552d3dc18$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $40154fc552d3dc18$var$shallowDiff(a, b) {
    if (a === b) return false;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return true;
    for (let key of aKeys){
        if (a[key] !== b[key]) return true;
    }
    return false;
}
function $40154fc552d3dc18$export$b23aa17f1e546c5e({ router: router, flushSync: reactDomFlushSyncImpl, unstable_onError: unstable_onError }) {
    let fetcherData = $bh6RR.useRef(/* @__PURE__ */ new Map());
    let [revalidating, startRevalidation] = $bh6RR.useTransition();
    let [state, setState] = $bh6RR.useState(router.state);
    router.__setPendingRerender = (promise)=>startRevalidation(// @ts-expect-error - need react 19 types for this to be async
        async ()=>{
            const rerender = await promise;
            startRevalidation(()=>{
                rerender();
            });
        });
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            unstable_onError: unstable_onError
        }), [
        router,
        navigator,
        basename,
        unstable_onError
    ]);
    $bh6RR.useLayoutEffect(()=>{
        return router.subscribe((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
            newState.fetchers.forEach((fetcher, key)=>{
                if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
            });
            deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
            const diff = $40154fc552d3dc18$var$shallowDiff(state, newState);
            if (!diff) return;
            if (flushSync) {
                if (reactDomFlushSyncImpl) reactDomFlushSyncImpl(()=>setState(newState));
                else setState(newState);
            } else $bh6RR.startTransition(()=>{
                setState(newState);
            });
        });
    }, [
        router,
        reactDomFlushSyncImpl,
        state
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$315e3ffb01f217.Provider, {
        value: {
            ...state,
            revalidation: revalidating ? "loading" : state.revalidation
        }
    }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        unstable_onError: unstable_onError
    }))))), null);
}
function $40154fc552d3dc18$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, unstable_onError: unstable_onError }) {
    let [state, setStateImpl] = $bh6RR.useState(router.state);
    let [pendingState, setPendingState] = $bh6RR.useState();
    let [vtContext, setVtContext] = $bh6RR.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $bh6RR.useState();
    let [transition, setTransition] = $bh6RR.useState();
    let [interruption, setInterruption] = $bh6RR.useState();
    let fetcherData = $bh6RR.useRef(/* @__PURE__ */ new Map());
    let logErrorsAndSetState = $bh6RR.useCallback((newState)=>{
        setStateImpl((prevState)=>{
            if (newState.errors && unstable_onError) Object.entries(newState.errors).forEach(([routeId, error])=>{
                if (prevState.errors?.[routeId] !== error) unstable_onError(error, {
                    location: newState.location,
                    params: newState.matches[0]?.params ?? {}
                });
            });
            return newState;
        });
    }, [
        unstable_onError
    ]);
    let setState = $bh6RR.useCallback((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $40154fc552d3dc18$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $40154fc552d3dc18$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>logErrorsAndSetState(newState));
            else $bh6RR.startTransition(()=>logErrorsAndSetState(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>logErrorsAndSetState(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        logErrorsAndSetState
    ]);
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $bh6RR.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $40154fc552d3dc18$var$Deferred());
    }, [
        vtContext
    ]);
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                $bh6RR.startTransition(()=>logErrorsAndSetState(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        logErrorsAndSetState
    ]);
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $bh6RR.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            unstable_onError: unstable_onError
        }), [
        router,
        navigator,
        basename,
        unstable_onError
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        unstable_onError: unstable_onError
    })))))), null);
}
var $40154fc552d3dc18$var$MemoizedDataRoutes = $bh6RR.memo($40154fc552d3dc18$var$DataRoutes);
function $40154fc552d3dc18$var$DataRoutes({ routes: routes, future: future, state: state, unstable_onError: unstable_onError }) {
    return $40154fc552d3dc18$var$useRoutesImpl(routes, void 0, state, unstable_onError, future);
}
function $40154fc552d3dc18$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex }) {
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = $40154fc552d3dc18$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let setState = $bh6RR.useCallback((newState)=>{
        $bh6RR.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $40154fc552d3dc18$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $40154fc552d3dc18$export$f5708dca728d7177($40154fc552d3dc18$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $bh6RR.useContext($40154fc552d3dc18$export$3044ab7fdabeaee6);
    $40154fc552d3dc18$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $bh6RR.useContext($40154fc552d3dc18$export$aac280ed165a4397);
    let { pathname: locationPathname } = $40154fc552d3dc18$export$45d76561a5302f2b();
    let navigate = $40154fc552d3dc18$export$9770f232ac06a008();
    let path = $40154fc552d3dc18$var$resolveTo(to, $40154fc552d3dc18$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $bh6RR.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $40154fc552d3dc18$export$910ae8079b2c2852(props) {
    return $40154fc552d3dc18$export$a3be3530d8e40d0b(props.context);
}
function $40154fc552d3dc18$export$e7b0ac011bb776c6(props) {
    $40154fc552d3dc18$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $40154fc552d3dc18$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false }) {
    $40154fc552d3dc18$export$f5708dca728d7177(!$40154fc552d3dc18$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $bh6RR.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = $40154fc552d3dc18$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $bh6RR.useMemo(()=>{
        let trailingPathname = $40154fc552d3dc18$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $40154fc552d3dc18$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $40154fc552d3dc18$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $40154fc552d3dc18$export$5d3fca4a98652595($40154fc552d3dc18$export$16da398f5434bdec(children), location);
}
function $40154fc552d3dc18$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $bh6RR.useContext($40154fc552d3dc18$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $bh6RR.useContext($40154fc552d3dc18$export$315e3ffb01f217);
    let onError = $bh6RR.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.unstable_onError && dataRouterStateContext) dataRouterContext.unstable_onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches?.[0]?.params || {},
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$ResolveAwait, null, children));
}
var $40154fc552d3dc18$var$AwaitErrorBoundary = class extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $40154fc552d3dc18$var$ResolveAwait({ children: children }) {
    let data2 = $40154fc552d3dc18$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, toRender);
}
function $40154fc552d3dc18$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $bh6RR.Children.forEach(children, (element, index)=>{
        if (!$bh6RR.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $bh6RR.Fragment) {
            routes.push.apply(routes, $40154fc552d3dc18$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $40154fc552d3dc18$export$f5708dca728d7177(element.type === $40154fc552d3dc18$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $40154fc552d3dc18$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $40154fc552d3dc18$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $40154fc552d3dc18$export$9b5b6d122dea0c88 = $40154fc552d3dc18$export$16da398f5434bdec;
function $40154fc552d3dc18$export$daf73786167a7f72(matches) {
    return $40154fc552d3dc18$var$_renderMatches(matches);
}
function $40154fc552d3dc18$var$useRouteComponentProps() {
    return {
        params: $40154fc552d3dc18$export$99eaa27ddbbb95ef(),
        loaderData: $40154fc552d3dc18$export$1448a5050d252c4d(),
        actionData: $40154fc552d3dc18$export$fdc00f3f26066d5e(),
        matches: $40154fc552d3dc18$export$2378eb7f5ff86053()
    };
}
function $40154fc552d3dc18$export$6c4f3826290c37af({ children: children }) {
    const props = $40154fc552d3dc18$var$useRouteComponentProps();
    return $bh6RR.cloneElement(children, props);
}
function $40154fc552d3dc18$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $40154fc552d3dc18$var$useRouteComponentProps();
        return $bh6RR.createElement(Component4, props);
    };
}
function $40154fc552d3dc18$var$useHydrateFallbackProps() {
    return {
        params: $40154fc552d3dc18$export$99eaa27ddbbb95ef(),
        loaderData: $40154fc552d3dc18$export$1448a5050d252c4d(),
        actionData: $40154fc552d3dc18$export$fdc00f3f26066d5e()
    };
}
function $40154fc552d3dc18$export$f8cff34f39c1932a({ children: children }) {
    const props = $40154fc552d3dc18$var$useHydrateFallbackProps();
    return $bh6RR.cloneElement(children, props);
}
function $40154fc552d3dc18$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $40154fc552d3dc18$var$useHydrateFallbackProps();
        return $bh6RR.createElement(HydrateFallback, props);
    };
}
function $40154fc552d3dc18$var$useErrorBoundaryProps() {
    return {
        params: $40154fc552d3dc18$export$99eaa27ddbbb95ef(),
        loaderData: $40154fc552d3dc18$export$1448a5050d252c4d(),
        actionData: $40154fc552d3dc18$export$fdc00f3f26066d5e(),
        error: $40154fc552d3dc18$export$ed527bf60f6e05f2()
    };
}
function $40154fc552d3dc18$export$e5afde5c4b6d747b({ children: children }) {
    const props = $40154fc552d3dc18$var$useErrorBoundaryProps();
    return $bh6RR.cloneElement(children, props);
}
function $40154fc552d3dc18$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $40154fc552d3dc18$var$useErrorBoundaryProps();
        return $bh6RR.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $40154fc552d3dc18$var$defaultMethod = "get";
var $40154fc552d3dc18$var$defaultEncType = "application/x-www-form-urlencoded";
function $40154fc552d3dc18$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $40154fc552d3dc18$var$isButtonElement(object) {
    return $40154fc552d3dc18$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $40154fc552d3dc18$var$isFormElement(object) {
    return $40154fc552d3dc18$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $40154fc552d3dc18$var$isInputElement(object) {
    return $40154fc552d3dc18$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $40154fc552d3dc18$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $40154fc552d3dc18$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$40154fc552d3dc18$var$isModifiedEvent(event);
}
function $40154fc552d3dc18$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $40154fc552d3dc18$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $40154fc552d3dc18$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $40154fc552d3dc18$var$_formDataSupportsSubmitter = null;
function $40154fc552d3dc18$var$isFormDataSubmitterSupported() {
    if ($40154fc552d3dc18$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $40154fc552d3dc18$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $40154fc552d3dc18$var$_formDataSupportsSubmitter = true;
    }
    return $40154fc552d3dc18$var$_formDataSupportsSubmitter;
}
var $40154fc552d3dc18$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $40154fc552d3dc18$var$getFormEncType(encType) {
    if (encType != null && !$40154fc552d3dc18$var$supportedFormEncTypes.has(encType)) {
        $40154fc552d3dc18$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$40154fc552d3dc18$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $40154fc552d3dc18$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($40154fc552d3dc18$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $40154fc552d3dc18$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $40154fc552d3dc18$var$defaultMethod;
        encType = $40154fc552d3dc18$var$getFormEncType(target.getAttribute("enctype")) || $40154fc552d3dc18$var$defaultEncType;
        formData = new FormData(target);
    } else if ($40154fc552d3dc18$var$isButtonElement(target) || $40154fc552d3dc18$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $40154fc552d3dc18$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $40154fc552d3dc18$var$defaultMethod;
        encType = $40154fc552d3dc18$var$getFormEncType(target.getAttribute("formenctype")) || $40154fc552d3dc18$var$getFormEncType(form.getAttribute("enctype")) || $40154fc552d3dc18$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$40154fc552d3dc18$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($40154fc552d3dc18$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $40154fc552d3dc18$var$defaultMethod;
        action = null;
        encType = $40154fc552d3dc18$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $40154fc552d3dc18$var$HOLE = -1;
var $40154fc552d3dc18$var$NAN = -2;
var $40154fc552d3dc18$var$NEGATIVE_INFINITY = -3;
var $40154fc552d3dc18$var$NEGATIVE_ZERO = -4;
var $40154fc552d3dc18$var$NULL = -5;
var $40154fc552d3dc18$var$POSITIVE_INFINITY = -6;
var $40154fc552d3dc18$var$UNDEFINED = -7;
var $40154fc552d3dc18$var$TYPE_BIGINT = "B";
var $40154fc552d3dc18$var$TYPE_DATE = "D";
var $40154fc552d3dc18$var$TYPE_ERROR = "E";
var $40154fc552d3dc18$var$TYPE_MAP = "M";
var $40154fc552d3dc18$var$TYPE_NULL_OBJECT = "N";
var $40154fc552d3dc18$var$TYPE_PROMISE = "P";
var $40154fc552d3dc18$var$TYPE_REGEXP = "R";
var $40154fc552d3dc18$var$TYPE_SET = "S";
var $40154fc552d3dc18$var$TYPE_SYMBOL = "Y";
var $40154fc552d3dc18$var$TYPE_URL = "U";
var $40154fc552d3dc18$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $40154fc552d3dc18$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $40154fc552d3dc18$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $40154fc552d3dc18$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $40154fc552d3dc18$var$UNDEFINED;
    if (input === null) return $40154fc552d3dc18$var$NULL;
    if (Number.isNaN(input)) return $40154fc552d3dc18$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $40154fc552d3dc18$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $40154fc552d3dc18$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $40154fc552d3dc18$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $40154fc552d3dc18$var$stringify.call(this, input, index);
    return index;
}
function $40154fc552d3dc18$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$40154fc552d3dc18$var$flatten.call(this, k)}":${$40154fc552d3dc18$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$40154fc552d3dc18$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$40154fc552d3dc18$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$40154fc552d3dc18$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$40154fc552d3dc18$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $40154fc552d3dc18$var$flatten.call(this, input2[i]) : $40154fc552d3dc18$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$40154fc552d3dc18$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$40154fc552d3dc18$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$40154fc552d3dc18$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$40154fc552d3dc18$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$40154fc552d3dc18$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$40154fc552d3dc18$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$40154fc552d3dc18$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $40154fc552d3dc18$var$flatten.call(this, k),
                                    $40154fc552d3dc18$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$40154fc552d3dc18$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$40154fc552d3dc18$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$40154fc552d3dc18$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$40154fc552d3dc18$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($40154fc552d3dc18$var$isPlainObject2(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$40154fc552d3dc18$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$40154fc552d3dc18$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $40154fc552d3dc18$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $40154fc552d3dc18$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $40154fc552d3dc18$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $40154fc552d3dc18$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $40154fc552d3dc18$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $40154fc552d3dc18$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $40154fc552d3dc18$var$hydrate.call(this, startIndex);
}
function $40154fc552d3dc18$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $40154fc552d3dc18$var$UNDEFINED:
                set(void 0);
                continue;
            case $40154fc552d3dc18$var$NULL:
                set(null);
                continue;
            case $40154fc552d3dc18$var$NAN:
                set(NaN);
                continue;
            case $40154fc552d3dc18$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $40154fc552d3dc18$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $40154fc552d3dc18$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $40154fc552d3dc18$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $40154fc552d3dc18$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $40154fc552d3dc18$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $40154fc552d3dc18$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $40154fc552d3dc18$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $40154fc552d3dc18$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $40154fc552d3dc18$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $40154fc552d3dc18$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $40154fc552d3dc18$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $40154fc552d3dc18$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $40154fc552d3dc18$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $40154fc552d3dc18$var$globalObj && $40154fc552d3dc18$var$globalObj[errorType] ? new $40154fc552d3dc18$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $40154fc552d3dc18$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $40154fc552d3dc18$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $40154fc552d3dc18$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $40154fc552d3dc18$var$Deferred2();
    const reader = readable.pipeThrough($40154fc552d3dc18$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $40154fc552d3dc18$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $40154fc552d3dc18$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $40154fc552d3dc18$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $40154fc552d3dc18$var$unflatten.call(this, line)
    };
}
async function $40154fc552d3dc18$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $40154fc552d3dc18$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $40154fc552d3dc18$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $40154fc552d3dc18$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $40154fc552d3dc18$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $40154fc552d3dc18$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $40154fc552d3dc18$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $40154fc552d3dc18$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$40154fc552d3dc18$var$TYPE_PROMISE}${deferredId}:[["${$40154fc552d3dc18$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$40154fc552d3dc18$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$40154fc552d3dc18$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $40154fc552d3dc18$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$40154fc552d3dc18$var$TYPE_ERROR}${deferredId}:[["${$40154fc552d3dc18$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$40154fc552d3dc18$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$40154fc552d3dc18$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $40154fc552d3dc18$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $40154fc552d3dc18$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $40154fc552d3dc18$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $40154fc552d3dc18$export$4cf11838cdc2a8a8(html) {
    return html.replace($40154fc552d3dc18$var$ESCAPE_REGEX, (match)=>$40154fc552d3dc18$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $40154fc552d3dc18$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $40154fc552d3dc18$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $40154fc552d3dc18$var$SingleFetchNoResultError = class extends Error {
};
var $40154fc552d3dc18$export$ae9272e641ead836 = 202;
var $40154fc552d3dc18$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $40154fc552d3dc18$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $bh6RR.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$40154fc552d3dc18$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, scriptTag, /* @__PURE__ */ $bh6RR.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, scriptTag, /* @__PURE__ */ $bh6RR.createElement($bh6RR.Suspense, null, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $40154fc552d3dc18$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename) {
    let dataStrategy = $40154fc552d3dc18$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $40154fc552d3dc18$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $40154fc552d3dc18$var$fetchAndDecodeViaTurboStream, ssr, basename);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $40154fc552d3dc18$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $40154fc552d3dc18$var$singleFetchActionStrategy(args, fetchAndDecode, basename);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.unstable_shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $40154fc552d3dc18$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename);
        if (fetcherKey) return $40154fc552d3dc18$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename);
        return $40154fc552d3dc18$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut);
    };
}
async function $40154fc552d3dc18$var$singleFetchActionStrategy(args, fetchAndDecode, basename) {
    let actionMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    $40154fc552d3dc18$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $40154fc552d3dc18$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($40154fc552d3dc18$export$3f1eb41d9a6a6a27(result.result) || $40154fc552d3dc18$export$972111febbeef05b(result.result) || $40154fc552d3dc18$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $40154fc552d3dc18$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $40154fc552d3dc18$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename) {
    let matchesToLoad = args.matches.filter((m)=>m.unstable_shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, [
                        routeId
                    ]);
                    return $40154fc552d3dc18$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $40154fc552d3dc18$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$40154fc552d3dc18$var$createDeferred2());
    let singleFetchDfd = $40154fc552d3dc18$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.unstable_shouldRevalidateArgs || m.unstable_shouldRevalidateArgs.actionStatus == null || m.unstable_shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.unstable_shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.unstable_shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, [
                            routeId
                        ]);
                        return $40154fc552d3dc18$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $40154fc552d3dc18$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $40154fc552d3dc18$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $40154fc552d3dc18$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $40154fc552d3dc18$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $40154fc552d3dc18$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename) {
    let fetcherMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    $40154fc552d3dc18$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, [
                routeId
            ]);
            return $40154fc552d3dc18$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $40154fc552d3dc18$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $40154fc552d3dc18$export$7b977381851b2c(reqUrl, basename, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = `_root.${extension}`;
    else if (basename && $40154fc552d3dc18$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    return url;
}
async function $40154fc552d3dc18$var$fetchAndDecodeViaTurboStream(args, basename, targetRoutes) {
    let { request: request } = args;
    let url = $40154fc552d3dc18$export$7b977381851b2c(request.url, basename, "data");
    if (request.method === "GET") {
        url = $40154fc552d3dc18$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $40154fc552d3dc18$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $40154fc552d3dc18$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $40154fc552d3dc18$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($40154fc552d3dc18$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $40154fc552d3dc18$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $40154fc552d3dc18$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($40154fc552d3dc18$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$40154fc552d3dc18$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $40154fc552d3dc18$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $40154fc552d3dc18$export$4023ad4ecd4126a2(body, global) {
    return $40154fc552d3dc18$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $40154fc552d3dc18$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$40154fc552d3dc18$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $40154fc552d3dc18$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $40154fc552d3dc18$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $40154fc552d3dc18$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $40154fc552d3dc18$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $40154fc552d3dc18$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $40154fc552d3dc18$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $40154fc552d3dc18$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $40154fc552d3dc18$var$getModuleLinkHrefs(matches, manifest);
    return $40154fc552d3dc18$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $40154fc552d3dc18$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $40154fc552d3dc18$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $40154fc552d3dc18$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($40154fc552d3dc18$var$prefetchStyleLink));
}
async function $40154fc552d3dc18$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$40154fc552d3dc18$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$40154fc552d3dc18$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$40154fc552d3dc18$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($40154fc552d3dc18$var$prefetchStyleLink));
}
async function $40154fc552d3dc18$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $40154fc552d3dc18$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $40154fc552d3dc18$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $40154fc552d3dc18$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $40154fc552d3dc18$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $40154fc552d3dc18$var$dedupeLinkDescriptors(links.flat(1).filter($40154fc552d3dc18$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $40154fc552d3dc18$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $40154fc552d3dc18$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $40154fc552d3dc18$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $40154fc552d3dc18$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $40154fc552d3dc18$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $40154fc552d3dc18$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$40154fc552d3dc18$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($40154fc552d3dc18$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $40154fc552d3dc18$var$_isPreloadSupported;
function $40154fc552d3dc18$var$isPreloadSupported() {
    if ($40154fc552d3dc18$var$_isPreloadSupported !== void 0) return $40154fc552d3dc18$var$_isPreloadSupported;
    let el = document.createElement("link");
    $40154fc552d3dc18$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $40154fc552d3dc18$var$_isPreloadSupported;
}
function $40154fc552d3dc18$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $40154fc552d3dc18$export$945fecf35a8ef089 ? /* @__PURE__ */ $bh6RR.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $40154fc552d3dc18$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $40154fc552d3dc18$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $40154fc552d3dc18$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $40154fc552d3dc18$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$RemixRootDefaultErrorBoundary, {
            error: $40154fc552d3dc18$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $bh6RR.createElement(routeModule.Layout, null, /* @__PURE__ */ $bh6RR.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $bh6RR.createElement(routeModule.Layout, null, /* @__PURE__ */ $bh6RR.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $bh6RR.createElement(routeModule.Layout, null, /* @__PURE__ */ $bh6RR.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $40154fc552d3dc18$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $40154fc552d3dc18$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $40154fc552d3dc18$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$40154fc552d3dc18$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $40154fc552d3dc18$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $40154fc552d3dc18$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $40154fc552d3dc18$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $40154fc552d3dc18$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $40154fc552d3dc18$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $40154fc552d3dc18$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $40154fc552d3dc18$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $40154fc552d3dc18$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $40154fc552d3dc18$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $40154fc552d3dc18$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $40154fc552d3dc18$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $40154fc552d3dc18$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $40154fc552d3dc18$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$40154fc552d3dc18$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $40154fc552d3dc18$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $40154fc552d3dc18$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            async serverLoader () {
                                $40154fc552d3dc18$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $40154fc552d3dc18$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $40154fc552d3dc18$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $40154fc552d3dc18$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        async serverAction () {
                            $40154fc552d3dc18$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $40154fc552d3dc18$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $40154fc552d3dc18$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $40154fc552d3dc18$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $40154fc552d3dc18$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $40154fc552d3dc18$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $40154fc552d3dc18$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $40154fc552d3dc18$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $40154fc552d3dc18$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $40154fc552d3dc18$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $40154fc552d3dc18$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $40154fc552d3dc18$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $40154fc552d3dc18$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    if (ssr && route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function $40154fc552d3dc18$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $40154fc552d3dc18$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $40154fc552d3dc18$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $40154fc552d3dc18$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $40154fc552d3dc18$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $40154fc552d3dc18$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $40154fc552d3dc18$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $40154fc552d3dc18$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $40154fc552d3dc18$var$nextPaths = /* @__PURE__ */ new Set();
var $40154fc552d3dc18$var$discoveredPathsMaxSize = 1e3;
var $40154fc552d3dc18$var$discoveredPaths = /* @__PURE__ */ new Set();
var $40154fc552d3dc18$var$URL_LIMIT = 7680;
function $40154fc552d3dc18$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $40154fc552d3dc18$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $40154fc552d3dc18$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $40154fc552d3dc18$export$72ab377a1030deb9(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$40154fc552d3dc18$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($40154fc552d3dc18$var$discoveredPaths.has(path)) return;
        await $40154fc552d3dc18$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $40154fc552d3dc18$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $bh6RR.useEffect(()=>{
        if (!$40154fc552d3dc18$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$40154fc552d3dc18$var$discoveredPaths.has(pathname)) $40154fc552d3dc18$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($40154fc552d3dc18$var$nextPaths.keys()).filter((path)=>{
                if ($40154fc552d3dc18$var$discoveredPaths.has(path)) {
                    $40154fc552d3dc18$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $40154fc552d3dc18$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $40154fc552d3dc18$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $40154fc552d3dc18$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $40154fc552d3dc18$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $40154fc552d3dc18$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($40154fc552d3dc18$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $40154fc552d3dc18$var$URL_LIMIT) {
        $40154fc552d3dc18$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($40154fc552d3dc18$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($40154fc552d3dc18$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($40154fc552d3dc18$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$40154fc552d3dc18$var$addToFifoQueue(p, $40154fc552d3dc18$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $40154fc552d3dc18$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $40154fc552d3dc18$var$addToFifoQueue(path, queue) {
    if (queue.size >= $40154fc552d3dc18$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $40154fc552d3dc18$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $40154fc552d3dc18$var$useDataRouterContext2() {
    let context = $bh6RR.useContext($40154fc552d3dc18$export$2eeee58951ff3c1c);
    $40154fc552d3dc18$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $40154fc552d3dc18$var$useDataRouterStateContext() {
    let context = $bh6RR.useContext($40154fc552d3dc18$export$315e3ffb01f217);
    $40154fc552d3dc18$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $40154fc552d3dc18$export$208d6a3bc3aa62bd = $bh6RR.createContext(void 0);
$40154fc552d3dc18$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $40154fc552d3dc18$var$useFrameworkContext() {
    let context = $bh6RR.useContext($40154fc552d3dc18$export$208d6a3bc3aa62bd);
    $40154fc552d3dc18$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $40154fc552d3dc18$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $bh6RR.useContext($40154fc552d3dc18$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $bh6RR.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $bh6RR.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $bh6RR.useRef(null);
    $bh6RR.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $bh6RR.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $40154fc552d3dc18$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $40154fc552d3dc18$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $40154fc552d3dc18$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $40154fc552d3dc18$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $40154fc552d3dc18$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $40154fc552d3dc18$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $40154fc552d3dc18$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$40154fc552d3dc18$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $40154fc552d3dc18$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $40154fc552d3dc18$export$b2e089eb3692b073({ nonce: nonce }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $40154fc552d3dc18$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $40154fc552d3dc18$var$useDataRouterStateContext();
    let matches = $40154fc552d3dc18$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $bh6RR.useMemo(()=>$40154fc552d3dc18$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $bh6RR.createElement("style", {
        [$40154fc552d3dc18$export$7e4ed4715c00dab0]: "",
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $bh6RR.createElement("link", {
        [$40154fc552d3dc18$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce
    }) : null, keyedLinks.map(({ key: key, link: link })=>$40154fc552d3dc18$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link
        }) : /* @__PURE__ */ $bh6RR.createElement("link", {
            key: key,
            nonce: nonce,
            ...link
        })));
}
function $40154fc552d3dc18$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $40154fc552d3dc18$var$useDataRouterContext2();
    let matches = $bh6RR.useMemo(()=>$40154fc552d3dc18$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $40154fc552d3dc18$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $40154fc552d3dc18$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $bh6RR.useState([]);
    $bh6RR.useEffect(()=>{
        let interrupted = false;
        $40154fc552d3dc18$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $40154fc552d3dc18$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $40154fc552d3dc18$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $40154fc552d3dc18$var$useFrameworkContext();
    let { basename: basename } = $40154fc552d3dc18$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $40154fc552d3dc18$var$useDataRouterStateContext();
    let newMatchesForData = $bh6RR.useMemo(()=>$40154fc552d3dc18$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $bh6RR.useMemo(()=>$40154fc552d3dc18$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $bh6RR.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $40154fc552d3dc18$export$7b977381851b2c(page, basename, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $bh6RR.useMemo(()=>$40154fc552d3dc18$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $40154fc552d3dc18$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $bh6RR.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $bh6RR.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $bh6RR.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link
        })));
}
function $40154fc552d3dc18$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $40154fc552d3dc18$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $40154fc552d3dc18$var$useDataRouterStateContext();
    let location = $40154fc552d3dc18$export$45d76561a5302f2b();
    let _matches = $40154fc552d3dc18$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$40154fc552d3dc18$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $bh6RR.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $bh6RR.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $bh6RR.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $bh6RR.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $40154fc552d3dc18$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $bh6RR.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $40154fc552d3dc18$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $40154fc552d3dc18$var$isHydrated = false;
function $40154fc552d3dc18$export$3be068dde909e563() {
    $40154fc552d3dc18$var$isHydrated = true;
}
function $40154fc552d3dc18$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $40154fc552d3dc18$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $40154fc552d3dc18$var$useDataRouterContext2();
    let { matches: routerMatches } = $40154fc552d3dc18$var$useDataRouterStateContext();
    let isRSCRouterContext = $40154fc552d3dc18$var$useIsRSCRouterContext();
    let enableFogOfWar = $40154fc552d3dc18$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $40154fc552d3dc18$var$getActiveMatches(routerMatches, null, isSpaMode);
    $bh6RR.useEffect(()=>{
        $40154fc552d3dc18$export$3be068dde909e563();
    }, []);
    let initialScripts = $bh6RR.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $40154fc552d3dc18$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($40154fc552d3dc18$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, /* @__PURE__ */ $bh6RR.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $bh6RR.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $40154fc552d3dc18$var$isHydrated || isRSCRouterContext ? [] : $40154fc552d3dc18$var$dedupe(manifest.entry.imports.concat($40154fc552d3dc18$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $40154fc552d3dc18$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $40154fc552d3dc18$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $bh6RR.createElement("script", {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $bh6RR.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $bh6RR.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $bh6RR.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $40154fc552d3dc18$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $40154fc552d3dc18$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $40154fc552d3dc18$export$32e57f52df4b6e34 = class extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $40154fc552d3dc18$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $bh6RR.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($40154fc552d3dc18$export$972111febbeef05b(error)) return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $bh6RR.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $40154fc552d3dc18$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $bh6RR.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $bh6RR.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $40154fc552d3dc18$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $40154fc552d3dc18$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $bh6RR.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $bh6RR.createElement("head", null, /* @__PURE__ */ $bh6RR.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $bh6RR.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $bh6RR.createElement("title", null, title)), /* @__PURE__ */ $bh6RR.createElement("body", null, /* @__PURE__ */ $bh6RR.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$ff0bf87698939488, null) : null)));
}
var $40154fc552d3dc18$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($40154fc552d3dc18$var$isBrowser) window.__reactRouterVersion = "7.9.6";
} catch (e) {}
function $40154fc552d3dc18$export$1f3f55432a00e06d(routes, opts) {
    return $40154fc552d3dc18$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $40154fc552d3dc18$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $40154fc552d3dc18$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $40154fc552d3dc18$export$9269a41d8c4635e,
        hydrationRouteProperties: $40154fc552d3dc18$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $40154fc552d3dc18$export$1ba7ed8a3a7b3765(routes, opts) {
    return $40154fc552d3dc18$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $40154fc552d3dc18$var$createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $40154fc552d3dc18$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $40154fc552d3dc18$export$9269a41d8c4635e,
        hydrationRouteProperties: $40154fc552d3dc18$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $40154fc552d3dc18$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $40154fc552d3dc18$var$deserializeErrors(state.errors)
    };
    return state;
}
function $40154fc552d3dc18$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $40154fc552d3dc18$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $40154fc552d3dc18$export$9ba4e89fdfa1fc54({ basename: basename, children: children, window: window2 }) {
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = $40154fc552d3dc18$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let setState = $bh6RR.useCallback((newState)=>{
        $bh6RR.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $40154fc552d3dc18$export$7221d69dcfc8e36b({ basename: basename, children: children, window: window2 }) {
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = $40154fc552d3dc18$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let setState = $bh6RR.useCallback((newState)=>{
        $bh6RR.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $40154fc552d3dc18$export$de73885c9336221c({ basename: basename, children: children, history: history }) {
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let setState = $bh6RR.useCallback((newState)=>{
        $bh6RR.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$40154fc552d3dc18$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $40154fc552d3dc18$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $40154fc552d3dc18$export$a6c7ac8248d6e38a = $bh6RR.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename } = $bh6RR.useContext($40154fc552d3dc18$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $40154fc552d3dc18$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($40154fc552d3dc18$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $40154fc552d3dc18$export$b69e3301ce081aa3(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $40154fc552d3dc18$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href = $40154fc552d3dc18$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $40154fc552d3dc18$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $40154fc552d3dc18$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $bh6RR.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $40154fc552d3dc18$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, link, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$40154fc552d3dc18$export$a6c7ac8248d6e38a.displayName = "Link";
var $40154fc552d3dc18$export$b0d92dbee9b5b60d = $bh6RR.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $40154fc552d3dc18$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $40154fc552d3dc18$export$45d76561a5302f2b();
    let routerState = $bh6RR.useContext($40154fc552d3dc18$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $bh6RR.useContext($40154fc552d3dc18$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $40154fc552d3dc18$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $40154fc552d3dc18$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$40154fc552d3dc18$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $40154fc552d3dc18$export$a7fed597f4b8afd8 = $bh6RR.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $40154fc552d3dc18$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let submit = $40154fc552d3dc18$export$47c85c6e3a081d3();
    let formAction = $40154fc552d3dc18$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $40154fc552d3dc18$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace2,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /* @__PURE__ */ $bh6RR.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$40154fc552d3dc18$export$a7fed597f4b8afd8.displayName = "Form";
function $40154fc552d3dc18$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $bh6RR.useContext($40154fc552d3dc18$export$208d6a3bc3aa62bd);
    let { basename: basename } = $bh6RR.useContext($40154fc552d3dc18$export$3044ab7fdabeaee6);
    let location = $40154fc552d3dc18$export$45d76561a5302f2b();
    let matches = $40154fc552d3dc18$export$2378eb7f5ff86053();
    $40154fc552d3dc18$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $bh6RR.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $40154fc552d3dc18$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $bh6RR.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $40154fc552d3dc18$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$40154fc552d3dc18$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $40154fc552d3dc18$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $40154fc552d3dc18$var$useDataRouterContext3(hookName) {
    let ctx = $bh6RR.useContext($40154fc552d3dc18$export$2eeee58951ff3c1c);
    $40154fc552d3dc18$export$f5708dca728d7177(ctx, $40154fc552d3dc18$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $40154fc552d3dc18$var$useDataRouterState2(hookName) {
    let state = $bh6RR.useContext($40154fc552d3dc18$export$315e3ffb01f217);
    $40154fc552d3dc18$export$f5708dca728d7177(state, $40154fc552d3dc18$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $40154fc552d3dc18$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = {}) {
    let navigate = $40154fc552d3dc18$export$9770f232ac06a008();
    let location = $40154fc552d3dc18$export$45d76561a5302f2b();
    let path = $40154fc552d3dc18$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $bh6RR.useCallback((event)=>{
        if ($40154fc552d3dc18$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $40154fc552d3dc18$export$fe53371bee54353d(location) === $40154fc552d3dc18$export$fe53371bee54353d(path);
            navigate(to, {
                replace: replace2,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function $40154fc552d3dc18$export$f1a78c17382fe22a(defaultInit) {
    $40154fc552d3dc18$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $bh6RR.useRef($40154fc552d3dc18$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $bh6RR.useRef(false);
    let location = $40154fc552d3dc18$export$45d76561a5302f2b();
    let searchParams = $bh6RR.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $40154fc552d3dc18$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $40154fc552d3dc18$export$9770f232ac06a008();
    let setSearchParams = $bh6RR.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $40154fc552d3dc18$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $40154fc552d3dc18$var$fetcherId = 0;
var $40154fc552d3dc18$var$getUniqueFetcherId = ()=>`__${String(++$40154fc552d3dc18$var$fetcherId)}__`;
function $40154fc552d3dc18$export$47c85c6e3a081d3() {
    let { router: router } = $40154fc552d3dc18$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $bh6RR.useContext($40154fc552d3dc18$export$3044ab7fdabeaee6);
    let currentRouteId = $40154fc552d3dc18$var$useRouteId();
    return $bh6RR.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $40154fc552d3dc18$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $40154fc552d3dc18$var$getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function $40154fc552d3dc18$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $bh6RR.useContext($40154fc552d3dc18$export$3044ab7fdabeaee6);
    let routeContext = $bh6RR.useContext($40154fc552d3dc18$export$aac280ed165a4397);
    $40154fc552d3dc18$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$40154fc552d3dc18$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $40154fc552d3dc18$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $40154fc552d3dc18$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $40154fc552d3dc18$export$fe53371bee54353d(path);
}
function $40154fc552d3dc18$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $40154fc552d3dc18$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $40154fc552d3dc18$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $bh6RR.useContext($40154fc552d3dc18$export$cb3f1df1bef00a39);
    let route = $bh6RR.useContext($40154fc552d3dc18$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $40154fc552d3dc18$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $40154fc552d3dc18$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $40154fc552d3dc18$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $bh6RR.useId();
    let [fetcherKey, setFetcherKey] = $bh6RR.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    $bh6RR.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = $bh6RR.useCallback(async (href, opts)=>{
        $40154fc552d3dc18$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $40154fc552d3dc18$export$47c85c6e3a081d3();
    let submit = $bh6RR.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let unstable_reset = $bh6RR.useCallback((opts)=>router.resetFetcher(fetcherKey, opts), [
        router,
        fetcherKey
    ]);
    let FetcherForm = $bh6RR.useMemo(()=>{
        let FetcherForm2 = $bh6RR.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $40154fc552d3dc18$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $bh6RR.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            unstable_reset: unstable_reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        unstable_reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $40154fc552d3dc18$export$fa996778a3a31087() {
    let state = $40154fc552d3dc18$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $40154fc552d3dc18$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $40154fc552d3dc18$var$savedScrollPositions = {};
function $40154fc552d3dc18$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $40154fc552d3dc18$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $40154fc552d3dc18$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $40154fc552d3dc18$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $40154fc552d3dc18$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $bh6RR.useContext($40154fc552d3dc18$export$3044ab7fdabeaee6);
    let location = $40154fc552d3dc18$export$45d76561a5302f2b();
    let matches = $40154fc552d3dc18$export$2378eb7f5ff86053();
    let navigation = $40154fc552d3dc18$export$d0fd4b7106de2769();
    $bh6RR.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $40154fc552d3dc18$var$usePageHide($bh6RR.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $40154fc552d3dc18$var$getScrollRestorationKey(location, matches, basename, getKey);
            $40154fc552d3dc18$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $40154fc552d3dc18$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($40154fc552d3dc18$var$savedScrollPositions));
        } catch (error) {
            $40154fc552d3dc18$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $bh6RR.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $40154fc552d3dc18$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $40154fc552d3dc18$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $bh6RR.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($40154fc552d3dc18$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$40154fc552d3dc18$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $bh6RR.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $40154fc552d3dc18$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $40154fc552d3dc18$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $40154fc552d3dc18$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $40154fc552d3dc18$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $40154fc552d3dc18$export$b273b3273281a049(when);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $40154fc552d3dc18$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $bh6RR.useContext($40154fc552d3dc18$export$3681f408decb40d1);
    $40154fc552d3dc18$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $40154fc552d3dc18$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $40154fc552d3dc18$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $40154fc552d3dc18$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $40154fc552d3dc18$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $40154fc552d3dc18$export$81336c211d5ff295(path.pathname, nextPath) != null || $40154fc552d3dc18$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $40154fc552d3dc18$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $40154fc552d3dc18$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $40154fc552d3dc18$var$getStatelessNavigator();
    return /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function $40154fc552d3dc18$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $40154fc552d3dc18$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $40154fc552d3dc18$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $40154fc552d3dc18$var$serializeErrors(context.errors)
        };
        let json = $40154fc552d3dc18$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ $bh6RR.createElement($40154fc552d3dc18$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $bh6RR.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $40154fc552d3dc18$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $40154fc552d3dc18$var$useRoutesImpl(routes, void 0, state, void 0, future);
}
function $40154fc552d3dc18$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($40154fc552d3dc18$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $40154fc552d3dc18$var$getStatelessNavigator() {
    return {
        createHref: $40154fc552d3dc18$var$createHref,
        encodeLocation: $40154fc552d3dc18$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $40154fc552d3dc18$export$69163f0b72ec60d9(routes, opts) {
    return $40154fc552d3dc18$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $40154fc552d3dc18$export$9269a41d8c4635e
    });
}
function $40154fc552d3dc18$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $40154fc552d3dc18$export$87cb1a9238dc3fba(routes, $40154fc552d3dc18$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $40154fc552d3dc18$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $40154fc552d3dc18$var$createHref,
        encodeLocation: $40154fc552d3dc18$var$encodeLocation,
        getFetcher () {
            return $40154fc552d3dc18$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $40154fc552d3dc18$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $40154fc552d3dc18$var$createHref(to) {
    return typeof to === "string" ? to : $40154fc552d3dc18$export$fe53371bee54353d(to);
}
function $40154fc552d3dc18$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $40154fc552d3dc18$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $40154fc552d3dc18$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $40154fc552d3dc18$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $40154fc552d3dc18$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $40154fc552d3dc18$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $40154fc552d3dc18$var$htmlEscape(str) {
    return str.replace($40154fc552d3dc18$var$ESCAPE_REGEX2, (match)=>$40154fc552d3dc18$var$ESCAPE_LOOKUP2[match]);
}

});

parcelRegister("4YIes", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39ff139754f0f361$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $blGXB = parcelRequire("blGXB");

var $OEXBZ = parcelRequire("OEXBZ");

var $ih19M = parcelRequire("ih19M");
'use client';
const $39ff139754f0f361$var$isDynamicSupport = typeof (0, $blGXB.globalCss)({}) === 'function';
const $39ff139754f0f361$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%',
        // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
        ...enableColorScheme && !theme.vars && {
            colorScheme: theme.palette.mode
        }
    });
const $39ff139754f0f361$export$32180ef41b15b513 = (theme)=>({
        color: (theme.vars || theme).palette.text.primary,
        ...theme.typography.body1,
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $39ff139754f0f361$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes && typeof theme.getColorSchemeSelector === 'function') Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        colorSchemeStyles[selector] = {
            ':root': {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        colorSchemeStyles[selector.replace(/\s*&/, '')] = {
            colorScheme: scheme.palette?.mode
        };
    });
    let defaultStyles = {
        html: $39ff139754f0f361$export$c0bb0b647f701bb5(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: {
            margin: 0,
            // Remove the margin in all browsers.
            ...$39ff139754f0f361$export$32180ef41b15b513(theme),
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        },
        ...colorSchemeStyles
    };
    const themeOverrides = theme.components?.MuiCssBaseline?.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
// `ecs` stands for enableColorScheme. This is internal logic to make it work with Pigment CSS, so shorter is better.
const $39ff139754f0f361$var$SELECTOR = 'mui-ecs';
const $39ff139754f0f361$var$staticStyles = (theme)=>{
    const result = $39ff139754f0f361$export$9dd6ff9ea0189349(theme, false);
    const baseStyles = Array.isArray(result) ? result[0] : result;
    if (!theme.vars && baseStyles) baseStyles.html[`:root:has(${$39ff139754f0f361$var$SELECTOR})`] = {
        colorScheme: theme.palette.mode
    };
    if (theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        baseStyles[selector] = {
            [`:root:not(:has(.${$39ff139754f0f361$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        baseStyles[selector.replace(/\s*&/, '')] = {
            [`&:not(:has(.${$39ff139754f0f361$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
    });
    return result;
};
const $39ff139754f0f361$var$GlobalStyles = (0, $blGXB.globalCss)($39ff139754f0f361$var$isDynamicSupport ? ({ theme: theme, enableColorScheme: enableColorScheme })=>$39ff139754f0f361$export$9dd6ff9ea0189349(theme, enableColorScheme) : ({ theme: theme })=>$39ff139754f0f361$var$staticStyles(theme));
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $39ff139754f0f361$var$CssBaseline(inProps) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            $39ff139754f0f361$var$isDynamicSupport && /*#__PURE__*/ (0, $ih19M.jsx)($39ff139754f0f361$var$GlobalStyles, {
                enableColorScheme: enableColorScheme
            }),
            !$39ff139754f0f361$var$isDynamicSupport && !enableColorScheme && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: $39ff139754f0f361$var$SELECTOR,
                style: {
                    display: 'none'
                }
            }),
            children
        ]
    });
}
var $39ff139754f0f361$export$2e2bcd8739ae039 = $39ff139754f0f361$var$CssBaseline;

});
parcelRegister("blGXB", function(module, exports) {

$parcel$export(module.exports, "globalCss", function () { return $8432fae1f2edd876$export$db53682eef82cc11; });
$parcel$export(module.exports, "internal_createExtendSxProp", function () { return $8432fae1f2edd876$export$7e7f5719ff4debb1; });

var $gIHYf = parcelRequire("gIHYf");

var $aOb5j = parcelRequire("aOb5j");

var $lVG0j = parcelRequire("lVG0j");

var $ih19M = parcelRequire("ih19M");

var $fPZvG = parcelRequire("fPZvG");

var $l0oRz = parcelRequire("l0oRz");
function $8432fae1f2edd876$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $ih19M.jsx)((0, $lVG0j.default), {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $8432fae1f2edd876$export$7e7f5719ff4debb1() {
    return 0, $gIHYf.default;
}

});
parcelRegister("gIHYf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2c2dd16a68b0773$export$2e2bcd8739ae039; });

var $5syur = parcelRequire("5syur");

var $8RAwN = parcelRequire("8RAwN");
const $c2c2dd16a68b0773$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $8RAwN.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $c2c2dd16a68b0773$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $c2c2dd16a68b0773$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $5syur.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});
parcelRegister("5syur", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $3f9a524a63e48d58$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $3f9a524a63e48d58$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $lhF4u = parcelRequire("lhF4u");
function $3f9a524a63e48d58$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $3f9a524a63e48d58$var$deepClone(source) {
    if (/*#__PURE__*/ $bh6RR.isValidElement(source) || (0, $lhF4u.isValidElementType)(source) || !$3f9a524a63e48d58$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $3f9a524a63e48d58$var$deepClone(source[key]);
    });
    return output;
}
function $3f9a524a63e48d58$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($3f9a524a63e48d58$export$53b83ca8eaab0383(target) && $3f9a524a63e48d58$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $bh6RR.isValidElement(source[key]) || (0, $lhF4u.isValidElementType)(source[key])) output[key] = source[key];
        else if ($3f9a524a63e48d58$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $3f9a524a63e48d58$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $3f9a524a63e48d58$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $3f9a524a63e48d58$export$53b83ca8eaab0383(source[key]) ? $3f9a524a63e48d58$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("lhF4u", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2OWAO"));

});
parcelRegister("2OWAO", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $20ddb394d2922a88$export$a7c73072b1a182ae; }, function (v) { return $20ddb394d2922a88$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $20ddb394d2922a88$export$9f27bc3417b4524d; }, function (v) { return $20ddb394d2922a88$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $20ddb394d2922a88$export$db77ccec0bb4ccac; }, function (v) { return $20ddb394d2922a88$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $20ddb394d2922a88$export$8392c0c9d3dcbd35; }, function (v) { return $20ddb394d2922a88$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $20ddb394d2922a88$export$ffb0004e005737fa; }, function (v) { return $20ddb394d2922a88$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $20ddb394d2922a88$export$b624eff549462981; }, function (v) { return $20ddb394d2922a88$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $20ddb394d2922a88$export$7897aa7841a5380c; }, function (v) { return $20ddb394d2922a88$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $20ddb394d2922a88$export$602eac185826482c; }, function (v) { return $20ddb394d2922a88$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $20ddb394d2922a88$export$e2c29f18771995cb; }, function (v) { return $20ddb394d2922a88$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $20ddb394d2922a88$export$5f8d39834fd61797; }, function (v) { return $20ddb394d2922a88$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $20ddb394d2922a88$export$74bf444e3cd11ea5; }, function (v) { return $20ddb394d2922a88$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $20ddb394d2922a88$export$998bcd577473dd93; }, function (v) { return $20ddb394d2922a88$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $20ddb394d2922a88$export$b706b080d889d2c9; }, function (v) { return $20ddb394d2922a88$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $20ddb394d2922a88$export$5be5a87408f70ddc; }, function (v) { return $20ddb394d2922a88$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $20ddb394d2922a88$export$45a5e7f76e0caa8d; }, function (v) { return $20ddb394d2922a88$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $20ddb394d2922a88$export$455c2e768291efa6; }, function (v) { return $20ddb394d2922a88$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $20ddb394d2922a88$export$9522e17588c12572; }, function (v) { return $20ddb394d2922a88$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $20ddb394d2922a88$export$2110ac352bb060b9; }, function (v) { return $20ddb394d2922a88$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $20ddb394d2922a88$export$56885ab8b9c456ab; }, function (v) { return $20ddb394d2922a88$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $20ddb394d2922a88$export$d927fcb6adf8f9de; }, function (v) { return $20ddb394d2922a88$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $20ddb394d2922a88$export$b82d16f27459e05a; }, function (v) { return $20ddb394d2922a88$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $20ddb394d2922a88$export$522c17b4f5e123e8; }, function (v) { return $20ddb394d2922a88$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $20ddb394d2922a88$export$1aabd8a0274ecfd6; }, function (v) { return $20ddb394d2922a88$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $20ddb394d2922a88$export$3d6c20d97e46b957; }, function (v) { return $20ddb394d2922a88$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $20ddb394d2922a88$export$9b621391a187a31a; }, function (v) { return $20ddb394d2922a88$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $20ddb394d2922a88$export$f5bbd400c2f4426f; }, function (v) { return $20ddb394d2922a88$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $20ddb394d2922a88$export$a7c73072b1a182ae;
var $20ddb394d2922a88$export$9f27bc3417b4524d;
var $20ddb394d2922a88$export$db77ccec0bb4ccac;
var $20ddb394d2922a88$export$8392c0c9d3dcbd35;
var $20ddb394d2922a88$export$ffb0004e005737fa;
var $20ddb394d2922a88$export$b624eff549462981;
var $20ddb394d2922a88$export$7897aa7841a5380c;
var $20ddb394d2922a88$export$602eac185826482c;
var $20ddb394d2922a88$export$e2c29f18771995cb;
var $20ddb394d2922a88$export$5f8d39834fd61797;
var $20ddb394d2922a88$export$74bf444e3cd11ea5;
var $20ddb394d2922a88$export$998bcd577473dd93;
var $20ddb394d2922a88$export$b706b080d889d2c9;
var $20ddb394d2922a88$export$5be5a87408f70ddc;
var $20ddb394d2922a88$export$45a5e7f76e0caa8d;
var $20ddb394d2922a88$export$455c2e768291efa6;
var $20ddb394d2922a88$export$9522e17588c12572;
var $20ddb394d2922a88$export$2110ac352bb060b9;
var $20ddb394d2922a88$export$56885ab8b9c456ab;
var $20ddb394d2922a88$export$d927fcb6adf8f9de;
var $20ddb394d2922a88$export$b82d16f27459e05a;
var $20ddb394d2922a88$export$522c17b4f5e123e8;
var $20ddb394d2922a88$export$1aabd8a0274ecfd6;
var $20ddb394d2922a88$export$3d6c20d97e46b957;
var $20ddb394d2922a88$export$9b621391a187a31a;
var $20ddb394d2922a88$export$f5bbd400c2f4426f;
"use strict";
var $20ddb394d2922a88$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $20ddb394d2922a88$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $20ddb394d2922a88$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $20ddb394d2922a88$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $20ddb394d2922a88$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $20ddb394d2922a88$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $20ddb394d2922a88$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $20ddb394d2922a88$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $20ddb394d2922a88$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $20ddb394d2922a88$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $20ddb394d2922a88$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $20ddb394d2922a88$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $20ddb394d2922a88$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $20ddb394d2922a88$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $20ddb394d2922a88$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $20ddb394d2922a88$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $20ddb394d2922a88$var$REACT_FRAGMENT_TYPE:
                    case $20ddb394d2922a88$var$REACT_PROFILER_TYPE:
                    case $20ddb394d2922a88$var$REACT_STRICT_MODE_TYPE:
                    case $20ddb394d2922a88$var$REACT_SUSPENSE_TYPE:
                    case $20ddb394d2922a88$var$REACT_SUSPENSE_LIST_TYPE:
                    case $20ddb394d2922a88$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $20ddb394d2922a88$var$REACT_CONTEXT_TYPE:
                            case $20ddb394d2922a88$var$REACT_FORWARD_REF_TYPE:
                            case $20ddb394d2922a88$var$REACT_LAZY_TYPE:
                            case $20ddb394d2922a88$var$REACT_MEMO_TYPE:
                                return object;
                            case $20ddb394d2922a88$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $20ddb394d2922a88$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$20ddb394d2922a88$export$a7c73072b1a182ae = $20ddb394d2922a88$var$REACT_CONSUMER_TYPE;
$20ddb394d2922a88$export$9f27bc3417b4524d = $20ddb394d2922a88$var$REACT_CONTEXT_TYPE;
$20ddb394d2922a88$export$db77ccec0bb4ccac = $20ddb394d2922a88$var$REACT_ELEMENT_TYPE;
$20ddb394d2922a88$export$8392c0c9d3dcbd35 = $20ddb394d2922a88$var$REACT_FORWARD_REF_TYPE;
$20ddb394d2922a88$export$ffb0004e005737fa = $20ddb394d2922a88$var$REACT_FRAGMENT_TYPE;
$20ddb394d2922a88$export$b624eff549462981 = $20ddb394d2922a88$var$REACT_LAZY_TYPE;
$20ddb394d2922a88$export$7897aa7841a5380c = $20ddb394d2922a88$var$REACT_MEMO_TYPE;
$20ddb394d2922a88$export$602eac185826482c = $20ddb394d2922a88$var$REACT_PORTAL_TYPE;
$20ddb394d2922a88$export$e2c29f18771995cb = $20ddb394d2922a88$var$REACT_PROFILER_TYPE;
$20ddb394d2922a88$export$5f8d39834fd61797 = $20ddb394d2922a88$var$REACT_STRICT_MODE_TYPE;
$20ddb394d2922a88$export$74bf444e3cd11ea5 = $20ddb394d2922a88$var$REACT_SUSPENSE_TYPE;
$20ddb394d2922a88$export$998bcd577473dd93 = $20ddb394d2922a88$var$REACT_SUSPENSE_LIST_TYPE;
$20ddb394d2922a88$export$b706b080d889d2c9 = function(object) {
    return $20ddb394d2922a88$var$typeOf(object) === $20ddb394d2922a88$var$REACT_CONSUMER_TYPE;
};
$20ddb394d2922a88$export$5be5a87408f70ddc = function(object) {
    return $20ddb394d2922a88$var$typeOf(object) === $20ddb394d2922a88$var$REACT_CONTEXT_TYPE;
};
$20ddb394d2922a88$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $20ddb394d2922a88$var$REACT_ELEMENT_TYPE;
};
$20ddb394d2922a88$export$455c2e768291efa6 = function(object) {
    return $20ddb394d2922a88$var$typeOf(object) === $20ddb394d2922a88$var$REACT_FORWARD_REF_TYPE;
};
$20ddb394d2922a88$export$9522e17588c12572 = function(object) {
    return $20ddb394d2922a88$var$typeOf(object) === $20ddb394d2922a88$var$REACT_FRAGMENT_TYPE;
};
$20ddb394d2922a88$export$2110ac352bb060b9 = function(object) {
    return $20ddb394d2922a88$var$typeOf(object) === $20ddb394d2922a88$var$REACT_LAZY_TYPE;
};
$20ddb394d2922a88$export$56885ab8b9c456ab = function(object) {
    return $20ddb394d2922a88$var$typeOf(object) === $20ddb394d2922a88$var$REACT_MEMO_TYPE;
};
$20ddb394d2922a88$export$d927fcb6adf8f9de = function(object) {
    return $20ddb394d2922a88$var$typeOf(object) === $20ddb394d2922a88$var$REACT_PORTAL_TYPE;
};
$20ddb394d2922a88$export$b82d16f27459e05a = function(object) {
    return $20ddb394d2922a88$var$typeOf(object) === $20ddb394d2922a88$var$REACT_PROFILER_TYPE;
};
$20ddb394d2922a88$export$522c17b4f5e123e8 = function(object) {
    return $20ddb394d2922a88$var$typeOf(object) === $20ddb394d2922a88$var$REACT_STRICT_MODE_TYPE;
};
$20ddb394d2922a88$export$1aabd8a0274ecfd6 = function(object) {
    return $20ddb394d2922a88$var$typeOf(object) === $20ddb394d2922a88$var$REACT_SUSPENSE_TYPE;
};
$20ddb394d2922a88$export$3d6c20d97e46b957 = function(object) {
    return $20ddb394d2922a88$var$typeOf(object) === $20ddb394d2922a88$var$REACT_SUSPENSE_LIST_TYPE;
};
$20ddb394d2922a88$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $20ddb394d2922a88$var$REACT_FRAGMENT_TYPE || type === $20ddb394d2922a88$var$REACT_PROFILER_TYPE || type === $20ddb394d2922a88$var$REACT_STRICT_MODE_TYPE || type === $20ddb394d2922a88$var$REACT_SUSPENSE_TYPE || type === $20ddb394d2922a88$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $20ddb394d2922a88$var$REACT_LAZY_TYPE || type.$$typeof === $20ddb394d2922a88$var$REACT_MEMO_TYPE || type.$$typeof === $20ddb394d2922a88$var$REACT_CONTEXT_TYPE || type.$$typeof === $20ddb394d2922a88$var$REACT_CONSUMER_TYPE || type.$$typeof === $20ddb394d2922a88$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $20ddb394d2922a88$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$20ddb394d2922a88$export$f5bbd400c2f4426f = $20ddb394d2922a88$var$typeOf;

});



parcelRegister("8RAwN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $673f9bacc92f414a$export$2e2bcd8739ae039; });

var $l0eT8 = parcelRequire("l0eT8");

var $gBlNg = parcelRequire("gBlNg");

var $cdIgX = parcelRequire("cdIgX");

var $g1uKl = parcelRequire("g1uKl");

var $jW9RL = parcelRequire("jW9RL");
const $673f9bacc92f414a$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $gBlNg.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $gBlNg.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $gBlNg.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $gBlNg.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $gBlNg.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $gBlNg.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $gBlNg.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $g1uKl.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $g1uKl.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $g1uKl.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $l0eT8.padding)
    },
    pt: {
        style: (0, $l0eT8.padding)
    },
    pr: {
        style: (0, $l0eT8.padding)
    },
    pb: {
        style: (0, $l0eT8.padding)
    },
    pl: {
        style: (0, $l0eT8.padding)
    },
    px: {
        style: (0, $l0eT8.padding)
    },
    py: {
        style: (0, $l0eT8.padding)
    },
    padding: {
        style: (0, $l0eT8.padding)
    },
    paddingTop: {
        style: (0, $l0eT8.padding)
    },
    paddingRight: {
        style: (0, $l0eT8.padding)
    },
    paddingBottom: {
        style: (0, $l0eT8.padding)
    },
    paddingLeft: {
        style: (0, $l0eT8.padding)
    },
    paddingX: {
        style: (0, $l0eT8.padding)
    },
    paddingY: {
        style: (0, $l0eT8.padding)
    },
    paddingInline: {
        style: (0, $l0eT8.padding)
    },
    paddingInlineStart: {
        style: (0, $l0eT8.padding)
    },
    paddingInlineEnd: {
        style: (0, $l0eT8.padding)
    },
    paddingBlock: {
        style: (0, $l0eT8.padding)
    },
    paddingBlockStart: {
        style: (0, $l0eT8.padding)
    },
    paddingBlockEnd: {
        style: (0, $l0eT8.padding)
    },
    m: {
        style: (0, $l0eT8.margin)
    },
    mt: {
        style: (0, $l0eT8.margin)
    },
    mr: {
        style: (0, $l0eT8.margin)
    },
    mb: {
        style: (0, $l0eT8.margin)
    },
    ml: {
        style: (0, $l0eT8.margin)
    },
    mx: {
        style: (0, $l0eT8.margin)
    },
    my: {
        style: (0, $l0eT8.margin)
    },
    margin: {
        style: (0, $l0eT8.margin)
    },
    marginTop: {
        style: (0, $l0eT8.margin)
    },
    marginRight: {
        style: (0, $l0eT8.margin)
    },
    marginBottom: {
        style: (0, $l0eT8.margin)
    },
    marginLeft: {
        style: (0, $l0eT8.margin)
    },
    marginX: {
        style: (0, $l0eT8.margin)
    },
    marginY: {
        style: (0, $l0eT8.margin)
    },
    marginInline: {
        style: (0, $l0eT8.margin)
    },
    marginInlineStart: {
        style: (0, $l0eT8.margin)
    },
    marginInlineEnd: {
        style: (0, $l0eT8.margin)
    },
    marginBlock: {
        style: (0, $l0eT8.margin)
    },
    marginBlockStart: {
        style: (0, $l0eT8.margin)
    },
    marginBlockEnd: {
        style: (0, $l0eT8.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $cdIgX.gap)
    },
    rowGap: {
        style: (0, $cdIgX.rowGap)
    },
    columnGap: {
        style: (0, $cdIgX.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $jW9RL.sizingTransform)
    },
    maxWidth: {
        style: (0, $jW9RL.maxWidth)
    },
    minWidth: {
        transform: (0, $jW9RL.sizingTransform)
    },
    height: {
        transform: (0, $jW9RL.sizingTransform)
    },
    maxHeight: {
        transform: (0, $jW9RL.sizingTransform)
    },
    minHeight: {
        transform: (0, $jW9RL.sizingTransform)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $673f9bacc92f414a$export$2e2bcd8739ae039 = $673f9bacc92f414a$var$defaultSxConfig;

});
parcelRegister("l0eT8", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $f4a525941e77cc75$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $f4a525941e77cc75$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $f4a525941e77cc75$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $f4a525941e77cc75$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $f4a525941e77cc75$export$6f98e8eaf0be1996; });


var $grZ4X = parcelRequire("grZ4X");

var $gzdlJ = parcelRequire("gzdlJ");

var $dbefT = parcelRequire("dbefT");

var $k2SzR = parcelRequire("k2SzR");
const $f4a525941e77cc75$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $f4a525941e77cc75$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $f4a525941e77cc75$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $f4a525941e77cc75$var$getCssProperties = (0, $k2SzR.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($f4a525941e77cc75$var$aliases[prop]) prop = $f4a525941e77cc75$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $f4a525941e77cc75$var$properties[a];
    const direction = $f4a525941e77cc75$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $f4a525941e77cc75$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $f4a525941e77cc75$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $f4a525941e77cc75$var$spacingKeys = [
    ...$f4a525941e77cc75$export$aab52a0dde05ad8a,
    ...$f4a525941e77cc75$export$f8397d44f03ab6ad
];
function $f4a525941e77cc75$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $gzdlJ.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $f4a525941e77cc75$export$1def6f833384e3d1(theme) {
    return $f4a525941e77cc75$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $f4a525941e77cc75$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $f4a525941e77cc75$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $f4a525941e77cc75$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $f4a525941e77cc75$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $f4a525941e77cc75$var$getCssProperties(prop);
    const styleFromPropValue = $f4a525941e77cc75$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $grZ4X.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $f4a525941e77cc75$var$style(props, keys) {
    const transformer = $f4a525941e77cc75$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$f4a525941e77cc75$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $dbefT.default), {});
}
function $f4a525941e77cc75$export$7ede87f9b603dd3c(props) {
    return $f4a525941e77cc75$var$style(props, $f4a525941e77cc75$export$aab52a0dde05ad8a);
}
$f4a525941e77cc75$export$7ede87f9b603dd3c.propTypes = {};
$f4a525941e77cc75$export$7ede87f9b603dd3c.filterProps = $f4a525941e77cc75$export$aab52a0dde05ad8a;
function $f4a525941e77cc75$export$6f98e8eaf0be1996(props) {
    return $f4a525941e77cc75$var$style(props, $f4a525941e77cc75$export$f8397d44f03ab6ad);
}
$f4a525941e77cc75$export$6f98e8eaf0be1996.propTypes = {};
$f4a525941e77cc75$export$6f98e8eaf0be1996.filterProps = $f4a525941e77cc75$export$f8397d44f03ab6ad;
function $f4a525941e77cc75$var$spacing(props) {
    return $f4a525941e77cc75$var$style(props, $f4a525941e77cc75$var$spacingKeys);
}
$f4a525941e77cc75$var$spacing.propTypes = {};
$f4a525941e77cc75$var$spacing.filterProps = $f4a525941e77cc75$var$spacingKeys;
var $f4a525941e77cc75$export$2e2bcd8739ae039 = $f4a525941e77cc75$var$spacing;

});
parcelRegister("grZ4X", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $bf9e8bf87379f8b1$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $bf9e8bf87379f8b1$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $bf9e8bf87379f8b1$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $bf9e8bf87379f8b1$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $bf9e8bf87379f8b1$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $bf9e8bf87379f8b1$export$980e6a259d807490; });


var $5syur = parcelRequire("5syur");

var $dbefT = parcelRequire("dbefT");

var $fWjZ8 = parcelRequire("fWjZ8");
const $bf9e8bf87379f8b1$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $bf9e8bf87379f8b1$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$bf9e8bf87379f8b1$export$68c286be0e7e55b7[key]}px)`
};
const $bf9e8bf87379f8b1$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $bf9e8bf87379f8b1$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $bf9e8bf87379f8b1$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $bf9e8bf87379f8b1$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $bf9e8bf87379f8b1$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $fWjZ8.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $fWjZ8.getContainerQuery)(theme.containerQueries ? theme : $bf9e8bf87379f8b1$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $bf9e8bf87379f8b1$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $bf9e8bf87379f8b1$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $bf9e8bf87379f8b1$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $dbefT.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $bf9e8bf87379f8b1$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $bf9e8bf87379f8b1$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $bf9e8bf87379f8b1$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $bf9e8bf87379f8b1$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $5syur.default)(prev, next), {});
    return $bf9e8bf87379f8b1$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $bf9e8bf87379f8b1$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $bf9e8bf87379f8b1$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $bf9e8bf87379f8b1$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $bf9e8bf87379f8b1$export$2e2bcd8739ae039 = $bf9e8bf87379f8b1$var$breakpoints;

});
parcelRegister("dbefT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99875c47530b8091$export$2e2bcd8739ae039; });

var $5syur = parcelRequire("5syur");
function $99875c47530b8091$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $5syur.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $99875c47530b8091$export$2e2bcd8739ae039 = $99875c47530b8091$var$merge;

});

parcelRegister("fWjZ8", function(module, exports) {

$parcel$export(module.exports, "sortContainerQueries", function () { return $b9abc6675e248d39$export$456f6c1142f990db; });
$parcel$export(module.exports, "isCqShorthand", function () { return $b9abc6675e248d39$export$77c7c3e357f440e7; });
$parcel$export(module.exports, "getContainerQuery", function () { return $b9abc6675e248d39$export$10a9745dfa00d15; });
$parcel$export(module.exports, "default", function () { return $b9abc6675e248d39$export$2e2bcd8739ae039; });

function $b9abc6675e248d39$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $b9abc6675e248d39$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $b9abc6675e248d39$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $b9abc6675e248d39$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});


parcelRegister("gzdlJ", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $c0fa452d73351d90$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $c0fa452d73351d90$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $c0fa452d73351d90$export$2e2bcd8739ae039; });

var $5pCmM = parcelRequire("5pCmM");


var $grZ4X = parcelRequire("grZ4X");
function $c0fa452d73351d90$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $c0fa452d73351d90$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $c0fa452d73351d90$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $c0fa452d73351d90$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $c0fa452d73351d90$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $c0fa452d73351d90$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $c0fa452d73351d90$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $5pCmM.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $grZ4X.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $c0fa452d73351d90$export$2e2bcd8739ae039 = $c0fa452d73351d90$var$style;

});
parcelRegister("5pCmM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f0d0c569d2896e9$export$2e2bcd8739ae039; });

var $avV9A = parcelRequire("avV9A");
function $3f0d0c569d2896e9$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $avV9A.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("avV9A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a79222bf14c8db7$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $7a79222bf14c8db7$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});



parcelRegister("k2SzR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e97e547a7356569d$export$2e2bcd8739ae039; });
function $e97e547a7356569d$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("gBlNg", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $c16101ceb658b9dd$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $c16101ceb658b9dd$export$7a57f79000377ca2; });


var $gzdlJ = parcelRequire("gzdlJ");

var $5R2Dw = parcelRequire("5R2Dw");

var $l0eT8 = parcelRequire("l0eT8");

var $grZ4X = parcelRequire("grZ4X");
function $c16101ceb658b9dd$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $c16101ceb658b9dd$var$createBorderStyle(prop, transform) {
    return (0, $gzdlJ.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $c16101ceb658b9dd$export$1edee58a52776cd9 = $c16101ceb658b9dd$var$createBorderStyle('border', $c16101ceb658b9dd$export$34e2febe53ae29cc);
const $c16101ceb658b9dd$export$f9a7b6bd24892946 = $c16101ceb658b9dd$var$createBorderStyle('borderTop', $c16101ceb658b9dd$export$34e2febe53ae29cc);
const $c16101ceb658b9dd$export$5abca33e6be905d2 = $c16101ceb658b9dd$var$createBorderStyle('borderRight', $c16101ceb658b9dd$export$34e2febe53ae29cc);
const $c16101ceb658b9dd$export$e2ce9f12a980a822 = $c16101ceb658b9dd$var$createBorderStyle('borderBottom', $c16101ceb658b9dd$export$34e2febe53ae29cc);
const $c16101ceb658b9dd$export$47658cca1a909427 = $c16101ceb658b9dd$var$createBorderStyle('borderLeft', $c16101ceb658b9dd$export$34e2febe53ae29cc);
const $c16101ceb658b9dd$export$e7fb0694ba2404fc = $c16101ceb658b9dd$var$createBorderStyle('borderColor');
const $c16101ceb658b9dd$export$126a92c968acdb85 = $c16101ceb658b9dd$var$createBorderStyle('borderTopColor');
const $c16101ceb658b9dd$export$85cc51cb8fbb8c0e = $c16101ceb658b9dd$var$createBorderStyle('borderRightColor');
const $c16101ceb658b9dd$export$340b0327727f6d1a = $c16101ceb658b9dd$var$createBorderStyle('borderBottomColor');
const $c16101ceb658b9dd$export$60beef91a985b4bf = $c16101ceb658b9dd$var$createBorderStyle('borderLeftColor');
const $c16101ceb658b9dd$export$f9258c55612cbed7 = $c16101ceb658b9dd$var$createBorderStyle('outline', $c16101ceb658b9dd$export$34e2febe53ae29cc);
const $c16101ceb658b9dd$export$621fe586efeb64b9 = $c16101ceb658b9dd$var$createBorderStyle('outlineColor');
const $c16101ceb658b9dd$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $l0eT8.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $l0eT8.getValue)(transformer, propValue)
            });
        return (0, $grZ4X.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$c16101ceb658b9dd$export$7a57f79000377ca2.propTypes = {};
$c16101ceb658b9dd$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $c16101ceb658b9dd$var$borders = (0, $5R2Dw.default)($c16101ceb658b9dd$export$1edee58a52776cd9, $c16101ceb658b9dd$export$f9a7b6bd24892946, $c16101ceb658b9dd$export$5abca33e6be905d2, $c16101ceb658b9dd$export$e2ce9f12a980a822, $c16101ceb658b9dd$export$47658cca1a909427, $c16101ceb658b9dd$export$e7fb0694ba2404fc, $c16101ceb658b9dd$export$126a92c968acdb85, $c16101ceb658b9dd$export$85cc51cb8fbb8c0e, $c16101ceb658b9dd$export$340b0327727f6d1a, $c16101ceb658b9dd$export$60beef91a985b4bf, $c16101ceb658b9dd$export$7a57f79000377ca2, $c16101ceb658b9dd$export$f9258c55612cbed7, $c16101ceb658b9dd$export$621fe586efeb64b9);
var $c16101ceb658b9dd$export$2e2bcd8739ae039 = $c16101ceb658b9dd$var$borders;

});
parcelRegister("5R2Dw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4433f2860b7f9e75$export$2e2bcd8739ae039; });

var $dbefT = parcelRequire("dbefT");
function $4433f2860b7f9e75$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $dbefT.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $4433f2860b7f9e75$export$2e2bcd8739ae039 = $4433f2860b7f9e75$var$compose;

});


parcelRegister("cdIgX", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $8e590a8387a268ce$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $8e590a8387a268ce$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $8e590a8387a268ce$export$8a833ffa5f5dbeda; });

var $gzdlJ = parcelRequire("gzdlJ");

var $5R2Dw = parcelRequire("5R2Dw");

var $l0eT8 = parcelRequire("l0eT8");

var $grZ4X = parcelRequire("grZ4X");

const $8e590a8387a268ce$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $l0eT8.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $l0eT8.getValue)(transformer, propValue)
            });
        return (0, $grZ4X.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$8e590a8387a268ce$export$5df9adcb0db95e1e.propTypes = {};
$8e590a8387a268ce$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $8e590a8387a268ce$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $l0eT8.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $l0eT8.getValue)(transformer, propValue)
            });
        return (0, $grZ4X.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$8e590a8387a268ce$export$ec60d70ff941a580.propTypes = {};
$8e590a8387a268ce$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $8e590a8387a268ce$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $l0eT8.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $l0eT8.getValue)(transformer, propValue)
            });
        return (0, $grZ4X.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$8e590a8387a268ce$export$8a833ffa5f5dbeda.propTypes = {};
$8e590a8387a268ce$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $8e590a8387a268ce$export$baf44164ca3a34e8 = (0, $gzdlJ.default)({
    prop: 'gridColumn'
});
const $8e590a8387a268ce$export$8f7213a1cd01e832 = (0, $gzdlJ.default)({
    prop: 'gridRow'
});
const $8e590a8387a268ce$export$b0e0abbc49ba668 = (0, $gzdlJ.default)({
    prop: 'gridAutoFlow'
});
const $8e590a8387a268ce$export$bcd8b929d4b4142 = (0, $gzdlJ.default)({
    prop: 'gridAutoColumns'
});
const $8e590a8387a268ce$export$e5039a674e14c828 = (0, $gzdlJ.default)({
    prop: 'gridAutoRows'
});
const $8e590a8387a268ce$export$42bd9088661ffb03 = (0, $gzdlJ.default)({
    prop: 'gridTemplateColumns'
});
const $8e590a8387a268ce$export$920682ae05b999bc = (0, $gzdlJ.default)({
    prop: 'gridTemplateRows'
});
const $8e590a8387a268ce$export$1b88fbdd482fd33a = (0, $gzdlJ.default)({
    prop: 'gridTemplateAreas'
});
const $8e590a8387a268ce$export$bdb486e40d52d26f = (0, $gzdlJ.default)({
    prop: 'gridArea'
});
const $8e590a8387a268ce$var$grid = (0, $5R2Dw.default)($8e590a8387a268ce$export$5df9adcb0db95e1e, $8e590a8387a268ce$export$ec60d70ff941a580, $8e590a8387a268ce$export$8a833ffa5f5dbeda, $8e590a8387a268ce$export$baf44164ca3a34e8, $8e590a8387a268ce$export$8f7213a1cd01e832, $8e590a8387a268ce$export$b0e0abbc49ba668, $8e590a8387a268ce$export$bcd8b929d4b4142, $8e590a8387a268ce$export$e5039a674e14c828, $8e590a8387a268ce$export$42bd9088661ffb03, $8e590a8387a268ce$export$920682ae05b999bc, $8e590a8387a268ce$export$1b88fbdd482fd33a, $8e590a8387a268ce$export$bdb486e40d52d26f);
var $8e590a8387a268ce$export$2e2bcd8739ae039 = $8e590a8387a268ce$var$grid;

});

parcelRegister("g1uKl", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $baa496f4d070b861$export$dbaffd4420ea0ac6; });

var $gzdlJ = parcelRequire("gzdlJ");

var $5R2Dw = parcelRequire("5R2Dw");
function $baa496f4d070b861$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $baa496f4d070b861$export$35e9368ef982300f = (0, $gzdlJ.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $baa496f4d070b861$export$dbaffd4420ea0ac6
});
const $baa496f4d070b861$export$2506f56c10355b33 = (0, $gzdlJ.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $baa496f4d070b861$export$dbaffd4420ea0ac6
});
const $baa496f4d070b861$export$8c5a050822fd698c = (0, $gzdlJ.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $baa496f4d070b861$export$dbaffd4420ea0ac6
});
const $baa496f4d070b861$var$palette = (0, $5R2Dw.default)($baa496f4d070b861$export$35e9368ef982300f, $baa496f4d070b861$export$2506f56c10355b33, $baa496f4d070b861$export$8c5a050822fd698c);
var $baa496f4d070b861$export$2e2bcd8739ae039 = $baa496f4d070b861$var$palette;

});

parcelRegister("jW9RL", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $e83b1655b3584a4e$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $e83b1655b3584a4e$export$488fda99655ff65a; });

var $gzdlJ = parcelRequire("gzdlJ");

var $5R2Dw = parcelRequire("5R2Dw");

var $grZ4X = parcelRequire("grZ4X");
function $e83b1655b3584a4e$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $e83b1655b3584a4e$export$7e3df82ee760448c = (0, $gzdlJ.default)({
    prop: 'width',
    transform: $e83b1655b3584a4e$export$8afece71750ec241
});
const $e83b1655b3584a4e$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $grZ4X.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $e83b1655b3584a4e$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $grZ4X.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$e83b1655b3584a4e$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $e83b1655b3584a4e$export$ee148fbbe8357dd2 = (0, $gzdlJ.default)({
    prop: 'minWidth',
    transform: $e83b1655b3584a4e$export$8afece71750ec241
});
const $e83b1655b3584a4e$export$ac607276a8fe9f0a = (0, $gzdlJ.default)({
    prop: 'height',
    transform: $e83b1655b3584a4e$export$8afece71750ec241
});
const $e83b1655b3584a4e$export$dc0d8bd0b94f8570 = (0, $gzdlJ.default)({
    prop: 'maxHeight',
    transform: $e83b1655b3584a4e$export$8afece71750ec241
});
const $e83b1655b3584a4e$export$a43cf604e12f3b17 = (0, $gzdlJ.default)({
    prop: 'minHeight',
    transform: $e83b1655b3584a4e$export$8afece71750ec241
});
const $e83b1655b3584a4e$export$ffed9f14fb65e276 = (0, $gzdlJ.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $e83b1655b3584a4e$export$8afece71750ec241
});
const $e83b1655b3584a4e$export$905076ed6620e671 = (0, $gzdlJ.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $e83b1655b3584a4e$export$8afece71750ec241
});
const $e83b1655b3584a4e$export$6ccc93f785106a58 = (0, $gzdlJ.default)({
    prop: 'boxSizing'
});
const $e83b1655b3584a4e$var$sizing = (0, $5R2Dw.default)($e83b1655b3584a4e$export$7e3df82ee760448c, $e83b1655b3584a4e$export$488fda99655ff65a, $e83b1655b3584a4e$export$ee148fbbe8357dd2, $e83b1655b3584a4e$export$ac607276a8fe9f0a, $e83b1655b3584a4e$export$dc0d8bd0b94f8570, $e83b1655b3584a4e$export$a43cf604e12f3b17, $e83b1655b3584a4e$export$6ccc93f785106a58);
var $e83b1655b3584a4e$export$2e2bcd8739ae039 = $e83b1655b3584a4e$var$sizing;

});



parcelRegister("aOb5j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7de72c13bebc6f30$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $5wgL8 = parcelRequire("5wgL8");

var $k3eY1 = parcelRequire("k3eY1");

var $2N3YN = parcelRequire("2N3YN");
'use client';
function $7de72c13bebc6f30$export$2e2bcd8739ae039() {
    const theme = (0, $5wgL8.default)((0, $k3eY1.default));
    return theme[0, $2N3YN.default] || theme;
}

});
parcelRegister("5wgL8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $404cf0f3e540a2cb$export$2e2bcd8739ae039; });

var $1zcRx = parcelRequire("1zcRx");

var $65M4H = parcelRequire("65M4H");
'use client';
const $404cf0f3e540a2cb$export$35e57303dbd8a66 = (0, $1zcRx.default)();
function $404cf0f3e540a2cb$var$useTheme(defaultTheme = $404cf0f3e540a2cb$export$35e57303dbd8a66) {
    return (0, $65M4H.default)(defaultTheme);
}
var $404cf0f3e540a2cb$export$2e2bcd8739ae039 = $404cf0f3e540a2cb$var$useTheme;

});
parcelRegister("1zcRx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $124309933ba5fccb$export$2e2bcd8739ae039; });

var $5syur = parcelRequire("5syur");

var $bE0Qy = parcelRequire("bE0Qy");

var $fWjZ8 = parcelRequire("fWjZ8");

var $8gTYU = parcelRequire("8gTYU");

var $b6RkN = parcelRequire("b6RkN");

var $f9NmP = parcelRequire("f9NmP");

var $8RAwN = parcelRequire("8RAwN");

var $cxNpU = parcelRequire("cxNpU");
function $124309933ba5fccb$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $bE0Qy.default)(breakpointsInput);
    const spacing = (0, $b6RkN.default)(spacingInput);
    let muiTheme = (0, $5syur.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $8gTYU.default),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $fWjZ8.default)(muiTheme);
    muiTheme.applyStyles = (0, $cxNpU.default);
    muiTheme = args.reduce((acc, argument)=>(0, $5syur.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $8RAwN.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $f9NmP.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $124309933ba5fccb$export$2e2bcd8739ae039 = $124309933ba5fccb$var$createTheme;

});
parcelRegister("bE0Qy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87a416430a959cea$export$2e2bcd8739ae039; });
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $87a416430a959cea$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $87a416430a959cea$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $87a416430a959cea$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $87a416430a959cea$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("8gTYU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $605b3e14c17458d8$export$2e2bcd8739ae039; });
const $605b3e14c17458d8$var$shape = {
    borderRadius: 4
};
var $605b3e14c17458d8$export$2e2bcd8739ae039 = $605b3e14c17458d8$var$shape;

});

parcelRegister("b6RkN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8169a057809484de$export$2e2bcd8739ae039; });

var $l0eT8 = parcelRequire("l0eT8");
function $8169a057809484de$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $l0eT8.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});

parcelRegister("f9NmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b08dfd925cd859a9$export$2e2bcd8739ae039; });

var $5pCmM = parcelRequire("5pCmM");

var $dbefT = parcelRequire("dbefT");

var $gzdlJ = parcelRequire("gzdlJ");

var $grZ4X = parcelRequire("grZ4X");

var $fWjZ8 = parcelRequire("fWjZ8");

var $8RAwN = parcelRequire("8RAwN");
function $b08dfd925cd859a9$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $b08dfd925cd859a9$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $b08dfd925cd859a9$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $gzdlJ.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $gzdlJ.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $gzdlJ.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $5pCmM.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $grZ4X.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $8RAwN.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $grZ4X.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $b08dfd925cd859a9$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $dbefT.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $grZ4X.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($b08dfd925cd859a9$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $dbefT.default)(css, breakpointsValues);
                        }
                    } else css = (0, $dbefT.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $fWjZ8.sortContainerQueries)(theme, (0, $grZ4X.removeUnusedBreakpoints)(breakpointsKeys, css))
            };
            return (0, $fWjZ8.sortContainerQueries)(theme, (0, $grZ4X.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $b08dfd925cd859a9$var$styleFunctionSx = $b08dfd925cd859a9$export$7d53d8bf2911e013();
$b08dfd925cd859a9$var$styleFunctionSx.filterProps = [
    'sx'
];
var $b08dfd925cd859a9$export$2e2bcd8739ae039 = $b08dfd925cd859a9$var$styleFunctionSx;

});

parcelRegister("cxNpU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $921ee6491134d507$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $921ee6491134d507$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("65M4H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46f880593fae972c$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("fPZvG");
var $gaZMG = parcelRequire("gaZMG");
'use client';
function $46f880593fae972c$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $46f880593fae972c$var$useTheme(defaultTheme = null) {
    const contextTheme = $bh6RR.useContext((0, $gaZMG.T));
    return !contextTheme || $46f880593fae972c$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $46f880593fae972c$export$2e2bcd8739ae039 = $46f880593fae972c$var$useTheme;

});
parcelRegister("fPZvG", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $b87b550e76e09f68$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $b87b550e76e09f68$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $b87b550e76e09f68$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("gaZMG")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("gaZMG")).w; });

var $gaZMG = parcelRequire("gaZMG");

var $bh6RR = parcelRequire("bh6RR");

var $3hmGv = parcelRequire("3hmGv");

var $lSpak = parcelRequire("lSpak");

var $9v6T8 = parcelRequire("9v6T8");
parcelRequire("lNmZA");
parcelRequire("4WYaH");
parcelRequire("ieFqf");

parcelRequire("adG4d");
var $b87b550e76e09f68$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $gaZMG.h).call(props, 'css')) return $bh6RR.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $gaZMG.E);
    createElementArgArray[1] = (0, $gaZMG.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $bh6RR.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($b87b550e76e09f68$export$c8a8987d4410bf2d || ($b87b550e76e09f68$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $b87b550e76e09f68$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $gaZMG.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $9v6T8.serializeStyles)([
        styles
    ], undefined, $bh6RR.useContext((0, $gaZMG.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $bh6RR.useRef();
    (0, $lSpak.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $lSpak.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $3hmGv.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $b87b550e76e09f68$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $9v6T8.serializeStyles)(args);
}
function $b87b550e76e09f68$export$d25ddfdf17c3ad3e() {
    var insertable = $b87b550e76e09f68$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $b87b550e76e09f68$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $b87b550e76e09f68$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $3hmGv.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $b87b550e76e09f68$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $lSpak.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $3hmGv.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $b87b550e76e09f68$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $gaZMG.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $gaZMG.i)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $9v6T8.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $3hmGv.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $gaZMG.i)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $b87b550e76e09f68$var$merge(cache.registered, css, $b87b550e76e09f68$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $bh6RR.useContext((0, $gaZMG.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($b87b550e76e09f68$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("gaZMG", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $bc6d818de25196f6$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "w", function () { return $bc6d818de25196f6$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $bc6d818de25196f6$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $bc6d818de25196f6$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $bc6d818de25196f6$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $bc6d818de25196f6$export$a9c23c6ac3fc3eca; });

var $bh6RR = parcelRequire("bh6RR");

var $lNmZA = parcelRequire("lNmZA");

var $4WYaH = parcelRequire("4WYaH");

var $ieFqf = parcelRequire("ieFqf");

var $8GHIh = parcelRequire("8GHIh");

var $3hmGv = parcelRequire("3hmGv");

var $9v6T8 = parcelRequire("9v6T8");

var $lSpak = parcelRequire("lSpak");
var $bc6d818de25196f6$export$23f2a1d2818174ef = false;
var $bc6d818de25196f6$var$EmotionCacheContext = /* #__PURE__ */ $bh6RR.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $lNmZA.default)({
    key: 'css'
}) : null);
var $bc6d818de25196f6$export$e7094788287c5e9b = $bc6d818de25196f6$var$EmotionCacheContext.Provider;
var $bc6d818de25196f6$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $bh6RR.useContext)($bc6d818de25196f6$var$EmotionCacheContext);
};
var $bc6d818de25196f6$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $bh6RR.useContext)($bc6d818de25196f6$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $bc6d818de25196f6$export$971d5caa766a69d7 = /* #__PURE__ */ $bh6RR.createContext({});
var $bc6d818de25196f6$export$3b14a55fb2447963 = function useTheme() {
    return $bh6RR.useContext($bc6d818de25196f6$export$971d5caa766a69d7);
};
var $bc6d818de25196f6$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $4WYaH.default)({}, outerTheme, theme);
};
var $bc6d818de25196f6$var$createCacheWithTheme = /* #__PURE__ */ (0, $ieFqf.default)(function(outerTheme) {
    return (0, $ieFqf.default)(function(theme) {
        return $bc6d818de25196f6$var$getTheme(outerTheme, theme);
    });
});
var $bc6d818de25196f6$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $bh6RR.useContext($bc6d818de25196f6$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $bc6d818de25196f6$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $bh6RR.createElement($bc6d818de25196f6$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $bc6d818de25196f6$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $bh6RR.forwardRef(function render(props, ref) {
        var theme = $bh6RR.useContext($bc6d818de25196f6$export$971d5caa766a69d7);
        return /*#__PURE__*/ $bh6RR.createElement(Component, (0, $4WYaH.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $8GHIh.default)(WithTheme, Component);
}
var $bc6d818de25196f6$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $bc6d818de25196f6$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $bc6d818de25196f6$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($bc6d818de25196f6$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$bc6d818de25196f6$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $bc6d818de25196f6$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $3hmGv.registerStyles)(cache, serialized, isStringTag);
    (0, $lSpak.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $3hmGv.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $bc6d818de25196f6$var$Emotion = /* #__PURE__ */ $bc6d818de25196f6$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$bc6d818de25196f6$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $3hmGv.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $9v6T8.serializeStyles)(registeredStyles, undefined, $bh6RR.useContext($bc6d818de25196f6$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($bc6d818de25196f6$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $bc6d818de25196f6$var$typePropName && !$bc6d818de25196f6$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($bc6d818de25196f6$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $bh6RR.createElement(WrappedComponent, newProps));
});
var $bc6d818de25196f6$export$a9c23c6ac3fc3eca = $bc6d818de25196f6$var$Emotion;

});
parcelRegister("lNmZA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fde0026076b18275$export$2e2bcd8739ae039; });

var $k2OLv = parcelRequire("k2OLv");

var $kxFgj = parcelRequire("kxFgj");
var $jkNT4 = parcelRequire("jkNT4");
var $cm1Zb = parcelRequire("cm1Zb");
var $b2BSq = parcelRequire("b2BSq");
var $3lkMb = parcelRequire("3lkMb");
var $8exKB = parcelRequire("8exKB");
parcelRequire("ieFqf");
parcelRequire("cthCm");
var $fde0026076b18275$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $kxFgj.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $kxFgj.token)(character)) break;
        (0, $kxFgj.next)();
    }
    return (0, $kxFgj.slice)(begin, (0, $kxFgj.position));
};
var $fde0026076b18275$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $kxFgj.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $kxFgj.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fde0026076b18275$var$identifierWithPointTracking((0, $kxFgj.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $kxFgj.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $kxFgj.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $jkNT4.from)(character);
    }
    while (character = (0, $kxFgj.next)());
    return parsed;
};
var $fde0026076b18275$var$getRules = function getRules(value, points) {
    return (0, $kxFgj.dealloc)($fde0026076b18275$var$toRules((0, $kxFgj.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fde0026076b18275$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fde0026076b18275$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fde0026076b18275$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fde0026076b18275$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fde0026076b18275$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fde0026076b18275$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $fde0026076b18275$var$prefix(value, length) {
    switch((0, $jkNT4.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $b2BSq.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $b2BSq.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MOZ) + value + (0, $b2BSq.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + value + value;
        // order
        case 6165:
            return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $b2BSq.WEBKIT) + value + (0, $jkNT4.replace)(value, /(\w+).+(:[^]+)/, (0, $b2BSq.WEBKIT) + 'box-$1$2' + (0, $b2BSq.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + 'flex-item-' + (0, $jkNT4.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + 'flex-line-pack' + (0, $jkNT4.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + (0, $jkNT4.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + (0, $jkNT4.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $b2BSq.WEBKIT) + 'box-' + (0, $jkNT4.replace)(value, '-grow', '') + (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + (0, $jkNT4.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $b2BSq.WEBKIT) + (0, $jkNT4.replace)(value, /([^-])(transform)/g, '$1' + (0, $b2BSq.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $jkNT4.replace)((0, $jkNT4.replace)((0, $jkNT4.replace)(value, /(zoom-|grab)/, (0, $b2BSq.WEBKIT) + '$1'), /(image-set)/, (0, $b2BSq.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $jkNT4.replace)(value, /(image-set\([^]*)/, (0, $b2BSq.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $jkNT4.replace)((0, $jkNT4.replace)(value, /(.+:)(flex-)?(.*)/, (0, $b2BSq.WEBKIT) + 'box-pack:$3' + (0, $b2BSq.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $b2BSq.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $jkNT4.replace)(value, /(.+)-inline(.+)/, (0, $b2BSq.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $jkNT4.strlen)(value) - 1 - length > 6) switch((0, $jkNT4.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $jkNT4.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $jkNT4.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $b2BSq.WEBKIT) + '$2-$3' + '$1' + (0, $b2BSq.MOZ) + ((0, $jkNT4.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $jkNT4.indexof)(value, 'stretch') ? $fde0026076b18275$var$prefix((0, $jkNT4.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $jkNT4.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $jkNT4.charat)(value, (0, $jkNT4.strlen)(value) - 3 - (~(0, $jkNT4.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $jkNT4.replace)(value, ':', ':' + (0, $b2BSq.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $jkNT4.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $b2BSq.WEBKIT) + ((0, $jkNT4.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $b2BSq.WEBKIT) + '$2$3' + '$1' + (0, $b2BSq.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $jkNT4.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + (0, $jkNT4.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + (0, $jkNT4.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + (0, $jkNT4.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + value + value;
    }
    return value;
}
var $fde0026076b18275$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $b2BSq.DECLARATION:
                element["return"] = $fde0026076b18275$var$prefix(element.value, element.length);
                break;
            case 0, $b2BSq.KEYFRAMES:
                return (0, $8exKB.serialize)([
                    (0, $kxFgj.copy)(element, {
                        value: (0, $jkNT4.replace)(element.value, '@', '@' + (0, $b2BSq.WEBKIT))
                    })
                ], callback);
            case 0, $b2BSq.RULESET:
                if (element.length) return (0, $jkNT4.combine)(element.props, function(value) {
                    switch((0, $jkNT4.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $8exKB.serialize)([
                                (0, $kxFgj.copy)(element, {
                                    props: [
                                        (0, $jkNT4.replace)(value, /:(read-\w+)/, ':' + (0, $b2BSq.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $8exKB.serialize)([
                                (0, $kxFgj.copy)(element, {
                                    props: [
                                        (0, $jkNT4.replace)(value, /:(plac\w+)/, ':' + (0, $b2BSq.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $kxFgj.copy)(element, {
                                    props: [
                                        (0, $jkNT4.replace)(value, /:(plac\w+)/, ':' + (0, $b2BSq.MOZ) + '$1')
                                    ]
                                }),
                                (0, $kxFgj.copy)(element, {
                                    props: [
                                        (0, $jkNT4.replace)(value, /:(plac\w+)/, (0, $b2BSq.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $fde0026076b18275$var$defaultStylisPlugins = [
    $fde0026076b18275$var$prefixer
];
var $fde0026076b18275$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $fde0026076b18275$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fde0026076b18275$var$compat,
        $fde0026076b18275$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $8exKB.stringify),
        (0, $3lkMb.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $3lkMb.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $8exKB.serialize)((0, $cm1Zb.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $k2OLv.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("k2OLv", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $e97b5f72ed127b53$export$9d753cd7ae895cce; });
var $e97b5f72ed127b53$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e97b5f72ed127b53$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e97b5f72ed127b53$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e97b5f72ed127b53$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e97b5f72ed127b53$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e97b5f72ed127b53$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e97b5f72ed127b53$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("kxFgj", function(module, exports) {

$parcel$export(module.exports, "position", function () { return $ef46e5822a5bca3d$export$5880b8b5730aff45; });
$parcel$export(module.exports, "node", function () { return $ef46e5822a5bca3d$export$35059013cd4a06db; });
$parcel$export(module.exports, "copy", function () { return $ef46e5822a5bca3d$export$784d13d8ee351f07; });
$parcel$export(module.exports, "char", function () { return $ef46e5822a5bca3d$export$eba6f6f03b0a92e7; });
$parcel$export(module.exports, "prev", function () { return $ef46e5822a5bca3d$export$232faf9add678146; });
$parcel$export(module.exports, "next", function () { return $ef46e5822a5bca3d$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $ef46e5822a5bca3d$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "caret", function () { return $ef46e5822a5bca3d$export$e88cb2efb12ae807; });
$parcel$export(module.exports, "slice", function () { return $ef46e5822a5bca3d$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $ef46e5822a5bca3d$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $ef46e5822a5bca3d$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $ef46e5822a5bca3d$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $ef46e5822a5bca3d$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "tokenize", function () { return $ef46e5822a5bca3d$export$660b2ee2d4fb4eff; });
$parcel$export(module.exports, "whitespace", function () { return $ef46e5822a5bca3d$export$7af1228ff777d175; });
$parcel$export(module.exports, "identifier", function () { return $ef46e5822a5bca3d$export$c2ab62c7bf24634; });
$parcel$export(module.exports, "escaping", function () { return $ef46e5822a5bca3d$export$955ba06d119e085e; });
$parcel$export(module.exports, "commenter", function () { return $ef46e5822a5bca3d$export$4254d4e2b3745c4c; });

var $jkNT4 = parcelRequire("jkNT4");
var $ef46e5822a5bca3d$export$53f1d5ea8de3d7c = 1;
var $ef46e5822a5bca3d$export$4e0c71f277ca26b3 = 1;
var $ef46e5822a5bca3d$export$f24224f1c91d8156 = 0;
var $ef46e5822a5bca3d$export$5880b8b5730aff45 = 0;
var $ef46e5822a5bca3d$export$c0306caf338ac095 = 0;
var $ef46e5822a5bca3d$export$30a86d91af8ff6e6 = '';
function $ef46e5822a5bca3d$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $ef46e5822a5bca3d$export$53f1d5ea8de3d7c,
        column: $ef46e5822a5bca3d$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $ef46e5822a5bca3d$export$784d13d8ee351f07(root, props) {
    return (0, $jkNT4.assign)($ef46e5822a5bca3d$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $ef46e5822a5bca3d$export$eba6f6f03b0a92e7() {
    return $ef46e5822a5bca3d$export$c0306caf338ac095;
}
function $ef46e5822a5bca3d$export$232faf9add678146() {
    $ef46e5822a5bca3d$export$c0306caf338ac095 = $ef46e5822a5bca3d$export$5880b8b5730aff45 > 0 ? (0, $jkNT4.charat)($ef46e5822a5bca3d$export$30a86d91af8ff6e6, --$ef46e5822a5bca3d$export$5880b8b5730aff45) : 0;
    if ($ef46e5822a5bca3d$export$4e0c71f277ca26b3--, $ef46e5822a5bca3d$export$c0306caf338ac095 === 10) $ef46e5822a5bca3d$export$4e0c71f277ca26b3 = 1, $ef46e5822a5bca3d$export$53f1d5ea8de3d7c--;
    return $ef46e5822a5bca3d$export$c0306caf338ac095;
}
function $ef46e5822a5bca3d$export$48cfd1e771a65c4f() {
    $ef46e5822a5bca3d$export$c0306caf338ac095 = $ef46e5822a5bca3d$export$5880b8b5730aff45 < $ef46e5822a5bca3d$export$f24224f1c91d8156 ? (0, $jkNT4.charat)($ef46e5822a5bca3d$export$30a86d91af8ff6e6, $ef46e5822a5bca3d$export$5880b8b5730aff45++) : 0;
    if ($ef46e5822a5bca3d$export$4e0c71f277ca26b3++, $ef46e5822a5bca3d$export$c0306caf338ac095 === 10) $ef46e5822a5bca3d$export$4e0c71f277ca26b3 = 1, $ef46e5822a5bca3d$export$53f1d5ea8de3d7c++;
    return $ef46e5822a5bca3d$export$c0306caf338ac095;
}
function $ef46e5822a5bca3d$export$4d3fb11e950abb9e() {
    return (0, $jkNT4.charat)($ef46e5822a5bca3d$export$30a86d91af8ff6e6, $ef46e5822a5bca3d$export$5880b8b5730aff45);
}
function $ef46e5822a5bca3d$export$e88cb2efb12ae807() {
    return $ef46e5822a5bca3d$export$5880b8b5730aff45;
}
function $ef46e5822a5bca3d$export$58adb3bec8346d0f(begin, end) {
    return (0, $jkNT4.substr)($ef46e5822a5bca3d$export$30a86d91af8ff6e6, begin, end);
}
function $ef46e5822a5bca3d$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $ef46e5822a5bca3d$export$2de70f21292aac9e(value) {
    return $ef46e5822a5bca3d$export$53f1d5ea8de3d7c = $ef46e5822a5bca3d$export$4e0c71f277ca26b3 = 1, $ef46e5822a5bca3d$export$f24224f1c91d8156 = (0, $jkNT4.strlen)($ef46e5822a5bca3d$export$30a86d91af8ff6e6 = value), $ef46e5822a5bca3d$export$5880b8b5730aff45 = 0, [];
}
function $ef46e5822a5bca3d$export$45918ac1574455b1(value) {
    return $ef46e5822a5bca3d$export$30a86d91af8ff6e6 = '', value;
}
function $ef46e5822a5bca3d$export$410ac95b9ec204b8(type) {
    return (0, $jkNT4.trim)($ef46e5822a5bca3d$export$58adb3bec8346d0f($ef46e5822a5bca3d$export$5880b8b5730aff45 - 1, $ef46e5822a5bca3d$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $ef46e5822a5bca3d$export$660b2ee2d4fb4eff(value) {
    return $ef46e5822a5bca3d$export$45918ac1574455b1($ef46e5822a5bca3d$export$5f8c09e3ae6f64e1($ef46e5822a5bca3d$export$2de70f21292aac9e(value)));
}
function $ef46e5822a5bca3d$export$7af1228ff777d175(type) {
    while($ef46e5822a5bca3d$export$c0306caf338ac095 = $ef46e5822a5bca3d$export$4d3fb11e950abb9e())if ($ef46e5822a5bca3d$export$c0306caf338ac095 < 33) $ef46e5822a5bca3d$export$48cfd1e771a65c4f();
    else break;
    return $ef46e5822a5bca3d$export$9e1725a4cfeada27(type) > 2 || $ef46e5822a5bca3d$export$9e1725a4cfeada27($ef46e5822a5bca3d$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $ef46e5822a5bca3d$export$5f8c09e3ae6f64e1(children) {
    while($ef46e5822a5bca3d$export$48cfd1e771a65c4f())switch($ef46e5822a5bca3d$export$9e1725a4cfeada27($ef46e5822a5bca3d$export$c0306caf338ac095)){
        case 0:
            (0, $jkNT4.append)($ef46e5822a5bca3d$export$c2ab62c7bf24634($ef46e5822a5bca3d$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $jkNT4.append)($ef46e5822a5bca3d$export$410ac95b9ec204b8($ef46e5822a5bca3d$export$c0306caf338ac095), children);
            break;
        default:
            (0, $jkNT4.append)((0, $jkNT4.from)($ef46e5822a5bca3d$export$c0306caf338ac095), children);
    }
    return children;
}
function $ef46e5822a5bca3d$export$955ba06d119e085e(index, count) {
    while(--count && $ef46e5822a5bca3d$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($ef46e5822a5bca3d$export$c0306caf338ac095 < 48 || $ef46e5822a5bca3d$export$c0306caf338ac095 > 102 || $ef46e5822a5bca3d$export$c0306caf338ac095 > 57 && $ef46e5822a5bca3d$export$c0306caf338ac095 < 65 || $ef46e5822a5bca3d$export$c0306caf338ac095 > 70 && $ef46e5822a5bca3d$export$c0306caf338ac095 < 97) break;
    return $ef46e5822a5bca3d$export$58adb3bec8346d0f(index, $ef46e5822a5bca3d$export$e88cb2efb12ae807() + (count < 6 && $ef46e5822a5bca3d$export$4d3fb11e950abb9e() == 32 && $ef46e5822a5bca3d$export$48cfd1e771a65c4f() == 32));
}
function $ef46e5822a5bca3d$export$c889f2fcc19dbf12(type) {
    while($ef46e5822a5bca3d$export$48cfd1e771a65c4f())switch($ef46e5822a5bca3d$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $ef46e5822a5bca3d$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $ef46e5822a5bca3d$export$c889f2fcc19dbf12($ef46e5822a5bca3d$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $ef46e5822a5bca3d$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $ef46e5822a5bca3d$export$48cfd1e771a65c4f();
            break;
    }
    return $ef46e5822a5bca3d$export$5880b8b5730aff45;
}
function $ef46e5822a5bca3d$export$4254d4e2b3745c4c(type, index) {
    while($ef46e5822a5bca3d$export$48cfd1e771a65c4f())// //
    if (type + $ef46e5822a5bca3d$export$c0306caf338ac095 === 57) break;
    else if (type + $ef46e5822a5bca3d$export$c0306caf338ac095 === 84 && $ef46e5822a5bca3d$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $ef46e5822a5bca3d$export$58adb3bec8346d0f(index, $ef46e5822a5bca3d$export$5880b8b5730aff45 - 1) + '*' + (0, $jkNT4.from)(type === 47 ? type : $ef46e5822a5bca3d$export$48cfd1e771a65c4f());
}
function $ef46e5822a5bca3d$export$c2ab62c7bf24634(index) {
    while(!$ef46e5822a5bca3d$export$9e1725a4cfeada27($ef46e5822a5bca3d$export$4d3fb11e950abb9e()))$ef46e5822a5bca3d$export$48cfd1e771a65c4f();
    return $ef46e5822a5bca3d$export$58adb3bec8346d0f(index, $ef46e5822a5bca3d$export$5880b8b5730aff45);
}

});
parcelRegister("jkNT4", function(module, exports) {

$parcel$export(module.exports, "abs", function () { return $e1369525a9d64396$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "from", function () { return $e1369525a9d64396$export$6788812c4e6611e6; });
$parcel$export(module.exports, "assign", function () { return $e1369525a9d64396$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "hash", function () { return $e1369525a9d64396$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $e1369525a9d64396$export$a9db5e087081082d; });
$parcel$export(module.exports, "trim", function () { return $e1369525a9d64396$export$87c2784dc9fc4ab; });
$parcel$export(module.exports, "match", function () { return $e1369525a9d64396$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $e1369525a9d64396$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $e1369525a9d64396$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "substr", function () { return $e1369525a9d64396$export$2f35ab04d2335697; });
$parcel$export(module.exports, "strlen", function () { return $e1369525a9d64396$export$36776f635604f274; });
$parcel$export(module.exports, "sizeof", function () { return $e1369525a9d64396$export$f9084667e487ed46; });
$parcel$export(module.exports, "append", function () { return $e1369525a9d64396$export$10d8903dec122b9d; });
$parcel$export(module.exports, "combine", function () { return $e1369525a9d64396$export$1be1fc439b849fdf; });
/**
 * @param {number}
 * @return {number}
 */ var $e1369525a9d64396$export$2335f513bbd82c6d = Math.abs;
var $e1369525a9d64396$export$6788812c4e6611e6 = String.fromCharCode;
var $e1369525a9d64396$export$e6e34fd1f2686227 = Object.assign;
function $e1369525a9d64396$export$d6af199866bfb566(value, length) {
    return $e1369525a9d64396$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $e1369525a9d64396$export$a9db5e087081082d(value, 0)) << 2 ^ $e1369525a9d64396$export$a9db5e087081082d(value, 1)) << 2 ^ $e1369525a9d64396$export$a9db5e087081082d(value, 2)) << 2 ^ $e1369525a9d64396$export$a9db5e087081082d(value, 3) : 0;
}
function $e1369525a9d64396$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $e1369525a9d64396$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $e1369525a9d64396$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $e1369525a9d64396$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $e1369525a9d64396$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $e1369525a9d64396$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $e1369525a9d64396$export$36776f635604f274(value) {
    return value.length;
}
function $e1369525a9d64396$export$f9084667e487ed46(value) {
    return value.length;
}
function $e1369525a9d64396$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $e1369525a9d64396$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("cm1Zb", function(module, exports) {

$parcel$export(module.exports, "compile", function () { return $8fe9146fb212183b$export$ef7acd7185315e22; });

var $b2BSq = parcelRequire("b2BSq");

var $jkNT4 = parcelRequire("jkNT4");

var $kxFgj = parcelRequire("kxFgj");
function $8fe9146fb212183b$export$ef7acd7185315e22(value) {
    return (0, $kxFgj.dealloc)($8fe9146fb212183b$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $kxFgj.alloc)(value), 0, [
        0
    ], value));
}
function $8fe9146fb212183b$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $kxFgj.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $jkNT4.charat)(characters, length - 1) == 58) {
                if ((0, $jkNT4.indexof)(characters += (0, $jkNT4.replace)((0, $kxFgj.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $kxFgj.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $kxFgj.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $kxFgj.escaping)((0, $kxFgj.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $kxFgj.peek)()){
                case 42:
                case 47:
                    (0, $jkNT4.append)($8fe9146fb212183b$export$4a34f930e789283c((0, $kxFgj.commenter)((0, $kxFgj.next)(), (0, $kxFgj.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $jkNT4.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $jkNT4.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, $jkNT4.strlen)(characters) - length) (0, $jkNT4.append)(property > 32 ? $8fe9146fb212183b$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $8fe9146fb212183b$export$f8483753829ec8f3((0, $jkNT4.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $jkNT4.append)(reference = $8fe9146fb212183b$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $8fe9146fb212183b$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $jkNT4.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $8fe9146fb212183b$export$98e6a39c04603d36(value, reference, reference, rule && (0, $jkNT4.append)($8fe9146fb212183b$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $8fe9146fb212183b$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $jkNT4.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $kxFgj.prev)() == 125) continue;
            }
            switch(characters += (0, $jkNT4.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $jkNT4.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $kxFgj.peek)() === 45) characters += (0, $kxFgj.delimit)((0, $kxFgj.next)());
                    atrule = (0, $kxFgj.peek)(), offset = length = (0, $jkNT4.strlen)(type = characters += (0, $kxFgj.identifier)((0, $kxFgj.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $jkNT4.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $8fe9146fb212183b$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $jkNT4.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $jkNT4.substr)(value, post + 1, post = (0, $jkNT4.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $jkNT4.trim)(j > 0 ? rule[x] + ' ' + y : (0, $jkNT4.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $kxFgj.node)(value, root, parent, offset === 0 ? (0, $b2BSq.RULESET) : type, props, children, length);
}
function $8fe9146fb212183b$export$4a34f930e789283c(value, root, parent) {
    return (0, $kxFgj.node)(value, root, parent, (0, $b2BSq.COMMENT), (0, $jkNT4.from)((0, $kxFgj.char)()), (0, $jkNT4.substr)(value, 2, -2), 0);
}
function $8fe9146fb212183b$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $kxFgj.node)(value, root, parent, (0, $b2BSq.DECLARATION), (0, $jkNT4.substr)(value, 0, length), (0, $jkNT4.substr)(value, length + 1, -1), length);
}

});
parcelRegister("b2BSq", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $809d4324f99b6fae$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $809d4324f99b6fae$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $809d4324f99b6fae$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "COMMENT", function () { return $809d4324f99b6fae$export$a29989082612d0d9; });
$parcel$export(module.exports, "RULESET", function () { return $809d4324f99b6fae$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $809d4324f99b6fae$export$527d108ccf083c2b; });
$parcel$export(module.exports, "IMPORT", function () { return $809d4324f99b6fae$export$a763edbf796b780a; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $809d4324f99b6fae$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "LAYER", function () { return $809d4324f99b6fae$export$d773506282b3cfe6; });
var $809d4324f99b6fae$export$71ad59f2e432cfe8 = '-ms-';
var $809d4324f99b6fae$export$2c0f367103c8d01c = '-moz-';
var $809d4324f99b6fae$export$39dfd62a25e0fe93 = '-webkit-';
var $809d4324f99b6fae$export$a29989082612d0d9 = 'comm';
var $809d4324f99b6fae$export$aa3a2e812ca8570d = 'rule';
var $809d4324f99b6fae$export$527d108ccf083c2b = 'decl';
var $809d4324f99b6fae$export$d3d35020fa5b54f0 = '@page';
var $809d4324f99b6fae$export$500415a86c544f73 = '@media';
var $809d4324f99b6fae$export$a763edbf796b780a = '@import';
var $809d4324f99b6fae$export$2790aeb8b4e5c826 = '@charset';
var $809d4324f99b6fae$export$1cc683e23b84b133 = '@viewport';
var $809d4324f99b6fae$export$9447a5efea57e862 = '@supports';
var $809d4324f99b6fae$export$ef011b4e114b1fba = '@document';
var $809d4324f99b6fae$export$6aad947bda0f3f46 = '@namespace';
var $809d4324f99b6fae$export$b44a8529a35fcb60 = '@keyframes';
var $809d4324f99b6fae$export$2c16de31893252e6 = '@font-face';
var $809d4324f99b6fae$export$3d846dd52e150c6f = '@counter-style';
var $809d4324f99b6fae$export$22314bfbb57653fe = '@font-feature-values';
var $809d4324f99b6fae$export$d773506282b3cfe6 = '@layer';

});


parcelRegister("3lkMb", function(module, exports) {

$parcel$export(module.exports, "middleware", function () { return $26f372faa6b2cbc7$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $26f372faa6b2cbc7$export$38bcb760f1d4871c; });

var $b2BSq = parcelRequire("b2BSq");

var $jkNT4 = parcelRequire("jkNT4");

var $kxFgj = parcelRequire("kxFgj");

var $8exKB = parcelRequire("8exKB");

var $hpy5e = parcelRequire("hpy5e");
function $26f372faa6b2cbc7$export$5a7767152ae0305f(collection) {
    var length = (0, $jkNT4.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $26f372faa6b2cbc7$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $26f372faa6b2cbc7$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $b2BSq.DECLARATION:
                element.return = (0, $hpy5e.prefix)(element.value, element.length, children);
                return;
            case 0, $b2BSq.KEYFRAMES:
                return (0, $8exKB.serialize)([
                    (0, $kxFgj.copy)(element, {
                        value: (0, $jkNT4.replace)(element.value, '@', '@' + (0, $b2BSq.WEBKIT))
                    })
                ], callback);
            case 0, $b2BSq.RULESET:
                if (element.length) return (0, $jkNT4.combine)(element.props, function(value) {
                    switch((0, $jkNT4.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $8exKB.serialize)([
                                (0, $kxFgj.copy)(element, {
                                    props: [
                                        (0, $jkNT4.replace)(value, /:(read-\w+)/, ':' + (0, $b2BSq.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $8exKB.serialize)([
                                (0, $kxFgj.copy)(element, {
                                    props: [
                                        (0, $jkNT4.replace)(value, /:(plac\w+)/, ':' + (0, $b2BSq.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $kxFgj.copy)(element, {
                                    props: [
                                        (0, $jkNT4.replace)(value, /:(plac\w+)/, ':' + (0, $b2BSq.MOZ) + '$1')
                                    ]
                                }),
                                (0, $kxFgj.copy)(element, {
                                    props: [
                                        (0, $jkNT4.replace)(value, /:(plac\w+)/, (0, $b2BSq.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $26f372faa6b2cbc7$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $b2BSq.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $jkNT4.combine)((0, $kxFgj.tokenize)(value), function(value, index, children) {
                    switch((0, $jkNT4.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $jkNT4.substr)(value, 1, (0, $jkNT4.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $jkNT4.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $jkNT4.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $jkNT4.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("8exKB", function(module, exports) {

$parcel$export(module.exports, "serialize", function () { return $5fe9cfb9170162a3$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $5fe9cfb9170162a3$export$fac44ee5b035f737; });

var $b2BSq = parcelRequire("b2BSq");

var $jkNT4 = parcelRequire("jkNT4");
function $5fe9cfb9170162a3$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $jkNT4.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $5fe9cfb9170162a3$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $b2BSq.LAYER:
            if (element.children.length) break;
        case 0, $b2BSq.IMPORT:
        case 0, $b2BSq.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $b2BSq.COMMENT:
            return '';
        case 0, $b2BSq.KEYFRAMES:
            return element.return = element.value + '{' + $5fe9cfb9170162a3$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $b2BSq.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $jkNT4.strlen)(children = $5fe9cfb9170162a3$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("hpy5e", function(module, exports) {

$parcel$export(module.exports, "prefix", function () { return $cacf35baaba986aa$export$82e9f45cca5ba907; });

var $b2BSq = parcelRequire("b2BSq");

var $jkNT4 = parcelRequire("jkNT4");
function $cacf35baaba986aa$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $jkNT4.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $b2BSq.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $b2BSq.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $b2BSq.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MOZ) + value + (0, $b2BSq.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $jkNT4.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + (0, $jkNT4.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + (0, $jkNT4.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + (0, $jkNT4.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + value + value;
        // order
        case 6165:
            return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $b2BSq.WEBKIT) + value + (0, $jkNT4.replace)(value, /(\w+).+(:[^]+)/, (0, $b2BSq.WEBKIT) + 'box-$1$2' + (0, $b2BSq.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + 'flex-item-' + (0, $jkNT4.replace)(value, /flex-|-self/g, '') + (!(0, $jkNT4.match)(value, /flex-|baseline/) ? (0, $b2BSq.MS) + 'grid-row-' + (0, $jkNT4.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + 'flex-line-pack' + (0, $jkNT4.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + (0, $jkNT4.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + (0, $jkNT4.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $b2BSq.WEBKIT) + 'box-' + (0, $jkNT4.replace)(value, '-grow', '') + (0, $b2BSq.WEBKIT) + value + (0, $b2BSq.MS) + (0, $jkNT4.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $b2BSq.WEBKIT) + (0, $jkNT4.replace)(value, /([^-])(transform)/g, '$1' + (0, $b2BSq.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $jkNT4.replace)((0, $jkNT4.replace)((0, $jkNT4.replace)(value, /(zoom-|grab)/, (0, $b2BSq.WEBKIT) + '$1'), /(image-set)/, (0, $b2BSq.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $jkNT4.replace)(value, /(image-set\([^]*)/, (0, $b2BSq.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $jkNT4.replace)((0, $jkNT4.replace)(value, /(.+:)(flex-)?(.*)/, (0, $b2BSq.WEBKIT) + 'box-pack:$3' + (0, $b2BSq.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $b2BSq.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $jkNT4.match)(value, /flex-|baseline/)) return (0, $b2BSq.MS) + 'grid-column-align' + (0, $jkNT4.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $b2BSq.MS) + (0, $jkNT4.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $jkNT4.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $jkNT4.indexof)(value + (children = children[length].value), 'span') ? value : (0, $b2BSq.MS) + (0, $jkNT4.replace)(value, '-start', '') + value + (0, $b2BSq.MS) + 'grid-row-span:' + (~(0, $jkNT4.indexof)(children, 'span') ? (0, $jkNT4.match)(children, /\d+/) : +(0, $jkNT4.match)(children, /\d+/) - +(0, $jkNT4.match)(value, /\d+/)) + ';';
            return (0, $b2BSq.MS) + (0, $jkNT4.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $jkNT4.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $b2BSq.MS) + (0, $jkNT4.replace)((0, $jkNT4.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $jkNT4.replace)(value, /(.+)-inline(.+)/, (0, $b2BSq.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $jkNT4.strlen)(value) - 1 - length > 6) switch((0, $jkNT4.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $jkNT4.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $jkNT4.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $b2BSq.WEBKIT) + '$2-$3' + '$1' + (0, $b2BSq.MOZ) + ((0, $jkNT4.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $jkNT4.indexof)(value, 'stretch') ? $cacf35baaba986aa$export$82e9f45cca5ba907((0, $jkNT4.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $jkNT4.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $b2BSq.MS) + a + ':' + b + f + (c ? (0, $b2BSq.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $jkNT4.charat)(value, length + 6) === 121) return (0, $jkNT4.replace)(value, ':', ':' + (0, $b2BSq.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $jkNT4.charat)(value, (0, $jkNT4.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $jkNT4.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $b2BSq.WEBKIT) + ((0, $jkNT4.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $b2BSq.WEBKIT) + '$2$3' + '$1' + (0, $b2BSq.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $jkNT4.replace)(value, ':', ':' + (0, $b2BSq.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $jkNT4.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("ieFqf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d469aa6647f846c1$export$2e2bcd8739ae039; });
var $d469aa6647f846c1$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("cthCm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9145dbf8e0e857b1$export$2e2bcd8739ae039; });
function $9145dbf8e0e857b1$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("4WYaH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39ab41060f0dd572$export$2e2bcd8739ae039; });
function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    return $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $39ab41060f0dd572$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("8GHIh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65342784890a87de$export$2e2bcd8739ae039; });

var $adG4d = parcelRequire("adG4d");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $65342784890a87de$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($adG4d)))(targetComponent, sourceComponent);
};

});
parcelRegister("adG4d", function(module, exports) {
'use strict';

var $aX2tJ = parcelRequire("aX2tJ");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $770bbfe5492d7fd4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $770bbfe5492d7fd4$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $770bbfe5492d7fd4$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$TYPE_STATICS = {};
$770bbfe5492d7fd4$var$TYPE_STATICS[$aX2tJ.ForwardRef] = $770bbfe5492d7fd4$var$FORWARD_REF_STATICS;
$770bbfe5492d7fd4$var$TYPE_STATICS[$aX2tJ.Memo] = $770bbfe5492d7fd4$var$MEMO_STATICS;
function $770bbfe5492d7fd4$var$getStatics(component) {
    // React v16.11 and below
    if ($aX2tJ.isMemo(component)) return $770bbfe5492d7fd4$var$MEMO_STATICS;
     // React v16.12 and above
    return $770bbfe5492d7fd4$var$TYPE_STATICS[component['$$typeof']] || $770bbfe5492d7fd4$var$REACT_STATICS;
}
var $770bbfe5492d7fd4$var$defineProperty = Object.defineProperty;
var $770bbfe5492d7fd4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $770bbfe5492d7fd4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $770bbfe5492d7fd4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $770bbfe5492d7fd4$var$getPrototypeOf = Object.getPrototypeOf;
var $770bbfe5492d7fd4$var$objectPrototype = Object.prototype;
function $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($770bbfe5492d7fd4$var$objectPrototype) {
            var inheritedComponent = $770bbfe5492d7fd4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $770bbfe5492d7fd4$var$objectPrototype) $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $770bbfe5492d7fd4$var$getOwnPropertyNames(sourceComponent);
        if ($770bbfe5492d7fd4$var$getOwnPropertySymbols) keys = keys.concat($770bbfe5492d7fd4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $770bbfe5492d7fd4$var$getStatics(targetComponent);
        var sourceStatics = $770bbfe5492d7fd4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$770bbfe5492d7fd4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $770bbfe5492d7fd4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $770bbfe5492d7fd4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $770bbfe5492d7fd4$var$hoistNonReactStatics;

});
parcelRegister("aX2tJ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4aTru"));

});
parcelRegister("4aTru", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $30a31a517a2d5cc7$export$2b8d127b894957b9; }, function (v) { return $30a31a517a2d5cc7$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $30a31a517a2d5cc7$export$cea3a54a6425200c; }, function (v) { return $30a31a517a2d5cc7$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $30a31a517a2d5cc7$export$a7c73072b1a182ae; }, function (v) { return $30a31a517a2d5cc7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $30a31a517a2d5cc7$export$9f27bc3417b4524d; }, function (v) { return $30a31a517a2d5cc7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $30a31a517a2d5cc7$export$db77ccec0bb4ccac; }, function (v) { return $30a31a517a2d5cc7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $30a31a517a2d5cc7$export$8392c0c9d3dcbd35; }, function (v) { return $30a31a517a2d5cc7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $30a31a517a2d5cc7$export$ffb0004e005737fa; }, function (v) { return $30a31a517a2d5cc7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $30a31a517a2d5cc7$export$b624eff549462981; }, function (v) { return $30a31a517a2d5cc7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $30a31a517a2d5cc7$export$7897aa7841a5380c; }, function (v) { return $30a31a517a2d5cc7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $30a31a517a2d5cc7$export$602eac185826482c; }, function (v) { return $30a31a517a2d5cc7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $30a31a517a2d5cc7$export$e2c29f18771995cb; }, function (v) { return $30a31a517a2d5cc7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $30a31a517a2d5cc7$export$5f8d39834fd61797; }, function (v) { return $30a31a517a2d5cc7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $30a31a517a2d5cc7$export$74bf444e3cd11ea5; }, function (v) { return $30a31a517a2d5cc7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $30a31a517a2d5cc7$export$92387174baf9b227; }, function (v) { return $30a31a517a2d5cc7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $30a31a517a2d5cc7$export$ec112efeb987d9c6; }, function (v) { return $30a31a517a2d5cc7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $30a31a517a2d5cc7$export$b706b080d889d2c9; }, function (v) { return $30a31a517a2d5cc7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $30a31a517a2d5cc7$export$5be5a87408f70ddc; }, function (v) { return $30a31a517a2d5cc7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $30a31a517a2d5cc7$export$45a5e7f76e0caa8d; }, function (v) { return $30a31a517a2d5cc7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $30a31a517a2d5cc7$export$455c2e768291efa6; }, function (v) { return $30a31a517a2d5cc7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $30a31a517a2d5cc7$export$9522e17588c12572; }, function (v) { return $30a31a517a2d5cc7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $30a31a517a2d5cc7$export$2110ac352bb060b9; }, function (v) { return $30a31a517a2d5cc7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $30a31a517a2d5cc7$export$56885ab8b9c456ab; }, function (v) { return $30a31a517a2d5cc7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $30a31a517a2d5cc7$export$d927fcb6adf8f9de; }, function (v) { return $30a31a517a2d5cc7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $30a31a517a2d5cc7$export$b82d16f27459e05a; }, function (v) { return $30a31a517a2d5cc7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $30a31a517a2d5cc7$export$522c17b4f5e123e8; }, function (v) { return $30a31a517a2d5cc7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $30a31a517a2d5cc7$export$1aabd8a0274ecfd6; }, function (v) { return $30a31a517a2d5cc7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $30a31a517a2d5cc7$export$9b621391a187a31a; }, function (v) { return $30a31a517a2d5cc7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $30a31a517a2d5cc7$export$f5bbd400c2f4426f; }, function (v) { return $30a31a517a2d5cc7$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $30a31a517a2d5cc7$export$2b8d127b894957b9;
var $30a31a517a2d5cc7$export$cea3a54a6425200c;
var $30a31a517a2d5cc7$export$a7c73072b1a182ae;
var $30a31a517a2d5cc7$export$9f27bc3417b4524d;
var $30a31a517a2d5cc7$export$db77ccec0bb4ccac;
var $30a31a517a2d5cc7$export$8392c0c9d3dcbd35;
var $30a31a517a2d5cc7$export$ffb0004e005737fa;
var $30a31a517a2d5cc7$export$b624eff549462981;
var $30a31a517a2d5cc7$export$7897aa7841a5380c;
var $30a31a517a2d5cc7$export$602eac185826482c;
var $30a31a517a2d5cc7$export$e2c29f18771995cb;
var $30a31a517a2d5cc7$export$5f8d39834fd61797;
var $30a31a517a2d5cc7$export$74bf444e3cd11ea5;
var $30a31a517a2d5cc7$export$92387174baf9b227;
var $30a31a517a2d5cc7$export$ec112efeb987d9c6;
var $30a31a517a2d5cc7$export$b706b080d889d2c9;
var $30a31a517a2d5cc7$export$5be5a87408f70ddc;
var $30a31a517a2d5cc7$export$45a5e7f76e0caa8d;
var $30a31a517a2d5cc7$export$455c2e768291efa6;
var $30a31a517a2d5cc7$export$9522e17588c12572;
var $30a31a517a2d5cc7$export$2110ac352bb060b9;
var $30a31a517a2d5cc7$export$56885ab8b9c456ab;
var $30a31a517a2d5cc7$export$d927fcb6adf8f9de;
var $30a31a517a2d5cc7$export$b82d16f27459e05a;
var $30a31a517a2d5cc7$export$522c17b4f5e123e8;
var $30a31a517a2d5cc7$export$1aabd8a0274ecfd6;
var $30a31a517a2d5cc7$export$9b621391a187a31a;
var $30a31a517a2d5cc7$export$f5bbd400c2f4426f;
'use strict';
var $30a31a517a2d5cc7$var$b = "function" === typeof Symbol && Symbol.for, $30a31a517a2d5cc7$var$c = $30a31a517a2d5cc7$var$b ? Symbol.for("react.element") : 60103, $30a31a517a2d5cc7$var$d = $30a31a517a2d5cc7$var$b ? Symbol.for("react.portal") : 60106, $30a31a517a2d5cc7$var$e = $30a31a517a2d5cc7$var$b ? Symbol.for("react.fragment") : 60107, $30a31a517a2d5cc7$var$f = $30a31a517a2d5cc7$var$b ? Symbol.for("react.strict_mode") : 60108, $30a31a517a2d5cc7$var$g = $30a31a517a2d5cc7$var$b ? Symbol.for("react.profiler") : 60114, $30a31a517a2d5cc7$var$h = $30a31a517a2d5cc7$var$b ? Symbol.for("react.provider") : 60109, $30a31a517a2d5cc7$var$k = $30a31a517a2d5cc7$var$b ? Symbol.for("react.context") : 60110, $30a31a517a2d5cc7$var$l = $30a31a517a2d5cc7$var$b ? Symbol.for("react.async_mode") : 60111, $30a31a517a2d5cc7$var$m = $30a31a517a2d5cc7$var$b ? Symbol.for("react.concurrent_mode") : 60111, $30a31a517a2d5cc7$var$n = $30a31a517a2d5cc7$var$b ? Symbol.for("react.forward_ref") : 60112, $30a31a517a2d5cc7$var$p = $30a31a517a2d5cc7$var$b ? Symbol.for("react.suspense") : 60113, $30a31a517a2d5cc7$var$q = $30a31a517a2d5cc7$var$b ? Symbol.for("react.suspense_list") : 60120, $30a31a517a2d5cc7$var$r = $30a31a517a2d5cc7$var$b ? Symbol.for("react.memo") : 60115, $30a31a517a2d5cc7$var$t = $30a31a517a2d5cc7$var$b ? Symbol.for("react.lazy") : 60116, $30a31a517a2d5cc7$var$v = $30a31a517a2d5cc7$var$b ? Symbol.for("react.block") : 60121, $30a31a517a2d5cc7$var$w = $30a31a517a2d5cc7$var$b ? Symbol.for("react.fundamental") : 60117, $30a31a517a2d5cc7$var$x = $30a31a517a2d5cc7$var$b ? Symbol.for("react.responder") : 60118, $30a31a517a2d5cc7$var$y = $30a31a517a2d5cc7$var$b ? Symbol.for("react.scope") : 60119;
function $30a31a517a2d5cc7$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $30a31a517a2d5cc7$var$c:
                switch(a = a.type, a){
                    case $30a31a517a2d5cc7$var$l:
                    case $30a31a517a2d5cc7$var$m:
                    case $30a31a517a2d5cc7$var$e:
                    case $30a31a517a2d5cc7$var$g:
                    case $30a31a517a2d5cc7$var$f:
                    case $30a31a517a2d5cc7$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $30a31a517a2d5cc7$var$k:
                            case $30a31a517a2d5cc7$var$n:
                            case $30a31a517a2d5cc7$var$t:
                            case $30a31a517a2d5cc7$var$r:
                            case $30a31a517a2d5cc7$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $30a31a517a2d5cc7$var$d:
                return u;
        }
    }
}
function $30a31a517a2d5cc7$var$A(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$m;
}
$30a31a517a2d5cc7$export$2b8d127b894957b9 = $30a31a517a2d5cc7$var$l;
$30a31a517a2d5cc7$export$cea3a54a6425200c = $30a31a517a2d5cc7$var$m;
$30a31a517a2d5cc7$export$a7c73072b1a182ae = $30a31a517a2d5cc7$var$k;
$30a31a517a2d5cc7$export$9f27bc3417b4524d = $30a31a517a2d5cc7$var$h;
$30a31a517a2d5cc7$export$db77ccec0bb4ccac = $30a31a517a2d5cc7$var$c;
$30a31a517a2d5cc7$export$8392c0c9d3dcbd35 = $30a31a517a2d5cc7$var$n;
$30a31a517a2d5cc7$export$ffb0004e005737fa = $30a31a517a2d5cc7$var$e;
$30a31a517a2d5cc7$export$b624eff549462981 = $30a31a517a2d5cc7$var$t;
$30a31a517a2d5cc7$export$7897aa7841a5380c = $30a31a517a2d5cc7$var$r;
$30a31a517a2d5cc7$export$602eac185826482c = $30a31a517a2d5cc7$var$d;
$30a31a517a2d5cc7$export$e2c29f18771995cb = $30a31a517a2d5cc7$var$g;
$30a31a517a2d5cc7$export$5f8d39834fd61797 = $30a31a517a2d5cc7$var$f;
$30a31a517a2d5cc7$export$74bf444e3cd11ea5 = $30a31a517a2d5cc7$var$p;
$30a31a517a2d5cc7$export$92387174baf9b227 = function(a) {
    return $30a31a517a2d5cc7$var$A(a) || $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$l;
};
$30a31a517a2d5cc7$export$ec112efeb987d9c6 = $30a31a517a2d5cc7$var$A;
$30a31a517a2d5cc7$export$b706b080d889d2c9 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$k;
};
$30a31a517a2d5cc7$export$5be5a87408f70ddc = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$h;
};
$30a31a517a2d5cc7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $30a31a517a2d5cc7$var$c;
};
$30a31a517a2d5cc7$export$455c2e768291efa6 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$n;
};
$30a31a517a2d5cc7$export$9522e17588c12572 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$e;
};
$30a31a517a2d5cc7$export$2110ac352bb060b9 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$t;
};
$30a31a517a2d5cc7$export$56885ab8b9c456ab = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$r;
};
$30a31a517a2d5cc7$export$d927fcb6adf8f9de = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$d;
};
$30a31a517a2d5cc7$export$b82d16f27459e05a = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$g;
};
$30a31a517a2d5cc7$export$522c17b4f5e123e8 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$f;
};
$30a31a517a2d5cc7$export$1aabd8a0274ecfd6 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$p;
};
$30a31a517a2d5cc7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $30a31a517a2d5cc7$var$e || a === $30a31a517a2d5cc7$var$m || a === $30a31a517a2d5cc7$var$g || a === $30a31a517a2d5cc7$var$f || a === $30a31a517a2d5cc7$var$p || a === $30a31a517a2d5cc7$var$q || "object" === typeof a && null !== a && (a.$$typeof === $30a31a517a2d5cc7$var$t || a.$$typeof === $30a31a517a2d5cc7$var$r || a.$$typeof === $30a31a517a2d5cc7$var$h || a.$$typeof === $30a31a517a2d5cc7$var$k || a.$$typeof === $30a31a517a2d5cc7$var$n || a.$$typeof === $30a31a517a2d5cc7$var$w || a.$$typeof === $30a31a517a2d5cc7$var$x || a.$$typeof === $30a31a517a2d5cc7$var$y || a.$$typeof === $30a31a517a2d5cc7$var$v);
};
$30a31a517a2d5cc7$export$f5bbd400c2f4426f = $30a31a517a2d5cc7$var$z;

});




parcelRegister("3hmGv", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $26348e4e5e8090bb$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $26348e4e5e8090bb$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $26348e4e5e8090bb$export$6f077d94b33a01aa; });
var $26348e4e5e8090bb$var$isBrowser = true;
function $26348e4e5e8090bb$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $26348e4e5e8090bb$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $26348e4e5e8090bb$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $26348e4e5e8090bb$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $26348e4e5e8090bb$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("9v6T8", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $6eac5a28f6e72cd5$export$6321afa313b251b5; });

var $171Pu = parcelRequire("171Pu");

var $amwve = parcelRequire("amwve");

var $cthCm = parcelRequire("cthCm");
var $6eac5a28f6e72cd5$var$isDevelopment = false;
var $6eac5a28f6e72cd5$var$hyphenateRegex = /[A-Z]|^ms/g;
var $6eac5a28f6e72cd5$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $6eac5a28f6e72cd5$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $6eac5a28f6e72cd5$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $6eac5a28f6e72cd5$var$processStyleName = /* #__PURE__ */ (0, $cthCm.default)(function(styleName) {
    return $6eac5a28f6e72cd5$var$isCustomProperty(styleName) ? styleName : styleName.replace($6eac5a28f6e72cd5$var$hyphenateRegex, '-$&').toLowerCase();
});
var $6eac5a28f6e72cd5$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($6eac5a28f6e72cd5$var$animationRegex, function(match, p1, p2) {
                $6eac5a28f6e72cd5$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $6eac5a28f6e72cd5$var$cursor
                };
                return p1;
            });
    }
    if ((0, $amwve.default)[key] !== 1 && !$6eac5a28f6e72cd5$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $6eac5a28f6e72cd5$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $6eac5a28f6e72cd5$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $6eac5a28f6e72cd5$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $6eac5a28f6e72cd5$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $6eac5a28f6e72cd5$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $6eac5a28f6e72cd5$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $6eac5a28f6e72cd5$var$cursor;
                var result = interpolation(mergedProps);
                $6eac5a28f6e72cd5$var$cursor = previousCursor;
                return $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $6eac5a28f6e72cd5$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($6eac5a28f6e72cd5$var$isProcessableValue(asString)) string += $6eac5a28f6e72cd5$var$processStyleName(key) + ":" + $6eac5a28f6e72cd5$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $6eac5a28f6e72cd5$var$isDevelopment) throw new Error($6eac5a28f6e72cd5$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($6eac5a28f6e72cd5$var$isProcessableValue(value[_i])) string += $6eac5a28f6e72cd5$var$processStyleName(key) + ":" + $6eac5a28f6e72cd5$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $6eac5a28f6e72cd5$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $6eac5a28f6e72cd5$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $6eac5a28f6e72cd5$var$cursor;
function $6eac5a28f6e72cd5$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $6eac5a28f6e72cd5$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $6eac5a28f6e72cd5$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $6eac5a28f6e72cd5$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $171Pu.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $6eac5a28f6e72cd5$var$cursor
    };
}

});
parcelRegister("171Pu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cf7dd2d70c55cf3$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $0cf7dd2d70c55cf3$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("amwve", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78b52bced097bc64$export$2e2bcd8739ae039; });
var $78b52bced097bc64$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("lSpak", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $fed2297e202d3641$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $fed2297e202d3641$export$811a713a7276cb9d; });

var $bh6RR = parcelRequire("bh6RR");
var $fed2297e202d3641$var$syncFallback = function syncFallback(create) {
    return create();
};
var $fed2297e202d3641$var$useInsertionEffect = $bh6RR.useInsertionEffect ? $bh6RR.useInsertionEffect : false;
var $fed2297e202d3641$export$db21c7ffa21794e7 = $fed2297e202d3641$var$useInsertionEffect || $fed2297e202d3641$var$syncFallback;
var $fed2297e202d3641$export$811a713a7276cb9d = $fed2297e202d3641$var$useInsertionEffect || $bh6RR.useLayoutEffect;

});





parcelRegister("k3eY1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e98fb29c5bc0ae79$export$2e2bcd8739ae039; });

var $c1Ell = parcelRequire("c1Ell");
'use client';
const $e98fb29c5bc0ae79$var$defaultTheme = (0, $c1Ell.default)();
var $e98fb29c5bc0ae79$export$2e2bcd8739ae039 = $e98fb29c5bc0ae79$var$defaultTheme;

});
parcelRegister("c1Ell", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c14df62f0995b25$export$2e2bcd8739ae039; });

var $b6aXv = parcelRequire("b6aXv");

var $hau7A = parcelRequire("hau7A");

var $75lq5 = parcelRequire("75lq5");
// eslint-disable-next-line consistent-return
function $8c14df62f0995b25$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $b6aXv.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $8c14df62f0995b25$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...other } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $75lq5.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $75lq5.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $8c14df62f0995b25$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $8c14df62f0995b25$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $hau7A.default)({
        ...other,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}

});
parcelRegister("b6aXv", function(module, exports) {

$parcel$export(module.exports, "light", function () { return $8148c1740213a627$export$a43af521ac8c3202; });
$parcel$export(module.exports, "dark", function () { return $8148c1740213a627$export$55ce6f3a06c59543; });
$parcel$export(module.exports, "default", function () { return $8148c1740213a627$export$2e2bcd8739ae039; });

var $avV9A = parcelRequire("avV9A");

var $5syur = parcelRequire("5syur");

var $7ITGE = parcelRequire("7ITGE");

var $c0QtN = parcelRequire("c0QtN");

var $jwQN6 = parcelRequire("jwQN6");

var $6boUu = parcelRequire("6boUu");

var $clIah = parcelRequire("clIah");

var $bBnsq = parcelRequire("bBnsq");

var $5epdk = parcelRequire("5epdk");

var $bNIVw = parcelRequire("bNIVw");

var $ft4eo = parcelRequire("ft4eo");
function $8148c1740213a627$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $c0QtN.default).white,
            default: (0, $c0QtN.default).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $8148c1740213a627$export$a43af521ac8c3202 = $8148c1740213a627$var$getLight();
function $8148c1740213a627$var$getDark() {
    return {
        text: {
            primary: (0, $c0QtN.default).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $c0QtN.default).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $8148c1740213a627$export$55ce6f3a06c59543 = $8148c1740213a627$var$getDark();
function $8148c1740213a627$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $7ITGE.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $7ITGE.darken)(intent.main, tonalOffsetDark);
    }
}
function $8148c1740213a627$var$mixLightOrDark(colorSpace, intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = `color-mix(in ${colorSpace}, ${intent.main}, #fff ${(tonalOffsetLight * 100).toFixed(0)}%)`;
        else if (direction === 'dark') intent.dark = `color-mix(in ${colorSpace}, ${intent.main}, #000 ${(tonalOffsetDark * 100).toFixed(0)}%)`;
    }
}
function $8148c1740213a627$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $5epdk.default)[200],
        light: (0, $5epdk.default)[50],
        dark: (0, $5epdk.default)[400]
    };
    return {
        main: (0, $5epdk.default)[700],
        light: (0, $5epdk.default)[400],
        dark: (0, $5epdk.default)[800]
    };
}
function $8148c1740213a627$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $6boUu.default)[200],
        light: (0, $6boUu.default)[50],
        dark: (0, $6boUu.default)[400]
    };
    return {
        main: (0, $6boUu.default)[500],
        light: (0, $6boUu.default)[300],
        dark: (0, $6boUu.default)[700]
    };
}
function $8148c1740213a627$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $clIah.default)[500],
        light: (0, $clIah.default)[300],
        dark: (0, $clIah.default)[700]
    };
    return {
        main: (0, $clIah.default)[700],
        light: (0, $clIah.default)[400],
        dark: (0, $clIah.default)[800]
    };
}
function $8148c1740213a627$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $bNIVw.default)[400],
        light: (0, $bNIVw.default)[300],
        dark: (0, $bNIVw.default)[700]
    };
    return {
        main: (0, $bNIVw.default)[700],
        light: (0, $bNIVw.default)[500],
        dark: (0, $bNIVw.default)[900]
    };
}
function $8148c1740213a627$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ft4eo.default)[400],
        light: (0, $ft4eo.default)[300],
        dark: (0, $ft4eo.default)[700]
    };
    return {
        main: (0, $ft4eo.default)[800],
        light: (0, $ft4eo.default)[500],
        dark: (0, $ft4eo.default)[900]
    };
}
function $8148c1740213a627$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $bBnsq.default)[400],
        light: (0, $bBnsq.default)[300],
        dark: (0, $bBnsq.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $bBnsq.default)[500],
        dark: (0, $bBnsq.default)[900]
    };
}
function $8148c1740213a627$export$b6e2ca4581a735cb(background) {
    return `oklch(from ${background} var(--__l) 0 h / var(--__a))`;
}
function $8148c1740213a627$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, colorSpace: colorSpace, ...other } = palette;
    const primary = palette.primary || $8148c1740213a627$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $8148c1740213a627$var$getDefaultSecondary(mode);
    const error = palette.error || $8148c1740213a627$var$getDefaultError(mode);
    const info = palette.info || $8148c1740213a627$var$getDefaultInfo(mode);
    const success = palette.success || $8148c1740213a627$var$getDefaultSuccess(mode);
    const warning = palette.warning || $8148c1740213a627$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        if (colorSpace) return $8148c1740213a627$export$b6e2ca4581a735cb(background);
        const contrastText = (0, $7ITGE.getContrastRatio)(background, $8148c1740213a627$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $8148c1740213a627$export$55ce6f3a06c59543.text.primary : $8148c1740213a627$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $avV9A.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $avV9A.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        if (colorSpace) {
            $8148c1740213a627$var$mixLightOrDark(colorSpace, color, 'light', lightShade, tonalOffset);
            $8148c1740213a627$var$mixLightOrDark(colorSpace, color, 'dark', darkShade, tonalOffset);
        } else {
            $8148c1740213a627$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
            $8148c1740213a627$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        }
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $8148c1740213a627$var$getLight();
    else if (mode === 'dark') modeHydrated = $8148c1740213a627$var$getDark();
    const paletteOutput = (0, $5syur.default)({
        // A collection of common colors.
        common: {
            ...(0, $c0QtN.default)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $jwQN6.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

});
parcelRegister("7ITGE", function(module, exports) {

$parcel$export(module.exports, "private_safeColorChannel", function () { return $59f7d6bdd52e4438$export$427365fc3db6fc5e; });
$parcel$export(module.exports, "hslToRgb", function () { return $59f7d6bdd52e4438$export$29fb7152bd3f781a; });
$parcel$export(module.exports, "getContrastRatio", function () { return $59f7d6bdd52e4438$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $59f7d6bdd52e4438$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "private_safeAlpha", function () { return $59f7d6bdd52e4438$export$34109543fc7f43f8; });
$parcel$export(module.exports, "darken", function () { return $59f7d6bdd52e4438$export$4b073707ff63303; });
$parcel$export(module.exports, "private_safeDarken", function () { return $59f7d6bdd52e4438$export$eaaef2dca3e9e512; });
$parcel$export(module.exports, "lighten", function () { return $59f7d6bdd52e4438$export$c0816ed86df316af; });
$parcel$export(module.exports, "private_safeLighten", function () { return $59f7d6bdd52e4438$export$aeeda94ef1d01275; });
$parcel$export(module.exports, "emphasize", function () { return $59f7d6bdd52e4438$export$e665714f76e581fd; });
$parcel$export(module.exports, "private_safeEmphasize", function () { return $59f7d6bdd52e4438$export$11bb74ba10c85505; });

var $avV9A = parcelRequire("avV9A");

var $8fhtc = parcelRequire("8fhtc");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $59f7d6bdd52e4438$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $8fhtc.default)(value, min, max);
}
function $59f7d6bdd52e4438$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $59f7d6bdd52e4438$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $59f7d6bdd52e4438$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $59f7d6bdd52e4438$export$677b39864803984e($59f7d6bdd52e4438$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $avV9A.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $avV9A.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $59f7d6bdd52e4438$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $59f7d6bdd52e4438$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $59f7d6bdd52e4438$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $59f7d6bdd52e4438$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $59f7d6bdd52e4438$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $59f7d6bdd52e4438$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $59f7d6bdd52e4438$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$59f7d6bdd52e4438$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $59f7d6bdd52e4438$export$29fb7152bd3f781a(color) {
    color = $59f7d6bdd52e4438$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $59f7d6bdd52e4438$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $59f7d6bdd52e4438$export$c852d90bf7403b62(color) {
    color = $59f7d6bdd52e4438$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $59f7d6bdd52e4438$export$677b39864803984e($59f7d6bdd52e4438$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $59f7d6bdd52e4438$export$d061e26956a60b0a(foreground, background) {
    const lumA = $59f7d6bdd52e4438$export$c852d90bf7403b62(foreground);
    const lumB = $59f7d6bdd52e4438$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $59f7d6bdd52e4438$export$58f0f39f63f3cf42(color, value) {
    color = $59f7d6bdd52e4438$export$677b39864803984e(color);
    value = $59f7d6bdd52e4438$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $59f7d6bdd52e4438$export$211a73f2b8c10ce4(color);
}
function $59f7d6bdd52e4438$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $59f7d6bdd52e4438$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $59f7d6bdd52e4438$export$4b073707ff63303(color, coefficient) {
    color = $59f7d6bdd52e4438$export$677b39864803984e(color);
    coefficient = $59f7d6bdd52e4438$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $59f7d6bdd52e4438$export$211a73f2b8c10ce4(color);
}
function $59f7d6bdd52e4438$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $59f7d6bdd52e4438$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $59f7d6bdd52e4438$export$c0816ed86df316af(color, coefficient) {
    color = $59f7d6bdd52e4438$export$677b39864803984e(color);
    coefficient = $59f7d6bdd52e4438$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $59f7d6bdd52e4438$export$211a73f2b8c10ce4(color);
}
function $59f7d6bdd52e4438$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $59f7d6bdd52e4438$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $59f7d6bdd52e4438$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $59f7d6bdd52e4438$export$c852d90bf7403b62(color) > 0.5 ? $59f7d6bdd52e4438$export$4b073707ff63303(color, coefficient) : $59f7d6bdd52e4438$export$c0816ed86df316af(color, coefficient);
}
function $59f7d6bdd52e4438$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $59f7d6bdd52e4438$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $59f7d6bdd52e4438$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $59f7d6bdd52e4438$export$677b39864803984e(background);
    const overlayColor = $59f7d6bdd52e4438$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $59f7d6bdd52e4438$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("8fhtc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $600d469f4ea2b960$export$2e2bcd8739ae039; });
function $600d469f4ea2b960$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $600d469f4ea2b960$export$2e2bcd8739ae039 = $600d469f4ea2b960$var$clamp;

});


parcelRegister("c0QtN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bee31774eaee893$export$2e2bcd8739ae039; });
const $8bee31774eaee893$var$common = {
    black: '#000',
    white: '#fff'
};
var $8bee31774eaee893$export$2e2bcd8739ae039 = $8bee31774eaee893$var$common;

});

parcelRegister("jwQN6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e379f4a65fa1b210$export$2e2bcd8739ae039; });
const $e379f4a65fa1b210$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $e379f4a65fa1b210$export$2e2bcd8739ae039 = $e379f4a65fa1b210$var$grey;

});

parcelRegister("6boUu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $480717c8ba3ceea4$export$2e2bcd8739ae039; });
const $480717c8ba3ceea4$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $480717c8ba3ceea4$export$2e2bcd8739ae039 = $480717c8ba3ceea4$var$purple;

});

parcelRegister("clIah", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fd9b464a113c294$export$2e2bcd8739ae039; });
const $8fd9b464a113c294$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $8fd9b464a113c294$export$2e2bcd8739ae039 = $8fd9b464a113c294$var$red;

});

parcelRegister("bBnsq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87255891923663c1$export$2e2bcd8739ae039; });
const $87255891923663c1$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $87255891923663c1$export$2e2bcd8739ae039 = $87255891923663c1$var$orange;

});

parcelRegister("5epdk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cf1d188dd181d19$export$2e2bcd8739ae039; });
const $3cf1d188dd181d19$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $3cf1d188dd181d19$export$2e2bcd8739ae039 = $3cf1d188dd181d19$var$blue;

});

parcelRegister("bNIVw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89771ed696f4e5a4$export$2e2bcd8739ae039; });
const $89771ed696f4e5a4$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $89771ed696f4e5a4$export$2e2bcd8739ae039 = $89771ed696f4e5a4$var$lightBlue;

});

parcelRegister("ft4eo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b42cd8a7bbaabf1c$export$2e2bcd8739ae039; });
const $b42cd8a7bbaabf1c$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $b42cd8a7bbaabf1c$export$2e2bcd8739ae039 = $b42cd8a7bbaabf1c$var$green;

});


parcelRegister("hau7A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7fabc54c7d3e9ac$export$2e2bcd8739ae039; });

var $avV9A = parcelRequire("avV9A");

var $5syur = parcelRequire("5syur");

var $b6RkN = parcelRequire("b6RkN");
var $f0BT0 = parcelRequire("f0BT0");

var $l0eT8 = parcelRequire("l0eT8");

var $iqLQR = parcelRequire("iqLQR");
var $jKm2e = parcelRequire("jKm2e");
var $hcnSG = parcelRequire("hcnSG");

var $f9NmP = parcelRequire("f9NmP");
var $8RAwN = parcelRequire("8RAwN");

var $7ITGE = parcelRequire("7ITGE");

var $75lq5 = parcelRequire("75lq5");

var $8HiDB = parcelRequire("8HiDB");

var $e3L84 = parcelRequire("e3L84");

var $3S5ey = parcelRequire("3S5ey");

var $evelv = parcelRequire("evelv");

var $b6aXv = parcelRequire("b6aXv");
function $c7fabc54c7d3e9ac$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $c7fabc54c7d3e9ac$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $c7fabc54c7d3e9ac$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $7ITGE.hslToRgb)(color);
}
function $c7fabc54c7d3e9ac$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $7ITGE.private_safeColorChannel)($c7fabc54c7d3e9ac$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $c7fabc54c7d3e9ac$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $c7fabc54c7d3e9ac$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $c7fabc54c7d3e9ac$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $f0BT0.default)(cssVarPrefix);
function $c7fabc54c7d3e9ac$var$attachColorScheme(colorSpace, colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $8HiDB.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            },
            colorSpace: colorSpace
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $75lq5.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        },
        colorSpace: colorSpace
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $8HiDB.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $8HiDB.getOverlays)(mode)
    };
    return muiTheme;
}
function $c7fabc54c7d3e9ac$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', nativeColor: nativeColor = false, shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $e3L84.default), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $c7fabc54c7d3e9ac$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $avV9A.default)(21, defaultColorScheme));
    // The reason to use `oklch` is that it is the most perceptually uniform color space and widely supported.
    let colorSpace;
    if (nativeColor) colorSpace = 'oklch';
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $c7fabc54c7d3e9ac$var$attachColorScheme(colorSpace, colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $c7fabc54c7d3e9ac$var$attachColorScheme(colorSpace, colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $c7fabc54c7d3e9ac$var$attachColorScheme(colorSpace, colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $hcnSG.default)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $c7fabc54c7d3e9ac$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $c7fabc54c7d3e9ac$var$setColor(palette.common, 'background', '#fff');
            $c7fabc54c7d3e9ac$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $c7fabc54c7d3e9ac$var$setColor(palette.common, 'background', '#000');
            $c7fabc54c7d3e9ac$var$setColor(palette.common, 'onBackground', '#fff');
        }
        function colorMix(method, color, coefficient) {
            if (colorSpace) {
                let mixer;
                if (method === (0, $7ITGE.private_safeAlpha)) mixer = `transparent ${((1 - coefficient) * 100).toFixed(0)}%`;
                if (method === (0, $7ITGE.private_safeDarken)) mixer = `#000 ${(coefficient * 100).toFixed(0)}%`;
                if (method === (0, $7ITGE.private_safeLighten)) mixer = `#fff ${(coefficient * 100).toFixed(0)}%`;
                return `color-mix(in ${colorSpace}, ${color}, ${mixer})`;
            }
            return method(color, coefficient);
        }
        // assign component variables
        $c7fabc54c7d3e9ac$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'errorColor', colorMix((0, $7ITGE.private_safeDarken), palette.error.light, 0.6));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'infoColor', colorMix((0, $7ITGE.private_safeDarken), palette.info.light, 0.6));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'successColor', colorMix((0, $7ITGE.private_safeDarken), palette.success.light, 0.6));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'warningColor', colorMix((0, $7ITGE.private_safeDarken), palette.warning.light, 0.6));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'errorFilledColor', $c7fabc54c7d3e9ac$var$silent(()=>palette.getContrastText(palette.error.main)));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'infoFilledColor', $c7fabc54c7d3e9ac$var$silent(()=>palette.getContrastText(palette.info.main)));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'successFilledColor', $c7fabc54c7d3e9ac$var$silent(()=>palette.getContrastText(palette.success.main)));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'warningFilledColor', $c7fabc54c7d3e9ac$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $7ITGE.private_safeLighten), palette.error.light, 0.9));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $7ITGE.private_safeLighten), palette.info.light, 0.9));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $7ITGE.private_safeLighten), palette.success.light, 0.9));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $7ITGE.private_safeLighten), palette.warning.light, 0.9));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $c7fabc54c7d3e9ac$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $c7fabc54c7d3e9ac$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $c7fabc54c7d3e9ac$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $c7fabc54c7d3e9ac$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $c7fabc54c7d3e9ac$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $7ITGE.private_safeLighten), palette.primary.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $7ITGE.private_safeLighten), palette.secondary.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $7ITGE.private_safeLighten), palette.error.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $7ITGE.private_safeLighten), palette.info.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $7ITGE.private_safeLighten), palette.success.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $7ITGE.private_safeLighten), palette.warning.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $7ITGE.private_safeAlpha), palette.text.primary, 0.11) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $c7fabc54c7d3e9ac$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $7ITGE.private_safeLighten), palette.primary.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $7ITGE.private_safeLighten), palette.secondary.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $7ITGE.private_safeLighten), palette.error.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $7ITGE.private_safeLighten), palette.info.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.Slider, 'successTrack', colorMix((0, $7ITGE.private_safeLighten), palette.success.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $7ITGE.private_safeLighten), palette.warning.main, 0.62));
            const snackbarContentBackground = colorSpace ? colorMix((0, $7ITGE.private_safeDarken), palette.background.default, 0.6825) // use `0.6825` instead of `0.8` to match the contrast ratio of JS implementation
             : (0, $7ITGE.private_safeEmphasize)(palette.background.default, 0.8);
            $c7fabc54c7d3e9ac$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $c7fabc54c7d3e9ac$var$setColor(palette.SnackbarContent, 'color', $c7fabc54c7d3e9ac$var$silent(()=>colorSpace ? (0, $b6aXv.dark).text.primary : palette.getContrastText(snackbarContentBackground)));
            $c7fabc54c7d3e9ac$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $7ITGE.private_safeEmphasize)(palette.background.paper, 0.15));
            $c7fabc54c7d3e9ac$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $c7fabc54c7d3e9ac$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $7ITGE.private_safeLighten), palette.primary.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $7ITGE.private_safeLighten), palette.secondary.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $7ITGE.private_safeLighten), palette.error.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $7ITGE.private_safeLighten), palette.info.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $7ITGE.private_safeLighten), palette.success.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $7ITGE.private_safeLighten), palette.warning.main, 0.62));
            $c7fabc54c7d3e9ac$var$setColor(palette.TableCell, 'border', colorMix((0, $7ITGE.private_safeLighten), colorMix((0, $7ITGE.private_safeAlpha), palette.divider, 1), 0.88));
            $c7fabc54c7d3e9ac$var$setColor(palette.Tooltip, 'bg', colorMix((0, $7ITGE.private_safeAlpha), palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'errorColor', colorMix((0, $7ITGE.private_safeLighten), palette.error.light, 0.6));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'infoColor', colorMix((0, $7ITGE.private_safeLighten), palette.info.light, 0.6));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'successColor', colorMix((0, $7ITGE.private_safeLighten), palette.success.light, 0.6));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'warningColor', colorMix((0, $7ITGE.private_safeLighten), palette.warning.light, 0.6));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'errorFilledColor', $c7fabc54c7d3e9ac$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'infoFilledColor', $c7fabc54c7d3e9ac$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'successFilledColor', $c7fabc54c7d3e9ac$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'warningFilledColor', $c7fabc54c7d3e9ac$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $7ITGE.private_safeDarken), palette.error.light, 0.9));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $7ITGE.private_safeDarken), palette.info.light, 0.9));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $7ITGE.private_safeDarken), palette.success.light, 0.9));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $7ITGE.private_safeDarken), palette.warning.light, 0.9));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $c7fabc54c7d3e9ac$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $c7fabc54c7d3e9ac$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $c7fabc54c7d3e9ac$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $c7fabc54c7d3e9ac$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $c7fabc54c7d3e9ac$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $c7fabc54c7d3e9ac$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $c7fabc54c7d3e9ac$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $c7fabc54c7d3e9ac$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $7ITGE.private_safeDarken), palette.primary.main, 0.5));
            $c7fabc54c7d3e9ac$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $7ITGE.private_safeDarken), palette.secondary.main, 0.5));
            $c7fabc54c7d3e9ac$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $7ITGE.private_safeDarken), palette.error.main, 0.5));
            $c7fabc54c7d3e9ac$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $7ITGE.private_safeDarken), palette.info.main, 0.5));
            $c7fabc54c7d3e9ac$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $7ITGE.private_safeDarken), palette.success.main, 0.5));
            $c7fabc54c7d3e9ac$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $7ITGE.private_safeDarken), palette.warning.main, 0.5));
            $c7fabc54c7d3e9ac$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $7ITGE.private_safeAlpha), palette.text.primary, 0.13) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $c7fabc54c7d3e9ac$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $7ITGE.private_safeDarken), palette.primary.main, 0.5));
            $c7fabc54c7d3e9ac$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $7ITGE.private_safeDarken), palette.secondary.main, 0.5));
            $c7fabc54c7d3e9ac$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $7ITGE.private_safeDarken), palette.error.main, 0.5));
            $c7fabc54c7d3e9ac$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $7ITGE.private_safeDarken), palette.info.main, 0.5));
            $c7fabc54c7d3e9ac$var$setColor(palette.Slider, 'successTrack', colorMix((0, $7ITGE.private_safeDarken), palette.success.main, 0.5));
            $c7fabc54c7d3e9ac$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $7ITGE.private_safeDarken), palette.warning.main, 0.5));
            const snackbarContentBackground = colorSpace ? colorMix((0, $7ITGE.private_safeLighten), palette.background.default, 0.985) // use `0.985` instead of `0.98` to match the contrast ratio of JS implementation
             : (0, $7ITGE.private_safeEmphasize)(palette.background.default, 0.98);
            $c7fabc54c7d3e9ac$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $c7fabc54c7d3e9ac$var$setColor(palette.SnackbarContent, 'color', $c7fabc54c7d3e9ac$var$silent(()=>colorSpace ? (0, $b6aXv.light).text.primary : palette.getContrastText(snackbarContentBackground)));
            $c7fabc54c7d3e9ac$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $7ITGE.private_safeEmphasize)(palette.background.paper, 0.15));
            $c7fabc54c7d3e9ac$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $c7fabc54c7d3e9ac$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $c7fabc54c7d3e9ac$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $7ITGE.private_safeDarken), palette.primary.main, 0.55));
            $c7fabc54c7d3e9ac$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $7ITGE.private_safeDarken), palette.secondary.main, 0.55));
            $c7fabc54c7d3e9ac$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $7ITGE.private_safeDarken), palette.error.main, 0.55));
            $c7fabc54c7d3e9ac$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $7ITGE.private_safeDarken), palette.info.main, 0.55));
            $c7fabc54c7d3e9ac$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $7ITGE.private_safeDarken), palette.success.main, 0.55));
            $c7fabc54c7d3e9ac$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $7ITGE.private_safeDarken), palette.warning.main, 0.55));
            $c7fabc54c7d3e9ac$var$setColor(palette.TableCell, 'border', colorMix((0, $7ITGE.private_safeDarken), colorMix((0, $7ITGE.private_safeAlpha), palette.divider, 1), 0.68));
            $c7fabc54c7d3e9ac$var$setColor(palette.Tooltip, 'bg', colorMix((0, $7ITGE.private_safeAlpha), palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $c7fabc54c7d3e9ac$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $c7fabc54c7d3e9ac$var$setColorChannel(palette.background, 'paper');
        $c7fabc54c7d3e9ac$var$setColorChannel(palette.common, 'background');
        $c7fabc54c7d3e9ac$var$setColorChannel(palette.common, 'onBackground');
        $c7fabc54c7d3e9ac$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $c7fabc54c7d3e9ac$var$setColor(palette[color], 'mainChannel', (0, $7ITGE.private_safeColorChannel)($c7fabc54c7d3e9ac$var$toRgb(colors.main)));
                if (colors.light) $c7fabc54c7d3e9ac$var$setColor(palette[color], 'lightChannel', (0, $7ITGE.private_safeColorChannel)($c7fabc54c7d3e9ac$var$toRgb(colors.light)));
                if (colors.dark) $c7fabc54c7d3e9ac$var$setColor(palette[color], 'darkChannel', (0, $7ITGE.private_safeColorChannel)($c7fabc54c7d3e9ac$var$toRgb(colors.dark)));
                if (colors.contrastText) $c7fabc54c7d3e9ac$var$setColor(palette[color], 'contrastTextChannel', (0, $7ITGE.private_safeColorChannel)($c7fabc54c7d3e9ac$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $c7fabc54c7d3e9ac$var$setColorChannel(palette[color], 'primary');
                    $c7fabc54c7d3e9ac$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $c7fabc54c7d3e9ac$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $c7fabc54c7d3e9ac$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $5syur.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $3S5ey.default)(theme),
        enableContrastVars: nativeColor
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $jKm2e.default)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $b6RkN.default)(input.spacing, (0, $l0eT8.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $iqLQR.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $8RAwN.default),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $f9NmP.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $evelv.stringifyTheme); // for Pigment CSS integration
    return theme;
}

});
parcelRegister("f0BT0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aed43e8423def469$export$2e2bcd8739ae039; });
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $aed43e8423def469$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("iqLQR", function(module, exports) {

$parcel$export(module.exports, "createGetColorSchemeSelector", function () { return $d6afc607569cbde9$export$858538ff6c0d421d; });
/* eslint-disable import/prefer-default-export */ function $d6afc607569cbde9$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});

parcelRegister("jKm2e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e60367e33ea06d6a$export$2e2bcd8739ae039; });

var $5syur = parcelRequire("5syur");

var $9hX5M = parcelRequire("9hX5M");
function $e60367e33ea06d6a$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector, enableContrastVars: enableContrastVars } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $9hX5M.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $9hX5M.default)(scheme, parserConfig);
        themeVars = (0, $5syur.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $9hX5M.default)(defaultScheme, parserConfig);
        themeVars = (0, $5syur.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $5syur.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        if (enableContrastVars) stylesheets.push({
            ':root': {
                // use double underscore to indicate that these are private variables
                '--__l-threshold': '0.7',
                '--__l': 'clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)',
                '--__a': 'clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)' // 0.87 is the default alpha value for black text.
            }
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $e60367e33ea06d6a$export$2e2bcd8739ae039 = $e60367e33ea06d6a$var$prepareCssVars;

});
parcelRegister("9hX5M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c338a0fae3ffe7a$export$2e2bcd8739ae039; });
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $6c338a0fae3ffe7a$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $6c338a0fae3ffe7a$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $6c338a0fae3ffe7a$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $6c338a0fae3ffe7a$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $6c338a0fae3ffe7a$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $6c338a0fae3ffe7a$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $6c338a0fae3ffe7a$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $6c338a0fae3ffe7a$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});


parcelRegister("hcnSG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c85614ec18932740$export$2e2bcd8739ae039; });
function $c85614ec18932740$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

});

parcelRegister("75lq5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52899d8ba90eac0c$export$2e2bcd8739ae039; });

var $avV9A = parcelRequire("avV9A");

var $5syur = parcelRequire("5syur");

var $f9NmP = parcelRequire("f9NmP");
var $8RAwN = parcelRequire("8RAwN");

var $1zcRx = parcelRequire("1zcRx");

var $7ITGE = parcelRequire("7ITGE");


var $kWgrs = parcelRequire("kWgrs");

var $b6aXv = parcelRequire("b6aXv");

var $hyCtF = parcelRequire("hyCtF");

var $VUHyc = parcelRequire("VUHyc");

var $gNPqJ = parcelRequire("gNPqJ");

var $eCH7b = parcelRequire("eCH7b");

var $evelv = parcelRequire("evelv");
function $52899d8ba90eac0c$var$coefficientToPercentage(coefficient) {
    if (typeof coefficient === 'number') return `${(coefficient * 100).toFixed(0)}%`;
    return `calc((${coefficient}) * 100%)`;
}
// This can be removed when moved to `color-mix()` entirely.
const $52899d8ba90eac0c$var$parseAddition = (str)=>{
    if (!Number.isNaN(+str)) return +str;
    const numbers = str.match(/\d*\.?\d+/g);
    if (!numbers) return 0;
    let sum = 0;
    for(let i = 0; i < numbers.length; i += 1)sum += +numbers[i];
    return sum;
};
function $52899d8ba90eac0c$var$attachColorManipulators(theme) {
    Object.assign(theme, {
        alpha (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `oklch(from ${color} l c h / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            if (obj.vars) // To preserve the behavior of the CSS theme variables
            // In the future, this could be replaced by `color-mix` (when https://caniuse.com/?search=color-mix reaches 95%).
            return `rgba(${color.replace(/var\(--([^,\s)]+)(?:,[^)]+)?\)+/g, 'var(--$1Channel)')} / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            return (0, $7ITGE.alpha)(color, $52899d8ba90eac0c$var$parseAddition(coefficient));
        },
        lighten (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #fff ${$52899d8ba90eac0c$var$coefficientToPercentage(coefficient)})`;
            return (0, $7ITGE.lighten)(color, coefficient);
        },
        darken (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #000 ${$52899d8ba90eac0c$var$coefficientToPercentage(coefficient)})`;
            return (0, $7ITGE.darken)(color, coefficient);
        }
    });
}
function $52899d8ba90eac0c$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, colorSpace: colorSpace, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $avV9A.default)(20));
    const palette = (0, $b6aXv.default)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    const systemTheme = (0, $1zcRx.default)(options);
    let muiTheme = (0, $5syur.default)(systemTheme, {
        mixins: (0, $kWgrs.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $VUHyc.default).slice(),
        typography: (0, $hyCtF.default)(palette, typographyInput),
        transitions: (0, $gNPqJ.default)(transitionsInput),
        zIndex: {
            ...(0, $eCH7b.default)
        }
    });
    muiTheme = (0, $5syur.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $5syur.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $8RAwN.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $f9NmP.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $evelv.stringifyTheme); // for Pigment CSS integration
    $52899d8ba90eac0c$var$attachColorManipulators(muiTheme);
    return muiTheme;
}
var $52899d8ba90eac0c$export$2e2bcd8739ae039 = $52899d8ba90eac0c$var$createThemeNoVars;

});
parcelRegister("kWgrs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3e5fa75ad269072$export$2e2bcd8739ae039; });
function $f3e5fa75ad269072$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("hyCtF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc83757918165c9b$export$2e2bcd8739ae039; });

var $5syur = parcelRequire("5syur");
function $cc83757918165c9b$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $cc83757918165c9b$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $cc83757918165c9b$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $cc83757918165c9b$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $cc83757918165c9b$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $cc83757918165c9b$var$defaultFontFamily ? {
                letterSpacing: `${$cc83757918165c9b$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $cc83757918165c9b$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $cc83757918165c9b$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $5syur.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("VUHyc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ae14eb54a84d710$export$2e2bcd8739ae039; });
const $0ae14eb54a84d710$var$shadowKeyUmbraOpacity = 0.2;
const $0ae14eb54a84d710$var$shadowKeyPenumbraOpacity = 0.14;
const $0ae14eb54a84d710$var$shadowAmbientShadowOpacity = 0.12;
function $0ae14eb54a84d710$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$0ae14eb54a84d710$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$0ae14eb54a84d710$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$0ae14eb54a84d710$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $0ae14eb54a84d710$var$shadows = [
    'none',
    $0ae14eb54a84d710$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $0ae14eb54a84d710$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $0ae14eb54a84d710$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $0ae14eb54a84d710$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $0ae14eb54a84d710$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $0ae14eb54a84d710$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $0ae14eb54a84d710$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $0ae14eb54a84d710$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $0ae14eb54a84d710$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $0ae14eb54a84d710$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $0ae14eb54a84d710$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $0ae14eb54a84d710$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $0ae14eb54a84d710$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $0ae14eb54a84d710$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $0ae14eb54a84d710$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $0ae14eb54a84d710$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $0ae14eb54a84d710$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $0ae14eb54a84d710$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $0ae14eb54a84d710$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $0ae14eb54a84d710$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $0ae14eb54a84d710$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $0ae14eb54a84d710$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $0ae14eb54a84d710$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $0ae14eb54a84d710$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $0ae14eb54a84d710$export$2e2bcd8739ae039 = $0ae14eb54a84d710$var$shadows;

});

parcelRegister("gNPqJ", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $c3b91dea892aaae0$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $c3b91dea892aaae0$export$2e2bcd8739ae039; });
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $c3b91dea892aaae0$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $c3b91dea892aaae0$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $c3b91dea892aaae0$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $c3b91dea892aaae0$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $c3b91dea892aaae0$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$c3b91dea892aaae0$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$c3b91dea892aaae0$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $c3b91dea892aaae0$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $c3b91dea892aaae0$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $c3b91dea892aaae0$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("eCH7b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa560f050bd29cd1$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $aa560f050bd29cd1$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $aa560f050bd29cd1$export$2e2bcd8739ae039 = $aa560f050bd29cd1$var$zIndex;

});

parcelRegister("evelv", function(module, exports) {

$parcel$export(module.exports, "stringifyTheme", function () { return $a8ef16b823347b9b$export$32c2afa5f91892aa; });
/* eslint-disable import/prefer-default-export */ 
var $5syur = parcelRequire("5syur");
function $a8ef16b823347b9b$var$isSerializable(val) {
    return (0, $5syur.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $a8ef16b823347b9b$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$a8ef16b823347b9b$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $5syur.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("8HiDB", function(module, exports) {

$parcel$export(module.exports, "getOpacity", function () { return $6550cbf8cd7bf664$export$c85e0347fceb69ba; });
$parcel$export(module.exports, "getOverlays", function () { return $6550cbf8cd7bf664$export$dd191566510330d3; });
$parcel$export(module.exports, "default", function () { return $6550cbf8cd7bf664$export$2e2bcd8739ae039; });

var $b6aXv = parcelRequire("b6aXv");

var $6mpQq = parcelRequire("6mpQq");
const $6550cbf8cd7bf664$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $6mpQq.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $6550cbf8cd7bf664$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $6550cbf8cd7bf664$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $6550cbf8cd7bf664$var$defaultDarkOverlays : [];
}
function $6550cbf8cd7bf664$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, colorSpace: colorSpace, ...other } = options;
    // need to cast because `colorSpace` is considered internal at the moment.
    const palette = (0, $b6aXv.default)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    return {
        palette: palette,
        opacity: {
            ...$6550cbf8cd7bf664$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $6550cbf8cd7bf664$export$dd191566510330d3(palette.mode),
        ...other
    };
}

});
parcelRegister("6mpQq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a18d8544edc226b$export$2e2bcd8739ae039; });
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $4a18d8544edc226b$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("e3L84", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3c5e75edb2f3360$export$2e2bcd8739ae039; });
function $a3c5e75edb2f3360$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

});

parcelRegister("3S5ey", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d1a7993bded0edf$export$2e2bcd8739ae039; });

var $jTYRJ = parcelRequire("jTYRJ");
var $2d1a7993bded0edf$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $jTYRJ.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };

});
parcelRegister("jTYRJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7d25e0670a75e53$export$2e2bcd8739ae039; });
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $e7d25e0670a75e53$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $e7d25e0670a75e53$export$2e2bcd8739ae039 = $e7d25e0670a75e53$var$excludeVariablesFromRoot;

});





parcelRegister("2N3YN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20833ea130c7e19e$export$2e2bcd8739ae039; });
var $20833ea130c7e19e$export$2e2bcd8739ae039 = '$$material';

});


parcelRegister("lVG0j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff6f80fcd1cc7908$export$2e2bcd8739ae039; });


var $1EIH3 = parcelRequire("1EIH3");

var $k3eY1 = parcelRequire("k3eY1");

var $2N3YN = parcelRequire("2N3YN");

var $ih19M = parcelRequire("ih19M");
'use client';
function $ff6f80fcd1cc7908$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1EIH3.default), {
        ...props,
        defaultTheme: (0, $k3eY1.default),
        themeId: (0, $2N3YN.default)
    });
}
var $ff6f80fcd1cc7908$export$2e2bcd8739ae039 = $ff6f80fcd1cc7908$var$GlobalStyles;

});
parcelRegister("1EIH3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $134c32104760d758$export$2e2bcd8739ae039; });


var $lkU0B = parcelRequire("lkU0B");
var $byUDZ = parcelRequire("byUDZ");

var $5wgL8 = parcelRequire("5wgL8");

var $ih19M = parcelRequire("ih19M");
'use client';
function $134c32104760d758$var$wrapGlobalLayer(styles) {
    const serialized = (0, $byUDZ.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $134c32104760d758$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $5wgL8.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $134c32104760d758$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $134c32104760d758$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $134c32104760d758$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lkU0B.default), {
        styles: globalStyles
    });
}
var $134c32104760d758$export$2e2bcd8739ae039 = $134c32104760d758$var$GlobalStyles;

});
parcelRegister("lkU0B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f886e967cc80b63c$export$2e2bcd8739ae039; });


var $fPZvG = parcelRequire("fPZvG");

var $ih19M = parcelRequire("ih19M");
'use client';
function $f886e967cc80b63c$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $f886e967cc80b63c$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($f886e967cc80b63c$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $fPZvG.Global), {
        styles: globalStyles
    });
}

});

parcelRegister("byUDZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86aecf06de9564b3$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_mutateStyles", function () { return $86aecf06de9564b3$export$592c7226e4cb0171; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $86aecf06de9564b3$export$13a2d3ef13012b32; });
/**
 * @mui/styled-engine v7.3.5
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $8dDdL = parcelRequire("8dDdL");

var $9v6T8 = parcelRequire("9v6T8");

var $fPZvG = parcelRequire("fPZvG");
var $gaZMG = parcelRequire("gaZMG");


var $lkU0B = parcelRequire("lkU0B");
'use client';
function $86aecf06de9564b3$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $8dDdL.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $86aecf06de9564b3$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $86aecf06de9564b3$var$wrapper = [];
function $86aecf06de9564b3$export$13a2d3ef13012b32(styles) {
    $86aecf06de9564b3$var$wrapper[0] = styles;
    return (0, $9v6T8.serializeStyles)($86aecf06de9564b3$var$wrapper);
}

});
parcelRegister("8dDdL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fbdf620290b3477$export$2e2bcd8739ae039; });

var $4I7Ie = parcelRequire("4I7Ie");
parcelRequire("4WYaH");

parcelRequire("9v6T8");
parcelRequire("lSpak");
parcelRequire("3hmGv");
parcelRequire("bh6RR");
parcelRequire("e94ba");
var $5fbdf620290b3477$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $5fbdf620290b3477$export$2e2bcd8739ae039 = (0, $4I7Ie.default).bind(null);
$5fbdf620290b3477$var$tags.forEach(function(tagName) {
    $5fbdf620290b3477$export$2e2bcd8739ae039[tagName] = $5fbdf620290b3477$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("4I7Ie", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36e14100b8801cb7$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");
parcelRequire("fPZvG");
var $gaZMG = parcelRequire("gaZMG");

var $9v6T8 = parcelRequire("9v6T8");

var $lSpak = parcelRequire("lSpak");

var $3hmGv = parcelRequire("3hmGv");

var $bh6RR = parcelRequire("bh6RR");

var $e94ba = parcelRequire("e94ba");
var $36e14100b8801cb7$var$isDevelopment = false;
var $36e14100b8801cb7$var$testOmitPropsOnStringTag = (0, $e94ba.default);
var $36e14100b8801cb7$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $36e14100b8801cb7$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $36e14100b8801cb7$var$testOmitPropsOnStringTag : $36e14100b8801cb7$var$testOmitPropsOnComponent;
};
var $36e14100b8801cb7$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $36e14100b8801cb7$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $3hmGv.registerStyles)(cache, serialized, isStringTag);
    (0, $lSpak.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $3hmGv.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $36e14100b8801cb7$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $36e14100b8801cb7$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $36e14100b8801cb7$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $gaZMG.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $bh6RR.useContext((0, $gaZMG.T));
            }
            if (typeof props.className === 'string') className = (0, $3hmGv.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $9v6T8.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $36e14100b8801cb7$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($36e14100b8801cb7$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $bh6RR.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $36e14100b8801cb7$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $4WYaH.default)({}, options, nextOptions, {
                shouldForwardProp: $36e14100b8801cb7$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("e94ba", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4c525d7dbc25949$export$2e2bcd8739ae039; });

var $cthCm = parcelRequire("cthCm");
// eslint-disable-next-line no-undef
var $a4c525d7dbc25949$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $a4c525d7dbc25949$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $cthCm.default)(function(prop) {
    return $a4c525d7dbc25949$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});






parcelRegister("l0oRz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4ace255d7a100be$export$2e2bcd8739ae039; });

var $6g8tU = parcelRequire("6g8tU");

var $k3eY1 = parcelRequire("k3eY1");

var $2N3YN = parcelRequire("2N3YN");

var $b6vKX = parcelRequire("b6vKX");

'use client';
const $f4ace255d7a100be$var$styled = (0, $6g8tU.default)({
    themeId: (0, $2N3YN.default),
    defaultTheme: $k3eY1.default,
    rootShouldForwardProp: $b6vKX.default
});
var $f4ace255d7a100be$export$2e2bcd8739ae039 = $f4ace255d7a100be$var$styled;

});
parcelRegister("6g8tU", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $48ead0efc7aea41a$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $48ead0efc7aea41a$export$2e2bcd8739ae039; });

var $byUDZ = parcelRequire("byUDZ");

var $5syur = parcelRequire("5syur");

var $5pCmM = parcelRequire("5pCmM");

var $hE2eI = parcelRequire("hE2eI");

var $1zcRx = parcelRequire("1zcRx");

var $f9NmP = parcelRequire("f9NmP");

var $hZ0bi = parcelRequire("hZ0bi");
const $48ead0efc7aea41a$export$35e57303dbd8a66 = (0, $1zcRx.default)();
function $48ead0efc7aea41a$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $48ead0efc7aea41a$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $48ead0efc7aea41a$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $48ead0efc7aea41a$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $48ead0efc7aea41a$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $48ead0efc7aea41a$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$48ead0efc7aea41a$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $48ead0efc7aea41a$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $48ead0efc7aea41a$var$shallowLayer((0, $byUDZ.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $48ead0efc7aea41a$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $48ead0efc7aea41a$var$shallowLayer((0, $byUDZ.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $48ead0efc7aea41a$var$shallowLayer((0, $byUDZ.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $48ead0efc7aea41a$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(layerName ? $48ead0efc7aea41a$var$shallowLayer((0, $byUDZ.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $48ead0efc7aea41a$var$shallowLayer((0, $byUDZ.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $48ead0efc7aea41a$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $48ead0efc7aea41a$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $48ead0efc7aea41a$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $48ead0efc7aea41a$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $48ead0efc7aea41a$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $byUDZ.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, $f9NmP.default)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $48ead0efc7aea41a$var$defaultOverridesResolver($48ead0efc7aea41a$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $48ead0efc7aea41a$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($48ead0efc7aea41a$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $byUDZ.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $48ead0efc7aea41a$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $48ead0efc7aea41a$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $5syur.isPlainObject)(style)) {
                const serialized = (0, $hZ0bi.default)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $48ead0efc7aea41a$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $48ead0efc7aea41a$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $48ead0efc7aea41a$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $48ead0efc7aea41a$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $f9NmP.default));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $48ead0efc7aea41a$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $5pCmM.default)(componentSlot || '')}`;
    return `Styled(${(0, $hE2eI.default)(tag)})`;
}
function $48ead0efc7aea41a$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $48ead0efc7aea41a$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $48ead0efc7aea41a$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $48ead0efc7aea41a$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("hE2eI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd87e835a564411b$export$2e2bcd8739ae039; });

var $lhF4u = parcelRequire("lhF4u");
function $cd87e835a564411b$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $cd87e835a564411b$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $cd87e835a564411b$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $cd87e835a564411b$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $cd87e835a564411b$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $lhF4u.ForwardRef:
            return $cd87e835a564411b$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $lhF4u.Memo:
            return $cd87e835a564411b$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});

parcelRegister("hZ0bi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d178462ac37357f6$export$2e2bcd8739ae039; });

var $byUDZ = parcelRequire("byUDZ");
function $d178462ac37357f6$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $byUDZ.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $byUDZ.internal_serializeStyles)(variant.style);
    });
    return result;
}

});


parcelRegister("b6vKX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8158e36b1c636688$export$2e2bcd8739ae039; });

var $52dC4 = parcelRequire("52dC4");
const $8158e36b1c636688$var$rootShouldForwardProp = (prop)=>(0, $52dC4.default)(prop) && prop !== 'classes';
var $8158e36b1c636688$export$2e2bcd8739ae039 = $8158e36b1c636688$var$rootShouldForwardProp;

});
parcelRegister("52dC4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3aa7b2ebf2e395dc$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $3aa7b2ebf2e395dc$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $3aa7b2ebf2e395dc$export$2e2bcd8739ae039 = $3aa7b2ebf2e395dc$var$slotShouldForwardProp;

});




parcelRegister("OEXBZ", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $098471865c93736f$export$2440da353cedad43; });
parcelRequire("bh6RR");


var $gJOWa = parcelRequire("gJOWa");

var $ih19M = parcelRequire("ih19M");
'use client';
function $098471865c93736f$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $gJOWa.default), {
        ...props
    });
}
var $098471865c93736f$export$2e2bcd8739ae039 = $098471865c93736f$var$DefaultPropsProvider;
function $098471865c93736f$export$2440da353cedad43(params) {
    return (0, $gJOWa.useDefaultProps)(params);
}

});
parcelRegister("gJOWa", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $c2f85c6276b95f84$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $c2f85c6276b95f84$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $e0O1m = parcelRequire("e0O1m");

var $ih19M = parcelRequire("ih19M");
'use client';
const $c2f85c6276b95f84$var$PropsContext = /*#__PURE__*/ $bh6RR.createContext(undefined);
function $c2f85c6276b95f84$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)($c2f85c6276b95f84$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $c2f85c6276b95f84$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $e0O1m.default)(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $e0O1m.default)(config, props, theme.components.mergeClassNameAndStyle);
    return props;
}
function $c2f85c6276b95f84$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $bh6RR.useContext($c2f85c6276b95f84$var$PropsContext);
    return $c2f85c6276b95f84$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $c2f85c6276b95f84$export$2e2bcd8739ae039 = $c2f85c6276b95f84$var$DefaultPropsProvider;

});
parcelRegister("e0O1m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a337dde2edf8b2e6$export$2e2bcd8739ae039; });

var $aPsoC = parcelRequire("aPsoC");
function $a337dde2edf8b2e6$export$2e2bcd8739ae039(defaultProps, props, mergeClassNameAndStyle = false) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $a337dde2edf8b2e6$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName], mergeClassNameAndStyle);
                }
            }
        } else if (propName === 'className' && mergeClassNameAndStyle && props.className) output.className = (0, $aPsoC.default)(defaultProps?.className, props?.className);
        else if (propName === 'style' && mergeClassNameAndStyle && props.style) output.style = {
            ...defaultProps?.style,
            ...props?.style
        };
        else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});
parcelRegister("aPsoC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa1a2e608fb826ea$export$2e2bcd8739ae039; });
function $fa1a2e608fb826ea$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $fa1a2e608fb826ea$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $fa1a2e608fb826ea$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $fa1a2e608fb826ea$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $fa1a2e608fb826ea$export$2e2bcd8739ae039 = $fa1a2e608fb826ea$export$4f5d2d50c9deca37;

});





parcelRegister("kE5Kn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f07c004ab71986d0$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $WU3Np = parcelRequire("WU3Np");

var $kuFH7 = parcelRequire("kuFH7");

var $2N3YN = parcelRequire("2N3YN");

var $ih19M = parcelRequire("ih19M");
'use client';
function $f07c004ab71986d0$export$2e2bcd8739ae039({ theme: theme, ...props }) {
    const noVarsTheme = $bh6RR.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = (0, $2N3YN.default) in theme ? theme[0, $2N3YN.default] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return {
                ...theme,
                vars: null
            };
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $WU3Np.default), {
        theme: noVarsTheme,
        ...props
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $kuFH7.CssVarsProvider), {
        theme: theme,
        ...props
    });
}

});
parcelRegister("WU3Np", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b10e749903d5b60$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $b1HNS = parcelRequire("b1HNS");

var $2N3YN = parcelRequire("2N3YN");

var $ih19M = parcelRequire("ih19M");
'use client';
function $0b10e749903d5b60$export$2e2bcd8739ae039({ theme: themeInput, ...props }) {
    const scopedTheme = (0, $2N3YN.default) in themeInput ? themeInput[0, $2N3YN.default] : undefined;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $b1HNS.default), {
        ...props,
        themeId: scopedTheme ? (0, $2N3YN.default) : undefined,
        theme: scopedTheme || themeInput
    });
}

});
parcelRegister("b1HNS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8071c4251b77a7d7$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $3NVTJ = parcelRequire("3NVTJ");
var $l0rU3 = parcelRequire("l0rU3");

parcelRequire("fPZvG");
var $gaZMG = parcelRequire("gaZMG");

var $65M4H = parcelRequire("65M4H");

var $am2yJ = parcelRequire("am2yJ");

var $gJOWa = parcelRequire("gJOWa");

var $k7YWb = parcelRequire("k7YWb");

var $ih19M = parcelRequire("ih19M");
'use client';
const $8071c4251b77a7d7$var$EMPTY_THEME = {};
function $8071c4251b77a7d7$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $bh6RR.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $8071c4251b77a7d7$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $65M4H.default)($8071c4251b77a7d7$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $l0rU3.default)() || $8071c4251b77a7d7$var$EMPTY_THEME;
    const engineTheme = $8071c4251b77a7d7$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $8071c4251b77a7d7$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $k7YWb.default)(engineTheme);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $3NVTJ.default), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gaZMG.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $am2yJ.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $gJOWa.default), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $8071c4251b77a7d7$export$2e2bcd8739ae039 = $8071c4251b77a7d7$var$ThemeProvider;

});
parcelRegister("3NVTJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c52dbfec5be7fe0$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");



var $iOUh5 = parcelRequire("iOUh5");

var $l0rU3 = parcelRequire("l0rU3");

var $1CaaD = parcelRequire("1CaaD");

var $ih19M = parcelRequire("ih19M");
function $2c52dbfec5be7fe0$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $2c52dbfec5be7fe0$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $l0rU3.default)();
    const theme = $bh6RR.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $2c52dbfec5be7fe0$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $1CaaD.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $iOUh5.default).Provider, {
        value: theme,
        children: children
    });
}
var $2c52dbfec5be7fe0$export$2e2bcd8739ae039 = $2c52dbfec5be7fe0$var$ThemeProvider;

});
parcelRegister("iOUh5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db388c7a98bf514f$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
const $db388c7a98bf514f$var$ThemeContext = /*#__PURE__*/ $bh6RR.createContext(null);
var $db388c7a98bf514f$export$2e2bcd8739ae039 = $db388c7a98bf514f$var$ThemeContext;

});

parcelRegister("l0rU3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4af3e083ce4263c$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $iOUh5 = parcelRequire("iOUh5");
function $f4af3e083ce4263c$export$2e2bcd8739ae039() {
    const theme = $bh6RR.useContext((0, $iOUh5.default));
    return theme;
}

});

parcelRegister("1CaaD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12d13ab84c5604f7$export$2e2bcd8739ae039; });
const $12d13ab84c5604f7$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $12d13ab84c5604f7$export$2e2bcd8739ae039 = $12d13ab84c5604f7$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("am2yJ", function(module, exports) {

$parcel$export(module.exports, "useRtl", function () { return $789df1a5c5390f1a$export$b2dd014b6c321cb; });
$parcel$export(module.exports, "default", function () { return $789df1a5c5390f1a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $ih19M = parcelRequire("ih19M");
'use client';
const $789df1a5c5390f1a$var$RtlContext = /*#__PURE__*/ $bh6RR.createContext();
function $789df1a5c5390f1a$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)($789df1a5c5390f1a$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $789df1a5c5390f1a$export$b2dd014b6c321cb = ()=>{
    const value = $bh6RR.useContext($789df1a5c5390f1a$var$RtlContext);
    return value ?? false;
};
var $789df1a5c5390f1a$export$2e2bcd8739ae039 = $789df1a5c5390f1a$var$RtlProvider;

});

parcelRegister("k7YWb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea73bb0251f72d6c$export$2e2bcd8739ae039; });

var $kLukk = parcelRequire("kLukk");

var $dDKx6 = parcelRequire("dDKx6");

var $1EIH3 = parcelRequire("1EIH3");

var $65M4H = parcelRequire("65M4H");

var $ih19M = parcelRequire("ih19M");
function $ea73bb0251f72d6c$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $65M4H.default)();
    const id = (0, $dDKx6.default)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $kLukk.default)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && firstChild.hasAttribute?.('data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1EIH3.default), {
        styles: layerOrder
    });
}

});
parcelRegister("kLukk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1dfb8b2cafe41bb$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $f1dfb8b2cafe41bb$var$useEnhancedEffect = typeof window !== 'undefined' ? $bh6RR.useLayoutEffect : $bh6RR.useEffect;
var $f1dfb8b2cafe41bb$export$2e2bcd8739ae039 = $f1dfb8b2cafe41bb$var$useEnhancedEffect;

});

parcelRegister("dDKx6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ee3035d4da2ac8a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
let $9ee3035d4da2ac8a$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $9ee3035d4da2ac8a$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $bh6RR.useState(idOverride);
    const id = idOverride || defaultId;
    $bh6RR.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $9ee3035d4da2ac8a$var$globalId += 1;
            setDefaultId(`mui-${$9ee3035d4da2ac8a$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $9ee3035d4da2ac8a$var$safeReact = {
    ...$bh6RR
};
const $9ee3035d4da2ac8a$var$maybeReactUseId = $9ee3035d4da2ac8a$var$safeReact.useId;
function $9ee3035d4da2ac8a$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($9ee3035d4da2ac8a$var$maybeReactUseId !== undefined) {
        const reactId = $9ee3035d4da2ac8a$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $9ee3035d4da2ac8a$var$useGlobalId(idOverride);
}

});




parcelRegister("kuFH7", function(module, exports) {

$parcel$export(module.exports, "CssVarsProvider", function () { return $eeb6f3a98ae5eee4$export$50ec01b133c61652; });

var $f9NmP = parcelRequire("f9NmP");

var $c9kpw = parcelRequire("c9kpw");

var $c1Ell = parcelRequire("c1Ell");

var $hyCtF = parcelRequire("hyCtF");

var $2N3YN = parcelRequire("2N3YN");

var $4LTy8 = parcelRequire("4LTy8");

var $ih19M = parcelRequire("ih19M");
'use client';
const { CssVarsProvider: $eeb6f3a98ae5eee4$var$InternalCssVarsProvider, useColorScheme: $eeb6f3a98ae5eee4$export$6343629ee1b29116, getInitColorSchemeScript: $eeb6f3a98ae5eee4$var$deprecatedGetInitColorSchemeScript } = (0, $c9kpw.default)({
    themeId: (0, $2N3YN.default),
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $c1Ell.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: (0, $4LTy8.defaultConfig).colorSchemeStorageKey,
    modeStorageKey: (0, $4LTy8.defaultConfig).modeStorageKey,
    defaultColorScheme: {
        light: (0, $4LTy8.defaultConfig).defaultLightColorScheme,
        dark: (0, $4LTy8.defaultConfig).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $hyCtF.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $f9NmP.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
let $eeb6f3a98ae5eee4$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $eeb6f3a98ae5eee4$export$99adf6d9ed169a14(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)($eeb6f3a98ae5eee4$var$InternalCssVarsProvider, {
        ...props
    });
}
let $eeb6f3a98ae5eee4$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $eeb6f3a98ae5eee4$export$f9a57b4a2abf8ed = (params)=>{
    if (!$eeb6f3a98ae5eee4$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $eeb6f3a98ae5eee4$var$warnedInitScriptOnce = true;
    }
    return $eeb6f3a98ae5eee4$var$deprecatedGetInitColorSchemeScript(params);
};
const $eeb6f3a98ae5eee4$export$50ec01b133c61652 = $eeb6f3a98ae5eee4$var$InternalCssVarsProvider;

});
parcelRegister("c9kpw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d8628744c972dac$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $lkU0B = parcelRequire("lkU0B");

var $l0rU3 = parcelRequire("l0rU3");

var $kLukk = parcelRequire("kLukk");

var $b1HNS = parcelRequire("b1HNS");

var $303bZ = parcelRequire("303bZ");

var $dHH5J = parcelRequire("dHH5J");

var $ih19M = parcelRequire("ih19M");
'use client';
const $8d8628744c972dac$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $8d8628744c972dac$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $303bZ.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $303bZ.DEFAULT_COLOR_SCHEME_STORAGE_KEY), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $bh6RR.createContext(undefined);
    const useColorScheme = ()=>$bh6RR.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $bh6RR.useRef(false);
        const upperTheme = (0, $l0rU3.default)();
        const ctx = $bh6RR.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $bh6RR.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $bh6RR.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $dHH5J.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $bh6RR.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $kLukk.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $bh6RR.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($8d8628744c972dac$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $bh6RR.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $bh6RR.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $b1HNS.default), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $ih19M.jsx)((0, $lkU0B.default), {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $ih19M.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $303bZ.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("303bZ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MODE_STORAGE_KEY", function () { return $22f3d91f20f9449a$export$ff0fa3047d11164c; });
$parcel$export(module.exports, "DEFAULT_COLOR_SCHEME_STORAGE_KEY", function () { return $22f3d91f20f9449a$export$665054ea9d94dab9; });
$parcel$export(module.exports, "default", function () { return $22f3d91f20f9449a$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
const $22f3d91f20f9449a$export$ff0fa3047d11164c = 'mode';
const $22f3d91f20f9449a$export$665054ea9d94dab9 = 'color-scheme';
const $22f3d91f20f9449a$export$14ebe5b26ee7fb38 = 'data-color-scheme';
function $22f3d91f20f9449a$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $22f3d91f20f9449a$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $22f3d91f20f9449a$export$665054ea9d94dab9, attribute: initialAttribute = $22f3d91f20f9449a$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^[\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $ih19M.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

});

parcelRegister("dHH5J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fa0b7960d638ad5$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $303bZ = parcelRequire("303bZ");

var $e3w1Y = parcelRequire("e3w1Y");
'use client';
function $9fa0b7960d638ad5$var$noop() {}
function $9fa0b7960d638ad5$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $9fa0b7960d638ad5$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $9fa0b7960d638ad5$export$3caa7590cc1987bd(state) {
    return $9fa0b7960d638ad5$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $9fa0b7960d638ad5$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $303bZ.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: colorSchemeStorageKey = (0, $303bZ.DEFAULT_COLOR_SCHEME_STORAGE_KEY), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = (0, $e3w1Y.default), noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $bh6RR.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $bh6RR.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $bh6RR.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $bh6RR.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $9fa0b7960d638ad5$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $bh6RR.useState(noSsr || !isMultiSchemes);
    $bh6RR.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $9fa0b7960d638ad5$export$3caa7590cc1987bd(state);
    const setMode = $bh6RR.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $9fa0b7960d638ad5$export$ab3d447356dfa3e5(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $bh6RR.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $9fa0b7960d638ad5$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $bh6RR.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $bh6RR.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $bh6RR.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $bh6RR.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $9fa0b7960d638ad5$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $9fa0b7960d638ad5$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $9fa0b7960d638ad5$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("e3w1Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3ba312b71bb6b6b$export$2e2bcd8739ae039; });
function $a3ba312b71bb6b6b$var$noop() {}
const $a3ba312b71bb6b6b$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $a3ba312b71bb6b6b$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $a3ba312b71bb6b6b$export$2e2bcd8739ae039 = $a3ba312b71bb6b6b$var$localStorageManager;

});



parcelRegister("4LTy8", function(module, exports) {

$parcel$export(module.exports, "defaultConfig", function () { return $3796a432092ccac7$export$f84bd70098573c5c; });


var $303bZ = parcelRequire("303bZ");

var $ih19M = parcelRequire("ih19M");
const $3796a432092ccac7$export$f84bd70098573c5c = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
/**
 *
 * Demos:
 *
 * - [InitColorSchemeScript](https://mui.com/material-ui/react-init-color-scheme-script/)
 *
 * API:
 *
 * - [InitColorSchemeScript API](https://mui.com/material-ui/api/init-color-scheme-script/)
 */ function $3796a432092ccac7$var$InitColorSchemeScript(props) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = $3796a432092ccac7$export$f84bd70098573c5c.defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme = $3796a432092ccac7$export$f84bd70098573c5c.defaultDarkColorScheme, modeStorageKey: modeStorageKey = $3796a432092ccac7$export$f84bd70098573c5c.modeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = $3796a432092ccac7$export$f84bd70098573c5c.colorSchemeStorageKey, attribute: initialAttribute = $3796a432092ccac7$export$f84bd70098573c5c.attribute, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = props;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $303bZ.default), {
        defaultMode: defaultMode,
        defaultLightColorScheme: defaultLightColorScheme,
        defaultDarkColorScheme: defaultDarkColorScheme,
        modeStorageKey: modeStorageKey,
        colorSchemeStorageKey: colorSchemeStorageKey,
        attribute: initialAttribute,
        colorSchemeNode: colorSchemeNode,
        nonce: nonce
    });
}
var $3796a432092ccac7$export$2e2bcd8739ae039 = $3796a432092ccac7$var$InitColorSchemeScript;

});



parcelRegister("1lMle", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e92bf8026be45e5$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "useLogMountTime", function () { return $3e92bf8026be45e5$export$3d9946d250688a07; });
/* eslint-disable import/no-cycle */ 
var $bh6RR = parcelRequire("bh6RR");

var $iZqJL = parcelRequire("iZqJL");

var $jdCKi = parcelRequire("jdCKi");
(0, $iZqJL.datadogLogs).init((0, $jdCKi.default).datadogLogging);
const $3e92bf8026be45e5$var$handler = (0, $jdCKi.default).env === "local" ? "console" : "http";
const $3e92bf8026be45e5$var$logger = (0, $iZqJL.datadogLogs).createLogger("webby-app", {
    level: "info",
    handler: $3e92bf8026be45e5$var$handler,
    context: {
        env: (0, $jdCKi.default).env,
        version: (0, $jdCKi.default).version
    }
});
var $3e92bf8026be45e5$export$2e2bcd8739ae039 = $3e92bf8026be45e5$var$logger;
function $3e92bf8026be45e5$export$3d9946d250688a07(componentName) {
    $bh6RR.useEffect(()=>{
        const mountTime = Date.now();
        return ()=>{
            const unmountTime = Date.now();
            const timeElapsed = unmountTime - mountTime;
            $3e92bf8026be45e5$var$logger.info(`${componentName} was up for ${timeElapsed}ms`, {
                mountDuration: timeElapsed,
                componentName: componentName
            });
        };
    }, [
        componentName
    ]);
}

});
parcelRegister("iZqJL", function(module, exports) {

$parcel$export(module.exports, "datadogLogs", function () { return $9d5b2390b23dcbbf$export$64696fc4da45d740; });

var $9SlTq = parcelRequire("9SlTq");

var $gQCCP = parcelRequire("gQCCP");

var $bsYup = parcelRequire("bsYup");

var $c2Qhr = parcelRequire("c2Qhr");

var $1nqsB = parcelRequire("1nqsB");
//#region src/entries/main.ts
/**
*
* Datadog Browser Logs SDK for collecting and forwarding browser logs to Datadog.
* Provides comprehensive logging capabilities with automatic error tracking and custom log collection.
*
* @packageDocumentation
* @see [Browser Log Collection](https://docs.datadoghq.com/logs/log_collection/javascript/)
*/ /**
* The global Logs instance. Use this to call Logs methods.
*
* @category Main
* @see {@link DatadogLogs}
* @see [Browser Log Collection](https://docs.datadoghq.com/logs/log_collection/javascript/)
*/ const $9d5b2390b23dcbbf$export$64696fc4da45d740 = (0, $bsYup.makeLogsPublicApi)({
    sdkName: "logs"
});
(0, $1nqsB.defineGlobal)((0, $c2Qhr.globalObject), "DD_LOGS", $9d5b2390b23dcbbf$export$64696fc4da45d740);

});
parcelRegister("9SlTq", function(module, exports) {

$parcel$export(module.exports, "isAuthorized", function () { return $6f48d70f96dce9b1$export$4f612ab7b7b1d133; });
$parcel$export(module.exports, "StatusType", function () { return $6f48d70f96dce9b1$export$e35c1996c6f482ad; });
//#region src/domain/logger/isAuthorized.ts
function $6f48d70f96dce9b1$export$4f612ab7b7b1d133(status, handlerType, logger) {
    const loggerHandler = logger.getHandler();
    const sanitizedHandlerType = Array.isArray(loggerHandler) ? loggerHandler : [
        loggerHandler
    ];
    return $6f48d70f96dce9b1$export$33137eb87fdcc0f7[status] >= $6f48d70f96dce9b1$export$33137eb87fdcc0f7[logger.getLevel()] && sanitizedHandlerType.includes(handlerType);
}
const $6f48d70f96dce9b1$export$e35c1996c6f482ad = {
    ok: "ok",
    debug: "debug",
    info: "info",
    notice: "notice",
    warn: "warn",
    error: "error",
    critical: "critical",
    alert: "alert",
    emerg: "emerg"
};
const $6f48d70f96dce9b1$export$33137eb87fdcc0f7 = {
    [$6f48d70f96dce9b1$export$e35c1996c6f482ad.ok]: 0,
    [$6f48d70f96dce9b1$export$e35c1996c6f482ad.debug]: 1,
    [$6f48d70f96dce9b1$export$e35c1996c6f482ad.info]: 2,
    [$6f48d70f96dce9b1$export$e35c1996c6f482ad.notice]: 4,
    [$6f48d70f96dce9b1$export$e35c1996c6f482ad.warn]: 5,
    [$6f48d70f96dce9b1$export$e35c1996c6f482ad.error]: 6,
    [$6f48d70f96dce9b1$export$e35c1996c6f482ad.critical]: 7,
    [$6f48d70f96dce9b1$export$e35c1996c6f482ad.alert]: 8,
    [$6f48d70f96dce9b1$export$e35c1996c6f482ad.emerg]: 9
};

});

parcelRegister("gQCCP", function(module, exports) {

$parcel$export(module.exports, "HandlerType", function () { return $213c293b402870fc$export$533bc3391342c4f6; });
$parcel$export(module.exports, "STATUSES", function () { return $213c293b402870fc$export$b41c0f52c41112e3; });
$parcel$export(module.exports, "Logger", function () { return $213c293b402870fc$export$efa9a398d6368992; });

var $9SlTq = parcelRequire("9SlTq");

var $2U7BZ = parcelRequire("2U7BZ");

var $5tXxv = parcelRequire("5tXxv");

var $leyUX = parcelRequire("leyUX");
var $SMkA1 = parcelRequire("SMkA1");
var $cybD8 = parcelRequire("cybD8");
var $e6zeV = parcelRequire("e6zeV");
var $7RJVj = parcelRequire("7RJVj");
var $hpOLz = parcelRequire("hpOLz");

var $dee0n = parcelRequire("dee0n");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/logger.ts
const $213c293b402870fc$export$533bc3391342c4f6 = {
    console: "console",
    http: "http",
    silent: "silent"
};
const $213c293b402870fc$export$b41c0f52c41112e3 = Object.keys((0, $9SlTq.StatusType));
var $213c293b402870fc$export$efa9a398d6368992 = class {
    constructor(handleLogStrategy, name, handlerType = $213c293b402870fc$export$533bc3391342c4f6.http, level = (0, $9SlTq.StatusType).debug, loggerContext = {}){
        this.handleLogStrategy = handleLogStrategy;
        this.handlerType = handlerType;
        this.level = level;
        this.contextManager = (0, $cybD8.createContextManager)("logger");
        this.tags = [];
        this.contextManager.setContext(loggerContext);
        if (name) this.contextManager.setContextProperty("logger", {
            name: name
        });
    }
    logImplementation(message, messageContext, status = (0, $9SlTq.StatusType).info, error, handlingStack) {
        (0, $dee0n.callMonitored)(()=>{
            const sanitizedMessageContext = (0, $hpOLz.sanitize)(messageContext);
            let context;
            let debugIds;
            if (error !== void 0 && error !== null) {
                const rawError = (0, $SMkA1.computeRawError)({
                    originalError: error,
                    nonErrorPrefix: (0, $7RJVj.NonErrorPrefix).PROVIDED,
                    source: (0, $7RJVj.ErrorSource).LOGGER,
                    handling: (0, $7RJVj.ErrorHandling).HANDLED,
                    startClocks: (0, $1wrwm.clocksNow)()
                });
                debugIds = rawError.debugIds;
                context = (0, $5tXxv.combine)({
                    error: (0, $2U7BZ.createErrorFieldFromRawError)(rawError, {
                        includeMessage: true
                    })
                }, rawError.context, sanitizedMessageContext);
            } else context = sanitizedMessageContext;
            this.handleLogStrategy({
                message: (0, $hpOLz.sanitize)(message),
                context: context,
                status: status,
                ...debugIds ? {
                    debugIds: debugIds
                } : {}
            }, this, handlingStack);
        });
    }
    log(message, messageContext, status = (0, $9SlTq.StatusType).info, error) {
        let handlingStack;
        if ((0, $9SlTq.isAuthorized)(status, $213c293b402870fc$export$533bc3391342c4f6.http, this)) handlingStack = (0, $e6zeV.createHandlingStack)("log");
        this.logImplementation(message, messageContext, status, error, handlingStack);
    }
    setContext(context) {
        this.contextManager.setContext(context);
    }
    getContext() {
        return this.contextManager.getContext();
    }
    setContextProperty(key, value) {
        this.contextManager.setContextProperty(key, value);
    }
    removeContextProperty(key) {
        this.contextManager.removeContextProperty(key);
    }
    clearContext() {
        this.contextManager.clearContext();
    }
    addTag(key, value) {
        this.tags.push((0, $leyUX.buildTag)(key, value));
    }
    removeTagsWithKey(key) {
        const sanitizedKey = (0, $leyUX.sanitizeTag)(key);
        this.tags = this.tags.filter((tag)=>tag !== sanitizedKey && !tag.startsWith(`${sanitizedKey}:`));
    }
    getTags() {
        return this.tags.slice();
    }
    setHandler(handler) {
        this.handlerType = handler;
    }
    getHandler() {
        return this.handlerType;
    }
    setLevel(level) {
        this.level = level;
    }
    getLevel() {
        return this.level;
    }
};
$213c293b402870fc$export$efa9a398d6368992.prototype.ok = $213c293b402870fc$var$createLoggerMethod((0, $9SlTq.StatusType).ok);
$213c293b402870fc$export$efa9a398d6368992.prototype.debug = $213c293b402870fc$var$createLoggerMethod((0, $9SlTq.StatusType).debug);
$213c293b402870fc$export$efa9a398d6368992.prototype.info = $213c293b402870fc$var$createLoggerMethod((0, $9SlTq.StatusType).info);
$213c293b402870fc$export$efa9a398d6368992.prototype.notice = $213c293b402870fc$var$createLoggerMethod((0, $9SlTq.StatusType).notice);
$213c293b402870fc$export$efa9a398d6368992.prototype.warn = $213c293b402870fc$var$createLoggerMethod((0, $9SlTq.StatusType).warn);
$213c293b402870fc$export$efa9a398d6368992.prototype.error = $213c293b402870fc$var$createLoggerMethod((0, $9SlTq.StatusType).error);
$213c293b402870fc$export$efa9a398d6368992.prototype.critical = $213c293b402870fc$var$createLoggerMethod((0, $9SlTq.StatusType).critical);
$213c293b402870fc$export$efa9a398d6368992.prototype.alert = $213c293b402870fc$var$createLoggerMethod((0, $9SlTq.StatusType).alert);
$213c293b402870fc$export$efa9a398d6368992.prototype.emerg = $213c293b402870fc$var$createLoggerMethod((0, $9SlTq.StatusType).emerg);
function $213c293b402870fc$var$createLoggerMethod(status) {
    return function(message, messageContext, error) {
        let handlingStack;
        if ((0, $9SlTq.isAuthorized)(status, $213c293b402870fc$export$533bc3391342c4f6.http, this)) handlingStack = (0, $e6zeV.createHandlingStack)("log");
        this.logImplementation(message, messageContext, status, error, handlingStack);
    };
}

});
parcelRegister("2U7BZ", function(module, exports) {

$parcel$export(module.exports, "createErrorFieldFromRawError", function () { return $500ff8a4fd8b3303$export$9acf36e88a596ad; });
//#region src/domain/createErrorFieldFromRawError.ts
function $500ff8a4fd8b3303$export$9acf36e88a596ad(rawError, { includeMessage: includeMessage = false } = {}) {
    return {
        stack: rawError.stack,
        kind: rawError.type,
        message: includeMessage ? rawError.message : void 0,
        causes: rawError.causes,
        fingerprint: rawError.fingerprint,
        handling: rawError.handling
    };
}

});


parcelRegister("bsYup", function(module, exports) {

$parcel$export(module.exports, "makeLogsPublicApi", function () { return $49c788809d12e4cc$export$39525f74d82d4cd7; });

var $gQCCP = parcelRequire("gQCCP");

var $7KyiY = parcelRequire("7KyiY");

var $eu1uA = parcelRequire("eu1uA");

var $kwb71 = parcelRequire("kwb71");

var $1sIcC = parcelRequire("1sIcC");

var $5tXxv = parcelRequire("5tXxv");

var $461Vl = parcelRequire("461Vl");
var $95eAR = parcelRequire("95eAR");
var $efY2P = parcelRequire("efY2P");
var $aAvkZ = parcelRequire("aAvkZ");
var $81mt8 = parcelRequire("81mt8");
var $1nqsB = parcelRequire("1nqsB");
var $bOZaS = parcelRequire("bOZaS");
var $hpOLz = parcelRequire("hpOLz");
var $lePkT = parcelRequire("lePkT");

var $dee0n = parcelRequire("dee0n");
//#region src/boot/logsPublicApi.ts
function $49c788809d12e4cc$export$39525f74d82d4cd7(options = {}) {
    const trackingConsentState = (0, $efY2P.createTrackingConsentState)();
    const bufferedDataObservable = (0, $lePkT.startBufferingData)().observable;
    let strategy = (0, $1sIcC.createPreStartStrategy)((0, $7KyiY.buildCommonContext), trackingConsentState, (configuration, logsSessionManager, hooks)=>{
        const startLogsResult = (0, $bOZaS.mockable)((0, $kwb71.startLogs))(configuration, logsSessionManager, (0, $7KyiY.buildCommonContext), bufferedDataObservable, hooks);
        strategy = $49c788809d12e4cc$var$createPostStartStrategy(strategy, startLogsResult);
        (0, $eu1uA.callPluginsMethod)(configuration.plugins, "onLogsStart", {
            handleLog: startLogsResult.handleLog
        });
        return startLogsResult;
    }, options.sdkName);
    const getStrategy = ()=>strategy;
    const customLoggers = {};
    const mainLogger = new (0, $gQCCP.Logger)((...params)=>strategy.handleLog(...params));
    const logsPublicApi = (0, $1nqsB.makePublicApi)({
        logger: mainLogger,
        init: (initConfiguration)=>{
            const errorStack = /* @__PURE__ */ new Error().stack;
            (0, $dee0n.callMonitored)(()=>strategy.init(initConfiguration, logsPublicApi, errorStack));
        },
        setTrackingConsent: (0, $dee0n.monitor)((trackingConsent)=>{
            trackingConsentState.update(trackingConsent);
            (0, $461Vl.addTelemetryUsage)({
                feature: "set-tracking-consent",
                tracking_consent: trackingConsent
            });
        }),
        getGlobalContext: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).globalContext, (0, $95eAR.ContextManagerMethod).getContext),
        setGlobalContext: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).globalContext, (0, $95eAR.ContextManagerMethod).setContext),
        setGlobalContextProperty: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).globalContext, (0, $95eAR.ContextManagerMethod).setContextProperty),
        removeGlobalContextProperty: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).globalContext, (0, $95eAR.ContextManagerMethod).removeContextProperty),
        clearGlobalContext: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).globalContext, (0, $95eAR.ContextManagerMethod).clearContext),
        createLogger: (0, $dee0n.monitor)((name, conf = {})=>{
            customLoggers[name] = new (0, $gQCCP.Logger)((...params)=>strategy.handleLog(...params), (0, $hpOLz.sanitize)(name), conf.handler, conf.level, (0, $hpOLz.sanitize)(conf.context));
            return customLoggers[name];
        }),
        getLogger: (0, $dee0n.monitor)((name)=>customLoggers[name]),
        getInitConfiguration: (0, $dee0n.monitor)(()=>(0, $5tXxv.deepClone)(strategy.initConfiguration)),
        getInternalContext: (0, $dee0n.monitor)((startTime)=>strategy.getInternalContext(startTime)),
        setUser: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).userContext, (0, $95eAR.ContextManagerMethod).setContext),
        getUser: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).userContext, (0, $95eAR.ContextManagerMethod).getContext),
        setUserProperty: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).userContext, (0, $95eAR.ContextManagerMethod).setContextProperty),
        removeUserProperty: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).userContext, (0, $95eAR.ContextManagerMethod).removeContextProperty),
        clearUser: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).userContext, (0, $95eAR.ContextManagerMethod).clearContext),
        setAccount: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).accountContext, (0, $95eAR.ContextManagerMethod).setContext),
        getAccount: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).accountContext, (0, $95eAR.ContextManagerMethod).getContext),
        setAccountProperty: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).accountContext, (0, $95eAR.ContextManagerMethod).setContextProperty),
        removeAccountProperty: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).accountContext, (0, $95eAR.ContextManagerMethod).removeContextProperty),
        clearAccount: (0, $aAvkZ.defineContextMethod)(getStrategy, (0, $95eAR.CustomerContextKey).accountContext, (0, $95eAR.ContextManagerMethod).clearContext)
    });
    return logsPublicApi;
}
function $49c788809d12e4cc$var$createPostStartStrategy(preStartStrategy, startLogsResult) {
    return {
        ...preStartStrategy,
        init: (initConfiguration)=>{
            (0, $81mt8.displayAlreadyInitializedError)("DD_LOGS", initConfiguration);
        },
        getInternalContext: startLogsResult.getInternalContext,
        globalContext: startLogsResult.globalContext,
        userContext: startLogsResult.userContext,
        accountContext: startLogsResult.accountContext
    };
}

});
parcelRegister("7KyiY", function(module, exports) {

$parcel$export(module.exports, "buildCommonContext", function () { return $d2202ac6d0c8c251$export$ef57df7b19d2c9ab; });

var $c2Qhr = parcelRequire("c2Qhr");
//#region src/domain/contexts/commonContext.ts
function $d2202ac6d0c8c251$export$ef57df7b19d2c9ab() {
    if (0, $c2Qhr.isWorkerEnvironment) return {};
    return {
        view: {
            referrer: document.referrer,
            url: window.location.href
        }
    };
}

});

parcelRegister("eu1uA", function(module, exports) {

$parcel$export(module.exports, "callPluginsMethod", function () { return $f613bf23f4fb5f2c$export$165b46b876b53122; });
//#region src/domain/plugins.ts
function $f613bf23f4fb5f2c$export$165b46b876b53122(plugins, methodName, parameter) {
    if (!plugins) return;
    for (const plugin of plugins){
        const method = plugin[methodName];
        if (method) method(parameter);
    }
}

});

parcelRegister("kwb71", function(module, exports) {

$parcel$export(module.exports, "startLogs", function () { return $f49710a4b75204dc$export$660a5342b09224dc; });

var $dLXGC = parcelRequire("dLXGC");

var $G8txz = parcelRequire("G8txz");

var $2pKQb = parcelRequire("2pKQb");

var $03n1p = parcelRequire("03n1p");

var $f6mpQ = parcelRequire("f6mpQ");

var $gTUoD = parcelRequire("gTUoD");

var $l1xsN = parcelRequire("l1xsN");

var $i1e8f = parcelRequire("i1e8f");

var $bQq97 = parcelRequire("bQq97");

var $aSOEX = parcelRequire("aSOEX");

var $gwpsB = parcelRequire("gwpsB");

var $lAh61 = parcelRequire("lAh61");

var $8cAzf = parcelRequire("8cAzf");

var $gS0nt = parcelRequire("gS0nt");
var $jkF2M = parcelRequire("jkF2M");
var $dmc88 = parcelRequire("dmc88");
var $4B1f5 = parcelRequire("4B1f5");
var $6gx7W = parcelRequire("6gx7W");
var $7P6fE = parcelRequire("7P6fE");
//#region src/boot/startLogs.ts
const $f49710a4b75204dc$var$LOGS_STORAGE_KEY = "logs";
function $f49710a4b75204dc$export$660a5342b09224dc(configuration, sessionManager, getCommonContext, bufferedDataObservable, hooks) {
    const lifeCycle = new (0, $dLXGC.LifeCycle)();
    const cleanupTasks = [];
    lifeCycle.subscribe(1, (log)=>(0, $jkF2M.sendToExtension)("logs", log));
    const reportError = (0, $gwpsB.startReportError)(lifeCycle);
    const { assembleEventDefaults: assembleHook } = hooks;
    (0, $8cAzf.startSessionContext)(assembleHook, configuration, sessionManager);
    const accountContext = (0, $dmc88.startAccountContext)(assembleHook, configuration, $f49710a4b75204dc$var$LOGS_STORAGE_KEY);
    const userContext = (0, $7P6fE.startUserContext)(assembleHook, configuration, sessionManager, $f49710a4b75204dc$var$LOGS_STORAGE_KEY);
    const globalContext = (0, $4B1f5.startGlobalContext)(assembleHook, configuration, $f49710a4b75204dc$var$LOGS_STORAGE_KEY, false);
    (0, $lAh61.startRUMInternalContext)(hooks);
    (0, $6gx7W.startTabContext)(assembleHook);
    (0, $f6mpQ.startNetworkErrorCollection)(configuration, lifeCycle, bufferedDataObservable);
    (0, $gTUoD.startRuntimeErrorCollection)(configuration, lifeCycle, bufferedDataObservable);
    (0, $2pKQb.startConsoleCollection)(configuration, lifeCycle, bufferedDataObservable);
    bufferedDataObservable.unbuffer();
    (0, $03n1p.startReportCollection)(configuration, lifeCycle);
    const { handleLog: handleLog } = (0, $l1xsN.startLoggerCollection)(lifeCycle);
    (0, $G8txz.startLogsAssembly)(configuration, lifeCycle, hooks, getCommonContext, reportError);
    if (!(0, $gS0nt.canUseEventBridge)()) {
        const { stop: stopLogsBatch } = (0, $i1e8f.startLogsBatch)(configuration, lifeCycle, reportError, sessionManager);
        cleanupTasks.push(()=>stopLogsBatch());
    } else (0, $bQq97.startLogsBridge)(lifeCycle);
    return {
        handleLog: handleLog,
        getInternalContext: (0, $aSOEX.startInternalContext)(sessionManager).get,
        accountContext: accountContext,
        globalContext: globalContext,
        userContext: userContext,
        stop: ()=>{
            cleanupTasks.forEach((task)=>task());
        }
    };
}

});
parcelRegister("dLXGC", function(module, exports) {

$parcel$export(module.exports, "LifeCycle", function () { return $076bc0de397c578a$export$6af70476896cbaec; });

var $dcbEk = parcelRequire("dcbEk");
//#region src/domain/lifeCycle.ts
const $076bc0de397c578a$export$6af70476896cbaec = (0, $dcbEk.AbstractLifeCycle);

});

parcelRegister("G8txz", function(module, exports) {

$parcel$export(module.exports, "startLogsAssembly", function () { return $b6d9f20bdd50f7d3$export$627391049aa7b21e; });

var $gQCCP = parcelRequire("gQCCP");
parcelRequire("dLXGC");

var $5tXxv = parcelRequire("5tXxv");

var $leyUX = parcelRequire("leyUX");
var $a55RI = parcelRequire("a55RI");
var $7RJVj = parcelRequire("7RJVj");

var $1wrwm = parcelRequire("1wrwm");

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/assembly.ts
function $b6d9f20bdd50f7d3$export$627391049aa7b21e(configuration, lifeCycle, hooks, getCommonContext, reportError, eventRateLimit) {
    const statusWithCustom = (0, $gQCCP.STATUSES).concat([
        "custom"
    ]);
    const logRateLimiters = {};
    statusWithCustom.forEach((status)=>{
        logRateLimiters[status] = (0, $a55RI.createEventRateLimiter)(status, reportError, eventRateLimit);
    });
    lifeCycle.subscribe(0, ({ rawLogsEvent: rawLogsEvent, savedCommonContext: savedCommonContext, domainContext: domainContext, ddtags: ddtags = [] })=>{
        const startTime = (0, $1wrwm.toRelativeTime)(rawLogsEvent.date);
        const commonContext = savedCommonContext || getCommonContext();
        const assemblyParams = {
            startTime: startTime,
            rawLogsEvent: rawLogsEvent,
            domainContext: domainContext
        };
        const defaultLogsEventAttributes = hooks.assembleEventDefaults.trigger(assemblyParams);
        if (defaultLogsEventAttributes === (0, $fNtjE.DISCARDED)) return;
        const logsEventAttributes = hooks.assembleEvent.trigger(assemblyParams);
        if (logsEventAttributes === (0, $fNtjE.DISCARDED)) return;
        const defaultDdtags = (0, $leyUX.buildTags)(configuration);
        const log = (0, $5tXxv.combine)({
            view: commonContext.view
        }, defaultLogsEventAttributes, rawLogsEvent, logsEventAttributes, {
            ddtags: defaultDdtags.concat(ddtags).join(",")
        });
        if (configuration.beforeSend?.(log, domainContext) === false || log.origin !== (0, $7RJVj.ErrorSource).AGENT && (logRateLimiters[log.status] ?? logRateLimiters["custom"]).isLimitReached()) return;
        lifeCycle.notify(1, log);
    });
}

});

parcelRegister("2pKQb", function(module, exports) {

$parcel$export(module.exports, "startConsoleCollection", function () { return $56b5c9625a56ca43$export$601e91d68ece5c12; });

var $9SlTq = parcelRequire("9SlTq");

var $2U7BZ = parcelRequire("2U7BZ");
parcelRequire("dLXGC");

var $5tXxv = parcelRequire("5tXxv");
var $6PIx8 = parcelRequire("6PIx8");

var $lePkT = parcelRequire("lePkT");
var $7RJVj = parcelRequire("7RJVj");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/console/consoleCollection.ts
const $56b5c9625a56ca43$export$aed7c9a1c59f7d58 = {
    [(0, $6PIx8.ConsoleApiName).log]: (0, $9SlTq.StatusType).info,
    [(0, $6PIx8.ConsoleApiName).debug]: (0, $9SlTq.StatusType).debug,
    [(0, $6PIx8.ConsoleApiName).info]: (0, $9SlTq.StatusType).info,
    [(0, $6PIx8.ConsoleApiName).warn]: (0, $9SlTq.StatusType).warn,
    [(0, $6PIx8.ConsoleApiName).error]: (0, $9SlTq.StatusType).error
};
function $56b5c9625a56ca43$export$601e91d68ece5c12(configuration, lifeCycle, bufferedDataObservable) {
    const subscription = bufferedDataObservable.subscribe(({ data: log, type: type })=>{
        if (type !== (0, $lePkT.BufferedDataType).CONSOLE || !configuration.forwardConsoleLogs.includes(log.api)) return;
        const collectedData = {
            rawLogsEvent: (0, $5tXxv.combine)({
                date: (0, $1wrwm.timeStampNow)(),
                message: log.message,
                origin: (0, $7RJVj.ErrorSource).CONSOLE,
                error: log.error && (0, $2U7BZ.createErrorFieldFromRawError)(log.error),
                _dd: log.error && {
                    debug_ids: log.error.debugIds
                },
                status: $56b5c9625a56ca43$export$aed7c9a1c59f7d58[log.api]
            }, log.error?.context),
            domainContext: {
                handlingStack: log.handlingStack
            }
        };
        lifeCycle.notify(0, collectedData);
    });
    return {
        stop: ()=>subscription.unsubscribe()
    };
}

});

parcelRegister("03n1p", function(module, exports) {

$parcel$export(module.exports, "startReportCollection", function () { return $91a6ae7f218554ad$export$764db0aca1d0911; });

var $9SlTq = parcelRequire("9SlTq");

var $2U7BZ = parcelRequire("2U7BZ");
parcelRequire("dLXGC");

var $7RJVj = parcelRequire("7RJVj");
var $SMkA1 = parcelRequire("SMkA1");
var $cMPyG = parcelRequire("cMPyG");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/report/reportCollection.ts
function $91a6ae7f218554ad$export$764db0aca1d0911(configuration, lifeCycle) {
    const reportSubscription = (0, $cMPyG.initReportObservable)(configuration.forwardReports).subscribe((rawError)=>{
        let message = rawError.message;
        let error;
        const status = rawError.originalError.type === "deprecation" ? (0, $9SlTq.StatusType).warn : (0, $9SlTq.StatusType).error;
        if (status === (0, $9SlTq.StatusType).error) error = (0, $2U7BZ.createErrorFieldFromRawError)(rawError);
        else if (rawError.stack) message += ` Found in ${(0, $SMkA1.getFileFromStackTraceString)(rawError.stack)}`;
        lifeCycle.notify(0, {
            rawLogsEvent: {
                date: (0, $1wrwm.timeStampNow)(),
                message: message,
                origin: (0, $7RJVj.ErrorSource).REPORT,
                error: error,
                _dd: {
                    debug_ids: rawError.debugIds
                },
                status: status
            }
        });
    });
    return {
        stop: ()=>{
            reportSubscription.unsubscribe();
        }
    };
}

});

parcelRegister("f6mpQ", function(module, exports) {

$parcel$export(module.exports, "startNetworkErrorCollection", function () { return $d5f7ff0a20fd3d83$export$d0c7c81096ec95e; });

var $9SlTq = parcelRequire("9SlTq");
parcelRequire("dLXGC");

var $lePkT = parcelRequire("lePkT");
var $cDxUX = parcelRequire("cDxUX");
var $fiOtf = parcelRequire("fiOtf");
var $7RJVj = parcelRequire("7RJVj");
var $SMkA1 = parcelRequire("SMkA1");
var $lEi17 = parcelRequire("lEi17");
var $aPpOh = parcelRequire("aPpOh");
var $hH6Lc = parcelRequire("hH6Lc");
var $eTAnO = parcelRequire("eTAnO");
var $iXofQ = parcelRequire("iXofQ");
var $bWkrj = parcelRequire("bWkrj");
var $e6zeV = parcelRequire("e6zeV");

var $hWYdN = parcelRequire("hWYdN");
//#region src/domain/networkError/networkErrorCollection.ts
/** arbitrary value, byte precision not needed */ const $d5f7ff0a20fd3d83$export$22e00ed24ca2e25e = 32 * (0, $eTAnO.ONE_KIBI_BYTE);
function $d5f7ff0a20fd3d83$export$d0c7c81096ec95e(configuration, lifeCycle, bufferedDataObservable) {
    if (!configuration.forwardErrorsToLogs) return {
        stop: (0, $hH6Lc.noop)
    };
    (0, $lEi17.initFetchObservable)({
        responseBodyAction: (context)=>isNetworkError(context) ? (0, $lEi17.ResponseBodyAction).COLLECT : (0, $lEi17.ResponseBodyAction).IGNORE
    });
    const subscription = bufferedDataObservable.subscribe(({ data: data, type: type })=>{
        if (type === (0, $lePkT.BufferedDataType).FETCH && data.state === "resolve") handleResponse((0, $iXofQ.RequestType).FETCH, data);
        else if (type === (0, $lePkT.BufferedDataType).XHR && data.state === "complete") handleResponse((0, $iXofQ.RequestType).XHR, data);
    });
    function isNetworkError(request) {
        return !(0, $hWYdN.isIntakeUrl)(request.url) && !request.isAborted && ($d5f7ff0a20fd3d83$var$isRejected(request) || (0, $aPpOh.isServerError)(request.status));
    }
    function handleResponse(type, request) {
        if (!isNetworkError(request)) return;
        const stackTrace = "error" in request && request.error ? (0, $fiOtf.computeStackTrace)(request.error) : void 0;
        const stack = stackTrace ? (0, $e6zeV.toStackTraceString)(stackTrace) : request.responseBody || "Failed to load";
        const debugIds = stackTrace ? (0, $cDxUX.buildDebugIdByUrl)((0, $SMkA1.getStackTraceUrls)(stackTrace)) : void 0;
        const domainContext = {
            handlingStack: request.handlingStack
        };
        lifeCycle.notify(0, {
            rawLogsEvent: {
                message: `${$d5f7ff0a20fd3d83$var$format(type)} error ${request.method} ${request.url}`,
                date: request.startClocks.timeStamp,
                error: {
                    stack: (0, $bWkrj.safeTruncate)(stack, $d5f7ff0a20fd3d83$export$22e00ed24ca2e25e, "..."),
                    handling: void 0
                },
                _dd: {
                    debug_ids: debugIds
                },
                http: {
                    method: request.method,
                    status_code: request.status,
                    url: request.url
                },
                status: (0, $9SlTq.StatusType).error,
                origin: (0, $7RJVj.ErrorSource).NETWORK
            },
            domainContext: domainContext
        });
    }
    return {
        stop: ()=>subscription.unsubscribe()
    };
}
function $d5f7ff0a20fd3d83$var$isRejected(request) {
    return request.status === 0 && request.responseType !== "opaque";
}
function $d5f7ff0a20fd3d83$var$format(type) {
    if ((0, $iXofQ.RequestType).XHR === type) return "XHR";
    return "Fetch";
}

});

parcelRegister("gTUoD", function(module, exports) {

$parcel$export(module.exports, "startRuntimeErrorCollection", function () { return $49dcf1c4ed810347$export$ae6d2c609a1d871; });

var $9SlTq = parcelRequire("9SlTq");

var $2U7BZ = parcelRequire("2U7BZ");
parcelRequire("dLXGC");

var $5tXxv = parcelRequire("5tXxv");

var $lePkT = parcelRequire("lePkT");
var $7RJVj = parcelRequire("7RJVj");
var $hH6Lc = parcelRequire("hH6Lc");
//#region src/domain/runtimeError/runtimeErrorCollection.ts
function $49dcf1c4ed810347$export$ae6d2c609a1d871(configuration, lifeCycle, bufferedDataObservable) {
    if (!configuration.forwardErrorsToLogs) return {
        stop: (0, $hH6Lc.noop)
    };
    const rawErrorSubscription = bufferedDataObservable.subscribe((bufferedData)=>{
        if (bufferedData.type === (0, $lePkT.BufferedDataType).RUNTIME_ERROR) {
            const error = bufferedData.data;
            lifeCycle.notify(0, {
                rawLogsEvent: (0, $5tXxv.combine)({
                    message: error.message,
                    date: error.startClocks.timeStamp,
                    error: (0, $2U7BZ.createErrorFieldFromRawError)(error),
                    _dd: {
                        debug_ids: error.debugIds
                    },
                    origin: (0, $7RJVj.ErrorSource).SOURCE,
                    status: (0, $9SlTq.StatusType).error
                }, error.context)
            });
        }
    });
    return {
        stop: ()=>{
            rawErrorSubscription.unsubscribe();
        }
    };
}

});

parcelRegister("l1xsN", function(module, exports) {

$parcel$export(module.exports, "startLoggerCollection", function () { return $acb08f5aed3f7fad$export$a909fdf2eb14fa81; });

var $9SlTq = parcelRequire("9SlTq");

var $gQCCP = parcelRequire("gQCCP");
parcelRequire("dLXGC");

var $5tXxv = parcelRequire("5tXxv");
var $6PIx8 = parcelRequire("6PIx8");

var $7RJVj = parcelRequire("7RJVj");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/logger/loggerCollection.ts
function $acb08f5aed3f7fad$export$a909fdf2eb14fa81(lifeCycle) {
    function handleLog(logsMessage, logger, handlingStack, savedCommonContext, savedDate) {
        const messageContext = (0, $5tXxv.combine)(logger.getContext(), logsMessage.context);
        if ((0, $9SlTq.isAuthorized)(logsMessage.status, (0, $gQCCP.HandlerType).console, logger)) $acb08f5aed3f7fad$var$displayInConsole(logsMessage, messageContext);
        if ((0, $9SlTq.isAuthorized)(logsMessage.status, (0, $gQCCP.HandlerType).http, logger)) {
            const rawLogEventData = {
                rawLogsEvent: (0, $5tXxv.combine)({
                    date: savedDate || (0, $1wrwm.timeStampNow)(),
                    message: logsMessage.message,
                    status: logsMessage.status,
                    origin: (0, $7RJVj.ErrorSource).LOGGER,
                    _dd: {
                        debug_ids: logsMessage.debugIds
                    }
                }, messageContext),
                savedCommonContext: savedCommonContext,
                ddtags: logger.getTags()
            };
            if (handlingStack) rawLogEventData.domainContext = {
                handlingStack: handlingStack
            };
            lifeCycle.notify(0, rawLogEventData);
        }
    }
    return {
        handleLog: handleLog
    };
}
const $acb08f5aed3f7fad$var$loggerToConsoleApiName = {
    [(0, $9SlTq.StatusType).ok]: (0, $6PIx8.ConsoleApiName).debug,
    [(0, $9SlTq.StatusType).debug]: (0, $6PIx8.ConsoleApiName).debug,
    [(0, $9SlTq.StatusType).info]: (0, $6PIx8.ConsoleApiName).info,
    [(0, $9SlTq.StatusType).notice]: (0, $6PIx8.ConsoleApiName).info,
    [(0, $9SlTq.StatusType).warn]: (0, $6PIx8.ConsoleApiName).warn,
    [(0, $9SlTq.StatusType).error]: (0, $6PIx8.ConsoleApiName).error,
    [(0, $9SlTq.StatusType).critical]: (0, $6PIx8.ConsoleApiName).error,
    [(0, $9SlTq.StatusType).alert]: (0, $6PIx8.ConsoleApiName).error,
    [(0, $9SlTq.StatusType).emerg]: (0, $6PIx8.ConsoleApiName).error
};
function $acb08f5aed3f7fad$var$displayInConsole({ status: status, message: message }, messageContext) {
    (0, $6PIx8.originalConsoleMethods)[$acb08f5aed3f7fad$var$loggerToConsoleApiName[status]].call((0, $6PIx8.globalConsole), message, messageContext);
}

});

parcelRegister("i1e8f", function(module, exports) {

$parcel$export(module.exports, "startLogsBatch", function () { return $d65f0c912de7bcb1$export$e4658c4e9fa6ec0a; });
parcelRequire("dLXGC");

var $luYWf = parcelRequire("luYWf");

var $k8VFU = parcelRequire("k8VFU");
//#region src/transport/startLogsBatch.ts
function $d65f0c912de7bcb1$export$e4658c4e9fa6ec0a(configuration, lifeCycle, reportError, sessionManager) {
    const endpoints = [
        (0, $k8VFU.createEndpointBuilder)(configuration, "logs")
    ];
    const replicaEndpoint = (0, $k8VFU.createReplicaEndpointBuilder)(configuration, "logs");
    if (replicaEndpoint) endpoints.push(replicaEndpoint);
    const batch = (0, $luYWf.createBatch)({
        endpoints: endpoints,
        reportError: reportError
    });
    sessionManager.expireObservable.subscribe(()=>batch.forceFlush("session_expire"));
    lifeCycle.subscribe(1, (serverLogsEvent)=>{
        batch.add(serverLogsEvent);
    });
    return batch;
}

});

parcelRegister("bQq97", function(module, exports) {

$parcel$export(module.exports, "startLogsBridge", function () { return $007eedb7d2c87603$export$4849c54cce6266f6; });
parcelRequire("dLXGC");

var $gS0nt = parcelRequire("gS0nt");
//#region src/transport/startLogsBridge.ts
function $007eedb7d2c87603$export$4849c54cce6266f6(lifeCycle) {
    const bridge = (0, $gS0nt.getEventBridge)();
    lifeCycle.subscribe(1, (serverLogsEvent)=>{
        bridge.send("log", serverLogsEvent);
    });
}

});

parcelRegister("aSOEX", function(module, exports) {

$parcel$export(module.exports, "startInternalContext", function () { return $567a1c3694e7a0ca$export$ee941cf091e8459; });
//#region src/domain/contexts/internalContext.ts
function $567a1c3694e7a0ca$export$ee941cf091e8459(sessionManager) {
    return {
        get: (startTime)=>{
            const trackedSession = sessionManager.findTrackedSession(startTime);
            if (trackedSession) return {
                session_id: trackedSession.id
            };
        }
    };
}

});

parcelRegister("gwpsB", function(module, exports) {

$parcel$export(module.exports, "startReportError", function () { return $2bd0fb2b2f9a7751$export$ec67f68cd82e645c; });

var $9SlTq = parcelRequire("9SlTq");
parcelRequire("dLXGC");

var $461Vl = parcelRequire("461Vl");
var $7RJVj = parcelRequire("7RJVj");

var $1wrwm = parcelRequire("1wrwm");
//#region src/domain/reportError.ts
function $2bd0fb2b2f9a7751$export$ec67f68cd82e645c(lifeCycle) {
    return (message)=>{
        lifeCycle.notify(0, {
            rawLogsEvent: {
                message: message,
                date: (0, $1wrwm.timeStampNow)(),
                origin: (0, $7RJVj.ErrorSource).AGENT,
                status: (0, $9SlTq.StatusType).error
            }
        });
        (0, $461Vl.addTelemetryDebug)("Error reported to customer", {
            "error.message": message
        });
    };
}

});

parcelRegister("lAh61", function(module, exports) {

$parcel$export(module.exports, "startRUMInternalContext", function () { return $e12613260165c6bd$export$dc1587cb7c68e163; });

var $c2Qhr = parcelRequire("c2Qhr");

var $eQBSl = parcelRequire("eQBSl");

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/contexts/rumInternalContext.ts
function $e12613260165c6bd$export$dc1587cb7c68e163(hooks) {
    const browserWindow = (0, $c2Qhr.globalObject);
    hooks.assembleEventDefaults.register(({ startTime: startTime })=>{
        const internalContext = getRUMInternalContext(startTime);
        if (!internalContext) return 0, $fNtjE.SKIPPED;
        return internalContext;
    });
    hooks.assembleTelemetry.register(({ startTime: startTime })=>{
        const internalContext = getRUMInternalContext(startTime);
        if (!internalContext) return 0, $fNtjE.SKIPPED;
        return {
            application: {
                id: internalContext.application_id
            },
            view: {
                id: internalContext.view?.id
            },
            action: {
                id: internalContext.user_action?.id
            }
        };
    });
    function getRUMInternalContext(startTime) {
        const rumContext = getInternalContextFromRumGlobal(startTime, (0, $eQBSl.willSyntheticsInjectRum)() ? browserWindow.DD_RUM_SYNTHETICS : browserWindow.DD_RUM);
        if (rumContext) return rumContext;
    }
    function getInternalContextFromRumGlobal(startTime, rumGlobal) {
        if (rumGlobal?.getInternalContext) return rumGlobal.getInternalContext(startTime);
    }
}

});

parcelRegister("8cAzf", function(module, exports) {

$parcel$export(module.exports, "startSessionContext", function () { return $e91a58fc3d7d0da8$export$930c4ba5de05acaa; });

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/contexts/sessionContext.ts
function $e91a58fc3d7d0da8$export$930c4ba5de05acaa(hook, configuration, sessionManager) {
    hook.register(({ startTime: startTime })=>{
        const session = sessionManager.findTrackedSession(startTime);
        if (!sessionManager.findTrackedSession(startTime, {
            returnInactive: true,
            maxAge: Infinity
        })) return 0, $fNtjE.DISCARDED;
        return {
            service: configuration.service,
            session_id: session ? session.id : void 0,
            session: session ? {
                id: session.id
            } : void 0
        };
    });
}

});


parcelRegister("1sIcC", function(module, exports) {

$parcel$export(module.exports, "createPreStartStrategy", function () { return $b675de1d47fff042$export$8f7002373dcc6602; });

var $eu1uA = parcelRequire("eu1uA");

var $gQaas = parcelRequire("gQaas");

var $6hCNq = parcelRequire("6hCNq");

var $je1xP = parcelRequire("je1xP");

var $461Vl = parcelRequire("461Vl");
var $aAvkZ = parcelRequire("aAvkZ");
var $fnvkG = parcelRequire("fnvkG");
var $dmc88 = parcelRequire("dmc88");
var $4B1f5 = parcelRequire("4B1f5");
var $7P6fE = parcelRequire("7P6fE");
var $gS0nt = parcelRequire("gS0nt");
var $95eAR = parcelRequire("95eAR");
var $jq8c3 = parcelRequire("jq8c3");
var $81mt8 = parcelRequire("81mt8");
var $fOYzt = parcelRequire("fOYzt");
var $dvi3b = parcelRequire("dvi3b");
var $bOZaS = parcelRequire("bOZaS");
var $hH6Lc = parcelRequire("hH6Lc");
var $50cui = parcelRequire("50cui");
var $a6fzQ = parcelRequire("a6fzQ");
var $kL392 = parcelRequire("kL392");

var $dee0n = parcelRequire("dee0n");

var $1wrwm = parcelRequire("1wrwm");
//#region src/boot/preStartLogs.ts
function $b675de1d47fff042$export$8f7002373dcc6602(getCommonContext, trackingConsentState, doStartLogs, sdkName) {
    const bufferApiCalls = new (0, $fnvkG.BufferedObservable)(500, (count)=>{
        (0, $461Vl.addTelemetryDebug)("preStartLogs buffer data lost", {
            count: count
        });
    });
    const globalContext = (0, $4B1f5.buildGlobalContextManager)();
    (0, $aAvkZ.bufferContextCalls)(globalContext, (0, $95eAR.CustomerContextKey).globalContext, bufferApiCalls);
    const accountContext = (0, $dmc88.buildAccountContextManager)();
    (0, $aAvkZ.bufferContextCalls)(accountContext, (0, $95eAR.CustomerContextKey).accountContext, bufferApiCalls);
    const userContext = (0, $7P6fE.buildUserContextManager)();
    (0, $aAvkZ.bufferContextCalls)(userContext, (0, $95eAR.CustomerContextKey).userContext, bufferApiCalls);
    let cachedInitConfiguration;
    let cachedConfiguration;
    let sessionManager;
    const hooks = (0, $gQaas.createHooks)();
    const trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartLogs);
    function tryStartLogs() {
        if (!cachedConfiguration || !cachedInitConfiguration || !sessionManager) return;
        trackingConsentStateSubscription.unsubscribe();
        const startLogsResult = doStartLogs(cachedConfiguration, sessionManager, hooks);
        bufferApiCalls.subscribe((callback)=>callback(startLogsResult));
        bufferApiCalls.unbuffer();
    }
    return {
        init (initConfiguration, publicApi, errorStack) {
            if (!initConfiguration) {
                (0, $jq8c3.display).error("Missing configuration");
                return;
            }
            (0, $fOYzt.initFeatureFlags)(initConfiguration.enableExperimentalFeatures);
            (0, $50cui.setAllowUntrustedEvents)(initConfiguration.allowUntrustedEvents);
            if ((0, $gS0nt.canUseEventBridge)()) initConfiguration = $b675de1d47fff042$var$overrideInitConfigurationForBridge(initConfiguration);
            cachedInitConfiguration = initConfiguration;
            if (cachedConfiguration) {
                (0, $81mt8.displayAlreadyInitializedError)("DD_LOGS", initConfiguration);
                return;
            }
            (0, $eu1uA.callPluginsMethod)(initConfiguration.plugins, "onInit", {
                initConfiguration: initConfiguration,
                publicApi: publicApi,
                registerAssembleEventHook: hooks.assembleEvent.register
            });
            const configuration = (0, $6hCNq.validateAndBuildLogsConfiguration)(initConfiguration);
            if (!configuration || !(0, $dvi3b.isAllowedTrackingOrigins)(configuration, errorStack ?? "")) return;
            cachedConfiguration = configuration;
            trackingConsentState.tryToInit(configuration.trackingConsent);
            trackingConsentState.onGrantedOnce(()=>{
                (0, $je1xP.startTrackingConsentContext)(hooks, trackingConsentState);
                (0, $bOZaS.mockable)((0, $461Vl.startTelemetry))((0, $461Vl.TelemetryService).LOGS, configuration, hooks.assembleTelemetry, sdkName);
                const onSessionManagerReady = (newSessionManager)=>{
                    sessionManager = newSessionManager;
                    (0, $kL392.startTelemetrySessionContext)(hooks.assembleTelemetry, sessionManager);
                    (0, $461Vl.addTelemetryConfiguration)((0, $6hCNq.serializeLogsConfiguration)(initConfiguration));
                    tryStartLogs();
                };
                if ((0, $gS0nt.canUseEventBridge)()) onSessionManagerReady((0, $a6fzQ.startSessionManagerStub)());
                else (0, $bOZaS.mockable)((0, $a6fzQ.startSessionManager))(configuration, trackingConsentState).then((newSessionManager)=>{
                    if (newSessionManager) onSessionManagerReady(newSessionManager);
                }).catch((0, $dee0n.monitorError));
            });
        },
        get initConfiguration () {
            return cachedInitConfiguration;
        },
        globalContext: globalContext,
        accountContext: accountContext,
        userContext: userContext,
        getInternalContext: (0, $hH6Lc.noop),
        handleLog (message, statusType, handlingStack, context = getCommonContext(), date = (0, $1wrwm.timeStampNow)()) {
            bufferApiCalls.notify((startLogsResult)=>startLogsResult.handleLog(message, statusType, handlingStack, context, date));
        }
    };
}
function $b675de1d47fff042$var$overrideInitConfigurationForBridge(initConfiguration) {
    return {
        ...initConfiguration,
        clientToken: "empty"
    };
}

});
parcelRegister("gQaas", function(module, exports) {

$parcel$export(module.exports, "createHooks", function () { return $ba50a3b04d626e0b$export$39c6a2b4dbabca5d; });

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/hooks.ts
function $ba50a3b04d626e0b$export$39c6a2b4dbabca5d() {
    return {
        assembleEventDefaults: (0, $fNtjE.createHook)(),
        assembleTelemetry: (0, $fNtjE.createHook)(),
        assembleEvent: (0, $fNtjE.createHook)()
    };
}

});

parcelRegister("6hCNq", function(module, exports) {

$parcel$export(module.exports, "validateAndBuildLogsConfiguration", function () { return $e851038168cc6a19$export$97b29d6675c29e61; });
$parcel$export(module.exports, "serializeLogsConfiguration", function () { return $e851038168cc6a19$export$3cd09719b205537a; });

var $6PIx8 = parcelRequire("6PIx8");

var $9O7SB = parcelRequire("9O7SB");
var $4wo62 = parcelRequire("4wo62");
var $jq8c3 = parcelRequire("jq8c3");
var $cMPyG = parcelRequire("cMPyG");

var $b6w9H = parcelRequire("b6w9H");
//#region src/domain/configuration.ts
const $e851038168cc6a19$export$8aeaa81da64b9ad8 = {
    ...(0, $9O7SB.BROWSER_CORE_SCHEMA),
    forwardErrorsToLogs: {
        type: "boolean",
        default: true,
        strict: false
    },
    forwardConsoleLogs: {
        type: "enum",
        values: (0, $6PIx8.ConsoleApiName),
        multiple: true,
        allowAll: true,
        default: []
    },
    forwardReports: {
        type: "enum",
        values: (0, $cMPyG.RawReportType),
        multiple: true,
        allowAll: true,
        default: []
    },
    plugins: {
        type: "schema",
        multiple: true,
        strict: false,
        default: [],
        schema: {
            name: {
                type: "string",
                required: true
            },
            getConfigurationTelemetry: {
                type: "function",
                strict: false,
                signature: void 0
            },
            onInit: {
                type: "function",
                strict: false,
                signature: void 0
            },
            onLogsStart: {
                type: "function",
                strict: false,
                signature: void 0
            }
        }
    }
};
function $e851038168cc6a19$export$97b29d6675c29e61(initConfiguration) {
    const config = (0, $b6w9H.validateAndBuildConfiguration)(initConfiguration, $e851038168cc6a19$export$8aeaa81da64b9ad8, (0, $jq8c3.display));
    if (!config) return;
    return {
        ...config,
        beforeSend: config.beforeSend ? (0, $4wo62.catchUserErrors)(config.beforeSend, "beforeSend threw an error:") : void 0
    };
}
function $e851038168cc6a19$export$3cd09719b205537a(configuration) {
    const baseSerializedInitConfiguration = (0, $9O7SB.serializeConfiguration)(configuration);
    return {
        forward_errors_to_logs: configuration.forwardErrorsToLogs,
        forward_console_logs: configuration.forwardConsoleLogs,
        forward_reports: configuration.forwardReports,
        plugins: configuration.plugins?.map((plugin)=>({
                name: plugin.name,
                ...plugin.getConfigurationTelemetry?.()
            })),
        ...baseSerializedInitConfiguration
    };
}

});

parcelRegister("je1xP", function(module, exports) {

$parcel$export(module.exports, "startTrackingConsentContext", function () { return $d5a8b1a8fec7b24c$export$43dc707f6931474b; });

var $fNtjE = parcelRequire("fNtjE");
//#region src/domain/contexts/trackingConsentContext.ts
function $d5a8b1a8fec7b24c$export$43dc707f6931474b(hooks, trackingConsentState) {
    function isConsented() {
        if (!trackingConsentState.isGranted()) return 0, $fNtjE.DISCARDED;
        return 0, $fNtjE.SKIPPED;
    }
    hooks.assembleEventDefaults.register(isConsented);
    hooks.assembleTelemetry.register(isConsented);
}

});




parcelRegister("jdCKi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ded0b9f0137d849$export$2e2bcd8739ae039; });
/* eslint-disable import/no-cycle */ parcelRequire("cFAEN");
var $4JHq1 = parcelRequire("4JHq1");

var $96Qh9 = parcelRequire("96Qh9");
const $1ded0b9f0137d849$var$env = (0, $4JHq1.default)(window.location);
const $1ded0b9f0137d849$var$version = "cloud-staging-20261105-01";
const $1ded0b9f0137d849$var$firebaseProduction = {
    apiKey: "AIzaSyBqpwriBEqjp1kVG0_PkruuWBg4VWQQirc",
    authDomain: "volley-web-production.firebaseapp.com",
    projectId: "volley-web-production",
    messagingSenderId: "884471169963",
    appId: "1:884471169963:web:65e228d70e0142ade948ee"
};
const $1ded0b9f0137d849$var$firebaseStaging = {
    apiKey: "AIzaSyC3aFyszleli58YwXsYwidflsQGfFQnjns",
    authDomain: "volley-web-staging.firebaseapp.com",
    projectId: "volley-web-staging",
    messagingSenderId: "1070126318692",
    appId: "1:1070126318692:web:be4c3943610fd9172a4b71"
};
const $1ded0b9f0137d849$var$firebaseRc = {
    apiKey: "AIzaSyAI2sRJcifXFyoAZmDeKF8upK2-OczW7Vg",
    authDomain: "volley-web-rc.firebaseapp.com",
    projectId: "volley-web-rc",
    messagingSenderId: "191844139284",
    appId: "1:191844139284:web:562e9f50febf9de46d4201"
};
const $1ded0b9f0137d849$var$datadogLogging = {
    clientToken: "pubbe07b92048ab4c7e176d8d18d4678af9",
    site: "us5.datadoghq.com",
    forwardErrorsToLogs: $1ded0b9f0137d849$var$env !== "local",
    // forwardErrorsToLogs stopped covering console.error in SDK v7
    forwardConsoleLogs: $1ded0b9f0137d849$var$env !== "local" ? [
        "error"
    ] : [],
    sessionSampleRate: 100,
    version: $1ded0b9f0137d849$var$version,
    beforeSend: (log)=>{
        if (log.view) {
            log.view.url = (0, $96Qh9.default)(log.view.url);
            log.view.referrer = (0, $96Qh9.default)(log.view.referrer);
        }
        return true;
    }
};
const $1ded0b9f0137d849$var$datadogRum = {
    applicationId: "0df780c6-2fb1-4255-911a-85a3fbb83196",
    clientToken: "pubbe07b92048ab4c7e176d8d18d4678af9",
    site: "us5.datadoghq.com",
    service: "webby-app",
    env: $1ded0b9f0137d849$var$env,
    version: $1ded0b9f0137d849$var$version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
    trackResources: true,
    allowedTracingUrls: [
        "https://staging.onevolley.com",
        "https://rc.onevolley.com",
        "https://play.onevolley.com",
        "https://app.onevolley.com",
        "https://staging.getvolley.com",
        "https://rc.getvolley.com",
        "https://play.getvolley.com",
        "https://app.getvolley.com",
        "https://scottm.ngrok.app"
    ],
    // SDK v7 defaults this on, adding a `baggage` header with the RUM session
    // and user IDs to traced requests. webby-server's OpenTelemetry re-sends
    // incoming baggage on its own outgoing HTTP calls, which would hand those
    // IDs to third-party APIs, and Cloud Trace does nothing with them.
    propagateTraceBaggage: false,
    beforeSend: (event)=>{
        // Returning false will prevent the event from being sent
        // we cannot discard page views, but we can discard actions
        if (event.view.url.includes("/admin") && event.type !== "view") return false;
        event.view.url = (0, $96Qh9.default)(event.view.url);
        event.view.referrer = (0, $96Qh9.default)(event.view.referrer);
        if (event.type === "resource") event.resource.url = (0, $96Qh9.default)(event.resource.url);
        return true;
    }
};
let $1ded0b9f0137d849$var$firebase = $1ded0b9f0137d849$var$firebaseStaging;
if ($1ded0b9f0137d849$var$env === "rc") $1ded0b9f0137d849$var$firebase = $1ded0b9f0137d849$var$firebaseRc;
else if ($1ded0b9f0137d849$var$env === "production") $1ded0b9f0137d849$var$firebase = $1ded0b9f0137d849$var$firebaseProduction;
const $1ded0b9f0137d849$var$intercomProduction = {
    appId: "qmxtzegi",
    name: "production-workspace"
};
const $1ded0b9f0137d849$var$intercomTest = {
    appId: "v0s3kwm6",
    name: "development-workspace"
};
let $1ded0b9f0137d849$var$intercom = $1ded0b9f0137d849$var$intercomTest;
if ($1ded0b9f0137d849$var$env === "production") $1ded0b9f0137d849$var$intercom = $1ded0b9f0137d849$var$intercomProduction;
// Each hosted Club-in-Club verifies tokens against exactly one Firebase project, so this has
// to name the deployment that shares ours -- a token minted for one project cannot be redeemed
// against a deployment configured for another. Chosen the same way as `firebase` and
// `intercom` above:
//   - staging (volley-web-staging) -> clubinclub-staging.getvolley.com, staging's own deployment;
//   - production (and rc)          -> clubinclub.getvolley.com;
//   - local                        -> a Club-in-Club run from its own repo on 5050.
// It must agree with webby-server's CLUB_IN_CLUB_BASE_URL for the same environment, which the
// widget's tap-through uses (k8s-config overlays).
let $1ded0b9f0137d849$var$clubInClubUrl = "https://clubinclub.getvolley.com/";
if ($1ded0b9f0137d849$var$env === "staging") $1ded0b9f0137d849$var$clubInClubUrl = "https://clubinclub-staging.getvolley.com/";
else if ($1ded0b9f0137d849$var$env === "local") $1ded0b9f0137d849$var$clubInClubUrl = "http://localhost:5050/";
const $1ded0b9f0137d849$var$config = {
    firebase: $1ded0b9f0137d849$var$firebase,
    datadogRum: $1ded0b9f0137d849$var$datadogRum,
    datadogLogging: $1ded0b9f0137d849$var$datadogLogging,
    intercom: $1ded0b9f0137d849$var$intercom,
    env: $1ded0b9f0137d849$var$env,
    version: $1ded0b9f0137d849$var$version,
    clubInClubUrl: $1ded0b9f0137d849$var$clubInClubUrl
};
var $1ded0b9f0137d849$export$2e2bcd8739ae039 = $1ded0b9f0137d849$var$config;

});
parcelRegister("cFAEN", function(module, exports) {

$parcel$export(module.exports, "round", function () { return $d714600b9ca5fa8b$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "usDateFormat", function () { return $d714600b9ca5fa8b$export$d5000a69432361a8; });
$parcel$export(module.exports, "verboseDateFormat", function () { return $d714600b9ca5fa8b$export$e6044523813ab5a2; });
$parcel$export(module.exports, "terseTimeFormat", function () { return $d714600b9ca5fa8b$export$6d36757fdb0d26bc; });
$parcel$export(module.exports, "terseDateFormat", function () { return $d714600b9ca5fa8b$export$230f0ab927f84128; });
$parcel$export(module.exports, "isoDateFormat", function () { return $d714600b9ca5fa8b$export$b0f7439824c9ada5; });
$parcel$export(module.exports, "timeOnlyFormat", function () { return $d714600b9ca5fa8b$export$78486ff2ea77b7ed; });
$parcel$export(module.exports, "getEnv", function () { return (parcelRequire("4JHq1")).default; });
$parcel$export(module.exports, "fetchApi", function () { return (parcelRequire("cK0UE")).default; });
$parcel$export(module.exports, "logFetchError", function () { return (parcelRequire("cK0UE")).logFetchError; });
$parcel$export(module.exports, "userFacingFetchMessage", function () { return (parcelRequire("cK0UE")).userFacingFetchMessage; });
$parcel$export(module.exports, "timeoutInit", function () { return (parcelRequire("fEgSm")).timeoutInit; });
/* eslint-disable import/no-cycle */ 
var $W8pDg = parcelRequire("W8pDg");

var $4JHq1 = parcelRequire("4JHq1");

var $cK0UE = parcelRequire("cK0UE");

var $fEgSm = parcelRequire("fEgSm");
const $d714600b9ca5fa8b$export$2077e0241d6afd3c = (num, places)=>Math.round((num + Number.EPSILON) * 10 ** places) / 10 ** places;
const $d714600b9ca5fa8b$export$d5000a69432361a8 = (0, $W8pDg.format)("M/dd/yyyy h:mm:ss aa");
const $d714600b9ca5fa8b$export$e6044523813ab5a2 = (0, $W8pDg.format)("LLLL d, yyyy");
const $d714600b9ca5fa8b$export$6d36757fdb0d26bc = (0, $W8pDg.format)("M/dd/yyyy hh:mm aa");
const $d714600b9ca5fa8b$export$230f0ab927f84128 = (0, $W8pDg.format)("M/dd/yyyy");
const $d714600b9ca5fa8b$export$b0f7439824c9ada5 = (0, $W8pDg.format)("yyyy-MM-dd");
const $d714600b9ca5fa8b$export$78486ff2ea77b7ed = (0, $W8pDg.format)("h:mm aa");

});
parcelRegister("W8pDg", function(module, exports) {

$parcel$export(module.exports, "format", function () { return $0aebf16d2abac4f8$export$d9468344d3651243; });
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

var $iMHZI = parcelRequire("iMHZI");

var $litXD = parcelRequire("litXD");
const $0aebf16d2abac4f8$export$d9468344d3651243 = (0, $litXD.convertToFP)((0, $iMHZI.format), 2);
var // Fallback for modularized imports:
$0aebf16d2abac4f8$export$2e2bcd8739ae039 = $0aebf16d2abac4f8$export$d9468344d3651243;

});
parcelRegister("iMHZI", function(module, exports) {

$parcel$export(module.exports, "format", function () { return $daced60c1cc75d5c$export$d9468344d3651243; });
$parcel$export(module.exports, "longFormatters", function () { return (parcelRequire("6NrGM")).longFormatters; });

var $6ycOY = parcelRequire("6ycOY");

var $kTedh = parcelRequire("kTedh");

var $1N6AJ = parcelRequire("1N6AJ");

var $6NrGM = parcelRequire("6NrGM");

var $9MRqa = parcelRequire("9MRqa");

var $44FAT = parcelRequire("44FAT");

var $1E9XN = parcelRequire("1E9XN");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $daced60c1cc75d5c$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $daced60c1cc75d5c$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $daced60c1cc75d5c$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $daced60c1cc75d5c$var$doubleQuoteRegExp = /''/g;
const $daced60c1cc75d5c$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $daced60c1cc75d5c$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $kTedh.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $6ycOY.enUS);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $1E9XN.toDate)(date, options?.in);
    if (!(0, $44FAT.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($daced60c1cc75d5c$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $6NrGM.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($daced60c1cc75d5c$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $daced60c1cc75d5c$var$cleanEscapedString(substring)
        };
        if ((0, $1N6AJ.formatters)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($daced60c1cc75d5c$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $9MRqa.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, $9MRqa.isProtectedDayOfYearToken)(token)) (0, $9MRqa.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = (0, $1N6AJ.formatters)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $daced60c1cc75d5c$var$cleanEscapedString(input) {
    const matched = input.match($daced60c1cc75d5c$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($daced60c1cc75d5c$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$daced60c1cc75d5c$export$2e2bcd8739ae039 = $daced60c1cc75d5c$export$d9468344d3651243;

});
parcelRegister("6ycOY", function(module, exports) {

$parcel$export(module.exports, "enUS", function () { return $4c4fdd1168cf2305$export$137380d9ce54f7f; });

var $bYiy4 = parcelRequire("bYiy4");

var $gouW0 = parcelRequire("gouW0");

var $il5Ip = parcelRequire("il5Ip");

var $e5dwE = parcelRequire("e5dwE");

var $l8qum = parcelRequire("l8qum");
const $4c4fdd1168cf2305$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $bYiy4.formatDistance),
    formatLong: (0, $gouW0.formatLong),
    formatRelative: (0, $il5Ip.formatRelative),
    localize: (0, $e5dwE.localize),
    match: (0, $l8qum.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$4c4fdd1168cf2305$export$2e2bcd8739ae039 = $4c4fdd1168cf2305$export$137380d9ce54f7f;

});
parcelRegister("bYiy4", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $8b73afab9ce7f525$export$2c14ff85d6318973; });
const $8b73afab9ce7f525$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $8b73afab9ce7f525$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $8b73afab9ce7f525$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

});

parcelRegister("gouW0", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $bef6e2302229fdb0$export$cbf60ecb96cbb82f; });

var $wIskX = parcelRequire("wIskX");
const $bef6e2302229fdb0$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $bef6e2302229fdb0$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $bef6e2302229fdb0$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $bef6e2302229fdb0$export$cbf60ecb96cbb82f = {
    date: (0, $wIskX.buildFormatLongFn)({
        formats: $bef6e2302229fdb0$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $wIskX.buildFormatLongFn)({
        formats: $bef6e2302229fdb0$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $wIskX.buildFormatLongFn)({
        formats: $bef6e2302229fdb0$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("wIskX", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", function () { return $06257951afd76b8b$export$38e44e97ce4dbb7d; });
function $06257951afd76b8b$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("il5Ip", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $d59e9f1d03c561df$export$8fbbfd65594f46a0; });
const $d59e9f1d03c561df$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $d59e9f1d03c561df$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$d59e9f1d03c561df$var$formatRelativeLocale[token];

});

parcelRegister("e5dwE", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $a40c06359575c36d$export$b3bd0bc58e36cd63; });

var $4A8Nt = parcelRequire("4A8Nt");
const $a40c06359575c36d$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $a40c06359575c36d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $a40c06359575c36d$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $a40c06359575c36d$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $a40c06359575c36d$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $a40c06359575c36d$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $a40c06359575c36d$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $a40c06359575c36d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $a40c06359575c36d$var$ordinalNumber,
    era: (0, $4A8Nt.buildLocalizeFn)({
        values: $a40c06359575c36d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4A8Nt.buildLocalizeFn)({
        values: $a40c06359575c36d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4A8Nt.buildLocalizeFn)({
        values: $a40c06359575c36d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4A8Nt.buildLocalizeFn)({
        values: $a40c06359575c36d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4A8Nt.buildLocalizeFn)({
        values: $a40c06359575c36d$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a40c06359575c36d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("4A8Nt", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", function () { return $3561591de78d1346$export$63596d6ee8878b25; });
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $3561591de78d1346$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("l8qum", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $f62ee46be3000302$export$4659b591c19bdf3d; });

var $exqOn = parcelRequire("exqOn");

var $kqHi7 = parcelRequire("kqHi7");
const $f62ee46be3000302$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $f62ee46be3000302$var$parseOrdinalNumberPattern = /\d+/i;
const $f62ee46be3000302$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $f62ee46be3000302$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $f62ee46be3000302$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $f62ee46be3000302$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $f62ee46be3000302$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $f62ee46be3000302$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $f62ee46be3000302$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $f62ee46be3000302$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $f62ee46be3000302$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $f62ee46be3000302$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $f62ee46be3000302$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $kqHi7.buildMatchPatternFn)({
        matchPattern: $f62ee46be3000302$var$matchOrdinalNumberPattern,
        parsePattern: $f62ee46be3000302$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $exqOn.buildMatchFn)({
        matchPatterns: $f62ee46be3000302$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f62ee46be3000302$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $exqOn.buildMatchFn)({
        matchPatterns: $f62ee46be3000302$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f62ee46be3000302$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $exqOn.buildMatchFn)({
        matchPatterns: $f62ee46be3000302$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f62ee46be3000302$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $exqOn.buildMatchFn)({
        matchPatterns: $f62ee46be3000302$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f62ee46be3000302$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $exqOn.buildMatchFn)({
        matchPatterns: $f62ee46be3000302$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $f62ee46be3000302$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("exqOn", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", function () { return $a958f1f81eb1542a$export$1430a0f35710914d; });
function $a958f1f81eb1542a$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $a958f1f81eb1542a$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $a958f1f81eb1542a$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $a958f1f81eb1542a$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $a958f1f81eb1542a$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("kqHi7", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", function () { return $edf7d116aa30cb26$export$fdaf2fd6d7edde95; });
function $edf7d116aa30cb26$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});



parcelRegister("kTedh", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $f353f82076d3b532$export$430a3269e24b912e; });
let $f353f82076d3b532$var$defaultOptions = {};
function $f353f82076d3b532$export$430a3269e24b912e() {
    return $f353f82076d3b532$var$defaultOptions;
}
function $f353f82076d3b532$export$95365be1b0704abc(newOptions) {
    $f353f82076d3b532$var$defaultOptions = newOptions;
}

});

parcelRegister("1N6AJ", function(module, exports) {

$parcel$export(module.exports, "formatters", function () { return $14df7afc360abb03$export$fe98a034cfb96d55; });

var $4S2jr = parcelRequire("4S2jr");

var $breGW = parcelRequire("breGW");

var $02k4z = parcelRequire("02k4z");

var $i66LE = parcelRequire("i66LE");

var $fT8XI = parcelRequire("fT8XI");

var $7k21F = parcelRequire("7k21F");

var $dXbB4 = parcelRequire("dXbB4");
const $14df7afc360abb03$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $14df7afc360abb03$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $dXbB4.lightFormatters).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $fT8XI.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $7k21F.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $7k21F.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $02k4z.getISOWeekYear)(date);
        // Padding
        return (0, $7k21F.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $7k21F.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $7k21F.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $7k21F.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $dXbB4.lightFormatters).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $7k21F.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $i66LE.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $7k21F.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $breGW.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $7k21F.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $dXbB4.lightFormatters).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $4S2jr.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $7k21F.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $7k21F.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $7k21F.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $7k21F.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $14df7afc360abb03$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $14df7afc360abb03$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $14df7afc360abb03$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $14df7afc360abb03$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $14df7afc360abb03$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $14df7afc360abb03$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $dXbB4.lightFormatters).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $dXbB4.lightFormatters).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $7k21F.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $7k21F.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $dXbB4.lightFormatters).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $dXbB4.lightFormatters).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $dXbB4.lightFormatters).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $14df7afc360abb03$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $14df7afc360abb03$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $14df7afc360abb03$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $14df7afc360abb03$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $14df7afc360abb03$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $14df7afc360abb03$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $14df7afc360abb03$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $14df7afc360abb03$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $14df7afc360abb03$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $14df7afc360abb03$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $7k21F.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $7k21F.addLeadingZeros)(+date, token.length);
    }
};
function $14df7afc360abb03$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $7k21F.addLeadingZeros)(minutes, 2);
}
function $14df7afc360abb03$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $7k21F.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $14df7afc360abb03$var$formatTimezone(offset, delimiter);
}
function $14df7afc360abb03$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $7k21F.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $7k21F.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("4S2jr", function(module, exports) {

$parcel$export(module.exports, "getDayOfYear", function () { return $38bdffd1cd03a775$export$d3b42cd8452deec; });

var $9Qmul = parcelRequire("9Qmul");

var $iV9PQ = parcelRequire("iV9PQ");

var $1E9XN = parcelRequire("1E9XN");
function $38bdffd1cd03a775$export$d3b42cd8452deec(date, options) {
    const _date = (0, $1E9XN.toDate)(date, options?.in);
    const diff = (0, $9Qmul.differenceInCalendarDays)(_date, (0, $iV9PQ.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$38bdffd1cd03a775$export$2e2bcd8739ae039 = $38bdffd1cd03a775$export$d3b42cd8452deec;

});
parcelRegister("9Qmul", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarDays", function () { return $72aa6a24832f876d$export$4a02e9c37dab4871; });

var $ib2QH = parcelRequire("ib2QH");

var $9Sr82 = parcelRequire("9Sr82");

var $kS8D1 = parcelRequire("kS8D1");

var $5o5SD = parcelRequire("5o5SD");
function $72aa6a24832f876d$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $9Sr82.normalizeDates)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $5o5SD.startOfDay)(laterDate_);
    const earlierStartOfDay = (0, $5o5SD.startOfDay)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $ib2QH.getTimezoneOffsetInMilliseconds)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $ib2QH.getTimezoneOffsetInMilliseconds)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $kS8D1.millisecondsInDay));
}
var // Fallback for modularized imports:
$72aa6a24832f876d$export$2e2bcd8739ae039 = $72aa6a24832f876d$export$4a02e9c37dab4871;

});
parcelRegister("ib2QH", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", function () { return $d3bb76cfe0976e3f$export$113002b5eff6e430; });

var $1E9XN = parcelRequire("1E9XN");
function $d3bb76cfe0976e3f$export$113002b5eff6e430(date) {
    const _date = (0, $1E9XN.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});
parcelRegister("1E9XN", function(module, exports) {

$parcel$export(module.exports, "toDate", function () { return $1331416c10fd5cc1$export$e67a095c620b86fe; });

var $2EKlW = parcelRequire("2EKlW");
function $1331416c10fd5cc1$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $2EKlW.constructFrom)(context || argument, argument);
}
var // Fallback for modularized imports:
$1331416c10fd5cc1$export$2e2bcd8739ae039 = $1331416c10fd5cc1$export$e67a095c620b86fe;

});
parcelRegister("2EKlW", function(module, exports) {

$parcel$export(module.exports, "constructFrom", function () { return $1ef345f01f51e00e$export$ead8a1812b171991; });

var $kS8D1 = parcelRequire("kS8D1");
function $1ef345f01f51e00e$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $kS8D1.constructFromSymbol) in date) return date[0, $kS8D1.constructFromSymbol](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$1ef345f01f51e00e$export$2e2bcd8739ae039 = $1ef345f01f51e00e$export$ead8a1812b171991;

});
parcelRegister("kS8D1", function(module, exports) {

$parcel$export(module.exports, "millisecondsInWeek", function () { return $f31f8b3a3596de95$export$4fad13613e88edc8; });
$parcel$export(module.exports, "millisecondsInDay", function () { return $f31f8b3a3596de95$export$b76b1809a2898f9a; });
$parcel$export(module.exports, "millisecondsInMinute", function () { return $f31f8b3a3596de95$export$91246f0b9bd9beff; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $f31f8b3a3596de95$export$7f72910d6dfd237a; });
$parcel$export(module.exports, "millisecondsInSecond", function () { return $f31f8b3a3596de95$export$397c2d5776aa9055; });
$parcel$export(module.exports, "minutesInMonth", function () { return $f31f8b3a3596de95$export$ab7da2ccd1075c38; });
$parcel$export(module.exports, "minutesInDay", function () { return $f31f8b3a3596de95$export$2423174df8cd3cd2; });
$parcel$export(module.exports, "constructFromSymbol", function () { return $f31f8b3a3596de95$export$2a7b97929c48d47d; });
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $f31f8b3a3596de95$export$dfd9b671c89acc8e = 7;
const $f31f8b3a3596de95$export$3913210603d8e9ae = 365.2425;
const $f31f8b3a3596de95$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $f31f8b3a3596de95$export$4dec998e48f9c246 = -$f31f8b3a3596de95$export$81caae6e1cc7a622;
const $f31f8b3a3596de95$export$4fad13613e88edc8 = 604800000;
const $f31f8b3a3596de95$export$b76b1809a2898f9a = 86400000;
const $f31f8b3a3596de95$export$91246f0b9bd9beff = 60000;
const $f31f8b3a3596de95$export$7f72910d6dfd237a = 3600000;
const $f31f8b3a3596de95$export$397c2d5776aa9055 = 1000;
const $f31f8b3a3596de95$export$3633035e63cee86a = 525600;
const $f31f8b3a3596de95$export$ab7da2ccd1075c38 = 43200;
const $f31f8b3a3596de95$export$2423174df8cd3cd2 = 1440;
const $f31f8b3a3596de95$export$f2f5ae5a8e2d8f9f = 60;
const $f31f8b3a3596de95$export$3c58128db900d44e = 3;
const $f31f8b3a3596de95$export$80d7e435f744f319 = 12;
const $f31f8b3a3596de95$export$4db7641526e3241f = 4;
const $f31f8b3a3596de95$export$698aec755e92c695 = 3600;
const $f31f8b3a3596de95$export$a77c1a7ebebe2a5a = 60;
const $f31f8b3a3596de95$export$815a9362476d2fe3 = $f31f8b3a3596de95$export$698aec755e92c695 * 24;
const $f31f8b3a3596de95$export$34804a017b31e2fe = $f31f8b3a3596de95$export$815a9362476d2fe3 * 7;
const $f31f8b3a3596de95$export$7271e9e3478110d1 = $f31f8b3a3596de95$export$815a9362476d2fe3 * $f31f8b3a3596de95$export$3913210603d8e9ae;
const $f31f8b3a3596de95$export$8e6600bbdee7dabb = $f31f8b3a3596de95$export$7271e9e3478110d1 / 12;
const $f31f8b3a3596de95$export$be1dccf2de902d31 = $f31f8b3a3596de95$export$8e6600bbdee7dabb * 3;
const $f31f8b3a3596de95$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");

});




parcelRegister("9Sr82", function(module, exports) {

$parcel$export(module.exports, "normalizeDates", function () { return $730e3364ffec7c5f$export$9f53b88e82f64d8d; });

var $2EKlW = parcelRequire("2EKlW");
function $730e3364ffec7c5f$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $2EKlW.constructFrom).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}

});

parcelRegister("5o5SD", function(module, exports) {

$parcel$export(module.exports, "startOfDay", function () { return $3ec3c15518c3f430$export$63fa379ae8a9ba2; });

var $1E9XN = parcelRequire("1E9XN");
function $3ec3c15518c3f430$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $1E9XN.toDate)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$3ec3c15518c3f430$export$2e2bcd8739ae039 = $3ec3c15518c3f430$export$63fa379ae8a9ba2;

});


parcelRegister("iV9PQ", function(module, exports) {

$parcel$export(module.exports, "startOfYear", function () { return $dc652def543aac3f$export$f91e89d3d0406102; });

var $1E9XN = parcelRequire("1E9XN");
function $dc652def543aac3f$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $1E9XN.toDate)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$dc652def543aac3f$export$2e2bcd8739ae039 = $dc652def543aac3f$export$f91e89d3d0406102;

});


parcelRegister("breGW", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", function () { return $853d9ccb1a38e019$export$7cabdc5698b63e2f; });

var $kS8D1 = parcelRequire("kS8D1");

var $gGqDr = parcelRequire("gGqDr");

var $6EfKG = parcelRequire("6EfKG");

var $1E9XN = parcelRequire("1E9XN");
function $853d9ccb1a38e019$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $1E9XN.toDate)(date, options?.in);
    const diff = +(0, $gGqDr.startOfISOWeek)(_date) - +(0, $6EfKG.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $kS8D1.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$853d9ccb1a38e019$export$2e2bcd8739ae039 = $853d9ccb1a38e019$export$7cabdc5698b63e2f;

});
parcelRegister("gGqDr", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", function () { return $c2553ac5290461c2$export$6173213f95a4431e; });

var $3Vw9s = parcelRequire("3Vw9s");
function $c2553ac5290461c2$export$6173213f95a4431e(date, options) {
    return (0, $3Vw9s.startOfWeek)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$c2553ac5290461c2$export$2e2bcd8739ae039 = $c2553ac5290461c2$export$6173213f95a4431e;

});
parcelRegister("3Vw9s", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", function () { return $2dbfa29a6c8eccb5$export$42c81a444fbfb5d4; });

var $kTedh = parcelRequire("kTedh");

var $1E9XN = parcelRequire("1E9XN");
function $2dbfa29a6c8eccb5$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $kTedh.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $1E9XN.toDate)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$2dbfa29a6c8eccb5$export$2e2bcd8739ae039 = $2dbfa29a6c8eccb5$export$42c81a444fbfb5d4;

});


parcelRegister("6EfKG", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", function () { return $4d72b27e81c47202$export$236bdfa374eb69a9; });

var $2EKlW = parcelRequire("2EKlW");

var $02k4z = parcelRequire("02k4z");

var $gGqDr = parcelRequire("gGqDr");
function $4d72b27e81c47202$export$236bdfa374eb69a9(date, options) {
    const year = (0, $02k4z.getISOWeekYear)(date, options);
    const fourthOfJanuary = (0, $2EKlW.constructFrom)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $gGqDr.startOfISOWeek)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$4d72b27e81c47202$export$2e2bcd8739ae039 = $4d72b27e81c47202$export$236bdfa374eb69a9;

});
parcelRegister("02k4z", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", function () { return $006fc20a684690aa$export$3dbc52535f6f8fcc; });

var $2EKlW = parcelRequire("2EKlW");

var $gGqDr = parcelRequire("gGqDr");

var $1E9XN = parcelRequire("1E9XN");
function $006fc20a684690aa$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $1E9XN.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $2EKlW.constructFrom)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $gGqDr.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $2EKlW.constructFrom)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $gGqDr.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$006fc20a684690aa$export$2e2bcd8739ae039 = $006fc20a684690aa$export$3dbc52535f6f8fcc;

});



parcelRegister("i66LE", function(module, exports) {

$parcel$export(module.exports, "getWeek", function () { return $d2ce096fd86b7d04$export$efe19b760242b2fc; });

var $kS8D1 = parcelRequire("kS8D1");

var $3Vw9s = parcelRequire("3Vw9s");

var $dTc39 = parcelRequire("dTc39");

var $1E9XN = parcelRequire("1E9XN");
function $d2ce096fd86b7d04$export$efe19b760242b2fc(date, options) {
    const _date = (0, $1E9XN.toDate)(date, options?.in);
    const diff = +(0, $3Vw9s.startOfWeek)(_date, options) - +(0, $dTc39.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $kS8D1.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$d2ce096fd86b7d04$export$2e2bcd8739ae039 = $d2ce096fd86b7d04$export$efe19b760242b2fc;

});
parcelRegister("dTc39", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", function () { return $a1c9c23d1c25765f$export$bb7b45bb8e74da0f; });

var $kTedh = parcelRequire("kTedh");

var $2EKlW = parcelRequire("2EKlW");

var $fT8XI = parcelRequire("fT8XI");

var $3Vw9s = parcelRequire("3Vw9s");
function $a1c9c23d1c25765f$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $kTedh.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $fT8XI.getWeekYear)(date, options);
    const firstWeek = (0, $2EKlW.constructFrom)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $3Vw9s.startOfWeek)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$a1c9c23d1c25765f$export$2e2bcd8739ae039 = $a1c9c23d1c25765f$export$bb7b45bb8e74da0f;

});
parcelRegister("fT8XI", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", function () { return $b912f1c940f5f799$export$12d572480ceb6e58; });

var $kTedh = parcelRequire("kTedh");

var $2EKlW = parcelRequire("2EKlW");

var $3Vw9s = parcelRequire("3Vw9s");

var $1E9XN = parcelRequire("1E9XN");
function $b912f1c940f5f799$export$12d572480ceb6e58(date, options) {
    const _date = (0, $1E9XN.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $kTedh.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $2EKlW.constructFrom)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $3Vw9s.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $2EKlW.constructFrom)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $3Vw9s.startOfWeek)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$b912f1c940f5f799$export$2e2bcd8739ae039 = $b912f1c940f5f799$export$12d572480ceb6e58;

});



parcelRegister("7k21F", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", function () { return $554bf8f44e39f395$export$c8306e720e213c0f; });
function $554bf8f44e39f395$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("dXbB4", function(module, exports) {

$parcel$export(module.exports, "lightFormatters", function () { return $a289c7f136875893$export$b0d4b338e1516f13; });

var $7k21F = parcelRequire("7k21F");
const $a289c7f136875893$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $7k21F.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $7k21F.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $7k21F.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $7k21F.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $7k21F.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $7k21F.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $7k21F.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $7k21F.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("6NrGM", function(module, exports) {

$parcel$export(module.exports, "longFormatters", function () { return $4f2ccc2847d84b9d$export$70cc8fd02856fd58; });
const $4f2ccc2847d84b9d$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $4f2ccc2847d84b9d$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $4f2ccc2847d84b9d$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $4f2ccc2847d84b9d$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $4f2ccc2847d84b9d$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $4f2ccc2847d84b9d$var$timeLongFormatter(timePattern, formatLong));
};
const $4f2ccc2847d84b9d$export$70cc8fd02856fd58 = {
    p: $4f2ccc2847d84b9d$var$timeLongFormatter,
    P: $4f2ccc2847d84b9d$var$dateTimeLongFormatter
};

});

parcelRegister("9MRqa", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $7202090db55fb6ef$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $7202090db55fb6ef$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "warnOrThrowProtectedError", function () { return $7202090db55fb6ef$export$f5f38f90ecaaf879; });
const $7202090db55fb6ef$var$dayOfYearTokenRE = /^D+$/;
const $7202090db55fb6ef$var$weekYearTokenRE = /^Y+$/;
const $7202090db55fb6ef$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $7202090db55fb6ef$export$c6cc36aa33304772(token) {
    return $7202090db55fb6ef$var$dayOfYearTokenRE.test(token);
}
function $7202090db55fb6ef$export$c6b49d6dceb604a1(token) {
    return $7202090db55fb6ef$var$weekYearTokenRE.test(token);
}
function $7202090db55fb6ef$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $7202090db55fb6ef$var$message(token, format, input);
    console.warn(_message);
    if ($7202090db55fb6ef$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $7202090db55fb6ef$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});

parcelRegister("44FAT", function(module, exports) {

$parcel$export(module.exports, "isValid", function () { return $2f77ccde46dd137f$export$1ea939691cdc45b8; });

var $aP9FJ = parcelRequire("aP9FJ");

var $1E9XN = parcelRequire("1E9XN");
function $2f77ccde46dd137f$export$1ea939691cdc45b8(date) {
    return !(!(0, $aP9FJ.isDate)(date) && typeof date !== "number" || isNaN(+(0, $1E9XN.toDate)(date)));
}
var // Fallback for modularized imports:
$2f77ccde46dd137f$export$2e2bcd8739ae039 = $2f77ccde46dd137f$export$1ea939691cdc45b8;

});
parcelRegister("aP9FJ", function(module, exports) {

$parcel$export(module.exports, "isDate", function () { return $7e162b774029e79e$export$871608497c498473; });
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $7e162b774029e79e$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$7e162b774029e79e$export$2e2bcd8739ae039 = $7e162b774029e79e$export$871608497c498473;

});



parcelRegister("litXD", function(module, exports) {

$parcel$export(module.exports, "convertToFP", function () { return $f812850049af036a$export$fd9936600310116b; });
/**
 * Converts a function to a curried function that accepts arguments in reverse
 * order.
 *
 * @param fn - The function to convert to FP
 * @param arity - The arity of the function
 * @param curriedArgs - The curried arguments
 *
 * @returns FP version of the function
 *
 * @private
 */ function $f812850049af036a$export$fd9936600310116b(fn, arity, curriedArgs = []) {
    return curriedArgs.length >= arity ? fn(...curriedArgs.slice(0, arity).reverse()) : (...args)=>$f812850049af036a$export$fd9936600310116b(fn, arity, curriedArgs.concat(args));
}

});


parcelRegister("4JHq1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d599ad5313515fb4$export$2e2bcd8739ae039; });
function $d599ad5313515fb4$export$2e2bcd8739ae039(location) {
    const { host: host } = location;
    if (host.includes("play.getvolley") || host.includes("app.getvolley") || host.includes("play.onevolley") || host.includes("app.onevolley")) return "production";
    if (host.includes("staging.getvolley") || host.includes("staging.onevolley")) return "staging";
    if (host.includes("ngrok.app")) return "ngrok";
    if (host.includes("rc.getvolley") || host.includes("rc.onevolley")) return "rc";
    return "local";
}

});

parcelRegister("cK0UE", function(module, exports) {

$parcel$export(module.exports, "FetchError", function () { return $48c2568ffa6c4e00$export$26e841bcf1aeb894; });
$parcel$export(module.exports, "PairRequiredError", function () { return $48c2568ffa6c4e00$export$3ebc707b47a27c75; });
$parcel$export(module.exports, "userFacingFetchMessage", function () { return $48c2568ffa6c4e00$export$c67b0f15a0849d9d; });
$parcel$export(module.exports, "default", function () { return $48c2568ffa6c4e00$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "fetchApiBlob", function () { return $48c2568ffa6c4e00$export$78cc64c45bbc132a; });
$parcel$export(module.exports, "pairedFetchApi", function () { return $48c2568ffa6c4e00$export$c5067c8749163823; });
$parcel$export(module.exports, "logFetchError", function () { return $48c2568ffa6c4e00$export$34d99c6be62b3468; });
$parcel$export(module.exports, "FETCH_TIMEOUT_MESSAGE", function () { return (parcelRequire("fEgSm")).FETCH_TIMEOUT_MESSAGE; });
$parcel$export(module.exports, "isAbortError", function () { return (parcelRequire("fEgSm")).isAbortError; });
$parcel$export(module.exports, "timeoutInit", function () { return (parcelRequire("fEgSm")).timeoutInit; });
/* eslint-disable import/no-cycle */ parcelRequire("eyjy7");
var $fgDKG = parcelRequire("fgDKG");

var $1lMle = parcelRequire("1lMle");

var $fEgSm = parcelRequire("fEgSm");
class $48c2568ffa6c4e00$export$26e841bcf1aeb894 extends Error {
    statusCode;
    info;
    method;
    errorCode = null;
    /**
     * The parsed JSON error body, when the response had one. Errors carry more
     * than a message for some endpoints (a retry timestamp, a limit), and
     * re-deriving that from the message string is worse than keeping it.
     */ body = null;
    constructor(code, method, info, message, errorCode, body){
        super(message);
        this.statusCode = code;
        this.method = method;
        this.info = info;
        this.errorCode = errorCode ?? null;
        this.body = body ?? null;
    }
}
class $48c2568ffa6c4e00$export$3ebc707b47a27c75 extends Error {
    method;
    info;
    constructor(method, info, message){
        super(message);
        this.method = method;
        this.info = info;
    }
}
function $48c2568ffa6c4e00$export$c67b0f15a0849d9d(e, fallback) {
    if ((0, $fEgSm.isAbortError)(e)) return 0, $fEgSm.FETCH_TIMEOUT_MESSAGE;
    if (e instanceof $48c2568ffa6c4e00$export$26e841bcf1aeb894 && e.statusCode < 500 && e.message) return e.message;
    return fallback;
}
async function $48c2568ffa6c4e00$export$2e2bcd8739ae039(info, method = "GET", body, init = {}) {
    const baseHeaders = {
        accept: "application/json, text/plain, */*",
        "content-type": "application/json",
        "x-requested-with": "fetch"
    };
    const { currentUser: currentUser } = (0, $fgDKG.p)();
    if (currentUser) {
        const token = await currentUser.getIdToken();
        baseHeaders.authorization = `Bearer ${token}`;
    }
    init.method = method;
    init.headers = {
        ...baseHeaders,
        ...init.headers
    };
    if (body) init.body = JSON.stringify(body);
    // Only add a default timeout if no signal is provided at all
    if (!init.signal && AbortSignal?.timeout) init.signal = AbortSignal.timeout(10000);
    (0, $1lMle.default).debug(`FETCHING - [${init.method || "GET"}] ${info}`);
    const res = await fetch(info, init);
    (0, $1lMle.default).debug(`[${init.method || "GET"}] ${info}: ${res.status} - [${res.statusText}] - ${res.ok ? "ok" : "failed"}`);
    if (res.headers.get("content-type")?.includes("application/json")) {
        const resJson = await res.json();
        if (!res.ok) {
            const err = resJson;
            throw new $48c2568ffa6c4e00$export$26e841bcf1aeb894(res.status, method, info, err.message, err.code, resJson);
        }
        return resJson;
    }
    if (!res.ok) throw new $48c2568ffa6c4e00$export$26e841bcf1aeb894(res.status, method, info, `HTTP fetch error: ${res.status}: ${await res.text()}`);
    return null;
}
async function $48c2568ffa6c4e00$export$78cc64c45bbc132a(info, init = {}) {
    const headers = {
        "x-requested-with": "fetch"
    };
    const { currentUser: currentUser } = (0, $fgDKG.p)();
    if (currentUser) headers.authorization = `Bearer ${await currentUser.getIdToken()}`;
    if (!init.signal && AbortSignal?.timeout) init.signal = AbortSignal.timeout(20000);
    const res = await fetch(info, {
        ...init,
        headers: {
            ...headers,
            ...init.headers
        }
    });
    if (!res.ok) throw new $48c2568ffa6c4e00$export$26e841bcf1aeb894(res.status, init.method ?? "GET", info, `HTTP fetch error: ${res.status}: ${(await res.text()).slice(0, 200)}`);
    return res.blob();
}
async function $48c2568ffa6c4e00$export$c5067c8749163823(trainerId, apiUrl, method = "GET", body, init = {}) {
    if (!trainerId) throw new $48c2568ffa6c4e00$export$3ebc707b47a27c75(method, apiUrl, "No trainer id provided");
    const baseUrl = `/trainer/${trainerId}`;
    const fullUrl = `${baseUrl}${apiUrl.startsWith("/") ? "" : "/"}${apiUrl}`;
    return $48c2568ffa6c4e00$export$2e2bcd8739ae039(fullUrl, method, body, init);
}
function $48c2568ffa6c4e00$export$34d99c6be62b3468(e, message) {
    let context = "";
    if (message) context = `${message}:\r\n`;
    if (e instanceof $48c2568ffa6c4e00$export$26e841bcf1aeb894) (0, $1lMle.default).error(`${context}${e.message}, status: ${e.statusCode}, [${e.method}] - ${JSON.stringify(e.info)}`);
    else if (e instanceof $48c2568ffa6c4e00$export$3ebc707b47a27c75) (0, $1lMle.default).error(`${context}${e.message}, [${e.method}] - ${JSON.stringify(e.info)}`);
    else (0, $1lMle.default).error(`${context}Unexpected error fetching: ${JSON.stringify(e, [
        "message",
        "type",
        "name"
    ])}`);
}

});
parcelRegister("eyjy7", function(module, exports) {
$parcel$export(module.exports, "confirmPasswordReset", function () { return (parcelRequire("fgDKG")).a7; });
$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("fgDKG")).p; });
$parcel$export(module.exports, "GoogleAuthProvider", function () { return (parcelRequire("fgDKG")).Y; });
$parcel$export(module.exports, "OAuthProvider", function () { return (parcelRequire("fgDKG"))._; });
$parcel$export(module.exports, "onAuthStateChanged", function () { return (parcelRequire("fgDKG")).z; });
$parcel$export(module.exports, "sendPasswordResetEmail", function () { return (parcelRequire("fgDKG")).a6; });
$parcel$export(module.exports, "signInWithCustomToken", function () { return (parcelRequire("fgDKG")).a5; });
$parcel$export(module.exports, "signInWithEmailAndPassword", function () { return (parcelRequire("fgDKG")).ac; });
$parcel$export(module.exports, "signInWithPopup", function () { return (parcelRequire("fgDKG")).d; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("fgDKG")).D; });
$parcel$export(module.exports, "verifyPasswordResetCode", function () { return (parcelRequire("fgDKG")).aa; });
parcelRequire("cMxtE");

});
parcelRegister("cMxtE", function(module, exports) {

$parcel$export(module.exports, "GoogleAuthProvider", function () { return (parcelRequire("fgDKG")).Y; });
$parcel$export(module.exports, "OAuthProvider", function () { return (parcelRequire("fgDKG"))._; });
$parcel$export(module.exports, "confirmPasswordReset", function () { return (parcelRequire("fgDKG")).a7; });
$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("fgDKG")).p; });
$parcel$export(module.exports, "onAuthStateChanged", function () { return (parcelRequire("fgDKG")).z; });
$parcel$export(module.exports, "sendPasswordResetEmail", function () { return (parcelRequire("fgDKG")).a6; });
$parcel$export(module.exports, "signInWithCustomToken", function () { return (parcelRequire("fgDKG")).a5; });
$parcel$export(module.exports, "signInWithEmailAndPassword", function () { return (parcelRequire("fgDKG")).ac; });
$parcel$export(module.exports, "signInWithPopup", function () { return (parcelRequire("fgDKG")).d; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("fgDKG")).D; });
$parcel$export(module.exports, "verifyPasswordResetCode", function () { return (parcelRequire("fgDKG")).aa; });

var $fgDKG = parcelRequire("fgDKG");
parcelRequire("bVYHX");
parcelRequire("9k0Bn");
parcelRequire("6mnY8");
parcelRequire("aPEEV");

});
parcelRegister("fgDKG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b1d72f86dd9d3107$export$71511d61b312f219; });
$parcel$export(module.exports, "Y", function () { return $b1d72f86dd9d3107$export$8743009a87fcb00f; });
$parcel$export(module.exports, "a5", function () { return $b1d72f86dd9d3107$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "a6", function () { return $b1d72f86dd9d3107$export$2e2af4578d910ddf; });
$parcel$export(module.exports, "a7", function () { return $b1d72f86dd9d3107$export$a93c5207d687da10; });
$parcel$export(module.exports, "aa", function () { return $b1d72f86dd9d3107$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "ac", function () { return $b1d72f86dd9d3107$export$2219238a014317b0; });
$parcel$export(module.exports, "z", function () { return $b1d72f86dd9d3107$export$df995fae86a55f06; });
$parcel$export(module.exports, "D", function () { return $b1d72f86dd9d3107$export$96f57966bedc81b4; });
$parcel$export(module.exports, "d", function () { return $b1d72f86dd9d3107$export$4368d992c4eafac0; });
$parcel$export(module.exports, "p", function () { return $b1d72f86dd9d3107$export$ffb5f4729a158638; });

var $bVYHX = parcelRequire("bVYHX");

var $9k0Bn = parcelRequire("9k0Bn");

var $6mnY8 = parcelRequire("6mnY8");

var $aPEEV = parcelRequire("aPEEV");
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $b1d72f86dd9d3107$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $b1d72f86dd9d3107$export$9e5f44173e64f162 = {
    /** Facebook provider ID */ FACEBOOK: 'facebook.com',
    /** GitHub provider ID */ GITHUB: 'github.com',
    /** Google provider ID */ GOOGLE: 'google.com',
    /** Password provider */ PASSWORD: 'password',
    /** Phone provider */ PHONE: 'phone',
    /** Twitter provider ID */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $b1d72f86dd9d3107$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */ EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */ FACEBOOK: 'facebook.com',
    /** GitHub sign in method */ GITHUB: 'github.com',
    /** Google sign in method */ GOOGLE: 'google.com',
    /** Phone sign in method */ PHONE: 'phone',
    /** Twitter sign in method */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $b1d72f86dd9d3107$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */ SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $b1d72f86dd9d3107$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */ PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */ RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */ VERIFY_EMAIL: 'VERIFY_EMAIL'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1d72f86dd9d3107$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: 'The mobile app identifier is not registered for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: 'The supplied auth credential is incorrect, malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is invalid when sending request to the backend.',
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: 'The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.',
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: 'The password does not meet the requirements.',
        ["invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ ]: "The provided Hosting link domain is not configured in Firebase Hosting or is not owned by the current project. This cannot be a default Hosting domain (`web.app` or `firebaseapp.com`)."
    };
}
function $b1d72f86dd9d3107$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $b1d72f86dd9d3107$export$7f8ddf7c7c20b3cd = $b1d72f86dd9d3107$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $b1d72f86dd9d3107$export$9bb611d729802a56 = $b1d72f86dd9d3107$var$_prodErrorMap;
const $b1d72f86dd9d3107$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $9k0Bn.ErrorFactory)('auth', 'Firebase', $b1d72f86dd9d3107$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $b1d72f86dd9d3107$export$b4171a6734a65d42 = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_PASSWORD: 'auth/missing-password',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type',
    INVALID_HOSTING_LINK_DOMAIN: 'auth/invalid-hosting-link-domain'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$logClient = new (0, $6mnY8.Logger)('@firebase/auth');
function $b1d72f86dd9d3107$var$_logWarn(msg, ...args) {
    if ($b1d72f86dd9d3107$var$logClient.logLevel <= (0, $6mnY8.LogLevel).WARN) $b1d72f86dd9d3107$var$logClient.warn(`Auth (${(0, $bVYHX.SDK_VERSION)}): ${msg}`, ...args);
}
function $b1d72f86dd9d3107$var$_logError(msg, ...args) {
    if ($b1d72f86dd9d3107$var$logClient.logLevel <= (0, $6mnY8.LogLevel).ERROR) $b1d72f86dd9d3107$var$logClient.error(`Auth (${(0, $bVYHX.SDK_VERSION)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1d72f86dd9d3107$export$28f7fcd39efa255(authOrCode, ...rest) {
    throw $b1d72f86dd9d3107$var$createErrorInternal(authOrCode, ...rest);
}
function $b1d72f86dd9d3107$export$890c4ad488842ce7(authOrCode, ...rest) {
    return $b1d72f86dd9d3107$var$createErrorInternal(authOrCode, ...rest);
}
function $b1d72f86dd9d3107$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = {
        ...$b1d72f86dd9d3107$export$9bb611d729802a56(),
        [code]: message
    };
    const factory = new (0, $9k0Bn.ErrorFactory)('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $b1d72f86dd9d3107$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'Operations that alter the current user are not supported in conjunction with FirebaseServerApp');
}
function $b1d72f86dd9d3107$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $b1d72f86dd9d3107$export$28f7fcd39efa255(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $b1d72f86dd9d3107$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $b1d72f86dd9d3107$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $b1d72f86dd9d3107$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $b1d72f86dd9d3107$export$24baa2b76016ce0e(assertion, authOrCode, ...rest) {
    if (!assertion) throw $b1d72f86dd9d3107$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $b1d72f86dd9d3107$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $b1d72f86dd9d3107$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $b1d72f86dd9d3107$export$d66dc83d8cfc8dd(assertion, message) {
    if (!assertion) $b1d72f86dd9d3107$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1d72f86dd9d3107$var$_getCurrentUrl() {
    return typeof self !== 'undefined' && self.location?.href || '';
}
function $b1d72f86dd9d3107$var$_isHttpOrHttps() {
    return $b1d72f86dd9d3107$var$_getCurrentScheme() === 'http:' || $b1d72f86dd9d3107$var$_getCurrentScheme() === 'https:';
}
function $b1d72f86dd9d3107$var$_getCurrentScheme() {
    return typeof self !== 'undefined' && self.location?.protocol || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $b1d72f86dd9d3107$var$_isOnline() {
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($b1d72f86dd9d3107$var$_isHttpOrHttps() || (0, $9k0Bn.isBrowserExtension)() || 'connection' in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $b1d72f86dd9d3107$var$_getUserLanguage() {
    if (typeof navigator === 'undefined') return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $b1d72f86dd9d3107$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $b1d72f86dd9d3107$export$d66dc83d8cfc8dd(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0, $9k0Bn.isMobileCordova)() || (0, $9k0Bn.isReactNative)();
    }
    get() {
        if (!$b1d72f86dd9d3107$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1d72f86dd9d3107$var$_emulatorUrl(config, path) {
    $b1d72f86dd9d3107$export$d66dc83d8cfc8dd(config.emulator, 'Emulator should always be set here');
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1d72f86dd9d3107$export$f96d196f7728bb5 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== 'undefined' && 'fetch' in self) return self.fetch;
        if (typeof globalThis !== 'undefined' && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== 'undefined') return fetch;
        $b1d72f86dd9d3107$var$debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== 'undefined' && 'Headers' in self) return self.Headers;
        if (typeof globalThis !== 'undefined' && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== 'undefined') return Headers;
        $b1d72f86dd9d3107$var$debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== 'undefined' && 'Response' in self) return self.Response;
        if (typeof globalThis !== 'undefined' && globalThis.Response) return globalThis.Response;
        if (typeof Response !== 'undefined') return Response;
        $b1d72f86dd9d3107$var$debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $b1d72f86dd9d3107$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$CookieAuthProxiedEndpoints = [
    "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ ,
    "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ ,
    "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ ,
    "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ ,
    "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ ,
    "/v1/token" /* Endpoint.TOKEN */ 
];
const $b1d72f86dd9d3107$var$DEFAULT_API_TIMEOUT_MS = new $b1d72f86dd9d3107$var$Delay(30000, 60000);
function $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return {
        ...request,
        tenantId: auth.tenantId
    };
    return request;
}
async function $b1d72f86dd9d3107$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $b1d72f86dd9d3107$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $9k0Bn.querystring)({
            key: auth.config.apiKey,
            ...params
        }).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/json';
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = {
            method: method,
            headers: headers,
            ...body
        };
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, $9k0Bn.isCloudflareWorker)()) fetchArgs.referrerPolicy = 'no-referrer';
        if (auth.emulatorConfig && (0, $9k0Bn.isCloudWorkstation)(auth.emulatorConfig.host)) fetchArgs.credentials = 'include';
        return $b1d72f86dd9d3107$export$f96d196f7728bb5.fetch()(await $b1d72f86dd9d3107$var$_getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function $b1d72f86dd9d3107$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = {
        ...$b1d72f86dd9d3107$var$SERVER_ERROR_MAP,
        ...customErrorMap
    };
    try {
        const networkTimeout = new $b1d72f86dd9d3107$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) throw $b1d72f86dd9d3107$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !('errorMessage' in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $b1d72f86dd9d3107$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $b1d72f86dd9d3107$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $b1d72f86dd9d3107$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');
            if (serverErrorMessage) throw $b1d72f86dd9d3107$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $b1d72f86dd9d3107$export$28f7fcd39efa255(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $9k0Bn.FirebaseError)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $b1d72f86dd9d3107$export$28f7fcd39efa255(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            'message': String(e)
        });
    }
}
async function $b1d72f86dd9d3107$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $b1d72f86dd9d3107$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ('mfaPendingCredential' in serverResponse) $b1d72f86dd9d3107$export$28f7fcd39efa255(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
async function $b1d72f86dd9d3107$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    const authInternal = auth;
    const finalTarget = authInternal.config.emulator ? $b1d72f86dd9d3107$var$_emulatorUrl(auth.config, base) : `${auth.config.apiScheme}://${base}`;
    // Cookie auth works by MiTMing the signIn and token endpoints from the developer's backend,
    // saving the idToken and refreshToken into cookies, and then redacting the refreshToken
    // from the response
    if ($b1d72f86dd9d3107$var$CookieAuthProxiedEndpoints.includes(path)) {
        // Persistence manager is async, we need to await it. We can't just wait for auth initialized
        // here since auth initialization calls this function.
        await authInternal._persistenceManagerAvailable;
        if (authInternal._getPersistenceType() === "COOKIE" /* PersistenceType.COOKIE */ ) {
            const cookiePersistence = authInternal._getPersistence();
            return cookiePersistence._getFinalTarget(finalTarget).toString();
        }
    }
    return finalTarget;
}
function $b1d72f86dd9d3107$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case 'ENFORCE':
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case 'AUDIT':
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case 'OFF':
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $b1d72f86dd9d3107$var$NetworkTimeout {
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($b1d72f86dd9d3107$export$890c4ad488842ce7(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $b1d72f86dd9d3107$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
}
function $b1d72f86dd9d3107$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $b1d72f86dd9d3107$export$890c4ad488842ce7(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1d72f86dd9d3107$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $b1d72f86dd9d3107$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $b1d72f86dd9d3107$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = '';
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error('recaptchaKey undefined');
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $b1d72f86dd9d3107$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
    /**
     * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
     * returns false.
     *
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
     */ isAnyProviderEnabled() {
        return this.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) || this.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$var$getRecaptchaParams(auth) {
    return (await $b1d72f86dd9d3107$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || '';
}
async function $b1d72f86dd9d3107$var$getRecaptchaConfig(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$var$deleteAccount(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $b1d72f86dd9d3107$var$deleteLinkedAccounts(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $b1d72f86dd9d3107$var$getAccountInfo(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1d72f86dd9d3107$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$7a38258bbe170828(user, forceRefresh = false) {
    return (0, $9k0Bn.getModularInstance)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$2f6ca3d3b1f80bf5(user, forceRefresh = false) {
    const userInternal = (0, $9k0Bn.getModularInstance)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $b1d72f86dd9d3107$var$_parseToken(token);
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase?.['sign_in_provider'];
    return {
        claims: claims,
        token: token,
        authTime: $b1d72f86dd9d3107$var$utcTimestampToDateString($b1d72f86dd9d3107$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $b1d72f86dd9d3107$var$utcTimestampToDateString($b1d72f86dd9d3107$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $b1d72f86dd9d3107$var$utcTimestampToDateString($b1d72f86dd9d3107$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: firebase?.['sign_in_second_factor'] || null
    };
}
function $b1d72f86dd9d3107$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $b1d72f86dd9d3107$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $b1d72f86dd9d3107$var$_logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0, $9k0Bn.base64Decode)(payload);
        if (!decoded) {
            $b1d72f86dd9d3107$var$_logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $b1d72f86dd9d3107$var$_logError('Caught error parsing JWT payload as JSON', e?.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $b1d72f86dd9d3107$var$_tokenExpiresIn(token) {
    const parsedToken = $b1d72f86dd9d3107$var$_parseToken(token);
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $9k0Bn.FirebaseError) && $b1d72f86dd9d3107$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $b1d72f86dd9d3107$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1d72f86dd9d3107$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = this.user.stsTokenManager.expirationTime ?? 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if (e?.code === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1d72f86dd9d3107$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $b1d72f86dd9d3107$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $b1d72f86dd9d3107$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$var$_reloadWithoutSaving(user) {
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $b1d72f86dd9d3107$var$_logoutIfInvalidated(user, $b1d72f86dd9d3107$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(response?.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = coreAccount.providerUserInfo?.length ? $b1d72f86dd9d3107$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $b1d72f86dd9d3107$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !providerData?.length;
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $b1d72f86dd9d3107$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$6554612db691658e(user) {
    const userInternal = (0, $9k0Bn.getModularInstance)(user);
    await $b1d72f86dd9d3107$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $b1d72f86dd9d3107$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $b1d72f86dd9d3107$var$extractProviderData(providers) {
    return providers.map(({ providerId: providerId, ...provider })=>{
        return {
            providerId: providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$var$requestStsToken(auth, refreshToken) {
    const response = await $b1d72f86dd9d3107$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $9k0Bn.querystring)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = await $b1d72f86dd9d3107$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/x-www-form-urlencoded';
        const options = {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        };
        if (auth.emulatorConfig && (0, $9k0Bn.isCloudWorkstation)(auth.emulatorConfig.host)) options.credentials = 'include';
        return $b1d72f86dd9d3107$export$f96d196f7728bb5.fetch()(url, options);
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $b1d72f86dd9d3107$var$revokeToken(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $b1d72f86dd9d3107$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : $b1d72f86dd9d3107$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $b1d72f86dd9d3107$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $b1d72f86dd9d3107$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $b1d72f86dd9d3107$var$StsTokenManager();
        if (refreshToken) {
            $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $b1d72f86dd9d3107$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $b1d72f86dd9d3107$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1d72f86dd9d3107$var$assertStringOrUndefined(assertion, appName) {
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $b1d72f86dd9d3107$export$91477dc880baac21 {
    constructor({ uid: uid, auth: auth, stsTokenManager: stsTokenManager, ...opt }){
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $b1d72f86dd9d3107$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $b1d72f86dd9d3107$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $b1d72f86dd9d3107$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $b1d72f86dd9d3107$export$2f6ca3d3b1f80bf5(this, forceRefresh);
    }
    reload() {
        return $b1d72f86dd9d3107$export$6554612db691658e(this);
    }
    _assign(user) {
        if (this === user) return;
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>({
                ...userInfo
            }));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $b1d72f86dd9d3107$export$91477dc880baac21({
            ...this,
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        });
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $b1d72f86dd9d3107$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $bVYHX._isFirebaseServerApp)(this.auth.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $b1d72f86dd9d3107$var$_logoutIfInvalidated(this, $b1d72f86dd9d3107$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return {
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>({
                    ...userInfo
                })),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId,
            ...this.metadata.toJSON(),
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        };
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        const displayName = object.displayName ?? undefined;
        const email = object.email ?? undefined;
        const phoneNumber = object.phoneNumber ?? undefined;
        const photoURL = object.photoURL ?? undefined;
        const tenantId = object.tenantId ?? undefined;
        const _redirectEventId = object._redirectEventId ?? undefined;
        const createdAt = object.createdAt ?? undefined;
        const lastLoginAt = object.lastLoginAt ?? undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $b1d72f86dd9d3107$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $b1d72f86dd9d3107$var$assertStringOrUndefined(displayName, auth.name);
        $b1d72f86dd9d3107$var$assertStringOrUndefined(email, auth.name);
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $b1d72f86dd9d3107$var$assertStringOrUndefined(phoneNumber, auth.name);
        $b1d72f86dd9d3107$var$assertStringOrUndefined(photoURL, auth.name);
        $b1d72f86dd9d3107$var$assertStringOrUndefined(tenantId, auth.name);
        $b1d72f86dd9d3107$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $b1d72f86dd9d3107$var$assertStringOrUndefined(createdAt, auth.name);
        $b1d72f86dd9d3107$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $b1d72f86dd9d3107$export$91477dc880baac21({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>({
                ...userInfo
            }));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $b1d72f86dd9d3107$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $b1d72f86dd9d3107$export$91477dc880baac21({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $b1d72f86dd9d3107$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $b1d72f86dd9d3107$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !providerData?.length;
        const stsTokenManager = new $b1d72f86dd9d3107$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $b1d72f86dd9d3107$export$91477dc880baac21({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $b1d72f86dd9d3107$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !providerData?.length
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$instanceCache = new Map();
function $b1d72f86dd9d3107$export$cf2f7c5792f80b46(cls) {
    $b1d72f86dd9d3107$export$d66dc83d8cfc8dd(cls instanceof Function, 'Expected a class definition');
    let instance = $b1d72f86dd9d3107$var$instanceCache.get(cls);
    if (instance) {
        $b1d72f86dd9d3107$export$d66dc83d8cfc8dd(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    $b1d72f86dd9d3107$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1d72f86dd9d3107$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$b1d72f86dd9d3107$var$InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $b1d72f86dd9d3107$export$e7c866399fa523f5 = $b1d72f86dd9d3107$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1d72f86dd9d3107$export$53a70dd1ebbae346(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $b1d72f86dd9d3107$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $b1d72f86dd9d3107$export$53a70dd1ebbae346(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $b1d72f86dd9d3107$export$53a70dd1ebbae346("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        if (!blob) return null;
        if (typeof blob === 'string') {
            const response = await $b1d72f86dd9d3107$var$getAccountInfo(this.auth, {
                idToken: blob
            }).catch(()=>undefined);
            if (!response) return null;
            return $b1d72f86dd9d3107$export$91477dc880baac21._fromGetAccountInfoResponse(this.auth, response, blob);
        }
        return $b1d72f86dd9d3107$export$91477dc880baac21._fromJSON(this.auth, blob);
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $b1d72f86dd9d3107$var$PersistenceUserManager($b1d72f86dd9d3107$export$cf2f7c5792f80b46($b1d72f86dd9d3107$export$e7c866399fa523f5), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $b1d72f86dd9d3107$export$cf2f7c5792f80b46($b1d72f86dd9d3107$export$e7c866399fa523f5);
        const key = $b1d72f86dd9d3107$export$53a70dd1ebbae346(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                let user;
                if (typeof blob === 'string') {
                    const response = await $b1d72f86dd9d3107$var$getAccountInfo(auth, {
                        idToken: blob
                    }).catch(()=>undefined);
                    if (!response) break;
                    user = await $b1d72f86dd9d3107$export$91477dc880baac21._fromGetAccountInfoResponse(auth, response, blob);
                } else user = $b1d72f86dd9d3107$export$91477dc880baac21._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch  {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $b1d72f86dd9d3107$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch  {}
        }));
        return new $b1d72f86dd9d3107$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $b1d72f86dd9d3107$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) return "Opera" /* BrowserName.OPERA */ ;
    else if ($b1d72f86dd9d3107$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes('msie') || ua.includes('trident/')) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes('edge/')) return "Edge" /* BrowserName.EDGE */ ;
    else if ($b1d72f86dd9d3107$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes('silk/')) return "Silk" /* BrowserName.SILK */ ;
    else if ($b1d72f86dd9d3107$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($b1d72f86dd9d3107$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($b1d72f86dd9d3107$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes('chrome/') || $b1d72f86dd9d3107$var$_isChromeIOS(ua)) && !ua.includes('edge/')) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($b1d72f86dd9d3107$export$9fa96a7d116ea3ce(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if (matches?.length === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $b1d72f86dd9d3107$var$_isFirefox(ua = (0, $9k0Bn.getUA)()) {
    return /firefox\//i.test(ua);
}
function $b1d72f86dd9d3107$var$_isSafari(userAgent = (0, $9k0Bn.getUA)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}
function $b1d72f86dd9d3107$var$_isChromeIOS(ua = (0, $9k0Bn.getUA)()) {
    return /crios\//i.test(ua);
}
function $b1d72f86dd9d3107$var$_isIEMobile(ua = (0, $9k0Bn.getUA)()) {
    return /iemobile/i.test(ua);
}
function $b1d72f86dd9d3107$export$9fa96a7d116ea3ce(ua = (0, $9k0Bn.getUA)()) {
    return /android/i.test(ua);
}
function $b1d72f86dd9d3107$var$_isBlackBerry(ua = (0, $9k0Bn.getUA)()) {
    return /blackberry/i.test(ua);
}
function $b1d72f86dd9d3107$var$_isWebOS(ua = (0, $9k0Bn.getUA)()) {
    return /webos/i.test(ua);
}
function $b1d72f86dd9d3107$export$92108d983e8ee699(ua = (0, $9k0Bn.getUA)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $b1d72f86dd9d3107$export$9d398bebfec1c039(ua = (0, $9k0Bn.getUA)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $b1d72f86dd9d3107$var$_isIOSStandalone(ua = (0, $9k0Bn.getUA)()) {
    return $b1d72f86dd9d3107$export$92108d983e8ee699(ua) && !!window.navigator?.standalone;
}
function $b1d72f86dd9d3107$var$_isIE10() {
    return (0, $9k0Bn.isIE)() && document.documentMode === 10;
}
function $b1d72f86dd9d3107$var$_isMobileBrowser(ua = (0, $9k0Bn.getUA)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $b1d72f86dd9d3107$export$92108d983e8ee699(ua) || $b1d72f86dd9d3107$export$9fa96a7d116ea3ce(ua) || $b1d72f86dd9d3107$var$_isWebOS(ua) || $b1d72f86dd9d3107$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $b1d72f86dd9d3107$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $b1d72f86dd9d3107$export$faec65b429be379(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $b1d72f86dd9d3107$var$_getBrowserName((0, $9k0Bn.getUA)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$b1d72f86dd9d3107$var$_getBrowserName((0, $9k0Bn.getUA)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web'; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $bVYHX.SDK_VERSION}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1d72f86dd9d3107$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e?.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $b1d72f86dd9d3107$var$_getPasswordPolicy(auth, request = {}) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $b1d72f86dd9d3107$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $b1d72f86dd9d3107$var$PasswordPolicyImpl {
    constructor(response){
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = responseOptions.minPasswordLength ?? $b1d72f86dd9d3107$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') this.enforcementState = 'OFF';
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = response.allowedNonAlphanumericCharacters?.join('') ?? '';
        this.forceUpgradeOnSignin = response.forceUpgradeOnSignin ?? false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = status.meetsMinPasswordLength ?? true);
        status.isValid && (status.isValid = status.meetsMaxPasswordLength ?? true);
        status.isValid && (status.isValid = status.containsLowercaseLetter ?? true);
        status.isValid && (status.isValid = status.containsUppercaseLetter ?? true);
        status.isValid && (status.isValid = status.containsNumericCharacter ?? true);
        status.isValid && (status.isValid = status.containsNonAlphanumericCharacter ?? true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= 'a' && passwordChar <= 'z', /* containsUppercaseCharacter= */ passwordChar >= 'A' && passwordChar <= 'Z', /* containsNumericCharacter= */ passwordChar >= '0' && passwordChar <= '9', /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1d72f86dd9d3107$export$9f4f30ee63539e24 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $b1d72f86dd9d3107$var$Subscription(this);
        this.idTokenSubscription = new $b1d72f86dd9d3107$var$Subscription(this);
        this.beforeStateQueue = new $b1d72f86dd9d3107$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $b1d72f86dd9d3107$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        this._resolvePersistenceManagerAvailable = undefined;
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
        // TODO(jamesdaniels) explore less hacky way to do this, cookie authentication needs
        // persistenceMananger to be available. see _getFinalTarget for more context
        this._persistenceManagerAvailable = new Promise((resolve)=>this._resolvePersistenceManagerAvailable = resolve);
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $b1d72f86dd9d3107$export$cf2f7c5792f80b46(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            if (this._deleted) return;
            this.persistenceManager = await $b1d72f86dd9d3107$var$PersistenceUserManager.create(this, persistenceHierarchy);
            this._resolvePersistenceManagerAvailable?.();
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if (this._popupRedirectResolver?._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = this.currentUser?.uid || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $b1d72f86dd9d3107$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $b1d72f86dd9d3107$export$91477dc880baac21._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn('FirebaseServerApp could not login user with provided authIdToken: ', err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        if ((0, $bVYHX._isFirebaseServerApp)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = this.redirectUser?._redirectEventId;
            const storedUserEventId = futureCurrentUser?._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && result?.user) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $b1d72f86dd9d3107$var$_reloadWithoutSaving(user);
        } catch (e) {
            if (e?.code !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $b1d72f86dd9d3107$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $bVYHX._isFirebaseServerApp)(this.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $9k0Bn.getModularInstance)(userExtern) : null;
        if (user) $b1d72f86dd9d3107$export$24baa2b76016ce0e(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $b1d72f86dd9d3107$export$24baa2b76016ce0e(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $bVYHX._isFirebaseServerApp)(this.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $bVYHX._isFirebaseServerApp)(this.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($b1d72f86dd9d3107$export$cf2f7c5792f80b46(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $b1d72f86dd9d3107$var$_getPasswordPolicy(this);
        const passwordPolicy = new $b1d72f86dd9d3107$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistenceType() {
        return this.assertedPersistence.persistence.type;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $9k0Bn.ErrorFactory)('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: 'apple.com',
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $b1d72f86dd9d3107$var$revokeToken(this, request);
        }
    }
    toJSON() {
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: this._currentUser?.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $b1d72f86dd9d3107$export$cf2f7c5792f80b46(popupRedirectResolver) || this._popupRedirectResolver;
            $b1d72f86dd9d3107$export$24baa2b76016ce0e(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $b1d72f86dd9d3107$var$PersistenceUserManager.create(this, [
                $b1d72f86dd9d3107$export$cf2f7c5792f80b46(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (this._currentUser?._redirectEventId === id) return this._currentUser;
        if (this.redirectUser?._redirectEventId === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = this.currentUser?.uid ?? null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === 'function') {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $b1d72f86dd9d3107$export$faec65b429be379(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await this.heartbeatServiceProvider.getImmediate({
            optional: true
        })?.getHeartbeatsHeader();
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        if ((0, $bVYHX._isFirebaseServerApp)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheckTokenResult = await this.appCheckServiceProvider.getImmediate({
            optional: true
        })?.getToken();
        if (appCheckTokenResult?.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $b1d72f86dd9d3107$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult?.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $b1d72f86dd9d3107$export$23ebac1979863676(auth) {
    return (0, $9k0Bn.getModularInstance)(auth);
}
/** Helper class to wrap subscriber logic */ class $b1d72f86dd9d3107$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $9k0Bn.createSubscribe)((observer)=>this.observer = observer);
    }
    get next() {
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $b1d72f86dd9d3107$var$externalJSProvider = {
    async loadJS () {
        throw new Error('Unable to load external scripts');
    },
    recaptchaV2Script: '',
    recaptchaEnterpriseScript: '',
    gapiScript: ''
};
function $b1d72f86dd9d3107$var$_setExternalJSProvider(p) {
    $b1d72f86dd9d3107$var$externalJSProvider = p;
}
function $b1d72f86dd9d3107$var$_loadJS(url) {
    return $b1d72f86dd9d3107$var$externalJSProvider.loadJS(url);
}
function $b1d72f86dd9d3107$var$_recaptchaV2ScriptUrl() {
    return $b1d72f86dd9d3107$var$externalJSProvider.recaptchaV2Script;
}
function $b1d72f86dd9d3107$var$_recaptchaEnterpriseScriptUrl() {
    return $b1d72f86dd9d3107$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $b1d72f86dd9d3107$var$_gapiScriptUrl() {
    return $b1d72f86dd9d3107$var$externalJSProvider.gapiScript;
}
function $b1d72f86dd9d3107$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$_SOLVE_TIME_MS = 500;
const $b1d72f86dd9d3107$var$_EXPIRATION_TIME_MS = 60000;
const $b1d72f86dd9d3107$var$_WIDGET_ID_START = 1000000000000;
class $b1d72f86dd9d3107$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $b1d72f86dd9d3107$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $b1d72f86dd9d3107$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        const id = optWidgetId || $b1d72f86dd9d3107$var$_WIDGET_ID_START;
        this._widgets.get(id)?.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        const id = optWidgetId || $b1d72f86dd9d3107$var$_WIDGET_ID_START;
        return this._widgets.get(id)?.getResponse() || '';
    }
    async execute(optWidgetId) {
        const id = optWidgetId || $b1d72f86dd9d3107$var$_WIDGET_ID_START;
        this._widgets.get(id)?.execute();
        return '';
    }
}
class $b1d72f86dd9d3107$var$MockGreCAPTCHATopLevel {
    constructor(){
        this.enterprise = new $b1d72f86dd9d3107$var$MockGreCAPTCHA();
    }
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $b1d72f86dd9d3107$var$MockGreCAPTCHA {
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $b1d72f86dd9d3107$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) this.execute();
        else this.container.addEventListener('click', this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $b1d72f86dd9d3107$var$generateRandomAlphaNumericString(50);
            const { callback: callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $b1d72f86dd9d3107$var$_EXPIRATION_TIME_MS);
        }, $b1d72f86dd9d3107$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error('reCAPTCHA mock was already deleted!');
    }
}
function $b1d72f86dd9d3107$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join('');
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $b1d72f86dd9d3107$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const $b1d72f86dd9d3107$var$FAKE_TOKEN = 'NO_RECAPTCHA';
class $b1d72f86dd9d3107$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $b1d72f86dd9d3107$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $b1d72f86dd9d3107$export$23ebac1979863676(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $b1d72f86dd9d3107$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error('recaptcha Enterprise site key undefined'));
                    else {
                        const config = new $b1d72f86dd9d3107$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($b1d72f86dd9d3107$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($b1d72f86dd9d3107$var$FAKE_TOKEN);
                });
            });
            else reject(Error('No reCAPTCHA enterprise script loaded.'));
        }
        // Returns Promise for a mock token when appVerificationDisabledForTesting is true.
        if (this.auth.settings.appVerificationDisabledForTesting) {
            const mockRecaptcha = new $b1d72f86dd9d3107$var$MockGreCAPTCHATopLevel();
            return mockRecaptcha.execute('siteKey', {
                action: 'verify'
            });
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $b1d72f86dd9d3107$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    let url = $b1d72f86dd9d3107$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    $b1d72f86dd9d3107$var$_loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $b1d72f86dd9d3107$var$injectRecaptchaFields(auth, request, action, isCaptchaResp = false, isFakeToken = false) {
    const verifier = new $b1d72f86dd9d3107$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    if (isFakeToken) captchaResponse = $b1d72f86dd9d3107$var$FAKE_TOKEN;
    else try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = {
        ...request
    };
    if (action === "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */  || action === "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ ) {
        if ('phoneEnrollmentInfo' in newRequest) {
            const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
            const recaptchaToken = newRequest.phoneEnrollmentInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneEnrollmentInfo': {
                    phoneNumber: phoneNumber,
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        } else if ('phoneSignInInfo' in newRequest) {
            const recaptchaToken = newRequest.phoneSignInInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneSignInInfo': {
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        }
        return newRequest;
    }
    if (!isCaptchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        'captchaResp': captchaResponse
    });
    Object.assign(newRequest, {
        'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $b1d72f86dd9d3107$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod, recaptchaAuthProvider) {
    if (recaptchaAuthProvider === "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) {
        if (authInstance._getRecaptchaConfig()?.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ )) {
            const requestWithRecaptcha = await $b1d72f86dd9d3107$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return actionMethod(authInstance, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
                const requestWithRecaptcha = await $b1d72f86dd9d3107$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
                return actionMethod(authInstance, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    } else if (recaptchaAuthProvider === "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) {
        if (authInstance._getRecaptchaConfig()?.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) {
            const requestWithRecaptcha = await $b1d72f86dd9d3107$var$injectRecaptchaFields(authInstance, request, actionName);
            return actionMethod(authInstance, requestWithRecaptcha).catch(async (error)=>{
                if (authInstance._getRecaptchaConfig()?.getProviderEnforcementState("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) === "AUDIT" /* EnforcementState.AUDIT */ ) // AUDIT mode
                {
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }` || error.code === `auth/${"invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ }`) {
                        console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${actionName} flow.`);
                        // reCAPTCHA Enterprise token is missing or reCAPTCHA Enterprise token
                        // check fails.
                        // Fallback to reCAPTCHA v2 flow.
                        const requestWithRecaptchaFields = await $b1d72f86dd9d3107$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
                        );
                        // This will call the PhoneApiCaller to fetch and inject reCAPTCHA v2 token.
                        return actionMethod(authInstance, requestWithRecaptchaFields);
                    }
                }
                // ENFORCE mode or AUDIT mode with any other error.
                return Promise.reject(error);
            });
        } else {
            // Do reCAPTCHA v2 flow.
            const requestWithRecaptchaFields = await $b1d72f86dd9d3107$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
            );
            // This will call the PhoneApiCaller to fetch and inject v2 token.
            return actionMethod(authInstance, requestWithRecaptchaFields);
        }
    } else return Promise.reject(recaptchaAuthProvider + ' provider is not supported.');
}
async function $b1d72f86dd9d3107$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $b1d72f86dd9d3107$export$23ebac1979863676(auth);
    const response = await $b1d72f86dd9d3107$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $b1d72f86dd9d3107$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isAnyProviderEnabled()) {
        const verifier = new $b1d72f86dd9d3107$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $b1d72f86dd9d3107$export$3466f893ebf79586(app, deps) {
    const provider = (0, $bVYHX._getProvider)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $9k0Bn.deepEqual)(initialOptions, deps ?? {})) return auth;
        else $b1d72f86dd9d3107$export$28f7fcd39efa255(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $b1d72f86dd9d3107$var$_initializeAuthInstance(auth, deps) {
    const persistence = deps?.persistence || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($b1d72f86dd9d3107$export$cf2f7c5792f80b46);
    if (deps?.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps?.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$61196ced6d74a310(auth, url, options) {
    const authInternal = $b1d72f86dd9d3107$export$23ebac1979863676(auth);
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!options?.disableWarnings;
    const protocol = $b1d72f86dd9d3107$var$extractProtocol(url);
    const { host: host, port: port } = $b1d72f86dd9d3107$var$extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    const emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    const emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    // There are a few scenarios to guard against if the Auth instance has already started:
    if (!authInternal._canInitEmulator) {
        // Applications may not initialize the emulator for the first time if Auth has already started
        // to make network requests.
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(authInternal.config.emulator && authInternal.emulatorConfig, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // Applications may not alter the configuration of the emulator (aka pass a different config)
        // once Auth has started to make network requests.
        $b1d72f86dd9d3107$export$24baa2b76016ce0e((0, $9k0Bn.deepEqual)(emulator, authInternal.config.emulator) && (0, $9k0Bn.deepEqual)(emulatorConfig, authInternal.emulatorConfig), authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // It's valid, however, to invoke connectAuthEmulator() after Auth has started making
        // connections, so long as the config matches the existing config. This results in a no-op.
        return;
    }
    authInternal.config.emulator = emulator;
    authInternal.emulatorConfig = emulatorConfig;
    authInternal.settings.appVerificationDisabledForTesting = true;
    // Workaround to get cookies in Firebase Studio
    if ((0, $9k0Bn.isCloudWorkstation)(host)) {
        (0, $9k0Bn.pingServer)(`${protocol}//${host}${portStr}`);
        (0, $9k0Bn.updateEmulatorBanner)('Auth', true);
    } else if (!disableWarnings) $b1d72f86dd9d3107$var$emitEmulatorWarning();
}
function $b1d72f86dd9d3107$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function $b1d72f86dd9d3107$var$extractHostAndPort(url) {
    const protocol = $b1d72f86dd9d3107$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: '',
        port: null
    };
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $b1d72f86dd9d3107$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(':');
        return {
            host: host,
            port: $b1d72f86dd9d3107$var$parsePort(port)
        };
    }
}
function $b1d72f86dd9d3107$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $b1d72f86dd9d3107$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText = 'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $b1d72f86dd9d3107$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $b1d72f86dd9d3107$var$debugFail('not implemented');
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $b1d72f86dd9d3107$var$debugFail('not implemented');
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $b1d72f86dd9d3107$var$debugFail('not implemented');
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $b1d72f86dd9d3107$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$var$resetPassword(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
async function $b1d72f86dd9d3107$var$updateEmailPassword(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $b1d72f86dd9d3107$var$linkEmailPassword(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $b1d72f86dd9d3107$var$applyActionCode$1(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$var$signInWithPassword(auth, request) {
    return $b1d72f86dd9d3107$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
async function $b1d72f86dd9d3107$var$sendOobCode(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
async function $b1d72f86dd9d3107$var$sendEmailVerification$1(auth, request) {
    return $b1d72f86dd9d3107$var$sendOobCode(auth, request);
}
async function $b1d72f86dd9d3107$var$sendPasswordResetEmail$1(auth, request) {
    return $b1d72f86dd9d3107$var$sendOobCode(auth, request);
}
async function $b1d72f86dd9d3107$var$sendSignInLinkToEmail$1(auth, request) {
    return $b1d72f86dd9d3107$var$sendOobCode(auth, request);
}
async function $b1d72f86dd9d3107$var$verifyAndChangeEmail(auth, request) {
    return $b1d72f86dd9d3107$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$var$signInWithEmailLink$1(auth, request) {
    return $b1d72f86dd9d3107$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
async function $b1d72f86dd9d3107$var$signInWithEmailLinkForLinking(auth, request) {
    return $b1d72f86dd9d3107$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $b1d72f86dd9d3107$export$a07804094c3ecf2d extends $b1d72f86dd9d3107$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $b1d72f86dd9d3107$export$a07804094c3ecf2d(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $b1d72f86dd9d3107$export$a07804094c3ecf2d(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if (obj?.email && obj?.password) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $b1d72f86dd9d3107$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $b1d72f86dd9d3107$var$signInWithPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $b1d72f86dd9d3107$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $b1d72f86dd9d3107$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $b1d72f86dd9d3107$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $b1d72f86dd9d3107$var$linkEmailPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $b1d72f86dd9d3107$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $b1d72f86dd9d3107$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$var$signInWithIdp(auth, request) {
    return $b1d72f86dd9d3107$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $b1d72f86dd9d3107$export$3722cfe417b6ed86 extends $b1d72f86dd9d3107$export$3a1a48c8f6ef640e {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $b1d72f86dd9d3107$export$3722cfe417b6ed86(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $b1d72f86dd9d3107$export$28f7fcd39efa255("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, ...rest } = obj;
        if (!providerId || !signInMethod) return null;
        const cred = new $b1d72f86dd9d3107$export$3722cfe417b6ed86(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $b1d72f86dd9d3107$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $b1d72f86dd9d3107$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $b1d72f86dd9d3107$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $b1d72f86dd9d3107$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody['id_token'] = this.idToken;
            if (this.accessToken) postBody['access_token'] = this.accessToken;
            if (this.secret) postBody['oauth_token_secret'] = this.secret;
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody['nonce'] = this.nonce;
            request.postBody = (0, $9k0Bn.querystring)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$var$sendPhoneVerificationCode(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
async function $b1d72f86dd9d3107$var$signInWithPhoneNumber$1(auth, request) {
    return $b1d72f86dd9d3107$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
async function $b1d72f86dd9d3107$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $b1d72f86dd9d3107$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $b1d72f86dd9d3107$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $b1d72f86dd9d3107$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $b1d72f86dd9d3107$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = {
        ...request,
        operation: 'REAUTH'
    };
    return $b1d72f86dd9d3107$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, apiRequest), $b1d72f86dd9d3107$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $b1d72f86dd9d3107$export$3a6d5c9ae78a2c08 extends $b1d72f86dd9d3107$export$3a1a48c8f6ef640e {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $b1d72f86dd9d3107$export$3a6d5c9ae78a2c08({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $b1d72f86dd9d3107$export$3a6d5c9ae78a2c08({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $b1d72f86dd9d3107$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $b1d72f86dd9d3107$var$linkWithPhoneNumber$1(auth, {
            idToken: idToken,
            ...this._makeVerificationRequest()
        });
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $b1d72f86dd9d3107$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === 'string') json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $b1d72f86dd9d3107$export$3a6d5c9ae78a2c08({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $b1d72f86dd9d3107$var$parseMode(mode) {
    switch(mode){
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $b1d72f86dd9d3107$var$parseDeepLink(url) {
    const link = (0, $9k0Bn.querystringDecode)((0, $9k0Bn.extractQuerystring)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $9k0Bn.querystringDecode)((0, $9k0Bn.extractQuerystring)(link))['deep_link_id'] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $9k0Bn.querystringDecode)((0, $9k0Bn.extractQuerystring)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $9k0Bn.querystringDecode)((0, $9k0Bn.extractQuerystring)(iOSDeepLink))['link'] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $b1d72f86dd9d3107$export$3b513254972cfc9c {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        const searchParams = (0, $9k0Bn.querystringDecode)((0, $9k0Bn.extractQuerystring)(actionLink));
        const apiKey = searchParams["apiKey" /* QueryField.API_KEY */ ] ?? null;
        const code = searchParams["oobCode" /* QueryField.CODE */ ] ?? null;
        const operation = $b1d72f86dd9d3107$var$parseMode(searchParams["mode" /* QueryField.MODE */ ] ?? null);
        // Validate API key, code and mode.
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ] ?? null;
        this.languageCode = searchParams["lang" /* QueryField.LANGUAGE_CODE */ ] ?? null;
        this.tenantId = searchParams["tenantId" /* QueryField.TENANT_ID */ ] ?? null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $b1d72f86dd9d3107$var$parseDeepLink(link);
        try {
            return new $b1d72f86dd9d3107$export$3b513254972cfc9c(actionLink);
        } catch  {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$21579262ef46735b(link) {
    return $b1d72f86dd9d3107$export$3b513254972cfc9c.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $b1d72f86dd9d3107$export$71cec2538cb2c617 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $b1d72f86dd9d3107$export$71cec2538cb2c617.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $b1d72f86dd9d3107$export$a07804094c3ecf2d._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $b1d72f86dd9d3107$export$3b513254972cfc9c.parseLink(emailLink);
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $b1d72f86dd9d3107$export$a07804094c3ecf2d._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $b1d72f86dd9d3107$export$71cec2538cb2c617.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $b1d72f86dd9d3107$export$71cec2538cb2c617.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $b1d72f86dd9d3107$export$71cec2538cb2c617.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $b1d72f86dd9d3107$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $b1d72f86dd9d3107$var$BaseOAuthProvider extends $b1d72f86dd9d3107$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $b1d72f86dd9d3107$export$71511d61b312f219 extends $b1d72f86dd9d3107$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        $b1d72f86dd9d3107$export$24baa2b76016ce0e('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $b1d72f86dd9d3107$export$3722cfe417b6ed86._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential({
            ...params,
            nonce: params.rawNonce
        });
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $b1d72f86dd9d3107$export$3722cfe417b6ed86._fromParams({
            ...params,
            providerId: this.providerId,
            signInMethod: this.providerId
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $b1d72f86dd9d3107$export$71511d61b312f219.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $b1d72f86dd9d3107$export$71511d61b312f219.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $b1d72f86dd9d3107$export$71511d61b312f219(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $b1d72f86dd9d3107$export$78acf4525d8a74c4 extends $b1d72f86dd9d3107$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $b1d72f86dd9d3107$export$3722cfe417b6ed86._fromParams({
            providerId: $b1d72f86dd9d3107$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $b1d72f86dd9d3107$export$78acf4525d8a74c4.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $b1d72f86dd9d3107$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $b1d72f86dd9d3107$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $b1d72f86dd9d3107$export$78acf4525d8a74c4.credential(tokenResponse.oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $b1d72f86dd9d3107$export$78acf4525d8a74c4.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $b1d72f86dd9d3107$export$78acf4525d8a74c4.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $b1d72f86dd9d3107$export$8743009a87fcb00f extends $b1d72f86dd9d3107$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $b1d72f86dd9d3107$export$3722cfe417b6ed86._fromParams({
            providerId: $b1d72f86dd9d3107$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $b1d72f86dd9d3107$export$8743009a87fcb00f.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $b1d72f86dd9d3107$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $b1d72f86dd9d3107$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $b1d72f86dd9d3107$export$8743009a87fcb00f.credential(oauthIdToken, oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $b1d72f86dd9d3107$export$8743009a87fcb00f.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $b1d72f86dd9d3107$export$8743009a87fcb00f.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $b1d72f86dd9d3107$export$dc98b0b04f4c7758 extends $b1d72f86dd9d3107$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $b1d72f86dd9d3107$export$3722cfe417b6ed86._fromParams({
            providerId: $b1d72f86dd9d3107$export$dc98b0b04f4c7758.PROVIDER_ID,
            signInMethod: $b1d72f86dd9d3107$export$dc98b0b04f4c7758.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $b1d72f86dd9d3107$export$dc98b0b04f4c7758.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $b1d72f86dd9d3107$export$dc98b0b04f4c7758.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $b1d72f86dd9d3107$export$dc98b0b04f4c7758.credential(tokenResponse.oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $b1d72f86dd9d3107$export$dc98b0b04f4c7758.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $b1d72f86dd9d3107$export$dc98b0b04f4c7758.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */ class $b1d72f86dd9d3107$export$738ab4df8bf92ae9 extends $b1d72f86dd9d3107$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $b1d72f86dd9d3107$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $b1d72f86dd9d3107$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $b1d72f86dd9d3107$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $b1d72f86dd9d3107$export$738ab4df8bf92ae9(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $b1d72f86dd9d3107$export$738ab4df8bf92ae9(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $b1d72f86dd9d3107$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $b1d72f86dd9d3107$export$3d8c2f653ac9d0b9 extends $b1d72f86dd9d3107$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(providerId.startsWith($b1d72f86dd9d3107$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $b1d72f86dd9d3107$export$3d8c2f653ac9d0b9.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $b1d72f86dd9d3107$export$3d8c2f653ac9d0b9.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $b1d72f86dd9d3107$export$738ab4df8bf92ae9.fromJSON(json);
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $b1d72f86dd9d3107$export$738ab4df8bf92ae9._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $b1d72f86dd9d3107$export$34aec0b863436764 extends $b1d72f86dd9d3107$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $b1d72f86dd9d3107$export$3722cfe417b6ed86._fromParams({
            providerId: $b1d72f86dd9d3107$export$34aec0b863436764.PROVIDER_ID,
            signInMethod: $b1d72f86dd9d3107$export$34aec0b863436764.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $b1d72f86dd9d3107$export$34aec0b863436764.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $b1d72f86dd9d3107$export$34aec0b863436764.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $b1d72f86dd9d3107$export$34aec0b863436764.credential(oauthAccessToken, oauthTokenSecret);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $b1d72f86dd9d3107$export$34aec0b863436764.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $b1d72f86dd9d3107$export$34aec0b863436764.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$var$signUp(auth, request) {
    return $b1d72f86dd9d3107$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1d72f86dd9d3107$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $b1d72f86dd9d3107$export$91477dc880baac21._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $b1d72f86dd9d3107$var$providerIdForResponse(idTokenResponse);
        const userCred = new $b1d72f86dd9d3107$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $b1d72f86dd9d3107$var$providerIdForResponse(response);
        return new $b1d72f86dd9d3107$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $b1d72f86dd9d3107$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ('phoneNumber' in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$3c2fa207a37baaea(auth) {
    if ((0, $bVYHX._isFirebaseServerApp)(auth.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $b1d72f86dd9d3107$export$23ebac1979863676(auth);
    await authInternal._initializationPromise;
    if (authInternal.currentUser?.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $b1d72f86dd9d3107$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $b1d72f86dd9d3107$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $b1d72f86dd9d3107$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1d72f86dd9d3107$var$MultiFactorError extends (0, $9k0Bn.FirebaseError) {
    constructor(auth, error, operationType, user){
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $b1d72f86dd9d3107$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: auth.tenantId ?? undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $b1d72f86dd9d3107$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $b1d72f86dd9d3107$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $b1d72f86dd9d3107$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $b1d72f86dd9d3107$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$8a5498727ef6be21(user, providerId) {
    const userInternal = (0, $9k0Bn.getModularInstance)(user);
    await $b1d72f86dd9d3107$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $b1d72f86dd9d3107$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $b1d72f86dd9d3107$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $b1d72f86dd9d3107$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $b1d72f86dd9d3107$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $b1d72f86dd9d3107$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $b1d72f86dd9d3107$var$_assertLinkedStatus(expected, user, provider) {
    await $b1d72f86dd9d3107$var$_reloadWithoutSaving(user);
    const providerIds = $b1d72f86dd9d3107$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $bVYHX._isFirebaseServerApp)(auth.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $b1d72f86dd9d3107$var$_logoutIfInvalidated(user, $b1d72f86dd9d3107$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $b1d72f86dd9d3107$var$_parseToken(response.idToken);
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $b1d72f86dd9d3107$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if (e?.code === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $b1d72f86dd9d3107$export$28f7fcd39efa255(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $bVYHX._isFirebaseServerApp)(auth.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $b1d72f86dd9d3107$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $b1d72f86dd9d3107$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$ce26c07117d59d6a(auth, credential) {
    return $b1d72f86dd9d3107$var$_signInWithCredential($b1d72f86dd9d3107$export$23ebac1979863676(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$6559d589eb85fbb6(user, credential) {
    const userInternal = (0, $9k0Bn.getModularInstance)(user);
    await $b1d72f86dd9d3107$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $b1d72f86dd9d3107$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$efca4cbe5dd06740(user, credential) {
    return $b1d72f86dd9d3107$var$_reauthenticate((0, $9k0Bn.getModularInstance)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$var$signInWithCustomToken$1(auth, request) {
    return $b1d72f86dd9d3107$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$a8550f7dbe79f93a(auth, customToken) {
    if ((0, $bVYHX._isFirebaseServerApp)(auth.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $b1d72f86dd9d3107$export$23ebac1979863676(auth);
    const response = await $b1d72f86dd9d3107$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $b1d72f86dd9d3107$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1d72f86dd9d3107$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) return $b1d72f86dd9d3107$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ('totpInfo' in enrollment) return $b1d72f86dd9d3107$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $b1d72f86dd9d3107$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $b1d72f86dd9d3107$var$PhoneMultiFactorInfoImpl extends $b1d72f86dd9d3107$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $b1d72f86dd9d3107$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $b1d72f86dd9d3107$var$TotpMultiFactorInfoImpl extends $b1d72f86dd9d3107$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $b1d72f86dd9d3107$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1d72f86dd9d3107$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(actionCodeSettings.url?.length > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof actionCodeSettings.linkDomain === 'undefined' || actionCodeSettings.linkDomain.length > 0, auth, "invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.linkDomain = actionCodeSettings.linkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $b1d72f86dd9d3107$var$recachePasswordPolicy(auth) {
    const authInternal = $b1d72f86dd9d3107$export$23ebac1979863676(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$2e2af4578d910ddf(auth, email, actionCodeSettings) {
    const authInternal = $b1d72f86dd9d3107$export$23ebac1979863676(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $b1d72f86dd9d3107$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $b1d72f86dd9d3107$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $b1d72f86dd9d3107$var$sendPasswordResetEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$a93c5207d687da10(auth, oobCode, newPassword) {
    await $b1d72f86dd9d3107$var$resetPassword((0, $9k0Bn.getModularInstance)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $b1d72f86dd9d3107$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$c3950d9923825c02(auth, oobCode) {
    await $b1d72f86dd9d3107$var$applyActionCode$1((0, $9k0Bn.getModularInstance)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$a9c996f45e5784d0(auth, oobCode) {
    const authModular = (0, $9k0Bn.getModularInstance)(auth);
    const response = await $b1d72f86dd9d3107$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $b1d72f86dd9d3107$export$24baa2b76016ce0e(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $b1d72f86dd9d3107$export$24baa2b76016ce0e(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $b1d72f86dd9d3107$export$24baa2b76016ce0e(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $b1d72f86dd9d3107$var$MultiFactorInfoImpl._fromServerResponse($b1d72f86dd9d3107$export$23ebac1979863676(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$7910e0436ed8d1de(auth, code) {
    const { data: data } = await $b1d72f86dd9d3107$export$a9c996f45e5784d0((0, $9k0Bn.getModularInstance)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$555508cbc6add439(auth, email, password) {
    if ((0, $bVYHX._isFirebaseServerApp)(auth.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $b1d72f86dd9d3107$export$23ebac1979863676(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $b1d72f86dd9d3107$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $b1d72f86dd9d3107$var$signUp, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $b1d72f86dd9d3107$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $b1d72f86dd9d3107$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$2219238a014317b0(auth, email, password) {
    if ((0, $bVYHX._isFirebaseServerApp)(auth.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $b1d72f86dd9d3107$export$ce26c07117d59d6a((0, $9k0Bn.getModularInstance)(auth), $b1d72f86dd9d3107$export$71cec2538cb2c617.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $b1d72f86dd9d3107$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$4c3d22f3d993c33f(auth, email, actionCodeSettings) {
    const authInternal = $b1d72f86dd9d3107$export$23ebac1979863676(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $b1d72f86dd9d3107$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $b1d72f86dd9d3107$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $b1d72f86dd9d3107$var$sendSignInLinkToEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$f787f51d84a910ad(auth, emailLink) {
    const actionCodeUrl = $b1d72f86dd9d3107$export$3b513254972cfc9c.parseLink(emailLink);
    return actionCodeUrl?.operation === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$c9170ad7d4cd7e57(auth, email, emailLink) {
    if ((0, $bVYHX._isFirebaseServerApp)(auth.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $9k0Bn.getModularInstance)(auth);
    const credential = $b1d72f86dd9d3107$export$71cec2538cb2c617.credentialWithLink(email, emailLink || $b1d72f86dd9d3107$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $b1d72f86dd9d3107$export$ce26c07117d59d6a(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$var$createAuthUri(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $b1d72f86dd9d3107$export$ee7c8ad385a60b7b(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $b1d72f86dd9d3107$var$_isHttpOrHttps() ? $b1d72f86dd9d3107$var$_getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $b1d72f86dd9d3107$var$createAuthUri((0, $9k0Bn.getModularInstance)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$995eb9fca571757(user, actionCodeSettings) {
    const userInternal = (0, $9k0Bn.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $b1d72f86dd9d3107$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $b1d72f86dd9d3107$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$f38c853ae54ed474(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $9k0Bn.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $b1d72f86dd9d3107$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $b1d72f86dd9d3107$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$var$updateProfile$1(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$ab83b03e4111b1d0(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $9k0Bn.getModularInstance)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $b1d72f86dd9d3107$var$_logoutIfInvalidated(userInternal, $b1d72f86dd9d3107$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$1a82df3d29112e01(user, newEmail) {
    const userInternal = (0, $9k0Bn.getModularInstance)(user);
    if ((0, $bVYHX._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $b1d72f86dd9d3107$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$306ddfe3a8403e2(user, newPassword) {
    return $b1d72f86dd9d3107$var$updateEmailOrPassword((0, $9k0Bn.getModularInstance)(user), null, newPassword);
}
async function $b1d72f86dd9d3107$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $b1d72f86dd9d3107$var$_logoutIfInvalidated(user, $b1d72f86dd9d3107$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $b1d72f86dd9d3107$var$_fromIdTokenResponse(idTokenResponse) {
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && idTokenResponse?.idToken) {
        const signInProvider = $b1d72f86dd9d3107$var$_parseToken(idTokenResponse.idToken)?.firebase?.['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $b1d72f86dd9d3107$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $b1d72f86dd9d3107$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $b1d72f86dd9d3107$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $b1d72f86dd9d3107$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $b1d72f86dd9d3107$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $b1d72f86dd9d3107$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $b1d72f86dd9d3107$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $b1d72f86dd9d3107$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $b1d72f86dd9d3107$var$FederatedAdditionalUserInfoWithUsername extends $b1d72f86dd9d3107$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $b1d72f86dd9d3107$var$FacebookAdditionalUserInfo extends $b1d72f86dd9d3107$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $b1d72f86dd9d3107$var$GithubAdditionalUserInfo extends $b1d72f86dd9d3107$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof profile?.login === 'string' ? profile?.login : null);
    }
}
class $b1d72f86dd9d3107$var$GoogleAdditionalUserInfo extends $b1d72f86dd9d3107$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $b1d72f86dd9d3107$var$TwitterAdditionalUserInfo extends $b1d72f86dd9d3107$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$d24c54395ce0c509(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $b1d72f86dd9d3107$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $b1d72f86dd9d3107$export$625550452a3fa3ec(auth, persistence) {
    return (0, $9k0Bn.getModularInstance)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$90a7f3efeed30595(auth) {
    return $b1d72f86dd9d3107$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$efccba1c4a2ef57b(auth, password) {
    const authInternal = $b1d72f86dd9d3107$export$23ebac1979863676(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$d141bba7fdc215a3(auth, nextOrObserver, error, completed) {
    return (0, $9k0Bn.getModularInstance)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $b1d72f86dd9d3107$export$4a5767248b18ef41(auth, callback, onAbort) {
    return (0, $9k0Bn.getModularInstance)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$df995fae86a55f06(auth, nextOrObserver, error, completed) {
    return (0, $9k0Bn.getModularInstance)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$ef35774e6d314e91(auth) {
    (0, $9k0Bn.getModularInstance)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$e7094788287c5e9b(auth, user) {
    return (0, $9k0Bn.getModularInstance)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$96f57966bedc81b4(auth) {
    return (0, $9k0Bn.getModularInstance)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$a9c23c6ac3fc3eca(auth, token) {
    const authInternal = $b1d72f86dd9d3107$export$23ebac1979863676(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$2329c99376c9d0a4(user) {
    return (0, $9k0Bn.getModularInstance)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1d72f86dd9d3107$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $b1d72f86dd9d3107$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $b1d72f86dd9d3107$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? 'idToken' : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        if (obj?.multiFactorSession) {
            if (obj.multiFactorSession?.pendingCredential) return $b1d72f86dd9d3107$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if (obj.multiFactorSession?.idToken) return $b1d72f86dd9d3107$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1d72f86dd9d3107$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $b1d72f86dd9d3107$export$23ebac1979863676(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$b1d72f86dd9d3107$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $b1d72f86dd9d3107$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $b1d72f86dd9d3107$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = {
                ...serverResponse,
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            };
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $b1d72f86dd9d3107$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $b1d72f86dd9d3107$export$24baa2b76016ce0e(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $b1d72f86dd9d3107$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $b1d72f86dd9d3107$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$493d36ec626b6698(auth, error) {
    const authModular = (0, $9k0Bn.getModularInstance)(auth);
    const errorInternal = error;
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(errorInternal.customData._serverResponse?.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $b1d72f86dd9d3107$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1d72f86dd9d3107$var$startEnrollPhoneMfa(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
function $b1d72f86dd9d3107$var$finalizeEnrollPhoneMfa(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
function $b1d72f86dd9d3107$var$startEnrollTotpMfa(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
function $b1d72f86dd9d3107$var$finalizeEnrollTotpMfa(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
function $b1d72f86dd9d3107$var$withdrawMfa(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
class $b1d72f86dd9d3107$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$b1d72f86dd9d3107$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $b1d72f86dd9d3107$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $b1d72f86dd9d3107$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $b1d72f86dd9d3107$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $b1d72f86dd9d3107$var$_logoutIfInvalidated(this.user, $b1d72f86dd9d3107$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $b1d72f86dd9d3107$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$1fbe638ecf81657e(user) {
    const userModular = (0, $9k0Bn.getModularInstance)(user);
    if (!$b1d72f86dd9d3107$var$multiFactorUserCache.has(userModular)) $b1d72f86dd9d3107$var$multiFactorUserCache.set(userModular, $b1d72f86dd9d3107$var$MultiFactorUserImpl._fromUser(userModular));
    return $b1d72f86dd9d3107$var$multiFactorUserCache.get(userModular);
}
const $b1d72f86dd9d3107$var$STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $b1d72f86dd9d3107$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($b1d72f86dd9d3107$var$STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem($b1d72f86dd9d3107$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch  {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $b1d72f86dd9d3107$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $b1d72f86dd9d3107$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $b1d72f86dd9d3107$var$BrowserLocalPersistence extends $b1d72f86dd9d3107$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $b1d72f86dd9d3107$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($b1d72f86dd9d3107$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $b1d72f86dd9d3107$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent('storage', {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $b1d72f86dd9d3107$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$b1d72f86dd9d3107$var$BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $b1d72f86dd9d3107$export$8b22cf2602fb60ce = $b1d72f86dd9d3107$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$POLLING_INTERVAL_MS = 1000;
// Pull a cookie value from document.cookie
function $b1d72f86dd9d3107$var$getDocumentCookie(name) {
    const escapedName = name.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
    const matcher = RegExp(`${escapedName}=([^;]+)`);
    return document.cookie.match(matcher)?.[1] ?? null;
}
// Produce a sanitized cookie name from the persistence key
function $b1d72f86dd9d3107$var$getCookieName(key) {
    // __HOST- doesn't work in localhost https://issues.chromium.org/issues/40196122 but it has
    // desirable security properties, so lets use a different cookie name while in dev-mode.
    // Already checked isSecureContext in _isAvailable, so if it's http we're hitting local.
    const isDevMode = window.location.protocol === 'http:';
    return `${isDevMode ? '__dev_' : '__HOST-'}FIREBASE_${key.split(':')[3]}`;
}
class $b1d72f86dd9d3107$var$CookiePersistence {
    constructor(){
        this.type = "COOKIE" /* PersistenceType.COOKIE */ ;
        this.listenerUnsubscribes = new Map();
    }
    // used to get the URL to the backend to proxy to
    _getFinalTarget(originalUrl) {
        const url = new URL(`${window.location.origin}/__cookies__`);
        url.searchParams.set('finalTarget', originalUrl);
        return url;
    }
    // To be a usable persistence method in a chain browserCookiePersistence ensures that
    // prerequisites have been met, namely that we're in a secureContext, navigator and document are
    // available and cookies are enabled. Not all UAs support these method, so fallback accordingly.
    async _isAvailable() {
        if (typeof isSecureContext === 'boolean' && !isSecureContext) return false;
        if (typeof navigator === 'undefined' || typeof document === 'undefined') return false;
        return navigator.cookieEnabled ?? true;
    }
    // Set should be a noop as we expect middleware to handle this
    async _set(_key, _value) {
        return;
    }
    // Attempt to get the cookie from cookieStore, fallback to document.cookie
    async _get(key) {
        if (!this._isAvailable()) return null;
        const name = $b1d72f86dd9d3107$var$getCookieName(key);
        if (window.cookieStore) {
            const cookie = await window.cookieStore.get(name);
            return cookie?.value;
        }
        return $b1d72f86dd9d3107$var$getDocumentCookie(name);
    }
    // Log out by overriding the idToken with a sentinel value of ""
    async _remove(key) {
        if (!this._isAvailable()) return;
        // To make sure we don't hit signout over and over again, only do this operation if we need to
        // with the logout sentinel value of "" this can cause race conditions. Unnecessary set-cookie
        // headers will reduce CDN hit rates too.
        const existingValue = await this._get(key);
        if (!existingValue) return;
        const name = $b1d72f86dd9d3107$var$getCookieName(key);
        document.cookie = `${name}=;Max-Age=34560000;Partitioned;Secure;SameSite=Strict;Path=/;Priority=High`;
        await fetch(`/__cookies__`, {
            method: 'DELETE'
        }).catch(()=>undefined);
    }
    // Listen for cookie changes, both cookieStore and fallback to polling document.cookie
    _addListener(key, listener) {
        if (!this._isAvailable()) return;
        const name = $b1d72f86dd9d3107$var$getCookieName(key);
        if (window.cookieStore) {
            const cb = (event)=>{
                const changedCookie = event.changed.find((change)=>change.name === name);
                if (changedCookie) listener(changedCookie.value);
                const deletedCookie = event.deleted.find((change)=>change.name === name);
                if (deletedCookie) listener(null);
            };
            const unsubscribe = ()=>window.cookieStore.removeEventListener('change', cb);
            this.listenerUnsubscribes.set(listener, unsubscribe);
            return window.cookieStore.addEventListener('change', cb);
        }
        let lastValue = $b1d72f86dd9d3107$var$getDocumentCookie(name);
        const interval = setInterval(()=>{
            const currentValue = $b1d72f86dd9d3107$var$getDocumentCookie(name);
            if (currentValue !== lastValue) {
                listener(currentValue);
                lastValue = currentValue;
            }
        }, $b1d72f86dd9d3107$var$POLLING_INTERVAL_MS);
        const unsubscribe = ()=>clearInterval(interval);
        this.listenerUnsubscribes.set(listener, unsubscribe);
    }
    _removeListener(_key, listener) {
        const unsubscribe = this.listenerUnsubscribes.get(listener);
        if (!unsubscribe) return;
        unsubscribe();
        this.listenerUnsubscribes.delete(listener);
    }
}
$b1d72f86dd9d3107$var$CookiePersistence.type = 'COOKIE';
/**
 * An implementation of {@link Persistence} of type `COOKIE`, for use on the client side in
 * applications leveraging hybrid rendering and middleware.
 *
 * @remarks This persistence method requires companion middleware to function, such as that provided
 * by {@link https://firebaseopensource.com/projects/firebaseextended/reactfire/ | ReactFire} for
 * NextJS.
 * @beta
 */ const $b1d72f86dd9d3107$export$407448d2b89b1813 = $b1d72f86dd9d3107$var$CookiePersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1d72f86dd9d3107$var$BrowserSessionPersistence extends $b1d72f86dd9d3107$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$b1d72f86dd9d3107$var$BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $b1d72f86dd9d3107$export$db3b6bfb95261072 = $b1d72f86dd9d3107$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $b1d72f86dd9d3107$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $b1d72f86dd9d3107$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $b1d72f86dd9d3107$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!handlers?.size) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $b1d72f86dd9d3107$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener('message', this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener('message', this.boundEventHandler);
    }
}
$b1d72f86dd9d3107$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1d72f86dd9d3107$export$c03999cb2f36933f(prefix = '', digits = 10) {
    let random = '';
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $b1d72f86dd9d3107$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $b1d72f86dd9d3107$export$c03999cb2f36933f('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $b1d72f86dd9d3107$var$_window() {
    return window;
}
function $b1d72f86dd9d3107$var$_setWindowLocation(url) {
    $b1d72f86dd9d3107$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1d72f86dd9d3107$var$_isWorker() {
    return typeof $b1d72f86dd9d3107$var$_window()['WorkerGlobalScope'] !== 'undefined' && typeof $b1d72f86dd9d3107$var$_window()['importScripts'] === 'function';
}
async function $b1d72f86dd9d3107$var$_getActiveServiceWorker() {
    if (!navigator?.serviceWorker) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch  {
        return null;
    }
}
function $b1d72f86dd9d3107$var$_getServiceWorkerController() {
    return navigator?.serviceWorker?.controller || null;
}
function $b1d72f86dd9d3107$var$_getWorkerGlobalScope() {
    return $b1d72f86dd9d3107$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$DB_NAME = 'firebaseLocalStorageDb';
const $b1d72f86dd9d3107$var$DB_VERSION = 1;
const $b1d72f86dd9d3107$var$DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const $b1d72f86dd9d3107$var$DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $b1d72f86dd9d3107$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener('success', ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener('error', ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $b1d72f86dd9d3107$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $b1d72f86dd9d3107$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? 'readwrite' : 'readonly').objectStore($b1d72f86dd9d3107$var$DB_OBJECTSTORE_NAME);
}
function $b1d72f86dd9d3107$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($b1d72f86dd9d3107$var$DB_NAME);
    return new $b1d72f86dd9d3107$var$DBPromise(request).toPromise();
}
function $b1d72f86dd9d3107$var$_openDatabase() {
    const request = indexedDB.open($b1d72f86dd9d3107$var$DB_NAME, $b1d72f86dd9d3107$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener('error', ()=>{
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', ()=>{
            const db = request.result;
            try {
                db.createObjectStore($b1d72f86dd9d3107$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $b1d72f86dd9d3107$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($b1d72f86dd9d3107$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $b1d72f86dd9d3107$var$_deleteDatabase();
                resolve(await $b1d72f86dd9d3107$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $b1d72f86dd9d3107$var$_putObject(db, key, value) {
    const request = $b1d72f86dd9d3107$var$getObjectStore(db, true).put({
        [$b1d72f86dd9d3107$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $b1d72f86dd9d3107$var$DBPromise(request).toPromise();
}
async function $b1d72f86dd9d3107$var$getObject(db, key) {
    const request = $b1d72f86dd9d3107$var$getObjectStore(db, false).get(key);
    const data = await new $b1d72f86dd9d3107$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $b1d72f86dd9d3107$var$_deleteObject(db, key) {
    const request = $b1d72f86dd9d3107$var$getObjectStore(db, true).delete(key);
    return new $b1d72f86dd9d3107$var$DBPromise(request).toPromise();
}
const $b1d72f86dd9d3107$var$_POLLING_INTERVAL_MS = 800;
const $b1d72f86dd9d3107$var$_TRANSACTION_RETRY_COUNT = 3;
class $b1d72f86dd9d3107$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $b1d72f86dd9d3107$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $b1d72f86dd9d3107$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $b1d72f86dd9d3107$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $b1d72f86dd9d3107$var$Receiver._getInstance($b1d72f86dd9d3107$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $b1d72f86dd9d3107$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $b1d72f86dd9d3107$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (results[0]?.fulfilled && results[0]?.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ )) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $b1d72f86dd9d3107$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch  {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $b1d72f86dd9d3107$var$_openDatabase();
            await $b1d72f86dd9d3107$var$_putObject(db, $b1d72f86dd9d3107$var$STORAGE_AVAILABLE_KEY, '1');
            await $b1d72f86dd9d3107$var$_deleteObject(db, $b1d72f86dd9d3107$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch  {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$b1d72f86dd9d3107$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$b1d72f86dd9d3107$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$b1d72f86dd9d3107$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $b1d72f86dd9d3107$var$getObjectStore(db, false).getAll();
            return new $b1d72f86dd9d3107$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $b1d72f86dd9d3107$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$b1d72f86dd9d3107$var$IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $b1d72f86dd9d3107$export$23f2a1d2818174ef = $b1d72f86dd9d3107$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1d72f86dd9d3107$var$startSignInPhoneMfa(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
function $b1d72f86dd9d3107$var$finalizeSignInPhoneMfa(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
function $b1d72f86dd9d3107$var$finalizeSignInTotpMfa(auth, request) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $b1d72f86dd9d3107$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $b1d72f86dd9d3107$var$_JSLOAD_CALLBACK = $b1d72f86dd9d3107$var$_generateCallbackName('rcb');
const $b1d72f86dd9d3107$var$NETWORK_TIMEOUT_DELAY = new $b1d72f86dd9d3107$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $b1d72f86dd9d3107$var$ReCaptchaLoaderImpl {
    constructor(){
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!$b1d72f86dd9d3107$var$_window().grecaptcha?.render;
    }
    load(auth, hl = '') {
        $b1d72f86dd9d3107$export$24baa2b76016ce0e($b1d72f86dd9d3107$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $b1d72f86dd9d3107$var$isV2($b1d72f86dd9d3107$var$_window().grecaptcha)) return Promise.resolve($b1d72f86dd9d3107$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $b1d72f86dd9d3107$var$_window().setTimeout(()=>{
                reject($b1d72f86dd9d3107$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $b1d72f86dd9d3107$var$NETWORK_TIMEOUT_DELAY.get());
            $b1d72f86dd9d3107$var$_window()[$b1d72f86dd9d3107$var$_JSLOAD_CALLBACK] = ()=>{
                $b1d72f86dd9d3107$var$_window().clearTimeout(networkTimeout);
                delete $b1d72f86dd9d3107$var$_window()[$b1d72f86dd9d3107$var$_JSLOAD_CALLBACK];
                const recaptcha = $b1d72f86dd9d3107$var$_window().grecaptcha;
                if (!recaptcha || !$b1d72f86dd9d3107$var$isV2(recaptcha)) {
                    reject($b1d72f86dd9d3107$export$890c4ad488842ce7(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$b1d72f86dd9d3107$var$_recaptchaV2ScriptUrl()}?${(0, $9k0Bn.querystring)({
                onload: $b1d72f86dd9d3107$var$_JSLOAD_CALLBACK,
                render: 'explicit',
                hl: hl
            })}`;
            $b1d72f86dd9d3107$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($b1d72f86dd9d3107$export$890c4ad488842ce7(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!$b1d72f86dd9d3107$var$_window().grecaptcha?.render && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $b1d72f86dd9d3107$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $b1d72f86dd9d3107$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $b1d72f86dd9d3107$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const $b1d72f86dd9d3107$var$DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $b1d72f86dd9d3107$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = {
        ...$b1d72f86dd9d3107$var$DEFAULT_PARAMS
    }){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $b1d72f86dd9d3107$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $b1d72f86dd9d3107$export$23ebac1979863676(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $b1d72f86dd9d3107$var$MockReCaptchaLoaderImpl() : new $b1d72f86dd9d3107$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === 'function') existing(token);
            else if (typeof existing === 'string') {
                const globalFunc = $b1d72f86dd9d3107$var$_window()[existing];
                if (typeof globalFunc === 'function') globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $b1d72f86dd9d3107$export$24baa2b76016ce0e($b1d72f86dd9d3107$var$_isHttpOrHttps() && !$b1d72f86dd9d3107$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $b1d72f86dd9d3107$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $b1d72f86dd9d3107$var$getRecaptchaParams(this.auth);
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $b1d72f86dd9d3107$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener('load', resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener('load', resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1d72f86dd9d3107$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $b1d72f86dd9d3107$export$3a6d5c9ae78a2c08._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method requires a {@link ApplicationVerifier}.
 * This SDK includes an implementation based on reCAPTCHA v2, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * If you've enabled project-level reCAPTCHA Enterprise bot protection in
 * Enforce mode, you can omit the {@link ApplicationVerifier}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    if ((0, $bVYHX._isFirebaseServerApp)(auth.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $b1d72f86dd9d3107$export$23ebac1979863676(auth);
    const verificationId = await $b1d72f86dd9d3107$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $9k0Bn.getModularInstance)(appVerifier));
    return new $b1d72f86dd9d3107$var$ConfirmationResultImpl(verificationId, (cred)=>$b1d72f86dd9d3107$export$ce26c07117d59d6a(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $9k0Bn.getModularInstance)(user);
    await $b1d72f86dd9d3107$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $b1d72f86dd9d3107$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $9k0Bn.getModularInstance)(appVerifier));
    return new $b1d72f86dd9d3107$var$ConfirmationResultImpl(verificationId, (cred)=>$b1d72f86dd9d3107$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $9k0Bn.getModularInstance)(user);
    if ((0, $bVYHX._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $b1d72f86dd9d3107$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $9k0Bn.getModularInstance)(appVerifier));
    return new $b1d72f86dd9d3107$var$ConfirmationResultImpl(verificationId, (cred)=>$b1d72f86dd9d3107$export$efca4cbe5dd06740(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $b1d72f86dd9d3107$var$_verifyPhoneNumber(auth, options, verifier) {
    if (!auth._getRecaptchaConfig()) try {
        await $b1d72f86dd9d3107$var$_initializeRecaptchaConfig(auth);
    } catch (error) {
        // If an error occurs while fetching the config, there is no way to know the enablement state
        // of Phone provider, so we proceed with recaptcha V2 verification.
        // The error is likely "recaptchaKey undefined", as reCAPTCHA Enterprise is not
        // enabled for any provider.
        console.log('Failed to initialize reCAPTCHA Enterprise config. Triggering the reCAPTCHA v2 verification.');
    }
    try {
        let phoneInfoOptions;
        if (typeof options === 'string') phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                $b1d72f86dd9d3107$export$24baa2b76016ce0e(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const startPhoneMfaEnrollmentRequest = {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startEnrollPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneEnrollmentInfo.captchaResponse === $b1d72f86dd9d3107$var$FAKE_TOKEN) {
                        $b1d72f86dd9d3107$export$24baa2b76016ce0e(verifier?.type === $b1d72f86dd9d3107$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $b1d72f86dd9d3107$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $b1d72f86dd9d3107$var$startEnrollPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $b1d72f86dd9d3107$var$startEnrollPhoneMfa(authInstance, request);
                };
                const startPhoneMfaEnrollmentResponse = $b1d72f86dd9d3107$var$handleRecaptchaFlow(auth, startPhoneMfaEnrollmentRequest, "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */ , startEnrollPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaEnrollmentResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $b1d72f86dd9d3107$export$24baa2b76016ce0e(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = phoneInfoOptions.multiFactorHint?.uid || phoneInfoOptions.multiFactorUid;
                $b1d72f86dd9d3107$export$24baa2b76016ce0e(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const startPhoneMfaSignInRequest = {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startSignInPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneSignInInfo.captchaResponse === $b1d72f86dd9d3107$var$FAKE_TOKEN) {
                        $b1d72f86dd9d3107$export$24baa2b76016ce0e(verifier?.type === $b1d72f86dd9d3107$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $b1d72f86dd9d3107$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $b1d72f86dd9d3107$var$startSignInPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $b1d72f86dd9d3107$var$startSignInPhoneMfa(authInstance, request);
                };
                const startPhoneMfaSignInResponse = $b1d72f86dd9d3107$var$handleRecaptchaFlow(auth, startPhoneMfaSignInRequest, "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ , startSignInPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaSignInResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const sendPhoneVerificationCodeRequest = {
                phoneNumber: phoneInfoOptions.phoneNumber,
                clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
            };
            const sendPhoneVerificationCodeActionCallback = async (authInstance, request)=>{
                // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                if (request.captchaResponse === $b1d72f86dd9d3107$var$FAKE_TOKEN) {
                    $b1d72f86dd9d3107$export$24baa2b76016ce0e(verifier?.type === $b1d72f86dd9d3107$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    const requestWithRecaptchaV2 = await $b1d72f86dd9d3107$var$injectRecaptchaV2Token(authInstance, request, verifier);
                    return $b1d72f86dd9d3107$var$sendPhoneVerificationCode(authInstance, requestWithRecaptchaV2);
                }
                return $b1d72f86dd9d3107$var$sendPhoneVerificationCode(authInstance, request);
            };
            const sendPhoneVerificationCodeResponse = $b1d72f86dd9d3107$var$handleRecaptchaFlow(auth, sendPhoneVerificationCodeRequest, "sendVerificationCode" /* RecaptchaActionName.SEND_VERIFICATION_CODE */ , sendPhoneVerificationCodeActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
            const response = await sendPhoneVerificationCodeResponse.catch((error)=>{
                return Promise.reject(error);
            });
            return response.sessionInfo;
        }
    } finally{
        verifier?._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$3b14a55fb2447963(user, credential) {
    const userInternal = (0, $9k0Bn.getModularInstance)(user);
    if ((0, $bVYHX._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $b1d72f86dd9d3107$var$_link$1(userInternal, credential);
}
// Helper function that fetches and injects a reCAPTCHA v2 token into the request.
async function $b1d72f86dd9d3107$var$injectRecaptchaV2Token(auth, request, recaptchaV2Verifier) {
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(recaptchaV2Verifier.type === $b1d72f86dd9d3107$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const recaptchaV2Token = await recaptchaV2Verifier.verify();
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof recaptchaV2Token === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const newRequest = {
        ...request
    };
    if ('phoneEnrollmentInfo' in newRequest) {
        const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
        const captchaResponse = newRequest.phoneEnrollmentInfo.captchaResponse;
        const clientType = newRequest.phoneEnrollmentInfo.clientType;
        const recaptchaVersion = newRequest.phoneEnrollmentInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneEnrollmentInfo': {
                phoneNumber: phoneNumber,
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else if ('phoneSignInInfo' in newRequest) {
        const captchaResponse = newRequest.phoneSignInInfo.captchaResponse;
        const clientType = newRequest.phoneSignInInfo.clientType;
        const recaptchaVersion = newRequest.phoneSignInInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneSignInInfo': {
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else {
        Object.assign(newRequest, {
            'recaptchaToken': recaptchaV2Token
        });
        return newRequest;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $b1d72f86dd9d3107$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $b1d72f86dd9d3107$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $b1d72f86dd9d3107$export$23ebac1979863676(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - An {@link ApplicationVerifier}, which prevents
     * requests from unauthorized clients. This SDK includes an implementation
     * based on reCAPTCHA v2, {@link RecaptchaVerifier}. If you've enabled
     * reCAPTCHA Enterprise bot protection in Enforce mode, this parameter is
     * optional; in all other configurations, the parameter is required.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow.
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $b1d72f86dd9d3107$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $9k0Bn.getModularInstance)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $b1d72f86dd9d3107$export$3a6d5c9ae78a2c08._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $b1d72f86dd9d3107$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $b1d72f86dd9d3107$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $b1d72f86dd9d3107$export$3a6d5c9ae78a2c08._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $b1d72f86dd9d3107$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $b1d72f86dd9d3107$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $b1d72f86dd9d3107$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $b1d72f86dd9d3107$export$cf2f7c5792f80b46(resolverOverride);
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1d72f86dd9d3107$var$IdpCredential extends $b1d72f86dd9d3107$export$3a1a48c8f6ef640e {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $b1d72f86dd9d3107$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $b1d72f86dd9d3107$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $b1d72f86dd9d3107$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $b1d72f86dd9d3107$var$_signIn(params) {
    return $b1d72f86dd9d3107$var$_signInWithCredential(params.auth, new $b1d72f86dd9d3107$var$IdpCredential(params), params.bypassAuthState);
}
function $b1d72f86dd9d3107$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $b1d72f86dd9d3107$var$_reauthenticate(user, new $b1d72f86dd9d3107$var$IdpCredential(params), params.bypassAuthState);
}
async function $b1d72f86dd9d3107$var$_link(params) {
    const { auth: auth, user: user } = params;
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $b1d72f86dd9d3107$var$_link$1(user, new $b1d72f86dd9d3107$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $b1d72f86dd9d3107$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $b1d72f86dd9d3107$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $b1d72f86dd9d3107$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $b1d72f86dd9d3107$var$_reauth;
            default:
                $b1d72f86dd9d3107$export$28f7fcd39efa255(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $b1d72f86dd9d3107$export$d66dc83d8cfc8dd(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $b1d72f86dd9d3107$export$d66dc83d8cfc8dd(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $b1d72f86dd9d3107$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$4368d992c4eafac0(auth, provider, resolver) {
    if ((0, $bVYHX._isFirebaseServerApp)(auth.app)) return Promise.reject($b1d72f86dd9d3107$export$890c4ad488842ce7(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $b1d72f86dd9d3107$export$23ebac1979863676(auth);
    $b1d72f86dd9d3107$var$_assertInstanceOf(auth, provider, $b1d72f86dd9d3107$var$FederatedAuthProvider);
    const resolverInternal = $b1d72f86dd9d3107$var$_withDefaultResolver(authInternal, resolver);
    const action = new $b1d72f86dd9d3107$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$2d1720544b23b823(user, provider, resolver) {
    const userInternal = (0, $9k0Bn.getModularInstance)(user);
    if ((0, $bVYHX._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($b1d72f86dd9d3107$export$890c4ad488842ce7(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $b1d72f86dd9d3107$var$_assertInstanceOf(userInternal.auth, provider, $b1d72f86dd9d3107$var$FederatedAuthProvider);
    const resolverInternal = $b1d72f86dd9d3107$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $b1d72f86dd9d3107$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $9k0Bn.getModularInstance)(user);
    $b1d72f86dd9d3107$var$_assertInstanceOf(userInternal.auth, provider, $b1d72f86dd9d3107$var$FederatedAuthProvider);
    const resolverInternal = $b1d72f86dd9d3107$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $b1d72f86dd9d3107$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $b1d72f86dd9d3107$var$PopupOperation extends $b1d72f86dd9d3107$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($b1d72f86dd9d3107$var$PopupOperation.currentPopupAction) $b1d72f86dd9d3107$var$PopupOperation.currentPopupAction.cancel();
        $b1d72f86dd9d3107$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $b1d72f86dd9d3107$export$d66dc83d8cfc8dd(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = $b1d72f86dd9d3107$export$c03999cb2f36933f();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($b1d72f86dd9d3107$export$890c4ad488842ce7(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        return this.authWindow?.associatedEvent || null;
    }
    cancel() {
        this.reject($b1d72f86dd9d3107$export$890c4ad488842ce7(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $b1d72f86dd9d3107$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            if (this.authWindow?.window?.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($b1d72f86dd9d3107$export$890c4ad488842ce7(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $b1d72f86dd9d3107$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$b1d72f86dd9d3107$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $b1d72f86dd9d3107$var$redirectOutcomeMap = new Map();
class $b1d72f86dd9d3107$var$RedirectAction extends $b1d72f86dd9d3107$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $b1d72f86dd9d3107$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $b1d72f86dd9d3107$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $b1d72f86dd9d3107$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $b1d72f86dd9d3107$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $b1d72f86dd9d3107$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $b1d72f86dd9d3107$var$pendingRedirectKey(auth);
    const persistence = $b1d72f86dd9d3107$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $b1d72f86dd9d3107$var$_setPendingRedirectStatus(resolver, auth) {
    return $b1d72f86dd9d3107$var$resolverPersistence(resolver)._set($b1d72f86dd9d3107$var$pendingRedirectKey(auth), 'true');
}
function $b1d72f86dd9d3107$export$a05254e7c3aeba6e() {
    $b1d72f86dd9d3107$var$redirectOutcomeMap.clear();
}
function $b1d72f86dd9d3107$export$b9a6b53f9be3734(auth, result) {
    $b1d72f86dd9d3107$var$redirectOutcomeMap.set(auth._key(), result);
}
function $b1d72f86dd9d3107$var$resolverPersistence(resolver) {
    return $b1d72f86dd9d3107$export$cf2f7c5792f80b46(resolver._redirectPersistence);
}
function $b1d72f86dd9d3107$var$pendingRedirectKey(auth) {
    return $b1d72f86dd9d3107$export$53a70dd1ebbae346($b1d72f86dd9d3107$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$39b482c5e57630a8(auth, provider, resolver) {
    return $b1d72f86dd9d3107$var$_signInWithRedirect(auth, provider, resolver);
}
async function $b1d72f86dd9d3107$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $bVYHX._isFirebaseServerApp)(auth.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $b1d72f86dd9d3107$export$23ebac1979863676(auth);
    $b1d72f86dd9d3107$var$_assertInstanceOf(auth, provider, $b1d72f86dd9d3107$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $b1d72f86dd9d3107$var$_withDefaultResolver(authInternal, resolver);
    await $b1d72f86dd9d3107$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$35e795649ee09318(user, provider, resolver) {
    return $b1d72f86dd9d3107$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $b1d72f86dd9d3107$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $9k0Bn.getModularInstance)(user);
    $b1d72f86dd9d3107$var$_assertInstanceOf(userInternal.auth, provider, $b1d72f86dd9d3107$var$FederatedAuthProvider);
    if ((0, $bVYHX._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $b1d72f86dd9d3107$var$_withDefaultResolver(userInternal.auth, resolver);
    await $b1d72f86dd9d3107$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $b1d72f86dd9d3107$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $b1d72f86dd9d3107$var$_linkWithRedirect(user, provider, resolver);
}
async function $b1d72f86dd9d3107$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $9k0Bn.getModularInstance)(user);
    $b1d72f86dd9d3107$var$_assertInstanceOf(userInternal.auth, provider, $b1d72f86dd9d3107$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $b1d72f86dd9d3107$var$_withDefaultResolver(userInternal.auth, resolver);
    await $b1d72f86dd9d3107$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $b1d72f86dd9d3107$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $b1d72f86dd9d3107$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $b1d72f86dd9d3107$export$342063e11d6c3cad(auth, resolver) {
    await $b1d72f86dd9d3107$export$23ebac1979863676(auth)._initializationPromise;
    return $b1d72f86dd9d3107$export$a33b77bbdbb8366c(auth, resolver, false);
}
async function $b1d72f86dd9d3107$export$a33b77bbdbb8366c(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $bVYHX._isFirebaseServerApp)(auth.app)) return Promise.reject($b1d72f86dd9d3107$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $b1d72f86dd9d3107$export$23ebac1979863676(auth);
    const resolver = $b1d72f86dd9d3107$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $b1d72f86dd9d3107$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $b1d72f86dd9d3107$var$prepareUserForRedirect(user) {
    const eventId = $b1d72f86dd9d3107$export$c03999cb2f36933f(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $b1d72f86dd9d3107$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $b1d72f86dd9d3107$export$158acd800e1ef08b {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$b1d72f86dd9d3107$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        if (event.error && !$b1d72f86dd9d3107$var$isNullRedirectEvent(event)) {
            const code = event.error.code?.split('auth/')[1] || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($b1d72f86dd9d3107$export$890c4ad488842ce7(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $b1d72f86dd9d3107$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($b1d72f86dd9d3107$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($b1d72f86dd9d3107$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $b1d72f86dd9d3107$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join('-');
}
function $b1d72f86dd9d3107$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && error?.code === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $b1d72f86dd9d3107$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $b1d72f86dd9d3107$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b1d72f86dd9d3107$export$91c6e00c14e7e6fd(auth, request = {}) {
    return $b1d72f86dd9d3107$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $b1d72f86dd9d3107$var$HTTP_REGEX = /^https?/;
async function $b1d72f86dd9d3107$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $b1d72f86dd9d3107$export$91c6e00c14e7e6fd(auth);
    for (const domain of authorizedDomains)try {
        if ($b1d72f86dd9d3107$var$matchDomain(domain)) return;
    } catch  {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $b1d72f86dd9d3107$export$28f7fcd39efa255(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $b1d72f86dd9d3107$var$matchDomain(expected) {
    const currentUrl = $b1d72f86dd9d3107$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') // For some reason we're not parsing chrome URLs properly
        return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!$b1d72f86dd9d3107$var$HTTP_REGEX.test(protocol)) return false;
    if ($b1d72f86dd9d3107$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$NETWORK_TIMEOUT = new $b1d72f86dd9d3107$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $b1d72f86dd9d3107$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $b1d72f86dd9d3107$var$_window().___jsl;
    // Get current hint.
    if (beacon?.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $b1d72f86dd9d3107$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $b1d72f86dd9d3107$var$resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $b1d72f86dd9d3107$var$resetUnloadedGapiModules();
                    reject($b1d72f86dd9d3107$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $b1d72f86dd9d3107$var$NETWORK_TIMEOUT.get()
            });
        }
        if ($b1d72f86dd9d3107$var$_window().gapi?.iframes?.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!$b1d72f86dd9d3107$var$_window().gapi?.load) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $b1d72f86dd9d3107$var$_generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            $b1d72f86dd9d3107$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($b1d72f86dd9d3107$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $b1d72f86dd9d3107$var$_loadJS(`${$b1d72f86dd9d3107$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $b1d72f86dd9d3107$var$cachedGApiLoader = null;
        throw error;
    });
}
let $b1d72f86dd9d3107$var$cachedGApiLoader = null;
function $b1d72f86dd9d3107$var$_loadGapi(auth) {
    $b1d72f86dd9d3107$var$cachedGApiLoader = $b1d72f86dd9d3107$var$cachedGApiLoader || $b1d72f86dd9d3107$var$loadGapi(auth);
    return $b1d72f86dd9d3107$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$PING_TIMEOUT = new $b1d72f86dd9d3107$var$Delay(5000, 15000);
const $b1d72f86dd9d3107$var$IFRAME_PATH = '__/auth/iframe';
const $b1d72f86dd9d3107$var$EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const $b1d72f86dd9d3107$var$IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $b1d72f86dd9d3107$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        'p'
    ],
    [
        'staging-identitytoolkit.sandbox.googleapis.com',
        's'
    ],
    [
        'test-identitytoolkit.sandbox.googleapis.com',
        't'
    ] // test
]);
function $b1d72f86dd9d3107$var$getIframeUrl(auth) {
    const config = auth.config;
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $b1d72f86dd9d3107$var$_emulatorUrl(config, $b1d72f86dd9d3107$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$b1d72f86dd9d3107$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $bVYHX.SDK_VERSION)
    };
    const eid = $b1d72f86dd9d3107$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(',');
    return `${url}?${(0, $9k0Bn.querystring)(params).slice(1)}`;
}
async function $b1d72f86dd9d3107$var$_openIframe(auth) {
    const context = await $b1d72f86dd9d3107$var$_loadGapi(auth);
    const gapi1 = $b1d72f86dd9d3107$var$_window().gapi;
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $b1d72f86dd9d3107$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $b1d72f86dd9d3107$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $b1d72f86dd9d3107$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $b1d72f86dd9d3107$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $b1d72f86dd9d3107$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $b1d72f86dd9d3107$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const $b1d72f86dd9d3107$var$DEFAULT_WIDTH = 500;
const $b1d72f86dd9d3107$var$DEFAULT_HEIGHT = 600;
const $b1d72f86dd9d3107$var$TARGET_BLANK = '_blank';
const $b1d72f86dd9d3107$var$FIREFOX_EMPTY_URL = 'http://localhost';
class $b1d72f86dd9d3107$export$2ed0fc6709e59212 {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $b1d72f86dd9d3107$var$_open(auth, url, name, width = $b1d72f86dd9d3107$var$DEFAULT_WIDTH, height = $b1d72f86dd9d3107$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = {
        ...$b1d72f86dd9d3107$var$BASE_POPUP_OPTIONS,
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    };
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $9k0Bn.getUA)().toLowerCase();
    if (name) target = $b1d72f86dd9d3107$var$_isChromeIOS(ua) ? $b1d72f86dd9d3107$var$TARGET_BLANK : name;
    if ($b1d72f86dd9d3107$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $b1d72f86dd9d3107$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, '');
    if ($b1d72f86dd9d3107$var$_isIOSStandalone(ua) && target !== '_self') {
        $b1d72f86dd9d3107$var$openAsNewWindowIOS(url || '', target);
        return new $b1d72f86dd9d3107$export$2ed0fc6709e59212(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $b1d72f86dd9d3107$export$2ed0fc6709e59212(newWin);
}
function $b1d72f86dd9d3107$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $b1d72f86dd9d3107$var$WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */ const $b1d72f86dd9d3107$var$EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $b1d72f86dd9d3107$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function $b1d72f86dd9d3107$export$3d12bd131bb975d1(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $b1d72f86dd9d3107$export$24baa2b76016ce0e(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $bVYHX.SDK_VERSION),
        eventId: eventId
    };
    if (provider instanceof $b1d72f86dd9d3107$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0, $9k0Bn.isEmpty)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $b1d72f86dd9d3107$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== '');
        if (scopes.length > 0) params.scopes = scopes.join(',');
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$b1d72f86dd9d3107$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${$b1d72f86dd9d3107$var$getHandlerBase(auth)}?${(0, $9k0Bn.querystring)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $b1d72f86dd9d3107$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$b1d72f86dd9d3107$var$WIDGET_PATH}`;
    return $b1d72f86dd9d3107$var$_emulatorUrl(config, $b1d72f86dd9d3107$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $b1d72f86dd9d3107$var$WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class $b1d72f86dd9d3107$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $b1d72f86dd9d3107$export$db3b6bfb95261072;
        this._completeRedirectFn = $b1d72f86dd9d3107$export$a33b77bbdbb8366c;
        this._overrideRedirectResult = $b1d72f86dd9d3107$export$b9a6b53f9be3734;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        $b1d72f86dd9d3107$export$d66dc83d8cfc8dd(this.eventManagers[auth._key()]?.manager, '_initialize() not called before _openPopup()');
        const url = await $b1d72f86dd9d3107$export$3d12bd131bb975d1(auth, provider, authType, $b1d72f86dd9d3107$var$_getCurrentUrl(), eventId);
        return $b1d72f86dd9d3107$var$_open(auth, url, $b1d72f86dd9d3107$export$c03999cb2f36933f());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $b1d72f86dd9d3107$export$3d12bd131bb975d1(auth, provider, authType, $b1d72f86dd9d3107$var$_getCurrentUrl(), eventId);
        $b1d72f86dd9d3107$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $b1d72f86dd9d3107$export$d66dc83d8cfc8dd(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $b1d72f86dd9d3107$var$_openIframe(auth);
        const manager = new $b1d72f86dd9d3107$export$158acd800e1ef08b(auth);
        iframe.register('authEvent', (iframeEvent)=>{
            $b1d72f86dd9d3107$export$24baa2b76016ce0e(iframeEvent?.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($b1d72f86dd9d3107$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $b1d72f86dd9d3107$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            const isSupported = result?.[0]?.[$b1d72f86dd9d3107$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $b1d72f86dd9d3107$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $b1d72f86dd9d3107$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $b1d72f86dd9d3107$var$_isMobileBrowser() || $b1d72f86dd9d3107$var$_isSafari() || $b1d72f86dd9d3107$export$92108d983e8ee699();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $b1d72f86dd9d3107$export$953cecd6e717a553 = $b1d72f86dd9d3107$var$BrowserPopupRedirectResolver;
class $b1d72f86dd9d3107$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $b1d72f86dd9d3107$var$debugFail('unexpected MultiFactorSessionType');
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $b1d72f86dd9d3107$var$PhoneMultiFactorAssertionImpl extends $b1d72f86dd9d3107$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $b1d72f86dd9d3107$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $b1d72f86dd9d3107$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $b1d72f86dd9d3107$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $b1d72f86dd9d3107$export$7ccc53e8f1e7dfc5 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $b1d72f86dd9d3107$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $b1d72f86dd9d3107$export$7ccc53e8f1e7dfc5.FACTOR_ID = 'phone';
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $b1d72f86dd9d3107$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $b1d72f86dd9d3107$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $b1d72f86dd9d3107$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        const mfaSession = session;
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof mfaSession.user?.auth !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $b1d72f86dd9d3107$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $b1d72f86dd9d3107$export$ae1af26003f05816._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $b1d72f86dd9d3107$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $b1d72f86dd9d3107$var$TotpMultiFactorAssertionImpl extends $b1d72f86dd9d3107$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $b1d72f86dd9d3107$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $b1d72f86dd9d3107$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $b1d72f86dd9d3107$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $b1d72f86dd9d3107$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $b1d72f86dd9d3107$export$ae1af26003f05816 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $b1d72f86dd9d3107$export$ae1af26003f05816(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        let useDefaults = false;
        if ($b1d72f86dd9d3107$var$_isEmptyString(accountName) || $b1d72f86dd9d3107$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($b1d72f86dd9d3107$var$_isEmptyString(accountName)) accountName = this.auth.currentUser?.email || 'unknownuser';
            if ($b1d72f86dd9d3107$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $b1d72f86dd9d3107$var$_isEmptyString(input) {
    return typeof input === 'undefined' || input?.length === 0;
}
var $b1d72f86dd9d3107$var$name = "@firebase/auth";
var $b1d72f86dd9d3107$var$version = "1.11.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1d72f86dd9d3107$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        this.assertAuthConfigured();
        return this.auth.currentUser?.uid || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener(user?.stsTokenManager.accessToken || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1d72f86dd9d3107$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */ :
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return 'cordova';
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return 'web-extension';
        default:
            return undefined;
    }
}
/** @internal */ function $b1d72f86dd9d3107$var$registerAuth(clientPlatform) {
    (0, $bVYHX._registerComponent)(new (0, $aPEEV.Component)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $b1d72f86dd9d3107$export$24baa2b76016ce0e(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $b1d72f86dd9d3107$export$faec65b429be379(clientPlatform)
        };
        const authInstance = new $b1d72f86dd9d3107$export$9f4f30ee63539e24(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $b1d72f86dd9d3107$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $bVYHX._registerComponent)(new (0, $aPEEV.Component)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $b1d72f86dd9d3107$export$23ebac1979863676(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $b1d72f86dd9d3107$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $bVYHX.registerVersion)($b1d72f86dd9d3107$var$name, $b1d72f86dd9d3107$var$version, $b1d72f86dd9d3107$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $bVYHX.registerVersion)($b1d72f86dd9d3107$var$name, $b1d72f86dd9d3107$var$version, 'esm2020');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1d72f86dd9d3107$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $b1d72f86dd9d3107$var$authIdTokenMaxAge = (0, $9k0Bn.getExperimentalSetting)('authIdTokenMaxAge') || $b1d72f86dd9d3107$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $b1d72f86dd9d3107$var$lastPostedIdToken = null;
const $b1d72f86dd9d3107$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $b1d72f86dd9d3107$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult?.token;
        if ($b1d72f86dd9d3107$var$lastPostedIdToken === idToken) return;
        $b1d72f86dd9d3107$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? 'POST' : 'DELETE',
            headers: idToken ? {
                'Authorization': `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $b1d72f86dd9d3107$export$ffb5f4729a158638(app = (0, $bVYHX.getApp)()) {
    const provider = (0, $bVYHX._getProvider)(app, 'auth');
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $b1d72f86dd9d3107$export$3466f893ebf79586(app, {
        popupRedirectResolver: $b1d72f86dd9d3107$export$953cecd6e717a553,
        persistence: [
            $b1d72f86dd9d3107$export$23f2a1d2818174ef,
            $b1d72f86dd9d3107$export$8b22cf2602fb60ce,
            $b1d72f86dd9d3107$export$db3b6bfb95261072
        ]
    });
    const authTokenSyncPath = (0, $9k0Bn.getExperimentalSetting)('authTokenSyncURL');
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === 'boolean' && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $b1d72f86dd9d3107$var$mintCookieFactory(authTokenSyncUrl.toString());
            $b1d72f86dd9d3107$export$4a5767248b18ef41(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $b1d72f86dd9d3107$export$d141bba7fdc215a3(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $9k0Bn.getDefaultEmulatorHost)('auth');
    if (authEmulatorHost) $b1d72f86dd9d3107$export$61196ced6d74a310(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $b1d72f86dd9d3107$var$getScriptParentElement() {
    return document.getElementsByTagName('head')?.[0] ?? document;
}
$b1d72f86dd9d3107$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement('script');
            el.setAttribute('src', url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $b1d72f86dd9d3107$export$890c4ad488842ce7("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = 'text/javascript';
            el.charset = 'UTF-8';
            $b1d72f86dd9d3107$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: 'https://apis.google.com/js/api.js',
    recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
    recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});
$b1d72f86dd9d3107$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );

});
parcelRegister("bVYHX", function(module, exports) {

$parcel$export(module.exports, "_registerComponent", function () { return $8b041be78626b50a$export$c930050e7bb63965; });
$parcel$export(module.exports, "_getProvider", function () { return $8b041be78626b50a$export$fa0d6da0f5838f50; });
$parcel$export(module.exports, "_isFirebaseServerApp", function () { return $8b041be78626b50a$export$643c8bc6c389f34e; });
$parcel$export(module.exports, "registerVersion", function () { return $8b041be78626b50a$export$d29d5299a7137abc; });
$parcel$export(module.exports, "SDK_VERSION", function () { return $8b041be78626b50a$export$31499a9cd224b78c; });
$parcel$export(module.exports, "initializeApp", function () { return $8b041be78626b50a$export$c55cfd413944906d; });
$parcel$export(module.exports, "getApp", function () { return $8b041be78626b50a$export$f9962582c9e66d99; });
$parcel$export(module.exports, "getApps", function () { return $8b041be78626b50a$export$68ddedf7d44b3bdf; });
$parcel$export(module.exports, "FirebaseError", function () { return (parcelRequire("9k0Bn")).FirebaseError; });

var $aPEEV = parcelRequire("aPEEV");

var $6mnY8 = parcelRequire("6mnY8");

var $9k0Bn = parcelRequire("9k0Bn");

var $cCiiD = parcelRequire("cCiiD");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8b041be78626b50a$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($8b041be78626b50a$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $8b041be78626b50a$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return component?.type === "VERSION" /* ComponentType.VERSION */ ;
}
const $8b041be78626b50a$var$name$q = "@firebase/app";
const $8b041be78626b50a$var$version$1 = "0.14.6";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8b041be78626b50a$var$logger = new (0, $6mnY8.Logger)('@firebase/app');
const $8b041be78626b50a$var$name$p = "@firebase/app-compat";
const $8b041be78626b50a$var$name$o = "@firebase/analytics-compat";
const $8b041be78626b50a$var$name$n = "@firebase/analytics";
const $8b041be78626b50a$var$name$m = "@firebase/app-check-compat";
const $8b041be78626b50a$var$name$l = "@firebase/app-check";
const $8b041be78626b50a$var$name$k = "@firebase/auth";
const $8b041be78626b50a$var$name$j = "@firebase/auth-compat";
const $8b041be78626b50a$var$name$i = "@firebase/database";
const $8b041be78626b50a$var$name$h = "@firebase/data-connect";
const $8b041be78626b50a$var$name$g = "@firebase/database-compat";
const $8b041be78626b50a$var$name$f = "@firebase/functions";
const $8b041be78626b50a$var$name$e = "@firebase/functions-compat";
const $8b041be78626b50a$var$name$d = "@firebase/installations";
const $8b041be78626b50a$var$name$c = "@firebase/installations-compat";
const $8b041be78626b50a$var$name$b = "@firebase/messaging";
const $8b041be78626b50a$var$name$a = "@firebase/messaging-compat";
const $8b041be78626b50a$var$name$9 = "@firebase/performance";
const $8b041be78626b50a$var$name$8 = "@firebase/performance-compat";
const $8b041be78626b50a$var$name$7 = "@firebase/remote-config";
const $8b041be78626b50a$var$name$6 = "@firebase/remote-config-compat";
const $8b041be78626b50a$var$name$5 = "@firebase/storage";
const $8b041be78626b50a$var$name$4 = "@firebase/storage-compat";
const $8b041be78626b50a$var$name$3 = "@firebase/firestore";
const $8b041be78626b50a$var$name$2 = "@firebase/ai";
const $8b041be78626b50a$var$name$1 = "@firebase/firestore-compat";
const $8b041be78626b50a$var$name = "firebase";
const $8b041be78626b50a$var$version = "12.6.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $8b041be78626b50a$export$9f30fa0c10967f7f = '[DEFAULT]';
const $8b041be78626b50a$var$PLATFORM_LOG_STRING = {
    [$8b041be78626b50a$var$name$q]: 'fire-core',
    [$8b041be78626b50a$var$name$p]: 'fire-core-compat',
    [$8b041be78626b50a$var$name$n]: 'fire-analytics',
    [$8b041be78626b50a$var$name$o]: 'fire-analytics-compat',
    [$8b041be78626b50a$var$name$l]: 'fire-app-check',
    [$8b041be78626b50a$var$name$m]: 'fire-app-check-compat',
    [$8b041be78626b50a$var$name$k]: 'fire-auth',
    [$8b041be78626b50a$var$name$j]: 'fire-auth-compat',
    [$8b041be78626b50a$var$name$i]: 'fire-rtdb',
    [$8b041be78626b50a$var$name$h]: 'fire-data-connect',
    [$8b041be78626b50a$var$name$g]: 'fire-rtdb-compat',
    [$8b041be78626b50a$var$name$f]: 'fire-fn',
    [$8b041be78626b50a$var$name$e]: 'fire-fn-compat',
    [$8b041be78626b50a$var$name$d]: 'fire-iid',
    [$8b041be78626b50a$var$name$c]: 'fire-iid-compat',
    [$8b041be78626b50a$var$name$b]: 'fire-fcm',
    [$8b041be78626b50a$var$name$a]: 'fire-fcm-compat',
    [$8b041be78626b50a$var$name$9]: 'fire-perf',
    [$8b041be78626b50a$var$name$8]: 'fire-perf-compat',
    [$8b041be78626b50a$var$name$7]: 'fire-rc',
    [$8b041be78626b50a$var$name$6]: 'fire-rc-compat',
    [$8b041be78626b50a$var$name$5]: 'fire-gcs',
    [$8b041be78626b50a$var$name$4]: 'fire-gcs-compat',
    [$8b041be78626b50a$var$name$3]: 'fire-fst',
    [$8b041be78626b50a$var$name$1]: 'fire-fst-compat',
    [$8b041be78626b50a$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$8b041be78626b50a$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $8b041be78626b50a$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $8b041be78626b50a$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8b041be78626b50a$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $8b041be78626b50a$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $8b041be78626b50a$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $8b041be78626b50a$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $8b041be78626b50a$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($8b041be78626b50a$export$9566bce3835c0f28.has(componentName)) {
        $8b041be78626b50a$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $8b041be78626b50a$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $8b041be78626b50a$export$b4e3c36c855b14b5.values())$8b041be78626b50a$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $8b041be78626b50a$export$fb03ad8d3d5c5f76.values())$8b041be78626b50a$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $8b041be78626b50a$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $8b041be78626b50a$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $8b041be78626b50a$export$9f30fa0c10967f7f) {
    $8b041be78626b50a$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $8b041be78626b50a$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $8b041be78626b50a$export$38e311c93c671bec(obj) {
    if ($8b041be78626b50a$export$110778f8e98b8257(obj)) return false;
    return 'authIdToken' in obj || 'appCheckToken' in obj || 'releaseOnDeref' in obj || 'automaticDataCollectionEnabled' in obj;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $8b041be78626b50a$export$643c8bc6c389f34e(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $8b041be78626b50a$export$3685d89b9c3cdfaf() {
    $8b041be78626b50a$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8b041be78626b50a$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $8b041be78626b50a$var$ERROR_FACTORY = new (0, $9k0Bn.ErrorFactory)('app', 'Firebase', $8b041be78626b50a$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8b041be78626b50a$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = {
            ...options
        };
        this._config = {
            ...config
        };
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $aPEEV.Component)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $8b041be78626b50a$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function $8b041be78626b50a$var$validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, $9k0Bn.base64Decode)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class $8b041be78626b50a$var$FirebaseServerAppImpl extends $8b041be78626b50a$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = {
            automaticDataCollectionEnabled: automaticDataCollectionEnabled,
            ...serverConfig
        };
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) $8b041be78626b50a$var$validateTokenTTL(this._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) $8b041be78626b50a$var$validateTokenTTL(this._serverConfig.appCheckToken, 'appCheckToken');
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $8b041be78626b50a$export$d29d5299a7137abc($8b041be78626b50a$var$name$q, $8b041be78626b50a$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $8b041be78626b50a$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $8b041be78626b50a$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $8b041be78626b50a$export$31499a9cd224b78c = $8b041be78626b50a$var$version;
function $8b041be78626b50a$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = {
        name: $8b041be78626b50a$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: true,
        ...rawConfig
    };
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $8b041be78626b50a$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $9k0Bn.getDefaultAppConfig)());
    if (!options) throw $8b041be78626b50a$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $8b041be78626b50a$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $9k0Bn.deepEqual)(options, existingApp.options) && (0, $9k0Bn.deepEqual)(config, existingApp.config)) return existingApp;
        else throw $8b041be78626b50a$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $aPEEV.ComponentContainer)(name);
    for (const component of $8b041be78626b50a$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $8b041be78626b50a$var$FirebaseAppImpl(options, config, container);
    $8b041be78626b50a$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $8b041be78626b50a$export$45a407ab953b136b(_options, _serverAppConfig = {}) {
    if ((0, $9k0Bn.isBrowser)() && !(0, $9k0Bn.isWebWorker)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $8b041be78626b50a$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    let firebaseOptions;
    let serverAppSettings = _serverAppConfig || {};
    if (_options) {
        if ($8b041be78626b50a$export$110778f8e98b8257(_options)) firebaseOptions = _options.options;
        else if ($8b041be78626b50a$export$38e311c93c671bec(_options)) serverAppSettings = _options;
        else firebaseOptions = _options;
    }
    if (serverAppSettings.automaticDataCollectionEnabled === undefined) serverAppSettings.automaticDataCollectionEnabled = true;
    firebaseOptions || (firebaseOptions = (0, $9k0Bn.getDefaultAppConfig)());
    if (!firebaseOptions) throw $8b041be78626b50a$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    // Build an app name based on a hash of the configuration options.
    const nameObj = {
        ...serverAppSettings,
        ...firebaseOptions
    };
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (serverAppSettings.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $8b041be78626b50a$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $8b041be78626b50a$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(serverAppSettings.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $aPEEV.ComponentContainer)(nameString);
    for (const component of $8b041be78626b50a$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $8b041be78626b50a$var$FirebaseServerAppImpl(firebaseOptions, serverAppSettings, nameString, container);
    $8b041be78626b50a$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $8b041be78626b50a$export$f9962582c9e66d99(name = $8b041be78626b50a$export$9f30fa0c10967f7f) {
    const app = $8b041be78626b50a$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $8b041be78626b50a$export$9f30fa0c10967f7f && (0, $9k0Bn.getDefaultAppConfig)()) return $8b041be78626b50a$export$c55cfd413944906d();
    if (!app) throw $8b041be78626b50a$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $8b041be78626b50a$export$68ddedf7d44b3bdf() {
    return Array.from($8b041be78626b50a$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $8b041be78626b50a$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($8b041be78626b50a$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $8b041be78626b50a$export$b4e3c36c855b14b5.delete(name);
    } else if ($8b041be78626b50a$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $8b041be78626b50a$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $8b041be78626b50a$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = $8b041be78626b50a$var$PLATFORM_LOG_STRING[libraryKeyOrName] ?? libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $8b041be78626b50a$var$logger.warn(warning.join(' '));
        return;
    }
    $8b041be78626b50a$export$c930050e7bb63965(new (0, $aPEEV.Component)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $8b041be78626b50a$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $8b041be78626b50a$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $6mnY8.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $8b041be78626b50a$export$c622e99c0ce7b1c9(logLevel) {
    (0, $6mnY8.setLogLevel)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8b041be78626b50a$var$DB_NAME = 'firebase-heartbeat-database';
const $8b041be78626b50a$var$DB_VERSION = 1;
const $8b041be78626b50a$var$STORE_NAME = 'firebase-heartbeat-store';
let $8b041be78626b50a$var$dbPromise = null;
function $8b041be78626b50a$var$getDbPromise() {
    if (!$8b041be78626b50a$var$dbPromise) $8b041be78626b50a$var$dbPromise = (0, $cCiiD.openDB)($8b041be78626b50a$var$DB_NAME, $8b041be78626b50a$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($8b041be78626b50a$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $8b041be78626b50a$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $8b041be78626b50a$var$dbPromise;
}
async function $8b041be78626b50a$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $8b041be78626b50a$var$getDbPromise();
        const tx = db.transaction($8b041be78626b50a$var$STORE_NAME);
        const result = await tx.objectStore($8b041be78626b50a$var$STORE_NAME).get($8b041be78626b50a$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $9k0Bn.FirebaseError)) $8b041be78626b50a$var$logger.warn(e.message);
        else {
            const idbGetError = $8b041be78626b50a$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e?.message
            });
            $8b041be78626b50a$var$logger.warn(idbGetError.message);
        }
    }
}
async function $8b041be78626b50a$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $8b041be78626b50a$var$getDbPromise();
        const tx = db.transaction($8b041be78626b50a$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($8b041be78626b50a$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $8b041be78626b50a$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $9k0Bn.FirebaseError)) $8b041be78626b50a$var$logger.warn(e.message);
        else {
            const idbGetError = $8b041be78626b50a$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e?.message
            });
            $8b041be78626b50a$var$logger.warn(idbGetError.message);
        }
    }
}
function $8b041be78626b50a$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8b041be78626b50a$var$MAX_HEADER_BYTES = 1024;
const $8b041be78626b50a$var$MAX_NUM_STORED_HEARTBEATS = 30;
class $8b041be78626b50a$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $8b041be78626b50a$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $8b041be78626b50a$var$getUTCDateString();
            if (this._heartbeatsCache?.heartbeats == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (this._heartbeatsCache?.heartbeats == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date: date,
                    agent: agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > $8b041be78626b50a$var$MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = $8b041be78626b50a$var$getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $8b041be78626b50a$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (this._heartbeatsCache?.heartbeats == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = $8b041be78626b50a$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $8b041be78626b50a$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $9k0Bn.base64urlEncodeWithoutPadding)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $8b041be78626b50a$var$logger.warn(e);
            return '';
        }
    }
}
function $8b041be78626b50a$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $8b041be78626b50a$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $8b041be78626b50a$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($8b041be78626b50a$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($8b041be78626b50a$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $8b041be78626b50a$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $9k0Bn.isIndexedDBAvailable)()) return false;
        else return (0, $9k0Bn.validateIndexedDBOpenable)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $8b041be78626b50a$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject?.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $8b041be78626b50a$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $8b041be78626b50a$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $8b041be78626b50a$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $9k0Bn.base64urlEncodeWithoutPadding)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function $8b041be78626b50a$var$getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8b041be78626b50a$var$registerCoreComponents(variant) {
    $8b041be78626b50a$export$c930050e7bb63965(new (0, $aPEEV.Component)('platform-logger', (container)=>new $8b041be78626b50a$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $8b041be78626b50a$export$c930050e7bb63965(new (0, $aPEEV.Component)('heartbeat', (container)=>new $8b041be78626b50a$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $8b041be78626b50a$export$d29d5299a7137abc($8b041be78626b50a$var$name$q, $8b041be78626b50a$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    $8b041be78626b50a$export$d29d5299a7137abc($8b041be78626b50a$var$name$q, $8b041be78626b50a$var$version$1, 'esm2020');
    // Register platform SDK identifier (no version).
    $8b041be78626b50a$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $8b041be78626b50a$var$registerCoreComponents('');

});
parcelRegister("aPEEV", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $7e2e34d8482c77be$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "ComponentContainer", function () { return $7e2e34d8482c77be$export$436a80eea5d5c0c5; });

var $9k0Bn = parcelRequire("9k0Bn");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $7e2e34d8482c77be$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7e2e34d8482c77be$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $7e2e34d8482c77be$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $9k0Bn.Deferred)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options?.identifier);
        const optional = options?.optional ?? false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($7e2e34d8482c77be$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $7e2e34d8482c77be$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $7e2e34d8482c77be$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $7e2e34d8482c77be$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $7e2e34d8482c77be$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = this.onInitCallbacks.get(normalizedIdentifier) ?? new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch  {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $7e2e34d8482c77be$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch  {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $7e2e34d8482c77be$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $7e2e34d8482c77be$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $7e2e34d8482c77be$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $7e2e34d8482c77be$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $7e2e34d8482c77be$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $7e2e34d8482c77be$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $7e2e34d8482c77be$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}

});
parcelRegister("9k0Bn", function(module, exports) {

$parcel$export(module.exports, "base64urlEncodeWithoutPadding", function () { return $6c9672d0931fa990$export$4b5284a3025a455; });
$parcel$export(module.exports, "base64Decode", function () { return $6c9672d0931fa990$export$c62426fdd000a97e; });
$parcel$export(module.exports, "getDefaultEmulatorHost", function () { return $6c9672d0931fa990$export$9c11895284c8adad; });
$parcel$export(module.exports, "getDefaultAppConfig", function () { return $6c9672d0931fa990$export$3dfb6827a9f89756; });
$parcel$export(module.exports, "getExperimentalSetting", function () { return $6c9672d0931fa990$export$5539a1a3afe87d6; });
$parcel$export(module.exports, "Deferred", function () { return $6c9672d0931fa990$export$85f6557964517f1a; });
$parcel$export(module.exports, "isCloudWorkstation", function () { return $6c9672d0931fa990$export$5b4d24b45140ad90; });
$parcel$export(module.exports, "pingServer", function () { return $6c9672d0931fa990$export$c0f0d0ce4283a937; });
$parcel$export(module.exports, "updateEmulatorBanner", function () { return $6c9672d0931fa990$export$fd3d2954543183b1; });
$parcel$export(module.exports, "getUA", function () { return $6c9672d0931fa990$export$c36915b22ce77c19; });
$parcel$export(module.exports, "isMobileCordova", function () { return $6c9672d0931fa990$export$872f8323f01d7ae0; });
$parcel$export(module.exports, "isBrowser", function () { return $6c9672d0931fa990$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "isWebWorker", function () { return $6c9672d0931fa990$export$97b87b8868ff7a3c; });
$parcel$export(module.exports, "isCloudflareWorker", function () { return $6c9672d0931fa990$export$ad9e9b75cb9fb797; });
$parcel$export(module.exports, "isBrowserExtension", function () { return $6c9672d0931fa990$export$caa8774a9107a58e; });
$parcel$export(module.exports, "isReactNative", function () { return $6c9672d0931fa990$export$f7a1e23e542d38e3; });
$parcel$export(module.exports, "isIE", function () { return $6c9672d0931fa990$export$7e7b1a9668aaed8; });
$parcel$export(module.exports, "isIndexedDBAvailable", function () { return $6c9672d0931fa990$export$3865db50535c2055; });
$parcel$export(module.exports, "validateIndexedDBOpenable", function () { return $6c9672d0931fa990$export$a8a3018f3d187a4d; });
$parcel$export(module.exports, "FirebaseError", function () { return $6c9672d0931fa990$export$dd24e9cd51226c56; });
$parcel$export(module.exports, "ErrorFactory", function () { return $6c9672d0931fa990$export$3fa6e1b18a3b2d40; });
$parcel$export(module.exports, "isEmpty", function () { return $6c9672d0931fa990$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "deepEqual", function () { return $6c9672d0931fa990$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "querystring", function () { return $6c9672d0931fa990$export$ac4103b836844853; });
$parcel$export(module.exports, "querystringDecode", function () { return $6c9672d0931fa990$export$c1271ca4c8a70741; });
$parcel$export(module.exports, "extractQuerystring", function () { return $6c9672d0931fa990$export$1a8408415472d8ed; });
$parcel$export(module.exports, "createSubscribe", function () { return $6c9672d0931fa990$export$364097d812234b3f; });
$parcel$export(module.exports, "getModularInstance", function () { return $6c9672d0931fa990$export$4befe9b5fa509a1b; });

var $6f4KJ = parcelRequire("6f4KJ");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $6c9672d0931fa990$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $6c9672d0931fa990$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $6c9672d0931fa990$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $6c9672d0931fa990$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $6c9672d0931fa990$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6c9672d0931fa990$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $6c9672d0931fa990$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $6c9672d0931fa990$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($6c9672d0931fa990$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $6c9672d0931fa990$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $6c9672d0931fa990$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $6c9672d0931fa990$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $6c9672d0931fa990$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $6c9672d0931fa990$var$stringToByteArray$1(str);
    return $6c9672d0931fa990$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $6c9672d0931fa990$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $6c9672d0931fa990$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $6c9672d0931fa990$export$c62426fdd000a97e = function(str) {
    try {
        return $6c9672d0931fa990$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $6c9672d0931fa990$export$6c40052bed430212(value) {
    return $6c9672d0931fa990$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $6c9672d0931fa990$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$6c9672d0931fa990$var$isValidKey(prop)) continue;
        target[prop] = $6c9672d0931fa990$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $6c9672d0931fa990$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $6c9672d0931fa990$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6c9672d0931fa990$var$getDefaultsFromGlobal = ()=>$6c9672d0931fa990$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $6c9672d0931fa990$var$getDefaultsFromEnvVariable = ()=>{
    return;
};
const $6c9672d0931fa990$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $6c9672d0931fa990$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $6c9672d0931fa990$export$212bb2fc580a90a8 = ()=>{
    try {
        return (0, $6f4KJ.getDefaultsFromPostinstall)() || $6c9672d0931fa990$var$getDefaultsFromGlobal() || $6c9672d0931fa990$var$getDefaultsFromEnvVariable() || $6c9672d0931fa990$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $6c9672d0931fa990$export$9c11895284c8adad = (productName)=>$6c9672d0931fa990$export$212bb2fc580a90a8()?.emulatorHosts?.[productName];
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $6c9672d0931fa990$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $6c9672d0931fa990$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $6c9672d0931fa990$export$3dfb6827a9f89756 = ()=>$6c9672d0931fa990$export$212bb2fc580a90a8()?.config;
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $6c9672d0931fa990$export$5539a1a3afe87d6 = (name)=>$6c9672d0931fa990$export$212bb2fc580a90a8()?.[`_${name}`];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $6c9672d0931fa990$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function $6c9672d0931fa990$export$5b4d24b45140ad90(url) {
    // `isCloudWorkstation` is called without protocol in certain connect*Emulator functions
    // In HTTP request builders, it's called with the protocol.
    // If called with protocol prefix, it's a valid URL, so we extract the hostname
    // If called without, we assume the string is the hostname.
    try {
        const host = url.startsWith('http://') || url.startsWith('https://') ? new URL(url).hostname : url;
        return host.endsWith('.cloudworkstations.dev');
    } catch  {
        return false;
    }
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function $6c9672d0931fa990$export$c0f0d0ce4283a937(endpoint) {
    const result = await fetch(endpoint, {
        credentials: 'include'
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $6c9672d0931fa990$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = {
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        },
        // Override with user options
        ...token
    };
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $6c9672d0931fa990$export$4b5284a3025a455(JSON.stringify(header)),
        $6c9672d0931fa990$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
const $6c9672d0931fa990$var$emulatorStatus = {};
// Checks whether any products are running on an emulator
function $6c9672d0931fa990$var$getEmulatorSummary() {
    const summary = {
        prod: [],
        emulator: []
    };
    for (const key of Object.keys($6c9672d0931fa990$var$emulatorStatus))if ($6c9672d0931fa990$var$emulatorStatus[key]) summary.emulator.push(key);
    else summary.prod.push(key);
    return summary;
}
function $6c9672d0931fa990$var$getOrCreateEl(id) {
    let parentDiv = document.getElementById(id);
    let created = false;
    if (!parentDiv) {
        parentDiv = document.createElement('div');
        parentDiv.setAttribute('id', id);
        created = true;
    }
    return {
        created: created,
        element: parentDiv
    };
}
let $6c9672d0931fa990$var$previouslyDismissed = false;
/**
 * Updates Emulator Banner. Primarily used for Firebase Studio
 * @param name
 * @param isRunningEmulator
 * @public
 */ function $6c9672d0931fa990$export$fd3d2954543183b1(name, isRunningEmulator) {
    if (typeof window === 'undefined' || typeof document === 'undefined' || !$6c9672d0931fa990$export$5b4d24b45140ad90(window.location.host) || $6c9672d0931fa990$var$emulatorStatus[name] === isRunningEmulator || $6c9672d0931fa990$var$emulatorStatus[name] || // If already set to use emulator, can't go back to prod.
    $6c9672d0931fa990$var$previouslyDismissed) return;
    $6c9672d0931fa990$var$emulatorStatus[name] = isRunningEmulator;
    function prefixedId(id) {
        return `__firebase__banner__${id}`;
    }
    const bannerId = '__firebase__banner';
    const summary = $6c9672d0931fa990$var$getEmulatorSummary();
    const showError = summary.prod.length > 0;
    function tearDown() {
        const element = document.getElementById(bannerId);
        if (element) element.remove();
    }
    function setupBannerStyles(bannerEl) {
        bannerEl.style.display = 'flex';
        bannerEl.style.background = '#7faaf0';
        bannerEl.style.position = 'fixed';
        bannerEl.style.bottom = '5px';
        bannerEl.style.left = '5px';
        bannerEl.style.padding = '.5em';
        bannerEl.style.borderRadius = '5px';
        bannerEl.style.alignItems = 'center';
    }
    function setupIconStyles(prependIcon, iconId) {
        prependIcon.setAttribute('width', '24');
        prependIcon.setAttribute('id', iconId);
        prependIcon.setAttribute('height', '24');
        prependIcon.setAttribute('viewBox', '0 0 24 24');
        prependIcon.setAttribute('fill', 'none');
        prependIcon.style.marginLeft = '-6px';
    }
    function setupCloseBtn() {
        const closeBtn = document.createElement('span');
        closeBtn.style.cursor = 'pointer';
        closeBtn.style.marginLeft = '16px';
        closeBtn.style.fontSize = '24px';
        closeBtn.innerHTML = ' &times;';
        closeBtn.onclick = ()=>{
            $6c9672d0931fa990$var$previouslyDismissed = true;
            tearDown();
        };
        return closeBtn;
    }
    function setupLinkStyles(learnMoreLink, learnMoreId) {
        learnMoreLink.setAttribute('id', learnMoreId);
        learnMoreLink.innerText = 'Learn more';
        learnMoreLink.href = 'https://firebase.google.com/docs/studio/preview-apps#preview-backend';
        learnMoreLink.setAttribute('target', '__blank');
        learnMoreLink.style.paddingLeft = '5px';
        learnMoreLink.style.textDecoration = 'underline';
    }
    function setupDom() {
        const banner = $6c9672d0931fa990$var$getOrCreateEl(bannerId);
        const firebaseTextId = prefixedId('text');
        const firebaseText = document.getElementById(firebaseTextId) || document.createElement('span');
        const learnMoreId = prefixedId('learnmore');
        const learnMoreLink = document.getElementById(learnMoreId) || document.createElement('a');
        const prependIconId = prefixedId('preprendIcon');
        const prependIcon = document.getElementById(prependIconId) || document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        if (banner.created) {
            // update styles
            const bannerEl = banner.element;
            setupBannerStyles(bannerEl);
            setupLinkStyles(learnMoreLink, learnMoreId);
            const closeBtn = setupCloseBtn();
            setupIconStyles(prependIcon, prependIconId);
            bannerEl.append(prependIcon, firebaseText, learnMoreLink, closeBtn);
            document.body.appendChild(bannerEl);
        }
        if (showError) {
            firebaseText.innerText = `Preview backend disconnected.`;
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6013_33858)">
<path d="M4.8 17.6L12 5.6L19.2 17.6H4.8ZM6.91667 16.4H17.0833L12 7.93333L6.91667 16.4ZM12 15.6C12.1667 15.6 12.3056 15.5444 12.4167 15.4333C12.5389 15.3111 12.6 15.1667 12.6 15C12.6 14.8333 12.5389 14.6944 12.4167 14.5833C12.3056 14.4611 12.1667 14.4 12 14.4C11.8333 14.4 11.6889 14.4611 11.5667 14.5833C11.4556 14.6944 11.4 14.8333 11.4 15C11.4 15.1667 11.4556 15.3111 11.5667 15.4333C11.6889 15.5444 11.8333 15.6 12 15.6ZM11.4 13.6H12.6V10.4H11.4V13.6Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6013_33858">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
        } else {
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6083_34804)">
<path d="M11.4 15.2H12.6V11.2H11.4V15.2ZM12 10C12.1667 10 12.3056 9.94444 12.4167 9.83333C12.5389 9.71111 12.6 9.56667 12.6 9.4C12.6 9.23333 12.5389 9.09444 12.4167 8.98333C12.3056 8.86111 12.1667 8.8 12 8.8C11.8333 8.8 11.6889 8.86111 11.5667 8.98333C11.4556 9.09444 11.4 9.23333 11.4 9.4C11.4 9.56667 11.4556 9.71111 11.5667 9.83333C11.6889 9.94444 11.8333 10 12 10ZM12 18.4C11.1222 18.4 10.2944 18.2333 9.51667 17.9C8.73889 17.5667 8.05556 17.1111 7.46667 16.5333C6.88889 15.9444 6.43333 15.2611 6.1 14.4833C5.76667 13.7056 5.6 12.8778 5.6 12C5.6 11.1111 5.76667 10.2833 6.1 9.51667C6.43333 8.73889 6.88889 8.06111 7.46667 7.48333C8.05556 6.89444 8.73889 6.43333 9.51667 6.1C10.2944 5.76667 11.1222 5.6 12 5.6C12.8889 5.6 13.7167 5.76667 14.4833 6.1C15.2611 6.43333 15.9389 6.89444 16.5167 7.48333C17.1056 8.06111 17.5667 8.73889 17.9 9.51667C18.2333 10.2833 18.4 11.1111 18.4 12C18.4 12.8778 18.2333 13.7056 17.9 14.4833C17.5667 15.2611 17.1056 15.9444 16.5167 16.5333C15.9389 17.1111 15.2611 17.5667 14.4833 17.9C13.7167 18.2333 12.8889 18.4 12 18.4ZM12 17.2C13.4444 17.2 14.6722 16.6944 15.6833 15.6833C16.6944 14.6722 17.2 13.4444 17.2 12C17.2 10.5556 16.6944 9.32778 15.6833 8.31667C14.6722 7.30555 13.4444 6.8 12 6.8C10.5556 6.8 9.32778 7.30555 8.31667 8.31667C7.30556 9.32778 6.8 10.5556 6.8 12C6.8 13.4444 7.30556 14.6722 8.31667 15.6833C9.32778 16.6944 10.5556 17.2 12 17.2Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6083_34804">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
            firebaseText.innerText = 'Preview backend running in this workspace.';
        }
        firebaseText.setAttribute('id', firebaseTextId);
    }
    if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', setupDom);
    else setupDom();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $6c9672d0931fa990$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $6c9672d0931fa990$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($6c9672d0931fa990$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $6c9672d0931fa990$export$8ee0fc9ee280b4ee() {
    const forceEnvironment = $6c9672d0931fa990$export$212bb2fc580a90a8()?.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $6c9672d0931fa990$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $6c9672d0931fa990$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $6c9672d0931fa990$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $6c9672d0931fa990$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $6c9672d0931fa990$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $6c9672d0931fa990$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $6c9672d0931fa990$export$f2f6a8999f8ebd30() {
    return $6c9672d0931fa990$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $6c9672d0931fa990$export$7e7b1a9668aaed8() {
    const ua = $6c9672d0931fa990$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $6c9672d0931fa990$export$202944b2d2824246() {
    return $6c9672d0931fa990$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $6c9672d0931fa990$export$5d1d834fbbf8bab7() {
    return $6c9672d0931fa990$export$588c7fdda06fbb0a.NODE_CLIENT === true || $6c9672d0931fa990$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $6c9672d0931fa990$export$95df08bae54cb4df() {
    return !$6c9672d0931fa990$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/** Returns true if we are running in Safari or WebKit */ function $6c9672d0931fa990$export$ef10bcfb06572016() {
    return !$6c9672d0931fa990$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && (navigator.userAgent.includes('Safari') || navigator.userAgent.includes('WebKit')) && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $6c9672d0931fa990$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $6c9672d0931fa990$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                reject(request.error?.message || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $6c9672d0931fa990$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $6c9672d0931fa990$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $6c9672d0931fa990$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $6c9672d0931fa990$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $6c9672d0931fa990$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $6c9672d0931fa990$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $6c9672d0931fa990$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $6c9672d0931fa990$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $6c9672d0931fa990$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $6c9672d0931fa990$var$replaceTemplate(template, data) {
    return template.replace($6c9672d0931fa990$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $6c9672d0931fa990$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $6c9672d0931fa990$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $6c9672d0931fa990$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $6c9672d0931fa990$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $6c9672d0931fa990$export$c5a53ce6a17cf18d($6c9672d0931fa990$export$c62426fdd000a97e(parts[0]) || '');
        claims = $6c9672d0931fa990$export$c5a53ce6a17cf18d($6c9672d0931fa990$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $6c9672d0931fa990$export$5f870fcca7ae6a88 = function(token) {
    const claims = $6c9672d0931fa990$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $6c9672d0931fa990$export$701c661ec91095f2 = function(token) {
    const claims = $6c9672d0931fa990$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $6c9672d0931fa990$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $6c9672d0931fa990$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $6c9672d0931fa990$export$fc970ed23da99565 = function(token) {
    const claims = $6c9672d0931fa990$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $6c9672d0931fa990$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $6c9672d0931fa990$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $6c9672d0931fa990$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $6c9672d0931fa990$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $6c9672d0931fa990$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($6c9672d0931fa990$var$isObject(aProp) && $6c9672d0931fa990$var$isObject(bProp)) {
            if (!$6c9672d0931fa990$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $6c9672d0931fa990$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $6c9672d0931fa990$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $6c9672d0931fa990$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $6c9672d0931fa990$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $6c9672d0931fa990$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $6c9672d0931fa990$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $6c9672d0931fa990$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $6c9672d0931fa990$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $6c9672d0931fa990$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $6c9672d0931fa990$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($6c9672d0931fa990$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $6c9672d0931fa990$var$noop;
        if (observer.error === undefined) observer.error = $6c9672d0931fa990$var$noop;
        if (observer.complete === undefined) observer.complete = $6c9672d0931fa990$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $6c9672d0931fa990$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $6c9672d0931fa990$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $6c9672d0931fa990$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $6c9672d0931fa990$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $6c9672d0931fa990$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $6c9672d0931fa990$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($6c9672d0931fa990$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $6c9672d0931fa990$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($6c9672d0931fa990$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $6c9672d0931fa990$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($6c9672d0931fa990$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $6c9672d0931fa990$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $6c9672d0931fa990$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $6c9672d0931fa990$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $6c9672d0931fa990$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $6c9672d0931fa990$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $6c9672d0931fa990$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $6c9672d0931fa990$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $6c9672d0931fa990$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $6c9672d0931fa990$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $6c9672d0931fa990$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $6c9672d0931fa990$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($6c9672d0931fa990$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $6c9672d0931fa990$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $6c9672d0931fa990$var$indicator(i);
}
function $6c9672d0931fa990$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $6c9672d0931fa990$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}

});
parcelRegister("6f4KJ", function(module, exports) {

$parcel$export(module.exports, "getDefaultsFromPostinstall", function () { return $2bcd0cec9f1e299c$export$6d3c090e66a883b1; });
const $2bcd0cec9f1e299c$export$6d3c090e66a883b1 = ()=>undefined;

});



parcelRegister("6mnY8", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $4a1763e4248d914b$export$243e62d78d3b544d; });
$parcel$export(module.exports, "Logger", function () { return $4a1763e4248d914b$export$efa9a398d6368992; });
$parcel$export(module.exports, "setLogLevel", function () { return $4a1763e4248d914b$export$c622e99c0ce7b1c9; });
$parcel$export(module.exports, "setUserLogHandler", function () { return $4a1763e4248d914b$export$29577d29c84db5f6; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $4a1763e4248d914b$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $4a1763e4248d914b$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($4a1763e4248d914b$export$243e62d78d3b544d || ($4a1763e4248d914b$export$243e62d78d3b544d = {}));
const $4a1763e4248d914b$var$levelStringToEnum = {
    'debug': $4a1763e4248d914b$export$243e62d78d3b544d.DEBUG,
    'verbose': $4a1763e4248d914b$export$243e62d78d3b544d.VERBOSE,
    'info': $4a1763e4248d914b$export$243e62d78d3b544d.INFO,
    'warn': $4a1763e4248d914b$export$243e62d78d3b544d.WARN,
    'error': $4a1763e4248d914b$export$243e62d78d3b544d.ERROR,
    'silent': $4a1763e4248d914b$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $4a1763e4248d914b$var$defaultLogLevel = $4a1763e4248d914b$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $4a1763e4248d914b$var$ConsoleMethod = {
    [$4a1763e4248d914b$export$243e62d78d3b544d.DEBUG]: 'log',
    [$4a1763e4248d914b$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$4a1763e4248d914b$export$243e62d78d3b544d.INFO]: 'info',
    [$4a1763e4248d914b$export$243e62d78d3b544d.WARN]: 'warn',
    [$4a1763e4248d914b$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $4a1763e4248d914b$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $4a1763e4248d914b$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $4a1763e4248d914b$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $4a1763e4248d914b$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $4a1763e4248d914b$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $4a1763e4248d914b$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $4a1763e4248d914b$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $4a1763e4248d914b$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $4a1763e4248d914b$export$c622e99c0ce7b1c9(level) {
    $4a1763e4248d914b$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $4a1763e4248d914b$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $4a1763e4248d914b$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $4a1763e4248d914b$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel ?? instance.logLevel)) logCallback({
                level: $4a1763e4248d914b$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}

});

parcelRegister("cCiiD", function(module, exports) {

$parcel$export(module.exports, "openDB", function () { return $92f73a92431170de$export$ca0ed41b1a2af7e; });

var $ekHjI = parcelRequire("ekHjI");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $92f73a92431170de$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $ekHjI.w)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $ekHjI.w)(request.result), event.oldVersion, event.newVersion, (0, $ekHjI.w)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $92f73a92431170de$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $ekHjI.w)(request).then(()=>undefined);
}
const $92f73a92431170de$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $92f73a92431170de$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $92f73a92431170de$var$cachedMethods = new Map();
function $92f73a92431170de$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($92f73a92431170de$var$cachedMethods.get(prop)) return $92f73a92431170de$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $92f73a92431170de$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $92f73a92431170de$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $92f73a92431170de$var$cachedMethods.set(prop, method);
    return method;
}
(0, $ekHjI.r)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$92f73a92431170de$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$92f73a92431170de$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));

});
parcelRegister("ekHjI", function(module, exports) {

$parcel$export(module.exports, "w", function () { return $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "r", function () { return $a6f488ce4cf7dbe7$export$43caf9889c228507; });
const $a6f488ce4cf7dbe7$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $a6f488ce4cf7dbe7$var$idbProxyableTypes;
let $a6f488ce4cf7dbe7$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $a6f488ce4cf7dbe7$var$getIdbProxyableTypes() {
    return $a6f488ce4cf7dbe7$var$idbProxyableTypes || ($a6f488ce4cf7dbe7$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $a6f488ce4cf7dbe7$var$getCursorAdvanceMethods() {
    return $a6f488ce4cf7dbe7$var$cursorAdvanceMethods || ($a6f488ce4cf7dbe7$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $a6f488ce4cf7dbe7$var$cursorRequestMap = new WeakMap();
const $a6f488ce4cf7dbe7$var$transactionDoneMap = new WeakMap();
const $a6f488ce4cf7dbe7$var$transactionStoreNamesMap = new WeakMap();
const $a6f488ce4cf7dbe7$var$transformCache = new WeakMap();
const $a6f488ce4cf7dbe7$export$407448d2b89b1813 = new WeakMap();
function $a6f488ce4cf7dbe7$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($a6f488ce4cf7dbe7$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $a6f488ce4cf7dbe7$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $a6f488ce4cf7dbe7$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $a6f488ce4cf7dbe7$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($a6f488ce4cf7dbe7$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $a6f488ce4cf7dbe7$var$transactionDoneMap.set(tx, done);
}
let $a6f488ce4cf7dbe7$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $a6f488ce4cf7dbe7$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $a6f488ce4cf7dbe7$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $a6f488ce4cf7dbe7$export$43caf9889c228507(callback) {
    $a6f488ce4cf7dbe7$var$idbProxyTraps = callback($a6f488ce4cf7dbe7$var$idbProxyTraps);
}
function $a6f488ce4cf7dbe7$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($a6f488ce4cf7dbe7$export$3b14a55fb2447963(this), storeNames, ...args);
        $a6f488ce4cf7dbe7$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($a6f488ce4cf7dbe7$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($a6f488ce4cf7dbe7$export$3b14a55fb2447963(this), args);
        return $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b($a6f488ce4cf7dbe7$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b(func.apply($a6f488ce4cf7dbe7$export$3b14a55fb2447963(this), args));
    };
}
function $a6f488ce4cf7dbe7$var$transformCachableValue(value) {
    if (typeof value === 'function') return $a6f488ce4cf7dbe7$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $a6f488ce4cf7dbe7$var$cacheDonePromiseForTransaction(value);
    if ($a6f488ce4cf7dbe7$export$23f2a1d2818174ef(value, $a6f488ce4cf7dbe7$var$getIdbProxyableTypes())) return new Proxy(value, $a6f488ce4cf7dbe7$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $a6f488ce4cf7dbe7$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($a6f488ce4cf7dbe7$var$transformCache.has(value)) return $a6f488ce4cf7dbe7$var$transformCache.get(value);
    const newValue = $a6f488ce4cf7dbe7$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $a6f488ce4cf7dbe7$var$transformCache.set(value, newValue);
        $a6f488ce4cf7dbe7$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $a6f488ce4cf7dbe7$export$3b14a55fb2447963 = (value)=>$a6f488ce4cf7dbe7$export$407448d2b89b1813.get(value);

});






parcelRegister("fEgSm", function(module, exports) {

$parcel$export(module.exports, "FETCH_TIMEOUT_MESSAGE", function () { return $0c0caf95a4514680$export$d9233801cfde16c7; });
$parcel$export(module.exports, "timeoutInit", function () { return $0c0caf95a4514680$export$8c3936aebc2dace1; });
$parcel$export(module.exports, "isAbortError", function () { return $0c0caf95a4514680$export$d2c30ea522b3259e; });
/**
 * Request-timeout helpers, deliberately kept free of any import that reaches
 * outside the module.
 *
 * These live apart from `fetchApi` because that module pulls in the logger,
 * which cannot initialise under jsdom: a test that mocks `fetchApi` to avoid
 * the network would otherwise have to mock these pure functions too, and an
 * auto-mocked `timeoutInit` answers `undefined` - something the real one can
 * never return.
 */ /**
 * Copy for a request this client gave up on. The engine's own wording is not
 * fit to show anyone - WebKit says "Fetch is aborted", Blink "signal timed
 * out" - and an abort is the one failure the user can usefully act on.
 */ const $0c0caf95a4514680$export$d9233801cfde16c7 = "This is taking longer than usual. Please try again in a moment.";
function $0c0caf95a4514680$export$8c3936aebc2dace1(ms) {
    return typeof AbortSignal?.timeout === "function" ? {
        signal: AbortSignal.timeout(ms)
    } : {};
}
function $0c0caf95a4514680$export$d2c30ea522b3259e(e) {
    if (typeof e !== "object" || e === null) return false;
    const { name: name } = e;
    return name === "AbortError" || name === "TimeoutError";
}

});



parcelRegister("96Qh9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0d577f640d1baee$export$2e2bcd8739ae039; });
/**
 * Query params that carry credentials and must never reach telemetry.
 *
 * The WebView sign-in token is stripped from the URL before RUM starts (see
 * `captureAuthTokenFromUrl`), so this is defence in depth for any path that
 * still manages to observe one — a referrer captured mid-navigation, a
 * resource request, a hand-built link.
 */ const $d0d577f640d1baee$export$a18c19cc1347bf0 = [
    "token"
];
function $d0d577f640d1baee$export$2e2bcd8739ae039(url) {
    if (!url) return url;
    try {
        const parsed = new URL(url);
        let redacted = false;
        $d0d577f640d1baee$export$a18c19cc1347bf0.forEach((param)=>{
            if (parsed.searchParams.has(param)) {
                parsed.searchParams.set(param, "REDACTED");
                redacted = true;
            }
        });
        return redacted ? parsed.toString() : url;
    } catch  {
        // Not an absolute URL; nothing safe to rewrite.
        return url;
    }
}

});



parcelRegister("e8yyN", function(module, exports) {

$parcel$export(module.exports, "darkTheme", function () { return $7251f1874f412b5f$export$3e936a8db52a10a0; });
$parcel$export(module.exports, "default", function () { return $7251f1874f412b5f$export$2e2bcd8739ae039; });

var $c1Ell = parcelRequire("c1Ell");

const $7251f1874f412b5f$var$headerRule = {
    fontFamily: [
        "Gotham",
        "sans-serif"
    ].join(", "),
    lineHeight: "1.2em",
    letterSpacing: "0.025rem"
};
const $7251f1874f412b5f$var$lightTheme = (0, $c1Ell.default)({
    typography: {
        fontFamily: "'Fira Sans', sans-serif",
        button: {
            fontFamily: "Gotham, sans-serif",
            letterSpacing: "0.025rem"
        },
        h1: {
            ...$7251f1874f412b5f$var$headerRule,
            textTransform: "uppercase",
            fontSize: "3rem"
        },
        h2: {
            ...$7251f1874f412b5f$var$headerRule,
            textTransform: "uppercase",
            fontSize: "2rem",
            fontWeight: "bold"
        },
        h3: {
            ...$7251f1874f412b5f$var$headerRule,
            textTransform: "uppercase",
            fontSize: "1.25rem"
        },
        h4: {
            ...$7251f1874f412b5f$var$headerRule,
            textTransform: "uppercase",
            fontSize: "1rem"
        },
        h5: {
            ...$7251f1874f412b5f$var$headerRule,
            textTransform: "uppercase",
            fontSize: "0.75rem"
        }
    },
    palette: {
        background: {
            default: "rgb(234, 236, 242)"
        },
        primary: {
            main: "rgb(21, 39, 86)",
            dark: "rgb(11, 23, 48)",
            light: "rgba(9, 110, 229, 1)"
        },
        secondary: {
            main: "rgb(60, 233, 124)"
        },
        info: {
            main: "rgb(9, 110, 229)"
        }
    },
    components: {
        MuiDialogContentText: {
            defaultProps: {
                align: "center",
                variant: "body2"
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                dividers: {
                    marginLeft: "16px",
                    marginRight: "16px",
                    paddingLeft: 0,
                    paddingRight: 0,
                    borderBottom: "none"
                }
            }
        },
        MuiCssBaseline: {
            styleOverrides: {
                html: {
                    "@fontFace": [
                        "'Fira Sans'",
                        "'Gotham'"
                    ]
                }
            }
        }
    }
});
const $7251f1874f412b5f$export$3e936a8db52a10a0 = (0, $c1Ell.default)({
    ...$7251f1874f412b5f$var$lightTheme,
    palette: {
        background: {
            default: "rgb(11, 23, 48)",
            paper: "rgb(28, 34, 45)"
        },
        primary: {
            main: "rgb(21, 39, 86)",
            dark: "rgb(11, 23, 48)",
            light: "rgba(9, 110, 229, 1)"
        },
        secondary: {
            main: "rgb(60, 233, 124)"
        },
        info: {
            main: "rgb(9, 110, 229)"
        },
        text: {
            primary: "rgb(255, 255, 255)"
        },
        mode: "dark"
    },
    components: {
        ...$7251f1874f412b5f$var$lightTheme.components,
        MuiButton: {
            styleOverrides: {
                root: ()=>({
                        color: "rgb(255, 255, 255)"
                    })
            }
        }
    }
});
var $7251f1874f412b5f$export$2e2bcd8739ae039 = $7251f1874f412b5f$var$lightTheme;

});

parcelRegister("cOVXE", function(module, exports) {

$parcel$export(module.exports, "ToastProvider", function () { return $da2138e001b1d335$export$f5d03d415824e0e; });
$parcel$export(module.exports, "useToast", function () { return $da2138e001b1d335$export$a407b657d3044108; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $506bB = parcelRequire("506bB");

var $euyyI = parcelRequire("euyyI");

var $1lMle = parcelRequire("1lMle");
const $da2138e001b1d335$var$ToastContext = /*#__PURE__*/ $bh6RR.createContext(undefined);
function $da2138e001b1d335$export$f5d03d415824e0e({ children: children }) {
    const [open, setOpen] = $bh6RR.useState(false);
    const [message, setMessage] = $bh6RR.useState("");
    const [severity, setSeverity] = $bh6RR.useState("info");
    const showToast = (msg, sev)=>{
        setMessage(msg);
        setSeverity(sev);
        setOpen(true);
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    const value = $bh6RR.useMemo(()=>({
            showSuccess: (msg)=>showToast(msg, "success"),
            showError: (msg)=>showToast(msg, "error"),
            showInfo: (msg)=>showToast(msg, "info"),
            showWarning: (msg)=>showToast(msg, "warning")
        }), []);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($da2138e001b1d335$var$ToastContext.Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $euyyI.default), {
                open: open,
                autoHideDuration: 6000,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $506bB.default), {
                    onClose: handleClose,
                    severity: severity,
                    sx: {
                        width: "100%"
                    },
                    children: message
                })
            })
        ]
    });
}
function $da2138e001b1d335$export$a407b657d3044108() {
    const context = $bh6RR.useContext($da2138e001b1d335$var$ToastContext);
    // Memoize fallback functions to prevent recreation on every render
    const fallbackFunctions = $bh6RR.useMemo(()=>({
            showSuccess: (message)=>(0, $1lMle.default).info(`Success: ${message}`),
            showError: (message)=>(0, $1lMle.default).error(`Error: ${message}`),
            showInfo: (message)=>(0, $1lMle.default).info(`Info: ${message}`),
            showWarning: (message)=>(0, $1lMle.default).warn(`Warning: ${message}`)
        }), []);
    if (!context) // Return stable fallback functions if context is not available
    return fallbackFunctions;
    return context;
}

});
parcelRegister("506bB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a41c04501aa89f5$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $dFvJW = parcelRequire("dFvJW");

var $krx4P = parcelRequire("krx4P");

var $4B5Or = parcelRequire("4B5Or");

var $4Athc = parcelRequire("4Athc");

var $4blbb = parcelRequire("4blbb");

var $4rInl = parcelRequire("4rInl");

var $fl3HQ = parcelRequire("fl3HQ");

var $fNrfk = parcelRequire("fNrfk");

var $cXU6H = parcelRequire("cXU6H");

var $jJCON = parcelRequire("jJCON");

var $54kMp = parcelRequire("54kMp");

var $ih19M = parcelRequire("ih19M");
'use client';
const $3a41c04501aa89f5$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $krx4P.default)(color || severity)}`,
            `${variant}${(0, $krx4P.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $4blbb.getAlertUtilityClass), classes);
};
const $3a41c04501aa89f5$var$AlertRoot = (0, $l0oRz.default)((0, $4Athc.default), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $krx4P.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? theme.darken : theme.lighten;
    const getBackgroundColor = theme.palette.mode === 'light' ? theme.lighten : theme.darken;
    return {
        ...theme.typography.body2,
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $4blbb.default).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $4blbb.default).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: {
                        fontWeight: theme.typography.fontWeightMedium,
                        ...theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}FilledColor`],
                            backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                        } : {
                            backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                            color: theme.palette.getContrastText(theme.palette[color].main)
                        }
                    }
                }))
        ]
    };
}));
const $3a41c04501aa89f5$var$AlertIcon = (0, $l0oRz.default)('div', {
    name: 'MuiAlert',
    slot: 'Icon'
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $3a41c04501aa89f5$var$AlertMessage = (0, $l0oRz.default)('div', {
    name: 'MuiAlert',
    slot: 'Message'
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $3a41c04501aa89f5$var$AlertAction = (0, $l0oRz.default)('div', {
    name: 'MuiAlert',
    slot: 'Action'
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $3a41c04501aa89f5$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fl3HQ.default), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fNrfk.default), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cXU6H.default), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $ih19M.jsx)((0, $jJCON.default), {
        fontSize: "inherit"
    })
};
const $3a41c04501aa89f5$var$Alert = /*#__PURE__*/ $bh6RR.forwardRef(function Alert(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $3a41c04501aa89f5$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    };
    const classes = $3a41c04501aa89f5$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $dFvJW.default)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $aPsoC.default)(classes.root, className),
        elementType: $3a41c04501aa89f5$var$AlertRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            role: role,
            elevation: 0
        }
    });
    const [IconSlot, iconSlotProps] = (0, $dFvJW.default)('icon', {
        className: classes.icon,
        elementType: $3a41c04501aa89f5$var$AlertIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MessageSlot, messageSlotProps] = (0, $dFvJW.default)('message', {
        className: classes.message,
        elementType: $3a41c04501aa89f5$var$AlertMessage,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $dFvJW.default)('action', {
        className: classes.action,
        elementType: $3a41c04501aa89f5$var$AlertAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseButtonSlot, closeButtonProps] = (0, $dFvJW.default)('closeButton', {
        elementType: (0, $4rInl.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $dFvJW.default)('closeIcon', {
        elementType: (0, $54kMp.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            icon !== false ? /*#__PURE__*/ (0, $ih19M.jsx)(IconSlot, {
                ...iconSlotProps,
                children: icon || iconMapping[severity] || $3a41c04501aa89f5$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $ih19M.jsx)(MessageSlot, {
                ...messageSlotProps,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $ih19M.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $ih19M.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: /*#__PURE__*/ (0, $ih19M.jsx)(CloseButtonSlot, {
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose,
                    ...closeButtonProps,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)(CloseIconSlot, {
                        fontSize: "small",
                        ...closeIconProps
                    })
                })
            }) : null
        ]
    });
});
var $3a41c04501aa89f5$export$2e2bcd8739ae039 = $3a41c04501aa89f5$var$Alert;

});
parcelRegister("96ZcP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a2426d16525cd13$export$2e2bcd8739ae039; });
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $6a2426d16525cd13$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});

parcelRegister("gfPc7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd55c232cdfb4412$export$2e2bcd8739ae039; });

var $fmzUP = parcelRequire("fmzUP");
const $bd55c232cdfb4412$var$memoTheme = (0, $fmzUP.default);
var $bd55c232cdfb4412$export$2e2bcd8739ae039 = $bd55c232cdfb4412$var$memoTheme;

});
parcelRegister("fmzUP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2f4c52e1e01d843$export$2e2bcd8739ae039; });

var $hZ0bi = parcelRequire("hZ0bi");
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $b2f4c52e1e01d843$var$arg = {
    theme: undefined
};
function $b2f4c52e1e01d843$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $b2f4c52e1e01d843$var$arg.theme = props.theme;
            value = (0, $hZ0bi.default)(styleFn($b2f4c52e1e01d843$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});


parcelRegister("dFvJW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f37b99abbdfd720$export$2e2bcd8739ae039; });

var $6RXey = parcelRequire("6RXey");

var $kx46n = parcelRequire("kx46n");

var $78QIe = parcelRequire("78QIe");

var $aF9o1 = parcelRequire("aF9o1");
'use client';
function $9f37b99abbdfd720$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $78QIe.default)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $aF9o1.default)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $6RXey.default)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $kx46n.default)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}

});
parcelRegister("6RXey", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5005a3e0d996687a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
function $5005a3e0d996687a$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $bh6RR.useRef(undefined);
    const refEffect = $bh6RR.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $bh6RR.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});

parcelRegister("kx46n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef2a1243842f5527$export$2e2bcd8739ae039; });

var $g0K0l = parcelRequire("g0K0l");
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $ef2a1243842f5527$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $g0K0l.default)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $ef2a1243842f5527$export$2e2bcd8739ae039 = $ef2a1243842f5527$var$appendOwnerState;

});
parcelRegister("g0K0l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba8054f7a87c1a37$export$2e2bcd8739ae039; });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $ba8054f7a87c1a37$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $ba8054f7a87c1a37$export$2e2bcd8739ae039 = $ba8054f7a87c1a37$var$isHostComponent;

});


parcelRegister("78QIe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53322b52ecf66e2d$export$2e2bcd8739ae039; });
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $53322b52ecf66e2d$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $53322b52ecf66e2d$export$2e2bcd8739ae039 = $53322b52ecf66e2d$var$resolveComponentProps;

});

parcelRegister("aF9o1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c3503ac85e2d115$export$2e2bcd8739ae039; });

var $aPsoC = parcelRequire("aPsoC");

var $jmq8q = parcelRequire("jmq8q");

var $1WH0U = parcelRequire("1WH0U");
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $7c3503ac85e2d115$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $aPsoC.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $jmq8q.default)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $1WH0U.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $1WH0U.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $aPsoC.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $7c3503ac85e2d115$export$2e2bcd8739ae039 = $7c3503ac85e2d115$var$mergeSlotProps;

});
parcelRegister("jmq8q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e18458377e3824f4$export$2e2bcd8739ae039; });
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $e18458377e3824f4$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $e18458377e3824f4$export$2e2bcd8739ae039 = $e18458377e3824f4$var$extractEventHandlers;

});

parcelRegister("1WH0U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16ac92dbf7799ab8$export$2e2bcd8739ae039; });
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $16ac92dbf7799ab8$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $16ac92dbf7799ab8$export$2e2bcd8739ae039 = $16ac92dbf7799ab8$var$omitEventHandlers;

});



parcelRegister("krx4P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee1ffca73a8a7552$export$2e2bcd8739ae039; });

var $5pCmM = parcelRequire("5pCmM");
var $ee1ffca73a8a7552$export$2e2bcd8739ae039 = (0, $5pCmM.default);

});

parcelRegister("4B5Or", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $358f205f5469d5cd$export$2e2bcd8739ae039; });
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $358f205f5469d5cd$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $358f205f5469d5cd$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$358f205f5469d5cd$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $358f205f5469d5cd$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $358f205f5469d5cd$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}

});

parcelRegister("4Athc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35713be4aa5e120f$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");



var $96ZcP = parcelRequire("96ZcP");

var $7ITGE = parcelRequire("7ITGE");

var $l0oRz = parcelRequire("l0oRz");
var $aOb5j = parcelRequire("aOb5j");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $6mpQq = parcelRequire("6mpQq");

var $dasMl = parcelRequire("dasMl");

var $ih19M = parcelRequire("ih19M");
'use client';
const $35713be4aa5e120f$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $dasMl.getPaperUtilityClass), classes);
};
const $35713be4aa5e120f$var$PaperRoot = (0, $l0oRz.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $35713be4aa5e120f$var$Paper = /*#__PURE__*/ $bh6RR.forwardRef(function Paper(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $aOb5j.default)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $35713be4aa5e120f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($35713be4aa5e120f$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $7ITGE.alpha)('#fff', (0, $6mpQq.default)(elevation))}, ${(0, $7ITGE.alpha)('#fff', (0, $6mpQq.default)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $35713be4aa5e120f$export$2e2bcd8739ae039 = $35713be4aa5e120f$var$Paper;

});
parcelRegister("dasMl", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", function () { return $99628866b8fe6b8b$export$29cdb466b9b6f20b; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $99628866b8fe6b8b$export$29cdb466b9b6f20b(slot) {
    return (0, $dmzXD.default)('MuiPaper', slot);
}
const $99628866b8fe6b8b$var$paperClasses = (0, $fYlYP.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $99628866b8fe6b8b$export$2e2bcd8739ae039 = $99628866b8fe6b8b$var$paperClasses;

});
parcelRegister("fYlYP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba0d826601bdb89a$export$2e2bcd8739ae039; });

var $dmzXD = parcelRequire("dmzXD");
function $ba0d826601bdb89a$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $dmzXD.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("dmzXD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ba9398501f2167d$export$2e2bcd8739ae039; });

var $7tI36 = parcelRequire("7tI36");
const $9ba9398501f2167d$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $9ba9398501f2167d$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $9ba9398501f2167d$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $7tI36.default).generate(componentName)}-${slot}`;
}
function $9ba9398501f2167d$export$34c0130b1f3e8ae3(slot) {
    return $9ba9398501f2167d$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("7tI36", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $571d691533056500$export$2e2bcd8739ae039; });
const $571d691533056500$var$defaultGenerator = (componentName)=>componentName;
const $571d691533056500$var$createClassNameGenerator = ()=>{
    let generate = $571d691533056500$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $571d691533056500$var$defaultGenerator;
        }
    };
};
const $571d691533056500$var$ClassNameGenerator = $571d691533056500$var$createClassNameGenerator();
var $571d691533056500$export$2e2bcd8739ae039 = $571d691533056500$var$ClassNameGenerator;

});





parcelRegister("4blbb", function(module, exports) {

$parcel$export(module.exports, "getAlertUtilityClass", function () { return $30b89e4309fbdf85$export$69aecd24bc2cf7e3; });
$parcel$export(module.exports, "default", function () { return $30b89e4309fbdf85$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $30b89e4309fbdf85$export$69aecd24bc2cf7e3(slot) {
    return (0, $dmzXD.default)('MuiAlert', slot);
}
const $30b89e4309fbdf85$var$alertClasses = (0, $fYlYP.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $30b89e4309fbdf85$export$2e2bcd8739ae039 = $30b89e4309fbdf85$var$alertClasses;

});

parcelRegister("4rInl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33cc1b1e40fd2781$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $96ZcP = parcelRequire("96ZcP");

var $2STLv = parcelRequire("2STLv");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $4B5Or = parcelRequire("4B5Or");

var $OEXBZ = parcelRequire("OEXBZ");

var $fbTZq = parcelRequire("fbTZq");

var $5CVHy = parcelRequire("5CVHy");

var $krx4P = parcelRequire("krx4P");

var $dJC5g = parcelRequire("dJC5g");

var $ih19M = parcelRequire("ih19M");
'use client';
const $33cc1b1e40fd2781$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $krx4P.default)(color)}`,
            edge && `edge${(0, $krx4P.default)(edge)}`,
            `size${(0, $krx4P.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $dJC5g.getIconButtonUtilityClass), classes);
};
const $33cc1b1e40fd2781$var$IconButtonRoot = (0, $l0oRz.default)((0, $fbTZq.default), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $krx4P.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $krx4P.default)(ownerState.edge)}`],
            styles[`size${(0, $krx4P.default)(ownerState.size)}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $gfPc7.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $dJC5g.default).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $dJC5g.default).loading}`]: {
            color: 'transparent'
        }
    })));
const $33cc1b1e40fd2781$var$IconButtonLoadingIndicator = (0, $l0oRz.default)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $33cc1b1e40fd2781$var$IconButton = /*#__PURE__*/ $bh6RR.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $2STLv.default)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $33cc1b1e40fd2781$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($33cc1b1e40fd2781$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $aPsoC.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $ih19M.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)($33cc1b1e40fd2781$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $33cc1b1e40fd2781$export$2e2bcd8739ae039 = $33cc1b1e40fd2781$var$IconButton;

});
parcelRegister("2STLv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $219be1b6f20c8a3c$export$2e2bcd8739ae039; });

var $dDKx6 = parcelRequire("dDKx6");
'use client';
var $219be1b6f20c8a3c$export$2e2bcd8739ae039 = (0, $dDKx6.default);

});

parcelRegister("fbTZq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0f3507844b5bc72$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");



var $96ZcP = parcelRequire("96ZcP");

var $25zti = parcelRequire("25zti");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $dg012 = parcelRequire("dg012");

var $6gtJo = parcelRequire("6gtJo");

var $UQz7P = parcelRequire("UQz7P");

var $aDDsk = parcelRequire("aDDsk");

var $hfmX4 = parcelRequire("hfmX4");

var $ih19M = parcelRequire("ih19M");
'use client';
const $b0f3507844b5bc72$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $hfmX4.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $b0f3507844b5bc72$export$7ec0dcc5e3cdcd36 = (0, $l0oRz.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root'
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $hfmX4.default).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $b0f3507844b5bc72$var$ButtonBase = /*#__PURE__*/ $bh6RR.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $bh6RR.useRef(null);
    const ripple = (0, $UQz7P.default)();
    const handleRippleRef = (0, $dg012.default)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $bh6RR.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $bh6RR.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $bh6RR.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $b0f3507844b5bc72$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $b0f3507844b5bc72$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $b0f3507844b5bc72$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $b0f3507844b5bc72$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $b0f3507844b5bc72$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $b0f3507844b5bc72$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $b0f3507844b5bc72$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $b0f3507844b5bc72$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $b0f3507844b5bc72$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $25zti.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $6gtJo.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $25zti.default)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $6gtJo.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $6gtJo.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $dg012.default)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $b0f3507844b5bc72$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($b0f3507844b5bc72$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $aDDsk.default), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $b0f3507844b5bc72$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $6gtJo.default)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $b0f3507844b5bc72$export$2e2bcd8739ae039 = $b0f3507844b5bc72$var$ButtonBase;

});
parcelRegister("25zti", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1857904dca761a0b$export$2e2bcd8739ae039; });
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $1857904dca761a0b$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}

});

parcelRegister("dg012", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a6cc81dfed05911$export$2e2bcd8739ae039; });

var $6RXey = parcelRequire("6RXey");
'use client';
var $9a6cc81dfed05911$export$2e2bcd8739ae039 = (0, $6RXey.default);

});

parcelRegister("6gtJo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48fb4ca9f528994b$export$2e2bcd8739ae039; });

var $87bEd = parcelRequire("87bEd");
'use client';
var $48fb4ca9f528994b$export$2e2bcd8739ae039 = (0, $87bEd.default);

});
parcelRegister("87bEd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e880324b7e05325$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $kLukk = parcelRequire("kLukk");
'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $5e880324b7e05325$var$useEventCallback(fn) {
    const ref = $bh6RR.useRef(fn);
    (0, $kLukk.default)(()=>{
        ref.current = fn;
    });
    return $bh6RR.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $5e880324b7e05325$export$2e2bcd8739ae039 = $5e880324b7e05325$var$useEventCallback;

});


parcelRegister("UQz7P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0aae017f6bf5e093$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $edp8o = parcelRequire("edp8o");
'use client';
class $0aae017f6bf5e093$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $0aae017f6bf5e093$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $edp8o.default)($0aae017f6bf5e093$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $bh6RR.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $bh6RR.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $0aae017f6bf5e093$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $0aae017f6bf5e093$export$2e2bcd8739ae039() {
    return $0aae017f6bf5e093$export$f5de0641c7db4154.use();
}
function $0aae017f6bf5e093$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}

});
parcelRegister("edp8o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a595c6c315f57376$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
const $a595c6c315f57376$var$UNINITIALIZED = {};
function $a595c6c315f57376$export$2e2bcd8739ae039(init, initArg) {
    const ref = $bh6RR.useRef($a595c6c315f57376$var$UNINITIALIZED);
    if (ref.current === $a595c6c315f57376$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});


parcelRegister("aDDsk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bec2705f933aa3b$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $bm1aQ = parcelRequire("bm1aQ");

var $aPsoC = parcelRequire("aPsoC");

var $c3mIq = parcelRequire("c3mIq");

var $fPZvG = parcelRequire("fPZvG");
var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $lrGKl = parcelRequire("lrGKl");

var $8o18Q = parcelRequire("8o18Q");

var $ih19M = parcelRequire("ih19M");
'use client';
const $7bec2705f933aa3b$var$DURATION = 550;
const $7bec2705f933aa3b$export$95d0c9356b2231a3 = 80;
const $7bec2705f933aa3b$var$enterKeyframe = (0, $fPZvG.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $7bec2705f933aa3b$var$exitKeyframe = (0, $fPZvG.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $7bec2705f933aa3b$var$pulsateKeyframe = (0, $fPZvG.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $7bec2705f933aa3b$export$f6b7418508c72c25 = (0, $l0oRz.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $7bec2705f933aa3b$export$676cfe7b12693c4b = (0, $l0oRz.default)((0, $lrGKl.default), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $8o18Q.default).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$7bec2705f933aa3b$var$enterKeyframe};
    animation-duration: ${$7bec2705f933aa3b$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $8o18Q.default).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $8o18Q.default).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $8o18Q.default).childLeaving} {
    opacity: 0;
    animation-name: ${$7bec2705f933aa3b$var$exitKeyframe};
    animation-duration: ${$7bec2705f933aa3b$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $8o18Q.default).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$7bec2705f933aa3b$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $7bec2705f933aa3b$var$TouchRipple = /*#__PURE__*/ $bh6RR.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $bh6RR.useState([]);
    const nextKey = $bh6RR.useRef(0);
    const rippleCallback = $bh6RR.useRef(null);
    $bh6RR.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $bh6RR.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $c3mIq.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $bh6RR.useRef(null);
    const container = $bh6RR.useRef(null);
    const startCommit = $bh6RR.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ih19M.jsx)($7bec2705f933aa3b$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $aPsoC.default)(classes.ripple, (0, $8o18Q.default).ripple),
                        rippleVisible: (0, $aPsoC.default)(classes.rippleVisible, (0, $8o18Q.default).rippleVisible),
                        ripplePulsate: (0, $aPsoC.default)(classes.ripplePulsate, (0, $8o18Q.default).ripplePulsate),
                        child: (0, $aPsoC.default)(classes.child, (0, $8o18Q.default).child),
                        childLeaving: (0, $aPsoC.default)(classes.childLeaving, (0, $8o18Q.default).childLeaving),
                        childPulsate: (0, $aPsoC.default)(classes.childPulsate, (0, $8o18Q.default).childPulsate)
                    },
                    timeout: $7bec2705f933aa3b$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $bh6RR.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($7bec2705f933aa3b$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $bh6RR.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $bh6RR.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $bh6RR.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($7bec2705f933aa3b$export$f6b7418508c72c25, {
        className: (0, $aPsoC.default)((0, $8o18Q.default).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bm1aQ.default), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $7bec2705f933aa3b$export$2e2bcd8739ae039 = $7bec2705f933aa3b$var$TouchRipple;

});
parcelRegister("bm1aQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8442a8eba1100460$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $hqR4t = parcelRequire("hqR4t");

var $gMqD6 = parcelRequire("gMqD6");


var $bh6RR = parcelRequire("bh6RR");

var $70uTP = parcelRequire("70uTP");

var $ePspO = parcelRequire("ePspO");
var $8442a8eba1100460$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $8442a8eba1100460$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $8442a8eba1100460$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $gMqD6.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $hqR4t.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $ePspO.getInitialChildMapping)(nextProps, handleExited) : (0, $ePspO.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $ePspO.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $4WYaH.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $hCIyK.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $8442a8eba1100460$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $70uTP.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $70uTP.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$8442a8eba1100460$var$TransitionGroup.propTypes = {};
$8442a8eba1100460$var$TransitionGroup.defaultProps = $8442a8eba1100460$var$defaultProps;
var $8442a8eba1100460$export$2e2bcd8739ae039 = $8442a8eba1100460$var$TransitionGroup;

});
parcelRegister("hCIyK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd488cd9c287f883$export$2e2bcd8739ae039; });
function $cd488cd9c287f883$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("hqR4t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb0e0834598ff6d6$export$2e2bcd8739ae039; });
function $cb0e0834598ff6d6$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("gMqD6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c375c92967c25393$export$2e2bcd8739ae039; });

var $hloi6 = parcelRequire("hloi6");
function $c375c92967c25393$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $hloi6.default)(t, o);
}

});
parcelRegister("hloi6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca073d81f2a471af$export$2e2bcd8739ae039; });
function $ca073d81f2a471af$export$2e2bcd8739ae039(t, e) {
    return $ca073d81f2a471af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ca073d81f2a471af$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("70uTP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51a0807799a59896$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
var $51a0807799a59896$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);

});

parcelRegister("ePspO", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $acbbdecafa0b932b$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $acbbdecafa0b932b$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $acbbdecafa0b932b$export$36fd1af28d383ec0; });

var $bh6RR = parcelRequire("bh6RR");
function $acbbdecafa0b932b$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $bh6RR.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $bh6RR.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $acbbdecafa0b932b$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $acbbdecafa0b932b$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $acbbdecafa0b932b$export$fa71e2345c31d7a2(props, onExited) {
    return $acbbdecafa0b932b$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $bh6RR.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $acbbdecafa0b932b$var$getProp(child, 'appear', props),
            enter: $acbbdecafa0b932b$var$getProp(child, 'enter', props),
            exit: $acbbdecafa0b932b$var$getProp(child, 'exit', props)
        });
    });
}
function $acbbdecafa0b932b$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $acbbdecafa0b932b$export$bbc8a025727ea824(nextProps.children);
    var children = $acbbdecafa0b932b$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $bh6RR.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $bh6RR.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $bh6RR.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $acbbdecafa0b932b$var$getProp(child, 'exit', nextProps),
            enter: $acbbdecafa0b932b$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $bh6RR.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $bh6RR.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $bh6RR.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $acbbdecafa0b932b$var$getProp(child, 'exit', nextProps),
            enter: $acbbdecafa0b932b$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("c3mIq", function(module, exports) {

$parcel$export(module.exports, "Timeout", function () { return $8c6762aec7cc866c$export$786b4da70f00938b; });
$parcel$export(module.exports, "default", function () { return $8c6762aec7cc866c$export$2e2bcd8739ae039; });

var $edp8o = parcelRequire("edp8o");

var $jUDOC = parcelRequire("jUDOC");
'use client';
class $8c6762aec7cc866c$export$786b4da70f00938b {
    static create() {
        return new $8c6762aec7cc866c$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $8c6762aec7cc866c$export$2e2bcd8739ae039() {
    const timeout = (0, $edp8o.default)($8c6762aec7cc866c$export$786b4da70f00938b.create).current;
    (0, $jUDOC.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("jUDOC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7f221d2eaddb322$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
const $e7f221d2eaddb322$var$EMPTY = [];
function $e7f221d2eaddb322$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $bh6RR.useEffect(fn, $e7f221d2eaddb322$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});


parcelRegister("lrGKl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9cd472610345472$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $ih19M = parcelRequire("ih19M");
'use client';
function $f9cd472610345472$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $bh6RR.useState(false);
    const rippleClassName = (0, $aPsoC.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $aPsoC.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $bh6RR.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
            className: childClassName
        })
    });
}
var $f9cd472610345472$export$2e2bcd8739ae039 = $f9cd472610345472$var$Ripple;

});

parcelRegister("8o18Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61b1735452939a1c$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $61b1735452939a1c$export$b464606f735ab902(slot) {
    return (0, $dmzXD.default)('MuiTouchRipple', slot);
}
const $61b1735452939a1c$var$touchRippleClasses = (0, $fYlYP.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $61b1735452939a1c$export$2e2bcd8739ae039 = $61b1735452939a1c$var$touchRippleClasses;

});


parcelRegister("hfmX4", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", function () { return $c8e5a41f28060a4a$export$fccb0498dcd99783; });
$parcel$export(module.exports, "default", function () { return $c8e5a41f28060a4a$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $c8e5a41f28060a4a$export$fccb0498dcd99783(slot) {
    return (0, $dmzXD.default)('MuiButtonBase', slot);
}
const $c8e5a41f28060a4a$var$buttonBaseClasses = (0, $fYlYP.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $c8e5a41f28060a4a$export$2e2bcd8739ae039 = $c8e5a41f28060a4a$var$buttonBaseClasses;

});


parcelRegister("5CVHy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $418d42b31fe206cc$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $96ZcP = parcelRequire("96ZcP");

var $fPZvG = parcelRequire("fPZvG");
var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $krx4P = parcelRequire("krx4P");

var $4B5Or = parcelRequire("4B5Or");

var $l6hGt = parcelRequire("l6hGt");

var $ih19M = parcelRequire("ih19M");
'use client';
const $418d42b31fe206cc$var$SIZE = 44;
const $418d42b31fe206cc$var$circularRotateKeyframe = (0, $fPZvG.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $418d42b31fe206cc$var$circularDashKeyframe = (0, $fPZvG.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $418d42b31fe206cc$var$rotateAnimation = typeof $418d42b31fe206cc$var$circularRotateKeyframe !== 'string' ? (0, $fPZvG.css)`
        animation: ${$418d42b31fe206cc$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $418d42b31fe206cc$var$dashAnimation = typeof $418d42b31fe206cc$var$circularDashKeyframe !== 'string' ? (0, $fPZvG.css)`
        animation: ${$418d42b31fe206cc$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $418d42b31fe206cc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $krx4P.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        track: [
            'track'
        ],
        circle: [
            'circle',
            `circle${(0, $krx4P.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $l6hGt.getCircularProgressUtilityClass), classes);
};
const $418d42b31fe206cc$var$CircularProgressRoot = (0, $l0oRz.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $krx4P.default)(ownerState.color)}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $418d42b31fe206cc$var$rotateAnimation || {
                    animation: `${$418d42b31fe206cc$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $418d42b31fe206cc$var$CircularProgressSVG = (0, $l0oRz.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg'
})({
    display: 'block' // Keeps the progress centered
});
const $418d42b31fe206cc$var$CircularProgressCircle = (0, $l0oRz.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $krx4P.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $418d42b31fe206cc$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$418d42b31fe206cc$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
const $418d42b31fe206cc$var$CircularProgressTrack = (0, $l0oRz.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Track'
})((0, $gfPc7.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        opacity: (theme.vars || theme).palette.action.activatedOpacity
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $418d42b31fe206cc$var$CircularProgress = /*#__PURE__*/ $bh6RR.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, enableTrackSlot: enableTrackSlot = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant,
        enableTrackSlot: enableTrackSlot
    };
    const classes = $418d42b31fe206cc$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($418d42b31fe206cc$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $ih19M.jsx)($418d42b31fe206cc$var$CircularProgressRoot, {
        className: (0, $aPsoC.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)($418d42b31fe206cc$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$418d42b31fe206cc$var$SIZE / 2} ${$418d42b31fe206cc$var$SIZE / 2} ${$418d42b31fe206cc$var$SIZE} ${$418d42b31fe206cc$var$SIZE}`,
            children: [
                enableTrackSlot ? /*#__PURE__*/ (0, $ih19M.jsx)($418d42b31fe206cc$var$CircularProgressTrack, {
                    className: classes.track,
                    ownerState: ownerState,
                    cx: $418d42b31fe206cc$var$SIZE,
                    cy: $418d42b31fe206cc$var$SIZE,
                    r: ($418d42b31fe206cc$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness,
                    "aria-hidden": "true"
                }) : null,
                /*#__PURE__*/ (0, $ih19M.jsx)($418d42b31fe206cc$var$CircularProgressCircle, {
                    className: classes.circle,
                    style: circleStyle,
                    ownerState: ownerState,
                    cx: $418d42b31fe206cc$var$SIZE,
                    cy: $418d42b31fe206cc$var$SIZE,
                    r: ($418d42b31fe206cc$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness
                })
            ]
        })
    });
});
var $418d42b31fe206cc$export$2e2bcd8739ae039 = $418d42b31fe206cc$var$CircularProgress;

});
parcelRegister("l6hGt", function(module, exports) {

$parcel$export(module.exports, "getCircularProgressUtilityClass", function () { return $f5c7e0375f6e8164$export$29cad1383b3f235d; });
$parcel$export(module.exports, "default", function () { return $f5c7e0375f6e8164$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $f5c7e0375f6e8164$export$29cad1383b3f235d(slot) {
    return (0, $dmzXD.default)('MuiCircularProgress', slot);
}
const $f5c7e0375f6e8164$var$circularProgressClasses = (0, $fYlYP.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'track',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $f5c7e0375f6e8164$export$2e2bcd8739ae039 = $f5c7e0375f6e8164$var$circularProgressClasses;

});


parcelRegister("dJC5g", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", function () { return $9ffd05059ed49025$export$5e8702d71474f093; });
$parcel$export(module.exports, "default", function () { return $9ffd05059ed49025$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $9ffd05059ed49025$export$5e8702d71474f093(slot) {
    return (0, $dmzXD.default)('MuiIconButton', slot);
}
const $9ffd05059ed49025$var$iconButtonClasses = (0, $fYlYP.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $9ffd05059ed49025$export$2e2bcd8739ae039 = $9ffd05059ed49025$var$iconButtonClasses;

});


parcelRegister("fl3HQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2abb12bc79ee534$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $b2abb12bc79ee534$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

});
parcelRegister("fWXJ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9ca9a433dba8de8$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $iYrdy = parcelRequire("iYrdy");

var $ih19M = parcelRequire("ih19M");
'use client';
function $b9ca9a433dba8de8$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $iYrdy.default), {
            "data-testid": undefined,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $iYrdy.default).muiName;
    return /*#__PURE__*/ $bh6RR.memo(/*#__PURE__*/ $bh6RR.forwardRef(Component));
}

});
parcelRegister("iYrdy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd02f16dba352f4c$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $krx4P = parcelRequire("krx4P");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $2gjNM = parcelRequire("2gjNM");

var $ih19M = parcelRequire("ih19M");
'use client';
const $dd02f16dba352f4c$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $krx4P.default)(color)}`,
            `fontSize${(0, $krx4P.default)(fontSize)}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $2gjNM.getSvgIconUtilityClass), classes);
};
const $dd02f16dba352f4c$var$SvgIconRoot = (0, $l0oRz.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $krx4P.default)(ownerState.color)}`],
            styles[`fontSize${(0, $krx4P.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $dd02f16dba352f4c$var$SvgIcon = /*#__PURE__*/ $bh6RR.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $bh6RR.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $dd02f16dba352f4c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($dd02f16dba352f4c$var$SvgIconRoot, {
        as: component,
        className: (0, $aPsoC.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ih19M.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$dd02f16dba352f4c$var$SvgIcon.muiName = 'SvgIcon';
var $dd02f16dba352f4c$export$2e2bcd8739ae039 = $dd02f16dba352f4c$var$SvgIcon;

});
parcelRegister("2gjNM", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $1a5c6fa0f07a3d49$export$c7c50641356bdfa5; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $1a5c6fa0f07a3d49$export$c7c50641356bdfa5(slot) {
    return (0, $dmzXD.default)('MuiSvgIcon', slot);
}
const $1a5c6fa0f07a3d49$var$svgIconClasses = (0, $fYlYP.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $1a5c6fa0f07a3d49$export$2e2bcd8739ae039 = $1a5c6fa0f07a3d49$var$svgIconClasses;

});




parcelRegister("fNrfk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b80091247c749afc$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $b80091247c749afc$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

});

parcelRegister("cXU6H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9706846767d54c35$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $9706846767d54c35$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

});

parcelRegister("jJCON", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5e054c8fabdcb28$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $e5e054c8fabdcb28$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

});

parcelRegister("54kMp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b0d71e49818da36$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $3b0d71e49818da36$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});


parcelRegister("euyyI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8ceacb76e7cc439$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $96ZcP = parcelRequire("96ZcP");

var $lPSsi = parcelRequire("lPSsi");

var $fz29f = parcelRequire("fz29f");

var $l0oRz = parcelRequire("l0oRz");
var $aOb5j = parcelRequire("aOb5j");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $krx4P = parcelRequire("krx4P");

var $3BTDi = parcelRequire("3BTDi");

var $blj8y = parcelRequire("blj8y");

var $e5BfU = parcelRequire("e5BfU");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
const $a8ceacb76e7cc439$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $krx4P.default)(anchorOrigin.vertical)}${(0, $krx4P.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $e5BfU.getSnackbarUtilityClass), classes);
};
const $a8ceacb76e7cc439$var$SnackbarRoot = (0, $l0oRz.default)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $krx4P.default)(ownerState.anchorOrigin.vertical)}${(0, $krx4P.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top',
                style: {
                    top: 8,
                    [theme.breakpoints.up('sm')]: {
                        top: 24
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical !== 'top',
                style: {
                    bottom: 8,
                    [theme.breakpoints.up('sm')]: {
                        bottom: 24
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'left',
                style: {
                    justifyContent: 'flex-start',
                    [theme.breakpoints.up('sm')]: {
                        left: 24,
                        right: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'right',
                style: {
                    justifyContent: 'flex-end',
                    [theme.breakpoints.up('sm')]: {
                        right: 24,
                        left: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'center',
                style: {
                    [theme.breakpoints.up('sm')]: {
                        left: '50%',
                        right: 'auto',
                        transform: 'translateX(-50%)'
                    }
                }
            }
        ]
    })));
const $a8ceacb76e7cc439$var$Snackbar = /*#__PURE__*/ $bh6RR.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $aOb5j.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerPropsProp, ContentProps: ContentPropsProp, disableWindowBlurListener: disableWindowBlurListener = false, message: message, onBlur: onBlur, onClose: onClose, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, open: open, resumeHideDuration: resumeHideDuration, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited, ...TransitionPropsProp } = {}, ...other } = props;
    const ownerState = {
        ...props,
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponentProp,
        transitionDuration: transitionDuration
    };
    const classes = $a8ceacb76e7cc439$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $lPSsi.default)({
        ...ownerState
    });
    const [exited, setExited] = $bh6RR.useState(true);
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponentProp,
            ...slots
        },
        slotProps: {
            content: ContentPropsProp,
            clickAwayListener: ClickAwayListenerPropsProp,
            transition: TransitionPropsProp,
            ...slotProps
        }
    };
    const [Root, rootProps] = (0, $dFvJW.default)('root', {
        ref: ref,
        className: [
            classes.root,
            className
        ],
        elementType: $a8ceacb76e7cc439$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState
    });
    const [ClickAwaySlot, { ownerState: clickAwayOwnerStateProp, ...clickAwayListenerProps }] = (0, $dFvJW.default)('clickAwayListener', {
        elementType: (0, $fz29f.ClickAwayListener),
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onClickAway: (...params)=>{
                    const event = params[0];
                    handlers.onClickAway?.(...params);
                    if (event?.defaultMuiPrevented) return;
                    onClickAway(...params);
                }
            }),
        ownerState: ownerState
    });
    const [ContentSlot, contentSlotProps] = (0, $dFvJW.default)('content', {
        elementType: (0, $blj8y.default),
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            message: message,
            action: action
        },
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $dFvJW.default)('transition', {
        elementType: (0, $3BTDi.default),
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onEnter: (...params)=>{
                    handlers.onEnter?.(...params);
                    handleEnter(...params);
                },
                onExited: (...params)=>{
                    handlers.onExited?.(...params);
                    handleExited(...params);
                }
            }),
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            direction: vertical === 'top' ? 'down' : 'up'
        },
        ownerState: ownerState
    });
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $ih19M.jsx)(ClickAwaySlot, {
        ...clickAwayListenerProps,
        ...slots.clickAwayListener && {
            ownerState: clickAwayOwnerStateProp
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)(Root, {
            ...rootProps,
            children: /*#__PURE__*/ (0, $ih19M.jsx)(TransitionSlot, {
                ...transitionProps,
                children: children || /*#__PURE__*/ (0, $ih19M.jsx)(ContentSlot, {
                    ...contentSlotProps
                })
            })
        })
    });
});
var $a8ceacb76e7cc439$export$2e2bcd8739ae039 = $a8ceacb76e7cc439$var$Snackbar;

});
parcelRegister("lPSsi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe589a1a0aded09a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $87bEd = parcelRequire("87bEd");

var $c3mIq = parcelRequire("c3mIq");

var $jmq8q = parcelRequire("jmq8q");
'use client';
function $fe589a1a0aded09a$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $c3mIq.default)();
    $bh6RR.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) {
                if (nativeEvent.key === 'Escape') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose?.(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $87bEd.default)((event, reason)=>{
        onClose?.(event, reason);
    });
    const setAutoHideTimer = (0, $87bEd.default)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, 'timeout');
        });
    });
    $bh6RR.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose?.(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $bh6RR.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback?.(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback?.(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback?.(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback?.(event);
            handleResume();
        };
    $bh6RR.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = {
            ...(0, $jmq8q.default)(parameters),
            ...(0, $jmq8q.default)(externalProps)
        };
        return {
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation',
            ...externalProps,
            ...externalEventHandlers,
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        };
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $fe589a1a0aded09a$export$2e2bcd8739ae039 = $fe589a1a0aded09a$var$useSnackbar;

});

parcelRegister("fz29f", function(module, exports) {

$parcel$export(module.exports, "ClickAwayListener", function () { return $b54bca811dd453fc$export$58385c17fee43f89; });

var $bh6RR = parcelRequire("bh6RR");


var $8HMMM = parcelRequire("8HMMM");

var $6RXey = parcelRequire("6RXey");

var $87bEd = parcelRequire("87bEd");



var $20D76 = parcelRequire("20D76");
'use client';
// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1
function $b54bca811dd453fc$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $b54bca811dd453fc$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $b54bca811dd453fc$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $bh6RR.useRef(false);
    const nodeRef = $bh6RR.useRef(null);
    const activatedRef = $bh6RR.useRef(false);
    const syntheticEventRef = $bh6RR.useRef(false);
    $bh6RR.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $6RXey.default)((0, $20D76.default)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $87bEd.default)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $8HMMM.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $b54bca811dd453fc$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().includes(nodeRef.current);
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $bh6RR.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $b54bca811dd453fc$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $8HMMM.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $bh6RR.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $b54bca811dd453fc$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $8HMMM.default)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $bh6RR.cloneElement(children, childrenProps);
}

});
parcelRegister("8HMMM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65682eb7ee0e459a$export$2e2bcd8739ae039; });
function $65682eb7ee0e459a$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("20D76", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1769ec00551295a6$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
function $1769ec00551295a6$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($bh6RR.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}

});


parcelRegister("3BTDi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a0ffb4a98fce46a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $c3mIq = parcelRequire("c3mIq");


var $20D76 = parcelRequire("20D76");

var $7ARPd = parcelRequire("7ARPd");

var $aOb5j = parcelRequire("aOb5j");

var $bi4C9 = parcelRequire("bi4C9");

var $dg012 = parcelRequire("dg012");

var $ih19M = parcelRequire("ih19M");
'use client';
function $2a0ffb4a98fce46a$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $2a0ffb4a98fce46a$var$styles = {
    entering: {
        opacity: 1,
        transform: $2a0ffb4a98fce46a$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $2a0ffb4a98fce46a$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $2a0ffb4a98fce46a$var$Grow = /*#__PURE__*/ $bh6RR.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $7ARPd.default), ...other } = props;
    const timer = (0, $c3mIq.default)();
    const autoTimeout = $bh6RR.useRef();
    const theme = (0, $aOb5j.default)();
    const nodeRef = $bh6RR.useRef(null);
    const handleRef = (0, $dg012.default)(nodeRef, (0, $20D76.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $bi4C9.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $bi4C9.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $2a0ffb4a98fce46a$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $bi4C9.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $2a0ffb4a98fce46a$var$isWebKit154 ? duration : duration * 0.666,
                delay: $2a0ffb4a98fce46a$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $2a0ffb4a98fce46a$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $bh6RR.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $2a0ffb4a98fce46a$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$2a0ffb4a98fce46a$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($2a0ffb4a98fce46a$var$Grow) $2a0ffb4a98fce46a$var$Grow.muiSupportAuto = true;
var $2a0ffb4a98fce46a$export$2e2bcd8739ae039 = $2a0ffb4a98fce46a$var$Grow;

});
parcelRegister("7ARPd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5875a5c0de10c551$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $gMqD6 = parcelRequire("gMqD6");


var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $3SX21 = parcelRequire("3SX21");


var $70uTP = parcelRequire("70uTP");

var $klu5V = parcelRequire("klu5V");
var $5875a5c0de10c551$export$bb38bb9a1161268 = 'unmounted';
var $5875a5c0de10c551$export$84cbff306f539230 = 'exited';
var $5875a5c0de10c551$export$df38205c966be359 = 'entering';
var $5875a5c0de10c551$export$78e9e6e3e014d60a = 'entered';
var $5875a5c0de10c551$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $5875a5c0de10c551$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $gMqD6.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $5875a5c0de10c551$export$84cbff306f539230;
                _this.appearStatus = $5875a5c0de10c551$export$df38205c966be359;
            } else initialStatus = $5875a5c0de10c551$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $5875a5c0de10c551$export$bb38bb9a1161268;
        else initialStatus = $5875a5c0de10c551$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $5875a5c0de10c551$export$bb38bb9a1161268) return {
            status: $5875a5c0de10c551$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $5875a5c0de10c551$export$df38205c966be359 && status !== $5875a5c0de10c551$export$78e9e6e3e014d60a) nextStatus = $5875a5c0de10c551$export$df38205c966be359;
            } else if (status === $5875a5c0de10c551$export$df38205c966be359 || status === $5875a5c0de10c551$export$78e9e6e3e014d60a) nextStatus = $5875a5c0de10c551$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $5875a5c0de10c551$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $klu5V.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $5875a5c0de10c551$export$84cbff306f539230) this.setState({
            status: $5875a5c0de10c551$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $3SX21.default).disabled) {
            this.safeSetState({
                status: $5875a5c0de10c551$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $5875a5c0de10c551$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $5875a5c0de10c551$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $3SX21.default).disabled) {
            this.safeSetState({
                status: $5875a5c0de10c551$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $5875a5c0de10c551$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $5875a5c0de10c551$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $5875a5c0de10c551$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $hCIyK.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $70uTP.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$5875a5c0de10c551$var$Transition.contextType = (0, $70uTP.default);
$5875a5c0de10c551$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $5875a5c0de10c551$var$noop() {}
$5875a5c0de10c551$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $5875a5c0de10c551$var$noop,
    onEntering: $5875a5c0de10c551$var$noop,
    onEntered: $5875a5c0de10c551$var$noop,
    onExit: $5875a5c0de10c551$var$noop,
    onExiting: $5875a5c0de10c551$var$noop,
    onExited: $5875a5c0de10c551$var$noop
};
$5875a5c0de10c551$var$Transition.UNMOUNTED = $5875a5c0de10c551$export$bb38bb9a1161268;
$5875a5c0de10c551$var$Transition.EXITED = $5875a5c0de10c551$export$84cbff306f539230;
$5875a5c0de10c551$var$Transition.ENTERING = $5875a5c0de10c551$export$df38205c966be359;
$5875a5c0de10c551$var$Transition.ENTERED = $5875a5c0de10c551$export$78e9e6e3e014d60a;
$5875a5c0de10c551$var$Transition.EXITING = $5875a5c0de10c551$export$4aacc83d4d59139f;
var $5875a5c0de10c551$export$2e2bcd8739ae039 = $5875a5c0de10c551$var$Transition;

});
parcelRegister("3SX21", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d4434ad62cd5cee$export$2e2bcd8739ae039; });
var $2d4434ad62cd5cee$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("klu5V", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $ecfd1cf4e45b6881$export$7d26bbb1236dafd6; });
var $ecfd1cf4e45b6881$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("bi4C9", function(module, exports) {

$parcel$export(module.exports, "reflow", function () { return $8384f46febfffad5$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getTransitionProps", function () { return $8384f46febfffad5$export$8cb1e9b404609ae9; });
const $8384f46febfffad5$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $8384f46febfffad5$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}

});


parcelRegister("blj8y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8420801110dac2ee$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $7ITGE = parcelRequire("7ITGE");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $4Athc = parcelRequire("4Athc");

var $7YcSZ = parcelRequire("7YcSZ");

var $ih19M = parcelRequire("ih19M");
'use client';
const $8420801110dac2ee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $7YcSZ.getSnackbarContentUtilityClass), classes);
};
const $8420801110dac2ee$var$SnackbarContentRoot = (0, $l0oRz.default)((0, $4Athc.default), {
    name: 'MuiSnackbarContent',
    slot: 'Root'
})((0, $gfPc7.default)(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    return {
        ...theme.typography.body2,
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText((0, $7ITGE.emphasize)(theme.palette.background.default, emphasis)),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : (0, $7ITGE.emphasize)(theme.palette.background.default, emphasis),
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    };
}));
const $8420801110dac2ee$var$SnackbarContentMessage = (0, $l0oRz.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message'
})({
    padding: '8px 0'
});
const $8420801110dac2ee$var$SnackbarContentAction = (0, $l0oRz.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action'
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $8420801110dac2ee$var$SnackbarContent = /*#__PURE__*/ $bh6RR.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert', ...other } = props;
    const ownerState = props;
    const classes = $8420801110dac2ee$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($8420801110dac2ee$var$SnackbarContentRoot, {
        role: role,
        elevation: 6,
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($8420801110dac2ee$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $ih19M.jsx)($8420801110dac2ee$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    });
});
var $8420801110dac2ee$export$2e2bcd8739ae039 = $8420801110dac2ee$var$SnackbarContent;

});
parcelRegister("7YcSZ", function(module, exports) {

$parcel$export(module.exports, "getSnackbarContentUtilityClass", function () { return $5cd821e6efc51ba9$export$def81488db1a3216; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $5cd821e6efc51ba9$export$def81488db1a3216(slot) {
    return (0, $dmzXD.default)('MuiSnackbarContent', slot);
}
const $5cd821e6efc51ba9$var$snackbarContentClasses = (0, $fYlYP.default)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $5cd821e6efc51ba9$export$2e2bcd8739ae039 = $5cd821e6efc51ba9$var$snackbarContentClasses;

});


parcelRegister("e5BfU", function(module, exports) {

$parcel$export(module.exports, "getSnackbarUtilityClass", function () { return $a41e6e7c159b204d$export$6cb096457f5926f4; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $a41e6e7c159b204d$export$6cb096457f5926f4(slot) {
    return (0, $dmzXD.default)('MuiSnackbar', slot);
}
const $a41e6e7c159b204d$var$snackbarClasses = (0, $fYlYP.default)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $a41e6e7c159b204d$export$2e2bcd8739ae039 = $a41e6e7c159b204d$var$snackbarClasses;

});



parcelRegister("62tuQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a86d2fbbb1afe1dd$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $fb8oe = parcelRequire("fb8oe");
function $a86d2fbbb1afe1dd$export$2e2bcd8739ae039() {
    return $bh6RR.useContext((0, $fb8oe.default));
}

});
parcelRegister("fb8oe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d933b67ba2a1bedf$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
var $d933b67ba2a1bedf$export$2e2bcd8739ae039 = $bh6RR.createContext({
    dialogType: null,
    forceDeviceDialog: false,
    ignoreProximity: false,
    batteryWarningDismissed: false,
    onClose: ()=>{},
    setDisableOnClose: ()=>{},
    setDialogProps: ()=>{},
    setDialogType: ()=>{},
    setDrawerHeight: ()=>{},
    setIgnoreProximity: ()=>{},
    setBatteryWarningDismissed: ()=>{},
    setTiltCalibrationDismissed: ()=>{},
    setBallJamDismissed: ()=>{}
});

});


parcelRegister("76QOg", function(module, exports) {

$parcel$export(module.exports, "ValidSportNames", function () { return $b26c18ec74a78487$export$2303a3be3c568c34; });
$parcel$export(module.exports, "isValidSportName", function () { return $b26c18ec74a78487$export$b6536430b5982232; });
$parcel$export(module.exports, "trainerCompatibleWithSport", function () { return $b26c18ec74a78487$export$1ab353ce50858bb7; });
$parcel$export(module.exports, "SportProvider", function () { return $b26c18ec74a78487$export$dc10a78c53e3cd1d; });
$parcel$export(module.exports, "useSelectedSport", function () { return $b26c18ec74a78487$export$f799767823f7b24c; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $3Xpkr = parcelRequire("3Xpkr");

var $506bB = parcelRequire("506bB");

var $4rInl = parcelRequire("4rInl");

var $euyyI = parcelRequire("euyyI");

var $1lMle = parcelRequire("1lMle");
parcelRequire("cFAEN");
var $cK0UE = parcelRequire("cK0UE");

var $cK0UE = parcelRequire("cK0UE");

var $fLW8f = parcelRequire("fLW8f");

var $gJv9f = parcelRequire("gJv9f");

var $W4f7l = parcelRequire("W4f7l");

var $4xl3n = parcelRequire("4xl3n");

var $ezs3H = parcelRequire("ezs3H");
const $b26c18ec74a78487$export$2303a3be3c568c34 = [
    "PLATFORM_TENNIS",
    "PADEL",
    "TENNIS",
    "PICKLEBALL",
    "LACROSSE"
];
function $b26c18ec74a78487$export$b6536430b5982232(maybeSportName) {
    return $b26c18ec74a78487$export$2303a3be3c568c34.includes(maybeSportName);
}
const $b26c18ec74a78487$export$8cf9e6d179476596 = {
    none: 0,
    slight: 500,
    moderate: 1000,
    fast: 1500
};
const $b26c18ec74a78487$var$SpinTable = {
    PLATFORM_TENNIS: $b26c18ec74a78487$export$8cf9e6d179476596,
    PADEL: $b26c18ec74a78487$export$8cf9e6d179476596,
    TENNIS: $b26c18ec74a78487$export$8cf9e6d179476596,
    PICKLEBALL: $b26c18ec74a78487$export$8cf9e6d179476596,
    LACROSSE: $b26c18ec74a78487$export$8cf9e6d179476596
};
const $b26c18ec74a78487$var$PlatformSpeed = {
    maxLaunchSpeed: 55,
    minLaunchSpeed: 15,
    variance: 1.5
};
const $b26c18ec74a78487$var$TennisSpeed = {
    maxLaunchSpeed: 80,
    minLaunchSpeed: 15,
    variance: 2
};
const $b26c18ec74a78487$var$PadelSpeed = {
    maxLaunchSpeed: 80,
    minLaunchSpeed: 15,
    variance: 2
};
const $b26c18ec74a78487$var$PickleballSpeed = {
    maxLaunchSpeed: 63,
    minLaunchSpeed: 11,
    variance: 1.5
};
// Lacrosse runs the platform tennis ball faster than platform tennis does:
// 80 mph against platform tennis's 55. The physics ceiling is 4350 RPM /
// ~80.6 mph (tableLimits.ts), so the slider's maximum sits just inside it and
// a user can never ask for a speed that mps2rpm has to clamp.
const $b26c18ec74a78487$var$LacrosseSpeed = {
    maxLaunchSpeed: 80,
    minLaunchSpeed: 15,
    variance: 1.5
};
const $b26c18ec74a78487$var$SpeedTable = {
    PLATFORM_TENNIS: $b26c18ec74a78487$var$PlatformSpeed,
    PADEL: $b26c18ec74a78487$var$PadelSpeed,
    TENNIS: $b26c18ec74a78487$var$TennisSpeed,
    PICKLEBALL: $b26c18ec74a78487$var$PickleballSpeed,
    LACROSSE: $b26c18ec74a78487$var$LacrosseSpeed
};
const $b26c18ec74a78487$var$DefaultPostionIndex = {
    PADEL: 12,
    PLATFORM_TENNIS: 8,
    TENNIS: 14,
    PICKLEBALL: 7,
    /*
        The centre of the 12 m fan: front axle on the fan, 14.6 m (16 yd) dead
        in front of the goal mouth. Named rather than left as a bare index,
        because the number means a ring position and would otherwise read as
        the tennis baseline row lacrosse used to borrow.
    */ LACROSSE: (0, $gJv9f.LACROSSE_DEFAULT_SPOT_INDEX)
};
const $b26c18ec74a78487$var$TennisPositions = [
    {
        x: -2.05,
        y: -2.32,
        sys: "physics"
    },
    {
        x: 0,
        y: -2.32,
        sys: "physics"
    },
    {
        x: 2.05,
        y: -2.32,
        sys: "physics"
    },
    {
        x: -2.05,
        y: -4.15,
        sys: "physics"
    },
    {
        x: 0,
        y: -4.15,
        sys: "physics"
    },
    {
        x: 2.05,
        y: -4.15,
        sys: "physics"
    },
    {
        x: -2.05,
        y: -7.2,
        sys: "physics"
    },
    {
        x: 0,
        y: -7.2,
        sys: "physics"
    },
    {
        x: 2.05,
        y: -7.2,
        sys: "physics"
    },
    {
        x: -2.05,
        y: -9.64,
        sys: "physics"
    },
    {
        x: 0,
        y: -9.64,
        sys: "physics"
    },
    {
        x: 2.05,
        y: -9.64,
        sys: "physics"
    },
    {
        x: -4.1,
        y: -12.69,
        sys: "physics"
    },
    {
        x: -2.05,
        y: -12.69,
        sys: "physics"
    },
    {
        x: 0,
        y: -12.69,
        sys: "physics"
    },
    {
        x: 2.05,
        y: -12.69,
        sys: "physics"
    },
    {
        x: 4.1,
        y: -12.69,
        sys: "physics"
    },
    {
        x: -4.1,
        y: -15.74,
        sys: "physics"
    },
    {
        x: -2.05,
        y: -15.74,
        sys: "physics"
    },
    {
        x: 0,
        y: -15.74,
        sys: "physics"
    },
    {
        x: 2.05,
        y: -15.74,
        sys: "physics"
    },
    {
        x: 4.1,
        y: -15.74,
        sys: "physics"
    }
];
const $b26c18ec74a78487$export$ac3f2ea1a2078d98 = {
    PADEL: [
        {
            x: -2.1,
            y: -2.34,
            sys: "physics"
        },
        {
            x: 0,
            y: -2.34,
            sys: "physics"
        },
        {
            x: 2.1,
            y: -2.34,
            sys: "physics"
        },
        {
            x: -4.2,
            y: -4.17,
            sys: "physics"
        },
        {
            x: -2.1,
            y: -4.17,
            sys: "physics"
        },
        {
            x: 0,
            y: -4.17,
            sys: "physics"
        },
        {
            x: 2.1,
            y: -4.17,
            sys: "physics"
        },
        {
            x: 4.2,
            y: -4.17,
            sys: "physics"
        },
        {
            x: -4.2,
            y: -6,
            sys: "physics"
        },
        {
            x: -2.1,
            y: -6,
            sys: "physics"
        },
        {
            x: 0,
            y: -6,
            sys: "physics"
        },
        {
            x: 2.1,
            y: -6,
            sys: "physics"
        },
        {
            x: 4.2,
            y: -6,
            sys: "physics"
        },
        {
            x: -4.2,
            y: -7.8,
            sys: "physics"
        },
        {
            x: -2.1,
            y: -7.8,
            sys: "physics"
        },
        {
            x: 0,
            y: -7.8,
            sys: "physics"
        },
        {
            x: 2.1,
            y: -7.8,
            sys: "physics"
        },
        {
            x: 4.2,
            y: -7.8,
            sys: "physics"
        },
        {
            x: -3,
            y: -9.6,
            sys: "physics"
        },
        {
            x: 0,
            y: -9.6,
            sys: "physics"
        },
        {
            x: 3,
            y: -9.6,
            sys: "physics"
        }
    ],
    PLATFORM_TENNIS: [
        {
            x: -1.22,
            y: -2.01,
            sys: "physics"
        },
        {
            x: 0,
            y: -2.01,
            sys: "physics"
        },
        {
            x: 1.22,
            y: -2.01,
            sys: "physics"
        },
        {
            x: -1.22,
            y: -4.46,
            sys: "physics"
        },
        {
            x: 0,
            y: -4.46,
            sys: "physics"
        },
        {
            x: 1.22,
            y: -4.46,
            sys: "physics"
        },
        {
            x: -2.44,
            y: -7.51,
            sys: "physics"
        },
        {
            x: -1.22,
            y: -7.51,
            sys: "physics"
        },
        {
            x: 0,
            y: -7.51,
            sys: "physics"
        },
        {
            x: 1.22,
            y: -7.51,
            sys: "physics"
        },
        {
            x: 2.44,
            y: -7.51,
            sys: "physics"
        },
        {
            x: -2.44,
            y: -8.53,
            sys: "physics"
        },
        {
            x: -1.22,
            y: -8.53,
            sys: "physics"
        },
        {
            x: 0,
            y: -8.53,
            sys: "physics"
        },
        {
            x: 1.22,
            y: -8.53,
            sys: "physics"
        },
        {
            x: 2.44,
            y: -8.53,
            sys: "physics"
        }
    ],
    TENNIS: $b26c18ec74a78487$var$TennisPositions,
    PICKLEBALL: [
        {
            x: -3.04,
            y: -2.93,
            sys: "physics"
        },
        {
            x: -1.52,
            y: -2.93,
            sys: "physics"
        },
        {
            x: 0,
            y: -2.93,
            sys: "physics"
        },
        {
            x: 1.52,
            y: -2.93,
            sys: "physics"
        },
        {
            x: 3.04,
            y: -2.93,
            sys: "physics"
        },
        {
            x: -3.04,
            y: -5.07,
            sys: "physics"
        },
        {
            x: -1.52,
            y: -5.07,
            sys: "physics"
        },
        {
            x: 0,
            y: -5.07,
            sys: "physics"
        },
        {
            x: 1.52,
            y: -5.07,
            sys: "physics"
        },
        {
            x: 3.04,
            y: -5.07,
            sys: "physics"
        },
        {
            x: -3.04,
            y: -7.51,
            sys: "physics"
        },
        {
            x: -2.28,
            y: -7.51,
            sys: "physics"
        },
        {
            x: -1.52,
            y: -7.51,
            sys: "physics"
        },
        {
            x: 0,
            y: -7.51,
            sys: "physics"
        },
        {
            x: 1.52,
            y: -7.51,
            sys: "physics"
        },
        {
            x: 2.28,
            y: -7.51,
            sys: "physics"
        },
        {
            x: 3.04,
            y: -7.51,
            sys: "physics"
        }
    ],
    /*
        Goal-relative, not net-relative: 25 spots on rings measured from the
        cage. See util/lacrosse/spots.ts for why a field cannot use a
        court-style grid. Shared by reference with the three app-local
        POSITION_TABLEs, which spots.test.ts asserts.
    */ LACROSSE: (0, $gJv9f.LACROSSE_SPOTS)
};
const $b26c18ec74a78487$export$f9c565f5e13a0a51 = /*#__PURE__*/ $bh6RR.createContext({
    available: {
        PLATFORM_TENNIS: "Platform Tennis"
    },
    selected: "PLATFORM_TENNIS",
    hasSelected: false,
    resolvingSelection: false,
    friendlyName: "None Selected",
    limits: {
        speed: $b26c18ec74a78487$var$SpeedTable.PLATFORM_TENNIS,
        spin: $b26c18ec74a78487$var$SpinTable.PLATFORM_TENNIS
    },
    manualPositions: $b26c18ec74a78487$export$ac3f2ea1a2078d98.PLATFORM_TENNIS,
    updateSelected: ()=>{},
    getSportFromId: ()=>"PLATFORM_TENNIS",
    getIdFromSport: ()=>1,
    getFriendlyName: ()=>"Platform Tennis",
    getDefaultPosition: ()=>$b26c18ec74a78487$export$ac3f2ea1a2078d98.PLATFORM_TENNIS[8],
    lacrosseVariant: "MENS",
    updateLacrosseVariant: ()=>{},
    lacrosseTwoCage: false,
    updateLacrosseTwoCage: ()=>{}
});
const $b26c18ec74a78487$var$LOCAL_STORAGE_KEY = "VOLLEY_SELECTED_SPORT";
const $b26c18ec74a78487$var$LACROSSE_VARIANT_STORAGE_KEY = "VOLLEY_LACROSSE_VARIANT";
const $b26c18ec74a78487$var$LACROSSE_TWO_CAGE_STORAGE_KEY = "VOLLEY_LACROSSE_TWO_CAGE";
const $b26c18ec74a78487$var$DEFAULT_LACROSSE_VARIANT = "MENS";
// Sports only offered to members holding the user feature of the same name
const $b26c18ec74a78487$var$FEATURE_GATED_SPORTS = [
    "PICKLEBALL",
    "LACROSSE"
];
const $b26c18ec74a78487$var$WORKOUT_ROUTE_PATTERNS = [
    "/content/apps/workouts/plugin/play",
    "/content/apps/workouts/freeplay",
    "/content/apps/workouts/experimental"
];
function $b26c18ec74a78487$var$isWorkoutRoute(pathname) {
    return $b26c18ec74a78487$var$WORKOUT_ROUTE_PATTERNS.some((pattern)=>pathname.startsWith(pattern));
}
function $b26c18ec74a78487$export$1ab353ce50858bb7(sport, status) {
    if (status?.trainer?.sports === undefined) return true;
    return status.trainer.sports.includes(sport.toLocaleLowerCase());
}
const $b26c18ec74a78487$export$dc10a78c53e3cd1d = /*#__PURE__*/ $bh6RR.memo(({ children: children })=>{
    $b26c18ec74a78487$export$2303a3be3c568c34.forEach((sport)=>{
        if (!$b26c18ec74a78487$export$ac3f2ea1a2078d98[sport]) {
            (0, $1lMle.default).error(`Position table for sport ${sport} is not defined.`);
            return;
        }
        const queries = [];
        $b26c18ec74a78487$export$ac3f2ea1a2078d98[sport].forEach((pos)=>{
            queries.push(`select * from workout_apps wa inner join sports s on s.id = wa.sport_id where s.name = '${sport}' and wa.position_x = ${pos.x} and wa.position_y = ${pos.y};`);
        });
    });
    const { status: status } = (0, $ezs3H.useStatus)();
    const { status: pairingStatus } = (0, $4xl3n.usePairingContext)();
    const { features: features, featuresLoaded: featuresLoaded, authState: authState } = (0, $W4f7l.useCurrentUser)();
    const [toastMessage, setToastMessage] = $bh6RR.useState("");
    const [toastOpen, setToastOpen] = $bh6RR.useState(false);
    const [sports, setSports] = $bh6RR.useState([]);
    const [loading, setLoading] = $bh6RR.useState(false);
    $bh6RR.useEffect(()=>{
        if (sports.length === 0 && !loading && authState === (0, $W4f7l.AuthState).AUTHENTICATED) {
            setLoading(true);
            (0, $cK0UE.default)("/api/sports").then((results)=>setSports(results)).catch((e)=>(0, $cK0UE.logFetchError)(e)).finally(()=>setLoading(false));
        }
    }, [
        loading,
        sports,
        authState
    ]);
    $bh6RR.useEffect(()=>{
        const pickleball = sports.find((s)=>s.name === "PICKLEBALL");
        if (pickleball && features.length > 0 && !features.includes("PICKLEBALL")) {
            (0, $1lMle.default).info("Removing pickleball from available sports");
            setSports(sports.filter((s)=>s.name !== "PICKLEBALL"));
        }
    }, [
        sports,
        features
    ]);
    $bh6RR.useEffect(()=>{
        const lacrosse = sports.find((s)=>s.name === "LACROSSE");
        if (lacrosse && features.length > 0 && !features.includes("LACROSSE")) {
            (0, $1lMle.default).info("Removing lacrosse from available sports");
            setSports(sports.filter((s)=>s.name !== "LACROSSE"));
        }
    }, [
        sports,
        features
    ]);
    let defaultValue = "PLATFORM_TENNIS";
    let defaultHasSelected = false;
    const sessionValue = localStorage.getItem($b26c18ec74a78487$var$LOCAL_STORAGE_KEY);
    if (sessionValue !== null) {
        defaultValue = sessionValue;
        defaultHasSelected = true;
    }
    const [selectedSport, setSelectedSport] = $bh6RR.useState(defaultValue);
    const [hasSelected, setHasSelected] = $bh6RR.useState(defaultHasSelected);
    // With no sport stored on this device, adopt the one saved on the
    // profile (chosen on another device, or the home court's default)
    // before anyone is asked. undefined: not looked up yet; null: none.
    const [profileSport, setProfileSport] = $bh6RR.useState(defaultHasSelected ? null : undefined);
    // A new member is signed in before signup saves their home court, and
    // with it their sport. An answer from then is stale, so look again
    // once they are past login and signup.
    const { pathname: pathname } = (0, $as544.useLocation)();
    const inSignup = pathname.startsWith("/login") || pathname.startsWith("/signup");
    $bh6RR.useEffect(()=>{
        if (inSignup && !hasSelected && profileSport !== undefined) setProfileSport(undefined);
    }, [
        inSignup,
        hasSelected,
        profileSport
    ]);
    $bh6RR.useEffect(()=>{
        if (hasSelected || inSignup || profileSport !== undefined || authState !== (0, $W4f7l.AuthState).AUTHENTICATED) return;
        let cancelled = false;
        (0, $cK0UE.default)("/api/users/me").then((me)=>{
            const name = me.profile?.primarySport?.name;
            if (!cancelled) setProfileSport(name && $b26c18ec74a78487$export$b6536430b5982232(name) ? name : null);
        }).catch((e)=>{
            (0, $cK0UE.logFetchError)(e);
            if (!cancelled) setProfileSport(null);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        hasSelected,
        inSignup,
        profileSport,
        authState
    ]);
    $bh6RR.useEffect(()=>{
        if (hasSelected || !profileSport || !featuresLoaded) return;
        if ($b26c18ec74a78487$var$FEATURE_GATED_SPORTS.includes(profileSport) && !features.includes(profileSport)) {
            (0, $1lMle.default).info(`[SportProvider] Profile sport ${profileSport} is not available to this member`);
            setProfileSport(null);
            return;
        }
        (0, $1lMle.default).info(`[SportProvider] Using profile sport ${profileSport} on this device`);
        localStorage.setItem($b26c18ec74a78487$var$LOCAL_STORAGE_KEY, profileSport);
        setSelectedSport(profileSport);
        setHasSelected(true);
    }, [
        hasSelected,
        profileSport,
        featuresLoaded,
        features
    ]);
    const resolvingSelection = !hasSelected && (profileSport === undefined || profileSport !== null && !featuresLoaded);
    const storedVariant = localStorage.getItem($b26c18ec74a78487$var$LACROSSE_VARIANT_STORAGE_KEY);
    const [lacrosseVariant, setLacrosseVariant] = $bh6RR.useState(storedVariant !== null && (0, $fLW8f.isValidLacrosseVariant)(storedVariant) ? storedVariant : $b26c18ec74a78487$var$DEFAULT_LACROSSE_VARIANT);
    const [lacrosseTwoCage, setLacrosseTwoCage] = $bh6RR.useState(localStorage.getItem($b26c18ec74a78487$var$LACROSSE_TWO_CAGE_STORAGE_KEY) === "true");
    const navigate = (0, $as544.useNavigate)();
    const location = (0, $as544.useLocation)();
    const previousSportRef = $bh6RR.useRef(selectedSport);
    // Redirect to home when sport changes while on a workout route
    $bh6RR.useEffect(()=>{
        const previousSport = previousSportRef.current;
        if (previousSport !== selectedSport) {
            if ($b26c18ec74a78487$var$isWorkoutRoute(location.pathname)) {
                const name = sports.find((s)=>s.name === selectedSport)?.label ?? selectedSport;
                setToastMessage(`Sport changed to ${name}. Returning to home.`);
                setToastOpen(true);
                navigate("/", {
                    replace: true
                });
            }
            previousSportRef.current = selectedSport;
        }
    }, [
        selectedSport,
        location.pathname,
        navigate,
        sports
    ]);
    const updateSelected = $bh6RR.useCallback((updated)=>{
        if (pairingStatus === "paired" && !$b26c18ec74a78487$export$1ab353ce50858bb7(updated, status)) {
            const name = sports.find((s)=>s.name === updated)?.label ?? "Platform Tennis";
            const m = `You are not using a ${name} trainer. ${name} balls will not work with this trainer.`;
            setToastMessage(m);
            setToastOpen(true);
            return;
        }
        localStorage.setItem($b26c18ec74a78487$var$LOCAL_STORAGE_KEY, updated);
        setSelectedSport(updated);
        setHasSelected(true);
    }, [
        pairingStatus,
        status,
        sports
    ]);
    const getSportFromId = $bh6RR.useCallback((id)=>sports.find((s)=>s.id === id)?.name ?? "PLATFORM_TENNIS", [
        sports
    ]);
    const getIdFromSport = $bh6RR.useCallback((sport)=>sports.find((s)=>s.name === sport)?.id ?? 1, [
        sports
    ]);
    const getFriendlyName = $bh6RR.useCallback((sport)=>{
        if (typeof sport === "number") return sports.find((s)=>s.id === sport)?.label ?? "Platform Tennis";
        return sports.find((s)=>s.name === sport)?.label ?? "Platform Tennis";
    }, [
        sports
    ]);
    const getDefaultPosition = $bh6RR.useCallback(()=>{
        /* The two-cage drill has no entry in PositionTable - its
               placements are a continuous range along the line bisecting the
               cages, not a spot list - so a new workout in that mode starts on
               the range's own default rather than out on the 12 m fan. */ if (selectedSport === "LACROSSE" && lacrosseTwoCage) return (0, $gJv9f.lacrosseTwoCageSpot)((0, $gJv9f.LACROSSE_TWO_CAGE_YARDS).default);
        const index = $b26c18ec74a78487$var$DefaultPostionIndex[selectedSport];
        return $b26c18ec74a78487$export$ac3f2ea1a2078d98[selectedSport][index];
    }, [
        selectedSport,
        lacrosseTwoCage
    ]);
    const available = $bh6RR.useMemo(()=>Object.fromEntries(sports.filter((s)=>$b26c18ec74a78487$export$b6536430b5982232(s.name)).map((s)=>[
                s.name,
                s.label
            ])), [
        sports
    ]);
    // Presentation only: this selects which lacrosse field markings to draw
    // and is deliberately not sent to the server, coach or physics.
    const updateLacrosseVariant = $bh6RR.useCallback((variant)=>{
        localStorage.setItem($b26c18ec74a78487$var$LACROSSE_VARIANT_STORAGE_KEY, variant);
        setLacrosseVariant(variant);
    }, []);
    // Placement only, like the variant above: it selects which cages are on
    // the grass and therefore where the machine may stand, and is
    // deliberately not sent to the server, coach or physics.
    const updateLacrosseTwoCage = $bh6RR.useCallback((twoCage)=>{
        localStorage.setItem($b26c18ec74a78487$var$LACROSSE_TWO_CAGE_STORAGE_KEY, String(twoCage));
        setLacrosseTwoCage(twoCage);
    }, []);
    const value = $bh6RR.useMemo(()=>({
            available: available,
            selected: selectedSport,
            hasSelected: hasSelected,
            resolvingSelection: resolvingSelection,
            friendlyName: available[selectedSport],
            limits: {
                speed: $b26c18ec74a78487$var$SpeedTable[selectedSport],
                spin: $b26c18ec74a78487$var$SpinTable[selectedSport]
            },
            manualPositions: $b26c18ec74a78487$export$ac3f2ea1a2078d98[selectedSport],
            updateSelected: updateSelected,
            getSportFromId: getSportFromId,
            getIdFromSport: getIdFromSport,
            getFriendlyName: getFriendlyName,
            getDefaultPosition: getDefaultPosition,
            lacrosseVariant: lacrosseVariant,
            updateLacrosseVariant: updateLacrosseVariant,
            lacrosseTwoCage: lacrosseTwoCage,
            updateLacrosseTwoCage: updateLacrosseTwoCage
        }), [
        available,
        selectedSport,
        hasSelected,
        resolvingSelection,
        updateSelected,
        getSportFromId,
        getIdFromSport,
        getFriendlyName,
        getDefaultPosition,
        lacrosseVariant,
        updateLacrosseVariant,
        lacrosseTwoCage,
        updateLacrosseTwoCage
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($b26c18ec74a78487$export$f9c565f5e13a0a51.Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $euyyI.default), {
                open: toastOpen,
                onClose: ()=>setToastOpen(false),
                anchorOrigin: {
                    horizontal: "center",
                    vertical: "top"
                },
                sx: {
                    top: 60
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $506bB.default), {
                    action: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                        size: "small",
                        "aria-label": "close",
                        color: "inherit",
                        onClick: ()=>setToastOpen(false),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3Xpkr.default), {})
                    }),
                    severity: "warning",
                    children: toastMessage
                })
            })
        ]
    });
});
$b26c18ec74a78487$export$dc10a78c53e3cd1d.displayName = "SportProvider";
function $b26c18ec74a78487$export$f799767823f7b24c() {
    return $bh6RR.useContext($b26c18ec74a78487$export$f9c565f5e13a0a51);
}

});
parcelRegister("3Xpkr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e1a878fcd0fc9be$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $2e1a878fcd0fc9be$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});

parcelRegister("fLW8f", function(module, exports) {

$parcel$export(module.exports, "FT", function () { return $01fb30493963024d$export$dbf12b8bb38bcd82; });
$parcel$export(module.exports, "YD", function () { return $01fb30493963024d$export$ca5961e9349495a; });
$parcel$export(module.exports, "LacrosseVariants", function () { return $01fb30493963024d$export$f329cfffd696d052; });
$parcel$export(module.exports, "isValidLacrosseVariant", function () { return $01fb30493963024d$export$ad16c880e7a9d516; });
$parcel$export(module.exports, "LACROSSE_FIELDS", function () { return $01fb30493963024d$export$9dc928e3abfa9490; });
$parcel$export(module.exports, "GOAL", function () { return $01fb30493963024d$export$871e58afc769b358; });
$parcel$export(module.exports, "LINE_W", function () { return $01fb30493963024d$export$82926de0ddf3d0a2; });
$parcel$export(module.exports, "APRON", function () { return $01fb30493963024d$export$eb8915e06bc05ae1; });
$parcel$export(module.exports, "DRILL_GEOMETRY", function () { return $01fb30493963024d$export$66b11c43a8e17974; });
$parcel$export(module.exports, "arcHalfAngle", function () { return $01fb30493963024d$export$cee2639ea5d02fe; });
$parcel$export(module.exports, "fieldLines", function () { return $01fb30493963024d$export$1eab7cedaa111d5f; });
$parcel$export(module.exports, "fieldArcs", function () { return $01fb30493963024d$export$58c2e72d4361655b; });
$parcel$export(module.exports, "arcHashes", function () { return $01fb30493963024d$export$59ac9ed2a4787f01; });
$parcel$export(module.exports, "mowStripes", function () { return $01fb30493963024d$export$16d695e5801a7abf; });
$parcel$export(module.exports, "TWO_CAGE_GAP", function () { return $01fb30493963024d$export$ea7558f71065ba70; });
$parcel$export(module.exports, "TWO_GOAL_OFFSET_X", function () { return $01fb30493963024d$export$ed98acebb9fe721e; });
$parcel$export(module.exports, "goalPositions", function () { return $01fb30493963024d$export$5c910cbfc06a147a; });
/*
    Lacrosse field geometry - pure data and math.

    This is the table `CourtGeometryBySport` would hold if a field were a court.
    It is not one: `CourtGeometryBySport.LACROSSE` is a single permissive
    SIMULATION VOLUME (the largest field either code allows, centred on the
    field), while this module is the MARKINGS, keyed by variant. Both are
    correct and they describe different rectangles; see the comment on
    CourtGeometryBySport.LACROSSE in @volley/physics.

    No THREE, no React, no colours, no layer heights, no scene frame. Metres
    and radians only, so every number can be asserted in a unit test without a
    canvas. The goal-relative translation the visualizer needs is applied by
    buildLacrosseLayout(), not here - keeping this module in the rulebook's own
    frame is what lets geometry.test.ts check the same numbers the field is
    drawn from.

    Frame: +x right, +z away, origin at the CENTRE of the field, centre line on
    z = 0, the two goal lines at z = +/-goalZ.

    Sources are the NCAA rulebooks read directly rather than from
    field-diagram sites, which disagree with each other on the restraining line
    because the two codes measure it from opposite ends:
      men's    NCAA Men's Lacrosse Rules, Rule 1 - "Men's Lacrosse Field of
               Play" diagram, and Sections 7 (restraining lines), 8 (wing
               areas), 9 (centre of the field).
      women's  NCAA Women's Lacrosse Rules, Rule 1 Sections 1 (dimensions),
               4 (restraining line), 5 (centre circle), 6-7 (arc and fan),
               8 (below-goal dots), 21 (goal circle), plus "Directions for
               8-Meter Arc / 12-Meter Fan".
*/ /** Feet, in metres. */ const $01fb30493963024d$export$dbf12b8bb38bcd82 = 0.3048;
const $01fb30493963024d$export$ca5961e9349495a = 0.9144;
const $01fb30493963024d$export$f329cfffd696d052 = [
    "MENS",
    "WOMENS",
    "MIXED"
];
function $01fb30493963024d$export$ad16c880e7a9d516(maybeVariant) {
    return $01fb30493963024d$export$f329cfffd696d052.includes(maybeVariant);
}
const $01fb30493963024d$export$9dc928e3abfa9490 = {
    MENS: {
        label: "Men's",
        halfL: 55 * $01fb30493963024d$export$ca5961e9349495a,
        halfW: 30 * $01fb30493963024d$export$ca5961e9349495a,
        goalZ: 40 * $01fb30493963024d$export$ca5961e9349495a,
        restrainZ: 20 * $01fb30493963024d$export$ca5961e9349495a,
        creaseR: 3 * $01fb30493963024d$export$ca5961e9349495a,
        wingX: 20 * $01fb30493963024d$export$ca5961e9349495a,
        wingZ: 10 * $01fb30493963024d$export$ca5961e9349495a,
        centreSquare: 4 / 12 * $01fb30493963024d$export$dbf12b8bb38bcd82
    },
    WOMENS: {
        label: "Women's",
        halfL: 60 * $01fb30493963024d$export$ca5961e9349495a,
        halfW: 32.5 * $01fb30493963024d$export$ca5961e9349495a,
        goalZ: 50 * $01fb30493963024d$export$ca5961e9349495a,
        restrainZ: 20 * $01fb30493963024d$export$ca5961e9349495a,
        goalCircleR: 2.6,
        arcR: 10.6,
        fanR: 14.6,
        angleLeg: 8.6106,
        centreCircleR: 15 * $01fb30493963024d$export$dbf12b8bb38bcd82,
        drawLine: 3.023,
        dotBack: 5 * $01fb30493963024d$export$ca5961e9349495a
    },
    /*
        A real dual-marked field, not a display mode.

        Men's footprint (110 x 60 is legal for women's too, which allows
        110-120 x 60-70) and ONE goal per end carrying both sets of markings -
        a trainer aims at a goal, so two goals 5 yd apart would be worse than
        useless.

        The women's restraining line is therefore measured off the men's goal
        line, landing 30 yd out and so 10 yd from centre, and BOTH restraining
        lines show. That is correct, and it is what these fields look like in
        person.
    */ MIXED: {
        label: "Mixed",
        halfL: 55 * $01fb30493963024d$export$ca5961e9349495a,
        halfW: 30 * $01fb30493963024d$export$ca5961e9349495a,
        goalZ: 40 * $01fb30493963024d$export$ca5961e9349495a,
        restrainZ: 20 * $01fb30493963024d$export$ca5961e9349495a,
        creaseR: 3 * $01fb30493963024d$export$ca5961e9349495a,
        wingX: 20 * $01fb30493963024d$export$ca5961e9349495a,
        wingZ: 10 * $01fb30493963024d$export$ca5961e9349495a,
        centreSquare: 4 / 12 * $01fb30493963024d$export$dbf12b8bb38bcd82,
        goalCircleR: 2.6,
        arcR: 10.6,
        fanR: 14.6,
        angleLeg: 8.6106,
        centreCircleR: 15 * $01fb30493963024d$export$dbf12b8bb38bcd82,
        drawLine: 3.023,
        dotBack: 5 * $01fb30493963024d$export$ca5961e9349495a,
        womensRestrainFromGoal: 30 * $01fb30493963024d$export$ca5961e9349495a
    }
};
const $01fb30493963024d$export$871e58afc769b358 = {
    halfWidth: 0.915,
    height: 1.83,
    pipeRadius: 0.045,
    netDepth: 2.2
};
const $01fb30493963024d$export$82926de0ddf3d0a2 = 0.05;
const $01fb30493963024d$export$eb8915e06bc05ae1 = {
    side: 3.5,
    back: 4
};
const $01fb30493963024d$export$66b11c43a8e17974 = {
    goalCircleR: $01fb30493963024d$export$9dc928e3abfa9490.WOMENS.goalCircleR,
    arcR: $01fb30493963024d$export$9dc928e3abfa9490.WOMENS.arcR,
    fanR: $01fb30493963024d$export$9dc928e3abfa9490.WOMENS.fanR,
    angleLeg: $01fb30493963024d$export$9dc928e3abfa9490.WOMENS.angleLeg,
    dotBack: $01fb30493963024d$export$9dc928e3abfa9490.WOMENS.dotBack
};
function $01fb30493963024d$export$cee2639ea5d02fe(V) {
    if (V.arcR == null || V.goalCircleR == null || V.angleLeg == null) return null;
    const leg = V.angleLeg / Math.SQRT2;
    return Math.atan2(V.goalCircleR + leg, leg);
}
/*
    The straight markings, one small function per group.

    Split out of a single fieldLines() that had grown to fifteen branches. Each
    of these owns one rulebook section, so a marking can be read, checked and
    corrected without holding the rest in your head - and the "absent key means
    no such marking" convention now reads as one guard per function instead of
    one clause in a long chain.
*/ /** The field of play itself: end lines, sidelines, centre line. */ function $01fb30493963024d$var$perimeterLines(V) {
    const hl = V.halfL;
    const hw = V.halfW;
    return [
        {
            x1: -hw,
            z1: -hl,
            x2: hw,
            z2: -hl
        },
        {
            x1: -hw,
            z1: hl,
            x2: hw,
            z2: hl
        },
        {
            x1: -hw,
            z1: -hl,
            x2: -hw,
            z2: hl
        },
        {
            x1: hw,
            z1: -hl,
            x2: hw,
            z2: hl
        },
        {
            x1: -hw,
            z1: 0,
            x2: hw,
            z2: 0
        }
    ];
}
/** The restraining line and the goal line, at one end. */ function $01fb30493963024d$var$endLines(V, m) {
    const gw = $01fb30493963024d$export$871e58afc769b358.halfWidth;
    return [
        {
            x1: -V.halfW,
            z1: m * V.restrainZ,
            x2: V.halfW,
            z2: m * V.restrainZ
        },
        {
            x1: -gw,
            z1: m * V.goalZ,
            x2: gw,
            z2: m * V.goalZ
        }
    ];
}
/** Men's wing lines: parallel to the sidelines, either side of centre. */ function $01fb30493963024d$var$wingLines(V, m) {
    if (V.wingX == null || V.wingZ == null) return [];
    return [
        {
            x1: m * V.wingX,
            z1: -V.wingZ,
            x2: m * V.wingX,
            z2: V.wingZ
        }
    ];
}
/**
 * Women's: the flat sides of the 12 m fan, which run along the goal line
 * extended from the goal circle out to where the semicircle lands, and the
 * 45-degree legs that close the 8 m arc onto the same two points.
 */ function $01fb30493963024d$var$fanSideLines(V, m) {
    if (V.fanR == null || V.goalCircleR == null || V.angleLeg == null) return [];
    const gz = m * V.goalZ;
    const fd = -m; // downfield direction in z
    const b = V.goalCircleR;
    const leg = V.angleLeg / Math.SQRT2;
    const out = [];
    for (const sx of [
        1,
        -1
    ]){
        out.push({
            x1: sx * b,
            z1: gz,
            x2: sx * V.fanR,
            z2: gz
        });
        out.push({
            x1: sx * b,
            z1: gz,
            x2: sx * (b + leg),
            z2: gz + fd * leg
        });
    }
    return out;
}
/**
 * Women's below-goal dots.
 *
 * Drawn as short cross-field ticks rather than the rulebook's small circles -
 * at any camera distance the app uses, a 1 ft circle is a dot either way.
 */ function $01fb30493963024d$var$belowGoalDots(V, m) {
    if (V.dotBack == null || V.goalCircleR == null) return [];
    const dz = m * (V.goalZ + V.dotBack);
    if (Math.abs(dz) >= V.halfL) return [];
    return [
        1,
        -1
    ].map((sx)=>({
            x1: sx * V.goalCircleR - 0.15,
            z1: dz,
            x2: sx * V.goalCircleR + 0.15,
            z2: dz
        }));
}
/** Mixed only: the women's restraining line, measured off the men's goal line. */ function $01fb30493963024d$var$womensRestrainingLine(V, m) {
    if (V.womensRestrainFromGoal == null) return [];
    const wz = m * (V.goalZ - V.womensRestrainFromGoal);
    return [
        {
            x1: -V.halfW,
            z1: wz,
            x2: V.halfW,
            z2: wz
        }
    ];
}
/**
 * Centre marking.
 *
 * Men's is a 4 in contrasting SQUARE (Rule 1-9) - not an X, which is what
 * field-diagram sites tend to show. Women's is a 9'11" draw line through the
 * centre point, parallel to the goal lines. A mixed field carries both.
 */ function $01fb30493963024d$var$centreLines(V) {
    const out = [];
    if (V.centreSquare != null) {
        const h = V.centreSquare / 2;
        out.push({
            x1: -h,
            z1: -h,
            x2: h,
            z2: -h
        });
        out.push({
            x1: -h,
            z1: h,
            x2: h,
            z2: h
        });
        out.push({
            x1: -h,
            z1: -h,
            x2: -h,
            z2: h
        });
        out.push({
            x1: h,
            z1: -h,
            x2: h,
            z2: h
        });
    }
    if (V.drawLine != null) out.push({
        x1: -V.drawLine / 2,
        z1: 0,
        x2: V.drawLine / 2,
        z2: 0
    });
    return out;
}
function $01fb30493963024d$export$1eab7cedaa111d5f(V) {
    const perEnd = [
        1,
        -1
    ].flatMap((m)=>[
            ...$01fb30493963024d$var$endLines(V, m),
            ...$01fb30493963024d$var$wingLines(V, m),
            ...$01fb30493963024d$var$fanSideLines(V, m),
            ...$01fb30493963024d$var$belowGoalDots(V, m),
            ...$01fb30493963024d$var$womensRestrainingLine(V, m)
        ]);
    return [
        ...$01fb30493963024d$var$perimeterLines(V),
        ...perEnd,
        ...$01fb30493963024d$var$centreLines(V)
    ];
}
function $01fb30493963024d$export$58c2e72d4361655b(V) {
    const A = [];
    const full = (cx, cz, r)=>A.push({
            cx: cx,
            cz: cz,
            r: r,
            from: 0,
            sweep: Math.PI * 2
        });
    const half = $01fb30493963024d$export$cee2639ea5d02fe(V);
    for (const m of [
        1,
        -1
    ]){
        const gz = m * V.goalZ;
        const fd = -m; // downfield in z, from this goal
        const toField = fd > 0 ? Math.PI / 2 : -Math.PI / 2;
        // Men's crease - a full 9 ft circle around the goal.
        if (V.creaseR != null) full(0, gz, V.creaseR);
        /*
            Women's goal circle - 8'6" to the OUTER edge, so the painted band
            sits just inside the nominal radius rather than straddling it.
        */ if (V.goalCircleR != null) full(0, gz, V.goalCircleR - $01fb30493963024d$export$82926de0ddf3d0a2 / 2);
        // 8 m arc, closed at each end by the 45-degree legs. See arcHalfAngle.
        if (V.arcR != null && half != null) A.push({
            cx: 0,
            cz: gz,
            r: V.arcR,
            from: toField - half,
            sweep: half * 2
        });
        // 12 m fan - a semicircle; its flat sides are straight segments.
        if (V.fanR != null) A.push({
            cx: 0,
            cz: gz,
            r: V.fanR,
            from: toField - Math.PI / 2,
            sweep: Math.PI
        });
    }
    if (V.centreCircleR != null) full(0, 0, V.centreCircleR);
    return A;
}
function $01fb30493963024d$export$59ac9ed2a4787f01(V) {
    if (V.arcR == null) return [];
    const out = [];
    for (const m of [
        1,
        -1
    ]){
        const hz = m * V.goalZ + -m * V.arcR;
        out.push({
            x1: -0.152,
            z1: hz,
            x2: 0.152,
            z2: hz
        }); // 1 ft
    }
    return out;
}
function $01fb30493963024d$export$16d695e5801a7abf(V) {
    const out = [];
    const band = 10 * $01fb30493963024d$export$ca5961e9349495a;
    const n = Math.round(V.halfL * 2 / band);
    for(let i = 0; i < n; i++){
        if (i % 2 === 0) continue;
        out.push({
            x: 0,
            z: -V.halfL + band * (i + 0.5),
            w: V.halfW * 2,
            d: band
        });
    }
    return out;
}
const $01fb30493963024d$export$ea7558f71065ba70 = 8 * $01fb30493963024d$export$dbf12b8bb38bcd82;
const $01fb30493963024d$export$ed98acebb9fe721e = 2 * $01fb30493963024d$export$871e58afc769b358.halfWidth + $01fb30493963024d$export$ea7558f71065ba70;
function $01fb30493963024d$export$5c910cbfc06a147a(V, { drillEndSign: drillEndSign = -1, twoGoals: twoGoals = false, extraGoalOffsetX: extraGoalOffsetX = $01fb30493963024d$export$ed98acebb9fe721e } = {}) {
    const out = [
        {
            x: 0,
            z: V.goalZ,
            sideSign: 1
        },
        {
            x: 0,
            z: -V.goalZ,
            sideSign: -1
        }
    ];
    if (twoGoals) {
        // Slide the drill-end cage half a spacing off centre and put its pair
        // on the other side, so x = 0 - the painted goal's own centreline -
        // bisects them.
        const half = extraGoalOffsetX / 2;
        const drillIndex = drillEndSign === 1 ? 0 : 1;
        out[drillIndex] = {
            ...out[drillIndex],
            x: -half
        };
        out.push({
            x: half,
            z: drillEndSign * V.goalZ,
            sideSign: drillEndSign
        });
    }
    return out;
}

});

parcelRegister("gJv9f", function(module, exports) {

$parcel$export(module.exports, "lacrosseDefaultYaw", function () { return $d110709e0d37691a$export$a31229d9a53b8591; });
$parcel$export(module.exports, "normaliseYaw", function () { return $d110709e0d37691a$export$35df35c3dbe17986; });
$parcel$export(module.exports, "LACROSSE_TWO_CAGE_YARDS", function () { return $d110709e0d37691a$export$82ab103a8aa9e5cb; });
$parcel$export(module.exports, "lacrosseTwoCageSpot", function () { return $d110709e0d37691a$export$b6b0c19195a4b24f; });
$parcel$export(module.exports, "lacrosseTwoCageYards", function () { return $d110709e0d37691a$export$84c0728c79dd6c0; });
$parcel$export(module.exports, "LACROSSE_SPOTS", function () { return $d110709e0d37691a$export$a3e51a5bc2bd3709; });
$parcel$export(module.exports, "LACROSSE_DEFAULT_SPOT_INDEX", function () { return $d110709e0d37691a$export$c2c60f8f1c3e6487; });
/*
    Where the machine stands on a lacrosse field.

    A racket-sport spot grid anchors the machine to painted lines - "rear axle
    on the baseline". A field has no baseline worth standing on: the four
    racket sports all fit inside 24 m, while a lacrosse field is 110 m long and
    the only findable thing on it is the cage. So these 25 spots are
    GOAL-RELATIVE, laid out on rings a coach can walk to, and every radius is a
    painted marking rather than a round number.

    Frame is the app's physics frame with the drill-end goal at the origin:
    goal centre (0, 0), downfield -y, +x to its right. Bearing phi is measured
    off the downfield axis, so spot(r, phi) = (r sin phi, -r cos phi) and
    bearing 0 is straight out in front of the mouth.

    Derived in code rather than transcribed, which is the whole point of the
    handoff package: change a rulebook number in geometry.ts and the spots
    follow it, instead of drifting from it silently.
*/ 
var $fLW8f = parcelRequire("fLW8f");
const $d110709e0d37691a$export$eb23c6a2cccd67bb = 0.8;
/** Deep ring: one long step back off the 12 m fan. */ const $d110709e0d37691a$var$DEEP_STEP = 4;
/**
 * The five bearings every outer ring uses, in radians.
 *
 * {-half, -half/2, 0, +half/2, +half} where `half` is the 8 m arc's own
 * half-extent - the angle the rulebook's 45 degree legs fix (see
 * arcHalfAngle). Using the arc's own extent rather than a hand-picked
 * +/-30/+/-60 means the three outer rings are radial step-backs on the SAME
 * five lines: a coach walks straight back 10.6 -> 14.6 -> 18.6 without moving
 * sideways, and no new angular constant enters the codebase.
 */ function $d110709e0d37691a$var$ringBearings() {
    // WOMENS and MIXED share these markings and MENS has none of them, so no
    // spot varies by variant - see DRILL_GEOMETRY.
    const half = (0, $fLW8f.arcHalfAngle)((0, $fLW8f.LACROSSE_FIELDS).WOMENS);
    if (half == null) throw new Error("lacrosse arc geometry is missing its 45 degree legs");
    return [
        -half,
        -half / 2,
        0,
        half / 2,
        half
    ];
}
/**
 * Round at the storage boundary, so stored values are stable and comparable.
 *
 * The `+ 0` normalises -0 to 0. The GLE ring sits at bearing +/-PI/2, where
 * `-d * cos(bearing)` is -0, and that would persist to the database as "-0".
 */ function $d110709e0d37691a$var$round3(value) {
    return Math.round(value * 1000) / 1000 + 0;
}
/**
 * Yaw is radians, so it needs finer rounding than the metre values.
 *
 * The `+ 0` normalises -0 to 0. Negating a zero bearing yields -0, which is
 * not `Object.is`-equal to 0 and would persist to the database as "-0".
 */ function $d110709e0d37691a$var$round6(value) {
    return Math.round(value * 1e6) / 1e6 + 0;
}
/**
 * Body yaw that points the machine at the cage, for a spot at `bearing`.
 *
 * Yaw 0 faces physics +y, and the machine's heading is `(sin yaw, cos yaw)` -
 * which is what CameraOribitControls' frontAxlePosition(), the visualizer's
 * trainer rotation and the 2D picker's marker rotation all read. A spot at
 * bearing b sits at `(d sin b, -d cos b)`, so facing back at the goal means
 * heading `(-sin b, cos b)`, i.e. simply:
 *
 *     yaw = -bearing
 *
 * For the SHOOTING rings only - the ones downfield of the goal line. It also
 * makes the wheelbase convention land: the front axle sits one wheelbase along
 * the heading, so facing the cage makes that offset radial and the axle lands
 * exactly on the ring radius. At yaw 0 the offset would run up the +y axis and
 * the deep corner spot would miss 18.6 m by 35 cm.
 */ function $d110709e0d37691a$var$yawFacingCage(bearing) {
    /*
        Clamped to +/-PI after rounding, not before. Rounding a bearing of PI to
        six decimals gives 3.141593, whose magnitude is very slightly MORE than
        PI - 180.0000198 degrees - and the yaw slider's range is exactly +/-180,
        so such a value would be one the control silently rewrites. Same class
        of bug as the old +/-75 clamp rewriting a 90 degree spot.
    */ return Math.max(-Math.PI, Math.min(Math.PI, $d110709e0d37691a$var$round6(-bearing)));
}
/**
 * Body yaw that points the machine down the field, for a spot at `x`.
 *
 * Used by every spot ON or BEHIND the goal line - the GLE ring and the pair
 * behind the cage. From there a coach feeds OUT into play: aiming at the cage
 * would fire straight across the mouth from the GLE, or into the back of the
 * net from behind it. So these face downfield, and the slider is how a drill
 * angles them off that.
 *
 * Straight downfield is heading (0, -1), which is yaw +/-180 - the same
 * direction either way. The SIGN is chosen by which side of the goal the spot
 * sits on, so the slider has room to swing the machine INWARD, towards the
 * middle of the field, without running off the end of its range: a left-side
 * spot starts at +180 and angles in as the value falls, a right-side spot
 * starts at -180 and angles in as it rises.
 *
 * No shipped spot on or behind the goal line sits at x = 0, so the tie is
 * academic; it resolves to +180.
 */ function $d110709e0d37691a$var$yawFacingField(x) {
    return x <= 0 ? Math.PI : -Math.PI;
}
function $d110709e0d37691a$export$a31229d9a53b8591(x, y) {
    return y >= 0 ? $d110709e0d37691a$var$yawFacingField(x) : $d110709e0d37691a$var$yawFacingCage(Math.atan2(x, -y));
}
function $d110709e0d37691a$export$35df35c3dbe17986(radians) {
    let v = radians;
    while(v <= -Math.PI)v += 2 * Math.PI;
    while(v > Math.PI)v -= 2 * Math.PI;
    return v + 0;
}
/**
 * Label for the module apps' yaw radio, which reads yawDescription.
 *
 * A bearing past +/-90 degrees puts the spot behind the goal line, where
 * "facing the cage" and "facing the field" are the same direction - the goal
 * is between the machine and the play. Saying the latter is more use to a
 * coach standing there.
 */ function $d110709e0d37691a$var$yawLabel(yaw, facingField) {
    if (yaw === 0) return undefined; // ModuleTrainerPosition renders "Forward"
    const deg = Math.round(yaw * 180 / Math.PI);
    const towards = facingField ? "facing down the field" : "facing the cage";
    return `${deg > 0 ? "+" : ""}${deg}\xb0 - ${towards}`;
}
/**
 * A spot's STORED value, given where its front axle should land.
 *
 * The stored position is the rear axle. The repo convention is that the front
 * axle goes on the painted line and the stored value is the line plus a
 * wheelbase - tennis stores -12.69 so its front axle lands on the -11.885 m
 * baseline, and padel stores -7.8 so its front axle lands exactly on the 7.0 m
 * service line. So the machine is pushed one wheelbase radially OUTWARD from
 * the goal, away from the direction it faces.
 */ /**
 * A spot at a stated STORED position - the rear axle, as the database holds it.
 *
 * Which way it faces is decided by which side of the goal LINE it sits on, not
 * by its ring. Downfield (y < 0) is a shooting position and aims at the cage;
 * on or behind the line it feeds out into the field instead. The yaw comes from
 * the ROUNDED position, so the table and the slider's reference agree exactly
 * rather than to within a rounding error.
 */ function $d110709e0d37691a$var$spotAt(x, y) {
    const facingField = y >= 0;
    const yaw = $d110709e0d37691a$export$a31229d9a53b8591(x, y);
    const description = $d110709e0d37691a$var$yawLabel(yaw, facingField);
    return {
        x: x,
        y: y,
        yaw: yaw,
        // Spread, not `yawDescription: undefined`: an explicit undefined key
        // still shows up in equality checks and in anything that serialises.
        ...description === undefined ? {} : {
            yawDescription: description
        },
        sys: "physics"
    };
}
/**
 * A spot on a ring, pushed one wheelbase radially outward so the FRONT axle
 * lands on the marking at `r`. See the note on yawFacingCage.
 */ function $d110709e0d37691a$var$stored(r, bearing) {
    const d = r + $d110709e0d37691a$export$eb23c6a2cccd67bb;
    return $d110709e0d37691a$var$spotAt($d110709e0d37691a$var$round3(d * Math.sin(bearing)), $d110709e0d37691a$var$round3(-d * Math.cos(bearing)));
}
/** As `stored`, but from a front-axle point rather than a radius and bearing. */ function $d110709e0d37691a$var$storedAt(x, y) {
    const r = Math.hypot(x, y);
    return $d110709e0d37691a$var$stored(r, Math.atan2(x, -y));
}
const $d110709e0d37691a$export$82ab103a8aa9e5cb = {
    near: 3,
    far: 15,
    step: 0.5,
    /** Where the slider lands when the drill is first switched on. */ default: 10
};
function $d110709e0d37691a$export$11eb6a85ca477ab0(yards) {
    const { near: near, far: far } = $d110709e0d37691a$export$82ab103a8aa9e5cb;
    return Math.max(near, Math.min(far, yards));
}
function $d110709e0d37691a$export$b6b0c19195a4b24f(yards) {
    const front = $d110709e0d37691a$export$11eb6a85ca477ab0(yards) * (0, $fLW8f.YD);
    return $d110709e0d37691a$var$spotAt(0, $d110709e0d37691a$var$round3(-(front + $d110709e0d37691a$export$eb23c6a2cccd67bb)));
}
function $d110709e0d37691a$export$84c0728c79dd6c0(y) {
    return $d110709e0d37691a$export$11eb6a85ca477ab0((-y - $d110709e0d37691a$export$eb23c6a2cccd67bb) / (0, $fLW8f.YD));
}
function $d110709e0d37691a$var$buildSpots() {
    const { goalCircleR: goalCircleR, arcR: arcR, fanR: fanR, dotBack: dotBack } = (0, $fLW8f.DRILL_GEOMETRY);
    const bearings = $d110709e0d37691a$var$ringBearings();
    const spots = [];
    /*
        Ring 1 - behind the cage, 6 spots.

        A straight row on the below-goal dot line, 5 yd behind the goal line.
        These all face straight down the field, so their wheelbase offset is
        purely in y: storing them one wheelbase BEHIND the dot line puts every
        front axle exactly on it, and the inner pair's on the painted dots at
        +/-goalCircleR.

        The lateral spread reuses the arc and fan radii rather than inventing
        offsets, so this row lines up with the GLE ring directly in front of it.

        THERE IS DELIBERATELY NO CENTRE SPOT. A machine dead behind the cage
        fires into the back of the net, so it would only work for a lofted feed
        over the 1.83 m crossbar; our subject-matter expert ruled it out. Every
        spot here clears the posts, whose half-width is 0.915 m.
    */ const dotRow = dotBack + $d110709e0d37691a$export$eb23c6a2cccd67bb;
    for (const x of [
        -fanR,
        -arcR,
        -goalCircleR,
        goalCircleR,
        arcR,
        fanR
    ])spots.push($d110709e0d37691a$var$spotAt($d110709e0d37691a$var$round3(x), $d110709e0d37691a$var$round3(dotRow)));
    /*
        Ring 2 - the GLE, or goal line extended, 5 spots.

        Level with the mouth at y = 0, out at the arc and fan radii. Both land
        on the 12 m fan's flat side, which runs along the GLE from the goal
        circle out to 14.6 - that side's far endpoint.

        These face DOWN THE FIELD, not at the cage. Level with the goal line,
        aiming at the cage would fire straight across the mouth, and a coach on
        the GLE is feeding out into play. Same as the behind-the-cage pair, and
        the reason the yaw range has to reach 180.
    */ const gle = [
        -fanR,
        -arcR,
        arcR,
        fanR
    ].map((x)=>$d110709e0d37691a$var$storedAt(x, 0));
    /*
        ... plus the GLE's centre: the machine standing IN the goal mouth,
        feeding out into the field. Stored (0, 0) puts the rear axle on the goal
        line with the body straddling the mouth, which is 1.83 m wide against a
        machine about 1.2 m across.

        Stated outright rather than built from a radius, because it is the one
        spot with no radius - at the origin there is no bearing to push along.
        It is also the only place yawFacingField's x = 0 tie is reachable, and
        it resolves to +180: down the field, the only sensible direction from
        inside the cage.
    */ gle.push($d110709e0d37691a$var$spotAt(0, 0));
    // Sorted so the row reads left to right and the mouth sits in its middle.
    gle.sort((a, b)=>a.x - b.x);
    spots.push(...gle);
    // Rings 3 and 4 - the 8 m arc and the 12 m fan.
    for (const r of [
        arcR,
        fanR
    ])for (const bearing of bearings)spots.push($d110709e0d37691a$var$stored(r, bearing));
    /*
        Ring 5 - deep, 4 spots.

        No straight-on spot: ring 4 already has a centre 4 m nearer, and
        widening the deep row opens the shooting angle rather than repeating a
        feed the next ring in already gives. Dropping the centre also keeps the
        default index on the fan's centre.
    */ for (const bearing of bearings.filter((b)=>b !== 0))spots.push($d110709e0d37691a$var$stored(fanR + $d110709e0d37691a$var$DEEP_STEP, bearing));
    return spots;
}
const $d110709e0d37691a$export$a3e51a5bc2bd3709 = Object.freeze($d110709e0d37691a$var$buildSpots());
const $d110709e0d37691a$export$c2c60f8f1c3e6487 = 18;
const $d110709e0d37691a$export$518909d4b8d071f = [
    6,
    5,
    5,
    5,
    4
];

});

parcelRegister("W4f7l", function(module, exports) {

$parcel$export(module.exports, "AuthState", function () { return $df9784074a49aff7$export$64ffd00f76289b4a; });
$parcel$export(module.exports, "CurrentUserProvider", function () { return $df9784074a49aff7$export$6414ebbbfff99d4c; });
$parcel$export(module.exports, "useCurrentUser", function () { return $df9784074a49aff7$export$3901076af3749fa9; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $iZqJL = parcelRequire("iZqJL");

var $6Wfmo = parcelRequire("6Wfmo");
parcelRequire("eyjy7");
var $fgDKG = parcelRequire("fgDKG");

var $iQG9n = parcelRequire("iQG9n");

var $cK0UE = parcelRequire("cK0UE");
var $df9784074a49aff7$export$64ffd00f76289b4a = /*#__PURE__*/ function(AuthState) {
    AuthState[AuthState["LOADING"] = 0] = "LOADING";
    AuthState[AuthState["UNAUTHENTICATED"] = 1] = "UNAUTHENTICATED";
    AuthState[AuthState["AUTHENTICATED"] = 2] = "AUTHENTICATED";
    return AuthState;
}({});
const $df9784074a49aff7$var$DEFAULT_VALUE = {
    currentUser: null,
    features: [],
    featuresLoaded: false,
    reloadFeatures: ()=>{},
    setCurrentUser: ()=>{},
    authState: 0,
    subscriptions: [],
    refreshSubscriptions: ()=>{},
    isAdmin: ()=>false,
    isPro: ()=>false,
    isAssessmentTester: ()=>false,
    signOut: ()=>{}
};
const $df9784074a49aff7$var$VALID_SUBSCRIPTION_STATUSES = new Set([
    "active",
    "past_due",
    "incomplete"
]);
const $df9784074a49aff7$export$901e53dee874e6ed = /*#__PURE__*/ $bh6RR.createContext($df9784074a49aff7$var$DEFAULT_VALUE);
function $df9784074a49aff7$var$hasRole(roles, role) {
    const matchingRoles = roles.filter((r)=>r.role.name === role);
    return matchingRoles.length > 0;
}
function $df9784074a49aff7$export$93a4b39e70a24e1d(user, subscriptions) {
    return user && $df9784074a49aff7$var$hasRole(user.userRoles, "ADMIN") || subscriptions.some((s)=>$df9784074a49aff7$var$VALID_SUBSCRIPTION_STATUSES.has(s.status));
}
function $df9784074a49aff7$export$6414ebbbfff99d4c({ children: children }) {
    const navigate = (0, $as544.useNavigate)();
    const location = (0, $as544.useLocation)();
    // Captured out of the URL at startup; cleared once exchanged for a
    // Firebase session, which mirrors the param disappearing from the URL.
    const [token, setToken] = $bh6RR.useState((0, $iQG9n.getAuthToken));
    const [authState, setAuthState] = $bh6RR.useState(0);
    const [user, setUser] = $bh6RR.useState(null);
    const [isNewUser, setIsNewUser] = $bh6RR.useState(false);
    const [features, setFeatures] = $bh6RR.useState(null);
    const [subscriptions, setSubscriptions] = $bh6RR.useState([]);
    const [error, setError] = $bh6RR.useState();
    const signOut = $bh6RR.useCallback(async ()=>{
        await (0, $fgDKG.D)((0, $fgDKG.p)());
        setUser(null);
    }, []);
    const handleAuthStateChange = $bh6RR.useCallback(async (authUser)=>{
        if (!authUser) {
            setUser(null);
            if (!token) setAuthState(1);
            return;
        }
        const idToken = await authUser.getIdToken();
        let volleyUser;
        try {
            const response = await (0, $cK0UE.default)("/api/users/authentication", "POST", {
                idToken: idToken
            });
            volleyUser = response;
            if (response.isNewUser) setIsNewUser(true);
        } catch (e) {
            setError(e.message);
            return;
        }
        setUser(volleyUser);
        const monitoredUser = {
            id: String(volleyUser.id),
            email: volleyUser.email,
            name: `${volleyUser.firstName} ${volleyUser.lastName}`,
            username: volleyUser.username
        };
        (0, $6Wfmo.datadogRum).setUser(monitoredUser);
        (0, $iZqJL.datadogLogs).setUser(monitoredUser);
        setError(undefined);
        setAuthState(2);
    }, [
        token
    ]);
    const refreshSubscriptions = $bh6RR.useCallback(()=>{
        if (!user?.id) return;
        (0, $cK0UE.default)(`/api/users/${user.id}/subscriptions?limit=10&offset=0`).then(({ result: result })=>{
            setSubscriptions(result);
        }).catch((0, $cK0UE.logFetchError));
    }, [
        user?.id
    ]);
    $bh6RR.useEffect(()=>{
        refreshSubscriptions();
    }, [
        refreshSubscriptions
    ]);
    const value = $bh6RR.useMemo(()=>({
            currentUser: user,
            authState: authState,
            subscriptions: subscriptions,
            refreshSubscriptions: refreshSubscriptions,
            error: error,
            features: features ?? [],
            featuresLoaded: features !== null,
            // Clearing them refetches below, and featuresLoaded is false
            // until the new list arrives.
            reloadFeatures: ()=>setFeatures(null),
            setCurrentUser: setUser,
            isAdmin: ()=>user !== null && $df9784074a49aff7$var$hasRole(user.userRoles, "ADMIN"),
            isPro: ()=>user !== null && $df9784074a49aff7$var$hasRole(user.userRoles, "PRO"),
            isAssessmentTester: ()=>user !== null && $df9784074a49aff7$var$hasRole(user.userRoles, "ASSESSMENTS_TESTER"),
            signOut: signOut
        }), [
        features,
        subscriptions,
        refreshSubscriptions,
        user,
        authState,
        error,
        signOut
    ]);
    // Observe changes to authentication state, stop listening on unmount
    $bh6RR.useEffect(()=>(0, $fgDKG.z)((0, $fgDKG.p)(), handleAuthStateChange), [
        handleAuthStateChange
    ]);
    // Sign in with custom auth token
    $bh6RR.useEffect(()=>{
        const auth = (0, $fgDKG.p)();
        if (token && !auth.currentUser) (0, $fgDKG.a5)(auth, token).then(()=>{
            (0, $iQG9n.clearAuthToken)();
            setToken(null);
        }).catch((err)=>{
            setError(err.message);
        });
    }, [
        token
    ]);
    // Direct user into application after login
    $bh6RR.useEffect(()=>{
        if (user && authState === 2 && location.pathname.startsWith("/login")) {
            const from = location.state?.from;
            if (isNewUser) {
                // A player who opened a claim link and then signed in with a
                // provider for the first time is signing up: carry the code
                // on so the account comes with their assessment.
                const claimCode = from?.match(/^\/claim\/([^/?#]+)/)?.[1];
                const signupPath = claimCode ? `/signup/account?invite=${encodeURIComponent(claimCode)}` : "/signup/account";
                navigate(signupPath, {
                    replace: true,
                    state: {
                        email: user.email,
                        name: `${user.firstName} ${user.lastName}`
                    }
                });
            } else navigate(from ?? "/", {
                replace: true
            });
        }
    }, [
        user,
        isNewUser,
        authState,
        location.pathname,
        location.state,
        navigate
    ]);
    $bh6RR.useEffect(()=>{
        async function fetchFeatures(id) {
            const results = await (0, $cK0UE.default)(`/api/users/${id}/features`, "GET");
            setFeatures(results);
        }
        if (authState === 2 && user?.id && features === null) fetchFeatures(user.id);
    }, [
        features,
        authState,
        user?.id
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($df9784074a49aff7$export$901e53dee874e6ed.Provider, {
        value: value,
        children: children
    });
}
function $df9784074a49aff7$export$3901076af3749fa9() {
    return $bh6RR.useContext($df9784074a49aff7$export$901e53dee874e6ed);
}

});
parcelRegister("iQG9n", function(module, exports) {

$parcel$export(module.exports, "captureAuthTokenFromUrl", function () { return $92c7e71853240eab$export$e5d768d6afb52082; });
$parcel$export(module.exports, "getAuthToken", function () { return $92c7e71853240eab$export$38e1f53b76ec7fed; });
$parcel$export(module.exports, "clearAuthToken", function () { return $92c7e71853240eab$export$df5ba283a82ad80a; });
/**
 * Sign-in token handoff for the React Native WebView.
 *
 * The mobile app loads webby-app with `?token=<firebase custom token>` so the
 * WebView lands already authenticated. Left in the URL, that credential ends up
 * in browser history, in the same-origin `Referer` header sent to webby-server
 * (and so in load balancer and access logs), and in every Datadog RUM
 * `view.url` / `view.referrer` for the session.
 *
 * `captureAuthTokenFromUrl` is called from the entrypoint before Datadog RUM
 * initializes: it moves the token into memory and rewrites the address bar, so
 * nothing downstream ever observes it.
 */ let $92c7e71853240eab$var$capturedToken = null;
function $92c7e71853240eab$export$e5d768d6afb52082() {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("token");
    if (!token) return;
    $92c7e71853240eab$var$capturedToken = token;
    url.searchParams.delete("token");
    window.history.replaceState(window.history.state, "", url.toString());
}
function $92c7e71853240eab$export$38e1f53b76ec7fed() {
    return $92c7e71853240eab$var$capturedToken;
}
function $92c7e71853240eab$export$df5ba283a82ad80a() {
    $92c7e71853240eab$var$capturedToken = null;
}

});


parcelRegister("4xl3n", function(module, exports) {

$parcel$export(module.exports, "PairingProvider", function () { return $e9090818e08d89a2$export$ec598cbcb6391e8f; });
$parcel$export(module.exports, "usePairingContext", function () { return $e9090818e08d89a2$export$dd23975923240066; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1lMle = parcelRequire("1lMle");
parcelRequire("cFAEN");
var $cK0UE = parcelRequire("cK0UE");

var $cK0UE = parcelRequire("cK0UE");

var $1ETlN = parcelRequire("1ETlN");

var $awHpO = parcelRequire("awHpO");

var $1xith = parcelRequire("1xith");

var $W4f7l = parcelRequire("W4f7l");
const $e9090818e08d89a2$var$defaultState = {
    status: "unknown",
    autoCalibrate: false
};
function $e9090818e08d89a2$var$pairingReducer(state, action) {
    (0, $1lMle.default).info(`[pairingState:reducer]: ${JSON.stringify(action)}`);
    if ([
        "sessionClosed",
        "pairingCancelled",
        "unpair"
    ].includes(action.type)) {
        (0, $awHpO.default).clearFilter();
        (0, $1xith.default).clearPosition();
        localStorage.removeItem("JOURNEY_FEEDBACK_SESSION_SHOWN");
        localStorage.removeItem("JOURNEY_FEEDBACK_PENDING");
    }
    switch(action.type){
        case "sessionClosed":
            return {
                status: "unpaired",
                autoCalibrate: false
            };
        case "pairingCancelled":
        case "unpair":
            return {
                ...state,
                status: "unpaired",
                autoCalibrate: false
            };
        case "sessionDetected":
            return {
                status: "validating",
                autoCalibrate: false,
                trainerId: action.trainerId,
                sessionId: action.sessionId
            };
        case "pairingVerified":
            return {
                ...state,
                status: "paired",
                autoCalibrate: false,
                trainerId: action.trainerId,
                sessionId: action.sessionId
            };
        case "promptToPair":
            return {
                ...state,
                status: "requested",
                autoCalibrate: action.autoCalibrate
            };
        default:
            (0, $1lMle.default).warn(`Invalid pairing state reducer action: ${JSON.stringify(action)}`);
            return state;
    }
}
const $e9090818e08d89a2$export$e1ef1bacf1645cc4 = /*#__PURE__*/ $bh6RR.createContext({
    status: "unknown",
    autoCalibrate: false,
    pairingCancelled: ()=>{},
    pairingVerified: ()=>{},
    promptToPair: ()=>{},
    unpair: ()=>{}
});
const $e9090818e08d89a2$export$ec598cbcb6391e8f = /*#__PURE__*/ $bh6RR.memo(({ children: children })=>{
    const { authState: authState } = (0, $W4f7l.useCurrentUser)();
    const [checking, setChecking] = $bh6RR.useState(false);
    const [state, dispatch] = $bh6RR.useReducer($e9090818e08d89a2$var$pairingReducer, $e9090818e08d89a2$var$defaultState);
    const pairingCancelled = $bh6RR.useCallback(()=>{
        (0, $1lMle.default).info("[pairing:pairingCancelled]");
        dispatch({
            type: "pairingCancelled"
        });
    }, []);
    const pairingVerified = $bh6RR.useCallback((trainerId, sessionId)=>{
        (0, $1lMle.default).info(`[pairing:pairingVerified] Trainer: ${trainerId}, Session: ${sessionId}`);
        if (state.trainerId && state.trainerId !== trainerId) (0, $1lMle.default).warn(`[pairing:pairingVerified] trainerId ${trainerId} doesn't match previoud: ${state.trainerId}`);
        if (state.sessionId && state.sessionId !== sessionId) (0, $1lMle.default).warn(`[pairing:pairingVerified] sessionId ${sessionId} doesn't match previoud: ${state.sessionId}`);
        dispatch({
            type: "pairingVerified",
            sessionId: sessionId,
            trainerId: trainerId
        });
    }, [
        state.trainerId,
        state.sessionId
    ]);
    const promptToPair = $bh6RR.useCallback((autoCalibrate = false)=>{
        (0, $1lMle.default).info(`[pairing:promptToPair] Auto-calibrate ${autoCalibrate ? "yes" : "no"}`);
        dispatch({
            type: "promptToPair",
            autoCalibrate: autoCalibrate
        });
    }, []);
    const registerSession = $bh6RR.useCallback((trainerId, sessionId)=>{
        dispatch({
            type: "sessionDetected",
            trainerId: trainerId,
            sessionId: sessionId
        });
    }, []);
    const unpair = $bh6RR.useCallback(()=>{
        (0, $1lMle.default).info("[pairing:unpaired] Resetting pairing state to 'unpaired'");
        dispatch({
            type: "unpair"
        });
    }, []);
    const value = $bh6RR.useMemo(()=>({
            ...state,
            pairingCancelled: pairingCancelled,
            pairingVerified: pairingVerified,
            promptToPair: promptToPair,
            unpair: unpair
        }), [
        state,
        pairingCancelled,
        pairingVerified,
        promptToPair,
        unpair
    ]);
    $bh6RR.useEffect(()=>{
        if (authState === (0, $W4f7l.AuthState).AUTHENTICATED && state.status === "unknown" && !checking) {
            setChecking(true);
            (0, $1lMle.default).info("[pairing:checkForSession] - performing check");
            (0, $1ETlN.checkForSession)().then((session)=>{
                if (session) {
                    (0, $1lMle.default).info("[pairing:checkForSession] Found session, attempting to validate and redirect");
                    const { trainerId: trainerId, sessionId: sessionId } = session;
                    registerSession(trainerId, sessionId);
                } else unpair();
            }).catch((e)=>{
                (0, $cK0UE.logFetchError)(e, "[pairing:checkForSession] - failed check for session");
                unpair();
            }).finally(()=>setChecking(false));
        }
    }, [
        authState,
        checking,
        state.status,
        registerSession,
        unpair
    ]);
    $bh6RR.useEffect(()=>{
        async function closeSession() {
            if (state.sessionId) {
                (0, $1lMle.default).info(`Attempting to close session ${state.sessionId} due to status change.`);
                await (0, $cK0UE.default)(`/api/sessions/${state.sessionId}/close`, "PUT");
            }
        }
        if (state.status === "unpaired") {
            (0, $1lMle.default).info("[pairing:statusChangedHook - Pairing state changed to 'unpaired'");
            closeSession().catch((e)=>(0, $cK0UE.logFetchError)(e));
        }
    }, [
        state.sessionId,
        state.status
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($e9090818e08d89a2$export$e1ef1bacf1645cc4.Provider, {
        value: value,
        children: children
    });
});
$e9090818e08d89a2$export$ec598cbcb6391e8f.displayName = "PairingProvider";
function $e9090818e08d89a2$export$dd23975923240066() {
    return $bh6RR.useContext($e9090818e08d89a2$export$e1ef1bacf1645cc4);
}

});
parcelRegister("1ETlN", function(module, exports) {

$parcel$export(module.exports, "checkForSession", function () { return $b75307a52549a631$export$4569e5113570f99e; });
parcelRequire("cFAEN");
var $cK0UE = parcelRequire("cK0UE");
async function $b75307a52549a631$export$4569e5113570f99e() {
    const sessions = await (0, $cK0UE.default)("/api/sessions/me?state=active&limit=1&offset=0");
    const sessionMaybe = sessions.result[0];
    if (!sessionMaybe) return null;
    const tId = sessionMaybe.sessionTrainers[0].trainerId;
    const t = await (0, $cK0UE.default)(`/api/trainers/${tId}`);
    return {
        trainerId: t.clientId,
        sessionId: sessionMaybe.id
    };
}

});

parcelRegister("awHpO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $938257f1d2476ff0$export$2e2bcd8739ae039; });
const $938257f1d2476ff0$var$VOLLEY_USER_FILTER = "volley-user-filter";
const $938257f1d2476ff0$var$VOLLEY_USER_SEARCH = "volley-user-search";
function $938257f1d2476ff0$var$generateKey(base, key) {
    return `${base}-${key}`;
}
/*
    App filter presets that have since gained apps (AppFilterDrawer): a
    filter saved as the old set is read back as the new one, so it still
    shows as chosen and still lists the added apps. Skill Building gained
    the lacrosse Module (18); the AI apps the lacrosse zone drills (19).
*/ const $938257f1d2476ff0$var$WIDENED_APP_IDS = [
    [
        [
            11
        ],
        [
            11,
            18
        ]
    ],
    [
        [
            8,
            10,
            15
        ],
        [
            8,
            10,
            15,
            19
        ]
    ]
];
function $938257f1d2476ff0$var$widenAppIds(appId) {
    if (!appId) return appId;
    const was = [
        ...appId
    ].sort((a, b)=>a - b).join(",");
    return $938257f1d2476ff0$var$WIDENED_APP_IDS.find(([old])=>old.join(",") === was)?.[1] ?? appId;
}
function $938257f1d2476ff0$var$migrateFilter(parsed) {
    // Check if this is a legacy filter with includeCommunityContent
    if ("includeCommunityContent" in parsed && !("contentMode" in parsed)) {
        const legacy = parsed;
        return {
            tagIds: legacy.tagIds,
            contentMode: legacy.includeCommunityContent ? "mixed" : "volleyOnly",
            position: legacy.position,
            appId: $938257f1d2476ff0$var$widenAppIds(legacy.appId),
            providerIds: legacy.providerIds,
            excludeProviderIds: []
        };
    }
    // Ensure excludeProviderIds exists
    const filter = parsed;
    if (!filter.excludeProviderIds) filter.excludeProviderIds = [];
    filter.appId = $938257f1d2476ff0$var$widenAppIds(filter.appId);
    return filter;
}
const $938257f1d2476ff0$var$FilterState = {
    getFilter: (key)=>{
        const objectMaybe = sessionStorage.getItem($938257f1d2476ff0$var$generateKey($938257f1d2476ff0$var$VOLLEY_USER_FILTER, key));
        if (objectMaybe) {
            const parsed = JSON.parse(objectMaybe);
            return $938257f1d2476ff0$var$migrateFilter(parsed);
        }
        return null;
    },
    setFilter: (key, filter)=>{
        const value = JSON.stringify(filter);
        sessionStorage.setItem($938257f1d2476ff0$var$generateKey($938257f1d2476ff0$var$VOLLEY_USER_FILTER, key), value);
    },
    clearFilter: (key)=>{
        if (key) sessionStorage.removeItem($938257f1d2476ff0$var$generateKey($938257f1d2476ff0$var$VOLLEY_USER_FILTER, key));
        else for(let i = 0; i < sessionStorage.length; i += 1){
            const keyMaybe = sessionStorage.key(i);
            if (keyMaybe && keyMaybe.startsWith($938257f1d2476ff0$var$VOLLEY_USER_FILTER)) sessionStorage.removeItem(keyMaybe);
        }
    },
    getSearch: (key)=>sessionStorage.getItem($938257f1d2476ff0$var$generateKey($938257f1d2476ff0$var$VOLLEY_USER_SEARCH, key)),
    setSearch: (key, search)=>{
        sessionStorage.setItem($938257f1d2476ff0$var$generateKey($938257f1d2476ff0$var$VOLLEY_USER_SEARCH, key), search);
    },
    clearSearch: (key)=>{
        if (key) sessionStorage.removeItem($938257f1d2476ff0$var$generateKey($938257f1d2476ff0$var$VOLLEY_USER_SEARCH, key));
        else for(let i = 0; i < sessionStorage.length; i += 1){
            const keyMaybe = sessionStorage.key(i);
            if (keyMaybe && keyMaybe.startsWith($938257f1d2476ff0$var$VOLLEY_USER_SEARCH)) sessionStorage.removeItem(keyMaybe);
        }
    }
};
var $938257f1d2476ff0$export$2e2bcd8739ae039 = $938257f1d2476ff0$var$FilterState;

});

parcelRegister("1xith", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $166890ba73cf89c8$export$2e2bcd8739ae039; });
const $166890ba73cf89c8$var$VOLLEY_LATEST_POSITION = "volley-latest-position";
const $166890ba73cf89c8$var$LatestPositionState = {
    getPosition: ()=>{
        const objectMaybe = sessionStorage.getItem($166890ba73cf89c8$var$VOLLEY_LATEST_POSITION);
        if (objectMaybe) return JSON.parse(objectMaybe);
        return null;
    },
    setPosition: (position)=>{
        const value = JSON.stringify(position);
        sessionStorage.setItem($166890ba73cf89c8$var$VOLLEY_LATEST_POSITION, value);
    },
    clearPosition: ()=>{
        sessionStorage.removeItem($166890ba73cf89c8$var$VOLLEY_LATEST_POSITION);
    }
};
var $166890ba73cf89c8$export$2e2bcd8739ae039 = $166890ba73cf89c8$var$LatestPositionState;

});


parcelRegister("ezs3H", function(module, exports) {

$parcel$export(module.exports, "RAPID_POLL", function () { return $6fa4352047978cbe$export$1d7c83cb437a010d; });
$parcel$export(module.exports, "StatusProvider", function () { return $6fa4352047978cbe$export$20bfcca5268239b4; });
$parcel$export(module.exports, "useStatus", function () { return $6fa4352047978cbe$export$53cc6abb6942ce72; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $1lMle = parcelRequire("1lMle");

var $cK0UE = parcelRequire("cK0UE");

var $5MeqM = parcelRequire("5MeqM");

var $1ETlN = parcelRequire("1ETlN");

var $W4f7l = parcelRequire("W4f7l");

var $4xl3n = parcelRequire("4xl3n");

var $1aFku = parcelRequire("1aFku");
const $6fa4352047978cbe$export$1d7c83cb437a010d = 1000;
const $6fa4352047978cbe$export$9f7581eb07f3c340 = /*#__PURE__*/ $bh6RR.createContext({
    status: null,
    error: null,
    networkStateCode: "Connecting",
    hasFault: false,
    removeRapidPollCheck: ()=>null,
    startRapidPoll: ()=>null
});
const $6fa4352047978cbe$export$c599b4bd137d4418 = "Check to make sure the trainer is powered on and connected to the internet.";
const $6fa4352047978cbe$export$5f0665813912d864 = "We ran into an issue and need to restart your session.";
const $6fa4352047978cbe$var$REESTABLISHING_THRESHOLD = 15000;
const $6fa4352047978cbe$var$DOWN_THRESHOLD = 30000;
const $6fa4352047978cbe$var$POLLING_RATE = 5000;
const $6fa4352047978cbe$var$TIMEOUT = 5000;
const $6fa4352047978cbe$var$RETRY_KEY = "status hook";
const $6fa4352047978cbe$export$20bfcca5268239b4 = /*#__PURE__*/ $bh6RR.memo(({ children: children })=>{
    const { pathname: pathname } = (0, $as544.useLocation)();
    const { status: pairingStatus, sessionId: sessionId, trainerId: trainerId, pairingCancelled: pairingCancelled, pairingVerified: pairingVerified, unpair: unpair } = (0, $4xl3n.usePairingContext)();
    const { currentUser: currentUser } = (0, $W4f7l.useCurrentUser)();
    const [status, setStatus] = $bh6RR.useState(null);
    const [rapidPollInterval, setRapidPollInterval] = $bh6RR.useState(null);
    const [error, setError] = $bh6RR.useState(null);
    const lastRequest = $bh6RR.useRef(performance.now());
    const lastSuccess = $bh6RR.useRef(performance.now());
    const hidden = $bh6RR.useRef(false);
    const gap = lastRequest.current - lastSuccess.current;
    const hasStatus = $bh6RR.useMemo(()=>!!status, [
        status
    ]);
    const isFetching = $bh6RR.useRef(false);
    const [predicates, setPredicates] = $bh6RR.useState(new Map());
    $bh6RR.useEffect(()=>{
        (0, $5MeqM.registerRetry)($6fa4352047978cbe$var$RETRY_KEY);
        return ()=>(0, $5MeqM.cancelRetry)($6fa4352047978cbe$var$RETRY_KEY);
    }, []);
    const networkStateCode = $bh6RR.useMemo(()=>{
        if (!hasStatus) {
            if (error?.type === "TrainerOffline") return "TrainerOffline";
            if (error?.type === "Authorization") return "NotAuthorized";
            if (gap > $6fa4352047978cbe$var$DOWN_THRESHOLD) {
                (0, $1lMle.default).warn('Setting network state to "ServiceConnectionDown"', {
                    gap: gap,
                    hasStatus: hasStatus
                });
                return "ServiceConnectionDown";
            }
            return "Connecting";
        }
        if (error && error.type !== "TrainerOffline") {
            (0, $1lMle.default).warn('Setting network state to "Unknown"', {
                gap: gap,
                hasStatus: hasStatus
            });
            return "Unknown";
        }
        if (gap > $6fa4352047978cbe$var$DOWN_THRESHOLD) {
            if (error?.type === "TrainerOffline") {
                (0, $1lMle.default).warn('Setting network state to "TrainerOffline"', {
                    gap: gap,
                    hasStatus: hasStatus
                });
                return "TrainerConnectionDown";
            }
            (0, $1lMle.default).warn('Setting network state to "ServiceConnectionDown"', {
                gap: gap,
                hasStatus: hasStatus
            });
            return "ServiceConnectionDown";
        }
        if (gap > $6fa4352047978cbe$var$REESTABLISHING_THRESHOLD) {
            (0, $1lMle.default).warn('Setting network state to "ConnectionReestablishing"', {
                gap: gap,
                hasStatus: hasStatus
            });
            return "ConnectionReestablishing";
        }
        return "Connected";
    }, [
        hasStatus,
        error,
        gap
    ]);
    const hasFault = $bh6RR.useMemo(()=>{
        if (!status || !status.fault) return false;
        return !status.fault.failures.every((f)=>f.source === "vision");
    }, [
        status
    ]);
    const fetchStatus = $bh6RR.useCallback(async (allowRetry = false)=>{
        if (isFetching.current || hidden.current) return;
        isFetching.current = true;
        try {
            lastRequest.current = performance.now();
            const statusResponse = await (0, $cK0UE.pairedFetchApi)(trainerId, "/api/status", "GET", undefined, {
                signal: typeof AbortSignal?.timeout !== "undefined" ? AbortSignal.timeout($6fa4352047978cbe$var$TIMEOUT) : undefined
            });
            setError(null);
            setStatus({
                ...statusResponse,
                timestamp: new Date(statusResponse.timestamp)
            });
            lastSuccess.current = performance.now();
            if (pairingStatus === "validating") {
                if (statusResponse.session !== null) {
                    (0, $1lMle.default).info("Status response had a session - verifying pairing");
                    pairingVerified(statusResponse.clientId, statusResponse.session.id);
                }
            }
            if (statusResponse.session === null) {
                (0, $1lMle.default).info(`Status response had no session - setting unpaired [${pathname}]`);
                pairingCancelled();
            }
            if (statusResponse.session?.users[0].id !== currentUser?.id) {
                (0, $1lMle.default).info("Status response user ID did not match logged in user's id");
                pairingCancelled();
            }
            if (rapidPollInterval) {
                if (predicates.size === 0) setRapidPollInterval(null);
                else {
                    const remaining = new Map();
                    predicates.forEach((p, k)=>{
                        const result = p(statusResponse);
                        if (!result) remaining.set(k, p);
                        else (0, $1lMle.default).debug(`rapid polling predicate ${k} was satisfied`);
                    });
                    setPredicates(remaining);
                    if (remaining.size === 0) {
                        (0, $1lMle.default).debug("No rapid polling predicates remain, stopping rapid polling");
                        setRapidPollInterval(null);
                    }
                }
            }
        } catch (e) {
            (0, $cK0UE.logFetchError)(e);
            if (e instanceof (0, $cK0UE.PairRequiredError)) {
                (0, $1lMle.default).warn("Attempted to fetch status without trainer ID");
                setError({
                    message: "No trainer id available",
                    type: "Unknown"
                });
            }
            if (e instanceof (0, $cK0UE.FetchError)) switch(e.statusCode){
                case 401:
                    setError({
                        message: $6fa4352047978cbe$export$5f0665813912d864,
                        type: "Authentication"
                    });
                    break;
                case 403:
                    (0, $1lMle.default).warn("fetchStatus: User not authorized to view session");
                    setError({
                        message: "You are not authorized to view this session",
                        type: "Authorization"
                    });
                    unpair();
                    break;
                case 404:
                case 504:
                    if (status?.ready === "SHUTDOWN") {
                        (0, $1lMle.default).info("Previous status indicates SHUTDOWN - unpairing and clearing error status");
                        setError(null);
                        unpair();
                    } else if (pairingStatus === "validating" && !allowRetry) {
                        (0, $1lMle.default).info("Trainer unreachable while attempting to validate session.");
                        setError(null);
                        setStatus(null);
                        unpair();
                    } else if (!allowRetry) {
                        (0, $1lMle.default).info("fetchStatus: Trainer offline while trying to fetch status", {
                            responseStatus: e.statusCode
                        });
                        setError({
                            message: $6fa4352047978cbe$export$c599b4bd137d4418,
                            type: "TrainerOffline"
                        });
                    }
                    break;
                default:
                    (0, $1lMle.default).error("fetchStatus: unexpected error fetching status from trainer", {
                        status: e.statusCode
                    });
                    setError({
                        message: `Unexpected error fetching status from the trainer, status code ${e.statusCode}`,
                        type: "Unknown"
                    });
                    break;
            }
        } finally{
            isFetching.current = false;
        }
    }, [
        currentUser,
        trainerId,
        pairingStatus,
        pathname,
        predicates,
        rapidPollInterval,
        status?.ready,
        pairingCancelled,
        pairingVerified,
        unpair
    ]);
    // if we're paired, set error to null because being unpaired can set an
    // unauthorized error, and we want that to reset when we're paired again
    $bh6RR.useEffect(()=>{
        if (pairingStatus === "paired") setError(null);
    }, [
        pairingStatus
    ]);
    // Fetch status on mount
    $bh6RR.useEffect(()=>{
        async function tryFetchStatus() {
            await (0, $5MeqM.retry)(async ()=>(0, $cK0UE.pairedFetchApi)(trainerId, "/api/status"), $6fa4352047978cbe$var$RETRY_KEY, 1000, 5);
        }
        if (pairingStatus === "validating" && trainerId && sessionId && isFetching.current === false) {
            (0, $1lMle.default).info(`Pairing status: ${pairingStatus} and trainer id set (${trainerId}) - fetching status`);
            tryFetchStatus().then(()=>pairingVerified(trainerId, sessionId)).catch((err)=>{
                // The provider unmounted and cancelled the retry key (see
                // the mount effect above); that is teardown, not a failure
                // worth surfacing.
                if ((0, $5MeqM.isRetryCancelled)(err)) return;
                setError({
                    message: "Could not fetch status",
                    type: "Unknown"
                });
                pairingCancelled();
            });
        }
    }, [
        pairingStatus,
        sessionId,
        trainerId,
        pairingCancelled,
        pairingVerified
    ]);
    $bh6RR.useEffect(()=>{
        const handleVisibilityChange = ()=>{
            // mark visibility state and reset timers so when we come back there
            // isn't a big gap
            (0, $1lMle.default).info("Browser visibility change", {
                hidden: document.hidden
            });
            hidden.current = document.hidden;
            lastSuccess.current = performance.now();
            lastRequest.current = performance.now();
            if (!document.hidden) {
                if (pairingStatus === "paired") {
                    (0, $1lMle.default).info("Browser visible and user is paired, attempting to fetch");
                    (0, $1ETlN.checkForSession)().then((session)=>{
                        if (session) {
                            const { trainerId: tId, sessionId: sId } = session;
                            pairingVerified(tId, sId);
                            const allowRetry = trainerId !== tId;
                            fetchStatus(allowRetry);
                        }
                    }).catch((err)=>{
                        (0, $cK0UE.logFetchError)(err, "Validating status on browser visibility change");
                    });
                } else (0, $1lMle.default).info("Browser visible but no session detected");
            }
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return ()=>{
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [
        fetchStatus,
        pairingVerified,
        pairingStatus,
        trainerId
    ]);
    (0, $1aFku.default)(()=>{
        fetchStatus().catch(()=>setError({
                message: "Could not fetch status",
                type: "Unknown"
            }));
    }, pairingStatus !== "paired" ? null : rapidPollInterval ?? $6fa4352047978cbe$var$POLLING_RATE, true);
    $bh6RR.useEffect(()=>{
        if (pairingStatus === "unpaired" && status !== null) {
            (0, $1lMle.default).info("Clearing status.");
            setStatus(null);
        }
    }, [
        pairingStatus,
        status
    ]);
    const startRapidPoll = $bh6RR.useCallback((interval, predicate, predicateKey)=>{
        (0, $1lMle.default).info(`Starting rapid polling for ${predicateKey ?? "unknown"} - ${interval}ms`);
        setRapidPollInterval(interval);
        if (predicate && predicateKey) setPredicates((prev)=>prev.set(predicateKey, predicate));
    }, []);
    const removeRapidPollCheck = $bh6RR.useCallback((key)=>{
        setPredicates((prev)=>{
            prev.delete(key);
            return prev;
        });
    }, []);
    const value = $bh6RR.useMemo(()=>({
            status: status,
            error: error,
            networkStateCode: networkStateCode,
            hasFault: hasFault,
            startRapidPoll: startRapidPoll,
            removeRapidPollCheck: removeRapidPollCheck
        }), [
        status,
        error,
        networkStateCode,
        hasFault,
        startRapidPoll,
        removeRapidPollCheck
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($6fa4352047978cbe$export$9f7581eb07f3c340.Provider, {
        value: value,
        children: children
    });
});
$6fa4352047978cbe$export$20bfcca5268239b4.displayName = "StatusProvider";
function $6fa4352047978cbe$export$53cc6abb6942ce72() {
    return $bh6RR.useContext($6fa4352047978cbe$export$9f7581eb07f3c340);
}

});
parcelRegister("5MeqM", function(module, exports) {

$parcel$export(module.exports, "isRetryCancelled", function () { return $9e0e80bf3e724721$export$841ba0447e73ef57; });
$parcel$export(module.exports, "registerRetry", function () { return $9e0e80bf3e724721$export$c7af88025a655818; });
$parcel$export(module.exports, "cancelRetry", function () { return $9e0e80bf3e724721$export$b5cbc5f015ab1159; });
$parcel$export(module.exports, "retry", function () { return $9e0e80bf3e724721$export$9369b12211e1fce4; });

var $1lMle = parcelRequire("1lMle");
const $9e0e80bf3e724721$var$requestMap = new Map();
class $9e0e80bf3e724721$export$98f20e7e270a7a2e extends Error {
    constructor(key){
        super(`Retry cancelled for ${key}`);
        this.name = "RetryCancelledError";
    }
}
const $9e0e80bf3e724721$export$841ba0447e73ef57 = (e)=>e instanceof $9e0e80bf3e724721$export$98f20e7e270a7a2e;
function $9e0e80bf3e724721$export$c7af88025a655818(key) {
    (0, $1lMle.default).info(`Attempting to register retry cancellation token: ${key}`);
    $9e0e80bf3e724721$var$requestMap.set(key, false);
    (0, $1lMle.default).info(`Registered retry cancellation token: ${key} successfully`);
}
function $9e0e80bf3e724721$export$b5cbc5f015ab1159(key) {
    (0, $1lMle.default).info(`Attempting to cancel retry ${key}`);
    $9e0e80bf3e724721$var$requestMap.set(key, true);
    (0, $1lMle.default).info(`Cancellation token set for ${key}`);
}
const $9e0e80bf3e724721$export$9369b12211e1fce4 = (fn, key, delay, retries, retryBreak)=>new Promise((resolve, reject)=>{
        const cancelled = !$9e0e80bf3e724721$var$requestMap.has(key) || $9e0e80bf3e724721$var$requestMap.get(key);
        if (cancelled) {
            (0, $1lMle.default).info(`Retry cancelled for ${key}: rejecting.`);
            // Returning without settling would leave every awaiting caller
            // hanging forever, with no way back short of a remount.
            reject(new $9e0e80bf3e724721$export$98f20e7e270a7a2e(key));
            return;
        }
        fn().then(resolve).catch((err)=>{
            if (retryBreak && retryBreak(err)) return reject(err);
            if (retries > 0) return new Promise((r)=>{
                setTimeout(r, delay);
            }).then($9e0e80bf3e724721$export$9369b12211e1fce4.bind(null, fn, key, delay, retries - 1, retryBreak))// eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            .then(resolve).catch(reject);
            return reject(err);
        });
    });

});

parcelRegister("1aFku", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afae9a830e3566c5$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
function $afae9a830e3566c5$export$2e2bcd8739ae039(cb, delay, immediate = false) {
    const savedCallback = $bh6RR.useRef(undefined);
    const [id, setId] = $bh6RR.useState();
    $bh6RR.useEffect(()=>{
        savedCallback.current = cb;
    }, [
        cb
    ]);
    $bh6RR.useEffect(()=>{
        function tick() {
            if (savedCallback.current) savedCallback.current();
        }
        if (delay !== null) {
            if (immediate) tick();
            const nextId = window.setInterval(tick, delay);
            setId(nextId);
            return ()=>clearInterval(nextId);
        }
    }, [
        delay,
        immediate
    ]);
    return id;
}

});



parcelRegister("1d1FK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e184d6f6d95f987$export$2e2bcd8739ae039; });

var $7UVcp = parcelRequire("7UVcp");


var $7tI36 = parcelRequire("7tI36");

var $c1Ell = parcelRequire("c1Ell");

var $2N3YN = parcelRequire("2N3YN");

var $7dAmR = parcelRequire("7dAmR");
'use client';
const $0e184d6f6d95f987$var$defaultTheme = (0, $c1Ell.default)();
const $0e184d6f6d95f987$var$Box = (0, $7UVcp.default)({
    themeId: (0, $2N3YN.default),
    defaultTheme: $0e184d6f6d95f987$var$defaultTheme,
    defaultClassName: (0, $7dAmR.default).root,
    generateClassName: (0, $7tI36.default).generate
});
var $0e184d6f6d95f987$export$2e2bcd8739ae039 = $0e184d6f6d95f987$var$Box;

});
parcelRegister("7UVcp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c3a21ed297e5c2c$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $aPsoC = parcelRequire("aPsoC");

var $byUDZ = parcelRequire("byUDZ");

var $f9NmP = parcelRequire("f9NmP");
var $gIHYf = parcelRequire("gIHYf");

var $5wgL8 = parcelRequire("5wgL8");

var $ih19M = parcelRequire("ih19M");
'use client';
function $5c3a21ed297e5c2c$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $byUDZ.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $f9NmP.default));
    const Box = /*#__PURE__*/ $bh6RR.forwardRef(function Box(inProps, ref) {
        const theme = (0, $5wgL8.default)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $gIHYf.default)(inProps);
        return /*#__PURE__*/ (0, $ih19M.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $aPsoC.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}

});

parcelRegister("7dAmR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5415f52cad1b1d56$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");
const $5415f52cad1b1d56$var$boxClasses = (0, $fYlYP.default)('MuiBox', [
    'root'
]);
var $5415f52cad1b1d56$export$2e2bcd8739ae039 = $5415f52cad1b1d56$var$boxClasses;

});


parcelRegister("bDIpx", function(module, exports) {

$parcel$export(module.exports, "IntercomProvider", function () { return $253171ed82815c8a$export$5091c5023e5c7eba; });
$parcel$export(module.exports, "default", function () { return $253171ed82815c8a$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $52nsO = parcelRequire("52nsO");

var $506bB = parcelRequire("506bB");

var $euyyI = parcelRequire("euyyI");

var $jdCKi = parcelRequire("jdCKi");

var $1lMle = parcelRequire("1lMle");
parcelRequire("cFAEN");
var $cK0UE = parcelRequire("cK0UE");

var $cK0UE = parcelRequire("cK0UE");

var $W4f7l = parcelRequire("W4f7l");
const $253171ed82815c8a$export$e578ca56db818a8e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    ready: false,
    unreadCount: 0,
    show: ()=>{},
    hide: ()=>{},
    logOut: ()=>{},
    newMessage: ()=>{},
    showConversation: ()=>{}
});
const $253171ed82815c8a$export$5091c5023e5c7eba = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(({ children: children })=>{
    const { authState: authState, currentUser: currentUser } = (0, $W4f7l.useCurrentUser)();
    const [ready, setReady] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [unavailable, setUnavailable] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [unreadCount, setUnreadCount] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0);
    const [alert, setAlert] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState({
        open: false,
        message: ""
    });
    const location = (0, $as544.useLocation)();
    const handleClose = (_, reason)=>{
        if (reason === "clickaway") return;
        setAlert({
            ...alert,
            open: false
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        async function fetchHMAC() {
            (0, $1lMle.default).info("[Intercom] Fetching HMAC to support widget signing");
            const response = await (0, $cK0UE.default)("/api/integrations/support-chat");
            (0, $1lMle.default).info("[Intercom] HMAC Fetch Succeeded");
            return response;
        }
        if (authState === (0, $W4f7l.AuthState).AUTHENTICATED && currentUser) {
            const { name: name } = (0, $jdCKi.default).intercom;
            (0, $1lMle.default).info(`[Intercom] Initializing for ${currentUser.username} (${name})`);
            fetchHMAC().then((chatInit)=>{
                if (!chatInit.hash) {
                    // Intercom rejects an unsigned user, so don't boot.
                    (0, $1lMle.default).info("[Intercom] Server has no identity-verification secret; support chat disabled");
                    setUnavailable(true);
                    return;
                }
                const { appId: appId } = (0, $jdCKi.default).intercom;
                (0, (/*@__PURE__*/$parcel$interopDefault($52nsO)))({
                    app_id: appId,
                    user_id: currentUser.id.toString(),
                    name: `${currentUser.firstName} ${currentUser.lastName}`,
                    email: currentUser.email,
                    hide_default_launcher: true,
                    user_hash: chatInit.hash,
                    volley_username: currentUser.username,
                    volley_phone: chatInit.volley_phone,
                    volley_home_location: chatInit.volley_home_location,
                    volley_self_described_home: chatInit.volley_self_described_home
                });
                (0, $52nsO.onShow)(()=>{
                    (0, $1lMle.default).info("[Intercom] Widget shown.");
                });
                (0, $52nsO.onUnreadCountChange)((count)=>{
                    (0, $1lMle.default).info(`[Intercom] unread count changed: ${count}`);
                    setUnreadCount(count);
                });
                setReady(true);
            }).catch((error)=>{
                (0, $cK0UE.logFetchError)(error, "[Intercom] Failed to fetch HMAC for support widget signing.");
            });
        }
    }, [
        authState,
        currentUser
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (ready && authState === (0, $W4f7l.AuthState).AUTHENTICATED && currentUser) {
            (0, $1lMle.default).info(`[Intercom] SPA route change to ${location.pathname} - calling update`);
            (0, $52nsO.update)({});
        }
    }, [
        ready,
        authState,
        currentUser,
        location.pathname
    ]);
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>{
        // Calling the SDK before boot only logs a console warning.
        const alertNotReady = ()=>setAlert({
                open: true,
                message: unavailable ? "Support chat is not available in this environment." : "Support chat is not ready yet."
            });
        return {
            ready: ready,
            unreadCount: unreadCount,
            show: ()=>{
                if (ready) {
                    (0, $1lMle.default).info("[Intercom] Showing widget");
                    (0, $52nsO.show)();
                } else alertNotReady();
            },
            hide: ()=>{
                if (ready) {
                    (0, $1lMle.default).info("[Intercom] Hiding widget");
                    (0, $52nsO.hide)();
                }
            },
            logOut: ()=>{
                if (ready) (0, $52nsO.shutdown)();
            },
            newMessage: (message)=>{
                if (ready) (0, $52nsO.showNewMessage)(message ?? "");
                else alertNotReady();
            },
            showConversation: (conversationId)=>{
                if (ready) {
                    (0, $1lMle.default).info(`[Intercom] Showing conversation ${conversationId}`);
                    (0, $52nsO.showConversation)(conversationId);
                } else alertNotReady();
            }
        };
    }, [
        ready,
        unavailable,
        unreadCount
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($253171ed82815c8a$export$e578ca56db818a8e.Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $euyyI.default), {
                open: alert.open,
                autoHideDuration: 3000,
                onClose: handleClose,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $506bB.default), {
                    onClose: handleClose,
                    severity: "warning",
                    variant: "filled",
                    sx: {
                        width: "100%"
                    },
                    children: alert.message
                })
            })
        ]
    });
});
$253171ed82815c8a$export$5091c5023e5c7eba.displayName = "IntercomProvider";
function $253171ed82815c8a$export$2e2bcd8739ae039() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($253171ed82815c8a$export$e578ca56db818a8e);
}

});
parcelRegister("52nsO", function(module, exports) {
"use strict";
var $3aaf570bbf99da76$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.onUserEmailSupplied = module.exports.showConversation = module.exports.showTicket = module.exports.startChecklist = module.exports.startSurvey = module.exports.showNews = module.exports.showArticle = module.exports.startTour = module.exports.getVisitorId = module.exports.trackEvent = module.exports.onUnreadCountChange = module.exports.onShow = module.exports.onHide = module.exports.showNewMessage = module.exports.showMessages = module.exports.showSpace = module.exports.show = module.exports.hide = module.exports.update = module.exports.shutdown = module.exports.boot = module.exports.Intercom = void 0;

var $24pjC = parcelRequire("24pjC");

var $eHTQZ = parcelRequire("eHTQZ");
const $3aaf570bbf99da76$var$callIntercomMethod = (method, ...args)=>{
    // window is undefined on server-side and this breaks our widget
    if (window.Intercom) window.Intercom(method, ...args);
    else console.warn("Please ensure Intercom is setup and running on client-side!");
};
const $3aaf570bbf99da76$var$Intercom = (props)=>{
    if (typeof props !== "object") {
        console.warn("Intercom initialiser called with invalid parameters.");
        return;
    }
    const { region: region = "us" } = props, args = $3aaf570bbf99da76$var$__rest(props, [
        "region"
    ]);
    if (typeof window !== "undefined" && !$eHTQZ.ref) {
        window.intercomSettings = Object.assign(Object.assign({}, args), {
            api_base: $24pjC.regionAPIs.get(region)
        });
        (0, $eHTQZ.init)();
    }
};
module.exports.Intercom = $3aaf570bbf99da76$var$Intercom;
// Public functions that can be called from outside the module
module.exports.default = module.exports.Intercom;
const $3aaf570bbf99da76$var$boot = (arg)=>$3aaf570bbf99da76$var$callIntercomMethod("boot", arg);
module.exports.boot = $3aaf570bbf99da76$var$boot;
const $3aaf570bbf99da76$var$shutdown = ()=>$3aaf570bbf99da76$var$callIntercomMethod("shutdown");
module.exports.shutdown = $3aaf570bbf99da76$var$shutdown;
const $3aaf570bbf99da76$var$update = (arg)=>$3aaf570bbf99da76$var$callIntercomMethod("update", arg);
module.exports.update = $3aaf570bbf99da76$var$update;
const $3aaf570bbf99da76$var$hide = ()=>$3aaf570bbf99da76$var$callIntercomMethod("hide");
module.exports.hide = $3aaf570bbf99da76$var$hide;
const $3aaf570bbf99da76$var$show = ()=>$3aaf570bbf99da76$var$callIntercomMethod("show");
module.exports.show = $3aaf570bbf99da76$var$show;
const $3aaf570bbf99da76$var$showSpace = (spaceName)=>$3aaf570bbf99da76$var$callIntercomMethod("showSpace", spaceName);
module.exports.showSpace = $3aaf570bbf99da76$var$showSpace;
const $3aaf570bbf99da76$var$showMessages = ()=>$3aaf570bbf99da76$var$callIntercomMethod("showMessages");
module.exports.showMessages = $3aaf570bbf99da76$var$showMessages;
const $3aaf570bbf99da76$var$showNewMessage = (prePopulatedContent)=>$3aaf570bbf99da76$var$callIntercomMethod("showNewMessage", prePopulatedContent);
module.exports.showNewMessage = $3aaf570bbf99da76$var$showNewMessage;
const $3aaf570bbf99da76$var$onHide = (callback)=>$3aaf570bbf99da76$var$callIntercomMethod("onHide", callback);
module.exports.onHide = $3aaf570bbf99da76$var$onHide;
const $3aaf570bbf99da76$var$onShow = (callback)=>$3aaf570bbf99da76$var$callIntercomMethod("onShow", callback);
module.exports.onShow = $3aaf570bbf99da76$var$onShow;
const $3aaf570bbf99da76$var$onUnreadCountChange = (callback)=>$3aaf570bbf99da76$var$callIntercomMethod("onUnreadCountChange", callback);
module.exports.onUnreadCountChange = $3aaf570bbf99da76$var$onUnreadCountChange;
const $3aaf570bbf99da76$var$trackEvent = (...args)=>$3aaf570bbf99da76$var$callIntercomMethod("trackEvent", ...args);
module.exports.trackEvent = $3aaf570bbf99da76$var$trackEvent;
const $3aaf570bbf99da76$var$getVisitorId = ()=>$3aaf570bbf99da76$var$callIntercomMethod("getVisitorId");
module.exports.getVisitorId = $3aaf570bbf99da76$var$getVisitorId;
const $3aaf570bbf99da76$var$startTour = (tourId)=>$3aaf570bbf99da76$var$callIntercomMethod("startTour", tourId);
module.exports.startTour = $3aaf570bbf99da76$var$startTour;
const $3aaf570bbf99da76$var$showArticle = (articleId)=>$3aaf570bbf99da76$var$callIntercomMethod("showArticle", articleId);
module.exports.showArticle = $3aaf570bbf99da76$var$showArticle;
const $3aaf570bbf99da76$var$showNews = (newsItemId)=>$3aaf570bbf99da76$var$callIntercomMethod("showNews", newsItemId);
module.exports.showNews = $3aaf570bbf99da76$var$showNews;
const $3aaf570bbf99da76$var$startSurvey = (surveyId)=>$3aaf570bbf99da76$var$callIntercomMethod("startSurvey", surveyId);
module.exports.startSurvey = $3aaf570bbf99da76$var$startSurvey;
const $3aaf570bbf99da76$var$startChecklist = (checklistId)=>$3aaf570bbf99da76$var$callIntercomMethod("startChecklist", checklistId);
module.exports.startChecklist = $3aaf570bbf99da76$var$startChecklist;
const $3aaf570bbf99da76$var$showTicket = (ticketId)=>$3aaf570bbf99da76$var$callIntercomMethod("showTicket", ticketId);
module.exports.showTicket = $3aaf570bbf99da76$var$showTicket;
const $3aaf570bbf99da76$var$showConversation = (conversationId)=>$3aaf570bbf99da76$var$callIntercomMethod("showConversation", conversationId);
module.exports.showConversation = $3aaf570bbf99da76$var$showConversation;
const $3aaf570bbf99da76$var$onUserEmailSupplied = (callback)=>$3aaf570bbf99da76$var$callIntercomMethod("onUserEmailSupplied", callback);
module.exports.onUserEmailSupplied = $3aaf570bbf99da76$var$onUserEmailSupplied;

});
parcelRegister("24pjC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.regionAPIs = void 0;
module.exports.regionAPIs = new Map([
    [
        "us",
        "https://api-iam.intercom.io"
    ],
    [
        "eu",
        "https://api-iam.eu.intercom.io"
    ],
    [
        "ap",
        "https://api-iam.au.intercom.io"
    ]
]);

});

parcelRegister("eHTQZ", function(module, exports) {
"use strict";
var $ab506835de4cf911$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ref = module.exports.init = void 0;
const $ab506835de4cf911$var$scriptElementId = "_intercom_npm_loader";
// This holds a queue of commands to be passed to the messenger widget API after it is added to the page
const $ab506835de4cf911$var$queueHolder = function() {
    $ab506835de4cf911$var$queueHolder.loaderQueue(arguments);
};
$ab506835de4cf911$var$queueHolder.q = [];
$ab506835de4cf911$var$queueHolder.loaderQueue = function(args) {
    $ab506835de4cf911$var$queueHolder.q.push(args);
};
const $ab506835de4cf911$var$addWidgetToPage = function() {
    var _a, _b;
    var d = document;
    if (d.getElementById($ab506835de4cf911$var$scriptElementId)) // script is already in DOM
    return;
    var s = d.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.id = $ab506835de4cf911$var$scriptElementId;
    s.src = "https://widget.intercom.io/widget/" + ((_a = window.intercomSettings) === null || _a === void 0 ? void 0 : _a.app_id);
    var x = d.getElementsByTagName("script")[0];
    (_b = x.parentNode) === null || _b === void 0 || _b.insertBefore(s, x);
};
const $ab506835de4cf911$var$isDocumentReady = ()=>document.readyState === "complete" || document.readyState === "interactive";
const $ab506835de4cf911$var$init = ()=>$ab506835de4cf911$var$__awaiter(void 0, void 0, void 0, function*() {
        var w = window;
        var ic = w.Intercom;
        if (w.intercomSettings) w.intercomSettings.installation_type = "npm-package";
        if (typeof ic === "function") {
            ic("reattach_activator");
            ic("update", w.intercomSettings);
        } else {
            w.Intercom = $ab506835de4cf911$var$queueHolder;
            if ($ab506835de4cf911$var$isDocumentReady()) $ab506835de4cf911$var$addWidgetToPage();
            else {
                document.addEventListener("readystatechange", function() {
                    if ($ab506835de4cf911$var$isDocumentReady()) $ab506835de4cf911$var$addWidgetToPage();
                });
                if (w.attachEvent) w.attachEvent("onload", $ab506835de4cf911$var$addWidgetToPage);
                else w.addEventListener("load", $ab506835de4cf911$var$addWidgetToPage, false);
            }
        }
    });
module.exports.init = $ab506835de4cf911$var$init;
module.exports.ref = undefined;

});



parcelRegister("8JNI1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65c915dde443e8f9$export$2e2bcd8739ae039; });


var $aRCSC = parcelRequire("aRCSC");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");
'use client';
const $65c915dde443e8f9$var$Stack = (0, $aRCSC.default)({
    createStyledComponent: (0, $l0oRz.default)('div', {
        name: 'MuiStack',
        slot: 'Root'
    }),
    useThemeProps: (inProps)=>(0, $OEXBZ.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $65c915dde443e8f9$export$2e2bcd8739ae039 = $65c915dde443e8f9$var$Stack;

});
parcelRegister("aRCSC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e8d036039a387ac$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $5syur = parcelRequire("5syur");

var $dmzXD = parcelRequire("dmzXD");

var $96ZcP = parcelRequire("96ZcP");

var $kleHe = parcelRequire("kleHe");

var $2DXvq = parcelRequire("2DXvq");

var $gIHYf = parcelRequire("gIHYf");

var $1zcRx = parcelRequire("1zcRx");

var $grZ4X = parcelRequire("grZ4X");

var $l0eT8 = parcelRequire("l0eT8");

var $ih19M = parcelRequire("ih19M");
'use client';
const $7e8d036039a387ac$var$defaultTheme = (0, $1zcRx.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $7e8d036039a387ac$var$defaultCreateStyledComponent = (0, $kleHe.default)('div', {
    name: 'MuiStack',
    slot: 'Root'
});
function $7e8d036039a387ac$var$useThemePropsDefault(props) {
    return (0, $2DXvq.default)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $7e8d036039a387ac$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $7e8d036039a387ac$var$joinChildren(children, separator) {
    const childrenArray = $bh6RR.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $bh6RR.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $7e8d036039a387ac$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $7e8d036039a387ac$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, $grZ4X.handleBreakpoints)({
            theme: theme
        }, (0, $grZ4X.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, $l0eT8.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $grZ4X.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $grZ4X.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $l0eT8.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$7e8d036039a387ac$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $l0eT8.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $5syur.default)(styles, (0, $grZ4X.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $grZ4X.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $7e8d036039a387ac$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $7e8d036039a387ac$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $7e8d036039a387ac$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $96ZcP.default)(slots, (slot)=>(0, $dmzXD.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($7e8d036039a387ac$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $bh6RR.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $gIHYf.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false, ...other } = props;
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ih19M.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $aPsoC.default)(classes.root, className),
            ...other,
            children: divider ? $7e8d036039a387ac$var$joinChildren(children, divider) : children
        });
    });
    return Stack;
}

});
parcelRegister("kleHe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecf12b35451e688c$export$2e2bcd8739ae039; });

var $6g8tU = parcelRequire("6g8tU");
const $ecf12b35451e688c$var$styled = (0, $6g8tU.default)();
var $ecf12b35451e688c$export$2e2bcd8739ae039 = $ecf12b35451e688c$var$styled;

});

parcelRegister("2DXvq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ecd61e8c633a3b4$export$2e2bcd8739ae039; });

var $lGIi0 = parcelRequire("lGIi0");

var $5wgL8 = parcelRequire("5wgL8");
'use client';
function $1ecd61e8c633a3b4$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $5wgL8.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $lGIi0.default)({
        theme: theme,
        name: name,
        props: props
    });
}

});
parcelRegister("lGIi0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc9fe0280c7e2b01$export$2e2bcd8739ae039; });

var $e0O1m = parcelRequire("e0O1m");
function $fc9fe0280c7e2b01$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $e0O1m.default)(theme.components[name].defaultProps, props);
}

});




parcelRegister("cbFbS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8df676b3e3d66186$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $blGXB = parcelRequire("blGXB");
var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $krx4P = parcelRequire("krx4P");

var $4B5Or = parcelRequire("4B5Or");

var $c33n3 = parcelRequire("c33n3");

var $ih19M = parcelRequire("ih19M");
'use client';
const $8df676b3e3d66186$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $8df676b3e3d66186$var$extendSxProp = (0, $blGXB.internal_createExtendSxProp)();
const $8df676b3e3d66186$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $krx4P.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $c33n3.getTypographyUtilityClass), classes);
};
const $8df676b3e3d66186$export$140e2f5526d3cad8 = (0, $l0oRz.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $krx4P.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $krx4P.default)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $8df676b3e3d66186$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $8df676b3e3d66186$var$Typography = /*#__PURE__*/ $bh6RR.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$8df676b3e3d66186$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $8df676b3e3d66186$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $8df676b3e3d66186$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $8df676b3e3d66186$var$defaultVariantMapping[variant]) || 'span';
    const classes = $8df676b3e3d66186$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($8df676b3e3d66186$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $aPsoC.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $8df676b3e3d66186$export$2e2bcd8739ae039 = $8df676b3e3d66186$var$Typography;

});
parcelRegister("c33n3", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", function () { return $8c5861372bc3b8c3$export$24c1f8f60cbac79e; });
$parcel$export(module.exports, "default", function () { return $8c5861372bc3b8c3$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $8c5861372bc3b8c3$export$24c1f8f60cbac79e(slot) {
    return (0, $dmzXD.default)('MuiTypography', slot);
}
const $8c5861372bc3b8c3$var$typographyClasses = (0, $fYlYP.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $8c5861372bc3b8c3$export$2e2bcd8739ae039 = $8c5861372bc3b8c3$var$typographyClasses;

});


parcelRegister("aSMrn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ec485cffb079177$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $7ec485cffb079177$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z"
}), 'Refresh');

});

parcelRegister("bZrpr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8baaa7262145e546$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $8baaa7262145e546$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "m19 9 1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25z"
}), 'AutoAwesome');

});

parcelRegister("5Jk4T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42c0bac5215ea471$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $42c0bac5215ea471$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), 'ArrowForward');

});

parcelRegister("gYkLQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5b25c8aa290ba1a$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $c5b25c8aa290ba1a$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    fillRule: "evenodd",
    d: "M3 3v8h8V3zm6 6H5V5h4zm-6 4v8h8v-8zm6 6H5v-4h4zm4-16v8h8V3zm6 6h-4V5h4zm-6 4v8h8v-8zm6 6h-4v-4h4z"
}), 'GridView');

});

parcelRegister("eedE5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5bcf533d69321e6$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $e0O1m = parcelRequire("e0O1m");

var $96ZcP = parcelRequire("96ZcP");

var $2STLv = parcelRequire("2STLv");

var $b6vKX = parcelRequire("b6vKX");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $fbTZq = parcelRequire("fbTZq");

var $5CVHy = parcelRequire("5CVHy");

var $krx4P = parcelRequire("krx4P");

var $4B5Or = parcelRequire("4B5Or");

var $4KLtn = parcelRequire("4KLtn");

var $fo047 = parcelRequire("fo047");

var $2NVcI = parcelRequire("2NVcI");

var $ih19M = parcelRequire("ih19M");
'use client';
const $a5bcf533d69321e6$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $krx4P.default)(color)}`,
            `size${(0, $krx4P.default)(size)}`,
            `${variant}Size${(0, $krx4P.default)(size)}`,
            `color${(0, $krx4P.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $krx4P.default)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $krx4P.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $krx4P.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $4KLtn.getButtonUtilityClass), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $a5bcf533d69321e6$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $a5bcf533d69321e6$var$ButtonRoot = (0, $l0oRz.default)((0, $fbTZq.default), {
    shouldForwardProp: (prop)=>(0, $b6vKX.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $krx4P.default)(ownerState.color)}`],
            styles[`size${(0, $krx4P.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $krx4P.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $4KLtn.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $4KLtn.default).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $4KLtn.default).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $4KLtn.default).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.alpha((theme.vars || theme).palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $4KLtn.default).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $4KLtn.default).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $4KLtn.default).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $a5bcf533d69321e6$var$ButtonStartIcon = (0, $l0oRz.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $krx4P.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$a5bcf533d69321e6$var$commonIconStyles
        ]
    }));
const $a5bcf533d69321e6$var$ButtonEndIcon = (0, $l0oRz.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $krx4P.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$a5bcf533d69321e6$var$commonIconStyles
        ]
    }));
const $a5bcf533d69321e6$var$ButtonLoadingIndicator = (0, $l0oRz.default)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $a5bcf533d69321e6$var$ButtonLoadingIconPlaceholder = (0, $l0oRz.default)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder'
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $a5bcf533d69321e6$var$Button = /*#__PURE__*/ $bh6RR.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $bh6RR.useContext((0, $fo047.default));
    const buttonGroupButtonContextPositionClassName = $bh6RR.useContext((0, $2NVcI.default));
    const resolvedProps = (0, $e0O1m.default)(contextProps, inProps);
    const props = (0, $OEXBZ.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $2STLv.default)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $a5bcf533d69321e6$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $ih19M.jsx)($a5bcf533d69321e6$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $ih19M.jsx)($a5bcf533d69321e6$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $ih19M.jsx)($a5bcf533d69321e6$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $ih19M.jsx)($a5bcf533d69321e6$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $ih19M.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $ih19M.jsx)($a5bcf533d69321e6$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, $ih19M.jsxs)($a5bcf533d69321e6$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $aPsoC.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $aPsoC.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $a5bcf533d69321e6$export$2e2bcd8739ae039 = $a5bcf533d69321e6$var$Button;

});
parcelRegister("4KLtn", function(module, exports) {

$parcel$export(module.exports, "getButtonUtilityClass", function () { return $3760486d860d1501$export$5a6f9035944c8119; });
$parcel$export(module.exports, "default", function () { return $3760486d860d1501$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $3760486d860d1501$export$5a6f9035944c8119(slot) {
    return (0, $dmzXD.default)('MuiButton', slot);
}
const $3760486d860d1501$var$buttonClasses = (0, $fYlYP.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $3760486d860d1501$export$2e2bcd8739ae039 = $3760486d860d1501$var$buttonClasses;

});

parcelRegister("fo047", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b33925e20a58929a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
/**
 * @ignore - internal component.
 */ const $b33925e20a58929a$var$ButtonGroupContext = /*#__PURE__*/ $bh6RR.createContext({});
var $b33925e20a58929a$export$2e2bcd8739ae039 = $b33925e20a58929a$var$ButtonGroupContext;

});

parcelRegister("2NVcI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20ac87e683c51cbf$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
/**
 * @ignore - internal component.
 */ const $20ac87e683c51cbf$var$ButtonGroupButtonContext = /*#__PURE__*/ $bh6RR.createContext(undefined);
var $20ac87e683c51cbf$export$2e2bcd8739ae039 = $20ac87e683c51cbf$var$ButtonGroupButtonContext;

});


parcelRegister("95FNu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69e500bfbcfc581a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $i624W = parcelRequire("i624W");

var $dg012 = parcelRequire("dg012");


var $krx4P = parcelRequire("krx4P");

var $fbTZq = parcelRequire("fbTZq");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $4B5Or = parcelRequire("4B5Or");

var $OEXBZ = parcelRequire("OEXBZ");

var $2bwY3 = parcelRequire("2bwY3");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
const $69e500bfbcfc581a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $krx4P.default)(size)}`,
            `color${(0, $krx4P.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $krx4P.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $krx4P.default)(color)}`,
            `${variant}${(0, $krx4P.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $krx4P.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $krx4P.default)(size)}`,
            `avatarColor${(0, $krx4P.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $krx4P.default)(size)}`,
            `iconColor${(0, $krx4P.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $krx4P.default)(size)}`,
            `deleteIconColor${(0, $krx4P.default)(color)}`,
            `deleteIcon${(0, $krx4P.default)(variant)}Color${(0, $krx4P.default)(color)}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $2bwY3.getChipUtilityClass), classes);
};
const $69e500bfbcfc581a$var$ChipRoot = (0, $l0oRz.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $2bwY3.default).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $2bwY3.default).avatar}`]: styles[`avatar${(0, $krx4P.default)(size)}`]
            },
            {
                [`& .${(0, $2bwY3.default).avatar}`]: styles[`avatarColor${(0, $krx4P.default)(color)}`]
            },
            {
                [`& .${(0, $2bwY3.default).icon}`]: styles.icon
            },
            {
                [`& .${(0, $2bwY3.default).icon}`]: styles[`icon${(0, $krx4P.default)(size)}`]
            },
            {
                [`& .${(0, $2bwY3.default).icon}`]: styles[`iconColor${(0, $krx4P.default)(iconColor)}`]
            },
            {
                [`& .${(0, $2bwY3.default).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $2bwY3.default).deleteIcon}`]: styles[`deleteIcon${(0, $krx4P.default)(size)}`]
            },
            {
                [`& .${(0, $2bwY3.default).deleteIcon}`]: styles[`deleteIconColor${(0, $krx4P.default)(color)}`]
            },
            {
                [`& .${(0, $2bwY3.default).deleteIcon}`]: styles[`deleteIcon${(0, $krx4P.default)(variant)}Color${(0, $krx4P.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $krx4P.default)(size)}`],
            styles[`color${(0, $krx4P.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $krx4P.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $krx4P.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $krx4P.default)(color)}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return {
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        lineHeight: 1.5,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $2bwY3.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $2bwY3.default).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $2bwY3.default).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $2bwY3.default).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $2bwY3.default).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $2bwY3.default).icon}`]: {
            marginLeft: 5,
            marginRight: -6
        },
        [`& .${(0, $2bwY3.default).deleteIcon}`]: {
            WebkitTapHighlightColor: 'transparent',
            color: theme.alpha((theme.vars || theme).palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.alpha((theme.vars || theme).palette.text.primary, 0.4)
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    height: 24,
                    [`& .${(0, $2bwY3.default).icon}`]: {
                        fontSize: 18,
                        marginLeft: 4,
                        marginRight: -4
                    },
                    [`& .${(0, $2bwY3.default).deleteIcon}`]: {
                        fontSize: 16,
                        marginRight: 4,
                        marginLeft: -4
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)([
                'contrastText'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText,
                        [`& .${(0, $2bwY3.default).deleteIcon}`]: {
                            color: theme.alpha((theme.vars || theme).palette[color].contrastText, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].contrastText
                            }
                        }
                    }
                };
            }),
            {
                props: (props)=>props.iconColor === props.color,
                style: {
                    [`& .${(0, $2bwY3.default).icon}`]: {
                        color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
                    }
                }
            },
            {
                props: (props)=>props.iconColor === props.color && props.color !== 'default',
                style: {
                    [`& .${(0, $2bwY3.default).icon}`]: {
                        color: 'inherit'
                    }
                }
            },
            {
                props: {
                    onDelete: true
                },
                style: {
                    [`&.${(0, $2bwY3.default).focusVisible}`]: {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)([
                'dark'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color,
                        onDelete: true
                    },
                    style: {
                        [`&.${(0, $2bwY3.default).focusVisible}`]: {
                            background: (theme.vars || theme).palette[color].dark
                        }
                    }
                };
            }),
            {
                props: {
                    clickable: true
                },
                style: {
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`)
                    },
                    [`&.${(0, $2bwY3.default).focusVisible}`]: {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[1]
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        color: color,
                        clickable: true
                    },
                    style: {
                        [`&:hover, &.${(0, $2bwY3.default).focusVisible}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                })),
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    backgroundColor: 'transparent',
                    border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
                    [`&.${(0, $2bwY3.default).clickable}:hover`]: {
                        backgroundColor: (theme.vars || theme).palette.action.hover
                    },
                    [`&.${(0, $2bwY3.default).focusVisible}`]: {
                        backgroundColor: (theme.vars || theme).palette.action.focus
                    },
                    [`& .${(0, $2bwY3.default).avatar}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $2bwY3.default).avatarSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $2bwY3.default).icon}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $2bwY3.default).iconSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $2bwY3.default).deleteIcon}`]: {
                        marginRight: 5
                    },
                    [`& .${(0, $2bwY3.default).deleteIconSmall}`]: {
                        marginRight: 3
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()) // no need to check for mainChannel as it's calculated from main
            .map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        border: `1px solid ${theme.alpha((theme.vars || theme).palette[color].main, 0.7)}`,
                        [`&.${(0, $2bwY3.default).clickable}:hover`]: {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        },
                        [`&.${(0, $2bwY3.default).focusVisible}`]: {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.focusOpacity)
                        },
                        [`& .${(0, $2bwY3.default).deleteIcon}`]: {
                            color: theme.alpha((theme.vars || theme).palette[color].main, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    };
}));
const $69e500bfbcfc581a$var$ChipLabel = (0, $l0oRz.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $krx4P.default)(size)}`]
        ];
    }
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: 'nowrap',
    variants: [
        {
            props: {
                variant: 'outlined'
            },
            style: {
                paddingLeft: 11,
                paddingRight: 11
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                size: 'small',
                variant: 'outlined'
            },
            style: {
                paddingLeft: 7,
                paddingRight: 7
            }
        }
    ]
});
function $69e500bfbcfc581a$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $69e500bfbcfc581a$var$Chip = /*#__PURE__*/ $bh6RR.forwardRef(function Chip(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false, slots: // TODO v6: Rename to `focusableWhenDisabled`.
    slots = {}, slotProps: slotProps = {}, ...other } = props;
    const chipRef = $bh6RR.useRef(null);
    const handleRef = (0, $dg012.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $69e500bfbcfc581a$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $69e500bfbcfc581a$var$isDeleteKeyboardEvent(event)) onDelete(event);
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $fbTZq.default) : ComponentProp || 'div';
    const ownerState = {
        ...props,
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $bh6RR.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    };
    const classes = $69e500bfbcfc581a$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $fbTZq.default) ? {
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible,
        ...onDelete && {
            disableRipple: true
        }
    } : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $bh6RR.isValidElement(deleteIconProp) ? /*#__PURE__*/ $bh6RR.cloneElement(deleteIconProp, {
        className: (0, $aPsoC.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $i624W.default), {
        className: classes.deleteIcon,
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $bh6RR.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $bh6RR.cloneElement(avatarProp, {
        className: (0, $aPsoC.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $bh6RR.isValidElement(iconProp)) icon = /*#__PURE__*/ $bh6RR.cloneElement(iconProp, {
        className: (0, $aPsoC.default)(classes.icon, iconProp.props.className)
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $dFvJW.default)('root', {
        elementType: $69e500bfbcfc581a$var$ChipRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        // The `component` prop is preserved because `Chip` relies on it for internal logic. If `shouldForwardComponentProp` were `false`, `useSlot` would remove the `component` prop, potentially breaking the component's behavior.
        shouldForwardComponentProp: true,
        ref: handleRef,
        className: (0, $aPsoC.default)(classes.root, className),
        additionalProps: {
            disabled: clickable && disabled ? true : undefined,
            tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
            ...moreProps
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    onClick?.(event);
                },
                onKeyDown: (event)=>{
                    handlers.onKeyDown?.(event);
                    handleKeyDown(event);
                },
                onKeyUp: (event)=>{
                    handlers.onKeyUp?.(event);
                    handleKeyUp(event);
                }
            })
    });
    const [LabelSlot, labelProps] = (0, $dFvJW.default)('label', {
        elementType: $69e500bfbcfc581a$var$ChipLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.label
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)(RootSlot, {
        as: component,
        ...rootProps,
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $ih19M.jsx)(LabelSlot, {
                ...labelProps,
                children: label
            }),
            deleteIcon
        ]
    });
});
var $69e500bfbcfc581a$export$2e2bcd8739ae039 = $69e500bfbcfc581a$var$Chip;

});
parcelRegister("i624W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2ca665063bdc64c$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $d2ca665063bdc64c$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

});

parcelRegister("2bwY3", function(module, exports) {

$parcel$export(module.exports, "getChipUtilityClass", function () { return $19762e89bbe06948$export$31444911e4ee6fdd; });
$parcel$export(module.exports, "default", function () { return $19762e89bbe06948$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $19762e89bbe06948$export$31444911e4ee6fdd(slot) {
    return (0, $dmzXD.default)('MuiChip', slot);
}
const $19762e89bbe06948$var$chipClasses = (0, $fYlYP.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorDefault',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $19762e89bbe06948$export$2e2bcd8739ae039 = $19762e89bbe06948$var$chipClasses;

});


parcelRegister("2Tk9i", function(module, exports) {

$parcel$export(module.exports, "variationPath", function () { return $0e0cd5edd046c5e3$export$1be811f003313f7b; });
/**
 * Where a catalog hit for an experience variation opens: the player page,
 * by key. The key rides the content index's metadata because `sourceId` is
 * the variation's private surrogate (ADR-034). Null for a row synced before
 * the key was projected — a resync fills it in.
 */ function $0e0cd5edd046c5e3$export$1be811f003313f7b(metadata) {
    const { experienceId: experienceId, variationKey: variationKey } = metadata ?? {};
    if (typeof experienceId !== "string" || typeof variationKey !== "string") return null;
    return `/exp/${encodeURIComponent(experienceId)}/${encodeURIComponent(variationKey)}`;
}

});

parcelRegister("9jrSn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01bfed77b5e29941$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $01bfed77b5e29941$export$2e2bcd8739ae039 = (0, $fWXJ7.default)([
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M21 12.22C21 6.73 16.74 3 12 3c-4.69 0-9 3.65-9 9.28-.6.34-1 .98-1 1.72v2c0 1.1.9 2 2 2h1v-6.1c0-3.87 3.13-7 7-7s7 3.13 7 7V19h-8v2h8c1.1 0 2-.9 2-2v-1.22c.59-.31 1-.92 1-1.64v-2.3c0-.7-.41-1.31-1-1.62"
    }, "0"),
    /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
        cx: "9",
        cy: "13",
        r: "1"
    }, "1"),
    /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
        cx: "15",
        cy: "13",
        r: "1"
    }, "2"),
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M18 11.03C17.52 8.18 15.04 6 12.05 6c-3.03 0-6.29 2.51-6.03 6.45 2.47-1.01 4.33-3.21 4.86-5.89 1.31 2.63 4 4.44 7.12 4.47"
    }, "3")
], 'SupportAgent');

});

parcelRegister("3EEPE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a94c7f14dadc5e9$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $2a94c7f14dadc5e9$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8z"
}), 'ArrowUpward');

});

parcelRegister("cVsvh", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", function () { return $9690eb1948c98c05$export$965edad20a84fa75; });
$parcel$export(module.exports, "inputOverridesResolver", function () { return $9690eb1948c98c05$export$cf507b112810e72d; });
$parcel$export(module.exports, "InputBaseRoot", function () { return $9690eb1948c98c05$export$298a043133d72a38; });
$parcel$export(module.exports, "InputBaseInput", function () { return $9690eb1948c98c05$export$ee10465db6ff6017; });
$parcel$export(module.exports, "default", function () { return $9690eb1948c98c05$export$2e2bcd8739ae039; });

var $avV9A = parcelRequire("avV9A");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");



var $96ZcP = parcelRequire("96ZcP");

var $g0K0l = parcelRequire("g0K0l");

var $hvfyO = parcelRequire("hvfyO");

var $jZFy8 = parcelRequire("jZFy8");

var $4Iacp = parcelRequire("4Iacp");

var $1BiIF = parcelRequire("1BiIF");

var $blGXB = parcelRequire("blGXB");
var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $krx4P = parcelRequire("krx4P");

var $dg012 = parcelRequire("dg012");

var $14LyK = parcelRequire("14LyK");

var $eC5hG = parcelRequire("eC5hG");

var $auhFG = parcelRequire("auhFG");

var $ih19M = parcelRequire("ih19M");
'use client';
var $9690eb1948c98c05$var$_InputGlobalStyles;
const $9690eb1948c98c05$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $krx4P.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $9690eb1948c98c05$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $9690eb1948c98c05$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $krx4P.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $krx4P.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $auhFG.getInputBaseUtilityClass), classes);
};
const $9690eb1948c98c05$export$298a043133d72a38 = (0, $l0oRz.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $9690eb1948c98c05$export$965edad20a84fa75
})((0, $gfPc7.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $auhFG.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $9690eb1948c98c05$export$ee10465db6ff6017 = (0, $l0oRz.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $9690eb1948c98c05$export$cf507b112810e72d
})((0, $gfPc7.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $auhFG.default).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $auhFG.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $9690eb1948c98c05$var$InputGlobalStyles = (0, $blGXB.globalCss)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $9690eb1948c98c05$var$InputBase = /*#__PURE__*/ $bh6RR.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $bh6RR.useRef(value != null);
    const inputRef = $bh6RR.useRef();
    const handleInputRefWarning = $bh6RR.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $dg012.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $bh6RR.useState(false);
    const muiFormControl = (0, $1BiIF.default)();
    const fcs = (0, $jZFy8.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $bh6RR.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $bh6RR.useCallback((obj)=>{
        if ((0, $eC5hG.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $14LyK.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $avV9A.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $bh6RR.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $hvfyO.default);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $bh6RR.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $9690eb1948c98c05$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $9690eb1948c98c05$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $9690eb1948c98c05$export$ee10465db6ff6017;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $9690eb1948c98c05$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($9690eb1948c98c05$var$_InputGlobalStyles || ($9690eb1948c98c05$var$_InputGlobalStyles = /*#__PURE__*/ (0, $ih19M.jsx)($9690eb1948c98c05$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $ih19M.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $g0K0l.default)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $aPsoC.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $4Iacp.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $g0K0l.default)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $aPsoC.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $9690eb1948c98c05$export$2e2bcd8739ae039 = $9690eb1948c98c05$var$InputBase;

});
parcelRegister("hvfyO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbe166ee1811159d$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $2UWap = parcelRequire("2UWap");

var $6RXey = parcelRequire("6RXey");

var $kLukk = parcelRequire("kLukk");

var $87bEd = parcelRequire("87bEd");

var $4CDSV = parcelRequire("4CDSV");

var $ih19M = parcelRequire("ih19M");
'use client';
function $cbe166ee1811159d$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $cbe166ee1811159d$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $cbe166ee1811159d$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $cbe166ee1811159d$var$isEmpty(obj) {
    return $cbe166ee1811159d$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $cbe166ee1811159d$var$TextareaAutosize = /*#__PURE__*/ $bh6RR.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $bh6RR.useRef(value != null);
    const textareaRef = $bh6RR.useRef(null);
    const handleRef = (0, $6RXey.default)(forwardedRef, textareaRef);
    const heightRef = $bh6RR.useRef(null);
    const hiddenTextareaRef = $bh6RR.useRef(null);
    const calculateTextareaStyles = $bh6RR.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $4CDSV.default)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $cbe166ee1811159d$var$getStyleValue(computedStyle.paddingBottom) + $cbe166ee1811159d$var$getStyleValue(computedStyle.paddingTop);
        const border = $cbe166ee1811159d$var$getStyleValue(computedStyle.borderBottomWidth) + $cbe166ee1811159d$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $87bEd.default)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $cbe166ee1811159d$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $bh6RR.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $cbe166ee1811159d$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $bh6RR.useRef(-1);
    (0, $kLukk.default)(()=>{
        const debouncedHandleResize = (0, $2UWap.default)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $4CDSV.default)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $kLukk.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        const textarea = event.target;
        const countOfCharacters = textarea.value.length;
        const isLastCharacterNewLine = textarea.value.endsWith('\n');
        const isEndOfTheLine = textarea.selectionStart === countOfCharacters;
        // Set the cursor position to the very end of the text.
        if (isLastCharacterNewLine && isEndOfTheLine) textarea.setSelectionRange(countOfCharacters, countOfCharacters);
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$cbe166ee1811159d$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $cbe166ee1811159d$export$2e2bcd8739ae039 = $cbe166ee1811159d$var$TextareaAutosize;

});
parcelRegister("2UWap", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21fdee74580c83e6$export$2e2bcd8739ae039; });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $21fdee74580c83e6$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});

parcelRegister("4CDSV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35d9a659d383d10c$export$2e2bcd8739ae039; });

var $8HMMM = parcelRequire("8HMMM");
function $35d9a659d383d10c$export$2e2bcd8739ae039(node) {
    const doc = (0, $8HMMM.default)(node);
    return doc.defaultView || window;
}

});


parcelRegister("jZFy8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8e3f1b20b527977$export$2e2bcd8739ae039; });
function $e8e3f1b20b527977$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("4Iacp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36e32ecc4d0ed1f4$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
/**
 * @ignore - internal component.
 */ const $36e32ecc4d0ed1f4$var$FormControlContext = /*#__PURE__*/ $bh6RR.createContext(undefined);
var $36e32ecc4d0ed1f4$export$2e2bcd8739ae039 = $36e32ecc4d0ed1f4$var$FormControlContext;

});

parcelRegister("1BiIF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12a7c46f2e3dd4d5$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $4Iacp = parcelRequire("4Iacp");
'use client';
function $12a7c46f2e3dd4d5$export$2e2bcd8739ae039() {
    return $bh6RR.useContext((0, $4Iacp.default));
}

});

parcelRegister("14LyK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c8b0e801cc4b148$export$2e2bcd8739ae039; });

var $kLukk = parcelRequire("kLukk");
'use client';
var $0c8b0e801cc4b148$export$2e2bcd8739ae039 = (0, $kLukk.default);

});

parcelRegister("eC5hG", function(module, exports) {

$parcel$export(module.exports, "isFilled", function () { return $aa38b6a58108d3e5$export$d652b828d7fdeff8; });
$parcel$export(module.exports, "isAdornedStart", function () { return $aa38b6a58108d3e5$export$1b68bdfa56faeb5d; });
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $aa38b6a58108d3e5$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $aa38b6a58108d3e5$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($aa38b6a58108d3e5$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $aa38b6a58108d3e5$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $aa38b6a58108d3e5$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRegister("auhFG", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", function () { return $7a2a69e20384ea09$export$ef57d5c8ca2278f6; });
$parcel$export(module.exports, "default", function () { return $7a2a69e20384ea09$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $7a2a69e20384ea09$export$ef57d5c8ca2278f6(slot) {
    return (0, $dmzXD.default)('MuiInputBase', slot);
}
const $7a2a69e20384ea09$var$inputBaseClasses = (0, $fYlYP.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $7a2a69e20384ea09$export$2e2bcd8739ae039 = $7a2a69e20384ea09$var$inputBaseClasses;

});


parcelRegister("60TOG", function(module, exports) {

$parcel$export(module.exports, "useAssessmentStart", function () { return $1c907dbbaa11247c$export$e2ea151309f2fc1f; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");
parcelRequire("cFAEN");
var $cK0UE = parcelRequire("cK0UE");

var $cK0UE = parcelRequire("cK0UE");

var $76QOg = parcelRequire("76QOg");

var $g6rVl = parcelRequire("g6rVl");

var $eyQ0b = parcelRequire("eyQ0b");

var $7uFU8 = parcelRequire("7uFU8");
function $1c907dbbaa11247c$export$e2ea151309f2fc1f() {
    const navigate = (0, $as544.useNavigate)();
    const { selected: selectedSport } = (0, $76QOg.useSelectedSport)();
    const { startJourney: startJourney, registerJourneyLinkIntent: registerJourneyLinkIntent, activeJourneys: activeJourneys } = (0, $g6rVl.default)();
    const [dialogOpen, setDialogOpen] = $bh6RR.useState(false);
    const [journey, setJourney] = $bh6RR.useState(null);
    const openStart = $bh6RR.useCallback(async (journeyId)=>{
        try {
            const j = await (0, $cK0UE.default)(`/api/journeys/${journeyId}`);
            setJourney(j);
            setDialogOpen(true);
        } catch (err) {
            (0, $cK0UE.logFetchError)(err);
        }
    }, []);
    const openStartWithJourney = $bh6RR.useCallback((j)=>{
        setJourney(j);
        setDialogOpen(true);
    }, []);
    const inProgressInstance = $bh6RR.useMemo(()=>{
        if (!journey) return null;
        return activeJourneys.find((j)=>j.journey.id === journey.id) ?? null;
    }, [
        journey,
        activeJourneys
    ]);
    const handleStart = $bh6RR.useCallback(async (metadata)=>{
        if (!journey) return;
        const instance = await startJourney(journey.id, metadata);
        const workouts = journey.journeyAppWorkouts;
        if (workouts.length === 1) {
            const aw = workouts[0].appWorkout;
            await registerJourneyLinkIntent(instance.ulid, aw.id);
            navigate(`/content/apps/workouts/plugin/play/${aw.appId}/${aw.id}`, {
                replace: true
            });
        } else navigate((0, $7uFU8.inProgressUrl)({
            journeyType: "assessment",
            journeyInstanceId: instance.id,
            journeyInstanceUlid: instance.ulid
        }), {
            replace: true
        });
    }, [
        journey,
        startJourney,
        registerJourneyLinkIntent,
        navigate
    ]);
    const dialog = /*#__PURE__*/ (0, $ih19M.jsx)((0, $eyQ0b.default), {
        open: dialogOpen,
        journey: journey,
        inProgressInstance: inProgressInstance,
        onClose: ()=>setDialogOpen(false),
        onStart: handleStart,
        sport: selectedSport
    });
    return {
        openStart: openStart,
        openStartWithJourney: openStartWithJourney,
        dialog: dialog
    };
}

});
parcelRegister("g6rVl", function(module, exports) {

$parcel$export(module.exports, "JourneyProvider", function () { return $7a3a9eb6f3c8e814$export$4ec694842caaa789; });
$parcel$export(module.exports, "default", function () { return $7a3a9eb6f3c8e814$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $eedE5 = parcelRequire("eedE5");

var $dUgAK = parcelRequire("dUgAK");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $1lMle = parcelRequire("1lMle");
parcelRequire("cFAEN");
var $cK0UE = parcelRequire("cK0UE");

var $cK0UE = parcelRequire("cK0UE");

var $e6FX7 = parcelRequire("e6FX7");

var $aCyHi = parcelRequire("aCyHi");

var $7uFU8 = parcelRequire("7uFU8");

var $76QOg = parcelRequire("76QOg");

var $4xl3n = parcelRequire("4xl3n");
const $7a3a9eb6f3c8e814$export$ff141119be8d5a15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    activeJourneys: [],
    refreshActiveJourneys: ()=>Promise.resolve([]),
    onWorkoutFinished: ()=>{},
    getJourneyWorkout: ()=>null,
    startJourney: ()=>Promise.resolve({
            id: 0,
            ulid: ""
        }),
    registerJourneyLinkIntent: ()=>Promise.resolve(false),
    markBallThrown: ()=>{},
    logStepEvent: ()=>{}
});
const $7a3a9eb6f3c8e814$var$FEEDBACK_PENDING_KEY = "JOURNEY_FEEDBACK_PENDING";
const $7a3a9eb6f3c8e814$var$FEEDBACK_SESSION_SHOWN_KEY = "JOURNEY_FEEDBACK_SESSION_SHOWN";
const $7a3a9eb6f3c8e814$var$FEEDBACK_TRIGGER_PATHS = new Set([
    "/",
    "/journeys/classes",
    "/journeys/assessments"
]);
// URL param that opts a play session out of all journey behavior, even if the
// workout is part of an active journey. Used when entering a workout as
// standalone practice from surfaces like PlayStartDialog.
const $7a3a9eb6f3c8e814$var$FORCE_NO_JOURNEY_PARAM = "forceNoJourney";
// Tracks which (journey instance, workout) pair the current/upcoming play
// belongs to. Set when registerJourneyLinkIntent succeeds.
const $7a3a9eb6f3c8e814$var$PENDING_JOURNEY_PLAY_KEY = "JOURNEY_PENDING_PLAY_CONTEXT";
const $7a3a9eb6f3c8e814$export$4ec694842caaa789 = ({ children: children })=>{
    const { selected: selectedSport } = (0, $76QOg.useSelectedSport)();
    const { sessionId: pairingSessionId } = (0, $4xl3n.usePairingContext)();
    const navigate = (0, $as544.useNavigate)();
    const location = (0, $as544.useLocation)();
    const [activeJourneys, setActiveJourneys] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const [lowerHeadDialogOpen, setLowerHeadDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [lowered, setLowered] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [pendingFeedback, setPendingFeedback] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [feedbackDialogOpen, setFeedbackDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [pendingJourneyPlay, setPendingJourneyPlayState] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(()=>{
        try {
            const saved = sessionStorage.getItem($7a3a9eb6f3c8e814$var$PENDING_JOURNEY_PLAY_KEY);
            return saved ? JSON.parse(saved) : null;
        } catch  {
            return null;
        }
    });
    const setPendingJourneyPlay = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((next)=>{
        setPendingJourneyPlayState(next);
        if (next) sessionStorage.setItem($7a3a9eb6f3c8e814$var$PENDING_JOURNEY_PLAY_KEY, JSON.stringify(next));
        else sessionStorage.removeItem($7a3a9eb6f3c8e814$var$PENDING_JOURNEY_PLAY_KEY);
    }, []);
    const forceNoJourney = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>new URLSearchParams(location.search).has($7a3a9eb6f3c8e814$var$FORCE_NO_JOURNEY_PARAM), [
        location.search
    ]);
    const onLowered = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(()=>setLowered(true), []);
    const onCloseLowerHeadDialog = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(()=>setLowerHeadDialogOpen(false), []);
    const refreshActiveJourneys = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(async (type)=>{
        const url = new URL("/api/journeys/instances/mine/active", window.location.origin);
        url.searchParams.set("sport", selectedSport);
        if (type) url.searchParams.set("type", type);
        try {
            const result = await (0, $cK0UE.default)(url.toString(), "GET");
            setActiveJourneys(result);
            return result;
        } catch (err) {
            (0, $cK0UE.logFetchError)(err);
            return [];
        }
    }, [
        selectedSport
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        refreshActiveJourneys().catch((0, $cK0UE.logFetchError));
    }, [
        refreshActiveJourneys
    ]);
    // Show feedback dialog when user navigates to a trigger path
    // and a pending feedback flag was set by markBallThrown
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (!$7a3a9eb6f3c8e814$var$FEEDBACK_TRIGGER_PATHS.has(location.pathname)) return;
        const pendingJson = localStorage.getItem($7a3a9eb6f3c8e814$var$FEEDBACK_PENDING_KEY);
        if (!pendingJson) return;
        let pending;
        try {
            pending = JSON.parse(pendingJson);
        } catch  {
            localStorage.removeItem($7a3a9eb6f3c8e814$var$FEEDBACK_PENDING_KEY);
            return;
        }
        // Clear pending flag regardless of whether we show the dialog
        localStorage.removeItem($7a3a9eb6f3c8e814$var$FEEDBACK_PENDING_KEY);
        // Only prompt once per trainer session
        if (localStorage.getItem($7a3a9eb6f3c8e814$var$FEEDBACK_SESSION_SHOWN_KEY)) return;
        localStorage.setItem($7a3a9eb6f3c8e814$var$FEEDBACK_SESSION_SHOWN_KEY, "1");
        setPendingFeedback(pending);
        setFeedbackDialogOpen(true);
    }, [
        location.pathname
    ]);
    const findCurrentPlayJourney = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((workoutId)=>{
        if (!pendingJourneyPlay || pendingJourneyPlay.appWorkoutId !== workoutId) return null;
        return activeJourneys.find((j)=>j.ulid === pendingJourneyPlay.instanceUlid) ?? null;
    }, [
        pendingJourneyPlay,
        activeJourneys
    ]);
    const markBallThrown = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((workoutId)=>{
        if (forceNoJourney) return;
        const activeJourney = findCurrentPlayJourney(workoutId);
        if (!activeJourney) return;
        const workoutPlay = activeJourney.workoutsPlays.find((p)=>p.appWorkout.id === workoutId);
        const pending = {
            journeyType: activeJourney.journey.type,
            metadata: {
                journeyInstanceUlid: activeJourney.ulid,
                journeyId: activeJourney.journey.id,
                journeyTitle: activeJourney.journey.title,
                completionStatus: "incomplete",
                sport: activeJourney.journey.sportName,
                lastWorkoutName: workoutPlay?.appWorkout.name,
                sessionId: pairingSessionId
            }
        };
        localStorage.setItem($7a3a9eb6f3c8e814$var$FEEDBACK_PENDING_KEY, JSON.stringify(pending));
    }, [
        findCurrentPlayJourney,
        pairingSessionId,
        forceNoJourney
    ]);
    const registerJourneyLinkIntent = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(async (instanceUlid, appWorkoutId)=>{
        try {
            await (0, $cK0UE.default)(`/api/journeys/instances/${instanceUlid}/register-next-play`, "POST", {
                appWorkoutId: appWorkoutId
            });
            setPendingJourneyPlay({
                instanceUlid: instanceUlid,
                appWorkoutId: appWorkoutId
            });
            return true;
        } catch (err) {
            // Best-effort for a user-initiated navigation: a missing intent
            // just means the play won't be linked to the journey. We log but
            // don't block. Callers that navigate on the player's behalf
            // (auto-advance) check the result instead, since an unlinked play
            // would silently drop that workout's clips from the assessment.
            (0, $cK0UE.logFetchError)(err);
            return false;
        }
    }, [
        setPendingJourneyPlay
    ]);
    const onWorkoutFinished = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((workoutId)=>{
        if (forceNoJourney) return;
        const activeJourney = findCurrentPlayJourney(workoutId);
        if (!activeJourney) return;
        const currentSequence = activeJourney.workoutsPlays.find((p)=>p.appWorkout.id === workoutId)?.sequence;
        if (!currentSequence) {
            (0, $1lMle.default).warn(`useJourney: workout '${workoutId}' not found in active journey '${activeJourney.id}'`);
            return;
        }
        let nextPlay = null;
        let minNextSequence = Infinity;
        for (const p of activeJourney.workoutsPlays){
            if (p.sequence > currentSequence) {
                if (p.sequence < minNextSequence) {
                    minNextSequence = p.sequence;
                    nextPlay = p;
                }
            }
        }
        const goToInProgress = ()=>{
            // Navigate synchronously, then refresh in the background.
            // The in-progress page does its own refresh on mount, so
            // gating navigation on the refresh promise just adds a race
            // where the .then() callback can be dropped on iOS during
            // visibility/tab-restoration transitions.
            navigate((0, $7uFU8.inProgressUrl)({
                journeyType: activeJourney.journey.type,
                journeyInstanceId: activeJourney.id,
                journeyInstanceUlid: activeJourney.ulid
            }), {
                replace: true
            });
            refreshActiveJourneys().catch((0, $cK0UE.logFetchError));
        };
        if (nextPlay) goToInProgress();
        else if (activeJourney.hasPreviousCompletion && activeJourney.journey.type === "class") // Previously completed class - let user decide when to complete
        goToInProgress();
        else (0, $cK0UE.default)(`/api/journeys/instances/${activeJourney.ulid}/complete`, "PUT").then(()=>{
            // Remove the completed journey from active journeys
            setActiveJourneys((prev)=>prev.filter((j)=>j.id !== activeJourney.id));
            // Clear pending feedback — the done page
            // handles its own feedback dialog
            localStorage.removeItem($7a3a9eb6f3c8e814$var$FEEDBACK_PENDING_KEY);
            const typePath = activeJourney.journey.type === "assessment" ? "assessments" : "classes";
            navigate(`/journeys/${typePath}/${activeJourney.ulid}/done`, {
                replace: true
            });
        }).catch((0, $cK0UE.logFetchError));
        setPendingJourneyPlay(null);
    }, [
        findCurrentPlayJourney,
        refreshActiveJourneys,
        navigate,
        forceNoJourney,
        setPendingJourneyPlay
    ]);
    const getJourneyWorkout = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((workoutId)=>{
        if (forceNoJourney) return null;
        const journey = findCurrentPlayJourney(workoutId);
        if (!journey) return null;
        return journey.workoutsPlays.find((w)=>w.appWorkout.id === workoutId) ?? null;
    }, [
        findCurrentPlayJourney,
        forceNoJourney
    ]);
    const startJourney = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(async (journeyId, metadata)=>{
        const payload = {
            journeyId: journeyId,
            metadata: metadata
        };
        try {
            const result = await (0, $cK0UE.default)("/api/journeys/instances", "POST", payload);
            await refreshActiveJourneys();
            return {
                id: result.createdId,
                ulid: result.createdUlid
            };
        } catch (err) {
            (0, $cK0UE.logFetchError)(err);
            throw err;
        }
    }, [
        refreshActiveJourneys
    ]);
    /**
     * Fire-and-forget step event logging for drop-off analytics.
     * Silent failure - analytics should never impact user experience.
     */ const logStepEvent = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((stepType, options)=>{
        const payload = {
            stepType: stepType,
            journeyInstanceUlid: options?.journeyInstanceUlid,
            journeyId: options?.journeyId,
            metadata: options?.metadata
        };
        // Fire-and-forget: no await, silent error handling
        fetch("/api/journeys/step-events", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload),
            credentials: "include"
        }).catch(()=>{
        // Silent failure - analytics should not block UX
        });
    }, []);
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>({
            activeJourneys: activeJourneys,
            refreshActiveJourneys: refreshActiveJourneys,
            onWorkoutFinished: onWorkoutFinished,
            getJourneyWorkout: getJourneyWorkout,
            startJourney: startJourney,
            registerJourneyLinkIntent: registerJourneyLinkIntent,
            markBallThrown: markBallThrown,
            logStepEvent: logStepEvent
        }), [
        activeJourneys,
        refreshActiveJourneys,
        onWorkoutFinished,
        getJourneyWorkout,
        startJourney,
        registerJourneyLinkIntent,
        markBallThrown,
        logStepEvent
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($7a3a9eb6f3c8e814$export$ff141119be8d5a15.Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dUgAK.default), {
                open: lowerHeadDialogOpen,
                onClose: onCloseLowerHeadDialog,
                children: lowered ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                                children: "Please confirm ball bin is filled for next workout."
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                variant: "contained",
                                color: "secondary",
                                onClick: onCloseLowerHeadDialog,
                                children: "Confirm"
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $e6FX7.default), {
                    reason: "refill",
                    message: "The trainer arm is moving to a more convenient height for refilling the bin.",
                    onLowered: onLowered,
                    onStopped: onCloseLowerHeadDialog
                })
            }),
            pendingFeedback && /*#__PURE__*/ (0, $ih19M.jsx)((0, $aCyHi.default), {
                open: feedbackDialogOpen,
                onClose: ()=>setFeedbackDialogOpen(false),
                journeyType: pendingFeedback.journeyType,
                metadata: pendingFeedback.metadata
            })
        ]
    });
};
const $7a3a9eb6f3c8e814$var$useJourney = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($7a3a9eb6f3c8e814$export$ff141119be8d5a15);
var $7a3a9eb6f3c8e814$export$2e2bcd8739ae039 = $7a3a9eb6f3c8e814$var$useJourney;

});
parcelRegister("dUgAK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1fd60131642d7c6$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $dDKx6 = parcelRequire("dDKx6");

var $krx4P = parcelRequire("krx4P");

var $4s2UK = parcelRequire("4s2UK");

var $gILAF = parcelRequire("gILAF");

var $4Athc = parcelRequire("4Athc");

var $4qxbM = parcelRequire("4qxbM");

var $6viHk = parcelRequire("6viHk");

var $b6C9d = parcelRequire("b6C9d");

var $l0oRz = parcelRequire("l0oRz");
var $aOb5j = parcelRequire("aOb5j");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
const $a1fd60131642d7c6$var$DialogBackdrop = (0, $l0oRz.default)((0, $b6C9d.default), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $a1fd60131642d7c6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $krx4P.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $krx4P.default)(scroll)}`,
            `paperWidth${(0, $krx4P.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $4qxbM.getDialogUtilityClass), classes);
};
const $a1fd60131642d7c6$var$DialogRoot = (0, $l0oRz.default)((0, $4s2UK.default), {
    name: 'MuiDialog',
    slot: 'Root'
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $a1fd60131642d7c6$var$DialogContainer = (0, $l0oRz.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $krx4P.default)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const $a1fd60131642d7c6$var$DialogPaper = (0, $l0oRz.default)((0, $4Athc.default), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $krx4P.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $krx4P.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${(0, $4qxbM.default).paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${(0, $4qxbM.default).paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: 'calc(100% - 64px)'
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0,
                    [`&.${(0, $4qxbM.default).paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $a1fd60131642d7c6$var$Dialog = /*#__PURE__*/ $bh6RR.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $aOb5j.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $4Athc.default), PaperProps: PaperProps = {}, scroll: scroll = 'paper', slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponent = (0, $gILAF.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    };
    const classes = $a1fd60131642d7c6$var$useUtilityClasses(ownerState);
    const backdropClick = $bh6RR.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $dDKx6.default)(ariaLabelledbyProp);
    const dialogContextValue = $bh6RR.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    const backwardCompatibleSlots = {
        transition: TransitionComponent,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionProps,
        paper: PaperProps,
        backdrop: BackdropProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, $dFvJW.default)('root', {
        elementType: $a1fd60131642d7c6$var$DialogRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref
    });
    const [BackdropSlot, backdropSlotProps] = (0, $dFvJW.default)('backdrop', {
        elementType: $a1fd60131642d7c6$var$DialogBackdrop,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [PaperSlot, paperSlotProps] = (0, $dFvJW.default)('paper', {
        elementType: $a1fd60131642d7c6$var$DialogPaper,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.paper, PaperProps.className)
    });
    const [ContainerSlot, containerSlotProps] = (0, $dFvJW.default)('container', {
        elementType: $a1fd60131642d7c6$var$DialogContainer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.container
    });
    const [TransitionSlot, transitionSlotProps] = (0, $dFvJW.default)('transition', {
        elementType: (0, $gILAF.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: 'presentation'
        }
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)(RootSlot, {
        closeAfterTransition: true,
        slots: {
            backdrop: BackdropSlot
        },
        slotProps: {
            backdrop: {
                transitionDuration: transitionDuration,
                as: BackdropComponent,
                ...backdropSlotProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        onClick: handleBackdropClick,
        ...rootSlotProps,
        ...other,
        children: /*#__PURE__*/ (0, $ih19M.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            children: /*#__PURE__*/ (0, $ih19M.jsx)(ContainerSlot, {
                onMouseDown: handleMouseDown,
                ...containerSlotProps,
                children: /*#__PURE__*/ (0, $ih19M.jsx)(PaperSlot, {
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby,
                    "aria-modal": ariaModal,
                    ...paperSlotProps,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6viHk.default).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
var $a1fd60131642d7c6$export$2e2bcd8739ae039 = $a1fd60131642d7c6$var$Dialog;

});
parcelRegister("4s2UK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33dc09ae8fbe24d6$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");



var $96ZcP = parcelRequire("96ZcP");

var $hyYKX = parcelRequire("hyYKX");

var $g3ngr = parcelRequire("g3ngr");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $b6C9d = parcelRequire("b6C9d");

var $e4cFl = parcelRequire("e4cFl");

var $gatuv = parcelRequire("gatuv");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
const $33dc09ae8fbe24d6$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $gatuv.getModalUtilityClass), classes);
};
const $33dc09ae8fbe24d6$var$ModalRoot = (0, $l0oRz.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $33dc09ae8fbe24d6$var$ModalBackdrop = (0, $l0oRz.default)((0, $b6C9d.default), {
    name: 'MuiModal',
    slot: 'Backdrop'
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $33dc09ae8fbe24d6$var$Modal = /*#__PURE__*/ $bh6RR.forwardRef(function Modal(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $33dc09ae8fbe24d6$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $e4cFl.default)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $33dc09ae8fbe24d6$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $dFvJW.default)('root', {
        ref: ref,
        elementType: $33dc09ae8fbe24d6$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $dFvJW.default)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $aPsoC.default)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $g3ngr.default), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ih19M.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $hyYKX.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $bh6RR.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $33dc09ae8fbe24d6$export$2e2bcd8739ae039 = $33dc09ae8fbe24d6$var$Modal;

});
parcelRegister("hyYKX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc94bd9d82d75e24$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $6RXey = parcelRequire("6RXey");

var $8HMMM = parcelRequire("8HMMM");

var $20D76 = parcelRequire("20D76");



var $ih19M = parcelRequire("ih19M");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $cc94bd9d82d75e24$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $cc94bd9d82d75e24$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $cc94bd9d82d75e24$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $cc94bd9d82d75e24$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $cc94bd9d82d75e24$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $cc94bd9d82d75e24$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($cc94bd9d82d75e24$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $cc94bd9d82d75e24$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$cc94bd9d82d75e24$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $cc94bd9d82d75e24$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $cc94bd9d82d75e24$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $cc94bd9d82d75e24$var$defaultGetTabbable, isEnabled: isEnabled = $cc94bd9d82d75e24$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $bh6RR.useRef(false);
    const sentinelStart = $bh6RR.useRef(null);
    const sentinelEnd = $bh6RR.useRef(null);
    const nodeToRestore = $bh6RR.useRef(null);
    const reactFocusEventTarget = $bh6RR.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $bh6RR.useRef(false);
    const rootRef = $bh6RR.useRef(null);
    const handleRef = (0, $6RXey.default)((0, $20D76.default)(children), rootRef);
    const lastKeydown = $bh6RR.useRef(null);
    $bh6RR.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $bh6RR.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $8HMMM.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $bh6RR.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $8HMMM.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $bh6RR.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $cc94bd9d82d75e24$export$2e2bcd8739ae039 = $cc94bd9d82d75e24$var$FocusTrap;

});

parcelRegister("g3ngr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bafef8eab1415540$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");


var $kLukk = parcelRequire("kLukk");

var $6RXey = parcelRequire("6RXey");

var $faL5S = parcelRequire("faL5S");

var $20D76 = parcelRequire("20D76");


'use client';
function $bafef8eab1415540$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $bafef8eab1415540$var$Portal = /*#__PURE__*/ $bh6RR.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $bh6RR.useState(null);
    const handleRef = (0, $6RXey.default)(/*#__PURE__*/ $bh6RR.isValidElement(children) ? (0, $20D76.default)(children) : null, forwardedRef);
    (0, $kLukk.default)(()=>{
        if (!disablePortal) setMountNode($bafef8eab1415540$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $kLukk.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $faL5S.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $faL5S.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $bh6RR.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $bh6RR.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $6afFj.createPortal(children, mountNode) : mountNode;
});
var $bafef8eab1415540$export$2e2bcd8739ae039 = $bafef8eab1415540$var$Portal;

});
parcelRegister("faL5S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0bc520ed4d58057$export$2e2bcd8739ae039; });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $b0bc520ed4d58057$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("b6C9d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $815dd88d54a149d3$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $dFvJW = parcelRequire("dFvJW");

var $gILAF = parcelRequire("gILAF");

var $kKNMK = parcelRequire("kKNMK");

var $ih19M = parcelRequire("ih19M");
'use client';
const $815dd88d54a149d3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $kKNMK.getBackdropUtilityClass), classes);
};
const $815dd88d54a149d3$var$BackdropRoot = (0, $l0oRz.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $815dd88d54a149d3$var$Backdrop = /*#__PURE__*/ $bh6RR.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $815dd88d54a149d3$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        component: component,
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $dFvJW.default)('root', {
        elementType: $815dd88d54a149d3$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $dFvJW.default)('transition', {
        elementType: (0, $gILAF.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $ih19M.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var $815dd88d54a149d3$export$2e2bcd8739ae039 = $815dd88d54a149d3$var$Backdrop;

});
parcelRegister("gILAF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2c5abd7ccecef5f$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $7ARPd = parcelRequire("7ARPd");


var $20D76 = parcelRequire("20D76");

var $aOb5j = parcelRequire("aOb5j");

var $bi4C9 = parcelRequire("bi4C9");

var $dg012 = parcelRequire("dg012");

var $ih19M = parcelRequire("ih19M");
'use client';
const $c2c5abd7ccecef5f$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $c2c5abd7ccecef5f$var$Fade = /*#__PURE__*/ $bh6RR.forwardRef(function Fade(props, ref) {
    const theme = (0, $aOb5j.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $7ARPd.default), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $bh6RR.useRef(null);
    const handleRef = (0, $dg012.default)(nodeRef, (0, $20D76.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $bi4C9.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $bi4C9.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $bi4C9.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $bh6RR.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$c2c5abd7ccecef5f$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $c2c5abd7ccecef5f$export$2e2bcd8739ae039 = $c2c5abd7ccecef5f$var$Fade;

});

parcelRegister("kKNMK", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", function () { return $f1beb8d1625d4049$export$9927a91fd93152bd; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $f1beb8d1625d4049$export$9927a91fd93152bd(slot) {
    return (0, $dmzXD.default)('MuiBackdrop', slot);
}
const $f1beb8d1625d4049$var$backdropClasses = (0, $fYlYP.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $f1beb8d1625d4049$export$2e2bcd8739ae039 = $f1beb8d1625d4049$var$backdropClasses;

});


parcelRegister("e4cFl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3db4399c4b4c42d$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $8HMMM = parcelRequire("8HMMM");

var $6RXey = parcelRequire("6RXey");

var $87bEd = parcelRequire("87bEd");

var $5EVAP = parcelRequire("5EVAP");

var $jmq8q = parcelRequire("jmq8q");

var $6cepl = parcelRequire("6cepl");
'use client';
function $a3db4399c4b4c42d$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $a3db4399c4b4c42d$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $a3db4399c4b4c42d$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $a3db4399c4b4c42d$var$manager = new (0, $6cepl.ModalManager)();
function $a3db4399c4b4c42d$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $bh6RR.useRef({});
    const mountNodeRef = $bh6RR.useRef(null);
    const modalRef = $bh6RR.useRef(null);
    const handleRef = (0, $6RXey.default)(modalRef, rootRef);
    const [exited, setExited] = $bh6RR.useState(!open);
    const hasTransition = $a3db4399c4b4c42d$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $8HMMM.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $a3db4399c4b4c42d$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $87bEd.default)(()=>{
        const resolvedContainer = $a3db4399c4b4c42d$var$getContainer(container) || getDoc().body;
        $a3db4399c4b4c42d$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$a3db4399c4b4c42d$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $87bEd.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $6cepl.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $bh6RR.useCallback(()=>{
        $a3db4399c4b4c42d$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $bh6RR.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $bh6RR.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $jmq8q.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $5EVAP.default)(handleEnter, children?.props.onEnter ?? $a3db4399c4b4c42d$var$noop),
            onExited: (0, $5EVAP.default)(handleExited, children?.props.onExited ?? $a3db4399c4b4c42d$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $a3db4399c4b4c42d$export$2e2bcd8739ae039 = $a3db4399c4b4c42d$var$useModal;

});
parcelRegister("5EVAP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41ed5ceec7b1d175$export$2e2bcd8739ae039; });
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $41ed5ceec7b1d175$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRegister("6cepl", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", function () { return $482f0a274daca8a6$export$e1bd0c6150f13d96; });
$parcel$export(module.exports, "ModalManager", function () { return $482f0a274daca8a6$export$ce11c4ecd08cea67; });

var $4CDSV = parcelRequire("4CDSV");

var $8HMMM = parcelRequire("8HMMM");

var $bwV8G = parcelRequire("bwV8G");
// Is a vertical scrollbar displayed?
function $482f0a274daca8a6$var$isOverflowing(container) {
    const doc = (0, $8HMMM.default)(container);
    if (doc.body === container) return (0, $4CDSV.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $482f0a274daca8a6$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $482f0a274daca8a6$var$getPaddingRight(element) {
    return parseInt((0, $4CDSV.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $482f0a274daca8a6$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $482f0a274daca8a6$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$482f0a274daca8a6$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $482f0a274daca8a6$export$e1bd0c6150f13d96(element, hide);
    });
}
function $482f0a274daca8a6$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $482f0a274daca8a6$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($482f0a274daca8a6$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $bwV8G.default)((0, $4CDSV.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$482f0a274daca8a6$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $8HMMM.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$482f0a274daca8a6$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $8HMMM.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $4CDSV.default)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $482f0a274daca8a6$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $482f0a274daca8a6$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $482f0a274daca8a6$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $482f0a274daca8a6$var$getHiddenSiblings(container);
        $482f0a274daca8a6$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $482f0a274daca8a6$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $482f0a274daca8a6$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $482f0a274daca8a6$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $482f0a274daca8a6$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $482f0a274daca8a6$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $482f0a274daca8a6$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $482f0a274daca8a6$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}

});
parcelRegister("bwV8G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $864f0184c091e2b8$export$2e2bcd8739ae039; });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $864f0184c091e2b8$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}

});



parcelRegister("gatuv", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", function () { return $bc5474d47ccf8e85$export$67960e22b12a638d; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $bc5474d47ccf8e85$export$67960e22b12a638d(slot) {
    return (0, $dmzXD.default)('MuiModal', slot);
}
const $bc5474d47ccf8e85$var$modalClasses = (0, $fYlYP.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $bc5474d47ccf8e85$export$2e2bcd8739ae039 = $bc5474d47ccf8e85$var$modalClasses;

});


parcelRegister("4qxbM", function(module, exports) {

$parcel$export(module.exports, "getDialogUtilityClass", function () { return $339355ca7fded988$export$2177af0aa15c34c2; });
$parcel$export(module.exports, "default", function () { return $339355ca7fded988$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $339355ca7fded988$export$2177af0aa15c34c2(slot) {
    return (0, $dmzXD.default)('MuiDialog', slot);
}
const $339355ca7fded988$var$dialogClasses = (0, $fYlYP.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $339355ca7fded988$export$2e2bcd8739ae039 = $339355ca7fded988$var$dialogClasses;

});

parcelRegister("6viHk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bc42457e53a52c4$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
const $4bc42457e53a52c4$var$DialogContext = /*#__PURE__*/ $bh6RR.createContext({});
var $4bc42457e53a52c4$export$2e2bcd8739ae039 = $4bc42457e53a52c4$var$DialogContext;

});


parcelRegister("bK42r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88c71f80aa9afdd5$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $6Xczc = parcelRequire("6Xczc");

var $ih19M = parcelRequire("ih19M");
'use client';
const $88c71f80aa9afdd5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $6Xczc.getDialogActionsUtilityClass), classes);
};
const $88c71f80aa9afdd5$var$DialogActionsRoot = (0, $l0oRz.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $88c71f80aa9afdd5$var$DialogActions = /*#__PURE__*/ $bh6RR.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $88c71f80aa9afdd5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($88c71f80aa9afdd5$var$DialogActionsRoot, {
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $88c71f80aa9afdd5$export$2e2bcd8739ae039 = $88c71f80aa9afdd5$var$DialogActions;

});
parcelRegister("6Xczc", function(module, exports) {

$parcel$export(module.exports, "getDialogActionsUtilityClass", function () { return $5102003ee9cd0c22$export$5e57a444791c63be; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $5102003ee9cd0c22$export$5e57a444791c63be(slot) {
    return (0, $dmzXD.default)('MuiDialogActions', slot);
}
const $5102003ee9cd0c22$var$dialogActionsClasses = (0, $fYlYP.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $5102003ee9cd0c22$export$2e2bcd8739ae039 = $5102003ee9cd0c22$var$dialogActionsClasses;

});


parcelRegister("1W9Do", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1692ae6ed5b51b7a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $fDyxi = parcelRequire("fDyxi");

var $ebAxO = parcelRequire("ebAxO");

var $ih19M = parcelRequire("ih19M");
'use client';
const $1692ae6ed5b51b7a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $fDyxi.getDialogContentUtilityClass), classes);
};
const $1692ae6ed5b51b7a$var$DialogContentRoot = (0, $l0oRz.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.dividers,
                style: {
                    padding: '16px 24px',
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dividers,
                style: {
                    [`.${(0, $ebAxO.default).root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const $1692ae6ed5b51b7a$var$DialogContent = /*#__PURE__*/ $bh6RR.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false, ...other } = props;
    const ownerState = {
        ...props,
        dividers: dividers
    };
    const classes = $1692ae6ed5b51b7a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($1692ae6ed5b51b7a$var$DialogContentRoot, {
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $1692ae6ed5b51b7a$export$2e2bcd8739ae039 = $1692ae6ed5b51b7a$var$DialogContent;

});
parcelRegister("fDyxi", function(module, exports) {

$parcel$export(module.exports, "getDialogContentUtilityClass", function () { return $b62549af695c48f3$export$61b0ee1f05fb344e; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $b62549af695c48f3$export$61b0ee1f05fb344e(slot) {
    return (0, $dmzXD.default)('MuiDialogContent', slot);
}
const $b62549af695c48f3$var$dialogContentClasses = (0, $fYlYP.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $b62549af695c48f3$export$2e2bcd8739ae039 = $b62549af695c48f3$var$dialogContentClasses;

});

parcelRegister("ebAxO", function(module, exports) {

$parcel$export(module.exports, "getDialogTitleUtilityClass", function () { return $a53e70be280f4e0e$export$f5d2ec7e4c47e088; });
$parcel$export(module.exports, "default", function () { return $a53e70be280f4e0e$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $a53e70be280f4e0e$export$f5d2ec7e4c47e088(slot) {
    return (0, $dmzXD.default)('MuiDialogTitle', slot);
}
const $a53e70be280f4e0e$var$dialogTitleClasses = (0, $fYlYP.default)('MuiDialogTitle', [
    'root'
]);
var $a53e70be280f4e0e$export$2e2bcd8739ae039 = $a53e70be280f4e0e$var$dialogTitleClasses;

});


parcelRegister("hHL9O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce3b08412c0130c6$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $b6vKX = parcelRequire("b6vKX");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $cbFbS = parcelRequire("cbFbS");

var $jsiOf = parcelRequire("jsiOf");

var $ih19M = parcelRequire("ih19M");
'use client';
const $ce3b08412c0130c6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $jsiOf.getDialogContentTextUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the Typography
        ...composedClasses
    };
};
const $ce3b08412c0130c6$var$DialogContentTextRoot = (0, $l0oRz.default)((0, $cbFbS.default), {
    shouldForwardProp: (prop)=>(0, $b6vKX.default)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root'
})({});
const $ce3b08412c0130c6$var$DialogContentText = /*#__PURE__*/ $bh6RR.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { children: children, className: className, ...ownerState } = props;
    const classes = $ce3b08412c0130c6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($ce3b08412c0130c6$var$DialogContentTextRoot, {
        component: "p",
        variant: "body1",
        color: "textSecondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className),
        ...props,
        classes: classes
    });
});
var $ce3b08412c0130c6$export$2e2bcd8739ae039 = $ce3b08412c0130c6$var$DialogContentText;

});
parcelRegister("jsiOf", function(module, exports) {

$parcel$export(module.exports, "getDialogContentTextUtilityClass", function () { return $e29f39053b5f4851$export$d9c6dc45f75b0e4f; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $e29f39053b5f4851$export$d9c6dc45f75b0e4f(slot) {
    return (0, $dmzXD.default)('MuiDialogContentText', slot);
}
const $e29f39053b5f4851$var$dialogContentTextClasses = (0, $fYlYP.default)('MuiDialogContentText', [
    'root'
]);
var $e29f39053b5f4851$export$2e2bcd8739ae039 = $e29f39053b5f4851$var$dialogContentTextClasses;

});


parcelRegister("e6FX7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3c8579cf2d28867$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $5CVHy = parcelRequire("5CVHy");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $eLohH = parcelRequire("eLohH");

var $cbFbS = parcelRequire("cbFbS");

var $cK0UE = parcelRequire("cK0UE");

var $ezs3H = parcelRequire("ezs3H");

var $69mPc = parcelRequire("69mPc");

var $gqoJ3 = parcelRequire("gqoJ3");
const $d3c8579cf2d28867$var$LIFTABLE_POWER_STATES = [
    "L0",
    "L2"
];
function $d3c8579cf2d28867$export$2e2bcd8739ae039({ onLowered: onLowered, onError: onError = ()=>{}, onStopped: onStopped, message: message = "The trainer arm is moving to the lowest position.", reason: reason }) {
    (0, $gqoJ3.default)();
    const { height: height, isLifting: isLifting, liftStatus: liftStatus, refillHeight: refillHeight, setHeight: setHeight, lowerHead: lowerHead, liftRange: liftRange, error: error } = (0, $69mPc.useLift)();
    const { status: status } = (0, $ezs3H.useStatus)();
    const [stopping, setStopping] = $bh6RR.useState(false);
    const targetHeight = $bh6RR.useMemo(()=>reason === "refill" ? refillHeight : liftRange.min, [
        reason,
        refillHeight,
        liftRange.min
    ]);
    const percent = $bh6RR.useMemo(()=>{
        const full = Math.abs(liftRange.max - liftRange.min);
        const diff = Math.abs(height - targetHeight);
        const inv = full - diff;
        return Math.floor(inv / full * 100);
    }, [
        liftRange.max,
        liftRange.min,
        height,
        targetHeight
    ]);
    $bh6RR.useEffect(()=>{
        const powerState = status?.trainer.powerState;
        if (Math.abs(targetHeight - height) <= 1 && !isLifting) onLowered();
        else if (powerState && !$d3c8579cf2d28867$var$LIFTABLE_POWER_STATES.includes(powerState)) // TODO: when we shutdown due to estop or other hardware issue
        // we may not be in a liftable power state but want to continue with
        // shutdown
        onLowered();
        else if (stopping && !isLifting) // we've requested a stop and it's no longer lifting, bubble up
        onStopped();
        else if (error && onError) onError(error);
        else if (!isLifting && liftStatus === "idle") {
            if (reason === "balljam" || reason === "battery-replace" || reason === "unpair") lowerHead();
            else if (reason !== "shutdown") setHeight(targetHeight);
        }
    }, [
        height,
        error,
        isLifting,
        liftStatus,
        status,
        stopping,
        targetHeight,
        reason,
        lowerHead,
        setHeight,
        onError,
        onLowered,
        onStopped
    ]);
    const onRequestStop = $bh6RR.useCallback(async ()=>{
        setStopping(true);
        try {
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/motors-stop", "POST");
        } catch (e) {
            (0, $cK0UE.logFetchError)(e, "Failed to soft-stop from LowerHeadDialog");
        }
    }, [
        status?.clientId
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eLohH.default), {
                variant: "h4",
                children: "Moving Trainer Arm"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        children: message
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        children: error
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                        sx: {
                            my: 2,
                            position: "relative",
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                                variant: "determinate",
                                value: percent,
                                size: 80,
                                sx: {
                                    color: "primary.light"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                                sx: {
                                    top: "50%",
                                    left: "50%",
                                    position: "absolute",
                                    transform: "translate(-50%, -50%)",
                                    fontSize: "16pt"
                                },
                                color: "primary.light",
                                children: [
                                    height,
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                        component: "span",
                                        sx: {
                                            fontSize: "11pt"
                                        },
                                        children: "in."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "error",
                            fullWidth: true,
                            loading: stopping,
                            onClick: onRequestStop,
                            children: "Stop"
                        })
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("eLohH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abf84ad989e8dee0$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $cbFbS = parcelRequire("cbFbS");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $ebAxO = parcelRequire("ebAxO");

var $6viHk = parcelRequire("6viHk");

var $ih19M = parcelRequire("ih19M");
'use client';
const $abf84ad989e8dee0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $ebAxO.getDialogTitleUtilityClass), classes);
};
const $abf84ad989e8dee0$var$DialogTitleRoot = (0, $l0oRz.default)((0, $cbFbS.default), {
    name: 'MuiDialogTitle',
    slot: 'Root'
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $abf84ad989e8dee0$var$DialogTitle = /*#__PURE__*/ $bh6RR.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp, ...other } = props;
    const ownerState = props;
    const classes = $abf84ad989e8dee0$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $bh6RR.useContext((0, $6viHk.default));
    return /*#__PURE__*/ (0, $ih19M.jsx)($abf84ad989e8dee0$var$DialogTitleRoot, {
        component: "h2",
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp ?? titleId,
        ...other
    });
});
var $abf84ad989e8dee0$export$2e2bcd8739ae039 = $abf84ad989e8dee0$var$DialogTitle;

});

parcelRegister("69mPc", function(module, exports) {

$parcel$export(module.exports, "isAtHeight", function () { return $39ffce33b568e8a7$export$d678b2f041cf33b5; });
$parcel$export(module.exports, "clampHeight", function () { return $39ffce33b568e8a7$export$4465cd453867bc23; });
$parcel$export(module.exports, "useLift", function () { return $39ffce33b568e8a7$export$d243d04afc6219a9; });
$parcel$export(module.exports, "LiftModal", function () { return $39ffce33b568e8a7$export$f16f95df8e0a4bc1; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $5CVHy = parcelRequire("5CVHy");

var $dUgAK = parcelRequire("dUgAK");

var $1W9Do = parcelRequire("1W9Do");

var $eLohH = parcelRequire("eLohH");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $1lMle = parcelRequire("1lMle");

var $cK0UE = parcelRequire("cK0UE");

var $62tuQ = parcelRequire("62tuQ");

var $7ybf3 = parcelRequire("7ybf3");

var $ezs3H = parcelRequire("ezs3H");

var $NbKWd = parcelRequire("NbKWd");
const $39ffce33b568e8a7$export$7c1bd43268b0af86 = 1;
function $39ffce33b568e8a7$export$d678b2f041cf33b5(current, target) {
    return Math.abs(current - target) < $39ffce33b568e8a7$export$7c1bd43268b0af86;
}
function $39ffce33b568e8a7$export$4465cd453867bc23(height, range) {
    return Math.max(range.min, Math.min(range.max, height));
}
function $39ffce33b568e8a7$export$d243d04afc6219a9() {
    const { lift: lift } = (0, $7ybf3.default)();
    const { status: status, startRapidPoll: startRapidPoll, removeRapidPollCheck: removeRapidPollCheck } = (0, $ezs3H.useStatus)();
    const [error, setError] = $bh6RR.useState(null);
    const [liftRange, setLiftRange] = $bh6RR.useState(lift);
    const [isLifting, setIsLifting] = $bh6RR.useState(status?.trainer.isLifting ?? false);
    const [startedLifting, setStartedLifting] = $bh6RR.useState(null);
    const [targetHeight, setTargetHeight] = $bh6RR.useState(null);
    // True while POST /api/height is outstanding: until motion has accepted
    // the command, the head being near the target says nothing about arrival.
    const [heightRequestPending, setHeightRequestPending] = $bh6RR.useState(false);
    const [liftStatus, setLiftStatus] = $bh6RR.useState("idle");
    const onTargetAcheived = $bh6RR.useRef(undefined);
    // Ensure rapid polling is stopped when we unmount
    $bh6RR.useEffect(()=>()=>removeRapidPollCheck("lift"), [
        removeRapidPollCheck
    ]);
    $bh6RR.useEffect(()=>{
        if (!status) return;
        setLiftRange(status.trainer.lift.range);
        const lifting = startedLifting !== null || (status.trainer.isLifting ?? false);
        setIsLifting(lifting);
        if (lifting) setLiftStatus("lifting");
        else setLiftStatus("idle");
        if (targetHeight !== null) {
            // Arrived only once motion has accepted the command and the head
            // has stopped; firing earlier lets a throw race the lift.
            if (!heightRequestPending && !(status.trainer.isLifting ?? false) && $39ffce33b568e8a7$export$d678b2f041cf33b5(status.trainer.height, targetHeight)) {
                (0, $1lMle.default).info(`Desired height ${targetHeight} reached...`);
                setStartedLifting(null);
                setTargetHeight(null);
                setLiftStatus("idle");
                if (onTargetAcheived.current) {
                    (0, $1lMle.default).info("Calling onTargetAcheived callback");
                    onTargetAcheived.current();
                    onTargetAcheived.current = undefined;
                }
            }
            // Clear started lifting if we have gotten a sufficiently up-to-date status
            if (startedLifting !== null && status !== null && status.timestamp.getTime() > startedLifting.getTime() + 6000) setStartedLifting(null);
        }
    }, [
        status,
        isLifting,
        startedLifting,
        targetHeight,
        heightRequestPending,
        setStartedLifting,
        setTargetHeight
    ]);
    const stop = $bh6RR.useCallback(async ()=>{
        try {
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/motors-stop", "POST");
        } catch (ex) {
            (0, $cK0UE.logFetchError)(ex, "Failed to soft stop from useLift > stop method");
        }
    }, [
        status?.clientId
    ]);
    const setHeight = $bh6RR.useCallback(async (height, callback)=>{
        let requestHeight = height;
        if (status?.trainer.height === height) {
            (0, $1lMle.default).info(`Requested height: ${height}, actual height: ${status?.trainer.height} - no change required`);
            if (callback) callback();
            return true;
        }
        if (isLifting) {
            (0, $1lMle.default).warn("Already lifting, ignoring request");
            return false;
        }
        if (height < liftRange.min || height > liftRange.max) {
            requestHeight = $39ffce33b568e8a7$export$4465cd453867bc23(height, liftRange);
            (0, $1lMle.default).warn(`Requested height ${height}in is outside valid range [${liftRange.min}, ${liftRange.max}]in - clamped to ${requestHeight}in`);
        }
        if (callback) {
            (0, $1lMle.default).info("Registered callback for lift complete");
            onTargetAcheived.current = callback;
        }
        setLiftStatus("requested");
        setStartedLifting(status?.timestamp ?? new Date());
        setTargetHeight(requestHeight);
        setHeightRequestPending(true);
        setError(null);
        try {
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/height", "POST", {
                height: requestHeight
            });
            setLiftStatus("pending");
            setIsLifting(true);
            startRapidPoll((0, $ezs3H.RAPID_POLL), (c)=>!c.trainer.isLifting, "lift");
            return true;
        } catch (e) {
            (0, $cK0UE.logFetchError)(e);
            setError(e instanceof Error ? e.message : JSON.stringify(e));
            setLiftStatus("error");
            setStartedLifting(null);
            // Disarm, so a later arrival at this height doesn't run a
            // callback the caller has already given up on.
            setTargetHeight(null);
            onTargetAcheived.current = undefined;
            return false;
        } finally{
            setHeightRequestPending(false);
        }
    }, [
        status,
        isLifting,
        liftRange,
        startRapidPoll
    ]);
    const lowerHead = $bh6RR.useCallback(async ()=>{
        if (isLifting) return;
        setLiftStatus("requested");
        setStartedLifting(status?.timestamp ?? new Date());
        setTargetHeight(liftRange.min);
        setError(null);
        try {
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/lower-head", "POST");
            setLiftStatus("pending");
            setIsLifting(true);
            startRapidPoll((0, $ezs3H.RAPID_POLL), (c)=>!c.trainer.isLifting, "lift");
        } catch (e) {
            (0, $cK0UE.logFetchError)(e);
            setError(e instanceof Error ? e.message : JSON.stringify(e));
            setLiftStatus("error");
            setStartedLifting(null);
        }
    }, [
        status?.clientId,
        isLifting,
        liftRange.min,
        startRapidPoll,
        status?.timestamp
    ]);
    const tickDown = $bh6RR.useCallback(async ()=>{
        if (status === null) return 0;
        const newHeight = Math.max(status.trainer.height - 0.6, liftRange.min);
        await setHeight(newHeight);
        return newHeight;
    }, [
        setHeight,
        liftRange,
        status
    ]);
    const tickUp = $bh6RR.useCallback(async ()=>{
        if (status === null) return 0;
        const newHeight = Math.min(status.trainer.height + 0.6, liftRange.max);
        await setHeight(newHeight);
        return newHeight;
    }, [
        setHeight,
        liftRange,
        status
    ]);
    const clearError = $bh6RR.useCallback(()=>setError(null), []);
    const checkForLift = $bh6RR.useCallback(()=>{
        // only start polling rapidly for lift if the trainer height will change
        if (!$39ffce33b568e8a7$export$d678b2f041cf33b5(status?.trainer.height ?? 0, targetHeight ?? 0)) startRapidPoll((0, $ezs3H.RAPID_POLL), (c)=>!c.trainer.isLifting, "lift");
    }, [
        status?.trainer.height,
        targetHeight,
        startRapidPoll
    ]);
    if (status === null) return {
        down: false,
        error: error,
        hasLift: false,
        height: 0,
        liftRange: liftRange,
        lowerHead: lowerHead,
        liftStatus: liftStatus,
        isLifting: false,
        safeHeight: 50,
        refillHeight: 40,
        setHeight: setHeight,
        stop: stop,
        tickDown: tickDown,
        tickUp: tickUp,
        checkForLift: checkForLift,
        clearError: clearError
    };
    return {
        down: Math.abs(status.trainer.height - liftRange.min) <= 0.5,
        hasLift: status.trainer.lift.state !== "Disabled",
        error: error,
        height: status.trainer.height,
        liftStatus: liftStatus,
        isLifting: isLifting,
        liftRange: liftRange,
        lowerHead: lowerHead,
        safeHeight: 50,
        refillHeight: 40,
        setHeight: setHeight,
        stop: stop,
        tickDown: tickDown,
        tickUp: tickUp,
        checkForLift: checkForLift,
        clearError: clearError
    };
}
function $39ffce33b568e8a7$export$f16f95df8e0a4bc1({ stop: stop, onStopped: onStopped = ()=>{}, targetHeight: targetHeight, message: message }) {
    const { dialogType: dialogType } = (0, $62tuQ.default)();
    const { height: height, isLifting: isLifting } = $39ffce33b568e8a7$export$d243d04afc6219a9();
    const [stopRequested, setStopRequested] = $bh6RR.useState(false);
    const [startHeight, setStartHeight] = $bh6RR.useState();
    const wasLifting = (0, $NbKWd.default)(isLifting);
    $bh6RR.useEffect(()=>{
        if (!wasLifting && isLifting) {
            (0, $1lMle.default).info(`Setting start height for lift dialog: ${height}`);
            setStartHeight(height);
        }
    }, [
        isLifting,
        wasLifting,
        height
    ]);
    const totalLiftDistance = $bh6RR.useMemo(()=>{
        if (targetHeight && startHeight) {
            const dist = Math.abs(startHeight - targetHeight);
            (0, $1lMle.default).info(`Target height provided (${targetHeight}) - lift distance: ${dist}`);
            return dist;
        }
        return undefined;
    }, [
        startHeight,
        targetHeight
    ]);
    const percent = $bh6RR.useMemo(()=>{
        if (targetHeight && totalLiftDistance) {
            const distanceLeft = Math.abs(height - targetHeight);
            const complete = 100 - Math.round(distanceLeft / totalLiftDistance * 100);
            return complete;
        }
        return undefined;
    }, [
        totalLiftDistance,
        targetHeight,
        height
    ]);
    // we don't want to open this lift dialog when we doing a diagnostic flow lift
    const diagnosticDialogOpen = $bh6RR.useMemo(()=>dialogType !== null, [
        dialogType
    ]);
    const handleStop = $bh6RR.useCallback(async ()=>{
        setStopRequested(true);
        await stop();
    }, [
        stop
    ]);
    $bh6RR.useEffect(()=>{
        if (stopRequested && !isLifting) {
            setStopRequested(false);
            if (onStopped) onStopped();
        }
    }, [
        stopRequested,
        isLifting,
        onStopped
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dUgAK.default), {
        open: isLifting && !diagnosticDialogOpen,
        fullWidth: true,
        maxWidth: false,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eLohH.default), {
                variant: "h4",
                color: "primary.main",
                sx: {
                    p: 2
                },
                children: "Moving Trainer Arm"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                dividers: true,
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                            children: message && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                variant: "body2",
                                textAlign: "center",
                                children: message
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                            sx: {
                                margin: "auto",
                                textAlign: "center",
                                position: "relative"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                                    variant: targetHeight ? "determinate" : "indeterminate",
                                    value: percent,
                                    size: 80,
                                    sx: {
                                        color: "primary.light"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                    sx: {
                                        top: 0,
                                        left: 0,
                                        bottom: 0,
                                        right: 0,
                                        position: "absolute",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                        variant: "caption",
                                        component: "div",
                                        color: "primary.light",
                                        children: `${height}in`
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                        variant: "contained",
                                        color: "error",
                                        onClick: handleStop,
                                        loading: stopRequested,
                                        children: "Stop"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

});
parcelRegister("7ybf3", function(module, exports) {

$parcel$export(module.exports, "DefaultRanges", function () { return $e59cc2be2841a8f2$export$8b9442ae9a98b102; });
$parcel$export(module.exports, "default", function () { return $e59cc2be2841a8f2$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $ezs3H = parcelRequire("ezs3H");
const $e59cc2be2841a8f2$export$8b9442ae9a98b102 = {
    pan: {
        min: -34,
        max: 34
    },
    lift: {
        min: 32.6,
        max: 86.6
    },
    tilt: {
        min: -38,
        max: 56
    },
    wheels: {
        min: 300,
        max: 5000
    }
};
function $e59cc2be2841a8f2$export$2e2bcd8739ae039() {
    const { status: status } = (0, $ezs3H.useStatus)();
    const wheels = $bh6RR.useMemo(()=>{
        return status?.trainer.wheels.top.range ?? $e59cc2be2841a8f2$export$8b9442ae9a98b102.wheels;
    }, [
        status?.trainer.wheels.top.range
    ]);
    return {
        lift: status?.trainer.lift.range ?? $e59cc2be2841a8f2$export$8b9442ae9a98b102.lift,
        pan: status?.trainer.pan.range ?? $e59cc2be2841a8f2$export$8b9442ae9a98b102.pan,
        tilt: status?.trainer.tilt.range ?? $e59cc2be2841a8f2$export$8b9442ae9a98b102.tilt,
        wheels: wheels
    };
}

});

parcelRegister("NbKWd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dac519888ae94fc4$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
function $dac519888ae94fc4$export$2e2bcd8739ae039(value) {
    const [previous, setPrevious] = $bh6RR.useState(value);
    $bh6RR.useEffect(()=>{
        setPrevious(value);
    }, [
        value
    ]);
    return previous;
}

});


parcelRegister("gqoJ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7391d40beaadbc6a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $62tuQ = parcelRequire("62tuQ");
function $7391d40beaadbc6a$export$2e2bcd8739ae039() {
    const { setDisableOnClose: setDisableOnClose } = (0, $62tuQ.default)();
    $bh6RR.useEffect(()=>{
        setDisableOnClose(true);
        return ()=>{
            setDisableOnClose(false);
        };
    }, [
        setDisableOnClose
    ]);
}

});


parcelRegister("aCyHi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b69e4cfd16e33ec2$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $dUgAK = parcelRequire("dUgAK");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $hrqHU = parcelRequire("hrqHU");

var $cbFbS = parcelRequire("cbFbS");

var $kE5Kn = parcelRequire("kE5Kn");

var $1lMle = parcelRequire("1lMle");

var $e8yyN = parcelRequire("e8yyN");
parcelRequire("cFAEN");
var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $dkPRN = parcelRequire("dkPRN");
function $b69e4cfd16e33ec2$export$2e2bcd8739ae039({ open: open, onClose: onClose, journeyType: journeyType, metadata: metadata }) {
    const [rating, setRating] = $bh6RR.useState(null);
    const [comment, setComment] = $bh6RR.useState("");
    const [submitting, setSubmitting] = $bh6RR.useState(false);
    const [apiError, setApiError] = $bh6RR.useState("");
    const handleSubmit = async ()=>{
        if (!rating) return;
        setSubmitting(true);
        setApiError("");
        const payload = {
            rating: rating,
            comment: comment || null,
            type: journeyType,
            metadata: metadata
        };
        try {
            await (0, $cK0UE.default)("/api/feedback/journey", "POST", payload);
            setRating(null);
            setComment("");
            onClose();
        } catch (e) {
            (0, $1lMle.default).error("Error submitting journey feedback", e);
            setApiError("Failed to submit feedback. Please try again.");
        } finally{
            setSubmitting(false);
        }
    };
    const label = journeyType === "assessment" ? "assessment" : "classes";
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $kE5Kn.default), {
        theme: (0, $e8yyN.default),
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dUgAK.default), {
            open: open,
            onClose: onClose,
            maxWidth: "sm",
            fullWidth: true,
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $jP5af.default), {
                    onClose: onClose,
                    children: [
                        "How was your ",
                        label,
                        " experience?"
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                            display: "flex",
                            justifyContent: "center",
                            component: "div",
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dkPRN.default), {
                                name: "journey-feedback-rating",
                                value: rating,
                                onChange: (_, newValue)=>setRating(newValue),
                                sx: {
                                    fontSize: "3rem",
                                    mb: 4
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $hrqHU.default), {
                            id: "journey-feedback-comment",
                            label: "Additional Comments",
                            type: "text",
                            fullWidth: true,
                            multiline: true,
                            rows: 3,
                            value: comment,
                            onChange: (e)=>setComment(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                onClick: handleSubmit,
                                color: "primary",
                                disabled: rating === null,
                                loading: submitting,
                                fullWidth: true,
                                children: "Submit"
                            }),
                            apiError && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                variant: "body2",
                                color: "error",
                                sx: {
                                    mt: 1,
                                    textAlign: "center"
                                },
                                role: "alert",
                                children: apiError
                            })
                        ]
                    })
                })
            ]
        })
    });
}

});
parcelRegister("hrqHU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb29acc1e6ba2d96$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $dDKx6 = parcelRequire("dDKx6");


var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $kUC3W = parcelRequire("kUC3W");

var $dKnfZ = parcelRequire("dKnfZ");

var $bBIWr = parcelRequire("bBIWr");

var $4IPS4 = parcelRequire("4IPS4");

var $1TxeB = parcelRequire("1TxeB");

var $aS3px = parcelRequire("aS3px");

var $84xZD = parcelRequire("84xZD");

var $iVhON = parcelRequire("iVhON");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
const $cb29acc1e6ba2d96$var$variantComponent = {
    standard: (0, $kUC3W.default),
    filled: (0, $dKnfZ.default),
    outlined: (0, $bBIWr.default)
};
const $cb29acc1e6ba2d96$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $iVhON.getTextFieldUtilityClass), classes);
};
const $cb29acc1e6ba2d96$var$TextFieldRoot = (0, $l0oRz.default)((0, $1TxeB.default), {
    name: 'MuiTextField',
    slot: 'Root'
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $cb29acc1e6ba2d96$var$TextField = /*#__PURE__*/ $bh6RR.forwardRef(function TextField(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $cb29acc1e6ba2d96$var$useUtilityClasses(ownerState);
    const id = (0, $dDKx6.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $cb29acc1e6ba2d96$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, $dFvJW.default)('root', {
        elementType: $cb29acc1e6ba2d96$var$TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    });
    const [InputSlot, inputProps] = (0, $dFvJW.default)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $dFvJW.default)('inputLabel', {
        elementType: (0, $4IPS4.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $dFvJW.default)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $dFvJW.default)('formHelperText', {
        elementType: (0, $aS3px.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $dFvJW.default)('select', {
        elementType: (0, $84xZD.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $ih19M.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $ih19M.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $ih19M.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $ih19M.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $cb29acc1e6ba2d96$export$2e2bcd8739ae039 = $cb29acc1e6ba2d96$var$TextField;

});
parcelRegister("kUC3W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f396900d6ba62954$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $96ZcP = parcelRequire("96ZcP");

var $5syur = parcelRequire("5syur");


var $cVsvh = parcelRequire("cVsvh");

var $b6vKX = parcelRequire("b6vKX");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $4B5Or = parcelRequire("4B5Or");

var $OEXBZ = parcelRequire("OEXBZ");

var $9K13D = parcelRequire("9K13D");

var $cVsvh = parcelRequire("cVsvh");

var $ih19M = parcelRequire("ih19M");
'use client';
const $f396900d6ba62954$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $9K13D.getInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $f396900d6ba62954$var$InputRoot = (0, $l0oRz.default)((0, $cVsvh.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $b6vKX.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $cVsvh.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline);
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $9K13D.default).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $9K13D.default).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $9K13D.default).disabled}, .${(0, $9K13D.default).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $9K13D.default).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $f396900d6ba62954$var$InputInput = (0, $l0oRz.default)((0, $cVsvh.InputBaseInput), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $cVsvh.inputOverridesResolver)
})({});
const $f396900d6ba62954$var$Input = /*#__PURE__*/ $bh6RR.forwardRef(function Input(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $f396900d6ba62954$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $5syur.default)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $f396900d6ba62954$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $f396900d6ba62954$var$InputInput;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cVsvh.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$f396900d6ba62954$var$Input.muiName = 'Input';
var $f396900d6ba62954$export$2e2bcd8739ae039 = $f396900d6ba62954$var$Input;

});
parcelRegister("9K13D", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", function () { return $71793af2acc5bd07$export$cdb270390122322b; });
$parcel$export(module.exports, "default", function () { return $71793af2acc5bd07$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");

var $auhFG = parcelRequire("auhFG");
function $71793af2acc5bd07$export$cdb270390122322b(slot) {
    return (0, $dmzXD.default)('MuiInput', slot);
}
const $71793af2acc5bd07$var$inputClasses = {
    ...(0, $auhFG.default),
    ...(0, $fYlYP.default)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $71793af2acc5bd07$export$2e2bcd8739ae039 = $71793af2acc5bd07$var$inputClasses;

});


parcelRegister("dKnfZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0219c8d8ab1171c$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $5syur = parcelRequire("5syur");



var $96ZcP = parcelRequire("96ZcP");

var $cVsvh = parcelRequire("cVsvh");

var $b6vKX = parcelRequire("b6vKX");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $4B5Or = parcelRequire("4B5Or");

var $OEXBZ = parcelRequire("OEXBZ");

var $dMXQH = parcelRequire("dMXQH");

var $cVsvh = parcelRequire("cVsvh");

var $krx4P = parcelRequire("krx4P");

var $ih19M = parcelRequire("ih19M");
'use client';
const $a0219c8d8ab1171c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $krx4P.default)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $dMXQH.getFilledInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $a0219c8d8ab1171c$var$FilledInputRoot = (0, $l0oRz.default)((0, $cVsvh.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $b6vKX.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $cVsvh.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $dMXQH.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $dMXQH.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $dMXQH.default).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $dMXQH.default).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline) : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $dMXQH.default).disabled}, .${(0, $dMXQH.default).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $dMXQH.default).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $a0219c8d8ab1171c$var$FilledInputInput = (0, $l0oRz.default)((0, $cVsvh.InputBaseInput), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $cVsvh.inputOverridesResolver)
})((0, $gfPc7.default)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $a0219c8d8ab1171c$var$FilledInput = /*#__PURE__*/ $bh6RR.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $a0219c8d8ab1171c$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $5syur.default)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $a0219c8d8ab1171c$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $a0219c8d8ab1171c$var$FilledInputInput;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cVsvh.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$a0219c8d8ab1171c$var$FilledInput.muiName = 'Input';
var $a0219c8d8ab1171c$export$2e2bcd8739ae039 = $a0219c8d8ab1171c$var$FilledInput;

});
parcelRegister("dMXQH", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", function () { return $a09e2ed1d854b346$export$3331e419f1a48437; });
$parcel$export(module.exports, "default", function () { return $a09e2ed1d854b346$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");

var $auhFG = parcelRequire("auhFG");
function $a09e2ed1d854b346$export$3331e419f1a48437(slot) {
    return (0, $dmzXD.default)('MuiFilledInput', slot);
}
const $a09e2ed1d854b346$var$filledInputClasses = {
    ...(0, $auhFG.default),
    ...(0, $fYlYP.default)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $a09e2ed1d854b346$export$2e2bcd8739ae039 = $a09e2ed1d854b346$var$filledInputClasses;

});


parcelRegister("bBIWr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $022e4a5e67a36acd$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");



var $96ZcP = parcelRequire("96ZcP");

var $i08EF = parcelRequire("i08EF");

var $1BiIF = parcelRequire("1BiIF");

var $jZFy8 = parcelRequire("jZFy8");

var $b6vKX = parcelRequire("b6vKX");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $4B5Or = parcelRequire("4B5Or");

var $OEXBZ = parcelRequire("OEXBZ");

var $2mXTA = parcelRequire("2mXTA");

var $cVsvh = parcelRequire("cVsvh");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
const $022e4a5e67a36acd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $2mXTA.getOutlinedInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $022e4a5e67a36acd$var$OutlinedInputRoot = (0, $l0oRz.default)((0, $cVsvh.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $b6vKX.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $cVsvh.rootOverridesResolver)
})((0, $gfPc7.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $2mXTA.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $2mXTA.default).notchedOutline}`]: {
                borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
            }
        },
        [`&.${(0, $2mXTA.default).focused} .${(0, $2mXTA.default).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $2mXTA.default).focused} .${(0, $2mXTA.default).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to override the above style
                style: {
                    [`&.${(0, $2mXTA.default).error} .${(0, $2mXTA.default).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $2mXTA.default).disabled} .${(0, $2mXTA.default).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $022e4a5e67a36acd$var$NotchedOutlineRoot = (0, $l0oRz.default)((0, $i08EF.default), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline'
})((0, $gfPc7.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
    };
}));
const $022e4a5e67a36acd$var$OutlinedInputInput = (0, $l0oRz.default)((0, $cVsvh.InputBaseInput), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $cVsvh.inputOverridesResolver)
})((0, $gfPc7.default)(({ theme: theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $022e4a5e67a36acd$var$OutlinedInput = /*#__PURE__*/ $bh6RR.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, slotProps: slotProps = {}, type: type = 'text', ...other } = props;
    const classes = $022e4a5e67a36acd$var$useUtilityClasses(props);
    const muiFormControl = (0, $1BiIF.default)();
    const fcs = (0, $jZFy8.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $022e4a5e67a36acd$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $022e4a5e67a36acd$var$OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, $dFvJW.default)('notchedOutline', {
        elementType: $022e4a5e67a36acd$var$NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cVsvh.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ih19M.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
$022e4a5e67a36acd$var$OutlinedInput.muiName = 'Input';
var $022e4a5e67a36acd$export$2e2bcd8739ae039 = $022e4a5e67a36acd$var$OutlinedInput;

});
parcelRegister("i08EF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1aef0c11b3ba606$export$2e2bcd8739ae039; });


var $b6vKX = parcelRequire("b6vKX");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $d1aef0c11b3ba606$var$_span;
const $d1aef0c11b3ba606$var$NotchedOutlineRoot = (0, $l0oRz.default)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $b6vKX.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $d1aef0c11b3ba606$var$NotchedOutlineLegend = (0, $l0oRz.default)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $b6vKX.default)
})((0, $gfPc7.default)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
function $d1aef0c11b3ba606$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)($d1aef0c11b3ba606$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($d1aef0c11b3ba606$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                children: label
            }) : $d1aef0c11b3ba606$var$_span || ($d1aef0c11b3ba606$var$_span = /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}

});

parcelRegister("2mXTA", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", function () { return $1b9c18d66f91616b$export$89922944c7227687; });
$parcel$export(module.exports, "default", function () { return $1b9c18d66f91616b$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");

var $auhFG = parcelRequire("auhFG");
function $1b9c18d66f91616b$export$89922944c7227687(slot) {
    return (0, $dmzXD.default)('MuiOutlinedInput', slot);
}
const $1b9c18d66f91616b$var$outlinedInputClasses = {
    ...(0, $auhFG.default),
    ...(0, $fYlYP.default)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $1b9c18d66f91616b$export$2e2bcd8739ae039 = $1b9c18d66f91616b$var$outlinedInputClasses;

});


parcelRegister("4IPS4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37038202e2788d3c$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $96ZcP = parcelRequire("96ZcP");

var $aPsoC = parcelRequire("aPsoC");

var $jZFy8 = parcelRequire("jZFy8");

var $1BiIF = parcelRequire("1BiIF");

var $3j95e = parcelRequire("3j95e");
var $bnna6 = parcelRequire("bnna6");

var $krx4P = parcelRequire("krx4P");

var $b6vKX = parcelRequire("b6vKX");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $ejZMX = parcelRequire("ejZMX");

var $ih19M = parcelRequire("ih19M");
'use client';
const $37038202e2788d3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'medium' && `size${(0, $krx4P.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $ejZMX.getInputLabelUtilityClasses), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $37038202e2788d3c$var$InputLabelRoot = (0, $l0oRz.default)((0, $3j95e.default), {
    shouldForwardProp: (prop)=>(0, $b6vKX.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $bnna6.default).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $37038202e2788d3c$var$InputLabel = /*#__PURE__*/ $bh6RR.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $1BiIF.default)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $jZFy8.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $37038202e2788d3c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($37038202e2788d3c$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $aPsoC.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $37038202e2788d3c$export$2e2bcd8739ae039 = $37038202e2788d3c$var$InputLabel;

});
parcelRegister("3j95e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $268a313b29de9934$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $jZFy8 = parcelRequire("jZFy8");

var $1BiIF = parcelRequire("1BiIF");

var $krx4P = parcelRequire("krx4P");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $4B5Or = parcelRequire("4B5Or");

var $OEXBZ = parcelRequire("OEXBZ");

var $bnna6 = parcelRequire("bnna6");

var $ih19M = parcelRequire("ih19M");
'use client';
const $268a313b29de9934$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $krx4P.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $bnna6.getFormLabelUtilityClasses), classes);
};
const $268a313b29de9934$export$aa5bc7f8a4705b27 = (0, $l0oRz.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $bnna6.default).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $bnna6.default).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $bnna6.default).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $268a313b29de9934$var$AsteriskComponent = (0, $l0oRz.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk'
})((0, $gfPc7.default)(({ theme: theme })=>({
        [`&.${(0, $bnna6.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $268a313b29de9934$var$FormLabel = /*#__PURE__*/ $bh6RR.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $1BiIF.default)();
    const fcs = (0, $jZFy8.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $268a313b29de9934$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($268a313b29de9934$export$aa5bc7f8a4705b27, {
        as: component,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ih19M.jsxs)($268a313b29de9934$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var $268a313b29de9934$export$2e2bcd8739ae039 = $268a313b29de9934$var$FormLabel;

});
parcelRegister("bnna6", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", function () { return $8483cf2d7acd6f6f$export$f7d501e40371cd17; });
$parcel$export(module.exports, "default", function () { return $8483cf2d7acd6f6f$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $8483cf2d7acd6f6f$export$f7d501e40371cd17(slot) {
    return (0, $dmzXD.default)('MuiFormLabel', slot);
}
const $8483cf2d7acd6f6f$var$formLabelClasses = (0, $fYlYP.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $8483cf2d7acd6f6f$export$2e2bcd8739ae039 = $8483cf2d7acd6f6f$var$formLabelClasses;

});


parcelRegister("ejZMX", function(module, exports) {

$parcel$export(module.exports, "getInputLabelUtilityClasses", function () { return $a6d2c4ffbcbf2e15$export$c1c4b4545ad2ea5f; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $a6d2c4ffbcbf2e15$export$c1c4b4545ad2ea5f(slot) {
    return (0, $dmzXD.default)('MuiInputLabel', slot);
}
const $a6d2c4ffbcbf2e15$var$inputLabelClasses = (0, $fYlYP.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $a6d2c4ffbcbf2e15$export$2e2bcd8739ae039 = $a6d2c4ffbcbf2e15$var$inputLabelClasses;

});


parcelRegister("1TxeB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1614b534859274fd$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $eC5hG = parcelRequire("eC5hG");

var $krx4P = parcelRequire("krx4P");

var $kN5Np = parcelRequire("kN5Np");

var $4Iacp = parcelRequire("4Iacp");

var $4nNKy = parcelRequire("4nNKy");

var $ih19M = parcelRequire("ih19M");
'use client';
const $1614b534859274fd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $krx4P.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $4nNKy.getFormControlUtilityClasses), classes);
};
const $1614b534859274fd$var$FormControlRoot = (0, $l0oRz.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $krx4P.default)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $1614b534859274fd$var$FormControl = /*#__PURE__*/ $bh6RR.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $1614b534859274fd$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $bh6RR.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $bh6RR.Children.forEach(children, (child)=>{
            if (!(0, $kN5Np.default)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $kN5Np.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $eC5hG.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $bh6RR.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $bh6RR.Children.forEach(children, (child)=>{
            if (!(0, $kN5Np.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $eC5hG.isFilled)(child.props, true) || (0, $eC5hG.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $bh6RR.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $bh6RR.useRef(false);
    const onFilled = $bh6RR.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $bh6RR.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = $bh6RR.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty: onEmpty,
            onFilled: onFilled,
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $4Iacp.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($1614b534859274fd$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $aPsoC.default)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $1614b534859274fd$export$2e2bcd8739ae039 = $1614b534859274fd$var$FormControl;

});
parcelRegister("kN5Np", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f22ce12fab313a2a$export$2e2bcd8739ae039; });

var $elIq5 = parcelRequire("elIq5");
var $f22ce12fab313a2a$export$2e2bcd8739ae039 = (0, $elIq5.default);

});
parcelRegister("elIq5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7257bb234da275b$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
function $a7257bb234da275b$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $bh6RR.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

});


parcelRegister("4nNKy", function(module, exports) {

$parcel$export(module.exports, "getFormControlUtilityClasses", function () { return $330fe6b5f34b4581$export$149c8b8bab2289d1; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $330fe6b5f34b4581$export$149c8b8bab2289d1(slot) {
    return (0, $dmzXD.default)('MuiFormControl', slot);
}
const $330fe6b5f34b4581$var$formControlClasses = (0, $fYlYP.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $330fe6b5f34b4581$export$2e2bcd8739ae039 = $330fe6b5f34b4581$var$formControlClasses;

});


parcelRegister("aS3px", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ea197e2ba53d10d$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $jZFy8 = parcelRequire("jZFy8");

var $1BiIF = parcelRequire("1BiIF");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $krx4P = parcelRequire("krx4P");

var $5S3lV = parcelRequire("5S3lV");

var $ih19M = parcelRequire("ih19M");
'use client';
var $7ea197e2ba53d10d$var$_span;
const $7ea197e2ba53d10d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $krx4P.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $5S3lV.getFormHelperTextUtilityClasses), classes);
};
const $7ea197e2ba53d10d$var$FormHelperTextRoot = (0, $l0oRz.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $krx4P.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $5S3lV.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $5S3lV.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $7ea197e2ba53d10d$var$FormHelperText = /*#__PURE__*/ $bh6RR.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $1BiIF.default)();
    const fcs = (0, $jZFy8.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $7ea197e2ba53d10d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($7ea197e2ba53d10d$var$FormHelperTextRoot, {
        as: component,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? $7ea197e2ba53d10d$var$_span || ($7ea197e2ba53d10d$var$_span = /*#__PURE__*/ (0, $ih19M.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var $7ea197e2ba53d10d$export$2e2bcd8739ae039 = $7ea197e2ba53d10d$var$FormHelperText;

});
parcelRegister("5S3lV", function(module, exports) {

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", function () { return $446498acc19c6022$export$a394fa61b1d583a9; });
$parcel$export(module.exports, "default", function () { return $446498acc19c6022$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $446498acc19c6022$export$a394fa61b1d583a9(slot) {
    return (0, $dmzXD.default)('MuiFormHelperText', slot);
}
const $446498acc19c6022$var$formHelperTextClasses = (0, $fYlYP.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $446498acc19c6022$export$2e2bcd8739ae039 = $446498acc19c6022$var$formHelperTextClasses;

});


parcelRegister("84xZD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e0910c9cf16bdc6$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $5syur = parcelRequire("5syur");

var $96ZcP = parcelRequire("96ZcP");

var $20D76 = parcelRequire("20D76");

var $i0VNS = parcelRequire("i0VNS");

var $jZFy8 = parcelRequire("jZFy8");

var $1BiIF = parcelRequire("1BiIF");

var $98F34 = parcelRequire("98F34");

var $kUC3W = parcelRequire("kUC3W");

var $dPQL7 = parcelRequire("dPQL7");

var $dKnfZ = parcelRequire("dKnfZ");

var $bBIWr = parcelRequire("bBIWr");

var $OEXBZ = parcelRequire("OEXBZ");

var $dg012 = parcelRequire("dg012");

var $l0oRz = parcelRequire("l0oRz");

var $b6vKX = parcelRequire("b6vKX");

var $dapNI = parcelRequire("dapNI");

var $ih19M = parcelRequire("ih19M");
'use client';
const $5e0910c9cf16bdc6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $dapNI.getSelectUtilityClasses), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $5e0910c9cf16bdc6$var$styledRootConfig = {
    name: 'MuiSelect',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $b6vKX.default)(prop) && prop !== 'variant'
};
const $5e0910c9cf16bdc6$var$StyledInput = (0, $l0oRz.default)((0, $kUC3W.default), $5e0910c9cf16bdc6$var$styledRootConfig)('');
const $5e0910c9cf16bdc6$var$StyledOutlinedInput = (0, $l0oRz.default)((0, $bBIWr.default), $5e0910c9cf16bdc6$var$styledRootConfig)('');
const $5e0910c9cf16bdc6$var$StyledFilledInput = (0, $l0oRz.default)((0, $dKnfZ.default), $5e0910c9cf16bdc6$var$styledRootConfig)('');
const $5e0910c9cf16bdc6$var$Select = /*#__PURE__*/ $bh6RR.forwardRef(function Select(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $98F34.default), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? (0, $dPQL7.default) : (0, $i0VNS.default);
    const muiFormControl = (0, $1BiIF.default)();
    const fcs = (0, $jZFy8.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $5e0910c9cf16bdc6$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $ih19M.jsx)($5e0910c9cf16bdc6$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $ih19M.jsx)($5e0910c9cf16bdc6$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $ih19M.jsx)($5e0910c9cf16bdc6$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $dg012.default)(ref, (0, $20D76.default)(InputComponent));
    return /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Fragment, {
        children: /*#__PURE__*/ $bh6RR.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, $5syur.default)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $aPsoC.default)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$5e0910c9cf16bdc6$var$Select.muiName = 'Select';
var $5e0910c9cf16bdc6$export$2e2bcd8739ae039 = $5e0910c9cf16bdc6$var$Select;

});
parcelRegister("i0VNS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1d510aa6a32f1a5$export$2e2bcd8739ae039; });

var $avV9A = parcelRequire("avV9A");

var $bh6RR = parcelRequire("bh6RR");



var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $dDKx6 = parcelRequire("dDKx6");


var $7ThAM = parcelRequire("7ThAM");

var $krx4P = parcelRequire("krx4P");

var $l2qS8 = parcelRequire("l2qS8");

var $dPQL7 = parcelRequire("dPQL7");

var $eC5hG = parcelRequire("eC5hG");

var $l0oRz = parcelRequire("l0oRz");

var $52dC4 = parcelRequire("52dC4");

var $dg012 = parcelRequire("dg012");

var $8ANil = parcelRequire("8ANil");

var $dapNI = parcelRequire("dapNI");

var $ih19M = parcelRequire("ih19M");
'use client';
var $d1d510aa6a32f1a5$var$_span;
const $d1d510aa6a32f1a5$var$SelectSelect = (0, $l0oRz.default)((0, $dPQL7.StyledSelectSelect), {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $dapNI.default).select}`]: styles.select
            },
            {
                [`&.${(0, $dapNI.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $dapNI.default).error}`]: styles.error
            },
            {
                [`&.${(0, $dapNI.default).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $dapNI.default).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $d1d510aa6a32f1a5$var$SelectIcon = (0, $l0oRz.default)((0, $dPQL7.StyledSelectIcon), {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $krx4P.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $d1d510aa6a32f1a5$var$SelectNativeInput = (0, $l0oRz.default)('input', {
    shouldForwardProp: (prop)=>(0, $52dC4.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput'
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $d1d510aa6a32f1a5$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $d1d510aa6a32f1a5$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $d1d510aa6a32f1a5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $krx4P.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $dapNI.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $d1d510aa6a32f1a5$var$SelectInput = /*#__PURE__*/ $bh6RR.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, $8ANil.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $8ANil.default)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $bh6RR.useRef(null);
    const displayRef = $bh6RR.useRef(null);
    const [displayNode, setDisplayNode] = $bh6RR.useState(null);
    const { current: isOpenControlled } = $bh6RR.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $bh6RR.useState();
    const handleRef = (0, $dg012.default)(ref, inputRefProp);
    const handleDisplayRef = $bh6RR.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $bh6RR.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $bh6RR.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $bh6RR.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $bh6RR.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $7ThAM.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $bh6RR.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $eC5hG.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $bh6RR.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $avV9A.default)(2));
            selected = value.some((v)=>$d1d510aa6a32f1a5$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $d1d510aa6a32f1a5$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $bh6RR.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $d1d510aa6a32f1a5$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...typeof MenuProps.slotProps?.paper === 'function' ? MenuProps.slotProps.paper(ownerState) : MenuProps.slotProps?.paper
    };
    const listProps = {
        ...MenuProps.MenuListProps,
        ...typeof MenuProps.slotProps?.list === 'function' ? MenuProps.slotProps.list(ownerState) : MenuProps.slotProps?.list
    };
    const listboxId = (0, $dDKx6.default)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($d1d510aa6a32f1a5$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $aPsoC.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $d1d510aa6a32f1a5$var$isEmpty(display) ? $d1d510aa6a32f1a5$var$_span || ($d1d510aa6a32f1a5$var$_span = /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)($d1d510aa6a32f1a5$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)($d1d510aa6a32f1a5$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $l2qS8.default), {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                slotProps: {
                    ...MenuProps.slotProps,
                    list: {
                        'aria-labelledby': labelId,
                        role: 'listbox',
                        'aria-multiselectable': multiple ? 'true' : undefined,
                        disableListWrap: true,
                        id: listboxId,
                        ...listProps
                    },
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $d1d510aa6a32f1a5$export$2e2bcd8739ae039 = $d1d510aa6a32f1a5$var$SelectInput;

});
parcelRegister("7ThAM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5beb50e6cb639e8e$export$2e2bcd8739ae039; });

var $8HMMM = parcelRequire("8HMMM");
var $5beb50e6cb639e8e$export$2e2bcd8739ae039 = (0, $8HMMM.default);

});

parcelRegister("l2qS8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f50ea11ed066a4b4$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");



var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");


var $am2yJ = parcelRequire("am2yJ");

var $l0eKO = parcelRequire("l0eKO");

var $kfVel = parcelRequire("kfVel");

var $7JfUx = parcelRequire("7JfUx");

var $b6vKX = parcelRequire("b6vKX");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $5FT45 = parcelRequire("5FT45");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
const $f50ea11ed066a4b4$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $f50ea11ed066a4b4$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $f50ea11ed066a4b4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $5FT45.getMenuUtilityClass), classes);
};
const $f50ea11ed066a4b4$var$MenuRoot = (0, $l0oRz.default)((0, $7JfUx.default), {
    shouldForwardProp: (prop)=>(0, $b6vKX.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root'
})({});
const $f50ea11ed066a4b4$export$4f7c51a5920c9f33 = (0, $l0oRz.default)((0, $7JfUx.PopoverPaper), {
    name: 'MuiMenu',
    slot: 'Paper'
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $f50ea11ed066a4b4$var$MenuMenuList = (0, $l0oRz.default)((0, $kfVel.default), {
    name: 'MuiMenu',
    slot: 'List'
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $f50ea11ed066a4b4$var$Menu = /*#__PURE__*/ $bh6RR.forwardRef(function Menu(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $am2yJ.useRtl)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $f50ea11ed066a4b4$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $bh6RR.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $bh6RR.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $bh6RR.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, $l0eKO.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $dFvJW.default)('paper', {
        className: classes.paper,
        elementType: $f50ea11ed066a4b4$export$4f7c51a5920c9f33,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $dFvJW.default)('list', {
        className: (0, $aPsoC.default)(classes.list, MenuListProps.className),
        elementType: $f50ea11ed066a4b4$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $ih19M.jsx)($f50ea11ed066a4b4$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $f50ea11ed066a4b4$var$RTL_ORIGIN : $f50ea11ed066a4b4$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $ih19M.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var $f50ea11ed066a4b4$export$2e2bcd8739ae039 = $f50ea11ed066a4b4$var$Menu;

});
parcelRegister("l0eKO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4a50aee12010e22$export$2e2bcd8739ae039; });

var $6RXey = parcelRequire("6RXey");

var $kx46n = parcelRequire("kx46n");

var $aF9o1 = parcelRequire("aF9o1");

var $78QIe = parcelRequire("78QIe");
'use client';
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $f4a50aee12010e22$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $78QIe.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $aF9o1.default)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $6RXey.default)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $kx46n.default)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $f4a50aee12010e22$export$2e2bcd8739ae039 = $f4a50aee12010e22$var$useSlotProps;

});

parcelRegister("kfVel", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebf19a19b5abb8f0$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");



var $7ThAM = parcelRequire("7ThAM");

var $iZWBy = parcelRequire("iZWBy");

var $gJLCY = parcelRequire("gJLCY");

var $dg012 = parcelRequire("dg012");

var $14LyK = parcelRequire("14LyK");

var $7tCBy = parcelRequire("7tCBy");

var $ih19M = parcelRequire("ih19M");
'use client';
function $ebf19a19b5abb8f0$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $ebf19a19b5abb8f0$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $ebf19a19b5abb8f0$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $ebf19a19b5abb8f0$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$ebf19a19b5abb8f0$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $ebf19a19b5abb8f0$var$MenuList = /*#__PURE__*/ $bh6RR.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $bh6RR.useRef(null);
    const textCriteriaRef = $bh6RR.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $14LyK.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $bh6RR.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $gJLCY.default)((0, $7tCBy.default)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $7ThAM.default)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $ebf19a19b5abb8f0$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $ebf19a19b5abb8f0$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $ebf19a19b5abb8f0$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $ebf19a19b5abb8f0$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $ebf19a19b5abb8f0$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $ebf19a19b5abb8f0$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $ebf19a19b5abb8f0$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $ebf19a19b5abb8f0$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $ebf19a19b5abb8f0$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $ebf19a19b5abb8f0$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $ebf19a19b5abb8f0$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $dg012.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $bh6RR.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $bh6RR.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $bh6RR.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $bh6RR.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $iZWBy.default), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $ebf19a19b5abb8f0$export$2e2bcd8739ae039 = $ebf19a19b5abb8f0$var$MenuList;

});
parcelRegister("iZWBy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd4b622ab4cc26cb$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $bvRvQ = parcelRequire("bvRvQ");

var $cjmbe = parcelRequire("cjmbe");

var $ih19M = parcelRequire("ih19M");
'use client';
const $dd4b622ab4cc26cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $cjmbe.getListUtilityClass), classes);
};
const $dd4b622ab4cc26cb$var$ListRoot = (0, $l0oRz.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $dd4b622ab4cc26cb$var$List = /*#__PURE__*/ $bh6RR.forwardRef(function List(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $bh6RR.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $dd4b622ab4cc26cb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $bvRvQ.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)($dd4b622ab4cc26cb$var$ListRoot, {
            as: component,
            className: (0, $aPsoC.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $dd4b622ab4cc26cb$export$2e2bcd8739ae039 = $dd4b622ab4cc26cb$var$List;

});
parcelRegister("bvRvQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $861c197319488196$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
/**
 * @ignore - internal component.
 */ const $861c197319488196$var$ListContext = /*#__PURE__*/ $bh6RR.createContext({});
var $861c197319488196$export$2e2bcd8739ae039 = $861c197319488196$var$ListContext;

});

parcelRegister("cjmbe", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", function () { return $8f6876e3833630a7$export$c6bd6795ed6e3203; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $8f6876e3833630a7$export$c6bd6795ed6e3203(slot) {
    return (0, $dmzXD.default)('MuiList', slot);
}
const $8f6876e3833630a7$var$listClasses = (0, $fYlYP.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $8f6876e3833630a7$export$2e2bcd8739ae039 = $8f6876e3833630a7$var$listClasses;

});


parcelRegister("gJLCY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2f5cb24d4935116$export$2e2bcd8739ae039; });

var $bwV8G = parcelRequire("bwV8G");
var $c2f5cb24d4935116$export$2e2bcd8739ae039 = (0, $bwV8G.default);

});

parcelRegister("7tCBy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57192fef19970e19$export$2e2bcd8739ae039; });

var $4CDSV = parcelRequire("4CDSV");
var $57192fef19970e19$export$2e2bcd8739ae039 = (0, $4CDSV.default);

});


parcelRegister("7JfUx", function(module, exports) {

$parcel$export(module.exports, "PopoverPaper", function () { return $5a0913f1afe7442b$export$821346c38a2d9390; });
$parcel$export(module.exports, "default", function () { return $5a0913f1afe7442b$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");






var $g0K0l = parcelRequire("g0K0l");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $8I3yK = parcelRequire("8I3yK");

var $7ThAM = parcelRequire("7ThAM");

var $7tCBy = parcelRequire("7tCBy");

var $3BTDi = parcelRequire("3BTDi");

var $4s2UK = parcelRequire("4s2UK");

var $4Athc = parcelRequire("4Athc");

var $2krtQ = parcelRequire("2krtQ");

var $dFvJW = parcelRequire("dFvJW");

var $bfkfm = parcelRequire("bfkfm");

var $ih19M = parcelRequire("ih19M");
'use client';
function $5a0913f1afe7442b$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $5a0913f1afe7442b$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $5a0913f1afe7442b$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $5a0913f1afe7442b$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $5a0913f1afe7442b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $2krtQ.getPopoverUtilityClass), classes);
};
const $5a0913f1afe7442b$export$bcce13685275fc99 = (0, $l0oRz.default)((0, $4s2UK.default), {
    name: 'MuiPopover',
    slot: 'Root'
})({});
const $5a0913f1afe7442b$export$821346c38a2d9390 = (0, $l0oRz.default)((0, $4Athc.default), {
    name: 'MuiPopover',
    slot: 'Paper'
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $5a0913f1afe7442b$var$Popover = /*#__PURE__*/ $bh6RR.forwardRef(function Popover(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $bh6RR.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $5a0913f1afe7442b$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $bh6RR.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $5a0913f1afe7442b$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $7ThAM.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $5a0913f1afe7442b$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $5a0913f1afe7442b$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $bh6RR.useCallback((elemRect)=>{
        return {
            vertical: $5a0913f1afe7442b$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $5a0913f1afe7442b$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $bh6RR.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $5a0913f1afe7442b$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $7tCBy.default)($5a0913f1afe7442b$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $5a0913f1afe7442b$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $bh6RR.useState(open);
    const setPositioningStyles = $bh6RR.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $bh6RR.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $bh6RR.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $bh6RR.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $bh6RR.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $8I3yK.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $7tCBy.default)($5a0913f1afe7442b$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $dFvJW.default)('transition', {
        elementType: (0, $3BTDi.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $7ThAM.default)($5a0913f1afe7442b$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $dFvJW.default)('root', {
        ref: ref,
        elementType: $5a0913f1afe7442b$export$bcce13685275fc99,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $bfkfm.default)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $dFvJW.default)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $5a0913f1afe7442b$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $g0K0l.default)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $ih19M.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var $5a0913f1afe7442b$export$2e2bcd8739ae039 = $5a0913f1afe7442b$var$Popover;

});
parcelRegister("8I3yK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6575319ccf2b458f$export$2e2bcd8739ae039; });

var $2UWap = parcelRequire("2UWap");
var $6575319ccf2b458f$export$2e2bcd8739ae039 = (0, $2UWap.default);

});

parcelRegister("2krtQ", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", function () { return $1b22c40897a051c2$export$88f455dd56c95edb; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $1b22c40897a051c2$export$88f455dd56c95edb(slot) {
    return (0, $dmzXD.default)('MuiPopover', slot);
}
const $1b22c40897a051c2$var$popoverClasses = (0, $fYlYP.default)('MuiPopover', [
    'root',
    'paper'
]);
var $1b22c40897a051c2$export$2e2bcd8739ae039 = $1b22c40897a051c2$var$popoverClasses;

});

parcelRegister("bfkfm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8300cd0435e793f9$export$2e2bcd8739ae039; });

var $aPsoC = parcelRequire("aPsoC");
// Brought from [Base UI](https://github.com/mui/base-ui/blob/master/packages/react/src/merge-props/mergeProps.ts#L119)
// Use it directly from Base UI once it's a package dependency.
function $8300cd0435e793f9$var$isEventHandler(key, value) {
    // This approach is more efficient than using a regex.
    const thirdCharCode = key.charCodeAt(2);
    return key[0] === 'o' && key[1] === 'n' && thirdCharCode >= 65 /* A */  && thirdCharCode <= 90 /* Z */  && typeof value === 'function';
}
function $8300cd0435e793f9$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
        const handlers = {};
        Object.keys(defaultSlotPropsValue).forEach((key)=>{
            if ($8300cd0435e793f9$var$isEventHandler(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === 'function') // only compose the handlers if both default and external slot props match the event handler
            handlers[key] = (...args)=>{
                externalSlotPropsValue[key](...args);
                defaultSlotPropsValue[key](...args);
            };
        });
        return handlers;
    }
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $aPsoC.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        const handlers = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...handlers,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
    const className = (0, $aPsoC.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...handlers,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}

});


parcelRegister("5FT45", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", function () { return $421b7ed01470aac8$export$2cf86a63a84fe23d; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $421b7ed01470aac8$export$2cf86a63a84fe23d(slot) {
    return (0, $dmzXD.default)('MuiMenu', slot);
}
const $421b7ed01470aac8$var$menuClasses = (0, $fYlYP.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $421b7ed01470aac8$export$2e2bcd8739ae039 = $421b7ed01470aac8$var$menuClasses;

});


parcelRegister("dPQL7", function(module, exports) {

$parcel$export(module.exports, "StyledSelectSelect", function () { return $a128f69a46f3826e$export$50b3545a8ccd87af; });
$parcel$export(module.exports, "StyledSelectIcon", function () { return $a128f69a46f3826e$export$7dd4d92f143902e3; });
$parcel$export(module.exports, "default", function () { return $a128f69a46f3826e$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $96ZcP = parcelRequire("96ZcP");

var $krx4P = parcelRequire("krx4P");

var $bmkH1 = parcelRequire("bmkH1");

var $l0oRz = parcelRequire("l0oRz");

var $b6vKX = parcelRequire("b6vKX");

var $ih19M = parcelRequire("ih19M");
'use client';
const $a128f69a46f3826e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $krx4P.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $bmkH1.getNativeSelectUtilityClasses), classes);
};
const $a128f69a46f3826e$export$50b3545a8ccd87af = (0, $l0oRz.default)('select', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $bmkH1.default).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $a128f69a46f3826e$var$NativeSelectSelect = (0, $l0oRz.default)($a128f69a46f3826e$export$50b3545a8ccd87af, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $b6vKX.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $bmkH1.default).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $a128f69a46f3826e$export$7dd4d92f143902e3 = (0, $l0oRz.default)('svg', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $bmkH1.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $a128f69a46f3826e$var$NativeSelectIcon = (0, $l0oRz.default)($a128f69a46f3826e$export$7dd4d92f143902e3, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $krx4P.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $a128f69a46f3826e$var$NativeSelectInput = /*#__PURE__*/ $bh6RR.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $a128f69a46f3826e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($a128f69a46f3826e$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $aPsoC.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $ih19M.jsx)($a128f69a46f3826e$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $a128f69a46f3826e$export$2e2bcd8739ae039 = $a128f69a46f3826e$var$NativeSelectInput;

});
parcelRegister("bmkH1", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", function () { return $8451ccf2969f4976$export$1ee13051fd9e2ab5; });
$parcel$export(module.exports, "default", function () { return $8451ccf2969f4976$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $8451ccf2969f4976$export$1ee13051fd9e2ab5(slot) {
    return (0, $dmzXD.default)('MuiNativeSelect', slot);
}
const $8451ccf2969f4976$var$nativeSelectClasses = (0, $fYlYP.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $8451ccf2969f4976$export$2e2bcd8739ae039 = $8451ccf2969f4976$var$nativeSelectClasses;

});


parcelRegister("8ANil", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6417ec7b2374ad18$export$2e2bcd8739ae039; });

var $d1JqZ = parcelRequire("d1JqZ");
'use client';
var $6417ec7b2374ad18$export$2e2bcd8739ae039 = (0, $d1JqZ.default);

});
parcelRegister("d1JqZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97be9ca9a8d9ffc7$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
function $97be9ca9a8d9ffc7$export$2e2bcd8739ae039(props) {
    const { controlled: controlled, default: defaultProp, name: name, state: state = 'value' } = props;
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $bh6RR.useRef(controlled !== undefined);
    const [valueState, setValue] = $bh6RR.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $bh6RR.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    // TODO: provide overloads for the useControlled function to account for the case where either
    // controlled or default is not undefined.
    // In that case the return type should be [T, React.Dispatch<React.SetStateAction<T>>]
    // otherwise it should be [T | undefined, React.Dispatch<React.SetStateAction<T | undefined>>]
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("dapNI", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", function () { return $9960390b54cf2227$export$2c0c1ee5a3392e; });
$parcel$export(module.exports, "default", function () { return $9960390b54cf2227$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $9960390b54cf2227$export$2c0c1ee5a3392e(slot) {
    return (0, $dmzXD.default)('MuiSelect', slot);
}
const $9960390b54cf2227$var$selectClasses = (0, $fYlYP.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $9960390b54cf2227$export$2e2bcd8739ae039 = $9960390b54cf2227$var$selectClasses;

});


parcelRegister("98F34", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a74b3ca395b414b$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $6a74b3ca395b414b$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});


parcelRegister("iVhON", function(module, exports) {

$parcel$export(module.exports, "getTextFieldUtilityClass", function () { return $dc6b5f2ff9bdc575$export$c1bdcbaf0596aeda; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $dc6b5f2ff9bdc575$export$c1bdcbaf0596aeda(slot) {
    return (0, $dmzXD.default)('MuiTextField', slot);
}
const $dc6b5f2ff9bdc575$var$textFieldClasses = (0, $fYlYP.default)('MuiTextField', [
    'root'
]);
var $dc6b5f2ff9bdc575$export$2e2bcd8739ae039 = $dc6b5f2ff9bdc575$var$textFieldClasses;

});


parcelRegister("jP5af", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fd0af9d197ccf5d$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $3Xpkr = parcelRequire("3Xpkr");

var $eLohH = parcelRequire("eLohH");

var $4rInl = parcelRequire("4rInl");
function $1fd0af9d197ccf5d$export$2e2bcd8739ae039({ children: children = /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Fragment, {}), onClose: onClose, ...other }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $eLohH.default), {
        sx: {
            p: 2
        },
        color: "primary.main",
        ...other,
        children: [
            children,
            onClose ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                "aria-label": "close",
                onClick: onClose,
                sx: {
                    position: "absolute",
                    right: 6,
                    top: 6,
                    color: (theme)=>theme.palette.grey[500]
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3Xpkr.default), {})
            }) : null
        ]
    });
}

});

parcelRegister("dkPRN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d601b1a939acdb29$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $aEnM8 = parcelRequire("aEnM8");

var $77HUe = parcelRequire("77HUe");

var $1d1FK = parcelRequire("1d1FK");

var $lethQ = parcelRequire("lethQ");

var $cbFbS = parcelRequire("cbFbS");
const $d601b1a939acdb29$var$labels = {
    1: "Poor",
    3: "Fair",
    5: "Great"
};
function $d601b1a939acdb29$var$CustomStar({ value: value }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        component: "div",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $aEnM8.default), {
                fontSize: "inherit"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                variant: "caption",
                color: "initial",
                children: $d601b1a939acdb29$var$labels[value]
            })
        ]
    });
}
function $d601b1a939acdb29$var$CustomEmptyStar({ value: value }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        component: "div",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $77HUe.default), {
                fontSize: "inherit"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                variant: "caption",
                color: "initial",
                children: $d601b1a939acdb29$var$labels[value]
            })
        ]
    });
}
function $d601b1a939acdb29$var$IconContainer(props) {
    const { value: value, rating: rating, ...other } = props;
    const shouldDisplayFilledStar = $bh6RR.useMemo(()=>{
        if (rating !== null) return value <= rating;
        return false;
    }, [
        rating,
        value
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        role: "button",
        tabIndex: -1,
        children: shouldDisplayFilledStar ? /*#__PURE__*/ (0, $ih19M.jsx)($d601b1a939acdb29$var$CustomStar, {
            value: value,
            ...other
        }) : /*#__PURE__*/ (0, $ih19M.jsx)($d601b1a939acdb29$var$CustomEmptyStar, {
            value: value,
            ...other
        })
    });
}
function $d601b1a939acdb29$export$2e2bcd8739ae039({ value: value, onChange: onChange, name: name = "custom-rating", sx: sx = {
    fontSize: "3rem"
} }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lethQ.default), {
        name: name,
        value: value,
        onChange: onChange,
        max: 5,
        slotProps: {
            icon: {
                component: (props)=>/*#__PURE__*/ (0, $ih19M.jsx)($d601b1a939acdb29$var$IconContainer, {
                        ...props,
                        rating: value
                    })
            }
        },
        sx: sx
    });
}

});
parcelRegister("aEnM8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c1015194dc1e259$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $7c1015194dc1e259$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');

});

parcelRegister("77HUe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52fb3ea515ab5205$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $52fb3ea515ab5205$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "m22 9.24-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28z"
}), 'StarBorder');

});

parcelRegister("lethQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7519f87f5964081$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $8fhtc = parcelRequire("8fhtc");

var $bXdZI = parcelRequire("bXdZI");


var $96ZcP = parcelRequire("96ZcP");

var $am2yJ = parcelRequire("am2yJ");

var $25zti = parcelRequire("25zti");

var $krx4P = parcelRequire("krx4P");
var $2STLv = parcelRequire("2STLv");
var $8ANil = parcelRequire("8ANil");
var $dg012 = parcelRequire("dg012");

var $dwTQO = parcelRequire("dwTQO");

var $4rAdQ = parcelRequire("4rAdQ");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $52dC4 = parcelRequire("52dC4");

var $3iXxG = parcelRequire("3iXxG");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
function $f7519f87f5964081$var$getDecimalPrecision(num) {
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $f7519f87f5964081$var$roundValueToPrecision(value, precision) {
    if (value == null) return value;
    const nearest = Math.round(value / precision) * precision;
    return Number(nearest.toFixed($f7519f87f5964081$var$getDecimalPrecision(precision)));
}
const $f7519f87f5964081$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, size: size, readOnly: readOnly, disabled: disabled, emptyValueFocused: emptyValueFocused, focusVisible: focusVisible } = ownerState;
    const slots = {
        root: [
            'root',
            `size${(0, $krx4P.default)(size)}`,
            disabled && 'disabled',
            focusVisible && 'focusVisible',
            readOnly && 'readOnly'
        ],
        label: [
            'label',
            'pristine'
        ],
        labelEmptyValue: [
            emptyValueFocused && 'labelEmptyValueActive'
        ],
        icon: [
            'icon'
        ],
        iconEmpty: [
            'iconEmpty'
        ],
        iconFilled: [
            'iconFilled'
        ],
        iconHover: [
            'iconHover'
        ],
        iconFocus: [
            'iconFocus'
        ],
        iconActive: [
            'iconActive'
        ],
        decimal: [
            'decimal'
        ],
        visuallyHidden: [
            'visuallyHidden'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $3iXxG.getRatingUtilityClass), classes);
};
const $f7519f87f5964081$var$RatingRoot = (0, $l0oRz.default)('span', {
    name: 'MuiRating',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $3iXxG.default).visuallyHidden}`]: styles.visuallyHidden
            },
            styles.root,
            styles[`size${(0, $krx4P.default)(ownerState.size)}`],
            ownerState.readOnly && styles.readOnly
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        display: 'inline-flex',
        // Required to position the pristine input absolutely
        position: 'relative',
        fontSize: theme.typography.pxToRem(24),
        color: '#faaf00',
        cursor: 'pointer',
        textAlign: 'left',
        width: 'min-content',
        WebkitTapHighlightColor: 'transparent',
        [`&.${(0, $3iXxG.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`&.${(0, $3iXxG.default).focusVisible} .${(0, $3iXxG.default).iconActive}`]: {
            outline: '1px solid #999'
        },
        [`& .${(0, $3iXxG.default).visuallyHidden}`]: (0, $bXdZI.default),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    fontSize: theme.typography.pxToRem(30)
                }
            },
            {
                // TODO v6: use the .Mui-readOnly global state class
                props: ({ ownerState: ownerState })=>ownerState.readOnly,
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const $f7519f87f5964081$var$RatingLabel = (0, $l0oRz.default)('label', {
    name: 'MuiRating',
    slot: 'Label',
    overridesResolver: ({ ownerState: ownerState }, styles)=>[
            styles.label,
            ownerState.emptyValueFocused && styles.labelEmptyValueActive
        ]
})({
    cursor: 'inherit',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.emptyValueFocused,
            style: {
                top: 0,
                bottom: 0,
                position: 'absolute',
                outline: '1px solid #999',
                width: '100%'
            }
        }
    ]
});
const $f7519f87f5964081$var$RatingIcon = (0, $l0oRz.default)('span', {
    name: 'MuiRating',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.iconEmpty && styles.iconEmpty,
            ownerState.iconFilled && styles.iconFilled,
            ownerState.iconHover && styles.iconHover,
            ownerState.iconFocus && styles.iconFocus,
            ownerState.iconActive && styles.iconActive
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        // Fit wrapper to actual icon size.
        display: 'flex',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        // Fix mouseLeave issue.
        // https://github.com/facebook/react/issues/4492
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.iconActive,
                style: {
                    transform: 'scale(1.2)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.iconEmpty,
                style: {
                    color: (theme.vars || theme).palette.action.disabled
                }
            }
        ]
    })));
const $f7519f87f5964081$var$RatingDecimal = (0, $l0oRz.default)('span', {
    name: 'MuiRating',
    slot: 'Decimal',
    shouldForwardProp: (prop)=>(0, $52dC4.default)(prop) && prop !== 'iconActive',
    overridesResolver: (props, styles)=>{
        const { iconActive: iconActive } = props;
        return [
            styles.decimal,
            iconActive && styles.iconActive
        ];
    }
})({
    position: 'relative',
    variants: [
        {
            props: ({ iconActive: iconActive })=>iconActive,
            style: {
                transform: 'scale(1.2)'
            }
        }
    ]
});
function $f7519f87f5964081$var$IconContainer(props) {
    const { value: value, ...other } = props;
    return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        ...other
    });
}
function $f7519f87f5964081$var$RatingItem(props) {
    const { classes: classes, disabled: disabled, emptyIcon: emptyIcon, focus: focus, getLabelText: getLabelText, highlightSelectedOnly: highlightSelectedOnly, hover: hover, icon: icon, IconContainerComponent: IconContainerComponent, isActive: isActive, itemValue: itemValue, labelProps: labelProps, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, readOnly: readOnly, ownerState: ownerState, ratingValue: ratingValue, ratingValueRounded: ratingValueRounded, slots: slots = {}, slotProps: slotProps = {} } = props;
    const isFilled = highlightSelectedOnly ? itemValue === ratingValue : itemValue <= ratingValue;
    const isHovered = itemValue <= hover;
    const isFocused = itemValue <= focus;
    const isChecked = itemValue === ratingValueRounded;
    // "name" ensures unique IDs across different Rating components in React 17,
    // preventing one component from affecting another. React 18's useId already handles this.
    // Update to const id = useId(); when React 17 support is dropped.
    // More details: https://github.com/mui/material-ui/issues/40997
    const id = `${name}-${(0, $2STLv.default)()}`;
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [IconSlot, iconSlotProps] = (0, $dFvJW.default)('icon', {
        elementType: $f7519f87f5964081$var$RatingIcon,
        className: (0, $aPsoC.default)(classes.icon, isFilled ? classes.iconFilled : classes.iconEmpty, isHovered && classes.iconHover, isFocused && classes.iconFocus, isActive && classes.iconActive),
        externalForwardedProps: externalForwardedProps,
        ownerState: {
            ...ownerState,
            iconEmpty: !isFilled,
            iconFilled: isFilled,
            iconHover: isHovered,
            iconFocus: isFocused,
            iconActive: isActive
        },
        additionalProps: {
            value: itemValue
        },
        internalForwardedProps: {
            // TODO: remove this in v7 because `IconContainerComponent` is deprecated
            // only forward if `slots.icon` is NOT provided
            as: IconContainerComponent
        }
    });
    const [LabelSlot, labelSlotProps] = (0, $dFvJW.default)('label', {
        elementType: $f7519f87f5964081$var$RatingLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: {
            ...ownerState,
            emptyValueFocused: undefined
        },
        additionalProps: {
            style: labelProps?.style,
            htmlFor: id
        }
    });
    const container = /*#__PURE__*/ (0, $ih19M.jsx)(IconSlot, {
        ...iconSlotProps,
        children: emptyIcon && !isFilled ? emptyIcon : icon
    });
    if (readOnly) return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        ...labelProps,
        children: container
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)(LabelSlot, {
                ...labelSlotProps,
                children: [
                    container,
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: classes.visuallyHidden,
                        children: getLabelText(itemValue)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                className: classes.visuallyHidden,
                onFocus: onFocus,
                onBlur: onBlur,
                onChange: onChange,
                onClick: onClick,
                disabled: disabled,
                value: itemValue,
                id: id,
                type: "radio",
                name: name,
                checked: isChecked
            })
        ]
    });
}
const $f7519f87f5964081$var$defaultIcon = /*#__PURE__*/ (0, $ih19M.jsx)((0, $dwTQO.default), {
    fontSize: "inherit"
});
const $f7519f87f5964081$var$defaultEmptyIcon = /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rAdQ.default), {
    fontSize: "inherit"
});
function $f7519f87f5964081$var$defaultLabelText(value) {
    return `${value || '0'} Star${value !== 1 ? 's' : ''}`;
}
const $f7519f87f5964081$var$Rating = /*#__PURE__*/ $bh6RR.forwardRef(function Rating(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        name: 'MuiRating',
        props: inProps
    });
    const { component: component = 'span', className: className, defaultValue: defaultValue = null, disabled: disabled = false, emptyIcon: emptyIcon = $f7519f87f5964081$var$defaultEmptyIcon, emptyLabelText: emptyLabelText = 'Empty', getLabelText: getLabelText = $f7519f87f5964081$var$defaultLabelText, highlightSelectedOnly: highlightSelectedOnly = false, icon: icon = $f7519f87f5964081$var$defaultIcon, IconContainerComponent: IconContainerComponent = $f7519f87f5964081$var$IconContainer, max: max = 5, name: nameProp, onChange: onChange, onChangeActive: onChangeActive, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, precision: precision = 1, readOnly: readOnly = false, size: size = 'medium', value: valueProp, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const name = (0, $2STLv.default)(nameProp);
    const [valueDerived, setValueState] = (0, $8ANil.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Rating'
    });
    const valueRounded = $f7519f87f5964081$var$roundValueToPrecision(valueDerived, precision);
    const isRtl = (0, $am2yJ.useRtl)();
    const [{ hover: hover, focus: focus }, setState] = $bh6RR.useState({
        hover: -1,
        focus: -1
    });
    let value = valueRounded;
    if (hover !== -1) value = hover;
    if (focus !== -1) value = focus;
    const [focusVisible, setFocusVisible] = $bh6RR.useState(false);
    const rootRef = $bh6RR.useRef();
    const handleRef = (0, $dg012.default)(rootRef, ref);
    const handleMouseMove = (event)=>{
        if (onMouseMove) onMouseMove(event);
        const rootNode = rootRef.current;
        const { right: right, left: left, width: containerWidth } = rootNode.getBoundingClientRect();
        let percent;
        if (isRtl) percent = (right - event.clientX) / containerWidth;
        else percent = (event.clientX - left) / containerWidth;
        let newHover = $f7519f87f5964081$var$roundValueToPrecision(max * percent + precision / 2, precision);
        newHover = (0, $8fhtc.default)(newHover, precision, max);
        setState((prev)=>prev.hover === newHover && prev.focus === newHover ? prev : {
                hover: newHover,
                focus: newHover
            });
        setFocusVisible(false);
        if (onChangeActive && hover !== newHover) onChangeActive(event, newHover);
    };
    const handleMouseLeave = (event)=>{
        if (onMouseLeave) onMouseLeave(event);
        const newHover = -1;
        setState({
            hover: newHover,
            focus: newHover
        });
        if (onChangeActive && hover !== newHover) onChangeActive(event, newHover);
    };
    const handleChange = (event)=>{
        let newValue = event.target.value === '' ? null : parseFloat(event.target.value);
        // Give mouse priority over keyboard
        // Fix https://github.com/mui/material-ui/issues/22827
        if (hover !== -1) newValue = hover;
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
    };
    const handleClear = (event)=>{
        // Ignore keyboard events
        // https://github.com/facebook/react/issues/7407
        if (event.clientX === 0 && event.clientY === 0) return;
        setState({
            hover: -1,
            focus: -1
        });
        setValueState(null);
        if (onChange && parseFloat(event.target.value) === valueRounded) onChange(event, null);
    };
    const handleFocus = (event)=>{
        if ((0, $25zti.default)(event.target)) setFocusVisible(true);
        const newFocus = parseFloat(event.target.value);
        setState((prev)=>({
                hover: prev.hover,
                focus: newFocus
            }));
    };
    const handleBlur = (event)=>{
        if (hover !== -1) return;
        if (!(0, $25zti.default)(event.target)) setFocusVisible(false);
        const newFocus = -1;
        setState((prev)=>({
                hover: prev.hover,
                focus: newFocus
            }));
    };
    const [emptyValueFocused, setEmptyValueFocused] = $bh6RR.useState(false);
    const ownerState = {
        ...props,
        component: component,
        defaultValue: defaultValue,
        disabled: disabled,
        emptyIcon: emptyIcon,
        emptyLabelText: emptyLabelText,
        emptyValueFocused: emptyValueFocused,
        focusVisible: focusVisible,
        getLabelText: getLabelText,
        icon: icon,
        IconContainerComponent: IconContainerComponent,
        max: max,
        precision: precision,
        readOnly: readOnly,
        size: size
    };
    const classes = $f7519f87f5964081$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $dFvJW.default)('root', {
        ref: handleRef,
        className: (0, $aPsoC.default)(classes.root, className),
        elementType: $f7519f87f5964081$var$RatingRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onMouseMove: (event)=>{
                    handleMouseMove(event);
                    handlers.onMouseMove?.(event);
                },
                onMouseLeave: (event)=>{
                    handleMouseLeave(event);
                    handlers.onMouseLeave?.(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            role: readOnly ? 'img' : null,
            'aria-label': readOnly ? getLabelText(value) : null
        }
    });
    const [LabelSlot, labelSlotProps] = (0, $dFvJW.default)('label', {
        className: (0, $aPsoC.default)(classes.label, classes.labelEmptyValue),
        elementType: $f7519f87f5964081$var$RatingLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [DecimalSlot, decimalSlotProps] = (0, $dFvJW.default)('decimal', {
        className: classes.decimal,
        elementType: $f7519f87f5964081$var$RatingDecimal,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            Array.from(new Array(max)).map((_, index)=>{
                const itemValue = index + 1;
                const ratingItemProps = {
                    classes: classes,
                    disabled: disabled,
                    emptyIcon: emptyIcon,
                    focus: focus,
                    getLabelText: getLabelText,
                    highlightSelectedOnly: highlightSelectedOnly,
                    hover: hover,
                    icon: icon,
                    IconContainerComponent: IconContainerComponent,
                    name: name,
                    onBlur: handleBlur,
                    onChange: handleChange,
                    onClick: handleClear,
                    onFocus: handleFocus,
                    ratingValue: value,
                    ratingValueRounded: valueRounded,
                    readOnly: readOnly,
                    ownerState: ownerState,
                    slots: slots,
                    slotProps: slotProps
                };
                const isActive = itemValue === Math.ceil(value) && (hover !== -1 || focus !== -1);
                if (precision < 1) {
                    const items = Array.from(new Array(1 / precision));
                    return /*#__PURE__*/ (0, $bh6RR.createElement)(DecimalSlot, {
                        ...decimalSlotProps,
                        key: itemValue,
                        className: (0, $aPsoC.default)(decimalSlotProps.className, isActive && classes.iconActive),
                        iconActive: isActive
                    }, items.map(($, indexDecimal)=>{
                        const itemDecimalValue = $f7519f87f5964081$var$roundValueToPrecision(itemValue - 1 + (indexDecimal + 1) * precision, precision);
                        return /*#__PURE__*/ (0, $ih19M.jsx)($f7519f87f5964081$var$RatingItem, {
                            ...ratingItemProps,
                            // The icon is already displayed as active
                            isActive: false,
                            itemValue: itemDecimalValue,
                            labelProps: {
                                style: items.length - 1 === indexDecimal ? {} : {
                                    width: itemDecimalValue === value ? `${(indexDecimal + 1) * precision * 100}%` : '0%',
                                    overflow: 'hidden',
                                    position: 'absolute'
                                }
                            }
                        }, itemDecimalValue);
                    }));
                }
                return /*#__PURE__*/ (0, $ih19M.jsx)($f7519f87f5964081$var$RatingItem, {
                    ...ratingItemProps,
                    isActive: isActive,
                    itemValue: itemValue
                }, itemValue);
            }),
            !readOnly && !disabled && /*#__PURE__*/ (0, $ih19M.jsxs)(LabelSlot, {
                ...labelSlotProps,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                        className: classes.visuallyHidden,
                        value: "",
                        id: `${name}-empty`,
                        type: "radio",
                        name: name,
                        checked: valueRounded == null,
                        onFocus: ()=>setEmptyValueFocused(true),
                        onBlur: ()=>setEmptyValueFocused(false),
                        onChange: handleChange
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: classes.visuallyHidden,
                        children: emptyLabelText
                    })
                ]
            })
        ]
    });
});
var $f7519f87f5964081$export$2e2bcd8739ae039 = $f7519f87f5964081$var$Rating;

});
parcelRegister("bXdZI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b400f632efaf004$export$2e2bcd8739ae039; });
const $8b400f632efaf004$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $8b400f632efaf004$export$2e2bcd8739ae039 = $8b400f632efaf004$var$visuallyHidden;

});

parcelRegister("dwTQO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d999655e224ab6f$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $9d999655e224ab6f$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');

});

parcelRegister("4rAdQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33c5c80c7263de4c$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $33c5c80c7263de4c$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), 'StarBorder');

});

parcelRegister("3iXxG", function(module, exports) {

$parcel$export(module.exports, "getRatingUtilityClass", function () { return $26813d692645ef79$export$2c22c4f65a44ac6b; });
$parcel$export(module.exports, "default", function () { return $26813d692645ef79$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $26813d692645ef79$export$2c22c4f65a44ac6b(slot) {
    return (0, $dmzXD.default)('MuiRating', slot);
}
const $26813d692645ef79$var$ratingClasses = (0, $fYlYP.default)('MuiRating', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'readOnly',
    'disabled',
    'focusVisible',
    'visuallyHidden',
    'pristine',
    'label',
    'labelEmptyValueActive',
    'icon',
    'iconEmpty',
    'iconFilled',
    'iconHover',
    'iconFocus',
    'iconActive',
    'decimal'
]);
var $26813d692645ef79$export$2e2bcd8739ae039 = $26813d692645ef79$var$ratingClasses;

});




parcelRegister("7uFU8", function(module, exports) {

$parcel$export(module.exports, "inProgressUrl", function () { return $b9ed47cdd255966d$export$2ac15679c0d571a1; });
/**
 * Build a URL path for the journey in-progress page with optional search params.
 */ function $b9ed47cdd255966d$export$2ac15679c0d571a1(params) {
    const url = new URL("/journeys/instances/in-progress", window.location.origin);
    if (params.journeyType) url.searchParams.set("journeyType", params.journeyType);
    if (params.journeyInstanceId != null) url.searchParams.set("journeyInstanceId", String(params.journeyInstanceId));
    if (params.journeyInstanceUlid) url.searchParams.set("journeyInstanceUlid", params.journeyInstanceUlid);
    return url.pathname + url.search;
}

});


parcelRegister("eyQ0b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $616000e91b8e4f47$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $3Xpkr = parcelRequire("3Xpkr");

var $gSq4G = parcelRequire("gSq4G");

var $506bB = parcelRequire("506bB");

var $btx4r = parcelRequire("btx4r");

var $eedE5 = parcelRequire("eedE5");

var $dUgAK = parcelRequire("dUgAK");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $eLohH = parcelRequire("eLohH");

var $j5ldk = parcelRequire("j5ldk");

var $1TxeB = parcelRequire("1TxeB");

var $4rInl = parcelRequire("4rInl");

var $4IPS4 = parcelRequire("4IPS4");

var $iZWBy = parcelRequire("iZWBy");

var $kclvT = parcelRequire("kclvT");

var $6qGY5 = parcelRequire("6qGY5");

var $gfi3N = parcelRequire("gfi3N");

var $10RGt = parcelRequire("10RGt");

var $84xZD = parcelRequire("84xZD");

var $8JNI1 = parcelRequire("8JNI1");

var $hrqHU = parcelRequire("hrqHU");

var $cbFbS = parcelRequire("cbFbS");
parcelRequire("cFAEN");
var $cK0UE = parcelRequire("cK0UE");
var $cFAEN = parcelRequire("cFAEN");

var $W4f7l = parcelRequire("W4f7l");

var $g6rVl = parcelRequire("g6rVl");

var $7uFU8 = parcelRequire("7uFU8");

var $b2ct8 = parcelRequire("b2ct8");
const $616000e91b8e4f47$var$STORAGE_KEYS = {
    RATING_TYPE: "assessment_ratingType",
    RATING: "assessment_rating",
    HAND: "assessment_hand",
    BACKHAND_STYLE: "assessment_backhandStyle"
};
const $616000e91b8e4f47$var$RATING_TYPES = [
    {
        label: "DUPR\xae",
        value: "DUPR"
    },
    {
        label: "Club Specific",
        value: "club_specific"
    }
];
const $616000e91b8e4f47$var$HANDS = [
    {
        label: "Right",
        value: "right"
    },
    {
        label: "Left",
        value: "left"
    }
];
const $616000e91b8e4f47$var$BACKHAND_STYLES = [
    {
        label: "One-Handed",
        value: "one_handed"
    },
    {
        label: "Two-Handed",
        value: "two_handed"
    }
];
const $616000e91b8e4f47$var$AssessmentStartDialog = ({ open: open, journey: journey, inProgressInstance: inProgressInstance, onClose: onClose, onStart: onStart, sport: sport })=>{
    const { isAdmin: isAdmin, isPro: isPro, features: features } = (0, $W4f7l.useCurrentUser)();
    const canTransferToOtherUser = isAdmin() || isPro() || features.includes((0, $b2ct8.ADMINISTER_ASSESSMENT_PROXY_FEATURE));
    const { logStepEvent: logStepEvent, registerJourneyLinkIntent: registerJourneyLinkIntent } = (0, $g6rVl.default)();
    const navigate = (0, $as544.useNavigate)();
    // Track that the user entered the metadata input step when the dialog
    // opens. `profileWasComplete` is read directly from localStorage (the
    // source of truth for the saved profile) so the value reflects the
    // pre-dialog state regardless of in-flight typing, and the effect
    // doesn't need `hand`/`backhandStyle` as deps.
    $bh6RR.useEffect(()=>{
        if (open && journey) {
            const profileWasComplete = !!localStorage.getItem($616000e91b8e4f47$var$STORAGE_KEYS.HAND) && !!localStorage.getItem($616000e91b8e4f47$var$STORAGE_KEYS.BACKHAND_STYLE);
            logStepEvent("metadata_input", {
                journeyId: journey.id,
                metadata: {
                    profileWasComplete: profileWasComplete
                }
            });
        }
    }, [
        open,
        journey,
        logStepEvent
    ]);
    const [ratingType, setRatingType] = $bh6RR.useState(()=>{
        const stored = localStorage.getItem($616000e91b8e4f47$var$STORAGE_KEYS.RATING_TYPE);
        const valid = [
            "DUPR",
            "club_specific"
        ];
        return valid.includes(stored) ? stored : "";
    });
    const [rating, setRating] = $bh6RR.useState(()=>localStorage.getItem($616000e91b8e4f47$var$STORAGE_KEYS.RATING) || "");
    const [hand, setHand] = $bh6RR.useState(()=>localStorage.getItem($616000e91b8e4f47$var$STORAGE_KEYS.HAND) || "");
    const [backhandStyle, setBackhandStyle] = $bh6RR.useState(()=>localStorage.getItem($616000e91b8e4f47$var$STORAGE_KEYS.BACKHAND_STYLE) || "");
    // Subject user state (admin only)
    const [subjectUser, setSubjectUser] = $bh6RR.useState("");
    const [isValidating, setIsValidating] = $bh6RR.useState(false);
    const [validationError, setValidationError] = $bh6RR.useState("");
    const [validUser, setValidUser] = $bh6RR.useState(null);
    const abortControllerRef = $bh6RR.useRef(null);
    const resumeUrl = $bh6RR.useMemo(()=>{
        if (!inProgressInstance) return "";
        if (inProgressInstance.workoutsPlays.length === 1) {
            const aw = inProgressInstance.workoutsPlays[0].appWorkout;
            return `/content/apps/workouts/plugin/play/${aw.appId}/${aw.id}`;
        }
        return (0, $7uFU8.inProgressUrl)({
            journeyType: "assessment",
            journeyInstanceId: inProgressInstance.id
        });
    }, [
        inProgressInstance
    ]);
    const handleResumeClick = $bh6RR.useCallback(async (e)=>{
        // Single-workout assessments navigate straight to play; intent
        // must be registered first so the play links back to this slot.
        // Multi-workout assessments resume on the in-progress page, where
        // intent is registered when the user picks the next workout.
        if (inProgressInstance?.workoutsPlays.length !== 1) return;
        e.preventDefault();
        const aw = inProgressInstance.workoutsPlays[0].appWorkout;
        await registerJourneyLinkIntent(inProgressInstance.ulid, aw.id);
        navigate(resumeUrl);
    }, [
        inProgressInstance,
        registerJourneyLinkIntent,
        navigate,
        resumeUrl
    ]);
    const [showConfirmation, setShowConfirmation] = $bh6RR.useState(false);
    const [isStarting, setIsStarting] = $bh6RR.useState(false);
    const [startError, setStartError] = $bh6RR.useState("");
    $bh6RR.useEffect(()=>{
        if (ratingType) localStorage.setItem($616000e91b8e4f47$var$STORAGE_KEYS.RATING_TYPE, ratingType);
        if (rating) localStorage.setItem($616000e91b8e4f47$var$STORAGE_KEYS.RATING, rating);
        if (hand) localStorage.setItem($616000e91b8e4f47$var$STORAGE_KEYS.HAND, hand);
        if (backhandStyle) localStorage.setItem($616000e91b8e4f47$var$STORAGE_KEYS.BACKHAND_STYLE, backhandStyle);
    }, [
        ratingType,
        rating,
        hand,
        backhandStyle
    ]);
    // Validate subject user function
    const validateUser = async (input)=>{
        const trimmedInput = input.trim();
        // Cancel any previous validation request
        if (abortControllerRef.current) abortControllerRef.current.abort();
        if (!trimmedInput) {
            setValidationError("");
            setValidUser(null);
            return;
        }
        // Basic email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isEmail = emailRegex.test(trimmedInput);
        if (!isEmail && trimmedInput.includes("@")) {
            setValidationError("Invalid email format");
            setValidUser(null);
            return;
        }
        setIsValidating(true);
        setValidationError("");
        // Create new AbortController for this request
        const controller = new AbortController();
        abortControllerRef.current = controller;
        try {
            const url = `/api/users/search?q=${encodeURIComponent(trimmedInput)}&limit=1&offset=0`;
            const result = await (0, $cK0UE.default)(url, "GET", undefined, {
                signal: controller.signal
            });
            if (result.count > 0 && result.result.length > 0) {
                const user = result.result[0];
                // Check for exact match
                if (user.email?.toLowerCase() === trimmedInput.toLowerCase() || user.username?.toLowerCase() === trimmedInput.toLowerCase()) {
                    setValidUser(user);
                    setValidationError("");
                } else {
                    setValidUser(null);
                    setValidationError("User not found with this exact email/username");
                }
            } else {
                setValidUser(null);
                setValidationError("User not found");
            }
        } catch (error) {
            // Don't show error if request was aborted
            if (error instanceof Error && error.name === "AbortError") return;
            setValidationError("Error validating user");
            setValidUser(null);
        } finally{
            // Only clear loading state if this request wasn't aborted
            if (abortControllerRef.current === controller) {
                setIsValidating(false);
                abortControllerRef.current = null;
            }
        }
    };
    // Debounced validation effect for subject user
    $bh6RR.useEffect(()=>{
        let timer;
        if (subjectUser) timer = setTimeout(()=>{
            validateUser(subjectUser);
        }, 500);
        else {
            setValidationError("");
            setValidUser(null);
        }
        return ()=>{
            if (timer) clearTimeout(timer);
            // Cancel any in-flight request on cleanup
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
                abortControllerRef.current = null;
            }
        };
    }, [
        subjectUser
    ]);
    const handleStartClick = ()=>{
        if (inProgressInstance) setShowConfirmation(true);
        else handleConfirmedStart();
    };
    const handleConfirmedStart = async ()=>{
        setIsStarting(true);
        setStartError("");
        const metadata = {
            subjectUser: subjectUser || undefined,
            hand: hand || undefined,
            side: hand === "right" ? "even" : hand === "left" ? "odd" : undefined,
            backhandStyle: backhandStyle || undefined,
            userDescribedRating: ratingType && rating ? {
                type: ratingType,
                rating: rating
            } : null
        };
        try {
            await onStart(metadata);
            setShowConfirmation(false);
        } catch  {
            setStartError("Something went wrong. Please try again.");
        } finally{
            setIsStarting(false);
        }
    };
    const handleClose = ()=>{
        setShowConfirmation(false);
        onClose();
    };
    if (!journey) return null;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dUgAK.default), {
                open: open && !showConfirmation,
                onClose: handleClose,
                fullScreen: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $eLohH.default), {
                        sx: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        },
                        children: [
                            "Start ",
                            journey.title,
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                                onClick: handleClose,
                                edge: "end",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3Xpkr.default), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                            spacing: 2,
                            sx: {
                                mt: 1
                            },
                            children: [
                                canTransferToOtherUser && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                            variant: "subtitle2",
                                            children: "Transfer to another user (optional)"
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $hrqHU.default), {
                                            type: "text",
                                            label: "Username or email",
                                            value: subjectUser,
                                            onChange: (e)=>setSubjectUser(e.target.value),
                                            helperText: isValidating ? "Validating..." : validUser ? `Volley user: ${validUser.firstName} ${validUser.lastName}` : validationError ? `Not a Volley user` : undefined,
                                            fullWidth: true,
                                            slotProps: {
                                                inputLabel: {
                                                    sx: {
                                                        "&.Mui-focused": {
                                                            color: "inherit"
                                                        }
                                                    }
                                                },
                                                formHelperText: {
                                                    sx: {
                                                        color: validUser ? "success.main" : validationError ? "info.light" : undefined
                                                    }
                                                }
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                    variant: "subtitle2",
                                    children: "Required for Setup"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1TxeB.default), {
                                    fullWidth: true,
                                    required: true,
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $4IPS4.default), {
                                            sx: {
                                                "&.Mui-focused": {
                                                    color: "inherit"
                                                }
                                            },
                                            children: "Dominant Hand"
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $84xZD.default), {
                                            label: "Dominant Hand",
                                            value: hand,
                                            onChange: (e)=>setHand(e.target.value),
                                            children: $616000e91b8e4f47$var$HANDS.map((h)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $10RGt.default), {
                                                    value: h.value,
                                                    children: h.label
                                                }, h.value))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1TxeB.default), {
                                    fullWidth: true,
                                    required: true,
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $4IPS4.default), {
                                            sx: {
                                                "&.Mui-focused": {
                                                    color: "inherit"
                                                }
                                            },
                                            children: "Backhand Style"
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $84xZD.default), {
                                            label: "Backhand Style",
                                            value: backhandStyle,
                                            onChange: (e)=>setBackhandStyle(e.target.value),
                                            children: $616000e91b8e4f47$var$BACKHAND_STYLES.map((b)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $10RGt.default), {
                                                    value: b.value,
                                                    children: b.label
                                                }, b.value))
                                        })
                                    ]
                                }),
                                sport === "PICKLEBALL" && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                            variant: "subtitle2",
                                            children: "Your Current Rating (optional)"
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                                            direction: "row",
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1TxeB.default), {
                                                    sx: {
                                                        minWidth: 150
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $4IPS4.default), {
                                                            sx: {
                                                                "&.Mui-focused": {
                                                                    color: "inherit"
                                                                }
                                                            },
                                                            children: "Type"
                                                        }),
                                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $84xZD.default), {
                                                            label: "Type",
                                                            value: ratingType,
                                                            onChange: (e)=>setRatingType(e.target.value),
                                                            children: $616000e91b8e4f47$var$RATING_TYPES.map((t)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $10RGt.default), {
                                                                    value: t.value,
                                                                    children: t.label
                                                                }, t.value))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $hrqHU.default), {
                                                    label: "Rating",
                                                    value: rating,
                                                    onChange: (e)=>setRating(e.target.value),
                                                    inputMode: "decimal",
                                                    sx: {
                                                        width: 120,
                                                        "&.Mui-focused": {
                                                            color: "inherit"
                                                        }
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ldk.default), {}),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                    variant: "subtitle2",
                                    children: "Workouts in this assessment:"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $iZWBy.default), {
                                    dense: true,
                                    children: journey.journeyAppWorkouts.map((w, index)=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $kclvT.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $6qGY5.default), {
                                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $btx4r.default), {
                                                        sx: {
                                                            bgcolor: "secondary.main",
                                                            width: 28,
                                                            height: 28,
                                                            fontSize: "0.75rem"
                                                        },
                                                        children: index + 1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                                                    primary: w.appWorkout.name
                                                })
                                            ]
                                        }, w.id))
                                }),
                                inProgressInstance && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $506bB.default), {
                                    severity: "warning",
                                    icon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gSq4G.default), {}),
                                    sx: {
                                        mt: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                                            variant: "body2",
                                            gutterBottom: true,
                                            children: [
                                                "An unfinished assessment from",
                                                " ",
                                                (0, $cFAEN.terseTimeFormat)(new Date(inProgressInstance.startTime)),
                                                " ",
                                                "exists. Starting a new assessment above will permanently delete your pending progress."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                            size: "small",
                                            variant: "outlined",
                                            color: "warning",
                                            component: (0, $as544.Link),
                                            to: resumeUrl,
                                            onClick: handleResumeClick,
                                            sx: {
                                                mt: 1
                                            },
                                            children: "Resume Existing"
                                        })
                                    ]
                                }),
                                startError && /*#__PURE__*/ (0, $ih19M.jsx)((0, $506bB.default), {
                                    severity: "error",
                                    children: startError
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                    variant: "contained",
                                    color: "secondary",
                                    onClick: handleStartClick,
                                    disabled: !hand || !backhandStyle || isStarting,
                                    fullWidth: true,
                                    size: "large",
                                    sx: {
                                        color: "primary.main",
                                        mt: 2
                                    },
                                    children: "Let\u2019s Go!"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dUgAK.default), {
                open: showConfirmation,
                onClose: ()=>setShowConfirmation(false),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                            children: [
                                "Are you sure you want to start a new assessment? This will permanently delete your in-progress assessment from",
                                " ",
                                inProgressInstance && (0, $cFAEN.terseTimeFormat)(new Date(inProgressInstance.startTime)),
                                "."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bK42r.default), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                onClick: ()=>setShowConfirmation(false),
                                color: "inherit",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                onClick: handleConfirmedStart,
                                color: "error",
                                disabled: isStarting,
                                children: "Delete & Start New"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $616000e91b8e4f47$export$2e2bcd8739ae039 = $616000e91b8e4f47$var$AssessmentStartDialog;

});
parcelRegister("gSq4G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c495ea5723d3a6a2$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $c495ea5723d3a6a2$export$2e2bcd8739ae039 = (0, $fWXJ7.default)([
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22z"
    }, "0"),
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M13 16h-2v2h2zm0-6h-2v5h2z"
    }, "1")
], 'WarningAmber');

});

parcelRegister("btx4r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85ac0e45a04d073d$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $aTI3z = parcelRequire("aTI3z");

var $3Z79e = parcelRequire("3Z79e");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
const $85ac0e45a04d073d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            colorDefault && 'colorDefault'
        ],
        img: [
            'img'
        ],
        fallback: [
            'fallback'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $3Z79e.getAvatarUtilityClass), classes);
};
const $85ac0e45a04d073d$var$AvatarRoot = (0, $l0oRz.default)('div', {
    name: 'MuiAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: '50%',
        overflow: 'hidden',
        userSelect: 'none',
        variants: [
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'square'
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: {
                    color: (theme.vars || theme).palette.background.default,
                    ...theme.vars ? {
                        backgroundColor: theme.vars.palette.Avatar.defaultBg
                    } : {
                        backgroundColor: theme.palette.grey[400],
                        ...theme.applyStyles('dark', {
                            backgroundColor: theme.palette.grey[600]
                        })
                    }
                }
            }
        ]
    })));
const $85ac0e45a04d073d$var$AvatarImg = (0, $l0oRz.default)('img', {
    name: 'MuiAvatar',
    slot: 'Img'
})({
    width: '100%',
    height: '100%',
    textAlign: 'center',
    // Handle non-square image.
    objectFit: 'cover',
    // Hide alt text.
    color: 'transparent',
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $85ac0e45a04d073d$var$AvatarFallback = (0, $l0oRz.default)((0, $aTI3z.default), {
    name: 'MuiAvatar',
    slot: 'Fallback'
})({
    width: '75%',
    height: '75%'
});
function $85ac0e45a04d073d$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $bh6RR.useState(false);
    $bh6RR.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded('loaded');
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded('error');
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $85ac0e45a04d073d$var$Avatar = /*#__PURE__*/ $bh6RR.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiAvatar'
    });
    const { alt: alt, children: childrenProp, className: className, component: component = 'div', slots: slots = {}, slotProps: slotProps = {}, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = 'circular', ...other } = props;
    let children = null;
    const ownerState = {
        ...props,
        component: component,
        variant: variant
    };
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $85ac0e45a04d073d$var$useLoaded({
        ...imgProps,
        ...typeof slotProps.img === 'function' ? slotProps.img(ownerState) : slotProps.img,
        src: src,
        srcSet: srcSet
    });
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== 'error';
    ownerState.colorDefault = !hasImgNotFailing;
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $85ac0e45a04d073d$var$useUtilityClasses(ownerState);
    const [RootSlot, rootSlotProps] = (0, $dFvJW.default)('root', {
        ref: ref,
        className: (0, $aPsoC.default)(classes.root, className),
        elementType: $85ac0e45a04d073d$var$AvatarRoot,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            component: component,
            ...other
        },
        ownerState: ownerState
    });
    const [ImgSlot, imgSlotProps] = (0, $dFvJW.default)('img', {
        className: classes.img,
        elementType: $85ac0e45a04d073d$var$AvatarImg,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                img: {
                    ...imgProps,
                    ...slotProps.img
                }
            }
        },
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes
        },
        ownerState: ownerState
    });
    const [FallbackSlot, fallbackSlotProps] = (0, $dFvJW.default)('fallback', {
        className: classes.fallback,
        elementType: $85ac0e45a04d073d$var$AvatarFallback,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $ih19M.jsx)(ImgSlot, {
        ...imgSlotProps
    });
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $ih19M.jsx)(FallbackSlot, {
        ...fallbackSlotProps
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)(RootSlot, {
        ...rootSlotProps,
        children: children
    });
});
var $85ac0e45a04d073d$export$2e2bcd8739ae039 = $85ac0e45a04d073d$var$Avatar;

});
parcelRegister("aTI3z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ef13728d6e5a477$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $7ef13728d6e5a477$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');

});

parcelRegister("3Z79e", function(module, exports) {

$parcel$export(module.exports, "getAvatarUtilityClass", function () { return $2e6c9d03bff73e2f$export$ffd560f22c0ecf04; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $2e6c9d03bff73e2f$export$ffd560f22c0ecf04(slot) {
    return (0, $dmzXD.default)('MuiAvatar', slot);
}
const $2e6c9d03bff73e2f$var$avatarClasses = (0, $fYlYP.default)('MuiAvatar', [
    'root',
    'colorDefault',
    'circular',
    'rounded',
    'square',
    'img',
    'fallback'
]);
var $2e6c9d03bff73e2f$export$2e2bcd8739ae039 = $2e6c9d03bff73e2f$var$avatarClasses;

});


parcelRegister("j5ldk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de4ef09d2705ac06$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $jZGwA = parcelRequire("jZGwA");

var $ih19M = parcelRequire("ih19M");
'use client';
const $de4ef09d2705ac06$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $jZGwA.getDividerUtilityClass), classes);
};
const $de4ef09d2705ac06$var$DividerRoot = (0, $l0oRz.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.alpha((theme.vars || theme).palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $de4ef09d2705ac06$var$DividerWrapper = (0, $l0oRz.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $de4ef09d2705ac06$var$Divider = /*#__PURE__*/ $bh6RR.forwardRef(function Divider(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    };
    const classes = $de4ef09d2705ac06$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($de4ef09d2705ac06$var$DividerRoot, {
        as: component,
        className: (0, $aPsoC.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, $ih19M.jsx)($de4ef09d2705ac06$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if ($de4ef09d2705ac06$var$Divider) $de4ef09d2705ac06$var$Divider.muiSkipListHighlight = true;
var $de4ef09d2705ac06$export$2e2bcd8739ae039 = $de4ef09d2705ac06$var$Divider;

});
parcelRegister("jZGwA", function(module, exports) {

$parcel$export(module.exports, "getDividerUtilityClass", function () { return $e8e4b34d08b94997$export$46f01d01378ec5a2; });
$parcel$export(module.exports, "default", function () { return $e8e4b34d08b94997$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $e8e4b34d08b94997$export$46f01d01378ec5a2(slot) {
    return (0, $dmzXD.default)('MuiDivider', slot);
}
const $e8e4b34d08b94997$var$dividerClasses = (0, $fYlYP.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $e8e4b34d08b94997$export$2e2bcd8739ae039 = $e8e4b34d08b94997$var$dividerClasses;

});


parcelRegister("kclvT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb459dc68b97465f$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");



var $g0K0l = parcelRequire("g0K0l");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $kN5Np = parcelRequire("kN5Np");

var $dg012 = parcelRequire("dg012");

var $bvRvQ = parcelRequire("bvRvQ");

var $euvO6 = parcelRequire("euvO6");

var $cuEW8 = parcelRequire("cuEW8");

var $4A6i3 = parcelRequire("4A6i3");

var $ih19M = parcelRequire("ih19M");
'use client';
const $eb459dc68b97465f$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $eb459dc68b97465f$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction'
        ],
        container: [
            'container'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $euvO6.getListItemUtilityClass), classes);
};
const $eb459dc68b97465f$export$aed538f7519abe89 = (0, $l0oRz.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $eb459dc68b97465f$export$4334bb34c76fef24
})((0, $gfPc7.default)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${(0, $cuEW8.default).root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const $eb459dc68b97465f$var$ListItemContainer = (0, $l0oRz.default)('li', {
    name: 'MuiListItem',
    slot: 'Container'
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $eb459dc68b97465f$var$ListItem = /*#__PURE__*/ $bh6RR.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName, ...ContainerProps } = {}, dense: dense = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, secondaryAction: secondaryAction, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const context = $bh6RR.useContext((0, $bvRvQ.default));
    const childContext = $bh6RR.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $bh6RR.useRef(null);
    const children = $bh6RR.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in a future major release
    const hasSecondaryAction = children.length && (0, $kN5Np.default)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction
    };
    const classes = $eb459dc68b97465f$var$useUtilityClasses(ownerState);
    const handleRef = (0, $dg012.default)(listItemRef, ref);
    const Root = slots.root || components.Root || $eb459dc68b97465f$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = {
        className: (0, $aPsoC.default)(classes.root, rootProps.className, className),
        ...other
    };
    let Component = componentProp || 'li';
    // v4 implementation, deprecated in v6, will be removed in a future major release
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $bvRvQ.default).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $ih19M.jsxs)($eb459dc68b97465f$var$ListItemContainer, {
                as: ContainerComponent,
                className: (0, $aPsoC.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState,
                ...ContainerProps,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)(Root, {
                        ...rootProps,
                        ...!(0, $g0K0l.default)(Root) && {
                            as: Component,
                            ownerState: {
                                ...ownerState,
                                ...rootProps.ownerState
                            }
                        },
                        ...componentProps,
                        children: children
                    }),
                    children.pop()
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $bvRvQ.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)(Root, {
            ...rootProps,
            as: Component,
            ref: handleRef,
            ...!(0, $g0K0l.default)(Root) && {
                ownerState: {
                    ...ownerState,
                    ...rootProps.ownerState
                }
            },
            ...componentProps,
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $ih19M.jsx)((0, $4A6i3.default), {
                    children: secondaryAction
                })
            ]
        })
    });
});
var $eb459dc68b97465f$export$2e2bcd8739ae039 = $eb459dc68b97465f$var$ListItem;

});
parcelRegister("euvO6", function(module, exports) {

$parcel$export(module.exports, "getListItemUtilityClass", function () { return $a8cc8a448239d4b3$export$5682c366c0c669d9; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $a8cc8a448239d4b3$export$5682c366c0c669d9(slot) {
    return (0, $dmzXD.default)('MuiListItem', slot);
}
const $a8cc8a448239d4b3$var$listItemClasses = (0, $fYlYP.default)('MuiListItem', [
    'root',
    'container',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var $a8cc8a448239d4b3$export$2e2bcd8739ae039 = $a8cc8a448239d4b3$var$listItemClasses;

});

parcelRegister("cuEW8", function(module, exports) {

$parcel$export(module.exports, "getListItemButtonUtilityClass", function () { return $91880a86907b48ef$export$c09531d8563c67a5; });
$parcel$export(module.exports, "default", function () { return $91880a86907b48ef$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $91880a86907b48ef$export$c09531d8563c67a5(slot) {
    return (0, $dmzXD.default)('MuiListItemButton', slot);
}
const $91880a86907b48ef$var$listItemButtonClasses = (0, $fYlYP.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $91880a86907b48ef$export$2e2bcd8739ae039 = $91880a86907b48ef$var$listItemButtonClasses;

});

parcelRegister("4A6i3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $355f67503658825c$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $bvRvQ = parcelRequire("bvRvQ");

var $3A4NR = parcelRequire("3A4NR");

var $ih19M = parcelRequire("ih19M");
'use client';
const $355f67503658825c$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $3A4NR.getListItemSecondaryActionClassesUtilityClass), classes);
};
const $355f67503658825c$var$ListItemSecondaryActionRoot = (0, $l0oRz.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const $355f67503658825c$var$ListItemSecondaryAction = /*#__PURE__*/ $bh6RR.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className, ...other } = props;
    const context = $bh6RR.useContext((0, $bvRvQ.default));
    const ownerState = {
        ...props,
        disableGutters: context.disableGutters
    };
    const classes = $355f67503658825c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($355f67503658825c$var$ListItemSecondaryActionRoot, {
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$355f67503658825c$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $355f67503658825c$export$2e2bcd8739ae039 = $355f67503658825c$var$ListItemSecondaryAction;

});
parcelRegister("3A4NR", function(module, exports) {

$parcel$export(module.exports, "getListItemSecondaryActionClassesUtilityClass", function () { return $29b875b97174d001$export$ccdb26aeba48a86e; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $29b875b97174d001$export$ccdb26aeba48a86e(slot) {
    return (0, $dmzXD.default)('MuiListItemSecondaryAction', slot);
}
const $29b875b97174d001$var$listItemSecondaryActionClasses = (0, $fYlYP.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $29b875b97174d001$export$2e2bcd8739ae039 = $29b875b97174d001$var$listItemSecondaryActionClasses;

});



parcelRegister("6qGY5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ae680623055631a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $bvRvQ = parcelRequire("bvRvQ");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $fIzmL = parcelRequire("fIzmL");

var $ih19M = parcelRequire("ih19M");
'use client';
const $4ae680623055631a$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $fIzmL.getListItemAvatarUtilityClass), classes);
};
const $4ae680623055631a$var$ListItemAvatarRoot = (0, $l0oRz.default)('div', {
    name: 'MuiListItemAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})({
    minWidth: 56,
    flexShrink: 0,
    variants: [
        {
            props: {
                alignItems: 'flex-start'
            },
            style: {
                marginTop: 8
            }
        }
    ]
});
/**
 * A simple wrapper to apply `List` styles to an `Avatar`.
 */ const $4ae680623055631a$var$ListItemAvatar = /*#__PURE__*/ $bh6RR.forwardRef(function ListItemAvatar(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemAvatar'
    });
    const { className: className, ...other } = props;
    const context = $bh6RR.useContext((0, $bvRvQ.default));
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = $4ae680623055631a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($4ae680623055631a$var$ListItemAvatarRoot, {
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $4ae680623055631a$export$2e2bcd8739ae039 = $4ae680623055631a$var$ListItemAvatar;

});
parcelRegister("fIzmL", function(module, exports) {

$parcel$export(module.exports, "getListItemAvatarUtilityClass", function () { return $b716660aec26f019$export$e4f04f80f2ce3fc0; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $b716660aec26f019$export$e4f04f80f2ce3fc0(slot) {
    return (0, $dmzXD.default)('MuiListItemAvatar', slot);
}
const $b716660aec26f019$var$listItemAvatarClasses = (0, $fYlYP.default)('MuiListItemAvatar', [
    'root',
    'alignItemsFlexStart'
]);
var $b716660aec26f019$export$2e2bcd8739ae039 = $b716660aec26f019$var$listItemAvatarClasses;

});


parcelRegister("gfi3N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd3c0e6b758a795f$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $cbFbS = parcelRequire("cbFbS");
var $c33n3 = parcelRequire("c33n3");

var $bvRvQ = parcelRequire("bvRvQ");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $blsZA = parcelRequire("blsZA");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
const $bd3c0e6b758a795f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $blsZA.getListItemTextUtilityClass), classes);
};
const $bd3c0e6b758a795f$var$ListItemTextRoot = (0, $l0oRz.default)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $blsZA.default).primary}`]: styles.primary
            },
            {
                [`& .${(0, $blsZA.default).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    [`.${(0, $c33n3.default).root}:where(& .${(0, $blsZA.default).primary})`]: {
        display: 'block'
    },
    [`.${(0, $c33n3.default).root}:where(& .${(0, $blsZA.default).secondary})`]: {
        display: 'block'
    },
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const $bd3c0e6b758a795f$var$ListItemText = /*#__PURE__*/ $bh6RR.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { dense: dense } = $bh6RR.useContext((0, $bvRvQ.default));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    };
    const classes = $bd3c0e6b758a795f$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $dFvJW.default)('root', {
        className: (0, $aPsoC.default)(classes.root, className),
        elementType: $bd3c0e6b758a795f$var$ListItemTextRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref
    });
    const [PrimarySlot, primarySlotProps] = (0, $dFvJW.default)('primary', {
        className: classes.primary,
        elementType: (0, $cbFbS.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, $dFvJW.default)('secondary', {
        className: classes.secondary,
        elementType: (0, $cbFbS.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    if (primary != null && primary.type !== (0, $cbFbS.default) && !disableTypography) primary = /*#__PURE__*/ (0, $ih19M.jsx)(PrimarySlot, {
        variant: dense ? 'body2' : 'body1',
        component: primarySlotProps?.variant ? undefined : 'span',
        ...primarySlotProps,
        children: primary
    });
    if (secondary != null && secondary.type !== (0, $cbFbS.default) && !disableTypography) secondary = /*#__PURE__*/ (0, $ih19M.jsx)(SecondarySlot, {
        variant: "body2",
        color: "textSecondary",
        ...secondarySlotProps,
        children: secondary
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            primary,
            secondary
        ]
    });
});
var $bd3c0e6b758a795f$export$2e2bcd8739ae039 = $bd3c0e6b758a795f$var$ListItemText;

});
parcelRegister("blsZA", function(module, exports) {

$parcel$export(module.exports, "getListItemTextUtilityClass", function () { return $8428252545b2b0fb$export$1061006a0db3aeb5; });
$parcel$export(module.exports, "default", function () { return $8428252545b2b0fb$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $8428252545b2b0fb$export$1061006a0db3aeb5(slot) {
    return (0, $dmzXD.default)('MuiListItemText', slot);
}
const $8428252545b2b0fb$var$listItemTextClasses = (0, $fYlYP.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $8428252545b2b0fb$export$2e2bcd8739ae039 = $8428252545b2b0fb$var$listItemTextClasses;

});


parcelRegister("10RGt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bcf6f0b8981f57b$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $b6vKX = parcelRequire("b6vKX");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $bvRvQ = parcelRequire("bvRvQ");

var $fbTZq = parcelRequire("fbTZq");

var $14LyK = parcelRequire("14LyK");

var $dg012 = parcelRequire("dg012");

var $jZGwA = parcelRequire("jZGwA");

var $5wa4U = parcelRequire("5wa4U");

var $blsZA = parcelRequire("blsZA");

var $lbQXP = parcelRequire("lbQXP");

var $ih19M = parcelRequire("ih19M");
'use client';
const $0bcf6f0b8981f57b$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $0bcf6f0b8981f57b$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $lbQXP.getMenuItemUtilityClass), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $0bcf6f0b8981f57b$var$MenuItemRoot = (0, $l0oRz.default)((0, $fbTZq.default), {
    shouldForwardProp: (prop)=>(0, $b6vKX.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $0bcf6f0b8981f57b$export$4334bb34c76fef24
})((0, $gfPc7.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $lbQXP.default).selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            [`&.${(0, $lbQXP.default).focusVisible}`]: {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
            }
        },
        [`&.${(0, $lbQXP.default).selected}:hover`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $lbQXP.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $lbQXP.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $jZGwA.default).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $jZGwA.default).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $blsZA.default).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $blsZA.default).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $5wa4U.default).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${(0, $5wa4U.default).root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const $0bcf6f0b8981f57b$var$MenuItem = /*#__PURE__*/ $bh6RR.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $bh6RR.useContext((0, $bvRvQ.default));
    const childContext = $bh6RR.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $bh6RR.useRef(null);
    (0, $14LyK.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $0bcf6f0b8981f57b$var$useUtilityClasses(props);
    const handleRef = (0, $dg012.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $bvRvQ.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($0bcf6f0b8981f57b$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $aPsoC.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $aPsoC.default)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $0bcf6f0b8981f57b$export$2e2bcd8739ae039 = $0bcf6f0b8981f57b$var$MenuItem;

});
parcelRegister("5wa4U", function(module, exports) {

$parcel$export(module.exports, "getListItemIconUtilityClass", function () { return $4047c239e8613f69$export$81478e24460c57f2; });
$parcel$export(module.exports, "default", function () { return $4047c239e8613f69$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $4047c239e8613f69$export$81478e24460c57f2(slot) {
    return (0, $dmzXD.default)('MuiListItemIcon', slot);
}
const $4047c239e8613f69$var$listItemIconClasses = (0, $fYlYP.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $4047c239e8613f69$export$2e2bcd8739ae039 = $4047c239e8613f69$var$listItemIconClasses;

});

parcelRegister("lbQXP", function(module, exports) {

$parcel$export(module.exports, "getMenuItemUtilityClass", function () { return $f6d3b599d8c23a72$export$515f8c67b5305377; });
$parcel$export(module.exports, "default", function () { return $f6d3b599d8c23a72$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $f6d3b599d8c23a72$export$515f8c67b5305377(slot) {
    return (0, $dmzXD.default)('MuiMenuItem', slot);
}
const $f6d3b599d8c23a72$var$menuItemClasses = (0, $fYlYP.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $f6d3b599d8c23a72$export$2e2bcd8739ae039 = $f6d3b599d8c23a72$var$menuItemClasses;

});


parcelRegister("b2ct8", function(module, exports) {

$parcel$export(module.exports, "DUPR_APP_ASSESSOR_FEATURE", function () { return $902b522ce094d6bb$export$79a18db4d1a4b2a3; });
$parcel$export(module.exports, "WPR_APP_ASSESSOR_FEATURE", function () { return $902b522ce094d6bb$export$a01b9f3774746d35; });
$parcel$export(module.exports, "isAssessmentAssessor", function () { return $902b522ce094d6bb$export$353e7d35280fbd6a; });
$parcel$export(module.exports, "ADMINISTER_ASSESSMENT_PROXY_FEATURE", function () { return $902b522ce094d6bb$export$f8468f7ea1d624f5; });
/**
 * Feature flag (configured server-side as segment-backed by
 * `long_form_assessment_assessor_access`) that surfaces the DUPR App
 * "Administer Assessment" entry in the hamburger menu. Server-side start is the
 * authoritative gate; this only controls menu visibility.
 *
 * NOTE: the flag string value changed with the DUPR App rename; the remote-config
 * flag must be renamed to "DUPR_APP_ASSESSOR" in lockstep (kept in sync with the
 * server-side `DUPR_APP_ASSESSOR_FEATURE` in dupr-app-level.ts). The
 * `long_form_assessment_assessor_access` segment value is persisted and unchanged.
 */ const $902b522ce094d6bb$export$79a18db4d1a4b2a3 = "DUPR_APP_ASSESSOR";
const $902b522ce094d6bb$export$a01b9f3774746d35 = "WPR_APP_ASSESSOR";
function $902b522ce094d6bb$export$353e7d35280fbd6a(isAdmin, features) {
    return isAdmin || features.includes($902b522ce094d6bb$export$79a18db4d1a4b2a3) || features.includes($902b522ce094d6bb$export$a01b9f3774746d35);
}
const $902b522ce094d6bb$export$f8468f7ea1d624f5 = "ADMINISTER_ASSESSMENT_PROXY";

});



parcelRegister("g0YYy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5019f00c55c142a$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bZrpr = parcelRequire("bZrpr");

var $506bB = parcelRequire("506bB");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $95FNu = parcelRequire("95FNu");

var $5CVHy = parcelRequire("5CVHy");

var $dUgAK = parcelRequire("dUgAK");

var $1W9Do = parcelRequire("1W9Do");

var $j5ldk = parcelRequire("j5ldk");

var $4Athc = parcelRequire("4Athc");

var $euyyI = parcelRequire("euyyI");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $aOb5j = parcelRequire("aOb5j");

var $cI8xM = parcelRequire("cI8xM");

var $2jcKA = parcelRequire("2jcKA");

var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");
const $c5019f00c55c142a$var$GENERIC_LINK_ERROR = "Could not link your DUPR\xae account.";
/**
 * The link refusals a player can actually do something about. Copy lives here
 * rather than echoing the server's `message` so the ® styling matches the rest
 * of this component, and it is keyed off the machine-readable `reason` so an
 * unrecognized failure (or a 500 body) can never be rendered at a player.
 */ const $c5019f00c55c142a$var$LINK_ERRORS = {
    dupr_account_in_use: "That DUPR\xae account is already connected to a different Volley account.",
    // "Unlink", not "disconnect" — that is what the button in this component
    // is labelled, and it is on screen whenever this refusal can happen.
    different_account_linked: "This Volley account is already connected to a different DUPR\xae account. Unlink it before connecting a new one."
};
function $c5019f00c55c142a$var$linkErrorMessage(e) {
    if (!(e instanceof (0, $cK0UE.FetchError)) || e.statusCode !== 409) return $c5019f00c55c142a$var$GENERIC_LINK_ERROR;
    const { reason: reason } = e.body ?? {};
    if (typeof reason !== "string") return $c5019f00c55c142a$var$GENERIC_LINK_ERROR;
    return $c5019f00c55c142a$var$LINK_ERRORS[reason] ?? $c5019f00c55c142a$var$GENERIC_LINK_ERROR;
}
function $c5019f00c55c142a$var$RatingBlock({ label: label, rating: rating, primary: primary = false }) {
    const subscoreEntries = Object.entries(rating.subscores ?? {});
    const value = (0, $2jcKA.formatDuprRating)(rating.value, {
        placeholder: "NR"
    });
    const verified = (0, $2jcKA.formatDuprRating)(rating.verified, {
        placeholder: ""
    });
    // Build the metadata line from whatever DUPR actually returned. The
    // verified rating is compared AFTER formatting: DUPR sends three decimals,
    // so two ratings that render identically here can still differ in a digit
    // the player never sees, and showing "3.75 · Verified 3.75" reads as a bug.
    // Reliability arrives from DUPR already scaled 0..100, so it is formatted
    // rather than rescaled. Suppressed for an unrated format, where DUPR's 0 is
    // the absence of a rating and not a real confidence.
    const reliability = (0, $2jcKA.isDuprRated)(rating.value) ? (0, $2jcKA.formatDuprReliability)(rating.reliability) : null;
    const meta = [
        verified && verified !== value ? `Verified ${verified}` : null,
        reliability !== null ? `Reliability ${reliability}` : null,
        rating.careerHigh ? `Career high ${(0, $2jcKA.formatDuprRating)(rating.careerHigh)}` : null
    ].filter(Boolean);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                direction: "row",
                spacing: 1,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "caption",
                        color: "text.secondary",
                        children: label
                    }),
                    primary && /*#__PURE__*/ (0, $ih19M.jsx)((0, $95FNu.default), {
                        label: "Primary",
                        size: "small",
                        variant: "outlined"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                direction: "row",
                spacing: 1,
                alignItems: "baseline",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "h4",
                        component: "span",
                        children: value
                    }),
                    rating.aiAnnotated && /*#__PURE__*/ (0, $ih19M.jsx)((0, $bZrpr.default), {
                        fontSize: "small",
                        color: "primary",
                        titleAccess: "Volley AI-estimated rating"
                    }),
                    rating.provisional && !rating.aiAnnotated && /*#__PURE__*/ (0, $ih19M.jsx)((0, $95FNu.default), {
                        label: "Provisional",
                        size: "small",
                        color: "warning"
                    })
                ]
            }),
            meta.length > 0 && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                variant: "caption",
                color: "text.secondary",
                component: "div",
                children: meta.join(" \xb7 ")
            }),
            subscoreEntries.length > 0 && /*#__PURE__*/ (0, $ih19M.jsx)((0, $8JNI1.default), {
                direction: "row",
                spacing: 0.5,
                flexWrap: "wrap",
                mt: 0.5,
                children: subscoreEntries.map(([key, subscore])=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $95FNu.default), {
                        label: `${key}: ${(0, $2jcKA.formatDuprRating)(subscore)}`,
                        size: "small",
                        variant: "outlined"
                    }, key))
            })
        ]
    });
}
function $c5019f00c55c142a$var$DuprRatingCard({ profile: profile }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $4Athc.default), {
        variant: "outlined",
        sx: {
            p: 2
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            mb: 0.5,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                    variant: "subtitle2",
                                    sx: {
                                        fontWeight: 900,
                                        letterSpacing: 1.5,
                                        color: "#001762"
                                    },
                                    children: "DUPR\xae"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $95FNu.default), {
                                    label: "Connected",
                                    size: "small",
                                    color: "success",
                                    variant: "outlined"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "h4",
                            children: profile.name ?? "DUPR\xae Member"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                            variant: "caption",
                            color: "text.secondary",
                            children: [
                                "DUPR\xae ID ",
                                profile.duprId,
                                profile.syncedAt ? ` \xb7 synced ${new Date(profile.syncedAt).toLocaleString()}` : ""
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ldk.default), {}),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    direction: {
                        xs: "column",
                        sm: "row"
                    },
                    spacing: 3,
                    divider: /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ldk.default), {
                        orientation: "vertical",
                        flexItem: true
                    }),
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)($c5019f00c55c142a$var$RatingBlock, {
                            label: "Doubles",
                            rating: profile.doubles,
                            primary: profile.defaultRating === "DOUBLES"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)($c5019f00c55c142a$var$RatingBlock, {
                            label: "Singles",
                            rating: profile.singles,
                            primary: profile.defaultRating === "SINGLES"
                        })
                    ]
                })
            ]
        })
    });
}
function $c5019f00c55c142a$export$2e2bcd8739ae039({ ssoConfig: ssoConfig, onProfileChange: onProfileChange, renderConnect: renderConnect, description: description }) {
    const theme = (0, $aOb5j.default)();
    const fullScreen = (0, $cI8xM.default)(theme.breakpoints.down("sm"));
    const [loading, setLoading] = $bh6RR.useState(true);
    const [profile, setProfile] = $bh6RR.useState(null);
    const [dialogOpen, setDialogOpen] = $bh6RR.useState(false);
    const [busy, setBusy] = $bh6RR.useState(false);
    const [error, setError] = $bh6RR.useState("");
    // Surface every profile transition (load/link/refresh/unlink) to the parent.
    $bh6RR.useEffect(()=>{
        onProfileChange?.(profile);
    }, [
        profile,
        onProfileChange
    ]);
    // Load any existing link on mount. A 404 simply means "not linked yet".
    $bh6RR.useEffect(()=>{
        (0, $cK0UE.default)("/api/integrations/dupr/me").then((p)=>setProfile(p)).catch((e)=>{
            if (!(e instanceof (0, $cK0UE.FetchError) && e.statusCode === 404)) (0, $cK0UE.logFetchError)(e);
        }).finally(()=>setLoading(false));
    }, []);
    const onConnect = $bh6RR.useCallback(()=>{
        setDialogOpen(true);
    }, []);
    // While the login dialog is open, listen for the token postMessage that
    // DUPR's embedded login emits on success. Origin is validated against the
    // configured DUPR host before we trust the payload.
    $bh6RR.useEffect(()=>{
        if (!dialogOpen) return undefined;
        const expectedOrigin = new URL(ssoConfig.ssoLoginUrl).origin;
        const handler = (event)=>{
            if (event.origin !== expectedOrigin) return;
            const data = event.data && typeof event.data === "object" ? event.data : event;
            const { userToken: userToken, refreshToken: refreshToken, duprId: duprId, id: id, stats: stats } = data;
            if (!userToken || !refreshToken || !duprId) return;
            setBusy(true);
            (0, $cK0UE.default)("/api/integrations/dupr/link", "POST", {
                userToken: userToken,
                refreshToken: refreshToken,
                duprId: duprId,
                providerInternalId: id != null ? String(id) : null,
                stats: stats
            }).then((linked)=>{
                setProfile(linked);
                setDialogOpen(false);
            }).catch((e)=>{
                (0, $cK0UE.logFetchError)(e);
                setError($c5019f00c55c142a$var$linkErrorMessage(e));
                // A 409 is a standing refusal, not a hiccup: re-running SSO
                // in the iframe will land in exactly the same place, so
                // close it rather than inviting a retry behind the snackbar.
                if (e instanceof (0, $cK0UE.FetchError) && e.statusCode === 409) setDialogOpen(false);
            }).finally(()=>setBusy(false));
        };
        window.addEventListener("message", handler);
        return ()=>window.removeEventListener("message", handler);
    }, [
        dialogOpen,
        ssoConfig
    ]);
    const onRefresh = $bh6RR.useCallback(()=>{
        setBusy(true);
        (0, $cK0UE.default)("/api/integrations/dupr/me?refresh=true").then((p)=>setProfile(p)).catch((e)=>{
            (0, $cK0UE.logFetchError)(e);
            setError("Could not refresh DUPR\xae data.");
        }).finally(()=>setBusy(false));
    }, []);
    const onUnlink = $bh6RR.useCallback(()=>{
        setBusy(true);
        (0, $cK0UE.default)("/api/integrations/dupr/me", "DELETE").then(()=>setProfile(null)).catch((e)=>{
            (0, $cK0UE.logFetchError)(e);
            setError("Could not unlink your DUPR\xae account.");
        }).finally(()=>setBusy(false));
    }, []);
    if (loading) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
        display: "flex",
        justifyContent: "center",
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {})
    });
    const ssoSrc = `${ssoConfig.ssoLoginUrl}/login-external-app/${ssoConfig.base64ClientKey}`;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            profile ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($c5019f00c55c142a$var$DuprRatingCard, {
                        profile: profile
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                        direction: "row",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                variant: "outlined",
                                color: "info",
                                onClick: onRefresh,
                                disabled: busy,
                                children: "Refresh"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                variant: "outlined",
                                color: "inherit",
                                onClick: onUnlink,
                                disabled: busy,
                                children: "Unlink"
                            })
                        ]
                    })
                ]
            }) : renderConnect ? renderConnect(onConnect) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                spacing: 1.5,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "body2",
                        color: "text.secondary",
                        children: description ?? "Connect your DUPR\xae account to see your official pickleball ratings here."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $eedE5.default), {
                            variant: "contained",
                            disableElevation: true,
                            onClick: onConnect,
                            sx: {
                                backgroundColor: "#001762",
                                color: "#ffffff",
                                textTransform: "none",
                                borderRadius: "6px",
                                fontWeight: 600,
                                fontSize: "0.9375rem",
                                letterSpacing: "0.015em",
                                px: 2.5,
                                py: 1,
                                gap: 1.5,
                                "&:hover": {
                                    backgroundColor: "#0f4299"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                    component: "span",
                                    sx: {
                                        fontWeight: 900,
                                        letterSpacing: "0.08em",
                                        borderRight: "1px solid rgba(255,255,255,0.3)",
                                        pr: 1.5
                                    },
                                    children: "DUPR\xae"
                                }),
                                "Connect account"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dUgAK.default), {
                open: dialogOpen,
                fullWidth: true,
                maxWidth: "sm",
                fullScreen: fullScreen,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                        onClose: ()=>setDialogOpen(false),
                        children: "Connect your DUPR\xae account"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                        dividers: true,
                        sx: {
                            p: 0,
                            m: 0,
                            position: "relative",
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [
                            busy && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                sx: {
                                    position: "absolute",
                                    inset: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    bgcolor: "rgba(255,255,255,0.6)",
                                    zIndex: 1
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {})
                            }),
                            ssoSrc && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                component: "iframe",
                                title: "DUPR\xae Login",
                                src: ssoSrc,
                                allow: "payment",
                                sx: {
                                    width: "100%",
                                    height: fullScreen ? "100%" : 600,
                                    flex: fullScreen ? 1 : "none",
                                    border: 0,
                                    display: "block"
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $euyyI.default), {
                autoHideDuration: 5000,
                open: !!error,
                onClose: ()=>setError(""),
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $506bB.default), {
                    severity: "error",
                    children: error
                })
            })
        ]
    });
}

});
parcelRegister("cI8xM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $941038bcfb224281$export$2e2bcd8739ae039; });

var $9B4vF = parcelRequire("9B4vF");

var $2N3YN = parcelRequire("2N3YN");
const $941038bcfb224281$var$useMediaQuery = (0, $9B4vF.unstable_createUseMediaQuery)({
    themeId: (0, $2N3YN.default)
});
var $941038bcfb224281$export$2e2bcd8739ae039 = $941038bcfb224281$var$useMediaQuery;

});
parcelRegister("9B4vF", function(module, exports) {

$parcel$export(module.exports, "unstable_createUseMediaQuery", function () { return $6fcb1152c15101f5$export$96d7927a982220b5; });

var $bh6RR = parcelRequire("bh6RR");

var $kLukk = parcelRequire("kLukk");

var $lGIi0 = parcelRequire("lGIi0");

var $65M4H = parcelRequire("65M4H");
'use client';
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $6fcb1152c15101f5$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $bh6RR.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $kLukk.default)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $6fcb1152c15101f5$var$safeReact = {
    ...$bh6RR
};
const $6fcb1152c15101f5$var$maybeReactUseSyncExternalStore = $6fcb1152c15101f5$var$safeReact.useSyncExternalStore;
function $6fcb1152c15101f5$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $bh6RR.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $bh6RR.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $bh6RR.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $6fcb1152c15101f5$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $6fcb1152c15101f5$export$96d7927a982220b5(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $65M4H.default)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $lGIi0.default)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = $6fcb1152c15101f5$var$maybeReactUseSyncExternalStore !== undefined ? $6fcb1152c15101f5$var$useMediaQueryNew : $6fcb1152c15101f5$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $6fcb1152c15101f5$var$useMediaQuery = $6fcb1152c15101f5$export$96d7927a982220b5();
var $6fcb1152c15101f5$export$2e2bcd8739ae039 = $6fcb1152c15101f5$var$useMediaQuery;

});


parcelRegister("2jcKA", function(module, exports) {

$parcel$export(module.exports, "formatDuprRating", function () { return $1ae73f131b9490f2$export$d712cf10a33f1a42; });
$parcel$export(module.exports, "isDuprRated", function () { return $1ae73f131b9490f2$export$9901a12466628e42; });
$parcel$export(module.exports, "duprReliabilityPercent", function () { return $1ae73f131b9490f2$export$94ee09868a16dc3b; });
$parcel$export(module.exports, "formatDuprReliability", function () { return $1ae73f131b9490f2$export$861d09b227bf85f1; });
const $1ae73f131b9490f2$var$MIN_RATING = 2.0;
const $1ae73f131b9490f2$var$MAX_RATING = 8.0;
const $1ae73f131b9490f2$var$BAND_WIDTH = 0.5;
const $1ae73f131b9490f2$export$b2d94958b10688d7 = "band";
const $1ae73f131b9490f2$export$91f0dd76b7830064 = 2;
function $1ae73f131b9490f2$export$2dd1fe9d4775e7aa(rating) {
    const factor = 10 ** $1ae73f131b9490f2$export$91f0dd76b7830064;
    return Math.round(rating * factor) / factor;
}
const $1ae73f131b9490f2$var$NO_RATING = "\u2014";
function $1ae73f131b9490f2$export$d712cf10a33f1a42(rating, { placeholder: placeholder = $1ae73f131b9490f2$var$NO_RATING, signed: signed = false } = {}) {
    if (rating === null || rating === undefined) return placeholder;
    let value;
    if (typeof rating === "string") {
        const trimmed = rating.trim();
        if (trimmed === "") return placeholder;
        value = Number(trimmed);
        if (!Number.isFinite(value)) return trimmed;
    } else {
        if (!Number.isFinite(rating)) return placeholder;
        value = rating;
    }
    const text = value.toFixed($1ae73f131b9490f2$export$91f0dd76b7830064);
    return signed && value > 0 ? `+${text}` : text;
}
function $1ae73f131b9490f2$var$roundToDisplayed(rating) {
    return $1ae73f131b9490f2$export$2dd1fe9d4775e7aa(rating);
}
function $1ae73f131b9490f2$var$clamp(rating) {
    return Math.min($1ae73f131b9490f2$var$MAX_RATING, Math.max($1ae73f131b9490f2$var$MIN_RATING, rating));
}
function $1ae73f131b9490f2$var$assertFinite(rating) {
    if (!Number.isFinite(rating)) throw new Error(`Cannot derive a coarse rating label from a non-finite value: ${String(rating)}`);
}
function $1ae73f131b9490f2$export$a8df535e84b3c23(rating) {
    $1ae73f131b9490f2$var$assertFinite(rating);
    const value = $1ae73f131b9490f2$var$clamp($1ae73f131b9490f2$var$roundToDisplayed(rating));
    const lower = Math.floor(value / $1ae73f131b9490f2$var$BAND_WIDTH) * $1ae73f131b9490f2$var$BAND_WIDTH;
    if (lower >= $1ae73f131b9490f2$var$MAX_RATING - $1ae73f131b9490f2$var$BAND_WIDTH) return `${($1ae73f131b9490f2$var$MAX_RATING - $1ae73f131b9490f2$var$BAND_WIDTH).toFixed(1)}+`;
    return `${lower.toFixed(1)}-${(lower + $1ae73f131b9490f2$var$BAND_WIDTH).toFixed(1)}`;
}
function $1ae73f131b9490f2$export$d8888e6585965464(rating) {
    $1ae73f131b9490f2$var$assertFinite(rating);
    const value = $1ae73f131b9490f2$var$clamp($1ae73f131b9490f2$var$roundToDisplayed(rating));
    if (value >= 5.0) return "Competitive";
    if (value >= 4.0) return "Advanced";
    if (value >= 3.0) return "Intermediate";
    return "Beginner";
}
function $1ae73f131b9490f2$export$babd5e775ab0c429(rating) {
    return $1ae73f131b9490f2$export$b2d94958b10688d7 === "band" ? $1ae73f131b9490f2$export$a8df535e84b3c23(rating) : $1ae73f131b9490f2$export$d8888e6585965464(rating);
}
function $1ae73f131b9490f2$export$9901a12466628e42(value) {
    const trimmed = value?.trim() ?? "";
    return trimmed !== "" && Number.isFinite(Number(trimmed));
}
function $1ae73f131b9490f2$export$94ee09868a16dc3b(reliability) {
    if (reliability === null || reliability === undefined) return null;
    if (!Number.isFinite(reliability)) return null;
    return Math.min(100, Math.max(0, Math.round(reliability)));
}
function $1ae73f131b9490f2$export$861d09b227bf85f1(reliability) {
    const pct = $1ae73f131b9490f2$export$94ee09868a16dc3b(reliability);
    return pct !== null ? `${pct}%` : null;
}

});


parcelRegister("b7oAt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81836ba89f7a94e6$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $81836ba89f7a94e6$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'ChevronLeft');

});

parcelRegister("9SkSI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73095ad41d99d4ff$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $krx4P = parcelRequire("krx4P");

var $4B5Or = parcelRequire("4B5Or");

var $4Athc = parcelRequire("4Athc");

var $92g7s = parcelRequire("92g7s");

var $ih19M = parcelRequire("ih19M");
'use client';
const $73095ad41d99d4ff$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $krx4P.default)(color)}`,
            `position${(0, $krx4P.default)(position)}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $92g7s.getAppBarUtilityClass), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $73095ad41d99d4ff$var$joinVars = (var1, var2)=>var1 ? `${var1?.replace(')', '')}, ${var2})` : var2;
const $73095ad41d99d4ff$var$AppBarRoot = (0, $l0oRz.default)((0, $4Athc.default), {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $krx4P.default)(ownerState.position)}`],
            styles[`color${(0, $krx4P.default)(ownerState.color)}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0,
        variants: [
            {
                props: {
                    position: 'fixed'
                },
                style: {
                    position: 'fixed',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0,
                    '@media print': {
                        // Prevent the app bar to be visible on each printed page.
                        position: 'absolute'
                    }
                }
            },
            {
                props: {
                    position: 'absolute'
                },
                style: {
                    position: 'absolute',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'sticky'
                },
                style: {
                    position: 'sticky',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'static'
                },
                style: {
                    position: 'static'
                }
            },
            {
                props: {
                    position: 'relative'
                },
                style: {
                    position: 'relative'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    '--AppBar-color': 'inherit'
                }
            },
            {
                props: {
                    color: 'default'
                },
                style: {
                    '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[100],
                    '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[100]),
                    ...theme.applyStyles('dark', {
                        '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[900],
                        '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[900])
                    })
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--AppBar-background': (theme.vars ?? theme).palette[color].main,
                        '--AppBar-color': (theme.vars ?? theme).palette[color].contrastText
                    }
                })),
            {
                props: (props)=>props.enableColorOnDark === true && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)'
                }
            },
            {
                props: (props)=>props.enableColorOnDark === false && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundColor: theme.vars ? $73095ad41d99d4ff$var$joinVars(theme.vars.palette.AppBar.darkBg, 'var(--AppBar-background)') : null,
                        color: theme.vars ? $73095ad41d99d4ff$var$joinVars(theme.vars.palette.AppBar.darkColor, 'var(--AppBar-color)') : null
                    })
                }
            },
            {
                props: {
                    color: 'transparent'
                },
                style: {
                    '--AppBar-background': 'transparent',
                    '--AppBar-color': 'inherit',
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundImage: 'none'
                    })
                }
            }
        ]
    })));
const $73095ad41d99d4ff$var$AppBar = /*#__PURE__*/ $bh6RR.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    };
    const classes = $73095ad41d99d4ff$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($73095ad41d99d4ff$var$AppBarRoot, {
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $aPsoC.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref,
        ...other
    });
});
var $73095ad41d99d4ff$export$2e2bcd8739ae039 = $73095ad41d99d4ff$var$AppBar;

});
parcelRegister("92g7s", function(module, exports) {

$parcel$export(module.exports, "getAppBarUtilityClass", function () { return $6940cdee197713a6$export$47a2da616e55e8e9; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $6940cdee197713a6$export$47a2da616e55e8e9(slot) {
    return (0, $dmzXD.default)('MuiAppBar', slot);
}
const $6940cdee197713a6$var$appBarClasses = (0, $fYlYP.default)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $6940cdee197713a6$export$2e2bcd8739ae039 = $6940cdee197713a6$var$appBarClasses;

});


parcelRegister("hL9jN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cede0de16229f07f$export$2e2bcd8739ae039; });


var $h4nVC = parcelRequire("h4nVC");

var $krx4P = parcelRequire("krx4P");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");
'use client';
const $cede0de16229f07f$var$Container = (0, $h4nVC.default)({
    createStyledComponent: (0, $l0oRz.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $krx4P.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $OEXBZ.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var $cede0de16229f07f$export$2e2bcd8739ae039 = $cede0de16229f07f$var$Container;

});
parcelRegister("h4nVC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6d55f111b0a5ada$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $dmzXD = parcelRequire("dmzXD");

var $96ZcP = parcelRequire("96ZcP");

var $5pCmM = parcelRequire("5pCmM");

var $2DXvq = parcelRequire("2DXvq");

var $kleHe = parcelRequire("kleHe");

var $1zcRx = parcelRequire("1zcRx");

var $ih19M = parcelRequire("ih19M");
'use client';
const $c6d55f111b0a5ada$var$defaultTheme = (0, $1zcRx.default)();
const $c6d55f111b0a5ada$var$defaultCreateStyledComponent = (0, $kleHe.default)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $5pCmM.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $c6d55f111b0a5ada$var$useThemePropsDefault = (inProps)=>(0, $2DXvq.default)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $c6d55f111b0a5ada$var$defaultTheme
    });
const $c6d55f111b0a5ada$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $dmzXD.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $5pCmM.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $96ZcP.default)(slots, getContainerUtilityClass, classes);
};
function $c6d55f111b0a5ada$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $c6d55f111b0a5ada$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $c6d55f111b0a5ada$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            ...!ownerState.disableGutters && {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3)
                }
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>({
            // @ts-ignore module augmentation fails if custom breakpoints are used
            ...ownerState.maxWidth === 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('xs')]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: Math.max(theme.breakpoints.values.xs, 444)
                }
            },
            ...ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
            ownerState.maxWidth !== 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up(ownerState.maxWidth)]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
                }
            }
        }));
    const Container = /*#__PURE__*/ $bh6RR.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg', classes: classesProp, ...other } = props;
        const ownerState = {
            ...props,
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        };
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $c6d55f111b0a5ada$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $ih19M.jsx)(ContainerRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $aPsoC.default)(classes.root, className),
            ref: ref,
            ...other
        }));
    });
    return Container;
}

});


parcelRegister("2J49z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fc3017df5439530$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $2hIot = parcelRequire("2hIot");

var $ih19M = parcelRequire("ih19M");
'use client';
const $1fc3017df5439530$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $2hIot.getToolbarUtilityClass), classes);
};
const $1fc3017df5439530$var$ToolbarRoot = (0, $l0oRz.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2),
                    [theme.breakpoints.up('sm')]: {
                        paddingLeft: theme.spacing(3),
                        paddingRight: theme.spacing(3)
                    }
                }
            },
            {
                props: {
                    variant: 'dense'
                },
                style: {
                    minHeight: 48
                }
            },
            {
                props: {
                    variant: 'regular'
                },
                style: theme.mixins.toolbar
            }
        ]
    })));
const $1fc3017df5439530$var$Toolbar = /*#__PURE__*/ $bh6RR.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableGutters: disableGutters,
        variant: variant
    };
    const classes = $1fc3017df5439530$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($1fc3017df5439530$var$ToolbarRoot, {
        as: component,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $1fc3017df5439530$export$2e2bcd8739ae039 = $1fc3017df5439530$var$Toolbar;

});
parcelRegister("2hIot", function(module, exports) {

$parcel$export(module.exports, "getToolbarUtilityClass", function () { return $1a9f9afd4d3b34a3$export$b12cb262231eef32; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $1a9f9afd4d3b34a3$export$b12cb262231eef32(slot) {
    return (0, $dmzXD.default)('MuiToolbar', slot);
}
const $1a9f9afd4d3b34a3$var$toolbarClasses = (0, $fYlYP.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $1a9f9afd4d3b34a3$export$2e2bcd8739ae039 = $1a9f9afd4d3b34a3$var$toolbarClasses;

});


parcelRegister("5Z0If", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45b333c73988c62b$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $96ZcP = parcelRequire("96ZcP");

var $25zti = parcelRequire("25zti");

var $krx4P = parcelRequire("krx4P");

var $l0oRz = parcelRequire("l0oRz");
var $aOb5j = parcelRequire("aOb5j");

var $gfPc7 = parcelRequire("gfPc7");

var $4B5Or = parcelRequire("4B5Or");

var $OEXBZ = parcelRequire("OEXBZ");

var $cbFbS = parcelRequire("cbFbS");

var $gyHnM = parcelRequire("gyHnM");

var $8bB4D = parcelRequire("8bB4D");

var $ih19M = parcelRequire("ih19M");
'use client';
const $45b333c73988c62b$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $45b333c73988c62b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $krx4P.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $gyHnM.getLinkUtilityClass), classes);
};
const $45b333c73988c62b$var$LinkRoot = (0, $l0oRz.default)((0, $cbFbS.default), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $krx4P.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>{
    return {
        variants: [
            {
                props: {
                    underline: 'none'
                },
                style: {
                    textDecoration: 'none'
                }
            },
            {
                props: {
                    underline: 'hover'
                },
                style: {
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            {
                props: {
                    underline: 'always'
                },
                style: {
                    textDecoration: 'underline',
                    '&:hover': {
                        textDecorationColor: 'inherit'
                    }
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color !== 'inherit',
                style: {
                    textDecorationColor: 'var(--Link-underlineColor)'
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color === 'inherit',
                style: theme.colorSpace ? {
                    textDecorationColor: theme.alpha('currentColor', 0.4)
                } : null
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        underline: 'always',
                        color: color
                    },
                    style: {
                        '--Link-underlineColor': theme.alpha((theme.vars || theme).palette[color].main, 0.4)
                    }
                })),
            {
                props: {
                    underline: 'always',
                    color: 'textPrimary'
                },
                style: {
                    '--Link-underlineColor': theme.alpha((theme.vars || theme).palette.text.primary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textSecondary'
                },
                style: {
                    '--Link-underlineColor': theme.alpha((theme.vars || theme).palette.text.secondary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textDisabled'
                },
                style: {
                    '--Link-underlineColor': (theme.vars || theme).palette.text.disabled
                }
            },
            {
                props: {
                    component: 'button'
                },
                style: {
                    position: 'relative',
                    WebkitTapHighlightColor: 'transparent',
                    backgroundColor: 'transparent',
                    // Reset default value
                    // We disable the focus ring for mouse, touch and keyboard users.
                    outline: 0,
                    border: 0,
                    margin: 0,
                    // Remove the margin in Safari
                    borderRadius: 0,
                    padding: 0,
                    // Remove the padding in Firefox
                    cursor: 'pointer',
                    userSelect: 'none',
                    verticalAlign: 'middle',
                    MozAppearance: 'none',
                    // Reset
                    WebkitAppearance: 'none',
                    // Reset
                    '&::-moz-focus-inner': {
                        borderStyle: 'none' // Remove Firefox dotted outline.
                    },
                    [`&.${(0, $gyHnM.default).focusVisible}`]: {
                        outline: 'auto'
                    }
                }
            }
        ]
    };
}));
const $45b333c73988c62b$var$Link = /*#__PURE__*/ $bh6RR.forwardRef(function Link(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const theme = (0, $aOb5j.default)();
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx, ...other } = props;
    const [focusVisible, setFocusVisible] = $bh6RR.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $25zti.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        if ((0, $25zti.default)(event.target)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = {
        ...props,
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    };
    const classes = $45b333c73988c62b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($45b333c73988c62b$var$LinkRoot, {
        color: color,
        className: (0, $aPsoC.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: ref,
        ownerState: ownerState,
        variant: variant,
        ...other,
        sx: [
            ...$45b333c73988c62b$var$v6Colors[color] === undefined ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        style: {
            ...other.style,
            ...underline === 'always' && color !== 'inherit' && !$45b333c73988c62b$var$v6Colors[color] && {
                '--Link-underlineColor': (0, $8bB4D.default)({
                    theme: theme,
                    ownerState: ownerState
                })
            }
        }
    });
});
var $45b333c73988c62b$export$2e2bcd8739ae039 = $45b333c73988c62b$var$Link;

});
parcelRegister("gyHnM", function(module, exports) {

$parcel$export(module.exports, "getLinkUtilityClass", function () { return $c0e1792c0f3a6651$export$d6efab9620b78fec; });
$parcel$export(module.exports, "default", function () { return $c0e1792c0f3a6651$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $c0e1792c0f3a6651$export$d6efab9620b78fec(slot) {
    return (0, $dmzXD.default)('MuiLink', slot);
}
const $c0e1792c0f3a6651$var$linkClasses = (0, $fYlYP.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $c0e1792c0f3a6651$export$2e2bcd8739ae039 = $c0e1792c0f3a6651$var$linkClasses;

});

parcelRegister("8bB4D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f5c1be28c14afae$export$2e2bcd8739ae039; });

var $gzdlJ = parcelRequire("gzdlJ");

var $7ITGE = parcelRequire("7ITGE");
const $5f5c1be28c14afae$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = ownerState.color;
    if ('colorSpace' in theme && theme.colorSpace) {
        const color = (0, $gzdlJ.getPath)(theme, `palette.${transformedColor}.main`) || (0, $gzdlJ.getPath)(theme, `palette.${transformedColor}`) || ownerState.color;
        return theme.alpha(color, 0.4);
    }
    // check the `main` color first for a custom palette, then fallback to the color itself
    const color = (0, $gzdlJ.getPath)(theme, `palette.${transformedColor}.main`, false) || (0, $gzdlJ.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $gzdlJ.getPath)(theme, `palette.${transformedColor}.mainChannel`) || (0, $gzdlJ.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $7ITGE.alpha)(color, 0.4);
};
var $5f5c1be28c14afae$export$2e2bcd8739ae039 = $5f5c1be28c14afae$var$getTextDecoration;

});


parcelRegister("3iMZv", function(module, exports) {

$parcel$export(module.exports, "VolleyButton", function () { return $4e4118f1e12f16a1$export$effcb98a3fecda68; });
$parcel$export(module.exports, "InfoButton", function () { return $4e4118f1e12f16a1$export$10d4b9c1046c21df; });
$parcel$export(module.exports, "GoogleSignInButton", function () { return $4e4118f1e12f16a1$export$33f3f0a205996c11; });
$parcel$export(module.exports, "AppleSignInButton", function () { return $4e4118f1e12f16a1$export$535118cbf0a41de8; });
$parcel$export(module.exports, "AppleBlackSignInButton", function () { return $4e4118f1e12f16a1$export$ebf011bb5902d6a3; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $4KLtn = parcelRequire("4KLtn");

var $l0oRz = parcelRequire("l0oRz");

var $e8yyN = parcelRequire("e8yyN");
function $4e4118f1e12f16a1$var$buttonRoot(variant) {
    let colors;
    switch(variant){
        case "apple":
            colors = {
                bg: (0, $e8yyN.default).palette.common.white,
                text: (0, $e8yyN.default).palette.grey[900],
                light: (0, $e8yyN.default).palette.grey[100],
                dark: (0, $e8yyN.default).palette.grey[300]
            };
            break;
        case "apple-black":
            colors = {
                bg: (0, $e8yyN.default).palette.common.black,
                text: (0, $e8yyN.default).palette.common.white,
                light: (0, $e8yyN.default).palette.grey[800],
                dark: (0, $e8yyN.default).palette.common.black
            };
            break;
        case "google":
            colors = {
                bg: "#1578e5",
                text: (0, $e8yyN.default).palette.common.white,
                light: "#4c99ee",
                dark: "#0f59ab"
            };
            break;
        case "info":
            colors = {
                bg: "#096ee5",
                text: (0, $e8yyN.default).palette.common.white,
                dark: "#d5dBed",
                light: "#0a4995"
            };
            break;
        case "volley":
        default:
            colors = {
                bg: (0, $e8yyN.default).palette.secondary.main,
                text: (0, $e8yyN.default).palette.primary.main,
                light: (0, $e8yyN.default).palette.secondary.light,
                dark: (0, $e8yyN.default).palette.secondary.dark
            };
            break;
    }
    colors = {
        ...colors,
        disabled: "#d5dbed",
        disabledText: "#8792ae"
    };
    return (0, $l0oRz.default)("button")`
        background-color: ${colors.bg};
        padding: 12px;
        border-radius: 2pt;
        color: ${colors.text};
        height: 50px;
        font-weight: 600;
        font-size: 12pt;
        font-family: Gotham, sans-serif;
        text-transform: uppercase;
        cursor: pointer;
        box-shadow:
            0 2px 3px 2px rgba(61, 71, 82, 0.1),
            0 0 0 0 rgba(0, 127, 255, 0);
        border: none;
        width: 100%;

        &:hover {
            background-color: ${colors.light};
        }

        &:active {
            background-color: ${colors.dark};
        }

        &.${(0, $4KLtn.default).focusVisible} {
            box-shadow:
                0 4px 20px 0 rgba(61, 71, 82, 0.1),
                0 0 0 5px rgba(0, 127, 255, 0.5);
            outline: none;
        }

        &.${(0, $4KLtn.default).disabled} {
            color: ${colors.disabledText};
            background: ${colors.disabled};
            cursor: not-allowed;
            box-shadow: 0 0 0 0 rgba(0, 127, 255, 0);
        }
    `;
}
function $4e4118f1e12f16a1$export$effcb98a3fecda68(props) {
    const Component = $4e4118f1e12f16a1$var$buttonRoot("volley");
    return /*#__PURE__*/ (0, $ih19M.jsx)(Component, {
        ...props
    });
}
function $4e4118f1e12f16a1$export$10d4b9c1046c21df(props) {
    const Component = $4e4118f1e12f16a1$var$buttonRoot("info");
    return /*#__PURE__*/ (0, $ih19M.jsx)(Component, {
        ...props
    });
}
function $4e4118f1e12f16a1$export$33f3f0a205996c11(props) {
    const Component = $4e4118f1e12f16a1$var$buttonRoot("google");
    return /*#__PURE__*/ (0, $ih19M.jsx)(Component, {
        ...props
    });
}
function $4e4118f1e12f16a1$export$535118cbf0a41de8(props) {
    const Component = $4e4118f1e12f16a1$var$buttonRoot("apple");
    return /*#__PURE__*/ (0, $ih19M.jsx)(Component, {
        ...props
    });
}
function $4e4118f1e12f16a1$export$ebf011bb5902d6a3(props) {
    const Component = $4e4118f1e12f16a1$var$buttonRoot("apple-black");
    return /*#__PURE__*/ (0, $ih19M.jsx)(Component, {
        ...props
    });
}
function $4e4118f1e12f16a1$export$5dd6d58aea1c0ce8({ children: children, sx: sx = {} }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
        component: "div",
        sx: {
            pt: 2,
            px: 2,
            mt: 8,
            position: "relative",
            ...sx
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
            component: "div",
            sx: {
                width: "93%",
                position: "absolute",
                bottom: 0,
                transform: "translateY(50%)",
                textAlign: "center"
            },
            children: children
        })
    });
}

});

parcelRegister("7S0DI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82e913df4fd9bdce$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $6MOqF = parcelRequire("6MOqF");

var $2zpN0 = parcelRequire("2zpN0");

var $1d1FK = parcelRequire("1d1FK");

var $4rInl = parcelRequire("4rInl");

var $gtX9p = parcelRequire("gtX9p");

var $h8IpO = parcelRequire("h8IpO");

var $hrqHU = parcelRequire("hrqHU");

var $cbFbS = parcelRequire("cbFbS");

var $aOb5j = parcelRequire("aOb5j");

var $jO4RJ = parcelRequire("jO4RJ");
function $82e913df4fd9bdce$export$2e2bcd8739ae039({ onPasswordChange: onPasswordChange }) {
    const theme = (0, $aOb5j.default)();
    const [password, setPassword] = $bh6RR.useState("");
    const [unmaskPassword, setUnmaskPassword] = $bh6RR.useState(false);
    const strength = $bh6RR.useMemo(()=>{
        if (!password.length) return {
            percent: 0,
            cssColor: "",
            color: "inherit",
            value: ""
        };
        const { value: value } = (0, $jO4RJ.default)(password);
        switch(value){
            case "Strong":
                return {
                    percent: 100,
                    cssColor: theme.palette.success.main,
                    color: "success",
                    value: value
                };
            case "Medium":
                return {
                    percent: 66,
                    cssColor: theme.palette.info.main,
                    color: "info",
                    value: value
                };
            case "Weak":
                return {
                    percent: 33,
                    cssColor: theme.palette.warning.main,
                    color: "warning",
                    value: value
                };
            case "Too weak":
            default:
                return {
                    percent: 0,
                    cssColor: theme.palette.error.main,
                    color: "error",
                    value: value
                };
        }
    }, [
        password,
        theme
    ]);
    const onChange = (e)=>{
        const { value: value } = e.currentTarget;
        setPassword(value);
        // if password is too weak return empty string to mark invalid password
        const passStrength = (0, $jO4RJ.default)(value);
        if (passStrength.value === "Too weak") onPasswordChange("");
        else onPasswordChange(value);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        component: "div",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $hrqHU.default), {
                type: unmaskPassword ? "text" : "password",
                id: "password",
                name: "password",
                autoComplete: "new-password",
                label: "Password",
                value: password,
                onChange: onChange,
                fullWidth: true,
                slotProps: {
                    input: {
                        endAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gtX9p.default), {
                            position: "end",
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                                onClick: ()=>setUnmaskPassword(!unmaskPassword),
                                children: unmaskPassword ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $2zpN0.default), {}) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $6MOqF.default), {})
                            })
                        })
                    }
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                component: "div",
                sx: {
                    w: "100%",
                    my: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $h8IpO.default), {
                        variant: "determinate",
                        value: strength.percent,
                        color: strength.color
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "body2",
                        sx: {
                            color: strength.cssColor
                        },
                        children: strength.value
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                variant: "caption",
                fontSize: "8pt",
                children: "Use eight or more characters with a mix of letters, numbers, & symbols"
            })
        ]
    });
}

});
parcelRegister("6MOqF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f0e57ee27f32827$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $4f0e57ee27f32827$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), 'Visibility');

});

parcelRegister("2zpN0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1df2dae69998a0e5$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $1df2dae69998a0e5$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), 'VisibilityOff');

});

parcelRegister("gtX9p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bffd3ce51cc7960e$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $krx4P = parcelRequire("krx4P");

var $cbFbS = parcelRequire("cbFbS");

var $4Iacp = parcelRequire("4Iacp");

var $1BiIF = parcelRequire("1BiIF");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $fs82o = parcelRequire("fs82o");

var $ih19M = parcelRequire("ih19M");
'use client';
var $bffd3ce51cc7960e$var$_span;
const $bffd3ce51cc7960e$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $krx4P.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $bffd3ce51cc7960e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $krx4P.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $krx4P.default)(size)}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $fs82o.getInputAdornmentUtilityClass), classes);
};
const $bffd3ce51cc7960e$var$InputAdornmentRoot = (0, $l0oRz.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $bffd3ce51cc7960e$var$overridesResolver
})((0, $gfPc7.default)(({ theme: theme })=>({
        display: 'flex',
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active,
        variants: [
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    [`&.${(0, $fs82o.default).positionStart}&:not(.${(0, $fs82o.default).hiddenLabel})`]: {
                        marginTop: 16
                    }
                }
            },
            {
                props: {
                    position: 'start'
                },
                style: {
                    marginRight: 8
                }
            },
            {
                props: {
                    position: 'end'
                },
                style: {
                    marginLeft: 8
                }
            },
            {
                props: {
                    disablePointerEvents: true
                },
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const $bffd3ce51cc7960e$var$InputAdornment = /*#__PURE__*/ $bh6RR.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp, ...other } = props;
    const muiFormControl = (0, $1BiIF.default)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = {
        ...props,
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    };
    const classes = $bffd3ce51cc7960e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $4Iacp.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($bffd3ce51cc7960e$var$InputAdornmentRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $aPsoC.default)(classes.root, className),
            ref: ref,
            ...other,
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                color: "textSecondary",
                children: children
            }) : /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $bffd3ce51cc7960e$var$_span || ($bffd3ce51cc7960e$var$_span = /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "notranslate",
                        "aria-hidden": true,
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        })
    });
});
var $bffd3ce51cc7960e$export$2e2bcd8739ae039 = $bffd3ce51cc7960e$var$InputAdornment;

});
parcelRegister("fs82o", function(module, exports) {

$parcel$export(module.exports, "getInputAdornmentUtilityClass", function () { return $b3ffb49fbb1e2266$export$4b135a4b3a6c4550; });
$parcel$export(module.exports, "default", function () { return $b3ffb49fbb1e2266$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $b3ffb49fbb1e2266$export$4b135a4b3a6c4550(slot) {
    return (0, $dmzXD.default)('MuiInputAdornment', slot);
}
const $b3ffb49fbb1e2266$var$inputAdornmentClasses = (0, $fYlYP.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $b3ffb49fbb1e2266$export$2e2bcd8739ae039 = $b3ffb49fbb1e2266$var$inputAdornmentClasses;

});


parcelRegister("h8IpO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7a5a2fa18b328ec$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $am2yJ = parcelRequire("am2yJ");

var $fPZvG = parcelRequire("fPZvG");
var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $4B5Or = parcelRequire("4B5Or");

var $OEXBZ = parcelRequire("OEXBZ");

var $krx4P = parcelRequire("krx4P");

var $dy9Qs = parcelRequire("dy9Qs");

var $ih19M = parcelRequire("ih19M");
'use client';
const $c7a5a2fa18b328ec$var$TRANSITION_DURATION = 4; // seconds
const $c7a5a2fa18b328ec$var$indeterminate1Keyframe = (0, $fPZvG.keyframes)`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $c7a5a2fa18b328ec$var$indeterminate1Animation = typeof $c7a5a2fa18b328ec$var$indeterminate1Keyframe !== 'string' ? (0, $fPZvG.css)`
        animation: ${$c7a5a2fa18b328ec$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null;
const $c7a5a2fa18b328ec$var$indeterminate2Keyframe = (0, $fPZvG.keyframes)`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`;
const $c7a5a2fa18b328ec$var$indeterminate2Animation = typeof $c7a5a2fa18b328ec$var$indeterminate2Keyframe !== 'string' ? (0, $fPZvG.css)`
        animation: ${$c7a5a2fa18b328ec$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null;
const $c7a5a2fa18b328ec$var$bufferKeyframe = (0, $fPZvG.keyframes)`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`;
const $c7a5a2fa18b328ec$var$bufferAnimation = typeof $c7a5a2fa18b328ec$var$bufferKeyframe !== 'string' ? (0, $fPZvG.css)`
        animation: ${$c7a5a2fa18b328ec$var$bufferKeyframe} 3s infinite linear;
      ` : null;
const $c7a5a2fa18b328ec$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $krx4P.default)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, $krx4P.default)(color)}`
        ],
        bar1: [
            'bar',
            'bar1',
            `barColor${(0, $krx4P.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            'bar2',
            variant !== 'buffer' && `barColor${(0, $krx4P.default)(color)}`,
            variant === 'buffer' && `color${(0, $krx4P.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $dy9Qs.getLinearProgressUtilityClass), classes);
};
const $c7a5a2fa18b328ec$var$getColorShade = (theme, color)=>{
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? theme.lighten(theme.palette[color].main, 0.62) : theme.darken(theme.palette[color].main, 0.5);
};
const $c7a5a2fa18b328ec$var$LinearProgressRoot = (0, $l0oRz.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $krx4P.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        // Fix Safari's bug during composition of different paint.
        zIndex: 0,
        '@media print': {
            colorAdjust: 'exact'
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: $c7a5a2fa18b328ec$var$getColorShade(theme, color)
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.color === 'inherit' && ownerState.variant !== 'buffer',
                style: {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'currentColor',
                        opacity: 0.3
                    }
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    backgroundColor: 'transparent'
                }
            },
            {
                props: {
                    variant: 'query'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
const $c7a5a2fa18b328ec$var$LinearProgressDashed = (0, $l0oRz.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $krx4P.default)(ownerState.color)}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%',
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3,
                    backgroundImage: `radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>{
                const backgroundColor = $c7a5a2fa18b328ec$var$getColorShade(theme, color);
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`
                    }
                };
            })
        ]
    })), $c7a5a2fa18b328ec$var$bufferAnimation || {
    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
    animation: `${$c7a5a2fa18b328ec$var$bufferKeyframe} 3s infinite linear`
});
const $c7a5a2fa18b328ec$var$LinearProgressBar1 = (0, $l0oRz.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar1,
            styles[`barColor${(0, $krx4P.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: `transform .${$c7a5a2fa18b328ec$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    zIndex: 1,
                    transition: `transform .${$c7a5a2fa18b328ec$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $c7a5a2fa18b328ec$var$indeterminate1Animation || {
                    animation: `${$c7a5a2fa18b328ec$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
                }
            }
        ]
    })));
const $c7a5a2fa18b328ec$var$LinearProgressBar2 = (0, $l0oRz.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar2,
            styles[`barColor${(0, $krx4P.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--LinearProgressBar2-barColor': (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color !== 'inherit',
                style: {
                    backgroundColor: 'var(--LinearProgressBar2-barColor, currentColor)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color === 'inherit',
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color,
                        variant: 'buffer'
                    },
                    style: {
                        backgroundColor: $c7a5a2fa18b328ec$var$getColorShade(theme, color),
                        transition: `transform .${$c7a5a2fa18b328ec$var$TRANSITION_DURATION}s linear`
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $c7a5a2fa18b328ec$var$indeterminate2Animation || {
                    animation: `${$c7a5a2fa18b328ec$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $c7a5a2fa18b328ec$var$LinearProgress = /*#__PURE__*/ $bh6RR.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        variant: variant
    };
    const classes = $c7a5a2fa18b328ec$var$useUtilityClasses(ownerState);
    const isRtl = (0, $am2yJ.useRtl)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $ih19M.jsxs)($c7a5a2fa18b328ec$var$LinearProgressRoot, {
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar",
        ...rootProps,
        ref: ref,
        ...other,
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $ih19M.jsx)($c7a5a2fa18b328ec$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $ih19M.jsx)($c7a5a2fa18b328ec$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $ih19M.jsx)($c7a5a2fa18b328ec$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    });
});
var $c7a5a2fa18b328ec$export$2e2bcd8739ae039 = $c7a5a2fa18b328ec$var$LinearProgress;

});
parcelRegister("dy9Qs", function(module, exports) {

$parcel$export(module.exports, "getLinearProgressUtilityClass", function () { return $9dd6165aafac7190$export$bc8a6ea1eb17d7c6; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $9dd6165aafac7190$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $dmzXD.default)('MuiLinearProgress', slot);
}
const $9dd6165aafac7190$var$linearProgressClasses = (0, $fYlYP.default)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'bar1',
    'bar2',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var $9dd6165aafac7190$export$2e2bcd8739ae039 = $9dd6165aafac7190$var$linearProgressClasses;

});


parcelRegister("jO4RJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dca6e70abc4397d$export$2e2bcd8739ae039; });
const $5dca6e70abc4397d$var$defaultOptions = [
    {
        id: 0,
        value: "Too weak",
        minDiversity: 0,
        minLength: 0
    },
    {
        id: 1,
        value: "Weak",
        minDiversity: 3,
        minLength: 8
    },
    {
        id: 2,
        value: "Medium",
        minDiversity: 3,
        minLength: 10
    },
    {
        id: 3,
        value: "Strong",
        minDiversity: 4,
        minLength: 12
    }
];
function $5dca6e70abc4397d$export$2e2bcd8739ae039(passwordInput, optionsInput = $5dca6e70abc4397d$var$defaultOptions) {
    const options = optionsInput;
    const password = passwordInput || "";
    options[0].minDiversity = 0;
    options[0].minLength = 0;
    const rules = [
        {
            regex: /[a-zA-Z]/,
            message: "lowercase"
        },
        {
            regex: /[0-9]/,
            message: "number"
        },
        {
            regex: /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/,
            message: "symbol"
        },
        {
            regex: /[A-Z]/,
            message: "uppercase"
        }
    ];
    const contains = rules.filter((rule)=>rule.regex.test(password)).map((rule)=>rule.message);
    const { length: length } = password;
    const fulfilledOptions = options.filter((option)=>contains.length >= option.minDiversity).filter((option)=>length >= option.minLength).sort((o1, o2)=>o2.id - o1.id).map((option)=>({
            id: option.id,
            value: option.value
        }));
    return {
        contains: contains,
        length: length,
        ...fulfilledOptions[0]
    };
}

});


parcelRegister("4UKpm", function(module, exports) {
module.exports = $parcel$resolve("022zR");

});

parcelRegister("6zj3p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $444b723bf9f89c13$export$2e2bcd8739ae039; });

var $4JHq1 = parcelRequire("4JHq1");
const $444b723bf9f89c13$var$bucket = ()=>{
    const env = (0, $4JHq1.default)(window.location);
    if (env === "production") return "volley-production-media";
    if (env === "rc") return "volley-rc-media";
    return "volley-staging-media";
};
var $444b723bf9f89c13$export$2e2bcd8739ae039 = (fileName)=>`https://storage.googleapis.com/${$444b723bf9f89c13$var$bucket()}/${fileName}`;

});

parcelRegister("gIiKg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2af4bca02238216$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $96ZcP = parcelRequire("96ZcP");

var $am2yJ = parcelRequire("am2yJ");

var $4s2UK = parcelRequire("4s2UK");

var $kefK8 = parcelRequire("kefK8");

var $4Athc = parcelRequire("4Athc");

var $krx4P = parcelRequire("krx4P");

var $b6vKX = parcelRequire("b6vKX");

var $l0oRz = parcelRequire("l0oRz");
var $aOb5j = parcelRequire("aOb5j");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $8Sqsp = parcelRequire("8Sqsp");

var $dFvJW = parcelRequire("dFvJW");

var $bfkfm = parcelRequire("bfkfm");

var $ih19M = parcelRequire("ih19M");
'use client';
const $c2af4bca02238216$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        styles.modal
    ];
};
const $c2af4bca02238216$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            `anchor${(0, $krx4P.default)(anchor)}`
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            `paperAnchor${(0, $krx4P.default)(anchor)}`,
            variant !== 'temporary' && `paperAnchorDocked${(0, $krx4P.default)(anchor)}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $8Sqsp.getDrawerUtilityClass), classes);
};
const $c2af4bca02238216$var$DrawerRoot = (0, $l0oRz.default)((0, $4s2UK.default), {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: $c2af4bca02238216$var$overridesResolver
})((0, $gfPc7.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    })));
const $c2af4bca02238216$var$DrawerDockedRoot = (0, $l0oRz.default)('div', {
    shouldForwardProp: (0, $b6vKX.default),
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: $c2af4bca02238216$var$overridesResolver
})({
    flex: '0 0 auto'
});
const $c2af4bca02238216$var$DrawerPaper = (0, $l0oRz.default)((0, $4Athc.default), {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $krx4P.default)(ownerState.anchor)}`],
            ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, $krx4P.default)(ownerState.anchor)}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0,
        variants: [
            {
                props: {
                    anchor: 'left'
                },
                style: {
                    left: 0
                }
            },
            {
                props: {
                    anchor: 'top'
                },
                style: {
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: {
                    anchor: 'right'
                },
                style: {
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'bottom'
                },
                style: {
                    top: 'auto',
                    left: 0,
                    bottom: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'left' && ownerState.variant !== 'temporary',
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'top' && ownerState.variant !== 'temporary',
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'right' && ownerState.variant !== 'temporary',
                style: {
                    borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary',
                style: {
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            }
        ]
    })));
const $c2af4bca02238216$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $c2af4bca02238216$export$2a62b49acb270576(anchor) {
    return [
        'left',
        'right'
    ].includes(anchor);
}
function $c2af4bca02238216$export$830f4f08342d299e({ direction: direction }, anchor) {
    return direction === 'rtl' && $c2af4bca02238216$export$2a62b49acb270576(anchor) ? $c2af4bca02238216$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $c2af4bca02238216$var$Drawer = /*#__PURE__*/ $bh6RR.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiDrawer'
    });
    const theme = (0, $aOb5j.default)();
    const isRtl = (0, $am2yJ.useRtl)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = 'left', BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp, ...ModalProps } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent, transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = 'temporary', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $bh6RR.useRef(false);
    $bh6RR.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $c2af4bca02238216$export$830f4f08342d299e({
        direction: isRtl ? 'rtl' : 'ltr'
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = {
        ...props,
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant,
        ...other
    };
    const classes = $c2af4bca02238216$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            paper: PaperProps,
            transition: SlideProps,
            ...slotProps,
            backdrop: (0, $bfkfm.default)(slotProps.backdrop || {
                ...BackdropProps,
                ...BackdropPropsProp
            }, {
                transitionDuration: transitionDuration
            })
        }
    };
    const [RootSlot, rootSlotProps] = (0, $dFvJW.default)('root', {
        ref: ref,
        elementType: $c2af4bca02238216$var$DrawerRoot,
        className: (0, $aPsoC.default)(classes.root, classes.modal, className),
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            ...ModalProps
        },
        additionalProps: {
            open: open,
            onClose: onClose,
            hideBackdrop: hideBackdrop,
            slots: {
                backdrop: externalForwardedProps.slots.backdrop
            },
            slotProps: {
                backdrop: externalForwardedProps.slotProps.backdrop
            }
        }
    });
    const [PaperSlot, paperSlotProps] = (0, $dFvJW.default)('paper', {
        elementType: $c2af4bca02238216$var$DrawerPaper,
        shouldForwardComponentProp: true,
        className: (0, $aPsoC.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            elevation: variant === 'temporary' ? elevation : 0,
            square: true,
            ...variant === 'temporary' && {
                role: 'dialog',
                'aria-modal': 'true'
            }
        }
    });
    const [DockedSlot, dockedSlotProps] = (0, $dFvJW.default)('docked', {
        elementType: $c2af4bca02238216$var$DrawerDockedRoot,
        ref: ref,
        className: (0, $aPsoC.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: other // pass `other` here because `DockedSlot` is also a root slot for some variants
    });
    const [TransitionSlot, transitionSlotProps] = (0, $dFvJW.default)('transition', {
        elementType: (0, $kefK8.default),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            in: open,
            direction: $c2af4bca02238216$var$oppositeDirection[anchorInvariant],
            timeout: transitionDuration,
            appear: mounted.current
        }
    });
    const drawer = /*#__PURE__*/ (0, $ih19M.jsx)(PaperSlot, {
        ...paperSlotProps,
        children: children
    });
    if (variant === 'permanent') return /*#__PURE__*/ (0, $ih19M.jsx)(DockedSlot, {
        ...dockedSlotProps,
        children: drawer
    });
    const slidingDrawer = /*#__PURE__*/ (0, $ih19M.jsx)(TransitionSlot, {
        ...transitionSlotProps,
        children: drawer
    });
    if (variant === 'persistent') return /*#__PURE__*/ (0, $ih19M.jsx)(DockedSlot, {
        ...dockedSlotProps,
        children: slidingDrawer
    });
    // variant === temporary
    return /*#__PURE__*/ (0, $ih19M.jsx)(RootSlot, {
        ...rootSlotProps,
        children: slidingDrawer
    });
});
var $c2af4bca02238216$export$2e2bcd8739ae039 = $c2af4bca02238216$var$Drawer;

});
parcelRegister("kefK8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eba153b44b4f3dc9$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $7ARPd = parcelRequire("7ARPd");




var $20D76 = parcelRequire("20D76");

var $8I3yK = parcelRequire("8I3yK");

var $dg012 = parcelRequire("dg012");

var $aOb5j = parcelRequire("aOb5j");

var $bi4C9 = parcelRequire("bi4C9");

var $7tCBy = parcelRequire("7tCBy");

var $ih19M = parcelRequire("ih19M");
'use client';
function $eba153b44b4f3dc9$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $7tCBy.default)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $eba153b44b4f3dc9$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $eba153b44b4f3dc9$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $eba153b44b4f3dc9$var$resolveContainer(containerProp);
    const transform = $eba153b44b4f3dc9$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $eba153b44b4f3dc9$var$Slide = /*#__PURE__*/ $bh6RR.forwardRef(function Slide(props, ref) {
    const theme = (0, $aOb5j.default)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $7ARPd.default), ...other } = props;
    const childrenRef = $bh6RR.useRef(null);
    const handleRef = (0, $dg012.default)((0, $20D76.default)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $eba153b44b4f3dc9$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $bi4C9.reflow)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $bi4C9.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', {
            ...transitionProps
        });
        node.style.transition = theme.transitions.create('transform', {
            ...transitionProps
        });
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $bi4C9.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $eba153b44b4f3dc9$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $bh6RR.useCallback(()=>{
        if (childrenRef.current) $eba153b44b4f3dc9$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $bh6RR.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $8I3yK.default)(()=>{
            if (childrenRef.current) $eba153b44b4f3dc9$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $7tCBy.default)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $bh6RR.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, {
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $bh6RR.cloneElement(children, {
                ref: handleRef,
                style: {
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...style,
                    ...children.props.style
                },
                ...restChildProps
            });
        }
    });
});
var $eba153b44b4f3dc9$export$2e2bcd8739ae039 = $eba153b44b4f3dc9$var$Slide;

});

parcelRegister("8Sqsp", function(module, exports) {

$parcel$export(module.exports, "getDrawerUtilityClass", function () { return $6767e3bb72261cb0$export$b801318a856c9cd2; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $6767e3bb72261cb0$export$b801318a856c9cd2(slot) {
    return (0, $dmzXD.default)('MuiDrawer', slot);
}
const $6767e3bb72261cb0$var$drawerClasses = (0, $fYlYP.default)('MuiDrawer', [
    'root',
    'docked',
    'paper',
    'anchorLeft',
    'anchorRight',
    'anchorTop',
    'anchorBottom',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
    'paperAnchorDockedLeft',
    'paperAnchorDockedRight',
    'paperAnchorDockedTop',
    'paperAnchorDockedBottom',
    'modal'
]);
var $6767e3bb72261cb0$export$2e2bcd8739ae039 = $6767e3bb72261cb0$var$drawerClasses;

});


parcelRegister("ltQuT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa35074bceb65222$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $fa35074bceb65222$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
}), 'Done');

});

parcelRegister("58g7B", function(module, exports) {

$parcel$export(module.exports, "aptaReadInit", function () { return $92e10e84449f9cac$export$4ea07b835533de80; });
$parcel$export(module.exports, "APTA_UNAVAILABLE_MESSAGE", function () { return $92e10e84449f9cac$export$c65bf9048aa63bdf; });
parcelRequire("cFAEN");
var $fEgSm = parcelRequire("fEgSm");
const $92e10e84449f9cac$export$3729910a344e48be = 45000;
function $92e10e84449f9cac$export$4ea07b835533de80() {
    return (0, $fEgSm.timeoutInit)($92e10e84449f9cac$export$3729910a344e48be);
}
const $92e10e84449f9cac$export$c65bf9048aa63bdf = "Your PTI stats are unavailable right now. Please try again in a moment.";

});

parcelRegister("lfvqn", function(module, exports) {

$parcel$export(module.exports, "TrainerFeatureProvider", function () { return $6ac50a4f73e41236$export$1fe945a08e96c8ad; });
$parcel$export(module.exports, "useTrainerFeatures", function () { return $6ac50a4f73e41236$export$a22d7355d29f3a34; });
$parcel$export(module.exports, "useTrainerFeaturesAdmin", function () { return $6ac50a4f73e41236$export$9c432c847fb40328; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1lMle = parcelRequire("1lMle");

var $cK0UE = parcelRequire("cK0UE");

var $ezs3H = parcelRequire("ezs3H");
const $6ac50a4f73e41236$export$142aefa59b24b7bd = /*#__PURE__*/ $bh6RR.createContext([]);
const $6ac50a4f73e41236$export$1fe945a08e96c8ad = /*#__PURE__*/ $bh6RR.memo(({ children: children })=>{
    const [fetching, setFetching] = $bh6RR.useState(false);
    const [features, setFeatures] = $bh6RR.useState([]);
    const [lastFetchedClientId, setLastFetchedClientId] = $bh6RR.useState(undefined);
    const { status: status } = (0, $ezs3H.useStatus)();
    $bh6RR.useEffect(()=>{
        async function checkRequiredFeatures() {
            if (status?.clientId) {
                const result = await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/features");
                (0, $1lMle.default).info(`Available trainer features: ${result.join(",")}`);
                setFeatures(result);
                setLastFetchedClientId(status.clientId);
            }
        }
        // Fetch features if we have a clientId and either:
        // 1. We haven't fetched for any clientId yet, OR
        // 2. The clientId has changed since last fetch
        if (status?.clientId && status.clientId !== lastFetchedClientId && !fetching) {
            setFetching(true);
            checkRequiredFeatures().catch((e)=>{
                (0, $cK0UE.logFetchError)(e);
            }).finally(()=>setFetching(false));
        } else if (status?.clientId === undefined && lastFetchedClientId !== undefined) {
            (0, $1lMle.default).info("Clearing cached trainer features.");
            setFeatures([]);
            setLastFetchedClientId(undefined);
        }
    }, [
        status?.clientId,
        lastFetchedClientId,
        fetching
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($6ac50a4f73e41236$export$142aefa59b24b7bd.Provider, {
        value: features,
        children: children
    });
});
$6ac50a4f73e41236$export$1fe945a08e96c8ad.displayName = "TrainerFeatureProvider";
function $6ac50a4f73e41236$export$a22d7355d29f3a34() {
    return $bh6RR.useContext($6ac50a4f73e41236$export$142aefa59b24b7bd);
}
function $6ac50a4f73e41236$export$9c432c847fb40328(clientId) {
    const [features, setFeatures] = $bh6RR.useState([]);
    $bh6RR.useEffect(()=>{
        async function checkRequiredFeatures() {
            if (clientId) {
                const result = await (0, $cK0UE.default)(`/trainer/${clientId}/api/features`);
                (0, $1lMle.default).info(`Available trainer features: ${result.join(",")}`);
                setFeatures(result);
            }
        }
        checkRequiredFeatures().catch((e)=>{
            (0, $cK0UE.logFetchError)(e);
        });
    }, [
        clientId
    ]);
    return features;
}

});

parcelRegister("68A8d", function(module, exports) {

$parcel$export(module.exports, "expandLabelToComponents", function () { return $31ad5c890d939057$export$8a8eca64fb4500d6; });
$parcel$export(module.exports, "buildLabelToVersionString", function () { return $31ad5c890d939057$export$6b1c1e1ecc2236ab; });
$parcel$export(module.exports, "isValidBuildLabel", function () { return $31ad5c890d939057$export$449add8db9d5a43; });
$parcel$export(module.exports, "expand", function () { return $31ad5c890d939057$export$9f77e0932fb78f72; });
$parcel$export(module.exports, "isVersionGreater", function () { return $31ad5c890d939057$export$871432cbfdd3e0ac; });
// Reference implementation: trainers/atom/go/internal/buildlabels/buildlabels.go
const $31ad5c890d939057$var$PLATFORMS = [
    "Unknown Platform",
    "Wall-E Gigabyte",
    "Small-E Gigabyte",
    "Atom Raspberry Pi 4b",
    "Atom Raspberry Pi CM4",
    "Atom Neousys AGX",
    "Atom PICO PCM R1",
    "Atom PICO HCM R1/R2",
    "Atom PICO LED R1",
    "Atom PICO PCM R2",
    "Atom PICO PCM R3",
    "Atom PICO HCM R3",
    "Atom PICO HCM BL",
    "Atom PICO PCM R4",
    "Atom PICO HCM R4",
    "Atom ForeCR AGX XV2 G2",
    "Atom PICO LED R2",
    "Atom PICO PCM R5",
    "Atom ForeCR AGX XV2 G1",
    "Atom HCM R6",
    "Atom PCM R6",
    "Atom HCM R5"
];
const $31ad5c890d939057$var$TYPES = [
    "Reserved",
    "Control Software",
    "Vision OS",
    "Vision App",
    "MCU Firmware"
];
function $31ad5c890d939057$var$b6(char) {
    const ord = (c)=>c.charCodeAt(0);
    const c = ord(char);
    if (c >= ord("0") && c <= ord("9")) return c - ord("0");
    if (c >= ord("a") && c <= ord("z")) return c - ord("a") + 10;
    if (c >= ord("A") && c <= ord("Z")) return c - ord("A") + 36;
    if (c === ord("-")) return 62;
    if (c === ord("~")) return 63;
    return NaN;
}
function $31ad5c890d939057$export$8a8eca64fb4500d6(label) {
    const yyyy = 2020 + $31ad5c890d939057$var$b6(label[0]);
    const m = $31ad5c890d939057$var$b6(label[1]);
    const d = $31ad5c890d939057$var$b6(label[2]);
    const platform = $31ad5c890d939057$var$PLATFORMS[$31ad5c890d939057$var$b6(label[3])];
    const type = $31ad5c890d939057$var$TYPES[$31ad5c890d939057$var$b6(label[4])];
    const major = $31ad5c890d939057$var$b6(label[5]);
    const minor = $31ad5c890d939057$var$b6(label[6]);
    const patch = $31ad5c890d939057$var$b6(label[7]);
    const alpha = $31ad5c890d939057$var$b6(label[8]);
    const release = alpha === 0 ? "-pro" : `-alpha.${alpha}`;
    const digest = label.slice(12, 20);
    const branch = label.slice(20).replace(/_*$/g, "");
    return {
        year: yyyy,
        month: m,
        day: d,
        platform: platform,
        type: type,
        major: major,
        minor: minor,
        patch: patch,
        alpha: alpha,
        release: release,
        digest: digest,
        branch: branch
    };
}
function $31ad5c890d939057$export$6b1c1e1ecc2236ab(label) {
    const components = $31ad5c890d939057$export$8a8eca64fb4500d6(label);
    let suffix = "";
    if (components.alpha !== 0) suffix = `-alpha.${components.alpha}`;
    return `${components.major}.${components.minor}.${components.patch}${suffix}`;
}
function $31ad5c890d939057$export$449add8db9d5a43(label) {
    if (label.length !== 36) return false;
    for(let i = 0; i < 9; i++){
        if (Number.isNaN($31ad5c890d939057$var$b6(label[i]))) return false;
    }
    return true;
}
function $31ad5c890d939057$export$9f77e0932fb78f72(label) {
    if (!label) return "";
    const components = $31ad5c890d939057$export$8a8eca64fb4500d6(label);
    const yyyy = components.year;
    const m = components.month;
    const mm = m < 10 ? `0${m}` : m;
    const d = components.day;
    const dd = d < 10 ? `0${d}` : d;
    const { platform: platform, type: type, major: major, minor: minor, patch: patch, release: release, digest: digest, branch: branch } = components;
    return `${yyyy}-${mm}-${dd} ${major}.${minor}.${patch}${release} ${platform} ${type} ${branch} ${digest}`;
}
function $31ad5c890d939057$export$871432cbfdd3e0ac(version1, version2) {
    const parseVersion = (version)=>{
        const matches = version.match(/^(\d+)\.(\d+)\.(\d+)/);
        if (!matches) throw new Error(`Invalid version format: ${version}`);
        const [, major, minor, patch] = matches;
        return [
            parseInt(major, 10),
            parseInt(minor, 10),
            parseInt(patch, 10)
        ];
    };
    const [major1, minor1, patch1] = parseVersion(version1);
    const [major2, minor2, patch2] = parseVersion(version2);
    if (major1 > major2) return true;
    if (major1 < major2) return false;
    if (minor1 > minor2) return true;
    if (minor1 < minor2) return false;
    if (patch1 > patch2) return true;
    return false;
}

});

parcelRegister("1lA67", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fb3c0e011ba7685$export$2e2bcd8739ae039; });


var $af4Kb = parcelRequire("af4Kb");


var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $aOb5j = parcelRequire("aOb5j");
'use client';
/**
 *
 * Demos:
 *
 * - [Grid](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/material-ui/api/grid/)
 */ const $0fb3c0e011ba7685$var$Grid = (0, $af4Kb.default)({
    createStyledComponent: (0, $l0oRz.default)('div', {
        name: 'MuiGrid',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                ownerState.container && styles.container
            ];
        }
    }),
    componentName: 'MuiGrid',
    useThemeProps: (inProps)=>(0, $OEXBZ.useDefaultProps)({
            props: inProps,
            name: 'MuiGrid'
        }),
    useTheme: $aOb5j.default
});
var $0fb3c0e011ba7685$export$2e2bcd8739ae039 = $0fb3c0e011ba7685$var$Grid;

});
parcelRegister("af4Kb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $774efc227b92d76c$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $elIq5 = parcelRequire("elIq5");

var $dmzXD = parcelRequire("dmzXD");

var $96ZcP = parcelRequire("96ZcP");

var $kleHe = parcelRequire("kleHe");

var $2DXvq = parcelRequire("2DXvq");

var $5wgL8 = parcelRequire("5wgL8");

var $gIHYf = parcelRequire("gIHYf");

var $1zcRx = parcelRequire("1zcRx");

var $35YUc = parcelRequire("35YUc");

var $fyTrX = parcelRequire("fyTrX");

var $ih19M = parcelRequire("ih19M");
'use client';
const $774efc227b92d76c$var$defaultTheme = (0, $1zcRx.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $774efc227b92d76c$var$defaultCreateStyledComponent = (0, $kleHe.default)('div', {
    name: 'MuiGrid',
    slot: 'Root'
});
function $774efc227b92d76c$var$useThemePropsDefault(props) {
    return (0, $2DXvq.default)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $774efc227b92d76c$var$defaultTheme
    });
}
function $774efc227b92d76c$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $774efc227b92d76c$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $774efc227b92d76c$var$useThemePropsDefault, useTheme: useTheme = (0, $5wgL8.default), componentName: componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $35YUc.generateDirectionClasses)(direction),
                ...(0, $35YUc.generateSizeClassNames)(size),
                ...container ? (0, $35YUc.generateSpacingClassNames)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $96ZcP.default)(slots, (slot)=>(0, $dmzXD.default)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent((0, $35YUc.generateGridColumnsStyles), (0, $35YUc.generateGridColumnSpacingStyles), (0, $35YUc.generateGridRowSpacingStyles), (0, $35YUc.generateGridSizeStyles), (0, $35YUc.generateGridDirectionStyles), (0, $35YUc.generateGridStyles), (0, $35YUc.generateGridOffsetStyles));
    const Grid = /*#__PURE__*/ $bh6RR.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = (0, $gIHYf.default)(themeProps); // `color` type conflicts with html color attribute.
        // TODO v8: Remove when removing the legacy Grid component
        (0, $fyTrX.default)(props, theme.breakpoints);
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $ih19M.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $aPsoC.default)(classes.root, className),
            ...other,
            children: $bh6RR.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $bh6RR.isValidElement(child) && (0, $elIq5.default)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ $bh6RR.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}

});
parcelRegister("35YUc", function(module, exports) {

$parcel$export(module.exports, "generateGridSizeStyles", function () { return $2411154178858100$export$84053369756c53db; });
$parcel$export(module.exports, "generateGridOffsetStyles", function () { return $2411154178858100$export$c1d4f281314969c2; });
$parcel$export(module.exports, "generateGridColumnsStyles", function () { return $2411154178858100$export$ccc4d4a4923f1b06; });
$parcel$export(module.exports, "generateGridRowSpacingStyles", function () { return $2411154178858100$export$68c4dad72dd49c74; });
$parcel$export(module.exports, "generateGridColumnSpacingStyles", function () { return $2411154178858100$export$a89c28919b8e3bb5; });
$parcel$export(module.exports, "generateGridDirectionStyles", function () { return $2411154178858100$export$2a0a3c01032b3f4; });
$parcel$export(module.exports, "generateGridStyles", function () { return $2411154178858100$export$810b8c3ab5d46bf; });
$parcel$export(module.exports, "generateSizeClassNames", function () { return $2411154178858100$export$e2d1175061442d38; });
$parcel$export(module.exports, "generateSpacingClassNames", function () { return $2411154178858100$export$6c7087d27c3329d3; });
$parcel$export(module.exports, "generateDirectionClasses", function () { return $2411154178858100$export$a7c8efbe2b138a60; });

var $74KvH = parcelRequire("74KvH");
function $2411154178858100$var$getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function $2411154178858100$var$getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const $2411154178858100$var$selfColumnsVar = '--Grid-columns';
const $2411154178858100$var$parentColumnsVar = '--Grid-parent-columns';
const $2411154178858100$export$84053369756c53db = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $74KvH.traverseBreakpoints)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${$2411154178858100$var$parentColumnsVar}) - (var(${$2411154178858100$var$parentColumnsVar}) - ${value}) * (var(${$2411154178858100$var$getParentSpacingVar('column')}) / var(${$2411154178858100$var$parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $2411154178858100$export$c1d4f281314969c2 = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $74KvH.traverseBreakpoints)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${$2411154178858100$var$parentColumnsVar}) + var(${$2411154178858100$var$getParentSpacingVar('column')}) * ${value} / var(${$2411154178858100$var$parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $2411154178858100$export$ccc4d4a4923f1b06 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [$2411154178858100$var$selfColumnsVar]: 12
    };
    (0, $74KvH.traverseBreakpoints)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [$2411154178858100$var$selfColumnsVar]: columns,
            '> *': {
                [$2411154178858100$var$parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
const $2411154178858100$export$68c4dad72dd49c74 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $74KvH.traverseBreakpoints)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$2411154178858100$var$getSelfSpacingVar('row')]: spacing,
            '> *': {
                [$2411154178858100$var$getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
const $2411154178858100$export$a89c28919b8e3bb5 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $74KvH.traverseBreakpoints)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$2411154178858100$var$getSelfSpacingVar('column')]: spacing,
            '> *': {
                [$2411154178858100$var$getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
const $2411154178858100$export$2a0a3c01032b3f4 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $74KvH.traverseBreakpoints)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
const $2411154178858100$export$810b8c3ab5d46bf = ({ ownerState: ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${$2411154178858100$var$getSelfSpacingVar('row')}) var(${$2411154178858100$var$getSelfSpacingVar('column')})`
        }
    };
};
const $2411154178858100$export$e2d1175061442d38 = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
const $2411154178858100$export$6c7087d27c3329d3 = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
const $2411154178858100$export$a7c8efbe2b138a60 = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};

});
parcelRegister("74KvH", function(module, exports) {

$parcel$export(module.exports, "traverseBreakpoints", function () { return $526cfc1c89507d19$export$e04173f1577f18b7; });
const $526cfc1c89507d19$export$f1ce4856483bd995 = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
const $526cfc1c89507d19$export$e04173f1577f18b7 = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $526cfc1c89507d19$export$f1ce4856483bd995(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};

});


parcelRegister("fyTrX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5450b2c06dc76e2$export$2e2bcd8739ae039; });
const $b5450b2c06dc76e2$var$getLegacyGridWarning = (propName)=>{
    if ([
        'item',
        'zeroMinWidth'
    ].includes(propName)) return `The \`${propName}\` prop has been removed and is no longer necessary. You can safely remove it.`;
    // #host-reference
    return `The \`${propName}\` prop has been removed. See https://mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.`;
};
const $b5450b2c06dc76e2$var$warnedAboutProps = [];
function $b5450b2c06dc76e2$export$2e2bcd8739ae039(props, breakpoints) {
    const propsToWarn = [];
    if (props.item !== undefined) {
        delete props.item;
        propsToWarn.push('item');
    }
    if (props.zeroMinWidth !== undefined) {
        delete props.zeroMinWidth;
        propsToWarn.push('zeroMinWidth');
    }
    breakpoints.keys.forEach((breakpoint)=>{
        if (props[breakpoint] !== undefined) {
            propsToWarn.push(breakpoint);
            delete props[breakpoint];
        }
    });
    var prop;
}

});



parcelRegister("cgUqb", function(module, exports) {

$parcel$export(module.exports, "useAppWorkoutStatus", function () { return $6d14c5b97717f08f$export$41fb9700809df5b2; });

var $bh6RR = parcelRequire("bh6RR");

var $1lMle = parcelRequire("1lMle");

var $ezs3H = parcelRequire("ezs3H");
function $6d14c5b97717f08f$export$41fb9700809df5b2() {
    const { status: status, removeRapidPollCheck: removeRapidPollCheck, startRapidPoll: startRapidPoll } = (0, $ezs3H.useStatus)();
    $bh6RR.useEffect(()=>{
        (0, $1lMle.default).info("Starting Rapid Polling for Workout Status");
        startRapidPoll(1000, ()=>false, "workouts");
        return ()=>{
            removeRapidPollCheck("workouts");
        };
    }, [
        startRapidPoll,
        removeRapidPollCheck
    ]);
    return status?.workouts ?? {
        appErrors: [],
        currentWorkout: null,
        diagnostics: {},
        recordingState: "inactive",
        playState: "stopped",
        serviceState: "Running"
    };
}

});

parcelRegister("9rvkQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6dfef134e22a56c8$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $6dfef134e22a56c8$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), 'Error');

});

parcelRegister("iTU6T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc28e359057ab97e$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $dc28e359057ab97e$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');

});

parcelRegister("3x9x0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $292bd8e89bc5e310$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $292bd8e89bc5e310$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 17h-2v-2h2zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25"
}), 'Help');

});

parcelRegister("l82lx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f61c2a4944b6b47e$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $b6vKX = parcelRequire("b6vKX");

var $fbTZq = parcelRequire("fbTZq");

var $14LyK = parcelRequire("14LyK");

var $dg012 = parcelRequire("dg012");

var $bvRvQ = parcelRequire("bvRvQ");

var $cuEW8 = parcelRequire("cuEW8");

var $ih19M = parcelRequire("ih19M");
'use client';
const $f61c2a4944b6b47e$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $f61c2a4944b6b47e$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            divider && 'divider',
            disabled && 'disabled',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $cuEW8.getListItemButtonUtilityClass), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $f61c2a4944b6b47e$var$ListItemButtonRoot = (0, $l0oRz.default)((0, $fbTZq.default), {
    shouldForwardProp: (prop)=>(0, $b6vKX.default)(prop) || prop === 'classes',
    name: 'MuiListItemButton',
    slot: 'Root',
    overridesResolver: $f61c2a4944b6b47e$export$4334bb34c76fef24
})((0, $gfPc7.default)(({ theme: theme })=>({
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minWidth: 0,
        boxSizing: 'border-box',
        textAlign: 'left',
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $cuEW8.default).selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            [`&.${(0, $cuEW8.default).focusVisible}`]: {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
            }
        },
        [`&.${(0, $cuEW8.default).selected}:hover`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $cuEW8.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $cuEW8.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            }
        ]
    })));
const $f61c2a4944b6b47e$var$ListItemButton = /*#__PURE__*/ $bh6RR.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemButton'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, component: component = 'div', children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className, ...other } = props;
    const context = $bh6RR.useContext((0, $bvRvQ.default));
    const childContext = $bh6RR.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $bh6RR.useRef(null);
    (0, $14LyK.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    };
    const classes = $f61c2a4944b6b47e$var$useUtilityClasses(ownerState);
    const handleRef = (0, $dg012.default)(listItemRef, ref);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $bvRvQ.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($f61c2a4944b6b47e$var$ListItemButtonRoot, {
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === 'div' ? 'button' : component,
            focusVisibleClassName: (0, $aPsoC.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $aPsoC.default)(classes.root, className),
            ...other,
            classes: classes,
            children: children
        })
    });
});
var $f61c2a4944b6b47e$export$2e2bcd8739ae039 = $f61c2a4944b6b47e$var$ListItemButton;

});

parcelRegister("dHxgH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f9918ebd5745758$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $5wa4U = parcelRequire("5wa4U");

var $bvRvQ = parcelRequire("bvRvQ");

var $ih19M = parcelRequire("ih19M");
'use client';
const $9f9918ebd5745758$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $5wa4U.getListItemIconUtilityClass), classes);
};
const $9f9918ebd5745758$var$ListItemIconRoot = (0, $l0oRz.default)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex',
        variants: [
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    marginTop: 8
                }
            }
        ]
    })));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $9f9918ebd5745758$var$ListItemIcon = /*#__PURE__*/ $bh6RR.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className, ...other } = props;
    const context = $bh6RR.useContext((0, $bvRvQ.default));
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = $9f9918ebd5745758$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($9f9918ebd5745758$var$ListItemIconRoot, {
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $9f9918ebd5745758$export$2e2bcd8739ae039 = $9f9918ebd5745758$var$ListItemIcon;

});

parcelRegister("fpwuC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b382653b554b1c0e$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $96ZcP = parcelRequire("96ZcP");

var $krx4P = parcelRequire("krx4P");

var $4B5Or = parcelRequire("4B5Or");

var $774Wc = parcelRequire("774Wc");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $igmqL = parcelRequire("igmqL");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
const $b382653b554b1c0e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $krx4P.default)(edge)}`,
            `size${(0, $krx4P.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $krx4P.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $igmqL.getSwitchUtilityClass), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $b382653b554b1c0e$var$SwitchRoot = (0, $l0oRz.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $krx4P.default)(ownerState.edge)}`],
            styles[`size${(0, $krx4P.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $igmqL.default).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $igmqL.default).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $igmqL.default).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $b382653b554b1c0e$var$SwitchSwitchBase = (0, $l0oRz.default)((0, $774Wc.default), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $igmqL.default).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $krx4P.default)(ownerState.color)}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $igmqL.default).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $igmqL.default).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $igmqL.default).checked} + .${(0, $igmqL.default).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $igmqL.default).disabled} + .${(0, $igmqL.default).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $igmqL.default).input}`]: {
            left: '-100%',
            width: '300%'
        }
    })), (0, $gfPc7.default)(({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)([
                'light'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $igmqL.default).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $igmqL.default).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? theme.lighten(theme.palette[color].main, 0.62) : theme.darken(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $igmqL.default).checked} + .${(0, $igmqL.default).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    })));
const $b382653b554b1c0e$var$SwitchTrack = (0, $l0oRz.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track'
})((0, $gfPc7.default)(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    })));
const $b382653b554b1c0e$var$SwitchThumb = (0, $l0oRz.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb'
})((0, $gfPc7.default)(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    })));
const $b382653b554b1c0e$var$Switch = /*#__PURE__*/ $bh6RR.forwardRef(function Switch(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        edge: edge,
        size: size
    };
    const classes = $b382653b554b1c0e$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $dFvJW.default)('root', {
        className: (0, $aPsoC.default)(classes.root, className),
        elementType: $b382653b554b1c0e$var$SwitchRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            sx: sx
        }
    });
    const [ThumbSlot, thumbSlotProps] = (0, $dFvJW.default)('thumb', {
        className: classes.thumb,
        elementType: $b382653b554b1c0e$var$SwitchThumb,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const icon = /*#__PURE__*/ (0, $ih19M.jsx)(ThumbSlot, {
        ...thumbSlotProps
    });
    const [TrackSlot, trackSlotProps] = (0, $dFvJW.default)('track', {
        className: classes.track,
        elementType: $b382653b554b1c0e$var$SwitchTrack,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($b382653b554b1c0e$var$SwitchSwitchBase, {
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState,
                ...other,
                classes: {
                    ...classes,
                    root: classes.switchBase
                },
                slots: {
                    ...slots.switchBase && {
                        root: slots.switchBase
                    },
                    ...slots.input && {
                        input: slots.input
                    }
                },
                slotProps: {
                    ...slotProps.switchBase && {
                        root: typeof slotProps.switchBase === 'function' ? slotProps.switchBase(ownerState) : slotProps.switchBase
                    },
                    input: {
                        role: 'switch'
                    },
                    ...slotProps.input && {
                        input: typeof slotProps.input === 'function' ? slotProps.input(ownerState) : slotProps.input
                    }
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)(TrackSlot, {
                ...trackSlotProps
            })
        ]
    });
});
var $b382653b554b1c0e$export$2e2bcd8739ae039 = $b382653b554b1c0e$var$Switch;

});
parcelRegister("774Wc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52dd0459e699bd84$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");



var $96ZcP = parcelRequire("96ZcP");

var $krx4P = parcelRequire("krx4P");

var $b6vKX = parcelRequire("b6vKX");

var $l0oRz = parcelRequire("l0oRz");

var $8ANil = parcelRequire("8ANil");

var $1BiIF = parcelRequire("1BiIF");

var $fbTZq = parcelRequire("fbTZq");

var $8CDnO = parcelRequire("8CDnO");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
const $52dd0459e699bd84$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $krx4P.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $8CDnO.getSwitchBaseUtilityClass), classes);
};
const $52dd0459e699bd84$var$SwitchBaseRoot = (0, $l0oRz.default)((0, $fbTZq.default), {
    name: 'MuiSwitchBase'
})({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $52dd0459e699bd84$var$SwitchBaseInput = (0, $l0oRz.default)('input', {
    name: 'MuiSwitchBase',
    shouldForwardProp: (0, $b6vKX.default)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $52dd0459e699bd84$var$SwitchBase = /*#__PURE__*/ $bh6RR.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [checked, setCheckedState] = (0, $8ANil.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $1BiIF.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $52dd0459e699bd84$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: inputProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $dFvJW.default)('root', {
        ref: ref,
        elementType: $52dd0459e699bd84$var$SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: 'span',
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleBlur(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            disabled: disabled,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, $dFvJW.default)('input', {
        ref: inputRef,
        elementType: $52dd0459e699bd84$var$SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event)=>{
                    handlers.onChange?.(event);
                    handleInputChange(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type,
            ...type === 'checkbox' && value === undefined ? {} : {
                value: value
            }
        }
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)(InputSlot, {
                ...inputSlotProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var $52dd0459e699bd84$export$2e2bcd8739ae039 = $52dd0459e699bd84$var$SwitchBase;

});
parcelRegister("8CDnO", function(module, exports) {

$parcel$export(module.exports, "getSwitchBaseUtilityClass", function () { return $64706c004e330838$export$baa0faa0c7ad8085; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $64706c004e330838$export$baa0faa0c7ad8085(slot) {
    return (0, $dmzXD.default)('PrivateSwitchBase', slot);
}
const $64706c004e330838$var$switchBaseClasses = (0, $fYlYP.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $64706c004e330838$export$2e2bcd8739ae039 = $64706c004e330838$var$switchBaseClasses;

});


parcelRegister("igmqL", function(module, exports) {

$parcel$export(module.exports, "getSwitchUtilityClass", function () { return $d4bb1ee283348f42$export$39f6debbec19b3ba; });
$parcel$export(module.exports, "default", function () { return $d4bb1ee283348f42$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $d4bb1ee283348f42$export$39f6debbec19b3ba(slot) {
    return (0, $dmzXD.default)('MuiSwitch', slot);
}
const $d4bb1ee283348f42$var$switchClasses = (0, $fYlYP.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $d4bb1ee283348f42$export$2e2bcd8739ae039 = $d4bb1ee283348f42$var$switchClasses;

});


parcelRegister("ehkZF", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $a652f01bdfc5ed2f$export$2c14ff85d6318973; });

var $6ycOY = parcelRequire("6ycOY");

var $kTedh = parcelRequire("kTedh");

var $ib2QH = parcelRequire("ib2QH");

var $9Sr82 = parcelRequire("9Sr82");

var $iNsOb = parcelRequire("iNsOb");

var $kS8D1 = parcelRequire("kS8D1");

var $1HZhy = parcelRequire("1HZhy");

var $1emKX = parcelRequire("1emKX");
function $a652f01bdfc5ed2f$export$2c14ff85d6318973(laterDate, earlierDate, options) {
    const defaultOptions = (0, $kTedh.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $6ycOY.enUS);
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $iNsOb.compareAsc)(laterDate, earlierDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    const [laterDate_, earlierDate_] = (0, $9Sr82.normalizeDates)(options?.in, ...comparison > 0 ? [
        earlierDate,
        laterDate
    ] : [
        laterDate,
        earlierDate
    ]);
    const seconds = (0, $1emKX.differenceInSeconds)(earlierDate_, laterDate_);
    const offsetInSeconds = ((0, $ib2QH.getTimezoneOffsetInMilliseconds)(earlierDate_) - (0, $ib2QH.getTimezoneOffsetInMilliseconds)(laterDate_)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < (0, $kS8D1.minutesInDay)) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < (0, $kS8D1.minutesInMonth)) {
        const days = Math.round(minutes / (0, $kS8D1.minutesInDay));
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < (0, $kS8D1.minutesInMonth) * 2) {
        months = Math.round(minutes / (0, $kS8D1.minutesInMonth));
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $1HZhy.differenceInMonths)(earlierDate_, laterDate_);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / (0, $kS8D1.minutesInMonth));
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}
var // Fallback for modularized imports:
$a652f01bdfc5ed2f$export$2e2bcd8739ae039 = $a652f01bdfc5ed2f$export$2c14ff85d6318973;

});
parcelRegister("iNsOb", function(module, exports) {

$parcel$export(module.exports, "compareAsc", function () { return $daf326573633e53e$export$fe114145ae75d197; });

var $1E9XN = parcelRequire("1E9XN");
function $daf326573633e53e$export$fe114145ae75d197(dateLeft, dateRight) {
    const diff = +(0, $1E9XN.toDate)(dateLeft) - +(0, $1E9XN.toDate)(dateRight);
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$daf326573633e53e$export$2e2bcd8739ae039 = $daf326573633e53e$export$fe114145ae75d197;

});

parcelRegister("1HZhy", function(module, exports) {

$parcel$export(module.exports, "differenceInMonths", function () { return $13e957f56260e25b$export$fc1ed482c2861792; });

var $9Sr82 = parcelRequire("9Sr82");

var $iNsOb = parcelRequire("iNsOb");

var $3CkjH = parcelRequire("3CkjH");

var $5GssB = parcelRequire("5GssB");
function $13e957f56260e25b$export$fc1ed482c2861792(laterDate, earlierDate, options) {
    const [laterDate_, workingLaterDate, earlierDate_] = (0, $9Sr82.normalizeDates)(options?.in, laterDate, laterDate, earlierDate);
    const sign = (0, $iNsOb.compareAsc)(workingLaterDate, earlierDate_);
    const difference = Math.abs((0, $3CkjH.differenceInCalendarMonths)(workingLaterDate, earlierDate_));
    if (difference < 1) return 0;
    if (workingLaterDate.getMonth() === 1 && workingLaterDate.getDate() > 27) workingLaterDate.setDate(30);
    workingLaterDate.setMonth(workingLaterDate.getMonth() - sign * difference);
    let isLastMonthNotFull = (0, $iNsOb.compareAsc)(workingLaterDate, earlierDate_) === -sign;
    if ((0, $5GssB.isLastDayOfMonth)(laterDate_) && difference === 1 && (0, $iNsOb.compareAsc)(laterDate_, earlierDate_) === 1) isLastMonthNotFull = false;
    const result = sign * (difference - +isLastMonthNotFull);
    return result === 0 ? 0 : result;
}
var // Fallback for modularized imports:
$13e957f56260e25b$export$2e2bcd8739ae039 = $13e957f56260e25b$export$fc1ed482c2861792;

});
parcelRegister("3CkjH", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarMonths", function () { return $2a24ae345dbdb04a$export$489984ac7c996389; });

var $9Sr82 = parcelRequire("9Sr82");
function $2a24ae345dbdb04a$export$489984ac7c996389(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $9Sr82.normalizeDates)(options?.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
    return yearsDiff * 12 + monthsDiff;
}
var // Fallback for modularized imports:
$2a24ae345dbdb04a$export$2e2bcd8739ae039 = $2a24ae345dbdb04a$export$489984ac7c996389;

});

parcelRegister("5GssB", function(module, exports) {

$parcel$export(module.exports, "isLastDayOfMonth", function () { return $4236f3a26e6254fb$export$c817d0312007ea5e; });

var $gq4Kz = parcelRequire("gq4Kz");

var $b6I4M = parcelRequire("b6I4M");

var $1E9XN = parcelRequire("1E9XN");
function $4236f3a26e6254fb$export$c817d0312007ea5e(date, options) {
    const _date = (0, $1E9XN.toDate)(date, options?.in);
    return +(0, $gq4Kz.endOfDay)(_date, options) === +(0, $b6I4M.endOfMonth)(_date, options);
}
var // Fallback for modularized imports:
$4236f3a26e6254fb$export$2e2bcd8739ae039 = $4236f3a26e6254fb$export$c817d0312007ea5e;

});
parcelRegister("gq4Kz", function(module, exports) {

$parcel$export(module.exports, "endOfDay", function () { return $bf42c24e3bf19d80$export$eb9a03f0e9aa6cea; });

var $1E9XN = parcelRequire("1E9XN");
function $bf42c24e3bf19d80$export$eb9a03f0e9aa6cea(date, options) {
    const _date = (0, $1E9XN.toDate)(date, options?.in);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$bf42c24e3bf19d80$export$2e2bcd8739ae039 = $bf42c24e3bf19d80$export$eb9a03f0e9aa6cea;

});

parcelRegister("b6I4M", function(module, exports) {

$parcel$export(module.exports, "endOfMonth", function () { return $816271d8f5f15699$export$a2258d9c4118825c; });

var $1E9XN = parcelRequire("1E9XN");
function $816271d8f5f15699$export$a2258d9c4118825c(date, options) {
    const _date = (0, $1E9XN.toDate)(date, options?.in);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$816271d8f5f15699$export$2e2bcd8739ae039 = $816271d8f5f15699$export$a2258d9c4118825c;

});



parcelRegister("1emKX", function(module, exports) {

$parcel$export(module.exports, "differenceInSeconds", function () { return $0e58c031cb3b0801$export$c1889aec51783710; });

var $jIPg4 = parcelRequire("jIPg4");

var $H1h0I = parcelRequire("H1h0I");
function $0e58c031cb3b0801$export$c1889aec51783710(laterDate, earlierDate, options) {
    const diff = (0, $H1h0I.differenceInMilliseconds)(laterDate, earlierDate) / 1000;
    return (0, $jIPg4.getRoundingMethod)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$0e58c031cb3b0801$export$2e2bcd8739ae039 = $0e58c031cb3b0801$export$c1889aec51783710;

});
parcelRegister("jIPg4", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", function () { return $e5b9e336203f625c$export$b6474a47258c1211; });
function $e5b9e336203f625c$export$b6474a47258c1211(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

});

parcelRegister("H1h0I", function(module, exports) {

$parcel$export(module.exports, "differenceInMilliseconds", function () { return $081501214ed40bbe$export$7be94d13716b4bf6; });

var $1E9XN = parcelRequire("1E9XN");
function $081501214ed40bbe$export$7be94d13716b4bf6(laterDate, earlierDate) {
    return +(0, $1E9XN.toDate)(laterDate) - +(0, $1E9XN.toDate)(earlierDate);
}
var // Fallback for modularized imports:
$081501214ed40bbe$export$2e2bcd8739ae039 = $081501214ed40bbe$export$7be94d13716b4bf6;

});



parcelRegister("97Cqv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d34e618eae58ac2$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $lQLDM = parcelRequire("lQLDM");

var $2btZb = parcelRequire("2btZb");

var $lQQsJ = parcelRequire("lQQsJ");

var $fJlfH = parcelRequire("fJlfH");

var $3e0y4 = parcelRequire("3e0y4");

var $7pXyk = parcelRequire("7pXyk");
function $0d34e618eae58ac2$export$2e2bcd8739ae039({ cellularStatus: cellularStatus }) {
    if (!cellularStatus) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $7pXyk.default), {});
    // new metric for network quality used by motion for the billboard
    if (cellularStatus.score) {
        if (cellularStatus.score < 20) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $2btZb.default), {
            color: "warning"
        });
        if (cellularStatus.score < 40) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $2btZb.default), {
            color: "success"
        });
        if (cellularStatus.score < 60) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lQQsJ.default), {
            color: "success"
        });
        if (cellularStatus.score < 80) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $fJlfH.default), {
            color: "success"
        });
        if (cellularStatus.score >= 80) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $3e0y4.default), {
            color: "success"
        });
    }
    // backwards compat for trainers without the new metric in coach status
    if (cellularStatus.rssi) {
        if (cellularStatus.rssi > -70) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $fJlfH.default), {
            color: "success"
        });
        if (cellularStatus.rssi > -85) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lQQsJ.default), {
            color: "warning"
        });
        if (cellularStatus.rssi > -95) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $2btZb.default), {
            color: "warning"
        });
    }
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lQLDM.default), {
        color: "error"
    });
}

});
parcelRegister("lQLDM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe8368bbdba5025a$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $fe8368bbdba5025a$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M20 6.83V20H6.83zM22 2 2 22h20z"
}), 'SignalCellular0Bar');

});

parcelRegister("2btZb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1973de6827b80069$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
var $1973de6827b80069$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            fillOpacity: ".3",
            d: "M2 22h20V2z"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M12 12L2 22h10z"
        })
    ]
}), 'SignalCellular1Bar');

});

parcelRegister("lQQsJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe87263eec9fa3ce$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
var $fe87263eec9fa3ce$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            fillOpacity: ".3",
            d: "M2 22h20V2z"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M14 10L2 22h12z"
        })
    ]
}), 'SignalCellular2Bar');

});

parcelRegister("fJlfH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b73b8b3e045fabce$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
var $b73b8b3e045fabce$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            fillOpacity: ".3",
            d: "M2 22h20V2z"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M17 7L2 22h15z"
        })
    ]
}), 'SignalCellular3Bar');

});

parcelRegister("3e0y4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25931acead4ea3b5$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $25931acead4ea3b5$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M2 22h20V2z"
}), 'SignalCellular4Bar');

});

parcelRegister("7pXyk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5669101d3aed0bfd$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $5669101d3aed0bfd$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M20 18h2v-8h-2zm0 4h2v-2h-2zm-2-2v2H2L22 2v6h-2V6.83L6.83 20z"
}), 'SignalCellularConnectedNoInternet0Bar');

});


parcelRegister("21XbV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $988e93726a85adc3$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $e3BVO = parcelRequire("e3BVO");

var $n0gOg = parcelRequire("n0gOg");

var $baA7G = parcelRequire("baA7G");

var $7Pqnq = parcelRequire("7Pqnq");

var $cqGmn = parcelRequire("cqGmn");

var $cEmOH = parcelRequire("cEmOH");
function $988e93726a85adc3$export$2e2bcd8739ae039({ wifiStatus: wifiStatus }) {
    if (!wifiStatus || !wifiStatus.essid) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cqGmn.default), {});
    // new metric for network quality used by motion for the billboard
    if (wifiStatus.score) {
        if (wifiStatus.score < 20) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e3BVO.default), {
            color: "warning"
        });
        if (wifiStatus.score < 40) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e3BVO.default), {
            color: "success"
        });
        if (wifiStatus.score < 60) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $n0gOg.default), {
            color: "success"
        });
        if (wifiStatus.score < 80) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $baA7G.default), {
            color: "success"
        });
        if (wifiStatus.score >= 80) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $7Pqnq.default), {
            color: "success"
        });
    }
    // backwards compat for trainers without the new metric in coach status
    if (wifiStatus.signal) {
        if (wifiStatus.signal > -50) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $7Pqnq.default), {
            color: "success"
        });
        if (wifiStatus.signal > -60) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $baA7G.default), {
            color: "success"
        });
        if (wifiStatus.signal > -70) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $n0gOg.default), {
            color: "warning"
        });
        if (wifiStatus.signal > -80) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e3BVO.default), {
            color: "warning"
        });
    }
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cEmOH.default), {
        color: "error"
    });
}

});
parcelRegister("e3BVO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3bec4dfa11a62ce$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
var $a3bec4dfa11a62ce$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            fillOpacity: ".3",
            d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z"
        })
    ]
}), 'SignalWifi1Bar');

});

parcelRegister("n0gOg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04525bbcfef7994a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
var $04525bbcfef7994a$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            fillOpacity: ".3",
            d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M4.79 12.52l7.2 8.98H12l.01-.01 7.2-8.98C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z"
        })
    ]
}), 'SignalWifi2Bar');

});

parcelRegister("baA7G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $821ca62a5715283f$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
var $821ca62a5715283f$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            fillOpacity: ".3",
            d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z"
        })
    ]
}), 'SignalWifi3Bar');

});

parcelRegister("7Pqnq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b31c1b4f7791249$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $5b31c1b4f7791249$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12.01 21.49 23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01z"
}), 'SignalWifi4Bar');

});

parcelRegister("cqGmn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90c8c588caf7a05e$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $90c8c588caf7a05e$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27z"
}), 'SignalWifiOff');

});

parcelRegister("cEmOH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $935aeb609a3c210d$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $935aeb609a3c210d$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98C20.93 5.9 16.69 4 12 4M2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07L12 18.17z"
}), 'SignalWifiStatusbarNull');

});


parcelRegister("9ug9t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e8371d23529ed50$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $96ZcP = parcelRequire("96ZcP");

var $am2yJ = parcelRequire("am2yJ");

var $l0eKO = parcelRequire("l0eKO");

var $g0K0l = parcelRequire("g0K0l");

var $5Htn0 = parcelRequire("5Htn0");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $52dC4 = parcelRequire("52dC4");

var $c088I = parcelRequire("c088I");

var $krx4P = parcelRequire("krx4P");

var $4B5Or = parcelRequire("4B5Or");

var $ayIxk = parcelRequire("ayIxk");

var $gCZmy = parcelRequire("gCZmy");

var $ih19M = parcelRequire("ih19M");
'use client';
function $6e8371d23529ed50$var$Identity(x) {
    return x;
}
const $6e8371d23529ed50$export$c1a21b3b4da66aa1 = (0, $l0oRz.default)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $krx4P.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, $krx4P.default)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${(0, $gCZmy.default).disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${(0, $gCZmy.default).dragging}`]: {
            [`& .${(0, $gCZmy.default).thumb}, & .${(0, $gCZmy.default).track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    })));
const $6e8371d23529ed50$export$b02fde61a3559c2 = (0, $l0oRz.default)('span', {
    name: 'MuiSlider',
    slot: 'Rail'
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const $6e8371d23529ed50$export$105594979f116971 = (0, $l0oRz.default)('span', {
    name: 'MuiSlider',
    slot: 'Track'
})((0, $gfPc7.default)(({ theme: theme })=>{
    return {
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    border: 'none'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color,
                        track: 'inverted'
                    },
                    style: {
                        ...theme.vars ? {
                            backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                            borderColor: theme.vars.palette.Slider[`${color}Track`]
                        } : {
                            backgroundColor: theme.lighten(theme.palette[color].main, 0.62),
                            borderColor: theme.lighten(theme.palette[color].main, 0.62),
                            ...theme.applyStyles('dark', {
                                backgroundColor: theme.darken(theme.palette[color].main, 0.5)
                            }),
                            ...theme.applyStyles('dark', {
                                borderColor: theme.darken(theme.palette[color].main, 0.5)
                            })
                        }
                    }
                }))
        ]
    };
}));
const $6e8371d23529ed50$export$2c1b491743890dec = (0, $l0oRz.default)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $krx4P.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, $krx4P.default)(ownerState.size)}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${(0, $gCZmy.default).disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&:hover, &.${(0, $gCZmy.default).focusVisible}`]: {
                            boxShadow: `0px 0px 0px 8px ${theme.alpha((theme.vars || theme).palette[color].main, 0.16)}`,
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        },
                        [`&.${(0, $gCZmy.default).active}`]: {
                            boxShadow: `0px 0px 0px 14px ${theme.alpha((theme.vars || theme).palette[color].main, 0.16)}`
                        }
                    }
                }))
        ]
    })));
const $6e8371d23529ed50$export$6453176f504d54f0 = (0, $l0oRz.default)((0, $ayIxk.default), {
    name: 'MuiSlider',
    slot: 'ValueLabel'
})((0, $gfPc7.default)(({ theme: theme })=>({
        zIndex: 1,
        whiteSpace: 'nowrap',
        ...theme.typography.body2,
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${(0, $gCZmy.default).valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${(0, $gCZmy.default).valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    })));
const $6e8371d23529ed50$export$6f85f6a3c5da6f62 = (0, $l0oRz.default)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, $52dC4.default)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    })));
const $6e8371d23529ed50$export$e6cd369965e5aa95 = (0, $l0oRz.default)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, $52dC4.default)(prop) && prop !== 'markLabelActive'
})((0, $gfPc7.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    })));
const $6e8371d23529ed50$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, $krx4P.default)(color)}`,
            size && `size${(0, $krx4P.default)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, $krx4P.default)(size)}`,
            color && `thumbColor${(0, $krx4P.default)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $gCZmy.getSliderUtilityClass), classes);
};
const $6e8371d23529ed50$var$Forward = ({ children: children })=>children;
const $6e8371d23529ed50$var$Slider = /*#__PURE__*/ $bh6RR.forwardRef(function Slider(inputProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, $am2yJ.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = 'span', components: components = {}, componentsProps: componentsProps = {}, color: color = 'primary', classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', shiftStep: shiftStep = 10, size: size = 'medium', step: step = 1, scale: scale = $6e8371d23529ed50$var$Identity, slotProps: slotProps, slots: slots, tabIndex: tabIndex, track: track = 'normal', value: valueProp, valueLabelDisplay: valueLabelDisplay = 'off', valueLabelFormat: valueLabelFormat = $6e8371d23529ed50$var$Identity, ...other } = props;
    const ownerState = {
        ...props,
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        shiftStep: shiftStep,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    };
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $5Htn0.useSlider)({
        ...ownerState,
        rootRef: ref
    });
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $6e8371d23529ed50$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = slots?.root ?? components.Root ?? $6e8371d23529ed50$export$c1a21b3b4da66aa1;
    const RailSlot = slots?.rail ?? components.Rail ?? $6e8371d23529ed50$export$b02fde61a3559c2;
    const TrackSlot = slots?.track ?? components.Track ?? $6e8371d23529ed50$export$105594979f116971;
    const ThumbSlot = slots?.thumb ?? components.Thumb ?? $6e8371d23529ed50$export$2c1b491743890dec;
    const ValueLabelSlot = slots?.valueLabel ?? components.ValueLabel ?? $6e8371d23529ed50$export$6453176f504d54f0;
    const MarkSlot = slots?.mark ?? components.Mark ?? $6e8371d23529ed50$export$6f85f6a3c5da6f62;
    const MarkLabelSlot = slots?.markLabel ?? components.MarkLabel ?? $6e8371d23529ed50$export$e6cd369965e5aa95;
    const InputSlot = slots?.input ?? components.Input ?? 'input';
    const rootSlotProps = slotProps?.root ?? componentsProps.root;
    const railSlotProps = slotProps?.rail ?? componentsProps.rail;
    const trackSlotProps = slotProps?.track ?? componentsProps.track;
    const thumbSlotProps = slotProps?.thumb ?? componentsProps.thumb;
    const valueLabelSlotProps = slotProps?.valueLabel ?? componentsProps.valueLabel;
    const markSlotProps = slotProps?.mark ?? componentsProps.mark;
    const markLabelSlotProps = slotProps?.markLabel ?? componentsProps.markLabel;
    const inputSlotProps = slotProps?.input ?? componentsProps.input;
    const rootProps = (0, $l0eKO.default)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ...(0, $c088I.default)(RootSlot) && {
                as: component
            }
        },
        ownerState: {
            ...ownerState,
            ...rootSlotProps?.ownerState
        },
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $l0eKO.default)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $l0eKO.default)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: {
                ...axisProps[axis].offset(trackOffset),
                ...axisProps[axis].leap(trackLeap)
            }
        },
        ownerState: {
            ...ownerState,
            ...trackSlotProps?.ownerState
        },
        className: classes.track
    });
    const thumbProps = (0, $l0eKO.default)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: {
            ...ownerState,
            ...thumbSlotProps?.ownerState
        },
        className: classes.thumb
    });
    const valueLabelProps = (0, $l0eKO.default)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: {
            ...ownerState,
            ...valueLabelSlotProps?.ownerState
        },
        className: classes.valueLabel
    });
    const markProps = (0, $l0eKO.default)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $l0eKO.default)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $l0eKO.default)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)(RailSlot, {
                ...railProps
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)(TrackSlot, {
                ...trackProps
            }),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $5Htn0.valueToPercent)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.includes(mark.value);
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)(MarkSlot, {
                            "data-index": index,
                            ...markProps,
                            ...!(0, $g0K0l.default)(MarkSlot) && {
                                markActive: markActive
                            },
                            style: {
                                ...style,
                                ...markProps.style
                            },
                            className: (0, $aPsoC.default)(markProps.className, markActive && classes.markActive)
                        }),
                        mark.label != null ? /*#__PURE__*/ (0, $ih19M.jsx)(MarkLabelSlot, {
                            "aria-hidden": true,
                            "data-index": index,
                            ...markLabelProps,
                            ...!(0, $g0K0l.default)(MarkLabelSlot) && {
                                markLabelActive: markActive
                            },
                            style: {
                                ...style,
                                ...markLabelProps.style
                            },
                            className: (0, $aPsoC.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        }) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $5Htn0.valueToPercent)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? $6e8371d23529ed50$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $ih19M.jsx)(ValueLabelComponent, {
                    ...!(0, $g0K0l.default)(ValueLabelComponent) && {
                        valueLabelFormat: valueLabelFormat,
                        valueLabelDisplay: valueLabelDisplay,
                        value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                        index: index,
                        open: open === index || active === index || valueLabelDisplay === 'on',
                        disabled: disabled
                    },
                    ...valueLabelProps,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)(ThumbSlot, {
                        "data-index": index,
                        ...thumbProps,
                        className: (0, $aPsoC.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: {
                            ...style,
                            ...getThumbStyle(index),
                            ...thumbProps.style
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)(InputSlot, {
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index],
                            ...inputSliderProps
                        })
                    })
                }, index);
            })
        ]
    });
});
var $6e8371d23529ed50$export$2e2bcd8739ae039 = $6e8371d23529ed50$var$Slider;

});
parcelRegister("5Htn0", function(module, exports) {

$parcel$export(module.exports, "valueToPercent", function () { return $4267c02afc339284$export$83ce4bc8280540e6; });
$parcel$export(module.exports, "useSlider", function () { return $4267c02afc339284$export$56b2c08e277f365; });

var $bh6RR = parcelRequire("bh6RR");

var $8HMMM = parcelRequire("8HMMM");

var $d1JqZ = parcelRequire("d1JqZ");

var $kLukk = parcelRequire("kLukk");

var $87bEd = parcelRequire("87bEd");

var $6RXey = parcelRequire("6RXey");

var $25zti = parcelRequire("25zti");

var $bXdZI = parcelRequire("bXdZI");

var $8fhtc = parcelRequire("8fhtc");

var $jmq8q = parcelRequire("jmq8q");

var $9WL8k = parcelRequire("9WL8k");
'use client';
const $4267c02afc339284$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $4267c02afc339284$var$getNewValue(currentValue, step, direction, min, max) {
    return direction === 1 ? Math.min(currentValue + step, max) : Math.max(currentValue - step, min);
}
function $4267c02afc339284$var$asc(a, b) {
    return a - b;
}
function $4267c02afc339284$var$findClosest(values, currentValue) {
    const { index: closestIndex } = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null) ?? {};
    return closestIndex;
}
function $4267c02afc339284$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $4267c02afc339284$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $4267c02afc339284$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $4267c02afc339284$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $4267c02afc339284$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($4267c02afc339284$var$getDecimalPrecision(step)));
}
function $4267c02afc339284$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($4267c02afc339284$var$asc);
}
function $4267c02afc339284$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    const doc = (0, $8HMMM.default)(sliderRef.current);
    if (!sliderRef.current?.contains(doc.activeElement) || Number(doc?.activeElement?.getAttribute('data-index')) !== activeIndex) sliderRef.current?.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    if (setActive) setActive(activeIndex);
}
function $4267c02afc339284$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, $9WL8k.default)(newValue, oldValue);
    return false;
}
const $4267c02afc339284$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $4267c02afc339284$export$544bf02140fa9a77 = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $4267c02afc339284$var$cachedSupportsTouchActionNone;
function $4267c02afc339284$var$doesSupportTouchActionNone() {
    if ($4267c02afc339284$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') $4267c02afc339284$var$cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else $4267c02afc339284$var$cachedSupportsTouchActionNone = true;
    }
    return $4267c02afc339284$var$cachedSupportsTouchActionNone;
}
function $4267c02afc339284$export$56b2c08e277f365(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', rootRef: ref, scale: scale = $4267c02afc339284$export$544bf02140fa9a77, step: step = 1, shiftStep: shiftStep = 10, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $bh6RR.useRef(undefined);
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $bh6RR.useState(-1);
    const [open, setOpen] = $bh6RR.useState(-1);
    const [dragging, setDragging] = $bh6RR.useState(false);
    const moveCount = $bh6RR.useRef(0);
    // lastChangedValue is updated whenever onChange is triggered.
    const lastChangedValue = $bh6RR.useRef(null);
    const [valueDerived, setValueState] = (0, $d1JqZ.default)({
        controlled: valueProp,
        default: defaultValue ?? min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        lastChangedValue.current = value;
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($4267c02afc339284$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, $8fhtc.default)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const [focusedThumbIndex, setFocusedThumbIndex] = $bh6RR.useState(-1);
    const sliderRef = $bh6RR.useRef(null);
    const handleRef = (0, $6RXey.default)(ref, sliderRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            const index = Number(event.currentTarget.getAttribute('data-index'));
            if ((0, $25zti.default)(event.target)) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers?.onFocus?.(event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            if (!(0, $25zti.default)(event.target)) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers?.onBlur?.(event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue >= maxMarksValue) newValue = maxMarksValue;
            else if (newValue <= marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, $8fhtc.default)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $8fhtc.default)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = $4267c02afc339284$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            $4267c02afc339284$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !$4267c02afc339284$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, lastChangedValue.current ?? newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            if ([
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight',
                'PageUp',
                'PageDown',
                'Home',
                'End'
            ].includes(event.key)) {
                event.preventDefault();
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                // Keys actions that change the value by more than the most granular `step`
                // value are only applied if the step not `null`.
                // When step is `null`, the `marks` prop is used instead to define valid values.
                if (step != null) {
                    const stepSize = event.shiftKey ? shiftStep : step;
                    switch(event.key){
                        case 'ArrowUp':
                            newValue = $4267c02afc339284$var$getNewValue(value, stepSize, 1, min, max);
                            break;
                        case 'ArrowRight':
                            newValue = $4267c02afc339284$var$getNewValue(value, stepSize, isRtl ? -1 : 1, min, max);
                            break;
                        case 'ArrowDown':
                            newValue = $4267c02afc339284$var$getNewValue(value, stepSize, -1, min, max);
                            break;
                        case 'ArrowLeft':
                            newValue = $4267c02afc339284$var$getNewValue(value, stepSize, isRtl ? 1 : -1, min, max);
                            break;
                        case 'PageUp':
                            newValue = $4267c02afc339284$var$getNewValue(value, shiftStep, 1, min, max);
                            break;
                        case 'PageDown':
                            newValue = $4267c02afc339284$var$getNewValue(value, shiftStep, -1, min, max);
                            break;
                        case 'Home':
                            newValue = min;
                            break;
                        case 'End':
                            newValue = max;
                            break;
                        default:
                            break;
                    }
                } else if (marks) {
                    const maxMarksValue = marksValues[marksValues.length - 1];
                    const currentMarkIndex = marksValues.indexOf(value);
                    const decrementKeys = [
                        isRtl ? 'ArrowRight' : 'ArrowLeft',
                        'ArrowDown',
                        'PageDown',
                        'Home'
                    ];
                    const incrementKeys = [
                        isRtl ? 'ArrowLeft' : 'ArrowRight',
                        'ArrowUp',
                        'PageUp',
                        'End'
                    ];
                    if (decrementKeys.includes(event.key)) {
                        if (currentMarkIndex === 0) newValue = marksValues[0];
                        else newValue = marksValues[currentMarkIndex - 1];
                    } else if (incrementKeys.includes(event.key)) {
                        if (currentMarkIndex === marksValues.length - 1) newValue = maxMarksValue;
                        else newValue = marksValues[currentMarkIndex + 1];
                    }
                }
                if (newValue != null) changeValue(event, newValue);
            }
            otherHandlers?.onKeyDown?.(event);
        };
    (0, $kLukk.default)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) // This is necessary because Firefox and Safari will keep focus
        // on a disabled element:
        // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
        // @ts-ignore
        document.activeElement?.blur();
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            otherHandlers.onChange?.(event);
            // this handles value change by Pointer or Touch events
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = $bh6RR.useRef(undefined);
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.startsWith('vertical')) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.includes('-reverse')) percent = 1 - percent;
        let newValue;
        newValue = $4267c02afc339284$var$percentToValue(percent, min, max);
        if (step) newValue = $4267c02afc339284$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $4267c02afc339284$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $8fhtc.default)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $4267c02afc339284$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $8fhtc.default)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $4267c02afc339284$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $87bEd.default)((nativeEvent)=>{
        const finger = $4267c02afc339284$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $4267c02afc339284$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $4267c02afc339284$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$4267c02afc339284$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $87bEd.default)((nativeEvent)=>{
        const finger = $4267c02afc339284$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, lastChangedValue.current ?? newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $87bEd.default)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$4267c02afc339284$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $4267c02afc339284$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $4267c02afc339284$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$4267c02afc339284$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $8HMMM.default)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $bh6RR.useCallback(()=>{
        const doc = (0, $8HMMM.default)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $bh6RR.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: $4267c02afc339284$var$doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $bh6RR.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseDown?.(event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $4267c02afc339284$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $4267c02afc339284$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$4267c02afc339284$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $8HMMM.default)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = $4267c02afc339284$export$83ce4bc8280540e6(range ? values[0] : min, min, max);
    const trackLeap = $4267c02afc339284$export$83ce4bc8280540e6(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $jmq8q.default)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            ...externalProps,
            ref: handleRef,
            ...mergedEventHandlers
        };
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseOver?.(event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseLeave?.(event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $jmq8q.default)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return {
            ...externalProps,
            ...externalHandlers,
            ...ownEventHandlers
        };
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    let cssWritingMode;
    if (orientation === 'vertical') cssWritingMode = isRtl ? 'vertical-rl' : 'vertical-lr';
    const getHiddenInputProps = (externalProps = {})=>{
        const externalHandlers = (0, $jmq8q.default)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            tabIndex: tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name: name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : parameters.step ?? undefined,
            disabled: disabled,
            ...externalProps,
            ...mergedEventHandlers,
            style: {
                ...(0, $bXdZI.default),
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%',
                writingMode: cssWritingMode
            }
        };
    };
    return {
        active: active,
        axis: axis,
        axisProps: $4267c02afc339284$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}

});
parcelRegister("9WL8k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73de1786d3ffb2e8$export$2e2bcd8739ae039; });
function $73de1786d3ffb2e8$var$areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var $73de1786d3ffb2e8$export$2e2bcd8739ae039 = $73de1786d3ffb2e8$var$areArraysEqual;

});


parcelRegister("c088I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bcbcc7a1e3b28c5$export$2e2bcd8739ae039; });

var $g0K0l = parcelRequire("g0K0l");
const $8bcbcc7a1e3b28c5$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $g0K0l.default)(Slot);
};
var $8bcbcc7a1e3b28c5$export$2e2bcd8739ae039 = $8bcbcc7a1e3b28c5$var$shouldSpreadAdditionalProps;

});

parcelRegister("ayIxk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7affa068e918ac62$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $gCZmy = parcelRequire("gCZmy");

var $ih19M = parcelRequire("ih19M");
'use client';
const $7affa068e918ac62$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $aPsoC.default)(open && (0, $gCZmy.default).valueLabelOpen),
        circle: (0, $gCZmy.default).valueLabelCircle,
        label: (0, $gCZmy.default).valueLabelLabel
    };
    return utilityClasses;
};
function $7affa068e918ac62$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $7affa068e918ac62$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $bh6RR.cloneElement(children, {
        className: children.props.className
    }, /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: (0, $aPsoC.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}

});
parcelRegister("gCZmy", function(module, exports) {

$parcel$export(module.exports, "getSliderUtilityClass", function () { return $c1afcb527dfdb9c0$export$9f59f2622d5cbc2a; });
$parcel$export(module.exports, "default", function () { return $c1afcb527dfdb9c0$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $c1afcb527dfdb9c0$export$9f59f2622d5cbc2a(slot) {
    return (0, $dmzXD.default)('MuiSlider', slot);
}
const $c1afcb527dfdb9c0$var$sliderClasses = (0, $fYlYP.default)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $c1afcb527dfdb9c0$export$2e2bcd8739ae039 = $c1afcb527dfdb9c0$var$sliderClasses;

});



parcelRegister("5ZUrR", function(module, exports) {

$parcel$export(module.exports, "downloadCard", function () { return $5796a73d7e2b1f5e$export$9535e0448e7d51c0; });
$parcel$export(module.exports, "canShareRecap", function () { return $5796a73d7e2b1f5e$export$40e85f9bae893008; });
$parcel$export(module.exports, "canShareCustomPhoto", function () { return $5796a73d7e2b1f5e$export$6d8234366e262928; });
$parcel$export(module.exports, "shareRecap", function () { return $5796a73d7e2b1f5e$export$3e5c00b8eea2ade1; });

var $1lMle = parcelRequire("1lMle");

var $3oWVD = parcelRequire("3oWVD");
/** The apps refuse anything longer, so a bigger card isn't sent. */ const $5796a73d7e2b1f5e$var$MAX_BRIDGE_IMAGE_CHARS = 4000000;
function $5796a73d7e2b1f5e$var$isAbort(e) {
    return e instanceof DOMException && e.name === "AbortError";
}
function $5796a73d7e2b1f5e$var$isNotAllowed(e) {
    return e instanceof DOMException && e.name === "NotAllowedError";
}
function $5796a73d7e2b1f5e$export$9535e0448e7d51c0(image, fileName) {
    const href = URL.createObjectURL(image);
    const a = document.createElement("a");
    a.href = href;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(()=>URL.revokeObjectURL(href), 10000);
}
/**
 * Whether the page is inside one of the Volley apps, old builds included:
 * every iOS app build registers a message handler on its web view, and the
 * Android app replaces the web view's user agent with its own. An iOS web
 * view with no "Safari" in its user agent counts too, since another app's
 * in-app browser can't be told from an app build that predates both.
 */ function $5796a73d7e2b1f5e$var$inVolleyApp() {
    if (window.webkit?.messageHandlers || window.ReactNativeWebView) return true;
    const ua = navigator.userAgent;
    return ua.includes("GetVolley") || (0, $3oWVD.default)() && !ua.includes("Safari/");
}
function $5796a73d7e2b1f5e$export$40e85f9bae893008() {
    return !$5796a73d7e2b1f5e$var$inVolleyApp() || window.volleyShareCapabilities?.shareImage === true;
}
function $5796a73d7e2b1f5e$export$6d8234366e262928() {
    const canDraw = typeof createImageBitmap === "function" && typeof HTMLCanvasElement.prototype.toBlob === "function";
    if (window.volleyShareCapabilities?.customPhoto === true) return canDraw;
    return !$5796a73d7e2b1f5e$var$inVolleyApp() && canDraw;
}
function $5796a73d7e2b1f5e$var$base64(image) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>resolve(String(reader.result).replace(/^data:[^,]*,/, ""));
        reader.onerror = ()=>reject(reader.error);
        reader.readAsDataURL(image);
    });
}
/** The card for an app's bridge, or null when it's too big to send. */ async function $5796a73d7e2b1f5e$var$bridgeImage(image) {
    const imageData = await $5796a73d7e2b1f5e$var$base64(image);
    if (imageData.length <= $5796a73d7e2b1f5e$var$MAX_BRIDGE_IMAGE_CHARS) return imageData;
    (0, $1lMle.default).error(`Recap card too big for the app bridge: ${imageData.length} chars`);
    return null;
}
async function $5796a73d7e2b1f5e$export$3e5c00b8eea2ade1(payload) {
    const ios = window.webkit?.messageHandlers?.volleyShare;
    const rn = window.volleyShareCapabilities?.shareImage === true ? window.ReactNativeWebView : undefined;
    const imageData = ios || rn ? await $5796a73d7e2b1f5e$var$bridgeImage(payload.image) : null;
    if (ios && imageData) try {
        await ios.postMessage({
            text: payload.text,
            imageData: imageData,
            fileName: payload.fileName
        });
        return {
            status: "handed_off",
            surface: "ios"
        };
    } catch (e) {
        // The app refused it, so no sheet is coming: share from the page.
        (0, $1lMle.default).error(`iOS share bridge refused the recap: ${String(e)}`);
    }
    if (rn && imageData) {
        // No reply comes back: the app says so itself if it can't share.
        rn.postMessage(JSON.stringify({
            type: "volley.share",
            text: payload.text,
            imageData: imageData,
            fileName: payload.fileName
        }));
        return {
            status: "handed_off",
            surface: "rn"
        };
    }
    const file = new File([
        payload.image
    ], payload.fileName, {
        type: payload.image.type || "image/png"
    });
    const data = {
        files: [
            file
        ],
        text: payload.text
    };
    if (typeof navigator.share === "function" && navigator.canShare?.(data)) return $5796a73d7e2b1f5e$var$webShare(data);
    return {
        status: "no_share_sheet"
    };
}
async function $5796a73d7e2b1f5e$var$webShare(data) {
    const surface = "web_files";
    try {
        await navigator.share(data);
        return {
            status: "shared",
            surface: surface
        };
    } catch (e) {
        if ($5796a73d7e2b1f5e$var$isAbort(e)) return {
            status: "cancelled",
            surface: surface
        };
        if ($5796a73d7e2b1f5e$var$isNotAllowed(e)) return {
            status: "needs_gesture"
        };
        const reason = e instanceof Error ? e.name : String(e);
        (0, $1lMle.default).error(`navigator.share failed: ${reason}: ${String(e)}`);
        return {
            status: "failed",
            reason: reason
        };
    }
}

});
parcelRegister("3oWVD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $909ae77701e2dbd6$export$2e2bcd8739ae039; });
function $909ae77701e2dbd6$export$2e2bcd8739ae039() {
    return [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod"
    ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}

});


parcelRegister("b3r65", function(module, exports) {

$parcel$export(module.exports, "SESSION_RECAP_FEATURE", function () { return $3439a847eef9ac91$export$f4a5c0c2ff70ebba; });
/**
 * The feature that turns Session Recap on for a member. Mirrors
 * SESSION_RECAP_FEATURE in @volley/data, which the browser bundle can't import
 * a value from without pulling in all of it.
 */ const $3439a847eef9ac91$export$f4a5c0c2ff70ebba = "SESSION_RECAP";

});

parcelRegister("hpaXv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cabd45ad47f94ca5$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $cabd45ad47f94ca5$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');

});

parcelRegister("jJOx9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5e96b36de09f105$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $e5e96b36de09f105$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 5V2L8 6l4 4V7c3.31 0 6 2.69 6 6 0 2.97-2.17 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93 0-4.42-3.58-8-8-8m-6 8c0-1.65.67-3.15 1.76-4.24L6.34 7.34C4.9 8.79 4 10.79 4 13c0 4.08 3.05 7.44 7 7.93v-2.02c-2.83-.48-5-2.94-5-5.91"
}), 'RestartAlt');

});

parcelRegister("islu0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6fb819b2ac93802$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $d6fb819b2ac93802$export$2e2bcd8739ae039 = (0, $fWXJ7.default)([
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M11 14c0-3.36 2.64-6 6-6 2.2 0 4.08 1.13 5.13 2.86L24 8.98C20.93 5.9 16.69 4 12 4S3.07 5.9 0 8.98L12 21l1.86-1.87C12.14 18.09 11 16.2 11 14"
    }, "0"),
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M21 14c0-2.24-1.76-4-4-4s-4 1.76-4 4 1.76 4 4 4c.75 0 1.44-.21 2.03-.56L21.59 20 23 18.59l-2.56-2.56c.35-.59.56-1.28.56-2.03m-6 0c0-1.12.88-2 2-2s2 .88 2 2-.88 2-2 2-2-.88-2-2"
    }, "1")
], 'WifiFind');

});

parcelRegister("1hRK9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f01114d299b10f3$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");



var $96ZcP = parcelRequire("96ZcP");

var $1xW7E = parcelRequire("1xW7E");

var $gAAjb = parcelRequire("gAAjb");

var $dU9vv = parcelRequire("dU9vv");

var $4Athc = parcelRequire("4Athc");

var $4rInl = parcelRequire("4rInl");

var $95FNu = parcelRequire("95FNu");

var $9K13D = parcelRequire("9K13D");

var $auhFG = parcelRequire("auhFG");

var $2mXTA = parcelRequire("2mXTA");

var $dMXQH = parcelRequire("dMXQH");

var $54kMp = parcelRequire("54kMp");

var $98F34 = parcelRequire("98F34");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $aGJXR = parcelRequire("aGJXR");

var $krx4P = parcelRequire("krx4P");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
var $0f01114d299b10f3$var$_ClearIcon, $0f01114d299b10f3$var$_ArrowDropDownIcon;
const $0f01114d299b10f3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $krx4P.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $aGJXR.getAutocompleteUtilityClass), classes);
};
const $0f01114d299b10f3$var$AutocompleteRoot = (0, $l0oRz.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $aGJXR.default).tag}`]: styles.tag
            },
            {
                [`& .${(0, $aGJXR.default).tag}`]: styles[`tagSize${(0, $krx4P.default)(size)}`]
            },
            {
                [`& .${(0, $aGJXR.default).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $aGJXR.default).input}`]: styles.input
            },
            {
                [`& .${(0, $aGJXR.default).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $aGJXR.default).focused} .${(0, $aGJXR.default).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $aGJXR.default).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $aGJXR.default).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $aGJXR.default).inputRoot}`]: {
        [`.${(0, $aGJXR.default).hasPopupIcon}&, .${(0, $aGJXR.default).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $aGJXR.default).hasPopupIcon}.${(0, $aGJXR.default).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $aGJXR.default).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $9K13D.default).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $9K13D.default).root}.${(0, $auhFG.default).sizeSmall}`]: {
        [`& .${(0, $9K13D.default).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $2mXTA.default).root}`]: {
        padding: 9,
        [`.${(0, $aGJXR.default).hasPopupIcon}&, .${(0, $aGJXR.default).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $aGJXR.default).hasPopupIcon}.${(0, $aGJXR.default).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $aGJXR.default).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $aGJXR.default).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $2mXTA.default).root}.${(0, $auhFG.default).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $aGJXR.default).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $dMXQH.default).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $aGJXR.default).hasPopupIcon}&, .${(0, $aGJXR.default).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $aGJXR.default).hasPopupIcon}.${(0, $aGJXR.default).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $dMXQH.default).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $aGJXR.default).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $dMXQH.default).root}.${(0, $auhFG.default).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $dMXQH.default).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $auhFG.default).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $dMXQH.default).root}.${(0, $auhFG.default).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $aGJXR.default).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $dMXQH.default).root}.${(0, $auhFG.default).hiddenLabel}.${(0, $auhFG.default).sizeSmall}`]: {
        [`& .${(0, $aGJXR.default).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $aGJXR.default).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $aGJXR.default).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $aGJXR.default).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $aGJXR.default).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $0f01114d299b10f3$var$AutocompleteEndAdornment = (0, $l0oRz.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment'
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $0f01114d299b10f3$var$AutocompleteClearIndicator = (0, $l0oRz.default)((0, $4rInl.default), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator'
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $0f01114d299b10f3$var$AutocompletePopupIndicator = (0, $l0oRz.default)((0, $4rInl.default), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popupIndicator,
            ownerState.popupOpen && styles.popupIndicatorOpen
        ];
    }
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $0f01114d299b10f3$var$AutocompletePopper = (0, $l0oRz.default)((0, $gAAjb.default), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $aGJXR.default).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    })));
const $0f01114d299b10f3$var$AutocompletePaper = (0, $l0oRz.default)((0, $4Athc.default), {
    name: 'MuiAutocomplete',
    slot: 'Paper'
})((0, $gfPc7.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        overflow: 'auto'
    })));
const $0f01114d299b10f3$var$AutocompleteLoading = (0, $l0oRz.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading'
})((0, $gfPc7.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $0f01114d299b10f3$var$AutocompleteNoOptions = (0, $l0oRz.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions'
})((0, $gfPc7.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $0f01114d299b10f3$var$AutocompleteListbox = (0, $l0oRz.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'Listbox'
})((0, $gfPc7.default)(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $aGJXR.default).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $aGJXR.default).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $aGJXR.default).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
                [`&.${(0, $aGJXR.default).focused}`]: {
                    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $aGJXR.default).focusVisible}`]: {
                    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                }
            }
        }
    })));
const $0f01114d299b10f3$var$AutocompleteGroupLabel = (0, $l0oRz.default)((0, $dU9vv.default), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel'
})((0, $gfPc7.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    })));
const $0f01114d299b10f3$var$AutocompleteGroupUl = (0, $l0oRz.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl'
})({
    padding: 0,
    [`& .${(0, $aGJXR.default).option}`]: {
        paddingLeft: 24
    }
});
const $0f01114d299b10f3$var$Autocomplete = /*#__PURE__*/ $bh6RR.forwardRef(function Autocomplete(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipPropsProp, className: className, clearIcon: clearIcon = $0f01114d299b10f3$var$_ClearIcon || ($0f01114d299b10f3$var$_ClearIcon = /*#__PURE__*/ (0, $ih19M.jsx)((0, $54kMp.default), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterOptions: filterOptions, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp, isOptionEqualToValue: isOptionEqualToValue, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, limitTags: limitTags = -1, ListboxComponent: ListboxComponentProp, ListboxProps: ListboxPropsProp, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: open, openOnFocus: openOnFocus = false, openText: openText = 'Open', options: options, PaperComponent: PaperComponentProp, PopperComponent: PopperComponentProp, popupIcon: popupIcon = $0f01114d299b10f3$var$_ArrowDropDownIcon || ($0f01114d299b10f3$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $ih19M.jsx)((0, $98F34.default), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, renderValue: renderValue, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slots: slots = {}, slotProps: slotProps = {}, value: valueProp, ...other } = props;
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getItemProps: getItemProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedItem: focusedItem, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $1xW7E.default)({
        ...props,
        componentName: 'Autocomplete'
    });
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: listboxRef, ...otherListboxProps } = getListboxProps();
    const defaultGetOptionLabel = (option)=>option.label ?? option;
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = {
        ...props,
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedItem === -1,
        popupOpen: popupOpen,
        size: size
    };
    const classes = $0f01114d299b10f3$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            paper: PaperComponentProp,
            popper: PopperComponentProp,
            ...slots
        },
        slotProps: {
            chip: ChipPropsProp,
            listbox: ListboxPropsProp,
            ...componentsProps,
            ...slotProps
        }
    };
    const [ListboxSlot, listboxProps] = (0, $dFvJW.default)('listbox', {
        elementType: $0f01114d299b10f3$var$AutocompleteListbox,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.listbox,
        additionalProps: otherListboxProps,
        ref: listboxRef
    });
    const [PaperSlot, paperProps] = (0, $dFvJW.default)('paper', {
        elementType: (0, $4Athc.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.paper
    });
    const [PopperSlot, popperProps] = (0, $dFvJW.default)('popper', {
        elementType: (0, $gAAjb.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.popper,
        additionalProps: {
            disablePortal: disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null
            },
            role: 'presentation',
            anchorEl: anchorEl,
            open: popupOpen
        }
    });
    let startAdornment;
    const getCustomizedItemProps = (params)=>({
            className: classes.tag,
            disabled: disabled,
            ...getItemProps(params)
        });
    if (multiple) {
        if (value.length > 0) {
            if (renderTags) startAdornment = renderTags(value, getCustomizedItemProps, ownerState);
            else if (renderValue) startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
            else startAdornment = value.map((option, index)=>{
                const { key: key, ...customItemProps } = getCustomizedItemProps({
                    index: index
                });
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $95FNu.default), {
                    label: getOptionLabel(option),
                    size: size,
                    ...customItemProps,
                    ...externalForwardedProps.slotProps.chip
                }, key);
            });
        }
    } else if (renderValue && value != null) startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $ih19M.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)($0f01114d299b10f3$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)($0f01114d299b10f3$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key, ...otherProps } = props2;
        return /*#__PURE__*/ (0, $ih19M.jsx)("li", {
            ...otherProps,
            children: getOptionLabel(option)
        }, key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption({
            ...optionProps,
            className: classes.option
        }, option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = externalForwardedProps.slotProps.clearIndicator;
    const popupIndicatorSlotProps = externalForwardedProps.slotProps.popupIndicator;
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($0f01114d299b10f3$var$AutocompleteRoot, {
                ref: ref,
                className: (0, $aPsoC.default)(classes.root, className),
                ownerState: ownerState,
                ...getRootProps(other),
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: {
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onMouseDown: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        },
                        ...(hasClearIcon || hasPopupIcon) && {
                            endAdornment: /*#__PURE__*/ (0, $ih19M.jsxs)($0f01114d299b10f3$var$AutocompleteEndAdornment, {
                                className: classes.endAdornment,
                                ownerState: ownerState,
                                children: [
                                    hasClearIcon ? /*#__PURE__*/ (0, $ih19M.jsx)($0f01114d299b10f3$var$AutocompleteClearIndicator, {
                                        ...getClearProps(),
                                        "aria-label": clearText,
                                        title: clearText,
                                        ownerState: ownerState,
                                        ...clearIndicatorSlotProps,
                                        className: (0, $aPsoC.default)(classes.clearIndicator, clearIndicatorSlotProps?.className),
                                        children: clearIcon
                                    }) : null,
                                    hasPopupIcon ? /*#__PURE__*/ (0, $ih19M.jsx)($0f01114d299b10f3$var$AutocompletePopupIndicator, {
                                        ...getPopupIndicatorProps(),
                                        disabled: disabled,
                                        "aria-label": popupOpen ? closeText : openText,
                                        title: popupOpen ? closeText : openText,
                                        ownerState: ownerState,
                                        ...popupIndicatorSlotProps,
                                        className: (0, $aPsoC.default)(classes.popupIndicator, popupIndicatorSlotProps?.className),
                                        children: popupIcon
                                    }) : null
                                ]
                            })
                        }
                    },
                    inputProps: {
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly,
                        ...getInputProps()
                    }
                })
            }),
            anchorEl ? /*#__PURE__*/ (0, $ih19M.jsx)($0f01114d299b10f3$var$AutocompletePopper, {
                as: PopperSlot,
                ...popperProps,
                children: /*#__PURE__*/ (0, $ih19M.jsxs)($0f01114d299b10f3$var$AutocompletePaper, {
                    as: PaperSlot,
                    ...paperProps,
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $ih19M.jsx)($0f01114d299b10f3$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $ih19M.jsx)($0f01114d299b10f3$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $ih19M.jsx)(ListboxSlot, {
                            as: ListboxComponentProp,
                            ...listboxProps,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        }) : null
                    ]
                })
            }) : null
        ]
    });
});
var $0f01114d299b10f3$export$2e2bcd8739ae039 = $0f01114d299b10f3$var$Autocomplete;

});
parcelRegister("1xW7E", function(module, exports) {

$parcel$export(module.exports, "createFilterOptions", function () { return $1205f56b0e935b64$export$f76f94b238d946d8; });
$parcel$export(module.exports, "default", function () { return $1205f56b0e935b64$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $faL5S = parcelRequire("faL5S");

var $87bEd = parcelRequire("87bEd");

var $d1JqZ = parcelRequire("d1JqZ");

var $dDKx6 = parcelRequire("dDKx6");

var $ktROk = parcelRequire("ktROk");
'use client';
function $1205f56b0e935b64$var$areArraysSame({ array1: array1, array2: array2, parser: parser = (value)=>value }) {
    return array1 && array2 && array1.length === array2.length && array1.every((prevOption, index)=>parser(prevOption) === parser(array2[index]));
}
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
function $1205f56b0e935b64$var$stripDiacritics(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function $1205f56b0e935b64$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $1205f56b0e935b64$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $1205f56b0e935b64$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.startsWith(input) : candidate.includes(input);
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
const $1205f56b0e935b64$var$defaultFilterOptions = $1205f56b0e935b64$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $1205f56b0e935b64$var$pageSize = 5;
const $1205f56b0e935b64$var$defaultIsActiveElementInListbox = (listboxRef)=>listboxRef.current !== null && listboxRef.current.parentElement?.contains(document.activeElement);
const $1205f56b0e935b64$var$MULTIPLE_DEFAULT_VALUE = [];
function $1205f56b0e935b64$var$getInputValue(value, multiple, getOptionLabel, renderValue) {
    if (multiple || value == null || renderValue) return '';
    const optionLabel = getOptionLabel(value);
    return typeof optionLabel === 'string' ? optionLabel : '';
}
function $1205f56b0e935b64$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $1205f56b0e935b64$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $1205f56b0e935b64$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $1205f56b0e935b64$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>option.label ?? option, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, renderValue: renderValue, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $dDKx6.default)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $bh6RR.useRef(false);
    const firstFocus = $bh6RR.useRef(true);
    const inputRef = $bh6RR.useRef(null);
    const listboxRef = $bh6RR.useRef(null);
    const [anchorEl, setAnchorEl] = $bh6RR.useState(null);
    const [focusedItem, setFocusedItem] = $bh6RR.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $bh6RR.useRef(defaultHighlighted);
    // Calculate the initial inputValue on mount only.
    // useRef ensures it doesn't update dynamically with defaultValue or value props.
    const initialInputValue = $bh6RR.useRef($1205f56b0e935b64$var$getInputValue(defaultValue ?? valueProp, multiple, getOptionLabel)).current;
    const [value, setValueState] = (0, $d1JqZ.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $d1JqZ.default)({
        controlled: inputValueProp,
        default: initialInputValue,
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $bh6RR.useState(false);
    const resetInputValue = $bh6RR.useCallback((event, newValue, reason)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        const newInputValue = $1205f56b0e935b64$var$getInputValue(newValue, multiple, getOptionLabel, renderValue);
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, reason);
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value,
        renderValue
    ]);
    const [open, setOpenState] = (0, $d1JqZ.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $bh6RR.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $ktROk.default)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $bh6RR.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value, 'reset');
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusItem = (0, $87bEd.default)((itemToFocus)=>{
        if (itemToFocus === -1) inputRef.current.focus();
        else {
            // Using `data-tag-index` for deprecated `renderTags`. Remove when `renderTags` is gone.
            const indexType = renderValue ? 'data-item-index' : 'data-tag-index';
            anchorEl.querySelector(`[${indexType}="${itemToFocus}"]`).focus();
        }
    });
    // Ensure the focusedItem is never inconsistent
    $bh6RR.useEffect(()=>{
        if (multiple && focusedItem > value.length - 1) {
            setFocusedItem(-1);
            focusItem(-1);
        }
    }, [
        value,
        multiple,
        focusedItem,
        focusItem
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $87bEd.default)(({ event: event, index: index, reason: reason })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange && [
            'mouse',
            'keyboard',
            'touch'
        ].includes(reason)) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $87bEd.default)(({ event: event, diff: diff, direction: direction = 'next', reason: reason })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const filteredOptionsChanged = !$1205f56b0e935b64$var$areArraysSame({
        array1: previousProps.filteredOptions,
        array2: filteredOptions,
        parser: getOptionLabel
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && !$1205f56b0e935b64$var$areArraysSame({
            array1: previousProps.filteredOptions,
            array2: filteredOptions,
            parser: getOptionLabel
        }) && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return filteredOptions.findIndex((option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $bh6RR.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && value.findIndex((val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = filteredOptions.findIndex((optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $87bEd.default)((node)=>{
        (0, $faL5S.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $bh6RR.useEffect(()=>{
        if (filteredOptionsChanged || popupOpen) syncHighlightedIndex();
    }, [
        syncHighlightedIndex,
        filteredOptionsChanged,
        popupOpen
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $bh6RR.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = newValue.findIndex((valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue, reason);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validItemIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            // Using `data-tag-index` for deprecated `renderTags`. Remove when `renderTags` is removed.
            const indexType = renderValue ? 'data-item-index' : 'data-tag-index';
            const option = anchorEl.querySelector(`[${indexType}="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusItem = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextItem = focusedItem;
        if (focusedItem === -1) {
            if (inputValue === '' && direction === 'previous') nextItem = value.length - 1;
        } else {
            nextItem += direction === 'next' ? 1 : -1;
            if (nextItem < 0) nextItem = 0;
            if (nextItem === value.length) nextItem = -1;
        }
        nextItem = validItemIndex(nextItem, direction);
        setFocusedItem(nextItem);
        focusItem(nextItem);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedItem !== -1 && ![
                'ArrowLeft',
                'ArrowRight'
            ].includes(event.key)) {
                setFocusedItem(-1);
                focusItem(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$1205f56b0e935b64$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $1205f56b0e935b64$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    if (!multiple && renderValue) focusItem(0);
                    else handleFocusItem(event, 'previous');
                    break;
                case 'ArrowRight':
                    if (!multiple && renderValue) focusItem(-1);
                    else handleFocusItem(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0 || renderValue)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedItem === -1 ? value.length - 1 : focusedItem;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    if (!multiple && renderValue && !readOnly) {
                        setValueState(null);
                        focusItem(-1);
                    }
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedItem !== -1) {
                        const index = focusedItem;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    if (!multiple && renderValue && !readOnly) {
                        setValueState(null);
                        focusItem(-1);
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value, 'blur');
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleItemDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handleSingleItemDelete = (event)=>{
        handleValue(event, null, 'removeOption', {
            option: value
        });
    };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>({
                ...other,
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getItemProps: ({ index: index = 0 } = {})=>({
                ...multiple && {
                    key: index
                },
                ...renderValue ? {
                    'data-item-index': index
                } : {
                    'data-tag-index': index
                },
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: multiple ? handleItemDelete(index) : handleSingleItemDelete
                }
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        // deprecated
        getTagProps: ({ index: index })=>({
                key: index,
                'data-tag-index': index,
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: handleItemDelete(index)
                }
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionKey?.(option) ?? getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedItem !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedItem: focusedItem,
        // deprecated
        focusedTag: focusedItem,
        groupedOptions: groupedOptions
    };
}
var $1205f56b0e935b64$export$2e2bcd8739ae039 = $1205f56b0e935b64$var$useAutocomplete;

});
parcelRegister("ktROk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee9041c1a3600091$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
function $ee9041c1a3600091$var$usePreviousProps(value) {
    const ref = $bh6RR.useRef({});
    $bh6RR.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
}
var $ee9041c1a3600091$export$2e2bcd8739ae039 = $ee9041c1a3600091$var$usePreviousProps;

});


parcelRegister("gAAjb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c13c2c37b5d9ab9c$export$2e2bcd8739ae039; });

var $am2yJ = parcelRequire("am2yJ");




var $bh6RR = parcelRequire("bh6RR");

var $5GbnD = parcelRequire("5GbnD");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $ih19M = parcelRequire("ih19M");
'use client';
const $c13c2c37b5d9ab9c$var$PopperRoot = (0, $l0oRz.default)((0, $5GbnD.default), {
    name: 'MuiPopper',
    slot: 'Root'
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $c13c2c37b5d9ab9c$var$Popper = /*#__PURE__*/ $bh6RR.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, $am2yJ.useRtl)();
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps, ...other } = props;
    const RootComponent = slots?.root ?? components?.Root;
    const otherProps = {
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition,
        ...other
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)($c13c2c37b5d9ab9c$var$PopperRoot, {
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: {
            root: RootComponent
        },
        slotProps: slotProps ?? componentsProps,
        ...otherProps,
        ref: ref
    });
});
var $c13c2c37b5d9ab9c$export$2e2bcd8739ae039 = $c13c2c37b5d9ab9c$var$Popper;

});
parcelRegister("5GbnD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4229b3ddb741663f$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $8HMMM = parcelRequire("8HMMM");

var $kLukk = parcelRequire("kLukk");

var $6RXey = parcelRequire("6RXey");




var $fZq58 = parcelRequire("fZq58");


var $96ZcP = parcelRequire("96ZcP");

var $l0eKO = parcelRequire("l0eKO");

var $g3ngr = parcelRequire("g3ngr");

var $dCGVL = parcelRequire("dCGVL");

var $ih19M = parcelRequire("ih19M");
'use client';
function $4229b3ddb741663f$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $4229b3ddb741663f$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $4229b3ddb741663f$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $4229b3ddb741663f$var$isVirtualElement(element) {
    return !$4229b3ddb741663f$var$isHTMLElement(element);
}
const $4229b3ddb741663f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $dCGVL.getPopperUtilityClass), classes);
};
const $4229b3ddb741663f$var$defaultPopperOptions = {};
const $4229b3ddb741663f$var$PopperTooltip = /*#__PURE__*/ $bh6RR.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = $bh6RR.useRef(null);
    const ownRef = (0, $6RXey.default)(tooltipRef, forwardedRef);
    const popperRef = $bh6RR.useRef(null);
    const handlePopperRef = (0, $6RXey.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $bh6RR.useRef(handlePopperRef);
    (0, $kLukk.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $bh6RR.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $4229b3ddb741663f$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $bh6RR.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $bh6RR.useState($4229b3ddb741663f$var$resolveAnchorEl(anchorEl));
    $bh6RR.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $bh6RR.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($4229b3ddb741663f$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $kLukk.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $fZq58.createPopper)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $4229b3ddb741663f$var$useUtilityClasses(props);
    const Root = slots.root ?? 'div';
    const rootProps = (0, $l0eKO.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)(Root, {
        ...rootProps,
        children: typeof children === 'function' ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const $4229b3ddb741663f$var$Popper = /*#__PURE__*/ $bh6RR.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $4229b3ddb741663f$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const [exited, setExited] = $bh6RR.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $4229b3ddb741663f$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $4229b3ddb741663f$var$isHTMLElement(resolvedAnchorEl) ? (0, $8HMMM.default)(resolvedAnchorEl).body : (0, $8HMMM.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $g3ngr.default), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($4229b3ddb741663f$var$PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
var $4229b3ddb741663f$export$2e2bcd8739ae039 = $4229b3ddb741663f$var$Popper;

});
parcelRegister("fZq58", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $ba40c8d2bf74e5cd$export$8f7491d57c8f97a9; });

var $fTJao = parcelRequire("fTJao");

var $745n9 = parcelRequire("745n9");

var $4mt2C = parcelRequire("4mt2C");

var $2SszJ = parcelRequire("2SszJ");

var $5KdgE = parcelRequire("5KdgE");

var $eqE9J = parcelRequire("eqE9J");

var $5QuYB = parcelRequire("5QuYB");

var $fVANH = parcelRequire("fVANH");

var $7HVwH = parcelRequire("7HVwH");

var $9bSGP = parcelRequire("9bSGP");


var $ba40c8d2bf74e5cd$export$d34966752335dd47 = [
    (0, $745n9.default),
    (0, $4mt2C.default),
    (0, $2SszJ.default),
    (0, $5KdgE.default),
    (0, $eqE9J.default),
    (0, $5QuYB.default),
    (0, $fVANH.default),
    (0, $7HVwH.default),
    (0, $9bSGP.default)
];
var $ba40c8d2bf74e5cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $fTJao.popperGenerator)({
    defaultModifiers: $ba40c8d2bf74e5cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("fTJao", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $b92f073993d3fb52$export$ed5e13716264f202; });

var $2HKsI = parcelRequire("2HKsI");

var $7oVdA = parcelRequire("7oVdA");

var $iJYQU = parcelRequire("iJYQU");

var $aI24A = parcelRequire("aI24A");

var $2J8Wv = parcelRequire("2J8Wv");

var $1hlpY = parcelRequire("1hlpY");

var $jvpLE = parcelRequire("jvpLE");


var $1c9xk = parcelRequire("1c9xk");
var $b92f073993d3fb52$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b92f073993d3fb52$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b92f073993d3fb52$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b92f073993d3fb52$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b92f073993d3fb52$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $1c9xk.isElement)(reference) ? (0, $iJYQU.default)(reference) : reference.contextElement ? (0, $iJYQU.default)(reference.contextElement) : [],
                    popper: (0, $iJYQU.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $2J8Wv.default)((0, $jvpLE.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b92f073993d3fb52$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $2HKsI.default)(reference, (0, $aI24A.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $7oVdA.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $1hlpY.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b92f073993d3fb52$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b92f073993d3fb52$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b92f073993d3fb52$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("2HKsI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f83a3590a58ca81$export$2e2bcd8739ae039; });

var $bsh7Q = parcelRequire("bsh7Q");

var $arVrm = parcelRequire("arVrm");

var $a72Qo = parcelRequire("a72Qo");

var $1c9xk = parcelRequire("1c9xk");

var $2vFiA = parcelRequire("2vFiA");

var $oVXMR = parcelRequire("oVXMR");

var $juuAX = parcelRequire("juuAX");

var $cQirN = parcelRequire("cQirN");
function $1f83a3590a58ca81$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $cQirN.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $cQirN.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1f83a3590a58ca81$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $1c9xk.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $1c9xk.isHTMLElement)(offsetParent) && $1f83a3590a58ca81$var$isElementScaled(offsetParent);
    var documentElement = (0, $oVXMR.default)(offsetParent);
    var rect = (0, $bsh7Q.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $a72Qo.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $juuAX.default)(documentElement)) scroll = (0, $arVrm.default)(offsetParent);
        if ((0, $1c9xk.isHTMLElement)(offsetParent)) {
            offsets = (0, $bsh7Q.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $2vFiA.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("bsh7Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $856f97fdf7a31786$export$2e2bcd8739ae039; });

var $1c9xk = parcelRequire("1c9xk");

var $cQirN = parcelRequire("cQirN");

var $fWtCY = parcelRequire("fWtCY");

var $f2h41 = parcelRequire("f2h41");
function $856f97fdf7a31786$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $1c9xk.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $cQirN.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $cQirN.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $1c9xk.isElement)(element) ? (0, $fWtCY.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $f2h41.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("1c9xk", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $0dee4f2dddb22277$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $0dee4f2dddb22277$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $0dee4f2dddb22277$export$af51f0f06c0f328a; });

var $fWtCY = parcelRequire("fWtCY");
function $0dee4f2dddb22277$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $fWtCY.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $0dee4f2dddb22277$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $fWtCY.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $0dee4f2dddb22277$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $fWtCY.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("fWtCY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9b3413274c87e21$export$2e2bcd8739ae039; });
function $b9b3413274c87e21$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("cQirN", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $9598a69d154bbd1e$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $9598a69d154bbd1e$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $9598a69d154bbd1e$export$2077e0241d6afd3c; });
var $9598a69d154bbd1e$export$8960430cfd85939f = Math.max;
var $9598a69d154bbd1e$export$96ec731ed4dcb222 = Math.min;
var $9598a69d154bbd1e$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("f2h41", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af244778ac85956c$export$2e2bcd8739ae039; });

var $eFBAH = parcelRequire("eFBAH");
function $af244778ac85956c$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $eFBAH.default)());
}

});
parcelRegister("eFBAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aae20dd24c8de568$export$2e2bcd8739ae039; });
function $aae20dd24c8de568$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("arVrm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01f698b37b56f293$export$2e2bcd8739ae039; });

var $6uoC5 = parcelRequire("6uoC5");

var $fWtCY = parcelRequire("fWtCY");

var $1c9xk = parcelRequire("1c9xk");

var $ea8tK = parcelRequire("ea8tK");
function $01f698b37b56f293$export$2e2bcd8739ae039(node) {
    if (node === (0, $fWtCY.default)(node) || !(0, $1c9xk.isHTMLElement)(node)) return (0, $6uoC5.default)(node);
    else return (0, $ea8tK.default)(node);
}

});
parcelRegister("6uoC5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b98a3172bacf8ec$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");
function $4b98a3172bacf8ec$export$2e2bcd8739ae039(node) {
    var win = (0, $fWtCY.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ea8tK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4f89398deb81d5a$export$2e2bcd8739ae039; });
function $a4f89398deb81d5a$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("a72Qo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75ccc39d2a806d7f$export$2e2bcd8739ae039; });
function $75ccc39d2a806d7f$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("2vFiA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d3e8317bca2b13b$export$2e2bcd8739ae039; });

var $bsh7Q = parcelRequire("bsh7Q");

var $oVXMR = parcelRequire("oVXMR");

var $6uoC5 = parcelRequire("6uoC5");
function $1d3e8317bca2b13b$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $bsh7Q.default)((0, $oVXMR.default)(element)).left + (0, $6uoC5.default)(element).scrollLeft;
}

});
parcelRegister("oVXMR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04af344fb3b2461e$export$2e2bcd8739ae039; });

var $1c9xk = parcelRequire("1c9xk");
function $04af344fb3b2461e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $1c9xk.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("juuAX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3088d3b293d3951$export$2e2bcd8739ae039; });

var $2L33g = parcelRequire("2L33g");
function $e3088d3b293d3951$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $2L33g.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("2L33g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $202256889fb084f4$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");
function $202256889fb084f4$export$2e2bcd8739ae039(element) {
    return (0, $fWtCY.default)(element).getComputedStyle(element);
}

});



parcelRegister("7oVdA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $563728a12da0f86b$export$2e2bcd8739ae039; });

var $bsh7Q = parcelRequire("bsh7Q");
function $563728a12da0f86b$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $bsh7Q.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("iJYQU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da4ba1ff29e25ddd$export$2e2bcd8739ae039; });

var $l4kGm = parcelRequire("l4kGm");

var $aSiof = parcelRequire("aSiof");

var $fWtCY = parcelRequire("fWtCY");

var $juuAX = parcelRequire("juuAX");
function $da4ba1ff29e25ddd$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $l4kGm.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $fWtCY.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $juuAX.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($da4ba1ff29e25ddd$export$2e2bcd8739ae039((0, $aSiof.default)(target)));
}

});
parcelRegister("l4kGm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f56a03bea423dc7d$export$2e2bcd8739ae039; });

var $aSiof = parcelRequire("aSiof");

var $juuAX = parcelRequire("juuAX");

var $a72Qo = parcelRequire("a72Qo");

var $1c9xk = parcelRequire("1c9xk");
function $f56a03bea423dc7d$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $a72Qo.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $1c9xk.isHTMLElement)(node) && (0, $juuAX.default)(node)) return node;
    return $f56a03bea423dc7d$export$2e2bcd8739ae039((0, $aSiof.default)(node));
}

});
parcelRegister("aSiof", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ead366da1fe435a$export$2e2bcd8739ae039; });

var $a72Qo = parcelRequire("a72Qo");

var $oVXMR = parcelRequire("oVXMR");

var $1c9xk = parcelRequire("1c9xk");
function $7ead366da1fe435a$export$2e2bcd8739ae039(element) {
    if ((0, $a72Qo.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $1c9xk.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $oVXMR.default)(element) // fallback
    );
}

});



parcelRegister("aI24A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cbf9f1a43b4b54b$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");

var $a72Qo = parcelRequire("a72Qo");

var $2L33g = parcelRequire("2L33g");

var $1c9xk = parcelRequire("1c9xk");

var $bJ3lS = parcelRequire("bJ3lS");

var $aSiof = parcelRequire("aSiof");

var $eFBAH = parcelRequire("eFBAH");
function $7cbf9f1a43b4b54b$var$getTrueOffsetParent(element) {
    if (!(0, $1c9xk.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $2L33g.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $7cbf9f1a43b4b54b$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $eFBAH.default)());
    var isIE = /Trident/i.test((0, $eFBAH.default)());
    if (isIE && (0, $1c9xk.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $2L33g.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $aSiof.default)(element);
    if ((0, $1c9xk.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $1c9xk.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $a72Qo.default)(currentNode)) < 0){
        var css = (0, $2L33g.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $7cbf9f1a43b4b54b$export$2e2bcd8739ae039(element) {
    var window = (0, $fWtCY.default)(element);
    var offsetParent = $7cbf9f1a43b4b54b$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $bJ3lS.default)(offsetParent) && (0, $2L33g.default)(offsetParent).position === 'static')offsetParent = $7cbf9f1a43b4b54b$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $a72Qo.default)(offsetParent) === 'html' || (0, $a72Qo.default)(offsetParent) === 'body' && (0, $2L33g.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $7cbf9f1a43b4b54b$var$getContainingBlock(element) || window;
}

});
parcelRegister("bJ3lS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88967f4bf6e216d4$export$2e2bcd8739ae039; });

var $a72Qo = parcelRequire("a72Qo");
function $88967f4bf6e216d4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $a72Qo.default)(element)) >= 0;
}

});


parcelRegister("2J8Wv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fc6b88d850995f4$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");
function $1fc6b88d850995f4$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $1fc6b88d850995f4$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $1fc6b88d850995f4$var$order(modifiers); // order based on phase
    return (0, $5juCh.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("5juCh", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $3de679e4868fd918$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $3de679e4868fd918$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $3de679e4868fd918$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $3de679e4868fd918$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $3de679e4868fd918$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $3de679e4868fd918$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $3de679e4868fd918$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $3de679e4868fd918$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $3de679e4868fd918$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $3de679e4868fd918$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $3de679e4868fd918$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $3de679e4868fd918$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $3de679e4868fd918$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $3de679e4868fd918$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $3de679e4868fd918$export$d087d3878fdf71d5; });
var $3de679e4868fd918$export$1e95b668f3b82d = 'top';
var $3de679e4868fd918$export$40e543e69a8b3fbb = 'bottom';
var $3de679e4868fd918$export$79ffe56a765070d2 = 'right';
var $3de679e4868fd918$export$eabcd2c8791e7bf4 = 'left';
var $3de679e4868fd918$export$dfb5619354ba860 = 'auto';
var $3de679e4868fd918$export$aec2ce47c367b8c3 = [
    $3de679e4868fd918$export$1e95b668f3b82d,
    $3de679e4868fd918$export$40e543e69a8b3fbb,
    $3de679e4868fd918$export$79ffe56a765070d2,
    $3de679e4868fd918$export$eabcd2c8791e7bf4
];
var $3de679e4868fd918$export$b3571188c770cc5a = 'start';
var $3de679e4868fd918$export$bd5df0f255a350f8 = 'end';
var $3de679e4868fd918$export$390fd549c5303b4d = 'clippingParents';
var $3de679e4868fd918$export$d7b7311ec04a3e8f = 'viewport';
var $3de679e4868fd918$export$ae5ab1c730825774 = 'popper';
var $3de679e4868fd918$export$ca50aac9f3ba507f = 'reference';
var $3de679e4868fd918$export$368f9a87e87fa4e1 = /*#__PURE__*/ $3de679e4868fd918$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $3de679e4868fd918$export$b3571188c770cc5a,
        placement + "-" + $3de679e4868fd918$export$bd5df0f255a350f8
    ]);
}, []);
var $3de679e4868fd918$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($3de679e4868fd918$export$aec2ce47c367b8c3, [
    $3de679e4868fd918$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $3de679e4868fd918$export$b3571188c770cc5a,
        placement + "-" + $3de679e4868fd918$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $3de679e4868fd918$export$421679a7c3d56e = 'beforeRead';
var $3de679e4868fd918$export$aafa59e2e03f2942 = 'read';
var $3de679e4868fd918$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $3de679e4868fd918$export$c65e99957a05207c = 'beforeMain';
var $3de679e4868fd918$export$f22da7240b7add18 = 'main';
var $3de679e4868fd918$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $3de679e4868fd918$export$8d4d2d70e7d46032 = 'beforeWrite';
var $3de679e4868fd918$export$68d8715fc104d294 = 'write';
var $3de679e4868fd918$export$70a6e5159acce2e6 = 'afterWrite';
var $3de679e4868fd918$export$d087d3878fdf71d5 = [
    $3de679e4868fd918$export$421679a7c3d56e,
    $3de679e4868fd918$export$aafa59e2e03f2942,
    $3de679e4868fd918$export$6964f6c886723980,
    $3de679e4868fd918$export$c65e99957a05207c,
    $3de679e4868fd918$export$f22da7240b7add18,
    $3de679e4868fd918$export$bab79516f2d662fe,
    $3de679e4868fd918$export$8d4d2d70e7d46032,
    $3de679e4868fd918$export$68d8715fc104d294,
    $3de679e4868fd918$export$70a6e5159acce2e6
];

});


parcelRegister("1hlpY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ee7fe20308229e3$export$2e2bcd8739ae039; });
function $0ee7fe20308229e3$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("jvpLE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e334e679a8da4fd2$export$2e2bcd8739ae039; });
function $e334e679a8da4fd2$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("745n9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $524d12f5e3f410b7$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");
var $524d12f5e3f410b7$var$passive = {
    passive: true
};
function $524d12f5e3f410b7$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $fWtCY.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $524d12f5e3f410b7$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $524d12f5e3f410b7$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $524d12f5e3f410b7$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $524d12f5e3f410b7$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $524d12f5e3f410b7$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $524d12f5e3f410b7$var$effect,
    data: {}
};

});

parcelRegister("4mt2C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32cfbe7d0e900a5d$export$2e2bcd8739ae039; });

var $h8FhS = parcelRequire("h8FhS");
function $32cfbe7d0e900a5d$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $h8FhS.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $32cfbe7d0e900a5d$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $32cfbe7d0e900a5d$var$popperOffsets,
    data: {}
};

});
parcelRegister("h8FhS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7a335ce8d6c7e22$export$2e2bcd8739ae039; });

var $7HOne = parcelRequire("7HOne");

var $a9b5p = parcelRequire("a9b5p");

var $5JvSi = parcelRequire("5JvSi");

var $5juCh = parcelRequire("5juCh");
function $c7a335ce8d6c7e22$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $7HOne.default)(placement) : null;
    var variation = placement ? (0, $a9b5p.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $5juCh.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $5juCh.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $5juCh.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $5juCh.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $5JvSi.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $5juCh.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $5juCh.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("7HOne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59c39fbf33d0fa38$export$2e2bcd8739ae039; });

function $59c39fbf33d0fa38$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("a9b5p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $763358296bc7f0da$export$2e2bcd8739ae039; });
function $763358296bc7f0da$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("5JvSi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42c9e163adb38c23$export$2e2bcd8739ae039; });
function $42c9e163adb38c23$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("2SszJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2186ca614d1914c5$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $aI24A = parcelRequire("aI24A");

var $fWtCY = parcelRequire("fWtCY");

var $oVXMR = parcelRequire("oVXMR");

var $2L33g = parcelRequire("2L33g");

var $7HOne = parcelRequire("7HOne");

var $a9b5p = parcelRequire("a9b5p");

var $cQirN = parcelRequire("cQirN");
var $2186ca614d1914c5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $2186ca614d1914c5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $cQirN.round)(x * dpr) / dpr || 0,
        y: (0, $cQirN.round)(y * dpr) / dpr || 0
    };
}
function $2186ca614d1914c5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $5juCh.left);
    var sideY = (0, $5juCh.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $aI24A.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $fWtCY.default)(popper)) {
            offsetParent = (0, $oVXMR.default)(popper);
            if ((0, $2L33g.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $5juCh.top) || (placement === (0, $5juCh.left) || placement === (0, $5juCh.right)) && variation === (0, $5juCh.end)) {
            sideY = (0, $5juCh.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $5juCh.left) || (placement === (0, $5juCh.top) || placement === (0, $5juCh.bottom)) && variation === (0, $5juCh.end)) {
            sideX = (0, $5juCh.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $2186ca614d1914c5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $2186ca614d1914c5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $fWtCY.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $2186ca614d1914c5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $7HOne.default)(state.placement),
        variation: (0, $a9b5p.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $2186ca614d1914c5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $2186ca614d1914c5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $2186ca614d1914c5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $2186ca614d1914c5$var$computeStyles,
    data: {}
};

});

parcelRegister("5KdgE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42eb8a49ca42db39$export$2e2bcd8739ae039; });

var $a72Qo = parcelRequire("a72Qo");

var $1c9xk = parcelRequire("1c9xk");
// and applies them to the HTMLElements such as popper and arrow
function $42eb8a49ca42db39$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $1c9xk.isHTMLElement)(element) || !(0, $a72Qo.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $42eb8a49ca42db39$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $1c9xk.isHTMLElement)(element) || !(0, $a72Qo.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $42eb8a49ca42db39$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $42eb8a49ca42db39$var$applyStyles,
    effect: $42eb8a49ca42db39$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("eqE9J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a812a48e30738572$export$2e2bcd8739ae039; });

var $7HOne = parcelRequire("7HOne");

var $5juCh = parcelRequire("5juCh");
function $a812a48e30738572$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $7HOne.default)(placement);
    var invertDistance = [
        (0, $5juCh.left),
        (0, $5juCh.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $5juCh.left),
        (0, $5juCh.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a812a48e30738572$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $5juCh.placements).reduce(function(acc, placement) {
        acc[placement] = $a812a48e30738572$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a812a48e30738572$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $a812a48e30738572$var$offset
};

});

parcelRegister("5QuYB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4419d659c5aee896$export$2e2bcd8739ae039; });

var $1rXBE = parcelRequire("1rXBE");

var $7HOne = parcelRequire("7HOne");

var $3PXal = parcelRequire("3PXal");

var $5uUmA = parcelRequire("5uUmA");

var $cPMZw = parcelRequire("cPMZw");

var $5juCh = parcelRequire("5juCh");

var $a9b5p = parcelRequire("a9b5p");
function $4419d659c5aee896$var$getExpandedFallbackPlacements(placement) {
    if ((0, $7HOne.default)(placement) === (0, $5juCh.auto)) return [];
    var oppositePlacement = (0, $1rXBE.default)(placement);
    return [
        (0, $3PXal.default)(placement),
        oppositePlacement,
        (0, $3PXal.default)(oppositePlacement)
    ];
}
function $4419d659c5aee896$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $7HOne.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $1rXBE.default)(preferredPlacement)
    ] : $4419d659c5aee896$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $7HOne.default)(placement) === (0, $5juCh.auto) ? (0, $cPMZw.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $7HOne.default)(placement);
        var isStartVariation = (0, $a9b5p.default)(placement) === (0, $5juCh.start);
        var isVertical = [
            (0, $5juCh.top),
            (0, $5juCh.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $5uUmA.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $5juCh.right) : (0, $5juCh.left) : isStartVariation ? (0, $5juCh.bottom) : (0, $5juCh.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $1rXBE.default)(mainVariationSide);
        var altVariationSide = (0, $1rXBE.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4419d659c5aee896$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $4419d659c5aee896$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("1rXBE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10e68ca32d71e128$export$2e2bcd8739ae039; });
var $10e68ca32d71e128$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $10e68ca32d71e128$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $10e68ca32d71e128$var$hash[matched];
    });
}

});

parcelRegister("3PXal", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cb407a558844daa$export$2e2bcd8739ae039; });
var $2cb407a558844daa$var$hash = {
    start: 'end',
    end: 'start'
};
function $2cb407a558844daa$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $2cb407a558844daa$var$hash[matched];
    });
}

});

parcelRegister("5uUmA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $400b79aa76081eef$export$2e2bcd8739ae039; });

var $i1jxU = parcelRequire("i1jxU");

var $oVXMR = parcelRequire("oVXMR");

var $bsh7Q = parcelRequire("bsh7Q");

var $h8FhS = parcelRequire("h8FhS");

var $jWjgS = parcelRequire("jWjgS");

var $5juCh = parcelRequire("5juCh");

var $1c9xk = parcelRequire("1c9xk");

var $cg2ZW = parcelRequire("cg2ZW");

var $aSXwy = parcelRequire("aSXwy");
function $400b79aa76081eef$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $5juCh.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $5juCh.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $5juCh.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $cg2ZW.default)(typeof padding !== 'number' ? padding : (0, $aSXwy.default)(padding, (0, $5juCh.basePlacements)));
    var altContext = elementContext === (0, $5juCh.popper) ? (0, $5juCh.reference) : (0, $5juCh.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $i1jxU.default)((0, $1c9xk.isElement)(element) ? element : element.contextElement || (0, $oVXMR.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $bsh7Q.default)(state.elements.reference);
    var popperOffsets = (0, $h8FhS.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $jWjgS.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $5juCh.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $5juCh.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $5juCh.right),
                (0, $5juCh.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $5juCh.top),
                (0, $5juCh.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("i1jxU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1e77b65493ae185$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $43VfI = parcelRequire("43VfI");

var $1xbC0 = parcelRequire("1xbC0");

var $iJYQU = parcelRequire("iJYQU");

var $aI24A = parcelRequire("aI24A");

var $oVXMR = parcelRequire("oVXMR");

var $2L33g = parcelRequire("2L33g");

var $1c9xk = parcelRequire("1c9xk");

var $bsh7Q = parcelRequire("bsh7Q");

var $aSiof = parcelRequire("aSiof");

var $jFWJP = parcelRequire("jFWJP");

var $a72Qo = parcelRequire("a72Qo");

var $jWjgS = parcelRequire("jWjgS");

var $cQirN = parcelRequire("cQirN");
function $d1e77b65493ae185$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $bsh7Q.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $d1e77b65493ae185$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $5juCh.viewport) ? (0, $jWjgS.default)((0, $43VfI.default)(element, strategy)) : (0, $1c9xk.isElement)(clippingParent) ? $d1e77b65493ae185$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $jWjgS.default)((0, $1xbC0.default)((0, $oVXMR.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $d1e77b65493ae185$var$getClippingParents(element) {
    var clippingParents = (0, $iJYQU.default)((0, $aSiof.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $2L33g.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $1c9xk.isHTMLElement)(element) ? (0, $aI24A.default)(element) : element;
    if (!(0, $1c9xk.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $1c9xk.isElement)(clippingParent) && (0, $jFWJP.default)(clippingParent, clipperElement) && (0, $a72Qo.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $d1e77b65493ae185$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $d1e77b65493ae185$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $d1e77b65493ae185$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $cQirN.max)(rect.top, accRect.top);
        accRect.right = (0, $cQirN.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cQirN.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cQirN.max)(rect.left, accRect.left);
        return accRect;
    }, $d1e77b65493ae185$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("43VfI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f53da607b3746be$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");

var $oVXMR = parcelRequire("oVXMR");

var $2vFiA = parcelRequire("2vFiA");

var $f2h41 = parcelRequire("f2h41");
function $2f53da607b3746be$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $fWtCY.default)(element);
    var html = (0, $oVXMR.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $f2h41.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $2vFiA.default)(element),
        y: y
    };
}

});

parcelRegister("1xbC0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11e1e16d619599d0$export$2e2bcd8739ae039; });

var $oVXMR = parcelRequire("oVXMR");

var $2L33g = parcelRequire("2L33g");

var $2vFiA = parcelRequire("2vFiA");

var $6uoC5 = parcelRequire("6uoC5");

var $cQirN = parcelRequire("cQirN");
function $11e1e16d619599d0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $oVXMR.default)(element);
    var winScroll = (0, $6uoC5.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $cQirN.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $cQirN.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $2vFiA.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $2L33g.default)(body || html).direction === 'rtl') x += (0, $cQirN.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("jFWJP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e52f68d10ea05d88$export$2e2bcd8739ae039; });

var $1c9xk = parcelRequire("1c9xk");
function $e52f68d10ea05d88$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $1c9xk.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("jWjgS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e84261f8276e3310$export$2e2bcd8739ae039; });
function $e84261f8276e3310$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("cg2ZW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ec94e005bd060d7$export$2e2bcd8739ae039; });

var $kGFu9 = parcelRequire("kGFu9");
function $8ec94e005bd060d7$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $kGFu9.default)(), paddingObject);
}

});
parcelRegister("kGFu9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0f7e8fd5f6df53a$export$2e2bcd8739ae039; });
function $f0f7e8fd5f6df53a$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("aSXwy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ecd1ec68ebe7fbd$export$2e2bcd8739ae039; });
function $7ecd1ec68ebe7fbd$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cPMZw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $958040209c61c1c6$export$2e2bcd8739ae039; });

var $a9b5p = parcelRequire("a9b5p");

var $5juCh = parcelRequire("5juCh");

var $5uUmA = parcelRequire("5uUmA");

var $7HOne = parcelRequire("7HOne");
function $958040209c61c1c6$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $5juCh.placements) : _options$allowedAutoP;
    var variation = (0, $a9b5p.default)(placement);
    var placements = variation ? flipVariations ? (0, $5juCh.variationPlacements) : (0, $5juCh.variationPlacements).filter(function(placement) {
        return (0, $a9b5p.default)(placement) === variation;
    }) : (0, $5juCh.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $5uUmA.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $7HOne.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("fVANH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b988b9b26e42e386$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $7HOne = parcelRequire("7HOne");

var $5JvSi = parcelRequire("5JvSi");

var $6Eqmz = parcelRequire("6Eqmz");

var $16lvl = parcelRequire("16lvl");

var $7oVdA = parcelRequire("7oVdA");

var $aI24A = parcelRequire("aI24A");

var $5uUmA = parcelRequire("5uUmA");

var $a9b5p = parcelRequire("a9b5p");

var $kGFu9 = parcelRequire("kGFu9");

var $cQirN = parcelRequire("cQirN");
function $b988b9b26e42e386$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $5uUmA.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $7HOne.default)(state.placement);
    var variation = (0, $a9b5p.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $5JvSi.default)(basePlacement);
    var altAxis = (0, $6Eqmz.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $5juCh.top) : (0, $5juCh.left);
        var altSide = mainAxis === 'y' ? (0, $5juCh.bottom) : (0, $5juCh.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $5juCh.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $5juCh.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $7oVdA.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $kGFu9.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $16lvl.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $aI24A.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $16lvl.within)(tether ? (0, $cQirN.min)(min, tetherMin) : min, offset, tether ? (0, $cQirN.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $5juCh.top) : (0, $5juCh.left);
        var _altSide = mainAxis === 'x' ? (0, $5juCh.bottom) : (0, $5juCh.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $5juCh.top),
            (0, $5juCh.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $16lvl.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $16lvl.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b988b9b26e42e386$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $b988b9b26e42e386$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("6Eqmz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d7aeda2d1cf8bc0$export$2e2bcd8739ae039; });
function $4d7aeda2d1cf8bc0$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("16lvl", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $0cd708593435dba4$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $0cd708593435dba4$export$86c8af6d3ef0b4a; });

var $cQirN = parcelRequire("cQirN");
function $0cd708593435dba4$export$f28d906d67a997f3(min, value, max) {
    return (0, $cQirN.max)(min, (0, $cQirN.min)(value, max));
}
function $0cd708593435dba4$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $0cd708593435dba4$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("7HVwH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59c92c1fc46a893e$export$2e2bcd8739ae039; });

var $7HOne = parcelRequire("7HOne");

var $7oVdA = parcelRequire("7oVdA");

var $jFWJP = parcelRequire("jFWJP");

var $aI24A = parcelRequire("aI24A");

var $5JvSi = parcelRequire("5JvSi");

var $16lvl = parcelRequire("16lvl");

var $cg2ZW = parcelRequire("cg2ZW");

var $aSXwy = parcelRequire("aSXwy");

var $5juCh = parcelRequire("5juCh");
var $59c92c1fc46a893e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $cg2ZW.default)(typeof padding !== 'number' ? padding : (0, $aSXwy.default)(padding, (0, $5juCh.basePlacements)));
};
function $59c92c1fc46a893e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $7HOne.default)(state.placement);
    var axis = (0, $5JvSi.default)(basePlacement);
    var isVertical = [
        (0, $5juCh.left),
        (0, $5juCh.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $59c92c1fc46a893e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $7oVdA.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $5juCh.top) : (0, $5juCh.left);
    var maxProp = axis === 'y' ? (0, $5juCh.bottom) : (0, $5juCh.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $aI24A.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $16lvl.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $59c92c1fc46a893e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $jFWJP.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $59c92c1fc46a893e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $59c92c1fc46a893e$var$arrow,
    effect: $59c92c1fc46a893e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("9bSGP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b0f9068ca75a57d$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $5uUmA = parcelRequire("5uUmA");
function $6b0f9068ca75a57d$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $6b0f9068ca75a57d$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $5juCh.top),
        (0, $5juCh.right),
        (0, $5juCh.bottom),
        (0, $5juCh.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $6b0f9068ca75a57d$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $5uUmA.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $5uUmA.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $6b0f9068ca75a57d$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $6b0f9068ca75a57d$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $6b0f9068ca75a57d$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $6b0f9068ca75a57d$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $6b0f9068ca75a57d$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $6b0f9068ca75a57d$var$hide
};

});


parcelRegister("dCGVL", function(module, exports) {

$parcel$export(module.exports, "getPopperUtilityClass", function () { return $9eb02017cd784ab8$export$1b69b6cd0fa638a1; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $9eb02017cd784ab8$export$1b69b6cd0fa638a1(slot) {
    return (0, $dmzXD.default)('MuiPopper', slot);
}
const $9eb02017cd784ab8$var$popperClasses = (0, $fYlYP.default)('MuiPopper', [
    'root'
]);
var $9eb02017cd784ab8$export$2e2bcd8739ae039 = $9eb02017cd784ab8$var$popperClasses;

});



parcelRegister("dU9vv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1f7e13a21cda24d$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $krx4P = parcelRequire("krx4P");

var $6KxuP = parcelRequire("6KxuP");

var $ih19M = parcelRequire("ih19M");
'use client';
const $a1f7e13a21cda24d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $krx4P.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $6KxuP.getListSubheaderUtilityClass), classes);
};
const $a1f7e13a21cda24d$var$ListSubheaderRoot = (0, $l0oRz.default)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $krx4P.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14),
        variants: [
            {
                props: {
                    color: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.inset,
                style: {
                    paddingLeft: 72
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableSticky,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    backgroundColor: (theme.vars || theme).palette.background.paper
                }
            }
        ]
    })));
const $a1f7e13a21cda24d$var$ListSubheader = /*#__PURE__*/ $bh6RR.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    };
    const classes = $a1f7e13a21cda24d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($a1f7e13a21cda24d$var$ListSubheaderRoot, {
        as: component,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
if ($a1f7e13a21cda24d$var$ListSubheader) $a1f7e13a21cda24d$var$ListSubheader.muiSkipListHighlight = true;
var $a1f7e13a21cda24d$export$2e2bcd8739ae039 = $a1f7e13a21cda24d$var$ListSubheader;

});
parcelRegister("6KxuP", function(module, exports) {

$parcel$export(module.exports, "getListSubheaderUtilityClass", function () { return $4ea1059bfc047cda$export$6816d4fc0981ec7; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $4ea1059bfc047cda$export$6816d4fc0981ec7(slot) {
    return (0, $dmzXD.default)('MuiListSubheader', slot);
}
const $4ea1059bfc047cda$var$listSubheaderClasses = (0, $fYlYP.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $4ea1059bfc047cda$export$2e2bcd8739ae039 = $4ea1059bfc047cda$var$listSubheaderClasses;

});


parcelRegister("aGJXR", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteUtilityClass", function () { return $7c817b358ad093b8$export$8ee01529667e66d9; });
$parcel$export(module.exports, "default", function () { return $7c817b358ad093b8$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $7c817b358ad093b8$export$8ee01529667e66d9(slot) {
    return (0, $dmzXD.default)('MuiAutocomplete', slot);
}
const $7c817b358ad093b8$var$autocompleteClasses = (0, $fYlYP.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $7c817b358ad093b8$export$2e2bcd8739ae039 = $7c817b358ad093b8$var$autocompleteClasses;

});


parcelRegister("f7sDp", function(module, exports) {

$parcel$export(module.exports, "useWifiScan", function () { return $64601be8f0920120$export$b37f6d04fb568520; });

var $bh6RR = parcelRequire("bh6RR");

var $1lMle = parcelRequire("1lMle");

var $cK0UE = parcelRequire("cK0UE");

var $gyheu = parcelRequire("gyheu");
/**
 * How long to allow for a scan. The trainer gives motion 8s and the server
 * waits 15s, so the browser has to outlast both — fetchApi's 10s default would
 * abort a scan that was about to return.
 */ const $64601be8f0920120$var$SCAN_TIMEOUT_MS = 20000;
function $64601be8f0920120$export$b37f6d04fb568520() {
    const [ssidOptions, setSsidOptions] = $bh6RR.useState([]);
    const [scanning, setScanning] = $bh6RR.useState(false);
    const [scanMessage, setScanMessage] = $bh6RR.useState("");
    const scan = $bh6RR.useCallback(async (trainerId)=>{
        setScanning(true);
        setScanMessage("");
        try {
            const { networks: networks } = await (0, $cK0UE.default)(`/api/trainers/${trainerId}/wifi-networks`, "POST", undefined, {
                signal: AbortSignal.timeout($64601be8f0920120$var$SCAN_TIMEOUT_MS)
            });
            const options = (0, $gyheu.toSsidOptions)(networks);
            setSsidOptions(options);
            if (options.length === 0) {
                setScanMessage("The trainer saw no named networks. Check that it is in range.");
                return;
            }
            const hidden = (0, $gyheu.countHiddenNetworks)(networks);
            setScanMessage(`Found ${options.length} ${options.length === 1 ? "network" : "networks"}` + (hidden > 0 ? ` (${hidden} hidden)` : ""));
        } catch (err) {
            (0, $1lMle.default).error("Error scanning wifi networks", {
                error: err
            });
            const status = err instanceof (0, $cK0UE.FetchError) ? err.statusCode : 0;
            if (status === 409) // Expected whenever the trainer is powered off. Credentials can
            // still be saved — they apply at its next boot — so this is a
            // note, not a failure of what the user came here to do.
            setScanMessage("The trainer is offline, so it cannot scan. You can still enter the network name by hand.");
            else if (status === 504) // The trainer is connected, the scan just did not finish. Do
            // not imply it is unreachable.
            setScanMessage("The trainer did not finish scanning in time. Try again, or enter the network name by hand.");
            else if (status === 501) setScanMessage("This trainer's software is too old to scan for networks.");
            else setScanMessage("Could not scan for networks. Enter the network name by hand.");
        } finally{
            setScanning(false);
        }
    }, []);
    return {
        ssidOptions: ssidOptions,
        scanning: scanning,
        scanMessage: scanMessage,
        scan: scan
    };
}
var $64601be8f0920120$export$2e2bcd8739ae039 = $64601be8f0920120$export$b37f6d04fb568520;

});
parcelRegister("gyheu", function(module, exports) {

$parcel$export(module.exports, "toSsidOptions", function () { return $a5a72ae7a02804a6$export$bbe08ce3779813e; });
$parcel$export(module.exports, "countHiddenNetworks", function () { return $a5a72ae7a02804a6$export$87b85d42cbd049c8; });
function $a5a72ae7a02804a6$export$bbe08ce3779813e(networks) {
    const strongestByEssid = new Map();
    networks.forEach(({ essid: essid, signal_level: signal })=>{
        if (!essid) return;
        const best = strongestByEssid.get(essid);
        if (best === undefined || signal > best) strongestByEssid.set(essid, signal);
    });
    return [
        ...strongestByEssid.entries()
    ].sort(([, a], [, b])=>b - a).map(([essid])=>essid);
}
function $a5a72ae7a02804a6$export$87b85d42cbd049c8(networks) {
    return networks.filter(({ essid: essid })=>!essid).length;
}
var $a5a72ae7a02804a6$export$2e2bcd8739ae039 = $a5a72ae7a02804a6$export$bbe08ce3779813e;

});


parcelRegister("85aFq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e27109f361a51fd$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $5e27109f361a51fd$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11z"
}), 'Videocam');

});

parcelRegister("gCqvy", function(module, exports) {

$parcel$export(module.exports, "launchRun", function () { return $d05d51a5c1bae59d$export$b3963a3337e04d7d; });
$parcel$export(module.exports, "stopRun", function () { return $d05d51a5c1bae59d$export$e4bac362e92c252e; });
$parcel$export(module.exports, "currentRun", function () { return $d05d51a5c1bae59d$export$26743e842957e030; });
$parcel$export(module.exports, "launchFailureText", function () { return $d05d51a5c1bae59d$export$e94e9b420e4600a2; });

var $cK0UE = parcelRequire("cK0UE");
async function $d05d51a5c1bae59d$export$b3963a3337e04d7d(trainerId, request) {
    const { params: params, ...rest } = request;
    // A Start that carried the surface's own inputs is a front door of its
    // own (ADR-044): the run is born begun, so the player taps once. Without
    // inputs the run waits, and the surface's next Start is its begin.
    const body = params !== undefined ? {
        ...rest,
        params: params,
        origin: "api",
        beginNow: true
    } : rest;
    return (0, $cK0UE.default)(`/trainer/${trainerId}/api/experience/runs`, "POST", body, // Accept is fast, but a cold trainer's bundle fetch rides inside it
    // and can take ~30s — far past fetchApi's 10s default.
    {
        signal: AbortSignal.timeout(45000)
    });
}
async function $d05d51a5c1bae59d$export$e4bac362e92c252e(trainerId) {
    return (0, $cK0UE.default)(`/trainer/${trainerId}/api/experience/runs/stop`, "POST", {});
}
async function $d05d51a5c1bae59d$export$26743e842957e030(trainerId) {
    const { run: run } = await (0, $cK0UE.default)(`/trainer/${trainerId}/api/experience/runs/current`);
    return run;
}
/** Not failures of the launch: the trainer is off, asleep or between uplinks. */ const $d05d51a5c1bae59d$var$UNREACHABLE = new Set([
    404,
    504
]);
function $d05d51a5c1bae59d$export$e94e9b420e4600a2(error) {
    if (error instanceof (0, $cK0UE.FetchError)) {
        if ($d05d51a5c1bae59d$var$UNREACHABLE.has(error.statusCode)) return "The trainer isn't responding. Check that it's on, then try again.";
        if (error.statusCode === 409) return "The trainer is already running something. Stop it, then try again.";
    }
    return "The trainer couldn't start this. Try again, or contact support if it keeps happening.";
}

});

parcelRegister("eRLVn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e09a52f1d43c4480$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $gIiKg = parcelRequire("gIiKg");

var $ln5eW = parcelRequire("ln5eW");

var $hMk93 = parcelRequire("hMk93");

var $1c3dI = parcelRequire("1c3dI");

var $bxQg9 = parcelRequire("bxQg9");

var $eMYZa = parcelRequire("eMYZa");

var $h4xLg = parcelRequire("h4xLg");

var $cbFbS = parcelRequire("cbFbS");

var $1lMle = parcelRequire("1lMle");

var $cK0UE = parcelRequire("cK0UE");

var $4ln86 = parcelRequire("4ln86");

var $62tuQ = parcelRequire("62tuQ");

var $76QOg = parcelRequire("76QOg");

var $g8gob = parcelRequire("g8gob");

var $ezs3H = parcelRequire("ezs3H");

var $cgUqb = parcelRequire("cgUqb");

var $NbKWd = parcelRequire("NbKWd");

var $lfvqn = parcelRequire("lfvqn");

var $2Q7us = parcelRequire("2Q7us");

var $8c9Rq = parcelRequire("8c9Rq");

var $fgY6R = parcelRequire("fgY6R");

var $1xith = parcelRequire("1xith");

var $h3IZ9 = parcelRequire("h3IZ9");
const $e09a52f1d43c4480$var$BASE_URL = "/api/apps/workouts";
function $e09a52f1d43c4480$export$2e2bcd8739ae039({ workout: workout, parameters: requestedParameters, localizedPosition: localizedPosition, level: level }) {
    const features = (0, $lfvqn.useTrainerFeatures)();
    const { currentWorkout: currentWorkout, playState: playState, recordingState: recordingState, diagnostics: diagnostics } = (0, $cgUqb.useAppWorkoutStatus)();
    const { status: trainerStatus } = (0, $ezs3H.useStatus)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const [stateChangeError, setStateChangeError] = $bh6RR.useState(null);
    const [status, setStatus] = $bh6RR.useState("stopped");
    const [workoutFinished, setWorkoutFinished] = $bh6RR.useState(false);
    const [workoutState, setWorkoutState] = $bh6RR.useState(currentWorkout?.appState || null);
    const stateChangeRequested = $bh6RR.useRef(null);
    const hidden = $bh6RR.useRef(false);
    // Sticky "we have observed playing at some point" flag used to latch
    // workoutFinished when the tab returns to visible after the play→stop
    // transition was missed (e.g. iOS suspended JS while the phone was locked).
    const hasBeenPlayingRef = $bh6RR.useRef(false);
    // The player asked for the current stop, so the latch above must not read
    // it as the workout finishing. Cleared when play starts again.
    const stopRequestedRef = $bh6RR.useRef(false);
    const [playInitiated, setPlayInitiated] = $bh6RR.useState(false);
    const { physicsModelName: physicsModelName } = (0, $g8gob.usePhysicsModelContext)();
    const { selected: selectedSport, lacrosseTwoCage: lacrosseTwoCage } = (0, $76QOg.useSelectedSport)();
    /*
        Some drills do not leave the play mode up to the coach. Lacrosse's
        two-cage drill is one: alternating between the cages is what the drill
        IS, so it plays "dual" whatever the screen's own side control last said.
        See forcedPlayMode for the full table - the drill's own shots decide it
        alongside the cage setup.

        Read off `workout` rather than taken as a parameter: the shots are the
        thing being coerced against, and this hook already holds the workout
        they live on. `level` narrows a leveled config to the one level that is
        about to play, so a drill whose level 2 works both sides stops forcing
        while level 1 still does.

        Coerced HERE because this is the one hook every play screen goes
        through - twenty-odd of them, each holding its own play-mode state in
        its own reducer or useState. Setting a default in each would be twenty
        edits and would still be a default a coach could then override.

        Memoised so `parameters` keeps its identity when nothing is forced,
        which the play callback below depends on.
    */ const spread = $bh6RR.useMemo(()=>(0, $4ln86.workoutShotSpread)(workout?.config, level), [
        workout?.config,
        level
    ]);
    const parameters = $bh6RR.useMemo(()=>{
        const playMode = (0, $2Q7us.effectivePlayMode)(// AppParameters is an untyped JSON bag; the value is a PlayMode.
        requestedParameters.playMode, selectedSport, lacrosseTwoCage, spread, workout?.appId);
        if (requestedParameters.playMode === playMode) return requestedParameters;
        return {
            ...requestedParameters,
            playMode: playMode
        };
    }, [
        requestedParameters,
        selectedSport,
        lacrosseTwoCage,
        spread,
        workout?.appId
    ]);
    const [captureStatus, setCaptureStatus] = $bh6RR.useState("Idle");
    const captureDisabled = $bh6RR.useMemo(()=>captureStatus === "Requested" || captureStatus === "Recording", [
        captureStatus
    ]);
    const [buttonState, setButtonState] = $bh6RR.useState({
        playDisabled: false,
        pauseDisabled: true,
        stopDisabled: true
    });
    const [expectedState, setExpectedState] = $bh6RR.useState("stopped");
    $bh6RR.useEffect(()=>{
        const handleVisibilityChange = ()=>{
            if (stateChangeRequested.current && hidden.current && !document.hidden) stateChangeRequested.current = performance.now();
            hidden.current = document.hidden;
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return ()=>{
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);
    $bh6RR.useEffect(()=>{
        if (currentWorkout !== null) setWorkoutState(currentWorkout.appState);
    }, [
        currentWorkout
    ]);
    const previousState = (0, $NbKWd.default)(playState);
    $bh6RR.useEffect(()=>{
        if (stateChangeRequested.current) {
            const diff = performance.now() - stateChangeRequested.current;
            (0, $1lMle.default).info(`Waiting confirmation: ${status} ${diff}ms`);
            const maxOffset = 10000;
            if (diff > maxOffset) {
                setStateChangeError(`Status hasn't updated within ${maxOffset}ms`);
                stateChangeRequested.current = null;
                setStatus("error");
                (0, $1lMle.default).warn(`Workout Status hasn't updated within ${maxOffset}ms - setting status to error`);
                return;
            }
            if (playState === expectedState) {
                (0, $1lMle.default).info(`Transitioning from ${status} -> ${playState}`);
                setExpectedState(playState);
                stateChangeRequested.current = null;
                setStatus(playState);
                setStateChangeError(null);
            } else if (expectedState === "paused" && playState === "stopped") {
                (0, $1lMle.default).info("Requested pause, but workout has been stopped");
                setExpectedState(playState);
                stateChangeRequested.current = null;
                setStatus(playState);
                setStateChangeError(null);
            } else (0, $1lMle.default).info(`Expected play status: ${expectedState}, got: ${playState} - continuing to wait`);
        } else {
            if (previousState === "playing" && playState === "stopped") setWorkoutFinished(true);
            setStatus(playState);
            if (playState === "playing" && !playInitiated) setPlayInitiated(true);
        }
    }, [
        previousState,
        playInitiated,
        playState,
        status,
        expectedState,
        trainerStatus?.timestamp
    ]);
    $bh6RR.useEffect(()=>{
        if (playState !== "stopped") setPlayInitiated(true);
        if (playState === "playing") {
            hasBeenPlayingRef.current = true;
            stopRequestedRef.current = false;
        }
    }, [
        playState
    ]);
    $bh6RR.useEffect(()=>{
        const handler = ()=>{
            if (!document.hidden && hasBeenPlayingRef.current && !stopRequestedRef.current && playState === "stopped" && stateChangeRequested.current === null) setWorkoutFinished(true);
        };
        document.addEventListener("visibilitychange", handler);
        return ()=>{
            document.removeEventListener("visibilitychange", handler);
        };
    }, [
        playState
    ]);
    $bh6RR.useEffect(()=>{
        if (status.endsWith("Requested") || status.startsWith("requesting")) {
            (0, $1lMle.default).info(`Disabling all buttons due to play state: ${status}`);
            setButtonState({
                pauseDisabled: true,
                playDisabled: true,
                stopDisabled: true
            });
            return;
        }
        if (status === "playing" && stateChangeRequested.current === null) {
            (0, $1lMle.default).info("Playing - play disabled, pause & stop: enabled");
            setButtonState({
                pauseDisabled: false,
                playDisabled: true,
                stopDisabled: false
            });
        }
        if (status === "paused" && stateChangeRequested.current === null) {
            (0, $1lMle.default).info("Paused - pause disabled, play & stop: enabled");
            setButtonState({
                pauseDisabled: true,
                playDisabled: false,
                stopDisabled: false
            });
        }
        if (status === "stopped" && stateChangeRequested.current === null) {
            (0, $1lMle.default).info("Stopped - stop disabled, play & pause: enabled");
            setPlayInitiated(false);
            setButtonState({
                pauseDisabled: true,
                playDisabled: false,
                stopDisabled: true
            });
        }
        if (status === "error") {
            (0, $1lMle.default).info("Error playing workout - enabling buttons");
            setPlayInitiated(false);
            setButtonState({
                pauseDisabled: true,
                playDisabled: false,
                stopDisabled: true
            });
        }
    }, [
        status,
        stateChangeRequested
    ]);
    const statusText = $bh6RR.useMemo(()=>{
        (0, $1lMle.default).info(`Status changed to ${status}`);
        switch(status){
            case "pauseRequested":
            case "requestingPause":
                return `Pausing ${workout?.name ?? "Workout"}`;
            case "paused":
                return `${workout?.name ?? "Workout"} Paused`;
            case "playRequested":
            case "requestingPlay":
                return `Loading ${workout?.name ?? "Workout"}`;
            case "playing":
                return `Playing ${workout?.name ?? "Workout"}`;
            case "requestingStop":
            case "stopRequested":
                return `Stopping ${workout?.name ?? "Workout"}`;
            case "stopped":
                return `${workout?.name ?? "Workout"} Stopped`;
            default:
                return `${workout?.name ?? "Workout"} Loading...`;
        }
    }, [
        status,
        workout?.name
    ]);
    const start = $bh6RR.useCallback(async (manualTrim, manualBoost)=>{
        if (trainerStatus?.trainer.powerState !== "L0") {
            setDialogType("Calibrating");
            return;
        }
        if (workout === null) {
            setStateChangeError("Workout is not set.");
            return;
        }
        setStatus("playRequested");
        setExpectedState("playing");
        setPlayInitiated(true);
        stateChangeRequested.current = performance.now();
        let plannedPosition = {
            x: workout.positionX,
            y: workout.positionY,
            yaw: workout.positionYaw,
            error: null
        };
        if (parameters.mirrored || parameters.playMode === "mirror") {
            (0, $1lMle.default).info("Using mirrored trainer position");
            const withHeight = {
                ...plannedPosition,
                heightIn: workout.positionHeight
            };
            const mirrored = (0, $8c9Rq.mirrorTrainer)(withHeight, selectedSport);
            const { x: x, y: y, yaw: yaw } = mirrored;
            plannedPosition = {
                x: x,
                y: y,
                yaw: yaw,
                error: null
            };
        }
        let localConfig = workout.config;
        const localParameters = parameters;
        if ((0, $h3IZ9.isMultiLevelWorkout)(workout) && level) localConfig = workout.config.levels[level];
        if (manualTrim) {
            // When mirrored, pre-negate the trim so it's preserved after coach-side mirroring
            const isMirrored = parameters.playMode === "mirror";
            const adjustedTrim = isMirrored ? -manualTrim : manualTrim;
            (0, $1lMle.default).info(`Applying ${adjustedTrim} degrees of trim to workout (original: ${manualTrim}, mirrored: ${isMirrored})`);
            if ([
                "User Workout",
                "Curated Workout",
                "Multi-Level Workout"
            ].includes(workout.appName)) {
                const config = localConfig;
                if (config.shots) {
                    const trimmed = (0, $h3IZ9.default)(adjustedTrim, config.shots);
                    const updatedConfig = {
                        ...config,
                        shots: trimmed
                    };
                    localConfig = updatedConfig;
                }
            } else if ([
                "Freeplay",
                "Guided Freeplay"
            ].includes(workout.name)) {
                const config = localConfig;
                const trimmed = (0, $h3IZ9.trimShot)(adjustedTrim, config.shot);
                const updatedConfig = {
                    ...config,
                    shot: trimmed
                };
                localConfig = updatedConfig;
            }
        }
        if (manualBoost) {
            (0, $1lMle.default).info(`Applying ${manualBoost} level of boost to workout`);
            if ([
                "User Workout",
                "Curated Workout",
                "Multi-Level Workout"
            ].includes(workout.appName)) {
                const config = localConfig;
                if (config.shots) {
                    const boosted = config.shots.map((s)=>({
                            ...s,
                            launchSpeed: s.launchSpeed * ((100 + manualBoost) / 100)
                        }));
                    const updatedConfig = {
                        ...config,
                        shots: boosted
                    };
                    localConfig = updatedConfig;
                }
            } else if ([
                "Freeplay",
                "Guided Freeplay"
            ].includes(workout.name)) {
                const config = localConfig;
                const boosted = {
                    ...config.shot,
                    launchSpeed: config.shot.launchSpeed * ((100 + manualBoost) / 100)
                };
                const updatedConfig = {
                    ...config,
                    shot: boosted
                };
                localConfig = updatedConfig;
            }
        }
        (0, $1lMle.default).info(`Starting workout with physics model: ${physicsModelName}`);
        // FIXME: This needs to be cleaned up as we deprecate multi-shot/curated workouts
        let appWorkoutId = workout.appId;
        const params = {
            ...localParameters
        };
        if (appWorkoutId === 9) {
            // this code is temporary, we'll modify coach to handle this app ID
            // in the future... but each level in a multi-level workout is the
            // same data structure as the deprecated 'curated' workouts, so we're
            // basically extracting the level and sending that to coach as a
            // curated workout
            appWorkoutId = 4;
            params.level = level;
        }
        const payload = {
            id: workout.id,
            name: workout.name,
            appId: appWorkoutId,
            config: localConfig,
            parameters: params,
            headHeight: workout.positionHeight,
            physicsModel: physicsModelName,
            sport: selectedSport,
            plannedPosition: plannedPosition,
            localizedPosition: localizedPosition
        };
        const includeOrientation = features.includes("failsafeLocalization");
        const cameraStatus = trainerStatus?.vision.camera;
        if (includeOrientation && cameraStatus && !(0, $fgY6R.isDeprecatedCameraStatus)(cameraStatus)) {
            if (cameraStatus.orientationCurrent) payload.cameraOrientation = cameraStatus.orientationCurrent;
            if (localizedPosition) payload.cameraOrientationSource = "Live Localization";
            else {
                const cameraOrientationSource = cameraStatus.orientationCurrentSource;
                if (cameraOrientationSource === "Trainer Override" || cameraOrientationSource === "Pending Workout Play") payload.cameraOrientationSource = "Trainer FailSafe";
            }
        } else if (includeOrientation && localizedPosition) payload.cameraOrientationSource = "Live Localization";
        try {
            (0, $1xith.default).setPosition({
                ...plannedPosition,
                heightIn: workout.positionHeight
            });
            await (0, $cK0UE.pairedFetchApi)(trainerStatus?.clientId, $e09a52f1d43c4480$var$BASE_URL, "POST", payload);
            setStatus("playRequested");
        } catch (ex) {
            if (ex.name === "AbortError") {
                setStatus(playState);
                setExpectedState(playState);
            } else {
                setStatus("error");
                (0, $cK0UE.logFetchError)(ex);
                stateChangeRequested.current = null;
                if (ex instanceof Error) setStateChangeError(ex.message);
                else setStateChangeError("Unexpected error starting workout.");
            }
        }
    }, [
        trainerStatus?.trainer.powerState,
        trainerStatus?.clientId,
        trainerStatus?.vision.camera,
        workout,
        playState,
        parameters,
        physicsModelName,
        setDialogType,
        selectedSport,
        localizedPosition,
        level,
        features
    ]);
    const pause = $bh6RR.useCallback(async ()=>{
        if (![
            "paused",
            "pauseRequested",
            "requestingPause"
        ].includes(status)) {
            setStatus("requestingPause");
            setExpectedState("paused");
            stateChangeRequested.current = performance.now();
            try {
                await (0, $cK0UE.pairedFetchApi)(trainerStatus?.clientId, `${$e09a52f1d43c4480$var$BASE_URL}/pause`, "POST");
                setStatus("pauseRequested");
            } catch (ex) {
                if (ex.name === "AbortError") {
                    setStatus(playState);
                    setExpectedState(playState);
                } else {
                    setStatus("error");
                    stateChangeRequested.current = null;
                    setStateChangeError("Error encounted while pausing workout");
                    (0, $cK0UE.logFetchError)(ex);
                }
            }
        }
    }, [
        status,
        trainerStatus?.clientId,
        playState
    ]);
    const stop = $bh6RR.useCallback(async ()=>{
        if (![
            "stopped",
            "stopRequested",
            "requestingStop"
        ].includes(status)) {
            setStatus("requestingStop");
            setExpectedState("stopped");
            stateChangeRequested.current = performance.now();
            stopRequestedRef.current = true;
            try {
                await (0, $cK0UE.pairedFetchApi)(trainerStatus?.clientId, `${$e09a52f1d43c4480$var$BASE_URL}/stop`, "POST");
                setStatus("stopRequested");
            } catch (ex) {
                stopRequestedRef.current = false;
                if (ex.name === "AbortError") {
                    setStatus(playState);
                    setExpectedState(playState);
                } else {
                    setStatus("error");
                    stateChangeRequested.current = null;
                    setStateChangeError("Error stopping workout");
                    (0, $cK0UE.logFetchError)(ex);
                }
            }
        }
    }, [
        status,
        trainerStatus?.clientId,
        playState
    ]);
    $bh6RR.useEffect(()=>{
        // older software versions don't report the recording status,
        // so here we just set a timeout to re-enable the button after a pause
        if (!features.includes("captureStatus") && captureStatus === "Recording") {
            (0, $1lMle.default).info("Trainer doesn't support upload status, using timeout to renable capture.");
            const timeout = setTimeout(()=>{
                setCaptureStatus("Idle");
            }, 3000);
            return ()=>clearTimeout(timeout);
        }
        return ()=>{};
    }, [
        captureStatus,
        features
    ]);
    $bh6RR.useEffect(()=>{
        if (features.includes("captureStatus")) {
            if (captureStatus === "Requested" && recordingState === "recording") {
                (0, $1lMle.default).info("Capture requested, state 'recording' -> transitioning to Recording");
                setCaptureStatus("Recording");
            }
            if (captureStatus === "Recording" && recordingState === "inactive") {
                (0, $1lMle.default).info("Capture state inactive, -> transitioning to Complete");
                setCaptureStatus("Complete");
            }
        }
    }, [
        features,
        captureStatus,
        recordingState
    ]);
    const captureVideo = $bh6RR.useCallback(async ()=>{
        // If capture is idle or we are in a retry-able state
        const statusValid = captureStatus === "Idle" || captureStatus === "Complete" || captureStatus === "NothingToRecord" || captureStatus === "Starting";
        // Vision is running and camera is online
        const visionUp = trainerStatus?.vision?.serviceState === "Running" && trainerStatus?.vision?.camera.state === "Online";
        // We can record
        if (statusValid && visionUp) {
            (0, $1lMle.default).info("Requesting clip capture");
            if (features.includes("captureStatus")) setCaptureStatus("Requested");
            else setCaptureStatus("Recording");
            try {
                await (0, $cK0UE.pairedFetchApi)(trainerStatus?.clientId, `${$e09a52f1d43c4480$var$BASE_URL}/capture`, "POST");
            } catch (ex) {
                if (ex instanceof (0, $cK0UE.FetchError) && ex.message === "NO_CLIPS") {
                    (0, $1lMle.default).info("Setting capture status to NothingToRecord");
                    setCaptureStatus("NothingToRecord");
                } else {
                    if (ex.name === "AbortError") (0, $1lMle.default).info("Capture request aborted by client");
                    else (0, $cK0UE.logFetchError)(ex);
                    setCaptureStatus("Idle");
                }
            }
        } else if (trainerStatus?.vision?.serviceState === "Fault" || trainerStatus?.vision?.camera.state === "Offline") // The trainer will have a fault and camera state will be offline
        // We can potentially improve this in the future - some fault states don't prevent video capture
        setDialogType("VisionFaultDialog");
        else if (trainerStatus?.vision?.serviceState === "Starting") // We're still waiting on vision to start up and show camera online
        setCaptureStatus("Starting");
        else {
            const cameraState = `Camera State: ${trainerStatus?.vision?.camera.state}`;
            const serviceState = `Vision Service State: ${trainerStatus?.vision?.serviceState}`;
            const internal = `Internal hook capture state: ${captureStatus}`;
            (0, $1lMle.default).error(`Ignoring request to capture clips - ${serviceState}, ${cameraState}, ${internal}`);
            (0, $1lMle.default).warn("Resetting captureStatus to 'Idle'");
            setCaptureStatus("Idle");
        }
    }, [
        captureStatus,
        features,
        setDialogType,
        trainerStatus?.clientId,
        trainerStatus?.vision?.serviceState,
        trainerStatus?.vision?.camera.state
    ]);
    const sendCommand = $bh6RR.useCallback(async (command)=>{
        if (!trainerStatus?.clientId) throw new Error("No trainer connected");
        (0, $1lMle.default).info(`[useAppWorkoutPlay] Sending command ${command.type}`);
        const request = {
            command: command
        };
        await (0, $cK0UE.pairedFetchApi)(trainerStatus.clientId, `${$e09a52f1d43c4480$var$BASE_URL}/sendCommand`, "POST", request);
    }, [
        trainerStatus?.clientId
    ]);
    return {
        start: start,
        pause: pause,
        stop: stop,
        captureVideo: captureVideo,
        captureStatus: captureStatus,
        diagnostics: diagnostics,
        playState: playState,
        statusText: statusText,
        workoutFinished: workoutFinished,
        requestError: stateChangeError,
        workoutState: workoutState,
        workout: workout,
        playInitiated: playInitiated,
        captureDisabled: captureDisabled,
        sendCommand: sendCommand,
        ...buttonState
    };
}
function $e09a52f1d43c4480$export$b8929196c0abab8a({ diagnostics: diagnostics, headerText: headerText }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bxQg9.default), {
        sx: {
            padding: "10px"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                variant: "h4",
                children: headerText
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ln5eW.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eMYZa.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $h4xLg.default), {
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1c3dI.default), {
                                    children: "Property"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1c3dI.default), {
                                    align: "right",
                                    children: "Value"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hMk93.default), {
                        children: Object.keys(diagnostics).map((k)=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $h4xLg.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1c3dI.default), {
                                        children: k
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1c3dI.default), {
                                        align: "right",
                                        children: diagnostics[k]
                                    })
                                ]
                            }, k))
                    })
                ]
            })
        ]
    });
}
function $e09a52f1d43c4480$export$427675715dfa80c({ open: open, diagnostics: diagnostics, headerText: headerText }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $gIiKg.default), {
        anchor: "top",
        variant: "persistent",
        open: open,
        sx: {
            ".MuiDrawer-paper": {
                height: "20%"
            }
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)($e09a52f1d43c4480$export$b8929196c0abab8a, {
            headerText: headerText,
            diagnostics: diagnostics
        })
    });
}

});
parcelRegister("ln5eW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8efcf88996b414a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $kW0H7 = parcelRequire("kW0H7");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $9QV4I = parcelRequire("9QV4I");

var $ih19M = parcelRequire("ih19M");
'use client';
const $f8efcf88996b414a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $9QV4I.getTableUtilityClass), classes);
};
const $f8efcf88996b414a$var$TableRoot = (0, $l0oRz.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': {
            ...theme.typography.body2,
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    borderCollapse: 'separate'
                }
            }
        ]
    })));
const $f8efcf88996b414a$var$defaultComponent = 'table';
const $f8efcf88996b414a$var$Table = /*#__PURE__*/ $bh6RR.forwardRef(function Table(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $f8efcf88996b414a$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    };
    const classes = $f8efcf88996b414a$var$useUtilityClasses(ownerState);
    const table = $bh6RR.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $kW0H7.default).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($f8efcf88996b414a$var$TableRoot, {
            as: component,
            role: component === $f8efcf88996b414a$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $aPsoC.default)(classes.root, className),
            ownerState: ownerState,
            ...other
        })
    });
});
var $f8efcf88996b414a$export$2e2bcd8739ae039 = $f8efcf88996b414a$var$Table;

});
parcelRegister("kW0H7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3d9c35637f513af$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
/**
 * @ignore - internal component.
 */ const $f3d9c35637f513af$var$TableContext = /*#__PURE__*/ $bh6RR.createContext();
var $f3d9c35637f513af$export$2e2bcd8739ae039 = $f3d9c35637f513af$var$TableContext;

});

parcelRegister("9QV4I", function(module, exports) {

$parcel$export(module.exports, "getTableUtilityClass", function () { return $72c53e47f705f503$export$315cb19215f77ce0; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $72c53e47f705f503$export$315cb19215f77ce0(slot) {
    return (0, $dmzXD.default)('MuiTable', slot);
}
const $72c53e47f705f503$var$tableClasses = (0, $fYlYP.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $72c53e47f705f503$export$2e2bcd8739ae039 = $72c53e47f705f503$var$tableClasses;

});


parcelRegister("hMk93", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf168bbd4775d14a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $lojaE = parcelRequire("lojaE");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $8NyKy = parcelRequire("8NyKy");

var $ih19M = parcelRequire("ih19M");
'use client';
const $cf168bbd4775d14a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $8NyKy.getTableBodyUtilityClass), classes);
};
const $cf168bbd4775d14a$var$TableBodyRoot = (0, $l0oRz.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root'
})({
    display: 'table-row-group'
});
const $cf168bbd4775d14a$var$tablelvl2 = {
    variant: 'body'
};
const $cf168bbd4775d14a$var$defaultComponent = 'tbody';
const $cf168bbd4775d14a$var$TableBody = /*#__PURE__*/ $bh6RR.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $cf168bbd4775d14a$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $cf168bbd4775d14a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lojaE.default).Provider, {
        value: $cf168bbd4775d14a$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($cf168bbd4775d14a$var$TableBodyRoot, {
            className: (0, $aPsoC.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $cf168bbd4775d14a$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var $cf168bbd4775d14a$export$2e2bcd8739ae039 = $cf168bbd4775d14a$var$TableBody;

});
parcelRegister("lojaE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f92ab5c9fd8e7882$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
/**
 * @ignore - internal component.
 */ const $f92ab5c9fd8e7882$var$Tablelvl2Context = /*#__PURE__*/ $bh6RR.createContext();
var $f92ab5c9fd8e7882$export$2e2bcd8739ae039 = $f92ab5c9fd8e7882$var$Tablelvl2Context;

});

parcelRegister("8NyKy", function(module, exports) {

$parcel$export(module.exports, "getTableBodyUtilityClass", function () { return $667ddaf35fb4c903$export$98bd2a9b566ec665; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $667ddaf35fb4c903$export$98bd2a9b566ec665(slot) {
    return (0, $dmzXD.default)('MuiTableBody', slot);
}
const $667ddaf35fb4c903$var$tableBodyClasses = (0, $fYlYP.default)('MuiTableBody', [
    'root'
]);
var $667ddaf35fb4c903$export$2e2bcd8739ae039 = $667ddaf35fb4c903$var$tableBodyClasses;

});


parcelRegister("1c3dI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0de968e0ec992796$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $krx4P = parcelRequire("krx4P");

var $kW0H7 = parcelRequire("kW0H7");

var $lojaE = parcelRequire("lojaE");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $bg6W6 = parcelRequire("bg6W6");

var $ih19M = parcelRequire("ih19M");
'use client';
const $0de968e0ec992796$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $krx4P.default)(align)}`,
            padding !== 'normal' && `padding${(0, $krx4P.default)(padding)}`,
            `size${(0, $krx4P.default)(size)}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $bg6W6.getTableCellUtilityClass), classes);
};
const $0de968e0ec992796$var$TableCellRoot = (0, $l0oRz.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $krx4P.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $krx4P.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $krx4P.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? theme.lighten(theme.alpha(theme.palette.divider, 1), 0.88) : theme.darken(theme.alpha(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16,
        variants: [
            {
                props: {
                    variant: 'head'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary,
                    lineHeight: theme.typography.pxToRem(24),
                    fontWeight: theme.typography.fontWeightMedium
                }
            },
            {
                props: {
                    variant: 'body'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            },
            {
                props: {
                    variant: 'footer'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    lineHeight: theme.typography.pxToRem(21),
                    fontSize: theme.typography.pxToRem(12)
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '6px 16px',
                    [`&.${(0, $bg6W6.default).paddingCheckbox}`]: {
                        width: 24,
                        // prevent the checkbox column from growing
                        padding: '0 12px 0 16px',
                        '& > *': {
                            padding: 0
                        }
                    }
                }
            },
            {
                props: {
                    padding: 'checkbox'
                },
                style: {
                    width: 48,
                    // prevent the checkbox column from growing
                    padding: '0 0 0 4px'
                }
            },
            {
                props: {
                    padding: 'none'
                },
                style: {
                    padding: 0
                }
            },
            {
                props: {
                    align: 'left'
                },
                style: {
                    textAlign: 'left'
                }
            },
            {
                props: {
                    align: 'center'
                },
                style: {
                    textAlign: 'center'
                }
            },
            {
                props: {
                    align: 'right'
                },
                style: {
                    textAlign: 'right',
                    flexDirection: 'row-reverse'
                }
            },
            {
                props: {
                    align: 'justify'
                },
                style: {
                    textAlign: 'justify'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: (theme.vars || theme).palette.background.default
                }
            }
        ]
    })));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $0de968e0ec992796$var$TableCell = /*#__PURE__*/ $bh6RR.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp, ...other } = props;
    const table = $bh6RR.useContext((0, $kW0H7.default));
    const tablelvl2 = $bh6RR.useContext((0, $lojaE.default));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = {
        ...props,
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    };
    const classes = $0de968e0ec992796$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $ih19M.jsx)($0de968e0ec992796$var$TableCellRoot, {
        as: component,
        ref: ref,
        className: (0, $aPsoC.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState,
        ...other
    });
});
var $0de968e0ec992796$export$2e2bcd8739ae039 = $0de968e0ec992796$var$TableCell;

});
parcelRegister("bg6W6", function(module, exports) {

$parcel$export(module.exports, "getTableCellUtilityClass", function () { return $832691b6c94e9185$export$33a0f07a16a10b1b; });
$parcel$export(module.exports, "default", function () { return $832691b6c94e9185$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $832691b6c94e9185$export$33a0f07a16a10b1b(slot) {
    return (0, $dmzXD.default)('MuiTableCell', slot);
}
const $832691b6c94e9185$var$tableCellClasses = (0, $fYlYP.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $832691b6c94e9185$export$2e2bcd8739ae039 = $832691b6c94e9185$var$tableCellClasses;

});


parcelRegister("bxQg9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $867b506db4de0084$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $jIJP4 = parcelRequire("jIJP4");

var $ih19M = parcelRequire("ih19M");
'use client';
const $867b506db4de0084$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $jIJP4.getTableContainerUtilityClass), classes);
};
const $867b506db4de0084$var$TableContainerRoot = (0, $l0oRz.default)('div', {
    name: 'MuiTableContainer',
    slot: 'Root'
})({
    width: '100%',
    overflowX: 'auto'
});
const $867b506db4de0084$var$TableContainer = /*#__PURE__*/ $bh6RR.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $867b506db4de0084$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($867b506db4de0084$var$TableContainerRoot, {
        ref: ref,
        as: component,
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ...other
    });
});
var $867b506db4de0084$export$2e2bcd8739ae039 = $867b506db4de0084$var$TableContainer;

});
parcelRegister("jIJP4", function(module, exports) {

$parcel$export(module.exports, "getTableContainerUtilityClass", function () { return $e5b5abd37905ec4c$export$eed427986a7abdf9; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $e5b5abd37905ec4c$export$eed427986a7abdf9(slot) {
    return (0, $dmzXD.default)('MuiTableContainer', slot);
}
const $e5b5abd37905ec4c$var$tableContainerClasses = (0, $fYlYP.default)('MuiTableContainer', [
    'root'
]);
var $e5b5abd37905ec4c$export$2e2bcd8739ae039 = $e5b5abd37905ec4c$var$tableContainerClasses;

});


parcelRegister("eMYZa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac44dadec77d9dfd$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $lojaE = parcelRequire("lojaE");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $iXqkX = parcelRequire("iXqkX");

var $ih19M = parcelRequire("ih19M");
'use client';
const $ac44dadec77d9dfd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $iXqkX.getTableHeadUtilityClass), classes);
};
const $ac44dadec77d9dfd$var$TableHeadRoot = (0, $l0oRz.default)('thead', {
    name: 'MuiTableHead',
    slot: 'Root'
})({
    display: 'table-header-group'
});
const $ac44dadec77d9dfd$var$tablelvl2 = {
    variant: 'head'
};
const $ac44dadec77d9dfd$var$defaultComponent = 'thead';
const $ac44dadec77d9dfd$var$TableHead = /*#__PURE__*/ $bh6RR.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $ac44dadec77d9dfd$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $ac44dadec77d9dfd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lojaE.default).Provider, {
        value: $ac44dadec77d9dfd$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($ac44dadec77d9dfd$var$TableHeadRoot, {
            as: component,
            className: (0, $aPsoC.default)(classes.root, className),
            ref: ref,
            role: component === $ac44dadec77d9dfd$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var $ac44dadec77d9dfd$export$2e2bcd8739ae039 = $ac44dadec77d9dfd$var$TableHead;

});
parcelRegister("iXqkX", function(module, exports) {

$parcel$export(module.exports, "getTableHeadUtilityClass", function () { return $dcd22aa98004f83a$export$2e731cea2d1c2392; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $dcd22aa98004f83a$export$2e731cea2d1c2392(slot) {
    return (0, $dmzXD.default)('MuiTableHead', slot);
}
const $dcd22aa98004f83a$var$tableHeadClasses = (0, $fYlYP.default)('MuiTableHead', [
    'root'
]);
var $dcd22aa98004f83a$export$2e2bcd8739ae039 = $dcd22aa98004f83a$var$tableHeadClasses;

});


parcelRegister("h4xLg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6dcffb33d4b0fb4$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $lojaE = parcelRequire("lojaE");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $h5SXT = parcelRequire("h5SXT");

var $ih19M = parcelRequire("ih19M");
'use client';
const $c6dcffb33d4b0fb4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $h5SXT.getTableRowUtilityClass), classes);
};
const $c6dcffb33d4b0fb4$var$TableRowRoot = (0, $l0oRz.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $h5SXT.default).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $h5SXT.default).selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`)
            }
        }
    })));
const $c6dcffb33d4b0fb4$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $c6dcffb33d4b0fb4$var$TableRow = /*#__PURE__*/ $bh6RR.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $c6dcffb33d4b0fb4$var$defaultComponent, hover: hover = false, selected: selected = false, ...other } = props;
    const tablelvl2 = $bh6RR.useContext((0, $lojaE.default));
    const ownerState = {
        ...props,
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    };
    const classes = $c6dcffb33d4b0fb4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($c6dcffb33d4b0fb4$var$TableRowRoot, {
        as: component,
        ref: ref,
        className: (0, $aPsoC.default)(classes.root, className),
        role: component === $c6dcffb33d4b0fb4$var$defaultComponent ? null : 'row',
        ownerState: ownerState,
        ...other
    });
});
var $c6dcffb33d4b0fb4$export$2e2bcd8739ae039 = $c6dcffb33d4b0fb4$var$TableRow;

});
parcelRegister("h5SXT", function(module, exports) {

$parcel$export(module.exports, "getTableRowUtilityClass", function () { return $c71d8a38e5685feb$export$ba0a6d6c28940107; });
$parcel$export(module.exports, "default", function () { return $c71d8a38e5685feb$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $c71d8a38e5685feb$export$ba0a6d6c28940107(slot) {
    return (0, $dmzXD.default)('MuiTableRow', slot);
}
const $c71d8a38e5685feb$var$tableRowClasses = (0, $fYlYP.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $c71d8a38e5685feb$export$2e2bcd8739ae039 = $c71d8a38e5685feb$var$tableRowClasses;

});


parcelRegister("4ln86", function(module, exports) {

$parcel$export(module.exports, "workoutShotSpread", function () { return $a978dda403f7b3bd$export$7780293beac59ed6; });
/*
    Which way a drill's shots are angled, and therefore whether mirroring it
    means anything.

    A lacrosse drill aims at a cage, not at a service court, so the deuce/ad
    side picker every other sport shows has nothing to name. What a coach
    actually wants to know is whether the drill attacks one side of the cage -
    because only then is there another side to feed.

    Pure, and takes `unknown`: a workout config is jsonb, every app declares its
    own shape, and the four shapes below are all in production at once. Reading
    defensively here is the same bargain workoutSetup.ts makes.
*/ function $a978dda403f7b3bd$var$isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
/**
 * The `pan` of anything in `shots` that carries a numeric one.
 *
 * Shots are read one field deep and nothing else about them is trusted, so a
 * config holding a half-built shot contributes what it has rather than throwing.
 */ function $a978dda403f7b3bd$var$pansFromShots(value) {
    if (!Array.isArray(value)) return [];
    return value.flatMap((shot)=>$a978dda403f7b3bd$var$isRecord(shot) && typeof shot.pan === "number" ? [
            shot.pan
        ] : []);
}
function $a978dda403f7b3bd$export$f4d71791967abe7(config, level) {
    if (!$a978dda403f7b3bd$var$isRecord(config)) return [];
    // 9-multi-level. First because a leveled config has no top-level `shots`,
    // and reading the wrong level is worse than reading none.
    if ($a978dda403f7b3bd$var$isRecord(config.levels)) {
        const { levels: levels } = config;
        const wanted = level !== undefined ? [
            levels[level]
        ] : Object.values(levels);
        return wanted.flatMap((entry)=>$a978dda403f7b3bd$var$isRecord(entry) ? $a978dda403f7b3bd$var$pansFromShots(entry.shots) : []);
    }
    // 15-aoi-triggered: shots hang off each triggered sequence.
    if (Array.isArray(config.sequence)) return config.sequence.flatMap((entry)=>$a978dda403f7b3bd$var$isRecord(entry) ? $a978dda403f7b3bd$var$pansFromShots(entry.shots) : []);
    // 4-multi-shot, 11-module, 17-padel.
    if (Array.isArray(config.shots)) return $a978dda403f7b3bd$var$pansFromShots(config.shots);
    // 5-single-shot: one shot, not a list.
    if ($a978dda403f7b3bd$var$isRecord(config.shot) && typeof config.shot.pan === "number") return [
        config.shot.pan
    ];
    return [];
}
function $a978dda403f7b3bd$export$d0dcf6621b707dce(pans) {
    const angled = pans.filter((pan)=>Number.isFinite(pan) && pan !== 0);
    if (angled.length === 0) return "none";
    const leansRight = angled[0] > 0;
    return angled.every((pan)=>pan > 0 === leansRight) ? "one-sided" : "mixed";
}
function $a978dda403f7b3bd$export$7780293beac59ed6(config, level) {
    return $a978dda403f7b3bd$export$d0dcf6621b707dce($a978dda403f7b3bd$export$f4d71791967abe7(config, level));
}

});

parcelRegister("g8gob", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PHYSICS_MODEL_BY_SPORT", function () { return $1a0c093b02a4f537$export$39bc86f93fc020d3; });
$parcel$export(module.exports, "resolvePhysicsModelName", function () { return $1a0c093b02a4f537$export$3fee8c33699828ed; });
$parcel$export(module.exports, "PhysicsModelProvider", function () { return $1a0c093b02a4f537$export$6689bb84ec90d310; });
$parcel$export(module.exports, "usePhysicsModelContext", function () { return $1a0c093b02a4f537$export$2a50a044cc286e5c; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $2Yg5G = parcelRequire("2Yg5G");

var $1lMle = parcelRequire("1lMle");

var $76QOg = parcelRequire("76QOg");

var $ezs3H = parcelRequire("ezs3H");
const $1a0c093b02a4f537$export$665c96f8af24c68b = "physics-";
const $1a0c093b02a4f537$export$ccf4c60f2112295f = "20B-base";
const $1a0c093b02a4f537$export$383c21c262df2646 = "30B-base";
const $1a0c093b02a4f537$export$39bc86f93fc020d3 = {
    PLATFORM_TENNIS: `${$1a0c093b02a4f537$export$665c96f8af24c68b}${$1a0c093b02a4f537$export$ccf4c60f2112295f}`,
    PADEL: `${$1a0c093b02a4f537$export$665c96f8af24c68b}${$1a0c093b02a4f537$export$ccf4c60f2112295f}`,
    TENNIS: `${$1a0c093b02a4f537$export$665c96f8af24c68b}${$1a0c093b02a4f537$export$ccf4c60f2112295f}`,
    PICKLEBALL: `${$1a0c093b02a4f537$export$665c96f8af24c68b}${$1a0c093b02a4f537$export$383c21c262df2646}`,
    // Lacrosse throws a platform tennis ball from a model-20 head, so it takes
    // the default model - matching what PhysicsModelProvider hands the app.
    LACROSSE: `${$1a0c093b02a4f537$export$665c96f8af24c68b}${$1a0c093b02a4f537$export$ccf4c60f2112295f}`
};
function $1a0c093b02a4f537$export$3fee8c33699828ed(name, sport) {
    return (0, $2Yg5G.ValidPhysicsModelNames).includes(name) ? name : $1a0c093b02a4f537$export$39bc86f93fc020d3[sport];
}
const $1a0c093b02a4f537$export$6198c9b417281812 = {
    physicsModelName: $1a0c093b02a4f537$export$665c96f8af24c68b + $1a0c093b02a4f537$export$ccf4c60f2112295f
};
const $1a0c093b02a4f537$export$8dc29226dae387a2 = /*#__PURE__*/ $bh6RR.createContext($1a0c093b02a4f537$export$6198c9b417281812);
const $1a0c093b02a4f537$export$6689bb84ec90d310 = /*#__PURE__*/ $bh6RR.memo(({ children: children })=>{
    const { selected: selectedSport } = (0, $76QOg.useSelectedSport)();
    const baseModel = $1a0c093b02a4f537$export$39bc86f93fc020d3[selectedSport];
    const [physicsModel, setPhysicsModel] = $bh6RR.useState({
        physicsModelName: baseModel
    });
    $bh6RR.useEffect(()=>{
        setPhysicsModel({
            physicsModelName: baseModel
        });
    }, [
        baseModel
    ]);
    const { status: status } = (0, $ezs3H.useStatus)();
    $bh6RR.useEffect(()=>{
        if (status?.physics && status.physics.modelName !== physicsModel.physicsModelName) {
            (0, $1lMle.default).info(`Setting physics model to ${status.physics.modelName} from Coach Status`);
            setPhysicsModel({
                physicsModelName: status.physics.modelName
            });
        }
    }, [
        status?.physics,
        physicsModel.physicsModelName
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($1a0c093b02a4f537$export$8dc29226dae387a2.Provider, {
        value: physicsModel,
        children: children
    });
});
$1a0c093b02a4f537$export$6689bb84ec90d310.displayName = "PhysicsModelProvider";
function $1a0c093b02a4f537$export$2a50a044cc286e5c() {
    return $bh6RR.useContext($1a0c093b02a4f537$export$8dc29226dae387a2);
}

});
parcelRegister("2Yg5G", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/indent */ /* eslint-disable @typescript-eslint/dot-notation */ /* eslint-disable no-multiple-empty-lines */ /* eslint-disable @typescript-eslint/no-inferrable-types */ /* eslint-disable no-multi-spaces */ /* ______________________________________________________________________________
  Physics models  Data types used for modeling the trainer, ball launch/flight
  All geometric quantities are in 'physics coordinates' unless
  otherwise noted.
  See Also: Coordinate Systems and Units (in conversions.ts)
  ______________________________________________________________________________
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultSimulationParams = module.exports.DefaultPhysicalConstants = module.exports.CourtGeometryBySport = module.exports.BallParamsBySport = module.exports.CourtSurface = module.exports.ValidPhysicsModelNames = module.exports.Sports = module.exports.metersPerYard = module.exports.metersPerInch = module.exports.metersPerFoot = void 0;
module.exports.isSport = $229daaa53b3c32be$var$isSport;
// Length conversions (convenience)
module.exports.metersPerFoot = 0.3048;
module.exports.metersPerInch = 0.0254;
module.exports.metersPerYard = 0.9144;
/**
 * Sports
 */ module.exports.Sports = [
    "PLATFORM_TENNIS",
    "PADEL",
    "TENNIS",
    "PICKLEBALL",
    "LACROSSE"
];
function $229daaa53b3c32be$var$isSport(sport) {
    return module.exports.Sports.includes(sport);
}
/**
 * Physics Models
 */ module.exports.ValidPhysicsModelNames = [
    "physics-20B-base",
    "physics-20C-base",
    "physics-20D-base",
    "physics-20E-base",
    "physics-20F-base",
    "physics-20G-base",
    "physics-20H-base",
    "physics-20I-base",
    "physics-20X-base",
    "physics-30A-base",
    "physics-30B-base",
    "physics-30C-base",
    "physics-30D-base",
    "physics-30E-base",
    "physics-30X-base"
];
/**
 * CourtSurface
 * The surfaces the ball can hit.
 */ var $229daaa53b3c32be$var$CourtSurface;
(function(CourtSurface) {
    CourtSurface["Court"] = "Court";
    CourtSurface["LeftWall"] = "LeftWall";
    CourtSurface["RightWall"] = "RightWall";
    CourtSurface["BackWall"] = "BackWall";
    CourtSurface["Net"] = "Net";
})($229daaa53b3c32be$var$CourtSurface || (module.exports.CourtSurface = $229daaa53b3c32be$var$CourtSurface = {}));
module.exports.BallParamsBySport = {
    PLATFORM_TENNIS: {
        diameter: 0.0635,
        mass: 0.072,
        drag: 0.85
    },
    PADEL: {
        diameter: 0.067,
        mass: 0.0577,
        drag: 0.637
    },
    TENNIS: {
        diameter: 0.067,
        mass: 0.0577,
        drag: 0.637
    },
    PICKLEBALL: {
        diameter: 0.07425,
        mass: 24.3 * 0.001,
        drag: 0.525
    },
    // Lacrosse is thrown with a platform tennis ball: the trainer has not been
    // redesigned to feed a lacrosse ball. These values are deliberately identical
    // to PLATFORM_TENNIS above and should not be "corrected" to lacrosse-ball
    // figures unless the hardware actually changes.
    LACROSSE: {
        diameter: 0.0635,
        mass: 0.072,
        drag: 0.85
    }
};
/**
 * CourtGeometryBySport
 * Select sport-specific court geometry
 */ module.exports.CourtGeometryBySport = {
    PLATFORM_TENNIS: {
        PLATFORM_WIDTH: 30.0 * module.exports.metersPerFoot,
        PLATFORM_LENGTH: 60.0 * module.exports.metersPerFoot,
        COURT_WIDTH: 20.0 * module.exports.metersPerFoot,
        COURT_LENGTH: 44.0 * module.exports.metersPerFoot,
        SERVICE_WIDTH: 16.0 * module.exports.metersPerFoot,
        SERVICE_LENGTH: 24.0 * module.exports.metersPerFoot,
        NET_WIDTH: 26.0 * module.exports.metersPerFoot,
        NET_HEIGHT_POST: 3.083 * module.exports.metersPerFoot,
        NET_HEIGHT_CENTER: 2.833 * module.exports.metersPerFoot,
        WALL_HEIGHT: 12 * module.exports.metersPerFoot,
        TALL_WALL_HEIGHT: 0,
        TALL_WALL_SIDE_LENGTH: 0
    },
    PADEL: {
        PLATFORM_WIDTH: 10.0,
        PLATFORM_LENGTH: 20.0,
        COURT_WIDTH: 10.0,
        COURT_LENGTH: 20.0,
        SERVICE_WIDTH: 10.0,
        SERVICE_LENGTH: 14.0,
        NET_WIDTH: 10.0,
        NET_HEIGHT_POST: 0.92,
        NET_HEIGHT_CENTER: 0.88,
        WALL_HEIGHT: 3.0,
        TALL_WALL_HEIGHT: 4.0,
        TALL_WALL_SIDE_LENGTH: 2.0
    },
    TENNIS: {
        PLATFORM_WIDTH: 60.0 * module.exports.metersPerFoot,
        PLATFORM_LENGTH: 120.0 * module.exports.metersPerFoot,
        COURT_WIDTH: 36.0 * module.exports.metersPerFoot,
        COURT_LENGTH: 78.0 * module.exports.metersPerFoot,
        SERVICE_WIDTH: 27.0 * module.exports.metersPerFoot,
        SERVICE_LENGTH: 42.0 * module.exports.metersPerFoot,
        NET_WIDTH: 42.0 * module.exports.metersPerFoot,
        NET_HEIGHT_POST: 3.51 * module.exports.metersPerFoot,
        NET_HEIGHT_CENTER: 3.0 * module.exports.metersPerFoot,
        WALL_HEIGHT: 0,
        TALL_WALL_HEIGHT: 0,
        TALL_WALL_SIDE_LENGTH: 0
    },
    PICKLEBALL: {
        PLATFORM_WIDTH: 30.0 * module.exports.metersPerFoot,
        PLATFORM_LENGTH: 60.0 * module.exports.metersPerFoot,
        COURT_WIDTH: 20.0 * module.exports.metersPerFoot,
        COURT_LENGTH: 44.0 * module.exports.metersPerFoot,
        SERVICE_WIDTH: 20.0 * module.exports.metersPerFoot,
        // SERVICE_LENGTH = KITCHEN FOR PICKLEBALL
        SERVICE_LENGTH: 14.0 * module.exports.metersPerFoot,
        NET_WIDTH: 22.0 * module.exports.metersPerFoot,
        NET_HEIGHT_POST: 3.0 * module.exports.metersPerFoot,
        NET_HEIGHT_CENTER: 34.0 / 12.0 * module.exports.metersPerFoot,
        WALL_HEIGHT: 0,
        TALL_WALL_HEIGHT: 0,
        TALL_WALL_SIDE_LENGTH: 0
    },
    // Lacrosse is played on an open field: no net, no walls, no service boxes.
    // A zero NET_HEIGHT_CENTER / WALL_HEIGHT disables the net and wall bounce
    // tests outright - both are strict "ball z < height" comparisons.
    //
    // The playing volume has to be field-sized rather than court-sized:
    // PLATFORM_WIDTH/LENGTH are what TrainerSim._ballOutOfBounds() clips
    // against, and with the walls gone nothing else keeps a high-speed shot
    // inside the simulation.
    //
    // These are the MAXIMUM PERMITTED field dimensions, not any one field's
    // actual size, and that is the point: they are simulation bounds.
    //
    // A men's field of play is 110 x 60 yd. The women's rules permit
    // 110-120 x 60-70 yd and call 120 x 65 optimal. So 120 x 70 is not
    // "the women's field" - it is the largest field either code allows, which
    // is the only choice that is strictly permissive. No shot that would be
    // tracked on a real field of any variant is lost here. The cost is that on
    // a men's field the sim keeps tracking for up to ~4.6m past the real
    // sideline, which is invisible because nothing acts on the boundary.
    //
    // The drawn field is a different table in a different frame. Field
    // MARKINGS live in webby-app's util/lacrosse/geometry.ts, keyed by variant
    // and measured from the goal line rather than the field centre - that is
    // the simulation-bounds / court-markings split, performed at the module
    // level rather than as a change to the CourtGeometry type. Nothing else
    // needs these two to agree, because buildLayout never sees Lacrosse.
    //
    // workout-kinematics is still blocked, and not by this entry: naming where
    // a shot landed needs the VARIANT to pick the marking rectangle, and the
    // variant is presentation-only and deliberately never reaches the server.
    // That is a schema decision, not a geometry one.
    LACROSSE: {
        PLATFORM_WIDTH: 70.0 * module.exports.metersPerYard,
        PLATFORM_LENGTH: 120.0 * module.exports.metersPerYard,
        COURT_WIDTH: 70.0 * module.exports.metersPerYard,
        COURT_LENGTH: 120.0 * module.exports.metersPerYard,
        SERVICE_WIDTH: 0,
        SERVICE_LENGTH: 0,
        NET_WIDTH: 0,
        NET_HEIGHT_POST: 0,
        NET_HEIGHT_CENTER: 0,
        WALL_HEIGHT: 0,
        TALL_WALL_HEIGHT: 0,
        TALL_WALL_SIDE_LENGTH: 0
    }
};
/**
 * DefaultPhysicalConstants
 * Default values for the physical constants required for simulation.
 */ module.exports.DefaultPhysicalConstants = {
    gravity: 9.8,
    airDensity: 1.225,
    wallRestCoeff: 0.5,
    courtRestCoeff: 0.8,
    netRestCoeff: 0.01
};
/**
 * DefaultSimulationParams
 * Default values for parameters that control ball flight simulation.
 */ module.exports.DefaultSimulationParams = {
    timeStep: 0.001,
    duration: 5.0,
    bounces: 3,
    wallBounceEnabled: true,
    netBounceEnabled: true,
    maxSteps: 50,
    stepDecay: 0.6,
    stopDist: 0.001
};

});


parcelRegister("2Q7us", function(module, exports) {

$parcel$export(module.exports, "CourtImages", function () { return $6c177f3101a28634$export$551b8fa98983466; });
$parcel$export(module.exports, "IconDimensions", function () { return $6c177f3101a28634$export$1214d0573fa36003; });
$parcel$export(module.exports, "CourtTable", function () { return $6c177f3101a28634$export$ee5e73d2720771b8; });
$parcel$export(module.exports, "yawOffsetRangeForSport", function () { return $6c177f3101a28634$export$a31a89603b1e373a; });
$parcel$export(module.exports, "yawControlAvailable", function () { return $6c177f3101a28634$export$bade18e6fd247d45; });
$parcel$export(module.exports, "yawSliderMarks", function () { return $6c177f3101a28634$export$2dc73d0f591ff506; });
$parcel$export(module.exports, "panConeAvailable", function () { return $6c177f3101a28634$export$2d0972c1709fae26; });
$parcel$export(module.exports, "coordSysForSport", function () { return $6c177f3101a28634$export$b784389a218509af; });
$parcel$export(module.exports, "forcedPlayMode", function () { return $6c177f3101a28634$export$c1ed794674fd6c2a; });
$parcel$export(module.exports, "effectivePlayMode", function () { return $6c177f3101a28634$export$c6c2818ed6e70375; });

var $iirf7 = parcelRequire("iirf7");

const $6c177f3101a28634$var$padelCourtImage = new URL((parcelRequire("6ZS8W"))).toString();

const $6c177f3101a28634$var$padelHalfCourtImage = new URL((parcelRequire("k2N8v"))).toString();

const $6c177f3101a28634$var$platformCourtImage = new URL((parcelRequire("jx2Il"))).toString();

const $6c177f3101a28634$var$platformHalfCourtImage = new URL((parcelRequire("4rQtG"))).toString();

const $6c177f3101a28634$var$tennisCourtImage = new URL((parcelRequire("6hd5j"))).toString();

const $6c177f3101a28634$var$tennisHalfCourtImage = new URL((parcelRequire("de3Zt"))).toString();

const $6c177f3101a28634$var$pickleballCourtImage = new URL((parcelRequire("duhQj"))).toString();

const $6c177f3101a28634$var$pickleballHalfCourtImage = new URL((parcelRequire("7RPm1"))).toString();
const $6c177f3101a28634$export$551b8fa98983466 = {
    FULL: {
        PADEL: $6c177f3101a28634$var$padelCourtImage,
        PLATFORM_TENNIS: $6c177f3101a28634$var$platformCourtImage,
        TENNIS: $6c177f3101a28634$var$tennisCourtImage,
        PICKLEBALL: $6c177f3101a28634$var$pickleballCourtImage,
        /*
            An inline SVG data URL rather than a PNG, drawn from the same
            rulebook table the 3D field is. One diagram serves all three
            variants - see util/lacrosse/diagram.ts. FULL and HALF are the same
            image because lacrosse has no meaningful half-field.
        */ LACROSSE: (0, $iirf7.LACROSSE_DIAGRAM)
    },
    HALF: {
        PADEL: $6c177f3101a28634$var$padelHalfCourtImage,
        PLATFORM_TENNIS: $6c177f3101a28634$var$platformHalfCourtImage,
        TENNIS: $6c177f3101a28634$var$tennisHalfCourtImage,
        PICKLEBALL: $6c177f3101a28634$var$pickleballHalfCourtImage,
        LACROSSE: (0, $iirf7.LACROSSE_DIAGRAM)
    }
};
const $6c177f3101a28634$export$1214d0573fa36003 = {
    trainerMarkerWidth: 48,
    trainerMarkerHeight: 48,
    trainerRingWidth: 66,
    trainerRingHeight: 98,
    trainerSolidWidth: 48,
    trainerSolidHeight: 72,
    circleMarkerWidth: 36,
    circleMarkerHeight: 36
};
const $6c177f3101a28634$export$ee5e73d2720771b8 = {
    PADEL: {
        widthMeters: 10.2,
        heightMeters: {
            FULL: 20.2,
            HALF: 10.62
        },
        width: 400,
        height: {
            FULL: 778,
            HALF: 409
        },
        xOffset: 200,
        yOffset: {
            FULL: 389,
            HALF: 5
        }
    },
    PICKLEBALL: {
        widthMeters: 7.92,
        heightMeters: {
            FULL: 16.46,
            HALF: 8.23
        },
        width: 482,
        height: {
            FULL: 1000,
            HALF: 500
        },
        xOffset: 240,
        yOffset: {
            FULL: 500,
            HALF: -50
        }
    },
    PLATFORM_TENNIS: {
        widthMeters: 9.144,
        heightMeters: {
            FULL: 18.288,
            HALF: 11.6
        },
        width: 400,
        height: {
            FULL: 800,
            HALF: 507
        },
        xOffset: 200,
        yOffset: {
            FULL: 400,
            HALF: 107
        }
    },
    TENNIS: {
        widthMeters: 18.3,
        heightMeters: {
            FULL: 36.58,
            HALF: 24.7
        },
        width: 400,
        height: {
            FULL: 800,
            HALF: 540
        },
        xOffset: 200,
        yOffset: {
            FULL: 400,
            HALF: 140
        }
    },
    /*
        A 40 x 40 m square centred on the goal, at 12.5 px/m. Not a stretched
        tennis frame: tennis is 18.3 m wide and the lacrosse spots reach
        +/-15.9, so WIDTH is the binding constraint, not length.

        Square pixels and `yOffset === height / 2` are both load-bearing - see
        LACROSSE_COURT_DIMENSIONS, which is where they are explained and
        asserted.
    */ LACROSSE: (0, $iirf7.LACROSSE_COURT_DIMENSIONS)
};
function $6c177f3101a28634$export$a31a89603b1e373a(sport) {
    return sport === "LACROSSE" ? 90 : 75;
}
function $6c177f3101a28634$export$bade18e6fd247d45(sport) {
    return sport === "PICKLEBALL" || sport === "LACROSSE";
}
function $6c177f3101a28634$export$2dc73d0f591ff506(sport) {
    const limit = $6c177f3101a28634$export$a31a89603b1e373a(sport);
    const step = limit % 30 === 0 ? 30 : 25;
    const centre = sport === "LACROSSE" ? "Aimed" : "Forward";
    const values = [
        0
    ];
    for(let i = step; i < limit; i += step)values.push(i, -i);
    values.push(limit, -limit);
    return values.sort((a, b)=>a - b).map((value)=>({
            label: value === 0 ? centre : `${value}\xb0`,
            value: value
        }));
}
function $6c177f3101a28634$export$2d0972c1709fae26(sport) {
    return sport === "LACROSSE";
}
function $6c177f3101a28634$export$b784389a218509af(sport) {
    return sport === "PLATFORM_TENNIS" ? "court" : "physics";
}
/**
 * Apps whose drills must never alternate sides, whatever the setup.
 *
 * 15, AOI Triggered, and 19, its lacrosse fork, are here because the drill is
 * built around a trigger zone the player stands in: the shots answer where
 * that player IS, so replaying each one at the mirrored pan aims the answer at
 * a zone nobody is standing in.
 * The app has always hidden the "both" button for that reason; this stops the
 * lacrosse two-cage setup forcing the mode back on behind its back.
 */ const $6c177f3101a28634$var$NO_DUAL_APP_IDS = [
    15,
    19
];
function $6c177f3101a28634$export$28e4a1362d0061bc(appId) {
    return appId === undefined || !$6c177f3101a28634$var$NO_DUAL_APP_IDS.includes(appId);
}
function $6c177f3101a28634$export$c1ed794674fd6c2a(sport, lacrosseTwoCage, spread, appId) {
    if (sport !== "LACROSSE") return null;
    if (!$6c177f3101a28634$export$28e4a1362d0061bc(appId)) return "standard";
    if (spread !== "one-sided") return "standard";
    return lacrosseTwoCage ? "dual" : null;
}
function $6c177f3101a28634$export$c6c2818ed6e70375(requested, sport, lacrosseTwoCage, spread, appId) {
    const forced = $6c177f3101a28634$export$c1ed794674fd6c2a(sport, lacrosseTwoCage, spread, appId);
    if (forced !== null) return forced;
    if (sport === "LACROSSE" && requested === "mirror") return "standard";
    return requested;
}

});
parcelRegister("iirf7", function(module, exports) {

$parcel$export(module.exports, "LACROSSE_DIAGRAM", function () { return $edcab28737d09ac0$export$e02c9e7becb42dd9; });
$parcel$export(module.exports, "LACROSSE_TWO_CAGE_DIAGRAM", function () { return $edcab28737d09ac0$export$864462704c4c28dc; });
$parcel$export(module.exports, "LACROSSE_COURT_DIMENSIONS", function () { return $edcab28737d09ac0$export$b5559e5ae2432291; });
/*
    The 2D placement diagram for lacrosse, as an inline SVG data URL.

    The tennis court diagram cannot be stretched to serve. Its frame is
    18.3 m wide (+/-9.15) and the lacrosse spots reach +/-15.9 - width is the
    binding constraint, not length. So lacrosse gets its own frame: a 40 x 40 m
    square centred on the goal, at 12.5 px/m.

    ONE STATIC DIAGRAM SERVES ALL THREE VARIANTS. That is not a simplification.
    At this zoom no end line, sideline, restraining line, wing line or centre
    circle is in frame for any variant, and everything that IS in frame - the
    goal, the crease and goal circle, the 8 m arc, the 12 m fan with its flat
    sides and 45 degree legs, the arc's centre hash and the below-goal dots -
    is identical in women's and mixed and absent from men's. Drawing the union
    is correct for two variants and harmless for the third, whose arc and fan
    the 3D view shows as dashed drill rings.

    THE TWO-CAGE DIAGRAM CARRIES NO PAINT. That drill is set up on a practice
    field rather than a marked one, so its diagram is two cages and the line
    between them and nothing else - see buildSvg.

    A `data:image/svg+xml` URL is a string and a valid `<img src>`, so
    CourtImages stays `Record<CourtSize, Record<Sport, string>>` and all four
    of its consumers are untouched.

    Rejected alternatives: a canvas plus toDataURL() (needs a DOM at module
    scope, so it breaks in any DOM-less context and produces a much larger
    base64 PNG), and widening CourtImages to `(variant) => string` (ripples to
    four consumers for a variant-dependence that does not exist).
*/ 
var $fLW8f = parcelRequire("fLW8f");

var $gJv9f = parcelRequire("gJv9f");
const $edcab28737d09ac0$export$d62d450b01975589 = 20;
const $edcab28737d09ac0$export$90f7b3f2f37867f = 500;
const $edcab28737d09ac0$export$309b5567c543b4b6 = $edcab28737d09ac0$export$90f7b3f2f37867f / ($edcab28737d09ac0$export$d62d450b01975589 * 2);
/**
 * Painted lines are 5 cm, which is 0.6 px here and invisible. The diagram is a
 * plan to place a machine against, not a scale drawing, so lines are drawn at
 * a legible width instead of a true one.
 */ const $edcab28737d09ac0$var$STROKE = 1.4;
const $edcab28737d09ac0$var$THIN_STROKE = 1;
/** Physics metres -> diagram pixels. +y is up the page, so py is inverted. */ function $edcab28737d09ac0$var$px(x) {
    return $edcab28737d09ac0$var$round(x * $edcab28737d09ac0$export$309b5567c543b4b6 + $edcab28737d09ac0$export$90f7b3f2f37867f / 2);
}
function $edcab28737d09ac0$var$py(y) {
    return $edcab28737d09ac0$var$round($edcab28737d09ac0$export$90f7b3f2f37867f / 2 - y * $edcab28737d09ac0$export$309b5567c543b4b6);
}
function $edcab28737d09ac0$var$len(metres) {
    return $edcab28737d09ac0$var$round(metres * $edcab28737d09ac0$export$309b5567c543b4b6);
}
function $edcab28737d09ac0$var$round(value) {
    return Math.round(value * 100) / 100;
}
const $edcab28737d09ac0$export$c208b88b766569b = {
    /*
        Turf, not paper.

        `forestgreen` is the closest CSS named colour to the 3D field's
        surface (#47903b), which the named-colour rule above rules out
        directly. A white ground was almost unreadable in the picker: the
        selected player marker is a light pin, and a light pin on white is the
        one combination that hides it.
    */ ground: "forestgreen",
    /*
        Field paint is white, and on turf it has to be - `dimgray` was chosen
        against a white ground and inverts to near-invisible on green.
    */ line: "white",
    faint: "silver",
    cage: "darkorange",
    /*
        The two-cage range guide. Deliberately labelled in yards as well as
        drawn: a coach reading this needs to know the line runs 3 to 15, and a
        line that only differs from the paint by colour tells them nothing.

        `gold` rather than the old `teal`, which was a dark blue-green on a
        white page and is nearly the ground colour on a green one.
    */ guide: "gold"
};
const $edcab28737d09ac0$var$COLOR = $edcab28737d09ac0$export$c208b88b766569b;
/** Straight `x1,y1 -> x2,y2` in metres. */ function $edcab28737d09ac0$var$line(x1, y1, x2, y2, stroke = $edcab28737d09ac0$var$STROKE, color = $edcab28737d09ac0$var$COLOR.line) {
    return `<line x1="${$edcab28737d09ac0$var$px(x1)}" y1="${$edcab28737d09ac0$var$py(y1)}" x2="${$edcab28737d09ac0$var$px(x2)}" y2="${$edcab28737d09ac0$var$py(y2)}"` + ` stroke="${color}" stroke-width="${stroke}"/>`;
}
/** Circle about the goal centre, radius in metres. */ function $edcab28737d09ac0$var$circle(r, stroke = $edcab28737d09ac0$var$STROKE, color = $edcab28737d09ac0$var$COLOR.line) {
    return `<circle cx="${$edcab28737d09ac0$var$px(0)}" cy="${$edcab28737d09ac0$var$py(0)}" r="${$edcab28737d09ac0$var$len(r)}"` + ` fill="none" stroke="${color}" stroke-width="${stroke}"/>`;
}
/**
 * Arc about the goal centre, opening DOWNFIELD (-y), spanning +/-halfAngle off
 * the downfield axis.
 *
 * Bearing b maps to physics (r sin b, -r cos b), which is the same convention
 * spots.ts uses, so an arc drawn here and a spot placed on it cannot disagree.
 */ function $edcab28737d09ac0$var$arc(r, halfAngle, stroke = $edcab28737d09ac0$var$STROKE) {
    const from = {
        x: r * Math.sin(-halfAngle),
        y: -r * Math.cos(-halfAngle)
    };
    const to = {
        x: r * Math.sin(halfAngle),
        y: -r * Math.cos(halfAngle)
    };
    // sweep-flag 0: from the -x end to the +x end the short way, through
    // straight-downfield. large-arc-flag is 0 while halfAngle < 90 deg.
    const large = halfAngle > Math.PI / 2 ? 1 : 0;
    return `<path d="M ${$edcab28737d09ac0$var$px(from.x)} ${$edcab28737d09ac0$var$py(from.y)}` + ` A ${$edcab28737d09ac0$var$len(r)} ${$edcab28737d09ac0$var$len(r)} 0 ${large} 0 ${$edcab28737d09ac0$var$px(to.x)} ${$edcab28737d09ac0$var$py(to.y)}"` + ` fill="none" stroke="${$edcab28737d09ac0$var$COLOR.line}" stroke-width="${stroke}"/>`;
}
/** A short text label, anchored at a point in metres. */ function $edcab28737d09ac0$var$text(x, y, body, anchor = "start") {
    return `<text x="${$edcab28737d09ac0$var$px(x)}" y="${$edcab28737d09ac0$var$py(y)}" fill="${$edcab28737d09ac0$var$COLOR.guide}"` + ` font-family="sans-serif" font-size="13" font-weight="600"` + ` text-anchor="${anchor}">${body}</text>`;
}
/**
 * One cage, mouth on the goal line at `cx`, netting tapering behind it.
 *
 * Same orange as the 3D pipe, so the two views read as the same object, and the
 * netting tapers behind the mouth (+y) - which is what tells a reader which way
 * the machine is meant to face.
 */ function $edcab28737d09ac0$var$cage(cx) {
    const gw = (0, $fLW8f.GOAL).halfWidth;
    return [
        `<path d="M ${$edcab28737d09ac0$var$px(cx - gw)} ${$edcab28737d09ac0$var$py(0)} L ${$edcab28737d09ac0$var$px(cx)} ${$edcab28737d09ac0$var$py((0, $fLW8f.GOAL).netDepth)}` + ` L ${$edcab28737d09ac0$var$px(cx + gw)} ${$edcab28737d09ac0$var$py(0)} Z"` + ` fill="${$edcab28737d09ac0$var$COLOR.faint}" fill-opacity="0.35" stroke="${$edcab28737d09ac0$var$COLOR.faint}" stroke-width="${$edcab28737d09ac0$var$THIN_STROKE}"/>`,
        $edcab28737d09ac0$var$line(cx - gw, 0, cx + gw, 0, 3, $edcab28737d09ac0$var$COLOR.cage)
    ];
}
/**
 * The two-cage drill's range guide: the bisector line the machine stands on,
 * ticked at every whole yard and labelled at both ends.
 *
 * Drawn because the two-cage picker offers no clickable markers - the distance
 * is a slider - so without this the diagram would give no hint of where the
 * machine may go or how far the range reaches.
 */ function $edcab28737d09ac0$var$rangeGuide() {
    const { near: near, far: far } = (0, $gJv9f.LACROSSE_TWO_CAGE_YARDS);
    const out = [
        `<line x1="${$edcab28737d09ac0$var$px(0)}" y1="${$edcab28737d09ac0$var$py(-near * (0, $fLW8f.YD))}"` + ` x2="${$edcab28737d09ac0$var$px(0)}" y2="${$edcab28737d09ac0$var$py(-far * (0, $fLW8f.YD))}"` + ` stroke="${$edcab28737d09ac0$var$COLOR.guide}" stroke-width="${$edcab28737d09ac0$var$STROKE}" stroke-dasharray="6 4"/>`
    ];
    for(let yards = near; yards <= far; yards += 1){
        const y = -yards * (0, $fLW8f.YD);
        const half = yards % 5 === 0 ? 0.6 : 0.3;
        out.push($edcab28737d09ac0$var$line(-half, y, half, y, $edcab28737d09ac0$var$THIN_STROKE, $edcab28737d09ac0$var$COLOR.guide));
    }
    out.push($edcab28737d09ac0$var$text(0.9, -near * (0, $fLW8f.YD) - 0.35, `${near} yd`));
    out.push($edcab28737d09ac0$var$text(0.9, -far * (0, $fLW8f.YD) - 0.35, `${far} yd`));
    return out;
}
/**
 * Every painted marking in frame: the 12 m fan, the 8 m arc and its 45 degree
 * legs, both goal-area circles, the arc's centre hash and the below-goal dots.
 *
 * Drawn for the ONE-cage placement only. Every spot in that mode is a radius
 * off one of these, so the paint is what a coach lines the machine up against.
 */ function $edcab28737d09ac0$var$markings() {
    const { goalCircleR: goalCircleR, arcR: arcR, fanR: fanR, angleLeg: angleLeg, dotBack: dotBack } = (0, $fLW8f.DRILL_GEOMETRY);
    const creaseR = (0, $fLW8f.LACROSSE_FIELDS).MENS.creaseR;
    const half = (0, $fLW8f.arcHalfAngle)((0, $fLW8f.LACROSSE_FIELDS).WOMENS);
    const leg = angleLeg / Math.SQRT2;
    // 12 m fan: the semicircle, its flat sides along the GLE (goal line
    // extended), and the 45 degree legs closing the 8 m arc onto the goal
    // circle.
    const out = [
        $edcab28737d09ac0$var$arc(fanR, Math.PI / 2),
        $edcab28737d09ac0$var$arc(arcR, half)
    ];
    for (const sx of [
        1,
        -1
    ]){
        out.push($edcab28737d09ac0$var$line(sx * goalCircleR, 0, sx * fanR, 0));
        out.push($edcab28737d09ac0$var$line(sx * goalCircleR, 0, sx * (goalCircleR + leg), -leg));
    }
    /*
        Both goal-area circles. The men's crease is 9 ft (2.743 m) and the
        women's goal circle 8'6" (2.6 m) - 14 cm apart, so they read as a
        double line at this scale, and each is correct on some field.
    */ out.push($edcab28737d09ac0$var$circle(creaseR, $edcab28737d09ac0$var$THIN_STROKE));
    out.push($edcab28737d09ac0$var$circle(goalCircleR, $edcab28737d09ac0$var$THIN_STROKE));
    // The arc's centre hash, 1 ft on the goal-line perpendicular. The most
    // findable mark on the field.
    out.push($edcab28737d09ac0$var$line(-0.152, -arcR, 0.152, -arcR, $edcab28737d09ac0$var$STROKE));
    // Below-goal dots, 5 yd behind the goal line at +/-goalCircleR.
    for (const sx of [
        1,
        -1
    ])out.push($edcab28737d09ac0$var$line(sx * goalCircleR - 0.15, dotBack, sx * goalCircleR + 0.15, dotBack, $edcab28737d09ac0$var$STROKE));
    return out;
}
function $edcab28737d09ac0$var$buildSvg(twoCage) {
    const parts = [
        `<rect x="0" y="0" width="${$edcab28737d09ac0$export$90f7b3f2f37867f}" height="${$edcab28737d09ac0$export$90f7b3f2f37867f}" fill="${$edcab28737d09ac0$var$COLOR.ground}"/>`
    ];
    /*
        NO PAINT IN TWO-CAGE MODE. A two-cage drill gets set up on a practice
        field, which has no markings on it - so drawing the arc and the fan
        would be a picture of a field the coach is not standing on, and worse,
        it would suggest they should be lining the cages up against paint that
        is not there. All they need is the two cages and the line between them.

        One cage is the other way round: every spot in that mode is a radius off
        one of these markings, so the paint IS the thing being placed against.
    */ if (twoCage) {
        const half = (0, $fLW8f.TWO_GOAL_OFFSET_X) / 2;
        // Cages last so they sit on top of the guide line running between them.
        parts.push(...$edcab28737d09ac0$var$rangeGuide(), ...$edcab28737d09ac0$var$cage(-half), ...$edcab28737d09ac0$var$cage(half));
    } else parts.push(...$edcab28737d09ac0$var$markings(), ...$edcab28737d09ac0$var$cage(0));
    /*
        The opening tag is ONE template literal, deliberately. Split across
        concatenated literals - which is how this was written - the production
        minifier folded the join and dropped a quote, emitting

            width="500" height="500 viewBox="0 0 500 500"

        The trigger is a literal that ends in a substitution immediately
        followed by a closing quote (`height="${X}"`) being concatenated with
        the next one; the other builders here end in `/>` and came through
        intact. That is invalid XML, so the browser refused the data: URL, the
        court image reported a load error, and the position editors showed
        "Unable to load required images" - with no failed request in the
        network tab, because a data: URL never makes one.

        It only ever reproduced in an optimised build, so keep this as a single
        literal and check `npm run build` output, not just the dev server, if
        it is ever reflowed.
    */ const open = `<svg xmlns="http://www.w3.org/2000/svg" width="${$edcab28737d09ac0$export$90f7b3f2f37867f}" height="${$edcab28737d09ac0$export$90f7b3f2f37867f}" viewBox="0 0 ${$edcab28737d09ac0$export$90f7b3f2f37867f} ${$edcab28737d09ac0$export$90f7b3f2f37867f}">`;
    return open + parts.join("") + `</svg>`;
}
const $edcab28737d09ac0$export$e02c9e7becb42dd9 = `data:image/svg+xml,${encodeURIComponent($edcab28737d09ac0$var$buildSvg(false))}`;
const $edcab28737d09ac0$export$864462704c4c28dc = `data:image/svg+xml,${encodeURIComponent($edcab28737d09ac0$var$buildSvg(true))}`;
const $edcab28737d09ac0$export$b5559e5ae2432291 = {
    widthMeters: $edcab28737d09ac0$export$d62d450b01975589 * 2,
    heightMeters: {
        FULL: $edcab28737d09ac0$export$d62d450b01975589 * 2,
        HALF: $edcab28737d09ac0$export$d62d450b01975589 * 2
    },
    width: $edcab28737d09ac0$export$90f7b3f2f37867f,
    height: {
        FULL: $edcab28737d09ac0$export$90f7b3f2f37867f,
        HALF: $edcab28737d09ac0$export$90f7b3f2f37867f
    },
    xOffset: $edcab28737d09ac0$export$90f7b3f2f37867f / 2,
    yOffset: {
        FULL: $edcab28737d09ac0$export$90f7b3f2f37867f / 2,
        HALF: $edcab28737d09ac0$export$90f7b3f2f37867f / 2
    }
};

});

parcelRegister("6ZS8W", function(module, exports) {
module.exports = $parcel$resolve("lfwpa");

});

parcelRegister("k2N8v", function(module, exports) {
module.exports = $parcel$resolve("ewXUA");

});

parcelRegister("jx2Il", function(module, exports) {
module.exports = $parcel$resolve("fOgys");

});

parcelRegister("4rQtG", function(module, exports) {
module.exports = $parcel$resolve("898SG");

});

parcelRegister("6hd5j", function(module, exports) {
module.exports = $parcel$resolve("aOorz");

});

parcelRegister("de3Zt", function(module, exports) {
module.exports = $parcel$resolve("7ReGb");

});

parcelRegister("duhQj", function(module, exports) {
module.exports = $parcel$resolve("7G039");

});

parcelRegister("7RPm1", function(module, exports) {
module.exports = $parcel$resolve("jkT2m");

});


parcelRegister("8c9Rq", function(module, exports) {

$parcel$export(module.exports, "pointInPolygon", function () { return $5501deb09d9431ed$export$7f6bc8d3d7d61b11; });
$parcel$export(module.exports, "projected2Image", function () { return $5501deb09d9431ed$export$3930bf68712f69ff; });
$parcel$export(module.exports, "image2Projected", function () { return $5501deb09d9431ed$export$6c61ada53ee218e1; });
$parcel$export(module.exports, "sideKeys", function () { return $5501deb09d9431ed$export$66cac5b14d71aa71; });
$parcel$export(module.exports, "mirrorShot", function () { return $5501deb09d9431ed$export$dc65a2133565d7a; });
$parcel$export(module.exports, "mirrorPlayer", function () { return $5501deb09d9431ed$export$c78ba13c5aeb1238; });
$parcel$export(module.exports, "mirrorPlayerForDual", function () { return $5501deb09d9431ed$export$3f8f398e223485c8; });
$parcel$export(module.exports, "mirrorTrainer", function () { return $5501deb09d9431ed$export$e575134e5a6e7eb5; });
$parcel$export(module.exports, "isCenterWorkout", function () { return $5501deb09d9431ed$export$918be100d407a11d; });
$parcel$export(module.exports, "playerPointIsSelectable", function () { return $5501deb09d9431ed$export$41357185870edc26; });

var $dlcrP = parcelRequire("dlcrP");

var $hz16f = parcelRequire("hz16f");
function $5501deb09d9431ed$export$b141efd0b0fb9174(a, b) {
    return a?.x === b?.x && a?.y === b?.y && a?.yaw === b?.yaw;
}
function $5501deb09d9431ed$export$f6301c12f124af2(coord, width, height) {
    const { x: x, y: y, sys: sys } = coord;
    let w = width;
    let h = height;
    if (sys === "court") {
        // the values need to be converted from m to mm
        w = width * 1000;
        h = height * 1000;
    }
    // distance to opposite baseline
    const a = sys === "court" ? y : h / 2 - y;
    const b = sys === "court" ? Math.abs(x - w / 2) : Math.abs(x);
    // yaw is calculated as the inverse sin of side b divided by side c
    const c = Math.sqrt(a ** 2 + b ** 2);
    const yaw = Math.asin(b / c);
    if (sys === "court") {
        if (x > w / 2) return -yaw;
        return yaw;
    }
    if (x > 0) return -yaw;
    return yaw;
}
function $5501deb09d9431ed$export$7f6bc8d3d7d61b11(x, y, hitBox) {
    const xmin = hitBox.x - hitBox.w / 2;
    const xmax = hitBox.x + hitBox.w / 2;
    const ymin = hitBox.y - hitBox.h / 2;
    const ymax = hitBox.y + hitBox.h / 2;
    return x >= xmin && x <= xmax && y >= ymin && y <= ymax;
}
function $5501deb09d9431ed$export$3930bf68712f69ff(coord, scaled) {
    const { x: x, y: y } = coord;
    let x1 = x;
    let y1 = y;
    if (coord.sys === "court") {
        const physics = (0, $dlcrP.convert).localization2physics({
            x: x,
            y: y,
            z: 1000
        });
        x1 = physics.x;
        y1 = physics.y;
    }
    const projected = {
        x: x1 * scaled.widthPPM + scaled.xOffset,
        y: y1 >= 0 ? scaled.yOffset - y1 * scaled.heightPPM : Math.abs(y1 * scaled.heightPPM) + scaled.yOffset
    };
    return projected;
}
function $5501deb09d9431ed$export$6c61ada53ee218e1(coord, scaled) {
    const { x: x, y: y } = coord;
    return {
        x: (x - scaled.xOffset) / scaled.widthPPM,
        y: (scaled.yOffset - y) / scaled.heightPPM
    };
}
function $5501deb09d9431ed$export$ab104502c42f6531(coord, sport) {
    if (sport === "PLATFORM_TENNIS" && coord.x <= (0, $hz16f.COURT_WIDTH_MM) / 2) return "deuce";
    if (coord.x < 0) return "deuce";
    return "ad";
}
function $5501deb09d9431ed$export$66cac5b14d71aa71(coord, sport) {
    const side = $5501deb09d9431ed$export$ab104502c42f6531(coord, sport);
    if (side === "deuce") return {
        adKey: "mirror",
        deuceKey: "standard"
    };
    return {
        adKey: "standard",
        deuceKey: "mirror"
    };
}
function $5501deb09d9431ed$export$dc65a2133565d7a(shot, manualTrim = 0) {
    const { pan: pan } = shot;
    return {
        ...shot,
        pan: -pan + manualTrim
    };
}
function $5501deb09d9431ed$export$c78ba13c5aeb1238(coord, sport) {
    const { x: x, y: y } = coord;
    // We're assuming positions are still in old mm system for platform tennis
    if (sport === "PLATFORM_TENNIS") return {
        y: y,
        x: (0, $hz16f.COURT_WIDTH_MM) - x,
        sys: "court"
    };
    return {
        y: y,
        x: -x,
        sys: "physics"
    };
}
function $5501deb09d9431ed$export$c9f657eee05d6ec(coord, trainer) {
    // Unit vector along the machine's heading.
    const dx = Math.sin(trainer.yaw);
    const dy = Math.cos(trainer.yaw);
    // The player relative to the machine, split into the part along the aim
    // (kept) and the part across it (negated).
    const vx = coord.x - trainer.x;
    const vy = coord.y - trainer.y;
    const along = vx * dx + vy * dy;
    return {
        x: trainer.x + 2 * along * dx - vx,
        y: trainer.y + 2 * along * dy - vy,
        sys: "physics"
    };
}
function $5501deb09d9431ed$export$3f8f398e223485c8(coord, trainer, sport) {
    if (sport !== "LACROSSE" || !trainer) return $5501deb09d9431ed$export$c78ba13c5aeb1238(coord, sport);
    return $5501deb09d9431ed$export$c9f657eee05d6ec(coord, trainer);
}
function $5501deb09d9431ed$export$e575134e5a6e7eb5(position, sport) {
    const { x: x, y: y, yaw: yaw, heightIn: heightIn } = position;
    // We're assuming positions are still in old mm system for platform tennis
    if (sport === "PLATFORM_TENNIS") return {
        y: y,
        heightIn: heightIn,
        yaw: -yaw,
        x: (0, $hz16f.COURT_WIDTH_MM) - x
    };
    return {
        y: y,
        heightIn: heightIn,
        yaw: -yaw,
        x: -x
    };
}
const $5501deb09d9431ed$var$ALLOWED_DIFF = 0.61; // 2 feet from center line in meters
function $5501deb09d9431ed$export$918be100d407a11d(positionX, sport) {
    if (sport === "PLATFORM_TENNIS" && Math.abs(positionX - (0, $hz16f.COURT_WIDTH_MM) / 2) < $5501deb09d9431ed$var$ALLOWED_DIFF * 1000) return true;
    if (sport !== "PLATFORM_TENNIS" && Math.abs(positionX) < $5501deb09d9431ed$var$ALLOWED_DIFF) return true;
    return false;
}
function $5501deb09d9431ed$export$41357185870edc26(sport, point) {
    return sport === "LACROSSE" || point.y > 0;
}

});
parcelRegister("dlcrP", function(module, exports) {
"use strict";
var $9b66e467feb793bf$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9b66e467feb793bf$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9b66e467feb793bf$var$__importStar = module.exports && module.exports.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $9b66e467feb793bf$var$__createBinding(result, mod, k[i]);
        }
        $9b66e467feb793bf$var$__setModuleDefault(result, mod);
        return result;
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.util = module.exports.adjust = module.exports.model = module.exports.TrainerSim = module.exports.sim = module.exports.convert = void 0;

/**
 * v1's API (TrainerSim, convert) on the engine, as drop-in replacements:
 * `const { sim, convert, model } = compat` stands in for the package's
 * top-level namespaces. See docs/compat.md for what differs.
 */ module.exports.convert = $9b66e467feb793bf$var$__importStar((parcelRequire("kZnrE")));

module.exports.sim = $9b66e467feb793bf$var$__importStar((parcelRequire("gsW5g")));

var $5OQUE = parcelRequire("5OQUE");
Object.defineProperty(module.exports, "TrainerSim", {
    enumerable: true,
    get: function() {
        return $5OQUE.TrainerSim;
    }
});

module.exports.model = $9b66e467feb793bf$var$__importStar((parcelRequire("2Yg5G")));

module.exports.adjust = $9b66e467feb793bf$var$__importStar((parcelRequire("gV6Yw")));

module.exports.util = $9b66e467feb793bf$var$__importStar((parcelRequire("fdyC4")));

});
parcelRegister("kZnrE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setPhysicsModel = module.exports.getPhysicsModel = module.exports.vector2Angle = module.exports.crossProduct = module.exports.angle2Vector = void 0;
module.exports.yawpitch2launchpoint = $f47bb0d16d8959dd$var$yawpitch2launchpoint;
module.exports.trainer2lift = $f47bb0d16d8959dd$var$trainer2lift;
module.exports.lift2trainer = $f47bb0d16d8959dd$var$lift2trainer;
module.exports.localization2physics = $f47bb0d16d8959dd$var$localization2physics;
module.exports.physics2localization = $f47bb0d16d8959dd$var$physics2localization;
module.exports.trainer2physics = $f47bb0d16d8959dd$var$trainer2physics;
module.exports.physics2trainer = $f47bb0d16d8959dd$var$physics2trainer;
module.exports.motorspin2ballspin = $f47bb0d16d8959dd$var$motorspin2ballspin;
module.exports.ballspin2motorspin = $f47bb0d16d8959dd$var$ballspin2motorspin;
module.exports.motorspin2spinlevel = $f47bb0d16d8959dd$var$motorspin2spinlevel;
module.exports.spinlevel2motorspin = $f47bb0d16d8959dd$var$spinlevel2motorspin;
module.exports.ballspin2spinlevel = $f47bb0d16d8959dd$var$ballspin2spinlevel;
module.exports.spinlevel2ballspin = $f47bb0d16d8959dd$var$spinlevel2ballspin;
module.exports.maxmotorspin_for_rpmspeed = $f47bb0d16d8959dd$var$maxmotorspin_for_rpmspeed;
module.exports.maxspinlevel_for_rpmspeed = $f47bb0d16d8959dd$var$maxspinlevel_for_rpmspeed;
module.exports.maxspinlevel = $f47bb0d16d8959dd$var$maxspinlevel;
module.exports.rpm2mps = $f47bb0d16d8959dd$var$rpm2mps;
module.exports.mps2rpm = $f47bb0d16d8959dd$var$mps2rpm;
module.exports.rpm2speedspin = $f47bb0d16d8959dd$var$rpm2speedspin;
module.exports.speedspin2rpm = $f47bb0d16d8959dd$var$speedspin2rpm;
module.exports.cameraHeight2HeadHeight = $f47bb0d16d8959dd$var$cameraHeight2HeadHeight;
module.exports.launchHeight2HeadHeight = $f47bb0d16d8959dd$var$launchHeight2HeadHeight;
module.exports.launchHeightInches2HeadHeight = $f47bb0d16d8959dd$var$launchHeightInches2HeadHeight;

var $jPwy6 = parcelRequire("jPwy6");

var $lFXDt = parcelRequire("lFXDt");
Object.defineProperty(module.exports, "angle2Vector", {
    enumerable: true,
    get: function() {
        return $lFXDt.angle2Vector;
    }
});
Object.defineProperty(module.exports, "crossProduct", {
    enumerable: true,
    get: function() {
        return $lFXDt.crossProduct;
    }
});
Object.defineProperty(module.exports, "vector2Angle", {
    enumerable: true,
    get: function() {
        return $lFXDt.vector2Angle;
    }
});

var $jPwy6 = parcelRequire("jPwy6");
Object.defineProperty(module.exports, "getPhysicsModel", {
    enumerable: true,
    get: function() {
        return $jPwy6.getPhysicsModel;
    }
});
Object.defineProperty(module.exports, "setPhysicsModel", {
    enumerable: true,
    get: function() {
        return $jPwy6.setPhysicsModel;
    }
});
function $f47bb0d16d8959dd$var$yawpitch2launchpoint(yawDeg, pitchDeg) {
    return (0, $jPwy6.globalConversions)().yawpitch2launchpoint(yawDeg, pitchDeg);
}
function $f47bb0d16d8959dd$var$trainer2lift(pTrainer) {
    return (0, $jPwy6.globalConversions)().trainer2lift(pTrainer);
}
function $f47bb0d16d8959dd$var$lift2trainer(pLift) {
    return (0, $jPwy6.globalConversions)().lift2trainer(pLift);
}
function $f47bb0d16d8959dd$var$localization2physics(pLocalization) {
    return (0, $jPwy6.globalConversions)().localization2physics(pLocalization);
}
function $f47bb0d16d8959dd$var$physics2localization(pPhysics) {
    return (0, $jPwy6.globalConversions)().physics2localization(pPhysics);
}
function $f47bb0d16d8959dd$var$trainer2physics(pTrainer, pTrainerPosition, trainerYaw) {
    return (0, $jPwy6.globalConversions)().trainer2physics(pTrainer, pTrainerPosition, trainerYaw);
}
function $f47bb0d16d8959dd$var$physics2trainer(pPhysics, pTrainerPosition, trainerYaw) {
    return (0, $jPwy6.globalConversions)().physics2trainer(pPhysics, pTrainerPosition, trainerYaw);
}
function $f47bb0d16d8959dd$var$motorspin2ballspin(motorspinRPM) {
    return (0, $jPwy6.globalConversions)().motorspin2ballspin(motorspinRPM);
}
function $f47bb0d16d8959dd$var$ballspin2motorspin(ballspinRPM) {
    return (0, $jPwy6.globalConversions)().ballspin2motorspin(ballspinRPM);
}
function $f47bb0d16d8959dd$var$motorspin2spinlevel(motorspinRPM) {
    return (0, $jPwy6.globalConversions)().motorspin2spinlevel(motorspinRPM);
}
function $f47bb0d16d8959dd$var$spinlevel2motorspin(spinLevel) {
    return (0, $jPwy6.globalConversions)().spinlevel2motorspin(spinLevel);
}
function $f47bb0d16d8959dd$var$ballspin2spinlevel(ballspinRPM) {
    return (0, $jPwy6.globalConversions)().ballspin2spinlevel(ballspinRPM);
}
function $f47bb0d16d8959dd$var$spinlevel2ballspin(spinlevel) {
    return (0, $jPwy6.globalConversions)().spinlevel2ballspin(spinlevel);
}
function $f47bb0d16d8959dd$var$maxmotorspin_for_rpmspeed(angle, launch_speed_rpm) {
    return (0, $jPwy6.globalConversions)().maxmotorspin_for_rpmspeed(angle, launch_speed_rpm);
}
function $f47bb0d16d8959dd$var$maxspinlevel_for_rpmspeed(angle, launch_speed_rpm) {
    return (0, $jPwy6.globalConversions)().maxspinlevel_for_rpmspeed(angle, launch_speed_rpm);
}
function $f47bb0d16d8959dd$var$maxspinlevel(angle, speed) {
    return (0, $jPwy6.globalConversions)().maxspinlevel(angle, speed);
}
function $f47bb0d16d8959dd$var$rpm2mps(rpm) {
    return (0, $jPwy6.globalConversions)().rpm2mps(rpm);
}
function $f47bb0d16d8959dd$var$mps2rpm(mps) {
    return (0, $jPwy6.globalConversions)().mps2rpm(mps);
}
function $f47bb0d16d8959dd$var$rpm2speedspin(rpms) {
    return (0, $jPwy6.globalConversions)().rpm2speedspin(rpms);
}
function $f47bb0d16d8959dd$var$speedspin2rpm(speedSpin) {
    return (0, $jPwy6.globalConversions)().speedspin2rpm(speedSpin);
}
function $f47bb0d16d8959dd$var$cameraHeight2HeadHeight(cameraHeightMeters) {
    return (0, $jPwy6.globalConversions)().cameraHeight2HeadHeight(cameraHeightMeters);
}
function $f47bb0d16d8959dd$var$launchHeight2HeadHeight(launchHeightMeters) {
    return (0, $jPwy6.globalConversions)().launchHeight2HeadHeight(launchHeightMeters);
}
function $f47bb0d16d8959dd$var$launchHeightInches2HeadHeight(launchHeightInches) {
    return (0, $jPwy6.globalConversions)().launchHeightInches2HeadHeight(launchHeightInches);
}

});
parcelRegister("jPwy6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.globalConversions = void 0;
module.exports.setPhysicsModel = $e6fc0753089ec5b6$var$setPhysicsModel;
module.exports.getPhysicsModel = $e6fc0753089ec5b6$var$getPhysicsModel;

var $2Yg5G = parcelRequire("2Yg5G");

var $4loQf = parcelRequire("4loQf");

var $o2r7v = parcelRequire("o2r7v");

var $fgwez = parcelRequire("fgwez");
const $e6fc0753089ec5b6$var$ballParamsBySport = Object.fromEntries($2Yg5G.Sports.map((sport)=>[
        sport,
        {
            ...$2Yg5G.BallParamsBySport[sport]
        }
    ]));
const $e6fc0753089ec5b6$var$PHYSICSMODEL = (0, $fgwez.createModel)("physics-20B-base", "PLATFORM_TENNIS", {
    ballParams: $e6fc0753089ec5b6$var$ballParamsBySport.PLATFORM_TENNIS,
    constants: {
        ...$2Yg5G.DefaultPhysicalConstants
    },
    simParams: {
        ...$2Yg5G.DefaultSimulationParams
    }
});
let $e6fc0753089ec5b6$var$conversions = new $4loQf.Conversions($e6fc0753089ec5b6$var$PHYSICSMODEL, (0, $o2r7v.baseEngine)($e6fc0753089ec5b6$var$PHYSICSMODEL.name, $e6fc0753089ec5b6$var$PHYSICSMODEL.sport));
/** The conversions of the global model as it is set now. */ const $e6fc0753089ec5b6$var$globalConversions = ()=>$e6fc0753089ec5b6$var$conversions;
module.exports.globalConversions = $e6fc0753089ec5b6$var$globalConversions;
/**
 * Set the model every conversion reads, changing the model object in place
 * as v1 does. A pair with no speed table is accepted, as in v1; the
 * conversions that need one throw for it (see engines.ts).
 */ function $e6fc0753089ec5b6$var$setPhysicsModel(physicsModelName, sport) {
    (0, $fgwez.assertModel)(physicsModelName, sport);
    const engine = (0, $o2r7v.baseEngine)(physicsModelName, sport);
    const { limits: limits, ...model } = (0, $fgwez.createModel)(physicsModelName, sport, {
        ballParams: $e6fc0753089ec5b6$var$ballParamsBySport[sport],
        constants: $e6fc0753089ec5b6$var$PHYSICSMODEL.constants,
        simParams: $e6fc0753089ec5b6$var$PHYSICSMODEL.simParams
    });
    Object.assign($e6fc0753089ec5b6$var$PHYSICSMODEL, model);
    $e6fc0753089ec5b6$var$PHYSICSMODEL.limits.RPM = limits.RPM;
    Object.assign($e6fc0753089ec5b6$var$PHYSICSMODEL.limits.MPS, limits.MPS);
    $e6fc0753089ec5b6$var$conversions = new $4loQf.Conversions($e6fc0753089ec5b6$var$PHYSICSMODEL, engine);
}
/** The global model: the same object on every call. */ function $e6fc0753089ec5b6$var$getPhysicsModel() {
    return $e6fc0753089ec5b6$var$PHYSICSMODEL;
}

});
parcelRegister("4loQf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Conversions = void 0;

var $faJc0 = parcelRequire("faJc0");

var $fdyC4 = parcelRequire("fdyC4");

var $d2cet = parcelRequire("d2cet");
const $329c649dec6963ca$var$NO_ROTATION = {
    x: 0,
    y: 0,
    z: 0
};
const $329c649dec6963ca$var$DEG_TO_RAD = Math.PI / 180.0;
/** A wheel whose share of the spin is within this of zero cannot limit it (v1). */ const $329c649dec6963ca$var$snap = (denominator)=>Math.abs(denominator) < 1.0e-8 ? 0 : denominator;
class $329c649dec6963ca$var$Conversions {
    model;
    engine;
    geometry;
    mechanism;
    /** v1's limits.RPM: wheel RPM band and most spin. */ rpmLimits;
    constructor(model, engine){
        this.model = model;
        this.engine = engine;
        this.geometry = engine.profile.trainer.geometry;
        this.mechanism = engine.profile.trainer.mechanism;
        this.rpmLimits = $faJc0.tableLimitsMap[model.name][model.sport].RPM;
    }
    yawpitch2launchpoint(yawDeg, pitchDeg) {
        const R = this.geometry.launchRadius;
        (0, $d2cet.assert)(Math.abs(yawDeg) <= 90 && Math.abs(pitchDeg) <= 90, `yaw and pitch (${yawDeg}, ${pitchDeg}) must be in [-90, 90]`);
        return {
            x: R * Math.cos(pitchDeg * $329c649dec6963ca$var$DEG_TO_RAD) * Math.sin(yawDeg * $329c649dec6963ca$var$DEG_TO_RAD),
            y: R * Math.cos(pitchDeg * $329c649dec6963ca$var$DEG_TO_RAD) * Math.cos(yawDeg * $329c649dec6963ca$var$DEG_TO_RAD),
            z: R * Math.sin(pitchDeg * $329c649dec6963ca$var$DEG_TO_RAD)
        };
    }
    trainer2lift(pTrainer) {
        const { liftPivot: lpp, liftArmLength: armLen } = this.geometry;
        return (0, $fdyC4.coordChange)(pTrainer, {
            x: lpp.x,
            y: lpp.y + armLen,
            z: lpp.z
        }, $329c649dec6963ca$var$NO_ROTATION);
    }
    lift2trainer(pLift) {
        const { liftPivot: lpp, liftArmLength: armLen } = this.geometry;
        return (0, $fdyC4.coordChange)(pLift, {
            x: -lpp.x,
            y: -(lpp.y + armLen),
            z: -lpp.z
        }, $329c649dec6963ca$var$NO_ROTATION);
    }
    localization2physics(pLocalization) {
        return this.engine.fromLocalization(pLocalization);
    }
    physics2localization(pPhysics) {
        return this.engine.toLocalization(pPhysics);
    }
    trainer2physics(pTrainer, pTrainerPosition, trainerYaw) {
        return this.engine.fromTrainerFrame(pTrainer, {
            x: pTrainerPosition.x,
            y: pTrainerPosition.y,
            yaw: trainerYaw,
            headHeight: 0
        });
    }
    // v1 also subtracts the position's height, which the engine's trainer frame has no use for.
    physics2trainer(pPhysics, pTrainerPosition, trainerYaw) {
        return this.engine.toTrainerFrame({
            x: pPhysics.x,
            y: pPhysics.y,
            z: pPhysics.z - pTrainerPosition.z
        }, {
            x: pTrainerPosition.x,
            y: pTrainerPosition.y,
            yaw: trainerYaw,
            headHeight: 0
        });
    }
    // v1 converts by the wheel-to-ball diameter ratio, reading the ball's diameter for both.
    motorspin2ballspin(motorspinRPM) {
        const ballDiam = this.model.ballParams.diameter;
        const wheelDiam = this.model.ballParams.diameter;
        (0, $d2cet.assert)(motorspinRPM >= 0, `ball spin in motor rpm ${motorspinRPM} must be >=0`);
        (0, $d2cet.assert)(ballDiam > 0, `ball diameter ${ballDiam} must be >0`);
        (0, $d2cet.assert)(wheelDiam > 0, `wheel diameter ${wheelDiam} must be >0`);
        return wheelDiam / ballDiam * motorspinRPM;
    }
    ballspin2motorspin(ballspinRPM) {
        const ballDiam = this.model.ballParams.diameter;
        const wheelDiam = this.model.ballParams.diameter;
        (0, $d2cet.assert)(ballspinRPM >= 0, `ball spin in ball rpm ${ballspinRPM} must be >=0`);
        (0, $d2cet.assert)(ballDiam > 0, `ball diameter ${ballDiam} must be >0`);
        (0, $d2cet.assert)(wheelDiam > 0, `wheel diameter ${wheelDiam} must be >0`);
        return ballDiam / wheelDiam * ballspinRPM;
    }
    motorspin2spinlevel(motorspinRPM) {
        const { maxSpin: maxSpin } = this.rpmLimits;
        (0, $d2cet.assert)(motorspinRPM >= 0 && motorspinRPM <= maxSpin, `motor spin RPM (${motorspinRPM}) must in [0, ${maxSpin}]`);
        if (motorspinRPM === 0) return 0;
        // 9.999, not 10: (0, max / 10] is level 1, and so on up
        return Math.floor(motorspinRPM / maxSpin * 9.999) + 1;
    }
    spinlevel2motorspin(spinLevel) {
        (0, $d2cet.assert)(spinLevel >= 0 && spinLevel <= 10 && Number.isInteger(spinLevel), `spin level ${spinLevel} must be an integer in [0,10]`);
        // the middle of the level's tenth of the spin range
        return spinLevel === 0 ? 0 : (spinLevel / 10.0 - 0.05) * this.rpmLimits.maxSpin;
    }
    ballspin2spinlevel(ballspinRPM) {
        return this.motorspin2spinlevel(this.ballspin2motorspin(ballspinRPM));
    }
    spinlevel2ballspin(spinlevel) {
        return this.motorspin2ballspin(this.spinlevel2motorspin(spinlevel));
    }
    maxmotorspin_for_rpmspeed(angle, launch_speed_rpm) {
        if (launch_speed_rpm === 0) return 0;
        const { minSafe: minSafe, maxSafe: maxSafe } = this.rpmLimits;
        return Math.min(this.maxMotorSpinForLimit(angle, launch_speed_rpm, maxSafe), this.maxMotorSpinForLimit(angle, launch_speed_rpm, minSafe));
    }
    maxspinlevel_for_rpmspeed(angle, launch_speed_rpm) {
        if (launch_speed_rpm === 0) return 0;
        const maxMotorSpin = this.maxmotorspin_for_rpmspeed(angle, launch_speed_rpm);
        const maxLevel = this.motorspin2spinlevel(maxMotorSpin);
        if (maxLevel === 0) return 0;
        return this.spinlevel2motorspin(maxLevel) > maxMotorSpin ? maxLevel - 1 : maxLevel;
    }
    maxspinlevel(angle, speed) {
        return this.maxspinlevel_for_rpmspeed(angle, this.mps2rpm(speed));
    }
    rpm2mps(rpm) {
        (0, $d2cet.assert)(rpm >= 0, `rpm is ${rpm}: must be >=0`);
        return this.mechanism.speedForRpm(rpm);
    }
    mps2rpm(mps) {
        (0, $d2cet.assert)(mps >= 0, `mps is ${mps}: must be >=0`);
        return this.mechanism.rpmForSpeed(mps);
    }
    rpm2speedspin(rpms) {
        const meanRpm = (rpms.top + rpms.left + rpms.right) / 3.0;
        const speed = this.rpm2mps(meanRpm);
        if (meanRpm === 0 || speed === 0) return {
            spinAxis: 0,
            speed: speed,
            spin: 0,
            spinLevel: 0
        };
        const thrown = this.mechanism.fromMotors(rpms);
        // The mechanism's spin is v1's spin motor RPM, damping applied.
        return {
            spinAxis: thrown.spin.axis,
            speed: thrown.speed,
            spin: this.motorspin2ballspin(thrown.spin.rpm),
            spinLevel: this.motorspin2spinlevel(thrown.spin.rpm)
        };
    }
    speedspin2rpm(speedSpin) {
        const { speed: speed, spin: spin, spinLevel: spinLevel, spinAxis: spinAxis } = speedSpin;
        (0, $d2cet.assert)(speed >= 0, `speedspin2rpm: illegal speed ${speed}: must be >=0`);
        (0, $d2cet.assert)(spin === null && spinLevel !== null || spin !== null && spinLevel === null, "speedspin2rpm: exactly 1 of (spin, spinLevel) must be specified");
        const hasSpin = spin !== null && spin > 0 || spinLevel !== null && spinLevel > 0;
        if (!hasSpin) return this.mechanism.toMotors(speed, {
            rpm: 0,
            axis: spinAxis
        });
        const spinRpm = spinLevel !== null ? this.spinlevel2motorspin(spinLevel) : this.ballspin2motorspin(spin);
        (0, $d2cet.assert)(spinAxis >= 0 && spinAxis <= 360, `angle ${spinAxis} must be in [0, 360]`);
        return this.mechanism.toMotors(speed, {
            rpm: spinRpm,
            axis: spinAxis
        });
    }
    cameraHeight2HeadHeight(cameraHeightMeters) {
        return this.engine.headHeightForCamera(cameraHeightMeters);
    }
    launchHeight2HeadHeight(launchHeightMeters) {
        return this.engine.headHeightForLaunch(launchHeightMeters);
    }
    launchHeightInches2HeadHeight(launchHeightInches) {
        return this.engine.headHeightForLaunch(launchHeightInches * 0.0254);
    }
    /** v1 maxmotorspin_for_limit: the most spin that keeps every wheel on its side of rpmLimit. */ maxMotorSpinForLimit(angle, launchSpeedRpm, rpmLimit) {
        const { minSafe: min, maxSafe: max } = this.rpmLimits;
        (0, $d2cet.assert)(angle >= 0 && angle <= 360, `angle ${angle} must be in [0, 360]`);
        (0, $d2cet.assert)(launchSpeedRpm >= min && launchSpeedRpm <= max, `launch speed RPM ${launchSpeedRpm} must be >=${min} and <= ${max}`);
        (0, $d2cet.assert)(rpmLimit >= min && rpmLimit <= max, `RPM limit ${rpmLimit} must be >= ${min} and <= ${max}`);
        if (launchSpeedRpm === 0 || launchSpeedRpm === rpmLimit) return 0;
        const top = $329c649dec6963ca$var$snap(Math.cos(angle * $329c649dec6963ca$var$DEG_TO_RAD));
        const left = $329c649dec6963ca$var$snap(Math.cos(angle * $329c649dec6963ca$var$DEG_TO_RAD) - Math.sqrt(3) * Math.sin(angle * $329c649dec6963ca$var$DEG_TO_RAD));
        const right = $329c649dec6963ca$var$snap(Math.cos(angle * $329c649dec6963ca$var$DEG_TO_RAD) + Math.sqrt(3) * Math.sin(angle * $329c649dec6963ca$var$DEG_TO_RAD));
        const headroom = launchSpeedRpm - rpmLimit;
        const flip = Math.sign(headroom);
        return Math.min(flip * top < 0 ? -1.5 * headroom * (1.0 / top) : 1e6, flip * left > 0 ? 3.0 * headroom * (1.0 / left) : 1e6, flip * right > 0 ? 3.0 * headroom * (1.0 / right) : 1e6);
    }
}
module.exports.Conversions = $329c649dec6963ca$var$Conversions;

});
parcelRegister("faJc0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tableLimitsMap = void 0;
/* eslint-disable import/prefer-default-export */ /* eslint-disable import/prefer-default-export */ /* eslint-disable quote-props */ /* eslint-disable max-len */ /*
    Trainer-specific physics limits
*/ const $b0bad87e5db43979$var$LIMITS_ATOM_20ABCDEF = {
    PLATFORM_TENNIS: {
        RPM: {
            limit: 5000,
            maxSafe: 3500,
            minSafe: 300,
            maxSpin: 3199
        }
    },
    PADEL: {
        RPM: {
            limit: 5000,
            maxSafe: 5000,
            minSafe: 300,
            maxSpin: 4699
        }
    },
    TENNIS: {
        RPM: {
            limit: 5000,
            maxSafe: 5000,
            minSafe: 300,
            maxSpin: 4699
        }
    },
    PICKLEBALL: {
        RPM: {
            limit: 3750,
            maxSafe: 3750,
            minSafe: 300,
            maxSpin: 3449
        }
    },
    // Lacrosse throws a platform tennis ball, so it shares that ball's
    // RPM->MPH curve, but it runs higher up that curve than platform tennis's
    // conservative 3500 / 64.8 mph.
    //   maxSafe 4350 RPM ~= 80.6 mph. The product ceiling is 80 mph, and the
    //   app's speed slider stops there; the small margin above it keeps a
    //   requested 80 mph off the clamp boundary rather than exactly on it.
    // This sits comfortably below 4701 RPM, where the fitted curve peaks and
    // then declines - so the whole usable band stays monotonic and a speed
    // never has two RPM solutions.
    // NOTE: measured bench data only goes to 4000 RPM (~75.5 mph); 4000-4350
    // is the fit extrapolating and should be re-measured before these speeds
    // are relied on.
    LACROSSE: {
        RPM: {
            limit: 5000,
            maxSafe: 4350,
            minSafe: 300,
            maxSpin: 4049
        }
    }
};
const $b0bad87e5db43979$var$LIMITS_ATOM_30A = {
    PLATFORM_TENNIS: {
        RPM: {
            limit: 5000,
            maxSafe: 3500,
            minSafe: 300,
            maxSpin: 3199
        }
    },
    PADEL: {
        RPM: {
            limit: 5000,
            maxSafe: 5000,
            minSafe: 300,
            maxSpin: 4699
        }
    },
    TENNIS: {
        RPM: {
            limit: 5000,
            maxSafe: 5000,
            minSafe: 300,
            maxSpin: 4699
        }
    },
    PICKLEBALL: {
        RPM: {
            limit: 3750,
            maxSafe: 3750,
            minSafe: 300,
            maxSpin: 3449
        }
    },
    // Model 30 trainers never advertise Lacrosse (see motion set_sports()).
    // Present only so every physics model has an entry for every sport.
    LACROSSE: {
        RPM: {
            limit: 5000,
            maxSafe: 3500,
            minSafe: 300,
            maxSpin: 3199
        }
    }
};
const $b0bad87e5db43979$var$LIMITS_ATOM_30B = {
    PLATFORM_TENNIS: {
        RPM: {
            limit: 5000,
            maxSafe: 3500,
            minSafe: 300,
            maxSpin: 3199
        }
    },
    PADEL: {
        RPM: {
            limit: 5000,
            maxSafe: 5000,
            minSafe: 300,
            maxSpin: 4699
        }
    },
    TENNIS: {
        RPM: {
            limit: 5000,
            maxSafe: 5000,
            minSafe: 300,
            maxSpin: 4699
        }
    },
    PICKLEBALL: {
        RPM: {
            limit: 5000,
            maxSafe: 5000,
            minSafe: 300,
            maxSpin: 4699
        }
    },
    // Model 30 trainers never advertise Lacrosse (see motion set_sports()).
    // Present only so every physics model has an entry for every sport.
    LACROSSE: {
        RPM: {
            limit: 5000,
            maxSafe: 3500,
            minSafe: 300,
            maxSpin: 3199
        }
    }
};
module.exports.tableLimitsMap = {
    "physics-20B-base": $b0bad87e5db43979$var$LIMITS_ATOM_20ABCDEF,
    "physics-20C-base": $b0bad87e5db43979$var$LIMITS_ATOM_20ABCDEF,
    "physics-20D-base": $b0bad87e5db43979$var$LIMITS_ATOM_20ABCDEF,
    "physics-20E-base": $b0bad87e5db43979$var$LIMITS_ATOM_20ABCDEF,
    "physics-20F-base": $b0bad87e5db43979$var$LIMITS_ATOM_20ABCDEF,
    "physics-20G-base": $b0bad87e5db43979$var$LIMITS_ATOM_20ABCDEF,
    "physics-20H-base": $b0bad87e5db43979$var$LIMITS_ATOM_20ABCDEF,
    "physics-20I-base": $b0bad87e5db43979$var$LIMITS_ATOM_20ABCDEF,
    "physics-20X-base": $b0bad87e5db43979$var$LIMITS_ATOM_20ABCDEF,
    "physics-30A-base": $b0bad87e5db43979$var$LIMITS_ATOM_30A,
    "physics-30B-base": $b0bad87e5db43979$var$LIMITS_ATOM_30B,
    "physics-30C-base": $b0bad87e5db43979$var$LIMITS_ATOM_30B,
    "physics-30D-base": $b0bad87e5db43979$var$LIMITS_ATOM_30B,
    "physics-30E-base": $b0bad87e5db43979$var$LIMITS_ATOM_30B,
    "physics-30X-base": $b0bad87e5db43979$var$LIMITS_ATOM_30B
};

});

parcelRegister("fdyC4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cartesianRotation = $b142eb57a0d7f9cf$var$cartesianRotation;
module.exports.coordChange = $b142eb57a0d7f9cf$var$coordChange;
module.exports.coordOffset = $b142eb57a0d7f9cf$var$coordOffset;
module.exports.calculateNetClearanceHeight = $b142eb57a0d7f9cf$var$calculateNetClearanceHeight;

var $2Yg5G = parcelRequire("2Yg5G");
/**
 * cartesianRotation
 * @param v: the 3D vector to rotate
 * @param axisName: cartesian axis around which to rotate the vector
 * @param angleDeg: angle around which to rotate the vector in degrees
 * @returns rotated vector
 */ function $b142eb57a0d7f9cf$var$cartesianRotation(v, axisName, angleDeg) {
    const out = {
        x: v.x,
        y: v.y,
        z: v.z
    };
    if (angleDeg === 0) return out;
    const angleRad = angleDeg * (Math.PI / 180.0);
    const c = Math.cos(angleRad);
    const s = Math.sin(angleRad);
    if (axisName === "x") {
        out.x = v.x;
        out.y = v.y * c + v.z * -s;
        out.z = v.y * s + v.z * c;
    } else if (axisName === "y") {
        out.x = v.x * c + v.z * -s;
        out.y = v.y;
        out.z = v.x * s + v.z * c;
    } else if (axisName === "z") {
        out.x = v.x * c + v.y * -s;
        out.y = v.x * s + v.y * c;
        out.z = v.z;
    }
    return out;
}
/**
 * coordChange
 * Change coordinate systems for a point
 * @param p : the source point to be expressed in the new coord system (will not be changed)
 * @param newOrigin: the origin of the new coord system in source system coords
 * @param rotation: rotations in degress in x/y/z of new coord axes wrt source system
 * == NOTE ==: rotations are standard mathematical rotations around x, y, z axes, NOT
 * the roll, pitch, and yaw angles of the trainer.
 * @returns the coordinates of point in the new coord system
 */ function $b142eb57a0d7f9cf$var$coordChange(p, newOrigin, rotation) {
    const v = {
        x: 0,
        y: 0,
        z: 0
    };
    // translate
    v.x = p.x - newOrigin.x;
    v.y = p.y - newOrigin.y;
    v.z = p.z - newOrigin.z;
    // rotate
    let newCoords = $b142eb57a0d7f9cf$var$cartesianRotation(v, "z", rotation.z * -1);
    newCoords = $b142eb57a0d7f9cf$var$cartesianRotation(newCoords, "y", rotation.y * -1);
    newCoords = $b142eb57a0d7f9cf$var$cartesianRotation(newCoords, "x", rotation.x * -1);
    // done
    return newCoords;
}
/**
 * coordOffset
 * Get the offset of a target coordinate system origin wrt a reference coord system given the
 * coords of the same point in both systems.
 * @param pRef: coordinates of the point in ref system
 * @param pTarget: coordinates of the point in target system
 * @param rotTarget: rotation (degrees) that takes ref system orientation to target system orientation
 * @returns the target coordinate system origin in reference system coords
 */ function $b142eb57a0d7f9cf$var$coordOffset(pRef, pTarget, rotTarget) {
    const origin = {
        x: pRef.x,
        y: pRef.y,
        z: pRef.z
    };
    let rotPoint = $b142eb57a0d7f9cf$var$cartesianRotation(pTarget, "x", rotTarget.x);
    rotPoint = $b142eb57a0d7f9cf$var$cartesianRotation(rotPoint, "y", rotTarget.y);
    rotPoint = $b142eb57a0d7f9cf$var$cartesianRotation(rotPoint, "z", rotTarget.z);
    origin.x -= rotPoint.x;
    origin.y -= rotPoint.y;
    origin.z -= rotPoint.z;
    return origin;
}
/**
 * calculateNetClearanceHeight
 * Calculate the appropriate net clearance height for user-aided localization based on
 * the trainer's position relative to the net. Returns a value between 1 and 3 feet.
 *
 * @param sport The sport being played (determines court dimensions)
 * @param trainerY The Y coordinate of the trainer in physics coordinates (meters)
 *                 Physics coords: origin at court center, +Y=forward, -Y=backward
 * @returns Net clearance height in feet (1.0 to 3.0)
 *          - Closer to net (Y near 0): Higher clearance (~3 feet) for better line-of-sight
 *          - Farther from net (more negative Y): Lower clearance (~1 feet) is sufficient
 */ function $b142eb57a0d7f9cf$var$calculateNetClearanceHeight(sport, trainerY) {
    // Get court geometry for the sport
    const courtGeometry = $2Yg5G.CourtGeometryBySport[sport];
    const maxDistance = courtGeometry.COURT_LENGTH / 2; // Half court length
    // Calculate distance from trainer to net (Y=0)
    const distanceToNet = Math.abs(trainerY);
    // Normalize distance (0 = at net, 1 = at court edge)
    const normalizedDistance = Math.min(distanceToNet / maxDistance, 1.0);
    // Interpolate clearance: 3 feet at net, 1 foot at max distance
    const minClearance = 1.0;
    const maxClearance = 3.0;
    const clearance = maxClearance - normalizedDistance * (maxClearance - minClearance);
    return Math.floor(Math.max(minClearance, Math.min(maxClearance, clearance)));
}

});

parcelRegister("d2cet", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assert = $97d4f364b0d34123$var$assert;
/**
 * v1's assert, without its console.error: the same Error, with the same
 * message, thrown silently.
 */ function $97d4f364b0d34123$var$assert(assertion, message) {
    if (!assertion) throw new Error(`Assertion Failed: ${message}`);
}

});


parcelRegister("o2r7v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.baseEngine = $048421d40d9b108c$var$baseEngine;
module.exports.assertLaunchable = $048421d40d9b108c$var$assertLaunchable;
module.exports.enginesFor = $048421d40d9b108c$var$enginesFor;

var $2Yg5G = parcelRequire("2Yg5G");

var $h0XTw = parcelRequire("h0XTw");

var $dGzHP = parcelRequire("dGzHP");
/** Retuning to many settings (a drag sweep, say) must not grow the cache without bound. */ const $048421d40d9b108c$var$MAX_CACHED = 64;
const $048421d40d9b108c$var$tuned = new Map();
const $048421d40d9b108c$var$base = new Map();
/** The engine on the model's untuned profile: conversions, pose and camera. */ function $048421d40d9b108c$var$baseEngine(name, sport) {
    const key = `${name}/${sport}`;
    let engine = $048421d40d9b108c$var$base.get(key);
    if (engine === undefined) {
        engine = (0, $h0XTw.createEngine)($048421d40d9b108c$var$baseProfile(name, sport));
        $048421d40d9b108c$var$base.set(key, engine);
    }
    return engine;
}
/**
 * The model's profile on v1's venue. v1 accepts a model and sport with no
 * speed table (it draws courts for them, and computes NaN if asked to throw),
 * where the engine refuses: for those, a profile with the model's geometry,
 * the sport's ball and venue, and a launch mechanism that throws when used.
 * Pose, camera, coordinates and strokes work as in v1; launching and speed
 * conversions fail, naming the pair.
 */ function $048421d40d9b108c$var$baseProfile(name, sport) {
    const venue = (0, $h0XTw.v1Venue)(sport);
    const result = (0, $h0XTw.loadProfile)(name, sport, {
        venue: venue
    });
    if (result.ok) return result.profile;
    // the trainer's geometry is the model's, whatever the sport
    const sibling = $2Yg5G.Sports.map((other)=>(0, $h0XTw.loadProfile)(name, other, {
            venue: (0, $h0XTw.v1Venue)(other)
        })).find((r)=>r.ok);
    if (sibling === undefined || !sibling.ok) throw new Error(result.message);
    return {
        trainer: {
            model: name,
            geometry: sibling.profile.trainer.geometry,
            mechanism: $048421d40d9b108c$var$unavailableMechanism(result.message)
        },
        ball: $h0XTw.BALLS[$h0XTw.DEFAULT_BALL[sport]],
        venue: venue,
        environment: sibling.profile.environment
    };
}
/** Why each stand-in mechanism cannot launch. */ const $048421d40d9b108c$var$unavailable = new WeakMap();
/** Throws, naming the pair, if the profile has no speed table to launch with. */ function $048421d40d9b108c$var$assertLaunchable({ trainer: { mechanism: mechanism } }) {
    const message = $048421d40d9b108c$var$unavailable.get(mechanism);
    if (message !== undefined) throw new Error(`${message}, which launching and speed conversions need`);
}
/** A launch mechanism for a pair with no speed table: every use throws. */ function $048421d40d9b108c$var$unavailableMechanism(message) {
    const fail = ()=>{
        throw new Error(`${message}, which launching and speed conversions need`);
    };
    const mechanism = {
        toMotors: fail,
        fromMotors: fail,
        deflectionCorrection: fail,
        limits: {
            maxSpeed: NaN,
            minSpeed: NaN,
            maxSpin: NaN,
            rpm: {
                min: NaN,
                max: NaN,
                maxSpin: NaN
            }
        },
        speedForRpm: fail,
        rpmForSpeed: fail,
        maxSpinAt: fail,
        spinLevels: {
            toRpm: fail,
            fromRpm: fail,
            maxAt: fail
        }
    };
    $048421d40d9b108c$var$unavailable.set(mechanism, message);
    return mechanism;
}
/** The engines for the model as it is tuned right now. */ function $048421d40d9b108c$var$enginesFor(model) {
    const { simParams: s, constants: c, ballParams: b } = model;
    const key = [
        model.name,
        model.sport,
        s.timeStep,
        s.wallBounceEnabled,
        s.netBounceEnabled,
        c.gravity,
        c.airDensity,
        c.courtRestCoeff,
        c.wallRestCoeff,
        c.netRestCoeff,
        b.diameter,
        b.mass,
        b.drag
    ].join("/");
    let engines = $048421d40d9b108c$var$tuned.get(key);
    if (engines === undefined) {
        if ($048421d40d9b108c$var$tuned.size >= $048421d40d9b108c$var$MAX_CACHED) $048421d40d9b108c$var$tuned.clear();
        const profile = $048421d40d9b108c$var$tunedProfile(model);
        let solver;
        engines = {
            profile: profile,
            kernel: (0, $dGzHP.createFlight)(profile, {
                integrator: "legacy",
                timeStep: s.timeStep
            }),
            get solver () {
                solver ??= (0, $h0XTw.createEngine)(profile, {
                    spinModel: "v1",
                    peakHeight: "v1"
                });
                return solver;
            }
        };
        $048421d40d9b108c$var$tuned.set(key, engines);
    }
    return engines;
}
/**
 * The model's profile with its tunables applied: v1's venue less the walls
 * or net a caller turned off, its restitutions, gravity, air and ball.
 */ function $048421d40d9b108c$var$tunedProfile({ name: name, sport: sport, simParams: simParams, constants: constants, ballParams: ballParams }) {
    const profile = $048421d40d9b108c$var$baseProfile(name, sport);
    const { venue: venue } = profile;
    const panels = venue.arena.panels.filter((panel)=>panel.kind === "wall" ? simParams.wallBounceEnabled : simParams.netBounceEnabled).map((panel)=>({
            ...panel,
            response: panel.kind === "wall" ? {
                kind: "bounce",
                restitution: constants.wallRestCoeff,
                tangential: 1
            } : {
                kind: "bounce",
                restitution: constants.netRestCoeff,
                tangential: constants.netRestCoeff
            }
        }));
    return {
        trainer: profile.trainer,
        ball: {
            ...profile.ball,
            diameter: ballParams.diameter,
            mass: ballParams.mass,
            dragCoefficient: ballParams.drag
        },
        venue: {
            ...venue,
            arena: {
                ...venue.arena,
                ground: {
                    restitution: constants.courtRestCoeff
                },
                panels: panels
            }
        },
        environment: {
            gravity: constants.gravity,
            airDensity: constants.airDensity
        }
    };
}

});
parcelRegister("h0XTw", function(module, exports) {
"use strict";
var $c630e5888af43e91$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c630e5888af43e91$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c630e5888af43e91$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.v1Venue = module.exports.lacrosseField = module.exports.defaultVenue = module.exports.requireProfile = module.exports.loadProfile = module.exports.createEngine = module.exports.DEFAULT_BALL = module.exports.BALLS = void 0;

var $hP7oQ = parcelRequire("hP7oQ");
Object.defineProperty(module.exports, "BALLS", {
    enumerable: true,
    get: function() {
        return $hP7oQ.BALLS;
    }
});
Object.defineProperty(module.exports, "DEFAULT_BALL", {
    enumerable: true,
    get: function() {
        return $hP7oQ.DEFAULT_BALL;
    }
});

var $LK6wG = parcelRequire("LK6wG");
Object.defineProperty(module.exports, "createEngine", {
    enumerable: true,
    get: function() {
        return $LK6wG.createEngine;
    }
});

var $54ih8 = parcelRequire("54ih8");
Object.defineProperty(module.exports, "loadProfile", {
    enumerable: true,
    get: function() {
        return $54ih8.loadProfile;
    }
});
Object.defineProperty(module.exports, "requireProfile", {
    enumerable: true,
    get: function() {
        return $54ih8.requireProfile;
    }
});

$c630e5888af43e91$var$__exportStar((parcelRequire("4iTSZ")), module.exports);

var $3P7gP = parcelRequire("3P7gP");
Object.defineProperty(module.exports, "defaultVenue", {
    enumerable: true,
    get: function() {
        return $3P7gP.defaultVenue;
    }
});
Object.defineProperty(module.exports, "lacrosseField", {
    enumerable: true,
    get: function() {
        return $3P7gP.lacrosseField;
    }
});
Object.defineProperty(module.exports, "v1Venue", {
    enumerable: true,
    get: function() {
        return $3P7gP.v1Venue;
    }
});

});
parcelRegister("hP7oQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ballById = module.exports.DEFAULT_BALL = module.exports.BALLS = void 0;

var $2Yg5G = parcelRequire("2Yg5G");

var $90lsY = parcelRequire("90lsY");
/** Same expression as v1's TrainerSim._calculateLiftCoefficient. */ const $cf9cf07f992746e3$var$liftCoefficient = (radius, angularSpeed, speed)=>-0.05 + Math.sqrt(0.0025 + 0.36 * radius * Math.abs(angularSpeed) / Math.abs(speed));
const $cf9cf07f992746e3$var$ball = (id, { diameter: diameter, mass: mass, drag: drag })=>({
        id: id,
        diameter: diameter,
        mass: mass,
        dragCoefficient: drag,
        liftCoefficient: $cf9cf07f992746e3$var$liftCoefficient
    });
module.exports.BALLS = (0, $90lsY.deepFreeze)({
    tennis: $cf9cf07f992746e3$var$ball("tennis", $2Yg5G.BallParamsBySport.TENNIS),
    padel: $cf9cf07f992746e3$var$ball("padel", $2Yg5G.BallParamsBySport.PADEL),
    pickleball: $cf9cf07f992746e3$var$ball("pickleball", $2Yg5G.BallParamsBySport.PICKLEBALL),
    platformTennis: $cf9cf07f992746e3$var$ball("platformTennis", $2Yg5G.BallParamsBySport.PLATFORM_TENNIS)
});
/** The ball each sport's trainer is loaded with. */ module.exports.DEFAULT_BALL = Object.freeze({
    TENNIS: "tennis",
    PADEL: "padel",
    PICKLEBALL: "pickleball",
    PLATFORM_TENNIS: "platformTennis",
    // The trainer has not been redesigned to feed a lacrosse ball, so it
    // throws platform tennis balls (as v1's BallParamsBySport.LACROSSE says).
    // A trainer that feeds lacrosse balls adds a ball and changes this line.
    LACROSSE: "platformTennis"
});
/** A ball by id, if the registry has it. */ const $cf9cf07f992746e3$var$ballById = (id)=>Object.hasOwn(module.exports.BALLS, id) ? module.exports.BALLS[id] : undefined;
module.exports.ballById = $cf9cf07f992746e3$var$ballById;

});
parcelRegister("90lsY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deepFreeze = $68e4c3ee0f5e5974$var$deepFreeze;
module.exports.isDeepFrozen = $68e4c3ee0f5e5974$var$isDeepFrozen;
module.exports.clonePlainData = $68e4c3ee0f5e5974$var$clonePlainData;
/** Freezes a tree of plain objects and arrays in place; functions are left as they are. */ function $68e4c3ee0f5e5974$var$deepFreeze(value) {
    if (typeof value === "object" && value !== null) {
        Object.freeze(value);
        Object.values(value).forEach($68e4c3ee0f5e5974$var$deepFreeze);
    }
    return value;
}
/** Whether a tree of plain objects and arrays is frozen all the way down. */ function $68e4c3ee0f5e5974$var$isDeepFrozen(value) {
    if (typeof value !== "object" || value === null) return true;
    return Object.isFrozen(value) && Object.values(value).every($68e4c3ee0f5e5974$var$isDeepFrozen);
}
/**
 * A deep copy of a tree of plain objects and arrays (structuredClone is not
 * everywhere the package runs: jest's jsdom environment lacks it). Throws a
 * TypeError on anything else: functions, class instances, Maps.
 */ function $68e4c3ee0f5e5974$var$clonePlainData(value) {
    if (typeof value === "function") throw new TypeError("not plain data: a function");
    if (typeof value !== "object" || value === null) return value;
    if (Array.isArray(value)) return value.map($68e4c3ee0f5e5974$var$clonePlainData);
    const proto = Object.getPrototypeOf(value);
    if (proto !== Object.prototype && proto !== null) throw new TypeError(`not plain data: a ${proto?.constructor?.name ?? "non-plain object"}`);
    return Object.fromEntries(Object.entries(value).map(([key, v])=>[
            key,
            $68e4c3ee0f5e5974$var$clonePlainData(v)
        ]));
}

});


parcelRegister("LK6wG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createEngine = $08f8273f32b3a15f$var$createEngine;

var $i7eH1 = parcelRequire("i7eH1");

var $8ogrt = parcelRequire("8ogrt");

var $7Vdbm = parcelRequire("7Vdbm");

var $kOjGe = parcelRequire("kOjGe");

var $dGzHP = parcelRequire("dGzHP");

var $fgrOf = parcelRequire("fgrOf");

var $fhneO = parcelRequire("fhneO");
const $08f8273f32b3a15f$var$DEFAULT_AIM_TOLERANCE = 0.005; // m
/**
 * An engine for one profile. It keeps no state between calls: every call
 * takes the trainer's pose and returns fresh results.
 */ function $08f8273f32b3a15f$var$createEngine(profile, options = {}) {
    const kernel = (0, $dGzHP.createFlight)(profile, {
        integrator: options.integrator,
        timeStep: options.timeStep,
        spinModel: options.spinModel
    });
    const { spinModel: spinModel } = kernel;
    const aim = (0, $i7eH1.createAimer)(profile, kernel, {
        tolerance: options.aimTolerance ?? $08f8273f32b3a15f$var$DEFAULT_AIM_TOLERANCE,
        peakHeight: options.peakHeight ?? "apex"
    });
    const reconstruct = (0, $fgrOf.createReconstructor)(profile, kernel, {
        tolerance: options.aimTolerance ?? $08f8273f32b3a15f$var$DEFAULT_AIM_TOLERANCE
    });
    const { mechanism: mechanism, geometry: geometry } = profile.trainer;
    const { venue: venue } = profile;
    return {
        profile: profile,
        launchPoint: (pose, pitch = 0, yaw = 0)=>(0, $fhneO.launchPoint)(profile.trainer.geometry, pose, pitch, yaw),
        launch: (pose, launch, flightOptions)=>kernel.fly((0, $fhneO.release)(profile, pose, launch, spinModel), flightOptions),
        launchMotors: (pose, pitch, yaw, rpms, flightOptions)=>{
            const { speed: speed, spin: spin } = mechanism.fromMotors(rpms);
            return kernel.fly((0, $fhneO.release)(profile, pose, {
                pitch: pitch,
                yaw: yaw,
                speed: speed,
                spin: spin
            }, spinModel), flightOptions);
        },
        aim: aim,
        reconstruct: reconstruct,
        release: (pose, launch)=>{
            const { origin: origin, velocity: velocity, pitch: pitch, yaw: yaw, deflection: deflection } = (0, $fhneO.release)(profile, pose, launch, spinModel);
            return {
                origin: origin,
                velocity: velocity,
                pitch: pitch,
                yaw: yaw,
                deflection: deflection
            };
        },
        armAngle: (headHeight)=>(0, $8ogrt.armAngle)(geometry, headHeight),
        camera: (pose, keep)=>(0, $8ogrt.camera)(profile, pose, keep),
        poseFromCamera: (localized)=>(0, $8ogrt.poseFromCamera)(profile, localized),
        headHeightForCamera: (height)=>(0, $8ogrt.headHeightForCamera)(geometry, height),
        headHeightForLaunch: (height)=>(0, $8ogrt.headHeightForLaunch)(geometry, height),
        localizationHeadHeight: (localized, point, clearanceFeet)=>(0, $kOjGe.localizationHeadHeight)(profile, localized, point, clearanceFeet),
        localizationNetClearance: (trainerY)=>(0, $kOjGe.localizationNetClearance)(venue, trainerY),
        toLocalization: (p)=>(0, $7Vdbm.toLocalization)(venue, p),
        fromLocalization: (p)=>(0, $7Vdbm.fromLocalization)(venue, p),
        fromTrainerFrame: $7Vdbm.fromTrainerFrame,
        toTrainerFrame: $7Vdbm.toTrainerFrame,
        referencePoint: (name)=>(0, $kOjGe.referencePoint)(venue, name),
        stroke: (origin, velocity, spin, flightOptions)=>kernel.fly((0, $fhneO.strokeRelease)(origin, velocity, spin, spinModel), {
                ...flightOptions,
                stopOutOfBounds: false
            })
    };
}

});
parcelRegister("i7eH1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createAimer = $d30447291f2d78a2$var$createAimer;

var $9UQpN = parcelRequire("9UQpN");

var $fhneO = parcelRequire("fhneO");

var $4iTSZ = parcelRequire("4iTSZ");
/** The head pans at most this far either side of the body's facing. */ const $d30447291f2d78a2$var$MAX_PAN = 90;
const $d30447291f2d78a2$var$MIN_RANGE = 0.1; // m, launch point to target
/** Above this a faster shot to the same point would fly higher, not flatter. */ const $d30447291f2d78a2$var$MAX_FLAT_PITCH = 45;
const $d30447291f2d78a2$var$PITCH_RANGE = [
    -60,
    80
];
const $d30447291f2d78a2$var$MAX_ITERATIONS = 25;
const $d30447291f2d78a2$var$toDeg = (rad)=>rad * 180 / Math.PI;
const $d30447291f2d78a2$var$toRad = (deg)=>deg * Math.PI / 180;
/** Wrap an angle in degrees to (-180, 180]. */ function $d30447291f2d78a2$var$wrapDeg(angle) {
    const w = (angle % 360 + 360) % 360;
    return w > 180 ? w - 360 : w;
}
/** Compass bearing from one point to another: 0 = +y, positive = clockwise. */ const $d30447291f2d78a2$var$bearing = (from, to)=>$d30447291f2d78a2$var$toDeg(Math.atan2(to.x - from.x, to.y - from.y));
/** Height the plan aims at: > 0 is an aerial target, 0 a landing. */ const $d30447291f2d78a2$var$targetHeight = (plan)=>Number.isFinite(plan.target.z) && plan.target.z > 0 ? plan.target.z : 0;
const $d30447291f2d78a2$var$fail = (reason, message, closest)=>({
        ok: false,
        reason: reason,
        message: message,
        closest: closest
    });
function $d30447291f2d78a2$var$createAimer(profile, kernel, options) {
    const { gravity: gravity } = profile.environment;
    const { limits: limits } = profile.trainer.mechanism;
    // Finite-difference steps: well above the integrator's noise, well below the tolerance
    const fdScale = kernel.integrator === "legacy" ? 100 : 1;
    const fdStep = {
        pitch: 1e-3 * fdScale,
        speed: 1e-4 * fdScale,
        yaw: 1e-3 * fdScale
    };
    const end = new Float64Array(8);
    /** Validity checks that need no flight, in v1's order. */ function checkPlan(plan, forward, pan) {
        const range = Math.hypot(plan.target.x - forward.x, plan.target.y - forward.y);
        if (Math.abs(pan) >= $d30447291f2d78a2$var$MAX_PAN) return $d30447291f2d78a2$var$fail("targetBehind", "target must be in front of the trainer");
        if (range < $d30447291f2d78a2$var$MIN_RANGE) return $d30447291f2d78a2$var$fail("targetTooClose", "launch and target point must be different");
        if (plan.shape === "peakHeight") {
            if (plan.peakHeight < forward.z) return $d30447291f2d78a2$var$fail("peakBelowLaunch", "peak height must be >= launch height");
            if (plan.peakHeight < $d30447291f2d78a2$var$targetHeight(plan)) return $d30447291f2d78a2$var$fail("peakBelowTarget", "peak height must be >= target height");
        }
        if (plan.shape === "speed" && !(plan.speed > 0 && plan.speed <= limits.maxSpeed)) return $d30447291f2d78a2$var$fail("speedOutOfRange", `speed must be in (0, ${limits.maxSpeed}] m/s`);
        return null;
    }
    /** No-drag, no-spin starting point for each plan shape. */ function unknownsFor(plan, forward, pan) {
        const spin = plan.spin ?? $4iTSZ.NO_SPIN;
        const range = Math.hypot(plan.target.x - forward.x, plan.target.y - forward.y);
        const rise = $d30447291f2d78a2$var$targetHeight(plan) - forward.z;
        const speedBounds = [
            limits.minSpeed,
            limits.maxSpeed
        ];
        const clampSpeed = (v)=>Math.min(limits.maxSpeed, Math.max(limits.minSpeed, v));
        switch(plan.shape){
            case "peakHeight":
                {
                    // up hDiff to the peak, down `fall` to the target height
                    const hDiff = plan.peakHeight - forward.z;
                    const fall = plan.peakHeight - $d30447291f2d78a2$var$targetHeight(plan);
                    const c = hDiff + Math.sqrt(fall * hDiff);
                    const pitch = $d30447291f2d78a2$var$toDeg(Math.atan(2 * c / range));
                    const speed = Math.sqrt(2 * gravity * hDiff * (range * range + 4 * c * c)) / (2 * c);
                    if (options.peakHeight === "v1") return {
                        names: [
                            "speed",
                            "yaw"
                        ],
                        start: [
                            clampSpeed(speed),
                            pan
                        ],
                        lower: [
                            speedBounds[0],
                            -$d30447291f2d78a2$var$MAX_PAN
                        ],
                        upper: [
                            speedBounds[1],
                            $d30447291f2d78a2$var$MAX_PAN
                        ],
                        launch: (u)=>({
                                pitch: pitch,
                                speed: u[0],
                                yaw: u[1],
                                spin: spin
                            })
                    };
                    return {
                        names: [
                            "pitch",
                            "speed",
                            "yaw"
                        ],
                        start: [
                            pitch,
                            clampSpeed(speed),
                            pan
                        ],
                        lower: [
                            $d30447291f2d78a2$var$PITCH_RANGE[0],
                            speedBounds[0],
                            -$d30447291f2d78a2$var$MAX_PAN
                        ],
                        upper: [
                            $d30447291f2d78a2$var$PITCH_RANGE[1],
                            speedBounds[1],
                            $d30447291f2d78a2$var$MAX_PAN
                        ],
                        launch: (u)=>({
                                pitch: u[0],
                                speed: u[1],
                                yaw: u[2],
                                spin: spin
                            })
                    };
                }
            case "pitch":
                {
                    const cos = Math.cos($d30447291f2d78a2$var$toRad(plan.pitch));
                    const height = 2 * cos * cos * (range * Math.tan($d30447291f2d78a2$var$toRad(plan.pitch)) - rise);
                    const speed = height > 0 ? Math.sqrt(gravity * range * range / height) : limits.maxSpeed;
                    return {
                        names: [
                            "speed",
                            "yaw"
                        ],
                        start: [
                            clampSpeed(speed),
                            pan
                        ],
                        lower: [
                            speedBounds[0],
                            -$d30447291f2d78a2$var$MAX_PAN
                        ],
                        upper: [
                            speedBounds[1],
                            $d30447291f2d78a2$var$MAX_PAN
                        ],
                        launch: (u)=>({
                                pitch: plan.pitch,
                                speed: u[0],
                                yaw: u[1],
                                spin: spin
                            })
                    };
                }
            case "speed":
                {
                    const v = plan.speed;
                    const disc = v ** 4 - gravity * (gravity * range * range + 2 * rise * v * v);
                    const pitch = disc >= 0 ? $d30447291f2d78a2$var$toDeg(Math.atan((v * v - Math.sqrt(disc)) / (gravity * range))) : 35;
                    return {
                        names: [
                            "pitch",
                            "yaw"
                        ],
                        start: [
                            pitch,
                            pan
                        ],
                        lower: [
                            $d30447291f2d78a2$var$PITCH_RANGE[0],
                            -$d30447291f2d78a2$var$MAX_PAN
                        ],
                        upper: [
                            $d30447291f2d78a2$var$MAX_FLAT_PITCH,
                            $d30447291f2d78a2$var$MAX_PAN
                        ],
                        launch: (u)=>({
                                pitch: u[0],
                                speed: v,
                                yaw: u[1],
                                spin: spin
                            })
                    };
                }
        }
    }
    return function aim(pose, plan) {
        const forward = (0, $fhneO.launchPoint)(profile.trainer.geometry, pose);
        const pan = $d30447291f2d78a2$var$wrapDeg($d30447291f2d78a2$var$bearing(forward, plan.target) - pose.yaw);
        const invalid = checkPlan(plan, forward, pan);
        if (invalid) return invalid;
        const unknowns = unknownsFor(plan, forward, pan);
        const until = $d30447291f2d78a2$var$targetHeight(plan) > 0 ? $d30447291f2d78a2$var$targetHeight(plan) : "landing";
        const apex = plan.shape === "peakHeight" && options.peakHeight === "apex" ? plan.peakHeight : null;
        const residual = (u, r)=>{
            // Net and walls are left out of the solve: clipping them makes the
            // landing jump, which stalls Newton. The real flight is checked after.
            if (!kernel.endpoint((0, $fhneO.release)(profile, pose, unknowns.launch(u), kernel.spinModel), until, end, "ground")) return false;
            r[0] = end[1] - plan.target.x;
            r[1] = end[2] - plan.target.y;
            if (apex !== null) r[2] = end[7] - apex;
            return true;
        };
        const solution = (0, $9UQpN.solve)(residual, unknowns.start, {
            lower: unknowns.lower,
            upper: unknowns.upper,
            steps: unknowns.names.map((name)=>fdStep[name]),
            maxIterations: $d30447291f2d78a2$var$MAX_ITERATIONS,
            // horizontal miss, and for a held apex its height error too
            done: (r)=>Math.hypot(r[0], r[1]) <= options.tolerance && (r.length < 3 || Math.abs(r[2]) <= options.tolerance)
        });
        if (!solution.defined) return $d30447291f2d78a2$var$fail("outOfReach", "the starting throw never reaches the target");
        const found = aimAt(pose, plan, unknowns.launch(solution.u), solution.iterations);
        if (solution.converged) {
            const struck = strikesOnTheWay(found);
            return struck ? $d30447291f2d78a2$var$fail("blocked", `the throw that reaches the target strikes the ${struck} on the way`, found) : {
                ok: true,
                ...found
            };
        }
        if (plan.shape === "speed" && solution.u[0] === unknowns.lower[0]) return $d30447291f2d78a2$var$fail("targetTooClose", "target too close for this speed", found);
        // Stalled short of the target: at a speed limit, or (for a fixed
        // speed) at the pitch that carries furthest. Either way, out of reach.
        if (solution.pinned || fallsShort(found, plan)) return $d30447291f2d78a2$var$fail("outOfReach", "the target is out of the trainer's reach for this plan", found);
        return $d30447291f2d78a2$var$fail("noConvergence", `missed by ${found.miss.toFixed(3)} m after ${solution.iterations} iterations`, found);
    };
    /** The first net or wall the solved flight strikes before its end, if any. */ function strikesOnTheWay(found) {
        const endT = found.flight.end?.t ?? Infinity;
        const struck = found.flight.contacts.find((c)=>c.kind !== "ground" && c.t <= endT);
        return struck ? struck.surface : null;
    }
    /** Whether the best attempt came up short of the target, along the line to it. */ function fallsShort(found, plan) {
        const reached = found.flight.end?.position;
        if (!reached) return true;
        const toTarget = Math.hypot(plan.target.x - found.origin.x, plan.target.y - found.origin.y);
        const carried = ((reached.x - found.origin.x) * (plan.target.x - found.origin.x) + (reached.y - found.origin.y) * (plan.target.y - found.origin.y)) / toTarget;
        return carried < toTarget - options.tolerance;
    }
    function aimAt(pose, plan, launch, iterations) {
        const released = (0, $fhneO.release)(profile, pose, launch, kernel.spinModel);
        const z = $d30447291f2d78a2$var$targetHeight(plan);
        const flight = kernel.fly(released, {
            until: z > 0 ? {
                kind: "descending",
                z: z
            } : {
                kind: "landing"
            }
        });
        const reached = flight.end?.position;
        return {
            launch: launch,
            motors: profile.trainer.mechanism.toMotors(launch.speed, launch.spin),
            origin: released.origin,
            deflection: released.deflection,
            flight: flight,
            miss: reached ? Math.hypot(reached.x - plan.target.x, reached.y - plan.target.y) : Infinity,
            iterations: iterations
        };
    }
}

});
parcelRegister("9UQpN", function(module, exports) {
"use strict";
/**
 * A small damped Newton solver for square systems of a few unknowns, with a
 * finite-difference Jacobian and box bounds. Aiming has 2 or 3 unknowns, so
 * the linear algebra is done in place on tiny arrays.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.solve = $7382008cba8347c1$var$solve;
const $7382008cba8347c1$var$norm = (r)=>Math.hypot(...r);
/** A step that leaves more than this fraction of the residual is slow... */ const $7382008cba8347c1$var$STALL_RATIO = 0.5;
/** ...and this many slow steps in a row is a stall. */ const $7382008cba8347c1$var$STALL_STEPS = 3;
const $7382008cba8347c1$var$clampInto = (u, lower, upper)=>{
    for(let i = 0; i < u.length; i += 1)u[i] = Math.min(upper[i], Math.max(lower[i], u[i]));
};
/** Solves J x = b in place by Gaussian elimination with partial pivoting. */ function $7382008cba8347c1$var$solveLinear(jacobian, b) {
    const n = b.length;
    const a = jacobian.map((row, i)=>Float64Array.of(...row, b[i]));
    for(let col = 0; col < n; col += 1){
        let pivot = col;
        for(let row = col + 1; row < n; row += 1)if (Math.abs(a[row][col]) > Math.abs(a[pivot][col])) pivot = row;
        if (Math.abs(a[pivot][col]) < 1e-14) return null;
        [a[col], a[pivot]] = [
            a[pivot],
            a[col]
        ];
        for(let row = col + 1; row < n; row += 1){
            const f = a[row][col] / a[col][col];
            for(let k = col; k <= n; k += 1)a[row][k] -= f * a[col][k];
        }
    }
    const x = new Float64Array(n);
    for(let row = n - 1; row >= 0; row -= 1){
        let s = a[row][n];
        for(let k = row + 1; k < n; k += 1)s -= a[row][k] * x[k];
        x[row] = s / a[row][row];
    }
    return x;
}
/**
 * Damped quasi-Newton from u0. The Jacobian starts as a forward difference
 * (n extra evaluations) and is then kept current with Broyden's rank-one
 * update from each accepted step; it is rebuilt by differences only when a
 * step fails to reduce the residual. Steps are clipped to the bounds and
 * halved until the residual shrinks.
 */ function $7382008cba8347c1$var$solve(residual, u0, options) {
    const n = u0.length;
    const u = Float64Array.from(u0);
    $7382008cba8347c1$var$clampInto(u, options.lower, options.upper);
    const r = new Float64Array(n);
    if (!residual(u, r)) return {
        u: u,
        r: r,
        converged: false,
        iterations: 0,
        defined: false,
        pinned: false
    };
    const probe = new Float64Array(n);
    const probeR = new Float64Array(n);
    const trial = new Float64Array(n);
    const trialR = new Float64Array(n);
    const result = (converged, iterations)=>({
            u: u,
            r: r,
            converged: converged,
            iterations: iterations,
            defined: true,
            pinned: u.some((v, i)=>v === options.lower[i] || v === options.upper[i])
        });
    /** Forward differences: column j = dr/du_j, stepping away from a bound. */ const differenced = ()=>{
        const jacobian = Array.from({
            length: n
        }, ()=>new Float64Array(n));
        for(let j = 0; j < n; j += 1){
            probe.set(u);
            const h = u[j] + options.steps[j] > options.upper[j] ? -options.steps[j] : options.steps[j];
            probe[j] += h;
            if (!residual(probe, probeR)) return null;
            for(let i = 0; i < n; i += 1)jacobian[i][j] = (probeR[i] - r[i]) / h;
        }
        return jacobian;
    };
    /** A step along the Newton direction that reduces the residual, applied to (u, r). */ const descend = (jacobian)=>{
        const step = $7382008cba8347c1$var$solveLinear(jacobian, r.map((v)=>-v));
        if (step === null) return false;
        for(let scale = 1; scale > 1 / 64; scale /= 2){
            for(let i = 0; i < n; i += 1)trial[i] = u[i] + scale * step[i];
            $7382008cba8347c1$var$clampInto(trial, options.lower, options.upper);
            if (residual(trial, trialR) && $7382008cba8347c1$var$norm(trialR) < $7382008cba8347c1$var$norm(r)) {
                broydenUpdate(jacobian, trial, trialR);
                u.set(trial);
                r.set(trialR);
                return true;
            }
        }
        return false;
    };
    /** J += (dr - J du) du^T / (du . du), for the step u -> next. */ const broydenUpdate = (jacobian, next, nextR)=>{
        let duDotDu = 0;
        for(let j = 0; j < n; j += 1)duDotDu += (next[j] - u[j]) ** 2;
        if (duDotDu === 0) return;
        for(let i = 0; i < n; i += 1){
            let predicted = 0;
            for(let j = 0; j < n; j += 1)predicted += jacobian[i][j] * (next[j] - u[j]);
            const surprise = (nextR[i] - r[i] - predicted) / duDotDu;
            for(let j = 0; j < n; j += 1)jacobian[i][j] += surprise * (next[j] - u[j]);
        }
    };
    let jacobian = options.jacobian?.map((row)=>Float64Array.from(row)) ?? null;
    let slowSteps = 0;
    for(let iteration = 1; iteration <= options.maxIterations; iteration += 1){
        if (options.done(r)) return result(true, iteration - 1);
        const before = $7382008cba8347c1$var$norm(r);
        if (jacobian === null || !descend(jacobian)) {
            // no Jacobian yet, or the updated one led nowhere: difference afresh
            jacobian = differenced();
            if (jacobian === null || !descend(jacobian)) return result(false, iteration);
        }
        // Near a root, Newton shrinks the residual many-fold per step. Steps
        // that barely shrink it mean a minimum that isn't a root (the target
        // is out of reach): stop rather than creep.
        slowSteps = $7382008cba8347c1$var$norm(r) > $7382008cba8347c1$var$STALL_RATIO * before ? slowSteps + 1 : 0;
        if (slowSteps === $7382008cba8347c1$var$STALL_STEPS) return result(false, iteration);
    }
    return result(options.done(r), options.maxIterations);
}

});

parcelRegister("fhneO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rotateAboutZ = $b1fa7818744d9b6c$var$rotateAboutZ;
module.exports.headInLift = $b1fa7818744d9b6c$var$headInLift;
module.exports.launchPoint = $b1fa7818744d9b6c$var$launchPoint;
module.exports.release = $b1fa7818744d9b6c$var$release;
module.exports.strokeRelease = $b1fa7818744d9b6c$var$strokeRelease;

var $4iTSZ = parcelRequire("4iTSZ");
const $b1fa7818744d9b6c$var$DEG_TO_RAD = Math.PI / 180.0;
function $b1fa7818744d9b6c$var$rotateAboutX(v, degrees) {
    if (degrees === 0) return v;
    const c = Math.cos(degrees * $b1fa7818744d9b6c$var$DEG_TO_RAD);
    const s = Math.sin(degrees * $b1fa7818744d9b6c$var$DEG_TO_RAD);
    return {
        x: v.x,
        y: v.y * c - v.z * s,
        z: v.y * s + v.z * c
    };
}
/** v rotated `degrees` about +z, counterclockwise seen from above. */ function $b1fa7818744d9b6c$var$rotateAboutZ(v, degrees) {
    if (degrees === 0) return v;
    const c = Math.cos(degrees * $b1fa7818744d9b6c$var$DEG_TO_RAD);
    const s = Math.sin(degrees * $b1fa7818744d9b6c$var$DEG_TO_RAD);
    return {
        x: v.x * c - v.y * s,
        y: v.x * s + v.y * c,
        z: v.z
    };
}
/**
 * The spin axis before any head rotation: in the x-z plane at `axis` degrees,
 * reversed for positive spin so the Magnus force falls out of a cross product.
 */ function $b1fa7818744d9b6c$var$unrotatedSpinAxis(spin) {
    const x = Math.cos(spin.axis * Math.PI / 180.0);
    const z = Math.sin(spin.axis * Math.PI / 180.0);
    return spin.rpm > 0 ? {
        x: -x,
        y: -0,
        z: -z
    } : {
        x: x,
        y: 0,
        z: z
    };
}
/**
 * The end of the lift arm at a head height, in lift coordinates: the arm
 * swings in the trainer's y-z plane about the pivot, and lift coordinates put
 * the origin at the arm's tip when it is level.
 *
 * Throws on a head height the lift arm cannot reach.
 */ function $b1fa7818744d9b6c$var$headInLift(geometry, headHeight) {
    const { liftPivot: liftPivot, liftArmLength: arm } = geometry;
    const headZ = headHeight - liftPivot.z;
    if (!(Math.abs(headZ) <= arm)) throw new RangeError(`head height ${headHeight} is out of the lift arm's reach [${liftPivot.z - arm}, ${liftPivot.z + arm}]`);
    return {
        x: 0,
        y: -arm + Math.sqrt(arm * arm - headZ * headZ),
        z: headZ
    };
}
/**
 * Where the ball leaves the wheels, in court coordinates, for a trainer at
 * `pose` with its head tilted `pitch` and panned `yaw` degrees.
 *
 * Throws on angles beyond ±90° or a head height the lift arm cannot reach.
 */ function $b1fa7818744d9b6c$var$launchPoint(geometry, pose, pitch = 0, yaw = 0) {
    if (!(Math.abs(yaw) <= 90 && Math.abs(pitch) <= 90)) throw new RangeError(`head yaw and pitch (${yaw}, ${pitch}) must be in [-90, 90]`);
    const { liftPivot: liftPivot, liftArmLength: arm, launchOriginOffset: offset, launchRadius: launchRadius } = geometry;
    const head = $b1fa7818744d9b6c$var$headInLift(geometry, pose.headHeight);
    // The wheels rotate about a point fixed to the head; the ball leaves
    // launchRadius in front of it, along the head's aim.
    const reach = launchRadius * Math.cos(pitch * $b1fa7818744d9b6c$var$DEG_TO_RAD);
    const lift = {
        x: head.x + offset.x + reach * Math.sin(yaw * $b1fa7818744d9b6c$var$DEG_TO_RAD),
        y: head.y + offset.y + reach * Math.cos(yaw * $b1fa7818744d9b6c$var$DEG_TO_RAD),
        z: head.z + offset.z + launchRadius * Math.sin(pitch * $b1fa7818744d9b6c$var$DEG_TO_RAD)
    };
    const body = {
        x: lift.x + liftPivot.x,
        y: lift.y + (liftPivot.y + arm),
        z: lift.z + liftPivot.z
    };
    const turned = $b1fa7818744d9b6c$var$rotateAboutZ(body, -pose.yaw);
    return {
        x: turned.x + pose.x,
        y: turned.y + pose.y,
        z: turned.z
    };
}
/**
 * The release for a trainer at `pose` throwing `launch`. With the "v1" spin
 * model it is bit-identical to v1's _initializeLaunch.
 */ function $b1fa7818744d9b6c$var$release(profile, pose, launch, spinModel = "physical") {
    const { geometry: geometry, mechanism: mechanism } = profile.trainer;
    const { speed: speed, spin: spin } = launch;
    const origin = $b1fa7818744d9b6c$var$launchPoint(geometry, pose, launch.pitch, launch.yaw);
    const correction = mechanism.deflectionCorrection(spin, speed);
    const yaw = launch.yaw - correction.yaw;
    const pitch = launch.pitch - correction.pitch;
    const heading = (pose.yaw + yaw) * Math.PI / 180.0;
    const elevation = pitch * Math.PI / 180.0;
    const horizontal = speed * Math.cos(elevation);
    // The axis is given looking at the ball from behind (x right, z up), with
    // the ball flying +y. "physical" turns it exactly as the ball's direction
    // turns: tilt about x, then pan and body yaw about z, so it stays
    // perpendicular to the throw.
    const spinAxis = spinModel === "physical" ? $b1fa7818744d9b6c$var$rotateAboutZ($b1fa7818744d9b6c$var$rotateAboutX($b1fa7818744d9b6c$var$unrotatedSpinAxis(spin), pitch), -(pose.yaw + yaw)) : $b1fa7818744d9b6c$var$rotateAboutZ($b1fa7818744d9b6c$var$rotateAboutX($b1fa7818744d9b6c$var$rotateAboutZ($b1fa7818744d9b6c$var$unrotatedSpinAxis(spin), -yaw), -pitch), -pose.yaw);
    return {
        origin: origin,
        velocity: {
            x: horizontal * Math.sin(heading),
            y: horizontal * Math.cos(heading),
            z: speed * Math.sin(elevation)
        },
        spinAxis: spinAxis,
        spinRpm: spin.rpm,
        pitch: pitch,
        yaw: yaw,
        deflection: {
            pitch: -correction.pitch,
            yaw: -correction.yaw
        }
    };
}
/**
 * The release for a ball struck by a player: no head and no deflection.
 *
 * "v1" leaves the spin axis unrotated in the court's x-z plane, bit-identical
 * to v1's _initializeStroke, so its topspin is topspin only for a ball flying
 * +y. "physical" reads the axis as for a trainer throw, seen from behind the
 * ball, and turns it with the stroke's own elevation and heading as release()
 * turns a throw's: topspin dips whichever way the ball is struck.
 */ function $b1fa7818744d9b6c$var$strokeRelease(origin, velocity, spin = $4iTSZ.NO_SPIN, spinModel = "physical") {
    return {
        origin: {
            x: origin.x,
            y: origin.y,
            z: origin.z
        },
        velocity: {
            x: velocity.x,
            y: velocity.y,
            z: velocity.z
        },
        spinAxis: spinModel === "physical" ? $b1fa7818744d9b6c$var$alongStroke($b1fa7818744d9b6c$var$unrotatedSpinAxis(spin), velocity) : $b1fa7818744d9b6c$var$unrotatedSpinAxis(spin),
        spinRpm: spin.rpm,
        pitch: 0,
        yaw: 0,
        deflection: {
            pitch: 0,
            yaw: 0
        }
    };
}
/** An axis given for a ball flying +y, turned to fly along `velocity`: tilt by its elevation, then pan by its heading. */ function $b1fa7818744d9b6c$var$alongStroke(axis, velocity) {
    const heading = Math.atan2(velocity.x, velocity.y) * 180.0 / Math.PI;
    const elevation = Math.atan2(velocity.z, Math.hypot(velocity.x, velocity.y)) * 180.0 / Math.PI;
    return $b1fa7818744d9b6c$var$rotateAboutZ($b1fa7818744d9b6c$var$rotateAboutX(axis, elevation), -heading);
}

});
parcelRegister("4iTSZ", function(module, exports) {
"use strict";
/**
 * Public types for the physics engine.
 *
 * Units at this boundary match the rest of the package: meters, seconds,
 * degrees, physics coordinates (origin at the venue's center, +x right, +y toward
 * the far baseline, +z up). Ball spin is in ball RPM.
 *
 * Everything here is plain, immutable data. The engine never mutates what it
 * is given and keeps no state between calls.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NO_SPIN = void 0;
module.exports.NO_SPIN = Object.freeze({
    rpm: 0,
    axis: 0
});

});



parcelRegister("8ogrt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.armAngle = $61bd51abe65e423c$var$armAngle;
module.exports.headHeightForCamera = $61bd51abe65e423c$var$headHeightForCamera;
module.exports.headHeightForLaunch = $61bd51abe65e423c$var$headHeightForLaunch;
module.exports.camera = $61bd51abe65e423c$var$camera;
module.exports.poseFromCamera = $61bd51abe65e423c$var$poseFromCamera;

var $7Vdbm = parcelRequire("7Vdbm");

var $fhneO = parcelRequire("fhneO");
/** The lift arm's angle above level, in degrees, at a head height (v1 GetArmAngle). */ function $61bd51abe65e423c$var$armAngle(geometry, headHeight) {
    const head = (0, $fhneO.headInLift)(geometry, headHeight);
    return Math.atan2(head.z, geometry.liftArmLength + head.y) * 180 / Math.PI;
}
/** The head height that puts the camera at `cameraHeight` (v1 cameraHeight2HeadHeight). */ function $61bd51abe65e423c$var$headHeightForCamera(geometry, cameraHeight) {
    return cameraHeight - geometry.cameraOffsetFromHead.z;
}
/**
 * The head height that puts a level launch point at `launchHeight` (v1
 * launchHeight2HeadHeight). v1 reads defaultLaunchPointOffset; profiles
 * check that its height equals launchOriginOffset's.
 */ function $61bd51abe65e423c$var$headHeightForLaunch(geometry, launchHeight) {
    return launchHeight - geometry.launchOriginOffset.z;
}
/**
 * The camera in the trainer's frame, for a camera `cameraZ` millimeters up
 * (v1 _getCameraLocationInTrainerCoords). Throws if the arm cannot put it there.
 */ function $61bd51abe65e423c$var$cameraInTrainer(geometry, cameraZ) {
    const { liftPivot: liftPivot, liftArmLength: arm, cameraOffsetFromHead: offset } = geometry;
    const head = (0, $fhneO.headInLift)(geometry, $61bd51abe65e423c$var$headHeightForCamera(geometry, cameraZ / 1000.0));
    return {
        x: head.x + offset.x + liftPivot.x,
        y: head.y + offset.y + (liftPivot.y + arm),
        z: head.z + offset.z + liftPivot.z
    };
}
/**
 * The camera, in localization coordinates, of a trainer standing at `pose`
 * (v1 _computeLocalizedCameraPosition). Roll and pitch are the mounting's,
 * level and cameraDownwardPitch below it, unless `keep` carries the ones
 * vision measured. Throws on a head height the arm cannot reach.
 */ function $61bd51abe65e423c$var$camera(profile, pose, keep) {
    const { geometry: geometry } = profile.trainer;
    const cameraZ = (pose.headHeight + geometry.cameraOffsetFromHead.z) * 1000.0;
    const { x: x, y: y, z: z } = (0, $7Vdbm.toLocalization)(profile.venue, (0, $7Vdbm.fromTrainerFrame)($61bd51abe65e423c$var$cameraInTrainer(geometry, cameraZ), pose));
    const { roll: roll, pitch: pitch } = keep ?? {
        roll: 0,
        pitch: 90 - geometry.cameraDownwardPitch
    };
    return {
        x: x,
        y: y,
        z: z,
        roll: roll,
        pitch: pitch,
        yaw: pose.yaw
    };
}
/**
 * The pose of a trainer whose camera vision localized at `localized` (v1
 * SetPositionLocalized). The camera's roll and pitch do not enter. Throws if
 * the arm cannot hold the camera at that height.
 */ function $61bd51abe65e423c$var$poseFromCamera(profile, localized) {
    const { geometry: geometry } = profile.trainer;
    const inTrainer = (0, $fhneO.rotateAboutZ)($61bd51abe65e423c$var$cameraInTrainer(geometry, localized.z), -localized.yaw);
    const atCourt = (0, $7Vdbm.fromLocalization)(profile.venue, localized);
    return {
        x: atCourt.x - inTrainer.x,
        y: atCourt.y - inTrainer.y,
        yaw: localized.yaw,
        headHeight: $61bd51abe65e423c$var$headHeightForCamera(geometry, localized.z / 1000.0)
    };
}

});
parcelRegister("7Vdbm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toLocalization = $5c4814f82278bb3f$var$toLocalization;
module.exports.fromLocalization = $5c4814f82278bb3f$var$fromLocalization;
module.exports.fromTrainerFrame = $5c4814f82278bb3f$var$fromTrainerFrame;
module.exports.toTrainerFrame = $5c4814f82278bb3f$var$toTrainerFrame;

var $fhneO = parcelRequire("fhneO");
/** Physics to the venue's localization frame (on a court: mm from the far-left corner, +y toward the near baseline). */ function $5c4814f82278bb3f$var$toLocalization({ frame: { localization: localization } }, p) {
    const { origin: origin, flipY: flipY, unitsPerMeter: unitsPerMeter } = localization;
    return {
        x: (p.x - origin.x) * unitsPerMeter,
        y: (flipY ? -(p.y - origin.y) : p.y - origin.y) * unitsPerMeter,
        z: (p.z - origin.z) * unitsPerMeter
    };
}
/** Adding a zero offset would turn -0 into +0, where v1 adds nothing. */ const $5c4814f82278bb3f$var$offset = (value, by)=>by === 0 ? value : value + by;
/** The venue's localization frame to physics; the inverse of toLocalization. */ function $5c4814f82278bb3f$var$fromLocalization({ frame: { localization: localization } }, p) {
    const { origin: origin, flipY: flipY, unitsPerMeter: unitsPerMeter } = localization;
    const y = p.y / unitsPerMeter;
    return {
        x: $5c4814f82278bb3f$var$offset(p.x / unitsPerMeter, origin.x),
        y: $5c4814f82278bb3f$var$offset(flipY ? -y : y, origin.y),
        z: $5c4814f82278bb3f$var$offset(p.z / unitsPerMeter, origin.z)
    };
}
/**
 * A point in the trainer's frame (origin on the ground under the rear axle,
 * +y the way it faces) to physics, for a trainer standing at `pose` (v1
 * trainer2physics). The head height does not enter: the frame sits on the
 * ground.
 */ function $5c4814f82278bb3f$var$fromTrainerFrame(p, pose) {
    const turned = (0, $fhneO.rotateAboutZ)(p, -pose.yaw);
    return {
        x: turned.x + pose.x,
        y: turned.y + pose.y,
        z: turned.z
    };
}
/** Physics to the trainer's frame; the inverse of fromTrainerFrame (v1 physics2trainer). */ function $5c4814f82278bb3f$var$toTrainerFrame(p, pose) {
    return (0, $fhneO.rotateAboutZ)({
        x: p.x - pose.x,
        y: p.y - pose.y,
        z: p.z
    }, pose.yaw);
}

});


parcelRegister("kOjGe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.referencePoint = $f267be3936051bef$var$referencePoint;
module.exports.localizationNetClearance = $f267be3936051bef$var$localizationNetClearance;
module.exports.localizationHeadHeight = $f267be3936051bef$var$localizationHeadHeight;

var $8ogrt = parcelRequire("8ogrt");

var $7Vdbm = parcelRequire("7Vdbm");
/** A named reference point of the venue (v1 getCourtPointByName), if it has one. */ function $f267be3936051bef$var$referencePoint({ frame: { referencePoints: referencePoints } }, name) {
    return Object.hasOwn(referencePoints, name) ? referencePoints[name] : undefined;
}
function $f267be3936051bef$var$requireNet(venue) {
    if (!venue.arena.panels.some((panel)=>panel.kind === "net")) throw new RangeError(`${venue.sport} has no net to see over`);
}
const $f267be3936051bef$var$MIN_CLEARANCE = 1.0; // ft, from the baseline back
const $f267be3936051bef$var$MAX_CLEARANCE = 3.0; // ft, at the net
/**
 * The net clearance, in whole feet, user-aided localization should ask for
 * with the trainer at `trainerY` (v1 calculateNetClearanceHeight): 3 ft at
 * the net, falling linearly to 1 ft at the trainer-side edge of the stage
 * (the near baseline) and beyond. Throws on a venue with no net, where v1
 * answers with a number that means nothing.
 */ function $f267be3936051bef$var$localizationNetClearance(venue, trainerY) {
    $f267be3936051bef$var$requireNet(venue);
    const { stage: stage } = venue;
    const fromNet = Math.min(Math.abs(trainerY) / -stage.extents.y[0], 1.0);
    const clearance = $f267be3936051bef$var$MAX_CLEARANCE - fromNet * ($f267be3936051bef$var$MAX_CLEARANCE - $f267be3936051bef$var$MIN_CLEARANCE);
    return Math.floor(Math.max($f267be3936051bef$var$MIN_CLEARANCE, Math.min($f267be3936051bef$var$MAX_CLEARANCE, clearance)));
}
const $f267be3936051bef$var$FEET_PER_METER = 3.281; // v1's rounding
const $f267be3936051bef$var$FAR_COURT_MIN_Y = 0.1; // m
const $f267be3936051bef$var$NEAR_COURT_MAX_Y = -0.01; // m
/** Clamped heights stop this fraction of the arm short of its ends. */ const $f267be3936051bef$var$REACH_MARGIN = 0.99;
/**
 * The head height at which the camera's line of sight to the far-court
 * reference point `pointName` passes `clearanceFeet` above the net post tops
 * (v1 GetUserAidedLocalizationHeight), clamped inside the arm's reach.
 *
 * Throws if the sport has no such point or no net, the point is not in the
 * far court, or the camera is not in the near court.
 */ function $f267be3936051bef$var$localizationHeadHeight(profile, localized, pointName, clearanceFeet) {
    const { venue: venue } = profile;
    const { geometry: geometry } = profile.trainer;
    const target = $f267be3936051bef$var$referencePoint(venue, pointName);
    if (target === undefined) throw new RangeError(`${pointName} is not a ${venue.sport} reference point`);
    const cam = (0, $7Vdbm.fromLocalization)(venue, localized);
    const netPost = $f267be3936051bef$var$referencePoint(venue, "netpost_r_t");
    if (netPost === undefined) throw new RangeError(`${venue.sport} has no net to see over`);
    if (!(target.y >= $f267be3936051bef$var$FAR_COURT_MIN_Y)) throw new RangeError(`${pointName} (y = ${target.y} m) must be at least ${$f267be3936051bef$var$FAR_COURT_MIN_Y} m into the far court`);
    if (!(cam.y <= $f267be3936051bef$var$NEAR_COURT_MAX_Y)) throw new RangeError(`the camera (y = ${cam.y} m) must be at least ${-$f267be3936051bef$var$NEAR_COURT_MAX_Y} m into the near court`);
    // The sight line from camera to point crosses the net plane (y = 0) at
    // parameter t; solve for the camera height that puts it at clearZ there.
    const clearZ = netPost.z + clearanceFeet / $f267be3936051bef$var$FEET_PER_METER;
    const t = -cam.y / (target.y - cam.y);
    const headHeight = (0, $8ogrt.headHeightForCamera)(geometry, (clearZ - t * target.z) / (1.0 - t));
    const { liftPivot: liftPivot, liftArmLength: arm } = geometry;
    const fromPivot = headHeight - liftPivot.z;
    if (fromPivot > arm) return $f267be3936051bef$var$REACH_MARGIN * arm + liftPivot.z;
    if (fromPivot < -arm) return liftPivot.z - $f267be3936051bef$var$REACH_MARGIN * arm;
    return headHeight;
}

});

parcelRegister("dGzHP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ENDPOINT_FIELDS = void 0;
module.exports.createFlight = $9f6ae514f99a409c$var$createFlight;
/** What endpoint() writes to `out`, in order. */ module.exports.ENDPOINT_FIELDS = [
    "t",
    "x",
    "y",
    "z",
    "vx",
    "vy",
    "vz",
    "apexZ"
];
const $9f6ae514f99a409c$var$MAX_DURATION = 5; // s, v1 simParams.duration
const $9f6ae514f99a409c$var$DEFAULT_UNTIL = {
    kind: "bounces",
    count: 3
}; // v1 simParams.bounces
const $9f6ae514f99a409c$var$OUT_OF_BOUNDS_MARGIN = 0.1; // m, v1 _ballOutOfBounds
/** rk4: a ground bounce lower than this ends the bouncing; the ball rolls. */ const $9f6ae514f99a409c$var$REST_HEIGHT = 1e-4; // m
function $9f6ae514f99a409c$var$createFlight(profile, options = {}) {
    const integrator = options.integrator ?? "rk4";
    const timeStep = options.timeStep ?? (integrator === "rk4" ? 0.02 : 0.001);
    if (!(timeStep > 0)) throw new RangeError(`timeStep must be positive, got ${timeStep}`);
    const world = $9f6ae514f99a409c$var$buildWorld(profile, options.spinModel ?? (integrator === "rk4" ? "physical" : "v1"), integrator);
    const worlds = {
        all: world,
        ground: {
            ...world,
            panels: [],
            legacy: $9f6ae514f99a409c$var$NO_LEGACY_PANELS
        },
        none: {
            ...world,
            panels: [],
            legacy: $9f6ae514f99a409c$var$NO_LEGACY_PANELS,
            ground: null
        }
    };
    const scratch = $9f6ae514f99a409c$var$createScratch();
    const run = integrator === "rk4" ? $9f6ae514f99a409c$var$runRk4 : $9f6ae514f99a409c$var$runLegacy;
    const fly = (release, flyOptions = {})=>{
        const log = $9f6ae514f99a409c$var$createLog(flyOptions.path ?? false);
        const surfaces = flyOptions.surfaces ?? "all";
        const stop = $9f6ae514f99a409c$var$toStop(flyOptions.until ?? $9f6ae514f99a409c$var$DEFAULT_UNTIL, (flyOptions.stopOutOfBounds ?? true) && surfaces !== "none");
        run(worlds[surfaces], timeStep, release, stop, log.recorder, scratch);
        const { result: result } = scratch;
        return {
            origin: release.origin,
            velocity: release.velocity,
            contacts: log.contacts,
            end: scratch.ended ? {
                t: result[$9f6ae514f99a409c$var$END_T],
                position: {
                    x: result[$9f6ae514f99a409c$var$END_X],
                    y: result[$9f6ae514f99a409c$var$END_Y],
                    z: result[$9f6ae514f99a409c$var$END_Z]
                }
            } : null,
            apex: {
                t: result[$9f6ae514f99a409c$var$APEX_T],
                position: {
                    x: result[$9f6ae514f99a409c$var$APEX_X],
                    y: result[$9f6ae514f99a409c$var$APEX_Y],
                    z: result[$9f6ae514f99a409c$var$APEX_Z]
                }
            },
            duration: result[$9f6ae514f99a409c$var$DURATION],
            ...log.path ? {
                path: log.path()
            } : {},
            stoppedBy: scratch.stoppedBy
        };
    };
    const endpointStop = {
        goal: "landing",
        value: 0,
        stopOutOfBounds: true
    };
    const endpoint = (release, until, out, surfaces = "all")=>{
        if (typeof until === "object") {
            if (integrator !== "rk4") throw new RangeError("endpoint({ time }) needs the rk4 integrator");
            endpointStop.goal = "time";
            endpointStop.value = until.time;
            endpointStop.stopOutOfBounds = surfaces !== "none";
            run(worlds[surfaces], timeStep, release, endpointStop, null, scratch);
            if (scratch.stoppedBy !== "until") return false;
            // rk4 leaves the ball's state at the stop in scratch.start
            const { start: start, result: result } = scratch;
            out[0] = result[$9f6ae514f99a409c$var$DURATION];
            for(let i = 0; i < 6; i++)out[1 + i] = start[i];
            out[7] = result[$9f6ae514f99a409c$var$APEX_Z];
            return true;
        }
        endpointStop.goal = until === "landing" ? "landing" : "descending";
        endpointStop.value = until === "landing" ? 0 : until;
        endpointStop.stopOutOfBounds = surfaces !== "none";
        run(worlds[surfaces], timeStep, release, endpointStop, null, scratch);
        if (!scratch.ended) return false;
        $9f6ae514f99a409c$var$copy(scratch.result, out, module.exports.ENDPOINT_FIELDS.length);
        return true;
    };
    const record = (release, recorder, flyOptions = {})=>{
        const surfaces = flyOptions.surfaces ?? "all";
        const stop = $9f6ae514f99a409c$var$toStop(flyOptions.until ?? $9f6ae514f99a409c$var$DEFAULT_UNTIL, (flyOptions.stopOutOfBounds ?? true) && surfaces !== "none");
        run(worlds[surfaces], timeStep, release, stop, recorder, scratch);
        return scratch.stoppedBy;
    };
    return {
        integrator: integrator,
        timeStep: timeStep,
        spinModel: world.spinModel,
        fly: fly,
        endpoint: endpoint,
        record: record
    };
}
const $9f6ae514f99a409c$var$NO_LEGACY_PANELS = {
    walls: [],
    net: null
};
/** The panels v1 has, by id, and which side of each is the court. */ const $9f6ae514f99a409c$var$V1_WALLS = [
    {
        id: "leftWall",
        axis: 0,
        inward: 1
    },
    {
        id: "rightWall",
        axis: 0,
        inward: -1
    },
    {
        id: "farWall",
        axis: 1,
        inward: -1
    }
];
function $9f6ae514f99a409c$var$buildWorld({ ball: ball, venue: venue, environment: environment }, spinModel, integrator) {
    const { arena: arena } = venue;
    const radius = ball.diameter / 2.0;
    const area = Math.PI * radius * radius;
    const dragCoefficient = 0.5 * environment.airDensity * ball.dragCoefficient * area;
    return {
        gravity: environment.gravity,
        mass: ball.mass,
        radius: radius,
        dragPerMass: -1 * (dragCoefficient / ball.mass),
        magnusCoefficient: 0.5 * environment.airDensity * area,
        liftCoefficient: ball.liftCoefficient,
        spinModel: spinModel,
        ground: {
            restitution: arena.ground.restitution
        },
        panels: integrator === "rk4" ? arena.panels.map($9f6ae514f99a409c$var$panelPlane) : [],
        legacy: integrator === "legacy" ? $9f6ae514f99a409c$var$legacyPanels(arena) : $9f6ae514f99a409c$var$NO_LEGACY_PANELS,
        reach: {
            minX: arena.bounds.x[0] - $9f6ae514f99a409c$var$OUT_OF_BOUNDS_MARGIN,
            maxX: arena.bounds.x[1] + $9f6ae514f99a409c$var$OUT_OF_BOUNDS_MARGIN,
            minY: arena.bounds.y[0] - $9f6ae514f99a409c$var$OUT_OF_BOUNDS_MARGIN,
            maxY: arena.bounds.y[1] + $9f6ae514f99a409c$var$OUT_OF_BOUNDS_MARGIN
        }
    };
}
function $9f6ae514f99a409c$var$panelPlane(panel) {
    const { from: from, to: to, response: response } = panel;
    const dx = to.x - from.x;
    const dy = to.y - from.y;
    const length = Math.hypot(dx, dy);
    if (!(length > 0 && Number.isFinite(length))) throw new RangeError(`panel ${panel.id} must have a finite, positive length`);
    const alongX = dx / length;
    const alongY = dy / length;
    const midX = (from.x + to.x) / 2;
    const midY = (from.y + to.y) / 2;
    const bounce = response.kind === "bounce" ? response : null;
    return {
        id: panel.id,
        kind: panel.kind,
        midX: midX,
        midY: midY,
        alongX: alongX,
        alongY: alongY,
        halfLength: length / 2,
        normalX: -alongY,
        normalY: alongX,
        offset: midX * -alongY + midY * alongX,
        stopsLeft: panel.faces !== "right",
        stopsRight: panel.faces !== "left",
        bottom: panel.bottom,
        top: panel.top,
        rise: (panel.topAtEnds ?? panel.top) - panel.top,
        absorbs: bounce === null,
        restitution: bounce?.restitution ?? 0,
        tangential: bounce?.tangential ?? 0
    };
}
/**
 * v1's walls and net, read from the arena by id; the other panels are
 * ignored. v1's rules need its own geometry: planes along the axes, walls
 * that bounce.
 */ function $9f6ae514f99a409c$var$legacyPanels({ panels: panels }) {
    const walls = $9f6ae514f99a409c$var$V1_WALLS.flatMap(({ id: id, axis: axis, inward: inward })=>{
        const panel = panels.find((p)=>p.id === id);
        if (panel === undefined) return [];
        return [
            {
                id: id,
                kind: panel.kind,
                axis: axis,
                at: $9f6ae514f99a409c$var$alignedAt(panel, axis),
                inward: inward,
                height: panel.top,
                restitution: $9f6ae514f99a409c$var$legacyBounce(panel).restitution
            }
        ];
    });
    const net = panels.find((p)=>p.id === "net");
    return {
        walls: walls,
        net: net === undefined ? null : {
            id: net.id,
            y: $9f6ae514f99a409c$var$alignedAt(net, 1),
            height: net.top,
            ...$9f6ae514f99a409c$var$legacyBounce(net)
        }
    };
}
/** Where an axis-aligned panel's plane meets `axis`: x = at (axis 0) or y = at (axis 1). */ function $9f6ae514f99a409c$var$alignedAt({ id: id, from: from, to: to }, axis) {
    const [at, end] = axis === 0 ? [
        from.x,
        to.x
    ] : [
        from.y,
        to.y
    ];
    if (at !== end) throw new RangeError(`legacy: panel ${id} must lie along ${axis === 0 ? "x" : "y"} = constant, as v1's does`);
    return at;
}
function $9f6ae514f99a409c$var$legacyBounce({ id: id, response: response }) {
    if (response.kind !== "bounce") throw new RangeError(`legacy: panel ${id} must bounce, as v1's do`);
    return {
        restitution: response.restitution,
        tangential: response.tangential
    };
}
function $9f6ae514f99a409c$var$toStop(until, stopOutOfBounds) {
    switch(until.kind){
        case "landing":
            return {
                goal: "landing",
                value: 0,
                stopOutOfBounds: stopOutOfBounds
            };
        case "descending":
            return {
                goal: "descending",
                value: until.z,
                stopOutOfBounds: stopOutOfBounds
            };
        case "bounces":
            return {
                goal: "bounces",
                value: until.count,
                stopOutOfBounds: stopOutOfBounds
            };
        case "time":
            return {
                goal: "time",
                value: until.seconds,
                stopOutOfBounds: stopOutOfBounds
            };
    }
}
const $9f6ae514f99a409c$var$SPIN_AXIS = 0; // x, y, z: the unit v1 magnus axis
const $9f6ae514f99a409c$var$SPIN_ANGULAR_SPEED = 3; // rad/s
const $9f6ae514f99a409c$var$SPIN_MAGNUS = 4; // the Magnus coefficient, 0 without spin as in v1
const $9f6ae514f99a409c$var$END_T = 0;
const $9f6ae514f99a409c$var$END_X = 1;
const $9f6ae514f99a409c$var$END_Y = 2;
const $9f6ae514f99a409c$var$END_Z = 3;
const $9f6ae514f99a409c$var$END_V = 4; // vx, vy, vz
const $9f6ae514f99a409c$var$APEX_Z = 7;
const $9f6ae514f99a409c$var$APEX_T = 8;
const $9f6ae514f99a409c$var$APEX_X = 9;
const $9f6ae514f99a409c$var$APEX_Y = 10;
const $9f6ae514f99a409c$var$DURATION = 11;
const $9f6ae514f99a409c$var$STEP_START = 0;
const $9f6ae514f99a409c$var$STEP_LENGTH = 1;
const $9f6ae514f99a409c$var$STEP_EVENT = 2;
const $9f6ae514f99a409c$var$PLANE_OFFSET = 3; // after the normal's x, y, z
function $9f6ae514f99a409c$var$createScratch() {
    return {
        spin: new Float64Array(5),
        rolling: false,
        result: new Float64Array(12),
        ended: false,
        stoppedBy: "until",
        step: new Float64Array(3),
        event: $9f6ae514f99a409c$var$NO_EVENT,
        plane: new Float64Array(4),
        onPlane: false,
        leaving: $9f6ae514f99a409c$var$NO_EVENT,
        start: new Float64Array(6),
        end: new Float64Array(6),
        startAcceleration: new Float64Array(3),
        endAcceleration: new Float64Array(3),
        velocities: new Float64Array(12),
        accelerations: new Float64Array(12)
    };
}
function $9f6ae514f99a409c$var$prepare(world, release, scratch) {
    const { spin: spin, result: result } = scratch;
    spin[$9f6ae514f99a409c$var$SPIN_AXIS] = release.spinAxis.x;
    spin[$9f6ae514f99a409c$var$SPIN_AXIS + 1] = release.spinAxis.y;
    spin[$9f6ae514f99a409c$var$SPIN_AXIS + 2] = release.spinAxis.z;
    spin[$9f6ae514f99a409c$var$SPIN_ANGULAR_SPEED] = release.spinRpm / 60.0 * 2 * Math.PI;
    spin[$9f6ae514f99a409c$var$SPIN_MAGNUS] = release.spinRpm === 0 ? 0 : world.magnusCoefficient;
    scratch.rolling = false;
    scratch.ended = false;
    scratch.stoppedBy = "until";
    scratch.leaving = $9f6ae514f99a409c$var$NO_EVENT;
    result[$9f6ae514f99a409c$var$APEX_T] = 0;
    result[$9f6ae514f99a409c$var$APEX_X] = release.origin.x;
    result[$9f6ae514f99a409c$var$APEX_Y] = release.origin.y;
    result[$9f6ae514f99a409c$var$APEX_Z] = release.origin.z;
}
function $9f6ae514f99a409c$var$finish(scratch, t, x, y, z, vx, vy, vz) {
    const { result: result } = scratch;
    scratch.ended = true;
    result[$9f6ae514f99a409c$var$END_T] = t;
    result[$9f6ae514f99a409c$var$END_X] = x;
    result[$9f6ae514f99a409c$var$END_Y] = y;
    result[$9f6ae514f99a409c$var$END_Z] = z;
    result[$9f6ae514f99a409c$var$END_V] = vx;
    result[$9f6ae514f99a409c$var$END_V + 1] = vy;
    result[$9f6ae514f99a409c$var$END_V + 2] = vz;
}
function $9f6ae514f99a409c$var$raiseApex(result, t, x, y, z) {
    if (z > result[$9f6ae514f99a409c$var$APEX_Z]) {
        result[$9f6ae514f99a409c$var$APEX_T] = t;
        result[$9f6ae514f99a409c$var$APEX_X] = x;
        result[$9f6ae514f99a409c$var$APEX_Y] = y;
        result[$9f6ae514f99a409c$var$APEX_Z] = z;
    }
}
function $9f6ae514f99a409c$var$stop(scratch, reason, t) {
    scratch.stoppedBy = reason;
    scratch.result[$9f6ae514f99a409c$var$DURATION] = t;
}
/** Element copy: TypedArray.prototype.set costs more than the copy at these sizes. */ function $9f6ae514f99a409c$var$copy(from, to, length) {
    for(let i = 0; i < length; i++)to[i] = from[i];
}
// ---------------------------------------------------------------------------
// The force model
/**
 * The ball's acceleration at the velocity in v[from..from+2], written to
 * out[to..to+2]. The arithmetic follows v1's _tick operation for operation;
 * the legacy integrator depends on that for bit-exactness.
 */ function $9f6ae514f99a409c$var$accelerate(world, scratch, v, from, out, to) {
    const { spin: spin } = scratch;
    const vx = v[from];
    const vy = v[from + 1];
    const vz = v[from + 2];
    const speed = Math.sqrt(vx * vx + vy * vy + vz * vz);
    let magnusX = 0;
    let magnusY = 0;
    let magnusZ = 0;
    if (spin[$9f6ae514f99a409c$var$SPIN_MAGNUS] !== 0) {
        const axisX = spin[$9f6ae514f99a409c$var$SPIN_AXIS];
        const axisY = spin[$9f6ae514f99a409c$var$SPIN_AXIS + 1];
        const axisZ = spin[$9f6ae514f99a409c$var$SPIN_AXIS + 2];
        let dirX = axisY * vz - vy * axisZ;
        let dirY = -(axisX * vz - vx * axisZ);
        let dirZ = axisX * vy - vx * axisY;
        // v1 lifts at full strength along the cross product's direction at any
        // angle; physically lift goes with omega x v, i.e. |axis x v| / |v|.
        // (A ball at rest has no cross product either; 1 keeps that at 0, not NaN.)
        const norm = world.spinModel === "v1" ? Math.sqrt(dirX * dirX + dirY * dirY + dirZ * dirZ) : speed || 1;
        dirX /= norm;
        dirY /= norm;
        dirZ /= norm;
        const lift = world.liftCoefficient(world.radius, spin[$9f6ae514f99a409c$var$SPIN_ANGULAR_SPEED], speed);
        const force = spin[$9f6ae514f99a409c$var$SPIN_MAGNUS] * lift * speed * speed;
        magnusX = force * dirX / world.mass;
        magnusY = force * dirY / world.mass;
        magnusZ = force * dirZ / world.mass;
    }
    const drag = world.dragPerMass * speed;
    out[to] = drag * vx + magnusX;
    out[to + 1] = drag * vy + magnusY;
    out[to + 2] = scratch.rolling ? 0 : drag * vz - world.gravity + magnusZ;
}
// ---------------------------------------------------------------------------
// legacy: v1's scheme
function $9f6ae514f99a409c$var$runLegacy(world, dt, release, { goal: goal, value: value, stopOutOfBounds: stopOutOfBounds }, recorder, scratch) {
    $9f6ae514f99a409c$var$prepare(world, release, scratch);
    const { result: result, spin: spin } = scratch;
    const { ground: ground, reach: reach } = world;
    const { walls: walls, net: net } = world.legacy;
    const capT = goal === "time" ? Math.min(value, $9f6ae514f99a409c$var$MAX_DURATION) : $9f6ae514f99a409c$var$MAX_DURATION;
    // accelerate()'s inputs, hoisted: the step below repeats its arithmetic
    // on locals, which V8 keeps in registers (the call and its typed-array
    // round trip cost v1's own loop's time again).
    const { gravity: gravity, mass: mass, radius: radius, dragPerMass: dragPerMass, liftCoefficient: liftCoefficient } = world;
    const v1Lift = world.spinModel === "v1";
    const magnus = spin[$9f6ae514f99a409c$var$SPIN_MAGNUS];
    const axisX = spin[$9f6ae514f99a409c$var$SPIN_AXIS];
    const axisY = spin[$9f6ae514f99a409c$var$SPIN_AXIS + 1];
    const axisZ = spin[$9f6ae514f99a409c$var$SPIN_AXIS + 2];
    const angularSpeed = spin[$9f6ae514f99a409c$var$SPIN_ANGULAR_SPEED];
    let x = release.origin.x;
    let y = release.origin.y;
    let z = release.origin.z;
    let vx = release.velocity.x;
    let vy = release.velocity.y;
    let vz = release.velocity.z;
    let contacts = 0;
    let landed = false;
    let previousT = 0;
    let time = 0;
    recorder?.point(0, x, y, z, vx, vy, vz);
    // A per-iteration `let time` in the for header would cost V8 an allocation per step.
    for(;;){
        time += dt;
        // accelerate(), operation for operation (the legacy loop is never rolling)
        const speed = Math.sqrt(vx * vx + vy * vy + vz * vz);
        let magnusX = 0;
        let magnusY = 0;
        let magnusZ = 0;
        if (magnus !== 0) {
            let dirX = axisY * vz - vy * axisZ;
            let dirY = -(axisX * vz - vx * axisZ);
            let dirZ = axisX * vy - vx * axisY;
            const norm = v1Lift ? Math.sqrt(dirX * dirX + dirY * dirY + dirZ * dirZ) : speed || 1;
            dirX /= norm;
            dirY /= norm;
            dirZ /= norm;
            const force = magnus * liftCoefficient(radius, angularSpeed, speed) * speed * speed;
            magnusX = force * dirX / mass;
            magnusY = force * dirY / mass;
            magnusZ = force * dirZ / mass;
        }
        const drag = dragPerMass * speed;
        const ax = drag * vx + magnusX;
        const ay = drag * vy + magnusY;
        const az = drag * vz - gravity + magnusZ;
        vx = vx + ax * dt;
        vy = vy + ay * dt;
        vz = vz + az * dt;
        const px = x;
        const py = y;
        const pz = z;
        x = x + vx * dt + 0.5 * ax * dt * dt;
        y = y + vy * dt + 0.5 * ay * dt * dt;
        z = z + vz * dt + 0.5 * az * dt * dt;
        const inVx = vx;
        const inVy = vy;
        const inVz = vz;
        // v1 _detectBounce: no interpolation; the sample is moved onto the surface.
        const hitGround = ground !== null && z <= 0.0;
        if (hitGround) {
            z = 0.0;
            vz = -1 * vz * ground.restitution;
        }
        // v1's walls are endless planes and leave the velocity along them alone.
        let hitWall = null;
        for (const wall of walls){
            const p = wall.axis === 0 ? x : y;
            const outside = wall.inward > 0 ? p <= wall.at : p >= wall.at;
            if (outside && z < wall.height) {
                if (wall.axis === 0) {
                    x = wall.at;
                    vx = -1 * vx * wall.restitution;
                } else {
                    y = wall.at;
                    vy = -1 * vy * wall.restitution;
                }
                hitWall = wall;
                break;
            }
        }
        // v1's net has no width, a flat top, and only stops balls travelling toward +y.
        const hitNet = net !== null && py < net.y && y >= net.y && z < net.height;
        if (hitNet) {
            y = net.y;
            vy = -1 * vy * net.restitution;
            vx = vx * net.tangential;
            vz = vz * net.tangential;
        }
        $9f6ae514f99a409c$var$raiseApex(result, time, x, y, z);
        recorder?.point(time, x, y, z, inVx, inVy, inVz);
        if (hitGround || hitWall !== null || hitNet) recorder?.deflect(vx, vy, vz);
        if (hitGround) recorder?.contact(time, x, y, z, "ground", "ground");
        if (hitWall !== null) recorder?.contact(time, x, y, z, hitWall.id, hitWall.kind);
        if (hitNet) recorder?.contact(time, x, y, z, net.id, "net");
        contacts += (hitGround ? 1 : 0) + (hitWall !== null ? 1 : 0) + (hitNet ? 1 : 0);
        const firstLanding = hitGround && !landed;
        landed ||= hitGround;
        if (goal === "descending") {
            // v1 _crossingPoint: linear between samples, searched up to the landing sample.
            if (pz >= value && z < value) {
                const f = (pz - value) / (pz - z);
                const t = previousT + f * (time - previousT);
                $9f6ae514f99a409c$var$finish(scratch, t, px + f * (x - px), py + f * (y - py), value, inVx, inVy, inVz);
                recorder?.truncate(t, result[$9f6ae514f99a409c$var$END_X], result[$9f6ae514f99a409c$var$END_Y], value);
                return $9f6ae514f99a409c$var$stop(scratch, "until", t);
            }
            if (firstLanding) return $9f6ae514f99a409c$var$stop(scratch, "until", time);
        } else if (firstLanding) $9f6ae514f99a409c$var$finish(scratch, time, x, y, z, inVx, inVy, inVz);
        if (goal === "landing" && firstLanding) return $9f6ae514f99a409c$var$stop(scratch, "until", time);
        // v1 stops on exactly this many contacts; a step that overshoots the count flies on.
        if (goal === "bounces" && contacts === value) return $9f6ae514f99a409c$var$stop(scratch, "until", time);
        if (goal === "time" && time >= capT && capT === value) return $9f6ae514f99a409c$var$stop(scratch, "until", time);
        if (stopOutOfBounds && (x > reach.maxX || x < reach.minX || y > reach.maxY || y < reach.minY)) return $9f6ae514f99a409c$var$stop(scratch, "outOfBounds", time);
        if (time >= capT) return $9f6ae514f99a409c$var$stop(scratch, "timeLimit", time);
        previousT = time;
    }
}
// ---------------------------------------------------------------------------
// rk4: classical Runge-Kutta with exact events
/** Events other than a panel (a panel is its index in world.panels). */ const $9f6ae514f99a409c$var$NO_EVENT = -1;
const $9f6ae514f99a409c$var$GROUND = -2;
const $9f6ae514f99a409c$var$OUT_OF_BOUNDS = -3;
const $9f6ae514f99a409c$var$DESCENDING = -4;
function $9f6ae514f99a409c$var$runRk4(world, dt, release, stopAt, recorder, scratch) {
    $9f6ae514f99a409c$var$prepare(world, release, scratch);
    const { step: step, start: start, end: end, startAcceleration: startAcceleration, endAcceleration: endAcceleration } = scratch;
    const { goal: goal, value: value } = stopAt;
    const capT = goal === "time" ? Math.min(value, $9f6ae514f99a409c$var$MAX_DURATION) : $9f6ae514f99a409c$var$MAX_DURATION;
    const capReason = goal === "time" && capT === value ? "until" : "timeLimit";
    $9f6ae514f99a409c$var$setState(start, release.origin, release.velocity);
    $9f6ae514f99a409c$var$accelerate(world, scratch, start, 3, startAcceleration, 0);
    recorder?.point(0, start[0], start[1], start[2], start[3], start[4], start[5]);
    step[$9f6ae514f99a409c$var$STEP_START] = 0;
    let contacts = 0;
    for(;;){
        const remaining = capT - step[$9f6ae514f99a409c$var$STEP_START];
        if (remaining <= 1e-12) return $9f6ae514f99a409c$var$stop(scratch, capReason, step[$9f6ae514f99a409c$var$STEP_START]);
        const last = remaining <= dt;
        step[$9f6ae514f99a409c$var$STEP_LENGTH] = last ? remaining : dt;
        $9f6ae514f99a409c$var$rk4Step(world, scratch, end);
        $9f6ae514f99a409c$var$accelerate(world, scratch, end, 3, endAcceleration, 0);
        const event = $9f6ae514f99a409c$var$findEvent(world, scratch, stopAt);
        $9f6ae514f99a409c$var$recordApex(scratch);
        if (event === $9f6ae514f99a409c$var$NO_EVENT) {
            step[$9f6ae514f99a409c$var$STEP_START] = last ? capT : step[$9f6ae514f99a409c$var$STEP_START] + step[$9f6ae514f99a409c$var$STEP_LENGTH];
            $9f6ae514f99a409c$var$copy(end, start, 6);
            $9f6ae514f99a409c$var$copy(endAcceleration, startAcceleration, 3);
            recorder?.point(step[$9f6ae514f99a409c$var$STEP_START], start[0], start[1], start[2], start[3], start[4], start[5]);
            continue;
        }
        // Fly again from the step's start, exactly as far as the event.
        step[$9f6ae514f99a409c$var$STEP_LENGTH] *= step[$9f6ae514f99a409c$var$STEP_EVENT];
        $9f6ae514f99a409c$var$rk4Step(world, scratch, end);
        $9f6ae514f99a409c$var$refineEvent(world, scratch);
        step[$9f6ae514f99a409c$var$STEP_START] += step[$9f6ae514f99a409c$var$STEP_LENGTH];
        $9f6ae514f99a409c$var$copy(end, start, 6);
        const t = step[$9f6ae514f99a409c$var$STEP_START];
        if (event === $9f6ae514f99a409c$var$OUT_OF_BOUNDS) {
            recorder?.point(t, start[0], start[1], start[2], start[3], start[4], start[5]);
            return $9f6ae514f99a409c$var$stop(scratch, "outOfBounds", t);
        }
        if (event === $9f6ae514f99a409c$var$DESCENDING) {
            start[2] = value;
            recorder?.point(t, start[0], start[1], start[2], start[3], start[4], start[5]);
            $9f6ae514f99a409c$var$finishAtEvent(scratch);
            return $9f6ae514f99a409c$var$stop(scratch, "until", t);
        }
        // end keeps the arriving velocity; start takes the bounce.
        const panel = event === $9f6ae514f99a409c$var$GROUND ? null : world.panels[event];
        if (panel === null) $9f6ae514f99a409c$var$bounceOffGround(world, scratch);
        else $9f6ae514f99a409c$var$strike(panel, start);
        recorder?.point(t, start[0], start[1], start[2], end[3], end[4], end[5]);
        if (panel === null) recorder?.contact(t, start[0], start[1], start[2], "ground", "ground");
        else recorder?.contact(t, start[0], start[1], start[2], panel.id, panel.kind);
        if (panel?.absorbs) return $9f6ae514f99a409c$var$stop(scratch, "absorbed", t);
        recorder?.deflect(start[3], start[4], start[5]);
        scratch.leaving = event;
        contacts += 1;
        $9f6ae514f99a409c$var$accelerate(world, scratch, start, 3, startAcceleration, 0);
        if (panel === null) {
            if (goal === "descending") return $9f6ae514f99a409c$var$stop(scratch, "until", t);
            if (!scratch.ended) $9f6ae514f99a409c$var$finishAtEvent(scratch);
            if (goal === "landing") return $9f6ae514f99a409c$var$stop(scratch, "until", t);
        }
        if (goal === "bounces" && contacts >= value) return $9f6ae514f99a409c$var$stop(scratch, "until", t);
    }
}
function $9f6ae514f99a409c$var$setState(state, p, v) {
    state[0] = p.x;
    state[1] = p.y;
    state[2] = p.z;
    state[3] = v.x;
    state[4] = v.y;
    state[5] = v.z;
}
/** The flight ends at the event: the ball is at scratch.start, arriving with scratch.end's velocity. */ function $9f6ae514f99a409c$var$finishAtEvent(scratch) {
    const { result: result, step: step, start: start, end: end } = scratch;
    scratch.ended = true;
    result[$9f6ae514f99a409c$var$END_T] = step[$9f6ae514f99a409c$var$STEP_START];
    for(let i = 0; i < 3; i++){
        result[$9f6ae514f99a409c$var$END_X + i] = start[i];
        result[$9f6ae514f99a409c$var$END_V + i] = end[3 + i];
    }
}
/** One classical RK4 step of the current step's length from scratch.start into out. */ function $9f6ae514f99a409c$var$rk4Step(world, scratch, out) {
    const { start: s, startAcceleration: startAcceleration, velocities: v, accelerations: k } = scratch;
    const h = scratch.step[$9f6ae514f99a409c$var$STEP_LENGTH];
    for(let i = 0; i < 3; i++){
        v[i] = s[3 + i];
        k[i] = startAcceleration[i];
    }
    // Stages 2-4 move half, half, then all of the step along the previous stage's acceleration.
    for(let stage = 3; stage < 12; stage += 3){
        const reach = stage === 9 ? h : h / 2;
        for(let i = 0; i < 3; i++)v[stage + i] = v[i] + reach * k[stage - 3 + i];
        $9f6ae514f99a409c$var$accelerate(world, scratch, v, stage, k, stage);
    }
    const sixth = h / 6;
    for(let i = 0; i < 3; i++){
        out[i] = s[i] + sixth * (v[i] + 2 * v[3 + i] + 2 * v[6 + i] + v[9 + i]);
        out[3 + i] = v[i] + sixth * (k[i] + 2 * k[3 + i] + 2 * k[6 + i] + k[9 + i]);
    }
    if (scratch.rolling) out[5] = 0;
}
/**
 * The earliest event between scratch.start and scratch.end, located on the
 * step's cubic Hermite interpolant. Returns the event and leaves its fraction
 * of the step in scratch.step[STEP_EVENT].
 */ function $9f6ae514f99a409c$var$findEvent(world, scratch, { goal: goal, value: value, stopOutOfBounds: stopOutOfBounds }) {
    const { start: s, end: e } = scratch;
    const { panels: panels, reach: reach } = world;
    scratch.event = $9f6ae514f99a409c$var$NO_EVENT;
    scratch.step[$9f6ae514f99a409c$var$STEP_EVENT] = Infinity;
    if (world.ground !== null && !scratch.rolling) {
        if (s[2] > 0 && e[2] <= 0) $9f6ae514f99a409c$var$consider(world, scratch, $9f6ae514f99a409c$var$GROUND, 0, 0, 1, 0, 0);
        else if (s[2] <= 0 && e[2] < 0) $9f6ae514f99a409c$var$considerHop(world, scratch);
    }
    // A sign change of the distance to a panel's plane, from a side it stops.
    // Most steps end on a wall's playing side, so the end is tested first.
    for(let i = 0; i < panels.length; i++){
        if (i === scratch.leaving) continue;
        const panel = panels[i];
        const after = e[0] * panel.normalX + e[1] * panel.normalY - panel.offset;
        if (!(panel.stopsLeft && after <= 0 || panel.stopsRight && after >= 0)) continue;
        const before = s[0] * panel.normalX + s[1] * panel.normalY - panel.offset;
        if (panel.stopsLeft && before > 0 && after <= 0 || panel.stopsRight && before < 0 && after >= 0) $9f6ae514f99a409c$var$consider(world, scratch, i, panel.normalX, panel.normalY, 0, panel.offset, 0);
    }
    scratch.leaving = $9f6ae514f99a409c$var$NO_EVENT;
    if (stopOutOfBounds) {
        if (e[0] > reach.maxX) $9f6ae514f99a409c$var$consider(world, scratch, $9f6ae514f99a409c$var$OUT_OF_BOUNDS, 1, 0, 0, reach.maxX, 0);
        if (e[0] < reach.minX) $9f6ae514f99a409c$var$consider(world, scratch, $9f6ae514f99a409c$var$OUT_OF_BOUNDS, 1, 0, 0, reach.minX, 0);
        if (e[1] > reach.maxY) $9f6ae514f99a409c$var$consider(world, scratch, $9f6ae514f99a409c$var$OUT_OF_BOUNDS, 0, 1, 0, reach.maxY, 0);
        if (e[1] < reach.minY) $9f6ae514f99a409c$var$consider(world, scratch, $9f6ae514f99a409c$var$OUT_OF_BOUNDS, 0, 1, 0, reach.minY, 0);
    }
    if (goal === "descending" && s[2] > value && e[2] <= value) $9f6ae514f99a409c$var$consider(world, scratch, $9f6ae514f99a409c$var$DESCENDING, 0, 0, 1, value, 0);
    return scratch.event;
}
/**
 * Keeps `event` if the step reaches the plane normal . p = offset after
 * fraction `from` of the step and before the earliest event so far. The
 * normal is a unit vector; for an axis it picks out that coordinate exactly.
 */ function $9f6ae514f99a409c$var$consider(world, scratch, event, nx, ny, nz, offset, from) {
    const { start: s, end: e, step: step, plane: plane } = scratch;
    const h = step[$9f6ae514f99a409c$var$STEP_LENGTH];
    const f = $9f6ae514f99a409c$var$hermiteRoot(s[0] * nx + s[1] * ny + s[2] * nz, e[0] * nx + e[1] * ny + e[2] * nz, (s[3] * nx + s[4] * ny + s[5] * nz) * h, (e[3] * nx + e[4] * ny + e[5] * nz) * h, offset, from);
    if (f < step[$9f6ae514f99a409c$var$STEP_EVENT] && $9f6ae514f99a409c$var$admits(world, scratch, event, f)) {
        scratch.event = event;
        scratch.onPlane = true;
        step[$9f6ae514f99a409c$var$STEP_EVENT] = f;
        plane[0] = nx;
        plane[1] = ny;
        plane[2] = nz;
        plane[$9f6ae514f99a409c$var$PLANE_OFFSET] = offset;
    }
}
/**
 * The ball left the ground at the start of this step and is below it at the
 * end: a hop shorter than the step. It lands after the top of the hop; a hop
 * too low for the interpolant to rise above the ground lands at its top, so
 * the bounce finds the ball at rest.
 */ function $9f6ae514f99a409c$var$considerHop(world, scratch) {
    const { start: s, end: e, startAcceleration: a0, endAcceleration: a1, step: step } = scratch;
    const h = step[$9f6ae514f99a409c$var$STEP_LENGTH];
    const top = s[5] > 0 && e[5] < 0 ? $9f6ae514f99a409c$var$hermiteRoot(s[5], e[5], a0[2] * h, a1[2] * h, 0, 0) : 0;
    if ($9f6ae514f99a409c$var$hermite(s[2], e[2], s[5] * h, e[5] * h, top) > 0) $9f6ae514f99a409c$var$consider(world, scratch, $9f6ae514f99a409c$var$GROUND, 0, 0, 1, 0, top);
    else if (top < step[$9f6ae514f99a409c$var$STEP_EVENT]) {
        scratch.event = $9f6ae514f99a409c$var$GROUND;
        scratch.onPlane = false;
        step[$9f6ae514f99a409c$var$STEP_EVENT] = top;
    }
}
/**
 * Newton's method on the length of the event substep, so the ball ends it on
 * the event's plane to rounding rather than to the interpolant's accuracy.
 */ function $9f6ae514f99a409c$var$refineEvent(world, scratch) {
    const { step: step, end: end, plane: plane } = scratch;
    if (!scratch.onPlane) return;
    for(let i = 0; i < 4; i++){
        const miss = end[0] * plane[0] + end[1] * plane[1] + end[2] * plane[2] - plane[$9f6ae514f99a409c$var$PLANE_OFFSET];
        const speed = end[3] * plane[0] + end[4] * plane[1] + end[5] * plane[2];
        if (Math.abs(miss) <= 1e-13 || speed === 0) return;
        step[$9f6ae514f99a409c$var$STEP_LENGTH] = Math.max(0, step[$9f6ae514f99a409c$var$STEP_LENGTH] - miss / speed);
        $9f6ae514f99a409c$var$rk4Step(world, scratch, end);
    }
}
/**
 * Whether a plane crossing at fraction f of the step is a contact: a panel's
 * crossing must lie within its ends, at or above its bottom and below its
 * top, which rises as a parabola from the middle to the ends.
 */ function $9f6ae514f99a409c$var$admits(world, { start: s, end: e, step: step }, event, f) {
    if (event < 0) return true;
    const panel = world.panels[event];
    const h = step[$9f6ae514f99a409c$var$STEP_LENGTH];
    const x = $9f6ae514f99a409c$var$hermite(s[0], e[0], s[3] * h, e[3] * h, f);
    const y = $9f6ae514f99a409c$var$hermite(s[1], e[1], s[4] * h, e[4] * h, f);
    const along = (x - panel.midX) * panel.alongX + (y - panel.midY) * panel.alongY;
    if (!(Math.abs(along) <= panel.halfLength)) return false;
    const z = $9f6ae514f99a409c$var$hermite(s[2], e[2], s[5] * h, e[5] * h, f);
    const w = along / panel.halfLength;
    return z >= panel.bottom && z < panel.top + panel.rise * w * w;
}
/** Puts the ball (scratch.start, at the event) on the ground and bounces it. */ function $9f6ae514f99a409c$var$bounceOffGround(world, scratch) {
    const s = scratch.start;
    s[2] = 0;
    s[5] = -s[5] * world.ground.restitution; // GROUND events need a ground
    if (s[5] * s[5] < 2 * world.gravity * $9f6ae514f99a409c$var$REST_HEIGHT) {
        s[5] = 0;
        scratch.rolling = true;
    }
}
/**
 * Puts the ball on the panel's plane and, unless the panel absorbs it,
 * bounces it: the normal velocity reverses, scaled by restitution, and the
 * velocity tangent to the panel (along it and vertical) is scaled by
 * tangential. The arithmetic is exact for an axis-aligned panel.
 */ function $9f6ae514f99a409c$var$strike(panel, s) {
    const { normalX: nx, normalY: ny } = panel;
    const miss = s[0] * nx + s[1] * ny - panel.offset;
    s[0] -= miss * nx;
    s[1] -= miss * ny;
    if (panel.absorbs) return;
    const { restitution: restitution, tangential: tangential } = panel;
    const normal = s[3] * nx + s[4] * ny;
    s[3] = tangential * (s[3] - normal * nx) - restitution * normal * nx;
    s[4] = tangential * (s[4] - normal * ny) - restitution * normal * ny;
    s[5] *= tangential;
}
/** The top of the flight, if the ball reaches it in this step before any event. */ function $9f6ae514f99a409c$var$recordApex(scratch) {
    const { start: s, end: e, startAcceleration: a0, endAcceleration: a1, result: result, step: step } = scratch;
    if (!(s[5] > 0 && e[5] <= 0)) return;
    const h = step[$9f6ae514f99a409c$var$STEP_LENGTH];
    const f = $9f6ae514f99a409c$var$hermiteRoot(s[5], e[5], a0[2] * h, a1[2] * h, 0, 0);
    if (f > step[$9f6ae514f99a409c$var$STEP_EVENT]) return;
    $9f6ae514f99a409c$var$raiseApex(result, step[$9f6ae514f99a409c$var$STEP_START] + f * h, $9f6ae514f99a409c$var$hermite(s[0], e[0], s[3] * h, e[3] * h, f), $9f6ae514f99a409c$var$hermite(s[1], e[1], s[4] * h, e[4] * h, f), $9f6ae514f99a409c$var$hermite(s[2], e[2], s[5] * h, e[5] * h, f));
}
// ---------------------------------------------------------------------------
// Cubic Hermite interpolation on a unit interval: values p0, p1 and
// derivatives d0, d1 (already scaled by the interval's length).
function $9f6ae514f99a409c$var$hermite(p0, p1, d0, d1, s) {
    const s2 = s * s;
    const s3 = s2 * s;
    return (2 * s3 - 3 * s2 + 1) * p0 + (s3 - 2 * s2 + s) * d0 + (3 * s2 - 2 * s3) * p1 + (s3 - s2) * d1;
}
/**
 * Where on [from, 1] the interpolant reaches `target`, given that it lies on
 * either side of it at the two ends (or on it at 1): Newton's method, falling
 * back to bisection whenever a step would leave the bracket.
 */ function $9f6ae514f99a409c$var$hermiteRoot(p0, p1, d0, d1, target, from) {
    // The interpolant minus target as c3 s^3 + c2 s^2 + c1 s + c0, so the loop makes no calls.
    const c3 = 2 * p0 - 2 * p1 + d0 + d1;
    const c2 = 3 * p1 - 3 * p0 - 2 * d0 - d1;
    const c1 = d0;
    const c0 = p0 - target;
    const atFrom = ((c3 * from + c2) * from + c1) * from + c0;
    const rising = p1 - target > atFrom;
    let lo = from;
    let hi = 1;
    let s = from + atFrom / (atFrom - (p1 - target)) * (1 - from);
    if (!(s > lo && s < hi)) s = (lo + hi) / 2;
    for(let i = 0; i < 60; i++){
        const value = ((c3 * s + c2) * s + c1) * s + c0;
        if (value === 0) return s;
        if (value < 0 === rising) lo = s;
        else hi = s;
        let next = s - value / ((3 * c3 * s + 2 * c2) * s + c1);
        if (!(next > lo && next < hi)) next = (lo + hi) / 2;
        if (Math.abs(next - s) < 1e-15) return next;
        s = next;
    }
    return s;
}
function $9f6ae514f99a409c$var$createLog(withPath) {
    const contacts = [];
    let capacity = 512;
    let size = 0;
    let steps = new Float64Array(4 * capacity);
    let velocities = new Float64Array(6 * capacity); // arriving xyz, leaving xyz
    const grow = ()=>{
        capacity *= 2;
        const moreSteps = new Float64Array(4 * capacity);
        moreSteps.set(steps);
        steps = moreSteps;
        const moreVelocities = new Float64Array(6 * capacity);
        moreVelocities.set(velocities);
        velocities = moreVelocities;
    };
    const recorder = {
        point (t, x, y, z, vx, vy, vz) {
            if (!withPath) return;
            if (size === capacity) grow();
            $9f6ae514f99a409c$var$writeStep(steps, 4 * size, t, x, y, z);
            $9f6ae514f99a409c$var$writeVelocity(velocities, 6 * size, vx, vy, vz);
            $9f6ae514f99a409c$var$writeVelocity(velocities, 6 * size + 3, vx, vy, vz);
            size += 1;
        },
        deflect (vx, vy, vz) {
            if (withPath) $9f6ae514f99a409c$var$writeVelocity(velocities, 6 * (size - 1) + 3, vx, vy, vz);
        },
        contact (t, x, y, z, surface, kind) {
            contacts.push({
                t: t,
                position: {
                    x: x,
                    y: y,
                    z: z
                },
                surface: surface,
                kind: kind
            });
        },
        truncate (t, x, y, z) {
            if (withPath) $9f6ae514f99a409c$var$writeStep(steps, 4 * (size - 1), t, x, y, z);
        }
    };
    const path = withPath ? ()=>$9f6ae514f99a409c$var$createPath(steps.slice(0, 4 * size), velocities.slice(0, 6 * size)) : null;
    return {
        recorder: recorder,
        contacts: contacts,
        path: path
    };
}
function $9f6ae514f99a409c$var$writeStep(steps, at, t, x, y, z) {
    steps[at] = t;
    steps[at + 1] = x;
    steps[at + 2] = y;
    steps[at + 3] = z;
}
function $9f6ae514f99a409c$var$writeVelocity(velocities, at, vx, vy, vz) {
    velocities[at] = vx;
    velocities[at + 1] = vy;
    velocities[at + 2] = vz;
}
/** A path through recorded points, cubic Hermite between them (exact at the points). */ function $9f6ae514f99a409c$var$createPath(steps, velocities) {
    const count = steps.length / 4;
    const duration = steps[4 * (count - 1)];
    const write = (t, out, at)=>{
        const time = Math.min(Math.max(t, 0), duration);
        let lo = 0;
        let hi = count - 1;
        while(hi - lo > 1){
            const mid = lo + hi >> 1;
            if (steps[4 * mid] <= time) lo = mid;
            else hi = mid;
        }
        const t0 = steps[4 * lo];
        const span = steps[4 * hi] - t0;
        const f = span > 0 ? (time - t0) / span : 0;
        for(let axis = 0; axis < 3; axis++)out[at + axis] = $9f6ae514f99a409c$var$hermite(steps[4 * lo + 1 + axis], steps[4 * hi + 1 + axis], velocities[6 * lo + 3 + axis] * span, velocities[6 * hi + axis] * span, f);
    };
    const point = new Float64Array(3);
    return {
        duration: duration,
        steps: steps,
        at: (t)=>{
            write(t, point, 0);
            return {
                x: point[0],
                y: point[1],
                z: point[2]
            };
        },
        sample: (interval)=>{
            if (!(interval > 0)) throw new RangeError(`interval must be positive, got ${interval}`);
            const n = Math.floor(duration / interval + 1e-9) + 1;
            const out = new Float32Array(3 * n);
            for(let i = 0; i < n; i++)write(i * interval, out, 3 * i);
            return out;
        }
    };
}

});

parcelRegister("fgrOf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createReconstructor = $02de28f7dde66014$var$createReconstructor;

var $9UQpN = parcelRequire("9UQpN");

var $fhneO = parcelRequire("fhneO");

var $4iTSZ = parcelRequire("4iTSZ");
/** v1 asserts flightTime > 0.01 s: any shorter and the seed divides by almost nothing. */ const $02de28f7dde66014$var$MIN_SECONDS = 0.01;
/** Bounds each velocity component, m/s; far beyond any stroke, there only to keep the solver finite. */ const $02de28f7dde66014$var$MAX_COMPONENT = 150;
const $02de28f7dde66014$var$MAX_ITERATIONS = 20;
const $02de28f7dde66014$var$toDeg = (rad)=>rad * 180 / Math.PI;
const $02de28f7dde66014$var$finitePoint = (p)=>Number.isFinite(p.x) && Number.isFinite(p.y) && Number.isFinite(p.z);
const $02de28f7dde66014$var$invalid = (message)=>({
        ok: false,
        reason: "invalidInput",
        message: message
    });
function $02de28f7dde66014$var$createReconstructor(profile, kernel, options) {
    const { ball: ball, environment: environment } = profile;
    const { gravity: gravity } = environment;
    const dragPerMass = 0.5 * environment.airDensity * ball.dragCoefficient * Math.PI * (ball.diameter / 2) ** 2 / ball.mass;
    const { spinModel: spinModel } = kernel;
    // Finite-difference step: the rk4 free flight is smooth to rounding; the
    // legacy scheme is noisier, as in aim.
    const fdStep = kernel.integrator === "legacy" ? 1e-3 : 1e-5;
    const state = new Float64Array(8);
    /**
     * The free-flight position at `seconds` into out[1..3]. rk4 stops exactly
     * there; the legacy scheme only samples every step, so it reads the
     * flight's interpolated path instead (and allocates it, being the
     * comparison mode rather than the hot path).
     */ const positionAt = (release, seconds, out)=>{
        if (kernel.integrator === "rk4") return kernel.endpoint(release, {
            time: seconds
        }, out, "none");
        const flight = kernel.fly(release, {
            until: {
                kind: "time",
                seconds: seconds
            },
            surfaces: "none",
            path: true
        });
        if (flight.stoppedBy !== "until" || flight.path === undefined) return false;
        const p = flight.path.at(seconds);
        out[1] = p.x;
        out[2] = p.y;
        out[3] = p.z;
        return true;
    };
    return function reconstruct(strike, at, seconds, spin = $4iTSZ.NO_SPIN) {
        if (!$02de28f7dde66014$var$finitePoint(strike) || !$02de28f7dde66014$var$finitePoint(at)) return $02de28f7dde66014$var$invalid("strike and observed points must be finite");
        if (!(seconds > $02de28f7dde66014$var$MIN_SECONDS && Number.isFinite(seconds))) return $02de28f7dde66014$var$invalid(`seconds must be greater than ${$02de28f7dde66014$var$MIN_SECONDS}, got ${seconds}`);
        if (!Number.isFinite(spin.rpm) || !Number.isFinite(spin.axis)) return $02de28f7dde66014$var$invalid("spin must be finite");
        const seed = $02de28f7dde66014$var$idealVelocity(strike, at, seconds, gravity);
        // v1's stroke axis is fixed for a ball flying +y, so v1 negates the
        // spin of a stroke the seed sends toward -y. The physical model turns
        // the axis with the stroke instead and needs no negation.
        const strokeSpin = spinModel === "v1" && seed.y < 0 ? {
            rpm: -spin.rpm,
            axis: spin.axis
        } : spin;
        const releaseFor = (u)=>(0, $fhneO.strokeRelease)(strike, {
                x: u[0],
                y: u[1],
                z: u[2]
            }, strokeSpin, spinModel);
        const solution = (0, $9UQpN.solve)((u, r)=>{
            if (!positionAt(releaseFor(u), seconds, state)) return false;
            r[0] = state[1] - at.x;
            r[1] = state[2] - at.y;
            r[2] = state[3] - at.z;
            return true;
        }, [
            seed.x,
            seed.y,
            seed.z
        ], {
            lower: [
                -$02de28f7dde66014$var$MAX_COMPONENT,
                -$02de28f7dde66014$var$MAX_COMPONENT,
                -$02de28f7dde66014$var$MAX_COMPONENT
            ],
            upper: [
                $02de28f7dde66014$var$MAX_COMPONENT,
                $02de28f7dde66014$var$MAX_COMPONENT,
                $02de28f7dde66014$var$MAX_COMPONENT
            ],
            steps: [
                fdStep,
                fdStep,
                fdStep
            ],
            maxIterations: $02de28f7dde66014$var$MAX_ITERATIONS,
            done: (r)=>Math.hypot(r[0], r[1], r[2]) <= options.tolerance,
            jacobian: $02de28f7dde66014$var$seedJacobian(seed, seconds, dragPerMass)
        });
        if (!solution.defined) return $02de28f7dde66014$var$invalid(`the flight cannot be followed for ${seconds} s`);
        const fit = {
            ...$02de28f7dde66014$var$strikeAngles({
                x: solution.u[0],
                y: solution.u[1],
                z: solution.u[2]
            }),
            flight: kernel.fly(releaseFor(solution.u), {
                stopOutOfBounds: false
            }),
            miss: Math.hypot(solution.r[0], solution.r[1], solution.r[2]),
            iterations: solution.iterations
        };
        return solution.converged ? {
            ok: true,
            ...fit
        } : {
            ok: false,
            reason: "noConvergence",
            message: `missed by ${fit.miss.toFixed(3)} m after ${fit.iterations} iterations`,
            closest: fit
        };
    };
}
/** v1 _getInitialVelocityGuess: constant horizontal velocity, gravity only. */ function $02de28f7dde66014$var$idealVelocity(strike, at, seconds, gravity) {
    return {
        x: (at.x - strike.x) / seconds,
        y: (at.y - strike.y) / seconds,
        z: (at.z - strike.z) / seconds + 0.5 * gravity * seconds
    };
}
/**
 * How the position at `seconds` moves with the strike velocity, near enough
 * to start Newton without differencing (which costs three flights). With
 * linear drag k it is (1 - e^(-kt)) / k in each direction; quadratic drag is
 * taken as linear at the seed's speed. Broyden updates correct the rest.
 */ function $02de28f7dde66014$var$seedJacobian(seed, seconds, dragPerMass) {
    const k = dragPerMass * Math.hypot(seed.x, seed.y, seed.z);
    const d = k > 0 ? -Math.expm1(-k * seconds) / k : seconds;
    return [
        [
            d,
            0,
            0
        ],
        [
            0,
            d,
            0
        ],
        [
            0,
            0,
            d
        ]
    ];
}
/** Speed and direction of a strike velocity, as v1 reports launchSpeed, launchPitch and launchYaw. */ function $02de28f7dde66014$var$strikeAngles(velocity) {
    const { x: x, y: y, z: z } = velocity;
    return {
        velocity: velocity,
        speed: Math.sqrt(x * x + y * y + z * z),
        pitch: $02de28f7dde66014$var$toDeg(Math.atan2(z, Math.sqrt(x * x + y * y))),
        yaw: $02de28f7dde66014$var$toDeg(Math.atan2(x, y))
    };
}

});


parcelRegister("54ih8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.loadProfile = $3b0b809915ecf80f$var$loadProfile;
module.exports.requireProfile = $3b0b809915ecf80f$var$requireProfile;

var $2Yg5G = parcelRequire("2Yg5G");

var $faJc0 = parcelRequire("faJc0");

var $2oLTm = parcelRequire("2oLTm");

var $gV6Yw = parcelRequire("gV6Yw");

var $bRtcj = parcelRequire("bRtcj");

var $hP7oQ = parcelRequire("hP7oQ");

var $90lsY = parcelRequire("90lsY");

var $bCDPq = parcelRequire("bCDPq");

var $3P7gP = parcelRequire("3P7gP");
/** Profiles on the default venues, and per venue a caller passed, by model, sport and ball. */ const $3b0b809915ecf80f$var$defaultVenueCache = new Map();
const $3b0b809915ecf80f$var$venueCache = new WeakMap();
function $3b0b809915ecf80f$var$cacheFor(venue) {
    if (venue === undefined) return $3b0b809915ecf80f$var$defaultVenueCache;
    let cache = $3b0b809915ecf80f$var$venueCache.get(venue);
    if (cache === undefined) {
        cache = new Map();
        $3b0b809915ecf80f$var$venueCache.set(venue, cache);
    }
    return cache;
}
/** The profile for a model, sport and (optionally) venue and ball, or why there is none. */ function $3b0b809915ecf80f$var$loadProfile(model, sport, options = {}) {
    const ball = options.ball ?? ((0, $2Yg5G.isSport)(sport) ? $hP7oQ.DEFAULT_BALL[sport] : "");
    const cache = $3b0b809915ecf80f$var$cacheFor(options.venue);
    const key = `${model}/${sport}/${ball}`;
    let result = cache.get(key);
    if (result === undefined) {
        result = (0, $90lsY.deepFreeze)($3b0b809915ecf80f$var$buildProfile(model, sport, ball, options.venue));
        cache.set(key, result);
    }
    return result;
}
/** The profile for a model, sport and (optionally) venue and ball; throws if unsupported. */ function $3b0b809915ecf80f$var$requireProfile(model, sport, options) {
    const result = $3b0b809915ecf80f$var$loadProfile(model, sport, options);
    if (!result.ok) throw new Error(result.message);
    return result.profile;
}
function $3b0b809915ecf80f$var$buildProfile(model, sport, ballId, requestedVenue) {
    const unsupported = (why)=>({
            ok: false,
            reason: "unsupported",
            message: `${model} / ${sport}: ${why}`
        });
    if (!Object.hasOwn($2oLTm.tableRPM2MPHMap, model)) return unsupported("unknown physics model");
    if (!(0, $2Yg5G.isSport)(sport)) return unsupported("unknown sport");
    const mphByRpm = $2oLTm.tableRPM2MPHMap[model][sport];
    if (mphByRpm.length === 0) return unsupported("the model has no RPM-to-speed data for this sport");
    const ball = (0, $hP7oQ.ballById)(ballId);
    if (ball === undefined) return unsupported(`unknown ball ${ballId}`);
    const venue = requestedVenue === undefined ? (0, $3P7gP.defaultVenue)(sport) : $3b0b809915ecf80f$var$frozenCopy(requestedVenue);
    if (venue === undefined) return unsupported("the venue must be plain data");
    const { RPM: rpmLimits } = $faJc0.tableLimitsMap[model][sport];
    const adjust = $gV6Yw.tableSpinAdjustMap[model][sport];
    const v1Geometry = $bRtcj.tableTrainerGeometryMap[model];
    const constants = $2Yg5G.DefaultPhysicalConstants;
    const problems = [
        ...$3b0b809915ecf80f$var$rpmProblems(mphByRpm, rpmLimits),
        ...$3b0b809915ecf80f$var$geometryProblems(v1Geometry),
        ...$3b0b809915ecf80f$var$ballProblems(ball),
        ...$3b0b809915ecf80f$var$environmentProblems(constants),
        ...(0, $3P7gP.venueProblems)(venue, sport)
    ];
    if (problems.length > 0) return unsupported(problems.join("; "));
    const mechanism = {
        mphByRpm: mphByRpm.slice(rpmLimits.minSafe, rpmLimits.maxSafe + 1),
        minRpm: rpmLimits.minSafe,
        maxRpm: rpmLimits.maxSafe,
        maxSpinRpm: rpmLimits.maxSpin,
        speedDamping: adjust.speedDampingFactor,
        spinDamping: adjust.spinDampingFactor,
        deflection: adjust.deflectionCorrection
    };
    return {
        ok: true,
        profile: {
            trainer: {
                model: model,
                geometry: $3b0b809915ecf80f$var$trainerGeometry(v1Geometry),
                mechanism: (0, $bCDPq.threeWheelMechanism)(mechanism)
            },
            ball: ball,
            venue: venue,
            environment: $3b0b809915ecf80f$var$environmentFor(constants)
        }
    };
}
/**
 * A venue the profile can hold: the caller's own if it is already deeply
 * frozen (as every built-in venue is), otherwise a frozen copy, so the
 * caller's object is never frozen or kept. Undefined if it is not plain data.
 */ function $3b0b809915ecf80f$var$frozenCopy(venue) {
    if ((0, $90lsY.isDeepFrozen)(venue)) return venue;
    try {
        return (0, $90lsY.deepFreeze)((0, $90lsY.clonePlainData)(venue));
    } catch  {
        return undefined;
    }
}
// ---------------------------------------------------------------------------
// Building
const $3b0b809915ecf80f$var$copy = ({ x: x, y: y, z: z })=>({
        x: x,
        y: y,
        z: z
    });
function $3b0b809915ecf80f$var$trainerGeometry(geometry) {
    return {
        liftPivot: $3b0b809915ecf80f$var$copy(geometry.liftPivotPosition),
        liftArmLength: geometry.liftArmLength,
        launchOriginOffset: $3b0b809915ecf80f$var$copy(geometry.launchOriginOffset),
        launchRadius: geometry.launchDistanceFromRotationCenter,
        cameraOffsetFromHead: $3b0b809915ecf80f$var$copy(geometry.cameraOffsetFromHead),
        cameraDownwardPitch: geometry.cameraDownwardPitch
    };
}
function $3b0b809915ecf80f$var$environmentFor(constants) {
    return {
        gravity: constants.gravity,
        airDensity: constants.airDensity
    };
}
// ---------------------------------------------------------------------------
// Validation: each returns what is wrong, empty when nothing is.
const $3b0b809915ecf80f$var$isFiniteVec = (v)=>[
        v.x,
        v.y,
        v.z
    ].every(Number.isFinite);
const $3b0b809915ecf80f$var$isPositive = (n)=>Number.isFinite(n) && n > 0;
const $3b0b809915ecf80f$var$failing = (checks)=>checks.filter(([ok])=>!ok).map(([, problem])=>problem);
function $3b0b809915ecf80f$var$rpmProblems(mphByRpm, limits) {
    const { minSafe: minSafe, maxSafe: maxSafe, maxSpin: maxSpin } = limits;
    const bandProblems = $3b0b809915ecf80f$var$failing([
        [
            Number.isInteger(minSafe) && minSafe >= 0,
            `safe minimum RPM ${minSafe} must be a whole number >= 0`
        ],
        [
            Number.isInteger(maxSafe) && maxSafe > minSafe,
            `safe maximum RPM ${maxSafe} must be a whole number above the minimum`
        ],
        [
            maxSafe < mphByRpm.length,
            `RPM-to-speed data ends at ${mphByRpm.length - 1} RPM, below the safe maximum ${maxSafe}`
        ],
        [
            $3b0b809915ecf80f$var$isPositive(maxSpin),
            `maximum spin RPM ${maxSpin} must be positive`
        ]
    ]);
    if (bandProblems.length > 0) return bandProblems;
    const band = mphByRpm.slice(minSafe, maxSafe + 1);
    const increasing = band.every((mph, i)=>Number.isFinite(mph) && mph >= 0 && (i === 0 || mph > band[i - 1]));
    return $3b0b809915ecf80f$var$failing([
        [
            increasing,
            `speeds over the safe band ${minSafe}-${maxSafe} RPM must be finite and strictly increasing`
        ]
    ]);
}
function $3b0b809915ecf80f$var$geometryProblems(geometry) {
    return $3b0b809915ecf80f$var$failing([
        [
            $3b0b809915ecf80f$var$isFiniteVec(geometry.liftPivotPosition),
            "lift pivot must be finite"
        ],
        [
            $3b0b809915ecf80f$var$isPositive(geometry.liftArmLength),
            `lift arm length ${geometry.liftArmLength} must be positive`
        ],
        [
            $3b0b809915ecf80f$var$isFiniteVec(geometry.launchOriginOffset),
            "launch origin offset must be finite"
        ],
        [
            $3b0b809915ecf80f$var$isPositive(geometry.launchDistanceFromRotationCenter),
            `launch radius ${geometry.launchDistanceFromRotationCenter} must be positive`
        ],
        [
            $3b0b809915ecf80f$var$isFiniteVec(geometry.cameraOffsetFromHead),
            "camera offset must be finite"
        ],
        [
            Number.isFinite(geometry.cameraDownwardPitch),
            "camera pitch must be finite"
        ],
        // v1 measures head height from liftOrigin but places the head from
        // liftPivotPosition; the engine keeps only the pivot, so they must agree.
        [
            geometry.liftOrigin.z === geometry.liftPivotPosition.z,
            `lift origin height ${geometry.liftOrigin.z} must equal the pivot height ${geometry.liftPivotPosition.z}`
        ],
        // Likewise v1 converts launch heights with defaultLaunchPointOffset,
        // which the engine derives from launchOriginOffset.
        [
            geometry.defaultLaunchPointOffset.z === geometry.launchOriginOffset.z,
            `default launch point height ${geometry.defaultLaunchPointOffset.z} must equal the launch origin height ${geometry.launchOriginOffset.z}`
        ]
    ]);
}
function $3b0b809915ecf80f$var$ballProblems(ball) {
    return $3b0b809915ecf80f$var$failing([
        [
            $3b0b809915ecf80f$var$isPositive(ball.diameter),
            `ball diameter ${ball.diameter} must be positive`
        ],
        [
            $3b0b809915ecf80f$var$isPositive(ball.mass),
            `ball mass ${ball.mass} must be positive`
        ],
        [
            Number.isFinite(ball.dragCoefficient) && ball.dragCoefficient >= 0,
            `ball drag coefficient ${ball.dragCoefficient} must be >= 0`
        ]
    ]);
}
function $3b0b809915ecf80f$var$environmentProblems(constants) {
    return $3b0b809915ecf80f$var$failing([
        [
            $3b0b809915ecf80f$var$isPositive(constants.gravity),
            `gravity ${constants.gravity} must be positive`
        ],
        [
            Number.isFinite(constants.airDensity) && constants.airDensity >= 0,
            `air density ${constants.airDensity} must be >= 0`
        ]
    ]);
}

});
parcelRegister("2oLTm", function(module, exports) {
"use strict";
/* eslint-disable import/prefer-default-export */ /* eslint-disable quote-props */ /* eslint-disable max-len */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tableRPM2MPHMap = void 0;
const $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_30A = {
    PLATFORM_TENNIS: [],
    TENNIS: [],
    PADEL: [],
    PICKLEBALL: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.007506436237329828,
        0.020371825003267174,
        0.03323721376920441,
        0.046102602535141646,
        0.05896799130107888,
        0.07183338006701612,
        0.08469876883295335,
        0.09756415759889059,
        0.11042954636482782,
        0.12329493513076506,
        0.1361603238967023,
        0.14902571266263953,
        0.16189110142857677,
        0.174756490194514,
        0.18762187896045124,
        0.20048726772638847,
        0.2133526564923257,
        0.22621804525826295,
        0.23908343402420018,
        0.2519488227901374,
        0.26481421155607465,
        0.2776796003220119,
        0.2905449890879491,
        0.30341037785388636,
        0.3162757666198236,
        0.32914115538576083,
        0.34200654415169807,
        0.3548719329176353,
        0.36773732168357254,
        0.3806027104495098,
        0.393468099215447,
        0.40633348798138424,
        0.4191988767473216,
        0.4320642655132587,
        0.44492965427919606,
        0.4577950430451332,
        0.47066043181107053,
        0.48352582057700766,
        0.496391209342945,
        0.5092565981088821,
        0.5221219868748195,
        0.5349873756407566,
        0.547852764406694,
        0.5607181531726311,
        0.5735835419385684,
        0.5864489307045055,
        0.5993143194704429,
        0.61217970823638,
        0.6250450970023174,
        0.6379104857682547,
        0.6507758745341918,
        0.6636412633001292,
        0.6765066520660663,
        0.6893720408320037,
        0.7022374295979408,
        0.7151028183638781,
        0.7279682071298152,
        0.7408335958957526,
        0.7536989846616897,
        0.7665643734276271,
        0.7794297621935642,
        0.7922951509595015,
        0.8051605397254387,
        0.818025928491376,
        0.8308913172573131,
        0.8437567060232505,
        0.8566220947891876,
        0.869487483555125,
        0.8823528723210621,
        0.8952182610869994,
        0.9080836498529365,
        0.9209490386188739,
        0.933814427384811,
        0.9466798161507484,
        0.9595452049166855,
        0.9724105936826228,
        0.98527598244856,
        0.9981413712144973,
        1.0110067599804344,
        1.0238721487463718,
        1.036737537512309,
        1.0496029262782463,
        1.0624683150441836,
        1.0753337038101207,
        1.088199092576058,
        1.1010644813419952,
        1.1139298701079325,
        1.1267952588738697,
        1.139660647639807,
        1.1525260364057441,
        1.1653914251716815,
        1.1782568139376186,
        1.191122202703556,
        1.203987591469493,
        1.2168529802354304,
        1.2297183690013676,
        1.242583757767305,
        1.255449146533242,
        1.2683145352991794,
        1.2811799240651165,
        1.2940453128310538,
        1.306910701596991,
        1.3197760903629283,
        1.3326414791288654,
        1.3455068678948028,
        1.35837225666074,
        1.3712376454266773,
        1.3841030341926144,
        1.3969684229585517,
        1.4098338117244889,
        1.4226992004904262,
        1.4355645892563635,
        1.4484299780223004,
        1.4612953667882378,
        1.4741607555541751,
        1.4870261443201125,
        1.4998915330860498,
        1.5127569218519867,
        1.525622310617924,
        1.5384876993838614,
        1.5513530881497988,
        1.5642184769157357,
        1.577083865681673,
        1.5899492544476104,
        1.6028146432135477,
        1.6156800319794846,
        1.628545420745422,
        1.6414108095113593,
        1.6542761982772967,
        1.6671415870432336,
        1.680006975809171,
        1.6928723645751083,
        1.7057377533410456,
        1.7186031421069825,
        1.7314685308729199,
        1.7443339196388572,
        1.7571993084047945,
        1.7700646971707314,
        1.7829300859366688,
        1.7957954747026061,
        1.8086608634685435,
        1.8215262522344804,
        1.8343916410004177,
        1.847257029766355,
        1.8601224185322924,
        1.8729878072982298,
        1.8858531960641667,
        1.898718584830104,
        1.9115839735960414,
        1.9244493623619787,
        1.9373147511279156,
        1.950180139893853,
        1.9630455286597903,
        1.9759109174257277,
        1.9887763061916646,
        2.001641694957602,
        2.0145070837235393,
        2.0273724724894766,
        2.0402378612554135,
        2.053103250021351,
        2.065968638787288,
        2.0788340275532255,
        2.0916994163191625,
        2.1045648050851,
        2.117430193851037,
        2.1302955826169745,
        2.1431609713829114,
        2.1560263601488487,
        2.168891748914786,
        2.1817571376807234,
        2.1946225264466603,
        2.2074879152125977,
        2.220353303978535,
        2.2332186927444724,
        2.2460840815104093,
        2.2589494702763466,
        2.271814859042284,
        2.2846802478082213,
        2.2975456365741587,
        2.3104110253400956,
        2.323276414106033,
        2.3361418028719703,
        2.3490071916379076,
        2.3618725804038445,
        2.374737969169782,
        2.387603357935719,
        2.4004687467016566,
        2.4133341354675935,
        2.426199524233531,
        2.439064912999468,
        2.4519303017654055,
        2.4647956905313424,
        2.4776610792972797,
        2.490526468063217,
        2.5033918568291544,
        2.5162572455950913,
        2.5291226343610287,
        2.541988023126966,
        2.5548534118929034,
        2.5677188006588403,
        2.5805841894247776,
        2.593449578190715,
        2.6063149669566523,
        2.6191803557225892,
        2.6320457444885266,
        2.644911133254464,
        2.6577765220204013,
        2.670641910786338,
        2.6835072995522755,
        2.696372688318213,
        2.70923807708415,
        2.7221034658500876,
        2.7349688546160245,
        2.747834243381962,
        2.760699632147899,
        2.7735650209138365,
        2.7864304096797734,
        2.7992957984457107,
        2.812161187211648,
        2.8250265759775854,
        2.8378919647435223,
        2.8507573535094597,
        2.863622742275397,
        2.8764881310413344,
        2.8893535198072713,
        2.9022189085732086,
        2.915084297339146,
        2.9279496861050833,
        2.9408150748710202,
        2.9536804636369576,
        2.966545852402895,
        2.9794112411688323,
        2.992276629934769,
        3.0051420187007065,
        3.018007407466644,
        3.030872796232581,
        3.043738184998518,
        3.0566035737644555,
        3.069468962530393,
        3.08233435129633,
        3.095199740062267,
        3.1080651288282044,
        3.1209305175941418,
        3.133795906360079,
        3.1466612951260164,
        3.1595266838919533,
        3.1723920726578907,
        3.185257461423828,
        3.1981228501897654,
        3.2109882389557023,
        3.2238536277216396,
        3.236719016487577,
        3.2495844052535143,
        3.2624497940194512,
        3.2753151827853886,
        3.288180571551326,
        3.3010459603172633,
        3.3139113490832,
        3.3267767378491375,
        3.339642126615075,
        3.352507515381012,
        3.365372904146949,
        3.3782382929128865,
        3.391103681678824,
        3.4039690704447607,
        3.416834459210698,
        3.4296998479766354,
        3.4425652367425728,
        3.45543062550851,
        3.4682960142744474,
        3.481161403040385,
        3.4940267918063213,
        3.5068921805722586,
        3.519757569338196,
        3.5326229581041333,
        3.5454883468700706,
        3.558353735636008,
        3.5712191244019453,
        3.5840845131678827,
        3.59694990193382,
        3.6098152906997565,
        3.622680679465694,
        3.635546068231631,
        3.6484114569975685,
        3.661276845763506,
        3.674142234529443,
        3.6870076232953806,
        3.699873012061318,
        3.7127384008272544,
        3.7256037895931917,
        3.738469178359129,
        3.7513345671250664,
        3.7641999558910038,
        3.777065344656941,
        3.7899307334228785,
        3.802796122188816,
        3.8156615109547523,
        3.8285268997206896,
        3.841392288486627,
        3.8542576772525643,
        3.8671230660185016,
        3.879988454784439,
        3.8928538435503763,
        3.9057192323163137,
        3.91858462108225,
        3.9314500098481875,
        3.944315398614125,
        3.957180787380062,
        3.9700461761459995,
        3.982911564911937,
        3.995776953677874,
        4.008642342443812,
        4.0215077312097485,
        4.034373119975685,
        4.047238508741623,
        4.06010389750756,
        4.072969286273498,
        4.085834675039434,
        4.0987000638053726,
        4.111565452571309,
        4.124430841337247,
        4.137296230103184,
        4.15016161886912,
        4.163027007635058,
        4.175892396400995,
        4.188757785166933,
        4.2016231739328695,
        4.214488562698808,
        4.227353951464744,
        4.240219340230681,
        4.253084728996619,
        4.265950117762555,
        4.278815506528494,
        4.29168089529443,
        4.304546284060368,
        4.317411672826305,
        4.330277061592243,
        4.3431424503581795,
        4.356007839124116,
        4.368873227890054,
        4.381738616655991,
        4.394604005421929,
        4.407469394187865,
        4.4203347829538036,
        4.43320017171974,
        4.446065560485678,
        4.458930949251615,
        4.471796338017551,
        4.484661726783489,
        4.497527115549426,
        4.510392504315364,
        4.5232578930813006,
        4.536123281847239,
        4.548988670613175,
        4.561854059379112,
        4.57471944814505,
        4.587584836910986,
        4.600450225676925,
        4.613315614442861,
        4.626181003208799,
        4.639046391974736,
        4.651911780740674,
        4.6647771695066105,
        4.677642558272547,
        4.690507947038485,
        4.703373335804422,
        4.71623872457036,
        4.729104113336296,
        4.741969502102235,
        4.754834890868171,
        4.767700279634109,
        4.780565668400046,
        4.793431057165982,
        4.80629644593192,
        4.819161834697857,
        4.832027223463795,
        4.8448926122297316,
        4.85775800099567,
        4.870623389761606,
        4.883488778527543,
        4.896354167293481,
        4.909219556059417,
        4.922084944825356,
        4.934950333591292,
        4.94781572235723,
        4.960681111123167,
        4.973546499889105,
        4.9864118886550415,
        4.999277277420978,
        5.012142666186916,
        5.025008054952853,
        5.037873443718791,
        5.050738832484727,
        5.063604221250666,
        5.076469610016602,
        5.0893349987825385,
        5.102200387548477,
        5.115065776314413,
        5.127931165080351,
        5.140796553846288,
        5.153661942612226,
        5.166527331378163,
        5.179392720144101,
        5.192258108910037,
        5.205123497675974,
        5.217988886441912,
        5.230854275207848,
        5.243719663973787,
        5.256585052739723,
        5.269450441505661,
        5.282315830271598,
        5.295181219037536,
        5.3080466078034725,
        5.320911996569409,
        5.333777385335347,
        5.346642774101284,
        5.359508162867222,
        5.372373551633158,
        5.385238940399097,
        5.398104329165033,
        5.4109697179309695,
        5.423835106696908,
        5.436700495462844,
        5.449565884228782,
        5.462431272994719,
        5.475296661760657,
        5.488162050526594,
        5.501027439292532,
        5.513892828058468,
        5.526758216824405,
        5.539623605590343,
        5.552488994356279,
        5.565354383122218,
        5.578219771888154,
        5.591085160654092,
        5.603950549420029,
        5.616815938185967,
        5.6296813269519035,
        5.64254671571784,
        5.655412104483778,
        5.668277493249715,
        5.681142882015653,
        5.694008270781589,
        5.706873659547528,
        5.719739048313464,
        5.7326044370794005,
        5.745469825845339,
        5.758335214611275,
        5.771200603377213,
        5.78406599214315,
        5.796931380909088,
        5.809796769675025,
        5.822662158440963,
        5.835527547206899,
        5.848392935972836,
        5.861258324738774,
        5.87412371350471,
        5.886989102270649,
        5.899854491036585,
        5.912719879802523,
        5.92558526856846,
        5.938450657334396,
        5.9513160461003345,
        5.964181434866271,
        5.977046823632209,
        5.989912212398146,
        6.002777601164084,
        6.01564298993002,
        6.028508378695959,
        6.041373767461895,
        6.0542391562278315,
        6.06710454499377,
        6.079969933759706,
        6.092835322525644,
        6.105700711291581,
        6.118566100057519,
        6.131431488823456,
        6.144296877589394,
        6.15716226635533,
        6.170027655121267,
        6.182893043887205,
        6.195758432653141,
        6.20862382141908,
        6.221489210185016,
        6.234354598950954,
        6.247219987716891,
        6.260085376482827,
        6.2729507652487655,
        6.285816154014702,
        6.29868154278064,
        6.311546931546577,
        6.324412320312515,
        6.337277709078451,
        6.35014309784439,
        6.363008486610326,
        6.3758738753762625,
        6.388739264142201,
        6.401604652908137,
        6.414470041674075,
        6.427335430440012,
        6.44020081920595,
        6.453066207971887,
        6.465931596737825,
        6.478796985503761,
        6.491662374269698,
        6.504527763035636,
        6.517393151801572,
        6.530258540567511,
        6.543123929333447,
        6.555989318099385,
        6.568854706865322,
        6.581720095631258,
        6.5945854843971965,
        6.607450873163133,
        6.620316261929071,
        6.633181650695008,
        6.646047039460946,
        6.658912428226882,
        6.671777816992821,
        6.684643205758757,
        6.6975085945246935,
        6.710373983290632,
        6.723239372056568,
        6.736104760822506,
        6.748970149588443,
        6.761835538354381,
        6.774700927120318,
        6.787566315886254,
        6.800431704652192,
        6.813297093418129,
        6.826162482184067,
        6.839027870950003,
        6.851893259715942,
        6.864758648481878,
        6.877624037247816,
        6.890489426013753,
        6.903354814779689,
        6.9162202035456275,
        6.929085592311564,
        6.941950981077502,
        6.954816369843439,
        6.967681758609377,
        6.980547147375313,
        6.993412536141252,
        7.006277924907188,
        7.0191433136731245,
        7.032008702439063,
        7.044874091204999,
        7.057739479970937,
        7.070604868736874,
        7.083470257502812,
        7.096335646268749,
        7.109201035034685,
        7.122066423800623,
        7.13493181256656,
        7.147797201332498,
        7.160662590098434,
        7.173527978864373,
        7.186393367630309,
        7.199258756396247,
        7.212124145162184,
        7.22498953392812,
        7.2378549226940585,
        7.250720311459995,
        7.263585700225933,
        7.27645108899187,
        7.289316477757808,
        7.302181866523744,
        7.315047255289683,
        7.327912644055619,
        7.3407780328215555,
        7.353643421587494,
        7.36650881035343,
        7.379374199119368,
        7.392239587885305,
        7.405104976651241,
        7.41797036541718,
        7.430835754183116,
        7.443701142949054,
        7.456566531714991,
        7.469431920480929,
        7.482297309246865,
        7.495162698012802,
        7.50802808677874,
        7.520893475544677,
        7.533758864310615,
        7.546624253076551,
        7.5594896418424895,
        7.572355030608426,
        7.585220419374362,
        7.598085808140301,
        7.610951196906237,
        7.623816585672175,
        7.636681974438112,
        7.64954736320405,
        7.6624127519699865,
        7.675278140735925,
        7.688143529501861,
        7.701008918267798,
        7.713874307033736,
        7.726739695799672,
        7.739605084565611,
        7.752470473331547,
        7.765335862097485,
        7.778201250863422,
        7.79106663962936,
        7.803932028395296,
        7.816797417161233,
        7.829662805927171,
        7.842528194693108,
        7.855393583459046,
        7.868258972224982,
        7.8811243609909205,
        7.893989749756857,
        7.906855138522793,
        7.919720527288732,
        7.932585916054668,
        7.945451304820606,
        7.958316693586543,
        7.971182082352481,
        7.9840474711184175,
        7.996912859884356,
        8.009778248650292,
        8.022643637416229,
        8.035509026182167,
        8.048374414948103,
        8.061239803714042,
        8.074105192479978,
        8.086970581245916,
        8.099835970011853,
        8.112701358777791,
        8.125566747543727,
        8.138432136309664,
        8.151297525075602,
        8.164162913841539,
        8.177028302607477,
        8.189893691373413,
        8.202759080139352,
        8.215624468905288,
        8.228489857671224,
        8.241355246437163,
        8.2542206352031,
        8.267086023969037,
        8.279951412734974,
        8.292816801500912,
        8.305682190266849,
        8.318547579032787,
        8.331412967798723,
        8.34427835656466,
        8.357143745330598,
        8.370009134096534,
        8.382874522862473,
        8.395739911628409,
        8.408605300394347,
        8.421470689160284,
        8.43433607792622,
        8.447201466692158,
        8.460066855458095,
        8.472932244224033,
        8.48579763298997,
        8.498663021755908,
        8.511528410521844,
        8.524393799287783,
        8.537259188053719,
        8.550124576819655,
        8.562989965585594,
        8.57585535435153,
        8.588720743117468,
        8.601586131883405,
        8.614451520649343,
        8.62731690941528,
        8.640182298181218,
        8.653047686947154,
        8.66591307571309,
        8.678778464479029,
        8.691643853244965,
        8.704509242010904,
        8.71737463077684,
        8.730240019542778,
        8.743105408308715,
        8.755970797074651,
        8.76883618584059,
        8.781701574606526,
        8.794566963372464,
        8.8074323521384,
        8.820297740904339,
        8.833163129670275,
        8.846028518436214,
        8.85889390720215,
        8.871759295968086,
        8.884624684734025,
        8.897490073499961,
        8.9103554622659,
        8.923220851031836,
        8.936086239797774,
        8.94895162856371,
        8.961817017329649,
        8.974682406095585,
        8.987547794861522,
        9.00041318362746,
        9.013278572393396,
        9.026143961159335,
        9.039009349925271,
        9.05187473869121,
        9.064740127457146,
        9.077605516223082,
        9.09047090498902,
        9.103336293754957,
        9.116201682520895,
        9.129067071286832,
        9.14193246005277,
        9.154797848818706,
        9.167663237584645,
        9.180528626350581,
        9.193394015116517,
        9.206259403882456,
        9.219124792648392,
        9.23199018141433,
        9.244855570180267,
        9.257720958946205,
        9.270586347712142,
        9.28345173647808,
        9.296317125244016,
        9.309182514009953,
        9.322047902775891,
        9.334913291541827,
        9.347778680307766,
        9.360644069073702,
        9.37350945783964,
        9.386374846605577,
        9.399240235371513,
        9.412105624137451,
        9.424971012903388,
        9.437836401669326,
        9.450701790435263,
        9.4635671792012,
        9.476432567967137,
        9.489297956733076,
        9.502163345499012,
        9.515028734264948,
        9.527894123030887,
        9.540759511796823,
        9.553624900562761,
        9.566490289328698,
        9.579355678094636,
        9.592221066860573,
        9.605086455626509,
        9.617951844392447,
        9.630817233158384,
        9.643682621924322,
        9.656548010690258,
        9.669413399456197,
        9.682278788222133,
        9.695144176988071,
        9.708009565754008,
        9.720874954519944,
        9.733740343285882,
        9.746605732051819,
        9.759471120817757,
        9.772336509583694,
        9.785201898349632,
        9.798067287115568,
        9.810932675881507,
        9.823798064647443,
        9.83666345341338,
        9.849528842179318,
        9.862394230945254,
        9.875259619711192,
        9.888125008477129,
        9.900990397243067,
        9.913855786009004,
        9.92672117477494,
        9.939586563540878,
        9.952451952306815,
        9.965317341072753,
        9.97818272983869,
        9.991048118604628,
        10.003913507370564,
        10.016778896136502,
        10.029644284902439,
        10.042509673668375,
        10.055375062434313,
        10.06824045120025,
        10.081105839966188,
        10.093971228732125,
        10.106836617498063,
        10.119702006264,
        10.132567395029938,
        10.145432783795874,
        10.15829817256181,
        10.171163561327749,
        10.184028950093685,
        10.196894338859623,
        10.20975972762556,
        10.222625116391498,
        10.235490505157435,
        10.248355893923371,
        10.26122128268931,
        10.274086671455246,
        10.286952060221184,
        10.29981744898712,
        10.312682837753059,
        10.325548226518995,
        10.338413615284933,
        10.35127900405087,
        10.364144392816806,
        10.377009781582744,
        10.389875170348681,
        10.40274055911462,
        10.415605947880556,
        10.428471336646494,
        10.44133672541243,
        10.454202114178367,
        10.467067502944305,
        10.479932891710241,
        10.49279828047618,
        10.505663669242116,
        10.518529058008054,
        10.53139444677399,
        10.544259835539929,
        10.557125224305866,
        10.569990613071802,
        10.58285600183774,
        10.595721390603677,
        10.608586779369615,
        10.621452168135551,
        10.63431755690149,
        10.647182945667426,
        10.660048334433364,
        10.6729137231993,
        10.685779111965237,
        10.698644500731175,
        10.711509889497112,
        10.72437527826305,
        10.737240667028987,
        10.750106055794925,
        10.762971444560861,
        10.775836833326798,
        10.788702222092736,
        10.801567610858672,
        10.81443299962461,
        10.827298388390547,
        10.840163777156485,
        10.853029165922422,
        10.86589455468836,
        10.878759943454297,
        10.891625332220233,
        10.904490720986171,
        10.917356109752108,
        10.930221498518046,
        10.943086887283982,
        10.95595227604992,
        10.968817664815857,
        10.981683053581795,
        10.994548442347732,
        11.007413831113668,
        11.020279219879606,
        11.033144608645543,
        11.046009997411481,
        11.058875386177418,
        11.071740774943356,
        11.084606163709292,
        11.097471552475229,
        11.110336941241167,
        11.123202330007103,
        11.136067718773042,
        11.148933107538978,
        11.161798496304916,
        11.174663885070853,
        11.187529273836791,
        11.200394662602728,
        11.213260051368664,
        11.226125440134602,
        11.238990828900539,
        11.251856217666477,
        11.264721606432413,
        11.277586995198352,
        11.290452383964288,
        11.303317772730225,
        11.316183161496163,
        11.3290485502621,
        11.341913939028037,
        11.354779327793974,
        11.367644716559912,
        11.380510105325849,
        11.393375494091787,
        11.406240882857723,
        11.41910627162366,
        11.431971660389598,
        11.444837049155534,
        11.457702437921473,
        11.47056782668741,
        11.483433215453347,
        11.496298604219284,
        11.509163992985222,
        11.522029381751159,
        11.534894770517095,
        11.547760159283033,
        11.56062554804897,
        11.573490936814908,
        11.586356325580844,
        11.599221714346783,
        11.612087103112719,
        11.624952491878656,
        11.637817880644594,
        11.65068326941053,
        11.663548658176468,
        11.676414046942405,
        11.689279435708343,
        11.70214482447428,
        11.715010213240218,
        11.727875602006154,
        11.74074099077209,
        11.753606379538029,
        11.766471768303965,
        11.779337157069904,
        11.79220254583584,
        11.805067934601778,
        11.817933323367715,
        11.830798712133653,
        11.84366410089959,
        11.856529489665526,
        11.869394878431464,
        11.8822602671974,
        11.895125655963339,
        11.907991044729275,
        11.920856433495214,
        11.93372182226115,
        11.946587211027087,
        11.959452599793025,
        11.972317988558961,
        11.9851833773249,
        11.998048766090836,
        12.010914154856774,
        12.02377954362271,
        12.036644932388649,
        12.049510321154585,
        12.062375709920522,
        12.07524109868646,
        12.088106487452396,
        12.100971876218335,
        12.113837264984271,
        12.12670265375021,
        12.139568042516146,
        12.152433431282082,
        12.16529882004802,
        12.178164208813957,
        12.191029597579895,
        12.203894986345832,
        12.21676037511177,
        12.229625763877706,
        12.242491152643645,
        12.255356541409581,
        12.268221930175518,
        12.281087318941456,
        12.293952707707392,
        12.30681809647333,
        12.319683485239267,
        12.332548874005205,
        12.345414262771142,
        12.35827965153708,
        12.371145040303016,
        12.384010429068953,
        12.396875817834891,
        12.409741206600827,
        12.422606595366766,
        12.435471984132702,
        12.44833737289864,
        12.461202761664577,
        12.474068150430513,
        12.486933539196452,
        12.499798927962388,
        12.512664316728326,
        12.525529705494263,
        12.538395094260201,
        12.551260483026137,
        12.564125871792076,
        12.576991260558012,
        12.589856649323949,
        12.602722038089887,
        12.615587426855823,
        12.628452815621761,
        12.641318204387698,
        12.654183593153636,
        12.667048981919573,
        12.67991437068551,
        12.692779759451447,
        12.705645148217384,
        12.718510536983322,
        12.731375925749258,
        12.744241314515197,
        12.757106703281133,
        12.769972092047071,
        12.782837480813008,
        12.795702869578944,
        12.808568258344883,
        12.821433647110819,
        12.834299035876757,
        12.847164424642694,
        12.860029813408632,
        12.872895202174568,
        12.885760590940507,
        12.898625979706443,
        12.91149136847238,
        12.924356757238318,
        12.937222146004254,
        12.950087534770192,
        12.962952923536129,
        12.975818312302067,
        12.988683701068004,
        13.001549089833942,
        13.014414478599878,
        13.027279867365815,
        13.040145256131753,
        13.05301064489769,
        13.065876033663628,
        13.078741422429564,
        13.091606811195502,
        13.104472199961439,
        13.117337588727375,
        13.130202977493314,
        13.14306836625925,
        13.155933755025188,
        13.168799143791125,
        13.181664532557063,
        13.194529921323,
        13.207395310088938,
        13.220260698854874,
        13.23312608762081,
        13.245991476386749,
        13.258856865152685,
        13.271722253918623,
        13.28458764268456,
        13.297453031450498,
        13.310318420216435,
        13.323183808982371,
        13.33604919774831,
        13.348914586514246,
        13.361779975280184,
        13.37464536404612,
        13.387510752812059,
        13.400376141577995,
        13.413241530343933,
        13.42610691910987,
        13.438972307875806,
        13.451837696641745,
        13.464703085407681,
        13.47756847417362,
        13.490433862939556,
        13.503299251705494,
        13.51616464047143,
        13.529030029237369,
        13.541895418003305,
        13.554760806769242,
        13.56762619553518,
        13.580491584301116,
        13.593356973067054,
        13.606222361832991,
        13.61908775059893,
        13.631953139364866,
        13.644818528130802,
        13.65768391689674,
        13.670549305662677,
        13.683414694428615,
        13.696280083194551,
        13.70914547196049,
        13.722010860726426,
        13.734876249492364,
        13.7477416382583,
        13.760607027024237,
        13.773472415790176,
        13.786337804556112,
        13.79920319332205,
        13.812068582087987,
        13.824933970853925,
        13.837799359619861,
        13.8506647483858,
        13.863530137151736,
        13.876395525917673,
        13.88926091468361,
        13.902126303449547,
        13.914991692215485,
        13.927857080981422,
        13.94072246974736,
        13.953587858513297,
        13.966453247279233,
        13.979318636045171,
        13.992184024811108,
        14.005049413577046,
        14.017914802342982,
        14.03078019110892,
        14.043645579874857,
        14.056510968640795,
        14.069376357406732,
        14.082241746172668,
        14.095107134938607,
        14.107972523704543,
        14.120837912470481,
        14.133703301236418,
        14.146568690002356,
        14.159434078768292,
        14.172299467534229,
        14.185164856300167,
        14.198030245066104,
        14.210895633832042,
        14.223761022597978,
        14.236626411363916,
        14.249491800129853,
        14.262357188895791,
        14.275222577661728,
        14.288087966427664,
        14.300953355193602,
        14.313818743959539,
        14.326684132725477,
        14.339549521491413,
        14.352414910257352,
        14.365280299023288,
        14.378145687789226,
        14.391011076555163,
        14.4038764653211,
        14.416741854087038,
        14.429607242852974,
        14.442472631618912,
        14.455338020384849,
        14.468203409150787,
        14.481068797916723,
        14.49393418668266,
        14.506799575448598,
        14.519664964214535,
        14.532530352980473,
        14.54539574174641,
        14.558261130512347,
        14.571126519278284,
        14.583991908044222,
        14.596857296810159,
        14.609722685576095,
        14.622588074342033,
        14.63545346310797,
        14.648318851873908,
        14.661184240639844,
        14.674049629405783,
        14.68691501817172,
        14.699780406937657,
        14.712645795703594,
        14.72551118446953,
        14.738376573235469,
        14.751241962001405,
        14.764107350767343,
        14.77697273953328,
        14.789838128299218,
        14.802703517065154,
        14.81556890583109,
        14.828434294597029,
        14.841299683362966,
        14.854165072128904,
        14.86703046089484,
        14.879895849660778,
        14.892761238426715,
        14.905626627192653,
        14.91849201595859,
        14.931357404724526,
        14.944222793490464,
        14.9570881822564,
        14.969953571022339,
        14.982818959788275,
        14.995684348554214,
        15.00854973732015,
        15.021415126086087,
        15.034280514852025,
        15.047145903617961,
        15.0600112923839,
        15.072876681149836,
        15.085742069915774,
        15.09860745868171,
        15.111472847447649,
        15.124338236213585,
        15.137203624979522,
        15.15006901374546,
        15.162934402511397,
        15.175799791277335,
        15.188665180043271,
        15.20153056880921,
        15.214395957575146,
        15.227261346341084,
        15.24012673510702,
        15.252992123872957,
        15.265857512638895,
        15.278722901404832,
        15.29158829017077,
        15.304453678936706,
        15.317319067702645,
        15.330184456468581,
        15.343049845234518,
        15.355915234000456,
        15.368780622766392,
        15.38164601153233,
        15.394511400298267,
        15.407376789064203,
        15.420242177830142,
        15.43310756659608,
        15.445972955362015,
        15.458838344127953,
        15.471703732893891,
        15.48456912165983,
        15.497434510425764,
        15.510299899191702,
        15.52316528795764,
        15.536030676723579,
        15.548896065489513,
        15.561761454255452,
        15.57462684302139,
        15.587492231787325,
        15.600357620553263,
        15.613223009319201,
        15.62608839808514,
        15.638953786851074,
        15.651819175617012,
        15.66468456438295,
        15.677549953148885,
        15.690415341914823,
        15.703280730680762,
        15.7161461194467,
        15.729011508212634,
        15.741876896978573,
        15.754742285744511,
        15.767607674510446,
        15.780473063276384,
        15.793338452042322,
        15.80620384080826,
        15.819069229574195,
        15.831934618340133,
        15.844800007106072,
        15.85766539587201,
        15.870530784637944,
        15.883396173403883,
        15.896261562169821,
        15.909126950935756,
        15.921992339701694,
        15.934857728467632,
        15.94772311723357,
        15.960588505999505,
        15.973453894765443,
        15.986319283531381,
        15.999184672297316,
        16.012050061063256,
        16.024915449829194,
        16.037780838595133,
        16.050646227361067,
        16.063511616127006,
        16.076377004892944,
        16.08924239365888,
        16.102107782424817,
        16.114973171190755,
        16.127838559956693,
        16.140703948722628,
        16.153569337488566,
        16.166434726254504,
        16.179300115020443,
        16.192165503786377,
        16.205030892552315,
        16.217896281318254,
        16.23076167008419,
        16.243627058850127,
        16.256492447616065,
        16.269357836382003,
        16.282223225147938,
        16.295088613913876,
        16.307954002679814,
        16.32081939144575,
        16.333684780211687,
        16.346550168977625,
        16.359415557743564,
        16.3722809465095,
        16.385146335275437,
        16.398011724041375,
        16.41087711280731,
        16.423742501573248,
        16.436607890339186,
        16.449473279105124,
        16.46233866787106,
        16.475204056636997,
        16.488069445402935,
        16.500934834168874,
        16.513800222934808,
        16.526665611700746,
        16.539531000466685,
        16.55239638923262,
        16.565261777998558,
        16.578127166764496,
        16.590992555530434,
        16.60385794429637,
        16.616723333062307,
        16.629588721828245,
        16.64245411059418,
        16.655319499360118,
        16.668184888126056,
        16.681050276891995,
        16.69391566565793,
        16.706781054423868,
        16.719646443189806,
        16.73251183195574,
        16.74537722072168,
        16.758242609487617,
        16.771107998253555,
        16.78397338701949,
        16.796838775785428,
        16.809704164551366,
        16.822569553317305,
        16.83543494208324,
        16.848300330849177,
        16.861165719615116,
        16.87403110838105,
        16.88689649714699,
        16.899761885912927,
        16.912627274678865,
        16.9254926634448,
        16.938358052210738,
        16.951223440976676,
        16.96408882974261,
        16.97695421850855,
        16.989819607274487,
        17.002684996040426,
        17.01555038480636,
        17.0284157735723,
        17.041281162338237,
        17.05414655110417,
        17.06701193987011,
        17.079877328636048,
        17.092742717401986,
        17.10560810616792,
        17.11847349493386,
        17.131338883699797,
        17.144204272465736,
        17.15706966123167,
        17.16993504999761,
        17.182800438763547,
        17.19566582752948,
        17.20853121629542,
        17.221396605061358,
        17.234261993827296,
        17.24712738259323,
        17.25999277135917,
        17.272858160125107,
        17.285723548891042,
        17.29858893765698,
        17.31145432642292,
        17.324319715188857,
        17.33718510395479,
        17.35005049272073,
        17.362915881486668,
        17.375781270252602,
        17.38864665901854,
        17.40151204778448,
        17.414377436550417,
        17.427242825316352,
        17.44010821408229,
        17.45297360284823,
        17.465838991614163,
        17.4787043803801,
        17.49156976914604,
        17.504435157911978,
        17.517300546677912,
        17.53016593544385,
        17.54303132420979,
        17.555896712975727,
        17.56876210174166,
        17.5816274905076,
        17.594492879273538,
        17.607358268039473,
        17.62022365680541,
        17.63308904557135,
        17.645954434337288,
        17.658819823103222,
        17.67168521186916,
        17.6845506006351,
        17.697415989401033,
        17.71028137816697,
        17.72314676693291,
        17.736012155698848,
        17.748877544464783,
        17.76174293323072,
        17.77460832199666,
        17.787473710762594,
        17.800339099528532,
        17.81320448829447,
        17.82606987706041,
        17.838935265826343,
        17.85180065459228,
        17.86466604335822,
        17.877531432124158,
        17.890396820890093,
        17.90326220965603,
        17.91612759842197,
        17.928992987187904,
        17.941858375953842,
        17.95472376471978,
        17.96758915348572,
        17.980454542251653,
        17.99331993101759,
        18.00618531978353,
        18.019050708549464,
        18.031916097315403,
        18.04478148608134,
        18.05764687484728,
        18.070512263613214,
        18.083377652379152,
        18.09624304114509,
        18.109108429911025,
        18.121973818676963,
        18.1348392074429,
        18.14770459620884,
        18.160569984974774,
        18.173435373740713,
        18.18630076250665,
        18.19916615127259,
        18.212031540038524,
        18.224896928804462,
        18.2377623175704,
        18.250627706336335,
        18.263493095102273,
        18.27635848386821,
        18.28922387263415,
        18.302089261400084,
        18.314954650166023,
        18.32782003893196,
        18.340685427697895,
        18.353550816463834,
        18.366416205229772,
        18.37928159399571,
        18.392146982761645,
        18.405012371527583,
        18.41787776029352,
        18.430743149059456,
        18.443608537825394,
        18.456473926591332,
        18.46933931535727,
        18.482204704123205,
        18.495070092889144,
        18.507935481655082,
        18.52080087042102,
        18.533666259186955,
        18.546531647952893,
        18.55939703671883,
        18.572262425484766,
        18.585127814250704,
        18.597993203016642,
        18.61085859178258,
        18.623723980548515,
        18.636589369314454,
        18.64945475808039,
        18.662320146846326,
        18.675185535612265,
        18.688050924378203,
        18.70091631314414,
        18.713781701910076,
        18.726647090676014,
        18.739512479441952,
        18.752377868207887,
        18.765243256973825,
        18.778108645739763,
        18.7909740345057,
        18.803839423271636,
        18.816704812037575,
        18.829570200803513,
        18.84243558956945,
        18.855300978335386,
        18.868166367101324,
        18.881031755867262,
        18.893897144633197,
        18.906762533399135,
        18.919627922165073,
        18.93249331093101,
        18.945358699696946,
        18.958224088462885,
        18.971089477228823,
        18.983954865994757,
        18.996820254760696,
        19.009685643526634,
        19.022551032292572,
        19.035416421058507,
        19.048281809824445,
        19.061147198590383,
        19.074012587356318,
        19.086877976122256,
        19.099743364888194,
        19.112608753654133,
        19.125474142420067,
        19.138339531186006,
        19.151204919951944,
        19.164070308717882,
        19.176935697483817,
        19.189801086249755,
        19.202666475015693,
        19.215531863781628,
        19.228397252547566,
        19.241262641313504,
        19.254128030079443,
        19.266993418845377,
        19.279858807611316,
        19.292724196377254,
        19.30558958514319,
        19.318454973909127,
        19.331320362675065,
        19.344185751441003,
        19.357051140206938,
        19.369916528972876,
        19.382781917738814,
        19.39564730650475,
        19.408512695270687,
        19.421378084036625,
        19.434243472802564,
        19.4471088615685,
        19.459974250334437,
        19.472839639100375,
        19.48570502786631,
        19.498570416632248,
        19.511435805398186,
        19.524301194164124,
        19.53716658293006,
        19.550031971695997,
        19.562897360461935,
        19.575762749227874,
        19.58862813799381,
        19.601493526759747,
        19.614358915525685,
        19.62722430429162,
        19.640089693057558,
        19.652955081823496,
        19.665820470589434,
        19.67868585935537,
        19.691551248121307,
        19.704416636887245,
        19.71728202565318,
        19.73014741441912,
        19.743012803185056,
        19.755878191950995,
        19.76874358071693,
        19.781608969482868,
        19.794474358248806,
        19.80733974701474,
        19.82020513578068,
        19.833070524546617,
        19.845935913312555,
        19.85880130207849,
        19.871666690844428,
        19.884532079610366,
        19.897397468376305,
        19.91026285714224,
        19.923128245908178,
        19.935993634674116,
        19.94885902344005,
        19.96172441220599,
        19.974589800971927,
        19.987455189737865,
        20.0003205785038,
        20.013185967269738,
        20.026051356035676,
        20.03891674480161,
        20.05178213356755,
        20.064647522333487,
        20.077512911099426,
        20.09037829986536,
        20.1032436886313,
        20.116109077397237,
        20.12897446616317,
        20.14183985492911,
        20.154705243695048,
        20.167570632460986,
        20.18043602122692,
        20.19330140999286,
        20.206166798758797,
        20.219032187524736,
        20.23189757629067,
        20.24476296505661,
        20.257628353822547,
        20.27049374258848,
        20.28335913135442,
        20.296224520120358,
        20.309089908886296,
        20.32195529765223,
        20.33482068641817,
        20.347686075184107,
        20.360551463950042,
        20.37341685271598,
        20.38628224148192,
        20.399147630247857,
        20.41201301901379,
        20.42487840777973,
        20.437743796545668,
        20.450609185311603,
        20.46347457407754,
        20.47633996284348,
        20.489205351609417,
        20.502070740375352,
        20.51493612914129,
        20.52780151790723,
        20.540666906673167,
        20.5535322954391,
        20.56639768420504,
        20.579263072970978,
        20.592128461736912,
        20.60499385050285,
        20.61785923926879,
        20.630724628034727,
        20.643590016800662,
        20.6564554055666,
        20.66932079433254,
        20.682186183098473,
        20.69505157186441,
        20.70791696063035,
        20.720782349396288,
        20.733647738162222,
        20.74651312692816,
        20.7593785156941,
        20.772243904460034,
        20.785109293225972,
        20.79797468199191,
        20.81084007075785,
        20.823705459523783,
        20.83657084828972,
        20.84943623705566,
        20.862301625821598,
        20.875167014587532,
        20.88803240335347,
        20.90089779211941,
        20.913763180885343,
        20.92662856965128,
        20.93949395841722,
        20.952359347183158,
        20.965224735949093,
        20.97809012471503,
        20.99095551348097,
        21.003820902246904,
        21.016686291012842,
        21.02955167977878,
        21.04241706854472,
        21.055282457310653,
        21.06814784607659,
        21.08101323484253,
        21.093878623608465,
        21.106744012374403,
        21.11960940114034,
        21.13247478990628,
        21.145340178672214,
        21.158205567438152,
        21.17107095620409,
        21.183936344970025,
        21.196801733735963,
        21.2096671225019,
        21.22253251126784,
        21.235397900033774,
        21.248263288799713,
        21.26112867756565,
        21.27399406633159,
        21.286859455097524,
        21.299724843863462,
        21.3125902326294,
        21.325455621395335,
        21.338321010161273,
        21.35118639892721,
        21.36405178769315,
        21.376917176459084,
        21.389782565225023,
        21.40264795399096,
        21.415513342756896,
        21.428378731522834,
        21.441244120288772,
        21.45410950905471,
        21.466974897820645,
        21.479840286586583,
        21.49270567535252,
        21.505571064118456,
        21.518436452884394,
        21.531301841650333,
        21.54416723041627,
        21.557032619182205,
        21.569898007948144,
        21.582763396714082,
        21.59562878548002,
        21.608494174245955,
        21.621359563011893,
        21.63422495177783,
        21.647090340543766,
        21.659955729309704,
        21.672821118075642,
        21.68568650684158,
        21.698551895607515,
        21.711417284373454,
        21.724282673139392,
        21.737148061905327,
        21.750013450671265,
        21.762878839437203,
        21.77574422820314,
        21.788609616969076,
        21.801475005735014,
        21.814340394500952,
        21.827205783266887,
        21.840071172032825,
        21.852936560798764,
        21.865801949564702,
        21.878667338330636,
        21.891532727096575,
        21.904398115862513,
        21.91726350462845,
        21.930128893394386,
        21.942994282160324,
        21.955859670926262,
        21.968725059692197,
        21.981590448458135,
        21.994455837224073,
        22.00732122599001,
        22.020186614755946,
        22.033052003521885,
        22.045917392287823,
        22.058782781053758,
        22.071648169819696,
        22.084513558585634,
        22.097378947351572,
        22.110244336117507,
        22.123109724883445,
        22.135975113649383,
        22.148840502415318,
        22.161705891181256,
        22.174571279947195,
        22.187436668713133,
        22.200302057479067,
        22.213167446245006,
        22.226032835010944,
        22.238898223776882,
        22.251763612542817,
        22.264629001308755,
        22.277494390074693,
        22.290359778840628,
        22.303225167606566,
        22.316090556372504,
        22.328955945138443,
        22.341821333904377,
        22.354686722670316,
        22.367552111436254,
        22.38041750020219,
        22.393282888968127,
        22.406148277734065,
        22.419013666500003,
        22.431879055265938,
        22.444744444031876,
        22.457609832797814,
        22.47047522156375,
        22.483340610329687,
        22.496205999095626,
        22.509071387861564,
        22.5219367766275,
        22.534802165393437,
        22.547667554159375,
        22.560532942925313,
        22.573398331691248,
        22.586263720457186,
        22.599129109223124,
        22.61199449798906,
        22.624859886754997,
        22.637725275520935,
        22.650590664286874,
        22.66345605305281,
        22.676321441818747,
        22.689186830584685,
        22.70205221935062,
        22.714917608116558,
        22.727782996882496,
        22.740648385648434,
        22.75351377441437,
        22.766379163180307,
        22.779244551946245,
        22.79210994071218,
        22.80497532947812,
        22.817840718244057,
        22.830706107009995,
        22.84357149577593,
        22.856436884541868,
        22.869302273307806,
        22.882167662073744,
        22.89503305083968,
        22.907898439605617,
        22.920763828371555,
        22.93362921713749,
        22.94649460590343,
        22.959359994669367,
        22.972225383435305,
        22.98509077220124,
        22.997956160967178,
        23.010821549733116,
        23.02368693849905,
        23.03655232726499,
        23.049417716030927,
        23.062283104796865,
        23.0751484935628,
        23.088013882328738,
        23.100879271094676,
        23.11374465986061,
        23.12661004862655,
        23.139475437392488,
        23.152340826158426,
        23.16520621492436,
        23.1780716036903,
        23.190936992456237,
        23.20380238122217,
        23.21666776998811,
        23.229533158754048,
        23.242398547519986,
        23.25526393628592,
        23.26812932505186,
        23.280994713817798,
        23.293860102583736,
        23.30672549134967,
        23.31959088011561,
        23.332456268881547,
        23.34532165764748,
        23.35818704641342,
        23.371052435179358,
        23.383917823945296,
        23.39678321271123,
        23.40964860147717,
        23.422513990243107,
        23.435379379009042,
        23.44824476777498,
        23.46111015654092,
        23.473975545306857,
        23.48684093407279,
        23.49970632283873,
        23.512571711604668,
        23.525437100370603,
        23.53830248913654,
        23.55116787790248,
        23.564033266668417,
        23.576898655434352,
        23.58976404420029,
        23.60262943296623,
        23.615494821732167,
        23.6283602104981,
        23.64122559926404,
        23.654090988029978,
        23.666956376795913,
        23.67982176556185,
        23.69268715432779,
        23.705552543093727,
        23.718417931859662,
        23.7312833206256,
        23.74414870939154,
        23.757014098157473,
        23.76987948692341,
        23.78274487568935,
        23.795610264455288,
        23.808475653221223,
        23.82134104198716,
        23.8342064307531,
        23.847071819519034,
        23.859937208284972,
        23.87280259705091,
        23.88566798581685,
        23.898533374582783,
        23.91139876334872,
        23.92426415211466,
        23.937129540880598,
        23.949994929646532,
        23.96286031841247,
        23.97572570717841,
        23.988591095944344,
        24.001456484710282,
        24.01432187347622,
        24.02718726224216,
        24.040052651008093,
        24.05291803977403,
        24.06578342853997,
        24.078648817305904,
        24.091514206071842,
        24.10437959483778,
        24.11724498360372,
        24.130110372369654,
        24.14297576113559,
        24.15584114990153,
        24.168706538667465,
        24.181571927433403,
        24.19443731619934,
        24.20730270496528,
        24.220168093731214,
        24.233033482497152,
        24.24589887126309,
        24.25876426002903,
        24.271629648794963,
        24.2844950375609,
        24.29736042632684,
        24.310225815092775,
        24.323091203858713,
        24.33595659262465,
        24.34882198139059,
        24.361687370156524,
        24.374552758922462,
        24.3874181476884,
        24.400283536454335,
        24.413148925220273,
        24.42601431398621,
        24.43887970275215,
        24.451745091518085,
        24.464610480284023,
        24.47747586904996,
        24.490341257815896,
        24.503206646581834,
        24.516072035347772,
        24.52893742411371,
        24.541802812879645,
        24.554668201645583,
        24.56753359041152,
        24.58039897917746,
        24.593264367943394,
        24.606129756709333,
        24.61899514547527,
        24.631860534241206,
        24.644725923007144,
        24.657591311773082,
        24.67045670053902,
        24.683322089304955,
        24.696187478070893,
        24.70905286683683,
        24.721918255602766,
        24.734783644368704,
        24.747649033134643,
        24.76051442190058,
        24.773379810666516,
        24.786245199432454,
        24.799110588198392,
        24.811975976964327,
        24.824841365730265,
        24.837706754496203,
        24.85057214326214,
        24.863437532028076,
        24.876302920794014,
        24.889168309559953,
        24.902033698325887,
        24.914899087091825,
        24.927764475857764,
        24.940629864623702,
        24.953495253389637,
        24.966360642155575,
        24.979226030921513,
        24.99209141968745,
        25.004956808453386,
        25.017822197219324,
        25.030687585985262,
        25.043552974751197,
        25.056418363517135,
        25.069283752283074,
        25.082149141049012,
        25.095014529814947,
        25.107879918580885,
        25.120745307346823,
        25.133610696112758,
        25.146476084878696,
        25.159341473644634,
        25.172206862410572,
        25.185072251176507,
        25.197937639942445,
        25.210803028708384,
        25.223668417474318,
        25.236533806240256,
        25.249399195006195,
        25.262264583772133,
        25.275129972538068,
        25.287995361304006,
        25.300860750069944,
        25.313726138835882,
        25.326591527601817,
        25.339456916367755,
        25.352322305133693,
        25.365187693899628,
        25.378053082665566,
        25.390918471431505,
        25.403783860197443,
        25.416649248963378,
        25.429514637729316,
        25.442380026495254,
        25.45524541526119,
        25.468110804027127,
        25.480976192793065,
        25.493841581559003,
        25.506706970324938,
        25.519572359090876,
        25.532437747856815,
        25.54530313662275,
        25.558168525388687,
        25.571033914154626,
        25.583899302920564,
        25.5967646916865,
        25.609630080452437,
        25.622495469218375,
        25.635360857984313,
        25.648226246750248,
        25.661091635516186,
        25.673957024282124,
        25.68682241304806,
        25.699687801813997,
        25.712553190579936,
        25.725418579345874,
        25.73828396811181,
        25.751149356877747,
        25.764014745643685,
        25.77688013440962,
        25.789745523175558,
        25.802610911941496,
        25.815476300707434,
        25.82834168947337,
        25.841207078239307,
        25.854072467005246,
        25.86693785577118,
        25.87980324453712,
        25.892668633303057,
        25.905534022068995,
        25.91839941083493,
        25.931264799600868,
        25.944130188366806,
        25.956995577132744,
        25.96986096589868,
        25.982726354664617,
        25.995591743430555,
        26.00845713219649,
        26.02132252096243,
        26.034187909728367,
        26.047053298494305,
        26.05991868726024,
        26.072784076026178,
        26.085649464792116,
        26.09851485355805,
        26.11138024232399,
        26.124245631089927,
        26.137111019855865,
        26.1499764086218,
        26.16284179738774,
        26.175707186153677,
        26.18857257491961,
        26.20143796368555,
        26.214303352451488,
        26.227168741217426,
        26.24003412998336,
        26.2528995187493,
        26.265764907515237,
        26.278630296281175,
        26.29149568504711,
        26.304361073813048,
        26.317226462578986,
        26.33009185134492,
        26.34295724011086,
        26.355822628876798,
        26.368688017642736,
        26.38155340640867,
        26.39441879517461,
        26.407284183940547,
        26.42014957270648,
        26.43301496147242,
        26.445880350238358,
        26.458745739004296,
        26.47161112777023,
        26.48447651653617,
        26.497341905302108,
        26.510207294068042,
        26.52307268283398,
        26.53593807159992,
        26.548803460365857,
        26.56166884913179,
        26.57453423789773,
        26.587399626663668,
        26.600265015429606,
        26.61313040419554,
        26.62599579296148,
        26.638861181727417,
        26.651726570493352,
        26.66459195925929,
        26.67745734802523,
        26.690322736791167,
        26.7031881255571,
        26.71605351432304,
        26.728918903088978,
        26.741784291854913,
        26.75464968062085,
        26.76751506938679,
        26.780380458152727,
        26.793245846918662,
        26.8061112356846,
        26.81897662445054,
        26.831842013216473,
        26.84470740198241,
        26.85757279074835,
        26.870438179514288,
        26.883303568280223,
        26.89616895704616,
        26.9090343458121,
        26.921899734578034,
        26.934765123343972,
        26.94763051210991,
        26.96049590087585,
        26.973361289641783,
        26.98622667840772,
        26.99909206717366,
        27.011957455939598,
        27.024822844705533,
        27.03768823347147,
        27.05055362223741,
        27.063419011003344,
        27.076284399769282,
        27.08914978853522,
        27.10201517730116,
        27.114880566067093,
        27.12774595483303,
        27.14061134359897,
        27.153476732364904,
        27.166342121130842,
        27.17920750989678,
        27.19207289866272,
        27.204938287428654,
        27.217803676194592,
        27.23066906496053,
        27.243534453726465,
        27.256399842492403,
        27.26926523125834,
        27.28213062002428,
        27.294996008790214,
        27.307861397556152,
        27.32072678632209,
        27.33359217508803,
        27.346457563853964,
        27.3593229526199,
        27.37218834138584,
        27.385053730151775,
        27.397919118917713,
        27.41078450768365,
        27.42364989644959,
        27.436515285215524,
        27.449380673981462,
        27.4622460627474,
        27.475111451513335,
        27.487976840279273,
        27.50084222904521,
        27.51370761781115,
        27.526573006577085,
        27.539438395343023,
        27.55230378410896,
        27.565169172874896,
        27.578034561640834,
        27.590899950406772,
        27.60376533917271,
        27.616630727938645,
        27.629496116704583,
        27.64236150547052,
        27.65522689423646,
        27.668092283002395,
        27.680957671768333,
        27.69382306053427,
        27.706688449300206,
        27.719553838066144,
        27.732419226832082,
        27.74528461559802,
        27.758150004363955,
        27.771015393129893,
        27.78388078189583,
        27.796746170661766,
        27.809611559427704,
        27.822476948193643,
        27.83534233695958,
        27.848207725725516,
        27.861073114491454,
        27.873938503257392,
        27.886803892023327,
        27.899669280789265,
        27.912534669555203,
        27.92540005832114,
        27.938265447087076,
        27.951130835853014,
        27.963996224618953,
        27.97686161338489,
        27.989727002150826,
        28.002592390916764,
        28.015457779682702,
        28.028323168448637,
        28.041188557214575,
        28.054053945980513,
        28.06691933474645,
        28.079784723512386,
        28.092650112278324,
        28.105515501044263,
        28.118380889810197,
        28.131246278576135,
        28.144111667342074,
        28.156977056108012,
        28.169842444873947,
        28.182707833639885,
        28.195573222405823,
        28.208438611171758,
        28.221303999937696,
        28.234169388703634,
        28.247034777469572,
        28.259900166235507,
        28.272765555001445,
        28.285630943767384,
        28.298496332533322,
        28.311361721299257,
        28.324227110065195,
        28.337092498831133,
        28.349957887597068,
        28.362823276363006,
        28.375688665128944,
        28.388554053894882,
        28.401419442660817,
        28.414284831426755,
        28.427150220192694,
        28.44001560895863,
        28.452880997724566,
        28.465746386490505,
        28.478611775256443,
        28.491477164022378,
        28.504342552788316,
        28.517207941554254,
        28.53007333032019,
        28.542938719086127,
        28.555804107852065,
        28.568669496618003,
        28.581534885383938,
        28.594400274149876,
        28.607265662915815,
        28.62013105168175,
        28.632996440447688,
        28.645861829213626,
        28.658727217979564,
        28.6715926067455,
        28.684457995511437,
        28.697323384277375,
        28.710188773043313,
        28.723054161809248,
        28.735919550575186,
        28.748784939341125,
        28.76165032810706,
        28.774515716872997,
        28.787381105638936,
        28.800246494404874,
        28.81311188317081,
        28.825977271936747,
        28.838842660702685,
        28.85170804946862,
        28.864573438234558,
        28.877438827000496,
        28.890304215766434,
        28.90316960453237,
        28.916034993298307,
        28.928900382064246,
        28.94176577083018,
        28.95463115959612,
        28.967496548362057,
        28.980361937127995,
        28.99322732589393,
        29.006092714659868,
        29.018958103425806,
        29.031823492191744,
        29.04468888095768,
        29.057554269723617,
        29.070419658489556,
        29.08328504725549,
        29.09615043602143,
        29.109015824787367,
        29.121881213553305,
        29.13474660231924,
        29.147611991085178,
        29.160477379851116,
        29.17334276861705,
        29.18620815738299,
        29.199073546148927,
        29.211938934914865,
        29.2248043236808,
        29.23766971244674,
        29.250535101212677,
        29.26340048997861,
        29.27626587874455,
        29.289131267510488,
        29.301996656276426,
        29.31486204504236,
        29.3277274338083,
        29.340592822574237,
        29.353458211340175,
        29.36632360010611,
        29.37918898887205,
        29.392054377637987,
        29.40491976640392,
        29.41778515516986,
        29.430650543935798,
        29.443515932701736,
        29.45638132146767,
        29.46924671023361,
        29.482112098999547,
        29.494977487765482,
        29.50784287653142,
        29.52070826529736,
        29.533573654063296,
        29.54643904282923,
        29.55930443159517,
        29.572169820361108,
        29.585035209127042,
        29.59790059789298,
        29.61076598665892,
        29.623631375424857,
        29.63649676419079,
        29.64936215295673,
        29.662227541722668,
        29.675092930488606,
        29.68795831925454,
        29.70082370802048,
        29.713689096786418,
        29.726554485552352,
        29.73941987431829,
        29.75228526308423,
        29.765150651850167,
        29.7780160406161,
        29.79088142938204,
        29.803746818147978,
        29.816612206913913,
        29.82947759567985,
        29.84234298444579,
        29.855208373211727,
        29.868073761977662,
        29.8809391507436,
        29.89380453950954,
        29.906669928275473,
        29.91953531704141,
        29.93240070580735,
        29.945266094573288,
        29.958131483339223,
        29.97099687210516,
        29.9838622608711,
        29.996727649637037,
        30.009593038402972,
        30.02245842716891,
        30.03532381593485,
        30.048189204700783,
        30.06105459346672,
        30.07391998223266,
        30.086785370998598,
        30.099650759764533,
        30.11251614853047,
        30.12538153729641,
        30.138246926062344,
        30.151112314828282,
        30.16397770359422,
        30.17684309236016,
        30.189708481126093,
        30.20257386989203,
        30.21543925865797,
        30.228304647423904,
        30.241170036189843,
        30.25403542495578,
        30.26690081372172,
        30.279766202487654,
        30.292631591253592,
        30.30549698001953,
        30.31836236878547,
        30.331227757551403,
        30.34409314631734,
        30.35695853508328,
        30.369823923849214,
        30.382689312615152,
        30.39555470138109,
        30.40842009014703,
        30.421285478912964,
        30.434150867678902,
        30.44701625644484,
        30.459881645210775,
        30.472747033976713,
        30.48561242274265,
        30.49847781150859,
        30.511343200274524,
        30.524208589040462,
        30.5370739778064,
        30.549939366572335,
        30.562804755338274,
        30.575670144104212,
        30.58853553287015,
        30.601400921636085,
        30.614266310402023,
        30.62713169916796,
        30.639997087933896,
        30.652862476699834,
        30.665727865465772,
        30.67859325423171,
        30.691458642997645,
        30.704324031763583,
        30.71718942052952,
        30.73005480929546,
        30.742920198061395,
        30.755785586827333,
        30.76865097559327,
        30.781516364359206,
        30.794381753125144,
        30.807247141891082,
        30.82011253065702,
        30.832977919422955,
        30.845843308188893,
        30.85870869695483,
        30.871574085720766,
        30.884439474486705,
        30.897304863252643,
        30.91017025201858,
        30.923035640784516,
        30.935901029550454,
        30.948766418316392,
        30.961631807082327,
        30.974497195848265,
        30.987362584614203,
        31.00022797338014,
        31.013093362146076,
        31.025958750912014,
        31.038824139677953,
        31.05168952844389,
        31.064554917209826,
        31.077420305975764,
        31.090285694741702,
        31.103151083507637,
        31.116016472273575,
        31.128881861039513,
        31.14174724980545,
        31.154612638571386,
        31.167478027337324,
        31.180343416103263,
        31.193208804869197,
        31.206074193635136,
        31.218939582401074,
        31.231804971167012,
        31.244670359932947,
        31.257535748698885,
        31.270401137464823,
        31.283266526230758,
        31.296131914996696,
        31.308997303762634,
        31.321862692528573,
        31.334728081294507,
        31.347593470060445,
        31.360458858826384,
        31.373324247592322,
        31.386189636358257,
        31.399055025124195,
        31.41192041389013,
        31.424785802656068,
        31.437651191422006,
        31.450516580187944,
        31.463381968953883,
        31.47624735771982,
        31.489112746485752,
        31.50197813525169,
        31.51484352401763,
        31.527708912783567,
        31.540574301549505,
        31.553439690315443,
        31.56630507908138,
        31.57917046784732,
        31.59203585661325,
        31.60490124537919,
        31.617766634145127,
        31.630632022911065,
        31.643497411677004,
        31.656362800442942,
        31.66922818920888,
        31.68209357797481,
        31.69495896674075,
        31.707824355506688,
        31.720689744272626,
        31.733555133038564,
        31.746420521804502,
        31.75928591057044,
        31.77215129933637,
        31.78501668810231,
        31.797882076868248,
        31.810747465634186,
        31.823612854400125,
        31.836478243166063,
        31.849343631932,
        31.862209020697932,
        31.87507440946387,
        31.88793979822981,
        31.900805186995747,
        31.913670575761685,
        31.926535964527623,
        31.93940135329356,
        31.952266742059493,
        31.96513213082543,
        31.97799751959137,
        31.990862908357308,
        32.003728297123246,
        32.016593685889184,
        32.02945907465512,
        32.04232446342105,
        32.05518985218699,
        32.06805524095293,
        32.08092062971887,
        32.093786018484806,
        32.106651407250745,
        32.11951679601668,
        32.132382184782614,
        32.14524757354855,
        32.15811296231449,
        32.17097835108043,
        32.18384373984637,
        32.196709128612305,
        32.20957451737824,
        32.22243990614418,
        32.23530529491011,
        32.24817068367605,
        32.26103607244199,
        32.27390146120793,
        32.286766849973866,
        32.299632238739804,
        32.31249762750574,
        32.32536301627167,
        32.33822840503761,
        32.35109379380355,
        32.36395918256949,
        32.376824571335426,
        32.389689960101364,
        32.4025553488673,
        32.415420737633234,
        32.42828612639917,
        32.44115151516511,
        32.45401690393105,
        32.46688229269699,
        32.479747681462925,
        32.49261307022886,
        32.505478458994794,
        32.51834384776073,
        32.53120923652667,
        32.54407462529261,
        32.55694001405855,
        32.569805402824485,
        32.582670791590424,
        32.595536180356355,
        32.60840156912229,
        32.62126695788823,
        32.63413234665417,
        32.64699773542011,
        32.659863124186046,
        32.672728512951984,
        32.685593901717915,
        32.698459290483854,
        32.71132467924979,
        32.72419006801573,
        32.73705545678167,
        32.74992084554761,
        32.762786234313545,
        32.775651623079476,
        32.788517011845414,
        32.80138240061135,
        32.81424778937729,
        32.82711317814323,
        32.83997856690917,
        32.852843955675105,
        32.86570934444104,
        32.878574733206975,
        32.89144012197291,
        32.90430551073885,
        32.91717089950479,
        32.93003628827073,
        32.942901677036666,
        32.955767065802604,
        32.968632454568535,
        32.98149784333447,
        32.99436323210041,
        33.00722862086635,
        33.02009400963229,
        33.032959398398226,
        33.045824787164165,
        33.058690175930096,
        33.071555564696034,
        33.08442095346197,
        33.09728634222791,
        33.11015173099385,
        33.12301711975979,
        33.135882508525725,
        33.148747897291656,
        33.161613286057595,
        33.17447867482353,
        33.18734406358947,
        33.20020945235541,
        33.21307484112135,
        33.225940229887286,
        33.23880561865322,
        33.251671007419155,
        33.26453639618509,
        33.27740178495103,
        33.29026717371697,
        33.30313256248291,
        33.315997951248846,
        33.32886334001478,
        33.341728728780716,
        33.354594117546654,
        33.36745950631259,
        33.38032489507853,
        33.39319028384447,
        33.40605567261041,
        33.41892106137634,
        33.431786450142276,
        33.444651838908214,
        33.45751722767415,
        33.47038261644009,
        33.48324800520603,
        33.49611339397197,
        33.5089787827379,
        33.52184417150384,
        33.534709560269775,
        33.54757494903571,
        33.56044033780165,
        33.57330572656759,
        33.58617111533353,
        33.599036504099466,
        33.6119018928654,
        33.624767281631335,
        33.637632670397274,
        33.65049805916321,
        33.66336344792915,
        33.67622883669509,
        33.68909422546103,
        33.70195961422696,
        33.714825002992896,
        33.727690391758834,
        33.74055578052477,
        33.75342116929071,
        33.76628655805665,
        33.77915194682259,
        33.79201733558852,
        33.80488272435446,
        33.817748113120395,
        33.83061350188633,
        33.84347889065227,
        33.85634427941821,
        33.86920966818415,
        33.88207505695008,
        33.89494044571602,
        33.907805834481955,
        33.92067122324789,
        33.93353661201383,
        33.94640200077977,
        33.95926738954571,
        33.97213277831164,
        33.98499816707758,
        33.997863555843516,
        34.010728944609454,
        34.02359433337539,
        34.03645972214133,
        34.04932511090727,
        34.0621904996732,
        34.07505588843914,
        34.087921277205076,
        34.100786665971015,
        34.11365205473695,
        34.12651744350289,
        34.13938283226883,
        34.15224822103476,
        34.1651136098007,
        34.17797899856664,
        34.190844387332575,
        34.20370977609851,
        34.21657516486445,
        34.22944055363039,
        34.24230594239633,
        34.25517133116226,
        34.2680367199282,
        34.280902108694136,
        34.293767497460074,
        34.30663288622601,
        34.31949827499195,
        34.33236366375789,
        34.34522905252382,
        34.35809444128976,
        34.370959830055696,
        34.383825218821634,
        34.39669060758757,
        34.40955599635351,
        34.42242138511945,
        34.43528677388538,
        34.44815216265132,
        34.46101755141726,
        34.473882940183195,
        34.48674832894913,
        34.49961371771507,
        34.51247910648101,
        34.52534449524694,
        34.53820988401288,
        34.55107527277882,
        34.563940661544756,
        34.576806050310694,
        34.58967143907663,
        34.60253682784257,
        34.6154022166085,
        34.62826760537444,
        34.64113299414038,
        34.653998382906316,
        34.666863771672254,
        34.67972916043819,
        34.69259454920413,
        34.70545993797006,
        34.718325326736,
        34.73119071550194,
        34.74405610426788,
        34.756921493033815,
        34.76978688179975,
        34.78265227056569,
        34.79551765933162,
        34.80838304809756,
        34.8212484368635,
        34.83411382562944,
        34.846979214395375,
        34.859844603161314,
        34.87270999192725,
        34.88557538069319,
        34.89844076945912,
        34.91130615822506,
        34.924171546991,
        34.937036935756936,
        34.949902324522874,
        34.96276771328881,
        34.97563310205475,
        34.98849849082068,
        35.00136387958662,
        35.01422926835256,
        35.0270946571185,
        35.039960045884435,
        35.05282543465037,
        35.06569082341631,
        35.07855621218224,
        35.09142160094818,
        35.10428698971412,
        35.11715237848006,
        35.130017767245995,
        35.14288315601193,
        35.15574854477787,
        35.1686139335438,
        35.18147932230974,
        35.19434471107568,
        35.20721009984162,
        35.220075488607556,
        35.232940877373494,
        35.24580626613943,
        35.25867165490536,
        35.2715370436713,
        35.28440243243724,
        35.29726782120318,
        35.310133209969116,
        35.322998598735055,
        35.33586398750099,
        35.348729376266924,
        35.36159476503286,
        35.3744601537988,
        35.38732554256474,
        35.40019093133068,
        35.413056320096615,
        35.42592170886255,
        35.438787097628484,
        35.45165248639442,
        35.46451787516036,
        35.4773832639263,
        35.49024865269224,
        35.503114041458176,
        35.515979430224114,
        35.528844818990045,
        35.54171020775598,
        35.55457559652192,
        35.56744098528786,
        35.5803063740538,
        35.593171762819736,
        35.606037151585674,
        35.61890254035161,
        35.631767929117544,
        35.64463331788348,
        35.65749870664942,
        35.67036409541536,
        35.6832294841813,
        35.696094872947235,
        35.70896026171317,
        35.721825650479104,
        35.73469103924504,
        35.74755642801098,
        35.76042181677692,
        35.77328720554286,
        35.786152594308795,
        35.799017983074734,
        35.811883371840665,
        35.8247487606066,
        35.83761414937254,
        35.85047953813848,
        35.86334492690442,
        35.876210315670356,
        35.889075704436294,
        35.901941093202225,
        35.914806481968164,
        35.9276718707341,
        35.94053725950004,
        35.95340264826598,
        35.96626803703192,
        35.979133425797855,
        35.991998814563786,
        36.004864203329724,
        36.01772959209566,
        36.0305949808616,
        36.04346036962754,
        36.05632575839348,
        36.069191147159415,
        36.08205653592535,
        36.094921924691285,
        36.10778731345722,
        36.12065270222316,
        36.1335180909891,
        36.14638347975504,
        36.159248868520976,
        36.17211425728691,
        36.184979646052845,
        36.19784503481878,
        36.21071042358472,
        36.22357581235066,
        36.2364412011166,
        36.249306589882536,
        36.262171978648475,
        36.275037367414406,
        36.287902756180344,
        36.30076814494628,
        36.31363353371222,
        36.32649892247816,
        36.3393643112441,
        36.352229700010035,
        36.365095088775966,
        36.377960477541905,
        36.39082586630784,
        36.40369125507378,
        36.41655664383972,
        36.42942203260566,
        36.442287421371596,
        36.45515281013753,
        36.468018198903465,
        36.4808835876694,
        36.49374897643534,
        36.50661436520128,
        36.51947975396722,
        36.532345142733156,
        36.54521053149909,
        36.558075920265026,
        36.570941309030964,
        36.5838066977969,
        36.59667208656284,
        36.60953747532878,
        36.62240286409472,
        36.63526825286065,
        36.648133641626586,
        36.660999030392524,
        36.67386441915846,
        36.6867298079244,
        36.69959519669034,
        36.71246058545628,
        36.72532597422221,
        36.73819136298815,
        36.751056751754085,
        36.76392214052002,
        36.77678752928596,
        36.7896529180519,
        36.80251830681784,
        36.81538369558377,
        36.82824908434971,
        36.841114473115645,
        36.853979861881584,
        36.86684525064752,
        36.87971063941346,
        36.8925760281794,
        36.90544141694534,
        36.91830680571127,
        36.931172194477206,
        36.944037583243144,
        36.95690297200908,
        36.96976836077502,
        36.98263374954096,
        36.9954991383069,
        37.00836452707283,
        37.02122991583877,
        37.034095304604705,
        37.04696069337064,
        37.05982608213658,
        37.07269147090252,
        37.08555685966846,
        37.09842224843439,
        37.11128763720033,
        37.124153025966265,
        37.137018414732204,
        37.14988380349814,
        37.16274919226408,
        37.17561458103002,
        37.18847996979595,
        37.20134535856189,
        37.214210747327826,
        37.227076136093764,
        37.2399415248597,
        37.25280691362564,
        37.26567230239158,
        37.27853769115751,
        37.29140307992345,
        37.304268468689386,
        37.317133857455325,
        37.32999924622126,
        37.3428646349872,
        37.35573002375314,
        37.36859541251907,
        37.38146080128501,
        37.39432619005095,
        37.407191578816885,
        37.42005696758282,
        37.43292235634876,
        37.4457877451147,
        37.45865313388063,
        37.47151852264657,
        37.48438391141251,
        37.497249300178446,
        37.510114688944384,
        37.52298007771032,
        37.53584546647626,
        37.54871085524219,
        37.56157624400813,
        37.57444163277407,
        37.587307021540006,
        37.600172410305944,
        37.61303779907188,
        37.62590318783782,
        37.63876857660376,
        37.65163396536969,
        37.66449935413563,
        37.67736474290157,
        37.690230131667505,
        37.70309552043344,
        37.71596090919938,
        37.72882629796532,
        37.74169168673125,
        37.75455707549719,
        37.76742246426313,
        37.780287853029066,
        37.793153241795004,
        37.80601863056094,
        37.81888401932688,
        37.83174940809281,
        37.84461479685875,
        37.85748018562469,
        37.870345574390626,
        37.883210963156564,
        37.8960763519225,
        37.90894174068844,
        37.92180712945437,
        37.93467251822031,
        37.94753790698625,
        37.96040329575219,
        37.973268684518125,
        37.98613407328406,
        37.99899946205,
        38.01186485081593,
        38.02473023958187,
        38.03759562834781,
        38.05046101711375,
        38.063326405879685,
        38.076191794645624,
        38.08905718341156,
        38.10192257217749,
        38.11478796094343,
        38.12765334970937,
        38.14051873847531,
        38.153384127241246,
        38.166249516007184,
        38.17911490477312,
        38.19198029353905,
        38.20484568230499,
        38.21771107107093,
        38.23057645983687,
        38.24344184860281,
        38.256307237368745,
        38.26917262613468,
        38.28203801490062,
        38.29490340366655,
        38.30776879243249,
        38.32063418119843,
        38.33349956996437,
        38.346364958730305,
        38.35923034749624,
        38.37209573626218,
        38.38496112502811,
        38.39782651379405,
        38.41069190255999,
        38.42355729132593,
        38.436422680091866,
        38.449288068857804,
        38.46215345762374,
        38.47501884638967,
        38.48788423515561,
        38.50074962392155,
        38.51361501268749,
        38.526480401453426,
        38.539345790219365,
        38.5522111789853,
        38.565076567751234,
        38.57794195651717,
        38.59080734528311,
        38.60367273404905,
        38.61653812281499,
        38.629403511580925,
        38.64226890034686,
        38.655134289112794,
        38.66799967787873,
        38.68086506664467,
        38.69373045541061,
        38.70659584417655,
        38.719461232942486,
        38.732326621708424,
        38.745192010474355,
        38.75805739924029,
        38.77092278800623,
        38.78378817677217,
        38.79665356553811,
        38.809518954304046,
        38.822384343069984,
        38.835249731835916,
        38.848115120601854,
        38.86098050936779,
        38.87384589813373,
        38.88671128689967,
        38.89957667566561,
        38.912442064431545,
        38.92530745319748,
        38.938172841963414,
        38.95103823072935,
        38.96390361949529,
        38.97676900826123,
        38.98963439702717,
        39.002499785793106,
        39.015365174559044,
        39.028230563324975,
        39.04109595209091,
        39.05396134085685,
        39.06682672962279,
        39.07969211838873,
        39.092557507154666,
        39.105422895920604,
        39.118288284686535,
        39.131153673452474,
        39.14401906221841,
        39.15688445098435,
        39.16974983975029,
        39.18261522851623,
        39.195480617282165,
        39.208346006048096,
        39.221211394814034,
        39.23407678357997,
        39.24694217234591,
        39.25980756111185,
        39.27267294987779,
        39.285538338643725,
        39.29840372740966,
        39.311269116175595,
        39.32413450494153,
        39.33699989370747,
        39.34986528247341,
        39.36273067123935,
        39.375596060005286,
        39.38846144877122,
        39.401326837537155,
        39.41419222630309,
        39.42705761506903,
        39.43992300383497,
        39.45278839260091,
        39.465653781366846,
        39.47851917013278,
        39.491384558898716,
        39.504249947664654,
        39.51711533643059,
        39.52998072519653,
        39.54284611396247,
        39.55571150272841,
        39.56857689149434,
        39.581442280260276,
        39.594307669026215,
        39.60717305779215,
        39.62003844655809,
        39.63290383532403,
        39.64576922408997,
        39.658634612855906,
        39.67150000162184,
        39.684365390387775,
        39.69723077915371,
        39.71009616791965,
        39.72296155668559,
        39.73582694545153,
        39.748692334217466,
        39.7615577229834,
        39.774423111749336,
        39.787288500515274,
        39.80015388928121,
        39.81301927804715,
        39.82588466681309,
        39.83875005557903,
        39.85161544434496,
        39.864480833110896,
        39.877346221876834,
        39.89021161064277,
        39.90307699940871,
        39.91594238817465,
        39.92880777694059,
        39.94167316570652,
        39.95453855447246,
        39.967403943238395,
        39.98026933200433,
        39.99313472077027,
        40.00600010953621,
        40.01886549830215,
        40.03173088706808,
        40.04459627583402,
        40.057461664599955,
        40.070327053365894,
        40.08319244213183,
        40.09605783089777,
        40.10892321966371,
        40.12178860842964,
        40.13465399719558,
        40.147519385961516,
        40.160384774727454,
        40.17325016349339,
        40.18611555225933,
        40.19898094102527,
        40.2118463297912,
        40.22471171855714,
        40.23757710732308,
        40.250442496089015,
        40.26330788485495,
        40.27617327362089,
        40.28903866238683,
        40.30190405115277,
        40.3147694399187,
        40.32763482868464,
        40.340500217450575,
        40.353365606216514,
        40.36623099498245,
        40.37909638374839,
        40.39196177251433,
        40.40482716128026,
        40.4176925500462,
        40.430557938812136,
        40.443423327578074,
        40.45628871634401,
        40.46915410510995,
        40.48201949387589,
        40.49488488264182,
        40.50775027140776,
        40.520615660173696,
        40.533481048939635,
        40.54634643770557,
        40.55921182647151,
        40.57207721523745,
        40.58494260400338,
        40.59780799276932,
        40.61067338153526,
        40.623538770301195,
        40.63640415906713,
        40.64926954783307,
        40.66213493659901,
        40.67500032536494,
        40.68786571413088,
        40.70073110289682,
        40.713596491662756,
        40.726461880428694,
        40.73932726919463,
        40.75219265796057,
        40.7650580467265,
        40.77792343549244,
        40.79078882425838,
        40.803654213024316,
        40.816519601790255,
        40.82938499055619,
        40.84225037932213,
        40.85511576808806,
        40.867981156854,
        40.88084654561994,
        40.89371193438588,
        40.906577323151815,
        40.91944271191775,
        40.93230810068369,
        40.94517348944962,
        40.95803887821556,
        40.9709042669815,
        40.98376965574744,
        40.996635044513376,
        41.009500433279314,
        41.02236582204525,
        41.03523121081119,
        41.04809659957712,
        41.06096198834306,
        41.073827377109,
        41.086692765874936,
        41.099558154640874,
        41.11242354340681,
        41.12528893217275,
        41.13815432093868,
        41.15101970970462,
        41.16388509847056,
        41.1767504872365,
        41.189615876002435,
        41.20248126476837,
        41.21534665353431,
        41.22821204230024,
        41.24107743106618,
        41.25394281983212,
        41.26680820859806,
        41.279673597363995,
        41.292538986129934,
        41.30540437489587,
        41.3182697636618,
        41.33113515242774,
        41.34400054119368,
        41.35686592995962,
        41.369731318725556,
        41.382596707491494,
        41.39546209625743,
        41.408327485023364,
        41.4211928737893,
        41.43405826255524,
        41.44692365132118,
        41.45978904008712,
        41.472654428853055,
        41.48551981761899,
        41.498385206384924,
        41.51125059515086,
        41.5241159839168,
        41.53698137268274,
        41.54984676144868,
        41.562712150214615,
        41.57557753898055,
        41.588442927746485,
        41.60130831651242,
        41.61417370527836,
        41.6270390940443,
        41.63990448281024,
        41.652769871576176,
        41.665635260342114,
        41.67850064910805,
        41.69136603787398,
        41.70423142663992,
        41.71709681540586,
        41.7299622041718,
        41.742827592937736,
        41.755692981703675,
        41.76855837046961,
        41.781423759235544,
        41.79428914800148,
        41.80715453676742,
        41.82001992553336,
        41.8328853142993,
        41.845750703065235,
        41.85861609183117,
        41.871481480597105,
        41.88434686936304,
        41.89721225812898,
        41.91007764689492,
        41.92294303566086,
        41.935808424426796,
        41.948673813192734,
        41.961539201958665,
        41.9744045907246,
        41.98726997949054,
        42.00013536825648,
        42.01300075702242,
        42.025866145788356,
        42.038731534554294,
        42.051596923320226,
        42.064462312086164,
        42.0773277008521,
        42.09019308961804,
        42.10305847838398,
        42.11592386714992,
        42.128789255915855,
        42.141654644681786,
        42.154520033447724,
        42.16738542221366,
        42.1802508109796,
        42.19311619974554,
        42.20598158851148,
        42.218846977277416,
        42.23171236604335,
        42.244577754809285,
        42.25744314357522,
        42.27030853234116,
        42.2831739211071,
        42.29603930987304,
        42.308904698638976,
        42.321770087404914,
        42.334635476170845,
        42.347500864936784,
        42.36036625370272,
        42.37323164246866,
        42.3860970312346,
        42.39896242000054,
        42.411827808766475,
        42.424693197532406,
        42.437558586298344,
        42.45042397506428,
        42.46328936383022,
        42.47615475259616,
        42.4890201413621,
        42.501885530128035,
        42.51475091889397,
        42.527616307659905,
        42.54048169642584,
        42.55334708519178,
        42.56621247395772,
        42.57907786272366,
        42.591943251489596,
        42.60480864025553,
        42.617674029021465,
        42.6305394177874,
        42.64340480655334,
        42.65627019531928,
        42.66913558408522,
        42.68200097285116,
        42.69486636161709,
        42.707731750383026,
        42.720597139148964,
        42.7334625279149,
        42.74632791668084,
        42.75919330544678,
        42.77205869421272,
        42.78492408297865,
        42.797789471744586,
        42.810654860510525,
        42.82352024927646,
        42.8363856380424,
        42.84925102680834,
        42.86211641557428,
        42.87498180434021,
        42.88784719310615,
        42.900712581872085,
        42.91357797063802,
        42.92644335940396,
        42.9393087481699,
        42.95217413693584,
        42.96503952570177,
        42.97790491446771,
        42.990770303233646,
        43.003635691999584,
        43.01650108076552,
        43.02936646953146,
        43.0422318582974,
        43.05509724706334,
        43.06796263582927,
        43.080828024595206,
        43.093693413361144,
        43.10655880212708,
        43.11942419089302,
        43.13228957965896,
        43.1451549684249,
        43.15802035719083,
        43.17088574595677,
        43.183751134722705,
        43.19661652348864,
        43.20948191225458,
        43.22234730102052,
        43.23521268978646,
        43.24807807855239,
        43.26094346731833,
        43.273808856084266,
        43.286674244850204,
        43.29953963361614,
        43.31240502238208,
        43.32527041114802,
        43.33813579991395,
        43.35100118867989,
        43.363866577445826,
        43.376731966211764,
        43.3895973549777,
        43.40246274374364,
        43.41532813250958,
        43.42819352127551,
        43.44105891004145,
        43.45392429880739,
        43.466789687573325,
        43.47965507633926,
        43.4925204651052,
        43.50538585387114,
        43.51825124263707,
        43.53111663140301,
        43.54398202016895,
        43.556847408934885,
        43.569712797700824,
        43.58257818646676,
        43.5954435752327,
        43.60830896399863,
        43.62117435276457,
        43.63403974153051,
        43.646905130296446,
        43.659770519062384,
        43.67263590782832,
        43.68550129659426,
        43.6983666853602,
        43.71123207412613,
        43.72409746289207,
        43.73696285165801,
        43.749828240423945,
        43.76269362918988,
        43.77555901795582,
        43.78842440672176,
        43.80128979548769,
        43.81415518425363,
        43.82702057301957,
        43.839885961785505,
        43.85275135055144,
        43.86561673931738,
        43.87848212808332,
        43.89134751684925,
        43.90421290561519,
        43.91707829438113,
        43.929943683147066,
        43.942809071913004,
        43.95567446067894,
        43.96853984944488,
        43.98140523821081,
        43.99427062697675,
        44.00713601574269,
        44.020001404508626,
        44.032866793274565,
        44.0457321820405,
        44.05859757080644,
        44.07146295957237,
        44.08432834833831,
        44.09719373710425,
        44.11005912587019,
        44.122924514636125,
        44.13578990340206,
        44.148655292168,
        44.16152068093393,
        44.17438606969987,
        44.18725145846581,
        44.20011684723175,
        44.212982235997686,
        44.225847624763624,
        44.23871301352956,
        44.25157840229549,
        44.26444379106143,
        44.27730917982737,
        44.29017456859331,
        44.303039957359246,
        44.315905346125184,
        44.32877073489112,
        44.34163612365706,
        44.35450151242299,
        44.36736690118893,
        44.38023228995487,
        44.39309767872081,
        44.405963067486745,
        44.41882845625268,
        44.43169384501862,
        44.44455923378455,
        44.45742462255049,
        44.47029001131643,
        44.48315540008237,
        44.496020788848305,
        44.508886177614244,
        44.52175156638018,
        44.53461695514611,
        44.54748234391205,
        44.56034773267799,
        44.57321312144393,
        44.586078510209866,
        44.598943898975804,
        44.61180928774174,
        44.624674676507674,
        44.63754006527361,
        44.65040545403955,
        44.66327084280549,
        44.67613623157143,
        44.689001620337365,
        44.7018670091033,
        44.714732397869234,
        44.72759778663517,
        44.74046317540111,
        44.75332856416705,
        44.76619395293299,
        44.779059341698925,
        44.791924730464864,
        44.804790119230795,
        44.81765550799673,
        44.83052089676267,
        44.84338628552861,
        44.85625167429455,
        44.869117063060486,
        44.881982451826424,
        44.894847840592355,
        44.90771322935829,
        44.92057861812423,
        44.93344400689017,
        44.94630939565611,
        44.959174784422046,
        44.972040173187985,
        44.984905561953916,
        44.997770950719854,
        45.01063633948579,
        45.02350172825173,
        45.03636711701767,
        45.04923250578361,
        45.062097894549545,
        45.07496328331548,
        45.087828672081415,
        45.10069406084735,
        45.11355944961329,
        45.12642483837923,
        45.13929022714517,
        45.152155615911106,
        45.165021004677044,
        45.177886393442975,
        45.19075178220891,
        45.20361717097485,
        45.21648255974079,
        45.22934794850673,
        45.242213337272666,
        45.255078726038604,
        45.267944114804536,
        45.280809503570474,
        45.29367489233641,
        45.30654028110235,
        45.31940566986829,
        45.33227105863423,
        45.345136447400165,
        45.358001836166096,
        45.370867224932034,
        45.38373261369797,
        45.39659800246391,
        45.40946339122985,
        45.42232877999579,
        45.435194168761726,
        45.44805955752766,
        45.460924946293595,
        45.47379033505953,
        45.48665572382547,
        45.49952111259141,
        45.51238650135735,
        45.525251890123286,
        45.53811727888922,
        45.550982667655155,
        45.563848056421094,
        45.57671344518703,
        45.58957883395297,
        45.60244422271891,
        45.61530961148485,
        45.62817500025078,
        45.641040389016716,
        45.653905777782654,
        45.66677116654859,
        45.67963655531453,
        45.69250194408047,
        45.70536733284641,
        45.718232721612345,
        45.73109811037828,
        45.743963499144215,
        45.75682888791015,
        45.76969427667609,
        45.78255966544203,
        45.79542505420797,
        45.808290442973906,
        45.82115583173984,
        45.834021220505775,
        45.846886609271714,
        45.85975199803765,
        45.87261738680359,
        45.88548277556953,
        45.89834816433547,
        45.9112135531014,
        45.924078941867336,
        45.936944330633274,
        45.94980971939921,
        45.96267510816515,
        45.97554049693109,
        45.98840588569703,
        46.00127127446296,
        46.014136663228896,
        46.027002051994835,
        46.03986744076077,
        46.05273282952671,
        46.06559821829265,
        46.07846360705859,
        46.09132899582452,
        46.10419438459046,
        46.117059773356395,
        46.12992516212233,
        46.14279055088827,
        46.15565593965421,
        46.16852132842015,
        46.18138671718608,
        46.19425210595202,
        46.207117494717956,
        46.219982883483894,
        46.23284827224983,
        46.24571366101577,
        46.25857904978171,
        46.27144443854764,
        46.28430982731358,
        46.297175216079516,
        46.310040604845454,
        46.32290599361139,
        46.33577138237733,
        46.34863677114327,
        46.36150215990921,
        46.37436754867514,
        46.38723293744108,
        46.400098326207015,
        46.41296371497295,
        46.42582910373889,
        46.43869449250483,
        46.45155988127077,
        46.4644252700367,
        46.47729065880264,
        46.490156047568576,
        46.503021436334514,
        46.51588682510045,
        46.52875221386639,
        46.54161760263233,
        46.55448299139826,
        46.5673483801642,
        46.580213768930136,
        46.593079157696074,
        46.60594454646201,
        46.61880993522795,
        46.63167532399389,
        46.64454071275982,
        46.65740610152576,
        46.6702714902917,
        46.683136879057635,
        46.69600226782357,
        46.70886765658951,
        46.72173304535545,
        46.73459843412138,
        46.74746382288732,
        46.76032921165326,
        46.773194600419195,
        46.786059989185134,
        46.79892537795107,
        46.81179076671701,
        46.82465615548294,
        46.83752154424888,
        46.85038693301482,
        46.863252321780756,
        46.876117710546694,
        46.88898309931263,
        46.90184848807857,
        46.9147138768445,
        46.92757926561044,
        46.94044465437638,
        46.95331004314232,
        46.966175431908255,
        46.97904082067419,
        46.99190620944013,
        47.00477159820606,
        47.017636986972,
        47.03050237573794,
        47.04336776450388,
        47.056233153269815,
        47.06909854203575,
        47.08196393080169,
        47.09482931956763,
        47.10769470833356,
        47.1205600970995,
        47.13342548586544,
        47.146290874631376,
        47.159156263397314,
        47.17202165216325,
        47.18488704092919,
        47.19775242969512,
        47.21061781846106,
        47.223483207227,
        47.236348595992936,
        47.249213984758875,
        47.26207937352481,
        47.27494476229075,
        47.28781015105668,
        47.30067553982262,
        47.31354092858856,
        47.3264063173545,
        47.339271706120435,
        47.35213709488637,
        47.36500248365231,
        47.37786787241824,
        47.39073326118418,
        47.40359864995012,
        47.41646403871606,
        47.429329427481996,
        47.442194816247934,
        47.45506020501387,
        47.4679255937798,
        47.48079098254574,
        47.49365637131168,
        47.50652176007762,
        47.519387148843556,
        47.532252537609494,
        47.54511792637543,
        47.557983315141364,
        47.5708487039073,
        47.58371409267324,
        47.59657948143918,
        47.60944487020512,
        47.622310258971055,
        47.63517564773699,
        47.648041036502924
    ],
    LACROSSE: []
};
const $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_30B = {
    PLATFORM_TENNIS: [],
    TENNIS: [],
    PADEL: [],
    PICKLEBALL: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.007529977401443677,
        0.02050729085351355,
        0.0334846043055832,
        0.04646191775765307,
        0.05943923120972272,
        0.07241654466179237,
        0.08539385811386224,
        0.09837117156593189,
        0.11134848501800176,
        0.12432579847007141,
        0.13730311192214106,
        0.15028042537421094,
        0.16325773882628059,
        0.17623505227835046,
        0.1892123657304201,
        0.20218967918248976,
        0.21516699263455963,
        0.22814430608662928,
        0.24112161953869915,
        0.2540989329907688,
        0.26707624644283845,
        0.2800535598949083,
        0.29303087334697797,
        0.30600818679904784,
        0.3189855002511175,
        0.33196281370318714,
        0.344940127155257,
        0.35791744060732666,
        0.37089475405939654,
        0.3838720675114662,
        0.39684938096353584,
        0.4098266944156057,
        0.42280400786767536,
        0.43578132131974523,
        0.4487586347718149,
        0.46173594822388453,
        0.4747132616759544,
        0.48769057512802405,
        0.5006678885800939,
        0.5136452020321636,
        0.5266225154842332,
        0.5395998289363031,
        0.5525771423883727,
        0.5655544558404426,
        0.5785317692925123,
        0.5915090827445819,
        0.6044863961966516,
        0.6174637096487214,
        0.6304410231007913,
        0.6434183365528607,
        0.6563956500049306,
        0.6693729634570005,
        0.6823502769090704,
        0.6953275903611398,
        0.7083049038132097,
        0.7212822172652795,
        0.734259530717349,
        0.7472368441694188,
        0.7602141576214887,
        0.7731914710735581,
        0.786168784525628,
        0.7991460979776979,
        0.8121234114297677,
        0.8251007248818372,
        0.838078038333907,
        0.8510553517859769,
        0.8640326652380463,
        0.8770099786901162,
        0.8899872921421861,
        0.9029646055942555,
        0.9159419190463254,
        0.9289192324983953,
        0.9418965459504651,
        0.9548738594025346,
        0.9678511728546044,
        0.9808284863066743,
        0.9938057997587437,
        1.0067831132108136,
        1.0197604266628835,
        1.032737740114953,
        1.0457150535670228,
        1.0586923670190926,
        1.0716696804711625,
        1.084646993923232,
        1.0976243073753018,
        1.1106016208273717,
        1.123578934279441,
        1.136556247731511,
        1.1495335611835809,
        1.1625108746356503,
        1.1754881880877202,
        1.18846550153979,
        1.20144281499186,
        1.2144201284439293,
        1.2273974418959992,
        1.240374755348069,
        1.2533520688001385,
        1.2663293822522084,
        1.2793066957042782,
        1.2922840091563477,
        1.3052613226084175,
        1.3182386360604874,
        1.3312159495125573,
        1.3441932629646267,
        1.3571705764166966,
        1.3701478898687665,
        1.3831252033208359,
        1.3961025167729058,
        1.4090798302249756,
        1.422057143677045,
        1.435034457129115,
        1.4480117705811848,
        1.4609890840332547,
        1.473966397485324,
        1.486943710937394,
        1.4999210243894638,
        1.5128983378415333,
        1.5258756512936031,
        1.538852964745673,
        1.5518302781977424,
        1.5648075916498123,
        1.5777849051018822,
        1.590762218553952,
        1.6037395320060215,
        1.6167168454580914,
        1.6296941589101612,
        1.6426714723622307,
        1.6556487858143005,
        1.6686260992663704,
        1.6816034127184398,
        1.6945807261705097,
        1.7075580396225796,
        1.7205353530746494,
        1.7335126665267189,
        1.7464899799787887,
        1.7594672934308586,
        1.772444606882928,
        1.785421920334998,
        1.7983992337870678,
        1.8113765472391372,
        1.824353860691207,
        1.837331174143277,
        1.8503084875953468,
        1.8632858010474163,
        1.8762631144994861,
        1.889240427951556,
        1.9022177414036254,
        1.9151950548556953,
        1.9281723683077652,
        1.9411496817598346,
        1.9541269952119045,
        1.9671043086639743,
        1.9800816221160438,
        1.9930589355681136,
        2.0060362490201835,
        2.0190135624722534,
        2.031990875924323,
        2.0449681893763927,
        2.0579455028284626,
        2.070922816280532,
        2.083900129732602,
        2.0968774431846717,
        2.109854756636741,
        2.122832070088811,
        2.135809383540881,
        2.1487866969929508,
        2.16176401044502,
        2.17474132389709,
        2.18771863734916,
        2.2006959508012294,
        2.2136732642532992,
        2.226650577705369,
        2.2396278911574385,
        2.2526052046095084,
        2.2655825180615783,
        2.278559831513648,
        2.2915371449657176,
        2.3045144584177875,
        2.3174917718698573,
        2.3304690853219268,
        2.3434463987739966,
        2.3564237122260665,
        2.369401025678136,
        2.382378339130206,
        2.3953556525822757,
        2.4083329660343455,
        2.421310279486415,
        2.434287592938485,
        2.4472649063905547,
        2.460242219842624,
        2.473219533294694,
        2.486196846746764,
        2.4991741601988333,
        2.512151473650903,
        2.525128787102973,
        2.538106100555043,
        2.5510834140071124,
        2.5640607274591822,
        2.577038040911252,
        2.5900153543633215,
        2.602992667815392,
        2.615969981267461,
        2.6289472947195307,
        2.6419246081716006,
        2.6549019216236704,
        2.6678792350757403,
        2.68085654852781,
        2.693833861979879,
        2.706811175431949,
        2.719788488884019,
        2.732765802336089,
        2.7457431157881587,
        2.7587204292402285,
        2.7716977426922984,
        2.7846750561443674,
        2.7976523695964373,
        2.810629683048507,
        2.823606996500577,
        2.836584309952647,
        2.8495616234047167,
        2.8625389368567866,
        2.8755162503088556,
        2.8884935637609255,
        2.9014708772129953,
        2.914448190665065,
        2.927425504117135,
        2.940402817569205,
        2.953380131021274,
        2.966357444473344,
        2.9793347579254137,
        2.9923120713774836,
        3.0052893848295534,
        3.0182666982816233,
        3.031244011733693,
        3.044221325185762,
        3.057198638637832,
        3.070175952089902,
        3.0831532655419718,
        3.0961305789940416,
        3.1091078924461115,
        3.1220852058981814,
        3.1350625193502504,
        3.1480398328023202,
        3.16101714625439,
        3.17399445970646,
        3.18697177315853,
        3.1999490866105997,
        3.2129264000626687,
        3.2259037135147386,
        3.2388810269668085,
        3.2518583404188783,
        3.264835653870948,
        3.277812967323018,
        3.290790280775088,
        3.303767594227157,
        3.316744907679227,
        3.3297222211312967,
        3.3426995345833665,
        3.3556768480354364,
        3.3686541614875063,
        3.381631474939576,
        3.394608788391645,
        3.407586101843715,
        3.420563415295785,
        3.4335407287478548,
        3.4465180421999246,
        3.4594953556519945,
        3.4724726691040635,
        3.4854499825561334,
        3.4984272960082032,
        3.511404609460273,
        3.524381922912343,
        3.537359236364413,
        3.5503365498164827,
        3.5633138632685517,
        3.5762911767206216,
        3.5892684901726915,
        3.6022458036247613,
        3.615223117076831,
        3.628200430528901,
        3.64117774398097,
        3.65415505743304,
        3.66713237088511,
        3.6801096843371797,
        3.6930869977892495,
        3.7060643112413194,
        3.7190416246933893,
        3.7320189381454583,
        3.744996251597528,
        3.757973565049598,
        3.770950878501668,
        3.7839281919537378,
        3.7969055054058076,
        3.8098828188578775,
        3.8228601323099465,
        3.8358374457620164,
        3.8488147592140862,
        3.861792072666156,
        3.874769386118226,
        3.887746699570296,
        3.900724013022365,
        3.9137013264744347,
        3.9266786399265046,
        3.9396559533785744,
        3.9526332668306443,
        3.965610580282714,
        3.978587893734784,
        3.991565207186853,
        4.004542520638923,
        4.017519834090993,
        4.030497147543063,
        4.0434744609951325,
        4.056451774447202,
        4.069429087899272,
        4.082406401351341,
        4.095383714803411,
        4.108361028255481,
        4.121338341707551,
        4.134315655159621,
        4.147292968611691,
        4.16027028206376,
        4.1732475955158295,
        4.186224908967899,
        4.199202222419969,
        4.212179535872039,
        4.225156849324109,
        4.238134162776179,
        4.251111476228248,
        4.264088789680318,
        4.2770661031323876,
        4.290043416584457,
        4.303020730036527,
        4.315998043488597,
        4.328975356940667,
        4.341952670392736,
        4.354929983844806,
        4.367907297296876,
        4.380884610748946,
        4.3938619242010155,
        4.406839237653085,
        4.419816551105154,
        4.432793864557224,
        4.445771178009294,
        4.458748491461364,
        4.471725804913434,
        4.484703118365504,
        4.497680431817574,
        4.510657745269643,
        4.5236350587217125,
        4.536612372173782,
        4.549589685625852,
        4.562566999077922,
        4.575544312529992,
        4.588521625982062,
        4.601498939434131,
        4.614476252886201,
        4.6274535663382705,
        4.64043087979034,
        4.65340819324241,
        4.66638550669448,
        4.679362820146549,
        4.692340133598619,
        4.705317447050689,
        4.718294760502759,
        4.731272073954829,
        4.7442493874068985,
        4.757226700858968,
        4.770204014311037,
        4.783181327763107,
        4.796158641215177,
        4.809135954667247,
        4.822113268119317,
        4.835090581571387,
        4.848067895023457,
        4.861045208475526,
        4.874022521927595,
        4.886999835379665,
        4.899977148831735,
        4.912954462283805,
        4.925931775735875,
        4.938909089187944,
        4.951886402640014,
        4.964863716092084,
        4.9778410295441535,
        4.990818342996223,
        5.003795656448293,
        5.016772969900363,
        5.029750283352432,
        5.042727596804502,
        5.055704910256572,
        5.068682223708642,
        5.081659537160712,
        5.0946368506127815,
        5.107614164064851,
        5.12059147751692,
        5.13356879096899,
        5.14654610442106,
        5.15952341787313,
        5.1725007313252,
        5.18547804477727,
        5.198455358229339,
        5.211432671681409,
        5.224409985133478,
        5.237387298585548,
        5.250364612037618,
        5.263341925489688,
        5.276319238941758,
        5.289296552393827,
        5.302273865845897,
        5.315251179297967,
        5.3282284927500365,
        5.341205806202106,
        5.354183119654176,
        5.367160433106245,
        5.380137746558315,
        5.393115060010385,
        5.406092373462455,
        5.419069686914525,
        5.432047000366595,
        5.4450243138186645,
        5.4580016272707335,
        5.470978940722803,
        5.483956254174873,
        5.496933567626943,
        5.509910881079013,
        5.522888194531083,
        5.535865507983153,
        5.548842821435222,
        5.5618201348872915,
        5.574797448339361,
        5.587774761791431,
        5.600752075243501,
        5.613729388695571,
        5.62670670214764,
        5.63968401559971,
        5.65266132905178,
        5.66563864250385,
        5.6786159559559195,
        5.691593269407989,
        5.704570582860059,
        5.717547896312128,
        5.730525209764198,
        5.743502523216268,
        5.756479836668338,
        5.769457150120408,
        5.782434463572478,
        5.7954117770245475,
        5.8083890904766164,
        5.821366403928686,
        5.834343717380756,
        5.847321030832826,
        5.860298344284896,
        5.873275657736966,
        5.886252971189035,
        5.899230284641105,
        5.9122075980931745,
        5.925184911545244,
        5.938162224997314,
        5.951139538449384,
        5.964116851901454,
        5.977094165353523,
        5.990071478805593,
        6.003048792257663,
        6.016026105709733,
        6.0290034191618025,
        6.041980732613872,
        6.054958046065942,
        6.067935359518011,
        6.080912672970081,
        6.093889986422151,
        6.106867299874221,
        6.119844613326291,
        6.132821926778361,
        6.14579924023043,
        6.158776553682499,
        6.171753867134569,
        6.184731180586639,
        6.197708494038709,
        6.210685807490779,
        6.223663120942849,
        6.236640434394918,
        6.249617747846988,
        6.2625950612990575,
        6.275572374751127,
        6.288549688203197,
        6.301527001655267,
        6.314504315107337,
        6.327481628559406,
        6.340458942011476,
        6.353436255463546,
        6.366413568915616,
        6.3793908823676855,
        6.392368195819755,
        6.405345509271824,
        6.418322822723894,
        6.431300136175964,
        6.444277449628034,
        6.457254763080104,
        6.470232076532174,
        6.483209389984244,
        6.4961867034363125,
        6.509164016888382,
        6.522141330340452,
        6.535118643792522,
        6.548095957244592,
        6.561073270696662,
        6.574050584148732,
        6.587027897600801,
        6.600005211052871,
        6.612982524504941,
        6.62595983795701,
        6.638937151409079,
        6.65191446486115,
        6.664891778313219,
        6.67786909176529,
        6.690846405217359,
        6.70382371866943,
        6.716801032121499,
        6.729778345573568,
        6.742755659025638,
        6.755732972477707,
        6.768710285929778,
        6.781687599381847,
        6.794664912833916,
        6.807642226285987,
        6.820619539738056,
        6.8335968531901266,
        6.8465741666421955,
        6.859551480094266,
        6.872528793546335,
        6.885506106998404,
        6.898483420450475,
        6.911460733902544,
        6.924438047354615,
        6.937415360806684,
        6.9503926742587545,
        6.9633699877108235,
        6.9763473011628925,
        6.989324614614963,
        7.002301928067032,
        7.015279241519103,
        7.028256554971172,
        7.041233868423243,
        7.054211181875312,
        7.067188495327381,
        7.0801658087794515,
        7.09314312223152,
        7.106120435683591,
        7.11909774913566,
        7.132075062587731,
        7.1450523760398,
        7.158029689491869,
        7.17100700294394,
        7.183984316396009,
        7.196961629848079,
        7.209938943300148,
        7.222916256752217,
        7.235893570204288,
        7.248870883656357,
        7.261848197108428,
        7.274825510560497,
        7.287802824012568,
        7.300780137464637,
        7.313757450916706,
        7.326734764368776,
        7.339712077820845,
        7.352689391272916,
        7.365666704724985,
        7.378644018177056,
        7.391621331629125,
        7.404598645081194,
        7.417575958533265,
        7.4305532719853336,
        7.443530585437404,
        7.456507898889473,
        7.469485212341544,
        7.482462525793613,
        7.495439839245682,
        7.508417152697753,
        7.521394466149822,
        7.5343717796018925,
        7.5473490930539615,
        7.560326406506032,
        7.573303719958101,
        7.58628103341017,
        7.599258346862241,
        7.61223566031431,
        7.625212973766381,
        7.63819028721845,
        7.6511676006705205,
        7.6641449141225895,
        7.6771222275746585,
        7.690099541026729,
        7.703076854478798,
        7.716054167930869,
        7.729031481382938,
        7.742008794835007,
        7.754986108287078,
        7.767963421739147,
        7.780940735191217,
        7.793918048643286,
        7.806895362095357,
        7.819872675547426,
        7.832849988999495,
        7.845827302451566,
        7.858804615903635,
        7.871781929355706,
        7.884759242807775,
        7.897736556259845,
        7.910713869711914,
        7.923691183163983,
        7.936668496616054,
        7.949645810068123,
        7.962623123520194,
        7.975600436972263,
        7.988577750424334,
        8.001555063876403,
        8.014532377328472,
        8.027509690780542,
        8.040487004232611,
        8.053464317684682,
        8.066441631136751,
        8.079418944588822,
        8.09239625804089,
        8.10537357149296,
        8.11835088494503,
        8.1313281983971,
        8.14430551184917,
        8.15728282530124,
        8.17026013875331,
        8.183237452205379,
        8.196214765657448,
        8.209192079109519,
        8.222169392561588,
        8.235146706013659,
        8.248124019465727,
        8.261101332917796,
        8.274078646369867,
        8.287055959821936,
        8.300033273274007,
        8.313010586726076,
        8.325987900178147,
        8.338965213630216,
        8.351942527082285,
        8.364919840534355,
        8.377897153986424,
        8.390874467438495,
        8.403851780890564,
        8.416829094342635,
        8.429806407794704,
        8.442783721246773,
        8.455761034698844,
        8.468738348150913,
        8.481715661602983,
        8.494692975055052,
        8.507670288507123,
        8.520647601959192,
        8.533624915411261,
        8.546602228863332,
        8.5595795423154,
        8.572556855767472,
        8.58553416921954,
        8.598511482671611,
        8.61148879612368,
        8.62446610957575,
        8.63744342302782,
        8.650420736479889,
        8.66339804993196,
        8.676375363384029,
        8.689352676836098,
        8.702329990288169,
        8.715307303740238,
        8.728284617192308,
        8.741261930644377,
        8.754239244096448,
        8.767216557548517,
        8.780193871000586,
        8.793171184452657,
        8.806148497904726,
        8.819125811356797,
        8.832103124808866,
        8.845080438260936,
        8.858057751713005,
        8.871035065165074,
        8.884012378617145,
        8.896989692069214,
        8.909967005521285,
        8.922944318973354,
        8.935921632425424,
        8.948898945877493,
        8.961876259329562,
        8.974853572781633,
        8.987830886233702,
        9.000808199685773,
        9.013785513137842,
        9.026762826589913,
        9.039740140041982,
        9.05271745349405,
        9.065694766946121,
        9.07867208039819,
        9.091649393850261,
        9.10462670730233,
        9.117604020754401,
        9.13058133420647,
        9.143558647658539,
        9.15653596111061,
        9.169513274562679,
        9.18249058801475,
        9.195467901466818,
        9.208445214918887,
        9.221422528370958,
        9.234399841823027,
        9.247377155275098,
        9.260354468727167,
        9.273331782179238,
        9.286309095631307,
        9.299286409083376,
        9.312263722535446,
        9.325241035987515,
        9.338218349439586,
        9.351195662891655,
        9.364172976343726,
        9.377150289795795,
        9.390127603247864,
        9.403104916699935,
        9.416082230152004,
        9.429059543604074,
        9.442036857056143,
        9.455014170508214,
        9.467991483960283,
        9.480968797412352,
        9.493946110864423,
        9.506923424316492,
        9.519900737768562,
        9.532878051220631,
        9.545855364672702,
        9.558832678124771,
        9.57180999157684,
        9.584787305028911,
        9.59776461848098,
        9.61074193193305,
        9.62371924538512,
        9.63669655883719,
        9.64967387228926,
        9.662651185741328,
        9.6756284991934,
        9.688605812645468,
        9.701583126097539,
        9.714560439549608,
        9.727537753001677,
        9.740515066453748,
        9.753492379905817,
        9.766469693357887,
        9.779447006809956,
        9.792424320262027,
        9.805401633714096,
        9.818378947166165,
        9.831356260618236,
        9.844333574070305,
        9.857310887522376,
        9.870288200974445,
        9.883265514426515,
        9.896242827878584,
        9.909220141330653,
        9.922197454782724,
        9.935174768234793,
        9.948152081686864,
        9.961129395138933,
        9.974106708591004,
        9.987084022043073,
        10.000061335495142,
        10.013038648947212,
        10.026015962399281,
        10.038993275851352,
        10.051970589303421,
        10.064947902755492,
        10.07792521620756,
        10.09090252965963,
        10.1038798431117,
        10.11685715656377,
        10.12983447001584,
        10.14281178346791,
        10.15578909691998,
        10.168766410372049,
        10.181743723824118,
        10.194721037276189,
        10.207698350728258,
        10.220675664180328,
        10.233652977632397,
        10.246630291084466,
        10.259607604536537,
        10.272584917988606,
        10.285562231440677,
        10.298539544892746,
        10.311516858344817,
        10.324494171796886,
        10.337471485248955,
        10.350448798701025,
        10.363426112153094,
        10.376403425605165,
        10.389380739057234,
        10.402358052509305,
        10.415335365961374,
        10.428312679413443,
        10.441289992865514,
        10.454267306317583,
        10.467244619769653,
        10.480221933221722,
        10.493199246673793,
        10.506176560125862,
        10.519153873577931,
        10.532131187030002,
        10.54510850048207,
        10.558085813934142,
        10.57106312738621,
        10.584040440838281,
        10.59701775429035,
        10.60999506774242,
        10.62297238119449,
        10.635949694646559,
        10.64892700809863,
        10.661904321550699,
        10.674881635002768,
        10.687858948454839,
        10.700836261906908,
        10.713813575358978,
        10.726790888811047,
        10.739768202263118,
        10.752745515715187,
        10.765722829167256,
        10.778700142619327,
        10.791677456071396,
        10.804654769523466,
        10.817632082975535,
        10.830609396427606,
        10.843586709879675,
        10.856564023331744,
        10.869541336783815,
        10.882518650235884,
        10.895495963687955,
        10.908473277140024,
        10.921450590592094,
        10.934427904044163,
        10.947405217496232,
        10.960382530948303,
        10.973359844400372,
        10.986337157852443,
        10.999314471304512,
        11.012291784756583,
        11.025269098208652,
        11.03824641166072,
        11.051223725112791,
        11.06420103856486,
        11.077178352016931,
        11.090155665469,
        11.10313297892107,
        11.11611029237314,
        11.129087605825209,
        11.14206491927728,
        11.155042232729349,
        11.16801954618142,
        11.180996859633488,
        11.193974173085557,
        11.206951486537628,
        11.219928799989697,
        11.232906113441768,
        11.245883426893837,
        11.258860740345908,
        11.271838053797977,
        11.284815367250046,
        11.297792680702116,
        11.310769994154185,
        11.323747307606256,
        11.336724621058325,
        11.349701934510396,
        11.362679247962465,
        11.375656561414534,
        11.388633874866605,
        11.401611188318673,
        11.414588501770744,
        11.427565815222813,
        11.440543128674884,
        11.453520442126953,
        11.466497755579022,
        11.479475069031093,
        11.492452382483162,
        11.505429695935232,
        11.518407009387301,
        11.531384322839372,
        11.544361636291441,
        11.55733894974351,
        11.570316263195581,
        11.58329357664765,
        11.59627089009972,
        11.60924820355179,
        11.62222551700386,
        11.63520283045593,
        11.648180143907998,
        11.66115745736007,
        11.674134770812138,
        11.687112084264209,
        11.700089397716278,
        11.713066711168347,
        11.726044024620418,
        11.739021338072487,
        11.751998651524557,
        11.764975964976626,
        11.777953278428697,
        11.790930591880766,
        11.803907905332835,
        11.816885218784906,
        11.829862532236975,
        11.842839845689046,
        11.855817159141115,
        11.868794472593185,
        11.881771786045254,
        11.894749099497323,
        11.907726412949394,
        11.920703726401463,
        11.933681039853534,
        11.946658353305603,
        11.959635666757674,
        11.972612980209743,
        11.985590293661812,
        11.998567607113882,
        12.011544920565951,
        12.024522234018022,
        12.037499547470091,
        12.050476860922162,
        12.06345417437423,
        12.0764314878263,
        12.08940880127837,
        12.10238611473044,
        12.11536342818251,
        12.12834074163458,
        12.141318055086648,
        12.154295368538719,
        12.167272681990788,
        12.180249995442859,
        12.193227308894928,
        12.206204622346998,
        12.219181935799067,
        12.232159249251136,
        12.245136562703207,
        12.258113876155276,
        12.271091189607347,
        12.284068503059416,
        12.297045816511487,
        12.310023129963556,
        12.323000443415625,
        12.335977756867695,
        12.348955070319764,
        12.361932383771835,
        12.374909697223904,
        12.387887010675975,
        12.400864324128044,
        12.413841637580113,
        12.426818951032184,
        12.439796264484253,
        12.452773577936323,
        12.465750891388392,
        12.478728204840463,
        12.491705518292532,
        12.504682831744601,
        12.517660145196672,
        12.53063745864874,
        12.543614772100812,
        12.55659208555288,
        12.569569399004951,
        12.58254671245702,
        12.59552402590909,
        12.60850133936116,
        12.621478652813229,
        12.6344559662653,
        12.647433279717369,
        12.660410593169438,
        12.673387906621508,
        12.686365220073577,
        12.699342533525648,
        12.712319846977717,
        12.725297160429788,
        12.738274473881857,
        12.751251787333926,
        12.764229100785997,
        12.777206414238066,
        12.790183727690136,
        12.803161041142205,
        12.816138354594276,
        12.829115668046345,
        12.842092981498414,
        12.855070294950485,
        12.868047608402554,
        12.881024921854625,
        12.894002235306694,
        12.906979548758764,
        12.919956862210833,
        12.932934175662902,
        12.945911489114973,
        12.958888802567042,
        12.971866116019113,
        12.984843429471182,
        12.997820742923253,
        13.010798056375322,
        13.02377536982739,
        13.036752683279461,
        13.04972999673153,
        13.062707310183601,
        13.07568462363567,
        13.08866193708774,
        13.10163925053981,
        13.114616563991879,
        13.12759387744395,
        13.140571190896019,
        13.15354850434809,
        13.166525817800158,
        13.179503131252227,
        13.192480444704298,
        13.205457758156367,
        13.218435071608438,
        13.231412385060507,
        13.244389698512578,
        13.257367011964647,
        13.270344325416715,
        13.283321638868786,
        13.296298952320855,
        13.309276265772926,
        13.322253579224995,
        13.335230892677066,
        13.348208206129135,
        13.361185519581204,
        13.374162833033274,
        13.387140146485343,
        13.400117459937414,
        13.413094773389483,
        13.426072086841554,
        13.439049400293623,
        13.452026713745692,
        13.465004027197763,
        13.477981340649832,
        13.490958654101902,
        13.503935967553971,
        13.516913281006042,
        13.529890594458111,
        13.54286790791018,
        13.555845221362251,
        13.56882253481432,
        13.58179984826639,
        13.59477716171846,
        13.607754475170529,
        13.6207317886226,
        13.633709102074668,
        13.646686415526739,
        13.659663728978808,
        13.672641042430879,
        13.685618355882948,
        13.698595669335017,
        13.711572982787088,
        13.724550296239157,
        13.737527609691227,
        13.750504923143296,
        13.763482236595367,
        13.776459550047436,
        13.789436863499505,
        13.802414176951576,
        13.815391490403645,
        13.828368803855716,
        13.841346117307785,
        13.854323430759855,
        13.867300744211924,
        13.880278057663993,
        13.893255371116064,
        13.906232684568133,
        13.919209998020204,
        13.932187311472273,
        13.945164624924343,
        13.958141938376412,
        13.971119251828481,
        13.984096565280552,
        13.997073878732621,
        14.010051192184692,
        14.023028505636761,
        14.036005819088832,
        14.0489831325409,
        14.06196044599297,
        14.07493775944504,
        14.08791507289711,
        14.10089238634918,
        14.11386969980125,
        14.126847013253318,
        14.139824326705389,
        14.152801640157458,
        14.165778953609529,
        14.178756267061598,
        14.191733580513668,
        14.204710893965737,
        14.217688207417806,
        14.230665520869877,
        14.243642834321946,
        14.256620147774017,
        14.269597461226086,
        14.282574774678157,
        14.295552088130226,
        14.308529401582295,
        14.321506715034365,
        14.334484028486434,
        14.347461341938505,
        14.360438655390574,
        14.373415968842645,
        14.386393282294714,
        14.399370595746783,
        14.412347909198854,
        14.425325222650923,
        14.438302536102993,
        14.451279849555062,
        14.464257163007133,
        14.477234476459202,
        14.490211789911271,
        14.503189103363342,
        14.51616641681541,
        14.529143730267482,
        14.54212104371955,
        14.555098357171621,
        14.56807567062369,
        14.58105298407576,
        14.59403029752783,
        14.607007610979899,
        14.619984924431968,
        14.63296223788404,
        14.64593955133611,
        14.658916864788178,
        14.671894178240247,
        14.684871491692316,
        14.697848805144389,
        14.710826118596458,
        14.723803432048527,
        14.736780745500596,
        14.749758058952665,
        14.762735372404737,
        14.775712685856806,
        14.788689999308875,
        14.801667312760944,
        14.814644626213017,
        14.827621939665086,
        14.840599253117155,
        14.853576566569224,
        14.866553880021293,
        14.879531193473365,
        14.892508506925434,
        14.905485820377503,
        14.918463133829572,
        14.931440447281641,
        14.944417760733714,
        14.957395074185783,
        14.970372387637852,
        14.98334970108992,
        14.99632701454199,
        15.009304327994062,
        15.022281641446131,
        15.0352589548982,
        15.04823626835027,
        15.061213581802342,
        15.07419089525441,
        15.08716820870648,
        15.100145522158549,
        15.113122835610618,
        15.12610014906269,
        15.13907746251476,
        15.152054775966828,
        15.165032089418897,
        15.178009402870966,
        15.190986716323039,
        15.203964029775108,
        15.216941343227177,
        15.229918656679246,
        15.242895970131318,
        15.255873283583387,
        15.268850597035456,
        15.281827910487525,
        15.294805223939594,
        15.307782537391667,
        15.320759850843736,
        15.333737164295805,
        15.346714477747874,
        15.359691791199943,
        15.372669104652015,
        15.385646418104084,
        15.398623731556153,
        15.411601045008222,
        15.424578358460291,
        15.437555671912364,
        15.450532985364433,
        15.463510298816502,
        15.47648761226857,
        15.489464925720643,
        15.502442239172712,
        15.515419552624781,
        15.52839686607685,
        15.541374179528919,
        15.554351492980992,
        15.56732880643306,
        15.58030611988513,
        15.593283433337199,
        15.606260746789268,
        15.61923806024134,
        15.632215373693409,
        15.645192687145478,
        15.658170000597547,
        15.67114731404962,
        15.684124627501689,
        15.697101940953758,
        15.710079254405827,
        15.723056567857896,
        15.736033881309968,
        15.749011194762037,
        15.761988508214106,
        15.774965821666175,
        15.787943135118244,
        15.800920448570317,
        15.813897762022386,
        15.826875075474454,
        15.839852388926523,
        15.852829702378592,
        15.865807015830665,
        15.878784329282734,
        15.891761642734803,
        15.904738956186872,
        15.917716269638944,
        15.930693583091013,
        15.943670896543082,
        15.956648209995151,
        15.96962552344722,
        15.982602836899293,
        15.995580150351362,
        16.00855746380343,
        16.0215347772555,
        16.03451209070757,
        16.04748940415964,
        16.06046671761171,
        16.07344403106378,
        16.08642134451585,
        16.09939865796792,
        16.11237597141999,
        16.12535328487206,
        16.138330598324128,
        16.151307911776197,
        16.16428522522827,
        16.17726253868034,
        16.190239852132407,
        16.203217165584476,
        16.216194479036545,
        16.229171792488618,
        16.242149105940687,
        16.255126419392756,
        16.268103732844825,
        16.281081046296897,
        16.294058359748966,
        16.307035673201035,
        16.320012986653104,
        16.332990300105173,
        16.345967613557246,
        16.358944927009315,
        16.371922240461384,
        16.384899553913453,
        16.39787686736552,
        16.410854180817594,
        16.423831494269663,
        16.436808807721732,
        16.4497861211738,
        16.46276343462587,
        16.475740748077943,
        16.48871806153001,
        16.50169537498208,
        16.51467268843415,
        16.527650001886222,
        16.54062731533829,
        16.55360462879036,
        16.56658194224243,
        16.579559255694498,
        16.59253656914657,
        16.60551388259864,
        16.61849119605071,
        16.631468509502778,
        16.644445822954847,
        16.65742313640692,
        16.670400449858988,
        16.683377763311057,
        16.696355076763126,
        16.7093323902152,
        16.722309703667268,
        16.735287017119337,
        16.748264330571406,
        16.761241644023475,
        16.774218957475547,
        16.787196270927616,
        16.800173584379685,
        16.813150897831754,
        16.826128211283823,
        16.839105524735896,
        16.852082838187965,
        16.865060151640034,
        16.878037465092103,
        16.89101477854417,
        16.903992091996244,
        16.916969405448313,
        16.929946718900382,
        16.94292403235245,
        16.955901345804524,
        16.968878659256593,
        16.98185597270866,
        16.99483328616073,
        17.0078105996128,
        17.020787913064872,
        17.03376522651694,
        17.04674253996901,
        17.05971985342108,
        17.072697166873148,
        17.08567448032522,
        17.09865179377729,
        17.11162910722936,
        17.124606420681427,
        17.1375837341335,
        17.15056104758557,
        17.163538361037638,
        17.176515674489707,
        17.189492987941776,
        17.20247030139385,
        17.215447614845917,
        17.228424928297986,
        17.241402241750055,
        17.254379555202124,
        17.267356868654197,
        17.280334182106266,
        17.293311495558335,
        17.306288809010404,
        17.319266122462473,
        17.332243435914545,
        17.345220749366614,
        17.358198062818683,
        17.371175376270752,
        17.384152689722825,
        17.397130003174894,
        17.410107316626963,
        17.423084630079032,
        17.4360619435311,
        17.449039256983173,
        17.462016570435242,
        17.47499388388731,
        17.48797119733938,
        17.50094851079145,
        17.513925824243522,
        17.52690313769559,
        17.53988045114766,
        17.55285776459973,
        17.5658350780518,
        17.57881239150387,
        17.59178970495594,
        17.60476701840801,
        17.617744331860077,
        17.63072164531215,
        17.64369895876422,
        17.656676272216288,
        17.669653585668357,
        17.682630899120426,
        17.6956082125725,
        17.708585526024567,
        17.721562839476636,
        17.734540152928705,
        17.747517466380778,
        17.760494779832847,
        17.773472093284916,
        17.786449406736985,
        17.799426720189054,
        17.812404033641126,
        17.825381347093195,
        17.838358660545264,
        17.851335973997333,
        17.864313287449402,
        17.877290600901475,
        17.890267914353544,
        17.903245227805613,
        17.91622254125768,
        17.92919985470975,
        17.942177168161823,
        17.955154481613892,
        17.96813179506596,
        17.98110910851803,
        17.994086421970103,
        18.00706373542217,
        18.02004104887424,
        18.03301836232631,
        18.04599567577838,
        18.05897298923045,
        18.07195030268252,
        18.08492761613459,
        18.097904929586658,
        18.110882243038727,
        18.1238595564908,
        18.13683686994287,
        18.149814183394938,
        18.162791496847007,
        18.17576881029908,
        18.188746123751148,
        18.201723437203217,
        18.214700750655286,
        18.227678064107355,
        18.240655377559428,
        18.253632691011497,
        18.266610004463566,
        18.279587317915635,
        18.292564631367703,
        18.305541944819776,
        18.318519258271845,
        18.331496571723914,
        18.344473885175983,
        18.357451198628052,
        18.370428512080125,
        18.383405825532193,
        18.396383138984262,
        18.40936045243633,
        18.422337765888404,
        18.435315079340473,
        18.448292392792542,
        18.46126970624461,
        18.47424701969668,
        18.487224333148752,
        18.50020164660082,
        18.51317896005289,
        18.52615627350496,
        18.53913358695703,
        18.5521109004091,
        18.56508821386117,
        18.57806552731324,
        18.591042840765308,
        18.60402015421738,
        18.61699746766945,
        18.62997478112152,
        18.642952094573587,
        18.655929408025656,
        18.66890672147773,
        18.681884034929798,
        18.694861348381867,
        18.707838661833936,
        18.720815975286005,
        18.733793288738077,
        18.746770602190146,
        18.759747915642215,
        18.772725229094284,
        18.785702542546353,
        18.798679855998426,
        18.811657169450495,
        18.824634482902564,
        18.837611796354633,
        18.850589109806705,
        18.863566423258774,
        18.876543736710843,
        18.889521050162912,
        18.90249836361498,
        18.915475677067054,
        18.928452990519123,
        18.94143030397119,
        18.95440761742326,
        18.96738493087533,
        18.980362244327402,
        18.99333955777947,
        19.00631687123154,
        19.01929418468361,
        19.03227149813568,
        19.04524881158775,
        19.05822612503982,
        19.07120343849189,
        19.084180751943958,
        19.09715806539603,
        19.1101353788481,
        19.123112692300168,
        19.136090005752237,
        19.149067319204306,
        19.16204463265638,
        19.175021946108448,
        19.187999259560517,
        19.200976573012586,
        19.213953886464658,
        19.226931199916727,
        19.239908513368796,
        19.252885826820865,
        19.265863140272934,
        19.278840453725007,
        19.291817767177076,
        19.304795080629145,
        19.317772394081214,
        19.330749707533283,
        19.343727020985355,
        19.356704334437424,
        19.369681647889493,
        19.382658961341562,
        19.39563627479363,
        19.408613588245704,
        19.421590901697773,
        19.43456821514984,
        19.44754552860191,
        19.460522842053983,
        19.473500155506052,
        19.48647746895812,
        19.49945478241019,
        19.51243209586226,
        19.52540940931433,
        19.5383867227664,
        19.55136403621847,
        19.56434134967054,
        19.577318663122607,
        19.59029597657468,
        19.60327329002675,
        19.616250603478818,
        19.629227916930887,
        19.64220523038296,
        19.65518254383503,
        19.668159857287097,
        19.681137170739166,
        19.694114484191235,
        19.707091797643308,
        19.720069111095377,
        19.733046424547446,
        19.746023737999515,
        19.759001051451584,
        19.771978364903656,
        19.784955678355725,
        19.797932991807794,
        19.810910305259863,
        19.823887618711932,
        19.836864932164005,
        19.849842245616074,
        19.862819559068143,
        19.875796872520212,
        19.888774185972284,
        19.901751499424353,
        19.914728812876422,
        19.92770612632849,
        19.94068343978056,
        19.953660753232633,
        19.966638066684702,
        19.97961538013677,
        19.99259269358884,
        20.00557000704091,
        20.01854732049298,
        20.03152463394505,
        20.04450194739712,
        20.05747926084919,
        20.07045657430126,
        20.08343388775333,
        20.0964112012054,
        20.109388514657468,
        20.122365828109537,
        20.13534314156161,
        20.14832045501368,
        20.161297768465747,
        20.174275081917816,
        20.187252395369885,
        20.200229708821958,
        20.213207022274027,
        20.226184335726096,
        20.239161649178165,
        20.252138962630234,
        20.265116276082306,
        20.278093589534375,
        20.291070902986444,
        20.304048216438513,
        20.317025529890586,
        20.330002843342655,
        20.342980156794724,
        20.355957470246793,
        20.36893478369886,
        20.381912097150934,
        20.394889410603003,
        20.407866724055072,
        20.42084403750714,
        20.43382135095921,
        20.446798664411283,
        20.45977597786335,
        20.47275329131542,
        20.48573060476749,
        20.498707918219562,
        20.51168523167163,
        20.5246625451237,
        20.53763985857577,
        20.550617172027838,
        20.56359448547991,
        20.57657179893198,
        20.58954911238405,
        20.602526425836118,
        20.615503739288187,
        20.62848105274026,
        20.641458366192328,
        20.654435679644397,
        20.667412993096466,
        20.68039030654854,
        20.693367620000608,
        20.706344933452677,
        20.719322246904746,
        20.732299560356815,
        20.745276873808887,
        20.758254187260956,
        20.771231500713025,
        20.784208814165094,
        20.797186127617163,
        20.810163441069236,
        20.823140754521305,
        20.836118067973374,
        20.849095381425442,
        20.86207269487751,
        20.875050008329584,
        20.888027321781653,
        20.901004635233722,
        20.91398194868579,
        20.926959262137864,
        20.939936575589932,
        20.952913889042,
        20.96589120249407,
        20.97886851594614,
        20.991845829398212,
        21.00482314285028,
        21.01780045630235,
        21.03077776975442,
        21.043755083206488,
        21.05673239665856,
        21.06970971011063,
        21.0826870235627,
        21.095664337014767,
        21.10864165046684,
        21.12161896391891,
        21.134596277370978,
        21.147573590823047,
        21.160550904275116,
        21.17352821772719,
        21.186505531179257,
        21.199482844631326,
        21.212460158083395,
        21.225437471535464,
        21.238414784987537,
        21.251392098439606,
        21.264369411891675,
        21.277346725343744,
        21.290324038795813,
        21.303301352247885,
        21.316278665699954,
        21.329255979152023,
        21.342233292604092,
        21.355210606056165,
        21.368187919508234,
        21.381165232960303,
        21.394142546412372,
        21.40711985986444,
        21.420097173316513,
        21.433074486768582,
        21.44605180022065,
        21.45902911367272,
        21.47200642712479,
        21.484983740576862,
        21.49796105402893,
        21.510938367481,
        21.52391568093307,
        21.53689299438514,
        21.54987030783721,
        21.56284762128928,
        21.575824934741348,
        21.588802248193417,
        21.60177956164549,
        21.61475687509756,
        21.627734188549628,
        21.640711502001697,
        21.653688815453766,
        21.666666128905838,
        21.679643442357907,
        21.692620755809976,
        21.705598069262045,
        21.718575382714118,
        21.731552696166187,
        21.744530009618256,
        21.757507323070325,
        21.770484636522394,
        21.783461949974466,
        21.796439263426535,
        21.809416576878604,
        21.822393890330673,
        21.835371203782742,
        21.848348517234815,
        21.861325830686884,
        21.874303144138953,
        21.88728045759102,
        21.90025777104309,
        21.913235084495163,
        21.926212397947232,
        21.9391897113993,
        21.95216702485137,
        21.965144338303443,
        21.97812165175551,
        21.99109896520758,
        22.00407627865965,
        22.01705359211172,
        22.03003090556379,
        22.04300821901586,
        22.05598553246793,
        22.068962845919998,
        22.081940159372067,
        22.09491747282414,
        22.10789478627621,
        22.120872099728278,
        22.133849413180346,
        22.14682672663242,
        22.159804040084488,
        22.172781353536557,
        22.185758666988626,
        22.198735980440695,
        22.211713293892767,
        22.224690607344836,
        22.237667920796905,
        22.250645234248974,
        22.263622547701043,
        22.276599861153116,
        22.289577174605185,
        22.302554488057254,
        22.315531801509323,
        22.328509114961392,
        22.341486428413464,
        22.354463741865533,
        22.367441055317602,
        22.38041836876967,
        22.393395682221744,
        22.406372995673813,
        22.419350309125882,
        22.43232762257795,
        22.44530493603002,
        22.458282249482092,
        22.47125956293416,
        22.48423687638623,
        22.4972141898383,
        22.51019150329037,
        22.52316881674244,
        22.53614613019451,
        22.54912344364658,
        22.562100757098648,
        22.57507807055072,
        22.58805538400279,
        22.60103269745486,
        22.614010010906927,
        22.626987324358996,
        22.63996463781107,
        22.652941951263138,
        22.665919264715207,
        22.678896578167276,
        22.691873891619345,
        22.704851205071417,
        22.717828518523486,
        22.730805831975555,
        22.743783145427624,
        22.756760458879693,
        22.769737772331766,
        22.782715085783835,
        22.795692399235904,
        22.808669712687973,
        22.821647026140045,
        22.834624339592114,
        22.847601653044183,
        22.860578966496252,
        22.87355627994832,
        22.886533593400394,
        22.899510906852463,
        22.91248822030453,
        22.9254655337566,
        22.93844284720867,
        22.951420160660742,
        22.96439747411281,
        22.97737478756488,
        22.99035210101695,
        23.00332941446902,
        23.01630672792109,
        23.02928404137316,
        23.04226135482523,
        23.055238668277298,
        23.06821598172937,
        23.08119329518144,
        23.094170608633508,
        23.107147922085577,
        23.120125235537646,
        23.13310254898972,
        23.146079862441788,
        23.159057175893857,
        23.172034489345926,
        23.185011802797998,
        23.197989116250067,
        23.210966429702136,
        23.223943743154205,
        23.236921056606274,
        23.249898370058347,
        23.262875683510416,
        23.275852996962485,
        23.288830310414554,
        23.301807623866623,
        23.314784937318695,
        23.327762250770764,
        23.340739564222833,
        23.353716877674902,
        23.36669419112697,
        23.379671504579044,
        23.392648818031113,
        23.40562613148318,
        23.41860344493525,
        23.431580758387323,
        23.444558071839392,
        23.45753538529146,
        23.47051269874353,
        23.4834900121956,
        23.49646732564767,
        23.50944463909974,
        23.52242195255181,
        23.53539926600388,
        23.548376579455947,
        23.56135389290802,
        23.57433120636009,
        23.587308519812158,
        23.600285833264227,
        23.6132631467163,
        23.62624046016837,
        23.639217773620437,
        23.652195087072506,
        23.665172400524575,
        23.678149713976648,
        23.691127027428717,
        23.704104340880786,
        23.717081654332855,
        23.730058967784924,
        23.743036281236996,
        23.756013594689065,
        23.768990908141134,
        23.781968221593203,
        23.794945535045272,
        23.807922848497345,
        23.820900161949414,
        23.833877475401483,
        23.846854788853552,
        23.859832102305624,
        23.872809415757693,
        23.885786729209762,
        23.89876404266183,
        23.9117413561139,
        23.924718669565973,
        23.937695983018042,
        23.95067329647011,
        23.96365060992218,
        23.97662792337425,
        23.98960523682632,
        24.00258255027839,
        24.01555986373046,
        24.02853717718253,
        24.0415144906346,
        24.05449180408667,
        24.06746911753874,
        24.080446430990808,
        24.093423744442877,
        24.10640105789495,
        24.11937837134702,
        24.132355684799087,
        24.145332998251156,
        24.158310311703225,
        24.171287625155298,
        24.184264938607367,
        24.197242252059436,
        24.210219565511505,
        24.223196878963574,
        24.236174192415646,
        24.249151505867715,
        24.262128819319784,
        24.275106132771853,
        24.288083446223926,
        24.301060759675995,
        24.314038073128064,
        24.327015386580133,
        24.3399927000322,
        24.352970013484274,
        24.365947326936343,
        24.378924640388412,
        24.39190195384048,
        24.40487926729255,
        24.417856580744623,
        24.43083389419669,
        24.44381120764876,
        24.45678852110083,
        24.469765834552902,
        24.48274314800497,
        24.49572046145704,
        24.50869777490911,
        24.521675088361178,
        24.53465240181325,
        24.54762971526532,
        24.56060702871739,
        24.573584342169458,
        24.586561655621527,
        24.5995389690736,
        24.612516282525668,
        24.625493595977737,
        24.638470909429806,
        24.65144822288188,
        24.664425536333948,
        24.677402849786017,
        24.690380163238085,
        24.703357476690154,
        24.716334790142227,
        24.729312103594296,
        24.742289417046365,
        24.755266730498434,
        24.768244043950503,
        24.781221357402575,
        24.794198670854644,
        24.807175984306713,
        24.820153297758782,
        24.83313061121085,
        24.846107924662924,
        24.859085238114993,
        24.872062551567062,
        24.88503986501913,
        24.898017178471203,
        24.910994491923272,
        24.92397180537534,
        24.93694911882741,
        24.94992643227948,
        24.962903745731552,
        24.97588105918362,
        24.98885837263569,
        25.00183568608776,
        25.014812999539828,
        25.0277903129919,
        25.04076762644397,
        25.05374493989604,
        25.066722253348107,
        25.07969956680018,
        25.09267688025225,
        25.105654193704318,
        25.118631507156387,
        25.131608820608456,
        25.14458613406053,
        25.157563447512597,
        25.170540760964666,
        25.183518074416735,
        25.196495387868804,
        25.209472701320877,
        25.222450014772946,
        25.235427328225015,
        25.248404641677084,
        25.261381955129153,
        25.274359268581225,
        25.287336582033294,
        25.300313895485363,
        25.313291208937432,
        25.326268522389505,
        25.339245835841574,
        25.352223149293643,
        25.36520046274571,
        25.37817777619778,
        25.391155089649853,
        25.404132403101922,
        25.41710971655399,
        25.43008703000606,
        25.44306434345813,
        25.4560416569102,
        25.46901897036227,
        25.48199628381434,
        25.49497359726641,
        25.50795091071848,
        25.52092822417055,
        25.53390553762262,
        25.546882851074688,
        25.559860164526757,
        25.57283747797883,
        25.5858147914309,
        25.598792104882968,
        25.611769418335037,
        25.624746731787106,
        25.637724045239178,
        25.650701358691247,
        25.663678672143316,
        25.676655985595385,
        25.689633299047454,
        25.702610612499527,
        25.715587925951596,
        25.728565239403665,
        25.741542552855734,
        25.754519866307806,
        25.767497179759875,
        25.780474493211944,
        25.793451806664013,
        25.806429120116082,
        25.819406433568155,
        25.832383747020224,
        25.845361060472293,
        25.85833837392436,
        25.87131568737643,
        25.884293000828503,
        25.897270314280572,
        25.91024762773264,
        25.92322494118471,
        25.936202254636783,
        25.94917956808885,
        25.96215688154092,
        25.97513419499299,
        25.98811150844506,
        26.00108882189713,
        26.0140661353492,
        26.02704344880127,
        26.040020762253338,
        26.052998075705407,
        26.06597538915748,
        26.07895270260955,
        26.091930016061617,
        26.104907329513686,
        26.11788464296576,
        26.130861956417828,
        26.143839269869897,
        26.156816583321966,
        26.169793896774035,
        26.182771210226107,
        26.195748523678176,
        26.208725837130245,
        26.221703150582314,
        26.234680464034383,
        26.247657777486456,
        26.260635090938525,
        26.273612404390594,
        26.286589717842663,
        26.299567031294732,
        26.312544344746804,
        26.325521658198873,
        26.338498971650942,
        26.35147628510301,
        26.364453598555084,
        26.377430912007153,
        26.390408225459222,
        26.40338553891129,
        26.41636285236336,
        26.429340165815432,
        26.4423174792675,
        26.45529479271957,
        26.46827210617164,
        26.48124941962371,
        26.49422673307578,
        26.50720404652785,
        26.52018135997992,
        26.533158673431988,
        26.54613598688406,
        26.55911330033613,
        26.5720906137882,
        26.585067927240267,
        26.598045240692336,
        26.61102255414441,
        26.623999867596478,
        26.636977181048547,
        26.649954494500616,
        26.662931807952685,
        26.675909121404757,
        26.688886434856826,
        26.701863748308895,
        26.714841061760964,
        26.727818375213033,
        26.740795688665106,
        26.753773002117175,
        26.766750315569244,
        26.779727629021313,
        26.792704942473385,
        26.805682255925454,
        26.818659569377523,
        26.831636882829592,
        26.84461419628166,
        26.857591509733734,
        26.870568823185803,
        26.88354613663787,
        26.89652345008994,
        26.90950076354201,
        26.922478076994082,
        26.93545539044615,
        26.94843270389822,
        26.96141001735029,
        26.97438733080236,
        26.98736464425443,
        27.0003419577065,
        27.01331927115857,
        27.026296584610638,
        27.03927389806271,
        27.05225121151478,
        27.065228524966848,
        27.078205838418917,
        27.091183151870986,
        27.10416046532306,
        27.117137778775128,
        27.130115092227197,
        27.143092405679266,
        27.156069719131334,
        27.169047032583407,
        27.182024346035476,
        27.195001659487545,
        27.207978972939614,
        27.220956286391687,
        27.233933599843756,
        27.246910913295824,
        27.259888226747893,
        27.272865540199962,
        27.285842853652035,
        27.298820167104104,
        27.311797480556173,
        27.324774794008242,
        27.33775210746031,
        27.350729420912383,
        27.363706734364452,
        27.37668404781652,
        27.38966136126859,
        27.402638674720663,
        27.415615988172732,
        27.4285933016248,
        27.44157061507687,
        27.45454792852894,
        27.46752524198101,
        27.48050255543308,
        27.49347986888515,
        27.50645718233722,
        27.519434495789287,
        27.53241180924136,
        27.54538912269343,
        27.558366436145498,
        27.571343749597567,
        27.58432106304964,
        27.59729837650171,
        27.610275689953777,
        27.623253003405846,
        27.636230316857915,
        27.649207630309988,
        27.662184943762057,
        27.675162257214126,
        27.688139570666195,
        27.701116884118264,
        27.714094197570336,
        27.727071511022405,
        27.740048824474474,
        27.753026137926543,
        27.766003451378612,
        27.778980764830685,
        27.791958078282754,
        27.804935391734823,
        27.81791270518689,
        27.830890018638964,
        27.843867332091033,
        27.856844645543102,
        27.86982195899517,
        27.88279927244724,
        27.895776585899313,
        27.90875389935138,
        27.92173121280345,
        27.93470852625552,
        27.94768583970759,
        27.96066315315966,
        27.97364046661173,
        27.9866177800638,
        27.999595093515868,
        28.01257240696794,
        28.02554972042001,
        28.03852703387208,
        28.051504347324148,
        28.064481660776217,
        28.07745897422829,
        28.090436287680358,
        28.103413601132427,
        28.116390914584496,
        28.129368228036565,
        28.142345541488638,
        28.155322854940707,
        28.168300168392776,
        28.181277481844845,
        28.194254795296914,
        28.207232108748986,
        28.220209422201055,
        28.233186735653124,
        28.246164049105193,
        28.259141362557266,
        28.272118676009335,
        28.285095989461404,
        28.298073302913473,
        28.31105061636554,
        28.324027929817614,
        28.337005243269683,
        28.349982556721752,
        28.36295987017382,
        28.37593718362589,
        28.388914497077963,
        28.40189181053003,
        28.4148691239821,
        28.42784643743417,
        28.440823750886242,
        28.45380106433831,
        28.46677837779038,
        28.47975569124245,
        28.492733004694518,
        28.50571031814659,
        28.51868763159866,
        28.53166494505073,
        28.544642258502797,
        28.557619571954866,
        28.57059688540694,
        28.583574198859008,
        28.596551512311077,
        28.609528825763146,
        28.622506139215215,
        28.635483452667287,
        28.648460766119356,
        28.661438079571425,
        28.674415393023494,
        28.687392706475567,
        28.700370019927636,
        28.713347333379705,
        28.726324646831774,
        28.739301960283843,
        28.752279273735915,
        28.765256587187984,
        28.778233900640053,
        28.791211214092122,
        28.80418852754419,
        28.817165840996264,
        28.830143154448333,
        28.843120467900402,
        28.85609778135247,
        28.869075094804543,
        28.882052408256612,
        28.89502972170868,
        28.90800703516075,
        28.92098434861282,
        28.933961662064892,
        28.94693897551696,
        28.95991628896903,
        28.9728936024211,
        28.985870915873168,
        28.99884822932524,
        29.01182554277731,
        29.02480285622938,
        29.037780169681447,
        29.05075748313352,
        29.06373479658559,
        29.076712110037658,
        29.089689423489727,
        29.102666736941796,
        29.11564405039387,
        29.128621363845937,
        29.141598677298006,
        29.154575990750075,
        29.167553304202144,
        29.180530617654217,
        29.193507931106286,
        29.206485244558355,
        29.219462558010424,
        29.232439871462493,
        29.245417184914565,
        29.258394498366634,
        29.271371811818703,
        29.284349125270772,
        29.297326438722845,
        29.310303752174914,
        29.323281065626983,
        29.33625837907905,
        29.34923569253112,
        29.362213005983193,
        29.375190319435262,
        29.38816763288733,
        29.4011449463394,
        29.41412225979147,
        29.42709957324354,
        29.44007688669561,
        29.45305420014768,
        29.46603151359975,
        29.47900882705182,
        29.49198614050389,
        29.50496345395596,
        29.517940767408028,
        29.530918080860097,
        29.54389539431217,
        29.55687270776424,
        29.569850021216308,
        29.582827334668377,
        29.595804648120446,
        29.608781961572518,
        29.621759275024587,
        29.634736588476656,
        29.647713901928725,
        29.660691215380794,
        29.673668528832867,
        29.686645842284936,
        29.699623155737005,
        29.712600469189073,
        29.725577782641146,
        29.738555096093215,
        29.751532409545284,
        29.764509722997353,
        29.777487036449422,
        29.790464349901495,
        29.803441663353563,
        29.816418976805632,
        29.8293962902577,
        29.84237360370977,
        29.855350917161843,
        29.868328230613912,
        29.88130554406598,
        29.89428285751805,
        29.907260170970122,
        29.92023748442219,
        29.93321479787426,
        29.94619211132633,
        29.9591694247784,
        29.97214673823047,
        29.98512405168254,
        29.99810136513461,
        30.011078678586678,
        30.024055992038747,
        30.03703330549082,
        30.05001061894289,
        30.062987932394957,
        30.075965245847026,
        30.0889425592991,
        30.101919872751168,
        30.114897186203237,
        30.127874499655306,
        30.140851813107375,
        30.153829126559447,
        30.166806440011516,
        30.179783753463585,
        30.192761066915654,
        30.205738380367723,
        30.218715693819796,
        30.231693007271865,
        30.244670320723934,
        30.257647634176003,
        30.27062494762807,
        30.283602261080144,
        30.296579574532213,
        30.309556887984282,
        30.32253420143635,
        30.335511514888424,
        30.348488828340493,
        30.36146614179256,
        30.37444345524463,
        30.3874207686967,
        30.400398082148772,
        30.41337539560084,
        30.42635270905291,
        30.43933002250498,
        30.452307335957048,
        30.46528464940912,
        30.47826196286119,
        30.49123927631326,
        30.504216589765328,
        30.5171939032174,
        30.53017121666947,
        30.543148530121538,
        30.556125843573607,
        30.569103157025676,
        30.58208047047775,
        30.595057783929818,
        30.608035097381887,
        30.621012410833956,
        30.633989724286025,
        30.646967037738094,
        30.659944351190163,
        30.67292166464224,
        30.685898978094308,
        30.698876291546377,
        30.711853604998446,
        30.724830918450515,
        30.737808231902584,
        30.750785545354653,
        30.76376285880672,
        30.77674017225879,
        30.78971748571086,
        30.802694799162936,
        30.815672112615005,
        30.828649426067074,
        30.841626739519143,
        30.85460405297121,
        30.86758136642328,
        30.88055867987535,
        30.89353599332742,
        30.906513306779487,
        30.919490620231564,
        30.932467933683633,
        30.9454452471357,
        30.95842256058777,
        30.97139987403984,
        30.98437718749191,
        30.997354500943977,
        31.010331814396046,
        31.023309127848115,
        31.03628644130019,
        31.04926375475226,
        31.06224106820433,
        31.0752183816564,
        31.088195695108467,
        31.101173008560536,
        31.114150322012605,
        31.127127635464674,
        31.140104948916743,
        31.153082262368812,
        31.16605957582089,
        31.179036889272957,
        31.192014202725026,
        31.204991516177095,
        31.217968829629164,
        31.230946143081233,
        31.243923456533302,
        31.25690076998537,
        31.26987808343744,
        31.282855396889516,
        31.295832710341585,
        31.308810023793654,
        31.321787337245723,
        31.334764650697792,
        31.34774196414986,
        31.36071927760193,
        31.373696591054,
        31.38667390450607,
        31.399651217958137,
        31.412628531410213,
        31.425605844862282,
        31.43858315831435,
        31.45156047176642,
        31.46453778521849,
        31.47751509867056,
        31.490492412122627,
        31.503469725574696,
        31.516447039026765,
        31.52942435247884,
        31.54240166593091,
        31.55537897938298,
        31.56835629283505,
        31.581333606287117,
        31.594310919739186,
        31.607288233191255,
        31.620265546643324,
        31.633242860095393,
        31.646220173547462,
        31.65919748699954,
        31.672174800451607,
        31.685152113903676,
        31.698129427355745,
        31.711106740807814,
        31.724084054259883,
        31.737061367711952,
        31.75003868116402,
        31.76301599461609,
        31.775993308068166,
        31.788970621520235,
        31.801947934972304,
        31.814925248424373,
        31.827902561876442,
        31.84087987532851,
        31.85385718878058,
        31.86683450223265,
        31.879811815684718,
        31.892789129136794,
        31.905766442588863,
        31.918743756040932,
        31.931721069493,
        31.94469838294507,
        31.95767569639714,
        31.970653009849208,
        31.983630323301277,
        31.996607636753346,
        32.009584950205415,
        32.02256226365749,
        32.03553957710956,
        32.04851689056163,
        32.0614942040137,
        32.07447151746577,
        32.087448830917836,
        32.100426144369905,
        32.113403457821974,
        32.12638077127404,
        32.13935808472612,
        32.15233539817819,
        32.16531271163026,
        32.178290025082326,
        32.191267338534395,
        32.204244651986464,
        32.21722196543853,
        32.2301992788906,
        32.24317659234267,
        32.25615390579474,
        32.269131219246816,
        32.282108532698885,
        32.295085846150954,
        32.30806315960302,
        32.32104047305509,
        32.33401778650716,
        32.34699509995923,
        32.3599724134113,
        32.37294972686337,
        32.385927040315444,
        32.39890435376751,
        32.41188166721958,
        32.42485898067165,
        32.43783629412372,
        32.45081360757579,
        32.46379092102786,
        32.47676823447993,
        32.489745547931996,
        32.50272286138407,
        32.51570017483614,
        32.52867748828821,
        32.54165480174028,
        32.55463211519235,
        32.56760942864442,
        32.580586742096486,
        32.593564055548555,
        32.606541369000624,
        32.61951868245269,
        32.63249599590477,
        32.64547330935684,
        32.65845062280891,
        32.671427936260976,
        32.684405249713045,
        32.697382563165114,
        32.71035987661718,
        32.72333719006925,
        32.73631450352132,
        32.7492918169734,
        32.762269130425466,
        32.775246443877535,
        32.788223757329604,
        32.80120107078167,
        32.81417838423374,
        32.82715569768581,
        32.84013301113788,
        32.85311032458995,
        32.86608763804202,
        32.879064951494094,
        32.89204226494616,
        32.90501957839823,
        32.9179968918503,
        32.93097420530237,
        32.94395151875444,
        32.95692883220651,
        32.96990614565858,
        32.982883459110646,
        32.99586077256272,
        33.00883808601479,
        33.02181539946686,
        33.03479271291893,
        33.047770026371,
        33.06074733982307,
        33.073724653275136,
        33.086701966727205,
        33.099679280179274,
        33.11265659363134,
        33.12563390708342,
        33.13861122053549,
        33.15158853398756,
        33.164565847439626,
        33.177543160891695,
        33.190520474343764,
        33.20349778779583,
        33.2164751012479,
        33.22945241469997,
        33.24242972815205,
        33.255407041604116,
        33.268384355056185,
        33.281361668508254,
        33.29433898196032,
        33.30731629541239,
        33.32029360886446,
        33.33327092231653,
        33.3462482357686,
        33.359225549220675,
        33.372202862672744,
        33.38518017612481,
        33.39815748957688,
        33.41113480302895,
        33.42411211648102,
        33.43708942993309,
        33.45006674338516,
        33.46304405683723,
        33.476021370289295,
        33.48899868374137,
        33.50197599719344,
        33.51495331064551,
        33.52793062409758,
        33.54090793754965,
        33.55388525100172,
        33.566862564453785,
        33.579839877905854,
        33.59281719135792,
        33.60579450481,
        33.61877181826207,
        33.63174913171414,
        33.64472644516621,
        33.657703758618275,
        33.670681072070344,
        33.68365838552241,
        33.69663569897448,
        33.70961301242655,
        33.72259032587862,
        33.7355676393307,
        33.748544952782765,
        33.761522266234834,
        33.7744995796869,
        33.78747689313897,
        33.80045420659104,
        33.81343152004311,
        33.82640883349518,
        33.83938614694725,
        33.852363460399324,
        33.86534077385139,
        33.87831808730346,
        33.89129540075553,
        33.9042727142076,
        33.91725002765967,
        33.93022734111174,
        33.94320465456381,
        33.956181968015876,
        33.96915928146795,
        33.98213659492002,
        33.99511390837209,
        34.00809122182416,
        34.02106853527623,
        34.0340458487283,
        34.047023162180366,
        34.060000475632435,
        34.072977789084504,
        34.08595510253657,
        34.09893241598865,
        34.11190972944072,
        34.12488704289279,
        34.137864356344856,
        34.150841669796925,
        34.163818983248994,
        34.17679629670106,
        34.18977361015313,
        34.2027509236052,
        34.21572823705728,
        34.228705550509346,
        34.241682863961415,
        34.254660177413484,
        34.26763749086555,
        34.28061480431762,
        34.29359211776969,
        34.30656943122176,
        34.31954674467383,
        34.3325240581259,
        34.345501371577974,
        34.35847868503004,
        34.37145599848211,
        34.38443331193418,
        34.39741062538625,
        34.41038793883832,
        34.42336525229039,
        34.43634256574246,
        34.449319879194526,
        34.4622971926466,
        34.47527450609867,
        34.48825181955074,
        34.50122913300281,
        34.51420644645488,
        34.52718375990695,
        34.540161073359016,
        34.553138386811085,
        34.566115700263154,
        34.57909301371522,
        34.5920703271673,
        34.60504764061937,
        34.61802495407144,
        34.631002267523506,
        34.643979580975575,
        34.656956894427644,
        34.66993420787971,
        34.68291152133178,
        34.69588883478385,
        34.70886614823593,
        34.721843461687996,
        34.734820775140065,
        34.747798088592134,
        34.7607754020442,
        34.77375271549627,
        34.78673002894834,
        34.79970734240041,
        34.81268465585248,
        34.825661969304555,
        34.838639282756624,
        34.85161659620869,
        34.86459390966076,
        34.87757122311283,
        34.8905485365649,
        34.90352585001697,
        34.91650316346904,
        34.92948047692111,
        34.942457790373176,
        34.95543510382525,
        34.96841241727732,
        34.98138973072939,
        34.99436704418146,
        35.00734435763353,
        35.0203216710856,
        35.033298984537666,
        35.046276297989735,
        35.059253611441804,
        35.07223092489388,
        35.08520823834595,
        35.09818555179802,
        35.11116286525009,
        35.124140178702156,
        35.137117492154225,
        35.150094805606294,
        35.16307211905836,
        35.17604943251043,
        35.1890267459625,
        35.20200405941458,
        35.214981372866646,
        35.227958686318715,
        35.240935999770784,
        35.25391331322285,
        35.26689062667492,
        35.27986794012699,
        35.29284525357906,
        35.30582256703113,
        35.318799880483205,
        35.331777193935274,
        35.34475450738734,
        35.35773182083941,
        35.37070913429148,
        35.38368644774355,
        35.39666376119562,
        35.40964107464769,
        35.42261838809976,
        35.43559570155183,
        35.4485730150039,
        35.46155032845597,
        35.47452764190804,
        35.48750495536011,
        35.50048226881218,
        35.51345958226425,
        35.526436895716316,
        35.539414209168385,
        35.552391522620454,
        35.56536883607253,
        35.5783461495246,
        35.59132346297667,
        35.60430077642874,
        35.617278089880806,
        35.630255403332875,
        35.643232716784944,
        35.65621003023701,
        35.66918734368908,
        35.68216465714116,
        35.69514197059323,
        35.708119284045296,
        35.721096597497365,
        35.734073910949434,
        35.7470512244015,
        35.76002853785357,
        35.77300585130564,
        35.78598316475771,
        35.79896047820978,
        35.811937791661855,
        35.824915105113924,
        35.83789241856599,
        35.85086973201806,
        35.86384704547013,
        35.8768243589222,
        35.88980167237427,
        35.90277898582634,
        35.91575629927841,
        35.92873361273048,
        35.94171092618255,
        35.95468823963462,
        35.96766555308669,
        35.98064286653876,
        35.99362017999083,
        36.0065974934429,
        36.019574806894965,
        36.032552120347034,
        36.0455294337991,
        36.05850674725118,
        36.07148406070325,
        36.08446137415532,
        36.09743868760739,
        36.110416001059455,
        36.123393314511524,
        36.13637062796359,
        36.14934794141566,
        36.16232525486773,
        36.17530256831981,
        36.18827988177188,
        36.201257195223945,
        36.214234508676014,
        36.22721182212808,
        36.24018913558015,
        36.25316644903222,
        36.26614376248429,
        36.27912107593636,
        36.292098389388435,
        36.305075702840504,
        36.31805301629257,
        36.33103032974464,
        36.34400764319671,
        36.35698495664878,
        36.36996227010085,
        36.38293958355292,
        36.39591689700499,
        36.408894210457056,
        36.42187152390913,
        36.4348488373612,
        36.44782615081327,
        36.46080346426534,
        36.47378077771741,
        36.48675809116948,
        36.499735404621546,
        36.512712718073615,
        36.525690031525684,
        36.53866734497776,
        36.55164465842983,
        36.5646219718819,
        36.57759928533397,
        36.590576598786036,
        36.603553912238105,
        36.616531225690174,
        36.62950853914224,
        36.64248585259431,
        36.65546316604638,
        36.66844047949846,
        36.681417792950526,
        36.694395106402595,
        36.707372419854664,
        36.72034973330673,
        36.7333270467588,
        36.74630436021087,
        36.75928167366294,
        36.77225898711501,
        36.785236300567085,
        36.798213614019154,
        36.81119092747122,
        36.82416824092329,
        36.83714555437536,
        36.85012286782743,
        36.8631001812795,
        36.87607749473157,
        36.88905480818364,
        36.90203212163571,
        36.91500943508778,
        36.92798674853985,
        36.94096406199192,
        36.95394137544399,
        36.96691868889606,
        36.97989600234813,
        36.992873315800196,
        37.005850629252265,
        37.018827942704334,
        37.03180525615641,
        37.04478256960848,
        37.05775988306055,
        37.07073719651262,
        37.083714509964686,
        37.096691823416755,
        37.109669136868824,
        37.12264645032089,
        37.13562376377296,
        37.14860107722504,
        37.16157839067711,
        37.174555704129176,
        37.187533017581245,
        37.200510331033314,
        37.21348764448538,
        37.22646495793745,
        37.23944227138952,
        37.25241958484159,
        37.26539689829366,
        37.278374211745735,
        37.291351525197804,
        37.30432883864987,
        37.31730615210194,
        37.33028346555401,
        37.34326077900608,
        37.35623809245815,
        37.36921540591022,
        37.38219271936229,
        37.39517003281436,
        37.40814734626643,
        37.4211246597185,
        37.43410197317057,
        37.44707928662264,
        37.46005660007471,
        37.47303391352678,
        37.486011226978846,
        37.498988540430915,
        37.511965853882984,
        37.52494316733506,
        37.53792048078713,
        37.5508977942392,
        37.56387510769127,
        37.576852421143336,
        37.589829734595405,
        37.602807048047474,
        37.61578436149954,
        37.62876167495161,
        37.64173898840369,
        37.65471630185576,
        37.667693615307826,
        37.680670928759895,
        37.693648242211964,
        37.70662555566403,
        37.7196028691161,
        37.73258018256817,
        37.74555749602024,
        37.758534809472316,
        37.771512122924385,
        37.784489436376454,
        37.79746674982852,
        37.81044406328059,
        37.82342137673266,
        37.83639869018473,
        37.8493760036368,
        37.86235331708887,
        37.87533063054094,
        37.88830794399301,
        37.90128525744508,
        37.91426257089715,
        37.92723988434922,
        37.94021719780129,
        37.95319451125336,
        37.96617182470543,
        37.979149138157496,
        37.992126451609565,
        38.00510376506164,
        38.01808107851371,
        38.03105839196578,
        38.04403570541785,
        38.05701301886992,
        38.069990332321986,
        38.082967645774055,
        38.095944959226124,
        38.10892227267819,
        38.12189958613026,
        38.13487689958234,
        38.14785421303441,
        38.160831526486476,
        38.173808839938545,
        38.186786153390614,
        38.19976346684268,
        38.21274078029475,
        38.22571809374682,
        38.23869540719889,
        38.251672720650966,
        38.264650034103035,
        38.277627347555104,
        38.29060466100717,
        38.30358197445924,
        38.31655928791131,
        38.32953660136338,
        38.34251391481545,
        38.35549122826752,
        38.368468541719594,
        38.38144585517166,
        38.39442316862373,
        38.4074004820758,
        38.42037779552787,
        38.43335510897994,
        38.44633242243201,
        38.45930973588408,
        38.472287049336146,
        38.485264362788214,
        38.49824167624029,
        38.51121898969236,
        38.52419630314443,
        38.5371736165965,
        38.55015093004857,
        38.563128243500636,
        38.576105556952704,
        38.58908287040477,
        38.60206018385684,
        38.61503749730892,
        38.62801481076099,
        38.64099212421306,
        38.653969437665125,
        38.666946751117194,
        38.67992406456926,
        38.69290137802133,
        38.7058786914734,
        38.71885600492547,
        38.73183331837754,
        38.744810631829615,
        38.757787945281684,
        38.77076525873375,
        38.78374257218582,
        38.79671988563789,
        38.80969719908996,
        38.82267451254203,
        38.8356518259941,
        38.84862913944617,
        38.86160645289824,
        38.87458376635031,
        38.88756107980238,
        38.90053839325445,
        38.91351570670652,
        38.92649302015859,
        38.93947033361066,
        38.952447647062726,
        38.965424960514795,
        38.978402273966864,
        38.99137958741894,
        39.00435690087101,
        39.01733421432308,
        39.03031152777515,
        39.043288841227216,
        39.056266154679285,
        39.069243468131354,
        39.08222078158342,
        39.09519809503549,
        39.10817540848757,
        39.12115272193964,
        39.134130035391706,
        39.147107348843775,
        39.160084662295844,
        39.17306197574791,
        39.18603928919998,
        39.19901660265205,
        39.21199391610412,
        39.224971229556196,
        39.237948543008265,
        39.250925856460334,
        39.2639031699124,
        39.27688048336447,
        39.28985779681654,
        39.30283511026861,
        39.31581242372068,
        39.32878973717275,
        39.34176705062482,
        39.35474436407689,
        39.36772167752896,
        39.38069899098103,
        39.3936763044331,
        39.40665361788517,
        39.41963093133724,
        39.43260824478931,
        39.445585558241376,
        39.458562871693445,
        39.47154018514552,
        39.48451749859759,
        39.49749481204966,
        39.51047212550173,
        39.5234494389538,
        39.536426752405866,
        39.549404065857935,
        39.562381379310004,
        39.57535869276207,
        39.58833600621414,
        39.60131331966622,
        39.61429063311829,
        39.627267946570356,
        39.640245260022425,
        39.653222573474494,
        39.66619988692656,
        39.67917720037863,
        39.6921545138307,
        39.70513182728277,
        39.718109140734846,
        39.731086454186915,
        39.744063767638984,
        39.75704108109105,
        39.77001839454312,
        39.78299570799519,
        39.79597302144726,
        39.80895033489933,
        39.8219276483514,
        39.834904961803474,
        39.84788227525554,
        39.86085958870761,
        39.87383690215968,
        39.88681421561175,
        39.89979152906382,
        39.91276884251589,
        39.92574615596796,
        39.938723469420026,
        39.951700782872095,
        39.96467809632417,
        39.97765540977624,
        39.99063272322831,
        40.00361003668038,
        40.01658735013245,
        40.029564663584516,
        40.042541977036585,
        40.055519290488654,
        40.06849660394072,
        40.0814739173928,
        40.09445123084487,
        40.10742854429694,
        40.120405857749006,
        40.133383171201075,
        40.146360484653144,
        40.15933779810521,
        40.17231511155728,
        40.18529242500935,
        40.19826973846142,
        40.211247051913496,
        40.224224365365565,
        40.237201678817634,
        40.2501789922697,
        40.26315630572177,
        40.27613361917384,
        40.28911093262591,
        40.30208824607798,
        40.31506555953005,
        40.328042872982124,
        40.34102018643419,
        40.35399749988626,
        40.36697481333833,
        40.3799521267904,
        40.39292944024247,
        40.40590675369454,
        40.41888406714661,
        40.431861380598676,
        40.444838694050745,
        40.45781600750282,
        40.47079332095489,
        40.48377063440696,
        40.49674794785903,
        40.5097252613111,
        40.522702574763166,
        40.535679888215235,
        40.548657201667304,
        40.56163451511937,
        40.57461182857145,
        40.58758914202352,
        40.60056645547559,
        40.613543768927656,
        40.626521082379725,
        40.639498395831794,
        40.65247570928386,
        40.66545302273593,
        40.678430336188,
        40.69140764964008,
        40.704384963092146,
        40.717362276544215,
        40.730339589996284,
        40.74331690344835,
        40.75629421690042,
        40.76927153035249,
        40.78224884380456,
        40.79522615725663,
        40.8082034707087,
        40.821180784160774,
        40.83415809761284,
        40.84713541106491,
        40.86011272451698,
        40.87309003796905,
        40.88606735142112,
        40.89904466487319,
        40.91202197832526,
        40.924999291777326,
        40.9379766052294,
        40.95095391868147,
        40.96393123213354,
        40.97690854558561,
        40.98988585903768,
        41.00286317248975,
        41.015840485941816,
        41.028817799393885,
        41.04179511284595,
        41.05477242629802,
        41.0677497397501,
        41.08072705320217,
        41.09370436665424,
        41.106681680106306,
        41.119658993558375,
        41.13263630701044,
        41.14561362046251,
        41.15859093391458,
        41.17156824736665,
        41.18454556081873,
        41.197522874270796,
        41.210500187722864,
        41.22347750117493,
        41.236454814627,
        41.24943212807907,
        41.26240944153114,
        41.27538675498321,
        41.28836406843528,
        41.301341381887354,
        41.31431869533942,
        41.32729600879149,
        41.34027332224356,
        41.35325063569563,
        41.3662279491477,
        41.37920526259977,
        41.39218257605184,
        41.405159889503906,
        41.418137202955975,
        41.43111451640805,
        41.44409182986012,
        41.45706914331219,
        41.47004645676426,
        41.48302377021633,
        41.496001083668396,
        41.508978397120465,
        41.521955710572534,
        41.5349330240246,
        41.54791033747668,
        41.56088765092875,
        41.57386496438082,
        41.586842277832886,
        41.599819591284955,
        41.612796904737024,
        41.62577421818909,
        41.63875153164116,
        41.65172884509323,
        41.6647061585453,
        41.677683471997376,
        41.690660785449445,
        41.703638098901514,
        41.71661541235358,
        41.72959272580565,
        41.74257003925772,
        41.75554735270979,
        41.76852466616186,
        41.78150197961393,
        41.794479293066004,
        41.80745660651807,
        41.82043391997014,
        41.83341123342221,
        41.84638854687428,
        41.85936586032635,
        41.87234317377842,
        41.88532048723049,
        41.898297800682556,
        41.911275114134625,
        41.9242524275867,
        41.93722974103877,
        41.95020705449084,
        41.96318436794291,
        41.97616168139498,
        41.989138994847046,
        42.002116308299115,
        42.015093621751184,
        42.02807093520325,
        42.04104824865533,
        42.0540255621074,
        42.06700287555947,
        42.079980189011536,
        42.092957502463605,
        42.105934815915674,
        42.11891212936774,
        42.13188944281981,
        42.14486675627188,
        42.15784406972396,
        42.170821383176026,
        42.183798696628095,
        42.196776010080164,
        42.20975332353223,
        42.2227306369843,
        42.23570795043637,
        42.24868526388844,
        42.26166257734051,
        42.27463989079258,
        42.287617204244654,
        42.30059451769672,
        42.31357183114879,
        42.32654914460086,
        42.33952645805293,
        42.352503771505,
        42.36548108495707,
        42.37845839840914,
        42.391435711861206,
        42.40441302531328,
        42.41739033876535,
        42.43036765221742,
        42.44334496566949,
        42.45632227912156,
        42.46929959257363,
        42.482276906025696,
        42.495254219477765,
        42.508231532929834,
        42.5212088463819,
        42.53418615983398,
        42.54716347328605,
        42.56014078673812,
        42.573118100190186,
        42.586095413642255,
        42.599072727094324,
        42.61205004054639,
        42.62502735399846,
        42.63800466745053,
        42.65098198090261,
        42.663959294354676,
        42.676936607806745,
        42.689913921258814,
        42.70289123471088,
        42.71586854816295,
        42.72884586161502,
        42.74182317506709,
        42.75480048851916,
        42.767777801971235,
        42.780755115423304,
        42.79373242887537,
        42.80670974232744,
        42.81968705577951,
        42.83266436923158,
        42.84564168268365,
        42.85861899613572,
        42.87159630958779,
        42.884573623039856,
        42.89755093649193,
        42.910528249944,
        42.92350556339607,
        42.93648287684814,
        42.94946019030021,
        42.96243750375228,
        42.975414817204346,
        42.988392130656415,
        43.001369444108484,
        43.01434675756056,
        43.02732407101263,
        43.0403013844647,
        43.05327869791677,
        43.066256011368836,
        43.079233324820905,
        43.092210638272974,
        43.10518795172504,
        43.11816526517711,
        43.13114257862918,
        43.14411989208126,
        43.157097205533326,
        43.170074518985395,
        43.183051832437464,
        43.19602914588953,
        43.2090064593416,
        43.22198377279367,
        43.23496108624574,
        43.24793839969781,
        43.260915713149885,
        43.273893026601954,
        43.28687034005402,
        43.29984765350609,
        43.31282496695816,
        43.32580228041023,
        43.3387795938623,
        43.35175690731437,
        43.36473422076644,
        43.37771153421851,
        43.39068884767058,
        43.40366616112265,
        43.41664347457472,
        43.42962078802679,
        43.44259810147886,
        43.45557541493093,
        43.468552728382996,
        43.481530041835065,
        43.49450735528713,
        43.50748466873921,
        43.52046198219128,
        43.53343929564335,
        43.54641660909542,
        43.559393922547486,
        43.572371235999555,
        43.58534854945162,
        43.59832586290369,
        43.61130317635576,
        43.62428048980784,
        43.63725780325991,
        43.650235116711976,
        43.663212430164045,
        43.67618974361611,
        43.68916705706818,
        43.70214437052025,
        43.71512168397232,
        43.72809899742439,
        43.74107631087646,
        43.754053624328535,
        43.7670309377806,
        43.78000825123267,
        43.79298556468474,
        43.80596287813681,
        43.81894019158888,
        43.83191750504095,
        43.84489481849302,
        43.857872131945086,
        43.87084944539716,
        43.88382675884923,
        43.8968040723013,
        43.90978138575337,
        43.92275869920544,
        43.93573601265751,
        43.948713326109576,
        43.961690639561645,
        43.974667953013714,
        43.98764526646578,
        44.00062257991786,
        44.01359989336993,
        44.026577206822,
        44.039554520274066,
        44.052531833726135,
        44.065509147178204,
        44.07848646063027,
        44.09146377408234,
        44.10444108753441,
        44.11741840098649,
        44.130395714438556,
        44.143373027890625,
        44.156350341342694,
        44.16932765479476,
        44.18230496824683,
        44.1952822816989,
        44.20825959515097,
        44.22123690860304,
        44.234214222055115,
        44.247191535507184,
        44.26016884895925,
        44.27314616241132,
        44.28612347586339,
        44.29910078931546,
        44.31207810276753,
        44.3250554162196,
        44.33803272967167,
        44.351010043123736,
        44.36398735657581,
        44.37696467002788,
        44.38994198347995,
        44.40291929693202,
        44.41589661038409,
        44.42887392383616,
        44.441851237288226,
        44.454828550740295,
        44.467805864192364,
        44.48078317764444,
        44.49376049109651,
        44.50673780454858,
        44.51971511800065,
        44.532692431452716,
        44.545669744904785,
        44.558647058356854,
        44.57162437180892,
        44.58460168526099,
        44.59757899871306,
        44.61055631216514,
        44.623533625617206,
        44.636510939069275,
        44.649488252521344,
        44.66246556597341,
        44.67544287942548,
        44.68842019287755,
        44.70139750632962,
        44.71437481978169,
        44.727352133233765,
        44.740329446685834,
        44.7533067601379,
        44.76628407358997,
        44.77926138704204,
        44.79223870049411,
        44.80521601394618,
        44.81819332739825,
        44.83117064085032,
        44.84414795430239,
        44.85712526775446,
        44.87010258120653,
        44.8830798946586,
        44.89605720811067,
        44.90903452156274,
        44.92201183501481,
        44.934989148466876,
        44.947966461918945,
        44.960943775371014,
        44.97392108882309,
        44.98689840227516,
        44.99987571572723,
        45.0128530291793,
        45.025830342631366,
        45.038807656083435,
        45.051784969535504,
        45.06476228298757,
        45.07773959643964,
        45.09071690989172,
        45.10369422334379,
        45.116671536795856,
        45.129648850247925,
        45.142626163699994,
        45.15560347715206,
        45.16858079060413,
        45.1815581040562,
        45.19453541750827,
        45.20751273096034,
        45.220490044412415,
        45.233467357864484,
        45.24644467131655,
        45.25942198476862,
        45.27239929822069,
        45.28537661167276,
        45.29835392512483,
        45.3113312385769,
        45.32430855202897,
        45.33728586548104,
        45.35026317893311,
        45.36324049238518,
        45.37621780583725,
        45.38919511928932,
        45.40217243274139,
        45.41514974619346,
        45.428127059645526,
        45.441104373097595,
        45.454081686549664,
        45.46705900000174,
        45.48003631345381,
        45.49301362690588,
        45.50599094035795,
        45.518968253810016,
        45.531945567262085,
        45.544922880714154,
        45.55790019416622,
        45.57087750761829,
        45.58385482107037,
        45.59683213452244,
        45.609809447974506,
        45.622786761426575,
        45.635764074878644,
        45.64874138833071,
        45.66171870178278,
        45.67469601523485,
        45.68767332868692,
        45.700650642138996,
        45.713627955591065,
        45.726605269043134,
        45.7395825824952,
        45.75255989594727,
        45.76553720939934,
        45.77851452285141,
        45.79149183630348,
        45.80446914975555,
        45.81744646320762,
        45.83042377665969,
        45.84340109011176,
        45.85637840356383,
        45.8693557170159,
        45.88233303046797,
        45.89531034392004,
        45.90828765737211,
        45.921264970824176,
        45.934242284276245,
        45.94721959772832,
        45.96019691118039,
        45.97317422463246,
        45.98615153808453,
        45.9991288515366,
        46.012106164988666,
        46.025083478440735,
        46.0380607918928,
        46.05103810534487,
        46.06401541879694,
        46.07699273224902,
        46.08997004570109,
        46.102947359153156,
        46.115924672605225,
        46.12890198605729,
        46.14187929950936,
        46.15485661296143,
        46.1678339264135,
        46.18081123986557,
        46.193788553317646,
        46.206765866769715,
        46.21974318022178,
        46.23272049367385,
        46.24569780712592,
        46.25867512057799,
        46.27165243403006,
        46.28462974748213,
        46.2976070609342,
        46.31058437438627,
        46.32356168783834,
        46.33653900129041,
        46.34951631474248,
        46.36249362819455,
        46.37547094164662,
        46.38844825509869,
        46.401425568550756,
        46.414402882002825,
        46.427380195454894,
        46.44035750890697,
        46.45333482235904,
        46.46631213581111,
        46.47928944926318,
        46.492266762715246,
        46.505244076167315,
        46.518221389619384,
        46.53119870307145,
        46.54417601652352,
        46.5571533299756,
        46.57013064342767,
        46.583107956879736,
        46.596085270331805,
        46.609062583783874,
        46.62203989723594,
        46.63501721068801,
        46.64799452414008,
        46.66097183759215,
        46.67394915104422,
        46.686926464496295,
        46.699903777948364,
        46.71288109140043,
        46.7258584048525,
        46.73883571830457,
        46.75181303175664,
        46.76479034520871,
        46.77776765866078,
        46.79074497211285,
        46.80372228556492,
        46.81669959901699,
        46.82967691246906,
        46.84265422592113,
        46.8556315393732,
        46.86860885282527,
        46.88158616627734,
        46.894563479729406,
        46.907540793181475,
        46.920518106633544,
        46.93349542008562,
        46.94647273353769,
        46.95945004698976,
        46.97242736044183,
        46.985404673893896,
        46.998381987345965,
        47.011359300798034,
        47.0243366142501,
        47.03731392770217,
        47.05029124115425,
        47.06326855460632,
        47.076245868058386,
        47.089223181510455,
        47.102200494962524,
        47.11517780841459,
        47.12815512186666,
        47.14113243531873,
        47.1541097487708,
        47.167087062222876,
        47.180064375674945,
        47.193041689127014,
        47.20601900257908,
        47.21899631603115,
        47.23197362948322,
        47.24495094293529,
        47.25792825638736,
        47.27090556983943,
        47.2838828832915,
        47.29686019674357,
        47.30983751019564,
        47.32281482364771,
        47.33579213709978,
        47.34876945055185,
        47.36174676400392,
        47.37472407745599,
        47.387701390908056,
        47.400678704360125,
        47.4136560178122,
        47.42663333126427,
        47.43961064471634,
        47.45258795816841,
        47.46556527162048,
        47.478542585072546,
        47.491519898524615,
        47.504497211976684,
        47.51747452542875,
        47.53045183888082,
        47.5434291523329,
        47.55640646578497,
        47.569383779237036,
        47.582361092689105,
        47.595338406141174,
        47.60831571959324,
        47.62129303304531,
        47.63427034649738,
        47.64724765994945,
        47.660224973401526,
        47.673202286853595,
        47.686179600305664,
        47.69915691375773,
        47.7121342272098,
        47.72511154066187,
        47.73808885411394,
        47.75106616756601,
        47.76404348101808,
        47.777020794470154,
        47.78999810792222,
        47.80297542137429,
        47.81595273482636,
        47.82893004827843,
        47.8419073617305,
        47.85488467518257,
        47.86786198863464,
        47.880839302086706,
        47.893816615538775,
        47.90679392899085,
        47.91977124244292,
        47.93274855589499,
        47.94572586934706,
        47.95870318279913,
        47.971680496251196,
        47.984657809703265,
        47.997635123155334,
        48.0106124366074,
        48.02358975005948,
        48.03656706351155,
        48.04954437696362,
        48.062521690415686,
        48.075499003867755,
        48.088476317319824,
        48.10145363077189,
        48.11443094422396,
        48.12740825767603,
        48.1403855711281,
        48.153362884580176,
        48.166340198032245,
        48.179317511484314,
        48.19229482493638,
        48.20527213838845,
        48.21824945184052,
        48.23122676529259,
        48.24420407874466,
        48.25718139219673,
        48.270158705648804,
        48.28313601910087,
        48.29611333255294,
        48.30909064600501,
        48.32206795945708,
        48.33504527290915,
        48.34802258636122,
        48.36099989981329,
        48.373977213265356,
        48.386954526717425,
        48.3999318401695,
        48.41290915362157,
        48.42588646707364,
        48.43886378052571,
        48.45184109397778,
        48.464818407429846,
        48.477795720881915,
        48.490773034333984,
        48.50375034778605,
        48.51672766123813,
        48.5297049746902,
        48.54268228814227,
        48.555659601594336,
        48.568636915046405,
        48.58161422849847,
        48.59459154195054,
        48.60756885540261,
        48.62054616885468,
        48.63352348230676,
        48.646500795758826,
        48.659478109210895,
        48.67245542266296,
        48.68543273611503,
        48.6984100495671,
        48.71138736301917,
        48.72436467647124,
        48.73734198992331,
        48.75031930337538,
        48.76329661682745,
        48.77627393027952,
        48.78925124373159,
        48.80222855718366,
        48.81520587063573,
        48.8281831840878,
        48.84116049753987,
        48.854137810991936,
        48.867115124444005,
        48.88009243789608,
        48.89306975134815,
        48.90604706480022,
        48.91902437825229,
        48.93200169170436,
        48.944979005156426,
        48.957956318608495,
        48.970933632060564,
        48.98391094551263,
        48.9968882589647,
        49.00986557241678,
        49.02284288586885,
        49.035820199320916,
        49.048797512772985,
        49.061774826225054,
        49.07475213967712,
        49.08772945312919,
        49.10070676658126,
        49.11368408003333,
        49.126661393485406,
        49.139638706937475,
        49.152616020389544,
        49.16559333384161,
        49.17857064729368,
        49.19154796074575,
        49.20452527419782,
        49.21750258764989,
        49.23047990110196,
        49.243457214554034,
        49.2564345280061,
        49.26941184145817,
        49.28238915491024,
        49.29536646836231,
        49.30834378181438,
        49.32132109526645,
        49.33429840871852,
        49.347275722170586,
        49.360253035622655,
        49.37323034907473,
        49.3862076625268,
        49.39918497597887,
        49.41216228943094,
        49.42513960288301,
        49.438116916335076,
        49.451094229787145,
        49.464071543239214,
        49.47704885669128,
        49.49002617014336,
        49.50300348359543,
        49.5159807970475,
        49.528958110499566,
        49.541935423951635,
        49.554912737403704,
        49.56789005085577,
        49.58086736430784,
        49.59384467775991,
        49.60682199121198,
        49.619799304664056,
        49.632776618116125,
        49.645753931568194,
        49.65873124502026,
        49.67170855847233,
        49.6846858719244,
        49.69766318537647,
        49.71064049882854,
        49.72361781228061,
        49.736595125732684,
        49.74957243918475,
        49.76254975263682,
        49.77552706608889,
        49.78850437954096,
        49.80148169299303,
        49.8144590064451,
        49.82743631989717,
        49.840413633349236,
        49.853390946801305,
        49.86636826025338,
        49.87934557370545,
        49.89232288715752,
        49.90530020060959,
        49.91827751406166,
        49.931254827513726,
        49.944232140965795,
        49.957209454417864,
        49.97018676786993,
        49.98316408132201,
        49.99614139477408,
        50.00911870822615,
        50.022096021678216,
        50.035073335130285,
        50.048050648582354,
        50.06102796203442,
        50.07400527548649,
        50.08698258893856,
        50.09995990239064,
        50.112937215842706,
        50.125914529294775,
        50.138891842746844,
        50.15186915619891,
        50.16484646965098,
        50.17782378310305,
        50.19080109655512,
        50.20377841000719,
        50.21675572345926,
        50.229733036911334,
        50.2427103503634,
        50.25568766381547,
        50.26866497726754,
        50.28164229071961,
        50.29461960417168,
        50.30759691762375,
        50.32057423107582,
        50.333551544527886,
        50.34652885797996,
        50.35950617143203,
        50.3724834848841,
        50.38546079833617,
        50.39843811178824,
        50.41141542524031,
        50.424392738692376,
        50.437370052144445,
        50.450347365596514,
        50.46332467904858,
        50.47630199250066,
        50.48927930595273,
        50.5022566194048,
        50.515233932856866,
        50.528211246308935,
        50.541188559761004,
        50.55416587321307,
        50.56714318666514,
        50.58012050011721,
        50.59309781356929,
        50.606075127021356,
        50.619052440473425,
        50.632029753925494,
        50.64500706737756,
        50.65798438082963,
        50.6709616942817,
        50.68393900773377,
        50.69691632118584,
        50.709893634637915,
        50.722870948089984,
        50.73584826154205,
        50.74882557499412,
        50.76180288844619,
        50.77478020189826,
        50.78775751535033,
        50.8007348288024,
        50.81371214225447,
        50.826689455706536,
        50.83966676915861,
        50.85264408261068,
        50.86562139606275,
        50.87859870951482,
        50.89157602296689,
        50.90455333641896,
        50.917530649871026,
        50.930507963323095,
        50.943485276775164,
        50.95646259022724,
        50.96943990367931,
        50.98241721713138,
        50.99539453058345,
        51.008371844035516,
        51.021349157487585,
        51.034326470939654,
        51.04730378439172,
        51.06028109784379,
        51.07325841129586,
        51.08623572474794,
        51.099213038200006,
        51.112190351652075,
        51.125167665104144,
        51.13814497855621,
        51.15112229200828,
        51.16409960546035,
        51.17707691891242,
        51.19005423236449,
        51.203031545816565,
        51.216008859268634,
        51.2289861727207,
        51.24196348617277,
        51.25494079962484,
        51.26791811307691,
        51.28089542652898,
        51.29387273998105,
        51.306850053433116,
        51.319827366885185,
        51.33280468033726,
        51.34578199378933,
        51.3587593072414,
        51.37173662069347,
        51.38471393414554,
        51.397691247597606,
        51.410668561049675,
        51.423645874501744,
        51.43662318795381,
        51.44960050140589,
        51.46257781485796,
        51.47555512831003,
        51.488532441762096,
        51.501509755214165,
        51.514487068666234,
        51.5274643821183,
        51.54044169557037,
        51.55341900902244,
        51.56639632247452,
        51.579373635926586,
        51.592350949378655,
        51.605328262830724,
        51.61830557628279,
        51.63128288973486,
        51.64426020318693,
        51.657237516639,
        51.67021483009107,
        51.68319214354314,
        51.696169456995214,
        51.70914677044728,
        51.72212408389935,
        51.73510139735142,
        51.74807871080349,
        51.76105602425556,
        51.77403333770763,
        51.7870106511597,
        51.799987964611766,
        51.81296527806384,
        51.82594259151591,
        51.83891990496798,
        51.85189721842005,
        51.86487453187212,
        51.87785184532419,
        51.890829158776256,
        51.903806472228325,
        51.916783785680394,
        51.92976109913246,
        51.94273841258454,
        51.95571572603661,
        51.96869303948868,
        51.981670352940746,
        51.994647666392815,
        52.007624979844884,
        52.02060229329695,
        52.03357960674902,
        52.04655692020109,
        52.05953423365317,
        52.072511547105236,
        52.085488860557305,
        52.098466174009374,
        52.11144348746144,
        52.12442080091351,
        52.13739811436558,
        52.15037542781765,
        52.16335274126972,
        52.176330054721795,
        52.189307368173864,
        52.20228468162593,
        52.215261995078,
        52.22823930853007,
        52.24121662198214,
        52.25419393543421,
        52.26717124888628,
        52.28014856233835,
        52.293125875790416,
        52.30610318924249,
        52.31908050269456,
        52.33205781614663,
        52.3450351295987,
        52.35801244305077,
        52.37098975650284,
        52.383967069954906,
        52.396944383406975,
        52.409921696859044,
        52.42289901031112,
        52.43587632376319,
        52.44885363721526,
        52.46183095066733,
        52.474808264119396,
        52.487785577571465,
        52.500762891023534,
        52.5137402044756,
        52.52671751792767,
        52.53969483137974,
        52.55267214483182,
        52.565649458283886,
        52.578626771735955,
        52.591604085188024,
        52.60458139864009,
        52.61755871209216,
        52.63053602554423,
        52.6435133389963,
        52.65649065244837,
        52.669467965900445,
        52.682445279352514,
        52.69542259280458,
        52.70839990625665,
        52.72137721970872,
        52.73435453316079,
        52.74733184661286,
        52.76030916006493,
        52.773286473517,
        52.786263786969066,
        52.79924110042114,
        52.81221841387321,
        52.82519572732528,
        52.83817304077735,
        52.85115035422942,
        52.86412766768149,
        52.877104981133556,
        52.890082294585625,
        52.903059608037694,
        52.91603692148977,
        52.92901423494184,
        52.94199154839391,
        52.95496886184598,
        52.967946175298046,
        52.980923488750115,
        52.993900802202184,
        53.00687811565425,
        53.01985542910632,
        53.0328327425584,
        53.04581005601047,
        53.058787369462536,
        53.071764682914605,
        53.084741996366674,
        53.09771930981874,
        53.11069662327081,
        53.12367393672288,
        53.13665125017495,
        53.14962856362702,
        53.162605877079095,
        53.175583190531164,
        53.18856050398323,
        53.2015378174353,
        53.21451513088737,
        53.22749244433944,
        53.24046975779151,
        53.25344707124358,
        53.26642438469565,
        53.27940169814772,
        53.29237901159979,
        53.30535632505186,
        53.31833363850393,
        53.331310951956,
        53.34428826540807,
        53.35726557886014,
        53.370242892312206,
        53.383220205764275,
        53.396197519216344,
        53.40917483266842,
        53.42215214612049,
        53.43512945957256,
        53.44810677302463,
        53.461084086476696,
        53.474061399928765,
        53.487038713380834,
        53.5000160268329,
        53.51299334028497,
        53.52597065373705,
        53.53894796718912,
        53.551925280641186,
        53.564902594093255,
        53.577879907545324,
        53.59085722099739,
        53.60383453444946,
        53.61681184790153,
        53.6297891613536,
        53.642766474805676,
        53.655743788257745,
        53.668721101709814,
        53.68169841516188,
        53.69467572861395,
        53.70765304206602,
        53.72063035551809,
        53.73360766897016,
        53.74658498242223,
        53.7595622958743,
        53.77253960932637,
        53.78551692277844,
        53.79849423623051,
        53.81147154968258,
        53.82444886313465,
        53.83742617658672,
        53.85040349003879,
        53.863380803490855,
        53.876358116942924,
        53.889335430395,
        53.90231274384707,
        53.91529005729914,
        53.92826737075121,
        53.94124468420328,
        53.954221997655345,
        53.967199311107414,
        53.98017662455948,
        53.99315393801155,
        54.00613125146362,
        54.0191085649157,
        54.032085878367766,
        54.045063191819835,
        54.058040505271904,
        54.07101781872397,
        54.08399513217604,
        54.09697244562811,
        54.10994975908018,
        54.12292707253225,
        54.135904385984325,
        54.148881699436394,
        54.16185901288846,
        54.17483632634053,
        54.1878136397926,
        54.20079095324467,
        54.21376826669674,
        54.22674558014881,
        54.23972289360088,
        54.252700207052946,
        54.26567752050502,
        54.27865483395709,
        54.29163214740916,
        54.30460946086123,
        54.3175867743133,
        54.33056408776537,
        54.343541401217436,
        54.356518714669505,
        54.369496028121574,
        54.38247334157365,
        54.39545065502572,
        54.40842796847779,
        54.42140528192986,
        54.434382595381926,
        54.447359908833995,
        54.460337222286064,
        54.47331453573813,
        54.4862918491902,
        54.49926916264228,
        54.51224647609435,
        54.525223789546416,
        54.538201102998485,
        54.551178416450554,
        54.56415572990262,
        54.57713304335469,
        54.59011035680676,
        54.60308767025883,
        54.6160649837109,
        54.629042297162975,
        54.642019610615044,
        54.65499692406711,
        54.66797423751918,
        54.68095155097125,
        54.69392886442332,
        54.70690617787539,
        54.71988349132746,
        54.73286080477953,
        54.7458381182316,
        54.75881543168367,
        54.77179274513574,
        54.78477005858781,
        54.79774737203988,
        54.81072468549195,
        54.82370199894402,
        54.836679312396086,
        54.849656625848155,
        54.862633939300224,
        54.8756112527523,
        54.88858856620437,
        54.90156587965644,
        54.91454319310851,
        54.927520506560576,
        54.940497820012645,
        54.953475133464714,
        54.96645244691678,
        54.97942976036885,
        54.99240707382093,
        55.005384387273,
        55.018361700725066,
        55.031339014177135,
        55.044316327629204,
        55.05729364108127,
        55.07027095453334,
        55.08324826798541,
        55.09622558143748,
        55.109202894889556,
        55.122180208341625,
        55.135157521793694,
        55.14813483524576,
        55.16111214869783,
        55.1740894621499,
        55.18706677560197,
        55.20004408905404,
        55.21302140250611,
        55.22599871595818,
        55.23897602941025,
        55.25195334286232,
        55.26493065631439,
        55.27790796976646,
        55.29088528321853,
        55.3038625966706,
        55.31683991012267,
        55.329817223574736,
        55.342794537026805,
        55.35577185047888,
        55.36874916393095,
        55.38172647738302,
        55.39470379083509,
        55.40768110428716,
        55.420658417739226,
        55.433635731191295,
        55.446613044643364,
        55.45959035809543,
        55.4725676715475,
        55.48554498499958,
        55.49852229845165,
        55.511499611903716,
        55.524476925355785,
        55.537454238807854,
        55.55043155225992,
        55.56340886571199,
        55.57638617916406,
        55.58936349261613,
        55.602340806068206,
        55.615318119520275,
        55.628295432972344,
        55.64127274642441,
        55.65425005987648,
        55.66722737332855,
        55.68020468678062,
        55.69318200023269,
        55.70615931368476,
        55.71913662713683,
        55.7321139405889,
        55.74509125404097,
        55.75806856749304,
        55.77104588094511,
        55.78402319439718,
        55.79700050784925,
        55.80997782130132,
        55.822955134753386,
        55.835932448205455,
        55.84890976165753,
        55.8618870751096,
        55.87486438856167,
        55.88784170201374,
        55.90081901546581,
        55.913796328917876,
        55.926773642369945,
        55.939750955822014,
        55.95272826927408,
        55.96570558272616,
        55.97868289617823,
        55.9916602096303,
        56.004637523082366,
        56.017614836534435,
        56.030592149986504,
        56.04356946343857,
        56.05654677689064,
        56.06952409034271,
        56.08250140379478,
        56.095478717246856,
        56.108456030698925,
        56.121433344150994,
        56.13441065760306,
        56.14738797105513,
        56.1603652845072,
        56.17334259795927,
        56.18631991141134,
        56.19929722486341,
        56.212274538315484,
        56.22525185176755,
        56.23822916521962,
        56.25120647867169,
        56.26418379212376,
        56.27716110557583,
        56.2901384190279,
        56.30311573247997,
        56.316093045932035,
        56.329070359384104,
        56.34204767283618,
        56.35502498628825,
        56.36800229974032,
        56.38097961319239,
        56.39395692664446,
        56.406934240096525,
        56.419911553548594,
        56.43288886700066,
        56.44586618045273,
        56.45884349390481,
        56.47182080735688,
        56.48479812080895,
        56.497775434261015,
        56.510752747713084,
        56.52373006116515,
        56.53670737461722,
        56.54968468806929,
        56.56266200152136,
        56.57563931497344,
        56.588616628425505,
        56.601593941877574,
        56.61457125532964,
        56.62754856878171,
        56.64052588223378,
        56.65350319568585,
        56.66648050913792,
        56.67945782258999,
        56.69243513604206,
        56.70541244949413,
        56.7183897629462,
        56.73136707639827,
        56.74434438985034,
        56.75732170330241,
        56.77029901675448,
        56.78327633020655,
        56.796253643658616,
        56.809230957110685,
        56.82220827056276,
        56.83518558401483,
        56.8481628974669,
        56.86114021091897,
        56.87411752437104,
        56.887094837823106,
        56.900072151275175,
        56.913049464727244,
        56.92602677817931,
        56.93900409163138,
        56.95198140508346,
        56.96495871853553,
        56.977936031987596,
        56.990913345439665,
        57.003890658891734,
        57.0168679723438,
        57.02984528579587,
        57.04282259924794,
        57.05579991270001,
        57.068777226152086,
        57.081754539604155,
        57.094731853056224,
        57.10770916650829,
        57.12068647996036,
        57.13366379341243,
        57.1466411068645,
        57.15961842031657,
        57.17259573376864,
        57.18557304722071,
        57.19855036067278,
        57.21152767412485,
        57.22450498757692,
        57.23748230102899,
        57.25045961448106,
        57.26343692793313,
        57.2764142413852,
        57.289391554837266,
        57.302368868289335,
        57.31534618174141,
        57.32832349519348,
        57.34130080864555,
        57.35427812209762,
        57.36725543554969,
        57.380232749001756,
        57.393210062453825,
        57.406187375905894,
        57.41916468935796,
        57.43214200281004,
        57.44511931626211,
        57.45809662971418,
        57.471073943166246,
        57.484051256618315,
        57.497028570070384,
        57.51000588352245,
        57.52298319697452,
        57.53596051042659,
        57.54893782387866,
        57.561915137330736,
        57.574892450782805,
        57.587869764234874,
        57.60084707768694,
        57.61382439113901,
        57.62680170459108,
        57.63977901804315,
        57.65275633149522,
        57.66573364494729,
        57.678710958399364,
        57.69168827185143,
        57.7046655853035,
        57.71764289875557,
        57.73062021220764,
        57.74359752565971,
        57.75657483911178,
        57.76955215256385,
        57.782529466015916,
        57.795506779467985,
        57.80848409292006,
        57.82146140637213,
        57.8344387198242,
        57.84741603327627,
        57.86039334672834,
        57.873370660180406,
        57.886347973632475,
        57.899325287084544,
        57.91230260053661,
        57.92527991398869,
        57.93825722744076,
        57.95123454089283,
        57.964211854344896,
        57.977189167796965,
        57.990166481249034,
        58.0031437947011,
        58.01612110815317,
        58.02909842160524,
        58.04207573505732,
        58.055053048509386,
        58.068030361961455,
        58.081007675413524,
        58.09398498886559,
        58.10696230231766,
        58.11993961576973,
        58.1329169292218,
        58.14589424267387,
        58.15887155612594,
        58.171848869578014,
        58.18482618303008,
        58.19780349648215,
        58.21078080993422,
        58.22375812338629,
        58.23673543683836,
        58.24971275029043,
        58.2626900637425,
        58.275667377194566,
        58.28864469064664,
        58.30162200409871,
        58.31459931755078,
        58.32757663100285,
        58.34055394445492,
        58.35353125790699,
        58.366508571359056,
        58.379485884811125,
        58.392463198263194,
        58.40544051171526,
        58.41841782516734,
        58.43139513861941,
        58.44437245207148,
        58.457349765523546,
        58.470327078975615,
        58.483304392427684,
        58.49628170587975,
        58.50925901933182,
        58.52223633278389,
        58.53521364623597,
        58.548190959688036,
        58.561168273140105,
        58.574145586592174,
        58.58712290004424,
        58.60010021349631,
        58.61307752694838,
        58.62605484040045,
        58.63903215385252,
        58.65200946730459,
        58.664986780756664,
        58.67796409420873,
        58.6909414076608,
        58.70391872111287,
        58.71689603456494,
        58.72987334801701,
        58.74285066146908,
        58.75582797492115,
        58.768805288373215,
        58.78178260182529,
        58.79475991527736,
        58.80773722872943,
        58.8207145421815,
        58.83369185563357,
        58.84666916908564,
        58.859646482537705,
        58.872623795989774,
        58.88560110944184,
        58.89857842289392,
        58.91155573634599,
        58.92453304979806,
        58.93751036325013,
        58.950487676702195,
        58.963464990154264,
        58.97644230360633,
        58.9894196170584,
        59.00239693051047,
        59.01537424396254,
        59.02835155741462,
        59.041328870866685,
        59.054306184318754,
        59.06728349777082,
        59.08026081122289,
        59.09323812467496,
        59.10621543812703,
        59.1191927515791,
        59.13217006503117,
        59.145147378483244,
        59.15812469193531,
        59.17110200538738,
        59.18407931883945,
        59.19705663229152,
        59.21003394574359,
        59.22301125919566,
        59.23598857264773,
        59.248965886099796,
        59.261943199551865,
        59.27492051300394,
        59.28789782645601,
        59.30087513990808,
        59.31385245336015,
        59.32682976681222,
        59.339807080264286,
        59.352784393716355,
        59.365761707168424,
        59.37873902062049,
        59.39171633407257,
        59.40469364752464,
        59.41767096097671,
        59.430648274428776,
        59.443625587880845,
        59.456602901332914,
        59.46958021478498,
        59.48255752823705,
        59.49553484168912,
        59.5085121551412,
        59.521489468593266,
        59.534466782045335,
        59.547444095497404,
        59.56042140894947,
        59.57339872240154,
        59.58637603585361,
        59.59935334930568,
        59.61233066275775,
        59.62530797620982,
        59.638285289661894,
        59.65126260311396,
        59.66423991656603,
        59.6772172300181,
        59.69019454347017,
        59.70317185692224,
        59.71614917037431,
        59.72912648382638,
        59.742103797278446,
        59.75508111073052,
        59.76805842418259,
        59.78103573763466,
        59.79401305108673,
        59.8069903645388,
        59.81996767799087,
        59.832944991442936,
        59.845922304895005,
        59.858899618347074,
        59.87187693179914,
        59.88485424525122,
        59.89783155870329,
        59.91080887215536,
        59.923786185607426,
        59.936763499059495,
        59.949740812511564,
        59.96271812596363,
        59.9756954394157,
        59.98867275286777,
        60.00165006631985,
        60.014627379771916,
        60.027604693223985,
        60.040582006676054,
        60.05355932012812,
        60.06653663358019,
        60.07951394703226,
        60.09249126048433,
        60.1054685739364,
        60.11844588738847,
        60.131423200840544,
        60.14440051429261,
        60.15737782774468,
        60.17035514119675,
        60.18333245464882,
        60.19630976810089,
        60.20928708155296,
        60.22226439500503,
        60.235241708457096,
        60.24821902190917,
        60.26119633536124,
        60.27417364881331,
        60.28715096226538,
        60.30012827571745,
        60.31310558916952,
        60.326082902621586,
        60.339060216073655,
        60.352037529525724,
        60.3650148429778,
        60.37799215642987,
        60.39096946988194,
        60.40394678333401,
        60.416924096786076,
        60.429901410238145,
        60.442878723690214,
        60.45585603714228,
        60.46883335059435,
        60.48181066404642,
        60.4947879774985,
        60.507765290950566,
        60.520742604402635,
        60.533719917854704,
        60.54669723130677,
        60.55967454475884,
        60.57265185821091,
        60.58562917166298,
        60.59860648511505,
        60.611583798567125,
        60.624561112019194,
        60.63753842547126,
        60.65051573892333,
        60.6634930523754,
        60.67647036582747,
        60.68944767927954,
        60.70242499273161,
        60.71540230618368,
        60.728379619635746,
        60.74135693308782,
        60.75433424653989,
        60.76731155999196,
        60.78028887344403,
        60.7932661868961,
        60.80624350034817,
        60.819220813800236,
        60.832198127252305,
        60.845175440704374,
        60.85815275415645,
        60.87113006760852,
        60.88410738106059,
        60.89708469451266,
        60.910062007964726,
        60.923039321416795,
        60.936016634868864,
        60.94899394832093,
        60.961971261773,
        60.97494857522508,
        60.98792588867715,
        61.000903202129216,
        61.013880515581285,
        61.026857829033354,
        61.03983514248542,
        61.05281245593749,
        61.06578976938956,
        61.07876708284163,
        61.0917443962937,
        61.104721709745775,
        61.117699023197844,
        61.13067633664991,
        61.14365365010198,
        61.15663096355405,
        61.16960827700612,
        61.18258559045819,
        61.19556290391026,
        61.20854021736233,
        61.2215175308144,
        61.23449484426647,
        61.24747215771854,
        61.26044947117061,
        61.27342678462268,
        61.28640409807475,
        61.29938141152682,
        61.312358724978886,
        61.325336038430954,
        61.33831335188302,
        61.3512906653351,
        61.36426797878717,
        61.37724529223924,
        61.39022260569131,
        61.403199919143375,
        61.416177232595444,
        61.42915454604751,
        61.44213185949958,
        61.45510917295165,
        61.46808648640373,
        61.4810637998558,
        61.494041113307865,
        61.507018426759934,
        61.519995740212,
        61.53297305366407,
        61.54595036711614,
        61.55892768056821,
        61.57190499402028,
        61.584882307472355,
        61.597859620924424,
        61.61083693437649,
        61.62381424782856,
        61.63679156128063,
        61.6497688747327,
        61.66274618818477,
        61.67572350163684,
        61.68870081508891,
        61.701678128540976,
        61.71465544199305,
        61.72763275544512,
        61.74061006889719,
        61.75358738234926,
        61.76656469580133,
        61.7795420092534,
        61.792519322705466,
        61.805496636157535,
        61.818473949609604,
        61.83145126306168,
        61.84442857651375,
        61.85740588996582,
        61.87038320341789,
        61.883360516869956,
        61.896337830322025,
        61.909315143774094,
        61.92229245722616,
        61.93526977067823,
        61.9482470841303,
        61.96122439758238,
        61.974201711034446,
        61.987179024486515,
        62.000156337938584,
        62.01313365139065,
        62.02611096484272,
        62.03908827829479,
        62.05206559174686,
        62.06504290519893,
        62.078020218651005,
        62.090997532103074,
        62.10397484555514,
        62.11695215900721,
        62.12992947245928,
        62.14290678591135,
        62.15588409936342,
        62.16886141281549,
        62.18183872626756,
        62.194816039719626,
        62.2077933531717,
        62.22077066662377,
        62.23374798007584,
        62.24672529352791,
        62.25970260697998,
        62.27267992043205,
        62.285657233884116,
        62.298634547336185,
        62.311611860788254,
        62.32458917424033,
        62.3375664876924,
        62.35054380114447,
        62.36352111459654,
        62.376498428048606,
        62.389475741500675,
        62.402453054952744,
        62.41543036840481,
        62.42840768185688,
        62.44138499530896,
        62.45436230876103,
        62.467339622213096,
        62.480316935665165,
        62.493294249117234,
        62.5062715625693,
        62.51924887602137,
        62.53222618947344,
        62.54520350292551,
        62.55818081637758,
        62.571158129829655,
        62.584135443281724,
        62.59711275673379,
        62.61009007018586,
        62.62306738363793,
        62.63604469709,
        62.64902201054207,
        62.66199932399414,
        62.67497663744621,
        62.687953950898276,
        62.700931264350345,
        62.713908577802414,
        62.72688589125448,
        62.73986320470655,
        62.752840518158635,
        62.765817831610704,
        62.77879514506277,
        62.79177245851484,
        62.80474977196691,
        62.81772708541898,
        62.83070439887105,
        62.84368171232312,
        62.85665902577519,
        62.869636339227256,
        62.882613652679325,
        62.895590966131394,
        62.90856827958346,
        62.92154559303553,
        62.9345229064876,
        62.94750021993967,
        62.96047753339174,
        62.97345484684381,
        62.98643216029588,
        62.99940947374796,
        63.01238678720003,
        63.0253641006521,
        63.03834141410417,
        63.051318727556236,
        63.064296041008305,
        63.077273354460374,
        63.09025066791244,
        63.10322798136451,
        63.11620529481658,
        63.12918260826865,
        63.14215992172072,
        63.15513723517279,
        63.16811454862486,
        63.181091862076926,
        63.194069175528995,
        63.207046488981064,
        63.22002380243313,
        63.2330011158852,
        63.245978429337285,
        63.258955742789354,
        63.27193305624142,
        63.28491036969349,
        63.29788768314556,
        63.31086499659763,
        63.3238423100497,
        63.33681962350177,
        63.34979693695384,
        63.362774250405906,
        63.375751563857975,
        63.388728877310044,
        63.40170619076211,
        63.41468350421418,
        63.42766081766625,
        63.44063813111832,
        63.45361544457039,
        63.46659275802246,
        63.47957007147454
    ],
    LACROSSE: []
};
const $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_20ABCDEF = {
    PLATFORM_TENNIS: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.3869144470794245,
        0.40061183272985823,
        0.4143012300879487,
        0.42798265725323487,
        0.4416561323150622,
        0.455321673352583,
        0.46897929843475616,
        0.48262902562034726,
        0.49627087295792854,
        0.509904858485879,
        0.5235310002323841,
        0.5371493162154362,
        0.5507598244428341,
        0.5643625429121837,
        0.577957489610897,
        0.5915446825161931,
        0.6051241395950975,
        0.6186958788044427,
        0.6322599180908675,
        0.6458162753908174,
        0.6593649686305452,
        0.6729060157261093,
        0.6864394345833758,
        0.6999652430980168,
        0.7134834591555113,
        0.7269941006311449,
        0.7404971853900102,
        0.7539927312870061,
        0.7674807561668382,
        0.7809612778640187,
        0.7944343142028671,
        0.8078998829975086,
        0.821358002051876,
        0.834808689159708,
        0.8482519621045503,
        0.8616878386597557,
        0.8751163365884826,
        0.8885374736436975,
        0.9019512675681722,
        0.915357736094486,
        0.9287568969450246,
        0.9421487678319802,
        0.9555333664573522,
        0.9689107105129464,
        0.982280817680375,
        0.9956437056310572,
        1.0089993920262186,
        1.022347894516892,
        1.035689230743916,
        1.049023418337937,
        1.0623504749194068,
        1.0756704180985852,
        1.0889832654755374,
        1.1022890346401364,
        1.1155877431720609,
        1.1288794086407967,
        1.1421640486056366,
        1.1554416806156798,
        1.1687123222098317,
        1.181975990916805,
        1.1952327042551192,
        1.2084824797330997,
        1.2217253348488792,
        1.2349612870903968,
        1.2481903539353985,
        1.2614125528514366,
        1.2746279012958708,
        1.2878364167158662,
        1.301038116548396,
        1.314233018220239,
        1.3274211391479813,
        1.3406024967380155,
        1.3537771083865406,
        1.3669449914795626,
        1.3801061633928944,
        1.3932606414921547,
        1.4064084431327697,
        1.4195495856599718,
        1.4326840864088006,
        1.445811962704102,
        1.4589332318605281,
        1.4720479111825386,
        1.4851560179643994,
        1.4982575694901832,
        1.511352583033769,
        1.524441075858843,
        1.5375230652188978,
        1.5505985683572325,
        1.5636676025069531,
        1.5767301848909725,
        1.5897863327220099,
        1.602836063202591,
        1.615879393525049,
        1.628916340871523,
        1.641946922413959,
        1.6549711553141095,
        1.6679890567235338,
        1.6810006437835983,
        1.6940059336254754,
        1.7070049433701446,
        1.7199976901283918,
        1.73298419100081,
        1.745964463077798,
        1.7589385234395623,
        1.7719063891561155,
        1.7848680772872771,
        1.7978236048826728,
        1.8107729889817357,
        1.8237162466137051,
        1.8366533947976271,
        1.8495844505423544,
        1.8625094308465464,
        1.8754283526986693,
        1.8883412330769958,
        1.901248088949605,
        1.9141489372743834,
        1.9270437949990238,
        1.9399326790610254,
        1.9528156063876947,
        1.9656925938961443,
        1.9785636584932933,
        1.991428817075868,
        2.004288086530402,
        2.017141483733233,
        2.0299890255505093,
        2.042830728838182,
        2.0556666104420116,
        2.068496687197564,
        2.0813209759302116,
        2.0941394934551347,
        2.1069522565773187,
        2.119759282091557,
        2.1325605867824486,
        2.1453561874244005,
        2.1581461007816247,
        2.1709303436081413,
        2.183708932647776,
        2.196481884634162,
        2.209249216290739,
        2.2220109443307527,
        2.234767085457257,
        2.2475176563631103,
        2.2602626737309794,
        2.273002154233337,
        2.285736114532463,
        2.298464571280444,
        2.3111875411191716,
        2.323905040680346,
        2.3366170865854743,
        2.3493236954458685,
        2.3620248838626487,
        2.3747206684267406,
        2.387411065718878,
        2.4000960923095995,
        2.4127757647592523,
        2.4254500996179886,
        2.4381191134257687,
        2.4507828227123585,
        2.463441243997331,
        2.4760943937900666,
        2.48874228858975,
        2.5013849448853755,
        2.514022379155743,
        2.526654607869458,
        2.539281647484933,
        2.5519035144503897,
        2.5645202252038524,
        2.577131796173155,
        2.5897382437759373,
        2.6023395844196453,
        2.6149358345015323,
        2.627527010408658,
        2.6401131285178887,
        2.6526942051958975,
        2.665270256799164,
        2.677841299673975,
        2.690407350156423,
        2.7029684245724077,
        2.715524539237636,
        2.7280757104576208,
        2.740621954527682,
        2.7531632877329457,
        2.765699726348345,
        2.77823128663862,
        2.790757984858317,
        2.803279837251789,
        2.8157968600531955,
        2.8283090694865036,
        2.840816481765486,
        2.8533191130937228,
        2.8658169796646,
        2.8783100976613114,
        2.890798483256856,
        2.903282152614041,
        2.915761121885479,
        2.92823540721359,
        2.9407050247306006,
        2.9531699905585445,
        2.9656303208092605,
        2.9780860315843958,
        2.9905371389754034,
        3.002983659063543,
        3.015425607919881,
        3.0278630016052914,
        3.040295856170453,
        3.052724187655853,
        3.0651480120917847,
        3.0775673454983474,
        3.089982203885448,
        3.1023926032528,
        3.1147985595899232,
        3.127200088876144,
        3.139597207080595,
        3.1519899301622174,
        3.164378274069757,
        3.176762254741767,
        3.1891418881066076,
        3.2015171900824453,
        3.213888176577253,
        3.2262548634888115,
        3.238617266704707,
        3.2509754021023327,
        3.2633292855488882,
        3.2756789329013807,
        3.2880243600066232,
        3.300365582701236,
        3.3127026168116456,
        3.325035478154085,
        3.337364182534594,
        3.3496887457490203,
        3.3620091835830164,
        3.3743255118120423,
        3.3866377462013655,
        3.3989459025060578,
        3.4112499964710006,
        3.42355004383088,
        3.4358460603101895,
        3.4481380616232293,
        3.460426063474105,
        3.472710081556732,
        3.4849901315548286,
        3.497266229141922,
        3.509538389981346,
        3.5218066297262403,
        3.5340709640195516,
        3.5463314084940336,
        3.558587978772246,
        3.5708406904665555,
        3.5830895591791356,
        3.595334600501967,
        3.6075758300168355,
        3.6198132632953355,
        3.6320469158988664,
        3.644276803378635,
        3.6565029412756545,
        3.668725345120746,
        3.6809440304345356,
        3.693159012727457,
        3.70537030749975,
        3.7175779302414615,
        3.729781896432445,
        3.7419822215423606,
        3.7541789210306757,
        3.7663720103466636,
        3.778561504929403,
        3.790747420207783,
        3.8029297716004953,
        3.8151085745160414,
        3.827283844352727,
        3.839455596498666,
        3.851623846331779,
        3.863788609219793,
        3.8759499005202405,
        3.8881077355804625,
        3.9002621297376057,
        3.9124130983186234,
        3.9245606566402764,
        3.936704820009131,
        3.948845603721561,
        3.9609830230637475,
        3.973117093311676,
        3.98524782973114,
        3.997375247577741,
        4.009499362096886,
        4.021620188523786,
        4.033737742083464,
        4.0458520379907466,
        4.057963091450266,
        4.070070917656464,
        4.082175531793586,
        4.094276949035687,
        4.106375184546628,
        4.118470253480073,
        4.130562170979498,
        4.142650952178183,
        4.154736612199215,
        4.166819166155485,
        4.178898629149698,
        4.190975016274358,
        4.20304834261178,
        4.215118623234082,
        4.227185873203194,
        4.2392501075708475,
        4.2513113413785835,
        4.263369589657749,
        4.275424867429499,
        4.287477189704792,
        4.299526571484396,
        4.311573027758885,
        4.323616573508637,
        4.335657223703843,
        4.3476949933044935,
        4.35972989726039,
        4.371761950511139,
        4.383791167986156,
        4.39581756460466,
        4.407841155275678,
        4.419861954898043,
        4.431879978360398,
        4.443895240541188,
        4.455907756308667,
        4.467917540520896,
        4.479924608025742,
        4.491928973660878,
        4.503930652253786,
        4.515929658621752,
        4.527926007571869,
        4.53991971390104,
        4.551910792395969,
        4.563899257833172,
        4.575885124978969,
        4.587868408589487,
        4.59984912341066,
        4.611827284178228,
        4.6238029056177385,
        4.635776002444546,
        4.647746589363809,
        4.659714681070497,
        4.671680292249383,
        4.683643437575047,
        4.695604131711877,
        4.707562389314066,
        4.719518225025615,
        4.731471653480331,
        4.743422689301829,
        4.755371347103528,
        4.767317641488655,
        4.779261587050246,
        4.791203198371139,
        4.803142490023984,
        4.815079476571234,
        4.827014172565147,
        4.838946592547794,
        4.850876751051046,
        4.862804662596585,
        4.874730341695899,
        4.88665380285028,
        4.89857506055083,
        4.910494129278455,
        4.922411023503872,
        4.934325757687597,
        4.946238346279962,
        4.958148803721098,
        4.970057144440945,
        4.981963382859254,
        4.9938675333855755,
        5.005769610419271,
        5.017669628349508,
        5.029567601555262,
        5.04146354440531,
        5.053357471258244,
        5.0652493964624545,
        5.077139334356144,
        5.089027299267318,
        5.100913305513793,
        5.112797367403188,
        5.124679499232931,
        5.136559715290256,
        5.148438029852202,
        5.16031445718562,
        5.172189011547161,
        5.184061707183286,
        5.195932558330265,
        5.207801579214168,
        5.219668784050879,
        5.231534187046084,
        5.243397802395278,
        5.25525964428376,
        5.267119726886641,
        5.278978064368831,
        5.290834670885051,
        5.302689560579832,
        5.314542747587506,
        5.326394246032212,
        5.338244070027901,
        5.350092233678325,
        5.361938751077044,
        5.3737836363074285,
        5.38562690344265,
        5.39746856654569,
        5.4093086396693355,
        5.421147136856183,
        5.4329840721386295,
        5.444819459538886,
        5.456653313068965,
        5.468485646730687,
        5.48031647451568,
        5.492145810405379,
        5.503973668371024,
        5.515800062373662,
        5.527625006364149,
        5.539448514283143,
        5.551270600061115,
        5.563091277618336,
        5.57491056086489,
        5.586728463700663,
        5.598545000015347,
        5.610360183688447,
        5.622174028589268,
        5.6339865485769245,
        5.645797757500338,
        5.657607669198237,
        5.669416297499153,
        5.681223656221429,
        5.693029759173213,
        5.704834620152458,
        5.716638252946924,
        5.728440671334182,
        5.740241889081604,
        5.75204191994637,
        5.76384077767547,
        5.775638476005696,
        5.787435028663651,
        5.7992304493657425,
        5.8110247518181835,
        5.822817949716995,
        5.834610056748006,
        5.84640108658685,
        5.858191052898968,
        5.8699799693396075,
        5.881767849553823,
        5.893554707176476,
        5.905340555832234,
        5.91712540913557,
        5.9289092806907675,
        5.940692184091913,
        5.9524741329229,
        5.96425514075743,
        5.9760352211590115,
        5.987814387680959,
        5.999592653866392,
        6.01137003324824,
        6.023146539349236,
        6.034922185681922,
        6.046696985748646,
        6.058470953041561,
        6.070244101042629,
        6.082016443223619,
        6.093787993046102,
        6.105558763961463,
        6.1173287694108875,
        6.129098022825371,
        6.140866537625713,
        6.152634327222523,
        6.164401405016215,
        6.17616778439701,
        6.187933478744935,
        6.199698501429825,
        6.211462865811323,
        6.223226585238874,
        6.234989673051735,
        6.2467521425789645,
        6.258514007139432,
        6.270275280041812,
        6.282035974584585,
        6.29379610405604,
        6.30555568173427,
        6.317314720887177,
        6.329073234772469,
        6.340831236637661,
        6.352588739720073,
        6.3643457572468325,
        6.376102302434876,
        6.387858388490943,
        6.399614028611583,
        6.41136923598315,
        6.423124023781804,
        6.434878405173514,
        6.4466323933140535,
        6.458386001349005,
        6.470139242413757,
        6.481892129633502,
        6.493644676123244,
        6.505396894987788,
        6.51714879932175,
        6.528900402209552,
        6.54065171672542,
        6.55240275593339,
        6.564153532887304,
        6.575904060630809,
        6.587654352197359,
        6.599404420610216,
        6.611154278882449,
        6.62290394001693,
        6.634653417006343,
        6.646402722833175,
        6.6581518704697205,
        6.66990087287808,
        6.681649743010163,
        6.693398493807684,
        6.705147138202164,
        6.7168956891149305,
        6.728644159457119,
        6.74039256212967,
        6.752140910023333,
        6.7638892160186606,
        6.775637492986016,
        6.787385753785567,
        6.799134011267288,
        6.8108822782709595,
        6.822630567626171,
        6.834378892152317,
        6.846127264658597,
        6.8578756979440225,
        6.8696242047974065,
        6.881372797997369,
        6.89312149031234,
        6.904870294500554,
        6.916619223310052,
        6.928368289478682,
        6.940117505734099,
        6.951866884793764,
        6.963616439364946,
        6.975366182144719,
        6.987116125819966,
        6.998866283067373,
        7.010616666553435,
        7.022367288934457,
        7.034118162856542,
        7.045869300955608,
        7.057620715857376,
        7.069372420177373,
        7.081124426520935,
        7.092876747483205,
        7.104629395649128,
        7.11638238359346,
        7.128135723880764,
        7.1398894290654065,
        7.151643511691562,
        7.163397984293214,
        7.1751528593941485,
        7.186908149507963,
        7.198663867138057,
        7.2104200247776395,
        7.222176634909725,
        7.233933710007135,
        7.245691262532498,
        7.25744930493825,
        7.26920784966663,
        7.280966909149688,
        7.292726495809281,
        7.304486622057066,
        7.316247300294513,
        7.328008542912899,
        7.339770362293304,
        7.3515327708066165,
        7.36329578081353,
        7.375059404664549,
        7.386823654699979,
        7.3985885432499385,
        7.410354082634344,
        7.422120285162928,
        7.433887163135226,
        7.445654728840576,
        7.457422994558128,
        7.469191972556837,
        7.4809616750954655,
        7.492732114422581,
        7.504503302776558,
        7.51627525238558,
        7.528047975467634,
        7.539821484230515,
        7.551595790871826,
        7.563370907578973,
        7.575146846529173,
        7.586923619889447,
        7.598701239816624,
        7.610479718457338,
        7.62225906794803,
        7.634039300414952,
        7.645820427974156,
        7.657602462731504,
        7.669385416782665,
        7.681169302213115,
        7.6929541310981335,
        7.7047399155028105,
        7.716526667482041,
        7.728314399080526,
        7.740103122332775,
        7.751892849263103,
        7.763683591885631,
        7.775475362204287,
        7.7872681722128085,
        7.799062033894734,
        7.810856959223416,
        7.822652960162006,
        7.834450048663468,
        7.8462482366705695,
        7.858047536115885,
        7.869847958921797,
        7.881649517000496,
        7.893452222253974,
        7.905256086574035,
        7.917061121842286,
        7.928867339930144,
        7.940674752698828,
        7.95248337199937,
        7.964293209672603,
        7.97610427754917,
        7.987916587449518,
        7.999730151183903,
        8.011544980552387,
        8.023361087344838,
        8.035178483340935,
        8.046997180310154,
        8.058817190011787,
        8.07063852419493,
        8.082461194598482,
        8.094285212951153,
        8.106110590971458,
        8.11793734036772,
        8.129765472838066,
        8.141595000070433,
        8.153425933742561,
        8.165258285522002,
        8.177092067066107,
        8.188927290022042,
        8.200763966026772,
        8.212602106707074,
        8.22444172367953,
        8.236282828550529,
        8.248125432916265,
        8.259969548362742,
        8.271815186465766,
        8.283662358790954,
        8.295511076893728,
        8.307361352319317,
        8.319213196602757,
        8.331066621268887,
        8.342921637832358,
        8.354778257797625,
        8.366636492658952,
        8.378496353900402,
        8.390357852995857,
        8.402221001408995,
        8.414085810593306,
        8.425952291992084,
        8.437820457038434,
        8.449690317155262,
        8.461561883755286,
        8.473435168241025,
        8.48531018200481,
        8.497186936428776,
        8.509065442884863,
        8.520945712734822,
        8.532827757330208,
        8.544711588012385,
        8.556597216112518,
        8.568484652951584,
        8.580373909840366,
        8.592264998079452,
        8.60415792895924,
        8.616052713759927,
        8.627949363751526,
        8.639847890193849,
        8.651748304336522,
        8.663650617418973,
        8.675554840670435,
        8.687460985309952,
        8.699369062546374,
        8.711279083578352,
        8.723191059594354,
        8.735105001772645,
        8.747020921281301,
        8.758938829278208,
        8.770858736911048,
        8.782780655317321,
        8.79470459562433,
        8.806630568949181,
        8.818558586398792,
        8.830488659069882,
        8.842420798048984,
        8.85435501441243,
        8.866291319226365,
        8.878229723546736,
        8.8901702384193,
        8.902112874879618,
        8.914057643953061,
        8.926004556654801,
        8.937953623989822,
        8.949904856952914,
        8.961858266528672,
        8.9738138636915,
        8.985771659405604,
        8.997731664624999,
        9.00969389029351,
        9.021658347344765,
        9.0336250467022,
        9.045593999279056,
        9.057565215978384,
        9.069538707693038,
        9.08151448530568,
        9.093492559688782,
        9.105472941704615,
        9.117455642205266,
        9.129440672032622,
        9.141428042018378,
        9.153417762984038,
        9.165409845740909,
        9.177404301090107,
        9.189401139822555,
        9.201400372718984,
        9.213402010549926,
        9.225406064075726,
        9.237412544046531,
        9.2494214612023,
        9.261432826272792,
        9.273446649977576,
        9.285462943026031,
        9.297481716117337,
        9.309502979940484,
        9.32152674517427,
        9.33355302248729,
        9.34558182253796,
        9.357613155974496,
        9.369647033434916,
        9.38168346554705,
        9.393722462928537,
        9.405764036186817,
        9.41780819591914,
        9.42985495271256,
        9.441904317143942,
        9.453956299779955,
        9.466010911177072,
        9.478068161881579,
        9.490128062429562,
        9.50219062334692,
        9.514255855149353,
        9.52632376834237,
        9.538394373421289,
        9.55046768087123,
        9.562543701167126,
        9.57462244477371,
        9.586703922145523,
        9.598788143726917,
        9.610875119952047,
        9.622964861244876,
        9.635057378019173,
        9.647152680678511,
        9.659250779616277,
        9.671351685215662,
        9.683455407849653,
        9.69556195788106,
        9.70767134566249,
        9.71978358153636,
        9.73189867583489,
        9.744016638880112,
        9.75613748098386,
        9.768261212447777,
        9.780387843563314,
        9.792517384611727,
        9.804649845864075,
        9.81678523758123,
        9.828923570013869,
        9.84106485340247,
        9.853209097977327,
        9.865356313958536,
        9.877506511555996,
        9.88965970096942,
        9.90181589238832,
        9.913975095992024,
        9.926137321949657,
        9.938302580420157,
        9.950470881552265,
        9.96264223548453,
        9.974816652345313,
        9.98699414225277,
        9.999174715314876,
        10.011358381629401,
        10.023545151283935,
        10.035735034355861,
        10.047928040912378,
        10.060124181010488,
        10.072323464697003,
        10.084525902008535,
        10.09673150297151,
        10.108940277602155,
        10.121152235906507,
        10.133367387880407,
        10.145585743509509,
        10.157807312769265,
        10.170032105624937,
        10.1822601320316,
        10.194491401934124,
        10.206725925267195,
        10.218963711955302,
        10.231204771912742,
        10.243449115043616,
        10.255696751241832,
        10.267947690391109,
        10.28020194236497,
        10.292459517026744,
        10.304720424229567,
        10.31698467381638,
        10.329252275619934,
        10.341523239462788,
        10.3537975751573,
        10.36607529250564,
        10.378356401299788,
        10.390640911321523,
        10.402928832342436,
        10.415220174123926,
        10.42751494641719,
        10.439813158963242,
        10.452114821492895,
        10.464419943726776,
        10.476728535375312,
        10.489040606138738,
        10.5013561657071,
        10.513675223760245,
        10.52599778996783,
        10.538323873989318,
        10.550653485473982,
        10.562986634060891,
        10.575323329378934,
        10.587663581046796,
        10.600007398672977,
        10.61235479185578,
        10.624705770183311,
        10.63706034323349,
        10.649418520574038,
        10.661780311762486,
        10.674145726346167,
        10.686514773862228,
        10.698887463837616,
        10.71126380578909,
        10.723643809223212,
        10.736027483636349,
        10.748414838514678,
        10.760805883334186,
        10.773200627560659,
        10.785599080649693,
        10.798001252046694,
        10.810407151186869,
        10.822816787495237,
        10.835230170386616,
        10.84764730926564,
        10.860068213526747,
        10.872492892554174,
        10.884921355721977,
        10.897353612394008,
        10.90978967192393,
        10.922229543655217,
        10.93467323692114,
        10.947120761044788,
        10.959572125339045,
        10.972027339106612,
        10.984486411639987,
        10.996949352221487,
        11.009416170123218,
        11.021886874607114,
        11.0343614749249,
        11.04683998031811,
        11.05932240001809,
        11.07180874324599,
        11.084299019212766,
        11.096793237119181,
        11.109291406155805,
        11.121793535503013,
        11.13429963433099,
        11.146809711799724,
        11.159323777059015,
        11.171841839248462,
        11.184363907497476,
        11.196889990925277,
        11.209420098640882,
        11.221954239743125,
        11.234492423320642,
        11.247034658451875,
        11.259580954205076,
        11.2721313196383,
        11.28468576379941,
        11.297244295726076,
        11.309806924445775,
        11.32237365897579,
        11.334944508323211,
        11.347519481484932,
        11.360098587447663,
        11.372681835187906,
        11.385269233671982,
        11.397860791856013,
        11.410456518685931,
        11.42305642309747,
        11.435660514016176,
        11.448268800357393,
        11.460881291026283,
        11.47349799491781,
        11.48611892091674,
        11.498744077897651,
        11.511373474724929,
        11.52400712025276,
        11.536645023325143,
        11.54928719277588,
        11.56193363742858,
        11.574584366096664,
        11.587239387583352,
        11.599898710681675,
        11.612562344174467,
        11.625230296834374,
        11.637902577423846,
        11.65057919469514,
        11.663260157390319,
        11.675945474241251,
        11.688635153969614,
        11.701329205286894,
        11.714027636894377,
        11.72673045748316,
        11.73943767573415,
        11.752149300318054,
        11.764865339895389,
        11.777585803116478,
        11.790310698621454,
        11.803040035040251,
        11.815773820992613,
        11.82851206508809,
        11.841254775926037,
        11.854001962095621,
        11.866753632175811,
        11.87950979473538,
        11.892270458332918,
        11.90503563151681,
        11.917805322825256,
        11.930579540786255,
        11.943358293917623,
        11.956141590726972,
        11.968929439711728,
        11.98172184935912,
        11.994518828146186,
        12.007320384539765,
        12.020126526996515,
        12.032937263962888,
        12.045752603875146,
        12.058572555159362,
        12.071397126231414,
        12.08422632549698,
        12.097060161351557,
        12.109898642180436,
        12.122741776358724,
        12.135589572251332,
        12.148442038212973,
        12.161299182588175,
        12.174161013711263,
        12.187027539906378,
        12.199898769487463,
        12.212774710758266,
        12.225655372012348,
        12.238540761533068,
        12.251430887593598,
        12.264325758456915,
        12.277225382375804,
        12.290129767592854,
        12.30303892234046,
        12.315952854840829,
        12.32887157330597,
        12.341795085937697,
        12.35472340092764,
        12.367656526457223,
        12.380594470697686,
        12.393537241810073,
        12.406484847945233,
        12.419437297243821,
        12.432394597836307,
        12.445356757842953,
        12.458323785373844,
        12.471295688528858,
        12.484272475397688,
        12.497254154059828,
        12.510240732584586,
        12.523232219031069,
        12.536228621448197,
        12.549229947874691,
        12.562236206339081,
        12.575247404859708,
        12.58826355144471,
        12.601284654092042,
        12.61431072078946,
        12.627341759514524,
        12.64037777823461,
        12.653418784906892,
        12.666464787478356,
        12.679515793885786,
        12.692571812055787,
        12.70563284990476,
        12.718698915338912,
        12.731770016254265,
        12.74484616053664,
        12.75792735606167,
        12.771013610694787,
        12.784104932291239,
        12.797201328696074,
        12.810302807744153,
        12.823409377260136,
        12.836521045058497,
        12.849637818943506,
        12.862759706709255,
        12.87588671613963,
        12.88901885500833,
        12.902156131078856,
        12.915298552104522,
        12.928446125828444,
        12.941598859983545,
        12.954756762292558,
        12.967919840468014,
        12.981088102212265,
        12.994261555217454,
        13.007440207165544,
        13.020624065728294,
        13.03381313856728,
        13.047007433333874,
        13.060206957669264,
        13.073411719204437,
        13.086621725560192,
        13.099836984347133,
        13.11305750316567,
        13.126283289606022,
        13.13951435124821,
        13.152750695662068,
        13.165992330407226,
        13.179239263033137,
        13.192491501079047,
        13.205749052074014,
        13.219011923536902,
        13.232280122976382,
        13.24555365789093,
        13.25883253576883,
        13.272116764088173,
        13.285406350316858,
        13.298701301912587,
        13.312001626322871,
        13.325307330985028,
        13.338618423326182,
        13.351934910763262,
        13.365256800703005,
        13.378584100541957,
        13.391916817666468,
        13.405254959452698,
        13.418598533266605,
        13.431947546463965,
        13.445302006390351,
        13.45866192038115,
        13.472027295761553,
        13.485398139846556,
        13.498774459940963,
        13.512156263339387,
        13.525543557326241,
        13.538936349175753,
        13.552334646151952,
        13.565738455508674,
        13.579147784489566,
        13.592562640328078,
        13.605983030247465,
        13.619408961460794,
        13.632840441170934,
        13.646277476570564,
        13.659720074842166,
        13.673168243158031,
        13.68662198868026,
        13.700081318560752,
        13.713546239941222,
        13.727016759953184,
        13.740492885717964,
        13.753974624346693,
        13.767461982940308,
        13.780954968589551,
        13.794453588374978,
        13.807957849366941,
        13.821467758625607,
        13.834983323200946,
        13.848504550132738,
        13.862031446450562,
        13.875564019173813,
        13.889102275311686,
        13.902646221863188,
        13.916195865817128,
        13.929751214152125,
        13.9433122738366,
        13.956879051828786,
        13.970451555076721,
        13.984029790518248,
        13.99761376508102,
        14.011203485682488,
        14.024798959229928,
        14.038400192620399,
        14.052007192740785,
        14.06561996646777,
        14.079238520667843,
        14.092862862197302,
        14.106492997902253,
        14.120128934618602,
        14.133770679172075,
        14.147418238378188,
        14.161071619042277,
        14.174730827959475,
        14.18839587191473,
        14.202066757682795,
        14.215743492028222,
        14.22942608170538,
        14.243114533458437,
        14.25680885402137,
        14.270509050117965,
        14.284215128461817,
        14.297927095756316,
        14.31164495869467,
        14.32536872395989,
        14.339098398224793,
        14.352833988152005,
        14.366575500393955,
        14.380322941592881,
        14.39407631838083,
        14.40783563737965,
        14.421600905200998,
        14.43537212844634,
        14.449149313706949,
        14.462932467563899,
        14.476721596588076,
        14.49051670734017,
        14.50431780637068,
        14.518124900219913,
        14.531937995417975,
        14.545757098484787,
        14.559582215930071,
        14.573413354253361,
        14.587250519943991,
        14.60109371948111,
        14.614942959333666,
        14.628798245960414,
        14.642659585809927,
        14.656526985320568,
        14.67040045092052,
        14.684279989027763,
        14.69816560605009,
        14.712057308385102,
        14.725955102420198,
        14.739858994532591,
        14.753768991089302,
        14.767685098447151,
        14.781607322952773,
        14.795535670942604,
        14.809470148742887,
        14.823410762669674,
        14.837357519028824,
        14.851310424116003,
        14.865269484216679,
        14.879234705606128,
        14.893206094549443,
        14.907183657301506,
        14.92116740010702,
        14.935157329200486,
        14.949153450806218,
        14.963155771138334,
        14.977164296400758,
        14.991179032787219,
        15.00519998648126,
        15.01922716365622,
        15.033260570475253,
        15.047300213091319,
        15.061346097647176,
        15.075398230275402,
        15.08945661709837,
        15.10352126422827,
        15.117592177767088,
        15.131669363806624,
        15.145752828428485,
        15.159842577704078,
        15.173938617694624,
        15.188040954451147,
        15.202149594014475,
        15.216264542415251,
        15.230385805673917,
        15.244513389800725,
        15.258647300795731,
        15.272787544648804,
        15.286934127339611,
        15.301087054837632,
        15.31524633310215,
        15.32941196808226,
        15.343583965716856,
        15.357762331934646,
        15.37194707265414,
        15.386138193783655,
        15.400335701221316,
        15.414539600855056,
        15.428749898562609,
        15.442966600211525,
        15.457189711659153,
        15.47141923875265,
        15.485655187328982,
        15.499897563214923,
        15.514146372227042,
        15.528401620171733,
        15.542663312845187,
        15.556931456033396,
        15.571206055512171,
        15.585487117047117,
        15.599774646393659,
        15.614068649297018,
        15.628369131492224,
        15.642676098704118,
        15.656989556647344,
        15.671309511026353,
        15.685635967535404,
        15.69996893185856,
        15.714308409669695,
        15.728654406632485,
        15.743006928400414,
        15.757365980616777,
        15.771731568914669,
        15.786103698916998,
        15.800482376236474,
        15.814867606475612,
        15.82925939522674,
        15.84365774807199,
        15.858062670583301,
        15.872474168322412,
        15.88689224684088,
        15.901316911680064,
        15.915748168371126,
        15.930186022435038,
        15.944630479382576,
        15.959081544714332,
        15.973539223920689,
        15.988003522481849,
        16.00247444586782,
        16.01695199953841,
        16.031436188943236,
        16.045927019521727,
        16.06042449670311,
        16.074928625906427,
        16.089439412540518,
        16.103956862004043,
        16.118480979685454,
        16.133011770963016,
        16.147549241204803,
        16.162093395768693,
        16.176644240002368,
        16.191201779243322,
        16.205766018818853,
        16.22033696404607,
        16.234914620231876,
        16.249498992672997,
        16.26409008665595,
        16.27868790745708,
        16.29329246034251,
        16.307903750568194,
        16.322521783379884,
        16.337146564013132,
        16.35177809769331,
        16.366416389635585,
        16.38106144504494,
        16.395713269116154,
        16.410371867033824,
        16.425037243972344,
        16.439709405095925,
        16.45438835555857,
        16.469074100504105,
        16.48376664506615,
        16.498465994368143,
        16.513172153523318,
        16.52788512763472,
        16.5426049217952,
        16.557331541087414,
        16.572064990583836,
        16.586805275346734,
        16.60155240042818,
        16.616306370870067,
        16.631067191704084,
        16.64583486795173,
        16.66060940462431,
        16.675390806722934,
        16.69017907923852,
        16.704974227151798,
        16.719776255433292,
        16.73458516904335,
        16.749400972932108,
        16.764223672039527,
        16.779053271295357,
        16.793889775619167,
        16.80873318992033,
        16.82358351909802,
        16.83844076804123,
        16.853304941628743,
        16.868176044729164,
        16.883054082200896,
        16.89793905889215,
        16.912830979640944,
        16.927729849275103,
        16.942635672612266,
        16.95754845445986,
        16.972468199615136,
        16.987394912865152,
        17.002328598986754,
        17.017269262746616,
        17.032216908901212,
        17.04717154219681,
        17.062133167369506,
        17.077101789145182,
        17.092077412239547,
        17.1070600413581,
        17.122049681196152,
        17.137046336438825,
        17.152050011761045,
        17.16706071182754,
        17.18207844129285,
        17.19710320480132,
        17.212135006987104,
        17.22717385247416,
        17.242219745876252,
        17.257272691796953,
        17.272332694829643,
        17.287399759557506,
        17.30247389055353,
        17.31755509238052,
        17.33264336959108,
        17.347738726727616,
        17.362841168322355,
        17.37795069889732,
        17.393067322964338,
        17.408191045025053,
        17.42332186957091,
        17.43845980108316,
        17.45360484403286,
        17.468757002880878,
        17.483916282077885,
        17.49908268606436,
        17.514256219270585,
        17.52943688611666,
        17.544624691012476,
        17.55981963835774,
        17.575021732541966,
        17.590230977944476,
        17.60544737893439,
        17.62067093987064,
        17.635901665101965,
        17.651139558966914,
        17.666384625793835,
        17.681636869900892,
        17.696896295596048,
        17.71216290717707,
        17.727436708931545,
        17.742717705136855,
        17.758005900060187,
        17.773301297958547,
        17.788603903078737,
        17.803913719657373,
        17.819230751920866,
        17.834555004085452,
        17.849886480357153,
        17.865225184931816,
        17.880571121995082,
        17.895924295722406,
        17.91128471027904,
        17.926652369820058,
        17.94202727849033,
        17.95740944042453,
        17.97279885974715,
        17.988195540572477,
        18.003599487004614,
        18.019010703137464,
        18.03442919305474,
        18.04985496082996,
        18.065288010526455,
        18.08072834619735,
        18.096175971885586,
        18.111630891623907,
        18.12709310943487,
        18.142562629330833,
        18.158039455313958,
        18.173523591376217,
        18.189015041499395,
        18.204513809655072,
        18.220019899804644,
        18.235533315899303,
        18.251054061880065,
        18.266582141677734,
        18.282117559212935,
        18.29766031839609,
        18.31321042312743,
        18.328767877296993,
        18.344332684784632,
        18.359904849459994,
        18.375484375182538,
        18.391071265801532,
        18.406665525156043,
        18.42226715707496,
        18.43787616537696,
        18.453492553870536,
        18.46911632635399,
        18.484747486615426,
        18.500386038432758,
        18.516031985573704,
        18.53168533179579,
        18.547346080846346,
        18.563014236462514,
        18.57868980237124,
        18.594372782289277,
        18.61006317992318,
        18.625760998969316,
        18.64146624311386,
        18.65717891603279,
        18.67289902139189,
        18.688626562846753,
        18.704361544042783,
        18.720103968615177,
        18.735853840188955,
        18.751611162378936,
        18.767375938789737,
        18.7831481730158,
        18.79892786864136,
        18.814715029240464,
        18.83050965837696,
        18.846311759604514,
        18.86212133646659,
        18.87793839249646,
        18.8937629312172,
        18.9095949561417,
        18.925434470772647,
        18.94128147860255,
        18.957135983113705,
        18.972997987778225,
        18.988867496058038,
        19.004744511404862,
        19.020629037260235,
        19.03652107705549,
        19.052420634211778,
        19.068327712140047,
        19.084242314241056,
        19.10016444390538,
        19.116094104513383,
        19.132031299435248,
        19.147976032030957,
        19.163928305650305,
        19.179888123632892,
        19.19585548930812,
        19.211830405995208,
        19.22781287700317,
        19.243802905630837,
        19.259800495166836,
        19.27580564888961,
        19.2918183700674,
        19.307838661958268,
        19.32386652781006,
        19.339901970860456,
        19.355944994336923,
        19.371995601456735,
        19.388053795426984,
        19.404119579444558,
        19.420192956696166,
        19.4362739303583,
        19.452362503597286,
        19.468458679569235,
        19.484562461420076,
        19.500673852285537,
        19.51679285529117,
        19.532919473552305,
        19.549053710174107,
        19.56519556825153,
        19.581345050869334,
        19.597502161102103,
        19.61366690201421,
        19.629839276659844,
        19.646019288083,
        19.662206939317464,
        19.67840223338686,
        19.69460517330459,
        19.710815762073878,
        19.727034002687745,
        19.74325989812903,
        19.759493451370364,
        19.775734665374202,
        19.79198354309279,
        19.808240087468192,
        19.824504301432274,
        19.840776187906705,
        19.85705574980297,
        19.873342990022348,
        19.88963791145594,
        19.90594051698464,
        19.922250809479152,
        19.938568791799998,
        19.954894466797487,
        19.97122783731175,
        19.987568906172722,
        20.003917676200135,
        20.020274150203544,
        20.036638330982296,
        20.053010221325557,
        20.069389824012287,
        20.085777141811256,
        20.10217217748105,
        20.118574933770056,
        20.134985413416462,
        20.151403619148272,
        20.167829553683287,
        20.184263219729125,
        20.200704619983203,
        20.217153757132746,
        20.23361063385479,
        20.250075252816174,
        20.266547616673538,
        20.283027728073346,
        20.299515589651847,
        20.316011204035117,
        20.33251457383902,
        20.34902570166924,
        20.365544590121264,
        20.382071241780384,
        20.398605659221698,
        20.415147845010114,
        20.431697801700345,
        20.44825553183691,
        20.464821037954135,
        20.481394322576154,
        20.497975388216904,
        20.514564237380135,
        20.531160872559397,
        20.547765296238055,
        20.56437751088927,
        20.580997518976012,
        20.597625322951064,
        20.61426092525702,
        20.630904328326263,
        20.647555534580995,
        20.664214546433225,
        20.680881366284765,
        20.69755599652723,
        20.714238439542054,
        20.730928697700467,
        20.74762677336351,
        20.764332668882023,
        20.781046386596664,
        20.797767928837896,
        20.81449729792598,
        20.831234496170985,
        20.847979525872802,
        20.864732389321112,
        20.88149308879541,
        20.898261626564988,
        20.915038004888963,
        20.931822226016244,
        20.94861429218555,
        20.9654142056254,
        20.982221968554143,
        20.999037583179906,
        21.01586105170064,
        21.0326923763041,
        21.049531559167846,
        21.06637860245924,
        21.083233508335454,
        21.100096278943475,
        21.116966916420086,
        21.133845422891874,
        21.150731800475253,
        21.167626051276415,
        21.184528177391385,
        21.20143818090597,
        21.218356063895808,
        21.235281828426327,
        21.25221547655277,
        21.26915701032018,
        21.28610643176341,
        21.30306374290712,
        21.32002894576578,
        21.337002042343663,
        21.353983034634844,
        21.370971924623213,
        21.38796871428246,
        21.404973405576094,
        21.421986000457412,
        21.43900650086953,
        21.45603490874537,
        21.473071226007654,
        21.49011545456892,
        21.507167596331506,
        21.52422765318756,
        21.541295627019032,
        21.558371519697687,
        21.575455333085085,
        21.592547069032605,
        21.609646729381424,
        21.62675431596253,
        21.643869830596714,
        21.66099327509458,
        21.678124651256528,
        21.69526396087278,
        21.712411205723352,
        21.729566387578064,
        21.746729508196562,
        21.76390056932828,
        21.78107957271246,
        21.798266520078162,
        21.815461413144245,
        21.83266425361937,
        21.849875043202022,
        21.867093783580465,
        21.8843204764328,
        21.901555123426913,
        21.91879772622051,
        21.93604828646109,
        21.95330680578597,
        21.97057328582227,
        21.987847728186917,
        22.005130134486645,
        22.022420506317992,
        22.039718845267302,
        22.05702515291074,
        22.074339430814256,
        22.091661680533615,
        22.1089919036144,
        22.126330101591982,
        22.143676275991556,
        22.161030428328107,
        22.17839256010644,
        22.195762672821164,
        22.21314076795668,
        22.230526846987225,
        22.247920911376816,
        22.265322962579294,
        22.28273300203829,
        22.30015103118725,
        22.317577051449437,
        22.335011064237907,
        22.352453070955526,
        22.36990307299497,
        22.387361071738713,
        22.404827068559044,
        22.42230106481806,
        22.439783061867665,
        22.457273061049552,
        22.474771063695247,
        22.492277071126068,
        22.509791084653134,
        22.52731310557739,
        22.54484313518957,
        22.56238117477022,
        22.579927225589696,
        22.597481288908153,
        22.615043365975566,
        22.632613458031706,
        22.650191566306155,
        22.667777692018287,
        22.68537183637731,
        22.702974000582223,
        22.72058418582183,
        22.73820239327474,
        22.755828624109384,
        22.773462879483976,
        22.791105160546557,
        22.80875546843497,
        22.82641380427686,
        22.844080169189677,
        22.86175456428068,
        22.87943699064694,
        22.897127449375333,
        22.91482594154254,
        22.932532468215037,
        22.950247030449127,
        22.96796962929091,
        22.985700265776288,
        23.00343894093098,
        23.02118565577051,
        23.038940411300192,
        23.05670320851517,
        23.07447404840038,
        23.092252931930574,
        23.110039860070298,
        23.127834833773917,
        23.145637853985598,
        23.163448921639315,
        23.181268037658853,
        23.199095202957785,
        23.216930418439517,
        23.234773684997247,
        23.252625003513984,
        23.270484374862534,
        23.28835179990552,
        23.306227279495378,
        23.32411081447433,
        23.342002405674425,
        23.359902053917505,
        23.377809760015232,
        23.395725524769052,
        23.41364934897024,
        23.43158123339987,
        23.449521178828824,
        23.467469186017787,
        23.485425255717256,
        23.503389388667525,
        23.521361585598704,
        23.53934184723071,
        23.55733017427326,
        23.575326567425883,
        23.59333102737791,
        23.61134355480849,
        23.629364150386557,
        23.647392814770875,
        23.665429548609996,
        23.6834743525423,
        23.70152722719595,
        23.719588173188928,
        23.737657191129024,
        23.755734281613837,
        23.773819445230753,
        23.79191268255699,
        23.810013994159558,
        23.828123380595287,
        23.846240842410793,
        23.86436638014251,
        23.882499994316685,
        23.900641685449358,
        23.918791454046392,
        23.936949300603438,
        23.95511522560597,
        23.97328922952926,
        23.99147131283839,
        24.009661475988242,
        24.027859719423514,
        24.046066043578712,
        24.06428044887813,
        24.082502935735896,
        24.10073350455592,
        24.118972155731935,
        24.137218889647475,
        24.155473706675878,
        24.173736607180295,
        24.192007591513672,
        24.210286660018777,
        24.22857381302818,
        24.246869050864248,
        24.26517237383916,
        24.283483782254915,
        24.301803276403295,
        24.320130856565903,
        24.33846652301415,
        24.356810276009256,
        24.375162115802226,
        24.3935220426339,
        24.411890056734904,
        24.43026615832569,
        24.448650347616493,
        24.46704262480737,
        24.48544299008818,
        24.503851443638606,
        24.522267985628105,
        24.54069261621596,
        24.55912533555127,
        24.577566143772913,
        24.5960150410096,
        24.614472027379833,
        24.63293710299193,
        24.651410267944016,
        24.669891522324004,
        24.68838086620964,
        24.706878299668467,
        24.725383822757827,
        24.743897435524868,
        24.762419138006564,
        24.780948930229673,
        24.799486812210777,
        24.81803278395624,
        24.836586845462275,
        24.855148996714856,
        24.873719237689794,
        24.89229756835269,
        24.910883988658963,
        24.92947849855383,
        24.948081097972324,
        24.96669178683927,
        24.985310565069323,
        25.003937432566914,
        25.02257238922631,
        25.041215434931566,
        25.059866569556547,
        25.07852579296494,
        25.097193105010213,
        25.11586850553566,
        25.134551994374366,
        25.15324357134924,
        25.17194323627299,
        25.190650988948132,
        25.20936682916698,
        25.22809075671167,
        25.246822771354125,
        25.265562872856094,
        25.284311060969124,
        25.303067335434566,
        25.321831695983587,
        25.34060414233715,
        25.359384674206026,
        25.378173291290803,
        25.396969993281868,
        25.41577477985941,
        25.434587650693437,
        25.453408605443748,
        25.472237643759964,
        25.491074765281507,
        25.509919969637593,
        25.528773256447273,
        25.54763462531938,
        25.56650407585256,
        25.585381607635266,
        25.604267220245774,
        25.623160913252125,
        25.642062686212217,
        25.660972538673718,
        25.679890470174122,
        25.698816480240726,
        25.71775056839062,
        25.73669273413072,
        25.755642976957738,
        25.7746012963582,
        25.79356769180842,
        25.812542162774548,
        25.831524708712518,
        25.85051532906808,
        25.869514023276786,
        25.888520790764,
        25.907535630944892,
        25.926558543224424,
        25.94558952699739,
        25.96462858164837,
        25.983675706551768,
        26.00273090107177,
        26.021794164562404,
        26.04086549636747,
        26.05994489582059,
        26.07903236224519,
        26.098127894954512,
        26.117231493251598,
        26.136343156429287,
        26.155462883770245,
        26.174590674546916,
        26.193726528021585,
        26.21287044344632,
        26.232022420063,
        26.251182457103315,
        26.27035055378876,
        26.289526709330634,
        26.30871092293005,
        26.327903193777914,
        26.347103521054958,
        26.3663119039317,
        26.385528341568477,
        26.40475283311544,
        26.423985377712523,
        26.44322597448949,
        26.462474622565892,
        26.48173132105111,
        26.50099606904431,
        26.520268865634474,
        26.539549709900395,
        26.558838600910658,
        26.578135537723675,
        26.597440519387654,
        26.616753544940593,
        26.636074613410333,
        26.655403723814494,
        26.67474087516051,
        26.69408606644562,
        26.71343929665688,
        26.732800564771136,
        26.752169869755054,
        26.7715472105651,
        26.79093258614755,
        26.81032599543849,
        26.8297274373638,
        26.849136910839178,
        26.86855441477012,
        26.887979948051946,
        26.90741350956976,
        26.926855098198487,
        26.946304712802856,
        26.9657623522374,
        26.985228015346465,
        27.00470170096419,
        27.024183407914542,
        27.04367313501127,
        27.06317088105795,
        27.082676644847954,
        27.102190425164462,
        27.121712220780463,
        27.141242030458756,
        27.16077985295194,
        27.180325687002416,
        27.199879531342408,
        27.21944138469393,
        27.239011245768822,
        27.25858911326871,
        27.278174985885034,
        27.29776886229904,
        27.3173707411818,
        27.33698062119415,
        27.35659850098678,
        27.376224379200153,
        27.395858254464553,
        27.41550012540007,
        27.435149990616594,
        27.454807848713834,
        27.474473698281294,
        27.494147537898286,
        27.513829366133937,
        27.53351918154717,
        27.553216982686724,
        27.57292276809114,
        27.59263653628876,
        27.612358285797747,
        27.632088015126065,
        27.651825722771473,
        27.67157140722155,
        27.691325066953674,
        27.71108670043504,
        27.730856306122636,
        27.75063388246327,
        27.77041942789355,
        27.79021294083988,
        27.810014419718495,
        27.829823862935417,
        27.849641268886483,
        27.869466635957334,
        27.889299962523417,
        27.909141246949986,
        27.92899048759211,
        27.948847682794643,
        27.968712830892272,
        27.98858593020948,
        28.008466979060543,
        28.028355975749566,
        28.04825291857045,
        28.068157805806905,
        28.088070635732436,
        28.10799140661037,
        28.127920116693844,
        28.14785676422578,
        28.167801347438925,
        28.187753864555827,
        28.207714313788845,
        28.227682693340135,
        28.24765900140167,
        28.267643236155212,
        28.28763539577237,
        28.307635478414504,
        28.327643482232823,
        28.347659405368326,
        28.36768324595182,
        28.387715002103924,
        28.40775467193506,
        28.427802253545448,
        28.447857745025136,
        28.467921144453957,
        28.487992449901558,
        28.5080716594274,
        28.528158771080736,
        28.548253782900648,
        28.568356692916,
        28.58846749914548,
        28.60858619959757,
        28.628712792270573,
        28.648847275152583,
        28.668989646221515,
        28.689139903445078,
        28.709298044780798,
        28.729464068176004,
        28.74963797156783,
        28.769819752883215,
        28.790009410038913,
        28.810206940941477,
        28.830412343487264,
        28.850625615562446,
        28.870846755043004,
        28.89107575979471,
        28.91131262767316,
        28.931557356523747,
        28.951809944181665,
        28.972070388471938,
        28.992338687209365,
        29.012614838198584,
        29.03289883923401,
        29.053190688099885,
        29.07349038257025,
        29.09379792040895,
        29.114113299369645,
        29.134436517195795,
        29.15476757162067,
        29.175106460367342,
        29.195453181148697,
        29.215807731667418,
        29.236170109616005,
        29.256540312676762,
        29.27691833852179,
        29.297304184813008,
        29.317697849202144,
        29.338099329330717,
        29.358508622830065,
        29.378925727321334,
        29.399350640415463,
        29.41978335971322,
        29.440223882805164,
        29.46067220727166,
        29.48112833068288,
        29.50159225059881,
        29.52206396456924,
        29.542543470133772,
        29.563030764821793,
        29.58352584615252,
        29.604028711634964,
        29.62453935876795,
        29.645057785040116,
        29.665583987929878,
        29.686117964905495,
        29.706659713425008,
        29.72720923093627,
        29.747766514876947,
        29.76833156267451,
        29.78890437174623,
        29.80948493949919,
        29.830073263330277,
        29.850669340626197,
        29.871273168763437,
        29.891884745108317,
        29.912504067016943,
        29.933131131835243,
        29.95376593689895,
        29.97440847953359,
        29.99505875705451,
        30.015716766766857,
        30.03638250596559,
        30.05705597193547,
        30.077737161951063,
        30.098426073276748,
        30.119122703166703,
        30.139827048864916,
        30.16053910760519,
        30.18125887661112,
        30.201986353096117,
        30.2227215342634,
        30.243464417305987,
        30.264214999406708,
        30.284973277738196,
        30.305739249462903,
        30.32651291173306,
        30.347294261690738,
        30.36808329646779,
        30.388880013185897,
        30.40968440895653,
        30.430496480880954,
        30.451316226050285,
        30.472143641545394,
        30.492978724437002,
        30.513821471785608,
        30.534671880641532,
        30.555529948044892,
        30.576395671025615,
        30.597269046603447,
        30.618150071787923,
        30.639038743578393,
        30.659935058964006,
        30.68083901492374,
        30.70175060842635,
        30.72266983643042,
        30.743596695884325,
        30.764531183726262,
        30.785473296884213,
        30.806423032275998,
        30.82738038680921,
        30.84834535738128,
        30.86931794087942,
        30.890298134180657,
        30.911285934151834,
        30.93228133764959,
        30.953284341520376,
        30.974294942600448,
        30.995313137715865,
        31.016338923682493,
        31.037372297306014,
        31.058413255381904,
        31.07946179469547,
        31.100517912021783,
        31.121581604125762,
        31.142652867762102,
        31.163731699675335,
        31.184818096599773,
        31.20591205525955,
        31.227013572368598,
        31.24812264463066,
        31.269239268739287,
        31.29036344137783,
        31.31149515921946,
        31.332634418927142,
        31.35378121715365,
        31.37493555054156,
        31.39609741572328,
        31.41726680932099,
        31.438443727946694,
        31.459628168202197,
        31.48082012667913,
        31.502019599958913,
        31.52322658461276,
        31.544441077201718,
        31.565663074276628,
        31.58689257237814,
        31.608129568036706,
        31.629374057772594,
        31.65062603809587,
        31.671885505506403,
        31.693152456493884,
        31.714426887537808,
        31.73570879510746,
        31.75699817566194,
        31.77829502565017,
        31.799599341510856,
        31.820911119672523,
        31.8422303565535,
        31.86355704856193,
        31.884891192095743,
        31.9062327835427,
        31.927581819280338,
        31.948938295676044,
        31.970302209086977,
        31.991673555860107,
        32.01305233233223,
        32.03443853482991,
        32.05583215966957,
        32.0772332031574,
        32.09864166158942,
        32.120057531251426,
        32.141480808419054,
        32.16291148935773,
        32.1843495703227,
        32.20579504755899,
        32.22724791730147,
        32.24870817577476,
        32.27017581919336,
        32.29165084376153,
        32.31313324567333,
        32.334623021112655,
        32.3561201662532,
        32.37762467725845,
        32.39913655028171,
        32.420655781466095,
        32.442182366944515,
        32.46371630283969,
        32.48525758526416,
        32.50680621032025,
        32.52836217410012,
        32.54992547268569,
        32.57149610214874,
        32.593074058550826,
        32.61465933794332,
        32.636251936367394,
        32.65785184985403,
        32.679459074424024,
        32.70107360608796,
        32.72269544084625,
        32.7443245746891,
        32.76596100359654,
        32.78760472353837,
        32.80925573047423,
        32.83091402035355,
        32.85257958911559,
        32.87425243268938,
        32.89593254699379,
        32.91761992793747,
        32.939314571418905,
        32.96101647332635,
        32.98272562953792,
        33.00444203592147,
        33.026165688334714,
        33.04789658262515,
        33.06963471463009,
        33.091380080176656,
        33.11313267508176,
        33.13489249515213,
        33.156659536184314,
        33.17843379396464,
        33.200215264269275,
        33.22200394286417,
        33.24379982550508,
        33.26560290793757,
        33.28741318589703,
        33.30923065510864,
        33.33105531128739,
        33.352887150138066,
        33.374726167355284,
        33.396572358623445,
        33.41842571961677,
        33.44028624599928,
        33.46215393342481,
        33.484028777536984,
        33.505910773969255,
        33.52779991834486,
        33.54969620627687,
        33.57159963336815,
        33.59351019521135,
        33.61542788738897,
        33.637352705473276,
        33.65928464502636,
        33.681223701600125,
        33.703169870736275,
        33.72512314796631,
        33.74708352881155,
        33.769051008783116,
        33.791025583381945,
        33.81300724809877,
        33.83499599841412,
        33.85699182979837,
        33.878994737711665,
        33.90100471760397,
        33.92302176491504,
        33.94504587507446,
        33.96707704350164,
        33.989115265605726,
        34.01116053678574,
        34.03321285243048,
        34.05527220791855,
        34.07733859861837,
        34.09941201988816,
        34.12149246707597,
        34.14357993551961,
        34.165674420546736,
        34.18777591747479,
        34.20988442161104,
        34.231999928252534,
        34.25412243268615,
        34.27625193018858,
        34.29838841602628,
        34.32053188545555,
        34.34268233372249,
        34.364839756063006,
        34.387004147702804,
        34.40917550385739,
        34.431353819732095,
        34.45353909052206,
        34.475731311412204,
        34.497930477577285,
        34.520136584181834,
        34.542349626380236,
        34.56456959931662,
        34.586796498124976,
        34.60903031792908,
        34.63127105384252,
        34.65351870096867,
        34.67577325440073,
        34.69803470922172,
        34.720303060504435,
        34.74257830331149,
        34.76486043269531,
        34.787149443698134,
        34.809445331351995,
        34.83174809067872,
        34.85405771668999,
        34.876374204387226,
        34.89869754876172,
        34.92102774479452,
        34.943364787456524,
        34.9657086717084,
        34.98805939250064,
        35.010416944773546,
        35.032781323457215,
        35.05515252347157,
        35.077530539726304,
        35.099915367120964,
        35.122307000544865,
        35.144705434877146,
        35.16711066498676,
        35.18952268573244,
        35.21194149196276,
        35.23436707851607,
        35.25679944022055,
        35.27923857189417,
        35.30168446834472,
        35.32413712436978,
        35.34659653475675,
        35.369062694282846,
        35.39153559771506,
        35.41401523981021,
        35.43650161531494,
        35.458994718965656,
        35.4814945454886,
        35.50400108959982,
        35.52651434600517,
        35.54903430940031,
        35.571560974470685,
        35.594094335891576,
        35.61663438832806,
        35.63918112643502,
        35.66173454485715,
        35.68429463822894,
        35.7068614011747,
        35.72943482830852,
        35.75201491423434,
        35.77460165354588,
        35.79719504082667,
        35.81979507065003,
        35.84240173757912,
        35.86501503616689,
        35.88763496095609,
        35.91026150647929,
        35.93289466725886,
        35.95553443780697,
        35.978180812625595,
        36.00083378620655,
        36.02349335303141,
        36.046159507571595,
        36.0688322442883,
        36.09151155763256,
        36.114197442045175,
        36.1368898919568,
        36.15958890178784,
        36.18229446594857,
        36.20500657883903,
        36.22772523484908,
        36.25045042835837,
        36.27318215373638,
        36.29592040534239,
        36.318665177525475,
        36.34141646462452,
        36.36417426096824,
        36.386938560875144,
        36.40970935865351,
        36.43248664860147,
        36.45527042500696,
        36.4780606821477,
        36.50085741429121,
        36.52366061569487,
        36.54647028060581,
        36.56928640326098,
        36.59210897788716,
        36.6149379987009,
        36.6377734599086,
        36.660615355706426,
        36.68346368028038,
        36.70631842780625,
        36.72917959244965,
        36.75204716836597,
        36.77492114970045,
        36.7978015305881,
        36.82068830515376,
        36.84358146751205,
        36.86648101176743,
        36.889386932014155,
        36.912299222336266,
        36.93521787680763,
        36.95814288949192,
        36.98107425444262,
        37.00401196570299,
        37.02695601730614,
        37.04990640327498,
        37.07286311762219,
        37.09582615435029,
        37.118795507451594,
        37.14177117090823,
        37.16475313869212,
        37.187741404765006,
        37.210735963078434,
        37.233736807573756,
        37.25674393218212,
        37.27975733082449,
        37.302776997411655,
        37.32580292584417,
        37.34883511001242,
        37.371873543796625,
        37.394918221066746,
        37.417969135682604,
        37.4410262814938,
        37.46408965233976,
        37.48715924204971,
        37.510235044442666,
        37.53331705332747,
        37.556405262502786,
        37.57949966575705,
        37.6026002568685,
        37.62570702960522,
        37.6488199777251,
        37.67193909497578,
        37.69506437509475,
        37.71819581180932,
        37.74133339883658,
        37.764477129883424,
        37.78762699864657,
        37.810782998812535,
        37.83394512405765,
        37.85711336804802,
        37.880287724439604,
        37.90346818687815,
        37.9266547489992,
        37.949847404428105,
        37.973046146780035,
        37.99625096965997,
        38.01946186666267,
        38.042678831372726,
        38.06590185736453,
        38.08913093820228,
        38.11236606743998,
        38.13560723862144,
        38.15885444528026,
        38.1821076809399,
        38.20536693911357,
        38.228632213304294,
        38.25190349700494,
        38.275180783698154,
        38.29846406685637,
        38.32175333994188,
        38.34504859640675,
        38.36834982969284,
        38.391657033231844,
        38.41497020044527,
        38.43828932474439,
        38.46161439953032,
        38.48494541819396,
        38.508282374116035,
        38.53162526066708,
        38.55497407120741,
        38.578328799087174,
        38.60168943764631,
        38.62505598021455,
        38.64842842011148,
        38.671806750646454,
        38.69519096511864,
        38.71858105681702,
        38.741977019020375,
        38.765378844997294,
        38.78878652800618,
        38.812200061295236,
        38.83561943810246,
        38.859044651655694,
        38.88247569517254,
        38.905912561860426,
        38.929355244916614,
        38.95280373752813,
        38.976258032871826,
        38.99971812411436,
        39.0231840044122,
        39.046655666911626,
        39.0701331047487,
        39.093616311049296,
        39.11710527892914,
        39.140600001493695,
        39.16410047183828,
        39.187606683048,
        39.211118628197795,
        39.234636300352356,
        39.258159692566224,
        39.28168879788376,
        39.30522360933907,
        39.32876411995614,
        39.3523103227487,
        39.37586221072033,
        39.3994197768644,
        39.42298301416409,
        39.44655191559236,
        39.47012647411204,
        39.493706682675686,
        39.51729253422574,
        39.54088402169439,
        39.56448113800366,
        39.588083876065376,
        39.61169222878116,
        39.63530618904246,
        39.65892574973052,
        39.682550903716376,
        39.706181643860916,
        39.72981796301477,
        39.753459854018416,
        39.77710730970216,
        39.800760322886056,
        39.82441888638,
        39.848082992983706,
        39.871752635486644,
        39.895427806668174,
        39.91910849929737,
        39.94279470613318,
        39.96648641992433,
        39.99018363340935,
        40.01388633931659,
        40.03759453036421,
        40.061308199260154,
        40.0850273387022,
        40.10875194137789,
        40.13248199996463,
        40.1562175071296,
        40.179958455529786,
        40.20370483781198,
        40.2274566466128,
        40.25121387455865,
        40.274976514265745,
        40.298744558340104,
        40.32251799937758,
        40.3462968299638,
        40.370081042674194,
        40.39387063007402,
        40.41766558471835,
        40.441465899152035,
        40.46527156590975,
        40.48908257751596,
        40.51289892648498,
        40.53672060532088,
        40.560547606517545,
        40.58437992255871,
        40.60821754591787,
        40.63206046905833,
        40.655908684433236,
        40.679762184485504,
        40.703620961647886,
        40.727485008342924,
        40.751354316982955,
        40.77522887997014,
        40.79910868969647,
        40.82299373854368,
        40.84688401888336,
        40.87077952307691,
        40.89468024347551,
        40.91858617242014,
        40.94249730224164,
        40.9664136252606,
        40.990335133787426,
        41.014261820122364,
        41.038193676555444,
        41.06213069536649,
        41.086072868825156,
        41.11002018919089,
        41.13397264871296,
        41.15793023963042,
        41.18189295417212,
        41.20586078455679,
        41.22983372299287,
        41.25381176167868,
        41.27779489280229,
        41.30178310854162,
        41.32577640106439,
        41.3497747625281,
        41.37377818508008,
        41.39778666085747,
        41.42180018198721,
        41.44581874058602,
        41.46984232876047,
        41.493870938606925,
        41.517904562211534,
        41.541943191650276,
        41.56598681898893,
        41.590035436283074,
        41.6140890355781,
        41.638147608909215,
        41.66221114830142,
        41.68627964576952,
        41.71035309331813,
        41.73443148294168,
        41.75851480662441,
        41.78260305634036,
        41.80669622405336,
        41.83079430171706,
        41.854897281274944,
        41.87900515466024,
        41.90311791379604,
        41.92723555059521,
        41.951358056960466,
        41.97548542478427,
        41.99961764594891,
        42.02375471232652,
        42.047896615779,
        42.07204334815806,
        42.096194901305246,
        42.120351267051866,
        42.14451243721906,
        42.16867840361779,
        42.192849158048794,
        42.217024692302644,
        42.241204998159674,
        42.26539006739009,
        42.28957989175385,
        42.313774463000755,
        42.33797377287038,
        42.36217781309212,
        42.386386575385195,
        42.410600051458616,
        42.43481823301118,
        42.459041111731544,
        42.483268679298114,
        42.50750092737914,
        42.531737847632655,
        42.55597943170654,
        42.580225671238416,
        42.60447655785576,
        42.62873208317585,
        42.65299223880577,
        42.677257016342395,
        42.70152640737241,
        42.72580040347232,
        42.750078996208444,
        42.77436217713687,
        42.798649937803525,
        42.822942269744146,
        42.84723916448424,
        42.87154061353917,
        42.89584660841406,
        42.92015714060388,
        42.94447220159338,
        42.968791782857124,
        42.99311587585947,
        43.01744447205465,
        43.04177756288657,
        43.06611513978907,
        43.090457194185745,
        43.11480371748999,
        43.13915470110502,
        43.16351013642385,
        43.18787001482932,
        43.212234327694055,
        43.236603066380475,
        43.26097622224084,
        43.285353786617215,
        43.30973575084143,
        43.33412210623516,
        43.35851284410989,
        43.38290795576689,
        43.407307432497234,
        43.43171126558182,
        43.45611944629136,
        43.48053196588635,
        43.50494881561709,
        43.52936998672371,
        43.55379547043614,
        43.5782252579741,
        43.60265934054713,
        43.62709770935459,
        43.651540355585624,
        43.675987270419164,
        43.700438445024005,
        43.72489387055872,
        43.74935353817168,
        43.77381743900106,
        43.798285564174854,
        43.82275790481089,
        43.84723445201672,
        43.87171519688981,
        43.89620013051734,
        43.92068924397637,
        43.94518252833369,
        43.969679974645956,
        43.99418157395963,
        44.01868731731095,
        44.043197195725966,
        44.06771120022054,
        44.092229321800374,
        44.11675155146093,
        44.141277880187474,
        44.16580829895512,
        44.19034279872878,
        44.21488137046313,
        44.239424005102684,
        44.263970693581776,
        44.28852142682452,
        44.313076195744856,
        44.3376349912465,
        44.36219780422304,
        44.386764625557795,
        44.41133544612392,
        44.4359102567844,
        44.460489048392,
        44.48507181178931,
        44.50965853780867,
        44.53424921727233,
        44.55884384099226,
        44.58344239977026,
        44.60804488439795,
        44.63265128565676,
        44.65726159431789,
        44.68187580114238,
        44.70649389688109,
        44.73111587227464,
        44.75574171805351,
        44.78037142493792,
        44.80500498363794,
        44.82964238485348,
        44.854283619274206,
        44.878928677579566,
        44.9035775504389,
        44.928230228511275,
        44.9528867024456,
        44.977546962880595,
        45.00221100044479,
        45.0268788057565,
        45.05155036942383,
        45.07622568204476,
        45.10090473420702,
        45.12558751648815,
        45.15027401945552,
        45.1749642336663,
        45.199658149667464,
        45.22435575799577,
        45.249057049177814,
        45.27376201373,
        45.29847064215853,
        45.323182924959376,
        45.34789885261836,
        45.37261841561113,
        45.39734160440309,
        45.42206840944946,
        45.44679882119531,
        45.47153283007547,
        45.49627042651458,
        45.52101160092711,
        45.54575634371733,
        45.5705046452793,
        45.595256495996914,
        45.620011886243844,
        45.64477080638358,
        45.66953324676945,
        45.694299197744506,
        45.71906864964171,
        45.74384159278377,
        45.768618017483185,
        45.79339791404231,
        45.818181272753286,
        45.84296808389805,
        45.867758337748356,
        45.89255202456575,
        45.91734913460162,
        45.942149658097144,
        45.966953585283264,
        45.99176090638079,
        46.01657161160032,
        46.04138569114224,
        46.06620313519675,
        46.09102393394387,
        46.11584807755344,
        46.14067555618505,
        46.165506359988136,
        46.19034047910198,
        46.21517790365558,
        46.240018623767796,
        46.2648626295473,
        46.28970991109256,
        46.31456045849184,
        46.339414261823215,
        46.364271311154575,
        46.38913159654361,
        46.41399510803784,
        46.43886183567453,
        46.46373176948082,
        46.48860489947363,
        46.51348121565967,
        46.53836070803548,
        46.56324336658741,
        46.58812918129159,
        46.61301814211398,
        46.63791023901033,
        46.66280546192621,
        46.68770380079701,
        46.71260524554789,
        46.73750978609384,
        46.762417412339644,
        46.787328114179914,
        46.81224188149904,
        46.83715870417126,
        46.86207857206057,
        46.887001475020796,
        46.911927402895586,
        46.936856345518365,
        46.96178829271239,
        46.9867232342907,
        47.011661160056164,
        47.03660205980146,
        47.06154592330903,
        47.086492740351176,
        47.11144250068997,
        47.13639519407731,
        47.1613508102549,
        47.18630933895423,
        47.21127076989664,
        47.23623509279322,
        47.261202297344916,
        47.28617237324245,
        47.311145310166374,
        47.336121097787014,
        47.36109972576454,
        47.38608118374889,
        47.41106546137985,
        47.43605254828699,
        47.461042434089684,
        47.48603510839711,
        47.511030560808265,
        47.53602878091196,
        47.5610297582868,
        47.58603348250118,
        47.611039943113326,
        47.63604912967127,
        47.661061031712855,
        47.6860756387657,
        47.71109294034725,
        47.73611292596477,
        47.761135585115305,
        47.78616090728574,
        47.81118888195274,
        47.83621949858278,
        47.86125274663214,
        47.886288615546924,
        47.91132709476303,
        47.93636817370616,
        47.96141184179182,
        47.986458088425344,
        48.01150690300185,
        48.03655827490628,
        48.06161219351335,
        48.08666864818763,
        48.111727628283454,
        48.13678912314499,
        48.161853122106216,
        48.18691961449088,
        48.21198858961258,
        48.2370600367747,
        48.26213394527042,
        48.287210304382754,
        48.3122891033845,
        48.337370331538274,
        48.36245397809649,
        48.387540032301374,
        48.412628483384964,
        48.437719320569094,
        48.46281253306542,
        48.48790811007539,
        48.51300604079025,
        48.53810631439108,
        48.56320892004876,
        48.58831384692396,
        48.61342108416715,
        48.63853062091865,
        48.663642446308536,
        48.68875654945674,
        48.713872919472955,
        48.73899154545669,
        48.764112416497305,
        48.7892355216739,
        48.81436085005544,
        48.83948839070066,
        48.86461813265811,
        48.88975006496614,
        48.91488417665294,
        48.94002045673646,
        48.965158894224494,
        48.99029947811463,
        49.01544219739424,
        49.04058704104055,
        49.06573399802055,
        49.09088305729106,
        49.116034207798684,
        49.14118743847987,
        49.16634273826084,
        49.19150009605763,
        49.216659500776096,
        49.241820941311886,
        49.266984406550456,
        49.292149885367074,
        49.31731736662681,
        49.342486839184545,
        49.36765829188498,
        49.392831713562586,
        49.418007093041666,
        49.44318441913634,
        49.468363680650505,
        49.493544866377896,
        49.51872796510203,
        49.54391296559625,
        49.56909985662367,
        49.594288626937264,
        49.619479265279764,
        49.64467176038374,
        49.669866100971554,
        49.6950622757554,
        49.72026027343722,
        49.745460082708824,
        49.7706616922518,
        49.79586509073755,
        49.82107026682728,
        49.84627720917201,
        49.87148590641254,
        49.89669634717951,
        49.92190852009334,
        49.94712241376429,
        49.97233801679239,
        49.99755531776751,
        50.02277430526929,
        50.047994967867204,
        50.073217294120525,
        50.098441272578334,
        50.123666891779514,
        50.148894140252764,
        50.17412300651658,
        50.19935347907927,
        50.22458554643894,
        50.24981919708352,
        50.275054419490736,
        50.30029120212811,
        50.32552953345298,
        50.35076940191251,
        50.37601079594364,
        50.40125370397313,
        50.42649811441755,
        50.451744015683275,
        50.47699139616649,
        50.502240244253166,
        50.52749054831909,
        50.552742296729896,
        50.57799547784096,
        50.603250079997494,
        50.62850609153455,
        50.65376350077691,
        50.67902229603925,
        50.70428246562598,
        50.72954399783135,
        50.75480688093942,
        50.78007110322406,
        50.80533665294892,
        50.83060351836747,
        50.855871687723,
        50.88114114924859,
        50.90641189116715,
        50.93168390169136,
        50.95695716902373,
        50.98223168135658,
        51.00750742687204,
        51.032784393742,
        51.05806257012823,
        51.083341944182244,
        51.10862250404542,
        51.133904237848874,
        51.159187133713594,
        51.18447117975033,
        51.20975636405965,
        51.23504267473196,
        51.26033009984742,
        51.28561862747604,
        51.31090824567761,
        51.33619894250175,
        51.361490705987855,
        51.38678352416516,
        51.41207738505268,
        51.43737227665927,
        51.46266818698353,
        51.48796510401394,
        51.51326301572874,
        51.53856191009599,
        51.56386177507357,
        51.589162598609136,
        51.61446436864017,
        51.63976707309397,
        51.66507069988762,
        51.69037523692802,
        51.71568067211189,
        51.74098699332573,
        51.76629418844585,
        51.79160224533839,
        51.81691115185929,
        51.842220895854275,
        51.86753146515891,
        51.89284284759852,
        51.918155030988295,
        51.943468003133184,
        51.96878175182796,
        51.99409626485722,
        52.01941152999533,
        52.04472753500649,
        52.070044267644704,
        52.09536171565377,
        52.120679866767325,
        52.14599870870875,
        52.17131822919131,
        52.196638415918024,
        52.22195925658171,
        52.247280738865044,
        52.27260285044048,
        52.29792557897025,
        52.32324891210645,
        52.34857283749094,
        52.3738973427554,
        52.39922241552133,
        52.424548043399994,
        52.44987421399251,
        52.4752009148898,
        52.50052813367255,
        52.5258558579113,
        52.55118407516636,
        52.576512772987876,
        52.60184193891578,
        52.62717156047984,
        52.652501625199584,
        52.67783212058437,
        52.70316303413339,
        52.72849435333559,
        52.75382606566978,
        52.779158158604524,
        52.80449061959821,
        52.82982343609906,
        52.85515659554507,
        52.880490085364045,
        52.90582389297362,
        52.931158005781214,
        52.956492411184065,
        52.98182709656921,
        53.00716204931349,
        53.032497256783586,
        53.05783270633592,
        53.083168385316775,
        53.10850428106222,
        53.13384038089815,
        53.15917667214024,
        53.184513142093984,
        53.20984977805468,
        53.23518656730745,
        53.260523497127195,
        53.28586055477863,
        53.3111977275163,
        53.33653500258451,
        53.36187236721743,
        53.387209808639,
        53.41254731406295,
        53.437884870692876,
        53.463222465722104,
        53.48856008633385,
        53.51389771970108,
        53.53923535298656,
        53.5645729733429,
        53.5899105679125,
        53.615248123827584,
        53.640585628210125,
        53.665923068171985,
        53.691260430814765,
        53.716597703229894,
        53.74193487249863,
        53.76727192569203,
        53.79260884987092,
        53.81794563208599,
        53.843282259377666,
        53.868618718776254,
        53.893954997301826,
        53.91929108196425,
        53.944626959763276,
        53.96996261768835,
        53.995298042718794,
        54.02063322182372,
        54.04596814196205,
        54.07130279008251,
        54.096637153123645,
        54.12197121801378,
        54.14730497167107,
        54.172638401003475,
        54.19797149290875,
        54.223304234274444,
        54.24863661197796,
        54.273968612886456,
        54.29930022385694,
        54.32463143173618,
        54.3499622233608,
        54.3752925855572,
        54.40062250514158,
        54.42595196891997,
        54.45128096368821,
        54.47660947623192,
        54.50193749332654,
        54.52726500173732,
        54.55259198821931,
        54.57791843951738,
        54.6032443423662,
        54.62856968349022,
        54.653894449603754,
        54.679218627410854,
        54.70454220360544,
        54.72986516487119,
        54.755187497881636,
        54.78050918930008,
        54.80583022577964,
        54.83115059396325,
        54.856470280483634,
        54.88178927196334,
        54.90710755501471,
        54.93242511623991,
        54.957741942230896,
        54.98305801956942,
        55.008373334827084,
        55.03368787456523,
        55.05900162533508,
        55.08431457367759,
        55.10962670612362,
        55.13493800919372,
        55.16024846939833,
        55.18555807323767,
        55.210866807201775,
        55.23617465777047,
        55.26148161141337,
        55.286787654589965,
        55.312092773749484,
        55.33739695533098,
        55.36270018576336,
        55.388002451465255,
        55.41330373884517,
        55.43860403430137,
        55.46390332422198,
        55.48920159498488,
        55.514498832957784,
        55.5397950244982,
        55.565090155953456,
        55.59038421366067,
        55.61567718394679,
        55.64096905312854,
        55.66625980751248,
        55.691549433394954,
        55.71683791706214,
        55.74212524478998,
        55.767411402844274,
        55.79269637748059,
        55.81798015494431,
        55.84326272147063,
        55.86854406328457,
        55.893824166600915,
        55.91910301762428,
        55.94438060254909,
        55.96965690755958,
        55.99493191882978,
        56.02020562252352,
        56.04547800479446,
        56.070749051786066,
        56.09601874963157,
        56.121287084454046,
        56.14655404236638,
        56.17181960947126,
        56.19708377186115,
        56.222346515618355,
        56.24760782681497,
        56.27286769151292,
        56.298126095763905,
        56.32338302560945,
        56.34863846708087,
        56.37389240619932,
        56.39914482897573,
        56.424395721410846,
        56.44964506949522,
        56.47489285920921,
        56.50013907652302,
        56.52538370739658,
        56.55062673777968,
        56.57586815361192,
        56.60110794082268,
        56.62634608533117,
        56.651582573046404,
        56.676817389867175,
        56.70205052168213,
        56.72728195436967,
        56.75251167379805,
        56.77773966582531,
        56.802965916299286,
        56.82819041105764,
        56.85341313592782,
        56.87863407672712,
        56.90385321926259,
        56.929070549331115,
        56.95428605271939,
        56.9794997152039,
        57.004711522550956,
        57.02992146051667,
        57.05512951484694,
        57.08033567127749,
        57.10553991553385,
        57.13074223333138,
        57.15594261037518,
        57.181141032360216,
        57.20633748497124,
        57.23153195388282,
        57.25672442475931,
        57.2819148832549,
        57.307103315013556,
        57.332289705669076,
        57.357474040845055,
        57.3826563061549,
        57.407836487201784,
        57.43301456957876,
        57.458190538868635,
        57.48336438064405,
        57.508536080467415,
        57.53370562389097,
        57.5588729964568,
        57.58403818369671,
        57.6092011711324,
        57.63436194427532,
        57.659520488626754,
        57.684676789677766,
        57.709830832909255,
        57.73498260379192,
        57.76013208778627,
        57.785279270342585,
        57.81042413690099,
        57.83556667289142,
        57.860706863733576,
        57.885844694837026,
        57.910980151601095,
        57.93611321941492,
        57.961243883657474,
        57.9863721296975,
        58.01149794289359,
        58.03662130859411,
        58.06174221213722,
        58.08686063885093,
        58.11197657405303,
        58.13709000305111,
        58.162200911142584,
        58.18730928361468,
        58.212415105744405,
        58.23751836279858,
        58.26261904003387,
        58.28771712269668,
        58.31281259602328,
        58.337905445239706,
        58.36299565556184,
        58.388083212195355,
        58.413168100335696,
        58.43825030516816,
        58.463329811867844,
        58.48840660559962,
        58.513480671518224,
        58.53855199476813,
        58.563620560483656,
        58.58868635378894,
        58.61374935979791,
        58.63880956361428,
        58.66386695033161,
        58.688921505033235,
        58.71397321279233,
        58.739022058671836,
        58.76406802772452,
        58.78911110499298,
        58.81415127550957,
        58.839188524296496,
        58.864222836365755,
        58.88925419671911,
        58.914282590348236,
        58.939308002234476,
        58.96433041734911,
        58.98934982065313,
        59.01436619709738,
        59.03937953162252,
        59.06438980915897,
        59.08939701462699,
        59.114401132936656,
        59.13940214898783,
        59.16440004767016,
        59.18939481386319,
        59.214386432436136,
        59.23937488824814,
        59.26436016614809,
        59.2893422509747,
        59.31432112755647,
        59.339296780711734,
        59.36426919524861,
        59.38923835596504,
        59.414204247648776,
        59.43916685507734,
        59.4641261630181,
        59.48908215622822,
        59.51403481945467,
        59.53898413743422,
        59.56393009489345,
        59.58887267654875,
        59.61381186710633,
        59.638747651262165,
        59.663680013702084,
        59.688608939101684,
        59.713534412126386,
        59.73845641743144,
        59.763374939661865,
        59.7882899634525,
        59.81320147342801,
        59.83810945420282,
        59.86301389038123,
        59.88791476655727,
        59.91281206731484,
        59.93770577722762,
        59.962595880859105,
        59.98748236276255,
        60.0123652074811,
        60.03724439954764,
        60.0621199234849,
        60.086991763805386,
        60.111859905011436,
        60.13672433159518,
        60.161585028038566,
        60.18644197881333,
        60.21129516838104,
        60.23614458119306,
        60.26099020169055,
        60.28583201430449,
        60.31067000345564,
        60.335504153554616,
        60.360334449001805,
        60.3851608741874,
        60.40998341349142,
        60.43480205128367,
        60.45961677192378,
        60.48442755976118,
        60.509234399135096,
        60.534037274374576,
        60.55883616979846,
        60.58363106971542,
        60.608421958423904,
        60.633208820212175,
        60.65799163935832,
        60.682770400130224,
        60.70754508678556,
        60.73231568357182,
        60.757082174726335,
        60.781844544476186,
        60.8066027770383,
        60.831356856619394,
        60.856106767415994,
        60.880852493614455,
        60.90559401939089,
        60.930331328911265,
        60.95506440633132,
        60.97979323579664,
        61.00451780144257,
        61.0292380873943,
        61.05395407776681,
        61.078665756664876,
        61.103373108183106,
        61.128076116405914,
        61.15277476540746,
        61.17746903925182,
        61.202158921992776,
        61.226844397673965,
        61.251525450328835,
        61.27620206398061,
        61.30087422264234,
        61.3255419103169,
        61.35020511099694,
        61.374863808664905,
        61.39951798729311,
        61.424167630843606,
        61.4488127232683,
        61.47345324850888,
        61.498089190496856,
        61.52272053315353,
        61.547347260390005,
        61.57196935610722,
        61.59658680419589,
        61.62119958853656,
        61.64580769299957,
        61.670411101445076,
        61.695009797723024,
        61.71960376567318,
        61.7441929891251,
        61.76877745189817,
        61.79335713780157,
        61.8179320306343,
        61.84250211418513,
        61.86706737223268,
        61.891627788545364,
        61.91618334688138,
        61.940734030988764,
        61.96527982460533,
        61.98982071145873,
        62.014356675266384,
        62.03888769973557,
        62.06341376856332,
        62.08793486543651,
        62.11245097403179,
        62.13696207801567,
        62.16146816104438,
        62.18596920676406,
        62.21046519881057,
        62.23495612080962,
        62.25944195637675,
        62.28392268911721,
        62.3083983026262,
        62.33286878048858,
        62.35733410627915,
        62.38179426356239,
        62.406249235892666,
        62.43069900681416,
        62.45514355986083,
        62.47958287855641,
        62.504016946414495,
        62.52844574693848,
        62.55286926362153,
        62.57728747994666,
        62.601700379386685,
        62.62610794540416,
        62.65051016145154,
        62.67490701097107,
        62.69929847739472,
        62.72368454414436,
        62.748065194631636,
        62.77244041225799,
        62.79681018041467,
        62.821174482482746,
        62.84553330183307,
        62.869886621826346,
        62.89423442581303,
        62.918576697133425,
        62.94291341911764,
        62.967244575085545,
        62.99157014834687,
        63.015890122201135,
        63.04020447993764,
        63.064513204835535,
        63.088816280163726,
        63.11311368918099,
        63.137405415135866,
        63.16169144126669,
        63.18597175080165,
        63.21024632695869,
        63.234515152945626,
        63.258778211959985,
        63.2830354871892,
        63.30728696181044,
        63.33153261899073,
        63.35577244188687,
        63.38000641364546,
        63.40423451740294,
        63.428456736285526,
        63.452673053409264,
        63.47688345188,
        63.50108791479337,
        63.52528642523484,
        63.54947896627965,
        63.57366552099292,
        63.59784607242946,
        63.622020603634006,
        63.64618909764102,
        63.6703515374748,
        63.69450790614944,
        63.718658186668875,
        63.74280236202679,
        63.76694041520674,
        63.79107232918203,
        63.81519808691579,
        63.839317671360995,
        63.86343106546036,
        63.88753825214646,
        63.91163921434165,
        63.9357339349581,
        63.95982239689779,
        63.9839045830525,
        64.00798047630381,
        64.03205005952312,
        64.05611331557164,
        64.08017022730037,
        64.10422077755014,
        64.12826494915156,
        64.15230272492506,
        64.17633408768086,
        64.20035902021904,
        64.22437750532941,
        64.24838952579167,
        64.27239506437525,
        64.29639410383942,
        64.32038662693324,
        64.34437261639565,
        64.36835205495528,
        64.39232492533064,
        64.41629121023004,
        64.44025089235161,
        64.46420395438324,
        64.48815037900266,
        64.51209014887738,
        64.53602324666477,
        64.55994965501195,
        64.58386935655588,
        64.6077823339233,
        64.63168856973077,
        64.65558804658468,
        64.67948074708121,
        64.70336665380633,
        64.72724574933581,
        64.75111801623528,
        64.77498343706011,
        64.79884199435554,
        64.82269367065658,
        64.84653844848802,
        64.87037631036455,
        64.89420723879053,
        64.91803121626026,
        64.94184822525777,
        64.96565824825691,
        64.98946126772135,
        65.01325726610457,
        65.03704622584982,
        65.0608281293902,
        65.08460295914861,
        65.10837069753771,
        65.13213132696004,
        65.1558848298079,
        65.17963118846338,
        65.20337038529844,
        65.22710240267477,
        65.25082722294394,
        65.27454482844729,
        65.29825520151594,
        65.32195832447087,
        65.34565417962284,
        65.36934274927242,
        65.39302401570997,
        65.41669796121569,
        65.44036456805956,
        65.4640238185014,
        65.48767569479078,
        65.51132017916714,
        65.53495725385966,
        65.55858690108737,
        65.58220910305911,
        65.60582384197355,
        65.62943110001906,
        65.65303085937394,
        65.67662310220625,
        65.70020781067382,
        65.72378496692436,
        65.74735455309528,
        65.77091655131393,
        65.79447094369738,
        65.81801771235251,
        65.84155683937603,
        65.86508830685446,
        65.8886120968641,
        65.91212819147108,
        65.93563657273133,
        65.95913722269057,
        65.9826301233844,
        66.0061152568381,
        66.02959260506685,
        66.05306215007563,
        66.0765238738592,
        66.09997775840213,
        66.1234237856788,
        66.1468619376534,
        66.17029219627993,
        66.19371454350221,
        66.21712896125382,
        66.24053543145818,
        66.26393393602854,
        66.28732445686789,
        66.31070697586911,
        66.33408147491481,
        66.35744793587746,
        66.38080634061929,
        66.40415667099238,
        66.42749890883859,
        66.45083303598962,
        66.47415903426692,
        66.49747688548183,
        66.52078657143538,
        66.54408807391852,
        66.56738137471193,
        66.59066645558615,
        66.61394329830149,
        66.63721188460809,
        66.66047219624588,
        66.68372421494459,
        66.7069679224238,
        66.73020330039283,
        66.75343033055087,
        66.77664899458686,
        66.79985927417964,
        66.8230611509977,
        66.84625460669952,
        66.86943962293323,
        66.89261618133686,
        66.91578426353823,
        66.93894385115495,
        66.96209492579442,
        66.98523746905389,
        67.00837146252039,
        67.03149688777076,
        67.05461372637167,
        67.07772195987955,
        67.10082156984068,
        67.12391253779113,
        67.14699484525677,
        67.17006847375328,
        67.19313340478611,
        67.21618961985067,
        67.23923710043195,
        67.26227582800492,
        67.28530578403426,
        67.30832694997453,
        67.33133930727003,
        67.35434283735489,
        67.3773375216531,
        67.40032334157837,
        67.42330027853426,
        67.44626831391415,
        67.4692274291012,
        67.49217760546837,
        67.51511882437846,
        67.53805106718407,
        67.56097431522757,
        67.58388854984119,
        67.60679375234692,
        67.62968990405658,
        67.6525769862718,
        67.675454980284,
        67.69832386737443,
        67.72118362881412,
        67.74403424586393,
        67.7668756997745,
        67.78970797178634,
        67.81253104312965,
        67.83534489502455,
        67.85814950868092,
        67.88094486529843,
        67.9037309460666,
        67.92650773216471,
        67.9492752047619,
        67.97203334501707,
        67.99478213407895,
        68.01752155308604,
        68.0402515831667,
        68.06297220543908,
        68.08568340101114,
        68.1083851509806,
        68.13107743643504,
        68.15376023845182,
        68.17643353809815,
        68.199097316431,
        68.22175155449712,
        68.24439623333313,
        68.26703133396548,
        68.28965683741032,
        68.31227272467369,
        68.33487897675141,
        68.35747557462912,
        68.38006249928222,
        68.40263973167602,
        68.42520725276549,
        68.44776504349555,
        68.47031308480082,
        68.4928513576058,
        68.51537984282476,
        68.53789852136178,
        68.56040737411075,
        68.58290638195535,
        68.60539552576911,
        68.62787478641533,
        68.65034414474714,
        68.67280358160743,
        68.69525307782895,
        68.71769261423424,
        68.74012217163563,
        68.76254173083528,
        68.78495127262516,
        68.80735077778701,
        68.8297402270924,
        68.85211960130272,
        68.87448888116916,
        68.89684804743268,
        68.91919708082412,
        68.94153596206404,
        68.96386467186286,
        68.98618319092083,
        69.00849149992793,
        69.030789579564,
        69.05307741049869,
        69.07535497339146,
        69.09762224889153,
        69.11987921763794,
        69.14212586025963,
        69.16436215737517,
        69.18658808959312,
        69.20880363751169,
        69.23100878171904,
        69.25320350279304,
        69.27538778130136,
        69.29756159780156,
        69.31972493284093,
        69.3418777669566,
        69.36402008067552,
        69.38615185451438,
        69.40827306897974,
        69.43038370456797,
        69.45248374176522,
        69.47457316104747,
        69.49665194288045,
        69.51872006771976,
        69.54077751601076,
        69.56282426818868,
        69.5848603046785,
        69.606885605895,
        69.62890015224284,
        69.65090392411639,
        69.6728969018999,
        69.69487906596738,
        69.71685039668269,
        69.73881087439946,
        69.76076047946114,
        69.78269919220098,
        69.80462699294206,
        69.82654386199725,
        69.84844977966921,
        69.87034472625042,
        69.8922286820232,
        69.91410162725964,
        69.93596354222161,
        69.95781440716087,
        69.97965420231888,
        70.00148290792701,
        70.02330050420636,
        70.04510697136791,
        70.06690228961236,
        70.08868643913027,
        70.110459400102,
        70.13222115269772,
        70.1539716770774,
        70.17571095339079,
        70.19743896177752,
        70.21915568236697,
        70.24086109527829,
        70.26255518062055,
        70.28423791849251,
        70.3059092889828,
        70.32756927216985,
        70.3492178481219,
        70.37085499689697,
        70.39248069854291,
        70.41409493309737,
        70.4356976805878,
        70.45728892103146,
        70.47886863443544,
        70.5004368007966,
        70.52199340010165,
        70.54353841232705,
        70.56507181743912,
        70.58659359539395,
        70.60810372613744,
        70.62960218960532,
        70.65108896572313,
        70.67256403440618,
        70.69402737555959,
        70.71547896907833,
        70.73691879484716,
        70.7583468327406,
        70.77976306262305,
        70.80116746434867,
        70.82256001776142,
        70.84394070269512,
        70.86530949897332,
        70.88666638640943,
        70.90801134480667,
        70.92934435395803,
        70.95066539364633,
        70.97197444364421,
        70.9932714837141,
        71.01455649360821,
        71.0358294530686,
        71.05709034182713,
        71.07833913960545,
        71.09957582611503,
        71.12080038105711,
        71.1420127841228,
        71.16321301499298,
        71.18440105333833,
        71.20557687881934,
        71.22674047108633,
        71.24789180977942,
        71.26903087452851,
        71.29015764495331,
        71.31127210066339,
        71.33237422125805,
        71.35346398632643,
        71.37454137544755,
        71.39560636819009,
        71.41665894411263,
        71.43769908276356,
        71.45872676368103,
        71.47974196639308,
        71.50074467041742,
        71.52173485526171,
        71.54271250042333,
        71.5636775853895,
        71.58463008963723,
        71.60556999263333,
        71.62649727383447,
        71.64741191268706,
        71.66831388862734,
        71.68920318108135,
        71.71007976946498,
        71.73094363318388,
        71.75179475163353,
        71.77263310419919,
        71.79345867025593,
        71.81427142916868,
        71.83507136029212,
        71.85585844297074,
        71.87663265653887,
        71.89739398032064,
        71.91814239362994,
        71.9388778757705,
        71.9596004060359,
        71.98030996370944,
        72.00100652806428,
        72.0216900783634,
        72.04236059385954,
        72.06301805379528,
        72.08366243740299,
        72.10429372390489,
        72.12491189251291,
        72.14551692242892,
        72.16610879284444,
        72.18668748294094,
        72.20725297188962,
        72.2278052388515,
        72.24834426297743,
        72.26887002340803,
        72.28938249927373,
        72.3098816696948,
        72.33036751378131,
        72.3508400106331,
        72.37129913933987,
        72.39174487898106,
        72.41217720862599,
        72.43259610733372,
        72.45300155415315,
        72.47339352812301,
        72.49377200827178,
        72.5141369736178,
        72.53448840316919,
        72.5548262759239,
        72.57515057086961,
        72.5954612669839,
        72.61575834323415,
        72.63604177857748,
        72.65631155196084,
        72.67656764232105,
        72.69681002858464,
        72.717038689668,
        72.73725360447736,
        72.75745475190868,
        72.7776421108478,
        72.79781566017029,
        72.8179753787416,
        72.83812124541693,
        72.8582532390413,
        72.8783713384496,
        72.89847552246643,
        72.91856576990625,
        72.93864205957331,
        72.9587043702617,
        72.97875268075529,
        72.99878696982772,
        73.01880721624251,
        73.03881339875294,
        73.0588054961021,
        73.07878348702289,
        73.09874735023804,
        73.11869706446008,
        73.13863260839129,
        73.15855396072384,
        73.17846110013964,
        73.19835400531045,
        73.21823265489782,
        73.2380970275531,
        73.25794710191745,
        73.27778285662187,
        73.29760427028711,
        73.31741132152376,
        73.33720398893222,
        73.35698225110268,
        73.37674608661514,
        73.39649547403941,
        73.41623039193514,
        73.43595081885171,
        73.45565673332838,
        73.47534811389416,
        73.49502493906793,
        73.5146871873583,
        73.53433483726378,
        73.55396786727259,
        73.5735862558628,
        73.59318998150232,
        73.61277902264881,
        73.63235335774978,
        73.65191296524253,
        73.67145782355412,
        73.69098791110152,
        73.71050320629138,
        73.73000368752031,
        73.74948933317457,
        73.76896012163033,
        73.78841603125353,
        73.80785704039991,
        73.82728312741503,
        73.84669427063429,
        73.86609044838282,
        73.8854716389756,
        73.90483782071745,
        73.92418897190292,
        73.94352507081642,
        73.96284609573216,
        73.98215202491414,
        74.00144283661619,
        74.02071850908195,
        74.0399790205448,
        74.05922434922805,
        74.07845447334468,
        74.09766937109758,
        74.11686902067937,
        74.13605340027257,
        74.15522248804942,
        74.17437626217196,
        74.19351470079215,
        74.21263778205163,
        74.23174548408191,
        74.2508377850043,
        74.2699146629299,
        74.28897609595965,
        74.30802206218426,
        74.32705253968425,
        74.34606750652998,
        74.36506694078156,
        74.384050820489,
        74.403019123692,
        74.42197182842015,
        74.4409089126928,
        74.45983035451918,
        74.47873613189822,
        74.49762622281875,
        74.51650060525934,
        74.5353592571884,
        74.55420215656414,
        74.5730292813346,
        74.59184060943761,
        74.61063611880074,
        74.6294157873415,
        74.64817959296708,
        74.66692751357456,
        74.68565952705079,
        74.70437561127247,
        74.723075744106,
        74.74175990340771,
        74.76042806702367,
        74.77908021278976,
        74.7977163185317,
        74.816336362065,
        74.83494032119494,
        74.85352817371668,
        74.87209989741508,
        74.89065547006494,
        74.90919486943075,
        74.9277180732669,
        74.9462250593175,
        74.96471580531652,
        74.98319028898771,
        75.0016484880447,
        75.02009038019081,
        75.03851594311924,
        75.05692515451298,
        75.07531799204484,
        75.09369443337742,
        75.11205445616312,
        75.13039803804418,
        75.14872515665257,
        75.16703578961021,
        75.18532991452867,
        75.20360750900942,
        75.22186855064369,
        75.24011301701258,
        75.25834088568692,
        75.27655213422739,
        75.29474674018446,
        75.31292468109847,
        75.33108593449941,
        75.34923047790726,
        75.3673582888317,
        75.38546934477223,
        75.40356362321819,
        75.42164110164867,
        75.43970175753265,
        75.45774556832883,
        75.47577251148579,
        75.49378256444183,
        75.51177570462517,
        75.52975190945371,
        75.54771115633528,
        75.56565342266742,
        75.58357868583754,
        75.60148692322281,
        75.61937811219025,
        75.63725223009664,
        75.65510925428858,
        75.67294916210255,
        75.69077193086473,
        75.70857753789114,
        75.72636596048767,
        75.7441371759499,
        75.76189116156336,
        75.77962789460321,
        75.7973473523346,
        75.81504951201234,
        75.83273435088115,
        75.8504018461755,
        75.8680519751197,
        75.88568471492782,
        75.90330004280378,
        75.92089793594127,
        75.93847837152386,
        75.95604132672482,
        75.9735867787073,
        75.99111470462427,
        76.00862508161842,
        76.02611788682235,
        76.04359309735838,
        76.0610506903387,
        76.07849064286528,
        76.09591293202989,
        76.11331753491409,
        76.13070442858933,
        76.14807359011675,
        76.1654249965474,
        76.18275862492207,
        76.20007445227142,
        76.2173724556158,
        76.2346526119655,
        76.2519148983205,
        76.26915929167072,
        76.28638576899576,
        76.3035943072651,
        76.320784883438,
        76.33795747446351,
        76.35511205728055,
        76.37224860881778,
        76.3893671059937,
        76.4064675257166,
        76.4235498448846,
        76.44061404038558,
        76.45766008909729,
        76.47468796788723,
        76.49169765361277,
        76.50868912312102,
        76.52566235324892,
        76.54261732082324,
        76.55955400266052,
        76.57647237556714,
        76.59337241633929,
        76.6102541017629,
        76.62711740861381,
        76.64396231365757,
        76.66078879364959,
        76.67759682533507,
        76.69438638544904,
        76.71115745071629,
        76.72790999785147,
        76.74464400355902,
        76.76135944453314,
        76.77805629745791,
        76.79473453900717,
        76.81139414584459,
        76.8280350946236,
        76.84465736198754,
        76.86126092456941,
        76.87784575899214,
        76.8944118418684,
        76.91095914980072,
        76.92748765938138,
        76.9439973471925,
        76.96048818980599,
        76.97696016378357,
        76.99341324567679,
        77.009847412027,
        77.02626263936531,
        77.04265890421273,
        77.05903618307994,
        77.07539445246755,
        77.09173368886593,
        77.10805386875523,
        77.1243549686055,
        77.14063696487646,
        77.15689983401776,
        77.17314355246879,
        77.18936809665875,
        77.20557344300667,
        77.22175956792135,
        77.23792644780147,
        77.25407405903546,
        77.27020237800151,
        77.28631138106773,
        77.30240104459196,
        77.31847134492186,
        77.3345222583949,
        77.35055376133836,
        77.36656583006935,
        77.38255844089474,
        77.39853157011123,
        77.41448519400532,
        77.43041928885333,
        77.44633383092139,
        77.46222879646542,
        77.47810416173112,
        77.49395990295406,
        77.5097959963596,
        77.52561241816285,
        77.54140914456879,
        77.5571861517722,
        77.57294341595764,
        77.58868091329948,
        77.60439861996191,
        77.62009651209894,
        77.63577456585432,
        77.65143275736175,
        77.66707106274454,
        77.68268945811595,
        77.698287919579,
        77.71386642322655,
        77.72942494514119,
        77.74496346139543,
        77.76048194805146,
        77.77598038116136,
        77.791458736767,
        77.80691699090008,
        77.82235511958201,
        77.83777309882416,
        77.85317090462755,
        77.86854851298311,
        77.88390589987155,
        77.89924304126335,
        77.91455991311888,
        77.92985649138824,
        77.94513275201135,
        77.96038867091795,
        77.97562422402761,
        77.99083938724966,
        78.00603413648328,
        78.02120844761743,
        78.03636229653088,
        78.05149565909218,
        78.06660851115974,
        78.08170082858177,
        78.09677258719624,
        78.11182376283098,
        78.12685433130356,
        78.14186426842146,
        78.15685354998185,
        78.1718221517718,
        78.18677004956812,
        78.2016972191375,
        78.21660363623637,
        78.23148927661096,
        78.24635411599736,
        78.26119813012143,
        78.27602129469888,
        78.29082358543515,
        78.30560497802558,
        78.32036544815524,
        78.33510497149904,
        78.3498235237217,
        78.36452108047773,
        78.37919761741145,
        78.39385311015702,
        78.40848753433838,
        78.42310086556922,
        78.43769307945314,
        78.45226415158349,
        78.46681405754343,
        78.48134277290595,
        78.49585027323378,
        78.51033653407958,
        78.5248015309857,
        78.53924523948433,
        78.55366763509748,
        78.568068693337,
        78.58244838970447,
        78.59680669969133,
        78.6111435987788,
        78.62545906243793,
        78.63975306612956,
        78.65402558530435,
        78.66827659540276,
        78.68250607185504,
        78.69671399008128,
        78.71090032549135,
        78.72506505348494,
        78.73920814945156,
        78.75332958877047,
        78.76742934681081,
        78.78150739893148,
        78.79556372048118,
        78.80959828679846,
        78.82361107321167,
        78.8376020550389,
        78.85157120758814,
        78.8655185061571,
        78.87944392603337,
        78.89334744249432,
        78.90722903080712,
        78.92108866622873,
        78.93492632400596,
        78.94874197937537,
        78.96253560756341,
        78.97630718378622,
        78.99005668324988,
        79.00378408115013,
        79.01748935267268,
        79.03117247299292,
        79.0448334172761,
        79.05847216067724,
        79.07208867834125,
        79.08568294540271,
        79.09925493698616,
        79.11280462820585,
        79.12633199416584,
        79.13983700996002,
        79.15331965067209,
        79.16677989137555,
        79.18021770713369,
        79.19363307299966,
        79.20702596401637,
        79.2203963552165,
        79.23374422162263,
        79.24706953824709,
        79.26037228009201,
        79.27365242214935,
        79.28690993940091,
        79.3001448068182,
        79.31335699936261,
        79.32654649198533,
        79.3397132596273,
        79.35285727721939,
        79.36597851968214,
        79.37907696192597,
        79.39215257885111,
        79.40520534534758,
        79.4182352362952,
        79.43124222656357,
        79.44422629101219,
        79.45718740449023,
        79.47012554183682,
        79.48304067788078,
        79.49593278744076,
        79.50880184532528,
        79.52164782633258,
        79.53447070525075,
        79.5472704568577,
        79.56004705592112,
        79.57280047719853,
        79.58553069543723,
        79.59823768537433,
        79.61092142173679,
        79.62358187924129,
        79.63621903259443,
        79.64883285649248,
        79.66142332562167,
        79.67399041465794,
        79.686534098267,
        79.69905435110451,
        79.71155114781577,
        79.72402446303602,
        79.73647427139024,
        79.7489005474932,
        79.76130326594958,
        79.77368240135371,
        79.78603792828986,
        79.79836982133202,
        79.81067805504405,
        79.82296260397959,
        79.83522344268208,
        79.84746054568475,
        79.85967388751071,
        79.87186344267276,
        79.88402918567364,
        79.8961710910058,
        79.90828913315151,
        79.9203832865829,
        79.93245352576186,
        79.94449982514006,
        79.95652215915904,
        79.9685205022501,
        79.98049482883441,
        79.99244511332287,
        80.00437133011624,
        80.01627345360505,
        80.02815145816965,
        80.04000531818019,
        80.05183500799666,
        80.06364050196886,
        80.07542177443631,
        80.0871787997284,
        80.09891155216438,
        80.1106200060532,
        80.12230413569367,
        80.13396391537441,
        80.14559931937386,
        80.15721032196024,
        80.16879689739156,
        80.18035901991567,
        80.19189666377021,
        80.20340980318267,
        80.21489841237026,
        80.22636246554006,
        80.23780193688897,
        80.24921680060363,
        80.26060703086058,
        80.27197260182606,
        80.2833134876562,
        80.29462966249689,
        80.30592110048386,
        80.31718777574261,
        80.32842966238847,
        80.33964673452658,
        80.35083896625191,
        80.36200633164914,
        80.37314880479288,
        80.38426635974746,
        80.39535897056703,
        80.40642661129561,
        80.41746925596698,
        80.42848687860469,
        80.43947945322213,
        80.45044695382254,
        80.46138935439888,
        80.472306628934,
        80.48319875140054,
        80.49406569576088,
        80.50490743596725,
        80.51572394596171,
        80.5265151996761,
        80.53728117103208,
        80.54802183394109,
        80.55873716230444,
        80.56942713001317,
        80.58009171094817,
        80.5907308789801,
        80.60134460796951,
        80.61193287176664,
        80.62249564421165,
        80.6330328991344,
        80.64354461035467,
        80.6540307516819,
        80.66449129691553,
        80.67492621984461,
        80.68533549424812,
        80.69571909389482,
        80.7060769925433,
        80.71640916394185,
        80.72671558182871,
        80.73699621993183,
        80.747251051969,
        80.75748005164783,
        80.7676831926657,
        80.7778604487098,
        80.78801179345719,
        80.79813720057467,
        80.80823664371884,
        80.81831009653617,
        80.82835753266286,
        80.83837892572502,
        80.84837424933846,
        80.85834347710883,
        80.86828658263161,
        80.87820353949212,
        80.88809432126536,
        80.89795890151626,
        80.90779725379949,
        80.91760935165958,
        80.92739516863082,
        80.93715467823733,
        80.94688785399302,
        80.95659466940162,
        80.96627509795671,
        80.97592911314152,
        80.98555668842933,
        80.99515779728297,
        81.00473241315531,
        81.01428050948881,
        81.02380205971595,
        81.0332970372588,
        81.04276541552946,
        81.05220716792962,
        81.06162226785098,
        81.07101068867487,
        81.08037240377251,
        81.08970738650497,
        81.09901561022303,
        81.10829704826736,
        81.11755167396834,
        81.12677946064629,
        81.1359803816112,
        81.14515441016299,
        81.15430151959126,
        81.16342168317556,
        81.17251487418508,
        81.181581065879,
        81.19062023150619,
        81.19963234430529,
        81.20861737750485,
        81.21757530432319,
        81.22650609796844,
        81.23540973163848,
        81.2442861785211,
        81.25313541179378,
        81.26195740462393,
        81.27075213016862,
        81.27951956157493,
        81.28825967197955,
        81.29697243450903,
        81.30565782227981,
        81.31431580839802,
        81.32294636595974,
        81.33154946805065,
        81.34012508774649,
        81.34867319811254,
        81.35719377220413,
        81.36568678306621,
        81.37415220373369,
        81.38259000723112,
        81.39100016657302,
        81.39938265476363,
        81.40773744479698,
        81.41606450965696,
        81.4243638223172,
        81.43263535574127,
        81.44087908288239,
        81.44909497668367,
        81.45728301007799,
        81.46544315598813,
        81.47357538732649,
        81.48167967699548,
        81.48975599788719,
        81.49780432288358,
        81.50582462485639,
        81.5138168766671,
        81.52178105116714,
        81.52971712119762,
        81.53762505958956,
        81.54550483916367,
        81.5533564327306,
        81.56117981309067,
        81.56897495303414,
        81.57674182534095,
        81.58448040278094,
        81.5921906581137,
        81.59987256408871,
        81.60752609344516,
        81.61515121891202,
        81.62274791320823,
        81.63031614904237,
        81.63785589911295,
        81.64536713610818,
        81.65284983270615,
        81.6603039615747,
        81.66772949537162,
        81.67512640674425,
        81.68249466833,
        81.68983425275589,
        81.69714513263887,
        81.70442728058565,
        81.71168066919272,
        81.71890527104647,
        81.72610105872296,
        81.7332680047882,
        81.74040608179789,
        81.7475152622976,
        81.75459551882265,
        81.7616468238983,
        81.76866915003944,
        81.7756624697509,
        81.78262675552725,
        81.78956197985285,
        81.79646811520196,
        81.80334513403852,
        81.81019300881646,
        81.81701171197923,
        81.82380121596042,
        81.83056149318314,
        81.83729251606053,
        81.84399425699534,
        81.85066668838034,
        81.85730978259788,
        81.8639235120203,
        81.87050784900966,
        81.87706276591778,
        81.88358823508646,
        81.89008422884707,
        81.89655071952102,
        81.90298767941931,
        81.90939508084298,
        81.91577289608264,
        81.92212109741888,
        81.92843965712198,
        81.93472854745217,
        81.9409877406593,
        81.94721720898319,
        81.95341692465338,
        81.95958685988919,
        81.96572698689988,
        81.97183727788438,
        81.97791770503149,
        81.98396824051979,
        81.98998885651771,
        81.9959795251834,
        82.00194021866496,
        82.00787090910012,
        82.01377156861659,
        82.01964216933176,
        82.02548268335285,
        82.03129308277697,
        82.03707333969089,
        82.04282342617135,
        82.04854331428477,
        82.05423297608746,
        82.05989238362545,
        82.0655215089347,
        82.0711203240408,
        82.07668880095939,
        82.08222691169563,
        82.08773462824476,
        82.09321192259165,
        82.09865876671097,
        82.10407513256735,
        82.10946099211503,
        82.11481631729829,
        82.12014108005096,
        82.12543525229688,
        82.13069880594954,
        82.13593171291242,
        82.14113394507861,
        82.14630547433116,
        82.15144627254278,
        82.15655631157617,
        82.1616355632837,
        82.16668399950754,
        82.17170159207978,
        82.17668831282218,
        82.18164413354647,
        82.18656902605396,
        82.19146296213601,
        82.19632591357362,
        82.20115785213767,
        82.20595874958882,
        82.21072857767756,
        82.21546730814411,
        82.22017491271865,
        82.22485136312105,
        82.22949663106093,
        82.2341106882379,
        82.23869350634119,
        82.24324505704999,
        82.24776531203318,
        82.25225424294955,
        82.25671182144755,
        82.26113801916564,
        82.26553280773186,
        82.2698961587643,
        82.27422804387064,
        82.27852843464841,
        82.2827973026851,
        82.28703461955782,
        82.29124035683363,
        82.29541448606925,
        82.29955697881138,
        82.30366780659634,
        82.30774694095042,
        82.31179435338962,
        82.31581001541979,
        82.31979389853653,
        82.32374597422536,
        82.32766621396149,
        82.33155458920996,
        82.33541107142567,
        82.33923563205327,
        82.34302824252728,
        82.34678887427194,
        82.35051749870141,
        82.35421408721949,
        82.35787861122,
        82.36151104208636,
        82.36511135119198,
        82.3686795098999,
        82.37221548956315,
        82.37571926152438,
        82.37919079711615,
        82.3826300676609,
        82.38603704447065,
        82.38941169884751,
        82.39275400208315,
        82.39606392545925,
        82.39934144024708,
        82.40258651770796,
        82.40579912909277,
        82.40897924564241,
        82.41212683858743,
        82.41524187914831,
        82.41832433853524,
        82.42137418794825,
        82.42439139857721,
        82.42737594160172,
        82.43032778819133,
        82.43324690950517,
        82.43613327669242,
        82.43898686089186,
        82.44180763323227,
        82.44459556483207,
        82.44735062679959,
        82.45007279023288,
        82.45276202621992,
        82.45541830583839,
        82.45804160015577,
        82.46063188022949,
        82.46318911710655,
        82.46571328182401,
        82.46820434540854,
        82.47066227887676,
        82.47308705323495,
        82.47547863947936,
        82.4778370085959,
        82.48016213156042,
        82.48245397933847,
        82.4847125228854,
        82.48693773314648,
        82.48912958105669,
        82.49128803754087,
        82.49341307351355,
        82.49550465987929,
        82.49756276753223,
        82.49958736735645,
        82.50157843022578,
        82.50353592700391,
        82.50545982854425,
        82.50735010569012,
        82.50920672927458,
        82.51102967012046,
        82.51281889904051,
        82.5145743868372,
        82.51629610430284,
        82.5179840222195,
        82.51963811135916,
        82.52125834248348,
        82.52284468634406,
        82.52439711368214,
        82.52591559522898,
        82.52740010170541,
        82.52885060382226,
        82.53026707228007,
        82.53164947776916,
        82.53299779096982,
        82.53431198255191,
        82.53559202317528,
        82.53683788348951,
        82.53804953413402,
        82.539226945738,
        82.54037008892047,
        82.54147893429023,
        82.54255345244596,
        82.54359361397601,
        82.54459938945875,
        82.54557074946213,
        82.54650766454398,
        82.54741010525208,
        82.54827804212377,
        82.54911144568642,
        82.54991028645703,
        82.55067453494259,
        82.55140416163967,
        82.5520991370349,
        82.55275943160447,
        82.55338501581461,
        82.55397586012117,
        82.55453193496986,
        82.55505321079627,
        82.5555396580257,
        82.55599124707334,
        82.55640794834409,
        82.55678973223277,
        82.55713656912388,
        82.5574484293919,
        82.55772528340088,
        82.55796710150491,
        82.55817385404774,
        82.55834551136302,
        82.55848204377408,
        82.55858342159416,
        82.55864961512636,
        82.55868059466339,
        82.55867633048797,
        82.55863679287248,
        82.55856195207923,
        82.55845177836021,
        82.55830624195737,
        82.55812531310227,
        82.55790896201647,
        82.55765715891118,
        82.5573698739876,
        82.55704707743654,
        82.55668873943867,
        82.5562948301646,
        82.55586531977453,
        82.5554001784187,
        82.55489937623693,
        82.55436288335905,
        82.55379066990449,
        82.55318270598275,
        82.55253896169283,
        82.5518594071238,
        82.55114401235437,
        82.55039274745316,
        82.54960558247853,
        82.54878248747863,
        82.54792343249153,
        82.54702838754494,
        82.54609732265658,
        82.54513020783374,
        82.54412701307378,
        82.54308770836359,
        82.54201226368014,
        82.54090064898993,
        82.53975283424954,
        82.53856878940516,
        82.53734848439282,
        82.53609188913845,
        82.53479897355768,
        82.53346970755608,
        82.53210406102879,
        82.53070200386105,
        82.52926350592763,
        82.52778853709339,
        82.52627706721267,
        82.52472906612998,
        82.52314450367928,
        82.52152334968461,
        82.51986557395972,
        82.51817114630805,
        82.51644003652306,
        82.51467221438784,
        82.51286764967546,
        82.51102631214854,
        82.50914817155984,
        82.50723319765159,
        82.50528136015612,
        82.5032926287953,
        82.50126697328105,
        82.49920436331492,
        82.49710476858837,
        82.49496815878263,
        82.49279450356865,
        82.49058377260742,
        82.48833593554943,
        82.48605096203526,
        82.48372882169508,
        82.48136948414907,
        82.47897291900696,
        82.47653909586859,
        82.4740679843233,
        82.47155955395051,
        82.4690137743192,
        82.46643061498841,
        82.46381004550679,
        82.46115203541281,
        82.4584565542349,
        82.45572357149109,
        82.45295305668942,
        82.45014497932758,
        82.44729930889318,
        82.44441601486349,
        82.44149506670577,
        82.43853643387692,
        82.43554008582379,
        82.43250599198298,
        82.42943412178076,
        82.42632444463348,
        82.42317692994702,
        82.4199915471173,
        82.41676826552988,
        82.41350705456026,
        82.41020788357356,
        82.40687072192496,
        82.40349553895916,
        82.40008230401097,
        82.39663098640472,
        82.39314155545478,
        82.38961398046516,
        82.38604823072971,
        82.38244427553224,
        82.37880208414613,
        82.37512162583475,
        82.37140286985117,
        82.36764578543836,
        82.36385034182895,
        82.36001650824555,
        82.35614425390044,
        82.35223354799582,
        82.34828435972359,
        82.34429665826555,
        82.34027041279326,
        82.336205592468,
        82.33210216644106,
        82.32796010385334,
        82.32377937383569,
        82.31955994550862,
        82.31530178798266,
        82.31100487035789,
        82.30666916172443,
        82.30229463116201,
        82.29788124774038,
        82.29342898051883,
        82.2889377985467,
        82.28440767086303,
        82.27983856649661,
        82.27523045446621,
        82.27058330378019,
        82.26589708343688,
        82.26117176242435,
        82.25640730972053,
        82.25160369429304,
        82.24676088509946,
        82.24187885108701,
        82.23695756119292,
        82.231996984344,
        82.22699708945707,
        82.22195784543862,
        82.21687922118494,
        82.2117611855823,
        82.20660370750655,
        82.20140675582353,
        82.19617029938871,
        82.19089430704759,
        82.18557874763525,
        82.18022358997675,
        82.17482880288684,
        82.16939435517016,
        82.1639202156211,
        82.15840635302382,
        82.15285273615244,
        82.1472593337707,
        82.14162611463233,
        82.13595304748068,
        82.13024010104907,
        82.12448724406049,
        82.11869444522789,
        82.11286167325383,
        82.1069888968309,
        82.10107608464126,
        82.09512320535714,
        82.08913022764034,
        82.08309712014253,
        82.07702385150534,
        82.07091039035994,
        82.06475670532761,
        82.05856276501913,
        82.05232853803537,
        82.04605399296675,
        82.03973909839371,
        82.03338382288635,
        82.0269881350047,
        82.02055200329842,
        82.0140753963072,
        82.00755828256038,
        82.0010006305771,
        81.99440240886642,
        81.9877635859271,
        81.9810841302478,
        81.97436401030686,
        81.9676031945726,
        81.96080165150292,
        81.95395934954583,
        81.94707625713878,
        81.94015234270938,
        81.93318757467479,
        81.92618192144212,
        81.91913535140823,
        81.91204783295974,
        81.90491933447323,
        81.89774982431489,
        81.8905392708409,
        81.8832876423971,
        81.87599490731925,
        81.86866103393282,
        81.86128599055321,
        81.85386974548541,
        81.84641226702452,
        81.83891352345519,
        81.83137348305193,
        81.82379211407918,
        81.81616938479104,
        81.80850526343158,
        81.80079971823443,
        81.7930527174233,
        81.78526422921148,
        81.77743422180225,
        81.76956266338854,
        81.76164952215326,
        81.7536947662689,
        81.74569836389799,
        81.73766028319271,
        81.72958049229504,
        81.72145895933696,
        81.71329565243997,
        81.70509053971564,
        81.69684358926516,
        81.68855476917966,
        81.68022404753995,
        81.67185139241678,
        81.66343677187058,
        81.65498015395171,
        81.6464815067002,
        81.63794079814603,
        81.62935799630887,
        81.62073306919824,
        81.61206598481351,
        81.60335671114372,
        81.59460521616795,
        81.58581146785484,
        81.57697543416305,
        81.56809708304081,
        81.55917638242641,
        81.55021330024772,
        81.54120780442264,
        81.53215986285865,
        81.52306944345325,
        81.51393651409356,
        81.50476104265658,
        81.49554299700922,
        81.486282345008,
        81.47697905449942,
        81.46763309331968,
        81.45824442929485,
        81.44881303024071,
        81.43933886396304,
        81.42982189825717,
        81.4202621009085,
        81.41065943969201,
        81.40101388237257,
        81.39132539670497,
        81.38159395043358,
        81.37181951129283,
        81.3620020470067,
        81.35214152528926,
        81.34223791384406,
        81.33229118036478,
        81.32230129253466,
        81.31226821802689,
        81.3021919245044,
        81.29207237961998,
        81.28190955101616,
        81.27170340632526,
        81.26145391316958,
        81.25116103916098,
        81.24082475190134,
        81.23044501898218,
        81.22002180798499,
        81.20955508648088,
        81.19904482203096,
        81.18849098218595,
        81.1778935344866,
        81.16725244646327,
        81.15656768563623,
        81.14583921951554,
        81.13506701560097,
        81.12425104138231,
        81.1133912643389,
        81.10248765194018,
        81.09154017164505,
        81.08054879090254,
        81.06951347715123,
        81.05843419781976,
        81.04731092032632,
        81.0361436120791,
        81.02493224047596,
        81.01367677290472,
        81.00237717674285,
        80.99103341935768,
        80.97964546810638,
        80.9682132903359,
        80.95673685338306,
        80.94521612457432,
        80.9336510712262,
        80.92204166064471,
        80.91038786012601,
        80.89868963695575,
        80.88694695840967,
        80.8751597917531,
        80.86332810424122,
        80.85145186311915
    ],
    PADEL: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.013984320356503988,
        0.028969701002330206,
        0.043955081648156424,
        0.05894046229398242,
        0.07392584293980864,
        0.08891122358563486,
        0.10389660423146108,
        0.11888198487728707,
        0.1338673655231133,
        0.1488527461689395,
        0.1638381268147655,
        0.17882350746059172,
        0.19380888810641794,
        0.20879426875224416,
        0.22377964939807016,
        0.23876503004389638,
        0.2537504106897226,
        0.2687357913355486,
        0.2837211719813748,
        0.298706552627201,
        0.31369193327302725,
        0.32867731391885324,
        0.34366269456467946,
        0.3586480752105057,
        0.3736334558563317,
        0.3886188365021579,
        0.4036042171479841,
        0.41858959779381033,
        0.43357497843963655,
        0.4485603590854623,
        0.46354573973128854,
        0.47853112037711476,
        0.493516501022941,
        0.5085018816687672,
        0.5234872623145934,
        0.5384726429604196,
        0.5534580236062454,
        0.5684434042520716,
        0.5834287848978978,
        0.5984141655437241,
        0.6133995461895503,
        0.6283849268353765,
        0.6433703074812027,
        0.6583556881270285,
        0.6733410687728547,
        0.6883264494186809,
        0.7033118300645071,
        0.7182972107103334,
        0.7332825913561596,
        0.7482679720019858,
        0.7632533526478116,
        0.7782387332936378,
        0.793224113939464,
        0.8082094945852902,
        0.8231948752311165,
        0.8381802558769427,
        0.8531656365227689,
        0.8681510171685947,
        0.8831363978144209,
        0.8981217784602471,
        0.9131071591060733,
        0.9280925397518995,
        0.9430779203977258,
        0.958063301043552,
        0.9730486816893777,
        0.988034062335204,
        1.0030194429810302,
        1.0180048236268564,
        1.0329902042726826,
        1.0479755849185088,
        1.062960965564335,
        1.0779463462101608,
        1.092931726855987,
        1.1079171075018133,
        1.1229024881476395,
        1.1378878687934657,
        1.152873249439292,
        1.1678586300851181,
        1.182844010730944,
        1.1978293913767701,
        1.2128147720225964,
        1.2278001526684226,
        1.2427855333142488,
        1.257770913960075,
        1.2727562946059012,
        1.287741675251727,
        1.3027270558975532,
        1.3177124365433794,
        1.3326978171892057,
        1.3476831978350319,
        1.362668578480858,
        1.3776539591266843,
        1.39263933977251,
        1.4076247204183363,
        1.4226101010641625,
        1.4375954817099887,
        1.452580862355815,
        1.4675662430016412,
        1.4825516236474674,
        1.4975370042932932,
        1.5125223849391194,
        1.5275077655849456,
        1.5424931462307718,
        1.557478526876598,
        1.5724639075224243,
        1.5874492881682505,
        1.6024346688140763,
        1.6174200494599025,
        1.6324054301057287,
        1.647390810751555,
        1.6623761913973811,
        1.6773615720432073,
        1.6923469526890331,
        1.7073323333348593,
        1.7223177139806856,
        1.7373030946265118,
        1.752288475272338,
        1.7672738559181642,
        1.7822592365639904,
        1.7972446172098162,
        1.8122299978556424,
        1.8272153785014686,
        1.8422007591472949,
        1.857186139793121,
        1.8721715204389473,
        1.8871569010847735,
        1.9021422817305993,
        1.9171276623764255,
        1.9321130430222517,
        1.947098423668078,
        1.9620838043139042,
        1.9770691849597304,
        1.9920545656055566,
        2.0070399462513824,
        2.0220253268972086,
        2.037010707543035,
        2.051996088188861,
        2.0669814688346873,
        2.0819668494805135,
        2.0969522301263397,
        2.1119376107721655,
        2.1269229914179917,
        2.141908372063818,
        2.156893752709644,
        2.1718791333554703,
        2.1868645140012966,
        2.2018498946471228,
        2.2168352752929485,
        2.2318206559387748,
        2.246806036584601,
        2.261791417230427,
        2.2767767978762534,
        2.2917621785220796,
        2.306747559167906,
        2.3217329398137316,
        2.336718320459558,
        2.351703701105384,
        2.3666890817512103,
        2.3816744623970365,
        2.3966598430428627,
        2.411645223688689,
        2.426630604334515,
        2.4416159849803414,
        2.4566013656261676,
        2.471586746271993,
        2.486572126917819,
        2.5015575075636454,
        2.5165428882094716,
        2.531528268855298,
        2.546513649501124,
        2.5614990301469502,
        2.5764844107927765,
        2.5914697914386027,
        2.606455172084429,
        2.621440552730255,
        2.6364259333760813,
        2.6514113140219076,
        2.6663966946677338,
        2.681382075313559,
        2.6963674559593853,
        2.7113528366052115,
        2.7263382172510378,
        2.741323597896864,
        2.75630897854269,
        2.7712943591885164,
        2.7862797398343426,
        2.801265120480169,
        2.816250501125995,
        2.8312358817718213,
        2.8462212624176475,
        2.8612066430634737,
        2.8761920237093,
        2.8911774043551253,
        2.9061627850009515,
        2.9211481656467777,
        2.936133546292604,
        2.95111892693843,
        2.9661043075842564,
        2.9810896882300826,
        2.996075068875909,
        3.011060449521735,
        3.0260458301675612,
        3.0410312108133875,
        3.0560165914592137,
        3.07100197210504,
        3.085987352750866,
        3.1009727333966914,
        3.1159581140425177,
        3.130943494688344,
        3.14592887533417,
        3.1609142559799963,
        3.1758996366258225,
        3.1908850172716487,
        3.205870397917475,
        3.220855778563301,
        3.2358411592091274,
        3.2508265398549536,
        3.26581192050078,
        3.280797301146606,
        3.2957826817924323,
        3.3107680624382576,
        3.325753443084084,
        3.34073882372991,
        3.3557242043757363,
        3.3707095850215625,
        3.3856949656673887,
        3.400680346313215,
        3.415665726959041,
        3.4306511076048674,
        3.4456364882506936,
        3.46062186889652,
        3.475607249542346,
        3.4905926301881722,
        3.5055780108339984,
        3.520563391479824,
        3.53554877212565,
        3.550534152771476,
        3.5655195334173024,
        3.5805049140631287,
        3.595490294708955,
        3.610475675354781,
        3.6254610560006073,
        3.6404464366464335,
        3.6554318172922597,
        3.670417197938086,
        3.685402578583912,
        3.7003879592297384,
        3.7153733398755637,
        3.73035872052139,
        3.745344101167216,
        3.7603294818130424,
        3.7753148624588686,
        3.790300243104695,
        3.805285623750521,
        3.8202710043963473,
        3.8352563850421735,
        3.8502417656879997,
        3.865227146333826,
        3.880212526979652,
        3.8951979076254784,
        3.9101832882713046,
        3.92516866891713,
        3.940154049562956,
        3.9551394302087823,
        3.9701248108546086,
        3.9851101915004348,
        4.000095572146261,
        4.015080952792087,
        4.030066333437913,
        4.04505171408374,
        4.060037094729566,
        4.075022475375392,
        4.090007856021218,
        4.1049932366670445,
        4.119978617312871,
        4.134963997958696,
        4.149949378604522,
        4.1649347592503485,
        4.179920139896175,
        4.194905520542001,
        4.209890901187827,
        4.224876281833653,
        4.23986166247948,
        4.254847043125306,
        4.269832423771132,
        4.284817804416958,
        4.2998031850627845,
        4.314788565708611,
        4.329773946354437,
        4.344759327000262,
        4.3597447076460885,
        4.374730088291915,
        4.389715468937741,
        4.404700849583567,
        4.419686230229393,
        4.4346716108752195,
        4.449656991521046,
        4.464642372166872,
        4.479627752812698,
        4.494613133458524,
        4.509598514104351,
        4.524583894750177,
        4.539569275396003,
        4.554554656041828,
        4.569540036687655,
        4.584525417333481,
        4.599510797979307,
        4.614496178625133,
        4.6294815592709595,
        4.644466939916786,
        4.659452320562612,
        4.674437701208438,
        4.689423081854264,
        4.704408462500091,
        4.719393843145917,
        4.734379223791743,
        4.749364604437569,
        4.764349985083395,
        4.779335365729221,
        4.794320746375047,
        4.809306127020873,
        4.8242915076666995,
        4.839276888312526,
        4.854262268958352,
        4.869247649604178,
        4.884233030250004,
        4.8992184108958305,
        4.914203791541657,
        4.929189172187483,
        4.944174552833309,
        4.9591599334791345,
        4.974145314124961,
        4.989130694770787,
        5.004116075416613,
        5.019101456062439,
        5.034086836708266,
        5.049072217354092,
        5.064057597999918,
        5.079042978645744,
        5.0940283592915705,
        5.109013739937397,
        5.123999120583223,
        5.138984501229049,
        5.153969881874875,
        5.168955262520701,
        5.183940643166527,
        5.198926023812353,
        5.213911404458179,
        5.228896785104006,
        5.243882165749832,
        5.258867546395658,
        5.273852927041484,
        5.2888383076873104,
        5.303823688333137,
        5.318809068978963,
        5.333794449624789,
        5.348779830270615,
        5.3637652109164415,
        5.378750591562267,
        5.393735972208093,
        5.408721352853919,
        5.4237067334997455,
        5.438692114145572,
        5.453677494791398,
        5.468662875437224,
        5.48364825608305,
        5.498633636728877,
        5.513619017374703,
        5.528604398020529,
        5.543589778666355,
        5.5585751593121815,
        5.573560539958008,
        5.588545920603833,
        5.603531301249659,
        5.6185166818954855,
        5.633502062541312,
        5.648487443187138,
        5.663472823832964,
        5.67845820447879,
        5.693443585124617,
        5.708428965770443,
        5.723414346416269,
        5.738399727062095,
        5.753385107707921,
        5.768370488353748,
        5.783355868999574,
        5.798341249645399,
        5.813326630291225,
        5.828312010937052,
        5.843297391582878,
        5.858282772228704,
        5.87326815287453,
        5.8882535335203565,
        5.903238914166183,
        5.918224294812009,
        5.933209675457835,
        5.948195056103661,
        5.963180436749488,
        5.978165817395314,
        5.99315119804114,
        6.008136578686965,
        6.023121959332792,
        6.038107339978618,
        6.053092720624444,
        6.06807810127027,
        6.0830634819160965,
        6.098048862561923,
        6.113034243207749,
        6.128019623853575,
        6.143005004499401,
        6.157990385145228,
        6.172975765791054,
        6.18796114643688,
        6.202946527082705,
        6.2179319077285315,
        6.232917288374358,
        6.247902669020184,
        6.26288804966601,
        6.277873430311836,
        6.292858810957663,
        6.307844191603489,
        6.322829572249315,
        6.337814952895141,
        6.3528003335409675,
        6.367785714186794,
        6.38277109483262,
        6.397756475478446,
        6.4127418561242715,
        6.427727236770099,
        6.442712617415924,
        6.457697998061751,
        6.472683378707576,
        6.4876687593534035,
        6.502654139999229,
        6.517639520645054,
        6.532624901290881,
        6.547610281936707,
        6.562595662582534,
        6.577581043228359,
        6.592566423874186,
        6.6075518045200115,
        6.622537185165839,
        6.637522565811664,
        6.652507946457491,
        6.667493327103316,
        6.682478707749143,
        6.697464088394969,
        6.712449469040796,
        6.727434849686621,
        6.7424202303324465,
        6.757405610978274,
        6.772390991624099,
        6.787376372269926,
        6.802361752915751,
        6.8173471335615785,
        6.832332514207404,
        6.847317894853231,
        6.862303275499056,
        6.877288656144883,
        6.892274036790709,
        6.907259417436536,
        6.922244798082361,
        6.9372301787281865,
        6.952215559374014,
        6.967200940019839,
        6.982186320665666,
        6.997171701311491,
        7.0121570819573185,
        7.027142462603144,
        7.042127843248971,
        7.057113223894796,
        7.072098604540623,
        7.087083985186449,
        7.102069365832276,
        7.117054746478101,
        7.132040127123928,
        7.1470255077697535,
        7.162010888415579,
        7.176996269061406,
        7.191981649707231,
        7.206967030353058,
        7.221952410998884,
        7.236937791644711,
        7.251923172290536,
        7.266908552936363,
        7.281893933582189,
        7.296879314228016,
        7.311864694873841,
        7.326850075519668,
        7.3418354561654935,
        7.356820836811319,
        7.371806217457146,
        7.386791598102971,
        7.401776978748798,
        7.416762359394624,
        7.431747740040451,
        7.446733120686276,
        7.461718501332103,
        7.476703881977929,
        7.491689262623756,
        7.506674643269581,
        7.521660023915408,
        7.536645404561233,
        7.551630785207059,
        7.566616165852886,
        7.581601546498711,
        7.596586927144538,
        7.611572307790364,
        7.626557688436191,
        7.641543069082016,
        7.656528449727843,
        7.6715138303736685,
        7.686499211019496,
        7.701484591665321,
        7.716469972311148,
        7.731455352956973,
        7.7464407336028005,
        7.761426114248626,
        7.776411494894451,
        7.791396875540278,
        7.806382256186104,
        7.821367636831931,
        7.836353017477756,
        7.851338398123583,
        7.8663237787694085,
        7.881309159415236,
        7.896294540061061,
        7.911279920706888,
        7.926265301352713,
        7.9412506819985405,
        7.956236062644366,
        7.971221443290191,
        7.986206823936018,
        8.001192204581844,
        8.01617758522767,
        8.031162965873495,
        8.046148346519324,
        8.06113372716515,
        8.076119107810975,
        8.0911044884568,
        8.106089869102629,
        8.121075249748454,
        8.13606063039428,
        8.151046011040105,
        8.166031391685934,
        8.181016772331759,
        8.196002152977584,
        8.21098753362341,
        8.225972914269235,
        8.240958294915064,
        8.25594367556089,
        8.270929056206715,
        8.28591443685254,
        8.300899817498369,
        8.315885198144194,
        8.33087057879002,
        8.345855959435845,
        8.360841340081674,
        8.375826720727499,
        8.390812101373324,
        8.40579748201915,
        8.420782862664975,
        8.435768243310804,
        8.45075362395663,
        8.465739004602455,
        8.48072438524828,
        8.495709765894109,
        8.510695146539934,
        8.52568052718576,
        8.540665907831585,
        8.555651288477414,
        8.570636669123239,
        8.585622049769064,
        8.60060743041489,
        8.615592811060715,
        8.630578191706544,
        8.64556357235237,
        8.660548952998194,
        8.67553433364402,
        8.690519714289849,
        8.705505094935674,
        8.7204904755815,
        8.735475856227325,
        8.750461236873154,
        8.765446617518979,
        8.780431998164804,
        8.79541737881063,
        8.810402759456455,
        8.825388140102284,
        8.84037352074811,
        8.855358901393934,
        8.87034428203976,
        8.885329662685589,
        8.900315043331414,
        8.91530042397724,
        8.930285804623065,
        8.945271185268894,
        8.960256565914719,
        8.975241946560544,
        8.99022732720637,
        9.005212707852195,
        9.020198088498024,
        9.035183469143849,
        9.050168849789674,
        9.0651542304355,
        9.080139611081329,
        9.095124991727154,
        9.11011037237298,
        9.125095753018805,
        9.140081133664633,
        9.155066514310459,
        9.170051894956284,
        9.18503727560211,
        9.200022656247938,
        9.215008036893764,
        9.229993417539589,
        9.244978798185414,
        9.25996417883124,
        9.274949559477069,
        9.289934940122894,
        9.30492032076872,
        9.319905701414545,
        9.334891082060373,
        9.349876462706199,
        9.364861843352024,
        9.37984722399785,
        9.394832604643678,
        9.409817985289504,
        9.424803365935329,
        9.439788746581154,
        9.45477412722698,
        9.469759507872809,
        9.484744888518634,
        9.49973026916446,
        9.514715649810285,
        9.529701030456113,
        9.544686411101939,
        9.559671791747764,
        9.57465717239359,
        9.589642553039418,
        9.604627933685244,
        9.619613314331069,
        9.634598694976894,
        9.64958407562272,
        9.664569456268548,
        9.679554836914374,
        9.6945402175602,
        9.709525598206024,
        9.724510978851853,
        9.739496359497679,
        9.754481740143504,
        9.76946712078933,
        9.784452501435158,
        9.799437882080984,
        9.814423262726809,
        9.829408643372634,
        9.84439402401846,
        9.859379404664288,
        9.874364785310114,
        9.889350165955939,
        9.904335546601764,
        9.919320927247593,
        9.934306307893419,
        9.949291688539244,
        9.96427706918507,
        9.979262449830898,
        9.994247830476723,
        10.009233211122549,
        10.024218591768374,
        10.0392039724142,
        10.054189353060028,
        10.069174733705854,
        10.084160114351679,
        10.099145494997504,
        10.114130875643333,
        10.129116256289159,
        10.144101636934984,
        10.15908701758081,
        10.174072398226638,
        10.189057778872463,
        10.204043159518289,
        10.219028540164114,
        10.234013920809943,
        10.248999301455768,
        10.263984682101594,
        10.278970062747419,
        10.293955443393244,
        10.308940824039073,
        10.323926204684899,
        10.338911585330724,
        10.35389696597655,
        10.368882346622378,
        10.383867727268203,
        10.398853107914029,
        10.413838488559854,
        10.428823869205683,
        10.443809249851508,
        10.458794630497334,
        10.473780011143159,
        10.488765391788984,
        10.503750772434813,
        10.518736153080638,
        10.533721533726464,
        10.54870691437229,
        10.563692295018118,
        10.578677675663943,
        10.593663056309769,
        10.608648436955594,
        10.623633817601423,
        10.638619198247248,
        10.653604578893074,
        10.668589959538899,
        10.683575340184724,
        10.698560720830553,
        10.713546101476378,
        10.728531482122204,
        10.743516862768029,
        10.758502243413858,
        10.773487624059683,
        10.788473004705509,
        10.803458385351334,
        10.818443765997163,
        10.833429146642988,
        10.848414527288814,
        10.863399907934639,
        10.878385288580464,
        10.893370669226293,
        10.908356049872118,
        10.923341430517944,
        10.938326811163769,
        10.953312191809598,
        10.968297572455423,
        10.983282953101249,
        10.998268333747074,
        11.013253714392903,
        11.028239095038728,
        11.043224475684553,
        11.058209856330379,
        11.073195236976208,
        11.088180617622033,
        11.103165998267858,
        11.118151378913684,
        11.133136759559509,
        11.148122140205338,
        11.163107520851163,
        11.178092901496989,
        11.193078282142814,
        11.208063662788643,
        11.223049043434468,
        11.238034424080293,
        11.253019804726119,
        11.268005185371948,
        11.282990566017773,
        11.297975946663598,
        11.312961327309424,
        11.327946707955249,
        11.342932088601078,
        11.357917469246903,
        11.372902849892728,
        11.387888230538554,
        11.402873611184383,
        11.417858991830208,
        11.432844372476033,
        11.447829753121859,
        11.462815133767688,
        11.477800514413513,
        11.492785895059338,
        11.507771275705164,
        11.522756656350989,
        11.537742036996818,
        11.552727417642643,
        11.567712798288468,
        11.582698178934294,
        11.597683559580123,
        11.612668940225948,
        11.627654320871773,
        11.642639701517599,
        11.657625082163428,
        11.672610462809253,
        11.687595843455078,
        11.702581224100904,
        11.717566604746729,
        11.732551985392558,
        11.747537366038383,
        11.762522746684208,
        11.777508127330034,
        11.792493507975863,
        11.807478888621688,
        11.822464269267513,
        11.837449649913339,
        11.852435030559167,
        11.867420411204993,
        11.882405791850818,
        11.897391172496643,
        11.912376553142469,
        11.927361933788298,
        11.942347314434123,
        11.957332695079948,
        11.972318075725774,
        11.987303456371603,
        12.002288837017428,
        12.017274217663253,
        12.032259598309079,
        12.047244978954907,
        12.062230359600733,
        12.077215740246558,
        12.092201120892383,
        12.107186501538212,
        12.122171882184038,
        12.137157262829863,
        12.152142643475688,
        12.167128024121514,
        12.182113404767343,
        12.197098785413168,
        12.212084166058993,
        12.227069546704818,
        12.242054927350647,
        12.257040307996473,
        12.272025688642298,
        12.287011069288123,
        12.301996449933952,
        12.316981830579778,
        12.331967211225603,
        12.346952591871428,
        12.361937972517254,
        12.376923353163082,
        12.391908733808908,
        12.406894114454733,
        12.421879495100558,
        12.436864875746387,
        12.451850256392213,
        12.466835637038038,
        12.481821017683863,
        12.496806398329692,
        12.511791778975518,
        12.526777159621343,
        12.541762540267168,
        12.556747920912994,
        12.571733301558822,
        12.586718682204648,
        12.601704062850473,
        12.616689443496298,
        12.631674824142127,
        12.646660204787953,
        12.661645585433778,
        12.676630966079603,
        12.691616346725432,
        12.706601727371257,
        12.721587108017083,
        12.736572488662908,
        12.751557869308733,
        12.766543249954562,
        12.781528630600388,
        12.796514011246213,
        12.811499391892038,
        12.826484772537867,
        12.841470153183693,
        12.856455533829518,
        12.871440914475343,
        12.886426295121172,
        12.901411675766997,
        12.916397056412823,
        12.931382437058648,
        12.946367817704473,
        12.961353198350302,
        12.976338578996128,
        12.991323959641953,
        13.006309340287778,
        13.021294720933607,
        13.036280101579433,
        13.051265482225258,
        13.066250862871083,
        13.081236243516912,
        13.096221624162737,
        13.111207004808563,
        13.126192385454388,
        13.141177766100217,
        13.156163146746042,
        13.171148527391868,
        13.186133908037693,
        13.201119288683518,
        13.216104669329347,
        13.231090049975172,
        13.246075430620998,
        13.261060811266823,
        13.276046191912652,
        13.291031572558477,
        13.306016953204303,
        13.321002333850128,
        13.335987714495957,
        13.350973095141782,
        13.365958475787608,
        13.380943856433433,
        13.395929237079258,
        13.410914617725087,
        13.425899998370912,
        13.440885379016738,
        13.455870759662563,
        13.470856140308392,
        13.485841520954217,
        13.500826901600043,
        13.515812282245868,
        13.530797662891697,
        13.545783043537522,
        13.560768424183347,
        13.575753804829173,
        13.590739185474998,
        13.605724566120827,
        13.620709946766652,
        13.635695327412478,
        13.650680708058303,
        13.665666088704132,
        13.680651469349957,
        13.695636849995783,
        13.710622230641608,
        13.725607611287437,
        13.740592991933262,
        13.755578372579087,
        13.770563753224913,
        13.785549133870738,
        13.800534514516567,
        13.815519895162392,
        13.830505275808218,
        13.845490656454043,
        13.860476037099872,
        13.875461417745697,
        13.890446798391523,
        13.905432179037348,
        13.920417559683177,
        13.935402940329002,
        13.950388320974827,
        13.965373701620653,
        13.980359082266478,
        13.995344462912307,
        14.010329843558132,
        14.025315224203958,
        14.040300604849783,
        14.055285985495612,
        14.070271366141437,
        14.085256746787262,
        14.100242127433088,
        14.115227508078917,
        14.130212888724742,
        14.145198269370567,
        14.160183650016393,
        14.175169030662222,
        14.190154411308047,
        14.205139791953872,
        14.220125172599698,
        14.235110553245523,
        14.250095933891352,
        14.265081314537177,
        14.280066695183002,
        14.295052075828828,
        14.310037456474657,
        14.325022837120482,
        14.340008217766307,
        14.354993598412133,
        14.369978979057962,
        14.384964359703787,
        14.399949740349612,
        14.414935120995438,
        14.429920501641266,
        14.444905882287092,
        14.459891262932917,
        14.474876643578742,
        14.489862024224571,
        14.504847404870397,
        14.519832785516222,
        14.534818166162047,
        14.549803546807876,
        14.564788927453701,
        14.579774308099527,
        14.594759688745352,
        14.609745069391177,
        14.624730450037006,
        14.639715830682832,
        14.654701211328657,
        14.669686591974482,
        14.684671972620311,
        14.699657353266137,
        14.714642733911962,
        14.729628114557787,
        14.744613495203616,
        14.759598875849441,
        14.774584256495267,
        14.789569637141092,
        14.804555017786921,
        14.819540398432746,
        14.834525779078572,
        14.849511159724397,
        14.864496540370222,
        14.879481921016051,
        14.894467301661876,
        14.909452682307702,
        14.924438062953527,
        14.939423443599356,
        14.954408824245181,
        14.969394204891007,
        14.984379585536832,
        14.999364966182661,
        15.014350346828486,
        15.029335727474312,
        15.044321108120137,
        15.059306488765962,
        15.074291869411791,
        15.089277250057616,
        15.104262630703442,
        15.119248011349267,
        15.134233391995096,
        15.149218772640921,
        15.164204153286747,
        15.179189533932572,
        15.1941749145784,
        15.209160295224226,
        15.224145675870052,
        15.239131056515877,
        15.254116437161702,
        15.269101817807531,
        15.284087198453356,
        15.299072579099182,
        15.314057959745007,
        15.329043340390836,
        15.344028721036661,
        15.359014101682487,
        15.373999482328312,
        15.38898486297414,
        15.403970243619966,
        15.418955624265791,
        15.433941004911617,
        15.448926385557442,
        15.463911766203271,
        15.478897146849096,
        15.493882527494922,
        15.508867908140747,
        15.523853288786576,
        15.538838669432401,
        15.553824050078227,
        15.568809430724052,
        15.58379481136988,
        15.598780192015706,
        15.613765572661531,
        15.628750953307357,
        15.643736333953182,
        15.658721714599011,
        15.673707095244836,
        15.688692475890662,
        15.703677856536487,
        15.718663237182316,
        15.733648617828141,
        15.748633998473966,
        15.763619379119792,
        15.77860475976562,
        15.793590140411446,
        15.808575521057271,
        15.823560901703097,
        15.838546282348926,
        15.853531662994751,
        15.868517043640576,
        15.883502424286402,
        15.898487804932227,
        15.913473185578056,
        15.928458566223881,
        15.943443946869706,
        15.958429327515532,
        15.97341470816136,
        15.988400088807186,
        16.00338546945301,
        16.018370850098837,
        16.033356230744666,
        16.04834161139049,
        16.063326992036316,
        16.07831237268214,
        16.093297753327967,
        16.108283133973796,
        16.12326851461962,
        16.138253895265446,
        16.15323927591127,
        16.1682246565571,
        16.183210037202926,
        16.19819541784875,
        16.213180798494577,
        16.228166179140405,
        16.24315155978623,
        16.258136940432056,
        16.27312232107788,
        16.288107701723707,
        16.303093082369536,
        16.31807846301536,
        16.333063843661186,
        16.34804922430701,
        16.36303460495284,
        16.378019985598666,
        16.39300536624449,
        16.407990746890317,
        16.422976127536145,
        16.43796150818197,
        16.452946888827796,
        16.46793226947362,
        16.482917650119447,
        16.497903030765276,
        16.5128884114111,
        16.527873792056926,
        16.54285917270275,
        16.55784455334858,
        16.572829933994406,
        16.58781531464023,
        16.602800695286057,
        16.617786075931885,
        16.63277145657771,
        16.647756837223536,
        16.66274221786936,
        16.677727598515187,
        16.692712979161016,
        16.70769835980684,
        16.722683740452666,
        16.73766912109849,
        16.75265450174432,
        16.767639882390146,
        16.78262526303597,
        16.797610643681796,
        16.812596024327625,
        16.82758140497345,
        16.842566785619276,
        16.8575521662651,
        16.87253754691093,
        16.887522927556756,
        16.90250830820258,
        16.917493688848406,
        16.93247906949423,
        16.94746445014006,
        16.962449830785886,
        16.97743521143171,
        16.992420592077536,
        17.007405972723365,
        17.02239135336919,
        17.037376734015016,
        17.05236211466084,
        17.06734749530667,
        17.082332875952495,
        17.09731825659832,
        17.112303637244146,
        17.12728901788997,
        17.1422743985358,
        17.157259779181626,
        17.17224515982745,
        17.187230540473276,
        17.202215921119105,
        17.21720130176493,
        17.232186682410756,
        17.24717206305658,
        17.26215744370241,
        17.277142824348235,
        17.29212820499406,
        17.307113585639886,
        17.32209896628571,
        17.33708434693154,
        17.352069727577366,
        17.36705510822319,
        17.382040488869016,
        17.397025869514845,
        17.41201125016067,
        17.426996630806496,
        17.44198201145232,
        17.45696739209815,
        17.471952772743975,
        17.4869381533898,
        17.501923534035626,
        17.51690891468145,
        17.53189429532728,
        17.546879675973106,
        17.56186505661893,
        17.576850437264756,
        17.591835817910585,
        17.60682119855641,
        17.621806579202236,
        17.63679195984806,
        17.65177734049389,
        17.666762721139715,
        17.68174810178554,
        17.696733482431366,
        17.71171886307719,
        17.72670424372302,
        17.741689624368846,
        17.75667500501467,
        17.771660385660496,
        17.786645766306325,
        17.80163114695215,
        17.816616527597976,
        17.8316019082438,
        17.84658728888963,
        17.861572669535455,
        17.87655805018128,
        17.891543430827106,
        17.906528811472935,
        17.92151419211876,
        17.936499572764586,
        17.95148495341041,
        17.966470334056236,
        17.981455714702065,
        17.99644109534789,
        18.011426475993716,
        18.02641185663954,
        18.04139723728537,
        18.056382617931195,
        18.07136799857702,
        18.086353379222846,
        18.101338759868675,
        18.1163241405145,
        18.131309521160325,
        18.14629490180615,
        18.161280282451976,
        18.176265663097805,
        18.19125104374363,
        18.206236424389456,
        18.22122180503528,
        18.23620718568111,
        18.251192566326935,
        18.26617794697276,
        18.281163327618586,
        18.296148708264415,
        18.31113408891024,
        18.326119469556065,
        18.34110485020189,
        18.356090230847716,
        18.371075611493545,
        18.38606099213937,
        18.401046372785196,
        18.41603175343102,
        18.43101713407685,
        18.446002514722675,
        18.4609878953685,
        18.475973276014326,
        18.490958656660155,
        18.50594403730598,
        18.520929417951805,
        18.53591479859763,
        18.550900179243456,
        18.565885559889285,
        18.58087094053511,
        18.595856321180936,
        18.61084170182676,
        18.62582708247259,
        18.640812463118415,
        18.65579784376424,
        18.670783224410066,
        18.685768605055895,
        18.70075398570172,
        18.715739366347545,
        18.73072474699337,
        18.7457101276392,
        18.760695508285025,
        18.77568088893085,
        18.790666269576676,
        18.8056516502225,
        18.82063703086833,
        18.835622411514155,
        18.85060779215998,
        18.865593172805806,
        18.880578553451635,
        18.89556393409746,
        18.910549314743285,
        18.92553469538911,
        18.94052007603494,
        18.955505456680765,
        18.97049083732659,
        18.985476217972415,
        19.00046159861824,
        19.01544697926407,
        19.030432359909895,
        19.04541774055572,
        19.060403121201546,
        19.075388501847375,
        19.0903738824932,
        19.105359263139025,
        19.12034464378485,
        19.13533002443068,
        19.150315405076505,
        19.16530078572233,
        19.180286166368155,
        19.19527154701398,
        19.21025692765981,
        19.225242308305635,
        19.24022768895146,
        19.255213069597286,
        19.270198450243115,
        19.28518383088894,
        19.300169211534765,
        19.31515459218059,
        19.33013997282642,
        19.345125353472245,
        19.36011073411807,
        19.375096114763895,
        19.39008149540972,
        19.40506687605555,
        19.420052256701375,
        19.4350376373472,
        19.450023017993026,
        19.465008398638854,
        19.47999377928468,
        19.494979159930505,
        19.50996454057633,
        19.52494992122216,
        19.539935301867985,
        19.55492068251381,
        19.569906063159635,
        19.58489144380546,
        19.59987682445129,
        19.614862205097115,
        19.62984758574294,
        19.644832966388766,
        19.659818347034594,
        19.67480372768042,
        19.689789108326245,
        19.70477448897207,
        19.7197598696179,
        19.734745250263725,
        19.74973063090955,
        19.764716011555375,
        19.779701392201204,
        19.79468677284703,
        19.809672153492855,
        19.82465753413868,
        19.839642914784505,
        19.854628295430334,
        19.86961367607616,
        19.884599056721985,
        19.89958443736781,
        19.91456981801364,
        19.929555198659465,
        19.94454057930529,
        19.959525959951115,
        19.974511340596944,
        19.98949672124277,
        20.004482101888595,
        20.01946748253442,
        20.034452863180245,
        20.049438243826074,
        20.0644236244719,
        20.079409005117725,
        20.09439438576355,
        20.10937976640938,
        20.124365147055205,
        20.13935052770103,
        20.154335908346855,
        20.169321288992684,
        20.18430666963851,
        20.199292050284335,
        20.21427743093016,
        20.229262811575985,
        20.244248192221814,
        20.25923357286764,
        20.274218953513465,
        20.28920433415929,
        20.30418971480512,
        20.319175095450944,
        20.33416047609677,
        20.349145856742595,
        20.364131237388424,
        20.37911661803425,
        20.394101998680075,
        20.4090873793259,
        20.424072759971725,
        20.439058140617554,
        20.45404352126338,
        20.469028901909205,
        20.48401428255503,
        20.49899966320086,
        20.513985043846684,
        20.52897042449251,
        20.543955805138335,
        20.558941185784164,
        20.57392656642999,
        20.588911947075815,
        20.60389732772164,
        20.618882708367465,
        20.633868089013294,
        20.64885346965912,
        20.663838850304945,
        20.67882423095077,
        20.6938096115966,
        20.708794992242424,
        20.72378037288825,
        20.738765753534075,
        20.753751134179904,
        20.76873651482573,
        20.783721895471555,
        20.79870727611738,
        20.81369265676321,
        20.828678037409034,
        20.84366341805486,
        20.858648798700685,
        20.87363417934651,
        20.88861955999234,
        20.903604940638164,
        20.91859032128399,
        20.933575701929815,
        20.948561082575644,
        20.96354646322147,
        20.978531843867295,
        20.99351722451312,
        21.00850260515895,
        21.023487985804774,
        21.0384733664506,
        21.053458747096425,
        21.06844412774225,
        21.08342950838808,
        21.098414889033904,
        21.11340026967973,
        21.128385650325555,
        21.143371030971384,
        21.15835641161721,
        21.173341792263034,
        21.18832717290886,
        21.20331255355469,
        21.218297934200514,
        21.23328331484634,
        21.248268695492165,
        21.26325407613799,
        21.27823945678382,
        21.293224837429644,
        21.30821021807547,
        21.323195598721295,
        21.338180979367124,
        21.35316636001295,
        21.368151740658774,
        21.3831371213046,
        21.39812250195043,
        21.413107882596254,
        21.42809326324208,
        21.443078643887905,
        21.45806402453373,
        21.47304940517956,
        21.488034785825384,
        21.50302016647121,
        21.518005547117035,
        21.532990927762864,
        21.54797630840869,
        21.562961689054514,
        21.57794706970034,
        21.59293245034617,
        21.607917830991994,
        21.62290321163782,
        21.637888592283645,
        21.65287397292947,
        21.6678593535753,
        21.682844734221124,
        21.69783011486695,
        21.712815495512775,
        21.727800876158604,
        21.74278625680443,
        21.757771637450254,
        21.77275701809608,
        21.78774239874191,
        21.802727779387734,
        21.81771316003356,
        21.832698540679385,
        21.847683921325213,
        21.86266930197104,
        21.877654682616864,
        21.89264006326269,
        21.907625443908515,
        21.922610824554344,
        21.93759620520017,
        21.952581585845994,
        21.96756696649182,
        21.98255234713765,
        21.997537727783474,
        22.0125231084293,
        22.027508489075124,
        22.042493869720953,
        22.05747925036678,
        22.072464631012604,
        22.08745001165843,
        22.102435392304255,
        22.117420772950084,
        22.13240615359591,
        22.147391534241734,
        22.16237691488756,
        22.17736229553339,
        22.192347676179214,
        22.20733305682504,
        22.222318437470864,
        22.237303818116693,
        22.25228919876252,
        22.267274579408344,
        22.28225996005417,
        22.297245340699995,
        22.312230721345824,
        22.32721610199165,
        22.342201482637474,
        22.3571868632833,
        22.37217224392913,
        22.387157624574954,
        22.40214300522078,
        22.417128385866604,
        22.432113766512433,
        22.44709914715826,
        22.462084527804084,
        22.47706990844991,
        22.492055289095735,
        22.507040669741563,
        22.52202605038739,
        22.537011431033214,
        22.55199681167904,
        22.56698219232487,
        22.581967572970694,
        22.59695295361652,
        22.611938334262344,
        22.626923714908173,
        22.641909095554,
        22.656894476199824,
        22.67187985684565,
        22.686865237491478,
        22.701850618137303,
        22.71683599878313,
        22.731821379428954,
        22.74680676007478,
        22.76179214072061,
        22.776777521366434,
        22.79176290201226,
        22.806748282658084,
        22.821733663303913,
        22.83671904394974,
        22.851704424595564,
        22.86668980524139,
        22.881675185887218,
        22.896660566533043,
        22.91164594717887,
        22.926631327824694,
        22.94161670847052,
        22.95660208911635,
        22.971587469762174,
        22.986572850408,
        23.001558231053824,
        23.016543611699653,
        23.03152899234548,
        23.046514372991304,
        23.06149975363713,
        23.076485134282958,
        23.091470514928783,
        23.10645589557461,
        23.121441276220434,
        23.13642665686626,
        23.151412037512088,
        23.166397418157914,
        23.18138279880374,
        23.196368179449564,
        23.211353560095393,
        23.22633894074122,
        23.241324321387044,
        23.25630970203287,
        23.271295082678698,
        23.286280463324523,
        23.30126584397035,
        23.316251224616174,
        23.331236605262,
        23.346221985907828,
        23.361207366553653,
        23.37619274719948,
        23.391178127845304,
        23.406163508491133,
        23.42114888913696,
        23.436134269782784,
        23.45111965042861,
        23.466105031074438,
        23.481090411720263,
        23.49607579236609,
        23.511061173011914,
        23.52604655365774,
        23.541031934303568,
        23.556017314949393,
        23.57100269559522,
        23.585988076241044,
        23.600973456886873,
        23.6159588375327,
        23.630944218178524,
        23.64592959882435,
        23.660914979470178,
        23.675900360116003,
        23.69088574076183,
        23.705871121407654,
        23.720856502053483,
        23.735841882699308,
        23.750827263345133,
        23.76581264399096,
        23.780798024636784,
        23.795783405282613,
        23.81076878592844,
        23.825754166574264,
        23.84073954722009,
        23.855724927865918,
        23.870710308511743,
        23.88569568915757,
        23.900681069803394,
        23.915666450449223,
        23.930651831095048,
        23.945637211740873,
        23.9606225923867,
        23.975607973032524,
        23.990593353678353,
        24.005578734324178,
        24.020564114970004,
        24.03554949561583,
        24.050534876261658,
        24.065520256907483,
        24.08050563755331,
        24.095491018199134,
        24.110476398844963,
        24.125461779490788,
        24.140447160136613,
        24.15543254078244,
        24.170417921428264,
        24.185403302074093,
        24.200388682719918,
        24.215374063365743,
        24.23035944401157,
        24.245344824657398,
        24.260330205303223,
        24.27531558594905,
        24.290300966594874,
        24.305286347240703,
        24.320271727886528,
        24.335257108532353,
        24.35024248917818,
        24.365227869824004,
        24.380213250469833,
        24.395198631115658,
        24.410184011761483,
        24.42516939240731,
        24.440154773053138,
        24.455140153698963,
        24.47012553434479,
        24.485110914990614,
        24.500096295636443,
        24.515081676282268,
        24.530067056928093,
        24.54505243757392,
        24.560037818219744,
        24.575023198865573,
        24.590008579511398,
        24.604993960157223,
        24.61997934080305,
        24.634964721448878,
        24.649950102094703,
        24.66493548274053,
        24.679920863386354,
        24.694906244032182,
        24.709891624678008,
        24.724877005323833,
        24.73986238596966,
        24.754847766615487,
        24.769833147261313,
        24.784818527907138,
        24.799803908552963,
        24.81478928919879,
        24.829774669844618,
        24.844760050490443,
        24.859745431136268,
        24.874730811782094,
        24.889716192427922,
        24.904701573073748,
        24.919686953719573,
        24.9346723343654,
        24.949657715011227,
        24.964643095657053,
        24.979628476302878,
        24.994613856948703,
        25.00959923759453,
        25.024584618240358,
        25.039569998886183,
        25.054555379532008,
        25.069540760177834,
        25.084526140823662,
        25.099511521469488,
        25.114496902115313,
        25.12948228276114,
        25.144467663406967,
        25.159453044052793,
        25.174438424698618,
        25.189423805344443,
        25.20440918599027,
        25.219394566636097,
        25.234379947281923,
        25.249365327927748,
        25.264350708573573,
        25.279336089219402,
        25.294321469865228,
        25.309306850511053,
        25.32429223115688,
        25.339277611802707,
        25.354262992448533,
        25.369248373094358,
        25.384233753740183,
        25.39921913438601,
        25.414204515031837,
        25.429189895677663,
        25.444175276323488,
        25.459160656969313,
        25.474146037615142,
        25.489131418260968,
        25.504116798906793,
        25.51910217955262,
        25.534087560198447,
        25.549072940844272,
        25.564058321490098,
        25.579043702135923,
        25.59402908278175,
        25.609014463427577,
        25.623999844073403,
        25.638985224719228,
        25.653970605365053,
        25.668955986010882,
        25.683941366656708,
        25.698926747302533,
        25.71391212794836,
        25.728897508594187,
        25.743882889240012,
        25.758868269885838,
        25.773853650531663,
        25.788839031177492,
        25.803824411823317,
        25.818809792469143,
        25.833795173114968,
        25.848780553760793,
        25.863765934406622,
        25.878751315052448,
        25.893736695698273,
        25.908722076344098,
        25.923707456989927,
        25.938692837635752,
        25.953678218281578,
        25.968663598927403,
        25.983648979573232,
        25.998634360219057,
        26.013619740864883,
        26.028605121510708,
        26.043590502156533,
        26.058575882802362,
        26.073561263448187,
        26.088546644094013,
        26.103532024739838,
        26.118517405385667,
        26.133502786031492,
        26.148488166677318,
        26.163473547323143,
        26.178458927968972,
        26.193444308614797,
        26.208429689260623,
        26.223415069906448,
        26.238400450552273,
        26.253385831198102,
        26.268371211843927,
        26.283356592489753,
        26.298341973135578,
        26.313327353781407,
        26.328312734427232,
        26.343298115073058,
        26.358283495718883,
        26.373268876364712,
        26.388254257010537,
        26.403239637656363,
        26.418225018302188,
        26.433210398948013,
        26.448195779593842,
        26.463181160239667,
        26.478166540885493,
        26.493151921531318,
        26.508137302177147,
        26.523122682822972,
        26.538108063468798,
        26.553093444114623,
        26.568078824760452,
        26.583064205406277,
        26.598049586052102,
        26.613034966697928,
        26.628020347343753,
        26.643005727989582,
        26.657991108635407,
        26.672976489281233,
        26.687961869927058,
        26.702947250572887,
        26.717932631218712,
        26.732918011864538,
        26.747903392510363,
        26.76288877315619,
        26.777874153802017,
        26.792859534447842,
        26.807844915093668,
        26.822830295739497,
        26.837815676385322,
        26.852801057031147,
        26.867786437676973,
        26.882771818322798,
        26.897757198968627,
        26.912742579614452,
        26.927727960260277,
        26.942713340906103,
        26.95769872155193,
        26.972684102197757,
        26.987669482843582,
        27.002654863489408,
        27.017640244135237,
        27.032625624781062,
        27.047611005426887,
        27.062596386072713,
        27.077581766718538,
        27.092567147364367,
        27.107552528010192,
        27.122537908656017,
        27.137523289301843,
        27.15250866994767,
        27.167494050593497,
        27.182479431239322,
        27.197464811885148,
        27.212450192530977,
        27.227435573176802,
        27.242420953822627,
        27.257406334468453,
        27.272391715114278,
        27.287377095760107,
        27.302362476405932,
        27.317347857051757,
        27.332333237697583,
        27.34731861834341,
        27.362303998989237,
        27.377289379635062,
        27.392274760280888,
        27.407260140926716,
        27.422245521572542,
        27.437230902218367,
        27.452216282864192,
        27.467201663510018,
        27.482187044155847,
        27.497172424801672,
        27.512157805447497,
        27.527143186093323,
        27.54212856673915,
        27.557113947384977,
        27.572099328030802,
        27.587084708676628,
        27.602070089322456,
        27.61705546996828,
        27.632040850614107,
        27.647026231259932,
        27.66201161190576,
        27.676996992551587,
        27.691982373197412,
        27.706967753843237,
        27.721953134489063,
        27.73693851513489,
        27.751923895780717,
        27.766909276426542,
        27.781894657072367,
        27.796880037718196,
        27.81186541836402,
        27.826850799009847,
        27.841836179655672,
        27.8568215603015,
        27.871806940947327,
        27.886792321593152,
        27.901777702238977,
        27.916763082884803,
        27.93174846353063,
        27.946733844176457,
        27.961719224822282,
        27.976704605468107,
        27.991689986113936,
        28.00667536675976,
        28.021660747405587,
        28.036646128051412,
        28.05163150869724,
        28.066616889343067,
        28.081602269988892,
        28.096587650634717,
        28.111573031280543,
        28.12655841192637,
        28.141543792572197,
        28.156529173218022,
        28.171514553863847,
        28.186499934509676,
        28.2014853151555,
        28.216470695801327,
        28.231456076447152,
        28.24644145709298,
        28.261426837738806,
        28.276412218384632,
        28.291397599030457,
        28.306382979676282,
        28.32136836032211,
        28.336353740967937,
        28.351339121613762,
        28.366324502259587,
        28.381309882905416,
        28.39629526355124,
        28.411280644197067,
        28.426266024842892,
        28.44125140548872,
        28.456236786134546,
        28.47122216678037,
        28.486207547426197,
        28.501192928072022,
        28.51617830871785,
        28.531163689363677,
        28.546149070009502,
        28.561134450655327,
        28.576119831301156,
        28.59110521194698,
        28.606090592592807,
        28.621075973238632,
        28.63606135388446,
        28.651046734530286,
        28.66603211517611,
        28.681017495821937,
        28.696002876467766,
        28.71098825711359,
        28.725973637759417,
        28.740959018405242,
        28.755944399051067,
        28.770929779696896,
        28.78591516034272,
        28.800900540988547,
        28.815885921634372,
        28.8308713022802,
        28.845856682926026,
        28.86084206357185,
        28.875827444217677,
        28.890812824863506,
        28.90579820550933,
        28.920783586155157,
        28.935768966800982,
        28.950754347446807,
        28.965739728092636,
        28.98072510873846,
        28.995710489384287,
        29.010695870030112,
        29.02568125067594,
        29.040666631321766,
        29.05565201196759,
        29.070637392613417,
        29.085622773259246,
        29.10060815390507,
        29.115593534550896,
        29.130578915196722,
        29.145564295842547,
        29.160549676488376,
        29.1755350571342,
        29.190520437780027,
        29.205505818425852,
        29.22049119907168,
        29.235476579717506,
        29.25046196036333,
        29.265447341009157,
        29.280432721654986,
        29.29541810230081,
        29.310403482946636,
        29.32538886359246,
        29.340374244238287,
        29.355359624884116,
        29.37034500552994,
        29.385330386175767,
        29.400315766821592,
        29.41530114746742,
        29.430286528113246,
        29.44527190875907,
        29.460257289404897,
        29.475242670050726,
        29.49022805069655,
        29.505213431342376,
        29.5201988119882,
        29.535184192634027,
        29.550169573279856,
        29.56515495392568,
        29.580140334571507,
        29.595125715217332,
        29.61011109586316,
        29.625096476508986,
        29.64008185715481,
        29.655067237800637,
        29.670052618446466,
        29.68503799909229,
        29.700023379738116,
        29.71500876038394,
        29.72999414102977,
        29.744979521675596,
        29.75996490232142,
        29.774950282967247,
        29.789935663613072,
        29.8049210442589,
        29.819906424904726,
        29.83489180555055,
        29.849877186196377,
        29.864862566842206,
        29.87984794748803,
        29.894833328133856,
        29.90981870877968,
        29.92480408942551,
        29.939789470071336,
        29.95477485071716,
        29.969760231362987,
        29.984745612008812,
        29.99973099265464,
        30.014716373300466,
        30.02970175394629,
        30.044687134592117,
        30.059672515237946,
        30.07465789588377,
        30.089643276529596,
        30.10462865717542,
        30.11961403782125,
        30.134599418467076,
        30.1495847991129,
        30.164570179758726,
        30.179555560404552,
        30.19454094105038,
        30.209526321696206,
        30.22451170234203,
        30.239497082987857,
        30.254482463633686,
        30.26946784427951,
        30.284453224925336,
        30.29943860557116,
        30.31442398621699,
        30.329409366862816,
        30.34439474750864,
        30.359380128154466,
        30.37436550880029,
        30.38935088944612,
        30.404336270091946,
        30.41932165073777,
        30.4343070313836,
        30.449292412029425,
        30.46427779267525,
        30.479263173321076,
        30.4942485539669,
        30.509233934612727,
        30.524219315258552,
        30.539204695904385,
        30.55419007655021,
        30.569175457196035,
        30.58416083784186,
        30.599146218487686,
        30.61413159913351,
        30.629116979779337,
        30.644102360425162,
        30.659087741070987,
        30.67407312171682,
        30.689058502362645,
        30.70404388300847,
        30.719029263654296,
        30.73401464430012,
        30.749000024945946,
        30.76398540559177,
        30.778970786237597,
        30.793956166883422,
        30.808941547529255,
        30.82392692817508,
        30.838912308820905,
        30.85389768946673,
        30.868883070112556,
        30.88386845075838,
        30.898853831404207,
        30.913839212050032,
        30.928824592695864,
        30.94380997334169,
        30.958795353987515,
        30.97378073463334,
        30.988766115279166,
        31.00375149592499,
        31.018736876570816,
        31.033722257216642,
        31.048707637862467,
        31.0636930185083,
        31.078678399154125,
        31.09366377979995,
        31.108649160445776,
        31.1236345410916,
        31.138619921737426,
        31.15360530238325,
        31.168590683029077,
        31.18357606367491,
        31.198561444320735,
        31.21354682496656,
        31.228532205612385,
        31.24351758625821,
        31.258502966904036,
        31.27348834754986,
        31.288473728195687,
        31.303459108841512,
        31.318444489487344,
        31.33342987013317,
        31.348415250778995,
        31.36340063142482,
        31.378386012070646,
        31.39337139271647,
        31.408356773362296,
        31.42334215400812,
        31.438327534653947,
        31.45331291529978,
        31.468298295945605,
        31.48328367659143,
        31.498269057237255,
        31.51325443788308,
        31.528239818528906,
        31.54322519917473,
        31.558210579820557,
        31.57319596046639,
        31.588181341112215,
        31.60316672175804,
        31.618152102403865,
        31.63313748304969,
        31.648122863695516,
        31.66310824434134,
        31.678093624987167,
        31.693079005632992,
        31.708064386278824,
        31.72304976692465,
        31.738035147570475,
        31.7530205282163,
        31.768005908862126,
        31.78299128950795,
        31.797976670153776,
        31.8129620507996,
        31.827947431445427,
        31.84293281209126,
        31.857918192737085,
        31.87290357338291,
        31.887888954028735,
        31.90287433467456,
        31.917859715320386,
        31.93284509596621,
        31.947830476612037,
        31.96281585725787,
        31.977801237903694,
        31.99278661854952,
        32.00777199919534,
        32.02275737984117,
        32.03774276048699,
        32.05272814113282,
        32.06771352177864,
        32.08269890242447,
        32.0976842830703,
        32.112669663716126,
        32.12765504436195,
        32.14264042500778,
        32.1576258056536,
        32.17261118629943,
        32.18759656694525,
        32.20258194759108,
        32.21756732823691,
        32.232552708882736,
        32.24753808952856,
        32.262523470174386,
        32.27750885082021,
        32.29249423146604,
        32.30747961211186,
        32.32246499275769,
        32.33745037340351,
        32.352435754049345,
        32.36742113469517,
        32.382406515340996,
        32.39739189598682,
        32.41237727663265,
        32.42736265727847,
        32.4423480379243,
        32.45733341857012,
        32.47231879921595,
        32.48730417986178,
        32.502289560507606,
        32.51727494115343,
        32.53226032179926,
        32.54724570244508,
        32.56223108309091,
        32.57721646373673,
        32.59220184438256,
        32.60718722502839,
        32.622172605674216,
        32.63715798632004,
        32.652143366965866,
        32.66712874761169,
        32.68211412825752,
        32.69709950890334,
        32.71208488954917,
        32.72707027019499,
        32.742055650840825,
        32.75704103148665,
        32.772026412132476,
        32.7870117927783,
        32.80199717342413,
        32.81698255406995,
        32.83196793471578,
        32.8469533153616,
        32.86193869600743,
        32.87692407665326,
        32.891909457299086,
        32.90689483794491,
        32.921880218590736,
        32.93686559923656,
        32.95185097988239,
        32.96683636052821,
        32.98182174117404,
        32.99680712181987,
        33.011792502465696,
        33.02677788311152,
        33.041763263757346,
        33.05674864440317,
        33.071734025049,
        33.08671940569482,
        33.10170478634065,
        33.11669016698647,
        33.131675547632305,
        33.14666092827813,
        33.161646308923956,
        33.17663168956978,
        33.19161707021561,
        33.20660245086143,
        33.22158783150726,
        33.23657321215308,
        33.251558592798915,
        33.26654397344474,
        33.281529354090566,
        33.29651473473639,
        33.311500115382216,
        33.32648549602804,
        33.34147087667387,
        33.35645625731969,
        33.37144163796552,
        33.38642701861135,
        33.401412399257175,
        33.416397779903,
        33.431383160548826,
        33.44636854119465,
        33.46135392184048,
        33.4763393024863,
        33.49132468313213,
        33.50631006377795,
        33.521295444423785,
        33.53628082506961,
        33.551266205715436,
        33.56625158636126,
        33.58123696700709,
        33.59622234765291,
        33.61120772829874,
        33.62619310894456,
        33.641178489590395,
        33.65616387023622,
        33.671149250882046,
        33.68613463152787,
        33.701120012173696,
        33.71610539281952,
        33.73109077346535,
        33.74607615411117,
        33.761061534757,
        33.77604691540283,
        33.791032296048655,
        33.80601767669448,
        33.821003057340306,
        33.83598843798613,
        33.85097381863196,
        33.86595919927778,
        33.88094457992361,
        33.89592996056943,
        33.910915341215265,
        33.92590072186109,
        33.940886102506916,
        33.95587148315274,
        33.970856863798566,
        33.98584224444439,
        34.00082762509022,
        34.01581300573604,
        34.030798386381875,
        34.0457837670277,
        34.060769147673525,
        34.07575452831935,
        34.090739908965176,
        34.105725289611,
        34.12071067025683,
        34.13569605090265,
        34.15068143154848,
        34.16566681219431,
        34.180652192840135,
        34.19563757348596,
        34.210622954131786,
        34.22560833477761,
        34.24059371542344,
        34.25557909606926,
        34.27056447671509,
        34.28554985736092,
        34.300535238006745,
        34.31552061865257,
        34.330505999298396,
        34.34549137994422,
        34.360476760590046,
        34.37546214123587,
        34.3904475218817,
        34.40543290252752,
        34.420418283173355,
        34.43540366381918,
        34.450389044465005,
        34.46537442511083,
        34.480359805756656,
        34.49534518640248,
        34.51033056704831,
        34.52531594769413,
        34.54030132833996,
        34.55528670898579,
        34.570272089631615,
        34.58525747027744,
        34.600242850923266,
        34.61522823156909,
        34.63021361221492,
        34.64519899286074,
        34.66018437350657,
        34.6751697541524,
        34.690155134798225,
        34.70514051544405,
        34.720125896089876,
        34.7351112767357,
        34.750096657381526,
        34.76508203802735,
        34.78006741867318,
        34.795052799319,
        34.810038179964835,
        34.82502356061066,
        34.840008941256485,
        34.85499432190231,
        34.869979702548136,
        34.88496508319396,
        34.89995046383979,
        34.91493584448561,
        34.92992122513144,
        34.94490660577727,
        34.959891986423095,
        34.97487736706892,
        34.989862747714746,
        35.00484812836057,
        35.019833509006396,
        35.03481888965222,
        35.04980427029805,
        35.06478965094388,
        35.079775031589705,
        35.09476041223553,
        35.109745792881355,
        35.12473117352718,
        35.139716554173006,
        35.15470193481883,
        35.16968731546466,
        35.18467269611048,
        35.199658076756315,
        35.21464345740214,
        35.229628838047965,
        35.24461421869379,
        35.259599599339616,
        35.27458497998544,
        35.28957036063127,
        35.30455574127709,
        35.319541121922924,
        35.33452650256875,
        35.349511883214575,
        35.3644972638604,
        35.379482644506226,
        35.39446802515205,
        35.409453405797876,
        35.4244387864437,
        35.43942416708953,
        35.45440954773536,
        35.469394928381185,
        35.48438030902701,
        35.499365689672835,
        35.51435107031866,
        35.529336450964486,
        35.54432183161031,
        35.55930721225614,
        35.57429259290196,
        35.589277973547794,
        35.60426335419362,
        35.619248734839445,
        35.63423411548527,
        35.649219496131096,
        35.66420487677692,
        35.679190257422746,
        35.69417563806857,
        35.709161018714404,
        35.72414639936023,
        35.739131780006055,
        35.75411716065188,
        35.769102541297705,
        35.78408792194353,
        35.799073302589356,
        35.81405868323518,
        35.82904406388101,
        35.84402944452684,
        35.859014825172665,
        35.87400020581849,
        35.888985586464315,
        35.90397096711014,
        35.918956347755966,
        35.93394172840179,
        35.94892710904762,
        35.96391248969344,
        35.978897870339274,
        35.9938832509851,
        36.008868631630925,
        36.02385401227675,
        36.038839392922576,
        36.0538247735684,
        36.068810154214226,
        36.08379553486005,
        36.098780915505884,
        36.11376629615171,
        36.128751676797535,
        36.14373705744336,
        36.158722438089185,
        36.17370781873501,
        36.188693199380836,
        36.20367858002666,
        36.21866396067249,
        36.23364934131832,
        36.248634721964144,
        36.26362010260997,
        36.278605483255795,
        36.29359086390162,
        36.308576244547446,
        36.32356162519327,
        36.3385470058391,
        36.35353238648493,
        36.368517767130754,
        36.38350314777658,
        36.398488528422405,
        36.41347390906823,
        36.428459289714056,
        36.44344467035988,
        36.458430051005706,
        36.47341543165153,
        36.488400812297364,
        36.50338619294319,
        36.518371573589015,
        36.53335695423484,
        36.548342334880665,
        36.56332771552649,
        36.578313096172316,
        36.59329847681814,
        36.60828385746397,
        36.6232692381098,
        36.638254618755624,
        36.65323999940145,
        36.668225380047275,
        36.6832107606931,
        36.698196141338926,
        36.71318152198475,
        36.728166902630576,
        36.74315228327641,
        36.758137663922234,
        36.77312304456806,
        36.788108425213885,
        36.80309380585971,
        36.818079186505535,
        36.83306456715136,
        36.848049947797186,
        36.86303532844301,
        36.878020709088844,
        36.89300608973467,
        36.907991470380495,
        36.92297685102632,
        36.937962231672145,
        36.95294761231797,
        36.967932992963796,
        36.98291837360962,
        36.99790375425545,
        37.01288913490128,
        37.027874515547104,
        37.04285989619293,
        37.057845276838755,
        37.07283065748458,
        37.087816038130406,
        37.10280141877623,
        37.117786799422056,
        37.13277218006789,
        37.147757560713714,
        37.16274294135954,
        37.177728322005365,
        37.19271370265119,
        37.207699083297015,
        37.22268446394284,
        37.237669844588666,
        37.25265522523449,
        37.267640605880324,
        37.28262598652615,
        37.297611367171974,
        37.3125967478178,
        37.327582128463625,
        37.34256750910945,
        37.357552889755276,
        37.3725382704011,
        37.38752365104693,
        37.40250903169276,
        37.417494412338584,
        37.43247979298441,
        37.447465173630235,
        37.46245055427606,
        37.477435934921886,
        37.49242131556771,
        37.507406696213536,
        37.52239207685937,
        37.537377457505194,
        37.55236283815102,
        37.567348218796845,
        37.58233359944267,
        37.597318980088495,
        37.61230436073432,
        37.627289741380146,
        37.64227512202597,
        37.657260502671804,
        37.67224588331763,
        37.687231263963454,
        37.70221664460928,
        37.717202025255105,
        37.73218740590093,
        37.747172786546756,
        37.76215816719258,
        37.77714354783841,
        37.79212892848424,
        37.807114309130064,
        37.82209968977589,
        37.837085070421715,
        37.85207045106754,
        37.867055831713365,
        37.88204121235919,
        37.897026593005016,
        37.91201197365085,
        37.926997354296674,
        37.9419827349425,
        37.956968115588325,
        37.97195349623415,
        37.986938876879975,
        38.0019242575258,
        38.016909638171626,
        38.03189501881746,
        38.046880399463284,
        38.06186578010911,
        38.076851160754934,
        38.09183654140076,
        38.106821922046585,
        38.12180730269241,
        38.136792683338236,
        38.15177806398406,
        38.16676344462989,
        38.18174882527572,
        38.196734205921544,
        38.21171958656737,
        38.226704967213195,
        38.24169034785902,
        38.256675728504845,
        38.27166110915067,
        38.286646489796496,
        38.30163187044233,
        38.316617251088154,
        38.33160263173398,
        38.346588012379804,
        38.36157339302563,
        38.376558773671455,
        38.39154415431728,
        38.406529534963106,
        38.42151491560894,
        38.43650029625476,
        38.45148567690059,
        38.466471057546414,
        38.48145643819224,
        38.496441818838065,
        38.51142719948389,
        38.526412580129715,
        38.54139796077554,
        38.55638334142137,
        38.5713687220672,
        38.586354102713024,
        38.60133948335885,
        38.616324864004675,
        38.6313102446505,
        38.646295625296325,
        38.66128100594215,
        38.676266386587976,
        38.69125176723381,
        38.706237147879634,
        38.72122252852546,
        38.736207909171284,
        38.75119328981711,
        38.766178670462935,
        38.78116405110876,
        38.796149431754586,
        38.81113481240042,
        38.82612019304624,
        38.84110557369207,
        38.856090954337894,
        38.87107633498372,
        38.886061715629545,
        38.90104709627537,
        38.916032476921195,
        38.93101785756702,
        38.94600323821285,
        38.96098861885868,
        38.975973999504504,
        38.99095938015033,
        39.005944760796154,
        39.02093014144198,
        39.035915522087805,
        39.05090090273363,
        39.06588628337946,
        39.08087166402529,
        39.095857044671114,
        39.11084242531694,
        39.125827805962764,
        39.14081318660859,
        39.155798567254415,
        39.17078394790024,
        39.185769328546066,
        39.2007547091919,
        39.21574008983772,
        39.23072547048355,
        39.245710851129374,
        39.2606962317752,
        39.275681612421025,
        39.29066699306685,
        39.305652373712675,
        39.3206377543585,
        39.33562313500433,
        39.35060851565016,
        39.365593896295984,
        39.38057927694181,
        39.395564657587634,
        39.41055003823346,
        39.425535418879285,
        39.44052079952511,
        39.45550618017094,
        39.47049156081677,
        39.48547694146259,
        39.50046232210842,
        39.515447702754244,
        39.53043308340007,
        39.545418464045895,
        39.56040384469172,
        39.575389225337545,
        39.59037460598338,
        39.6053599866292,
        39.62034536727503,
        39.635330747920854,
        39.65031612856668,
        39.665301509212505,
        39.68028688985833,
        39.695272270504155,
        39.71025765114998,
        39.72524303179581,
        39.74022841244164,
        39.755213793087464,
        39.77019917373329,
        39.785184554379114,
        39.80016993502494,
        39.815155315670765,
        39.83014069631659,
        39.84512607696242,
        39.86011145760825,
        39.87509683825407,
        39.8900822188999,
        39.905067599545724,
        39.92005298019155,
        39.935038360837375,
        39.9500237414832,
        39.965009122129025,
        39.97999450277486,
        39.99497988342068,
        40.00996526406651,
        40.024950644712334,
        40.03993602535816,
        40.054921406003984,
        40.06990678664981,
        40.084892167295635,
        40.09987754794147,
        40.11486292858729,
        40.12984830923312,
        40.14483368987894,
        40.15981907052477,
        40.174804451170594,
        40.18978983181642,
        40.204775212462245,
        40.21976059310807,
        40.2347459737539,
        40.24973135439973,
        40.26471673504555,
        40.27970211569138,
        40.294687496337204,
        40.30967287698303,
        40.324658257628855,
        40.33964363827468,
        40.354629018920505,
        40.36961439956634,
        40.38459978021216,
        40.39958516085799,
        40.414570541503814,
        40.42955592214964,
        40.444541302795464,
        40.45952668344129,
        40.474512064087115,
        40.48949744473295,
        40.50448282537877,
        40.5194682060246,
        40.53445358667042,
        40.54943896731625,
        40.564424347962074,
        40.5794097286079,
        40.594395109253725,
        40.60938048989955,
        40.62436587054538,
        40.63935125119121,
        40.65433663183703,
        40.66932201248286,
        40.684307393128684,
        40.69929277377451,
        40.714278154420334,
        40.72926353506616,
        40.744248915711985,
        40.75923429635782,
        40.77421967700364,
        40.78920505764947,
        40.804190438295294,
        40.81917581894112,
        40.834161199586944,
        40.84914658023277,
        40.864131960878595,
        40.87911734152443,
        40.89410272217025,
        40.90908810281608,
        40.9240734834619,
        40.93905886410773,
        40.954044244753554,
        40.96902962539938,
        40.984015006045205,
        40.99900038669103,
        41.01398576733686,
        41.02897114798269,
        41.04395652862851,
        41.05894190927434,
        41.073927289920164,
        41.08891267056599,
        41.103898051211814,
        41.11888343185764,
        41.13386881250347,
        41.1488541931493,
        41.16383957379512,
        41.17882495444095,
        41.19381033508677,
        41.2087957157326,
        41.223781096378424,
        41.23876647702425,
        41.253751857670075,
        41.26873723831591,
        41.28372261896173,
        41.29870799960756,
        41.31369338025338,
        41.32867876089921,
        41.343664141545034,
        41.35864952219086,
        41.373634902836685,
        41.38862028348251,
        41.40360566412834,
        41.41859104477417,
        41.43357642541999,
        41.44856180606582,
        41.463547186711644,
        41.47853256735747,
        41.493517948003294,
        41.50850332864912,
        41.52348870929495,
        41.53847408994078,
        41.5534594705866,
        41.56844485123243,
        41.58343023187825,
        41.59841561252408,
        41.613400993169904,
        41.62838637381573,
        41.643371754461555,
        41.65835713510739,
        41.67334251575321,
        41.68832789639904,
        41.70331327704486,
        41.71829865769069,
        41.733284038336514,
        41.74826941898234,
        41.763254799628164,
        41.77824018027399,
        41.79322556091982,
        41.80821094156565,
        41.82319632221147,
        41.8381817028573,
        41.85316708350312,
        41.86815246414895,
        41.883137844794774,
        41.8981232254406,
        41.91310860608643,
        41.92809398673226,
        41.94307936737808,
        41.95806474802391,
        41.97305012866973,
        41.98803550931556,
        42.003020889961384,
        42.01800627060721,
        42.032991651253035,
        42.04797703189887,
        42.06296241254469,
        42.07794779319052,
        42.09293317383634,
        42.10791855448217,
        42.122903935127994,
        42.13788931577382,
        42.152874696419644,
        42.16786007706548,
        42.1828454577113,
        42.19783083835713,
        42.21281621900295,
        42.22780159964878,
        42.2427869802946,
        42.25777236094043,
        42.272757741586254,
        42.28774312223208,
        42.30272850287791,
        42.31771388352374,
        42.33269926416956,
        42.34768464481539,
        42.36267002546121,
        42.37765540610704,
        42.392640786752864,
        42.40762616739869,
        42.422611548044515,
        42.43759692869035,
        42.45258230933617,
        42.467567689982,
        42.48255307062782,
        42.49753845127365,
        42.512523831919474,
        42.5275092125653,
        42.542494593211124,
        42.55747997385696,
        42.57246535450278,
        42.58745073514861,
        42.60243611579443,
        42.61742149644026,
        42.63240687708608,
        42.64739225773191,
        42.662377638377734,
        42.67736301902356,
        42.69234839966939,
        42.70733378031522,
        42.72231916096104,
        42.73730454160687,
        42.75228992225269,
        42.76727530289852,
        42.782260683544344,
        42.79724606419017,
        42.812231444835994,
        42.82721682548183,
        42.84220220612765,
        42.85718758677348,
        42.8721729674193,
        42.88715834806513,
        42.90214372871095,
        42.91712910935678,
        42.932114490002604,
        42.94709987064844,
        42.96208525129426,
        42.97707063194009,
        42.99205601258591,
        43.00704139323174,
        43.02202677387756,
        43.03701215452339,
        43.051997535169214,
        43.06698291581504,
        43.08196829646087,
        43.0969536771067,
        43.11193905775252,
        43.12692443839835,
        43.14190981904417,
        43.15689519969,
        43.171880580335824,
        43.18686596098165,
        43.20185134162748,
        43.21683672227331,
        43.23182210291913,
        43.24680748356496,
        43.26179286421078,
        43.27677824485661,
        43.29176362550243,
        43.30674900614826,
        43.321734386794084,
        43.33671976743992,
        43.35170514808574,
        43.36669052873157,
        43.38167590937739,
        43.39666129002322,
        43.41164667066904,
        43.42663205131487,
        43.441617431960694,
        43.45660281260652,
        43.47158819325235,
        43.48657357389818,
        43.501558954544,
        43.51654433518983,
        43.53152971583565,
        43.54651509648148,
        43.561500477127304,
        43.57648585777313,
        43.59147123841896,
        43.60645661906479,
        43.62144199971061,
        43.63642738035644,
        43.65141276100226,
        43.66639814164809,
        43.68138352229391,
        43.69636890293974,
        43.711354283585564,
        43.726339664231396,
        43.74132504487722,
        43.75631042552305,
        43.77129580616887,
        43.7862811868147,
        43.80126656746052,
        43.81625194810635,
        43.831237328752174,
        43.846222709398,
        43.86120809004383,
        43.87619347068966,
        43.89117885133548,
        43.90616423198131,
        43.92114961262713,
        43.93613499327296,
        43.95112037391878,
        43.96610575456461,
        43.98109113521044,
        43.99607651585627,
        44.01106189650209,
        44.02604727714792,
        44.04103265779374,
        44.05601803843957,
        44.07100341908539,
        44.08598879973122,
        44.100974180377044,
        44.115959561022876,
        44.1309449416687,
        44.14593032231453,
        44.16091570296035,
        44.17590108360618,
        44.190886464252,
        44.20587184489783,
        44.220857225543654,
        44.235842606189486,
        44.25082798683531,
        44.26581336748114,
        44.28079874812696,
        44.29578412877279,
        44.31076950941861,
        44.32575489006444,
        44.34074027071026,
        44.35572565135609,
        44.37071103200192,
        44.38569641264775,
        44.40068179329357,
        44.4156671739394,
        44.43065255458522,
        44.44563793523105,
        44.46062331587687,
        44.4756086965227,
        44.490594077168524,
        44.505579457814356,
        44.52056483846018,
        44.53555021910601,
        44.55053559975183,
        44.56552098039766,
        44.58050636104348,
        44.59549174168931,
        44.61047712233513,
        44.625462502980966,
        44.64044788362679,
        44.65543326427262,
        44.67041864491844,
        44.68540402556427,
        44.70038940621009,
        44.71537478685592,
        44.73036016750174,
        44.74534554814757,
        44.7603309287934,
        44.775316309439226,
        44.79030169008505,
        44.80528707073088,
        44.8202724513767,
        44.83525783202253,
        44.85024321266835,
        44.86522859331418,
        44.880213973960004,
        44.895199354605836,
        44.91018473525166,
        44.92517011589749,
        44.94015549654331,
        44.95514087718914,
        44.97012625783496,
        44.98511163848079,
        45.00009701912661,
        45.015082399772446,
        45.03006778041827,
        45.0450531610641,
        45.06003854170992,
        45.07502392235575,
        45.09000930300157,
        45.1049946836474,
        45.11998006429322,
        45.13496544493905,
        45.14995082558488,
        45.164936206230706,
        45.17992158687653,
        45.19490696752236,
        45.20989234816818,
        45.22487772881401,
        45.23986310945983,
        45.25484849010566,
        45.26983387075149,
        45.284819251397316,
        45.29980463204314,
        45.31479001268897,
        45.32977539333479,
        45.34476077398062,
        45.35974615462644,
        45.37473153527227,
        45.38971691591809,
        45.404702296563926,
        45.41968767720975,
        45.434673057855576,
        45.4496584385014,
        45.46464381914723,
        45.47962919979305,
        45.49461458043888,
        45.5095999610847,
        45.52458534173053,
        45.53957072237636,
        45.554556103022186,
        45.56954148366801,
        45.58452686431384,
        45.59951224495966,
        45.61449762560549,
        45.62948300625131,
        45.64446838689714,
        45.65945376754297,
        45.674439148188796,
        45.68942452883462,
        45.70440990948045,
        45.71939529012627,
        45.7343806707721,
        45.74936605141792,
        45.76435143206375,
        45.77933681270957,
        45.794322193355406,
        45.80930757400123,
        45.824292954647056,
        45.83927833529288,
        45.85426371593871,
        45.86924909658453,
        45.88423447723036,
        45.89921985787618,
        45.91420523852201,
        45.92919061916784,
        45.944175999813666,
        45.95916138045949,
        45.97414676110532,
        45.98913214175114,
        46.00411752239697,
        46.01910290304279,
        46.03408828368862,
        46.04907366433445,
        46.064059044980276,
        46.0790444256261,
        46.09402980627193,
        46.10901518691775,
        46.12400056756358,
        46.1389859482094,
        46.15397132885523,
        46.16895670950105,
        46.183942090146886,
        46.19892747079271,
        46.213912851438536,
        46.22889823208436,
        46.24388361273019,
        46.25886899337601,
        46.27385437402184,
        46.28883975466766,
        46.303825135313495,
        46.31881051595932,
        46.333795896605146,
        46.34878127725097,
        46.3637666578968,
        46.37875203854262,
        46.39373741918845,
        46.40872279983427,
        46.4237081804801,
        46.43869356112593,
        46.453678941771756,
        46.46866432241758,
        46.483649703063406,
        46.49863508370923,
        46.51362046435506,
        46.52860584500088,
        46.54359122564671,
        46.55857660629253,
        46.573561986938365,
        46.58854736758419,
        46.603532748230016,
        46.61851812887584,
        46.63350350952167,
        46.64848889016749,
        46.66347427081332,
        46.67845965145914,
        46.693445032104975,
        46.7084304127508,
        46.723415793396626,
        46.73840117404245,
        46.75338655468828,
        46.7683719353341,
        46.78335731597993,
        46.79834269662575,
        46.81332807727158,
        46.82831345791741,
        46.843298838563236,
        46.85828421920906,
        46.873269599854886,
        46.88825498050071,
        46.90324036114654,
        46.91822574179236,
        46.93321112243819,
        46.94819650308402,
        46.963181883729845,
        46.97816726437567,
        46.993152645021496,
        47.00813802566732,
        47.02312340631315,
        47.03810878695897,
        47.0530941676048,
        47.06807954825062,
        47.083064928896455,
        47.09805030954228,
        47.113035690188106,
        47.12802107083393,
        47.143006451479756,
        47.15799183212558,
        47.17297721277141,
        47.18796259341723,
        47.20294797406306,
        47.21793335470889,
        47.232918735354716,
        47.24790411600054,
        47.262889496646366,
        47.27787487729219,
        47.29286025793802,
        47.30784563858384,
        47.32283101922967,
        47.3378163998755,
        47.352801780521325,
        47.36778716116715,
        47.382772541812976,
        47.3977579224588,
        47.41274330310463,
        47.42772868375045,
        47.44271406439628,
        47.4576994450421,
        47.472684825687935,
        47.48767020633376,
        47.502655586979586,
        47.51764096762541,
        47.532626348271236,
        47.54761172891706,
        47.56259710956289,
        47.57758249020871,
        47.59256787085454,
        47.60755325150037,
        47.622538632146195,
        47.63752401279202,
        47.652509393437846,
        47.66749477408367,
        47.6824801547295,
        47.69746553537532,
        47.71245091602115,
        47.72743629666698,
        47.742421677312805,
        47.75740705795863,
        47.772392438604456,
        47.78737781925028,
        47.80236319989611,
        47.81734858054193,
        47.83233396118776,
        47.84731934183358,
        47.862304722479415,
        47.87729010312524,
        47.892275483771066,
        47.90726086441689,
        47.922246245062716,
        47.93723162570854,
        47.95221700635437,
        47.96720238700019,
        47.982187767646025,
        47.99717314829185,
        48.012158528937675,
        48.0271439095835,
        48.042129290229326,
        48.05711467087515,
        48.07210005152098,
        48.0870854321668,
        48.10207081281263,
        48.11705619345846,
        48.132041574104285,
        48.14702695475011,
        48.162012335395936,
        48.17699771604176,
        48.191983096687586,
        48.20696847733341,
        48.22195385797924,
        48.23693923862506,
        48.251924619270895,
        48.26690999991672,
        48.281895380562545,
        48.29688076120837,
        48.311866141854196,
        48.32685152250002,
        48.34183690314585,
        48.35682228379167,
        48.371807664437505,
        48.38679304508333,
        48.401778425729155,
        48.41676380637498,
        48.431749187020806,
        48.44673456766663,
        48.46171994831246,
        48.47670532895828,
        48.49169070960411,
        48.50667609024994,
        48.521661470895765,
        48.53664685154159,
        48.551632232187416,
        48.56661761283324,
        48.581602993479066,
        48.59658837412489,
        48.61157375477072,
        48.62655913541654,
        48.641544516062375,
        48.6565298967082,
        48.671515277354025,
        48.68650065799985,
        48.701486038645676,
        48.7164714192915,
        48.73145679993733,
        48.74644218058315,
        48.761427561228984,
        48.77641294187481,
        48.791398322520635,
        48.80638370316646,
        48.821369083812286,
        48.83635446445811,
        48.85133984510394,
        48.86632522574976,
        48.88131060639559,
        48.89629598704142,
        48.911281367687245,
        48.92626674833307,
        48.941252128978896,
        48.95623750962472,
        48.971222890270546,
        48.98620827091637,
        49.0011936515622,
        49.01617903220803,
        49.031164412853855,
        49.04614979349968,
        49.061135174145505,
        49.07612055479133,
        49.091105935437156,
        49.10609131608298,
        49.12107669672881,
        49.13606207737463,
        49.151047458020464,
        49.16603283866629,
        49.181018219312115,
        49.19600359995794,
        49.210988980603766,
        49.22597436124959,
        49.240959741895416,
        49.25594512254124,
        49.27093050318707,
        49.2859158838329,
        49.300901264478725,
        49.31588664512455,
        49.330872025770375,
        49.3458574064162,
        49.360842787062026,
        49.37582816770785,
        49.39081354835368,
        49.40579892899951,
        49.420784309645335,
        49.43576969029116,
        49.450755070936985,
        49.46574045158281,
        49.480725832228636,
        49.49571121287446,
        49.51069659352029,
        49.52568197416611,
        49.540667354811944,
        49.55565273545777,
        49.570638116103595,
        49.58562349674942,
        49.600608877395246,
        49.61559425804107,
        49.630579638686896,
        49.64556501933272,
        49.66055039997855,
        49.67553578062438,
        49.690521161270205,
        49.70550654191603,
        49.720491922561855,
        49.73547730320768,
        49.750462683853506,
        49.76544806449933,
        49.78043344514516,
        49.79541882579099,
        49.810404206436814,
        49.82538958708264,
        49.840374967728465,
        49.85536034837429,
        49.870345729020116,
        49.88533110966594,
        49.900316490311766,
        49.91530187095759,
        49.930287251603424,
        49.94527263224925,
        49.960258012895075,
        49.9752433935409,
        49.990228774186726,
        50.00521415483255,
        50.020199535478376,
        50.0351849161242,
        50.050170296770034,
        50.06515567741586,
        50.080141058061685,
        50.09512643870751,
        50.110111819353335,
        50.12509719999916,
        50.140082580644986,
        50.15506796129081,
        50.17005334193664,
        50.18503872258247,
        50.200024103228294,
        50.21500948387412,
        50.229994864519945,
        50.24498024516577,
        50.259965625811596,
        50.27495100645742,
        50.289936387103246,
        50.30492176774907,
        50.319907148394904,
        50.33489252904073,
        50.349877909686555,
        50.36486329033238,
        50.379848670978205,
        50.39483405162403,
        50.409819432269856,
        50.42480481291568,
        50.439790193561514,
        50.45477557420734,
        50.469760954853164,
        50.48474633549899,
        50.499731716144815,
        50.51471709679064,
        50.529702477436466,
        50.54468785808229,
        50.55967323872812,
        50.57465861937395,
        50.589644000019774,
        50.6046293806656,
        50.619614761311425,
        50.63460014195725,
        50.649585522603076,
        50.6645709032489,
        50.679556283894726,
        50.69454166454055,
        50.709527045186384,
        50.72451242583221,
        50.739497806478035,
        50.75448318712386,
        50.769468567769685,
        50.78445394841551,
        50.799439329061336,
        50.81442470970716,
        50.829410090352994,
        50.84439547099882,
        50.859380851644644,
        50.87436623229047,
        50.889351612936295,
        50.90433699358212,
        50.919322374227946,
        50.93430775487377,
        50.949293135519596,
        50.96427851616543,
        50.979263896811254,
        50.99424927745708,
        51.009234658102905,
        51.02422003874873,
        51.039205419394555,
        51.05419080004038,
        51.069176180686206,
        51.08416156133204,
        51.099146941977864,
        51.11413232262369,
        51.129117703269515,
        51.14410308391534,
        51.159088464561165,
        51.17407384520699,
        51.189059225852816,
        51.20404460649864,
        51.219029987144474,
        51.2340153677903,
        51.249000748436124,
        51.26398612908195,
        51.278971509727775,
        51.2939568903736,
        51.308942271019426,
        51.32392765166525,
        51.338913032311076,
        51.35389841295691,
        51.368883793602734,
        51.38386917424856,
        51.398854554894385,
        51.41383993554021,
        51.428825316186035,
        51.44381069683186,
        51.458796077477686,
        51.47378145812352,
        51.488766838769344,
        51.50375221941517,
        51.518737600060994,
        51.53372298070682,
        51.548708361352645,
        51.56369374199847,
        51.578679122644296,
        51.59366450329012,
        51.60864988393595,
        51.62363526458178,
        51.638620645227604,
        51.65360602587343,
        51.668591406519255,
        51.68357678716508,
        51.698562167810906,
        51.71354754845673,
        51.728532929102556,
        51.74351830974839,
        51.758503690394214,
        51.77348907104004,
        51.788474451685865,
        51.80345983233169,
        51.818445212977515,
        51.83343059362334,
        51.848415974269166,
        51.863401354915,
        51.878386735560824,
        51.89337211620665,
        51.908357496852474,
        51.9233428774983,
        51.938328258144125,
        51.95331363878995,
        51.968299019435776,
        51.9832844000816,
        51.99826978072743,
        52.01325516137326,
        52.028240542019084,
        52.04322592266491,
        52.058211303310735,
        52.07319668395656,
        52.088182064602385,
        52.10316744524821,
        52.11815282589404,
        52.13313820653987,
        52.148123587185694,
        52.16310896783152,
        52.178094348477345,
        52.19307972912317,
        52.208065109768995,
        52.22305049041482,
        52.238035871060646,
        52.25302125170648,
        52.268006632352304,
        52.28299201299813,
        52.297977393643954,
        52.31296277428978,
        52.327948154935605,
        52.34293353558143,
        52.357918916227256,
        52.37290429687308,
        52.38788967751891,
        52.40287505816474,
        52.417860438810564,
        52.43284581945639,
        52.447831200102215,
        52.46281658074804,
        52.477801961393865,
        52.49278734203969,
        52.50777272268552,
        52.52275810333135,
        52.537743483977174,
        52.552728864623,
        52.567714245268824,
        52.58269962591465,
        52.597685006560475,
        52.6126703872063,
        52.627655767852126,
        52.64264114849796,
        52.65762652914378,
        52.67261190978961,
        52.687597290435434,
        52.70258267108126,
        52.717568051727085,
        52.73255343237291,
        52.747538813018735,
        52.76252419366456,
        52.77750957431039,
        52.79249495495622,
        52.807480335602044,
        52.82246571624787,
        52.837451096893695,
        52.85243647753952,
        52.867421858185345,
        52.88240723883117,
        52.897392619477,
        52.91237800012283,
        52.927363380768654,
        52.94234876141448,
        52.957334142060304,
        52.97231952270613,
        52.987304903351955,
        53.00229028399778,
        53.017275664643606,
        53.03226104528944,
        53.04724642593526,
        53.06223180658109,
        53.077217187226914,
        53.09220256787274,
        53.107187948518565,
        53.12217332916439,
        53.137158709810215,
        53.15214409045605,
        53.16712947110187,
        53.1821148517477,
        53.197100232393524,
        53.21208561303935,
        53.227070993685174,
        53.242056374331,
        53.257041754976825,
        53.27202713562265,
        53.28701251626848,
        53.30199789691431,
        53.316983277560134,
        53.33196865820596,
        53.346954038851784,
        53.36193941949761,
        53.376924800143435,
        53.39191018078926,
        53.406895561435086,
        53.42188094208092,
        53.43686632272674,
        53.45185170337257,
        53.466837084018394,
        53.48182246466422,
        53.496807845310045,
        53.51179322595587,
        53.526778606601695,
        53.54176398724753,
        53.55674936789335,
        53.57173474853918,
        53.586720129185004,
        53.60170550983083,
        53.616690890476654,
        53.63167627112248,
        53.646661651768305,
        53.66164703241413,
        53.67663241305996,
        53.69161779370579,
        53.70660317435161,
        53.72158855499744,
        53.736573935643264,
        53.75155931628909,
        53.766544696934915,
        53.78153007758074,
        53.796515458226565,
        53.8115008388724,
        53.82648621951822,
        53.84147160016405,
        53.856456980809874,
        53.8714423614557,
        53.886427742101525,
        53.90141312274735,
        53.916398503393175,
        53.93138388403901,
        53.94636926468483,
        53.96135464533066,
        53.976340025976484,
        53.99132540662231,
        54.006310787268134,
        54.02129616791396,
        54.036281548559785,
        54.05126692920561,
        54.06625230985144,
        54.08123769049727,
        54.09622307114309,
        54.11120845178892,
        54.126193832434744,
        54.14117921308057,
        54.156164593726395,
        54.17114997437222,
        54.18613535501805,
        54.20112073566388,
        54.2161061163097,
        54.23109149695553,
        54.246076877601354,
        54.26106225824718,
        54.276047638893004,
        54.29103301953883,
        54.306018400184655,
        54.32100378083049,
        54.33598916147631,
        54.35097454212214,
        54.36595992276796,
        54.38094530341379,
        54.395930684059614,
        54.41091606470544,
        54.425901445351265,
        54.44088682599709,
        54.45587220664292,
        54.47085758728875,
        54.48584296793457,
        54.5008283485804,
        54.515813729226224,
        54.53079910987205,
        54.545784490517875,
        54.5607698711637,
        54.57575525180953,
        54.59074063245536,
        54.60572601310118,
        54.62071139374701,
        55.686742183736,
        55.71188645672267,
        55.73701982104315,
        55.76214227669739,
        55.787253823685475,
        55.81235446200732,
        55.83744419166301,
        55.86252301265249,
        55.88759092497578,
        55.912647928632865,
        55.937694023623735,
        55.96272920994845,
        55.98775348760695,
        56.01276685659927,
        56.03776931692535,
        56.06276086858527,
        56.08774151157898,
        56.11271124590651,
        56.137670071567854,
        56.162617988562985,
        56.187554996891876,
        56.21248109655461,
        56.237396287551164,
        56.2623005698815,
        56.28719394354566,
        56.312076408543604,
        56.336947964875364,
        56.36180861254091,
        56.38665835154028,
        56.41149718187346,
        56.436325103540426,
        56.46114211654118,
        56.48594822087573,
        56.510743416544116,
        56.53552770354632,
        56.560301081882315,
        56.585063551552096,
        56.609815112555694,
        56.63455576489308,
        56.65928550856428,
        56.6840043435693,
        56.70871226990813,
        56.73340928758073,
        56.75809539658714,
        56.782770596927364,
        56.807434888601406,
        56.83208827160924,
        56.856730745950856,
        56.88136231162629,
        56.90598296863551,
        56.93059271697858,
        56.955191556655436,
        56.97977948766611,
        57.00435651001054,
        57.028922623688786,
        57.05347782870085,
        57.07802212504673,
        57.1025555127264,
        57.12707799173988,
        57.15158956208715,
        57.17609022376821,
        57.20057997678312,
        57.22505882113181,
        57.24952675681432,
        57.273983783830616,
        57.2984299021807,
        57.3228651118646,
        57.34728941288232,
        57.37170280523385,
        57.39610528891917,
        57.42049686393828,
        57.44487753029118,
        57.46924728797792,
        57.49360613699845,
        57.5179540773528,
        57.54229110904093,
        57.56661723206285,
        57.59093244641862,
        57.615236752108174,
        57.639530149131545,
        57.663812637488704,
        57.68808421717965,
        57.71234488820441,
        57.73659465056299,
        57.76083350425536,
        57.78506144928157,
        57.809278485641514,
        57.83348461333533,
        57.857679832362905,
        57.8818641427243,
        57.906037544419505,
        57.9302000374485,
        57.95435162181131,
        57.978492297507884,
        58.00262206453833,
        58.02674092290253,
        58.05084887260058,
        58.07494591363239,
        58.099032045998015,
        58.12310726969743,
        58.147171584730685,
        58.17122499109773,
        58.195267488798564,
        58.21929907783321,
        58.24331975820165,
        58.267329529903904,
        58.291328392939974,
        58.31531634730983,
        58.33929339301348,
        58.36325953005097,
        58.38721475842222,
        58.41115907812731,
        58.435092489166195,
        58.45901499153889,
        58.48292658524538,
        58.506827270285655,
        58.530717046659746,
        58.55459591436765,
        58.578463873409376,
        58.60232092378486,
        58.62616706549419,
        58.650002298537274,
        58.673826622914206,
        58.697640038624954,
        58.72144254566949,
        58.745234144047785,
        58.769014833759925,
        58.79278461480585,
        58.816543487185626,
        58.84029145089916,
        58.86402850594651,
        58.88775465232767,
        58.911469890042596,
        58.935174219091365,
        58.95886763947395,
        58.982550151190324,
        59.006221754240485,
        59.029882448624434,
        59.05353223434223,
        59.07717111139384,
        59.100799079779236,
        59.12441613949839,
        59.148022290551395,
        59.171617532938185,
        59.19520186665879,
        59.218775291713214,
        59.242337808101425,
        59.26588941582342,
        59.28943011487924,
        59.31295990526887,
        59.33647878699229,
        59.35998676004955,
        59.383483824440574,
        59.406969980165414,
        59.43044522722401,
        59.453909565616485,
        59.477362995342745,
        59.50080551640279,
        59.52423712879663,
        59.54765783252428,
        59.57106762758575,
        59.59446651398103,
        59.617854491710105,
        59.641231560772994,
        59.66459772116967,
        59.687952972900135,
        59.711297315964416,
        59.73463075036251,
        59.757953276094426,
        59.7812648931601,
        59.80456560155962,
        59.82785540129292,
        59.851134292360015,
        59.87440227476095,
        59.89765934849568,
        59.92090551356419,
        59.944140769966495,
        59.96736511770264,
        59.990578556772576,
        60.013781087176326,
        60.03697270891384,
        60.06015342198519,
        60.083323226390334,
        60.10648212212929,
        60.12963010920204,
        60.15276718760863,
        60.175893357348954,
        60.19900861842312,
        60.222112970831105,
        60.24520641457288,
        60.268288949648465,
        60.29136057605784,
        60.31442129380103,
        60.33747110287801,
        60.36051000328881,
        60.38353799503342,
        60.40655507811182,
        60.42956125252401,
        60.452556518269986,
        60.47554087534981,
        60.498514323763445,
        60.52147686351087,
        60.54442849459208,
        60.56736921700711,
        60.59029903075593,
        60.61321793583859,
        60.63612593225504,
        60.65902302000528,
        60.681909199089304,
        60.704784469507146,
        60.727648831258804,
        60.75050228434428,
        60.77334482876354,
        60.79617646451659,
        60.818997191603486,
        60.84180701002414,
        60.86460591977861,
        60.8873939208669,
        60.910171013289,
        60.932937197044865,
        60.955692472134544,
        60.97843683855807,
        61.00117029631538,
        61.02389284540648,
        61.04660448583137,
        61.0693052175901,
        61.09199504068259,
        61.11467395510893,
        61.13734196086905,
        61.15999905796299,
        61.18264524639069,
        61.20528052615221,
        61.22790489724757,
        61.25051835967672,
        61.27312091343968,
        61.29571255853644,
        61.31829329496698,
        61.34086312273131,
        61.36342204182948,
        61.38597005226147,
        61.40850715402725,
        61.431033347126785,
        61.45354863156014,
        61.47605300732734,
        61.49854647442832,
        61.521029032863126,
        61.543500682631745,
        61.56596142373412,
        61.58841125617029,
        61.6108501799403,
        61.63327819504413,
        61.65569530148174,
        61.678101499253145,
        61.700496788358365,
        61.72288116879737,
        61.745254640570195,
        61.767617203676835,
        61.78996885811729,
        61.81230960389151,
        61.83463944099954,
        61.85695836944139,
        61.87926638921705,
        61.9015635003265,
        61.92384970276974,
        61.94612499654683,
        61.96838938165767,
        61.99064285810233,
        62.01288542588081,
        62.035117084993104,
        62.05733783543916,
        62.079547677219026,
        62.10174661033274,
        62.12393463478024,
        62.14611175056153,
        62.16827795767661,
        62.19043325612553,
        62.21257764590821,
        62.23471112702474,
        62.25683369947505,
        62.27894536325918,
        62.3010461183771,
        62.32313596482881,
        62.34521490261433,
        62.36728293173367,
        62.389340052186824,
        62.41138626397374,
        62.4334215670945,
        62.45544596154902,
        62.47745944733738,
        62.49946202445956,
        62.52145369291553,
        62.543434452705284,
        62.56540430382883,
        62.58736324628619,
        62.60931128007739,
        62.631248405202385,
        62.65317462166114,
        62.67508992945373,
        62.69699432858012,
        62.71888781904032,
        62.74077040083431,
        62.76264207396214,
        62.784502838423705,
        62.806352694219115,
        62.82819164134834,
        62.85001967981135,
        62.87183680960818,
        62.8936430307388,
        62.915438343203235,
        62.93722274700143,
        62.958996242133495,
        62.98075882859935,
        63.00251050639899,
        63.02425127553242,
        63.04598113599964,
        63.0677000878007,
        63.08940813093558,
        63.11110526540425,
        63.13279149120673,
        63.154466808342974,
        63.17613121681303,
        63.19778471661694,
        63.21942730775463,
        63.24105899022611,
        63.262679764031375,
        63.28428962917046,
        63.30588858564336,
        63.327476633450075,
        63.34905377259058,
        63.3706200030649,
        63.39217532487301,
        63.413719738014905,
        63.43525324249062,
        63.456775838300146,
        63.47828752544349,
        63.499788303920596,
        63.521278173731545,
        63.54275713487628,
        63.564225187354836,
        63.58568233116718,
        63.607128566313335,
        63.62856389279328,
        63.649988310607014,
        63.67140181975459,
        63.69280442023596,
        63.71419611205114,
        63.73557689520008,
        63.75694676968287,
        63.778305735499444,
        63.799653792649835,
        63.82099094113404,
        63.84231718095204,
        63.86363251210382,
        63.88493693458939,
        63.906230448408806,
        63.92751305356204,
        63.94878475004906,
        63.97004553786984,
        63.99129541702446,
        64.01253438751287,
        64.0337624493351,
        64.05497960249114,
        64.076185846981,
        64.09738118280463,
        64.11856560996203,
        64.13973912845329,
        64.16090173827835,
        64.18205343943721,
        64.20319423192986,
        64.22432411575632,
        64.24544309091657,
        64.26655115741063,
        64.28764831523851,
        64.30873456440021,
        64.32980990489567,
        64.35087433672494,
        64.37192785988803,
        64.39297047438494,
        64.41400218021563,
        64.43502297738011,
        64.45603286587844,
        64.47703184571053,
        64.49801991687643,
        64.51899707937618,
        64.53996333320968,
        64.560918678377,
        64.58186311487809,
        64.60279664271305,
        64.62371926188179,
        64.64463097238432,
        64.66553177422064,
        64.6864216673908,
        64.70730065189473,
        64.7281687277325,
        64.74902589490405,
        64.76987215340942,
        64.79070750324858,
        64.81153194442153,
        64.8323454769283,
        64.8531481007689,
        64.87393981594327,
        64.89472062245146,
        64.91549052029343,
        64.93624950946922,
        64.95699758997883,
        64.97773476182222,
        64.99846102499943,
        65.01917637951043,
        65.03988082535521,
        65.06057436253384,
        65.08125699104626,
        65.1019287108925,
        65.12258952207252,
        65.14323942458633,
        65.16387841843395,
        65.1845065036154,
        65.20512368013065,
        65.2257299479797,
        65.24632530716254,
        65.26690975767919,
        65.28748329952963,
        65.30804593271388,
        65.32859765723195,
        65.34913847308384,
        65.36966838026949,
        65.39018737878895,
        65.41069546864223,
        65.43119264982933,
        65.45167892235021,
        65.47215428620488,
        65.4926187413934,
        65.51307228791568,
        65.53351492577177,
        65.5539466549617,
        65.5743674754854,
        65.59477738734292,
        65.61517639053419,
        65.63556448505933,
        65.65594167091827,
        65.67630794811099,
        65.69666331663753,
        65.71700777649785,
        65.73734132769196,
        65.75766397021992,
        65.7779757040817,
        65.79827652927726,
        65.81856644580658,
        65.83884545366972,
        65.8591135528667,
        65.87937074339747,
        65.89961702526206,
        65.9198523984604,
        65.9400768629926,
        65.96029041885855,
        65.98049306605834,
        66.00068480459196,
        66.02086563445935,
        66.04103555566051,
        66.06119456819549,
        66.08134267206431,
        66.10147986726695,
        66.12160615380334,
        66.14172153167355,
        66.16182600087758,
        66.18191956141537,
        66.20200221328703,
        66.22207395649245,
        66.24213479103169,
        66.26218471690471,
        66.28222373411155,
        66.30225184265221,
        66.32226904252666,
        66.34227533373492,
        66.36227071627697,
        66.38225519015283,
        66.40222875536249,
        66.42219141190596,
        66.44214315978324,
        66.46208399899432,
        66.48201392953918,
        66.50193295141786,
        66.52184106463035,
        66.54173826917663,
        66.56162456505676,
        66.58149995227065,
        66.60136443081835,
        66.62121800069981,
        66.64106066191515,
        66.66089241446427,
        66.68071325834721,
        66.70052319356391,
        66.7203222201144,
        66.74011033799876,
        66.75988754721688,
        66.77965384776884,
        66.7994092396546,
        66.8191537228741,
        66.83888729742743,
        66.8586099633146,
        66.87832172053557,
        66.89802256909034,
        66.91771250897888,
        66.93739154020126,
        66.9570596627574,
        66.97671687664739,
        66.99636318187119,
        67.01599857842878,
        67.03562306632016,
        67.05523664554532,
        67.07483931610433,
        67.09443107799713,
        67.11401193122374,
        67.13358187578412,
        67.15314091167834,
        67.17268903890634,
        67.19222625746816,
        67.2117525673638,
        67.23126796859323,
        67.25077246115644,
        67.27026604505345,
        67.2897487202843,
        67.30922048684896,
        67.32868134474741,
        67.34813129397962,
        67.3675703345457,
        67.38699846644552,
        67.4064156896792,
        67.42582200424665,
        67.44521741014795,
        67.464601907383,
        67.48397549595184,
        67.50333817585452,
        67.52268994709102,
        67.54203080966131,
        67.56136076356539,
        67.58067980880331,
        67.59998794537496,
        67.61928517328049,
        67.6385714925198,
        67.65784690309293,
        67.67711140499982,
        67.6963649982405,
        67.71560768281505,
        67.73483945872336,
        67.75406032596551,
        67.77327028454143,
        67.79246933445116,
        67.81165747569467,
        67.83083470827204,
        67.85000103218319,
        67.86915644742815,
        67.88830095400688,
        67.90743455191942,
        67.92655724116581,
        67.94566902174599,
        67.96476989365995,
        67.9838598569077,
        68.0029389114893,
        68.02200705740465,
        68.04106429465385,
        68.06011062323684,
        68.07914604315364,
        68.09817055440423,
        68.11718415698861,
        68.13618685090681,
        68.15517863615885,
        68.17415951274465,
        68.1931294806643,
        68.21208853991767,
        68.2310366905049,
        68.24997393242593,
        68.26890026568076,
        68.2878156902694,
        68.30672020619183,
        68.32561381344804,
        68.3444965120381,
        68.36336830196196,
        68.38222918321962,
        68.4010791558111,
        68.41991821973635,
        68.43874637499538,
        68.45756362158825,
        68.47636995951494,
        68.49516538877542,
        68.51394990936969,
        68.53272352129777,
        68.55148622455964,
        68.57023801915535,
        68.58897890508486,
        68.60770888234815,
        68.62642795094526,
        68.64513611087612,
        68.66383336214086,
        68.68251970473936,
        68.70119513867171,
        68.71985966393781,
        68.73851328053773,
        68.75715598847144,
        68.77578778773899,
        68.79440867834033,
        68.81301866027549,
        68.8316177335444,
        68.85020589814714,
        68.86878315408372,
        68.88734950135408,
        68.90590493995823,
        68.92444946989617,
        68.94298309116796,
        68.9615058037735,
        68.9800176077129,
        68.9985185029861,
        69.0170084895931,
        69.03548756753385,
        69.05395573680842,
        69.07241299741683,
        69.09085934935904,
        69.10929479263505,
        69.12771932724483,
        69.14613295318846,
        69.16453567046584,
        69.18292747907707,
        69.20130837902211,
        69.21967837030094,
        69.23803745291356,
        69.25638562685997,
        69.27472289214019,
        69.29304924875426,
        69.31136469670211,
        69.32966923598373,
        69.34796286659919,
        69.36624558854844,
        69.3845174018315,
        69.40277830644838,
        69.42102830239905,
        69.43926738968351,
        69.45749556830175,
        69.47571283825384,
        69.49391919953975,
        69.51211465215944,
        69.53029919611289,
        69.54847283140019,
        69.56663555802128,
        69.5847873759762,
        69.6029282852649,
        69.62105828588743,
        69.63917737784372,
        69.6572855611338,
        69.67538283575773,
        69.69346920171547,
        69.711544659007,
        69.72960920763235,
        69.74766284759149,
        69.76570557888438,
        69.78373740151115,
        69.8017583154717,
        69.81976832076607,
        69.8377674173942,
        69.85575560535612,
        69.87373288465191,
        69.89169925528147,
        69.90965471724486,
        69.92759927054205,
        69.94553291517299,
        69.96345565113775,
        69.98136747843635,
        69.99926839706875,
        70.01715840703496,
        70.03503750833492,
        70.05290570096874,
        70.07076298493634,
        70.08860936023775,
        70.10644482687296,
        70.12426938484198,
        70.14208303414479,
        70.15988577478139,
        70.17767760675183,
        70.19545853005606,
        70.2132285446941,
        70.23098765066594,
        70.24873584797159,
        70.266473136611,
        70.28419951658428,
        70.30191498789132,
        70.31961955053221,
        70.33731320450683,
        70.35499594981529,
        70.37266778645757,
        70.39032871443364,
        70.40797873374352,
        70.42561784438719,
        70.44324604636468,
        70.46086333967595,
        70.47846972432104,
        70.49606520029995,
        70.51364976761268,
        70.53122342625916,
        70.54878617623943,
        70.56633801755355,
        70.58387895020148,
        70.6014089741832,
        70.61892808949871,
        70.63643629614803,
        70.65393359413115,
        70.6714199834481,
        70.68889546409885,
        70.70636003608341,
        70.72381369940173,
        70.74125645405384,
        70.75868830003982,
        70.77610923735959,
        70.79351926601315,
        70.8109183860005,
        70.82830659732168,
        70.84568389997663,
        70.8630502939654,
        70.88040577928801,
        70.89775035594438,
        70.91508402393457,
        70.93240678325851,
        70.94971863391633,
        70.96701957590794,
        70.98430960923336,
        71.00158873389255,
        71.01885694988555,
        71.03611425721236,
        71.05336065587296,
        71.07059614586741,
        71.08782072719565,
        71.10503439985764,
        71.12223716385346,
        71.13942901918311,
        71.15660996584656,
        71.17378000384382,
        71.19093913317487,
        71.2080873538397,
        71.22522466583833,
        71.2423510691708,
        71.25946656383708,
        71.27657114983715,
        71.29366482717101,
        71.31074759583866,
        71.32781945584016,
        71.34488040717544,
        71.36193044984454,
        71.37896958384745,
        71.3959978091841,
        71.41301512585459,
        71.43002153385889,
        71.44701703319701,
        71.46400162386892,
        71.48097530587462,
        71.49793807921414,
        71.51488994388744,
        71.53183089989459,
        71.54876094723552,
        71.56568008591027,
        71.58258831591878,
        71.59948563726108,
        71.61637204993725,
        71.63324755394721,
        71.65011214929096,
        71.6669658359685,
        71.68380861397988,
        71.70064048332502,
        71.71746144400397,
        71.73427149601677,
        71.75107063936336,
        71.76785887404371,
        71.78463620005788,
        71.80140261740586,
        71.81815812608765,
        71.83490272610327,
        71.85163641745264,
        71.86835920013586,
        71.88507107415283,
        71.90177203950365,
        71.91846209618826,
        71.93514124420669,
        71.9518094835589,
        71.9684668142449,
        71.98511323626472,
        72.00174874961839,
        72.01837335430581,
        72.03498705032705,
        72.0515898376821,
        72.06818171637092,
        72.08476268639357,
        72.10133274775005,
        72.11789190044031,
        72.13444014446434,
        72.1509774798222,
        72.16750390651386,
        72.18401942453936,
        72.20052403389865,
        72.21701773459169,
        72.23350052661858,
        72.24997240997926,
        72.26643338467376,
        72.28288345070207,
        72.29932260806417,
        72.31575085676006,
        72.33216819678974,
        72.34857462815326,
        72.3649701508506,
        72.38135476488172,
        72.3977284702466,
        72.41409126694536,
        72.43044315497785,
        72.44678413434421,
        72.46311420504436,
        72.4794333670783,
        72.49574162044603,
        72.51203896514757,
        72.52832540118293,
        72.54460092855207,
        72.56086554725506,
        72.57711925729184,
        72.59336205866238,
        72.60959395136673,
        72.6258149354049,
        72.64202501077689,
        72.6582241774827,
        72.67441243552226,
        72.69058978489564,
        72.70675622560283,
        72.72291175764384,
        72.73905638101867,
        72.75519009572729,
        72.77131290176966,
        72.78742479914585,
        72.80352578785589,
        72.81961586789971,
        72.83569503927735,
        72.85176330198875,
        72.867820656034,
        72.883867101413,
        72.89990263812585,
        72.91592726617252,
        72.93194098555297,
        72.94794379626721,
        72.96393569831524,
        72.97991669169711,
        72.99588677641277,
        73.01184595246225,
        73.02779421984552,
        73.0437315785626,
        73.05965802861344,
        73.07557356999816,
        73.09147820271663,
        73.10737192676895,
        73.12325474215503,
        73.13912664887489,
        73.1549876469286,
        73.17083773631613,
        73.18667691703745,
        73.20250518909252,
        73.21832255248147,
        73.23412900720415,
        73.2499245532607,
        73.26570919065104,
        73.28148291937516,
        73.29724573943308,
        73.31299765082481,
        73.32873865355036,
        73.34446874760972,
        73.36018793300288,
        73.37589620972982,
        73.39159357779057,
        73.40728003718512,
        73.42295558791348,
        73.43862022997568,
        73.45427396337165,
        73.4699167881014,
        73.48554870416497,
        73.50116971156235,
        73.51677981029356,
        73.53237900035857,
        73.54796728175735,
        73.56354465448995,
        73.57911111855633,
        73.59466667395655,
        73.61021132069057,
        73.6257450587584,
        73.64126788815999,
        73.6567798088954,
        73.67228082096464,
        73.68777092436768,
        73.70325011910454,
        73.71871840517515,
        73.73417578257958,
        73.74962225131783,
        73.76505781138987,
        73.78048246279575,
        73.79589620553541,
        73.81129903960884,
        73.82669096501608,
        73.84207198175717,
        73.85744208983205,
        73.87280128924074,
        73.88814957998322,
        73.90348696205949,
        73.91881343546957,
        73.93412900021347,
        73.94943365629116,
        73.96472740370267,
        73.98001024244796,
        73.99528217252704,
        74.01054319393997,
        74.02579330668668,
        74.04103251076721,
        74.05626080618156,
        74.07147819292966,
        74.08668467101155,
        74.10188024042732,
        74.11706490117685,
        74.13223865326022,
        74.14740149667735,
        74.1625534314283,
        74.17769445751303,
        74.19282457493158,
        74.20794378368397,
        74.22305208377013,
        74.23814947519007,
        74.25323595794383,
        74.2683115320314,
        74.2833761974528,
        74.298429954208,
        74.31347280229697,
        74.32850474171975,
        74.34352577247635,
        74.35853589456674,
        74.37353510799097,
        74.38852341274897,
        74.40350080884077,
        74.41846729626637,
        74.43342287502578,
        74.44836754511901,
        74.46330130654606,
        74.47822415930686,
        74.49313610340151,
        74.50803713882992,
        74.52292726559217,
        74.53780648368821,
        74.55267479311807,
        74.56753219388172,
        74.58237868597915,
        74.59721426941043,
        74.6120389441755,
        74.62685271027438,
        74.64165556770702,
        74.6564475164735,
        74.67122855657375,
        74.68599868800784,
        74.70075791077575,
        74.71550622487744,
        74.73024363031293,
        74.7449701270822,
        74.75968571518531,
        74.77439039462222,
        74.78908416539294,
        74.80376702749744,
        74.81843898093577,
        74.83310002570785,
        74.8477501618138,
        74.86238938925352,
        74.87701770802708,
        74.89163511813437,
        74.90624161957551,
        74.92083721235046,
        74.9354218964592,
        74.94999567190179,
        74.9645585386781,
        74.97911049678827,
        74.99365154623221,
        75.00818168701001,
        75.02270091912159,
        75.03720924256696,
        75.05170665734612,
        75.06619316345906,
        75.08066876090588,
        75.09513344968646,
        75.10958722980088,
        75.12403010124909,
        75.13846206403106,
        75.15288311814685,
        75.16729326359645,
        75.1816925003799,
        75.1960808284971,
        75.2104582479481,
        75.22482475873291,
        75.23918036085153,
        75.25352505430398,
        75.26785883909024,
        75.28218171521029,
        75.29649368266409,
        75.31079474145172,
        75.32508489157318,
        75.33936413302844,
        75.35363246581751,
        75.36788988994034,
        75.38213640539702,
        75.39637201218748,
        75.41059671031176,
        75.42481049976986,
        75.43901338056175,
        75.45320535268739,
        75.46738641614688,
        75.48155657094016,
        75.49571581706728,
        75.50986415452819,
        75.52400158332286,
        75.53812810345137,
        75.55224371491367,
        75.56634841770979,
        75.58044221183972,
        75.59452509730347,
        75.60859707410096,
        75.62265814223228,
        75.63670830169742,
        75.65074755249636,
        75.66477589462913,
        75.67879332809564,
        75.69279985289599,
        75.70679546903013,
        75.72078017649811,
        75.73475397529988,
        75.74871686543544,
        75.76266884690479,
        75.77660991970795,
        75.79054008384493,
        75.80445933931573,
        75.81836768612031,
        75.83226512425868,
        75.84615165373087,
        75.86002727453685,
        75.87389198667667,
        75.88774579015028,
        75.90158868495767,
        75.91542067109889,
        75.92924174857386,
        75.9430519173827,
        75.95685117752534,
        75.97063952900176,
        75.98441697181197,
        75.99818350595602,
        76.01193913143383,
        76.02568384824546,
        76.03941765639094,
        76.0531405558702,
        76.06685254668322,
        76.08055362883006,
        76.09424380231071,
        76.10792306712518,
        76.12159142327347,
        76.13524887075552,
        76.14889540957141,
        76.16253103972106,
        76.17615576120456,
        76.18976957402187,
        76.20337247817297,
        76.21696447365782,
        76.2305455604765,
        76.24411573862902,
        76.25767500811533,
        76.27122336893545,
        76.28476082108936,
        76.29828736457706,
        76.31180299939855,
        76.32530772555388,
        76.33880154304303,
        76.35228445186597,
        76.3657564520227,
        76.3792175435132,
        76.39266772633756,
        76.40610700049571,
        76.41953536598767,
        76.43295282281345,
        76.44635937097298,
        76.45975501046631,
        76.47313974129351,
        76.4865135634545,
        76.49987647694927,
        76.51322848177783,
        76.52656957794018,
        76.53989976543637,
        76.55321904426638,
        76.56652741443018,
        76.5798248759278,
        76.59311142875917,
        76.60638707292433,
        76.61965180842337,
        76.6329056352562,
        76.6461485534228,
        76.6593805629232,
        76.67260166375745,
        76.68581185592545,
        76.6990111394273,
        76.71219951426293,
        76.72537698043239,
        76.7385435379356,
        76.75169918677263,
        76.7648439269435,
        76.77797775844816,
        76.79110068128661,
        76.80421269545887,
        76.81731380096493,
        76.8304039978048,
        76.84348328597848,
        76.85655166548595,
        76.86960913632724,
        76.88265569850232,
        76.89569135201118,
        76.90871609685387,
        76.92172993303039,
        76.93473286054068,
        76.94772487938478,
        76.9607059895627,
        76.97367619107438,
        76.9866354839199,
        76.99958386809924,
        77.01252134361236,
        77.02544791045928,
        77.03836356863998,
        77.05126831815453,
        77.06416215900286,
        77.07704509118501,
        77.08991711470095,
        77.10277822955071,
        77.11562843573422,
        77.12846773325161,
        77.14129612210276,
        77.15411360228775,
        77.1669201738065,
        77.17971583665904,
        77.19250059084543,
        77.20527443636563,
        77.21803737321962,
        77.23078940140736,
        77.24353052092899,
        77.25626073178434,
        77.26898003397356,
        77.28168842749658,
        77.29438591235338,
        77.30707248854397,
        77.31974815606837,
        77.33241291492659,
        77.34506676511863,
        77.35770970664446,
        77.3703417395041,
        77.38296286369753,
        77.39557307922472,
        77.40817238608578,
        77.42076078428063,
        77.4333382738093,
        77.44590485467172,
        77.45846052686797,
        77.47100529039803,
        77.4835391452619,
        77.49606209145959,
        77.50857412899107,
        77.52107525785631,
        77.53356547805537,
        77.54604478958827,
        77.55851319245495,
        77.57097068665546,
        77.58341727218972,
        77.5958529490578,
        77.60827771725972,
        77.62069157679544,
        77.63309452766497,
        77.64548656986828,
        77.65786770340536,
        77.67023792827628,
        77.68259724448102,
        77.69494565201954,
        77.70728315089188,
        77.71960974109798,
        77.73192542263796,
        77.74423019551166,
        77.75652405971924,
        77.76880701526058,
        77.78107906213576,
        77.7933402003447,
        77.80559042988743,
        77.817829750764,
        77.8300581629744,
        77.84227566651857,
        77.85448226139651,
        77.86667794760832,
        77.8788627251539,
        77.89103659403328,
        77.90319955424648,
        77.9153516057935,
        77.92749274867428,
        77.93962298288885,
        77.95174230843726,
        77.96385072531949,
        77.97594823353553,
        77.98803483308531,
        78.00011052396896,
        78.01217530618636,
        78.02422917973759,
        78.03627214462263,
        78.04830420084149,
        78.0603253483941,
        78.07233558728053,
        78.08433491750078,
        78.09632333905485,
        78.10830085194273,
        78.12026745616437,
        78.13222315171983,
        78.1441679386091,
        78.15610181683216,
        78.16802478638907,
        78.17993684727976,
        78.19183799950422,
        78.20372824306249,
        78.21560757795457,
        78.22747600418047,
        78.23933352174019,
        78.25118013063367,
        78.263015830861,
        78.27484062242208,
        78.286654505317,
        78.29845747954575,
        78.31024954510828,
        78.32203070200457,
        78.33380095023468,
        78.34556028979863,
        78.35730872069637,
        78.36904624292792,
        78.3807728564933,
        78.3924885613924,
        78.40419335762535,
        78.41588724519211,
        78.42757022409269,
        78.43924229432706,
        78.45090345589519,
        78.46255370879716,
        78.47419305303292,
        78.48582148860253,
        78.49743901550592,
        78.50904563374313,
        78.5206413433141,
        78.53222614421885,
        78.54380003645745,
        78.55536302002987,
        78.5669150949361,
        78.57845626117607,
        78.58998651874988,
        78.60150586765751,
        78.61301430789892,
        78.62451183947418,
        78.6359984623832,
        78.64747417662603,
        78.65893898220263,
        78.6703928791131,
        78.68183586735735,
        78.69326794693539,
        78.70468911784722,
        78.7160993800929,
        78.72749873367233,
        78.73888717858561,
        78.75026471483268,
        78.76163134241357,
        78.77298706132821,
        78.78433187157667,
        78.79566577315897,
        78.80698876607507,
        78.81830085032497,
        78.82960202590864,
        78.84089229282615,
        78.85217165107743,
        78.86344010066254,
        78.87469764158145,
        78.88594427383417,
        78.89717999742068,
        78.90840481234098,
        78.91961871859512,
        78.93082171618305,
        78.94201380510479,
        78.9531949853603,
        78.96436525694965,
        78.97552461987279,
        78.98667307412974,
        78.99781061972048,
        79.00893725664507,
        79.02005298490339,
        79.03115780449552,
        79.0422517154215,
        79.0533347176813,
        79.06440681127488,
        79.07546799620222,
        79.08651827246344,
        79.09755764005838,
        79.10858609898717,
        79.11960364924978,
        79.1306102908462,
        79.14160602377636,
        79.15259084804036,
        79.16356476363818,
        79.17452777056981,
        79.18547986883523,
        79.19642105843441,
        79.20735133936746,
        79.21827071163425,
        79.2291791752349,
        79.24007673016935,
        79.25096337643758,
        79.2618391140396,
        79.27270394297544,
        79.2835578632451,
        79.29440087484856,
        79.30523297778582,
        79.3160541720569,
        79.32686445766176,
        79.3376638346004,
        79.34845230287287,
        79.35922986247915,
        79.36999651341925,
        79.38075225569311,
        79.39149708930078,
        79.40223101424228,
        79.41295403051758,
        79.4236661381267,
        79.43436733706962,
        79.44505762734629,
        79.45573700895677,
        79.4664054819011,
        79.47706304617925,
        79.48770970179119,
        79.49834544873688,
        79.5089702870164,
        79.51958421662972,
        79.53018723757687,
        79.54077934985783,
        79.55136055347258,
        79.56193084842111,
        79.57249023470344,
        79.5830387123196,
        79.59357628126959,
        79.60410294155336,
        79.6146186931709,
        79.62512353612227,
        79.63561747040744,
        79.64610049602642,
        79.65657261297922,
        79.66703382126583,
        79.67748412088618,
        79.68792351184037,
        79.69835199412837,
        79.7087695677502,
        79.7191762327058,
        79.72957198899518,
        79.73995683661842,
        79.75033077557539,
        79.76069380586624,
        79.77104592749087,
        79.78138714044933,
        79.79171744474154,
        79.80203684036753,
        79.81234532732738,
        79.82264290562104,
        79.83292957524851,
        79.84320533620972,
        79.8534701885048,
        79.86372413213364,
        79.8739671670963,
        79.8841992933928,
        79.89442051102306,
        79.90463081998713,
        79.91483022028497,
        79.92501871191668,
        79.93519629488218,
        79.94536296918146,
        79.95551873481453,
        79.96566359178145,
        79.97579754008213,
        79.98592057971665,
        79.99603271068496,
        80.00613393298708,
        80.01622424662297,
        80.02630365159267,
        80.03637214789622,
        80.04642973553355,
        80.0564764145047,
        80.06651218480961,
        80.07653704644837,
        80.08655099942088,
        80.09655404372724,
        80.10654617936738,
        80.11652740634138,
        80.1264977246491,
        80.13645713429064,
        80.14640563526602,
        80.15634322757519,
        80.16626991121818,
        80.17618568619498,
        80.18609055250552,
        80.1959845101499,
        80.2058675591281,
        80.2157396994401,
        80.2256009310859,
        80.23545125406547,
        80.24529066837887,
        80.25511917402609,
        80.2649367710071,
        80.27474345932193,
        80.28453923897057,
        80.29432410995297,
        80.30409807226916,
        80.31386112591922,
        80.32361327090304,
        80.3333545072207,
        80.34308483487213,
        80.35280425385734,
        80.3625127641764,
        80.37221036582928,
        80.38189705881594,
        80.39157284313642,
        80.40123771879065,
        80.41089168577871,
        80.42053474410058,
        80.43016689375627,
        80.43978813474577,
        80.44939846706903,
        80.45899789072611,
        80.46858640571698,
        80.47816401204169,
        80.48773070970022,
        80.49728649869253,
        80.5068313790186,
        80.5163653506785,
        80.5258884136722,
        80.53540056799976,
        80.54490181366107,
        80.55439215065617,
        80.56387157898511,
        80.57334009864785,
        80.5827977096444,
        80.59224441197473,
        80.60168020563889,
        80.61110509063683,
        80.62051906696855,
        80.62992213463413,
        80.63931429363349,
        80.64869554396667,
        80.6580658856336,
        80.66742531863439,
        80.67677384296896,
        80.68611145863734,
        80.69543816563952,
        80.70475396397553,
        80.71405885364528,
        80.72335283464885,
        80.73263590698626,
        80.74190807065749,
        80.7511693256625,
        80.7604196720013,
        80.76965910967392,
        80.7788876386803,
        80.78810525902055,
        80.7973119706946,
        80.80650777370242,
        80.81569266804404,
        80.82486665371944,
        80.83402973072869,
        80.84318189907175,
        80.8523231587486,
        80.86145350975924,
        80.8705729521037,
        80.87968148578194,
        80.888779110794,
        80.89786582713988,
        80.90694163481957,
        80.91600653383303,
        80.92506052418027,
        80.93410360586138,
        80.94313577887628,
        80.95215704322497,
        80.96116739890748,
        80.97016684592374,
        80.97915538427382,
        80.98813301395775,
        80.99709973497546,
        81.006055547327,
        81.01500045101228,
        81.02393444603139,
        81.03285753238431,
        81.04176971007105,
        81.0506709790916,
        81.05956133944595,
        81.06844079113405,
        81.07730933415597,
        81.08616696851173,
        81.09501369420131,
        81.10384951122468,
        81.11267441958181,
        81.12148841927275,
        81.13029151029751,
        81.13908369265611,
        81.14786496634848,
        81.15663533137469,
        81.16539478773463,
        81.17414333542838,
        81.18288097445598,
        81.1916077048174,
        81.2003235265126,
        81.20902843954157,
        81.2177224439044,
        81.22640553960098,
        81.23507772663142,
        81.24373900499565,
        81.25238937469366,
        81.26102883572547,
        81.26965738809106,
        81.2782750317905,
        81.28688176682375,
        81.2954775931908,
        81.30406251089163,
        81.31263651992627,
        81.3211996202947,
        81.32975181199699,
        81.33829309503305,
        81.3468234694029,
        81.35534293510655,
        81.36385149214401,
        81.37234914051528,
        81.38083588022037,
        81.38931171125925,
        81.39777663363192,
        81.40623064733843,
        81.4146737523787,
        81.42310594875279,
        81.43152723646072,
        81.43993761550242,
        81.4483370858779,
        81.45672564758719,
        81.46510330063033,
        81.47347004500726,
        81.48182588071798,
        81.49017080776248,
        81.49850482614083,
        81.50682793585294,
        81.51514013689889,
        81.52344142927863,
        81.53173181299219,
        81.54001128803954,
        81.54827985442064,
        81.55653751213562,
        81.56478426118439,
        81.57302010156697,
        81.58124503328331,
        81.5894590563335,
        81.59766217071744,
        81.60585437643523,
        81.61403567348684,
        81.62220606187223,
        81.63036554159139,
        81.63851411264436,
        81.64665177503117,
        81.6547785287518,
        81.66289437380622,
        81.67099931019443,
        81.67909333791643,
        81.68717645697221,
        81.69524866736184,
        81.70330996908528,
        81.71136036214251,
        81.71939984653353,
        81.72742842225834,
        81.735446089317,
        81.74345284770946,
        81.75144869743572,
        81.75943363849579,
        81.7674076708896,
        81.77537079461725,
        81.78332300967871,
        81.79126431607399,
        81.79919471380309,
        81.80711420286592,
        81.81502278326259,
        81.82292045499308,
        81.83080721805739,
        81.83868307245548,
        81.84654801818739,
        81.85440205525306,
        81.86224518365255,
        81.87007740338585,
        81.87789871445297,
        81.8857091168539,
        81.8935086105886,
        81.90129719565711,
        81.90907487205943,
        81.91684163979555,
        81.92459749886551,
        81.93234244926926,
        81.94007649100676,
        81.94779962407809,
        81.95551184848325,
        81.96321316422221,
        81.97090357129498,
        81.97858306970151,
        81.98625165944189,
        81.99390934051603,
        82.001556112924,
        82.0091919766658,
        82.01681693174139,
        82.02443097815073,
        82.0320341158939,
        82.0396263449709,
        82.04720766538169,
        82.0547780771263,
        82.0623375802047,
        82.06988617461691,
        82.07742386036288,
        82.0849506374427,
        82.09246650585634,
        82.09997146560376,
        82.10746551668497,
        82.11494865909997,
        82.12242089284881,
        82.12988221793147,
        82.13733263434791,
        82.14477214209812,
        82.1522007411822,
        82.15961843160001,
        82.16702521335166,
        82.17442108643714,
        82.18180605085642,
        82.18918010660947,
        82.1965432536963,
        82.20389549211698,
        82.21123682187148,
        82.21856724295976,
        82.22588675538184,
        82.23319535913772,
        82.2404930542274,
        82.24777984065089,
        82.25505571840823,
        82.26232068749933,
        82.26957474792421,
        82.27681789968291,
        82.28405014277543,
        82.29127147720176,
        82.29848190296188,
        82.30568142005582,
        82.31287002848354,
        82.32004772824503,
        82.32721451934039,
        82.33437040176953,
        82.3415153755325,
        82.34864944062922,
        82.35577259705975,
        82.36288484482414,
        82.36998618392231,
        82.37707661435427,
        82.38415613612004,
        82.3912247492196,
        82.39828245365295,
        82.40532924942015,
        82.41236513652113,
        82.41939011495593,
        82.42640418472449,
        82.43340734582686,
        82.44039959826308,
        82.44738094203309,
        82.45435137713692,
        82.46131090357453,
        82.46825952134593,
        82.47519723045112,
        82.48212403089015,
        82.489039922663,
        82.49594490576963,
        82.50283898021003,
        82.5097221459843,
        82.5165944030923,
        82.52345575153417,
        82.53030619130983,
        82.53714572241928,
        82.54397434486252,
        82.55079205863954,
        82.55759886375041,
        82.5643947601951,
        82.57117974797357,
        82.57795382708584,
        82.58471699753191,
        82.59146925931178,
        82.59821061242549,
        82.60494105687299,
        82.6116605926543,
        82.61836921976935,
        82.62506693821824,
        82.63175374800095,
        82.63842964911747,
        82.64509464156781,
        82.65174872535188,
        82.65839190046982,
        82.66502416692153,
        82.67164552470707,
        82.67825597382641,
        82.68485551427956,
        82.69144414606647,
        82.6980218691872,
        82.70458868364175,
        82.7111445894301,
        82.71768958655228,
        82.72422367500822,
        82.730746854798,
        82.73725912592154,
        82.7437604883789,
        82.7502509421701,
        82.75673048729509,
        82.76319912375384,
        82.7696568515464,
        82.77610367067281,
        82.78253958113301,
        82.78896458292702,
        82.7953786760548,
        82.80178186051641,
        82.80817413631179,
        82.81455550344101,
        82.82092596190405,
        82.82728551170088,
        82.83363415283146,
        82.83997188529587,
        82.84629870909411,
        82.85261462422618,
        82.85891963069203,
        82.86521372849167,
        82.8714969176251,
        82.87776919809231,
        82.88403056989337,
        82.89028103302824,
        82.89652058749694,
        82.90274923329936,
        82.9089669704356,
        82.91517379890568,
        82.92136971870958,
        82.92755472984727,
        82.93372883231878,
        82.93989202612404,
        82.9460443112631,
        82.95218568773602,
        82.95831615554273,
        82.96443571468323,
        82.97054436515752,
        82.9766421069656,
        82.98272894010752,
        82.98880486458326
    ],
    TENNIS: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.013984320356503988,
        0.028969701002330206,
        0.043955081648156424,
        0.05894046229398242,
        0.07392584293980864,
        0.08891122358563486,
        0.10389660423146108,
        0.11888198487728707,
        0.1338673655231133,
        0.1488527461689395,
        0.1638381268147655,
        0.17882350746059172,
        0.19380888810641794,
        0.20879426875224416,
        0.22377964939807016,
        0.23876503004389638,
        0.2537504106897226,
        0.2687357913355486,
        0.2837211719813748,
        0.298706552627201,
        0.31369193327302725,
        0.32867731391885324,
        0.34366269456467946,
        0.3586480752105057,
        0.3736334558563317,
        0.3886188365021579,
        0.4036042171479841,
        0.41858959779381033,
        0.43357497843963655,
        0.4485603590854623,
        0.46354573973128854,
        0.47853112037711476,
        0.493516501022941,
        0.5085018816687672,
        0.5234872623145934,
        0.5384726429604196,
        0.5534580236062454,
        0.5684434042520716,
        0.5834287848978978,
        0.5984141655437241,
        0.6133995461895503,
        0.6283849268353765,
        0.6433703074812027,
        0.6583556881270285,
        0.6733410687728547,
        0.6883264494186809,
        0.7033118300645071,
        0.7182972107103334,
        0.7332825913561596,
        0.7482679720019858,
        0.7632533526478116,
        0.7782387332936378,
        0.793224113939464,
        0.8082094945852902,
        0.8231948752311165,
        0.8381802558769427,
        0.8531656365227689,
        0.8681510171685947,
        0.8831363978144209,
        0.8981217784602471,
        0.9131071591060733,
        0.9280925397518995,
        0.9430779203977258,
        0.958063301043552,
        0.9730486816893777,
        0.988034062335204,
        1.0030194429810302,
        1.0180048236268564,
        1.0329902042726826,
        1.0479755849185088,
        1.062960965564335,
        1.0779463462101608,
        1.092931726855987,
        1.1079171075018133,
        1.1229024881476395,
        1.1378878687934657,
        1.152873249439292,
        1.1678586300851181,
        1.182844010730944,
        1.1978293913767701,
        1.2128147720225964,
        1.2278001526684226,
        1.2427855333142488,
        1.257770913960075,
        1.2727562946059012,
        1.287741675251727,
        1.3027270558975532,
        1.3177124365433794,
        1.3326978171892057,
        1.3476831978350319,
        1.362668578480858,
        1.3776539591266843,
        1.39263933977251,
        1.4076247204183363,
        1.4226101010641625,
        1.4375954817099887,
        1.452580862355815,
        1.4675662430016412,
        1.4825516236474674,
        1.4975370042932932,
        1.5125223849391194,
        1.5275077655849456,
        1.5424931462307718,
        1.557478526876598,
        1.5724639075224243,
        1.5874492881682505,
        1.6024346688140763,
        1.6174200494599025,
        1.6324054301057287,
        1.647390810751555,
        1.6623761913973811,
        1.6773615720432073,
        1.6923469526890331,
        1.7073323333348593,
        1.7223177139806856,
        1.7373030946265118,
        1.752288475272338,
        1.7672738559181642,
        1.7822592365639904,
        1.7972446172098162,
        1.8122299978556424,
        1.8272153785014686,
        1.8422007591472949,
        1.857186139793121,
        1.8721715204389473,
        1.8871569010847735,
        1.9021422817305993,
        1.9171276623764255,
        1.9321130430222517,
        1.947098423668078,
        1.9620838043139042,
        1.9770691849597304,
        1.9920545656055566,
        2.0070399462513824,
        2.0220253268972086,
        2.037010707543035,
        2.051996088188861,
        2.0669814688346873,
        2.0819668494805135,
        2.0969522301263397,
        2.1119376107721655,
        2.1269229914179917,
        2.141908372063818,
        2.156893752709644,
        2.1718791333554703,
        2.1868645140012966,
        2.2018498946471228,
        2.2168352752929485,
        2.2318206559387748,
        2.246806036584601,
        2.261791417230427,
        2.2767767978762534,
        2.2917621785220796,
        2.306747559167906,
        2.3217329398137316,
        2.336718320459558,
        2.351703701105384,
        2.3666890817512103,
        2.3816744623970365,
        2.3966598430428627,
        2.411645223688689,
        2.426630604334515,
        2.4416159849803414,
        2.4566013656261676,
        2.471586746271993,
        2.486572126917819,
        2.5015575075636454,
        2.5165428882094716,
        2.531528268855298,
        2.546513649501124,
        2.5614990301469502,
        2.5764844107927765,
        2.5914697914386027,
        2.606455172084429,
        2.621440552730255,
        2.6364259333760813,
        2.6514113140219076,
        2.6663966946677338,
        2.681382075313559,
        2.6963674559593853,
        2.7113528366052115,
        2.7263382172510378,
        2.741323597896864,
        2.75630897854269,
        2.7712943591885164,
        2.7862797398343426,
        2.801265120480169,
        2.816250501125995,
        2.8312358817718213,
        2.8462212624176475,
        2.8612066430634737,
        2.8761920237093,
        2.8911774043551253,
        2.9061627850009515,
        2.9211481656467777,
        2.936133546292604,
        2.95111892693843,
        2.9661043075842564,
        2.9810896882300826,
        2.996075068875909,
        3.011060449521735,
        3.0260458301675612,
        3.0410312108133875,
        3.0560165914592137,
        3.07100197210504,
        3.085987352750866,
        3.1009727333966914,
        3.1159581140425177,
        3.130943494688344,
        3.14592887533417,
        3.1609142559799963,
        3.1758996366258225,
        3.1908850172716487,
        3.205870397917475,
        3.220855778563301,
        3.2358411592091274,
        3.2508265398549536,
        3.26581192050078,
        3.280797301146606,
        3.2957826817924323,
        3.3107680624382576,
        3.325753443084084,
        3.34073882372991,
        3.3557242043757363,
        3.3707095850215625,
        3.3856949656673887,
        3.400680346313215,
        3.415665726959041,
        3.4306511076048674,
        3.4456364882506936,
        3.46062186889652,
        3.475607249542346,
        3.4905926301881722,
        3.5055780108339984,
        3.520563391479824,
        3.53554877212565,
        3.550534152771476,
        3.5655195334173024,
        3.5805049140631287,
        3.595490294708955,
        3.610475675354781,
        3.6254610560006073,
        3.6404464366464335,
        3.6554318172922597,
        3.670417197938086,
        3.685402578583912,
        3.7003879592297384,
        3.7153733398755637,
        3.73035872052139,
        3.745344101167216,
        3.7603294818130424,
        3.7753148624588686,
        3.790300243104695,
        3.805285623750521,
        3.8202710043963473,
        3.8352563850421735,
        3.8502417656879997,
        3.865227146333826,
        3.880212526979652,
        3.8951979076254784,
        3.9101832882713046,
        3.92516866891713,
        3.940154049562956,
        3.9551394302087823,
        3.9701248108546086,
        3.9851101915004348,
        4.000095572146261,
        4.015080952792087,
        4.030066333437913,
        4.04505171408374,
        4.060037094729566,
        4.075022475375392,
        4.090007856021218,
        4.1049932366670445,
        4.119978617312871,
        4.134963997958696,
        4.149949378604522,
        4.1649347592503485,
        4.179920139896175,
        4.194905520542001,
        4.209890901187827,
        4.224876281833653,
        4.23986166247948,
        4.254847043125306,
        4.269832423771132,
        4.284817804416958,
        4.2998031850627845,
        4.314788565708611,
        4.329773946354437,
        4.344759327000262,
        4.3597447076460885,
        4.374730088291915,
        4.389715468937741,
        4.404700849583567,
        4.419686230229393,
        4.4346716108752195,
        4.449656991521046,
        4.464642372166872,
        4.479627752812698,
        4.494613133458524,
        4.509598514104351,
        4.524583894750177,
        4.539569275396003,
        4.554554656041828,
        4.569540036687655,
        4.584525417333481,
        4.599510797979307,
        4.614496178625133,
        4.6294815592709595,
        4.644466939916786,
        4.659452320562612,
        4.674437701208438,
        4.689423081854264,
        4.704408462500091,
        4.719393843145917,
        4.734379223791743,
        4.749364604437569,
        4.764349985083395,
        4.779335365729221,
        4.794320746375047,
        4.809306127020873,
        4.8242915076666995,
        4.839276888312526,
        4.854262268958352,
        4.869247649604178,
        4.884233030250004,
        4.8992184108958305,
        4.914203791541657,
        4.929189172187483,
        4.944174552833309,
        4.9591599334791345,
        4.974145314124961,
        4.989130694770787,
        5.004116075416613,
        5.019101456062439,
        5.034086836708266,
        5.049072217354092,
        5.064057597999918,
        5.079042978645744,
        5.0940283592915705,
        5.109013739937397,
        5.123999120583223,
        5.138984501229049,
        5.153969881874875,
        5.168955262520701,
        5.183940643166527,
        5.198926023812353,
        5.213911404458179,
        5.228896785104006,
        5.243882165749832,
        5.258867546395658,
        5.273852927041484,
        5.2888383076873104,
        5.303823688333137,
        5.318809068978963,
        5.333794449624789,
        5.348779830270615,
        5.3637652109164415,
        5.378750591562267,
        5.393735972208093,
        5.408721352853919,
        5.4237067334997455,
        5.438692114145572,
        5.453677494791398,
        5.468662875437224,
        5.48364825608305,
        5.498633636728877,
        5.513619017374703,
        5.528604398020529,
        5.543589778666355,
        5.5585751593121815,
        5.573560539958008,
        5.588545920603833,
        5.603531301249659,
        5.6185166818954855,
        5.633502062541312,
        5.648487443187138,
        5.663472823832964,
        5.67845820447879,
        5.693443585124617,
        5.708428965770443,
        5.723414346416269,
        5.738399727062095,
        5.753385107707921,
        5.768370488353748,
        5.783355868999574,
        5.798341249645399,
        5.813326630291225,
        5.828312010937052,
        5.843297391582878,
        5.858282772228704,
        5.87326815287453,
        5.8882535335203565,
        5.903238914166183,
        5.918224294812009,
        5.933209675457835,
        5.948195056103661,
        5.963180436749488,
        5.978165817395314,
        5.99315119804114,
        6.008136578686965,
        6.023121959332792,
        6.038107339978618,
        6.053092720624444,
        6.06807810127027,
        6.0830634819160965,
        6.098048862561923,
        6.113034243207749,
        6.128019623853575,
        6.143005004499401,
        6.157990385145228,
        6.172975765791054,
        6.18796114643688,
        6.202946527082705,
        6.2179319077285315,
        6.232917288374358,
        6.247902669020184,
        6.26288804966601,
        6.277873430311836,
        6.292858810957663,
        6.307844191603489,
        6.322829572249315,
        6.337814952895141,
        6.3528003335409675,
        6.367785714186794,
        6.38277109483262,
        6.397756475478446,
        6.4127418561242715,
        6.427727236770099,
        6.442712617415924,
        6.457697998061751,
        6.472683378707576,
        6.4876687593534035,
        6.502654139999229,
        6.517639520645054,
        6.532624901290881,
        6.547610281936707,
        6.562595662582534,
        6.577581043228359,
        6.592566423874186,
        6.6075518045200115,
        6.622537185165839,
        6.637522565811664,
        6.652507946457491,
        6.667493327103316,
        6.682478707749143,
        6.697464088394969,
        6.712449469040796,
        6.727434849686621,
        6.7424202303324465,
        6.757405610978274,
        6.772390991624099,
        6.787376372269926,
        6.802361752915751,
        6.8173471335615785,
        6.832332514207404,
        6.847317894853231,
        6.862303275499056,
        6.877288656144883,
        6.892274036790709,
        6.907259417436536,
        6.922244798082361,
        6.9372301787281865,
        6.952215559374014,
        6.967200940019839,
        6.982186320665666,
        6.997171701311491,
        7.0121570819573185,
        7.027142462603144,
        7.042127843248971,
        7.057113223894796,
        7.072098604540623,
        7.087083985186449,
        7.102069365832276,
        7.117054746478101,
        7.132040127123928,
        7.1470255077697535,
        7.162010888415579,
        7.176996269061406,
        7.191981649707231,
        7.206967030353058,
        7.221952410998884,
        7.236937791644711,
        7.251923172290536,
        7.266908552936363,
        7.281893933582189,
        7.296879314228016,
        7.311864694873841,
        7.326850075519668,
        7.3418354561654935,
        7.356820836811319,
        7.371806217457146,
        7.386791598102971,
        7.401776978748798,
        7.416762359394624,
        7.431747740040451,
        7.446733120686276,
        7.461718501332103,
        7.476703881977929,
        7.491689262623756,
        7.506674643269581,
        7.521660023915408,
        7.536645404561233,
        7.551630785207059,
        7.566616165852886,
        7.581601546498711,
        7.596586927144538,
        7.611572307790364,
        7.626557688436191,
        7.641543069082016,
        7.656528449727843,
        7.6715138303736685,
        7.686499211019496,
        7.701484591665321,
        7.716469972311148,
        7.731455352956973,
        7.7464407336028005,
        7.761426114248626,
        7.776411494894451,
        7.791396875540278,
        7.806382256186104,
        7.821367636831931,
        7.836353017477756,
        7.851338398123583,
        7.8663237787694085,
        7.881309159415236,
        7.896294540061061,
        7.911279920706888,
        7.926265301352713,
        7.9412506819985405,
        7.956236062644366,
        7.971221443290191,
        7.986206823936018,
        8.001192204581844,
        8.01617758522767,
        8.031162965873495,
        8.046148346519324,
        8.06113372716515,
        8.076119107810975,
        8.0911044884568,
        8.106089869102629,
        8.121075249748454,
        8.13606063039428,
        8.151046011040105,
        8.166031391685934,
        8.181016772331759,
        8.196002152977584,
        8.21098753362341,
        8.225972914269235,
        8.240958294915064,
        8.25594367556089,
        8.270929056206715,
        8.28591443685254,
        8.300899817498369,
        8.315885198144194,
        8.33087057879002,
        8.345855959435845,
        8.360841340081674,
        8.375826720727499,
        8.390812101373324,
        8.40579748201915,
        8.420782862664975,
        8.435768243310804,
        8.45075362395663,
        8.465739004602455,
        8.48072438524828,
        8.495709765894109,
        8.510695146539934,
        8.52568052718576,
        8.540665907831585,
        8.555651288477414,
        8.570636669123239,
        8.585622049769064,
        8.60060743041489,
        8.615592811060715,
        8.630578191706544,
        8.64556357235237,
        8.660548952998194,
        8.67553433364402,
        8.690519714289849,
        8.705505094935674,
        8.7204904755815,
        8.735475856227325,
        8.750461236873154,
        8.765446617518979,
        8.780431998164804,
        8.79541737881063,
        8.810402759456455,
        8.825388140102284,
        8.84037352074811,
        8.855358901393934,
        8.87034428203976,
        8.885329662685589,
        8.900315043331414,
        8.91530042397724,
        8.930285804623065,
        8.945271185268894,
        8.960256565914719,
        8.975241946560544,
        8.99022732720637,
        9.005212707852195,
        9.020198088498024,
        9.035183469143849,
        9.050168849789674,
        9.0651542304355,
        9.080139611081329,
        9.095124991727154,
        9.11011037237298,
        9.125095753018805,
        9.140081133664633,
        9.155066514310459,
        9.170051894956284,
        9.18503727560211,
        9.200022656247938,
        9.215008036893764,
        9.229993417539589,
        9.244978798185414,
        9.25996417883124,
        9.274949559477069,
        9.289934940122894,
        9.30492032076872,
        9.319905701414545,
        9.334891082060373,
        9.349876462706199,
        9.364861843352024,
        9.37984722399785,
        9.394832604643678,
        9.409817985289504,
        9.424803365935329,
        9.439788746581154,
        9.45477412722698,
        9.469759507872809,
        9.484744888518634,
        9.49973026916446,
        9.514715649810285,
        9.529701030456113,
        9.544686411101939,
        9.559671791747764,
        9.57465717239359,
        9.589642553039418,
        9.604627933685244,
        9.619613314331069,
        9.634598694976894,
        9.64958407562272,
        9.664569456268548,
        9.679554836914374,
        9.6945402175602,
        9.709525598206024,
        9.724510978851853,
        9.739496359497679,
        9.754481740143504,
        9.76946712078933,
        9.784452501435158,
        9.799437882080984,
        9.814423262726809,
        9.829408643372634,
        9.84439402401846,
        9.859379404664288,
        9.874364785310114,
        9.889350165955939,
        9.904335546601764,
        9.919320927247593,
        9.934306307893419,
        9.949291688539244,
        9.96427706918507,
        9.979262449830898,
        9.994247830476723,
        10.009233211122549,
        10.024218591768374,
        10.0392039724142,
        10.054189353060028,
        10.069174733705854,
        10.084160114351679,
        10.099145494997504,
        10.114130875643333,
        10.129116256289159,
        10.144101636934984,
        10.15908701758081,
        10.174072398226638,
        10.189057778872463,
        10.204043159518289,
        10.219028540164114,
        10.234013920809943,
        10.248999301455768,
        10.263984682101594,
        10.278970062747419,
        10.293955443393244,
        10.308940824039073,
        10.323926204684899,
        10.338911585330724,
        10.35389696597655,
        10.368882346622378,
        10.383867727268203,
        10.398853107914029,
        10.413838488559854,
        10.428823869205683,
        10.443809249851508,
        10.458794630497334,
        10.473780011143159,
        10.488765391788984,
        10.503750772434813,
        10.518736153080638,
        10.533721533726464,
        10.54870691437229,
        10.563692295018118,
        10.578677675663943,
        10.593663056309769,
        10.608648436955594,
        10.623633817601423,
        10.638619198247248,
        10.653604578893074,
        10.668589959538899,
        10.683575340184724,
        10.698560720830553,
        10.713546101476378,
        10.728531482122204,
        10.743516862768029,
        10.758502243413858,
        10.773487624059683,
        10.788473004705509,
        10.803458385351334,
        10.818443765997163,
        10.833429146642988,
        10.848414527288814,
        10.863399907934639,
        10.878385288580464,
        10.893370669226293,
        10.908356049872118,
        10.923341430517944,
        10.938326811163769,
        10.953312191809598,
        10.968297572455423,
        10.983282953101249,
        10.998268333747074,
        11.013253714392903,
        11.028239095038728,
        11.043224475684553,
        11.058209856330379,
        11.073195236976208,
        11.088180617622033,
        11.103165998267858,
        11.118151378913684,
        11.133136759559509,
        11.148122140205338,
        11.163107520851163,
        11.178092901496989,
        11.193078282142814,
        11.208063662788643,
        11.223049043434468,
        11.238034424080293,
        11.253019804726119,
        11.268005185371948,
        11.282990566017773,
        11.297975946663598,
        11.312961327309424,
        11.327946707955249,
        11.342932088601078,
        11.357917469246903,
        11.372902849892728,
        11.387888230538554,
        11.402873611184383,
        11.417858991830208,
        11.432844372476033,
        11.447829753121859,
        11.462815133767688,
        11.477800514413513,
        11.492785895059338,
        11.507771275705164,
        11.522756656350989,
        11.537742036996818,
        11.552727417642643,
        11.567712798288468,
        11.582698178934294,
        11.597683559580123,
        11.612668940225948,
        11.627654320871773,
        11.642639701517599,
        11.657625082163428,
        11.672610462809253,
        11.687595843455078,
        11.702581224100904,
        11.717566604746729,
        11.732551985392558,
        11.747537366038383,
        11.762522746684208,
        11.777508127330034,
        11.792493507975863,
        11.807478888621688,
        11.822464269267513,
        11.837449649913339,
        11.852435030559167,
        11.867420411204993,
        11.882405791850818,
        11.897391172496643,
        11.912376553142469,
        11.927361933788298,
        11.942347314434123,
        11.957332695079948,
        11.972318075725774,
        11.987303456371603,
        12.002288837017428,
        12.017274217663253,
        12.032259598309079,
        12.047244978954907,
        12.062230359600733,
        12.077215740246558,
        12.092201120892383,
        12.107186501538212,
        12.122171882184038,
        12.137157262829863,
        12.152142643475688,
        12.167128024121514,
        12.182113404767343,
        12.197098785413168,
        12.212084166058993,
        12.227069546704818,
        12.242054927350647,
        12.257040307996473,
        12.272025688642298,
        12.287011069288123,
        12.301996449933952,
        12.316981830579778,
        12.331967211225603,
        12.346952591871428,
        12.361937972517254,
        12.376923353163082,
        12.391908733808908,
        12.406894114454733,
        12.421879495100558,
        12.436864875746387,
        12.451850256392213,
        12.466835637038038,
        12.481821017683863,
        12.496806398329692,
        12.511791778975518,
        12.526777159621343,
        12.541762540267168,
        12.556747920912994,
        12.571733301558822,
        12.586718682204648,
        12.601704062850473,
        12.616689443496298,
        12.631674824142127,
        12.646660204787953,
        12.661645585433778,
        12.676630966079603,
        12.691616346725432,
        12.706601727371257,
        12.721587108017083,
        12.736572488662908,
        12.751557869308733,
        12.766543249954562,
        12.781528630600388,
        12.796514011246213,
        12.811499391892038,
        12.826484772537867,
        12.841470153183693,
        12.856455533829518,
        12.871440914475343,
        12.886426295121172,
        12.901411675766997,
        12.916397056412823,
        12.931382437058648,
        12.946367817704473,
        12.961353198350302,
        12.976338578996128,
        12.991323959641953,
        13.006309340287778,
        13.021294720933607,
        13.036280101579433,
        13.051265482225258,
        13.066250862871083,
        13.081236243516912,
        13.096221624162737,
        13.111207004808563,
        13.126192385454388,
        13.141177766100217,
        13.156163146746042,
        13.171148527391868,
        13.186133908037693,
        13.201119288683518,
        13.216104669329347,
        13.231090049975172,
        13.246075430620998,
        13.261060811266823,
        13.276046191912652,
        13.291031572558477,
        13.306016953204303,
        13.321002333850128,
        13.335987714495957,
        13.350973095141782,
        13.365958475787608,
        13.380943856433433,
        13.395929237079258,
        13.410914617725087,
        13.425899998370912,
        13.440885379016738,
        13.455870759662563,
        13.470856140308392,
        13.485841520954217,
        13.500826901600043,
        13.515812282245868,
        13.530797662891697,
        13.545783043537522,
        13.560768424183347,
        13.575753804829173,
        13.590739185474998,
        13.605724566120827,
        13.620709946766652,
        13.635695327412478,
        13.650680708058303,
        13.665666088704132,
        13.680651469349957,
        13.695636849995783,
        13.710622230641608,
        13.725607611287437,
        13.740592991933262,
        13.755578372579087,
        13.770563753224913,
        13.785549133870738,
        13.800534514516567,
        13.815519895162392,
        13.830505275808218,
        13.845490656454043,
        13.860476037099872,
        13.875461417745697,
        13.890446798391523,
        13.905432179037348,
        13.920417559683177,
        13.935402940329002,
        13.950388320974827,
        13.965373701620653,
        13.980359082266478,
        13.995344462912307,
        14.010329843558132,
        14.025315224203958,
        14.040300604849783,
        14.055285985495612,
        14.070271366141437,
        14.085256746787262,
        14.100242127433088,
        14.115227508078917,
        14.130212888724742,
        14.145198269370567,
        14.160183650016393,
        14.175169030662222,
        14.190154411308047,
        14.205139791953872,
        14.220125172599698,
        14.235110553245523,
        14.250095933891352,
        14.265081314537177,
        14.280066695183002,
        14.295052075828828,
        14.310037456474657,
        14.325022837120482,
        14.340008217766307,
        14.354993598412133,
        14.369978979057962,
        14.384964359703787,
        14.399949740349612,
        14.414935120995438,
        14.429920501641266,
        14.444905882287092,
        14.459891262932917,
        14.474876643578742,
        14.489862024224571,
        14.504847404870397,
        14.519832785516222,
        14.534818166162047,
        14.549803546807876,
        14.564788927453701,
        14.579774308099527,
        14.594759688745352,
        14.609745069391177,
        14.624730450037006,
        14.639715830682832,
        14.654701211328657,
        14.669686591974482,
        14.684671972620311,
        14.699657353266137,
        14.714642733911962,
        14.729628114557787,
        14.744613495203616,
        14.759598875849441,
        14.774584256495267,
        14.789569637141092,
        14.804555017786921,
        14.819540398432746,
        14.834525779078572,
        14.849511159724397,
        14.864496540370222,
        14.879481921016051,
        14.894467301661876,
        14.909452682307702,
        14.924438062953527,
        14.939423443599356,
        14.954408824245181,
        14.969394204891007,
        14.984379585536832,
        14.999364966182661,
        15.014350346828486,
        15.029335727474312,
        15.044321108120137,
        15.059306488765962,
        15.074291869411791,
        15.089277250057616,
        15.104262630703442,
        15.119248011349267,
        15.134233391995096,
        15.149218772640921,
        15.164204153286747,
        15.179189533932572,
        15.1941749145784,
        15.209160295224226,
        15.224145675870052,
        15.239131056515877,
        15.254116437161702,
        15.269101817807531,
        15.284087198453356,
        15.299072579099182,
        15.314057959745007,
        15.329043340390836,
        15.344028721036661,
        15.359014101682487,
        15.373999482328312,
        15.38898486297414,
        15.403970243619966,
        15.418955624265791,
        15.433941004911617,
        15.448926385557442,
        15.463911766203271,
        15.478897146849096,
        15.493882527494922,
        15.508867908140747,
        15.523853288786576,
        15.538838669432401,
        15.553824050078227,
        15.568809430724052,
        15.58379481136988,
        15.598780192015706,
        15.613765572661531,
        15.628750953307357,
        15.643736333953182,
        15.658721714599011,
        15.673707095244836,
        15.688692475890662,
        15.703677856536487,
        15.718663237182316,
        15.733648617828141,
        15.748633998473966,
        15.763619379119792,
        15.77860475976562,
        15.793590140411446,
        15.808575521057271,
        15.823560901703097,
        15.838546282348926,
        15.853531662994751,
        15.868517043640576,
        15.883502424286402,
        15.898487804932227,
        15.913473185578056,
        15.928458566223881,
        15.943443946869706,
        15.958429327515532,
        15.97341470816136,
        15.988400088807186,
        16.00338546945301,
        16.018370850098837,
        16.033356230744666,
        16.04834161139049,
        16.063326992036316,
        16.07831237268214,
        16.093297753327967,
        16.108283133973796,
        16.12326851461962,
        16.138253895265446,
        16.15323927591127,
        16.1682246565571,
        16.183210037202926,
        16.19819541784875,
        16.213180798494577,
        16.228166179140405,
        16.24315155978623,
        16.258136940432056,
        16.27312232107788,
        16.288107701723707,
        16.303093082369536,
        16.31807846301536,
        16.333063843661186,
        16.34804922430701,
        16.36303460495284,
        16.378019985598666,
        16.39300536624449,
        16.407990746890317,
        16.422976127536145,
        16.43796150818197,
        16.452946888827796,
        16.46793226947362,
        16.482917650119447,
        16.497903030765276,
        16.5128884114111,
        16.527873792056926,
        16.54285917270275,
        16.55784455334858,
        16.572829933994406,
        16.58781531464023,
        16.602800695286057,
        16.617786075931885,
        16.63277145657771,
        16.647756837223536,
        16.66274221786936,
        16.677727598515187,
        16.692712979161016,
        16.70769835980684,
        16.722683740452666,
        16.73766912109849,
        16.75265450174432,
        16.767639882390146,
        16.78262526303597,
        16.797610643681796,
        16.812596024327625,
        16.82758140497345,
        16.842566785619276,
        16.8575521662651,
        16.87253754691093,
        16.887522927556756,
        16.90250830820258,
        16.917493688848406,
        16.93247906949423,
        16.94746445014006,
        16.962449830785886,
        16.97743521143171,
        16.992420592077536,
        17.007405972723365,
        17.02239135336919,
        17.037376734015016,
        17.05236211466084,
        17.06734749530667,
        17.082332875952495,
        17.09731825659832,
        17.112303637244146,
        17.12728901788997,
        17.1422743985358,
        17.157259779181626,
        17.17224515982745,
        17.187230540473276,
        17.202215921119105,
        17.21720130176493,
        17.232186682410756,
        17.24717206305658,
        17.26215744370241,
        17.277142824348235,
        17.29212820499406,
        17.307113585639886,
        17.32209896628571,
        17.33708434693154,
        17.352069727577366,
        17.36705510822319,
        17.382040488869016,
        17.397025869514845,
        17.41201125016067,
        17.426996630806496,
        17.44198201145232,
        17.45696739209815,
        17.471952772743975,
        17.4869381533898,
        17.501923534035626,
        17.51690891468145,
        17.53189429532728,
        17.546879675973106,
        17.56186505661893,
        17.576850437264756,
        17.591835817910585,
        17.60682119855641,
        17.621806579202236,
        17.63679195984806,
        17.65177734049389,
        17.666762721139715,
        17.68174810178554,
        17.696733482431366,
        17.71171886307719,
        17.72670424372302,
        17.741689624368846,
        17.75667500501467,
        17.771660385660496,
        17.786645766306325,
        17.80163114695215,
        17.816616527597976,
        17.8316019082438,
        17.84658728888963,
        17.861572669535455,
        17.87655805018128,
        17.891543430827106,
        17.906528811472935,
        17.92151419211876,
        17.936499572764586,
        17.95148495341041,
        17.966470334056236,
        17.981455714702065,
        17.99644109534789,
        18.011426475993716,
        18.02641185663954,
        18.04139723728537,
        18.056382617931195,
        18.07136799857702,
        18.086353379222846,
        18.101338759868675,
        18.1163241405145,
        18.131309521160325,
        18.14629490180615,
        18.161280282451976,
        18.176265663097805,
        18.19125104374363,
        18.206236424389456,
        18.22122180503528,
        18.23620718568111,
        18.251192566326935,
        18.26617794697276,
        18.281163327618586,
        18.296148708264415,
        18.31113408891024,
        18.326119469556065,
        18.34110485020189,
        18.356090230847716,
        18.371075611493545,
        18.38606099213937,
        18.401046372785196,
        18.41603175343102,
        18.43101713407685,
        18.446002514722675,
        18.4609878953685,
        18.475973276014326,
        18.490958656660155,
        18.50594403730598,
        18.520929417951805,
        18.53591479859763,
        18.550900179243456,
        18.565885559889285,
        18.58087094053511,
        18.595856321180936,
        18.61084170182676,
        18.62582708247259,
        18.640812463118415,
        18.65579784376424,
        18.670783224410066,
        18.685768605055895,
        18.70075398570172,
        18.715739366347545,
        18.73072474699337,
        18.7457101276392,
        18.760695508285025,
        18.77568088893085,
        18.790666269576676,
        18.8056516502225,
        18.82063703086833,
        18.835622411514155,
        18.85060779215998,
        18.865593172805806,
        18.880578553451635,
        18.89556393409746,
        18.910549314743285,
        18.92553469538911,
        18.94052007603494,
        18.955505456680765,
        18.97049083732659,
        18.985476217972415,
        19.00046159861824,
        19.01544697926407,
        19.030432359909895,
        19.04541774055572,
        19.060403121201546,
        19.075388501847375,
        19.0903738824932,
        19.105359263139025,
        19.12034464378485,
        19.13533002443068,
        19.150315405076505,
        19.16530078572233,
        19.180286166368155,
        19.19527154701398,
        19.21025692765981,
        19.225242308305635,
        19.24022768895146,
        19.255213069597286,
        19.270198450243115,
        19.28518383088894,
        19.300169211534765,
        19.31515459218059,
        19.33013997282642,
        19.345125353472245,
        19.36011073411807,
        19.375096114763895,
        19.39008149540972,
        19.40506687605555,
        19.420052256701375,
        19.4350376373472,
        19.450023017993026,
        19.465008398638854,
        19.47999377928468,
        19.494979159930505,
        19.50996454057633,
        19.52494992122216,
        19.539935301867985,
        19.55492068251381,
        19.569906063159635,
        19.58489144380546,
        19.59987682445129,
        19.614862205097115,
        19.62984758574294,
        19.644832966388766,
        19.659818347034594,
        19.67480372768042,
        19.689789108326245,
        19.70477448897207,
        19.7197598696179,
        19.734745250263725,
        19.74973063090955,
        19.764716011555375,
        19.779701392201204,
        19.79468677284703,
        19.809672153492855,
        19.82465753413868,
        19.839642914784505,
        19.854628295430334,
        19.86961367607616,
        19.884599056721985,
        19.89958443736781,
        19.91456981801364,
        19.929555198659465,
        19.94454057930529,
        19.959525959951115,
        19.974511340596944,
        19.98949672124277,
        20.004482101888595,
        20.01946748253442,
        20.034452863180245,
        20.049438243826074,
        20.0644236244719,
        20.079409005117725,
        20.09439438576355,
        20.10937976640938,
        20.124365147055205,
        20.13935052770103,
        20.154335908346855,
        20.169321288992684,
        20.18430666963851,
        20.199292050284335,
        20.21427743093016,
        20.229262811575985,
        20.244248192221814,
        20.25923357286764,
        20.274218953513465,
        20.28920433415929,
        20.30418971480512,
        20.319175095450944,
        20.33416047609677,
        20.349145856742595,
        20.364131237388424,
        20.37911661803425,
        20.394101998680075,
        20.4090873793259,
        20.424072759971725,
        20.439058140617554,
        20.45404352126338,
        20.469028901909205,
        20.48401428255503,
        20.49899966320086,
        20.513985043846684,
        20.52897042449251,
        20.543955805138335,
        20.558941185784164,
        20.57392656642999,
        20.588911947075815,
        20.60389732772164,
        20.618882708367465,
        20.633868089013294,
        20.64885346965912,
        20.663838850304945,
        20.67882423095077,
        20.6938096115966,
        20.708794992242424,
        20.72378037288825,
        20.738765753534075,
        20.753751134179904,
        20.76873651482573,
        20.783721895471555,
        20.79870727611738,
        20.81369265676321,
        20.828678037409034,
        20.84366341805486,
        20.858648798700685,
        20.87363417934651,
        20.88861955999234,
        20.903604940638164,
        20.91859032128399,
        20.933575701929815,
        20.948561082575644,
        20.96354646322147,
        20.978531843867295,
        20.99351722451312,
        21.00850260515895,
        21.023487985804774,
        21.0384733664506,
        21.053458747096425,
        21.06844412774225,
        21.08342950838808,
        21.098414889033904,
        21.11340026967973,
        21.128385650325555,
        21.143371030971384,
        21.15835641161721,
        21.173341792263034,
        21.18832717290886,
        21.20331255355469,
        21.218297934200514,
        21.23328331484634,
        21.248268695492165,
        21.26325407613799,
        21.27823945678382,
        21.293224837429644,
        21.30821021807547,
        21.323195598721295,
        21.338180979367124,
        21.35316636001295,
        21.368151740658774,
        21.3831371213046,
        21.39812250195043,
        21.413107882596254,
        21.42809326324208,
        21.443078643887905,
        21.45806402453373,
        21.47304940517956,
        21.488034785825384,
        21.50302016647121,
        21.518005547117035,
        21.532990927762864,
        21.54797630840869,
        21.562961689054514,
        21.57794706970034,
        21.59293245034617,
        21.607917830991994,
        21.62290321163782,
        21.637888592283645,
        21.65287397292947,
        21.6678593535753,
        21.682844734221124,
        21.69783011486695,
        21.712815495512775,
        21.727800876158604,
        21.74278625680443,
        21.757771637450254,
        21.77275701809608,
        21.78774239874191,
        21.802727779387734,
        21.81771316003356,
        21.832698540679385,
        21.847683921325213,
        21.86266930197104,
        21.877654682616864,
        21.89264006326269,
        21.907625443908515,
        21.922610824554344,
        21.93759620520017,
        21.952581585845994,
        21.96756696649182,
        21.98255234713765,
        21.997537727783474,
        22.0125231084293,
        22.027508489075124,
        22.042493869720953,
        22.05747925036678,
        22.072464631012604,
        22.08745001165843,
        22.102435392304255,
        22.117420772950084,
        22.13240615359591,
        22.147391534241734,
        22.16237691488756,
        22.17736229553339,
        22.192347676179214,
        22.20733305682504,
        22.222318437470864,
        22.237303818116693,
        22.25228919876252,
        22.267274579408344,
        22.28225996005417,
        22.297245340699995,
        22.312230721345824,
        22.32721610199165,
        22.342201482637474,
        22.3571868632833,
        22.37217224392913,
        22.387157624574954,
        22.40214300522078,
        22.417128385866604,
        22.432113766512433,
        22.44709914715826,
        22.462084527804084,
        22.47706990844991,
        22.492055289095735,
        22.507040669741563,
        22.52202605038739,
        22.537011431033214,
        22.55199681167904,
        22.56698219232487,
        22.581967572970694,
        22.59695295361652,
        22.611938334262344,
        22.626923714908173,
        22.641909095554,
        22.656894476199824,
        22.67187985684565,
        22.686865237491478,
        22.701850618137303,
        22.71683599878313,
        22.731821379428954,
        22.74680676007478,
        22.76179214072061,
        22.776777521366434,
        22.79176290201226,
        22.806748282658084,
        22.821733663303913,
        22.83671904394974,
        22.851704424595564,
        22.86668980524139,
        22.881675185887218,
        22.896660566533043,
        22.91164594717887,
        22.926631327824694,
        22.94161670847052,
        22.95660208911635,
        22.971587469762174,
        22.986572850408,
        23.001558231053824,
        23.016543611699653,
        23.03152899234548,
        23.046514372991304,
        23.06149975363713,
        23.076485134282958,
        23.091470514928783,
        23.10645589557461,
        23.121441276220434,
        23.13642665686626,
        23.151412037512088,
        23.166397418157914,
        23.18138279880374,
        23.196368179449564,
        23.211353560095393,
        23.22633894074122,
        23.241324321387044,
        23.25630970203287,
        23.271295082678698,
        23.286280463324523,
        23.30126584397035,
        23.316251224616174,
        23.331236605262,
        23.346221985907828,
        23.361207366553653,
        23.37619274719948,
        23.391178127845304,
        23.406163508491133,
        23.42114888913696,
        23.436134269782784,
        23.45111965042861,
        23.466105031074438,
        23.481090411720263,
        23.49607579236609,
        23.511061173011914,
        23.52604655365774,
        23.541031934303568,
        23.556017314949393,
        23.57100269559522,
        23.585988076241044,
        23.600973456886873,
        23.6159588375327,
        23.630944218178524,
        23.64592959882435,
        23.660914979470178,
        23.675900360116003,
        23.69088574076183,
        23.705871121407654,
        23.720856502053483,
        23.735841882699308,
        23.750827263345133,
        23.76581264399096,
        23.780798024636784,
        23.795783405282613,
        23.81076878592844,
        23.825754166574264,
        23.84073954722009,
        23.855724927865918,
        23.870710308511743,
        23.88569568915757,
        23.900681069803394,
        23.915666450449223,
        23.930651831095048,
        23.945637211740873,
        23.9606225923867,
        23.975607973032524,
        23.990593353678353,
        24.005578734324178,
        24.020564114970004,
        24.03554949561583,
        24.050534876261658,
        24.065520256907483,
        24.08050563755331,
        24.095491018199134,
        24.110476398844963,
        24.125461779490788,
        24.140447160136613,
        24.15543254078244,
        24.170417921428264,
        24.185403302074093,
        24.200388682719918,
        24.215374063365743,
        24.23035944401157,
        24.245344824657398,
        24.260330205303223,
        24.27531558594905,
        24.290300966594874,
        24.305286347240703,
        24.320271727886528,
        24.335257108532353,
        24.35024248917818,
        24.365227869824004,
        24.380213250469833,
        24.395198631115658,
        24.410184011761483,
        24.42516939240731,
        24.440154773053138,
        24.455140153698963,
        24.47012553434479,
        24.485110914990614,
        24.500096295636443,
        24.515081676282268,
        24.530067056928093,
        24.54505243757392,
        24.560037818219744,
        24.575023198865573,
        24.590008579511398,
        24.604993960157223,
        24.61997934080305,
        24.634964721448878,
        24.649950102094703,
        24.66493548274053,
        24.679920863386354,
        24.694906244032182,
        24.709891624678008,
        24.724877005323833,
        24.73986238596966,
        24.754847766615487,
        24.769833147261313,
        24.784818527907138,
        24.799803908552963,
        24.81478928919879,
        24.829774669844618,
        24.844760050490443,
        24.859745431136268,
        24.874730811782094,
        24.889716192427922,
        24.904701573073748,
        24.919686953719573,
        24.9346723343654,
        24.949657715011227,
        24.964643095657053,
        24.979628476302878,
        24.994613856948703,
        25.00959923759453,
        25.024584618240358,
        25.039569998886183,
        25.054555379532008,
        25.069540760177834,
        25.084526140823662,
        25.099511521469488,
        25.114496902115313,
        25.12948228276114,
        25.144467663406967,
        25.159453044052793,
        25.174438424698618,
        25.189423805344443,
        25.20440918599027,
        25.219394566636097,
        25.234379947281923,
        25.249365327927748,
        25.264350708573573,
        25.279336089219402,
        25.294321469865228,
        25.309306850511053,
        25.32429223115688,
        25.339277611802707,
        25.354262992448533,
        25.369248373094358,
        25.384233753740183,
        25.39921913438601,
        25.414204515031837,
        25.429189895677663,
        25.444175276323488,
        25.459160656969313,
        25.474146037615142,
        25.489131418260968,
        25.504116798906793,
        25.51910217955262,
        25.534087560198447,
        25.549072940844272,
        25.564058321490098,
        25.579043702135923,
        25.59402908278175,
        25.609014463427577,
        25.623999844073403,
        25.638985224719228,
        25.653970605365053,
        25.668955986010882,
        25.683941366656708,
        25.698926747302533,
        25.71391212794836,
        25.728897508594187,
        25.743882889240012,
        25.758868269885838,
        25.773853650531663,
        25.788839031177492,
        25.803824411823317,
        25.818809792469143,
        25.833795173114968,
        25.848780553760793,
        25.863765934406622,
        25.878751315052448,
        25.893736695698273,
        25.908722076344098,
        25.923707456989927,
        25.938692837635752,
        25.953678218281578,
        25.968663598927403,
        25.983648979573232,
        25.998634360219057,
        26.013619740864883,
        26.028605121510708,
        26.043590502156533,
        26.058575882802362,
        26.073561263448187,
        26.088546644094013,
        26.103532024739838,
        26.118517405385667,
        26.133502786031492,
        26.148488166677318,
        26.163473547323143,
        26.178458927968972,
        26.193444308614797,
        26.208429689260623,
        26.223415069906448,
        26.238400450552273,
        26.253385831198102,
        26.268371211843927,
        26.283356592489753,
        26.298341973135578,
        26.313327353781407,
        26.328312734427232,
        26.343298115073058,
        26.358283495718883,
        26.373268876364712,
        26.388254257010537,
        26.403239637656363,
        26.418225018302188,
        26.433210398948013,
        26.448195779593842,
        26.463181160239667,
        26.478166540885493,
        26.493151921531318,
        26.508137302177147,
        26.523122682822972,
        26.538108063468798,
        26.553093444114623,
        26.568078824760452,
        26.583064205406277,
        26.598049586052102,
        26.613034966697928,
        26.628020347343753,
        26.643005727989582,
        26.657991108635407,
        26.672976489281233,
        26.687961869927058,
        26.702947250572887,
        26.717932631218712,
        26.732918011864538,
        26.747903392510363,
        26.76288877315619,
        26.777874153802017,
        26.792859534447842,
        26.807844915093668,
        26.822830295739497,
        26.837815676385322,
        26.852801057031147,
        26.867786437676973,
        26.882771818322798,
        26.897757198968627,
        26.912742579614452,
        26.927727960260277,
        26.942713340906103,
        26.95769872155193,
        26.972684102197757,
        26.987669482843582,
        27.002654863489408,
        27.017640244135237,
        27.032625624781062,
        27.047611005426887,
        27.062596386072713,
        27.077581766718538,
        27.092567147364367,
        27.107552528010192,
        27.122537908656017,
        27.137523289301843,
        27.15250866994767,
        27.167494050593497,
        27.182479431239322,
        27.197464811885148,
        27.212450192530977,
        27.227435573176802,
        27.242420953822627,
        27.257406334468453,
        27.272391715114278,
        27.287377095760107,
        27.302362476405932,
        27.317347857051757,
        27.332333237697583,
        27.34731861834341,
        27.362303998989237,
        27.377289379635062,
        27.392274760280888,
        27.407260140926716,
        27.422245521572542,
        27.437230902218367,
        27.452216282864192,
        27.467201663510018,
        27.482187044155847,
        27.497172424801672,
        27.512157805447497,
        27.527143186093323,
        27.54212856673915,
        27.557113947384977,
        27.572099328030802,
        27.587084708676628,
        27.602070089322456,
        27.61705546996828,
        27.632040850614107,
        27.647026231259932,
        27.66201161190576,
        27.676996992551587,
        27.691982373197412,
        27.706967753843237,
        27.721953134489063,
        27.73693851513489,
        27.751923895780717,
        27.766909276426542,
        27.781894657072367,
        27.796880037718196,
        27.81186541836402,
        27.826850799009847,
        27.841836179655672,
        27.8568215603015,
        27.871806940947327,
        27.886792321593152,
        27.901777702238977,
        27.916763082884803,
        27.93174846353063,
        27.946733844176457,
        27.961719224822282,
        27.976704605468107,
        27.991689986113936,
        28.00667536675976,
        28.021660747405587,
        28.036646128051412,
        28.05163150869724,
        28.066616889343067,
        28.081602269988892,
        28.096587650634717,
        28.111573031280543,
        28.12655841192637,
        28.141543792572197,
        28.156529173218022,
        28.171514553863847,
        28.186499934509676,
        28.2014853151555,
        28.216470695801327,
        28.231456076447152,
        28.24644145709298,
        28.261426837738806,
        28.276412218384632,
        28.291397599030457,
        28.306382979676282,
        28.32136836032211,
        28.336353740967937,
        28.351339121613762,
        28.366324502259587,
        28.381309882905416,
        28.39629526355124,
        28.411280644197067,
        28.426266024842892,
        28.44125140548872,
        28.456236786134546,
        28.47122216678037,
        28.486207547426197,
        28.501192928072022,
        28.51617830871785,
        28.531163689363677,
        28.546149070009502,
        28.561134450655327,
        28.576119831301156,
        28.59110521194698,
        28.606090592592807,
        28.621075973238632,
        28.63606135388446,
        28.651046734530286,
        28.66603211517611,
        28.681017495821937,
        28.696002876467766,
        28.71098825711359,
        28.725973637759417,
        28.740959018405242,
        28.755944399051067,
        28.770929779696896,
        28.78591516034272,
        28.800900540988547,
        28.815885921634372,
        28.8308713022802,
        28.845856682926026,
        28.86084206357185,
        28.875827444217677,
        28.890812824863506,
        28.90579820550933,
        28.920783586155157,
        28.935768966800982,
        28.950754347446807,
        28.965739728092636,
        28.98072510873846,
        28.995710489384287,
        29.010695870030112,
        29.02568125067594,
        29.040666631321766,
        29.05565201196759,
        29.070637392613417,
        29.085622773259246,
        29.10060815390507,
        29.115593534550896,
        29.130578915196722,
        29.145564295842547,
        29.160549676488376,
        29.1755350571342,
        29.190520437780027,
        29.205505818425852,
        29.22049119907168,
        29.235476579717506,
        29.25046196036333,
        29.265447341009157,
        29.280432721654986,
        29.29541810230081,
        29.310403482946636,
        29.32538886359246,
        29.340374244238287,
        29.355359624884116,
        29.37034500552994,
        29.385330386175767,
        29.400315766821592,
        29.41530114746742,
        29.430286528113246,
        29.44527190875907,
        29.460257289404897,
        29.475242670050726,
        29.49022805069655,
        29.505213431342376,
        29.5201988119882,
        29.535184192634027,
        29.550169573279856,
        29.56515495392568,
        29.580140334571507,
        29.595125715217332,
        29.61011109586316,
        29.625096476508986,
        29.64008185715481,
        29.655067237800637,
        29.670052618446466,
        29.68503799909229,
        29.700023379738116,
        29.71500876038394,
        29.72999414102977,
        29.744979521675596,
        29.75996490232142,
        29.774950282967247,
        29.789935663613072,
        29.8049210442589,
        29.819906424904726,
        29.83489180555055,
        29.849877186196377,
        29.864862566842206,
        29.87984794748803,
        29.894833328133856,
        29.90981870877968,
        29.92480408942551,
        29.939789470071336,
        29.95477485071716,
        29.969760231362987,
        29.984745612008812,
        29.99973099265464,
        30.014716373300466,
        30.02970175394629,
        30.044687134592117,
        30.059672515237946,
        30.07465789588377,
        30.089643276529596,
        30.10462865717542,
        30.11961403782125,
        30.134599418467076,
        30.1495847991129,
        30.164570179758726,
        30.179555560404552,
        30.19454094105038,
        30.209526321696206,
        30.22451170234203,
        30.239497082987857,
        30.254482463633686,
        30.26946784427951,
        30.284453224925336,
        30.29943860557116,
        30.31442398621699,
        30.329409366862816,
        30.34439474750864,
        30.359380128154466,
        30.37436550880029,
        30.38935088944612,
        30.404336270091946,
        30.41932165073777,
        30.4343070313836,
        30.449292412029425,
        30.46427779267525,
        30.479263173321076,
        30.4942485539669,
        30.509233934612727,
        30.524219315258552,
        30.539204695904385,
        30.55419007655021,
        30.569175457196035,
        30.58416083784186,
        30.599146218487686,
        30.61413159913351,
        30.629116979779337,
        30.644102360425162,
        30.659087741070987,
        30.67407312171682,
        30.689058502362645,
        30.70404388300847,
        30.719029263654296,
        30.73401464430012,
        30.749000024945946,
        30.76398540559177,
        30.778970786237597,
        30.793956166883422,
        30.808941547529255,
        30.82392692817508,
        30.838912308820905,
        30.85389768946673,
        30.868883070112556,
        30.88386845075838,
        30.898853831404207,
        30.913839212050032,
        30.928824592695864,
        30.94380997334169,
        30.958795353987515,
        30.97378073463334,
        30.988766115279166,
        31.00375149592499,
        31.018736876570816,
        31.033722257216642,
        31.048707637862467,
        31.0636930185083,
        31.078678399154125,
        31.09366377979995,
        31.108649160445776,
        31.1236345410916,
        31.138619921737426,
        31.15360530238325,
        31.168590683029077,
        31.18357606367491,
        31.198561444320735,
        31.21354682496656,
        31.228532205612385,
        31.24351758625821,
        31.258502966904036,
        31.27348834754986,
        31.288473728195687,
        31.303459108841512,
        31.318444489487344,
        31.33342987013317,
        31.348415250778995,
        31.36340063142482,
        31.378386012070646,
        31.39337139271647,
        31.408356773362296,
        31.42334215400812,
        31.438327534653947,
        31.45331291529978,
        31.468298295945605,
        31.48328367659143,
        31.498269057237255,
        31.51325443788308,
        31.528239818528906,
        31.54322519917473,
        31.558210579820557,
        31.57319596046639,
        31.588181341112215,
        31.60316672175804,
        31.618152102403865,
        31.63313748304969,
        31.648122863695516,
        31.66310824434134,
        31.678093624987167,
        31.693079005632992,
        31.708064386278824,
        31.72304976692465,
        31.738035147570475,
        31.7530205282163,
        31.768005908862126,
        31.78299128950795,
        31.797976670153776,
        31.8129620507996,
        31.827947431445427,
        31.84293281209126,
        31.857918192737085,
        31.87290357338291,
        31.887888954028735,
        31.90287433467456,
        31.917859715320386,
        31.93284509596621,
        31.947830476612037,
        31.96281585725787,
        31.977801237903694,
        31.99278661854952,
        32.00777199919534,
        32.02275737984117,
        32.03774276048699,
        32.05272814113282,
        32.06771352177864,
        32.08269890242447,
        32.0976842830703,
        32.112669663716126,
        32.12765504436195,
        32.14264042500778,
        32.1576258056536,
        32.17261118629943,
        32.18759656694525,
        32.20258194759108,
        32.21756732823691,
        32.232552708882736,
        32.24753808952856,
        32.262523470174386,
        32.27750885082021,
        32.29249423146604,
        32.30747961211186,
        32.32246499275769,
        32.33745037340351,
        32.352435754049345,
        32.36742113469517,
        32.382406515340996,
        32.39739189598682,
        32.41237727663265,
        32.42736265727847,
        32.4423480379243,
        32.45733341857012,
        32.47231879921595,
        32.48730417986178,
        32.502289560507606,
        32.51727494115343,
        32.53226032179926,
        32.54724570244508,
        32.56223108309091,
        32.57721646373673,
        32.59220184438256,
        32.60718722502839,
        32.622172605674216,
        32.63715798632004,
        32.652143366965866,
        32.66712874761169,
        32.68211412825752,
        32.69709950890334,
        32.71208488954917,
        32.72707027019499,
        32.742055650840825,
        32.75704103148665,
        32.772026412132476,
        32.7870117927783,
        32.80199717342413,
        32.81698255406995,
        32.83196793471578,
        32.8469533153616,
        32.86193869600743,
        32.87692407665326,
        32.891909457299086,
        32.90689483794491,
        32.921880218590736,
        32.93686559923656,
        32.95185097988239,
        32.96683636052821,
        32.98182174117404,
        32.99680712181987,
        33.011792502465696,
        33.02677788311152,
        33.041763263757346,
        33.05674864440317,
        33.071734025049,
        33.08671940569482,
        33.10170478634065,
        33.11669016698647,
        33.131675547632305,
        33.14666092827813,
        33.161646308923956,
        33.17663168956978,
        33.19161707021561,
        33.20660245086143,
        33.22158783150726,
        33.23657321215308,
        33.251558592798915,
        33.26654397344474,
        33.281529354090566,
        33.29651473473639,
        33.311500115382216,
        33.32648549602804,
        33.34147087667387,
        33.35645625731969,
        33.37144163796552,
        33.38642701861135,
        33.401412399257175,
        33.416397779903,
        33.431383160548826,
        33.44636854119465,
        33.46135392184048,
        33.4763393024863,
        33.49132468313213,
        33.50631006377795,
        33.521295444423785,
        33.53628082506961,
        33.551266205715436,
        33.56625158636126,
        33.58123696700709,
        33.59622234765291,
        33.61120772829874,
        33.62619310894456,
        33.641178489590395,
        33.65616387023622,
        33.671149250882046,
        33.68613463152787,
        33.701120012173696,
        33.71610539281952,
        33.73109077346535,
        33.74607615411117,
        33.761061534757,
        33.77604691540283,
        33.791032296048655,
        33.80601767669448,
        33.821003057340306,
        33.83598843798613,
        33.85097381863196,
        33.86595919927778,
        33.88094457992361,
        33.89592996056943,
        33.910915341215265,
        33.92590072186109,
        33.940886102506916,
        33.95587148315274,
        33.970856863798566,
        33.98584224444439,
        34.00082762509022,
        34.01581300573604,
        34.030798386381875,
        34.0457837670277,
        34.060769147673525,
        34.07575452831935,
        34.090739908965176,
        34.105725289611,
        34.12071067025683,
        34.13569605090265,
        34.15068143154848,
        34.16566681219431,
        34.180652192840135,
        34.19563757348596,
        34.210622954131786,
        34.22560833477761,
        34.24059371542344,
        34.25557909606926,
        34.27056447671509,
        34.28554985736092,
        34.300535238006745,
        34.31552061865257,
        34.330505999298396,
        34.34549137994422,
        34.360476760590046,
        34.37546214123587,
        34.3904475218817,
        34.40543290252752,
        34.420418283173355,
        34.43540366381918,
        34.450389044465005,
        34.46537442511083,
        34.480359805756656,
        34.49534518640248,
        34.51033056704831,
        34.52531594769413,
        34.54030132833996,
        34.55528670898579,
        34.570272089631615,
        34.58525747027744,
        34.600242850923266,
        34.61522823156909,
        34.63021361221492,
        34.64519899286074,
        34.66018437350657,
        34.6751697541524,
        34.690155134798225,
        34.70514051544405,
        34.720125896089876,
        34.7351112767357,
        34.750096657381526,
        34.76508203802735,
        34.78006741867318,
        34.795052799319,
        34.810038179964835,
        34.82502356061066,
        34.840008941256485,
        34.85499432190231,
        34.869979702548136,
        34.88496508319396,
        34.89995046383979,
        34.91493584448561,
        34.92992122513144,
        34.94490660577727,
        34.959891986423095,
        34.97487736706892,
        34.989862747714746,
        35.00484812836057,
        35.019833509006396,
        35.03481888965222,
        35.04980427029805,
        35.06478965094388,
        35.079775031589705,
        35.09476041223553,
        35.109745792881355,
        35.12473117352718,
        35.139716554173006,
        35.15470193481883,
        35.16968731546466,
        35.18467269611048,
        35.199658076756315,
        35.21464345740214,
        35.229628838047965,
        35.24461421869379,
        35.259599599339616,
        35.27458497998544,
        35.28957036063127,
        35.30455574127709,
        35.319541121922924,
        35.33452650256875,
        35.349511883214575,
        35.3644972638604,
        35.379482644506226,
        35.39446802515205,
        35.409453405797876,
        35.4244387864437,
        35.43942416708953,
        35.45440954773536,
        35.469394928381185,
        35.48438030902701,
        35.499365689672835,
        35.51435107031866,
        35.529336450964486,
        35.54432183161031,
        35.55930721225614,
        35.57429259290196,
        35.589277973547794,
        35.60426335419362,
        35.619248734839445,
        35.63423411548527,
        35.649219496131096,
        35.66420487677692,
        35.679190257422746,
        35.69417563806857,
        35.709161018714404,
        35.72414639936023,
        35.739131780006055,
        35.75411716065188,
        35.769102541297705,
        35.78408792194353,
        35.799073302589356,
        35.81405868323518,
        35.82904406388101,
        35.84402944452684,
        35.859014825172665,
        35.87400020581849,
        35.888985586464315,
        35.90397096711014,
        35.918956347755966,
        35.93394172840179,
        35.94892710904762,
        35.96391248969344,
        35.978897870339274,
        35.9938832509851,
        36.008868631630925,
        36.02385401227675,
        36.038839392922576,
        36.0538247735684,
        36.068810154214226,
        36.08379553486005,
        36.098780915505884,
        36.11376629615171,
        36.128751676797535,
        36.14373705744336,
        36.158722438089185,
        36.17370781873501,
        36.188693199380836,
        36.20367858002666,
        36.21866396067249,
        36.23364934131832,
        36.248634721964144,
        36.26362010260997,
        36.278605483255795,
        36.29359086390162,
        36.308576244547446,
        36.32356162519327,
        36.3385470058391,
        36.35353238648493,
        36.368517767130754,
        36.38350314777658,
        36.398488528422405,
        36.41347390906823,
        36.428459289714056,
        36.44344467035988,
        36.458430051005706,
        36.47341543165153,
        36.488400812297364,
        36.50338619294319,
        36.518371573589015,
        36.53335695423484,
        36.548342334880665,
        36.56332771552649,
        36.578313096172316,
        36.59329847681814,
        36.60828385746397,
        36.6232692381098,
        36.638254618755624,
        36.65323999940145,
        36.668225380047275,
        36.6832107606931,
        36.698196141338926,
        36.71318152198475,
        36.728166902630576,
        36.74315228327641,
        36.758137663922234,
        36.77312304456806,
        36.788108425213885,
        36.80309380585971,
        36.818079186505535,
        36.83306456715136,
        36.848049947797186,
        36.86303532844301,
        36.878020709088844,
        36.89300608973467,
        36.907991470380495,
        36.92297685102632,
        36.937962231672145,
        36.95294761231797,
        36.967932992963796,
        36.98291837360962,
        36.99790375425545,
        37.01288913490128,
        37.027874515547104,
        37.04285989619293,
        37.057845276838755,
        37.07283065748458,
        37.087816038130406,
        37.10280141877623,
        37.117786799422056,
        37.13277218006789,
        37.147757560713714,
        37.16274294135954,
        37.177728322005365,
        37.19271370265119,
        37.207699083297015,
        37.22268446394284,
        37.237669844588666,
        37.25265522523449,
        37.267640605880324,
        37.28262598652615,
        37.297611367171974,
        37.3125967478178,
        37.327582128463625,
        37.34256750910945,
        37.357552889755276,
        37.3725382704011,
        37.38752365104693,
        37.40250903169276,
        37.417494412338584,
        37.43247979298441,
        37.447465173630235,
        37.46245055427606,
        37.477435934921886,
        37.49242131556771,
        37.507406696213536,
        37.52239207685937,
        37.537377457505194,
        37.55236283815102,
        37.567348218796845,
        37.58233359944267,
        37.597318980088495,
        37.61230436073432,
        37.627289741380146,
        37.64227512202597,
        37.657260502671804,
        37.67224588331763,
        37.687231263963454,
        37.70221664460928,
        37.717202025255105,
        37.73218740590093,
        37.747172786546756,
        37.76215816719258,
        37.77714354783841,
        37.79212892848424,
        37.807114309130064,
        37.82209968977589,
        37.837085070421715,
        37.85207045106754,
        37.867055831713365,
        37.88204121235919,
        37.897026593005016,
        37.91201197365085,
        37.926997354296674,
        37.9419827349425,
        37.956968115588325,
        37.97195349623415,
        37.986938876879975,
        38.0019242575258,
        38.016909638171626,
        38.03189501881746,
        38.046880399463284,
        38.06186578010911,
        38.076851160754934,
        38.09183654140076,
        38.106821922046585,
        38.12180730269241,
        38.136792683338236,
        38.15177806398406,
        38.16676344462989,
        38.18174882527572,
        38.196734205921544,
        38.21171958656737,
        38.226704967213195,
        38.24169034785902,
        38.256675728504845,
        38.27166110915067,
        38.286646489796496,
        38.30163187044233,
        38.316617251088154,
        38.33160263173398,
        38.346588012379804,
        38.36157339302563,
        38.376558773671455,
        38.39154415431728,
        38.406529534963106,
        38.42151491560894,
        38.43650029625476,
        38.45148567690059,
        38.466471057546414,
        38.48145643819224,
        38.496441818838065,
        38.51142719948389,
        38.526412580129715,
        38.54139796077554,
        38.55638334142137,
        38.5713687220672,
        38.586354102713024,
        38.60133948335885,
        38.616324864004675,
        38.6313102446505,
        38.646295625296325,
        38.66128100594215,
        38.676266386587976,
        38.69125176723381,
        38.706237147879634,
        38.72122252852546,
        38.736207909171284,
        38.75119328981711,
        38.766178670462935,
        38.78116405110876,
        38.796149431754586,
        38.81113481240042,
        38.82612019304624,
        38.84110557369207,
        38.856090954337894,
        38.87107633498372,
        38.886061715629545,
        38.90104709627537,
        38.916032476921195,
        38.93101785756702,
        38.94600323821285,
        38.96098861885868,
        38.975973999504504,
        38.99095938015033,
        39.005944760796154,
        39.02093014144198,
        39.035915522087805,
        39.05090090273363,
        39.06588628337946,
        39.08087166402529,
        39.095857044671114,
        39.11084242531694,
        39.125827805962764,
        39.14081318660859,
        39.155798567254415,
        39.17078394790024,
        39.185769328546066,
        39.2007547091919,
        39.21574008983772,
        39.23072547048355,
        39.245710851129374,
        39.2606962317752,
        39.275681612421025,
        39.29066699306685,
        39.305652373712675,
        39.3206377543585,
        39.33562313500433,
        39.35060851565016,
        39.365593896295984,
        39.38057927694181,
        39.395564657587634,
        39.41055003823346,
        39.425535418879285,
        39.44052079952511,
        39.45550618017094,
        39.47049156081677,
        39.48547694146259,
        39.50046232210842,
        39.515447702754244,
        39.53043308340007,
        39.545418464045895,
        39.56040384469172,
        39.575389225337545,
        39.59037460598338,
        39.6053599866292,
        39.62034536727503,
        39.635330747920854,
        39.65031612856668,
        39.665301509212505,
        39.68028688985833,
        39.695272270504155,
        39.71025765114998,
        39.72524303179581,
        39.74022841244164,
        39.755213793087464,
        39.77019917373329,
        39.785184554379114,
        39.80016993502494,
        39.815155315670765,
        39.83014069631659,
        39.84512607696242,
        39.86011145760825,
        39.87509683825407,
        39.8900822188999,
        39.905067599545724,
        39.92005298019155,
        39.935038360837375,
        39.9500237414832,
        39.965009122129025,
        39.97999450277486,
        39.99497988342068,
        40.00996526406651,
        40.024950644712334,
        40.03993602535816,
        40.054921406003984,
        40.06990678664981,
        40.084892167295635,
        40.09987754794147,
        40.11486292858729,
        40.12984830923312,
        40.14483368987894,
        40.15981907052477,
        40.174804451170594,
        40.18978983181642,
        40.204775212462245,
        40.21976059310807,
        40.2347459737539,
        40.24973135439973,
        40.26471673504555,
        40.27970211569138,
        40.294687496337204,
        40.30967287698303,
        40.324658257628855,
        40.33964363827468,
        40.354629018920505,
        40.36961439956634,
        40.38459978021216,
        40.39958516085799,
        40.414570541503814,
        40.42955592214964,
        40.444541302795464,
        40.45952668344129,
        40.474512064087115,
        40.48949744473295,
        40.50448282537877,
        40.5194682060246,
        40.53445358667042,
        40.54943896731625,
        40.564424347962074,
        40.5794097286079,
        40.594395109253725,
        40.60938048989955,
        40.62436587054538,
        40.63935125119121,
        40.65433663183703,
        40.66932201248286,
        40.684307393128684,
        40.69929277377451,
        40.714278154420334,
        40.72926353506616,
        40.744248915711985,
        40.75923429635782,
        40.77421967700364,
        40.78920505764947,
        40.804190438295294,
        40.81917581894112,
        40.834161199586944,
        40.84914658023277,
        40.864131960878595,
        40.87911734152443,
        40.89410272217025,
        40.90908810281608,
        40.9240734834619,
        40.93905886410773,
        40.954044244753554,
        40.96902962539938,
        40.984015006045205,
        40.99900038669103,
        41.01398576733686,
        41.02897114798269,
        41.04395652862851,
        41.05894190927434,
        41.073927289920164,
        41.08891267056599,
        41.103898051211814,
        41.11888343185764,
        41.13386881250347,
        41.1488541931493,
        41.16383957379512,
        41.17882495444095,
        41.19381033508677,
        41.2087957157326,
        41.223781096378424,
        41.23876647702425,
        41.253751857670075,
        41.26873723831591,
        41.28372261896173,
        41.29870799960756,
        41.31369338025338,
        41.32867876089921,
        41.343664141545034,
        41.35864952219086,
        41.373634902836685,
        41.38862028348251,
        41.40360566412834,
        41.41859104477417,
        41.43357642541999,
        41.44856180606582,
        41.463547186711644,
        41.47853256735747,
        41.493517948003294,
        41.50850332864912,
        41.52348870929495,
        41.53847408994078,
        41.5534594705866,
        41.56844485123243,
        41.58343023187825,
        41.59841561252408,
        41.613400993169904,
        41.62838637381573,
        41.643371754461555,
        41.65835713510739,
        41.67334251575321,
        41.68832789639904,
        41.70331327704486,
        41.71829865769069,
        41.733284038336514,
        41.74826941898234,
        41.763254799628164,
        41.77824018027399,
        41.79322556091982,
        41.80821094156565,
        41.82319632221147,
        41.8381817028573,
        41.85316708350312,
        41.86815246414895,
        41.883137844794774,
        41.8981232254406,
        41.91310860608643,
        41.92809398673226,
        41.94307936737808,
        41.95806474802391,
        41.97305012866973,
        41.98803550931556,
        42.003020889961384,
        42.01800627060721,
        42.032991651253035,
        42.04797703189887,
        42.06296241254469,
        42.07794779319052,
        42.09293317383634,
        42.10791855448217,
        42.122903935127994,
        42.13788931577382,
        42.152874696419644,
        42.16786007706548,
        42.1828454577113,
        42.19783083835713,
        42.21281621900295,
        42.22780159964878,
        42.2427869802946,
        42.25777236094043,
        42.272757741586254,
        42.28774312223208,
        42.30272850287791,
        42.31771388352374,
        42.33269926416956,
        42.34768464481539,
        42.36267002546121,
        42.37765540610704,
        42.392640786752864,
        42.40762616739869,
        42.422611548044515,
        42.43759692869035,
        42.45258230933617,
        42.467567689982,
        42.48255307062782,
        42.49753845127365,
        42.512523831919474,
        42.5275092125653,
        42.542494593211124,
        42.55747997385696,
        42.57246535450278,
        42.58745073514861,
        42.60243611579443,
        42.61742149644026,
        42.63240687708608,
        42.64739225773191,
        42.662377638377734,
        42.67736301902356,
        42.69234839966939,
        42.70733378031522,
        42.72231916096104,
        42.73730454160687,
        42.75228992225269,
        42.76727530289852,
        42.782260683544344,
        42.79724606419017,
        42.812231444835994,
        42.82721682548183,
        42.84220220612765,
        42.85718758677348,
        42.8721729674193,
        42.88715834806513,
        42.90214372871095,
        42.91712910935678,
        42.932114490002604,
        42.94709987064844,
        42.96208525129426,
        42.97707063194009,
        42.99205601258591,
        43.00704139323174,
        43.02202677387756,
        43.03701215452339,
        43.051997535169214,
        43.06698291581504,
        43.08196829646087,
        43.0969536771067,
        43.11193905775252,
        43.12692443839835,
        43.14190981904417,
        43.15689519969,
        43.171880580335824,
        43.18686596098165,
        43.20185134162748,
        43.21683672227331,
        43.23182210291913,
        43.24680748356496,
        43.26179286421078,
        43.27677824485661,
        43.29176362550243,
        43.30674900614826,
        43.321734386794084,
        43.33671976743992,
        43.35170514808574,
        43.36669052873157,
        43.38167590937739,
        43.39666129002322,
        43.41164667066904,
        43.42663205131487,
        43.441617431960694,
        43.45660281260652,
        43.47158819325235,
        43.48657357389818,
        43.501558954544,
        43.51654433518983,
        43.53152971583565,
        43.54651509648148,
        43.561500477127304,
        43.57648585777313,
        43.59147123841896,
        43.60645661906479,
        43.62144199971061,
        43.63642738035644,
        43.65141276100226,
        43.66639814164809,
        43.68138352229391,
        43.69636890293974,
        43.711354283585564,
        43.726339664231396,
        43.74132504487722,
        43.75631042552305,
        43.77129580616887,
        43.7862811868147,
        43.80126656746052,
        43.81625194810635,
        43.831237328752174,
        43.846222709398,
        43.86120809004383,
        43.87619347068966,
        43.89117885133548,
        43.90616423198131,
        43.92114961262713,
        43.93613499327296,
        43.95112037391878,
        43.96610575456461,
        43.98109113521044,
        43.99607651585627,
        44.01106189650209,
        44.02604727714792,
        44.04103265779374,
        44.05601803843957,
        44.07100341908539,
        44.08598879973122,
        44.100974180377044,
        44.115959561022876,
        44.1309449416687,
        44.14593032231453,
        44.16091570296035,
        44.17590108360618,
        44.190886464252,
        44.20587184489783,
        44.220857225543654,
        44.235842606189486,
        44.25082798683531,
        44.26581336748114,
        44.28079874812696,
        44.29578412877279,
        44.31076950941861,
        44.32575489006444,
        44.34074027071026,
        44.35572565135609,
        44.37071103200192,
        44.38569641264775,
        44.40068179329357,
        44.4156671739394,
        44.43065255458522,
        44.44563793523105,
        44.46062331587687,
        44.4756086965227,
        44.490594077168524,
        44.505579457814356,
        44.52056483846018,
        44.53555021910601,
        44.55053559975183,
        44.56552098039766,
        44.58050636104348,
        44.59549174168931,
        44.61047712233513,
        44.625462502980966,
        44.64044788362679,
        44.65543326427262,
        44.67041864491844,
        44.68540402556427,
        44.70038940621009,
        44.71537478685592,
        44.73036016750174,
        44.74534554814757,
        44.7603309287934,
        44.775316309439226,
        44.79030169008505,
        44.80528707073088,
        44.8202724513767,
        44.83525783202253,
        44.85024321266835,
        44.86522859331418,
        44.880213973960004,
        44.895199354605836,
        44.91018473525166,
        44.92517011589749,
        44.94015549654331,
        44.95514087718914,
        44.97012625783496,
        44.98511163848079,
        45.00009701912661,
        45.015082399772446,
        45.03006778041827,
        45.0450531610641,
        45.06003854170992,
        45.07502392235575,
        45.09000930300157,
        45.1049946836474,
        45.11998006429322,
        45.13496544493905,
        45.14995082558488,
        45.164936206230706,
        45.17992158687653,
        45.19490696752236,
        45.20989234816818,
        45.22487772881401,
        45.23986310945983,
        45.25484849010566,
        45.26983387075149,
        45.284819251397316,
        45.29980463204314,
        45.31479001268897,
        45.32977539333479,
        45.34476077398062,
        45.35974615462644,
        45.37473153527227,
        45.38971691591809,
        45.404702296563926,
        45.41968767720975,
        45.434673057855576,
        45.4496584385014,
        45.46464381914723,
        45.47962919979305,
        45.49461458043888,
        45.5095999610847,
        45.52458534173053,
        45.53957072237636,
        45.554556103022186,
        45.56954148366801,
        45.58452686431384,
        45.59951224495966,
        45.61449762560549,
        45.62948300625131,
        45.64446838689714,
        45.65945376754297,
        45.674439148188796,
        45.68942452883462,
        45.70440990948045,
        45.71939529012627,
        45.7343806707721,
        45.74936605141792,
        45.76435143206375,
        45.77933681270957,
        45.794322193355406,
        45.80930757400123,
        45.824292954647056,
        45.83927833529288,
        45.85426371593871,
        45.86924909658453,
        45.88423447723036,
        45.89921985787618,
        45.91420523852201,
        45.92919061916784,
        45.944175999813666,
        45.95916138045949,
        45.97414676110532,
        45.98913214175114,
        46.00411752239697,
        46.01910290304279,
        46.03408828368862,
        46.04907366433445,
        46.064059044980276,
        46.0790444256261,
        46.09402980627193,
        46.10901518691775,
        46.12400056756358,
        46.1389859482094,
        46.15397132885523,
        46.16895670950105,
        46.183942090146886,
        46.19892747079271,
        46.213912851438536,
        46.22889823208436,
        46.24388361273019,
        46.25886899337601,
        46.27385437402184,
        46.28883975466766,
        46.303825135313495,
        46.31881051595932,
        46.333795896605146,
        46.34878127725097,
        46.3637666578968,
        46.37875203854262,
        46.39373741918845,
        46.40872279983427,
        46.4237081804801,
        46.43869356112593,
        46.453678941771756,
        46.46866432241758,
        46.483649703063406,
        46.49863508370923,
        46.51362046435506,
        46.52860584500088,
        46.54359122564671,
        46.55857660629253,
        46.573561986938365,
        46.58854736758419,
        46.603532748230016,
        46.61851812887584,
        46.63350350952167,
        46.64848889016749,
        46.66347427081332,
        46.67845965145914,
        46.693445032104975,
        46.7084304127508,
        46.723415793396626,
        46.73840117404245,
        46.75338655468828,
        46.7683719353341,
        46.78335731597993,
        46.79834269662575,
        46.81332807727158,
        46.82831345791741,
        46.843298838563236,
        46.85828421920906,
        46.873269599854886,
        46.88825498050071,
        46.90324036114654,
        46.91822574179236,
        46.93321112243819,
        46.94819650308402,
        46.963181883729845,
        46.97816726437567,
        46.993152645021496,
        47.00813802566732,
        47.02312340631315,
        47.03810878695897,
        47.0530941676048,
        47.06807954825062,
        47.083064928896455,
        47.09805030954228,
        47.113035690188106,
        47.12802107083393,
        47.143006451479756,
        47.15799183212558,
        47.17297721277141,
        47.18796259341723,
        47.20294797406306,
        47.21793335470889,
        47.232918735354716,
        47.24790411600054,
        47.262889496646366,
        47.27787487729219,
        47.29286025793802,
        47.30784563858384,
        47.32283101922967,
        47.3378163998755,
        47.352801780521325,
        47.36778716116715,
        47.382772541812976,
        47.3977579224588,
        47.41274330310463,
        47.42772868375045,
        47.44271406439628,
        47.4576994450421,
        47.472684825687935,
        47.48767020633376,
        47.502655586979586,
        47.51764096762541,
        47.532626348271236,
        47.54761172891706,
        47.56259710956289,
        47.57758249020871,
        47.59256787085454,
        47.60755325150037,
        47.622538632146195,
        47.63752401279202,
        47.652509393437846,
        47.66749477408367,
        47.6824801547295,
        47.69746553537532,
        47.71245091602115,
        47.72743629666698,
        47.742421677312805,
        47.75740705795863,
        47.772392438604456,
        47.78737781925028,
        47.80236319989611,
        47.81734858054193,
        47.83233396118776,
        47.84731934183358,
        47.862304722479415,
        47.87729010312524,
        47.892275483771066,
        47.90726086441689,
        47.922246245062716,
        47.93723162570854,
        47.95221700635437,
        47.96720238700019,
        47.982187767646025,
        47.99717314829185,
        48.012158528937675,
        48.0271439095835,
        48.042129290229326,
        48.05711467087515,
        48.07210005152098,
        48.0870854321668,
        48.10207081281263,
        48.11705619345846,
        48.132041574104285,
        48.14702695475011,
        48.162012335395936,
        48.17699771604176,
        48.191983096687586,
        48.20696847733341,
        48.22195385797924,
        48.23693923862506,
        48.251924619270895,
        48.26690999991672,
        48.281895380562545,
        48.29688076120837,
        48.311866141854196,
        48.32685152250002,
        48.34183690314585,
        48.35682228379167,
        48.371807664437505,
        48.38679304508333,
        48.401778425729155,
        48.41676380637498,
        48.431749187020806,
        48.44673456766663,
        48.46171994831246,
        48.47670532895828,
        48.49169070960411,
        48.50667609024994,
        48.521661470895765,
        48.53664685154159,
        48.551632232187416,
        48.56661761283324,
        48.581602993479066,
        48.59658837412489,
        48.61157375477072,
        48.62655913541654,
        48.641544516062375,
        48.6565298967082,
        48.671515277354025,
        48.68650065799985,
        48.701486038645676,
        48.7164714192915,
        48.73145679993733,
        48.74644218058315,
        48.761427561228984,
        48.77641294187481,
        48.791398322520635,
        48.80638370316646,
        48.821369083812286,
        48.83635446445811,
        48.85133984510394,
        48.86632522574976,
        48.88131060639559,
        48.89629598704142,
        48.911281367687245,
        48.92626674833307,
        48.941252128978896,
        48.95623750962472,
        48.971222890270546,
        48.98620827091637,
        49.0011936515622,
        49.01617903220803,
        49.031164412853855,
        49.04614979349968,
        49.061135174145505,
        49.07612055479133,
        49.091105935437156,
        49.10609131608298,
        49.12107669672881,
        49.13606207737463,
        49.151047458020464,
        49.16603283866629,
        49.181018219312115,
        49.19600359995794,
        49.210988980603766,
        49.22597436124959,
        49.240959741895416,
        49.25594512254124,
        49.27093050318707,
        49.2859158838329,
        49.300901264478725,
        49.31588664512455,
        49.330872025770375,
        49.3458574064162,
        49.360842787062026,
        49.37582816770785,
        49.39081354835368,
        49.40579892899951,
        49.420784309645335,
        49.43576969029116,
        49.450755070936985,
        49.46574045158281,
        49.480725832228636,
        49.49571121287446,
        49.51069659352029,
        49.52568197416611,
        49.540667354811944,
        49.55565273545777,
        49.570638116103595,
        49.58562349674942,
        49.600608877395246,
        49.61559425804107,
        49.630579638686896,
        49.64556501933272,
        49.66055039997855,
        49.67553578062438,
        49.690521161270205,
        49.70550654191603,
        49.720491922561855,
        49.73547730320768,
        49.750462683853506,
        49.76544806449933,
        49.78043344514516,
        49.79541882579099,
        49.810404206436814,
        49.82538958708264,
        49.840374967728465,
        49.85536034837429,
        49.870345729020116,
        49.88533110966594,
        49.900316490311766,
        49.91530187095759,
        49.930287251603424,
        49.94527263224925,
        49.960258012895075,
        49.9752433935409,
        49.990228774186726,
        50.00521415483255,
        50.020199535478376,
        50.0351849161242,
        50.050170296770034,
        50.06515567741586,
        50.080141058061685,
        50.09512643870751,
        50.110111819353335,
        50.12509719999916,
        50.140082580644986,
        50.15506796129081,
        50.17005334193664,
        50.18503872258247,
        50.200024103228294,
        50.21500948387412,
        50.229994864519945,
        50.24498024516577,
        50.259965625811596,
        50.27495100645742,
        50.289936387103246,
        50.30492176774907,
        50.319907148394904,
        50.33489252904073,
        50.349877909686555,
        50.36486329033238,
        50.379848670978205,
        50.39483405162403,
        50.409819432269856,
        50.42480481291568,
        50.439790193561514,
        50.45477557420734,
        50.469760954853164,
        50.48474633549899,
        50.499731716144815,
        50.51471709679064,
        50.529702477436466,
        50.54468785808229,
        50.55967323872812,
        50.57465861937395,
        50.589644000019774,
        50.6046293806656,
        50.619614761311425,
        50.63460014195725,
        50.649585522603076,
        50.6645709032489,
        50.679556283894726,
        50.69454166454055,
        50.709527045186384,
        50.72451242583221,
        50.739497806478035,
        50.75448318712386,
        50.769468567769685,
        50.78445394841551,
        50.799439329061336,
        50.81442470970716,
        50.829410090352994,
        50.84439547099882,
        50.859380851644644,
        50.87436623229047,
        50.889351612936295,
        50.90433699358212,
        50.919322374227946,
        50.93430775487377,
        50.949293135519596,
        50.96427851616543,
        50.979263896811254,
        50.99424927745708,
        51.009234658102905,
        51.02422003874873,
        51.039205419394555,
        51.05419080004038,
        51.069176180686206,
        51.08416156133204,
        51.099146941977864,
        51.11413232262369,
        51.129117703269515,
        51.14410308391534,
        51.159088464561165,
        51.17407384520699,
        51.189059225852816,
        51.20404460649864,
        51.219029987144474,
        51.2340153677903,
        51.249000748436124,
        51.26398612908195,
        51.278971509727775,
        51.2939568903736,
        51.308942271019426,
        51.32392765166525,
        51.338913032311076,
        51.35389841295691,
        51.368883793602734,
        51.38386917424856,
        51.398854554894385,
        51.41383993554021,
        51.428825316186035,
        51.44381069683186,
        51.458796077477686,
        51.47378145812352,
        51.488766838769344,
        51.50375221941517,
        51.518737600060994,
        51.53372298070682,
        51.548708361352645,
        51.56369374199847,
        51.578679122644296,
        51.59366450329012,
        51.60864988393595,
        51.62363526458178,
        51.638620645227604,
        51.65360602587343,
        51.668591406519255,
        51.68357678716508,
        51.698562167810906,
        51.71354754845673,
        51.728532929102556,
        51.74351830974839,
        51.758503690394214,
        51.77348907104004,
        51.788474451685865,
        51.80345983233169,
        51.818445212977515,
        51.83343059362334,
        51.848415974269166,
        51.863401354915,
        51.878386735560824,
        51.89337211620665,
        51.908357496852474,
        51.9233428774983,
        51.938328258144125,
        51.95331363878995,
        51.968299019435776,
        51.9832844000816,
        51.99826978072743,
        52.01325516137326,
        52.028240542019084,
        52.04322592266491,
        52.058211303310735,
        52.07319668395656,
        52.088182064602385,
        52.10316744524821,
        52.11815282589404,
        52.13313820653987,
        52.148123587185694,
        52.16310896783152,
        52.178094348477345,
        52.19307972912317,
        52.208065109768995,
        52.22305049041482,
        52.238035871060646,
        52.25302125170648,
        52.268006632352304,
        52.28299201299813,
        52.297977393643954,
        52.31296277428978,
        52.327948154935605,
        52.34293353558143,
        52.357918916227256,
        52.37290429687308,
        52.38788967751891,
        52.40287505816474,
        52.417860438810564,
        52.43284581945639,
        52.447831200102215,
        52.46281658074804,
        52.477801961393865,
        52.49278734203969,
        52.50777272268552,
        52.52275810333135,
        52.537743483977174,
        52.552728864623,
        52.567714245268824,
        52.58269962591465,
        52.597685006560475,
        52.6126703872063,
        52.627655767852126,
        52.64264114849796,
        52.65762652914378,
        52.67261190978961,
        52.687597290435434,
        52.70258267108126,
        52.717568051727085,
        52.73255343237291,
        52.747538813018735,
        52.76252419366456,
        52.77750957431039,
        52.79249495495622,
        52.807480335602044,
        52.82246571624787,
        52.837451096893695,
        52.85243647753952,
        52.867421858185345,
        52.88240723883117,
        52.897392619477,
        52.91237800012283,
        52.927363380768654,
        52.94234876141448,
        52.957334142060304,
        52.97231952270613,
        52.987304903351955,
        53.00229028399778,
        53.017275664643606,
        53.03226104528944,
        53.04724642593526,
        53.06223180658109,
        53.077217187226914,
        53.09220256787274,
        53.107187948518565,
        53.12217332916439,
        53.137158709810215,
        53.15214409045605,
        53.16712947110187,
        53.1821148517477,
        53.197100232393524,
        53.21208561303935,
        53.227070993685174,
        53.242056374331,
        53.257041754976825,
        53.27202713562265,
        53.28701251626848,
        53.30199789691431,
        53.316983277560134,
        53.33196865820596,
        53.346954038851784,
        53.36193941949761,
        53.376924800143435,
        53.39191018078926,
        53.406895561435086,
        53.42188094208092,
        53.43686632272674,
        53.45185170337257,
        53.466837084018394,
        53.48182246466422,
        53.496807845310045,
        53.51179322595587,
        53.526778606601695,
        53.54176398724753,
        53.55674936789335,
        53.57173474853918,
        53.586720129185004,
        53.60170550983083,
        53.616690890476654,
        53.63167627112248,
        53.646661651768305,
        53.66164703241413,
        53.67663241305996,
        53.69161779370579,
        53.70660317435161,
        53.72158855499744,
        53.736573935643264,
        53.75155931628909,
        53.766544696934915,
        53.78153007758074,
        53.796515458226565,
        53.8115008388724,
        53.82648621951822,
        53.84147160016405,
        53.856456980809874,
        53.8714423614557,
        53.886427742101525,
        53.90141312274735,
        53.916398503393175,
        53.93138388403901,
        53.94636926468483,
        53.96135464533066,
        53.976340025976484,
        53.99132540662231,
        54.006310787268134,
        54.02129616791396,
        54.036281548559785,
        54.05126692920561,
        54.06625230985144,
        54.08123769049727,
        54.09622307114309,
        54.11120845178892,
        54.126193832434744,
        54.14117921308057,
        54.156164593726395,
        54.17114997437222,
        54.18613535501805,
        54.20112073566388,
        54.2161061163097,
        54.23109149695553,
        54.246076877601354,
        54.26106225824718,
        54.276047638893004,
        54.29103301953883,
        54.306018400184655,
        54.32100378083049,
        54.33598916147631,
        54.35097454212214,
        54.36595992276796,
        54.38094530341379,
        54.395930684059614,
        54.41091606470544,
        54.425901445351265,
        54.44088682599709,
        54.45587220664292,
        54.47085758728875,
        54.48584296793457,
        54.5008283485804,
        54.515813729226224,
        54.53079910987205,
        54.545784490517875,
        54.5607698711637,
        54.57575525180953,
        54.59074063245536,
        54.60572601310118,
        54.62071139374701,
        55.686742183736,
        55.71188645672267,
        55.73701982104315,
        55.76214227669739,
        55.787253823685475,
        55.81235446200732,
        55.83744419166301,
        55.86252301265249,
        55.88759092497578,
        55.912647928632865,
        55.937694023623735,
        55.96272920994845,
        55.98775348760695,
        56.01276685659927,
        56.03776931692535,
        56.06276086858527,
        56.08774151157898,
        56.11271124590651,
        56.137670071567854,
        56.162617988562985,
        56.187554996891876,
        56.21248109655461,
        56.237396287551164,
        56.2623005698815,
        56.28719394354566,
        56.312076408543604,
        56.336947964875364,
        56.36180861254091,
        56.38665835154028,
        56.41149718187346,
        56.436325103540426,
        56.46114211654118,
        56.48594822087573,
        56.510743416544116,
        56.53552770354632,
        56.560301081882315,
        56.585063551552096,
        56.609815112555694,
        56.63455576489308,
        56.65928550856428,
        56.6840043435693,
        56.70871226990813,
        56.73340928758073,
        56.75809539658714,
        56.782770596927364,
        56.807434888601406,
        56.83208827160924,
        56.856730745950856,
        56.88136231162629,
        56.90598296863551,
        56.93059271697858,
        56.955191556655436,
        56.97977948766611,
        57.00435651001054,
        57.028922623688786,
        57.05347782870085,
        57.07802212504673,
        57.1025555127264,
        57.12707799173988,
        57.15158956208715,
        57.17609022376821,
        57.20057997678312,
        57.22505882113181,
        57.24952675681432,
        57.273983783830616,
        57.2984299021807,
        57.3228651118646,
        57.34728941288232,
        57.37170280523385,
        57.39610528891917,
        57.42049686393828,
        57.44487753029118,
        57.46924728797792,
        57.49360613699845,
        57.5179540773528,
        57.54229110904093,
        57.56661723206285,
        57.59093244641862,
        57.615236752108174,
        57.639530149131545,
        57.663812637488704,
        57.68808421717965,
        57.71234488820441,
        57.73659465056299,
        57.76083350425536,
        57.78506144928157,
        57.809278485641514,
        57.83348461333533,
        57.857679832362905,
        57.8818641427243,
        57.906037544419505,
        57.9302000374485,
        57.95435162181131,
        57.978492297507884,
        58.00262206453833,
        58.02674092290253,
        58.05084887260058,
        58.07494591363239,
        58.099032045998015,
        58.12310726969743,
        58.147171584730685,
        58.17122499109773,
        58.195267488798564,
        58.21929907783321,
        58.24331975820165,
        58.267329529903904,
        58.291328392939974,
        58.31531634730983,
        58.33929339301348,
        58.36325953005097,
        58.38721475842222,
        58.41115907812731,
        58.435092489166195,
        58.45901499153889,
        58.48292658524538,
        58.506827270285655,
        58.530717046659746,
        58.55459591436765,
        58.578463873409376,
        58.60232092378486,
        58.62616706549419,
        58.650002298537274,
        58.673826622914206,
        58.697640038624954,
        58.72144254566949,
        58.745234144047785,
        58.769014833759925,
        58.79278461480585,
        58.816543487185626,
        58.84029145089916,
        58.86402850594651,
        58.88775465232767,
        58.911469890042596,
        58.935174219091365,
        58.95886763947395,
        58.982550151190324,
        59.006221754240485,
        59.029882448624434,
        59.05353223434223,
        59.07717111139384,
        59.100799079779236,
        59.12441613949839,
        59.148022290551395,
        59.171617532938185,
        59.19520186665879,
        59.218775291713214,
        59.242337808101425,
        59.26588941582342,
        59.28943011487924,
        59.31295990526887,
        59.33647878699229,
        59.35998676004955,
        59.383483824440574,
        59.406969980165414,
        59.43044522722401,
        59.453909565616485,
        59.477362995342745,
        59.50080551640279,
        59.52423712879663,
        59.54765783252428,
        59.57106762758575,
        59.59446651398103,
        59.617854491710105,
        59.641231560772994,
        59.66459772116967,
        59.687952972900135,
        59.711297315964416,
        59.73463075036251,
        59.757953276094426,
        59.7812648931601,
        59.80456560155962,
        59.82785540129292,
        59.851134292360015,
        59.87440227476095,
        59.89765934849568,
        59.92090551356419,
        59.944140769966495,
        59.96736511770264,
        59.990578556772576,
        60.013781087176326,
        60.03697270891384,
        60.06015342198519,
        60.083323226390334,
        60.10648212212929,
        60.12963010920204,
        60.15276718760863,
        60.175893357348954,
        60.19900861842312,
        60.222112970831105,
        60.24520641457288,
        60.268288949648465,
        60.29136057605784,
        60.31442129380103,
        60.33747110287801,
        60.36051000328881,
        60.38353799503342,
        60.40655507811182,
        60.42956125252401,
        60.452556518269986,
        60.47554087534981,
        60.498514323763445,
        60.52147686351087,
        60.54442849459208,
        60.56736921700711,
        60.59029903075593,
        60.61321793583859,
        60.63612593225504,
        60.65902302000528,
        60.681909199089304,
        60.704784469507146,
        60.727648831258804,
        60.75050228434428,
        60.77334482876354,
        60.79617646451659,
        60.818997191603486,
        60.84180701002414,
        60.86460591977861,
        60.8873939208669,
        60.910171013289,
        60.932937197044865,
        60.955692472134544,
        60.97843683855807,
        61.00117029631538,
        61.02389284540648,
        61.04660448583137,
        61.0693052175901,
        61.09199504068259,
        61.11467395510893,
        61.13734196086905,
        61.15999905796299,
        61.18264524639069,
        61.20528052615221,
        61.22790489724757,
        61.25051835967672,
        61.27312091343968,
        61.29571255853644,
        61.31829329496698,
        61.34086312273131,
        61.36342204182948,
        61.38597005226147,
        61.40850715402725,
        61.431033347126785,
        61.45354863156014,
        61.47605300732734,
        61.49854647442832,
        61.521029032863126,
        61.543500682631745,
        61.56596142373412,
        61.58841125617029,
        61.6108501799403,
        61.63327819504413,
        61.65569530148174,
        61.678101499253145,
        61.700496788358365,
        61.72288116879737,
        61.745254640570195,
        61.767617203676835,
        61.78996885811729,
        61.81230960389151,
        61.83463944099954,
        61.85695836944139,
        61.87926638921705,
        61.9015635003265,
        61.92384970276974,
        61.94612499654683,
        61.96838938165767,
        61.99064285810233,
        62.01288542588081,
        62.035117084993104,
        62.05733783543916,
        62.079547677219026,
        62.10174661033274,
        62.12393463478024,
        62.14611175056153,
        62.16827795767661,
        62.19043325612553,
        62.21257764590821,
        62.23471112702474,
        62.25683369947505,
        62.27894536325918,
        62.3010461183771,
        62.32313596482881,
        62.34521490261433,
        62.36728293173367,
        62.389340052186824,
        62.41138626397374,
        62.4334215670945,
        62.45544596154902,
        62.47745944733738,
        62.49946202445956,
        62.52145369291553,
        62.543434452705284,
        62.56540430382883,
        62.58736324628619,
        62.60931128007739,
        62.631248405202385,
        62.65317462166114,
        62.67508992945373,
        62.69699432858012,
        62.71888781904032,
        62.74077040083431,
        62.76264207396214,
        62.784502838423705,
        62.806352694219115,
        62.82819164134834,
        62.85001967981135,
        62.87183680960818,
        62.8936430307388,
        62.915438343203235,
        62.93722274700143,
        62.958996242133495,
        62.98075882859935,
        63.00251050639899,
        63.02425127553242,
        63.04598113599964,
        63.0677000878007,
        63.08940813093558,
        63.11110526540425,
        63.13279149120673,
        63.154466808342974,
        63.17613121681303,
        63.19778471661694,
        63.21942730775463,
        63.24105899022611,
        63.262679764031375,
        63.28428962917046,
        63.30588858564336,
        63.327476633450075,
        63.34905377259058,
        63.3706200030649,
        63.39217532487301,
        63.413719738014905,
        63.43525324249062,
        63.456775838300146,
        63.47828752544349,
        63.499788303920596,
        63.521278173731545,
        63.54275713487628,
        63.564225187354836,
        63.58568233116718,
        63.607128566313335,
        63.62856389279328,
        63.649988310607014,
        63.67140181975459,
        63.69280442023596,
        63.71419611205114,
        63.73557689520008,
        63.75694676968287,
        63.778305735499444,
        63.799653792649835,
        63.82099094113404,
        63.84231718095204,
        63.86363251210382,
        63.88493693458939,
        63.906230448408806,
        63.92751305356204,
        63.94878475004906,
        63.97004553786984,
        63.99129541702446,
        64.01253438751287,
        64.0337624493351,
        64.05497960249114,
        64.076185846981,
        64.09738118280463,
        64.11856560996203,
        64.13973912845329,
        64.16090173827835,
        64.18205343943721,
        64.20319423192986,
        64.22432411575632,
        64.24544309091657,
        64.26655115741063,
        64.28764831523851,
        64.30873456440021,
        64.32980990489567,
        64.35087433672494,
        64.37192785988803,
        64.39297047438494,
        64.41400218021563,
        64.43502297738011,
        64.45603286587844,
        64.47703184571053,
        64.49801991687643,
        64.51899707937618,
        64.53996333320968,
        64.560918678377,
        64.58186311487809,
        64.60279664271305,
        64.62371926188179,
        64.64463097238432,
        64.66553177422064,
        64.6864216673908,
        64.70730065189473,
        64.7281687277325,
        64.74902589490405,
        64.76987215340942,
        64.79070750324858,
        64.81153194442153,
        64.8323454769283,
        64.8531481007689,
        64.87393981594327,
        64.89472062245146,
        64.91549052029343,
        64.93624950946922,
        64.95699758997883,
        64.97773476182222,
        64.99846102499943,
        65.01917637951043,
        65.03988082535521,
        65.06057436253384,
        65.08125699104626,
        65.1019287108925,
        65.12258952207252,
        65.14323942458633,
        65.16387841843395,
        65.1845065036154,
        65.20512368013065,
        65.2257299479797,
        65.24632530716254,
        65.26690975767919,
        65.28748329952963,
        65.30804593271388,
        65.32859765723195,
        65.34913847308384,
        65.36966838026949,
        65.39018737878895,
        65.41069546864223,
        65.43119264982933,
        65.45167892235021,
        65.47215428620488,
        65.4926187413934,
        65.51307228791568,
        65.53351492577177,
        65.5539466549617,
        65.5743674754854,
        65.59477738734292,
        65.61517639053419,
        65.63556448505933,
        65.65594167091827,
        65.67630794811099,
        65.69666331663753,
        65.71700777649785,
        65.73734132769196,
        65.75766397021992,
        65.7779757040817,
        65.79827652927726,
        65.81856644580658,
        65.83884545366972,
        65.8591135528667,
        65.87937074339747,
        65.89961702526206,
        65.9198523984604,
        65.9400768629926,
        65.96029041885855,
        65.98049306605834,
        66.00068480459196,
        66.02086563445935,
        66.04103555566051,
        66.06119456819549,
        66.08134267206431,
        66.10147986726695,
        66.12160615380334,
        66.14172153167355,
        66.16182600087758,
        66.18191956141537,
        66.20200221328703,
        66.22207395649245,
        66.24213479103169,
        66.26218471690471,
        66.28222373411155,
        66.30225184265221,
        66.32226904252666,
        66.34227533373492,
        66.36227071627697,
        66.38225519015283,
        66.40222875536249,
        66.42219141190596,
        66.44214315978324,
        66.46208399899432,
        66.48201392953918,
        66.50193295141786,
        66.52184106463035,
        66.54173826917663,
        66.56162456505676,
        66.58149995227065,
        66.60136443081835,
        66.62121800069981,
        66.64106066191515,
        66.66089241446427,
        66.68071325834721,
        66.70052319356391,
        66.7203222201144,
        66.74011033799876,
        66.75988754721688,
        66.77965384776884,
        66.7994092396546,
        66.8191537228741,
        66.83888729742743,
        66.8586099633146,
        66.87832172053557,
        66.89802256909034,
        66.91771250897888,
        66.93739154020126,
        66.9570596627574,
        66.97671687664739,
        66.99636318187119,
        67.01599857842878,
        67.03562306632016,
        67.05523664554532,
        67.07483931610433,
        67.09443107799713,
        67.11401193122374,
        67.13358187578412,
        67.15314091167834,
        67.17268903890634,
        67.19222625746816,
        67.2117525673638,
        67.23126796859323,
        67.25077246115644,
        67.27026604505345,
        67.2897487202843,
        67.30922048684896,
        67.32868134474741,
        67.34813129397962,
        67.3675703345457,
        67.38699846644552,
        67.4064156896792,
        67.42582200424665,
        67.44521741014795,
        67.464601907383,
        67.48397549595184,
        67.50333817585452,
        67.52268994709102,
        67.54203080966131,
        67.56136076356539,
        67.58067980880331,
        67.59998794537496,
        67.61928517328049,
        67.6385714925198,
        67.65784690309293,
        67.67711140499982,
        67.6963649982405,
        67.71560768281505,
        67.73483945872336,
        67.75406032596551,
        67.77327028454143,
        67.79246933445116,
        67.81165747569467,
        67.83083470827204,
        67.85000103218319,
        67.86915644742815,
        67.88830095400688,
        67.90743455191942,
        67.92655724116581,
        67.94566902174599,
        67.96476989365995,
        67.9838598569077,
        68.0029389114893,
        68.02200705740465,
        68.04106429465385,
        68.06011062323684,
        68.07914604315364,
        68.09817055440423,
        68.11718415698861,
        68.13618685090681,
        68.15517863615885,
        68.17415951274465,
        68.1931294806643,
        68.21208853991767,
        68.2310366905049,
        68.24997393242593,
        68.26890026568076,
        68.2878156902694,
        68.30672020619183,
        68.32561381344804,
        68.3444965120381,
        68.36336830196196,
        68.38222918321962,
        68.4010791558111,
        68.41991821973635,
        68.43874637499538,
        68.45756362158825,
        68.47636995951494,
        68.49516538877542,
        68.51394990936969,
        68.53272352129777,
        68.55148622455964,
        68.57023801915535,
        68.58897890508486,
        68.60770888234815,
        68.62642795094526,
        68.64513611087612,
        68.66383336214086,
        68.68251970473936,
        68.70119513867171,
        68.71985966393781,
        68.73851328053773,
        68.75715598847144,
        68.77578778773899,
        68.79440867834033,
        68.81301866027549,
        68.8316177335444,
        68.85020589814714,
        68.86878315408372,
        68.88734950135408,
        68.90590493995823,
        68.92444946989617,
        68.94298309116796,
        68.9615058037735,
        68.9800176077129,
        68.9985185029861,
        69.0170084895931,
        69.03548756753385,
        69.05395573680842,
        69.07241299741683,
        69.09085934935904,
        69.10929479263505,
        69.12771932724483,
        69.14613295318846,
        69.16453567046584,
        69.18292747907707,
        69.20130837902211,
        69.21967837030094,
        69.23803745291356,
        69.25638562685997,
        69.27472289214019,
        69.29304924875426,
        69.31136469670211,
        69.32966923598373,
        69.34796286659919,
        69.36624558854844,
        69.3845174018315,
        69.40277830644838,
        69.42102830239905,
        69.43926738968351,
        69.45749556830175,
        69.47571283825384,
        69.49391919953975,
        69.51211465215944,
        69.53029919611289,
        69.54847283140019,
        69.56663555802128,
        69.5847873759762,
        69.6029282852649,
        69.62105828588743,
        69.63917737784372,
        69.6572855611338,
        69.67538283575773,
        69.69346920171547,
        69.711544659007,
        69.72960920763235,
        69.74766284759149,
        69.76570557888438,
        69.78373740151115,
        69.8017583154717,
        69.81976832076607,
        69.8377674173942,
        69.85575560535612,
        69.87373288465191,
        69.89169925528147,
        69.90965471724486,
        69.92759927054205,
        69.94553291517299,
        69.96345565113775,
        69.98136747843635,
        69.99926839706875,
        70.01715840703496,
        70.03503750833492,
        70.05290570096874,
        70.07076298493634,
        70.08860936023775,
        70.10644482687296,
        70.12426938484198,
        70.14208303414479,
        70.15988577478139,
        70.17767760675183,
        70.19545853005606,
        70.2132285446941,
        70.23098765066594,
        70.24873584797159,
        70.266473136611,
        70.28419951658428,
        70.30191498789132,
        70.31961955053221,
        70.33731320450683,
        70.35499594981529,
        70.37266778645757,
        70.39032871443364,
        70.40797873374352,
        70.42561784438719,
        70.44324604636468,
        70.46086333967595,
        70.47846972432104,
        70.49606520029995,
        70.51364976761268,
        70.53122342625916,
        70.54878617623943,
        70.56633801755355,
        70.58387895020148,
        70.6014089741832,
        70.61892808949871,
        70.63643629614803,
        70.65393359413115,
        70.6714199834481,
        70.68889546409885,
        70.70636003608341,
        70.72381369940173,
        70.74125645405384,
        70.75868830003982,
        70.77610923735959,
        70.79351926601315,
        70.8109183860005,
        70.82830659732168,
        70.84568389997663,
        70.8630502939654,
        70.88040577928801,
        70.89775035594438,
        70.91508402393457,
        70.93240678325851,
        70.94971863391633,
        70.96701957590794,
        70.98430960923336,
        71.00158873389255,
        71.01885694988555,
        71.03611425721236,
        71.05336065587296,
        71.07059614586741,
        71.08782072719565,
        71.10503439985764,
        71.12223716385346,
        71.13942901918311,
        71.15660996584656,
        71.17378000384382,
        71.19093913317487,
        71.2080873538397,
        71.22522466583833,
        71.2423510691708,
        71.25946656383708,
        71.27657114983715,
        71.29366482717101,
        71.31074759583866,
        71.32781945584016,
        71.34488040717544,
        71.36193044984454,
        71.37896958384745,
        71.3959978091841,
        71.41301512585459,
        71.43002153385889,
        71.44701703319701,
        71.46400162386892,
        71.48097530587462,
        71.49793807921414,
        71.51488994388744,
        71.53183089989459,
        71.54876094723552,
        71.56568008591027,
        71.58258831591878,
        71.59948563726108,
        71.61637204993725,
        71.63324755394721,
        71.65011214929096,
        71.6669658359685,
        71.68380861397988,
        71.70064048332502,
        71.71746144400397,
        71.73427149601677,
        71.75107063936336,
        71.76785887404371,
        71.78463620005788,
        71.80140261740586,
        71.81815812608765,
        71.83490272610327,
        71.85163641745264,
        71.86835920013586,
        71.88507107415283,
        71.90177203950365,
        71.91846209618826,
        71.93514124420669,
        71.9518094835589,
        71.9684668142449,
        71.98511323626472,
        72.00174874961839,
        72.01837335430581,
        72.03498705032705,
        72.0515898376821,
        72.06818171637092,
        72.08476268639357,
        72.10133274775005,
        72.11789190044031,
        72.13444014446434,
        72.1509774798222,
        72.16750390651386,
        72.18401942453936,
        72.20052403389865,
        72.21701773459169,
        72.23350052661858,
        72.24997240997926,
        72.26643338467376,
        72.28288345070207,
        72.29932260806417,
        72.31575085676006,
        72.33216819678974,
        72.34857462815326,
        72.3649701508506,
        72.38135476488172,
        72.3977284702466,
        72.41409126694536,
        72.43044315497785,
        72.44678413434421,
        72.46311420504436,
        72.4794333670783,
        72.49574162044603,
        72.51203896514757,
        72.52832540118293,
        72.54460092855207,
        72.56086554725506,
        72.57711925729184,
        72.59336205866238,
        72.60959395136673,
        72.6258149354049,
        72.64202501077689,
        72.6582241774827,
        72.67441243552226,
        72.69058978489564,
        72.70675622560283,
        72.72291175764384,
        72.73905638101867,
        72.75519009572729,
        72.77131290176966,
        72.78742479914585,
        72.80352578785589,
        72.81961586789971,
        72.83569503927735,
        72.85176330198875,
        72.867820656034,
        72.883867101413,
        72.89990263812585,
        72.91592726617252,
        72.93194098555297,
        72.94794379626721,
        72.96393569831524,
        72.97991669169711,
        72.99588677641277,
        73.01184595246225,
        73.02779421984552,
        73.0437315785626,
        73.05965802861344,
        73.07557356999816,
        73.09147820271663,
        73.10737192676895,
        73.12325474215503,
        73.13912664887489,
        73.1549876469286,
        73.17083773631613,
        73.18667691703745,
        73.20250518909252,
        73.21832255248147,
        73.23412900720415,
        73.2499245532607,
        73.26570919065104,
        73.28148291937516,
        73.29724573943308,
        73.31299765082481,
        73.32873865355036,
        73.34446874760972,
        73.36018793300288,
        73.37589620972982,
        73.39159357779057,
        73.40728003718512,
        73.42295558791348,
        73.43862022997568,
        73.45427396337165,
        73.4699167881014,
        73.48554870416497,
        73.50116971156235,
        73.51677981029356,
        73.53237900035857,
        73.54796728175735,
        73.56354465448995,
        73.57911111855633,
        73.59466667395655,
        73.61021132069057,
        73.6257450587584,
        73.64126788815999,
        73.6567798088954,
        73.67228082096464,
        73.68777092436768,
        73.70325011910454,
        73.71871840517515,
        73.73417578257958,
        73.74962225131783,
        73.76505781138987,
        73.78048246279575,
        73.79589620553541,
        73.81129903960884,
        73.82669096501608,
        73.84207198175717,
        73.85744208983205,
        73.87280128924074,
        73.88814957998322,
        73.90348696205949,
        73.91881343546957,
        73.93412900021347,
        73.94943365629116,
        73.96472740370267,
        73.98001024244796,
        73.99528217252704,
        74.01054319393997,
        74.02579330668668,
        74.04103251076721,
        74.05626080618156,
        74.07147819292966,
        74.08668467101155,
        74.10188024042732,
        74.11706490117685,
        74.13223865326022,
        74.14740149667735,
        74.1625534314283,
        74.17769445751303,
        74.19282457493158,
        74.20794378368397,
        74.22305208377013,
        74.23814947519007,
        74.25323595794383,
        74.2683115320314,
        74.2833761974528,
        74.298429954208,
        74.31347280229697,
        74.32850474171975,
        74.34352577247635,
        74.35853589456674,
        74.37353510799097,
        74.38852341274897,
        74.40350080884077,
        74.41846729626637,
        74.43342287502578,
        74.44836754511901,
        74.46330130654606,
        74.47822415930686,
        74.49313610340151,
        74.50803713882992,
        74.52292726559217,
        74.53780648368821,
        74.55267479311807,
        74.56753219388172,
        74.58237868597915,
        74.59721426941043,
        74.6120389441755,
        74.62685271027438,
        74.64165556770702,
        74.6564475164735,
        74.67122855657375,
        74.68599868800784,
        74.70075791077575,
        74.71550622487744,
        74.73024363031293,
        74.7449701270822,
        74.75968571518531,
        74.77439039462222,
        74.78908416539294,
        74.80376702749744,
        74.81843898093577,
        74.83310002570785,
        74.8477501618138,
        74.86238938925352,
        74.87701770802708,
        74.89163511813437,
        74.90624161957551,
        74.92083721235046,
        74.9354218964592,
        74.94999567190179,
        74.9645585386781,
        74.97911049678827,
        74.99365154623221,
        75.00818168701001,
        75.02270091912159,
        75.03720924256696,
        75.05170665734612,
        75.06619316345906,
        75.08066876090588,
        75.09513344968646,
        75.10958722980088,
        75.12403010124909,
        75.13846206403106,
        75.15288311814685,
        75.16729326359645,
        75.1816925003799,
        75.1960808284971,
        75.2104582479481,
        75.22482475873291,
        75.23918036085153,
        75.25352505430398,
        75.26785883909024,
        75.28218171521029,
        75.29649368266409,
        75.31079474145172,
        75.32508489157318,
        75.33936413302844,
        75.35363246581751,
        75.36788988994034,
        75.38213640539702,
        75.39637201218748,
        75.41059671031176,
        75.42481049976986,
        75.43901338056175,
        75.45320535268739,
        75.46738641614688,
        75.48155657094016,
        75.49571581706728,
        75.50986415452819,
        75.52400158332286,
        75.53812810345137,
        75.55224371491367,
        75.56634841770979,
        75.58044221183972,
        75.59452509730347,
        75.60859707410096,
        75.62265814223228,
        75.63670830169742,
        75.65074755249636,
        75.66477589462913,
        75.67879332809564,
        75.69279985289599,
        75.70679546903013,
        75.72078017649811,
        75.73475397529988,
        75.74871686543544,
        75.76266884690479,
        75.77660991970795,
        75.79054008384493,
        75.80445933931573,
        75.81836768612031,
        75.83226512425868,
        75.84615165373087,
        75.86002727453685,
        75.87389198667667,
        75.88774579015028,
        75.90158868495767,
        75.91542067109889,
        75.92924174857386,
        75.9430519173827,
        75.95685117752534,
        75.97063952900176,
        75.98441697181197,
        75.99818350595602,
        76.01193913143383,
        76.02568384824546,
        76.03941765639094,
        76.0531405558702,
        76.06685254668322,
        76.08055362883006,
        76.09424380231071,
        76.10792306712518,
        76.12159142327347,
        76.13524887075552,
        76.14889540957141,
        76.16253103972106,
        76.17615576120456,
        76.18976957402187,
        76.20337247817297,
        76.21696447365782,
        76.2305455604765,
        76.24411573862902,
        76.25767500811533,
        76.27122336893545,
        76.28476082108936,
        76.29828736457706,
        76.31180299939855,
        76.32530772555388,
        76.33880154304303,
        76.35228445186597,
        76.3657564520227,
        76.3792175435132,
        76.39266772633756,
        76.40610700049571,
        76.41953536598767,
        76.43295282281345,
        76.44635937097298,
        76.45975501046631,
        76.47313974129351,
        76.4865135634545,
        76.49987647694927,
        76.51322848177783,
        76.52656957794018,
        76.53989976543637,
        76.55321904426638,
        76.56652741443018,
        76.5798248759278,
        76.59311142875917,
        76.60638707292433,
        76.61965180842337,
        76.6329056352562,
        76.6461485534228,
        76.6593805629232,
        76.67260166375745,
        76.68581185592545,
        76.6990111394273,
        76.71219951426293,
        76.72537698043239,
        76.7385435379356,
        76.75169918677263,
        76.7648439269435,
        76.77797775844816,
        76.79110068128661,
        76.80421269545887,
        76.81731380096493,
        76.8304039978048,
        76.84348328597848,
        76.85655166548595,
        76.86960913632724,
        76.88265569850232,
        76.89569135201118,
        76.90871609685387,
        76.92172993303039,
        76.93473286054068,
        76.94772487938478,
        76.9607059895627,
        76.97367619107438,
        76.9866354839199,
        76.99958386809924,
        77.01252134361236,
        77.02544791045928,
        77.03836356863998,
        77.05126831815453,
        77.06416215900286,
        77.07704509118501,
        77.08991711470095,
        77.10277822955071,
        77.11562843573422,
        77.12846773325161,
        77.14129612210276,
        77.15411360228775,
        77.1669201738065,
        77.17971583665904,
        77.19250059084543,
        77.20527443636563,
        77.21803737321962,
        77.23078940140736,
        77.24353052092899,
        77.25626073178434,
        77.26898003397356,
        77.28168842749658,
        77.29438591235338,
        77.30707248854397,
        77.31974815606837,
        77.33241291492659,
        77.34506676511863,
        77.35770970664446,
        77.3703417395041,
        77.38296286369753,
        77.39557307922472,
        77.40817238608578,
        77.42076078428063,
        77.4333382738093,
        77.44590485467172,
        77.45846052686797,
        77.47100529039803,
        77.4835391452619,
        77.49606209145959,
        77.50857412899107,
        77.52107525785631,
        77.53356547805537,
        77.54604478958827,
        77.55851319245495,
        77.57097068665546,
        77.58341727218972,
        77.5958529490578,
        77.60827771725972,
        77.62069157679544,
        77.63309452766497,
        77.64548656986828,
        77.65786770340536,
        77.67023792827628,
        77.68259724448102,
        77.69494565201954,
        77.70728315089188,
        77.71960974109798,
        77.73192542263796,
        77.74423019551166,
        77.75652405971924,
        77.76880701526058,
        77.78107906213576,
        77.7933402003447,
        77.80559042988743,
        77.817829750764,
        77.8300581629744,
        77.84227566651857,
        77.85448226139651,
        77.86667794760832,
        77.8788627251539,
        77.89103659403328,
        77.90319955424648,
        77.9153516057935,
        77.92749274867428,
        77.93962298288885,
        77.95174230843726,
        77.96385072531949,
        77.97594823353553,
        77.98803483308531,
        78.00011052396896,
        78.01217530618636,
        78.02422917973759,
        78.03627214462263,
        78.04830420084149,
        78.0603253483941,
        78.07233558728053,
        78.08433491750078,
        78.09632333905485,
        78.10830085194273,
        78.12026745616437,
        78.13222315171983,
        78.1441679386091,
        78.15610181683216,
        78.16802478638907,
        78.17993684727976,
        78.19183799950422,
        78.20372824306249,
        78.21560757795457,
        78.22747600418047,
        78.23933352174019,
        78.25118013063367,
        78.263015830861,
        78.27484062242208,
        78.286654505317,
        78.29845747954575,
        78.31024954510828,
        78.32203070200457,
        78.33380095023468,
        78.34556028979863,
        78.35730872069637,
        78.36904624292792,
        78.3807728564933,
        78.3924885613924,
        78.40419335762535,
        78.41588724519211,
        78.42757022409269,
        78.43924229432706,
        78.45090345589519,
        78.46255370879716,
        78.47419305303292,
        78.48582148860253,
        78.49743901550592,
        78.50904563374313,
        78.5206413433141,
        78.53222614421885,
        78.54380003645745,
        78.55536302002987,
        78.5669150949361,
        78.57845626117607,
        78.58998651874988,
        78.60150586765751,
        78.61301430789892,
        78.62451183947418,
        78.6359984623832,
        78.64747417662603,
        78.65893898220263,
        78.6703928791131,
        78.68183586735735,
        78.69326794693539,
        78.70468911784722,
        78.7160993800929,
        78.72749873367233,
        78.73888717858561,
        78.75026471483268,
        78.76163134241357,
        78.77298706132821,
        78.78433187157667,
        78.79566577315897,
        78.80698876607507,
        78.81830085032497,
        78.82960202590864,
        78.84089229282615,
        78.85217165107743,
        78.86344010066254,
        78.87469764158145,
        78.88594427383417,
        78.89717999742068,
        78.90840481234098,
        78.91961871859512,
        78.93082171618305,
        78.94201380510479,
        78.9531949853603,
        78.96436525694965,
        78.97552461987279,
        78.98667307412974,
        78.99781061972048,
        79.00893725664507,
        79.02005298490339,
        79.03115780449552,
        79.0422517154215,
        79.0533347176813,
        79.06440681127488,
        79.07546799620222,
        79.08651827246344,
        79.09755764005838,
        79.10858609898717,
        79.11960364924978,
        79.1306102908462,
        79.14160602377636,
        79.15259084804036,
        79.16356476363818,
        79.17452777056981,
        79.18547986883523,
        79.19642105843441,
        79.20735133936746,
        79.21827071163425,
        79.2291791752349,
        79.24007673016935,
        79.25096337643758,
        79.2618391140396,
        79.27270394297544,
        79.2835578632451,
        79.29440087484856,
        79.30523297778582,
        79.3160541720569,
        79.32686445766176,
        79.3376638346004,
        79.34845230287287,
        79.35922986247915,
        79.36999651341925,
        79.38075225569311,
        79.39149708930078,
        79.40223101424228,
        79.41295403051758,
        79.4236661381267,
        79.43436733706962,
        79.44505762734629,
        79.45573700895677,
        79.4664054819011,
        79.47706304617925,
        79.48770970179119,
        79.49834544873688,
        79.5089702870164,
        79.51958421662972,
        79.53018723757687,
        79.54077934985783,
        79.55136055347258,
        79.56193084842111,
        79.57249023470344,
        79.5830387123196,
        79.59357628126959,
        79.60410294155336,
        79.6146186931709,
        79.62512353612227,
        79.63561747040744,
        79.64610049602642,
        79.65657261297922,
        79.66703382126583,
        79.67748412088618,
        79.68792351184037,
        79.69835199412837,
        79.7087695677502,
        79.7191762327058,
        79.72957198899518,
        79.73995683661842,
        79.75033077557539,
        79.76069380586624,
        79.77104592749087,
        79.78138714044933,
        79.79171744474154,
        79.80203684036753,
        79.81234532732738,
        79.82264290562104,
        79.83292957524851,
        79.84320533620972,
        79.8534701885048,
        79.86372413213364,
        79.8739671670963,
        79.8841992933928,
        79.89442051102306,
        79.90463081998713,
        79.91483022028497,
        79.92501871191668,
        79.93519629488218,
        79.94536296918146,
        79.95551873481453,
        79.96566359178145,
        79.97579754008213,
        79.98592057971665,
        79.99603271068496,
        80.00613393298708,
        80.01622424662297,
        80.02630365159267,
        80.03637214789622,
        80.04642973553355,
        80.0564764145047,
        80.06651218480961,
        80.07653704644837,
        80.08655099942088,
        80.09655404372724,
        80.10654617936738,
        80.11652740634138,
        80.1264977246491,
        80.13645713429064,
        80.14640563526602,
        80.15634322757519,
        80.16626991121818,
        80.17618568619498,
        80.18609055250552,
        80.1959845101499,
        80.2058675591281,
        80.2157396994401,
        80.2256009310859,
        80.23545125406547,
        80.24529066837887,
        80.25511917402609,
        80.2649367710071,
        80.27474345932193,
        80.28453923897057,
        80.29432410995297,
        80.30409807226916,
        80.31386112591922,
        80.32361327090304,
        80.3333545072207,
        80.34308483487213,
        80.35280425385734,
        80.3625127641764,
        80.37221036582928,
        80.38189705881594,
        80.39157284313642,
        80.40123771879065,
        80.41089168577871,
        80.42053474410058,
        80.43016689375627,
        80.43978813474577,
        80.44939846706903,
        80.45899789072611,
        80.46858640571698,
        80.47816401204169,
        80.48773070970022,
        80.49728649869253,
        80.5068313790186,
        80.5163653506785,
        80.5258884136722,
        80.53540056799976,
        80.54490181366107,
        80.55439215065617,
        80.56387157898511,
        80.57334009864785,
        80.5827977096444,
        80.59224441197473,
        80.60168020563889,
        80.61110509063683,
        80.62051906696855,
        80.62992213463413,
        80.63931429363349,
        80.64869554396667,
        80.6580658856336,
        80.66742531863439,
        80.67677384296896,
        80.68611145863734,
        80.69543816563952,
        80.70475396397553,
        80.71405885364528,
        80.72335283464885,
        80.73263590698626,
        80.74190807065749,
        80.7511693256625,
        80.7604196720013,
        80.76965910967392,
        80.7788876386803,
        80.78810525902055,
        80.7973119706946,
        80.80650777370242,
        80.81569266804404,
        80.82486665371944,
        80.83402973072869,
        80.84318189907175,
        80.8523231587486,
        80.86145350975924,
        80.8705729521037,
        80.87968148578194,
        80.888779110794,
        80.89786582713988,
        80.90694163481957,
        80.91600653383303,
        80.92506052418027,
        80.93410360586138,
        80.94313577887628,
        80.95215704322497,
        80.96116739890748,
        80.97016684592374,
        80.97915538427382,
        80.98813301395775,
        80.99709973497546,
        81.006055547327,
        81.01500045101228,
        81.02393444603139,
        81.03285753238431,
        81.04176971007105,
        81.0506709790916,
        81.05956133944595,
        81.06844079113405,
        81.07730933415597,
        81.08616696851173,
        81.09501369420131,
        81.10384951122468,
        81.11267441958181,
        81.12148841927275,
        81.13029151029751,
        81.13908369265611,
        81.14786496634848,
        81.15663533137469,
        81.16539478773463,
        81.17414333542838,
        81.18288097445598,
        81.1916077048174,
        81.2003235265126,
        81.20902843954157,
        81.2177224439044,
        81.22640553960098,
        81.23507772663142,
        81.24373900499565,
        81.25238937469366,
        81.26102883572547,
        81.26965738809106,
        81.2782750317905,
        81.28688176682375,
        81.2954775931908,
        81.30406251089163,
        81.31263651992627,
        81.3211996202947,
        81.32975181199699,
        81.33829309503305,
        81.3468234694029,
        81.35534293510655,
        81.36385149214401,
        81.37234914051528,
        81.38083588022037,
        81.38931171125925,
        81.39777663363192,
        81.40623064733843,
        81.4146737523787,
        81.42310594875279,
        81.43152723646072,
        81.43993761550242,
        81.4483370858779,
        81.45672564758719,
        81.46510330063033,
        81.47347004500726,
        81.48182588071798,
        81.49017080776248,
        81.49850482614083,
        81.50682793585294,
        81.51514013689889,
        81.52344142927863,
        81.53173181299219,
        81.54001128803954,
        81.54827985442064,
        81.55653751213562,
        81.56478426118439,
        81.57302010156697,
        81.58124503328331,
        81.5894590563335,
        81.59766217071744,
        81.60585437643523,
        81.61403567348684,
        81.62220606187223,
        81.63036554159139,
        81.63851411264436,
        81.64665177503117,
        81.6547785287518,
        81.66289437380622,
        81.67099931019443,
        81.67909333791643,
        81.68717645697221,
        81.69524866736184,
        81.70330996908528,
        81.71136036214251,
        81.71939984653353,
        81.72742842225834,
        81.735446089317,
        81.74345284770946,
        81.75144869743572,
        81.75943363849579,
        81.7674076708896,
        81.77537079461725,
        81.78332300967871,
        81.79126431607399,
        81.79919471380309,
        81.80711420286592,
        81.81502278326259,
        81.82292045499308,
        81.83080721805739,
        81.83868307245548,
        81.84654801818739,
        81.85440205525306,
        81.86224518365255,
        81.87007740338585,
        81.87789871445297,
        81.8857091168539,
        81.8935086105886,
        81.90129719565711,
        81.90907487205943,
        81.91684163979555,
        81.92459749886551,
        81.93234244926926,
        81.94007649100676,
        81.94779962407809,
        81.95551184848325,
        81.96321316422221,
        81.97090357129498,
        81.97858306970151,
        81.98625165944189,
        81.99390934051603,
        82.001556112924,
        82.0091919766658,
        82.01681693174139,
        82.02443097815073,
        82.0320341158939,
        82.0396263449709,
        82.04720766538169,
        82.0547780771263,
        82.0623375802047,
        82.06988617461691,
        82.07742386036288,
        82.0849506374427,
        82.09246650585634,
        82.09997146560376,
        82.10746551668497,
        82.11494865909997,
        82.12242089284881,
        82.12988221793147,
        82.13733263434791,
        82.14477214209812,
        82.1522007411822,
        82.15961843160001,
        82.16702521335166,
        82.17442108643714,
        82.18180605085642,
        82.18918010660947,
        82.1965432536963,
        82.20389549211698,
        82.21123682187148,
        82.21856724295976,
        82.22588675538184,
        82.23319535913772,
        82.2404930542274,
        82.24777984065089,
        82.25505571840823,
        82.26232068749933,
        82.26957474792421,
        82.27681789968291,
        82.28405014277543,
        82.29127147720176,
        82.29848190296188,
        82.30568142005582,
        82.31287002848354,
        82.32004772824503,
        82.32721451934039,
        82.33437040176953,
        82.3415153755325,
        82.34864944062922,
        82.35577259705975,
        82.36288484482414,
        82.36998618392231,
        82.37707661435427,
        82.38415613612004,
        82.3912247492196,
        82.39828245365295,
        82.40532924942015,
        82.41236513652113,
        82.41939011495593,
        82.42640418472449,
        82.43340734582686,
        82.44039959826308,
        82.44738094203309,
        82.45435137713692,
        82.46131090357453,
        82.46825952134593,
        82.47519723045112,
        82.48212403089015,
        82.489039922663,
        82.49594490576963,
        82.50283898021003,
        82.5097221459843,
        82.5165944030923,
        82.52345575153417,
        82.53030619130983,
        82.53714572241928,
        82.54397434486252,
        82.55079205863954,
        82.55759886375041,
        82.5643947601951,
        82.57117974797357,
        82.57795382708584,
        82.58471699753191,
        82.59146925931178,
        82.59821061242549,
        82.60494105687299,
        82.6116605926543,
        82.61836921976935,
        82.62506693821824,
        82.63175374800095,
        82.63842964911747,
        82.64509464156781,
        82.65174872535188,
        82.65839190046982,
        82.66502416692153,
        82.67164552470707,
        82.67825597382641,
        82.68485551427956,
        82.69144414606647,
        82.6980218691872,
        82.70458868364175,
        82.7111445894301,
        82.71768958655228,
        82.72422367500822,
        82.730746854798,
        82.73725912592154,
        82.7437604883789,
        82.7502509421701,
        82.75673048729509,
        82.76319912375384,
        82.7696568515464,
        82.77610367067281,
        82.78253958113301,
        82.78896458292702,
        82.7953786760548,
        82.80178186051641,
        82.80817413631179,
        82.81455550344101,
        82.82092596190405,
        82.82728551170088,
        82.83363415283146,
        82.83997188529587,
        82.84629870909411,
        82.85261462422618,
        82.85891963069203,
        82.86521372849167,
        82.8714969176251,
        82.87776919809231,
        82.88403056989337,
        82.89028103302824,
        82.89652058749694,
        82.90274923329936,
        82.9089669704356,
        82.91517379890568,
        82.92136971870958,
        82.92755472984727,
        82.93372883231878,
        82.93989202612404,
        82.9460443112631,
        82.95218568773602,
        82.95831615554273,
        82.96443571468323,
        82.97054436515752,
        82.9766421069656,
        82.98272894010752,
        82.98880486458326
    ],
    PICKLEBALL: [],
    // Lacrosse throws a platform tennis ball, so the measured RPM->MPH
    // curve is the same one. Referenced, not copied, so the two can never
    // drift apart.
    LACROSSE: []
};
// Lacrosse is thrown with a platform tennis ball, so it shares that ball's
// measured RPM->MPH curve exactly. Aliased rather than copied so the two
// cannot drift apart, and so we do not duplicate ~5000 sampled floats.
$1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_20ABCDEF.LACROSSE = $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_20ABCDEF.PLATFORM_TENNIS;
module.exports.tableRPM2MPHMap = {
    "physics-20B-base": $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_20ABCDEF,
    "physics-20C-base": $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_20ABCDEF,
    "physics-20D-base": $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_20ABCDEF,
    "physics-20E-base": $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_20ABCDEF,
    "physics-20F-base": $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_20ABCDEF,
    "physics-20G-base": $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_20ABCDEF,
    "physics-20H-base": $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_20ABCDEF,
    "physics-20I-base": $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_20ABCDEF,
    "physics-20X-base": $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_20ABCDEF,
    "physics-30A-base": $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_30A,
    "physics-30B-base": $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_30B,
    "physics-30C-base": $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_30B,
    "physics-30D-base": $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_30B,
    "physics-30E-base": $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_30B,
    "physics-30X-base": $1bf2f8fd5ab9fb2d$var$RPM2MPH_ATOM_30B
};

});

parcelRegister("gV6Yw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tableSpinAdjustMap = void 0;
module.exports.deflectionAngleAtom = $c51761562cd7cff4$var$deflectionAngleAtom;
module.exports.launchDeflectionCorrection = $c51761562cd7cff4$var$launchDeflectionCorrection;

var $lfLSf = parcelRequire("lfLSf");

var $fdyC4 = parcelRequire("fdyC4");
// ____________________________________________________________________________
// ATOM
// Is spin axis aligned with a single motor (e.g. topsin)?
function $c51761562cd7cff4$var$isOneMotorAtom(axis) {
    return axis === 0 || axis === 120 || axis === 240 || axis === 360 || axis === -120 || axis === -240 || axis === -360;
}
// Is spin axis aligned with two motors (e.g. backspin)?
function $c51761562cd7cff4$var$isTwoMotorAtom(axis) {
    return axis === 60 || axis === 180 || axis === 300 || axis === -60 || axis === -180 || axis === -300;
}
// compute the launch deflection angle for a given spin rotation axis (degrees)
// and launch speed (MPH).
// NOTE: this function was determined via cubic polynomial fit of empirical
// deflection data.
function $c51761562cd7cff4$var$deflectionAngleAtom(axisDeg, speedMPH) {
    let angDeg = 0;
    // one motor: e.g. topspin
    if ($c51761562cd7cff4$var$isOneMotorAtom(axisDeg)) angDeg = 2.049e-5 * speedMPH * speedMPH * speedMPH + 0.002078 * speedMPH * speedMPH - 0.1768 * speedMPH - 0.01364;
    // two motor: e.g. backspin
    if ($c51761562cd7cff4$var$isTwoMotorAtom(axisDeg)) angDeg = 6.453e-5 * speedMPH * speedMPH * speedMPH - 0.01165 * speedMPH * speedMPH + 0.4449 * speedMPH - 0.01287;
    return angDeg;
}
/**
 * launchDeflectionCorrection
 * When we apply ball spin around an axis (e.g. axis 0 degrees = topspin), the motor differential (e.g. topspin
 * has top motor spinning much faster than bottom 2 equal-RPM motors) causes a launch "deflection"; i.e. for a
 * straight-on shot the ball is launched not straight but down with a "deflection angle" caused by the motor
 * differential. This deflection is always "with the spin" (e.g. topspin --> down, backspin --> up).
 * To undo this deflection and shoot straight, a corrective pitch and/or yaw must be applied to any shot
 * with spin.
 * This function converts a (spin axis, deflection angle degrees) pair into the (pitch, yaw) adjustments that
 * must be added to a shot to correct for launch deflection.
 *
 * @param axisDeg: spin axis of rotation in degrees (0=topspin, 180=backspin), clockwise
 * @param defDeg: deflection angle in degrees: must be in (-90, 90)
 * @returns { pitch, yaw, dvect }: pitch and yaw angles (degrees) to ADD to the shot, and
 * the deflection vector (in launch coords) that was corrected (for debugging).
 */ function $c51761562cd7cff4$var$launchDeflectionCorrection(axisDeg, defDeg) {
    // console.log(`launchDeflectionCorrection: AxisDeg=${axisDeg} deg, def=${defDeg}`);
    const out = {
        pitch: 0,
        yaw: 0,
        dvect: {
            x: 0,
            y: 0,
            z: 0
        }
    };
    if (defDeg === 0) return out;
    // NOTE: avoid gimbal lock, and deflection will never be close to 90 in any case
    (0, $lfLSf.assert)(Math.abs(axisDeg) <= 360, `Illegal spin axis ${axisDeg} deg (must be in (-360, 360))`);
    (0, $lfLSf.assert)(Math.abs(defDeg) < 90, `Illegal deflection angle ${defDeg} deg (must be in (-90, 90))`);
    // Rotate the launch coord system so that x axis aligns with spin rotation axis
    // Now we have a rotated coord system with basis cols: [ xrot, y, zrot ].
    const xv = {
        x: 1,
        y: 0,
        z: 0
    };
    const zv = {
        x: 0,
        y: 0,
        z: 1
    };
    const xrot = (0, $fdyC4.cartesianRotation)(xv, "y", -axisDeg);
    const zrot = (0, $fdyC4.cartesianRotation)(zv, "y", -axisDeg);
    // Our deflection vector is a rotation of the unit y "launch direction" vector
    // by angle of -defDeg about x axis. Negative because deflection is "with the spin".
    const yv = {
        x: 0,
        y: 1,
        z: 0
    };
    const dvr = (0, $fdyC4.cartesianRotation)(yv, "x", -defDeg);
    // console.log(`deflectionToYawPitch: dvr=${dvr.x},${dvr.y},${dvr.z}`);
    // Get the coords of deflection vector wrt orignal launch coord frame
    const dvsx = xrot.x * dvr.x + yv.x * dvr.y + zrot.x * dvr.z;
    const dvsy = xrot.y * dvr.x + yv.y * dvr.y + zrot.y * dvr.z;
    const dvsz = xrot.z * dvr.x + yv.z * dvr.y + zrot.z * dvr.z;
    // console.log(`launchDeflectionCorrection: deflection vector: ${dvsx}, ${dvsy}, ${dvsz}`);
    (0, $lfLSf.assert)(dvsy > 0, "Illegal 0 or backward deflection vector");
    // note: divisions are well-conditioned as long as dvsy non-zero
    const yawDeg = -1 * (Math.atan(dvsx / dvsy) * (180.0 / Math.PI));
    const pitchDeg = -1 * (Math.atan(dvsz / Math.sqrt(dvsx * dvsx + dvsy * dvsy)) * (180.0 / Math.PI));
    // console.log(`launchDeflectionCorrection: yaw: ${yawDeg}, pitch: ${pitchDeg} degrees`);
    out.yaw = yawDeg;
    out.pitch = pitchDeg;
    out.dvect = {
        x: dvsx,
        y: dvsy,
        z: dvsz
    };
    return out;
}
// deflectionCorrectionAtom
// Determines the correction that must be applied to a shot with spin to offset the
// launch deflection that occurs as a result of ball spin.
// The pitchAdjust and yawAdjust (degrees) fields of the output are the values that
// should be added to the shot settings in order to produce a straight shot.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $c51761562cd7cff4$var$deflectionCorrectionAtom(axisDeg, launchSpeedMPS) {
    const sMPH = launchSpeedMPS * 2.23694;
    const correction = {
        axis: axisDeg,
        speed: launchSpeedMPS,
        deflectionAngle: 0,
        deflectionVector: {
            x: 0,
            y: 0,
            z: 0
        },
        pitchAdjust: 0,
        yawAdjust: 0
    };
    // outside this range deflection negligible according to our measurements
    if (sMPH > 55 || sMPH <= 0) return correction;
    // NOTE: function deflectionAngleAtom takes in a clockwise axis in degrees with 0 = up;
    // axisDeg coming in is counterclockwise degrees with 0 = up
    const cwAxis = 360 - axisDeg;
    // get the deflection angle for this launch
    // NOTE: the deflection angle AngDeg is >=0 for backspin ("up") and <=0 for topspin ("down").
    const angDeg = $c51761562cd7cff4$var$deflectionAngleAtom(cwAxis, sMPH);
    correction.deflectionAngle = angDeg;
    // Compute yaw and tilt correction and deflection vector from angular deflection
    // NOTE: correction "knows" that the deflection is "with the spin", so it needs only
    // deflection magnitude.
    const { pitch: pitch, yaw: yaw, dvect: dvect } = $c51761562cd7cff4$var$launchDeflectionCorrection(cwAxis, Math.abs(angDeg));
    correction.pitchAdjust = pitch;
    correction.yawAdjust = yaw;
    correction.deflectionVector = dvect;
    return correction;
}
// scale spin to better match empirical measurements that vary from the
// mathematical model (due to dual-motor vs single-motor spins).
function $c51761562cd7cff4$var$spinDampingFactorAtom(spinAxisDeg) {
    const cwAxis = 360 - spinAxisDeg;
    const M = 0.44;
    const arad = cwAxis * (Math.PI / 180.0);
    const magFactor = M / 2.0 * Math.sin(3.0 * arad - Math.PI / 2.0) + M / 2.0 + 1;
    const dampFactor = 1.0 / magFactor;
    return dampFactor;
}
// Returns a speed damping factor
function $c51761562cd7cff4$var$speedDampingFactorAtom(spinAxisDeg) {
    const cwAxis = 360 - spinAxisDeg;
    const M = 0.09;
    const arad = cwAxis * (Math.PI / 180.0);
    const factor = M / 2.0 * Math.sin(3.0 * arad - Math.PI / 2.0) + M / 2.0 + 1;
    return factor;
}
// Atom shot speed adjustment based on spin and speed
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $c51761562cd7cff4$var$speedAdjustAtom(speedspin) {
    (0, $lfLSf.assert)(speedspin.spin !== null, "speedAdjustAtom: speedspin 'spin' value must be non-null");
    // no spin: nothing to do
    if (speedspin.spin === null || speedspin.spin === 0) return speedspin.speed;
    const { speed: speed, spin: spin } = speedspin;
    // we model ONLY "on-motor" spins
    const isSingleMotor = $c51761562cd7cff4$var$isOneMotorAtom(speedspin.spinAxis);
    const isDualMotor = $c51761562cd7cff4$var$isTwoMotorAtom(speedspin.spinAxis);
    if (!isSingleMotor && !isDualMotor) return speed;
    let newspeed = speed;
    // DUAL MOTOR
    // ramp speed scale factor from 1 to 1.11 over spins [0, 1500]
    if (isDualMotor) {
        const delta = (1.11 - 1.0) / 1500;
        if (spin > 1500) newspeed = speed * 1.11;
        else newspeed = speed * (1.0 + delta * spin);
    }
    // SINGLE MOTOR
    // if spin > 1500, ramp speed scale factor from 0.83 to 1 over speeds [0, 30]
    if (isSingleMotor) {
        const delta = (1.0 - 0.83) / 13.41;
        if (spin < 1500) newspeed = speed;
        if (speed > 13.41) newspeed = speed;
        else newspeed = speed * (0.83 + delta * speed);
    }
    return newspeed;
}
// Atom shot spin adjustment based on spin and speed
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $c51761562cd7cff4$var$spinAdjustAtom(speedspin) {
    (0, $lfLSf.assert)(speedspin.spin !== null, "spinAdjustAtom: speedspin 'spin' value must be non-null");
    // no spin: nothing to do
    if (speedspin.spin === null || speedspin.spin === 0) return 0;
    const { spin: spin, speed: speed } = speedspin;
    // we model ONLY "on-motor" spins
    const isSingleMotor = $c51761562cd7cff4$var$isOneMotorAtom(speedspin.spinAxis);
    const isDualMotor = $c51761562cd7cff4$var$isTwoMotorAtom(speedspin.spinAxis);
    if (!isSingleMotor && !isDualMotor) return spin;
    let newspin = spin;
    // DUAL MOTOR
    // ramp spin scale factor from 1 to 0.689 over spins [0, 1500]
    if (isDualMotor) {
        const delta = -1 * (0.311 / 1500);
        if (spin > 1500) newspin = spin * 0.689;
        else newspin = spin * (1.0 + delta * spin);
    }
    // SINGLE MOTOR
    // if spin is > 1500 RPM: ramp spin scale factor from 1 to 0.83 over [30, 45] MPH
    if (isSingleMotor) {
        const delta = (0.83 - 1.0) / (20.11 - 13.41);
        if (spin < 1500) newspin = spin;
        if (speed < 13.41) newspin = spin;
        else if (speed > 20.11) newspin = spin * 0.83;
        else newspin = spin * (1 + (speed - 13.41) * delta);
    }
    return newspin;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $c51761562cd7cff4$var$speedAdjustAtomInverse(speedspin) {
    (0, $lfLSf.assert)(speedspin.spin !== null, "speedAdjustAtom: speedspin 'spin' value must be non-null");
    // no spin: nothing to do
    if (speedspin.spin === null || speedspin.spin === 0) return speedspin.speed;
    const { speed: speed, spin: spin } = speedspin;
    // we model ONLY "on-motor" spins
    const isSingleMotor = $c51761562cd7cff4$var$isOneMotorAtom(speedspin.spinAxis);
    const isDualMotor = $c51761562cd7cff4$var$isTwoMotorAtom(speedspin.spinAxis);
    if (!isSingleMotor && !isDualMotor) return speed;
    let newspeed = speed;
    // DUAL MOTOR
    if (isDualMotor) {
        const delta = (1.11 - 1.0) / 1500;
        if (spin > 1500) newspeed = speed / 1.11;
        else newspeed = speed / (1.0 + delta * spin);
    }
    // SINGLE MOTOR
    if (isSingleMotor) {
        const delta = (1.0 - 0.83) / 13.41;
        if (spin < 1500) newspeed = speed;
        if (speed > 13.41) newspeed = speed;
        else newspeed = (-0.83 + Math.sqrt(0.6889 + 4 * delta * speed)) / (2 * delta);
    }
    return newspeed;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $c51761562cd7cff4$var$spinAdjustAtomInverse(speedspin) {
    (0, $lfLSf.assert)(speedspin.spin !== null, "spinAdjustAtom: speedspin 'spin' value must be non-null");
    // no spin: nothing to do
    if (speedspin.spin === null || speedspin.spin === 0) return 0;
    const { spin: spin, speed: speed } = speedspin;
    // we model ONLY "on-motor" spins
    const isSingleMotor = $c51761562cd7cff4$var$isOneMotorAtom(speedspin.spinAxis);
    const isDualMotor = $c51761562cd7cff4$var$isTwoMotorAtom(speedspin.spinAxis);
    if (!isSingleMotor && !isDualMotor) return spin;
    let newspin = spin;
    // DUAL MOTOR
    if (isDualMotor) {
        const delta = -1 * (0.311 / 1500);
        if (spin > 1033.5) newspin = spin * (1.0 / 0.689);
        else newspin = (-1 + Math.sqrt(1 + 4 * delta * spin)) / (2 * delta);
    }
    // SINGLE MOTOR
    if (isSingleMotor) {
        const delta = (0.83 - 1.0) / (20.11 - 13.41);
        if (speed < 13.41) newspin = spin;
        else {
            let oldspin = 0;
            if (speed > 20.11) oldspin = spin * (1.0 / 0.83);
            else oldspin = spin / (1 + (speed - 13.41) * delta);
            // adjust was only applied to spins > 1500
            if (oldspin < 1500) newspin = spin;
            else newspin = oldspin;
        }
    }
    return newspin;
}
const $c51761562cd7cff4$var$spinSpeedAdjustAtom = {
    spinDampingFactor: $c51761562cd7cff4$var$spinDampingFactorAtom,
    speedDampingFactor: $c51761562cd7cff4$var$speedDampingFactorAtom,
    deflectionCorrection: null
};
const $c51761562cd7cff4$var$spinSpeedAdjustNone = {
    spinDampingFactor: null,
    speedDampingFactor: null,
    deflectionCorrection: null
};
const $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_20ABCDEF = {
    PLATFORM_TENNIS: $c51761562cd7cff4$var$spinSpeedAdjustAtom,
    PADEL: $c51761562cd7cff4$var$spinSpeedAdjustNone,
    TENNIS: $c51761562cd7cff4$var$spinSpeedAdjustNone,
    PICKLEBALL: $c51761562cd7cff4$var$spinSpeedAdjustNone,
    // Lacrosse throws a platform tennis ball through the same wheel
    // assembly, so it inherits platform tennis's spin/speed damping.
    LACROSSE: $c51761562cd7cff4$var$spinSpeedAdjustAtom
};
const $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_30A = {
    PLATFORM_TENNIS: $c51761562cd7cff4$var$spinSpeedAdjustNone,
    PADEL: $c51761562cd7cff4$var$spinSpeedAdjustNone,
    TENNIS: $c51761562cd7cff4$var$spinSpeedAdjustNone,
    PICKLEBALL: $c51761562cd7cff4$var$spinSpeedAdjustNone,
    LACROSSE: $c51761562cd7cff4$var$spinSpeedAdjustNone
};
const $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_30B = {
    PLATFORM_TENNIS: $c51761562cd7cff4$var$spinSpeedAdjustNone,
    PADEL: $c51761562cd7cff4$var$spinSpeedAdjustNone,
    TENNIS: $c51761562cd7cff4$var$spinSpeedAdjustNone,
    PICKLEBALL: $c51761562cd7cff4$var$spinSpeedAdjustNone,
    LACROSSE: $c51761562cd7cff4$var$spinSpeedAdjustNone
};
module.exports.tableSpinAdjustMap = {
    "physics-20B-base": $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_20ABCDEF,
    "physics-20C-base": $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_20ABCDEF,
    "physics-20D-base": $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_20ABCDEF,
    "physics-20E-base": $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_20ABCDEF,
    "physics-20F-base": $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_20ABCDEF,
    "physics-20G-base": $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_20ABCDEF,
    "physics-20H-base": $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_20ABCDEF,
    "physics-20I-base": $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_20ABCDEF,
    "physics-20X-base": $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_20ABCDEF,
    "physics-30A-base": $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_30A,
    "physics-30B-base": $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_30B,
    "physics-30C-base": $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_30B,
    "physics-30D-base": $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_30B,
    "physics-30E-base": $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_30B,
    "physics-30X-base": $c51761562cd7cff4$var$SPINSPEED_ADJUST_ATOM_30B
};

});
parcelRegister("lfLSf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assert = $f790227bded06391$var$assert;
// TODO: include this from somewhere else?
function $f790227bded06391$var$assert(assertion, message) {
    if (!assertion) {
        const errorForStack = new Error(`Assertion Failed: ${message}`);
        console.error(`Assertion failed: ${message}\n${errorForStack.stack}`);
        throw errorForStack;
    }
}

});


parcelRegister("bRtcj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tableTrainerGeometryMap = void 0;

var $2Yg5G = parcelRequire("2Yg5G");
const $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_20B = {
    cameraOffsetFromHead: {
        x: -2.36 * $2Yg5G.metersPerInch,
        y: 11.77 * $2Yg5G.metersPerInch,
        z: 32.07 * $2Yg5G.metersPerInch
    },
    cameraDownwardPitch: 7.0,
    secondaryCameraOffsetFromHead: {
        x: 6.252 * $2Yg5G.metersPerInch,
        y: 11.776 * $2Yg5G.metersPerInch,
        z: 6.308 * $2Yg5G.metersPerInch
    },
    secondaryCameraDownwardPitch: 24.0,
    liftOrigin: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 31.87 * $2Yg5G.metersPerInch,
        z: 42.86 * $2Yg5G.metersPerInch
    },
    liftPivotPosition: {
        x: 0 * $2Yg5G.metersPerInch,
        y: -5.63 * $2Yg5G.metersPerInch,
        z: 42.86 * $2Yg5G.metersPerInch
    },
    liftArmLength: 37.5 * $2Yg5G.metersPerInch,
    defaultLaunchPointOffset: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 12.89 * $2Yg5G.metersPerInch,
        z: 17.75 * $2Yg5G.metersPerInch
    },
    // launchOriginOffset: offset of launch coord system origin from lift arm end
    // NOTE: origin is launchDistanceFromRotationCenter behind the default
    // launch point in Y.
    launchOriginOffset: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 10.09 * $2Yg5G.metersPerInch,
        z: 17.75 * $2Yg5G.metersPerInch
    },
    // distance from launch assembly center of rotation to launch point
    launchDistanceFromRotationCenter: 2.8 * $2Yg5G.metersPerInch
};
const $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_20CDEF = {
    cameraOffsetFromHead: {
        x: -2.36 * $2Yg5G.metersPerInch,
        y: 11.77 * $2Yg5G.metersPerInch,
        z: 32.07 * $2Yg5G.metersPerInch
    },
    cameraDownwardPitch: 7.0,
    secondaryCameraOffsetFromHead: {
        x: 7.935 * $2Yg5G.metersPerInch,
        y: 12.72 * $2Yg5G.metersPerInch,
        z: 4.884 * $2Yg5G.metersPerInch
    },
    secondaryCameraDownwardPitch: 24.0,
    liftOrigin: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 31.87 * $2Yg5G.metersPerInch,
        z: 42.86 * $2Yg5G.metersPerInch
    },
    liftPivotPosition: {
        x: 0 * $2Yg5G.metersPerInch,
        y: -5.63 * $2Yg5G.metersPerInch,
        z: 42.86 * $2Yg5G.metersPerInch
    },
    liftArmLength: 37.5 * $2Yg5G.metersPerInch,
    defaultLaunchPointOffset: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 12.89 * $2Yg5G.metersPerInch,
        z: 17.75 * $2Yg5G.metersPerInch
    },
    // launchOriginOffset: offset of launch coord system origin from lift arm end
    // NOTE: origin is launchDistanceFromRotationCenter behind the default
    // launch point in Y.
    launchOriginOffset: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 10.09 * $2Yg5G.metersPerInch,
        z: 17.75 * $2Yg5G.metersPerInch
    },
    // distance from launch assembly center of rotation to launch point
    launchDistanceFromRotationCenter: 2.8 * $2Yg5G.metersPerInch
};
const $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_20G = {
    // The 20G has the "swept forward and up" roll bar, just
    // like the 20H
    cameraOffsetFromHead: {
        x: -2.36 * $2Yg5G.metersPerInch,
        y: 14.77 * $2Yg5G.metersPerInch,
        z: 37.07 * $2Yg5G.metersPerInch
    },
    cameraDownwardPitch: 7.0,
    // A difference between 20F and 20G
    // is the minicam has been moved, and the downward
    // pitch of the cam is now 25 degrees.
    secondaryCameraOffsetFromHead: {
        x: -7.663 * $2Yg5G.metersPerInch,
        y: 12.451 * $2Yg5G.metersPerInch,
        z: 5.264 * $2Yg5G.metersPerInch
    },
    secondaryCameraDownwardPitch: 25.0,
    liftOrigin: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 31.87 * $2Yg5G.metersPerInch,
        z: 42.86 * $2Yg5G.metersPerInch
    },
    liftPivotPosition: {
        x: 0 * $2Yg5G.metersPerInch,
        y: -5.63 * $2Yg5G.metersPerInch,
        z: 42.86 * $2Yg5G.metersPerInch
    },
    liftArmLength: 37.5 * $2Yg5G.metersPerInch,
    defaultLaunchPointOffset: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 12.89 * $2Yg5G.metersPerInch,
        z: 17.75 * $2Yg5G.metersPerInch
    },
    // launchOriginOffset: offset of launch coord system origin from lift arm end
    // NOTE: origin is launchDistanceFromRotationCenter behind the default
    // launch point in Y.
    launchOriginOffset: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 10.09 * $2Yg5G.metersPerInch,
        z: 17.75 * $2Yg5G.metersPerInch
    },
    // distance from launch assembly center of rotation to launch point
    launchDistanceFromRotationCenter: 2.8 * $2Yg5G.metersPerInch
};
const $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_20H = {
    // Note: this is what differentiates the 20H from 20CDEF.
    // The roll bar is swept forward 3 inches (like 30B),
    // and raised up by 5 inches.
    cameraOffsetFromHead: {
        x: -2.36 * $2Yg5G.metersPerInch,
        y: 14.77 * $2Yg5G.metersPerInch,
        z: 37.07 * $2Yg5G.metersPerInch
    },
    cameraDownwardPitch: 7.0,
    secondaryCameraOffsetFromHead: {
        x: 7.935 * $2Yg5G.metersPerInch,
        y: 12.72 * $2Yg5G.metersPerInch,
        z: 4.884 * $2Yg5G.metersPerInch
    },
    secondaryCameraDownwardPitch: 24.0,
    liftOrigin: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 31.87 * $2Yg5G.metersPerInch,
        z: 42.86 * $2Yg5G.metersPerInch
    },
    liftPivotPosition: {
        x: 0 * $2Yg5G.metersPerInch,
        y: -5.63 * $2Yg5G.metersPerInch,
        z: 42.86 * $2Yg5G.metersPerInch
    },
    liftArmLength: 37.5 * $2Yg5G.metersPerInch,
    defaultLaunchPointOffset: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 12.89 * $2Yg5G.metersPerInch,
        z: 17.75 * $2Yg5G.metersPerInch
    },
    // launchOriginOffset: offset of launch coord system origin from lift arm end
    // NOTE: origin is launchDistanceFromRotationCenter behind the default
    // launch point in Y.
    launchOriginOffset: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 10.09 * $2Yg5G.metersPerInch,
        z: 17.75 * $2Yg5G.metersPerInch
    },
    // distance from launch assembly center of rotation to launch point
    launchDistanceFromRotationCenter: 2.8 * $2Yg5G.metersPerInch
};
const $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_30A = {
    cameraOffsetFromHead: {
        x: -2.36 * $2Yg5G.metersPerInch,
        y: 11.77 * $2Yg5G.metersPerInch,
        z: 32.07 * $2Yg5G.metersPerInch
    },
    cameraDownwardPitch: 7.0,
    secondaryCameraOffsetFromHead: {
        x: 7.935 * $2Yg5G.metersPerInch,
        y: 12.72 * $2Yg5G.metersPerInch,
        z: 4.884 * $2Yg5G.metersPerInch
    },
    secondaryCameraDownwardPitch: 24.0,
    liftOrigin: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 31.87 * $2Yg5G.metersPerInch,
        z: 42.86 * $2Yg5G.metersPerInch
    },
    liftPivotPosition: {
        x: 0 * $2Yg5G.metersPerInch,
        y: -5.63 * $2Yg5G.metersPerInch,
        z: 42.86 * $2Yg5G.metersPerInch
    },
    liftArmLength: 37.5 * $2Yg5G.metersPerInch,
    defaultLaunchPointOffset: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 12.89 * $2Yg5G.metersPerInch,
        z: 17.75 * $2Yg5G.metersPerInch
    },
    // launchOriginOffset: offset of launch coord system origin from lift arm end
    // NOTE: origin is launchDistanceFromRotationCenter behind the default
    // launch point in Y.
    launchOriginOffset: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 10.09 * $2Yg5G.metersPerInch,
        z: 17.75 * $2Yg5G.metersPerInch
    },
    // distance from launch assembly center of rotation to launch point
    launchDistanceFromRotationCenter: 2.8 * $2Yg5G.metersPerInch
};
const $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_30B = {
    // NOTE: the only change from 30A to 30B is the rollbar (and thus camera)
    // is pushed forward 3 inches.
    cameraOffsetFromHead: {
        x: -2.36 * $2Yg5G.metersPerInch,
        y: 14.77 * $2Yg5G.metersPerInch,
        z: 32.07 * $2Yg5G.metersPerInch
    },
    cameraDownwardPitch: 7.0,
    secondaryCameraOffsetFromHead: {
        x: 7.935 * $2Yg5G.metersPerInch,
        y: 12.72 * $2Yg5G.metersPerInch,
        z: 4.884 * $2Yg5G.metersPerInch
    },
    secondaryCameraDownwardPitch: 24.0,
    liftOrigin: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 31.87 * $2Yg5G.metersPerInch,
        z: 42.86 * $2Yg5G.metersPerInch
    },
    liftPivotPosition: {
        x: 0 * $2Yg5G.metersPerInch,
        y: -5.63 * $2Yg5G.metersPerInch,
        z: 42.86 * $2Yg5G.metersPerInch
    },
    liftArmLength: 37.5 * $2Yg5G.metersPerInch,
    defaultLaunchPointOffset: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 12.89 * $2Yg5G.metersPerInch,
        z: 17.75 * $2Yg5G.metersPerInch
    },
    // launchOriginOffset: offset of launch coord system origin from lift arm end
    // NOTE: origin is launchDistanceFromRotationCenter behind the default
    // launch point in Y.
    launchOriginOffset: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 10.09 * $2Yg5G.metersPerInch,
        z: 17.75 * $2Yg5G.metersPerInch
    },
    // distance from launch assembly center of rotation to launch point
    launchDistanceFromRotationCenter: 2.8 * $2Yg5G.metersPerInch
};
const $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_30C = {
    // NOTE: the only change from 30B to 30C is the rollbar (and thus camera)
    // is up higher (e.g. it has the swept-foward and up rollbar)
    cameraOffsetFromHead: {
        x: -2.36 * $2Yg5G.metersPerInch,
        y: 14.77 * $2Yg5G.metersPerInch,
        z: 37.07 * $2Yg5G.metersPerInch
    },
    cameraDownwardPitch: 7.0,
    secondaryCameraOffsetFromHead: {
        x: 7.935 * $2Yg5G.metersPerInch,
        y: 12.72 * $2Yg5G.metersPerInch,
        z: 4.884 * $2Yg5G.metersPerInch
    },
    secondaryCameraDownwardPitch: 24.0,
    liftOrigin: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 31.87 * $2Yg5G.metersPerInch,
        z: 42.86 * $2Yg5G.metersPerInch
    },
    liftPivotPosition: {
        x: 0 * $2Yg5G.metersPerInch,
        y: -5.63 * $2Yg5G.metersPerInch,
        z: 42.86 * $2Yg5G.metersPerInch
    },
    liftArmLength: 37.5 * $2Yg5G.metersPerInch,
    defaultLaunchPointOffset: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 12.89 * $2Yg5G.metersPerInch,
        z: 17.75 * $2Yg5G.metersPerInch
    },
    // launchOriginOffset: offset of launch coord system origin from lift arm end
    // NOTE: origin is launchDistanceFromRotationCenter behind the default
    // launch point in Y.
    launchOriginOffset: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 10.09 * $2Yg5G.metersPerInch,
        z: 17.75 * $2Yg5G.metersPerInch
    },
    // distance from launch assembly center of rotation to launch point
    launchDistanceFromRotationCenter: 2.8 * $2Yg5G.metersPerInch
};
const $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_30D = {
    // The 30D is the pickleball version of the 20G, it is
    // identical to 20G with the "swept forward and up" roll bar
    cameraOffsetFromHead: {
        x: -2.36 * $2Yg5G.metersPerInch,
        y: 14.77 * $2Yg5G.metersPerInch,
        z: 37.07 * $2Yg5G.metersPerInch
    },
    cameraDownwardPitch: 7.0,
    // 20G/30D has miniam moved to left, and the downward
    // pitch of the cam is now 25 degrees.
    secondaryCameraOffsetFromHead: {
        x: -7.663 * $2Yg5G.metersPerInch,
        y: 12.451 * $2Yg5G.metersPerInch,
        z: 5.264 * $2Yg5G.metersPerInch
    },
    secondaryCameraDownwardPitch: 25.0,
    liftOrigin: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 31.87 * $2Yg5G.metersPerInch,
        z: 42.86 * $2Yg5G.metersPerInch
    },
    liftPivotPosition: {
        x: 0 * $2Yg5G.metersPerInch,
        y: -5.63 * $2Yg5G.metersPerInch,
        z: 42.86 * $2Yg5G.metersPerInch
    },
    liftArmLength: 37.5 * $2Yg5G.metersPerInch,
    defaultLaunchPointOffset: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 12.89 * $2Yg5G.metersPerInch,
        z: 17.75 * $2Yg5G.metersPerInch
    },
    // launchOriginOffset: offset of launch coord system origin from lift arm end
    // NOTE: origin is launchDistanceFromRotationCenter behind the default
    // launch point in Y.
    launchOriginOffset: {
        x: 0 * $2Yg5G.metersPerInch,
        y: 10.09 * $2Yg5G.metersPerInch,
        z: 17.75 * $2Yg5G.metersPerInch
    },
    // distance from launch assembly center of rotation to launch point
    launchDistanceFromRotationCenter: 2.8 * $2Yg5G.metersPerInch
};
module.exports.tableTrainerGeometryMap = {
    "physics-20B-base": $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_20B,
    "physics-20C-base": $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_20CDEF,
    "physics-20D-base": $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_20CDEF,
    "physics-20E-base": $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_20CDEF,
    "physics-20F-base": $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_20CDEF,
    "physics-20G-base": $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_20G,
    "physics-20H-base": $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_20H,
    "physics-20I-base": $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_20H,
    "physics-20X-base": $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_20H,
    "physics-30A-base": $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_30A,
    "physics-30B-base": $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_30B,
    "physics-30C-base": $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_30C,
    "physics-30D-base": $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_30D,
    "physics-30E-base": $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_30D,
    "physics-30X-base": $8a2b4af62c0bbc86$var$GEOMETRY_ATOM_30D
};

});

parcelRegister("bCDPq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.threeWheelMechanism = $8762236e4e3247e3$var$threeWheelMechanism;
const $8762236e4e3247e3$var$MPS_PER_MPH = 0.44704;
const $8762236e4e3247e3$var$SQRT3 = Math.sqrt(3);
const $8762236e4e3247e3$var$HALF_SQRT3 = Math.sqrt(3) / 2.0;
const $8762236e4e3247e3$var$TOP_GAIN = 2.0 / 3;
const $8762236e4e3247e3$var$SIDE_GAIN = -1 / 3;
const $8762236e4e3247e3$var$LATERAL_GAIN = 1.0 / Math.sqrt(3);
/** Stands in for "no limit" from a wheel that cannot bound the spin. */ const $8762236e4e3247e3$var$UNBOUNDED_SPIN = 1e6;
/**
 * Ball RPM per wheel RPM of spin. v1 converts by the ratio of the wheel's
 * diameter to the ball's, but uses the ball's diameter for both, so the
 * ratio is exactly 1; the conversions stay explicit so that a real ratio
 * changes only this.
 */ const $8762236e4e3247e3$var$BALL_SPIN_PER_WHEEL_SPIN = 1;
const $8762236e4e3247e3$var$toBallSpin = (wheelRpm)=>$8762236e4e3247e3$var$BALL_SPIN_PER_WHEEL_SPIN * wheelRpm;
const $8762236e4e3247e3$var$toWheelSpin = (ballRpm)=>ballRpm / $8762236e4e3247e3$var$BALL_SPIN_PER_WHEEL_SPIN;
const $8762236e4e3247e3$var$SPIN_LEVELS = 10;
const $8762236e4e3247e3$var$NO_SPIN = Object.freeze({
    rpm: 0,
    axis: 0
});
const $8762236e4e3247e3$var$NO_CORRECTION = Object.freeze({
    pitch: 0,
    yaw: 0
});
const $8762236e4e3247e3$var$STOPPED = Object.freeze({
    top: 0,
    left: 0,
    right: 0
});
/** Angle of (x, y) in degrees, [0, 360), exactly as v1's vector2Angle. */ function $8762236e4e3247e3$var$axisAngle(x, y) {
    if (y === 0) return x < 0 ? 180.0 : 0;
    if (x === 0) return y > 0 ? 90.0 : 270.0;
    const angle = Math.atan(Math.abs(y) / Math.abs(x)) * 180.0 / Math.PI;
    if (x > 0 && y < 0) return 360.0 - angle;
    if (x < 0 && y > 0) return 180.0 - angle;
    if (x < 0 && y < 0) return 180.0 + angle;
    return angle;
}
/** A wheel whose share of the spin is within this of zero cannot limit it. */ const $8762236e4e3247e3$var$snapToZero = (share)=>Math.abs(share) < 1.0e-8 ? 0 : share;
/**
 * The most spin (wheel RPM) about `axis` that keeps every wheel on its side
 * of `limitRpm`, given the wheels' mean RPM.
 */ function $8762236e4e3247e3$var$maxSpinWithin(axis, launchRpm, limitRpm) {
    if (launchRpm === limitRpm) return 0;
    const radians = axis * (Math.PI / 180.0);
    const top = $8762236e4e3247e3$var$snapToZero(Math.cos(radians));
    const left = $8762236e4e3247e3$var$snapToZero(Math.cos(radians) - $8762236e4e3247e3$var$SQRT3 * Math.sin(radians));
    const right = $8762236e4e3247e3$var$snapToZero(Math.cos(radians) + $8762236e4e3247e3$var$SQRT3 * Math.sin(radians));
    const headroom = launchRpm - limitRpm;
    const toward = Math.sign(headroom);
    return Math.min(toward * top < 0 ? -1.5 * headroom * (1.0 / top) : $8762236e4e3247e3$var$UNBOUNDED_SPIN, toward * left > 0 ? 3.0 * headroom * (1.0 / left) : $8762236e4e3247e3$var$UNBOUNDED_SPIN, toward * right > 0 ? 3.0 * headroom * (1.0 / right) : $8762236e4e3247e3$var$UNBOUNDED_SPIN);
}
/** Builds the mechanism. The spec must already be valid (profile loading checks it). */ function $8762236e4e3247e3$var$threeWheelMechanism(spec) {
    const { mphByRpm: mphByRpm, minRpm: minRpm, maxRpm: maxRpm, maxSpinRpm: maxSpinRpm, speedDamping: speedDamping, spinDamping: spinDamping, deflection: deflection } = spec;
    const minSpeed = mphByRpm[0] * $8762236e4e3247e3$var$MPS_PER_MPH;
    const maxSpeed = mphByRpm[mphByRpm.length - 1] * $8762236e4e3247e3$var$MPS_PER_MPH;
    /** v1 mps2rpm: the band RPM whose speed is nearest, the lower on a tie. */ const rpmForSpeed = (speed)=>{
        if (!(speed >= 0)) throw new RangeError(`launch speed ${speed} must be >= 0`);
        const mph = Math.min(Math.max(speed, minSpeed), maxSpeed) / $8762236e4e3247e3$var$MPS_PER_MPH;
        let low = 0;
        let high = mphByRpm.length;
        while(low < high){
            const mid = low + high >>> 1;
            if (mphByRpm[mid] < mph) low = mid + 1;
            else high = mid;
        }
        if (low === 0) return minRpm;
        if (low === mphByRpm.length) return maxRpm;
        const above = Math.abs(mph - mphByRpm[low]);
        const below = Math.abs(mph - mphByRpm[low - 1]);
        return minRpm + (above < below ? low : low - 1);
    };
    /** v1 rpm2mps: the speed at the nearest whole RPM, clamped to the band. */ const speedForRpm = (rpm)=>{
        if (!(rpm >= 0)) throw new RangeError(`mean wheel RPM ${rpm} must be >= 0`);
        const whole = Math.round(Math.min(Math.max(rpm, minRpm), maxRpm));
        return mphByRpm[whole - minRpm] * $8762236e4e3247e3$var$MPS_PER_MPH;
    };
    /** v1 maxmotorspin_for_rpmspeed: the most wheel spin about `axis` at a mean wheel RPM. */ const maxWheelSpin = (axis, launchRpm)=>{
        if (launchRpm === 0) return 0;
        if (!(axis >= 0 && axis <= 360)) throw new RangeError(`spin axis ${axis} must be in [0, 360]`);
        return Math.min($8762236e4e3247e3$var$maxSpinWithin(axis, launchRpm, maxRpm), $8762236e4e3247e3$var$maxSpinWithin(axis, launchRpm, minRpm));
    };
    /** v1 spinlevel2motorspin: each level is the middle of its tenth of the spin range. */ const wheelSpinByLevel = Object.freeze(Array.from({
        length: $8762236e4e3247e3$var$SPIN_LEVELS + 1
    }, (_, level)=>level === 0 ? 0 : (level / 10.0 - 0.05) * maxSpinRpm));
    /** v1 motorspin2spinlevel: 0 only for no spin, else the tenth of the range it falls in. */ const levelForWheelSpin = (wheelRpm)=>{
        if (!(wheelRpm >= 0 && wheelRpm <= maxSpinRpm)) throw new RangeError(`wheel spin ${wheelRpm} RPM must be in [0, ${maxSpinRpm}]`);
        return wheelRpm === 0 ? 0 : Math.floor(wheelRpm / maxSpinRpm * 9.999) + 1;
    };
    const spinLevels = Object.freeze({
        toRpm: (level)=>{
            if (!(Number.isInteger(level) && level >= 0 && level <= $8762236e4e3247e3$var$SPIN_LEVELS)) throw new RangeError(`spin level ${level} must be a whole number in [0, ${$8762236e4e3247e3$var$SPIN_LEVELS}]`);
            return $8762236e4e3247e3$var$toBallSpin(wheelSpinByLevel[level]);
        },
        fromRpm: (rpm)=>{
            if (!(rpm >= 0)) throw new RangeError(`ball spin ${rpm} RPM must be >= 0`);
            return levelForWheelSpin($8762236e4e3247e3$var$toWheelSpin(rpm));
        },
        /**
         * v1 maxspinlevel: the level of the most spin, or the one below when
         * that level's own spin is more than the wheels can give. At some
         * speeds on the wheel-aligned axes the wheels can give a little more
         * than maxSpin, where v1 throws; that is level 10.
         */ maxAt: (axis, speed)=>{
            const most = Math.min(maxWheelSpin(axis, rpmForSpeed(speed)), maxSpinRpm);
            const level = levelForWheelSpin(most);
            return level > 0 && wheelSpinByLevel[level] > most ? level - 1 : level;
        }
    });
    const toMotors = (speed, spin)=>{
        if (!(speed >= 0)) throw new RangeError(`launch speed ${speed} must be >= 0`);
        const hasSpin = spin.rpm > 0;
        const launchRpm = rpmForSpeed(hasSpin && speedDamping ? speed * speedDamping(spin.axis) : speed);
        if (launchRpm === 0) return $8762236e4e3247e3$var$STOPPED;
        if (!hasSpin) return $8762236e4e3247e3$var$wheelRpms(launchRpm, 0, 0);
        const achievable = Math.min($8762236e4e3247e3$var$toWheelSpin(spin.rpm), maxWheelSpin(spin.axis, launchRpm));
        const spinRpm = spinDamping ? achievable * spinDamping(spin.axis) : achievable;
        return $8762236e4e3247e3$var$wheelRpms(launchRpm, Math.cos(spin.axis * (Math.PI / 180.0)) * spinRpm, Math.sin(spin.axis * (Math.PI / 180.0)) * spinRpm);
    };
    const fromMotors = (rpms)=>{
        const { top: top, left: left, right: right } = rpms;
        const launchRpm = (top + left + right) / 3.0;
        const knuckleSpeed = speedForRpm(launchRpm);
        if (launchRpm === 0 || knuckleSpeed === 0) return {
            speed: knuckleSpeed,
            spin: $8762236e4e3247e3$var$NO_SPIN
        };
        const axis = $8762236e4e3247e3$var$axisAngle(top - 0.5 * left - 0.5 * right, $8762236e4e3247e3$var$HALF_SQRT3 * left - $8762236e4e3247e3$var$HALF_SQRT3 * right);
        const wheelSpin = Math.sqrt(0.5 * ((left - right) * (left - right) + (right - top) * (right - top) + (left - top) * (left - top)));
        return {
            speed: wheelSpin > 0 && speedDamping ? knuckleSpeed / speedDamping(axis) : knuckleSpeed,
            spin: {
                rpm: $8762236e4e3247e3$var$toBallSpin(spinDamping ? wheelSpin / spinDamping(axis) : wheelSpin),
                axis: axis
            }
        };
    };
    const deflectionCorrection = (spin, speed)=>{
        if (!(spin.rpm > 0 && deflection)) return $8762236e4e3247e3$var$NO_CORRECTION;
        const { pitchAdjust: pitchAdjust, yawAdjust: yawAdjust } = deflection(spin.axis, speed);
        return {
            pitch: pitchAdjust,
            yaw: yawAdjust
        };
    };
    return Object.freeze({
        toMotors: toMotors,
        fromMotors: fromMotors,
        deflectionCorrection: deflectionCorrection,
        limits: Object.freeze({
            maxSpeed: maxSpeed,
            minSpeed: minSpeed,
            maxSpin: $8762236e4e3247e3$var$toBallSpin(maxSpinRpm),
            rpm: Object.freeze({
                min: minRpm,
                max: maxRpm,
                maxSpin: maxSpinRpm
            })
        }),
        speedForRpm: speedForRpm,
        rpmForSpeed: rpmForSpeed,
        maxSpinAt: (axis, speed)=>$8762236e4e3247e3$var$toBallSpin(maxWheelSpin(axis, rpmForSpeed(speed))),
        spinLevels: spinLevels
    });
}
/** Wheel RPMs for a mean RPM and a spin vector (spinX, spinY) in wheel RPM. */ function $8762236e4e3247e3$var$wheelRpms(launchRpm, spinX, spinY) {
    return {
        top: $8762236e4e3247e3$var$TOP_GAIN * spinX + launchRpm,
        left: $8762236e4e3247e3$var$SIDE_GAIN * spinX + $8762236e4e3247e3$var$LATERAL_GAIN * spinY + launchRpm,
        right: $8762236e4e3247e3$var$SIDE_GAIN * spinX - $8762236e4e3247e3$var$LATERAL_GAIN * spinY + launchRpm
    };
}

});

parcelRegister("3P7gP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultVenue = module.exports.venueProblems = module.exports.v1Venue = module.exports.lacrosseField = void 0;

var $2Yg5G = parcelRequire("2Yg5G");

var $90lsY = parcelRequire("90lsY");

var $lO2oX = parcelRequire("lO2oX");

var $c4d8I = parcelRequire("c4d8I");

var $lO2oX = parcelRequire("lO2oX");
Object.defineProperty(module.exports, "lacrosseField", {
    enumerable: true,
    get: function() {
        return $lO2oX.lacrosseField;
    }
});

var $8OM0c = parcelRequire("8OM0c");
Object.defineProperty(module.exports, "v1Venue", {
    enumerable: true,
    get: function() {
        return $8OM0c.v1Venue;
    }
});

var $gGXrv = parcelRequire("gGXrv");
Object.defineProperty(module.exports, "venueProblems", {
    enumerable: true,
    get: function() {
        return $gGXrv.venueProblems;
    }
});
const $2c8bc64b637caef1$var$DEFAULT_VENUES = (0, $90lsY.deepFreeze)(Object.fromEntries($2Yg5G.Sports.map((sport)=>[
        sport,
        sport === "LACROSSE" ? (0, $lO2oX.lacrosseField)("ncaaWomens") : (0, $c4d8I.racquetVenue)(sport)
    ])));
/** The regulation court for a racquet sport; the NCAA women's half-field for lacrosse. */ const $2c8bc64b637caef1$var$defaultVenue = (sport)=>$2c8bc64b637caef1$var$DEFAULT_VENUES[sport];
module.exports.defaultVenue = $2c8bc64b637caef1$var$defaultVenue;

});
parcelRegister("lO2oX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lacrosseField = void 0;

var $2Yg5G = parcelRequire("2Yg5G");

var $90lsY = parcelRequire("90lsY");

var $kc6qZ = parcelRequire("kc6qZ");
/**
 * NCAA rulebooks, Rule 1, as read in webby-app's util/lacrosse/geometry.ts.
 * Meters where the rulebook writes meters, yards and feet where it writes
 * those.
 */ const $fe00215cf73e485b$var$FIELDS = {
    // 120 x 70 yd (the largest the rules allow, as physics' volume and the
    // protocol's stage have it), the goals 100 yd apart, a 2.6 m goal circle,
    // the restraining line 30 yd up field.
    ncaaWomens: {
        width: 70 * $2Yg5G.metersPerYard,
        toMidfield: 50 * $2Yg5G.metersPerYard,
        behindGoal: 10 * $2Yg5G.metersPerYard,
        creaseRadius: 2.6,
        toRestrainingLine: 30 * $2Yg5G.metersPerYard
    },
    // 110 x 60 yd, the goal line 15 yd off the end line, a 9 ft crease, the
    // restraining line 20 yd out.
    ncaaMens: {
        width: 60 * $2Yg5G.metersPerYard,
        toMidfield: 40 * $2Yg5G.metersPerYard,
        behindGoal: 15 * $2Yg5G.metersPerYard,
        creaseRadius: 3 * $2Yg5G.metersPerYard,
        toRestrainingLine: 20 * $2Yg5G.metersPerYard
    }
};
/** A 6 x 6 ft cage in both codes; its net meets the ground 7 ft behind the center of the goal line. */ const $fe00215cf73e485b$var$GOAL = {
    width: 6 * $2Yg5G.metersPerFoot,
    height: 6 * $2Yg5G.metersPerFoot,
    depth: 7 * $2Yg5G.metersPerFoot
};
/**
 * The protocol's lacrosse features. The goal is a prism, the cage's
 * footprint up to the crossbar; the crease is a circle. The women's 8 m arc
 * and 12 m fan wait for an `arc` kind.
 */ function $fe00215cf73e485b$var$fieldFeatures(f) {
    const hw = f.width / 2;
    const gw = $fe00215cf73e485b$var$GOAL.width / 2;
    return {
        center: (0, $kc6qZ.point)(0, 0),
        goal_line: (0, $kc6qZ.segment)(-gw, 0, gw, 0),
        goal_line_extended: (0, $kc6qZ.segment)(-hw, 0, hw, 0),
        goal: {
            kind: "polygon",
            points: [
                {
                    x: -gw,
                    y: 0
                },
                {
                    x: gw,
                    y: 0
                },
                {
                    x: 0,
                    y: $fe00215cf73e485b$var$GOAL.depth
                }
            ],
            z: {
                min: 0,
                max: $fe00215cf73e485b$var$GOAL.height
            }
        },
        crease: {
            kind: "circle",
            at: {
                x: 0,
                y: 0
            },
            radius: f.creaseRadius
        },
        restraining_line: (0, $kc6qZ.segment)(-hw, -f.toRestrainingLine, hw, -f.toRestrainingLine),
        midfield_line: (0, $kc6qZ.segment)(-hw, -f.toMidfield, hw, -f.toMidfield),
        end_line: (0, $kc6qZ.segment)(-hw, f.behindGoal, hw, f.behindGoal),
        sideline_left: (0, $kc6qZ.segment)(-hw, -f.toMidfield, -hw, f.behindGoal),
        sideline_right: (0, $kc6qZ.segment)(hw, -f.toMidfield, hw, f.behindGoal)
    };
}
/** The goal mouth, stopping what the trainer's side sends into it. */ const $fe00215cf73e485b$var$goalMouth = {
    id: "goal",
    kind: "goal",
    from: {
        x: -$fe00215cf73e485b$var$GOAL.width / 2,
        y: 0
    },
    to: {
        x: $fe00215cf73e485b$var$GOAL.width / 2,
        y: 0
    },
    bottom: 0,
    top: $fe00215cf73e485b$var$GOAL.height,
    faces: "right",
    response: {
        kind: "absorb"
    }
};
/**
 * The stage's own frame (ADR-045 asks vision to adopt it): origin at the
 * goal-line midpoint, +y through the goal, millimeters. Reference points are
 * the cage and the crease, not v1's placeholder tennis COURTPOINTS. Vision
 * has no lacrosse model yet, so this is a proposal it may revise.
 */ function $fe00215cf73e485b$var$goalFrame(f) {
    const gw = $fe00215cf73e485b$var$GOAL.width / 2;
    const r = f.creaseRadius;
    return {
        localization: {
            origin: (0, $kc6qZ.vec3)(0, 0, 0),
            flipY: false,
            unitsPerMeter: 1000.0
        },
        referencePoints: {
            goal_line_center: (0, $kc6qZ.vec3)(0, 0, 0),
            goal_post_left_bottom: (0, $kc6qZ.vec3)(-gw, 0, 0),
            goal_post_left_top: (0, $kc6qZ.vec3)(-gw, 0, $fe00215cf73e485b$var$GOAL.height),
            goal_post_right_bottom: (0, $kc6qZ.vec3)(gw, 0, 0),
            goal_post_right_top: (0, $kc6qZ.vec3)(gw, 0, $fe00215cf73e485b$var$GOAL.height),
            crossbar_center: (0, $kc6qZ.vec3)(0, 0, $fe00215cf73e485b$var$GOAL.height),
            goal_back: (0, $kc6qZ.vec3)(0, $fe00215cf73e485b$var$GOAL.depth, 0),
            crease_left: (0, $kc6qZ.vec3)(-r, 0, 0),
            crease_right: (0, $kc6qZ.vec3)(r, 0, 0),
            crease_front: (0, $kc6qZ.vec3)(0, -r, 0)
        }
    };
}
function $fe00215cf73e485b$var$buildField(field) {
    const spec = $fe00215cf73e485b$var$FIELDS[field];
    const hw = spec.width / 2;
    const extents = {
        x: [
            -hw,
            hw
        ],
        y: [
            -spec.toMidfield,
            spec.behindGoal
        ]
    };
    return {
        id: `lacrosse/${field}`,
        sport: "LACROSSE",
        stage: {
            extents: extents,
            features: $fe00215cf73e485b$var$fieldFeatures(spec)
        },
        arena: {
            bounds: extents,
            ground: {
                restitution: $2Yg5G.DefaultPhysicalConstants.courtRestCoeff
            },
            panels: [
                $fe00215cf73e485b$var$goalMouth
            ]
        },
        frame: $fe00215cf73e485b$var$goalFrame(spec)
    };
}
const $fe00215cf73e485b$var$VENUES = (0, $90lsY.deepFreeze)({
    ncaaWomens: $fe00215cf73e485b$var$buildField("ncaaWomens"),
    ncaaMens: $fe00215cf73e485b$var$buildField("ncaaMens")
});
/** A lacrosse half-field, in the goal-centered frame. `ncaaWomens` is the sport's default. */ const $fe00215cf73e485b$var$lacrosseField = (field)=>$fe00215cf73e485b$var$VENUES[field];
module.exports.lacrosseField = $fe00215cf73e485b$var$lacrosseField;

});
parcelRegister("kc6qZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.corners = module.exports.wall = module.exports.vec3 = module.exports.box = module.exports.segment = module.exports.point = void 0;
const $eb39eb568491acf9$var$point = (x, y)=>({
        kind: "point",
        at: {
            x: x,
            y: y
        }
    });
module.exports.point = $eb39eb568491acf9$var$point;
const $eb39eb568491acf9$var$segment = (x0, y0, x1, y1)=>({
        kind: "segment",
        from: {
            x: x0,
            y: y0
        },
        to: {
            x: x1,
            y: y1
        }
    });
module.exports.segment = $eb39eb568491acf9$var$segment;
/** An axis-aligned rectangle, corners in the protocol's order. */ const $eb39eb568491acf9$var$box = (x0, x1, y0, y1)=>({
        kind: "polygon",
        points: [
            {
                x: x0,
                y: y0
            },
            {
                x: x1,
                y: y0
            },
            {
                x: x1,
                y: y1
            },
            {
                x: x0,
                y: y1
            }
        ]
    });
module.exports.box = $eb39eb568491acf9$var$box;
const $eb39eb568491acf9$var$vec3 = (x, y, z)=>({
        x: x,
        y: y,
        z: z
    });
module.exports.vec3 = $eb39eb568491acf9$var$vec3;
/**
 * A wall from `from` to `to`, `height` tall, stopping balls from its left.
 * Walls around a court run counterclockwise seen from above, so their left
 * is always the court.
 */ const $eb39eb568491acf9$var$wall = (id, from, to, height, response)=>({
        id: id,
        kind: "wall",
        from: from,
        to: to,
        bottom: 0,
        top: height,
        faces: "left",
        response: response
    });
module.exports.wall = $eb39eb568491acf9$var$wall;
/** The four corners of an axis-aligned rectangle centered on the origin. */ const $eb39eb568491acf9$var$corners = (halfWidth, halfLength)=>({
        nearLeft: {
            x: -halfWidth,
            y: -halfLength
        },
        nearRight: {
            x: halfWidth,
            y: -halfLength
        },
        farRight: {
            x: halfWidth,
            y: halfLength
        },
        farLeft: {
            x: -halfWidth,
            y: halfLength
        }
    });
module.exports.corners = $eb39eb568491acf9$var$corners;

});


parcelRegister("c4d8I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.racquetVenue = module.exports.platformBounds = module.exports.NET_BOUNCE = module.exports.WALL_BOUNCE = void 0;
module.exports.racquetStage = $8c900d03efaeaba9$var$racquetStage;

var $2Yg5G = parcelRequire("2Yg5G");

var $kc6qZ = parcelRequire("kc6qZ");

var $5ygG6 = parcelRequire("5ygG6");
const $8c900d03efaeaba9$var$RACQUET_VENUE_IDS = {
    TENNIS: "tennis",
    PICKLEBALL: "pickleball",
    PADEL: "padel",
    PLATFORM_TENNIS: "platformTennis"
};
const { courtRestCoeff: $8c900d03efaeaba9$var$courtRestCoeff, netRestCoeff: $8c900d03efaeaba9$var$netRestCoeff, wallRestCoeff: $8c900d03efaeaba9$var$wallRestCoeff } = $2Yg5G.DefaultPhysicalConstants;
module.exports.WALL_BOUNCE = {
    kind: "bounce",
    restitution: $8c900d03efaeaba9$var$wallRestCoeff,
    tangential: 1
};
module.exports.NET_BOUNCE = {
    kind: "bounce",
    restitution: $8c900d03efaeaba9$var$netRestCoeff,
    tangential: $8c900d03efaeaba9$var$netRestCoeff
};
/**
 * What every court has: the net, its posts and the boundary. The net's `z`
 * is the tape at the center; the posts stand at the lined court's sides.
 */ function $8c900d03efaeaba9$var$courtBase(g) {
    const hw = g.COURT_WIDTH / 2;
    const hl = g.COURT_LENGTH / 2;
    return {
        center: (0, $kc6qZ.point)(0, 0),
        net: {
            ...(0, $kc6qZ.segment)(-hw, 0, hw, 0),
            z: {
                min: 0,
                max: g.NET_HEIGHT_CENTER
            }
        },
        net_post_left: {
            ...(0, $kc6qZ.point)(-hw, 0),
            z: {
                min: 0,
                max: g.NET_HEIGHT_POST
            }
        },
        net_post_right: {
            ...(0, $kc6qZ.point)(hw, 0),
            z: {
                min: 0,
                max: g.NET_HEIGHT_POST
            }
        },
        baseline_near: (0, $kc6qZ.segment)(-hw, -hl, hw, -hl),
        baseline_far: (0, $kc6qZ.segment)(-hw, hl, hw, hl),
        sideline_left: (0, $kc6qZ.segment)(-hw, -hl, -hw, hl),
        sideline_right: (0, $kc6qZ.segment)(hw, -hl, hw, hl)
    };
}
/** Service boxes between the net and the service line: tennis, padel, platform tennis. */ function $8c900d03efaeaba9$var$serviceCourts(g) {
    const sw = g.SERVICE_WIDTH / 2;
    const sl = g.SERVICE_LENGTH / 2;
    return {
        service_line_near: (0, $kc6qZ.segment)(-sw, -sl, sw, -sl),
        service_line_far: (0, $kc6qZ.segment)(-sw, sl, sw, sl),
        center_service_line: (0, $kc6qZ.segment)(0, -sl, 0, sl),
        service_box_near_left: (0, $kc6qZ.box)(-sw, 0, -sl, 0),
        service_box_near_right: (0, $kc6qZ.box)(0, sw, -sl, 0),
        service_box_far_left: (0, $kc6qZ.box)(-sw, 0, 0, sl),
        service_box_far_right: (0, $kc6qZ.box)(0, sw, 0, sl)
    };
}
/** A centre mark's length, inward from the baseline: 4 in. */ const $8c900d03efaeaba9$var$CENTER_MARK = 4 / 12 * 0.3048;
/**
 * Lines baseline to baseline inside a court narrower inside than out (tennis
 * singles sidelines, platform tennis alley lines), named by the sport, and
 * the centre mark bisecting each baseline.
 */ function $8c900d03efaeaba9$var$innerLines(g, name) {
    const sw = g.SERVICE_WIDTH / 2;
    const hl = g.COURT_LENGTH / 2;
    return {
        [`${name}_left`]: (0, $kc6qZ.segment)(-sw, -hl, -sw, hl),
        [`${name}_right`]: (0, $kc6qZ.segment)(sw, -hl, sw, hl),
        center_mark_near: (0, $kc6qZ.segment)(0, -hl, 0, -hl + $8c900d03efaeaba9$var$CENTER_MARK),
        center_mark_far: (0, $kc6qZ.segment)(0, hl, 0, hl - $8c900d03efaeaba9$var$CENTER_MARK)
    };
}
/** The inner lines' name where a sport has them. */ const $8c900d03efaeaba9$var$INNER_LINES = {
    TENNIS: "singles_sideline",
    PLATFORM_TENNIS: "alley_line"
};
/** Pickleball: the kitchen against the net, service boxes from it to the baseline. */ function $8c900d03efaeaba9$var$kitchenCourts(g) {
    const hl = g.COURT_LENGTH / 2;
    const sw = g.SERVICE_WIDTH / 2;
    const sl = g.SERVICE_LENGTH / 2;
    return {
        kitchen_line_near: (0, $kc6qZ.segment)(-sw, -sl, sw, -sl),
        kitchen_line_far: (0, $kc6qZ.segment)(-sw, sl, sw, sl),
        center_line_near: (0, $kc6qZ.segment)(0, -hl, 0, -sl),
        center_line_far: (0, $kc6qZ.segment)(0, sl, 0, hl),
        service_box_near_left: (0, $kc6qZ.box)(-sw, 0, -hl, -sl),
        service_box_near_right: (0, $kc6qZ.box)(0, sw, -hl, -sl),
        service_box_far_left: (0, $kc6qZ.box)(-sw, 0, sl, hl),
        service_box_far_right: (0, $kc6qZ.box)(0, sw, sl, hl)
    };
}
/** The protocol's stage for a racquet sport (experiences `stageFor`). */ function $8c900d03efaeaba9$var$racquetStage(sport) {
    const g = $2Yg5G.CourtGeometryBySport[sport];
    return {
        extents: {
            x: [
                -g.COURT_WIDTH / 2,
                g.COURT_WIDTH / 2
            ],
            y: [
                -g.COURT_LENGTH / 2,
                g.COURT_LENGTH / 2
            ]
        },
        features: {
            ...$8c900d03efaeaba9$var$courtBase(g),
            ...sport === "PICKLEBALL" ? $8c900d03efaeaba9$var$kitchenCourts(g) : $8c900d03efaeaba9$var$serviceCourts(g),
            ...$8c900d03efaeaba9$var$INNER_LINES[sport] ? $8c900d03efaeaba9$var$innerLines(g, $8c900d03efaeaba9$var$INNER_LINES[sport]) : {}
        }
    };
}
/** The platform's half extents: the ground the ball can be on. */ const $8c900d03efaeaba9$var$platformBounds = (g)=>({
        x: [
            -g.PLATFORM_WIDTH / 2,
            g.PLATFORM_WIDTH / 2
        ],
        y: [
            -g.PLATFORM_LENGTH / 2,
            g.PLATFORM_LENGTH / 2
        ]
    });
module.exports.platformBounds = $8c900d03efaeaba9$var$platformBounds;
/**
 * Walls round the platform's edge, counterclockwise from the far left
 * corner: left, right, far, near. The side walls are WALL_HEIGHT tall, the
 * end walls TALL_WALL_HEIGHT where the sport has one. A padel side wall is
 * three panels: its TALL_WALL_SIDE_LENGTH at each end, as tall as the end
 * walls, are the corners `leftWallFarCorner`, `leftWallNearCorner`, and so
 * on, and `leftWall` / `rightWall` are the lower stretch between them.
 */ function $8c900d03efaeaba9$var$walls(g) {
    if (g.WALL_HEIGHT === 0) return [];
    const side = g.WALL_HEIGHT;
    const end = g.TALL_WALL_HEIGHT !== 0 ? g.TALL_WALL_HEIGHT : g.WALL_HEIGHT;
    const hw = g.PLATFORM_WIDTH / 2;
    const { nearLeft: nearLeft, nearRight: nearRight, farRight: farRight, farLeft: farLeft } = (0, $kc6qZ.corners)(hw, g.PLATFORM_LENGTH / 2);
    const ends = [
        (0, $kc6qZ.wall)("farWall", farRight, farLeft, end, module.exports.WALL_BOUNCE),
        (0, $kc6qZ.wall)("nearWall", nearLeft, nearRight, end, module.exports.WALL_BOUNCE)
    ];
    if (g.TALL_WALL_SIDE_LENGTH === 0) return [
        (0, $kc6qZ.wall)("leftWall", farLeft, nearLeft, side, module.exports.WALL_BOUNCE),
        (0, $kc6qZ.wall)("rightWall", nearRight, farRight, side, module.exports.WALL_BOUNCE),
        ...ends
    ];
    const inner = g.PLATFORM_LENGTH / 2 - g.TALL_WALL_SIDE_LENGTH;
    const at = (x, y)=>({
            x: x,
            y: y
        });
    return [
        (0, $kc6qZ.wall)("leftWallFarCorner", farLeft, at(-hw, inner), end, module.exports.WALL_BOUNCE),
        (0, $kc6qZ.wall)("leftWall", at(-hw, inner), at(-hw, -inner), side, module.exports.WALL_BOUNCE),
        (0, $kc6qZ.wall)("leftWallNearCorner", at(-hw, -inner), nearLeft, end, module.exports.WALL_BOUNCE),
        (0, $kc6qZ.wall)("rightWallNearCorner", nearRight, at(hw, -inner), end, module.exports.WALL_BOUNCE),
        (0, $kc6qZ.wall)("rightWall", at(hw, -inner), at(hw, inner), side, module.exports.WALL_BOUNCE),
        (0, $kc6qZ.wall)("rightWallFarCorner", at(hw, inner), farRight, end, module.exports.WALL_BOUNCE),
        ...ends
    ];
}
/** The net post to post, sagging from NET_HEIGHT_POST to NET_HEIGHT_CENTER, stopping balls from both sides. */ const $8c900d03efaeaba9$var$net = (g)=>({
        id: "net",
        kind: "net",
        from: {
            x: -g.NET_WIDTH / 2,
            y: 0
        },
        to: {
            x: g.NET_WIDTH / 2,
            y: 0
        },
        bottom: 0,
        top: g.NET_HEIGHT_CENTER,
        topAtEnds: g.NET_HEIGHT_POST,
        faces: "both",
        response: module.exports.NET_BOUNCE
    });
function $8c900d03efaeaba9$var$racquetArena(sport) {
    const g = $2Yg5G.CourtGeometryBySport[sport];
    return {
        bounds: (0, module.exports.platformBounds)(g),
        ground: {
            restitution: $8c900d03efaeaba9$var$courtRestCoeff
        },
        panels: [
            ...$8c900d03efaeaba9$var$walls(g),
            $8c900d03efaeaba9$var$net(g)
        ]
    };
}
/** The regulation court a racquet sport is played on. */ const $8c900d03efaeaba9$var$racquetVenue = (sport)=>({
        id: $8c900d03efaeaba9$var$RACQUET_VENUE_IDS[sport],
        sport: sport,
        stage: $8c900d03efaeaba9$var$racquetStage(sport),
        arena: $8c900d03efaeaba9$var$racquetArena(sport),
        frame: (0, $5ygG6.v1Frame)(sport)
    });
module.exports.racquetVenue = $8c900d03efaeaba9$var$racquetVenue;

});
parcelRegister("5ygG6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.v1Frame = $40ad10a36de0b31a$var$v1Frame;

var $2Yg5G = parcelRequire("2Yg5G");

var $7Hn04 = parcelRequire("7Hn04");

var $kc6qZ = parcelRequire("kc6qZ");
/**
 * Millimeters, origin at the far-left corner of the lined court, y flipped,
 * calibrated against v1's COURTPOINTS. Physics to localization subtracts the
 * origin, which is bit for bit v1's `p.x + COURT_WIDTH / 2` and
 * `p.y - COURT_LENGTH / 2`.
 */ function $40ad10a36de0b31a$var$v1Frame(sport) {
    const g = $2Yg5G.CourtGeometryBySport[sport];
    return {
        localization: {
            origin: (0, $kc6qZ.vec3)(-g.COURT_WIDTH / 2.0, g.COURT_LENGTH / 2.0, 0),
            flipY: true,
            unitsPerMeter: 1000.0
        },
        referencePoints: Object.fromEntries(Object.entries($7Hn04.COURTPOINTS[sport]).map(([name, p])=>[
                name,
                (0, $kc6qZ.vec3)(p.x, p.y, p.z)
            ]))
    };
}

});
parcelRegister("7Hn04", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.COURTPOINTS = module.exports.CourtLineLabel = module.exports.CourtPointLabel = void 0;
module.exports.getCourtPointByName = $59ae63e0e57f6fcd$var$getCourtPointByName;
module.exports.CourtPointLabel = {
    base_b_dl: "Baseline Doubles Left (Trainer Side)",
    base_b_l: "Baseline Singles Left (Trainer Side)",
    base_b_m: "Baseline Center (Trainer Side)",
    base_b_r: "Base Singles Right (Trainer Side)",
    base_b_dr: "Baseline Doubles Right (Trainer Side)",
    base_t_dl: "Baseline Doubles Left (Player Side)",
    base_t_l: "Baseline Singles Left (Player Side)",
    base_t_m: "Center Baseline",
    base_t_r: "Baseline Singles Right (Player Side)",
    base_t_dr: "Baseline Doubles Right (Player Side)",
    serve_b_dl: "Service Line Doubles Left (Trainer Side)",
    serve_b_l: "Service Line Singles Left (Trainer Side)",
    serve_b_m: "Service Line Center (Trainer Side)",
    serve_b_r: "Service Line Singles Right (Trainer Side)",
    serve_b_dr: "Service Line Doubles Right (Trainer Side)",
    serve_t_dl: "Service Line Doubles Left (Player Side)",
    serve_t_l: "Service Line Singles Left (Player Side)",
    serve_t_m: "Center Service Line",
    serve_t_r: "Service Line Singles Right (Player Side)",
    serve_t_dr: "Service Line Doubles Right (Player Side)",
    net_l: "Net Bottom Singles Left",
    net_dl: "Net Bottom Doubles Left",
    net_m: "Net Bottom Middle",
    net_dr: "Net Bottom Doubles Right",
    net_r: "Net Bottom Singles Right",
    play_t_l: "Play Area Left (Player Side)",
    play_t_m: "Play Area Center (Player Side)",
    play_t_r: "Play Area Right (Player Side)",
    play_b_l: "Play Area Left (Trainer Side)",
    play_b_m: "Play Area Center (Trainer Side)",
    play_b_r: "Play Area Right (Trainer Side)",
    netpost_l_b: "Net Post Bottom Left",
    netpost_l_t: "Net Post Top Left",
    netpost_r_b: "Net Post Bottom Right",
    netpost_r_t: "Net Post Top Right"
};
module.exports.CourtLineLabel = {
    base_b_dl: "Baseline (Trainer Side)",
    base_b_l: "Baseline (Trainer Side)",
    base_b_m: "Baseline (Trainer Side)",
    base_b_r: "Baseline (Trainer Side)",
    base_b_dr: "Baseline (Trainer Side)",
    base_t_dl: "Baseline (Player Side)",
    base_t_l: "Baseline (Player Side)",
    base_t_m: "Center Baseline (Player Side)",
    base_t_r: "Baseline (Player Side)",
    base_t_dr: "Baseline (Player Side)",
    serve_b_dl: "Service Line (Trainer Side)",
    serve_b_l: "Service Line (Trainer Side)",
    serve_b_m: "Service Line (Trainer Side)",
    serve_b_r: "Service Line (Trainer Side)",
    serve_b_dr: "Service Line (Trainer Side)",
    serve_t_dl: "Service Line (Player Side)",
    serve_t_l: "Service Line (Player Side)",
    serve_t_m: "Service Line (Player Side)",
    serve_t_r: "Service Line (Player Side)",
    serve_t_dr: "Service Line (Player Side)",
    net_l: "Net Bottom",
    net_dl: "Net Bottom",
    net_m: "Net Bottom",
    net_dr: "Net Bottom",
    net_r: "Net Bottom",
    play_t_l: "Play Area (Player Side)",
    play_t_m: "Play Area (Player Side)",
    play_t_r: "Play Area (Player Side)",
    play_b_l: "Play Area (Trainer Side)",
    play_b_m: "Play Area (Trainer Side)",
    play_b_r: "Play Area (Trainer Side)",
    netpost_l_b: "Net Post Bottom",
    netpost_l_t: "Net Post Top",
    netpost_r_b: "Net Post Bottom",
    netpost_r_t: "Net Post Top"
};
module.exports.COURTPOINTS = {
    PLATFORM_TENNIS: {
        base_t_l: {
            x: -3.048,
            y: 6.7056,
            z: 0.0
        },
        base_t_dl: {
            x: -2.4384,
            y: 6.7056,
            z: 0.0
        },
        base_t_m: {
            x: 0.0,
            y: 6.7056,
            z: 0.0
        },
        base_t_dr: {
            x: 2.4384,
            y: 6.7056,
            z: 0.0
        },
        base_t_r: {
            x: 3.048,
            y: 6.7056,
            z: 0.0
        },
        base_b_l: {
            x: -3.048,
            y: -6.7056,
            z: 0.0
        },
        base_b_dl: {
            x: -2.4384,
            y: -6.7056,
            z: 0.0
        },
        base_b_m: {
            x: 0.0,
            y: -6.7056,
            z: 0.0
        },
        base_b_dr: {
            x: 2.4384,
            y: -6.7056,
            z: 0.0
        },
        base_b_r: {
            x: 3.048,
            y: -6.7056,
            z: 0.0
        },
        serve_t_l: {
            x: -3.048,
            y: 3.6576,
            z: 0.0
        },
        serve_t_dl: {
            x: -2.4384,
            y: 3.6576,
            z: 0.0
        },
        serve_t_m: {
            x: 0.0,
            y: 3.6576,
            z: 0.0
        },
        serve_t_dr: {
            x: 2.4384,
            y: 3.6576,
            z: 0.0
        },
        serve_t_r: {
            x: 3.048,
            y: 3.6576,
            z: 0.0
        },
        serve_b_l: {
            x: -3.048,
            y: -3.6576,
            z: 0.0
        },
        serve_b_dl: {
            x: -2.4384,
            y: -3.6576,
            z: 0.0
        },
        serve_b_m: {
            x: 0.0,
            y: -3.6576,
            z: 0.0
        },
        serve_b_dr: {
            x: 2.4384,
            y: -3.6576,
            z: 0.0
        },
        serve_b_r: {
            x: 3.048,
            y: -3.6576,
            z: 0.0
        },
        net_l: {
            x: -3.048,
            y: 0.0,
            z: 0.0
        },
        net_dl: {
            x: -2.4384,
            y: 0.0,
            z: 0.0
        },
        net_m: {
            x: 0.0,
            y: 0.0,
            z: 0.0
        },
        net_dr: {
            x: 2.4384,
            y: 0.0,
            z: 0.0
        },
        net_r: {
            x: 3.048,
            y: 0.0,
            z: 0.0
        },
        play_t_l: {
            x: -4.572,
            y: 9.144,
            z: 0.0
        },
        play_t_m: {
            x: 0,
            y: 9.144,
            z: 0.0
        },
        play_t_r: {
            x: 4.572,
            y: 9.144,
            z: 0.0
        },
        play_b_l: {
            x: -4.572,
            y: -9.144,
            z: 0.0
        },
        play_b_m: {
            x: 0,
            y: -9.144,
            z: 0.0
        },
        play_b_r: {
            x: 4.572,
            y: -9.144,
            z: 0.0
        },
        netpost_l_b: {
            x: -3.5052,
            y: 0.0,
            z: 0.0
        },
        netpost_l_t: {
            x: -3.5052,
            y: 0.0,
            z: 0.9398
        },
        netpost_r_b: {
            x: 3.5052,
            y: 0.0,
            z: 0.0
        },
        netpost_r_t: {
            x: 3.5052,
            y: 0.0,
            z: 0.9398
        }
    },
    PADEL: {
        base_t_l: {
            x: -5,
            y: 10.0,
            z: 0.0
        },
        base_t_m: {
            x: 0.0,
            y: 10.0,
            z: 0.0
        },
        base_t_r: {
            x: 5.0,
            y: 10.0,
            z: 0.0
        },
        base_b_l: {
            x: -5,
            y: -10,
            z: 0.0
        },
        base_b_m: {
            x: 0.0,
            y: -10,
            z: 0.0
        },
        base_b_r: {
            x: 5.0,
            y: -10,
            z: 0.0
        },
        serve_t_l: {
            x: -5,
            y: 7.0,
            z: 0.0
        },
        serve_t_m: {
            x: 0.0,
            y: 7.0,
            z: 0.0
        },
        serve_t_r: {
            x: 5.0,
            y: 7.0,
            z: 0.0
        },
        serve_b_l: {
            x: -5,
            y: -7,
            z: 0.0
        },
        serve_b_m: {
            x: 0.0,
            y: -7,
            z: 0.0
        },
        serve_b_r: {
            x: 5.0,
            y: -7,
            z: 0.0
        },
        net_l: {
            x: -5,
            y: 0.0,
            z: 0.0
        },
        net_m: {
            x: 0.0,
            y: 0.0,
            z: 0.0
        },
        net_r: {
            x: 5.0,
            y: 0.0,
            z: 0.0
        },
        play_t_l: {
            x: -6.5,
            y: 11.5,
            z: 0.0
        },
        play_t_m: {
            x: 0,
            y: 11.5,
            z: 0.0
        },
        play_t_r: {
            x: 6.5,
            y: 11.5,
            z: 0.0
        },
        play_b_l: {
            x: -6.5,
            y: -11.5,
            z: 0.0
        },
        play_b_m: {
            x: 0,
            y: -11.5,
            z: 0.0
        },
        play_b_r: {
            x: 6.5,
            y: -11.5,
            z: 0.0
        },
        netpost_l_b: {
            x: -5.0365,
            y: 0.0,
            z: 0.0
        },
        netpost_l_t: {
            x: -5.0365,
            y: 0.0,
            z: 0.92
        },
        netpost_r_b: {
            x: 5.0365,
            y: 0.0,
            z: 0.0
        },
        netpost_r_t: {
            x: 5.0365,
            y: 0.0,
            z: 0.92
        }
    },
    TENNIS: {
        base_t_l: {
            x: -5.485,
            y: 11.885,
            z: 0.0
        },
        base_t_dl: {
            x: -4.115,
            y: 11.885,
            z: 0.0
        },
        base_t_m: {
            x: 0.0,
            y: 11.885,
            z: 0.0
        },
        base_t_dr: {
            x: 4.115,
            y: 11.885,
            z: 0.0
        },
        base_t_r: {
            x: 5.485,
            y: 11.885,
            z: 0.0
        },
        base_b_l: {
            x: -5.485,
            y: -11.885,
            z: 0.0
        },
        base_b_dl: {
            x: -4.115,
            y: -11.885,
            z: 0.0
        },
        base_b_m: {
            x: 0.0,
            y: -11.885,
            z: 0.0
        },
        base_b_dr: {
            x: 4.115,
            y: -11.885,
            z: 0.0
        },
        base_b_r: {
            x: 5.485,
            y: -11.885,
            z: 0.0
        },
        serve_t_l: {
            x: -5.485,
            y: 6.4,
            z: 0.0
        },
        serve_t_dl: {
            x: -4.115,
            y: 6.4,
            z: 0.0
        },
        serve_t_m: {
            x: 0.0,
            y: 6.4,
            z: 0.0
        },
        serve_t_dr: {
            x: 4.115,
            y: 6.4,
            z: 0.0
        },
        serve_t_r: {
            x: 5.485,
            y: 6.4,
            z: 0.0
        },
        serve_b_l: {
            x: -5.485,
            y: -6.4,
            z: 0.0
        },
        serve_b_dl: {
            x: -4.115,
            y: -6.4,
            z: 0.0
        },
        serve_b_m: {
            x: 0.0,
            y: -6.4,
            z: 0.0
        },
        serve_b_dr: {
            x: 4.115,
            y: -6.4,
            z: 0.0
        },
        serve_b_r: {
            x: 5.485,
            y: -6.4,
            z: 0.0
        },
        net_l: {
            x: -5.485,
            y: 0.0,
            z: 0.0
        },
        net_dl: {
            x: -4.115,
            y: 0.0,
            z: 0.0
        },
        net_m: {
            x: 0.0,
            y: 0.0,
            z: 0.0
        },
        net_dr: {
            x: 4.115,
            y: 0.0,
            z: 0.0
        },
        net_r: {
            x: 5.485,
            y: 0.0,
            z: 0.0
        },
        play_t_l: {
            x: -9.144,
            y: 18.288,
            z: 0.0
        },
        play_t_m: {
            x: 0,
            y: 18.288,
            z: 0.0
        },
        play_t_r: {
            x: 9.144,
            y: 18.288,
            z: 0.0
        },
        play_b_l: {
            x: -9.144,
            y: -18.288,
            z: 0.0
        },
        play_b_m: {
            x: 0,
            y: -18.288,
            z: 0.0
        },
        play_b_r: {
            x: 9.144,
            y: -18.288,
            z: 0.0
        },
        netpost_l_b: {
            x: -6.399,
            y: 0.0,
            z: 0.0
        },
        netpost_l_t: {
            x: -6.399,
            y: 0.0,
            z: 1.07
        },
        netpost_r_b: {
            x: 6.399,
            y: 0.0,
            z: 0.0
        },
        netpost_r_t: {
            x: 6.399,
            y: 0.0,
            z: 1.07
        }
    },
    PICKLEBALL: {
        base_t_l: {
            x: -3.048,
            y: 6.7056,
            z: 0.0
        },
        base_t_m: {
            x: 0.0,
            y: 6.7056,
            z: 0.0
        },
        base_t_r: {
            x: 3.048,
            y: 6.7056,
            z: 0.0
        },
        base_b_l: {
            x: -3.048,
            y: -6.7056,
            z: 0.0
        },
        base_b_m: {
            x: 0.0,
            y: -6.7056,
            z: 0.0
        },
        base_b_r: {
            x: 3.048,
            y: -6.7056,
            z: 0.0
        },
        serve_t_l: {
            x: -3.048,
            y: 2.1336,
            z: 0.0
        },
        serve_t_m: {
            x: 0.0,
            y: 2.1336,
            z: 0.0
        },
        serve_t_r: {
            x: 3.048,
            y: 2.1336,
            z: 0.0
        },
        serve_b_l: {
            x: -3.048,
            y: -2.1336,
            z: 0.0
        },
        serve_b_m: {
            x: 0.0,
            y: -2.1336,
            z: 0.0
        },
        serve_b_r: {
            x: 3.048,
            y: -2.1336,
            z: 0.0
        },
        net_l: {
            x: -3.048,
            y: 0.0,
            z: 0.0
        },
        net_m: {
            x: 0.0,
            y: 0.0,
            z: 0.0
        },
        net_r: {
            x: 3.048,
            y: 0.0,
            z: 0.0
        },
        play_t_l: {
            x: -4.572,
            y: 9.144,
            z: 0.0
        },
        play_t_m: {
            x: 0.0,
            y: 9.144,
            z: 0.0
        },
        play_t_r: {
            x: 4.572,
            y: 9.144,
            z: 0.0
        },
        play_b_l: {
            x: -4.572,
            y: -9.144,
            z: 0.0
        },
        play_b_m: {
            x: 0.0,
            y: -9.144,
            z: 0.0
        },
        play_b_r: {
            x: 4.572,
            y: -9.144,
            z: 0.0
        },
        netpost_l_b: {
            x: -3.3528,
            y: 0.0,
            z: 0.0
        },
        netpost_l_t: {
            x: -3.3528,
            y: 0.0,
            z: 0.9144
        },
        netpost_r_b: {
            x: 3.3528,
            y: 0.0,
            z: 0.0
        },
        netpost_r_t: {
            x: 3.3528,
            y: 0.0,
            z: 0.9144
        }
    },
    // Placeholder: Lacrosse has no field markings of its own yet, so it
    // reuses the tennis court points - the wall-less court whose art the
    // visualizer currently stands in with. See LacrosseCourtPointName.
    LACROSSE: {
        base_t_l: {
            x: -5.485,
            y: 11.885,
            z: 0.0
        },
        base_t_dl: {
            x: -4.115,
            y: 11.885,
            z: 0.0
        },
        base_t_m: {
            x: 0.0,
            y: 11.885,
            z: 0.0
        },
        base_t_dr: {
            x: 4.115,
            y: 11.885,
            z: 0.0
        },
        base_t_r: {
            x: 5.485,
            y: 11.885,
            z: 0.0
        },
        base_b_l: {
            x: -5.485,
            y: -11.885,
            z: 0.0
        },
        base_b_dl: {
            x: -4.115,
            y: -11.885,
            z: 0.0
        },
        base_b_m: {
            x: 0.0,
            y: -11.885,
            z: 0.0
        },
        base_b_dr: {
            x: 4.115,
            y: -11.885,
            z: 0.0
        },
        base_b_r: {
            x: 5.485,
            y: -11.885,
            z: 0.0
        },
        serve_t_l: {
            x: -5.485,
            y: 6.4,
            z: 0.0
        },
        serve_t_dl: {
            x: -4.115,
            y: 6.4,
            z: 0.0
        },
        serve_t_m: {
            x: 0.0,
            y: 6.4,
            z: 0.0
        },
        serve_t_dr: {
            x: 4.115,
            y: 6.4,
            z: 0.0
        },
        serve_t_r: {
            x: 5.485,
            y: 6.4,
            z: 0.0
        },
        serve_b_l: {
            x: -5.485,
            y: -6.4,
            z: 0.0
        },
        serve_b_dl: {
            x: -4.115,
            y: -6.4,
            z: 0.0
        },
        serve_b_m: {
            x: 0.0,
            y: -6.4,
            z: 0.0
        },
        serve_b_dr: {
            x: 4.115,
            y: -6.4,
            z: 0.0
        },
        serve_b_r: {
            x: 5.485,
            y: -6.4,
            z: 0.0
        },
        net_l: {
            x: -5.485,
            y: 0.0,
            z: 0.0
        },
        net_dl: {
            x: -4.115,
            y: 0.0,
            z: 0.0
        },
        net_m: {
            x: 0.0,
            y: 0.0,
            z: 0.0
        },
        net_dr: {
            x: 4.115,
            y: 0.0,
            z: 0.0
        },
        net_r: {
            x: 5.485,
            y: 0.0,
            z: 0.0
        },
        play_t_l: {
            x: -9.144,
            y: 18.288,
            z: 0.0
        },
        play_t_m: {
            x: 0,
            y: 18.288,
            z: 0.0
        },
        play_t_r: {
            x: 9.144,
            y: 18.288,
            z: 0.0
        },
        play_b_l: {
            x: -9.144,
            y: -18.288,
            z: 0.0
        },
        play_b_m: {
            x: 0,
            y: -18.288,
            z: 0.0
        },
        play_b_r: {
            x: 9.144,
            y: -18.288,
            z: 0.0
        },
        netpost_l_b: {
            x: -6.399,
            y: 0.0,
            z: 0.0
        },
        netpost_l_t: {
            x: -6.399,
            y: 0.0,
            z: 1.07
        },
        netpost_r_b: {
            x: 6.399,
            y: 0.0,
            z: 0.0
        },
        netpost_r_t: {
            x: 6.399,
            y: 0.0,
            z: 1.07
        }
    }
};
function $59ae63e0e57f6fcd$var$getCourtPointByName(sport, pointName) {
    const sportPoints = module.exports.COURTPOINTS[sport];
    if (pointName in sportPoints) return sportPoints[pointName];
    return null;
}

});



parcelRegister("8OM0c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.v1Venue = void 0;

var $2Yg5G = parcelRequire("2Yg5G");

var $90lsY = parcelRequire("90lsY");

var $kc6qZ = parcelRequire("kc6qZ");

var $5ygG6 = parcelRequire("5ygG6");

var $c4d8I = parcelRequire("c4d8I");
/** Left, right, far and near walls at the platform's edge, as v1 has them. */ function $66b83a75d4fc54f8$var$v1Walls(g) {
    if (g.WALL_HEIGHT === 0) return [];
    const end = g.TALL_WALL_HEIGHT !== 0 ? g.TALL_WALL_HEIGHT : g.WALL_HEIGHT;
    const { nearLeft: nearLeft, nearRight: nearRight, farRight: farRight, farLeft: farLeft } = (0, $kc6qZ.corners)(g.PLATFORM_WIDTH / 2, g.PLATFORM_LENGTH / 2);
    return [
        (0, $kc6qZ.wall)("leftWall", farLeft, nearLeft, g.WALL_HEIGHT, $c4d8I.WALL_BOUNCE),
        (0, $kc6qZ.wall)("rightWall", nearRight, farRight, g.WALL_HEIGHT, $c4d8I.WALL_BOUNCE),
        (0, $kc6qZ.wall)("farWall", farRight, farLeft, end, $c4d8I.WALL_BOUNCE),
        (0, $kc6qZ.wall)("nearWall", nearLeft, nearRight, end, $c4d8I.WALL_BOUNCE)
    ];
}
/** v1's net: flat at the center height, stopping balls from the trainer's side (-y) only. */ function $66b83a75d4fc54f8$var$v1Net(g) {
    if (g.NET_HEIGHT_CENTER === 0) return [];
    return [
        {
            id: "net",
            kind: "net",
            from: {
                x: -g.NET_WIDTH / 2,
                y: 0
            },
            to: {
                x: g.NET_WIDTH / 2,
                y: 0
            },
            bottom: 0,
            top: g.NET_HEIGHT_CENTER,
            faces: "right",
            response: $c4d8I.NET_BOUNCE
        }
    ];
}
function $66b83a75d4fc54f8$var$v1Stage(sport) {
    if (sport !== "LACROSSE") return (0, $c4d8I.racquetStage)(sport);
    const { x: x, y: y } = (0, $c4d8I.platformBounds)($2Yg5G.CourtGeometryBySport[sport]);
    return {
        extents: {
            x: x,
            y: y
        },
        features: {
            center: (0, $kc6qZ.point)(0, 0)
        }
    };
}
function $66b83a75d4fc54f8$var$buildV1Venue(sport) {
    const g = $2Yg5G.CourtGeometryBySport[sport];
    return {
        id: `v1/${sport}`,
        sport: sport,
        stage: $66b83a75d4fc54f8$var$v1Stage(sport),
        arena: {
            bounds: (0, $c4d8I.platformBounds)(g),
            ground: {
                restitution: $2Yg5G.DefaultPhysicalConstants.courtRestCoeff
            },
            panels: [
                ...$66b83a75d4fc54f8$var$v1Walls(g),
                ...$66b83a75d4fc54f8$var$v1Net(g)
            ]
        },
        frame: (0, $5ygG6.v1Frame)(sport)
    };
}
const $66b83a75d4fc54f8$var$V1_VENUES = (0, $90lsY.deepFreeze)(Object.fromEntries($2Yg5G.Sports.map((sport)=>[
        sport,
        $66b83a75d4fc54f8$var$buildV1Venue(sport)
    ])));
/** v1's geometry for a sport, exactly: `requireProfile(model, sport, { venue: v1Venue(sport) })`. */ const $66b83a75d4fc54f8$var$v1Venue = (sport)=>$66b83a75d4fc54f8$var$V1_VENUES[sport];
module.exports.v1Venue = $66b83a75d4fc54f8$var$v1Venue;

});

parcelRegister("gGXrv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.venueProblems = $0322d1409acd0ca0$var$venueProblems;
const $0322d1409acd0ca0$var$isFiniteVec2 = (v)=>Number.isFinite(v.x) && Number.isFinite(v.y);
const $0322d1409acd0ca0$var$isFiniteVec3 = (v)=>$0322d1409acd0ca0$var$isFiniteVec2(v) && Number.isFinite(v.z);
const $0322d1409acd0ca0$var$isFraction = (n)=>Number.isFinite(n) && n >= 0 && n <= 1;
const $0322d1409acd0ca0$var$isRange = ([lo, hi])=>Number.isFinite(lo) && Number.isFinite(hi) && lo < hi;
const $0322d1409acd0ca0$var$failing = (checks)=>checks.filter(([ok])=>!ok).map(([, problem])=>problem);
function $0322d1409acd0ca0$var$featureProblems(id, feature) {
    const shape = (()=>{
        switch(feature.kind){
            case "point":
                return $0322d1409acd0ca0$var$isFiniteVec2(feature.at);
            case "segment":
                return $0322d1409acd0ca0$var$isFiniteVec2(feature.from) && $0322d1409acd0ca0$var$isFiniteVec2(feature.to);
            case "polygon":
                return feature.points.length >= 3 && feature.points.every($0322d1409acd0ca0$var$isFiniteVec2);
            case "circle":
                return $0322d1409acd0ca0$var$isFiniteVec2(feature.at) && Number.isFinite(feature.radius) && feature.radius > 0;
            default:
                return false;
        }
    })();
    const { z: z } = feature;
    return $0322d1409acd0ca0$var$failing([
        [
            shape,
            `stage feature ${id} must be a point, segment, polygon or circle with finite coordinates`
        ],
        [
            z === undefined || Number.isFinite(z.min) && Number.isFinite(z.max) && z.min <= z.max,
            `stage feature ${id}'s z range must be finite and ordered`
        ]
    ]);
}
function $0322d1409acd0ca0$var$stageProblems(stage) {
    return [
        ...$0322d1409acd0ca0$var$failing([
            [
                $0322d1409acd0ca0$var$isRange(stage.extents.x) && $0322d1409acd0ca0$var$isRange(stage.extents.y),
                "stage extents must be finite and non-empty"
            ],
            [
                Object.hasOwn(stage.features, "center") && stage.features.center.kind === "point",
                "the stage must have a center point"
            ]
        ]),
        ...Object.entries(stage.features).flatMap(([id, feature])=>$0322d1409acd0ca0$var$featureProblems(id, feature))
    ];
}
function $0322d1409acd0ca0$var$responseProblems(id, response) {
    switch(response.kind){
        case "absorb":
            return [];
        case "bounce":
            return $0322d1409acd0ca0$var$failing([
                [
                    $0322d1409acd0ca0$var$isFraction(response.restitution),
                    `panel ${id}'s restitution ${response.restitution} must be in [0, 1]`
                ],
                [
                    $0322d1409acd0ca0$var$isFraction(response.tangential),
                    `panel ${id}'s tangential ${response.tangential} must be in [0, 1]`
                ]
            ]);
        default:
            return [
                `panel ${id}'s response must bounce or absorb`
            ];
    }
}
function $0322d1409acd0ca0$var$panelProblems(panel) {
    const { id: id, from: from, to: to, bottom: bottom, top: top, topAtEnds: topAtEnds } = panel;
    return [
        ...$0322d1409acd0ca0$var$failing([
            [
                [
                    "net",
                    "wall",
                    "goal"
                ].includes(panel.kind),
                `panel ${id}'s kind ${panel.kind} must be net, wall or goal`
            ],
            [
                $0322d1409acd0ca0$var$isFiniteVec2(from) && $0322d1409acd0ca0$var$isFiniteVec2(to),
                `panel ${id}'s ends must be finite`
            ],
            [
                from.x !== to.x || from.y !== to.y,
                `panel ${id} must run between two different points`
            ],
            [
                Number.isFinite(bottom) && Number.isFinite(top) && top > bottom,
                `panel ${id}'s top ${top} must be above its bottom ${bottom}`
            ],
            [
                topAtEnds === undefined || Number.isFinite(topAtEnds) && topAtEnds > bottom,
                `panel ${id}'s top at the ends ${topAtEnds} must be above its bottom ${bottom}`
            ],
            [
                [
                    "both",
                    "left",
                    "right"
                ].includes(panel.faces),
                `panel ${id} must face both, left or right`
            ]
        ]),
        ...$0322d1409acd0ca0$var$responseProblems(id, panel.response)
    ];
}
function $0322d1409acd0ca0$var$arenaProblems(arena) {
    const ids = arena.panels.map((panel)=>panel.id);
    const repeated = [
        ...new Set(ids.filter((id, i)=>ids.indexOf(id) !== i))
    ];
    return [
        ...$0322d1409acd0ca0$var$failing([
            [
                $0322d1409acd0ca0$var$isRange(arena.bounds.x) && $0322d1409acd0ca0$var$isRange(arena.bounds.y),
                "arena bounds must be finite and non-empty"
            ],
            [
                $0322d1409acd0ca0$var$isFraction(arena.ground.restitution),
                `ground restitution ${arena.ground.restitution} must be in [0, 1]`
            ],
            [
                repeated.length === 0,
                `panel ids must be unique: ${repeated.join(", ")} repeat`
            ]
        ]),
        ...arena.panels.flatMap($0322d1409acd0ca0$var$panelProblems)
    ];
}
function $0322d1409acd0ca0$var$frameProblems({ localization: localization, referencePoints: referencePoints }) {
    const unfinite = Object.entries(referencePoints).filter(([, p])=>!$0322d1409acd0ca0$var$isFiniteVec3(p)).map(([name])=>name);
    return $0322d1409acd0ca0$var$failing([
        [
            $0322d1409acd0ca0$var$isFiniteVec3(localization.origin),
            "the localization origin must be finite"
        ],
        [
            typeof localization.flipY === "boolean",
            "the localization frame must say whether y is flipped"
        ],
        [
            Number.isFinite(localization.unitsPerMeter) && localization.unitsPerMeter > 0,
            `localization units per meter ${localization.unitsPerMeter} must be positive`
        ],
        [
            unfinite.length === 0,
            `reference points must be finite: ${unfinite.join(", ")} are not`
        ]
    ]);
}
/** Everything wrong with `venue` as a place to play `sport`. */ function $0322d1409acd0ca0$var$venueProblems(venue, sport) {
    return [
        ...$0322d1409acd0ca0$var$failing([
            [
                venue.sport === sport,
                `venue ${venue.id} is for ${venue.sport}`
            ]
        ]),
        ...$0322d1409acd0ca0$var$stageProblems(venue.stage),
        ...$0322d1409acd0ca0$var$arenaProblems(venue.arena),
        ...$0322d1409acd0ca0$var$frameProblems(venue.frame)
    ];
}

});





parcelRegister("fgwez", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copyTunables = void 0;
module.exports.assertModel = $b1d15aa3890db200$var$assertModel;
module.exports.createModel = $b1d15aa3890db200$var$createModel;

var $90lsY = parcelRequire("90lsY");

var $2Yg5G = parcelRequire("2Yg5G");

var $faJc0 = parcelRequire("faJc0");

var $2oLTm = parcelRequire("2oLTm");

var $gV6Yw = parcelRequire("gV6Yw");

var $bRtcj = parcelRequire("bRtcj");

var $d2cet = parcelRequire("d2cet");
const $b1d15aa3890db200$var$MPS_PER_MPH = 0.44704;
/** v1 setPhysicsModel's checks, in its order and with its messages. */ function $b1d15aa3890db200$var$assertModel(name, sport) {
    (0, $d2cet.assert)(name in $2oLTm.tableRPM2MPHMap, `no RPM2MPH mapping for physics model ${name}`);
    (0, $d2cet.assert)(sport in $2oLTm.tableRPM2MPHMap[name], `no RPM2MPH mapping for physics model ${name}, sport ${sport}`);
    (0, $d2cet.assert)(name in $faJc0.tableLimitsMap, `no physicsModelName limits mapping for physics model ${name}`);
    (0, $d2cet.assert)(sport in $faJc0.tableLimitsMap[name], `no physicsModelName limits mapping for physics model ${name}, sport ${sport}`);
    (0, $d2cet.assert)(sport in $2Yg5G.CourtGeometryBySport, `no court geometry mapping for sport ${sport}`);
    (0, $d2cet.assert)(name in $bRtcj.tableTrainerGeometryMap, `no trainer geometry mapping for physics model ${name}`);
    (0, $d2cet.assert)(name in $gV6Yw.tableSpinAdjustMap, `no spin adjustment mapping for physics model ${name}`);
    (0, $d2cet.assert)(sport in $gV6Yw.tableSpinAdjustMap[name], `no spin adjustment mapping for sport ${sport}`);
}
/** v1's MPS limits, derived from the RPM limits through the speed table. */ function $b1d15aa3890db200$var$mpsLimits(name, sport) {
    const mph = $2oLTm.tableRPM2MPHMap[name][sport];
    const rpm = $faJc0.tableLimitsMap[name][sport].RPM;
    return {
        limit: mph[rpm.limit] * $b1d15aa3890db200$var$MPS_PER_MPH,
        maxSafe: mph[rpm.maxSafe] * $b1d15aa3890db200$var$MPS_PER_MPH,
        minSafe: mph[rpm.minSafe] * $b1d15aa3890db200$var$MPS_PER_MPH
    };
}
/** A model for a trainer and sport, holding `tunables` as its own. */ function $b1d15aa3890db200$var$createModel(name, sport, tunables) {
    return {
        name: name,
        sport: sport,
        ballParams: tunables.ballParams,
        mapRPM2MPH: $2oLTm.tableRPM2MPHMap[name][sport],
        simParams: tunables.simParams,
        trainerGeometry: (0, $90lsY.clonePlainData)($bRtcj.tableTrainerGeometryMap[name]),
        constants: tunables.constants,
        limits: {
            RPM: {
                ...$faJc0.tableLimitsMap[name][sport].RPM
            },
            MPS: $b1d15aa3890db200$var$mpsLimits(name, sport)
        },
        courtGeometry: {
            ...$2Yg5G.CourtGeometryBySport[sport]
        },
        spinAdjust: $gV6Yw.tableSpinAdjustMap[name][sport]
    };
}
/** Copies of a model's tunables, for a model that must not share them. */ const $b1d15aa3890db200$var$copyTunables = ({ ballParams: ballParams, constants: constants, simParams: simParams })=>({
        ballParams: {
            ...ballParams
        },
        constants: {
            ...constants
        },
        simParams: {
            ...simParams
        }
    });
module.exports.copyTunables = $b1d15aa3890db200$var$copyTunables;

});


parcelRegister("lFXDt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setPhysicsModel = $fc7bafbc02aaa463$var$setPhysicsModel;
module.exports.getPhysicsModel = $fc7bafbc02aaa463$var$getPhysicsModel;
module.exports.crossProduct = $fc7bafbc02aaa463$var$crossProduct;
module.exports.yawpitch2launchpoint = $fc7bafbc02aaa463$var$yawpitch2launchpoint;
module.exports.trainer2lift = $fc7bafbc02aaa463$var$trainer2lift;
module.exports.lift2trainer = $fc7bafbc02aaa463$var$lift2trainer;
module.exports.localization2physics = $fc7bafbc02aaa463$var$localization2physics;
module.exports.physics2localization = $fc7bafbc02aaa463$var$physics2localization;
module.exports.trainer2physics = $fc7bafbc02aaa463$var$trainer2physics;
module.exports.physics2trainer = $fc7bafbc02aaa463$var$physics2trainer;
module.exports.motorspin2ballspin = $fc7bafbc02aaa463$var$motorspin2ballspin;
module.exports.ballspin2motorspin = $fc7bafbc02aaa463$var$ballspin2motorspin;
module.exports.motorspin2spinlevel = $fc7bafbc02aaa463$var$motorspin2spinlevel;
module.exports.spinlevel2motorspin = $fc7bafbc02aaa463$var$spinlevel2motorspin;
module.exports.ballspin2spinlevel = $fc7bafbc02aaa463$var$ballspin2spinlevel;
module.exports.spinlevel2ballspin = $fc7bafbc02aaa463$var$spinlevel2ballspin;
module.exports.maxmotorspin_for_rpmspeed = $fc7bafbc02aaa463$var$maxmotorspin_for_rpmspeed;
module.exports.maxspinlevel_for_rpmspeed = $fc7bafbc02aaa463$var$maxspinlevel_for_rpmspeed;
module.exports.maxspinlevel = $fc7bafbc02aaa463$var$maxspinlevel;
module.exports.rpm2mps = $fc7bafbc02aaa463$var$rpm2mps;
module.exports.mps2rpm = $fc7bafbc02aaa463$var$mps2rpm;
module.exports.rpm2speedspin = $fc7bafbc02aaa463$var$rpm2speedspin;
module.exports.speedspin2rpm = $fc7bafbc02aaa463$var$speedspin2rpm;
module.exports.angle2Vector = $fc7bafbc02aaa463$var$angle2Vector;
module.exports.vector2Angle = $fc7bafbc02aaa463$var$vector2Angle;
module.exports.cameraHeight2HeadHeight = $fc7bafbc02aaa463$var$cameraHeight2HeadHeight;
module.exports.launchHeight2HeadHeight = $fc7bafbc02aaa463$var$launchHeight2HeadHeight;
module.exports.launchHeightInches2HeadHeight = $fc7bafbc02aaa463$var$launchHeightInches2HeadHeight;

var $lfLSf = parcelRequire("lfLSf");

var $2Yg5G = parcelRequire("2Yg5G");

var $2oLTm = parcelRequire("2oLTm");

var $faJc0 = parcelRequire("faJc0");

var $bRtcj = parcelRequire("bRtcj");

var $fdyC4 = parcelRequire("fdyC4");

var $gV6Yw = parcelRequire("gV6Yw");
/**
 * PHYSICSMODEL
 * Singleton physics model
 */ const $fc7bafbc02aaa463$var$defaultPhysicsModelName = "physics-20B-base";
const $fc7bafbc02aaa463$var$defaultSport = "PLATFORM_TENNIS";
(0, $lfLSf.assert)($fc7bafbc02aaa463$var$defaultPhysicsModelName in $2oLTm.tableRPM2MPHMap, `no RPM2MPH mapping for physics model ${$fc7bafbc02aaa463$var$defaultPhysicsModelName}`);
(0, $lfLSf.assert)($fc7bafbc02aaa463$var$defaultSport in $2oLTm.tableRPM2MPHMap[$fc7bafbc02aaa463$var$defaultPhysicsModelName], `no RPM2MPH mapping for physics model ${$fc7bafbc02aaa463$var$defaultPhysicsModelName}, sport ${$fc7bafbc02aaa463$var$defaultSport}`);
const $fc7bafbc02aaa463$var$defRPM2MPH = $2oLTm.tableRPM2MPHMap[$fc7bafbc02aaa463$var$defaultPhysicsModelName][$fc7bafbc02aaa463$var$defaultSport];
(0, $lfLSf.assert)($fc7bafbc02aaa463$var$defaultPhysicsModelName in $faJc0.tableLimitsMap, `no trainer limits mapping for physics model ${$fc7bafbc02aaa463$var$defaultPhysicsModelName}`);
(0, $lfLSf.assert)($fc7bafbc02aaa463$var$defaultSport in $faJc0.tableLimitsMap[$fc7bafbc02aaa463$var$defaultPhysicsModelName], `no trainer limits mapping for physics model ${$fc7bafbc02aaa463$var$defaultPhysicsModelName}, sport ${$fc7bafbc02aaa463$var$defaultSport}`);
const $fc7bafbc02aaa463$var$defLimitsRPM = $faJc0.tableLimitsMap[$fc7bafbc02aaa463$var$defaultPhysicsModelName][$fc7bafbc02aaa463$var$defaultSport].RPM;
(0, $lfLSf.assert)($fc7bafbc02aaa463$var$defaultPhysicsModelName in $bRtcj.tableTrainerGeometryMap, `no trainer geometry mapping for physics model ${$fc7bafbc02aaa463$var$defaultPhysicsModelName}`);
const $fc7bafbc02aaa463$var$defTrainerGeometry = $bRtcj.tableTrainerGeometryMap[$fc7bafbc02aaa463$var$defaultPhysicsModelName];
(0, $lfLSf.assert)($fc7bafbc02aaa463$var$defaultSport in $2Yg5G.CourtGeometryBySport, `no court geometry mapping for sport ${$fc7bafbc02aaa463$var$defaultSport}`);
(0, $lfLSf.assert)($fc7bafbc02aaa463$var$defaultPhysicsModelName in $gV6Yw.tableSpinAdjustMap, `no spin adjustment mapping for physics model ${$fc7bafbc02aaa463$var$defaultPhysicsModelName}`);
(0, $lfLSf.assert)($fc7bafbc02aaa463$var$defaultSport in $gV6Yw.tableSpinAdjustMap[$fc7bafbc02aaa463$var$defaultPhysicsModelName], `no spin adjustment mapping for physics model ${$fc7bafbc02aaa463$var$defaultPhysicsModelName}, sport ${$fc7bafbc02aaa463$var$defaultSport}`);
const $fc7bafbc02aaa463$var$defSpinAdjust = $gV6Yw.tableSpinAdjustMap[$fc7bafbc02aaa463$var$defaultPhysicsModelName][$fc7bafbc02aaa463$var$defaultSport];
const $fc7bafbc02aaa463$var$PHYSICSMODEL = {
    name: $fc7bafbc02aaa463$var$defaultPhysicsModelName,
    sport: $fc7bafbc02aaa463$var$defaultSport,
    ballParams: $2Yg5G.BallParamsBySport[$fc7bafbc02aaa463$var$defaultSport],
    mapRPM2MPH: $fc7bafbc02aaa463$var$defRPM2MPH,
    simParams: $2Yg5G.DefaultSimulationParams,
    trainerGeometry: $fc7bafbc02aaa463$var$defTrainerGeometry,
    constants: $2Yg5G.DefaultPhysicalConstants,
    limits: {
        RPM: $fc7bafbc02aaa463$var$defLimitsRPM,
        MPS: {
            limit: $fc7bafbc02aaa463$var$defRPM2MPH[$fc7bafbc02aaa463$var$defLimitsRPM.limit] * 0.44704,
            maxSafe: $fc7bafbc02aaa463$var$defRPM2MPH[$fc7bafbc02aaa463$var$defLimitsRPM.maxSafe] * 0.44704,
            minSafe: $fc7bafbc02aaa463$var$defRPM2MPH[$fc7bafbc02aaa463$var$defLimitsRPM.minSafe] * 0.44704
        }
    },
    courtGeometry: $2Yg5G.CourtGeometryBySport[$fc7bafbc02aaa463$var$defaultSport],
    spinAdjust: $fc7bafbc02aaa463$var$defSpinAdjust
};
/**
 * setPhysicsModel
 * Set the internal physics model used to predict/simulate ball launch, etc.
 * @param trainer  trainer type
 * @param sport  sport to model
 */ function $fc7bafbc02aaa463$var$setPhysicsModel(physicsModelName, sport) {
    (0, $lfLSf.assert)(physicsModelName in $2oLTm.tableRPM2MPHMap, `no RPM2MPH mapping for physics model ${physicsModelName}`);
    (0, $lfLSf.assert)(sport in $2oLTm.tableRPM2MPHMap[physicsModelName], `no RPM2MPH mapping for physics model ${physicsModelName}, sport ${sport}`);
    (0, $lfLSf.assert)(physicsModelName in $faJc0.tableLimitsMap, `no physicsModelName limits mapping for physics model ${physicsModelName}`);
    (0, $lfLSf.assert)(sport in $faJc0.tableLimitsMap[physicsModelName], `no physicsModelName limits mapping for physics model ${physicsModelName}, sport ${sport}`);
    (0, $lfLSf.assert)(sport in $2Yg5G.CourtGeometryBySport, `no court geometry mapping for sport ${sport}`);
    (0, $lfLSf.assert)(physicsModelName in $bRtcj.tableTrainerGeometryMap, `no trainer geometry mapping for physics model ${physicsModelName}`);
    (0, $lfLSf.assert)(physicsModelName in $gV6Yw.tableSpinAdjustMap, `no spin adjustment mapping for physics model ${physicsModelName}`);
    (0, $lfLSf.assert)(sport in $gV6Yw.tableSpinAdjustMap[physicsModelName], `no spin adjustment mapping for sport ${sport}`);
    const limitsRPM = $faJc0.tableLimitsMap[physicsModelName][sport].RPM;
    const RPMtoMPH = $2oLTm.tableRPM2MPHMap[physicsModelName][sport];
    const trainerGeometry = $bRtcj.tableTrainerGeometryMap[physicsModelName];
    const spinAdjust = $gV6Yw.tableSpinAdjustMap[physicsModelName][sport];
    // --- set the model ---
    $fc7bafbc02aaa463$var$PHYSICSMODEL.name = physicsModelName;
    $fc7bafbc02aaa463$var$PHYSICSMODEL.sport = sport;
    $fc7bafbc02aaa463$var$PHYSICSMODEL.ballParams = $2Yg5G.BallParamsBySport[sport];
    $fc7bafbc02aaa463$var$PHYSICSMODEL.mapRPM2MPH = RPMtoMPH;
    $fc7bafbc02aaa463$var$PHYSICSMODEL.simParams = $2Yg5G.DefaultSimulationParams;
    $fc7bafbc02aaa463$var$PHYSICSMODEL.trainerGeometry = trainerGeometry;
    $fc7bafbc02aaa463$var$PHYSICSMODEL.constants = $2Yg5G.DefaultPhysicalConstants;
    $fc7bafbc02aaa463$var$PHYSICSMODEL.limits.RPM = limitsRPM;
    $fc7bafbc02aaa463$var$PHYSICSMODEL.courtGeometry = $2Yg5G.CourtGeometryBySport[sport];
    $fc7bafbc02aaa463$var$PHYSICSMODEL.spinAdjust = spinAdjust;
    // MPS limits are derived from RPM limits (note: converting MPH to MPS)
    $fc7bafbc02aaa463$var$PHYSICSMODEL.limits.MPS.limit = RPMtoMPH[limitsRPM.limit] * 0.44704;
    $fc7bafbc02aaa463$var$PHYSICSMODEL.limits.MPS.maxSafe = RPMtoMPH[limitsRPM.maxSafe] * 0.44704;
    $fc7bafbc02aaa463$var$PHYSICSMODEL.limits.MPS.minSafe = RPMtoMPH[limitsRPM.minSafe] * 0.44704;
}
/**
 * getPhysicsModel
 * Get the currently used physics model name.
 */ function $fc7bafbc02aaa463$var$getPhysicsModel() {
    return $fc7bafbc02aaa463$var$PHYSICSMODEL;
}
/**
 * crossProduct
 * Compute the cross product of 2 non-zero vectors
 * @param a  Vector
 * @param b  Vector
 * Returns: a unit vector that is the cross-product (a x b)
 */ function $fc7bafbc02aaa463$var$crossProduct(a, b) {
    const out = {
        x: a.y * b.z - b.y * a.z,
        y: -(a.x * b.z - b.x * a.z),
        z: a.x * b.y - b.x * a.y
    };
    const mag = Math.sqrt(out.x * out.x + out.y * out.y + out.z * out.z);
    out.x /= mag;
    out.y /= mag;
    out.z /= mag;
    return out;
}
/**
 * yawpitch2launchpoint
 * Convert trainer yaw (pan) and pitch (tilt) to a launch point.
 * This conversion tranlates the wheel assembly rotations into the point from which
 * the ball will be launched (launch coords).
 * @param: yawDeg: yaw (pan) angle in degrees: forward (+y) is 0, + = right
 * @param: pitchDeg: pitch (tilt) angle in degrees: forward (+y) is 0, + = up
 * @returns the ball launch point in launch coords
 */ function $fc7bafbc02aaa463$var$yawpitch2launchpoint(yawDeg, pitchDeg) {
    const R = $fc7bafbc02aaa463$var$PHYSICSMODEL.trainerGeometry.launchDistanceFromRotationCenter;
    (0, $lfLSf.assert)(Math.abs(yawDeg) <= 90 && Math.abs(pitchDeg) <= 90, `yaw and pitch (${yawDeg}, ${pitchDeg}) must be in [-90, 90]`);
    const lp_launch = {
        x: R * Math.cos(pitchDeg * (Math.PI / 180.0)) * Math.sin(yawDeg * (Math.PI / 180.0)),
        y: R * Math.cos(pitchDeg * (Math.PI / 180.0)) * Math.cos(yawDeg * (Math.PI / 180.0)),
        z: R * Math.sin(pitchDeg * (Math.PI / 180.0))
    };
    return lp_launch;
}
/**
 * trainer2lift
 * Convert a point in trainer coords to lift coords.
 * Trainer coords: origin is on court below center of rear axle, +x is right wrt trainer, +y is forward, +z is up
 * lift coords: origin is at end of lift arm when arm is parallel to ground (fully extended)
 * @param pTrainer: point in trainer coords
 * @returns same point in lift coords
 */ function $fc7bafbc02aaa463$var$trainer2lift(pTrainer) {
    const lpp = $fc7bafbc02aaa463$var$PHYSICSMODEL.trainerGeometry.liftPivotPosition;
    const armLen = $fc7bafbc02aaa463$var$PHYSICSMODEL.trainerGeometry.liftArmLength;
    const liftOrigin = {
        x: lpp.x,
        y: lpp.y + armLen,
        z: lpp.z
    };
    const liftRot = {
        x: 0,
        y: 0,
        z: 0
    };
    const pLift = (0, $fdyC4.coordChange)(pTrainer, liftOrigin, liftRot);
    return pLift;
}
/**
 * lift2trainer
 * Convert a point in lift to trainer coords.
 * lift coords: origin is at end of lift arm when arm is parallel to ground (fully extended)
 * Trainer coords: origin is on court below center of rear axle, +x is right wrt trainer, +y is forward, +z is up
 * @param pLift: point in lift coords
 * @returns same point in trainer coords
 */ function $fc7bafbc02aaa463$var$lift2trainer(pLift) {
    const lpp = $fc7bafbc02aaa463$var$PHYSICSMODEL.trainerGeometry.liftPivotPosition;
    const armLen = $fc7bafbc02aaa463$var$PHYSICSMODEL.trainerGeometry.liftArmLength;
    const trainerOrigin = {
        x: -lpp.x,
        y: -(lpp.y + armLen),
        z: -lpp.z
    };
    const trainerRot = {
        x: 0,
        y: 0,
        z: 0
    };
    const pTrainer = (0, $fdyC4.coordChange)(pLift, trainerOrigin, trainerRot);
    return pTrainer;
}
/**
 * localization2physics
 * Convert a point in localization coords to physics coords.
 * Localization coords (NOTE: mm): origin is upper-left corner of court, +x right, +y into court, +z up
 * Physics coords (m): origin is court center, +x right, +y toward top baseline, +z up
 * @param pLocalization: point in localization coords
 * @returns point pLocalization in physics coords
 */ function $fc7bafbc02aaa463$var$localization2physics(pLocalization) {
    const CW = $fc7bafbc02aaa463$var$PHYSICSMODEL.courtGeometry.COURT_WIDTH;
    const CL = $fc7bafbc02aaa463$var$PHYSICSMODEL.courtGeometry.COURT_LENGTH;
    const pPoint = {
        x: 0,
        y: 0,
        z: 0
    };
    pPoint.x = pLocalization.x / 1000.0 - CW / 2.0;
    pPoint.y = -1 * (pLocalization.y / 1000.0) + CL / 2.0;
    pPoint.z = pLocalization.z / 1000.0;
    return pPoint;
}
/**
 * physics2localization
 * Convert a point in physics coords to localization coords.
 * Physics coords (m): origin is court center, +x right, +y toward top/far baseline, +z up
 * Localization coords (NOTE: mm): origin is upper-left corner of court, +x right, +y into court, +z up
 * @param pPhysics: point in physics coords
 * @returns same point in localization coords
 */ function $fc7bafbc02aaa463$var$physics2localization(pPhysics) {
    const CW = $fc7bafbc02aaa463$var$PHYSICSMODEL.courtGeometry.COURT_WIDTH;
    const CL = $fc7bafbc02aaa463$var$PHYSICSMODEL.courtGeometry.COURT_LENGTH;
    const lPoint = {
        x: 0,
        y: 0,
        z: 0
    };
    lPoint.x = (pPhysics.x + CW / 2.0) * 1000.0;
    lPoint.y = -1 * (pPhysics.y - CL / 2.0) * 1000.0;
    lPoint.z = pPhysics.z * 1000.0;
    return lPoint;
}
/**
 * trainer2physics
 * Convert a point in trainer coords to physics coords, given the position and orientation
 * of the trainer in physics coords.
 * Physics coords: origin is court center, +x right, +y toward top/far baseline, +z up
 * Trainer coords: origin is on court below center of rear axle, +x is right wrt trainer, +y is forward, +z is up
 * @param pTrainer: point in trainer coords
 * @param pTrainerPosition: the position of the trainer in physics coords
 * @param trainerYaw: the yaw angle of the trainer in degrees (0 = down trainer y axis with +=right)
 * @returns same point in physics coords
 */ function $fc7bafbc02aaa463$var$trainer2physics(pTrainer, pTrainerPosition, trainerYaw) {
    // first, rotate the trainer axes to align them with physics coords
    const pAligned = (0, $fdyC4.coordChange)(pTrainer, {
        x: 0,
        y: 0,
        z: 0
    }, {
        x: 0,
        y: 0,
        z: trainerYaw
    });
    // Now the coordinates of physics system origin in aligned coords are simply
    // the inverse of the trainer position passed in
    const newOrigin = {
        x: -1 * pTrainerPosition.x,
        y: -1 * pTrainerPosition.y,
        z: 0
    };
    const pPoint = (0, $fdyC4.coordChange)(pAligned, newOrigin, {
        x: 0,
        y: 0,
        z: 0
    });
    return pPoint;
}
/**
 * physics2trainer
 * Convert a point in physics coords to trainer coords, given the position and orientation
 * of the trainer in physics coords.
 * Physics coords: origin is court center, +x right, +y toward top/far baseline, +z up
 * Trainer coords: origin is on court below center of rear axle, +x is right wrt trainer, +y is forward, +z is up
 * @param pPhysics: point in physics coords
 * @param pTrainerPosition: the position of the trainer in physics coords
 * @param trainerYaw: the yaw angle of the trainer in degrees (0 = down trainer y axis with +=right)
 * @returns same point in physics coords
 */ function $fc7bafbc02aaa463$var$physics2trainer(pPhysics, pTrainerPosition, trainerYaw) {
    // The new coordinate system origin is the trainer position
    const newOrigin = pTrainerPosition;
    // The rotation that takes physics coords to trainer coords
    const rotZDegrees = -1 * trainerYaw;
    const pTrainer = (0, $fdyC4.coordChange)(pPhysics, newOrigin, {
        x: 0,
        y: 0,
        z: rotZDegrees
    });
    return pTrainer;
}
/**
 * motorspin2ballspin
 * Convert ball spin in motor RPM (motor RPM is the equivalent motor RPM induced by the trainer motors
 * around a spin axis) to ball spin in ball RPMs (ball rotation RPMs). Ball spin RPM is higher than
 * motor RPM proportional to the wheel diameter ratio "gain" (i.e. big motor wheel spinning small ball).
 * @param motorspinRPM: spin magnitude in motor RPM
 * returns: spin magnitude in ball RPM
 */ function $fc7bafbc02aaa463$var$motorspin2ballspin(motorspinRPM) {
    const ballDiam = $fc7bafbc02aaa463$var$PHYSICSMODEL.ballParams.diameter;
    const wheelDiam = $fc7bafbc02aaa463$var$PHYSICSMODEL.ballParams.diameter;
    // diameters of ball and wheel in meters
    (0, $lfLSf.assert)(motorspinRPM >= 0, `ball spin in motor rpm ${motorspinRPM} must be >=0`);
    (0, $lfLSf.assert)(ballDiam > 0, `ball diameter ${ballDiam} must be >0`);
    (0, $lfLSf.assert)(wheelDiam > 0, `wheel diameter ${wheelDiam} must be >0`);
    const ballspinRPM = wheelDiam / ballDiam * motorspinRPM;
    return ballspinRPM;
}
/**
 * ballspin2motorspin
 * Convert ball spin in ball RPM to ball spin in motor RPMs.
 * @param ballspinRPM: spin magnitude in motor RPM
 * returns: spin magnitude in motor RPM
 */ function $fc7bafbc02aaa463$var$ballspin2motorspin(ballspinRPM) {
    const ballDiam = $fc7bafbc02aaa463$var$PHYSICSMODEL.ballParams.diameter;
    const wheelDiam = $fc7bafbc02aaa463$var$PHYSICSMODEL.ballParams.diameter;
    // diameters of ball and wheel in meters
    (0, $lfLSf.assert)(ballspinRPM >= 0, `ball spin in ball rpm ${ballspinRPM} must be >=0`);
    (0, $lfLSf.assert)(ballDiam > 0, `ball diameter ${ballDiam} must be >0`);
    (0, $lfLSf.assert)(wheelDiam > 0, `wheel diameter ${wheelDiam} must be >0`);
    const motorspinRPM = ballDiam / wheelDiam * ballspinRPM;
    return motorspinRPM;
}
/**
 * motorspin2spinlevel
 * Convert an "analog" ball spin in motor RPM to a "digital" integer spin level in [0, 10] based on
 * the max motor spin RPM achievable by the trainer.  Level 0 (no spin) occurs only for motorspinRPM
 * 0. Positive motorspinRPM values will be mapped to equal-sized bins 1-10 covering the interval
 * (0, maxSpin], where maxSpin is the max spin RPM the trainer can achieve.
 * @param motorspinRPM: spin magnitude in motor RPM
 * returns: integer spin level in [0, 10]
 */ function $fc7bafbc02aaa463$var$motorspin2spinlevel(motorspinRPM) {
    const maxMotorSpinRPM = $fc7bafbc02aaa463$var$PHYSICSMODEL.limits.RPM.maxSpin;
    (0, $lfLSf.assert)(motorspinRPM >= 0 && motorspinRPM <= maxMotorSpinRPM, `motor spin RPM (${motorspinRPM}) must in [0, ${maxMotorSpinRPM}]`);
    if (motorspinRPM === 0) return 0;
    const levelFraction = motorspinRPM / maxMotorSpinRPM;
    // Why is scale factor 9.999 (and the "+1") used instead of scale factor of 10?
    // So that all values in (0, 1/10th of max) map to 1, etc...
    return Math.floor(levelFraction * 9.999) + 1;
}
/**
 * spinlevel2motorspin
 * Convert a "digital" ball spin level in [0, 10] to a specific motor RPM spin. Level 0 yields 0.
 * The motor RPM spins returned for levels 1-10 correspond to the RPMs at the midpoint of
 * the 10 equisized bins covering (0, maxSpin], where maxSpin is the max achievable spin RPM.
 * @param spinLevel: spin level in [0,10]
 * return: spin motor RPM at the midpoint of the interval corresponding to the level
 */ function $fc7bafbc02aaa463$var$spinlevel2motorspin(spinLevel) {
    const maxMotorSpinRPM = $fc7bafbc02aaa463$var$PHYSICSMODEL.limits.RPM.maxSpin;
    (0, $lfLSf.assert)(spinLevel >= 0 && spinLevel <= 10 && Number.isInteger(spinLevel), `spin level ${spinLevel} must be an integer in [0,10]`);
    if (spinLevel === 0) return 0;
    return (spinLevel / 10.0 - 0.05) * maxMotorSpinRPM;
}
/**
 * ballspin2spinlevel
 * @param ballspinRPM: ball spin in ball RPM
 * @returns spinlevel in [0, 10]
 */ function $fc7bafbc02aaa463$var$ballspin2spinlevel(ballspinRPM) {
    const motor_spin = $fc7bafbc02aaa463$var$ballspin2motorspin(ballspinRPM);
    return $fc7bafbc02aaa463$var$motorspin2spinlevel(motor_spin);
}
/**
 * spinlevel2ballspin
 * @param spinlevel:spinlevel in [0, 10]
 * @returns ball spin in ball RPM
 */ function $fc7bafbc02aaa463$var$spinlevel2ballspin(spinlevel) {
    const motor_spin = $fc7bafbc02aaa463$var$spinlevel2motorspin(spinlevel);
    return $fc7bafbc02aaa463$var$motorspin2ballspin(motor_spin);
}
/**
 * maxmotorspin_for_limit (private)
 * For a given angle and launch speed in motor RPM, returns the max motor spin RPM
 * attainable constrainted by the specified motor RPM limit.
 * Returns a positive motor spin RPM value.
 * @param angle: spin axis angle in degrees
 * @param launch_speed_rpm: ball launch speed in motor RPM
 * @param rpm_limit: the RPM limit
 * returns: max possible motor RPM spin possible under the limit constraint.
 */ function $fc7bafbc02aaa463$var$maxmotorspin_for_limit(angle, launch_speed_rpm, rpm_limit) {
    const minRPM = $fc7bafbc02aaa463$var$PHYSICSMODEL.limits.RPM.minSafe;
    const maxRPM = $fc7bafbc02aaa463$var$PHYSICSMODEL.limits.RPM.maxSafe;
    (0, $lfLSf.assert)(angle >= 0 && angle <= 360, `angle ${angle} must be in [0, 360]`);
    (0, $lfLSf.assert)(launch_speed_rpm >= minRPM && launch_speed_rpm <= maxRPM, `launch speed RPM ${launch_speed_rpm} must be >=${minRPM} and <= ${maxRPM}`);
    (0, $lfLSf.assert)(rpm_limit >= minRPM && rpm_limit <= maxRPM, `RPM limit ${rpm_limit} must be >= ${minRPM} and <= ${maxRPM}`);
    if (launch_speed_rpm === 0 || launch_speed_rpm === rpm_limit) return 0;
    let spin_t = 1e6;
    let spin_l = 1e6;
    let spin_r = 1e6;
    const deg2rad = Math.PI / 180.0;
    let spin_t_denom = Math.cos(angle * deg2rad);
    let spin_l_denom = Math.cos(angle * deg2rad) - Math.sqrt(3) * Math.sin(angle * deg2rad);
    let spin_r_denom = Math.cos(angle * deg2rad) + Math.sqrt(3) * Math.sin(angle * deg2rad);
    if (Math.abs(spin_t_denom) < 1.0e-8) spin_t_denom = 0;
    if (Math.abs(spin_l_denom) < 1.0e-8) spin_l_denom = 0;
    if (Math.abs(spin_r_denom) < 1.0e-8) spin_r_denom = 0;
    // flip ensures that we return only positive spins
    const flip = Math.sign(launch_speed_rpm - rpm_limit);
    if (flip * spin_t_denom < 0) spin_t = -1.5 * (launch_speed_rpm - rpm_limit) * (1.0 / spin_t_denom);
    if (flip * spin_l_denom > 0) spin_l = 3.0 * (launch_speed_rpm - rpm_limit) * (1.0 / spin_l_denom);
    if (flip * spin_r_denom > 0) spin_r = 3.0 * (launch_speed_rpm - rpm_limit) * (1.0 / spin_r_denom);
    const max_spin = Math.min(spin_t, spin_l, spin_r);
    return max_spin;
}
/**
 * maxmotorspin_for_rpmspeed
 * For a given angle and launch speed in motor RPM, returns the max spin attainable
 * by the trainer in motor RPM.
 * @param angle: spin axis angle in degrees
 * @param launch_speed_rpm: ball launch speed in motor RPM
 * returns: max possible motor RPM spin for (angle, launch_speed_rpm).
 * NOTE: depends on physics model lower (0) and upper (RPMMaxSafe) limits on
 * individual motor RPM.
 */ function $fc7bafbc02aaa463$var$maxmotorspin_for_rpmspeed(angle, launch_speed_rpm) {
    if (launch_speed_rpm === 0) return 0;
    const rpm_limit_low = $fc7bafbc02aaa463$var$PHYSICSMODEL.limits.RPM.minSafe;
    const rpm_limit_high = $fc7bafbc02aaa463$var$PHYSICSMODEL.limits.RPM.maxSafe;
    const max_spin1 = $fc7bafbc02aaa463$var$maxmotorspin_for_limit(angle, launch_speed_rpm, rpm_limit_high);
    const max_spin2 = $fc7bafbc02aaa463$var$maxmotorspin_for_limit(angle, launch_speed_rpm, rpm_limit_low);
    return Math.min(max_spin1, max_spin2);
}
/**
 * maxspinlevel_for_rpmspeed
 * For a given angle and launch speed in motor RPM, returns the max ball spin
 * level [0-10] attainable by the trainer.
 * @param angle: spin axis angle in degrees
 * @param launch_speed_rpm: ball launch speed in motor RPM
 * @returns the max spin level in [0, 10] achievable for (angle, launch speed)
 */ function $fc7bafbc02aaa463$var$maxspinlevel_for_rpmspeed(angle, launch_speed_rpm) {
    if (launch_speed_rpm === 0) return 0;
    const max_motor_spin = $fc7bafbc02aaa463$var$maxmotorspin_for_rpmspeed(angle, launch_speed_rpm);
    const max_lev = $fc7bafbc02aaa463$var$motorspin2spinlevel(max_motor_spin);
    if (max_lev === 0) return 0;
    // the spin level corresponding to max motor spin might yield spin motor RPM
    // > max motor spin (since max motor spin can land anywhere in the level
    // interval and a level's spin RPM is at 0.95 of the max). In this case, use
    // the next level down.
    const max_lev_rpm = $fc7bafbc02aaa463$var$spinlevel2motorspin(max_lev);
    return max_lev_rpm > max_motor_spin ? max_lev - 1 : max_lev;
}
/**
 * maxspinlevel
 * For a given angle and launch speed in m/sec, returns the max ball spin
 * level [0-10] attainable by the trainer.
 * @param angle: spin axis angle (degrees)
 * @param speed: launch speed (m/sec)
 */ function $fc7bafbc02aaa463$var$maxspinlevel(angle, speed) {
    const speed_rpm = $fc7bafbc02aaa463$var$mps2rpm(speed);
    return $fc7bafbc02aaa463$var$maxspinlevel_for_rpmspeed(angle, speed_rpm);
}
/**
 * rpm2mps
 * Returns the launch speed in m/sec corresponding to the specified trainer
 * motor RPMs (with all motors set to the same RPMs; i.e. a knuckleball).
 * NOTE: input RPM values are rounded to the nearest integer RPM and
 * the speeds read from a table generated by fitting measured data.
 * NOTE: input rpms must be in [-4000,4000] (limits of measured data).
 * @param rpm motor RPM
 * @returns launch speed in m/sec
 */ function $fc7bafbc02aaa463$var$rpm2mps(rpm) {
    const minRPM = $fc7bafbc02aaa463$var$PHYSICSMODEL.limits.RPM.minSafe;
    const maxRPM = $fc7bafbc02aaa463$var$PHYSICSMODEL.limits.RPM.maxSafe;
    // assert(rpm >= physicsModel.RPMMinSafe && rpm <= physicsModel.RPMMaxSafe,
    //     `rpm ${rpm} must be >= ${physicsModel.RPMMinSafe} && <= ${physicsModel.RPMMaxSafe}`);
    (0, $lfLSf.assert)(rpm >= 0, `rpm is ${rpm}: must be >=0`);
    if (rpm > maxRPM) {
        console.warn(`rpm2mps: ** WARNING **: rpm ${rpm} high, limiting to ${maxRPM}`);
        rpm = maxRPM;
    }
    if (rpm < minRPM) {
        console.warn(`rpm2mps: ** WARNING **: rpm ${rpm} low, limiting to ${minRPM}`);
        rpm = minRPM;
    }
    const irpm = Math.round(rpm);
    // Read from RPM2MPH table and convert to mps
    const mps = $fc7bafbc02aaa463$var$PHYSICSMODEL.mapRPM2MPH[irpm] * 0.44704;
    return mps;
}
/**
 * isNonDecreasing (private)
 * Whether table[lo..hi] never decreases, memoized per table and band:
 * mps2rpm runs on every solver iteration, and the tables never change.
 */ const $fc7bafbc02aaa463$var$nonDecreasingCache = new WeakMap();
function $fc7bafbc02aaa463$var$isNonDecreasing(table, lo, hi) {
    let byBand = $fc7bafbc02aaa463$var$nonDecreasingCache.get(table);
    if (byBand === undefined) {
        byBand = new Map();
        $fc7bafbc02aaa463$var$nonDecreasingCache.set(table, byBand);
    }
    const key = `${lo}:${hi}`;
    let result = byBand.get(key);
    if (result === undefined) {
        result = true;
        for(let i = lo + 1; i <= hi; i += 1)// also rejects NaN, which a binary search can't order
        if (!(table[i] >= table[i - 1])) {
            result = false;
            break;
        }
        byBand.set(key, result);
    }
    return result;
}
/**
 * closestRPM (private)
 * The RPM in [minRPM, maxRPM] whose table MPH is nearest mph, as [error, rpm];
 * [-1, -1] if the band holds no table entries. On a tie the lower RPM wins.
 * Bit-identical to a linear scan of the band, but a binary search when the
 * band is monotonic (every fitted table is).
 */ function $fc7bafbc02aaa463$var$closestRPM(table, mph, minRPM, maxRPM) {
    const lo = Math.max(0, minRPM);
    const hi = Math.min(table.length - 1, maxRPM);
    if (hi < lo) return [
        -1,
        -1
    ];
    if (!$fc7bafbc02aaa463$var$isNonDecreasing(table, lo, hi)) {
        let best = lo;
        let bestErr = Math.abs(mph - table[lo]);
        for(let i = lo + 1; i <= hi; i += 1){
            const e = Math.abs(mph - table[i]);
            if (e < bestErr) {
                best = i;
                bestErr = e;
            }
        }
        return [
            bestErr,
            best
        ];
    }
    // first index whose value is >= v (hi + 1 if none)
    const lowerBound = (v)=>{
        let a = lo;
        let b = hi + 1;
        while(a < b){
            const m = Math.floor((a + b) / 2);
            if (table[m] < v) a = m + 1;
            else b = m;
        }
        return a;
    };
    const above = lowerBound(mph);
    if (above === lo) return [
        Math.abs(mph - table[lo]),
        lo
    ];
    // the entry below mph: the first of its run of equal values, as a scan finds
    const below = lowerBound(table[above - 1]);
    const belowErr = Math.abs(mph - table[below]);
    if (above > hi) return [
        belowErr,
        below
    ];
    const aboveErr = Math.abs(mph - table[above]);
    return aboveErr < belowErr ? [
        aboveErr,
        above
    ] : [
        belowErr,
        below
    ];
}
/**
 * mps2rpm
 * Returns the motor RPM (constant for all motors) that correspond
 * to the specified launch speed in m/sec.
 * NOTE: input mps must be in [-28,28] (limits of measured data).
 * NOTE: values are determined by doing closest-element lookup
 * in table RPM2MPH (a binary search; see closestRPM). This
 * assures close to perfect invertibility of the mps2rpm() and
 * rpm2mps() functions.
 * @param mps launch speed in m/sec
 * @returns motor RPM
 */ function $fc7bafbc02aaa463$var$mps2rpm(mps) {
    const minMPS = $fc7bafbc02aaa463$var$PHYSICSMODEL.limits.MPS.minSafe;
    const maxMPS = $fc7bafbc02aaa463$var$PHYSICSMODEL.limits.MPS.maxSafe;
    // assert(mps >= physicsModel.MPSMinSafe && mps <= physicsModel.MPSMaxSafe,
    //     `mps ${mps} must be >= ${physicsModel.MPSMinSafe} && <= ${physicsModel.MPSMaxSafe}`);
    (0, $lfLSf.assert)(mps >= 0, `mps is ${mps}: must be >=0`);
    if (mps > maxMPS) {
        // eslint-disable-next-line max-len
        console.warn(`mps2rpm: ** WARNING **: internal scaled mps ${mps} high, limiting to ${maxMPS}`);
        mps = maxMPS;
    }
    if (mps < minMPS) {
        // eslint-disable-next-line max-len
        console.warn(`mps2rpm: ** WARNING **: internal scaled mps ${mps} low, limiting to ${minMPS}`);
        mps = minMPS;
    }
    // convert to mph
    const imph = mps / 0.44704;
    // Find the RPM that gives the closest mps match, searching only the safe
    // operating band. Bounding this is load-bearing, not tidiness: an RPM2MPH
    // curve is a fit, and a fit can roll over past the top of its measured
    // data. Platform tennis's does - it peaks at 4701 RPM and then declines -
    // so an unbounded nearest-value scan can match a speed on the falling side
    // and return an RPM above maxSafe. Every caller assumes the result is
    // within [minSafe, maxSafe] (maxmotorspin_for_limit asserts it), so an
    // out-of-band answer surfaces as an assertion failure rather than a clamp.
    const minRPM = $fc7bafbc02aaa463$var$PHYSICSMODEL.limits.RPM.minSafe;
    const maxRPM = $fc7bafbc02aaa463$var$PHYSICSMODEL.limits.RPM.maxSafe;
    const [err, rpm] = $fc7bafbc02aaa463$var$closestRPM($fc7bafbc02aaa463$var$PHYSICSMODEL.mapRPM2MPH, imph, minRPM, maxRPM);
    if (Math.abs(err) > 10) console.warn(`mps2rpm: ** WARNING **: mps=${mps}: large error in RPM value (err: ${err})`);
    const rpmout = rpm;
    // console.log(`mps2rpm: ${mps} --> ${rpmout} (err=${err}])`)
    return rpmout;
}
/**
 * rpm2speedspin
 * Convert from motor RPMs shot representation to "speed and spin" representation.
 * @param rpms  RPM3 object specifying top, left, and right motor RPMs
 * @returns  The speed+spin representation of the shot.
 */ function $fc7bafbc02aaa463$var$rpm2speedspin(rpms) {
    const ss = {
        spinAxis: 0,
        speed: 0,
        spin: 0,
        spinLevel: 0
    };
    const vx = rpms.top - 0.5 * rpms.left - 0.5 * rpms.right;
    const vy = Math.sqrt(3) / 2.0 * rpms.left - Math.sqrt(3) / 2.0 * rpms.right;
    const sl_rpm = (rpms.top + rpms.left + rpms.right) / 3.0;
    // console.log(`rpm2speedspin_l: t=${rpms.top}, l=${rpms.left}, r=${rpms.right}`);
    // console.log(`rpm2speedspin_l: launch speed RPM: ${sl_rpm}`);
    // console.log(`rpm2speedspin_l: vx=${vx}, vy=${vy}`);
    ss.speed = $fc7bafbc02aaa463$var$rpm2mps(sl_rpm);
    if (sl_rpm === 0 || ss.speed === 0) return ss;
    // extract axis angle from spin vector
    ss.spinAxis = $fc7bafbc02aaa463$var$vector2Angle(vx, vy);
    // Ball spin motor RPM is equal to the magnitude of the spin vector
    let spinMotorRPM = Math.sqrt(0.5 * ((rpms.left - rpms.right) * (rpms.left - rpms.right) + (rpms.right - rpms.top) * (rpms.right - rpms.top) + (rpms.left - rpms.top) * (rpms.left - rpms.top)));
    // Adjust speed (in spin case only) based on motor alignment of spin
    if (spinMotorRPM > 0 && $fc7bafbc02aaa463$var$PHYSICSMODEL.spinAdjust.speedDampingFactor) // const oldSpeed = ss.speed;
    ss.speed /= $fc7bafbc02aaa463$var$PHYSICSMODEL.spinAdjust.speedDampingFactor(ss.spinAxis);
    // Spin motor RPM is the target ball spin. This is the place where we
    // can apply spin adjustment based on how the spin axis aligns with motors.
    if ($fc7bafbc02aaa463$var$PHYSICSMODEL.spinAdjust.spinDampingFactor) // const oldSpin = spinMotorRPM;
    spinMotorRPM /= $fc7bafbc02aaa463$var$PHYSICSMODEL.spinAdjust.spinDampingFactor(ss.spinAxis);
    // set spin
    ss.spin = $fc7bafbc02aaa463$var$motorspin2ballspin(spinMotorRPM);
    ss.spinLevel = $fc7bafbc02aaa463$var$motorspin2spinlevel(spinMotorRPM);
    return ss;
}
/**
 * speedspin2rpm
 * Convert a shot in speedspin format to motor RPM values.
 * @param speedSpin: shot in speedspin form
 * @returns RPM3 object of motor RPM values (top, left, right)
 */ function $fc7bafbc02aaa463$var$speedspin2rpm(speedSpin) {
    const rpms = {
        left: 0,
        top: 0,
        right: 0
    };
    (0, $lfLSf.assert)(speedSpin.speed >= 0, `speedspin2rpm: illegal speed ${speedSpin.speed}: must be >=0`);
    // Spin can be specified using spin (ball RPMs) or spinLevel([0-10]) but not both.
    (0, $lfLSf.assert)(// eslint-disable-next-line max-len
    speedSpin.spin === null && speedSpin.spinLevel !== null || speedSpin.spin !== null && speedSpin.spinLevel === null, "speedspin2rpm: exactly 1 of (spin, spinLevel) must be specified");
    let shotSpeed = speedSpin.speed;
    // Does this shot incorporate spin?
    const hasSpin = speedSpin.spin !== null && speedSpin.spin > 0 || speedSpin.spinLevel !== null && speedSpin.spinLevel > 0;
    // Adjust speed (in spin case only) based on motor alignment of spin
    if (hasSpin && $fc7bafbc02aaa463$var$PHYSICSMODEL.spinAdjust.speedDampingFactor) {
        // const oldSpeed = shotSpeed;
        const df = $fc7bafbc02aaa463$var$PHYSICSMODEL.spinAdjust.speedDampingFactor(speedSpin.spinAxis);
        shotSpeed *= df;
    // console.log(`speedspin2rpm: axis: ${speedSpin.spinAxis}, df: ${df}, speed adjust: ${oldSpeed} -> ${shotSpeed}`);
    }
    // convert launch speed mps to motor rpm
    // fast return if launch speed is 0
    const launchSpeedRPM = $fc7bafbc02aaa463$var$mps2rpm(shotSpeed);
    // eslint-disable-next-line max-len
    // console.log(`speedspin2rpm: mps=${shotSpeed}, RPM=${launchSpeedRPM}, spin=${speedSpin.spin}, L=${speedSpin.spinLevel}, A=${speedSpin.spinAxis}`);
    if (launchSpeedRPM === 0) return rpms;
    let spinMotorRPM = 0;
    let vx = 0;
    let vy = 0;
    if (hasSpin) {
        let spinQuantity = 0;
        let spinType = "";
        // spin: use units of motor RPM
        if (speedSpin.spinLevel !== null) {
            spinQuantity = speedSpin.spinLevel;
            spinType = "level";
            spinMotorRPM = $fc7bafbc02aaa463$var$spinlevel2motorspin(speedSpin.spinLevel);
        // console.log(`speedspin2rpm: using motor spin RPM: ${spinMotorRPM}`);
        }
        if (speedSpin.spin !== null) {
            spinQuantity = speedSpin.spin;
            spinType = "ball RPM";
            spinMotorRPM = $fc7bafbc02aaa463$var$ballspin2motorspin(speedSpin.spin);
        }
        // spin must be achievable!
        const maxSpinMotorRPM = $fc7bafbc02aaa463$var$maxmotorspin_for_rpmspeed(speedSpin.spinAxis, launchSpeedRPM);
        if (spinMotorRPM > maxSpinMotorRPM) spinMotorRPM = maxSpinMotorRPM;
        // Spin motor RPM is the target ball spin. This is the place where we apply
        // spin adjustment based on how the spin axis aligns with motors.
        if ($fc7bafbc02aaa463$var$PHYSICSMODEL.spinAdjust.spinDampingFactor) {
            // const oldSpin = spinMotorRPM;
            const df = $fc7bafbc02aaa463$var$PHYSICSMODEL.spinAdjust.spinDampingFactor(speedSpin.spinAxis);
            spinMotorRPM *= df;
        // console.log(`speedspin2rpm: axis: ${speedSpin.spinAxis}, df: ${df}, spin adjust: ${oldSpin} -> ${spinMotorRPM}`);
        }
        // compute spin vector (vx, vy)
        const [ux, uy] = [
            Math.cos(speedSpin.spinAxis * (Math.PI / 180.0)),
            Math.sin(speedSpin.spinAxis * (Math.PI / 180.0))
        ];
        vx = ux * spinMotorRPM;
        vy = uy * spinMotorRPM;
    }
    // console.log(`ss2rpm: vx=${vx}, vy=${vy}`);
    // eslint-disable-next-line max-len
    // console.log(`speedspin2rpm NEW: Axis=${speedSpin.spinAxis}, launchRPM=${launchSpeedRPM}, spinRPM=${spinMotorRPM}, VX=${vx}, VY=${vy}`);
    // matrix operation to get motor RPMs
    rpms.top = 2.0 / 3 * vx + launchSpeedRPM;
    rpms.left = -1 / 3 * vx + 1.0 / Math.sqrt(3) * vy + launchSpeedRPM;
    rpms.right = -1 / 3 * vx - 1.0 / Math.sqrt(3) * vy + launchSpeedRPM;
    /*
    // make motor RPMs integers
    rpms.top = Math.round(rpms.top);
    rpms.left = Math.round(rpms.left);
    rpms.right = Math.round(rpms.right);
    */ // console.log(`speedspin2rpm: TOP=${rpms.top}, LEFT = ${rpms.left}, RIGHT = ${rpms.right}`);
    return rpms;
}
/**
 * angle2Vector
 * Return the 2D unit vector on the (unit) circle corresponding to a specified
 * counterclockwise rotation angle (in degrees).
 * @param angDeg
 * returns array [vx, vy] of unit vector corresponding to the rotation angle
 */ function $fc7bafbc02aaa463$var$angle2Vector(angDeg) {
    const c = Math.cos(angDeg * Math.PI / 180.0);
    const s = Math.sin(angDeg * Math.PI / 180.0);
    return [
        c,
        s
    ];
}
/**
 * vector2Angle
 * Return the rotation angle in degrees [0,360) of the
 * specified 2D vector (vx, vy).
 * @param vx  X coordinate of vector
 * @param vy  Y coordinate of vector
 * @returns  Rotation angle in degrees in [0, 360)
 */ function $fc7bafbc02aaa463$var$vector2Angle(vx, vy) {
    let ang = 0;
    if (vx === 0 || vy === 0) {
        if (vx === 0) ang = vy === 0 ? 0 : vy > 0 ? 90.0 : 270.0;
        if (vy === 0) ang = vx === 0 ? 0 : vx > 0 ? 0.0 : 180.0;
    } else {
        // quadrant 1
        ang = Math.atan(Math.abs(vy) / Math.abs(vx)) * 180.0 / Math.PI;
        // quadrant 4
        if (vx > 0 && vy < 0) ang = 360.0 - ang;
        else if (vx < 0 && vy > 0) ang = 180.0 - ang;
        else if (vx < 0 && vy < 0) ang = 180.0 + ang;
    }
    return ang;
}
/**
 * cameraHeight2HeadHeight
 * Return the Head height in meters corresponding to given cameraHeight specified in meters.
 * @param cameraHeightMeters Z coordinate of the camera in meters from the ground
 * @returns  Z coordinate of the head height in meters from the ground
 */ function $fc7bafbc02aaa463$var$cameraHeight2HeadHeight(cameraHeightMeters) {
    const cameraHeightOffset = $fc7bafbc02aaa463$var$PHYSICSMODEL.trainerGeometry.cameraOffsetFromHead.z;
    const headHeight = cameraHeightMeters - cameraHeightOffset;
    return headHeight;
}
/**
 * launchHeight2HeadHeight
 * Return the Head height in meters corresponding to given launchHeight in meters
 * @param launchHeightMeters Z coordinate of the launch point in meters from the ground
 * @returns  Z coordinate of the head height in meters from the ground
 */ function $fc7bafbc02aaa463$var$launchHeight2HeadHeight(launchHeightMeters) {
    const lph = $fc7bafbc02aaa463$var$PHYSICSMODEL.trainerGeometry.defaultLaunchPointOffset.z;
    return launchHeightMeters - lph;
}
/**
 * launchHeightInches2HeadHeight
 * Return the Head height in meters corresponding to given launchHeight in meters
 * @param launchHeightInches Z coordinate of the launch point in inches from the ground
 * @returns  Z coordinate of the head height in meters from the ground
 */ function $fc7bafbc02aaa463$var$launchHeightInches2HeadHeight(launchHeightInches) {
    const lph = $fc7bafbc02aaa463$var$PHYSICSMODEL.trainerGeometry.defaultLaunchPointOffset.z;
    return launchHeightInches * 0.0254 - lph;
}

});


parcelRegister("gsW5g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TrainerSim = void 0;

var $5OQUE = parcelRequire("5OQUE");
Object.defineProperty(module.exports, "TrainerSim", {
    enumerable: true,
    get: function() {
        return $5OQUE.TrainerSim;
    }
});

});
parcelRegister("5OQUE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TrainerSim = void 0;

var $fhneO = parcelRequire("fhneO");

var $d2cet = parcelRequire("d2cet");

var $4loQf = parcelRequire("4loQf");

var $o2r7v = parcelRequire("o2r7v");

var $jPwy6 = parcelRequire("jPwy6");

var $fgwez = parcelRequire("fgwez");

var $33LBW = parcelRequire("33LBW");

var $kLrhG = parcelRequire("kLrhG");
class $43caaaa672fae96f$var$TrainerSim {
    static DefaultCourtPoint = {
        x: 0,
        y: 0,
        z: 0
    };
    m_model;
    m_position;
    m_armAngle = 0;
    m_launchPoint = $43caaaa672fae96f$var$TrainerSim.DefaultCourtPoint;
    m_localizedCameraPosition;
    conversions;
    constructor(physicsModelName, sport){
        (0, $jPwy6.setPhysicsModel)(physicsModelName, sport);
        this.m_model = (0, $fgwez.createModel)(physicsModelName, sport, (0, $fgwez.copyTunables)((0, $jPwy6.getPhysicsModel)()));
        this.conversions = new $4loQf.Conversions(this.m_model, this.engine);
        const { trainerGeometry: trainerGeometry } = this.m_model;
        this.m_position = {
            x: 0,
            y: 0,
            yaw: 0,
            h: trainerGeometry.liftOrigin.z
        };
        this.m_localizedCameraPosition = {
            x: 0,
            y: 0,
            z: 0,
            roll: 0,
            yaw: 0,
            pitch: 90 - trainerGeometry.cameraDownwardPitch
        };
        this.SetPositionManual(this.m_position);
    }
    /** The engine for pose, camera and conversions. */ get engine() {
        return (0, $o2r7v.baseEngine)(this.m_model.name, this.m_model.sport);
    }
    get pose() {
        const { x: x, y: y, yaw: yaw, h: h } = this.m_position;
        return {
            x: x,
            y: y,
            yaw: yaw,
            headHeight: h
        };
    }
    GetUserAidedLocalizationHeight(courtPoint, netClearanceFeet) {
        const { sport: sport } = this.m_model;
        const { engine: engine } = this;
        const upG = engine.referencePoint(courtPoint);
        (0, $d2cet.assert)(upG !== undefined, `GetUserAidedLocalizationHeight: point ${courtPoint} is invalid for sport ${sport}`);
        const camera = this.m_localizedCameraPosition;
        const cpP = engine.fromLocalization(camera);
        (0, $d2cet.assert)(engine.referencePoint("netpost_r_t") !== undefined, `GetUserAidedLocalizationHeight: net point netpost_r_t not found for sport ${sport}!`);
        const minFC = 0.1;
        const maxNC = -0.01;
        (0, $d2cet.assert)(upG.y >= minFC, `GetUserAidedLocalizationHeight: court point ${courtPoint} y=${upG.y} must be > ${minFC} m (into far court)`);
        (0, $d2cet.assert)(cpP.y <= maxNC, `GetUserAidedLocalizationHeight: cam pos y=${cpP.y} must be <= ${maxNC} (in near court)`);
        return engine.localizationHeadHeight(camera, courtPoint, netClearanceFeet);
    }
    SetPositionManual(position) {
        this.m_position = position;
        this.m_localizedCameraPosition = this.cameraAt(true);
        this.m_launchPoint = this.launchPointAt(0, 0);
    }
    SetPositionLocalized(localizedCameraPosition) {
        this.m_localizedCameraPosition = localizedCameraPosition;
        this.headAt(this.cameraHeadHeight(localizedCameraPosition.z));
        const pose = this.engine.poseFromCamera(localizedCameraPosition);
        this.m_position.x = pose.x;
        this.m_position.y = pose.y;
        this.m_position.yaw = pose.yaw;
        this.m_position.h = pose.headHeight;
        this.m_launchPoint = this.launchPointAt(0, 0);
    }
    GetPosition() {
        return this.m_position;
    }
    GetArmAngle() {
        return this.m_armAngle;
    }
    SetHeadHeight(height) {
        this.m_position.h = height;
        this.m_localizedCameraPosition = this.cameraAt(false);
        this.m_launchPoint = this.launchPointAt(0, 0);
    }
    GetLaunchPoint() {
        return this.m_launchPoint;
    }
    SetLaunchPoint(yawDeg, pitchDeg) {
        (0, $d2cet.assert)(Math.abs(yawDeg) <= 90 && Math.abs(pitchDeg) <= 90, `SetLaunchPoint: yaw and pitch (${yawDeg}, ${pitchDeg}) must be in [-90, 90]`);
        this.m_launchPoint = this.launchPointAt(yawDeg, pitchDeg);
    }
    GetHeadHeight() {
        return this.m_position.h;
    }
    GetConfig() {
        return this.m_model;
    }
    /**
     * The `convert` functions bound to this sim's own model. Not in v1, whose
     * only conversions read the global model: use these to convert for this
     * sim when another sim may have set the global to a different sport.
     */ GetConversions() {
        return this.conversions;
    }
    GetLocalizedCameraPosition() {
        return this.m_localizedCameraPosition;
    }
    Target(plannedShot) {
        const { result: result, launchPoint: launchPoint } = (0, $kLrhG.target)({
            model: this.m_model,
            conversions: this.conversions,
            pose: this.pose,
            launchPoint: this.m_launchPoint,
            launchPointAt: (yaw, pitch)=>this.launchPointAt(yaw, pitch)
        }, plannedShot);
        if (launchPoint !== null) this.m_launchPoint = launchPoint;
        return result;
    }
    Launch(launchParams) {
        (0, $d2cet.assert)(launchParams.rpms !== null || launchParams.speedSpin !== null, "Launch: one of (speedSpin, rpms) must be set");
        const { simParams: simParams, constants: constants } = this.m_model;
        (0, $33LBW.assertFinish)(simParams, "Launch");
        const { kernel: kernel, profile: profile } = (0, $o2r7v.enginesFor)(this.m_model);
        (0, $o2r7v.assertLaunchable)(profile);
        if (launchParams.speedSpin === null) launchParams.speedSpin = this.conversions.rpm2speedspin(launchParams.rpms);
        if (launchParams.rpms === null) launchParams.rpms = this.conversions.speedspin2rpm(launchParams.speedSpin);
        const { speedSpin: speedSpin } = launchParams;
        this.m_launchPoint = this.launchPointAt(launchParams.yaw, launchParams.pitch);
        if (speedSpin.spinLevel !== null && speedSpin.spinLevel > 0 && speedSpin.spin === null) speedSpin.spin = this.conversions.spinlevel2ballspin(speedSpin.spinLevel);
        // A null spin flies as v1 flies it: no lift, exactly as 0.
        const launch = {
            pitch: launchParams.pitch,
            yaw: launchParams.yaw,
            speed: speedSpin.speed,
            spin: {
                rpm: speedSpin.spin === null ? 0 : speedSpin.spin,
                axis: speedSpin.spinAxis
            }
        };
        const thrown = (0, $fhneO.release)(profile, this.pose, launch, "v1");
        const shot = new $33LBW.ShotRecorder(this.m_launchPoint, simParams.duration, 0);
        kernel.record(thrown, shot, {
            until: (0, $33LBW.untilFor)(simParams)
        });
        // v1's no-drag range, from _initializeLaunch
        const g = constants.gravity;
        const h = this.m_launchPoint.z;
        const vz = thrown.velocity.z;
        const vr = speedSpin.speed * Math.cos(thrown.pitch * Math.PI / 180.0);
        return {
            ballPath: shot.ballPath,
            bounces: shot.bounces,
            range: vr * ((vz + Math.sqrt(vz * vz + 2.0 * g * h)) / g),
            peakHeight: shot.peakHeight,
            landingPoint: shot.landingPoint,
            launchPoint: {
                ...this.m_launchPoint
            },
            launchSpeed: speedSpin.speed,
            spinAxis: speedSpin.spinAxis,
            spin: speedSpin.spin,
            pitch: thrown.pitch,
            yaw: thrown.yaw,
            pitchDeflection: thrown.deflection.pitch,
            yawDeflection: thrown.deflection.yaw
        };
    }
    Stroke(strikePoint, initialVelocity, spin = 0, spinAxis = 0) {
        const { simParams: simParams } = this.m_model;
        (0, $33LBW.assertFinish)(simParams, "Stroke");
        const { x: vx, y: vy, z: vz } = initialVelocity;
        const shot = new $33LBW.ShotRecorder(strikePoint, simParams.duration, strikePoint.z);
        (0, $o2r7v.enginesFor)(this.m_model).kernel.record((0, $fhneO.strokeRelease)(strikePoint, initialVelocity, {
            rpm: spin,
            axis: spinAxis
        }, "v1"), shot, {
            until: (0, $33LBW.untilFor)(simParams),
            stopOutOfBounds: false
        });
        return {
            ballPath: shot.ballPath,
            bounces: shot.bounces,
            peakHeight: shot.peakHeight,
            landingPoint: shot.landingPoint,
            range: -1,
            launchPoint: {
                ...strikePoint
            },
            launchSpeed: Math.sqrt(vx * vx + vy * vy + vz * vz),
            spinAxis: spinAxis,
            spin: spin,
            pitch: Math.atan2(vz, Math.sqrt(vx * vx + vy * vy)) * 180 / Math.PI,
            yaw: Math.atan2(vx, vy) * 180 / Math.PI,
            pitchDeflection: 0,
            yawDeflection: 0
        };
    }
    /**
     * The engine's reconstruction (free flight, rk4, v1's spin model), with
     * shot = the legacy Stroke of the fitted velocity. errorDistance is the
     * fit's free-flight miss; errorTime is 0, as v1's always is.
     */ ReconstructStroke(strikePoint, landingPoint, flightTime, spin = 0, spinAxis = 0) {
        (0, $d2cet.assert)(flightTime > 0.01, "ReconstructStroke: flightTime must be greater than 0.01 seconds");
        const reconstructed = (0, $o2r7v.enginesFor)(this.m_model).solver.reconstruct(strikePoint, landingPoint, flightTime, {
            rpm: spin,
            axis: spinAxis
        });
        // v1 negates the spin of a stroke its no-drag seed sends toward -y, and so does the engine's fit.
        const g = this.m_model.constants.gravity;
        const seed = {
            x: (landingPoint.x - strikePoint.x) / flightTime,
            y: (landingPoint.y - strikePoint.y) / flightTime,
            z: (landingPoint.z - strikePoint.z) / flightTime + 0.5 * g * flightTime
        };
        const adjustedSpin = seed.y < 0 ? -spin : spin;
        const fit = reconstructed.ok ? reconstructed : reconstructed.closest;
        const velocity = fit ? {
            ...fit.velocity
        } : seed;
        const { x: x, y: y, z: z } = velocity;
        return {
            initialVelocity: velocity,
            shot: this.Stroke(strikePoint, velocity, adjustedSpin, spinAxis),
            isConverged: reconstructed.ok,
            iterations: fit?.iterations ?? 0,
            errorDistance: fit?.miss ?? Infinity,
            errorTime: 0,
            launchSpeed: Math.sqrt(x * x + y * y + z * z),
            launchPitch: Math.atan2(z, Math.sqrt(x * x + y * y)) * 180 / Math.PI,
            launchYaw: Math.atan2(x, y) * 180 / Math.PI
        };
    }
    // _______________________________________________________________________
    // Pose helpers: v1's assertions and arm-angle bookkeeping around the engine
    /** v1 _headPositionFromHeight: asserts the arm can reach, and moves it there. */ headAt(headHeight) {
        const { liftArmLength: radius, liftOrigin: liftOrigin } = this.m_model.trainerGeometry;
        const headZ = headHeight - liftOrigin.z;
        (0, $d2cet.assert)(Math.abs(headZ) <= radius, `arm pos Z in lift coords ${headZ} must be in [-${radius}, ${radius}]`);
        this.m_armAngle = this.engine.armAngle(headHeight);
    }
    /** The head height v1 derives from a localized camera height, through millimeters. */ cameraHeadHeight(cameraZ) {
        return cameraZ / 1000.0 - this.m_model.trainerGeometry.cameraOffsetFromHead.z;
    }
    /** v1 _computeLaunchPoint. */ launchPointAt(yawDeg, pitchDeg) {
        this.headAt(this.m_position.h);
        (0, $d2cet.assert)(Math.abs(yawDeg) <= 90 && Math.abs(pitchDeg) <= 90, `yaw and pitch (${yawDeg}, ${pitchDeg}) must be in [-90, 90]`);
        return this.engine.launchPoint(this.pose, pitchDeg, yawDeg);
    }
    /** v1 _computeLocalizedCameraPosition: the mounting's roll and pitch, or the current camera's. */ cameraAt(changePitchRoll) {
        const { cameraOffsetFromHead: cameraOffsetFromHead } = this.m_model.trainerGeometry;
        this.headAt(this.cameraHeadHeight((this.m_position.h + cameraOffsetFromHead.z) * 1000.0));
        const { roll: roll, pitch: pitch } = this.m_localizedCameraPosition;
        return this.engine.camera(this.pose, changePitchRoll ? undefined : {
            roll: roll,
            pitch: pitch
        });
    }
}
module.exports.TrainerSim = $43caaaa672fae96f$var$TrainerSim;

});
parcelRegister("33LBW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ShotRecorder = module.exports.untilFor = void 0;
module.exports.assertFinish = $23a6956faf39a6b9$var$assertFinish;

var $2Yg5G = parcelRequire("2Yg5G");

var $d2cet = parcelRequire("d2cet");
/** v1's surfaces by the v1 venue's panel ids. */ const $23a6956faf39a6b9$var$SURFACES = {
    ground: $2Yg5G.CourtSurface.Court,
    leftWall: $2Yg5G.CourtSurface.LeftWall,
    rightWall: $2Yg5G.CourtSurface.RightWall,
    farWall: $2Yg5G.CourtSurface.BackWall,
    net: $2Yg5G.CourtSurface.Net
};
/** v1 Launch's and Stroke's check on simParams, with their message. */ function $23a6956faf39a6b9$var$assertFinish({ duration: duration, bounces: bounces }, method) {
    (0, $d2cet.assert)(duration !== null && duration >= 0 || bounces !== null && bounces > 0, `${method}: one or both of (duration>=0, bounces>0) must be specified`);
}
/**
 * When v1's loop stops: at so many contacts, or at the duration when
 * bounces are off. The kernel also stops every flight at 5 s, where v1
 * would run on past a duration above that (or none).
 */ const $23a6956faf39a6b9$var$untilFor = ({ bounces: bounces, duration: duration })=>bounces !== null ? {
        kind: "bounces",
        count: bounces
    } : {
        kind: "time",
        seconds: duration ?? 0
    };
module.exports.untilFor = $23a6956faf39a6b9$var$untilFor;
/**
 * Lays a flight out as v1's loop leaves its Shot while the legacy kernel
 * steps (FlightKernel.record), so no path is recorded and converted. As in
 * v1, `start` is itself the first point's position, a bounce's timePosition
 * is the path sample it happened at (so contacts in one step share the
 * position the last of them left), the landing point is that sample's
 * position, and the peak climbs from `peakFrom` over the samples after the
 * first. Samples past `duration` (v1 stops at the first at or past it) are
 * dropped.
 */ class $23a6956faf39a6b9$var$ShotRecorder {
    start;
    duration;
    ballPath = [];
    bounces = [];
    landingPoint = {
        x: 0,
        y: 0,
        z: -1
    };
    peakHeight;
    stopped = false;
    constructor(start, duration, peakFrom){
        this.start = start;
        this.duration = duration;
        this.peakHeight = peakFrom;
    }
    point(t, x, y, z) {
        if (this.stopped) return;
        if (this.ballPath.length === 0) {
            this.ballPath.push({
                t: 0.0,
                pos: this.start
            });
            return;
        }
        this.ballPath.push({
            t: t,
            pos: {
                x: x,
                y: y,
                z: z
            }
        });
        if (z > this.peakHeight) this.peakHeight = z;
        this.stopped = this.duration !== null && t >= this.duration;
    }
    contact(t, _x, _y, _z, surface, kind) {
        const last = this.ballPath[this.ballPath.length - 1];
        if (last.t !== t) return;
        this.bounces.push({
            timePosition: last,
            surface: $23a6956faf39a6b9$var$SURFACES[surface]
        });
        if (kind === "ground" && this.landingPoint.z === -1) this.landingPoint = last.pos;
    }
    deflect() {}
    truncate() {}
}
module.exports.ShotRecorder = $23a6956faf39a6b9$var$ShotRecorder;

});

parcelRegister("kLrhG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.target = $f1dd5c88bd6adc1a$var$target;

var $fhneO = parcelRequire("fhneO");

var $d2cet = parcelRequire("d2cet");

var $o2r7v = parcelRequire("o2r7v");

var $33LBW = parcelRequire("33LBW");
/**
 * 5 mm, or a looser simParams.stopDist. v1's 1 mm default is out of reach for
 * most targets once landings move in 2 cm jumps; tighter is not honored.
 */ const $f1dd5c88bd6adc1a$var$MIN_TOLERANCE = 0.005;
/** Legacy flights the correction may spend before the one that measures the result. */ const $f1dd5c88bd6adc1a$var$MAX_CORRECTIONS = 8;
/** The head pans at most this far either side of the body (yawpitch2launchpoint asserts it). */ const $f1dd5c88bd6adc1a$var$MAX_PAN_DEG = 90;
/** Bearing in degrees from one court point to another: 0 = +y, positive = clockwise. */ const $f1dd5c88bd6adc1a$var$bearingDeg = (from, to)=>Math.atan2(to.x - from.x, to.y - from.y) * 180.0 / Math.PI;
/** Wrap an angle in degrees to (-180, 180]. */ function $f1dd5c88bd6adc1a$var$wrapDeg(angle) {
    const w = (angle % 360 + 360) % 360;
    return w > 180 ? w - 360 : w;
}
/** Height a planned shot targets: > 0 is an aerial target, 0 a landing. */ function $f1dd5c88bd6adc1a$var$targetHeight(plannedShot) {
    const { z: z } = plannedShot.target;
    return Number.isFinite(z) && z > 0 ? z : 0;
}
function $f1dd5c88bd6adc1a$var$target(ctx, plannedShot) {
    const forms = [
        plannedShot.launchAngle,
        plannedShot.peakHeight,
        plannedShot.speed ?? null
    ].filter((v)=>v !== null).length;
    (0, $d2cet.assert)(forms === 1, "planned shot must have exactly 1 of (launch angle, peak height, speed)");
    const result = $f1dd5c88bd6adc1a$var$createTargetResult(ctx, plannedShot);
    if (!result.isValid) return {
        result: result,
        launchPoint: null
    };
    const { model: model } = ctx;
    const legacy = (0, $o2r7v.enginesFor)(model);
    // from here every plan needs the speed table (v1 computes NaN without one)
    (0, $o2r7v.assertLaunchable)(legacy.profile);
    if (plannedShot.speed != null) {
        if (!$f1dd5c88bd6adc1a$var$reachableWithoutDrag(ctx, plannedShot, result.launchPoint)) return {
            result: $f1dd5c88bd6adc1a$var$invalid(result, `target out of reach at ${plannedShot.speed} m/s`),
            launchPoint: null
        };
    } else if (plannedShot.peakHeight !== null && model.ballParams.drag === 0 && !(plannedShot.spin > 0)) {
        $f1dd5c88bd6adc1a$var$targetIdealPeakHeight(ctx, result);
        return {
            result: result,
            launchPoint: null
        };
    }
    const spin = $f1dd5c88bd6adc1a$var$shotSpin(plannedShot);
    if (spin.rpm > 0) (0, $d2cet.assert)(spin.axis >= 0 && spin.axis <= 360, `angle ${spin.axis} must be in [0, 360]`);
    const plan = $f1dd5c88bd6adc1a$var$shotPlan(plannedShot, spin);
    const tolerance = Math.max($f1dd5c88bd6adc1a$var$MIN_TOLERANCE, model.simParams.stopDist);
    const { solver: solver } = legacy;
    const aimed = solver.aim(ctx.pose, plan);
    let attempt;
    if (aimed.ok) attempt = $f1dd5c88bd6adc1a$var$correct(ctx.pose, plan, aimed, solver, legacy, tolerance);
    else {
        attempt = aimed.closest ? {
            aim: aimed.closest,
            flights: 0
        } : null;
        const message = $f1dd5c88bd6adc1a$var$failureMessage(aimed.reason, plannedShot, model, attempt !== null);
        if (message !== null) $f1dd5c88bd6adc1a$var$invalid(result, message);
    }
    if (attempt === null) return {
        result: result,
        launchPoint: null
    };
    const launchPoint = $f1dd5c88bd6adc1a$var$measure(ctx, result, attempt, legacy, tolerance);
    // v1's verdicts on the throw it ends with
    if (plannedShot.peakHeight !== null && attempt.aim.launch.speed >= model.limits.MPS.maxSafe && !result.isAccurate) $f1dd5c88bd6adc1a$var$invalid(result, `out of reach: needs more than this trainer's ${model.limits.MPS.maxSafe.toFixed(1)} m/s`);
    if (result.isValid && !Number.isFinite(result.errorDistance)) $f1dd5c88bd6adc1a$var$invalid(result, `no solution: the flight never comes down through ${$f1dd5c88bd6adc1a$var$targetHeight(plannedShot)} m`);
    return {
        result: result,
        launchPoint: launchPoint
    };
}
function $f1dd5c88bd6adc1a$var$invalid(result, message) {
    result.isValid = false;
    result.invalidMessage = message;
    return result;
}
/**
 * v1's message for an engine failure, or null where v1 would return the
 * closest throw as valid but inaccurate (it has no notion of a solve that
 * fails to converge, or of a throw blocked by the net).
 */ function $f1dd5c88bd6adc1a$var$failureMessage(reason, plannedShot, model, solved) {
    const { maxSafe: maxSafe } = model.limits.MPS;
    switch(reason){
        case "targetBehind":
            return "target must be in front of trainer";
        case "targetTooClose":
            return solved ? `target too close for ${plannedShot.speed} m/s` : "launch and target point must be different";
        case "peakBelowLaunch":
            return "peak height must be >= launch height";
        case "peakBelowTarget":
            return "peak height must be >= target height";
        case "speedOutOfRange":
            return `speed must be in (0, ${maxSafe}] m/s`;
        case "outOfReach":
            if (plannedShot.speed != null) return `target out of reach at ${plannedShot.speed} m/s`;
            if (plannedShot.peakHeight !== null) return `out of reach: needs more than this trainer's ${maxSafe.toFixed(1)} m/s`;
            return `no solution at launch angle ${plannedShot.launchAngle ?? "n/a"}: the shot does not land`;
        case "blocked":
        case "noConvergence":
            return null;
    }
}
/**
 * v1 _createTargetResult: the initial result, and v1's validity rules in
 * v1's order, judged from the trainer's current launch point.
 */ function $f1dd5c88bd6adc1a$var$createTargetResult(ctx, plannedShot) {
    const result = {
        launchPoint: ctx.launchPointAt(0, 0),
        plannedShot: plannedShot,
        launchParams: {
            yaw: 0,
            pitch: 0,
            speedSpin: {
                speed: 0,
                spin: 0,
                spinAxis: 0,
                spinLevel: null
            },
            rpms: {
                left: 0,
                right: 0,
                top: 0
            }
        },
        isValid: true,
        invalidMessage: "",
        isAccurate: false,
        errorDistance: -1,
        simIterations: -1,
        peakHeight: -1,
        pitchDeflection: 0,
        yawDeflection: 0
    };
    const from = ctx.launchPoint;
    const dx = plannedShot.target.x - from.x;
    const dy = plannedShot.target.y - from.y;
    const range = Math.sqrt(dx * dx + dy * dy);
    if (Math.abs($f1dd5c88bd6adc1a$var$wrapDeg($f1dd5c88bd6adc1a$var$bearingDeg(from, plannedShot.target) - ctx.pose.yaw)) >= $f1dd5c88bd6adc1a$var$MAX_PAN_DEG) $f1dd5c88bd6adc1a$var$invalid(result, "target must be in front of trainer");
    else if (range < 0.1) $f1dd5c88bd6adc1a$var$invalid(result, "launch and target point must be different");
    else if (plannedShot.peakHeight !== null) {
        if (plannedShot.peakHeight - from.z < 0) $f1dd5c88bd6adc1a$var$invalid(result, "peak height must be >= launch height");
        else if (plannedShot.peakHeight < $f1dd5c88bd6adc1a$var$targetHeight(plannedShot)) $f1dd5c88bd6adc1a$var$invalid(result, "peak height must be >= target height");
    } else if (plannedShot.speed != null) {
        const { maxSafe: maxSafe } = ctx.model.limits.MPS;
        if (!(plannedShot.speed > 0) || plannedShot.speed > maxSafe) $f1dd5c88bd6adc1a$var$invalid(result, `speed must be in (0, ${maxSafe}] m/s`);
    }
    return result;
}
/** v1 _targetSpeed's first check: whether the target is in no-drag reach at the planned speed. */ function $f1dd5c88bd6adc1a$var$reachableWithoutDrag(ctx, plannedShot, from) {
    const v = plannedShot.speed;
    const g = ctx.model.constants.gravity;
    const { target: tp } = plannedShot;
    const range = Math.hypot(tp.x - from.x, tp.y - from.y);
    const dz = $f1dd5c88bd6adc1a$var$targetHeight(plannedShot) - from.z;
    return v ** 4 - g * (g * range * range + 2 * dz * v * v) >= 0;
}
/** v1 _targetIdealPeakHeight: the closed-form shot when there is neither drag nor spin. */ function $f1dd5c88bd6adc1a$var$targetIdealPeakHeight(ctx, result) {
    const lp = result.launchPoint;
    const tp = result.plannedShot.target;
    const peakH = result.plannedShot.peakHeight;
    const hDiff = peakH - lp.z;
    const g = ctx.model.constants.gravity;
    const dx = tp.x - lp.x;
    const dy = tp.y - lp.y;
    const range = Math.sqrt(dx * dx + dy * dy);
    const yawDegrees = $f1dd5c88bd6adc1a$var$wrapDeg($f1dd5c88bd6adc1a$var$bearingDeg(lp, tp) - ctx.pose.yaw);
    const fall = peakH - $f1dd5c88bd6adc1a$var$targetHeight(result.plannedShot);
    const C = hDiff + Math.sqrt(fall * hDiff);
    const pitchDegrees = Math.atan(2.0 * C / range) * (180.0 / Math.PI);
    const speed = Math.sqrt(2.0 * g * hDiff * (range * range + 4 * C * C)) / (2.0 * C);
    const { launchParams: launchParams } = result;
    launchParams.yaw = yawDegrees;
    launchParams.pitch = pitchDegrees;
    result.launchPoint = ctx.launchPointAt(yawDegrees, pitchDegrees);
    launchParams.speedSpin.speed = speed;
    launchParams.speedSpin.spin = 0;
    launchParams.speedSpin.spinAxis = 0;
    launchParams.rpms = ctx.conversions.speedspin2rpm(launchParams.speedSpin);
}
/** The spin v1 throws a plan with: a peak-height plan drops spin that is not positive. */ function $f1dd5c88bd6adc1a$var$shotSpin(plannedShot) {
    if (plannedShot.peakHeight !== null && !(plannedShot.spin > 0)) return {
        rpm: 0,
        axis: 0
    };
    return {
        rpm: plannedShot.spin,
        axis: plannedShot.spinAxis
    };
}
function $f1dd5c88bd6adc1a$var$shotPlan(plannedShot, spin) {
    const { target: t } = plannedShot;
    const target = {
        x: t.x,
        y: t.y,
        z: t.z
    };
    if (plannedShot.speed != null) return {
        target: target,
        spin: spin,
        shape: "speed",
        speed: plannedShot.speed
    };
    if (plannedShot.peakHeight !== null) return {
        target: target,
        spin: spin,
        shape: "peakHeight",
        peakHeight: plannedShot.peakHeight
    };
    return {
        target: target,
        spin: spin,
        shape: "pitch",
        pitch: plannedShot.launchAngle
    };
}
/**
 * Re-aims until a legacy flight of the aim arrives within tolerance, or the
 * flights run out; returns the aim whose legacy flight came closest.
 */ function $f1dd5c88bd6adc1a$var$correct(pose, plan, first, solver, legacy, tolerance) {
    const { target: target } = plan;
    const z = Number.isFinite(target.z) && target.z > 0 ? target.z : 0;
    const until = z > 0 ? {
        kind: "descending",
        z: z
    } : {
        kind: "landing"
    };
    const options = {
        until: until
    };
    // misses split into along the throw (range) and across it
    const length = Math.hypot(target.x - first.origin.x, target.y - first.origin.y);
    const ux = (target.x - first.origin.x) / length;
    const uy = (target.y - first.origin.y) / length;
    let aim = first;
    let best = first;
    let bestMiss = Infinity;
    let flights = 0;
    let aimPoint = {
        x: target.x,
        y: target.y
    };
    let short = null;
    let long = null;
    for(;;){
        const end = new $f1dd5c88bd6adc1a$var$ArrivalRecorder(z > 0);
        legacy.kernel.record((0, $fhneO.release)(legacy.profile, pose, aim.launch, "v1"), end, options);
        flights += 1;
        if (!end.arrived) break;
        const ex = end.x - target.x;
        const ey = end.y - target.y;
        const miss = Math.hypot(ex, ey);
        if (miss < bestMiss) {
            best = aim;
            bestMiss = miss;
        }
        if (miss <= tolerance || flights === $f1dd5c88bd6adc1a$var$MAX_CORRECTIONS) break;
        const along = ex * ux + ey * uy;
        if (along < 0) short = aimPoint;
        else long = aimPoint;
        if (short !== null && long !== null && flights >= 2) // across the throw the landing is smooth: correct that part directly
        aimPoint = {
            x: (short.x + long.x) / 2 - (ex - along * ux),
            y: (short.y + long.y) / 2 - (ey - along * uy)
        };
        else aimPoint = {
            x: aimPoint.x - ex,
            y: aimPoint.y - ey
        };
        const next = solver.aim(pose, {
            ...plan,
            target: {
                x: aimPoint.x,
                y: aimPoint.y,
                z: target.z
            }
        });
        if (!next.ok) break;
        aim = next;
    }
    return {
        aim: best,
        flights: flights
    };
}
/**
 * Where a legacy flight arrives, as engine endpoints do: its first landing,
 * or its first descent through `z` (past net and wall contacts).
 */ class $f1dd5c88bd6adc1a$var$ArrivalRecorder {
    descending;
    arrived = false;
    x = NaN;
    y = NaN;
    constructor(descending){
        this.descending = descending;
    }
    point() {}
    deflect() {}
    contact(_t, x, y, _z, _surface, kind) {
        if (kind === "ground" && !this.descending && !this.arrived) this.arrive(x, y);
    }
    truncate(_t, x, y) {
        this.arrive(x, y);
    }
    arrive(x, y) {
        this.arrived = true;
        this.x = x;
        this.y = y;
    }
}
/** v1 _crossingPoint: where a Shot descends through height z before its first bounce. */ function $f1dd5c88bd6adc1a$var$crossing({ ballPath: ballPath, bounces: bounces }, z) {
    const bounceT = bounces.length > 0 ? bounces[0].timePosition.t : Infinity;
    for(let i = 1; i < ballPath.length && ballPath[i - 1].t < bounceT; i++){
        const a = ballPath[i - 1].pos;
        const b = ballPath[i].pos;
        if (a.z >= z && b.z < z) {
            const f = (a.z - z) / (a.z - b.z);
            return {
                x: a.x + f * (b.x - a.x),
                y: a.y + f * (b.y - a.y)
            };
        }
    }
    return null;
}
/**
 * Flies the attempt as Launch would and fills the result from it, measured
 * as v1 measures: the landing (or the descent through an aerial target's
 * height before any contact), the whole flight's peak. Returns the trainer's
 * new launch point.
 */ function $f1dd5c88bd6adc1a$var$measure(ctx, result, attempt, legacy, tolerance) {
    const { model: model, pose: pose } = ctx;
    const { plannedShot: plannedShot } = result;
    const { launch: launch, deflection: deflection } = attempt.aim;
    (0, $33LBW.assertFinish)(model.simParams, "Launch");
    const launchPoint = ctx.launchPointAt(launch.yaw, launch.pitch);
    const shot = new $33LBW.ShotRecorder(launchPoint, model.simParams.duration, 0);
    legacy.kernel.record((0, $fhneO.release)(legacy.profile, pose, launch, "v1"), shot, {
        until: (0, $33LBW.untilFor)(model.simParams)
    });
    const z = $f1dd5c88bd6adc1a$var$targetHeight(plannedShot);
    const { target: planned } = plannedShot;
    // v1 measures a throw that never lands from its unset landing point, (0, 0)
    const arrived = z > 0 ? $f1dd5c88bd6adc1a$var$crossing(shot, z) : shot.landingPoint;
    const errorDistance = arrived === null ? Infinity : Math.hypot(planned.x - arrived.x, planned.y - arrived.y);
    result.launchParams = $f1dd5c88bd6adc1a$var$launchParamsFor(plannedShot, launch, ctx.conversions);
    result.launchPoint = {
        ...launchPoint
    };
    result.peakHeight = shot.peakHeight;
    result.pitchDeflection = deflection.pitch;
    result.yawDeflection = deflection.yaw;
    result.errorDistance = errorDistance;
    // v1 counts the flights it launched; so does compat, its legacy ones
    result.simIterations = attempt.flights + 1;
    result.isAccurate = errorDistance <= tolerance;
    return launchPoint;
}
/** The launch parameters, shaped as each of v1's solvers leaves them. */ function $f1dd5c88bd6adc1a$var$launchParamsFor(plannedShot, launch, conversions) {
    const { pitch: pitch, yaw: yaw, speed: speed } = launch;
    let speedSpin;
    if (plannedShot.peakHeight !== null) {
        const spun = plannedShot.spin > 0;
        speedSpin = {
            speed: speed,
            spin: spun ? plannedShot.spin : 0,
            spinAxis: spun ? plannedShot.spinAxis : 0,
            spinLevel: null
        };
    } else speedSpin = {
        speed: speed,
        spin: plannedShot.spin,
        spinAxis: plannedShot.spinAxis,
        spinLevel: null
    };
    return {
        pitch: pitch,
        yaw: yaw,
        speedSpin: speedSpin,
        rpms: conversions.speedspin2rpm(speedSpin)
    };
}

});




parcelRegister("hz16f", function(module, exports) {

$parcel$export(module.exports, "COURT_WIDTH_MM", function () { return $66f5e321df8ae632$export$e1795b1d29ad9ffb; });
$parcel$export(module.exports, "radToDeg", function () { return $66f5e321df8ae632$export$54390e3b44c4a9cb; });
$parcel$export(module.exports, "degToRad", function () { return $66f5e321df8ae632$export$e6bfdeff8bfc94f9; });
$parcel$export(module.exports, "calculateTrim", function () { return $66f5e321df8ae632$export$6da90624f0eb761c; });
$parcel$export(module.exports, "round", function () { return $66f5e321df8ae632$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "feetToMm", function () { return $66f5e321df8ae632$export$3d03403e5c862584; });
$parcel$export(module.exports, "mmToFeet", function () { return $66f5e321df8ae632$export$a356350fdd4e59fd; });
$parcel$export(module.exports, "courtToPhysics", function () { return $66f5e321df8ae632$export$7b6b3fbbd65d2b2c; });
$parcel$export(module.exports, "physicsToCourt", function () { return $66f5e321df8ae632$export$f510560af55c4f49; });
$parcel$export(module.exports, "shouldImprovePosition", function () { return $66f5e321df8ae632$export$6420a2a3b79553bb; });

var $iwHAd = parcelRequire("iwHAd");
const $66f5e321df8ae632$export$8e44303a6dd66b7b = 280;
const $66f5e321df8ae632$export$52022f71af1f80a3 = 20;
const $66f5e321df8ae632$export$e1795b1d29ad9ffb = 6096;
const $66f5e321df8ae632$export$e3b841c6f9d3fd60 = 13411;
const $66f5e321df8ae632$export$42be8028855a61ac = 44;
const $66f5e321df8ae632$var$GOOD_LOCALIZATION_RADIUS_MM = 625;
function $66f5e321df8ae632$export$cf4d6cef653a725(p) {
    return p.error !== null && p.error !== "";
}
function $66f5e321df8ae632$export$414a326189bb076a(rad, x, y) {
    return {
        x: x - $66f5e321df8ae632$export$8e44303a6dd66b7b * Math.cos(rad),
        y: y + $66f5e321df8ae632$export$8e44303a6dd66b7b * Math.sin(rad)
    };
}
function $66f5e321df8ae632$export$54390e3b44c4a9cb(rad) {
    return rad * 180 / Math.PI;
}
function $66f5e321df8ae632$export$e6bfdeff8bfc94f9(deg) {
    return deg * Math.PI / 180;
}
function $66f5e321df8ae632$export$6da90624f0eb761c(expectedYaw, detectedYaw) {
    let trim = 0;
    if (Number.isNaN(detectedYaw) || expectedYaw === detectedYaw) return trim;
    if (expectedYaw > 0 && detectedYaw > 0 || expectedYaw < 0 && detectedYaw < 0) {
        // Both are on the same side of zero or one value is zero
        const absExpectedYaw = Math.abs(expectedYaw);
        const absDetectedYaw = Math.abs(detectedYaw);
        trim = Math.max(absExpectedYaw, absDetectedYaw) - Math.min(absExpectedYaw, absDetectedYaw);
    } else // Opposite sides of zero
    trim = Math.abs(expectedYaw) + Math.abs(detectedYaw);
    if (expectedYaw < detectedYaw) trim = -trim;
    return trim;
}
function $66f5e321df8ae632$export$2077e0241d6afd3c(value, step) {
    const internalStep = step ?? 1.0;
    const stepFactor = 1.0 / internalStep;
    return Math.round(value * stepFactor) / stepFactor;
}
function $66f5e321df8ae632$export$3d03403e5c862584(feet) {
    return $66f5e321df8ae632$export$2077e0241d6afd3c(feet * 304.8, 1);
}
function $66f5e321df8ae632$export$a356350fdd4e59fd(mm) {
    return $66f5e321df8ae632$export$2077e0241d6afd3c(mm / 304.8, 0.25);
}
function $66f5e321df8ae632$export$4cad6f23e603471f(mm) {
    return $66f5e321df8ae632$export$2077e0241d6afd3c(mm / 10 / 2.54, 0.25);
}
function $66f5e321df8ae632$export$ed9ada12808e101b(inch) {
    return $66f5e321df8ae632$export$2077e0241d6afd3c(inch * 25.4, 1);
}
function $66f5e321df8ae632$export$b423dd3612d9910a(mm, direction) {
    const ft = $66f5e321df8ae632$export$a356350fdd4e59fd(mm);
    if (direction === (0, $iwHAd.CourtDirection).X) return $66f5e321df8ae632$export$52022f71af1f80a3 - ft;
    return $66f5e321df8ae632$export$42be8028855a61ac - ft;
}
function $66f5e321df8ae632$export$3adf4bd37a26f896(coord) {
    if (coord.x > $66f5e321df8ae632$export$e1795b1d29ad9ffb / 2) return "deuce";
    return "ad";
}
function $66f5e321df8ae632$export$dec0c59c690e1007(coord) {
    if (coord.x > 0) return "deuce";
    return "ad";
}
function $66f5e321df8ae632$export$4b027a126fd1cf3a(coord) {
    if (coord.y < 0) return "trainer";
    if (coord.y > $66f5e321df8ae632$export$e3b841c6f9d3fd60 / 2) return "trainer";
    return "player";
}
function $66f5e321df8ae632$export$d97d428d22096731(coord) {
    if (coord.y < 0) return "trainer";
    return "player";
}
function $66f5e321df8ae632$export$7b6b3fbbd65d2b2c(coord) {
    const { x: x, y: y } = coord;
    const side = $66f5e321df8ae632$export$3adf4bd37a26f896(coord);
    const netSide = $66f5e321df8ae632$export$4b027a126fd1cf3a(coord);
    let x2;
    let y2;
    if (side === "ad" && netSide === "player") {
        x2 = -($66f5e321df8ae632$export$e1795b1d29ad9ffb / 2 - x) / 1000;
        y2 = ($66f5e321df8ae632$export$e3b841c6f9d3fd60 / 2 - y) / 1000;
    } else if (side === "ad" && netSide === "trainer") {
        x2 = -($66f5e321df8ae632$export$e1795b1d29ad9ffb / 2 - x) / 1000;
        y2 = -(y - $66f5e321df8ae632$export$e3b841c6f9d3fd60 / 2) / 1000;
    } else if (side === "deuce" && netSide === "player") {
        x2 = (x - $66f5e321df8ae632$export$e1795b1d29ad9ffb / 2) / 1000;
        y2 = ($66f5e321df8ae632$export$e3b841c6f9d3fd60 / 2 - y) / 1000;
    } else {
        // side = deuce, netSide = trainer
        x2 = (x - $66f5e321df8ae632$export$e1795b1d29ad9ffb / 2) / 1000;
        y2 = ($66f5e321df8ae632$export$e3b841c6f9d3fd60 / 2 - y) / 1000;
    }
    return {
        x: x2,
        y: y2
    };
}
function $66f5e321df8ae632$export$f510560af55c4f49(coord) {
    const { x: x, y: y } = coord;
    const side = $66f5e321df8ae632$export$dec0c59c690e1007(coord);
    const netSide = $66f5e321df8ae632$export$d97d428d22096731(coord);
    let x2;
    let y2;
    if (side === "ad" && netSide === "player") {
        x2 = $66f5e321df8ae632$export$e1795b1d29ad9ffb / 2 + x * 1000;
        y2 = $66f5e321df8ae632$export$e3b841c6f9d3fd60 / 2 - y * 1000;
    } else if (side === "ad" && netSide === "trainer") {
        x2 = $66f5e321df8ae632$export$e1795b1d29ad9ffb / 2 + x * 1000;
        y2 = $66f5e321df8ae632$export$e3b841c6f9d3fd60 / 2 - y * 1000;
    } else if (side === "deuce" && netSide === "player") {
        x2 = x * 1000 + $66f5e321df8ae632$export$e1795b1d29ad9ffb / 2;
        y2 = -y * 1000 + $66f5e321df8ae632$export$e3b841c6f9d3fd60 / 2;
    } else {
        // side = deuce, netSide = trainer
        x2 = x * 1000 + $66f5e321df8ae632$export$e1795b1d29ad9ffb / 2;
        y2 = $66f5e321df8ae632$export$e3b841c6f9d3fd60 / 2 + -y * 1000;
    }
    return {
        x: x2,
        y: y2
    };
}
function $66f5e321df8ae632$export$6420a2a3b79553bb(delta) {
    return Math.sqrt(delta.x ** 2 + delta.y ** 2) > $66f5e321df8ae632$var$GOOD_LOCALIZATION_RADIUS_MM;
}

});
parcelRegister("iwHAd", function(module, exports) {

$parcel$export(module.exports, "CourtDirection", function () { return $593ceb827f622ae2$export$15402954d4301d38; });
var $593ceb827f622ae2$export$15402954d4301d38 = /*#__PURE__*/ function(CourtDirection) {
    CourtDirection[CourtDirection["X"] = 0] = "X";
    CourtDirection[CourtDirection["Y"] = 1] = "Y";
    return CourtDirection;
}({});
var $593ceb827f622ae2$export$21f69db77506516b = /*#__PURE__*/ function(CircleResult) {
    CircleResult[CircleResult["None"] = 0] = "None";
    CircleResult[CircleResult["Touching"] = 1] = "Touching";
    CircleResult[CircleResult["Intersecting"] = 2] = "Intersecting";
    return CircleResult;
}({});

});



parcelRegister("fgY6R", function(module, exports) {

$parcel$export(module.exports, "isDeprecatedCameraStatus", function () { return $8f237d1715c1c3e3$export$9f3a1c7dd0b7a37f; });
$parcel$export(module.exports, "isDeprecatedLocalizationStatus", function () { return $8f237d1715c1c3e3$export$fbdc1e1099a3796b; });
function $8f237d1715c1c3e3$export$9f3a1c7dd0b7a37f(status) {
    return status !== undefined && !("orientationCurrentSource" in status);
}
function $8f237d1715c1c3e3$export$fbdc1e1099a3796b(status) {
    return status !== undefined && !("accurate" in status);
}

});

parcelRegister("h3IZ9", function(module, exports) {

$parcel$export(module.exports, "isMultiLevelWorkout", function () { return $4ac6576a0dee4ea5$export$d8e84bc6fafee4bf; });
$parcel$export(module.exports, "trimShot", function () { return $4ac6576a0dee4ea5$export$a23ef463c0184f70; });
$parcel$export(module.exports, "default", function () { return $4ac6576a0dee4ea5$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "makeWorkoutCompatible", function () { return $4ac6576a0dee4ea5$export$fd8ff7e46546722; });

var $1lMle = parcelRequire("1lMle");

var $3Qvqk = parcelRequire("3Qvqk");
function $4ac6576a0dee4ea5$export$d8e84bc6fafee4bf(workout) {
    return workout.config.levels !== undefined;
}
function $4ac6576a0dee4ea5$export$5517a3496c13fa74(config) {
    return config.shots !== undefined;
}
function $4ac6576a0dee4ea5$export$a23ef463c0184f70(trim, shot) {
    return {
        ...shot,
        pan: shot.pan + trim
    };
}
function $4ac6576a0dee4ea5$export$2e2bcd8739ae039(trim, shots) {
    return shots.map((s)=>$4ac6576a0dee4ea5$export$a23ef463c0184f70(trim, s));
}
function $4ac6576a0dee4ea5$export$4450cb132f24a206(workout, features) {
    const hasDecimalFeed = features.includes("decimal-feed");
    const hasShotIntervals = features.includes("shotIntervalOverride");
    const hasModules = features.includes("modules");
    if (hasDecimalFeed && hasShotIntervals && hasModules) // short circuit here - if the trainer can handle both of these features, any workout should work
    return [];
    if (!$4ac6576a0dee4ea5$export$5517a3496c13fa74(workout.config)) // the UI should prevent freeplay or quickstart shots from using these features
    return [];
    const { config: config } = workout;
    const missingFeatures = [];
    if (!hasDecimalFeed && config.interval) {
        if (config.interval % 1 !== 0) missingFeatures.push("decimal-feed");
    }
    if (!hasShotIntervals) {
        if (config.shots?.some((s)=>s.intervalOverride)) missingFeatures.push("shotIntervalOverride");
    }
    if (!hasModules) missingFeatures.push("modules");
    return missingFeatures;
}
function $4ac6576a0dee4ea5$export$fd8ff7e46546722(workout, features) {
    const missing = $4ac6576a0dee4ea5$export$4450cb132f24a206(workout, features);
    if (missing.length === 0) return {
        workout: workout,
        missing: []
    };
    const { config: config } = workout;
    if (missing.includes("decimal-feed") && config.interval) {
        const { interval: interval } = config;
        config.interval = Math.round(interval);
        (0, $1lMle.default).info(`Adjusting feed rate from ${interval} to ${config.interval}`);
    }
    if (missing.includes("shotIntervalOverride") && config.shots) {
        const updated = config.shots.map((s)=>({
                ...s,
                intervalOverride: undefined
            }));
        config.shots = updated;
    }
    const updated = {
        ...workout,
        config: config
    };
    return {
        workout: updated,
        missing: missing
    };
}
function $4ac6576a0dee4ea5$var$moduleShotToCuratedShot(shotArg) {
    const { launchSpeedVariation: launchSpeedVariation, tiltVariation: tiltVariation, panVariation: panVariation, name: name, ...shot } = shotArg;
    return {
        ...shot,
        launchSpeedVariance: launchSpeedVariation,
        tiltVariance: tiltVariation,
        panVariance: panVariation
    };
}
function $4ac6576a0dee4ea5$export$45f1096a3d9b7921(config, params) {
    const { sets: sets, numberOfBalls: numberOfBalls, intervalAfterSet: intervalAfterSet } = params;
    const { randomize: randomize, shots: moduleShots } = config;
    const moduleShotLength = moduleShots.length;
    let moduleShotIndex = 0;
    const shots = [];
    for(let i = 0; i < sets; i += 1){
        const isLastSet = i === sets - 1;
        for(let j = 0; j < numberOfBalls; j += 1){
            let shot;
            if (randomize) shot = moduleShots[Math.floor(Math.random() * moduleShotLength)];
            else {
                if (moduleShotIndex >= moduleShotLength) moduleShotIndex = 0;
                shot = moduleShots[moduleShotIndex];
                moduleShotIndex += 1;
            }
            if (shot) {
                const isLastShotInSet = j === numberOfBalls - 1;
                shots.push({
                    ...$4ac6576a0dee4ea5$var$moduleShotToCuratedShot(shot),
                    id: (0, $3Qvqk.default)(),
                    intervalOverride: !isLastSet && isLastShotInSet ? intervalAfterSet : shot.intervalOverride
                });
            }
        }
    }
    const convertedConfig = {
        randomize: false,
        interval: config.interval,
        playerPosition: config.playerPosition,
        shots: shots,
        shotCount: shots.length
    };
    const convertedParams = {
        intervalOverride: params.interval,
        numberOfBalls: shots.length,
        playMode: params.playMode,
        shuffle: false,
        initialDelay: 1
    };
    return [
        convertedConfig,
        convertedParams
    ];
}

});
parcelRegister("3Qvqk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3f51ba7d831d310$export$2e2bcd8739ae039; });
/**
 * Generate a UUID
 *
 * This function first checks if the 'randomUUID' function is available in the 'crypto' object.
 * If available, it uses 'crypto.randomUUID()' to generate a secure UUID.
 * If 'randomUUID' is not available, it falls back to a less secure method using 'Math.random()'.
 *
 * @returns {string} A UUID in the version 4 format.
 */ function $b3f51ba7d831d310$export$2e2bcd8739ae039() {
    if (crypto.randomUUID) return crypto.randomUUID();
    // UUID version 4 is 32 hexadecimal digits in the format of:
    // xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
    // where x is any hexadecimal digit and y is one of 8, 9, A, or B
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.floor(Math.random() * 16); // random hexadecimal digit
        const v = c === "x" ? r // replace x with a random hexadecimal digit
         : r % 4 + 8; // replace y with a random hexadecimal digit that is either 8, 9, A, or B
        return v.toString(16); // convert to hexadecimal string
    });
}

});



parcelRegister("8SbZe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $675caa268f29cd7f$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $774Wc = parcelRequire("774Wc");

var $jUiX6 = parcelRequire("jUiX6");

var $goBCW = parcelRequire("goBCW");

var $gSN9R = parcelRequire("gSN9R");

var $krx4P = parcelRequire("krx4P");

var $b6vKX = parcelRequire("b6vKX");

var $lNVEm = parcelRequire("lNVEm");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $4B5Or = parcelRequire("4B5Or");

var $OEXBZ = parcelRequire("OEXBZ");

var $bfkfm = parcelRequire("bfkfm");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
const $675caa268f29cd7f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $krx4P.default)(color)}`,
            `size${(0, $krx4P.default)(size)}`
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $lNVEm.getCheckboxUtilityClass), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $675caa268f29cd7f$var$CheckboxRoot = (0, $l0oRz.default)((0, $774Wc.default), {
    shouldForwardProp: (prop)=>(0, $b6vKX.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $krx4P.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $krx4P.default)(ownerState.color)}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: 'default',
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $lNVEm.default).checked}, &.${(0, $lNVEm.default).indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${(0, $lNVEm.default).disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
const $675caa268f29cd7f$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ih19M.jsx)((0, $goBCW.default), {});
const $675caa268f29cd7f$var$defaultIcon = /*#__PURE__*/ (0, $ih19M.jsx)((0, $jUiX6.default), {});
const $675caa268f29cd7f$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $ih19M.jsx)((0, $gSN9R.default), {});
const $675caa268f29cd7f$var$Checkbox = /*#__PURE__*/ $bh6RR.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $675caa268f29cd7f$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $675caa268f29cd7f$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $675caa268f29cd7f$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', disableRipple: disableRipple = false, className: className, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = {
        ...props,
        disableRipple: disableRipple,
        color: color,
        indeterminate: indeterminate,
        size: size
    };
    const classes = $675caa268f29cd7f$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $dFvJW.default)('root', {
        ref: ref,
        elementType: $675caa268f29cd7f$var$CheckboxRoot,
        className: (0, $aPsoC.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            type: 'checkbox',
            icon: /*#__PURE__*/ $bh6RR.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $bh6RR.cloneElement(indeterminateIcon, {
                fontSize: indeterminateIcon.props.fontSize ?? size
            }),
            disableRipple: disableRipple,
            slots: slots,
            slotProps: {
                input: (0, $bfkfm.default)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                    'data-indeterminate': indeterminate
                })
            }
        }
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $675caa268f29cd7f$export$2e2bcd8739ae039 = $675caa268f29cd7f$var$Checkbox;

});
parcelRegister("jUiX6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7e1f2c9d6d45288$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $e7e1f2c9d6d45288$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

});

parcelRegister("goBCW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $befc1332596d2b7c$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $befc1332596d2b7c$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

});

parcelRegister("gSN9R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4a7d243a8247625$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $c4a7d243a8247625$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

});

parcelRegister("lNVEm", function(module, exports) {

$parcel$export(module.exports, "getCheckboxUtilityClass", function () { return $fdfae4ae16482388$export$6c57c6e16b4063b; });
$parcel$export(module.exports, "default", function () { return $fdfae4ae16482388$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $fdfae4ae16482388$export$6c57c6e16b4063b(slot) {
    return (0, $dmzXD.default)('MuiCheckbox', slot);
}
const $fdfae4ae16482388$var$checkboxClasses = (0, $fYlYP.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $fdfae4ae16482388$export$2e2bcd8739ae039 = $fdfae4ae16482388$var$checkboxClasses;

});


parcelRegister("fMPxo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7e3510426f71ef7$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $96ZcP = parcelRequire("96ZcP");

var $1BiIF = parcelRequire("1BiIF");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $cbFbS = parcelRequire("cbFbS");

var $krx4P = parcelRequire("krx4P");

var $3BiAh = parcelRequire("3BiAh");

var $jZFy8 = parcelRequire("jZFy8");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
const $b7e3510426f71ef7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $krx4P.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $3BiAh.getFormControlLabelUtilityClasses), classes);
};
const $b7e3510426f71ef7$export$1b479270917a5676 = (0, $l0oRz.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $3BiAh.default).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $krx4P.default)(ownerState.labelPlacement)}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $3BiAh.default).disabled}`]: {
            cursor: 'default'
        },
        [`& .${(0, $3BiAh.default).label}`]: {
            [`&.${(0, $3BiAh.default).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: 'start'
                },
                style: {
                    flexDirection: 'row-reverse',
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: 'top'
                },
                style: {
                    flexDirection: 'column-reverse'
                }
            },
            {
                props: {
                    labelPlacement: 'bottom'
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ labelPlacement: labelPlacement })=>labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom',
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const $b7e3510426f71ef7$var$AsteriskComponent = (0, $l0oRz.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk'
})((0, $gfPc7.default)(({ theme: theme })=>({
        [`&.${(0, $3BiAh.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $b7e3510426f71ef7$var$FormControlLabel = /*#__PURE__*/ $bh6RR.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { checked: checked, className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, inputRef: inputRef, label: labelProp, labelPlacement: labelPlacement = 'end', name: name, onChange: onChange, required: requiredProp, slots: slots = {}, slotProps: slotProps = {}, value: value, ...other } = props;
    const muiFormControl = (0, $1BiIF.default)();
    const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
    const required = requiredProp ?? control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $jZFy8.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    };
    const classes = $b7e3510426f71ef7$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [TypographySlot, typographySlotProps] = (0, $dFvJW.default)('typography', {
        elementType: (0, $cbFbS.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== (0, $cbFbS.default) && !disableTypography) label = /*#__PURE__*/ (0, $ih19M.jsx)(TypographySlot, {
        component: "span",
        ...typographySlotProps,
        className: (0, $aPsoC.default)(classes.label, typographySlotProps?.className),
        children: label
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)($b7e3510426f71ef7$export$1b479270917a5676, {
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ $bh6RR.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $ih19M.jsxs)($b7e3510426f71ef7$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    });
});
var $b7e3510426f71ef7$export$2e2bcd8739ae039 = $b7e3510426f71ef7$var$FormControlLabel;

});
parcelRegister("3BiAh", function(module, exports) {

$parcel$export(module.exports, "getFormControlLabelUtilityClasses", function () { return $29f33e3761d37853$export$717666c39ec07e12; });
$parcel$export(module.exports, "default", function () { return $29f33e3761d37853$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $29f33e3761d37853$export$717666c39ec07e12(slot) {
    return (0, $dmzXD.default)('MuiFormControlLabel', slot);
}
const $29f33e3761d37853$var$formControlLabelClasses = (0, $fYlYP.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $29f33e3761d37853$export$2e2bcd8739ae039 = $29f33e3761d37853$var$formControlLabelClasses;

});


parcelRegister("iUqMN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc423c1edee1edb2$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $OEXBZ = parcelRequire("OEXBZ");

var $kb82Q = parcelRequire("kb82Q");

var $1BiIF = parcelRequire("1BiIF");

var $jZFy8 = parcelRequire("jZFy8");

var $ih19M = parcelRequire("ih19M");
'use client';
const $dc423c1edee1edb2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $kb82Q.getFormGroupUtilityClass), classes);
};
const $dc423c1edee1edb2$var$FormGroupRoot = (0, $l0oRz.default)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    variants: [
        {
            props: {
                row: true
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $dc423c1edee1edb2$var$FormGroup = /*#__PURE__*/ $bh6RR.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false, ...other } = props;
    const muiFormControl = (0, $1BiIF.default)();
    const fcs = (0, $jZFy8.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        row: row,
        error: fcs.error
    };
    const classes = $dc423c1edee1edb2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($dc423c1edee1edb2$var$FormGroupRoot, {
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $dc423c1edee1edb2$export$2e2bcd8739ae039 = $dc423c1edee1edb2$var$FormGroup;

});
parcelRegister("kb82Q", function(module, exports) {

$parcel$export(module.exports, "getFormGroupUtilityClass", function () { return $eb0b13469d6fc359$export$d72d4cbdc30b331f; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $eb0b13469d6fc359$export$d72d4cbdc30b331f(slot) {
    return (0, $dmzXD.default)('MuiFormGroup', slot);
}
const $eb0b13469d6fc359$var$formGroupClasses = (0, $fYlYP.default)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $eb0b13469d6fc359$export$2e2bcd8739ae039 = $eb0b13469d6fc359$var$formGroupClasses;

});


parcelRegister("c0jqm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bd48d60a2be0b12$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $8bd48d60a2be0b12$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), 'ArrowBack');

});

parcelRegister("asfIb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fed93d6c4658b242$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");
function $fed93d6c4658b242$export$2e2bcd8739ae039({ html: html }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
        sx: {
            fontSize: 16,
            lineHeight: 1.6,
            wordBreak: "break-word",
            "& h1, & h2, & h3, & h4": {
                lineHeight: 1.3,
                mt: 3,
                mb: 1,
                "&:first-of-type": {
                    mt: 0
                }
            },
            "& h1": {
                fontSize: 24
            },
            "& h2": {
                fontSize: 20
            },
            "& h3": {
                fontSize: 17
            },
            "& p": {
                my: 1.5
            },
            "& ul, & ol": {
                pl: 3,
                my: 1.5
            },
            "& li": {
                my: 0.5
            },
            "& a": {
                color: "info.main"
            },
            "& strong, & b": {
                fontWeight: 600
            },
            "& blockquote": {
                borderLeft: "3px solid",
                borderColor: "divider",
                pl: 2,
                ml: 0,
                my: 2,
                fontStyle: "italic"
            },
            "& code": {
                fontFamily: "monospace",
                fontSize: "0.9em",
                bgcolor: "action.hover",
                px: 0.5,
                borderRadius: 0.5
            },
            "& pre": {
                bgcolor: "action.hover",
                p: 1.5,
                borderRadius: 1,
                overflowX: "auto"
            },
            // Images come from the Intercom CDN at their authored size;
            // constrain them so a wide screenshot can't force the article
            // column to scroll sideways on a phone.
            "& img": {
                maxWidth: "100%",
                height: "auto",
                display: "block",
                my: 2,
                borderRadius: 1
            },
            "& figure": {
                m: 0,
                my: 2
            },
            "& figcaption": {
                fontSize: 13,
                color: "text.secondary",
                mt: 0.5
            },
            "& iframe": {
                maxWidth: "100%",
                border: 0,
                aspectRatio: "16 / 9",
                width: "100%",
                my: 2
            },
            // Tables scroll within their own container rather than
            // widening the page.
            "& table": {
                display: "block",
                overflowX: "auto",
                borderCollapse: "collapse",
                my: 2,
                maxWidth: "100%"
            },
            "& th, & td": {
                border: "1px solid",
                borderColor: "divider",
                px: 1,
                py: 0.75,
                textAlign: "left"
            },
            "& hr": {
                border: 0,
                borderTop: "1px solid",
                borderColor: "divider",
                my: 3
            }
        },
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
}

});

parcelRegister("9GahD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70c003668de89a84$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $70c003668de89a84$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2"
}), 'Circle');

});

parcelRegister("j4ol5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de21454286632e32$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $aPsoC = parcelRequire("aPsoC");


var $96ZcP = parcelRequire("96ZcP");

var $fJ5i3 = parcelRequire("fJ5i3");

var $fPZvG = parcelRequire("fPZvG");
var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $4obuG = parcelRequire("4obuG");

var $ih19M = parcelRequire("ih19M");
'use client';
const $de21454286632e32$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $4obuG.getSkeletonUtilityClass), classes);
};
const $de21454286632e32$var$pulseKeyframe = (0, $fPZvG.keyframes)`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;
const $de21454286632e32$var$waveKeyframe = (0, $fPZvG.keyframes)`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $de21454286632e32$var$pulseAnimation = typeof $de21454286632e32$var$pulseKeyframe !== 'string' ? (0, $fPZvG.css)`
        animation: ${$de21454286632e32$var$pulseKeyframe} 2s ease-in-out 0.5s infinite;
      ` : null;
const $de21454286632e32$var$waveAnimation = typeof $de21454286632e32$var$waveKeyframe !== 'string' ? (0, $fPZvG.css)`
        &::after {
          animation: ${$de21454286632e32$var$waveKeyframe} 2s linear 0.5s infinite;
        }
      ` : null;
const $de21454286632e32$var$SkeletonRoot = (0, $l0oRz.default)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>{
    const radiusUnit = (0, $fJ5i3.getUnit)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $fJ5i3.toUnitless)(theme.shape.borderRadius);
    return {
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : theme.alpha(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em',
        variants: [
            {
                props: {
                    variant: 'text'
                },
                style: {
                    marginTop: 0,
                    marginBottom: 0,
                    height: 'auto',
                    transformOrigin: '0 55%',
                    transform: 'scale(1, 0.60)',
                    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
                    '&:empty:before': {
                        content: '"\\00a0"'
                    }
                }
            },
            {
                props: {
                    variant: 'circular'
                },
                style: {
                    borderRadius: '50%'
                }
            },
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren,
                style: {
                    '& > *': {
                        visibility: 'hidden'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.width,
                style: {
                    maxWidth: 'fit-content'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.height,
                style: {
                    height: 'auto'
                }
            },
            {
                props: {
                    animation: 'pulse'
                },
                style: $de21454286632e32$var$pulseAnimation || {
                    animation: `${$de21454286632e32$var$pulseKeyframe} 2s ease-in-out 0.5s infinite`
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: {
                    position: 'relative',
                    overflow: 'hidden',
                    /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */ WebkitMaskImage: '-webkit-radial-gradient(white, black)',
                    '&::after': {
                        background: `linear-gradient(
                90deg,
                transparent,
                ${(theme.vars || theme).palette.action.hover},
                transparent
              )`,
                        content: '""',
                        position: 'absolute',
                        transform: 'translateX(-100%)' /* Avoid flash during server-side hydration */ ,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        top: 0
                    }
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: $de21454286632e32$var$waveAnimation || {
                    '&::after': {
                        animation: `${$de21454286632e32$var$waveKeyframe} 2s linear 0.5s infinite`
                    }
                }
            }
        ]
    };
}));
const $de21454286632e32$var$Skeleton = /*#__PURE__*/ $bh6RR.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width, ...other } = props;
    const ownerState = {
        ...props,
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    };
    const classes = $de21454286632e32$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($de21454286632e32$var$SkeletonRoot, {
        as: component,
        ref: ref,
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ...other,
        style: {
            width: width,
            height: height,
            ...style
        }
    });
});
var $de21454286632e32$export$2e2bcd8739ae039 = $de21454286632e32$var$Skeleton;

});
parcelRegister("fJ5i3", function(module, exports) {

$parcel$export(module.exports, "getUnit", function () { return $b72f29819d97d322$export$65f2564e9a9b9222; });
$parcel$export(module.exports, "toUnitless", function () { return $b72f29819d97d322$export$8af1d214c6c2f0f1; });
function $b72f29819d97d322$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $b72f29819d97d322$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $b72f29819d97d322$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $b72f29819d97d322$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $b72f29819d97d322$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $b72f29819d97d322$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $b72f29819d97d322$export$8af1d214c6c2f0f1(length) * $b72f29819d97d322$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $b72f29819d97d322$export$8af1d214c6c2f0f1(length) * $b72f29819d97d322$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $b72f29819d97d322$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $b72f29819d97d322$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $b72f29819d97d322$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $b72f29819d97d322$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $b72f29819d97d322$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

});

parcelRegister("4obuG", function(module, exports) {

$parcel$export(module.exports, "getSkeletonUtilityClass", function () { return $332251c75e897120$export$c987db9fc844f86; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $332251c75e897120$export$c987db9fc844f86(slot) {
    return (0, $dmzXD.default)('MuiSkeleton', slot);
}
const $332251c75e897120$var$skeletonClasses = (0, $fYlYP.default)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $332251c75e897120$export$2e2bcd8739ae039 = $332251c75e897120$var$skeletonClasses;

});


parcelRegister("kjzzE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});

var $bh6RR = parcelRequire("bh6RR");
function $eca12d3f808a0970$var$t(n) {
    return Array.prototype.slice.call(n);
}
function $eca12d3f808a0970$var$e(n, t) {
    var e = Math.floor(n);
    return e === t || e + 1 === t ? n : t;
}
function $eca12d3f808a0970$var$i() {
    return Date.now();
}
function $eca12d3f808a0970$var$r(n, t, e) {
    if (t = "data-keen-slider-" + t, null === e) return n.removeAttribute(t);
    n.setAttribute(t, e || "");
}
function $eca12d3f808a0970$var$a(n, e) {
    return e = e || document, "function" == typeof n && (n = n(e)), Array.isArray(n) ? n : "string" == typeof n ? $eca12d3f808a0970$var$t(e.querySelectorAll(n)) : n instanceof HTMLElement ? [
        n
    ] : n instanceof NodeList ? $eca12d3f808a0970$var$t(n) : [];
}
function $eca12d3f808a0970$var$o(n) {
    n.raw && (n = n.raw), n.cancelable && !n.defaultPrevented && n.preventDefault();
}
function $eca12d3f808a0970$var$u(n) {
    n.raw && (n = n.raw), n.stopPropagation && n.stopPropagation();
}
function $eca12d3f808a0970$var$c() {
    var n = [];
    return {
        add: function(t, e, i, r) {
            t.addListener ? t.addListener(i) : t.addEventListener(e, i, r), n.push([
                t,
                e,
                i,
                r
            ]);
        },
        input: function(n, t, e, i) {
            this.add(n, t, function(n) {
                return function(t) {
                    t.nativeEvent && (t = t.nativeEvent);
                    var e = t.changedTouches || [], i = t.targetTouches || [], r = t.detail && t.detail.x ? t.detail : null;
                    return n({
                        id: r ? r.identifier ? r.identifier : "i" : i[0] ? i[0] ? i[0].identifier : "e" : "d",
                        idChanged: r ? r.identifier ? r.identifier : "i" : e[0] ? e[0] ? e[0].identifier : "e" : "d",
                        raw: t,
                        x: r && r.x ? r.x : i[0] ? i[0].screenX : r ? r.x : t.pageX,
                        y: r && r.y ? r.y : i[0] ? i[0].screenY : r ? r.y : t.pageY
                    });
                };
            }(e), i);
        },
        purge: function() {
            n.forEach(function(n) {
                n[0].removeListener ? n[0].removeListener(n[2]) : n[0].removeEventListener(n[1], n[2], n[3]);
            }), n = [];
        }
    };
}
function $eca12d3f808a0970$var$s(n, t, e) {
    return Math.min(Math.max(n, t), e);
}
function $eca12d3f808a0970$var$d(n) {
    return (n > 0 ? 1 : 0) - (n < 0 ? 1 : 0) || +n;
}
function $eca12d3f808a0970$var$l(n) {
    var t = n.getBoundingClientRect();
    return {
        height: $eca12d3f808a0970$var$e(t.height, n.offsetHeight),
        width: $eca12d3f808a0970$var$e(t.width, n.offsetWidth)
    };
}
function $eca12d3f808a0970$var$f(n, t, e, i) {
    var r = n && n[t];
    return null == r ? e : i && "function" == typeof r ? r() : r;
}
function $eca12d3f808a0970$var$p(n) {
    return Math.round(1e6 * n) / 1e6;
}
function $eca12d3f808a0970$var$v(n, t) {
    if (n === t) return !0;
    var e = typeof n;
    if (e !== typeof t) return !1;
    if ("object" !== e || null === n || null === t) return "function" === e && n.toString() === t.toString();
    if (n.length !== t.length || Object.getOwnPropertyNames(n).length !== Object.getOwnPropertyNames(t).length) return !1;
    for(var i in n)if (!$eca12d3f808a0970$var$v(n[i], t[i])) return !1;
    return !0;
}
var $eca12d3f808a0970$var$h = function() {
    return $eca12d3f808a0970$var$h = Object.assign || function(n) {
        for(var t, e = 1, i = arguments.length; e < i; e++)for(var r in t = arguments[e])Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
        return n;
    }, $eca12d3f808a0970$var$h.apply(this, arguments);
};
function $eca12d3f808a0970$var$m(n, t, e) {
    if (e || 2 === arguments.length) for(var i, r = 0, a = t.length; r < a; r++)!i && r in t || (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
    return n.concat(i || Array.prototype.slice.call(t));
}
function $eca12d3f808a0970$var$g(n) {
    var t, e, i, r, a, o;
    function u(t) {
        o || (o = t), c(!0);
        var a = t - o;
        a > i && (a = i);
        var l = r[e];
        if (l[3] < a) return e++, u(t);
        var f = l[2], p = l[4], v = l[0], h = l[1] * (0, l[5])(0 === p ? 1 : (a - f) / p);
        if (h && n.track.to(v + h), a < i) return d();
        o = null, c(!1), s(null), n.emit("animationEnded");
    }
    function c(n) {
        t.active = n;
    }
    function s(n) {
        t.targetIdx = n;
    }
    function d() {
        var n;
        n = u, a = window.requestAnimationFrame(n);
    }
    function l() {
        var t;
        t = a, window.cancelAnimationFrame(t), c(!1), s(null), o && n.emit("animationStopped"), o = null;
    }
    return t = {
        active: !1,
        start: function(t) {
            if (l(), n.track.details) {
                var a = 0, o = n.track.details.position;
                e = 0, i = 0, r = t.map(function(n) {
                    var t, e = Number(o), r = null !== (t = n.earlyExit) && void 0 !== t ? t : n.duration, u = n.easing, c = n.distance * u(r / n.duration) || 0;
                    o += c;
                    var s = i;
                    return i += r, a += c, [
                        e,
                        n.distance,
                        s,
                        i,
                        n.duration,
                        u
                    ];
                }), s(n.track.distToIdx(a)), d(), n.emit("animationStarted");
            }
        },
        stop: l,
        targetIdx: null
    };
}
function $eca12d3f808a0970$var$b(n) {
    var t, e, r, a, o, u, c, l, v, h, g, b, y, x, k = 1 / 0, w = [], M = null, T = 0;
    function C(n) {
        P(T + n);
    }
    function E(n) {
        var t = z(T + n).abs;
        return O(t) ? t : null;
    }
    function z(n) {
        var t = Math.floor(Math.abs($eca12d3f808a0970$var$p(n / e))), i = $eca12d3f808a0970$var$p((n % e + e) % e);
        i === e && (i = 0);
        var r = $eca12d3f808a0970$var$d(n), a = c.indexOf($eca12d3f808a0970$var$m([], c, !0).reduce(function(n, t) {
            return Math.abs(t - i) < Math.abs(n - i) ? t : n;
        })), o = a;
        return r < 0 && t++, a === u && (o = 0, t += r > 0 ? 1 : -1), {
            abs: o + t * u * r,
            origin: a,
            rel: o
        };
    }
    function I(n, t, e) {
        var i;
        if (t || !S()) return A(n, e);
        if (!O(n)) return null;
        var r = z(null != e ? e : T), a = r.abs, o = n - r.rel, c = a + o;
        i = A(c);
        var s = A(c - u * $eca12d3f808a0970$var$d(o));
        return (null !== s && Math.abs(s) < Math.abs(i) || null === i) && (i = s), $eca12d3f808a0970$var$p(i);
    }
    function A(n, t) {
        if (null == t && (t = $eca12d3f808a0970$var$p(T)), !O(n) || null === n) return null;
        n = Math.round(n);
        var i = z(t), r = i.abs, a = i.rel, o = i.origin, s = L(n), d = (t % e + e) % e, l = c[o], f = Math.floor((n - (r - a)) / u) * e;
        return $eca12d3f808a0970$var$p(l - d - l + c[s] + f + (o === u ? e : 0));
    }
    function O(n) {
        return D(n) === n;
    }
    function D(n) {
        return $eca12d3f808a0970$var$s(n, v, h);
    }
    function S() {
        return a.loop;
    }
    function L(n) {
        return (n % u + u) % u;
    }
    function P(t) {
        var e;
        e = t - T, w.push({
            distance: e,
            timestamp: $eca12d3f808a0970$var$i()
        }), w.length > 6 && (w = w.slice(-6)), T = $eca12d3f808a0970$var$p(t);
        var r = _().abs;
        if (r !== M) {
            var a = null !== M;
            M = r, a && n.emit("slideChanged");
        }
    }
    function _(i) {
        var c = i ? null : function() {
            if (u) {
                var n = S(), t = n ? (T % e + e) % e : T, i = (n ? T % e : T) - o[0][2], c = 0 - (i < 0 && n ? e - Math.abs(i) : i), s = 0, l = z(T), f = l.abs, p = l.rel, m = o[p][2], k = o.map(function(t, i) {
                    var r = c + s;
                    (r < 0 - t[0] || r > 1) && (r += (Math.abs(r) > e - 1 && n ? e : 0) * $eca12d3f808a0970$var$d(-r));
                    var o = i - p, l = $eca12d3f808a0970$var$d(o), v = o + f;
                    n && (-1 === l && r > m && (v += u), 1 === l && r < m && (v -= u), null !== g && v < g && (r += e), null !== b && v > b && (r -= e));
                    var h = r + t[0] + t[1], y = Math.max(r >= 0 && h <= 1 ? 1 : h < 0 || r > 1 ? 0 : r < 0 ? Math.min(1, (t[0] + r) / t[0]) : (1 - r) / t[0], 0);
                    return s += t[0] + t[1], {
                        abs: v,
                        distance: a.rtl ? -1 * r + 1 - t[0] : r,
                        portion: y,
                        size: t[0]
                    };
                });
                return f = D(f), p = L(f), {
                    abs: D(f),
                    length: r,
                    max: x,
                    maxIdx: h,
                    min: y,
                    minIdx: v,
                    position: T,
                    progress: n ? t / e : T / r,
                    rel: p,
                    slides: k,
                    slidesLength: e
                };
            }
        }();
        return t.details = c, n.emit("detailsChanged"), c;
    }
    return t = {
        absToRel: L,
        add: C,
        details: null,
        distToIdx: E,
        idxToDist: I,
        init: function(t) {
            if (function() {
                if (a = n.options, o = (a.trackConfig || []).map(function(n) {
                    return [
                        $eca12d3f808a0970$var$f(n, "size", 1),
                        $eca12d3f808a0970$var$f(n, "spacing", 0),
                        $eca12d3f808a0970$var$f(n, "origin", 0)
                    ];
                }), u = o.length) {
                    e = $eca12d3f808a0970$var$p(o.reduce(function(n, t) {
                        return n + t[0] + t[1];
                    }, 0));
                    var t, i = u - 1;
                    r = $eca12d3f808a0970$var$p(e + o[0][2] - o[i][0] - o[i][2] - o[i][1]), c = o.reduce(function(n, e) {
                        if (!n) return [
                            0
                        ];
                        var i = o[n.length - 1], r = n[n.length - 1] + (i[0] + i[2]) + i[1];
                        return r -= e[2], n[n.length - 1] > r && (r = n[n.length - 1]), r = $eca12d3f808a0970$var$p(r), n.push(r), (!t || t < r) && (l = n.length - 1), t = r, n;
                    }, null), 0 === r && (l = 0), c.push($eca12d3f808a0970$var$p(e));
                }
            }(), !u) return _(!0);
            var i;
            !function() {
                var t = n.options.range, e = n.options.loop;
                g = v = e ? $eca12d3f808a0970$var$f(e, "min", -1 / 0) : 0, b = h = e ? $eca12d3f808a0970$var$f(e, "max", k) : l;
                var i = $eca12d3f808a0970$var$f(t, "min", null), r = $eca12d3f808a0970$var$f(t, "max", null);
                null !== i && (v = i), null !== r && (h = r), y = v === -1 / 0 ? v : n.track.idxToDist(v || 0, !0, 0), x = h === k ? h : I(h, !0, 0), null === r && (b = h), $eca12d3f808a0970$var$f(t, "align", !1) && h !== k && 0 === o[L(h)][2] && (x -= 1 - o[L(h)][0], h = E(x - T)), y = $eca12d3f808a0970$var$p(y), x = $eca12d3f808a0970$var$p(x);
            }(), i = t, Number(i) === i ? C(A(D(t))) : _();
        },
        to: P,
        velocity: function() {
            var n = $eca12d3f808a0970$var$i(), t = w.reduce(function(t, e) {
                var i = e.distance, r = e.timestamp;
                return n - r > 200 || ($eca12d3f808a0970$var$d(i) !== $eca12d3f808a0970$var$d(t.distance) && t.distance && (t = {
                    distance: 0,
                    lastTimestamp: 0,
                    time: 0
                }), t.time && (t.distance += i), t.lastTimestamp && (t.time += r - t.lastTimestamp), t.lastTimestamp = r), t;
            }, {
                distance: 0,
                lastTimestamp: 0,
                time: 0
            });
            return t.distance / t.time || 0;
        }
    };
}
function $eca12d3f808a0970$var$y(n) {
    var t, e, i, r, a, o, u, c;
    function l(n) {
        return 2 * n;
    }
    function f(n) {
        return $eca12d3f808a0970$var$s(n, u, c);
    }
    function p(n) {
        return 1 - Math.pow(1 - n, 3);
    }
    function v() {
        return i ? n.track.velocity() : 0;
    }
    function h() {
        b();
        var t = "free-snap" === n.options.mode, e = n.track, i = v();
        r = $eca12d3f808a0970$var$d(i);
        var u = n.track.details, c = [];
        if (i || !t) {
            var s = m(i), h = s.dist, g = s.dur;
            if (g = l(g), h *= r, t) {
                var y = e.idxToDist(e.distToIdx(h), !0);
                y && (h = y);
            }
            c.push({
                distance: h,
                duration: g,
                easing: p
            });
            var x = u.position, k = x + h;
            if (k < a || k > o) {
                var w = k < a ? a - x : o - x, M = 0, T = i;
                if ($eca12d3f808a0970$var$d(w) === r) {
                    var C = Math.min(Math.abs(w) / Math.abs(h), 1), E = function(n) {
                        return 1 - Math.pow(1 - n, 1 / 3);
                    }(C) * g;
                    c[0].earlyExit = E, T = i * (1 - C);
                } else c[0].earlyExit = 0, M += w;
                var z = m(T, 100), I = z.dist * r;
                n.options.rubberband && (c.push({
                    distance: I,
                    duration: l(z.dur),
                    easing: p
                }), c.push({
                    distance: -I + M,
                    duration: 500,
                    easing: p
                }));
            }
            n.animator.start(c);
        } else n.moveToIdx(f(u.abs), !0, {
            duration: 500,
            easing: function(n) {
                return 1 + --n * n * n * n * n;
            }
        });
    }
    function m(n, t) {
        void 0 === t && (t = 1e3);
        var e = 147e-9 + (n = Math.abs(n)) / t;
        return {
            dist: Math.pow(n, 2) / e,
            dur: n / e
        };
    }
    function g() {
        var t = n.track.details;
        t && (a = t.min, o = t.max, u = t.minIdx, c = t.maxIdx);
    }
    function b() {
        n.animator.stop();
    }
    n.on("updated", g), n.on("optionsChanged", g), n.on("created", g), n.on("dragStarted", function() {
        i = !1, b(), t = e = n.track.details.abs;
    }), n.on("dragChecked", function() {
        i = !0;
    }), n.on("dragEnded", function() {
        var i = n.options.mode;
        "snap" === i && function() {
            var i = n.track, r = n.track.details, u = r.position, c = $eca12d3f808a0970$var$d(v());
            (u > o || u < a) && (c = 0);
            var s = t + c;
            0 === r.slides[i.absToRel(s)].portion && (s -= c), t !== e && (s = e), $eca12d3f808a0970$var$d(i.idxToDist(s, !0)) !== c && (s += c), s = f(s);
            var l = i.idxToDist(s, !0);
            n.animator.start([
                {
                    distance: l,
                    duration: 500,
                    easing: function(n) {
                        return 1 + --n * n * n * n * n;
                    }
                }
            ]);
        }(), "free" !== i && "free-snap" !== i || h();
    }), n.on("dragged", function() {
        e = n.track.details.abs;
    });
}
function $eca12d3f808a0970$var$x(n) {
    var t, e, i, r, l, f, p, v, h, m, g, b, y, x, k, w, M, T, C = $eca12d3f808a0970$var$c();
    function E(t) {
        if (f && v === t.id) {
            var a = O(t);
            if (h) {
                if (!A(t)) return I(t);
                m = a, h = !1, n.emit("dragChecked");
            }
            if (w) return m = a;
            $eca12d3f808a0970$var$o(t);
            var c = function(t) {
                if (M === -1 / 0 && T === 1 / 0) return t;
                var i = n.track.details, a = i.length, o = i.position, u = $eca12d3f808a0970$var$s(t, M - o, T - o);
                if (0 === a) return 0;
                if (!n.options.rubberband) return u;
                if (o <= T && o >= M) return t;
                if (o < M && e > 0 || o > T && e < 0) return t;
                var c = (o < M ? o - M : o - T) / a, d = r * a, f = Math.abs(c * d), p = Math.max(0, 1 - f / l * 2);
                return p * p * t;
            }(p(m - a) / r * i);
            e = $eca12d3f808a0970$var$d(c);
            var y = n.track.details.position;
            (y > M && y < T || y === M && e > 0 || y === T && e < 0) && $eca12d3f808a0970$var$u(t), g += c, !b && Math.abs(g * r) > 5 && (b = !0), n.track.add(c), m = a, n.emit("dragged");
        }
    }
    function z(t) {
        !f && n.track.details && n.track.details.length && (g = 0, f = !0, b = !1, h = !0, v = t.id, A(t), m = O(t), n.emit("dragStarted"));
    }
    function I(t) {
        f && v === t.idChanged && (f = !1, n.emit("dragEnded"));
    }
    function A(n) {
        var t = D(), e = t ? n.y : n.x, i = t ? n.x : n.y, r = void 0 !== y && void 0 !== x && Math.abs(x - i) <= Math.abs(y - e);
        return y = e, x = i, r;
    }
    function O(n) {
        return D() ? n.y : n.x;
    }
    function D() {
        return n.options.vertical;
    }
    function S() {
        r = n.size, l = D() ? window.innerHeight : window.innerWidth;
        var t = n.track.details;
        t && (M = t.min, T = t.max);
    }
    function L(n) {
        b && ($eca12d3f808a0970$var$u(n), $eca12d3f808a0970$var$o(n));
    }
    function P() {
        if (C.purge(), n.options.drag && !n.options.disabled) {
            var e;
            e = n.options.dragSpeed || 1, p = "function" == typeof e ? e : function(n) {
                return n * e;
            }, i = n.options.rtl ? -1 : 1, S(), t = n.container, function() {
                var n = "data-keen-slider-clickable";
                $eca12d3f808a0970$var$a("[".concat(n, "]:not([").concat(n, "=false])"), t).map(function(n) {
                    C.add(n, "dragstart", $eca12d3f808a0970$var$u), C.add(n, "mousedown", $eca12d3f808a0970$var$u), C.add(n, "touchstart", $eca12d3f808a0970$var$u);
                });
            }(), C.add(t, "dragstart", function(n) {
                $eca12d3f808a0970$var$o(n);
            }), C.add(t, "click", L, {
                capture: !0
            }), C.input(t, "ksDragStart", z), C.input(t, "ksDrag", E), C.input(t, "ksDragEnd", I), C.input(t, "mousedown", z), C.input(t, "mousemove", E), C.input(t, "mouseleave", I), C.input(t, "mouseup", I), C.input(t, "touchstart", z, {
                passive: !0
            }), C.input(t, "touchmove", E, {
                passive: !1
            }), C.input(t, "touchend", I), C.input(t, "touchcancel", I), C.add(window, "wheel", function(n) {
                f && $eca12d3f808a0970$var$o(n);
            });
            var r = "data-keen-slider-scrollable";
            $eca12d3f808a0970$var$a("[".concat(r, "]:not([").concat(r, "=false])"), n.container).map(function(n) {
                return function(n) {
                    var t;
                    C.input(n, "touchstart", function(n) {
                        t = O(n), w = !0, k = !0;
                    }, {
                        passive: !0
                    }), C.input(n, "touchmove", function(e) {
                        var i = D(), r = i ? n.scrollHeight - n.clientHeight : n.scrollWidth - n.clientWidth, a = t - O(e), u = i ? n.scrollTop : n.scrollLeft, c = i && "scroll" === n.style.overflowY || !i && "scroll" === n.style.overflowX;
                        if (t = O(e), (a < 0 && u > 0 || a > 0 && u < r) && k && c) return w = !0;
                        k = !1, $eca12d3f808a0970$var$o(e), w = !1;
                    }), C.input(n, "touchend", function() {
                        w = !1;
                    });
                }(n);
            });
        }
    }
    n.on("updated", S), n.on("optionsChanged", P), n.on("created", P), n.on("destroyed", C.purge);
}
function $eca12d3f808a0970$var$k(n) {
    var t, e, i = null;
    function r(t, e, i) {
        n.animator.active ? o(t, e, i) : requestAnimationFrame(function() {
            return o(t, e, i);
        });
    }
    function a() {
        r(!1, !1, e);
    }
    function o(e, r, a) {
        var o = 0, u = n.size, d = n.track.details;
        if (d && t) {
            var l = d.slides;
            t.forEach(function(n, t) {
                if (e) !i && r && c(n, null, a), s(n, null, a);
                else {
                    if (!l[t]) return;
                    var d = l[t].size * u;
                    !i && r && c(n, d, a), s(n, l[t].distance * u - o, a), o += d;
                }
            });
        }
    }
    function u(t) {
        return "performance" === n.options.renderMode ? Math.round(t) : t;
    }
    function c(n, t, e) {
        var i = e ? "height" : "width";
        null !== t && (t = u(t) + "px"), n.style["min-" + i] = t, n.style["max-" + i] = t;
    }
    function s(n, t, e) {
        if (null !== t) {
            t = u(t);
            var i = e ? t : 0;
            t = "translate3d(".concat(e ? 0 : t, "px, ").concat(i, "px, 0)");
        }
        n.style.transform = t, n.style["-webkit-transform"] = t;
    }
    function d() {
        t && (o(!0, !0, e), t = null), n.on("detailsChanged", a, !0);
    }
    function l() {
        r(!1, !0, e);
    }
    function p() {
        d(), e = n.options.vertical, n.options.disabled || "custom" === n.options.renderMode || (i = "auto" === $eca12d3f808a0970$var$f(n.options.slides, "perView", null), n.on("detailsChanged", a), (t = n.slides).length && l());
    }
    n.on("created", p), n.on("optionsChanged", p), n.on("beforeOptionsChanged", function() {
        d();
    }), n.on("updated", l), n.on("destroyed", d);
}
function $eca12d3f808a0970$var$w(n, t) {
    return function(e) {
        var i, o, u, s, d, p, v = $eca12d3f808a0970$var$c();
        function m(n) {
            var t;
            $eca12d3f808a0970$var$r(e.container, "reverse", "rtl" !== (t = e.container, window.getComputedStyle(t, null).getPropertyValue("direction")) || n ? null : ""), $eca12d3f808a0970$var$r(e.container, "v", e.options.vertical && !n ? "" : null), $eca12d3f808a0970$var$r(e.container, "disabled", e.options.disabled && !n ? "" : null);
        }
        function g() {
            b() && M();
        }
        function b() {
            var n = null;
            if (s.forEach(function(t) {
                t.matches && (n = t.__media);
            }), n === i) return !1;
            i || e.emit("beforeOptionsChanged"), i = n;
            var t = n ? u.breakpoints[n] : u;
            return e.options = $eca12d3f808a0970$var$h($eca12d3f808a0970$var$h({}, u), t), m(), I(), A(), C(), !0;
        }
        function y(n) {
            var t = $eca12d3f808a0970$var$l(n);
            return (e.options.vertical ? t.height : t.width) / e.size || 1;
        }
        function x() {
            return e.options.trackConfig.length;
        }
        function k(n) {
            for(var r in i = !1, u = $eca12d3f808a0970$var$h($eca12d3f808a0970$var$h({}, t), n), v.purge(), o = e.size, s = [], u.breakpoints || []){
                var a = window.matchMedia(r);
                a.__media = r, s.push(a), v.add(a, "change", g);
            }
            v.add(window, "orientationchange", z), v.add(window, "resize", E), b();
        }
        function w(n) {
            e.animator.stop();
            var t = e.track.details;
            e.track.init(null != n ? n : t ? t.abs : 0);
        }
        function M(n) {
            w(n), e.emit("optionsChanged");
        }
        function T(n, t) {
            if (n) return k(n), void M(t);
            I(), A();
            var i = x();
            C(), x() !== i ? M(t) : w(t), e.emit("updated");
        }
        function C() {
            var n = e.options.slides;
            if ("function" == typeof n) return e.options.trackConfig = n(e.size, e.slides);
            for(var t = e.slides, i = t.length, r = "number" == typeof n ? n : $eca12d3f808a0970$var$f(n, "number", i, !0), a = [], o = $eca12d3f808a0970$var$f(n, "perView", 1, !0), u = $eca12d3f808a0970$var$f(n, "spacing", 0, !0) / e.size || 0, c = "auto" === o ? u : u / o, s = $eca12d3f808a0970$var$f(n, "origin", "auto"), d = 0, l = 0; l < r; l++){
                var p = "auto" === o ? y(t[l]) : 1 / o - u + c, v = "center" === s ? .5 - p / 2 : "auto" === s ? 0 : s;
                a.push({
                    origin: v,
                    size: p,
                    spacing: u
                }), d += p;
            }
            if (d += u * (r - 1), "auto" === s && !e.options.loop && 1 !== o) {
                var h = 0;
                a.map(function(n) {
                    var t = d - h;
                    return h += n.size + u, t >= 1 || (n.origin = 1 - t - (d > 1 ? 0 : 1 - d)), n;
                });
            }
            e.options.trackConfig = a;
        }
        function E() {
            I();
            var n = e.size;
            e.options.disabled || n === o || (o = n, T());
        }
        function z() {
            E(), setTimeout(E, 500), setTimeout(E, 2e3);
        }
        function I() {
            var n = $eca12d3f808a0970$var$l(e.container);
            e.size = (e.options.vertical ? n.height : n.width) || 1;
        }
        function A() {
            e.slides = $eca12d3f808a0970$var$a(e.options.selector, e.container);
        }
        e.container = (p = $eca12d3f808a0970$var$a(n, d || document)).length ? p[0] : null, e.destroy = function() {
            v.purge(), e.emit("destroyed"), m(!0);
        }, e.prev = function() {
            e.moveToIdx(e.track.details.abs - 1, !0);
        }, e.next = function() {
            e.moveToIdx(e.track.details.abs + 1, !0);
        }, e.update = T, k(e.options);
    };
}
var $eca12d3f808a0970$var$M = function(n, t, e) {
    try {
        return function(n, t) {
            var e, i = {};
            return e = {
                emit: function(n) {
                    i[n] && i[n].forEach(function(n) {
                        n(e);
                    });
                    var t = e.options && e.options[n];
                    t && t(e);
                },
                moveToIdx: function(n, t, i) {
                    var r = e.track.idxToDist(n, t);
                    if (r) {
                        var a = e.options.defaultAnimation;
                        e.animator.start([
                            {
                                distance: r,
                                duration: $eca12d3f808a0970$var$f(i || a, "duration", 500),
                                easing: $eca12d3f808a0970$var$f(i || a, "easing", function(n) {
                                    return 1 + --n * n * n * n * n;
                                })
                            }
                        ]);
                    }
                },
                on: function(n, t, e) {
                    void 0 === e && (e = !1), i[n] || (i[n] = []);
                    var r = i[n].indexOf(t);
                    r > -1 ? e && delete i[n][r] : e || i[n].push(t);
                },
                options: n
            }, function() {
                if (e.track = $eca12d3f808a0970$var$b(e), e.animator = $eca12d3f808a0970$var$g(e), t) for(var n = 0, i = t; n < i.length; n++)(0, i[n])(e);
                e.track.init(e.options.initial || 0), e.emit("created");
            }(), e;
        }(t, $eca12d3f808a0970$var$m([
            $eca12d3f808a0970$var$w(n, {
                drag: !0,
                mode: "snap",
                renderMode: "precision",
                rubberband: !0,
                selector: ".keen-slider__slide"
            }),
            $eca12d3f808a0970$var$k,
            $eca12d3f808a0970$var$x,
            $eca12d3f808a0970$var$y
        ], e || [], !0));
    } catch (n) {
        console.error(n);
    }
};
module.exports.useKeenSlider = function(t, e) {
    var i = $bh6RR.useRef(null), r = $bh6RR.useRef(!1), a = $bh6RR.useRef(t), o = $bh6RR.useCallback(function(n) {
        n ? (a.current = t, i.current = new $eca12d3f808a0970$var$M(n, t, e), r.current = !1) : (i.current && i.current.destroy && i.current.destroy(), i.current = null);
    }, []);
    return $bh6RR.useEffect(function() {
        $eca12d3f808a0970$var$v(a.current, t) || (a.current = t, i.current && i.current.update(a.current));
    }, [
        t
    ]), [
        o,
        i
    ];
};

});

parcelRegister("8dR8l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fc8c0db75a8af79$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $5fc8c0db75a8af79$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2M5 8V7h2v3.82C5.84 10.4 5 9.3 5 8m14 0c0 1.3-.84 2.4-2 2.82V7h2z"
}), 'EmojiEvents');

});

parcelRegister("8yAk0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63adac6c7341670b$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $63adac6c7341670b$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "m16 18 2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"
}), 'TrendingDown');

});

parcelRegister("8HCQF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $656079612d87779b$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $656079612d87779b$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "m16 6 2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
}), 'TrendingUp');

});

parcelRegister("jzjwW", function(module, exports) {

$parcel$export(module.exports, "MY_GAME_FEATURE", function () { return $e3f06f85f48c3e1b$export$3130346b640e2200; });
const $e3f06f85f48c3e1b$export$3130346b640e2200 = "MY_GAME";

});

parcelRegister("54VCJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $597c9fb1bbf079a8$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $cgxZJ = parcelRequire("cgxZJ");

var $9VC8i = parcelRequire("9VC8i");

var $jZn3C = parcelRequire("jZn3C");

var $kTwZS = parcelRequire("kTwZS");

var $6N9X3 = parcelRequire("6N9X3");

var $k3Qux = parcelRequire("k3Qux");

var $gKTrX = parcelRequire("gKTrX");

var $48XwK = parcelRequire("48XwK");

var $86YkO = parcelRequire("86YkO");

var $e9JfK = parcelRequire("e9JfK");

var $5pDJL = parcelRequire("5pDJL");

var $tNNO5 = parcelRequire("tNNO5");

var $cYpOd = parcelRequire("cYpOd");

var $clg0Q = parcelRequire("clg0Q");

var $4sFFp = parcelRequire("4sFFp");
const $597c9fb1bbf079a8$var$StatsAchievementIcon = ({ achievementId: achievementId, ...props })=>{
    if (!achievementId) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cgxZJ.default), {
        ...props
    });
    switch(achievementId){
        case 1:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $gKTrX.default), {
                ...props
            });
        case 2:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $48XwK.default), {
                ...props
            });
        case 3:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $86YkO.default), {
                ...props
            });
        case 4:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e9JfK.default), {
                ...props
            });
        case 5:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5pDJL.default), {
                ...props
            });
        case 6:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $tNNO5.default), {
                ...props
            });
        case 7:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cYpOd.default), {
                ...props
            });
        case 8:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $clg0Q.default), {
                ...props
            });
        case 9:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $4sFFp.default), {
                ...props
            });
        case 10:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $9VC8i.default), {
                ...props
            });
        case 11:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $jZn3C.default), {
                ...props
            });
        case 12:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $kTwZS.default), {
                ...props
            });
        case 13:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $6N9X3.default), {
                ...props
            });
        case 14:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3Qux.default), {
                ...props
            });
        default:
            return null;
    }
};
var $597c9fb1bbf079a8$export$2e2bcd8739ae039 = $597c9fb1bbf079a8$var$StatsAchievementIcon;

});
parcelRegister("cgxZJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $024df50da789d14b$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $024df50da789d14b$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M7 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5"
}), 'Pending');

});

parcelRegister("9VC8i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95fa819cdbc2127f$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");
const $95fa819cdbc2127f$var$Achievement10Icon = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M76.6223 158.427L33.9378 135.097C19.1794 127.03 10 111.552 10 94.7326V6C10 2.68629 12.6863 0 16 0H43H79.5H116H143C146.314 0 149 2.6863 149 6V94.7326C149 111.552 139.821 127.03 125.062 135.097L82.3777 158.427C80.5844 159.407 78.4156 159.407 76.6223 158.427Z",
            fill: "url(#paint0_linear_5305_1588)"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("g", {
            filter: "url(#filter0_i_5305_1588)",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M76.6129 141.415L48.8659 126.185C34.1476 118.106 25 102.65 25 85.8603V23C25 19.6863 27.6863 17 31 17H50.8777H79.5H108.122H128C131.314 17 134 19.6863 134 23V85.8603C134 102.65 124.852 118.106 110.134 126.185L82.3871 141.415C80.5889 142.402 78.4111 142.402 76.6129 141.415Z",
                fill: "url(#paint1_linear_5305_1588)"
            })
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M76.6129 141.415L48.8659 126.185C34.1476 118.106 25 102.65 25 85.8603V23C25 19.6863 27.6863 17 31 17H50.8777H79.5H108.122H128C131.314 17 134 19.6863 134 23V85.8603C134 102.65 124.852 118.106 110.134 126.185L82.3871 141.415C80.5889 142.402 78.4111 142.402 76.6129 141.415Z",
            stroke: "#182370",
            strokeWidth: "3"
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter1_d_5305_1588)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.2065 42.634C78.9402 41.1475 81.0598 41.1475 81.7935 42.634L88.9392 57.1128C89.2305 57.7031 89.7937 58.1123 90.4451 58.2069L106.423 60.5287C108.064 60.7671 108.719 62.783 107.532 63.9401L95.9698 75.2103C95.4985 75.6698 95.2834 76.3318 95.3946 76.9806L98.1241 92.8944C98.4043 94.5282 96.6894 95.7742 95.2222 95.0028L80.9307 87.4893C80.348 87.183 79.652 87.183 79.0693 87.4893L64.7778 95.0028C63.3106 95.7742 61.5957 94.5282 61.8759 92.8944L64.6054 76.9806C64.7166 76.3318 64.5015 75.6698 64.0302 75.2103L52.4681 63.9401C51.2811 62.783 51.9361 60.7671 53.5765 60.5287L69.5549 58.2069C70.2063 58.1123 70.7695 57.7031 71.0608 57.1128L78.2065 42.634Z",
                    fill: "url(#paint2_linear_5305_1588)"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.8789 42.9658C79.3088 42.0948 80.5004 42.0404 81.0254 42.8027L81.1211 42.9658L88.2666 57.4443C88.6422 58.2053 89.3463 58.7479 90.1709 58.9199L90.3369 58.9492L106.315 61.2705C107.277 61.4102 107.697 62.5269 107.134 63.2617L107.009 63.4033L95.4463 74.6729C94.8386 75.2652 94.5405 76.1029 94.6318 76.9404L94.6553 77.1074L97.3848 93.0215C97.5488 93.9788 96.6169 94.7233 95.7441 94.415L95.5713 94.3389L81.2793 86.8252C80.5283 86.4305 79.6401 86.4055 78.8721 86.751L78.7207 86.8252L64.4287 94.3389C63.5691 94.7907 62.5738 94.1349 62.5967 93.21L62.6152 93.0215L65.3447 77.1074C65.4882 76.2711 65.2369 75.4188 64.6709 74.7949L64.5537 74.6729L52.9912 63.4033C52.2959 62.7255 52.6123 61.5756 53.499 61.3115L53.6846 61.2705L69.6631 58.9492C70.5028 58.8271 71.236 58.3249 71.6543 57.5938L71.7334 57.4443L78.8789 42.9658Z",
                    stroke: "#182370",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter0_i_5305_1588",
                    x: "23.5",
                    y: "15.5",
                    width: "116",
                    height: "132.156",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "4",
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow_5305_1588"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter1_d_5305_1588",
                    x: "46.8619",
                    y: "35.5191",
                    width: "68.2761",
                    height: "65.7178",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1588"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1588",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint0_linear_5305_1588",
                    x1: "10",
                    y1: "0",
                    x2: "168.978",
                    y2: "141.565",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#586EC3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#0C1779"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint1_linear_5305_1588",
                    x1: "25",
                    y1: "17",
                    x2: "149.688",
                    y2: "124.865",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#2E4898"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#122181"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint2_linear_5305_1588",
                    x1: "126.545",
                    y1: "103",
                    x2: "62.8571",
                    y2: "17.1799",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#4E64D5"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#8199E6"
                        })
                    ]
                })
            ]
        })
    ]
}), "Achievement10Icon");
var $95fa819cdbc2127f$export$2e2bcd8739ae039 = $95fa819cdbc2127f$var$Achievement10Icon;

});

parcelRegister("jZn3C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe6adfd31cb1bc67$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");
const $fe6adfd31cb1bc67$var$Achievement11Icon = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M76.6223 158.427L33.9378 135.097C19.1794 127.03 10 111.552 10 94.7326V6C10 2.68629 12.6863 0 16 0H43H79.5H116H143C146.314 0 149 2.6863 149 6V94.7326C149 111.552 139.821 127.03 125.062 135.097L82.3777 158.427C80.5844 159.407 78.4156 159.407 76.6223 158.427Z",
            fill: "url(#paint0_linear_5305_1602)"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("g", {
            filter: "url(#filter0_i_5305_1602)",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M76.6129 141.415L48.8659 126.185C34.1476 118.106 25 102.65 25 85.8603V23C25 19.6863 27.6863 17 31 17H50.8777H79.5H108.122H128C131.314 17 134 19.6863 134 23V85.8603C134 102.65 124.852 118.106 110.134 126.185L82.3871 141.415C80.5889 142.402 78.4111 142.402 76.6129 141.415Z",
                fill: "url(#paint1_linear_5305_1602)"
            })
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M76.6129 141.415L48.8659 126.185C34.1476 118.106 25 102.65 25 85.8603V23C25 19.6863 27.6863 17 31 17H50.8777H79.5H108.122H128C131.314 17 134 19.6863 134 23V85.8603C134 102.65 124.852 118.106 110.134 126.185L82.3871 141.415C80.5889 142.402 78.4111 142.402 76.6129 141.415Z",
            stroke: "#182370",
            strokeWidth: "3"
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter1_d_5305_1602)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.2065 32.634C78.9402 31.1475 81.0598 31.1475 81.7935 32.634L85.4125 39.9669C85.7038 40.5572 86.267 40.9664 86.9184 41.061L95.0108 42.2369C96.6512 42.4753 97.3063 44.4912 96.1192 45.6483L90.2635 51.3562C89.7921 51.8157 89.577 52.4777 89.6883 53.1265L91.0707 61.1862C91.3509 62.82 89.636 64.066 88.1688 63.2946L80.9307 59.4893C80.348 59.183 79.652 59.183 79.0693 59.4893L71.8312 63.2946C70.364 64.066 68.6491 62.82 68.9293 61.1862L70.3117 53.1265C70.423 52.4777 70.2079 51.8157 69.7365 51.3562L63.8808 45.6483C62.6937 44.4912 63.3488 42.4753 64.9892 42.2369L73.0816 41.061C73.733 40.9664 74.2962 40.5572 74.5875 39.9669L78.2065 32.634Z",
                    fill: "url(#paint2_linear_5305_1602)"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.8789 32.9658C79.3088 32.0948 80.5004 32.0404 81.0254 32.8027L81.1211 32.9658L84.7402 40.2988C85.1158 41.0598 85.8198 41.6015 86.6445 41.7734L86.8105 41.8037L94.9033 42.9795C95.8642 43.1194 96.284 44.235 95.7217 44.9697L95.5957 45.1113L89.7402 50.8193C89.1326 51.4116 88.8346 52.2485 88.9258 53.0859L88.9492 53.2529L90.3311 61.3135C90.4949 62.2705 89.5639 63.0146 88.6914 62.707L88.5176 62.6309L81.2793 58.8252C80.5283 58.4305 79.6401 58.4055 78.8721 58.751L78.7207 58.8252L71.4824 62.6309C70.6226 63.0829 69.6269 62.4264 69.6504 61.501L69.6689 61.3135L71.0508 53.2529C71.1941 52.4165 70.9431 51.5642 70.377 50.9404L70.2598 50.8193L64.4043 45.1113C63.7088 44.4334 64.025 43.2834 64.9121 43.0195L65.0967 42.9795L73.1895 41.8037C74.0291 41.6817 74.7622 41.1792 75.1807 40.4482L75.2598 40.2988L78.8789 32.9658Z",
                    stroke: "#182370",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter2_d_5305_1602)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.2065 72.634C78.9402 71.1475 81.0598 71.1475 81.7935 72.634L85.4125 79.9669C85.7038 80.5572 86.267 80.9664 86.9184 81.061L95.0108 82.2369C96.6512 82.4753 97.3063 84.4912 96.1192 85.6483L90.2635 91.3562C89.7921 91.8157 89.577 92.4777 89.6883 93.1265L91.0707 101.186C91.3509 102.82 89.636 104.066 88.1688 103.295L80.9307 99.4893C80.348 99.183 79.652 99.183 79.0693 99.4893L71.8312 103.295C70.364 104.066 68.6491 102.82 68.9293 101.186L70.3117 93.1265C70.423 92.4777 70.2079 91.8157 69.7365 91.3562L63.8808 85.6483C62.6937 84.4912 63.3488 82.4753 64.9892 82.2369L73.0816 81.061C73.733 80.9664 74.2962 80.5572 74.5875 79.9669L78.2065 72.634Z",
                    fill: "url(#paint3_linear_5305_1602)"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.8789 72.9658C79.3088 72.0948 80.5004 72.0404 81.0254 72.8027L81.1211 72.9658L84.7402 80.2988C85.1158 81.0598 85.8198 81.6015 86.6445 81.7734L86.8105 81.8037L94.9033 82.9795C95.8642 83.1194 96.284 84.235 95.7217 84.9697L95.5957 85.1113L89.7402 90.8193C89.1326 91.4116 88.8346 92.2485 88.9258 93.0859L88.9492 93.2529L90.3311 101.313C90.4949 102.27 89.5639 103.015 88.6914 102.707L88.5176 102.631L81.2793 98.8252C80.5283 98.4305 79.6401 98.4055 78.8721 98.751L78.7207 98.8252L71.4824 102.631C70.6226 103.083 69.6269 102.426 69.6504 101.501L69.6689 101.313L71.0508 93.2529C71.1941 92.4165 70.9431 91.5642 70.377 90.9404L70.2598 90.8193L64.4043 85.1113C63.7088 84.4334 64.025 83.2834 64.9121 83.0195L65.0967 82.9795L73.1895 81.8037C74.0291 81.6817 74.7622 81.1792 75.1807 80.4482L75.2598 80.2988L78.8789 72.9658Z",
                    stroke: "#182370",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter0_i_5305_1602",
                    x: "23.5",
                    y: "15.5",
                    width: "116",
                    height: "132.156",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "4",
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow_5305_1602"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter1_d_5305_1602",
                    x: "58.2747",
                    y: "25.5191",
                    width: "45.4507",
                    height: "44.0096",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1602"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1602",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter2_d_5305_1602",
                    x: "58.2747",
                    y: "65.5191",
                    width: "45.4507",
                    height: "44.0096",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1602"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1602",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint0_linear_5305_1602",
                    x1: "10",
                    y1: "0",
                    x2: "168.978",
                    y2: "141.565",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#586EC3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#0C1779"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint1_linear_5305_1602",
                    x1: "25",
                    y1: "17",
                    x2: "149.688",
                    y2: "124.865",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#2E4898"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#122181"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint2_linear_5305_1602",
                    x1: "109.091",
                    y1: "69",
                    x2: "69.2857",
                    y2: "15.3625",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#4E64D5"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#8199E6"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint3_linear_5305_1602",
                    x1: "109.091",
                    y1: "109",
                    x2: "69.2857",
                    y2: "55.3625",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#4E64D5"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#8199E6"
                        })
                    ]
                })
            ]
        })
    ]
}), "Achievement11Icon");
var $fe6adfd31cb1bc67$export$2e2bcd8739ae039 = $fe6adfd31cb1bc67$var$Achievement11Icon;

});

parcelRegister("kTwZS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5e5990c5e386fec$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");
const $d5e5990c5e386fec$var$Achievement12Icon = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M76.6223 158.427L33.9378 135.097C19.1794 127.03 10 111.552 10 94.7326V6C10 2.68629 12.6863 0 16 0H43H79.5H116H143C146.314 0 149 2.6863 149 6V94.7326C149 111.552 139.821 127.03 125.062 135.097L82.3777 158.427C80.5844 159.407 78.4156 159.407 76.6223 158.427Z",
            fill: "url(#paint0_linear_5305_1624)"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("g", {
            filter: "url(#filter0_i_5305_1624)",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M76.6129 141.415L48.8659 126.185C34.1476 118.106 25 102.65 25 85.8603V23C25 19.6863 27.6863 17 31 17H50.8777H79.5H108.122H128C131.314 17 134 19.6863 134 23V85.8603C134 102.65 124.852 118.106 110.134 126.185L82.3871 141.415C80.5889 142.402 78.4111 142.402 76.6129 141.415Z",
                fill: "url(#paint1_linear_5305_1624)"
            })
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M76.6129 141.415L48.8659 126.185C34.1476 118.106 25 102.65 25 85.8603V23C25 19.6863 27.6863 17 31 17H50.8777H79.5H108.122H128C131.314 17 134 19.6863 134 23V85.8603C134 102.65 124.852 118.106 110.134 126.185L82.3871 141.415C80.5889 142.402 78.4111 142.402 76.6129 141.415Z",
            stroke: "#182370",
            strokeWidth: "3"
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter1_d_5305_1624)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M58.2065 66.634C58.9402 65.1475 61.0598 65.1475 61.7935 66.634L65.4125 73.9669C65.7038 74.5572 66.267 74.9664 66.9184 75.061L75.0108 76.2369C76.6512 76.4753 77.3063 78.4912 76.1192 79.6483L70.2635 85.3562C69.7921 85.8157 69.577 86.4777 69.6883 87.1265L71.0707 95.1862C71.3509 96.82 69.636 98.066 68.1688 97.2946L60.9307 93.4893C60.348 93.183 59.652 93.183 59.0693 93.4893L51.8312 97.2946C50.364 98.066 48.6491 96.82 48.9293 95.1862L50.3117 87.1265C50.423 86.4777 50.2079 85.8157 49.7365 85.3562L43.8808 79.6483C42.6937 78.4912 43.3488 76.4753 44.9892 76.2369L53.0816 75.061C53.733 74.9664 54.2962 74.5572 54.5875 73.9669L58.2065 66.634Z",
                    fill: "#FBCF26"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M58.2065 66.634C58.9402 65.1475 61.0598 65.1475 61.7935 66.634L65.4125 73.9669C65.7038 74.5572 66.267 74.9664 66.9184 75.061L75.0108 76.2369C76.6512 76.4753 77.3063 78.4912 76.1192 79.6483L70.2635 85.3562C69.7921 85.8157 69.577 86.4777 69.6883 87.1265L71.0707 95.1862C71.3509 96.82 69.636 98.066 68.1688 97.2946L60.9307 93.4893C60.348 93.183 59.652 93.183 59.0693 93.4893L51.8312 97.2946C50.364 98.066 48.6491 96.82 48.9293 95.1862L50.3117 87.1265C50.423 86.4777 50.2079 85.8157 49.7365 85.3562L43.8808 79.6483C42.6937 78.4912 43.3488 76.4753 44.9892 76.2369L53.0816 75.061C53.733 74.9664 54.2962 74.5572 54.5875 73.9669L58.2065 66.634Z",
                    fill: "url(#paint2_linear_5305_1624)"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M58.8789 66.9658C59.3088 66.0948 60.5004 66.0404 61.0254 66.8027L61.1211 66.9658L64.7402 74.2988C65.1158 75.0598 65.8198 75.6015 66.6445 75.7734L66.8105 75.8037L74.9033 76.9795C75.8642 77.1194 76.284 78.235 75.7217 78.9697L75.5957 79.1113L69.7402 84.8193C69.1326 85.4116 68.8346 86.2485 68.9258 87.0859L68.9492 87.2529L70.3311 95.3135C70.4949 96.2705 69.5639 97.0146 68.6914 96.707L68.5176 96.6309L61.2793 92.8252C60.5283 92.4305 59.6401 92.4055 58.8721 92.751L58.7207 92.8252L51.4824 96.6309C50.6226 97.0829 49.6269 96.4264 49.6504 95.501L49.6689 95.3135L51.0508 87.2529C51.1941 86.4165 50.9431 85.5642 50.377 84.9404L50.2598 84.8193L44.4043 79.1113C43.7088 78.4334 44.025 77.2834 44.9121 77.0195L45.0967 76.9795L53.1895 75.8037C54.0291 75.6817 54.7622 75.1792 55.1807 74.4482L55.2598 74.2988L58.8789 66.9658Z",
                    stroke: "#182370",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter2_d_5305_1624)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.2065 32.634C78.9402 31.1475 81.0598 31.1475 81.7935 32.634L85.4125 39.9669C85.7038 40.5572 86.267 40.9664 86.9184 41.061L95.0108 42.2369C96.6512 42.4753 97.3063 44.4912 96.1192 45.6483L90.2635 51.3562C89.7921 51.8157 89.577 52.4777 89.6883 53.1265L91.0707 61.1862C91.3509 62.82 89.636 64.066 88.1688 63.2946L80.9307 59.4893C80.348 59.183 79.652 59.183 79.0693 59.4893L71.8312 63.2946C70.364 64.066 68.6491 62.82 68.9293 61.1862L70.3117 53.1265C70.423 52.4777 70.2079 51.8157 69.7365 51.3562L63.8808 45.6483C62.6937 44.4912 63.3488 42.4753 64.9892 42.2369L73.0816 41.061C73.733 40.9664 74.2962 40.5572 74.5875 39.9669L78.2065 32.634Z",
                    fill: "url(#paint3_linear_5305_1624)"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.8789 32.9658C79.3088 32.0948 80.5004 32.0404 81.0254 32.8027L81.1211 32.9658L84.7402 40.2988C85.1158 41.0598 85.8198 41.6015 86.6445 41.7734L86.8105 41.8037L94.9033 42.9795C95.8642 43.1194 96.284 44.235 95.7217 44.9697L95.5957 45.1113L89.7402 50.8193C89.1326 51.4116 88.8346 52.2485 88.9258 53.0859L88.9492 53.2529L90.3311 61.3135C90.4949 62.2705 89.5639 63.0146 88.6914 62.707L88.5176 62.6309L81.2793 58.8252C80.5283 58.4305 79.6401 58.4055 78.8721 58.751L78.7207 58.8252L71.4824 62.6309C70.6226 63.0829 69.6269 62.4264 69.6504 61.501L69.6689 61.3135L71.0508 53.2529C71.1941 52.4165 70.9431 51.5642 70.377 50.9404L70.2598 50.8193L64.4043 45.1113C63.7088 44.4334 64.025 43.2834 64.9121 43.0195L65.0967 42.9795L73.1895 41.8037C74.0291 41.6817 74.7622 41.1792 75.1807 40.4482L75.2598 40.2988L78.8789 32.9658Z",
                    stroke: "#182370",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter3_d_5305_1624)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M98.2065 66.634C98.9402 65.1475 101.06 65.1475 101.793 66.634L105.413 73.9669C105.704 74.5572 106.267 74.9664 106.918 75.061L115.011 76.2369C116.651 76.4753 117.306 78.4912 116.119 79.6483L110.264 85.3562C109.792 85.8157 109.577 86.4777 109.688 87.1265L111.071 95.1862C111.351 96.82 109.636 98.066 108.169 97.2946L100.931 93.4893C100.348 93.183 99.652 93.183 99.0693 93.4893L91.8312 97.2946C90.364 98.066 88.6491 96.82 88.9293 95.1862L90.3117 87.1265C90.423 86.4777 90.2079 85.8157 89.7365 85.3562L83.8808 79.6483C82.6937 78.4912 83.3488 76.4753 84.9892 76.2369L93.0816 75.061C93.733 74.9664 94.2962 74.5572 94.5875 73.9669L98.2065 66.634Z",
                    fill: "#FBCF26"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M98.2065 66.634C98.9402 65.1475 101.06 65.1475 101.793 66.634L105.413 73.9669C105.704 74.5572 106.267 74.9664 106.918 75.061L115.011 76.2369C116.651 76.4753 117.306 78.4912 116.119 79.6483L110.264 85.3562C109.792 85.8157 109.577 86.4777 109.688 87.1265L111.071 95.1862C111.351 96.82 109.636 98.066 108.169 97.2946L100.931 93.4893C100.348 93.183 99.652 93.183 99.0693 93.4893L91.8312 97.2946C90.364 98.066 88.6491 96.82 88.9293 95.1862L90.3117 87.1265C90.423 86.4777 90.2079 85.8157 89.7365 85.3562L83.8808 79.6483C82.6937 78.4912 83.3488 76.4753 84.9892 76.2369L93.0816 75.061C93.733 74.9664 94.2962 74.5572 94.5875 73.9669L98.2065 66.634Z",
                    fill: "url(#paint4_linear_5305_1624)"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M98.8789 66.9658C99.3088 66.0948 100.5 66.0404 101.025 66.8027L101.121 66.9658L104.74 74.2988C105.116 75.0598 105.82 75.6015 106.645 75.7734L106.811 75.8037L114.903 76.9795C115.864 77.1194 116.284 78.235 115.722 78.9697L115.596 79.1113L109.74 84.8193C109.133 85.4116 108.835 86.2485 108.926 87.0859L108.949 87.2529L110.331 95.3135C110.495 96.2705 109.564 97.0146 108.691 96.707L108.518 96.6309L101.279 92.8252C100.528 92.4305 99.6401 92.4055 98.8721 92.751L98.7207 92.8252L91.4824 96.6309C90.6226 97.0829 89.6269 96.4264 89.6504 95.501L89.6689 95.3135L91.0508 87.2529C91.1941 86.4165 90.9431 85.5642 90.377 84.9404L90.2598 84.8193L84.4043 79.1113C83.7088 78.4334 84.025 77.2834 84.9121 77.0195L85.0967 76.9795L93.1895 75.8037C94.0291 75.6817 94.7622 75.1792 95.1807 74.4482L95.2598 74.2988L98.8789 66.9658Z",
                    stroke: "#182370",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter0_i_5305_1624",
                    x: "23.5",
                    y: "15.5",
                    width: "116",
                    height: "132.156",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "4",
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow_5305_1624"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter1_d_5305_1624",
                    x: "38.2747",
                    y: "59.5191",
                    width: "45.4507",
                    height: "44.0096",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1624"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1624",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter2_d_5305_1624",
                    x: "58.2747",
                    y: "25.5191",
                    width: "45.4507",
                    height: "44.0096",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1624"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1624",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter3_d_5305_1624",
                    x: "78.2747",
                    y: "59.5191",
                    width: "45.4507",
                    height: "44.0096",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1624"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1624",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint0_linear_5305_1624",
                    x1: "10",
                    y1: "0",
                    x2: "168.978",
                    y2: "141.565",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#586EC3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#0C1779"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint1_linear_5305_1624",
                    x1: "25",
                    y1: "17",
                    x2: "149.688",
                    y2: "124.865",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#2E4898"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#122181"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint2_linear_5305_1624",
                    x1: "89.0909",
                    y1: "103",
                    x2: "49.2857",
                    y2: "49.3625",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#4E64D5"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#8199E6"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint3_linear_5305_1624",
                    x1: "109.091",
                    y1: "69",
                    x2: "69.2857",
                    y2: "15.3625",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#4E64D5"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#8199E6"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint4_linear_5305_1624",
                    x1: "129.091",
                    y1: "103",
                    x2: "89.2857",
                    y2: "49.3625",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#4E64D5"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#8199E6"
                        })
                    ]
                })
            ]
        })
    ]
}), "Achievement12Icon");
var $d5e5990c5e386fec$export$2e2bcd8739ae039 = $d5e5990c5e386fec$var$Achievement12Icon;

});

parcelRegister("6N9X3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da1248998085888b$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");
const $da1248998085888b$var$Achievement13Icon = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M77.214 6.70423C78.7659 5.19787 81.2341 5.19787 82.786 6.70423L107.397 30.5925C107.871 31.0535 108.453 31.3894 109.09 31.5701L142.083 40.9394C144.163 41.5302 145.398 43.6677 144.869 45.7649L136.486 79.0224C136.325 79.6641 136.325 80.3359 136.486 80.9776L144.869 114.235C145.398 116.332 144.163 118.47 142.083 119.061L109.09 128.43C108.453 128.611 107.871 128.947 107.397 129.407L82.786 153.296C81.2341 154.802 78.7659 154.802 77.214 153.296L52.6034 129.407C52.1286 128.947 51.5468 128.611 50.9101 128.43L17.917 119.061C15.8365 118.47 14.6024 116.332 15.131 114.235L23.5136 80.9776C23.6753 80.3359 23.6753 79.6641 23.5136 79.0224L15.131 45.7649C14.6024 43.6677 15.8365 41.5302 17.917 40.9394L50.9101 31.5701C51.5468 31.3894 52.1286 31.0535 52.6034 30.5925L77.214 6.70423Z",
            fill: "url(#paint0_linear_5305_1646)"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M77.214 6.70423C78.7659 5.19787 81.2341 5.19787 82.786 6.70423L107.397 30.5925C107.871 31.0535 108.453 31.3894 109.09 31.5701L142.083 40.9394C144.163 41.5302 145.398 43.6677 144.869 45.7649L136.486 79.0224C136.325 79.6641 136.325 80.3359 136.486 80.9776L144.869 114.235C145.398 116.332 144.163 118.47 142.083 119.061L109.09 128.43C108.453 128.611 107.871 128.947 107.397 129.407L82.786 153.296C81.2341 154.802 78.7659 154.802 77.214 153.296L52.6034 129.407C52.1286 128.947 51.5468 128.611 50.9101 128.43L17.917 119.061C15.8365 118.47 14.6024 116.332 15.131 114.235L23.5136 80.9776C23.6753 80.3359 23.6753 79.6641 23.5136 79.0224L15.131 45.7649C14.6024 43.6677 15.8365 41.5302 17.917 40.9394L50.9101 31.5701C51.5468 31.3894 52.1286 31.0535 52.6034 30.5925L77.214 6.70423Z",
            fill: "url(#paint1_linear_5305_1646)"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("g", {
            filter: "url(#filter0_i_5305_1646)",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M77.214 22.7042C78.7659 21.1979 81.2341 21.1979 82.786 22.7042L101.477 40.8463C101.951 41.3072 102.533 41.6431 103.17 41.8239L128.227 48.9394C130.307 49.5302 131.541 51.6677 131.013 53.7649L124.646 79.0224C124.485 79.6641 124.485 80.3359 124.646 80.9776L131.013 106.235C131.541 108.332 130.307 110.47 128.227 111.061L103.17 118.176C102.533 118.357 101.951 118.693 101.477 119.154L82.786 137.296C81.2341 138.802 78.7659 138.802 77.214 137.296L58.5234 119.154C58.0486 118.693 57.4668 118.357 56.8301 118.176L31.7734 111.061C29.6929 110.47 28.4588 108.332 28.9874 106.235L35.3536 80.9776C35.5153 80.3359 35.5153 79.6641 35.3536 79.0224L28.9874 53.7649C28.4588 51.6677 29.6929 49.5302 31.7734 48.9394L56.8301 41.8239C57.4668 41.6431 58.0486 41.3072 58.5234 40.8463L77.214 22.7042Z",
                fill: "url(#paint2_linear_5305_1646)"
            })
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M78.2588 23.7803C79.1681 22.8978 80.5806 22.843 81.5527 23.6152L81.7412 23.7803L100.432 41.9229C101.003 42.4774 101.687 42.9005 102.436 43.1641L102.76 43.2666L127.816 50.3818C129.035 50.728 129.79 51.9243 129.607 53.1523L129.558 53.3984L123.192 78.6553C122.998 79.4274 122.973 80.2317 123.119 81.0117L123.192 81.3447L129.558 106.602C129.867 107.83 129.209 109.081 128.055 109.537L127.816 109.617V109.618L102.76 116.733C101.994 116.951 101.286 117.331 100.684 117.848L100.432 118.077L81.7412 136.22C80.8319 137.102 79.4194 137.157 78.4473 136.385L78.2588 136.22L59.5684 118.077C58.997 117.523 58.313 117.1 57.5645 116.836L57.2402 116.733L32.1836 109.618V109.617C30.9646 109.271 30.2099 108.076 30.3926 106.848L30.4424 106.602L36.8076 81.3447C37.0022 80.5726 37.0268 79.7683 36.8809 78.9883L36.8076 78.6562L30.4424 53.3984C30.1327 52.1698 30.7906 50.9189 31.9453 50.4629L32.1836 50.3818L57.2402 43.2666C58.0059 43.0491 58.714 42.6686 59.3164 42.1523L59.5684 41.9229L78.2588 23.7803Z",
            stroke: "#AEAEAE",
            strokeWidth: "3"
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter1_d_5305_1646)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M80 48L100 64V80V96L80 112L60 96V80V64L80 48Z",
                    fill: "url(#paint3_linear_5305_1646)"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M80 48L100 64M80 48L60 64M80 48V64M80 112L60 96M80 112L100 96M80 112V96M100 64V80V96M100 64L89.0909 72.4211M60 64V80V96M60 64L70.9091 72.4211M60 96L70.9091 87.5789M100 96L89.0909 87.5789M70.9091 72.4211V87.5789M70.9091 72.4211L80 64M70.9091 87.5789L80 96M89.0909 72.4211V87.5789M89.0909 72.4211L80 64M89.0909 87.5789L80 96",
                    stroke: "#E9E6E4",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter0_i_5305_1646",
                    x: "28.8652",
                    y: "21.5745",
                    width: "106.27",
                    height: "120.851",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "4",
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow_5305_1646"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter1_d_5305_1646",
                    x: "59.25",
                    y: "43.0396",
                    width: "49.5",
                    height: "73.9209",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1646"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1646",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint0_linear_5305_1646",
                    x1: "4",
                    y1: "4",
                    x2: "156",
                    y2: "159.8",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#FBE865"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#F1A718"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint1_linear_5305_1646",
                    x1: "4",
                    y1: "4",
                    x2: "156",
                    y2: "159.8",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#FFF7EF"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#D5D4D3"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint2_linear_5305_1646",
                    x1: "20",
                    y1: "20",
                    x2: "140",
                    y2: "140",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#F4F4F4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#CEC5C0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint3_linear_5305_1646",
                    x1: "109.091",
                    y1: "112",
                    x2: "43.5184",
                    y2: "56.7756",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#3A50C1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#8199E6"
                        })
                    ]
                })
            ]
        })
    ]
}), "Achievement13Icon");
var $da1248998085888b$export$2e2bcd8739ae039 = $da1248998085888b$var$Achievement13Icon;

});

parcelRegister("k3Qux", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94b5c2acd917df81$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");
const $94b5c2acd917df81$var$Achievement14Icon = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M76.9233 7.7031C78.5228 5.77803 81.4772 5.77803 83.0767 7.7031L97.7427 25.3553C98.6649 26.4652 100.113 26.9924 101.533 26.7349L124.115 22.6397C126.577 22.1931 128.841 24.0922 128.828 26.595L128.717 49.5446C128.71 50.9875 129.48 52.3225 130.733 53.0379L150.664 64.4159C152.838 65.6567 153.351 68.5663 151.733 70.4757L136.895 87.9843C135.963 89.0851 135.695 90.6031 136.195 91.9567L144.149 113.484C145.017 115.832 143.539 118.39 141.073 118.813L118.452 122.688C117.03 122.932 115.849 123.922 115.362 125.281L107.618 146.885C106.774 149.241 103.997 150.251 101.836 148.989L82.0168 137.418C80.7707 136.69 79.2293 136.69 77.9832 137.418L58.1641 148.989C56.0028 150.251 53.2264 149.241 52.3819 146.885L44.6377 125.281C44.1508 123.922 42.97 122.932 41.5477 122.688L18.9274 118.813C16.4605 118.39 14.9833 115.832 15.8507 113.484L23.805 91.9567C24.3051 90.6031 24.0374 89.0851 23.1045 87.9843L8.2672 70.4757C6.64911 68.5663 7.16215 65.6567 9.33571 64.4159L29.2665 53.0379C30.5197 52.3225 31.2904 50.9875 31.2834 49.5446L31.1716 26.595C31.1594 24.0922 33.4227 22.1931 35.8853 22.6397L58.4668 26.7349C59.8867 26.9924 61.3351 26.4652 62.2573 25.3553L76.9233 7.7031Z",
            fill: "url(#paint0_linear_5311_1690)"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("g", {
            filter: "url(#filter0_i_5311_1690)",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M76.9233 23.7031C78.5228 21.778 81.4772 21.778 83.0767 23.7031L93.6932 36.4813C94.6154 37.5912 96.0638 38.1184 97.4837 37.8609L113.83 34.8964C116.293 34.4498 118.556 36.3489 118.544 38.8517L118.463 55.4646C118.456 56.9076 119.227 58.2425 120.48 58.9579L134.907 67.1942C137.081 68.4351 137.594 71.3447 135.976 73.2541L125.235 85.9283C124.302 87.0291 124.035 88.5471 124.535 89.9007L130.293 105.484C131.16 107.832 129.683 110.39 127.216 110.813L110.842 113.618C109.419 113.862 108.239 114.852 107.752 116.211L102.146 131.85C101.301 134.206 98.5249 135.216 96.3636 133.954L82.0168 125.578C80.7707 124.85 79.2293 124.85 77.9832 125.578L63.6364 133.954C61.4751 135.216 58.6988 134.206 57.8542 131.85L52.2483 116.211C51.7614 114.852 50.5806 113.862 49.1583 113.618L32.7838 110.813C30.3169 110.39 28.8397 107.832 29.7071 105.484L35.4651 89.9007C35.9652 88.5471 35.6976 87.0291 34.7646 85.9283L24.0241 73.2541C22.406 71.3447 22.9191 68.4351 25.0926 67.1942L39.5203 58.9579C40.7734 58.2425 41.5441 56.9076 41.5371 55.4646L41.4562 38.8517C41.444 36.3489 43.7073 34.4498 46.1699 34.8964L62.5163 37.8609C63.9362 38.1184 65.3846 37.5912 66.3068 36.4813L76.9233 23.7031Z",
                fill: "url(#paint1_linear_5311_1690)"
            })
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M78.0771 24.6621C79.0457 23.4964 80.8091 23.4596 81.8271 24.5527L81.9229 24.6621L92.5391 37.4395C93.7277 38.8701 95.5528 39.597 97.3848 39.3906L97.751 39.3369L114.098 36.3721C115.589 36.1016 116.963 37.2076 117.04 38.6992L117.044 38.8447L116.963 55.457C116.954 57.3171 117.885 59.047 119.421 60.0664L119.736 60.2607L134.164 68.4971C135.48 69.2485 135.822 70.9787 134.923 72.1709L134.831 72.2842L124.091 84.958C122.888 86.3772 122.49 88.3009 123.012 90.0693L123.128 90.4209L128.886 106.004C129.411 107.425 128.561 108.97 127.105 109.306L126.963 109.334L110.589 112.14C108.756 112.454 107.214 113.671 106.477 115.36L106.34 115.705L100.733 131.344C100.222 132.77 98.5782 133.407 97.248 132.729L97.1201 132.659L82.7734 124.282C81.1671 123.344 79.2037 123.286 77.5527 124.106L77.2266 124.282L62.8799 132.659C61.5712 133.423 59.9021 132.854 59.3193 131.479L59.2666 131.344L53.6602 115.705C53.0325 113.954 51.5666 112.646 49.7744 112.214L49.4111 112.14L33.0371 109.334C31.5435 109.078 30.63 107.57 31.0674 106.142L31.1143 106.004L36.8721 90.4209C37.5168 88.6761 37.2335 86.7324 36.1387 85.249L35.9092 84.958L25.1689 72.2842C24.1892 71.1281 24.4589 69.3851 25.7119 68.5723L25.8359 68.4971L40.2637 60.2607C41.8791 59.3385 42.9117 57.6673 43.0264 55.8271L43.0371 55.457L42.9561 38.8447C42.9487 37.3292 44.2763 36.1676 45.7588 36.3506L45.9023 36.3721L62.249 39.3369C64.0792 39.6687 65.9442 39.0526 67.2148 37.7168L67.4609 37.4395L78.0771 24.6621Z",
            stroke: "url(#paint2_linear_5311_1690)",
            strokeWidth: "3"
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter1_d_5311_1690)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M80 48L100 64V80V96L80 112L60 96V80V64L80 48Z",
                    fill: "url(#paint3_linear_5311_1690)"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M80 48L100 64M80 48L60 64M80 48V64M80 112L60 96M80 112L100 96M80 112V96M100 64V80V96M100 64L89.0909 72.4211M60 64V80V96M60 64L70.9091 72.4211M60 96L70.9091 87.5789M100 96L89.0909 87.5789M70.9091 72.4211V87.5789M70.9091 72.4211L80 64M70.9091 87.5789L80 96M89.0909 72.4211V87.5789M89.0909 72.4211L80 64M89.0909 87.5789L80 96",
                    stroke: "#EB9D19",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter0_i_5311_1690",
                    x: "23.0752",
                    y: "22.2593",
                    width: "117.85",
                    height: "116.242",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "4",
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow_5311_1690"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter1_d_5311_1690",
                    x: "59.25",
                    y: "43.0396",
                    width: "49.5",
                    height: "73.9209",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5311_1690"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5311_1690",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint0_linear_5311_1690",
                    x1: "4",
                    y1: "4",
                    x2: "156",
                    y2: "159.8",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#FBE865"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#F1A718"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint1_linear_5311_1690",
                    x1: "20",
                    y1: "20",
                    x2: "140",
                    y2: "140",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#FFE33D"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#FFB62B"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint2_linear_5311_1690",
                    x1: "140",
                    y1: "140",
                    x2: "38.6727",
                    y2: "5.89158",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#E69614"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#E69614",
                            stopOpacity: "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint3_linear_5311_1690",
                    x1: "109.091",
                    y1: "112",
                    x2: "43.5184",
                    y2: "56.7756",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#3A50C1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#8199E6"
                        })
                    ]
                })
            ]
        })
    ]
}), "Achievement14Icon");
var $94b5c2acd917df81$export$2e2bcd8739ae039 = $94b5c2acd917df81$var$Achievement14Icon;

});

parcelRegister("gKTrX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $887656f6e93849d5$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");
const $887656f6e93849d5$var$Achievement1Icon = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
            cx: "80",
            cy: "80",
            r: "80",
            fill: "url(#paint0_linear_5305_1562)"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("g", {
            filter: "url(#filter0_i_5305_1562)",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "80",
                cy: "80",
                r: "67",
                fill: "url(#paint1_linear_5305_1562)"
            })
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
            cx: "80",
            cy: "80",
            r: "67",
            stroke: "#842F10",
            strokeWidth: "3"
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter1_d_5305_1562)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.2065 51.634C78.9402 50.1475 81.0598 50.1475 81.7935 51.634L88.9392 66.1128C89.2305 66.7031 89.7937 67.1123 90.4451 67.2069L106.423 69.5287C108.064 69.7671 108.719 71.783 107.532 72.9401L95.9698 84.2103C95.4985 84.6698 95.2834 85.3318 95.3946 85.9806L98.1241 101.894C98.4043 103.528 96.6894 104.774 95.2222 104.003L80.9307 96.4893C80.348 96.183 79.652 96.183 79.0693 96.4893L64.7778 104.003C63.3106 104.774 61.5957 103.528 61.8759 101.894L64.6054 85.9806C64.7166 85.3318 64.5015 84.6698 64.0302 84.2103L52.4681 72.9401C51.2811 71.783 51.9361 69.7671 53.5765 69.5287L69.5549 67.2069C70.2063 67.1123 70.7695 66.7031 71.0608 66.1128L78.2065 51.634Z",
                    fill: "#F29441"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.8789 51.9658C79.3088 51.0948 80.5004 51.0404 81.0254 51.8027L81.1211 51.9658L88.2666 66.4443C88.6422 67.2053 89.3463 67.7479 90.1709 67.9199L90.3369 67.9492L106.315 70.2705C107.277 70.4102 107.697 71.5269 107.134 72.2617L107.009 72.4033L95.4463 83.6729C94.8386 84.2652 94.5405 85.1029 94.6318 85.9404L94.6553 86.1074L97.3848 102.021C97.5488 102.979 96.6169 103.723 95.7441 103.415L95.5713 103.339L81.2793 95.8252C80.5283 95.4305 79.6401 95.4055 78.8721 95.751L78.7207 95.8252L64.4287 103.339C63.5691 103.791 62.5738 103.135 62.5967 102.21L62.6152 102.021L65.3447 86.1074C65.4882 85.2711 65.2369 84.4188 64.6709 83.7949L64.5537 83.6729L52.9912 72.4033C52.2959 71.7255 52.6123 70.5756 53.499 70.3115L53.6846 70.2705L69.6631 67.9492C70.5028 67.8271 71.236 67.3249 71.6543 66.5938L71.7334 66.4443L78.8789 51.9658Z",
                    stroke: "#842F10",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter0_i_5305_1562",
                    x: "11.5",
                    y: "11.5",
                    width: "141",
                    height: "141",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "4",
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow_5305_1562"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter1_d_5305_1562",
                    x: "46.8619",
                    y: "44.5191",
                    width: "68.2761",
                    height: "65.7179",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1562"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1562",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint0_linear_5305_1562",
                    x1: "0",
                    y1: "0",
                    x2: "160",
                    y2: "164",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#FFAB4D"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#CC621A"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint1_linear_5305_1562",
                    x1: "13",
                    y1: "13",
                    x2: "147",
                    y2: "147",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#D06615"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#A04109"
                        })
                    ]
                })
            ]
        })
    ]
}), "Achievement1Icon");
var $887656f6e93849d5$export$2e2bcd8739ae039 = $887656f6e93849d5$var$Achievement1Icon;

});

parcelRegister("48XwK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8d3eeab6c8b1722$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");
const $c8d3eeab6c8b1722$var$Achievement2Icon = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
            cx: "80",
            cy: "80",
            r: "80",
            fill: "url(#paint0_linear_5305_1567)"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("g", {
            filter: "url(#filter0_i_5305_1567)",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "80",
                cy: "80",
                r: "67",
                fill: "url(#paint1_linear_5305_1567)"
            })
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
            cx: "80",
            cy: "80",
            r: "67",
            stroke: "#842F10",
            strokeWidth: "3"
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter1_d_5305_1567)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M53.2065 58.634C53.9402 57.1475 56.0598 57.1475 56.7935 58.634L61.882 68.9444C62.1733 69.5347 62.7364 69.9438 63.3879 70.0385L74.7661 71.6918C76.4065 71.9302 77.0615 73.9462 75.8745 75.1032L67.6411 83.1288C67.1698 83.5883 66.9547 84.2503 67.066 84.899L69.0096 96.2313C69.2898 97.8651 67.5749 99.111 66.1077 98.3397L55.9307 92.9893C55.348 92.683 54.652 92.683 54.0693 92.9893L43.8923 98.3397C42.4251 99.111 40.7102 97.8651 40.9904 96.2313L42.934 84.899C43.0453 84.2503 42.8302 83.5883 42.3589 83.1288L34.1255 75.1032C32.9385 73.9462 33.5935 71.9302 35.2339 71.6918L46.6122 70.0385C47.2636 69.9438 47.8267 69.5347 48.118 68.9444L53.2065 58.634Z",
                    fill: "#F29441"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M53.8789 58.9658C54.3088 58.0948 55.5004 58.0404 56.0254 58.8027L56.1211 58.9658L61.209 69.2764C61.5845 70.0372 62.2888 70.5789 63.1133 70.751L63.2803 70.7803L74.6582 72.4336C75.6195 72.5733 76.0393 73.69 75.4766 74.4248L75.3506 74.5664L67.1172 82.5918C66.5097 83.1841 66.2125 84.0211 66.3037 84.8584L66.3271 85.0254L68.2705 96.3584C68.4344 97.3156 67.5025 98.06 66.6299 97.752L66.457 97.6758L56.2793 92.3252C55.5283 91.9305 54.6401 91.9055 53.8721 92.251L53.7207 92.3252L43.543 97.6758C42.6834 98.1274 41.688 97.4717 41.7109 96.5469L41.7295 96.3584L43.6729 85.0254C43.8162 84.1891 43.566 83.3367 43 82.7129L42.8828 82.5918L34.6494 74.5664C33.9538 73.8884 34.2699 72.7383 35.1572 72.4746L35.3418 72.4336L46.7197 70.7803C47.5593 70.6583 48.2925 70.1567 48.7109 69.4258L48.791 69.2764L53.8789 58.9658Z",
                    stroke: "#842F10",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter2_d_5305_1567)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M103.207 58.634C103.94 57.1475 106.06 57.1475 106.793 58.634L111.882 68.9444C112.173 69.5347 112.736 69.9438 113.388 70.0385L124.766 71.6918C126.407 71.9302 127.062 73.9462 125.875 75.1032L117.641 83.1288C117.17 83.5883 116.955 84.2503 117.066 84.899L119.01 96.2313C119.29 97.8651 117.575 99.111 116.108 98.3397L105.931 92.9893C105.348 92.683 104.652 92.683 104.069 92.9893L93.8923 98.3397C92.4251 99.111 90.7102 97.8651 90.9904 96.2313L92.934 84.899C93.0453 84.2503 92.8302 83.5883 92.3589 83.1288L84.1255 75.1032C82.9385 73.9462 83.5935 71.9302 85.2339 71.6918L96.6122 70.0385C97.2636 69.9438 97.8267 69.5347 98.118 68.9444L103.207 58.634Z",
                    fill: "#F29441"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M103.879 58.9658C104.309 58.0948 105.5 58.0404 106.025 58.8027L106.121 58.9658L111.209 69.2764C111.584 70.0372 112.289 70.5789 113.113 70.751L113.28 70.7803L124.658 72.4336C125.619 72.5733 126.039 73.69 125.477 74.4248L125.351 74.5664L117.117 82.5918C116.51 83.1841 116.213 84.0211 116.304 84.8584L116.327 85.0254L118.271 96.3584C118.434 97.3156 117.503 98.06 116.63 97.752L116.457 97.6758L106.279 92.3252C105.528 91.9305 104.64 91.9055 103.872 92.251L103.721 92.3252L93.543 97.6758C92.6834 98.1274 91.688 97.4717 91.7109 96.5469L91.7295 96.3584L93.6729 85.0254C93.8162 84.1891 93.566 83.3367 93 82.7129L92.8828 82.5918L84.6494 74.5664C83.9538 73.8884 84.2699 72.7383 85.1572 72.4746L85.3418 72.4336L96.7197 70.7803C97.5593 70.6583 98.2925 70.1567 98.7109 69.4258L98.791 69.2764L103.879 58.9658Z",
                    stroke: "#842F10",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter0_i_5305_1567",
                    x: "11.5",
                    y: "11.5",
                    width: "141",
                    height: "141",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "4",
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow_5305_1567"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter1_d_5305_1567",
                    x: "28.5193",
                    y: "51.5191",
                    width: "54.9614",
                    height: "53.0547",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1567"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1567",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter2_d_5305_1567",
                    x: "78.5193",
                    y: "51.5191",
                    width: "54.9614",
                    height: "53.0547",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1567"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1567",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint0_linear_5305_1567",
                    x1: "0",
                    y1: "0",
                    x2: "160",
                    y2: "164",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#FFAB4D"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#CC621A"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint1_linear_5305_1567",
                    x1: "13",
                    y1: "13",
                    x2: "147",
                    y2: "147",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#D06615"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#A04109"
                        })
                    ]
                })
            ]
        })
    ]
}), "Achievement2Icon");
var $c8d3eeab6c8b1722$export$2e2bcd8739ae039 = $c8d3eeab6c8b1722$var$Achievement2Icon;

});

parcelRegister("86YkO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54e3879deb11ea87$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");
const $54e3879deb11ea87$var$Achievement3Icon = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
            cx: "80",
            cy: "80",
            r: "80",
            fill: "url(#paint0_linear_5305_1573)"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("g", {
            filter: "url(#filter0_i_5305_1573)",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "80",
                cy: "80",
                r: "67",
                fill: "url(#paint1_linear_5305_1573)"
            })
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
            cx: "80",
            cy: "80",
            r: "67",
            stroke: "#842F10",
            strokeWidth: "3"
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter1_d_5305_1573)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M53.2065 75.634C53.9402 74.1475 56.0598 74.1475 56.7935 75.634L61.882 85.9444C62.1733 86.5347 62.7364 86.9438 63.3879 87.0385L74.7661 88.6918C76.4065 88.9302 77.0615 90.9462 75.8745 92.1032L67.6411 100.129C67.1698 100.588 66.9547 101.25 67.066 101.899L69.0096 113.231C69.2898 114.865 67.5749 116.111 66.1077 115.34L55.9307 109.989C55.348 109.683 54.652 109.683 54.0693 109.989L43.8923 115.34C42.4251 116.111 40.7102 114.865 40.9904 113.231L42.934 101.899C43.0453 101.25 42.8302 100.588 42.3589 100.129L34.1255 92.1032C32.9385 90.9462 33.5935 88.9302 35.2339 88.6918L46.6122 87.0385C47.2636 86.9438 47.8267 86.5347 48.118 85.9444L53.2065 75.634Z",
                    fill: "#F29441"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M53.8789 75.9658C54.3088 75.0948 55.5004 75.0404 56.0254 75.8027L56.1211 75.9658L61.209 86.2764C61.5845 87.0372 62.2888 87.5789 63.1133 87.751L63.2803 87.7803L74.6582 89.4336C75.6195 89.5733 76.0393 90.69 75.4766 91.4248L75.3506 91.5664L67.1172 99.5918C66.5097 100.184 66.2125 101.021 66.3037 101.858L66.3271 102.025L68.2705 113.358C68.4344 114.316 67.5025 115.06 66.6299 114.752L66.457 114.676L56.2793 109.325C55.5283 108.931 54.6401 108.906 53.8721 109.251L53.7207 109.325L43.543 114.676C42.6834 115.127 41.688 114.472 41.7109 113.547L41.7295 113.358L43.6729 102.025C43.8162 101.189 43.566 100.337 43 99.7129L42.8828 99.5918L34.6494 91.5664C33.9538 90.8884 34.2699 89.7383 35.1572 89.4746L35.3418 89.4336L46.7197 87.7803C47.5593 87.6583 48.2925 87.1567 48.7109 86.4258L48.791 86.2764L53.8789 75.9658Z",
                    stroke: "#842F10",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter2_d_5305_1573)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.2065 33.634C78.9402 32.1475 81.0598 32.1475 81.7935 33.634L86.882 43.9444C87.1733 44.5347 87.7364 44.9438 88.3879 45.0385L99.7661 46.6918C101.407 46.9302 102.062 48.9462 100.875 50.1032L92.6411 58.1288C92.1698 58.5883 91.9547 59.2503 92.066 59.899L94.0096 71.2313C94.2898 72.8651 92.5749 74.111 91.1077 73.3397L80.9307 67.9893C80.348 67.683 79.652 67.683 79.0693 67.9893L68.8923 73.3397C67.4251 74.111 65.7102 72.8651 65.9904 71.2313L67.934 59.899C68.0453 59.2503 67.8302 58.5883 67.3589 58.1288L59.1255 50.1032C57.9385 48.9462 58.5935 46.9302 60.2339 46.6918L71.6122 45.0385C72.2636 44.9438 72.8267 44.5347 73.118 43.9444L78.2065 33.634Z",
                    fill: "#F29441"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.8789 33.9658C79.3088 33.0948 80.5004 33.0404 81.0254 33.8027L81.1211 33.9658L86.209 44.2764C86.5845 45.0372 87.2888 45.5789 88.1133 45.751L88.2803 45.7803L99.6582 47.4336C100.619 47.5733 101.039 48.69 100.477 49.4248L100.351 49.5664L92.1172 57.5918C91.5097 58.1841 91.2125 59.0211 91.3037 59.8584L91.3271 60.0254L93.2705 71.3584C93.4344 72.3156 92.5025 73.06 91.6299 72.752L91.457 72.6758L81.2793 67.3252C80.5283 66.9305 79.6401 66.9055 78.8721 67.251L78.7207 67.3252L68.543 72.6758C67.6834 73.1274 66.688 72.4717 66.7109 71.5469L66.7295 71.3584L68.6729 60.0254C68.8162 59.1891 68.566 58.3367 68 57.7129L67.8828 57.5918L59.6494 49.5664C58.9538 48.8884 59.2699 47.7383 60.1572 47.4746L60.3418 47.4336L71.7197 45.7803C72.5593 45.6583 73.2925 45.1567 73.7109 44.4258L73.791 44.2764L78.8789 33.9658Z",
                    stroke: "#842F10",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter3_d_5305_1573)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M103.207 75.634C103.94 74.1475 106.06 74.1475 106.793 75.634L111.882 85.9444C112.173 86.5347 112.736 86.9438 113.388 87.0385L124.766 88.6918C126.407 88.9302 127.062 90.9462 125.875 92.1032L117.641 100.129C117.17 100.588 116.955 101.25 117.066 101.899L119.01 113.231C119.29 114.865 117.575 116.111 116.108 115.34L105.931 109.989C105.348 109.683 104.652 109.683 104.069 109.989L93.8923 115.34C92.4251 116.111 90.7102 114.865 90.9904 113.231L92.934 101.899C93.0453 101.25 92.8302 100.588 92.3589 100.129L84.1255 92.1032C82.9385 90.9462 83.5935 88.9302 85.2339 88.6918L96.6122 87.0385C97.2636 86.9438 97.8267 86.5347 98.118 85.9444L103.207 75.634Z",
                    fill: "#F29441"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M103.879 75.9658C104.309 75.0948 105.5 75.0404 106.025 75.8027L106.121 75.9658L111.209 86.2764C111.584 87.0372 112.289 87.5789 113.113 87.751L113.28 87.7803L124.658 89.4336C125.619 89.5733 126.039 90.69 125.477 91.4248L125.351 91.5664L117.117 99.5918C116.51 100.184 116.213 101.021 116.304 101.858L116.327 102.025L118.271 113.358C118.434 114.316 117.503 115.06 116.63 114.752L116.457 114.676L106.279 109.325C105.528 108.931 104.64 108.906 103.872 109.251L103.721 109.325L93.543 114.676C92.6834 115.127 91.688 114.472 91.7109 113.547L91.7295 113.358L93.6729 102.025C93.8162 101.189 93.566 100.337 93 99.7129L92.8828 99.5918L84.6494 91.5664C83.9538 90.8884 84.2699 89.7383 85.1572 89.4746L85.3418 89.4336L96.7197 87.7803C97.5593 87.6583 98.2925 87.1567 98.7109 86.4258L98.791 86.2764L103.879 75.9658Z",
                    stroke: "#842F10",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter0_i_5305_1573",
                    x: "11.5",
                    y: "11.5",
                    width: "141",
                    height: "141",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "4",
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow_5305_1573"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter1_d_5305_1573",
                    x: "28.5193",
                    y: "68.5191",
                    width: "54.9614",
                    height: "53.0547",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1573"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1573",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter2_d_5305_1573",
                    x: "53.5193",
                    y: "26.5191",
                    width: "54.9614",
                    height: "53.0547",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1573"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1573",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter3_d_5305_1573",
                    x: "78.5193",
                    y: "68.5191",
                    width: "54.9614",
                    height: "53.0547",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1573"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1573",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint0_linear_5305_1573",
                    x1: "0",
                    y1: "0",
                    x2: "160",
                    y2: "164",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#FFAB4D"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#CC621A"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint1_linear_5305_1573",
                    x1: "13",
                    y1: "13",
                    x2: "147",
                    y2: "147",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#D06615"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#A04109"
                        })
                    ]
                })
            ]
        })
    ]
}), "Achievement3Icon");
var $54e3879deb11ea87$export$2e2bcd8739ae039 = $54e3879deb11ea87$var$Achievement3Icon;

});

parcelRegister("e9JfK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bec26f22e9caad78$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");
const $bec26f22e9caad78$var$Achievement4Icon = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M10 87.8743V24.5169C10 21.8422 11.7704 19.4905 14.3407 18.7509L77.8407 0.477491C78.9249 0.165494 80.0751 0.165493 81.1593 0.477489L144.659 18.7509C147.23 19.4905 149 21.8422 149 24.5169V87.8744C149 102.989 141.575 117.14 129.136 125.728L82.9091 157.646C80.8572 159.063 78.1428 159.063 76.0909 157.646L29.8636 125.728C17.4254 117.14 10 102.989 10 87.8743Z",
            fill: "url(#paint0_linear_5305_1580)"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("g", {
            filter: "url(#filter0_i_5305_1580)",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M24 81.4965V36.5146C24 33.841 25.769 31.49 28.338 30.7494L77.838 16.4791C78.9239 16.1661 80.0761 16.1661 81.162 16.4791L130.662 30.7494C133.231 31.49 135 33.841 135 36.5146V81.4965C135 96.5978 127.588 110.737 115.168 119.328L82.9133 141.639C80.8595 143.06 78.1405 143.06 76.0867 141.639L43.8317 119.328C31.4121 110.737 24 96.5978 24 81.4965Z",
                fill: "url(#paint1_linear_5305_1580)"
            })
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M24 81.4965V36.5146C24 33.841 25.769 31.49 28.338 30.7494L77.838 16.4791C78.9239 16.1661 80.0761 16.1661 81.162 16.4791L130.662 30.7494C133.231 31.49 135 33.841 135 36.5146V81.4965C135 96.5978 127.588 110.737 115.168 119.328L82.9133 141.639C80.8595 143.06 78.1405 143.06 76.0867 141.639L43.8317 119.328C31.4121 110.737 24 96.5978 24 81.4965Z",
            stroke: "#AEAEAE",
            strokeWidth: "3"
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter1_d_5305_1580)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.2065 47.634C78.9402 46.1475 81.0598 46.1475 81.7935 47.634L88.9392 62.1128C89.2305 62.7031 89.7937 63.1123 90.4451 63.2069L106.423 65.5287C108.064 65.7671 108.719 67.783 107.532 68.9401L95.9698 80.2103C95.4985 80.6698 95.2834 81.3318 95.3946 81.9806L98.1241 97.8944C98.4043 99.5282 96.6894 100.774 95.2222 100.003L80.9307 92.4893C80.348 92.183 79.652 92.183 79.0693 92.4893L64.7778 100.003C63.3106 100.774 61.5957 99.5282 61.8759 97.8944L64.6054 81.9806C64.7166 81.3318 64.5015 80.6698 64.0302 80.2103L52.4681 68.9401C51.2811 67.783 51.9361 65.7671 53.5765 65.5287L69.5549 63.2069C70.2063 63.1123 70.7695 62.7031 71.0608 62.1128L78.2065 47.634Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.8789 47.9658C79.3088 47.0948 80.5004 47.0404 81.0254 47.8027L81.1211 47.9658L88.2666 62.4443C88.6422 63.2053 89.3463 63.7479 90.1709 63.9199L90.3369 63.9492L106.315 66.2705C107.277 66.4102 107.697 67.5269 107.134 68.2617L107.009 68.4033L95.4463 79.6729C94.8386 80.2652 94.5405 81.1029 94.6318 81.9404L94.6553 82.1074L97.3848 98.0215C97.5488 98.9788 96.6169 99.7233 95.7441 99.415L95.5713 99.3389L81.2793 91.8252C80.5283 91.4305 79.6401 91.4055 78.8721 91.751L78.7207 91.8252L64.4287 99.3389C63.5691 99.7907 62.5738 99.1349 62.5967 98.21L62.6152 98.0215L65.3447 82.1074C65.4882 81.2711 65.2369 80.4188 64.6709 79.7949L64.5537 79.6729L52.9912 68.4033C52.2959 67.7255 52.6123 66.5756 53.499 66.3115L53.6846 66.2705L69.6631 63.9492C70.5028 63.8271 71.236 63.3249 71.6543 62.5938L71.7334 62.4443L78.8789 47.9658Z",
                    stroke: "#AEAEAE",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter0_i_5305_1580",
                    x: "22.5",
                    y: "14.7444",
                    width: "118",
                    height: "133.46",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "4",
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow_5305_1580"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter1_d_5305_1580",
                    x: "46.8619",
                    y: "40.5191",
                    width: "68.2761",
                    height: "65.7179",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1580"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1580",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint0_linear_5305_1580",
                    x1: "10",
                    y1: "0",
                    x2: "168.978",
                    y2: "141.565",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#FFF7EF"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#D5D4D3"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint1_linear_5305_1580",
                    x1: "24",
                    y1: "16",
                    x2: "150.711",
                    y2: "125.882",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#F4F4F4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#CDCDCA"
                        })
                    ]
                })
            ]
        })
    ]
}), "Achievement4Icon");
var $bec26f22e9caad78$export$2e2bcd8739ae039 = $bec26f22e9caad78$var$Achievement4Icon;

});

parcelRegister("5pDJL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caa964f7bcb87e1a$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");
const $caa964f7bcb87e1a$var$Achievement5Icon = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M10 87.8743V24.5169C10 21.8422 11.7704 19.4905 14.3407 18.7509L77.2876 0.636655C78.7332 0.220659 80.2668 0.220657 81.7124 0.636653L144.659 18.7509C147.23 19.4905 149 21.8422 149 24.5169V87.8744C149 102.989 141.575 117.14 129.136 125.728L82.9091 157.646C80.8572 159.063 78.1428 159.063 76.0909 157.646L29.8636 125.728C17.4254 117.14 10 102.989 10 87.8743Z",
            fill: "url(#paint0_linear_5305_1592)"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("g", {
            filter: "url(#filter0_i_5305_1592)",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M24 81.4965V36.5146C24 33.841 25.769 31.49 28.338 30.7494L77.838 16.4791C78.9239 16.1661 80.0761 16.1661 81.162 16.4791L130.662 30.7494C133.231 31.49 135 33.841 135 36.5146V81.4965C135 96.5978 127.588 110.737 115.168 119.328L82.9133 141.639C80.8595 143.06 78.1405 143.06 76.0867 141.639L43.8317 119.328C31.4121 110.737 24 96.5978 24 81.4965Z",
                fill: "url(#paint1_linear_5305_1592)"
            })
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M24 81.4965V36.5146C24 33.841 25.769 31.49 28.338 30.7494L77.838 16.4791C78.9239 16.1661 80.0761 16.1661 81.162 16.4791L130.662 30.7494C133.231 31.49 135 33.841 135 36.5146V81.4965C135 96.5978 127.588 110.737 115.168 119.328L82.9133 141.639C80.8595 143.06 78.1405 143.06 76.0867 141.639L43.8317 119.328C31.4121 110.737 24 96.5978 24 81.4965Z",
            stroke: "#AEAEAE",
            strokeWidth: "3"
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter1_d_5305_1592)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M58.2065 59.634C58.9402 58.1475 61.0598 58.1475 61.7935 59.634L65.4125 66.9669C65.7038 67.5572 66.267 67.9664 66.9184 68.061L75.0108 69.2369C76.6512 69.4753 77.3063 71.4912 76.1192 72.6483L70.2635 78.3562C69.7921 78.8157 69.577 79.4777 69.6883 80.1265L71.0707 88.1862C71.3509 89.82 69.636 91.066 68.1688 90.2946L60.9307 86.4893C60.348 86.183 59.652 86.183 59.0693 86.4893L51.8312 90.2946C50.364 91.066 48.6491 89.82 48.9293 88.1862L50.3117 80.1265C50.423 79.4777 50.2079 78.8157 49.7365 78.3562L43.8808 72.6483C42.6937 71.4912 43.3488 69.4753 44.9892 69.2369L53.0816 68.061C53.733 67.9664 54.2962 67.5572 54.5875 66.9669L58.2065 59.634Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M58.8789 59.9658C59.3088 59.0948 60.5004 59.0404 61.0254 59.8027L61.1211 59.9658L64.7402 67.2988C65.1158 68.0598 65.8198 68.6015 66.6445 68.7734L66.8105 68.8037L74.9033 69.9795C75.8642 70.1194 76.284 71.235 75.7217 71.9697L75.5957 72.1113L69.7402 77.8193C69.1326 78.4116 68.8346 79.2485 68.9258 80.0859L68.9492 80.2529L70.3311 88.3135C70.4949 89.2705 69.5639 90.0146 68.6914 89.707L68.5176 89.6309L61.2793 85.8252C60.5283 85.4305 59.6401 85.4055 58.8721 85.751L58.7207 85.8252L51.4824 89.6309C50.6226 90.0829 49.6269 89.4264 49.6504 88.501L49.6689 88.3135L51.0508 80.2529C51.1941 79.4165 50.9431 78.5642 50.377 77.9404L50.2598 77.8193L44.4043 72.1113C43.7088 71.4334 44.025 70.2834 44.9121 70.0195L45.0967 69.9795L53.1895 68.8037C54.0291 68.6817 54.7622 68.1792 55.1807 67.4482L55.2598 67.2988L58.8789 59.9658Z",
                    stroke: "#AEAEAE",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter2_d_5305_1592)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M98.2065 59.634C98.9402 58.1475 101.06 58.1475 101.793 59.634L105.413 66.9669C105.704 67.5572 106.267 67.9664 106.918 68.061L115.011 69.2369C116.651 69.4753 117.306 71.4912 116.119 72.6483L110.264 78.3562C109.792 78.8157 109.577 79.4777 109.688 80.1265L111.071 88.1862C111.351 89.82 109.636 91.066 108.169 90.2946L100.931 86.4893C100.348 86.183 99.652 86.183 99.0693 86.4893L91.8312 90.2946C90.364 91.066 88.6491 89.82 88.9293 88.1862L90.3117 80.1265C90.423 79.4777 90.2079 78.8157 89.7365 78.3562L83.8808 72.6483C82.6937 71.4912 83.3488 69.4753 84.9892 69.2369L93.0816 68.061C93.733 67.9664 94.2962 67.5572 94.5875 66.9669L98.2065 59.634Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M98.8789 59.9658C99.3088 59.0948 100.5 59.0404 101.025 59.8027L101.121 59.9658L104.74 67.2988C105.116 68.0598 105.82 68.6015 106.645 68.7734L106.811 68.8037L114.903 69.9795C115.864 70.1194 116.284 71.235 115.722 71.9697L115.596 72.1113L109.74 77.8193C109.133 78.4116 108.835 79.2485 108.926 80.0859L108.949 80.2529L110.331 88.3135C110.495 89.2705 109.564 90.0146 108.691 89.707L108.518 89.6309L101.279 85.8252C100.528 85.4305 99.6401 85.4055 98.8721 85.751L98.7207 85.8252L91.4824 89.6309C90.6226 90.0829 89.6269 89.4264 89.6504 88.501L89.6689 88.3135L91.0508 80.2529C91.1941 79.4165 90.9431 78.5642 90.377 77.9404L90.2598 77.8193L84.4043 72.1113C83.7088 71.4334 84.025 70.2834 84.9121 70.0195L85.0967 69.9795L93.1895 68.8037C94.0291 68.6817 94.7622 68.1792 95.1807 67.4482L95.2598 67.2988L98.8789 59.9658Z",
                    stroke: "#AEAEAE",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter0_i_5305_1592",
                    x: "22.5",
                    y: "14.7444",
                    width: "118",
                    height: "133.46",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "4",
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow_5305_1592"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter1_d_5305_1592",
                    x: "38.2747",
                    y: "52.5191",
                    width: "45.4507",
                    height: "44.0096",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1592"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1592",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter2_d_5305_1592",
                    x: "78.2747",
                    y: "52.5191",
                    width: "45.4507",
                    height: "44.0096",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1592"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1592",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint0_linear_5305_1592",
                    x1: "10",
                    y1: "0",
                    x2: "168.978",
                    y2: "141.565",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#FFF7EF"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#D5D4D3"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint1_linear_5305_1592",
                    x1: "24",
                    y1: "16",
                    x2: "150.711",
                    y2: "125.882",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#F4F4F4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#CDCDCA"
                        })
                    ]
                })
            ]
        })
    ]
}), "Achievement5Icon");
var $caa964f7bcb87e1a$export$2e2bcd8739ae039 = $caa964f7bcb87e1a$var$Achievement5Icon;

});

parcelRegister("tNNO5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $588c5b0b7edaa3f9$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");
const $588c5b0b7edaa3f9$var$Achievement6Icon = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M10 87.8743V24.5169C10 21.8422 11.7704 19.4905 14.3407 18.7509L77.8407 0.477491C78.9249 0.165494 80.0751 0.165493 81.1593 0.477489L144.659 18.7509C147.23 19.4905 149 21.8422 149 24.5169V87.8744C149 102.989 141.575 117.14 129.136 125.728L82.9091 157.646C80.8572 159.063 78.1428 159.063 76.0909 157.646L29.8636 125.728C17.4254 117.14 10 102.989 10 87.8743Z",
            fill: "url(#paint0_linear_5305_1612)"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("g", {
            filter: "url(#filter0_i_5305_1612)",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M24 81.4965V36.5146C24 33.841 25.769 31.49 28.338 30.7494L77.838 16.4791C78.9239 16.1661 80.0761 16.1661 81.162 16.4791L130.662 30.7494C133.231 31.49 135 33.841 135 36.5146V81.4965C135 96.5978 127.588 110.737 115.168 119.328L82.9133 141.639C80.8595 143.06 78.1405 143.06 76.0867 141.639L43.8317 119.328C31.4121 110.737 24 96.5978 24 81.4965Z",
                fill: "url(#paint1_linear_5305_1612)"
            })
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M24 81.4965V36.5146C24 33.841 25.769 31.49 28.338 30.7494L77.838 16.4791C78.9239 16.1661 80.0761 16.1661 81.162 16.4791L130.662 30.7494C133.231 31.49 135 33.841 135 36.5146V81.4965C135 96.5978 127.588 110.737 115.168 119.328L82.9133 141.639C80.8595 143.06 78.1405 143.06 76.0867 141.639L43.8317 119.328C31.4121 110.737 24 96.5978 24 81.4965Z",
            stroke: "#AEAEAE",
            strokeWidth: "3"
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter1_d_5305_1612)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M58.2065 71.634C58.9402 70.1475 61.0598 70.1475 61.7935 71.634L65.4125 78.9669C65.7038 79.5572 66.267 79.9664 66.9184 80.061L75.0108 81.2369C76.6512 81.4753 77.3063 83.4912 76.1192 84.6483L70.2635 90.3562C69.7921 90.8157 69.577 91.4777 69.6883 92.1265L71.0707 100.186C71.3509 101.82 69.636 103.066 68.1688 102.295L60.9307 98.4893C60.348 98.183 59.652 98.183 59.0693 98.4893L51.8312 102.295C50.364 103.066 48.6491 101.82 48.9293 100.186L50.3117 92.1265C50.423 91.4777 50.2079 90.8157 49.7365 90.3562L43.8808 84.6483C42.6937 83.4912 43.3488 81.4753 44.9892 81.2369L53.0816 80.061C53.733 79.9664 54.2962 79.5572 54.5875 78.9669L58.2065 71.634Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M58.8789 71.9658C59.3088 71.0948 60.5004 71.0404 61.0254 71.8027L61.1211 71.9658L64.7402 79.2988C65.1158 80.0598 65.8198 80.6015 66.6445 80.7734L66.8105 80.8037L74.9033 81.9795C75.8642 82.1194 76.284 83.235 75.7217 83.9697L75.5957 84.1113L69.7402 89.8193C69.1326 90.4116 68.8346 91.2485 68.9258 92.0859L68.9492 92.2529L70.3311 100.313C70.4949 101.27 69.5639 102.015 68.6914 101.707L68.5176 101.631L61.2793 97.8252C60.5283 97.4305 59.6401 97.4055 58.8721 97.751L58.7207 97.8252L51.4824 101.631C50.6226 102.083 49.6269 101.426 49.6504 100.501L49.6689 100.313L51.0508 92.2529C51.1941 91.4165 50.9431 90.5642 50.377 89.9404L50.2598 89.8193L44.4043 84.1113C43.7088 83.4334 44.025 82.2834 44.9121 82.0195L45.0967 81.9795L53.1895 80.8037C54.0291 80.6817 54.7622 80.1792 55.1807 79.4482L55.2598 79.2988L58.8789 71.9658Z",
                    stroke: "#AEAEAE",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter2_d_5305_1612)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.2065 37.634C78.9402 36.1475 81.0598 36.1475 81.7935 37.634L85.4125 44.9669C85.7038 45.5572 86.267 45.9664 86.9184 46.061L95.0108 47.2369C96.6512 47.4753 97.3063 49.4912 96.1192 50.6483L90.2635 56.3562C89.7921 56.8157 89.577 57.4777 89.6883 58.1265L91.0707 66.1862C91.3509 67.82 89.636 69.066 88.1688 68.2946L80.9307 64.4893C80.348 64.183 79.652 64.183 79.0693 64.4893L71.8312 68.2946C70.364 69.066 68.6491 67.82 68.9293 66.1862L70.3117 58.1265C70.423 57.4777 70.2079 56.8157 69.7365 56.3562L63.8808 50.6483C62.6937 49.4912 63.3488 47.4753 64.9892 47.2369L73.0816 46.061C73.733 45.9664 74.2962 45.5572 74.5875 44.9669L78.2065 37.634Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.8789 37.9658C79.3088 37.0948 80.5004 37.0404 81.0254 37.8027L81.1211 37.9658L84.7402 45.2988C85.1158 46.0598 85.8198 46.6015 86.6445 46.7734L86.8105 46.8037L94.9033 47.9795C95.8642 48.1194 96.284 49.235 95.7217 49.9697L95.5957 50.1113L89.7402 55.8193C89.1326 56.4116 88.8346 57.2485 88.9258 58.0859L88.9492 58.2529L90.3311 66.3135C90.4949 67.2705 89.5639 68.0146 88.6914 67.707L88.5176 67.6309L81.2793 63.8252C80.5283 63.4305 79.6401 63.4055 78.8721 63.751L78.7207 63.8252L71.4824 67.6309C70.6226 68.0829 69.6269 67.4264 69.6504 66.501L69.6689 66.3135L71.0508 58.2529C71.1941 57.4165 70.9431 56.5642 70.377 55.9404L70.2598 55.8193L64.4043 50.1113C63.7088 49.4334 64.025 48.2834 64.9121 48.0195L65.0967 47.9795L73.1895 46.8037C74.0291 46.6817 74.7622 46.1792 75.1807 45.4482L75.2598 45.2988L78.8789 37.9658Z",
                    stroke: "#AEAEAE",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter3_d_5305_1612)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M98.2065 71.634C98.9402 70.1475 101.06 70.1475 101.793 71.634L105.413 78.9669C105.704 79.5572 106.267 79.9664 106.918 80.061L115.011 81.2369C116.651 81.4753 117.306 83.4912 116.119 84.6483L110.264 90.3562C109.792 90.8157 109.577 91.4777 109.688 92.1265L111.071 100.186C111.351 101.82 109.636 103.066 108.169 102.295L100.931 98.4893C100.348 98.183 99.652 98.183 99.0693 98.4893L91.8312 102.295C90.364 103.066 88.6491 101.82 88.9293 100.186L90.3117 92.1265C90.423 91.4777 90.2079 90.8157 89.7365 90.3562L83.8808 84.6483C82.6937 83.4912 83.3488 81.4753 84.9892 81.2369L93.0816 80.061C93.733 79.9664 94.2962 79.5572 94.5875 78.9669L98.2065 71.634Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M98.8789 71.9658C99.3088 71.0948 100.5 71.0404 101.025 71.8027L101.121 71.9658L104.74 79.2988C105.116 80.0598 105.82 80.6015 106.645 80.7734L106.811 80.8037L114.903 81.9795C115.864 82.1194 116.284 83.235 115.722 83.9697L115.596 84.1113L109.74 89.8193C109.133 90.4116 108.835 91.2485 108.926 92.0859L108.949 92.2529L110.331 100.313C110.495 101.27 109.564 102.015 108.691 101.707L108.518 101.631L101.279 97.8252C100.528 97.4305 99.6401 97.4055 98.8721 97.751L98.7207 97.8252L91.4824 101.631C90.6226 102.083 89.6269 101.426 89.6504 100.501L89.6689 100.313L91.0508 92.2529C91.1941 91.4165 90.9431 90.5642 90.377 89.9404L90.2598 89.8193L84.4043 84.1113C83.7088 83.4334 84.025 82.2834 84.9121 82.0195L85.0967 81.9795L93.1895 80.8037C94.0291 80.6817 94.7622 80.1792 95.1807 79.4482L95.2598 79.2988L98.8789 71.9658Z",
                    stroke: "#AEAEAE",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter0_i_5305_1612",
                    x: "22.5",
                    y: "14.7444",
                    width: "118",
                    height: "133.46",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "4",
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow_5305_1612"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter1_d_5305_1612",
                    x: "38.2747",
                    y: "64.5191",
                    width: "45.4507",
                    height: "44.0096",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1612"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1612",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter2_d_5305_1612",
                    x: "58.2747",
                    y: "30.5191",
                    width: "45.4507",
                    height: "44.0096",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1612"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1612",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter3_d_5305_1612",
                    x: "78.2747",
                    y: "64.5191",
                    width: "45.4507",
                    height: "44.0096",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1612"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1612",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint0_linear_5305_1612",
                    x1: "10",
                    y1: "0",
                    x2: "168.978",
                    y2: "141.565",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#FFF7EF"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#D5D4D3"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint1_linear_5305_1612",
                    x1: "24",
                    y1: "16",
                    x2: "150.711",
                    y2: "125.882",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#F4F4F4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#CDCDCA"
                        })
                    ]
                })
            ]
        })
    ]
}), "Achievement6Icon");
var $588c5b0b7edaa3f9$export$2e2bcd8739ae039 = $588c5b0b7edaa3f9$var$Achievement6Icon;

});

parcelRegister("cYpOd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4d9142d559b9213$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");
const $b4d9142d559b9213$var$Achievement7Icon = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M10 94.7326V26C10 22.6863 12.6863 20 16 20H43.3866C44.4434 20 45.4815 19.7209 46.3958 19.1908L76.5124 1.73197C78.3619 0.659779 80.6422 0.652688 82.4984 1.71335L113.117 19.2095C114.023 19.7275 115.049 20 116.093 20H143C146.314 20 149 22.6863 149 26V94.7326C149 111.552 139.821 127.03 125.062 135.097L82.3777 158.427C80.5844 159.407 78.4156 159.407 76.6223 158.427L33.9378 135.097C19.1794 127.03 10 111.552 10 94.7326Z",
            fill: "url(#paint0_linear_5305_1584)"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("g", {
            filter: "url(#filter0_i_5305_1584)",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M23 95.1528V37.25C23 33.9363 25.6863 31.25 29 31.25H50.3598C51.4336 31.25 52.4877 30.9618 53.4121 30.4156L76.5271 16.7567C78.3675 15.6692 80.6476 15.643 82.5125 16.688L107.133 30.4843C108.029 30.9863 109.039 31.25 110.066 31.25H130C133.314 31.25 136 33.9363 136 37.25V95.1528C136 106.856 129.611 117.625 119.341 123.236L82.3764 143.429C80.5838 144.408 78.4162 144.408 76.6236 143.429L39.659 123.236C29.3885 117.625 23 106.856 23 95.1528Z",
                fill: "url(#paint1_linear_5305_1584)"
            })
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M23 95.1528V37.25C23 33.9363 25.6863 31.25 29 31.25H50.3598C51.4336 31.25 52.4877 30.9618 53.4121 30.4156L76.5271 16.7567C78.3675 15.6692 80.6476 15.643 82.5125 16.688L107.133 30.4843C108.029 30.9863 109.039 31.25 110.066 31.25H130C133.314 31.25 136 33.9363 136 37.25V95.1528C136 106.856 129.611 117.625 119.341 123.236L82.3764 143.429C80.5838 144.408 78.4162 144.408 76.6236 143.429L39.659 123.236C29.3885 117.625 23 106.856 23 95.1528Z",
            stroke: "url(#paint2_linear_5305_1584)",
            strokeWidth: "3"
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter1_d_5305_1584)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.2065 47.634C78.9402 46.1475 81.0598 46.1475 81.7935 47.634L88.9392 62.1128C89.2305 62.7031 89.7937 63.1123 90.4451 63.2069L106.423 65.5287C108.064 65.7671 108.719 67.783 107.532 68.9401L95.9698 80.2103C95.4985 80.6698 95.2834 81.3318 95.3946 81.9806L98.1241 97.8944C98.4043 99.5282 96.6894 100.774 95.2222 100.003L80.9307 92.4893C80.348 92.183 79.652 92.183 79.0693 92.4893L64.7778 100.003C63.3106 100.774 61.5957 99.5282 61.8759 97.8944L64.6054 81.9806C64.7166 81.3318 64.5015 80.6698 64.0302 80.2103L52.4681 68.9401C51.2811 67.783 51.9361 65.7671 53.5765 65.5287L69.5549 63.2069C70.2063 63.1123 70.7695 62.7031 71.0608 62.1128L78.2065 47.634Z",
                    fill: "#F5E65F"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.8789 47.9658C79.3088 47.0948 80.5004 47.0404 81.0254 47.8027L81.1211 47.9658L88.2666 62.4443C88.6422 63.2053 89.3463 63.7479 90.1709 63.9199L90.3369 63.9492L106.315 66.2705C107.277 66.4102 107.697 67.5269 107.134 68.2617L107.009 68.4033L95.4463 79.6729C94.8386 80.2652 94.5405 81.1029 94.6318 81.9404L94.6553 82.1074L97.3848 98.0215C97.5488 98.9788 96.6169 99.7233 95.7441 99.415L95.5713 99.3389L81.2793 91.8252C80.5283 91.4305 79.6401 91.4055 78.8721 91.751L78.7207 91.8252L64.4287 99.3389C63.5691 99.7907 62.5738 99.1349 62.5967 98.21L62.6152 98.0215L65.3447 82.1074C65.4882 81.2711 65.2369 80.4188 64.6709 79.7949L64.5537 79.6729L52.9912 68.4033C52.2959 67.7255 52.6123 66.5756 53.499 66.3115L53.6846 66.2705L69.6631 63.9492C70.5028 63.8271 71.236 63.3249 71.6543 62.5938L71.7334 62.4443L78.8789 47.9658Z",
                    stroke: "#E69614",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter0_i_5305_1584",
                    x: "21.5",
                    y: "14.4223",
                    width: "120",
                    height: "135.241",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "4",
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow_5305_1584"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter1_d_5305_1584",
                    x: "46.8619",
                    y: "40.5191",
                    width: "68.2761",
                    height: "65.7178",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1584"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1584",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint0_linear_5305_1584",
                    x1: "10",
                    y1: "0",
                    x2: "168.978",
                    y2: "141.565",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#FBE865"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#F1A718"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint1_linear_5305_1584",
                    x1: "23",
                    y1: "15",
                    x2: "151.734",
                    y2: "126.899",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#FFE33D"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#E1980D"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint2_linear_5305_1584",
                    x1: "136",
                    y1: "145",
                    x2: "23",
                    y2: "15",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#E69614"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#E69614",
                            stopOpacity: "0"
                        })
                    ]
                })
            ]
        })
    ]
}), "Achievement7Icon");
var $b4d9142d559b9213$export$2e2bcd8739ae039 = $b4d9142d559b9213$var$Achievement7Icon;

});

parcelRegister("clg0Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eabf11e174e3e36c$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");
const $eabf11e174e3e36c$var$Achievement8Icon = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M10 94.7326V26C10 22.6863 12.6863 20 16 20H43.3866C44.4434 20 45.4815 19.7209 46.3958 19.1908L76.5124 1.73197C78.3619 0.659779 80.6422 0.652688 82.4984 1.71335L113.117 19.2095C114.023 19.7275 115.049 20 116.093 20H143C146.314 20 149 22.6863 149 26V94.7326C149 111.552 139.821 127.03 125.062 135.097L82.3777 158.427C80.5844 159.407 78.4156 159.407 76.6223 158.427L33.9378 135.097C19.1794 127.03 10 111.552 10 94.7326Z",
            fill: "url(#paint0_linear_5305_1597)"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("g", {
            filter: "url(#filter0_i_5305_1597)",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M23 95.1528V37.25C23 33.9363 25.6863 31.25 29 31.25H50.3598C51.4336 31.25 52.4877 30.9618 53.4121 30.4156L76.5271 16.7567C78.3675 15.6692 80.6476 15.643 82.5125 16.688L107.133 30.4843C108.029 30.9863 109.039 31.25 110.066 31.25H130C133.314 31.25 136 33.9363 136 37.25V95.1528C136 106.856 129.611 117.625 119.341 123.236L82.3764 143.429C80.5838 144.408 78.4162 144.408 76.6236 143.429L39.659 123.236C29.3885 117.625 23 106.856 23 95.1528Z",
                fill: "url(#paint1_linear_5305_1597)"
            })
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M23 95.1528V37.25C23 33.9363 25.6863 31.25 29 31.25H50.3598C51.4336 31.25 52.4877 30.9618 53.4121 30.4156L76.5271 16.7567C78.3675 15.6692 80.6476 15.643 82.5125 16.688L107.133 30.4843C108.029 30.9863 109.039 31.25 110.066 31.25H130C133.314 31.25 136 33.9363 136 37.25V95.1528C136 106.856 129.611 117.625 119.341 123.236L82.3764 143.429C80.5838 144.408 78.4162 144.408 76.6236 143.429L39.659 123.236C29.3885 117.625 23 106.856 23 95.1528Z",
            stroke: "url(#paint2_linear_5305_1597)",
            strokeWidth: "3"
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter1_d_5305_1597)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.2065 43.634C78.9402 42.1475 81.0598 42.1475 81.7935 43.634L85.4125 50.9669C85.7038 51.5572 86.267 51.9664 86.9184 52.061L95.0108 53.2369C96.6512 53.4753 97.3063 55.4912 96.1192 56.6483L90.2635 62.3562C89.7921 62.8157 89.577 63.4777 89.6883 64.1265L91.0707 72.1862C91.3509 73.82 89.636 75.066 88.1688 74.2946L80.9307 70.4893C80.348 70.183 79.652 70.183 79.0693 70.4893L71.8312 74.2946C70.364 75.066 68.6491 73.82 68.9293 72.1862L70.3117 64.1265C70.423 63.4777 70.2079 62.8157 69.7365 62.3562L63.8808 56.6483C62.6937 55.4912 63.3488 53.4753 64.9892 53.2369L73.0816 52.061C73.733 51.9664 74.2962 51.5572 74.5875 50.9669L78.2065 43.634Z",
                    fill: "#F5E65F"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.8789 43.9658C79.3088 43.0948 80.5004 43.0404 81.0254 43.8027L81.1211 43.9658L84.7402 51.2988C85.1158 52.0598 85.8198 52.6015 86.6445 52.7734L86.8105 52.8037L94.9033 53.9795C95.8642 54.1194 96.284 55.235 95.7217 55.9697L95.5957 56.1113L89.7402 61.8193C89.1326 62.4116 88.8346 63.2485 88.9258 64.0859L88.9492 64.2529L90.3311 72.3135C90.4949 73.2705 89.5639 74.0146 88.6914 73.707L88.5176 73.6309L81.2793 69.8252C80.5283 69.4305 79.6401 69.4055 78.8721 69.751L78.7207 69.8252L71.4824 73.6309C70.6226 74.0829 69.6269 73.4264 69.6504 72.501L69.6689 72.3135L71.0508 64.2529C71.1941 63.4165 70.9431 62.5642 70.377 61.9404L70.2598 61.8193L64.4043 56.1113C63.7088 55.4334 64.025 54.2834 64.9121 54.0195L65.0967 53.9795L73.1895 52.8037C74.0291 52.6817 74.7622 52.1792 75.1807 51.4482L75.2598 51.2988L78.8789 43.9658Z",
                    stroke: "#E69614",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter2_d_5305_1597)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.2065 83.634C78.9402 82.1475 81.0598 82.1475 81.7935 83.634L85.4125 90.9669C85.7038 91.5572 86.267 91.9664 86.9184 92.061L95.0108 93.2369C96.6512 93.4753 97.3063 95.4912 96.1192 96.6483L90.2635 102.356C89.7921 102.816 89.577 103.478 89.6883 104.126L91.0707 112.186C91.3509 113.82 89.636 115.066 88.1688 114.295L80.9307 110.489C80.348 110.183 79.652 110.183 79.0693 110.489L71.8312 114.295C70.364 115.066 68.6491 113.82 68.9293 112.186L70.3117 104.126C70.423 103.478 70.2079 102.816 69.7365 102.356L63.8808 96.6483C62.6937 95.4912 63.3488 93.4753 64.9892 93.2369L73.0816 92.061C73.733 91.9664 74.2962 91.5572 74.5875 90.9669L78.2065 83.634Z",
                    fill: "#F5E65F"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.8789 83.9658C79.3088 83.0948 80.5004 83.0404 81.0254 83.8027L81.1211 83.9658L84.7402 91.2988C85.1158 92.0598 85.8198 92.6015 86.6445 92.7734L86.8105 92.8037L94.9033 93.9795C95.8642 94.1194 96.284 95.235 95.7217 95.9697L95.5957 96.1113L89.7402 101.819C89.1326 102.412 88.8346 103.249 88.9258 104.086L88.9492 104.253L90.3311 112.313C90.4949 113.27 89.5639 114.015 88.6914 113.707L88.5176 113.631L81.2793 109.825C80.5283 109.431 79.6401 109.406 78.8721 109.751L78.7207 109.825L71.4824 113.631C70.6226 114.083 69.6269 113.426 69.6504 112.501L69.6689 112.313L71.0508 104.253C71.1941 103.417 70.9431 102.564 70.377 101.94L70.2598 101.819L64.4043 96.1113C63.7088 95.4334 64.025 94.2834 64.9121 94.0195L65.0967 93.9795L73.1895 92.8037C74.0291 92.6817 74.7622 92.1792 75.1807 91.4482L75.2598 91.2988L78.8789 83.9658Z",
                    stroke: "#E69614",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter0_i_5305_1597",
                    x: "21.5",
                    y: "14.4223",
                    width: "120",
                    height: "135.241",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "4",
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow_5305_1597"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter1_d_5305_1597",
                    x: "58.2747",
                    y: "36.5191",
                    width: "45.4507",
                    height: "44.0096",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1597"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1597",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter2_d_5305_1597",
                    x: "58.2747",
                    y: "76.5191",
                    width: "45.4507",
                    height: "44.0096",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1597"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1597",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint0_linear_5305_1597",
                    x1: "10",
                    y1: "0",
                    x2: "168.978",
                    y2: "141.565",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#FBE865"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#F1A718"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint1_linear_5305_1597",
                    x1: "23",
                    y1: "15",
                    x2: "151.734",
                    y2: "126.899",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#FFE33D"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#E1980D"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint2_linear_5305_1597",
                    x1: "136",
                    y1: "145",
                    x2: "23",
                    y2: "15",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#E69614"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#E69614",
                            stopOpacity: "0"
                        })
                    ]
                })
            ]
        })
    ]
}), "Achievement8Icon");
var $eabf11e174e3e36c$export$2e2bcd8739ae039 = $eabf11e174e3e36c$var$Achievement8Icon;

});

parcelRegister("4sFFp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7290729dd13dda2$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");
const $d7290729dd13dda2$var$Achievement9Icon = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M10 94.7326V26C10 22.6863 12.6863 20 16 20H43.3866C44.4434 20 45.4815 19.7209 46.3958 19.1908L76.5124 1.73197C78.3619 0.659779 80.6422 0.652688 82.4984 1.71335L113.117 19.2095C114.023 19.7275 115.049 20 116.093 20H143C146.314 20 149 22.6863 149 26V94.7326C149 111.552 139.821 127.03 125.062 135.097L82.3777 158.427C80.5844 159.407 78.4156 159.407 76.6223 158.427L33.9378 135.097C19.1794 127.03 10 111.552 10 94.7326Z",
            fill: "url(#paint0_linear_5305_1618)"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("g", {
            filter: "url(#filter0_i_5305_1618)",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M23 95.1528V37.25C23 33.9363 25.6863 31.25 29 31.25H50.3598C51.4336 31.25 52.4877 30.9618 53.4121 30.4156L76.5271 16.7567C78.3675 15.6692 80.6476 15.643 82.5125 16.688L107.133 30.4843C108.029 30.9863 109.039 31.25 110.066 31.25H130C133.314 31.25 136 33.9363 136 37.25V95.1528C136 106.856 129.611 117.625 119.341 123.236L82.3764 143.429C80.5838 144.408 78.4162 144.408 76.6236 143.429L39.659 123.236C29.3885 117.625 23 106.856 23 95.1528Z",
                fill: "url(#paint1_linear_5305_1618)"
            })
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M23 95.1528V37.25C23 33.9363 25.6863 31.25 29 31.25H50.3598C51.4336 31.25 52.4877 30.9618 53.4121 30.4156L76.5271 16.7567C78.3675 15.6692 80.6476 15.643 82.5125 16.688L107.133 30.4843C108.029 30.9863 109.039 31.25 110.066 31.25H130C133.314 31.25 136 33.9363 136 37.25V95.1528C136 106.856 129.611 117.625 119.341 123.236L82.3764 143.429C80.5838 144.408 78.4162 144.408 76.6236 143.429L39.659 123.236C29.3885 117.625 23 106.856 23 95.1528Z",
            stroke: "url(#paint2_linear_5305_1618)",
            strokeWidth: "3"
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter1_d_5305_1618)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M58.2065 75.634C58.9402 74.1475 61.0598 74.1475 61.7935 75.634L65.4125 82.9669C65.7038 83.5572 66.267 83.9664 66.9184 84.061L75.0108 85.2369C76.6512 85.4753 77.3063 87.4912 76.1192 88.6483L70.2635 94.3562C69.7921 94.8157 69.577 95.4777 69.6883 96.1265L71.0707 104.186C71.3509 105.82 69.636 107.066 68.1688 106.295L60.9307 102.489C60.348 102.183 59.652 102.183 59.0693 102.489L51.8312 106.295C50.364 107.066 48.6491 105.82 48.9293 104.186L50.3117 96.1265C50.423 95.4777 50.2079 94.8157 49.7365 94.3562L43.8808 88.6483C42.6937 87.4912 43.3488 85.4753 44.9892 85.2369L53.0816 84.061C53.733 83.9664 54.2962 83.5572 54.5875 82.9669L58.2065 75.634Z",
                    fill: "#F5E65F"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M58.8789 75.9658C59.3088 75.0948 60.5004 75.0404 61.0254 75.8027L61.1211 75.9658L64.7402 83.2988C65.1158 84.0598 65.8198 84.6015 66.6445 84.7734L66.8105 84.8037L74.9033 85.9795C75.8642 86.1194 76.284 87.235 75.7217 87.9697L75.5957 88.1113L69.7402 93.8193C69.1326 94.4116 68.8346 95.2485 68.9258 96.0859L68.9492 96.2529L70.3311 104.313C70.4949 105.27 69.5639 106.015 68.6914 105.707L68.5176 105.631L61.2793 101.825C60.5283 101.431 59.6401 101.406 58.8721 101.751L58.7207 101.825L51.4824 105.631C50.6226 106.083 49.6269 105.426 49.6504 104.501L49.6689 104.313L51.0508 96.2529C51.1941 95.4165 50.9431 94.5642 50.377 93.9404L50.2598 93.8193L44.4043 88.1113C43.7088 87.4334 44.025 86.2834 44.9121 86.0195L45.0967 85.9795L53.1895 84.8037C54.0291 84.6817 54.7622 84.1792 55.1807 83.4482L55.2598 83.2988L58.8789 75.9658Z",
                    stroke: "#E69614",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter2_d_5305_1618)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.2065 41.634C78.9402 40.1475 81.0598 40.1475 81.7935 41.634L85.4125 48.9669C85.7038 49.5572 86.267 49.9664 86.9184 50.061L95.0108 51.2369C96.6512 51.4753 97.3063 53.4912 96.1192 54.6483L90.2635 60.3562C89.7921 60.8157 89.577 61.4777 89.6883 62.1265L91.0707 70.1862C91.3509 71.82 89.636 73.066 88.1688 72.2946L80.9307 68.4893C80.348 68.183 79.652 68.183 79.0693 68.4893L71.8312 72.2946C70.364 73.066 68.6491 71.82 68.9293 70.1862L70.3117 62.1265C70.423 61.4777 70.2079 60.8157 69.7365 60.3562L63.8808 54.6483C62.6937 53.4912 63.3488 51.4753 64.9892 51.2369L73.0816 50.061C73.733 49.9664 74.2962 49.5572 74.5875 48.9669L78.2065 41.634Z",
                    fill: "#F5E65F"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M78.8789 41.9658C79.3088 41.0948 80.5004 41.0404 81.0254 41.8027L81.1211 41.9658L84.7402 49.2988C85.1158 50.0598 85.8198 50.6015 86.6445 50.7734L86.8105 50.8037L94.9033 51.9795C95.8642 52.1194 96.284 53.235 95.7217 53.9697L95.5957 54.1113L89.7402 59.8193C89.1326 60.4116 88.8346 61.2485 88.9258 62.0859L88.9492 62.2529L90.3311 70.3135C90.4949 71.2705 89.5639 72.0146 88.6914 71.707L88.5176 71.6309L81.2793 67.8252C80.5283 67.4305 79.6401 67.4055 78.8721 67.751L78.7207 67.8252L71.4824 71.6309C70.6226 72.0829 69.6269 71.4264 69.6504 70.501L69.6689 70.3135L71.0508 62.2529C71.1941 61.4165 70.9431 60.5642 70.377 59.9404L70.2598 59.8193L64.4043 54.1113C63.7088 53.4334 64.025 52.2834 64.9121 52.0195L65.0967 51.9795L73.1895 50.8037C74.0291 50.6817 74.7622 50.1792 75.1807 49.4482L75.2598 49.2988L78.8789 41.9658Z",
                    stroke: "#E69614",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            filter: "url(#filter3_d_5305_1618)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M98.2065 75.634C98.9402 74.1475 101.06 74.1475 101.793 75.634L105.413 82.9669C105.704 83.5572 106.267 83.9664 106.918 84.061L115.011 85.2369C116.651 85.4753 117.306 87.4912 116.119 88.6483L110.264 94.3562C109.792 94.8157 109.577 95.4777 109.688 96.1265L111.071 104.186C111.351 105.82 109.636 107.066 108.169 106.295L100.931 102.489C100.348 102.183 99.652 102.183 99.0693 102.489L91.8312 106.295C90.364 107.066 88.6491 105.82 88.9293 104.186L90.3117 96.1265C90.423 95.4777 90.2079 94.8157 89.7365 94.3562L83.8808 88.6483C82.6937 87.4912 83.3488 85.4753 84.9892 85.2369L93.0816 84.061C93.733 83.9664 94.2962 83.5572 94.5875 82.9669L98.2065 75.634Z",
                    fill: "#F5E65F"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M98.8789 75.9658C99.3088 75.0948 100.5 75.0404 101.025 75.8027L101.121 75.9658L104.74 83.2988C105.116 84.0598 105.82 84.6015 106.645 84.7734L106.811 84.8037L114.903 85.9795C115.864 86.1194 116.284 87.235 115.722 87.9697L115.596 88.1113L109.74 93.8193C109.133 94.4116 108.835 95.2485 108.926 96.0859L108.949 96.2529L110.331 104.313C110.495 105.27 109.564 106.015 108.691 105.707L108.518 105.631L101.279 101.825C100.528 101.431 99.6401 101.406 98.8721 101.751L98.7207 101.825L91.4824 105.631C90.6226 106.083 89.6269 105.426 89.6504 104.501L89.6689 104.313L91.0508 96.2529C91.1941 95.4165 90.9431 94.5642 90.377 93.9404L90.2598 93.8193L84.4043 88.1113C83.7088 87.4334 84.025 86.2834 84.9121 86.0195L85.0967 85.9795L93.1895 84.8037C94.0291 84.6817 94.7622 84.1792 95.1807 83.4482L95.2598 83.2988L98.8789 75.9658Z",
                    stroke: "#E69614",
                    strokeWidth: "1.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ih19M.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter0_i_5305_1618",
                    x: "21.5",
                    y: "14.4223",
                    width: "120",
                    height: "135.241",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "4",
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow_5305_1618"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter1_d_5305_1618",
                    x: "38.2747",
                    y: "68.5191",
                    width: "45.4507",
                    height: "44.0096",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1618"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1618",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter2_d_5305_1618",
                    x: "58.2747",
                    y: "34.5191",
                    width: "45.4507",
                    height: "44.0096",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1618"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1618",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("filter", {
                    id: "filter3_d_5305_1618",
                    x: "78.2747",
                    y: "68.5191",
                    width: "45.4507",
                    height: "44.0096",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feOffset", {
                            dx: "1"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_5305_1618"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_5305_1618",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint0_linear_5305_1618",
                    x1: "10",
                    y1: "0",
                    x2: "168.978",
                    y2: "141.565",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#FBE865"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#F1A718"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint1_linear_5305_1618",
                    x1: "23",
                    y1: "15",
                    x2: "151.734",
                    y2: "126.899",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#FFE33D"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#E1980D"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                    id: "paint2_linear_5305_1618",
                    x1: "136",
                    y1: "145",
                    x2: "23",
                    y2: "15",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            stopColor: "#E69614"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                            offset: "1",
                            stopColor: "#E69614",
                            stopOpacity: "0"
                        })
                    ]
                })
            ]
        })
    ]
}), "Achievement9Icon");
var $d7290729dd13dda2$export$2e2bcd8739ae039 = $d7290729dd13dda2$var$Achievement9Icon;

});


parcelRegister("2VZfN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f063decec2db43f0$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $W4f7l = parcelRequire("W4f7l");

var $lfvqn = parcelRequire("lfvqn");
function $f063decec2db43f0$var$passesConditional(condition) {
    if (condition) return condition();
    return true;
}
function $f063decec2db43f0$export$2e2bcd8739ae039({ flag: flag, source: source, enabled: enabled, default: defaultComponent, additionalCondition: additionalCondition }) {
    const { features: userFeatures } = (0, $W4f7l.useCurrentUser)();
    const trainerFeatures = (0, $lfvqn.useTrainerFeatures)();
    const features = source === "user_feature" ? userFeatures : trainerFeatures;
    const hasFeature = features.includes(flag);
    const passesChecks = $f063decec2db43f0$var$passesConditional(additionalCondition);
    const featureEnabled = passesChecks && hasFeature;
    return featureEnabled ? enabled : defaultComponent;
}

});

parcelRegister("a8DUk", function(module, exports) {

$parcel$export(module.exports, "PADEL_ASSESSMENT_FEATURE", function () { return $ce95a6051bac2a14$export$90bc7ad895117112; });
$parcel$export(module.exports, "duprAssessmentLabel", function () { return $ce95a6051bac2a14$export$f03e96a0b9c91a21; });
$parcel$export(module.exports, "SEGMENT_COLLECTIONS", function () { return $ce95a6051bac2a14$export$5b05ed8263fad978; });
$parcel$export(module.exports, "SEGMENT_COLLECTION_ITEM_PREFIX", function () { return $ce95a6051bac2a14$export$414e796d655ab1cf; });
$parcel$export(module.exports, "withSegmentCollections", function () { return $ce95a6051bac2a14$export$44c3ace7dee009b3; });
$parcel$export(module.exports, "mainWorkoutItems", function () { return $ce95a6051bac2a14$export$ecd09032cb30e0db; });
$parcel$export(module.exports, "personalItems", function () { return $ce95a6051bac2a14$export$58e6ca9d780f3dfa; });
$parcel$export(module.exports, "CLUB_IN_CLUB_FEATURE", function () { return (parcelRequire("kkvif")).CLUB_IN_CLUB_FEATURE; });

var $7WNdr = parcelRequire("7WNdr");

var $awHpO = parcelRequire("awHpO");

var $kkvif = parcelRequire("kkvif");
const $ce95a6051bac2a14$var$defaultFilters = {
    appId: null,
    position: false,
    providerIds: [],
    excludeProviderIds: [],
    tagIds: [],
    contentMode: "volleyOnly"
};
const $ce95a6051bac2a14$export$90bc7ad895117112 = "PADEL_ASSESSMENT";
function $ce95a6051bac2a14$export$f03e96a0b9c91a21({ duprRated: duprRated, duprLinked: duprLinked }) {
    if (duprRated) return "Retake your DUPR assessment";
    if (duprLinked) return "Get your official DUPR rating";
    return "Don't have a DUPR? Get Rated";
}
const $ce95a6051bac2a14$export$5b05ed8263fad978 = [
    {
        segmentKey: "club:padel-singles:exclusive",
        featureFlag: "PADEL_SINGLES_EXCLUSIVE",
        label: "Padel Singles Workouts",
        subtitle: "Singles Court Workouts",
        iconColor: "#3CE97C",
        sports: [
            "PADEL"
        ],
        placeAfter: "single_shots"
    }
];
const $ce95a6051bac2a14$export$414e796d655ab1cf = "segment:";
function $ce95a6051bac2a14$export$d658c6d84186a990(segmentKey) {
    return `/content/apps/workouts/segment/${encodeURIComponent(segmentKey)}`;
}
function $ce95a6051bac2a14$export$44c3ace7dee009b3(items, collections) {
    return items.flatMap((item)=>[
            item,
            ...collections.filter((c)=>c.placeAfter === item.name).map($ce95a6051bac2a14$export$1aa9e0fb4a639940)
        ]);
}
function $ce95a6051bac2a14$export$1aa9e0fb4a639940(collection) {
    return {
        name: `${$ce95a6051bac2a14$export$414e796d655ab1cf}${collection.segmentKey}`,
        label: collection.label,
        subtitle: collection.subtitle,
        iconColor: collection.iconColor,
        navUrl: $ce95a6051bac2a14$export$d658c6d84186a990(collection.segmentKey),
        featureFlag: collection.featureFlag,
        sports: collection.sports,
        order: 0
    };
}
const $ce95a6051bac2a14$export$ecd09032cb30e0db = [
    {
        // Base copy is the not-linked (3a) variant; NewHomeScreenLibrary
        // overrides the title for linked-but-unrated users and drops this item
        // entirely for users who have already submitted a rating. Availability
        // is the sport alone — no feature flag.
        name: "long_form_assessment",
        label: "Don't have a DUPR? Get Rated",
        subtitle: "Take the 10-minute assessment",
        iconColor: "#3CE97C",
        navUrl: "/journeys/long-form",
        order: 0,
        sports: [
            "PICKLEBALL"
        ],
        badge: "New"
    },
    {
        name: "performance_dashboard",
        label: "Know Your Game",
        subtitle: "Get an objective skills rating. Level up with Volley",
        iconColor: "#3b82f6",
        navUrl: "/performance",
        order: 0,
        sports: [
            "PICKLEBALL"
        ]
    },
    {
        // Unlike its DUPR twin above, this is gated on a feature as well as the
        // sport. The DUPR assessment is content that exists in every
        // environment; the padel journeys and workouts are authored per
        // environment, and a player who taps this before they land gets a 404
        // from the start endpoint. The flag is what says "padel content is live
        // here" — nothing else can, since the client can't see the journeys.
        name: "padel_assessment",
        label: "Know Your Padel Game",
        subtitle: "Take the 10-minute assessment",
        iconColor: "#3CE97C",
        navUrl: "/journeys/padel-assessment",
        featureFlag: $ce95a6051bac2a14$export$90bc7ad895117112,
        order: 0,
        sports: [
            "PADEL"
        ],
        badge: "New"
    },
    {
        // The lacrosse MVP's two workout types, both Lacrosse Module (app 18)
        // workouts, and the only rows lacrosse shows (see NewHomeScreenLibrary).
        // Lacrosse is only selectable with the LACROSSE feature anyway; the
        // flag here keeps the tiles to the same trial users if that ever
        // changes.
        name: "lacrosse_passing",
        label: "Player Workouts",
        subtitle: "Feeds to one to four players, from one spot",
        iconColor: "#3CE97C",
        navUrl: "/content/apps/workouts/lacrosse/passing",
        featureFlag: "LACROSSE",
        order: 0,
        sports: [
            "LACROSSE"
        ]
    },
    {
        name: "lacrosse_goalie",
        label: "Goalie Workouts",
        subtitle: "Shots on one cage or two",
        iconColor: "#3CE97C",
        navUrl: "/content/apps/workouts/lacrosse/goalie",
        featureFlag: "LACROSSE",
        order: 0,
        sports: [
            "LACROSSE"
        ]
    },
    {
        name: "performance_dashboard",
        label: "Know Your Game",
        subtitle: "Level up with Volley",
        iconColor: "#3b82f6",
        navUrl: "/journeys/assessments",
        featureFlag: "ASSESSMENT_DASHBOARD_V2",
        order: 0,
        sports: [
            "PLATFORM_TENNIS",
            "TENNIS",
            "PADEL"
        ]
    },
    {
        name: "quick_start",
        label: "Quick Start",
        subtitle: "Choose what to hit then press play",
        iconColor: "#4ade80",
        navUrl: "/content/apps/workouts/experimental/basic/play?tag=BASIC_FRONTCOURT_SIDE",
        order: 1
    },
    {
        name: "ai_workouts",
        label: "Interactive Workouts",
        subtitle: "Powered by Volley's camera system",
        iconColor: "#a855f7",
        navUrl: "/content/apps/workouts/search",
        setFilter: ()=>{
            (0, $awHpO.default).setFilter("search", {
                ...$ce95a6051bac2a14$var$defaultFilters,
                appId: (0, $7WNdr.AI_APP_IDS)
            });
        },
        order: 3
    },
    {
        name: "multi_level",
        label: "Multi Level",
        subtitle: "Train an area of your game at a chosen difficulty",
        iconColor: "#56D5EF",
        navUrl: "/content/apps/workouts/search",
        setFilter: ()=>{
            (0, $awHpO.default).setFilter("search", {
                ...$ce95a6051bac2a14$var$defaultFilters,
                appId: [
                    9
                ]
            });
        },
        order: 4
    },
    {
        name: "skill_building",
        label: "Skill Building",
        subtitle: "Sequenced workouts paired with pro instruction",
        iconColor: "#DA30D8",
        navUrl: "/content/apps/workouts/search",
        setFilter: ()=>{
            (0, $awHpO.default).setFilter("search", {
                ...$ce95a6051bac2a14$var$defaultFilters,
                appId: [
                    11,
                    18
                ]
            });
        },
        order: 5
    },
    {
        name: "single_shots",
        label: "Single Shots",
        subtitle: "Customize a specific shot for targeted reps",
        iconColor: "#EFA511",
        navUrl: "/content/apps/workouts/search",
        setFilter: ()=>{
            (0, $awHpO.default).setFilter("search", {
                ...$ce95a6051bac2a14$var$defaultFilters,
                appId: [
                    5
                ]
            });
        },
        order: 6
    },
    {
        name: "classes_at_location",
        label: "Classes",
        subtitle: "Guided classes from your home club",
        iconColor: "#3CE97C",
        navUrl: "/content/classes",
        featureFlag: "HOME_SCREEN_CLASSES",
        order: 7
    },
    {
        name: "all_workouts",
        label: "All Workouts",
        subtitle: "Explore the complete workout library",
        iconColor: "#ffffff",
        navUrl: "/content/apps/workouts/search",
        setFilter: ()=>{
            (0, $awHpO.default).setFilter("search", {
                ...$ce95a6051bac2a14$var$defaultFilters
            });
        },
        order: 8
    }
];
const $ce95a6051bac2a14$export$58e6ca9d780f3dfa = [
    {
        name: "my_workouts",
        label: "My Workouts (Create & Play)",
        navUrl: "/content/apps/workouts/user",
        setFilter: ()=>{
            (0, $awHpO.default).setFilter("user", {
                ...$ce95a6051bac2a14$var$defaultFilters,
                contentMode: "mixed"
            });
        }
    },
    {
        name: "favorites",
        label: "Favorites",
        navUrl: "/content/apps/workouts/favorites",
        setFilter: ()=>{
            (0, $awHpO.default).setFilter("favorites", {
                ...$ce95a6051bac2a14$var$defaultFilters,
                contentMode: "mixed"
            });
        }
    },
    {
        name: "recently_played",
        label: "Recently Played",
        navUrl: "/content/apps/workouts/recent"
    },
    {
        name: "pti_stats",
        label: "PTI Stats",
        navUrl: "/player-pti",
        sportFilter: [
            "PLATFORM_TENNIS"
        ]
    }
];

});
parcelRegister("7WNdr", function(module, exports) {

$parcel$export(module.exports, "AI_APP_IDS", function () { return $2465f8126c273909$export$58f7d3a8a6d9fb62; });
$parcel$export(module.exports, "getApp", function () { return $2465f8126c273909$export$f9962582c9e66d99; });
$parcel$export(module.exports, "findApp", function () { return $2465f8126c273909$export$db0e6e8ec5c7eab5; });
$parcel$export(module.exports, "getAppId", function () { return $2465f8126c273909$export$fb2283f4a44fb53; });

var $1lMle = parcelRequire("1lMle");

var $3WN4W = parcelRequire("3WN4W");

var $iBd1J = parcelRequire("iBd1J");
const $2465f8126c273909$var$eFn = (e)=>{
    (0, $1lMle.default).error(`Error lazy loading app component: ${e.message}`, undefined, e);
    return {
        default: (0, $3WN4W.default)
    };
};
const $2465f8126c273909$export$b608bf4d51a366da = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19
];
const $2465f8126c273909$export$58f7d3a8a6d9fb62 = [
    8,
    10,
    15,
    19
];









































































































const $2465f8126c273909$var$apps = {
    1: {
        id: 1,
        name: "Freeplay",
        loadEditComponent: ()=>(parcelRequire("cQRJu")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("cQRJu")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("jCIRP")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("jCIRP")).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    2: {
        id: 2,
        name: "Responsive Play",
        loadEditComponent: ()=>(parcelRequire("jwPLq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("jmzVO")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("RbZZ1")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    3: {
        id: 3,
        name: "Point-and-Click Lob App",
        loadEditComponent: ()=>(parcelRequire("jwPLq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("jSqFI")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("icN0f")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    4: {
        id: 4,
        name: "Curated Workout",
        loadEditComponent: ()=>(parcelRequire("k8bTo")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("dSJzN")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("gY6gC")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        loadIconComponent: ()=>(parcelRequire("epTiz")).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    5: {
        id: 5,
        name: "Single Shot Skills",
        loadEditComponent: ()=>(parcelRequire("lxTHT")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("lxTHT")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("jCIRP")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        loadIconComponent: ()=>Promise.resolve((parcelRequire("6tjVY"))).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    6: {
        id: 6,
        name: "User Created Workout",
        loadEditComponent: ()=>(parcelRequire("k8bTo")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("dSJzN")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("gY6gC")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        loadIconComponent: ()=>(parcelRequire("epTiz")).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    7: {
        id: 7,
        name: "Shared Workout",
        loadEditComponent: ()=>(parcelRequire("jwPLq")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("jwPLq")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("cf67Q")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    8: {
        id: 8,
        name: "Pickleball Game",
        loadEditComponent: ()=>(parcelRequire("jwPLq")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("lnNGh")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("cf67Q")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    9: {
        id: 9,
        name: "Multi-Level Workout",
        loadEditComponent: ()=>(parcelRequire("J8yHd")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("74Z4B")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("ifp3w")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        loadIconComponent: ()=>Promise.resolve((parcelRequire("9hCj6"))).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: (0, $iBd1J.getDefaultMultiLevelConfig),
        getDefaultParams: (0, $iBd1J.getDefaultMultiLevelParams)
    },
    10: {
        id: 10,
        name: "Serve and Volley",
        loadEditComponent: ()=>(parcelRequire("jwPLq")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("fDo58")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("cf67Q")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    11: {
        id: 11,
        name: "Module",
        loadEditComponent: ()=>(parcelRequire("a8vkU")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("6iR6Y")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("7SHsw")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        loadIconComponent: ()=>Promise.resolve((parcelRequire("6sKkU"))).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    12: {
        id: 12,
        name: "Serve Challenge",
        loadEditComponent: ()=>(parcelRequire("jwPLq")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("jwPLq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("6a4Ka")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("cf67Q")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    13: {
        id: 13,
        name: "Baseline Depth",
        loadEditComponent: ()=>(parcelRequire("jwPLq")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("kbNno")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("cf67Q")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    14: {
        id: 14,
        name: "Serve and Volley",
        loadEditComponent: ()=>(parcelRequire("jwPLq")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("iYIgK")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("cf67Q")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        loadHistoryComponent: ()=>(parcelRequire("dUlKq")).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    15: {
        id: 15,
        name: "Zone Triggered",
        loadEditComponent: ()=>(parcelRequire("1Jx3k")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("40sok")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("cf67Q")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    // 16 (DUPR, pickleball) and 17 (Padel) load the SAME components. The
    // runtimes are forked on coach so a padel change during the trial cannot
    // reach a DUPR play; the play screens are not, because they were already
    // parameterized by sport — instructions, the 3D guide and the visualizer
    // targets all key off `sport`, so a second copy would be two places to fix
    // every padel wording change.
    //
    // The shared directory carries the padel name because padel is the app
    // being actively worked; DUPR loading from `17-padel-app` reads oddly and
    // is worth revisiting if DUPR outlives the trial.
    16: {
        id: 16,
        name: "DUPR App",
        loadEditComponent: ()=>(parcelRequire("1PcEH")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("dRBWh")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("25nnN")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        loadIconComponent: ()=>(parcelRequire("ke7BX")).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    17: {
        id: 17,
        name: "Padel Assessment",
        loadEditComponent: ()=>(parcelRequire("1PcEH")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("dRBWh")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("25nnN")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        loadIconComponent: ()=>(parcelRequire("ke7BX")).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    // 18 and 19 are lacrosse forks of Module (11) and Zone Triggered (15),
    // forked on both webby-app and coach so the lacrosse MVP can change
    // without reaching the other sports' plays.
    // The lacrosse builders and play screen, not the Module ones: the generic
    // Module editor would drop `config.lacrosse` on save.
    18: {
        id: 18,
        name: "Lacrosse Module",
        loadEditComponent: ()=>(parcelRequire("giJkd")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("eyvXB")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("aN4EM")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        loadIconComponent: ()=>(parcelRequire("lpE0L")).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    },
    19: {
        id: 19,
        name: "Lacrosse Zone Triggered",
        // Zone drills: one ball each time a player runs into a zone. The
        // zone builder and play screen; they share the lacrosse builders'
        // parts and are listed with the player workouts.
        loadEditComponent: ()=>(parcelRequire("888Ti")).catch($2465f8126c273909$var$eFn),
        loadListComponent: ()=>(parcelRequire("5x9cq")).catch($2465f8126c273909$var$eFn),
        loadPlayComponent: ()=>(parcelRequire("14hWu")).catch($2465f8126c273909$var$eFn),
        loadCardComponent: ()=>(parcelRequire("aN4EM")).catch($2465f8126c273909$var$eFn),
        loadHeroComponent: ()=>(parcelRequire("caJ0s")).catch($2465f8126c273909$var$eFn),
        loadIconComponent: ()=>(parcelRequire("lpE0L")).catch($2465f8126c273909$var$eFn),
        getDefaultConfig: ()=>({}),
        getDefaultParams: ()=>({})
    }
};
function $2465f8126c273909$export$f9962582c9e66d99(id) {
    return $2465f8126c273909$var$apps[id];
}
function $2465f8126c273909$export$db0e6e8ec5c7eab5(id) {
    return $2465f8126c273909$var$apps[id] ?? null;
}
function $2465f8126c273909$export$68ddedf7d44b3bdf() {
    return Object.values($2465f8126c273909$var$apps);
}
function $2465f8126c273909$export$fb2283f4a44fb53(idMaybe) {
    if (idMaybe) {
        const parsed = parseInt(idMaybe, 10);
        if (!Number.isNaN(parsed)) {
            if ($2465f8126c273909$export$b608bf4d51a366da.includes(parsed)) return parsed;
        }
    }
    return null;
}

});
parcelRegister("3WN4W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $442c87b9b4f8284d$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $cbFbS = parcelRequire("cbFbS");
const $442c87b9b4f8284d$var$ReactLazyError = /*#__PURE__*/ $bh6RR.memo(()=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                sx: {
                    my: 2,
                    p: 2,
                    backgroundColor: "white"
                },
                children: "It looks like we had a problem loading this page. Tap \u201CRefresh\u201D to get the latest update."
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                component: "div",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                    variant: "contained",
                    color: "primary",
                    fullWidth: true,
                    onClick: ()=>{
                        const url = new URL(window.location.href);
                        url.searchParams.set("t", Date.now().toString());
                        window.location.replace(url.toString());
                    },
                    children: "Refresh the Volley App"
                })
            })
        ]
    }));
$442c87b9b4f8284d$var$ReactLazyError.displayName = "ReactLazyError";
var $442c87b9b4f8284d$export$2e2bcd8739ae039 = $442c87b9b4f8284d$var$ReactLazyError;

});

parcelRegister("iBd1J", function(module, exports) {

$parcel$export(module.exports, "getDefaultMultiLevelParams", function () { return $73bf49f395eac538$export$7cacf7e87f4e938a; });
$parcel$export(module.exports, "getDefaultMultiLevelConfig", function () { return $73bf49f395eac538$export$10612feeca1038ae; });

var $3TjY8 = parcelRequire("3TjY8");
function $73bf49f395eac538$export$7cacf7e87f4e938a() {
    const defaultMultiLevelParams = {
        initialDelay: 1,
        intervalOverride: 3,
        numberOfBalls: (0, $3TjY8.SMALLE_MAX_BALLS),
        playMode: "standard",
        shuffle: false
    };
    return defaultMultiLevelParams;
}
function $73bf49f395eac538$export$10612feeca1038ae() {
    const defaultMultiLevelConfig = {
        levels: {
            1: {
                number: 1,
                shots: []
            },
            2: {
                number: 2,
                shots: []
            },
            3: {
                number: 3,
                shots: []
            },
            4: {
                number: 4,
                shots: []
            },
            5: {
                number: 5,
                shots: []
            }
        }
    };
    return defaultMultiLevelConfig;
}

});
parcelRegister("3TjY8", function(module, exports) {

$parcel$export(module.exports, "SMALLE_MAX_BALLS", function () { return $fc0ae57cd190d5a9$export$a879049cc6884a6e; });
$parcel$export(module.exports, "default", function () { return $fc0ae57cd190d5a9$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $3OBHq = parcelRequire("3OBHq");

var $3ny7R = parcelRequire("3ny7R");

var $jZhDJ = parcelRequire("jZhDJ");

var $2bbvG = parcelRequire("2bbvG");

var $1d1FK = parcelRequire("1d1FK");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $8EjJH = parcelRequire("8EjJH");

var $198hy = parcelRequire("198hy");

var $gleSN = parcelRequire("gleSN");

var $6v5EZ = parcelRequire("6v5EZ");

var $ir8S0 = parcelRequire("ir8S0");
const $fc0ae57cd190d5a9$var$FEED_INTERVAL = 0.25;
const $fc0ae57cd190d5a9$var$INTERVAL_OFFSET = 6;
const $fc0ae57cd190d5a9$var$KnownFeedSpeeds = {
    1: "very fast",
    1.25: "very fast",
    1.5: "very fast",
    1.75: "very fast",
    2: "fast",
    2.25: "fast",
    2.5: "fast",
    2.75: "fast",
    3: "moderate",
    3.25: "moderate",
    3.5: "moderate",
    3.75: "moderate",
    4: "slow",
    4.25: "slow",
    4.5: "slow",
    4.75: "slow",
    5: "very slow"
};
const $fc0ae57cd190d5a9$var$rateMarks = Object.keys($fc0ae57cd190d5a9$var$KnownFeedSpeeds).filter((v)=>parseFloat(v) % 1 === 0).map((v)=>({
        label: `${6 - parseFloat(v)} sec.`,
        value: parseFloat(v)
    }));
const $fc0ae57cd190d5a9$export$a879049cc6884a6e = 60;
const $fc0ae57cd190d5a9$var$KnownBallCounts = {
    1: 1,
    15: 15,
    30: 30,
    45: 45,
    All: $fc0ae57cd190d5a9$export$a879049cc6884a6e
};
const $fc0ae57cd190d5a9$var$ballCountMarks = Object.keys($fc0ae57cd190d5a9$var$KnownBallCounts).map((k)=>({
        label: k,
        value: $fc0ae57cd190d5a9$var$KnownBallCounts[k]
    }));
function $fc0ae57cd190d5a9$var$intervalToKnownSpeed(interval) {
    return $fc0ae57cd190d5a9$var$KnownFeedSpeeds[interval];
}
function $fc0ae57cd190d5a9$export$2e2bcd8739ae039({ selectedInterval: selectedInterval, selectedShotCount: selectedShotCount, validationError: validationError, onIntervalChanged: onIntervalChanged, onShotCountChanged: onShotCountChanged, level: level, setLevel: setLevel, copyLevel: copyLevel, ...props }) {
    const [userInterval, setUserInterval] = $bh6RR.useState($fc0ae57cd190d5a9$var$INTERVAL_OFFSET - selectedInterval);
    const [userShotCount, setUserShotCount] = $bh6RR.useState(selectedShotCount);
    const [durationText, setDurationText] = $bh6RR.useState("calculating...");
    $bh6RR.useEffect(()=>{
        setUserInterval($fc0ae57cd190d5a9$var$INTERVAL_OFFSET - selectedInterval);
    }, [
        selectedInterval
    ]);
    $bh6RR.useEffect(()=>{
        setUserShotCount(selectedShotCount);
    }, [
        selectedShotCount
    ]);
    $bh6RR.useEffect(()=>{
        if (userShotCount === $fc0ae57cd190d5a9$export$a879049cc6884a6e) setDurationText("as long as you keep the bin full.");
        else {
            const time = userShotCount * ($fc0ae57cd190d5a9$var$INTERVAL_OFFSET - userInterval);
            if (time < 60) setDurationText(`about ${time} sec.`);
            else {
                let minutes = Math.floor(time / 60);
                const seconds = time % 60;
                if (seconds > 40) minutes += 1;
                if (seconds > 20 && seconds <= 40) minutes = `${minutes}.5`;
                setDurationText(`about ${minutes} ${minutes === 1 ? "minute" : "minutes"}.`);
            }
        }
    }, [
        userShotCount,
        userInterval,
        setDurationText
    ]);
    const summary = $bh6RR.useMemo(()=>{
        const countText = userShotCount === $fc0ae57cd190d5a9$export$a879049cc6884a6e ? "All" : userShotCount;
        const feedRateText = $fc0ae57cd190d5a9$var$intervalToKnownSpeed(selectedInterval) || "Unknown";
        return `${countText} ${(0, $8EjJH.pluralize)(userShotCount, "Ball")}, ${feedRateText}`;
    }, [
        userShotCount,
        selectedInterval
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $3ny7R.default), {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $2bbvG.default), {
                expandIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3OBHq.default), {}),
                children: [
                    !props.expanded && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                        component: "div",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                variant: "h4",
                                color: "primary.main",
                                children: "Feed"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                variant: "h4",
                                color: "primary.main",
                                children: summary
                            })
                        ]
                    }),
                    props.expanded && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "h3",
                        color: "primary.main",
                        children: "Feed"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jZhDJ.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    spacing: 1,
                    children: [
                        level && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ir8S0.default), {
                            type: "feed",
                            level: level,
                            setLevel: setLevel,
                            onCopyLevel: copyLevel
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $198hy.default), {
                            label: "Rate",
                            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gleSN.default), {
                                        minValue: 1,
                                        maxValue: 5,
                                        decimalPrecision: 2,
                                        showDecimal: true,
                                        onChange: (value)=>{
                                            setUserInterval($fc0ae57cd190d5a9$var$INTERVAL_OFFSET - value);
                                            onIntervalChanged(value);
                                        },
                                        incrementValue: $fc0ae57cd190d5a9$var$FEED_INTERVAL,
                                        value: $fc0ae57cd190d5a9$var$INTERVAL_OFFSET - userInterval,
                                        reverseIncrement: true
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $6v5EZ.default), {
                                        min: 1,
                                        max: 5,
                                        marks: $fc0ae57cd190d5a9$var$rateMarks,
                                        step: $fc0ae57cd190d5a9$var$FEED_INTERVAL,
                                        value: userInterval,
                                        track: false,
                                        onChange: (_, v)=>setUserInterval(v),
                                        onChangeCommitted: (_, v)=>onIntervalChanged($fc0ae57cd190d5a9$var$INTERVAL_OFFSET - v),
                                        sx: {
                                            display: "table",
                                            margin: "0px auto 20px auto",
                                            maxWidth: "80%",
                                            ".MuiSlider-track": {
                                                color: "primary.light"
                                            }
                                        }
                                    }),
                                    validationError && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                        variant: "caption",
                                        align: "center",
                                        children: validationError
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $198hy.default), {
                            label: "Number of Balls",
                            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gleSN.default), {
                                        onChange: (value)=>{
                                            setUserShotCount(value);
                                            onShotCountChanged(value);
                                        },
                                        value: userShotCount,
                                        incrementValue: 1,
                                        maxValue: $fc0ae57cd190d5a9$export$a879049cc6884a6e,
                                        minValue: 1,
                                        showDecimal: false,
                                        showInfinity: true
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $6v5EZ.default), {
                                        min: 1,
                                        max: $fc0ae57cd190d5a9$export$a879049cc6884a6e,
                                        marks: $fc0ae57cd190d5a9$var$ballCountMarks,
                                        value: userShotCount,
                                        onChange: (_, v)=>setUserShotCount(v),
                                        onChangeCommitted: (_, v)=>onShotCountChanged(v),
                                        sx: {
                                            display: "table",
                                            margin: "0px auto 20px auto",
                                            maxWidth: "80%"
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                            component: "div",
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                variant: "body2",
                                textAlign: "center",
                                children: `Duration of the workout will be ${durationText}`
                            })
                        })
                    ]
                })
            })
        ]
    });
}

});
parcelRegister("3OBHq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c7348e7ce2374cc$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $2c7348e7ce2374cc$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

});

parcelRegister("3ny7R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $275dfdbc6707896d$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");



var $aPsoC = parcelRequire("aPsoC");


var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $1NU2k = parcelRequire("1NU2k");

var $4Athc = parcelRequire("4Athc");

var $8yBup = parcelRequire("8yBup");

var $8ANil = parcelRequire("8ANil");

var $dFvJW = parcelRequire("dFvJW");

var $g5iIc = parcelRequire("g5iIc");

var $ih19M = parcelRequire("ih19M");
'use client';
const $275dfdbc6707896d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        heading: [
            'heading'
        ],
        region: [
            'region'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $g5iIc.getAccordionUtilityClass), classes);
};
const $275dfdbc6707896d$var$AccordionRoot = (0, $l0oRz.default)((0, $4Athc.default), {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $g5iIc.default).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${(0, $g5iIc.default).expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${(0, $g5iIc.default).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}), (0, $gfPc7.default)(({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $g5iIc.default).expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    })));
const $275dfdbc6707896d$var$AccordionHeading = (0, $l0oRz.default)('h3', {
    name: 'MuiAccordion',
    slot: 'Heading'
})({
    all: 'unset'
});
const $275dfdbc6707896d$var$AccordionRegion = (0, $l0oRz.default)('div', {
    name: 'MuiAccordion',
    slot: 'Region'
})({});
const $275dfdbc6707896d$var$Accordion = /*#__PURE__*/ $bh6RR.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp, ...other } = props;
    const [expanded, setExpandedState] = (0, $8ANil.default)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $bh6RR.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $bh6RR.Children.toArray(childrenProp);
    const contextValue = $bh6RR.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = {
        ...props,
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    };
    const classes = $275dfdbc6707896d$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionPropsProp,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $dFvJW.default)('root', {
        elementType: $275dfdbc6707896d$var$AccordionRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        className: (0, $aPsoC.default)(classes.root, className),
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        ref: ref,
        additionalProps: {
            square: square
        }
    });
    const [AccordionHeadingSlot, accordionProps] = (0, $dFvJW.default)('heading', {
        elementType: $275dfdbc6707896d$var$AccordionHeading,
        externalForwardedProps: externalForwardedProps,
        className: classes.heading,
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $dFvJW.default)('transition', {
        elementType: (0, $1NU2k.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [AccordionRegionSlot, accordionRegionProps] = (0, $dFvJW.default)('region', {
        elementType: $275dfdbc6707896d$var$AccordionRegion,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.region,
        additionalProps: {
            'aria-labelledby': summary.props.id,
            id: summary.props['aria-controls'],
            role: 'region'
        }
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)(AccordionHeadingSlot, {
                ...accordionProps,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8yBup.default).Provider, {
                    value: contextValue,
                    children: summary
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)(TransitionSlot, {
                in: expanded,
                timeout: "auto",
                ...transitionProps,
                children: /*#__PURE__*/ (0, $ih19M.jsx)(AccordionRegionSlot, {
                    ...accordionRegionProps,
                    children: children
                })
            })
        ]
    });
});
var $275dfdbc6707896d$export$2e2bcd8739ae039 = $275dfdbc6707896d$var$Accordion;

});
parcelRegister("1NU2k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1505d5c1c4a3f337$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $aPsoC = parcelRequire("aPsoC");


var $7ARPd = parcelRequire("7ARPd");

var $c3mIq = parcelRequire("c3mIq");


var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");
var $aOb5j = parcelRequire("aOb5j");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $gNPqJ = parcelRequire("gNPqJ");

var $bi4C9 = parcelRequire("bi4C9");

var $dg012 = parcelRequire("dg012");

var $dFvJW = parcelRequire("dFvJW");

var $d92et = parcelRequire("d92et");

var $ih19M = parcelRequire("ih19M");
'use client';
const $1505d5c1c4a3f337$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $d92et.getCollapseUtilityClass), classes);
};
const $1505d5c1c4a3f337$var$CollapseRoot = (0, $l0oRz.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height'),
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'auto',
                    width: 0,
                    transition: theme.transitions.create('width')
                }
            },
            {
                props: {
                    state: 'entered'
                },
                style: {
                    height: 'auto',
                    overflow: 'visible'
                }
            },
            {
                props: {
                    state: 'entered',
                    orientation: 'horizontal'
                },
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px',
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $1505d5c1c4a3f337$var$CollapseWrapper = (0, $l0oRz.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper'
})({
    // Hack to get children with a negative margin to not falsify the height computation.
    display: 'flex',
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
const $1505d5c1c4a3f337$var$CollapseWrapperInner = (0, $l0oRz.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner'
})({
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $1505d5c1c4a3f337$var$Collapse = /*#__PURE__*/ $bh6RR.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', slots: slots = {}, slotProps: slotProps = {}, style: style, timeout: timeout = (0, $gNPqJ.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $7ARPd.default), ...other } = props;
    const ownerState = {
        ...props,
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    };
    const classes = $1505d5c1c4a3f337$var$useUtilityClasses(ownerState);
    const theme = (0, $aOb5j.default)();
    const timer = (0, $c3mIq.default)();
    const wrapperRef = $bh6RR.useRef(null);
    const autoTransitionDuration = $bh6RR.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $bh6RR.useRef(null);
    const handleRef = (0, $dg012.default)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $bi4C9.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $bi4C9.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps,
        component: component
    };
    const [RootSlot, rootSlotProps] = (0, $dFvJW.default)('root', {
        ref: handleRef,
        className: (0, $aPsoC.default)(classes.root, className),
        elementType: $1505d5c1c4a3f337$var$CollapseRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: {
                [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize,
                ...style
            }
        }
    });
    const [WrapperSlot, wrapperSlotProps] = (0, $dFvJW.default)('wrapper', {
        ref: wrapperRef,
        className: classes.wrapper,
        elementType: $1505d5c1c4a3f337$var$CollapseWrapper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [WrapperInnerSlot, wrapperInnerSlotProps] = (0, $dFvJW.default)('wrapperInner', {
        className: classes.wrapperInner,
        elementType: $1505d5c1c4a3f337$var$CollapseWrapperInner,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, {
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: incomingOwnerState, ...restChildProps })=>{
            const stateOwnerState = {
                ...ownerState,
                state: state
            };
            return /*#__PURE__*/ (0, $ih19M.jsx)(RootSlot, {
                ...rootSlotProps,
                className: (0, $aPsoC.default)(rootSlotProps.className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                ownerState: stateOwnerState,
                ...restChildProps,
                children: /*#__PURE__*/ (0, $ih19M.jsx)(WrapperSlot, {
                    ...wrapperSlotProps,
                    ownerState: stateOwnerState,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)(WrapperInnerSlot, {
                        ...wrapperInnerSlotProps,
                        ownerState: stateOwnerState,
                        children: children
                    })
                })
            });
        }
    });
});
if ($1505d5c1c4a3f337$var$Collapse) $1505d5c1c4a3f337$var$Collapse.muiSupportAuto = true;
var $1505d5c1c4a3f337$export$2e2bcd8739ae039 = $1505d5c1c4a3f337$var$Collapse;

});
parcelRegister("d92et", function(module, exports) {

$parcel$export(module.exports, "getCollapseUtilityClass", function () { return $991dd8ec944fcb47$export$5162da8f798e0959; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $991dd8ec944fcb47$export$5162da8f798e0959(slot) {
    return (0, $dmzXD.default)('MuiCollapse', slot);
}
const $991dd8ec944fcb47$var$collapseClasses = (0, $fYlYP.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $991dd8ec944fcb47$export$2e2bcd8739ae039 = $991dd8ec944fcb47$var$collapseClasses;

});


parcelRegister("8yBup", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63ae9452f53592da$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $63ae9452f53592da$var$AccordionContext = /*#__PURE__*/ $bh6RR.createContext({});
var $63ae9452f53592da$export$2e2bcd8739ae039 = $63ae9452f53592da$var$AccordionContext;

});

parcelRegister("g5iIc", function(module, exports) {

$parcel$export(module.exports, "getAccordionUtilityClass", function () { return $bb5ba0c57907d3ff$export$80fb6a2cb3f13b8b; });
$parcel$export(module.exports, "default", function () { return $bb5ba0c57907d3ff$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $bb5ba0c57907d3ff$export$80fb6a2cb3f13b8b(slot) {
    return (0, $dmzXD.default)('MuiAccordion', slot);
}
const $bb5ba0c57907d3ff$var$accordionClasses = (0, $fYlYP.default)('MuiAccordion', [
    'root',
    'heading',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $bb5ba0c57907d3ff$export$2e2bcd8739ae039 = $bb5ba0c57907d3ff$var$accordionClasses;

});


parcelRegister("jZhDJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8d165c0b3a7cd50$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $1ruG8 = parcelRequire("1ruG8");

var $ih19M = parcelRequire("ih19M");
'use client';
const $e8d165c0b3a7cd50$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $1ruG8.getAccordionDetailsUtilityClass), classes);
};
const $e8d165c0b3a7cd50$var$AccordionDetailsRoot = (0, $l0oRz.default)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root'
})((0, $gfPc7.default)(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    })));
const $e8d165c0b3a7cd50$var$AccordionDetails = /*#__PURE__*/ $bh6RR.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className, ...other } = props;
    const ownerState = props;
    const classes = $e8d165c0b3a7cd50$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($e8d165c0b3a7cd50$var$AccordionDetailsRoot, {
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $e8d165c0b3a7cd50$export$2e2bcd8739ae039 = $e8d165c0b3a7cd50$var$AccordionDetails;

});
parcelRegister("1ruG8", function(module, exports) {

$parcel$export(module.exports, "getAccordionDetailsUtilityClass", function () { return $10d01c2c40614f36$export$a6afb527becfac26; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $10d01c2c40614f36$export$a6afb527becfac26(slot) {
    return (0, $dmzXD.default)('MuiAccordionDetails', slot);
}
const $10d01c2c40614f36$var$accordionDetailsClasses = (0, $fYlYP.default)('MuiAccordionDetails', [
    'root'
]);
var $10d01c2c40614f36$export$2e2bcd8739ae039 = $10d01c2c40614f36$var$accordionDetailsClasses;

});


parcelRegister("2bbvG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19658983978b5602$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $fbTZq = parcelRequire("fbTZq");

var $8yBup = parcelRequire("8yBup");

var $9Bbai = parcelRequire("9Bbai");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
const $19658983978b5602$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $9Bbai.getAccordionSummaryUtilityClass), classes);
};
const $19658983978b5602$var$AccordionSummaryRoot = (0, $l0oRz.default)((0, $fbTZq.default), {
    name: 'MuiAccordionSummary',
    slot: 'Root'
})((0, $gfPc7.default)(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        width: '100%',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${(0, $9Bbai.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $9Bbai.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $9Bbai.default).disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $9Bbai.default).expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
}));
const $19658983978b5602$var$AccordionSummaryContent = (0, $l0oRz.default)('span', {
    name: 'MuiAccordionSummary',
    slot: 'Content'
})((0, $gfPc7.default)(({ theme: theme })=>({
        display: 'flex',
        textAlign: 'start',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${(0, $9Bbai.default).expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    })));
const $19658983978b5602$var$AccordionSummaryExpandIconWrapper = (0, $l0oRz.default)('span', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper'
})((0, $gfPc7.default)(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $9Bbai.default).expanded}`]: {
            transform: 'rotate(180deg)'
        }
    })));
const $19658983978b5602$var$AccordionSummary = /*#__PURE__*/ $bh6RR.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick, slots: slots, slotProps: slotProps, ...other } = props;
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $bh6RR.useContext((0, $8yBup.default));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = {
        ...props,
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    };
    const classes = $19658983978b5602$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $dFvJW.default)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $aPsoC.default)(classes.root, className),
        elementType: $19658983978b5602$var$AccordionSummaryRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            focusRipple: false,
            disableRipple: true,
            disabled: disabled,
            'aria-expanded': expanded,
            focusVisibleClassName: (0, $aPsoC.default)(classes.focusVisible, focusVisibleClassName)
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    handleChange(event);
                }
            })
    });
    const [ContentSlot, contentSlotProps] = (0, $dFvJW.default)('content', {
        className: classes.content,
        elementType: $19658983978b5602$var$AccordionSummaryContent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ExpandIconWrapperSlot, expandIconWrapperSlotProps] = (0, $dFvJW.default)('expandIconWrapper', {
        className: classes.expandIconWrapper,
        elementType: $19658983978b5602$var$AccordionSummaryExpandIconWrapper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)(ContentSlot, {
                ...contentSlotProps,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $ih19M.jsx)(ExpandIconWrapperSlot, {
                ...expandIconWrapperSlotProps,
                children: expandIcon
            })
        ]
    });
});
var $19658983978b5602$export$2e2bcd8739ae039 = $19658983978b5602$var$AccordionSummary;

});
parcelRegister("9Bbai", function(module, exports) {

$parcel$export(module.exports, "getAccordionSummaryUtilityClass", function () { return $6fd03ae92b6a180d$export$282216ad123d6580; });
$parcel$export(module.exports, "default", function () { return $6fd03ae92b6a180d$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $6fd03ae92b6a180d$export$282216ad123d6580(slot) {
    return (0, $dmzXD.default)('MuiAccordionSummary', slot);
}
const $6fd03ae92b6a180d$var$accordionSummaryClasses = (0, $fYlYP.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $6fd03ae92b6a180d$export$2e2bcd8739ae039 = $6fd03ae92b6a180d$var$accordionSummaryClasses;

});


parcelRegister("8EjJH", function(module, exports) {

$parcel$export(module.exports, "capitalizeFirstLetter", function () { return $590ce98e536f444a$export$d07f57595c356899; });
$parcel$export(module.exports, "pluralize", function () { return $590ce98e536f444a$export$cefb40c9962541b5; });
function $590ce98e536f444a$export$d07f57595c356899([first, ...rest], locale = navigator.language) {
    return `${first.toLocaleUpperCase(locale)}${rest.join("")}`;
}
function $590ce98e536f444a$export$cefb40c9962541b5(count, noun, suffix = "s") {
    if (count === 1) return noun;
    return `${noun}${suffix}`;
}

});

parcelRegister("198hy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a3ee053349ac5c6$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $aOb5j = parcelRequire("aOb5j");
function $7a3ee053349ac5c6$export$2e2bcd8739ae039({ label: label, centerLabel: centerLabel = false, elliptical: elliptical = false, position: position = "top", children: children, color: color }) {
    const theme = (0, $aOb5j.default)();
    const nColor = color === "black" ? color : theme.palette.primary.light;
    const legendStyle = {
        color: nColor,
        fontSize: "small"
    };
    if (position === "bottom") {
        legendStyle.position = "absolute";
        legendStyle.margin = "0px auto";
        legendStyle.position = "absolute";
        legendStyle.bottom = 0;
        legendStyle.left = "50%";
        legendStyle.transform = "translate(-50%, 50%)";
        legendStyle.background = "white";
    }
    if (centerLabel) legendStyle.margin = "0 auto";
    return /*#__PURE__*/ (0, $ih19M.jsxs)("fieldset", {
        style: {
            borderColor: nColor,
            borderRadius: elliptical ? "50px / 50px" : theme.shape.borderRadius,
            borderWidth: "1px",
            paddingBlockStart: "1px",
            paddingBlockEnd: "5px",
            paddingInlineStart: "5px",
            paddingInlineEnd: "5px",
            position: "relative"
        },
        children: [
            label && /*#__PURE__*/ (0, $ih19M.jsx)("legend", {
                style: legendStyle,
                children: label
            }),
            children
        ]
    });
}

});

parcelRegister("gleSN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb5e861cc58de2c5$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $eXkDO = parcelRequire("eXkDO");

var $1t7vi = parcelRequire("1t7vi");

var $1lA67 = parcelRequire("1lA67");

var $4rInl = parcelRequire("4rInl");

var $gtX9p = parcelRequire("gtX9p");

var $hrqHU = parcelRequire("hrqHU");

var $aOb5j = parcelRequire("aOb5j");

var $198hy = parcelRequire("198hy");
function $fb5e861cc58de2c5$var$SlimNumberInput({ label: label, value: value, minValue: minValue, maxValue: maxValue, incrementValue: incrementValue = 1, onChange: onChange, disabled: disabled = false, showDecimal: showDecimal = true, showInfinity: showInfinity = false, suffix: suffix, reverseIncrement: reverseIncrement = false, decimalPrecision: decimalPrecision = 1 }) {
    const [numberValue, setNumberValue] = $bh6RR.useState(value?.toFixed(1) ?? 0);
    const [infinityTouched, setInfinityTouched] = $bh6RR.useState(false);
    const numberChange = $bh6RR.useCallback((newValue)=>{
        if (Number.isNaN(newValue)) {
            setNumberValue(showDecimal ? value.toFixed(1) : value?.toFixed(0));
            return;
        }
        if (minValue !== undefined && newValue < minValue) onChange(minValue);
        else if (minValue !== undefined && newValue > maxValue) onChange(maxValue);
        else onChange(newValue);
    }, [
        maxValue,
        minValue,
        onChange,
        setNumberValue,
        value,
        showDecimal
    ]);
    const decrementClick = $bh6RR.useCallback(()=>{
        if (reverseIncrement) {
            const decremented = value + incrementValue;
            numberChange(decremented);
        } else {
            const decremented = value - incrementValue;
            numberChange(decremented);
        }
    }, [
        incrementValue,
        value,
        reverseIncrement,
        numberChange
    ]);
    const incrementClick = $bh6RR.useCallback(()=>{
        if (reverseIncrement) {
            const incremented = value - incrementValue;
            numberChange(incremented);
        } else {
            const incremented = value + incrementValue;
            numberChange(incremented);
        }
    }, [
        incrementValue,
        value,
        reverseIncrement,
        numberChange
    ]);
    $bh6RR.useEffect(()=>{
        if (showDecimal) setNumberValue(value.toFixed(decimalPrecision));
        else setNumberValue(value.toFixed(0));
    }, [
        value,
        showDecimal,
        decimalPrecision
    ]);
    const numberInputRef = $bh6RR.useRef(undefined);
    const infinity = $bh6RR.useMemo(()=>{
        if (showInfinity) {
            if (infinityTouched) return false;
            return value === maxValue;
        }
        return false;
    }, [
        value,
        maxValue,
        showInfinity,
        infinityTouched
    ]);
    $bh6RR.useEffect(()=>{
        if (infinityTouched) numberInputRef.current?.focus();
    }, [
        infinityTouched,
        numberInputRef
    ]);
    const theme = (0, $aOb5j.default)();
    const arrowButton = {
        border: "1px solid",
        color: "white",
        background: theme.palette.primary.light,
        margin: ".5em",
        "& .MuiSvgIcon-root": {
            width: "0.75em",
            height: "0.75em"
        },
        "&:hover": {
            backgroundColor: theme.palette.primary.light
        }
    };
    const textInput = {
        "& .MuiInputBase-input": {
            textAlign: "center",
            fontSize: "2.75em",
            fontWeight: "bold",
            color: theme.palette.primary.light
        }
    };
    const decrementIcon = reverseIncrement ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $eXkDO.default), {}) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $1t7vi.default), {});
    const incrementIcon = reverseIncrement ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $1t7vi.default), {}) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $eXkDO.default), {});
    const decrementDisabled = reverseIncrement ? value === maxValue : value === minValue;
    const incrementDisabled = reverseIncrement ? value === minValue : value === maxValue;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1lA67.default), {
        container: true,
        direction: "column",
        sx: {
            maxWidth: "90%"
        },
        alignSelf: "center",
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $198hy.default), {
            label: label,
            position: "bottom",
            centerLabel: true,
            elliptical: true,
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1lA67.default), {
                container: true,
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1lA67.default), {
                        container: true,
                        justifyContent: "center",
                        size: {
                            xs: 3,
                            md: 2
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                            color: "primary",
                            onClick: decrementClick,
                            disabled: disabled || decrementDisabled,
                            size: "large",
                            sx: arrowButton,
                            children: decrementIcon
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1lA67.default), {
                        container: true,
                        justifyContent: "center",
                        size: {
                            xs: 6,
                            md: 8
                        },
                        children: [
                            infinity && /*#__PURE__*/ (0, $ih19M.jsx)((0, $hrqHU.default), {
                                variant: "standard",
                                value: "\u221E",
                                onFocus: ()=>setInfinityTouched(true),
                                sx: textInput,
                                slotProps: {
                                    input: {
                                        disableUnderline: true
                                    }
                                }
                            }),
                            !infinity && /*#__PURE__*/ (0, $ih19M.jsx)((0, $hrqHU.default), {
                                variant: "standard",
                                type: "number",
                                onChange: (evt)=>setNumberValue(evt.target.value),
                                onBlur: ()=>{
                                    numberChange(parseInt(numberValue, 10));
                                    setInfinityTouched(false);
                                },
                                onFocus: (evt)=>evt.target.select(),
                                value: numberValue,
                                inputRef: numberInputRef,
                                sx: textInput,
                                slotProps: {
                                    input: {
                                        disableUnderline: true,
                                        endAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gtX9p.default), {
                                            position: "end",
                                            sx: {
                                                "& .MuiTypography-root": {
                                                    fontSize: "3.5em",
                                                    color: theme.palette.primary.light
                                                }
                                            },
                                            children: suffix
                                        })
                                    }
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1lA67.default), {
                        container: true,
                        justifyContent: "center",
                        size: {
                            xs: 3,
                            md: 2
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                            color: "primary",
                            onClick: incrementClick,
                            disabled: disabled || incrementDisabled,
                            size: "large",
                            sx: arrowButton,
                            children: incrementIcon
                        })
                    })
                ]
            })
        })
    });
}
var $fb5e861cc58de2c5$export$2e2bcd8739ae039 = $fb5e861cc58de2c5$var$SlimNumberInput;

});
parcelRegister("eXkDO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae36964841d8482f$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $ae36964841d8482f$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');

});

parcelRegister("1t7vi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $111e51f58499c341$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $111e51f58499c341$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 13H5v-2h14z"
}), 'Remove');

});


parcelRegister("6v5EZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f42efbd4505cd5da$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $9ug9t = parcelRequire("9ug9t");

var $1lMle = parcelRequire("1lMle");

var $3oWVD = parcelRequire("3oWVD");
const $f42efbd4505cd5da$var$browserIsiOS = (0, $3oWVD.default)();
function $f42efbd4505cd5da$export$2e2bcd8739ae039({ ...props }) {
    const { onChange: onChange, onChangeCommitted: onChangeCommitted, sx: sx } = props;
    const handleChange = $bh6RR.useCallback((event, value, activeThumb)=>{
        if (onChange) {
            if ($f42efbd4505cd5da$var$browserIsiOS && event.type === "mousedown") {
                (0, $1lMle.default).debug(`Ignoring slider change event (${event.type}), value: ${JSON.stringify(value)}`);
                return;
            }
            onChange(event, value, activeThumb);
        }
    }, [
        onChange
    ]);
    const handleChangeCommitted = $bh6RR.useCallback((event, value)=>{
        if (onChangeCommitted) {
            if ($f42efbd4505cd5da$var$browserIsiOS && event.type === "mouseup") {
                (0, $1lMle.default).debug(`Ignoring slider changeCommitted event (${event.type}), value: ${value.toString()}`);
                return;
            }
            onChangeCommitted(event, value);
        }
    }, [
        onChangeCommitted
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $9ug9t.default), {
        ...props,
        onChange: handleChange,
        onChangeCommitted: handleChangeCommitted,
        slotProps: {
            root: {
                unselectable: "on",
                style: {
                    userSelect: "none",
                    WebkitTouchCallout: "none",
                    WebkitUserSelect: "none",
                    touchAction: "none"
                },
                onTouchStart: ()=>{}
            }
        },
        sx: {
            ...sx,
            "& .MuiSlider-track": {
                color: props.disabled ? "grey" : "primary.light"
            },
            "& .MuiSlider-thumb": {
                width: 28,
                height: 28,
                backgroundColor: "white",
                border: "4px solid",
                borderColor: props.disabled ? "grey" : "primary.light"
            }
        }
    });
}

});

parcelRegister("ir8S0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40f6289aacd81bfc$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $40t4Y = parcelRequire("40t4Y");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $dUgAK = parcelRequire("dUgAK");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $eLohH = parcelRequire("eLohH");

var $fMPxo = parcelRequire("fMPxo");

var $2qYOa = parcelRequire("2qYOa");

var $5jTwi = parcelRequire("5jTwi");

var $8JNI1 = parcelRequire("8JNI1");

var $2vfd6 = parcelRequire("2vfd6");

var $g0xix = parcelRequire("g0xix");

var $cbFbS = parcelRequire("cbFbS");

var $f4RsT = parcelRequire("f4RsT");
function $40f6289aacd81bfc$export$2e2bcd8739ae039({ type: type, level: level, setLevel: setLevel, onCopyLevel: onCopyLevel }) {
    const [copyDialogOpen, setCopyDialogOpen] = $bh6RR.useState(false);
    const [levelToCopy, setLevelToCopy] = $bh6RR.useState(level === 1 ? (0, $f4RsT.Levels).length : level - 1);
    $bh6RR.useEffect(()=>{
        setLevelToCopy(level === 1 ? (0, $f4RsT.Levels).length : level - 1);
    }, [
        level
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
        spacing: 2,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                direction: "row",
                spacing: 0.5,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "caption",
                        sx: {
                            minWidth: "30px"
                        },
                        children: "Level"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $g0xix.default), {
                        fullWidth: true,
                        size: "small",
                        color: "primary",
                        exclusive: true,
                        value: level,
                        onChange: (_, v)=>{
                            if (v) setLevel(v);
                        },
                        children: (0, $f4RsT.Levels).map((l)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $2vfd6.default), {
                                size: "small",
                                value: l,
                                sx: {
                                    p: "2px"
                                },
                                children: l
                            }, l))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                component: "div",
                display: "flex",
                justifyContent: "end",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                    variant: "contained",
                    color: "primary",
                    size: "small",
                    startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $40t4Y.default), {}),
                    onClick: ()=>setCopyDialogOpen(true),
                    children: "Copy from\u2026"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dUgAK.default), {
                sx: {
                    "& .MuiDialog-paper": {
                        width: "80%"
                    }
                },
                open: copyDialogOpen,
                onClose: ()=>setCopyDialogOpen(false),
                maxWidth: "xs",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eLohH.default), {
                        children: `Copy ${type} from\u{2026}`
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                        dividers: true,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5jTwi.default), {
                            name: "copyLevel",
                            value: levelToCopy,
                            onChange: (_, v)=>setLevelToCopy(parseInt(v, 10)),
                            children: (0, $f4RsT.Levels).filter((l)=>l !== level).map((option)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $fMPxo.default), {
                                    value: option,
                                    control: /*#__PURE__*/ (0, $ih19M.jsx)((0, $2qYOa.default), {}),
                                    label: `Level ${option}`
                                }, option))
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bK42r.default), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                autoFocus: true,
                                onClick: ()=>setCopyDialogOpen(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                onClick: ()=>{
                                    onCopyLevel(type, levelToCopy);
                                    setCopyDialogOpen(false);
                                },
                                children: "Ok"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("40t4Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2eadb80b37ea9754$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $2eadb80b37ea9754$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), 'ContentCopy');

});

parcelRegister("2qYOa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c5d2db1dfc6c35f$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $96ZcP = parcelRequire("96ZcP");

var $774Wc = parcelRequire("774Wc");

var $dSSdf = parcelRequire("dSSdf");

var $krx4P = parcelRequire("krx4P");

var $1WYnL = parcelRequire("1WYnL");

var $1BiIF = parcelRequire("1BiIF");

var $evOnD = parcelRequire("evOnD");

var $9CJ7V = parcelRequire("9CJ7V");

var $b6vKX = parcelRequire("b6vKX");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $4B5Or = parcelRequire("4B5Or");

var $dFvJW = parcelRequire("dFvJW");

var $OEXBZ = parcelRequire("OEXBZ");

var $ih19M = parcelRequire("ih19M");
'use client';
const $1c5d2db1dfc6c35f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $krx4P.default)(color)}`,
            size !== 'medium' && `size${(0, $krx4P.default)(size)}`
        ]
    };
    return {
        ...classes,
        ...(0, $96ZcP.default)(slots, (0, $9CJ7V.getRadioUtilityClass), classes)
    };
};
const $1c5d2db1dfc6c35f$var$RadioRoot = (0, $l0oRz.default)((0, $774Wc.default), {
    shouldForwardProp: (prop)=>(0, $b6vKX.default)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $krx4P.default)(ownerState.size)}`],
            styles[`color${(0, $krx4P.default)(ownerState.color)}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $9CJ7V.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    color: 'default',
                    disabled: false,
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false
                    },
                    style: {
                        [`&.${(0, $9CJ7V.default).checked}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
function $1c5d2db1dfc6c35f$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $1c5d2db1dfc6c35f$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ih19M.jsx)((0, $dSSdf.default), {
    checked: true
});
const $1c5d2db1dfc6c35f$var$defaultIcon = /*#__PURE__*/ (0, $ih19M.jsx)((0, $dSSdf.default), {});
const $1c5d2db1dfc6c35f$var$Radio = /*#__PURE__*/ $bh6RR.forwardRef(function Radio(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $1c5d2db1dfc6c35f$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $1c5d2db1dfc6c35f$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className, disabled: disabledProp, disableRipple: disableRipple = false, slots: slots = {}, slotProps: slotProps = {}, inputProps: inputProps, ...other } = props;
    const muiFormControl = (0, $1BiIF.default)();
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    disabled ??= false;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableRipple: disableRipple,
        color: color,
        size: size
    };
    const classes = $1c5d2db1dfc6c35f$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $evOnD.default)();
    let checked = checkedProp;
    const onChange = (0, $1WYnL.default)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $1c5d2db1dfc6c35f$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $dFvJW.default)('root', {
        ref: ref,
        elementType: $1c5d2db1dfc6c35f$var$RadioRoot,
        className: (0, $aPsoC.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event, ...args)=>{
                    handlers.onChange?.(event, ...args);
                    onChange(event, ...args);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            type: 'radio',
            icon: /*#__PURE__*/ $bh6RR.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $bh6RR.cloneElement(checkedIcon, {
                fontSize: checkedIcon.props.fontSize ?? size
            }),
            disabled: disabled,
            name: name,
            checked: checked,
            slots: slots,
            slotProps: {
                // Do not forward `slotProps.root` again because it's already handled by the `RootSlot` in this file.
                input: typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps
            }
        }
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $1c5d2db1dfc6c35f$export$2e2bcd8739ae039 = $1c5d2db1dfc6c35f$var$Radio;

});
parcelRegister("dSSdf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1ba5eff07ec031a$export$2e2bcd8739ae039; });


var $bbv8s = parcelRequire("bbv8s");

var $igva3 = parcelRequire("igva3");

var $b6vKX = parcelRequire("b6vKX");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $ih19M = parcelRequire("ih19M");
'use client';
const $a1ba5eff07ec031a$var$RadioButtonIconRoot = (0, $l0oRz.default)('span', {
    name: 'MuiRadioButtonIcon',
    shouldForwardProp: (0, $b6vKX.default)
})({
    position: 'relative',
    display: 'flex'
});
const $a1ba5eff07ec031a$var$RadioButtonIconBackground = (0, $l0oRz.default)((0, $bbv8s.default), {
    name: 'MuiRadioButtonIcon'
})({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $a1ba5eff07ec031a$var$RadioButtonIconDot = (0, $l0oRz.default)((0, $igva3.default), {
    name: 'MuiRadioButtonIcon'
})((0, $gfPc7.default)(({ theme: theme })=>({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    checked: true
                },
                style: {
                    transform: 'scale(1)',
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeOut,
                        duration: theme.transitions.duration.shortest
                    })
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function $a1ba5eff07ec031a$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = {
        ...props,
        checked: checked
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)($a1ba5eff07ec031a$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($a1ba5eff07ec031a$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)($a1ba5eff07ec031a$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $a1ba5eff07ec031a$export$2e2bcd8739ae039 = $a1ba5eff07ec031a$var$RadioButtonIcon;

});
parcelRegister("bbv8s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8248dfa0559c172f$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $8248dfa0559c172f$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');

});

parcelRegister("igva3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4c1e49752e738d0$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $d4c1e49752e738d0$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');

});


parcelRegister("1WYnL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16ba0be86ea37fd1$export$2e2bcd8739ae039; });

var $5EVAP = parcelRequire("5EVAP");
var $16ba0be86ea37fd1$export$2e2bcd8739ae039 = (0, $5EVAP.default);

});

parcelRegister("evOnD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a90b0a6879a52ed8$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $98u4O = parcelRequire("98u4O");
'use client';
function $a90b0a6879a52ed8$export$2e2bcd8739ae039() {
    return $bh6RR.useContext((0, $98u4O.default));
}

});
parcelRegister("98u4O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a6c30fe141be8e1$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
/**
 * @ignore - internal component.
 */ const $6a6c30fe141be8e1$var$RadioGroupContext = /*#__PURE__*/ $bh6RR.createContext(undefined);
var $6a6c30fe141be8e1$export$2e2bcd8739ae039 = $6a6c30fe141be8e1$var$RadioGroupContext;

});


parcelRegister("9CJ7V", function(module, exports) {

$parcel$export(module.exports, "getRadioUtilityClass", function () { return $701aaae687305159$export$192f7b2363c77155; });
$parcel$export(module.exports, "default", function () { return $701aaae687305159$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $701aaae687305159$export$192f7b2363c77155(slot) {
    return (0, $dmzXD.default)('MuiRadio', slot);
}
const $701aaae687305159$var$radioClasses = (0, $fYlYP.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $701aaae687305159$export$2e2bcd8739ae039 = $701aaae687305159$var$radioClasses;

});


parcelRegister("5jTwi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3df9cb383c8c51ff$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $iUqMN = parcelRequire("iUqMN");

var $dGFlQ = parcelRequire("dGFlQ");

var $dg012 = parcelRequire("dg012");

var $8ANil = parcelRequire("8ANil");

var $98u4O = parcelRequire("98u4O");

var $2STLv = parcelRequire("2STLv");

var $ih19M = parcelRequire("ih19M");
'use client';
const $3df9cb383c8c51ff$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $dGFlQ.getRadioGroupUtilityClass), classes);
};
const $3df9cb383c8c51ff$var$RadioGroup = /*#__PURE__*/ $bh6RR.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp, ...other } = props;
    const rootRef = $bh6RR.useRef(null);
    const classes = $3df9cb383c8c51ff$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $8ANil.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    $bh6RR.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $dg012.default)(ref, rootRef);
    const name = (0, $2STLv.default)(nameProp);
    const contextValue = $bh6RR.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $98u4O.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $iUqMN.default), {
            role: "radiogroup",
            ref: handleRef,
            className: (0, $aPsoC.default)(classes.root, className),
            ...other,
            children: children
        })
    });
});
var $3df9cb383c8c51ff$export$2e2bcd8739ae039 = $3df9cb383c8c51ff$var$RadioGroup;

});
parcelRegister("dGFlQ", function(module, exports) {

$parcel$export(module.exports, "getRadioGroupUtilityClass", function () { return $9f6f461b5e1aa9cf$export$c4cff3a43f7cabb6; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $9f6f461b5e1aa9cf$export$c4cff3a43f7cabb6(slot) {
    return (0, $dmzXD.default)('MuiRadioGroup', slot);
}
const $9f6f461b5e1aa9cf$var$radioGroupClasses = (0, $fYlYP.default)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
var $9f6f461b5e1aa9cf$export$2e2bcd8739ae039 = $9f6f461b5e1aa9cf$var$radioGroupClasses;

});


parcelRegister("2vfd6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d2a46774ff9949c$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $e0O1m = parcelRequire("e0O1m");

var $96ZcP = parcelRequire("96ZcP");

var $fbTZq = parcelRequire("fbTZq");

var $krx4P = parcelRequire("krx4P");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $4B5Or = parcelRequire("4B5Or");

var $OEXBZ = parcelRequire("OEXBZ");

var $iwKeU = parcelRequire("iwKeU");

var $l2gmx = parcelRequire("l2gmx");

var $13Ecm = parcelRequire("13Ecm");

var $jRN9r = parcelRequire("jRN9r");

var $ih19M = parcelRequire("ih19M");
'use client';
const $1d2a46774ff9949c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, fullWidth: fullWidth, selected: selected, disabled: disabled, size: size, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            fullWidth && 'fullWidth',
            `size${(0, $krx4P.default)(size)}`,
            color
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $iwKeU.getToggleButtonUtilityClass), classes);
};
const $1d2a46774ff9949c$var$ToggleButtonRoot = (0, $l0oRz.default)((0, $fbTZq.default), {
    name: 'MuiToggleButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, $krx4P.default)(ownerState.size)}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        ...theme.typography.button,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $iwKeU.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        '&:hover': {
            textDecoration: 'none',
            // Reset on mouse devices
            backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            {
                props: {
                    color: 'standard'
                },
                style: {
                    [`&.${(0, $iwKeU.default).selected}`]: {
                        color: (theme.vars || theme).palette.text.primary,
                        backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.selectedOpacity),
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.selectedOpacity)
                            }
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $iwKeU.default).selected}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.selectedOpacity),
                            '&:hover': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.selectedOpacity)
                                }
                            }
                        }
                    }
                })),
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 7,
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 15,
                    fontSize: theme.typography.pxToRem(15)
                }
            }
        ]
    })));
const $1d2a46774ff9949c$var$ToggleButton = /*#__PURE__*/ $bh6RR.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const { value: contextValue, ...contextProps } = $bh6RR.useContext((0, $l2gmx.default));
    const toggleButtonGroupButtonContextPositionClassName = $bh6RR.useContext((0, $13Ecm.default));
    const resolvedProps = (0, $e0O1m.default)({
        ...contextProps,
        selected: (0, $jRN9r.default)(inProps.value, contextValue)
    }, inProps);
    const props = (0, $OEXBZ.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiToggleButton'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: fullWidth = false, onChange: onChange, onClick: onClick, selected: selected, size: size = 'medium', value: value, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size
    };
    const classes = $1d2a46774ff9949c$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $ih19M.jsx)($1d2a46774ff9949c$var$ToggleButtonRoot, {
        className: (0, $aPsoC.default)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected,
        ...other,
        children: children
    });
});
var $1d2a46774ff9949c$export$2e2bcd8739ae039 = $1d2a46774ff9949c$var$ToggleButton;

});
parcelRegister("iwKeU", function(module, exports) {

$parcel$export(module.exports, "getToggleButtonUtilityClass", function () { return $d7cf155aa87d84d6$export$21f89b560b65a301; });
$parcel$export(module.exports, "default", function () { return $d7cf155aa87d84d6$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $d7cf155aa87d84d6$export$21f89b560b65a301(slot) {
    return (0, $dmzXD.default)('MuiToggleButton', slot);
}
const $d7cf155aa87d84d6$var$toggleButtonClasses = (0, $fYlYP.default)('MuiToggleButton', [
    'root',
    'disabled',
    'selected',
    'standard',
    'primary',
    'secondary',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'fullWidth'
]);
var $d7cf155aa87d84d6$export$2e2bcd8739ae039 = $d7cf155aa87d84d6$var$toggleButtonClasses;

});

parcelRegister("l2gmx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5067a238a92011a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
/**
 * @ignore - internal component.
 */ const $f5067a238a92011a$var$ToggleButtonGroupContext = /*#__PURE__*/ $bh6RR.createContext({});
var $f5067a238a92011a$export$2e2bcd8739ae039 = $f5067a238a92011a$var$ToggleButtonGroupContext;

});

parcelRegister("13Ecm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c5540d605d8dc0c$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
'use client';
/**
 * @ignore - internal component.
 */ const $0c5540d605d8dc0c$var$ToggleButtonGroupButtonContext = /*#__PURE__*/ $bh6RR.createContext(undefined);
var $0c5540d605d8dc0c$export$2e2bcd8739ae039 = $0c5540d605d8dc0c$var$ToggleButtonGroupButtonContext;

});

parcelRegister("jRN9r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7691800e7798608$export$2e2bcd8739ae039; });
// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function $e7691800e7798608$export$2e2bcd8739ae039(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.includes(value);
    return value === candidate;
}

});


parcelRegister("g0xix", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba7679b70533ca3e$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");



var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $585kK = parcelRequire("585kK");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $krx4P = parcelRequire("krx4P");

var $4Q87A = parcelRequire("4Q87A");

var $l2gmx = parcelRequire("l2gmx");

var $13Ecm = parcelRequire("13Ecm");

var $iwKeU = parcelRequire("iwKeU");

var $ih19M = parcelRequire("ih19M");
'use client';
const $ba7679b70533ca3e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, fullWidth: fullWidth, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            fullWidth && 'fullWidth'
        ],
        grouped: [
            'grouped',
            `grouped${(0, $krx4P.default)(orientation)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $4Q87A.getToggleButtonGroupUtilityClass), classes);
};
const $ba7679b70533ca3e$var$ToggleButtonGroupRoot = (0, $l0oRz.default)('div', {
    name: 'MuiToggleButtonGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $4Q87A.default).grouped}`]: styles.grouped
            },
            {
                [`& .${(0, $4Q87A.default).grouped}`]: styles[`grouped${(0, $krx4P.default)(ownerState.orientation)}`]
            },
            {
                [`& .${(0, $4Q87A.default).firstButton}`]: styles.firstButton
            },
            {
                [`& .${(0, $4Q87A.default).lastButton}`]: styles.lastButton
            },
            {
                [`& .${(0, $4Q87A.default).middleButton}`]: styles.middleButton
            },
            styles.root,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${(0, $4Q87A.default).grouped}`]: {
                        [`&.${(0, $4Q87A.default).selected} + .${(0, $4Q87A.default).grouped}.${(0, $4Q87A.default).selected}`]: {
                            borderTop: 0,
                            marginTop: 0
                        }
                    },
                    [`& .${(0, $4Q87A.default).firstButton},& .${(0, $4Q87A.default).middleButton}`]: {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $4Q87A.default).lastButton},& .${(0, $4Q87A.default).middleButton}`]: {
                        marginTop: -1,
                        borderTop: '1px solid transparent',
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0
                    },
                    [`& .${(0, $4Q87A.default).lastButton}.${(0, $iwKeU.default).disabled},& .${(0, $4Q87A.default).middleButton}.${(0, $iwKeU.default).disabled}`]: {
                        borderTop: '1px solid transparent'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $4Q87A.default).grouped}`]: {
                        [`&.${(0, $4Q87A.default).selected} + .${(0, $4Q87A.default).grouped}.${(0, $4Q87A.default).selected}`]: {
                            borderLeft: 0,
                            marginLeft: 0
                        }
                    },
                    [`& .${(0, $4Q87A.default).firstButton},& .${(0, $4Q87A.default).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $4Q87A.default).lastButton},& .${(0, $4Q87A.default).middleButton}`]: {
                        marginLeft: -1,
                        borderLeft: '1px solid transparent',
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    },
                    [`& .${(0, $4Q87A.default).lastButton}.${(0, $iwKeU.default).disabled},& .${(0, $4Q87A.default).middleButton}.${(0, $iwKeU.default).disabled}`]: {
                        borderLeft: '1px solid transparent'
                    }
                }
            }
        ]
    })));
const $ba7679b70533ca3e$var$ToggleButtonGroup = /*#__PURE__*/ $bh6RR.forwardRef(function ToggleButtonGroup(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiToggleButtonGroup'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, exclusive: exclusive = false, fullWidth: fullWidth = false, onChange: onChange, orientation: orientation = 'horizontal', size: size = 'medium', value: value, ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size
    };
    const classes = $ba7679b70533ca3e$var$useUtilityClasses(ownerState);
    const handleChange = $bh6RR.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    }, [
        onChange,
        value
    ]);
    const handleExclusiveChange = $bh6RR.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    }, [
        onChange,
        value
    ]);
    const context = $bh6RR.useMemo(()=>({
            className: classes.grouped,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            value: value,
            size: size,
            fullWidth: fullWidth,
            color: color,
            disabled: disabled
        }), [
        classes.grouped,
        exclusive,
        handleExclusiveChange,
        handleChange,
        value,
        size,
        fullWidth,
        color,
        disabled
    ]);
    const validChildren = (0, $585kK.default)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)($ba7679b70533ca3e$var$ToggleButtonGroupRoot, {
        role: "group",
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $l2gmx.default).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $13Ecm.default).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var $ba7679b70533ca3e$export$2e2bcd8739ae039 = $ba7679b70533ca3e$var$ToggleButtonGroup;

});
parcelRegister("585kK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bc1d6480fb81c79$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
function $3bc1d6480fb81c79$export$2e2bcd8739ae039(children) {
    return $bh6RR.Children.toArray(children).filter((child)=>/*#__PURE__*/ $bh6RR.isValidElement(child));
}

});

parcelRegister("4Q87A", function(module, exports) {

$parcel$export(module.exports, "getToggleButtonGroupUtilityClass", function () { return $38625179a5625c20$export$44aa3ae5b353cef1; });
$parcel$export(module.exports, "default", function () { return $38625179a5625c20$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $38625179a5625c20$export$44aa3ae5b353cef1(slot) {
    return (0, $dmzXD.default)('MuiToggleButtonGroup', slot);
}
const $38625179a5625c20$var$toggleButtonGroupClasses = (0, $fYlYP.default)('MuiToggleButtonGroup', [
    'root',
    'selected',
    'horizontal',
    'vertical',
    'disabled',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'fullWidth',
    'firstButton',
    'lastButton',
    'middleButton'
]);
var $38625179a5625c20$export$2e2bcd8739ae039 = $38625179a5625c20$var$toggleButtonGroupClasses;

});


parcelRegister("f4RsT", function(module, exports) {

$parcel$export(module.exports, "Levels", function () { return $44a2f66f3165387a$export$7dc82a261720bb19; });
const $44a2f66f3165387a$export$7dc82a261720bb19 = [
    1,
    2,
    3,
    4,
    5
];

});




parcelRegister("cQRJu", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("01DVg"),
    $parcel$import("3zbg6"),
    $parcel$import("6OTYw"),
    $parcel$import("eP1UT")
]).then(()=>parcelRequire('gqDne'));

});

parcelRegister("5x9cq", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("kUuaI"),
    $parcel$import("8Kb7Q")
]).then(()=>parcelRequire('3wVzY'));

});

parcelRegister("jCIRP", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("7A9kg"),
    $parcel$import("2wzkX")
]).then(()=>parcelRequire('jiYID'));

});

parcelRegister("jwPLq", function(module, exports) {
module.exports = $parcel$import("10UvT").then(()=>parcelRequire('iZzLu'));

});

parcelRegister("jmzVO", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("buCO7"),
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("01DVg"),
    $parcel$import("y782T")
]).then(()=>parcelRequire('abI21'));

});

parcelRegister("RbZZ1", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("7A9kg"),
    $parcel$import("iPpXy")
]).then(()=>parcelRequire('6RhIO'));

});

parcelRegister("caJ0s", function(module, exports) {
module.exports = $parcel$import("jjQZS").then(()=>parcelRequire('4iTPO'));

});

parcelRegister("jSqFI", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("6OTYw"),
    $parcel$import("6e2AR")
]).then(()=>parcelRequire('jg5aJ'));

});

parcelRegister("icN0f", function(module, exports) {
module.exports = $parcel$import("kOHa8").then(()=>parcelRequire('6Z8tV'));

});

parcelRegister("k8bTo", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("7eokS"),
    $parcel$import("41e5U"),
    $parcel$import("3JBno"),
    $parcel$import("2Zzi2"),
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("01DVg"),
    $parcel$import("3zbg6"),
    $parcel$import("6OTYw"),
    $parcel$import("jn0Fh")
]).then(()=>parcelRequire('cLIC1'));

});

parcelRegister("dSJzN", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("01DVg"),
    $parcel$import("1Kwkm")
]).then(()=>parcelRequire('802fB'));

});

parcelRegister("gY6gC", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("7A9kg"),
    $parcel$import("7v4Gr")
]).then(()=>parcelRequire('a3asB'));

});

parcelRegister("epTiz", function(module, exports) {
module.exports = $parcel$import("kUuaI").then(()=>parcelRequire('gQDAA'));

});

parcelRegister("lxTHT", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("Idach"),
    $parcel$import("41e5U"),
    $parcel$import("3JBno"),
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("01DVg"),
    $parcel$import("6OTYw"),
    $parcel$import("e2wF8")
]).then(()=>parcelRequire('7QqrR'));

});

parcelRegister("6tjVY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $b11b511bf42f9a0f$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $iYrdy = parcelRequire("iYrdy");
function $b11b511bf42f9a0f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $iYrdy.default), {
        width: "45",
        height: "50",
        viewBox: "0 0 45 50",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M32.1869 41.4106C37.597 41.4106 41.9827 37.0248 41.9827 31.6147C41.9827 26.2046 37.597 21.8188 32.1869 21.8188C26.7768 21.8188 22.391 26.2046 22.391 31.6147C22.391 37.0248 26.7768 41.4106 32.1869 41.4106Z",
                stroke: "#EFA511",
                strokeWidth: "2",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M25.6476 17.0592L12.2788 3.69043",
                stroke: "#EFA511",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M19.082 18.4969L2.25891 1.67383",
                stroke: "#EFA511",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M16.524 25.0753L3.70898 12.2603",
                stroke: "#EFA511",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M44 48.0942H1.88965",
                stroke: "#EFA511",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            })
        ]
    });
}

});

parcelRegister("cf67Q", function(module, exports) {
module.exports = $parcel$import("7A9kg").then(()=>parcelRequire('16A9w'));

});

parcelRegister("lnNGh", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("3mM7q"),
    $parcel$import("aBMOs"),
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("01DVg"),
    $parcel$import("9LPS3")
]).then(()=>parcelRequire('Btyx5'));

});

parcelRegister("J8yHd", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("7eokS"),
    $parcel$import("41e5U"),
    $parcel$import("3JBno"),
    $parcel$import("2Zzi2"),
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("01DVg"),
    $parcel$import("3zbg6"),
    $parcel$import("6OTYw"),
    $parcel$import("imDjm")
]).then(()=>parcelRequire('kGsld'));

});

parcelRegister("74Z4B", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("01DVg"),
    $parcel$import("7cf0W")
]).then(()=>parcelRequire('6kOqS'));

});

parcelRegister("ifp3w", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("7A9kg"),
    $parcel$import("aeZp9")
]).then(()=>parcelRequire('6Skca'));

});

parcelRegister("9hCj6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5b8c592058c79dd9$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $iYrdy = parcelRequire("iYrdy");
function $5b8c592058c79dd9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $iYrdy.default), {
        width: "74",
        height: "61",
        viewBox: "0 0 74 61",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M59.1851 1.06006L64.9981 1.18643C65.5939 1.19546 66.0272 1.73705 65.9279 2.32377L64.9259 7.92921",
                stroke: "#56D5EF",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M55.1954 24.4839H47.8568C46.9396 24.4839 46.196 25.2275 46.196 26.1448V57.3493C46.196 58.2666 46.9396 59.0102 47.8568 59.0102H55.1954C56.1126 59.0102 56.8563 58.2666 56.8563 57.3493V26.1448C56.8563 25.2275 56.1126 24.4839 55.1954 24.4839Z",
                stroke: "#56D5EF",
                strokeWidth: "2",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M70.766 15.5293H63.4275C62.5102 15.5293 61.7667 16.2729 61.7667 17.1902V57.349C61.7667 58.2663 62.5102 59.0098 63.4275 59.0098H70.766C71.6833 59.0098 72.4269 58.2663 72.4269 57.349V17.1902C72.4269 16.2729 71.6833 15.5293 70.766 15.5293Z",
                stroke: "#56D5EF",
                strokeWidth: "2",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M40.5093 33.4019H33.1708C32.2535 33.4019 31.5099 34.1455 31.5099 35.0627V57.3491C31.5099 58.2664 32.2535 59.01 33.1708 59.01H40.5093C41.4266 59.01 42.1702 58.2664 42.1702 57.3491V35.0627C42.1702 34.1455 41.4266 33.4019 40.5093 33.4019Z",
                stroke: "#56D5EF",
                strokeWidth: "2",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M25.8232 42.8345H18.4847C17.5674 42.8345 16.8238 43.5781 16.8238 44.4953V57.3491C16.8238 58.2663 17.5674 59.0099 18.4847 59.0099H25.8232C26.7405 59.0099 27.4841 58.2663 27.4841 57.3491V44.4953C27.4841 43.5781 26.7405 42.8345 25.8232 42.8345Z",
                stroke: "#56D5EF",
                strokeWidth: "2",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M11.1462 49.5684H3.80763C2.89035 49.5684 2.14676 50.312 2.14676 51.2292V57.3492C2.14676 58.2665 2.89035 59.0101 3.80763 59.0101H11.1462C12.0634 59.0101 12.8071 58.2665 12.8071 57.3492V51.2292C12.8071 50.312 12.0634 49.5684 11.1462 49.5684Z",
                stroke: "#56D5EF",
                strokeWidth: "2",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M1.05457 41.7515L30.0657 18.8604L36.6821 24.52L64.3302 2.80225",
                stroke: "#56D5EF",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            })
        ]
    });
}

});

parcelRegister("fDo58", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("8BlCc"),
    $parcel$import("aBMOs"),
    $parcel$import("buCO7"),
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("01DVg"),
    $parcel$import("8ZAFZ")
]).then(()=>parcelRequire('iu1Sq'));

});

parcelRegister("a8vkU", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("dFEJ6"),
    $parcel$import("3mM7q"),
    $parcel$import("Idach"),
    $parcel$import("7eokS"),
    $parcel$import("41e5U"),
    $parcel$import("3JBno"),
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("01DVg"),
    $parcel$import("6OTYw"),
    $parcel$import("9kSth")
]).then(()=>parcelRequire('lsVff'));

});

parcelRegister("6iR6Y", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("aBMOs"),
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("01DVg"),
    $parcel$import("9Yszp")
]).then(()=>parcelRequire('qGVbm'));

});

parcelRegister("7SHsw", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("7A9kg"),
    $parcel$import("9XJBM")
]).then(()=>parcelRequire('lW7QC'));

});

parcelRegister("6sKkU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $fa2e65c8e302d11a$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $iYrdy = parcelRequire("iYrdy");
function $fa2e65c8e302d11a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $iYrdy.default), {
        width: "51",
        height: "51",
        viewBox: "0 0 51 51",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M43.4727 36.4478C46.7822 36.276 49.5277 33.5146 49.589 30.1886C49.6503 26.6172 46.7821 23.7085 43.2276 23.7085C42.247 23.7085 41.3277 23.9294 40.5065 24.3222C40.4207 24.359 40.3226 24.2976 40.3226 24.1994V13.0802C40.3226 11.767 39.2562 10.6992 37.9447 10.6992H26.852C26.7539 10.6992 26.6927 10.601 26.7294 10.5151C27.1217 9.68057 27.33 8.74783 27.3178 7.766C27.2933 4.3664 24.4373 1.49454 21.0421 1.44544C17.6469 1.39635 14.5826 4.26822 14.5826 7.81509C14.5826 8.77238 14.791 9.69284 15.1709 10.5029C15.2077 10.5888 15.1587 10.687 15.0606 10.687C13.0872 10.687 7.27732 10.687 3.96789 10.687C2.65637 10.687 1.59 11.7547 1.59 13.0679V24.0767C1.59 24.1749 1.68806 24.2363 1.77386 24.1994C2.59509 23.8558 3.50212 23.6717 4.44592 23.6962C7.77986 23.7944 10.5622 26.6172 10.6113 29.9554C10.6726 33.5269 7.80437 36.4355 4.2498 36.4355C3.36728 36.4355 2.5338 36.2514 1.77386 35.9323C1.68806 35.8955 1.59 35.9569 1.59 36.0551V47.0639C1.59 48.3771 2.65637 49.4448 3.96789 49.4448C7.28958 49.4448 13.0872 49.4448 14.6929 49.4448C14.791 49.4448 14.8522 49.3466 14.8155 49.2607C14.4478 48.4384 14.2516 47.518 14.2762 46.5484C14.3374 43.1856 17.1811 40.3506 20.5396 40.3138C24.0941 40.2647 26.9991 43.1365 26.9991 46.6834C26.9991 47.6039 26.803 48.4753 26.4598 49.2607C26.423 49.3466 26.4843 49.4448 26.5823 49.4448C28.2861 49.4448 34.4882 49.4448 37.9325 49.4448C39.244 49.4448 40.2981 48.3771 40.2981 47.0639V35.9446C40.2981 35.8464 40.3962 35.7728 40.482 35.8219C40.9477 36.0305 42.1612 36.4969 43.4605 36.4355L43.4727 36.4478Z",
            stroke: "#DA30D8",
            strokeWidth: "2",
            strokeMiterlimit: "10"
        })
    });
}

});

parcelRegister("6a4Ka", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("3mM7q"),
    $parcel$import("buCO7"),
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("01DVg"),
    $parcel$import("6w5sC")
]).then(()=>parcelRequire('5ciys'));

});

parcelRegister("kbNno", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("3mM7q"),
    $parcel$import("buCO7"),
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("01DVg"),
    $parcel$import("1awVm")
]).then(()=>parcelRequire('iXbg3'));

});

parcelRegister("iYIgK", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("24JfN"),
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("01DVg"),
    $parcel$import("5doD5")
]).then(()=>parcelRequire('gkj0m'));

});

parcelRegister("dUlKq", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("Kmh8h"),
    $parcel$import("3mM7q"),
    $parcel$import("c38S7")
]).then(()=>parcelRequire('41hL6'));

});

parcelRegister("1Jx3k", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("7eokS"),
    $parcel$import("41e5U"),
    $parcel$import("3JBno"),
    $parcel$import("2Zzi2"),
    $parcel$import("01DVg"),
    $parcel$import("3zbg6"),
    $parcel$import("6OTYw"),
    $parcel$import("8IOv0")
]).then(()=>parcelRequire('fwWrV'));

});

parcelRegister("40sok", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("24JfN"),
    $parcel$import("aBMOs"),
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("01DVg"),
    $parcel$import("3JGyK")
]).then(()=>parcelRequire('2TSaK'));

});

parcelRegister("1PcEH", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("dFEJ6"),
    $parcel$import("3mM7q"),
    $parcel$import("Idach"),
    $parcel$import("7eokS"),
    $parcel$import("41e5U"),
    $parcel$import("3JBno"),
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("01DVg"),
    $parcel$import("6OTYw"),
    $parcel$import("l44ev")
]).then(()=>parcelRequire('casyK'));

});

parcelRegister("dRBWh", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("01DVg"),
    $parcel$import("gamAG")
]).then(()=>parcelRequire('f0BFv'));

});

parcelRegister("25nnN", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("7A9kg"),
    $parcel$import("2zZYM")
]).then(()=>parcelRequire('bPtLq'));

});

parcelRegister("ke7BX", function(module, exports) {
module.exports = $parcel$import("aRQVM").then(()=>parcelRequire('kGqwF'));

});

parcelRegister("giJkd", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("fVbov"),
    $parcel$import("Idach"),
    $parcel$import("30nEm"),
    $parcel$import("2BXJz")
]).then(()=>parcelRequire('cuMrn'));

});

parcelRegister("eyvXB", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("fVbov"),
    $parcel$import("30nEm"),
    $parcel$import("01DVg"),
    $parcel$import("5XZSD")
]).then(()=>parcelRequire('9pJJr'));

});

parcelRegister("aN4EM", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("7A9kg"),
    $parcel$import("tlPsp")
]).then(()=>parcelRequire('dl7yR'));

});

parcelRegister("lpE0L", function(module, exports) {
module.exports = $parcel$import("8PhpM").then(()=>parcelRequire('bv9ZJ'));

});

parcelRegister("888Ti", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("fVbov"),
    $parcel$import("Idach"),
    $parcel$import("30nEm"),
    $parcel$import("Lfv6y")
]).then(()=>parcelRequire('2rrAx'));

});

parcelRegister("14hWu", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("fVbov"),
    $parcel$import("30nEm"),
    $parcel$import("01DVg"),
    $parcel$import("k7IPS")
]).then(()=>parcelRequire('3Vc66'));

});


parcelRegister("kkvif", function(module, exports) {

$parcel$export(module.exports, "CLUB_IN_CLUB_FEATURE", function () { return $eccdf32114290015$export$ab8ef6ed5a810f55; });
const $eccdf32114290015$export$ab8ef6ed5a810f55 = "CLUB_IN_CLUB";

});


parcelRegister("3vS3m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28ee32347c2863a5$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $28ee32347c2863a5$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M7.5 21H2V9h5.5zm7.25-18h-5.5v18h5.5zM22 11h-5.5v10H22z"
}), 'Leaderboard');

});

parcelRegister("dOzud", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0eb78bad280cd12$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $a0eb78bad280cd12$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "m20.38 8.57-1.23 1.85a8 8 0 0 1-.22 7.58H5.07A8 8 0 0 1 15.58 6.85l1.85-1.23A10 10 0 0 0 3.35 19a2 2 0 0 0 1.72 1h13.85a2 2 0 0 0 1.74-1 10 10 0 0 0-.27-10.44zm-9.79 6.84a2 2 0 0 0 2.83 0l5.66-8.49-8.49 5.66a2 2 0 0 0 0 2.83"
}), 'Speed');

});

parcelRegister("fcQCp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbd908bca640e216$export$2e2bcd8739ae039; });

var $6Wfmo = parcelRequire("6Wfmo");
function $dbd908bca640e216$var$addAction(name, context) {
    (0, $6Wfmo.datadogRum).addAction(name, context);
}
function $dbd908bca640e216$var$addWorkoutViewContext(workout) {
    (0, $6Wfmo.datadogRum).setViewContextProperty("workout", workout);
}
var $dbd908bca640e216$export$2e2bcd8739ae039 = {
    addAction: $dbd908bca640e216$var$addAction,
    addWorkoutViewContext: $dbd908bca640e216$var$addWorkoutViewContext
};

});

parcelRegister("f3YXY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af766d7d51db1853$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $af766d7d51db1853$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 16H5V10h14zM9 14H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2zm-8 4H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2z"
}), 'CalendarMonth');

});

parcelRegister("V7QJD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0abb69bef67d294a$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $0abb69bef67d294a$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4z"
}), 'AddBox');

});

parcelRegister("84QRb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e17b2b0d4edf140$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $5e17b2b0d4edf140$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9m-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8z"
}), 'History');

});

parcelRegister("jwTd4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e37bd50189b5eca7$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $e37bd50189b5eca7$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "m11.99 18.54-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27z"
}), 'Layers');

});

parcelRegister("j3Clf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddfc09fa455357c4$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $ddfc09fa455357c4$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19.88 18.47c.44-.7.7-1.51.7-2.39 0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5 2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21.58 23 23 21.58zm-3.8.11c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5m-.36-8.5c-.74.02-1.45.18-2.1.45l-.55-.83-3.8 6.18-3.01-3.52-3.63 5.81L1 17l5-8 3 3.5L13 6zm2.59.5c-.64-.28-1.33-.45-2.05-.49L21.38 2 23 3.18z"
}), 'QueryStats');

});

parcelRegister("lqNsp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9a263d8bce506ab$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $f9a263d8bce506ab$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M5 13.18v4L12 21l7-3.82v-4L12 17zM12 3 1 9l11 6 9-4.91V17h2V9z"
}), 'School');

});

parcelRegister("ltl7W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa1cb1d1ab842150$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $fa1cb1d1ab842150$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19.52 2.49C17.18.15 12.9.62 9.97 3.55c-1.6 1.6-2.52 3.87-2.54 5.46-.02 1.58.26 3.89-1.35 5.5l-4.24 4.24 1.42 1.42 4.24-4.24c1.61-1.61 3.92-1.33 5.5-1.35s3.86-.94 5.46-2.54c2.92-2.93 3.4-7.21 1.06-9.55m-9.2 9.19c-1.53-1.53-1.05-4.61 1.06-6.72s5.18-2.59 6.72-1.06c1.53 1.53 1.05 4.61-1.06 6.72s-5.18 2.59-6.72 1.06M18 17c.53 0 1.04.21 1.41.59.78.78.78 2.05 0 2.83-.37.37-.88.58-1.41.58s-1.04-.21-1.41-.59c-.78-.78-.78-2.05 0-2.83.37-.37.88-.58 1.41-.58m0-2c-1.02 0-2.05.39-2.83 1.17-1.56 1.56-1.56 4.09 0 5.66.78.78 1.81 1.17 2.83 1.17s2.05-.39 2.83-1.17c1.56-1.56 1.56-4.09 0-5.66C20.05 15.39 19.02 15 18 15"
}), 'SportsTennis');

});

parcelRegister("9aar5", function(module, exports) {

$parcel$export(module.exports, "hasOfficialDuprRating", function () { return $4a0b776d8d250c70$export$c68a02025551c068; });
function $4a0b776d8d250c70$export$2f662780f7853b5b(rating) {
    const value = rating?.value;
    if (value == null) return null;
    return Number.isNaN(Number.parseFloat(value)) ? null : value;
}
function $4a0b776d8d250c70$export$6d7256158528b81d(profile) {
    return $4a0b776d8d250c70$export$2f662780f7853b5b(profile.doubles) ?? $4a0b776d8d250c70$export$2f662780f7853b5b(profile.singles);
}
/** True when a format holds a usable OFFICIAL number (not null/"NR"/AI-annotated). */ function $4a0b776d8d250c70$var$isOfficialRating(rating) {
    if (rating.aiAnnotated) return false;
    return $4a0b776d8d250c70$export$2f662780f7853b5b(rating) != null;
}
function $4a0b776d8d250c70$export$c68a02025551c068(profile) {
    return $4a0b776d8d250c70$var$isOfficialRating(profile.doubles);
}

});

parcelRegister("5O1Z6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e02b80f058798f8$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $cK0UE = parcelRequire("cK0UE");

var $76QOg = parcelRequire("76QOg");
function $1e02b80f058798f8$export$2e2bcd8739ae039() {
    const { selected: sport } = (0, $76QOg.useSelectedSport)();
    // Only padel players have any use for this, so nobody else pays for the
    // request. Mirrors `HomeDuprProvider`'s sport gate.
    const shouldFetch = sport === "PADEL";
    const [phase, setPhase] = $bh6RR.useState("trial");
    // Starts true so consumers withhold rather than flash: the sport context
    // reports a placeholder before it resolves, so "not padel" is not yet a
    // settled answer on the first render.
    const [loading, setLoading] = $bh6RR.useState(true);
    $bh6RR.useEffect(()=>{
        if (!shouldFetch) {
            setPhase("trial");
            setLoading(false);
            return undefined;
        }
        const controller = new AbortController();
        setLoading(true);
        (0, $cK0UE.default)("/api/journeys/long-form?sport=PADEL", "GET", undefined, {
            signal: controller.signal
        }).then((res)=>{
            setPhase(res.rolloutPhase);
            setLoading(false);
        }).catch((err)=>{
            if (controller.signal.aborted) return;
            // Degrades to trial rather than surfacing an error: this gates
            // presentation, and the strict phase is the safe presentation.
            (0, $cK0UE.logFetchError)(err, "Failed to load padel rollout phase");
            setPhase("trial");
            setLoading(false);
        });
        return ()=>{
            controller.abort();
        };
    }, [
        shouldFetch
    ]);
    return {
        phase: phase,
        loading: loading
    };
}

});

parcelRegister("hkEd6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6fc51c275d45f6a$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $iYrdy = parcelRequire("iYrdy");
function $a6fc51c275d45f6a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $iYrdy.default), {
        viewBox: "0 0 61 59",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M6.11278 18.3978C7.89701 18.3978 9.34341 16.9514 9.34341 15.1672C9.34341 13.3829 7.89701 11.9365 6.11278 11.9365C4.32855 11.9365 2.88214 13.3829 2.88214 15.1672C2.88214 16.9514 4.32855 18.3978 6.11278 18.3978Z",
                fill: "#9429FF"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M6.11278 46.6234C7.89701 46.6234 9.34341 45.177 9.34341 43.3927C9.34341 41.6085 7.89701 40.1621 6.11278 40.1621C4.32855 40.1621 2.88214 41.6085 2.88214 43.3927C2.88214 45.177 4.32855 46.6234 6.11278 46.6234Z",
                fill: "#9429FF"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M54.613 46.8954C56.3973 46.8954 57.8437 45.4489 57.8437 43.6647C57.8437 41.8805 56.3973 40.4341 54.613 40.4341C52.8288 40.4341 51.3824 41.8805 51.3824 43.6647C51.3824 45.4489 52.8288 46.8954 54.613 46.8954Z",
                fill: "#9429FF"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M54.613 18.3978C56.3973 18.3978 57.8437 16.9514 57.8437 15.1672C57.8437 13.3829 56.3973 11.9365 54.613 11.9365C52.8288 11.9365 51.3824 13.3829 51.3824 15.1672C51.3824 16.9514 52.8288 18.3978 54.613 18.3978Z",
                fill: "#9429FF"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M30.1283 57.7229C34.3804 57.7229 37.8274 45.098 37.8274 29.5245C37.8274 13.951 34.3804 1.32617 30.1283 1.32617C25.8762 1.32617 22.4292 13.951 22.4292 29.5245C22.4292 45.098 25.8762 57.7229 30.1283 57.7229Z",
                stroke: "#9429FF",
                strokeWidth: "1",
                fill: "none",
                style: {
                    vectorEffect: "non-scaling-stroke"
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M35.8331 39.4074C49.3202 31.6206 57.6988 20.8831 54.5473 15.4246C51.3958 9.96597 37.9075 11.8533 24.4205 19.6401C10.9334 27.4268 2.55481 38.1643 5.70632 43.6229C8.85784 49.0815 22.3461 47.1941 35.8331 39.4074Z",
                stroke: "#9429FF",
                strokeWidth: "1",
                fill: "none",
                style: {
                    vectorEffect: "non-scaling-stroke"
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M54.548 43.6253C57.6995 38.1667 49.3209 27.4292 35.8339 19.6424C22.3468 11.8557 8.85857 9.96832 5.70706 15.4269C2.55554 20.8855 10.9342 31.623 24.4212 39.4097C37.9083 47.1965 51.3965 49.0838 54.548 43.6253Z",
                stroke: "#9429FF",
                strokeWidth: "1",
                fill: "none",
                style: {
                    vectorEffect: "non-scaling-stroke"
                }
            })
        ]
    });
}

});

parcelRegister("afMDy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7771085fee42245d$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $7771085fee42245d$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"
}), 'Apple');

});

parcelRegister("gOLF2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3e6494b3c039efd$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
'use client';
var $c3e6494b3c039efd$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12.545,10.239v3.821h5.445c-0.712,2.315-2.647,3.972-5.445,3.972c-3.332,0-6.033-2.701-6.033-6.032s2.701-6.032,6.033-6.032c1.498,0,2.866,0.549,3.921,1.453l2.814-2.814C17.503,2.988,15.139,2,12.545,2C7.021,2,2.543,6.477,2.543,12s4.478,10,10.002,10c8.396,0,10.249-7.85,9.426-11.748L12.545,10.239z"
}), 'Google');

});

parcelRegister("fOOlI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b84294d65894e409$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $b84294d65894e409$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5-1-1h-5l-1 1H5v2h14V4z"
}), 'DeleteOutline');

});

parcelRegister("kKa2X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f19fe59c9777f8e9$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $f19fe59c9777f8e9$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "m16 5-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4zm4 5v11c0 1.1-.9 2-2 2H6c-1.11 0-2-.9-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3c1.1 0 2 .89 2 2"
}), 'IosShare');

});

parcelRegister("bmJi8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30c878c919e608d8$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("cFAEN");
var $4JHq1 = parcelRequire("4JHq1");
const $30c878c919e608d8$var$env = (0, $4JHq1.default)(window.location);
const $30c878c919e608d8$var$BASE_TITLE = `Volley${$30c878c919e608d8$var$env === "production" ? "" : ` - ${$30c878c919e608d8$var$env.toUpperCase()[0]}${$30c878c919e608d8$var$env.slice(1)}`}`;
const $30c878c919e608d8$var$usePageTitle = (parts)=>{
    $bh6RR.useEffect(()=>{
        document.title = `${parts.join(" - ")} | ${$30c878c919e608d8$var$BASE_TITLE}`;
        return ()=>{
            document.title = $30c878c919e608d8$var$BASE_TITLE;
        };
    }, [
        parts
    ]);
};
const $30c878c919e608d8$var$PageTitle = ({ parts: parts })=>{
    $30c878c919e608d8$var$usePageTitle(parts);
    return null;
};
var $30c878c919e608d8$export$2e2bcd8739ae039 = $30c878c919e608d8$var$PageTitle;

});

parcelRegister("lNpFn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73db3f08a3f71fe1$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $506bB = parcelRequire("506bB");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $5CVHy = parcelRequire("5CVHy");

var $hL9jN = parcelRequire("hL9jN");

var $dUgAK = parcelRequire("dUgAK");

var $1W9Do = parcelRequire("1W9Do");

var $j5ldk = parcelRequire("j5ldk");

var $iZWBy = parcelRequire("iZWBy");

var $kclvT = parcelRequire("kclvT");

var $gfi3N = parcelRequire("gfi3N");

var $cbFbS = parcelRequire("cbFbS");

var $1lMle = parcelRequire("1lMle");

var $e8yyN = parcelRequire("e8yyN");
parcelRequire("cFAEN");
var $cK0UE = parcelRequire("cK0UE");

var $5MeqM = parcelRequire("5MeqM");
parcelRequire("a8DUk");
var $kkvif = parcelRequire("kkvif");

var $jP5af = parcelRequire("jP5af");

var $5EgP1 = parcelRequire("5EgP1");

var $jrL0R = parcelRequire("jrL0R");

var $W4f7l = parcelRequire("W4f7l");

var $4xl3n = parcelRequire("4xl3n");

var $ev1dj = parcelRequire("ev1dj");

var $3YcN0 = parcelRequire("3YcN0");

var $cbyJ0 = parcelRequire("cbyJ0");
var $73db3f08a3f71fe1$var$ErrorDialogType = /*#__PURE__*/ function(ErrorDialogType) {
    ErrorDialogType["GENERIC"] = "GENERIC";
    ErrorDialogType["TRAINER_BUSY"] = "TRAINER_BUSY";
    ErrorDialogType["MAINTENANCE"] = "MAINTENANCE";
    ErrorDialogType["OUT_OF_ORDER"] = "OUT_OF_ORDER";
    ErrorDialogType["SHUTDOWN"] = "SHUTDOWN";
    ErrorDialogType["UPDATING"] = "UPDATING";
    ErrorDialogType["NO_SUBSCRIPTION"] = "NO_SUBSCRIPTION";
    ErrorDialogType["UNKNOWN"] = "UNKNOWN";
    ErrorDialogType["INVALID_REFERENCE_NUMBER"] = "INVALID_REFERENCE_NUMBER";
    /**
     * Nothing is booked, so the trainer is free — but this club requires a booking. The
     * only reservation denial: a block held by somebody else lets the pairing through.
     */ ErrorDialogType["NO_RESERVATION"] = "NO_RESERVATION";
    return ErrorDialogType;
}($73db3f08a3f71fe1$var$ErrorDialogType || {});
/** The dialogs that should offer a way into the portal's booking screen. */ const $73db3f08a3f71fe1$var$RESERVATION_TYPES = [
    "NO_RESERVATION"
];
const $73db3f08a3f71fe1$var$RETRY_KEY = "pairselect";
const $73db3f08a3f71fe1$var$PAIRING_FAILURE = "Connection Failed";
function $73db3f08a3f71fe1$var$ErrorDialogMessage({ type: type }) {
    switch(type){
        case "SHUTDOWN":
            return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                component: "div",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                        component: "ol",
                        align: "left",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                children: "Hold red Stop button for 15 seconds until trainer lights in the back turn off"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                children: "Turn trainer back on and connect"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ldk.default), {
                        sx: {
                            m: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        sx: {
                            mx: 2,
                            mb: 2
                        },
                        children: "If you are able, wait until trainer shuts down and the lights go off, then turn back on and connect. This will take up to 2 minutes."
                    })
                ]
            });
        case "GENERIC":
            return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                        variant: "body2",
                        gutterBottom: true,
                        children: [
                            "Do not connect until the billboard says ",
                            /*#__PURE__*/ (0, $ih19M.jsx)("em", {
                                children: "Volley"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "body2",
                        gutterBottom: true,
                        children: "If you are still unable to connect, confirm the following:"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $iZWBy.default), {
                        component: "ol",
                        sx: {
                            listStyle: "outside",
                            listStyleType: "decimal",
                            px: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
                                sx: {
                                    display: "list-item",
                                    pl: 0.5
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                    variant: "body2",
                                    children: "The batteries are inserted and the trainer is turned on (green button at back of trainer)"
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
                                sx: {
                                    display: "list-item",
                                    pl: 0.5
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                    variant: "body2",
                                    children: "The LED(s) are on at back of the trainer"
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
                                sx: {
                                    display: "list-item",
                                    pl: 0.5
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                    variant: "body2",
                                    children: "Is the four digit connect code correct?"
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
                                sx: {
                                    display: "list-item",
                                    pl: 0.5
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                    variant: "body2",
                                    children: "If the trainer says \u201CNo Network\u201D on the billboard, contact support. You are likely experiencing network connection issues."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $jrL0R.default), {
                        children: "Message Support"
                    })
                ]
            });
        case "OUT_OF_ORDER":
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                textAlign: "center",
                gutterBottom: true,
                mb: 2,
                children: "Sorry, this trainer is currently out of order."
            });
        case "UPDATING":
            return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        textAlign: "center",
                        gutterBottom: true,
                        mb: 4,
                        children: "The trainer is currently updating. Please wait a moment and try again."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "body1",
                        fontWeight: "bold",
                        my: 2,
                        children: "Do not remove the batteries during this time or shut down the trainer. This could permanently damage the trainer."
                    })
                ]
            });
        case "TRAINER_BUSY":
            return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "body2",
                        textAlign: "center",
                        gutterBottom: true,
                        sx: {
                            mb: 2
                        },
                        children: "The trainer is still finishing the previous session. Wait a few seconds and connect again."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "body2",
                        textAlign: "center",
                        gutterBottom: true,
                        children: "If it keeps saying this, the trainer needs attention."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $jrL0R.default), {
                        children: "Message Support"
                    })
                ]
            });
        case "MAINTENANCE":
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                variant: "body2",
                textAlign: "center",
                gutterBottom: true,
                sx: {
                    mb: 2
                },
                children: "The trainer is currently in maintenance mode and being updated. Please leave the trainer powered on, and return it to the storage area. Thank you."
            });
        case "INVALID_REFERENCE_NUMBER":
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                textAlign: "center",
                children: "The 4 digit code you entered is invalid. Please check the code and try again."
            });
        case "NO_SUBSCRIPTION":
            return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                align: "center",
                children: [
                    "This location requires an access code to use the trainer.",
                    /*#__PURE__*/ (0, $ih19M.jsx)("br", {}),
                    "Please enter the code below."
                ]
            });
        case "NO_RESERVATION":
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                align: "center",
                children: "You need a reservation to use this trainer. It is open right now \u2014 book a session to get started."
            });
        default:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                variant: "body2",
                textAlign: "center",
                gutterBottom: true,
                sx: {
                    mb: 2
                },
                children: "Unknown error while pairing to trainer"
            });
    }
}
const $73db3f08a3f71fe1$var$isUnauthorized = (e)=>e?.errorCode === "PAIRING_NO_SUBSCRIPTION";
const $73db3f08a3f71fe1$var$isOutOfOrder = (e)=>e?.errorCode === "PAIRING_OUT_OF_ORDER";
const $73db3f08a3f71fe1$var$isNotConnectedError = (e)=>e?.errorCode === "PAIRING_NOT_CONNECTED";
const $73db3f08a3f71fe1$var$isInvalidReferenceNumberError = (e)=>e?.errorCode === "PAIRING_INVALID_REFERENCE_NUMBER";
const $73db3f08a3f71fe1$var$isPairingUnavailableError = (e)=>e?.errorCode === "PAIRING_UNAVAILABLE";
/**
 * The reservation gate's one denial: nothing is booked for this moment. (It used to also
 * refuse a block held by somebody else; that rule was dropped, so every reservation denial
 * now means the trainer is free and bookable.)
 */ const $73db3f08a3f71fe1$var$isNoReservationError = (e)=>e?.errorCode === "PAIRING_NO_RESERVATION";
/**
 * Why the trainer refused to pair.
 *
 * The server has sent both a structured `reason` and the "because: X" message
 * suffix since they were added together (#2518), so neither is a version-skew
 * fallback for the other. What is new is this app's ability to read the
 * structured one at all -- FetchError only started carrying the parsed body
 * recently -- so the field is preferred and the suffix kept as a cheap guard
 * against a response that arrives without a parsed body.
 */ function $73db3f08a3f71fe1$var$pairingUnavailableReason(e) {
    const body = e?.body;
    if (typeof body?.reason === "string") return body.reason;
    const match = /because: ([A-Z_]+)/.exec(e?.message ?? "");
    return match ? match[1] : null;
}
/**
 * Reasons the trainer clears on its own within seconds, so the user just needs
 * to wait -- nothing is wrong with the trainer.
 *
 * The reason is the coach ready state (webby-server `routes/sessions.ts` passes
 * through what `pairable.ts` returns), and IDLE/INIT/READY are the *pairable*
 * states, so they never arrive here. DEINIT -- the trainer winding down the
 * previous session -- is the only transient refusal coach can send.
 *
 * The ready state BUSY is deliberately absent and is not the same thing as
 * ErrorDialogType.TRAINER_BUSY: BUSY has no reducer entry in coach and nothing
 * transitions into it, so it cannot arrive as a refusal.
 */ const $73db3f08a3f71fe1$var$BUSY_REASONS = [
    "DEINIT"
];
/**
 * Whether a refusal is one the trainer will clear on its own. These are worth
 * waiting out: the pairing retry loop usually outlives them, so the user gets a
 * session instead of a dialog telling them to try again.
 */ const $73db3f08a3f71fe1$var$isTransientPairingFailure = (e)=>{
    const reason = $73db3f08a3f71fe1$var$pairingUnavailableReason(e);
    return reason !== null && $73db3f08a3f71fe1$var$BUSY_REASONS.includes(reason);
};
/**
 * EXITING_MAINTENANCE is as unreachable as BUSY today, and is listed only so
 * that wiring it up in coach does not silently fall through to the generic
 * dialog.
 */ const $73db3f08a3f71fe1$var$MAINTENANCE_REASONS = [
    "MAINTENANCE",
    "ENTERING_MAINTENANCE",
    "EXITING_MAINTENANCE"
];
/**
 * What a member can do about a reservation denial.
 *
 * Both denials offer booking, not just the "nothing is booked" one: being told the
 * trainer is taken is exactly when a member wants to find the next slot they *can* have,
 * and a dialog whose only action is "OK" leaves them to work that out on their own.
 *
 * The booking action needs the cohort flag as well as a configured portal — a member
 * outside the trial has no Club-in-Club account, so sending them there would strand them
 * on an onboarding screen for a club they cannot join. They still get the message.
 */ function $73db3f08a3f71fe1$var$ReservationActions({ onDismiss: onDismiss }) {
    const { features: features } = (0, $W4f7l.useCurrentUser)();
    const { available: available, opening: opening, error: error, open: open } = (0, $ev1dj.default)();
    const canBook = available && features.includes((0, $kkvif.CLUB_IN_CLUB_FEATURE));
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            canBook && /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                type: "button",
                variant: "contained",
                size: "large",
                fullWidth: true,
                color: "secondary",
                disabled: opening,
                onClick: ()=>void open({
                        screen: "book"
                    }),
                sx: {
                    mt: 1
                },
                children: opening ? "Opening\u2026" : "Book a session"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                type: "button",
                variant: canBook ? "text" : "contained",
                size: "large",
                fullWidth: true,
                color: canBook ? "primary" : "secondary",
                onClick: onDismiss,
                sx: {
                    mt: 1
                },
                children: canBook ? "Not now" : "OK"
            }),
            error && /*#__PURE__*/ (0, $ih19M.jsx)((0, $506bB.default), {
                severity: "error",
                children: error
            })
        ]
    });
}
function $73db3f08a3f71fe1$export$2e2bcd8739ae039({ alwaysAutoCalibrate: alwaysAutoCalibrate = false }) {
    const { autoCalibrate: autoCalibrate, pairingVerified: pairingVerified } = (0, $4xl3n.usePairingContext)();
    const { currentUser: currentUser, setCurrentUser: setCurrentUser } = (0, $W4f7l.useCurrentUser)();
    const [referenceNumber, setReferenceNumber] = $bh6RR.useState("####");
    const referenceNumberValid = referenceNumber.indexOf("#") === -1;
    const [waiverOpen, setWaiverOpen] = $bh6RR.useState(false);
    const [loadingOpen, setLoadingOpen] = $bh6RR.useState(false);
    const [errorOpen, setErrorOpen] = $bh6RR.useState(false);
    const [errorType, setErrorType] = $bh6RR.useState("GENERIC");
    const [errorHeader, setErrorHeader] = $bh6RR.useState($73db3f08a3f71fe1$var$PAIRING_FAILURE);
    $bh6RR.useEffect(()=>{
        (0, $1lMle.default).info("Resetting retry status on mount.");
        (0, $5MeqM.registerRetry)($73db3f08a3f71fe1$var$RETRY_KEY);
        return ()=>{
            (0, $1lMle.default).info("Cancelling retry on unmount...");
            (0, $5MeqM.cancelRetry)($73db3f08a3f71fe1$var$RETRY_KEY);
        };
    }, []);
    const goToTrainer = $bh6RR.useCallback(async (session)=>{
        const trainer = await (0, $cK0UE.default)(`/api/trainers/${session.sessionTrainers[0].trainerId}`);
        try {
            await (0, $5MeqM.retry)(async ()=>{
                const status = await (0, $cK0UE.default)(`/trainer/${trainer.clientId}/api/status?forceRefresh=true`);
                if (status?.session?.id !== session.id) throw new Error("Session on trainer doesn't match");
            }, $73db3f08a3f71fe1$var$RETRY_KEY, 1000, 5);
            pairingVerified(trainer.clientId, session.id);
        } catch (err) {
            setLoadingOpen(false);
            // The user closed the dialog; they are not waiting for news.
            if ((0, $5MeqM.isRetryCancelled)(err)) return;
            setErrorType("GENERIC");
            setErrorHeader($73db3f08a3f71fe1$var$PAIRING_FAILURE);
            setErrorOpen(true);
        }
    }, [
        pairingVerified
    ]);
    const pair = $bh6RR.useCallback(async ()=>{
        // Closing the loading dialog cancels the retry key, and the cancel flag
        // is sticky -- only registering clears it. Without this, one close
        // leaves every later Connect press rejecting before it reaches the
        // network, silently, for as long as this component stays mounted.
        (0, $5MeqM.registerRetry)($73db3f08a3f71fe1$var$RETRY_KEY);
        setLoadingOpen(true);
        try {
            const session = await (0, $5MeqM.retry)(async ()=>{
                const result = await (0, $cK0UE.default)("/api/sessions/pair", "POST", {
                    referenceNumber: referenceNumber,
                    autoCalibrate: typeof alwaysAutoCalibrate !== "undefined" && alwaysAutoCalibrate ? true : autoCalibrate
                });
                return result;
            }, $73db3f08a3f71fe1$var$RETRY_KEY, 1000, 15, (e)=>$73db3f08a3f71fe1$var$isInvalidReferenceNumberError(e) || $73db3f08a3f71fe1$var$isPairingUnavailableError(e) && !$73db3f08a3f71fe1$var$isTransientPairingFailure(e) || $73db3f08a3f71fe1$var$isOutOfOrder(e) || $73db3f08a3f71fe1$var$isUnauthorized(e) || // Nothing about a booking changes inside 15 seconds, so retrying
                // fifteen times only delays the dialog and hammers the gate.
                $73db3f08a3f71fe1$var$isNoReservationError(e));
            return session;
        // A hook in the session provider makes the user go into the trainer context when there's a session
        } catch (err) {
            setLoadingOpen(false);
            if ((0, $5MeqM.isRetryCancelled)(err)) {
                (0, $1lMle.default).info("Pairing cancelled by the user.");
                return null;
            }
            if ($73db3f08a3f71fe1$var$isOutOfOrder(err)) {
                setErrorHeader("Out of Order");
                setErrorType("OUT_OF_ORDER");
                setErrorOpen(true);
                (0, $1lMle.default).warn("User tried to pair with out of order trainer.");
                return null;
            }
            if ($73db3f08a3f71fe1$var$isNoReservationError(err)) {
                setErrorHeader("Reservation Needed");
                setErrorType("NO_RESERVATION");
                setErrorOpen(true);
                (0, $1lMle.default).warn("User tried to pair without a reservation");
                return null;
            }
            if ($73db3f08a3f71fe1$var$isUnauthorized(err)) {
                const fetchError = err;
                if (fetchError.errorCode === "PAIRING_NO_SUBSCRIPTION") {
                    setErrorHeader("Access Code Needed");
                    setErrorType("NO_SUBSCRIPTION");
                } else {
                    setErrorHeader("Unauthorized");
                    setErrorType("UNKNOWN");
                }
                setErrorOpen(true);
                (0, $1lMle.default).warn(`User tried to pair with unauthorized trainer: ${fetchError.errorCode ?? "?"}`);
                return null;
            }
            if ($73db3f08a3f71fe1$var$isPairingUnavailableError(err)) {
                const reason = $73db3f08a3f71fe1$var$pairingUnavailableReason(err);
                if (reason === "BOOT") {
                    // Boot error will help user check their battery, but it's also a catch all for
                    // many other problems. Further error message refinement would be needed later on
                    // throughout the various services such as motion and coach.
                    setErrorHeader("Check Batteries & Hardware");
                    setErrorType("GENERIC");
                } else if (reason === "SHUTDOWN") {
                    setErrorHeader("Trainer in Shutdown Process");
                    setErrorType("SHUTDOWN");
                } else if (reason === "UPDATING") {
                    setErrorHeader("Trainer is Updating");
                    setErrorType("UPDATING");
                } else if (reason !== null && $73db3f08a3f71fe1$var$BUSY_REASONS.includes(reason)) {
                    setErrorHeader("Trainer Busy");
                    setErrorType("TRAINER_BUSY");
                } else if (reason !== null && $73db3f08a3f71fe1$var$MAINTENANCE_REASONS.includes(reason)) {
                    setErrorHeader($73db3f08a3f71fe1$var$PAIRING_FAILURE);
                    setErrorType("MAINTENANCE");
                } else {
                    // An unrecognised reason is not evidence of maintenance --
                    // telling the user to put a working trainer away is worse
                    // than admitting we do not know why pairing failed.
                    setErrorHeader($73db3f08a3f71fe1$var$PAIRING_FAILURE);
                    setErrorType("GENERIC");
                }
                setErrorOpen(true);
                (0, $1lMle.default).warn(`User tried to pair while the trainer was unavailable: ${reason ?? "no reason given"}`);
                return null;
            }
            if ($73db3f08a3f71fe1$var$isNotConnectedError(err)) {
                setErrorHeader("Trainer Not Connected");
                setErrorType("GENERIC");
                setErrorOpen(true);
                (0, $1lMle.default).warn("User tried to pair before trainer was connected to bridge.");
                return null;
            }
            if ($73db3f08a3f71fe1$var$isInvalidReferenceNumberError(err)) {
                setErrorHeader("Invalid Code");
                setErrorType("INVALID_REFERENCE_NUMBER");
                setErrorOpen(true);
                (0, $1lMle.default).warn(`User tried to pair with an invalid reference number: ${referenceNumber}`);
                return null;
            }
            (0, $1lMle.default).warn("Unable to pair with trainer after 15 tries.", {
                error: err.message
            });
            setErrorType("GENERIC");
            setErrorHeader($73db3f08a3f71fe1$var$PAIRING_FAILURE);
            setErrorOpen(true);
            return null;
        }
    }, [
        referenceNumber,
        autoCalibrate,
        alwaysAutoCalibrate
    ]);
    const onSubmit = $bh6RR.useCallback(async (e)=>{
        e.preventDefault();
        if (currentUser && !currentUser.termsOfServiceAcceptedAt) {
            setWaiverOpen(true);
            return;
        }
        const session = await pair();
        if (session) await goToTrainer(session);
    }, [
        pair,
        currentUser,
        goToTrainer
    ]);
    const onWaiverClose = $bh6RR.useCallback(async (accepted)=>{
        setWaiverOpen(false);
        if (accepted && currentUser) {
            setCurrentUser({
                ...currentUser,
                termsOfServiceAcceptedAt: new Date()
            });
            const session = await pair();
            if (session) await goToTrainer(session);
        }
    }, [
        currentUser,
        setCurrentUser,
        pair,
        goToTrainer
    ]);
    const onPromoCodeEntryDone = $bh6RR.useCallback(async ()=>{
        setErrorOpen(false);
        const session = await pair();
        if (session) await goToTrainer(session);
    }, [
        pair,
        goToTrainer
    ]);
    const onLoadingClosed = $bh6RR.useCallback(()=>{
        (0, $1lMle.default).info("Cancelling retry on dialog close");
        setLoadingOpen(false);
        (0, $5MeqM.cancelRetry)($73db3f08a3f71fe1$var$RETRY_KEY);
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $hL9jN.default), {
        maxWidth: "xs",
        component: "form",
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                variant: "h3",
                component: "h2",
                sx: {
                    mt: 2,
                    fontSize: "17pt"
                },
                gutterBottom: true,
                color: "primary.main",
                children: "Enter Trainer ID to Begin"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ldk.default), {
                sx: {
                    my: 2,
                    borderColor: (0, $e8yyN.default).palette.primary.main
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $iZWBy.default), {
                component: "ol",
                sx: {
                    listStyle: "outside",
                    listStyleType: "decimal",
                    px: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
                        sx: {
                            display: "list-item",
                            pl: 0.5
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                            children: "If the trainer is off, power on by pressing the green button, located at the rear of the trainer."
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
                        sx: {
                            display: "list-item",
                            pl: 0.5
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                            children: "Enter the 4 digit number located on the side of the trainer."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $5EgP1.default), {
                value: referenceNumber,
                onChange: setReferenceNumber
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                component: "div",
                sx: {
                    my: 2
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                    type: "submit",
                    variant: "contained",
                    size: "large",
                    fullWidth: true,
                    color: "secondary",
                    disabled: !referenceNumberValid,
                    children: "Connect"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbyJ0.default), {
                open: waiverOpen,
                onClose: onWaiverClose
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dUgAK.default), {
                open: loadingOpen,
                onClose: ()=>onLoadingClosed(),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                        onClose: ()=>onLoadingClosed(),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "h4",
                            component: "p",
                            color: "primary",
                            children: "Connecting to the Trainer"
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ldk.default), {
                        sx: {
                            mx: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                align: "center",
                                variant: "body2",
                                gutterBottom: true,
                                children: "Please wait a moment while we connect with the trainer."
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                component: "div",
                                display: "flex",
                                justifyContent: "center",
                                my: 2,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                                    variant: "indeterminate",
                                    color: "info",
                                    size: 60
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dUgAK.default), {
                open: errorOpen,
                onClose: ()=>setErrorOpen(false),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                        onClose: ()=>setErrorOpen(false),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "h4",
                            component: "p",
                            color: "primary",
                            children: errorHeader
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ldk.default), {
                        sx: {
                            mx: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)($73db3f08a3f71fe1$var$ErrorDialogMessage, {
                                type: errorType
                            }),
                            errorType === "NO_SUBSCRIPTION" ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $3YcN0.default), {
                                onDone: onPromoCodeEntryDone
                            }) : $73db3f08a3f71fe1$var$RESERVATION_TYPES.includes(errorType) ? /*#__PURE__*/ (0, $ih19M.jsx)($73db3f08a3f71fe1$var$ReservationActions, {
                                onDismiss: ()=>setErrorOpen(false)
                            }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                type: "button",
                                variant: "contained",
                                size: "large",
                                fullWidth: true,
                                color: "secondary",
                                onClick: ()=>setErrorOpen(false),
                                sx: {
                                    mt: 1
                                },
                                children: "OK"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("5EgP1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1afcc01c799d5ca6$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $8JNI1 = parcelRequire("8JNI1");

var $hrqHU = parcelRequire("hrqHU");

var $l0oRz = parcelRequire("l0oRz");
const $1afcc01c799d5ca6$var$DigitField = (0, $l0oRz.default)((0, $hrqHU.default))({
    "& label": {
        color: (t)=>t.palette.primary.main
    },
    "& .MuiOutlinedInput-root": {
        "& input": {
            fontSize: "2.5rem",
            textAlign: "center"
        },
        "&:hover fieldset": {
            borderColor: (t)=>t.palette.primary.main
        },
        "&.Mui-focused fieldset": {
            borderColor: (t)=>t.palette.primary.main
        }
    },
    "& .MuiOutlinedInput-root:active, & .MuiOutlinedInput-root:focus, & .MuiOutlinedInput-root:focus-within": {
        "& .MuiIconButton-root": {
            color: (t)=>t.palette.primary.main
        }
    }
});
function $1afcc01c799d5ca6$var$useFocus() {
    const ref = $bh6RR.useRef(null);
    const setFocus = ()=>{
        if (ref.current) ref.current.focus();
    };
    return [
        ref,
        setFocus
    ];
}
function $1afcc01c799d5ca6$export$2e2bcd8739ae039({ value: value, onChange: onChange }) {
    const ref0 = $1afcc01c799d5ca6$var$useFocus();
    const ref1 = $1afcc01c799d5ca6$var$useFocus();
    const ref2 = $1afcc01c799d5ca6$var$useFocus();
    const ref3 = $1afcc01c799d5ca6$var$useFocus();
    const focusRefs = $bh6RR.useMemo(()=>[
            ref0,
            ref1,
            ref2,
            ref3
        ], [
        ref0,
        ref1,
        ref2,
        ref3
    ]);
    const handleChange = $bh6RR.useCallback((index, inputValue)=>{
        const parts = value.split("");
        const digit = inputValue.replace(/\D/g, "").slice(-1);
        if (digit) {
            parts[Math.min(index, 3)] = digit;
            focusRefs[Math.min(index + 1, 3)][1]();
        } else parts[index] = "#";
        onChange(parts.join(""));
    }, [
        focusRefs,
        value,
        onChange
    ]);
    const handleKeyDown = $bh6RR.useCallback((index, e)=>{
        if (e.key === "Backspace" && value.charAt(index) === "#" && index > 0) {
            e.preventDefault();
            const parts = value.split("");
            parts[index - 1] = "#";
            focusRefs[index - 1][1]();
            onChange(parts.join(""));
        }
    }, [
        focusRefs,
        value,
        onChange
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8JNI1.default), {
        direction: "row",
        spacing: 2,
        children: [
            0,
            1,
            2,
            3
        ].map((i)=>/*#__PURE__*/ (0, $ih19M.jsx)($1afcc01c799d5ca6$var$DigitField, {
                type: "text",
                margin: "normal",
                name: `fourDigitInput${i + 1}`,
                value: value.charAt(i) === "#" ? "" : value.charAt(i),
                onChange: (e)=>handleChange(i, e.target.value),
                onKeyDown: (e)=>handleKeyDown(i, e),
                autoFocus: i === 0,
                autoComplete: "off",
                placeholder: "#",
                slotProps: {
                    htmlInput: {
                        ref: focusRefs[i][0],
                        inputMode: "numeric",
                        maxLength: 1,
                        "aria-label": `Code ${i + 1}`
                    }
                }
            }, i))
    });
}

});

parcelRegister("jrL0R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $534c68d8451602fc$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $eedE5 = parcelRequire("eedE5");

var $cbFbS = parcelRequire("cbFbS");

var $bDIpx = parcelRequire("bDIpx");
function $534c68d8451602fc$export$2e2bcd8739ae039({ TypographyProps: TypographyProps = {}, preText: preText = "", message: message, onEscalate: onEscalate, children: children, ...props }) {
    const intercom = (0, $bDIpx.default)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
        variant: "body2",
        align: "center",
        sx: {
            my: 2
        },
        ...TypographyProps,
        children: [
            `${preText ?? ""} `,
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                ...props,
                type: "button",
                onClick: ()=>{
                    onEscalate?.();
                    intercom.newMessage(message);
                },
                variant: "text",
                color: "info",
                children: children
            })
        ]
    });
}

});

parcelRegister("ev1dj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $181770f1b834dd12$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("eyjy7");
var $fgDKG = parcelRequire("fgDKG");

var $jdCKi = parcelRequire("jdCKi");

var $5rkdj = parcelRequire("5rkdj");

var $cK0UE = parcelRequire("cK0UE");

var $loAb5 = parcelRequire("loAb5");
const $181770f1b834dd12$var$TIMEOUT_MS = 10000;
function $181770f1b834dd12$export$2e2bcd8739ae039() {
    const [opening, setOpening] = $bh6RR.useState(false);
    const [error, setError] = $bh6RR.useState(null);
    const request = $bh6RR.useRef(null);
    const active = $bh6RR.useRef(false);
    $bh6RR.useEffect(()=>{
        active.current = true;
        return ()=>{
            active.current = false;
            request.current?.abort();
        };
    }, []);
    const open = $bh6RR.useCallback(async (target)=>{
        // Click-only: rendering a dialog must never mint a credential.
        if (!(0, $jdCKi.default).clubInClubUrl || request.current) return;
        const signedInAs = (0, $fgDKG.p)().currentUser;
        if (!signedInAs) {
            setError("Please sign in to Volley before opening your membership.");
            return;
        }
        const controller = new AbortController();
        const timeout = window.setTimeout(()=>controller.abort(), $181770f1b834dd12$var$TIMEOUT_MS);
        request.current = controller;
        setOpening(true);
        setError(null);
        try {
            const { token: token } = await (0, $cK0UE.default)("/api/users/token", "GET", undefined, {
                signal: controller.signal,
                cache: "no-store"
            });
            if (!active.current || controller.signal.aborted) return;
            if ((0, $fgDKG.p)().currentUser !== signedInAs) {
                setError("Your sign-in changed. Please try again.");
                return;
            }
            if (typeof token !== "string" || !token.trim()) throw new Error("Missing handoff token");
            const destination = new URL((0, $jdCKi.default).clubInClubUrl);
            destination.searchParams.set("token", token);
            (0, $5rkdj.addWebbySession)(destination);
            if (target) {
                destination.searchParams.set("screen", target.screen);
                for (const [key, value] of Object.entries(target.params ?? {}))destination.searchParams.set(key, value);
            }
            // In place, not a new tab: the portal shows a "← Back to Volley" link in this
            // webview and replaces the cleaned URL, so both it and webview-back return
            // here. A new tab becomes a Safari sheet with its own session and no way back.
            (0, $loAb5.navigateTo)(destination.href);
        } catch  {
            if (active.current) setError("Unable to open Volley membership. Please try again.");
        } finally{
            window.clearTimeout(timeout);
            request.current = null;
            if (active.current) setOpening(false);
        }
    }, []);
    return {
        available: Boolean((0, $jdCKi.default).clubInClubUrl),
        opening: opening,
        error: error,
        open: open
    };
}

});
parcelRegister("5rkdj", function(module, exports) {

$parcel$export(module.exports, "addWebbySession", function () { return $ed676cc88b9ea179$export$b5912710814007d9; });

var $6Wfmo = parcelRequire("6Wfmo");
function $ed676cc88b9ea179$export$b5912710814007d9(destination) {
    const session = (0, $6Wfmo.datadogRum).getInternalContext()?.session_id;
    if (session) destination.searchParams.set("webby_session", session);
}

});

parcelRegister("loAb5", function(module, exports) {

$parcel$export(module.exports, "navigateTo", function () { return $5fc763cc75468f53$export$971646e43cc4a11b; });
/**
 * Leave the app for another origin, without handing it our URL.
 *
 * `no-referrer` because the destination has no business knowing which Volley screen sent
 * the member, and the URL that sends them has, moments earlier, carried a handoff token
 * in its query string.
 *
 * An anchor rather than `window.location.assign` because only the anchor carries a
 * referrer policy. It is also a named seam: jsdom implements neither navigation nor a
 * configurable `location`, so a test can observe this and cannot observe what it wraps.
 */ function $5fc763cc75468f53$export$971646e43cc4a11b(url) {
    const link = document.createElement("a");
    link.href = url;
    link.referrerPolicy = "no-referrer";
    link.click();
}

});


parcelRegister("3YcN0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05a8ce33145c338d$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ltQuT = parcelRequire("ltQuT");

var $eedE5 = parcelRequire("eedE5");

var $8JNI1 = parcelRequire("8JNI1");

var $hrqHU = parcelRequire("hrqHU");

var $1lMle = parcelRequire("1lMle");
parcelRequire("cFAEN");
var $cK0UE = parcelRequire("cK0UE");
function $05a8ce33145c338d$export$2e2bcd8739ae039({ onDone: onDone }) {
    const [promoCode, setPromoCode] = $bh6RR.useState("");
    const [loading, setLoading] = $bh6RR.useState(false);
    const [errorMessage, setErrorMessage] = $bh6RR.useState("");
    const onSubmit = $bh6RR.useCallback(async (event)=>{
        event.preventDefault();
        setErrorMessage("");
        setLoading(true);
        let config;
        try {
            config = await (0, $cK0UE.default)("/api/signup/config");
        } catch (e) {
            setErrorMessage("Error configuring account to pair with this trainer");
            setLoading(false);
            (0, $1lMle.default).error(e.message);
            return;
        }
        try {
            const payload = {
                priceId: config.prices.platform_tennis_yearly.id,
                promoCode: promoCode
            };
            await (0, $cK0UE.default)("/api/signup/invoice-preview", "POST", payload);
        } catch (e) {
            setErrorMessage("Invalid code. Please try again");
            setLoading(false);
            (0, $1lMle.default).error(e.message);
            return;
        }
        try {
            const payload = {
                isFreeForever: true,
                priceId: config.prices.platform_tennis_yearly.id,
                promoCode: promoCode
            };
            await (0, $cK0UE.default)("/api/signup/subscriptions", "POST", payload);
        } catch (e) {
            setErrorMessage("Could not complete club registration.");
            (0, $1lMle.default).error(e.message);
            return;
        } finally{
            setLoading(false);
        }
        onDone();
    }, [
        promoCode,
        onDone
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
        spacing: 2,
        pt: 2,
        component: "form",
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $hrqHU.default), {
                disabled: loading,
                name: "promoCode",
                id: "promoCode",
                label: "Code",
                value: promoCode,
                onChange: (e)=>setPromoCode(e.currentTarget.value),
                error: !!errorMessage,
                helperText: errorMessage
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                type: "submit",
                color: "secondary",
                variant: "contained",
                disabled: loading || promoCode.length < 3,
                startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ltQuT.default), {}),
                children: "Submit"
            })
        ]
    });
}

});

parcelRegister("cbyJ0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63cd0448adcdda5a$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $3Xpkr = parcelRequire("3Xpkr");

var $5hUVC = parcelRequire("5hUVC");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $8SbZe = parcelRequire("8SbZe");

var $5CVHy = parcelRequire("5CVHy");

var $dUgAK = parcelRequire("dUgAK");

var $5jlmt = parcelRequire("5jlmt");

var $fMPxo = parcelRequire("fMPxo");

var $1lA67 = parcelRequire("1lA67");

var $4rInl = parcelRequire("4rInl");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $aOb5j = parcelRequire("aOb5j");

var $cI8xM = parcelRequire("cI8xM");
parcelRequire("cFAEN");
var $cK0UE = parcelRequire("cK0UE");
var $fEgSm = parcelRequire("fEgSm");

var $W4f7l = parcelRequire("W4f7l");
// Accepting the waiver blocks the whole first-pair flow, and it's often done on
// a flaky court network, so allow more time than the default fetch timeout.
const $63cd0448adcdda5a$var$ACCEPT_TIMEOUT_MS = 30000;
function $63cd0448adcdda5a$export$2e2bcd8739ae039({ open: open, onClose: onClose }) {
    const { currentUser: currentUser } = (0, $W4f7l.useCurrentUser)();
    const textRef = $bh6RR.useRef(null);
    const [accepting, setAccepting] = $bh6RR.useState(false);
    const [acceptFailed, setAcceptFailed] = $bh6RR.useState(false);
    const [showVScrollIndicator, setShowVScrollIndicator] = $bh6RR.useState(true);
    const theme = (0, $aOb5j.default)();
    const fullScreen = (0, $cI8xM.default)(theme.breakpoints.down("md"));
    // Bumped whenever the dialog opens or closes, which abandons any acceptance
    // still in flight so its late result can't touch state or close the dialog.
    const attempt = $bh6RR.useRef(0);
    const onAccept = $bh6RR.useCallback(async ()=>{
        if (!currentUser || accepting) return;
        attempt.current += 1;
        const thisAttempt = attempt.current;
        setAccepting(true);
        setAcceptFailed(false);
        try {
            await (0, $cK0UE.default)(`/api/users/${currentUser.id}/terms-of-service`, "PUT", undefined, (0, $fEgSm.timeoutInit)($63cd0448adcdda5a$var$ACCEPT_TIMEOUT_MS));
        } catch (e) {
            // Leave the dialog open with the checkbox cleared so the user can retry.
            (0, $cK0UE.logFetchError)(e, "Failed to accept terms of service");
            if (attempt.current === thisAttempt) {
                setAcceptFailed(true);
                setAccepting(false);
            }
            return;
        }
        if (attempt.current !== thisAttempt) return;
        setAccepting(false);
        onClose(true);
    }, [
        currentUser,
        onClose,
        accepting
    ]);
    // The dialog stays mounted when closed, so reset on every open change: the
    // user can dismiss mid-flight, and that attempt's failure (or success) must
    // not surface the next time the waiver is opened.
    $bh6RR.useEffect(()=>{
        attempt.current += 1;
        setAccepting(false);
        setAcceptFailed(false);
    }, [
        open
    ]);
    const ticking = $bh6RR.useRef(false);
    const onScroll = ()=>{
        if (ticking.current) return;
        window.requestAnimationFrame(()=>{
            if (!textRef.current) return;
            const { top: top, bottom: bottom } = textRef.current.getBoundingClientRect();
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;
            if (top < windowHeight && bottom >= 0) setShowVScrollIndicator(false);
            else setShowVScrollIndicator(true);
            ticking.current = false;
        });
        ticking.current = true;
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dUgAK.default), {
        fullScreen: fullScreen,
        open: open,
        onClose: ()=>onClose(false),
        PaperProps: {
            onScroll: onScroll
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1lA67.default), {
                container: true,
                direction: "row",
                alignItems: "center",
                sx: {
                    p: 3
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1lA67.default), {
                        size: 10,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "h3",
                            component: "h1",
                            children: "Liability Waiver"
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1lA67.default), {
                        sx: {
                            textAlign: "right"
                        },
                        size: 2,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                            onClick: ()=>onClose(false),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3Xpkr.default), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                sx: {
                    p: 2
                },
                children: "Please carefully read the terms of use and liability waiver below. You will have to agree to these terms to use the training machine."
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                component: "div",
                p: 2,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "h5",
                        component: "h2",
                        gutterBottom: true,
                        children: "RELEASE OF LIABILITY AND ASSUMPTION OF RISK"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        gutterBottom: true,
                        children: "I desire to use Volley (the \u201CTrainer\u201D), which is an automated tennis ball trainer/throwing machine (the \u201CActivity\u201D) provided by Volley LLC, a Pennsylvania Limited Liability Corporation (the \u201CCompany\u201D) at 1811 Rohrerstown Rd, Lancaster PA 17601. In consideration of being permitted by the Company to engage in the Activity/the intangible value that I will gain by participating in the Activity, and in recognition of the Company's reliance hereon, I agree to all of the terms and conditions set forth below (this \u201CRelease\u201D)."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        gutterBottom: true,
                        children: "1. I am aware and understand that the Activity is a potentially dangerous activity and involves the risk of serious injury, disability, death, and property damage, including, but not limited to, property damage or injury resulting from misaimed or \u201Cwild\u201D balls thrown by the Trainer, balls that ricochet off a paddle or part of the court, balls on the ground that can cause a slip, trip or fall, Trainer tipping over on a person or property, injury to or loss of limbs (including fingers or hair) caught in Trainer moving parts, balls falling on persons or property while loading into the ball bin, and possible electric shock. I am also aware of the highly contagious nature of bacterial and viral diseases, including the 2019 novel coronavirus disease (COVID-19) collectively, the \u201CDisease\u201D) and the risk that I may be exposed to or contract the Disease by engaging in the Activity, which may result in serious illness, personal injury, disability, death, and/or property damage. I acknowledge that these risks may result from or be compounded by the actions, omissions, or negligence of Company employees or others, including negligent emergency response or rescue operations of the Company. I understand that while the Company has implemented measures to reduce the risk of injury from the Activity and the spread of the Disease, the Company cannot guarantee that I will not be injured or become infected with the Disease or other infectious diseases due to my participation in the Activity and that engaging in the Activity may increase my risk of contracting the Disease. NOTWITHSTANDING THESE RISKS, I ACKNOWLEDGE THAT I AM VOLUNTARILY PARTICIPATING IN THE ACTIVITY WITH KNOWLEDGE OF THE DANGERS INVOLVED. I HEREBY AGREE TO ACCEPT AND ASSUME ALL RISKS OF INJURY, ILLNESS, DISABILITY, DEATH, AND/OR PROPERTY DAMAGE ARISING FROM MY ENGAGING IN THE ACTIVITY, WHETHER CAUSED BY THE ORDINARY NEGLIGENCE OF THE COMPANY OR OTHERWISE."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        gutterBottom: true,
                        children: "2. I hereby expressly waive and release any and all claims, now known or hereafter known, against the Company and its affiliates and their respect officers, directors, manager(s), employees, agents, shareholders/members, successors, and assigns (collectively, \u201CReleasees\u201D), on account of injury, illness, disability, death, or property damage arising out of or attributable to the Activity, whether arising out of the ordinary negligence of the Company or any Releasees or otherwise. I covenant not to make or bring any such claim against the Company or any other Releasee, and forever release and discharge the Company and all other Releasees from liability under such claims. This waiver and release does not extend to claims for gross negligence, willful misconduct, or any other liabilities that Pennsylvania law does not permit to be released by agreement."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        gutterBottom: true,
                        children: "3. I confirm that I am: (a) in good health, in proper physical condition, and do not have any medical or other conditions that would impair my ability to participate in the Activity; and (b) not experiencing symptoms of the Disease (such as cough, shortness of breath, or fever), do not have a confirmed or suspected case of the Disease, and have not come in contact in the last 14 days with a person who has been confirmed to have or suspected of having the Disease. I will comply with all federal, state, and local laws, orders, directives, and guidelines related to the Activity and the Disease while participating in the Activity, including, without limitation, requirements related to hand sanitation, social distancing, and use of face coverings and safety equipment. I will also follow all instructions, recommendations, and cautions of the Company at all times during the Activity. If at any time I believe conditions to be unsafe, that I am no longer in proper physical condition to participate in the Activity, or I begin experiencing symptoms of the Disease, I will immediately discontinue further participation in the Activity."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        gutterBottom: true,
                        children: "4. I shall defend, indemnify, and hold harmless the Company and all other Releasees against any and all losses, damages, liabilities, deficiencies, claims, actions, judgments, settlements, interest, awards, penalties, fines, costs, or expenses of whatever kind, including reasonable attorney fees, fees, the costs of enforcing any right to indemnification under this Release, and the cost of pursuing any insurance providers, incurred by/awarded against the Company or any other Releasees, arising out or resulting from my participation in the Activity, including injury to third parties, including third parties that I invite to participate in or observe the Activity, which occurs during the Activity, and including any claim related to my own negligence or the ordinary negligence of the Company."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        gutterBottom: true,
                        children: "5. I hereby consent to receive medical treatment deemed necessary if I am injured or require medical attention during my participation in the Activity. I understand and agree that I am solely responsible for all costs related to such medical treatment and any related medical transportation and/or evacuation. I hereby release, forever discharge, and hold harmless the Company from any claim based on such treatment or other medical services."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                        gutterBottom: true,
                        children: [
                            "6. Any dispute, controversy or claim arising out of or relating in any way to this Agreement or the Activity including, without limitation, any dispute concerning the construction, validity, interpretation, enforceability or breach of the Agreement, shall be exclusively resolved by binding arbitration upon a Party\u2019s submission of the dispute to arbitration. The demand for arbitration shall be made within a reasonable time after the claim, dispute or other matter in question has arisen, and in no event shall it be made after two years from when the aggrieved party knew or should have known of the controversy, claim, dispute or breach. The arbitration shall be conducted by one arbitrators. If the Parties are not able to agree upon the selection of an arbitrator, within twenty days of commencement of an arbitration proceeding by service of a demand for arbitration, the arbitrator shall be selected. The arbitration shall be conducted in accordance with the then existing Commercial Rules of the American Arbitration Association and shall be held in Lancaster, Pa.",
                            /*#__PURE__*/ (0, $ih19M.jsx)("br", {}),
                            "It is the intent of the parties that, barring extraordinary circumstances, arbitration proceedings will be concluded within one hundred and twenty days from the date the arbitrators are appointed. The arbitrators may extend this time limit in the interests of justice. Failure to adhere to this time limit shall not constitute a basis for challenging the award. The Parties shall not be entitled to discovery in the arbitration. The Parties shall exchange a copy of all exhibits for the arbitration hearing and shall identify each witness who will testify at the arbitration, with a summary of the anticipated testimony of such witness [ten] days before the arbitration hearing.",
                            /*#__PURE__*/ (0, $ih19M.jsx)("br", {}),
                            "Each party shall pay its own proportionate share of arbitrator fees and expenses and the arbitration fees and expenses of the American Arbitration Association. The arbitrator[s] shall be entitled to award the foregoing arbitration and administrative fees and expenses as damages in his/her discretion."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        gutterBottom: true,
                        children: "7. This Release constitutes the sole and entire agreement of the Company and me with respect to the subject matter contained herein and supersedes all prior and contemporaneous understandings, agreements, representations, and warranties, both written and oral, with respect to such subject matter. If any term or provision of this Release is invalid, illegal, or unenforceable in any jurisdiction, such invalidity, illegality, or unenforceability shall not affect any other term or provision of this Release or invalidate or render unenforceable such term or provision in any other jurisdiction. This Release is binding on and shall inure to the benefit of the Company and me and our respective successors and assigns. All matters arising out of or relating to this Release shall be governed by and construed in accordance with the internal laws of the State of Pennsylvania without giving effect to any choice or conflict of law provision or rule (whether of the State of Pennsylvania or any other jurisdiction). Any claim or cause of action arising under this Release may be brought only in the federal and state courts located in Lancaster County, Pennsylvania and I hereby consent to the exclusive jurisdiction of such courts."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        gutterBottom: true,
                        children: "I ACKNOWLEDGE THAT I HAVE READ AND UNDERSTOOD ALL OF THE TERMS OF THIS RELEASE AND THAT I AM VOLUNTARILY GIVING UP SUBSTANTIAL LEGAL RIGHTS, INCLUDING THE RIGHT TO SUE THE COMPANY."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                spacing: 2,
                ref: textRef,
                sx: {
                    mx: 2,
                    mb: 4
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        sx: {
                            mt: 2
                        },
                        children: "THIS IS A RELEASE OF LIABILITY - DO NOT SIGN IT UNLESS YOU AGREE TO BE BOUND BY ITS TERMS."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                        spacing: 2,
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $fMPxo.default), {
                                htmlFor: "termsAccepted",
                                label: "Tap to agree",
                                control: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8SbZe.default), {
                                    id: "termsAccepted",
                                    checked: accepting,
                                    disabled: accepting,
                                    onChange: (e)=>{
                                        if (e.target.checked) onAccept();
                                    },
                                    sx: {
                                        "& .MuiSvgIcon-root": {
                                            fontSize: 32
                                        }
                                    }
                                })
                            }),
                            accepting && /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                                color: "info",
                                size: 24
                            })
                        ]
                    }),
                    acceptFailed && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                color: "error",
                                align: "center",
                                children: "We were unable to save your agreement. Please check your connection and try again."
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                type: "button",
                                variant: "contained",
                                color: "secondary",
                                onClick: ()=>void onAccept(),
                                children: "Try Again"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5jlmt.default), {
                variant: "extended",
                "aria-label": "keep scrolling down",
                sx: {
                    position: "fixed",
                    display: showVScrollIndicator ? "flex" : "none",
                    bottom: fullScreen ? 10 : 40,
                    left: "50%",
                    right: "50%",
                    transform: "translateX(-50%)",
                    opacity: 0.9,
                    width: 300,
                    cursor: "default"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $5hUVC.default), {
                        sx: {
                            mr: 1
                        }
                    }),
                    "Scroll down to accept"
                ]
            })
        ]
    });
}

});
parcelRegister("5hUVC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d9ab309c32493ff$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $3d9ab309c32493ff$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 13.5L7.5 11l1.42-1.41L12 12.67l3.08-3.08L16.5 11z"
}), 'ExpandCircleDown');

});

parcelRegister("5jlmt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ddf4c07e26e94f3$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $fbTZq = parcelRequire("fbTZq");

var $krx4P = parcelRequire("krx4P");

var $fkCx1 = parcelRequire("fkCx1");

var $b6vKX = parcelRequire("b6vKX");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $4B5Or = parcelRequire("4B5Or");

var $OEXBZ = parcelRequire("OEXBZ");

var $ih19M = parcelRequire("ih19M");
'use client';
const $3ddf4c07e26e94f3$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `size${(0, $krx4P.default)(size)}`,
            color === 'inherit' ? 'colorInherit' : color
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $fkCx1.getFabUtilityClass), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $3ddf4c07e26e94f3$var$FabRoot = (0, $l0oRz.default)((0, $fbTZq.default), {
    name: 'MuiFab',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $b6vKX.default)(prop) || prop === 'classes',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $krx4P.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            styles[(0, $krx4P.default)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        ...theme.typography.button,
        minHeight: 36,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: '50%',
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.grey[900] : theme.palette.getContrastText?.(theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: 'none'
        },
        [`&.${(0, $fkCx1.default).focusVisible}`]: {
            boxShadow: (theme.vars || theme).shadows[6]
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 40,
                    height: 40
                }
            },
            {
                props: {
                    size: 'medium'
                },
                style: {
                    width: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended'
                },
                style: {
                    borderRadius: 24,
                    padding: '0 16px',
                    width: 'auto',
                    minHeight: 'auto',
                    minWidth: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'small'
                },
                style: {
                    width: 'auto',
                    padding: '0 8px',
                    borderRadius: 17,
                    minWidth: 34,
                    height: 34
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'medium'
                },
                style: {
                    width: 'auto',
                    padding: '0 16px',
                    borderRadius: 20,
                    minWidth: 40,
                    height: 40
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            }
        ]
    })), (0, $gfPc7.default)(({ theme: theme })=>({
        variants: [
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)([
                'dark',
                'contrastText'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].contrastText,
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        '&:hover': {
                            backgroundColor: (theme.vars || theme).palette[color].dark,
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    })), (0, $gfPc7.default)(({ theme: theme })=>({
        [`&.${(0, $fkCx1.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    })));
const $3ddf4c07e26e94f3$var$Fab = /*#__PURE__*/ $bh6RR.forwardRef(function Fab(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiFab'
    });
    const { children: children, className: className, color: color = 'default', component: component = 'button', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = 'large', variant: variant = 'circular', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    };
    const classes = $3ddf4c07e26e94f3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($3ddf4c07e26e94f3$var$FabRoot, {
        className: (0, $aPsoC.default)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $aPsoC.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref,
        ...other,
        classes: classes,
        children: children
    });
});
var $3ddf4c07e26e94f3$export$2e2bcd8739ae039 = $3ddf4c07e26e94f3$var$Fab;

});
parcelRegister("fkCx1", function(module, exports) {

$parcel$export(module.exports, "getFabUtilityClass", function () { return $b2969cdc75290131$export$e2cfa0ca4bce1fc2; });
$parcel$export(module.exports, "default", function () { return $b2969cdc75290131$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $b2969cdc75290131$export$e2cfa0ca4bce1fc2(slot) {
    return (0, $dmzXD.default)('MuiFab', slot);
}
const $b2969cdc75290131$var$fabClasses = (0, $fYlYP.default)('MuiFab', [
    'root',
    'primary',
    'secondary',
    'extended',
    'circular',
    'focusVisible',
    'disabled',
    'colorInherit',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'info',
    'error',
    'warning',
    'success'
]);
var $b2969cdc75290131$export$2e2bcd8739ae039 = $b2969cdc75290131$var$fabClasses;

});




parcelRegister("fQfP9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b887fcac5d535ac2$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $b887fcac5d535ac2$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');

});

parcelRegister("jcydt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfa9adf82c89162c$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $dfa9adf82c89162c$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), 'Menu');

});

parcelRegister("j7UqF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $deca7163a8233953$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $ktROk = parcelRequire("ktROk");

var $96ZcP = parcelRequire("96ZcP");

var $ft3X3 = parcelRequire("ft3X3");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $4B5Or = parcelRequire("4B5Or");

var $OEXBZ = parcelRequire("OEXBZ");

var $krx4P = parcelRequire("krx4P");

var $cAKIb = parcelRequire("cAKIb");

var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
const $deca7163a8233953$var$RADIUS_STANDARD = 10;
const $deca7163a8233953$var$RADIUS_DOT = 4;
const $deca7163a8233953$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, $krx4P.default)(anchorOrigin.vertical)}${(0, $krx4P.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $krx4P.default)(anchorOrigin.vertical)}${(0, $krx4P.default)(anchorOrigin.horizontal)}${(0, $krx4P.default)(overlap)}`,
            `overlap${(0, $krx4P.default)(overlap)}`,
            color !== 'default' && `color${(0, $krx4P.default)(color)}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $cAKIb.getBadgeUtilityClass), classes);
};
const $deca7163a8233953$var$BadgeRoot = (0, $l0oRz.default)('span', {
    name: 'MuiBadge',
    slot: 'Root'
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const $deca7163a8233953$var$BadgeBadge = (0, $l0oRz.default)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $krx4P.default)(ownerState.anchorOrigin.vertical)}${(0, $krx4P.default)(ownerState.anchorOrigin.horizontal)}${(0, $krx4P.default)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, $krx4P.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $deca7163a8233953$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: $deca7163a8233953$var$RADIUS_STANDARD * 2,
        borderRadius: $deca7163a8233953$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.entries(theme.palette).filter((0, $4B5Or.default)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: $deca7163a8233953$var$RADIUS_DOT,
                    height: $deca7163a8233953$var$RADIUS_DOT * 2,
                    minWidth: $deca7163a8233953$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $cAKIb.default).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $cAKIb.default).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $cAKIb.default).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $cAKIb.default).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $cAKIb.default).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $cAKIb.default).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $cAKIb.default).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $cAKIb.default).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    })));
function $deca7163a8233953$var$getAnchorOrigin(anchorOrigin) {
    return {
        vertical: anchorOrigin?.vertical ?? 'top',
        horizontal: anchorOrigin?.horizontal ?? 'right'
    };
}
const $deca7163a8233953$var$Badge = /*#__PURE__*/ $bh6RR.forwardRef(function Badge(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp, className: className, classes: classesProp, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = 'standard', ...other } = props;
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $ft3X3.default)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $ktROk.default)({
        anchorOrigin: $deca7163a8233953$var$getAnchorOrigin(anchorOriginProp),
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOriginPropProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const anchorOrigin = $deca7163a8233953$var$getAnchorOrigin(anchorOriginPropProp);
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = {
        ...props,
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    };
    const classes = $deca7163a8233953$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const externalForwardedProps = {
        slots: {
            root: slots?.root ?? components.Root,
            badge: slots?.badge ?? components.Badge
        },
        slotProps: {
            root: slotProps?.root ?? componentsProps.root,
            badge: slotProps?.badge ?? componentsProps.badge
        }
    };
    const [RootSlot, rootProps] = (0, $dFvJW.default)('root', {
        elementType: $deca7163a8233953$var$BadgeRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            as: component
        }
    });
    const [BadgeSlot, badgeProps] = (0, $dFvJW.default)('badge', {
        elementType: $deca7163a8233953$var$BadgeBadge,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.badge
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            children,
            /*#__PURE__*/ (0, $ih19M.jsx)(BadgeSlot, {
                ...badgeProps,
                children: displayValue
            })
        ]
    });
});
var $deca7163a8233953$export$2e2bcd8739ae039 = $deca7163a8233953$var$Badge;

});
parcelRegister("ft3X3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b42ca11bc5e9706e$export$2e2bcd8739ae039; });

var $ktROk = parcelRequire("ktROk");
'use client';
function $b42ca11bc5e9706e$var$useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $ktROk.default)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}
var $b42ca11bc5e9706e$export$2e2bcd8739ae039 = $b42ca11bc5e9706e$var$useBadge;

});

parcelRegister("cAKIb", function(module, exports) {

$parcel$export(module.exports, "getBadgeUtilityClass", function () { return $92ad14c4cfd70f22$export$aaccef17e6dab084; });
$parcel$export(module.exports, "default", function () { return $92ad14c4cfd70f22$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $92ad14c4cfd70f22$export$aaccef17e6dab084(slot) {
    return (0, $dmzXD.default)('MuiBadge', slot);
}
const $92ad14c4cfd70f22$var$badgeClasses = (0, $fYlYP.default)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var $92ad14c4cfd70f22$export$2e2bcd8739ae039 = $92ad14c4cfd70f22$var$badgeClasses;

});


parcelRegister("lADbI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb7b5bb222c5bdb2$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $c3mIq = parcelRequire("c3mIq");


var $96ZcP = parcelRequire("96ZcP");

var $am2yJ = parcelRequire("am2yJ");

var $25zti = parcelRequire("25zti");

var $20D76 = parcelRequire("20D76");

var $l0oRz = parcelRequire("l0oRz");
var $aOb5j = parcelRequire("aOb5j");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $krx4P = parcelRequire("krx4P");

var $3BTDi = parcelRequire("3BTDi");

var $gAAjb = parcelRequire("gAAjb");

var $6gtJo = parcelRequire("6gtJo");

var $dg012 = parcelRequire("dg012");

var $2STLv = parcelRequire("2STLv");

var $8ANil = parcelRequire("8ANil");

var $dFvJW = parcelRequire("dFvJW");

var $dCGOJ = parcelRequire("dCGOJ");

var $ih19M = parcelRequire("ih19M");
'use client';
function $fb7b5bb222c5bdb2$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $fb7b5bb222c5bdb2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $krx4P.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $dCGOJ.getTooltipUtilityClass), classes);
};
const $fb7b5bb222c5bdb2$var$TooltipPopper = (0, $l0oRz.default)((0, $gAAjb.default), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInteractive,
                style: {
                    pointerEvents: 'auto'
                }
            },
            {
                props: ({ open: open })=>!open,
                style: {
                    pointerEvents: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${(0, $dCGOJ.default).arrow}`]: {
                        top: 0,
                        marginTop: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 100%'
                        }
                    },
                    [`&[data-popper-placement*="top"] .${(0, $dCGOJ.default).arrow}`]: {
                        bottom: 0,
                        marginBottom: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 0'
                        }
                    },
                    [`&[data-popper-placement*="right"] .${(0, $dCGOJ.default).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '100% 100%'
                        }
                    },
                    [`&[data-popper-placement*="left"] .${(0, $dCGOJ.default).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '0 0'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $dCGOJ.default).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $dCGOJ.default).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $dCGOJ.default).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $dCGOJ.default).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            }
        ]
    })));
const $fb7b5bb222c5bdb2$var$TooltipTooltip = (0, $l0oRz.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $krx4P.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium,
        [`.${(0, $dCGOJ.default).popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: 'right center'
        },
        [`.${(0, $dCGOJ.default).popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: 'left center'
        },
        [`.${(0, $dCGOJ.default).popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        },
        [`.${(0, $dCGOJ.default).popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: 'center top',
            marginTop: '14px'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    position: 'relative',
                    margin: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    padding: '8px 16px',
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${$fb7b5bb222c5bdb2$var$round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl,
                style: {
                    [`.${(0, $dCGOJ.default).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '14px'
                    },
                    [`.${(0, $dCGOJ.default).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $dCGOJ.default).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '24px'
                    },
                    [`.${(0, $dCGOJ.default).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl,
                style: {
                    [`.${(0, $dCGOJ.default).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '14px'
                    },
                    [`.${(0, $dCGOJ.default).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $dCGOJ.default).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '24px'
                    },
                    [`.${(0, $dCGOJ.default).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $dCGOJ.default).popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $dCGOJ.default).popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: '24px'
                    }
                }
            }
        ]
    })));
const $fb7b5bb222c5bdb2$var$TooltipArrow = (0, $l0oRz.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow'
})((0, $gfPc7.default)(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    })));
let $fb7b5bb222c5bdb2$var$hystersisOpen = false;
const $fb7b5bb222c5bdb2$var$hystersisTimer = new (0, $c3mIq.Timeout)();
let $fb7b5bb222c5bdb2$var$cursorPosition = {
    x: 0,
    y: 0
};
function $fb7b5bb222c5bdb2$export$b9ee5a7ace0541f8() {
    $fb7b5bb222c5bdb2$var$hystersisOpen = false;
    $fb7b5bb222c5bdb2$var$hystersisTimer.clear();
}
function $fb7b5bb222c5bdb2$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $fb7b5bb222c5bdb2$var$Tooltip = /*#__PURE__*/ $bh6RR.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, classes: classesProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionProps, ...other } = props;
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $bh6RR.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $aOb5j.default)();
    const isRtl = (0, $am2yJ.useRtl)();
    const [childNode, setChildNode] = $bh6RR.useState();
    const [arrowRef, setArrowRef] = $bh6RR.useState(null);
    const ignoreNonTouchEvents = $bh6RR.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $c3mIq.default)();
    const enterTimer = (0, $c3mIq.default)();
    const leaveTimer = (0, $c3mIq.default)();
    const touchTimer = (0, $c3mIq.default)();
    const [openState, setOpenState] = (0, $8ANil.default)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $2STLv.default)(idProp);
    const prevUserSelect = $bh6RR.useRef();
    const stopTouchInteraction = (0, $6gtJo.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $bh6RR.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $fb7b5bb222c5bdb2$var$hystersisTimer.clear();
        $fb7b5bb222c5bdb2$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $6gtJo.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $fb7b5bb222c5bdb2$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $fb7b5bb222c5bdb2$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $fb7b5bb222c5bdb2$var$hystersisOpen && enterNextDelay) enterTimer.start($fb7b5bb222c5bdb2$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = $bh6RR.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $25zti.default)(event.target)) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, $25zti.default)(event.target)) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $bh6RR.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === 'Escape') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $dg012.default)((0, $20D76.default)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $bh6RR.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $fb7b5bb222c5bdb2$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        ...children.props,
        className: (0, $aPsoC.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...followCursor ? {
            onMouseMove: handleMouseMove
        } : {}
    };
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $fb7b5bb222c5bdb2$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $fb7b5bb222c5bdb2$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $fb7b5bb222c5bdb2$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $fb7b5bb222c5bdb2$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const ownerState = {
        ...props,
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    };
    const resolvedPopperProps = typeof slotProps.popper === 'function' ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = $bh6RR.useMemo(()=>{
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if (PopperProps.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        if (resolvedPopperProps?.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return {
            ...PopperProps.popperOptions,
            ...resolvedPopperProps?.popperOptions,
            modifiers: tooltipModifiers
        };
    }, [
        arrowRef,
        PopperProps.popperOptions,
        resolvedPopperProps?.popperOptions
    ]);
    const classes = $fb7b5bb222c5bdb2$var$useUtilityClasses(ownerState);
    const resolvedTransitionProps = typeof slotProps.transition === 'function' ? slotProps.transition(ownerState) : slotProps.transition;
    const externalForwardedProps = {
        slots: {
            popper: components.Popper,
            transition: components.Transition ?? TransitionComponentProp,
            tooltip: components.Tooltip,
            arrow: components.Arrow,
            ...slots
        },
        slotProps: {
            arrow: slotProps.arrow ?? componentsProps.arrow,
            popper: {
                ...PopperProps,
                ...resolvedPopperProps ?? componentsProps.popper
            },
            // resolvedPopperProps can be spread because it's already an object
            tooltip: slotProps.tooltip ?? componentsProps.tooltip,
            transition: {
                ...TransitionProps,
                ...resolvedTransitionProps ?? componentsProps.transition
            }
        }
    };
    const [PopperSlot, popperSlotProps] = (0, $dFvJW.default)('popper', {
        elementType: $fb7b5bb222c5bdb2$var$TooltipPopper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.popper, PopperProps?.className)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $dFvJW.default)('transition', {
        elementType: (0, $3BTDi.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $dFvJW.default)('tooltip', {
        elementType: $fb7b5bb222c5bdb2$var$TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, $dFvJW.default)('arrow', {
        elementType: $fb7b5bb222c5bdb2$var$TooltipArrow,
        className: classes.arrow,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ $bh6RR.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ih19M.jsx)(PopperSlot, {
                as: PopperComponentProp ?? (0, $gAAjb.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $fb7b5bb222c5bdb2$var$cursorPosition.y,
                            left: $fb7b5bb222c5bdb2$var$cursorPosition.x,
                            right: $fb7b5bb222c5bdb2$var$cursorPosition.x,
                            bottom: $fb7b5bb222c5bdb2$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true,
                ...interactiveWrapperListeners,
                ...popperSlotProps,
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ih19M.jsx)(TransitionSlot, {
                        timeout: theme.transitions.duration.shorter,
                        ...TransitionPropsInner,
                        ...transitionSlotProps,
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)(TooltipSlot, {
                            ...tooltipSlotProps,
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ih19M.jsx)(ArrowSlot, {
                                    ...arrowSlotProps
                                }) : null
                            ]
                        })
                    })
            })
        ]
    });
});
var $fb7b5bb222c5bdb2$export$2e2bcd8739ae039 = $fb7b5bb222c5bdb2$var$Tooltip;

});
parcelRegister("dCGOJ", function(module, exports) {

$parcel$export(module.exports, "getTooltipUtilityClass", function () { return $9eb0099c0c356958$export$837848f5f6cee923; });
$parcel$export(module.exports, "default", function () { return $9eb0099c0c356958$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $9eb0099c0c356958$export$837848f5f6cee923(slot) {
    return (0, $dmzXD.default)('MuiTooltip', slot);
}
const $9eb0099c0c356958$var$tooltipClasses = (0, $fYlYP.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $9eb0099c0c356958$export$2e2bcd8739ae039 = $9eb0099c0c356958$var$tooltipClasses;

});


parcelRegister("8QeQV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66feb3788a5e0ef0$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $66feb3788a5e0ef0$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3m6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1z"
}), 'AssignmentInd');

});

parcelRegister("iJ6Ak", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da218992783afdad$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $da218992783afdad$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M7.5 5.6 10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.996.996 0 0 0-1.41 0L1.29 18.96c-.39.39-.39 1.02 0 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05c.39-.39.39-1.02 0-1.41zm-1.03 5.49-2.12-2.12 2.44-2.44 2.12 2.12z"
}), 'AutoFixHigh');

});

parcelRegister("kSc4Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f322381384b5fe7c$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $f322381384b5fe7c$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M4 7h16v2H4zm0 6h16v-2H4zm0 4h7v-2H4zm0 4h7v-2H4zm11.41-2.83L14 16.75l-1.41 1.41L15.41 21 20 16.42 18.58 15zM4 3v2h16V3z"
}), 'Grading');

});

parcelRegister("6ag42", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47d0234273209074$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $47d0234273209074$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M15 21h-2v-2h2zm-2-7h-2v5h2zm8-2h-2v4h2zm-2-2h-2v2h2zM7 12H5v2h2zm-2-2H3v2h2zm7-5h2V3h-2zm-7.5-.5v3h3v-3zM9 9H3V3h6zm-4.5 7.5v3h3v-3zM9 21H3v-6h6zm7.5-16.5v3h3v-3zM21 9h-6V3h6zm-2 10v-3h-4v2h2v3h4v-2zm-2-7h-4v2h4zm-4-2H7v2h2v2h2v-2h2zm1-1V7h-2V5h-2v4zM6.75 5.25h-1.5v1.5h1.5zm0 12h-1.5v1.5h1.5zm12-12h-1.5v1.5h1.5z"
}), 'QrCode2');

});

parcelRegister("hE2xX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd8825d76831a500$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $cd8825d76831a500$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14zm12 0h-7.5l2-2H18z"
}), 'RateReview');

});

parcelRegister("jIOsh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5b943b8920ffc79$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $e5b943b8920ffc79$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');

});

parcelRegister("htLA2", function(module, exports) {

$parcel$export(module.exports, "isPadelAssessmentCollection", function () { return $1242d02582f09d67$export$8c099142480be67e; });
$parcel$export(module.exports, "PADEL_ASSESSMENT_START_URL", function () { return $1242d02582f09d67$export$8aa61ffd508aa310; });
$parcel$export(module.exports, "padelAppDoneUrl", function () { return $1242d02582f09d67$export$fb8d6eabe4f9b8b0; });
/**
 * Routing helpers for padel assessment completions, the padel twin of
 * `JourneyAssessment/duprAppDone.ts`.
 *
 * A run's sport is decided by its journey collection prefix, which is why padel
 * has its own `padel_assessment_*` family rather than sharing the DUPR one:
 * collections are unique per (collection, sport), so sharing would resolve, but
 * both done-screen redirects key off the prefix and a shared prefix would send
 * padel completions to the DUPR "Thank you" screen.
 */ /** Prefix on the padel assessment journey collections. */ const $1242d02582f09d67$var$PADEL_ASSESSMENT_COLLECTION_PREFIX = "padel_assessment_";
function $1242d02582f09d67$export$8c099142480be67e(collection) {
    return (collection ?? "").startsWith($1242d02582f09d67$var$PADEL_ASSESSMENT_COLLECTION_PREFIX);
}
const $1242d02582f09d67$export$8aa61ffd508aa310 = "/journeys/padel-assessment";
function $1242d02582f09d67$export$fb8d6eabe4f9b8b0(ulid) {
    return `${$1242d02582f09d67$export$8aa61ffd508aa310}/${ulid}/done`;
}

});

parcelRegister("kRyrt", function(module, exports) {

$parcel$export(module.exports, "BackNavProvider", function () { return $2071300c6724a264$export$aff72fc909c205bb; });
$parcel$export(module.exports, "useBackNav", function () { return $2071300c6724a264$export$3a7a74d6ddec2c85; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $1lMle = parcelRequire("1lMle");
const $2071300c6724a264$var$BackNavContext = /*#__PURE__*/ $bh6RR.createContext({});
function $2071300c6724a264$export$aff72fc909c205bb({ navigateToOnDeepLink: navigateToOnDeepLink, children: children }) {
    const value = $bh6RR.useMemo(()=>({
            navigateToOnDeepLink: navigateToOnDeepLink
        }), [
        navigateToOnDeepLink
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($2071300c6724a264$var$BackNavContext.Provider, {
        value: value,
        children: children
    });
}
function $2071300c6724a264$export$3a7a74d6ddec2c85() {
    const { navigateToOnDeepLink: navigateToOnDeepLink } = $bh6RR.useContext($2071300c6724a264$var$BackNavContext);
    const location = (0, $as544.useLocation)();
    return $bh6RR.useMemo(()=>{
        // Deep link case: no history present, but we have explicit direction
        if (window.history.state && (window.history.state.idx === 0 || location.state?.idx === 0) && navigateToOnDeepLink) {
            (0, $1lMle.default).info(`[useBackNav] - Back navigates to: ${navigateToOnDeepLink}`);
            return {
                target: navigateToOnDeepLink,
                state: {
                    deep: navigateToOnDeepLink
                }
            };
        }
        // Page directly after a deep link redirect
        if (window.history.state && window.history.state.idx === 1 && location.state?.deep === location.pathname) {
            (0, $1lMle.default).info(`[useBackNav] - Back navigates to "/"`);
            return {
                target: "/"
            };
        }
        (0, $1lMle.default).info(`[useBackNav] - Back navigates back 1.`);
        return {
            target: -1
        };
    }, [
        location,
        navigateToOnDeepLink
    ]);
}

});

parcelRegister("cC4Zp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1efe0924e1102c69$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $iYrdy = parcelRequire("iYrdy");
function $1efe0924e1102c69$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $iYrdy.default), {
        viewBox: "0 0 211 188",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "m 196.78,15.66378 h -20.46 l -46.91,81.17 a 22.822665,22.822665 0 1 1 -39.52,-22.84 l 33.71,-58.33 H 22.78 a 18.83,18.83 0 0 0 -16.2999989,28.24 L 93.48,194.49378 a 18.83,18.83 0 0 0 32.6,0 l 87,-150.59 a 18.83,18.83 0 0 0 -16.3,-28.24 z"
        })
    });
}

});

parcelRegister("18rAL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d3bf0f86d5758c4$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $0d3bf0f86d5758c4$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6z"
}), 'KeyboardArrowLeft');

});

parcelRegister("j6Qoj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de9737a179b5ca44$export$2e2bcd8739ae039; });

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $de9737a179b5ca44$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z"
}), 'KeyboardArrowRight');

});

parcelRegister("kMz87", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d26bfcbe9e022b6c$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $5CVHy = parcelRequire("5CVHy");

var $dUgAK = parcelRequire("dUgAK");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $aOb5j = parcelRequire("aOb5j");

const $d26bfcbe9e022b6c$var$VOLLEY_LOGO_URL = new URL((parcelRequire("gySc0")));
function $d26bfcbe9e022b6c$export$2e2bcd8739ae039({ open: open = true }) {
    const theme = (0, $aOb5j.default)();
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $dUgAK.default), {
        fullScreen: true,
        open: open,
        slotProps: {
            paper: {
                sx: {
                    background: theme.palette.primary.main
                }
            }
        },
        transitionDuration: {
            exit: 400
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
            spacing: 2,
            alignItems: "center",
            justifyContent: "center",
            sx: {
                height: "90vh"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                    src: $d26bfcbe9e022b6c$var$VOLLEY_LOGO_URL.toString(),
                    alt: "green volley logo",
                    height: 60
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h3",
                    color: "white",
                    sx: {
                        mt: 2,
                        mb: 4
                    },
                    children: "Loading ..."
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                    color: "secondary"
                })
            ]
        })
    });
}

});
parcelRegister("gySc0", function(module, exports) {
module.exports = $parcel$resolve("fkvji");

});


parcelRegister("8eLYQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86835f8e868d5367$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $W4f7l = parcelRequire("W4f7l");
function $86835f8e868d5367$export$2e2bcd8739ae039({ children: children }) {
    const { isAdmin: isAdmin, authState: authState } = (0, $W4f7l.useCurrentUser)();
    if (authState === (0, $W4f7l.AuthState).LOADING) return children;
    return isAdmin() ? children : /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Navigate), {
        to: "/"
    });
}

});

parcelRegister("dnGn2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8a7abf42cdf3f3c$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $W4f7l = parcelRequire("W4f7l");

var $kMz87 = parcelRequire("kMz87");
function $a8a7abf42cdf3f3c$export$2e2bcd8739ae039({ children: children }) {
    const location = (0, $as544.useLocation)();
    const from = location.pathname.indexOf("/login") > -1 || location.pathname.indexOf("/account") > -1 ? "/" : `${location.pathname}${location.search}`;
    const { currentUser: currentUser, authState: authState } = (0, $W4f7l.useCurrentUser)();
    if (authState === (0, $W4f7l.AuthState).LOADING) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $kMz87.default), {});
    return currentUser ? children : /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Navigate), {
        to: "/login",
        state: {
            from: from
        }
    });
}

});

parcelRegister("b66Yl", function(module, exports) {

$parcel$export(module.exports, "DebugProvider", function () { return $d2c3283e2388740b$export$fe72a86dd2b9e6e2; });
$parcel$export(module.exports, "useDebugMode", function () { return $d2c3283e2388740b$export$c7e39c9bdc5cd7d0; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
const $d2c3283e2388740b$export$26cd2de697ec4bb5 = /*#__PURE__*/ $bh6RR.createContext({
    enabled: false,
    setEnabled: ()=>{}
});
const $d2c3283e2388740b$export$fe72a86dd2b9e6e2 = /*#__PURE__*/ $bh6RR.memo(({ children: children })=>{
    const [enabled, setEnabled] = $bh6RR.useState(false);
    const value = $bh6RR.useMemo(()=>({
            enabled: enabled,
            setEnabled: setEnabled
        }), [
        enabled
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($d2c3283e2388740b$export$26cd2de697ec4bb5.Provider, {
        value: value,
        children: children
    });
});
$d2c3283e2388740b$export$fe72a86dd2b9e6e2.displayName = "DebugProvider";
function $d2c3283e2388740b$export$c7e39c9bdc5cd7d0() {
    return $bh6RR.useContext($d2c3283e2388740b$export$26cd2de697ec4bb5);
}

});

parcelRegister("6w3z5", function(module, exports) {

$parcel$export(module.exports, "ualSupported", function () { return $04144eb006aeae31$export$b9af974ba19a0aa7; });
$parcel$export(module.exports, "LocalizationProvider", function () { return $04144eb006aeae31$export$dc45bdc734ce6f1e; });
$parcel$export(module.exports, "default", function () { return $04144eb006aeae31$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $kZnrE = parcelRequire("kZnrE");

var $1lMle = parcelRequire("1lMle");

var $cK0UE = parcelRequire("cK0UE");

var $hz16f = parcelRequire("hz16f");

var $fgY6R = parcelRequire("fgY6R");

var $76QOg = parcelRequire("76QOg");

var $7ybf3 = parcelRequire("7ybf3");

var $ezs3H = parcelRequire("ezs3H");

var $lfvqn = parcelRequire("lfvqn");
function $04144eb006aeae31$export$69411073baf677a2(sport) {
    return sport === "TENNIS" || sport === "PLATFORM_TENNIS" || sport === "PICKLEBALL";
}
function $04144eb006aeae31$export$b9af974ba19a0aa7(sport) {
    return $04144eb006aeae31$export$69411073baf677a2(sport) || sport === "PADEL";
}
const $04144eb006aeae31$var$defaultPositionStateInternal = {
    requestedAt: undefined,
    error: undefined,
    position: undefined,
    improve: false,
    isVisionStarting: true,
    isVisionFaulted: false,
    localizationStatus: "idle",
    delta: undefined,
    method: "smart",
    ualResult: null
};
const $04144eb006aeae31$var$defaultLocalizationState = {
    ...$04144eb006aeae31$var$defaultPositionStateInternal,
    isLocalizing: false,
    isCanceled: false,
    updatePosition: ()=>{},
    cancel: ()=>{},
    setUalResult: ()=>{},
    clearUalResult: ()=>{},
    isCloseEnough: ()=>"fail",
    isPlannedPositionCloseEnough: ()=>"fail"
};
const $04144eb006aeae31$export$51216bcc3983e55d = /*#__PURE__*/ $bh6RR.createContext($04144eb006aeae31$var$defaultLocalizationState);
const $04144eb006aeae31$var$DISTANCE_DELTA_ALLOWED_BY_SPORT = {
    PLATFORM_TENNIS: 500,
    PADEL: 500,
    TENNIS: 500,
    PICKLEBALL: 500,
    LACROSSE: 500
};
const $04144eb006aeae31$var$HEIGHT_DELTA_ALLOWED_BY_SPORT = {
    PLATFORM_TENNIS: 100,
    PADEL: 100,
    TENNIS: 150,
    PICKLEBALL: 100,
    // Lacrosse localizes against the tennis court model, so it takes tennis's
    // tolerances.
    LACROSSE: 150
};
const $04144eb006aeae31$var$YAW_DELTA_ALLOWED_BY_SPORT = {
    PLATFORM_TENNIS: 15,
    PADEL: 4,
    PICKLEBALL: 4,
    TENNIS: 2,
    LACROSSE: 2
};
function $04144eb006aeae31$var$absoluteDiff(a, b) {
    if (a > 0 && b > 0 || a < 0 && b < 0) return Math.max(Math.abs(a), Math.abs(b)) - Math.min(Math.abs(a), Math.abs(b));
    return Math.abs(a) + Math.abs(b);
}
function $04144eb006aeae31$var$cameraPositionToFullPosition(cameraPosition) {
    if (!cameraPosition) return undefined;
    return {
        x: cameraPosition.x,
        y: cameraPosition.y,
        z: cameraPosition.z,
        error: null,
        debug: null,
        intersections: {
            bottomLeft: {
                x: 0,
                y: 0
            },
            bottomRight: {
                x: 0,
                y: 0
            },
            topLeft: {
                x: 0,
                y: 0
            },
            topRight: {
                x: 0,
                y: 0
            }
        },
        pitch: cameraPosition.pitch,
        roll: cameraPosition.roll,
        yaw: cameraPosition.yaw
    };
}
function $04144eb006aeae31$var$cameraPositionDeltaToDelta(cameraPositionDelta) {
    if (!cameraPositionDelta) return undefined;
    return {
        x: cameraPositionDelta.x,
        y: cameraPositionDelta.y,
        yaw: cameraPositionDelta.yaw
    };
}
function $04144eb006aeae31$var$positionReducer(state, action) {
    switch(action.type){
        case "vision-status":
            return {
                ...state,
                isVisionStarting: action.value
            };
        case "set-error":
            return {
                ...state,
                error: action.value
            };
        case "set-faulted":
            return {
                ...state,
                isVisionFaulted: action.value,
                isVisionStarting: !action.value
            };
        case "request-cancel":
            return {
                ...state,
                localizationStatus: "cancelling",
                error: undefined,
                improve: false,
                position: undefined,
                requestedAt: performance.now()
            };
        case "cancel-confirmed":
            return {
                ...$04144eb006aeae31$var$defaultPositionStateInternal,
                isVisionStarting: state.isVisionStarting
            };
        case "request-localization":
            return {
                ...$04144eb006aeae31$var$defaultPositionStateInternal,
                method: action.value,
                isVisionStarting: state.isVisionStarting,
                localizationStatus: "pending",
                requestedAt: performance.now()
            };
        case "localization-unavailable":
            return {
                ...$04144eb006aeae31$var$defaultPositionStateInternal,
                isVisionStarting: state.isVisionStarting,
                localizationStatus: "unavailable"
            };
        case "localization-confirmed":
            return {
                ...state,
                localizationStatus: "localizing",
                method: state.method,
                requestedAt: undefined
            };
        case "localization-in-progress":
            return {
                ...$04144eb006aeae31$var$defaultLocalizationState,
                method: state.method,
                isVisionStarting: state.isVisionStarting,
                localizationStatus: "localizing"
            };
        case "localization-confirm-fail":
            return {
                ...state,
                localizationStatus: "error",
                error: action.value,
                requestedAt: undefined
            };
        case "completed":
            if ((0, $fgY6R.isDeprecatedLocalizationStatus)(action.value)) return {
                ...$04144eb006aeae31$var$defaultPositionStateInternal,
                isVisionStarting: state.isVisionStarting,
                method: state.method,
                position: action.value.position ?? undefined,
                error: action.value.position?.error ?? undefined,
                improve: action.value.improve,
                delta: action.value.delta,
                ualResult: state.ualResult
            };
            else return {
                ...$04144eb006aeae31$var$defaultPositionStateInternal,
                isVisionStarting: state.isVisionStarting,
                method: state.method,
                position: $04144eb006aeae31$var$cameraPositionToFullPosition(action.value.cameraPosition),
                error: action.value.cameraPosition ? undefined : "Failed",
                improve: action.value.improve,
                delta: $04144eb006aeae31$var$cameraPositionDeltaToDelta(action.value.cameraPositionDelta),
                ualResult: state.ualResult
            };
        case "set-ual-result":
            return {
                ...state,
                ualResult: action.value
            };
        case "clear-ual-result":
            return {
                ...state,
                ualResult: null
            };
        default:
            return state;
    }
}
const $04144eb006aeae31$var$DEFAULT_TOLERANCE = {
    maxGroundDistanceDeltaMeters: 0.5,
    maxHeightDeltaMeters: 0.15,
    maxRollDeltaDegrees: 1.7,
    maxPitchDeltaDegrees: 1.5,
    maxYawDeltaDegrees: 5.0
};
const $04144eb006aeae31$export$dc45bdc734ce6f1e = /*#__PURE__*/ $bh6RR.memo(({ children: children })=>{
    const { status: status } = (0, $ezs3H.useStatus)();
    const { selected: sport } = (0, $76QOg.useSelectedSport)();
    const trainerFeatures = (0, $lfvqn.useTrainerFeatures)();
    const { lift: { max: maxTrainerLiftHeight } } = (0, $7ybf3.default)();
    const [stateInternal, dispatch] = $bh6RR.useReducer($04144eb006aeae31$var$positionReducer, $04144eb006aeae31$var$defaultPositionStateInternal);
    $bh6RR.useEffect(()=>{
        (0, $1lMle.default).info(`[usePosition] Internal State Changed: ${JSON.stringify(stateInternal)}`);
    }, [
        stateInternal
    ]);
    $bh6RR.useEffect(()=>{
        if (!status?.localization) return;
        const updatedVisionStarting = status?.vision?.visionSystemStarting ?? false;
        if (stateInternal.isVisionStarting !== updatedVisionStarting) {
            if (status?.vision?.serviceState !== "Fault") {
                (0, $1lMle.default).info(`[usePosition] - Setting vision status to '${updatedVisionStarting ? "Starting" : "Up"}'`);
                dispatch({
                    type: "vision-status",
                    value: updatedVisionStarting
                });
            }
        }
        if (status?.vision?.serviceState === "Fault" && !stateInternal.isVisionFaulted) {
            (0, $1lMle.default).info("[usePosition] - Vision reporting a fault.");
            dispatch({
                type: "set-faulted",
                value: true
            });
            return;
        }
        if (stateInternal.isVisionFaulted) {
            if (status?.vision?.serviceState === "Running" && status?.vision?.visionSystemStarting !== true) {
                (0, $1lMle.default).info("[usePosition] - Vision no longer faulted");
                dispatch({
                    type: "set-faulted",
                    value: false
                });
                return;
            }
        }
        const localizing = status?.localization?.isActive ?? false;
        // We asked for a localization job and coach has now confirmed it is running
        if (localizing && stateInternal.localizationStatus === "pending") {
            (0, $1lMle.default).info("[usePosition] - Localization was Pending - Confirmed by Coach Status");
            dispatch({
                type: "localization-confirmed"
            });
            return;
        }
        // This can happen if localization is in progress and the user refreshes/navigates
        if (localizing && stateInternal.localizationStatus === "idle") {
            (0, $1lMle.default).info("[usePosition] - Localization  was idle, but is active from state - resetting internal state");
            dispatch({
                type: "localization-in-progress"
            });
            return;
        }
        // We were tracking a localization task, but coach's status indicates it is no longer active
        if (!localizing && stateInternal.localizationStatus === "localizing") {
            (0, $1lMle.default).info("[usePosition] - Localization was active, status indicates it is no longer active");
            dispatch({
                type: "completed",
                value: status?.localization
            });
            return;
        }
        // We asked to cancel the running localization job and coach is validating our request
        if (!localizing && stateInternal.localizationStatus === "cancelling") {
            (0, $1lMle.default).info("[usePosition] - Cancellation confirmed, status indicates it is no longer active");
            dispatch({
                type: "cancel-confirmed"
            });
            return;
        }
        // Clear started startedLocalizing if we have gotten a sufficiently up-to-date status
        if (stateInternal.requestedAt && performance.now() > stateInternal.requestedAt + 10000) dispatch({
            type: "localization-confirm-fail",
            value: "Status not confirmed after 5 seconds, aborting"
        });
    }, [
        status?.vision,
        status?.localization,
        stateInternal
    ]);
    const fetchPosition = $bh6RR.useCallback(async (hintPosition, oneShot, cameraPositionTolerance)=>{
        if (stateInternal.isVisionStarting) {
            (0, $1lMle.default).info("[usePosition] - returning early from 'fetchPosition' because vision is not yet ready");
            dispatch({
                type: "set-error",
                value: "NOT_READY"
            });
            return;
        }
        if (stateInternal.isVisionFaulted) {
            (0, $1lMle.default).info("[usePosition] - returning early from 'fetchPosition' because vision is not yet ready");
            dispatch({
                type: "set-error",
                value: "FAULTED"
            });
            return;
        }
        if (stateInternal.localizationStatus !== "idle") {
            (0, $1lMle.default).info(`[usePosition] - returning early from 'fetchPosition': ${stateInternal.localizationStatus}`);
            return;
        }
        /*
                    Lacrosse never localizes. This was written the other way -
                    lacrosse was included on the reasoning that vision knows the
                    sport and could match it against the tennis court model -
                    but vision has no lacrosse support yet, so what came back
                    was a position derived from court lines that are not on the
                    field.

                    Gated HERE rather than at the screens because this is the
                    one call every one of them makes: the accordions, the module
                    start flow, the AOI app's re-localize, the lift dialog.
                    Missing one would mean a trainer positioned from a reading
                    that means nothing.

                    Returned quietly instead of as UNSUPPORTED_SPORT: that error
                    surfaces to the coach, and nothing has gone wrong here - the
                    drill simply does not use localization. Screens already cope,
                    because they only consume a localized position for platform
                    tennis anyway.
                */ if (sport === "LACROSSE") {
            (0, $1lMle.default).info(`[usePosition] - returning early from 'fetchPosition': vision has no lacrosse support yet`);
            return;
        }
        if (!$04144eb006aeae31$export$69411073baf677a2(sport)) {
            (0, $1lMle.default).info(`[usePosition] - returning early from 'fetchPosition': sport is not tennis or platform tennis or pickleball`);
            dispatch({
                type: "set-error",
                value: "UNSUPPORTED_SPORT"
            });
            return;
        }
        const method = oneShot ? "one-shot" : "smart";
        (0, $1lMle.default).info(`[usePosition] - Requesting localization with method: ${method}`);
        dispatch({
            type: "request-localization",
            value: method
        });
        try {
            const payload = {
                hint: hintPosition
            };
            // only pass oneshot if the trainer supports it, it was added with Serve and Volley
            // this should allow backwards compatibility with older trainers
            if (trainerFeatures.includes("serveAndVolley")) payload.oneshot = oneShot;
            if (trainerFeatures.includes("localizationPipeline")) payload.sport = sport;
            if (cameraPositionTolerance && trainerFeatures.includes("failsafeLocalization")) payload.tolerance = cameraPositionTolerance;
            else if (trainerFeatures.includes("failsafeLocalization")) payload.tolerance = $04144eb006aeae31$var$DEFAULT_TOLERANCE;
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/position", "POST", payload);
        } catch (e) {
            (0, $cK0UE.logFetchError)(e, "[usePosition] - Request to start localizing failed");
            dispatch({
                type: "localization-confirm-fail",
                value: e.message
            });
        }
    }, [
        sport,
        status?.clientId,
        stateInternal,
        trainerFeatures
    ]);
    // SoftStop
    const cancel = $bh6RR.useCallback(()=>{
        (0, $1lMle.default).info("[usePosition] - user requested localization cancellation");
        dispatch({
            type: "request-cancel"
        });
        (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/cancel-position", "POST").catch((e)=>(0, $cK0UE.logFetchError)(e)).finally(()=>{
            (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/motors-stop", "POST").catch((stopError)=>{
                (0, $cK0UE.logFetchError)(stopError);
            });
        });
    }, [
        status?.clientId
    ]);
    const isCloseEnough = $bh6RR.useCallback((plannedPosition, sport, physicsModelName, compareHeight)=>{
        if ((0, $fgY6R.isDeprecatedLocalizationStatus)(status?.localization) || stateInternal.ualResult) {
            if (stateInternal.ualResult) (0, $1lMle.default).info("[usePosition] closeEnough - using cached UAL position result");
            else (0, $1lMle.default).info("[usePosition] closeEnough - using deprecated localization status");
            const position = stateInternal.ualResult ? stateInternal.ualResult : stateInternal.position;
            if (!position) // logger.warn(
            //     "[usePosition] closeEnough - no position available",
            // );
            return "fail";
            const distanceDeltaAllowed = $04144eb006aeae31$var$DISTANCE_DELTA_ALLOWED_BY_SPORT[sport];
            const heightDeltaAllowed = $04144eb006aeae31$var$HEIGHT_DELTA_ALLOWED_BY_SPORT[sport];
            const yawDeltaAllowed = $04144eb006aeae31$var$YAW_DELTA_ALLOWED_BY_SPORT[sport];
            let comparePosition = {
                ...plannedPosition
            };
            if (sport !== "PLATFORM_TENNIS") {
                (0, $1lMle.default).info(`Converting Planned Position: ${JSON.stringify(comparePosition)} for comparison`);
                (0, $kZnrE.setPhysicsModel)(physicsModelName, sport);
                const asLocalized = (0, $kZnrE.physics2localization)({
                    x: comparePosition.x,
                    y: comparePosition.y,
                    z: (0, $kZnrE.launchHeightInches2HeadHeight)(comparePosition.heightIn)
                });
                comparePosition = {
                    x: asLocalized.x,
                    y: asLocalized.y,
                    yaw: (0, $hz16f.degToRad)(comparePosition.yaw),
                    heightIn: comparePosition.heightIn
                };
                (0, $1lMle.default).info(`Updated Compare Position: ${JSON.stringify(comparePosition)}`);
            }
            (0, $1lMle.default).info(`Localized Position: ${JSON.stringify(position)}`);
            const distance = Math.sqrt((position.x - comparePosition.x) ** 2 + (position.y - comparePosition.y) ** 2);
            const distanceGood = distance <= distanceDeltaAllowed;
            (0, $1lMle.default).info(`[usePosition]: Allowed Distance: ${distanceDeltaAllowed} - calculated distance: ${distance}, distance good? ${distanceGood ? "yes" : "no"}`);
            let heightDiff = 0;
            let heightGood = true;
            const physicsModel = (0, $kZnrE.getPhysicsModel)();
            const launchPointToCameraDistanceMeters = physicsModel.trainerGeometry.cameraOffsetFromHead.z - physicsModel.trainerGeometry.launchOriginOffset.z;
            if (compareHeight) {
                (0, $1lMle.default).info("Comparing height as part of localization validation");
                const launchPointToCameraDistanceMeters = physicsModel.trainerGeometry.cameraOffsetFromHead.z - physicsModel.trainerGeometry.launchOriginOffset.z;
                // compute planned camera height in mm from launch position height in inches
                const plannedHeightAdjusted = comparePosition.heightIn * 25.4 + launchPointToCameraDistanceMeters * 1000.0;
                heightDiff = Math.abs(position.z - plannedHeightAdjusted);
                heightGood = heightDiff <= heightDeltaAllowed;
            } else {
                // check to make sure the Z value is still reasonable based on trainer geometry
                (0, $1lMle.default).info("Checking if height is within trainer limits");
                const maxZ = maxTrainerLiftHeight * 25.4 + launchPointToCameraDistanceMeters * 1000.0;
                heightDiff = Math.abs(maxZ - position.z);
                heightGood = position.z <= maxZ;
                if (!heightGood) (0, $1lMle.default).info(`Localized height too tall! Max Z: ${maxZ} (based on trainer max lift height), Localized Z: ${position.z}, Height Diff: ${heightDiff}`);
            }
            const yawDiff = $04144eb006aeae31$var$absoluteDiff(plannedPosition.yaw, position.yaw);
            const yawGood = yawDiff < (0, $hz16f.degToRad)(yawDeltaAllowed);
            (0, $1lMle.default).info("[serveAndVolley] closeEnough summary", {
                plannedPosition: plannedPosition,
                position: position,
                distance: distance,
                distanceGood: distanceGood,
                heightDiff: heightDiff,
                heightGood: heightGood,
                yawGood: yawGood,
                yawDiff: yawDiff
            });
            // return true;
            const close = distanceGood && heightGood && yawGood;
            if (close) {
                (0, $1lMle.default).info(`[usePosition]: returning good from checkPosition`);
                return "good";
            } else {
                (0, $1lMle.default).info(`[usePosition]: returning improve from checkPosition`);
                return "improve";
            }
        } else {
            // logger.info(
            //     '"[usePosition] closeEnough - using new localization status',
            // );
            // new localization status includes the tolerance we used... we don't need to
            // do any client side checks for whether we're close enough or not, just use
            if (!status?.localization) return "fail";
            const { cameraPosition: cameraPosition, accurate: accurate, improve: improve, errormsg: errormsg } = status.localization;
            if (cameraPosition === null) // logger.warn(
            //     `[usePosition] closeEnough - no camera position available: ${errormsg}`,
            // );
            return "fail";
            else if (improve) {
                (0, $1lMle.default).info(`[usePosition] closeEnough - camera position is close enough, but user improvable: ${errormsg}`);
                return "improve";
            } else if (accurate) {
                (0, $1lMle.default).info(`[usePosition] closeEnough - camera position is accurate: ${errormsg}`);
                return "good";
            } else // logger.warn(
            //     `[usePosition] closeEnough - not accurate or improve, failing: ${errormsg} - ${JSON.stringify(cameraPosition)}`,
            // );
            return "fail";
        }
    }, [
        stateInternal.ualResult,
        stateInternal.position,
        maxTrainerLiftHeight,
        status?.localization
    ]);
    const isPlannedPositionCloseEnough = $bh6RR.useCallback((plannedPosition, sport, physicsModelName, compareHeight)=>{
        const currentCloseEnough = isCloseEnough(plannedPosition, sport, physicsModelName, compareHeight);
        if (currentCloseEnough !== "good") return currentCloseEnough;
        if (!(0, $fgY6R.isDeprecatedLocalizationStatus)(status?.localization) && status?.localization.cameraHintPosition) {
            const distanceDeltaAllowed = $04144eb006aeae31$var$DISTANCE_DELTA_ALLOWED_BY_SPORT[sport];
            const yawDeltaAllowed = $04144eb006aeae31$var$YAW_DELTA_ALLOWED_BY_SPORT[sport];
            let comparePosition = plannedPosition;
            if (sport !== "PLATFORM_TENNIS") {
                (0, $1lMle.default).info(`Converting Planned Position: ${JSON.stringify(comparePosition)} for comparison`);
                (0, $kZnrE.setPhysicsModel)(physicsModelName, sport);
                const asLocalized = (0, $kZnrE.physics2localization)({
                    x: comparePosition.x,
                    y: comparePosition.y,
                    z: (0, $kZnrE.launchHeightInches2HeadHeight)(comparePosition.heightIn)
                });
                comparePosition = {
                    x: asLocalized.x,
                    y: asLocalized.y,
                    yaw: (0, $hz16f.degToRad)(comparePosition.yaw),
                    heightIn: comparePosition.heightIn
                };
                (0, $1lMle.default).info(`Updated Compare Position: ${JSON.stringify(comparePosition)}`);
            }
            const distance = Math.sqrt((status.localization.cameraHintPosition.x - comparePosition.x) ** 2 + (status.localization.cameraHintPosition.y - comparePosition.y) ** 2);
            const distanceGood = distance <= distanceDeltaAllowed;
            const yawDiff = $04144eb006aeae31$var$absoluteDiff(comparePosition.yaw, status.localization.cameraHintPosition.yaw);
            const yawGood = yawDiff < (0, $hz16f.degToRad)(yawDeltaAllowed);
            return distanceGood && yawGood ? "good" : "improve";
        }
        return currentCloseEnough;
    }, [
        isCloseEnough,
        status?.localization
    ]);
    const setUalResult = $bh6RR.useCallback((result)=>{
        (0, $1lMle.default).info(`[usePosition] - Caching UAL result: ${JSON.stringify(result)}`);
        dispatch({
            type: "set-ual-result",
            value: result
        });
    }, []);
    const clearUalResult = $bh6RR.useCallback(()=>{
        (0, $1lMle.default).info(`[usePosition] - Clearing locally cached UAL result`);
        dispatch({
            type: "clear-ual-result"
        });
    }, []);
    const state = $bh6RR.useMemo(()=>({
            ...stateInternal,
            isCanceled: stateInternal.localizationStatus === "cancelling",
            isLocalizing: stateInternal.localizationStatus !== "idle",
            cancel: cancel,
            updatePosition: fetchPosition,
            setUalResult: setUalResult,
            clearUalResult: clearUalResult,
            isCloseEnough: isCloseEnough,
            isPlannedPositionCloseEnough: isPlannedPositionCloseEnough
        }), [
        cancel,
        stateInternal,
        fetchPosition,
        setUalResult,
        clearUalResult,
        isCloseEnough,
        isPlannedPositionCloseEnough
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($04144eb006aeae31$export$51216bcc3983e55d.Provider, {
        value: status === null ? $04144eb006aeae31$var$defaultLocalizationState : state,
        children: children
    });
});
$04144eb006aeae31$export$dc45bdc734ce6f1e.displayName = "LocalizationProvider";
function $04144eb006aeae31$export$2e2bcd8739ae039() {
    return $bh6RR.useContext($04144eb006aeae31$export$51216bcc3983e55d);
}

});

parcelRegister("8LDjk", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("g1aK0"),
    $parcel$import("jvtwO")
]).then(()=>parcelRequire('lXfoI'));

});

parcelRegister("4D1FD", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("7xF25"),
    $parcel$import("03TWs"),
    $parcel$import("loiVx"),
    $parcel$import("kagDH"),
    $parcel$import("23Zfg"),
    $parcel$import("cyz1y"),
    $parcel$import("4d7Bg"),
    $parcel$import("UHAim"),
    $parcel$import("8Dgp0"),
    $parcel$import("j0aM5"),
    $parcel$import("g1aK0"),
    $parcel$import("Kmh8h"),
    $parcel$import("3mM7q"),
    $parcel$import("Idach"),
    $parcel$import("7eokS"),
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("fjIlD")
]).then(()=>parcelRequire('l47GJ'));

});

parcelRegister("cNGRb", function(module, exports) {
module.exports = $parcel$import("702X8").then(()=>parcelRequire('5NbTf'));

});

parcelRegister("JK0MB", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("gPFjp"),
    $parcel$import("62Gm4"),
    $parcel$import("03TWs"),
    $parcel$import("loiVx"),
    $parcel$import("kagDH"),
    $parcel$import("23Zfg"),
    $parcel$import("4d7Bg"),
    $parcel$import("UHAim"),
    $parcel$import("Kmh8h"),
    $parcel$import("3mM7q"),
    $parcel$import("Idach"),
    $parcel$import("gxlPR")
]).then(()=>parcelRequire('84zUt'));

});

parcelRegister("dYxEJ", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("lcs4R"),
    $parcel$import("gPFjp"),
    $parcel$import("7xF25"),
    $parcel$import("cyz1y"),
    $parcel$import("UHAim"),
    $parcel$import("8Dgp0"),
    $parcel$import("Kmh8h"),
    $parcel$import("Idach"),
    $parcel$import("8FTpb")
]).then(()=>parcelRequire('hQfHW'));

});

parcelRegister("igQNc", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("g1aK0"),
    $parcel$import("godR7")
]).then(()=>parcelRequire('lheGM'));

});

parcelRegister("45w4G", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("gPFjp"),
    $parcel$import("UHAim"),
    $parcel$import("Kmh8h"),
    $parcel$import("fD4of")
]).then(()=>parcelRequire('dbvpt'));

});

parcelRegister("bk5HP", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("hjJuJ"),
    $parcel$import("gPFjp"),
    $parcel$import("62Gm4"),
    $parcel$import("23Zfg"),
    $parcel$import("UHAim"),
    $parcel$import("Kmh8h"),
    $parcel$import("iUuUZ")
]).then(()=>parcelRequire('bWYPh'));

});

parcelRegister("ilVlw", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("lcs4R"),
    $parcel$import("loiVx"),
    $parcel$import("cyz1y"),
    $parcel$import("8Dgp0"),
    $parcel$import("j0aM5"),
    $parcel$import("8BlCc"),
    $parcel$import("Idach"),
    $parcel$import("41e5U"),
    $parcel$import("kUuaI"),
    $parcel$import("6w5sC"),
    $parcel$import("3mM7q"),
    $parcel$import("aBMOs"),
    $parcel$import("9LPS3"),
    $parcel$import("buCO7"),
    $parcel$import("30nEm"),
    $parcel$import("6YNHO"),
    $parcel$import("y782T"),
    $parcel$import("6e2AR"),
    $parcel$import("01DVg"),
    $parcel$import("3zbg6"),
    $parcel$import("6OTYw"),
    $parcel$import("eP1UT"),
    $parcel$import("aT16h")
]).then(()=>parcelRequire('6OcNQ'));

});

parcelRegister("f4mJV", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("03TWs"),
    $parcel$import("8Dgp0"),
    $parcel$import("js5KE")
]).then(()=>parcelRequire('hSyPz'));

});

parcelRegister("5nxTQ", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("hjJuJ"),
    $parcel$import("gPFjp"),
    $parcel$import("62Gm4"),
    $parcel$import("kagDH"),
    $parcel$import("23Zfg"),
    $parcel$import("UHAim"),
    $parcel$import("Kmh8h"),
    $parcel$import("Idach"),
    $parcel$import("1OGQc")
]).then(()=>parcelRequire('kLl71'));

});

parcelRegister("hackQ", function(module, exports) {
module.exports = $parcel$import("1AG2d").then(()=>parcelRequire('3knYO'));

});

parcelRegister("9eVn0", function(module, exports) {
module.exports = $parcel$import("fddBV").then(()=>parcelRequire('4SGuZ'));

});

var $991470701e407a99$exports = {};
$parcel$extendImportMap({
    "krmla": "datadogRecorder.3042155a.js",
    "dQHPw": "datadogProfiler.5dad5de2.js",
    "022zR": "logo-volley-horizontal-white.94b0536e.png",
    "lfwpa": "padel-full-court.a3f143b0.png",
    "ewXUA": "padel-half-court.0170138c.png",
    "fOgys": "platform-full-court.bf71f684.png",
    "898SG": "platform-half-court.944b1743.png",
    "aOorz": "tennis-full-court.a76a7b7d.png",
    "7ReGb": "tennis-half-court.bc50c65b.png",
    "7G039": "pickeball-court.0a511976.jpg",
    "jkT2m": "pickleball-court-half.64b7088a.jpg",
    "eP1UT": "AimSpinPlay.4d774719.js",
    "6OTYw": "AimSpinPlay.26f908ce.js",
    "3zbg6": "AimSpinPlay.532ee7e0.js",
    "01DVg": "AimSpinPlay.29652a9b.js",
    "fkvji": "icon-volley-green.05fce6ed.png",
    "8Kb7Q": "ListItemWrapper.791dee0e.js",
    "kUuaI": "Icon.e7e8a01e.js",
    "2wzkX": "Card.7f1e283f.js",
    "7A9kg": "CardWrapper.6984bccc.js",
    "0PPjD": "ai.9919c98d.svg",
    "em1DG": "multi-level.cb646e61.svg",
    "k5eQM": "multi-shot.c4e25514.svg",
    "a81DL": "single-shot.7b609f4c.svg",
    "69z19": "skill.f6d843ac.svg",
    "10UvT": "NotAvailable.a5b52b11.js",
    "y782T": "ResponsivePlayApp.17e49c09.js",
    "6YNHO": "ResponsivePlayApp.0076ba2c.js",
    "GGfgm": "padel-court-transformed.28d2baee.glb",
    "cgz8u": "pickleball-court-transformed.2f9be26f.glb",
    "5ee9I": "platform-court-transformed.69b18fe9.glb",
    "lgIGD": "tennis-court-transformed.0bfb2339.glb",
    "cu1kx": "figure-with-racquet-transformed.6fdcf495.glb",
    "dh37G": "padel-blue-twotone.6699e865.jpg",
    "6eRVt": "padel-blue.da56d04b.jpg",
    "cZinQ": "padel-green.6b40c4f0.jpg",
    "cyviV": "platform-court.ae7eb6ce.jpg",
    "9igfQ": "tennis-court.b3518169.jpg",
    "9RXJb": "arm-transformed.9374f4a6.glb",
    "jlTu5": "base-transformed.51e8fc53.glb",
    "eFQNv": "head-transformed.9c950f5c.glb",
    "jCjSS": "thrower-transformed.7075809b.glb",
    "30nEm": "ResponsivePlayApp.d41d8816.js",
    "buCO7": "ResponsivePlayApp.994f3e3a.js",
    "iPpXy": "Card.f2b65348.js",
    "jjQZS": "Hero.b6f6948a.js",
    "6e2AR": "LobApp2.04d96f80.js",
    "i9AG5": "court-model-geomcorrect.ddf7fc10.png",
    "1jwbh": "indicator-open-green.6ea09afa.png",
    "86Bf6": "indicator-v-green.6dc05399.png",
    "kOHa8": "Card.5e6c4d5a.js",
    "jn0Fh": "Edit.49861b84.js",
    "2Zzi2": "Edit.edb6a9a8.js",
    "3JBno": "Edit.92343376.js",
    "4n6zv": "indicator-filled-white.191aff33.png",
    "42zdT": "indicator-p.89bb1437.png",
    "41e5U": "Edit.c86d915f.js",
    "2rTzC": "indicator-circle-green.0355cc7a.png",
    "7eokS": "Edit.ba135e4f.js",
    "1Kwkm": "PlayScreen.7a25caac.js",
    "7v4Gr": "Card.a57f0eb7.js",
    "e2wF8": "SingleShot.7e97744a.js",
    "Idach": "SingleShot.66ec9ad2.js",
    "9LPS3": "pickleBallGame.b24ce949.js",
    "1Tgoa": "3sd-trainer-location.51247794.png",
    "aBMOs": "pickleBallGame.c0c9fa9f.js",
    "3mM7q": "pickleBallGame.db3ceb8e.js",
    "imDjm": "Edit.15c9e209.js",
    "7cf0W": "PlayScreen.075e1774.js",
    "aeZp9": "Card.cf0211b9.js",
    "8ZAFZ": "serveAndVolleyNewUI.af632fb8.js",
    "8BlCc": "serveAndVolleyNewUI.02704ab0.js",
    "gvSKK": "sv-too-many.38dab711.png",
    "5HeyS": "sv-no-person.cfda8b51.png",
    "aBd01": "sv-hourglass.d888d18d.png",
    "8po0U": "sv-move-to-serve.90404c0e.png",
    "gwExj": "sv-serve.1aaae01d.png",
    "kLCwd": "sv-time.37ac4705.png",
    "9kSth": "ModuleEdit.c2157906.js",
    "dFEJ6": "ModuleEdit.ae654bd9.js",
    "9Yszp": "ModulePlay.6abccde3.js",
    "9XJBM": "Card.e51060cd.js",
    "6w5sC": "12-serve-challenge.ed5e863e.js",
    "83v6l": "sv-trainer-location.79da67e9.jpg",
    "1awVm": "13-baseline-depth.52e00663.js",
    "5doD5": "serveAndVolleyV4.6c49b4b2.js",
    "24JfN": "serveAndVolleyV4.87345a5c.js",
    "c38S7": "History.452b97fd.js",
    "Kmh8h": "History.145d468c.js",
    "8IOv0": "Edit.e6f457b7.js",
    "3JGyK": "AOITriggeredApp.44003d91.js",
    "l44ev": "ModuleEdit.726357ad.js",
    "gamAG": "ModulePlay.0fbc4e79.js",
    "2zZYM": "Card.44347bbb.js",
    "aRQVM": "Icon.1bc50d1f.js",
    "2BXJz": "LacrosseEdit.ffe0bdbc.js",
    "fVbov": "LacrosseEdit.8cef94f7.js",
    "5XZSD": "LacrossePlay.8a9cb3c1.js",
    "tlPsp": "Card.b8c9b142.js",
    "8PhpM": "Icon.8e097876.js",
    "Lfv6y": "ZoneEdit.b4a55c38.js",
    "k7IPS": "ZonePlay.1d834a2e.js",
    "kBSJR": "background-gradient-curves.c06ab289.svg",
    "2lEYF": "logo-volley-square-white.9d158c91.png",
    "jvtwO": "Account.c9c140bb.js",
    "g1aK0": "Account.d5164430.js",
    "fjIlD": "Admin.d16b8aa5.js",
    "j0aM5": "Admin.bbec0f20.js",
    "8Dgp0": "Admin.5785f4f2.js",
    "UHAim": "Admin.e89a3832.js",
    "4d7Bg": "Admin.6f9739a1.js",
    "cyz1y": "Admin.390eb9f2.js",
    "23Zfg": "Admin.60ebd951.js",
    "kagDH": "Admin.baf5d929.js",
    "loiVx": "Admin.053eb8dc.js",
    "03TWs": "Admin.2e12915b.js",
    "7xF25": "Admin.955f9eba.js",
    "702X8": "Experiences.c4735546.js",
    "gxlPR": "Journeys.5c7a29d4.js",
    "62Gm4": "Journeys.f5f14d0e.js",
    "gPFjp": "Journeys.e84d80e1.js",
    "8FTpb": "PlayerPTI.d8208cb7.js",
    "lcs4R": "PlayerPTI.db5e0904.js",
    "godR7": "Signup.62d4e6b2.js",
    "fD4of": "Stats.bd71cba3.js",
    "iUuUZ": "MyGamePage.b3361074.js",
    "hjJuJ": "MyGamePage.6a209e27.js",
    "aT16h": "Trainer.bb18d9af.js",
    "fkyVv": "LacrosseWorkouts.655ce37e.js",
    "js5KE": "ProGrading.1c80aa60.js",
    "1OGQc": "Performance.507004c1.js",
    "1AG2d": "DuprDashboard.03881187.js",
    "fddBV": "PadelDashboard.b7e49f95.js"
});


var $bh6RR = parcelRequire("bh6RR");

var $6Wfmo = parcelRequire("6Wfmo");

var $bVYHX = parcelRequire("bVYHX");
var $c3111c3e3c6a9bdc$var$name = "firebase";
var $c3111c3e3c6a9bdc$var$version = "12.6.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $bVYHX.registerVersion)($c3111c3e3c6a9bdc$var$name, $c3111c3e3c6a9bdc$var$version, 'app');


var $bVYHX = parcelRequire("bVYHX");

var $9ATkq = parcelRequire("9ATkq");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $4YIes = parcelRequire("4YIes");

var $kE5Kn = parcelRequire("kE5Kn");
/**
 * react-router v7.9.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v7.9.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $as544 = parcelRequire("as544");

var $bh6RR = parcelRequire("bh6RR");
var $afb2546315a2083f$exports = {};
"use strict";
Object.defineProperty($afb2546315a2083f$exports, "__esModule", {
    value: true
});
$afb2546315a2083f$exports.parseCookie = $afb2546315a2083f$var$parseCookie;
$afb2546315a2083f$exports.parse = $afb2546315a2083f$var$parseCookie;
$afb2546315a2083f$exports.stringifyCookie = $afb2546315a2083f$var$stringifyCookie;
$afb2546315a2083f$exports.stringifySetCookie = $afb2546315a2083f$var$stringifySetCookie;
$afb2546315a2083f$exports.serialize = $afb2546315a2083f$var$stringifySetCookie;
$afb2546315a2083f$exports.parseSetCookie = $afb2546315a2083f$var$parseSetCookie;
$afb2546315a2083f$exports.stringifySetCookie = $afb2546315a2083f$var$stringifySetCookie;
$afb2546315a2083f$exports.serialize = $afb2546315a2083f$var$stringifySetCookie;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $afb2546315a2083f$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $afb2546315a2083f$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $afb2546315a2083f$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $afb2546315a2083f$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
/**
 * RegExp to match max-age-value in RFC 6265 sec 5.6.2
 */ const $afb2546315a2083f$var$maxAgeRegExp = /^-?\d+$/;
const $afb2546315a2083f$var$__toString = Object.prototype.toString;
const $afb2546315a2083f$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a `Cookie` header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $afb2546315a2083f$var$parseCookie(str, options) {
    const obj = new $afb2546315a2083f$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $afb2546315a2083f$var$decode;
    let index = 0;
    do {
        const eqIdx = $afb2546315a2083f$var$eqIndex(str, index, len);
        if (eqIdx === -1) break; // No more cookie pairs.
        const endIdx = $afb2546315a2083f$var$endIndex(str, index, len);
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = $afb2546315a2083f$var$valueSlice(str, index, eqIdx);
        // only assign once
        if (obj[key] === undefined) obj[key] = dec($afb2546315a2083f$var$valueSlice(str, eqIdx + 1, endIdx));
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
/**
 * Stringifies an object into an HTTP `Cookie` header.
 */ function $afb2546315a2083f$var$stringifyCookie(cookie, options) {
    const enc = options?.encode || encodeURIComponent;
    const cookieStrings = [];
    for (const name of Object.keys(cookie)){
        const val = cookie[name];
        if (val === undefined) continue;
        if (!$afb2546315a2083f$var$cookieNameRegExp.test(name)) throw new TypeError(`cookie name is invalid: ${name}`);
        const value = enc(val);
        if (!$afb2546315a2083f$var$cookieValueRegExp.test(value)) throw new TypeError(`cookie val is invalid: ${val}`);
        cookieStrings.push(`${name}=${value}`);
    }
    return cookieStrings.join("; ");
}
function $afb2546315a2083f$var$stringifySetCookie(_name, _val, _opts) {
    const cookie = typeof _name === "object" ? _name : {
        ..._opts,
        name: _name,
        value: String(_val)
    };
    const options = typeof _val === "object" ? _val : _opts;
    const enc = options?.encode || encodeURIComponent;
    if (!$afb2546315a2083f$var$cookieNameRegExp.test(cookie.name)) throw new TypeError(`argument name is invalid: ${cookie.name}`);
    const value = cookie.value ? enc(cookie.value) : "";
    if (!$afb2546315a2083f$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${cookie.value}`);
    let str = cookie.name + "=" + value;
    if (cookie.maxAge !== undefined) {
        if (!Number.isInteger(cookie.maxAge)) throw new TypeError(`option maxAge is invalid: ${cookie.maxAge}`);
        str += "; Max-Age=" + cookie.maxAge;
    }
    if (cookie.domain) {
        if (!$afb2546315a2083f$var$domainValueRegExp.test(cookie.domain)) throw new TypeError(`option domain is invalid: ${cookie.domain}`);
        str += "; Domain=" + cookie.domain;
    }
    if (cookie.path) {
        if (!$afb2546315a2083f$var$pathValueRegExp.test(cookie.path)) throw new TypeError(`option path is invalid: ${cookie.path}`);
        str += "; Path=" + cookie.path;
    }
    if (cookie.expires) {
        if (!$afb2546315a2083f$var$isDate(cookie.expires) || !Number.isFinite(cookie.expires.valueOf())) throw new TypeError(`option expires is invalid: ${cookie.expires}`);
        str += "; Expires=" + cookie.expires.toUTCString();
    }
    if (cookie.httpOnly) str += "; HttpOnly";
    if (cookie.secure) str += "; Secure";
    if (cookie.partitioned) str += "; Partitioned";
    if (cookie.priority) {
        const priority = typeof cookie.priority === "string" ? cookie.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${cookie.priority}`);
        }
    }
    if (cookie.sameSite) {
        const sameSite = typeof cookie.sameSite === "string" ? cookie.sameSite.toLowerCase() : cookie.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${cookie.sameSite}`);
        }
    }
    return str;
}
/**
 * Deserialize a `Set-Cookie` header into an object.
 *
 * deserialize('foo=bar; httpOnly')
 *   => { name: 'foo', value: 'bar', httpOnly: true }
 */ function $afb2546315a2083f$var$parseSetCookie(str, options) {
    const dec = options?.decode || $afb2546315a2083f$var$decode;
    const len = str.length;
    const endIdx = $afb2546315a2083f$var$endIndex(str, 0, len);
    const eqIdx = $afb2546315a2083f$var$eqIndex(str, 0, endIdx);
    const setCookie = eqIdx === -1 ? {
        name: "",
        value: dec($afb2546315a2083f$var$valueSlice(str, 0, endIdx))
    } : {
        name: $afb2546315a2083f$var$valueSlice(str, 0, eqIdx),
        value: dec($afb2546315a2083f$var$valueSlice(str, eqIdx + 1, endIdx))
    };
    let index = endIdx + 1;
    while(index < len){
        const endIdx = $afb2546315a2083f$var$endIndex(str, index, len);
        const eqIdx = $afb2546315a2083f$var$eqIndex(str, index, endIdx);
        const attr = eqIdx === -1 ? $afb2546315a2083f$var$valueSlice(str, index, endIdx) : $afb2546315a2083f$var$valueSlice(str, index, eqIdx);
        const val = eqIdx === -1 ? undefined : $afb2546315a2083f$var$valueSlice(str, eqIdx + 1, endIdx);
        switch(attr.toLowerCase()){
            case "httponly":
                setCookie.httpOnly = true;
                break;
            case "secure":
                setCookie.secure = true;
                break;
            case "partitioned":
                setCookie.partitioned = true;
                break;
            case "domain":
                setCookie.domain = val;
                break;
            case "path":
                setCookie.path = val;
                break;
            case "max-age":
                if (val && $afb2546315a2083f$var$maxAgeRegExp.test(val)) setCookie.maxAge = Number(val);
                break;
            case "expires":
                if (!val) break;
                const date = new Date(val);
                if (Number.isFinite(date.valueOf())) setCookie.expires = date;
                break;
            case "priority":
                if (!val) break;
                const priority = val.toLowerCase();
                if (priority === "low" || priority === "medium" || priority === "high") setCookie.priority = priority;
                break;
            case "samesite":
                if (!val) break;
                const sameSite = val.toLowerCase();
                if (sameSite === "lax" || sameSite === "strict" || sameSite === "none") setCookie.sameSite = sameSite;
                break;
        }
        index = endIdx + 1;
    }
    return setCookie;
}
/**
 * Find the `;` character between `min` and `len` in str.
 */ function $afb2546315a2083f$var$endIndex(str, min, len) {
    const index = str.indexOf(";", min);
    return index === -1 ? len : index;
}
/**
 * Find the `=` character between `min` and `max` in str.
 */ function $afb2546315a2083f$var$eqIndex(str, min, max) {
    const index = str.indexOf("=", min);
    return index < max ? index : -1;
}
/**
 * Slice out a value between startPod to max.
 */ function $afb2546315a2083f$var$valueSlice(str, min, max) {
    let start = min;
    let end = max;
    do {
        const code = str.charCodeAt(start);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) break;
    }while (++start < end);
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) break;
        end--;
    }
    return str.slice(start, end);
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $afb2546315a2083f$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $afb2546315a2083f$var$isDate(val) {
    return $afb2546315a2083f$var$__toString.call(val) === "[object Date]";
}


var $9f9e482d4249abb3$exports = {};
"use strict";
var $9f9e482d4249abb3$var$defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function $9f9e482d4249abb3$var$isForbiddenKey(key) {
    return typeof key !== "string" || key in {};
}
function $9f9e482d4249abb3$var$createNullObj() {
    return Object.create(null);
}
function $9f9e482d4249abb3$var$isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function $9f9e482d4249abb3$var$parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter($9f9e482d4249abb3$var$isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = $9f9e482d4249abb3$var$parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, $9f9e482d4249abb3$var$defaultParseOptions, options) : $9f9e482d4249abb3$var$defaultParseOptions;
    if ($9f9e482d4249abb3$var$isForbiddenKey(name)) return null;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser: failed to decode cookie value. Set options.decodeValues=false to disable decoding.", e);
    }
    var cookie = $9f9e482d4249abb3$var$createNullObj();
    cookie.name = name;
    cookie.value = value;
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        if ($9f9e482d4249abb3$var$isForbiddenKey(key)) return;
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") {
            var n = parseInt(value, 10);
            if (!Number.isNaN(n)) cookie.maxAge = n;
        } else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else if (key === "partitioned") cookie.partitioned = true;
        else if (key) cookie[key] = value;
    });
    return cookie;
}
function $9f9e482d4249abb3$var$parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function $9f9e482d4249abb3$var$parse(input, options) {
    options = options ? Object.assign({}, $9f9e482d4249abb3$var$defaultParseOptions, options) : $9f9e482d4249abb3$var$defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return $9f9e482d4249abb3$var$createNullObj();
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case)
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!options.map) return input.filter($9f9e482d4249abb3$var$isNonEmptyString).map(function(str) {
        return $9f9e482d4249abb3$var$parseString(str, options);
    }).filter(Boolean);
    else {
        var cookies = $9f9e482d4249abb3$var$createNullObj();
        return input.filter($9f9e482d4249abb3$var$isNonEmptyString).reduce(function(cookies, str) {
            var cookie = $9f9e482d4249abb3$var$parseString(str, options);
            if (cookie && !$9f9e482d4249abb3$var$isForbiddenKey(cookie.name)) cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function $9f9e482d4249abb3$var$splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
$9f9e482d4249abb3$exports = $9f9e482d4249abb3$var$parse;
$9f9e482d4249abb3$exports.parse = $9f9e482d4249abb3$var$parse;
$9f9e482d4249abb3$exports.parseString = $9f9e482d4249abb3$var$parseString;
$9f9e482d4249abb3$exports.splitCookiesString = $9f9e482d4249abb3$var$splitCookiesString;


function $e68dc042638cd0a8$export$7246f7e18cebe1bd({ context: context, url: url, nonce: nonce }) {
    if (typeof url === "string") url = new URL(url);
    let { manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, serverHandoffString: serverHandoffString } = context;
    let routes = (0, $as544.createServerRoutes)(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = {
        ...context.staticHandlerContext.loaderData
    };
    for (let match of context.staticHandlerContext.matches){
        let routeId = match.route.id;
        let route = routeModules[routeId];
        let manifestRoute = context.manifest.routes[routeId];
        if (route && manifestRoute && (0, $as544.shouldHydrateRouteLoader)(routeId, route.clientLoader, manifestRoute.hasLoader, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
    }
    let router = (0, $as544.createStaticRouter)(routes, context.staticHandlerContext);
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, /* @__PURE__ */ $bh6RR.createElement((0, $as544.FrameworkContext).Provider, {
        value: {
            manifest: manifest,
            routeModules: routeModules,
            criticalCss: criticalCss,
            serverHandoffString: serverHandoffString,
            future: context.future,
            ssr: context.ssr,
            isSpaMode: context.isSpaMode,
            routeDiscovery: context.routeDiscovery,
            serializeError: context.serializeError,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ $bh6RR.createElement((0, $as544.RemixErrorBoundary), {
        location: router.state.location
    }, /* @__PURE__ */ $bh6RR.createElement((0, $as544.StaticRouterProvider), {
        router: router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ $bh6RR.createElement($bh6RR.Suspense, null, /* @__PURE__ */ $bh6RR.createElement((0, $as544.StreamTransfer), {
        context: context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce: nonce
    })) : null);
}
function $e68dc042638cd0a8$export$bea31554c7dfd2ad(routes, _context) {
    return function RoutesTestStub({ initialEntries: initialEntries, initialIndex: initialIndex, hydrationData: hydrationData, future: future }) {
        let routerRef = $bh6RR.useRef();
        let frameworkContextRef = $bh6RR.useRef();
        if (routerRef.current == null) {
            frameworkContextRef.current = {
                future: {
                    unstable_subResourceIntegrity: future?.unstable_subResourceIntegrity === true,
                    v8_middleware: future?.v8_middleware === true
                },
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                ssr: false,
                isSpaMode: false,
                routeDiscovery: {
                    mode: "lazy",
                    manifestPath: "/__manifest"
                }
            };
            let patched = $e68dc042638cd0a8$var$processRoutes(// @ts-expect-error `StubRouteObject` is stricter about `loader`/`action`
            // types compared to `AgnosticRouteObject`
            (0, $as544.convertRoutesToDataRoutes)(routes, (r)=>r), _context !== void 0 ? _context : future?.v8_middleware ? new (0, $as544.RouterContextProvider)() : {}, frameworkContextRef.current.manifest, frameworkContextRef.current.routeModules);
            routerRef.current = (0, $as544.createMemoryRouter)(patched, {
                initialEntries: initialEntries,
                initialIndex: initialIndex,
                hydrationData: hydrationData
            });
        }
        return /* @__PURE__ */ $bh6RR.createElement((0, $as544.FrameworkContext).Provider, {
            value: frameworkContextRef.current
        }, /* @__PURE__ */ $bh6RR.createElement((0, $as544.RouterProvider), {
            router: routerRef.current
        }));
    };
}
function $e68dc042638cd0a8$var$processRoutes(routes, context, manifest, routeModules, parentId) {
    return routes.map((route)=>{
        if (!route.id) throw new Error("Expected a route.id in react-router processRoutes() function");
        let newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component ? (0, $as544.withComponentProps)(route.Component) : void 0,
            HydrateFallback: route.HydrateFallback ? (0, $as544.withHydrateFallbackProps)(route.HydrateFallback) : void 0,
            ErrorBoundary: route.ErrorBoundary ? (0, $as544.withErrorBoundaryProps)(route.ErrorBoundary) : void 0,
            action: route.action ? (args)=>route.action({
                    ...args,
                    context: context
                }) : void 0,
            loader: route.loader ? (args)=>route.loader({
                    ...args,
                    context: context
                }) : void 0,
            middleware: route.middleware ? route.middleware.map((mw)=>(...args)=>mw({
                        ...args[0],
                        context: context
                    }, args[1])) : void 0,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        let entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId: parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should be stubbing loader/action/middleware,
            // not trying to re-implement the full loader/clientLoader/SSR/hydration
            // flow. That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasClientMiddleware: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            // any need for these?
            module: "build/stub-path-to-module.js",
            clientActionModule: void 0,
            clientLoaderModule: void 0,
            clientMiddlewareModule: void 0,
            hydrateFallbackModule: void 0
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: newRoute.Component || (0, $as544.Outlet),
            ErrorBoundary: newRoute.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = $e68dc042638cd0a8$var$processRoutes(route.children, context, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var $e68dc042638cd0a8$var$encoder = /* @__PURE__ */ new TextEncoder();
var $e68dc042638cd0a8$var$sign = async (value, secret)=>{
    let data2 = $e68dc042638cd0a8$var$encoder.encode(value);
    let key = await $e68dc042638cd0a8$var$createKey(secret, [
        "sign"
    ]);
    let signature = await crypto.subtle.sign("HMAC", key, data2);
    let hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(/=+$/, "");
    return value + "." + hash;
};
var $e68dc042638cd0a8$var$unsign = async (cookie, secret)=>{
    let index = cookie.lastIndexOf(".");
    let value = cookie.slice(0, index);
    let hash = cookie.slice(index + 1);
    let data2 = $e68dc042638cd0a8$var$encoder.encode(value);
    let key = await $e68dc042638cd0a8$var$createKey(secret, [
        "verify"
    ]);
    try {
        let signature = $e68dc042638cd0a8$var$byteStringToUint8Array(atob(hash));
        let valid = await crypto.subtle.verify("HMAC", key, signature, data2);
        return valid ? value : false;
    } catch (error) {
        return false;
    }
};
var $e68dc042638cd0a8$var$createKey = async (secret, usages)=>crypto.subtle.importKey("raw", $e68dc042638cd0a8$var$encoder.encode(secret), {
        name: "HMAC",
        hash: "SHA-256"
    }, false, usages);
function $e68dc042638cd0a8$var$byteStringToUint8Array(byteString) {
    let array = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var $e68dc042638cd0a8$export$7892c26d6c7a7447 = (name, cookieOptions = {})=>{
    let { secrets: secrets = [], ...options } = {
        path: "/",
        sameSite: "lax",
        ...cookieOptions
    };
    $e68dc042638cd0a8$var$warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        async parse (cookieHeader, parseOptions) {
            if (!cookieHeader) return null;
            let cookies = (0, $afb2546315a2083f$exports.parse)(cookieHeader, {
                ...options,
                ...parseOptions
            });
            if (name in cookies) {
                let value = cookies[name];
                if (typeof value === "string" && value !== "") {
                    let decoded = await $e68dc042638cd0a8$var$decodeCookieValue(value, secrets);
                    return decoded;
                } else return "";
            } else return null;
        },
        async serialize (value, serializeOptions) {
            return (0, $afb2546315a2083f$exports.serialize)(name, value === "" ? "" : await $e68dc042638cd0a8$var$encodeCookieValue(value, secrets), {
                ...options,
                ...serializeOptions
            });
        }
    };
};
var $e68dc042638cd0a8$export$f00768c7d8d5ffdb = (object)=>{
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
async function $e68dc042638cd0a8$var$encodeCookieValue(value, secrets) {
    let encoded = $e68dc042638cd0a8$var$encodeData(value);
    if (secrets.length > 0) encoded = await $e68dc042638cd0a8$var$sign(encoded, secrets[0]);
    return encoded;
}
async function $e68dc042638cd0a8$var$decodeCookieValue(value, secrets) {
    if (secrets.length > 0) {
        for (let secret of secrets){
            let unsignedValue = await $e68dc042638cd0a8$var$unsign(value, secret);
            if (unsignedValue !== false) return $e68dc042638cd0a8$var$decodeData(unsignedValue);
        }
        return null;
    }
    return $e68dc042638cd0a8$var$decodeData(value);
}
function $e68dc042638cd0a8$var$encodeData(value) {
    return btoa($e68dc042638cd0a8$var$myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function $e68dc042638cd0a8$var$decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent($e68dc042638cd0a8$var$myEscape(atob(value))));
    } catch (error) {
        return {};
    }
}
function $e68dc042638cd0a8$var$myEscape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + $e68dc042638cd0a8$var$hex(code, 2);
            else result += "%u" + $e68dc042638cd0a8$var$hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function $e68dc042638cd0a8$var$hex(code, length) {
    let result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function $e68dc042638cd0a8$var$myUnescape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function $e68dc042638cd0a8$var$warnOnceAboutExpiresCookie(name, expires) {
    (0, $as544.warnOnce)(!expires, `The "${name}" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use \`commitSession(session, { expires })\` if using a session storage object, or \`cookie.serialize("value", { expires })\` if you're using the cookie directly.`);
}
// lib/server-runtime/entry.ts
function $e68dc042638cd0a8$var$createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce((memo, routeId)=>{
        let route = manifest[routeId];
        if (route) memo[routeId] = route.module;
        return memo;
    }, {});
}
// lib/server-runtime/mode.ts
var $e68dc042638cd0a8$export$e7973f87fd96e4f2 = /* @__PURE__ */ ((ServerMode2)=>{
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
})($e68dc042638cd0a8$export$e7973f87fd96e4f2 || {});
function $e68dc042638cd0a8$var$isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function $e68dc042638cd0a8$var$sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        let sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function $e68dc042638cd0a8$var$sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce((acc, [routeId, error])=>{
        return Object.assign(acc, {
            [routeId]: $e68dc042638cd0a8$var$sanitizeError(error, serverMode)
        });
    }, {});
}
function $e68dc042638cd0a8$var$serializeError(error, serverMode) {
    let sanitized = $e68dc042638cd0a8$var$sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
function $e68dc042638cd0a8$var$serializeErrors(errors, serverMode) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ((0, $as544.isRouteErrorResponse)(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) {
            let sanitized = $e68dc042638cd0a8$var$sanitizeError(val, serverMode);
            serialized[key] = {
                message: sanitized.message,
                stack: sanitized.stack,
                __type: "Error",
                // If this is a subclass (i.e., ReferenceError), send up the type so we
                // can re-create the same type during hydration.  This will only apply
                // in dev mode since all production errors are sanitized to normal
                // Error instances
                ...sanitized.name !== "Error" ? {
                    __subType: sanitized.name
                } : {}
            };
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/server-runtime/routeMatching.ts
function $e68dc042638cd0a8$var$matchServerRoutes(routes, pathname, basename) {
    let matches = (0, $as544.matchRoutes)(routes, pathname, basename);
    if (!matches) return null;
    return matches.map((match)=>({
            params: match.params,
            pathname: match.pathname,
            route: match.route
        }));
}
// lib/server-runtime/data.ts
async function $e68dc042638cd0a8$var$callRouteHandler(handler, args) {
    let result = await handler({
        request: $e68dc042638cd0a8$var$stripRoutesParam($e68dc042638cd0a8$var$stripIndexParam(args.request)),
        params: args.params,
        context: args.context,
        unstable_pattern: args.unstable_pattern
    });
    if ((0, $as544.isDataWithResponseInit)(result) && result.init && result.init.status && (0, $as544.isRedirectStatusCode)(result.init.status)) throw new Response(null, result.init);
    return result;
}
function $e68dc042638cd0a8$var$stripIndexParam(request) {
    let url = new URL(request.url);
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function $e68dc042638cd0a8$var$stripRoutesParam(request) {
    let url = new URL(request.url);
    url.searchParams.delete("_routes");
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/invariant.ts
function $e68dc042638cd0a8$var$invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/dev.ts
var $e68dc042638cd0a8$var$globalDevServerHooksKey = "__reactRouterDevServerHooks";
function $e68dc042638cd0a8$export$31bc6e795ff1cb0a(devServerHooks) {
    globalThis[$e68dc042638cd0a8$var$globalDevServerHooksKey] = devServerHooks;
}
function $e68dc042638cd0a8$var$getDevServerHooks() {
    return globalThis[$e68dc042638cd0a8$var$globalDevServerHooksKey];
}
function $e68dc042638cd0a8$var$getBuildTimeHeader(request, headerName) {
    var e;
    return null;
}
// lib/server-runtime/routes.ts
function $e68dc042638cd0a8$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $e68dc042638cd0a8$var$createRoutes(manifest, parentId = "", routesByParentId = $e68dc042638cd0a8$var$groupRoutesByParentId(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>({
            ...route,
            children: $e68dc042638cd0a8$var$createRoutes(manifest, route.id, routesByParentId)
        }));
}
function $e68dc042638cd0a8$var$createStaticHandlerDataRoutes(manifest, future, parentId = "", routesByParentId = $e68dc042638cd0a8$var$groupRoutesByParentId(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            middleware: route.module.middleware,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? async (args)=>{
                let preRenderedData = $e68dc042638cd0a8$var$getBuildTimeHeader(args.request, "X-React-Router-Prerender-Data");
                if (preRenderedData != null) {
                    let encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                    $e68dc042638cd0a8$var$invariant(encoded, "Missing prerendered data for route");
                    let uint8array = new TextEncoder().encode(encoded);
                    let stream = new ReadableStream({
                        start (controller) {
                            controller.enqueue(uint8array);
                            controller.close();
                        }
                    });
                    let decoded = await (0, $as544.decodeViaTurboStream)(stream, $parcel$global);
                    let data2 = decoded.value;
                    if (data2 && (0, $as544.SingleFetchRedirectSymbol) in data2) {
                        let result = data2[0, $as544.SingleFetchRedirectSymbol];
                        let init = {
                            status: result.status
                        };
                        if (result.reload) throw (0, $as544.redirectDocument)(result.redirect, init);
                        else if (result.replace) throw (0, $as544.replace)(result.redirect, init);
                        else throw (0, $as544.redirect)(result.redirect, init);
                    } else {
                        $e68dc042638cd0a8$var$invariant(data2 && route.id in data2, "Unable to decode prerendered data");
                        let result = data2[route.id];
                        $e68dc042638cd0a8$var$invariant("data" in result, "Unable to process prerendered data");
                        return result.data;
                    }
                }
                let val = await $e68dc042638cd0a8$var$callRouteHandler(route.module.loader, args);
                return val;
            } : void 0,
            action: route.module.action ? (args)=>$e68dc042638cd0a8$var$callRouteHandler(route.module.action, args) : void 0,
            handle: route.module.handle
        };
        return route.index ? {
            index: true,
            ...commonRoute
        } : {
            caseSensitive: route.caseSensitive,
            children: $e68dc042638cd0a8$var$createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId),
            ...commonRoute
        };
    });
}
// lib/server-runtime/serverHandoff.ts
function $e68dc042638cd0a8$var$createServerHandoffString(serverHandoff) {
    return (0, $as544.escapeHtml)(JSON.stringify(serverHandoff));
}
function $e68dc042638cd0a8$var$getDocumentHeaders(context, build) {
    return $e68dc042638cd0a8$var$getDocumentHeadersImpl(context, (m)=>{
        let route = build.routes[m.route.id];
        $e68dc042638cd0a8$var$invariant(route, `Route with id "${m.route.id}" not found in build`);
        return route.module.headers;
    });
}
function $e68dc042638cd0a8$var$getDocumentHeadersImpl(context, getRouteHeadersFn, _defaultHeaders) {
    let boundaryIdx = context.errors ? context.matches.findIndex((m)=>context.errors[m.route.id]) : -1;
    let matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    let errorHeaders;
    if (boundaryIdx >= 0) {
        let { actionHeaders: actionHeaders, actionData: actionData, loaderHeaders: loaderHeaders, loaderData: loaderData } = context;
        context.matches.slice(boundaryIdx).some((match)=>{
            let id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    const defaultHeaders = new Headers(_defaultHeaders);
    return matches.reduce((parentHeaders, match, idx)=>{
        let { id: id } = match.route;
        let loaderHeaders = context.loaderHeaders[id] || new Headers();
        let actionHeaders = context.actionHeaders[id] || new Headers();
        let includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        let includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        let headersFn = getRouteHeadersFn(match);
        if (headersFn == null) {
            let headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) $e68dc042638cd0a8$var$prependCookies(errorHeaders, headers2);
            $e68dc042638cd0a8$var$prependCookies(actionHeaders, headers2);
            $e68dc042638cd0a8$var$prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        let headers = new Headers(typeof headersFn === "function" ? headersFn({
            loaderHeaders: loaderHeaders,
            parentHeaders: parentHeaders,
            actionHeaders: actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : headersFn);
        if (includeErrorCookies) $e68dc042638cd0a8$var$prependCookies(errorHeaders, headers);
        $e68dc042638cd0a8$var$prependCookies(actionHeaders, headers);
        $e68dc042638cd0a8$var$prependCookies(loaderHeaders, headers);
        $e68dc042638cd0a8$var$prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers(defaultHeaders));
}
function $e68dc042638cd0a8$var$prependCookies(parentHeaders, childHeaders) {
    let parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        let cookies = (0, $9f9e482d4249abb3$exports.splitCookiesString)(parentSetCookieString);
        let childCookies = new Set(childHeaders.getSetCookie());
        cookies.forEach((cookie)=>{
            if (!childCookies.has(cookie)) childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/server-runtime/single-fetch.ts
var $e68dc042638cd0a8$var$SERVER_NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    ...(0, $as544.NO_BODY_STATUS_CODES),
    304
]);
async function $e68dc042638cd0a8$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            method: request.method,
            body: request.body,
            headers: request.headers,
            signal: request.signal,
            ...request.body ? {
                duplex: "half"
            } : void 0
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            skipRevalidation: true,
            generateMiddlewareResponse: build.future.v8_middleware ? async (query)=>{
                try {
                    let innerResult = await query(handlerRequest);
                    return handleQueryResult(innerResult);
                } catch (error) {
                    return handleQueryError(error);
                }
            } : void 0
        });
        return handleQueryResult(result);
    } catch (error) {
        return handleQueryError(error);
    }
    function handleQueryResult(result) {
        return (0, $as544.isResponse)(result) ? result : staticContextToResponse(result);
    }
    function handleQueryError(error) {
        handleError(error);
        return $e68dc042638cd0a8$var$generateSingleFetchResponse(request, build, serverMode, {
            result: {
                error: error
            },
            headers: new Headers(),
            status: 500
        });
    }
    function staticContextToResponse(context) {
        let headers = $e68dc042638cd0a8$var$getDocumentHeaders(context, build);
        if ((0, $as544.isRedirectStatusCode)(context.statusCode) && headers.has("Location")) return new Response(null, {
            status: context.statusCode,
            headers: headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!(0, $as544.isRouteErrorResponse)(err) || err.error) handleError(err);
            });
            context.errors = $e68dc042638cd0a8$var$sanitizeErrors(context.errors, serverMode);
        }
        let singleFetchResult;
        if (context.errors) singleFetchResult = {
            error: Object.values(context.errors)[0]
        };
        else singleFetchResult = {
            data: Object.values(context.actionData || {})[0]
        };
        return $e68dc042638cd0a8$var$generateSingleFetchResponse(request, build, serverMode, {
            result: singleFetchResult,
            headers: headers,
            status: context.statusCode
        });
    }
}
async function $e68dc042638cd0a8$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    let routesParam = new URL(request.url).searchParams.get("_routes");
    let loadRouteIds = routesParam ? new Set(routesParam.split(",")) : null;
    try {
        let handlerRequest = new Request(handlerUrl, {
            headers: request.headers,
            signal: request.signal
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            filterMatchesToLoad: (m)=>!loadRouteIds || loadRouteIds.has(m.route.id),
            skipLoaderErrorBubbling: true,
            generateMiddlewareResponse: build.future.v8_middleware ? async (query)=>{
                try {
                    let innerResult = await query(handlerRequest);
                    return handleQueryResult(innerResult);
                } catch (error) {
                    return handleQueryError(error);
                }
            } : void 0
        });
        return handleQueryResult(result);
    } catch (error) {
        return handleQueryError(error);
    }
    function handleQueryResult(result) {
        return (0, $as544.isResponse)(result) ? result : staticContextToResponse(result);
    }
    function handleQueryError(error) {
        handleError(error);
        return $e68dc042638cd0a8$var$generateSingleFetchResponse(request, build, serverMode, {
            result: {
                error: error
            },
            headers: new Headers(),
            status: 500
        });
    }
    function staticContextToResponse(context) {
        let headers = $e68dc042638cd0a8$var$getDocumentHeaders(context, build);
        if ((0, $as544.isRedirectStatusCode)(context.statusCode) && headers.has("Location")) return new Response(null, {
            status: context.statusCode,
            headers: headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!(0, $as544.isRouteErrorResponse)(err) || err.error) handleError(err);
            });
            context.errors = $e68dc042638cd0a8$var$sanitizeErrors(context.errors, serverMode);
        }
        let results = {};
        let loadedMatches = new Set(context.matches.filter((m)=>loadRouteIds ? loadRouteIds.has(m.route.id) : m.route.loader != null).map((m)=>m.route.id));
        if (context.errors) for (let [id, error] of Object.entries(context.errors))results[id] = {
            error: error
        };
        for (let [id, data2] of Object.entries(context.loaderData))if (!(id in results) && loadedMatches.has(id)) results[id] = {
            data: data2
        };
        return $e68dc042638cd0a8$var$generateSingleFetchResponse(request, build, serverMode, {
            result: results,
            headers: headers,
            status: context.statusCode
        });
    }
}
function $e68dc042638cd0a8$var$generateSingleFetchResponse(request, build, serverMode, { result: result, headers: headers, status: status }) {
    let resultHeaders = new Headers(headers);
    resultHeaders.set("X-Remix-Response", "yes");
    if ($e68dc042638cd0a8$var$SERVER_NO_BODY_STATUS_CODES.has(status)) return new Response(null, {
        status: status,
        headers: resultHeaders
    });
    resultHeaders.set("Content-Type", "text/x-script");
    resultHeaders.delete("Content-Length");
    return new Response($e68dc042638cd0a8$var$encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
        status: status || 200,
        headers: resultHeaders
    });
}
function $e68dc042638cd0a8$var$generateSingleFetchRedirectResponse(redirectResponse, request, build, serverMode) {
    let redirect2 = $e68dc042638cd0a8$var$getSingleFetchRedirect(redirectResponse.status, redirectResponse.headers, build.basename);
    let headers = new Headers(redirectResponse.headers);
    headers.delete("Location");
    headers.set("Content-Type", "text/x-script");
    return $e68dc042638cd0a8$var$generateSingleFetchResponse(request, build, serverMode, {
        result: request.method === "GET" ? {
            [(0, $as544.SingleFetchRedirectSymbol)]: redirect2
        } : redirect2,
        headers: headers,
        status: (0, $as544.SINGLE_FETCH_REDIRECT_STATUS)
    });
}
function $e68dc042638cd0a8$var$getSingleFetchRedirect(status, headers, basename) {
    let redirect2 = headers.get("Location");
    if (basename) redirect2 = (0, $as544.stripBasename)(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status: status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function $e68dc042638cd0a8$var$encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    let controller = new AbortController();
    let timeoutId = setTimeout(()=>controller.abort(new Error("Server Timeout")), typeof streamTimeout === "number" ? streamTimeout : 4950);
    requestSignal.addEventListener("abort", ()=>clearTimeout(timeoutId));
    return (0, $as544.encode)(data2, {
        signal: controller.signal,
        plugins: [
            (value)=>{
                if (value instanceof Error) {
                    let { name: name, message: message, stack: stack } = serverMode === "production" /* Production */  ? $e68dc042638cd0a8$var$sanitizeError(value, serverMode) : value;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof (0, $as544.ErrorResponseImpl)) {
                    let { data: data3, status: status, statusText: statusText } = value;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && typeof value === "object" && (0, $as544.SingleFetchRedirectSymbol) in value) return [
                    "SingleFetchRedirect",
                    value[0, $as544.SingleFetchRedirectSymbol]
                ];
            }
        ],
        postPlugins: [
            (value)=>{
                if (!value) return;
                if (typeof value !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            ()=>[
                    "SingleFetchFallback"
                ]
        ]
    });
}
// lib/server-runtime/server.ts
function $e68dc042638cd0a8$var$derive(build, mode) {
    let routes = $e68dc042638cd0a8$var$createRoutes(build.routes);
    let dataRoutes = $e68dc042638cd0a8$var$createStaticHandlerDataRoutes(build.routes, build.future);
    let serverMode = $e68dc042638cd0a8$var$isServerMode(mode) ? mode : "production" /* Production */ ;
    let staticHandler = (0, $as544.createStaticHandler)(dataRoutes, {
        basename: build.basename,
        unstable_instrumentations: build.entry.module.unstable_instrumentations
    });
    let errorHandler = build.entry.module.handleError || ((error, { request: request })=>{
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        (0, $as544.isRouteErrorResponse)(error) && error.error ? error.error : error);
    });
    let requestHandler = async (request, initialContext)=>{
        let params = {};
        let loadContext;
        let handleError = (error)=>{
            if (mode === "development" /* Development */ ) $e68dc042638cd0a8$var$getDevServerHooks()?.processRequestError?.(error);
            errorHandler(error, {
                context: loadContext,
                params: params,
                request: request
            });
        };
        if (build.future.v8_middleware) {
            if (initialContext && !(initialContext instanceof (0, $as544.RouterContextProvider))) {
                let error = new Error("Invalid `context` value provided to `handleRequest`. When middleware is enabled you must return an instance of `RouterContextProvider` from your `getLoadContext` function.");
                handleError(error);
                return $e68dc042638cd0a8$var$returnLastResortErrorResponse(error, serverMode);
            }
            loadContext = initialContext || new (0, $as544.RouterContextProvider)();
        } else loadContext = initialContext || {};
        let url = new URL(request.url);
        let normalizedBasename = build.basename || "/";
        let normalizedPath = url.pathname;
        if ((0, $as544.stripBasename)(normalizedPath, normalizedBasename) === "/_root.data") normalizedPath = normalizedBasename;
        else if (normalizedPath.endsWith(".data")) normalizedPath = normalizedPath.replace(/\.data$/, "");
        if ((0, $as544.stripBasename)(normalizedPath, normalizedBasename) !== "/" && normalizedPath.endsWith("/")) normalizedPath = normalizedPath.slice(0, -1);
        let isSpaMode = $e68dc042638cd0a8$var$getBuildTimeHeader(request, "X-React-Router-SPA-Mode") === "yes";
        if (!build.ssr) {
            let decodedPath = decodeURI(normalizedPath);
            if (normalizedBasename !== "/") {
                let strippedPath = (0, $as544.stripBasename)(decodedPath, normalizedBasename);
                if (strippedPath == null) {
                    errorHandler(new (0, $as544.ErrorResponseImpl)(404, "Not Found", `Refusing to prerender the \`${decodedPath}\` path because it does not start with the basename \`${normalizedBasename}\``), {
                        context: loadContext,
                        params: params,
                        request: request
                    });
                    return new Response("Not Found", {
                        status: 404,
                        statusText: "Not Found"
                    });
                }
                decodedPath = strippedPath;
            }
            if (build.prerender.length === 0) isSpaMode = true;
            else if (!build.prerender.includes(decodedPath) && !build.prerender.includes(decodedPath + "/")) {
                if (url.pathname.endsWith(".data")) {
                    errorHandler(new (0, $as544.ErrorResponseImpl)(404, "Not Found", `Refusing to SSR the path \`${decodedPath}\` because \`ssr:false\` is set and the path is not included in the \`prerender\` config, so in production the path will be a 404.`), {
                        context: loadContext,
                        params: params,
                        request: request
                    });
                    return new Response("Not Found", {
                        status: 404,
                        statusText: "Not Found"
                    });
                } else isSpaMode = true;
            }
        }
        let manifestUrl = (0, $as544.getManifestPath)(build.routeDiscovery.manifestPath, normalizedBasename);
        if (url.pathname === manifestUrl) try {
            let res = await $e68dc042638cd0a8$var$handleManifestRequest(build, routes, url);
            return res;
        } catch (e) {
            handleError(e);
            return new Response("Unknown Server Error", {
                status: 500
            });
        }
        let matches = $e68dc042638cd0a8$var$matchServerRoutes(routes, normalizedPath, build.basename);
        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
        let response;
        if (url.pathname.endsWith(".data")) {
            let handlerUrl = new URL(request.url);
            handlerUrl.pathname = normalizedPath;
            let singleFetchMatches = $e68dc042638cd0a8$var$matchServerRoutes(routes, handlerUrl.pathname, build.basename);
            response = await $e68dc042638cd0a8$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError);
            if ((0, $as544.isRedirectResponse)(response)) response = $e68dc042638cd0a8$var$generateSingleFetchRedirectResponse(response, request, build, serverMode);
            if (build.entry.module.handleDataRequest) {
                response = await build.entry.module.handleDataRequest(response, {
                    context: loadContext,
                    params: singleFetchMatches ? singleFetchMatches[0].params : {},
                    request: request
                });
                if ((0, $as544.isRedirectResponse)(response)) response = $e68dc042638cd0a8$var$generateSingleFetchRedirectResponse(response, request, build, serverMode);
            }
        } else if (!isSpaMode && matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null) response = await $e68dc042638cd0a8$var$handleResourceRequest(serverMode, build, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError);
        else {
            let { pathname: pathname } = url;
            let criticalCss = void 0;
            if (build.unstable_getCriticalCss) criticalCss = await build.unstable_getCriticalCss({
                pathname: pathname
            });
            else if (mode === "development" /* Development */  && $e68dc042638cd0a8$var$getDevServerHooks()?.getCriticalCss) criticalCss = await $e68dc042638cd0a8$var$getDevServerHooks()?.getCriticalCss?.(pathname);
            response = await $e68dc042638cd0a8$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, isSpaMode, criticalCss);
        }
        if (request.method === "HEAD") return new Response(null, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
        return response;
    };
    if (build.entry.module.unstable_instrumentations) requestHandler = (0, $as544.instrumentHandler)(requestHandler, build.entry.module.unstable_instrumentations.map((i)=>i.handler).filter(Boolean));
    return {
        routes: routes,
        dataRoutes: dataRoutes,
        serverMode: serverMode,
        staticHandler: staticHandler,
        errorHandler: errorHandler,
        requestHandler: requestHandler
    };
}
var $e68dc042638cd0a8$export$6308091d8cbd0718 = (build, mode)=>{
    let _build;
    let routes;
    let serverMode;
    let staticHandler;
    let errorHandler;
    let _requestHandler;
    return async function requestHandler(request, initialContext) {
        _build = typeof build === "function" ? await build() : build;
        if (typeof build === "function") {
            let derived = $e68dc042638cd0a8$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
            _requestHandler = derived.requestHandler;
        } else if (!routes || !serverMode || !staticHandler || !errorHandler || !_requestHandler) {
            let derived = $e68dc042638cd0a8$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
            _requestHandler = derived.requestHandler;
        }
        return _requestHandler(request, initialContext);
    };
};
async function $e68dc042638cd0a8$var$handleManifestRequest(build, routes, url) {
    if (build.assets.version !== url.searchParams.get("version")) return new Response(null, {
        status: 204,
        headers: {
            "X-Remix-Reload-Document": "true"
        }
    });
    let patches = {};
    if (url.searchParams.has("paths")) {
        let paths = /* @__PURE__ */ new Set();
        let pathParam = url.searchParams.get("paths") || "";
        let requestedPaths = pathParam.split(",").filter(Boolean);
        requestedPaths.forEach((path)=>{
            if (!path.startsWith("/")) path = `/${path}`;
            let segments = path.split("/").slice(1);
            segments.forEach((_, i)=>{
                let partialPath = segments.slice(0, i + 1).join("/");
                paths.add(`/${partialPath}`);
            });
        });
        for (let path of paths){
            let matches = $e68dc042638cd0a8$var$matchServerRoutes(routes, path, build.basename);
            if (matches) for (let match of matches){
                let routeId = match.route.id;
                let route = build.assets.routes[routeId];
                if (route) patches[routeId] = route;
            }
        }
        return Response.json(patches, {
            headers: {
                "Cache-Control": "public, max-age=31536000, immutable"
            }
        });
    }
    return new Response("Invalid Request", {
        status: 400
    });
}
async function $e68dc042638cd0a8$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError) {
    let response = request.method !== "GET" ? await $e68dc042638cd0a8$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) : await $e68dc042638cd0a8$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError);
    return response;
}
async function $e68dc042638cd0a8$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, isSpaMode, criticalCss) {
    try {
        let result = await staticHandler.query(request, {
            requestContext: loadContext,
            generateMiddlewareResponse: build.future.v8_middleware ? async (query)=>{
                try {
                    let innerResult = await query(request);
                    if (!(0, $as544.isResponse)(innerResult)) innerResult = await renderHtml(innerResult, isSpaMode);
                    return innerResult;
                } catch (error) {
                    handleError(error);
                    return new Response(null, {
                        status: 500
                    });
                }
            } : void 0
        });
        if (!(0, $as544.isResponse)(result)) result = await renderHtml(result, isSpaMode);
        return result;
    } catch (error) {
        handleError(error);
        return new Response(null, {
            status: 500
        });
    }
    async function renderHtml(context, isSpaMode2) {
        let headers = $e68dc042638cd0a8$var$getDocumentHeaders(context, build);
        if ($e68dc042638cd0a8$var$SERVER_NO_BODY_STATUS_CODES.has(context.statusCode)) return new Response(null, {
            status: context.statusCode,
            headers: headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!(0, $as544.isRouteErrorResponse)(err) || err.error) handleError(err);
            });
            context.errors = $e68dc042638cd0a8$var$sanitizeErrors(context.errors, serverMode);
        }
        let state = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $e68dc042638cd0a8$var$serializeErrors(context.errors, serverMode)
        };
        let baseServerHandoff = {
            basename: build.basename,
            future: build.future,
            routeDiscovery: build.routeDiscovery,
            ssr: build.ssr,
            isSpaMode: isSpaMode2
        };
        let entryContext = {
            manifest: build.assets,
            routeModules: $e68dc042638cd0a8$var$createEntryRouteModules(build.routes),
            staticHandlerContext: context,
            criticalCss: criticalCss,
            serverHandoffString: $e68dc042638cd0a8$var$createServerHandoffString({
                ...baseServerHandoff,
                criticalCss: criticalCss
            }),
            serverHandoffStream: $e68dc042638cd0a8$var$encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
            renderMeta: {},
            future: build.future,
            ssr: build.ssr,
            routeDiscovery: build.routeDiscovery,
            isSpaMode: isSpaMode2,
            serializeError: (err)=>$e68dc042638cd0a8$var$serializeError(err, serverMode)
        };
        let handleDocumentRequestFunction = build.entry.module.default;
        try {
            return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
        } catch (error) {
            handleError(error);
            let errorForSecondRender = error;
            if ((0, $as544.isResponse)(error)) try {
                let data2 = await $e68dc042638cd0a8$var$unwrapResponse(error);
                errorForSecondRender = new (0, $as544.ErrorResponseImpl)(error.status, error.statusText, data2);
            } catch (e) {}
            context = (0, $as544.getStaticContextFromError)(staticHandler.dataRoutes, context, errorForSecondRender);
            if (context.errors) context.errors = $e68dc042638cd0a8$var$sanitizeErrors(context.errors, serverMode);
            let state2 = {
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: $e68dc042638cd0a8$var$serializeErrors(context.errors, serverMode)
            };
            entryContext = {
                ...entryContext,
                staticHandlerContext: context,
                serverHandoffString: $e68dc042638cd0a8$var$createServerHandoffString(baseServerHandoff),
                serverHandoffStream: $e68dc042638cd0a8$var$encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
                renderMeta: {}
            };
            try {
                return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
            } catch (error2) {
                handleError(error2);
                return $e68dc042638cd0a8$var$returnLastResortErrorResponse(error2, serverMode);
            }
        }
    }
}
async function $e68dc042638cd0a8$var$handleResourceRequest(serverMode, build, staticHandler, routeId, request, loadContext, handleError) {
    try {
        let result = await staticHandler.queryRoute(request, {
            routeId: routeId,
            requestContext: loadContext,
            generateMiddlewareResponse: build.future.v8_middleware ? async (queryRoute)=>{
                try {
                    let innerResult = await queryRoute(request);
                    return handleQueryRouteResult(innerResult);
                } catch (error) {
                    return handleQueryRouteError(error);
                }
            } : void 0
        });
        return handleQueryRouteResult(result);
    } catch (error) {
        return handleQueryRouteError(error);
    }
    function handleQueryRouteResult(result) {
        if ((0, $as544.isResponse)(result)) return result;
        if (typeof result === "string") return new Response(result);
        return Response.json(result);
    }
    function handleQueryRouteError(error) {
        if ((0, $as544.isResponse)(error)) return error;
        if ((0, $as544.isRouteErrorResponse)(error)) {
            handleError(error);
            return $e68dc042638cd0a8$var$errorResponseToJson(error, serverMode);
        }
        if (error instanceof Error && error.message === "Expected a response from queryRoute") {
            let newError = new Error("Expected a Response to be returned from resource route handler");
            handleError(newError);
            return $e68dc042638cd0a8$var$returnLastResortErrorResponse(newError, serverMode);
        }
        handleError(error);
        return $e68dc042638cd0a8$var$returnLastResortErrorResponse(error, serverMode);
    }
}
function $e68dc042638cd0a8$var$errorResponseToJson(errorResponse, serverMode) {
    return Response.json($e68dc042638cd0a8$var$serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText
    });
}
function $e68dc042638cd0a8$var$returnLastResortErrorResponse(error, serverMode) {
    let message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += `

${String(error)}`;
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function $e68dc042638cd0a8$var$unwrapResponse(response) {
    let contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function $e68dc042638cd0a8$var$flash(name) {
    return `__flash_${name}__`;
}
var $e68dc042638cd0a8$export$f7c62c73429afa28 = (initialData = {}, id = "")=>{
    let map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has (name) {
            return map.has(name) || map.has($e68dc042638cd0a8$var$flash(name));
        },
        get (name) {
            if (map.has(name)) return map.get(name);
            let flashName = $e68dc042638cd0a8$var$flash(name);
            if (map.has(flashName)) {
                let value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set (name, value) {
            map.set(name, value);
        },
        flash (name, value) {
            map.set($e68dc042638cd0a8$var$flash(name), value);
        },
        unset (name) {
            map.delete(name);
        }
    };
};
var $e68dc042638cd0a8$export$548944bd211b425f = (object)=>{
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function $e68dc042638cd0a8$export$1f1c547b06207ca3({ cookie: cookieArg, createData: createData, readData: readData, updateData: updateData, deleteData: deleteData }) {
    let cookie = $e68dc042638cd0a8$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $e68dc042638cd0a8$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $e68dc042638cd0a8$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            let id = cookieHeader && await cookie.parse(cookieHeader, options);
            let data2 = id && await readData(id);
            return $e68dc042638cd0a8$export$f7c62c73429afa28(data2 || {}, id || "");
        },
        async commitSession (session, options) {
            let { id: id, data: data2 } = session;
            let expires = options?.maxAge != null ? new Date(Date.now() + options.maxAge * 1e3) : options?.expires != null ? options.expires : cookie.expires;
            if (id) await updateData(id, data2, expires);
            else id = await createData(data2, expires);
            return cookie.serialize(id, options);
        },
        async destroySession (session, options) {
            await deleteData(session.id);
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
function $e68dc042638cd0a8$var$warnOnceAboutSigningSessionCookie(cookie) {
    (0, $as544.warnOnce)(cookie.isSigned, `The "${cookie.name}" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://reactrouter.com/explanation/sessions-and-cookies#signing-cookies for more information.`);
}
// lib/server-runtime/sessions/cookieStorage.ts
function $e68dc042638cd0a8$export$2641c3ccec6bd360({ cookie: cookieArg } = {}) {
    let cookie = $e68dc042638cd0a8$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $e68dc042638cd0a8$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $e68dc042638cd0a8$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            return $e68dc042638cd0a8$export$f7c62c73429afa28(cookieHeader && await cookie.parse(cookieHeader, options) || {});
        },
        async commitSession (session, options) {
            let serializedCookie = await cookie.serialize(session.data, options);
            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
            return serializedCookie;
        },
        async destroySession (_session, options) {
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function $e68dc042638cd0a8$export$abd1f21611468758({ cookie: cookie } = {}) {
    let map = /* @__PURE__ */ new Map();
    return $e68dc042638cd0a8$export$1f1c547b06207ca3({
        cookie: cookie,
        async createData (data2, expires) {
            let id = Math.random().toString(36).substring(2, 10);
            map.set(id, {
                data: data2,
                expires: expires
            });
            return id;
        },
        async readData (id) {
            if (map.has(id)) {
                let { data: data2, expires: expires } = map.get(id);
                if (!expires || expires > /* @__PURE__ */ new Date()) return data2;
                if (expires) map.delete(id);
            }
            return null;
        },
        async updateData (id, data2, expires) {
            map.set(id, {
                data: data2,
                expires: expires
            });
        },
        async deleteData (id) {
            map.delete(id);
        }
    });
}
// lib/href.ts
function $e68dc042638cd0a8$export$8f51af5840e0602a(path, ...args) {
    let params = args[0];
    let result = path.replace(/\/*\*?$/, "").replace(/\/:([\w-]+)(\?)?/g, // same regex as in .\router\utils.ts: compilePath().
    (_, param, questionMark)=>{
        const isRequired = questionMark === void 0;
        const value = params ? params[param] : void 0;
        if (isRequired && value === void 0) throw new Error(`Path '${path}' requires param '${param}' but it was not provided`);
        return value === void 0 ? "" : "/" + value;
    });
    if (path.endsWith("*")) {
        const value = params ? params["*"] : void 0;
        if (value !== void 0) result += "/" + value;
    }
    return result || "/";
}
// lib/rsc/html-stream/server.ts
var $e68dc042638cd0a8$var$encoder2 = new TextEncoder();
var $e68dc042638cd0a8$var$trailer = "</body></html>";
function $e68dc042638cd0a8$var$injectRSCPayload(rscStream) {
    let decoder = new TextDecoder();
    let resolveFlightDataPromise;
    let flightDataPromise = new Promise((resolve)=>resolveFlightDataPromise = resolve);
    let startedRSC = false;
    let buffered = [];
    let timeout = null;
    function flushBufferedChunks(controller) {
        for (let chunk of buffered){
            let buf = decoder.decode(chunk, {
                stream: true
            });
            if (buf.endsWith($e68dc042638cd0a8$var$trailer)) buf = buf.slice(0, -$e68dc042638cd0a8$var$trailer.length);
            controller.enqueue($e68dc042638cd0a8$var$encoder2.encode(buf));
        }
        buffered.length = 0;
        timeout = null;
    }
    return new TransformStream({
        transform (chunk, controller) {
            buffered.push(chunk);
            if (timeout) return;
            timeout = setTimeout(async ()=>{
                flushBufferedChunks(controller);
                if (!startedRSC) {
                    startedRSC = true;
                    $e68dc042638cd0a8$var$writeRSCStream(rscStream, controller).catch((err)=>controller.error(err)).then(resolveFlightDataPromise);
                }
            }, 0);
        },
        async flush (controller) {
            await flightDataPromise;
            if (timeout) {
                clearTimeout(timeout);
                flushBufferedChunks(controller);
            }
            controller.enqueue($e68dc042638cd0a8$var$encoder2.encode("</body></html>"));
        }
    });
}
async function $e68dc042638cd0a8$var$writeRSCStream(rscStream, controller) {
    let decoder = new TextDecoder("utf-8", {
        fatal: true
    });
    const reader = rscStream.getReader();
    try {
        let read;
        while((read = await reader.read()) && !read.done){
            const chunk = read.value;
            try {
                $e68dc042638cd0a8$var$writeChunk(JSON.stringify(decoder.decode(chunk, {
                    stream: true
                })), controller);
            } catch (err) {
                let base64 = JSON.stringify(btoa(String.fromCodePoint(...chunk)));
                $e68dc042638cd0a8$var$writeChunk(`Uint8Array.from(atob(${base64}), m => m.codePointAt(0))`, controller);
            }
        }
    } finally{
        reader.releaseLock();
    }
    let remaining = decoder.decode();
    if (remaining.length) $e68dc042638cd0a8$var$writeChunk(JSON.stringify(remaining), controller);
}
function $e68dc042638cd0a8$var$writeChunk(chunk, controller) {
    controller.enqueue($e68dc042638cd0a8$var$encoder2.encode(`<script>${$e68dc042638cd0a8$var$escapeScript(`(self.__FLIGHT_DATA||=[]).push(${chunk})`)}</script>`));
}
function $e68dc042638cd0a8$var$escapeScript(script) {
    return script.replace(/<!--/g, "<\\!--").replace(/<\/(script)/gi, "</\\$1");
}
var $e68dc042638cd0a8$export$ea608ff93320d416 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: null,
            location: props.location
        };
        return {
            error: state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e68dc042638cd0a8$var$RSCDefaultRootErrorBoundaryImpl, {
            error: this.state.error,
            renderAppShell: true
        });
        else return this.props.children;
    }
};
function $e68dc042638cd0a8$var$ErrorWrapper({ renderAppShell: renderAppShell, title: title, children: children }) {
    if (!renderAppShell) return children;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("head", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("title", null, title)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("body", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children)));
}
function $e68dc042638cd0a8$var$RSCDefaultRootErrorBoundaryImpl({ error: error, renderAppShell: renderAppShell }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ((0, $as544.isRouteErrorResponse)(error)) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e68dc042638cd0a8$var$ErrorWrapper, {
        renderAppShell: renderAppShell,
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), (0, $as544.ENABLE_DEV_WARNINGS) ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e68dc042638cd0a8$var$ErrorWrapper, {
        renderAppShell: renderAppShell,
        title: "Application Error!"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $e68dc042638cd0a8$export$a55eecbda762d267({ hasRootLayout: hasRootLayout }) {
    let error = (0, $as544.useRouteError)();
    if (hasRootLayout === void 0) throw new Error("Missing 'hasRootLayout' prop");
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e68dc042638cd0a8$var$RSCDefaultRootErrorBoundaryImpl, {
        renderAppShell: !hasRootLayout,
        error: error
    });
}
// lib/rsc/route-modules.ts
function $e68dc042638cd0a8$var$createRSCRouteModules(payload) {
    const routeModules = {};
    for (const match of payload.matches)$e68dc042638cd0a8$export$93a6ee970ac9d016(routeModules, match);
    return routeModules;
}
function $e68dc042638cd0a8$export$93a6ee970ac9d016(routeModules, matches) {
    matches = Array.isArray(matches) ? matches : [
        matches
    ];
    for (const match of matches)routeModules[match.id] = {
        links: match.links,
        meta: match.meta,
        default: $e68dc042638cd0a8$var$noopComponent
    };
}
var $e68dc042638cd0a8$var$noopComponent = ()=>null;
// lib/rsc/server.ssr.tsx
var $e68dc042638cd0a8$var$REACT_USE = "use";
var $e68dc042638cd0a8$var$useImpl = $bh6RR[$e68dc042638cd0a8$var$REACT_USE];
function $e68dc042638cd0a8$var$useSafe(promise) {
    if ($e68dc042638cd0a8$var$useImpl) return $e68dc042638cd0a8$var$useImpl(promise);
    throw new Error("React Router v7 requires React 19+ for RSC features.");
}
async function $e68dc042638cd0a8$export$144ccff01a5655fc({ request: request, fetchServer: fetchServer, createFromReadableStream: createFromReadableStream, renderHTML: renderHTML, hydrate: hydrate = true }) {
    const url = new URL(request.url);
    const isDataRequest = $e68dc042638cd0a8$var$isReactServerRequest(url);
    const respondWithRSCPayload = isDataRequest || $e68dc042638cd0a8$var$isManifestRequest(url) || request.headers.has("rsc-action-id");
    const serverResponse = await fetchServer(request);
    if (respondWithRSCPayload || serverResponse.headers.get("React-Router-Resource") === "true") return serverResponse;
    if (!serverResponse.body) throw new Error("Missing body in server response");
    const detectRedirectResponse = serverResponse.clone();
    let serverResponseB = null;
    if (hydrate) serverResponseB = serverResponse.clone();
    const body = serverResponse.body;
    let buffer;
    let streamControllers = [];
    const createStream = ()=>{
        if (!buffer) {
            buffer = [];
            return body.pipeThrough(new TransformStream({
                transform (chunk, controller) {
                    buffer.push(chunk);
                    controller.enqueue(chunk);
                    streamControllers.forEach((c)=>c.enqueue(chunk));
                },
                flush () {
                    streamControllers.forEach((c)=>c.close());
                    streamControllers = [];
                }
            }));
        }
        return new ReadableStream({
            start (controller) {
                buffer.forEach((chunk)=>controller.enqueue(chunk));
                streamControllers.push(controller);
            }
        });
    };
    let deepestRenderedBoundaryId = null;
    const getPayload = ()=>{
        const payloadPromise = Promise.resolve(createFromReadableStream(createStream()));
        return Object.defineProperties(payloadPromise, {
            _deepestRenderedBoundaryId: {
                get () {
                    return deepestRenderedBoundaryId;
                },
                set (boundaryId1) {
                    deepestRenderedBoundaryId = boundaryId1;
                }
            },
            formState: {
                get () {
                    return payloadPromise.then((payload)=>payload.type === "render" ? payload.formState : void 0);
                }
            }
        });
    };
    try {
        if (!detectRedirectResponse.body) throw new Error("Failed to clone server response");
        const payload = await createFromReadableStream(detectRedirectResponse.body);
        if (serverResponse.status === (0, $as544.SINGLE_FETCH_REDIRECT_STATUS) && payload.type === "redirect") {
            const headers2 = new Headers(serverResponse.headers);
            headers2.delete("Content-Encoding");
            headers2.delete("Content-Length");
            headers2.delete("Content-Type");
            headers2.delete("X-Remix-Response");
            headers2.set("Location", payload.location);
            return new Response(serverResponseB?.body || "", {
                headers: headers2,
                status: payload.status,
                statusText: serverResponse.statusText
            });
        }
        const html = await renderHTML(getPayload);
        const headers = new Headers(serverResponse.headers);
        headers.set("Content-Type", "text/html; charset=utf-8");
        if (!hydrate) return new Response(html, {
            status: serverResponse.status,
            headers: headers
        });
        if (!serverResponseB?.body) throw new Error("Failed to clone server response");
        const body2 = html.pipeThrough($e68dc042638cd0a8$var$injectRSCPayload(serverResponseB.body));
        return new Response(body2, {
            status: serverResponse.status,
            headers: headers
        });
    } catch (reason) {
        if (reason instanceof Response) return reason;
        try {
            const status = (0, $as544.isRouteErrorResponse)(reason) ? reason.status : 500;
            const html = await renderHTML(()=>{
                const decoded = Promise.resolve(createFromReadableStream(createStream()));
                const payloadPromise = decoded.then((payload)=>Object.assign(payload, {
                        status: status,
                        errors: deepestRenderedBoundaryId ? {
                            [deepestRenderedBoundaryId]: reason
                        } : {}
                    }));
                return Object.defineProperties(payloadPromise, {
                    _deepestRenderedBoundaryId: {
                        get () {
                            return deepestRenderedBoundaryId;
                        },
                        set (boundaryId1) {
                            deepestRenderedBoundaryId = boundaryId1;
                        }
                    },
                    formState: {
                        get () {
                            return payloadPromise.then((payload)=>payload.type === "render" ? payload.formState : void 0);
                        }
                    }
                });
            });
            const headers = new Headers(serverResponse.headers);
            headers.set("Content-Type", "text/html");
            if (!hydrate) return new Response(html, {
                status: status,
                headers: headers
            });
            if (!serverResponseB?.body) throw new Error("Failed to clone server response");
            const body2 = html.pipeThrough($e68dc042638cd0a8$var$injectRSCPayload(serverResponseB.body));
            return new Response(body2, {
                status: status,
                headers: headers
            });
        } catch  {}
        throw reason;
    }
}
function $e68dc042638cd0a8$export$7f2da8ab5e593830({ getPayload: getPayload }) {
    const decoded = getPayload();
    const payload = $e68dc042638cd0a8$var$useSafe(decoded);
    if (payload.type === "redirect") throw new Response(null, {
        status: payload.status,
        headers: {
            Location: payload.location
        }
    });
    if (payload.type !== "render") return null;
    let patchedLoaderData = {
        ...payload.loaderData
    };
    for (const match of payload.matches)if ((0, $as544.shouldHydrateRouteLoader)(match.id, match.clientLoader, match.hasLoader, false) && (match.hydrateFallbackElement || !match.hasLoader)) delete patchedLoaderData[match.id];
    const context = {
        get _deepestRenderedBoundaryId () {
            return decoded._deepestRenderedBoundaryId ?? null;
        },
        set _deepestRenderedBoundaryId (boundaryId){
            decoded._deepestRenderedBoundaryId = boundaryId;
        },
        actionData: payload.actionData,
        actionHeaders: {},
        basename: payload.basename,
        errors: payload.errors,
        loaderData: patchedLoaderData,
        loaderHeaders: {},
        location: payload.location,
        statusCode: 200,
        matches: payload.matches.map((match)=>({
                params: match.params,
                pathname: match.pathname,
                pathnameBase: match.pathnameBase,
                route: {
                    id: match.id,
                    action: match.hasAction || !!match.clientAction,
                    handle: match.handle,
                    hasErrorBoundary: match.hasErrorBoundary,
                    loader: match.hasLoader || !!match.clientLoader,
                    index: match.index,
                    path: match.path,
                    shouldRevalidate: match.shouldRevalidate
                }
            }))
    };
    const router = (0, $as544.createStaticRouter)(payload.matches.reduceRight((previous, match)=>{
        const route = {
            id: match.id,
            action: match.hasAction || !!match.clientAction,
            element: match.element,
            errorElement: match.errorElement,
            handle: match.handle,
            hasErrorBoundary: !!match.errorElement,
            hydrateFallbackElement: match.hydrateFallbackElement,
            index: match.index,
            loader: match.hasLoader || !!match.clientLoader,
            path: match.path,
            shouldRevalidate: match.shouldRevalidate
        };
        if (previous.length > 0) route.children = previous;
        return [
            route
        ];
    }, []), context);
    const frameworkContext = {
        future: {
            // These flags have no runtime impact so can always be false.  If we add
            // flags that drive runtime behavior they'll need to be proxied through.
            v8_middleware: false,
            unstable_subResourceIntegrity: false
        },
        isSpaMode: false,
        ssr: true,
        criticalCss: "",
        manifest: {
            routes: {},
            version: "1",
            url: "",
            entry: {
                module: "",
                imports: []
            }
        },
        routeDiscovery: {
            mode: "lazy",
            manifestPath: "/__manifest"
        },
        routeModules: $e68dc042638cd0a8$var$createRSCRouteModules(payload)
    };
    return /* @__PURE__ */ $bh6RR.createElement((0, $as544.RSCRouterContext).Provider, {
        value: true
    }, /* @__PURE__ */ $bh6RR.createElement($e68dc042638cd0a8$export$ea608ff93320d416, {
        location: payload.location
    }, /* @__PURE__ */ $bh6RR.createElement((0, $as544.FrameworkContext).Provider, {
        value: frameworkContext
    }, /* @__PURE__ */ $bh6RR.createElement((0, $as544.StaticRouterProvider), {
        context: context,
        router: router,
        hydrate: false,
        nonce: payload.nonce
    }))));
}
function $e68dc042638cd0a8$var$isReactServerRequest(url) {
    return url.pathname.endsWith(".rsc");
}
function $e68dc042638cd0a8$var$isManifestRequest(url) {
    return url.pathname.endsWith(".manifest");
}
// lib/dom/ssr/errors.ts
function $e68dc042638cd0a8$export$c923cb491441bb56(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $as544.ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = val.stack;
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = val.stack;
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/dom/ssr/hydration.tsx
function $e68dc042638cd0a8$export$6fa8d910d97963ad({ state: state, routes: routes, getRouteInfo: getRouteInfo, location: location, basename: basename, isSpaMode: isSpaMode }) {
    let hydrationData = {
        ...state,
        loaderData: {
            ...state.loaderData
        }
    };
    let initialMatches = (0, $as544.matchRoutes)(routes, location, basename);
    if (initialMatches) for (let match of initialMatches){
        let routeId = match.route.id;
        let routeInfo = getRouteInfo(routeId);
        if ((0, $as544.shouldHydrateRouteLoader)(routeId, routeInfo.clientLoader, routeInfo.hasLoader, isSpaMode) && (routeInfo.hasHydrateFallback || !routeInfo.hasLoader)) delete hydrationData.loaderData[routeId];
        else if (!routeInfo.hasLoader) hydrationData.loaderData[routeId] = null;
    }
    return hydrationData;
}



var $as544 = parcelRequire("as544");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");
"use client";
function $5ba1327dd9c1735a$export$323e4fc2fa4753fb(props) {
    return /* @__PURE__ */ $bh6RR.createElement((0, $as544.RouterProvider), {
        flushSync: $6afFj.flushSync,
        ...props
    });
}
var $5ba1327dd9c1735a$var$ssrInfo = null;
var $5ba1327dd9c1735a$var$router = null;
function $5ba1327dd9c1735a$var$initSsrInfo() {
    if (!$5ba1327dd9c1735a$var$ssrInfo && window.__reactRouterContext && window.__reactRouterManifest && window.__reactRouterRouteModules) {
        if (window.__reactRouterManifest.sri === true) {
            const importMap = document.querySelector("script[rr-importmap]");
            if (importMap?.textContent) try {
                window.__reactRouterManifest.sri = JSON.parse(importMap.textContent).integrity;
            } catch (err) {
                console.error("Failed to parse import map", err);
            }
        }
        $5ba1327dd9c1735a$var$ssrInfo = {
            context: window.__reactRouterContext,
            manifest: window.__reactRouterManifest,
            routeModules: window.__reactRouterRouteModules,
            stateDecodingPromise: void 0,
            router: void 0,
            routerInitialized: false
        };
    }
}
function $5ba1327dd9c1735a$var$createHydratedRouter({ getContext: getContext, unstable_instrumentations: unstable_instrumentations }) {
    $5ba1327dd9c1735a$var$initSsrInfo();
    if (!$5ba1327dd9c1735a$var$ssrInfo) throw new Error("You must be using the SSR features of React Router in order to skip passing a `router` prop to `<RouterProvider>`");
    let localSsrInfo = $5ba1327dd9c1735a$var$ssrInfo;
    if (!$5ba1327dd9c1735a$var$ssrInfo.stateDecodingPromise) {
        let stream = $5ba1327dd9c1735a$var$ssrInfo.context.stream;
        (0, $as544.invariant)(stream, "No stream found for single fetch decoding");
        $5ba1327dd9c1735a$var$ssrInfo.context.stream = void 0;
        $5ba1327dd9c1735a$var$ssrInfo.stateDecodingPromise = (0, $as544.decodeViaTurboStream)(stream, window).then((value)=>{
            $5ba1327dd9c1735a$var$ssrInfo.context.state = value.value;
            localSsrInfo.stateDecodingPromise.value = true;
        }).catch((e)=>{
            localSsrInfo.stateDecodingPromise.error = e;
        });
    }
    if ($5ba1327dd9c1735a$var$ssrInfo.stateDecodingPromise.error) throw $5ba1327dd9c1735a$var$ssrInfo.stateDecodingPromise.error;
    if (!$5ba1327dd9c1735a$var$ssrInfo.stateDecodingPromise.value) throw $5ba1327dd9c1735a$var$ssrInfo.stateDecodingPromise;
    let routes = (0, $as544.createClientRoutes)($5ba1327dd9c1735a$var$ssrInfo.manifest.routes, $5ba1327dd9c1735a$var$ssrInfo.routeModules, $5ba1327dd9c1735a$var$ssrInfo.context.state, $5ba1327dd9c1735a$var$ssrInfo.context.ssr, $5ba1327dd9c1735a$var$ssrInfo.context.isSpaMode);
    let hydrationData = void 0;
    if ($5ba1327dd9c1735a$var$ssrInfo.context.isSpaMode) {
        let { loaderData: loaderData } = $5ba1327dd9c1735a$var$ssrInfo.context.state;
        if ($5ba1327dd9c1735a$var$ssrInfo.manifest.routes.root?.hasLoader && loaderData && "root" in loaderData) hydrationData = {
            loaderData: {
                root: loaderData.root
            }
        };
    } else {
        hydrationData = (0, $e68dc042638cd0a8$export$6fa8d910d97963ad)({
            state: $5ba1327dd9c1735a$var$ssrInfo.context.state,
            routes: routes,
            getRouteInfo: (routeId)=>({
                    clientLoader: $5ba1327dd9c1735a$var$ssrInfo.routeModules[routeId]?.clientLoader,
                    hasLoader: $5ba1327dd9c1735a$var$ssrInfo.manifest.routes[routeId]?.hasLoader === true,
                    hasHydrateFallback: $5ba1327dd9c1735a$var$ssrInfo.routeModules[routeId]?.HydrateFallback != null
                }),
            location: window.location,
            basename: window.__reactRouterContext?.basename,
            isSpaMode: $5ba1327dd9c1735a$var$ssrInfo.context.isSpaMode
        });
        if (hydrationData && hydrationData.errors) hydrationData.errors = (0, $e68dc042638cd0a8$export$c923cb491441bb56)(hydrationData.errors);
    }
    let router2 = (0, $as544.createRouter)({
        routes: routes,
        history: (0, $as544.createBrowserHistory)(),
        basename: $5ba1327dd9c1735a$var$ssrInfo.context.basename,
        getContext: getContext,
        hydrationData: hydrationData,
        hydrationRouteProperties: $as544.hydrationRouteProperties,
        unstable_instrumentations: unstable_instrumentations,
        mapRouteProperties: $as544.mapRouteProperties,
        future: {
            middleware: $5ba1327dd9c1735a$var$ssrInfo.context.future.v8_middleware
        },
        dataStrategy: (0, $as544.getTurboStreamSingleFetchDataStrategy)(()=>router2, $5ba1327dd9c1735a$var$ssrInfo.manifest, $5ba1327dd9c1735a$var$ssrInfo.routeModules, $5ba1327dd9c1735a$var$ssrInfo.context.ssr, $5ba1327dd9c1735a$var$ssrInfo.context.basename),
        patchRoutesOnNavigation: (0, $as544.getPatchRoutesOnNavigationFunction)($5ba1327dd9c1735a$var$ssrInfo.manifest, $5ba1327dd9c1735a$var$ssrInfo.routeModules, $5ba1327dd9c1735a$var$ssrInfo.context.ssr, $5ba1327dd9c1735a$var$ssrInfo.context.routeDiscovery, $5ba1327dd9c1735a$var$ssrInfo.context.isSpaMode, $5ba1327dd9c1735a$var$ssrInfo.context.basename)
    });
    $5ba1327dd9c1735a$var$ssrInfo.router = router2;
    if (router2.state.initialized) {
        $5ba1327dd9c1735a$var$ssrInfo.routerInitialized = true;
        router2.initialize();
    }
    router2.createRoutesForHMR = /* spacer so ts-ignore does not affect the right hand of the assignment */ (0, $as544.createClientRoutesWithHMRRevalidationOptOut);
    window.__reactRouterDataRouter = router2;
    return router2;
}
function $5ba1327dd9c1735a$export$63ce90781bf4d238(props) {
    if (!$5ba1327dd9c1735a$var$router) $5ba1327dd9c1735a$var$router = $5ba1327dd9c1735a$var$createHydratedRouter({
        getContext: props.getContext,
        unstable_instrumentations: props.unstable_instrumentations
    });
    let [criticalCss, setCriticalCss] = $bh6RR.useState(void 0);
    $bh6RR.useEffect(()=>{}, []);
    $bh6RR.useEffect(()=>{
        var element;
    }, [
        criticalCss
    ]);
    let [location2, setLocation] = $bh6RR.useState($5ba1327dd9c1735a$var$router.state.location);
    $bh6RR.useLayoutEffect(()=>{
        if ($5ba1327dd9c1735a$var$ssrInfo && $5ba1327dd9c1735a$var$ssrInfo.router && !$5ba1327dd9c1735a$var$ssrInfo.routerInitialized) {
            $5ba1327dd9c1735a$var$ssrInfo.routerInitialized = true;
            $5ba1327dd9c1735a$var$ssrInfo.router.initialize();
        }
    }, []);
    $bh6RR.useLayoutEffect(()=>{
        if ($5ba1327dd9c1735a$var$ssrInfo && $5ba1327dd9c1735a$var$ssrInfo.router) return $5ba1327dd9c1735a$var$ssrInfo.router.subscribe((newState)=>{
            if (newState.location !== location2) setLocation(newState.location);
        });
    }, [
        location2
    ]);
    (0, $as544.invariant)($5ba1327dd9c1735a$var$ssrInfo, "ssrInfo unavailable for HydratedRouter");
    (0, $as544.useFogOFWarDiscovery)($5ba1327dd9c1735a$var$router, $5ba1327dd9c1735a$var$ssrInfo.manifest, $5ba1327dd9c1735a$var$ssrInfo.routeModules, $5ba1327dd9c1735a$var$ssrInfo.context.ssr, $5ba1327dd9c1735a$var$ssrInfo.context.routeDiscovery, $5ba1327dd9c1735a$var$ssrInfo.context.isSpaMode);
    return(// This fragment is important to ensure we match the <ServerRouter> JSX
    // structure so that useId values hydrate correctly
    /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, /* @__PURE__ */ $bh6RR.createElement((0, $as544.FrameworkContext).Provider, {
        value: {
            manifest: $5ba1327dd9c1735a$var$ssrInfo.manifest,
            routeModules: $5ba1327dd9c1735a$var$ssrInfo.routeModules,
            future: $5ba1327dd9c1735a$var$ssrInfo.context.future,
            criticalCss: criticalCss,
            ssr: $5ba1327dd9c1735a$var$ssrInfo.context.ssr,
            isSpaMode: $5ba1327dd9c1735a$var$ssrInfo.context.isSpaMode,
            routeDiscovery: $5ba1327dd9c1735a$var$ssrInfo.context.routeDiscovery
        }
    }, /* @__PURE__ */ $bh6RR.createElement((0, $as544.RemixErrorBoundary), {
        location: location2
    }, /* @__PURE__ */ $bh6RR.createElement($5ba1327dd9c1735a$export$323e4fc2fa4753fb, {
        router: $5ba1327dd9c1735a$var$router,
        unstable_onError: props.unstable_onError
    }))), /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null)));
}
function $5ba1327dd9c1735a$export$e5e8f3607b669df({ createFromReadableStream: createFromReadableStream, createTemporaryReferenceSet: createTemporaryReferenceSet, encodeReply: encodeReply, fetch: fetchImplementation = fetch }) {
    const globalVar = window;
    let landedActionId = 0;
    return async (id, args)=>{
        let actionId = globalVar.__routerActionID = (globalVar.__routerActionID ?? (globalVar.__routerActionID = 0)) + 1;
        const temporaryReferences = createTemporaryReferenceSet();
        const payloadPromise = fetchImplementation(new Request(location.href, {
            body: await encodeReply(args, {
                temporaryReferences: temporaryReferences
            }),
            method: "POST",
            headers: {
                Accept: "text/x-component",
                "rsc-action-id": id
            }
        })).then((response)=>{
            if (!response.body) throw new Error("No response body");
            return createFromReadableStream(response.body, {
                temporaryReferences: temporaryReferences
            });
        });
        globalVar.__reactRouterDataRouter.__setPendingRerender(Promise.resolve(payloadPromise).then(async (payload)=>{
            if (payload.type === "redirect") {
                if (payload.reload || $5ba1327dd9c1735a$var$isExternalLocation(payload.location)) {
                    window.location.href = payload.location;
                    return ()=>{};
                }
                return ()=>{
                    globalVar.__reactRouterDataRouter.navigate(payload.location, {
                        replace: payload.replace
                    });
                };
            }
            if (payload.type !== "action") throw new Error("Unexpected payload type");
            const rerender = await payload.rerender;
            if (rerender && landedActionId < actionId && globalVar.__routerActionID <= actionId) {
                if (rerender.type === "redirect") {
                    if (rerender.reload || $5ba1327dd9c1735a$var$isExternalLocation(rerender.location)) {
                        window.location.href = rerender.location;
                        return;
                    }
                    return ()=>{
                        globalVar.__reactRouterDataRouter.navigate(rerender.location, {
                            replace: rerender.replace
                        });
                    };
                }
                return ()=>{
                    let lastMatch;
                    for (const match of rerender.matches){
                        globalVar.__reactRouterDataRouter.patchRoutes(lastMatch?.id ?? null, [
                            $5ba1327dd9c1735a$var$createRouteFromServerManifest(match)
                        ], true);
                        lastMatch = match;
                    }
                    window.__reactRouterDataRouter._internalSetStateDoNotUseOrYouWillBreakYourApp({
                        loaderData: Object.assign({}, globalVar.__reactRouterDataRouter.state.loaderData, rerender.loaderData),
                        errors: rerender.errors ? Object.assign({}, globalVar.__reactRouterDataRouter.state.errors, rerender.errors) : null
                    });
                };
            }
            return ()=>{};
        }).catch(()=>{}));
        return payloadPromise.then((payload)=>{
            if (payload.type !== "action" && payload.type !== "redirect") throw new Error("Unexpected payload type");
            return payload.actionResult;
        });
    };
}
function $5ba1327dd9c1735a$var$createRouterFromPayload({ fetchImplementation: fetchImplementation, createFromReadableStream: createFromReadableStream, getContext: getContext, payload: payload }) {
    const globalVar = window;
    if (globalVar.__reactRouterDataRouter && globalVar.__reactRouterRouteModules) return {
        router: globalVar.__reactRouterDataRouter,
        routeModules: globalVar.__reactRouterRouteModules
    };
    if (payload.type !== "render") throw new Error("Invalid payload type");
    globalVar.__reactRouterRouteModules = globalVar.__reactRouterRouteModules ?? {};
    (0, $e68dc042638cd0a8$export$93a6ee970ac9d016)(globalVar.__reactRouterRouteModules, payload.matches);
    let patches = /* @__PURE__ */ new Map();
    payload.patches?.forEach((patch)=>{
        (0, $as544.invariant)(patch.parentId, "Invalid patch parentId");
        if (!patches.has(patch.parentId)) patches.set(patch.parentId, []);
        patches.get(patch.parentId)?.push(patch);
    });
    let routes = payload.matches.reduceRight((previous, match)=>{
        const route = $5ba1327dd9c1735a$var$createRouteFromServerManifest(match, payload);
        if (previous.length > 0) {
            route.children = previous;
            let childrenToPatch = patches.get(match.id);
            if (childrenToPatch) route.children.push(...childrenToPatch.map((r)=>$5ba1327dd9c1735a$var$createRouteFromServerManifest(r)));
        }
        return [
            route
        ];
    }, []);
    globalVar.__reactRouterDataRouter = (0, $as544.createRouter)({
        routes: routes,
        getContext: getContext,
        basename: payload.basename,
        history: (0, $as544.createBrowserHistory)(),
        hydrationData: (0, $e68dc042638cd0a8$export$6fa8d910d97963ad)({
            state: {
                loaderData: payload.loaderData,
                actionData: payload.actionData,
                errors: payload.errors
            },
            routes: routes,
            getRouteInfo: (routeId)=>{
                let match = payload.matches.find((m)=>m.id === routeId);
                (0, $as544.invariant)(match, "Route not found in payload");
                return {
                    clientLoader: match.clientLoader,
                    hasLoader: match.hasLoader,
                    hasHydrateFallback: match.hydrateFallbackElement != null
                };
            },
            location: payload.location,
            basename: payload.basename,
            isSpaMode: false
        }),
        async patchRoutesOnNavigation ({ path: path, signal: signal }) {
            if ($5ba1327dd9c1735a$var$discoveredPaths.has(path)) return;
            await $5ba1327dd9c1735a$var$fetchAndApplyManifestPatches([
                path
            ], createFromReadableStream, fetchImplementation, signal);
        },
        // FIXME: Pass `build.ssr` into this function
        dataStrategy: $5ba1327dd9c1735a$var$getRSCSingleFetchDataStrategy(()=>globalVar.__reactRouterDataRouter, true, payload.basename, createFromReadableStream, fetchImplementation)
    });
    if (globalVar.__reactRouterDataRouter.state.initialized) {
        globalVar.__routerInitialized = true;
        globalVar.__reactRouterDataRouter.initialize();
    } else globalVar.__routerInitialized = false;
    let lastLoaderData = void 0;
    globalVar.__reactRouterDataRouter.subscribe(({ loaderData: loaderData, actionData: actionData })=>{
        if (lastLoaderData !== loaderData) globalVar.__routerActionID = (globalVar.__routerActionID ?? (globalVar.__routerActionID = 0)) + 1;
    });
    globalVar.__reactRouterDataRouter._updateRoutesForHMR = (routeUpdateByRouteId)=>{
        const oldRoutes = window.__reactRouterDataRouter.routes;
        const newRoutes = [];
        function walkRoutes(routes2, parentId) {
            return routes2.map((route)=>{
                const routeUpdate = routeUpdateByRouteId.get(route.id);
                if (routeUpdate) {
                    const { routeModule: routeModule, hasAction: hasAction, hasComponent: hasComponent, hasErrorBoundary: hasErrorBoundary, hasLoader: hasLoader } = routeUpdate;
                    const newRoute = $5ba1327dd9c1735a$var$createRouteFromServerManifest({
                        clientAction: routeModule.clientAction,
                        clientLoader: routeModule.clientLoader,
                        element: route.element,
                        errorElement: route.errorElement,
                        handle: route.handle,
                        hasAction: hasAction,
                        hasComponent: hasComponent,
                        hasErrorBoundary: hasErrorBoundary,
                        hasLoader: hasLoader,
                        hydrateFallbackElement: route.hydrateFallbackElement,
                        id: route.id,
                        index: route.index,
                        links: routeModule.links,
                        meta: routeModule.meta,
                        parentId: parentId,
                        path: route.path,
                        shouldRevalidate: routeModule.shouldRevalidate
                    });
                    if (route.children) newRoute.children = walkRoutes(route.children, route.id);
                    return newRoute;
                }
                const updatedRoute = {
                    ...route
                };
                if (route.children) updatedRoute.children = walkRoutes(route.children, route.id);
                return updatedRoute;
            });
        }
        newRoutes.push(...walkRoutes(oldRoutes, void 0));
        window.__reactRouterDataRouter._internalSetRoutes(newRoutes);
    };
    return {
        router: globalVar.__reactRouterDataRouter,
        routeModules: globalVar.__reactRouterRouteModules
    };
}
var $5ba1327dd9c1735a$var$renderedRoutesContext = (0, $as544.createContext)();
function $5ba1327dd9c1735a$var$getRSCSingleFetchDataStrategy(getRouter, ssr, basename, createFromReadableStream, fetchImplementation) {
    let dataStrategy = (0, $as544.getSingleFetchDataStrategyImpl)(getRouter, (match)=>{
        let M = match;
        return {
            hasLoader: M.route.hasLoader,
            hasClientLoader: M.route.hasClientLoader,
            hasComponent: M.route.hasComponent,
            hasAction: M.route.hasAction,
            hasClientAction: M.route.hasClientAction,
            hasShouldRevalidate: M.route.hasShouldRevalidate
        };
    }, // pass map into fetchAndDecode so it can add payloads
    $5ba1327dd9c1735a$var$getFetchAndDecodeViaRSC(createFromReadableStream, fetchImplementation), ssr, basename, // If the route has a component but we don't have an element, we need to hit
    // the server loader flow regardless of whether the client loader calls
    // `serverLoader` or not, otherwise we'll have nothing to render.
    (match)=>{
        let M = match;
        return M.route.hasComponent && !M.route.element;
    });
    return async (args)=>args.runClientMiddleware(async ()=>{
            let context = args.context;
            context.set($5ba1327dd9c1735a$var$renderedRoutesContext, []);
            let results = await dataStrategy(args);
            const renderedRoutesById = /* @__PURE__ */ new Map();
            for (const route of context.get($5ba1327dd9c1735a$var$renderedRoutesContext)){
                if (!renderedRoutesById.has(route.id)) renderedRoutesById.set(route.id, []);
                renderedRoutesById.get(route.id).push(route);
            }
            for (const match of args.matches){
                const renderedRoutes = renderedRoutesById.get(match.route.id);
                if (renderedRoutes) for (const rendered of renderedRoutes)window.__reactRouterDataRouter.patchRoutes(rendered.parentId ?? null, [
                    $5ba1327dd9c1735a$var$createRouteFromServerManifest(rendered)
                ], true);
            }
            return results;
        });
}
function $5ba1327dd9c1735a$var$getFetchAndDecodeViaRSC(createFromReadableStream, fetchImplementation) {
    return async (args, basename, targetRoutes)=>{
        let { request: request, context: context } = args;
        let url = (0, $as544.singleFetchUrl)(request.url, basename, "rsc");
        if (request.method === "GET") {
            url = (0, $as544.stripIndexParam)(url);
            if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
        }
        let res = await fetchImplementation(new Request(url, await (0, $as544.createRequestInit)(request)));
        if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new (0, $as544.ErrorResponseImpl)(res.status, res.statusText, await res.text());
        (0, $as544.invariant)(res.body, "No response body to decode");
        try {
            const payload = await createFromReadableStream(res.body, {
                temporaryReferences: void 0
            });
            if (payload.type === "redirect") return {
                status: res.status,
                data: {
                    redirect: {
                        redirect: payload.location,
                        reload: payload.reload,
                        replace: payload.replace,
                        revalidate: false,
                        status: payload.status
                    }
                }
            };
            if (payload.type !== "render") throw new Error("Unexpected payload type");
            context.get($5ba1327dd9c1735a$var$renderedRoutesContext).push(...payload.matches);
            let results = {
                routes: {}
            };
            const dataKey = (0, $as544.isMutationMethod)(request.method) ? "actionData" : "loaderData";
            for (let [routeId, data] of Object.entries(payload[dataKey] || {}))results.routes[routeId] = {
                data: data
            };
            if (payload.errors) for (let [routeId, error] of Object.entries(payload.errors))results.routes[routeId] = {
                error: error
            };
            return {
                status: res.status,
                data: results
            };
        } catch (e) {
            throw new Error("Unable to decode RSC response");
        }
    };
}
function $5ba1327dd9c1735a$export$af9dbdb90aaefbae({ createFromReadableStream: createFromReadableStream, fetch: fetchImplementation = fetch, payload: payload, routeDiscovery: routeDiscovery = "eager", getContext: getContext }) {
    if (payload.type !== "render") throw new Error("Invalid payload type");
    let { router: router2, routeModules: routeModules } = $bh6RR.useMemo(()=>$5ba1327dd9c1735a$var$createRouterFromPayload({
            payload: payload,
            fetchImplementation: fetchImplementation,
            getContext: getContext,
            createFromReadableStream: createFromReadableStream
        }), [
        createFromReadableStream,
        payload,
        fetchImplementation,
        getContext
    ]);
    $bh6RR.useEffect(()=>{
        (0, $as544.setIsHydrated)();
    }, []);
    $bh6RR.useLayoutEffect(()=>{
        const globalVar = window;
        if (!globalVar.__routerInitialized) {
            globalVar.__routerInitialized = true;
            globalVar.__reactRouterDataRouter.initialize();
        }
    }, []);
    let [location2, setLocation] = $bh6RR.useState(router2.state.location);
    $bh6RR.useLayoutEffect(()=>router2.subscribe((newState)=>{
            if (newState.location !== location2) setLocation(newState.location);
        }), [
        router2,
        location2
    ]);
    $bh6RR.useEffect(()=>{
        if (routeDiscovery === "lazy" || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$5ba1327dd9c1735a$var$discoveredPaths.has(pathname)) $5ba1327dd9c1735a$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let paths = Array.from($5ba1327dd9c1735a$var$nextPaths.keys()).filter((path)=>{
                if ($5ba1327dd9c1735a$var$discoveredPaths.has(path)) {
                    $5ba1327dd9c1735a$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (paths.length === 0) return;
            try {
                await $5ba1327dd9c1735a$var$fetchAndApplyManifestPatches(paths, createFromReadableStream, fetchImplementation);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $5ba1327dd9c1735a$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
    }, [
        routeDiscovery,
        createFromReadableStream,
        fetchImplementation
    ]);
    const frameworkContext = {
        future: {
            // These flags have no runtime impact so can always be false.  If we add
            // flags that drive runtime behavior they'll need to be proxied through.
            v8_middleware: false,
            unstable_subResourceIntegrity: false
        },
        isSpaMode: false,
        ssr: true,
        criticalCss: "",
        manifest: {
            routes: {},
            version: "1",
            url: "",
            entry: {
                module: "",
                imports: []
            }
        },
        routeDiscovery: {
            mode: "lazy",
            manifestPath: "/__manifest"
        },
        routeModules: routeModules
    };
    return /* @__PURE__ */ $bh6RR.createElement((0, $as544.RSCRouterContext).Provider, {
        value: true
    }, /* @__PURE__ */ $bh6RR.createElement((0, $e68dc042638cd0a8$export$ea608ff93320d416), {
        location: location2
    }, /* @__PURE__ */ $bh6RR.createElement((0, $as544.FrameworkContext).Provider, {
        value: frameworkContext
    }, /* @__PURE__ */ $bh6RR.createElement((0, $as544.UNSTABLE_TransitionEnabledRouterProvider), {
        router: router2,
        flushSync: $6afFj.flushSync
    }))));
}
function $5ba1327dd9c1735a$var$createRouteFromServerManifest(match, payload) {
    let hasInitialData = payload && match.id in payload.loaderData;
    let initialData = payload?.loaderData[match.id];
    let hasInitialError = payload?.errors && match.id in payload.errors;
    let initialError = payload?.errors?.[match.id];
    let isHydrationRequest = match.clientLoader?.hydrate === true || !match.hasLoader || // If the route has a component but we don't have an element, we need to hit
    // the server loader flow regardless of whether the client loader calls
    // `serverLoader` or not, otherwise we'll have nothing to render.
    match.hasComponent && !match.element;
    (0, $as544.invariant)(window.__reactRouterRouteModules);
    (0, $e68dc042638cd0a8$export$93a6ee970ac9d016)(window.__reactRouterRouteModules, match);
    let dataRoute = {
        id: match.id,
        element: match.element,
        errorElement: match.errorElement,
        handle: match.handle,
        hasErrorBoundary: match.hasErrorBoundary,
        hydrateFallbackElement: match.hydrateFallbackElement,
        index: match.index,
        loader: match.clientLoader ? async (args, singleFetch)=>{
            try {
                let result = await match.clientLoader({
                    ...args,
                    serverLoader: ()=>{
                        $5ba1327dd9c1735a$var$preventInvalidServerHandlerCall("loader", match.id, match.hasLoader);
                        if (isHydrationRequest) {
                            if (hasInitialData) return initialData;
                            if (hasInitialError) throw initialError;
                        }
                        return $5ba1327dd9c1735a$var$callSingleFetch(singleFetch);
                    }
                });
                return result;
            } finally{
                isHydrationRequest = false;
            }
        } : // We always make the call in this RSC world since even if we don't
        // have a `loader` we may need to get the `element` implementation
        (_, singleFetch)=>$5ba1327dd9c1735a$var$callSingleFetch(singleFetch),
        action: match.clientAction ? (args, singleFetch)=>match.clientAction({
                ...args,
                serverAction: async ()=>{
                    $5ba1327dd9c1735a$var$preventInvalidServerHandlerCall("action", match.id, match.hasLoader);
                    return await $5ba1327dd9c1735a$var$callSingleFetch(singleFetch);
                }
            }) : match.hasAction ? (_, singleFetch)=>$5ba1327dd9c1735a$var$callSingleFetch(singleFetch) : ()=>{
            throw (0, $as544.noActionDefinedError)("action", match.id);
        },
        path: match.path,
        shouldRevalidate: match.shouldRevalidate,
        // We always have a "loader" in this RSC world since even if we don't
        // have a `loader` we may need to get the `element` implementation
        hasLoader: true,
        hasClientLoader: match.clientLoader != null,
        hasAction: match.hasAction,
        hasClientAction: match.clientAction != null,
        hasShouldRevalidate: match.shouldRevalidate != null
    };
    if (typeof dataRoute.loader === "function") dataRoute.loader.hydrate = (0, $as544.shouldHydrateRouteLoader)(match.id, match.clientLoader, match.hasLoader, false);
    return dataRoute;
}
function $5ba1327dd9c1735a$var$callSingleFetch(singleFetch) {
    (0, $as544.invariant)(typeof singleFetch === "function", "Invalid singleFetch parameter");
    return singleFetch();
}
function $5ba1327dd9c1735a$var$preventInvalidServerHandlerCall(type, routeId, hasHandler) {
    if (!hasHandler) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${routeId}")`;
        console.error(msg);
        throw new (0, $as544.ErrorResponseImpl)(400, "Bad Request", new Error(msg), true);
    }
}
var $5ba1327dd9c1735a$var$nextPaths = /* @__PURE__ */ new Set();
var $5ba1327dd9c1735a$var$discoveredPathsMaxSize = 1e3;
var $5ba1327dd9c1735a$var$discoveredPaths = /* @__PURE__ */ new Set();
var $5ba1327dd9c1735a$var$URL_LIMIT = 7680;
function $5ba1327dd9c1735a$var$getManifestUrl(paths) {
    if (paths.length === 0) return null;
    if (paths.length === 1) return new URL(`${paths[0]}.manifest`, window.location.origin);
    const globalVar = window;
    let basename = (globalVar.__reactRouterDataRouter.basename ?? "").replace(/^\/|\/$/g, "");
    let url = new URL(`${basename}/.manifest`, window.location.origin);
    url.searchParams.set("paths", paths.sort().join(","));
    return url;
}
async function $5ba1327dd9c1735a$var$fetchAndApplyManifestPatches(paths, createFromReadableStream, fetchImplementation, signal) {
    let url = $5ba1327dd9c1735a$var$getManifestUrl(paths);
    if (url == null) return;
    if (url.toString().length > $5ba1327dd9c1735a$var$URL_LIMIT) {
        $5ba1327dd9c1735a$var$nextPaths.clear();
        return;
    }
    let response = await fetchImplementation(new Request(url, {
        signal: signal
    }));
    if (!response.body || response.status < 200 || response.status >= 300) throw new Error("Unable to fetch new route matches from the server");
    let payload = await createFromReadableStream(response.body, {
        temporaryReferences: void 0
    });
    if (payload.type !== "manifest") throw new Error("Failed to patch routes");
    paths.forEach((p)=>$5ba1327dd9c1735a$var$addToFifoQueue(p, $5ba1327dd9c1735a$var$discoveredPaths));
    payload.patches.forEach((p)=>{
        window.__reactRouterDataRouter.patchRoutes(p.parentId ?? null, [
            $5ba1327dd9c1735a$var$createRouteFromServerManifest(p)
        ]);
    });
}
function $5ba1327dd9c1735a$var$addToFifoQueue(path, queue) {
    if (queue.size >= $5ba1327dd9c1735a$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $5ba1327dd9c1735a$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
function $5ba1327dd9c1735a$var$isExternalLocation(location2) {
    const newLocation = new URL(location2, window.location.href);
    return newLocation.origin !== window.location.origin;
}
// lib/rsc/html-stream/browser.ts
function $5ba1327dd9c1735a$export$f4bb6b48866e43b() {
    let encoder = new TextEncoder();
    let streamController = null;
    let rscStream = new ReadableStream({
        start (controller) {
            if (typeof window === "undefined") return;
            let handleChunk = (chunk)=>{
                if (typeof chunk === "string") controller.enqueue(encoder.encode(chunk));
                else controller.enqueue(chunk);
            };
            window.__FLIGHT_DATA || (window.__FLIGHT_DATA = []);
            window.__FLIGHT_DATA.forEach(handleChunk);
            window.__FLIGHT_DATA.push = (chunk)=>{
                handleChunk(chunk);
                return 0;
            };
            streamController = controller;
        }
    });
    if (typeof document !== "undefined" && document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>{
        streamController?.close();
    });
    else streamController?.close();
    return rscStream;
}



var $1lMle = parcelRequire("1lMle");

var $e8yyN = parcelRequire("e8yyN");

var $cOVXE = parcelRequire("cOVXE");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");
/**
 * Minimal client-side ULID generator (Crockford base32, 26 chars).
 *
 * Used to mint an `impressionUlid` that correlates a prompt impression with the
 * answer and recommendation that follow. The server (webby-server) generates
 * ULIDs with `ulidx`; we avoid pulling that dependency into the browser bundle
 * for a single id, so this is a small, dependency-free equivalent. The value is
 * only ever used as an opaque correlation key, never parsed.
 */ // Crockford's base32 alphabet (excludes I, L, O, U to avoid ambiguity).
const $b645fccf57198abf$var$ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
const $b645fccf57198abf$var$ENCODING_LEN = $b645fccf57198abf$var$ENCODING.length;
const $b645fccf57198abf$var$TIME_LEN = 10;
const $b645fccf57198abf$var$RANDOM_LEN = 16;
function $b645fccf57198abf$var$encodeTime(time) {
    let now = time;
    let str = "";
    for(let i = $b645fccf57198abf$var$TIME_LEN - 1; i >= 0; i -= 1){
        const mod = now % $b645fccf57198abf$var$ENCODING_LEN;
        str = $b645fccf57198abf$var$ENCODING[mod] + str;
        now = (now - mod) / $b645fccf57198abf$var$ENCODING_LEN;
    }
    return str;
}
function $b645fccf57198abf$var$encodeRandom() {
    let str = "";
    for(let i = 0; i < $b645fccf57198abf$var$RANDOM_LEN; i += 1)str += $b645fccf57198abf$var$ENCODING[Math.floor(Math.random() * $b645fccf57198abf$var$ENCODING_LEN)];
    return str;
}
function $b645fccf57198abf$export$c34778236461ea95() {
    return $b645fccf57198abf$var$encodeTime(Date.now()) + $b645fccf57198abf$var$encodeRandom();
}
var $b645fccf57198abf$export$2e2bcd8739ae039 = $b645fccf57198abf$export$c34778236461ea95;



var $62tuQ = parcelRequire("62tuQ");

var $76QOg = parcelRequire("76QOg");

var $W4f7l = parcelRequire("W4f7l");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $1d1FK = parcelRequire("1d1FK");

var $W4f7l = parcelRequire("W4f7l");

var $bDIpx = parcelRequire("bDIpx");

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $3Xpkr = parcelRequire("3Xpkr");

var $1d1FK = parcelRequire("1d1FK");

var $4rInl = parcelRequire("4rInl");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $aSMrn = parcelRequire("aSMrn");

var $1d1FK = parcelRequire("1d1FK");
function $0841b83cc923c319$export$2e2bcd8739ae039({ disabled: disabled, onClick: onClick }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        component: "button",
        type: "button",
        disabled: disabled,
        onClick: onClick,
        sx: {
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            height: 34,
            px: 1.5,
            borderRadius: 999,
            border: 0,
            bgcolor: "rgba(255,255,255,0.06)",
            color: "#C3CFE6",
            fontFamily: "inherit",
            fontSize: 12.5,
            fontWeight: 600,
            whiteSpace: "nowrap",
            flexShrink: 0,
            cursor: disabled ? "default" : "pointer",
            opacity: disabled ? 0.5 : 1
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $aSMrn.default), {
                sx: {
                    fontSize: 15
                }
            }),
            "New chat"
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $bZrpr = parcelRequire("bZrpr");

var $1d1FK = parcelRequire("1d1FK");

var $5CVHy = parcelRequire("5CVHy");

var $8JNI1 = parcelRequire("8JNI1");

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $5Jk4T = parcelRequire("5Jk4T");

var $gYkLQ = parcelRequire("gYkLQ");

var $1d1FK = parcelRequire("1d1FK");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $5Jk4T = parcelRequire("5Jk4T");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $95FNu = parcelRequire("95FNu");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $2Tk9i = parcelRequire("2Tk9i");
const $cc3a0128bb238ddf$export$2796973bb2f51929 = 248;
function $cc3a0128bb238ddf$export$fddb767f9a0c44e1(content) {
    if (content.type === "WORKOUT") {
        const metadata = content.metadata;
        const appId = metadata?.appId ?? 0;
        return `/content/apps/workouts/plugin/play/${appId}/${content.sourceId}`;
    }
    if (content.type === "EXPERIENCE_VARIATION") return (0, $2Tk9i.variationPath)(content.metadata) ?? "/content/apps/workouts/search";
    if (content.type === "HELP_ARTICLE") {
        const metadata = content.metadata;
        return `/help/${metadata?.slug ?? ""}`;
    }
    // JOURNEY (classes)
    return `/content/classes?providerId=${content.contentProvider?.id ?? ""}`;
}
/**
 * Per-type card presentation. Help articles are answers to a support question,
 * not something you "start", so they get their own tag and call to action —
 * without this they render as a green "Workout" card offering to start a
 * workout, which misdescribes what the card actually opens.
 */ const $cc3a0128bb238ddf$var$CARD_STYLES = {
    WORKOUT: {
        tagLabel: "Workout",
        tagBg: "rgba(60, 233, 124, 0.92)",
        tagColor: "#0B1730",
        cta: "Start workout"
    },
    JOURNEY: {
        tagLabel: "Class",
        tagBg: "rgba(148, 41, 255, 0.92)",
        tagColor: "#fff",
        cta: "View class"
    },
    // An experience may be a game as easily as a drill, so it is neither
    // "Workout" nor "Class".
    EXPERIENCE_VARIATION: {
        tagLabel: "App",
        tagBg: "rgba(60, 233, 124, 0.92)",
        tagColor: "#0B1730",
        cta: "Play"
    },
    HELP_ARTICLE: {
        tagLabel: "Help",
        tagBg: "rgba(90, 162, 255, 0.92)",
        tagColor: "#0B1730",
        cta: "Read article"
    }
};
function $cc3a0128bb238ddf$export$2e2bcd8739ae039({ content: content, onStart: onStart }) {
    const isHelp = content.type === "HELP_ARTICLE";
    const { tagLabel: tagLabel, tagBg: tagBg, tagColor: tagColor, cta: cta } = content.type in $cc3a0128bb238ddf$var$CARD_STYLES ? $cc3a0128bb238ddf$var$CARD_STYLES[content.type] : $cc3a0128bb238ddf$var$CARD_STYLES.WORKOUT;
    const description = content.overview || content.description || "";
    // A help article is neither sport-specific (they apply to every sport) nor
    // meaningfully "provided by" anyone from a reader's point of view, so the
    // meta row would render as a stray "Volley" with nothing to qualify it.
    const sportLabel = isHelp ? null : content.sport?.label ?? content.sport?.name ?? null;
    const providerLabel = isHelp ? null : content.contentProvider?.label ?? content.contentProvider?.name ?? null;
    const heroImageUrl = content.cardImage?.url;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        sx: {
            flex: `0 0 ${$cc3a0128bb238ddf$export$2796973bb2f51929}px`,
            width: $cc3a0128bb238ddf$export$2796973bb2f51929,
            scrollSnapAlign: "start",
            bgcolor: "#fff",
            color: "#0B1730",
            borderRadius: 3,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            boxShadow: "0 6px 18px rgba(0, 0, 0, 0.28)"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                sx: {
                    position: "relative",
                    height: 132,
                    flexShrink: 0,
                    bgcolor: "#0E1B3A",
                    backgroundImage: "radial-gradient(120% 90% at 50% 0%, rgba(60,233,124,0.18) 0%, rgba(60,233,124,0) 60%)",
                    display: "flex",
                    alignItems: "flex-end"
                },
                children: [
                    heroImageUrl && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                component: "img",
                                src: heroImageUrl,
                                alt: content.cardImage?.alt ?? "",
                                loading: "lazy",
                                sx: {
                                    position: "absolute",
                                    inset: 0,
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                sx: {
                                    position: "absolute",
                                    inset: 0,
                                    background: "linear-gradient(180deg, rgba(11,23,48,0.10) 0%, rgba(11,23,48,0.78) 100%)"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $95FNu.default), {
                        label: tagLabel,
                        size: "small",
                        sx: {
                            position: "absolute",
                            zIndex: 1,
                            top: 10,
                            left: 10,
                            height: 22,
                            bgcolor: tagBg,
                            color: tagColor,
                            fontWeight: 700,
                            fontSize: 10.5,
                            letterSpacing: "0.02em",
                            textTransform: "uppercase",
                            "& .MuiChip-label": {
                                px: 1
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        sx: {
                            position: "relative",
                            zIndex: 1,
                            px: 1.75,
                            pb: 1.5,
                            fontWeight: 700,
                            fontSize: 19,
                            lineHeight: 1.12,
                            color: "#fff",
                            letterSpacing: "-0.01em",
                            textShadow: "0 1px 8px rgba(11, 23, 48, 0.55)"
                        },
                        children: content.title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                sx: {
                    p: 1.75,
                    gap: 1,
                    flex: 1
                },
                children: [
                    (sportLabel || providerLabel) && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                        direction: "row",
                        spacing: 1,
                        sx: {
                            alignItems: "center",
                            fontSize: 12,
                            color: "#5a6883",
                            fontWeight: 600
                        },
                        children: [
                            sportLabel && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                children: sportLabel
                            }),
                            sportLabel && providerLabel && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                sx: {
                                    width: 3,
                                    height: 3,
                                    borderRadius: "50%",
                                    bgcolor: "#aab4c8"
                                }
                            }),
                            providerLabel && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                component: "span",
                                sx: {
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                },
                                children: providerLabel
                            })
                        ]
                    }),
                    description && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        sx: {
                            m: 0,
                            fontSize: 13,
                            lineHeight: 1.45,
                            color: "#46546f",
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            minHeight: 56
                        },
                        children: description
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                        fullWidth: true,
                        onClick: ()=>onStart(content),
                        endIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5Jk4T.default), {
                            sx: {
                                fontSize: 15
                            }
                        }),
                        sx: {
                            mt: "auto",
                            borderRadius: 999,
                            textTransform: "none",
                            bgcolor: "#1FA557",
                            color: "#fff",
                            fontWeight: 600,
                            fontSize: 14,
                            py: 1.25,
                            "&:hover": {
                                bgcolor: "#23BC63"
                            }
                        },
                        children: cta
                    })
                ]
            })
        ]
    });
}


function $e30035af9d4690fd$export$2e2bcd8739ae039({ onBrowseAll: onBrowseAll }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        component: "button",
        type: "button",
        onClick: onBrowseAll,
        "aria-label": "Browse all workouts",
        sx: {
            flex: `0 0 ${(0, $cc3a0128bb238ddf$export$2796973bb2f51929)}px`,
            width: (0, $cc3a0128bb238ddf$export$2796973bb2f51929),
            scrollSnapAlign: "start",
            cursor: "pointer",
            p: 0,
            border: "1px dashed rgba(168,184,217,0.35)",
            borderRadius: 3,
            bgcolor: "rgba(255,255,255,0.04)",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 1.25,
            transition: "background-color 160ms ease, border-color 160ms ease",
            "&:hover": {
                bgcolor: "rgba(255,255,255,0.08)",
                borderColor: "rgba(60,233,124,0.55)"
            }
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                sx: {
                    width: 48,
                    height: 48,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "rgba(60,233,124,0.14)",
                    color: "#3CE97C"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gYkLQ.default), {
                    sx: {
                        fontSize: 24
                    }
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                sx: {
                    fontWeight: 700,
                    fontSize: 16,
                    lineHeight: 1.15
                },
                children: "Browse all"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                direction: "row",
                sx: {
                    alignItems: "center",
                    gap: 0.5,
                    color: "#aab4c8"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        sx: {
                            fontSize: 13,
                            fontWeight: 600
                        },
                        children: "See every workout"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $5Jk4T.default), {
                        sx: {
                            fontSize: 15
                        }
                    })
                ]
            })
        ]
    });
}




var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $aSMrn = parcelRequire("aSMrn");

var $9jrSn = parcelRequire("9jrSn");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $94afd6c6a7c19c21$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "m10.89 18.28.57-2.89c.12-.59-.04-1.2-.42-1.66S10.1 13 9.5 13H4v-1.08L6.57 6h8.09c.18 0 .34.16.34.34v7.84zM10 22l6.41-6.41c.38-.38.59-.89.59-1.42V6.34C17 5.05 15.95 4 14.66 4h-8.1c-.71 0-1.36.37-1.72.97l-2.67 6.15c-.11.25-.17.52-.17.8V13c0 1.1.9 2 2 2h5.5l-.92 4.65c-.05.22-.02.46.08.66.23.45.52.86.88 1.22zm10-7h2V4h-2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1"
}), 'ThumbDownOffAlt');



var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $b82342c8b19c81da$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "m13.11 5.72-.57 2.89c-.12.59.04 1.2.42 1.66s.94.73 1.54.73H20v1.08L17.43 18H9.34c-.18 0-.34-.16-.34-.34V9.82zM14 2 7.59 8.41C7.21 8.79 7 9.3 7 9.83v7.83C7 18.95 8.05 20 9.34 20h8.1c.71 0 1.36-.37 1.72-.97l2.67-6.15c.11-.25.17-.52.17-.8V11c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66-.23-.45-.52-.86-.88-1.22zM4 9H2v11h2c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1"
}), 'ThumbUpOffAlt');



var $1d1FK = parcelRequire("1d1FK");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");
const $877db909e215b109$var$GREEN = "#3CE97C";
function $877db909e215b109$var$Thumb({ label: label, selected: selected, dimmed: dimmed, onClick: onClick, children: children }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
        component: "button",
        type: "button",
        "aria-label": label,
        "aria-pressed": selected,
        onClick: onClick,
        sx: {
            width: 44,
            height: 44,
            borderRadius: 999,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: selected ? "rgba(60,233,124,0.10)" : "transparent",
            border: selected ? `1.5px solid ${$877db909e215b109$var$GREEN}` : "1px solid rgba(168,184,217,0.25)",
            color: selected ? $877db909e215b109$var$GREEN : dimmed ? "#55658A" : "#C3CFE6",
            cursor: "pointer"
        },
        children: children
    });
}
function $877db909e215b109$var$BranchChoice({ title: title, detail: detail, tint: tint, icon: icon, onClick: onClick }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
        component: "button",
        type: "button",
        direction: "row",
        onClick: onClick,
        sx: {
            alignItems: "center",
            gap: 1.5,
            p: 1,
            width: "100%",
            border: 0,
            borderRadius: 1.5,
            bgcolor: "transparent",
            textAlign: "left",
            cursor: "pointer",
            fontFamily: "inherit"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                sx: {
                    width: 36,
                    height: 36,
                    flexShrink: 0,
                    borderRadius: "50%",
                    bgcolor: tint,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: icon
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                sx: {
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        sx: {
                            fontSize: 14.5,
                            fontWeight: 600,
                            color: "#fff",
                            lineHeight: 1.25
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        sx: {
                            fontSize: 12.5,
                            color: "#94A3B8",
                            mt: "2px"
                        },
                        children: detail
                    })
                ]
            })
        ]
    });
}
function $877db909e215b109$export$2e2bcd8739ae039({ intent: intent, helpful: helpful, onRate: onRate, onRetry: onRetry, onEscalate: onEscalate }) {
    const rated = helpful !== undefined;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        sx: {
            px: 2,
            pl: "52px",
            mb: 1.75
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                sx: {
                    fontSize: 12.5,
                    color: "#94A3B8",
                    mb: 1.25
                },
                children: helpful === true ? "Glad that helped." : "Did this help?"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                direction: "row",
                sx: {
                    gap: 1.25
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($877db909e215b109$var$Thumb, {
                        label: "This helped",
                        selected: helpful === true,
                        dimmed: rated,
                        onClick: ()=>onRate(true),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b82342c8b19c81da$export$2e2bcd8739ae039), {
                            sx: {
                                fontSize: 19
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($877db909e215b109$var$Thumb, {
                        label: "This did not help",
                        selected: helpful === false,
                        dimmed: rated,
                        onClick: ()=>onRate(false),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $94afd6c6a7c19c21$export$2e2bcd8739ae039), {
                            sx: {
                                fontSize: 19
                            }
                        })
                    })
                ]
            }),
            helpful === false && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                sx: {
                    mt: 1.5,
                    p: 1.5,
                    borderRadius: 2,
                    bgcolor: "rgba(255,255,255,0.045)",
                    border: "1px solid rgba(168,184,217,0.18)"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                        sx: {
                            fontSize: 14.5,
                            color: "#E2E8F0",
                            lineHeight: 1.4,
                            mb: 1.25
                        },
                        children: [
                            "Sorry \u2014 that missed. Tell me what is actually happening and I'll try again",
                            intent === "HELP" ? ", or I can get a person on it." : "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($877db909e215b109$var$BranchChoice, {
                        title: "Let me try again",
                        detail: "Say what is missing and I'll have another go",
                        tint: "rgba(60,233,124,0.12)",
                        icon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aSMrn.default), {
                            sx: {
                                fontSize: 18,
                                color: $877db909e215b109$var$GREEN
                            }
                        }),
                        onClick: onRetry
                    }),
                    intent === "HELP" && /*#__PURE__*/ (0, $ih19M.jsx)($877db909e215b109$var$BranchChoice, {
                        title: "Message the team",
                        detail: "Sends this conversation so you don't repeat it",
                        tint: "rgba(90,162,255,0.14)",
                        icon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9jrSn.default), {
                            sx: {
                                fontSize: 18,
                                color: "#7FB4FF"
                            }
                        }),
                        onClick: onEscalate
                    })
                ]
            })
        ]
    });
}


const $3790b426c3116030$var$GREEN = "#3CE97C";
const $3790b426c3116030$var$NAVY_DEEP = "#0B1730";
function $3790b426c3116030$export$e2255cf6045e8d47({ size: size }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
        sx: {
            width: size,
            height: size,
            borderRadius: "50%",
            flexShrink: 0,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            color: $3790b426c3116030$var$NAVY_DEEP,
            background: "radial-gradient(circle at 30% 30%, #58F08C 0%, #1FA557 60%, #0E6E3A 100%)"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bZrpr.default), {
            sx: {
                fontSize: size * 0.55
            }
        })
    });
}
function $3790b426c3116030$export$2e2bcd8739ae039({ message: message, onStart: onStart, onBrowseAll: onBrowseAll, onEscalate: onEscalate, onRate: onRate, onRetry: onRetry }) {
    if (message.kind === "rating") return /*#__PURE__*/ (0, $ih19M.jsx)((0, $877db909e215b109$export$2e2bcd8739ae039), {
        intent: message.intent,
        helpful: message.helpful,
        onRate: (helpful)=>onRate(message.askId, helpful),
        onRetry: onRetry,
        onEscalate: ()=>onEscalate("help")
    });
    if (message.kind === "assistant") return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
        direction: "row",
        sx: {
            gap: 1,
            px: 2,
            mb: 1.75,
            alignItems: "flex-end"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($3790b426c3116030$export$e2255cf6045e8d47, {
                size: 28
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                sx: {
                    maxWidth: "78%",
                    px: 1.75,
                    py: 1.5,
                    borderRadius: 2,
                    borderBottomLeftRadius: 6,
                    bgcolor: "#182B57",
                    fontSize: 15,
                    lineHeight: 1.4
                },
                children: message.content
            })
        ]
    });
    if (message.kind === "support") return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
        direction: "row",
        sx: {
            gap: 1,
            px: 2,
            mb: 1.75,
            alignItems: "flex-end"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($3790b426c3116030$export$e2255cf6045e8d47, {
                size: 28
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                sx: {
                    maxWidth: "78%",
                    px: 1.75,
                    py: 1.5,
                    borderRadius: 2,
                    borderBottomLeftRadius: 6,
                    bgcolor: "#182B57",
                    fontSize: 15,
                    lineHeight: 1.4
                },
                children: [
                    message.content,
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        component: "button",
                        type: "button",
                        // The player's own words travel as the fallback first
                        // message: this is the one path where we know the
                        // question and are admitting we cannot answer it.
                        onClick: ()=>onEscalate(message.origin, message.question),
                        sx: {
                            display: "block",
                            mt: 1,
                            p: 0,
                            border: 0,
                            bgcolor: "transparent",
                            color: $3790b426c3116030$var$GREEN,
                            fontFamily: "inherit",
                            fontSize: 14,
                            fontWeight: 600,
                            cursor: "pointer"
                        },
                        children: "Message support"
                    })
                ]
            })
        ]
    });
    if (message.kind === "user") return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8JNI1.default), {
        direction: "row",
        sx: {
            px: 2,
            mb: 1.75,
            justifyContent: "flex-end"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
            sx: {
                maxWidth: "78%",
                px: 1.75,
                py: 1.5,
                borderRadius: 2,
                borderBottomRightRadius: 6,
                bgcolor: "#fff",
                color: $3790b426c3116030$var$NAVY_DEEP,
                fontWeight: 500,
                fontSize: 15,
                lineHeight: 1.4
            },
            children: message.content
        })
    });
    if (message.kind === "loading") return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
        direction: "row",
        sx: {
            gap: 1,
            px: 2,
            mb: 1.75,
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($3790b426c3116030$export$e2255cf6045e8d47, {
                size: 28
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                size: 18,
                sx: {
                    color: $3790b426c3116030$var$GREEN
                }
            })
        ]
    });
    // carousel
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
        direction: "row",
        sx: {
            gap: 1.5,
            px: 2,
            pb: 1.5,
            mb: 0.5,
            overflowX: "auto",
            scrollSnapType: "x proximity",
            "&::-webkit-scrollbar": {
                display: "none"
            },
            scrollbarWidth: "none"
        },
        children: [
            message.cards.map((card)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $cc3a0128bb238ddf$export$2e2bcd8739ae039), {
                    content: card,
                    onStart: onStart
                }, `${card.type}-${card.id}`)),
            message.intent !== "HELP" && /*#__PURE__*/ (0, $ih19M.jsx)((0, $e30035af9d4690fd$export$2e2bcd8739ae039), {
                onBrowseAll: onBrowseAll
            })
        ]
    });
}


const $e7ad11bb0f30ef0e$var$GREEN = "#3CE97C";
function $e7ad11bb0f30ef0e$export$2e2bcd8739ae039({ status: status, canClear: canClear, busy: busy, onNewChat: onNewChat, onClose: onClose }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
        direction: "row",
        sx: {
            alignItems: "center",
            gap: 1.5,
            px: 2,
            py: 1.5,
            flexShrink: 0,
            borderBottom: "1px solid rgba(168,184,217,0.10)"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $3790b426c3116030$export$e2255cf6045e8d47), {
                size: 40
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                sx: {
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        sx: {
                            fontWeight: 700,
                            fontSize: 16,
                            lineHeight: 1.1
                        },
                        children: "Volley"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                        direction: "row",
                        sx: {
                            alignItems: "center",
                            gap: 0.75
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                sx: {
                                    width: 6,
                                    height: 6,
                                    borderRadius: "50%",
                                    bgcolor: $e7ad11bb0f30ef0e$var$GREEN,
                                    boxShadow: `0 0 6px ${$e7ad11bb0f30ef0e$var$GREEN}`
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                sx: {
                                    fontSize: 12,
                                    color: $e7ad11bb0f30ef0e$var$GREEN,
                                    fontWeight: 500
                                },
                                children: status
                            })
                        ]
                    })
                ]
            }),
            canClear && /*#__PURE__*/ (0, $ih19M.jsx)((0, $0841b83cc923c319$export$2e2bcd8739ae039), {
                disabled: busy,
                onClick: onNewChat
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                onClick: onClose,
                "aria-label": "close",
                sx: {
                    color: "#fff",
                    bgcolor: "rgba(255,255,255,0.06)"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3Xpkr.default), {
                    sx: {
                        fontSize: 16
                    }
                })
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $3EEPE = parcelRequire("3EEPE");

var $1d1FK = parcelRequire("1d1FK");

var $cVsvh = parcelRequire("cVsvh");

var $8JNI1 = parcelRequire("8JNI1");
const $748abb3592c3b3a7$var$GREEN = "#3CE97C";
const $748abb3592c3b3a7$var$NAVY_DEEP = "#0B1730";
/** Max free-text length per turn, matching the widget's open field. */ const $748abb3592c3b3a7$var$ASK_MAX_LENGTH = 500;
function $748abb3592c3b3a7$export$2e2bcd8739ae039({ inputRef: inputRef, value: value, onChange: onChange, onSubmit: onSubmit, busy: busy }) {
    const canSend = !busy && value.trim().length > 0;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
        direction: "row",
        sx: {
            alignItems: "center",
            gap: 1,
            px: 2,
            py: 1.5,
            flexShrink: 0,
            borderTop: "1px solid rgba(168,184,217,0.10)"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cVsvh.default), {
                fullWidth: true,
                inputRef: inputRef,
                value: value,
                disabled: busy,
                placeholder: "Ask a follow-up\u2026",
                inputProps: {
                    maxLength: $748abb3592c3b3a7$var$ASK_MAX_LENGTH,
                    "aria-label": "Ask a follow-up"
                },
                onChange: (e)=>onChange(e.target.value),
                onKeyDown: (e)=>{
                    if (e.key === "Enter") {
                        e.preventDefault();
                        onSubmit();
                    }
                },
                sx: {
                    flex: 1,
                    minWidth: 0,
                    height: 46,
                    borderRadius: "24px",
                    px: 2,
                    color: "#fff",
                    fontSize: 14,
                    bgcolor: "rgba(60,233,124,0.06)",
                    border: "1.5px solid rgba(60,233,124,0.55)",
                    boxShadow: "0 0 0 3px rgba(60,233,124,0.07)",
                    opacity: busy ? 0.5 : 1,
                    transition: "border-color 120ms ease, box-shadow 120ms ease, background 120ms ease, opacity 120ms ease",
                    "& input::placeholder": {
                        color: "#9DB0D0",
                        opacity: 1
                    },
                    "&.Mui-focused": {
                        borderColor: $748abb3592c3b3a7$var$GREEN,
                        bgcolor: "rgba(60,233,124,0.1)",
                        boxShadow: "0 0 0 4px rgba(60,233,124,0.18)"
                    }
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                component: "button",
                type: "button",
                "aria-label": "send",
                disabled: !canSend,
                onClick: onSubmit,
                sx: {
                    width: 44,
                    height: 44,
                    flexShrink: 0,
                    borderRadius: 999,
                    border: 0,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: $748abb3592c3b3a7$var$NAVY_DEEP,
                    bgcolor: canSend ? $748abb3592c3b3a7$var$GREEN : "rgba(60,233,124,0.82)",
                    opacity: busy ? 0.5 : 1,
                    cursor: canSend ? "pointer" : "default",
                    transition: "background 120ms ease, opacity 120ms ease"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3EEPE.default), {
                    sx: {
                        fontSize: 18
                    }
                })
            })
        ]
    });
}




function $c37b1f47be1186b7$export$ecfc5e94598ea38c(result, question) {
    // Unroutable input: neither a training request nor a support question.
    // Offer a human rather than a dead end.
    if (result.kind === "not_workout_request") return [
        {
            kind: "support",
            origin: "unroutable",
            question: question,
            // Only offer support help to users who can actually reach it.
            // Outside the classifier rollout the server never routes to
            // articles, so the wider promise would send them rephrasing
            // towards a dead end.
            content: result.helpAvailable ? "I can help with your training or with using Volley \u2014 try rephrasing your question." : "I can only help with workout recommendations right now \u2014 try asking about a skill, drill, or workout you'd like to train."
        }
    ];
    // The request itself failed, so we never learned the intent. Say so and
    // offer a human: rendering the recommendation miss copy here would tell
    // someone who asked a support question to rephrase, and never admit
    // anything broke.
    if (result.kind === "error") return [
        {
            kind: "support",
            origin: "error",
            question: question,
            content: "Something went wrong on my end \u2014 try asking again in a moment."
        }
    ];
    const { cards: cards, intent: intent, summary: summary } = result;
    if (cards.length === 0) // A support question we have no article for is the one miss worth
    // escalating: the user asked something answerable, we just don't hold
    // the answer.
    return intent === "HELP" ? [
        {
            kind: "support",
            origin: "help",
            question: question,
            content: "I couldn't find an article on that."
        }
    ] : [
        {
            kind: "assistant",
            content: "I couldn't find a match for that right now \u2014 try asking another way."
        }
    ];
    // A help answer leads with the summary when we have one: it answers the
    // question in the thread, which is the whole point of asking here rather
    // than opening the help centre. The generic lead-in is then dropped rather
    // than stacked on top — "here's what I found" reads as filler once a real
    // answer sits directly above the same cards.
    const lead = intent === "HELP" && summary ? {
        kind: "assistant",
        content: summary
    } : {
        kind: "assistant",
        content: intent === "HELP" ? "Here's what I found that should help:" : "Here's what I'd recommend:"
    };
    // Only an answer we actually stand behind gets rated. The misses above
    // already say we could not help and offer a way on, so asking "did this
    // help?" under one would be asking a question we just answered ourselves.
    //
    // No askId means the ask log write failed. The answer still stands; it just
    // has nowhere to record a rating, so none is offered.
    return [
        lead,
        {
            kind: "carousel",
            cards: cards,
            intent: intent
        },
        ...result.askId === undefined ? [] : [
            {
                kind: "rating",
                askId: result.askId,
                intent: intent,
                question: question
            }
        ]
    ];
}
function $c37b1f47be1186b7$export$114308a33ac1659c(result) {
    if (result.kind === "not_workout_request") return {
        action: "free_text_result",
        outcome: "not_workout_request",
        intent: "UNCLASSIFIED",
        count: 0
    };
    if (result.kind === "error") return {
        action: "free_text_result",
        outcome: "error",
        count: 0
    };
    return {
        action: "free_text_result",
        intent: result.intent,
        count: result.cards.length,
        contentIds: result.cards.map((c)=>c.id)
    };
}



var $cK0UE = parcelRequire("cK0UE");
const $54cda1d76057ea5a$export$d25966be0dd29595 = "home_screen_widget";
const $54cda1d76057ea5a$export$fb4230faa4b8183a = "ask_volley_page";
async function $54cda1d76057ea5a$export$2c6d799cadbcdd81(sportId) {
    const params = new URLSearchParams({
        limit: "1"
    });
    if (sportId != null) params.set("sportId", String(sportId));
    const { prompts: prompts } = await (0, $cK0UE.default)(`/api/home-prompts/next?${params.toString()}`);
    return prompts[0] ?? null;
}
async function $54cda1d76057ea5a$export$ad90a8b5454baf8e(request, limit = 10) {
    try {
        const result = await (0, $cK0UE.default)(`/api/content/recommend?limit=${limit}&offset=0`, "POST", request);
        return result.result;
    } catch (e) {
        if (e instanceof (0, $cK0UE.FetchError) && e.statusCode === 404) return [];
        (0, $cK0UE.logFetchError)(e, "Failed to fetch content recommendations");
        return [];
    }
}
/** Drop the keys the server treats as absent rather than sending them empty. */ function $54cda1d76057ea5a$var$askBody(ask) {
    const { text: text, sportName: sportName, impressionUlid: impressionUlid, thread: thread, conversationUlid: conversationUlid } = ask;
    return Object.fromEntries(Object.entries({
        text: text,
        sportName: sportName,
        impressionUlid: impressionUlid,
        conversationUlid: conversationUlid,
        thread: thread?.length ? thread : undefined
    }).filter(([, v])=>v !== undefined && v !== ""));
}
async function $54cda1d76057ea5a$export$8736feb2fc75242(ask) {
    const limit = ask.limit ?? 4;
    try {
        const result = await (0, $cK0UE.default)(`/api/content/recommend/free-text?limit=${limit}&offset=0`, "POST", $54cda1d76057ea5a$var$askBody(ask), {
            signal: AbortSignal.timeout(60000)
        });
        return {
            kind: "results",
            // Default to RECOMMEND so a server running with the classifier
            // toggled off (no intent in the payload) renders exactly as before.
            intent: result.intent ?? "RECOMMEND",
            cards: result.result,
            ...result.conversationUlid ? {
                conversationUlid: result.conversationUlid
            } : {},
            ...result.askId === undefined ? {} : {
                askId: result.askId
            },
            ...result.helpSummary?.text ? {
                summary: result.helpSummary.text
            } : {}
        };
    } catch (e) {
        if (e instanceof (0, $cK0UE.FetchError) && e.statusCode === 422) {
            // Absent on an older server: default to the narrower claim rather
            // than promising help this user may not be able to reach.
            const body = e.body;
            return {
                kind: "not_workout_request",
                helpAvailable: body?.helpAvailable === true,
                ...body?.conversationUlid ? {
                    conversationUlid: body.conversationUlid
                } : {}
            };
        }
        // A 404 is an older server without the route at all — there is nothing
        // wrong for the user to retry, so keep the pre-existing graceful miss.
        if (e instanceof (0, $cK0UE.FetchError) && e.statusCode === 404) return {
            kind: "results",
            intent: "RECOMMEND",
            cards: []
        };
        (0, $cK0UE.logFetchError)(e, "Failed to fetch free-text recommendations");
        return {
            kind: "error"
        };
    }
}
async function $54cda1d76057ea5a$export$a31e339227814228(homePromptId, answer, impressionUlid) {
    try {
        await (0, $cK0UE.default)("/api/home-prompts/responses", "POST", {
            answers: [
                {
                    homePromptId: homePromptId,
                    answer: answer,
                    impressionUlid: impressionUlid
                }
            ]
        });
    } catch (e) {
        (0, $cK0UE.logFetchError)(e, "Failed to submit prompt answer");
    }
}
function $54cda1d76057ea5a$export$46298099f5f107b1({ eventType: eventType, prompt: prompt, impressionUlid: impressionUlid, sportId: sportId, surface: surface = $54cda1d76057ea5a$export$d25966be0dd29595, metadata: metadata }) {
    const payload = {
        eventType: eventType,
        homePromptId: prompt?.id ?? null,
        promptType: prompt?.promptType ?? null,
        sportId: sportId ?? null,
        impressionUlid: impressionUlid,
        surface: surface,
        // Only when there is a prompt: an absent key and a null one read the
        // same in the JSONB, and writing null here would make "no prompt" and
        // "a universal prompt" indistinguishable in the per-prompt reports.
        metadata: {
            ...metadata ?? {},
            ...prompt ? {
                promptSportId: prompt.sportId
            } : {}
        }
    };
    (0, $cK0UE.default)("/api/home-prompts/events", "POST", payload).catch((e)=>(0, $cK0UE.logFetchError)(e, "Failed to record home prompt event"));
}
function $54cda1d76057ea5a$export$ba616d63d7d5a2d7(conversationUlid) {
    (0, $cK0UE.default)(`/api/ask-volley/conversations/${encodeURIComponent(conversationUlid)}/close`, "POST").catch((e)=>(0, $cK0UE.logFetchError)(e, "Failed to close Ask Volley conversation"));
}
function $54cda1d76057ea5a$export$1721634c0ceb81c6(askId, helpful) {
    (0, $cK0UE.default)(`/api/ask-volley/asks/${askId}/rating`, "POST", {
        helpful: helpful
    }).catch((e)=>(0, $cK0UE.logFetchError)(e, "Failed to record Ask Volley rating"));
}
async function $54cda1d76057ea5a$export$7bce94669212d405(conversationUlid) {
    try {
        const { intercomConversationId: intercomConversationId } = await (0, $cK0UE.default)(`/api/ask-volley/conversations/${encodeURIComponent(conversationUlid)}/escalate`, "POST");
        return intercomConversationId ?? null;
    } catch (e) {
        (0, $cK0UE.logFetchError)(e, "Failed to hand the Ask Volley conversation over");
        return null;
    }
}


/**
 * How long a saved chat stays restorable. Bounds the "back to home much later in
 * the session re-opens a stale chat" case — a chat abandoned beyond this window
 * is treated as gone and the home screen loads a fresh prompt instead.
 */ const $41b2e6bb65ce7f0b$var$TTL_MS = 1800000;
function $41b2e6bb65ce7f0b$var$key(userId) {
    return `askVolley.openChat.v1.${userId ?? "anon"}`;
}
function $41b2e6bb65ce7f0b$export$693f923f38b7ee97(userId, snapshot) {
    try {
        sessionStorage.setItem($41b2e6bb65ce7f0b$var$key(userId), JSON.stringify(snapshot));
    } catch  {
    // Persisting the chat is a nicety; never let it break navigation.
    }
}
function $41b2e6bb65ce7f0b$export$8169690c1ed1afde(userId) {
    try {
        const raw = sessionStorage.getItem($41b2e6bb65ce7f0b$var$key(userId));
        if (!raw) return null;
        const snapshot = JSON.parse(raw);
        if (typeof snapshot.savedAt !== "number" || Date.now() - snapshot.savedAt > $41b2e6bb65ce7f0b$var$TTL_MS) {
            $41b2e6bb65ce7f0b$export$a4b3eaeabef16fd2(userId);
            return null;
        }
        return snapshot;
    } catch  {
        return null;
    }
}
function $41b2e6bb65ce7f0b$export$a4b3eaeabef16fd2(userId) {
    try {
        sessionStorage.removeItem($41b2e6bb65ce7f0b$var$key(userId));
    } catch  {
    // Ignore — nothing actionable if storage is unavailable.
    }
}


const $a80a94320a991500$export$7efb6b5d91849ee1 = new Set([
    "PICKLEBALL",
    "PLATFORM_TENNIS",
    "PADEL",
    "TENNIS",
    "LACROSSE"
]);
const $a80a94320a991500$export$f0ab39a679c40ec8 = "/ask";
const $a80a94320a991500$export$ee52a99483b4dd = "browse_all";
const $a80a94320a991500$export$dc8094ab5ed228c0 = "/content/apps/workouts/search";
const $a80a94320a991500$export$6f37da0b64ed9ef3 = "start_assessment";
const $a80a94320a991500$export$13daccba1fc24702 = "finish_assessment";
const $a80a94320a991500$export$9b04b86b97ffec74 = "connect_dupr";
const $a80a94320a991500$export$a2b1695e29f6b62d = "connect_apta";
const $a80a94320a991500$export$94865bdb2f9b35fc = "see_my_stats";
const $a80a94320a991500$export$dd471baad5e544d0 = "/performance";
const $a80a94320a991500$export$de3715c89a541648 = "/journeys/assessments";
function $a80a94320a991500$export$59b2f70a1d4214ae(sport) {
    return sport === "PICKLEBALL" ? $a80a94320a991500$export$dd471baad5e544d0 : $a80a94320a991500$export$de3715c89a541648;
}
function $a80a94320a991500$export$48778c1a1acbe210(option) {
    return option.value === $a80a94320a991500$export$9b04b86b97ffec74;
}
function $a80a94320a991500$export$ca1696bb8b460f3e(option) {
    return option.value === $a80a94320a991500$export$a2b1695e29f6b62d;
}
function $a80a94320a991500$export$67e233fd2cb25dd3(option) {
    return option.value === $a80a94320a991500$export$94865bdb2f9b35fc;
}
function $a80a94320a991500$export$706a5404f6f91eaa(option) {
    return option.value === $a80a94320a991500$export$6f37da0b64ed9ef3 || option.value === $a80a94320a991500$export$13daccba1fc24702;
}


// The subpath, not the package root: a value import of the root pulls the
// whole of @volley/data — Prisma included — into the browser bundle.
const $95f607c8206696a5$export$6b7359ec55231b09 = 6;


function $68a6ee10e198e7cf$export$9564a097b54a5c43(thread) {
    const turns = thread.flatMap((message)=>{
        if (message.kind === "user") return [
            {
                role: "user",
                text: message.content
            }
        ];
        if (message.kind === "assistant" || message.kind === "support") return [
            {
                role: "assistant",
                text: message.content
            }
        ];
        if (message.kind === "rating" && message.helpful === false) return [
            {
                role: "user",
                text: "That answer didn't help."
            }
        ];
        return [];
    });
    return turns.slice(-(0, $95f607c8206696a5$export$6b7359ec55231b09));
}


const $ba01596fc99c49d5$var$NAVY_DEEP = "#0B1730";
/**
 * Cap on recommended content shown for an answer. Kept small so the carousel
 * stays a focused pick, not a full list — and so the recommendation snapshot
 * (what the server records as "served") matches what the user actually saw.
 */ const $ba01596fc99c49d5$var$MAX_RECOMMENDATIONS = 4;
/**
 * How the chat opens when nothing prompted it.
 *
 * Deliberately an invitation rather than a greeting with no exit: opened from
 * the launcher there are no chips to tap, so the only way forward is the
 * composer, and the opening line has to say so.
 */ const $ba01596fc99c49d5$var$LAUNCHER_GREETING = "Ask me anything \u2014 about your training, or about using your trainer.";
/**
 * How the chat re-opens after "New chat".
 *
 * Never the prompt's own words, even when there is a prompt: the person has
 * just said they are done with what we suggested, and handing them the same
 * suggestion back reads as not having listened. An open question instead.
 */ const $ba01596fc99c49d5$var$NEW_CHAT_GREETING = "What can I help you with today?";
/**
 * What the header says the chat is doing.
 *
 * "Picked for you" is the promise a home-screen prompt made, and it holds only
 * while the thread still answers that prompt. After "New chat" nothing has been
 * picked, and claiming otherwise over an open question is a lie the user can
 * see — so a started-over chat reads like one opened from the launcher.
 */ function $ba01596fc99c49d5$var$headerStatus(hasPrompt, startedOver) {
    return hasPrompt && !startedOver ? "Picked for you" : "Ask anything";
}
/** The three ways a chat can begin. Pure, so it can be read in one sitting. */ function $ba01596fc99c49d5$var$seedThread({ restored: restored, freeTextSeed: freeTextSeed, prompt: prompt }) {
    // Restoring a chat the user left to view a workout: seed from the saved
    // thread verbatim (nothing is re-fetched).
    if (restored) return restored.thread;
    // Opened from the widget's open field: lead with their own message and an
    // acknowledgement, because the question is already asked.
    if (freeTextSeed) return [
        {
            kind: "user",
            content: freeTextSeed
        },
        {
            kind: "assistant",
            content: "Got it \u2014 let me pull that together for you."
        }
    ];
    // Otherwise we speak first: the prompt's own words, or the invitation when
    // nothing prompted this.
    return [
        {
            kind: "assistant",
            content: prompt?.promptText ?? $ba01596fc99c49d5$var$LAUNCHER_GREETING
        }
    ];
}
/**
 * Options that leave the chat rather than being answered in it — start an
 * assessment, link a rating, open the dashboard. Returns true when the option
 * was one of them and has been played.
 *
 * Grouped because they are one idea (an option that is a launch, not a
 * question) and because inlining four of them made the one function that
 * actually answers a question hard to read past.
 */ function $ba01596fc99c49d5$var$playLaunchOption(option, handlers) {
    // "Start" / "Finish assessment": drives the assessment flow directly.
    if ((0, $a80a94320a991500$export$706a5404f6f91eaa)(option)) {
        handlers.onLaunchAssessment(option);
        return true;
    }
    // "Connect DUPR": opens the existing DUPR connect flow.
    if ((0, $a80a94320a991500$export$48778c1a1acbe210)(option)) {
        handlers.onConnectDupr(option);
        return true;
    }
    // Platform tennis's equivalent: link an APTA id so PTI resolves.
    if ((0, $a80a94320a991500$export$ca1696bb8b460f3e)(option)) {
        handlers.onConnectApta(option);
        return true;
    }
    // "See my stats": navigates to the performance dashboard.
    if ((0, $a80a94320a991500$export$67e233fd2cb25dd3)(option)) {
        handlers.onSeeStats(option);
        return true;
    }
    return false;
}
function $ba01596fc99c49d5$export$2e2bcd8739ae039({ prompt: prompt, impressionUlid: impressionUlid, surface: surface = (0, $54cda1d76057ea5a$export$d25966be0dd29595), sportName: sportName, sportId: sportId, initialOptionValue: initialOptionValue, freeTextSeed: freeTextSeed, restored: restored, onClose: onClose, onLaunchAssessment: onLaunchAssessment, onConnectDupr: onConnectDupr, onConnectApta: onConnectApta, onSeeStats: onSeeStats }) {
    const navigate = (0, $as544.useNavigate)();
    const { currentUser: currentUser } = (0, $W4f7l.useCurrentUser)();
    const intercom = (0, $bDIpx.default)();
    const userId = currentUser?.id;
    const [thread, setThread] = $bh6RR.useState(()=>$ba01596fc99c49d5$var$seedThread({
            restored: restored,
            freeTextSeed: freeTextSeed,
            prompt: prompt
        }));
    const [busy, setBusy] = $bh6RR.useState(false);
    const [mounted, setMounted] = $bh6RR.useState(false);
    const [draft, setDraft] = $bh6RR.useState("");
    // Set once "New chat" has run. The prompt still exists as a prop, but the
    // thread no longer answers it — so the header must stop saying so.
    const [startedOver, setStartedOver] = $bh6RR.useState(false);
    // The server-side conversation these turns belong to. The server mints it on
    // the first ask and hands it back; every later ask echoes it so the turns
    // land together. Undefined until the first answer returns, and again after a
    // "New chat" — in both cases the next ask opens a fresh one.
    const [conversationUlid, setConversationUlid] = $bh6RR.useState(restored?.conversationUlid);
    const threadRef = $bh6RR.useRef(null);
    const composerRef = $bh6RR.useRef(null);
    // Drive the slide-in on the next frame.
    $bh6RR.useEffect(()=>{
        const id = requestAnimationFrame(()=>setMounted(true));
        return ()=>cancelAnimationFrame(id);
    }, []);
    // Keep the thread pinned to the latest message.
    $bh6RR.useEffect(()=>{
        if (threadRef.current) threadRef.current.scrollTop = threadRef.current.scrollHeight;
    }, [
        thread
    ]);
    // Leave the chat for the full workouts library via the fixed trailing
    // carousel card, capturing the choice for attribution.
    const handleBrowseAll = $bh6RR.useCallback(()=>{
        (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: prompt,
            impressionUlid: impressionUlid,
            sportId: sportId,
            surface: surface,
            metadata: {
                action: "browse_all",
                answerValue: (0, $a80a94320a991500$export$ee52a99483b4dd),
                answerLabel: "Browse all",
                via: "carousel"
            }
        });
        // Leaving via the trailing carousel card keeps the conversation going, so
        // persist it (like tapping a workout) — backing out of the library then
        // restores this exact thread and its recommendations.
        (0, $41b2e6bb65ce7f0b$export$693f923f38b7ee97)(userId, {
            savedAt: Date.now(),
            impressionUlid: impressionUlid,
            sportId: sportId,
            prompt: prompt,
            surface: surface,
            initialOptionValue: initialOptionValue,
            freeTextSeed: freeTextSeed,
            thread: thread,
            conversationUlid: conversationUlid
        });
        onClose();
        navigate((0, $a80a94320a991500$export$dc8094ab5ed228c0));
    }, [
        impressionUlid,
        sportId,
        navigate,
        onClose,
        prompt,
        userId,
        initialOptionValue,
        freeTextSeed,
        thread,
        surface,
        conversationUlid
    ]);
    const handleSelect = $bh6RR.useCallback(async (option)=>{
        // Options only ever come off a prompt, so there is nothing to
        // select without one. Stated rather than assumed: it is also what
        // keeps the prompt reads below narrowed.
        if (busy || !prompt) return;
        // Options that leave the chat instead of being answered in it. The
        // parent records the interaction in each case.
        const launched = $ba01596fc99c49d5$var$playLaunchOption(option, {
            onLaunchAssessment: onLaunchAssessment,
            onConnectDupr: onConnectDupr,
            onConnectApta: onConnectApta,
            onSeeStats: onSeeStats
        });
        if (launched) return;
        // A dismiss option ("Maybe later") closes the chat instead of
        // routing or saving an answer; the choice is still captured.
        if (option.dismiss) {
            (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
                eventType: "interaction",
                prompt: prompt,
                impressionUlid: impressionUlid,
                sportId: sportId,
                surface: surface,
                metadata: {
                    action: "dismiss",
                    answerValue: option.value,
                    answerLabel: option.label
                }
            });
            onClose();
            return;
        }
        setBusy(true);
        (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: prompt,
            impressionUlid: impressionUlid,
            sportId: sportId,
            surface: surface,
            metadata: {
                action: "answer_select",
                answerValue: option.value,
                answerLabel: option.label
            }
        });
        setThread((prev)=>[
                ...prev,
                {
                    kind: "user",
                    content: option.label
                }
            ]);
        if (prompt.promptType === "profile") {
            await (0, $54cda1d76057ea5a$export$a31e339227814228)(prompt.id, {
                value: option.value
            }, impressionUlid);
            setThread((prev)=>[
                    ...prev,
                    {
                        kind: "assistant",
                        content: "Got it \u2014 I'll use that to tune your recommendations."
                    }
                ]);
            setBusy(false);
            return;
        }
        setThread((prev)=>[
                ...prev,
                {
                    kind: "loading"
                }
            ]);
        const cards = await (0, $54cda1d76057ea5a$export$ad90a8b5454baf8e)({
            homePromptId: prompt.id,
            answerValue: option.value,
            impressionUlid: impressionUlid,
            ...sportName ? {
                sportName: sportName
            } : {}
        }, $ba01596fc99c49d5$var$MAX_RECOMMENDATIONS);
        setThread((prev)=>{
            const next = prev.filter((m)=>m.kind !== "loading");
            if (cards.length === 0) return [
                ...next,
                {
                    kind: "assistant",
                    content: "I couldn't find a match for that right now \u2014 try another option."
                }
            ];
            return [
                ...next,
                {
                    kind: "assistant",
                    content: "Here's what I'd start with:"
                },
                {
                    kind: "carousel",
                    cards: cards
                }
            ];
        });
        setBusy(false);
    }, [
        busy,
        impressionUlid,
        sportId,
        surface,
        prompt,
        sportName,
        onClose,
        onLaunchAssessment,
        onConnectApta,
        onConnectDupr,
        onSeeStats
    ]);
    // Play the option the user tapped in the widget, once.
    // When restoring, the thread is already populated — suppress both play-once
    // effects so the option/free-text recommendations aren't re-fetched.
    const initialPlayed = $bh6RR.useRef(Boolean(restored));
    $bh6RR.useEffect(()=>{
        if (initialPlayed.current || !initialOptionValue || !prompt) return;
        const option = prompt.options.find((o)=>o.value === initialOptionValue);
        if (option) {
            initialPlayed.current = true;
            handleSelect(option);
        }
    }, [
        initialOptionValue,
        prompt,
        handleSelect
    ]);
    /**
     * Ask a free-text question: send it along with the conversation so far, then
     * render the answer (or a graceful miss).
     *
     * This used to live inside the play-once seed effect. The composer needs
     * exactly the same behaviour on every turn, so the seed is now just the
     * first call rather than a special case.
     *
     * `seeded` marks the one ask that is already in the thread before it is
     * sent: the overlay opens showing the question the user typed in the widget.
     * That makes it both the question and, without this, its own context — so a
     * seeded ask neither echoes the user again nor carries any prior turns.
     */ const handleAsk = $bh6RR.useCallback(async (text, { seeded: seeded = false } = {})=>{
        const question = text.trim();
        if (!question || busy) return;
        // The turns as they stand BEFORE this question. `question` travels
        // as the ask itself, so including it here would hand the model its
        // own input twice, once as context for itself.
        const priorTurns = seeded ? [] : (0, $68a6ee10e198e7cf$export$9564a097b54a5c43)(thread);
        setBusy(true);
        setThread((prev)=>[
                ...prev,
                ...seeded ? [] : [
                    {
                        kind: "user",
                        content: question
                    }
                ],
                {
                    kind: "loading"
                }
            ]);
        const result = await (0, $54cda1d76057ea5a$export$8736feb2fc75242)({
            text: question,
            sportName: sportName,
            impressionUlid: impressionUlid,
            thread: priorTurns,
            conversationUlid: conversationUlid
        });
        // Every outcome carries the conversation, the misses included: a
        // question that failed is still a turn of the same conversation, and
        // a transcript handed to a human that skipped it would omit the very
        // thing that sent them there.
        if (result.conversationUlid) setConversationUlid(result.conversationUlid);
        (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: prompt,
            impressionUlid: impressionUlid,
            sportId: sportId,
            surface: surface,
            metadata: (0, $c37b1f47be1186b7$export$114308a33ac1659c)(result)
        });
        setThread((prev)=>[
                ...prev.filter((m)=>m.kind !== "loading"),
                ...(0, $c37b1f47be1186b7$export$ecfc5e94598ea38c)(result, question)
            ]);
        setBusy(false);
    }, [
        busy,
        thread,
        conversationUlid,
        sportName,
        impressionUlid,
        surface,
        prompt,
        sportId
    ]);
    // Answer the free-text request the user typed in the widget, once.
    const freeTextPlayed = $bh6RR.useRef(Boolean(restored));
    $bh6RR.useEffect(()=>{
        if (freeTextPlayed.current || !freeTextSeed) return;
        freeTextPlayed.current = true;
        handleAsk(freeTextSeed, {
            seeded: true
        });
    }, [
        freeTextSeed,
        handleAsk
    ]);
    /** Send the composer's contents as the next turn. */ const submitDraft = $bh6RR.useCallback(()=>{
        const text = draft.trim();
        if (!text || busy) return;
        setDraft("");
        handleAsk(text);
    }, [
        draft,
        busy,
        handleAsk
    ]);
    /**
     * Hand this conversation to a human.
     *
     * Tries the transcript first: an agent who can see what was already asked,
     * what we answered and which answer was rejected does not have to make
     * anyone repeat themselves. When that is unavailable — the hand-off is
     * switched off, Intercom has never seen this player, or the call failed —
     * it falls back to opening the messenger prefilled with their question,
     * which is exactly what shipped before any of this. The fallback matters
     * more than usual here: this is the moment we have already let someone
     * down once, and a dead end would be the second time.
     */ const handleEscalate = $bh6RR.useCallback((origin, question)=>{
        (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: prompt,
            impressionUlid: impressionUlid,
            sportId: sportId,
            surface: surface,
            metadata: {
                action: "support_escalate",
                source: "widget",
                origin: origin
            }
        });
        (async ()=>{
            const handedOver = conversationUlid ? await (0, $54cda1d76057ea5a$export$7bce94669212d405)(conversationUlid) : null;
            if (handedOver) // Open the messenger onto that conversation by id. A plain
            // show() lands on the messenger's cached view, which was
            // built before this conversation existed and does not
            // learn about it until a reload.
            intercom.showConversation(handedOver);
            else intercom.newMessage(question);
        })();
    }, [
        conversationUlid,
        intercom,
        prompt,
        impressionUlid,
        sportId,
        surface
    ]);
    /**
     * Record whether an answer helped, and show the choice immediately.
     *
     * The thumb is marked locally without waiting for the write: it is a
     * one-tap gesture, and making someone watch a spinner to find out whether
     * their opinion registered is worse than losing the occasional row.
     */ const handleRate = $bh6RR.useCallback((askId, helpful)=>{
        (0, $54cda1d76057ea5a$export$1721634c0ceb81c6)(askId, helpful);
        (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: prompt,
            impressionUlid: impressionUlid,
            sportId: sportId,
            surface: surface,
            metadata: {
                action: "answer_rating",
                askId: askId,
                helpful: helpful
            }
        });
        setThread((prev)=>prev.map((m)=>m.kind === "rating" && m.askId === askId ? {
                    ...m,
                    helpful: helpful
                } : m));
    }, [
        prompt,
        impressionUlid,
        sportId,
        surface
    ]);
    /**
     * The "let me try again" side of a thumb down: put the cursor in the
     * composer. We deliberately do not re-ask on the user's behalf — the whole
     * value of the retry is that it knows what was wrong, and only they can say.
     */ const handleRetry = $bh6RR.useCallback(()=>{
        composerRef.current?.focus();
    }, []);
    /**
     * Start over: drop the thread on screen and close the conversation server
     * side, so its turns stop being replayed to the models.
     *
     * Needed precisely because follow-ups carry context. Without it a user who
     * moves on to an unrelated question drags the old one along with no way to
     * say otherwise.
     *
     * Re-opens on an open question rather than the prompt. Starting over is the
     * user declining what we suggested; showing it again is the wrong reply.
     */ const handleNewChat = $bh6RR.useCallback(()=>{
        if (busy) return;
        if (conversationUlid) (0, $54cda1d76057ea5a$export$ba616d63d7d5a2d7)(conversationUlid);
        (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: prompt,
            impressionUlid: impressionUlid,
            sportId: sportId,
            surface: surface,
            metadata: {
                action: "new_chat"
            }
        });
        setConversationUlid(undefined);
        setDraft("");
        setStartedOver(true);
        setThread([
            {
                kind: "assistant",
                content: $ba01596fc99c49d5$var$NEW_CHAT_GREETING
            }
        ]);
    }, [
        busy,
        conversationUlid,
        prompt,
        impressionUlid,
        sportId,
        surface
    ]);
    const handleStart = $bh6RR.useCallback((content)=>{
        (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: prompt,
            impressionUlid: impressionUlid,
            sportId: sportId,
            surface: surface,
            metadata: {
                action: "content_tap",
                contentId: content.id,
                contentType: content.type
            }
        });
        // Persist the open chat before leaving, so backing out of the workout
        // detail restores this exact thread (and its other recommendations).
        (0, $41b2e6bb65ce7f0b$export$693f923f38b7ee97)(userId, {
            savedAt: Date.now(),
            impressionUlid: impressionUlid,
            sportId: sportId,
            prompt: prompt,
            surface: surface,
            initialOptionValue: initialOptionValue,
            freeTextSeed: freeTextSeed,
            thread: thread,
            conversationUlid: conversationUlid
        });
        onClose();
        navigate((0, $cc3a0128bb238ddf$export$fddb767f9a0c44e1)(content), {
            state: {
                source: "ask_volley"
            }
        });
    }, [
        impressionUlid,
        sportId,
        navigate,
        onClose,
        prompt,
        userId,
        initialOptionValue,
        freeTextSeed,
        thread,
        surface,
        conversationUlid
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        sx: {
            position: "fixed",
            inset: 0,
            zIndex: (t)=>t.zIndex.modal,
            bgcolor: $ba01596fc99c49d5$var$NAVY_DEEP,
            display: "flex",
            flexDirection: "column",
            color: "#fff",
            transform: mounted ? "translateY(0)" : "translateY(20px)",
            opacity: mounted ? 1 : 0,
            transition: "transform 260ms cubic-bezier(.2,.8,.2,1), opacity 220ms ease-out"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $e7ad11bb0f30ef0e$export$2e2bcd8739ae039), {
                status: $ba01596fc99c49d5$var$headerStatus(Boolean(prompt), startedOver),
                canClear: thread.length > 1,
                busy: busy,
                onNewChat: handleNewChat,
                onClose: onClose
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                ref: threadRef,
                sx: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: "auto",
                    overflowX: "hidden",
                    py: 2
                },
                children: thread.map((message, i)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $3790b426c3116030$export$2e2bcd8739ae039), {
                        message: message,
                        onStart: handleStart,
                        onBrowseAll: handleBrowseAll,
                        onRate: handleRate,
                        onRetry: handleRetry,
                        onEscalate: handleEscalate
                    }, `${message.kind}-${i}`))
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $748abb3592c3b3a7$export$2e2bcd8739ae039), {
                inputRef: composerRef,
                value: draft,
                onChange: setDraft,
                onSubmit: submitDraft,
                busy: busy
            })
        ]
    });
}






var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");
parcelRequire("cFAEN");
var $cK0UE = parcelRequire("cK0UE");

var $cK0UE = parcelRequire("cK0UE");

var $60TOG = parcelRequire("60TOG");

var $7uFU8 = parcelRequire("7uFU8");

var $g6rVl = parcelRequire("g6rVl");

function $a7bc24707d3d7752$export$a438bae8ee6b34ea() {
    const navigate = (0, $as544.useNavigate)();
    const { openStart: openStart, dialog: dialog } = (0, $60TOG.useAssessmentStart)();
    const { activeJourneys: activeJourneys, registerJourneyLinkIntent: registerJourneyLinkIntent } = (0, $g6rVl.default)();
    // Resume the user's in-progress assessment directly, returning false when
    // there is none to resume (so the caller can fall back to starting one).
    const resumeInProgressAssessment = $bh6RR.useCallback(async ()=>{
        const instance = activeJourneys.find((j)=>j.journey.type === "assessment");
        if (!instance) return false;
        // Single-workout assessment: go straight to play. Intent must be
        // registered first so the play links back to this journey slot.
        if (instance.workoutsPlays.length === 1) {
            const aw = instance.workoutsPlays[0].appWorkout;
            await registerJourneyLinkIntent(instance.ulid, aw.id);
            navigate(`/content/apps/workouts/plugin/play/${aw.appId}/${aw.id}`);
            return true;
        }
        // Multi-workout assessment: resume on the in-progress page.
        navigate((0, $7uFU8.inProgressUrl)({
            journeyType: "assessment",
            journeyInstanceId: instance.id,
            journeyInstanceUlid: instance.ulid
        }));
        return true;
    }, [
        activeJourneys,
        registerJourneyLinkIntent,
        navigate
    ]);
    // Open the start dialog for the sport's all-skills assessment.
    const startAllSkillsAssessment = $bh6RR.useCallback(async (sport)=>{
        try {
            const res = await (0, $cK0UE.default)(`/api/journeys/performance/v2/recommended-assessments?sport=${sport}`);
            if (res.allSkillsAssessment) {
                openStart(res.allSkillsAssessment.journeyId);
                return;
            }
            // Only pickleball has a released all-skills assessment, so for
            // every other sport this is the normal outcome, not an error.
            // Land on the assessments list rather than doing nothing, which
            // reads as a broken chip.
            navigate((0, $a80a94320a991500$export$de3715c89a541648));
        } catch (err) {
            (0, $cK0UE.logFetchError)(err, "Failed to load the all-skills assessment");
            navigate((0, $a80a94320a991500$export$de3715c89a541648));
        }
    }, [
        openStart,
        navigate
    ]);
    const launchAssessment = $bh6RR.useCallback(async (option, sport)=>{
        if (option.value === (0, $a80a94320a991500$export$13daccba1fc24702)) {
            const resumed = await resumeInProgressAssessment();
            if (resumed) return;
        // Nothing in progress (state drifted since the prompt was
        // served): fall through to offering a fresh assessment.
        }
        await startAllSkillsAssessment(sport);
    }, [
        resumeInProgressAssessment,
        startAllSkillsAssessment
    ]);
    return {
        launchAssessment: launchAssessment,
        dialog: dialog
    };
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $5CVHy = parcelRequire("5CVHy");

var $dUgAK = parcelRequire("dUgAK");

var $1W9Do = parcelRequire("1W9Do");

var $cbFbS = parcelRequire("cbFbS");

var $cK0UE = parcelRequire("cK0UE");

var $g0YYy = parcelRequire("g0YYy");

var $jP5af = parcelRequire("jP5af");
function $2306f394fbe75dd1$export$a195d94d08cd882e(options) {
    const [open, setOpen] = $bh6RR.useState(false);
    const [ssoConfig, setSsoConfig] = $bh6RR.useState(null);
    // Fetch the config at most once, and only after the user opts in — the
    // profile prompt is just one of many, so we don't pay for it up front.
    const requested = $bh6RR.useRef(false);
    const launchDuprConnect = $bh6RR.useCallback(()=>{
        setOpen(true);
        if (requested.current) return;
        requested.current = true;
        (0, $cK0UE.default)("/api/integrations/dupr/config").then(setSsoConfig).catch((0, $cK0UE.logFetchError));
    }, []);
    const onClose = options?.onClose;
    const handleClose = $bh6RR.useCallback(()=>{
        setOpen(false);
        onClose?.();
    }, [
        onClose
    ]);
    const dialog = /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dUgAK.default), {
        open: open,
        onClose: handleClose,
        fullWidth: true,
        maxWidth: "sm",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                onClose: handleClose,
                children: "Connect your DUPR\xae rating"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                dividers: true,
                children: !ssoConfig ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                    display: "flex",
                    justifyContent: "center",
                    py: 3,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {})
                }) : ssoConfig.enabled ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $g0YYy.default), {
                    ssoConfig: ssoConfig
                }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "body2",
                    color: "text.secondary",
                    children: "DUPR connection isn't available right now."
                })
            })
        ]
    });
    return {
        launchDuprConnect: launchDuprConnect,
        dialog: dialog
    };
}


function $bedbc14e43525c03$export$2e2bcd8739ae039() {
    const navigate = (0, $as544.useNavigate)();
    const { currentUser: currentUser } = (0, $W4f7l.useCurrentUser)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { selected: sport, getIdFromSport: getIdFromSport } = (0, $76QOg.useSelectedSport)();
    const userId = currentUser?.id;
    const { launchAssessment: launchAssessment, dialog: assessmentDialog } = (0, $a7bc24707d3d7752$export$a438bae8ee6b34ea)();
    const { launchDuprConnect: launchDuprConnect, dialog: duprDialog } = (0, $2306f394fbe75dd1$export$a195d94d08cd882e)();
    const sportId = $bh6RR.useMemo(()=>{
        try {
            return getIdFromSport(sport);
        } catch  {
            return undefined;
        }
    }, [
        getIdFromSport,
        sport
    ]);
    // A chat left to open a workout or an article, if it was left from here.
    // Read once on mount and consumed, exactly as the widget does: re-reading
    // it on every render would re-restore a chat the user has moved past.
    const [restored] = $bh6RR.useState(()=>{
        const snapshot = (0, $41b2e6bb65ce7f0b$export$8169690c1ed1afde)(userId);
        if (snapshot?.surface !== (0, $54cda1d76057ea5a$export$fb4230faa4b8183a)) return undefined;
        (0, $41b2e6bb65ce7f0b$export$a4b3eaeabef16fd2)(userId);
        return snapshot;
    });
    // One impression per visit, reused by the restored chat so a round trip
    // through a workout stays one session rather than reading as two.
    const [impressionUlid] = $bh6RR.useState(()=>restored?.impressionUlid ?? (0, $b645fccf57198abf$export$c34778236461ea95)());
    // A restored chat is a continuation, not a new arrival: recording a second
    // impression for it would count one visit twice.
    const impressionRecorded = $bh6RR.useRef(Boolean(restored));
    $bh6RR.useEffect(()=>{
        if (impressionRecorded.current) return;
        impressionRecorded.current = true;
        (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "impression",
            impressionUlid: impressionUlid,
            sportId: sportId,
            surface: (0, $54cda1d76057ea5a$export$fb4230faa4b8183a),
            metadata: {
                action: "open"
            }
        });
    }, [
        impressionUlid,
        sportId
    ]);
    // Back to wherever they came from. `navigate(-1)` rather than a fixed home
    // route: the launcher is reachable from every screen, and dumping someone
    // on the home screen because they asked a question would lose their place.
    const handleClose = $bh6RR.useCallback(()=>{
        (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            impressionUlid: impressionUlid,
            sportId: sportId,
            surface: (0, $54cda1d76057ea5a$export$fb4230faa4b8183a),
            metadata: {
                action: "overlay_close"
            }
        });
        navigate(-1);
    }, [
        impressionUlid,
        navigate,
        sportId
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ba01596fc99c49d5$export$2e2bcd8739ae039), {
                impressionUlid: impressionUlid,
                surface: (0, $54cda1d76057ea5a$export$fb4230faa4b8183a),
                sportName: sport,
                sportId: sportId,
                restored: restored ? {
                    thread: restored.thread,
                    conversationUlid: restored.conversationUlid
                } : undefined,
                onClose: handleClose,
                // These four are the prompt's own escape hatches — an option
                // that launches the assessment, links a rating, or opens the
                // dashboard instead of answering. Nothing here can reach them
                // (there are no options without a prompt), but the overlay
                // takes them as required props and wiring them to the real
                // flows is more honest than passing four no-ops that would
                // silently do nothing if an option ever did arrive.
                onLaunchAssessment: (option)=>{
                    launchAssessment(option, sport);
                },
                onConnectDupr: ()=>launchDuprConnect(),
                onConnectApta: ()=>setDialogType("APTAId"),
                onSeeStats: ()=>navigate((0, $a80a94320a991500$export$59b2f70a1d4214ae)(sport))
            }),
            assessmentDialog,
            duprDialog
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $b7oAt = parcelRequire("b7oAt");

var $9SkSI = parcelRequire("9SkSI");

var $1d1FK = parcelRequire("1d1FK");

var $hL9jN = parcelRequire("hL9jN");

var $4rInl = parcelRequire("4rInl");

var $2J49z = parcelRequire("2J49z");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");
function $9ff02201f931f065$export$2e2bcd8739ae039() {
    const [queryParams] = (0, $as544.useSearchParams)();
    const navigate = (0, $as544.useNavigate)();
    $bh6RR.useEffect(()=>{
        const mode = queryParams.get("mode");
        const code = queryParams.get("oobCode");
        const apiKey = queryParams.get("apiKey");
        if (mode === "resetPassword") navigate("/auth/reset-password", {
            state: {
                code: code,
                apiKey: apiKey
            }
        });
    }, [
        queryParams,
        navigate
    ]);
    // we shouldn't get here, but if we do navigate to root
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Navigate), {
        to: "/",
        replace: true
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $dUgAK = parcelRequire("dUgAK");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $j5ldk = parcelRequire("j5ldk");

var $5Z0If = parcelRequire("5Z0If");

var $8JNI1 = parcelRequire("8JNI1");

var $hrqHU = parcelRequire("hrqHU");

var $cbFbS = parcelRequire("cbFbS");

var $aOb5j = parcelRequire("aOb5j");
parcelRequire("eyjy7");
var $fgDKG = parcelRequire("fgDKG");

var $jP5af = parcelRequire("jP5af");

var $3iMZv = parcelRequire("3iMZv");
function $a4b3c5d608d5212f$export$2e2bcd8739ae039() {
    const navigate = (0, $as544.useNavigate)();
    const theme = (0, $aOb5j.default)();
    const [email, setEmail] = $bh6RR.useState("");
    const [loading, setLoading] = $bh6RR.useState(false);
    const [dialogOpen, setDialogOpen] = $bh6RR.useState(false);
    const [error, setError] = $bh6RR.useState("");
    const onSubmit = $bh6RR.useCallback(async (e)=>{
        e.preventDefault();
        setLoading(true);
        setError("");
        const auth = (0, $fgDKG.p)();
        try {
            await (0, $fgDKG.a6)(auth, email);
            setDialogOpen(true);
        } catch  {
            setError("There was an error sending the password reset email.");
        } finally{
            setLoading(false);
        }
    }, [
        email
    ]);
    const onChangeEmail = $bh6RR.useCallback((e)=>{
        e.preventDefault();
        setEmail(e.currentTarget.value);
    }, []);
    const onDialogConfirm = $bh6RR.useCallback(()=>{
        setDialogOpen(false);
        navigate("/login");
    }, [
        navigate
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                variant: "h3",
                component: "h2",
                children: "Forgot your Password?"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ldk.default), {
                sx: {
                    my: 2
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                variant: "body1",
                mb: 2,
                children: "Enter the email address associated with your Volley account and we'll send you instructions to reset your password"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                spacing: 4,
                component: "form",
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hrqHU.default), {
                        type: "email",
                        autoComplete: "email",
                        name: "email",
                        label: "Email",
                        placeholder: "Email address",
                        value: email,
                        onChange: onChangeEmail,
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $3iMZv.VolleyButton), {
                        type: "submit",
                        disabled: loading || !/^\S+@\S+\.\S+$/.test(email),
                        children: "Continue"
                    }),
                    error && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "body2",
                        color: "error.main",
                        children: error
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dUgAK.default), {
                open: dialogOpen,
                disableEscapeKeyDown: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                        onClose: onDialogConfirm,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "h4",
                            children: "Password Reset Sent"
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                        dividers: true,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                                variant: "body2",
                                my: 2,
                                align: "center",
                                color: "black",
                                children: "A link to reset your password has been sent to your email address. After you reset your password, proceed with login."
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $3iMZv.VolleyButton), {
                                onClick: onDialogConfirm,
                                children: "Back to login"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                                variant: "caption",
                                component: "div",
                                sx: {
                                    mt: 2
                                },
                                textAlign: "center",
                                children: [
                                    "Didn\u2019t see the email? Even in spam?",
                                    " ",
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $5Z0If.default), {
                                        color: theme.palette.info.main,
                                        underline: "none",
                                        component: "button",
                                        onClick: ()=>setDialogOpen(false),
                                        sx: {
                                            cursor: "pointer",
                                            fontWeight: "bold"
                                        },
                                        children: "Send again."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $dUgAK = parcelRequire("dUgAK");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $j5ldk = parcelRequire("j5ldk");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $9k0Bn = parcelRequire("9k0Bn");
parcelRequire("eyjy7");
var $fgDKG = parcelRequire("fgDKG");

var $jP5af = parcelRequire("jP5af");

var $7S0DI = parcelRequire("7S0DI");

var $3iMZv = parcelRequire("3iMZv");
function $fa7442e0ab220243$export$2e2bcd8739ae039() {
    const location = (0, $as544.useLocation)();
    const state = location.state;
    const navigate = (0, $as544.useNavigate)();
    const [password, setPassword] = $bh6RR.useState("");
    const [verified, setVerified] = $bh6RR.useState(false);
    const [loading, setLoading] = $bh6RR.useState(false);
    const [verificationError, setVerificationError] = $bh6RR.useState("");
    const [resetError, setResetError] = $bh6RR.useState("");
    const [dialogOpen, setDialogOpen] = $bh6RR.useState(false);
    $bh6RR.useEffect(()=>{
        async function verifyCode(c) {
            const auth = (0, $fgDKG.p)();
            try {
                await (0, $fgDKG.aa)(auth, c);
                setVerified(true);
            } catch (e) {
                setVerified(false);
                if (e instanceof (0, $9k0Bn.FirebaseError)) switch(e.code){
                    case "auth/expired-action-code":
                        setVerificationError("Code is expired.");
                        break;
                    case "auth/invalid-action-code":
                        setVerificationError("Invalid or used code.");
                        break;
                    default:
                        setVerificationError("Error reseting your password.");
                        break;
                }
                else // generic error
                setVerificationError("Error reseting your password.");
            }
        }
        const code = state?.code ?? "";
        verifyCode(code);
    }, [
        state
    ]);
    const formValid = $bh6RR.useMemo(()=>password && verified && !verificationError, [
        password,
        verified,
        verificationError
    ]);
    const onSubmit = $bh6RR.useCallback(async (e)=>{
        e.preventDefault();
        setLoading(true);
        const auth = (0, $fgDKG.p)();
        const code = state?.code;
        try {
            setResetError("");
            await (0, $fgDKG.a7)(auth, code, password);
            setDialogOpen(true);
        } catch  {
            setResetError("Error resetting your password.");
        } finally{
            setLoading(false);
        }
    }, [
        password,
        state
    ]);
    if (verificationError) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
        color: "error.main",
        children: verificationError
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                variant: "h3",
                component: "h2",
                children: "Choose a new password"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ldk.default), {
                sx: {
                    my: 2
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                variant: "body2",
                mb: 2,
                children: "Please enter a new password."
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                spacing: 4,
                component: "form",
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $7S0DI.default), {
                        onPasswordChange: setPassword
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $3iMZv.VolleyButton), {
                        type: "submit",
                        disabled: !formValid || loading,
                        children: "Reset"
                    }),
                    resetError && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "body2",
                        color: "error.main",
                        children: resetError
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dUgAK.default), {
                open: dialogOpen,
                disableEscapeKeyDown: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                        onClose: ()=>navigate("/"),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "h4",
                            children: "Password Reset"
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                        dividers: true,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                                variant: "body2",
                                mb: 2,
                                align: "center",
                                color: "black",
                                children: "Your password has been reset. You can now log in."
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $3iMZv.VolleyButton), {
                                onClick: ()=>navigate("/"),
                                children: "OK"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



const $bccf3362d6ee201b$var$volleyIconImg = new URL((parcelRequire("4UKpm"))).toString();
function $bccf3362d6ee201b$export$2e2bcd8739ae039() {
    const navigate = (0, $as544.useNavigate)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $9SkSI.default), {
                sx: {
                    zIndex: (theme)=>theme.zIndex.drawer + 1,
                    flexGrow: 1
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $2J49z.default), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                            size: "large",
                            edge: "start",
                            color: "inherit",
                            "aria-label": "back",
                            sx: {
                                mr: 2
                            },
                            onClick: ()=>navigate("/"),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b7oAt.default), {})
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                            size: "large",
                            edge: "start",
                            color: "inherit",
                            "aria-label": "back",
                            sx: {
                                m: 0,
                                p: 0,
                                flexGrow: 1,
                                // to center volley icon, remove space back button takes
                                ml: "-60px"
                            },
                            component: (0, $as544.Link),
                            to: "/",
                            children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                src: $bccf3362d6ee201b$var$volleyIconImg,
                                width: "130",
                                alt: "Volley logo"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                component: "main",
                sx: {
                    my: 4
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $hL9jN.default), {
                    maxWidth: "xs",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $2J49z.default), {}),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $as544.Routes), {
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                                    path: "/action",
                                    element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9ff02201f931f065$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                                    path: "/forgot-password",
                                    element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $a4b3c5d608d5212f$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                                    path: "/reset-password",
                                    element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fa7442e0ab220243$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                                    path: "*",
                                    element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Navigate), {
                                        replace: true,
                                        to: "/"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $4Athc = parcelRequire("4Athc");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $6zj3p = parcelRequire("6zj3p");
function $981e9ff21606e8b5$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $4Athc.default), {
        sx: {
            p: 2,
            minHeight: "90vh"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
            spacing: 3,
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h3",
                    component: "h1",
                    children: "Ball Cabinet Unlock"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    children: "If your club has a locking Volley cabinet, use the following code to access the batteries and balls:"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    align: "center",
                    sx: {
                        letterSpacing: 30,
                        fontFamily: "monospace",
                        fontSize: "5rem"
                    },
                    children: "717"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h5",
                    component: "h2",
                    children: "Enter the code on the lock face:"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                    sx: {
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                        src: (0, $6zj3p.default)("instructions/cabinet-locked.jpg"),
                        alt: "Cabinet lock face showing code dials",
                        style: {
                            maxWidth: "100%",
                            height: "auto"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h5",
                    component: "h2",
                    children: "Twist lock to the right and open doors:"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                    sx: {
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                        src: (0, $6zj3p.default)("instructions/cabinet-unlocked.jpg"),
                        alt: "Cabinet doors open showing contents",
                        style: {
                            maxWidth: "100%",
                            height: "auto"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    sx: {
                        mt: 2
                    },
                    children: "Please be sure to re-lock the cabinet after your session by twisting the lock back to the original position and changing the numbers on the dials away from the code."
                })
            ]
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $eedE5 = parcelRequire("eedE5");

var $5CVHy = parcelRequire("5CVHy");

var $hL9jN = parcelRequire("hL9jN");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");
parcelRequire("cFAEN");
var $cK0UE = parcelRequire("cK0UE");

var $cK0UE = parcelRequire("cK0UE");

var $W4f7l = parcelRequire("W4f7l");
const $3b0ab500972ae70c$var$FAILURE_MESSAGES = {
    not_found: "We couldn't find that code. Check the link and try again.",
    not_journey: "This link isn't for an assessment.",
    expired: "This code has expired. Ask whoever ran your assessment for a new one.",
    used: "This code has already been used.",
    already_claimed: "This assessment is already on a Volley account.",
    wrong_player: "This assessment belongs to a different Volley account.",
    own_run: "You ran this assessment. Have the player scan the code to claim it.",
    unfinished: "This assessment isn't finished yet. Ask whoever ran it to finish it and show you a new code."
};
function $3b0ab500972ae70c$var$failureMessage(e) {
    if (e instanceof (0, $cK0UE.FetchError)) {
        const reason = e.body?.reason;
        if (reason && reason in $3b0ab500972ae70c$var$FAILURE_MESSAGES) return $3b0ab500972ae70c$var$FAILURE_MESSAGES[reason];
    }
    return "Something went wrong claiming your assessment. Try again in a moment.";
}
function $3b0ab500972ae70c$export$2e2bcd8739ae039() {
    const { code: code = "" } = (0, $as544.useParams)();
    const navigate = (0, $as544.useNavigate)();
    const { currentUser: currentUser, authState: authState } = (0, $W4f7l.useCurrentUser)();
    const [error, setError] = $bh6RR.useState();
    const attempted = $bh6RR.useRef(false);
    $bh6RR.useEffect(()=>{
        if (!currentUser || attempted.current) return;
        attempted.current = true;
        (0, $cK0UE.default)(`/api/invites/${encodeURIComponent(code)}/redeem`, "POST").then(({ journeyInstanceUlid: journeyInstanceUlid })=>{
            // ShareSnackbar on the home screen announces it and links
            // to the result.
            navigate("/", {
                replace: true,
                state: {
                    journeyInstanceShareUlid: journeyInstanceUlid
                }
            });
        }).catch((e)=>{
            if (!(e instanceof (0, $cK0UE.FetchError)) || e.statusCode >= 500) (0, $cK0UE.logFetchError)(e);
            setError($3b0ab500972ae70c$var$failureMessage(e));
        });
    }, [
        code,
        currentUser,
        navigate
    ]);
    let body;
    if (authState === (0, $W4f7l.AuthState).LOADING || currentUser && !error) body = /*#__PURE__*/ (0, $ih19M.jsx)((0, $8JNI1.default), {
        alignItems: "center",
        sx: {
            py: 4
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {})
    });
    else if (error) body = /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
        spacing: 2,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                children: error
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                variant: "contained",
                component: (0, $as544.Link),
                to: "/",
                children: "Go to Volley"
            })
        ]
    });
    else body = /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
        spacing: 2,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                children: "Your assessment results are waiting. Create a free Volley account, or log in, and we'll add them to your account."
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                variant: "contained",
                size: "large",
                component: (0, $as544.Link),
                to: `/signup/email?invite=${encodeURIComponent(code)}`,
                children: "Create account"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                variant: "outlined",
                size: "large",
                component: (0, $as544.Link),
                to: "/login",
                state: {
                    from: `/claim/${encodeURIComponent(code)}`
                },
                children: "I have an account"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $hL9jN.default), {
        maxWidth: "xs",
        sx: {
            py: 6
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
            spacing: 3,
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h3",
                    component: "h1",
                    children: "Claim your assessment"
                }),
                body
            ]
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $dUgAK = parcelRequire("dUgAK");

var $gIiKg = parcelRequire("gIiKg");

var $1lMle = parcelRequire("1lMle");

var $1lMle = parcelRequire("1lMle");
function $82c981ccb1aeb53c$export$adda08d0816d149a(fault, trainerFeatures) {
    if (!fault) return false;
    if (!trainerFeatures.includes("powerUpAutoCalibrate")) {
        (0, $1lMle.default).debug("Trainer doesn't support required APIs for tilt calibration failure");
        return false;
    }
    const match = fault.failures.find((failure)=>Object.hasOwn(failure.context, "motionFault") && failure.context.motionFault.type === "CalibrationRange" && failure.context.motionFault.failures.some((f)=>f.name === "Tilt"));
    if (!match) return false;
    (0, $1lMle.default).info("Found CalibrationRange failure for Tilt Servo");
    return true;
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $ltQuT = parcelRequire("ltQuT");

var $eedE5 = parcelRequire("eedE5");

var $5CVHy = parcelRequire("5CVHy");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $5Z0If = parcelRequire("5Z0If");

var $iZWBy = parcelRequire("iZWBy");

var $kclvT = parcelRequire("kclvT");

var $hrqHU = parcelRequire("hrqHU");

var $cK0UE = parcelRequire("cK0UE");

var $62tuQ = parcelRequire("62tuQ");
/**
 * APTA numbers are issued as `XX-XXXXX` — two digits, a hyphen, five more.
 *
 * Players get theirs by copying it off the APTA member lookup page, and the
 * hyphen does not always survive the trip: on 2026-09-10 the server rejected
 * `1408192`, `1406893`, `1399118`, `1401381` and `1701196` inside one hour,
 * every one of them a real number that had lost its separator. Each of those
 * cost a round trip to APTA before coming back "Invalid APTA ID", so the shape
 * is worth settling in the browser.
 */ /** The canonical form, for display and for what we send to the server. */ const $0e22788e7a0d8ba6$var$APTA_DIGITS = 7;
function $0e22788e7a0d8ba6$export$f3529b71477cacc7(raw) {
    const digits = raw.replace(/\D/g, "");
    if (digits.length !== $0e22788e7a0d8ba6$var$APTA_DIGITS) return null;
    return `${digits.slice(0, 2)}-${digits.slice(2)}`;
}
function $0e22788e7a0d8ba6$export$44d8a815c6bcf68f(raw) {
    return $0e22788e7a0d8ba6$export$f3529b71477cacc7(raw) !== null;
}
function $0e22788e7a0d8ba6$export$a31238088378fc26(raw) {
    if (raw.trim() === "") return null;
    if ($0e22788e7a0d8ba6$export$44d8a815c6bcf68f(raw)) return null;
    const digits = raw.replace(/\D/g, "").length;
    if (digits < $0e22788e7a0d8ba6$var$APTA_DIGITS) return "An APTA number has 7 digits, like 21-02826.";
    return "That looks like too many digits \u2014 an APTA number is 7, like 21-02826.";
}



var $58g7B = parcelRequire("58g7B");
function $20d3319373ec90b8$export$3c40a5df05cde92b({ cancelText: cancelText = "Cancel" }) {
    const navigate = (0, $as544.useNavigate)();
    const { onClose: onClose, setDialogType: setDialogType } = (0, $62tuQ.default)();
    const [aptaId, setAptaId] = $bh6RR.useState("");
    const [errorMessage, setErrorMessage] = $bh6RR.useState("");
    const [submitting, setSubmitting] = $bh6RR.useState(false);
    // Canonical `XX-XXXXX`, or null while what they have typed cannot be one.
    // Normalising here rather than at submit means a pasted number that lost
    // its hyphen enables the button instead of failing a round trip later.
    const normalizedId = (0, $0e22788e7a0d8ba6$export$f3529b71477cacc7)(aptaId);
    const onSubmit = $bh6RR.useCallback(async (e)=>{
        e.preventDefault();
        // Registration can take seconds on a slow connection, and the
        // dialog gave no feedback while it ran - users read that as a dead
        // button and tapped again, registering several times (issue #8321).
        if (submitting) return;
        if (!normalizedId) {
            setErrorMessage("Enter your 7-digit APTA number, like 21-02826.");
            return;
        }
        setSubmitting(true);
        setErrorMessage("");
        let playerId;
        try {
            const res = await (0, $cK0UE.default)("/api/pti/register", "POST", {
                aptaPlayerId: normalizedId
            }, // Registering verifies the number against APTA, so this is
            // a cold read like the stats below it and cannot live
            // inside the 10s default.
            (0, $58g7B.aptaReadInit)());
            ({ playerId: playerId } = res);
        } catch (err) {
            (0, $cK0UE.logFetchError)(err, "APTA registration failed");
            setErrorMessage((0, $cK0UE.userFacingFetchMessage)(err, "We couldn't verify that APTA number right now. Please try again in a moment."));
            setSubmitting(false);
            return;
        }
        setDialogType(null);
        navigate("/player-pti", {
            state: {
                aptaPlayerId: parseInt(playerId, 10)
            }
        });
    }, [
        normalizedId,
        navigate,
        setDialogType,
        submitting
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        align: "left",
                        fontWeight: "bold",
                        fontSize: 16,
                        children: "Link your APTA Account to receive more personalized content, monitor PTI and view all your match stats."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hrqHU.default), {
                        autoFocus: true,
                        required: true,
                        margin: "dense",
                        label: "APTA Number",
                        name: "aptaId",
                        id: "aptaId",
                        value: aptaId,
                        disabled: submitting,
                        onChange: (e)=>{
                            setAptaId(e.currentTarget.value);
                            // Clear a stale rejection as soon as they start
                            // fixing it, rather than leaving the field red while
                            // they type a number that is now fine.
                            setErrorMessage("");
                        },
                        helperText: errorMessage || (0, $0e22788e7a0d8ba6$export$a31238088378fc26)(aptaId) || " ",
                        error: !!errorMessage,
                        fullWidth: true,
                        variant: "outlined"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $hHL9O.default), {
                        align: "left",
                        children: [
                            "To Obtain Your APTA Number:",
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $iZWBy.default), {
                                component: "ol",
                                type: "1",
                                dense: true,
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $kclvT.default), {
                                        sx: {
                                            display: "list-item",
                                            listStyleType: "decimal",
                                            listStylePosition: "inside"
                                        },
                                        children: [
                                            "Follow this link to the APTA site:\xa0",
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $5Z0If.default), {
                                                href: "https://www.platformtennisonline.org/MemberNumberLookup.aspx",
                                                target: "_blank",
                                                children: "LINK"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
                                        sx: {
                                            display: "list-item",
                                            listStyleType: "decimal",
                                            listStylePosition: "inside"
                                        },
                                        children: "Search for your name"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
                                        sx: {
                                            display: "list-item",
                                            listStyleType: "decimal",
                                            listStylePosition: "inside"
                                        },
                                        children: "Select your name from the results"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
                                        sx: {
                                            display: "list-item",
                                            listStyleType: "decimal",
                                            listStylePosition: "inside"
                                        },
                                        children: "Copy the APTA Number (XX-XXXXX) to the text box above"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
                                        sx: {
                                            display: "list-item",
                                            listStyleType: "decimal",
                                            listStylePosition: "inside"
                                        },
                                        children: "Submit"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
                                        sx: {
                                            display: "list-item",
                                            listStyleType: "decimal",
                                            listStylePosition: "inside"
                                        },
                                        children: "View your PTI stats by scrolling to the bottom of the app homepage"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bK42r.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                        type: "button",
                        onClick: ()=>onClose(),
                        children: cancelText
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                        variant: "contained",
                        color: "secondary",
                        startIcon: submitting ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                            size: 20,
                            color: "inherit"
                        }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $ltQuT.default), {}),
                        disabled: !normalizedId || submitting,
                        onClick: onSubmit,
                        children: submitting ? "Submitting\u2026" : "Submit"
                    })
                ]
            })
        ]
    });
}
function $20d3319373ec90b8$export$be80556e231894c4() {
    return /*#__PURE__*/ (0, $ih19M.jsx)($20d3319373ec90b8$export$3c40a5df05cde92b, {
        cancelText: "Skip for Now"
    });
}



var $W4f7l = parcelRequire("W4f7l");

var $4xl3n = parcelRequire("4xl3n");

var $ezs3H = parcelRequire("ezs3H");

var $NbKWd = parcelRequire("NbKWd");

var $lfvqn = parcelRequire("lfvqn");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1lMle = parcelRequire("1lMle");

var $68A8d = parcelRequire("68A8d");

var $cK0UE = parcelRequire("cK0UE");

var $4xl3n = parcelRequire("4xl3n");

var $ezs3H = parcelRequire("ezs3H");

var $lfvqn = parcelRequire("lfvqn");
const $dfce5f3c74840ea7$export$c58da0618ccd7928 = /*#__PURE__*/ $bh6RR.createContext({
    availableBuilds: null,
    buildsReadyToInstall: false,
    hasAvailableBuilds: false,
    showAvailableUpdate: null,
    updateRequired: false,
    versionString: ""
});
function $dfce5f3c74840ea7$export$559156530d829ebd({ children: children }) {
    const { status: status } = (0, $ezs3H.useStatus)();
    const trainerFeatures = (0, $lfvqn.useTrainerFeatures)();
    const { status: pairingStatus } = (0, $4xl3n.usePairingContext)();
    const [availableBuilds, setAvailableBuilds] = $bh6RR.useState(null);
    const checkVersion = $bh6RR.useCallback(async ()=>{
        if (status?.clientId) try {
            const builds = await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/update/check-version");
            if (builds) setAvailableBuilds(builds);
        } catch (e) {
            (0, $cK0UE.logFetchError)(e);
        }
    }, [
        status?.clientId
    ]);
    // Check version on mount and when pairing status changes, but only if we're paired
    $bh6RR.useEffect(()=>{
        if (pairingStatus === "paired") checkVersion().catch(()=>{
            (0, $1lMle.default).error("Could not check version");
        });
    }, [
        checkVersion,
        pairingStatus
    ]);
    const buildsReadyToInstall = $bh6RR.useMemo(()=>{
        if (!status?.update?.systems) return false;
        const controlUpdateStatus = status.update.systems.control;
        const visionUpdateStatus = status.update.systems.vision;
        if (!controlUpdateStatus || !visionUpdateStatus) return false;
        const downloaded = controlUpdateStatus.readyToInstall && visionUpdateStatus.readyToInstall;
        const outOfDate = controlUpdateStatus.outOfDate || visionUpdateStatus.outOfDate;
        // we can't know if the vision software is out of date if we don't know the version
        if (status.vision.visionSoftwareVersion === "Unknown") return false;
        // `outOfDate` will be wrong for 3.10.1 trainers because the `name` of builds
        // was changed to use control style software labels instead of version strings,
        // however the version reported by vision is still using version strings.
        //
        // check if the next build is a valid build label and the current build is not
        // if so, we need to convert the next build label to a version string and compare
        if (visionUpdateStatus.next && visionUpdateStatus.current && (0, $68A8d.isValidBuildLabel)(visionUpdateStatus.next) && !(0, $68A8d.isValidBuildLabel)(visionUpdateStatus.current)) {
            const versionStringNext = (0, $68A8d.buildLabelToVersionString)(visionUpdateStatus.next);
            return downloaded && versionStringNext !== visionUpdateStatus.current;
        }
        return downloaded && !!outOfDate;
    }, [
        status?.update?.systems,
        status?.vision?.visionSoftwareVersion
    ]);
    const updateRequired = $bh6RR.useMemo(()=>{
        // If there are no available builds, we can't determine if an update is required
        if (!availableBuilds) return false;
        let controlRequiresUpdate = false;
        if (availableBuilds.minSupported.control && status?.softwareBuildLabel) {
            const components = (0, $68A8d.expandLabelToComponents)(status.softwareBuildLabel);
            const version = `${components.major}.${components.minor}.${components.patch}`;
            const minComponents = (0, $68A8d.expandLabelToComponents)(availableBuilds.minSupported.control);
            const minVersion = `${minComponents.major}.${minComponents.minor}.${minComponents.patch}`;
            try {
                controlRequiresUpdate = (0, $68A8d.isVersionGreater)(minVersion, version);
            } catch  {
                (0, $1lMle.default).error("Error comparing control versions", {
                    minVersion: minVersion,
                    version: version
                });
            }
        }
        let visionRequiresUpdate = false;
        if (availableBuilds.minSupported.vision && status?.vision?.visionSoftwareVersion) try {
            visionRequiresUpdate = (0, $68A8d.isVersionGreater)(availableBuilds.minSupported.vision, status.vision.visionSoftwareVersion);
        } catch  {
            (0, $1lMle.default).error("Error comparing vision versions", {
                minVersion: availableBuilds.minSupported.vision,
                version: status.vision.visionSoftwareVersion
            });
        }
        return controlRequiresUpdate || visionRequiresUpdate;
    }, [
        availableBuilds,
        status?.softwareBuildLabel,
        status?.vision?.visionSoftwareVersion
    ]);
    const showAvailableUpdate = $bh6RR.useMemo(()=>{
        if (!status?.update?.systems) return false;
        // This could be due to a fault or the vision computer is not fully up and running yet
        if (status?.vision?.visionSoftwareVersion?.toLocaleLowerCase() === "unknown") return false;
        const { control: control, vision: vision } = status.update.systems;
        if (!control || !vision) return false;
        const isControlUpdateReady = control.outOfDate && control.readyToInstall;
        const isVisionUpdateReady = vision.outOfDate && vision.readyToInstall;
        const isUserUpdateSupported = trainerFeatures.includes("userUpdate");
        return isControlUpdateReady && isVisionUpdateReady && isUserUpdateSupported;
    }, [
        status,
        trainerFeatures
    ]);
    const hasAvailableBuilds = $bh6RR.useMemo(()=>{
        if (!availableBuilds || !status) return false;
        const { active: { control: control, vision: vision } } = availableBuilds;
        if (control !== null && control !== status.softwareBuildLabel) return true;
        if (vision !== null) {
            // `vision` is the active build's name, which is an encoded build
            // label, while vision reports its current version as a version
            // string (e.g. "4.2.8"). Comparing the two directly is always
            // unequal, which falsely reports an available update on a
            // fully-updated trainer. Decode the label to a version string
            // before comparing (same reasoning as `buildsReadyToInstall`, #6001).
            const activeVisionVersion = (0, $68A8d.isValidBuildLabel)(vision) ? (0, $68A8d.buildLabelToVersionString)(vision) : vision;
            if (activeVisionVersion !== status.vision.visionSoftwareVersion) return true;
        }
        return false;
    }, [
        availableBuilds,
        status
    ]);
    const versionString = $bh6RR.useMemo(()=>status?.softwareBuildLabel ? (0, $68A8d.buildLabelToVersionString)(status.softwareBuildLabel) : "", [
        status?.softwareBuildLabel
    ]);
    const value = $bh6RR.useMemo(()=>({
            availableBuilds: availableBuilds,
            buildsReadyToInstall: buildsReadyToInstall,
            hasAvailableBuilds: hasAvailableBuilds,
            showAvailableUpdate: showAvailableUpdate,
            updateRequired: updateRequired,
            versionString: versionString
        }), [
        availableBuilds,
        buildsReadyToInstall,
        hasAvailableBuilds,
        showAvailableUpdate,
        updateRequired,
        versionString
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($dfce5f3c74840ea7$export$c58da0618ccd7928.Provider, {
        value: value,
        children: children
    });
}
function $dfce5f3c74840ea7$export$74524c73191a667c() {
    return $bh6RR.useContext($dfce5f3c74840ea7$export$c58da0618ccd7928);
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $1W9Do = parcelRequire("1W9Do");

var $1lA67 = parcelRequire("1lA67");

var $cbFbS = parcelRequire("cbFbS");

var $68A8d = parcelRequire("68A8d");

var $jP5af = parcelRequire("jP5af");

var $W4f7l = parcelRequire("W4f7l");

var $ezs3H = parcelRequire("ezs3H");

var $cgUqb = parcelRequire("cgUqb");

var $lfvqn = parcelRequire("lfvqn");


var $62tuQ = parcelRequire("62tuQ");
function $a1931579effc0d5a$var$VersionGridItem({ children: children }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1lA67.default), {
        sx: {
            display: "flex",
            alignItems: "center"
        },
        size: 6,
        children: children
    });
}
function $a1931579effc0d5a$var$VersionHeader({ children: children }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
        align: "left",
        variant: "h5",
        component: "dt",
        children: children
    });
}
function $a1931579effc0d5a$var$VersionValue({ children: children }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
        align: "left",
        component: "dd",
        sx: {
            ml: 2
        },
        children: children
    });
}
function $a1931579effc0d5a$export$2e2bcd8739ae039() {
    const { status: status } = (0, $ezs3H.useStatus)();
    const { hasAvailableBuilds: hasAvailableBuilds, updateRequired: updateRequired } = (0, $dfce5f3c74840ea7$export$74524c73191a667c)();
    const { isAdmin: isAdmin } = (0, $W4f7l.useCurrentUser)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const trainerFeatures = (0, $lfvqn.useTrainerFeatures)();
    const { playState: playState } = (0, $cgUqb.useAppWorkoutStatus)();
    const showAvailableUpdate = hasAvailableBuilds && trainerFeatures.includes("userUpdate");
    const updatesReady = $bh6RR.useMemo(()=>{
        if (!status) return false;
        if (!status.update.systems) return false;
        const { control: control, vision: vision } = status.update.systems;
        if (!control || !vision) return false;
        return control.readyToInstall && vision.readyToInstall;
    }, [
        status
    ]);
    const batteryLevelGood = $bh6RR.useMemo(()=>{
        const batteryLevel = status?.trainer?.battery?.level;
        return batteryLevel && batteryLevel >= 35;
    }, [
        status?.trainer?.battery?.level
    ]);
    const buildLabel = status?.softwareBuildLabel ?? "";
    let softwareVersion = "Unknown";
    if (buildLabel) {
        const components = (0, $68A8d.expandLabelToComponents)(buildLabel);
        softwareVersion = `${components.major}.${components.minor}.${components.patch}`;
        softwareVersion += components.alpha ? `${components.release}` : "";
    }
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                onClose: ()=>setDialogType(null),
                children: "About"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                dividers: true,
                sx: {
                    p: 2
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1lA67.default), {
                    container: true,
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1lA67.default), {
                            size: 12,
                            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1lA67.default), {
                                container: true,
                                component: "dl",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)($a1931579effc0d5a$var$VersionGridItem, {
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)($a1931579effc0d5a$var$VersionHeader, {
                                            children: "Trainer ID"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)($a1931579effc0d5a$var$VersionGridItem, {
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)($a1931579effc0d5a$var$VersionValue, {
                                            children: status?.clientId ?? "?"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)($a1931579effc0d5a$var$VersionGridItem, {
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)($a1931579effc0d5a$var$VersionHeader, {
                                            children: "Trainer Version"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)($a1931579effc0d5a$var$VersionGridItem, {
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)($a1931579effc0d5a$var$VersionValue, {
                                            children: softwareVersion
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)($a1931579effc0d5a$var$VersionGridItem, {
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)($a1931579effc0d5a$var$VersionHeader, {
                                            children: "Vision Version"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)($a1931579effc0d5a$var$VersionGridItem, {
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)($a1931579effc0d5a$var$VersionValue, {
                                            children: status?.vision.visionSoftwareVersion ?? "?"
                                        })
                                    })
                                ]
                            })
                        }),
                        showAvailableUpdate && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1lA67.default), {
                            container: true,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1lA67.default), {
                                    sx: {
                                        mt: 2
                                    },
                                    size: 12,
                                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                                        component: "div",
                                        sx: {
                                            display: "flex",
                                            justifyContent: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                                variant: "h6",
                                                component: "h2",
                                                children: "Update Available!"
                                            }),
                                            !updatesReady && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                                variant: "h6",
                                                component: "h2",
                                                color: "success",
                                                sx: {
                                                    ml: 1
                                                },
                                                children: "But NOT Ready to Install"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1lA67.default), {
                                    sx: {
                                        mt: 2
                                    },
                                    size: 12,
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                        component: "div",
                                        sx: {
                                            display: "flex",
                                            justifyContent: "center"
                                        },
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                            variant: "contained",
                                            color: "secondary",
                                            disabled: !batteryLevelGood || playState === "playing",
                                            onClick: ()=>setDialogType("Update"),
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                                variant: "h6",
                                                component: "h2",
                                                children: "Start Update"
                                            })
                                        })
                                    })
                                }),
                                batteryLevelGood && playState !== "playing" && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1lA67.default), {
                                    sx: {
                                        mt: 2
                                    },
                                    size: 12,
                                    children: [
                                        updatesReady && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                            variant: "body1",
                                            component: "p",
                                            children: "A new version of the software is available. Please update the trainer."
                                        }),
                                        !updatesReady && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                            variant: "body1",
                                            component: "p",
                                            children: "A new version of the software is available, but it is not ready to install. The trainer will first have to download the update. This may take some time."
                                        }),
                                        !isAdmin && updateRequired && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                            variant: "body1",
                                            component: "p",
                                            children: "This update is required to continue using the trainer."
                                        })
                                    ]
                                }),
                                !batteryLevelGood && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1lA67.default), {
                                    sx: {
                                        mt: 2
                                    },
                                    size: 12,
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                        component: "div",
                                        sx: {
                                            display: "flex",
                                            justifyContent: "center"
                                        },
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                            variant: "body2",
                                            component: "p",
                                            color: "error",
                                            textAlign: "center",
                                            children: "A new version of the software is available, however the battery level is too low to update."
                                        })
                                    })
                                }),
                                playState === "playing" && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1lA67.default), {
                                    sx: {
                                        mt: 2
                                    },
                                    size: 12,
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                        component: "div",
                                        sx: {
                                            display: "flex",
                                            justifyContent: "center"
                                        },
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                            variant: "body2",
                                            component: "p",
                                            color: "error",
                                            textAlign: "center",
                                            children: "A new version of the software is available, however the trainer is playing a workout."
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $eedE5 = parcelRequire("eedE5");

var $1W9Do = parcelRequire("1W9Do");

var $iZWBy = parcelRequire("iZWBy");

var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $W4f7l = parcelRequire("W4f7l");

var $ezs3H = parcelRequire("ezs3H");

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $9rvkQ = parcelRequire("9rvkQ");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");


var $62tuQ = parcelRequire("62tuQ");

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $iTU6T = parcelRequire("iTU6T");

var $9rvkQ = parcelRequire("9rvkQ");

var $3x9x0 = parcelRequire("3x9x0");

var $4rInl = parcelRequire("4rInl");

var $5Z0If = parcelRequire("5Z0If");

var $kclvT = parcelRequire("kclvT");

var $l82lx = parcelRequire("l82lx");

var $dHxgH = parcelRequire("dHxgH");

var $gfi3N = parcelRequire("gfi3N");

var $4Athc = parcelRequire("4Athc");

var $cbFbS = parcelRequire("cbFbS");
function $e71467bf781640c0$export$52e11c18b4d91d9b({ children: children, helpHref: helpHref = null }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $kclvT.default), {
        sx: {
            py: 2,
            backgroundColor: (theme)=>theme.palette.common.white
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                children: children
            }),
            !!helpHref && /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                component: (0, $5Z0If.default),
                href: helpHref,
                rel: "noopener",
                target: "_blank",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3x9x0.default), {
                    color: "disabled"
                })
            })
        ]
    });
}
function $e71467bf781640c0$export$6cde6908a811b9a4({ children: children, helpHref: helpHref = null }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $kclvT.default), {
        sx: {
            py: 2
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9rvkQ.default), {
                    color: "primary"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                children: children
            }),
            !!helpHref && /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                component: (0, $5Z0If.default),
                href: helpHref,
                rel: "noopener",
                target: "_blank",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3x9x0.default), {
                    color: "disabled"
                })
            })
        ]
    });
}
function $e71467bf781640c0$export$50f09c8cd4c007f5({ children: children, action: action, priority: priority = true, icon: icon = null }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
        component: (0, $4Athc.default),
        elevation: priority ? 4 : 0,
        disablePadding: true,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
            onClick: action,
            sx: {
                py: 2,
                backgroundColor: (t)=>priority ? t.palette.secondary.main : t.palette.background.paper,
                "&:hover": {
                    backgroundColor: (t)=>priority ? t.palette.secondary.main : t.palette.background.paper
                }
            },
            children: [
                icon && /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                    sx: {
                        minWidth: "auto",
                        pr: 1
                    },
                    children: icon
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "h4",
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                    sx: {
                        justifyContent: "flex-end",
                        minWidth: "24px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $iTU6T.default), {
                        color: "primary"
                    })
                })
            ]
        })
    });
}


function $a85613f68917a7f0$export$2e2bcd8739ae039({ hideIfNoUpdate: hideIfNoUpdate = true }) {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { showAvailableUpdate: showAvailableUpdate, versionString: versionString } = (0, $dfce5f3c74840ea7$export$74524c73191a667c)();
    if (hideIfNoUpdate && !showAvailableUpdate) return null;
    // Show update-specific UI when update is available
    if (showAvailableUpdate) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e71467bf781640c0$export$50f09c8cd4c007f5), {
        action: ()=>setDialogType("UserUpdate"),
        priority: true,
        icon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9rvkQ.default), {
            color: "error",
            fontSize: "small"
        }),
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8JNI1.default), {
            direction: "row",
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                variant: "h4",
                component: "span",
                children: "Update available"
            })
        })
    });
    // Show standard "About" link when no update available
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e71467bf781640c0$export$50f09c8cd4c007f5), {
        action: ()=>setDialogType("About"),
        priority: false,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h4",
                    component: "span",
                    children: "About"
                }),
                versionString && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                    variant: "h4",
                    component: "span",
                    color: "text.secondary",
                    children: [
                        "v",
                        versionString
                    ]
                })
            ]
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $8JNI1 = parcelRequire("8JNI1");

var $fpwuC = parcelRequire("fpwuC");

var $cbFbS = parcelRequire("cbFbS");

var $l0oRz = parcelRequire("l0oRz");

var $cK0UE = parcelRequire("cK0UE");

var $4xl3n = parcelRequire("4xl3n");

var $ezs3H = parcelRequire("ezs3H");

const $0623e97c71c43192$var$GestureSwitch = (0, $l0oRz.default)((0, $fpwuC.default))(({ theme: theme })=>({
        "& .MuiSwitch-switchBase.Mui-checked": {
            color: theme.palette.success.main
        },
        "& .MuiSwitch-switchBase.Mui-unchecked": {
            color: theme.palette.grey
        }
    }));
function $0623e97c71c43192$export$2e2bcd8739ae039() {
    const { status: trainerStatus } = (0, $ezs3H.useStatus)();
    const { status: status } = (0, $4xl3n.usePairingContext)();
    const [gestEnabled, setGestEnabled] = $bh6RR.useState(false);
    const enableGesture = $bh6RR.useCallback(async (enable)=>{
        try {
            await (0, $cK0UE.pairedFetchApi)(trainerStatus?.clientId, "/api/enable-gesture/set", "POST", {
                enable: enable
            });
        } catch (ex) {
            (0, $cK0UE.logFetchError)(ex);
        }
    }, [
        trainerStatus?.clientId
    ]);
    $bh6RR.useEffect(()=>{
        const fetchData = async ()=>{
            const res = await (0, $cK0UE.pairedFetchApi)(trainerStatus?.clientId, "/api/enable-gesture/get", "GET");
            setGestEnabled(res.enable);
        };
        fetchData().catch((err)=>{
            (0, $cK0UE.logFetchError)(err);
        });
    }, [
        trainerStatus?.clientId
    ]);
    const gestureToggle = $bh6RR.useCallback(async ()=>{
        setGestEnabled(!gestEnabled);
        await enableGesture(!gestEnabled);
    }, [
        gestEnabled,
        enableGesture
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e71467bf781640c0$export$52e11c18b4d91d9b), {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
            direction: "row",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h4",
                    component: "span",
                    children: "Gestures:"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                    component: "div",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)($0623e97c71c43192$var$GestureSwitch, {
                        size: "small",
                        name: "gestureEnable",
                        checked: gestEnabled,
                        onChange: gestureToggle,
                        disabled: status !== "paired"
                    })
                })
            ]
        })
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $ezs3H = parcelRequire("ezs3H");

var $62tuQ = parcelRequire("62tuQ");

function $917475698a8d3726$export$2e2bcd8739ae039() {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { status: status } = (0, $ezs3H.useStatus)();
    const name = status?.system.wifi?.essid ?? "Not Connected";
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e71467bf781640c0$export$50f09c8cd4c007f5), {
        action: ()=>{
            setDialogType("WifiCredentials");
        },
        priority: false,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h4",
                    children: "Trainer WiFi:"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h4",
                    color: "success.main",
                    textAlign: "right",
                    pl: 2,
                    sx: {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        maxWidth: 200
                    },
                    children: name
                })
            ]
        })
    });
}



var $62tuQ = parcelRequire("62tuQ");
function $679ec990694c00ac$export$2e2bcd8739ae039() {
    const navigate = (0, $as544.useNavigate)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { features: features, isAdmin: isAdmin } = (0, $W4f7l.useCurrentUser)();
    const { status: status } = (0, $ezs3H.useStatus)();
    const [gestureAvailable, setGestureAvailable] = $bh6RR.useState(false);
    $bh6RR.useEffect(()=>{
        async function fetchData() {
            if (status?.clientId) {
                const show = await (0, $cK0UE.pairedFetchApi)(status.clientId, "/api/features");
                setGestureAvailable(show.includes("gestures"));
            }
        }
        fetchData().catch((e)=>{
            (0, $cK0UE.logFetchError)(e);
        });
    }, [
        status?.clientId
    ]);
    const handleClose = $bh6RR.useCallback(()=>{
        setDialogType("Device");
    }, [
        setDialogType
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                onClose: handleClose,
                children: "Advanced Settings"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $iZWBy.default), {
                        sx: {
                            my: 0.5,
                            "& .MuiListItem-root": {
                                borderStyle: "solid",
                                borderWidth: 1,
                                borderColor: (t)=>t.palette.grey[400],
                                borderBottomStyle: "none",
                                "&:last-child": {
                                    borderBottomStyle: "solid"
                                }
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $a85613f68917a7f0$export$2e2bcd8739ae039), {
                                hideIfNoUpdate: false
                            }),
                            features.includes("WIFI-RESET") && /*#__PURE__*/ (0, $ih19M.jsx)((0, $917475698a8d3726$export$2e2bcd8739ae039), {}),
                            features.includes("GESTURE_CONTROL") && gestureAvailable && /*#__PURE__*/ (0, $ih19M.jsx)((0, $0623e97c71c43192$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    isAdmin() && /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                        fullWidth: true,
                        onClick: ()=>{
                            setDialogType(null);
                            navigate("/content/status");
                        },
                        sx: {
                            mt: 2
                        },
                        children: "Trainer Status"
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $5CVHy = parcelRequire("5CVHy");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $cbFbS = parcelRequire("cbFbS");

var $jP5af = parcelRequire("jP5af");

var $ezs3H = parcelRequire("ezs3H");

var $69mPc = parcelRequire("69mPc");

var $62tuQ = parcelRequire("62tuQ");
function $8cb45a87b21cdf76$export$2e2bcd8739ae039() {
    const { status: status, networkStateCode: networkStateCode } = (0, $ezs3H.useStatus)();
    const { setDialogType: setDialogType, onClose: onClose } = (0, $62tuQ.default)();
    const { height: height, lowerHead: lowerHead, down: down, liftRange: liftRange } = (0, $69mPc.useLift)();
    const [errorMessage, setErrorMessage] = $bh6RR.useState("");
    const percent = $bh6RR.useMemo(()=>{
        const full = Math.abs(liftRange.max - liftRange.min);
        const diff = Math.abs(height - liftRange.min);
        const inv = full - diff;
        return Math.floor(inv / full * 100);
    }, [
        height,
        liftRange.min,
        liftRange.max
    ]);
    $bh6RR.useEffect(()=>{
        if (down) setDialogType("EmptyBallBin");
        else lowerHead().catch((e)=>setErrorMessage(e.message));
    }, [
        down,
        setDialogType,
        lowerHead
    ]);
    $bh6RR.useEffect(()=>{
        if (networkStateCode !== "Connected" || status?.fault) setDialogType("PowerDown");
    }, [
        networkStateCode,
        status?.fault,
        setDialogType
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                onClose: onClose,
                children: "Moving Trainer Arm"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        children: "The trainer is lowering so the arm is in the storage position"
                    }),
                    !!errorMessage && /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        color: "error.main",
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                        sx: {
                            my: 2,
                            position: "relative",
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                                variant: "determinate",
                                value: percent,
                                size: 80,
                                sx: {
                                    color: "primary.light"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                                sx: {
                                    top: "50%",
                                    left: "50%",
                                    position: "absolute",
                                    transform: "translate(-50%, -50%)",
                                    fontSize: "24pt"
                                },
                                color: "primary.light",
                                children: [
                                    height,
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                        component: "span",
                                        sx: {
                                            fontSize: "11pt"
                                        },
                                        children: "in."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $5CVHy = parcelRequire("5CVHy");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $1lMle = parcelRequire("1lMle");

var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $ezs3H = parcelRequire("ezs3H");

var $gqoJ3 = parcelRequire("gqoJ3");

var $62tuQ = parcelRequire("62tuQ");
function $0371568947c9a0c4$export$2e2bcd8739ae039() {
    (0, $1lMle.useLogMountTime)("CalibrationDialog");
    (0, $gqoJ3.default)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { startRapidPoll: startRapidPoll, removeRapidPollCheck: removeRapidPollCheck, status: status, hasFault: hasFault } = (0, $ezs3H.useStatus)();
    const [calibrating, setCalibrating] = $bh6RR.useState(false);
    const [errorMessage, setErrorMessage] = $bh6RR.useState("");
    $bh6RR.useEffect(()=>{
        startRapidPoll(1000, ()=>false, "calibration");
        return ()=>removeRapidPollCheck("calibration");
    }, [
        startRapidPoll,
        removeRapidPollCheck
    ]);
    $bh6RR.useEffect(()=>{
        async function powerUp() {
            setCalibrating(true);
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/power-up", "POST");
        }
        if (status?.trainer.powerState !== "L0") powerUp().catch((e)=>{
            setCalibrating(false);
            setErrorMessage(e.message);
            (0, $cK0UE.logFetchError)(e, "Failed to power up from CalibratingDialog");
        });
    }, [
        status?.clientId,
        status?.trainer.powerState
    ]);
    // Send command to calibrate if not calibrated
    $bh6RR.useEffect(()=>{
        async function calibrate() {
            setCalibrating(true);
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/calibrate", "POST");
        }
        if (status?.trainer.calibrated === "Uncalibrated" && status?.trainer.powerState === "L0") calibrate().catch((e)=>{
            setCalibrating(false);
            setErrorMessage(e.message);
            (0, $cK0UE.logFetchError)(e, "Failed to calibrate from CalibratingDialog");
        });
    }, [
        status?.clientId,
        status?.trainer.calibrated,
        status?.trainer.powerState
    ]);
    // if user refreshes page during calibration
    $bh6RR.useEffect(()=>{
        if (!errorMessage && !calibrating && status?.trainer.calibrated === "Calibrating") setCalibrating(true);
    }, [
        calibrating,
        errorMessage,
        status?.trainer.calibrated
    ]);
    // Close dialog if calibrated
    $bh6RR.useEffect(()=>{
        if (status?.trainer.calibrated === "Calibrated" && status?.trainer.powerState === "L0" && status?.trainer.state === "IDLE") setDialogType(null);
    }, [
        status?.trainer.calibrated,
        setDialogType,
        status?.trainer.powerState,
        status?.trainer.state
    ]);
    $bh6RR.useEffect(()=>{
        if (hasFault) {
            removeRapidPollCheck("calibration");
            setDialogType("Device");
        }
    }, [
        setDialogType,
        hasFault,
        removeRapidPollCheck
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                children: "Starting Up"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                dividers: true,
                children: [
                    !errorMessage && /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        children: "The trainer is calibrating the head unit. This shouldn't take very long."
                    }),
                    !!errorMessage && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                                children: errorMessage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                                sx: {
                                    mt: 2
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                    fullWidth: true,
                                    variant: "contained",
                                    onClick: ()=>setDialogType(null),
                                    children: "Dismiss"
                                })
                            })
                        ]
                    }),
                    !!calibrating && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        component: "div",
                        sx: {
                            textAlign: "center",
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                            size: 80,
                            color: "info"
                        })
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $eedE5 = parcelRequire("eedE5");

var $1W9Do = parcelRequire("1W9Do");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $1TxeB = parcelRequire("1TxeB");

var $4IPS4 = parcelRequire("4IPS4");

var $10RGt = parcelRequire("10RGt");

var $84xZD = parcelRequire("84xZD");

var $76QOg = parcelRequire("76QOg");

var $ezs3H = parcelRequire("ezs3H");
function $412502cd2cb80f64$export$2e2bcd8739ae039({ showOnlyCompatible: showOnlyCompatible = false, afterSportChanged: afterSportChanged, limitedList: limitedList, label: label = "Sport", fullWidth: fullWidth = true, size: size = "medium", disabled: disabled = false }) {
    const { selected: selected, hasSelected: hasSelected, available: available, updateSelected: updateSelected } = (0, $76QOg.useSelectedSport)();
    const { status: status } = (0, $ezs3H.useStatus)();
    const handleChange = (event)=>{
        const sport = event.target.value;
        updateSelected(sport);
        if (afterSportChanged) afterSportChanged(sport);
    };
    const filteredSports = Object.keys(limitedList ?? available).filter((a)=>{
        if (showOnlyCompatible) return (0, $76QOg.trainerCompatibleWithSport)(a, status);
        return true;
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1TxeB.default), {
        fullWidth: fullWidth,
        size: size,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $4IPS4.default), {
                id: "sport-select-label",
                children: label
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $84xZD.default), {
                labelId: "sport-select-label",
                id: "sport-select",
                value: hasSelected ? selected : "",
                label: label,
                onChange: handleChange,
                children: filteredSports.map((k)=>{
                    let itemLabel = limitedList ? limitedList[k] : available[k];
                    if (itemLabel === "Pickleball" && status) itemLabel += " (Requires Pickleball Trainer)";
                    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $10RGt.default), {
                        value: k,
                        children: itemLabel
                    }, k);
                })
            })
        ]
    });
}



var $jP5af = parcelRequire("jP5af");

var $62tuQ = parcelRequire("62tuQ");
function $aa3b78f67da175a3$export$2e2bcd8739ae039() {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const handleStartCalibration = ()=>{
        setDialogType("Calibrating");
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                onClose: ()=>setDialogType("Finished"),
                children: "Trainer Setup"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                dividers: true,
                sx: {
                    p: 2
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "body1",
                            children: "Welcome!"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "body1",
                            children: "Before you start a workout, we need to confirm your sport and ensure the trainer is ready."
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $412502cd2cb80f64$export$2e2bcd8739ae039), {
                            showOnlyCompatible: true
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "body1",
                            children: "Next we need to check to ensure all moving parts are properly working. You'll be able to start your workout when this calibration concludes."
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "secondary",
                            onClick: handleStartCalibration,
                            children: "Start Preparation"
                        })
                    ]
                })
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $3x9x0 = parcelRequire("3x9x0");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $3aa34969b3efbd8d$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27zM12 17.3c-.72 0-1.3-.58-1.3-1.3s.58-1.3 1.3-1.3 1.3.58 1.3 1.3-.58 1.3-1.3 1.3m1-4.3h-2V7h2z"
}), 'Report');



var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $5CVHy = parcelRequire("5CVHy");

var $iZWBy = parcelRequire("iZWBy");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $ehkZF = parcelRequire("ehkZF");

var $cK0UE = parcelRequire("cK0UE");

var $97Cqv = parcelRequire("97Cqv");

var $21XbV = parcelRequire("21XbV");

var $W4f7l = parcelRequire("W4f7l");

var $4xl3n = parcelRequire("4xl3n");

var $ezs3H = parcelRequire("ezs3H");

var $bDIpx = parcelRequire("bDIpx");

var $62tuQ = parcelRequire("62tuQ");


var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $779b541bbf93badb$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1m-2 1H9v12h6z"
}), 'Battery1Bar');



var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $9c92e0786f5b7185$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1m-2 1H9v10h6z"
}), 'Battery2Bar');



var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $adb3b8c908ae8cfa$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1m-2 1H9v8h6z"
}), 'Battery3Bar');



var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $ca72c015da430619$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1m-2 1H9v6h6z"
}), 'Battery4Bar');



var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $b9c76f478e2bba84$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4"
}), 'BatteryFull');



var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $316d18a7bd331783$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4m-2.72 13.95h-1.9v-1.9h1.9zm1.35-5.26s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69"
}), 'BatteryUnknown');



var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $ezs3H = parcelRequire("ezs3H");

var $62tuQ = parcelRequire("62tuQ");

const $be2546138a4a3f70$var$BATTERY_THRESHOLDS = {
    FULL: 70,
    HIGH: 46,
    MEDIUM: 23,
    LOW: 15
};
function $be2546138a4a3f70$export$73e894099ffb91a5({ level: level, ...rest }) {
    if (!level && level !== 0) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $316d18a7bd331783$export$2e2bcd8739ae039), {
        ...rest
    });
    if (level >= $be2546138a4a3f70$var$BATTERY_THRESHOLDS.FULL) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $b9c76f478e2bba84$export$2e2bcd8739ae039), {
        ...rest
    });
    if (level >= $be2546138a4a3f70$var$BATTERY_THRESHOLDS.HIGH) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ca72c015da430619$export$2e2bcd8739ae039), {
        ...rest
    });
    if (level >= $be2546138a4a3f70$var$BATTERY_THRESHOLDS.MEDIUM) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $adb3b8c908ae8cfa$export$2e2bcd8739ae039), {
        ...rest
    });
    if (level >= $be2546138a4a3f70$var$BATTERY_THRESHOLDS.LOW) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $9c92e0786f5b7185$export$2e2bcd8739ae039), {
        color: "warning",
        ...rest
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $779b541bbf93badb$export$2e2bcd8739ae039), {
        color: "error"
    });
}
function $be2546138a4a3f70$export$2e2bcd8739ae039() {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { status: status } = (0, $ezs3H.useStatus)();
    const isLowBattery = status?.hardwarePlatform === "atom" && status.fault?.failures[0].type === "LowBattery";
    if (!isLowBattery) return null;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e71467bf781640c0$export$50f09c8cd4c007f5), {
        action: ()=>setDialogType("ReplaceBatteries"),
        icon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $779b541bbf93badb$export$2e2bcd8739ae039), {
            color: "error",
            fontSize: "medium"
        }),
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
            direction: "row",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h4",
                    children: "Low Battery:"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h4",
                    color: "text.primary",
                    children: "Exchange"
                })
            ]
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $5CVHy = parcelRequire("5CVHy");

var $kclvT = parcelRequire("kclvT");

var $dHxgH = parcelRequire("dHxgH");

var $gfi3N = parcelRequire("gfi3N");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $1lMle = parcelRequire("1lMle");

var $4xl3n = parcelRequire("4xl3n");

var $ezs3H = parcelRequire("ezs3H");

var $62tuQ = parcelRequire("62tuQ");

const $374eba222487c4d6$var$specificFaultTypes = [
    "FeedFailure",
    "FeedFailureNoPowerDrop",
    "BallBinEmpty",
    "SafetyIssue",
    "LowBattery",
    "EStop"
];
function $374eba222487c4d6$export$2e2bcd8739ae039() {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { status: status, hasFault: hasFault } = (0, $ezs3H.useStatus)();
    const { autoCalibrate: autoCalibrate } = (0, $4xl3n.usePairingContext)();
    // don't show calibrate if fault is present, user should take care of other
    // fault before calibrating
    const calibrated = status?.trainer.calibrated ?? "Calibrated";
    const requiresCalibration = !hasFault && calibrated !== "Calibrated";
    const init = status?.ready === "INIT" || autoCalibrate;
    $bh6RR.useEffect(()=>{
        if (calibrated === "Calibrating") setDialogType("Calibrating");
    }, [
        calibrated,
        setDialogType
    ]);
    // Show button for specific faults to re-trigger their workflow dialogs
    if (hasFault && $374eba222487c4d6$var$specificFaultTypes.includes(status?.fault?.failures[0].type || "")) {
        const faultType = status?.fault?.failures[0].type;
        const isFeedFailure = faultType === "FeedFailure" || faultType === "FeedFailureNoPowerDrop";
        if (isFeedFailure) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e71467bf781640c0$export$50f09c8cd4c007f5), {
            action: ()=>{
                setDialogType(faultType === "FeedFailureNoPowerDrop" ? "BallJamNoPowerDrop" : "BallJam");
            },
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                direction: "row",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "h4",
                        children: "Ball Jam:"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "h4",
                        component: "span",
                        color: "text.primary",
                        children: "Press to Resolve"
                    })
                ]
            })
        });
        if (faultType === "BallBinEmpty") return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e71467bf781640c0$export$50f09c8cd4c007f5), {
            action: ()=>setDialogType("RefillBallBin"),
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                direction: "row",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "h4",
                        children: "Refill:"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "h4",
                        component: "span",
                        color: "text.primary",
                        children: "Press to Resolve"
                    })
                ]
            })
        });
    // For other specific types (SafetyIssue, LowBattery, EStop), fall through to generic handler
    }
    if (hasFault && !$374eba222487c4d6$var$specificFaultTypes.includes(status?.fault?.failures[0].type || "")) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e71467bf781640c0$export$50f09c8cd4c007f5), {
        action: ()=>{
            (0, $1lMle.default).warn("Unexpected error, showing HardwareFailure dialog", {
                fault: status?.fault
            });
            setDialogType("HardwareFailure");
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
            direction: "row",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h4",
                    children: "Error:"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h4",
                    component: "span",
                    color: "text.primary",
                    children: "Press to Resolve"
                })
            ]
        })
    });
    if (init) return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $kclvT.default), {
        sx: {
            py: 2,
            backgroundColor: (theme)=>theme.palette.common.white
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "h4",
                            component: "span",
                            children: "Head Unit:"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "h4",
                            component: "span",
                            color: "success.main",
                            children: "Starting Up"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                sx: {
                    justifyContent: "flex-end"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                    size: 16,
                    color: "success",
                    sx: {
                        textAlign: "right"
                    }
                })
            })
        ]
    });
    if (requiresCalibration) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e71467bf781640c0$export$50f09c8cd4c007f5), {
        action: ()=>setDialogType("Calibrating"),
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
            direction: "row",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h4",
                    children: "Calibrate:"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h4",
                    color: "text.primary",
                    children: "Press to Start"
                })
            ]
        })
    });
    return null;
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $ezs3H = parcelRequire("ezs3H");

var $62tuQ = parcelRequire("62tuQ");

function $3dcc99bd33fd3ea8$export$2e2bcd8739ae039() {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { status: status } = (0, $ezs3H.useStatus)();
    // TODO - cbley - specific type of safety issue?
    if (status?.fault && status.fault.failures[0].type === "SafetyIssue") return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e71467bf781640c0$export$50f09c8cd4c007f5), {
        action: ()=>setDialogType("ClearObstructions"),
        children: "Clear Obstructions"
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e71467bf781640c0$export$52e11c18b4d91d9b), {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
            direction: "row",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h4",
                    children: "Obstructions:"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    variant: "h4",
                    color: "success.main",
                    children: "Clear"
                })
            ]
        })
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $kclvT = parcelRequire("kclvT");

var $gfi3N = parcelRequire("gfi3N");

function $2119247745a97e0d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
        sx: {
            py: 2,
            backgroundColor: (theme)=>theme.palette.common.white
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $412502cd2cb80f64$export$2e2bcd8739ae039), {
                showOnlyCompatible: true
            })
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $8fe6de31b281324d$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02M5 9v6h4l5 5V4L9 9z"
}), 'VolumeDown');



var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $2ff2c3c427237da4$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M7 9v6h4l5 5V4l-5 5z"
}), 'VolumeMute');



var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $a5aca55b3fa43485$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M3 9v6h4l5 5V4L7 9zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02M14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77"
}), 'VolumeUp');



var $kclvT = parcelRequire("kclvT");

var $9ug9t = parcelRequire("9ug9t");

var $8JNI1 = parcelRequire("8JNI1");

var $cK0UE = parcelRequire("cK0UE");

var $ezs3H = parcelRequire("ezs3H");

var $lfvqn = parcelRequire("lfvqn");
const $751269665daf2a05$var$STORAGE_KEY = "volley-volume-pref";
function $751269665daf2a05$var$loadStoredPct() {
    try {
        const stored = localStorage.getItem($751269665daf2a05$var$STORAGE_KEY);
        if (stored !== null) {
            const val = Number(stored);
            if (!Number.isNaN(val) && val >= 0 && val <= 100) return val;
        }
    } catch  {
    // localStorage unavailable
    }
    return 100;
}
function $751269665daf2a05$var$saveStoredPct(pct) {
    try {
        localStorage.setItem($751269665daf2a05$var$STORAGE_KEY, String(pct));
    } catch  {
    // localStorage unavailable
    }
}
function $751269665daf2a05$var$pctToVolume(pct, maxVolume) {
    return Math.round(pct / 100 * maxVolume);
}
function $751269665daf2a05$export$2e2bcd8739ae039() {
    const { status: status } = (0, $ezs3H.useStatus)();
    const clientId = status?.clientId;
    const features = (0, $lfvqn.useTrainerFeatures)();
    const supported = features.includes("remoteConfig");
    const [maxVolume, setMaxVolume] = $bh6RR.useState(64);
    const [pct, setPct] = $bh6RR.useState($751269665daf2a05$var$loadStoredPct);
    const [loaded, setLoaded] = $bh6RR.useState(false);
    // Fetch the admin-configured max volume
    $bh6RR.useEffect(()=>{
        if (!clientId || !supported) return;
        (0, $cK0UE.pairedFetchApi)(clientId, "/api/volume").then((data)=>{
            setMaxVolume(data.maxVolume);
            setLoaded(true);
        }).catch((e)=>{
            (0, $cK0UE.logFetchError)(e, "Error fetching volume config");
            setLoaded(true);
        });
    }, [
        clientId,
        supported
    ]);
    // Apply stored preference on initial load
    const appliedRef = $bh6RR.useRef(false);
    $bh6RR.useEffect(()=>{
        if (!loaded || !clientId || !supported || appliedRef.current) return;
        appliedRef.current = true;
        const storedPct = $751269665daf2a05$var$loadStoredPct();
        if (storedPct < 100) {
            const volume = $751269665daf2a05$var$pctToVolume(storedPct, maxVolume);
            (0, $cK0UE.pairedFetchApi)(clientId, "/api/volume", "POST", {
                volume: volume
            }).catch((e)=>(0, $cK0UE.logFetchError)(e, "Error applying stored volume"));
        }
    }, [
        loaded,
        clientId,
        maxVolume,
        supported
    ]);
    // Debounced send to trainer
    const timerRef = $bh6RR.useRef(null);
    const sendVolume = $bh6RR.useCallback((newPct)=>{
        if (!clientId) return;
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            const volume = $751269665daf2a05$var$pctToVolume(newPct, maxVolume);
            (0, $cK0UE.pairedFetchApi)(clientId, "/api/volume", "POST", {
                volume: volume
            }).catch((e)=>(0, $cK0UE.logFetchError)(e, "Error setting volume"));
        }, 150);
    }, [
        clientId,
        maxVolume
    ]);
    const handleChange = $bh6RR.useCallback((_event, value)=>{
        const newPct = value;
        setPct(newPct);
        $751269665daf2a05$var$saveStoredPct(newPct);
        sendVolume(newPct);
    }, [
        sendVolume
    ]);
    if (!supported) return null;
    const icon = pct === 0 ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $2ff2c3c427237da4$export$2e2bcd8739ae039), {
        color: "action"
    }) : pct < 50 ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $8fe6de31b281324d$export$2e2bcd8739ae039), {
        color: "action"
    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $a5aca55b3fa43485$export$2e2bcd8739ae039), {
        color: "action"
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
        sx: {
            py: 1.5,
            px: 2,
            backgroundColor: (theme)=>theme.palette.common.white
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
            direction: "row",
            spacing: 2,
            alignItems: "center",
            width: "100%",
            children: [
                icon,
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $9ug9t.default), {
                    value: pct,
                    onChange: handleChange,
                    min: 0,
                    max: 100,
                    step: 5,
                    valueLabelDisplay: "auto",
                    valueLabelFormat: (v)=>`${v}%`,
                    size: "small",
                    sx: {
                        flex: 1
                    }
                })
            ]
        })
    });
}


function $70850d57de9869e6$export$2e2bcd8739ae039() {
    const intercom = (0, $bDIpx.default)();
    const { setDialogType: setDialogType, setDrawerHeight: setDrawerHeight } = (0, $62tuQ.default)();
    const { status: status, networkStateCode: networkStateCode } = (0, $ezs3H.useStatus)();
    const { status: pairingStatus, trainerId: trainerId } = (0, $4xl3n.usePairingContext)();
    const { isAdmin: isAdmin } = (0, $W4f7l.useCurrentUser)();
    const [configRequested, setConfigRequested] = $bh6RR.useState(false);
    const [proximityEnabled, setProximityEnabled] = $bh6RR.useState(false);
    const [previousSessionUser, setPreviousSessionUser] = $bh6RR.useState(null);
    // Set drawer to auto height for V2 dialog
    $bh6RR.useEffect(()=>{
        setDrawerHeight("auto");
    }, [
        setDrawerHeight
    ]);
    $bh6RR.useEffect(()=>{
        async function fetchProximityConfig() {
            const config = await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/proximity/config");
            return config.enabled;
        }
        if (!configRequested && isAdmin() && status?.clientId) {
            setConfigRequested(true);
            fetchProximityConfig().then((enabled)=>setProximityEnabled(enabled)).catch((e)=>(0, $cK0UE.logFetchError)(e, "Error loading proximity config status for DeviceDialog"));
        }
    }, [
        status?.clientId,
        configRequested,
        isAdmin
    ]);
    $bh6RR.useEffect(()=>{
        async function fetchPreviousUser(clientId) {
            return await (0, $cK0UE.default)(`/api/sessions/previous/trainer/${clientId}`);
        }
        if (status?.clientId) fetchPreviousUser(status.clientId).then((username)=>{
            const date = new Date(username.date);
            const ago = (0, $ehkZF.formatDistance)(date, new Date(), {
                addSuffix: true
            });
            setPreviousSessionUser(`${username.username} (${ago})`);
        }).catch((e)=>(0, $cK0UE.logFetchError)(e));
    }, [
        status?.clientId
    ]);
    const calibrated = status?.trainer.calibrated ?? "Uncalibrated";
    const requiresCalibration = calibrated !== "Calibrated" || status?.ready === "INIT";
    const isConnecting = pairingStatus === "unknown" || pairingStatus === "paired" && networkStateCode === "Connecting";
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
        component: "div",
        pt: {
            sm: 8,
            xs: 6
        },
        ml: {
            sm: "240px"
        },
        width: {
            sm: "calc(100% - 240px)"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
            sx: {
                p: 2,
                bgcolor: (t)=>t.palette.grey[200]
            },
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $be2546138a4a3f70$export$73e894099ffb91a5), {
                                    level: status?.trainer.battery.level
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $21XbV.default), {
                                    wifiStatus: status?.system.wifi ?? null
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $97Cqv.default), {
                                    cellularStatus: status?.system.cellular ?? null
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "info",
                            size: "small",
                            onClick: ()=>setDialogType("Finished"),
                            children: "End Session"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    direction: "row",
                    alignItems: "center",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "h3",
                            pl: 1,
                            children: `Trainer ${trainerId ?? ""}`
                        }),
                        isConnecting && /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                            size: 24
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $iZWBy.default), {
                    sx: {
                        my: 0.5,
                        "& .MuiListItem-root": {
                            borderStyle: "solid",
                            borderWidth: 1,
                            borderColor: (t)=>t.palette.grey[400],
                            borderBottomStyle: "none",
                            "&:last-child": {
                                borderBottomStyle: "solid"
                            }
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $2119247745a97e0d$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $374eba222487c4d6$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $a85613f68917a7f0$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $751269665daf2a05$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $be2546138a4a3f70$export$2e2bcd8739ae039), {}),
                        !requiresCalibration && isAdmin() && proximityEnabled && /*#__PURE__*/ (0, $ih19M.jsx)((0, $3dcc99bd33fd3ea8$export$2e2bcd8739ae039), {})
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    direction: "row",
                    justifyContent: "space-evenly",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            onClick: ()=>{
                                intercom.newMessage();
                            },
                            startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3x9x0.default), {}),
                            children: "Help"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            onClick: ()=>setDialogType("ReportIssue"),
                            startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3aa34969b3efbd8d$export$2e2bcd8739ae039), {}),
                            children: "Report an Issue"
                        })
                    ]
                }),
                previousSessionUser && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                    variant: "caption",
                    textAlign: "center",
                    children: [
                        "Previous session: ",
                        previousSessionUser
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                    onClick: ()=>setDialogType("AdvancedSettings"),
                    fullWidth: true,
                    sx: {
                        mt: 1
                    },
                    children: "Control Center"
                })
            ]
        })
    });
}



var $fb8oe = parcelRequire("fb8oe");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $eedE5 = parcelRequire("eedE5");

var $1W9Do = parcelRequire("1W9Do");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $ezs3H = parcelRequire("ezs3H");

var $gqoJ3 = parcelRequire("gqoJ3");

var $62tuQ = parcelRequire("62tuQ");
function $933b0698d152a332$export$2e2bcd8739ae039() {
    (0, $gqoJ3.default)();
    const { status: status } = (0, $ezs3H.useStatus)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const [dismissed, setDismissed] = $bh6RR.useState(false);
    // We're ready to continue when we no longer have an EStop fault
    // and we're "Uncalibrated". Note: had to add wait until "Uncalibrated" because
    // we'll clear fault, move to L0 but can be in a NODE_BOOT motion state
    // when we try to calibrate, which will fail. This waits until the trainsition
    // is complete and trainer can be calibrated.
    const clear = $bh6RR.useMemo(()=>!status?.fault?.failures.some((f)=>f.type === "EStop") && status?.trainer.calibrated === "Uncalibrated", [
        status
    ]);
    $bh6RR.useEffect(()=>{
        if (dismissed && clear) setDialogType("Calibrating");
    }, [
        clear,
        dismissed,
        setDialogType
    ]);
    // If we're no longer in an EStop fault, dismiss the dialog,
    // this can happen if the user clears fault by using "resume" button
    $bh6RR.useEffect(()=>{
        // only clear if we have't already dismissed, manual dismiss has its own flow
        if (!dismissed && !status?.fault?.failures.some((f)=>f.type === "EStop")) setDialogType(null);
    }, [
        dismissed,
        setDialogType,
        status?.fault?.failures
    ]);
    const clearEStopFault = $bh6RR.useCallback(async ()=>{
        setDismissed(true);
        try {
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/clear-fault", "POST");
        } catch (ex) {
            (0, $cK0UE.logFetchError)(ex, "Failed to clear fault dismissing EStopDialog");
        }
    }, [
        status?.clientId
    ]);
    const shutdown = $bh6RR.useCallback(()=>{
        setDialogType("NoConfirmShutdown");
    }, [
        setDialogType
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                children: "E-Stop Button Pressed"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                dividers: true,
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "secondary",
                            size: "large",
                            onClick: shutdown,
                            sx: {
                                mb: 3
                            },
                            disabled: dismissed,
                            children: "Shutdown Trainer"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "caption",
                            textAlign: "center",
                            children: "Hit the button by accident?"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            size: "small",
                            onClick: clearEStopFault,
                            color: "info",
                            loading: dismissed,
                            sx: {
                                lineHeight: 0.75
                            },
                            children: "Dismiss"
                        })
                    ]
                })
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $eedE5 = parcelRequire("eedE5");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $jP5af = parcelRequire("jP5af");

var $jrL0R = parcelRequire("jrL0R");

var $4xl3n = parcelRequire("4xl3n");
function $b189567a869f8683$export$2e2bcd8739ae039() {
    const { unpair: unpair } = (0, $4xl3n.usePairingContext)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                children: "Something Happened."
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                dividers: true,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                    children: "We can't recover from this, read this article to learn how to shutdown the machine."
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                    variant: "contained",
                    color: "secondary",
                    size: "large",
                    fullWidth: true,
                    onClick: ()=>unpair(),
                    children: "Shutdown Trainer"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jrL0R.default), {
                preText: "Having Trouble?",
                children: "Click here."
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $eedE5 = parcelRequire("eedE5");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $8JNI1 = parcelRequire("8JNI1");

var $jP5af = parcelRequire("jP5af");

var $W4f7l = parcelRequire("W4f7l");

var $62tuQ = parcelRequire("62tuQ");
function $be7267ad9826b217$export$2e2bcd8739ae039() {
    const { onClose: onClose, setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { isPro: isPro, isAdmin: isAdmin } = (0, $W4f7l.useCurrentUser)();
    const navigate = (0, $as544.useNavigate)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                onClose: onClose,
                children: "Ready to End Your Session?"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        sx: {
                            mb: 2
                        },
                        children: "Disconnect if someone else is ready to use the trainer, this will leave the trainer on. Shut down if you are the last to use it."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                variant: "contained",
                                color: "secondary",
                                size: "large",
                                fullWidth: true,
                                onClick: ()=>setDialogType("NoConfirmUnpair"),
                                children: "Disconnect"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                variant: "contained",
                                color: "info",
                                size: "large",
                                fullWidth: true,
                                onClick: ()=>setDialogType("NoConfirmShutdown"),
                                children: "Shut Down"
                            }),
                            (isPro() || isAdmin()) && /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                variant: "contained",
                                color: "primary",
                                size: "large",
                                fullWidth: true,
                                onClick: ()=>{
                                    setDialogType(null);
                                    navigate("/content/history/mine", {
                                        state: {
                                            showCurrent: true
                                        }
                                    });
                                },
                                children: "Share Workouts"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $eedE5 = parcelRequire("eedE5");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $8JNI1 = parcelRequire("8JNI1");

var $1lMle = parcelRequire("1lMle");

var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $jrL0R = parcelRequire("jrL0R");

var $ezs3H = parcelRequire("ezs3H");

var $62tuQ = parcelRequire("62tuQ");
function $414c144e2c18d120$export$2e2bcd8739ae039() {
    (0, $1lMle.useLogMountTime)("HardwareFailureDialog");
    const { status: status, error: error } = (0, $ezs3H.useStatus)();
    const { setDialogProps: setDialogProps, setDialogType: setDialogType } = (0, $62tuQ.default)();
    const [loading, setLoading] = $bh6RR.useState(false);
    const retryCount = $bh6RR.useRef(0);
    const recheckCount = $bh6RR.useRef(undefined);
    const [message, setMessage] = $bh6RR.useState("Attempting to automatically resolve the issue.");
    const [showShutdown, setShowShutdown] = $bh6RR.useState(false);
    const [showRetry, setShowRetry] = $bh6RR.useState(true);
    const [faultCleared, setFaultCleared] = $bh6RR.useState(false);
    const clearFault = $bh6RR.useCallback(async ()=>{
        recheckCount.current = 0;
        retryCount.current += 1;
        setLoading(true);
        try {
            (0, $1lMle.default).info("Attempting to clear fault from HardwareFailureDialog");
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/clear-fault", "POST");
        } catch (ex) {
            (0, $cK0UE.logFetchError)(ex, "Failed to clear fault from HardwareFailureDialog");
            setMessage("We can't automatically fix this issue. Please shut the trainer down and restart it.");
            setShowRetry(false);
            setShowShutdown(true);
        }
    }, [
        status?.clientId
    ]);
    $bh6RR.useEffect(()=>{
        if (typeof recheckCount.current !== "undefined") {
            recheckCount.current += 1;
            (0, $1lMle.default).info(`recheckCount: ${recheckCount.current}`);
            if (status?.fault === null && (status?.trainer.state === "UNCALIBRATED" || status?.trainer.state === "IDLE")) {
                (0, $1lMle.default).info("Clearing hardware fault dialog.");
                setLoading(false);
                setShowRetry(false);
                setShowShutdown(false);
                setFaultCleared(true);
            } else if (recheckCount.current > 2) {
                setMessage("Please click retry which will attempt to fix the issue.");
                recheckCount.current = undefined;
                setLoading(false);
                if (retryCount.current > 2) {
                    setMessage("We can't seem to automatically recover. Please shut down and restart the trainer.");
                    setShowRetry(false);
                    setShowShutdown(true);
                }
            }
        }
    }, [
        setDialogType,
        status
    ]);
    $bh6RR.useEffect(()=>{
        if (error) setLoading(false);
    }, [
        error
    ]);
    const onClose = $bh6RR.useCallback(()=>{
        setDialogType("Device");
    }, [
        setDialogType
    ]);
    $bh6RR.useEffect(()=>{
        setDialogProps({
            onClose: onClose
        });
    }, [
        onClose,
        setDialogProps
    ]);
    $bh6RR.useEffect(()=>{
        clearFault();
    }, [
        clearFault
    ]);
    $bh6RR.useEffect(()=>{
        if (faultCleared) {
            setMessage("The issue has been resolved.");
            const timeout = setTimeout(()=>{
                setDialogType(null);
            }, 3000);
            return ()=>clearTimeout(timeout);
        }
        return ()=>null;
    }, [
        faultCleared,
        setDialogType
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                onClose: onClose,
                children: "Hardware Fault"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                dividers: true,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                    children: message
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    sx: {
                        width: "100%"
                    },
                    children: [
                        showRetry && /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "secondary",
                            size: "large",
                            fullWidth: true,
                            loading: loading,
                            onClick: clearFault,
                            sx: {
                                mb: 2
                            },
                            children: "Retry"
                        }),
                        showShutdown && /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "info",
                            size: "large",
                            fullWidth: true,
                            disabled: loading,
                            onClick: ()=>setDialogType("NoConfirmShutdown"),
                            sx: {
                                mb: 2
                            },
                            children: "Shut Down"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $jrL0R.default), {
                            preText: "Need more help?",
                            children: "Click here."
                        })
                    ]
                })
            })
        ]
    });
}



var $bh6RR = parcelRequire("bh6RR");

var $4xl3n = parcelRequire("4xl3n");

var $62tuQ = parcelRequire("62tuQ");
function $1ed66809b48e4a45$export$2e2bcd8739ae039() {
    const { unpair: unpair } = (0, $4xl3n.usePairingContext)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    $bh6RR.useEffect(()=>{
        unpair();
        setDialogType("ShutdownHardwareChecklist");
    }, [
        unpair,
        setDialogType
    ]);
    return null;
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $eedE5 = parcelRequire("eedE5");

var $5CVHy = parcelRequire("5CVHy");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $eLohH = parcelRequire("eLohH");

var $cbFbS = parcelRequire("cbFbS");

var $cK0UE = parcelRequire("cK0UE");

var $g0YYy = parcelRequire("g0YYy");

var $62tuQ = parcelRequire("62tuQ");
/**
 * Default prompt copy — the new-user onboarding framing from the design's
 * "Connect your DUPR® account" dialog (scenario 2, screen 2).
 */ const $09a36d0ec1a0705c$var$DEFAULT_DESCRIPTION = "Receive a rating if you don't have one, track your improvement, and train with recommendations matched to your level.";
function $09a36d0ec1a0705c$export$2e2bcd8739ae039({ description: description = $09a36d0ec1a0705c$var$DEFAULT_DESCRIPTION }) {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const [ssoConfig, setSsoConfig] = $bh6RR.useState(null);
    const [loading, setLoading] = $bh6RR.useState(true);
    $bh6RR.useEffect(()=>{
        let active = true;
        (0, $cK0UE.default)("/api/integrations/dupr/config").then((cfg)=>{
            if (active) setSsoConfig(cfg);
        }).catch((e)=>(0, $cK0UE.logFetchError)(e)).finally(()=>{
            if (active) setLoading(false);
        });
        return ()=>{
            active = false;
        };
    }, []);
    const close = $bh6RR.useCallback(()=>setDialogType(null), [
        setDialogType
    ]);
    // A successful link surfaces a non-null profile — finish onboarding.
    const handleProfileChange = $bh6RR.useCallback((profile)=>{
        if (profile) close();
    }, [
        close
    ]);
    const duprEnabled = ssoConfig?.enabled === true;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eLohH.default), {
                sx: {
                    p: 2
                },
                color: "primary.main",
                children: "Connect your DUPR\xae account"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                children: loading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                    size: 28
                }) : duprEnabled && ssoConfig ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $g0YYy.default), {
                    ssoConfig: ssoConfig,
                    description: description,
                    onProfileChange: handleProfileChange
                }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    color: "text.secondary",
                    children: "DUPR connection isn't available right now. You can link later from your profile."
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                    onClick: close,
                    children: "Skip for Now"
                })
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $eedE5 = parcelRequire("eedE5");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $eLohH = parcelRequire("eLohH");

var $8JNI1 = parcelRequire("8JNI1");

var $62tuQ = parcelRequire("62tuQ");
function $fe8b729e4b857251$export$2e2bcd8739ae039() {
    const { setDialogType: setDialogType, setBatteryWarningDismissed: setBatteryWarningDismissed } = (0, $62tuQ.default)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eLohH.default), {
                variant: "h4",
                sx: {
                    p: 2
                },
                color: "primary.main",
                children: "Batteries Running Low"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        sx: {
                            mb: 2
                        },
                        children: "The batteries are running low. You can swap them now or keep playing."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                variant: "contained",
                                color: "secondary",
                                size: "large",
                                fullWidth: true,
                                onClick: ()=>setDialogType("NoConfirmReplaceBatteries"),
                                children: "Swap Now"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                variant: "contained",
                                color: "info",
                                size: "large",
                                fullWidth: true,
                                onClick: ()=>{
                                    setBatteryWarningDismissed(true);
                                    setDialogType(null);
                                },
                                children: "Keep Playing"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $jrL0R = parcelRequire("jrL0R");

var $4xl3n = parcelRequire("4xl3n");

var $ezs3H = parcelRequire("ezs3H");

var $62tuQ = parcelRequire("62tuQ");
function $ef47b45cdff3b9fd$export$2e2bcd8739ae039() {
    const { status: status } = (0, $ezs3H.useStatus)();
    const { onClose: onClose } = (0, $62tuQ.default)();
    const { unpair: unpair } = (0, $4xl3n.usePairingContext)();
    const [errorMessage, setErrorMessage] = $bh6RR.useState("");
    $bh6RR.useEffect(()=>{
        async function shutdown() {
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/shutdown", "POST");
        }
        shutdown().catch((e)=>{
            (0, $cK0UE.logFetchError)(e, "API call failed from PowerDownDialog");
            setErrorMessage(e.message);
        }).finally(()=>{
            unpair();
        });
    }, [
        status?.clientId,
        unpair
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                onClose: onClose,
                children: "Power Down Trainer"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        children: "Please push the large red button on the base of the trainer to finish turning it off."
                    }),
                    !!errorMessage && /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        color: "error.main",
                        children: errorMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jrL0R.default), {
                preText: "Having Trouble?",
                children: "Click here."
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $3x9x0 = parcelRequire("3x9x0");

var $eedE5 = parcelRequire("eedE5");

var $5CVHy = parcelRequire("5CVHy");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $8JNI1 = parcelRequire("8JNI1");

var $1lMle = parcelRequire("1lMle");

var $jP5af = parcelRequire("jP5af");

var $4xl3n = parcelRequire("4xl3n");

var $ezs3H = parcelRequire("ezs3H");

var $bDIpx = parcelRequire("bDIpx");

var $1aFku = parcelRequire("1aFku");

var $62tuQ = parcelRequire("62tuQ");
const $fa916c2c9fb1d295$var$MAX_RECONNECT_SECONDS = 5;
const $fa916c2c9fb1d295$var$SHOW_UNPAIR_MILLISECONDS = 3000;
function $fa916c2c9fb1d295$export$2e2bcd8739ae039() {
    (0, $1lMle.useLogMountTime)("ServiceUnavailableDialog");
    const { networkStateCode: networkStateCode, status: status } = (0, $ezs3H.useStatus)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const intercom = (0, $bDIpx.default)();
    const { unpair: unpair } = (0, $4xl3n.usePairingContext)();
    const [nextAttemptSeconds, setNextAttemptSeconds] = $bh6RR.useState($fa916c2c9fb1d295$var$MAX_RECONNECT_SECONDS);
    const [firstRender] = $bh6RR.useState(performance.now());
    const onClose = $bh6RR.useCallback(()=>{
        setDialogType(null);
    }, [
        setDialogType
    ]);
    const onClickUnpair = $bh6RR.useCallback((e)=>{
        e.preventDefault();
        unpair();
        setDialogType("ShutdownHardwareChecklist");
    }, [
        setDialogType,
        unpair
    ]);
    const onClickSupport = $bh6RR.useCallback(()=>{
        const trainer = status?.clientId ? ` (trainer ${status.clientId})` : "";
        intercom.newMessage(`My trainer lost its network connection${trainer}. Status: ${networkStateCode}`);
    }, [
        intercom,
        networkStateCode,
        status?.clientId
    ]);
    (0, $1aFku.default)(()=>{
        setNextAttemptSeconds(nextAttemptSeconds === 1 ? $fa916c2c9fb1d295$var$MAX_RECONNECT_SECONDS : nextAttemptSeconds - 1);
    }, 1000);
    // Auto close this dialog if the network reconnects
    $bh6RR.useEffect(()=>{
        if (networkStateCode === "Connected") onClose();
    }, [
        networkStateCode,
        onClose
    ]);
    const secondsDisplay = `${nextAttemptSeconds} second${nextAttemptSeconds > 1 ? "s" : ""}`;
    const showDisconnect = firstRender + $fa916c2c9fb1d295$var$SHOW_UNPAIR_MILLISECONDS < performance.now();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                children: "Network Connection Problem"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                            color: "primary"
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        children: networkStateCode === "ServiceConnectionDown" ? "We're sorry. Connection with the Volley service couldn't be established." : `The trainer will attempt to reconnect in ${secondsDisplay}.`
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        children: "If a connection is not re-established, please contact support."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    width: "100%",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "info",
                            fullWidth: true,
                            startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3x9x0.default), {}),
                            onClick: onClickSupport,
                            children: "Contact Support"
                        }),
                        showDisconnect && /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            onClick: onClickUnpair,
                            children: "Disconnect"
                        })
                    ]
                })
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $hrqHU = parcelRequire("hrqHU");

var $cbFbS = parcelRequire("cbFbS");

var $1lMle = parcelRequire("1lMle");
parcelRequire("cFAEN");
var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $dkPRN = parcelRequire("dkPRN");

var $4xl3n = parcelRequire("4xl3n");

var $62tuQ = parcelRequire("62tuQ");
const $ccdff366f9a49f4d$export$d8474cff104280f3 = "SESSION_FEEDBACK_LAST_DATE_NEW_HOMEPAGE";
const $ccdff366f9a49f4d$export$409e2d469b6db473 = 5;
const $ccdff366f9a49f4d$var$FEEDBACK_COOLDOWN_DAYS = 14;
const $ccdff366f9a49f4d$var$FEEDBACK_COOLDOWN_MS = $ccdff366f9a49f4d$var$FEEDBACK_COOLDOWN_DAYS * 86400000;
function $ccdff366f9a49f4d$export$c2111a0f3a21e800(session, now = Date.now()) {
    try {
        // if we don't have a previous date or the session, we should solicit feedback
        if (!session) {
            (0, $1lMle.default).warn("[feedback] No session, soliciting feedback");
            return true;
        }
        // session length check, must meet min length
        const sessionStart = new Date(session.startTimestamp);
        const sessionLengthRequired = $ccdff366f9a49f4d$export$409e2d469b6db473 * 60000;
        if (Number.isNaN(sessionStart.getTime())) {
            (0, $1lMle.default).error("[feedback] Error parsing session start time", session.startTimestamp);
            return false;
        }
        const sessionDuration = now - sessionStart.getTime();
        if (sessionDuration < sessionLengthRequired) {
            (0, $1lMle.default).info(`[feedback] Session length is ${sessionDuration}, less than ${sessionLengthRequired}`);
            return false;
        }
        // if we don't have a previous date, we should solicit feedback
        const lastDate = localStorage.getItem($ccdff366f9a49f4d$export$d8474cff104280f3);
        if (!lastDate) {
            (0, $1lMle.default).info("[feedback] No last solicited date, soliciting feedback");
            return true;
        }
        // if lastDate is not a number, we should solicit feedback
        // and reset localStorage value
        const lastDateNum = parseInt(lastDate, 10);
        if (Number.isNaN(lastDateNum)) {
            (0, $1lMle.default).warn("[feedback] Last solicited date is not a number, resetting localStorage");
            localStorage.removeItem($ccdff366f9a49f4d$export$d8474cff104280f3);
            return true;
        }
        // Check if enough time has elapsed since last feedback
        const elapsed = now - lastDateNum;
        if (elapsed >= $ccdff366f9a49f4d$var$FEEDBACK_COOLDOWN_MS) {
            (0, $1lMle.default).info(`[feedback] ${Math.floor(elapsed / 86400000)} days since last feedback, soliciting feedback`);
            return true;
        }
        (0, $1lMle.default).info(`[feedback] Only ${Math.floor(elapsed / 86400000)} days since last feedback, waiting for ${$ccdff366f9a49f4d$var$FEEDBACK_COOLDOWN_DAYS} day cooldown`);
    } catch (e) {
        (0, $1lMle.default).error("[feedback] Error checking if we should solicit feedback", e);
    }
    return false;
}
function $ccdff366f9a49f4d$var$FeedbackDialog({ postDialog: postDialog }) {
    (0, $1lMle.useLogMountTime)("FeedbackDialog");
    const { sessionId: sessionId } = (0, $4xl3n.usePairingContext)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const [rating, setRating] = $bh6RR.useState(null);
    const [comment, setComments] = $bh6RR.useState("");
    const [submitting, setSubmitting] = $bh6RR.useState(false);
    const [apiError, setApiError] = $bh6RR.useState("");
    $bh6RR.useEffect(()=>{
        if (sessionId) localStorage.setItem($ccdff366f9a49f4d$export$d8474cff104280f3, Date.now().toString());
    }, [
        sessionId
    ]);
    const handleSave = async ()=>{
        try {
            if (!sessionId) throw new Error("Session ID is undefined");
            if (!rating) throw new Error("Rating is undefined");
            setSubmitting(true);
            setApiError(""); // Clear any previous API errors
            const feedbackResponse = {
                rating: rating,
                comment: comment || null,
                session: {
                    id: sessionId
                }
            };
            try {
                await (0, $cK0UE.default)("/api/feedback", "POST", feedbackResponse);
                setDialogType(postDialog);
            } catch (apiErr) {
                (0, $1lMle.default).error("Error submitting feedback", apiErr);
                setApiError("Failed to submit feedback. Please try again.");
            }
        } catch (e) {
            (0, $1lMle.default).error("Error in feedback submission", e);
        } finally{
            setSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                onClose: ()=>setDialogType(postDialog),
                children: "Rate Your Volley Session"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        display: "flex",
                        justifyContent: "center",
                        component: "div",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dkPRN.default), {
                            name: "simple-controlled",
                            value: rating,
                            onChange: (_, newValue)=>setRating(newValue),
                            sx: {
                                fontSize: "3rem",
                                mb: 4
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hrqHU.default), {
                        id: "comment",
                        label: "Additional Comments",
                        type: "text",
                        fullWidth: true,
                        multiline: true,
                        rows: 3,
                        value: comment,
                        onChange: (e)=>setComments(e.target.value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            onClick: handleSave,
                            color: "primary",
                            disabled: rating === null,
                            loading: submitting,
                            fullWidth: true,
                            children: "Submit"
                        }),
                        apiError && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "body2",
                            color: "error",
                            sx: {
                                mt: 1,
                                textAlign: "center"
                            },
                            role: "alert",
                            children: apiError
                        })
                    ]
                })
            })
        ]
    });
}
function $ccdff366f9a49f4d$export$b068dbffe314498d() {
    return /*#__PURE__*/ (0, $ih19M.jsx)($ccdff366f9a49f4d$var$FeedbackDialog, {
        postDialog: "DisconnectCleanupChecklist"
    });
}
function $ccdff366f9a49f4d$export$f00f0f7057ca95e7() {
    return /*#__PURE__*/ (0, $ih19M.jsx)($ccdff366f9a49f4d$var$FeedbackDialog, {
        postDialog: "ShutdownCleanupChecklist"
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $eedE5 = parcelRequire("eedE5");

var $1W9Do = parcelRequire("1W9Do");

var $iZWBy = parcelRequire("iZWBy");

var $kclvT = parcelRequire("kclvT");

var $8JNI1 = parcelRequire("8JNI1");

var $5ZUrR = parcelRequire("5ZUrR");

var $b3r65 = parcelRequire("b3r65");

var $jP5af = parcelRequire("jP5af");

var $jrL0R = parcelRequire("jrL0R");

var $W4f7l = parcelRequire("W4f7l");

var $4xl3n = parcelRequire("4xl3n");

var $62tuQ = parcelRequire("62tuQ");
function $f214969cee44af3c$var$ChecklistDialog({ shutdown: shutdown }) {
    const { unpair: unpair, sessionId: sessionId } = (0, $4xl3n.usePairingContext)();
    const { dialogType: dialogType, setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { isAdmin: isAdmin, features: features } = (0, $W4f7l.useCurrentUser)();
    const navigate = (0, $as544.useNavigate)();
    // Held from when the dialog opened. Every flow that opens this checklist
    // has just unpaired, and unpairing keeps the session id (only a
    // server-sent sessionClosed drops it), so this is the session that ended.
    const ended = $bh6RR.useRef({
        sessionId: sessionId,
        showRecap: features.includes((0, $b3r65.SESSION_RECAP_FEATURE)) && !isAdmin() && (0, $5ZUrR.canShareRecap)(),
        navigate: navigate
    });
    $bh6RR.useEffect(()=>{
        unpair();
    }, [
        unpair
    ]);
    // Leaving the checklist, however it's closed (Finished, the X, the
    // backdrop, Escape), is the end of the session: show its recap, for
    // members with the feature, where it can be shared. Staff end sessions
    // all day testing trainers, so they're spared.
    $bh6RR.useEffect(()=>()=>{
            const { sessionId: id, showRecap: showRecap, navigate: go } = ended.current;
            if (id && showRecap) go(`/sessions/${id}/recap?source=end_flow`);
        }, []);
    const handleClose = $bh6RR.useCallback(()=>{
        setDialogType(null);
    }, [
        setDialogType
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                onClose: handleClose,
                children: "Please Clean-up the Court"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $iZWBy.default), {
                        sx: {
                            listStyleType: dialogType === "ShutdownCleanupChecklist" ? "decimal" : "disc",
                            pl: 3,
                            "& .MuiListItem-root": {
                                display: "list-item"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
                                children: "Empty the ball bin if necessary."
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
                                children: "Store the trainer and balls in the designated area."
                            }),
                            shutdown && /*#__PURE__*/ (0, $ih19M.jsx)((0, $kclvT.default), {
                                children: "It may take up to a minute for the two lights in the back to turn off. You can put the trainer away in the meantime."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $8JNI1.default), {
                        direction: "column",
                        spacing: 1,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "secondary",
                            size: "large",
                            fullWidth: true,
                            onClick: handleClose,
                            children: "Finished"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jrL0R.default), {
                preText: "Having Trouble?",
                children: "Click here."
            })
        ]
    });
}
function $f214969cee44af3c$export$91a0c4c1589f36a3() {
    return /*#__PURE__*/ (0, $ih19M.jsx)($f214969cee44af3c$var$ChecklistDialog, {
        shutdown: true
    });
}
function $f214969cee44af3c$export$61a4b2d41ab91c59() {
    return /*#__PURE__*/ (0, $ih19M.jsx)($f214969cee44af3c$var$ChecklistDialog, {
        shutdown: false
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $eLohH = parcelRequire("eLohH");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $1lMle = parcelRequire("1lMle");

var $cK0UE = parcelRequire("cK0UE");

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $hpaXv = parcelRequire("hpaXv");

var $iTU6T = parcelRequire("iTU6T");

var $eedE5 = parcelRequire("eedE5");

var $8JNI1 = parcelRequire("8JNI1");

var $76QOg = parcelRequire("76QOg");

var $ezs3H = parcelRequire("ezs3H");
function $30be4d1a11e8d0ca$export$2e2bcd8739ae039({ showOnlyCompatible: showOnlyCompatible = false, afterSportChanged: afterSportChanged, limitedList: limitedList }) {
    const { selected: selected, hasSelected: hasSelected, available: available, updateSelected: updateSelected } = (0, $76QOg.useSelectedSport)();
    const { status: status } = (0, $ezs3H.useStatus)();
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8JNI1.default), {
        spacing: 1,
        width: "100%",
        children: Object.keys(limitedList ?? available).filter((a)=>{
            if (showOnlyCompatible) return (0, $76QOg.trainerCompatibleWithSport)(a, status);
            return true;
        }).map((k)=>{
            let label = limitedList ? limitedList[k] : available[k];
            if (label === "Pickleball" && status) label += " (Requires Pickleball Trainer)";
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                onClick: ()=>{
                    updateSelected(k);
                    if (afterSportChanged) afterSportChanged(k);
                },
                color: hasSelected && selected === k ? "primary" : "secondary",
                endIcon: !hasSelected || selected !== k ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $iTU6T.default), {}) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $hpaXv.default), {
                    sx: {
                        color: (t)=>t.palette.secondary.main
                    }
                }),
                variant: "contained",
                children: label
            }, k);
        })
    });
}



var $awHpO = parcelRequire("awHpO");

var $jP5af = parcelRequire("jP5af");

var $76QOg = parcelRequire("76QOg");

var $gqoJ3 = parcelRequire("gqoJ3");

var $62tuQ = parcelRequire("62tuQ");
const $3b163ddc44c20efc$var$TITLE = "What would you like to play?";
function $3b163ddc44c20efc$export$332889412786ce7b({ closable: closable, selector: selector }) {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            closable && /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                onClose: ()=>setDialogType(null),
                children: $3b163ddc44c20efc$var$TITLE
            }),
            !closable && /*#__PURE__*/ (0, $ih19M.jsx)((0, $eLohH.default), {
                sx: {
                    p: 2
                },
                color: "primary.main",
                children: $3b163ddc44c20efc$var$TITLE
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8JNI1.default), {
                    spacing: 2,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        children: "You can change this any time from the menu on the left."
                    })
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: selector
            })
        ]
    });
}
function $3b163ddc44c20efc$export$1236e8a916f705fe() {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { getIdFromSport: getIdFromSport } = (0, $76QOg.useSelectedSport)();
    (0, $gqoJ3.default)();
    return /*#__PURE__*/ (0, $ih19M.jsx)($3b163ddc44c20efc$export$332889412786ce7b, {
        closable: false,
        selector: /*#__PURE__*/ (0, $ih19M.jsx)((0, $30be4d1a11e8d0ca$export$2e2bcd8739ae039), {
            showOnlyCompatible: true,
            afterSportChanged: async (sport)=>{
                const primarySportId = getIdFromSport(sport);
                (0, $cK0UE.default)("/api/users/me", "PUT", {
                    profile: {
                        primarySportId: primarySportId
                    }
                }).catch((err)=>{
                    (0, $cK0UE.logFetchError)(err);
                });
                if (sport === "PLATFORM_TENNIS") try {
                    const { playerId: playerId } = await (0, $cK0UE.default)("/api/pti/player-id/mine");
                    (0, $1lMle.default).info(`Found APTA number ${playerId} for user, not prompting`);
                    setDialogType(null);
                } catch  {
                    (0, $1lMle.default).info("No APTA number found for user, prompting");
                    setDialogType("InitialAPTAId");
                }
                else if (sport === "PICKLEBALL") // Pickleball users are offered a DUPR link right
                // after picking their sport (skippable here).
                setDialogType("InitialDuprConnect");
                else setDialogType(null);
            }
        })
    });
}
function $3b163ddc44c20efc$export$9b7adb518c14ce98() {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    return /*#__PURE__*/ (0, $ih19M.jsx)($3b163ddc44c20efc$export$332889412786ce7b, {
        closable: true,
        selector: /*#__PURE__*/ (0, $ih19M.jsx)((0, $30be4d1a11e8d0ca$export$2e2bcd8739ae039), {
            showOnlyCompatible: true,
            afterSportChanged: async (sport)=>{
                (0, $awHpO.default).clearFilter();
                if (sport === "PLATFORM_TENNIS") try {
                    const { playerId: playerId } = await (0, $cK0UE.default)("/api/pti/player-id/mine");
                    (0, $1lMle.default).info(`Found APTA number ${playerId} for user, not prompting`);
                    setDialogType(null);
                } catch  {
                    (0, $1lMle.default).info("No APTA number found for user, prompting");
                    setDialogType("APTAId");
                }
                else setDialogType(null);
            }
        })
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $eedE5 = parcelRequire("eedE5");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $eLohH = parcelRequire("eLohH");

var $8JNI1 = parcelRequire("8JNI1");


var $76QOg = parcelRequire("76QOg");

var $62tuQ = parcelRequire("62tuQ");
function $96df68da84261a05$export$2e2bcd8739ae039() {
    const { friendlyName: friendlyName } = (0, $76QOg.useSelectedSport)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const content = [
        `This trainer is not compatible with ${friendlyName}`,
        "Please select another sport."
    ].join(". ");
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eLohH.default), {
                sx: {
                    p: 2
                },
                color: "primary.main",
                children: `Trainer Incompatible with ${friendlyName}`
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                children: content
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    spacing: 1,
                    sx: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $30be4d1a11e8d0ca$export$2e2bcd8739ae039), {
                            showOnlyCompatible: true,
                            afterSportChanged: ()=>{
                                setDialogType(null);
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            fullWidth: true,
                            variant: "contained",
                            color: "secondary",
                            size: "large",
                            onClick: ()=>setDialogType("Finished"),
                            children: "End Session"
                        })
                    ]
                })
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $jJOx9 = parcelRequire("jJOx9");

var $eedE5 = parcelRequire("eedE5");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $1lMle = parcelRequire("1lMle");

var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $4xl3n = parcelRequire("4xl3n");

var $ezs3H = parcelRequire("ezs3H");

var $e6FX7 = parcelRequire("e6FX7");

var $62tuQ = parcelRequire("62tuQ");
function $ae7278535be4a1cc$export$3b235c6847ef011({ primaryText: primaryText, step: step, changeStep: changeStep }) {
    const { status: status } = (0, $ezs3H.useStatus)();
    const { onClose: onClose } = (0, $62tuQ.default)();
    const { unpair: unpair } = (0, $4xl3n.usePairingContext)();
    const [loading, setLoading] = $bh6RR.useState(false);
    const [error, setError] = $bh6RR.useState(false);
    const onClick = $bh6RR.useCallback(()=>{
        changeStep(1);
    }, [
        changeStep
    ]);
    $bh6RR.useEffect(()=>{
        async function restart() {
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/reboot", "POST");
        }
        if (!loading && step === 2) {
            (0, $1lMle.default).info("Head lowered, requesting reboot.");
            setLoading(true);
            restart().then(()=>{
                (0, $1lMle.default).info("Reboot command accepted, unpairing.");
                unpair();
            }).catch((ex)=>{
                (0, $cK0UE.logFetchError)(ex);
                setError(true);
                setLoading(false);
            });
        }
    }, [
        loading,
        status?.clientId,
        step,
        unpair
    ]);
    const restartFailed = [
        "We were unable to restart the trainer.",
        "Please press the red stop button on the trainer until the light turns off.",
        "Then press the green button to power it back on."
    ].join(" ");
    const text = error ? restartFailed : primaryText;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                onClose: onClose,
                children: "Camera Unavailable"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                dividers: true,
                sx: {
                    mx: "auto"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                    children: text
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                    variant: "contained",
                    color: "secondary",
                    fullWidth: true,
                    loading: loading,
                    onClick: onClick,
                    sx: {
                        mb: 2
                    },
                    startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $jJOx9.default), {}),
                    children: "Restart"
                })
            })
        ]
    });
}
function $ae7278535be4a1cc$var$VisionFaultRestartFlowCore({ primaryText: primaryText }) {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const [step, setStep] = $bh6RR.useState(0);
    if (step !== 1) return /*#__PURE__*/ (0, $ih19M.jsx)($ae7278535be4a1cc$export$3b235c6847ef011, {
        primaryText: primaryText,
        step: step,
        changeStep: (s)=>setStep(s)
    });
    if (step === 1) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e6FX7.default), {
        message: "The trainer arm is being lowered before restarting the trainer.",
        reason: "unpair",
        onLowered: ()=>setStep(2),
        onStopped: ()=>setDialogType(null)
    });
    return null;
}
function $ae7278535be4a1cc$export$501eaafbbaa642a1() {
    const text = "You can restart the trainer to attempt to fix this problem, or play a different workout. This workout requires the camera.";
    return /*#__PURE__*/ (0, $ih19M.jsx)($ae7278535be4a1cc$var$VisionFaultRestartFlowCore, {
        primaryText: text
    });
}
function $ae7278535be4a1cc$export$f914897e1cdef869() {
    const text = "You can restart the trainer to attempt to fix this problem, or keep using the trainer without the camera.";
    return /*#__PURE__*/ (0, $ih19M.jsx)($ae7278535be4a1cc$var$VisionFaultRestartFlowCore, {
        primaryText: text
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $6MOqF = parcelRequire("6MOqF");

var $2zpN0 = parcelRequire("2zpN0");

var $islu0 = parcelRequire("islu0");

var $1hRK9 = parcelRequire("1hRK9");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $1W9Do = parcelRequire("1W9Do");

var $eLohH = parcelRequire("eLohH");

var $4rInl = parcelRequire("4rInl");

var $9ug9t = parcelRequire("9ug9t");

var $8JNI1 = parcelRequire("8JNI1");

var $hrqHU = parcelRequire("hrqHU");

var $cbFbS = parcelRequire("cbFbS");

var $1lMle = parcelRequire("1lMle");

var $e8yyN = parcelRequire("e8yyN");

var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $ezs3H = parcelRequire("ezs3H");

var $lfvqn = parcelRequire("lfvqn");

var $f7sDp = parcelRequire("f7sDp");

var $62tuQ = parcelRequire("62tuQ");
const $3d266225b8e5ed26$var$MIN = -80;
const $3d266225b8e5ed26$var$MAX = -50;
// normalize the signal strength to fit between 0 and 100
const $3d266225b8e5ed26$var$normalize = (value)=>{
    const normalized = (value - $3d266225b8e5ed26$var$MIN) * 100 / ($3d266225b8e5ed26$var$MAX - $3d266225b8e5ed26$var$MIN);
    // show a little bit of red if the signal is really bad
    if (normalized < 2) return 2;
    return normalized;
};
function $3d266225b8e5ed26$var$SignalStrengthIndicator({ wifiMetrics: wifiMetrics }) {
    const { signalStrength: signalStrength, ping: ping } = wifiMetrics;
    let color;
    let description;
    if (signalStrength <= -70) {
        color = (0, $e8yyN.default).palette.error.main;
        description = "poor";
    } else if (signalStrength <= -60) {
        color = (0, $e8yyN.default).palette.warning.main;
        description = "fair";
    } else {
        color = (0, $e8yyN.default).palette.success.main;
        description = "good";
    }
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        component: "div",
        sx: {
            px: 1
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                variant: "body2",
                sx: {
                    mt: 2
                },
                children: [
                    "The trainer's Wi-Fi signal strength is ",
                    description,
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $9ug9t.default), {
                value: $3d266225b8e5ed26$var$normalize(signalStrength),
                min: 0,
                max: 100,
                step: null,
                marks: [
                    {
                        value: 5,
                        label: "Poor"
                    },
                    {
                        value: $3d266225b8e5ed26$var$normalize(-70),
                        label: "Fair"
                    },
                    {
                        value: $3d266225b8e5ed26$var$normalize(-60),
                        label: "Good"
                    },
                    {
                        value: 95,
                        label: "Great"
                    }
                ],
                disabled: true,
                sx: {
                    "& .MuiSlider-thumb": {
                        display: "none"
                    },
                    "& .MuiSlider-rail": {
                        opacity: 0.5
                    },
                    "& .MuiSlider-track": {
                        backgroundColor: color
                    }
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                variant: "body2",
                sx: {
                    mt: 2
                },
                children: [
                    "Connected network: ",
                    /*#__PURE__*/ (0, $ih19M.jsx)("strong", {
                        children: wifiMetrics.essid
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                component: "div",
                sx: {
                    mt: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                        variant: "caption",
                        component: "p",
                        children: [
                            "Signal Strength: ",
                            Math.round(signalStrength),
                            " dBm"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                        variant: "caption",
                        component: "p",
                        children: [
                            "Ping: ",
                            ping,
                            " ms"
                        ]
                    })
                ]
            })
        ]
    });
}
function $3d266225b8e5ed26$export$2e2bcd8739ae039() {
    const [ssid, setSsid] = $bh6RR.useState("");
    const [passphrase, setPassphrase] = $bh6RR.useState("");
    const [showPassword, setShowPassword] = $bh6RR.useState(false);
    const [submitting, setSubmitting] = $bh6RR.useState(false);
    const [loading, setLoading] = $bh6RR.useState(true);
    const [resetting, setResetting] = $bh6RR.useState(false);
    const [supported, setSupported] = $bh6RR.useState(true);
    const [error, setError] = $bh6RR.useState("");
    const { status: status } = (0, $ezs3H.useStatus)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const trainerFeatures = (0, $lfvqn.useTrainerFeatures)();
    const canScan = trainerFeatures.includes("wifiScan");
    const { ssidOptions: ssidOptions, scanning: scanning, scanMessage: scanMessage, scan: scan } = (0, $f7sDp.useWifiScan)();
    $bh6RR.useEffect(()=>{
        async function loadWifiCredentials() {
            try {
                if (status?.clientId === undefined) throw new Error("No trainer connected");
                // we need to fetch the trainer for the trainer id
                const trainerResult = await (0, $cK0UE.default)(`/api/trainers/clientId_${status?.clientId}`);
                if (!trainerResult) throw new Error("Trainer not found");
                const result = await (0, $cK0UE.default)(`/api/trainers/${trainerResult.id}/wifi-credentials`);
                setSsid(result.ssid);
                setPassphrase(result.passphrase);
            } catch (err) {
                if (err instanceof Error && err.message === "Method not found") setSupported(false);
                else {
                    (0, $1lMle.default).error("Error getting wifi credentials", {
                        error: err
                    });
                    setError(err.message);
                }
            } finally{
                setLoading(false);
            }
        }
        loadWifiCredentials();
    }, [
        status?.clientId
    ]);
    const onScan = $bh6RR.useCallback(async ()=>{
        try {
            if (status?.clientId === undefined) throw new Error("No trainer connected");
            const trainerResult = await (0, $cK0UE.default)(`/api/trainers/clientId_${status?.clientId}`);
            if (!trainerResult) throw new Error("Trainer not found");
            await scan(trainerResult.id);
        } catch (err) {
            (0, $1lMle.default).error("Error resolving trainer for wifi scan", {
                error: err
            });
            setError(err.message);
        }
    }, [
        status?.clientId,
        scan
    ]);
    const onSubmit = $bh6RR.useCallback(async (e)=>{
        e.preventDefault();
        setSubmitting(true);
        try {
            if (status?.clientId === undefined) throw new Error("No trainer connected");
            const trainerResult = await (0, $cK0UE.default)(`/api/trainers/clientId_${status?.clientId}`);
            if (!trainerResult) throw new Error("Trainer not found");
            await (0, $cK0UE.default)(`/api/trainers/${trainerResult.id}/wifi-credentials`, "POST", {
                ssid: ssid,
                passphrase: passphrase
            });
            setDialogType("Device");
        } catch (err) {
            (0, $1lMle.default).error("Error setting wifi credentials", {
                error: err
            });
            setError(err.message);
        } finally{
            setSubmitting(false);
        }
    }, [
        status?.clientId,
        ssid,
        passphrase,
        setDialogType
    ]);
    const onReset = $bh6RR.useCallback(async (e)=>{
        e.preventDefault();
        if (!window.confirm("Are you sure you want to reset this trainer's wifi credentials?")) return;
        setResetting(true);
        try {
            if (status?.clientId === undefined) throw new Error("No trainer connected");
            const trainerResult = await (0, $cK0UE.default)(`/api/trainers/clientId_${status?.clientId}`);
            if (!trainerResult) throw new Error("Trainer not found");
            await (0, $cK0UE.default)(`/api/trainers/${trainerResult.id}/wifi-credentials`, "DELETE");
            setSsid("");
            setPassphrase("");
        } catch (err) {
            (0, $1lMle.default).error("Error resetting wifi credentials", {
                error: err
            });
            setError(err.message);
        } finally{
            setResetting(false);
        }
    }, [
        status?.clientId
    ]);
    const toggleShowPassword = ()=>{
        setShowPassword(!showPassword);
    };
    const wifiMetrics = $bh6RR.useMemo(()=>{
        // if we're not connected we don't have metrics
        if (!status?.system.wifi?.essid) return undefined;
        return {
            signalStrength: status.system.wifi.signal,
            ping: status.system.wifi.monitorPing ?? 0,
            essid: status.system.wifi.essid
        };
    }, [
        status?.system.wifi
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                onClose: ()=>setDialogType("Device"),
                children: "Trainer Wi-Fi"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                dividers: true,
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    spacing: 2,
                    alignContent: "start",
                    children: [
                        !supported && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            children: "Wi-Fi configuration is not supported by this trainer."
                        }),
                        error && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            color: "error",
                            children: error
                        }),
                        !loading && supported && /*#__PURE__*/ (0, $ih19M.jsx)("form", {
                            onSubmit: onSubmit,
                            autoComplete: "off",
                            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                                        direction: "row",
                                        spacing: 1,
                                        alignItems: "flex-start",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1hRK9.default), {
                                                freeSolo: true,
                                                fullWidth: true,
                                                options: ssidOptions,
                                                // The field is the source of truth:
                                                // a name typed by hand is as valid as
                                                // one picked from the list, since
                                                // hidden networks never appear in a
                                                // scan and an offline trainer cannot
                                                // produce one at all.
                                                inputValue: ssid,
                                                onInputChange: (_e, value)=>setSsid(value),
                                                size: "small",
                                                sx: {
                                                    pr: 2
                                                },
                                                renderInput: (params)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $hrqHU.default), {
                                                        ...params,
                                                        label: "SSID",
                                                        variant: "outlined",
                                                        helperText: scanMessage
                                                    })
                                            }),
                                            canScan && /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                                                onClick: ()=>void onScan(),
                                                loading: scanning,
                                                title: "Scan for nearby networks",
                                                "aria-label": "Scan for nearby networks",
                                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $islu0.default), {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hrqHU.default), {
                                        fullWidth: true,
                                        label: "Password",
                                        variant: "outlined",
                                        value: passphrase,
                                        size: "small",
                                        sx: {
                                            pr: 2
                                        },
                                        type: showPassword ? "text" : "password",
                                        onChange: (e)=>setPassphrase(e.target.value),
                                        slotProps: {
                                            input: {
                                                endAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                                                    onClick: toggleShowPassword,
                                                    children: showPassword ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $2zpN0.default), {}) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $6MOqF.default), {})
                                                })
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                                        component: "div",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                                variant: "contained",
                                                type: "submit",
                                                loading: submitting,
                                                color: "secondary",
                                                children: "Submit"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                                variant: "contained",
                                                type: "button",
                                                loading: resetting,
                                                color: "info",
                                                sx: {
                                                    ml: 2
                                                },
                                                onClick: onReset,
                                                children: "Reset"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            wifiMetrics && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eLohH.default), {
                        children: "Strength"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                        dividers: true,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)($3d266225b8e5ed26$var$SignalStrengthIndicator, {
                            wifiMetrics: wifiMetrics
                        })
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $3x9x0 = parcelRequire("3x9x0");

var $85aFq = parcelRequire("85aFq");

var $eedE5 = parcelRequire("eedE5");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $ezs3H = parcelRequire("ezs3H");

var $bDIpx = parcelRequire("bDIpx");

var $62tuQ = parcelRequire("62tuQ");
function $ed31ecda65737f12$var$BoldTypography({ children: children }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
        variant: "body1",
        fontSize: "1.25rem",
        fontWeight: "bold",
        mb: 2,
        children: children
    });
}
function $ed31ecda65737f12$export$2e2bcd8739ae039({ onClear: onClear, onRetry: onRetry }) {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { hasFault: hasFault, status: status } = (0, $ezs3H.useStatus)();
    const [retrying, setRetrying] = $bh6RR.useState(false);
    const [loweringPower, setLoweringPower] = $bh6RR.useState(false);
    const intercom = (0, $bDIpx.default)();
    $bh6RR.useEffect(()=>{
        if (retrying && !hasFault) onRetry();
    }, [
        retrying,
        hasFault,
        onRetry
    ]);
    const onClearRetry = $bh6RR.useCallback(async ()=>{
        setRetrying(true);
        try {
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/clear-fault", "POST");
        } catch (e) {
            (0, $cK0UE.logFetchError)(e, "Failed to clear fault from BalljamPreamble");
        }
    }, [
        status?.clientId
    ]);
    const onClearLowerPower = $bh6RR.useCallback(async ()=>{
        setLoweringPower(true);
        try {
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/motors-off", "POST");
        } catch (e) {
            (0, $cK0UE.logFetchError)(e, "Failed to soft-stop from BalljamPreamble");
        }
    }, [
        status?.clientId
    ]);
    $bh6RR.useEffect(()=>{
        if (loweringPower && status?.trainer.powerState === "L2" && (status?.trainer.state === "IDLE" || status?.trainer.state === "UNCALIBRATED")) onClear();
    }, [
        loweringPower,
        onClear,
        status?.trainer.powerState,
        status?.trainer.state
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                onClose: ()=>setDialogType("Device"),
                children: "Ball Jam"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                dividers: true,
                children: /*#__PURE__*/ (0, $ih19M.jsx)($ed31ecda65737f12$var$BoldTypography, {
                    children: "Wet balls are the likely cause of ball jams. Do not use wet balls."
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "secondary",
                            fullWidth: true,
                            loading: retrying,
                            onClick: onClearRetry,
                            sx: {
                                mb: 2
                            },
                            children: "Retry"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "info",
                            fullWidth: true,
                            onClick: onClearLowerPower,
                            loading: loweringPower,
                            sx: {
                                mb: 2
                            },
                            children: "Clear Jam Manually"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                            mt: 1,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                    onClick: ()=>{
                                        window.open("https://www.youtube.com/watch?v=8Yp8J8tvWMs", "_blank");
                                    },
                                    startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $85aFq.default), {}),
                                    children: "Watch how"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                    onClick: ()=>{
                                        intercom.newMessage();
                                    },
                                    startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3x9x0.default), {}),
                                    children: "Need help? Chat with support."
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $e6FX7 = parcelRequire("e6FX7");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $5CVHy = parcelRequire("5CVHy");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $1lMle = parcelRequire("1lMle");

var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $jrL0R = parcelRequire("jrL0R");

var $ezs3H = parcelRequire("ezs3H");

var $lfvqn = parcelRequire("lfvqn");

var $gqoJ3 = parcelRequire("gqoJ3");

var $62tuQ = parcelRequire("62tuQ");
function $f7d7f59f9ca0e649$export$2e2bcd8739ae039({ autoCalibrate: autoCalibrate, onPoweredUp: onPoweredUp, onError: onError }) {
    (0, $gqoJ3.default)();
    // const { post, error: fetchError } = useFetch();
    const [fetchError, setFetchError] = $bh6RR.useState();
    const { status: status, hasFault: hasFault } = (0, $ezs3H.useStatus)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const [poweredUp, setPoweredUp] = $bh6RR.useState(false);
    const features = (0, $lfvqn.useTrainerFeatures)();
    function shouldSetDialogType(failures) {
        return failures !== undefined && !failures.some((f)=>f.type === "LowBattery" || f.type === "RemovedBattery" || f.type === "PowerIssue");
    }
    $bh6RR.useEffect(()=>{
        if (hasFault && onError) // the controlling dialog flow has a specific error handler
        onError();
        else if (hasFault && shouldSetDialogType(status?.fault?.failures)) setDialogType("Device");
    }, [
        hasFault,
        onError,
        setDialogType,
        status
    ]);
    $bh6RR.useEffect(()=>{
        async function powerup() {
            try {
                if (autoCalibrate && features?.includes("powerUpAutoCalibrate")) await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/power-up", "POST", {
                    autoCalibrate: true
                });
                else await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/power-up", "POST");
            } catch (ex) {
                (0, $cK0UE.logFetchError)(ex, "Failed to power up from PowerUpDialog");
                if (ex instanceof Error) setFetchError(ex.message);
                else {
                    const msg = `Unknown error attempting to power up: ${JSON.stringify(ex)}`;
                    setFetchError(msg);
                }
            }
        }
        powerup();
    }, [
        status?.clientId,
        autoCalibrate,
        features
    ]);
    $bh6RR.useEffect(()=>{
        async function calibrate() {
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/calibrate", "POST");
        }
        const powerState = status?.trainer.powerState;
        const motionState = status?.trainer.state;
        if (powerState === "L0" && (motionState === "UNCALIBRATED" || motionState === "IDLE") && !poweredUp) {
            if (autoCalibrate && features?.includes("powerUpAutoCalibrate")) {
                (0, $1lMle.default).info("Autocalibrate was set - setting powered up");
                setPoweredUp(true);
            } else {
                (0, $1lMle.default).info("Autocalibrate was not set - setting powered up and calling calibrate");
                setPoweredUp(true);
                calibrate();
            }
        }
    }, [
        status?.trainer.powerState,
        status?.trainer.state,
        status?.clientId,
        poweredUp,
        features,
        autoCalibrate
    ]);
    $bh6RR.useEffect(()=>{
        if (poweredUp && status?.trainer.calibrated === "Calibrated") // we're done
        onPoweredUp();
    }, [
        onPoweredUp,
        poweredUp,
        status?.trainer.calibrated
    ]);
    $bh6RR.useEffect(()=>{
        if (fetchError) setDialogType("FatalError");
    }, [
        fetchError,
        setDialogType
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                children: "Powering Up"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        children: "Please wait one moment. The trainer is powering back up. The head will move as it recalibrates."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        sx: {
                            textAlign: "center",
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                            size: 80,
                            color: "info"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jrL0R.default), {
                preText: "Having Trouble?",
                children: "Click here."
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $3x9x0 = parcelRequire("3x9x0");

var $85aFq = parcelRequire("85aFq");

var $eedE5 = parcelRequire("eedE5");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $ezs3H = parcelRequire("ezs3H");

var $bDIpx = parcelRequire("bDIpx");

var $62tuQ = parcelRequire("62tuQ");
function $93db05effaef977c$export$2e2bcd8739ae039({ onClear: onClear }) {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { hasFault: hasFault, status: status } = (0, $ezs3H.useStatus)();
    const [clearing, setClearing] = $bh6RR.useState(false);
    const intercom = (0, $bDIpx.default)();
    $bh6RR.useEffect(()=>{
        if (clearing && !hasFault) onClear();
    }, [
        clearing,
        hasFault,
        onClear,
        status?.fault
    ]);
    const onClearClick = $bh6RR.useCallback(async ()=>{
        setClearing(true);
        try {
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/clear-fault", "POST");
        } catch (ex) {
            (0, $cK0UE.logFetchError)(ex, "Failed to clear fault from RemoveBallsDialog > Clear Clicked");
        }
    }, [
        status?.clientId
    ]);
    const disableButton = $bh6RR.useMemo(()=>{
        // disable clear button if we're in L6
        // or either battery is not present
        const L6 = status?.trainer.powerState === "L6";
        const missingBattery = !status?.trainer.battery.present?.a || !status?.trainer.battery.present?.b;
        return L6 || missingBattery;
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                onClose: ()=>setDialogType("Device"),
                children: "Remove Balls"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                dividers: true,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "body1",
                        gutterBottom: true,
                        textAlign: "left",
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                    children: "For safety, remove one battery."
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                    children: "Remove balls and clear jam."
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                    children: "Re-insert battery."
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "secondary",
                            fullWidth: true,
                            loading: clearing,
                            onClick: onClearClick,
                            disabled: disableButton,
                            children: "Ball Jam Cleared"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                            mt: 1,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                    onClick: ()=>{
                                        window.open("https://www.youtube.com/watch?v=8Yp8J8tvWMs", "_blank");
                                    },
                                    startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $85aFq.default), {}),
                                    children: "Watch how"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                    onClick: ()=>{
                                        intercom.newMessage();
                                    },
                                    startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3x9x0.default), {}),
                                    children: "Need help? Chat with support."
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $62tuQ = parcelRequire("62tuQ");
function $d9865ed511012324$export$2e2bcd8739ae039({ noPowerDrop: noPowerDrop = false }) {
    const { setDialogType: setDialogType, setBallJamDismissed: setBallJamDismissed } = (0, $62tuQ.default)();
    const [step, setStep] = $bh6RR.useState(noPowerDrop ? 0 : 1);
    const onError = $bh6RR.useCallback(()=>{
        setDialogType("FatalError");
    }, [
        setDialogType
    ]);
    const onBallJamClear = $bh6RR.useCallback(()=>{
        setStep(3);
    }, [
        setStep
    ]);
    if (step === 1) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e6FX7.default), {
        reason: "balljam",
        onLowered: ()=>setStep(2),
        onStopped: ()=>setDialogType(null),
        onError: onError
    });
    if (step === 0) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ed31ecda65737f12$export$2e2bcd8739ae039), {
        onClear: ()=>setStep(1),
        onRetry: ()=>setStep(5)
    });
    if (step === 2) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $93db05effaef977c$export$2e2bcd8739ae039), {
        onClear: onBallJamClear
    });
    if (step === 3) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $f7d7f59f9ca0e649$export$2e2bcd8739ae039), {
        onPoweredUp: ()=>setStep(5)
    });
    if (step === 5) {
        setBallJamDismissed(true);
        setDialogType(null);
    }
    return null;
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ezs3H = parcelRequire("ezs3H");

var $69mPc = parcelRequire("69mPc");

var $e6FX7 = parcelRequire("e6FX7");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $8JNI1 = parcelRequire("8JNI1");

var $1lMle = parcelRequire("1lMle");

var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $iYrdy = parcelRequire("iYrdy");
function $e652d8bb43df4144$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $iYrdy.default), {
        viewBox: "0 0 48 48",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M47.1,43.6L5.4,1.7L0.9,6.1l12,12h-0.2L17,43c0.2,1.4,1.4,2.4,2.9,2.4h11.5c1.4,0,2.6-1,2.9-2.4l0.5-2.9l7.8,7.9L47.1,43.6 z"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M37.3,15c0.4-0.8,0.7-1.7,0.7-2.6c0-3-2.4-5.4-5.4-5.4c-1.3,0-2.5,0.5-3.4,1.3C29.1,8.1,29,8.1,29,8 c0.4-0.8,0.7-1.7,0.7-2.6c0-3-2.4-5.4-5.4-5.4c-3,0-5.4,2.4-5.4,5.4c0,0.5,0.1,1,0.2,1.5c-0.1,0-0.2,0-0.3,0 c-0.5,0-0.9,0.1-1.4,0.2l7.9,7.9H37.3z"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("polygon", {
                points: "37.1,26.8 38.6,18.1 28.4,18.1"
            })
        ]
    });
}



var $ezs3H = parcelRequire("ezs3H");

var $69mPc = parcelRequire("69mPc");

var $gqoJ3 = parcelRequire("gqoJ3");
const $a672e94112bea5b2$var$RAPID_POLL = 1000;
function $a672e94112bea5b2$export$2e2bcd8739ae039({ onFilled: onFilled, onLowerHead: onLowerHead, manual: manual = false }) {
    (0, $1lMle.useLogMountTime)("RefillBallBinDialog");
    (0, $gqoJ3.default)();
    const { status: status, startRapidPoll: startRapidPoll, removeRapidPollCheck: removeRapidPollCheck } = (0, $ezs3H.useStatus)();
    const [loading, setLoading] = $bh6RR.useState(false);
    const [loadingLower, setLoadingLower] = $bh6RR.useState(false);
    const filled = $bh6RR.useRef(false);
    const { height: height, refillHeight: refillHeight, isLifting: isLifting } = (0, $69mPc.useLift)();
    const lowEnough = $bh6RR.useMemo(()=>height <= refillHeight, [
        height,
        refillHeight
    ]);
    const hasEmptyBinFault = $bh6RR.useMemo(()=>status?.fault?.failures.some((f)=>f.type === "BallBinEmpty"), [
        status
    ]);
    // rapid poll status to clear dialog asap
    $bh6RR.useEffect(()=>{
        startRapidPoll($a672e94112bea5b2$var$RAPID_POLL, (c)=>!c.fault?.failures.some((f)=>f.type === "BallBinEmpty"), "ballbin");
        return ()=>removeRapidPollCheck("ballbin");
    }, [
        startRapidPoll,
        removeRapidPollCheck
    ]);
    $bh6RR.useEffect(()=>{
        // if user has clicked filled and we no longer have
        // a BallBinEmpty fault, close modal.
        if (filled.current && !hasEmptyBinFault) onFilled();
    }, [
        hasEmptyBinFault,
        onFilled
    ]);
    const onLowerHeadClick = $bh6RR.useCallback(async ()=>{
        setLoadingLower(true);
        try {
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/clear-fault", "POST");
            onLowerHead();
        } catch (ex) {
            (0, $cK0UE.logFetchError)(ex, "Failed to clear fault from RefillBallBin > Lower Head Clicked");
        }
    }, [
        onLowerHead,
        status?.clientId
    ]);
    const onClick = $bh6RR.useCallback(async ()=>{
        // if this is a manual refill, we don't need to clear the fault
        if (manual) {
            onFilled();
            return;
        }
        // otherwise, clear the fault and wait for it to clear
        setLoading(true);
        filled.current = true;
        try {
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/clear-fault", "POST");
        } catch (ex) {
            (0, $cK0UE.logFetchError)(ex, "Failed to clear fault from RefillBallBin > Resume Clicked");
        }
    }, [
        manual,
        onFilled,
        status?.clientId
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                children: "Ball Bin Empty"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                dividers: true,
                sx: {
                    mx: "auto"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                    component: "div",
                    sx: {
                        mx: "auto"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e652d8bb43df4144$export$2e2bcd8739ae039), {
                        sx: {
                            fontSize: 64
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    sx: {
                        width: "100%"
                    },
                    children: [
                        !lowEnough && !isLifting && /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "secondary",
                            fullWidth: true,
                            loading: loadingLower,
                            onClick: onLowerHeadClick,
                            sx: {
                                mb: 2
                            },
                            children: "Lower Head"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "info",
                            fullWidth: true,
                            loading: loading,
                            onClick: onClick,
                            sx: {
                                mb: 2
                            },
                            children: "Close"
                        })
                    ]
                })
            })
        ]
    });
}



var $62tuQ = parcelRequire("62tuQ");
function $df15bd38d6a5a67a$export$2e2bcd8739ae039({ manual: manual = false }) {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { hasFault: hasFault } = (0, $ezs3H.useStatus)();
    const { height: height, refillHeight: refillHeight } = (0, $69mPc.useLift)();
    const lowEnough = $bh6RR.useMemo(()=>height <= refillHeight, [
        height,
        refillHeight
    ]);
    const [step, setStep] = $bh6RR.useState(0);
    // close the dialog if there's no more fault and this isn't a manual refil.
    // this can happen if the user pressed the hardware "resume" button on the trainer
    $bh6RR.useEffect(()=>{
        if (!hasFault && !manual) setDialogType(null);
    }, [
        hasFault,
        manual,
        setDialogType
    ]);
    $bh6RR.useEffect(()=>{
        if (step === 2) setDialogType(null);
    }, [
        lowEnough,
        setDialogType,
        step
    ]);
    if (step === 0) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $a672e94112bea5b2$export$2e2bcd8739ae039), {
        onFilled: ()=>setStep(2),
        onLowerHead: ()=>setStep(1),
        manual: manual
    });
    if (step === 1) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e6FX7.default), {
        message: "The trainer arm is moving to a more convenient height to refill the bin.",
        reason: "refill",
        onLowered: ()=>setStep(2),
        onStopped: ()=>setDialogType(null)
    });
    return null;
}


function $00645d9c1e6ec7e3$export$2e2bcd8739ae039() {
    return (0, $df15bd38d6a5a67a$export$2e2bcd8739ae039)({
        manual: true
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $W4f7l = parcelRequire("W4f7l");

var $4xl3n = parcelRequire("4xl3n");

var $ezs3H = parcelRequire("ezs3H");

var $e6FX7 = parcelRequire("e6FX7");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $5CVHy = parcelRequire("5CVHy");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $4xl3n = parcelRequire("4xl3n");

var $ezs3H = parcelRequire("ezs3H");

var $gqoJ3 = parcelRequire("gqoJ3");
function $8b6627c2666c0219$export$2e2bcd8739ae039({ onPoweredOff: onPoweredOff, full: full = false }) {
    (0, $gqoJ3.default)();
    const { status: status, networkStateCode: networkStateCode } = (0, $ezs3H.useStatus)();
    const [started, setStarted] = $bh6RR.useState(false);
    const [closedSession, setClosedSession] = $bh6RR.useState(false);
    const { unpair: unpair } = (0, $4xl3n.usePairingContext)();
    $bh6RR.useEffect(()=>{
        async function powerOff() {
            if (!started) {
                setStarted(true);
                await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/shutdown", "POST", {
                    soft: !full
                });
            }
        }
        powerOff().catch((e)=>(0, $cK0UE.logFetchError)(e));
    }, [
        full,
        started,
        status
    ]);
    $bh6RR.useEffect(()=>{
        const powerState = status?.trainer?.powerState;
        // we're shutdown if motion reports OFF or trainer goes offline (shut down
        // can happen before we get OFF reported)
        if ((powerState === "L4" || powerState === "L5" || powerState === "L6" || networkStateCode === "ConnectionReestablishing") && !closedSession) {
            setClosedSession(true);
            unpair();
            onPoweredOff();
        }
    }, [
        closedSession,
        networkStateCode,
        onPoweredOff,
        status,
        unpair
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                children: "Shutting Down"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        children: "The trainer is shutting down. It may take up to a minute for the two lights on the back to turn off. You can put the trainer away in the meantime."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        component: "div",
                        sx: {
                            textAlign: "center",
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                            size: 80,
                            color: "info"
                        })
                    })
                ]
            })
        ]
    });
}




var $62tuQ = parcelRequire("62tuQ");
function $8979458a99b143b4$export$2e2bcd8739ae039() {
    const { unpair: unpair } = (0, $4xl3n.usePairingContext)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { isAdmin: isAdmin } = (0, $W4f7l.useCurrentUser)();
    const { status: status } = (0, $ezs3H.useStatus)();
    const [step, setStep] = $bh6RR.useState(1);
    $bh6RR.useEffect(()=>{
        if (step === 3) {
            setDialogType("ShutdownCleanupChecklist");
            unpair();
        }
    }, [
        step,
        setDialogType,
        unpair
    ]);
    if (step === 0) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e6FX7.default), {
        message: "The trainer arm is moving to the lowest position for storage.",
        reason: "shutdown",
        onLowered: ()=>setStep(1),
        onStopped: ()=>setDialogType(null),
        onError: ()=>setStep(1)
    });
    if (step === 1) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8b6627c2666c0219$export$2e2bcd8739ae039), {
        onPoweredOff: ()=>setStep(2),
        full: true
    });
    if (step === 2) {
        // don't prompt for feedback if the user is an admin
        if (isAdmin()) setStep(3);
        // if we shouldn't prompt for feedback, continue with to cleanup
        if (!(0, $ccdff366f9a49f4d$export$c2111a0f3a21e800)(status?.session)) setStep(3);
        setDialogType("ShutdownFeedback");
    }
    return null;
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1lMle = parcelRequire("1lMle");

var $gCqvy = parcelRequire("gCqvy");

var $eRLVn = parcelRequire("eRLVn");

var $W4f7l = parcelRequire("W4f7l");

var $4xl3n = parcelRequire("4xl3n");

var $ezs3H = parcelRequire("ezs3H");

var $cgUqb = parcelRequire("cgUqb");

var $e6FX7 = parcelRequire("e6FX7");


var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $5CVHy = parcelRequire("5CVHy");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $jP5af = parcelRequire("jP5af");

var $ezs3H = parcelRequire("ezs3H");
function $06608456476ff5aa$export$2e2bcd8739ae039({ onUnpair: onUnpair }) {
    const { status: status } = (0, $ezs3H.useStatus)();
    const [closedSession, setClosedSession] = $bh6RR.useState(false);
    $bh6RR.useEffect(()=>{
        setClosedSession(true);
        if (status?.session?.id && !closedSession) onUnpair();
    }, [
        closedSession,
        onUnpair,
        status
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                children: "Please Wait"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        children: "The trainer is finishing shutting down and will return you to the home screen when done."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        sx: {
                            textAlign: "center",
                            mt: 2
                        },
                        component: "div",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                            size: 80,
                            color: "info"
                        })
                    })
                ]
            })
        ]
    });
}



var $62tuQ = parcelRequire("62tuQ");
function $b7522b3930e0d9ed$export$2e2bcd8739ae039() {
    const { unpair: unpair } = (0, $4xl3n.usePairingContext)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { isAdmin: isAdmin } = (0, $W4f7l.useCurrentUser)();
    const { status: status } = (0, $ezs3H.useStatus)();
    const { currentWorkout: currentWorkout, playState: playState } = (0, $cgUqb.useAppWorkoutStatus)();
    const { stop: stopWorkout } = (0, $eRLVn.default)({
        workout: null,
        parameters: {}
    });
    const [step, setStep] = $bh6RR.useState(0);
    $bh6RR.useEffect(()=>{
        if (step === 4) setDialogType("DisconnectCleanupChecklist");
    }, [
        step,
        setDialogType,
        unpair
    ]);
    $bh6RR.useEffect(()=>{
        const handleStopWorkout = async ()=>{
            if (step === 0) {
                if (currentWorkout && playState !== "stopped") try {
                    await stopWorkout();
                } catch (error) {
                    (0, $1lMle.default).error("Failed to stop workout:", error);
                }
                else {
                    // An experience run is not a legacy workout, and the
                    // trainer does not stop one when the session closes.
                    // "Nothing running" is the usual answer, and a trainer
                    // without experiences refuses — neither holds this up.
                    if (status?.clientId !== undefined) await (0, $gCqvy.stopRun)(status.clientId).catch(()=>undefined);
                    setStep(1);
                }
            }
        };
        handleStopWorkout();
    }, [
        step,
        currentWorkout,
        playState,
        stopWorkout,
        status?.clientId
    ]);
    $bh6RR.useEffect(()=>{
        if (step === 0 && playState === "stopped") setStep(1);
    }, [
        step,
        playState
    ]);
    if (step === 1) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e6FX7.default), {
        message: "The trainer arm is moving to the lowest position for storage.",
        reason: "unpair",
        onLowered: ()=>setStep(2),
        onStopped: ()=>setDialogType(null),
        onError: ()=>setStep(2)
    });
    if (step === 2) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $06608456476ff5aa$export$2e2bcd8739ae039), {
        onUnpair: ()=>{
            unpair();
            setStep(3);
        }
    });
    if (step === 3) {
        // don't prompt for feedback if the user is an admin
        if (isAdmin()) setStep(4);
        // if we shouldn't prompt for feedback, continue with to cleanup
        if (!(0, $ccdff366f9a49f4d$export$c2111a0f3a21e800)(status?.session)) setStep(4);
        setDialogType("DisconnectFeedback");
    }
    return null;
}



function $67448a78a925ea76$export$2e2bcd8739ae039() {
    return (0, $d9865ed511012324$export$2e2bcd8739ae039)({
        noPowerDrop: true
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $eedE5 = parcelRequire("eedE5");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $8JNI1 = parcelRequire("8JNI1");

var $jP5af = parcelRequire("jP5af");

var $jrL0R = parcelRequire("jrL0R");

var $62tuQ = parcelRequire("62tuQ");
function $056db8d91ca7f61c$export$2e2bcd8739ae039({ onCleared: onCleared }) {
    const { setIgnoreProximity: setIgnoreProximity, setDialogType: setDialogType } = (0, $62tuQ.default)();
    const onClickIgnore = $bh6RR.useCallback(()=>{
        setIgnoreProximity(true);
        setDialogType(null);
    }, [
        setDialogType,
        setIgnoreProximity
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                children: "Clear Obstructions"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                dividers: true,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                    children: "Please check there isn't anything directly in front of the trainer. If there is, please secure it off the court."
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    width: "100%",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "secondary",
                            size: "large",
                            fullWidth: true,
                            onClick: onCleared,
                            children: "Done"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "primary",
                            size: "large",
                            fullWidth: true,
                            onClick: onClickIgnore,
                            children: "Ignore"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jrL0R.default), {
                preText: "Having Trouble?",
                children: "Click here."
            })
        ]
    });
}



var $62tuQ = parcelRequire("62tuQ");
function $aa8f67308ad198e0$export$2e2bcd8739ae039() {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const [step, setStep] = $bh6RR.useState(0);
    $bh6RR.useEffect(()=>{
        setStep(1);
    }, []);
    if (step === 1) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $056db8d91ca7f61c$export$2e2bcd8739ae039), {
        onCleared: ()=>setStep(2)
    });
    if (step === 2) setDialogType(null);
    return null;
}




var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");


var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $eedE5 = parcelRequire("eedE5");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $jP5af = parcelRequire("jP5af");

var $ezs3H = parcelRequire("ezs3H");

var $gqoJ3 = parcelRequire("gqoJ3");

var $62tuQ = parcelRequire("62tuQ");
function $a1e2503d73feec06$export$2e2bcd8739ae039({ onSwapped: onSwapped, titleText: titleText = "Insert Both Charged Batteries" }) {
    (0, $gqoJ3.default)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { status: status, startRapidPoll: startRapidPoll, removeRapidPollCheck: removeRapidPollCheck } = (0, $ezs3H.useStatus)();
    const onClickShutdown = $bh6RR.useCallback(()=>{
        setDialogType("Shutdown");
    }, [
        setDialogType
    ]);
    $bh6RR.useEffect(()=>{
        startRapidPoll(1000, ()=>false, "batteries");
        return ()=>removeRapidPollCheck("batteries");
    }, [
        startRapidPoll,
        removeRapidPollCheck
    ]);
    const disableButton = $bh6RR.useMemo(()=>{
        // we disable the continue button if we're in L6
        // or either battery is not present
        const L6 = status?.trainer.powerState === "L6";
        const missingBattery = !status?.trainer.battery.present?.a || !status?.trainer.battery.present?.b;
        return L6 || missingBattery;
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                children: titleText
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $hHL9O.default), {
                        mb: 2,
                        children: [
                            "Please put in ",
                            /*#__PURE__*/ (0, $ih19M.jsx)("strong", {
                                children: "both"
                            }),
                            " charged batteries and then click done."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                        variant: "contained",
                        onClick: ()=>onSwapped(),
                        fullWidth: true,
                        disabled: disableButton,
                        sx: {
                            mb: 1
                        },
                        children: "Done"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        children: "No charged batteries available?"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                        onClick: onClickShutdown,
                        color: "info",
                        fullWidth: true,
                        children: "Shutdown trainer."
                    })
                ]
            })
        ]
    });
}



var $62tuQ = parcelRequire("62tuQ");
function $df13f571dfd3348e$export$2e2bcd8739ae039() {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const [step, setStep] = $bh6RR.useState(0);
    if (step === 0) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $a1e2503d73feec06$export$2e2bcd8739ae039), {
        onSwapped: ()=>setStep(1),
        titleText: "Battery removed"
    });
    if (step === 1) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $f7d7f59f9ca0e649$export$2e2bcd8739ae039), {
        onPoweredUp: ()=>setStep(2)
    });
    if (step === 2) setDialogType(null);
    return null;
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $5CVHy = parcelRequire("5CVHy");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $eLohH = parcelRequire("eLohH");

var $cK0UE = parcelRequire("cK0UE");

var $ezs3H = parcelRequire("ezs3H");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $eedE5 = parcelRequire("eedE5");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $jP5af = parcelRequire("jP5af");

var $62tuQ = parcelRequire("62tuQ");
function $be6239d67ce94449$export$2e2bcd8739ae039({ title: title, contentText: contentText, buttonLabel: buttonLabel, onConfirm: onConfirm, onClose: onClose }) {
    const { onClose: defaultClose } = (0, $62tuQ.default)();
    const handleClose = $bh6RR.useCallback(()=>{
        if (onClose) onClose();
        else defaultClose();
    }, [
        onClose,
        defaultClose
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                onClose: handleClose,
                children: title
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                dividers: true,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                    children: contentText
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                    variant: "contained",
                    color: "secondary",
                    size: "large",
                    fullWidth: true,
                    onClick: onConfirm,
                    children: buttonLabel
                })
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $5CVHy = parcelRequire("5CVHy");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $ezs3H = parcelRequire("ezs3H");

var $gqoJ3 = parcelRequire("gqoJ3");
function $d623827d87f9e7d4$export$2e2bcd8739ae039({ onPoweredDown: onPoweredDown, message: message = "The trainer will shut down motor control and then walk you through exchanging the batteries." }) {
    (0, $gqoJ3.default)();
    const { status: status } = (0, $ezs3H.useStatus)();
    $bh6RR.useEffect(()=>{
        async function powerDown() {
            try {
                await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/low-power", "POST");
            } catch (e) {
                (0, $cK0UE.logFetchError)(e, "Failed to power down from LowPowerDialog");
            }
        }
        powerDown();
    }, [
        status?.clientId
    ]);
    $bh6RR.useEffect(()=>{
        const powerState = status?.trainer?.powerState;
        // wait for L5 or below
        if (powerState === "L5" || powerState === "L6") onPoweredDown();
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                children: "Entering Low Power Mode"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        children: message
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        sx: {
                            textAlign: "center",
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                            size: 80,
                            color: "info"
                        })
                    })
                ]
            })
        ]
    });
}



var $e6FX7 = parcelRequire("e6FX7");



var $62tuQ = parcelRequire("62tuQ");
function $86bb8afe4699e2ad$var$PauseWorkoutDialog({ onPaused: onPaused }) {
    const { status: status } = (0, $ezs3H.useStatus)();
    const [requestedPause, setRequestedPause] = $bh6RR.useState(false);
    $bh6RR.useEffect(()=>{
        if (status?.workouts.playState === "playing" && !requestedPause) {
            (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/apps/workouts/pause", "POST");
            setRequestedPause(true);
        } else onPaused();
    }, [
        onPaused,
        requestedPause,
        status?.clientId,
        status?.workouts.playState
    ]);
    $bh6RR.useEffect(()=>{
        if (requestedPause && status?.workouts.playState !== "playing") onPaused();
    }, [
        status?.workouts.playState,
        onPaused,
        requestedPause
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eLohH.default), {
                children: "Stopping workout"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        children: "Pausing workout..."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        component: "div",
                        sx: {
                            textAlign: "center",
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                            size: 80,
                            color: "info"
                        })
                    })
                ]
            })
        ]
    });
}
function $86bb8afe4699e2ad$export$2e2bcd8739ae039({ initialStep: initialStep = 0 }) {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const [step, setStep] = $bh6RR.useState(initialStep ?? 0);
    const [error, setError] = $bh6RR.useState("");
    if (error) setDialogType("Shutdown");
    if (step === 0) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $be6239d67ce94449$export$2e2bcd8739ae039), {
        title: "Replace batteries?",
        contentText: "Are you sure you'd like to replace the batteries?",
        buttonLabel: "Replace",
        onConfirm: ()=>setStep(1),
        onClose: ()=>setDialogType("Device")
    });
    if (step === 1) return /*#__PURE__*/ (0, $ih19M.jsx)($86bb8afe4699e2ad$var$PauseWorkoutDialog, {
        onPaused: ()=>setStep(2)
    });
    if (step === 2) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e6FX7.default), {
        onLowered: ()=>{
            setTimeout(()=>{
                // TODO - cbley - for some reason when we try to power down
                // too soon after lowering, it never powers down
                // here we'll just try to wait a second after lowering
                // before powering down
                setStep(3);
            }, 1000);
        },
        reason: "battery-replace",
        onStopped: ()=>setDialogType(null),
        onError: setError
    });
    if (step === 3) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $d623827d87f9e7d4$export$2e2bcd8739ae039), {
        onPoweredDown: ()=>setStep(4)
    });
    if (step === 4) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $a1e2503d73feec06$export$2e2bcd8739ae039), {
        onSwapped: ()=>setStep(5)
    });
    if (step === 5) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $f7d7f59f9ca0e649$export$2e2bcd8739ae039), {
        onPoweredUp: ()=>setStep(7)
    });
    if (step === 7) setDialogType(null);
    return null;
}
function $86bb8afe4699e2ad$export$4114a649c0cd87a8() {
    return /*#__PURE__*/ (0, $ih19M.jsx)($86bb8afe4699e2ad$export$2e2bcd8739ae039, {
        initialStep: 1
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $3x9x0 = parcelRequire("3x9x0");

var $eedE5 = parcelRequire("eedE5");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $jP5af = parcelRequire("jP5af");

var $bDIpx = parcelRequire("bDIpx");

var $62tuQ = parcelRequire("62tuQ");
function $2971a7b8ca0a3ca8$export$2e2bcd8739ae039({ onDone: onDone }) {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const intercom = (0, $bDIpx.default)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                onClose: ()=>setDialogType("Device"),
                children: "Issue Reported"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                children: "Your issue has been reported. Thank you for your feedback."
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bK42r.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                        onClick: ()=>{
                            intercom.newMessage();
                            onDone();
                        },
                        startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3x9x0.default), {}),
                        variant: "contained",
                        color: "secondary",
                        children: "Contact Support"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                        onClick: onDone,
                        color: "primary",
                        variant: "contained",
                        children: "Done"
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $eedE5 = parcelRequire("eedE5");

var $8SbZe = parcelRequire("8SbZe");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $fMPxo = parcelRequire("fMPxo");

var $iUqMN = parcelRequire("iUqMN");

var $8JNI1 = parcelRequire("8JNI1");

var $hrqHU = parcelRequire("hrqHU");

var $cbFbS = parcelRequire("cbFbS");

var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $4xl3n = parcelRequire("4xl3n");

var $62tuQ = parcelRequire("62tuQ");
const $4e29848e7c6f84f8$var$MIN_COMMENT_LENGTH = 5;
function $4e29848e7c6f84f8$export$2e2bcd8739ae039({ onSubmitted: onSubmitted, onError: onError }) {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const [issues, setIssues] = $bh6RR.useState([]);
    const { sessionId: sessionId } = (0, $4xl3n.usePairingContext)();
    const [userIssues, setUserIssues] = $bh6RR.useState([]);
    const [comment, setComment] = $bh6RR.useState("");
    const [otherExplanationRequired, setOtherExplanationRequired] = $bh6RR.useState(false);
    const [otherExplanation, setOtherExplanation] = $bh6RR.useState("");
    const [submitting, setSubmitting] = $bh6RR.useState(false);
    $bh6RR.useEffect(()=>{
        async function fetchIssueTypes() {
            return await (0, $cK0UE.default)("/api/issue-reports/types", "GET");
        }
        fetchIssueTypes().then((data)=>{
            setIssues(data);
        }).catch((e)=>{
            (0, $cK0UE.logFetchError)(e, "Failed to fetch issue types");
            onError();
        });
    }, [
        onError
    ]);
    const handleSave = async ()=>{
        setSubmitting(true);
        try {
            // post to save
            if (!sessionId) throw new Error("Session ID is undefined");
            const otherIssue = issues.find((i)=>i.name === "other");
            const issueReport = {
                comment: comment || null,
                issueReportIssues: userIssues.map((issueId)=>({
                        issueDescription: issueId === otherIssue?.id ? otherExplanation : null,
                        issueTypeId: issueId
                    })),
                session: {
                    id: sessionId
                }
            };
            await (0, $cK0UE.default)("/api/issue-reports", "POST", issueReport);
            onSubmitted();
        } catch (e) {
            (0, $cK0UE.logFetchError)(e, "Failed to submit user issue");
            onError();
        }
    };
    const submitDisabled = $bh6RR.useMemo(()=>{
        if (userIssues.length === 0) return true;
        if (comment.length > 0 && comment.length < 5) return true;
        const otherIssue = issues.find((i)=>i.name === "other");
        if (userIssues.includes(otherIssue?.id ?? -1) && otherExplanation.length < 5) return true;
        return false;
    }, [
        userIssues,
        comment.length,
        issues,
        otherExplanation.length
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                onClose: ()=>setDialogType("Device"),
                children: "Report an Issue"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $iUqMN.default), {
                            children: issues.map((issue)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $fMPxo.default), {
                                    disableTypography: true,
                                    control: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8SbZe.default), {
                                        sx: {
                                            p: 0.5
                                        },
                                        checked: userIssues.includes(issue.id),
                                        onChange: (e)=>{
                                            if (e.target.checked) {
                                                if (issue.name === "other") setOtherExplanationRequired(true);
                                                setUserIssues([
                                                    ...userIssues,
                                                    issue.id
                                                ]);
                                            } else {
                                                if (issue.name === "other") {
                                                    setOtherExplanationRequired(false);
                                                    setOtherExplanation("");
                                                }
                                                setUserIssues(userIssues.filter((i)=>i !== issue.id));
                                            }
                                        }
                                    }),
                                    label: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                        variant: "body2",
                                        children: issue.label
                                    })
                                }, issue.id))
                        }),
                        otherExplanationRequired && /*#__PURE__*/ (0, $ih19M.jsx)((0, $hrqHU.default), {
                            id: "other-explanation",
                            label: "Please explain the issue",
                            type: "text",
                            fullWidth: true,
                            multiline: true,
                            rows: 1,
                            value: otherExplanation,
                            onChange: (e)=>setOtherExplanation(e.target.value),
                            error: otherExplanation.length < $4e29848e7c6f84f8$var$MIN_COMMENT_LENGTH,
                            helperText: otherExplanation.length < $4e29848e7c6f84f8$var$MIN_COMMENT_LENGTH ? `Explanation must be at least ${$4e29848e7c6f84f8$var$MIN_COMMENT_LENGTH} characters` : undefined,
                            required: true
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $hrqHU.default), {
                            id: "comment",
                            label: "Additional Comments",
                            type: "text",
                            fullWidth: true,
                            multiline: true,
                            rows: 3,
                            value: comment,
                            onChange: (e)=>setComment(e.target.value),
                            error: comment.length > 0 && comment.length < $4e29848e7c6f84f8$var$MIN_COMMENT_LENGTH,
                            helperText: comment.length > 0 && comment.length < $4e29848e7c6f84f8$var$MIN_COMMENT_LENGTH ? `Comments must be at least ${$4e29848e7c6f84f8$var$MIN_COMMENT_LENGTH} characters` : undefined
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                    onClick: handleSave,
                    color: "secondary",
                    variant: "contained",
                    disabled: submitDisabled,
                    loading: submitting,
                    children: "Submit"
                })
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $3x9x0 = parcelRequire("3x9x0");

var $eedE5 = parcelRequire("eedE5");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $jP5af = parcelRequire("jP5af");

var $bDIpx = parcelRequire("bDIpx");

var $62tuQ = parcelRequire("62tuQ");
function $2e4bd4c925294a3c$export$2e2bcd8739ae039({ onDone: onDone }) {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const intercom = (0, $bDIpx.default)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                onClose: ()=>setDialogType("Device"),
                children: "Problem Submitting Issue"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                children: 'We\'ve encountered an error submitting your issue. Please click "Contact Help" below to chat with support.'
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                    onClick: ()=>{
                        intercom.newMessage();
                        onDone();
                    },
                    startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3x9x0.default), {}),
                    variant: "contained",
                    color: "secondary",
                    children: "Contact Help"
                })
            })
        ]
    });
}



var $62tuQ = parcelRequire("62tuQ");
function $1f2fdb3c9ce81056$export$2e2bcd8739ae039() {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const [step, setStep] = $bh6RR.useState(0);
    switch(step){
        case 0:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $4e29848e7c6f84f8$export$2e2bcd8739ae039), {
                onSubmitted: ()=>setStep(1),
                onError: ()=>setStep(2)
            });
        case 1:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $2971a7b8ca0a3ca8$export$2e2bcd8739ae039), {
                onDone: ()=>setStep(3)
            });
        case 2:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $2e4bd4c925294a3c$export$2e2bcd8739ae039), {
                onDone: ()=>setStep(3)
            });
        case 3:
            setDialogType(null);
    }
    return null;
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $4xl3n = parcelRequire("4xl3n");


var $e6FX7 = parcelRequire("e6FX7");


var $62tuQ = parcelRequire("62tuQ");
function $62f4d732ceaddb73$export$2e2bcd8739ae039() {
    const { unpair: unpair } = (0, $4xl3n.usePairingContext)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const [step, setStep] = $bh6RR.useState(0);
    $bh6RR.useEffect(()=>{
        if (step === 3) {
            setDialogType("ShutdownCleanupChecklist");
            unpair();
        }
    }, [
        step,
        setDialogType,
        unpair
    ]);
    if (step === 0) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $be6239d67ce94449$export$2e2bcd8739ae039), {
        title: "Confirm Shut Down",
        contentText: "This will end your session and shut down the trainer. It may take up to a minute for the two lights on the back to turn off. You can put the trainer away in the meantime.",
        buttonLabel: "Shut Down",
        onConfirm: ()=>setStep(1)
    });
    if (step === 1) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e6FX7.default), {
        message: "The trainer arm is moving to the lowest position for storage.",
        reason: "shutdown",
        onLowered: ()=>setStep(2),
        onStopped: ()=>setDialogType(null),
        onError: ()=>setStep(2)
    });
    if (step === 2) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8b6627c2666c0219$export$2e2bcd8739ae039), {
        onPoweredOff: ()=>setStep(3),
        full: true
    });
    return null;
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");


var $ezs3H = parcelRequire("ezs3H");

var $lfvqn = parcelRequire("lfvqn");


var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $3x9x0 = parcelRequire("3x9x0");

var $eedE5 = parcelRequire("eedE5");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $eLohH = parcelRequire("eLohH");

var $8JNI1 = parcelRequire("8JNI1");

var $bDIpx = parcelRequire("bDIpx");

var $62tuQ = parcelRequire("62tuQ");
function $4d1f3cf9e70ab23e$export$2e2bcd8739ae039() {
    const { setDialogType: setDialogType, setTiltCalibrationDismissed: setTiltCalibrationDismissed } = (0, $62tuQ.default)();
    const intercom = (0, $bDIpx.default)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eLohH.default), {
                variant: "h4",
                sx: {
                    p: 2
                },
                color: "primary.main",
                children: "Ball Stuck"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                dividers: true,
                children: "There was an error while trying to prepare the trainer to remove the ball."
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "secondary",
                            fullWidth: true,
                            onClick: ()=>{
                                setTiltCalibrationDismissed(true);
                                setDialogType("Device");
                            },
                            sx: {
                                mb: 2
                            },
                            children: "Close"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            onClick: ()=>{
                                intercom.newMessage();
                            },
                            startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3x9x0.default), {}),
                            children: "Need help? Chat with support."
                        })
                    ]
                })
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $3x9x0 = parcelRequire("3x9x0");

var $eLohH = parcelRequire("eLohH");

var $eedE5 = parcelRequire("eedE5");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $cK0UE = parcelRequire("cK0UE");

var $6zj3p = parcelRequire("6zj3p");

var $jP5af = parcelRequire("jP5af");

var $ezs3H = parcelRequire("ezs3H");

var $bDIpx = parcelRequire("bDIpx");

var $62tuQ = parcelRequire("62tuQ");
function $9dcee82a6b003679$export$2e2bcd8739ae039({ onPoweredDown: onPoweredDown, onError: onError }) {
    const { setDialogType: setDialogType, setTiltCalibrationDismissed: setTiltCalibrationDismissed } = (0, $62tuQ.default)();
    const { status: status } = (0, $ezs3H.useStatus)();
    const [loweringPower, setLoweringPower] = $bh6RR.useState(false);
    const intercom = (0, $bDIpx.default)();
    const onClearLowerPower = $bh6RR.useCallback(async ()=>{
        setLoweringPower(true);
        try {
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/clear-fault", "POST");
            await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/low-power-clear-jam", "POST");
        } catch (e) {
            (0, $cK0UE.logFetchError)(e, "Failed to lower power level from BalljamPreamble");
            onError();
        }
    }, [
        status?.clientId,
        onError
    ]);
    $bh6RR.useEffect(()=>{
        if (loweringPower && status?.trainer.powerState === "L3" && (status?.trainer.state === "IDLE" || status?.trainer.state === "UNCALIBRATED")) onPoweredDown();
    }, [
        loweringPower,
        onPoweredDown,
        status?.trainer.powerState,
        status?.trainer.state
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            loweringPower && /*#__PURE__*/ (0, $ih19M.jsx)((0, $eLohH.default), {
                sx: {
                    p: 2
                },
                color: "primary.main",
                variant: "h4",
                children: "Ball Stuck"
            }),
            !loweringPower && /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                onClose: ()=>{
                    setTiltCalibrationDismissed(true);
                    setDialogType("Device");
                },
                children: "Ball Stuck"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        gutterBottom: true,
                        children: "There is likely a ball stuck in the location circled in red below. Press Proceed when you are ready to remove the ball. If there is no ball stuck, ensure that you are not leaning on the trainer's head as it moves."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                        src: (0, $6zj3p.default)("help-dialogs/tilt_calibration_help.jpg"),
                        alt: "Ball jam location",
                        style: {
                            width: "100%",
                            marginTop: "8px"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "secondary",
                            fullWidth: true,
                            loading: loweringPower,
                            onClick: onClearLowerPower,
                            sx: {
                                mb: 2
                            },
                            children: "Proceed"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            onClick: ()=>{
                                intercom.newMessage();
                            },
                            startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3x9x0.default), {}),
                            children: "Need help? Chat with support."
                        })
                    ]
                })
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $3x9x0 = parcelRequire("3x9x0");

var $eedE5 = parcelRequire("eedE5");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $eLohH = parcelRequire("eLohH");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $6zj3p = parcelRequire("6zj3p");

var $bDIpx = parcelRequire("bDIpx");
function $3f10d50378110b69$export$2e2bcd8739ae039({ onBallRemoved: onBallRemoved }) {
    const intercom = (0, $bDIpx.default)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eLohH.default), {
                sx: {
                    p: 2
                },
                color: "primary.main",
                variant: "h4",
                children: "Remove Stuck Ball"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        gutterBottom: true,
                        children: "It is now safe for you to remove the ball. Once the ball has been removed, press done to power the trainer back up."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                        src: (0, $6zj3p.default)("help-dialogs/tilt_calibration_help.jpg"),
                        alt: "Remove ball",
                        style: {
                            width: "100%"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "secondary",
                            fullWidth: true,
                            onClick: onBallRemoved,
                            sx: {
                                mb: 2
                            },
                            children: "Done"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            onClick: ()=>{
                                intercom.newMessage();
                            },
                            startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3x9x0.default), {}),
                            children: "Need help? Chat with support."
                        })
                    ]
                })
            })
        ]
    });
}



var $62tuQ = parcelRequire("62tuQ");
function $fa6d558a9f0a19b6$export$2e2bcd8739ae039() {
    const { status: status } = (0, $ezs3H.useStatus)();
    const features = (0, $lfvqn.useTrainerFeatures)();
    const { setDialogType: setDialogType, setTiltCalibrationDismissed: setTiltCalibrationDismissed } = (0, $62tuQ.default)();
    const [step, setStep] = $bh6RR.useState(0);
    switch(step){
        case 0:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $9dcee82a6b003679$export$2e2bcd8739ae039), {
                onPoweredDown: ()=>setStep(1),
                onError: ()=>{
                    setStep(4);
                }
            });
        case 1:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $3f10d50378110b69$export$2e2bcd8739ae039), {
                onBallRemoved: ()=>setStep(2)
            });
        case 2:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $f7d7f59f9ca0e649$export$2e2bcd8739ae039), {
                onPoweredUp: ()=>setStep(3),
                onError: ()=>{
                    // PowerUpDialog calls this if it detects a fault
                    // Check if we have a tilt calibration failure, if so
                    // reset to the start and the user can either cancel
                    // the flow or try again.
                    if ((0, $82c981ccb1aeb53c$export$adda08d0816d149a)(status?.fault, features)) setStep(0);
                    else {
                        // if not a tilt calibration failure, mark the flow
                        // as dismissed and show the device dialog
                        setTiltCalibrationDismissed(true);
                        setDialogType("Device");
                    }
                },
                autoCalibrate: true
            });
        case 4:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $4d1f3cf9e70ab23e$export$2e2bcd8739ae039), {});
        case 3:
            setDialogType(null);
    }
    return null;
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $4xl3n = parcelRequire("4xl3n");


var $e6FX7 = parcelRequire("e6FX7");


var $62tuQ = parcelRequire("62tuQ");
function $008aee3affed7072$export$2e2bcd8739ae039() {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { unpair: unpair } = (0, $4xl3n.usePairingContext)();
    const [step, setStep] = $bh6RR.useState(0);
    $bh6RR.useEffect(()=>{
        if (step === 3) {
            setDialogType("DisconnectCleanupChecklist");
            unpair();
        }
    }, [
        step,
        setDialogType,
        unpair
    ]);
    if (step === 0) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $be6239d67ce94449$export$2e2bcd8739ae039), {
        title: "Confirm Disconnect",
        contentText: "This action will end your session but keeps the trainer on for the next person.",
        buttonLabel: "Disconnect",
        onConfirm: ()=>setStep(1)
    });
    if (step === 1) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e6FX7.default), {
        message: "The trainer arm is moving to the lowest position for storage.",
        reason: "shutdown",
        onLowered: ()=>setStep(2),
        onStopped: ()=>setDialogType(null),
        onError: ()=>setStep(2)
    });
    if (step === 2) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $06608456476ff5aa$export$2e2bcd8739ae039), {
        onUnpair: ()=>setStep(3)
    });
    return null;
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $f052a48fd4d80af9$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M11.5 2C6.81 2 3 5.81 3 10.5S6.81 19 11.5 19h.5v3c4.86-2.34 8-7 8-11.5C20 5.81 16.19 2 11.5 2m1 14.5h-2v-2h2zm0-3.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5"
}), 'ContactSupport');



var $eedE5 = parcelRequire("eedE5");

var $5CVHy = parcelRequire("5CVHy");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $4rInl = parcelRequire("4rInl");

var $h8IpO = parcelRequire("h8IpO");

var $8JNI1 = parcelRequire("8JNI1");

var $1lMle = parcelRequire("1lMle");

var $68A8d = parcelRequire("68A8d");

var $cK0UE = parcelRequire("cK0UE");

var $jP5af = parcelRequire("jP5af");

var $4xl3n = parcelRequire("4xl3n");

var $ezs3H = parcelRequire("ezs3H");

var $bDIpx = parcelRequire("bDIpx");


var $gqoJ3 = parcelRequire("gqoJ3");

var $62tuQ = parcelRequire("62tuQ");
const $db91e2e477a2e299$var$MIN_BATTERY_LEVEL = 35;
const $db91e2e477a2e299$var$MIN_BATTERY_LEVEL_USER = 20;
function $db91e2e477a2e299$export$57829e44ecf4fa0({ addMargin: addMargin = false }) {
    const intercom = (0, $bDIpx.default)();
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
        "aria-label": "help",
        color: "inherit",
        sx: {
            position: "absolute",
            right: addMargin ? 40 : 6,
            top: 6
        },
        onClick: ()=>intercom.newMessage(),
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $f052a48fd4d80af9$export$2e2bcd8739ae039), {})
    });
}
function $db91e2e477a2e299$export$3d51f2ecd9a449fc({ onConfirm: onConfirm }) {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { availableBuilds: availableBuilds } = (0, $dfce5f3c74840ea7$export$74524c73191a667c)();
    const { status: status } = (0, $ezs3H.useStatus)();
    const activeVersion = availableBuilds?.active.control ? (0, $68A8d.buildLabelToVersionString)(availableBuilds.active.control) : "N/A";
    $bh6RR.useEffect(()=>{
        if (status?.update?.inProgress) onConfirm();
    }, [
        onConfirm,
        status?.update?.inProgress
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jP5af.default), {
                variant: "h4",
                onClose: ()=>setDialogType(null),
                children: "Update"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $hHL9O.default), {
                        children: [
                            "This will update the trainer to ",
                            activeVersion,
                            ". The length of time required to update depends on network conditions."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        variant: "body1",
                        fontWeight: "bold",
                        mt: 2,
                        children: "Do not remove the batteries during this time or shut down the trainer. This could permanently damage the trainer."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        sx: {
                            mt: 4
                        },
                        children: "Do you want to continue?"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                    variant: "contained",
                    color: "secondary",
                    size: "large",
                    fullWidth: true,
                    onClick: onConfirm,
                    children: "Confirm"
                })
            })
        ]
    });
}
function $db91e2e477a2e299$export$63510af7e1a90dd1({ onConfirm: onConfirm }) {
    (0, $gqoJ3.default)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { status: status } = (0, $ezs3H.useStatus)();
    const batteryLevelGood = $bh6RR.useMemo(()=>{
        const batteryLevel = status?.trainer?.battery?.level;
        return batteryLevel && batteryLevel >= $db91e2e477a2e299$var$MIN_BATTERY_LEVEL_USER;
    }, [
        status?.trainer?.battery?.level
    ]);
    $bh6RR.useEffect(()=>{
        if (status?.update?.inProgress) onConfirm();
    }, [
        onConfirm,
        status?.update?.inProgress
    ]);
    const dismiss = $bh6RR.useCallback(()=>{
        setDialogType(null);
        (0, $1lMle.default).info("User chose to dismiss the update dialog", {
            trainerId: status?.clientId
        });
    }, [
        setDialogType,
        status?.clientId
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $jP5af.default), {
                variant: "h4",
                children: [
                    "Update",
                    /*#__PURE__*/ (0, $ih19M.jsx)($db91e2e477a2e299$export$57829e44ecf4fa0, {})
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        mt: 2,
                        children: 'The trainer should be updated before use. This could take up to 10 minutes.\xa0 Click "Update Now" to start the update or "Not Now" to update another time.'
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        variant: "body1",
                        fontWeight: "bold",
                        mt: 4,
                        children: "Do not remove the batteries during this time or shut down the trainer. This could permanently damage the trainer."
                    }),
                    !batteryLevelGood && /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        mt: 2,
                        color: "error",
                        children: "Battery level is too low to update."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    direction: "column",
                    sx: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "secondary",
                            size: "large",
                            fullWidth: true,
                            onClick: onConfirm,
                            disabled: !batteryLevelGood,
                            sx: {
                                mb: 2
                            },
                            children: "Update now"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "info",
                            size: "large",
                            fullWidth: true,
                            onClick: dismiss,
                            children: "Not now"
                        })
                    ]
                })
            })
        ]
    });
}
function $db91e2e477a2e299$export$5b8f4f80aa7c3618({ onConfirm: onConfirm }) {
    (0, $gqoJ3.default)();
    const { status: status } = (0, $ezs3H.useStatus)();
    const batteryLevelGood = $bh6RR.useMemo(()=>{
        const batteryLevel = status?.trainer?.battery?.level;
        return batteryLevel && batteryLevel >= $db91e2e477a2e299$var$MIN_BATTERY_LEVEL;
    }, [
        status?.trainer?.battery?.level
    ]);
    $bh6RR.useEffect(()=>{
        if (status?.update?.inProgress) onConfirm();
    }, [
        onConfirm,
        status?.update?.inProgress
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $jP5af.default), {
                variant: "h4",
                children: [
                    "Update",
                    /*#__PURE__*/ (0, $ih19M.jsx)($db91e2e477a2e299$export$57829e44ecf4fa0, {})
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        mt: 2,
                        children: 'The trainer should be updated before use. This could take up to 30 minutes, depending on network conditions\xa0 Click "Update Now" to start the update or "Not Now" to update another time.'
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        variant: "body1",
                        fontWeight: "bold",
                        mt: 4,
                        children: "Do not remove the batteries during this time or shut down the trainer. This could permanently damage the trainer."
                    }),
                    !batteryLevelGood && /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        mt: 2,
                        color: "error",
                        children: "Battery level is too low to update."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8JNI1.default), {
                    direction: "column",
                    sx: {
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                        variant: "contained",
                        color: "secondary",
                        size: "large",
                        fullWidth: true,
                        onClick: onConfirm,
                        disabled: !batteryLevelGood,
                        sx: {
                            mb: 2
                        },
                        children: "Update now"
                    })
                })
            })
        ]
    });
}
function $db91e2e477a2e299$export$b898046e3cf912a6({ onError: onError, onDone: onDone }) {
    (0, $gqoJ3.default)();
    const [updateRequested, setUpdateRequested] = $bh6RR.useState(0);
    const [updateStarted, setUpdateStarted] = $bh6RR.useState(false);
    const { status: status, startRapidPoll: startRapidPoll, removeRapidPollCheck: removeRapidPollCheck } = (0, $ezs3H.useStatus)();
    const { unpair: unpair } = (0, $4xl3n.usePairingContext)();
    $bh6RR.useEffect(()=>{
        const updateState = status?.update?.updateState;
        const validStates = [
            "Idle",
            "Cancelled",
            "Error"
        ];
        if (!updateState || !validStates.includes(updateState) || updateRequested) return;
        (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/user-update", "POST").catch((err)=>{
            (0, $1lMle.default).error(`Error requesting update: ${err.message}`, err);
            onError();
        }).finally(()=>{
            setUpdateRequested(performance.now());
        });
    }, [
        status?.clientId,
        onError,
        status?.update.updateState,
        updateRequested
    ]);
    $bh6RR.useEffect(()=>{
        if (updateRequested && !updateStarted && status?.update?.inProgress) setUpdateStarted(true);
    }, [
        status?.update?.inProgress,
        updateRequested,
        updateStarted
    ]);
    // rapid poll status to clear dialog asap
    $bh6RR.useEffect(()=>{
        startRapidPoll(1000, ()=>false, "userUpdate");
        return ()=>removeRapidPollCheck("userUpdate");
    }, [
        removeRapidPollCheck,
        startRapidPoll
    ]);
    $bh6RR.useEffect(()=>{
        if (updateRequested && updateStarted && status?.update?.updateState === "Error") {
            (0, $1lMle.default).error("Error in user update flow", status?.update);
            setUpdateRequested(0);
            setUpdateStarted(false);
            onError();
        }
        if (status?.update?.updateState === "Complete") {
            setUpdateRequested(0);
            setUpdateStarted(false);
            onDone();
        }
    }, [
        onDone,
        onError,
        status?.update,
        updateRequested,
        updateStarted
    ]);
    const updateText = $bh6RR.useMemo(()=>{
        if (!updateStarted) return "Update Requested...";
        if (status?.update?.updateState === "Downloading") return "Downloading...";
        if (status?.update?.updateState === "Installing") return "Installing update...";
        if (status?.update.inProgress) return "Updating...";
        return "";
    }, [
        updateStarted,
        status?.update?.updateState,
        status?.update.inProgress
    ]);
    const downloadInfo = $bh6RR.useMemo(()=>{
        let progress = 0;
        const { updateState: updateState } = status?.update ?? {};
        const { loaded: loaded, total: total, type: type } = status?.update?.download ?? {};
        if (updateState === "Downloading" && total && loaded) progress = loaded / total * 100;
        return {
            progress: progress,
            index: !type || type === "control" ? 0 : 1
        };
    }, [
        status?.update
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $jP5af.default), {
                variant: "h4",
                children: [
                    "Update",
                    /*#__PURE__*/ (0, $ih19M.jsx)($db91e2e477a2e299$export$57829e44ecf4fa0, {})
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        children: updateText
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        variant: "body1",
                        fontWeight: "bold",
                        mt: 2,
                        children: "Do not remove the batteries during this time or shut down the trainer. This could permanently damage the trainer."
                    }),
                    (updateRequested || status?.update.inProgress) && /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                        sx: {
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {})
                    })
                ]
            }),
            updateStarted && status?.update?.updateState === "Downloading" && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $hHL9O.default), {
                        children: [
                            "Download ",
                            downloadInfo.index + 1,
                            " of 2"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $h8IpO.default), {
                        variant: "determinate",
                        value: downloadInfo.progress
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8JNI1.default), {
                    direction: "column",
                    sx: {
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                        variant: "contained",
                        color: "secondary",
                        size: "large",
                        onClick: ()=>unpair(),
                        sx: {
                            mb: 2
                        },
                        children: "Disconnect (update will continue)"
                    })
                })
            })
        ]
    });
}
function $db91e2e477a2e299$export$41dc73b726c95fec() {
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { unpair: unpair } = (0, $4xl3n.usePairingContext)();
    const onConfirm = $bh6RR.useCallback(()=>{
        unpair();
        setDialogType(null);
    }, [
        setDialogType,
        unpair
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $jP5af.default), {
                variant: "h4",
                onClose: ()=>setDialogType(null),
                children: [
                    "Update",
                    /*#__PURE__*/ (0, $ih19M.jsx)($db91e2e477a2e299$export$57829e44ecf4fa0, {
                        addMargin: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                    children: "The update is complete. The trainer will now restart. This may take a few minutes."
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                    variant: "contained",
                    color: "secondary",
                    size: "large",
                    fullWidth: true,
                    onClick: onConfirm,
                    children: "Confirm"
                })
            })
        ]
    });
}
function $db91e2e477a2e299$export$760d89035838e1a7({ onDismiss: onDismiss }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $jP5af.default), {
                variant: "h4",
                children: [
                    "Update",
                    /*#__PURE__*/ (0, $ih19M.jsx)($db91e2e477a2e299$export$57829e44ecf4fa0, {})
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1W9Do.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                    children: "Update failed."
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK42r.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                    variant: "contained",
                    color: "error",
                    size: "large",
                    onClick: onDismiss,
                    children: "Cancel"
                })
            })
        ]
    });
}
function $db91e2e477a2e299$export$2e2bcd8739ae039({ force: force = false, isUserUpdate: isUserUpdate = false }) {
    const [step, setStep] = $bh6RR.useState(0);
    const { status: status } = (0, $ezs3H.useStatus)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const onError = $bh6RR.useCallback(()=>setStep(3), []);
    $bh6RR.useEffect(()=>{
        async function pauseWorkout() {
            if (status?.clientId) try {
                await (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/apps/workouts/pause", "POST");
            } catch (err) {
                (0, $1lMle.default).error("Error pausing workout", err);
            }
        }
        pauseWorkout();
    }, [
        status?.clientId
    ]);
    if (step === 0) {
        let StartComponent = $db91e2e477a2e299$export$3d51f2ecd9a449fc;
        if (force) StartComponent = $db91e2e477a2e299$export$5b8f4f80aa7c3618;
        else if (isUserUpdate) StartComponent = $db91e2e477a2e299$export$63510af7e1a90dd1;
        return /*#__PURE__*/ (0, $ih19M.jsx)(StartComponent, {
            onConfirm: ()=>setStep(1)
        });
    }
    if (step === 1) return /*#__PURE__*/ (0, $ih19M.jsx)($db91e2e477a2e299$export$b898046e3cf912a6, {
        onError: onError,
        onDone: ()=>setStep(2)
    });
    if (step === 2) return /*#__PURE__*/ (0, $ih19M.jsx)($db91e2e477a2e299$export$41dc73b726c95fec, {});
    if (step === 3) return /*#__PURE__*/ (0, $ih19M.jsx)($db91e2e477a2e299$export$760d89035838e1a7, {
        onDismiss: ()=>setDialogType(null)
    });
    return null;
}
function $db91e2e477a2e299$export$225388809cf777c2() {
    return /*#__PURE__*/ (0, $ih19M.jsx)($db91e2e477a2e299$export$2e2bcd8739ae039, {
        force: true,
        isUserUpdate: false
    });
}
function $db91e2e477a2e299$export$1d4352a3cf9aa28() {
    return /*#__PURE__*/ (0, $ih19M.jsx)($db91e2e477a2e299$export$2e2bcd8739ae039, {
        force: false,
        isUserUpdate: true
    });
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ec0eff3d524f9b2c$var$getDialogChildren(type) {
    switch(type){
        case "ClearObstructions":
            return 0, $aa8f67308ad198e0$export$2e2bcd8739ae039;
        case "RefillBallBin":
            return 0, $df15bd38d6a5a67a$export$2e2bcd8739ae039;
        case "ManualRefillBallBin":
            return 0, $00645d9c1e6ec7e3$export$2e2bcd8739ae039;
        case "ReplaceBatteries":
            return 0, $86bb8afe4699e2ad$export$2e2bcd8739ae039;
        case "BallJam":
            return 0, $d9865ed511012324$export$2e2bcd8739ae039;
        case "BallJamNoPowerDrop":
            return 0, $67448a78a925ea76$export$2e2bcd8739ae039;
        case "Unpair":
            return 0, $008aee3affed7072$export$2e2bcd8739ae039;
        case "NoConfirmUnpair":
            return 0, $b7522b3930e0d9ed$export$2e2bcd8739ae039;
        case "Shutdown":
            return 0, $62f4d732ceaddb73$export$2e2bcd8739ae039;
        case "NoConfirmShutdown":
            return 0, $8979458a99b143b4$export$2e2bcd8739ae039;
        case "RemovedBattery":
            return 0, $df13f571dfd3348e$export$2e2bcd8739ae039;
        case "Update":
            return 0, $db91e2e477a2e299$export$2e2bcd8739ae039;
        case "ForceUpdate":
            return 0, $db91e2e477a2e299$export$225388809cf777c2;
        case "UserUpdate":
            return 0, $db91e2e477a2e299$export$1d4352a3cf9aa28;
        case "TiltCalibrationFailure":
            return 0, $fa6d558a9f0a19b6$export$2e2bcd8739ae039;
        case "About":
            return 0, $a1931579effc0d5a$export$2e2bcd8739ae039;
        case "CalibrationSetup":
            return 0, $aa3b78f67da175a3$export$2e2bcd8739ae039;
        case "APTAId":
            return 0, $20d3319373ec90b8$export$3c40a5df05cde92b;
        case "InitialAPTAId":
            return 0, $20d3319373ec90b8$export$be80556e231894c4;
        case "InitialDuprConnect":
            return 0, $09a36d0ec1a0705c$export$2e2bcd8739ae039;
        case "EStop":
            return 0, $933b0698d152a332$export$2e2bcd8739ae039;
        case "FatalError":
            return 0, $b189567a869f8683$export$2e2bcd8739ae039;
        case "Finished":
            return 0, $be7267ad9826b217$export$2e2bcd8739ae039;
        case "ArmMoving":
            return 0, $8cb45a87b21cdf76$export$2e2bcd8739ae039;
        case "Calibrating":
            return 0, $0371568947c9a0c4$export$2e2bcd8739ae039;
        case "HardwareFailure":
            return 0, $414c144e2c18d120$export$2e2bcd8739ae039;
        case "HardwareShutdown":
            return 0, $1ed66809b48e4a45$export$2e2bcd8739ae039;
        case "PowerDown":
            return 0, $ef47b45cdff3b9fd$export$2e2bcd8739ae039;
        case "ServiceUnavailable":
            return 0, $fa916c2c9fb1d295$export$2e2bcd8739ae039;
        case "ShutdownCleanupChecklist":
            return 0, $f214969cee44af3c$export$91a0c4c1589f36a3;
        case "ShutdownFeedback":
            return 0, $ccdff366f9a49f4d$export$f00f0f7057ca95e7;
        case "DisconnectCleanupChecklist":
            return 0, $f214969cee44af3c$export$61a4b2d41ab91c59;
        case "DisconnectFeedback":
            return 0, $ccdff366f9a49f4d$export$b068dbffe314498d;
        case "ShutdownHardwareChecklist":
            return 0, $f214969cee44af3c$export$91a0c4c1589f36a3;
        case "WifiCredentials":
            return 0, $3d266225b8e5ed26$export$2e2bcd8739ae039;
        case "VisionFaultDialog":
            return 0, $ae7278535be4a1cc$export$f914897e1cdef869;
        case "VisionFaultCameraRequiredDialog":
            return 0, $ae7278535be4a1cc$export$501eaafbbaa642a1;
        case "InvalidSportSelection":
            return 0, $96df68da84261a05$export$2e2bcd8739ae039;
        case "SportSelectorWelcome":
            return 0, $3b163ddc44c20efc$export$1236e8a916f705fe;
        case "SportSelectorChange":
            return 0, $3b163ddc44c20efc$export$9b7adb518c14ce98;
        case "LowBatteryWarning":
            return 0, $fe8b729e4b857251$export$2e2bcd8739ae039;
        case "NoConfirmReplaceBatteries":
            return 0, $86bb8afe4699e2ad$export$4114a649c0cd87a8;
        case "ReportIssue":
            return 0, $1f2fdb3c9ce81056$export$2e2bcd8739ae039;
        case "AdvancedSettings":
            return 0, $679ec990694c00ac$export$2e2bcd8739ae039;
        default:
            return function EmptyComponent() {
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {});
            };
    }
}
const $ec0eff3d524f9b2c$var$showDeviceOnClose = [
    "Finished",
    "Shutdown",
    "Unpair",
    "HardwareFailure"
];
const $ec0eff3d524f9b2c$var$showWhileDisconnected = [
    "APTAId",
    "InitialAPTAId",
    "ShutdownCleanupChecklist",
    "Cleanup",
    "DisconnectCleanupChecklist",
    "ShutdownHardwareChecklist",
    "DisconnectFeedback",
    "ShutdownFeedback",
    "SportSelectorWelcome",
    "SportSelectorChange",
    "InitialDuprConnect",
    "AdvancedSettings"
];
const $ec0eff3d524f9b2c$var$DialogProvider = /*#__PURE__*/ $bh6RR.memo(({ children: children })=>{
    const { pathname: pathname } = (0, $as544.useLocation)();
    const { status: pairingStatus, sessionId: sessionId } = (0, $4xl3n.usePairingContext)();
    const { isAdmin: isAdmin, features: features } = (0, $W4f7l.useCurrentUser)();
    const trainerFeatures = (0, $lfvqn.useTrainerFeatures)();
    const { status: status, networkStateCode: networkStateCode } = (0, $ezs3H.useStatus)();
    const { updateRequired: updateRequired, buildsReadyToInstall: buildsReadyToIntall } = (0, $dfce5f3c74840ea7$export$74524c73191a667c)();
    const [stateDialogType, setDialogType] = $bh6RR.useState(null);
    const onClose = $bh6RR.useCallback(()=>{
        if (stateDialogType && $ec0eff3d524f9b2c$var$showDeviceOnClose.includes(stateDialogType)) setDialogType("Device");
        else setDialogType(null);
    }, [
        stateDialogType
    ]);
    const [dialogProps, setDialogProps] = $bh6RR.useState({
        onClose: onClose
    });
    const [drawerHeight, setDrawerHeight] = $bh6RR.useState("100vh");
    const [disableOnClose, setDisableOnClose] = $bh6RR.useState(false);
    const [ignoreProximity, setIgnoreProximity] = $bh6RR.useState(false);
    const [openedRefill, setOpenedRefill] = $bh6RR.useState(false);
    const [openedBallJam, setOpenedBallJam] = $bh6RR.useState(false);
    const [openedRemoved, setOpenRemoved] = $bh6RR.useState(false);
    const [batteryWarningDismissed, setBatteryWarningDismissed] = $bh6RR.useState(false);
    const [tiltCalibrationDismissed, setTiltCalibrationDismissed] = $bh6RR.useState(false);
    const [ballJamDismissed, setBallJamDismissed] = $bh6RR.useState(false);
    const forceDeviceDialog = $bh6RR.useMemo(()=>{
        if (pairingStatus !== "paired" || pathname.startsWith("/admin")) return false;
        if (stateDialogType === "ReportIssue") return false;
        // if there's a fault we force the dialog open, with a few exceptions
        if (status?.fault) {
            if (status.fault.failures.every((f)=>f.type === "SafetyIssue")) return !ignoreProximity;
            if (status.fault.failures.every((f)=>f.type === "BallBinEmpty")) return false;
            if (status.fault.failures.every((f)=>f.source === "vision")) return status?.trainer?.calibrated === "Uncalibrated";
            // If ball jam workflow completed and trainer is calibrated,
            // don't force Device dialog for FeedFailure faults
            if (ballJamDismissed && status?.trainer?.calibrated === "Calibrated" && status.fault.failures.every((f)=>f.type === "FeedFailure" || f.type === "FeedFailureNoPowerDrop" || f.type === "Other" && f.message === "Gate Sensor Failure")) return false;
            return true;
        }
        if (status?.ready === "INIT") return true;
        const needsCalibration = networkStateCode === "Connected" && status?.trainer?.calibrated !== "Calibrated";
        return needsCalibration || networkStateCode !== "Connected" && networkStateCode !== "Connecting";
    }, [
        pairingStatus,
        pathname,
        stateDialogType,
        status?.fault,
        status?.ready,
        status?.trainer?.calibrated,
        networkStateCode,
        ignoreProximity,
        ballJamDismissed
    ]);
    const dialogType = stateDialogType === null && forceDeviceDialog ? "Device" : stateDialogType;
    const DialogChildren = $bh6RR.useMemo(()=>$ec0eff3d524f9b2c$var$getDialogChildren(dialogType), [
        dialogType
    ]);
    const prevDialogType = (0, $NbKWd.default)(dialogType);
    $bh6RR.useEffect(()=>{
        if (prevDialogType !== dialogType) (0, $1lMle.default).info(`Changing dialog from ${prevDialogType ?? "none"} to ${dialogType || "none"}`);
    }, [
        prevDialogType,
        dialogType
    ]);
    $bh6RR.useEffect(()=>{
        if (pathname.toLowerCase().startsWith("/admin")) {
            setDialogType(null);
            return;
        }
        if (!status?.ready && dialogType && !$ec0eff3d524f9b2c$var$showWhileDisconnected.includes(dialogType)) {
            (0, $1lMle.default).info("Trainer status unavailable - dismissing all dialogs except cleanup");
            setDialogType(null);
            return;
        }
        if (pairingStatus !== "paired") return;
        if (updateRequired && !isAdmin()) // if we're below the min required version, show the update dialog
        {
            if (dialogType !== "Shutdown" && dialogType !== "Unpair") {
                (0, $1lMle.default).info("Showing update dialog");
                setDialogType("ForceUpdate");
                return;
            }
        }
        // we automatically open the user update dialog if:
        //  1. builds are ready to install
        //  3. we haven't shown the dialog yet this session
        if (buildsReadyToIntall && !isAdmin() && sessionId) {
            const lastSessionChecked = sessionStorage.getItem("builds_ready_to_install_last_session");
            const sessionChecked = lastSessionChecked === sessionId.toString();
            if (dialogType !== "Shutdown" && dialogType !== "Unpair" && !sessionChecked && status?.ready !== "INIT") {
                (0, $1lMle.default).info("Showing forced short update dialog");
                setDialogType("UserUpdate");
                sessionStorage.setItem("builds_ready_to_install_last_session", sessionId.toString());
                return;
            }
        }
        // if we're in the middle of an update, show the update dialog
        // if we're not already in an update dialog
        // this can happen if the user refreshes the page during an update
        const isShowingUpdateDialog = dialogType === "Update" || dialogType === "UserUpdate" || dialogType === "ForceUpdate";
        if (!isShowingUpdateDialog && status?.update?.inProgress) {
            setDialogType("Update");
            return;
        }
        if (networkStateCode === "ServiceConnectionDown" || networkStateCode === "TrainerConnectionDown" || networkStateCode === "ConnectionReestablishing") {
            if (dialogType !== "ServiceUnavailable") {
                (0, $1lMle.default).warn("Showing ServiceUnavailable dialog", {
                    networkStateCode: networkStateCode
                });
                setDialogType("ServiceUnavailable");
            }
            return;
        }
        const fault = status?.fault;
        if (fault?.failures.some((f)=>f.type === "EStop")) // if we're shutting down, ignore EStop
        {
            if (stateDialogType !== "NoConfirmShutdown") {
                (0, $1lMle.default).info("Showing EStop dialog");
                setDialogType("EStop");
                return;
            }
        }
        if (fault?.failures.some((f)=>f.type === "RemovedBattery")) // don't open battery removed dialog if we're in an update flow
        {
            if (!openedRemoved && dialogType !== "Update" && dialogType !== "BallJamNoPowerDrop") {
                (0, $1lMle.default).warn("Showing RemovedBattery dialog", {
                    fault: fault
                });
                setOpenRemoved(true);
                setDialogType("RemovedBattery");
                return;
            }
        }
        if (fault?.failures.some((f)=>f.type === "HardwareShutdown")) {
            (0, $1lMle.default).warn("Showing ShutdownCleanupChecklist dialog due to hardware shutdown", {
                fault: fault
            });
            setDialogType("ShutdownCleanupChecklist");
            return;
        }
        if (fault?.failures.some((f)=>f.type === "BallBinEmpty")) // only open refill dialog if we haven't opened it yet
        {
            if (!openedRefill) {
                setOpenedRefill(true);
                setDialogType("RefillBallBin");
            }
        }
        if (fault?.failures.length === 1 && (fault.failures[0].type === "FeedFailure" || fault.failures[0].type === "FeedFailureNoPowerDrop")) // only open refill dialog if we haven't opened it yet
        // also re-open if user dismissed (completed workflow) but calibration failed again
        {
            if (!openedBallJam || ballJamDismissed) {
                (0, $1lMle.default).info("Show EmptyBallBin dialog", {
                    fault: fault
                });
                setBallJamDismissed(false);
                setOpenedBallJam(true);
                if (fault.failures[0].type === "FeedFailureNoPowerDrop") setDialogType("BallJamNoPowerDrop");
                else setDialogType("BallJam");
            }
        }
        // special case for gate sensor failure for older trainers who don't
        // yet propogate gate sensor failures as a FeedFailureNoPowerDrop
        if (fault?.failures.length === 1 && fault.failures[0].type === "Other" && fault.failures[0].message === "Gate Sensor Failure") {
            if (!openedBallJam || ballJamDismissed) {
                (0, $1lMle.default).info("Show EmptyBallBin dialog", {
                    fault: fault
                });
                setBallJamDismissed(false);
                setOpenedBallJam(true);
                setDialogType("BallJamNoPowerDrop");
            }
        }
        // special case for tilt servo fault due to a ball in the head during calibration
        if (!tiltCalibrationDismissed && (0, $82c981ccb1aeb53c$export$adda08d0816d149a)(fault, trainerFeatures)) {
            (0, $1lMle.default).info(`Showing TiltCalibrationFailure workflow.`);
            setDialogType("TiltCalibrationFailure");
        }
        // no faults, reset if we've opened refill
        if (!fault || fault?.failures.every((f)=>f.source === "vision")) {
            setOpenedRefill(false);
            setOpenedBallJam(false);
            setOpenRemoved(false);
            setBallJamDismissed(false);
        }
        if (status?.ready === "INIT") {
            // if we're doing a battery swap or a battery was removed, we'll enter INIT state
            // but we want to stay in those flows
            // also, if there's a hardware failure, we want to show that dialog
            // or any of the shutdown/unpair dialogs
            if (dialogType === "ReplaceBatteries" || dialogType === "RemovedBattery" || dialogType === "BallJamNoPowerDrop" || dialogType === "HardwareFailure" || dialogType === "Finished" || dialogType === "Shutdown" || dialogType === "NoConfirmShutdown" || dialogType === "Unpair" || dialogType === "NoConfirmUnpair") return;
            setDialogType("Device");
        }
    }, [
        dialogType,
        networkStateCode,
        openedRefill,
        openedBallJam,
        openedRemoved,
        pairingStatus,
        pathname,
        stateDialogType,
        status?.softwareBuildLabel,
        status?.fault,
        status?.ready,
        status?.vision?.serviceState,
        status?.update?.inProgress,
        trainerFeatures,
        updateRequired,
        isAdmin,
        buildsReadyToIntall,
        features,
        sessionId,
        tiltCalibrationDismissed,
        ballJamDismissed
    ]);
    const value = $bh6RR.useMemo(()=>({
            dialogType: dialogType,
            forceDeviceDialog: forceDeviceDialog,
            ignoreProximity: ignoreProximity,
            batteryWarningDismissed: batteryWarningDismissed,
            onClose: onClose,
            setDialogProps: setDialogProps,
            setDisableOnClose: setDisableOnClose,
            setDialogType: setDialogType,
            setDrawerHeight: setDrawerHeight,
            setIgnoreProximity: setIgnoreProximity,
            setBatteryWarningDismissed: setBatteryWarningDismissed,
            setTiltCalibrationDismissed: setTiltCalibrationDismissed,
            setBallJamDismissed: setBallJamDismissed
        }), [
        dialogType,
        forceDeviceDialog,
        ignoreProximity,
        batteryWarningDismissed,
        onClose
    ]);
    // Reset dialog props on every `dialogType` change
    $bh6RR.useEffect(()=>{
        setDialogProps({
            onClose: onClose,
            fullWidth: true
        });
    }, [
        dialogType,
        onClose
    ]);
    const modalOpen = dialogType !== null && dialogType !== "Device";
    const drawerOpen = dialogType !== null && dialogType === "Device";
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $fb8oe.default).Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dUgAK.default), {
                ...dialogProps,
                onClose: disableOnClose ? undefined : dialogProps.onClose,
                open: modalOpen,
                children: modalOpen && /*#__PURE__*/ (0, $ih19M.jsx)(DialogChildren, {})
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $gIiKg.default), {
                role: drawerOpen ? "dialog" : undefined,
                open: drawerOpen,
                anchor: "top",
                onClose: forceDeviceDialog ? undefined : ()=>setDialogType(null),
                variant: "temporary",
                hideBackdrop: false,
                sx: {
                    "& .MuiDrawer-paper": {
                        backgroundColor: "#D0D2D8",
                        height: drawerHeight
                    }
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $70850d57de9869e6$export$2e2bcd8739ae039), {})
            })
        ]
    });
});
$ec0eff3d524f9b2c$var$DialogProvider.displayName = "DialogProvider";
var $ec0eff3d524f9b2c$export$2e2bcd8739ae039 = $ec0eff3d524f9b2c$var$DialogProvider;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $c0jqm = parcelRequire("c0jqm");

var $1d1FK = parcelRequire("1d1FK");

var $5CVHy = parcelRequire("5CVHy");

var $4rInl = parcelRequire("4rInl");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $cK0UE = parcelRequire("cK0UE");



var $jrL0R = parcelRequire("jrL0R");

var $W4f7l = parcelRequire("W4f7l");

var $asfIb = parcelRequire("asfIb");
function $cb357f32cdc295f0$export$2e2bcd8739ae039() {
    const { slug: slug } = (0, $as544.useParams)();
    const navigate = (0, $as544.useNavigate)();
    const { currentUser: currentUser } = (0, $W4f7l.useCurrentUser)();
    const [article, setArticle] = $bh6RR.useState(null);
    const [loading, setLoading] = $bh6RR.useState(true);
    // The Ask Volley ask this read belongs to, when there is one. Tapping a help
    // card saves the open chat before navigating, so the snapshot carries the
    // prompt and impression the answer was served against — which is what lets
    // the read and any escalation join the same funnel as the question.
    //
    // Attributed only when this very article was one of the cards served, so a
    // deep link or a bookmark opened while an unrelated chat is still saved is
    // left unattributed rather than credited to the wrong ask.
    const askContext = $bh6RR.useMemo(()=>{
        const snapshot = (0, $41b2e6bb65ce7f0b$export$8169690c1ed1afde)(currentUser?.id);
        if (!snapshot || !slug) return null;
        const wasServed = snapshot.thread.some((message)=>message.kind === "carousel" && message.cards.some((card)=>card.type === "HELP_ARTICLE" && card.metadata?.slug === slug));
        return wasServed ? snapshot : null;
    }, [
        currentUser?.id,
        slug
    ]);
    // One view per article opened, not per render.
    const viewRecorded = $bh6RR.useRef(false);
    $bh6RR.useEffect(()=>{
        if (viewRecorded.current || !article || !askContext) return;
        viewRecorded.current = true;
        (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: askContext.prompt,
            impressionUlid: askContext.impressionUlid,
            sportId: askContext.sportId,
            metadata: {
                action: "help_article_view",
                slug: article.slug
            }
        });
    }, [
        article,
        askContext
    ]);
    const recordEscalation = $bh6RR.useCallback((reason)=>{
        if (!askContext) return;
        (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: askContext.prompt,
            impressionUlid: askContext.impressionUlid,
            sportId: askContext.sportId,
            metadata: {
                action: "support_escalate",
                source: "help_article",
                reason: reason,
                slug: slug
            }
        });
    }, [
        askContext,
        slug
    ]);
    $bh6RR.useEffect(()=>{
        let cancelled = false;
        (async ()=>{
            setLoading(true);
            try {
                const result = await (0, $cK0UE.default)(`/api/help-articles/slug/${encodeURIComponent(slug ?? "")}`);
                if (!cancelled) setArticle(result);
            } catch (e) {
                (0, $cK0UE.logFetchError)(e, "Failed to fetch help article");
                if (!cancelled) setArticle(null);
            } finally{
                if (!cancelled) setLoading(false);
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        slug
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        sx: {
            maxWidth: 720,
            mx: "auto",
            px: 2,
            pb: 6
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                direction: "row",
                sx: {
                    alignItems: "center",
                    gap: 1,
                    py: 1.5
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                        "aria-label": "Back",
                        onClick: ()=>navigate(-1),
                        edge: "start",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $c0jqm.default), {})
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "h6",
                        sx: {
                            fontWeight: 600
                        },
                        children: "Help"
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0, $ih19M.jsx)((0, $8JNI1.default), {
                sx: {
                    alignItems: "center",
                    py: 6
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                    size: 28
                })
            }),
            !loading && !article && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                sx: {
                    py: 4
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "body1",
                        children: "We couldn't find that article."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $jrL0R.default), {
                        message: askContext?.freeTextSeed,
                        onEscalate: ()=>recordEscalation("article_missing"),
                        TypographyProps: {
                            align: "left"
                        },
                        children: "Message support"
                    })
                ]
            }),
            !loading && article && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "h5",
                        component: "h1",
                        sx: {
                            fontWeight: 700,
                            mb: 2
                        },
                        children: article.title
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $asfIb.default), {
                        html: article.bodyHtml
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $jrL0R.default), {
                        preText: "Still stuck?",
                        message: askContext?.freeTextSeed,
                        onEscalate: ()=>recordEscalation("read_article"),
                        TypographyProps: {
                            align: "left",
                            sx: {
                                mt: 4
                            }
                        },
                        children: "Message support"
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $8JNI1 = parcelRequire("8JNI1");

var $cK0UE = parcelRequire("cK0UE");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $506bB = parcelRequire("506bB");

var $eedE5 = parcelRequire("eedE5");

var $euyyI = parcelRequire("euyyI");
const $801236f4e9a889e8$var$ShareSnackbar = ()=>{
    const navigate = (0, $as544.useNavigate)();
    const location = (0, $as544.useLocation)();
    const locationState = location.state;
    const [showSnackbar, setShowSnackbar] = $bh6RR.useState(!!locationState?.workoutShareSucceeded || !!locationState?.journeyInstanceShareUlid);
    const onClose = (_event, reason)=>{
        if (reason === "clickaway") return;
        setShowSnackbar(false);
    };
    const snackbarMessage = $bh6RR.useMemo(()=>{
        if (locationState?.workoutShareSucceeded) return "New workouts added to your history!";
        if (locationState?.journeyInstanceShareUlid) return "Assessment Successfully Added to Your Account";
        return null;
    }, [
        locationState
    ]);
    const snackbarAction = $bh6RR.useMemo(()=>{
        if (locationState?.workoutShareSucceeded) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
            variant: "contained",
            color: "info",
            onClick: ()=>{
                // clear the location state so hitting back from My
                // Workouts won't display this toast again
                navigate("/", {
                    replace: true,
                    state: undefined
                });
                navigate("/content/apps/workouts/user");
            },
            children: "View"
        });
        if (locationState?.journeyInstanceShareUlid) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
            variant: "contained",
            color: "info",
            onClick: ()=>{
                navigate("/", {
                    replace: true,
                    state: undefined
                });
                navigate(`/journeys/assessments/${locationState.journeyInstanceShareUlid}/result`);
            },
            children: "View"
        });
        return null;
    }, [
        locationState,
        navigate
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $euyyI.default), {
        open: showSnackbar,
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $506bB.default), {
            severity: "info",
            action: snackbarAction,
            onClose: onClose,
            children: snackbarMessage
        })
    });
};
var $801236f4e9a889e8$export$2e2bcd8739ae039 = $801236f4e9a889e8$var$ShareSnackbar;



var $76QOg = parcelRequire("76QOg");

var $ezs3H = parcelRequire("ezs3H");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");


var $9GahD = parcelRequire("9GahD");

var $j4ol5 = parcelRequire("j4ol5");

var $8JNI1 = parcelRequire("8JNI1");

var $kjzzE = parcelRequire("kjzzE");

var $1lMle = parcelRequire("1lMle");


var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $bZrpr = parcelRequire("bZrpr");

var $iTU6T = parcelRequire("iTU6T");

var $1d1FK = parcelRequire("1d1FK");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");
function $f4d5f23f499595fd$export$2e2bcd8739ae039({ year: year }) {
    const navigate = (0, $as544.useNavigate)();
    const displayYear = year ?? new Date().getFullYear();
    const handleClick = ()=>{
        navigate(`/stats/year-in-review/${displayYear}`);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        onClick: handleClick,
        sx: {
            cursor: "pointer",
            borderRadius: 2,
            overflow: "hidden",
            background: "linear-gradient(135deg, rgb(11, 23, 48) 0%, rgb(21, 39, 86) 50%, rgb(9, 110, 229) 100%)",
            minHeight: 220,
            p: 3,
            display: "flex",
            alignItems: "center",
            position: "relative",
            "&:hover": {
                "& .chevron": {
                    transform: "translateX(4px)"
                }
            }
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                sx: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                        spacing: 1.5,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bZrpr.default), {
                                        sx: {
                                            color: "rgb(60, 233, 124)",
                                            fontSize: 28
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                        variant: "h4",
                                        sx: {
                                            color: "rgb(60, 233, 124)",
                                            fontWeight: "bold",
                                            letterSpacing: 1
                                        },
                                        children: "NEW"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                                variant: "h2",
                                sx: {
                                    color: "#fff",
                                    fontSize: {
                                        xs: "1.5rem",
                                        sm: "2rem"
                                    },
                                    fontWeight: "bold"
                                },
                                children: [
                                    displayYear,
                                    " Year in Review"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                variant: "body2",
                                sx: {
                                    color: "rgba(255,255,255,0.7)",
                                    maxWidth: 250
                                },
                                children: "See your training highlights, top workouts, and more!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $iTU6T.default), {
                        className: "chevron",
                        sx: {
                            color: "#fff",
                            fontSize: 40,
                            opacity: 0.7,
                            transition: "transform 0.2s ease"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                sx: {
                    position: "absolute",
                    top: -20,
                    right: -20,
                    width: 120,
                    height: 120,
                    borderRadius: "50%",
                    background: "radial-gradient(circle, rgba(60,233,124,0.2) 0%, transparent 70%)",
                    pointerEvents: "none"
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                sx: {
                    position: "absolute",
                    bottom: -30,
                    right: 60,
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    background: "radial-gradient(circle, rgba(9,110,229,0.3) 0%, transparent 70%)",
                    pointerEvents: "none"
                }
            })
        ]
    });
}
function $f4d5f23f499595fd$export$9b15b141faa6f6ce() {
    const now = new Date();
    const month = now.getMonth();
    const year = now.getFullYear();
    // In January, show previous year's review
    return month === 0 ? year - 1 : year;
}



var $76QOg = parcelRequire("76QOg");

var $W4f7l = parcelRequire("W4f7l");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $iTU6T = parcelRequire("iTU6T");

var $8dR8l = parcelRequire("8dR8l");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $dUgAK = parcelRequire("dUgAK");

var $bK42r = parcelRequire("bK42r");

var $1W9Do = parcelRequire("1W9Do");

var $hHL9O = parcelRequire("hHL9O");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");
parcelRequire("cFAEN");
var $cK0UE = parcelRequire("cK0UE");

var $7uFU8 = parcelRequire("7uFU8");

var $g6rVl = parcelRequire("g6rVl");
async function $3d40638987c76c25$export$bfd364b38a61b7b(selectedSport, controller) {
    if (selectedSport !== "PLATFORM_TENNIS") return null;
    const url = new URL("/api/journeys", window.location.origin);
    url.searchParams.set("limit", "100");
    url.searchParams.set("offset", "0");
    url.searchParams.set("type", "assessment");
    url.searchParams.set("sport", selectedSport);
    try {
        const result = await (0, $cK0UE.default)(url.toString(), "GET", undefined, {
            signal: controller.signal
        });
        const candidate = result.result.find((j)=>j.name === "CUTTER_CHALLENGE");
        return candidate ?? null;
    } catch  {
        return null;
    }
}
function $3d40638987c76c25$export$2e2bcd8739ae039({ journey: journey }) {
    const navigate = (0, $as544.useNavigate)();
    const { startJourney: startJourney, registerJourneyLinkIntent: registerJourneyLinkIntent } = (0, $g6rVl.default)();
    const [dialogOpen, setDialogOpen] = $bh6RR.useState(false);
    const onConfirm = $bh6RR.useCallback(async ()=>{
        if (!journey) return;
        const instance = await startJourney(journey.id);
        const firstWorkout = journey.journeyAppWorkouts.at(0);
        if (firstWorkout) {
            await registerJourneyLinkIntent(instance.ulid, firstWorkout.appWorkout.id);
            navigate(`/content/apps/workouts/plugin/play/${firstWorkout.appWorkout.appId}/${firstWorkout.appWorkout.id}`);
        } else navigate((0, $7uFU8.inProgressUrl)({
            journeyType: journey.type,
            journeyInstanceId: instance.id,
            journeyInstanceUlid: instance.ulid
        }));
    }, [
        journey,
        startJourney,
        registerJourneyLinkIntent,
        navigate
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                onClick: ()=>setDialogOpen(true),
                sx: {
                    cursor: "pointer",
                    borderRadius: 2,
                    overflow: "hidden",
                    background: (theme)=>`linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 60%, ${theme.palette.info.main} 100%)`,
                    minHeight: 95,
                    width: "100%",
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    "&:hover": {
                        "& .chevron": {
                            transform: "translateX(4px)"
                        }
                    }
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    direction: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    sx: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                            spacing: 0.5,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                                    direction: "row",
                                    spacing: 1,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $8dR8l.default), {
                                            sx: {
                                                color: "secondary.main",
                                                fontSize: 20
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                            variant: "h4",
                                            sx: {
                                                color: "#fff",
                                                fontWeight: "bold"
                                            },
                                            children: journey.title ?? "Cutter Challenge"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                    variant: "body2",
                                    sx: {
                                        color: "rgba(255,255,255,0.7)",
                                        fontSize: "0.75rem",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical"
                                    },
                                    children: journey.description ?? "Join the challenge!"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $iTU6T.default), {
                            className: "chevron",
                            sx: {
                                color: "#fff",
                                fontSize: 32,
                                opacity: 0.7,
                                transition: "transform 0.2s ease",
                                flexShrink: 0
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dUgAK.default), {
                open: dialogOpen,
                onClose: ()=>setDialogOpen(false),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1W9Do.default), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $hHL9O.default), {
                                sx: {
                                    pb: 2
                                },
                                children: [
                                    "Are you ready to start",
                                    " ",
                                    /*#__PURE__*/ (0, $ih19M.jsx)("strong", {
                                        children: journey?.title ?? ""
                                    }),
                                    "?"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $hHL9O.default), {
                                children: journey?.description ?? ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bK42r.default), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                color: "inherit",
                                autoFocus: true,
                                onClick: ()=>setDialogOpen(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                color: "inherit",
                                onClick: onConfirm,
                                children: "Let's go!"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $iTU6T = parcelRequire("iTU6T");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $1e71a6223f3e8211$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1 1.1-.49 1.1-1.1-.49-1.1-1.1-1.1M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m2.19 12.19L6 18l3.81-8.19L18 6z"
}), 'Explore');



var $1d1FK = parcelRequire("1d1FK");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");
function $a57c8de8b0c4125c$export$2e2bcd8739ae039() {
    const navigate = (0, $as544.useNavigate)();
    const handleClick = ()=>{
        navigate("/journeys/assessments");
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
        onClick: handleClick,
        sx: {
            cursor: "pointer",
            borderRadius: 2,
            overflow: "hidden",
            background: (theme)=>`linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 60%, ${theme.palette.secondary.main} 100%)`,
            minHeight: 95,
            width: "100%",
            p: 2,
            display: "flex",
            alignItems: "center",
            position: "relative",
            "&:hover": {
                "& .chevron": {
                    transform: "translateX(4px)"
                }
            }
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
            direction: "row",
            alignItems: "center",
            justifyContent: "space-between",
            sx: {
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    spacing: 0.5,
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1e71a6223f3e8211$export$2e2bcd8739ae039), {
                                    sx: {
                                        color: "secondary.main",
                                        fontSize: 20
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                    variant: "h4",
                                    sx: {
                                        color: "#fff",
                                        fontWeight: "bold"
                                    },
                                    children: "Start Your Volley Journey"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "body2",
                            sx: {
                                color: "rgba(255,255,255,0.7)",
                                fontSize: "0.75rem"
                            },
                            children: "Take skill assessments to get feedback on your game"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $iTU6T.default), {
                    className: "chevron",
                    sx: {
                        color: "#fff",
                        fontSize: 32,
                        opacity: 0.7,
                        transition: "transform 0.2s ease"
                    }
                })
            ]
        })
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $bZrpr = parcelRequire("bZrpr");

var $iTU6T = parcelRequire("iTU6T");

var $1d1FK = parcelRequire("1d1FK");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");
function $6f7a4922937fd490$export$2e2bcd8739ae039({ year: year }) {
    const navigate = (0, $as544.useNavigate)();
    const displayYear = year ?? new Date().getFullYear();
    const handleClick = ()=>{
        navigate(`/stats/year-in-review/${displayYear}`);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
        onClick: handleClick,
        sx: {
            cursor: "pointer",
            borderRadius: 2,
            overflow: "hidden",
            background: (theme)=>`linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.primary.light} 100%)`,
            minHeight: 95,
            width: "100%",
            p: 2,
            display: "flex",
            alignItems: "center",
            position: "relative",
            "&:hover": {
                "& .chevron": {
                    transform: "translateX(4px)"
                }
            }
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
            direction: "row",
            alignItems: "center",
            justifyContent: "space-between",
            sx: {
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    spacing: 0.5,
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $bZrpr.default), {
                                    sx: {
                                        color: "secondary.main",
                                        fontSize: 20
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                    variant: "h5",
                                    sx: {
                                        color: "secondary.main",
                                        fontWeight: "bold",
                                        letterSpacing: 1
                                    },
                                    children: "NEW"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                            variant: "h4",
                            sx: {
                                color: "#fff",
                                fontWeight: "bold"
                            },
                            children: [
                                displayYear,
                                " Year in Review"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "body2",
                            sx: {
                                color: "rgba(255,255,255,0.7)",
                                fontSize: "0.75rem"
                            },
                            children: "See your training highlights and top workouts!"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $iTU6T.default), {
                    className: "chevron",
                    sx: {
                        color: "#fff",
                        fontSize: 32,
                        opacity: 0.7,
                        transition: "transform 0.2s ease"
                    }
                })
            ]
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $cK0UE = parcelRequire("cK0UE");

var $76QOg = parcelRequire("76QOg");
const $a046b59bbb6f4fe3$var$HomeDuprContext = /*#__PURE__*/ $bh6RR.createContext(null);
function $a046b59bbb6f4fe3$export$fa46ab00627a53e2({ children: children }) {
    const { selected: sport } = (0, $76QOg.useSelectedSport)();
    // Only pickleball players have any use for this, so nobody else pays for the
    // request. This used to also wait on the DUPR flow feature, which meant
    // waiting on `featuresLoaded` to tell "not granted" apart from "not loaded
    // yet" — the assessment is no longer feature-gated, so the sport is the
    // whole condition.
    const shouldFetch = sport === "PICKLEBALL";
    const [profile, setProfile] = $bh6RR.useState(null);
    const [hasSubmitted, setHasSubmitted] = $bh6RR.useState(false);
    // Starts true so consumers withhold rather than flash: the sport context
    // reports PLATFORM_TENNIS before it resolves, so "not pickleball" is not yet
    // a settled answer on the first render.
    const [loading, setLoading] = $bh6RR.useState(true);
    // A ref, not an effect-scoped flag: `load` is also called manually via
    // refetch(), whose result can land after unmount just as the initial fetch's
    // can, and a per-effect closure wouldn't cover that.
    const mounted = $bh6RR.useRef(true);
    $bh6RR.useEffect(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const load = $bh6RR.useCallback(async ()=>{
        if (!shouldFetch) {
            // Settled, not pending: there is nothing to wait for.
            if (mounted.current) {
                setProfile(null);
                setHasSubmitted(false);
                setLoading(false);
            }
            return;
        }
        setLoading(true);
        try {
            const res = await (0, $cK0UE.default)("/api/integrations/dupr/home-status");
            if (mounted.current) {
                setProfile(res.profile);
                setHasSubmitted(res.hasSubmittedToDupr);
            }
        } catch (err) {
            // No error state: DUPR standing is supplementary on this screen, so a
            // failure degrades to the unlinked presentation rather than
            // interrupting the home screen.
            (0, $cK0UE.logFetchError)(err, "Failed to load DUPR home status");
            if (mounted.current) {
                setProfile(null);
                setHasSubmitted(false);
            }
        } finally{
            if (mounted.current) setLoading(false);
        }
    }, [
        shouldFetch
    ]);
    $bh6RR.useEffect(()=>{
        load();
    }, [
        load
    ]);
    const value = $bh6RR.useMemo(()=>({
            profile: profile,
            hasSubmitted: hasSubmitted,
            loading: loading,
            refetch: load
        }), [
        profile,
        hasSubmitted,
        loading,
        load
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($a046b59bbb6f4fe3$var$HomeDuprContext.Provider, {
        value: value,
        children: children
    });
}
function $a046b59bbb6f4fe3$export$dfdd01146dc6f769() {
    const context = $bh6RR.useContext($a046b59bbb6f4fe3$var$HomeDuprContext);
    if (!context) throw new Error("useHomeDupr must be used within HomeDuprProvider");
    return context;
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $cK0UE = parcelRequire("cK0UE");

var $76QOg = parcelRequire("76QOg");
const $478bae5a1981a49e$var$HomePtiContext = /*#__PURE__*/ $bh6RR.createContext(null);
function $478bae5a1981a49e$export$d43e0738e73f0d05({ children: children }) {
    const { selected: sport } = (0, $76QOg.useSelectedSport)();
    // PTI is a platform tennis rating, so nobody else pays for the request.
    const shouldFetch = sport === "PLATFORM_TENNIS";
    const [rating, setRating] = $bh6RR.useState(null);
    const [hasAptaId, setHasAptaId] = $bh6RR.useState(false);
    // Starts pending so consumers withhold rather than flash.
    const [state, setState] = $bh6RR.useState("loading");
    // A ref, not an effect-scoped flag: `load` is also called via refetch(),
    // whose result can land after unmount just as the initial fetch's can.
    const mounted = $bh6RR.useRef(true);
    $bh6RR.useEffect(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const load = $bh6RR.useCallback(async ()=>{
        if (!shouldFetch) {
            // Settled, not pending: there is nothing to wait for. `hasAptaId`
            // false is honest here — this player is not in a sport that asks.
            if (mounted.current) {
                setRating(null);
                setHasAptaId(false);
                setState("loaded");
            }
            return;
        }
        setState("loading");
        try {
            const res = await (0, $cK0UE.default)("/api/pti/summary");
            if (mounted.current) {
                setRating(res.rating);
                setHasAptaId(res.hasAptaId);
                setState("loaded");
            }
        } catch (err) {
            (0, $cK0UE.logFetchError)(err, "Failed to load PTI summary");
            if (mounted.current) {
                setRating(null);
                setHasAptaId(false);
                // "error", never "loaded": we did not learn that this player has
                // no APTA number, so nothing may act as though we did.
                setState("error");
            }
        }
    }, [
        shouldFetch
    ]);
    $bh6RR.useEffect(()=>{
        load();
    }, [
        load
    ]);
    const value = $bh6RR.useMemo(()=>({
            rating: rating,
            hasAptaId: hasAptaId,
            state: state,
            refetch: load
        }), [
        rating,
        hasAptaId,
        state,
        load
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($478bae5a1981a49e$var$HomePtiContext.Provider, {
        value: value,
        children: children
    });
}
function $478bae5a1981a49e$export$7a3fe963304383f4() {
    const context = $bh6RR.useContext($478bae5a1981a49e$var$HomePtiContext);
    if (!context) throw new Error("useHomePti must be used within HomePtiProvider");
    return context;
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $cbFbS = parcelRequire("cbFbS");
function $02156a51ea3eae63$export$2e2bcd8739ae039({ globalBallsThrown: globalBallsThrown }) {
    const formattedCount = Intl.NumberFormat().format(globalBallsThrown);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
        variant: "body2",
        sx: {
            textAlign: "center",
            color: "white",
            fontSize: "0.8rem",
            margin: "20px 0 15px 0",
            fontWeight: 600
        },
        children: `Volley trainers have thrown ${formattedCount} balls`
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $8yAk0 = parcelRequire("8yAk0");

var $8HCQF = parcelRequire("8HCQF");

var $1d1FK = parcelRequire("1d1FK");

var $95FNu = parcelRequire("95FNu");

var $5CVHy = parcelRequire("5CVHy");

var $5Z0If = parcelRequire("5Z0If");

var $cbFbS = parcelRequire("cbFbS");

var $jzjwW = parcelRequire("jzjwW");

var $2jcKA = parcelRequire("2jcKA");

var $54VCJ = parcelRequire("54VCJ");

var $2VZfN = parcelRequire("2VZfN");
function $638ad77d77397e92$var$StatusItem({ to: to, onClick: onClick, children: children }) {
    const variantProps = to ? {
        component: (0, $as544.Link),
        to: to
    } : {
        component: "button",
        type: "button",
        onClick: onClick
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5Z0If.default), {
        ...variantProps,
        sx: {
            flex: 1,
            textAlign: "center",
            color: "white",
            fontSize: "0.8rem",
            fontWeight: 600,
            fontFamily: "inherit",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "4px",
            cursor: "pointer",
            textDecoration: "none",
            border: "none",
            background: "none",
            padding: 0,
            "&:hover": {
                textDecoration: "underline"
            }
        },
        children: children
    });
}
/**
 * The DUPR rating panels to rotate through for a linked account: one per rated
 * format (Doubles/Singles), ordered with DUPR's primary format (`defaultRating`)
 * first. When linked but unrated, returns a single "NR" panel so the user still
 * sees their link state (confirming the pairing) rather than the connect prompt.
 */ function $638ad77d77397e92$var$duprRatingsToShow(profile) {
    const formats = [
        {
            label: "Doubles",
            key: "DOUBLES",
            value: profile.doubles?.value
        },
        {
            label: "Singles",
            key: "SINGLES",
            value: profile.singles?.value
        }
    ];
    const rated = formats.filter((f)=>!!f.value && f.value !== "NR");
    if (rated.length > 0) {
        // Primary format first so the user's main rating leads the rotation.
        rated.sort((a, b)=>a.key === profile.defaultRating ? -1 : b.key === profile.defaultRating ? 1 : 0);
        return rated.map(({ label: label, value: value })=>({
                label: label,
                value: value
            }));
    }
    const primaryLabel = profile.defaultRating === "SINGLES" ? "Singles" : "Doubles";
    return [
        {
            label: primaryLabel,
            value: "NR"
        }
    ];
}
function $638ad77d77397e92$var$StatusDivider() {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
        sx: {
            width: "3px",
            height: "20px",
            backgroundColor: "#2c3e50",
            flexShrink: 0
        }
    });
}
function $638ad77d77397e92$var$PtiTrendIcon({ trend: trend, ...props }) {
    switch(trend){
        case -1:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8yAk0.default), {
                ...props
            });
        case 0:
            return null;
        case 1:
        default:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8HCQF.default), {
                ...props,
                sx: {
                    color: (theme)=>`${theme.palette.success.main} !important`,
                    ...props.sx
                }
            });
    }
}
const $638ad77d77397e92$var$ratingChipSx = (theme)=>({
        px: 1,
        textDecoration: "none",
        background: theme.palette.background.default,
        color: theme.palette.text.primary
    });
/** A DUPR rating chip with the format (Singles/Doubles) as a second line. */ function $638ad77d77397e92$var$DuprRatingItem({ label: label, value: value }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)($638ad77d77397e92$var$StatusItem, {
        to: "/dupr-dashboard",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
            sx: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "2px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $95FNu.default), {
                    size: "small",
                    label: `DUPR ${(0, $2jcKA.formatDuprRating)(value)}`,
                    sx: $638ad77d77397e92$var$ratingChipSx
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                    component: "span",
                    sx: {
                        fontSize: "0.65rem",
                        fontWeight: 600,
                        lineHeight: 1
                    },
                    children: label
                })
            ]
        })
    });
}
function $638ad77d77397e92$export$2e2bcd8739ae039({ atAGlance: atAGlance, goalData: goalData, sport: sport, duprProfile: duprProfile, duprLoading: duprLoading, pti: pti, ptiLoading: ptiLoading, onConnectDupr: onConnectDupr }) {
    const goalProgress = $bh6RR.useMemo(()=>{
        if (goalData?.goal) {
            const target = parseInt(goalData.goal.target, 10);
            return Math.round(goalData.actual / target * 100);
        }
        return null;
    }, [
        goalData
    ]);
    const volleyLevelContent = /*#__PURE__*/ (0, $ih19M.jsxs)($638ad77d77397e92$var$StatusItem, {
        to: "/stats/achievements",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $54VCJ.default), {
                achievementId: atAGlance.activityAchievement.id,
                fontSize: "small"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                component: "span",
                sx: {
                    fontSize: "inherit",
                    fontWeight: "inherit"
                },
                children: atAGlance.activityAchievement.name
            })
        ]
    });
    const ptiContent = !ptiLoading && pti?.value != null ? /*#__PURE__*/ (0, $ih19M.jsx)($638ad77d77397e92$var$StatusItem, {
        to: "/player-pti/summary",
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $95FNu.default), {
            size: "small",
            label: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    "PTI ",
                    pti.value,
                    " ",
                    /*#__PURE__*/ (0, $ih19M.jsx)($638ad77d77397e92$var$PtiTrendIcon, {
                        trend: pti.trend ?? 0,
                        sx: {
                            fontSize: "1.2rem",
                            verticalAlign: "middle"
                        }
                    })
                ]
            }),
            sx: $638ad77d77397e92$var$ratingChipSx
        })
    }) : null;
    const connectContent = /*#__PURE__*/ (0, $ih19M.jsx)($638ad77d77397e92$var$StatusItem, {
        onClick: onConnectDupr,
        children: "Connect DUPR"
    });
    // A single static panel. Pickleball surfaces DUPR only — the linked rating
    // (primary format) or the connect prompt, never the Volley level; nothing
    // while the DUPR fetch is in flight. Platform tennis shows PTI; all other
    // cases fall back to the Volley level. (This cell used to rotate through
    // every rating and the Volley level for users off the DUPR flow.)
    let middleContent = null;
    if (sport === "PICKLEBALL") {
        if (!duprLoading) middleContent = duprProfile ? /*#__PURE__*/ (0, $ih19M.jsx)($638ad77d77397e92$var$DuprRatingItem, {
            ...$638ad77d77397e92$var$duprRatingsToShow(duprProfile)[0]
        }) : connectContent;
    } else if (sport === "PLATFORM_TENNIS" && ptiContent) middleContent = ptiContent;
    else middleContent = volleyLevelContent;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        sx: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "transparent",
            border: "2px solid #2c3e50",
            borderRadius: "8px",
            marginTop: "15px",
            padding: "10px 5px"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2VZfN.default), {
                flag: (0, $jzjwW.MY_GAME_FEATURE),
                source: "user_feature",
                enabled: /*#__PURE__*/ (0, $ih19M.jsx)($638ad77d77397e92$var$StatusItem, {
                    to: "/stats/my-game",
                    children: "My Game"
                }),
                default: /*#__PURE__*/ (0, $ih19M.jsx)($638ad77d77397e92$var$StatusItem, {
                    to: "/stats/goal",
                    children: goalProgress !== null ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: "6px"
                        },
                        children: [
                            goalProgress > 0 && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                                sx: {
                                    position: "relative",
                                    display: "flex"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                                        variant: "determinate",
                                        value: 100,
                                        size: 24,
                                        sx: {
                                            color: "rgba(255, 255, 255, 0.2)"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                                        variant: "determinate",
                                        value: Math.min(goalProgress, 100),
                                        size: 24,
                                        sx: {
                                            color: "#4ade80",
                                            position: "absolute",
                                            left: 0
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                        children: [
                                            goalProgress,
                                            "%"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        children: "Goal"
                                    })
                                ]
                            })
                        ]
                    }) : "Set Goal"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)($638ad77d77397e92$var$StatusDivider, {}),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                sx: {
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: middleContent
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)($638ad77d77397e92$var$StatusDivider, {}),
            /*#__PURE__*/ (0, $ih19M.jsx)($638ad77d77397e92$var$StatusItem, {
                to: "/stats/leaderboard",
                children: atAGlance.globalRank > 0 ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                            children: [
                                "#",
                                Intl.NumberFormat().format(atAGlance.globalRank)
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            children: "Leaderboard"
                        })
                    ]
                }) : "Leaderboard"
            })
        ]
    });
}


function $7186da02e657d657$export$2e2bcd8739ae039({ atAGlance: atAGlance, goalData: goalData, yearInReviewYears: yearInReviewYears }) {
    const { selected: selectedSport } = (0, $76QOg.useSelectedSport)();
    const { features: features } = (0, $W4f7l.useCurrentUser)();
    const [currentSlide, setCurrentSlide] = $bh6RR.useState(0);
    const [state, setState] = $bh6RR.useState(null);
    // DUPR (pickleball) rating shown in the StatusStrip. Shared with the
    // library's assessment entry via the home provider, which owns the sport and
    // feature gating and the "waiting, so withhold" loading state — this used to
    // be a second, independent fetch of the same profile.
    const { profile: duprProfile, loading: duprLoading, refetch: refetchDupr } = (0, $a046b59bbb6f4fe3$export$dfdd01146dc6f769)();
    // PTI (platform tennis) rating shown in the StatusStrip. Shared with the
    // library's PTI entry via the home provider, for the same reasons.
    const { rating: pti, state: ptiState } = (0, $478bae5a1981a49e$export$7a3fe963304383f4)();
    // Re-fetch after the connect dialog closes so a freshly linked account
    // surfaces in the strip without a full reload. DuprConnect links inside its
    // own dialog and doesn't notify its host, so the close is the only signal.
    const { launchDuprConnect: launchDuprConnect, dialog: duprDialog } = (0, $2306f394fbe75dd1$export$a195d94d08cd882e)({
        onClose: ()=>{
            refetchDupr();
        }
    });
    $bh6RR.useEffect(()=>{
        const controller = new AbortController();
        setCurrentSlide(0);
        (0, $1lMle.default).info(`[Home Carousel] - Determining which home carousel items to show for ${selectedSport}`);
        let number = 1;
        const showTakeAssessment = features.includes("JOURNEY_INSTANCES_AT_A_GLANCE") && !features.includes("ASSESSMENT_DASHBOARD_V2");
        if (showTakeAssessment) {
            number += 1;
            (0, $1lMle.default).info(`[Home Carousel] - Will show start journey card - card count [${number}]`);
        }
        const showYearInReview = (yearInReviewYears ?? []).includes((0, $f4d5f23f499595fd$export$9b15b141faa6f6ce)());
        if (showYearInReview) {
            number += 1;
            (0, $1lMle.default).info(`[Home Carousel] - Will show year in review card - card count [${number}]`);
        }
        const showCutterChallenge = features.includes("CUTTER_CHALLENGE");
        if (showCutterChallenge) {
            let cutterChallengeJourney = null;
            (0, $1lMle.default).info(`[Home Carousel] - Looking for cutter challenge journey...`);
            (0, $3d40638987c76c25$export$bfd364b38a61b7b)(selectedSport, controller).then((result)=>{
                cutterChallengeJourney = result;
                if (cutterChallengeJourney) {
                    (0, $1lMle.default).info(`[Home Carousel] - found cutter challenge journey - card count [${number}]`);
                    number += 1;
                } else (0, $1lMle.default).info(`[Home Carousel] - cutter challenge journey not found - card count [${number}]`);
            }).catch(()=>{
                (0, $1lMle.default).warn("Failed to load cutter challenge journey");
            }).finally(()=>{
                (0, $1lMle.default).info("[Home Carousel] - initialization complete");
                setState({
                    cutterChallengeJourney: cutterChallengeJourney,
                    showTakeAssessment: showTakeAssessment,
                    showYearInReview: showYearInReview,
                    slideCount: number,
                    sport: selectedSport
                });
            });
        } else setState({
            cutterChallengeJourney: null,
            showTakeAssessment: showTakeAssessment,
            showYearInReview: showYearInReview,
            slideCount: number,
            sport: selectedSport
        });
        return ()=>{
            controller.abort();
        };
    }, [
        features,
        selectedSport,
        yearInReviewYears
    ]);
    const options = $bh6RR.useMemo(()=>({
            slideChanged (slider) {
                setCurrentSlide(slider.track.details.rel);
            },
            slides: {
                number: state?.slideCount ?? 0,
                origin: "auto",
                perView: 1
            },
            loop: true,
            dragSpeed: 1,
            rubberband: true,
            mode: "snap"
        }), [
        state
    ]);
    const [sliderRef, slider] = (0, $kjzzE.useKeenSlider)(options);
    if (!state) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $j4ol5.default), {
        height: 155
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
        spacing: 0,
        mb: 1,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                ref: sliderRef,
                className: "keen-slider",
                children: [
                    state.showTakeAssessment && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "keen-slider__slide",
                        style: {
                            display: "grid",
                            placeItems: "center"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $a57c8de8b0c4125c$export$2e2bcd8739ae039), {})
                    }, `assessment-${state.sport}`),
                    state.cutterChallengeJourney && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "keen-slider__slide",
                        style: {
                            display: "grid",
                            placeItems: "center"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3d40638987c76c25$export$2e2bcd8739ae039), {
                            journey: state.cutterChallengeJourney
                        })
                    }, `cutter-${state.sport}`),
                    state.showYearInReview && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "keen-slider__slide",
                        style: {
                            display: "grid",
                            placeItems: "center"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6f7a4922937fd490$export$2e2bcd8739ae039), {
                            year: (0, $f4d5f23f499595fd$export$9b15b141faa6f6ce)()
                        })
                    }, `review-${state.sport}`),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "keen-slider__slide",
                        children: atAGlance ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $638ad77d77397e92$export$2e2bcd8739ae039), {
                                    atAGlance: atAGlance,
                                    goalData: goalData,
                                    sport: state.sport,
                                    duprProfile: duprProfile,
                                    duprLoading: duprLoading,
                                    pti: pti,
                                    ptiLoading: ptiState === "loading",
                                    onConnectDupr: launchDuprConnect
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $02156a51ea3eae63$export$2e2bcd8739ae039), {
                                    globalBallsThrown: atAGlance.globalBallsThrown
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $j4ol5.default), {
                            height: 120
                        })
                    }, `status-${state.sport}`)
                ]
            }, state.sport),
            state.slideCount > 1 && /*#__PURE__*/ (0, $ih19M.jsx)((0, $8JNI1.default), {
                direction: "row",
                spacing: 1,
                justifyContent: "center",
                children: Array.from(Array(state.slideCount)).map((_, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $9GahD.default), {
                        sx: {
                            color: index === currentSlide ? "primary.light" : "grey.500",
                            cursor: "pointer",
                            fontSize: "12px"
                        },
                        onClick: ()=>{
                            slider.current?.moveToIdx(index);
                        }
                    }, index))
            }),
            duprDialog
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $cK0UE = parcelRequire("cK0UE");

var $W4f7l = parcelRequire("W4f7l");
parcelRequire("a8DUk");
var $kkvif = parcelRequire("kkvif");
/**
 * The single "nothing to show" value. A member who is not in Club-in-Club, a disabled
 * integration and an unreachable upstream all land here, because the widget's job in all
 * three cases is identical: render nothing.
 */ const $6a0e34c2415dc9c5$var$NOT_A_MEMBER = {
    member: null,
    pointBalance: null,
    refreshInDays: null,
    nextSession: null,
    upcomingSessionCount: 0,
    setup: null,
    portalUrl: null,
    volley: {
        hasPriorSessions: false
    }
};
const $6a0e34c2415dc9c5$var$HomeClubInClubContext = /*#__PURE__*/ $bh6RR.createContext(null);
function $6a0e34c2415dc9c5$export$788c90b6634b4fd8({ children: children }) {
    const { features: features, featuresLoaded: featuresLoaded } = (0, $W4f7l.useCurrentUser)();
    // "Not granted" and "not loaded yet" must not look the same: treating an empty
    // feature list as a decision would settle on "hide" and then flip.
    const granted = features.includes((0, $kkvif.CLUB_IN_CLUB_FEATURE));
    const shouldFetch = featuresLoaded && granted;
    const [status, setStatus] = $bh6RR.useState($6a0e34c2415dc9c5$var$NOT_A_MEMBER);
    // Starts true so consumers withhold on the first render, before any fetch begins.
    const [fetching, setFetching] = $bh6RR.useState(true);
    // Derived, not stored: "the feature list hasn't resolved" and "a request is in
    // flight" are two independent reasons to withhold, and keeping them in one piece of
    // state meant each writer had to know about the other.
    const loading = !featuresLoaded || fetching;
    // A ref, not an effect-scoped flag: `load` is also called manually via refetch(),
    // whose result can land after unmount just as the initial fetch's can.
    const mounted = $bh6RR.useRef(true);
    $bh6RR.useEffect(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const load = $bh6RR.useCallback(async ({ quiet: quiet } = {})=>{
        if (!shouldFetch) {
            // Nothing to wait for. Whether consumers still withhold is `featuresLoaded`'s
            // business, not ours.
            if (mounted.current) {
                setStatus($6a0e34c2415dc9c5$var$NOT_A_MEMBER);
                setFetching(false);
            }
            return;
        }
        if (!quiet) setFetching(true);
        try {
            const res = await (0, $cK0UE.default)("/api/integrations/club-in-club/home-status");
            if (mounted.current) setStatus(res);
        } catch (err) {
            // No error state: Club-in-Club standing is supplementary on this screen, so a
            // failure degrades to an absent widget rather than interrupting the home
            // screen. The server already collapses upstream failures into the same shape;
            // this covers our own request failing.
            (0, $cK0UE.logFetchError)(err, "Failed to load Club-in-Club home status");
            if (mounted.current && !quiet) setStatus($6a0e34c2415dc9c5$var$NOT_A_MEMBER);
        } finally{
            if (mounted.current && !quiet) setFetching(false);
        }
    }, [
        shouldFetch
    ]);
    $bh6RR.useEffect(()=>{
        load();
    }, [
        load
    ]);
    const value = $bh6RR.useMemo(()=>({
            granted: shouldFetch,
            status: status,
            loading: loading,
            refetch: load
        }), [
        shouldFetch,
        status,
        loading,
        load
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($6a0e34c2415dc9c5$var$HomeClubInClubContext.Provider, {
        value: value,
        children: children
    });
}
function $6a0e34c2415dc9c5$export$de64c3853562681() {
    const context = $bh6RR.useContext($6a0e34c2415dc9c5$var$HomeClubInClubContext);
    if (!context) throw new Error("useHomeClubInClub must be used within HomeClubInClubProvider");
    return context;
}





var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $iTU6T = parcelRequire("iTU6T");

var $3Xpkr = parcelRequire("3Xpkr");

var $3vS3m = parcelRequire("3vS3m");

var $dOzud = parcelRequire("dOzud");

var $1d1FK = parcelRequire("1d1FK");

var $4rInl = parcelRequire("4rInl");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $fcQCp = parcelRequire("fcQCp");

function $53b1705fc6183606$export$2e2bcd8739ae039({ recommendation: recommendation }) {
    const navigate = (0, $as544.useNavigate)();
    const [dismissed, setDismissed] = $bh6RR.useState(false);
    const { hasSubmitted: hasSubmitted, loading: loading } = (0, $a046b59bbb6f4fe3$export$dfdd01146dc6f769)();
    // Withheld while DUPR standing is unknown, as the library row is, so the title
    // does not change under the member's finger.
    if (!recommendation || dismissed || loading) return null;
    const target = hasSubmitted ? {
        title: "See your DUPR Dashboard",
        subtitle: "Your rating, match history and reliability",
        navUrl: "/dupr-dashboard",
        icon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3vS3m.default), {
            sx: {
                color: "#3CE97C",
                fontSize: "1.5rem"
            }
        })
    } : {
        title: "Get rated",
        subtitle: "Take the 10-minute assessment. Volley's AI rates your game, then a real coach sends feedback and drills for your next session.",
        navUrl: "/journeys/long-form",
        icon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dOzud.default), {
            sx: {
                color: "#3CE97C",
                fontSize: "1.5rem"
            }
        })
    };
    const go = ()=>{
        (0, $fcQCp.default).addAction("home_recommendation_selected", {
            recommendation: recommendation,
            navUrl: target.navUrl
        });
        navigate(target.navUrl, {
            state: {
                source: "membership_onboarding"
            }
        });
    };
    const dismiss = ()=>{
        (0, $fcQCp.default).addAction("home_recommendation_dismissed", {
            recommendation: recommendation
        });
        setDismissed(true);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        sx: {
            mb: 1.5,
            p: "12px 10px 10px",
            borderRadius: "12px",
            backgroundColor: "#243049",
            boxShadow: "inset 0 0 0 2px #3CE97C",
            display: "flex",
            flexDirection: "column",
            gap: "6px"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                sx: {
                    pl: "45px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        component: "span",
                        sx: {
                            fontSize: "0.62rem",
                            fontWeight: 800,
                            letterSpacing: "0.08em",
                            textTransform: "uppercase",
                            color: "#3CE97C"
                        },
                        children: "You're in. Start here."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                        size: "small",
                        "aria-label": "Dismiss recommendation",
                        onClick: dismiss,
                        sx: {
                            color: "#94a3b8",
                            my: -1,
                            mr: -0.5
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3Xpkr.default), {
                            fontSize: "small"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                component: "button",
                type: "button",
                onClick: go,
                sx: {
                    all: "unset",
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    cursor: "pointer",
                    color: "white",
                    textAlign: "left",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        sx: {
                            width: 30,
                            display: "flex",
                            justifyContent: "center",
                            fontSize: "1.5rem"
                        },
                        children: target.icon
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                        spacing: 0.25,
                        sx: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                variant: "body1",
                                sx: {
                                    color: "white",
                                    fontWeight: 700,
                                    fontSize: "1.1rem"
                                },
                                children: target.title
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                variant: "body2",
                                sx: {
                                    color: "#94a3b8",
                                    fontSize: "0.8rem",
                                    fontWeight: 400
                                },
                                children: target.subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $iTU6T.default), {
                        sx: {
                            color: "#3CE97C",
                            fontSize: 20
                        }
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $4xl3n = parcelRequire("4xl3n");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $5Jk4T = parcelRequire("5Jk4T");

var $bZrpr = parcelRequire("bZrpr");

var $f3YXY = parcelRequire("f3YXY");

var $iTU6T = parcelRequire("iTU6T");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $1e07b0a1f174c679$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5z"
}), 'Shield');



var $aEnM8 = parcelRequire("aEnM8");

var $1d1FK = parcelRequire("1d1FK");

var $fbTZq = parcelRequire("fbTZq");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");
parcelRequire("eyjy7");
var $fgDKG = parcelRequire("fgDKG");

var $fcQCp = parcelRequire("fcQCp");

var $5rkdj = parcelRequire("5rkdj");

var $cK0UE = parcelRequire("cK0UE");
var $fEgSm = parcelRequire("fEgSm");

var $loAb5 = parcelRequire("loAb5");

/**
 * The palette and metrics are lifted from the member portal's own home module
 * (`ClubHomeModule` / `cic.css` in the clubinclub repo) so the two surfaces read as one
 * product — a member tapping through should not notice a seam. Values are inlined rather
 * than themed because they are Club-in-Club's, not Volley's, and should not drift with
 * the rest of the home screen.
 */ const $41de705815c137e5$var$CIC = {
    accent: "#3CE97C",
    accentFg: "#07301a",
    surface: "#243049",
    line: "rgba(255,255,255,0.09)",
    lineStrong: "rgba(255,255,255,0.16)",
    muted: "#94A3B8",
    danger: "#ef4444",
    /** VIP members are picked out in gold, as on the design canvas. */ vip: "#F5C542"
};
/** Full-bleed row below the balance: next session, alerts. Matches `.cic-next-strip`. */ const $41de705815c137e5$var$STRIP = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    width: "100%",
    color: "#fff",
    padding: "13px 16px",
    background: "rgba(0,0,0,0.18)",
    borderTop: `1px solid ${$41de705815c137e5$var$CIC.line}`,
    textAlign: "left"
};
/** The 34px rounded glyph tile at the head of a strip. Matches `.cic-next-ic`. */ const $41de705815c137e5$var$STRIP_ICON = {
    width: 34,
    height: 34,
    borderRadius: "10px",
    background: "rgba(60,233,124,0.14)",
    color: $41de705815c137e5$var$CIC.accent,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
};
/** Pill button. Matches `.cic-btn.sm`. */ const $41de705815c137e5$var$PILL = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    height: 42,
    padding: "0 18px",
    borderRadius: "30px",
    fontFamily: "'Fira Sans', sans-serif",
    fontSize: "15px",
    fontWeight: 700,
    transition: "filter 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
        filter: "brightness(1.08)"
    },
    "&.Mui-disabled": {
        opacity: 0.5
    }
};
/**
 * The day portion of a session label, mirroring the portal's `fmtDayLong`: a relative
 * word where one applies, but always with the concrete date, because "Tomorrow" alone
 * stops being unambiguous the moment a member holds more than one booking.
 */ function $41de705815c137e5$var$formatSessionStart(iso, timeZone) {
    const start = new Date(iso);
    const dayKey = (d)=>new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone,
            dateStyle: "medium"
        }).format(d);
    const date = new Intl.DateTimeFormat("en-US", {
        timeZone: timeZone,
        month: "short",
        day: "numeric"
    }).format(start);
    const time = new Intl.DateTimeFormat("en-US", {
        timeZone: timeZone,
        hour: "numeric",
        minute: "2-digit"
    }).format(start);
    const now = new Date();
    const tomorrow = new Date(now.getTime() + 86400000);
    if (dayKey(start) === dayKey(now)) return `Today \xb7 ${date} ${time}`;
    if (dayKey(start) === dayKey(tomorrow)) return `Tomorrow \xb7 ${date} ${time}`;
    const weekday = new Intl.DateTimeFormat("en-US", {
        timeZone: timeZone,
        weekday: "short"
    }).format(start);
    return `${weekday}, ${date} ${time}`;
}
function $41de705815c137e5$export$bcbc2d08c18b1dc(session, timeZone) {
    const when = $41de705815c137e5$var$formatSessionStart(session.startTime, timeZone);
    return session.courtName ? `${when} \xb7 ${session.courtName}` : when;
}
function $41de705815c137e5$export$4f6efe9814f702e(refreshInDays, timeZone, now = new Date(), verb = "Resets on") {
    if (refreshInDays == null) return null;
    const expires = new Date(now.getTime() + refreshInDays * 86400000);
    const date = new Intl.DateTimeFormat("en-US", {
        timeZone: timeZone,
        month: "short",
        day: "numeric"
    }).format(expires);
    return `${verb} ${date}`;
}
function $41de705815c137e5$export$ab5be0593b4211f3(portalUrl, token, target) {
    const url = new URL("/", portalUrl);
    url.searchParams.set("token", token);
    (0, $5rkdj.addWebbySession)(url);
    if (target) {
        url.searchParams.set("screen", target.screen);
        for (const [key, value] of Object.entries(target.params ?? {}))url.searchParams.set(key, value);
    }
    return url.href;
}
function $41de705815c137e5$var$Strip({ icon: icon, eyebrow: eyebrow, title: title, subtitle: subtitle, tone: tone = "normal", onClick: onClick, busy: busy = false, announce: announce = false }) {
    const danger = tone === "danger";
    const body = /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                sx: {
                    ...$41de705815c137e5$var$STRIP_ICON,
                    ...danger && {
                        background: "rgba(239,68,68,0.2)",
                        color: $41de705815c137e5$var$CIC.danger
                    }
                },
                children: icon
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                spacing: 0.25,
                sx: {
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    eyebrow && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        sx: {
                            fontSize: "11px",
                            color: $41de705815c137e5$var$CIC.muted,
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",
                            fontWeight: 700
                        },
                        children: eyebrow
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        sx: {
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: "14.5px"
                        },
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        sx: {
                            color: $41de705815c137e5$var$CIC.muted,
                            fontSize: "12.5px"
                        },
                        "aria-live": announce ? "polite" : undefined,
                        children: subtitle
                    })
                ]
            }),
            onClick && /*#__PURE__*/ (0, $ih19M.jsx)((0, $iTU6T.default), {
                sx: {
                    color: $41de705815c137e5$var$CIC.muted,
                    fontSize: 20
                }
            })
        ]
    });
    const sx = {
        ...$41de705815c137e5$var$STRIP,
        ...danger && {
            background: "rgba(239,68,68,0.15)",
            borderTop: `1px solid ${$41de705815c137e5$var$CIC.danger}`
        }
    };
    return onClick ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $fbTZq.default), {
        onClick: onClick,
        sx: sx,
        "aria-busy": busy || undefined,
        "aria-disabled": busy || undefined,
        children: body
    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
        sx: sx,
        children: body
    });
}
const $41de705815c137e5$export$d9f3f2101c30533a = "Activate your Volley membership";
/**
 * The prompt for someone who hasn't activated (IPC activation handoff, 2026-10): heading,
 * one line, and a button, with a small non-lock icon. Prominent, but the rest of home stays
 * as browsable as ever: nothing here blurs, locks or blocks anything below it. The choice
 * itself (I'm VIP, or the free month) is Club-in-Club's Welcome screen, which the button
 * opens.
 */ function $41de705815c137e5$var$ActivationCard({ club: club, busy: busy, busyLabel: busyLabel, problem: problem, onActivate: onActivate }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
        alignItems: "center",
        spacing: 1.25,
        sx: {
            padding: "26px 18px 18px",
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bZrpr.default), {
                sx: {
                    fontSize: 34,
                    color: $41de705815c137e5$var$CIC.accent
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                component: "h2",
                sx: {
                    color: "#fff",
                    fontFamily: "Gotham, 'Arial Black', sans-serif",
                    fontWeight: 900,
                    fontSize: "24px",
                    lineHeight: 1.15,
                    margin: 0
                },
                children: $41de705815c137e5$export$d9f3f2101c30533a
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                sx: {
                    color: "#C7D0E0",
                    fontSize: "15px",
                    lineHeight: 1.45
                },
                children: club ? `Activate your membership to access Volley at ${club}.` : "Activate your membership to access Volley."
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $fbTZq.default), {
                disabled: !onActivate,
                onClick: onActivate,
                "aria-busy": busy || undefined,
                "aria-disabled": busy || undefined,
                sx: {
                    ...$41de705815c137e5$var$PILL,
                    width: "100%",
                    marginTop: "8px !important",
                    height: 46,
                    background: $41de705815c137e5$var$CIC.accent,
                    color: $41de705815c137e5$var$CIC.accentFg
                },
                children: busy ? busyLabel : $41de705815c137e5$export$d9f3f2101c30533a
            }),
            problem && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                "aria-live": "polite",
                sx: {
                    color: $41de705815c137e5$var$CIC.muted,
                    fontSize: "12.5px",
                    lineHeight: 1.4
                },
                children: problem
            })
        ]
    });
}
function $41de705815c137e5$export$4127afe53d112b37(planTag, isVip) {
    if (planTag === "vip" || planTag == null && isVip) return {
        label: "VIP member",
        vip: true
    };
    if (planTag === "trial") return {
        label: "Free trial",
        vip: false
    };
    if (planTag === "member") return {
        label: "Volley member",
        vip: false
    };
    return null;
}
function $41de705815c137e5$export$7a40e08785c662d4(outcome, club) {
    switch(outcome){
        case "no_home_location":
            return club ? `Volley membership is only at ${club} for now. Make it your home location in your profile to join.` : "Volley membership isn't available at your club yet.";
        // Also what a club mapping that's wrong on our side looks like, for someone whose
        // home location is already the right club: hence the second half.
        case "location_not_enabled":
            return club ? `Volley membership is only at ${club} for now. Make it your home location in your profile to join, or contact support if it already is.` : "Volley membership isn't available at your club yet.";
        case "needs_link":
            return club ? `There's already a membership at ${club} with your email. Contact support to connect it to this account.` : "There's already a membership with your email. Contact support to connect it to this account.";
        case "identity_conflict":
            return "Your Volley membership is set up at another club. Contact support if that's not right.";
        case "invalid_profile":
            return "Add your first and last name to your profile, then tap to try again.";
        case "account_not_found":
        case "account_disabled":
        case "no_firebase_account":
            return "We couldn't set up a membership for this account. Contact support for help.";
        case "unavailable":
        case "disabled":
            return "Membership set-up isn't available right now. Please try again later.";
        default:
            return "Couldn't set up your membership just now. Tap to try again.";
    }
}
function $41de705815c137e5$export$e38ed0ca3b4ed3c8(err, club) {
    if ((0, $fEgSm.isAbortError)(err)) return 0, $fEgSm.FETCH_TIMEOUT_MESSAGE;
    if (err instanceof (0, $cK0UE.FetchError) && err.statusCode >= 400 && err.statusCode < 500) return $41de705815c137e5$export$7a40e08785c662d4("account_not_found", club);
    return $41de705815c137e5$export$7a40e08785c662d4("unreachable", club);
}
const $41de705815c137e5$export$ba1247050b986c64 = "Couldn't open Club-in-Club just now. Tap to try again.";
const $41de705815c137e5$export$78972d538fdee166 = "This can take a few seconds.";
/**
 * How long the banner waits for its push. Longer than fetchApi's 10s default, and longer
 * than webby-server's own budget for the push (CLUB_IN_CLUB_PROVISION_TIMEOUT_MS, 20s), so
 * a slow Club-in-Club reads as the answer webby-server gives rather than as our timeout while
 * the member is still being created.
 */ const $41de705815c137e5$var$SET_UP_WAIT_MS = 25000;
function $41de705815c137e5$export$a89f1bb070a75146(value) {
    if (value.loading) return false;
    const { member: member, setup: setup } = value.status;
    return member != null || setup?.state === "ready";
}
function $41de705815c137e5$export$2e2bcd8739ae039() {
    const { status: status, loading: loading, refetch: refetch } = (0, $6a0e34c2415dc9c5$export$de64c3853562681)();
    const [opening, setOpening] = $bh6RR.useState(false);
    // The state drives the card; the ref is what stops a second tap, as `setUpInFlight`
    // does for the push.
    const openInFlight = $bh6RR.useRef(false);
    // Set once the handoff has navigated, so only a return from the portal counts as
    // one: a focus event while the token is still being minted doesn't.
    const handedOff = $bh6RR.useRef(false);
    // Why the last handoff didn't get as far as Club-in-Club. Shown on the activation
    // card, where a tap that silently did nothing reads as a broken button.
    const [openProblem, setOpenProblem] = $bh6RR.useState(null);
    // The set-up banner's push: in flight, and why it didn't go through when it didn't.
    // `settingUp` drives the banner; the ref is what stops a second tap, since two taps
    // can land before the first one's state update renders.
    const [settingUp, setSettingUp] = $bh6RR.useState(false);
    const [setUpProblem, setSetUpProblem] = $bh6RR.useState(null);
    const setUpInFlight = $bh6RR.useRef(false);
    const setUpTapped = $bh6RR.useRef(false);
    // A push or a token mint can outlive the card: the member taps it and then leaves
    // home. Its answer must not then pull them into Club-in-Club from wherever they went.
    const mounted = $bh6RR.useRef(true);
    $bh6RR.useEffect(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const { member: member, portalUrl: portalUrl, setup: setup } = status;
    const club = setup?.locationName ?? null;
    // Leaving for the portal normally tears this page down, so `opening` never needed
    // clearing. It does not in the native app: the portal loads in a drawer over the
    // dashboard, and closing it returns to a page that never unmounted -- with the card
    // still latched disabled until the screen is navigated away from and back. Nor is
    // the status re-read, so a member who just activated there would still be asked to
    // activate: hence the quiet refetch, which re-reads without blanking the card.
    //
    // Three signals because no single one covers every way back: `pageshow` fires on a
    // bfcache restore, `visibilitychange` when a backgrounded webview returns, and
    // `focus` when a drawer closes over a page that was never hidden.
    $bh6RR.useEffect(()=>{
        if (!opening) return undefined;
        const reset = ()=>{
            if (!handedOff.current) return;
            handedOff.current = false;
            openInFlight.current = false;
            setOpening(false);
            refetch({
                quiet: true
            });
        };
        const onVisible = ()=>{
            if (document.visibilityState === "visible") reset();
        };
        window.addEventListener("pageshow", reset);
        window.addEventListener("focus", reset);
        document.addEventListener("visibilitychange", onVisible);
        return ()=>{
            window.removeEventListener("pageshow", reset);
            window.removeEventListener("focus", reset);
            document.removeEventListener("visibilitychange", onVisible);
        };
    }, [
        opening,
        refetch
    ]);
    const open = $bh6RR.useCallback(async (action, target)=>{
        if (!portalUrl || openInFlight.current) return;
        openInFlight.current = true;
        setOpening(true);
        setOpenProblem(null);
        (0, $fcQCp.default).addAction("club_in_club_open", {
            action: action
        });
        // Who the token will be minted for. Checked again below: a member who
        // switches account mid-flight must not be handed the previous one's session.
        const signedInAs = (0, $fgDKG.p)().currentUser;
        try {
            // no-store: a custom token is single-use and short-lived, so a cached
            // response would hand the portal a credential that is already spent.
            const { token: token } = await (0, $cK0UE.default)("/api/users/token", "GET", undefined, {
                cache: "no-store"
            });
            if (!mounted.current) {
                openInFlight.current = false;
                return;
            }
            if ((0, $fgDKG.p)().currentUser !== signedInAs) {
                openInFlight.current = false;
                setOpening(false);
                return;
            }
            if (typeof token !== "string" || !token.trim()) throw new Error("Missing handoff token");
            // In place, not a new tab: the portal shows a "← Back to Volley" link in
            // this webview and replaces (not pushes) the cleaned URL, so both it and
            // webview-back return to this screen. A new tab becomes a Safari sheet
            // with its own session and no return path.
            handedOff.current = true;
            (0, $loAb5.navigateTo)($41de705815c137e5$export$ab5be0593b4211f3(portalUrl, token, target));
        } catch (err) {
            (0, $cK0UE.logFetchError)(err, "Could not open the Club-in-Club portal");
            openInFlight.current = false;
            if (mounted.current) {
                setOpening(false);
                setOpenProblem($41de705815c137e5$export$ba1247050b986c64);
            }
        }
    }, [
        portalUrl
    ]);
    // Club-in-Club creates members only when Volley pushes them, so the activation card makes
    // that push itself -- the same one signup and the admin button make -- and only then
    // hands off to Club-in-Club's Welcome screen, which by then knows them.
    const setUp = $bh6RR.useCallback(async ()=>{
        if (setUpInFlight.current) return;
        setUpInFlight.current = true;
        setSettingUp(true);
        setSetUpProblem(null);
        setOpenProblem(null);
        // One "selected" per visit to home, as when a tap always left the screen; a tap
        // after a refusal is a retry.
        (0, $fcQCp.default).addAction(setUpTapped.current ? "membership_setup_retried" : "membership_banner_selected", {});
        setUpTapped.current = true;
        // Who the member is being set up for. A switch of account mid-flight drops the
        // answer, as `open` does for its token.
        const signedInAs = (0, $fgDKG.p)().currentUser;
        let problem = null;
        try {
            const { outcome: outcome } = await (0, $cK0UE.default)("/api/integrations/club-in-club/me/provision", "POST", undefined, (0, $fEgSm.timeoutInit)($41de705815c137e5$var$SET_UP_WAIT_MS));
            if (!mounted.current) return;
            if ((0, $fgDKG.p)().currentUser !== signedInAs) {
                setSettingUp(false);
                return;
            }
            if (outcome === "created" || outcome === "exists") {
                // open() says why itself when the handoff fails.
                await open("activate", {
                    screen: "activate"
                });
                if (mounted.current) setSettingUp(false);
                return;
            }
            (0, $fcQCp.default).addAction("membership_setup_refused", {
                outcome: outcome
            });
            problem = $41de705815c137e5$export$7a40e08785c662d4(outcome, club);
        } catch (err) {
            (0, $cK0UE.logFetchError)(err, "Could not set up the Club-in-Club membership");
            problem = $41de705815c137e5$export$e38ed0ca3b4ed3c8(err, club);
        } finally{
            setUpInFlight.current = false;
        }
        if (!mounted.current) return;
        setSetUpProblem(problem);
        setSettingUp(false);
    }, [
        open,
        club
    ]);
    // Withhold while the answer could still change, and stay absent for the large
    // majority who have neither an account nor a way to create one.
    if (loading) return null;
    if (!member && setup?.state !== "ready") return null;
    // The card itself. `overflow: hidden` is what lets the strips run full-bleed to the
    // rounded edge, and the radial wash is the portal's signature.
    const card = {
        margin: "6px 0 18px",
        borderRadius: "18px",
        overflow: "hidden",
        background: `radial-gradient(130% 100% at 100% 0%, rgba(60,233,124,0.14), transparent 60%), ${$41de705815c137e5$var$CIC.surface}`,
        boxShadow: "0 8px 24px rgba(0,0,0,0.25)"
    };
    if (!member) // The way in for someone who isn't a member yet: create them in Club-in-Club (see
    // setUp), then hand off to its Welcome screen. Gated on a portal, since the choice
    // lives there; a tap while the push is in flight does nothing.
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
        sx: card,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($41de705815c137e5$var$ActivationCard, {
            club: club,
            busy: settingUp || opening,
            busyLabel: settingUp ? "Setting up your membership\u2026" : "Opening\u2026",
            // Neutral words while a push is in flight, so a retry doesn't read the
            // last refusal out again.
            problem: settingUp ? $41de705815c137e5$export$78972d538fdee166 : setUpProblem ?? openProblem,
            onActivate: portalUrl ? ()=>void setUp() : undefined
        })
    });
    const next = status.nextSession;
    // A VIP tapped "I'm VIP" in the portal: no card, no subscription, never charged.
    const vip = member.isVip === true;
    const expiry = $41de705815c137e5$export$4f6efe9814f702e(status.refreshInDays, member.timezone, undefined, member.subscriptionStatus === "canceled" ? "Expires on" : "Resets on");
    const suspended = member.status === "suspended";
    const pastDue = member.subscriptionStatus === "past_due";
    const noPlan = member.subscriptionStatus === null;
    // A member who has never activated: no plan, not VIP. Choosing either plan activates
    // them, the Volley membership by creating a subscription and "I'm VIP" by setting
    // isVip. They get the activation card instead of a balance they can't use yet.
    const preActivation = !suspended && !pastDue && noPlan && !vip;
    if (preActivation) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
        sx: card,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($41de705815c137e5$var$ActivationCard, {
            club: member.locationName,
            busy: opening,
            busyLabel: "Opening\u2026",
            problem: openProblem,
            onActivate: portalUrl ? ()=>{
                (0, $fcQCp.default).addAction("membership_activate_selected", {});
                open("activate", {
                    screen: "activate"
                });
            } : undefined
        })
    });
    const tag = $41de705815c137e5$export$4127afe53d112b37(member.planTag, vip);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        sx: card,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                sx: {
                    padding: "16px 16px 14px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: "12px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                sx: {
                                    textTransform: "uppercase",
                                    fontSize: "12px",
                                    fontWeight: 700,
                                    letterSpacing: "0.12em",
                                    color: $41de705815c137e5$var$CIC.accent
                                },
                                children: "Points"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                                direction: "row",
                                alignItems: "baseline",
                                gap: "8px",
                                sx: {
                                    marginTop: "4px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                        component: "span",
                                        sx: {
                                            fontFamily: "Gotham, 'Arial Black', sans-serif",
                                            fontWeight: 900,
                                            fontSize: "40px",
                                            lineHeight: 1,
                                            color: "#fff"
                                        },
                                        children: status.pointBalance ?? 0
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                        component: "span",
                                        sx: {
                                            color: $41de705815c137e5$var$CIC.muted,
                                            fontWeight: 700,
                                            fontSize: "14px"
                                        },
                                        children: "points"
                                    })
                                ]
                            }),
                            expiry && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                sx: {
                                    color: $41de705815c137e5$var$CIC.muted,
                                    fontSize: "13px",
                                    fontWeight: 500,
                                    marginTop: "6px"
                                },
                                children: expiry
                            })
                        ]
                    }),
                    tag && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                        component: "span",
                        sx: {
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            flexShrink: 0,
                            fontSize: "11px",
                            fontWeight: 700,
                            letterSpacing: "0.12em",
                            textTransform: "uppercase",
                            color: tag.vip ? $41de705815c137e5$var$CIC.vip : $41de705815c137e5$var$CIC.accent,
                            padding: "6px 10px",
                            border: tag.vip ? "1px solid rgba(245,197,66,0.5)" : "1px solid rgba(60,233,124,0.5)",
                            borderRadius: "999px"
                        },
                        children: [
                            tag.vip && /*#__PURE__*/ (0, $ih19M.jsx)((0, $aEnM8.default), {
                                sx: {
                                    fontSize: 12
                                }
                            }),
                            tag.label
                        ]
                    })
                ]
            }),
            (suspended || pastDue) && /*#__PURE__*/ (0, $ih19M.jsx)($41de705815c137e5$var$Strip, {
                tone: "danger",
                icon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1e07b0a1f174c679$export$2e2bcd8739ae039), {
                    sx: {
                        fontSize: 18
                    }
                }),
                title: "Membership paused \u2014 payment failed",
                subtitle: "Update your card to reactivate and book",
                onClick: portalUrl ? ()=>void open("billing", {
                        screen: "account"
                    }) : undefined
            }),
            portalUrl && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                sx: {
                    display: "flex",
                    gap: "10px",
                    padding: "0 14px 14px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $fbTZq.default), {
                    disabled: opening,
                    onClick: ()=>void open("book", {
                            screen: "book"
                        }),
                    sx: {
                        ...$41de705815c137e5$var$PILL,
                        flex: 1,
                        background: $41de705815c137e5$var$CIC.accent,
                        color: $41de705815c137e5$var$CIC.accentFg
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $f3YXY.default), {
                            sx: {
                                fontSize: 17
                            }
                        }),
                        "Book a session"
                    ]
                })
            }),
            next ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($41de705815c137e5$var$Strip, {
                        icon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $f3YXY.default), {
                            sx: {
                                fontSize: 18
                            }
                        }),
                        eyebrow: "Next session",
                        title: $41de705815c137e5$export$bcbc2d08c18b1dc(next, member.timezone),
                        onClick: portalUrl ? ()=>void open("reservation", {
                                screen: "reservation",
                                params: {
                                    id: next.seatBookingId
                                }
                            }) : undefined
                    }),
                    status.upcomingSessionCount > 1 && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $fbTZq.default), {
                        onClick: portalUrl ? ()=>void open("reservations", {
                                screen: "reservations"
                            }) : undefined,
                        disabled: !portalUrl,
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "6px",
                            width: "100%",
                            padding: "11px 16px",
                            background: "rgba(0,0,0,0.10)",
                            borderTop: `1px solid ${$41de705815c137e5$var$CIC.line}`,
                            color: $41de705815c137e5$var$CIC.accent,
                            fontFamily: "'Fira Sans', sans-serif",
                            fontWeight: 700,
                            fontSize: "13px"
                        },
                        children: [
                            `View all ${status.upcomingSessionCount} upcoming sessions`,
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $5Jk4T.default), {
                                sx: {
                                    fontSize: 15
                                }
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                sx: {
                    color: $41de705815c137e5$var$CIC.muted,
                    fontSize: "13px",
                    lineHeight: 1.5,
                    padding: "12px 18px 16px"
                },
                children: "No upcoming sessions yet."
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $1d1FK = parcelRequire("1d1FK");

var $gILAF = parcelRequire("gILAF");


var $62tuQ = parcelRequire("62tuQ");

var $76QOg = parcelRequire("76QOg");

var $W4f7l = parcelRequire("W4f7l");


var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $3EEPE = parcelRequire("3EEPE");

var $bZrpr = parcelRequire("bZrpr");

var $iTU6T = parcelRequire("iTU6T");

var $1d1FK = parcelRequire("1d1FK");

var $cVsvh = parcelRequire("cVsvh");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

const $70d4d09c562a4094$var$GREEN = "#3CE97C";
/** Max free-text length captured from the open field, to keep events bounded. */ const $70d4d09c562a4094$var$ASK_MAX_LENGTH = 500;
function $70d4d09c562a4094$export$2e2bcd8739ae039({ prompt: prompt, onOpen: onOpen, onAskAnything: onAskAnything, onDismiss: onDismiss, onLaunchAssessment: onLaunchAssessment, onConnectDupr: onConnectDupr, onConnectApta: onConnectApta, onSeeStats: onSeeStats, spotlit: spotlit = false }) {
    const [draft, setDraft] = $bh6RR.useState("");
    const submitDraft = $bh6RR.useCallback(()=>{
        const text = draft.trim();
        if (!text) return;
        onAskAnything(text);
        setDraft("");
    }, [
        draft,
        onAskAnything
    ]);
    const canSend = draft.trim().length > 0;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        role: "button",
        tabIndex: 0,
        onClick: ()=>onOpen(),
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onOpen();
            }
        },
        sx: {
            position: "relative",
            mt: 1.75,
            borderRadius: 2,
            p: "14px 14px 12px",
            background: `linear-gradient(180deg, rgba(60,233,124,0.04) 0%, rgba(60,233,124,0) 60%), #14213F`,
            border: `1px solid ${spotlit ? "rgba(60,233,124,0.8)" : "rgba(60,233,124,0.35)"}`,
            boxShadow: spotlit ? `0 0 0 3px rgba(60,233,124,0.35), 0 8px 22px rgba(0,0,0,0.35), 0 0 36px rgba(60,233,124,0.25)` : `0 8px 22px rgba(0,0,0,0.35), 0 0 24px rgba(60,233,124,0.06)`,
            color: "#fff",
            cursor: "pointer",
            overflow: "hidden",
            transition: "box-shadow 240ms ease, border-color 240ms ease",
            "&:hover": {
                borderColor: "rgba(60,233,124,0.5)"
            }
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                direction: "row",
                sx: {
                    alignItems: "center",
                    gap: 1.25,
                    mb: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        sx: {
                            width: 32,
                            height: 32,
                            borderRadius: "50%",
                            flexShrink: 0,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#0B1730",
                            background: "radial-gradient(circle at 30% 30%, #58F08C 0%, #1FA557 60%, #0E6E3A 100%)",
                            boxShadow: "0 0 0 2px rgba(60,233,124,0.4), 0 0 14px rgba(60,233,124,0.45)"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bZrpr.default), {
                            sx: {
                                fontSize: 18
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                sx: {
                                    fontWeight: 900,
                                    fontSize: 13,
                                    letterSpacing: "0.06em",
                                    color: $70d4d09c562a4094$var$GREEN,
                                    textTransform: "uppercase",
                                    lineHeight: 1
                                },
                                children: "Ask Volley"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                                direction: "row",
                                sx: {
                                    alignItems: "center",
                                    gap: 0.75,
                                    mt: "3px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                        sx: {
                                            width: 6,
                                            height: 6,
                                            borderRadius: "50%",
                                            bgcolor: $70d4d09c562a4094$var$GREEN,
                                            boxShadow: `0 0 6px ${$70d4d09c562a4094$var$GREEN}`
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                        sx: {
                                            fontWeight: 500,
                                            fontSize: 11,
                                            color: "#94A3B8"
                                        },
                                        children: prompt.status?.trim() || "Picked for you"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        sx: {
                            ml: "auto",
                            color: "rgba(255,255,255,0.45)",
                            display: "inline-flex"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $iTU6T.default), {
                            sx: {
                                fontSize: 20
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                sx: {
                    fontSize: 15,
                    lineHeight: 1.4,
                    fontWeight: 400,
                    mb: 1.5,
                    color: "#fff"
                },
                children: prompt.promptText
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8JNI1.default), {
                direction: "row",
                sx: {
                    flexWrap: "wrap",
                    gap: 1
                },
                children: prompt.options.map((option)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        component: "button",
                        onClick: (e)=>{
                            e.stopPropagation();
                            if ((0, $a80a94320a991500$export$706a5404f6f91eaa)(option)) onLaunchAssessment(option);
                            else if ((0, $a80a94320a991500$export$48778c1a1acbe210)(option)) onConnectDupr(option);
                            else if ((0, $a80a94320a991500$export$ca1696bb8b460f3e)(option)) onConnectApta(option);
                            else if ((0, $a80a94320a991500$export$67e233fd2cb25dd3)(option)) onSeeStats(option);
                            else if (option.dismiss) onDismiss(option);
                            else onOpen(option.value);
                        },
                        sx: {
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 0.75,
                            px: 1.5,
                            py: 1,
                            borderRadius: 999,
                            bgcolor: "rgba(255,255,255,0.04)",
                            border: "1px solid rgba(168,184,217,0.22)",
                            // Dismiss chips read as a quieter, secondary action.
                            color: option.dismiss ? "#94A3B8" : "#E2E8F0",
                            fontFamily: "inherit",
                            fontWeight: 500,
                            fontSize: 12.5,
                            whiteSpace: "nowrap",
                            cursor: "pointer",
                            transition: "background 120ms ease, border-color 120ms ease",
                            "&:hover": option.dismiss ? {
                                borderColor: "rgba(168,184,217,0.4)"
                            } : {
                                bgcolor: "rgba(60,233,124,0.06)",
                                borderColor: "rgba(60,233,124,0.35)"
                            }
                        },
                        children: option.label
                    }, option.value))
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                direction: "row",
                onClick: (e)=>e.stopPropagation(),
                sx: {
                    alignItems: "center",
                    gap: 1,
                    mt: 1.5,
                    pt: 1.5,
                    borderTop: "1px solid rgba(168,184,217,0.12)"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cVsvh.default), {
                        fullWidth: true,
                        value: draft,
                        placeholder: "Ask Volley anything\u2026",
                        inputProps: {
                            maxLength: $70d4d09c562a4094$var$ASK_MAX_LENGTH,
                            "aria-label": "Ask Volley anything"
                        },
                        onChange: (e)=>setDraft(e.target.value),
                        onKeyDown: (e)=>{
                            // Keep keystrokes from reaching the card's key handler,
                            // which would otherwise swallow Space and open on Enter.
                            e.stopPropagation();
                            if (e.key === "Enter") {
                                e.preventDefault();
                                submitDraft();
                            }
                        },
                        sx: {
                            flex: 1,
                            minWidth: 0,
                            height: 46,
                            borderRadius: "24px",
                            px: 2,
                            color: "#fff",
                            fontSize: 14,
                            // Standing green outline + faint wash so the field reads
                            // as the desired action even after the spotlight is gone.
                            bgcolor: "rgba(60,233,124,0.06)",
                            border: "1.5px solid rgba(60,233,124,0.55)",
                            boxShadow: "0 0 0 3px rgba(60,233,124,0.07)",
                            transition: "border-color 120ms ease, box-shadow 120ms ease, background 120ms ease",
                            "& input::placeholder": {
                                color: "#9DB0D0",
                                opacity: 1
                            },
                            "&.Mui-focused": {
                                borderColor: $70d4d09c562a4094$var$GREEN,
                                bgcolor: "rgba(60,233,124,0.1)",
                                boxShadow: "0 0 0 4px rgba(60,233,124,0.18)"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        component: "button",
                        type: "button",
                        "aria-label": "send",
                        disabled: !canSend,
                        onClick: (e)=>{
                            e.stopPropagation();
                            submitDraft();
                        },
                        sx: {
                            width: 44,
                            height: 44,
                            flexShrink: 0,
                            borderRadius: 999,
                            border: 0,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#0B1730",
                            // Full Volley green at rest — the arrow is the action
                            // color, always; just softer while the field is empty.
                            bgcolor: canSend ? $70d4d09c562a4094$var$GREEN : "rgba(60,233,124,0.82)",
                            boxShadow: canSend ? "0 0 14px rgba(60,233,124,0.35)" : "0 0 10px rgba(60,233,124,0.2)",
                            cursor: canSend ? "pointer" : "default",
                            transition: "background 120ms ease, box-shadow 120ms ease",
                            "&:hover": canSend ? {
                                bgcolor: "#5BF295"
                            } : {},
                            "&:active": canSend ? {
                                bgcolor: "#2FCB69"
                            } : {},
                            "@media (prefers-reduced-motion: no-preference)": canSend ? {
                                animation: "askVolleySendPulse 1.8s ease-in-out infinite",
                                "@keyframes askVolleySendPulse": {
                                    "0%, 100%": {
                                        boxShadow: "0 0 14px rgba(60,233,124,0.35)"
                                    },
                                    "50%": {
                                        boxShadow: "0 0 22px rgba(60,233,124,0.62)"
                                    }
                                }
                            } : {}
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3EEPE.default), {
                            sx: {
                                fontSize: 18
                            }
                        })
                    })
                ]
            })
        ]
    });
}







/** localStorage key for the once-per-user first-run spotlight. */ function $e950ea899c1c09b0$var$spotlightSeenKey(userId) {
    return `askVolley.spotlightSeen.v1.${userId ?? "anon"}`;
}
function $e950ea899c1c09b0$var$hasSeenSpotlight(userId) {
    try {
        return localStorage.getItem($e950ea899c1c09b0$var$spotlightSeenKey(userId)) === "1";
    } catch  {
        return true; // No storage access → don't nag.
    }
}
function $e950ea899c1c09b0$var$markSpotlightSeen(userId) {
    try {
        localStorage.setItem($e950ea899c1c09b0$var$spotlightSeenKey(userId), "1");
    } catch  {
    // Ignore — the spotlight is non-essential.
    }
}
function $e950ea899c1c09b0$export$2e2bcd8739ae039({ fallback: fallback }) {
    const { currentUser: currentUser } = (0, $W4f7l.useCurrentUser)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    const { selected: sport, getIdFromSport: getIdFromSport } = (0, $76QOg.useSelectedSport)();
    const navigate = (0, $as544.useNavigate)();
    const userId = currentUser?.id;
    const { launchAssessment: launchAssessment, dialog: assessmentDialog } = (0, $a7bc24707d3d7752$export$a438bae8ee6b34ea)();
    const { launchDuprConnect: launchDuprConnect, dialog: duprDialog } = (0, $2306f394fbe75dd1$export$a195d94d08cd882e)();
    const [prompt, setPrompt] = $bh6RR.useState(null);
    // False until the first fetch resolves, so we render neither the widget nor
    // the fallback during the loading window (avoids a carousel→widget flash).
    const [loaded, setLoaded] = $bh6RR.useState(false);
    const [impressionUlid, setImpressionUlid] = $bh6RR.useState("");
    const [open, setOpen] = $bh6RR.useState(false);
    const [initialOption, setInitialOption] = $bh6RR.useState(undefined);
    const [freeTextSeed, setFreeTextSeed] = $bh6RR.useState(undefined);
    // A chat restored after the user backed out of a workout detail page. When
    // set, the overlay re-opens seeded from it instead of fetching fresh.
    const [restored, setRestored] = $bh6RR.useState(undefined);
    // Bumped to force a fresh prompt fetch after a restored chat is dismissed
    // (the restore path skips the fetch, so dismissal must re-trigger it).
    const [reloadNonce, setReloadNonce] = $bh6RR.useState(0);
    const [spotlight, setSpotlight] = $bh6RR.useState(false);
    // Set when the user soft-dismisses the prompt (e.g. "Maybe later"); hides
    // the widget for the rest of this load.
    const [dismissed, setDismissed] = $bh6RR.useState(false);
    // Widget wrapper, observed to log when the prompt actually enters the
    // viewport (vs. merely being rendered below the fold).
    const widgetRef = $bh6RR.useRef(null);
    // Guards the one-per-impression viewport_visible event.
    const viewportLoggedUlid = $bh6RR.useRef("");
    const sportId = $bh6RR.useMemo(()=>{
        try {
            return getIdFromSport(sport);
        } catch  {
            return undefined;
        }
    }, [
        getIdFromSport,
        sport
    ]);
    // Fetch the next prompt whenever the sport changes; record an impression
    // and arm the first-run spotlight when one arrives.
    $bh6RR.useEffect(()=>{
        let cancelled = false;
        // Restore a chat the user left to view a workout, instead of fetching a
        // fresh prompt. Consume-once: clear it so it re-opens exactly once per
        // round-trip (a tap from the restored chat re-arms it). No new impression
        // and no spotlight — this is a continuation of the same view.
        //
        // Only a chat left from THIS surface, and only one that answered a
        // prompt. A chat opened from the launcher is restored by the page that
        // owns it; re-opening it here would put it on a screen it was never
        // shown on. Anything else falls through to the normal fetch below
        // rather than leaving the widget with nothing to render.
        const snapshot = (0, $41b2e6bb65ce7f0b$export$8169690c1ed1afde)(userId);
        if (snapshot?.prompt && (snapshot.surface ?? (0, $54cda1d76057ea5a$export$d25966be0dd29595)) === (0, $54cda1d76057ea5a$export$d25966be0dd29595)) {
            (0, $41b2e6bb65ce7f0b$export$a4b3eaeabef16fd2)(userId);
            setPrompt(snapshot.prompt);
            setImpressionUlid(snapshot.impressionUlid);
            setInitialOption(snapshot.initialOptionValue);
            setFreeTextSeed(snapshot.freeTextSeed);
            setRestored({
                thread: snapshot.thread,
                conversationUlid: snapshot.conversationUlid
            });
            setDismissed(false);
            setOpen(true);
            setLoaded(true);
            return ()=>{
                cancelled = true;
            };
        }
        async function load() {
            try {
                const next = await (0, $54cda1d76057ea5a$export$2c6d799cadbcdd81)(sportId);
                if (cancelled) return;
                if (!next) {
                    setPrompt(null);
                    return;
                }
                const id = (0, $b645fccf57198abf$export$c34778236461ea95)();
                setPrompt(next);
                setImpressionUlid(id);
                setDismissed(false);
                (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
                    eventType: "impression",
                    prompt: next,
                    impressionUlid: id,
                    sportId: sportId
                });
                if (!$e950ea899c1c09b0$var$hasSeenSpotlight(userId)) setSpotlight(true);
            } catch  {
                if (!cancelled) setPrompt(null);
            } finally{
                if (!cancelled) setLoaded(true);
            }
        }
        load();
        return ()=>{
            cancelled = true;
        };
    }, [
        sportId,
        userId,
        reloadNonce
    ]);
    // Dismiss the first-run spotlight. A `reason` (timer / scrim / got_it) logs
    // a spotlight_dismiss event; calls without one (e.g. when opening the chat)
    // are silent, since that path already logs its own interaction.
    const dismissSpotlight = $bh6RR.useCallback((reason)=>{
        if (!spotlight) return;
        $e950ea899c1c09b0$var$markSpotlightSeen(userId);
        if (reason && prompt) (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: prompt,
            impressionUlid: impressionUlid,
            sportId: sportId,
            metadata: {
                action: "spotlight_dismiss",
                reason: reason
            }
        });
        setSpotlight(false);
    }, [
        spotlight,
        userId,
        prompt,
        impressionUlid,
        sportId
    ]);
    // Log when the widget actually scrolls into view (once per impression), so
    // "saw it and ignored it" can be told apart from "never noticed it". Falls
    // back gracefully where IntersectionObserver is unavailable.
    $bh6RR.useEffect(()=>{
        const node = widgetRef.current;
        if (!prompt || !impressionUlid || !node) return undefined;
        if (typeof IntersectionObserver === "undefined") return undefined;
        const observer = new IntersectionObserver((entries)=>{
            const seen = entries.some((e)=>e.isIntersecting);
            if (!seen) return;
            if (viewportLoggedUlid.current === impressionUlid) return;
            viewportLoggedUlid.current = impressionUlid;
            (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
                eventType: "impression",
                prompt: prompt,
                impressionUlid: impressionUlid,
                sportId: sportId,
                metadata: {
                    action: "viewport_visible"
                }
            });
            observer.disconnect();
        }, {
            threshold: 0.5
        });
        observer.observe(node);
        return ()=>observer.disconnect();
    }, [
        prompt,
        impressionUlid,
        sportId
    ]);
    const handleOpen = $bh6RR.useCallback((optionValue)=>{
        dismissSpotlight();
        setRestored(undefined);
        setFreeTextSeed(undefined);
        setInitialOption(optionValue);
        setOpen(true);
        if (prompt) (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: prompt,
            impressionUlid: impressionUlid,
            sportId: sportId,
            metadata: {
                action: "open",
                ...optionValue ? {
                    answerValue: optionValue
                } : {}
            }
        });
    }, [
        dismissSpotlight,
        impressionUlid,
        prompt,
        sportId
    ]);
    // The open "Ask anything" field: capture the free text, then open the chat
    // seeded with it. The overlay sends the text to the LLM recommender and shows
    // the returned content; here we just log the free_text interaction and hand
    // off the seed.
    const handleAskAnything = $bh6RR.useCallback((text)=>{
        dismissSpotlight();
        if (prompt) (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: prompt,
            impressionUlid: impressionUlid,
            sportId: sportId,
            metadata: {
                action: "free_text",
                text: text
            }
        });
        setRestored(undefined);
        setInitialOption(undefined);
        setFreeTextSeed(text);
        setOpen(true);
    }, [
        dismissSpotlight,
        impressionUlid,
        prompt,
        sportId
    ]);
    // A soft-dismiss chip (e.g. "Maybe later"): capture the choice and hide the
    // widget for this load rather than opening the chat or routing to content.
    const handleDismiss = $bh6RR.useCallback((option)=>{
        dismissSpotlight();
        if (prompt) (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: prompt,
            impressionUlid: impressionUlid,
            sportId: sportId,
            metadata: {
                action: "dismiss",
                answerValue: option.value,
                answerLabel: option.label
            }
        });
        setDismissed(true);
    }, [
        dismissSpotlight,
        impressionUlid,
        prompt,
        sportId
    ]);
    // An assessment-launch chip ("Start assessment" / "Finish assessment"):
    // drive the assessment flow directly instead of opening the chat — resume
    // an in-progress assessment, or open the all-skills assessment start dialog.
    const handleLaunchAssessment = $bh6RR.useCallback((option)=>{
        dismissSpotlight();
        if (prompt) (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: prompt,
            impressionUlid: impressionUlid,
            sportId: sportId,
            metadata: {
                action: option.value === (0, $a80a94320a991500$export$13daccba1fc24702) ? "assessment_resume" : "assessment_start",
                answerValue: option.value,
                answerLabel: option.label
            }
        });
        launchAssessment(option, sport);
    }, [
        dismissSpotlight,
        impressionUlid,
        prompt,
        launchAssessment,
        sport,
        sportId
    ]);
    // The "Connect DUPR" chip on the profile prompt: open the existing DUPR
    // connect flow directly instead of opening the chat (the user links a
    // verified rating; "I don't have a rating" is the paired soft-dismiss).
    const handleConnectDupr = $bh6RR.useCallback((option)=>{
        dismissSpotlight();
        if (prompt) (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: prompt,
            impressionUlid: impressionUlid,
            sportId: sportId,
            metadata: {
                action: "dupr_connect",
                answerValue: option.value,
                answerLabel: option.label
            }
        });
        launchDuprConnect();
    }, [
        dismissSpotlight,
        impressionUlid,
        prompt,
        launchDuprConnect,
        sportId
    ]);
    // Platform tennis's counterpart to "Connect DUPR": open the existing
    // APTA-id dialog so the user's PTI can be resolved. Reachable only from a
    // prompt authored with the connect_apta option, so it is inert until one
    // exists.
    const handleConnectApta = $bh6RR.useCallback((option)=>{
        dismissSpotlight();
        if (prompt) (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: prompt,
            impressionUlid: impressionUlid,
            sportId: sportId,
            metadata: {
                action: "apta_connect",
                answerValue: option.value,
                answerLabel: option.label
            }
        });
        setDialogType("APTAId");
    }, [
        dismissSpotlight,
        impressionUlid,
        prompt,
        setDialogType,
        sportId
    ]);
    // The "See my stats" chip on the post-assessment prompt: navigate to the
    // performance dashboard directly instead of opening the chat. The prompt is
    // gated server-side on the user actually having a VSR result to view.
    const handleSeeStats = $bh6RR.useCallback((option)=>{
        dismissSpotlight();
        if (prompt) (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: prompt,
            impressionUlid: impressionUlid,
            sportId: sportId,
            metadata: {
                action: "see_stats",
                answerValue: option.value,
                answerLabel: option.label
            }
        });
        // /performance is the pickleball-only dashboard; the other
        // sports' stats live on their assessments list.
        navigate((0, $a80a94320a991500$export$59b2f70a1d4214ae)(sport));
    }, [
        dismissSpotlight,
        impressionUlid,
        prompt,
        navigate,
        sport,
        sportId
    ]);
    // Close the chat overlay, logging the close so "opened then backed out" is
    // captured as a soft dismiss (analysis tells acted-vs-not via impressionUlid).
    const handleClose = $bh6RR.useCallback(()=>{
        if (prompt) (0, $54cda1d76057ea5a$export$46298099f5f107b1)({
            eventType: "interaction",
            prompt: prompt,
            impressionUlid: impressionUlid,
            sportId: sportId,
            metadata: {
                action: "overlay_close"
            }
        });
        setOpen(false);
        setFreeTextSeed(undefined);
        // Closing a restored chat: drop the restored state and trigger a fresh
        // prompt fetch (the restore path skipped it), so the widget doesn't stay
        // frozen on the restored prompt.
        if (restored) {
            setRestored(undefined);
            setReloadNonce((n)=>n + 1);
        }
    }, [
        impressionUlid,
        prompt,
        restored,
        sportId
    ]);
    // Still loading: render nothing rather than flashing the fallback in and
    // then straight back out.
    if (!loaded) return null;
    // Soft-dismissed (e.g. "Maybe later"), or the fetch resolved with no
    // eligible prompt: hand off to the fallback. A dismiss puts the prompt away,
    // not whatever the surface would otherwise be showing — on the home screen
    // that is the Club-in-Club card, which would otherwise leave a member who
    // tapped "Maybe later" on court with an empty top of screen until they
    // disconnect.
    if (dismissed || !prompt) return fallback ?? null;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $gILAF.default), {
                in: spotlight,
                unmountOnExit: true,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                    onClick: ()=>dismissSpotlight("scrim"),
                    sx: {
                        position: "fixed",
                        inset: 0,
                        bgcolor: "rgba(7, 12, 24, 0.66)",
                        zIndex: (t)=>t.zIndex.modal - 1
                    }
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                ref: widgetRef,
                sx: {
                    position: "relative",
                    zIndex: (t)=>spotlight ? t.zIndex.modal : "auto"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $70d4d09c562a4094$export$2e2bcd8739ae039), {
                        prompt: prompt,
                        onOpen: handleOpen,
                        onAskAnything: handleAskAnything,
                        onDismiss: handleDismiss,
                        onLaunchAssessment: handleLaunchAssessment,
                        onConnectDupr: handleConnectDupr,
                        onConnectApta: handleConnectApta,
                        onSeeStats: handleSeeStats,
                        spotlit: spotlight
                    }),
                    spotlight && // Volley-green coachmark bubble that points up at the lit
                    // widget. Clicking anywhere (or "Got it") dismisses it; it
                    // never auto-settles — the user must dismiss it manually.
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                        onClick: ()=>dismissSpotlight("callout"),
                        sx: {
                            position: "relative",
                            mt: 1.5,
                            mx: 1,
                            p: "12px 14px",
                            borderRadius: "12px",
                            bgcolor: "#3CE97C",
                            color: "#0B1730",
                            fontSize: 13.5,
                            fontWeight: 600,
                            lineHeight: 1.35,
                            cursor: "pointer",
                            boxShadow: "0 10px 28px rgba(0,0,0,0.4)",
                            // Diamond tail pointing up at the widget above.
                            "&::before": {
                                content: '""',
                                position: "absolute",
                                top: -7,
                                left: 26,
                                width: 14,
                                height: 14,
                                bgcolor: "#3CE97C",
                                transform: "rotate(45deg)",
                                borderRadius: "3px"
                            },
                            "@media (prefers-reduced-motion: no-preference)": {
                                animation: "askVolleySpotPopIn 320ms cubic-bezier(.2,.8,.2,1) both",
                                animationDelay: "120ms",
                                "@keyframes askVolleySpotPopIn": {
                                    from: {
                                        opacity: 0,
                                        transform: "translateY(-6px) scale(0.97)"
                                    },
                                    to: {
                                        opacity: 1,
                                        transform: "none"
                                    }
                                }
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                component: "span",
                                sx: {
                                    display: "block",
                                    fontWeight: 900,
                                    fontSize: 10,
                                    letterSpacing: "0.06em",
                                    textTransform: "uppercase",
                                    opacity: 0.7,
                                    mb: "3px"
                                },
                                children: "Start here"
                            }),
                            "Get the most out of your trainer \u2014 tap for content picked just for you.",
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                component: "button",
                                type: "button",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    dismissSpotlight("got_it");
                                },
                                sx: {
                                    display: "block",
                                    mt: "10px",
                                    p: 0,
                                    border: 0,
                                    background: "none",
                                    color: "rgba(11,23,48,0.55)",
                                    fontFamily: "inherit",
                                    fontWeight: 900,
                                    fontSize: 11,
                                    letterSpacing: "0.05em",
                                    textTransform: "uppercase",
                                    cursor: "pointer"
                                },
                                children: "Got it"
                            })
                        ]
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ba01596fc99c49d5$export$2e2bcd8739ae039), {
                prompt: prompt,
                impressionUlid: impressionUlid,
                sportName: sport,
                sportId: sportId,
                initialOptionValue: initialOption,
                freeTextSeed: freeTextSeed,
                restored: restored,
                onClose: handleClose,
                onLaunchAssessment: handleLaunchAssessment,
                onConnectDupr: handleConnectDupr,
                onConnectApta: handleConnectApta,
                onSeeStats: handleSeeStats
            }),
            assessmentDialog,
            duprDialog
        ]
    });
}






var $2VZfN = parcelRequire("2VZfN");

var $76QOg = parcelRequire("76QOg");
function $e440638a3df0a03b$export$2e2bcd8739ae039({ fallback: fallback = null }) {
    const { selected: sport } = (0, $76QOg.useSelectedSport)();
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $2VZfN.default), {
        flag: "ASK_VOLLEY_HOME_PROMPT",
        source: "user_feature",
        enabled: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e950ea899c1c09b0$export$2e2bcd8739ae039), {
            fallback: fallback
        }),
        default: fallback,
        additionalCondition: ()=>(0, $a80a94320a991500$export$7efb6b5d91849ee1).has(sport)
    });
}



function $0e9b401647d5d429$export$2e2bcd8739ae039() {
    const clubInClub = (0, $6a0e34c2415dc9c5$export$de64c3853562681)();
    const { status: status } = (0, $4xl3n.usePairingContext)();
    if (clubInClub.loading) return null;
    const card = (0, $41de705815c137e5$export$a89f1bb070a75146)(clubInClub) ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $41de705815c137e5$export$2e2bcd8739ae039), {}) : null;
    // Null for anyone with no club standing, which leaves Ask Volley exactly as it was
    // for the large majority of users, on court and off.
    if (status === "paired") return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e440638a3df0a03b$export$2e2bcd8739ae039), {
        fallback: card
    });
    return card ?? /*#__PURE__*/ (0, $ih19M.jsx)((0, $e440638a3df0a03b$export$2e2bcd8739ae039), {});
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $V7QJD = parcelRequire("V7QJD");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $04d5755b7590a459$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 12.75c1.63 0 3.07.39 4.24.9 1.08.48 1.76 1.56 1.76 2.73V18H6v-1.61c0-1.18.68-2.26 1.76-2.73 1.17-.52 2.61-.91 4.24-.91M4 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58C.48 14.9 0 15.62 0 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29M20 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m4 3.43c0-.81-.48-1.53-1.22-1.85-.85-.37-1.79-.58-2.78-.58-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24zM12 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3"
}), 'Groups');



var $84QRb = parcelRequire("84QRb");

var $jwTd4 = parcelRequire("jwTd4");

var $3vS3m = parcelRequire("3vS3m");

var $j3Clf = parcelRequire("j3Clf");

var $lqNsp = parcelRequire("lqNsp");

var $dOzud = parcelRequire("dOzud");

var $ltl7W = parcelRequire("ltl7W");

var $aEnM8 = parcelRequire("aEnM8");

var $8yAk0 = parcelRequire("8yAk0");

var $8HCQF = parcelRequire("8HCQF");

var $95FNu = parcelRequire("95FNu");

var $8JNI1 = parcelRequire("8JNI1");

var $fcQCp = parcelRequire("fcQCp");

var $62tuQ = parcelRequire("62tuQ");

var $9aar5 = parcelRequire("9aar5");

var $5O1Z6 = parcelRequire("5O1Z6");

var $6sKkU = parcelRequire("6sKkU");

var $6tjVY = parcelRequire("6tjVY");

var $9hCj6 = parcelRequire("9hCj6");

var $hkEd6 = parcelRequire("hkEd6");

var $awHpO = parcelRequire("awHpO");

var $76QOg = parcelRequire("76QOg");

var $W4f7l = parcelRequire("W4f7l");

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $btx4r = parcelRequire("btx4r");

var $1d1FK = parcelRequire("1d1FK");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $6zj3p = parcelRequire("6zj3p");
const $4362490af671785c$var$DescriptiveText = {
    home: "Your home club workouts",
    connected: "Workouts from the trainer's club"
};
function $4362490af671785c$export$2e2bcd8739ae039({ clubType: clubType, providerName: providerName, providerLabel: providerLabel, onClick: onClick }) {
    const avatarUrl = (0, $6zj3p.default)(`publisher-avatars/${providerName}.png`);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        onClick: onClick,
        sx: {
            backgroundColor: "#243049",
            borderRadius: "12px",
            padding: "10px",
            display: "flex",
            alignItems: "center",
            gap: "15px",
            cursor: "pointer",
            transition: "background 0.2s",
            opacity: 0.75,
            "&:active": {
                backgroundColor: "#26334d"
            }
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                sx: {
                    width: 30,
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $btx4r.default), {
                    src: avatarUrl,
                    alt: providerLabel,
                    sx: {
                        backgroundColor: "white",
                        width: 30,
                        height: 30
                    },
                    variant: "square"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                spacing: 0.25,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "body1",
                        sx: {
                            color: "white",
                            fontWeight: 700,
                            fontSize: "1.1rem"
                        },
                        children: providerLabel
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "body2",
                        sx: {
                            color: "#94a3b8",
                            fontSize: "0.8rem",
                            fontWeight: 400
                        },
                        children: $4362490af671785c$var$DescriptiveText[clubType]
                    })
                ]
            })
        ]
    });
}





var $a8DUk = parcelRequire("a8DUk");

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $cbFbS = parcelRequire("cbFbS");
function $17c35323064cc301$export$2e2bcd8739ae039({ title: title }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
        variant: "h6",
        sx: {
            color: "white",
            fontWeight: 700,
            fontSize: "1.1rem",
            marginBottom: "5px",
            marginTop: "10px"
        },
        children: title
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");
function $fabffa6a060a1d01$export$2e2bcd8739ae039({ dim: dim = false, endIcon: endIcon, icon: icon, label: label, subtitle: subtitle, onClick: onClick }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        onClick: onClick,
        sx: {
            backgroundColor: "#243049",
            padding: icon || subtitle ? "10px" : "16px",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            gap: "15px",
            cursor: "pointer",
            transition: "background 0.2s",
            opacity: dim ? 0.75 : 1.0,
            "&:active": {
                backgroundColor: "#26334d"
            }
        },
        children: [
            icon && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                sx: {
                    width: 30,
                    display: "flex",
                    justifyContent: "center",
                    fontSize: "1.5rem"
                },
                children: icon
            }),
            subtitle ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                spacing: 0.25,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "body1",
                        sx: {
                            color: "white",
                            fontWeight: 700,
                            fontSize: "1.1rem"
                        },
                        children: label
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "body2",
                        sx: {
                            color: "#94a3b8",
                            fontSize: "0.8rem",
                            fontWeight: 400
                        },
                        children: subtitle
                    })
                ]
            }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                sx: {
                    color: "white",
                    fontWeight: 600,
                    fontSize: "0.9rem"
                },
                children: label
            }),
            endIcon && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    fontSize: "1.5rem",
                    marginLeft: "auto"
                },
                children: endIcon
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");
function $23c0029d1bae07f3$export$2e2bcd8739ae039({ icon: icon, title: title, subtitle: subtitle, onClick: onClick, badge: badge }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        onClick: onClick,
        sx: {
            backgroundColor: "#243049",
            borderRadius: "12px",
            padding: "10px",
            display: "flex",
            alignItems: "center",
            gap: "15px",
            cursor: "pointer",
            transition: "background 0.2s",
            "&:active": {
                backgroundColor: "#26334d"
            }
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                sx: {
                    width: 30,
                    display: "flex",
                    justifyContent: "center",
                    fontSize: "1.5rem"
                },
                children: icon
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                spacing: 0.25,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "body1",
                        sx: {
                            color: "white",
                            fontWeight: 700,
                            fontSize: "1.1rem"
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "body2",
                        sx: {
                            color: "#94a3b8",
                            fontSize: "0.8rem",
                            fontWeight: 400
                        },
                        children: subtitle
                    })
                ]
            }),
            badge && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                component: "span",
                sx: {
                    marginLeft: "auto",
                    flexShrink: 0,
                    backgroundColor: "rgba(60,233,124,0.15)",
                    color: "#3CE97C",
                    fontSize: "0.62rem",
                    fontWeight: 800,
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    padding: "2px 5px",
                    borderRadius: "999px"
                },
                children: badge
            })
        ]
    });
}


const $77966e41cbb89d26$var$iconMap = {
    performance_dashboard: /*#__PURE__*/ (0, $ih19M.jsx)((0, $j3Clf.default), {
        sx: {
            color: "#3b82f6",
            fontSize: "1.5rem"
        }
    }),
    quick_start: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ltl7W.default), {
        sx: {
            color: "#4ade80",
            fontSize: "1.5rem"
        }
    }),
    classes_at_location: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lqNsp.default), {
        sx: {
            color: "#3CE97C",
            fontSize: "1.5rem"
        }
    }),
    ai_workouts: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hkEd6.default), {
        sx: {
            color: "#a855f7",
            fontSize: "1.5rem"
        }
    }),
    multi_level: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9hCj6.default), {
        sx: {
            color: "#56D5EF",
            fontSize: "1.5rem"
        }
    }),
    skill_building: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6sKkU.default), {
        sx: {
            color: "#DA30D8",
            fontSize: "1.5rem"
        }
    }),
    single_shots: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6tjVY.default), {
        sx: {
            color: "#EFA511",
            fontSize: "1.5rem"
        }
    }),
    all_workouts: /*#__PURE__*/ (0, $ih19M.jsx)((0, $jwTd4.default), {
        sx: {
            color: "#ffffff",
            fontSize: "1.5rem"
        }
    }),
    long_form_assessment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dOzud.default), {
        sx: {
            color: "#3CE97C",
            fontSize: "1.5rem"
        }
    }),
    padel_assessment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dOzud.default), {
        sx: {
            color: "#3CE97C",
            fontSize: "1.5rem"
        }
    })
};
const $77966e41cbb89d26$var$personalIconMap = {
    recently_played: /*#__PURE__*/ (0, $ih19M.jsx)((0, $84QRb.default), {
        sx: {
            color: "#ffffff",
            fontSize: "1.5rem"
        }
    }),
    favorites: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aEnM8.default), {
        sx: {
            color: "#ffffff",
            fontSize: "1.5rem"
        }
    }),
    my_workouts: /*#__PURE__*/ (0, $ih19M.jsx)((0, $V7QJD.default), {
        sx: {
            color: "#ffffff",
            fontSize: "1.5rem"
        }
    }),
    pti_stats: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8HCQF.default), {
        sx: {
            color: "#ffffff",
            fontSize: "1.5rem"
        }
    }),
    dupr_dashboard: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3vS3m.default), {
        sx: {
            color: "#3CE97C",
            fontSize: "1.5rem"
        }
    }),
    padel_dashboard: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3vS3m.default), {
        sx: {
            color: "#3CE97C",
            fontSize: "1.5rem"
        }
    })
};
function $77966e41cbb89d26$var$PtiTrendIcon({ trend: trend, ...props }) {
    switch(trend){
        case -1:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8yAk0.default), {
                ...props
            });
        case 0:
            return null;
        case 1:
        default:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8HCQF.default), {
                ...props,
                sx: {
                    color: (theme)=>`${theme.palette.success.main} !important`,
                    ...props.sx
                }
            });
    }
}
function $77966e41cbb89d26$export$2e2bcd8739ae039({ homeClub: homeClub, homeClubClasses: homeClubClasses, homeClubWorkouts: homeClubWorkouts, trainerClub: trainerClub }) {
    const navigate = (0, $as544.useNavigate)();
    const { selected: sport } = (0, $76QOg.useSelectedSport)();
    const { features: features } = (0, $W4f7l.useCurrentUser)();
    const { setDialogType: setDialogType } = (0, $62tuQ.default)();
    // PTI comes from its own request, so a slow or failing APTA lookup no longer
    // holds up — or silently blanks — the rest of this screen.
    const { rating: rating, hasAptaId: hasAptaId, state: ptiState } = (0, $478bae5a1981a49e$export$7a3fe963304383f4)();
    // DUPR state drives the assessment entry's copy and placement:
    //  - not linked            → "Don't have a DUPR? Get Rated"
    //  - linked, unrated       → "Get your official DUPR rating"
    //  - officially rated      → "Retake your DUPR assessment", and the DUPR
    //                            Dashboard is added under Personal
    //  - already submitted     → the entry drops out entirely; only the Personal
    //                            Dashboard row remains
    const { profile: duprProfile, hasSubmitted: duprSubmitted, loading: duprLoading } = (0, $a046b59bbb6f4fe3$export$dfdd01146dc6f769)();
    const { phase: padelPhase, loading: padelPhaseLoading } = (0, $5O1Z6.default)();
    const duprLinked = duprProfile != null;
    const duprRated = duprProfile ? (0, $9aar5.hasOfficialDuprRating)(duprProfile) : false;
    // A spent submission means the player is done with the assessment even though
    // `duprRated` is still false: DUPR reports our push as an AI-annotated
    // rating, which `hasOfficialDuprRating` deliberately does not count. Reading
    // the profile alone is why a submitted player used to keep seeing the "get
    // rated" CTA.
    const duprDone = duprRated || duprSubmitted;
    const duprDashboardInPersonal = sport === "PICKLEBALL" && !duprLoading && duprDone;
    // The padel dashboard rides alongside the padel assessment entry rather
    // than replacing it: its DUPR twin appears only once the player is done
    // with the assessment, because submitting is once-only and the entry has
    // nothing left to offer after it. Padel has nothing to submit, so taking it
    // again stays on offer and both rows show together.
    // Withheld entirely during the trial: the padel dashboard is a results
    // surface, and the trial's whole premise is that results are not shown back
    // yet. Withheld while the phase is still loading too, for the same reason
    // the DUPR row waits on `duprLoading` — offering a row that then vanishes is
    // worse than a beat of nothing, and here the row would lead somewhere that
    // redirects.
    const padelDashboardInPersonal = sport === "PADEL" && features.includes((0, $a8DUk.PADEL_ASSESSMENT_FEATURE)) && !padelPhaseLoading && padelPhase === "general";
    // The lacrosse trial has two things to offer, its Player and Goalie
    // workouts, and nothing else on this screen leads anywhere useful for it:
    // the sport-agnostic rows, clubs, community and Personal all list racquet
    // content. So lacrosse shows its own rows and nothing more.
    const lacrosseOnly = sport === "LACROSSE";
    const logInteractions = $bh6RR.useMemo(()=>{
        return features.includes("HOME_SCREEN_CLASSES");
    }, [
        features
    ]);
    const mainWorkoutItemsFiltered = $bh6RR.useMemo(()=>{
        return (0, $a8DUk.withSegmentCollections)((0, $a8DUk.mainWorkoutItems), (0, $a8DUk.SEGMENT_COLLECTIONS)).filter((item)=>item.sports ? item.sports.includes(sport) : !lacrosseOnly).filter((item)=>!item.featureFlag || features.includes(item.featureFlag)).filter((item)=>item.name !== "classes_at_location" || homeClubClasses).flatMap((item)=>{
            if (item.name === "padel_assessment") {
                // Badged "Beta" for the length of the trial, so a player
                // knows what they are opting into before they tap — the
                // assessment asks for their WPR and shows no score back,
                // and both are easier to accept when flagged up front.
                // Defer while the phase is unknown, the same way the DUPR
                // entry defers on `duprLoading`, rather than badging and
                // then un-badging.
                if (padelPhaseLoading) return [];
                return [
                    {
                        ...item,
                        badge: padelPhase === "general" ? item.badge : "Beta"
                    }
                ];
            }
            if (item.name !== "long_form_assessment") return [
                item
            ];
            // Availability is the sport alone (`sports: ["PICKLEBALL"]` on
            // the item, applied by the filter above) — the assessment is no
            // longer gated on a feature.
            //
            // Defer until DUPR status is known (avoids a title flash), then
            // title by DUPR status.
            if (duprLoading) return [];
            // A player who has submitted has spent their one submission, so
            // there is nothing for this entry to offer. It drops out and the
            // DUPR Dashboard takes its place under Personal (see
            // duprDashboardInPersonal). Retaking stays reachable from the
            // dashboard itself.
            if (duprSubmitted) return [];
            // Officially-rated players keep the entry — they may retake,
            // subject to the server's retake throttle — but the copy shifts
            // from "get rated" to "retake", since they already have one.
            return [
                {
                    ...item,
                    label: (0, $a8DUk.duprAssessmentLabel)({
                        duprRated: duprRated,
                        duprLinked: duprLinked
                    })
                }
            ];
        });
    }, [
        sport,
        lacrosseOnly,
        features,
        homeClubClasses,
        duprLoading,
        duprRated,
        duprLinked,
        duprSubmitted,
        padelPhase,
        padelPhaseLoading
    ]);
    const logInteraction = $bh6RR.useCallback((name, context)=>{
        if (logInteractions) (0, $fcQCp.default).addAction(name, context);
    }, [
        logInteractions
    ]);
    const handleWorkoutItemClick = (item)=>{
        if (item.setFilter) item.setFilter();
        logInteraction("Workout Category Selected", {
            value: item.label
        });
        // Tag navigation from the home screen so destinations (e.g. the
        // Performance Dashboard) can attribute the entry path on their
        // drop-off funnel events.
        navigate(item.navUrl, {
            state: {
                source: "home"
            }
        });
    };
    const handleCommunityClick = (providerId, name)=>{
        (0, $awHpO.default).setFilter("search", {
            appId: null,
            position: false,
            providerIds: [
                providerId
            ],
            excludeProviderIds: [],
            tagIds: [],
            contentMode: "mixed"
        });
        logInteraction("Community Workouts Selected", {
            value: name
        });
        navigate("/content/apps/workouts/search");
    };
    const handleAllCommunityClick = ()=>{
        (0, $awHpO.default).setFilter("search", {
            appId: null,
            position: false,
            providerIds: [],
            excludeProviderIds: [],
            tagIds: [],
            contentMode: "communityOnly"
        });
        logInteraction("All Community Workouts Selected", {});
        navigate("/content/apps/workouts/search");
    };
    const handlePersonalItemClick = (item)=>{
        // The question is whether the player has given us an APTA number, not
        // whether we could compute a PTI from it. Those differ: a linked player
        // with no matches attributed to them yet has no rating, and gating on
        // `rating` asked them to re-enter a number they already had, on every
        // tap, forever (issue #8335). Only "loaded" is an answer: on "error" we
        // never learned whether they have a number, so we fall through to
        // /player-pti, which reports its own failures, rather than ask.
        if (item.name === "pti_stats" && ptiState === "loaded" && !hasAptaId) {
            logInteraction("PTI Selected - No APTA ID", {});
            setDialogType("APTAId");
            return;
        }
        if (item.setFilter) item.setFilter();
        logInteraction("Personal Content Selected", {
            value: item.label
        });
        navigate(item.navUrl);
    };
    const filteredPersonalItems = $bh6RR.useMemo(()=>{
        const base = (0, $a8DUk.personalItems).filter((item)=>!item.sportFilter || item.sportFilter.includes(sport))// Defer the PTI entry until its state is settled, the same way the
        // DUPR assessment entry defers on duprLoading. Its click behaviour
        // and its trailing PTI chip both read this state, so showing it
        // early means either a mistap into the wrong dialog or a chip that
        // pops in a beat later.
        // Withheld only while pending — on "error" the entry stays,
        // navigating to /player-pti, which reports its own failures. Hiding
        // it there would leave no way to reach PTI from home.
        .filter((item)=>item.name !== "pti_stats" || ptiState !== "loading");
        if (padelDashboardInPersonal) return [
            {
                name: "padel_dashboard",
                label: "Padel Dashboard",
                subtitle: "Your assessment results",
                navUrl: "/padel-dashboard"
            },
            ...base
        ];
        if (!duprDashboardInPersonal) return base;
        // Rated players get the DUPR Dashboard as their assessment-adjacent
        // Personal entry. A submitted player has no main-list entry at all; an
        // officially-rated one keeps a "retake" entry alongside this.
        return [
            {
                name: "dupr_dashboard",
                label: "DUPR Dashboard",
                subtitle: "Your rating, match history and reliability",
                navUrl: "/dupr-dashboard"
            },
            ...base
        ];
    }, [
        sport,
        duprDashboardInPersonal,
        padelDashboardInPersonal,
        ptiState
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                spacing: 1.5,
                sx: {
                    marginBottom: "25px"
                },
                children: [
                    mainWorkoutItemsFiltered.map((item)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $23c0029d1bae07f3$export$2e2bcd8739ae039), {
                            icon: item.name.startsWith((0, $a8DUk.SEGMENT_COLLECTION_ITEM_PREFIX)) ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $04d5755b7590a459$export$2e2bcd8739ae039), {
                                sx: {
                                    color: item.iconColor,
                                    fontSize: "1.5rem"
                                }
                            }) : $77966e41cbb89d26$var$iconMap[item.name],
                            title: item.label,
                            subtitle: item.subtitle,
                            badge: item.badge,
                            onClick: ()=>handleWorkoutItemClick(item)
                        }, item.name)),
                    !lacrosseOnly && homeClub && homeClubWorkouts && /*#__PURE__*/ (0, $ih19M.jsx)((0, $4362490af671785c$export$2e2bcd8739ae039), {
                        clubType: "home",
                        providerName: homeClub.name,
                        providerLabel: homeClub.label,
                        onClick: ()=>handleCommunityClick(homeClub.providerId, homeClub.label)
                    }),
                    !lacrosseOnly && trainerClub && /*#__PURE__*/ (0, $ih19M.jsx)((0, $4362490af671785c$export$2e2bcd8739ae039), {
                        clubType: "connected",
                        providerName: trainerClub.name,
                        providerLabel: trainerClub.label,
                        onClick: ()=>handleCommunityClick(trainerClub.providerId, trainerClub.label)
                    }),
                    !lacrosseOnly && /*#__PURE__*/ (0, $ih19M.jsx)((0, $fabffa6a060a1d01$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $04d5755b7590a459$export$2e2bcd8739ae039), {
                            sx: {
                                color: "#ffffff",
                                fontSize: "1.5rem"
                            }
                        }),
                        label: "Community Published Workouts",
                        subtitle: "Public drills created by other clubs and players",
                        dim: true,
                        onClick: handleAllCommunityClick
                    })
                ]
            }),
            !lacrosseOnly && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $17c35323064cc301$export$2e2bcd8739ae039), {
                        title: "Personal"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $8JNI1.default), {
                        spacing: 1.5,
                        children: filteredPersonalItems.map((item)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $fabffa6a060a1d01$export$2e2bcd8739ae039), {
                                icon: $77966e41cbb89d26$var$personalIconMap[item.name],
                                label: item.label,
                                subtitle: item.subtitle,
                                onClick: ()=>handlePersonalItemClick(item),
                                endIcon: item.name === "pti_stats" && rating ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $95FNu.default), {
                                    size: "small",
                                    label: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                        children: [
                                            rating.value,
                                            " ",
                                            /*#__PURE__*/ (0, $ih19M.jsx)($77966e41cbb89d26$var$PtiTrendIcon, {
                                                trend: rating.trend,
                                                sx: {
                                                    fontSize: "1.2rem",
                                                    verticalAlign: "middle"
                                                }
                                            })
                                        ]
                                    }),
                                    sx: (theme)=>({
                                            px: 1,
                                            textDecoration: "none",
                                            background: theme.palette.background.default,
                                            color: theme.palette.text.primary
                                        })
                                }) : undefined
                            }, item.name))
                    })
                ]
            })
        ]
    });
}



var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");
const $f072e1db2548de52$export$fb9ad0468e9276eb = "recommend";
function $f072e1db2548de52$var$parse(value) {
    return value === "assessment" ? value : null;
}
function $f072e1db2548de52$export$2e2bcd8739ae039() {
    const [searchParams, setSearchParams] = (0, $as544.useSearchParams)();
    const [value] = $bh6RR.useState(()=>$f072e1db2548de52$var$parse(searchParams.get($f072e1db2548de52$export$fb9ad0468e9276eb)));
    // Strips the parameter once it has been read. Honest dependencies, no loop: after
    // the replace, `searchParams` no longer carries the key and the effect is a no-op.
    $bh6RR.useEffect(()=>{
        if (!searchParams.has($f072e1db2548de52$export$fb9ad0468e9276eb)) return;
        const next = new URLSearchParams(searchParams);
        next.delete($f072e1db2548de52$export$fb9ad0468e9276eb);
        setSearchParams(next, {
            replace: true
        });
    }, [
        searchParams,
        setSearchParams
    ]);
    return value;
}


function $4c7bc7bf7b2536bf$export$2e2bcd8739ae039() {
    const { selected: sport } = (0, $76QOg.useSelectedSport)();
    const statusValue = (0, $ezs3H.useStatus)();
    const [atAGlance, setAtAGlance] = $bh6RR.useState(null);
    const [goalData, setGoalData] = $bh6RR.useState(null);
    const [homeClub, setHomeClub] = $bh6RR.useState(null);
    const [trainerClub, setTrainerClub] = $bh6RR.useState(null);
    const [yearInReviewYears, setYearInReviewYears] = $bh6RR.useState([]);
    const [homeClubWorkouts, setHomeClubWorkouts] = $bh6RR.useState(false);
    const [homeClubClasses, setHomeClubClasses] = $bh6RR.useState(false);
    // Consumed from the URL on mount: Club-in-Club's onboarding ends by sending the
    // member here with `?recommend=assessment`.
    const recommendation = (0, $f072e1db2548de52$export$2e2bcd8739ae039)();
    $bh6RR.useEffect(()=>{
        async function fetchData() {
            try {
                const trainerId = statusValue.status?.clientId;
                const [atAGlanceData, goalProgressData, userProfileData, trainerClubData, yearInReviewData] = await Promise.all([
                    // Every member catches for itself. Two of these used to
                    // reject into the batch, so one slow or unauthorized call
                    // — at-a-glance runs to 10s and fetchApi aborts there —
                    // discarded the whole screen's data, leaving `atAGlance`
                    // null for the life of the page (issue #8335).
                    (0, $cK0UE.default)("/api/stats/at-a-glance").catch((e)=>{
                        (0, $cK0UE.logFetchError)(e, "Could not fetch stats at-a-glance");
                        return null;
                    }),
                    (0, $cK0UE.default)("/api/stats/goals/active/progress").catch((e)=>{
                        (0, $cK0UE.logFetchError)(e, "Could not fetch active goal progress");
                        return null;
                    }),
                    (0, $cK0UE.default)("/api/users/me").catch((e)=>{
                        (0, $cK0UE.logFetchError)(e, "Could not fetch user profile");
                        return null;
                    }),
                    trainerId ? (0, $cK0UE.default)(`/api/app-workouts/trainer-club/${trainerId}?sport=${sport}&limit=1&offset=0`).catch(()=>({
                            count: 0,
                            result: []
                        })) : Promise.resolve({
                        count: 0,
                        result: []
                    }),
                    (0, $cK0UE.default)("/api/year-in-review/available").catch(()=>({
                            years: []
                        }))
                ]);
                if (atAGlanceData) setAtAGlance(atAGlanceData);
                setGoalData(goalProgressData);
                setYearInReviewYears(yearInReviewData.years);
                // Get home club info from user profile's home location
                const homeLocation = userProfileData?.profile?.homeLocation;
                const homeClubProviderId = homeLocation?.contentProvider?.id ?? null;
                if (homeLocation && homeLocation.contentProvider) {
                    const homeClubWorkouts = await (0, $cK0UE.default)(`/api/app-workouts/home-club?sport=${sport}&limit=1&offset=0`);
                    setHomeClub({
                        name: homeLocation.contentProvider.name,
                        label: homeLocation.name,
                        providerId: homeLocation.contentProvider.id
                    });
                    setHomeClubWorkouts(homeClubWorkouts.count > 0);
                } else setHomeClub(null);
                // If we have a home club provider, check for classes
                if (homeClubProviderId) {
                    const classesData = await (0, $cK0UE.default)(`/api/content/search?type=JOURNEY&journeyType=class&sport=${sport}&providerId=${homeClubProviderId}&limit=1&offset=0`).catch(()=>({
                            count: 0,
                            result: []
                        }));
                    setHomeClubClasses(classesData.count > 0);
                } else setHomeClubClasses(false);
                if (trainerClubData.count > 0 && trainerClubData.result[0]?.provider) {
                    const trainerProviderId = trainerClubData.result[0].provider.id;
                    // Only show trainer club if different from home club
                    if (trainerProviderId !== homeClubProviderId) setTrainerClub({
                        name: trainerClubData.result[0].provider.name,
                        label: trainerClubData.result[0].provider.label,
                        providerId: trainerProviderId
                    });
                    else setTrainerClub(null);
                } else setTrainerClub(null);
            } catch (e) {
                (0, $cK0UE.logFetchError)(e, "Could not fetch home screen data");
            }
        }
        fetchData();
    }, [
        sport,
        statusValue.status?.clientId
    ]);
    const homeCarousel = /*#__PURE__*/ (0, $ih19M.jsx)((0, $7186da02e657d657$export$2e2bcd8739ae039), {
        atAGlance: atAGlance,
        goalData: goalData,
        yearInReviewYears: yearInReviewYears
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
        sx: {
            position: "relative",
            overscrollBehavior: "contain",
            px: 1,
            pb: 12,
            backgroundColor: (t)=>t.palette.primary.dark
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $6a0e34c2415dc9c5$export$788c90b6634b4fd8), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $a046b59bbb6f4fe3$export$fa46ab00627a53e2), {
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $478bae5a1981a49e$export$d43e0738e73f0d05), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e9b401647d5d429$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $53b1705fc6183606$export$2e2bcd8739ae039), {
                                recommendation: recommendation
                            }),
                            homeCarousel,
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $77966e41cbb89d26$export$2e2bcd8739ae039), {
                                homeClub: homeClub,
                                homeClubClasses: homeClubClasses,
                                homeClubWorkouts: homeClubWorkouts,
                                trainerClub: trainerClub
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $801236f4e9a889e8$export$2e2bcd8739ae039), {})
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $afMDy = parcelRequire("afMDy");

var $gOLF2 = parcelRequire("gOLF2");

var $6MOqF = parcelRequire("6MOqF");

var $2zpN0 = parcelRequire("2zpN0");

var $1d1FK = parcelRequire("1d1FK");

var $j5ldk = parcelRequire("j5ldk");

var $1lA67 = parcelRequire("1lA67");

var $4rInl = parcelRequire("4rInl");

var $gtX9p = parcelRequire("gtX9p");

var $5Z0If = parcelRequire("5Z0If");

var $hrqHU = parcelRequire("hrqHU");

var $cbFbS = parcelRequire("cbFbS");

var $l0oRz = parcelRequire("l0oRz");

var $cI8xM = parcelRequire("cI8xM");
parcelRequire("eyjy7");
var $fgDKG = parcelRequire("fgDKG");

var $e8yyN = parcelRequire("e8yyN");

var $3iMZv = parcelRequire("3iMZv");

var $W4f7l = parcelRequire("W4f7l");
var $2f0cb17234abb545$exports = {};
$2f0cb17234abb545$exports = $parcel$resolve("kBSJR");


const $225230b7cb484a56$var$backgroundImage = new URL($2f0cb17234abb545$exports).toString();
var $d13559674f70ca16$exports = {};
$d13559674f70ca16$exports = $parcel$resolve("2lEYF");


const $225230b7cb484a56$var$volleyLogoImg = new URL($d13559674f70ca16$exports).toString();
const $225230b7cb484a56$var$googleProvider = new (0, $fgDKG.Y)();
const $225230b7cb484a56$var$appleProvider = new (0, $fgDKG._)("apple.com");
const $225230b7cb484a56$var$LoginTextField = (0, $l0oRz.default)((0, $hrqHU.default))({
    "&.MuiFormControl-root .Mui-disabled": {
        color: "#808799",
        fieldset: {
            borderColor: "#808799"
        }
    },
    "& label": {
        color: "#a8b8d9"
    },
    "& label.Mui-focused": {
        color: (0, $e8yyN.default).palette.secondary.main
    },
    "& .MuiInput-underline:after": {
        borderBottomColor: (0, $e8yyN.default).palette.secondary.main
    },
    "& .MuiOutlinedInput-root": {
        "input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,input:-webkit-autofill:active": {
            WebkitBoxShadow: `0 0 0 30px ${(0, $e8yyN.default).palette.primary.light} inset`
        },
        "input:-webkit-autofill": {
            WebkitTextFillColor: (0, $e8yyN.default).palette.common.white
        },
        "& .MuiIconButton-root": {
            color: (0, $e8yyN.default).palette.primary.light
        },
        "& input": {
            color: (0, $e8yyN.default).palette.common.white
        },
        "& fieldset": {
            borderColor: "#a8b8d9"
        },
        "&:hover fieldset": {
            borderColor: (0, $e8yyN.default).palette.secondary.main
        },
        "&.Mui-focused fieldset": {
            borderColor: (0, $e8yyN.default).palette.secondary.main
        }
    },
    "& .MuiOutlinedInput-root:active, & .MuiOutlinedInput-root:focus, & .MuiOutlinedInput-root:focus-within": {
        "& .MuiIconButton-root": {
            color: (0, $e8yyN.default).palette.secondary.main
        }
    }
});
const $225230b7cb484a56$var$FirebaseErrorMap = {
    "auth/popup-closed-by-user": "Popup closed before logging in",
    "auth/user-not-found": "Invalid email and password combination. Please try again.",
    "auth/wrong-password": "Invalid email and password combination. Please try again."
};
function $225230b7cb484a56$export$2e2bcd8739ae039() {
    const { error: currentUserError } = (0, $W4f7l.useCurrentUser)();
    const desktopMatch = (0, $cI8xM.default)((0, $e8yyN.default).breakpoints.up("md"));
    const [email, setEmail] = $bh6RR.useState("");
    const [password, setPassword] = $bh6RR.useState("");
    const [emailError, setEmailError] = $bh6RR.useState("");
    const [passwordError, setPasswordError] = $bh6RR.useState("");
    const [authError, setAuthError] = $bh6RR.useState("");
    const [showPassword, setShowPassword] = $bh6RR.useState(false);
    const [submitting, setSubmitting] = $bh6RR.useState(false);
    const onSubmit = $bh6RR.useCallback(async (e)=>{
        e.preventDefault();
        setSubmitting(true);
        setEmailError("");
        setPasswordError("");
        let errorCount = 0;
        if (email.length < 5 || !email.includes("@")) {
            setEmailError("Invalid email");
            errorCount += 1;
        }
        if (password.length < 6) {
            setPasswordError("Invalid password");
            errorCount += 1;
        }
        if (errorCount) {
            setSubmitting(false);
            return;
        }
        try {
            await (0, $fgDKG.ac)((0, $fgDKG.p)(), email, password);
        } catch (err) {
            const error = err;
            setAuthError($225230b7cb484a56$var$FirebaseErrorMap[error.code] ?? error.message.slice(0, 100));
        } finally{
            setSubmitting(false);
        }
    }, [
        email,
        password
    ]);
    const onSignInWithGoogle = $bh6RR.useCallback(async ()=>{
        setSubmitting(true);
        try {
            await (0, $fgDKG.d)((0, $fgDKG.p)(), $225230b7cb484a56$var$googleProvider);
        } catch (err) {
            const error = err;
            setAuthError($225230b7cb484a56$var$FirebaseErrorMap[error.code] ?? error.message.slice(0, 100));
        } finally{
            setSubmitting(false);
        }
    }, []);
    const onSignInWithApple = $bh6RR.useCallback(async ()=>{
        setSubmitting(true);
        try {
            await (0, $fgDKG.d)((0, $fgDKG.p)(), $225230b7cb484a56$var$appleProvider);
        } catch (err) {
            const error = err;
            setAuthError($225230b7cb484a56$var$FirebaseErrorMap[error.code] ?? error.message.slice(0, 100));
        } finally{
            setSubmitting(false);
        }
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1lA67.default), {
        container: true,
        alignItems: desktopMatch ? "center" : "flex-end",
        sx: {
            background: desktopMatch ? (0, $e8yyN.default).palette.primary.main : "linear-gradient(157deg, rgba(32, 67, 136, 1) 0%, rgba(24, 39, 79, 1) 100%)",
            backgroundImage: desktopMatch ? `url('${$225230b7cb484a56$var$backgroundImage}')` : undefined,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "left",
            minHeight: "100vh",
            boxShadow: "3px 4px 8px 4px rgb(0, 0, 0, 0.2)",
            py: 2
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1lA67.default), {
                sx: {
                    textAlign: "center"
                },
                size: {
                    xs: 12,
                    md: 7
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                    src: $225230b7cb484a56$var$volleyLogoImg,
                    width: "45%",
                    alt: "Volley logo"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1lA67.default), {
                component: "form",
                onSubmit: onSubmit,
                size: {
                    xs: 12,
                    md: 5
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                        component: "div",
                        sx: {
                            mx: 4,
                            mb: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                color: "error.light",
                                children: currentUserError || authError
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)($225230b7cb484a56$var$LoginTextField, {
                                type: "email",
                                id: "email",
                                label: "Email",
                                fullWidth: true,
                                margin: "normal",
                                disabled: submitting,
                                error: !!emailError,
                                helperText: emailError ?? undefined,
                                onChange: (e)=>setEmail(e.currentTarget.value),
                                sx: {
                                    color: (0, $e8yyN.default).palette.text.secondary,
                                    my: 2
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)($225230b7cb484a56$var$LoginTextField, {
                                type: showPassword ? "text" : "password",
                                id: "password",
                                label: "Password",
                                fullWidth: true,
                                margin: "normal",
                                disabled: submitting,
                                error: !!passwordError,
                                helperText: passwordError ?? undefined,
                                onChange: (e)=>setPassword(e.currentTarget.value),
                                InputProps: {
                                    endAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gtX9p.default), {
                                        position: "end",
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                                            onClick: ()=>setShowPassword(!showPassword),
                                            children: showPassword ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $2zpN0.default), {}) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $6MOqF.default), {})
                                        })
                                    })
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                variant: "body2",
                                align: "center",
                                sx: {
                                    fontSize: 13,
                                    mb: 2
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5Z0If.default), {
                                    color: (0, $e8yyN.default).palette.secondary.main,
                                    underline: "none",
                                    component: (0, $as544.Link),
                                    to: "/auth/forgot-password",
                                    children: "Forgot password?"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        component: "div",
                        sx: {
                            my: 1,
                            mx: 4
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3iMZv.VolleyButton), {
                            type: "submit",
                            disabled: submitting,
                            children: "LOG IN"
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                        variant: "body2",
                        align: "center",
                        sx: {
                            color: (0, $e8yyN.default).palette.common.white,
                            my: 3,
                            fontSize: 13,
                            px: 8
                        },
                        children: [
                            "Not yet a member? No problem!",
                            /*#__PURE__*/ (0, $ih19M.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $5Z0If.default), {
                                color: (0, $e8yyN.default).palette.secondary.main,
                                underline: "none",
                                component: (0, $as544.Link),
                                to: "../signup",
                                fontWeight: "bold",
                                children: "Create an account today."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ldk.default), {
                        sx: {
                            my: 3,
                            mx: 4,
                            borderColor: "#A8B8D9"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        component: "div",
                        sx: {
                            mx: 2,
                            my: 2
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3iMZv.AppleSignInButton), {
                            type: "button",
                            onClick: onSignInWithApple,
                            disabled: submitting,
                            disableElevation: true,
                            sx: {
                                textTransform: "none",
                                fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, Helvetica, Arial, sans-serif",
                                fontSize: 16
                            },
                            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                                component: "div",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $afMDy.default), {
                                        sx: {
                                            mb: 0.5,
                                            mr: 0.4
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        children: "Sign in with Apple"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                        component: "div",
                        sx: {
                            mx: 2,
                            my: 2
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3iMZv.GoogleSignInButton), {
                            type: "button",
                            onClick: onSignInWithGoogle,
                            disabled: submitting,
                            disableElevation: true,
                            sx: {
                                textTransform: "none",
                                fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, Helvetica, Arial, sans-serif",
                                fontSize: 16
                            },
                            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                                component: "div",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gOLF2.default), {
                                        sx: {
                                            mr: 1
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        children: "Sign in with Google"
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $ec3ae2124c820e5d$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8zM5 19l3-4 2 3 3-4 4 5z"
}), 'AddPhotoAlternate');



var $3Xpkr = parcelRequire("3Xpkr");

var $fOOlI = parcelRequire("fOOlI");

var $kKa2X = parcelRequire("kKa2X");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $044c56022562315b$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2m-11-4 2.03 2.71L16 11l4 5H8zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6z"
}), 'PhotoLibrary');



var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $5CVHy = parcelRequire("5CVHy");

var $4YIes = parcelRequire("4YIes");

var $gILAF = parcelRequire("gILAF");

var $4rInl = parcelRequire("4rInl");

var $euyyI = parcelRequire("euyyI");

var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $l0oRz = parcelRequire("l0oRz");
var $kE5Kn = parcelRequire("kE5Kn");

var $1lMle = parcelRequire("1lMle");

var $e8yyN = parcelRequire("e8yyN");

var $fcQCp = parcelRequire("fcQCp");

var $cK0UE = parcelRequire("cK0UE");

var $5ZUrR = parcelRequire("5ZUrR");

var $bmJi8 = parcelRequire("bmJi8");
/**
 * The one card a player shares: 9:16, with its stats kept inside the centre
 * 4:5 band, so a story shows it whole and a feed's crop still shows all of
 * it. Behind the stats is nothing, or the player's own photo.
 */ const $43a568e080e05e35$export$883a12d12ea37139 = {
    width: 1080,
    height: 1920
};


/**
 * The "Your photo" card: the player's own photo under the server's
 * transparent card, combined on the device. The photo never leaves it, so
 * the page draws only the photo and the wash; every word on the card comes
 * from the server's PNG, keeping the design in one place.
 */ 
const $91dd0f6b216a4146$export$86bdef5bfd8abba3 = {
    x: 0.5,
    y: 0.5
};
/** The card a photo is decoded to cover. */ const $91dd0f6b216a4146$var$LARGEST_CARD = (0, $43a568e080e05e35$export$883a12d12ea37139);
/**
 * The longest side a decoded photo is kept at. A panorama scaled to cover
 * the card would otherwise pass the canvas area iOS Safari allows.
 */ const $91dd0f6b216a4146$var$MAX_PHOTO_SIDE = 4096;
/**
 * The design's navy wash, kept light: the transparent card's type carries
 * its own shadow, so more of the player's photo can show through.
 */ const $91dd0f6b216a4146$var$WASH = [
    [
        0,
        0.35
    ],
    [
        0.4,
        0.45
    ],
    [
        1,
        0.85
    ]
];
function $91dd0f6b216a4146$var$coverScale(photo, card) {
    return Math.max(card.width / photo.width, card.height / photo.height);
}
function $91dd0f6b216a4146$export$385b8d11753a5957(photo, focus, card) {
    const scale = $91dd0f6b216a4146$var$coverScale(photo, card);
    const w = photo.width * scale;
    const h = photo.height * scale;
    return {
        x: (card.width - w) * focus.x,
        y: (card.height - h) * focus.y,
        w: w,
        h: h
    };
}
function $91dd0f6b216a4146$export$ecf7c062f0bbbc33(photo, card) {
    const { w: w, h: h } = $91dd0f6b216a4146$export$385b8d11753a5957(photo, $91dd0f6b216a4146$export$86bdef5bfd8abba3, card);
    return w - card.width > 0.5 || h - card.height > 0.5;
}
function $91dd0f6b216a4146$var$clamp01(n) {
    return Math.min(1, Math.max(0, n));
}
function $91dd0f6b216a4146$export$ed9c62577cafeee8(photo, focus, dx, dy, card) {
    const { w: w, h: h } = $91dd0f6b216a4146$export$385b8d11753a5957(photo, focus, card);
    const spareX = w - card.width;
    const spareY = h - card.height;
    return {
        x: spareX > 0.5 ? $91dd0f6b216a4146$var$clamp01(focus.x - dx / spareX) : focus.x,
        y: spareY > 0.5 ? $91dd0f6b216a4146$var$clamp01(focus.y - dy / spareY) : focus.y
    };
}
function $91dd0f6b216a4146$var$newCanvas(width, height) {
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    return canvas;
}
function $91dd0f6b216a4146$var$context2d(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("No 2D canvas");
    return ctx;
}
async function $91dd0f6b216a4146$export$145c61690dbf8d14(file) {
    // `from-image` turns an iPhone photo by its EXIF orientation.
    const full = await createImageBitmap(file, {
        imageOrientation: "from-image"
    });
    const scale = Math.min($91dd0f6b216a4146$var$coverScale(full, $91dd0f6b216a4146$var$LARGEST_CARD), $91dd0f6b216a4146$var$MAX_PHOTO_SIDE / Math.max(full.width, full.height));
    if (scale >= 1) return full;
    const canvas = $91dd0f6b216a4146$var$newCanvas(Math.round(full.width * scale), Math.round(full.height * scale));
    try {
        const ctx = $91dd0f6b216a4146$var$context2d(canvas);
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(full, 0, 0, canvas.width, canvas.height);
        return await createImageBitmap(canvas);
    } finally{
        full.close();
        // iOS holds a canvas's memory until it's collected; this frees it now.
        canvas.width = 0;
        canvas.height = 0;
    }
}
function $91dd0f6b216a4146$export$ca4ed61802041b9d(ctx, photo, overlay, focus, card) {
    const { x: x, y: y, w: w, h: h } = $91dd0f6b216a4146$export$385b8d11753a5957(photo, focus, card);
    ctx.clearRect(0, 0, card.width, card.height);
    ctx.drawImage(photo, x, y, w, h);
    const wash = ctx.createLinearGradient(0, 0, 0, card.height);
    for (const [stop, alpha] of $91dd0f6b216a4146$var$WASH)wash.addColorStop(stop, `rgba(22, 39, 77, ${alpha})`);
    ctx.fillStyle = wash;
    ctx.fillRect(0, 0, card.width, card.height);
    ctx.drawImage(overlay, 0, 0, card.width, card.height);
}
function $91dd0f6b216a4146$export$9281b2ccc10dc4bc(canvas) {
    return new Promise((resolve, reject)=>{
        canvas.toBlob((blob)=>blob ? resolve(blob) : reject(new Error("Empty card image")), "image/jpeg", 0.9);
    });
}



var $bh6RR = parcelRequire("bh6RR");

var $1lMle = parcelRequire("1lMle");

/** Wait for a drag to settle before encoding the card to share. */ const $39144c63ca2eba38$var$EXPORT_DELAY_MS = 150;
function $39144c63ca2eba38$export$f0650636b065e827(photo, overlay, card) {
    const [canvas, setCanvas] = $bh6RR.useState(null);
    const [decoded, setDecoded] = $bh6RR.useState(null);
    const [focus, setFocus] = $bh6RR.useState((0, $91dd0f6b216a4146$export$86bdef5bfd8abba3));
    const [exported, setExported] = $bh6RR.useState(null);
    const [failed, setFailed] = $bh6RR.useState(false);
    const drag = $bh6RR.useRef(null);
    $bh6RR.useEffect(()=>setFocus((0, $91dd0f6b216a4146$export$86bdef5bfd8abba3)), [
        photo
    ]);
    $bh6RR.useEffect(()=>{
        if (!overlay) return undefined;
        let cancelled = false;
        let bitmap = null;
        setFailed(false);
        createImageBitmap(overlay).then((b)=>{
            if (cancelled) {
                b.close();
                return;
            }
            bitmap = b;
            setDecoded({
                source: overlay,
                bitmap: b
            });
        }).catch((e)=>{
            if (cancelled) return;
            (0, $1lMle.default).error(`Could not decode the recap card: ${String(e)}`);
            setFailed(true);
        });
        return ()=>{
            cancelled = true;
            if (!bitmap) return;
            const closing = bitmap;
            // Forget it as well as closing it: the same card comes back when
            // the player returns from Stats only, and a closed bitmap can't
            // be drawn (drawImage throws).
            setDecoded((d)=>d?.bitmap === closing ? null : d);
            closing.close();
        };
    }, [
        overlay
    ]);
    // A bitmap decoded from an earlier card is closed, so never drawn.
    const overlayBitmap = decoded && overlay && decoded.source === overlay ? decoded.bitmap : null;
    $bh6RR.useEffect(()=>{
        if (!canvas || !photo || !overlayBitmap) return undefined;
        const ctx = canvas.getContext("2d");
        if (!ctx) {
            setFailed(true);
            return undefined;
        }
        (0, $91dd0f6b216a4146$export$ca4ed61802041b9d)(ctx, photo, overlayBitmap, focus, card);
        let cancelled = false;
        const timer = setTimeout(()=>{
            (0, $91dd0f6b216a4146$export$9281b2ccc10dc4bc)(canvas).then((blob)=>{
                if (cancelled) return;
                setExported({
                    blob: blob,
                    photo: photo,
                    overlay: overlayBitmap,
                    focus: focus,
                    card: card
                });
            }).catch((e)=>{
                if (cancelled) return;
                (0, $1lMle.default).error(`Could not encode the recap card: ${String(e)}`);
                setFailed(true);
            });
        }, $39144c63ca2eba38$var$EXPORT_DELAY_MS);
        return ()=>{
            cancelled = true;
            clearTimeout(timer);
        };
    }, [
        canvas,
        photo,
        overlayBitmap,
        focus,
        card
    ]);
    const onPointerDown = $bh6RR.useCallback((e)=>{
        e.currentTarget.setPointerCapture?.(e.pointerId);
        drag.current = {
            id: e.pointerId,
            x: e.clientX,
            y: e.clientY
        };
    }, []);
    const onPointerMove = $bh6RR.useCallback((e)=>{
        const last = drag.current;
        if (!photo || !last || last.id !== e.pointerId) return;
        // Screen pixels to card pixels: the canvas is shown scaled down.
        const scale = card.width / e.currentTarget.clientWidth;
        const dx = (e.clientX - last.x) * scale;
        const dy = (e.clientY - last.y) * scale;
        drag.current = {
            ...last,
            x: e.clientX,
            y: e.clientY
        };
        setFocus((f)=>(0, $91dd0f6b216a4146$export$ed9c62577cafeee8)(photo, f, dx, dy, card));
    }, [
        photo,
        card
    ]);
    const onPointerUp = $bh6RR.useCallback(()=>{
        drag.current = null;
    }, []);
    const ready = exported !== null && exported.photo === photo && exported.overlay === overlayBitmap && exported.focus === focus && exported.card === card;
    return {
        canvasRef: setCanvas,
        /** The card to share, when it matches what's on screen. */ blob: ready ? exported.blob : null,
        ready: ready,
        loading: photo !== null && overlay !== null && overlayBitmap === null,
        failed: failed,
        /** Whether a drag would show any more of the photo. */ movable: photo !== null && (0, $91dd0f6b216a4146$export$ecf7c062f0bbbc33)(photo, card),
        dragHandlers: {
            onPointerDown: onPointerDown,
            onPointerMove: onPointerMove,
            onPointerUp: onPointerUp,
            onPointerCancel: onPointerUp
        }
    };
}


/** How long the drag hint stays on a fresh photo before fading. */ const $167f3d5b1a572a70$var$DRAG_HINT_MS = 2500;
/**
 * The app closes a session without waiting, so a recap opened straight from
 * the end-of-session flow can arrive before the server knows it ended.
 */ const $167f3d5b1a572a70$var$NOT_ENDED_RETRIES = 4;
const $167f3d5b1a572a70$var$NOT_ENDED_RETRY_MS = 1500;
const $167f3d5b1a572a70$var$numberFormat = new Intl.NumberFormat("en-US");
const $167f3d5b1a572a70$var$TITLE = [
    "Session Recap"
];
function $167f3d5b1a572a70$var$deviceTimeZone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    } catch  {
        return "UTC";
    }
}
/** Volley's account, for players to tag when they post. */ const $167f3d5b1a572a70$var$VOLLEY_HANDLE = "@trainwithvolley";
function $167f3d5b1a572a70$var$shareText(stats) {
    const balls = $167f3d5b1a572a70$var$numberFormat.format(stats.ballsHit);
    const sport = stats.sport ? ` ${stats.sport.toLowerCase()}` : "";
    return `Just hit ${balls}${sport} balls on Volley \u{1F3BE} ${$167f3d5b1a572a70$var$VOLLEY_HANDLE}`;
}
/**
 * The card carries no name: marketing's design leaves it off.
 */ const $167f3d5b1a572a70$var$SHOW_NAME = false;
/**
 * The club is always on the card (home courts never are; the server leaves
 * them off). Hiding it can come back as a toggle if players ask for it.
 */ const $167f3d5b1a572a70$var$SHOW_LOCATION = true;
/** A canvas that takes `sx`; Box would read width and height as styles. */ const $167f3d5b1a572a70$var$Canvas = (0, $l0oRz.default)("canvas")({});
/**
 * What the card is previewed on without a photo: a plain stage standing in
 * for wherever it's posted, edged with a dashed line to show the card itself
 * has no background.
 */ const $167f3d5b1a572a70$var$TRANSPARENT_STAGE = {
    borderRadius: 3,
    background: "linear-gradient(180deg, #2B3550 0%, #151C2E 100%)",
    outline: "1.5px dashed rgba(255, 255, 255, 0.3)",
    outlineOffset: "-6px"
};
/** A note pinned to the foot of the card's preview; never part of the card. */ const $167f3d5b1a572a70$var$CARD_NOTE_SX = {
    position: "absolute",
    bottom: "4%",
    left: "50%",
    transform: "translateX(-50%)",
    px: 1.5,
    py: 0.5,
    borderRadius: 99,
    bgcolor: "rgba(11, 23, 48, 0.72)",
    color: "common.white",
    fontWeight: 600,
    whiteSpace: "nowrap",
    pointerEvents: "none"
};
/**
 * The card's own box inside the preview, so the notes above sit on the card
 * rather than somewhere in the space around it. Sized from the preview with
 * container units; a browser without them (iOS before 16) gets the whole
 * preview as the frame, and the notes sit at its foot instead.
 */ function $167f3d5b1a572a70$var$cardFrameSx() {
    const { width: width, height: height } = (0, $43a568e080e05e35$export$883a12d12ea37139);
    return {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        "@supports (width: 1cqw)": {
            width: `min(100cqw, 100cqh * ${width} / ${height})`,
            height: `min(100cqh, 100cqw * ${height} / ${width})`
        }
    };
}
/**
 * The stats with nothing behind them: shared as they are, or laid over the
 * player's own photo on the device.
 */ function $167f3d5b1a572a70$var$previewUrl(sessionId) {
    const params = new URLSearchParams({
        showName: String($167f3d5b1a572a70$var$SHOW_NAME),
        showLocation: String($167f3d5b1a572a70$var$SHOW_LOCATION),
        timeZone: $167f3d5b1a572a70$var$deviceTimeZone()
    });
    return `/api/session-recaps/sessions/${sessionId}/image?${params}`;
}
/** The card the player would share, as both a blob (to share) and a URL. */ function $167f3d5b1a572a70$var$useCardImage(url) {
    const [image, setImage] = $bh6RR.useState(null);
    const [loading, setLoading] = $bh6RR.useState(false);
    const [failed, setFailed] = $bh6RR.useState(false);
    const [attempt, setAttempt] = $bh6RR.useState(0);
    $bh6RR.useEffect(()=>{
        if (!url) return undefined;
        let objectUrl = null;
        let cancelled = false;
        setLoading(true);
        setFailed(false);
        (0, $cK0UE.fetchApiBlob)(url).then((blob)=>{
            if (cancelled) return;
            objectUrl = URL.createObjectURL(blob);
            setImage({
                blob: blob,
                objectUrl: objectUrl,
                url: url
            });
        }).catch((e)=>{
            if (cancelled) return;
            (0, $cK0UE.logFetchError)(e, "Could not load session recap card");
            setFailed(true);
        }).finally(()=>!cancelled && setLoading(false));
        return ()=>{
            cancelled = true;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [
        url,
        attempt
    ]);
    const retry = $bh6RR.useCallback(()=>setAttempt((n)=>n + 1), []);
    /** The card on screen is the one these settings would share. */ const ready = !loading && !failed && image !== null && image.url === url;
    return {
        image: image,
        loading: loading,
        failed: failed,
        ready: ready,
        retry: retry
    };
}
function $167f3d5b1a572a70$export$2e2bcd8739ae039() {
    const navigate = (0, $as544.useNavigate)();
    const { id: id } = (0, $as544.useParams)();
    const sessionId = Number(id);
    const [searchParams] = (0, $as544.useSearchParams)();
    const source = searchParams.get("source") === "end_flow" ? "end_flow" : "history";
    const [recap, setRecap] = $bh6RR.useState(null);
    const [error, setError] = $bh6RR.useState(null);
    const [photo, setPhoto] = $bh6RR.useState(null);
    const [decodingPhoto, setDecodingPhoto] = $bh6RR.useState(false);
    const [dragHintSeen, setDragHintSeen] = $bh6RR.useState(false);
    const photoInput = $bh6RR.useRef(null);
    const offerCustomPhoto = $bh6RR.useMemo((0, $5ZUrR.canShareCustomPhoto), []);
    // An old app build has nowhere to send the card; it isn't sent here, but
    // a link or a back button can still land on the page.
    const supported = $bh6RR.useMemo((0, $5ZUrR.canShareRecap), []);
    // The player's photo goes under the server's transparent card.
    const isCustom = photo !== null;
    const card = (0, $43a568e080e05e35$export$883a12d12ea37139);
    const [busy, setBusy] = $bh6RR.useState(false);
    const [needsTap, setNeedsTap] = $bh6RR.useState(false);
    const gestureRefusals = $bh6RR.useRef(0);
    // Set when there's no share sheet to open: the player saves the card.
    const [saveInstead, setSaveInstead] = $bh6RR.useState(false);
    const [toast, setToast] = $bh6RR.useState(null);
    const close = $bh6RR.useCallback(()=>{
        // Back to the history list they came from; the end of a session
        // carries on to home.
        if (source === "history" && window.history.length > 1) navigate(-1);
        else navigate("/");
    }, [
        navigate,
        source
    ]);
    $bh6RR.useEffect(()=>{
        if (!supported) {
            (0, $fcQCp.default).addAction("session_recap_unsupported_app", {
                source: source
            });
            return undefined;
        }
        if (!sessionId) {
            setError("We couldn't find that session.");
            return undefined;
        }
        let cancelled = false;
        let timer;
        const load = (attempt)=>{
            (0, $cK0UE.default)(`/api/session-recaps/sessions/${sessionId}`).then((res)=>{
                if (cancelled) return;
                if (!res.eligible && res.reason === "not_ended" && source === "end_flow" && attempt < $167f3d5b1a572a70$var$NOT_ENDED_RETRIES) {
                    timer = setTimeout(()=>load(attempt + 1), $167f3d5b1a572a70$var$NOT_ENDED_RETRY_MS);
                    return;
                }
                if (!res.eligible && source === "end_flow") {
                    // Nothing worth celebrating; carry on as before.
                    (0, $fcQCp.default).addAction("session_recap_skipped", {
                        reason: res.reason,
                        attempts: attempt + 1
                    });
                    navigate("/", {
                        replace: true
                    });
                    return;
                }
                setRecap(res);
                if (res.eligible) (0, $fcQCp.default).addAction("session_recap_viewed", {
                    source: source
                });
            }).catch((e)=>{
                if (cancelled) return;
                (0, $cK0UE.logFetchError)(e, "Could not load session recap");
                if (source === "end_flow") {
                    (0, $fcQCp.default).addAction("session_recap_skipped", {
                        reason: "error",
                        status: e instanceof (0, $cK0UE.FetchError) ? e.statusCode : null,
                        attempts: attempt + 1
                    });
                    navigate("/", {
                        replace: true
                    });
                } else setError("We couldn't load this recap.");
            });
        };
        load(0);
        return ()=>{
            cancelled = true;
            if (timer) clearTimeout(timer);
        };
    }, [
        sessionId,
        source,
        navigate,
        supported
    ]);
    const eligible = recap?.eligible ? recap : null;
    const { image: image, loading: imageLoading, failed: imageFailed, ready: cardReady, retry: retryImage } = $167f3d5b1a572a70$var$useCardImage(eligible ? $167f3d5b1a572a70$var$previewUrl(sessionId) : null);
    const custom = (0, $39144c63ca2eba38$export$f0650636b065e827)(photo, isCustom && cardReady && image ? image.blob : null, card);
    const shareReady = isCustom ? custom.ready : cardReady;
    // The card as it's on screen now, which a change after a share attempt
    // (a photo added, removed or moved) makes the one to save.
    const currentCard = isCustom ? custom.blob : image?.blob ?? null;
    const fileName = isCustom ? "volley-session-recap-your-photo.jpg" : "volley-session-recap.png";
    const previewFailed = isCustom ? custom.failed || imageFailed : imageFailed;
    const previewLoading = imageLoading || decodingPhoto || isCustom && custom.loading;
    // Once, on a photo with something to bring in; gone at the first drag.
    const showDragHint = isCustom && custom.movable && !previewLoading && !previewFailed && !dragHintSeen;
    $bh6RR.useEffect(()=>{
        if (!showDragHint) return undefined;
        const timer = setTimeout(()=>setDragHintSeen(true), $167f3d5b1a572a70$var$DRAG_HINT_MS);
        return ()=>clearTimeout(timer);
    }, [
        showDragHint
    ]);
    // Each photo is closed once it's replaced, or the page goes.
    $bh6RR.useEffect(()=>()=>photo?.close(), [
        photo
    ]);
    const pickPhoto = $bh6RR.useCallback(()=>{
        // Opened from the tap, so the browser lets the picker open.
        photoInput.current?.click();
    }, []);
    const onPhotoPicked = $bh6RR.useCallback(async (e)=>{
        const file = e.target.files?.[0];
        // Picking the same photo again should still count as a change.
        e.target.value = "";
        // Cancelled: the previous card was never swapped out.
        if (!file) return;
        setDecodingPhoto(true);
        try {
            setPhoto(await (0, $91dd0f6b216a4146$export$145c61690dbf8d14)(file));
            (0, $fcQCp.default).addAction("session_recap_photo_picked", {
                type: file.type
            });
        } catch (err) {
            (0, $1lMle.default).warn(`Could not open recap photo: ${String(err)}`);
            setToast("We couldn't open that photo. Try another one.");
        } finally{
            setDecodingPhoto(false);
        }
    }, []);
    // Back to the stats alone; the photo is closed by the effect above.
    const removePhoto = $bh6RR.useCallback(()=>setPhoto(null), []);
    const share = $bh6RR.useCallback(async ()=>{
        if (!eligible || !shareReady || !currentCard) return;
        setBusy(true);
        setNeedsTap(false);
        const picked = {
            photo: isCustom
        };
        (0, $fcQCp.default).addAction("session_recap_share_tapped", picked);
        try {
            const payload = {
                image: currentCard,
                text: $167f3d5b1a572a70$var$shareText(eligible.stats),
                fileName: fileName
            };
            const outcome = await (0, $5ZUrR.shareRecap)(payload);
            (0, $fcQCp.default).addAction("session_recap_shared", {
                ...outcome,
                ...picked
            });
            switch(outcome.status){
                case "needs_gesture":
                    // Once is a spent tap; twice is a browser that won't.
                    gestureRefusals.current += 1;
                    if (gestureRefusals.current < 2) setNeedsTap(true);
                    else setSaveInstead(true);
                    return;
                case "no_share_sheet":
                case "failed":
                    setSaveInstead(true);
                    break;
                case "shared":
                case "handed_off":
                case "cancelled":
                    break;
            }
            gestureRefusals.current = 0;
        } catch (e) {
            (0, $1lMle.default).error(`Could not share session recap: ${String(e)}`);
            setToast("Sharing didn't work. Please try again.");
        } finally{
            setBusy(false);
        }
    }, [
        eligible,
        shareReady,
        isCustom,
        currentCard,
        fileName
    ]);
    const content = (()=>{
        if (!supported || error || recap && !recap.eligible) {
            const message = !supported ? "Update the Volley app to share your sessions." : error ?? (recap && !recap.eligible && recap.reason === "not_ended" ? "This session is still going. Your recap will be here when it ends." : "This session was too short for a recap.");
            return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                spacing: 3,
                alignItems: "center",
                sx: {
                    pt: 10,
                    px: 3
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                        variant: "h5",
                        textAlign: "center",
                        children: message
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                        variant: "contained",
                        color: "secondary",
                        onClick: close,
                        children: "Done"
                    })
                ]
            });
        }
        if (!eligible) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
            sx: {
                display: "flex",
                justifyContent: "center",
                pt: 14
            },
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                color: "secondary"
            })
        });
        const previewSx = {
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
            display: "block",
            borderRadius: 3,
            boxShadow: 8,
            opacity: imageLoading ? 0.5 : 1,
            transition: "opacity 150ms"
        };
        return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
            children: [
                offerCustomPhoto && /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                    ref: photoInput,
                    type: "file",
                    accept: "image/*",
                    hidden: true,
                    "data-testid": "recap-photo-input",
                    onChange: (e)=>void onPhotoPicked(e)
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                    sx: {
                        flex: "1 1 auto",
                        minHeight: 160,
                        position: "relative",
                        containerType: "size"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                        sx: {
                            position: "absolute",
                            inset: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                                sx: {
                                    ...$167f3d5b1a572a70$var$cardFrameSx(),
                                    ...isCustom ? {} : $167f3d5b1a572a70$var$TRANSPARENT_STAGE
                                },
                                children: [
                                    isCustom ? // Drawn here, not in an <img>, so a drag can
                                    // move the photo without encoding every frame.
                                    /*#__PURE__*/ (0, $ih19M.jsx)($167f3d5b1a572a70$var$Canvas, {
                                        ref: custom.canvasRef,
                                        width: card.width,
                                        height: card.height,
                                        role: "img",
                                        "aria-label": "Your session recap card on your photo. Drag to move the photo.",
                                        ...custom.dragHandlers,
                                        onPointerDown: (e)=>{
                                            setDragHintSeen(true);
                                            custom.dragHandlers.onPointerDown(e);
                                        },
                                        sx: {
                                            ...previewSx,
                                            touchAction: "none",
                                            cursor: "grab"
                                        }
                                    }) : image && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                        component: "img",
                                        src: image.objectUrl,
                                        alt: "Your session recap card",
                                        sx: previewSx
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gILAF.default), {
                                        in: showDragHint,
                                        unmountOnExit: true,
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                            variant: "caption",
                                            sx: $167f3d5b1a572a70$var$CARD_NOTE_SX,
                                            children: "Drag to move your photo"
                                        })
                                    })
                                ]
                            }),
                            previewFailed && !previewLoading && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                                spacing: 1,
                                alignItems: "center",
                                justifyContent: "center",
                                sx: {
                                    position: "absolute",
                                    inset: 0,
                                    p: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                        variant: "body2",
                                        textAlign: "center",
                                        children: "We couldn't load your card."
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                        size: "small",
                                        variant: "outlined",
                                        color: "inherit",
                                        onClick: imageFailed ? retryImage : pickPhoto,
                                        children: imageFailed ? "Retry" : "Pick another"
                                    })
                                ]
                            }),
                            previewLoading && /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                                color: "secondary",
                                sx: {
                                    position: "absolute"
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    spacing: 1.25,
                    sx: {
                        flex: "none"
                    },
                    children: [
                        offerCustomPhoto && (isCustom ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                            direction: "row",
                            justifyContent: "center",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                    color: "inherit",
                                    startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $044c56022562315b$export$2e2bcd8739ae039), {}),
                                    disabled: busy || decodingPhoto,
                                    onClick: pickPhoto,
                                    children: "Change photo"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                    color: "inherit",
                                    startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fOOlI.default), {}),
                                    disabled: busy || decodingPhoto,
                                    onClick: removePhoto,
                                    children: "Remove photo"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "outlined",
                            color: "inherit",
                            size: "large",
                            fullWidth: true,
                            startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ec3ae2124c820e5d$export$2e2bcd8739ae039), {}),
                            loading: decodingPhoto,
                            loadingPosition: "start",
                            disabled: busy,
                            onClick: pickPhoto,
                            children: "Add a photo"
                        })),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                            variant: "contained",
                            color: "secondary",
                            size: "large",
                            fullWidth: true,
                            startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kKa2X.default), {}),
                            loading: busy,
                            loadingPosition: "start",
                            // The card on screen is what gets shared, so wait for it
                            // to match the choices.
                            disabled: !shareReady,
                            onClick: ()=>void share(),
                            children: needsTap ? "Tap to share" : "Share"
                        }),
                        saveInstead && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                            direction: "row",
                            alignItems: "center",
                            spacing: 1,
                            sx: {
                                p: 1.5,
                                borderRadius: 2,
                                bgcolor: "action.hover"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                    variant: "body2",
                                    sx: {
                                        flex: 1
                                    },
                                    children: "Save your card, then post it from your photos."
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                    variant: "contained",
                                    color: "secondary",
                                    disabled: !shareReady || !currentCard,
                                    onClick: ()=>currentCard && (0, $5ZUrR.downloadCard)(currentCard, fileName),
                                    children: "Save card"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    })();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $kE5Kn.default), {
        theme: (0, $e8yyN.darkTheme),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $4YIes.default), {}),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bmJi8.default), {
                parts: $167f3d5b1a572a70$var$TITLE
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                sx: {
                    height: "100dvh",
                    overflowY: "auto",
                    background: "linear-gradient(180deg, rgb(11, 23, 48) 0%, rgb(21, 39, 86) 100%)",
                    pt: "env(safe-area-inset-top, 0px)",
                    pb: "calc(env(safe-area-inset-bottom, 0px) + 16px)"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                    spacing: 1.5,
                    sx: {
                        height: "100%",
                        minHeight: 520,
                        maxWidth: 520,
                        mx: "auto",
                        px: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                            direction: "row",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                            sx: {
                                flex: "none",
                                pt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                                    sx: {
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                            component: "h1",
                                            variant: "h4",
                                            sx: {
                                                // As big as one line beside the close
                                                // button allows, from an SE up.
                                                fontSize: "clamp(1.375rem, 6.2vw, 1.75rem)",
                                                fontWeight: 900,
                                                lineHeight: 1.1,
                                                letterSpacing: "0.01em",
                                                textTransform: "uppercase"
                                            },
                                            children: "Share your session"
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cbFbS.default), {
                                            variant: "body2",
                                            color: "text.secondary",
                                            sx: {
                                                mt: 0.5
                                            },
                                            children: [
                                                "Tag ",
                                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                                    component: "span",
                                                    sx: {
                                                        color: "secondary.main",
                                                        fontWeight: 700
                                                    },
                                                    children: $167f3d5b1a572a70$var$VOLLEY_HANDLE
                                                }),
                                                " when you post"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                                    "aria-label": "Close",
                                    onClick: close,
                                    sx: {
                                        mt: -0.5,
                                        mr: -1
                                    },
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3Xpkr.default), {})
                                })
                            ]
                        }),
                        content
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $euyyI.default), {
                open: toast !== null,
                autoHideDuration: 4000,
                onClose: ()=>setToast(null),
                message: toast
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");
function $be79e6112f4a26ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $as544.Routes), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                path: "",
                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Navigate), {
                    replace: true,
                    to: "/"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                path: "select",
                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Navigate), {
                    replace: true,
                    to: "/"
                })
            })
        ]
    });
}


function $251a9bb50607619b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $as544.Routes), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                path: "pair/*",
                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $be79e6112f4a26ea$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                path: ":id/recap",
                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $167f3d5b1a572a70$export$2e2bcd8739ae039), {})
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $3Xpkr = parcelRequire("3Xpkr");

var $9SkSI = parcelRequire("9SkSI");

var $dUgAK = parcelRequire("dUgAK");

var $4rInl = parcelRequire("4rInl");

var $2J49z = parcelRequire("2J49z");

var $cbFbS = parcelRequire("cbFbS");

var $4xl3n = parcelRequire("4xl3n");

var $lNpFn = parcelRequire("lNpFn");
function $b0386f0fa123eb6d$export$2e2bcd8739ae039() {
    const { status: status, pairingCancelled: pairingCancelled } = (0, $4xl3n.usePairingContext)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dUgAK.default), {
        fullScreen: true,
        open: status === "requested",
        PaperProps: {
            sx: {
                background: "#fff"
            }
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $9SkSI.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $2J49z.default), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                            variant: "h3",
                            component: "h1",
                            color: "inherit",
                            sx: {
                                flex: 1
                            },
                            children: "Connect to the Trainer"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                            edge: "end",
                            color: "inherit",
                            onClick: ()=>pairingCancelled(),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3Xpkr.default), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2J49z.default), {}),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lNpFn.default), {})
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");

var $aOb5j = parcelRequire("aOb5j");
function $9d51477499000f4c$var$getStackColor(theme) {
    const { hostname: hostname } = window.location;
    if (hostname.includes("staging") || hostname.includes("ngrok")) return theme.palette.error.main;
    if (hostname.includes("localhost")) return theme.palette.warning.main;
    return null;
}
function $9d51477499000f4c$export$2e2bcd8739ae039() {
    const theme = (0, $aOb5j.default)();
    const background = $9d51477499000f4c$var$getStackColor(theme);
    if (!background) return null;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
        component: "div",
        sx: {
            position: "absolute",
            zIndex: theme.zIndex.modal + 1,
            top: 0,
            height: 5,
            width: "100%",
            background: background,
            opacity: "0.3"
        }
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $1d1FK = parcelRequire("1d1FK");

var $hL9jN = parcelRequire("hL9jN");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $b7oAt = parcelRequire("b7oAt");

var $9GahD = parcelRequire("9GahD");


var $9rvkQ = parcelRequire("9rvkQ");

var $fQfP9 = parcelRequire("fQfP9");

var $3OBHq = parcelRequire("3OBHq");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $a8d50a943a29fc3c$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
}), 'Home');



var $jcydt = parcelRequire("jcydt");

var $9SkSI = parcelRequire("9SkSI");

var $j7UqF = parcelRequire("j7UqF");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $5CVHy = parcelRequire("5CVHy");

var $4rInl = parcelRequire("4rInl");

var $2J49z = parcelRequire("2J49z");

var $lADbI = parcelRequire("lADbI");

var $aOb5j = parcelRequire("aOb5j");

var $cI8xM = parcelRequire("cI8xM");

var $1lMle = parcelRequire("1lMle");

var $cK0UE = parcelRequire("cK0UE");

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $bZrpr = parcelRequire("bZrpr");

var $4rInl = parcelRequire("4rInl");

var $lADbI = parcelRequire("lADbI");

var $2VZfN = parcelRequire("2VZfN");

var $76QOg = parcelRequire("76QOg");

/**
 * The persistent way in.
 *
 * Ask Volley answers support questions, which makes "wherever you are, ask"
 * the behaviour to have. It lives in the top bar beside the support-chat
 * button rather than as a floating corner button: the corner is where every
 * full-width call to action ends and where the workout play bar is fixed, so
 * a button there either covered the former or was covered by the latter.
 */ function $a1c80595c82a1b9d$var$Launcher({ size: size }) {
    const navigate = (0, $as544.useNavigate)();
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lADbI.default), {
        title: "Ask Volley",
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
            "aria-label": "Ask Volley",
            color: "inherit",
            size: size,
            onClick: ()=>navigate((0, $a80a94320a991500$export$f0ab39a679c40ec8)),
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bZrpr.default), {})
        })
    });
}
function $a1c80595c82a1b9d$export$2e2bcd8739ae039({ size: size }) {
    const { selected: sport } = (0, $76QOg.useSelectedSport)();
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $2VZfN.default), {
        flag: "ASK_VOLLEY_HOME_PROMPT",
        source: "user_feature",
        enabled: /*#__PURE__*/ (0, $ih19M.jsx)($a1c80595c82a1b9d$var$Launcher, {
            size: size
        }),
        default: null,
        additionalCondition: ()=>(0, $a80a94320a991500$export$7efb6b5d91849ee1).has(sport)
    });
}



var $62tuQ = parcelRequire("62tuQ");

var $gCqvy = parcelRequire("gCqvy");

var $4xl3n = parcelRequire("4xl3n");

var $ezs3H = parcelRequire("ezs3H");

var $bDIpx = parcelRequire("bDIpx");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $e25cf56cd3a1e9c6$export$2e2bcd8739ae039 = (0, $fWXJ7.default)([
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M17 11c.34 0 .67.04 1 .09V6.27L10.5 3 3 6.27v4.91c0 4.54 3.2 8.79 7.5 9.82.55-.13 1.08-.32 1.6-.55-.69-.98-1.1-2.17-1.1-3.45 0-3.31 2.69-6 6-6"
    }, "0"),
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M17 13c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 1.38c.62 0 1.12.51 1.12 1.12s-.51 1.12-1.12 1.12-1.12-.51-1.12-1.12.5-1.12 1.12-1.12m0 5.37c-.93 0-1.74-.46-2.24-1.17.05-.72 1.51-1.08 2.24-1.08s2.19.36 2.24 1.08c-.5.71-1.31 1.17-2.24 1.17"
    }, "1")
], 'AdminPanelSettings');



var $8QeQV = parcelRequire("8QeQV");

var $iJ6Ak = parcelRequire("iJ6Ak");

var $3Xpkr = parcelRequire("3Xpkr");

var $fQfP9 = parcelRequire("fQfP9");

var $3OBHq = parcelRequire("3OBHq");

var $kSc4Q = parcelRequire("kSc4Q");

var $3x9x0 = parcelRequire("3x9x0");

var $84QRb = parcelRequire("84QRb");

var $3vS3m = parcelRequire("3vS3m");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $47623ba30b70bce3$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M2 17h20v2H2zm1.15-4.05L4 11.47l.85 1.48 1.3-.75-.85-1.48H7v-1.5H5.3l.85-1.47L4.85 7 4 8.47 3.15 7l-1.3.75.85 1.47H1v1.5h1.7l-.85 1.48zm6.7-.75 1.3.75.85-1.48.85 1.48 1.3-.75-.85-1.48H15v-1.5h-1.7l.85-1.47-1.3-.75L12 8.47 11.15 7l-1.3.75.85 1.47H9v1.5h1.7zM23 9.22h-1.7l.85-1.47-1.3-.75L20 8.47 19.15 7l-1.3.75.85 1.47H17v1.5h1.7l-.85 1.48 1.3.75.85-1.48.85 1.48 1.3-.75-.85-1.48H23z"
}), 'Password');



var $6ag42 = parcelRequire("6ag42");

var $hE2xX = parcelRequire("hE2xX");

var $lqNsp = parcelRequire("lqNsp");

var $jIOsh = parcelRequire("jIOsh");

var $ltl7W = parcelRequire("ltl7W");

var $1NU2k = parcelRequire("1NU2k");

var $j5ldk = parcelRequire("j5ldk");

var $gIiKg = parcelRequire("gIiKg");

var $4rInl = parcelRequire("4rInl");

var $iZWBy = parcelRequire("iZWBy");

var $l82lx = parcelRequire("l82lx");

var $dHxgH = parcelRequire("dHxgH");

var $gfi3N = parcelRequire("gfi3N");

var $2J49z = parcelRequire("2J49z");

var $aOb5j = parcelRequire("aOb5j");

var $cI8xM = parcelRequire("cI8xM");

var $jdCKi = parcelRequire("jdCKi");

var $cK0UE = parcelRequire("cK0UE");
parcelRequire("a8DUk");
var $kkvif = parcelRequire("kkvif");

var $b2ct8 = parcelRequire("b2ct8");

var $htLA2 = parcelRequire("htLA2");

var $W4f7l = parcelRequire("W4f7l");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $fWXJ7 = parcelRequire("fWXJ7");

var $ih19M = parcelRequire("ih19M");
"use client";
var $6f5f68cc0e4f416a$export$2e2bcd8739ae039 = (0, $fWXJ7.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2m0 13H4v-2h16zm0-5H4V4h16z"
}), 'CardMembership');



var $506bB = parcelRequire("506bB");

var $5CVHy = parcelRequire("5CVHy");

var $l82lx = parcelRequire("l82lx");

var $dHxgH = parcelRequire("dHxgH");

var $gfi3N = parcelRequire("gfi3N");
parcelRequire("eyjy7");
var $fgDKG = parcelRequire("fgDKG");

var $5rkdj = parcelRequire("5rkdj");

var $cK0UE = parcelRequire("cK0UE");

var $loAb5 = parcelRequire("loAb5");
function $33a0af0479cc0905$export$2e2bcd8739ae039({ url: url, onClose: onClose }) {
    const [busy, setBusy] = $bh6RR.useState(false);
    const [error, setError] = $bh6RR.useState(null);
    const request = $bh6RR.useRef(null);
    const active = $bh6RR.useRef(false);
    $bh6RR.useEffect(()=>{
        active.current = true;
        return ()=>{
            active.current = false;
            request.current?.abort();
        };
    }, []);
    const openClub = async ()=>{
        // This is deliberately click-only; rendering or opening the menu mints nothing.
        if (request.current) return;
        const user = (0, $fgDKG.p)().currentUser;
        if (!user) {
            setError("Please sign in to Volley before opening your membership.");
            return;
        }
        const controller = new AbortController();
        const timeout = window.setTimeout(()=>controller.abort(), 10000);
        request.current = controller;
        setBusy(true);
        setError(null);
        try {
            const result = await (0, $cK0UE.default)("/api/users/token", "GET", undefined, {
                signal: controller.signal,
                cache: "no-store"
            });
            if (!active.current || controller.signal.aborted) return;
            if ((0, $fgDKG.p)().currentUser !== user) {
                setError("Your sign-in changed. Please try again.");
                return;
            }
            if (typeof result.token !== "string" || !result.token.trim()) throw new Error("Missing handoff token");
            const destination = new URL(url);
            destination.searchParams.set("token", result.token);
            (0, $5rkdj.addWebbySession)(destination);
            (0, $loAb5.navigateTo)(destination.href);
            onClose();
        } catch  {
            if (active.current) setError("Unable to open Volley membership. Please try again.");
        } finally{
            window.clearTimeout(timeout);
            request.current = null;
            if (active.current) setBusy(false);
        }
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
                disabled: busy,
                onClick: (event)=>{
                    // Keep the temporary drawer open while requesting, including errors.
                    event.stopPropagation();
                    openClub();
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                        children: busy ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                            size: 24,
                            sx: {
                                color: "white"
                            }
                        }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $6f5f68cc0e4f416a$export$2e2bcd8739ae039), {
                            sx: {
                                color: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                        primary: busy ? "Opening Volley membership\u2026" : "Volley membership",
                        sx: {
                            color: "white"
                        }
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $ih19M.jsx)((0, $506bB.default), {
                severity: "error",
                children: error
            })
        ]
    });
}



var $76QOg = parcelRequire("76QOg");
const $e263e025c499448c$var$DISPLAY_CLUB_SUMMARY_CACHE_KEY = "volley.displayClubSummary";
function $e263e025c499448c$var$UserMenuItems({ closeMenu: closeMenu }) {
    const { isAdmin: isAdmin, isAssessmentTester: isAssessmentTester, features: features } = (0, $W4f7l.useCurrentUser)();
    const location = (0, $as544.useLocation)();
    const navigate = (0, $as544.useNavigate)();
    const { selected: selected, friendlyName: friendlyName, available: available, updateSelected: updateSelected } = (0, $76QOg.useSelectedSport)();
    const [open, setOpen] = $bh6RR.useState(false);
    const [displayClubSummary, setDisplayClubSummary] = $bh6RR.useState(false);
    $bh6RR.useEffect(()=>{
        if (isAdmin()) setDisplayClubSummary(true);
        else {
            const cachedDisplayClubSummary = window.sessionStorage.getItem($e263e025c499448c$var$DISPLAY_CLUB_SUMMARY_CACHE_KEY);
            if (cachedDisplayClubSummary === null) (0, $cK0UE.default)("/api/partner-locations").then((assignedLocations)=>{
                const hasAssignedLocations = assignedLocations.length > 0;
                setDisplayClubSummary(hasAssignedLocations);
                window.sessionStorage.setItem($e263e025c499448c$var$DISPLAY_CLUB_SUMMARY_CACHE_KEY, String(hasAssignedLocations));
            }).catch((error)=>(0, $cK0UE.logFetchError)(error, "GET /api/partner-locations failed in UserHamburgerMenu component"));
            else if (cachedDisplayClubSummary === "true") setDisplayClubSummary(true);
        }
    }, [
        isAdmin
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
                onClick: (e)=>{
                    e.stopPropagation();
                    setOpen(!open);
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ltl7W.default), {
                            sx: {
                                color: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                        primary: friendlyName,
                        sx: {
                            color: "white"
                        }
                    }),
                    open ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $fQfP9.default), {
                        sx: {
                            color: "white"
                        }
                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $3OBHq.default), {
                        sx: {
                            color: "white"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1NU2k.default), {
                in: open,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $iZWBy.default), {
                    component: "div",
                    disablePadding: true,
                    children: Object.keys(available).map((sport)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $l82lx.default), {
                            sx: {
                                pl: 4
                            },
                            onClick: ()=>{
                                if (sport === selected) {
                                    setOpen(false);
                                    closeMenu();
                                } else {
                                    updateSelected(sport);
                                    setOpen(false);
                                    closeMenu();
                                    if (location.pathname !== "/") navigate("/");
                                }
                            },
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                                primary: available[sport],
                                sx: {
                                    color: sport === selected ? "secondary.main" : "white"
                                }
                            })
                        }, sport))
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
                component: (0, $as544.Link),
                to: "/tutorials",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3x9x0.default), {
                            sx: {
                                color: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                        primary: "Tutorial",
                        sx: {
                            color: "white"
                        }
                    })
                ]
            }),
            (0, $jdCKi.default).clubInClubUrl && features.includes((0, $kkvif.CLUB_IN_CLUB_FEATURE)) && /*#__PURE__*/ (0, $ih19M.jsx)((0, $33a0af0479cc0905$export$2e2bcd8739ae039), {
                url: (0, $jdCKi.default).clubInClubUrl,
                onClose: closeMenu
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
                component: (0, $as544.Link),
                to: "/content/history/mine",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $84QRb.default), {
                            sx: {
                                color: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                        primary: "Sharing & History",
                        sx: {
                            color: "white"
                        }
                    })
                ]
            }),
            features.includes("POINT_CLICK_AI") && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
                component: (0, $as544.Link),
                to: "/content/apps/workouts/experimental/point-click?mode=ai",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $iJ6Ak.default), {
                            sx: {
                                color: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                        primary: "Racquet AI",
                        sx: {
                            color: "white"
                        }
                    })
                ]
            }),
            features.includes("JOURNEY_INSTANCES_AT_A_GLANCE") && !features.includes("ASSESSMENT_DASHBOARD_V2") && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
                component: (0, $as544.Link),
                to: "/journeys/assessments",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kSc4Q.default), {
                            sx: {
                                color: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                        primary: "My Assessments",
                        sx: {
                            color: "white"
                        }
                    })
                ]
            }),
            features.includes("JOURNEY_CLASSES") && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
                component: (0, $as544.Link),
                to: "/journeys/classes",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lqNsp.default), {
                            sx: {
                                color: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                        primary: "Classes",
                        sx: {
                            color: "white"
                        }
                    })
                ]
            }),
            (features.includes("PRO_GRADING") || features.includes("CONTACT_ANNOTATION")) && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
                component: (0, $as544.Link),
                to: "/pro-grading",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hE2xX.default), {
                            sx: {
                                color: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                        primary: "Pro Grading",
                        sx: {
                            color: "white"
                        }
                    })
                ]
            }),
            displayClubSummary && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
                component: (0, $as544.Link),
                to: "/content/club-summary",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3vS3m.default), {
                            sx: {
                                color: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                        primary: "Club Summary",
                        sx: {
                            color: "white"
                        }
                    })
                ]
            }),
            (isAdmin() || isAssessmentTester()) && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
                component: (0, $as544.Link),
                to: "/journeys/assessments",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kSc4Q.default), {
                            sx: {
                                color: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                        primary: "Administer Assessment",
                        sx: {
                            color: "white"
                        }
                    })
                ]
            }),
            features.includes((0, $b2ct8.DUPR_APP_ASSESSOR_FEATURE)) && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
                component: (0, $as544.Link),
                to: "/journeys/long-form?administer=1",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8QeQV.default), {
                            sx: {
                                color: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                        primary: "DUPR Assessment",
                        sx: {
                            color: "white"
                        }
                    })
                ]
            }),
            features.includes((0, $b2ct8.WPR_APP_ASSESSOR_FEATURE)) && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
                component: (0, $as544.Link),
                to: `${(0, $htLA2.PADEL_ASSESSMENT_START_URL)}?administer=1`,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8QeQV.default), {
                            sx: {
                                color: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                        primary: "WPR Assessment",
                        sx: {
                            color: "white"
                        }
                    })
                ]
            }),
            (0, $b2ct8.isAssessmentAssessor)(isAdmin(), features) && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
                component: (0, $as544.Link),
                to: "/journeys/assessments/unclaimed",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6ag42.default), {
                            sx: {
                                color: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                        primary: "Unclaimed Assessments",
                        sx: {
                            color: "white"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
                component: (0, $as544.Link),
                to: "/ball-cabinet-unlock",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $47623ba30b70bce3$export$2e2bcd8739ae039), {
                            sx: {
                                color: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                        primary: "Ball Cabinet Unlock",
                        sx: {
                            color: "white"
                        }
                    })
                ]
            }),
            isAdmin() && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ldk.default), {
                        sx: {
                            borderColor: "white",
                            width: "80%",
                            margin: "auto"
                        }
                    }),
                    features.includes("CONTENT_SEARCH") && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
                        component: (0, $as544.Link),
                        to: "/content/search",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $jIOsh.default), {
                                    sx: {
                                        color: "white"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                                primary: "Content Search",
                                sx: {
                                    color: "white"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $l82lx.default), {
                        component: (0, $as544.Link),
                        to: "/admin",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dHxgH.default), {
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e25cf56cd3a1e9c6$export$2e2bcd8739ae039), {
                                    sx: {
                                        color: "white"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                                primary: "Admin Panel",
                                sx: {
                                    color: "white"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $l82lx.default), {
                        component: (0, $as544.Link),
                        to: "/exp",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                            inset: true,
                            primary: "Experiences",
                            sx: {
                                color: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $l82lx.default), {
                        component: (0, $as544.Link),
                        to: "/content/apps/workouts/experimental/point-click",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                            inset: true,
                            primary: "Tap & Throw",
                            sx: {
                                color: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $l82lx.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gfi3N.default), {
                            inset: true,
                            primary: "Software Build:",
                            secondary: (0, $jdCKi.default).version,
                            sx: {
                                color: "white",
                                "& .MuiListItemText-secondary": {
                                    color: "white"
                                }
                            }
                        })
                    })
                ]
            })
        ]
    });
}
const $e263e025c499448c$var$DRAWER_WIDTH = 240;
function $e263e025c499448c$export$2e2bcd8739ae039({ open: open, onClose: onClose }) {
    const theme = (0, $aOb5j.default)();
    const isSmUp = (0, $cI8xM.default)(theme.breakpoints.up("sm"));
    if (isSmUp) return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $gIiKg.default), {
        variant: "permanent",
        open: open,
        onClose: onClose,
        slotProps: {
            paper: {
                sx: {
                    backgroundColor: "primary.dark",
                    borderBottomRightRadius: 24,
                    borderTopRightRadius: 24,
                    width: $e263e025c499448c$var$DRAWER_WIDTH
                }
            }
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2J49z.default), {}),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $iZWBy.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)($e263e025c499448c$var$UserMenuItems, {
                    closeMenu: onClose
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $gIiKg.default), {
        variant: "temporary",
        open: open,
        onClose: onClose,
        slotProps: {
            paper: {
                sx: {
                    backgroundColor: "primary.dark",
                    borderBottomRightRadius: 24,
                    borderTopRightRadius: 24,
                    width: $e263e025c499448c$var$DRAWER_WIDTH,
                    borderRight: "2px solid",
                    borderRightColor: "primary.main"
                }
            }
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2J49z.default), {
                sx: {
                    justifyContent: "flex-end"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                    onClick: onClose,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3Xpkr.default), {
                        sx: {
                            color: "white"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $iZWBy.default), {
                onClick: onClose,
                children: /*#__PURE__*/ (0, $ih19M.jsx)($e263e025c499448c$var$UserMenuItems, {
                    closeMenu: onClose
                })
            })
        ]
    });
}



var $kRyrt = parcelRequire("kRyrt");

var $cC4Zp = parcelRequire("cC4Zp");
function $b59ffe53f395f581$export$2e2bcd8739ae039({ optionalText: optionalText = "" }) {
    const intercom = (0, $bDIpx.default)();
    const { status: pairingStatus, promptToPair: promptToPair, pairingCancelled: pairingCancelled } = (0, $4xl3n.usePairingContext)();
    const { dialogType: dialogType, setDialogType: setDialogType, forceDeviceDialog: forceDeviceDialog } = (0, $62tuQ.default)();
    const { status: status } = (0, $ezs3H.useStatus)();
    const headerText = optionalText || `Trainer ${status?.clientId ?? "?"}`;
    const navigate = (0, $as544.useNavigate)();
    const location = (0, $as544.useLocation)();
    const backNav = (0, $kRyrt.useBackNav)();
    const [menuOpen, setMenuOpen] = $bh6RR.useState(false);
    const [backReadyState, setBackReadyState] = $bh6RR.useState("ready");
    const [navigateTarget, setNavigateTarget] = $bh6RR.useState(-1);
    const [navigateState, setNavigateState] = $bh6RR.useState();
    const theme = (0, $aOb5j.default)();
    // Narrow bars: the right slot holds up to three icon buttons beside the
    // trainer button, and at 40px each they do not fit next to it. "Narrow"
    // is below `md`, not `sm`, because from `sm` the bar gives up 240px to
    // the drawer and is at its tightest just past that breakpoint.
    const compact = (0, $cI8xM.default)(theme.breakpoints.down("md"));
    const iconSize = compact ? "small" : "medium";
    const showNavigation = $bh6RR.useMemo(()=>{
        if (location.pathname === "/") return false;
        if (dialogType === "Device") return false;
        return true;
    }, [
        location,
        dialogType
    ]);
    const onHeaderClick = $bh6RR.useCallback(()=>{
        if (dialogType === "Device") setDialogType(null);
        else setDialogType("Device");
    }, [
        dialogType,
        setDialogType
    ]);
    const showConnectButton = pairingStatus === "unpaired";
    const doNavigate = $bh6RR.useCallback((target, state)=>{
        navigate(target, state ? {
            state: state
        } : undefined);
    }, [
        navigate
    ]);
    const handleNav = $bh6RR.useCallback((target, state)=>{
        setNavigateTarget(target);
        setNavigateState(state);
        if (status?.workouts.playState === "playing" || status?.workouts.playState === "paused") {
            (0, $1lMle.default).info(`[Top Nav Bar] - Workout ${status?.workouts.playState}, stopping workout before navigating.`);
            (0, $cK0UE.pairedFetchApi)(status?.clientId, "/api/apps/workouts/stop", "POST").then(()=>setBackReadyState("waiting"));
        } else if (backReadyState === "ready" && location.pathname.startsWith("/exp/") && status?.clientId !== undefined) {
            // Leaving an experience ends its run, the way leaving a
            // workout stops it. "Nothing running" is a fine answer too.
            (0, $1lMle.default).info("[Top Nav Bar] - Leaving an experience, stopping its run before navigating.");
            setBackReadyState("stopping");
            (0, $gCqvy.stopRun)(status.clientId).catch((error)=>(0, $1lMle.default).warn(`[Top Nav Bar] - Stopping the experience run failed: ${String(error)}`)).finally(()=>{
                setBackReadyState("ready");
                doNavigate(target, state);
            });
        } else if (backReadyState === "ready") {
            (0, $1lMle.default).info(`[Top Nav Bar] - Navigating ${target} from handleNav.`);
            doNavigate(target, state);
        } else (0, $1lMle.default).info("[Top Nav Bar] - handleNav called while not in 'ready' state.");
    }, [
        status,
        backReadyState,
        doNavigate,
        location.pathname
    ]);
    $bh6RR.useEffect(()=>{
        if (backReadyState === "waiting") {
            (0, $1lMle.default).info("[Top Nav Bar] - Checking play state.");
            const playState = status?.workouts.playState;
            if (playState === "paused" || playState === "stopped") {
                (0, $1lMle.default).info("[Top Nav Bar] - Play state is no longer playing, navigating back.");
                setBackReadyState("ready");
                doNavigate(navigateTarget, navigateState);
            }
        }
    }, [
        backReadyState,
        status,
        doNavigate,
        navigateTarget,
        navigateState
    ]);
    const statusIcon = $bh6RR.useMemo(()=>{
        if (status && status.fault) {
            if (status.fault.failures.every((f)=>f.source === "vision")) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $9GahD.default), {
                color: "success"
            });
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $9rvkQ.default), {
                color: "error"
            });
        }
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $9GahD.default), {
            color: "success"
        });
    }, [
        status
    ]);
    const onConnectClick = $bh6RR.useCallback(()=>{
        (0, $1lMle.default).info(`Connect Clicked from ${location.pathname}`);
        promptToPair();
    }, [
        promptToPair,
        location.pathname
    ]);
    const onClose = $bh6RR.useCallback(()=>{
        setMenuOpen(false);
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9SkSI.default), {
        id: "volley-app-bar",
        position: "sticky",
        sx: {
            width: {
                sm: "calc(100% - 240px)"
            },
            ml: {
                sm: "240px"
            },
            backgroundColor: (t)=>dialogType === "Device" ? t.palette.grey[200] : t.palette.primary.dark,
            zIndex: (t)=>t.zIndex.drawer + 1
        },
        elevation: 0,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2J49z.default), {
                sx: {
                    px: 0
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                    component: "div",
                    sx: {
                        flex: 1,
                        display: "grid",
                        gridTemplateColumns: "minmax(max-content, 1fr) minmax(0, max-content) minmax(max-content, 1fr)",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                            component: "div",
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start"
                            },
                            children: [
                                showNavigation && backReadyState === "ready" && /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                                    onClick: ()=>handleNav(backNav.target, backNav.state),
                                    color: "inherit",
                                    "aria-label": "back",
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b7oAt.default), {})
                                }),
                                showNavigation && backReadyState !== "ready" && navigateTarget === -1 && /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                                    size: 24,
                                    color: "secondary",
                                    "aria-busy": "true",
                                    role: "alert"
                                }),
                                !showNavigation && dialogType !== "Device" && /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                                    onClick: ()=>setMenuOpen(!menuOpen),
                                    color: "inherit",
                                    "aria-label": "menu",
                                    sx: {
                                        display: {
                                            sm: "none"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $jcydt.default), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                            component: "div",
                            sx: {
                                minWidth: 0,
                                px: 1
                            },
                            children: [
                                showConnectButton && /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                    variant: "contained",
                                    color: "secondary",
                                    onClick: onConnectClick,
                                    startIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cC4Zp.default), {}),
                                    fullWidth: true,
                                    sx: {
                                        color: (t)=>t.palette.primary.dark
                                    },
                                    children: "Connect"
                                }),
                                [
                                    "requested",
                                    "validating"
                                ].includes(pairingStatus) && /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                    color: "warning",
                                    onClick: ()=>pairingCancelled(),
                                    fullWidth: true,
                                    children: "Cancel"
                                }),
                                pairingStatus === "paired" && dialogType === null && /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                    onClick: onHeaderClick,
                                    sx: {
                                        display: "inline-flex",
                                        color: "inherit",
                                        // Smaller on a compact bar so the id
                                        // stays whole beside three icons.
                                        fontSize: compact ? "1rem" : "1.2rem",
                                        minWidth: 0,
                                        maxWidth: "100%"
                                    },
                                    startIcon: statusIcon,
                                    endIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3OBHq.default), {
                                        sx: {
                                            color: "common.white"
                                        }
                                    }),
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                                        component: "span",
                                        sx: {
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap"
                                        },
                                        children: headerText
                                    })
                                }),
                                pairingStatus === "paired" && dialogType === "Device" && /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                    onClick: ()=>setDialogType(null),
                                    fullWidth: true,
                                    disabled: forceDeviceDialog,
                                    sx: {
                                        color: "primary",
                                        "&.Mui-disabled": {
                                            color: theme.palette.grey[500]
                                        }
                                    },
                                    endIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fQfP9.default), {}),
                                    children: "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                            component: "div",
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $a1c80595c82a1b9d$export$2e2bcd8739ae039), {
                                    size: iconSize
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $lADbI.default), {
                                    title: "Support chat",
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $j7UqF.default), {
                                        badgeContent: intercom.unreadCount,
                                        color: "error",
                                        overlap: "circular",
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "left"
                                        },
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                                            onClick: ()=>intercom.show(),
                                            disabled: !intercom.ready,
                                            size: iconSize,
                                            color: dialogType === "Device" ? "primary" : "inherit",
                                            "aria-label": "help",
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $f052a48fd4d80af9$export$2e2bcd8739ae039), {})
                                        })
                                    })
                                }),
                                showNavigation && backReadyState === "ready" && /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                                    onClick: ()=>handleNav("/"),
                                    color: "inherit",
                                    size: iconSize,
                                    "aria-label": "home",
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $a8d50a943a29fc3c$export$2e2bcd8739ae039), {})
                                }),
                                showNavigation && backReadyState !== "ready" && navigateTarget === "/" && /*#__PURE__*/ (0, $ih19M.jsx)((0, $5CVHy.default), {
                                    size: 24,
                                    color: "secondary",
                                    "aria-busy": "true",
                                    role: "alert"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $e263e025c499448c$export$2e2bcd8739ae039), {
                open: menuOpen,
                onClose: onClose
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ltQuT = parcelRequire("ltQuT");

var $18rAL = parcelRequire("18rAL");

var $j6Qoj = parcelRequire("j6Qoj");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $96ZcP = parcelRequire("96ZcP");

var $4Athc = parcelRequire("4Athc");

var $krx4P = parcelRequire("krx4P");

var $h8IpO = parcelRequire("h8IpO");

var $l0oRz = parcelRequire("l0oRz");

var $gfPc7 = parcelRequire("gfPc7");

var $OEXBZ = parcelRequire("OEXBZ");

var $52dC4 = parcelRequire("52dC4");

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $6ad09409d8e752d2$export$af7da6d60955385e(slot) {
    return (0, $dmzXD.default)('MuiMobileStepper', slot);
}
const $6ad09409d8e752d2$var$mobileStepperClasses = (0, $fYlYP.default)('MuiMobileStepper', [
    'root',
    'positionBottom',
    'positionTop',
    'positionStatic',
    'dots',
    'dot',
    'dotActive',
    'progress'
]);
var $6ad09409d8e752d2$export$2e2bcd8739ae039 = $6ad09409d8e752d2$var$mobileStepperClasses;



var $dFvJW = parcelRequire("dFvJW");

var $ih19M = parcelRequire("ih19M");
'use client';
const $7089d35b35957c8e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, position: position } = ownerState;
    const slots = {
        root: [
            'root',
            `position${(0, $krx4P.default)(position)}`
        ],
        dots: [
            'dots'
        ],
        dot: [
            'dot'
        ],
        dotActive: [
            'dotActive'
        ],
        progress: [
            'progress'
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $6ad09409d8e752d2$export$af7da6d60955385e), classes);
};
const $7089d35b35957c8e$var$MobileStepperRoot = (0, $l0oRz.default)((0, $4Athc.default), {
    name: 'MuiMobileStepper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $krx4P.default)(ownerState.position)}`]
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: (theme.vars || theme).palette.background.default,
        padding: 8,
        variants: [
            {
                props: ({ position: position })=>position === 'top' || position === 'bottom',
                style: {
                    position: 'fixed',
                    left: 0,
                    right: 0,
                    zIndex: (theme.vars || theme).zIndex.mobileStepper
                }
            },
            {
                props: {
                    position: 'top'
                },
                style: {
                    top: 0
                }
            },
            {
                props: {
                    position: 'bottom'
                },
                style: {
                    bottom: 0
                }
            }
        ]
    })));
const $7089d35b35957c8e$var$MobileStepperDots = (0, $l0oRz.default)('div', {
    name: 'MuiMobileStepper',
    slot: 'Dots'
})({
    variants: [
        {
            props: {
                variant: 'dots'
            },
            style: {
                display: 'flex',
                flexDirection: 'row'
            }
        }
    ]
});
const $7089d35b35957c8e$var$MobileStepperDot = (0, $l0oRz.default)('div', {
    name: 'MuiMobileStepper',
    slot: 'Dot',
    shouldForwardProp: (prop)=>(0, $52dC4.default)(prop) && prop !== 'dotActive',
    overridesResolver: (props, styles)=>{
        const { dotActive: dotActive } = props;
        return [
            styles.dot,
            dotActive && styles.dotActive
        ];
    }
})((0, $gfPc7.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    variant: 'dots'
                },
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    backgroundColor: (theme.vars || theme).palette.action.disabled,
                    borderRadius: '50%',
                    width: 8,
                    height: 8,
                    margin: '0 2px'
                }
            },
            {
                props: {
                    variant: 'dots',
                    dotActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            }
        ]
    })));
const $7089d35b35957c8e$var$MobileStepperProgress = (0, $l0oRz.default)((0, $h8IpO.default), {
    name: 'MuiMobileStepper',
    slot: 'Progress'
})({
    variants: [
        {
            props: {
                variant: 'progress'
            },
            style: {
                width: '50%'
            }
        }
    ]
});
const $7089d35b35957c8e$var$MobileStepper = /*#__PURE__*/ $bh6RR.forwardRef(function MobileStepper(inProps, ref) {
    const props = (0, $OEXBZ.useDefaultProps)({
        props: inProps,
        name: 'MuiMobileStepper'
    });
    const { activeStep: activeStep = 0, backButton: backButton, className: className, LinearProgressProps: LinearProgressProps, nextButton: nextButton, position: position = 'bottom', steps: steps, variant: variant = 'dots', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        activeStep: activeStep,
        position: position,
        variant: variant
    };
    let value;
    if (variant === 'progress') {
        if (steps === 1) value = 100;
        else value = Math.ceil(activeStep / (steps - 1) * 100);
    }
    const classes = $7089d35b35957c8e$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            progress: LinearProgressProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $dFvJW.default)('root', {
        ref: ref,
        elementType: $7089d35b35957c8e$var$MobileStepperRoot,
        shouldForwardComponentProp: true,
        className: (0, $aPsoC.default)(classes.root, className),
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            square: true,
            elevation: 0
        }
    });
    const [DotsSlot, dotsSlotProps] = (0, $dFvJW.default)('dots', {
        className: classes.dots,
        elementType: $7089d35b35957c8e$var$MobileStepperDots,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [DotSlot, dotSlotProps] = (0, $dFvJW.default)('dot', {
        elementType: $7089d35b35957c8e$var$MobileStepperDot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ProgressSlot, progressSlotProps] = (0, $dFvJW.default)('progress', {
        className: classes.progress,
        elementType: $7089d35b35957c8e$var$MobileStepperProgress,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            value: value,
            variant: 'determinate'
        }
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            backButton,
            variant === 'text' && /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
                children: [
                    activeStep + 1,
                    " / ",
                    steps
                ]
            }),
            variant === 'dots' && /*#__PURE__*/ (0, $ih19M.jsx)(DotsSlot, {
                ...dotsSlotProps,
                children: [
                    ...new Array(steps)
                ].map((_, index)=>/*#__PURE__*/ (0, $ih19M.jsx)(DotSlot, {
                        ...dotSlotProps,
                        className: (0, $aPsoC.default)(classes.dot, dotSlotProps.className, index === activeStep && classes.dotActive),
                        dotActive: index === activeStep
                    }, index))
            }),
            variant === 'progress' && /*#__PURE__*/ (0, $ih19M.jsx)(ProgressSlot, {
                ...progressSlotProps
            }),
            nextButton
        ]
    });
});
var $7089d35b35957c8e$export$2e2bcd8739ae039 = $7089d35b35957c8e$var$MobileStepper;



var $8JNI1 = parcelRequire("8JNI1");

var $cbFbS = parcelRequire("cbFbS");

var $6zj3p = parcelRequire("6zj3p");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1d1FK = parcelRequire("1d1FK");
function $a1e9ad08b87759ba$export$2e2bcd8739ae039({ index: index, onChangeIndex: onChangeIndex, children: children }) {
    const containerRef = $bh6RR.useRef(null);
    const scrollTimeout = $bh6RR.useRef(undefined);
    const onScroll = $bh6RR.useCallback(({ currentTarget: currentTarget })=>{
        if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
        scrollTimeout.current = window.setTimeout(()=>{
            const pageWidth = currentTarget.scrollWidth / (currentTarget.children.length || 1);
            onChangeIndex(Math.round(currentTarget.scrollLeft / pageWidth));
        }, 100);
    }, [
        onChangeIndex
    ]);
    $bh6RR.useEffect(()=>{
        containerRef.current?.children[index]?.scrollIntoView({
            behavior: "auto"
        });
    }, [
        index
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
        component: "div",
        ref: containerRef,
        onScroll: onScroll,
        sx: {
            display: "flex",
            scrollSnapType: "x mandatory",
            overflowX: "scroll",
            scrollbarWidth: "none",
            "& > *": {
                width: "100%",
                flexShrink: 0,
                scrollSnapAlign: "center",
                scrollSnapStop: "always"
            },
            "&::-webkit-scrollbar": {
                display: "none"
            }
        },
        children: children
    });
}


const $08d95a2c1c420c0e$var$TUTORIALS_DATA = [
    {
        title: "",
        slug: "app-welcome",
        text: ""
    },
    {
        title: "Volley App Navigation",
        slug: "app-support",
        text: `To access our support, click the \u{201C}?\u{201D} button for live chat and support articles.

Volley also proactively monitors for errors, so you may see an option to chat proactively pop up during play. If you see this, it means a staff member has detected a problem with a trainer.

If your phone number is on file, Volley may text you when problems arise.`
    },
    {
        title: "Volley App Navigation",
        slug: "app-sport",
        text: `If you need to change the sport you selected after your first login, you can do that on the Play screen.

Picking the right sport is important as all the content available for selection is based on the sport choice.

Volley makes 2 trainers, a dedicated one for pickleball and a second one for all other sports.

If you need to share a workout with a student, coach, or friend, go to Sharing & History and select a recently played workout to share.

For clubs with cabinets, the cabinet has a universal password, which you can find in the play screen menu bar.`
    },
    {
        title: "Volley App Navigation",
        slug: "app-connect",
        text: `When you're ready to get started with a trainer, press Connect at the top of the screen.

When you're connected to a trainer, this button will change to the Trainer number and is how you access options such as shut down.

The first time you click connect, we'll walk you through how to get ready for your time on court.`
    },
    {
        title: "Trainer Navigation",
        slug: "trainer-batteries",
        text: `The Volley trainer can run for 3+ hours on a set of 2 batteries. Many clubs opt to buy 2 sets of batteries so there is always a backup.


If you want to check the charge level on an individual battery, click the clear/white button to the right of the bars on the battery.`
    },
    {
        title: "Trainer Navigation",
        slug: "trainer-buttons",
        text: `You'll see 4 buttons on the back of the trainer:

- Green: Turn on the trainer after inserting batteries


- Red: E-stop button. To shut down the trainer normally, use the Volley app


- Yellow: Lower the trainer head. This is often used to refill balls without needing a phone.


- Blue: Resume or repeat playing. After refilling balls, this allows you to restart without your phone.`
    },
    {
        title: "Trainer Navigation",
        slug: "trainer-buttons-green",
        text: `Green LED Light indicates machine is on and ready.

After turning on, the machine will say, \u{201C}Volley starting.\u{201D} At this point you can connect to the trainer.

If the green light never comes on, use the in-app chat to contact Volley.`
    },
    {
        title: "Trainer Navigation",
        slug: "trainer-billboard",
        text: `The billboard screen shows WiFi strength, cell strength, & battery life.

If there is a connectivity issue with the cell or WiFi, the trainer will let you know it can't connect. In these cases, use the in-app chat to contact Volley.`
    },
    {
        title: "Trainer Navigation",
        slug: "trainer-pairing-code",
        text: `Connect to the trainer using the 4-digit code on the side of the trainer.

If a trainer has issues, Volley might swap the entire unit rather than repair on-site. In these cases, the connect code might change, so make sure to check each time even if you play at the same club.`
    },
    {
        title: "Connecting to the Trainer",
        slug: "trainer-pairing-code-entry",
        text: `It's time to connect to the trainer!


After completing the tutorial, enter the 4-digit code on your trainer and press Connect to start your session. 

Make sure you pick the correct sport that you are going to play before calibrating.

During calibration, the head/arm will move as it runs a self-check for any issues.`
    },
    {
        title: "Trainer Navigation",
        slug: "trainer-loading-balls-cover",
        text: `To load balls, flip up the cover. There is a magnet in the cover that allows it to stick to the top green bar for easy loading.

After filling, pull the cover back over the bin. The trainer will indicate when it is out of balls, so there is no need to re-check the inside of the bin.`
    },
    {
        title: "Trainer Navigation",
        slug: "trainer-billboard-countdown",
        text: `The billboard's countdown timer shows you how much time until the next ball is thrown.

On the righthand side, you'll see a ball speed indicator.

For ball direction, we recommend watching the throwing head of the trainer as it will point correctly before throwing.`
    },
    {
        title: "Trainer Navigation",
        slug: "trainer-tomohopper-arms",
        text: `Most clubs opt to purchase a Volley-branded ball mower, though it is optional. If your club has one, you can assemble it in 3 quick steps:


1) Remove the pin, flip up the handle and insert the pin to lock it in place,

2) Insert the trainer arms into bottom front, paying attention to the "This side up" sticker.


The arms should easily slide into the designated slots.


3) Use the attached bungees to fasten the arms. There is a small hole in the plastic where the bungees can easily be clipped to secure the arms in place.`
    }
];
var $08d95a2c1c420c0e$export$2e2bcd8739ae039 = $08d95a2c1c420c0e$var$TUTORIALS_DATA;


function $372e971e335deb7d$export$2e2bcd8739ae039({ slugs: slugs, onDone: onDone }) {
    const [index, setIndex] = $bh6RR.useState(0);
    const [textExpanded, setTextExpanded] = $bh6RR.useState(false);
    const data = $bh6RR.useMemo(()=>slugs ? (0, $08d95a2c1c420c0e$export$2e2bcd8739ae039).filter(({ slug: pageSlug })=>slugs.includes(pageSlug)) : (0, $08d95a2c1c420c0e$export$2e2bcd8739ae039).slice(1), [
        slugs
    ]);
    const onChangeIndex = $bh6RR.useCallback((nextIndex)=>{
        setTextExpanded(false);
        setIndex(nextIndex);
    }, []);
    const isLastSlide = index === data.length - 1;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $a1e9ad08b87759ba$export$2e2bcd8739ae039), {
                index: index,
                onChangeIndex: onChangeIndex,
                children: data.map((page)=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
                        component: "div",
                        display: "flex",
                        justifyContent: "center",
                        position: "relative",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                src: (0, $6zj3p.default)(`tutorials/${page.slug}.jpg`),
                                alt: page.slug,
                                style: {
                                    aspectRatio: "9 / 16",
                                    maxHeight: "80vh",
                                    minHeight: "80vh"
                                },
                                loading: "lazy"
                            }),
                            page.title && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8JNI1.default), {
                                sx: {
                                    px: 1,
                                    position: "absolute",
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    overflow: "hidden",
                                    whiteSpace: "pre-wrap",
                                    maxHeight: "3rem",
                                    background: "rgba(0, 0, 0, 0.6)",
                                    color: "#fff",
                                    transition: "max-height 0.3s ease-in-out",
                                    ...textExpanded ? {
                                        maxHeight: "100%",
                                        background: "rgba(0, 0, 0, 0.9)"
                                    } : undefined
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                        variant: "h5",
                                        component: "h1",
                                        sx: {
                                            pb: 0,
                                            pt: 1
                                        },
                                        children: page.title
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $cbFbS.default), {
                                        variant: "body2",
                                        sx: {
                                            whiteSpace: "pre-wrap",
                                            cursor: "pointer",
                                            ...!textExpanded ? {
                                                pr: 5.5,
                                                maxHeight: "1.5rem",
                                                overflow: "hidden",
                                                "&::after": {
                                                    content: '"\u2026(more)"',
                                                    position: "absolute",
                                                    bottom: 2,
                                                    right: 0,
                                                    pr: 1
                                                }
                                            } : {
                                                p: 1
                                            }
                                        },
                                        onClick: ()=>setTextExpanded(!textExpanded),
                                        children: `${page.text}${!textExpanded ? "\u2026(more)" : ""}`
                                    })
                                ]
                            })
                        ]
                    }, page.slug))
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7089d35b35957c8e$export$2e2bcd8739ae039), {
                variant: data.length <= 10 ? "dots" : "text",
                position: "static",
                steps: data.length,
                activeStep: index,
                backButton: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $eedE5.default), {
                    size: "small",
                    disabled: index === 0,
                    onClick: ()=>setIndex(index - 1),
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $18rAL.default), {}),
                        "Back"
                    ]
                }),
                nextButton: isLastSlide ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $eedE5.default), {
                    size: "small",
                    variant: "contained",
                    color: "secondary",
                    onClick: onDone,
                    children: [
                        "Done",
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ltQuT.default), {})
                    ]
                }) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $eedE5.default), {
                    size: "small",
                    onClick: ()=>setIndex(index + 1),
                    children: [
                        "Next",
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $j6Qoj.default), {})
                    ]
                }),
                sx: {
                    my: 2,
                    background: "transparent"
                }
            })
        ]
    });
}


function $11e408542ea04bce$export$2e2bcd8739ae039() {
    const navigate = (0, $as544.useNavigate)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        component: "div",
        sx: {
            backgroundColor: "white",
            minHeight: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $b59ffe53f395f581$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                component: "main",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hL9jN.default), {
                    maxWidth: "xs",
                    sx: {
                        px: 0
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $372e971e335deb7d$export$2e2bcd8739ae039), {
                        onDone: ()=>navigate("/")
                    })
                })
            })
        ]
    });
}



var $kMz87 = parcelRequire("kMz87");

var $3WN4W = parcelRequire("3WN4W");

var $8eLYQ = parcelRequire("8eLYQ");

var $dnGn2 = parcelRequire("dnGn2");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $as544 = parcelRequire("as544");

var $3Xpkr = parcelRequire("3Xpkr");

var $506bB = parcelRequire("506bB");

var $1d1FK = parcelRequire("1d1FK");

var $eedE5 = parcelRequire("eedE5");

var $4rInl = parcelRequire("4rInl");

var $euyyI = parcelRequire("euyyI");

var $1lMle = parcelRequire("1lMle");

var $cK0UE = parcelRequire("cK0UE");

var $62tuQ = parcelRequire("62tuQ");

var $W4f7l = parcelRequire("W4f7l");

var $4xl3n = parcelRequire("4xl3n");

var $ezs3H = parcelRequire("ezs3H");


var $76QOg = parcelRequire("76QOg");
const $6aff9162b6471e41$var$FIRST_SESSION_TOAST_KEY = "volley.hasSeenFirstSessionToast";
function $6aff9162b6471e41$export$2e2bcd8739ae039({ children: children }) {
    const location = (0, $as544.useLocation)();
    const navigate = (0, $as544.useNavigate)();
    const { status: status } = (0, $ezs3H.useStatus)();
    const { dialogType: dialogType, setDialogType: setDialogType, batteryWarningDismissed: batteryWarningDismissed } = (0, $62tuQ.default)();
    const { status: pairingStatus } = (0, $4xl3n.usePairingContext)();
    const { selected: selectedSport, hasSelected: hasSelected, resolvingSelection: resolvingSelection } = (0, $76QOg.useSelectedSport)();
    const { authState: authState } = (0, $W4f7l.useCurrentUser)();
    const [firstSessionToastOpen, setFirstSessionToastOpen] = $bh6RR.useState(false);
    $bh6RR.useEffect(()=>{
        if (pairingStatus === "paired" && (dialogType === "Device" || dialogType === null)) {
            if (!(0, $76QOg.trainerCompatibleWithSport)(selectedSport, status)) setDialogType("InvalidSportSelection");
        }
    }, [
        pairingStatus,
        status,
        selectedSport,
        dialogType,
        setDialogType
    ]);
    $bh6RR.useEffect(()=>{
        if (status?.trainer.battery.level && status?.ready !== "INIT" && status?.trainer.battery.level <= 30 && dialogType !== "NoConfirmReplaceBatteries" && !batteryWarningDismissed) setDialogType("LowBatteryWarning");
    }, [
        status,
        batteryWarningDismissed,
        dialogType,
        setDialogType
    ]);
    $bh6RR.useEffect(()=>{
        if (!hasSelected && !resolvingSelection) {
            (0, $1lMle.default).info("[UserPage] No sport selected, showing welcome dialog");
            setDialogType("SportSelectorWelcome");
        }
    }, [
        hasSelected,
        resolvingSelection,
        setDialogType
    ]);
    $bh6RR.useEffect(()=>{
        if (authState !== (0, $W4f7l.AuthState).AUTHENTICATED) return;
        if (window.localStorage.getItem($6aff9162b6471e41$var$FIRST_SESSION_TOAST_KEY)) return;
        (0, $cK0UE.default)("/api/sessions/me?limit=1&offset=0").then((recent)=>{
            window.localStorage.setItem($6aff9162b6471e41$var$FIRST_SESSION_TOAST_KEY, "true");
            if (recent.count === 0) {
                (0, $1lMle.default).info("[UserPage] First session detected, showing tutorial toast");
                setFirstSessionToastOpen(true);
            }
        }).catch((0, $cK0UE.logFetchError));
    }, [
        authState
    ]);
    // HACK: Force repaint after navigation.
    // iOS WebView/Safari fails to paint elements after back navigation due to
    // bfcache (back-forward cache) issues. The DOM is correct and interactive,
    // but not painted. We use a delayed viewport width change to force repaint.
    $bh6RR.useEffect(()=>{
        // Use a longer delay to ensure WebKit has finished bfcache restoration
        const timeoutId = setTimeout(()=>{
            requestAnimationFrame(()=>{
                window.scrollBy(-1, -1);
            });
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        location.key
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1d1FK.default), {
        component: "div",
        sx: {
            backgroundColor: "primary.dark",
            minHeight: "100vh"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $b59ffe53f395f581$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1d1FK.default), {
                component: "main",
                sx: {
                    pl: {
                        sm: "240px"
                    }
                },
                children: children
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $euyyI.default), {
                open: firstSessionToastOpen,
                onClose: (_event, reason)=>{
                    if (reason === "clickaway") return;
                    setFirstSessionToastOpen(false);
                },
                anchorOrigin: {
                    horizontal: "center",
                    vertical: "top"
                },
                sx: {
                    top: 60
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $506bB.default), {
                    severity: "info",
                    action: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eedE5.default), {
                                color: "inherit",
                                size: "small",
                                onClick: ()=>{
                                    setFirstSessionToastOpen(false);
                                    navigate("/tutorials");
                                },
                                children: "Tour"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $4rInl.default), {
                                size: "small",
                                "aria-label": "close",
                                color: "inherit",
                                onClick: ()=>setFirstSessionToastOpen(false),
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3Xpkr.default), {
                                    fontSize: "small"
                                })
                            })
                        ]
                    }),
                    children: "New here? Take a quick tour, or find it any time in the menu."
                })
            })
        ]
    });
}



var $76QOg = parcelRequire("76QOg");

var $W4f7l = parcelRequire("W4f7l");

var $b66Yl = parcelRequire("b66Yl");

var $4xl3n = parcelRequire("4xl3n");

var $ezs3H = parcelRequire("ezs3H");

var $bDIpx = parcelRequire("bDIpx");

var $g6rVl = parcelRequire("g6rVl");

var $6w3z5 = parcelRequire("6w3z5");

var $lfvqn = parcelRequire("lfvqn");

function $7e1bd9d654e310e3$var$handleImportError(e) {
    (0, $1lMle.default).error(`Error lazy loading component: ${e.message}`, undefined, e);
    return {
        default: ()=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $3WN4W.default), {})
    };
}

const $7e1bd9d654e310e3$var$Account = /*#__PURE__*/ $bh6RR.lazy(()=>(parcelRequire("8LDjk")).catch($7e1bd9d654e310e3$var$handleImportError));

const $7e1bd9d654e310e3$var$Admin = /*#__PURE__*/ $bh6RR.lazy(()=>(parcelRequire("4D1FD")).catch($7e1bd9d654e310e3$var$handleImportError));

const $7e1bd9d654e310e3$var$Experiences = /*#__PURE__*/ $bh6RR.lazy(()=>(parcelRequire("cNGRb")).catch($7e1bd9d654e310e3$var$handleImportError));

const $7e1bd9d654e310e3$var$Journeys = /*#__PURE__*/ $bh6RR.lazy(()=>(parcelRequire("JK0MB")).catch($7e1bd9d654e310e3$var$handleImportError));

const $7e1bd9d654e310e3$var$PlayerPTI = /*#__PURE__*/ $bh6RR.lazy(()=>(parcelRequire("dYxEJ")).catch($7e1bd9d654e310e3$var$handleImportError));

const $7e1bd9d654e310e3$var$Signup = /*#__PURE__*/ $bh6RR.lazy(()=>(parcelRequire("igQNc")).catch($7e1bd9d654e310e3$var$handleImportError));

const $7e1bd9d654e310e3$var$Stats = /*#__PURE__*/ $bh6RR.lazy(()=>(parcelRequire("45w4G")).catch($7e1bd9d654e310e3$var$handleImportError));

const $7e1bd9d654e310e3$var$MyGamePage = /*#__PURE__*/ $bh6RR.lazy(()=>(parcelRequire("bk5HP")).catch($7e1bd9d654e310e3$var$handleImportError));

const $7e1bd9d654e310e3$var$Trainer = /*#__PURE__*/ $bh6RR.lazy(()=>(parcelRequire("ilVlw")).catch($7e1bd9d654e310e3$var$handleImportError));

const $7e1bd9d654e310e3$var$ProGrading = /*#__PURE__*/ $bh6RR.lazy(()=>(parcelRequire("f4mJV")).catch($7e1bd9d654e310e3$var$handleImportError));

const $7e1bd9d654e310e3$var$Performance = /*#__PURE__*/ $bh6RR.lazy(()=>(parcelRequire("5nxTQ")).catch($7e1bd9d654e310e3$var$handleImportError));

const $7e1bd9d654e310e3$var$DuprDashboard = /*#__PURE__*/ $bh6RR.lazy(()=>(parcelRequire("hackQ")).catch($7e1bd9d654e310e3$var$handleImportError));

const $7e1bd9d654e310e3$var$PadelDashboard = /*#__PURE__*/ $bh6RR.lazy(()=>(parcelRequire("9eVn0")).catch($7e1bd9d654e310e3$var$handleImportError));
function $7e1bd9d654e310e3$var$ContextProviders({ children: children }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $W4f7l.CurrentUserProvider), {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cOVXE.ToastProvider), {
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4xl3n.PairingProvider), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b66Yl.DebugProvider), {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ezs3H.StatusProvider), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $76QOg.SportProvider), {
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lfvqn.TrainerFeatureProvider), {
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bDIpx.IntercomProvider), {
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6w3z5.LocalizationProvider), {
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $g6rVl.JourneyProvider), {
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dfce5f3c74840ea7$export$559156530d829ebd), {
                                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ec0eff3d524f9b2c$export$2e2bcd8739ae039), {
                                                    children: children
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}
function $7e1bd9d654e310e3$var$Root() {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $as544.Routes), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $as544.Route), {
                element: /*#__PURE__*/ (0, $ih19M.jsx)($7e1bd9d654e310e3$var$ContextProviders, {
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dnGn2.default), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Outlet), {}),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $b0386f0fa123eb6d$export$2e2bcd8739ae039), {})
                        ]
                    })
                }),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $as544.Route), {
                        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6aff9162b6471e41$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Outlet), {})
                        }),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                                path: "*",
                                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4c7bc7bf7b2536bf$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                                path: "/content/*",
                                element: /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Suspense, {
                                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kMz87.default), {}),
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)($7e1bd9d654e310e3$var$Trainer, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                                path: "/player-pti/*",
                                element: /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Suspense, {
                                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kMz87.default), {}),
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)($7e1bd9d654e310e3$var$PlayerPTI, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                                path: "/account",
                                element: /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Suspense, {
                                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kMz87.default), {}),
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)($7e1bd9d654e310e3$var$Account, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                                path: "/ball-cabinet-unlock",
                                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $981e9ff21606e8b5$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                                path: "/journeys/*",
                                element: /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Suspense, {
                                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kMz87.default), {}),
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)($7e1bd9d654e310e3$var$Journeys, {
                                        publicFacing: false
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                                path: "/performance/*",
                                element: /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Suspense, {
                                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kMz87.default), {}),
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)($7e1bd9d654e310e3$var$Performance, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                                path: "/dupr-dashboard/*",
                                element: /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Suspense, {
                                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kMz87.default), {}),
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)($7e1bd9d654e310e3$var$DuprDashboard, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                                path: "/stats/my-game",
                                element: /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Suspense, {
                                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kMz87.default), {}),
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)($7e1bd9d654e310e3$var$MyGamePage, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                                path: "/exp/*",
                                element: /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Suspense, {
                                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kMz87.default), {}),
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)($7e1bd9d654e310e3$var$Experiences, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                                path: "/padel-dashboard/*",
                                element: /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Suspense, {
                                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kMz87.default), {}),
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)($7e1bd9d654e310e3$var$PadelDashboard, {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                        path: "/admin/*",
                        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8eLYQ.default), {
                            children: /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Suspense, {
                                fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kMz87.default), {}),
                                children: /*#__PURE__*/ (0, $ih19M.jsx)($7e1bd9d654e310e3$var$Admin, {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                        path: "/stats/*",
                        element: /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Suspense, {
                            fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kMz87.default), {}),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)($7e1bd9d654e310e3$var$Stats, {})
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                        path: "/pro-grading/*",
                        element: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $kE5Kn.default), {
                            theme: (0, $e8yyN.darkTheme),
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $4YIes.default), {}),
                                /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Suspense, {
                                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kMz87.default), {}),
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)($7e1bd9d654e310e3$var$ProGrading, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                        path: "/sessions/*",
                        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $251a9bb50607619b$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                        path: "/tutorials/*",
                        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $11e408542ea04bce$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                        path: "/help/:slug",
                        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cb357f32cdc295f0$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                        path: "/ask",
                        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bedbc14e43525c03$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                        path: "/membership/welcome",
                        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Navigate), {
                            to: "/",
                            replace: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $as544.Route), {
                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $W4f7l.CurrentUserProvider), {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Outlet), {})
                }),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                        path: "/external-journeys/*",
                        element: /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Suspense, {
                            fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kMz87.default), {}),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)($7e1bd9d654e310e3$var$Journeys, {
                                publicFacing: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                        path: "/signup/*",
                        element: /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Suspense, {
                            fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kMz87.default), {}),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)($7e1bd9d654e310e3$var$Signup, {})
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                        path: "/claim/:code",
                        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3b0ab500972ae70c$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                        path: "/login",
                        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $225230b7cb484a56$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $as544.Route), {
                        path: "/auth/*",
                        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bccf3362d6ee201b$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
}
const $7e1bd9d654e310e3$var$router = (0, $as544.createBrowserRouter)([
    {
        path: "*",
        element: /*#__PURE__*/ (0, $ih19M.jsx)($7e1bd9d654e310e3$var$Root, {})
    }
]);
function $7e1bd9d654e310e3$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $kE5Kn.default), {
        theme: (0, $e8yyN.default),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $4YIes.default), {}),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $9d51477499000f4c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $5ba1327dd9c1735a$export$323e4fc2fa4753fb), {
                router: $7e1bd9d654e310e3$var$router
            })
        ]
    });
}



var $jdCKi = parcelRequire("jdCKi");

var $iQG9n = parcelRequire("iQG9n");
// Must precede datadogRum.init: RUM stamps the current URL onto the first
// view, and every later view carries it as the referrer.
(0, $iQG9n.captureAuthTokenFromUrl)();
if ((0, $jdCKi.default).env !== "local") {
    (0, $6Wfmo.datadogRum).init((0, $jdCKi.default).datadogRum);
    (0, $6Wfmo.datadogRum).startSessionReplayRecording();
}
if ((0, $bVYHX.getApps)().length === 0) (0, $bVYHX.initializeApp)((0, $jdCKi.default).firebase);
if ((0, $jdCKi.default).env !== "production") document.title = `${document.title} - ${(0, $jdCKi.default).env[0].toUpperCase()}${(0, $jdCKi.default).env.slice(1)}`;
const $1e6a16da88d577c6$var$root = (0, $9ATkq.createRoot)(document.getElementById("app"));
$1e6a16da88d577c6$var$root.render($bh6RR.createElement((0, $7e1bd9d654e310e3$export$2e2bcd8739ae039), {}, null));


//# sourceMappingURL=webby-app.17b22108.js.map
